
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("ezFY9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("4KfBY")).default);

var $4KfBY = parcelRequire("4KfBY");

});
parcelRegister("4KfBY", function(module, exports) {

$parcel$export(module.exports, "default", () => $33a681160b0bab08$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("kQSGw");

var $kwMhr = parcelRequire("kwMhr");
var $9EHc8 = parcelRequire("9EHc8");

var $6iz4v = parcelRequire("6iz4v");

var $1ybV0 = parcelRequire("1ybV0");

var $kJlBc = parcelRequire("kJlBc");

var $eIp1n = parcelRequire("eIp1n");

var $5p2pw = parcelRequire("5p2pw");

var $bhwgQ = parcelRequire("bhwgQ");

var $7BhMl = parcelRequire("7BhMl");

var $iPDOm = parcelRequire("iPDOm");

var $6M8Uw = parcelRequire("6M8Uw");

var $gd0Sp = parcelRequire("gd0Sp");

var $jK1pm = parcelRequire("jK1pm");


var $fv2PY = parcelRequire("fv2PY");

var $5s3sY = parcelRequire("5s3sY");
const $33a681160b0bab08$export$2532845c810cfaa1 = ()=>{
    (0, $fv2PY.useOnce)(()=>{
        (0, $6iz4v.setMark)((0, $ce79b29fab1e78a6$export$df49868e6ee293e));
    });
    const [boardIdStr] = (0, $kJlBc.usePathParam)('boardId');
    const boardId = Number(boardIdStr);
    const isCompanyManaged = (0, $fv2PY.useIsCMPBacklogRoute)();
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const isAuthenticated = (0, $bhwgQ.checkAuthentication)(tenantContext);
    const hasSoftwareLicense = (0, $7BhMl.checkLicense)(tenantContext, 'software');
    if (!isAuthenticated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iPDOm.RedirectToLoginPage), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9EHc8.ViewExperienceTrackingProvider), {
        experienceId: `${boardId}`,
        experience: "viewBacklog",
        analyticsSource: "backlog",
        edition: tenantContext.appEditions.software,
        application: (0, $eIp1n.JIRA_SOFTWARE),
        additionalAttributes: {
            isClassic: isCompanyManaged,
            isUIF: true,
            synthetic: (0, $1ybV0.ff)('jsw.pollinator.tenants'),
            isBacklogWithRelayEnabled: (0, $1ybV0.ff)('jsw.perf.critical-backlog-with-relay'),
            jswSprintPlanningWhiteboards: (0, $1ybV0.ff)('sprint_planning_whiteboards_kill_switch')
        }
    }, hasSoftwareLicense ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5s3sY.default), {
        isCompanyManaged: isCompanyManaged
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceSuccessTracker), {
        location: "ng-backlog-context-query"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5p2pw.AsyncNoSoftwareLicense), null)));
};
const $33a681160b0bab08$var$BacklogWrapper = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "backlog-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6M8Uw.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($33a681160b0bab08$export$2532845c810cfaa1, null));
var $33a681160b0bab08$export$2e2bcd8739ae039 = $33a681160b0bab08$var$BacklogWrapper;

});
parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
        (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $ce79b29fab1e78a6$export$b5f697f1279a473e = 'USE_RESOURCE_START';
const $ce79b29fab1e78a6$export$a6940922387b16 = 'USE_RESOURCE_READY';
const $ce79b29fab1e78a6$export$e9163c48bfd4013e = 'BACKLOG_PREFETCHED_DATA_READY';
const $ce79b29fab1e78a6$export$fb27ff41b54b88b0 = 'AGG_DATA_TRANSFORM_START';
const $ce79b29fab1e78a6$export$bde49eba9c87d991 = 'AGG_DATA_TRANSFORM_END';
const $ce79b29fab1e78a6$export$df49868e6ee293e = 'BACKLOG_ROOT_SPA_APP_START';
const $ce79b29fab1e78a6$export$dedbdcc35e955187 = 'BACKLOG';
const $ce79b29fab1e78a6$export$e927a5d1b72f0b68 = 'ENABLED';
const $ce79b29fab1e78a6$export$8cd212c10b4124d2 = 'DISABLED';
const $ce79b29fab1e78a6$export$912d9029af46d426 = 'Board is locationless';

parcelRegister("fv2PY", function(module, exports) {

$parcel$export(module.exports, "getBoardUrl", () => $2cd529f26973befe$export$505a9f131607d070);
$parcel$export(module.exports, "getCMPBoardUrl", () => $2cd529f26973befe$export$c89a0c88af322ce1);
$parcel$export(module.exports, "isBacklogDisabled", () => $2cd529f26973befe$export$c5cfccba3ef0f2a9);
$parcel$export(module.exports, "useOnce", () => $2cd529f26973befe$export$392544347a18b6ea);
$parcel$export(module.exports, "getIdFromAri", () => $2cd529f26973befe$export$79640a85913af5aa);
$parcel$export(module.exports, "useIsCMPBacklogRoute", () => $2cd529f26973befe$export$d2d03c28ed220603);

var $eUqFw = parcelRequire("eUqFw");

var $exb0h = parcelRequire("exb0h");

var $huI7r = parcelRequire("huI7r");

var $10fdS = parcelRequire("10fdS");

const $2cd529f26973befe$export$505a9f131607d070 = (projectKey, boardId)=>`/jira/software/projects/${projectKey}/boards/${boardId}`;
const $2cd529f26973befe$export$c89a0c88af322ce1 = (projectKey, boardId)=>`/jira/software/c/projects/${projectKey}/boards/${boardId}`;
const $2cd529f26973befe$export$c5cfccba3ef0f2a9 = (data)=>{
    if (!data?.boardScope.features) return false;
    return data.boardScope.features.some(({ key: key, status: status })=>key === (0, $ce79b29fab1e78a6$export$dedbdcc35e955187) && status === (0, $ce79b29fab1e78a6$export$8cd212c10b4124d2));
};
const $2cd529f26973befe$var$defaultPredicate = ()=>true;
const $2cd529f26973befe$export$392544347a18b6ea = (callback, predicate = $2cd529f26973befe$var$defaultPredicate)=>{
    const done = (0, $eUqFw.useRef)(false);
    if (!done.current && predicate()) {
        callback();
        done.current = true;
    }
};
const $2cd529f26973befe$export$79640a85913af5aa = (ari)=>{
    const possibleAri = (0, $huI7r.toAri)(ari);
    if (possibleAri) return (0, $huI7r.getAriConfig)(possibleAri).resourceId;
    return ari;
};
const $2cd529f26973befe$export$d2d03c28ed220603 = ()=>{
    const route = (0, $10fdS.useCurrentRoute)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return [
        (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_BACKLOG,
        (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_USER_BACKLOG
    ].includes(route.name);
};

});

parcelRegister("5s3sY", function(module, exports) {

$parcel$export(module.exports, "default", () => $50ebd0fe13bb9557$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $gytIO = parcelRequire("gytIO");

var $6Pp4s = parcelRequire("6Pp4s");

var $bbDk1 = parcelRequire("bbDk1");
const $50ebd0fe13bb9557$var$BacklogMetaAPIConsumerWrapper = ({ isCompanyManaged: isCompanyManaged })=>{
    if (isCompanyManaged) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Pp4s.default), null);
    if ((0, $1ybV0.ff)('jsw.perf.critical-backlog-with-relay')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gytIO.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbDk1.default), null);
};
var $50ebd0fe13bb9557$export$2e2bcd8739ae039 = $50ebd0fe13bb9557$var$BacklogMetaAPIConsumerWrapper;

});
parcelRegister("gytIO", function(module, exports) {

$parcel$export(module.exports, "default", () => $057e2311be11a68a$export$2e2bcd8739ae039);

var $3mjFf = parcelRequire("3mjFf");

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("kQSGw");

var $iWLL0 = parcelRequire("iWLL0");

var $dpXKE = parcelRequire("dpXKE");

var $2BvS3 = parcelRequire("2BvS3");

var $6iz4v = parcelRequire("6iz4v");

var $gGtKh = parcelRequire("gGtKh");

var $huI7r = parcelRequire("huI7r");
parcelRequire("inDCU");
var $eZGdd = parcelRequire("eZGdd");

var $eI64M = parcelRequire("eI64M");

var $buJlM = parcelRequire("buJlM");

var $jZqFH = parcelRequire("jZqFH");

var $kJlBc = parcelRequire("kJlBc");

var $bc7vB = parcelRequire("bc7vB");
var $59z8J = parcelRequire("59z8J");

var $7msR2 = parcelRequire("7msR2");

var $a18DT = parcelRequire("a18DT");

var $cYzE1 = parcelRequire("cYzE1");

var $fO5rB = parcelRequire("fO5rB");

var $iJHZm = parcelRequire("iJHZm");
var $78d1w = parcelRequire("78d1w");

var $gd0Sp = parcelRequire("gd0Sp");


var $fv2PY = parcelRequire("fv2PY");

var $3FCHp = parcelRequire("3FCHp");

var $grcgD = parcelRequire("grcgD");

var $fJY8E = parcelRequire("fJY8E");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $057e2311be11a68a$var$bindToOnJiraGlobalIssueCreateClose = (callback)=>{
    // window.require is not available on initial script load.
    // eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $2BvS3.loadBridge)({
        name: 'jira/util/events',
        wrmKeys: 'wrc!jira.webresources:jira-events'
    }).then((Events)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        Events?.bind('QuickCreateIssue.sessionComplete', callback);
    });
};
const $057e2311be11a68a$export$e14c6311549531c9 = ({ backlogQueryReference: backlogQueryReference })=>{
    const [projectKey] = (0, $kJlBc.usePathParam)('projectKey');
    const [boardIdStr] = (0, $kJlBc.usePathParam)('boardId');
    const boardId = Number(boardIdStr);
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    /* eslint-disable @atlassian/relay/unused-fields */ const aggData = (0, $iWLL0.usePreloadedQuery)((0, $3mjFf.default), backlogQueryReference);
    /* eslint-enable @atlassian/relay/unused-fields */ (0, $fv2PY.useOnce)(()=>{
        (0, $6iz4v.setMark)((0, $ce79b29fab1e78a6$export$e9163c48bfd4013e));
        (0, $6iz4v.setMeasure)('use-resource-fetch-finish', (0, $ce79b29fab1e78a6$export$b5f697f1279a473e), (0, $ce79b29fab1e78a6$export$e9163c48bfd4013e));
    });
    const response = (0, $buJlM.useRelayResource)((0, $59z8J.customFiltersResource));
    const customFiltersQueryRef = response.queryReference;
    const [{ isInitialRender: isInitialRender }] = (0, $78d1w.useSpaStateTransition)();
    const hasSuspended = (0, $cYzE1.useGetHasSuspended)();
    const isCacheHit = !isInitialRender && !hasSuspended;
    const projectKeyFromContext = aggData?.boardScope.projectLocation.key || '';
    const projectNameFromContext = aggData?.boardScope.projectLocation.name || '';
    const projectIdFromContext = (0, $fv2PY.getIdFromAri)(aggData?.boardScope.projectLocation.id || '');
    const [versionFilterRelayQueryRef, loadVersionFilterRelayQuery] = (0, $iWLL0.useQueryLoader)((0, $jZqFH.default));
    const getDataFromAGG = (0, $grcgD.useGetDataFromAGG)({
        cloudId: tenantContext.cloudId,
        boardId: boardId
    });
    (0, $eUqFw.useEffect)(()=>{
        // only run the query if projectId exists in context
        // we load the query client-side because:
        //  1. The field relies on projectId which isn't available from the URL path
        //  2. We don't want version data to block the critical page load
        if (loadVersionFilterRelayQuery != null && projectIdFromContext.length > 0) {
            const jiraProjectId = (0, $huI7r.createAri)({
                resourceOwner: 'jira',
                cloudId: tenantContext.cloudId,
                resourceType: 'project',
                resourceId: `${projectIdFromContext}`
            });
            loadVersionFilterRelayQuery({
                jiraProjectIds: [
                    jiraProjectId
                ],
                first: 500,
                after: null
            });
        }
    }, [
        loadVersionFilterRelayQuery,
        projectIdFromContext,
        tenantContext.cloudId
    ]);
    // redirect to the board only if the backlog is disabled, no redirect if timeout
    if ((0, $fJY8E.isBacklogDisabledFromAggData)(aggData)) {
        const urlProjectKey = projectKey ?? projectKeyFromContext;
        const boardUrl = (0, $fv2PY.getBoardUrl)(urlProjectKey, String(boardId));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
            to: boardUrl
        });
    }
    const backlogEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
        subProduct: "software"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eZGdd.default), {
        name: "configApiReady"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a18DT.default), {
        isCacheHit: isCacheHit,
        bindToOnJiraGlobalIssueCreateClose: $057e2311be11a68a$var$bindToOnJiraGlobalIssueCreateClose,
        // Route match data that could be read inside of the app
        projectKey: projectKey ?? projectKeyFromContext,
        projectId: Number(projectIdFromContext),
        rapidViewId: String(boardId),
        // Tenant context data that could be read inside of the app
        locale: tenantContext.locale,
        baseUrl: tenantContext.baseUrl,
        xsrfToken: tenantContext.xsrfToken ?? '',
        cloudId: tenantContext.cloudId ?? '',
        atlassianAccountId: tenantContext.atlassianAccountId ?? null,
        prefetchedData: null,
        prefetchedAggData: aggData,
        isServer: false,
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef,
        getDataFromAGG: getDataFromAGG
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStatePageReady), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpXKE.default), {
        projectKey: projectKeyFromContext,
        projectName: projectNameFromContext,
        projectId: projectIdFromContext,
        isSimplifiedProject: true
    }, backlogEl, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eI64M.default), {
        projectKey: projectKey ?? projectKeyFromContext ?? null
    }));
};
const $057e2311be11a68a$export$180813d52fa33cf7 = ()=>{
    (0, $fv2PY.useOnce)(()=>{
        (0, $6iz4v.setMark)((0, $ce79b29fab1e78a6$export$b5f697f1279a473e));
    });
    const response = (0, $buJlM.useRelayResource)((0, $bc7vB.backlogRelayResource));
    const backlogQueryReference = response.queryReference;
    (0, $fv2PY.useOnce)(()=>{
        (0, $6iz4v.setMark)((0, $ce79b29fab1e78a6$export$a6940922387b16));
        (0, $6iz4v.setMeasure)('use-resource', (0, $ce79b29fab1e78a6$export$b5f697f1279a473e), (0, $ce79b29fab1e78a6$export$a6940922387b16));
    }, ()=>!!backlogQueryReference);
    if (backlogQueryReference != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cYzE1.SuspenseTrackerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "backlog-api-consumer-with-relay",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7msR2.NextGenBacklogSkeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cYzE1.SuspenseTrackerFallback), null))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3FCHp.BacklogCriticalDataBoundary), {
        errorCaptureKey: backlogQueryReference.fetchKey.toString(),
        backlogRootQueryName: backlogQueryReference.name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($057e2311be11a68a$export$e14c6311549531c9, {
        backlogQueryReference: backlogQueryReference
    }))));
    return null;
};
var $057e2311be11a68a$export$2e2bcd8739ae039 = $057e2311be11a68a$export$180813d52fa33cf7;

});
parcelRegister("inDCU", function(module, exports) {

$parcel$export(module.exports, "SetBootstrapBundleReadyMark", () => $f59b0dd69e4560bf$export$336667852b20afff);
$parcel$export(module.exports, "SetBundleReadyMark", () => $f59b0dd69e4560bf$export$6204e01bde3d2625);
$parcel$export(module.exports, "SetCustomMark", () => (parcelRequire("eZGdd")).default);

var $eUqFw = parcelRequire("eUqFw");


var $eZGdd = parcelRequire("eZGdd");

var $3dxBh = parcelRequire("3dxBh");

var $7vf5z = parcelRequire("7vf5z");

var $hqj5v = parcelRequire("hqj5v");


var $ifyPR = parcelRequire("ifyPR");

const $f59b0dd69e4560bf$export$336667852b20afff = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eZGdd.default), {
        name: "appBootstrapBundleReady"
    });
const $f59b0dd69e4560bf$export$6204e01bde3d2625 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eZGdd.default), {
        name: (0, $37f655a4e4d5690e$export$ff834eccc35b9089)
    });
const $f59b0dd69e4560bf$export$f9a192d46021c340 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eZGdd.default), {
        name: (0, $37f655a4e4d5690e$export$86b05e34d462ead8)
    });

});
const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';

parcelRegister("eZGdd", function(module, exports) {

$parcel$export(module.exports, "default", () => $1717fc440f3604c9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $0S0fK = parcelRequire("0S0fK");
class $1717fc440f3604c9$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const { name: name } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0S0fK.default).Consumer, null, ({ pageId: pageId, onCustomMark: onCustomMark })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
                op: onCustomMark,
                args: [
                    name,
                    pageId
                ]
            }));
    }
}

});

parcelRegister("7vf5z", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $074ba9858fda469d$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $074ba9858fda469d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $074ba9858fda469d$export$9b3029ee6188a41f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $4nnPJ = parcelRequire("4nnPJ");

var $1QVWH = parcelRequire("1QVWH");

var $j2Yjr = parcelRequire("j2Yjr");

var $gnIbC = parcelRequire("gnIbC");

var $22iQy = parcelRequire("22iQy");

var $brm1D = parcelRequire("brm1D");

var $ifyPR = parcelRequire("ifyPR");

var $aS0xb = parcelRequire("aS0xb");

var $45wsB = parcelRequire("45wsB");
const $074ba9858fda469d$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $074ba9858fda469d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame, waitForLongTaskIdleTTI: waitForLongTaskIdleTTI } = this.props;
        $074ba9858fda469d$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1ybV0.ff)('uip.ufo') && (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $aS0xb.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $ifyPR.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $45wsB.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1QVWH.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j2Yjr.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brm1D.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $gnIbC.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22iQy.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame,
            waitForLongTaskIdleTTI: waitForLongTaskIdleTTI
        }));
    }
}
const $074ba9858fda469d$export$9b3029ee6188a41f = $074ba9858fda469d$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("1QVWH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4fbf7a0879450da$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addUFOCustomData", () => $a4fbf7a0879450da$export$d12f56a472cdbe6c);

var $eUqFw = parcelRequire("eUqFw");

var $5iuyH = parcelRequire("5iuyH");

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
function $a4fbf7a0879450da$export$2e2bcd8739ae039({ data: data }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $5iuyH.default));
    (0, $eUqFw.useMemo)(()=>{
        if (!interactionContext) return;
        interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}
function $a4fbf7a0879450da$export$d12f56a472cdbe6c(data) {
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    (0, $fVaJL.addCustomData)(currentInteractionId, [], data);
}

});

parcelRegister("j2Yjr", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $9cfce24b860b88bd$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $9cfce24b860b88bd$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $9cfce24b860b88bd$export$d93d677ef2f33c5c);

var $eUqFw = parcelRequire("eUqFw");

var $5iuyH = parcelRequire("5iuyH");

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
function $9cfce24b860b88bd$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $9cfce24b860b88bd$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $5iuyH.default));
    const interactionId = (0, $gnIbC.getInteractionId)().current;
    (0, $eUqFw.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $fVaJL.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $9cfce24b860b88bd$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $9cfce24b860b88bd$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $gnIbC.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $fVaJL.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $9cfce24b860b88bd$export$f02972da195a43bb(marks, timingsConfig);
        (0, $fVaJL.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("22iQy", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $c48b51f586335ad5$export$575e93c0f9905999);

var $eUqFw = parcelRequire("eUqFw");

var $acbV3 = parcelRequire("acbV3");

var $6iz4v = parcelRequire("6iz4v");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");

var $cNlZD = parcelRequire("cNlZD");

var $cNlZD = parcelRequire("cNlZD");

var $6M8Uw = parcelRequire("6M8Uw");
var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $5iuyH = parcelRequire("5iuyH");

const $c48b51f586335ad5$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $1ybV0.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
};
class $c48b51f586335ad5$export$575e93c0f9905999 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $1ybV0.ff)('bm3.wait-for-long-task') ? (0, $acbV3.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (this.props.waitForLongTaskIdleTTI) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            (0, $cNlZD.getTTIValue)().then((tti)=>{
                (0, $cNlZD.resetTTIObserver)();
                (0, $6iz4v.setMark)('BROWSER_METRICS_LONG_TASK_TTI_END', {
                    startTime: tti
                });
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_LONG_TASK_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_LONG_TASK_TTI_END');
                $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
        } else if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                }
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            $c48b51f586335ad5$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $5iuyH.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("cNlZD", function(module, exports) {

$parcel$export(module.exports, "resetTTIObserver", () => $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c);
$parcel$export(module.exports, "startTTIObserver", () => $2134fd1f8b4ec9b6$export$d2209a9a3184ff99);
$parcel$export(module.exports, "getTTIValue", () => $2134fd1f8b4ec9b6$export$e67176cf000b0a2e);

var $ba8ih = parcelRequire("ba8ih");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
let $2134fd1f8b4ec9b6$var$resolveTti = (_v)=>{};
let $2134fd1f8b4ec9b6$var$observerStarted = false;
/**
 * Initialize module state and return the promise a consumer can use to wait
 * for the TTI event.
 */ function $2134fd1f8b4ec9b6$var$initTtiPromise() {
    return new Promise((resolve)=>{
        let hasResolved = false;
        const callback = (ttiResult)=>{
            if (hasResolved) return;
            hasResolved = true;
            resolve(ttiResult);
        };
        $2134fd1f8b4ec9b6$var$resolveTti = callback;
    });
}
let $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
function $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c() {
    $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
    $2134fd1f8b4ec9b6$var$observerStarted = false;
}
function $2134fd1f8b4ec9b6$export$d2209a9a3184ff99() {
    $2134fd1f8b4ec9b6$var$observerStarted = true;
    let cleanupObserver = null;
    let lastSeenEventTime = performance.now();
    const callback = ()=>{
        cleanupObserver?.();
        $2134fd1f8b4ec9b6$var$resolveTti(lastSeenEventTime);
    };
    let timeoutId = setTimeout(callback, 5000);
    cleanupObserver = (0, $ba8ih.startLongTaskObserver)(()=>{
        lastSeenEventTime = performance.now();
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, 5000);
    });
}
function $2134fd1f8b4ec9b6$export$e67176cf000b0a2e() {
    const promise = $2134fd1f8b4ec9b6$var$ttiPromise ?? $2134fd1f8b4ec9b6$var$initTtiPromise();
    if (!$2134fd1f8b4ec9b6$var$observerStarted) $2134fd1f8b4ec9b6$export$d2209a9a3184ff99();
    return promise;
}

});
parcelRegister("ba8ih", function(module, exports) {

$parcel$export(module.exports, "startLongTaskObserver", () => $c3f66a1c0c2d8c9c$export$af412d3da3bf848a);
/**
 * Starts a long-task observer that will call `cb` on each observation.
 * Returns a disposal function
 */ function $c3f66a1c0c2d8c9c$export$af412d3da3bf848a(cb) {
    const observer = new PerformanceObserver(()=>{
        cb();
    });
    observer.observe({
        type: 'longtask'
    });
    return ()=>{
        observer.disconnect();
    };
}

});



parcelRegister("brm1D", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $aa08c3eb931d9705$export$d91154f099475c5);

var $eUqFw = parcelRequire("eUqFw");

var $4nnPJ = parcelRequire("4nnPJ");

var $5iuyH = parcelRequire("5iuyH");
class $aa08c3eb931d9705$export$d91154f099475c5 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $4nnPJ.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $5iuyH.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("ifyPR", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $d6714c8d166fb68b$export$bf239ac2bfb04967);

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
function $d6714c8d166fb68b$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $fVaJL.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("aS0xb", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $714e33db0dc77e43$export$e63862cd888fe05a);

var $4nnPJ = parcelRequire("4nnPJ");
var $aPkDp = parcelRequire("aPkDp");

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
async function $714e33db0dc77e43$export$e63862cd888fe05a() {
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $4nnPJ.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $aPkDp.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $fVaJL.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("45wsB", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $58cb476ec3ec20ed$export$f00f1e874ce869e9);

var $aWbzA = parcelRequire("aWbzA");

var $gnIbC = parcelRequire("gnIbC");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $58cb476ec3ec20ed$export$7b4abba432e57989 = (value)=>$58cb476ec3ec20ed$var$isString(value) && $58cb476ec3ec20ed$var$startsAsObject(value) || $58cb476ec3ec20ed$var$isObject(value);
const $58cb476ec3ec20ed$export$fcc03ee4c944962f = (featureFlagValue)=>$58cb476ec3ec20ed$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $58cb476ec3ec20ed$export$d2818866b4acbea4 = new Map();
const $58cb476ec3ec20ed$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $aWbzA.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $58cb476ec3ec20ed$export$fcc03ee4c944962f(value);
            $58cb476ec3ec20ed$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("hqj5v", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd515edca209afee$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $0S0fK = parcelRequire("0S0fK");

var $7vf5z = parcelRequire("7vf5z");
// eslint-disable-next-line jira/react/no-class-components
class $dd515edca209afee$var$ApdexActions extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = (0, $7vf5z.baseDefaultProps);
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, children: children, metric: metric } = this.props;
        (0, $7vf5z.checkAndEmitApdexSignal)(appName, metricKey);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0S0fK.default).Consumer, null, ({ onReady: onReady })=>children({
                submit: ()=>onReady(metricKey || `jira.fe.spa.initial-render.${String(appName)}`, metricKey || `jira.fe.spa.transition.${String(appName)}`, extra, metric)
            }));
    }
}
var $dd515edca209afee$export$2e2bcd8739ae039 = $dd515edca209afee$var$ApdexActions;

});


parcelRegister("eI64M", function(module, exports) {

$parcel$export(module.exports, "isProjectArchivedCondition", () => $949f89d276fadb14$export$34040938aec58f90);
$parcel$export(module.exports, "RedirectToArchivedPage", () => $949f89d276fadb14$export$36db2ddf32573bd8);
$parcel$export(module.exports, "default", () => $949f89d276fadb14$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bNe1g = parcelRequire("bNe1g");

var $kJlBc = parcelRequire("kJlBc");

const $949f89d276fadb14$export$34040938aec58f90 = (projectContextData)=>projectContextData && projectContextData.isProjectArchived || false;
const $949f89d276fadb14$var$RedirectIfProjectArchived = ({ projectKey: projectKey })=>{
    if (projectKey === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bNe1g.ProjectContextProvider), null, (projectContext)=>$949f89d276fadb14$export$34040938aec58f90(projectContext.data) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
            to: (0, $8b47e2956ab1dffe$export$9a6ccb84170b615b)
        }) : null);
};
const $949f89d276fadb14$export$36db2ddf32573bd8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
        to: (0, $8b47e2956ab1dffe$export$9a6ccb84170b615b)
    });
var $949f89d276fadb14$export$2e2bcd8739ae039 = $949f89d276fadb14$var$RedirectIfProjectArchived;

});
const $8b47e2956ab1dffe$export$9a6ccb84170b615b = '/jira/errors/project-archived';


parcelRegister("jZqFH", function(module, exports) {

$parcel$export(module.exports, "default", () => $3579a52289c5f6c7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5068d76754b722b425f5ed8d488e33db>>
 * @relayHash 7794c32f565bb65ec1d58cdfe2cd7c65
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 815e8e86601de719f9d0106d420dba00c2dd02b64bc8e63048a0b261dccf95a2
const $3579a52289c5f6c7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraProjectIds"
    }, v3 = {
        "kind": "Literal",
        "name": "filter",
        "value": [
            "UNRELEASED"
        ]
    }, v4 = {
        "kind": "Variable",
        "name": "jiraProjectIds",
        "variableName": "jiraProjectIds"
    }, v5 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v8 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v9 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        v3 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v4 /*: any*/ 
    ], v10 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "viewBacklogVersionFilterRelayQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "versionsForProjects",
                                    "args": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ],
                                    "concreteType": "JiraVersionConnection",
                                    "kind": "LinkedField",
                                    "name": "__versionBacklogPanelRelay_versionsForProjects_connection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraVersionEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "versionFilterRelay_softwareFilters"
                                                    },
                                                    {
                                                        "concreteType": "JiraVersion",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v5 /*: any*/ ,
                                                            v6 /*: any*/ 
                                                        ]
                                                    },
                                                    v7 /*: any*/ 
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.versionsForProjects.edges"
                                        },
                                        v8 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.versionsForProjects"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "viewBacklogVersionFilterRelayQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v9 /*: any*/ ,
                            "concreteType": "JiraVersionConnection",
                            "kind": "LinkedField",
                            "name": "versionsForProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraVersionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersion",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        v10 /*: any*/ 
                                                    ]
                                                },
                                                v10 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        v7 /*: any*/ 
                                    ]
                                },
                                v8 /*: any*/ 
                            ]
                        },
                        {
                            "args": v9 /*: any*/ ,
                            "filters": [
                                "jiraProjectIds",
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "versionBacklogPanelRelay_versionsForProjects",
                            "kind": "LinkedHandle",
                            "name": "versionsForProjects"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "815e8e86601de719f9d0106d420dba00c2dd02b64bc8e63048a0b261dccf95a2",
            "metadata": {
                "connection": [
                    {
                        "count": "first",
                        "cursor": "after",
                        "direction": "forward",
                        "path": [
                            "jira",
                            "versionsForProjects"
                        ]
                    }
                ]
            },
            "name": "viewBacklogVersionFilterRelayQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3579a52289c5f6c7$var$node.hash = "8f0feba2d091a19a39a14c5133920950";
var $3579a52289c5f6c7$export$2e2bcd8739ae039 = $3579a52289c5f6c7$var$node;

});

parcelRegister("a18DT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f0c34147023c3d2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $ldoFd = parcelRequire("ldoFd");

var $aOINP = parcelRequire("aOINP");

var $yuXsW = parcelRequire("yuXsW");

var $2Wgbz = parcelRequire("2Wgbz");

var $5BRby = parcelRequire("5BRby");

var $cA8OV = parcelRequire("cA8OV");

var $6iz4v = parcelRequire("6iz4v");

var $bQQi1 = parcelRequire("bQQi1");
var $4B7EY = parcelRequire("4B7EY");

var $aFvYX = parcelRequire("aFvYX");

var $1ybV0 = parcelRequire("1ybV0");

var $9m9bG = parcelRequire("9m9bG");

var $41KUh = parcelRequire("41KUh");

var $bFzGY = parcelRequire("bFzGY");

var $5yh8X = parcelRequire("5yh8X");

var $kJlBc = parcelRequire("kJlBc");

var $1JdUa = parcelRequire("1JdUa");
var $5cznK = parcelRequire("5cznK");

var $lA3UV = parcelRequire("lA3UV");

var $6M1P4 = parcelRequire("6M1P4");

var $8wXFi = parcelRequire("8wXFi");

var $2a0bR = parcelRequire("2a0bR");

var $7TyGu = parcelRequire("7TyGu");

var $d6rfk = parcelRequire("d6rfk");

var $iYUz7 = parcelRequire("iYUz7");
var $5YMxX = parcelRequire("5YMxX");

var $4xhKq = parcelRequire("4xhKq");

var $4T9ID = parcelRequire("4T9ID");

var $gPQCf = parcelRequire("gPQCf");

var $1gQ73 = parcelRequire("1gQ73");

var $jiL2Q = parcelRequire("jiL2Q");

var $7TN4i = parcelRequire("7TN4i");

var $lG1Gj = parcelRequire("lG1Gj");

var $eYeFr = parcelRequire("eYeFr");

var $lafvx = parcelRequire("lafvx");

var $bDGeR = parcelRequire("bDGeR");

var $bLaT7 = parcelRequire("bLaT7");

var $a2Kov = parcelRequire("a2Kov");

var $8vO0b = parcelRequire("8vO0b");

var $diedG = parcelRequire("diedG");
/**
 * Set performance marks for rendering performance
 */ function $2f0c34147023c3d2$var$measureRender() {
    (0, $6iz4v.setMark)('render:start');
    requestAnimationFrame(()=>{
        (0, $6iz4v.setMark)('render:end');
        (0, $6iz4v.setMeasure)('render', 'render:start', 'render:end');
    });
}
// eslint-disable-next-line jira/react/no-class-components
class $2f0c34147023c3d2$var$Backlog extends (0, $eUqFw.Component) {
    static{
        // go/jfe-eslint
        // eslint-disable-next-line react/sort-comp
        this.defaultProps = {
            isServer: false,
            isCompanyManaged: false,
            initialState: {}
        };
    }
    static getAppPropsFromProps(props) {
        return {
            locale: props.locale,
            baseUrl: props.baseUrl,
            rapidViewId: props.rapidViewId,
            isCompanyManaged: props.isCompanyManaged ?? false,
            xsrfToken: props.xsrfToken,
            projectKey: props.projectKey,
            projectId: props.projectId,
            projectName: props.projectName,
            cloudId: props.cloudId,
            atlassianAccountId: props.atlassianAccountId
        };
    }
    constructor(props){
        super(props);
        this.prefetchedData = null;
        this.hasRendered = false;
        this.onGetLocation = ()=>this.props.location;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onPush = (path, state)=>{
            this.props.push(path, state);
        };
        const { isCompanyManaged: isCompanyManaged } = props;
        const metric = isCompanyManaged ? (0, $gPQCf.uifBacklogNewUiPageLoad) : (0, $gPQCf.nextGenBacklogPageLoad);
        metric.mark((0, $gPQCf.PAGE_LOAD_MARK_CONSTRUCTOR_START));
        metric.mark((0, $gPQCf.PAGE_LOAD_MARK_REDUX_START));
        const rootEpic = (0, $d6rfk.default)(props.isServer, props.isCompanyManaged, ()=>this.props.location, props.push, props.replace, (0, $yuXsW.getClient)(props.baseUrl, (0, $2Wgbz.default), props.xsrfToken));
        (0, $6iz4v.setMark)((0, $5yh8X.jswCreateReduxStoreStartMark));
        const createStoreOptions = {
            rootEpic: (0, $bQQi1.disposableEpic)(rootEpic),
            dependencies: {
                isCompanyManaged: isCompanyManaged,
                fetchDataFromAGG: props.getDataFromAGG,
                storeFieldsActions: props.storeFieldsActions,
                refetchVersionsForProjects: props.refetchVersionsForProjects,
                createAnalyticsEvent: props.createAnalyticsEvent
            }
        };
        this.store = (0, $1gQ73.createStoreWithCache)(props.rapidViewId, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props.initialState ?? {}, {
            ...createStoreOptions,
            disableStoreCaches: props.disableStoreCaches ?? false
        });
        (0, $6iz4v.setMark)((0, $5yh8X.jswCreateReduxStoreEndMark));
        (0, $6iz4v.setMeasure)('create-redux-store', (0, $5yh8X.jswCreateReduxStoreStartMark), (0, $5yh8X.jswCreateReduxStoreEndMark));
        this.store.dispatch((0, $jiL2Q.initializeAppProps)($2f0c34147023c3d2$var$Backlog.getAppPropsFromProps(props)));
        // Fire multiple requests to get data for the board. GraphQL please save us.
        (0, $6iz4v.measureFunc)('loadAppData', ()=>{
            if (props.isCompanyManaged) {
                if ((0, $1ybV0.ff)('jsw.perf.enable-indexeddb-caching-for-backlog')) {
                    if (props.prefetchCmpBacklogDataPromise) props.prefetchCmpBacklogDataPromise.then((data)=>{
                        this.store.dispatch((0, $jiL2Q.loadAppData)({
                            prefetchCmpBacklogData: data
                        }));
                    });
                    else this.store.dispatch((0, $jiL2Q.loadAppData)());
                } else if (props.prefetchedJiraPlanRestDataPromise) // TODO: Handle error
                props.prefetchedJiraPlanRestDataPromise.then((data)=>{
                    this.store.dispatch((0, $jiL2Q.loadAppData)({
                        prefetchedJiraPlanRestData: data
                    }));
                });
                else if (props.prefetchedJiraPlanRestData) this.store.dispatch((0, $jiL2Q.loadAppData)({
                    prefetchedJiraPlanRestData: props.prefetchedJiraPlanRestData
                }));
                else this.store.dispatch((0, $jiL2Q.loadAppData)());
            } else if ((0, $8wXFi.isBacklogWithRelayEnabled)() && props.prefetchedAggData) this.store.dispatch((0, $jiL2Q.loadAppData)({
                prefetchedAggData: props.prefetchedAggData
            }));
            else if (props.prefetchedData) {
                this.prefetchedData = props.prefetchedData;
                this.store.dispatch((0, $jiL2Q.loadAppData)({
                    prefetchedData: props.prefetchedData
                }));
            } else this.store.dispatch((0, $jiL2Q.loadAppData)());
        });
        (0, $6iz4v.measureFunc)('loadConfigData', ()=>{
            this.store.dispatch((0, $jiL2Q.loadConfigData)());
            this.store.dispatch((0, $eYeFr.loadPriorities)());
            // This isn't required on the server, so it shouldn't be requested.
            if (!false) this.store.dispatch((0, $lafvx.requestCurrentUser)());
        });
        (0, $6iz4v.measureFunc)('setCollapsedCardLists', ()=>{
            const lists = (0, $iYUz7.getBacklogSettings)(Number(props.rapidViewId)).collapsedCardLists;
            if (lists) {
                const listsIds = Object.keys(lists);
                if (listsIds.length > 0) this.store.dispatch((0, $7TN4i.setCollapsedCardLists)(listsIds));
            }
        });
        (0, $6iz4v.measureFunc)('setCollapsedCardGroups', ()=>{
            const groups = (0, $iYUz7.getBacklogCardGroupSettings)(Number(props.rapidViewId));
            if (groups) {
                const groupIds = Object.keys(groups);
                if (groupIds.length > 0) this.store.dispatch((0, $7TN4i.setCollapsedCardGroups)(groupIds));
            }
        });
        (0, $6iz4v.measureFunc)('setExpandedCardGroups', ()=>{
            const groups = (0, $iYUz7.getBacklogCardGroupSettings)(Number(props.rapidViewId));
            if (groups) {
                const groupIds = Object.keys(groups);
                if (groupIds.length > 0) this.store.dispatch((0, $7TN4i.setExpandedCardGroups)(groupIds));
            }
        });
        (0, $6iz4v.measureFunc)('toggleHiddenLabels', ()=>{
            if (isCompanyManaged) {
                const willHideEpicLabels = (0, $5YMxX.getHideEpics)(props.rapidViewId);
                this.store.dispatch((0, $lG1Gj.toggleCardEpicFields)(willHideEpicLabels));
                const willToggleStatusLabels = (0, $5YMxX.getHideStatuses)(props.rapidViewId);
                this.store.dispatch((0, $lG1Gj.toggleCardStatusFields)(willToggleStatusLabels));
                const willToggleVersionLabels = (0, $5YMxX.getHideVersions)(props.rapidViewId);
                this.store.dispatch((0, $lG1Gj.toggleCardVersionFields)(willToggleVersionLabels));
            }
        });
        (0, $6iz4v.measureFunc)('setIncludeSubtasksInWorkloadModal', ()=>{
            if (isCompanyManaged) {
                const includeSubtasksLocal = (0, $iYUz7.getWorkloadSubtaskSettings)();
                this.store.dispatch((0, $bDGeR.setIncludeSubtasksAction)(includeSubtasksLocal));
            }
        });
        metric.mark((0, $gPQCf.PAGE_LOAD_MARK_REDUX_END));
        metric.mark((0, $gPQCf.PAGE_LOAD_MARK_CONSTRUCTOR_END));
    }
    componentDidMount() {
        this.hasRendered = true;
        (0, $4xhKq.removeLocationLegacyPanelQueryParameters)(this.props.location, this.props.push);
        if ((0, $8wXFi.isBacklogWithRelayEnabled)() && this.props.isCacheHit) this.store.dispatch((0, $jiL2Q.refreshDataRequest)((0, $7TyGu.REFRESH_SOURCE_ON_MOUNT)));
    }
    componentDidUpdate(prevProps) {
        const prevAppProps = $2f0c34147023c3d2$var$Backlog.getAppPropsFromProps(prevProps);
        const appProps = $2f0c34147023c3d2$var$Backlog.getAppPropsFromProps(this.props);
        // If our resource cache data is different, load it up!!!
        // We fire a refresh on cached mount and it will proc this lifecycle event
        // See src/packages/spa-apps/nextgen-backlog/src/resources-cache-refresh
        if (!(0, $8wXFi.isBacklogWithRelayEnabled)() && !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(prevProps.prefetchedData, this.props.prefetchedData)) // if this has a source key, and the key is the one we get from the resources
        // cache updater. Don't process it.
        {
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(this.props.prefetchedData) && (!((0, $c22b1ee1fcd49c4a$export$889129cf7f70997b) in this.props.prefetchedData) || this.props.prefetchedData[0, $c22b1ee1fcd49c4a$export$889129cf7f70997b] !== (0, $c22b1ee1fcd49c4a$export$b7dfe28569b170a1))) {
                // fires an analytics event to track that the cache is stale and will be updated
                (0, $5cznK.triggerCacheRefreshAnalytics)((0, $c22b1ee1fcd49c4a$export$dedbdcc35e955187));
                this.store.dispatch((0, $jiL2Q.loadAppData)({
                    prefetchedData: this.props.prefetchedData
                }));
            }
        }
        if ((0, $aFvYX.default)(prevAppProps, appProps)) return;
        this.store.dispatch((0, $jiL2Q.initializeAppProps)(appProps));
    }
    componentWillUnmount() {
        if (this.store && this.store.dispatch) this.store.dispatch((0, $4B7EY.DISPOSE_ACTION));
        (0, $1gQ73.unmountCachedStore)();
    }
    renderContent() {
        const { rapidViewId: rapidViewId, isCacheHit: isCacheHit, customFiltersQueryRef: customFiltersQueryRef, versionFilterRelayQueryRef: versionFilterRelayQueryRef, prefetchedAggData: prefetchedAggData, prefetchedJiraPlanRestData: prefetchedJiraPlanRestData, prefetchCmpBacklogData: prefetchCmpBacklogData } = this.props;
        const inner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $diedG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOINP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLaT7.default), {
            isCacheHit: isCacheHit,
            prefetchedData: this.prefetchedData,
            prefetchedAggData: prefetchedAggData,
            prefetchedPlanData: (0, $1ybV0.ff)('jsw.perf.enable-indexeddb-caching-for-backlog') ? prefetchCmpBacklogData?.result : prefetchedJiraPlanRestData,
            getLocation: this.onGetLocation,
            push: this.onPush,
            customFiltersQueryRef: customFiltersQueryRef,
            versionFilterRelayQueryRef: versionFilterRelayQueryRef
        })));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cA8OV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a2Kov.default), {
            boardId: Number(rapidViewId)
        }, inner), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9m9bG.FlagsDispatcher), {
            mapper: (0, $2a0bR.flagsMapper)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1JdUa.default), {
            origin: (0, $c22b1ee1fcd49c4a$export$dedbdcc35e955187)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $41KUh.default), {
            getCustomData: (0, $4T9ID.getCustomDataForMemoryAnalyticsFromUrl)
        }));
    }
    render() {
        const { isCompanyManaged: isCompanyManaged } = this.props;
        const metric = isCompanyManaged ? (0, $gPQCf.uifBacklogNewUiPageLoad) : (0, $gPQCf.nextGenBacklogPageLoad);
        if (!this.hasRendered) {
            (0, $6iz4v.setMark)((0, $5yh8X.jswRenderStartMark));
            metric.mark((0, $gPQCf.PAGE_LOAD_MARK_RENDER_START));
            $2f0c34147023c3d2$var$measureRender();
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
            id: (0, $7TyGu.APP_ID),
            teamName: (0, $7TyGu.TEAM_NAME),
            packageName: (0, $7TyGu.PACKAGE_NAME),
            store: this.store,
            fallback: "page"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1gQ73.BacklogReduxProvider), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8vO0b.default), {
            bindToOnJiraGlobalIssueCreateClose: this.props.bindToOnJiraGlobalIssueCreateClose
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $yuXsW.ApolloClientProvider), {
            client: (0, $2Wgbz.default)
        }, this.renderContent())));
    }
}
const $2f0c34147023c3d2$var$BacklogWrapper = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const storeFieldsActions = (0, $lA3UV.useStoreFields)();
    const refetchVersions = (0, $6M1P4.useVersionsRefetch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f0c34147023c3d2$var$Backlog, {
        ...props,
        storeFieldsActions: storeFieldsActions,
        refetchVersionsForProjects: refetchVersions,
        createAnalyticsEvent: createAnalyticsEvent
    });
});
// withRouter types are wrong
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $2f0c34147023c3d2$var$BacklogWithRouter = (0, $kJlBc.withRouter)($2f0c34147023c3d2$var$BacklogWrapper);
var $2f0c34147023c3d2$export$2e2bcd8739ae039 = $2f0c34147023c3d2$var$BacklogWithRouter;

});
parcelRegister("yuXsW", function(module, exports) {

$parcel$export(module.exports, "resetCache", () => $343a391851b41a38$export$6e5dca841bdf93e3);
$parcel$export(module.exports, "getClient", () => $343a391851b41a38$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "ApolloClientProvider", () => $343a391851b41a38$export$8e363dbef886ff17);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $4ErPU = parcelRequire("4ErPU");

var $gd0Sp = parcelRequire("gd0Sp");
const $343a391851b41a38$var$CLIENTS_CACHE = {};
const $343a391851b41a38$export$6e5dca841bdf93e3 = (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    $343a391851b41a38$var$CLIENTS_CACHE[clientId]?.clearStore();
    delete $343a391851b41a38$var$CLIENTS_CACHE[clientId];
};
const $343a391851b41a38$export$44dd3e9494f887fc = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys($343a391851b41a38$var$CLIENTS_CACHE).reduce((acc, key)=>Object.assign(acc, {
            [`apollo-cache/${key}`]: $343a391851b41a38$var$CLIENTS_CACHE[key].extract()
        }), {});
const $343a391851b41a38$export$6bb76d6eba7e258c = (baseUrl, { clientId: clientId, clientCreator: clientCreator }, xsrfToken)=>{
    let client = $343a391851b41a38$var$CLIENTS_CACHE[clientId];
    if (!client) {
        client = clientCreator(baseUrl, xsrfToken);
        $343a391851b41a38$var$CLIENTS_CACHE[clientId] = client;
    }
    return client;
};
class $343a391851b41a38$export$8e363dbef886ff17 extends (0, $eUqFw.Component) {
    getClient(baseUrl, xsrfToken) {
        return $343a391851b41a38$export$6bb76d6eba7e258c(baseUrl, this.props.client, xsrfToken != null ? xsrfToken : undefined);
    }
    render() {
        const { children: children } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(this.props, 'client.clientId')) throw new Error('Please provide a client configuration');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
            const client = this.getClient(tenantContext.baseUrl, tenantContext.xsrfToken);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ErPU.ApolloProvider), {
                client: client
            }, children);
        });
    }
}

});
parcelRegister("4ErPU", function(module, exports) {

$parcel$export(module.exports, "getApolloContext", () => $36307d91b5e24fba$export$a47505d961ee3a1);
$parcel$export(module.exports, "ApolloProvider", () => $36307d91b5e24fba$export$c16b04c8a9956446);
$parcel$export(module.exports, "DocumentType", () => $36307d91b5e24fba$export$d1d99cf900472499);
$parcel$export(module.exports, "operationName", () => $36307d91b5e24fba$export$5db520940cf00715);
$parcel$export(module.exports, "parser", () => $36307d91b5e24fba$export$8f49e4af10703ce3);

var $eUqFw = parcelRequire("eUqFw");

var $8j2fP = parcelRequire("8j2fP");
var $36307d91b5e24fba$var$apolloContext;
function $36307d91b5e24fba$export$a47505d961ee3a1() {
    if (!$36307d91b5e24fba$var$apolloContext) $36307d91b5e24fba$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
    return $36307d91b5e24fba$var$apolloContext;
}
function $36307d91b5e24fba$export$c2ee824bcc89ca6a() {
    $36307d91b5e24fba$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
}
var $36307d91b5e24fba$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $36307d91b5e24fba$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $8j2fP.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $36307d91b5e24fba$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $36307d91b5e24fba$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $8j2fP.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $36307d91b5e24fba$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($36307d91b5e24fba$export$d1d99cf900472499 || ($36307d91b5e24fba$export$d1d99cf900472499 = {}));
var $36307d91b5e24fba$var$cache = new Map();
function $36307d91b5e24fba$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $36307d91b5e24fba$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $36307d91b5e24fba$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $36307d91b5e24fba$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $36307d91b5e24fba$export$8f49e4af10703ce3(document) {
    var cached = $36307d91b5e24fba$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $8j2fP.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $8j2fP.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $8j2fP.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $36307d91b5e24fba$export$d1d99cf900472499.Query : $36307d91b5e24fba$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $36307d91b5e24fba$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $8j2fP.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $36307d91b5e24fba$var$cache.set(document, payload);
    return payload;
}

});
parcelRegister("8j2fP", function(module, exports) {

$parcel$export(module.exports, "InvariantError", () => $60c1d8bb20ac9f24$export$cea12affaee22fe8);
$parcel$export(module.exports, "invariant", () => $60c1d8bb20ac9f24$export$f5708dca728d7177);

var $fKE23 = parcelRequire("fKE23");

var $2fFJv = parcelRequire("2fFJv");
var $60c1d8bb20ac9f24$var$genericMessage = "Invariant Violation";
var $60c1d8bb20ac9f24$var$_a = Object.setPrototypeOf, $60c1d8bb20ac9f24$var$setPrototypeOf = $60c1d8bb20ac9f24$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $60c1d8bb20ac9f24$var$_a;
var $60c1d8bb20ac9f24$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $fKE23.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $60c1d8bb20ac9f24$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $60c1d8bb20ac9f24$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $60c1d8bb20ac9f24$var$genericMessage;
        $60c1d8bb20ac9f24$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $60c1d8bb20ac9f24$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $60c1d8bb20ac9f24$export$cea12affaee22fe8(message);
}
function $60c1d8bb20ac9f24$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $60c1d8bb20ac9f24$var$wrapConsoleMethod("warn");
    invariant.error = $60c1d8bb20ac9f24$var$wrapConsoleMethod("error");
})($60c1d8bb20ac9f24$export$f5708dca728d7177 || ($60c1d8bb20ac9f24$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $60c1d8bb20ac9f24$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $2fFJv === "object") $60c1d8bb20ac9f24$export$e54fe5b0f43758f7 = $2fFJv;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($60c1d8bb20ac9f24$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $60c1d8bb20ac9f24$var$invariant$1 = $60c1d8bb20ac9f24$export$f5708dca728d7177;
var $60c1d8bb20ac9f24$export$2e2bcd8739ae039 = $60c1d8bb20ac9f24$var$invariant$1;

});



parcelRegister("2Wgbz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e169a67ca28ac2$export$2e2bcd8739ae039);

var $illlw = parcelRequire("illlw");

var $2vRh6 = parcelRequire("2vRh6");

var $jlBDe = parcelRequire("jlBDe");

var $bvQX6 = parcelRequire("bvQX6");

var $8Y3VE = parcelRequire("8Y3VE");

var $aqG9W = parcelRequire("aqG9W");

var $35Kb7 = parcelRequire("35Kb7");

var $kcwGc = parcelRequire("kcwGc");

var $10n8H = parcelRequire("10n8H");

var $5zSUY = parcelRequire("5zSUY");

var $2emZ8 = parcelRequire("2emZ8");
var $eeJ3R = parcelRequire("eeJ3R");

var $aXA7t = parcelRequire("aXA7t");

var $277yk = parcelRequire("277yk");

var $9ypom = parcelRequire("9ypom");

var $dYexY = parcelRequire("dYexY");
const $a3e169a67ca28ac2$var$retryLink = new (0, $kcwGc.RetryLink)({
    attempts: {
        max: 2,
        retryIf: (networkError, operation)=>{
            const { operationName: operationName } = operation;
            const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(networkError, [
                'statusCode'
            ], null);
            // retry once when SWAG Node is dead.
            const shouldRetry = [
                502,
                503,
                504
            ].includes(Number(statusCode));
            if (shouldRetry) (0, $eeJ3R.logApolloRetry)({
                queryName: operationName,
                statusCode: statusCode
            });
            return shouldRetry;
        }
    }
});
const $a3e169a67ca28ac2$var$errorLink = (0, $aqG9W.onError)(({ operation: operation, graphQLErrors: graphQLErrors, networkError: networkError })=>{
    const { operationName: operationName } = operation;
    if (graphQLErrors) {
        if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ path: path, extensions: extensions })=>{
            const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(extensions, [
                'statusCode'
            ], null);
            const errorType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(extensions, [
                'errorType'
            ], null);
            return (0, $eeJ3R.logApolloError)(path, statusCode, operationName, errorType);
        });
        else (0, $eeJ3R.logRestParsingError)('Unexpected error message format', JSON.stringify(graphQLErrors));
    }
    if (networkError) {
        const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(networkError, [
            'statusCode'
        ], null);
        (0, $eeJ3R.logApolloNetworkError)(networkError.toString(), statusCode, operationName);
    }
});
// Exporting fragmentMatcher to use it in StoryBook examples
const $a3e169a67ca28ac2$var$fragmentMatcher = new (0, $2vRh6.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: (/*@__PURE__*/$parcel$interopDefault($277yk))
});
const $a3e169a67ca28ac2$var$cacheConfig = {
    cacheRedirects: {
        Query: {
            ...(0, $10n8H.fragmentCacheRedirect)()
        }
    },
    freezeResults: true,
    fragmentMatcher: $a3e169a67ca28ac2$var$fragmentMatcher
};
const $a3e169a67ca28ac2$var$cache = new (0, $2vRh6.InMemoryCache)($a3e169a67ca28ac2$var$cacheConfig);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a3e169a67ca28ac2$var$customFetch = (uri, options)=>{
    const body = options && options.body ? JSON.parse(options.body) : null;
    return fetch(`${uri}?operation=${body ? body.operationName : 'unknown'}`, options);
};
const $a3e169a67ca28ac2$var$xsrfLink = ()=>(0, $8Y3VE.setContext)((operation, previousContext)=>{
        const { headers: headers } = previousContext;
        // set empty xsrfToken for SSR as cookies are unavailable
        const xsrfToken = false ? '' : (0, $5zSUY.default)();
        if (!xsrfToken) return previousContext;
        return {
            ...previousContext,
            headers: {
                ...headers,
                'atl-xsrf-token': xsrfToken
            }
        };
    });
const $a3e169a67ca28ac2$var$clientCreator = (baseUrl)=>new (0, $jlBDe.ApolloClient)({
        name: 'SWAG',
        link: (0, $bvQX6.ApolloLink).from([
            $a3e169a67ca28ac2$var$retryLink,
            $a3e169a67ca28ac2$var$xsrfLink(),
            $a3e169a67ca28ac2$var$errorLink,
            (0, $aXA7t.UFOLoggerLink),
            (0, $10n8H.fragmentLinkState)($a3e169a67ca28ac2$var$cache),
            new (0, $35Kb7.HttpLink)({
                uri: `${baseUrl}/jsw2/graphql`,
                credentials: 'same-origin',
                fetch: $a3e169a67ca28ac2$var$customFetch
            })
        ]),
        cache: $a3e169a67ca28ac2$var$cache,
        assumeImmutableResults: true
    });
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$a3e169a67ca28ac2$export$2e2bcd8739ae039 = {
    clientId: 'SWAG',
    clientCreator: $a3e169a67ca28ac2$var$clientCreator
};

});
parcelRegister("2vRh6", function(module, exports) {

$parcel$export(module.exports, "IntrospectionFragmentMatcher", () => $1d47cd4d9b8db33d$export$3b71c6b829c99d21);
$parcel$export(module.exports, "defaultDataIdFromObject", () => $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "InMemoryCache", () => $1d47cd4d9b8db33d$export$467265324939f47f);

var $fKE23 = parcelRequire("fKE23");

var $bO1Qv = parcelRequire("bO1Qv");

var $42BH7 = parcelRequire("42BH7");
var $66hGB = parcelRequire("66hGB");

var $7xYai = parcelRequire("7xYai");

var $8j2fP = parcelRequire("8j2fP");
var $1d47cd4d9b8db33d$var$haveWarned = false;
function $1d47cd4d9b8db33d$var$shouldWarn() {
    var answer = !$1d47cd4d9b8db33d$var$haveWarned;
    if (!(0, $42BH7.isTest)()) $1d47cd4d9b8db33d$var$haveWarned = true;
    return answer;
}
var $1d47cd4d9b8db33d$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            $1d47cd4d9b8db33d$var$shouldWarn();
            return 'heuristic';
        }
        if (__typename === typeCondition) return true;
        $1d47cd4d9b8db33d$var$shouldWarn();
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}();
var $1d47cd4d9b8db33d$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $8j2fP.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        (0, $8j2fP.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $1d47cd4d9b8db33d$var$hasOwn = Object.prototype.hasOwnProperty;
var $1d47cd4d9b8db33d$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $7xYai.wrap)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($1d47cd4d9b8db33d$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$1d47cd4d9b8db33d$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory(seed) {
    return new $1d47cd4d9b8db33d$var$DepTrackingCache(seed);
}
var $1d47cd4d9b8db33d$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $7xYai.KeyTrie)((0, $42BH7.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $7xYai.wrap)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $7xYai.wrap)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $7xYai.wrap)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $42BH7.getQueryDefinition)(query);
        variables = (0, $42BH7.assign)({}, (0, $42BH7.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query'
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $8j2fP.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $66hGB.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $42BH7.getMainDefinition)(query);
        var fragments = (0, $42BH7.getFragmentDefinitions)(query);
        var fragmentMap = (0, $42BH7.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $42BH7.shouldInclude)(selection, variables)) return;
            if ((0, $42BH7.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, $42BH7.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $8j2fP.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $42BH7.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $42BH7.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $42BH7.resultKeyNameFromField)(field),
            directives: (0, $42BH7.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $1d47cd4d9b8db33d$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $42BH7.isIdValue)(value)) throw new (0, $8j2fP.InvariantError)(10);
}
function $1d47cd4d9b8db33d$var$defaultFragmentMatcher() {
    return true;
}
function $1d47cd4d9b8db33d$export$7a4899fe13f33235(idValue) {
    (0, $8j2fP.invariant)((0, $42BH7.isIdValue)(idValue), 11);
}
function $1d47cd4d9b8db33d$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $42BH7.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $42BH7.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === 'undefined') return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $42BH7.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $1d47cd4d9b8db33d$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $1d47cd4d9b8db33d$export$7e2b40d1002de152(seed) {
    return new $1d47cd4d9b8db33d$export$ee7258b8691956a3(seed);
}
var $1d47cd4d9b8db33d$export$de4e6870dc6ac801 = function(_super) {
    (0, $fKE23.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error);
function $1d47cd4d9b8db33d$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $1d47cd4d9b8db33d$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $1d47cd4d9b8db33d$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $42BH7.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $42BH7.assign)({}, (0, $42BH7.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $42BH7.createFragmentMap)((0, $42BH7.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $1d47cd4d9b8db33d$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $42BH7.shouldInclude)(selection, variables)) return;
            if ((0, $42BH7.isField)(selection)) {
                var resultFieldKey = (0, $42BH7.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'defer';
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'client';
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $8j2fP.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = (0, $42BH7.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $1d47cd4d9b8db33d$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $42BH7.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $42BH7.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$1d47cd4d9b8db33d$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $8j2fP.invariant)(!semanticId || !$1d47cd4d9b8db33d$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$1d47cd4d9b8db33d$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $42BH7.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $42BH7.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $8j2fP.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $8j2fP.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $1d47cd4d9b8db33d$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $66hGB.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$1d47cd4d9b8db33d$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $42BH7.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $1d47cd4d9b8db33d$var$isGeneratedId(id) {
    return id[0] === '$';
}
function $1d47cd4d9b8db33d$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $42BH7.isIdValue)(value) && $1d47cd4d9b8db33d$var$isGeneratedId(value.id) && (0, $42BH7.isIdValue)(realValue) && !(0, $66hGB.equal)(value, realValue) && $1d47cd4d9b8db33d$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, generated), real);
    if ((0, $66hGB.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $1d47cd4d9b8db33d$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $1d47cd4d9b8db33d$var$defaultConfig = {
    fragmentMatcher: new $1d47cd4d9b8db33d$export$5d3fcf53267091de(),
    dataIdFromObject: $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $1d47cd4d9b8db33d$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $1d47cd4d9b8db33d$var$OptimisticCacheLayer = function(_super) {
    (0, $fKE23.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $1d47cd4d9b8db33d$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($1d47cd4d9b8db33d$export$ee7258b8691956a3);
var $1d47cd4d9b8db33d$export$467265324939f47f = function(_super) {
    (0, $fKE23.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $7xYai.KeyTrie)((0, $42BH7.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, $1d47cd4d9b8db33d$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $1d47cd4d9b8db33d$var$DepTrackingCache() : new $1d47cd4d9b8db33d$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $1d47cd4d9b8db33d$export$eb8361c5d132fb8f();
        _this.storeReader = new $1d47cd4d9b8db33d$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $7xYai.wrap)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $8j2fP.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $1d47cd4d9b8db33d$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') this.data = this.optimisticData = new $1d47cd4d9b8db33d$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $42BH7.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $bO1Qv.ApolloCache));

});
parcelRegister("bO1Qv", function(module, exports) {

$parcel$export(module.exports, "ApolloCache", () => $8985cbc47a37b971$export$5fc74f25506aa9c);

var $42BH7 = parcelRequire("42BH7");
function $8985cbc47a37b971$var$queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $8985cbc47a37b971$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            op
        ]
    };
    return out;
}
function $8985cbc47a37b971$var$fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType'
            }
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $8985cbc47a37b971$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            frag
        ]
    };
    return out;
}
function $8985cbc47a37b971$var$selectionSetFromObj(obj) {
    if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
    if (Array.isArray(obj)) return $8985cbc47a37b971$var$selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = $8985cbc47a37b971$var$selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections
    };
    return selectionSet;
}
var $8985cbc47a37b971$var$justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename'
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var $8985cbc47a37b971$export$5fc74f25506aa9c = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, $42BH7.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, $42BH7.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: $8985cbc47a37b971$var$justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || '__ClientData';
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: $8985cbc47a37b971$var$fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: $8985cbc47a37b971$var$queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var $8985cbc47a37b971$export$94affb487e701bf2;
$8985cbc47a37b971$export$94affb487e701bf2 || ($8985cbc47a37b971$export$94affb487e701bf2 = {});

});
parcelRegister("42BH7", function(module, exports) {

$parcel$export(module.exports, "storeKeyNameFromField", () => $2f1496a7de754c2a$export$54be8689c65f3b56);
$parcel$export(module.exports, "getStoreKeyName", () => $2f1496a7de754c2a$export$3cdb6c178b88cabe);
$parcel$export(module.exports, "argumentsObjectFromField", () => $2f1496a7de754c2a$export$3f5a60fb6a781b4f);
$parcel$export(module.exports, "resultKeyNameFromField", () => $2f1496a7de754c2a$export$7d1ad22471852218);
$parcel$export(module.exports, "isField", () => $2f1496a7de754c2a$export$fb56ad75dd311c12);
$parcel$export(module.exports, "isInlineFragment", () => $2f1496a7de754c2a$export$22a1cdafaf27bcff);
$parcel$export(module.exports, "isIdValue", () => $2f1496a7de754c2a$export$e33b89a9aa87695);
$parcel$export(module.exports, "toIdValue", () => $2f1496a7de754c2a$export$b124f125e34d720a);
$parcel$export(module.exports, "isJsonValue", () => $2f1496a7de754c2a$export$226c1c6d1a5b660a);
$parcel$export(module.exports, "getDirectiveInfoFromField", () => $2f1496a7de754c2a$export$2a7f471142984a91);
$parcel$export(module.exports, "shouldInclude", () => $2f1496a7de754c2a$export$3dc388a5f013b4a5);
$parcel$export(module.exports, "hasDirectives", () => $2f1496a7de754c2a$export$2dafb573e282fe8d);
$parcel$export(module.exports, "hasClientExports", () => $2f1496a7de754c2a$export$8d1e9e5bbfa5d09a);
$parcel$export(module.exports, "getFragmentQueryDocument", () => $2f1496a7de754c2a$export$abbf37c7cf644e41);
$parcel$export(module.exports, "assign", () => $2f1496a7de754c2a$export$e6e34fd1f2686227);
$parcel$export(module.exports, "checkDocument", () => $2f1496a7de754c2a$export$a7d0d8111d2386df);
$parcel$export(module.exports, "getOperationDefinition", () => $2f1496a7de754c2a$export$7a5b1fa979d2c158);
$parcel$export(module.exports, "getOperationName", () => $2f1496a7de754c2a$export$41bca9dc6871dd4e);
$parcel$export(module.exports, "getFragmentDefinitions", () => $2f1496a7de754c2a$export$5320a7ba9466a3df);
$parcel$export(module.exports, "getQueryDefinition", () => $2f1496a7de754c2a$export$d96b2213c1b9d3a9);
$parcel$export(module.exports, "getMainDefinition", () => $2f1496a7de754c2a$export$f431198736b7f96d);
$parcel$export(module.exports, "createFragmentMap", () => $2f1496a7de754c2a$export$193789b4c8246dd4);
$parcel$export(module.exports, "getDefaultValues", () => $2f1496a7de754c2a$export$84c19026e616569e);
$parcel$export(module.exports, "removeDirectivesFromDocument", () => $2f1496a7de754c2a$export$e5ae0530da5fe96c);
$parcel$export(module.exports, "addTypenameToDocument", () => $2f1496a7de754c2a$export$43b332f87950a467);
$parcel$export(module.exports, "removeConnectionDirectiveFromDocument", () => $2f1496a7de754c2a$export$74985f3324559867);
$parcel$export(module.exports, "buildQueryFromSelectionSet", () => $2f1496a7de754c2a$export$57c368c23873f32b);
$parcel$export(module.exports, "removeClientSetsFromDocument", () => $2f1496a7de754c2a$export$8eae69e876ee321e);
$parcel$export(module.exports, "canUseWeakMap", () => $2f1496a7de754c2a$export$772fbc04a0ad4ce9);
$parcel$export(module.exports, "cloneDeep", () => $2f1496a7de754c2a$export$629a2bd3f5a49ecc);
$parcel$export(module.exports, "isProduction", () => $2f1496a7de754c2a$export$f15d00aa73aafac4);
$parcel$export(module.exports, "isTest", () => $2f1496a7de754c2a$export$410cbc2864fa25b5);
$parcel$export(module.exports, "tryFunctionOrLogError", () => $2f1496a7de754c2a$export$50a91acae4904909);
$parcel$export(module.exports, "graphQLResultHasError", () => $2f1496a7de754c2a$export$b4df399e879e53ab);
$parcel$export(module.exports, "mergeDeep", () => $2f1496a7de754c2a$export$dd702b3c8240390c);
$parcel$export(module.exports, "mergeDeepArray", () => $2f1496a7de754c2a$export$160070228be94b08);

var $961BR = parcelRequire("961BR");

var $8j2fP = parcelRequire("8j2fP");

var $fKE23 = parcelRequire("fKE23");

var $cGs0N = parcelRequire("cGs0N");

var $66hGB = parcelRequire("66hGB");

var $2fFJv = parcelRequire("2fFJv");
function $2f1496a7de754c2a$export$dc071f102752d0eb(value) {
    return [
        'StringValue',
        'BooleanValue',
        'EnumValue'
    ].indexOf(value.kind) > -1;
}
function $2f1496a7de754c2a$export$3ff5e9927c3257c6(value) {
    return [
        'IntValue',
        'FloatValue'
    ].indexOf(value.kind) > -1;
}
function $2f1496a7de754c2a$var$isStringValue(value) {
    return value.kind === 'StringValue';
}
function $2f1496a7de754c2a$var$isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function $2f1496a7de754c2a$var$isIntValue(value) {
    return value.kind === 'IntValue';
}
function $2f1496a7de754c2a$var$isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function $2f1496a7de754c2a$var$isVariable(value) {
    return value.kind === 'Variable';
}
function $2f1496a7de754c2a$var$isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function $2f1496a7de754c2a$var$isListValue(value) {
    return value.kind === 'ListValue';
}
function $2f1496a7de754c2a$var$isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function $2f1496a7de754c2a$var$isNullValue(value) {
    return value.kind === 'NullValue';
}
function $2f1496a7de754c2a$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($2f1496a7de754c2a$var$isIntValue(value) || $2f1496a7de754c2a$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($2f1496a7de754c2a$var$isBooleanValue(value) || $2f1496a7de754c2a$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($2f1496a7de754c2a$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $2f1496a7de754c2a$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($2f1496a7de754c2a$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($2f1496a7de754c2a$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $2f1496a7de754c2a$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($2f1496a7de754c2a$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($2f1496a7de754c2a$var$isNullValue(value)) argObj[name.value] = null;
    else throw new (0, $8j2fP.InvariantError)(17);
}
function $2f1496a7de754c2a$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $2f1496a7de754c2a$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $2f1496a7de754c2a$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $2f1496a7de754c2a$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $2f1496a7de754c2a$var$KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export'
];
function $2f1496a7de754c2a$export$3cdb6c178b88cabe(fieldName, args, directives) {
    if (directives && directives['connection'] && directives['connection']['key']) {
        if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        } else return directives['connection']['key'];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = (0, (/*@__PURE__*/$parcel$interopDefault($cGs0N)))(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($2f1496a7de754c2a$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
        else completeFieldName += "@" + key;
    });
    return completeFieldName;
}
function $2f1496a7de754c2a$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $2f1496a7de754c2a$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $2f1496a7de754c2a$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $2f1496a7de754c2a$export$fb56ad75dd311c12(selection) {
    return selection.kind === 'Field';
}
function $2f1496a7de754c2a$export$22a1cdafaf27bcff(selection) {
    return selection.kind === 'InlineFragment';
}
function $2f1496a7de754c2a$export$e33b89a9aa87695(idObject) {
    return idObject && idObject.type === 'id' && typeof idObject.generated === 'boolean';
}
function $2f1496a7de754c2a$export$b124f125e34d720a(idConfig, generated) {
    if (generated === void 0) generated = false;
    return (0, $fKE23.__assign)({
        type: 'id',
        generated: generated
    }, typeof idConfig === 'string' ? {
        id: idConfig,
        typename: undefined
    } : idConfig);
}
function $2f1496a7de754c2a$export$226c1c6d1a5b660a(jsonObject) {
    return jsonObject != null && typeof jsonObject === 'object' && jsonObject.type === 'json';
}
function $2f1496a7de754c2a$var$defaultValueFromVariable(node) {
    throw new (0, $8j2fP.InvariantError)(18);
}
function $2f1496a7de754c2a$export$b3db129ed867b445(node, onVariable) {
    if (onVariable === void 0) onVariable = $2f1496a7de754c2a$var$defaultValueFromVariable;
    switch(node.kind){
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value, 10);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function(v) {
                return $2f1496a7de754c2a$export$b3db129ed867b445(v, onVariable);
            });
        case 'ObjectValue':
            var value = {};
            for(var _i = 0, _a = node.fields; _i < _a.length; _i++){
                var field = _a[_i];
                value[field.name.value] = $2f1496a7de754c2a$export$b3db129ed867b445(field.value, onVariable);
            }
            return value;
        default:
            return node.value;
    }
}
function $2f1496a7de754c2a$export$2a7f471142984a91(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function(directive) {
            directiveObj_1[directive.name.value] = $2f1496a7de754c2a$export$3f5a60fb6a781b4f(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function $2f1496a7de754c2a$export$3dc388a5f013b4a5(selection, variables) {
    if (variables === void 0) variables = {};
    return $2f1496a7de754c2a$export$b7bdffb7e6f1ef53(selection.directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables[ifArgument.value.name.value];
            (0, $8j2fP.invariant)(evaledValue !== void 0, 13);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function $2f1496a7de754c2a$export$1b217de6ce18b9a(doc) {
    var names = [];
    (0, $961BR.visit)(doc, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
function $2f1496a7de754c2a$export$2dafb573e282fe8d(names, doc) {
    return $2f1496a7de754c2a$export$1b217de6ce18b9a(doc).some(function(name) {
        return names.indexOf(name) > -1;
    });
}
function $2f1496a7de754c2a$export$8d1e9e5bbfa5d09a(document) {
    return document && $2f1496a7de754c2a$export$2dafb573e282fe8d([
        'client'
    ], document) && $2f1496a7de754c2a$export$2dafb573e282fe8d([
        'export'
    ], document);
}
function $2f1496a7de754c2a$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function $2f1496a7de754c2a$export$b7bdffb7e6f1ef53(directives) {
    return directives ? directives.filter($2f1496a7de754c2a$var$isInclusionDirective).map(function(directive) {
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $8j2fP.invariant)(directiveArguments && directiveArguments.length === 1, 14);
        var ifArgument = directiveArguments[0];
        (0, $8j2fP.invariant)(ifArgument.name && ifArgument.name.value === 'if', 15);
        var ifValue = ifArgument.value;
        (0, $8j2fP.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16);
        return {
            directive: directive,
            ifArgument: ifArgument
        };
    }) : [];
}
function $2f1496a7de754c2a$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === 'OperationDefinition') throw new (0, $8j2fP.InvariantError)(11);
        if (definition.kind === 'FragmentDefinition') fragments.push(definition);
    });
    if (typeof actualFragmentName === 'undefined') {
        (0, $8j2fP.invariant)(fragments.length === 1, 12);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, document), {
        definitions: (0, $fKE23.__spreadArrays)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions)
    });
    return query;
}
function $2f1496a7de754c2a$export$e6e34fd1f2686227(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    sources.forEach(function(source) {
        if (typeof source === 'undefined' || source === null) return;
        Object.keys(source).forEach(function(key) {
            target[key] = source[key];
        });
    });
    return target;
}
function $2f1496a7de754c2a$export$a92e7a440b22bdf0(doc) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(doc);
    var mutationDef = doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.operation === 'mutation';
    })[0];
    (0, $8j2fP.invariant)(mutationDef, 1);
    return mutationDef;
}
function $2f1496a7de754c2a$export$a7d0d8111d2386df(doc) {
    (0, $8j2fP.invariant)(doc && doc.kind === 'Document', 2);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== 'FragmentDefinition';
    }).map(function(definition) {
        if (definition.kind !== 'OperationDefinition') throw new (0, $8j2fP.InvariantError)(3);
        return definition;
    });
    (0, $8j2fP.invariant)(operations.length <= 1, 4);
    return doc;
}
function $2f1496a7de754c2a$export$7a5b1fa979d2c158(doc) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition';
    })[0];
}
function $2f1496a7de754c2a$export$78a8e95d8d43ad7f(document) {
    var def = $2f1496a7de754c2a$export$7a5b1fa979d2c158(document);
    (0, $8j2fP.invariant)(def, 5);
    return def;
}
function $2f1496a7de754c2a$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $2f1496a7de754c2a$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'FragmentDefinition';
    });
}
function $2f1496a7de754c2a$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $2f1496a7de754c2a$export$7a5b1fa979d2c158(doc);
    (0, $8j2fP.invariant)(queryDef && queryDef.operation === 'query', 6);
    return queryDef;
}
function $2f1496a7de754c2a$export$772111caef41b3f5(doc) {
    (0, $8j2fP.invariant)(doc.kind === 'Document', 7);
    (0, $8j2fP.invariant)(doc.definitions.length <= 1, 8);
    var fragmentDef = doc.definitions[0];
    (0, $8j2fP.invariant)(fragmentDef.kind === 'FragmentDefinition', 9);
    return fragmentDef;
}
function $2f1496a7de754c2a$export$f431198736b7f96d(queryDoc) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' || operation === 'mutation' || operation === 'subscription') return definition;
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw new (0, $8j2fP.InvariantError)(10);
}
function $2f1496a7de754c2a$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $2f1496a7de754c2a$export$84c19026e616569e(definition) {
    if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions.filter(function(_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        }).map(function(_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            $2f1496a7de754c2a$export$a1dab82d368d6525(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return $2f1496a7de754c2a$export$e6e34fd1f2686227.apply(void 0, (0, $fKE23.__spreadArrays)([
            {}
        ], defaultValues));
    }
    return {};
}
function $2f1496a7de754c2a$export$55ead6c9e4eac970(operation) {
    var names = new Set();
    if (operation.variableDefinitions) for(var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++){
        var definition = _a[_i];
        names.add(definition.variable.name.value);
    }
    return names;
}
function $2f1496a7de754c2a$var$filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function(elem, i) {
        if (test.call(this, elem, i, array)) array[target++] = elem;
    }, context);
    array.length = target;
    return array;
}
var $2f1496a7de754c2a$var$TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename'
    }
};
function $2f1496a7de754c2a$var$isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function(selection) {
        return selection.kind === 'FragmentSpread' && $2f1496a7de754c2a$var$isEmpty(fragments[selection.name.value], fragments);
    });
}
function $2f1496a7de754c2a$var$nullIfDocIsEmpty(doc) {
    return $2f1496a7de754c2a$var$isEmpty($2f1496a7de754c2a$export$7a5b1fa979d2c158(doc) || $2f1496a7de754c2a$export$772111caef41b3f5(doc), $2f1496a7de754c2a$export$193789b4c8246dd4($2f1496a7de754c2a$export$5320a7ba9466a3df(doc))) ? null : doc;
}
function $2f1496a7de754c2a$var$getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function(dir) {
            return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
        });
    };
}
function $2f1496a7de754c2a$export$e5ae0530da5fe96c(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = $2f1496a7de754c2a$var$nullIfDocIsEmpty((0, $961BR.visit)(doc, {
        Variable: {
            enter: function(node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') variablesInUse[node.name.value] = true;
            }
        },
        Field: {
            enter: function(node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function(directive) {
                        return directive.remove;
                    });
                    if (shouldRemoveField && node.directives && node.directives.some($2f1496a7de754c2a$var$getDirectiveMatcher(directives))) {
                        if (node.arguments) node.arguments.forEach(function(arg) {
                            if (arg.value.kind === 'Variable') variablesToRemove.push({
                                name: arg.value.name.value
                            });
                        });
                        if (node.selectionSet) $2f1496a7de754c2a$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                            fragmentSpreadsToRemove.push({
                                name: frag.name.value
                            });
                        });
                        return null;
                    }
                }
            }
        },
        FragmentSpread: {
            enter: function(node) {
                fragmentSpreadsInUse[node.name.value] = true;
            }
        },
        Directive: {
            enter: function(node) {
                if ($2f1496a7de754c2a$var$getDirectiveMatcher(directives)(node)) return null;
            }
        }
    }));
    if (modifiedDoc && $2f1496a7de754c2a$var$filterInPlace(variablesToRemove, function(v) {
        return !variablesInUse[v.name];
    }).length) modifiedDoc = $2f1496a7de754c2a$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
    if (modifiedDoc && $2f1496a7de754c2a$var$filterInPlace(fragmentSpreadsToRemove, function(fs) {
        return !fragmentSpreadsInUse[fs.name];
    }).length) modifiedDoc = $2f1496a7de754c2a$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
    return modifiedDoc;
}
function $2f1496a7de754c2a$export$43b332f87950a467(doc) {
    return (0, $961BR.visit)($2f1496a7de754c2a$export$a7d0d8111d2386df(doc), {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === 'OperationDefinition') return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return $2f1496a7de754c2a$export$fb56ad75dd311c12(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ($2f1496a7de754c2a$export$fb56ad75dd311c12(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === 'export';
                })) return;
                return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                    selections: (0, $fKE23.__spreadArrays)(selections, [
                        $2f1496a7de754c2a$var$TYPENAME_FIELD
                    ])
                });
            }
        }
    });
}
var $2f1496a7de754c2a$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
            return arg.name.value === 'key';
        });
        return willRemove;
    }
};
function $2f1496a7de754c2a$export$74985f3324559867(doc) {
    return $2f1496a7de754c2a$export$e5ae0530da5fe96c([
        $2f1496a7de754c2a$var$connectionRemoveConfig
    ], $2f1496a7de754c2a$export$a7d0d8111d2386df(doc));
}
function $2f1496a7de754c2a$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $2f1496a7de754c2a$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $2f1496a7de754c2a$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!$2f1496a7de754c2a$export$fb56ad75dd311c12(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($2f1496a7de754c2a$var$getDirectiveMatcher(directives)) || nestedCheck && $2f1496a7de754c2a$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $2f1496a7de754c2a$export$deed3420cb5d2e1d(directives, doc) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(doc);
    var parentPath;
    return $2f1496a7de754c2a$var$nullIfDocIsEmpty((0, $961BR.visit)(doc, {
        SelectionSet: {
            enter: function(node, _key, _parent, path) {
                var currentPath = path.join('-');
                if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
                    if (node.selections) {
                        var selectionsWithDirectives = node.selections.filter(function(selection) {
                            return $2f1496a7de754c2a$var$hasDirectivesInSelection(directives, selection);
                        });
                        if ($2f1496a7de754c2a$var$hasDirectivesInSelectionSet(directives, node, false)) parentPath = currentPath;
                        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                            selections: selectionsWithDirectives
                        });
                    } else return null;
                }
            }
        }
    }));
}
function $2f1496a7de754c2a$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $2f1496a7de754c2a$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $2f1496a7de754c2a$var$getArgumentMatcher(config);
    return $2f1496a7de754c2a$var$nullIfDocIsEmpty((0, $961BR.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                    variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    })
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $2f1496a7de754c2a$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $2f1496a7de754c2a$var$nullIfDocIsEmpty((0, $961BR.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $2f1496a7de754c2a$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function(selection) {
        if (($2f1496a7de754c2a$export$fb56ad75dd311c12(selection) || $2f1496a7de754c2a$export$22a1cdafaf27bcff(selection)) && selection.selectionSet) $2f1496a7de754c2a$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
            return allFragments.push(frag);
        });
        else if (selection.kind === 'FragmentSpread') allFragments.push(selection);
    });
    return allFragments;
}
function $2f1496a7de754c2a$export$57c368c23873f32b(document) {
    var definition = $2f1496a7de754c2a$export$f431198736b7f96d(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') return document;
    var modifiedDoc = (0, $961BR.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                    operation: 'query'
                });
            }
        }
    });
    return modifiedDoc;
}
function $2f1496a7de754c2a$export$8eae69e876ee321e(document) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(document);
    var modifiedDoc = $2f1496a7de754c2a$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === 'client';
            },
            remove: true
        }
    ], document);
    if (modifiedDoc) modifiedDoc = (0, $961BR.visit)(modifiedDoc, {
        FragmentDefinition: {
            enter: function(node) {
                if (node.selectionSet) {
                    var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                        return $2f1496a7de754c2a$export$fb56ad75dd311c12(selection) && selection.name.value === '__typename';
                    });
                    if (isTypenameOnly) return null;
                }
            }
        }
    });
    return modifiedDoc;
}
var $2f1496a7de754c2a$export$772fbc04a0ad4ce9 = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');
var $2f1496a7de754c2a$var$toString = Object.prototype.toString;
function $2f1496a7de754c2a$export$629a2bd3f5a49ecc(value) {
    return $2f1496a7de754c2a$var$cloneDeepHelper(value, new Map());
}
function $2f1496a7de754c2a$var$cloneDeepHelper(val, seen) {
    switch($2f1496a7de754c2a$var$toString.call(val)){
        case "[object Array]":
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $2f1496a7de754c2a$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $2f1496a7de754c2a$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}
function $2f1496a7de754c2a$export$4bd44a2aa29d3d6e() {
    if (typeof $2fFJv !== 'undefined' && "production") return "production";
    return 'development';
}
function $2f1496a7de754c2a$export$f0cb0fda19c18b37(env) {
    return $2f1496a7de754c2a$export$4bd44a2aa29d3d6e() === env;
}
function $2f1496a7de754c2a$export$f15d00aa73aafac4() {
    return $2f1496a7de754c2a$export$f0cb0fda19c18b37('production') === true;
}
function $2f1496a7de754c2a$export$df77466336fe5355() {
    return $2f1496a7de754c2a$export$f0cb0fda19c18b37('development') === true;
}
function $2f1496a7de754c2a$export$410cbc2864fa25b5() {
    return $2f1496a7de754c2a$export$f0cb0fda19c18b37('test') === true;
}
function $2f1496a7de754c2a$export$50a91acae4904909(f) {
    try {
        return f();
    } catch (e) {
        if (console.error) console.error(e);
    }
}
function $2f1496a7de754c2a$export$b4df399e879e53ab(result) {
    return result.errors && result.errors.length;
}
function $2f1496a7de754c2a$var$deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function(prop) {
        if (o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) $2f1496a7de754c2a$var$deepFreeze(o[prop]);
    });
    return o;
}
function $2f1496a7de754c2a$export$7f9c177735b71f18(obj) {
    if ($2f1496a7de754c2a$export$df77466336fe5355() || $2f1496a7de754c2a$export$410cbc2864fa25b5()) {
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) return $2f1496a7de754c2a$var$deepFreeze(obj);
    }
    return obj;
}
var $2f1496a7de754c2a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $2f1496a7de754c2a$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $2f1496a7de754c2a$export$160070228be94b08(sources);
}
function $2f1496a7de754c2a$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = $2f1496a7de754c2a$var$shallowCopyForMerge(target, pastCopies);
        for(var i = 1; i < count; ++i)target = $2f1496a7de754c2a$var$mergeHelper(target, sources[i], pastCopies);
    }
    return target;
}
function $2f1496a7de754c2a$var$isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function $2f1496a7de754c2a$var$mergeHelper(target, source, pastCopies) {
    if ($2f1496a7de754c2a$var$isObject(source) && $2f1496a7de754c2a$var$isObject(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) target = $2f1496a7de754c2a$var$shallowCopyForMerge(target, pastCopies);
        Object.keys(source).forEach(function(sourceKey) {
            var sourceValue = source[sourceKey];
            if ($2f1496a7de754c2a$var$hasOwnProperty.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) target[sourceKey] = $2f1496a7de754c2a$var$mergeHelper($2f1496a7de754c2a$var$shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
            } else target[sourceKey] = sourceValue;
        });
        return target;
    }
    return source;
}
function $2f1496a7de754c2a$var$shallowCopyForMerge(value, pastCopies) {
    if (value !== null && typeof value === 'object' && pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) value = value.slice(0);
        else value = (0, $fKE23.__assign)({
            __proto__: Object.getPrototypeOf(value)
        }, value);
        pastCopies.push(value);
    }
    return value;
}
var $2f1496a7de754c2a$var$haveWarned = Object.create({});
function $2f1496a7de754c2a$export$49d47c8e549bfaf9(msg, type) {
    if (type === void 0) type = 'warn';
    if (!$2f1496a7de754c2a$export$f15d00aa73aafac4() && !$2f1496a7de754c2a$var$haveWarned[msg]) {
        if (!$2f1496a7de754c2a$export$410cbc2864fa25b5()) $2f1496a7de754c2a$var$haveWarned[msg] = true;
        if (type === 'error') console.error(msg);
        else console.warn(msg);
    }
}
function $2f1496a7de754c2a$export$c54efeba029d4fe8(data) {
    return JSON.parse(JSON.stringify(data));
}

});
parcelRegister("961BR", function(module, exports) {

$parcel$export(module.exports, "BREAK", () => $916291e3e456a050$export$a89c95c098ac2a58);
$parcel$export(module.exports, "visit", () => $916291e3e456a050$export$bf638b60ea8b89b7);
$parcel$export(module.exports, "getVisitFn", () => $916291e3e456a050$export$c9c25cca74db6e70);
$parcel$export(module.exports, "visitInParallel", () => $916291e3e456a050$export$728beebeea393478);

var $biK02 = parcelRequire("biK02");

var $c8MIO = parcelRequire("c8MIO");
var $916291e3e456a050$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
var $916291e3e456a050$export$a89c95c098ac2a58 = Object.freeze({});
function $916291e3e456a050$export$bf638b60ea8b89b7(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $916291e3e456a050$export$4fcd777a40ccf407;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $c8MIO.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, $biK02.default)(node), "."));
            var visitFn = $916291e3e456a050$export$c9c25cca74db6e70(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $916291e3e456a050$export$a89c95c098ac2a58) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $c8MIO.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $916291e3e456a050$export$728beebeea393478(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $916291e3e456a050$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $916291e3e456a050$export$a89c95c098ac2a58) skipping[i] = $916291e3e456a050$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $916291e3e456a050$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $916291e3e456a050$export$a89c95c098ac2a58) skipping[i] = $916291e3e456a050$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function $916291e3e456a050$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});
parcelRegister("biK02", function(module, exports) {

$parcel$export(module.exports, "default", () => $971870e72b5f63d8$export$2e2bcd8739ae039);

var $8Ygpi = parcelRequire("8Ygpi");
function $971870e72b5f63d8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $971870e72b5f63d8$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $971870e72b5f63d8$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $971870e72b5f63d8$var$_typeof(obj);
}
var $971870e72b5f63d8$var$MAX_ARRAY_LENGTH = 10;
var $971870e72b5f63d8$var$MAX_RECURSIVE_DEPTH = 2;
function $971870e72b5f63d8$export$2e2bcd8739ae039(value) {
    return $971870e72b5f63d8$var$formatValue(value, []);
}
function $971870e72b5f63d8$var$formatValue(value, seenValues) {
    switch($971870e72b5f63d8$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $971870e72b5f63d8$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $971870e72b5f63d8$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $971870e72b5f63d8$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $971870e72b5f63d8$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $971870e72b5f63d8$var$formatArray(value, seenValues);
    return $971870e72b5f63d8$var$formatObject(value, seenValues);
}
function $971870e72b5f63d8$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $971870e72b5f63d8$var$MAX_RECURSIVE_DEPTH) return '[' + $971870e72b5f63d8$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $971870e72b5f63d8$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $971870e72b5f63d8$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $971870e72b5f63d8$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($971870e72b5f63d8$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($971870e72b5f63d8$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $971870e72b5f63d8$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $8Ygpi.default))];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $971870e72b5f63d8$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});
parcelRegister("8Ygpi", function(module, exports) {

$parcel$export(module.exports, "default", () => $02e19fa1ae734114$export$2e2bcd8739ae039);
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $02e19fa1ae734114$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $02e19fa1ae734114$export$2e2bcd8739ae039 = $02e19fa1ae734114$var$nodejsCustomInspectSymbol;

});


parcelRegister("c8MIO", function(module, exports) {

$parcel$export(module.exports, "Location", () => $e2c0ca6f27c1fab3$export$18a2be9195644f38);
$parcel$export(module.exports, "Token", () => $e2c0ca6f27c1fab3$export$50792b0e93539fde);
$parcel$export(module.exports, "isNode", () => $e2c0ca6f27c1fab3$export$8ee0fc9ee280b4ee);

var $51GHS = parcelRequire("51GHS");
var $e2c0ca6f27c1fab3$export$18a2be9195644f38 = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($e2c0ca6f27c1fab3$export$18a2be9195644f38);
var $e2c0ca6f27c1fab3$export$50792b0e93539fde = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($e2c0ca6f27c1fab3$export$50792b0e93539fde);
function $e2c0ca6f27c1fab3$export$8ee0fc9ee280b4ee(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === 'string';
} /**
 * The list of all possible AST node types.
 */ 

});
parcelRegister("51GHS", function(module, exports) {

$parcel$export(module.exports, "default", () => $01e114d2d62ce6bf$export$2e2bcd8739ae039);

var $43MJl = parcelRequire("43MJl");

var $8Ygpi = parcelRequire("8Ygpi");
function $01e114d2d62ce6bf$export$2e2bcd8739ae039(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === 'function' || (0, $43MJl.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, $8Ygpi.default) classObject.prototype[0, $8Ygpi.default] = fn;
}

});
parcelRegister("43MJl", function(module, exports) {

$parcel$export(module.exports, "default", () => $56486ec4c154c5f8$export$2e2bcd8739ae039);
function $56486ec4c154c5f8$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}

});




parcelRegister("cGs0N", function(module, exports) {
'use strict';
module.exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === 'boolean' ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for(i = 0; i < node.length; i++){
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }
        if (node === null) return 'null';
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    }(data);
};

});

parcelRegister("66hGB", function(module, exports) {

$parcel$export(module.exports, "equal", () => $471105b2f2fd38f1$export$411ce8e5a71e3069);
var $471105b2f2fd38f1$var$_a = Object.prototype, $471105b2f2fd38f1$var$toString = $471105b2f2fd38f1$var$_a.toString, $471105b2f2fd38f1$var$hasOwnProperty = $471105b2f2fd38f1$var$_a.hasOwnProperty;
var $471105b2f2fd38f1$var$previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function $471105b2f2fd38f1$export$411ce8e5a71e3069(a, b) {
    try {
        return $471105b2f2fd38f1$var$check(a, b);
    } finally{
        $471105b2f2fd38f1$var$previousComparisons.clear();
    }
}
function $471105b2f2fd38f1$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = $471105b2f2fd38f1$var$toString.call(a);
    var bTag = $471105b2f2fd38f1$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            if ($471105b2f2fd38f1$var$previouslyCompared(a, b)) return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!$471105b2f2fd38f1$var$hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!$471105b2f2fd38f1$var$check(a[key], b[key])) return false;
            }
            return true;
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]':
            if (a.size !== b.size) return false;
            if ($471105b2f2fd38f1$var$previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !$471105b2f2fd38f1$var$check(aValue, b.get(aKey))) return false;
            }
            return true;
    }
    // Otherwise the values are not equal.
    return false;
}
function $471105b2f2fd38f1$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = $471105b2f2fd38f1$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $471105b2f2fd38f1$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}
var $471105b2f2fd38f1$export$2e2bcd8739ae039 = $471105b2f2fd38f1$export$411ce8e5a71e3069;

});



parcelRegister("7xYai", function(module, exports) {

$parcel$export(module.exports, "KeyTrie", () => $57ea48f9f955816f$export$6bd8d8299be3ac82);
$parcel$export(module.exports, "wrap", () => $57ea48f9f955816f$export$4997ffc0176396a6);

var $182fv = parcelRequire("182fv");
function $57ea48f9f955816f$var$defaultDispose() {}
var $57ea48f9f955816f$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $57ea48f9f955816f$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $57ea48f9f955816f$var$parentEntrySlot = new (0, $182fv.Slot)();
var $57ea48f9f955816f$var$reusableEmptyArray = [];
var $57ea48f9f955816f$var$emptySetPool = [];
var $57ea48f9f955816f$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $57ea48f9f955816f$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $57ea48f9f955816f$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $57ea48f9f955816f$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $57ea48f9f955816f$var$valueCopy(value) {
    return value.slice(0);
}
var $57ea48f9f955816f$var$Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        $57ea48f9f955816f$var$assert(!this.recomputing, "already recomputing");
        if (!$57ea48f9f955816f$var$rememberParent(this) && $57ea48f9f955816f$var$maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return $57ea48f9f955816f$var$mightBeDirty(this) ? $57ea48f9f955816f$var$reallyRecompute(this) : $57ea48f9f955816f$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $57ea48f9f955816f$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $57ea48f9f955816f$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $57ea48f9f955816f$var$forgetChildren(this).forEach($57ea48f9f955816f$var$maybeReportOrphan);
        $57ea48f9f955816f$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $57ea48f9f955816f$var$forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function $57ea48f9f955816f$var$rememberParent(child) {
    var parent = $57ea48f9f955816f$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($57ea48f9f955816f$var$mightBeDirty(child)) $57ea48f9f955816f$var$reportDirtyChild(parent, child);
        else $57ea48f9f955816f$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $57ea48f9f955816f$var$reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = $57ea48f9f955816f$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $57ea48f9f955816f$var$parentEntrySlot.withValue(entry, $57ea48f9f955816f$var$recomputeNewValue, [
        entry
    ]);
    if ($57ea48f9f955816f$var$maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $57ea48f9f955816f$var$setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach($57ea48f9f955816f$var$maybeReportOrphan);
    return $57ea48f9f955816f$var$valueGet(entry.value);
}
function $57ea48f9f955816f$var$recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $57ea48f9f955816f$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $57ea48f9f955816f$var$setClean(entry) {
    entry.dirty = false;
    if ($57ea48f9f955816f$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $57ea48f9f955816f$var$reportClean(entry);
}
function $57ea48f9f955816f$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $57ea48f9f955816f$var$reportDirtyChild(parent, child);
    });
}
function $57ea48f9f955816f$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $57ea48f9f955816f$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $57ea48f9f955816f$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $57ea48f9f955816f$var$assert(parent.childValues.has(child));
    $57ea48f9f955816f$var$assert($57ea48f9f955816f$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $57ea48f9f955816f$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $57ea48f9f955816f$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $57ea48f9f955816f$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $57ea48f9f955816f$var$assert(parent.childValues.has(child));
    $57ea48f9f955816f$var$assert(!$57ea48f9f955816f$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $57ea48f9f955816f$var$valueCopy(child.value));
    else if (!$57ea48f9f955816f$var$valueIs(childValue, child.value)) parent.setDirty();
    $57ea48f9f955816f$var$removeDirtyChild(parent, child);
    if ($57ea48f9f955816f$var$mightBeDirty(parent)) return;
    $57ea48f9f955816f$var$reportClean(parent);
}
function $57ea48f9f955816f$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($57ea48f9f955816f$var$emptySetPool.length < $57ea48f9f955816f$var$POOL_TARGET_SIZE) $57ea48f9f955816f$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function $57ea48f9f955816f$var$maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function $57ea48f9f955816f$var$forgetChildren(parent) {
    var children = $57ea48f9f955816f$var$reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            $57ea48f9f955816f$var$forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $57ea48f9f955816f$var$assert(parent.dirtyChildren === null);
    return children;
}
function $57ea48f9f955816f$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $57ea48f9f955816f$var$removeDirtyChild(parent, child);
}
function $57ea48f9f955816f$var$maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        $57ea48f9f955816f$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $57ea48f9f955816f$var$maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $57ea48f9f955816f$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $57ea48f9f955816f$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function $57ea48f9f955816f$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $57ea48f9f955816f$var$keyTrie = new $57ea48f9f955816f$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $57ea48f9f955816f$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $57ea48f9f955816f$var$keyTrie.lookupArray(args);
}
var $57ea48f9f955816f$var$caches = new Set();
function $57ea48f9f955816f$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $57ea48f9f955816f$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || $57ea48f9f955816f$export$cd3144f8dd136006;
    function optimistic() {
        if (disposable && !$57ea48f9f955816f$var$parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new $57ea48f9f955816f$var$Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $57ea48f9f955816f$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$57ea48f9f955816f$var$parentEntrySlot.hasValue()) {
            $57ea48f9f955816f$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $57ea48f9f955816f$var$caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}

});
parcelRegister("182fv", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $0d28486785009faf$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $0d28486785009faf$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $0d28486785009faf$var$MISSING_VALUE = {};
var $0d28486785009faf$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $0d28486785009faf$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $0d28486785009faf$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $0d28486785009faf$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $0d28486785009faf$var$MISSING_VALUE) break;
                if (context_1 !== $0d28486785009faf$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $0d28486785009faf$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($0d28486785009faf$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $0d28486785009faf$var$currentContext.slots[this.id] = $0d28486785009faf$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $0d28486785009faf$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $0d28486785009faf$var$currentContext;
            $0d28486785009faf$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $0d28486785009faf$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $0d28486785009faf$var$currentContext;
            return function() {
                var saved = $0d28486785009faf$var$currentContext;
                try {
                    $0d28486785009faf$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $0d28486785009faf$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($0d28486785009faf$var$currentContext) {
                var saved = $0d28486785009faf$var$currentContext;
                try {
                    $0d28486785009faf$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $0d28486785009faf$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $0d28486785009faf$var$globalKey = "@wry/context:Slot";
var $0d28486785009faf$var$host = Array;
var $0d28486785009faf$export$8c6ed5c666ac1360 = $0d28486785009faf$var$host[$0d28486785009faf$var$globalKey] || function() {
    var Slot = $0d28486785009faf$var$makeSlotClass();
    try {
        Object.defineProperty($0d28486785009faf$var$host, $0d28486785009faf$var$globalKey, {
            value: $0d28486785009faf$var$host[$0d28486785009faf$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $0d28486785009faf$export$2385a24977818dd0 = $0d28486785009faf$export$8c6ed5c666ac1360.bind, $0d28486785009faf$export$9fa6f2e300a97f8 = $0d28486785009faf$export$8c6ed5c666ac1360.noContext;
function $0d28486785009faf$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($0d28486785009faf$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $0d28486785009faf$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $0d28486785009faf$export$2385a24977818dd0(gen.next);
        var boundThrow = $0d28486785009faf$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($0d28486785009faf$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $0d28486785009faf$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $0d28486785009faf$var$wrappedFibers = [];
function $0d28486785009faf$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($0d28486785009faf$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $0d28486785009faf$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $0d28486785009faf$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});



parcelRegister("jlBDe", function(module, exports) {

$parcel$export(module.exports, "NetworkStatus", () => $03a288f5350d9e9d$export$bd096ddbd246c79c);
$parcel$export(module.exports, "ApolloError", () => $03a288f5350d9e9d$export$26a337512320b8c6);
$parcel$export(module.exports, "ApolloClient", () => $03a288f5350d9e9d$export$13f5a5f0f1dbab88);
$parcel$export(module.exports, "default", () => $03a288f5350d9e9d$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $42BH7 = parcelRequire("42BH7");
var $66hGB = parcelRequire("66hGB");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");

var $6XJYy = parcelRequire("6XJYy");

var $8j2fP = parcelRequire("8j2fP");

var $961BR = parcelRequire("961BR");
var $03a288f5350d9e9d$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($03a288f5350d9e9d$export$bd096ddbd246c79c || ($03a288f5350d9e9d$export$bd096ddbd246c79c = {}));
function $03a288f5350d9e9d$var$isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}
var $03a288f5350d9e9d$var$Observable = function(_super) {
    (0, $fKE23.__extends)(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[0, $6XJYy.default] = function() {
        return this;
    };
    Observable.prototype['@@observable'] = function() {
        return this;
    };
    return Observable;
}((0, $5ECju.default));
function $03a288f5350d9e9d$var$isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
function $03a288f5350d9e9d$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var $03a288f5350d9e9d$var$generateErrorMessage = function(err) {
    var message = '';
    if ($03a288f5350d9e9d$var$isNonEmptyArray(err.graphQLErrors)) err.graphQLErrors.forEach(function(graphQLError) {
        var errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += "GraphQL error: " + errorMessage + "\n";
    });
    if (err.networkError) message += 'Network error: ' + err.networkError.message + '\n';
    message = message.replace(/\n$/, '');
    return message;
};
var $03a288f5350d9e9d$export$26a337512320b8c6 = function(_super) {
    (0, $fKE23.__extends)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) _this.message = $03a288f5350d9e9d$var$generateErrorMessage(_this);
        else _this.message = errorMessage;
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);
var $03a288f5350d9e9d$export$160bafb6ac1e0641;
(function(FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})($03a288f5350d9e9d$export$160bafb6ac1e0641 || ($03a288f5350d9e9d$export$160bafb6ac1e0641 = {}));
var $03a288f5350d9e9d$var$hasError = function(storeValue, policy) {
    if (policy === void 0) policy = 'none';
    return storeValue && (storeValue.networkError || policy === 'none' && $03a288f5350d9e9d$var$isNonEmptyArray(storeValue.graphQLErrors));
};
var $03a288f5350d9e9d$export$6c1b56eac59c9584 = function(_super) {
    (0, $fKE23.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function(observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.isTornDown = false;
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        var opDef = (0, $42BH7.getOperationDefinition)(options.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        _this.queryManager = queryManager;
        return _this;
    }
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var observer = {
                next: function(result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.currentResult = function() {
        var result = this.getCurrentResult();
        if (result.data === undefined) result.data = {};
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function() {
        if (this.isTornDown) {
            var lastResult = this.lastResult;
            return {
                data: !this.lastError && lastResult && lastResult.data || void 0,
                error: this.lastError,
                loading: false,
                networkStatus: $03a288f5350d9e9d$export$bd096ddbd246c79c.error
            };
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        var result;
        var fetchPolicy = this.options.fetchPolicy;
        var isNetworkFetchPolicy = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
        if (queryStoreValue) {
            var networkStatus = queryStoreValue.networkStatus;
            if ($03a288f5350d9e9d$var$hasError(queryStoreValue, this.options.errorPolicy)) return {
                data: void 0,
                loading: false,
                networkStatus: networkStatus,
                error: new $03a288f5350d9e9d$export$26a337512320b8c6({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError
                })
            };
            if (queryStoreValue.variables) {
                this.options.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options.variables), queryStoreValue.variables);
                this.variables = this.options.variables;
            }
            result = {
                data: data,
                loading: $03a288f5350d9e9d$var$isNetworkRequestInFlight(networkStatus),
                networkStatus: networkStatus
            };
            if (queryStoreValue.graphQLErrors && this.options.errorPolicy === 'all') result.errors = queryStoreValue.graphQLErrors;
        } else {
            var loading = isNetworkFetchPolicy || partial && fetchPolicy !== 'cache-only';
            result = {
                data: data,
                loading: loading,
                networkStatus: loading ? $03a288f5350d9e9d$export$bd096ddbd246c79c.loading : $03a288f5350d9e9d$export$bd096ddbd246c79c.ready
            };
        }
        if (!partial) this.updateLastResult((0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
            stale: false
        }));
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
            partial: partial
        });
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult) {
        var snapshot = this.lastResultSnapshot;
        return !(snapshot && newResult && snapshot.networkStatus === newResult.networkStatus && snapshot.stale === newResult.stale && (0, $66hGB.equal)(snapshot.data, newResult.data));
    };
    ObservableQuery.prototype.getLastResult = function() {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function() {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        var queryStore = this.queryManager.queryStore.get(this.queryId);
        if (queryStore) {
            queryStore.networkError = null;
            queryStore.graphQLErrors = [];
        }
    };
    ObservableQuery.prototype.refetch = function(variables) {
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-only') return Promise.reject(new (0, $8j2fP.InvariantError)(1));
        if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'cache-and-network') fetchPolicy = 'network-only';
        if (!(0, $66hGB.equal)(this.variables, variables)) this.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.variables), variables);
        if (!(0, $66hGB.equal)(this.options.variables, this.variables)) this.options.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options.variables), this.variables);
        return this.queryManager.fetchQuery(this.queryId, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options), {
            fetchPolicy: fetchPolicy
        }), $03a288f5350d9e9d$export$160bafb6ac1e0641.refetch);
    };
    ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        (0, $8j2fP.invariant)(fetchMoreOptions.updateQuery, 2);
        var combinedOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $fKE23.__assign)((0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options), fetchMoreOptions), {
            variables: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.variables), fetchMoreOptions.variables)
        })), {
            fetchPolicy: 'network-only'
        });
        var qid = this.queryManager.generateQueryId();
        return this.queryManager.fetchQuery(qid, combinedOptions, $03a288f5350d9e9d$export$160bafb6ac1e0641.normal, this.queryId).then(function(fetchMoreResult) {
            _this.updateQuery(function(previousResult) {
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables
                });
            });
            _this.queryManager.stopQuery(qid);
            return fetchMoreResult;
        }, function(error) {
            _this.queryManager.stopQuery(qid);
            throw error;
        });
    };
    ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(opts) {
        var oldFetchPolicy = this.options.fetchPolicy;
        this.options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options), opts);
        if (opts.pollInterval) this.startPolling(opts.pollInterval);
        else if (opts.pollInterval === 0) this.stopPolling();
        var fetchPolicy = opts.fetchPolicy;
        return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === 'cache-only' || oldFetchPolicy === 'standby' || fetchPolicy === 'network-only'), opts.fetchResults);
    };
    ObservableQuery.prototype.setVariables = function(variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) tryFetch = false;
        if (fetchResults === void 0) fetchResults = true;
        this.isTornDown = false;
        variables = variables || this.variables;
        if (!tryFetch && (0, $66hGB.equal)(variables, this.variables)) return this.observers.size && fetchResults ? this.result() : Promise.resolve();
        this.variables = this.options.variables = variables;
        if (!this.observers.size) return Promise.resolve();
        return this.queryManager.fetchQuery(this.queryId, this.options);
    };
    ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var _a = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = (0, $42BH7.tryFunctionOrLogError)(function() {
            return mapFn(previousResult, {
                variables: variables
            });
        });
        if (newResult) {
            queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function() {
        this.queryManager.stopPollingQuery(this.queryId);
        this.options.pollInterval = undefined;
    };
    ObservableQuery.prototype.startPolling = function(pollInterval) {
        $03a288f5350d9e9d$var$assertNotCacheFirstOrOnly(this);
        this.options.pollInterval = pollInterval;
        this.queryManager.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.updateLastResult = function(newResult) {
        var previousResult = this.lastResult;
        this.lastResult = newResult;
        this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? newResult : (0, $42BH7.cloneDeep)(newResult);
        return previousResult;
    };
    ObservableQuery.prototype.onSubscribe = function(observer) {
        var _this = this;
        try {
            var subObserver = observer._subscription._observer;
            if (subObserver && !subObserver.error) subObserver.error = $03a288f5350d9e9d$var$defaultSubscriptionObserverErrorCallback;
        } catch (_a) {}
        var first = !this.observers.size;
        this.observers.add(observer);
        if (observer.next && this.lastResult) observer.next(this.lastResult);
        if (observer.error && this.lastError) observer.error(this.lastError);
        if (first) this.setUpQuery();
        return function() {
            if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
        };
    };
    ObservableQuery.prototype.setUpQuery = function() {
        var _this = this;
        var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
        if (this.shouldSubscribe) queryManager.addObservableQuery(queryId, this);
        if (this.options.pollInterval) {
            $03a288f5350d9e9d$var$assertNotCacheFirstOrOnly(this);
            queryManager.startPollingQuery(this.options, queryId);
        }
        var onError = function(error) {
            _this.updateLastResult((0, $fKE23.__assign)((0, $fKE23.__assign)({}, _this.lastResult), {
                errors: error.graphQLErrors,
                networkStatus: $03a288f5350d9e9d$export$bd096ddbd246c79c.error,
                loading: false
            }));
            $03a288f5350d9e9d$var$iterateObserversSafely(_this.observers, 'error', _this.lastError = error);
        };
        queryManager.observeQuery(queryId, this.options, {
            next: function(result) {
                if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                    var previousResult_1 = _this.updateLastResult(result);
                    var _a = _this.options, query_1 = _a.query, variables = _a.variables, fetchPolicy_1 = _a.fetchPolicy;
                    if (queryManager.transform(query_1).hasClientExports) queryManager.getLocalState().addExportedVariables(query_1, variables).then(function(variables) {
                        var previousVariables = _this.variables;
                        _this.variables = _this.options.variables = variables;
                        if (!result.loading && previousResult_1 && fetchPolicy_1 !== 'cache-only' && queryManager.transform(query_1).serverQuery && !(0, $66hGB.equal)(previousVariables, variables)) _this.refetch();
                        else $03a288f5350d9e9d$var$iterateObserversSafely(_this.observers, 'next', result);
                    });
                    else $03a288f5350d9e9d$var$iterateObserversSafely(_this.observers, 'next', result);
                }
            },
            error: onError
        }).catch(onError);
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        var queryManager = this.queryManager;
        this.isTornDown = true;
        queryManager.stopPollingQuery(this.queryId);
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        queryManager.removeObservableQuery(this.queryId);
        queryManager.stopQuery(this.queryId);
        this.observers.clear();
    };
    return ObservableQuery;
}($03a288f5350d9e9d$var$Observable);
function $03a288f5350d9e9d$var$defaultSubscriptionObserverErrorCallback(error) {}
function $03a288f5350d9e9d$var$iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}
function $03a288f5350d9e9d$var$assertNotCacheFirstOrOnly(obsQuery) {
    var fetchPolicy = obsQuery.options.fetchPolicy;
    (0, $8j2fP.invariant)(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 3);
}
var $03a288f5350d9e9d$var$MutationStore = function() {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function() {
        return this.store;
    };
    MutationStore.prototype.get = function(mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function(mutationId, mutation, variables) {
        this.store[mutationId] = {
            mutation: mutation,
            variables: variables || {},
            loading: true,
            error: null
        };
    };
    MutationStore.prototype.markMutationError = function(mutationId, error) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = error;
        }
    };
    MutationStore.prototype.markMutationResult = function(mutationId) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = null;
        }
    };
    MutationStore.prototype.reset = function() {
        this.store = {};
    };
    return MutationStore;
}();
var $03a288f5350d9e9d$var$QueryStore = function() {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function() {
        return this.store;
    };
    QueryStore.prototype.get = function(queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function(query) {
        var previousQuery = this.store[query.queryId];
        (0, $8j2fP.invariant)(!previousQuery || previousQuery.document === query.document || (0, $66hGB.equal)(previousQuery.document, query.document), 19);
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables && previousQuery && previousQuery.networkStatus !== $03a288f5350d9e9d$export$bd096ddbd246c79c.loading) {
            if (!(0, $66hGB.equal)(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        var networkStatus;
        if (isSetVariables) networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.setVariables;
        else if (query.isPoll) networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.poll;
        else if (query.isRefetch) networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.refetch;
        else networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.loading;
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) graphQLErrors = previousQuery.graphQLErrors;
        this.store[query.queryId] = {
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata
        };
        if (typeof query.fetchMoreForQueryId === 'string' && this.store[query.fetchMoreForQueryId]) this.store[query.fetchMoreForQueryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.fetchMore;
    };
    QueryStore.prototype.markQueryResult = function(queryId, result, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors = $03a288f5350d9e9d$var$isNonEmptyArray(result.errors) ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.ready;
        if (typeof fetchMoreForQueryId === 'string' && this.store[fetchMoreForQueryId]) this.store[fetchMoreForQueryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.ready;
    };
    QueryStore.prototype.markQueryError = function(queryId, error, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.error;
        if (typeof fetchMoreForQueryId === 'string') this.markQueryResultClient(fetchMoreForQueryId, true);
    };
    QueryStore.prototype.markQueryResultClient = function(queryId, complete) {
        var storeValue = this.store && this.store[queryId];
        if (storeValue) {
            storeValue.networkError = null;
            storeValue.previousVariables = null;
            if (complete) storeValue.networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.ready;
        }
    };
    QueryStore.prototype.stopQuery = function(queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function(observableQueryIds) {
        var _this = this;
        Object.keys(this.store).forEach(function(queryId) {
            if (observableQueryIds.indexOf(queryId) < 0) _this.stopQuery(queryId);
            else _this.store[queryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.loading;
        });
    };
    return QueryStore;
}();
function $03a288f5350d9e9d$var$capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
var $03a288f5350d9e9d$var$LocalState = function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $42BH7.mergeDeep)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $42BH7.mergeDeep)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            return (0, $fKE23.__generator)(this, function(_c) {
                if (document) return [
                    2,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $42BH7.hasDirectives)([
            'client'
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function(document) {
        return this.resolvers ? (0, $42BH7.removeClientSetsFromDocument)(document) : document;
    };
    LocalState.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var cache = this.cache;
        var newContext = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
            cache: cache,
            getCacheKey: function(obj) {
                if (cache.config) return cache.config.dataIdFromObject(obj);
                else (0, $8j2fP.invariant)(false, 6);
            }
        });
        return newContext;
    };
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            return (0, $fKE23.__generator)(this, function(_a) {
                if (document) return [
                    2,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2,
                    (0, $fKE23.__assign)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $961BR.visit)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === 'always' && arg.value.kind === 'BooleanValue' && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $961BR.BREAK;
                    }
                }
            }
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $42BH7.buildQueryFromSelectionSet)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return (0, $fKE23.__generator)(this, function(_b) {
                mainDefinition = (0, $42BH7.getMainDefinition)(document);
                fragments = (0, $42BH7.getFragmentDefinitions)(document);
                fragmentMap = (0, $42BH7.createFragmentMap)(fragments);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? $03a288f5350d9e9d$var$capitalizeFirstLetter(definitionOperation) : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                return [
                    2,
                    this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, rootValue, execContext) {
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $fKE23.__generator)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $fKE23.__awaiter)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $fKE23.__generator)(this, function(_a) {
                            if (!(0, $42BH7.shouldInclude)(selection, variables)) return [
                                2
                            ];
                            if ((0, $42BH7.isField)(selection)) return [
                                2,
                                this.resolveField(selection, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') resultsToMerge.push((_a = {}, _a[(0, $42BH7.resultKeyNameFromField)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                            else {
                                fragment = fragmentMap[selection.name.value];
                                (0, $8j2fP.invariant)(fragment, 7);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2,
                                    this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2
                            ];
                        });
                    });
                };
                return [
                    2,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $42BH7.mergeDeepArray)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, rootValue, execContext) {
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $fKE23.__generator)(this, function(_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $42BH7.resultKeyNameFromField)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(resolve(rootValue, (0, $42BH7.argumentsObjectFromField)(field, variables), execContext.context, {
                            field: field,
                            fragmentMap: execContext.fragmentMap
                        }));
                    }
                }
                return [
                    2,
                    resultPromise.then(function(result) {
                        if (result === void 0) result = defaultResult;
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === 'export' && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === 'as' && arg.value.kind === 'StringValue') execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        if (!field.selectionSet) return result;
                        if (result == null) return result;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, result, execContext);
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, item, execContext);
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, item, execContext);
        }));
    };
    return LocalState;
}();
function $03a288f5350d9e9d$var$multiplex(inner) {
    var observers = new Set();
    var sub = null;
    return new $03a288f5350d9e9d$var$Observable(function(observer) {
        observers.add(observer);
        sub = sub || inner.subscribe({
            next: function(value) {
                observers.forEach(function(obs) {
                    return obs.next && obs.next(value);
                });
            },
            error: function(error) {
                observers.forEach(function(obs) {
                    return obs.error && obs.error(error);
                });
            },
            complete: function() {
                observers.forEach(function(obs) {
                    return obs.complete && obs.complete();
                });
            }
        });
        return function() {
            if (observers.delete(observer) && !observers.size && sub) {
                sub.unsubscribe();
                sub = null;
            }
        };
    });
}
function $03a288f5350d9e9d$var$asyncMap(observable, mapFn) {
    return new $03a288f5350d9e9d$var$Observable(function(observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeNextCount = 0;
        var completed = false;
        var handler = {
            next: function(value) {
                ++activeNextCount;
                new Promise(function(resolve) {
                    resolve(mapFn(value));
                }).then(function(result) {
                    --activeNextCount;
                    next && next.call(observer, result);
                    completed && handler.complete();
                }, function(e) {
                    --activeNextCount;
                    error && error.call(observer, e);
                });
            },
            error: function(e) {
                error && error.call(observer, e);
            },
            complete: function() {
                completed = true;
                if (!activeNextCount) complete && complete.call(observer);
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}
var $03a288f5350d9e9d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $03a288f5350d9e9d$var$QueryManager = function() {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function() {
            return undefined;
        } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.mutationStore = new $03a288f5350d9e9d$var$MutationStore();
        this.queryStore = new $03a288f5350d9e9d$var$QueryStore();
        this.clientAwareness = {};
        this.idCounter = 1;
        this.queries = new Map();
        this.fetchQueryRejectFns = new Map();
        this.transformCache = new ((0, $42BH7.canUseWeakMap) ? WeakMap : Map)();
        this.inFlightLinkObservables = new Map();
        this.pollingInfoByQueryId = new Map();
        this.link = link;
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new $03a288f5350d9e9d$var$LocalState({
            cache: store.getCache()
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
    }
    QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $8j2fP.InvariantError)(8));
        });
    };
    QueryManager.prototype.mutate = function(_a) {
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var mutationId, generateUpdateQueriesInfo, self;
            var _this = this;
            return (0, $fKE23.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        (0, $8j2fP.invariant)(mutation, 9);
                        (0, $8j2fP.invariant)(!fetchPolicy || fetchPolicy === 'no-cache', 10);
                        mutationId = this.generateQueryId();
                        mutation = this.transform(mutation).document;
                        this.setQuery(mutationId, function() {
                            return {
                                document: mutation
                            };
                        });
                        variables = this.getVariables(mutation, variables);
                        if (!this.transform(mutation).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _f.sent();
                        _f.label = 2;
                    case 2:
                        generateUpdateQueriesInfo = function() {
                            var ret = {};
                            if (updateQueriesByName) _this.queries.forEach(function(_a, queryId) {
                                var observableQuery = _a.observableQuery;
                                if (observableQuery) {
                                    var queryName = observableQuery.queryName;
                                    if (queryName && $03a288f5350d9e9d$var$hasOwnProperty.call(updateQueriesByName, queryName)) ret[queryId] = {
                                        updater: updateQueriesByName[queryName],
                                        query: _this.queryStore.get(queryId)
                                    };
                                }
                            });
                            return ret;
                        };
                        this.mutationStore.initMutation(mutationId, mutation, variables);
                        this.dataStore.markMutationInit({
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                            optimisticResponse: optimisticResponse
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var storeResult;
                                var error;
                                self.getObservableFromLink(mutation, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
                                    optimisticResponse: optimisticResponse
                                }), variables, false).subscribe({
                                    next: function(result) {
                                        if ((0, $42BH7.graphQLResultHasError)(result) && errorPolicy === 'none') {
                                            error = new $03a288f5350d9e9d$export$26a337512320b8c6({
                                                graphQLErrors: result.errors
                                            });
                                            return;
                                        }
                                        self.mutationStore.markMutationResult(mutationId);
                                        if (fetchPolicy !== 'no-cache') self.dataStore.markMutationResult({
                                            mutationId: mutationId,
                                            result: result,
                                            document: mutation,
                                            variables: variables,
                                            updateQueries: generateUpdateQueriesInfo(),
                                            update: updateWithProxyFn
                                        });
                                        storeResult = result;
                                    },
                                    error: function(err) {
                                        self.mutationStore.markMutationError(mutationId, err);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        self.setQuery(mutationId, function() {
                                            return {
                                                document: null
                                            };
                                        });
                                        reject(new $03a288f5350d9e9d$export$26a337512320b8c6({
                                            networkError: err
                                        }));
                                    },
                                    complete: function() {
                                        if (error) self.mutationStore.markMutationError(mutationId, error);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        if (error) {
                                            reject(error);
                                            return;
                                        }
                                        if (typeof refetchQueries === 'function') refetchQueries = refetchQueries(storeResult);
                                        var refetchQueryPromises = [];
                                        if ($03a288f5350d9e9d$var$isNonEmptyArray(refetchQueries)) refetchQueries.forEach(function(refetchQuery) {
                                            if (typeof refetchQuery === 'string') self.queries.forEach(function(_a) {
                                                var observableQuery = _a.observableQuery;
                                                if (observableQuery && observableQuery.queryName === refetchQuery) refetchQueryPromises.push(observableQuery.refetch());
                                            });
                                            else {
                                                var queryOptions = {
                                                    query: refetchQuery.query,
                                                    variables: refetchQuery.variables,
                                                    fetchPolicy: 'network-only'
                                                };
                                                if (refetchQuery.context) queryOptions.context = refetchQuery.context;
                                                refetchQueryPromises.push(self.query(queryOptions));
                                            }
                                        });
                                        Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function() {
                                            self.setQuery(mutationId, function() {
                                                return {
                                                    document: null
                                                };
                                            });
                                            if (errorPolicy === 'ignore' && storeResult && (0, $42BH7.graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                            resolve(storeResult);
                                        });
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, fetchType, fetchMoreForQueryId) {
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
            var _this = this;
            return (0, $fKE23.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? 'cache-first' : _b, _c = options.context, context = _c === void 0 ? {} : _c;
                        query = this.transform(options.query).document;
                        variables = this.getVariables(query, options.variables);
                        if (!this.transform(query).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(query, variables, context)
                        ];
                    case 1:
                        variables = _e.sent();
                        _e.label = 2;
                    case 2:
                        options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
                            variables: variables
                        });
                        isNetworkOnly = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
                        needToFetch = isNetworkOnly;
                        if (!isNetworkOnly) {
                            _d = this.dataStore.getCache().diff({
                                query: query,
                                variables: variables,
                                returnPartialData: true,
                                optimistic: false
                            }), complete = _d.complete, result = _d.result;
                            needToFetch = !complete || fetchPolicy === 'cache-and-network';
                            storeResult = result;
                        }
                        shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
                        if ((0, $42BH7.hasDirectives)([
                            'live'
                        ], query)) shouldFetch = true;
                        requestId = this.idCounter++;
                        cancel = fetchPolicy !== 'no-cache' ? this.updateQueryWatch(queryId, query, options) : undefined;
                        this.setQuery(queryId, function() {
                            return {
                                document: query,
                                lastRequestId: requestId,
                                invalidated: true,
                                cancel: cancel
                            };
                        });
                        this.invalidate(fetchMoreForQueryId);
                        this.queryStore.initQuery({
                            queryId: queryId,
                            document: query,
                            storePreviousVariables: shouldFetch,
                            variables: variables,
                            isPoll: fetchType === $03a288f5350d9e9d$export$160bafb6ac1e0641.poll,
                            isRefetch: fetchType === $03a288f5350d9e9d$export$160bafb6ac1e0641.refetch,
                            metadata: metadata,
                            fetchMoreForQueryId: fetchMoreForQueryId
                        });
                        this.broadcastQueries();
                        if (shouldFetch) {
                            networkResult = this.fetchRequest({
                                requestId: requestId,
                                queryId: queryId,
                                document: query,
                                options: options,
                                fetchMoreForQueryId: fetchMoreForQueryId
                            }).catch(function(error) {
                                if ($03a288f5350d9e9d$export$17f5e6bd290bb15d(error)) throw error;
                                else {
                                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
                                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                        _this.invalidate(queryId);
                                        _this.invalidate(fetchMoreForQueryId);
                                        _this.broadcastQueries();
                                    }
                                    throw new $03a288f5350d9e9d$export$26a337512320b8c6({
                                        networkError: error
                                    });
                                }
                            });
                            if (fetchPolicy !== 'cache-and-network') return [
                                2,
                                networkResult
                            ];
                            networkResult.catch(function() {});
                        }
                        this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                        this.invalidate(queryId);
                        this.invalidate(fetchMoreForQueryId);
                        if (this.transform(query).hasForcedResolvers) return [
                            2,
                            this.localState.runResolvers({
                                document: query,
                                remoteResult: {
                                    data: storeResult
                                },
                                context: context,
                                variables: variables,
                                onlyRunForcedResolvers: true
                            }).then(function(result) {
                                _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                                _this.broadcastQueries();
                                return result;
                            })
                        ];
                        this.broadcastQueries();
                        return [
                            2,
                            {
                                data: storeResult
                            }
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markQueryResult = function(queryId, result, _a, fetchMoreForQueryId) {
        var fetchPolicy = _a.fetchPolicy, variables = _a.variables, errorPolicy = _a.errorPolicy;
        if (fetchPolicy === 'no-cache') this.setQuery(queryId, function() {
            return {
                newData: {
                    result: result.data,
                    complete: true
                }
            };
        });
        else this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
    };
    QueryManager.prototype.queryListenerForObserver = function(queryId, options, observer) {
        var _this = this;
        function invoke(method, argument) {
            if (observer[method]) try {
                observer[method](argument);
            } catch (e) {}
            else method;
        }
        return function(queryStoreValue, newData) {
            _this.invalidate(queryId, false);
            if (!queryStoreValue) return;
            var _a = _this.getQuery(queryId), observableQuery = _a.observableQuery, document = _a.document;
            var fetchPolicy = observableQuery ? observableQuery.options.fetchPolicy : options.fetchPolicy;
            if (fetchPolicy === 'standby') return;
            var loading = $03a288f5350d9e9d$var$isNetworkRequestInFlight(queryStoreValue.networkStatus);
            var lastResult = observableQuery && observableQuery.getLastResult();
            var networkStatusChanged = !!(lastResult && lastResult.networkStatus !== queryStoreValue.networkStatus);
            var shouldNotifyIfLoading = options.returnPartialData || !newData && queryStoreValue.previousVariables || networkStatusChanged && options.notifyOnNetworkStatusChange || fetchPolicy === 'cache-only' || fetchPolicy === 'cache-and-network';
            if (loading && !shouldNotifyIfLoading) return;
            var hasGraphQLErrors = $03a288f5350d9e9d$var$isNonEmptyArray(queryStoreValue.graphQLErrors);
            var errorPolicy = observableQuery && observableQuery.options.errorPolicy || options.errorPolicy || 'none';
            if (errorPolicy === 'none' && hasGraphQLErrors || queryStoreValue.networkError) return invoke('error', new $03a288f5350d9e9d$export$26a337512320b8c6({
                graphQLErrors: queryStoreValue.graphQLErrors,
                networkError: queryStoreValue.networkError
            }));
            try {
                var data = void 0;
                var isMissing = void 0;
                if (newData) {
                    if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') _this.setQuery(queryId, function() {
                        return {
                            newData: null
                        };
                    });
                    data = newData.result;
                    isMissing = !newData.complete;
                } else {
                    var lastError = observableQuery && observableQuery.getLastError();
                    var errorStatusChanged = errorPolicy !== 'none' && (lastError && lastError.graphQLErrors) !== queryStoreValue.graphQLErrors;
                    if (lastResult && lastResult.data && !errorStatusChanged) {
                        data = lastResult.data;
                        isMissing = false;
                    } else {
                        var diffResult = _this.dataStore.getCache().diff({
                            query: document,
                            variables: queryStoreValue.previousVariables || queryStoreValue.variables,
                            returnPartialData: true,
                            optimistic: true
                        });
                        data = diffResult.result;
                        isMissing = !diffResult.complete;
                    }
                }
                var stale = isMissing && !(options.returnPartialData || fetchPolicy === 'cache-only');
                var resultFromStore = {
                    data: stale ? lastResult && lastResult.data : data,
                    loading: loading,
                    networkStatus: queryStoreValue.networkStatus,
                    stale: stale
                };
                if (errorPolicy === 'all' && hasGraphQLErrors) resultFromStore.errors = queryStoreValue.graphQLErrors;
                invoke('next', resultFromStore);
            } catch (networkError) {
                invoke('error', new $03a288f5350d9e9d$export$26a337512320b8c6({
                    networkError: networkError
                }));
            }
        };
    };
    QueryManager.prototype.transform = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cache = this.dataStore.getCache();
            var transformed = cache.transformDocument(document);
            var forLink = (0, $42BH7.removeConnectionDirectiveFromDocument)(cache.transformForLink(transformed));
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = this.localState.serverQuery(forLink);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0, $42BH7.hasClientExports)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0, $42BH7.getDefaultValues)((0, $42BH7.getOperationDefinition)(transformed))
            };
            var add = function(doc) {
                if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options, shouldSubscribe) {
        if (shouldSubscribe === void 0) shouldSubscribe = true;
        (0, $8j2fP.invariant)(options.fetchPolicy !== 'standby', 11);
        options.variables = this.getVariables(options.query, options.variables);
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') options.notifyOnNetworkStatusChange = false;
        var transformedOptions = (0, $fKE23.__assign)({}, options);
        return new $03a288f5350d9e9d$export$6c1b56eac59c9584({
            queryManager: this,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe
        });
    };
    QueryManager.prototype.query = function(options) {
        var _this = this;
        (0, $8j2fP.invariant)(options.query, 12);
        (0, $8j2fP.invariant)(options.query.kind === 'Document', 13);
        (0, $8j2fP.invariant)(!options.returnPartialData, 14);
        (0, $8j2fP.invariant)(!options.pollInterval, 15);
        return new Promise(function(resolve, reject) {
            var watchedQuery = _this.watchQuery(options, false);
            _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
            watchedQuery.result().then(resolve, reject).then(function() {
                return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
            });
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.idCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        this.stopPollingQuery(queryId);
        this.queryStore.stopQuery(queryId);
        this.invalidate(queryId);
    };
    QueryManager.prototype.addQueryListener = function(queryId, listener) {
        this.setQuery(queryId, function(_a) {
            var listeners = _a.listeners;
            listeners.add(listener);
            return {
                invalidated: false
            };
        });
    };
    QueryManager.prototype.updateQueryWatch = function(queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel) cancel();
        var previousResult = function() {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) previousResult = lastResult.data;
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function(newData) {
                _this.setQuery(queryId, function() {
                    return {
                        invalidated: true,
                        newData: newData
                    };
                });
            }
        });
    };
    QueryManager.prototype.addObservableQuery = function(queryId, observableQuery) {
        this.setQuery(queryId, function() {
            return {
                observableQuery: observableQuery
            };
        });
    };
    QueryManager.prototype.removeObservableQuery = function(queryId) {
        var cancel = this.getQuery(queryId).cancel;
        this.setQuery(queryId, function() {
            return {
                observableQuery: null
            };
        });
        if (cancel) cancel();
    };
    QueryManager.prototype.clearStore = function() {
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $8j2fP.InvariantError)(16));
        });
        var resetIds = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        return this.dataStore.reset();
    };
    QueryManager.prototype.resetStore = function() {
        var _this = this;
        return this.clearStore().then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) {
                var fetchPolicy = observableQuery.options.fetchPolicy;
                observableQuery.resetLastResults();
                if (fetchPolicy !== 'cache-only' && (includeStandby || fetchPolicy !== 'standby')) observableQueryPromises.push(observableQuery.refetch());
                _this.setQuery(queryId, function() {
                    return {
                        newData: null
                    };
                });
                _this.invalidate(queryId);
            }
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.observeQuery = function(queryId, options, observer) {
        this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
        return this.fetchQuery(queryId, options);
    };
    QueryManager.prototype.startQuery = function(queryId, options, listener) {
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options).catch(function() {
            return undefined;
        });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, variables = _a.variables;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, {}, variables, false).map(function(result) {
                if (!fetchPolicy || fetchPolicy !== 'no-cache') {
                    _this.dataStore.markSubscriptionResult(result, query, variables);
                    _this.broadcastQueries();
                }
                if ((0, $42BH7.graphQLResultHasError)(result)) throw new $03a288f5350d9e9d$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                });
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
            return new $03a288f5350d9e9d$var$Observable(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        this.fetchQueryRejectFns.delete("query:" + queryId);
        this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
        this.getQuery(queryId).subscriptions.forEach(function(x) {
            return x.unsubscribe();
        });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function(observableQuery, optimistic) {
        if (optimistic === void 0) optimistic = true;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy, returnPartialData = _a.returnPartialData;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        if (newData && newData.complete) return {
            data: newData.result,
            partial: false
        };
        if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') return {
            data: undefined,
            partial: false
        };
        var _b = this.dataStore.getCache().diff({
            query: query,
            variables: variables,
            previousResult: lastResult ? lastResult.data : undefined,
            returnPartialData: true,
            optimistic: optimistic
        }), result = _b.result, complete = _b.complete;
        return {
            data: complete || returnPartialData ? result : void 0,
            partial: !complete
        };
    };
    QueryManager.prototype.getQueryWithPreviousResult = function(queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === 'string') {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
            (0, $8j2fP.invariant)(foundObserveableQuery, 17);
            observableQuery = foundObserveableQuery;
        } else observableQuery = queryIdOrObservable;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        return {
            previousResult: this.getCurrentQueryResult(observableQuery, false).data,
            variables: variables,
            document: query
        };
    };
    QueryManager.prototype.broadcastQueries = function() {
        var _this = this;
        this.onBroadcast();
        this.queries.forEach(function(info, id) {
            if (info.invalidated) info.listeners.forEach(function(listener) {
                if (listener) listener(_this.queryStore.get(id), info.newData);
            });
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
        var _this = this;
        if (deduplication === void 0) deduplication = this.queryDeduplication;
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _a = this, inFlightLinkObservables_1 = _a.inFlightLinkObservables, link = _a.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $42BH7.getOperationName)(serverQuery) || void 0,
                context: this.prepareContext((0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = JSON.stringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    byVariables_1.set(varJson_1, observable = $03a288f5350d9e9d$var$multiplex((0, $bvQX6.execute)(link, operation)));
                    var cleanup = function() {
                        byVariables_1.delete(varJson_1);
                        if (!byVariables_1.size) inFlightLinkObservables_1.delete(serverQuery);
                        cleanupSub_1.unsubscribe();
                    };
                    var cleanupSub_1 = observable.subscribe({
                        next: cleanup,
                        error: cleanup,
                        complete: cleanup
                    });
                }
            } else observable = $03a288f5350d9e9d$var$multiplex((0, $bvQX6.execute)(link, operation));
        } else {
            observable = $03a288f5350d9e9d$var$Observable.of({
                data: {}
            });
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) observable = $03a288f5350d9e9d$var$asyncMap(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.fetchRequest = function(_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
        var resultFromStore;
        var errorsFromStore;
        return new Promise(function(resolve, reject) {
            var observable = _this.getObservableFromLink(document, options.context, variables);
            var fqrfId = "fetchRequest:" + queryId;
            _this.fetchQueryRejectFns.set(fqrfId, reject);
            var cleanup = function() {
                _this.fetchQueryRejectFns.delete(fqrfId);
                _this.setQuery(queryId, function(_a) {
                    var subscriptions = _a.subscriptions;
                    subscriptions.delete(subscription);
                });
            };
            var subscription = observable.map(function(result) {
                if (requestId >= _this.getQuery(queryId).lastRequestId) {
                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                    _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                    _this.invalidate(queryId);
                    _this.invalidate(fetchMoreForQueryId);
                    _this.broadcastQueries();
                }
                if (errorPolicy === 'none' && $03a288f5350d9e9d$var$isNonEmptyArray(result.errors)) return reject(new $03a288f5350d9e9d$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                }));
                if (errorPolicy === 'all') errorsFromStore = result.errors;
                if (fetchMoreForQueryId || fetchPolicy === 'no-cache') resultFromStore = result.data;
                else {
                    var _a = _this.dataStore.getCache().diff({
                        variables: variables,
                        query: document,
                        optimistic: false,
                        returnPartialData: true
                    }), result_1 = _a.result, complete = _a.complete;
                    if (complete || options.returnPartialData) resultFromStore = result_1;
                }
            }).subscribe({
                error: function(error) {
                    cleanup();
                    reject(error);
                },
                complete: function() {
                    cleanup();
                    resolve({
                        data: resultFromStore,
                        errors: errorsFromStore,
                        loading: false,
                        networkStatus: $03a288f5350d9e9d$export$bd096ddbd246c79c.ready,
                        stale: false
                    });
                }
            });
            _this.setQuery(queryId, function(_a) {
                var subscriptions = _a.subscriptions;
                subscriptions.add(subscription);
            });
        });
    };
    QueryManager.prototype.getQuery = function(queryId) {
        return this.queries.get(queryId) || {
            listeners: new Set(),
            invalidated: false,
            document: null,
            newData: null,
            lastRequestId: 1,
            observableQuery: null,
            subscriptions: new Set()
        };
    };
    QueryManager.prototype.setQuery = function(queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, prev), updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function(queryId, invalidated) {
        if (invalidated === void 0) invalidated = true;
        if (queryId) this.setQuery(queryId, function() {
            return {
                invalidated: invalidated
            };
        });
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    QueryManager.prototype.checkInFlight = function(queryId) {
        var query = this.queryStore.get(queryId);
        return query && query.networkStatus !== $03a288f5350d9e9d$export$bd096ddbd246c79c.ready && query.networkStatus !== $03a288f5350d9e9d$export$bd096ddbd246c79c.error;
    };
    QueryManager.prototype.startPollingQuery = function(options, queryId, listener) {
        var _this = this;
        var pollInterval = options.pollInterval;
        (0, $8j2fP.invariant)(pollInterval, 18);
        if (!this.ssrMode) {
            var info = this.pollingInfoByQueryId.get(queryId);
            if (!info) this.pollingInfoByQueryId.set(queryId, info = {});
            info.interval = pollInterval;
            info.options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
                fetchPolicy: 'network-only'
            });
            var maybeFetch_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    if (_this.checkInFlight(queryId)) poll_1();
                    else _this.fetchQuery(queryId, info.options, $03a288f5350d9e9d$export$160bafb6ac1e0641.poll).then(poll_1, poll_1);
                }
            };
            var poll_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    clearTimeout(info.timeout);
                    info.timeout = setTimeout(maybeFetch_1, info.interval);
                }
            };
            if (listener) this.addQueryListener(queryId, listener);
            poll_1();
        }
        return queryId;
    };
    QueryManager.prototype.stopPollingQuery = function(queryId) {
        this.pollingInfoByQueryId.delete(queryId);
    };
    return QueryManager;
}();
var $03a288f5350d9e9d$var$DataStore = function() {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function() {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function(result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) ignoreErrors = false;
        var writeWithErrors = !(0, $42BH7.graphQLResultHasError)(result);
        if (ignoreErrors && (0, $42BH7.graphQLResultHasError)(result) && result.data) writeWithErrors = true;
        if (!fetchMoreForQueryId && writeWithErrors) this.cache.write({
            result: result.data,
            dataId: 'ROOT_QUERY',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markSubscriptionResult = function(result, document, variables) {
        if (!(0, $42BH7.graphQLResultHasError)(result)) this.cache.write({
            result: result.data,
            dataId: 'ROOT_SUBSCRIPTION',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markMutationInit = function(mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === 'function') optimistic_1 = mutation.optimisticResponse(mutation.variables);
            else optimistic_1 = mutation.optimisticResponse;
            this.cache.recordOptimisticTransaction(function(c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    _this.markMutationResult({
                        mutationId: mutation.mutationId,
                        result: {
                            data: optimistic_1
                        },
                        document: mutation.document,
                        variables: mutation.variables,
                        updateQueries: mutation.updateQueries,
                        update: mutation.update
                    });
                } finally{
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function(mutation) {
        var _this = this;
        if (!(0, $42BH7.graphQLResultHasError)(mutation.result)) {
            var cacheWrites_1 = [
                {
                    result: mutation.result.data,
                    dataId: 'ROOT_MUTATION',
                    query: mutation.document,
                    variables: mutation.variables
                }
            ];
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) Object.keys(updateQueries_1).forEach(function(id) {
                var _a = updateQueries_1[id], query = _a.query, updater = _a.updater;
                var _b = _this.cache.diff({
                    query: query.document,
                    variables: query.variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _b.result, complete = _b.complete;
                if (complete) {
                    var nextQueryResult = (0, $42BH7.tryFunctionOrLogError)(function() {
                        return updater(currentQueryResult, {
                            mutationResult: mutation.result,
                            queryName: (0, $42BH7.getOperationName)(query.document) || undefined,
                            queryVariables: query.variables
                        });
                    });
                    if (nextQueryResult) cacheWrites_1.push({
                        result: nextQueryResult,
                        dataId: 'ROOT_QUERY',
                        query: query.document,
                        variables: query.variables
                    });
                }
            });
            this.cache.performTransaction(function(c) {
                cacheWrites_1.forEach(function(write) {
                    return c.write(write);
                });
                var update = mutation.update;
                if (update) (0, $42BH7.tryFunctionOrLogError)(function() {
                    return update(c, mutation.result);
                });
            });
        }
    };
    DataStore.prototype.markMutationComplete = function(_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (optimisticResponse) this.cache.removeOptimistic(mutationId);
    };
    DataStore.prototype.markUpdateQueryResult = function(document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: 'ROOT_QUERY',
            variables: variables,
            query: document
        });
    };
    DataStore.prototype.reset = function() {
        return this.cache.reset();
    };
    return DataStore;
}();
var $03a288f5350d9e9d$var$version = "2.6.10";
var $03a288f5350d9e9d$var$hasSuggestedDevtools = false;
var $03a288f5350d9e9d$export$13f5a5f0f1dbab88 = function() {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link && resolvers) link = (0, $bvQX6.ApolloLink).empty();
        if (!link || !cache) throw new (0, $8j2fP.InvariantError)(4);
        this.link = link;
        this.cache = cache;
        this.store = new $03a288f5350d9e9d$var$DataStore(cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        var defaultConnectToDevTools = false;
        if (typeof connectToDevTools === 'undefined' ? defaultConnectToDevTools : connectToDevTools && typeof window !== 'undefined') window.__APOLLO_CLIENT__ = this;
        this.version = $03a288f5350d9e9d$var$version;
        this.localState = new $03a288f5350d9e9d$var$LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new $03a288f5350d9e9d$var$QueryManager({
            link: this.link,
            store: this.store,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.queryStore.getStore(),
                        mutations: _this.queryManager.mutationStore.getStore()
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            }
        });
    }
    ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.defaultOptions.watchQuery), options);
        if (this.disableNetworkFetches && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.defaultOptions.query), options);
        (0, $8j2fP.invariant)(options.fetchPolicy !== 'cache-and-network', 5);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.defaultOptions.mutate), options);
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function(options) {
        var result = this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeFragment = function(options) {
        var result = this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeData = function(options) {
        var result = this.cache.writeData(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $bvQX6.execute)(this.link, payload);
    };
    ApolloClient.prototype.initQueryManager = function() {
        return this.queryManager;
    };
    ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    return ApolloClient;
}();
var $03a288f5350d9e9d$export$2e2bcd8739ae039 = $03a288f5350d9e9d$export$13f5a5f0f1dbab88;

});
parcelRegister("bvQX6", function(module, exports) {

$parcel$export(module.exports, "makePromise", () => makePromise);
$parcel$export(module.exports, "fromError", () => fromError);
$parcel$export(module.exports, "ApolloLink", () => ApolloLink);
$parcel$export(module.exports, "from", () => from);
$parcel$export(module.exports, "split", () => split);
$parcel$export(module.exports, "execute", () => execute);
$parcel$export(module.exports, "Observable", () => (parcelRequire("5ECju")).default);

var $5ECju = parcelRequire("5ECju");

var $8j2fP = parcelRequire("8j2fP");

var $fKE23 = parcelRequire("fKE23");

var $42BH7 = parcelRequire("42BH7");
function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context'
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw new (0, $8j2fP.InvariantError)(2);
    }
    return operation;
}
var LinkError = function(_super) {
    (0, $fKE23.__extends)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error);
function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function(resolve, reject) {
        observable.subscribe({
            next: function(data) {
                if (completed) ;
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject
        });
    });
}
var makePromise = toPromise;
function fromPromise(promise) {
    return new (0, $5ECju.default)(function(observer) {
        promise.then(function(value) {
            observer.next(value);
            observer.complete();
        }).catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new (0, $5ECju.default)(function(observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== 'string' ? (0, $42BH7.getOperationName)(transformedOperation.query) : '';
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = (0, $fKE23.__assign)({}, starting);
    var setContext = function(next) {
        if (typeof next === 'function') context = (0, $fKE23.__assign)({}, context, next(context));
        else context = (0, $fKE23.__assign)({}, context, next);
    };
    var getContext = function() {
        return (0, $fKE23.__assign)({}, context);
    };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function() {
            return getKey(operation);
        }
    });
    return operation;
}
function getKey(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([
        operationName,
        query,
        variables
    ]);
}
function passthrough(op, forward) {
    return forward ? forward(op) : (0, $5ECju.default).of();
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function empty() {
    return new ApolloLink(function() {
        return (0, $5ECju.default).of();
    });
}
function from(links) {
    if (links.length === 0) return empty();
    return links.map(toLink).reduce(function(x, y) {
        return x.concat(y);
    });
}
function split(test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));
    if (isTerminating(leftLink) && isTerminating(rightLink)) return new ApolloLink(function(operation) {
        return test(operation) ? leftLink.request(operation) || (0, $5ECju.default).of() : rightLink.request(operation) || (0, $5ECju.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return test(operation) ? leftLink.request(operation, forward) || (0, $5ECju.default).of() : rightLink.request(operation, forward) || (0, $5ECju.default).of();
    });
}
var concat = function(first, second) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink)) return firstLink;
    var nextLink = toLink(second);
    if (isTerminating(nextLink)) return new ApolloLink(function(operation) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op) || (0, $5ECju.default).of();
        }) || (0, $5ECju.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op, forward) || (0, $5ECju.default).of();
        }) || (0, $5ECju.default).of();
    });
};
var ApolloLink = function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw new (0, $8j2fP.InvariantError)(1);
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}();
function execute(link, operation) {
    return link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || (0, $5ECju.default).of();
}

});
parcelRegister("5ECju", function(module, exports) {

$parcel$export(module.exports, "default", () => $41de6865c2ff0290$export$2e2bcd8739ae039);

var $1eC02 = parcelRequire("1eC02");
var $41de6865c2ff0290$export$77cea355fa80b5f4 = (0, (/*@__PURE__*/$parcel$interopDefault($1eC02)));
var $41de6865c2ff0290$export$2e2bcd8739ae039 = $41de6865c2ff0290$export$77cea355fa80b5f4;

});
parcelRegister("1eC02", function(module, exports) {

module.exports = (parcelRequire("bhbKH")).Observable;

});
parcelRegister("bhbKH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Observable = void 0;
function $835a65fddbd60374$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $835a65fddbd60374$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $835a65fddbd60374$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $835a65fddbd60374$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $835a65fddbd60374$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var $835a65fddbd60374$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $835a65fddbd60374$var$hasSymbol = function(name) {
    return $835a65fddbd60374$var$hasSymbols() && Boolean(Symbol[name]);
};
var $835a65fddbd60374$var$getSymbol = function(name) {
    return $835a65fddbd60374$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($835a65fddbd60374$var$hasSymbols() && !$835a65fddbd60374$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $835a65fddbd60374$var$SymbolIterator = $835a65fddbd60374$var$getSymbol('iterator');
var $835a65fddbd60374$var$SymbolObservable = $835a65fddbd60374$var$getSymbol('observable');
var $835a65fddbd60374$var$SymbolSpecies = $835a65fddbd60374$var$getSymbol('species'); // === Abstract Operations ===
function $835a65fddbd60374$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $835a65fddbd60374$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$835a65fddbd60374$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $835a65fddbd60374$var$Observable;
}
function $835a65fddbd60374$var$isObservable(x) {
    return x instanceof $835a65fddbd60374$var$Observable; // SPEC: Brand check
}
function $835a65fddbd60374$var$hostReportError(e) {
    if ($835a65fddbd60374$var$hostReportError.log) $835a65fddbd60374$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $835a65fddbd60374$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $835a65fddbd60374$var$hostReportError(e);
        }
    });
}
function $835a65fddbd60374$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $835a65fddbd60374$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $835a65fddbd60374$var$hostReportError(e);
    }
}
function $835a65fddbd60374$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $835a65fddbd60374$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $835a65fddbd60374$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $835a65fddbd60374$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $835a65fddbd60374$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $835a65fddbd60374$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $835a65fddbd60374$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $835a65fddbd60374$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $835a65fddbd60374$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $835a65fddbd60374$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $835a65fddbd60374$var$enqueue(function() {
            return $835a65fddbd60374$var$flushSubscription(subscription);
        });
        return;
    }
    $835a65fddbd60374$var$notifySubscription(subscription, type, value);
}
var $835a65fddbd60374$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        $835a65fddbd60374$var$_classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $835a65fddbd60374$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    $835a65fddbd60374$var$_createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== 'closed') {
                    $835a65fddbd60374$var$closeSubscription(this);
                    $835a65fddbd60374$var$cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $835a65fddbd60374$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        $835a65fddbd60374$var$_classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    $835a65fddbd60374$var$_createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                $835a65fddbd60374$var$onNotify(this._subscription, 'next', value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                $835a65fddbd60374$var$onNotify(this._subscription, 'error', value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                $835a65fddbd60374$var$onNotify(this._subscription, 'complete');
            }
        },
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $835a65fddbd60374$var$Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        $835a65fddbd60374$var$_classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    $835a65fddbd60374$var$_createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new $835a65fddbd60374$var$Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== 'function') {
                        reject(new TypeError(fn + ' is not a function'));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $835a65fddbd60374$var$getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $835a65fddbd60374$var$getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $835a65fddbd60374$var$getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = $835a65fddbd60374$var$getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function(v) {
                                observer.next(v);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $835a65fddbd60374$var$getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function(value) {
                                    observer.next(value);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: $835a65fddbd60374$var$SymbolObservable,
            value: function() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === 'function' ? this : Observable;
                if (x == null) throw new TypeError(x + ' is not an object');
                var method = $835a65fddbd60374$var$getMethod(x, $835a65fddbd60374$var$SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
                    if ($835a65fddbd60374$var$isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if ($835a65fddbd60374$var$hasSymbol('iterator')) {
                    method = $835a65fddbd60374$var$getMethod(x, $835a65fddbd60374$var$SymbolIterator);
                    if (method) return new C(function(observer) {
                        $835a65fddbd60374$var$enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    $835a65fddbd60374$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + ' is not observable');
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === 'function' ? this : Observable;
                return new C(function(observer) {
                    $835a65fddbd60374$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: $835a65fddbd60374$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
module.exports.Observable = $835a65fddbd60374$var$Observable;
if ($835a65fddbd60374$var$hasSymbols()) Object.defineProperty($835a65fddbd60374$var$Observable, Symbol('extensions'), {
    value: {
        symbol: $835a65fddbd60374$var$SymbolObservable,
        hostReportError: $835a65fddbd60374$var$hostReportError
    },
    configurable: true
});

});





parcelRegister("8Y3VE", function(module, exports) {

$parcel$export(module.exports, "setContext", () => $6876f98359b8915e$export$2f04de43fe27971a);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");
function $6876f98359b8915e$export$2f04de43fe27971a(setter) {
    return new (0, $bvQX6.ApolloLink)(function(operation, forward) {
        var request = (0, $fKE23.__rest)(operation, []);
        return new (0, $5ECju.default)(function(observer) {
            var handle;
            Promise.resolve(request).then(function(req) {
                return setter(req, operation.getContext());
            }).then(operation.setContext).then(function() {
                handle = forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer)
                });
            }).catch(observer.error.bind(observer));
            return function() {
                if (handle) handle.unsubscribe();
            };
        });
    });
}

});

parcelRegister("aqG9W", function(module, exports) {

$parcel$export(module.exports, "onError", () => $797d090cd04ee84b$export$2288787135a8f66e);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");
function $797d090cd04ee84b$export$2288787135a8f66e(errorHandler) {
    return new (0, $bvQX6.ApolloLink)(function(operation, forward) {
        return new (0, $5ECju.default)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $797d090cd04ee84b$export$d2c8415987899609 = function(_super) {
    (0, $fKE23.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $797d090cd04ee84b$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $bvQX6.ApolloLink));

});

parcelRegister("35Kb7", function(module, exports) {

$parcel$export(module.exports, "HttpLink", () => $2405a8c9bbd1579c$export$f4bbf1aec241cc1);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");

var $cp9eN = parcelRequire("cp9eN");
var $2405a8c9bbd1579c$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, $fKE23.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries",
        "abortErrorDoesNotCauseError"
    ]);
    (0, $cp9eN.checkFetcher)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $bvQX6.ApolloLink)(function(operation) {
        var chosenURI = (0, $cp9eN.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $fKE23.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $cp9eN.selectHttpOptionsAndBody)(operation, (0, $cp9eN.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $cp9eN.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = $2405a8c9bbd1579c$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $bvQX6.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $cp9eN.serializeFetchParameter)(body, 'Payload');
        } catch (parseError) {
            return (0, $bvQX6.fromError)(parseError);
        }
        return new (0, $5ECju.default)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $cp9eN.parseAndCheckHttpResponse)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function $2405a8c9bbd1579c$var$rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $cp9eN.serializeFetchParameter)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $cp9eN.serializeFetchParameter)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}
var $2405a8c9bbd1579c$export$f4bbf1aec241cc1 = function(_super) {
    (0, $fKE23.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, $2405a8c9bbd1579c$export$95180a16573d6675(opts).request) || this;
    }
    return HttpLink;
}((0, $bvQX6.ApolloLink));

});
parcelRegister("cp9eN", function(module, exports) {

$parcel$export(module.exports, "fallbackHttpConfig", () => $907efc3a22e8ac51$export$dd86f00dc866e75d);
$parcel$export(module.exports, "parseAndCheckHttpResponse", () => $907efc3a22e8ac51$export$d4051215bea0639f);
$parcel$export(module.exports, "checkFetcher", () => $907efc3a22e8ac51$export$8423f0cd3773115e);
$parcel$export(module.exports, "createSignalIfSupported", () => $907efc3a22e8ac51$export$f5853cd1fc39aea6);
$parcel$export(module.exports, "selectHttpOptionsAndBody", () => $907efc3a22e8ac51$export$a00ebfd5f1eebfb1);
$parcel$export(module.exports, "serializeFetchParameter", () => $907efc3a22e8ac51$export$5f8e80ac52052e28);
$parcel$export(module.exports, "selectURI", () => $907efc3a22e8ac51$export$63ccc2571850f81a);

var $fKE23 = parcelRequire("fKE23");

var $aKlnM = parcelRequire("aKlnM");

var $8j2fP = parcelRequire("8j2fP");
var $907efc3a22e8ac51$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $907efc3a22e8ac51$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $907efc3a22e8ac51$var$defaultOptions = {
    method: 'POST'
};
var $907efc3a22e8ac51$export$dd86f00dc866e75d = {
    http: $907efc3a22e8ac51$var$defaultHttpOptions,
    headers: $907efc3a22e8ac51$var$defaultHeaders,
    options: $907efc3a22e8ac51$var$defaultOptions
};
var $907efc3a22e8ac51$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var $907efc3a22e8ac51$export$d4051215bea0639f = function(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) $907efc3a22e8ac51$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $907efc3a22e8ac51$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var $907efc3a22e8ac51$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined') library = 'node-fetch';
        throw new (0, $8j2fP.InvariantError)(1);
    }
};
var $907efc3a22e8ac51$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var $907efc3a22e8ac51$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $fKE23.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, $fKE23.__assign)({}, options, config.options, {
            headers: (0, $fKE23.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $fKE23.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $aKlnM.print)(query);
    return {
        options: options,
        body: body
    };
};
var $907efc3a22e8ac51$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $8j2fP.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var $907efc3a22e8ac51$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};

});
parcelRegister("aKlnM", function(module, exports) {

$parcel$export(module.exports, "print", () => $1f94f8496a1ffd7f$export$c2d084dc44961371);

var $961BR = parcelRequire("961BR");

var $flA0a = parcelRequire("flA0a");
function $1f94f8496a1ffd7f$export$c2d084dc44961371(ast) {
    return (0, $961BR.visit)(ast, {
        leave: $1f94f8496a1ffd7f$var$printDocASTReducer
    });
}
var $1f94f8496a1ffd7f$var$MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var $1f94f8496a1ffd7f$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return '$' + node.name;
    },
    // Document
    Document: function Document(node) {
        return $1f94f8496a1ffd7f$var$join(node.definitions, '\n\n') + '\n';
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(node.variableDefinitions, ', '), ')');
        var directives = $1f94f8496a1ffd7f$var$join(node.directives, ' ');
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === 'query' ? selectionSet : $1f94f8496a1ffd7f$var$join([
            op,
            $1f94f8496a1ffd7f$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], ' ');
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ': ' + type + $1f94f8496a1ffd7f$var$wrap(' = ', defaultValue) + $1f94f8496a1ffd7f$var$wrap(' ', $1f94f8496a1ffd7f$var$join(directives, ' '));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $1f94f8496a1ffd7f$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = $1f94f8496a1ffd7f$var$wrap('', alias, ': ') + name;
        var argsLine = prefix + $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(args, ', '), ')');
        if (argsLine.length > $1f94f8496a1ffd7f$var$MAX_LINE_LENGTH) argsLine = prefix + $1f94f8496a1ffd7f$var$wrap('(\n', $1f94f8496a1ffd7f$var$indent($1f94f8496a1ffd7f$var$join(args, '\n')), '\n)');
        return $1f94f8496a1ffd7f$var$join([
            argsLine,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ': ' + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return '...' + name + $1f94f8496a1ffd7f$var$wrap(' ', $1f94f8496a1ffd7f$var$join(directives, ' '));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $1f94f8496a1ffd7f$var$join([
            '...',
            $1f94f8496a1ffd7f$var$wrap('on ', typeCondition),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat($1f94f8496a1ffd7f$var$wrap('', $1f94f8496a1ffd7f$var$join(directives, ' '), ' ')) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $flA0a.printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? 'true' : 'false';
    },
    NullValue: function NullValue() {
        return 'null';
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return '[' + $1f94f8496a1ffd7f$var$join(values, ', ') + ']';
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return '{' + $1f94f8496a1ffd7f$var$join(fields, ', ') + '}';
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ': ' + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return '@' + name + $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(args, ', '), ')');
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return '[' + type + ']';
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + '!';
    },
    // Type System Definitions
    SchemaDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $1f94f8496a1ffd7f$var$join([
            'schema',
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(operationTypes)
        ], ' ');
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ': ' + type;
    },
    ScalarTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $1f94f8496a1ffd7f$var$join([
            'scalar',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' ')
        ], ' ');
    }),
    ObjectTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $1f94f8496a1ffd7f$var$join([
            'type',
            name,
            $1f94f8496a1ffd7f$var$wrap('implements ', $1f94f8496a1ffd7f$var$join(interfaces, ' & ')),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    }),
    FieldDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($1f94f8496a1ffd7f$var$hasMultilineItems(args) ? $1f94f8496a1ffd7f$var$wrap('(\n', $1f94f8496a1ffd7f$var$indent($1f94f8496a1ffd7f$var$join(args, '\n')), '\n)') : $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(args, ', '), ')')) + ': ' + type + $1f94f8496a1ffd7f$var$wrap(' ', $1f94f8496a1ffd7f$var$join(directives, ' '));
    }),
    InputValueDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $1f94f8496a1ffd7f$var$join([
            name + ': ' + type,
            $1f94f8496a1ffd7f$var$wrap('= ', defaultValue),
            $1f94f8496a1ffd7f$var$join(directives, ' ')
        ], ' ');
    }),
    InterfaceTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return $1f94f8496a1ffd7f$var$join([
            'interface',
            name,
            $1f94f8496a1ffd7f$var$wrap('implements ', $1f94f8496a1ffd7f$var$join(interfaces, ' & ')),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    }),
    UnionTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $1f94f8496a1ffd7f$var$join([
            'union',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $1f94f8496a1ffd7f$var$join(types, ' | ') : ''
        ], ' ');
    }),
    EnumTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $1f94f8496a1ffd7f$var$join([
            'enum',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(values)
        ], ' ');
    }),
    EnumValueDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $1f94f8496a1ffd7f$var$join([
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' ')
        ], ' ');
    }),
    InputObjectTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $1f94f8496a1ffd7f$var$join([
            'input',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    }),
    DirectiveDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return 'directive @' + name + ($1f94f8496a1ffd7f$var$hasMultilineItems(args) ? $1f94f8496a1ffd7f$var$wrap('(\n', $1f94f8496a1ffd7f$var$indent($1f94f8496a1ffd7f$var$join(args, '\n')), '\n)') : $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $1f94f8496a1ffd7f$var$join(locations, ' | ');
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $1f94f8496a1ffd7f$var$join([
            'extend schema',
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(operationTypes)
        ], ' ');
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $1f94f8496a1ffd7f$var$join([
            'extend scalar',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' ')
        ], ' ');
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $1f94f8496a1ffd7f$var$join([
            'extend type',
            name,
            $1f94f8496a1ffd7f$var$wrap('implements ', $1f94f8496a1ffd7f$var$join(interfaces, ' & ')),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return $1f94f8496a1ffd7f$var$join([
            'extend interface',
            name,
            $1f94f8496a1ffd7f$var$wrap('implements ', $1f94f8496a1ffd7f$var$join(interfaces, ' & ')),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $1f94f8496a1ffd7f$var$join([
            'extend union',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $1f94f8496a1ffd7f$var$join(types, ' | ') : ''
        ], ' ');
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $1f94f8496a1ffd7f$var$join([
            'extend enum',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(values)
        ], ' ');
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $1f94f8496a1ffd7f$var$join([
            'extend input',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    }
};
function $1f94f8496a1ffd7f$var$addDescription(cb) {
    return function(node) {
        return $1f94f8496a1ffd7f$var$join([
            node.description,
            cb(node)
        ], '\n');
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $1f94f8496a1ffd7f$var$join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $1f94f8496a1ffd7f$var$block(array) {
    return $1f94f8496a1ffd7f$var$wrap('{\n', $1f94f8496a1ffd7f$var$indent($1f94f8496a1ffd7f$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $1f94f8496a1ffd7f$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $1f94f8496a1ffd7f$var$indent(str) {
    return $1f94f8496a1ffd7f$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $1f94f8496a1ffd7f$var$isMultiline(str) {
    return str.indexOf('\n') !== -1;
}
function $1f94f8496a1ffd7f$var$hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some($1f94f8496a1ffd7f$var$isMultiline);
}

});
parcelRegister("flA0a", function(module, exports) {

$parcel$export(module.exports, "dedentBlockStringValue", () => $06a65b237068075a$export$fd88c0b652c46ccc);
$parcel$export(module.exports, "printBlockString", () => $06a65b237068075a$export$adb6ca997eeb1f45);
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $06a65b237068075a$export$fd88c0b652c46ccc(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $06a65b237068075a$export$3c95bfdc680af0c(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $06a65b237068075a$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $06a65b237068075a$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join('\n');
}
function $06a65b237068075a$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== ' ' && str[i] !== '\t') return false;
    }
    return true;
}
function $06a65b237068075a$export$3c95bfdc680af0c(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
function $06a65b237068075a$export$adb6ca997eeb1f45(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === '\\';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

});




parcelRegister("kcwGc", function(module, exports) {

$parcel$export(module.exports, "RetryLink", () => $eb4e47225b0a9c93$export$943d544ad120494a);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");
function $eb4e47225b0a9c93$var$buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) delay = Math.random() * delay;
        return delay;
    };
}
function $eb4e47225b0a9c93$var$buildRetryFunction(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max) return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}
var $eb4e47225b0a9c93$var$RetryableOperation = function() {
    function RetryableOperation(operation, nextLink, delayFor, retryIf) {
        var _this = this;
        this.operation = operation;
        this.nextLink = nextLink;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.values = [];
        this.complete = false;
        this.canceled = false;
        this.observers = [];
        this.currentSubscription = null;
        this.onNext = function(value) {
            _this.values.push(value);
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.next(value);
            }
        };
        this.onComplete = function() {
            _this.complete = true;
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.complete();
            }
        };
        this.onError = function(error) {
            return (0, $fKE23.__awaiter)(_this, void 0, void 0, function() {
                var shouldRetry, _i, _a, observer;
                return (0, $fKE23.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.retryCount += 1;
                            return [
                                4,
                                this.retryIf(this.retryCount, this.operation, error)
                            ];
                        case 1:
                            shouldRetry = _b.sent();
                            if (shouldRetry) {
                                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                return [
                                    2
                                ];
                            }
                            this.error = error;
                            for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                observer = _a[_i];
                                if (!observer) continue;
                                observer.error(error);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        };
    }
    RetryableOperation.prototype.subscribe = function(observer) {
        if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
        this.observers.push(observer);
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var value = _a[_i];
            observer.next(value);
        }
        if (this.complete) observer.complete();
        else if (this.error) observer.error(this.error);
    };
    RetryableOperation.prototype.unsubscribe = function(observer) {
        var index = this.observers.indexOf(observer);
        if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
        this.observers[index] = null;
        if (this.observers.every(function(o) {
            return o === null;
        })) this.cancel();
    };
    RetryableOperation.prototype.start = function() {
        if (this.currentSubscription) return;
        this.try();
    };
    RetryableOperation.prototype.cancel = function() {
        if (this.currentSubscription) this.currentSubscription.unsubscribe();
        clearTimeout(this.timerId);
        this.timerId = null;
        this.currentSubscription = null;
        this.canceled = true;
    };
    RetryableOperation.prototype.try = function() {
        this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
        });
    };
    RetryableOperation.prototype.scheduleRetry = function(delay) {
        var _this = this;
        if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
        this.timerId = setTimeout(function() {
            _this.timerId = null;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}();
var $eb4e47225b0a9c93$export$943d544ad120494a = function(_super) {
    (0, $fKE23.__extends)(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor = typeof delay === 'function' ? delay : $eb4e47225b0a9c93$var$buildDelayFunction(delay);
        _this.retryIf = typeof attempts === 'function' ? attempts : $eb4e47225b0a9c93$var$buildRetryFunction(attempts);
        return _this;
    }
    RetryLink.prototype.request = function(operation, nextLink) {
        var retryable = new $eb4e47225b0a9c93$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
        retryable.start();
        return new (0, $5ECju.default)(function(observer) {
            retryable.subscribe(observer);
            return function() {
                retryable.unsubscribe(observer);
            };
        });
    };
    return RetryLink;
}((0, $bvQX6.ApolloLink));

});

parcelRegister("10n8H", function(module, exports) {

$parcel$export(module.exports, "fragmentCacheRedirect", () => $0bb7bd86ef08f58c$export$5133c88128301697);
$parcel$export(module.exports, "fragmentLinkState", () => $0bb7bd86ef08f58c$export$3f9ecfb4d42ab23d);

var $42BH7 = parcelRequire("42BH7");

var $hiwGV = parcelRequire("hiwGV");

var $2vRh6 = parcelRequire("2vRh6");
function $0bb7bd86ef08f58c$export$5133c88128301697(dataIdFromObject) {
    if (dataIdFromObject === void 0) dataIdFromObject = (0, $2vRh6.defaultDataIdFromObject);
    return {
        getFragment: function(_, _a) {
            var id = _a.id, __typename = _a.__typename;
            return (0, $42BH7.toIdValue)(dataIdFromObject({
                __typename: __typename,
                id: id
            }));
        }
    };
}
function $0bb7bd86ef08f58c$export$3f9ecfb4d42ab23d(apolloCache) {
    return (0, $hiwGV.withClientState)({
        cache: apolloCache,
        resolvers: {
            Query: {
                getFragment: function(_, _a, _b) {
                    var __typename = _a.__typename, id = _a.id;
                    var cache = _b.cache;
                    var fragmentId = cache.config.dataIdFromObject({
                        __typename: __typename,
                        id: id
                    });
                    return cache.data.data[fragmentId];
                }
            }
        }
    });
}

});
parcelRegister("hiwGV", function(module, exports) {

$parcel$export(module.exports, "withClientState", () => $c97d79f1a0a9adb8$export$a13f755900e15d9e);

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");

var $42BH7 = parcelRequire("42BH7");

var $77JSu = parcelRequire("77JSu");

var $fl4NX = parcelRequire("fl4NX");
var $c97d79f1a0a9adb8$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c97d79f1a0a9adb8$var$graphql = $77JSu.graphql;
var $c97d79f1a0a9adb8$var$capitalizeFirstLetter = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var $c97d79f1a0a9adb8$export$a13f755900e15d9e = function(clientStateConfig) {
    if (clientStateConfig === void 0) clientStateConfig = {
        resolvers: {},
        defaults: {}
    };
    var defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs, fragmentMatcher = clientStateConfig.fragmentMatcher;
    if (cache && defaults) cache.writeData({
        data: defaults
    });
    return new (function(_super) {
        $c97d79f1a0a9adb8$var$__extends(StateLink, _super);
        function StateLink() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        StateLink.prototype.writeDefaults = function() {
            if (cache && defaults) cache.writeData({
                data: defaults
            });
        };
        StateLink.prototype.request = function(operation, forward) {
            if (forward === void 0) forward = function() {
                return (0, $5ECju.default).of({
                    data: {}
                });
            };
            if (typeDefs) {
                var directives_1 = 'directive @client on FIELD';
                var definition_1 = (0, $fl4NX.normalizeTypeDefs)(typeDefs);
                operation.setContext(function(_a) {
                    var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
                    return {
                        schemas: schemas.concat([
                            {
                                definition: definition_1,
                                directives: directives_1
                            }
                        ])
                    };
                });
            }
            var isClient = (0, $42BH7.hasDirectives)([
                'client'
            ], operation.query);
            if (!isClient) return forward(operation);
            var resolvers = typeof clientStateConfig.resolvers === 'function' ? clientStateConfig.resolvers() : clientStateConfig.resolvers;
            var server = (0, $fl4NX.removeClientSetsFromDocument)(operation.query);
            var query = operation.query;
            var type = $c97d79f1a0a9adb8$var$capitalizeFirstLetter(((0, $42BH7.getMainDefinition)(query) || {}).operation) || 'Query';
            var resolver = function(fieldName, rootValue, args, context, info) {
                if (rootValue === void 0) rootValue = {};
                var resultKey = info.resultKey;
                var aliasedNode = rootValue[resultKey];
                var preAliasingNode = rootValue[fieldName];
                var aliasNeeded = resultKey !== fieldName;
                if (aliasedNode !== undefined || preAliasingNode !== undefined) return aliasedNode || preAliasingNode;
                var resolverMap = resolvers[rootValue.__typename || type];
                if (resolverMap) {
                    var resolve = resolverMap[fieldName];
                    if (resolve) return resolve(rootValue, args, context, info);
                }
                return (aliasNeeded ? aliasedNode : preAliasingNode) || (defaults || {})[fieldName];
            };
            if (server) operation.query = server;
            var obs = server && forward ? forward(operation) : (0, $5ECju.default).of({
                data: {}
            });
            return new (0, $5ECju.default)(function(observer) {
                var complete = false;
                var handlingNext = false;
                obs.subscribe({
                    next: function(_a) {
                        var data = _a.data, errors = _a.errors;
                        var observerErrorHandler = observer.error.bind(observer);
                        var context = operation.getContext();
                        handlingNext = true;
                        $c97d79f1a0a9adb8$var$graphql(resolver, query, data, context, operation.variables, {
                            fragmentMatcher: fragmentMatcher
                        }).then(function(nextData) {
                            observer.next({
                                data: nextData,
                                errors: errors
                            });
                            if (complete) observer.complete();
                            handlingNext = false;
                        }).catch(observerErrorHandler);
                    },
                    error: observer.error.bind(observer),
                    complete: function() {
                        if (!handlingNext) observer.complete();
                        complete = true;
                    }
                });
            });
        };
        return StateLink;
    }((0, $bvQX6.ApolloLink)))();
};

});
parcelRegister("77JSu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fKE23 = parcelRequire("fKE23");

var $42BH7 = parcelRequire("42BH7");

var $1BuKE = parcelRequire("1BuKE");
function $52fcc63cc3cd9b23$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $42BH7.getMainDefinition(document);
    var fragments = $42BH7.getFragmentDefinitions(document);
    var fragmentMap = $42BH7.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $52fcc63cc3cd9b23$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $52fcc63cc3cd9b23$var$graphql;
function $52fcc63cc3cd9b23$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    return $fKE23.__awaiter(this, void 0, void 0, function() {
        var fragmentMap, contextValue, variables, result, execute;
        var _this = this;
        return $fKE23.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
                    result = {};
                    execute = function(selection) {
                        return $fKE23.__awaiter(_this, void 0, void 0, function() {
                            var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
                            return $fKE23.__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!$42BH7.shouldInclude(selection, variables)) return [
                                            2
                                        ];
                                        if (!$42BH7.isField(selection)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            $52fcc63cc3cd9b23$var$executeField(selection, rootValue, execContext)
                                        ];
                                    case 1:
                                        fieldResult = _a.sent();
                                        resultFieldKey = $42BH7.resultKeyNameFromField(selection);
                                        if (fieldResult !== undefined) {
                                            if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                                            else $1BuKE.merge(result[resultFieldKey], fieldResult);
                                        }
                                        return [
                                            2
                                        ];
                                    case 2:
                                        if ($42BH7.isInlineFragment(selection)) fragment = selection;
                                        else {
                                            fragment = fragmentMap[selection.name.value];
                                            if (!fragment) throw new Error("No fragment named " + selection.name.value);
                                        }
                                        typeCondition = fragment.typeCondition.name.value;
                                        if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            $52fcc63cc3cd9b23$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext)
                                        ];
                                    case 3:
                                        fragmentResult = _a.sent();
                                        $1BuKE.merge(result, fragmentResult);
                                        _a.label = 4;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    };
                    return [
                        4,
                        Promise.all(selectionSet.selections.map(execute))
                    ];
                case 1:
                    _a.sent();
                    if (execContext.resultMapper) return [
                        2,
                        execContext.resultMapper(result, rootValue)
                    ];
                    return [
                        2,
                        result
                    ];
            }
        });
    });
}
function $52fcc63cc3cd9b23$var$executeField(field, rootValue, execContext) {
    return $fKE23.__awaiter(this, void 0, void 0, function() {
        var variables, contextValue, resolver, fieldName, args, info, result;
        return $fKE23.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
                    fieldName = field.name.value;
                    args = $42BH7.argumentsObjectFromField(field, variables);
                    info = {
                        isLeaf: !field.selectionSet,
                        resultKey: $42BH7.resultKeyNameFromField(field),
                        directives: $42BH7.getDirectiveInfoFromField(field, variables),
                        field: field
                    };
                    return [
                        4,
                        resolver(fieldName, rootValue, args, contextValue, info)
                    ];
                case 1:
                    result = _a.sent();
                    if (!field.selectionSet) return [
                        2,
                        result
                    ];
                    if (result == null) return [
                        2,
                        result
                    ];
                    if (Array.isArray(result)) return [
                        2,
                        $52fcc63cc3cd9b23$var$executeSubSelectedArray(field, result, execContext)
                    ];
                    return [
                        2,
                        $52fcc63cc3cd9b23$var$executeSelectionSet(field.selectionSet, result, execContext)
                    ];
            }
        });
    });
}
function $52fcc63cc3cd9b23$var$executeSubSelectedArray(field, result, execContext) {
    return Promise.all(result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $52fcc63cc3cd9b23$var$executeSubSelectedArray(field, item, execContext);
        return $52fcc63cc3cd9b23$var$executeSelectionSet(field.selectionSet, item, execContext);
    }));
}

});
parcelRegister("1BuKE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $42BH7 = parcelRequire("42BH7");
function $12b119b85c2553d1$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (variableValues === void 0) variableValues = {};
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $42BH7.getMainDefinition(document);
    var fragments = $42BH7.getFragmentDefinitions(document);
    var fragmentMap = $42BH7.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $12b119b85c2553d1$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $12b119b85c2553d1$var$graphql;
function $12b119b85c2553d1$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
    var result = {};
    selectionSet.selections.forEach(function(selection) {
        if (variables && !$42BH7.shouldInclude(selection, variables)) return;
        if ($42BH7.isField(selection)) {
            var fieldResult = $12b119b85c2553d1$var$executeField(selection, rootValue, execContext);
            var resultFieldKey = $42BH7.resultKeyNameFromField(selection);
            if (fieldResult !== undefined) {
                if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                else $12b119b85c2553d1$var$merge(result[resultFieldKey], fieldResult);
            }
        } else {
            var fragment = void 0;
            if ($42BH7.isInlineFragment(selection)) fragment = selection;
            else {
                fragment = fragmentMap[selection.name.value];
                if (!fragment) throw new Error("No fragment named " + selection.name.value);
            }
            var typeCondition = fragment.typeCondition.name.value;
            if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                var fragmentResult = $12b119b85c2553d1$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                $12b119b85c2553d1$var$merge(result, fragmentResult);
            }
        }
    });
    if (execContext.resultMapper) return execContext.resultMapper(result, rootValue);
    return result;
}
function $12b119b85c2553d1$var$executeField(field, rootValue, execContext) {
    var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
    var fieldName = field.name.value;
    var args = $42BH7.argumentsObjectFromField(field, variables);
    var info = {
        isLeaf: !field.selectionSet,
        resultKey: $42BH7.resultKeyNameFromField(field),
        directives: $42BH7.getDirectiveInfoFromField(field, variables),
        field: field
    };
    var result = resolver(fieldName, rootValue, args, contextValue, info);
    if (!field.selectionSet) return result;
    if (result == null) return result;
    if (Array.isArray(result)) return $12b119b85c2553d1$var$executeSubSelectedArray(field, result, execContext);
    return $12b119b85c2553d1$var$executeSelectionSet(field.selectionSet, result, execContext);
}
function $12b119b85c2553d1$var$executeSubSelectedArray(field, result, execContext) {
    return result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $12b119b85c2553d1$var$executeSubSelectedArray(field, item, execContext);
        return $12b119b85c2553d1$var$executeSelectionSet(field.selectionSet, item, execContext);
    });
}
var $12b119b85c2553d1$var$hasOwn = Object.prototype.hasOwnProperty;
function $12b119b85c2553d1$var$merge(dest, src) {
    if (src !== null && typeof src === 'object') Object.keys(src).forEach(function(key) {
        var srcVal = src[key];
        if (!$12b119b85c2553d1$var$hasOwn.call(dest, key)) dest[key] = srcVal;
        else $12b119b85c2553d1$var$merge(dest[key], srcVal);
    });
}
module.exports.merge = $12b119b85c2553d1$var$merge;

});


parcelRegister("fl4NX", function(module, exports) {

$parcel$export(module.exports, "removeClientSetsFromDocument", () => $b2ac8b51e1cafdcd$export$8eae69e876ee321e);
$parcel$export(module.exports, "normalizeTypeDefs", () => $b2ac8b51e1cafdcd$export$467f9c465e4ace4e);

var $aKlnM = parcelRequire("aKlnM");

var $42BH7 = parcelRequire("42BH7");
var $b2ac8b51e1cafdcd$var$connectionRemoveConfig = {
    test: function(directive) {
        return directive.name.value === 'client';
    },
    remove: true
};
var $b2ac8b51e1cafdcd$var$removed = new Map();
function $b2ac8b51e1cafdcd$export$8eae69e876ee321e(query) {
    var cached = $b2ac8b51e1cafdcd$var$removed.get(query);
    if (cached) return cached;
    (0, $42BH7.checkDocument)(query);
    var docClone = (0, $42BH7.removeDirectivesFromDocument)([
        $b2ac8b51e1cafdcd$var$connectionRemoveConfig
    ], query);
    $b2ac8b51e1cafdcd$var$removed.set(query, docClone);
    return docClone;
}
function $b2ac8b51e1cafdcd$export$467f9c465e4ace4e(typeDefs) {
    var defs = Array.isArray(typeDefs) ? typeDefs : [
        typeDefs
    ];
    return defs.map(function(typeDef) {
        return typeof typeDef === 'string' ? typeDef : (0, $aKlnM.print)(typeDef);
    }).map(function(str) {
        return str.trim();
    }).join('\n');
}

});



parcelRegister("2emZ8", function(module, exports) {

$parcel$export(module.exports, "getErrorFlag", () => $27007c9b77094f4f$export$7a23a73c35436772);
$parcel$export(module.exports, "extractFlagFromAction", () => $27007c9b77094f4f$export$6783b18b1c9d1ab1);

var $illlw = parcelRequire("illlw");

var $3tfzg = parcelRequire("3tfzg");

var $hr2LF = parcelRequire("hr2LF");

var $1h6oK = parcelRequire("1h6oK");

var $R1ugb = parcelRequire("R1ugb");
const $27007c9b77094f4f$export$2cf9ab1b4d75e34e = (error)=>{
    const { graphQLErrors: graphQLErrors } = error;
    if (!graphQLErrors || graphQLErrors.length === 0) return null;
    const applicationError = graphQLErrors.find((e)=>(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(e, [
            'extensions',
            'errorType'
        ], false));
    if (!applicationError) return null;
    return {
        errorType: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(applicationError, [
            'extensions',
            'errorType'
        ], '')
    };
};
const $27007c9b77094f4f$export$eeae51b1c2ad1cfa = (error)=>{
    if ((0, $R1ugb.isFetchError)(error)) return {
        statusCode: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
            'statusCode'
        ], null),
        userMessage: null
    };
    const { graphQLErrors: graphQLErrors, networkError: networkError } = error;
    if (networkError) return {
        statusCode: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(networkError, [
            'statusCode'
        ], null),
        userMessage: null
    };
    if (graphQLErrors.length > 0) return {
        statusCode: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(graphQLErrors, [
            0,
            'extensions',
            'statusCode'
        ], null),
        userMessage: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(graphQLErrors, [
            0,
            'extensions',
            'userMessage'
        ], null)
    };
    return {
        statusCode: null,
        userMessage: null
    };
};
const $27007c9b77094f4f$var$isApplicationError = (error)=>{
    const applicationError = $27007c9b77094f4f$export$2cf9ab1b4d75e34e(error);
    return applicationError?.errorType === (0, $hr2LF.XSRF_CHECK_FAILED);
};
const $27007c9b77094f4f$export$7a23a73c35436772 = (error)=>{
    if (!(0, $R1ugb.isFetchError)(error)) {
        // check if any error contains "errorType", and process prior to http-status-code
        if ($27007c9b77094f4f$var$isApplicationError(error)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return {
            type: 'error',
            title: (0, $1h6oK.default).xsrfCheckFailedTitle,
            description: (0, $1h6oK.default).xsrfCheckFailedDescription,
            error: error
        };
    }
    const { statusCode: httpStatusCode, userMessage: userMessage } = $27007c9b77094f4f$export$eeae51b1c2ad1cfa(error);
    if ((httpStatusCode === 400 || httpStatusCode === 403) && userMessage) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        type: 'error',
        title: (0, $3tfzg.default).genericError().title,
        description: [
            (0, $1h6oK.default).genericErrorDescription,
            {
                userMessage: userMessage
            }
        ],
        error: error
    };
    if (httpStatusCode === 401) {
        const unauthorizedError = (0, $3tfzg.default).unauthorized();
        unauthorizedError.error = error;
        return unauthorizedError;
    }
    if (httpStatusCode === 403) {
        const forbiddenError = (0, $3tfzg.default).forbidden();
        forbiddenError.error = error;
        return forbiddenError;
    }
    const genericError = (0, $3tfzg.default).genericError();
    genericError.error = error;
    return genericError;
};
const $27007c9b77094f4f$export$6783b18b1c9d1ab1 = (action)=>{
    const { payload: error } = action;
    if ((0, $R1ugb.isSwagError)(error) || (0, $R1ugb.isFetchError)(error)) return $27007c9b77094f4f$export$7a23a73c35436772(error);
    // eslint-disable-next-line no-console
    console.error('Action showErrorFlag(error) contains invalid error format. \n Make sure you are using query$() or mutation$() utils from @atlassian/jira-software-swag in /rest layer');
    return undefined;
};

});
parcelRegister("3tfzg", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2f5282da7c4a398$export$2e2bcd8739ae039);

var $7ZFHa = parcelRequire("7ZFHa");

var $1yPyd = parcelRequire("1yPyd");

var $kZOWw = parcelRequire("kZOWw");

var $aiNUT = parcelRequire("aiNUT");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c2f5282da7c4a398$export$2e2bcd8739ae039 = {
    forbidden: $7ZFHa.default,
    genericError: $1yPyd.default,
    serverError: $kZOWw.default,
    unauthorized: $aiNUT.default
};

});
parcelRegister("7ZFHa", function(module, exports) {

$parcel$export(module.exports, "default", () => $38183d80ce97928d$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package
    --------
    Temporary disable while refactoring the flags package
    so that we don't trigger retranslation of strings */ 
var $90IgZ = parcelRequire("90IgZ");
const $38183d80ce97928d$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.forbidden.title",
        "defaultMessage": "You don't have permission to do that"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.forbidden.description",
        "defaultMessage": "Ask your Jira admin for help."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$38183d80ce97928d$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $38183d80ce97928d$var$messages.title,
        description: $38183d80ce97928d$var$messages.description
    });

});

parcelRegister("1yPyd", function(module, exports) {

$parcel$export(module.exports, "default", () => $2073c932b2866c1b$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package
    --------
    Temporary disable while refactoring the flags package
    so that we don't trigger retranslation of strings */ 
var $90IgZ = parcelRequire("90IgZ");
const $2073c932b2866c1b$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.generic-error.title",
        "defaultMessage": "Something's gone wrong"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.generic-error.description",
        "defaultMessage": "Refresh the page and try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2073c932b2866c1b$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $2073c932b2866c1b$var$messages.title,
        description: $2073c932b2866c1b$var$messages.description
    });

});

parcelRegister("kZOWw", function(module, exports) {

$parcel$export(module.exports, "default", () => $e55ad6379920dc9f$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package
    --------
    Temporary disable while refactoring the flags package
    so that we don't trigger retranslation of strings */ 
var $90IgZ = parcelRequire("90IgZ");
const $e55ad6379920dc9f$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.server-error.title",
        "defaultMessage": "We're having some trouble"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.server-error.description",
        "defaultMessage": "Something went wrong on our end. Refresh the page and try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e55ad6379920dc9f$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $e55ad6379920dc9f$var$messages.title,
        description: $e55ad6379920dc9f$var$messages.description
    });

});

parcelRegister("aiNUT", function(module, exports) {

$parcel$export(module.exports, "default", () => $df39dc77bca926f0$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package
    --------
    Temporary disable while refactoring the flags package
    so that we don't trigger retranslation of strings */ 
var $90IgZ = parcelRequire("90IgZ");
const $df39dc77bca926f0$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.unauthorized.title",
        "defaultMessage": "You're logged out"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.unauthorized.description",
        "defaultMessage": "Log back in and try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$df39dc77bca926f0$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $df39dc77bca926f0$var$messages.title,
        description: $df39dc77bca926f0$var$messages.description
    });

});


parcelRegister("hr2LF", function(module, exports) {

$parcel$export(module.exports, "SHOW_ERROR_FLAG_FROM_SWAG", () => $6e7bdf98a1568716$export$849b6aff5e6c9763);
$parcel$export(module.exports, "showErrorFlag", () => $6e7bdf98a1568716$export$dfa2148cdb92917d);
$parcel$export(module.exports, "XSRF_CHECK_FAILED", () => $6e7bdf98a1568716$export$653597ecd43ee3b5);
const $6e7bdf98a1568716$export$849b6aff5e6c9763 = 'SHOW_ERROR_FLAG_FROM_SWAG';
const $6e7bdf98a1568716$export$dfa2148cdb92917d = (error)=>({
        type: $6e7bdf98a1568716$export$849b6aff5e6c9763,
        payload: error
    });
const $6e7bdf98a1568716$export$653597ecd43ee3b5 = 'XSRF_CHECK_FAILED';

});

parcelRegister("1h6oK", function(module, exports) {

$parcel$export(module.exports, "default", () => $e09e9c2f98710854$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e09e9c2f98710854$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    genericErrorDescription: {
        "id": "software-swag.common.generic-error-description",
        "defaultMessage": "{userMessage}"
    },
    xsrfCheckFailedTitle: {
        "id": "software-swag.common.xsrf-check-failed-title",
        "defaultMessage": "Our session has expired"
    },
    xsrfCheckFailedDescription: {
        "id": "software-swag.common.xsrf-check-failed-description",
        "defaultMessage": "Refresh the page and try again"
    }
});

});

parcelRegister("R1ugb", function(module, exports) {

$parcel$export(module.exports, "SwagError", () => $265fd8fb70331573$export$c6b77322a15ada4f);
$parcel$export(module.exports, "isJson", () => $265fd8fb70331573$export$952e1d8683e4d0c4);
$parcel$export(module.exports, "isFetchError", () => $265fd8fb70331573$export$96f7e6db4105d70c);
$parcel$export(module.exports, "isSwagError", () => $265fd8fb70331573$export$7d7253f3a1a7c031);

var $7byHA = parcelRequire("7byHA");
const $265fd8fb70331573$var$generateErrorMessage = (err)=>{
    let message = '';
    // If we have GraphQL errors present, add that to the error message.
    if (Array.isArray(err.graphQLErrors) && err.graphQLErrors.length !== 0) err.graphQLErrors.forEach((graphQLError)=>{
        const errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += `GraphQL error: ${errorMessage}\n`;
    });
    if (err.networkError) message += `Network error: ${err.networkError.message}\n`;
    // strip newline from the end of the message
    message = message.replace(/\n$/, '');
    return message;
};
class $265fd8fb70331573$export$c6b77322a15ada4f extends Error {
    constructor({ graphQLErrors: graphQLErrors, networkError: networkError, errorMessage: errorMessage, traceId: traceId = '' }){
        super(errorMessage);
        this.graphQLErrors = [];
        this.networkError = null;
        // SWAG trace id, extracted from "atl-traceid" response-header
        // Helps to find relevant error in SWAG logs
        this.traceId = '';
        this.graphQLErrors = graphQLErrors || [];
        this.networkError = networkError || null;
        if (!errorMessage) this.message = $265fd8fb70331573$var$generateErrorMessage(this);
        else this.message = errorMessage;
        this.name = this.constructor.name;
        this.traceId = traceId;
        this.cause = networkError || graphQLErrors?.[0];
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(this.message).stack;
    }
    skipSentry() {
        return this.networkError != null || this.graphQLErrors.length > 0;
    }
}
const $265fd8fb70331573$export$952e1d8683e4d0c4 = (value)=>{
    try {
        JSON.parse(value);
    } catch (e) {
        return false;
    }
    return true;
};
const $265fd8fb70331573$export$96f7e6db4105d70c = (error)=>error !== null && typeof error === 'object' && error instanceof (0, $7byHA.default);
const $265fd8fb70331573$export$7d7253f3a1a7c031 = (error)=>{
    if (error !== null && typeof error === 'object' && error instanceof $265fd8fb70331573$export$c6b77322a15ada4f) return 'graphQLErrors' in error || 'networkError' in error;
    return false;
};

});


parcelRegister("eeJ3R", function(module, exports) {

$parcel$export(module.exports, "logApolloError", () => $ff92a92e5b2be045$export$2c9c775c9aa1863d);
$parcel$export(module.exports, "logApolloNetworkError", () => $ff92a92e5b2be045$export$45c096492076b53a);
$parcel$export(module.exports, "logRestError", () => $ff92a92e5b2be045$export$9a40393cdc64dc7d);
$parcel$export(module.exports, "logRestNetworkError", () => $ff92a92e5b2be045$export$b2eb9fe68368f77d);
$parcel$export(module.exports, "logRestParsingError", () => $ff92a92e5b2be045$export$25d52be9f4671e9e);
$parcel$export(module.exports, "logRestRetry", () => $ff92a92e5b2be045$export$e8ce08d55ac713ef);
$parcel$export(module.exports, "logApolloRetry", () => $ff92a92e5b2be045$export$3e50530825dee9d1);

var $gUUjF = parcelRequire("gUUjF");
const $ff92a92e5b2be045$var$logError = (type, m, extra)=>{
    const { message: message, path: path, queryName: queryName, statusCode: statusCode, errorType: errorType, errorName: errorName, hash: hash } = extra;
    const params = {
        message: message || '',
        path: JSON.stringify(path || []),
        statusCode: String(statusCode || '[unknown]'),
        queryName: queryName,
        errorType: errorType ? String(errorType) : '',
        errorName: errorName ? String(errorName) : '',
        hash: hash
    };
    return (0, $gUUjF.default).safeErrorWithoutCustomerData(type, m, params);
};
const $ff92a92e5b2be045$var$SwagErrorPlaceholder = '[errors in SWAG response]';
const $ff92a92e5b2be045$export$2c9c775c9aa1863d = (path, statusCode, queryName, errorType)=>$ff92a92e5b2be045$var$logError('apollo.swag.error.graphql', '[GraphQL error]', {
        message: $ff92a92e5b2be045$var$SwagErrorPlaceholder,
        path: path,
        statusCode: statusCode,
        queryName: queryName,
        errorType: errorType
    });
const $ff92a92e5b2be045$export$45c096492076b53a = (networkError, statusCode, queryName)=>{
    $ff92a92e5b2be045$var$logError('apollo.swag.error.network', '[Network error]', {
        message: `[Network error]: ${networkError}`,
        statusCode: statusCode,
        queryName: queryName
    });
};
const $ff92a92e5b2be045$export$9a40393cdc64dc7d = (path, statusCode, queryName, errorType)=>{
    $ff92a92e5b2be045$var$logError('rest.swag.error.graphql', '[GraphQL error]', {
        message: $ff92a92e5b2be045$var$SwagErrorPlaceholder,
        path: path,
        statusCode: statusCode,
        queryName: queryName,
        errorType: errorType
    });
};
const $ff92a92e5b2be045$export$b2eb9fe68368f77d = (networkError, statusCode, queryName, errorName, hash)=>{
    $ff92a92e5b2be045$var$logError('rest.swag.error.network', '[Network error]', {
        message: `[Network error]: ${networkError}`,
        statusCode: statusCode,
        queryName: queryName,
        errorName: errorName,
        hash: hash
    });
};
const $ff92a92e5b2be045$export$25d52be9f4671e9e = (error, queryName)=>{
    $ff92a92e5b2be045$var$logError('rest.swag.error.parsing', '[Parsing error]', {
        message: `[Parsing error]: ${error}`,
        queryName: queryName
    });
};
const $ff92a92e5b2be045$export$e8ce08d55ac713ef = ({ queryName: queryName, statusCode: statusCode, isRetrySuccessful: isRetrySuccessful, retryStatusCode: retryStatusCode })=>(0, $gUUjF.default).safeErrorWithoutCustomerData('rest.swag.retry', '[Retry]', {
        queryName: queryName,
        statusCode: statusCode || '',
        isRetrySuccessful: String(isRetrySuccessful),
        retryStatusCode: retryStatusCode || ''
    });
const $ff92a92e5b2be045$export$3e50530825dee9d1 = ({ queryName: queryName, statusCode: statusCode })=>(0, $gUUjF.default).safeErrorWithoutCustomerData('apollo.swag.retry', '[Retry]', {
        queryName: queryName,
        statusCode: statusCode
    });

});

parcelRegister("aXA7t", function(module, exports) {

$parcel$export(module.exports, "UFOLoggerLink", () => $2f1700194c3d8ae8$export$fb326ed954631f3f);

var $bvQX6 = parcelRequire("bvQX6");

var $fVaJL = parcelRequire("fVaJL");
const $2f1700194c3d8ae8$export$fb326ed954631f3f = new (0, $bvQX6.ApolloLink)((operation, forward)=>{
    const networkStart = performance.now();
    return forward(operation).map((response)=>{
        const networkComplete = performance.now();
        const operationName = operation.operationName ?? 'unnamed';
        (0, $fVaJL.addSpanToAll)('graphql', operationName, [
            {
                name: 'network'
            }
        ], networkStart, networkComplete);
        return response;
    });
});

});

parcelRegister("277yk", function(module, exports) {
module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"Admin\",\"possibleTypes\":[{\"name\":\"JiraGroup\"},{\"name\":\"JiraUser\"}]},{\"kind\":\"UNION\",\"name\":\"BoardFeatureView\",\"possibleTypes\":[{\"name\":\"BasicBoardFeatureView\"},{\"name\":\"EstimationBoardFeatureView\"}]},{\"kind\":\"UNION\",\"name\":\"BoardLocation\",\"possibleTypes\":[{\"name\":\"Project\"},{\"name\":\"UserLocation\"}]}]}}");

});

parcelRegister("9ypom", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f4afc5439e22f0a$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $6ds0g = parcelRequire("6ds0g");
var $6f4afc5439e22f0a$var$docCache = new Map();
var $6f4afc5439e22f0a$var$fragmentSourceMap = new Map();
var $6f4afc5439e22f0a$var$printFragmentWarnings = true;
var $6f4afc5439e22f0a$var$experimentalFragmentVariables = false;
function $6f4afc5439e22f0a$var$normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function $6f4afc5439e22f0a$var$cacheKeyFromLoc(loc) {
    return $6f4afc5439e22f0a$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $6f4afc5439e22f0a$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $6f4afc5439e22f0a$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $6f4afc5439e22f0a$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($6f4afc5439e22f0a$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $6f4afc5439e22f0a$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, ast), {
        definitions: definitions
    });
}
function $6f4afc5439e22f0a$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === 'object') workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $6f4afc5439e22f0a$var$parseDocument(source) {
    var cacheKey = $6f4afc5439e22f0a$var$normalize(source);
    if (!$6f4afc5439e22f0a$var$docCache.has(cacheKey)) {
        var parsed = (0, $6ds0g.parse)(source, {
            experimentalFragmentVariables: $6f4afc5439e22f0a$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $6f4afc5439e22f0a$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') throw new Error('Not a valid GraphQL document.');
        $6f4afc5439e22f0a$var$docCache.set(cacheKey, $6f4afc5439e22f0a$var$stripLoc($6f4afc5439e22f0a$var$processFragments(parsed)));
    }
    return $6f4afc5439e22f0a$var$docCache.get(cacheKey);
}
function $6f4afc5439e22f0a$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === 'string') literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === 'Document') result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $6f4afc5439e22f0a$var$parseDocument(result);
}
function $6f4afc5439e22f0a$export$657554ef4dc7ac2d() {
    $6f4afc5439e22f0a$var$docCache.clear();
    $6f4afc5439e22f0a$var$fragmentSourceMap.clear();
}
function $6f4afc5439e22f0a$export$e4294e638636c6ab() {
    $6f4afc5439e22f0a$var$printFragmentWarnings = false;
}
function $6f4afc5439e22f0a$export$78cf889af350c840() {
    $6f4afc5439e22f0a$var$experimentalFragmentVariables = true;
}
function $6f4afc5439e22f0a$export$5290df9bbbd3cfa() {
    $6f4afc5439e22f0a$var$experimentalFragmentVariables = false;
}
var $6f4afc5439e22f0a$var$extras = {
    gql: $6f4afc5439e22f0a$export$72e4926bf8358653,
    resetCaches: $6f4afc5439e22f0a$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $6f4afc5439e22f0a$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $6f4afc5439e22f0a$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $6f4afc5439e22f0a$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $6f4afc5439e22f0a$var$extras.gql, gql_1.resetCaches = $6f4afc5439e22f0a$var$extras.resetCaches, gql_1.disableFragmentWarnings = $6f4afc5439e22f0a$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $6f4afc5439e22f0a$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $6f4afc5439e22f0a$var$extras.disableExperimentalFragmentVariables;
})($6f4afc5439e22f0a$export$72e4926bf8358653 || ($6f4afc5439e22f0a$export$72e4926bf8358653 = {}));
$6f4afc5439e22f0a$export$72e4926bf8358653["default"] = $6f4afc5439e22f0a$export$72e4926bf8358653;
var $6f4afc5439e22f0a$export$2e2bcd8739ae039 = $6f4afc5439e22f0a$export$72e4926bf8358653;

});
parcelRegister("6ds0g", function(module, exports) {

$parcel$export(module.exports, "parse", () => $d396d90054ce02d1$export$98e6a39c04603d36);
$parcel$export(module.exports, "parseValue", () => $d396d90054ce02d1$export$5303528d1070ff6f);

var $l48s6 = parcelRequire("l48s6");

var $1c4hI = parcelRequire("1c4hI");

var $c8MIO = parcelRequire("c8MIO");

var $hFu5F = parcelRequire("hFu5F");

var $7vqrl = parcelRequire("7vqrl");

var $5hGV7 = parcelRequire("5hGV7");

var $b5rqB = parcelRequire("b5rqB");
function $d396d90054ce02d1$export$98e6a39c04603d36(source, options) {
    var parser = new $d396d90054ce02d1$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $d396d90054ce02d1$export$5303528d1070ff6f(source, options) {
    var parser = new $d396d90054ce02d1$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $hFu5F.TokenKind).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $hFu5F.TokenKind).EOF);
    return value;
}
function $d396d90054ce02d1$export$28b8f402ccc88182(source, options) {
    var parser = new $d396d90054ce02d1$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $hFu5F.TokenKind).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $hFu5F.TokenKind).EOF);
    return type;
}
var $d396d90054ce02d1$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, $7vqrl.isSource)(source) ? source : new (0, $7vqrl.Source)(source);
        this._lexer = new (0, $b5rqB.Lexer)(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, $hFu5F.TokenKind).NAME);
        return {
            kind: (0, $1c4hI.Kind).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
     /**
   * Document : Definition+
   */ ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).DOCUMENT,
            definitions: this.many((0, $hFu5F.TokenKind).SOF, this.parseDefinition, (0, $hFu5F.TokenKind).EOF),
            loc: this.loc(start)
        };
    } /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */ ;
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, $hFu5F.TokenKind).NAME)) switch(this._lexer.token.value){
            case 'query':
            case 'mutation':
            case 'subscription':
                return this.parseOperationDefinition();
            case 'fragment':
                return this.parseFragmentDefinition();
            case 'schema':
            case 'scalar':
            case 'type':
            case 'interface':
            case 'union':
            case 'enum':
            case 'input':
            case 'directive':
                return this.parseTypeSystemDefinition();
            case 'extend':
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, $hFu5F.TokenKind).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
     /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, $hFu5F.TokenKind).BRACE_L)) return {
            kind: (0, $1c4hI.Kind).OPERATION_DEFINITION,
            operation: 'query',
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, $hFu5F.TokenKind).NAME)) name = this.parseName();
        return {
            kind: (0, $1c4hI.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * OperationType : one of query mutation subscription
   */ ;
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, $hFu5F.TokenKind).NAME);
        switch(operationToken.value){
            case 'query':
                return 'query';
            case 'mutation':
                return 'mutation';
            case 'subscription':
                return 'subscription';
        }
        throw this.unexpected(operationToken);
    } /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ ;
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, $hFu5F.TokenKind).PAREN_L, this.parseVariableDefinition, (0, $hFu5F.TokenKind).PAREN_R);
    } /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $hFu5F.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $hFu5F.TokenKind).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    } /**
   * Variable : $ Name
   */ ;
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, $hFu5F.TokenKind).DOLLAR);
        return {
            kind: (0, $1c4hI.Kind).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } /**
   * SelectionSet : { Selection+ }
   */ ;
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).SELECTION_SET,
            selections: this.many((0, $hFu5F.TokenKind).BRACE_L, this.parseSelection, (0, $hFu5F.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ ;
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, $hFu5F.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    } /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ ;
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, $hFu5F.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, $1c4hI.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $hFu5F.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    } /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ ;
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $hFu5F.TokenKind).PAREN_L, item, (0, $hFu5F.TokenKind).PAREN_R);
    } /**
   * Argument[Const] : Name : Value[?Const]
   */ ;
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        return {
            kind: (0, $1c4hI.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, $hFu5F.TokenKind).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
     /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, $hFu5F.TokenKind).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $hFu5F.TokenKind).NAME)) return {
            kind: (0, $1c4hI.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, $1c4hI.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ ;
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: (0, $1c4hI.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, $1c4hI.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentName : Name but not `on`
   */ ;
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
     /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, $hFu5F.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, $hFu5F.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, $hFu5F.TokenKind).INT:
                this._lexer.advance();
                return {
                    kind: (0, $1c4hI.Kind).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $hFu5F.TokenKind).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, $1c4hI.Kind).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $hFu5F.TokenKind).STRING:
            case (0, $hFu5F.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $hFu5F.TokenKind).NAME:
                this._lexer.advance();
                switch(token.value){
                    case 'true':
                        return {
                            kind: (0, $1c4hI.Kind).BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case 'false':
                        return {
                            kind: (0, $1c4hI.Kind).BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case 'null':
                        return {
                            kind: (0, $1c4hI.Kind).NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: (0, $1c4hI.Kind).ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case (0, $hFu5F.TokenKind).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, $1c4hI.Kind).STRING,
            value: token.value,
            block: token.kind === (0, $hFu5F.TokenKind).BLOCK_STRING,
            loc: this.loc(token)
        };
    } /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ ;
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, $1c4hI.Kind).LIST,
            values: this.any((0, $hFu5F.TokenKind).BRACKET_L, item, (0, $hFu5F.TokenKind).BRACKET_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */ ;
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, $1c4hI.Kind).OBJECT,
            fields: this.any((0, $hFu5F.TokenKind).BRACE_L, item, (0, $hFu5F.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectField[Const] : Name : Value[?Const]
   */ ;
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        return {
            kind: (0, $1c4hI.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
     /**
   * Directives[Const] : Directive[?Const]+
   */ ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, $hFu5F.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    } /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */ ;
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, $hFu5F.TokenKind).AT);
        return {
            kind: (0, $1c4hI.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
     /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, $hFu5F.TokenKind).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, $hFu5F.TokenKind).BRACKET_R);
            type = {
                kind: (0, $1c4hI.Kind).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $hFu5F.TokenKind).BANG)) return {
            kind: (0, $1c4hI.Kind).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    } /**
   * NamedType : Name
   */ ;
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
     /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $hFu5F.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaDefinition();
            case 'scalar':
                return this.parseScalarTypeDefinition();
            case 'type':
                return this.parseObjectTypeDefinition();
            case 'interface':
                return this.parseInterfaceTypeDefinition();
            case 'union':
                return this.parseUnionTypeDefinition();
            case 'enum':
                return this.parseEnumTypeDefinition();
            case 'input':
                return this.parseInputObjectTypeDefinition();
            case 'directive':
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, $hFu5F.TokenKind).STRING) || this.peek((0, $hFu5F.TokenKind).BLOCK_STRING);
    } /**
   * Description : StringValue
   */ ;
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    } /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */ ;
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, $hFu5F.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $hFu5F.TokenKind).BRACE_R);
        return {
            kind: (0, $1c4hI.Kind).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * OperationTypeDefinition : OperationType : NamedType
   */ ;
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, $1c4hI.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ ;
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $1c4hI.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $1c4hI.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ ;
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword('implements')) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken((0, $hFu5F.TokenKind).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $hFu5F.TokenKind).AMP) || this.peek((0, $hFu5F.TokenKind).NAME));
            return types;
        }
        return this.delimitedMany((0, $hFu5F.TokenKind).AMP, this.parseNamedType);
    } /**
   * FieldsDefinition : { FieldDefinition+ }
   */ ;
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, $hFu5F.TokenKind).BRACE_L) && this._lexer.lookahead().kind === (0, $hFu5F.TokenKind).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, $hFu5F.TokenKind).BRACE_L, this.parseFieldDefinition, (0, $hFu5F.TokenKind).BRACE_R);
    } /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ ;
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $1c4hI.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ ;
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, $hFu5F.TokenKind).PAREN_L, this.parseInputValueDef, (0, $hFu5F.TokenKind).PAREN_R);
    } /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, $hFu5F.TokenKind).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $1c4hI.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $1c4hI.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ ;
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, $1c4hI.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ ;
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $hFu5F.TokenKind).EQUALS) ? this.delimitedMany((0, $hFu5F.TokenKind).PIPE, this.parseNamedType) : [];
    } /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ ;
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, $1c4hI.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */ ;
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, $hFu5F.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, $hFu5F.TokenKind).BRACE_R);
    } /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */ ;
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $1c4hI.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ ;
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */ ;
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, $hFu5F.TokenKind).BRACE_L, this.parseInputValueDef, (0, $hFu5F.TokenKind).BRACE_R);
    } /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $hFu5F.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    } /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */ ;
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, $hFu5F.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $hFu5F.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ ;
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ ;
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ ;
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ ;
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ ;
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ ;
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */ ;
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $hFu5F.TokenKind).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, $1c4hI.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    } /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ ;
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany((0, $hFu5F.TokenKind).PIPE, this.parseDirectiveLocation);
    } /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ ;
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, $5hGV7.DirectiveLocation)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
     /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */ ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, $c8MIO.Location)(startToken, this._lexer.lastToken, this._lexer.source);
    } /**
   * Determines if the next token is of a given kind
   */ ;
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $l48s6.syntaxError)(this._lexer.source, token.start, "Expected ".concat($d396d90054ce02d1$var$getTokenKindDesc(kind), ", found ").concat($d396d90054ce02d1$var$getTokenDesc(token), "."));
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */ ;
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    } /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $hFu5F.TokenKind).NAME && token.value === value) this._lexer.advance();
        else throw (0, $l48s6.syntaxError)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat($d396d90054ce02d1$var$getTokenDesc(token), "."));
    } /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ ;
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $hFu5F.TokenKind).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    } /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ ;
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $l48s6.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat($d396d90054ce02d1$var$getTokenDesc(token), "."));
    } /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    } /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ ;
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ function $d396d90054ce02d1$var$getTokenDesc(token) {
    var value = token.value;
    return $d396d90054ce02d1$var$getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $d396d90054ce02d1$var$getTokenKindDesc(kind) {
    return (0, $b5rqB.isPunctuatorTokenKind)(kind) ? "\"".concat(kind, "\"") : kind;
}

});
parcelRegister("l48s6", function(module, exports) {

$parcel$export(module.exports, "syntaxError", () => $6cdd0c9c097dfc31$export$bbee0c6176c019d4);

var $9fgMZ = parcelRequire("9fgMZ");
function $6cdd0c9c097dfc31$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $9fgMZ.GraphQLError)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}

});
parcelRegister("9fgMZ", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", () => $20ec348cfe64bfcc$export$92d6ed0888e7cb7f);

var $fbtyx = parcelRequire("fbtyx");

var $gwa3m = parcelRequire("gwa3m");

var $cBRMW = parcelRequire("cBRMW");

var $5LGuP = parcelRequire("5LGuP");
function $20ec348cfe64bfcc$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $20ec348cfe64bfcc$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $20ec348cfe64bfcc$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $20ec348cfe64bfcc$var$_typeof(obj);
}
function $20ec348cfe64bfcc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $20ec348cfe64bfcc$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $20ec348cfe64bfcc$var$ownKeys(Object(source), true).forEach(function(key) {
            $20ec348cfe64bfcc$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $20ec348cfe64bfcc$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $20ec348cfe64bfcc$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $20ec348cfe64bfcc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $20ec348cfe64bfcc$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $20ec348cfe64bfcc$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $20ec348cfe64bfcc$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $20ec348cfe64bfcc$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $20ec348cfe64bfcc$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $20ec348cfe64bfcc$var$_setPrototypeOf(subClass, superClass);
}
function $20ec348cfe64bfcc$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $20ec348cfe64bfcc$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $20ec348cfe64bfcc$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $20ec348cfe64bfcc$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $20ec348cfe64bfcc$var$_possibleConstructorReturn(this, result);
    };
}
function $20ec348cfe64bfcc$var$_possibleConstructorReturn(self, call) {
    if (call && ($20ec348cfe64bfcc$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $20ec348cfe64bfcc$var$_assertThisInitialized(self);
}
function $20ec348cfe64bfcc$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $20ec348cfe64bfcc$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $20ec348cfe64bfcc$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$20ec348cfe64bfcc$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $20ec348cfe64bfcc$var$_construct(Class, arguments, $20ec348cfe64bfcc$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $20ec348cfe64bfcc$var$_setPrototypeOf(Wrapper, Class);
    };
    return $20ec348cfe64bfcc$var$_wrapNativeSuper(Class);
}
function $20ec348cfe64bfcc$var$_construct(Parent, args, Class) {
    if ($20ec348cfe64bfcc$var$_isNativeReflectConstruct()) $20ec348cfe64bfcc$var$_construct = Reflect.construct;
    else $20ec348cfe64bfcc$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $20ec348cfe64bfcc$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $20ec348cfe64bfcc$var$_construct.apply(null, arguments);
}
function $20ec348cfe64bfcc$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $20ec348cfe64bfcc$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $20ec348cfe64bfcc$var$_setPrototypeOf(o, p) {
    $20ec348cfe64bfcc$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $20ec348cfe64bfcc$var$_setPrototypeOf(o, p);
}
function $20ec348cfe64bfcc$var$_getPrototypeOf(o) {
    $20ec348cfe64bfcc$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $20ec348cfe64bfcc$var$_getPrototypeOf(o);
}
var $20ec348cfe64bfcc$export$92d6ed0888e7cb7f = /*#__PURE__*/ function(_Error) {
    $20ec348cfe64bfcc$var$_inherits(GraphQLError, _Error);
    var _super = $20ec348cfe64bfcc$var$_createSuper(GraphQLError);
    /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodeLocations, _nodeLocations2, _nodeLocations3;
        var _this;
        $20ec348cfe64bfcc$var$_classCallCheck(this, GraphQLError);
        _this = _super.call(this, message);
        _this.name = 'GraphQLError';
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = $20ec348cfe64bfcc$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = [];
        for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
            var _this$nodes;
            var _ref4 = _ref3[_i2];
            var loc = _ref4.loc;
            if (loc != null) nodeLocations.push(loc);
        }
        nodeLocations = $20ec348cfe64bfcc$var$undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
        _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, $cBRMW.getLocation)(source, pos);
        }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
            return (0, $cBRMW.getLocation)(loc.source, loc.start);
        });
        _this.path = path !== null && path !== void 0 ? path : undefined;
        var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
        if (extensions == null && (0, $fbtyx.default)(originalExtensions)) _this.extensions = $20ec348cfe64bfcc$var$_objectSpread({}, originalExtensions);
        else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
         // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
        // This ensures that the simplest possible GraphQL service adheres to the spec.
        Object.defineProperties($20ec348cfe64bfcc$var$_assertThisInitialized(_this), {
            message: {
                enumerable: true
            },
            locations: {
                enumerable: _this.locations != null
            },
            path: {
                enumerable: _this.path != null
            },
            extensions: {
                enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty($20ec348cfe64bfcc$var$_assertThisInitialized(_this), 'stack', {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return $20ec348cfe64bfcc$var$_possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace($20ec348cfe64bfcc$var$_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty($20ec348cfe64bfcc$var$_assertThisInitialized(_this), 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    $20ec348cfe64bfcc$var$_createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return $20ec348cfe64bfcc$export$55ee1551a3f962e6(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Object';
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ $20ec348cfe64bfcc$var$_wrapNativeSuper(Error));
function $20ec348cfe64bfcc$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $20ec348cfe64bfcc$export$55ee1551a3f962e6(error) {
    var output = error.message;
    if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
        var node = _error$nodes2[_i4];
        if (node.loc) output += '\n\n' + (0, $5LGuP.printLocation)(node.loc);
    }
    else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
        var location = _error$locations2[_i6];
        output += '\n\n' + (0, $5LGuP.printSourceLocation)(error.source, location);
    }
    return output;
}

});
parcelRegister("fbtyx", function(module, exports) {

$parcel$export(module.exports, "default", () => $700b00a777571467$export$2e2bcd8739ae039);
function $700b00a777571467$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $700b00a777571467$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $700b00a777571467$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $700b00a777571467$var$_typeof(obj);
}
function $700b00a777571467$export$2e2bcd8739ae039(value) {
    return $700b00a777571467$var$_typeof(value) == 'object' && value !== null;
}

});

parcelRegister("gwa3m", function(module, exports) {

$parcel$export(module.exports, "SYMBOL_ITERATOR", () => $84dde8096e41b064$export$f6cdee3c26d6da57);
$parcel$export(module.exports, "SYMBOL_ASYNC_ITERATOR", () => $84dde8096e41b064$export$8d0083df0471478e);
$parcel$export(module.exports, "SYMBOL_TO_STRING_TAG", () => $84dde8096e41b064$export$5deadc579ccc7c9c);
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $84dde8096e41b064$export$f6cdee3c26d6da57 = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $84dde8096e41b064$export$8d0083df0471478e = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $84dde8096e41b064$export$5deadc579ccc7c9c = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';

});

parcelRegister("cBRMW", function(module, exports) {

$parcel$export(module.exports, "getLocation", () => $d7d707e8e9ee9fd6$export$e7fd20fad3cf4b5f);
/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $d7d707e8e9ee9fd6$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

});

parcelRegister("5LGuP", function(module, exports) {

$parcel$export(module.exports, "printLocation", () => $66f0d94dee1ae1b2$export$96a9681e539deed);
$parcel$export(module.exports, "printSourceLocation", () => $66f0d94dee1ae1b2$export$867940333fd9f869);

var $cBRMW = parcelRequire("cBRMW");
function $66f0d94dee1ae1b2$export$96a9681e539deed(location) {
    return $66f0d94dee1ae1b2$export$867940333fd9f869(location.source, (0, $cBRMW.getLocation)(location.source, location.start));
}
function $66f0d94dee1ae1b2$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $66f0d94dee1ae1b2$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $66f0d94dee1ae1b2$var$printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                '',
                subLine
            ];
        }), [
            [
                ' ',
                $66f0d94dee1ae1b2$var$whitespace(subLineColumnNum - 1) + '^'
            ],
            [
                '',
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + $66f0d94dee1ae1b2$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            '',
            $66f0d94dee1ae1b2$var$whitespace(columnNum - 1) + '^'
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $66f0d94dee1ae1b2$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $66f0d94dee1ae1b2$var$leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
    }).join('\n');
}
function $66f0d94dee1ae1b2$var$whitespace(len) {
    return Array(len + 1).join(' ');
}
function $66f0d94dee1ae1b2$var$leftPad(len, str) {
    return $66f0d94dee1ae1b2$var$whitespace(len - str.length) + str;
}

});



parcelRegister("1c4hI", function(module, exports) {

$parcel$export(module.exports, "Kind", () => $1bf9b417a1cf9d08$export$a84bdc57c5122798);
/**
 * The set of allowed kind values for AST nodes.
 */ var $1bf9b417a1cf9d08$export$a84bdc57c5122798 = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 

});

parcelRegister("hFu5F", function(module, exports) {

$parcel$export(module.exports, "TokenKind", () => $7350b511ab98151f$export$8b9d26ab11394711);
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $7350b511ab98151f$export$8b9d26ab11394711 = Object.freeze({
    SOF: '<SOF>',
    EOF: '<EOF>',
    BANG: '!',
    DOLLAR: '$',
    AMP: '&',
    PAREN_L: '(',
    PAREN_R: ')',
    SPREAD: '...',
    COLON: ':',
    EQUALS: '=',
    AT: '@',
    BRACKET_L: '[',
    BRACKET_R: ']',
    BRACE_L: '{',
    PIPE: '|',
    BRACE_R: '}',
    NAME: 'Name',
    INT: 'Int',
    FLOAT: 'Float',
    STRING: 'String',
    BLOCK_STRING: 'BlockString',
    COMMENT: 'Comment'
}); /**
 * The enum type representing the token kinds values.
 */ 

});

parcelRegister("7vqrl", function(module, exports) {

$parcel$export(module.exports, "Source", () => $0269dc101dba4337$export$1d2df86270c81ecb);
$parcel$export(module.exports, "isSource", () => $0269dc101dba4337$export$75135ee9ed6e435b);

var $gwa3m = parcelRequire("gwa3m");

var $biK02 = parcelRequire("biK02");

var $fZdRY = parcelRequire("fZdRY");

var $aVhwC = parcelRequire("aVhwC");
function $0269dc101dba4337$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $0269dc101dba4337$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0269dc101dba4337$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0269dc101dba4337$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $0269dc101dba4337$export$1d2df86270c81ecb = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === 'string' || (0, $fZdRY.default)(0, "Body must be a string. Received: ".concat((0, $biK02.default)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $fZdRY.default)(0, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $fZdRY.default)(0, 'column in locationOffset is 1-indexed and must be positive.');
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    $0269dc101dba4337$var$_createClass(Source, [
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Source';
            }
        }
    ]);
    return Source;
}();
function $0269dc101dba4337$export$75135ee9ed6e435b(source) {
    return (0, $aVhwC.default)(source, $0269dc101dba4337$export$1d2df86270c81ecb);
}

});
parcelRegister("fZdRY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b04eb23f905f9ab5$export$2e2bcd8739ae039);
function $b04eb23f905f9ab5$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("aVhwC", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef14998e21195a05$export$2e2bcd8739ae039);

function $ef14998e21195a05$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ef14998e21195a05$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $ef14998e21195a05$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ef14998e21195a05$var$_typeof(obj);
}
var /**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */ // See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
$ef14998e21195a05$export$2e2bcd8739ae039 = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
    return value instanceof constructor;
};

});


parcelRegister("5hGV7", function(module, exports) {

$parcel$export(module.exports, "DirectiveLocation", () => $d7161a38006ba9b3$export$b45ffd2948484c41);
/**
 * The set of allowed directive location values.
 */ var $d7161a38006ba9b3$export$b45ffd2948484c41 = Object.freeze({
    // Request Definitions
    QUERY: 'QUERY',
    MUTATION: 'MUTATION',
    SUBSCRIPTION: 'SUBSCRIPTION',
    FIELD: 'FIELD',
    FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
    FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
    INLINE_FRAGMENT: 'INLINE_FRAGMENT',
    VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
    // Type System Definitions
    SCHEMA: 'SCHEMA',
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    FIELD_DEFINITION: 'FIELD_DEFINITION',
    ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    ENUM_VALUE: 'ENUM_VALUE',
    INPUT_OBJECT: 'INPUT_OBJECT',
    INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
}); /**
 * The enum type representing the directive location values.
 */ 

});

parcelRegister("b5rqB", function(module, exports) {

$parcel$export(module.exports, "Lexer", () => $a5d33b5906ae43cc$export$6168dc8908a6c652);
$parcel$export(module.exports, "isPunctuatorTokenKind", () => $a5d33b5906ae43cc$export$59ac0f4da287406a);

var $l48s6 = parcelRequire("l48s6");

var $c8MIO = parcelRequire("c8MIO");

var $hFu5F = parcelRequire("hFu5F");

var $flA0a = parcelRequire("flA0a");
var $a5d33b5906ae43cc$export$6168dc8908a6c652 = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    } /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ ;
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== (0, $hFu5F.TokenKind).EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = $a5d33b5906ae43cc$var$readToken(this, token);
        }while (token.kind === (0, $hFu5F.TokenKind).COMMENT);
        return token;
    };
    return Lexer;
}();
function $a5d33b5906ae43cc$export$59ac0f4da287406a(kind) {
    return kind === (0, $hFu5F.TokenKind).BANG || kind === (0, $hFu5F.TokenKind).DOLLAR || kind === (0, $hFu5F.TokenKind).AMP || kind === (0, $hFu5F.TokenKind).PAREN_L || kind === (0, $hFu5F.TokenKind).PAREN_R || kind === (0, $hFu5F.TokenKind).SPREAD || kind === (0, $hFu5F.TokenKind).COLON || kind === (0, $hFu5F.TokenKind).EQUALS || kind === (0, $hFu5F.TokenKind).AT || kind === (0, $hFu5F.TokenKind).BRACKET_L || kind === (0, $hFu5F.TokenKind).BRACKET_R || kind === (0, $hFu5F.TokenKind).BRACE_L || kind === (0, $hFu5F.TokenKind).PIPE || kind === (0, $hFu5F.TokenKind).BRACE_R;
}
function $a5d33b5906ae43cc$var$printCharCode(code) {
    return isNaN(code) ? (0, $hFu5F.TokenKind).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"");
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $a5d33b5906ae43cc$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return $a5d33b5906ae43cc$var$readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $a5d33b5906ae43cc$var$readBlockString(source, pos, _line, _col, prev, lexer);
                return $a5d33b5906ae43cc$var$readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return $a5d33b5906ae43cc$var$readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return $a5d33b5906ae43cc$var$readName(source, pos, _line, _col, prev);
        }
        throw (0, $l48s6.syntaxError)(source, pos, $a5d33b5906ae43cc$var$unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $a5d33b5906ae43cc$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($a5d33b5906ae43cc$var$printCharCode(code), ".");
    if (code === 39) // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
    return "Cannot parse the unexpected character ".concat($a5d33b5906ae43cc$var$printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $a5d33b5906ae43cc$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $a5d33b5906ae43cc$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $l48s6.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
    } else {
        position = $a5d33b5906ae43cc$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $a5d33b5906ae43cc$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $a5d33b5906ae43cc$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || $a5d33b5906ae43cc$var$isNameStart(code)) throw (0, $l48s6.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
    return new (0, $c8MIO.Token)(isFloat ? (0, $hFu5F.TokenKind).FLOAT : (0, $hFu5F.TokenKind).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $a5d33b5906ae43cc$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $l48s6.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $a5d33b5906ae43cc$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $l48s6.syntaxError)(source, position, "Invalid character within String: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += '/';
                    break;
                case 92:
                    value += '\\';
                    break;
                case 98:
                    value += '\b';
                    break;
                case 102:
                    value += '\f';
                    break;
                case 110:
                    value += '\n';
                    break;
                case 114:
                    value += '\r';
                    break;
                case 116:
                    value += '\t';
                    break;
                case 117:
                    // uXXXX
                    var charCode = $a5d33b5906ae43cc$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $l48s6.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $l48s6.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $l48s6.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $a5d33b5906ae43cc$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BLOCK_STRING, start, position + 3, line, col, prev, (0, $flA0a.dedentBlockStringValue)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $l48s6.syntaxError)(source, position, "Invalid character within String: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $l48s6.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $a5d33b5906ae43cc$var$uniCharCode(a, b, c, d) {
    return $a5d33b5906ae43cc$var$char2hex(a) << 12 | $a5d33b5906ae43cc$var$char2hex(b) << 8 | $a5d33b5906ae43cc$var$char2hex(c) << 4 | $a5d33b5906ae43cc$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $a5d33b5906ae43cc$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $a5d33b5906ae43cc$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function $a5d33b5906ae43cc$var$isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

});



parcelRegister("dYexY", function(module, exports) {

$parcel$export(module.exports, "FlagFromError", () => $716d88be84ddab45$export$cdf31994a253e80);

var $eUqFw = parcelRequire("eUqFw");

var $izafr = parcelRequire("izafr");

var $2emZ8 = parcelRequire("2emZ8");
const $716d88be84ddab45$export$cdf31994a253e80 = ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izafr.FlagRenderer), {
        flag: (0, $2emZ8.getErrorFlag)(error)
    });

});
parcelRegister("izafr", function(module, exports) {

$parcel$export(module.exports, "FlagRenderer", () => $e43c89914c6fc6a2$export$7c38ebd1f7ca6a5a);

var $gf6nQ = parcelRequire("gf6nQ");

var $5oIBC = parcelRequire("5oIBC");
const $e43c89914c6fc6a2$export$7c38ebd1f7ca6a5a = (0, $5oIBC.default)((0, $gf6nQ.default));

});
parcelRegister("gf6nQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7eec4e9461c786a4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8vPhU = parcelRequire("8vPhU");
class $7eec4e9461c786a4$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { flagService: flagService, flag: flag } = this.props;
        if (flagService) this.flagId = flagService.showFlag(flag);
    }
    componentWillUnmount() {
        const { flagService: flagService } = this.props;
        if (flagService && this.flagId) flagService.dismissFlag((0, $8vPhU.dismissFlag)(this.flagId));
    }
    render() {
        return null;
    }
}

});




parcelRegister("cA8OV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0809371ccd3c77a9$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

var $c9TLT = parcelRequire("c9TLT");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any,  @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
$0809371ccd3c77a9$export$2e2bcd8739ae039 = (0, $kwce8.default).div.withConfig({
    componentId: "h5xpn2-0"
})({
    fontFamily: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $c9TLT.fontFamily,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: `${(0, $c9TLT.fontSize)}px`,
    height: 'inherit',
    letterSpacing: 'normal'
});

});

parcelRegister("bQQi1", function(module, exports) {

$parcel$export(module.exports, "disposableEpic", () => $669b2126028ef686$export$e6b812e492b046b8);
parcelRequire("5hZYM");

const $669b2126028ef686$export$e6b812e492b046b8 = (rootEpic)=>(action$, store, dependencies)=>rootEpic(action$, store, dependencies).takeUntil(action$.ofType((0, $4f32d292c46e5882$export$58387e80544dbf03)));

});
const $4f32d292c46e5882$export$58387e80544dbf03 = 'COMMON/REDUX_DISPOSABLE/DISPOSE_ACTION';


parcelRegister("4B7EY", function(module, exports) {

$parcel$export(module.exports, "DISPOSE_ACTION", () => $fcece09efe01c906$export$78be82e7e063a3fb);


var $bQQi1 = parcelRequire("bQQi1");

const $fcece09efe01c906$export$78be82e7e063a3fb = {
    type: (0, $4f32d292c46e5882$export$58387e80544dbf03)
};

});

parcelRegister("aFvYX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f24f9d4e9538bf7e$export$2e2bcd8739ae039);

var $5NVi6 = parcelRequire("5NVi6");
var /**
 * Shallow equal using '===' comparison and one-level array checks.
 *
 * WARNING: This is not a true shallow equal, use @atlassian/jira-platform-shallow-equal.
 *
 * @see {@link http://go.atlassian.com/shallow-equal}
 *
 * @param {*} obj1
 * @param {*} obj2
 * @returns {boolean}
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$f24f9d4e9538bf7e$export$2e2bcd8739ae039 = (obj1, obj2)=>{
    if (obj1 === obj2) return true;
    if (!obj1 || !obj2) return false;
    const item1Keys = Object.keys(obj1).sort();
    const item2Keys = Object.keys(obj2).sort();
    // are keys equal?
    if (!(0, $5NVi6.default)(item1Keys, item2Keys)) return false;
    // are the values equal?
    const areValuesEqual = item2Keys.every((key)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const value = obj1[key];
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const nextValue = obj2[key];
        if (value === nextValue) return true;
        return Array.isArray(nextValue) && Array.isArray(value) && (0, $5NVi6.default)(value, nextValue);
    });
    return areValuesEqual;
};

});
parcelRegister("5NVi6", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e4109ba822744d4$export$2e2bcd8739ae039);
/**
 * Returns true if the two given arrays are equal one level deep
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
var $8e4109ba822744d4$export$2e2bcd8739ae039 = (array1 = [], array2 = [])=>{
    // @ts-expect-error - This comparison appears to be unintentional because the types 'readonly T[]' and 'readonly U[]' have no overlap.
    if (array1 === array2) return true;
    // check one level deep
    // @ts-expect-error - This comparison appears to be unintentional because the types 'T' and 'U' have no overlap.
    return array1.length === array2.length && array1.every((item, index)=>item === array2[index]);
};

});


parcelRegister("9m9bG", function(module, exports) {

$parcel$export(module.exports, "FlagsDispatcher", () => $002bf7125eab9f2d$export$9e60e3d40b6e758f);

var $eUqFw = parcelRequire("eUqFw");

var $k8Qyf = parcelRequire("k8Qyf");

var $9IFOX = parcelRequire("9IFOX");
const $002bf7125eab9f2d$export$9e60e3d40b6e758f = ({ store: store, mapper: mapper })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9IFOX.Dispatcher), {
        store: store,
        mapper: mapper,
        showFlag: (0, $k8Qyf.showFlag),
        dismissFlag: (0, $k8Qyf.dismissFlag)
    });

});
parcelRegister("9IFOX", function(module, exports) {

$parcel$export(module.exports, "Dispatcher", () => $d0a959626f60d440$export$ab054a1ef92eeb01);

var $eUqFw = parcelRequire("eUqFw");

var $6Yzg9 = parcelRequire("6Yzg9");
const $d0a959626f60d440$export$ab054a1ef92eeb01 = (props)=>{
    const { store: store, ...dispatcherProps } = props;
    const [lastStore, setLastStore] = (0, $eUqFw.useState)(store);
    if (store !== lastStore) setLastStore(store);
    const DispatcherComponent = (0, $eUqFw.useMemo)(()=>(0, $6Yzg9.createDispatcher)(store), [
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DispatcherComponent, dispatcherProps);
};

});
parcelRegister("6Yzg9", function(module, exports) {

$parcel$export(module.exports, "createDispatcher", () => $4432f346a9cf5cd1$export$7b259d28468da15b);

var $eUqFw = parcelRequire("eUqFw");

var $3npQj = parcelRequire("3npQj");

var $k8Qyf = parcelRequire("k8Qyf");
const $4432f346a9cf5cd1$export$81c2f3c810206fa9 = (store)=>{
    if (!store) throw new Error('Store not available through direct injection or Provider context');
    if (!('addActionListener' in store) || !('removeActionListener' in store) || typeof store.addActionListener !== 'function' || typeof store.removeActionListener !== 'function') throw new Error("Your store doesn't support action listeners; please use the Tangerine store initialiser.");
    return store;
};
const $4432f346a9cf5cd1$export$8a44987212de21b = (store, result, showFlag, dismissFlag)=>{
    if (!result) return;
    if ((0, $k8Qyf.isDismissFlag)(result)) dismissFlag(result);
    else if ((0, $k8Qyf.isFlagComponent)(result)) {
        const FlagComponent = result;
        const FlagComponentWithProvider = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3npQj.Provider), {
                store: store
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FlagComponent, props));
        showFlag(FlagComponentWithProvider);
    } else showFlag(result);
};
const $4432f346a9cf5cd1$export$2bedce6f5250e28d = (action, state, store, mapper, showFlag, dismissFlag)=>{
    // handle batch middleware
    if ((0, $k8Qyf.isBatchAction)(action)) action.payload.forEach((childAction)=>{
        if (childAction.type && typeof childAction.type === 'string') {
            const childResult = mapper(childAction, state);
            $4432f346a9cf5cd1$export$8a44987212de21b(store, childResult, showFlag, dismissFlag);
        }
    });
    else {
        const result = mapper(action, state);
        $4432f346a9cf5cd1$export$8a44987212de21b(store, result, showFlag, dismissFlag);
    }
};
const $4432f346a9cf5cd1$var$Dispatcher8 = (props)=>{
    const { store: storeUnchecked, mapper: mapper, showFlag: showFlag, dismissFlag: dismissFlag } = props;
    const store = (0, $eUqFw.useMemo)(()=>$4432f346a9cf5cd1$export$81c2f3c810206fa9(storeUnchecked), [
        storeUnchecked
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const handleAction = (action, state)=>{
            $4432f346a9cf5cd1$export$2bedce6f5250e28d(action, state, store, mapper, showFlag, dismissFlag);
        };
        store.addActionListener(handleAction);
        return ()=>store.removeActionListener(handleAction);
    }, [
        store,
        mapper,
        showFlag,
        dismissFlag
    ]);
    return null;
};
const $4432f346a9cf5cd1$var$Dispatcher8DefaultStore = (props)=>{
    const store = (0, $3npQj.useStore)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4432f346a9cf5cd1$var$Dispatcher8, {
        ...props,
        store: store
    });
};
const $4432f346a9cf5cd1$export$7b259d28468da15b = (customStore)=>{
    const Dispatcher8CustomStore = (props)=>customStore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4432f346a9cf5cd1$var$Dispatcher8, {
            ...props,
            store: customStore
        }) : null;
    return customStore ? Dispatcher8CustomStore : $4432f346a9cf5cd1$var$Dispatcher8DefaultStore;
};

});



parcelRegister("41KUh", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd48e2bae41599d1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $9RVox = parcelRequire("9RVox");
const $bd48e2bae41599d1$var$MemoryObserver = ({ getCustomData: getCustomData })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        const memoryReporter = new (0, $9RVox.PollingMemoryReporter)(createAnalyticsEvent, getCustomData);
        memoryReporter.start();
        memoryReporter.setBucketTimeouts();
        return ()=>{
            memoryReporter.stop();
            memoryReporter.clearBucketTimeouts();
        };
    }, [
        createAnalyticsEvent,
        getCustomData
    ]);
    return null;
};
var $bd48e2bae41599d1$export$2e2bcd8739ae039 = $bd48e2bae41599d1$var$MemoryObserver;

});
parcelRegister("9RVox", function(module, exports) {

$parcel$export(module.exports, "PollingMemoryReporter", () => $8268f4e0a152e9f1$export$3e76404af7b93e06);

var $gUUjF = parcelRequire("gUUjF");

var $jMP2a = parcelRequire("jMP2a");

var $4KQd6 = parcelRequire("4KQd6");

var $8iunV = parcelRequire("8iunV");
const $8268f4e0a152e9f1$var$minMs = 60000; // number of ms in a minute
const $8268f4e0a152e9f1$export$54912f9240c8e5db = 20 * $8268f4e0a152e9f1$var$minMs;
const $8268f4e0a152e9f1$export$9f536c7d89257714 = [
    2 * $8268f4e0a152e9f1$var$minMs,
    10 * $8268f4e0a152e9f1$var$minMs
];
const $8268f4e0a152e9f1$export$c63950c55adb1607 = (createAnalyticsEvent, getCustomData)=>{
    try {
        const memoryUsageReport = (0, $8iunV.getMemoryUsageReport)();
        if (memoryUsageReport == null) return;
        const { sessionTime: sessionTime, performanceMemoryEntry: { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } } = memoryUsageReport;
        const customData = getCustomData ? getCustomData() : {};
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'memory tracked', {
            bucket: (0, $4KQd6.memoryBucketHandler).getBucket(usedJSHeapSize),
            sessionTime: sessionTime,
            sessionTimeBucket: (0, $4KQd6.sessionTimeBucketHandler).getBucket(sessionTime),
            jsHeapSizeLimit: jsHeapSizeLimit,
            totalJSHeapSize: totalJSHeapSize,
            usedJSHeapSize: usedJSHeapSize,
            ...customData
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('observability.memory-metrics.measure-and-report-memory', 'Failed to poll for memory usage');
    }
};
class $8268f4e0a152e9f1$export$3e76404af7b93e06 {
    constructor(createAnalyticsEvent, getCustomData){
        this.pollInterval = null;
        this.bucketTimeouts = null;
        this.report = ()=>{
            $8268f4e0a152e9f1$export$c63950c55adb1607(this.createAnalyticsEvent, this.getCustomData);
        };
        this.onVisibilityChange = ()=>{
            const isHidden = window.document?.hidden === true;
            if (isHidden) this.stop();
            else {
                this.stop();
                this.start();
            }
        };
        this.createAnalyticsEvent = createAnalyticsEvent;
        this.getCustomData = getCustomData;
    }
    start() {
        if (this.pollInterval != null) return;
        this.report();
        // @ts-expect-error - TS2322 - Type 'Timer' is not assignable to type 'number'.
        this.pollInterval = setInterval(()=>{
            if (this.pollInterval == null) return;
            this.report();
        }, $8268f4e0a152e9f1$export$54912f9240c8e5db);
        document.addEventListener('visibilitychange', this.onVisibilityChange);
    }
    stop() {
        if (this.pollInterval != null) {
            clearInterval(this.pollInterval);
            this.pollInterval = null;
        }
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }
    setBucketTimeouts() {
        this.bucketTimeouts = $8268f4e0a152e9f1$export$9f536c7d89257714.map((ms)=>setTimeout(()=>{
                this.report();
            }, ms));
    }
    clearBucketTimeouts() {
        this.bucketTimeouts?.forEach((timeout)=>{
            clearTimeout(timeout);
        });
    }
}

});
parcelRegister("4KQd6", function(module, exports) {

$parcel$export(module.exports, "memoryBucketHandler", () => $96908605e33e1f39$export$26aac2ead17b35e5);
$parcel$export(module.exports, "sessionTimeBucketHandler", () => $96908605e33e1f39$export$af08fe8a31c89520);
class $96908605e33e1f39$export$a9fa854dd2f29162 {
    constructor(buckets, options){
        this.buckets = buckets;
        this.formatLabel = options?.formatLabel ?? ((low, high)=>`${low}-${high ?? 'Inf'}`);
    }
    /**
	 * Returns the lowest matching bucket for this measurement.
	 *
	 * For example, if buckets are [0, 10, 20, 30] and the measurement is 15,
	 * this function will return 10 meaning this measurement is in the 10-20
	 * range.
	 */ getBucket(measurement) {
        const bucketIndex = this.buckets.findIndex((bucket)=>measurement < bucket);
        if (bucketIndex < 0) return this.formatLabel(this.buckets[this.buckets.length - 1]);
        return this.formatLabel(this.buckets[bucketIndex - 1], this.buckets[bucketIndex]);
    }
}
const $96908605e33e1f39$var$mbBytes = 1048576; // number of bytes in a MB
const $96908605e33e1f39$var$minMs = 60000; // number of ms in a minute
const $96908605e33e1f39$export$26aac2ead17b35e5 = new $96908605e33e1f39$export$a9fa854dd2f29162([
    0,
    100 * $96908605e33e1f39$var$mbBytes,
    200 * $96908605e33e1f39$var$mbBytes,
    400 * $96908605e33e1f39$var$mbBytes,
    800 * $96908605e33e1f39$var$mbBytes,
    1600 * $96908605e33e1f39$var$mbBytes,
    3200 * $96908605e33e1f39$var$mbBytes
], {
    formatLabel: (lowBucket, highBucket)=>`${lowBucket / $96908605e33e1f39$var$mbBytes}-${highBucket != null ? highBucket / $96908605e33e1f39$var$mbBytes : 'Inf'}MB`
});
const $96908605e33e1f39$export$af08fe8a31c89520 = new $96908605e33e1f39$export$a9fa854dd2f29162([
    0,
    2 * $96908605e33e1f39$var$minMs,
    5 * $96908605e33e1f39$var$minMs,
    10 * $96908605e33e1f39$var$minMs,
    20 * $96908605e33e1f39$var$minMs
], {
    formatLabel: (lowBucket, highBucket)=>`${lowBucket / $96908605e33e1f39$var$minMs}-${highBucket != null ? highBucket / $96908605e33e1f39$var$minMs : 'Inf'}MIN`
});

});



parcelRegister("5yh8X", function(module, exports) {

$parcel$export(module.exports, "appBundleReadyMark", () => $b15a1f5ef3252a04$export$7e50945a65dd40e);
$parcel$export(module.exports, "prefetchApiReadyMark", () => $b15a1f5ef3252a04$export$17cbe723d23101d8);
$parcel$export(module.exports, "prefetchApiStartMark", () => $b15a1f5ef3252a04$export$887fadb22e7c7735);
$parcel$export(module.exports, "jswRenderStartMark", () => $b15a1f5ef3252a04$export$bd099c0a906f4b3f);
$parcel$export(module.exports, "jswCreateReduxStoreStartMark", () => $b15a1f5ef3252a04$export$d23ef9e7633e30e7);
$parcel$export(module.exports, "jswCreateReduxStoreEndMark", () => $b15a1f5ef3252a04$export$319da6d901948a6d);
$parcel$export(module.exports, "jswTransformCriticalDataStartMark", () => $b15a1f5ef3252a04$export$f0b6622cdc5c7e4f);
$parcel$export(module.exports, "jswTransformCriticalDataEndMark", () => $b15a1f5ef3252a04$export$37e82663aa1e79a8);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedStartMark", () => $b15a1f5ef3252a04$export$21146514eacceb12);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedEndMark", () => $b15a1f5ef3252a04$export$4eb8d44ddb14424a);


var $1cNJ6 = parcelRequire("1cNJ6");
const $b15a1f5ef3252a04$export$7e50945a65dd40e = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$ff834eccc35b9089));
const $b15a1f5ef3252a04$export$17cbe723d23101d8 = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$86b05e34d462ead8));
const $b15a1f5ef3252a04$export$887fadb22e7c7735 = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$d6a604a7d9a390fb));
const $b15a1f5ef3252a04$export$bd099c0a906f4b3f = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$3ae43cc1782d058f));
const $b15a1f5ef3252a04$export$d23ef9e7633e30e7 = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$363f6703ffa600be));
const $b15a1f5ef3252a04$export$319da6d901948a6d = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$e87b74567b79c8));
const $b15a1f5ef3252a04$export$f0b6622cdc5c7e4f = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$99fe642459a8b02));
const $b15a1f5ef3252a04$export$37e82663aa1e79a8 = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$ab1f5705fc8e0571));
const $b15a1f5ef3252a04$export$21146514eacceb12 = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$8c3a9046da692c35));
const $b15a1f5ef3252a04$export$4eb8d44ddb14424a = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$5aa497d1efdcc5bf));

});
parcelRegister("1cNJ6", function(module, exports) {

$parcel$export(module.exports, "getPrefixedMarkName", () => $c844db40c28c8d19$export$c8f0e9837e7e9425);

const $c844db40c28c8d19$export$c8f0e9837e7e9425 = (name)=>`${0, $37f655a4e4d5690e$export$56940a9488e85199}${name}`;

});


const $c22b1ee1fcd49c4a$export$9b8283d5878d2491 = 'BOARD';
const $c22b1ee1fcd49c4a$export$dedbdcc35e955187 = 'BACKLOG';
const $c22b1ee1fcd49c4a$export$ffff0a2c60bf4822 = 'ROADMAPS';
const $c22b1ee1fcd49c4a$export$78244dbb77cfa6b6 = 'UNKNOWN';
const $c22b1ee1fcd49c4a$export$b7dfe28569b170a1 = 'RESOURCES_CACHE_UPDATER_SOURCE';
const $c22b1ee1fcd49c4a$export$889129cf7f70997b = 'resourcesCacheSource';

parcelRegister("1JdUa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $48a5e529c3628da4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fee69 = parcelRequire("fee69");

var $eZThA = parcelRequire("eZThA");

var $4s0JT = parcelRequire("4s0JT");

var $2e3bR = parcelRequire("2e3bR");
const $48a5e529c3628da4$var$ResourcesCacheWrapper = ({ origin: origin })=>{
    (0, $eZThA.default)(origin);
    (0, $2e3bR.default)();
    (0, $4s0JT.default)(origin);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
};
const $48a5e529c3628da4$var$ResourcesCacheWrapperWithBoundary = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorBoundaryFlag), {
        id: "jira-software-resource-invalidator"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($48a5e529c3628da4$var$ResourcesCacheWrapper, props));
var $48a5e529c3628da4$export$2e2bcd8739ae039 = $48a5e529c3628da4$var$ResourcesCacheWrapperWithBoundary;

});
parcelRegister("eZThA", function(module, exports) {

$parcel$export(module.exports, "default", () => $50d03910cf9c5012$export$2e2bcd8739ae039);
/* eslint-disable react-hooks/exhaustive-deps */ 
var $eUqFw = parcelRequire("eUqFw");
parcelRequire("jnCPY");
parcelRequire("8OtG5");

var $iWLL0 = parcelRequire("iWLL0");

var $kJlBc = parcelRequire("kJlBc");

var $dWLk9 = parcelRequire("dWLk9");

var $ieUWD = parcelRequire("ieUWD");

var $iKyFB = parcelRequire("iKyFB");

var $l38jp = parcelRequire("l38jp");
/*
 * This hook is for handling when a change is performed that should invalidate the cache of another
 * resource. In the current case, the BOARD and BACKLOG caches are intertwined such that a major change
 * in the BOARD will invalidate the BACKLOG.
 */ const $50d03910cf9c5012$var$useResourcesCacheInvalidation = (origin)=>{
    const [resourcesRef] = (0, $iKyFB.default)();
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const [{ match: match }] = (0, $kJlBc.useRouter)();
    const boardId = match.params.boardId || '';
    (0, $eUqFw.useEffect)(()=>{
        // We don't want to refresh every time we have a change. Instead we only tell it to refresh its cache
        // AFTER we leave. The reason for doing this is we get a fresh cached version AFTER we've done all
        // our actions (and we minimise the number of API calls)
        let needToClearResourcesCacheOnExit = false;
        // We only need to proc this once and then we don't care about any further invalidation events
        const subscription = (0, $ieUWD.default).filter((val)=>val === origin).take(1).subscribe(()=>{
            // If we get an invalidation specific to this page, we flush out the caches of
            // all other pages we have cached that could be impacted
            Object.keys(resourcesRef.current).filter((key)=>key !== origin).forEach((key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<CacheInvalidationType, Resource>>'.
                resourcesRef.current[key].clear();
            });
            // Invalidate the boardScope resource in the Relay store
            (0, $l38jp.invalidateRelayStore)(environment, cloudId, boardId);
            // If we are allowed to refresh this cache on exit, set the flag for it
            if (origin in resourcesRef.current) needToClearResourcesCacheOnExit = true;
        });
        return ()=>{
            subscription.unsubscribe();
            if (needToClearResourcesCacheOnExit && origin in resourcesRef.current) {
                // Clear out this cache after we leave so when we come back we get a more up to date version.
                resourcesRef.current[origin].clear();
                // Invalidate the boardScope resource in the Relay store
                (0, $l38jp.invalidateRelayStore)(environment, cloudId, boardId);
            }
        };
    }, [
        origin,
        resourcesRef,
        environment,
        cloudId,
        boardId
    ]);
    return [
        (0, $ieUWD.default)
    ];
};
var $50d03910cf9c5012$export$2e2bcd8739ae039 = $50d03910cf9c5012$var$useResourcesCacheInvalidation;

});
parcelRegister("ieUWD", function(module, exports) {

$parcel$export(module.exports, "default", () => $dce68b2aa6b68041$export$2e2bcd8739ae039);
$parcel$export(module.exports, "triggerResourceCacheInvalidation", () => $dce68b2aa6b68041$export$76c3549b2288ab5d);
$parcel$export(module.exports, "addInvalidationReason", () => $dce68b2aa6b68041$export$77045c8772786aca);
$parcel$export(module.exports, "getAndClearInvalidationReasons", () => $dce68b2aa6b68041$export$c5ab3b0612bd31b4);

var $70s4u = parcelRequire("70s4u");


var $avsDR = parcelRequire("avsDR");
const $dce68b2aa6b68041$var$invalidationTracker = new (0, $avsDR.CacheInvalidationTracker)();
// Standard observer pattern, the middleware in board/backlog will invoke this
// when it comes across a matching redux mutation that requires the cache
// to be purged
const $dce68b2aa6b68041$var$ResourcesCacheInvalidationSubject = new (0, $70s4u.Subject)();
var $dce68b2aa6b68041$export$2e2bcd8739ae039 = $dce68b2aa6b68041$var$ResourcesCacheInvalidationSubject;
const $dce68b2aa6b68041$export$76c3549b2288ab5d = (origin, reason = (0, $c22b1ee1fcd49c4a$export$78244dbb77cfa6b6))=>{
    $dce68b2aa6b68041$var$ResourcesCacheInvalidationSubject.next(origin);
    $dce68b2aa6b68041$var$invalidationTracker.addReason(origin, reason);
};
const $dce68b2aa6b68041$export$77045c8772786aca = (origin, reason)=>{
    $dce68b2aa6b68041$var$invalidationTracker.addReason(origin, reason);
};
const $dce68b2aa6b68041$export$c5ab3b0612bd31b4 = (origin)=>$dce68b2aa6b68041$var$invalidationTracker.getAndClearReasons(origin);

});
parcelRegister("avsDR", function(module, exports) {

$parcel$export(module.exports, "CacheInvalidationTracker", () => $d2e1dd882832ab2e$export$71900622f425a7c3);

class $d2e1dd882832ab2e$export$71900622f425a7c3 {
    /**
	 * Pushes an invalidation reason to be tracked on the next cache-miss.
	 */ addReason(origin, reason = (0, $c22b1ee1fcd49c4a$export$78244dbb77cfa6b6)) {
        const reasonString = `${origin}:${reason}`;
        Object.keys(this.reasons).forEach((key)=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<CacheInvalidationType, Set<string>>>'.
            if (this.reasons[key].size >= 10) return;
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<CacheInvalidationType, Set<string>>>'.
            this.reasons[key].add(reasonString);
        });
    }
    /**
	 * Fetch invalidation reasons from the reasons set.
	 *
	 * If an experience does not read / clear reasons there's still only a bounded number of strings
	 * (10) that will be added into the Set; e.g. it's not a memory concern.
	 *
	 * The reasons are sorted.
	 */ getAndClearReasons(origin) {
        const reasonsSet = this.reasons[origin];
        const reasons = Array.from(reasonsSet);
        reasons.sort();
        reasonsSet.clear();
        return reasons;
    }
    constructor(){
        /**
	 * Holds reasons cache has been invalidated as a set of strings, for example:
	 *
	 * * BOARD:state.ISSUE_MOVE
	 * * BACKLOG:CREATE_SPRINT
	 *
	 * Reasons are kept separately for each page because they'll be cleared when the page is loaded.
	 *
	 * The reasoning can be exemplified by:
	 *
	 * * Visit board
	 * * Visit backlog
	 * * Visit roadmaps
	 * * Visit backlog - Load from cache
	 * * Make a BACKLOG:CARD_MOVE invalidation reason in backlog
	 *   * All 3 caches are now cleared
	 * * Visit board - reason is BACKLOG:CARD_MOVE - reasons are cleared;
	 * * Visit roadmaps - reason is BACKLOG:CARD_MOVE - reasons are cleared;
	 * * Visit backlog - reason is BACKLOG:CARD_MOVE - reasons are cleared;
	 * * Make a BACKLOG:SPRINT_COMPLETE invalidation reason in backlog
	 * * Visit board - reason is BACKLOG:SPRINT_COMPLETE **only**
	 */ this.reasons = {
            [(0, $c22b1ee1fcd49c4a$export$9b8283d5878d2491)]: new Set(),
            [(0, $c22b1ee1fcd49c4a$export$dedbdcc35e955187)]: new Set(),
            [(0, $c22b1ee1fcd49c4a$export$ffff0a2c60bf4822)]: new Set(),
            [(0, $c22b1ee1fcd49c4a$export$78244dbb77cfa6b6)]: new Set()
        };
    }
}

});


parcelRegister("iKyFB", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfcdcca2f5502863$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3HCkE = parcelRequire("3HCkE");

var $chAei = parcelRequire("chAei");

var $gmVN5 = parcelRequire("gmVN5");

var $bU6C3 = parcelRequire("bU6C3");

// We only ever want refresh and update in this component
// @ts-expect-error - TS7031 - Binding element 'update' implicitly has an 'any' type. | TS7031 - Binding element 'refresh' implicitly has an 'any' type. | TS7031 - Binding element 'clear' implicitly has an 'any' type.
const $dfcdcca2f5502863$var$buildResource = ({ update: update, refresh: refresh, clear: clear })=>({
        update: update,
        refresh: refresh,
        clear: clear
    });
/*
 * Simple hook that wraps the commonly used JSW resources in a dictionary and returns them
 */ const $dfcdcca2f5502863$var$useResourcesCacheTracker = ()=>{
    const boardResource = (0, $3HCkE.useResource)((0, $chAei.boardResource));
    const backlogResource = (0, $3HCkE.useResource)((0, $gmVN5.backlogResource));
    const roadmapResource = (0, $3HCkE.useResource)((0, $bU6C3.nextGenRoadmapResource));
    // Store the retrieved objects in an internal state. The reason for doing this is because when our routes
    // change, the objects returned from useResource appear to change as well. We don't want/need that.
    const resourcesByOriginByRef = (0, $eUqFw.useRef)({});
    (0, $eUqFw.useEffect)(()=>{
        resourcesByOriginByRef.current = {
            [(0, $9d4e95f592d66664$export$9b8283d5878d2491)]: $dfcdcca2f5502863$var$buildResource(boardResource),
            [(0, $9d4e95f592d66664$export$dedbdcc35e955187)]: $dfcdcca2f5502863$var$buildResource(backlogResource),
            [(0, $9d4e95f592d66664$export$ffff0a2c60bf4822)]: $dfcdcca2f5502863$var$buildResource(roadmapResource)
        };
    }, [
        boardResource,
        backlogResource,
        roadmapResource
    ]);
    // @ts-expect-error - TS2322 - Type 'MutableRefObject<{}>' is not assignable to type 'ResourcesDictionary'.
    return [
        resourcesByOriginByRef
    ];
};
var $dfcdcca2f5502863$export$2e2bcd8739ae039 = $dfcdcca2f5502863$var$useResourcesCacheTracker;

});
const $9d4e95f592d66664$export$9b8283d5878d2491 = 'BOARD';
const $9d4e95f592d66664$export$dedbdcc35e955187 = 'BACKLOG';
const $9d4e95f592d66664$export$ffff0a2c60bf4822 = 'ROADMAPS';
const $9d4e95f592d66664$export$78244dbb77cfa6b6 = 'UNKNOWN';


parcelRegister("l38jp", function(module, exports) {

$parcel$export(module.exports, "invalidateRelayStore", () => $3a7ab9bf04da86d8$export$fac5cf9145049c1c);

var $huI7r = parcelRequire("huI7r");
const $3a7ab9bf04da86d8$export$fac5cf9145049c1c = (environment, cloudId, boardId)=>{
    const boardAri = (0, $huI7r.createAri)({
        resourceOwner: 'jira-software',
        cloudId: cloudId,
        resourceType: 'board',
        resourceId: boardId
    });
    environment.commitUpdate((store)=>{
        const boardScopeRecord = store.getRoot().getLinkedRecord('boardScope', {
            boardId: boardAri
        });
        if (boardScopeRecord) boardScopeRecord.invalidateRecord();
    });
};

});


parcelRegister("4s0JT", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c09bc7e8f5aeaea$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("8OtG5");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $5cznK = parcelRequire("5cznK");
/*
 * This hook is for firing an analytics event to track whether the cache is stale
 * It will be fired when we load a cache but the cache is stale and later gets updated
 */ const $7c09bc7e8f5aeaea$var$useCacheRefreshAnalytics = (origin)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        const subscription = (0, $5cznK.default).filter((val)=>val === origin).subscribe(()=>{
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'resourcesCacheInvalidator updatedStaleData', {
                origin: origin
            });
        });
        return ()=>{
            subscription.unsubscribe();
        };
    }, [
        createAnalyticsEvent,
        origin
    ]);
    return [
        (0, $5cznK.default)
    ];
};
var $7c09bc7e8f5aeaea$export$2e2bcd8739ae039 = $7c09bc7e8f5aeaea$var$useCacheRefreshAnalytics;

});
parcelRegister("5cznK", function(module, exports) {

$parcel$export(module.exports, "default", () => $78426c31f217ab22$export$2e2bcd8739ae039);
$parcel$export(module.exports, "triggerCacheRefreshAnalytics", () => $78426c31f217ab22$export$e78b5ce2eed37743);

var $70s4u = parcelRequire("70s4u");
// Standard observer pattern, when the board/backlog/roadmap is mounted and loaded cache,
// but cache is stale and is updated by live data, this will be triggered
const $78426c31f217ab22$var$ResourcesCacheRefreshAnalytics = new (0, $70s4u.Subject)();
var $78426c31f217ab22$export$2e2bcd8739ae039 = $78426c31f217ab22$var$ResourcesCacheRefreshAnalytics;
const $78426c31f217ab22$export$e78b5ce2eed37743 = (origin)=>{
    $78426c31f217ab22$var$ResourcesCacheRefreshAnalytics.next(origin);
};

});


parcelRegister("2e3bR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e41ae913878c87da$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");
parcelRequire("8OtG5");


var $Tnz9v = parcelRequire("Tnz9v");

var $iKyFB = parcelRequire("iKyFB");
/*
 * Note this is only really used to handle real-time updates or any other methods of updating the cache
 */ const $e41ae913878c87da$var$useResourcesCacheUpdater = ()=>{
    // Use a local resources cache to track all the useResource instances for each key
    const [resourcesByRef] = (0, $iKyFB.default)();
    (0, $eUqFw.useEffect)(()=>{
        // We only need to proc this once and then we don't care about any further invalidation events
        const subscription = (0, $Tnz9v.default).filter((msg)=>!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(msg.origin)).subscribe((msg)=>{
            // Only handle this update if we have the resources in our dictionary
            if (msg.origin in resourcesByRef.current) {
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(msg.payload)) resourcesByRef.current[msg.origin].clear();
                else // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2345 - Argument of type '(currentData: any) => any' is not assignable to parameter of type '() => null'. | TS7006 - Parameter 'currentData' implicitly has an 'any' type.
                resourcesByRef.current[msg.origin].update((currentData)=>({
                        ...currentData,
                        ...msg.payload,
                        // Metadata to tell us where this actually came from
                        [(0, $c22b1ee1fcd49c4a$export$889129cf7f70997b)]: (0, $c22b1ee1fcd49c4a$export$b7dfe28569b170a1)
                    }));
            }
        });
        return ()=>{
            subscription.unsubscribe();
        };
    }, [
        resourcesByRef
    ]);
    return [
        (0, $Tnz9v.default)
    ];
};
var $e41ae913878c87da$export$2e2bcd8739ae039 = $e41ae913878c87da$var$useResourcesCacheUpdater;

});
parcelRegister("Tnz9v", function(module, exports) {

$parcel$export(module.exports, "default", () => $188b2e5bea53760e$export$2e2bcd8739ae039);

var $70s4u = parcelRequire("70s4u");
var // Standard observer pattern, the middleware in board/backlog will invoke this
// when it comes across a matching redux mutation that requires the cache
// to be updated
// eslint-disable-next-line jira/import/no-anonymous-default-export
$188b2e5bea53760e$export$2e2bcd8739ae039 = new (0, $70s4u.Subject)();

});



parcelRegister("lA3UV", function(module, exports) {

$parcel$export(module.exports, "getExtractedFields", () => $38a48273043e138d$export$44c042f94120778f);
$parcel$export(module.exports, "useStoreFields", () => $38a48273043e138d$export$52c92ba3608fca57);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $6iz4v = parcelRequire("6iz4v");

var $kmr29 = parcelRequire("kmr29");

var $gmrx4 = parcelRequire("gmrx4");

var $bMvpH = parcelRequire("bMvpH");
const $38a48273043e138d$export$44c042f94120778f = (0, $5iWql.default)((extractedCustomFields)=>Object.values(extractedCustomFields).reduce((extractedFields, extractedCustomFieldId)=>{
        const extractedCustomField = extractedCustomFieldId || '';
        if (extractedCustomField) extractedFields.push(extractedCustomField);
        return extractedFields;
    }, [
        ...(0, $gmrx4.extractedFixedFields)
    ]));
const $38a48273043e138d$export$52c92ba3608fca57 = ({ issueParents: issueParents } = {})=>{
    const [, fieldsValueActions] = (0, $kmr29.useFieldsValuesActions)();
    const storeFieldsActions = (0, $eUqFw.useMemo)(()=>{
        const storeFieldsFromCardCreateData = (cardCreateData, fieldConfigs)=>{
            (0, $bMvpH.mergeFieldsFromCardCreateData)(cardCreateData, fieldsValueActions, fieldConfigs, issueParents);
        };
        const storeFieldsFromFetchIssuesData = (issues, epicIssueType)=>{
            (0, $6iz4v.measureFunc)('storeFieldsFromFetchIssuesData', ()=>{
                (0, $bMvpH.mergeFieldsFromFetchIssuesData)(issues, fieldsValueActions, epicIssueType);
            });
        };
        const storeFieldsFromPrefetchedData = (prefetchedData, fieldConfigs)=>(0, $6iz4v.measureFunc)('storeFieldsFromPrefetchedData', ()=>{
                (0, $bMvpH.mergeFieldsFromPrefetchedData)(prefetchedData, fieldsValueActions, fieldConfigs);
            });
        const storeFieldsFromPrefetchedAggData = (prefetchedAggData, fieldConfigs)=>(0, $6iz4v.measureFunc)('storeFieldsFromPrefetchedAggData', ()=>{
                (0, $bMvpH.mergeFieldsFromPrefetchedAggData)(prefetchedAggData, fieldsValueActions, fieldConfigs);
            });
        const storeFieldsFromPrefetchedPlanData = (prefetchedJiraPlanRestData, epicIssueType)=>(0, $6iz4v.measureFunc)('storeFieldsFromPrefetchedJiraPlanRestData', ()=>{
                (0, $bMvpH.mergeFieldsFromPrefetchedJiraPlanData)(prefetchedJiraPlanRestData, fieldsValueActions, epicIssueType);
            });
        return {
            storeFieldsFromCardCreateData: storeFieldsFromCardCreateData,
            storeFieldsFromFetchIssuesData: storeFieldsFromFetchIssuesData,
            storeFieldsFromPrefetchedData: storeFieldsFromPrefetchedData,
            storeFieldsFromPrefetchedAggData: storeFieldsFromPrefetchedAggData,
            storeFieldsFromPrefetchedPlanData: storeFieldsFromPrefetchedPlanData
        };
    }, [
        fieldsValueActions,
        issueParents
    ]);
    return storeFieldsActions;
};

});
parcelRegister("kmr29", function(module, exports) {

$parcel$export(module.exports, "useFieldValue", () => $da19d1ee706d4a81$export$b79fae7fbe3ac392);
$parcel$export(module.exports, "useFieldsValues", () => $da19d1ee706d4a81$export$25b73e671fe7a8fa);
$parcel$export(module.exports, "useFieldValuesForIssues", () => $da19d1ee706d4a81$export$ac289b84121829df);
$parcel$export(module.exports, "useMultiFieldValuesForIssues", () => $da19d1ee706d4a81$export$915cdeec521b54f7);
$parcel$export(module.exports, "FieldValueSubscriber", () => $da19d1ee706d4a81$export$4e5f1f4ed08d155e);
$parcel$export(module.exports, "useFieldsValuesActions", () => $da19d1ee706d4a81$export$612d9bcb0c9d8976);

var $eUqFw = parcelRequire("eUqFw");

var $2vzCR = parcelRequire("2vzCR");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");
const $da19d1ee706d4a81$var$setIssue = (issueKey, fields)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: fields
        });
    };
const $da19d1ee706d4a81$var$setIssues = (issues)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState(newIssues);
    };
const $da19d1ee706d4a81$var$setFieldValue = (issueKey, fieldKey, value)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: value
            }
        });
    };
const $da19d1ee706d4a81$var$getFieldValue = (issueKey, fieldKey)=>({ getState: getState })=>{
        const issueFieldValues = getState()[issueKey];
        return issueFieldValues && issueFieldValues[fieldKey];
    };
const $da19d1ee706d4a81$var$mergeIssue = (issueKey, fields)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, getState()[issueKey], fields)
        });
    };
const $da19d1ee706d4a81$export$11aa02e14fdf7753 = (issues)=>({ setState: setState, getState: getState })=>{
        if (issues.length === 0) return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, getState(), newIssues));
    };
const $da19d1ee706d4a81$var$actions = {
    setFieldValue: $da19d1ee706d4a81$var$setFieldValue,
    getFieldValue: $da19d1ee706d4a81$var$getFieldValue,
    setIssue: $da19d1ee706d4a81$var$setIssue,
    mergeIssue: $da19d1ee706d4a81$var$mergeIssue,
    setIssues: $da19d1ee706d4a81$var$setIssues,
    mergeIssues: $da19d1ee706d4a81$export$11aa02e14fdf7753
};
// this is a global store
const $da19d1ee706d4a81$var$store = (0, $a61MH.createStore)({
    name: 'issue-fields',
    initialState: {},
    actions: $da19d1ee706d4a81$var$actions
});
const $da19d1ee706d4a81$var$getFieldValueSelector = (state, { issueKey: issueKey, fieldKey: fieldKey })=>{
    const issueFieldValues = state[issueKey];
    return issueFieldValues && issueFieldValues[fieldKey];
};
const $da19d1ee706d4a81$var$getFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKey: fieldKey })=>(issueKeys || []).map((issueKey)=>$da19d1ee706d4a81$var$getFieldValueSelector(state, {
            fieldKey: fieldKey,
            issueKey: issueKey
        }));
const $da19d1ee706d4a81$var$getMultiFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKeys: fieldKeys })=>(issueKeys || []).reduce((accumulator, issueKey)=>{
        if (!state[issueKey]) return accumulator;
        const fieldValue = fieldKeys.reduce((acc, fieldKey)=>{
            acc[fieldKey] = $da19d1ee706d4a81$var$getFieldValueSelector(state, {
                fieldKey: fieldKey,
                issueKey: issueKey
            });
            return acc;
        }, {});
        accumulator[issueKey] = fieldValue;
        return accumulator;
    }, {});
const $da19d1ee706d4a81$var$getAllFields = (state, issueKey)=>state[issueKey];
const $da19d1ee706d4a81$export$b79fae7fbe3ac392 = (0, $ggKAj.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getFieldValueSelector
});
const $da19d1ee706d4a81$export$25b73e671fe7a8fa = (0, $ggKAj.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getAllFields
});
const $da19d1ee706d4a81$export$ac289b84121829df = (0, $ggKAj.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getFieldValuesForIssuesSelector
});
const $da19d1ee706d4a81$export$915cdeec521b54f7 = (0, $ggKAj.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getMultiFieldValuesForIssuesSelector
});
const $da19d1ee706d4a81$export$4e5f1f4ed08d155e = (0, $dYfll.createSubscriber)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getFieldValueSelector
});
const $da19d1ee706d4a81$var$useFieldValueStoreActions = (0, $ggKAj.createHook)($da19d1ee706d4a81$var$store, {
    selector: null
});
const $da19d1ee706d4a81$export$612d9bcb0c9d8976 = ()=>{
    const [, fieldValueStoreActions] = $da19d1ee706d4a81$var$useFieldValueStoreActions();
    const fieldsValuesActions = (0, $eUqFw.useMemo)(()=>{
        const setIssueAction = (issueKey, fields)=>fieldValueStoreActions.setIssue(issueKey, fields);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const setFieldValueAction = (issueKey, fieldKey, value)=>fieldValueStoreActions.setFieldValue(issueKey, fieldKey, value);
        const getFieldValueAction = (issueKey, fieldKey)=>fieldValueStoreActions.getFieldValue(issueKey, fieldKey);
        const mergeIssueAction = (issueKey, fields)=>fieldValueStoreActions.mergeIssue(issueKey, fields);
        const setIssuesAction = (issues)=>fieldValueStoreActions.setIssues(issues);
        const mergeIssuesAction = (issues)=>fieldValueStoreActions.mergeIssues(issues);
        return {
            setIssue: setIssueAction,
            setFieldValue: setFieldValueAction,
            getFieldValue: getFieldValueAction,
            mergeIssue: mergeIssueAction,
            setIssues: setIssuesAction,
            mergeIssues: mergeIssuesAction
        };
    }, [
        fieldValueStoreActions
    ]);
    return [
        null,
        fieldsValuesActions
    ];
};

});

parcelRegister("gmrx4", function(module, exports) {

$parcel$export(module.exports, "extractedFixedFields", () => $61dbaa96d2108158$export$302ef72acec731a7);

var $lO4Or = parcelRequire("lO4Or");

const $61dbaa96d2108158$export$302ef72acec731a7 = [
    (0, $ebc098a76317be78$export$5fbd3b15555b9ef2),
    (0, $ebc098a76317be78$export$4420b7468f889692),
    (0, $ebc098a76317be78$export$e18419056f3d184a),
    (0, $lO4Or.PRIORITY_TYPE),
    (0, $lO4Or.PARENT_TYPE),
    (0, $lO4Or.HIERARCHY_LEVEL_ABOVE)
];

});
const $ebc098a76317be78$export$e18419056f3d184a = 'assignee';
const $ebc098a76317be78$export$45cafdfd629c3ca1 = 'reporter';
const $ebc098a76317be78$export$d5bc879e3b748593 = 'description';
const $ebc098a76317be78$export$a68dbc90211df1a8 = 'fixVersions';
const $ebc098a76317be78$export$93605f2a09aa8d26 = 'labels';
const $ebc098a76317be78$export$4420b7468f889692 = 'status';
const $ebc098a76317be78$export$e7cf1830fe735d1f = 'summary';
const $ebc098a76317be78$export$5fbd3b15555b9ef2 = 'timeoriginalestimate';
const $ebc098a76317be78$export$a5fc282ab2bf9b89 = 'issuelinks';
const $ebc098a76317be78$export$b52547457d714bc0 = 'epic-issues';
const $ebc098a76317be78$export$3cca6e37a5823d5a = 'children-issues';
const $ebc098a76317be78$export$98a935eb30de54ab = 'components';


parcelRegister("bMvpH", function(module, exports) {

$parcel$export(module.exports, "mergeFieldsFromCardCreateData", () => $b5df59e05ad5486a$export$d2f0044e31dbf46e);
$parcel$export(module.exports, "mergeFieldsFromFetchIssuesData", () => $b5df59e05ad5486a$export$934909337e38984d);
$parcel$export(module.exports, "mergeFieldsFromPrefetchedData", () => $b5df59e05ad5486a$export$ccb35cdb8dc761f5);
$parcel$export(module.exports, "mergeFieldsFromPrefetchedAggData", () => $b5df59e05ad5486a$export$eb61dff658e38dce);
$parcel$export(module.exports, "mergeFieldsFromPrefetchedJiraPlanData", () => $b5df59e05ad5486a$export$6503472ec8a310fa);

var $ezsJz = parcelRequire("ezsJz");

var $3aUuh = parcelRequire("3aUuh");

var $czx3b = parcelRequire("czx3b");

var $lPQPn = parcelRequire("lPQPn");

var $6cPKE = parcelRequire("6cPKE");

var $51HAN = parcelRequire("51HAN");

var $50D0V = parcelRequire("50D0V");

var $3l6tm = parcelRequire("3l6tm");

var $lO4Or = parcelRequire("lO4Or");


var $1ZZJ4 = parcelRequire("1ZZJ4");

var $bHPpI = parcelRequire("bHPpI");
const $b5df59e05ad5486a$var$toFieldAccessibleValues = (fields = [])=>(0, (/*@__PURE__*/$parcel$interopDefault($czx3b)))((0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))((0, (/*@__PURE__*/$parcel$interopDefault($ezsJz)))(fields, ({ isFieldAccessible: isFieldAccessible })=>isFieldAccessible), ({ fieldKey: fieldKey })=>fieldKey), ({ fieldValue: fieldValue })=>fieldValue);
const $b5df59e05ad5486a$export$599b8b9cc9396260 = ({ issue: { assignee: assignee, status: status, summary: summary }, priority: priority, parentId: parentId, ...restOfTheCard }, { storyPointFieldId: storyPointFieldId }, issueParents)=>{
    const estimate = 'estimate' in restOfTheCard ? restOfTheCard.estimate : null;
    // NOTE: Pre-populated fields should follow the same logic as how they are handled in syncing (src/packages/software/backlog/src/view/all-fields-sync/field-sync)
    const StoryPointKey = storyPointFieldId || '';
    const parentValue = parentId && issueParents?.length ? issueParents.find(({ id: id })=>Number(id) === Number(parentId)) : null;
    const issueParentType = issueParents?.length ? issueParents[0].issueType : null;
    const fields = [
        {
            isFieldAccessible: Boolean(estimate),
            fieldKey: (0, $ebc098a76317be78$export$5fbd3b15555b9ef2),
            fieldValue: estimate?.originalEstimate?.value ?? null
        },
        {
            isFieldAccessible: Boolean(StoryPointKey && estimate),
            fieldKey: StoryPointKey,
            fieldValue: estimate?.storyPoints ?? null
        },
        {
            isFieldAccessible: Boolean(status && status.id),
            fieldKey: (0, $ebc098a76317be78$export$4420b7468f889692),
            fieldValue: (0, $50D0V.getStatusShape)(status.id, status.name, status.category)
        },
        {
            isFieldAccessible: Boolean(assignee && assignee.accountId),
            fieldKey: (0, $ebc098a76317be78$export$e18419056f3d184a),
            fieldValue: (0, $6cPKE.getUserShape)(assignee?.accountId || '', assignee?.displayName || '', assignee?.avatarUrl)
        },
        {
            isFieldAccessible: Boolean(priority && priority.name),
            fieldKey: (0, $lO4Or.PRIORITY_TYPE),
            fieldValue: priority
        },
        {
            isFieldAccessible: Boolean(parentValue && parentId),
            fieldKey: (0, $lO4Or.PARENT_TYPE),
            fieldValue: parentValue ? (0, $51HAN.getParentShape)(parentValue.id, parentValue.key, parentValue.summary, {
                id: parentValue.issueType.id,
                name: parentValue.issueType.name,
                iconUrl: parentValue.issueType.iconUrl
            }) : null
        },
        {
            isFieldAccessible: Boolean(issueParentType),
            fieldKey: (0, $lO4Or.HIERARCHY_LEVEL_ABOVE),
            fieldValue: issueParentType ? (0, $51HAN.getHierarchyShape)({
                id: issueParentType.id,
                name: issueParentType.name,
                iconUrl: issueParentType.iconUrl
            }) : null
        },
        {
            isFieldAccessible: Boolean(summary),
            fieldKey: (0, $ebc098a76317be78$export$e7cf1830fe735d1f),
            fieldValue: summary ?? null
        }
    ];
    return $b5df59e05ad5486a$var$toFieldAccessibleValues(fields);
};
const $b5df59e05ad5486a$export$de671f46cd9f407c = (issue, epicIssueType)=>{
    const { summary: summary, status: status, assigneeAccountId: assigneeAccountId, assigneeName: assigneeName, avatarUrl: avatarUrl, priorityName: priorityName, priorityUrl: priorityUrl, estimateStatistic: estimateStatistic } = issue;
    const epicField = (0, $1ZZJ4.hasEpicField)(issue) && (0, $3l6tm.isBaseHierarchyLevel)(issue.typeHierarchyLevel) ? issue.epicField : null;
    const fields = [
        {
            isFieldAccessible: Boolean(estimateStatistic?.statFieldId),
            fieldKey: estimateStatistic?.statFieldId ?? '',
            fieldValue: estimateStatistic?.statFieldValue?.value ?? null
        },
        {
            isFieldAccessible: Boolean(status?.id),
            fieldKey: (0, $ebc098a76317be78$export$4420b7468f889692),
            fieldValue: (0, $50D0V.getStatusShape)(status.id, status.name, status.statusCategory.key)
        },
        {
            isFieldAccessible: Boolean(assigneeAccountId && assigneeName && avatarUrl),
            fieldKey: (0, $ebc098a76317be78$export$e18419056f3d184a),
            fieldValue: (0, $6cPKE.getUserShape)(assigneeAccountId || '', assigneeName || '', avatarUrl)
        },
        {
            isFieldAccessible: Boolean(priorityName && priorityUrl),
            fieldKey: (0, $lO4Or.PRIORITY_TYPE),
            fieldValue: {
                name: priorityName,
                iconUrl: priorityUrl
            }
        },
        {
            isFieldAccessible: Boolean((0, $3l6tm.isBaseHierarchyLevel)(issue.typeHierarchyLevel)),
            fieldKey: (0, $lO4Or.PARENT_TYPE),
            fieldValue: epicField ? (0, $51HAN.getParentShape)((0, $bHPpI.getIdFromAri)(String(epicField.issueId)), epicField.epicKey, epicField.summary || epicField.text, {
                id: epicField.issueTypeId,
                name: epicField.label,
                iconUrl: epicField.issueTypeIconUrl
            }, (0, $lPQPn.asColor)(epicField.color || epicField.epicColor)) : null
        },
        {
            isFieldAccessible: Boolean((0, $3l6tm.isBaseHierarchyLevel)(issue.typeHierarchyLevel)),
            fieldKey: (0, $lO4Or.HIERARCHY_LEVEL_ABOVE),
            fieldValue: epicField || epicIssueType ? (0, $51HAN.getHierarchyShape)({
                id: epicField?.issueTypeId ?? epicIssueType?.id,
                name: epicField?.label ?? epicIssueType?.name,
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                iconUrl: epicField?.issueTypeIconUrl ?? epicIssueType.iconUrl
            }) : null
        },
        {
            isFieldAccessible: Boolean(summary),
            fieldKey: (0, $ebc098a76317be78$export$e7cf1830fe735d1f),
            fieldValue: summary ?? null
        }
    ];
    return $b5df59e05ad5486a$var$toFieldAccessibleValues(fields);
};
const $b5df59e05ad5486a$export$62abca6d719f7b31 = (card, { storyPointFieldId: storyPointFieldId }, cardParents)=>{
    const estimate = 'estimate' in card ? card.estimate : null;
    // NOTE: Pre-populated fields should follow the same logic as how they are handled in syncing (src/packages/software/backlog/src/view/all-fields-sync/field-sync)
    const StoryPointKey = storyPointFieldId || '';
    const { status: status, assignee: assignee, priority: priority, parentId: parentId, summary: summary } = card;
    const parentValue = parentId && cardParents?.length ? cardParents.filter(Boolean).find(({ id: id })=>id === parentId) : null;
    const filteredCardParents = cardParents?.filter(Boolean);
    const cardParentCardType = filteredCardParents?.length ? filteredCardParents[0].cardType : null;
    const fields = [
        {
            isFieldAccessible: Boolean(estimate),
            fieldKey: (0, $ebc098a76317be78$export$5fbd3b15555b9ef2),
            fieldValue: estimate?.originalEstimate?.value ?? null
        },
        {
            isFieldAccessible: Boolean(StoryPointKey && estimate),
            fieldKey: StoryPointKey,
            fieldValue: estimate?.storyPoints ?? null
        },
        {
            isFieldAccessible: Boolean(status && status.id),
            fieldKey: (0, $ebc098a76317be78$export$4420b7468f889692),
            // @ts-expect-error TS2322: Type 'string' is not assignable to type 'StatusCategoryKeys'.
            fieldValue: (0, $50D0V.getStatusShape)(status.id, status.name, status.category)
        },
        {
            isFieldAccessible: Boolean(assignee && assignee.accountId),
            fieldKey: (0, $ebc098a76317be78$export$e18419056f3d184a),
            fieldValue: (0, $6cPKE.getUserShape)(assignee?.accountId || '', assignee?.name || '', assignee?.picture)
        },
        {
            isFieldAccessible: Boolean(priority && priority.name),
            fieldKey: (0, $lO4Or.PRIORITY_TYPE),
            fieldValue: priority
        },
        {
            isFieldAccessible: Boolean(parentValue && parentId),
            fieldKey: (0, $lO4Or.PARENT_TYPE),
            fieldValue: parentValue ? (0, $51HAN.getParentShape)((0, $bHPpI.getIdFromAri)(parentValue.id), parentValue.key, parentValue.summary, {
                id: parentValue.cardType.id,
                name: parentValue.cardType.name,
                iconUrl: parentValue.cardType.iconUrl
            }) : null
        },
        {
            isFieldAccessible: Boolean(cardParentCardType),
            fieldKey: (0, $lO4Or.HIERARCHY_LEVEL_ABOVE),
            fieldValue: cardParentCardType ? (0, $51HAN.getHierarchyShape)({
                id: cardParentCardType.id,
                name: cardParentCardType.name,
                iconUrl: cardParentCardType.iconUrl
            }) : null
        },
        {
            isFieldAccessible: Boolean(summary),
            fieldKey: (0, $ebc098a76317be78$export$e7cf1830fe735d1f),
            fieldValue: summary ?? null
        }
    ];
    return $b5df59e05ad5486a$var$toFieldAccessibleValues(fields);
};
const $b5df59e05ad5486a$export$d2f0044e31dbf46e = (cardCreateData, { mergeIssues: mergeIssues }, fieldConfigs, issueParents)=>{
    if (!cardCreateData?.planModeCardCreate) return;
    const { newCards: newCards } = cardCreateData.planModeCardCreate;
    if (newCards && newCards.length) {
        const issuesWithFields = newCards.map((card)=>{
            const fieldValues = $b5df59e05ad5486a$export$599b8b9cc9396260(card, fieldConfigs, issueParents);
            return {
                [card.issue.key]: fieldValues
            };
        });
        mergeIssues(issuesWithFields);
    }
};
const $b5df59e05ad5486a$export$934909337e38984d = (issues, { mergeIssues: mergeIssues }, epicIssueType)=>{
    if (issues && issues.length) {
        const issuesWithFields = issues.map((issue)=>{
            const fieldValues = $b5df59e05ad5486a$export$de671f46cd9f407c(issue, epicIssueType);
            return {
                [issue.key]: fieldValues
            };
        });
        mergeIssues(issuesWithFields);
    }
};
const $b5df59e05ad5486a$export$ccb35cdb8dc761f5 = (prefetchedData, { mergeIssues: mergeIssues }, fieldConfigs)=>{
    if (!prefetchedData?.boardScope) return;
    const { backlog: { cards: backlogCards }, board: { cards: boardCards, issueParents: issueParents }, sprints: sprints } = prefetchedData.boardScope;
    const cards = sprints.reduce((allCards, { cards: sprintCards })=>[
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...allCards,
            ...sprintCards
        ], [
        ...backlogCards,
        ...boardCards
    ]);
    if (cards.length) {
        const issuesWithFields = cards.map((card)=>{
            const fieldValues = $b5df59e05ad5486a$export$599b8b9cc9396260(card, fieldConfigs, issueParents);
            return {
                [card.issue.key]: fieldValues
            };
        });
        mergeIssues(issuesWithFields);
    }
};
const $b5df59e05ad5486a$export$eb61dff658e38dce = (prefetchedAggData, { mergeIssues: mergeIssues }, fieldConfigs)=>{
    if (!prefetchedAggData) return;
    const { backlog: backlog, board: { cards: boardCards }, sprints: sprints, cardParents: cardParents } = prefetchedAggData.boardScope;
    const backlogCards = backlog?.cards || [];
    const sprintCards = sprints.filter(Boolean).flatMap((sprint)=>sprint.cards);
    const cards = [
        ...backlogCards.filter(Boolean),
        ...boardCards.filter(Boolean),
        ...sprintCards.filter(Boolean)
    ];
    if (cards.length) {
        const issuesWithFields = cards.map((card)=>{
            const fieldValues = $b5df59e05ad5486a$export$62abca6d719f7b31(card, fieldConfigs, cardParents.filter(Boolean));
            return {
                [card.key]: fieldValues
            };
        });
        mergeIssues(issuesWithFields);
    }
};
const $b5df59e05ad5486a$export$6503472ec8a310fa = (prefetchedJiraPlanRestData, fieldValueServiceActions, epicIssueType)=>{
    if (!prefetchedJiraPlanRestData) return;
    const { issues: issues } = prefetchedJiraPlanRestData;
    $b5df59e05ad5486a$export$934909337e38984d(issues, fieldValueServiceActions, epicIssueType);
};

});
parcelRegister("ezsJz", function(module, exports) {

var $904yO = parcelRequire("904yO");

var $9vvKC = parcelRequire("9vvKC");

var $7qARj = parcelRequire("7qARj");

var $1c8hB = parcelRequire("1c8hB");
/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */ function $a9ba9f860705508e$var$filter(collection, predicate) {
    var func = $1c8hB(collection) ? $904yO : $9vvKC;
    return func(collection, $7qARj(predicate, 3));
}
module.exports = $a9ba9f860705508e$var$filter;

});
parcelRegister("9vvKC", function(module, exports) {

var $awetI = parcelRequire("awetI");
/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $6ebfa35ee06f887f$var$baseFilter(collection, predicate) {
    var result = [];
    $awetI(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) result.push(value);
    });
    return result;
}
module.exports = $6ebfa35ee06f887f$var$baseFilter;

});


parcelRegister("3aUuh", function(module, exports) {

var $3pSMu = parcelRequire("3pSMu");

var $f2sQe = parcelRequire("f2sQe");
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */ var $24fe1f7ac78dbb37$var$keyBy = $f2sQe(function(result, value, key) {
    $3pSMu(result, key, value);
});
module.exports = $24fe1f7ac78dbb37$var$keyBy;

});

parcelRegister("czx3b", function(module, exports) {

var $3pSMu = parcelRequire("3pSMu");

var $piimr = parcelRequire("piimr");

var $7qARj = parcelRequire("7qARj");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $9272640aa667e27d$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $7qARj(iteratee, 3);
    $piimr(object, function(value, key, object) {
        $3pSMu(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $9272640aa667e27d$var$mapValues;

});

parcelRegister("lPQPn", function(module, exports) {

$parcel$export(module.exports, "asColor", () => $66f7283bb625ccc7$export$b74af6529f09947);
$parcel$export(module.exports, "asServerColor", () => $66f7283bb625ccc7$export$442690a499ee9598);
$parcel$export(module.exports, "asClassicEpicColor", () => $66f7283bb625ccc7$export$eb754032c0b9698c);
$parcel$export(module.exports, "transformColorToTheme", () => $66f7283bb625ccc7$export$37c9bd72afe7f286);
$parcel$export(module.exports, "getValueFromColor", () => $66f7283bb625ccc7$export$a00423580059ae28);
$parcel$export(module.exports, "getColorFromValue", () => $66f7283bb625ccc7$export$6d14528e40cbe34b);
$parcel$export(module.exports, "toFrontendColor", () => $66f7283bb625ccc7$export$574e4dbf3c01f0ad);
$parcel$export(module.exports, "toBackendColor", () => $66f7283bb625ccc7$export$47af25386a01de1);
$parcel$export(module.exports, "classicToFrontendColor", () => $66f7283bb625ccc7$export$8f81207f7ac5fb9a);
$parcel$export(module.exports, "classicToBackendColor", () => $66f7283bb625ccc7$export$28fb68bb1de025d5);
$parcel$export(module.exports, "getDefaultColorPalette", () => $66f7283bb625ccc7$export$f6e067d5c418081a);
$parcel$export(module.exports, "getLozengeThemeByColor", () => $66f7283bb625ccc7$export$949dc67535a8ff2);
$parcel$export(module.exports, "getRandomColor", () => $66f7283bb625ccc7$export$e4369cabd7e84cd9);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $aXGkF = parcelRequire("aXGkF");

var $tgbCK = parcelRequire("tgbCK");

var $hNY9X = parcelRequire("hNY9X");

var $opsFH = parcelRequire("opsFH");
const $66f7283bb625ccc7$export$b74af6529f09947 = (color)=>{
    if (color == null) return (0, $opsFH.Colors).PURPLE;
    if (color in (0, $opsFH.Colors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_SERVER_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_AGILE_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color];
    return (0, $opsFH.Colors).PURPLE;
};
const $66f7283bb625ccc7$export$442690a499ee9598 = (color)=>{
    if (color == null) return (0, $opsFH.ServerColors).SERVER_PURPLE;
    if (color in (0, $opsFH.ServerColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_AGILE_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[(0, $tgbCK.MAP_FROM_AGILE_COLOR)[color]];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)) return (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    return (0, $opsFH.ServerColors).SERVER_PURPLE;
};
const $66f7283bb625ccc7$export$eb754032c0b9698c = (color)=>{
    if (color === null) return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $opsFH.Colors).PURPLE];
    if (color in (0, $opsFH.ClassicEpicColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $tgbCK.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $tgbCK.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_AGILE_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $tgbCK.MAP_FROM_AGILE_COLOR)[color]];
    // i.e: ghx-label-7
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $opsFH.Colors).PURPLE];
};
const $66f7283bb625ccc7$export$1a0a4af71e00cea4 = (color)=>{
    if (color === null) return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $opsFH.Colors).PURPLE];
    if (color in (0, $opsFH.AgileColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $tgbCK.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)) return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    // i.e: color_7
    return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $opsFH.Colors).PURPLE];
};
const $66f7283bb625ccc7$export$37c9bd72afe7f286 = (transformation, colorSchemaExtension)=>{
    const newColorSchema = {
        ...(0, $tgbCK.BASE_COLOR_SCHEMA),
        ...colorSchemaExtension
    };
    const extendedColors = (colorSchemaExtension ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys(colorSchemaExtension) : []).concat(Object.keys((0, $opsFH.Colors)));
    return extendedColors.reduce((obj, color)=>({
            ...obj,
            [color]: transformation(newColorSchema[color])
        }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});
};
const $66f7283bb625ccc7$export$a00423580059ae28 = (color)=>(0, $tgbCK.MAP_COLORS_TO_VALUE)[color] || (0, $tgbCK.MAP_COLORS_TO_VALUE)[0, $opsFH.PURPLE];
const $66f7283bb625ccc7$export$6d14528e40cbe34b = (value)=>// NOTE: lodash invert coerce the output to Dictionary<string> instead of using a polymorphic type
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Color'.
    (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))((0, $tgbCK.MAP_COLORS_TO_VALUE))[value] || (0, $opsFH.PURPLE);
const $66f7283bb625ccc7$export$574e4dbf3c01f0ad = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $tgbCK.MAP_FROM_SERVER_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_COLOR)[colorStr] : (0, $opsFH.PURPLE);
const $66f7283bb625ccc7$export$47af25386a01de1 = (color)=>(0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[color];
const $66f7283bb625ccc7$export$8f81207f7ac5fb9a = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[colorStr] : (0, $opsFH.PURPLE);
const $66f7283bb625ccc7$export$28fb68bb1de025d5 = (color)=>(0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
/**
 * Return default color palette
 */ const $66f7283bb625ccc7$var$paletteColorValues = $66f7283bb625ccc7$export$37c9bd72afe7f286((colorSchema)=>colorSchema.primary);
const $66f7283bb625ccc7$export$f6e067d5c418081a = (formatMessage)=>[
        {
            label: formatMessage((0, $hNY9X.default).purpleLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).PURPLE]
        },
        {
            label: formatMessage((0, $hNY9X.default).blueLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).BLUE]
        },
        {
            label: formatMessage((0, $hNY9X.default).greenLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).GREEN]
        },
        {
            label: formatMessage((0, $hNY9X.default).tealLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).TEAL]
        },
        {
            label: formatMessage((0, $hNY9X.default).yellowLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).YELLOW]
        },
        {
            label: formatMessage((0, $hNY9X.default).orangeLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).ORANGE]
        },
        {
            label: formatMessage((0, $hNY9X.default).greyLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).GREY]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkPurpleLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_PURPLE]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkBlueLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_BLUE]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkGreenLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_GREEN]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkTealLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_TEAL]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkYellowLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_YELLOW]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkOrangeLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_ORANGE]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkGreyLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_GREY]
        }
    ];
const $66f7283bb625ccc7$export$9b822862d986dfdf = $66f7283bb625ccc7$export$37c9bd72afe7f286((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $66f7283bb625ccc7$export$949dc67535a8ff2 = (color = (0, $tgbCK.DEFAULT_EPIC_COLOR))=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $66f7283bb625ccc7$export$9b822862d986dfdf[color] ?? $66f7283bb625ccc7$export$9b822862d986dfdf[0, $tgbCK.DEFAULT_EPIC_COLOR];
const $66f7283bb625ccc7$export$e4369cabd7e84cd9 = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const colorKeys = Object.keys((0, $opsFH.Colors));
    return colorKeys[Math.floor(Math.random() * colorKeys.length)];
};

});
parcelRegister("tgbCK", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_EPIC_COLOR", () => $3e0c3a8718e9d782$export$c2357bec51c5cf5b);
$parcel$export(module.exports, "MAP_COLORS_TO_VALUE", () => $3e0c3a8718e9d782$export$db33d74b098e3da9);
$parcel$export(module.exports, "MAP_COLORS_TO_TOKEN", () => $3e0c3a8718e9d782$export$fc5fe4213a5703f1);
$parcel$export(module.exports, "MAP_VALUE_TO_COLOR", () => $3e0c3a8718e9d782$export$a6cb26e106674600);
$parcel$export(module.exports, "MAP_FROM_SERVER_COLOR", () => $3e0c3a8718e9d782$export$43264b0781f10167);
$parcel$export(module.exports, "MAP_FROM_CLIENT_SERVER_COLOR", () => $3e0c3a8718e9d782$export$aedca9f3a1ee43d7);
$parcel$export(module.exports, "MAP_FROM_SERVER_CLASSIC_COLOR", () => $3e0c3a8718e9d782$export$fb5d051fe1b2bccc);
$parcel$export(module.exports, "MAP_FROM_CLIENT_CLASSIC_COLOR", () => $3e0c3a8718e9d782$export$c13af2d9629c53d8);
$parcel$export(module.exports, "MAP_FROM_AGILE_COLOR", () => $3e0c3a8718e9d782$export$994d3ffa39be04fd);
$parcel$export(module.exports, "MAP_FROM_CLIENT_AGILE_COLOR", () => $3e0c3a8718e9d782$export$db17671bf37971e7);
$parcel$export(module.exports, "MAP_CLASSIC_COLOR_TO_AGILE_COLOR", () => $3e0c3a8718e9d782$export$1fdd5a248b5f697c);
$parcel$export(module.exports, "MAP_COLOR_TO_AK_COLOR", () => $3e0c3a8718e9d782$export$82fc3b0b98905453);
$parcel$export(module.exports, "MAP_AGILE_COLOR_TO_AK_COLOR", () => $3e0c3a8718e9d782$export$703aca53c431bb88);
$parcel$export(module.exports, "BASE_COLOR_SCHEMA", () => $3e0c3a8718e9d782$export$92b6aebfb522f0d9);

var $aXGkF = parcelRequire("aXGkF");

var $PdmhA = parcelRequire("PdmhA");

var $opsFH = parcelRequire("opsFH");
const $3e0c3a8718e9d782$export$c2357bec51c5cf5b = 'PURPLE';
const $3e0c3a8718e9d782$export$db33d74b098e3da9 = {
    [(0, $opsFH.PURPLE)]: `var(--ds-background-accent-purple-subtle, ${(0, $PdmhA).P200})`,
    [(0, $opsFH.BLUE)]: `var(--ds-background-accent-blue-subtle, ${(0, $PdmhA).B200})`,
    [(0, $opsFH.GREEN)]: `var(--ds-background-accent-green-subtle, ${(0, $PdmhA).G200})`,
    [(0, $opsFH.TEAL)]: `var(--ds-background-accent-teal-subtle, ${(0, $PdmhA).T200})`,
    [(0, $opsFH.YELLOW)]: `var(--ds-background-accent-yellow-subtle, ${(0, $PdmhA).Y200})`,
    [(0, $opsFH.ORANGE)]: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R200})`,
    [(0, $opsFH.GREY)]: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N200})`,
    [(0, $opsFH.DARK_PURPLE)]: `var(--ds-background-accent-purple-bolder, ${(0, $PdmhA).P400})`,
    [(0, $opsFH.DARK_BLUE)]: `var(--ds-background-accent-blue-bolder, ${(0, $PdmhA).B400})`,
    [(0, $opsFH.DARK_GREEN)]: `var(--ds-background-accent-green-bolder, ${(0, $PdmhA).G400})`,
    [(0, $opsFH.DARK_TEAL)]: `var(--ds-background-accent-teal-bolder, ${(0, $PdmhA).T400})`,
    [(0, $opsFH.DARK_YELLOW)]: `var(--ds-background-accent-orange-bolder, ${(0, $PdmhA).Y400})`,
    [(0, $opsFH.DARK_ORANGE)]: `var(--ds-background-accent-red-bolder, ${(0, $PdmhA).R400})`,
    [(0, $opsFH.DARK_GREY)]: `var(--ds-background-accent-gray-bolder, ${(0, $PdmhA).N700})`
};
const $3e0c3a8718e9d782$export$fc5fe4213a5703f1 = {
    [(0, $PdmhA).P200]: `var(--ds-background-accent-purple-subtle, ${(0, $PdmhA).P200})`,
    [(0, $PdmhA).B200]: `var(--ds-background-accent-blue-subtle, ${(0, $PdmhA).B200})`,
    [(0, $PdmhA).G200]: `var(--ds-background-accent-green-subtle, ${(0, $PdmhA).G200})`,
    [(0, $PdmhA).T200]: `var(--ds-background-accent-teal-subtle, ${(0, $PdmhA).T200})`,
    [(0, $PdmhA).Y200]: `var(--ds-background-accent-yellow-subtle, ${(0, $PdmhA).Y200})`,
    [(0, $PdmhA).R200]: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R200})`,
    [(0, $PdmhA).N200]: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N200})`,
    [(0, $PdmhA).P400]: `var(--ds-background-accent-purple-bolder, ${(0, $PdmhA).P400})`,
    [(0, $PdmhA).B400]: `var(--ds-background-accent-blue-bolder, ${(0, $PdmhA).B400})`,
    [(0, $PdmhA).G400]: `var(--ds-background-accent-green-bolder, ${(0, $PdmhA).G400})`,
    [(0, $PdmhA).T400]: `var(--ds-background-accent-teal-bolder, ${(0, $PdmhA).T400})`,
    [(0, $PdmhA).Y400]: `var(--ds-background-accent-orange-bolder, ${(0, $PdmhA).Y400})`,
    [(0, $PdmhA).R400]: `var(--ds-background-accent-red-bolder, ${(0, $PdmhA).R400})`,
    [(0, $PdmhA).N700]: `var(--ds-background-accent-gray-bolder, ${(0, $PdmhA).N700})`
};
const $3e0c3a8718e9d782$export$a6cb26e106674600 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$db33d74b098e3da9);
const $3e0c3a8718e9d782$export$43264b0781f10167 = {
    [(0, $opsFH.SERVER_PURPLE)]: (0, $opsFH.PURPLE),
    [(0, $opsFH.SERVER_DARK_PURPLE)]: (0, $opsFH.DARK_PURPLE),
    [(0, $opsFH.SERVER_BLUE)]: (0, $opsFH.BLUE),
    [(0, $opsFH.SERVER_DARK_BLUE)]: (0, $opsFH.DARK_BLUE),
    [(0, $opsFH.SERVER_GREEN)]: (0, $opsFH.GREEN),
    [(0, $opsFH.SERVER_DARK_GREEN)]: (0, $opsFH.DARK_GREEN),
    [(0, $opsFH.SERVER_TEAL)]: (0, $opsFH.TEAL),
    [(0, $opsFH.SERVER_DARK_TEAL)]: (0, $opsFH.DARK_TEAL),
    [(0, $opsFH.SERVER_YELLOW)]: (0, $opsFH.YELLOW),
    [(0, $opsFH.SERVER_DARK_YELLOW)]: (0, $opsFH.DARK_YELLOW),
    [(0, $opsFH.SERVER_ORANGE)]: (0, $opsFH.ORANGE),
    [(0, $opsFH.SERVER_DARK_ORANGE)]: (0, $opsFH.DARK_ORANGE),
    [(0, $opsFH.SERVER_GREY)]: (0, $opsFH.GREY),
    [(0, $opsFH.SERVER_DARK_GREY)]: (0, $opsFH.DARK_GREY)
};
const $3e0c3a8718e9d782$export$aedca9f3a1ee43d7 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$43264b0781f10167);
const $3e0c3a8718e9d782$export$fb5d051fe1b2bccc = {
    [(0, $opsFH.GHX_LABEL_1)]: (0, $opsFH.DARK_GREY),
    [(0, $opsFH.GHX_LABEL_2)]: (0, $opsFH.DARK_YELLOW),
    [(0, $opsFH.GHX_LABEL_3)]: (0, $opsFH.YELLOW),
    [(0, $opsFH.GHX_LABEL_4)]: (0, $opsFH.DARK_BLUE),
    [(0, $opsFH.GHX_LABEL_5)]: (0, $opsFH.DARK_TEAL),
    [(0, $opsFH.GHX_LABEL_6)]: (0, $opsFH.GREEN),
    [(0, $opsFH.GHX_LABEL_7)]: (0, $opsFH.PURPLE),
    [(0, $opsFH.GHX_LABEL_8)]: (0, $opsFH.DARK_PURPLE),
    [(0, $opsFH.GHX_LABEL_9)]: (0, $opsFH.ORANGE),
    [(0, $opsFH.GHX_LABEL_10)]: (0, $opsFH.BLUE),
    [(0, $opsFH.GHX_LABEL_11)]: (0, $opsFH.TEAL),
    [(0, $opsFH.GHX_LABEL_12)]: (0, $opsFH.GREY),
    [(0, $opsFH.GHX_LABEL_13)]: (0, $opsFH.DARK_GREEN),
    [(0, $opsFH.GHX_LABEL_14)]: (0, $opsFH.DARK_ORANGE)
};
const $3e0c3a8718e9d782$export$c13af2d9629c53d8 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$fb5d051fe1b2bccc);
const $3e0c3a8718e9d782$export$994d3ffa39be04fd = {
    [(0, $opsFH.AGILE_COLOR_1)]: (0, $opsFH.DARK_GREY),
    [(0, $opsFH.AGILE_COLOR_2)]: (0, $opsFH.DARK_YELLOW),
    [(0, $opsFH.AGILE_COLOR_3)]: (0, $opsFH.YELLOW),
    [(0, $opsFH.AGILE_COLOR_4)]: (0, $opsFH.DARK_BLUE),
    [(0, $opsFH.AGILE_COLOR_5)]: (0, $opsFH.DARK_TEAL),
    [(0, $opsFH.AGILE_COLOR_6)]: (0, $opsFH.GREEN),
    [(0, $opsFH.AGILE_COLOR_7)]: (0, $opsFH.PURPLE),
    [(0, $opsFH.AGILE_COLOR_8)]: (0, $opsFH.DARK_PURPLE),
    [(0, $opsFH.AGILE_COLOR_9)]: (0, $opsFH.ORANGE),
    [(0, $opsFH.AGILE_COLOR_10)]: (0, $opsFH.BLUE),
    [(0, $opsFH.AGILE_COLOR_11)]: (0, $opsFH.TEAL),
    [(0, $opsFH.AGILE_COLOR_12)]: (0, $opsFH.GREY),
    [(0, $opsFH.AGILE_COLOR_13)]: (0, $opsFH.DARK_GREEN),
    [(0, $opsFH.AGILE_COLOR_14)]: (0, $opsFH.DARK_ORANGE)
};
const $3e0c3a8718e9d782$export$db17671bf37971e7 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$994d3ffa39be04fd);
const $3e0c3a8718e9d782$export$1fdd5a248b5f697c = {
    [(0, $opsFH.GHX_LABEL_1)]: (0, $opsFH.AGILE_COLOR_1),
    [(0, $opsFH.GHX_LABEL_2)]: (0, $opsFH.AGILE_COLOR_2),
    [(0, $opsFH.GHX_LABEL_3)]: (0, $opsFH.AGILE_COLOR_3),
    [(0, $opsFH.GHX_LABEL_4)]: (0, $opsFH.AGILE_COLOR_4),
    [(0, $opsFH.GHX_LABEL_5)]: (0, $opsFH.AGILE_COLOR_5),
    [(0, $opsFH.GHX_LABEL_6)]: (0, $opsFH.AGILE_COLOR_6),
    [(0, $opsFH.GHX_LABEL_7)]: (0, $opsFH.AGILE_COLOR_7),
    [(0, $opsFH.GHX_LABEL_8)]: (0, $opsFH.AGILE_COLOR_8),
    [(0, $opsFH.GHX_LABEL_9)]: (0, $opsFH.AGILE_COLOR_9),
    [(0, $opsFH.GHX_LABEL_10)]: (0, $opsFH.AGILE_COLOR_10),
    [(0, $opsFH.GHX_LABEL_11)]: (0, $opsFH.AGILE_COLOR_11),
    [(0, $opsFH.GHX_LABEL_12)]: (0, $opsFH.AGILE_COLOR_12),
    [(0, $opsFH.GHX_LABEL_13)]: (0, $opsFH.AGILE_COLOR_13),
    [(0, $opsFH.GHX_LABEL_14)]: (0, $opsFH.AGILE_COLOR_14)
};
const $3e0c3a8718e9d782$export$82fc3b0b98905453 = {
    [(0, $opsFH.DARK_GREY)]: 'grey',
    [(0, $opsFH.DARK_YELLOW)]: 'yellow',
    [(0, $opsFH.YELLOW)]: 'yellowLight',
    [(0, $opsFH.DARK_BLUE)]: 'blue',
    [(0, $opsFH.DARK_TEAL)]: 'teal',
    [(0, $opsFH.GREEN)]: 'greenLight',
    [(0, $opsFH.PURPLE)]: 'purpleLight',
    [(0, $opsFH.DARK_PURPLE)]: 'purple',
    [(0, $opsFH.ORANGE)]: 'redLight',
    [(0, $opsFH.BLUE)]: 'blueLight',
    [(0, $opsFH.TEAL)]: 'tealLight',
    [(0, $opsFH.GREY)]: 'greyLight',
    [(0, $opsFH.DARK_GREEN)]: 'green',
    [(0, $opsFH.DARK_ORANGE)]: 'red'
};
const $3e0c3a8718e9d782$export$703aca53c431bb88 = {
    [(0, $opsFH.AGILE_COLOR_1)]: 'grey',
    [(0, $opsFH.AGILE_COLOR_2)]: 'yellow',
    [(0, $opsFH.AGILE_COLOR_3)]: 'yellowLight',
    [(0, $opsFH.AGILE_COLOR_4)]: 'blue',
    [(0, $opsFH.AGILE_COLOR_5)]: 'teal',
    [(0, $opsFH.AGILE_COLOR_6)]: 'greenLight',
    [(0, $opsFH.AGILE_COLOR_7)]: 'purpleLight',
    [(0, $opsFH.AGILE_COLOR_8)]: 'purple',
    [(0, $opsFH.AGILE_COLOR_9)]: 'redLight',
    [(0, $opsFH.AGILE_COLOR_10)]: 'blueLight',
    [(0, $opsFH.AGILE_COLOR_11)]: 'tealLight',
    [(0, $opsFH.AGILE_COLOR_12)]: 'greyLight',
    [(0, $opsFH.AGILE_COLOR_13)]: 'green',
    [(0, $opsFH.AGILE_COLOR_14)]: 'red'
};
const $3e0c3a8718e9d782$export$92b6aebfb522f0d9 = {
    [(0, $opsFH.PURPLE)]: {
        primary: `var(--ds-background-accent-purple-subtle, ${(0, $PdmhA).P200})`,
        secondary: `var(--ds-background-accent-purple-bolder, ${(0, $PdmhA).P500})`,
        text: `var(--ds-text-accent-purple, ${(0, $PdmhA).P500})`,
        textBackground: `var(--ds-background-accent-purple-subtler, ${(0, $PdmhA).P50})`,
        border: `var(--ds-border-accent-purple, ${(0, $PdmhA).P400})`,
        line: `var(--ds-border-accent-purple, ${(0, $PdmhA).P300})`,
        primaryGradient: `var(--ds-background-accent-purple-subtler, ${(0, $PdmhA).P75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.BLUE)]: {
        primary: `var(--ds-background-accent-blue-subtle, ${(0, $PdmhA).B200})`,
        secondary: `var(--ds-background-accent-blue-bolder, ${(0, $PdmhA).B500})`,
        text: `var(--ds-text-accent-blue, ${(0, $PdmhA).B500})`,
        textBackground: `var(--ds-background-accent-blue-subtler, ${(0, $PdmhA).B50})`,
        border: `var(--ds-border-accent-blue, ${(0, $PdmhA).B400})`,
        line: `var(--ds-border-accent-blue, ${(0, $PdmhA).B300})`,
        primaryGradient: `var(--ds-background-accent-blue-subtler, ${(0, $PdmhA).B75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.GREEN)]: {
        primary: `var(--ds-background-accent-green-subtle, ${(0, $PdmhA).G200})`,
        secondary: `var(--ds-background-accent-green-bolder, ${(0, $PdmhA).G500})`,
        text: `var(--ds-text-accent-green, ${(0, $PdmhA).G500})`,
        textBackground: `var(--ds-background-accent-green-subtler, ${(0, $PdmhA).G50})`,
        border: `var(--ds-border-accent-green, ${(0, $PdmhA).G400})`,
        line: `var(--ds-border-accent-green, ${(0, $PdmhA).G300})`,
        primaryGradient: `var(--ds-background-accent-green-subtler, ${(0, $PdmhA).G75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.TEAL)]: {
        primary: `var(--ds-background-accent-teal-subtle, ${(0, $PdmhA).T200})`,
        secondary: `var(--ds-background-accent-teal-bolder, ${(0, $PdmhA).T500})`,
        text: `var(--ds-text-accent-teal, ${(0, $PdmhA).T500})`,
        textBackground: `var(--ds-background-accent-teal-subtler, ${(0, $PdmhA).T50})`,
        border: `var(--ds-border-accent-teal, ${(0, $PdmhA).T400})`,
        line: `var(--ds-border-accent-teal, ${(0, $PdmhA).T300})`,
        primaryGradient: `var(--ds-background-accent-teal-subtler, ${(0, $PdmhA).T75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.YELLOW)]: {
        primary: `var(--ds-background-accent-yellow-subtle, ${(0, $PdmhA).Y200})`,
        secondary: `var(--ds-background-accent-yellow-bolder, ${(0, $PdmhA).Y500})`,
        text: `var(--ds-text-accent-yellow, ${(0, $PdmhA).Y500})`,
        textBackground: `var(--ds-background-accent-yellow-subtler, ${(0, $PdmhA).Y50})`,
        border: `var(--ds-border-accent-yellow, ${(0, $PdmhA).Y400})`,
        line: `var(--ds-border-accent-yellow, ${(0, $PdmhA).Y300})`,
        primaryGradient: `var(--ds-background-accent-yellow-subtler, ${(0, $PdmhA).Y75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.ORANGE)]: {
        primary: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R200})`,
        secondary: `var(--ds-background-accent-red-bolder, ${(0, $PdmhA).R500})`,
        text: `var(--ds-text-accent-red, ${(0, $PdmhA).R500})`,
        textBackground: `var(--ds-background-accent-red-subtler, ${(0, $PdmhA).R50})`,
        border: `var(--ds-border-accent-red, ${(0, $PdmhA).R400})`,
        line: `var(--ds-border-accent-red, ${(0, $PdmhA).R300})`,
        primaryGradient: `var(--ds-background-accent-red-subtler, ${(0, $PdmhA).R75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.GREY)]: {
        primary: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N200})`,
        secondary: `var(--ds-background-accent-gray-bolder, ${(0, $PdmhA).N500})`,
        text: `var(--ds-text-accent-gray, ${(0, $PdmhA).N500})`,
        textBackground: `var(--ds-background-accent-gray-subtler, ${(0, $PdmhA).N30})`,
        border: `var(--ds-border-accent-gray, ${(0, $PdmhA).N700})`,
        line: `var(--ds-border-accent-gray, ${(0, $PdmhA).N500})`,
        primaryGradient: `var(--ds-background-accent-gray-subtler, ${(0, $PdmhA).N50})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.DARK_PURPLE)]: {
        primary: `var(--ds-background-accent-purple-bolder, ${(0, $PdmhA).P400})`,
        secondary: `var(--ds-background-accent-purple-subtle, ${(0, $PdmhA).P200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-purple-bolder, ${(0, $PdmhA).P400})`,
        border: `var(--ds-border-accent-purple, ${(0, $PdmhA).P100})`,
        line: `var(--ds-border-accent-purple, ${(0, $PdmhA).P300})`,
        primaryGradient: `var(--ds-background-accent-purple-subtle, ${(0, $PdmhA).P100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_BLUE)]: {
        primary: `var(--ds-background-accent-blue-bolder, ${(0, $PdmhA).B400})`,
        secondary: `var(--ds-background-accent-blue-subtle, ${(0, $PdmhA).B200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-blue-bolder, ${(0, $PdmhA).B400})`,
        border: `var(--ds-border-accent-blue, ${(0, $PdmhA).B200})`,
        line: `var(--ds-border-accent-blue, ${(0, $PdmhA).B100})`,
        primaryGradient: `var(--ds-background-accent-blue-subtle, ${(0, $PdmhA).B100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_GREEN)]: {
        primary: `var(--ds-background-accent-green-bolder, ${(0, $PdmhA).G400})`,
        secondary: `var(--ds-background-accent-green-subtle, ${(0, $PdmhA).G200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-green-bolder, ${(0, $PdmhA).G400})`,
        border: `var(--ds-border-accent-green, ${(0, $PdmhA).G200})`,
        line: `var(--ds-border-accent-green, ${(0, $PdmhA).G300})`,
        primaryGradient: `var(--ds-background-accent-green-subtle, ${(0, $PdmhA).G200})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_TEAL)]: {
        primary: `var(--ds-background-accent-teal-bolder, ${(0, $PdmhA).T400})`,
        secondary: `var(--ds-background-accent-teal-subtle, ${(0, $PdmhA).T200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-teal-bolder, ${(0, $PdmhA).T400})`,
        border: `var(--ds-border-accent-teal, ${(0, $PdmhA).T200})`,
        line: `var(--ds-border-accent-teal, ${(0, $PdmhA).T300})`,
        primaryGradient: `var(--ds-background-accent-teal-subtle, ${(0, $PdmhA).T100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_YELLOW)]: {
        primary: `var(--ds-background-accent-orange-bolder, ${(0, $PdmhA).Y400})`,
        secondary: `var(--ds-background-accent-orange-subtle, ${(0, $PdmhA).Y200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-orange-bolder, ${(0, $PdmhA).Y400})`,
        border: `var(--ds-background-accent-orange-subtle, ${(0, $PdmhA).Y200})`,
        line: `var(--ds-border-accent-orange, ${(0, $PdmhA).Y300})`,
        primaryGradient: `var(--ds-background-accent-orange-subtle, ${(0, $PdmhA).Y100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_ORANGE)]: {
        primary: `var(--ds-background-accent-red-bolder, ${(0, $PdmhA).R400})`,
        secondary: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-red-bolder, ${(0, $PdmhA).R400})`,
        border: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R100})`,
        line: `var(--ds-border-accent-red, ${(0, $PdmhA).R300})`,
        primaryGradient: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_GREY)]: {
        primary: `var(--ds-background-accent-gray-bolder, ${(0, $PdmhA).N700})`,
        secondary: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N300})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-gray-bolder, ${(0, $PdmhA).N500})`,
        border: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N100})`,
        line: `var(--ds-border-accent-gray, ${(0, $PdmhA).N500})`,
        primaryGradient: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N100})`,
        hasContrastSecondaryGradient: false
    }
};

});
parcelRegister("opsFH", function(module, exports) {

$parcel$export(module.exports, "PURPLE", () => $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2);
$parcel$export(module.exports, "DARK_PURPLE", () => $e6c2c5f41d0c328b$export$c815fe495e8174a0);
$parcel$export(module.exports, "BLUE", () => $e6c2c5f41d0c328b$export$738c3b9a44c87ecc);
$parcel$export(module.exports, "DARK_BLUE", () => $e6c2c5f41d0c328b$export$1225f83626261b80);
$parcel$export(module.exports, "GREEN", () => $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b);
$parcel$export(module.exports, "DARK_GREEN", () => $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78);
$parcel$export(module.exports, "TEAL", () => $e6c2c5f41d0c328b$export$d0446fe88325854e);
$parcel$export(module.exports, "DARK_TEAL", () => $e6c2c5f41d0c328b$export$bb848c92687e69dc);
$parcel$export(module.exports, "YELLOW", () => $e6c2c5f41d0c328b$export$aab610c505c06a8f);
$parcel$export(module.exports, "DARK_YELLOW", () => $e6c2c5f41d0c328b$export$466af87757d343a2);
$parcel$export(module.exports, "ORANGE", () => $e6c2c5f41d0c328b$export$3de5e29ed1757f9b);
$parcel$export(module.exports, "DARK_ORANGE", () => $e6c2c5f41d0c328b$export$da02e4820b6ab753);
$parcel$export(module.exports, "GREY", () => $e6c2c5f41d0c328b$export$7d278ca694634874);
$parcel$export(module.exports, "DARK_GREY", () => $e6c2c5f41d0c328b$export$26453300bfc61cb8);
$parcel$export(module.exports, "COLORS", () => $e6c2c5f41d0c328b$export$56d196d2844d1ca1);
$parcel$export(module.exports, "SERVER_PURPLE", () => $e6c2c5f41d0c328b$export$792af22a0198af8d);
$parcel$export(module.exports, "SERVER_DARK_PURPLE", () => $e6c2c5f41d0c328b$export$588af712afdcb006);
$parcel$export(module.exports, "SERVER_BLUE", () => $e6c2c5f41d0c328b$export$84c4918645391802);
$parcel$export(module.exports, "SERVER_DARK_BLUE", () => $e6c2c5f41d0c328b$export$b8f1f5838352a33a);
$parcel$export(module.exports, "SERVER_GREEN", () => $e6c2c5f41d0c328b$export$9384b7e350ee6542);
$parcel$export(module.exports, "SERVER_DARK_GREEN", () => $e6c2c5f41d0c328b$export$87d3fb8d8656d38b);
$parcel$export(module.exports, "SERVER_TEAL", () => $e6c2c5f41d0c328b$export$b0b4ce3e99e66aae);
$parcel$export(module.exports, "SERVER_DARK_TEAL", () => $e6c2c5f41d0c328b$export$a89b77a449bd223e);
$parcel$export(module.exports, "SERVER_YELLOW", () => $e6c2c5f41d0c328b$export$9a33b5e3cde94885);
$parcel$export(module.exports, "SERVER_DARK_YELLOW", () => $e6c2c5f41d0c328b$export$33253d7862bceb8a);
$parcel$export(module.exports, "SERVER_ORANGE", () => $e6c2c5f41d0c328b$export$6609c2b23fc42f39);
$parcel$export(module.exports, "SERVER_DARK_ORANGE", () => $e6c2c5f41d0c328b$export$cd994662b5911917);
$parcel$export(module.exports, "SERVER_GREY", () => $e6c2c5f41d0c328b$export$1793d43e13e078c5);
$parcel$export(module.exports, "SERVER_DARK_GREY", () => $e6c2c5f41d0c328b$export$487a6e9145526564);
$parcel$export(module.exports, "GHX_LABEL_1", () => $e6c2c5f41d0c328b$export$e4bdf2d4c4bbb15e);
$parcel$export(module.exports, "GHX_LABEL_2", () => $e6c2c5f41d0c328b$export$8f5c1c5512278dc6);
$parcel$export(module.exports, "GHX_LABEL_3", () => $e6c2c5f41d0c328b$export$94ac87c81ed074a7);
$parcel$export(module.exports, "GHX_LABEL_4", () => $e6c2c5f41d0c328b$export$6bc9ab1f489f76f7);
$parcel$export(module.exports, "GHX_LABEL_5", () => $e6c2c5f41d0c328b$export$610a2c132b6fcf96);
$parcel$export(module.exports, "GHX_LABEL_6", () => $e6c2c5f41d0c328b$export$8e4997dba71f1c40);
$parcel$export(module.exports, "GHX_LABEL_7", () => $e6c2c5f41d0c328b$export$18a545b4e69b27b4);
$parcel$export(module.exports, "GHX_LABEL_8", () => $e6c2c5f41d0c328b$export$27fff1a0d295292a);
$parcel$export(module.exports, "GHX_LABEL_9", () => $e6c2c5f41d0c328b$export$e57aa662a56724e1);
$parcel$export(module.exports, "GHX_LABEL_10", () => $e6c2c5f41d0c328b$export$4b0d63e2c3be2072);
$parcel$export(module.exports, "GHX_LABEL_11", () => $e6c2c5f41d0c328b$export$457ecb9560f2bf83);
$parcel$export(module.exports, "GHX_LABEL_12", () => $e6c2c5f41d0c328b$export$a866db37165a696c);
$parcel$export(module.exports, "GHX_LABEL_13", () => $e6c2c5f41d0c328b$export$9b18447c1168a1b6);
$parcel$export(module.exports, "GHX_LABEL_14", () => $e6c2c5f41d0c328b$export$93b9ad4020e271b7);
$parcel$export(module.exports, "AGILE_COLOR_1", () => $e6c2c5f41d0c328b$export$5cd2af17b34de3e3);
$parcel$export(module.exports, "AGILE_COLOR_2", () => $e6c2c5f41d0c328b$export$987671fa69482a7b);
$parcel$export(module.exports, "AGILE_COLOR_3", () => $e6c2c5f41d0c328b$export$70ba8a5b1f4c7446);
$parcel$export(module.exports, "AGILE_COLOR_4", () => $e6c2c5f41d0c328b$export$fcd1c42d8d3ebd36);
$parcel$export(module.exports, "AGILE_COLOR_5", () => $e6c2c5f41d0c328b$export$f80a5bd2fa0ba256);
$parcel$export(module.exports, "AGILE_COLOR_6", () => $e6c2c5f41d0c328b$export$37ad5ce8d2aeaf78);
$parcel$export(module.exports, "AGILE_COLOR_7", () => $e6c2c5f41d0c328b$export$9dc62d5d151cb355);
$parcel$export(module.exports, "AGILE_COLOR_8", () => $e6c2c5f41d0c328b$export$1ed15b30f5663f92);
$parcel$export(module.exports, "AGILE_COLOR_9", () => $e6c2c5f41d0c328b$export$5d23a84d55ac1644);
$parcel$export(module.exports, "AGILE_COLOR_10", () => $e6c2c5f41d0c328b$export$bf08c9a6ed42e349);
$parcel$export(module.exports, "AGILE_COLOR_11", () => $e6c2c5f41d0c328b$export$66c5d8f0b5ff279c);
$parcel$export(module.exports, "AGILE_COLOR_12", () => $e6c2c5f41d0c328b$export$da30755a37c3a597);
$parcel$export(module.exports, "AGILE_COLOR_13", () => $e6c2c5f41d0c328b$export$721cf84faff6bf19);
$parcel$export(module.exports, "AGILE_COLOR_14", () => $e6c2c5f41d0c328b$export$4b8f8666bd7b61dd);
$parcel$export(module.exports, "Colors", () => $e6c2c5f41d0c328b$export$c537fa0d021d010b);
$parcel$export(module.exports, "ServerColors", () => $e6c2c5f41d0c328b$export$d33d39828a18210a);
$parcel$export(module.exports, "ClassicEpicColors", () => $e6c2c5f41d0c328b$export$f476e6e43e0101e7);
$parcel$export(module.exports, "AgileColors", () => $e6c2c5f41d0c328b$export$4b7407b8700035bd);
/**
 * Color constants
 */ const $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2 = 'PURPLE';
const $e6c2c5f41d0c328b$export$c815fe495e8174a0 = 'DARK_PURPLE';
const $e6c2c5f41d0c328b$export$738c3b9a44c87ecc = 'BLUE';
const $e6c2c5f41d0c328b$export$1225f83626261b80 = 'DARK_BLUE';
const $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b = 'GREEN';
const $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78 = 'DARK_GREEN';
const $e6c2c5f41d0c328b$export$d0446fe88325854e = 'TEAL';
const $e6c2c5f41d0c328b$export$bb848c92687e69dc = 'DARK_TEAL';
const $e6c2c5f41d0c328b$export$aab610c505c06a8f = 'YELLOW';
const $e6c2c5f41d0c328b$export$466af87757d343a2 = 'DARK_YELLOW';
const $e6c2c5f41d0c328b$export$3de5e29ed1757f9b = 'ORANGE';
const $e6c2c5f41d0c328b$export$da02e4820b6ab753 = 'DARK_ORANGE';
const $e6c2c5f41d0c328b$export$7d278ca694634874 = 'GREY';
const $e6c2c5f41d0c328b$export$26453300bfc61cb8 = 'DARK_GREY';
const $e6c2c5f41d0c328b$export$56d196d2844d1ca1 = [
    $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2,
    $e6c2c5f41d0c328b$export$c815fe495e8174a0,
    $e6c2c5f41d0c328b$export$738c3b9a44c87ecc,
    $e6c2c5f41d0c328b$export$1225f83626261b80,
    $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b,
    $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78,
    $e6c2c5f41d0c328b$export$d0446fe88325854e,
    $e6c2c5f41d0c328b$export$bb848c92687e69dc,
    $e6c2c5f41d0c328b$export$aab610c505c06a8f,
    $e6c2c5f41d0c328b$export$466af87757d343a2,
    $e6c2c5f41d0c328b$export$3de5e29ed1757f9b,
    $e6c2c5f41d0c328b$export$da02e4820b6ab753,
    $e6c2c5f41d0c328b$export$7d278ca694634874,
    $e6c2c5f41d0c328b$export$26453300bfc61cb8
];
const $e6c2c5f41d0c328b$export$792af22a0198af8d = 'purple';
const $e6c2c5f41d0c328b$export$588af712afdcb006 = 'dark_purple';
const $e6c2c5f41d0c328b$export$84c4918645391802 = 'blue';
const $e6c2c5f41d0c328b$export$b8f1f5838352a33a = 'dark_blue';
const $e6c2c5f41d0c328b$export$9384b7e350ee6542 = 'green';
const $e6c2c5f41d0c328b$export$87d3fb8d8656d38b = 'dark_green';
const $e6c2c5f41d0c328b$export$b0b4ce3e99e66aae = 'teal';
const $e6c2c5f41d0c328b$export$a89b77a449bd223e = 'dark_teal';
const $e6c2c5f41d0c328b$export$9a33b5e3cde94885 = 'yellow';
const $e6c2c5f41d0c328b$export$33253d7862bceb8a = 'dark_yellow';
const $e6c2c5f41d0c328b$export$6609c2b23fc42f39 = 'orange';
const $e6c2c5f41d0c328b$export$cd994662b5911917 = 'dark_orange';
const $e6c2c5f41d0c328b$export$1793d43e13e078c5 = 'grey';
const $e6c2c5f41d0c328b$export$487a6e9145526564 = 'dark_grey';
const $e6c2c5f41d0c328b$export$e4bdf2d4c4bbb15e = 'ghx-label-1';
const $e6c2c5f41d0c328b$export$8f5c1c5512278dc6 = 'ghx-label-2';
const $e6c2c5f41d0c328b$export$94ac87c81ed074a7 = 'ghx-label-3';
const $e6c2c5f41d0c328b$export$6bc9ab1f489f76f7 = 'ghx-label-4';
const $e6c2c5f41d0c328b$export$610a2c132b6fcf96 = 'ghx-label-5';
const $e6c2c5f41d0c328b$export$8e4997dba71f1c40 = 'ghx-label-6';
const $e6c2c5f41d0c328b$export$18a545b4e69b27b4 = 'ghx-label-7';
const $e6c2c5f41d0c328b$export$27fff1a0d295292a = 'ghx-label-8';
const $e6c2c5f41d0c328b$export$e57aa662a56724e1 = 'ghx-label-9';
const $e6c2c5f41d0c328b$export$4b0d63e2c3be2072 = 'ghx-label-10';
const $e6c2c5f41d0c328b$export$457ecb9560f2bf83 = 'ghx-label-11';
const $e6c2c5f41d0c328b$export$a866db37165a696c = 'ghx-label-12';
const $e6c2c5f41d0c328b$export$9b18447c1168a1b6 = 'ghx-label-13';
const $e6c2c5f41d0c328b$export$93b9ad4020e271b7 = 'ghx-label-14';
const $e6c2c5f41d0c328b$export$5cd2af17b34de3e3 = 'color_1';
const $e6c2c5f41d0c328b$export$987671fa69482a7b = 'color_2';
const $e6c2c5f41d0c328b$export$70ba8a5b1f4c7446 = 'color_3';
const $e6c2c5f41d0c328b$export$fcd1c42d8d3ebd36 = 'color_4';
const $e6c2c5f41d0c328b$export$f80a5bd2fa0ba256 = 'color_5';
const $e6c2c5f41d0c328b$export$37ad5ce8d2aeaf78 = 'color_6';
const $e6c2c5f41d0c328b$export$9dc62d5d151cb355 = 'color_7';
const $e6c2c5f41d0c328b$export$1ed15b30f5663f92 = 'color_8';
const $e6c2c5f41d0c328b$export$5d23a84d55ac1644 = 'color_9';
const $e6c2c5f41d0c328b$export$bf08c9a6ed42e349 = 'color_10';
const $e6c2c5f41d0c328b$export$66c5d8f0b5ff279c = 'color_11';
const $e6c2c5f41d0c328b$export$da30755a37c3a597 = 'color_12';
const $e6c2c5f41d0c328b$export$721cf84faff6bf19 = 'color_13';
const $e6c2c5f41d0c328b$export$4b8f8666bd7b61dd = 'color_14';
const $e6c2c5f41d0c328b$export$c537fa0d021d010b = {
    PURPLE: $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2,
    DARK_PURPLE: $e6c2c5f41d0c328b$export$c815fe495e8174a0,
    BLUE: $e6c2c5f41d0c328b$export$738c3b9a44c87ecc,
    DARK_BLUE: $e6c2c5f41d0c328b$export$1225f83626261b80,
    GREEN: $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b,
    DARK_GREEN: $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78,
    TEAL: $e6c2c5f41d0c328b$export$d0446fe88325854e,
    DARK_TEAL: $e6c2c5f41d0c328b$export$bb848c92687e69dc,
    YELLOW: $e6c2c5f41d0c328b$export$aab610c505c06a8f,
    DARK_YELLOW: $e6c2c5f41d0c328b$export$466af87757d343a2,
    ORANGE: $e6c2c5f41d0c328b$export$3de5e29ed1757f9b,
    DARK_ORANGE: $e6c2c5f41d0c328b$export$da02e4820b6ab753,
    GREY: $e6c2c5f41d0c328b$export$7d278ca694634874,
    DARK_GREY: $e6c2c5f41d0c328b$export$26453300bfc61cb8
};
const $e6c2c5f41d0c328b$export$d33d39828a18210a = {
    SERVER_PURPLE: $e6c2c5f41d0c328b$export$792af22a0198af8d,
    SERVER_DARK_PURPLE: $e6c2c5f41d0c328b$export$588af712afdcb006,
    SERVER_BLUE: $e6c2c5f41d0c328b$export$84c4918645391802,
    SERVER_DARK_BLUE: $e6c2c5f41d0c328b$export$b8f1f5838352a33a,
    SERVER_GREEN: $e6c2c5f41d0c328b$export$9384b7e350ee6542,
    SERVER_DARK_GREEN: $e6c2c5f41d0c328b$export$87d3fb8d8656d38b,
    SERVER_TEAL: $e6c2c5f41d0c328b$export$b0b4ce3e99e66aae,
    SERVER_DARK_TEAL: $e6c2c5f41d0c328b$export$a89b77a449bd223e,
    SERVER_YELLOW: $e6c2c5f41d0c328b$export$9a33b5e3cde94885,
    SERVER_DARK_YELLOW: $e6c2c5f41d0c328b$export$33253d7862bceb8a,
    SERVER_ORANGE: $e6c2c5f41d0c328b$export$6609c2b23fc42f39,
    SERVER_DARK_ORANGE: $e6c2c5f41d0c328b$export$cd994662b5911917,
    SERVER_GREY: $e6c2c5f41d0c328b$export$1793d43e13e078c5,
    SERVER_DARK_GREY: $e6c2c5f41d0c328b$export$487a6e9145526564
};
const $e6c2c5f41d0c328b$export$f476e6e43e0101e7 = {
    GHX_LABEL_1: $e6c2c5f41d0c328b$export$e4bdf2d4c4bbb15e,
    GHX_LABEL_2: $e6c2c5f41d0c328b$export$8f5c1c5512278dc6,
    GHX_LABEL_3: $e6c2c5f41d0c328b$export$94ac87c81ed074a7,
    GHX_LABEL_4: $e6c2c5f41d0c328b$export$6bc9ab1f489f76f7,
    GHX_LABEL_5: $e6c2c5f41d0c328b$export$610a2c132b6fcf96,
    GHX_LABEL_6: $e6c2c5f41d0c328b$export$8e4997dba71f1c40,
    GHX_LABEL_7: $e6c2c5f41d0c328b$export$18a545b4e69b27b4,
    GHX_LABEL_8: $e6c2c5f41d0c328b$export$27fff1a0d295292a,
    GHX_LABEL_9: $e6c2c5f41d0c328b$export$e57aa662a56724e1,
    GHX_LABEL_10: $e6c2c5f41d0c328b$export$4b0d63e2c3be2072,
    GHX_LABEL_11: $e6c2c5f41d0c328b$export$457ecb9560f2bf83,
    GHX_LABEL_12: $e6c2c5f41d0c328b$export$a866db37165a696c,
    GHX_LABEL_13: $e6c2c5f41d0c328b$export$9b18447c1168a1b6,
    GHX_LABEL_14: $e6c2c5f41d0c328b$export$93b9ad4020e271b7
};
const $e6c2c5f41d0c328b$export$4b7407b8700035bd = {
    AGILE_COLOR_1: $e6c2c5f41d0c328b$export$5cd2af17b34de3e3,
    AGILE_COLOR_2: $e6c2c5f41d0c328b$export$987671fa69482a7b,
    AGILE_COLOR_3: $e6c2c5f41d0c328b$export$70ba8a5b1f4c7446,
    AGILE_COLOR_4: $e6c2c5f41d0c328b$export$fcd1c42d8d3ebd36,
    AGILE_COLOR_5: $e6c2c5f41d0c328b$export$f80a5bd2fa0ba256,
    AGILE_COLOR_6: $e6c2c5f41d0c328b$export$37ad5ce8d2aeaf78,
    AGILE_COLOR_7: $e6c2c5f41d0c328b$export$9dc62d5d151cb355,
    AGILE_COLOR_8: $e6c2c5f41d0c328b$export$1ed15b30f5663f92,
    AGILE_COLOR_9: $e6c2c5f41d0c328b$export$5d23a84d55ac1644,
    AGILE_COLOR_10: $e6c2c5f41d0c328b$export$bf08c9a6ed42e349,
    AGILE_COLOR_11: $e6c2c5f41d0c328b$export$66c5d8f0b5ff279c,
    AGILE_COLOR_12: $e6c2c5f41d0c328b$export$da30755a37c3a597,
    AGILE_COLOR_13: $e6c2c5f41d0c328b$export$721cf84faff6bf19,
    AGILE_COLOR_14: $e6c2c5f41d0c328b$export$4b8f8666bd7b61dd
};

});


parcelRegister("hNY9X", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7d8f225d60e32dd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a7d8f225d60e32dd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    purpleLabel: {
        "id": "issue-epic-color.common.purple-label",
        "defaultMessage": "purple"
    },
    blueLabel: {
        "id": "issue-epic-color.common.blue-label",
        "defaultMessage": "blue"
    },
    greenLabel: {
        "id": "issue-epic-color.common.green-label",
        "defaultMessage": "green"
    },
    tealLabel: {
        "id": "issue-epic-color.common.teal-label",
        "defaultMessage": "teal"
    },
    yellowLabel: {
        "id": "issue-epic-color.common.yellow-label",
        "defaultMessage": "yellow"
    },
    orangeLabel: {
        "id": "issue-epic-color.common.orange-label",
        "defaultMessage": "orange"
    },
    greyLabel: {
        "id": "issue-epic-color.common.grey-label",
        "defaultMessage": "grey"
    },
    darkPurpleLabel: {
        "id": "issue-epic-color.common.dark-purple-label",
        "defaultMessage": "dark purple"
    },
    darkBlueLabel: {
        "id": "issue-epic-color.common.dark-blue-label",
        "defaultMessage": "dark blue"
    },
    darkGreenLabel: {
        "id": "issue-epic-color.common.dark-green-label",
        "defaultMessage": "dark green"
    },
    darkTealLabel: {
        "id": "issue-epic-color.common.dark-teal-label",
        "defaultMessage": "dark teal"
    },
    darkYellowLabel: {
        "id": "issue-epic-color.common.dark-yellow-label",
        "defaultMessage": "dark yellow"
    },
    darkOrangeLabel: {
        "id": "issue-epic-color.common.dark-orange-label",
        "defaultMessage": "dark orange"
    },
    darkGreyLabel: {
        "id": "issue-epic-color.common.dark-grey-label",
        "defaultMessage": "dark grey"
    }
});

});


parcelRegister("6cPKE", function(module, exports) {

$parcel$export(module.exports, "getUnassignedUser", () => $c06f6916b7f49c06$export$42c5a0b65ef9ee80);
$parcel$export(module.exports, "getAutomaticUserOption", () => $c06f6916b7f49c06$export$8d7a63500893c8c);
$parcel$export(module.exports, "getInvitePeopleOption", () => $c06f6916b7f49c06$export$84a82764cf0a696e);
$parcel$export(module.exports, "getUserOptionFromUser", () => $c06f6916b7f49c06$export$16086438354dcc85);
$parcel$export(module.exports, "getUserFromUserOption", () => $c06f6916b7f49c06$export$78a8bcc5bd21caa2);
$parcel$export(module.exports, "getUserAvatarUrl", () => $c06f6916b7f49c06$export$7d801d84202c7743);
$parcel$export(module.exports, "getUserShape", () => $c06f6916b7f49c06$export$322b6ab8c29a006e);

var $51p9V = parcelRequire("51p9V");

var $43MEA = parcelRequire("43MEA");

const $c06f6916b7f49c06$export$42c5a0b65ef9ee80 = ({ formatMessage: formatMessage })=>({
        accountId: (0, $7a4a7348bcf111f0$export$bdab9bfb39981463),
        displayName: formatMessage((0, $51p9V.default).unassignedOption),
        avatarUrls: {}
    });
const $c06f6916b7f49c06$export$8d7a63500893c8c = ({ formatMessage: formatMessage })=>({
        accountId: (0, $7a4a7348bcf111f0$export$f5d5f6bb902f1027),
        displayName: formatMessage((0, $51p9V.default).automaticOption),
        avatarUrls: {}
    });
const $c06f6916b7f49c06$export$84a82764cf0a696e = ({ formatMessage: formatMessage }, isAdmin)=>({
        accountId: (0, $7a4a7348bcf111f0$export$d875316cb0cd94f7),
        displayName: formatMessage(isAdmin ? (0, $51p9V.default).invitePeopleOptionAdmin : (0, $51p9V.default).invitePeopleOption),
        avatarUrls: {
            '48x48': (0, (/*@__PURE__*/$parcel$interopDefault($43MEA)))
        }
    });
const $c06f6916b7f49c06$export$16086438354dcc85 = ({ accountId: accountId, displayName: displayName, avatarUrls: avatarUrls, emailAddress: emailAddress })=>({
        id: accountId || '',
        name: displayName,
        avatarUrl: avatarUrls['48x48'],
        // @ts-expect-error Will be part of JIV-13488; `user.emailAddress` returned by the REST API can be null depending on their privacy settings
        byline: emailAddress
    });
const $c06f6916b7f49c06$export$78a8bcc5bd21caa2 = ({ id: id, name: name, avatarUrl: avatarUrl })=>({
        accountId: id,
        displayName: name,
        avatarUrls: {
            '48x48': avatarUrl
        }
    });
const $c06f6916b7f49c06$export$7d801d84202c7743 = ({ avatarUrls: avatarUrls })=>avatarUrls['48x48'];
const $c06f6916b7f49c06$export$322b6ab8c29a006e = (accountId, displayName, avatarUrl)=>({
        accountId: accountId,
        displayName: displayName,
        avatarUrls: {
            '48x48': avatarUrl
        }
    });

});
parcelRegister("51p9V", function(module, exports) {

$parcel$export(module.exports, "default", () => $62a9b3be869d04c4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $62a9b3be869d04c4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    unassignedOption: {
        "id": "issue-field-assignee.unassigned-option",
        "defaultMessage": "Unassigned"
    },
    automaticOption: {
        "id": "issue-field-assignee.automatic-option",
        "defaultMessage": "Automatic"
    },
    assignToMe: {
        "id": "issue-field-assignee.assign-to-me",
        "defaultMessage": "Assign to me"
    },
    searchForAssignee: {
        "id": "issue-field-assignee.search-for-assignee",
        "defaultMessage": "Search for assignee"
    },
    invitePeopleOption: {
        "id": "issue-field-assignee.invite-people-option",
        "defaultMessage": "Add teammate to Jira"
    },
    invitePeopleOptionAdmin: {
        "id": "issue-field-assignee.invite-people-option-admin",
        "defaultMessage": "Invite teammate to Jira"
    }
});

});

parcelRegister("43MEA", function(module, exports) {
module.exports = new URL("add.6dea82c4.png", import.meta.url).toString();

});

const $7a4a7348bcf111f0$export$bdab9bfb39981463 = '__UNASSIGNED_ID__';
const $7a4a7348bcf111f0$export$d875316cb0cd94f7 = '__INVITE_PEOPLE_ID__';
const $7a4a7348bcf111f0$export$f5d5f6bb902f1027 = '-1';


parcelRegister("51HAN", function(module, exports) {

$parcel$export(module.exports, "getLozengeThemeByColor", () => $dea00c9a632d112b$export$949dc67535a8ff2);
$parcel$export(module.exports, "getParentShape", () => $dea00c9a632d112b$export$1a0682c86bbf9e96);
$parcel$export(module.exports, "getHierarchyShape", () => $dea00c9a632d112b$export$5f81302d25451851);
$parcel$export(module.exports, "formatOptionList", () => $dea00c9a632d112b$export$48f827b6d0c5862);
$parcel$export(module.exports, "transformToEpic", () => $dea00c9a632d112b$export$11773371cf35c9f8);

var $lPQPn = parcelRequire("lPQPn");

var $hVwWE = parcelRequire("hVwWE");
const $dea00c9a632d112b$export$9b822862d986dfdf = (0, $lPQPn.transformColorToTheme)((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $dea00c9a632d112b$export$949dc67535a8ff2 = (color = (0, $hVwWE.DEFAULT_EPIC_COLOR))=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $dea00c9a632d112b$export$9b822862d986dfdf[color] ?? $dea00c9a632d112b$export$9b822862d986dfdf[0, $hVwWE.DEFAULT_EPIC_COLOR];
const $dea00c9a632d112b$export$1a0682c86bbf9e96 = (id, key, summary, issuetype, color)=>({
        id: id,
        key: key,
        color: color,
        fields: {
            summary: summary,
            issuetype: issuetype
        }
    });
const $dea00c9a632d112b$export$5f81302d25451851 = ({ id: id, name: name, iconUrl: iconUrl })=>({
        name: 'Epic',
        level: 1,
        issueTypeIds: [
            Number(id)
        ],
        issueTypes: [
            {
                id: id,
                name: name,
                iconUrl: iconUrl
            }
        ]
    });
const $dea00c9a632d112b$export$48f827b6d0c5862 = (unformattedOptions, currentParent, label)=>{
    const filteredOptions = unformattedOptions.filter((option)=>option.key !== currentParent);
    const parentList = filteredOptions.slice(0, (0, $hVwWE.MAX_SUGGESTIONS)).map((option)=>({
            label: `${option.key} ${option.fields.summary}`,
            value: option.fields.summary,
            iconUrl: option.fields.issuetype.iconUrl,
            ...option
        }));
    return {
        options: parentList.length > 0 ? [
            {
                label: label,
                options: parentList
            }
        ] : [],
        hasMoreOptions: filteredOptions.length > (0, $hVwWE.MAX_SUGGESTIONS)
    };
};
const $dea00c9a632d112b$export$11773371cf35c9f8 = ({ id: id, key: key, summary: summary, color: color, issueType: { id: issueTypeId, name: issueTypeName, iconUrl: iconUrl } })=>({
        id: id,
        key: key,
        summary: summary,
        color: color,
        issueType: {
            id: issueTypeId,
            name: issueTypeName,
            iconUrl: iconUrl
        }
    });

});
parcelRegister("hVwWE", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $45f95733a0d2beeb$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "DEFAULT_EPIC_COLOR", () => $45f95733a0d2beeb$export$c2357bec51c5cf5b);
$parcel$export(module.exports, "MAX_SUGGESTIONS", () => $45f95733a0d2beeb$export$eb8d067f048699c8);
$parcel$export(module.exports, "MENU_WIDTH", () => $45f95733a0d2beeb$export$2467bcf8f6d5c6b6);
$parcel$export(module.exports, "MENU_EMPTY_WIDTH", () => $45f95733a0d2beeb$export$84f510916a7dff2e);
$parcel$export(module.exports, "LONG_LABEL_LIMIT", () => $45f95733a0d2beeb$export$29ec59bc4d551a41);
$parcel$export(module.exports, "PARENT_SWITCHER_LOZENGE_TEST_ID", () => $45f95733a0d2beeb$export$680faa54dc6da799);
$parcel$export(module.exports, "PARENT_SWITCHER_LOADING_SPINNER_TEST_ID", () => $45f95733a0d2beeb$export$11e2185ebbcf7235);
$parcel$export(module.exports, "PARENT_SWITCHER_SUGGESTED_PARENTS_ACTIONS_TEST_ID", () => $45f95733a0d2beeb$export$2aa213773f04da8f);
$parcel$export(module.exports, "PARENT_SWITCHER_LABEL_TEST_ID", () => $45f95733a0d2beeb$export$bccc9d1ffeb474d3);
$parcel$export(module.exports, "PARENT_SWITCHER_ADD_PARENT_BUTTON_TEST_ID", () => $45f95733a0d2beeb$export$cc185b35b5eb5c92);
$parcel$export(module.exports, "PARENT_SWITCHER_SUGGESTED_PARENTS_REMOVE_PARENT_TEST_ID", () => $45f95733a0d2beeb$export$31b523708d2a8acb);
$parcel$export(module.exports, "PARENT_SWITCHER_SUGGESTED_PARENTS_VIEW_ALL_PARENTS_TEST_ID", () => $45f95733a0d2beeb$export$ac3a223c1d7cac9a);
$parcel$export(module.exports, "PARENT_SWITCHER_SUGGESTED_PARENTS_EMPTY_TEST_ID", () => $45f95733a0d2beeb$export$beb7535f4921d585);
$parcel$export(module.exports, "PARENT_SWITCHER_OPEN_ISSUE_CREATE_LINK_TEST_ID", () => $45f95733a0d2beeb$export$a019f396c99849dc);

var $opsFH = parcelRequire("opsFH");

var $6bYiA = parcelRequire("6bYiA");
const $45f95733a0d2beeb$export$b8b9d90f9e5bd72b = (0, $6bYiA.toPackageName)('jiraParentSwitcherField');
const $45f95733a0d2beeb$export$c2357bec51c5cf5b = (0, $opsFH.PURPLE);
const $45f95733a0d2beeb$export$eb8d067f048699c8 = 5;
const $45f95733a0d2beeb$export$2467bcf8f6d5c6b6 = 345;
const $45f95733a0d2beeb$export$84f510916a7dff2e = 180;
const $45f95733a0d2beeb$export$29ec59bc4d551a41 = 40;
const $45f95733a0d2beeb$export$680faa54dc6da799 = 'issue-field-parent-switcher.common.ui.epic-lozenge.epic-lozenge';
const $45f95733a0d2beeb$export$11813783c408cdf1 = `[data-testid="${$45f95733a0d2beeb$export$680faa54dc6da799}"]`;
const $45f95733a0d2beeb$export$11e2185ebbcf7235 = 'issue-field-parent-switcher.ui.edit.suggested-parents-dropdown.loading-content.parent-switcher-suggested-parents-loading-spinner';
const $45f95733a0d2beeb$export$2aa213773f04da8f = 'issue-field-parent-switcher.ui.edit.suggested-parents-dropdown.actions';
const $45f95733a0d2beeb$export$bccc9d1ffeb474d3 = 'issue-field-parent.edit-view.options.';
const $45f95733a0d2beeb$export$cc185b35b5eb5c92 = 'issue-field-parent-switcher.ui.edit.suggested-parents-dropdown.add-parent-button';
const $45f95733a0d2beeb$export$31b523708d2a8acb = 'issue-field-parent-switcher.ui.edit.suggested-parents-dropdown.remove-parent';
const $45f95733a0d2beeb$export$986b8ef30a6bdca7 = `[data-testid="${$45f95733a0d2beeb$export$31b523708d2a8acb}"]`;
const $45f95733a0d2beeb$export$ac3a223c1d7cac9a = 'issue-field-parent-switcher.ui.edit.view-all-parents';
const $45f95733a0d2beeb$export$6494872dab91ac11 = `[data-testid="${$45f95733a0d2beeb$export$ac3a223c1d7cac9a}"]`;
const $45f95733a0d2beeb$export$beb7535f4921d585 = 'issue-field-parent-switcher.ui.edit.empty-container';
const $45f95733a0d2beeb$export$c0432cfce03a69a8 = `[data-testid="${$45f95733a0d2beeb$export$beb7535f4921d585}"]`;
const $45f95733a0d2beeb$export$a019f396c99849dc = 'issue-field-parent-switcher.ui.edit.suggested-parents-dropdown.empty-content.open-issue-create';

});


parcelRegister("50D0V", function(module, exports) {

$parcel$export(module.exports, "isOnlyGlobalTransitions", () => $eb8c09ff04a7e642$export$10992041bf7e444a);
$parcel$export(module.exports, "getFilteredOrderedTransitions", () => $eb8c09ff04a7e642$export$707115549202b9e4);
$parcel$export(module.exports, "getLoopedTransitionsForStatus", () => $eb8c09ff04a7e642$export$38146914a8d06579);
$parcel$export(module.exports, "transformOptions", () => $eb8c09ff04a7e642$export$8f4ed8ef83bcbf04);
$parcel$export(module.exports, "getStatusShape", () => $eb8c09ff04a7e642$export$e2dafe47b17b2cfc);

var $5iWql = parcelRequire("5iWql");

var $8Qd0L = parcelRequire("8Qd0L");
const $eb8c09ff04a7e642$var$isGlobalSelfTransition = (transition, currentStatusId)=>transition.isGlobal && transition.to.id === currentStatusId;
const $eb8c09ff04a7e642$var$isInitialSelfTransition = (transition, currentStatusId)=>transition.isInitial && transition.to.id === currentStatusId;
const $eb8c09ff04a7e642$var$isLoopedTransitionToSelf = (transition, currentStatusId)=>transition.to.id === currentStatusId && transition.isLooped === true;
const $eb8c09ff04a7e642$var$filterLoopedTransitionsToSelf = (0, $5iWql.default)((transitions, currentStatusId)=>transitions.filter((transition)=>!$eb8c09ff04a7e642$var$isLoopedTransitionToSelf(transition, currentStatusId) && !$eb8c09ff04a7e642$var$isGlobalSelfTransition(transition, currentStatusId) && !$eb8c09ff04a7e642$var$isInitialSelfTransition(transition, currentStatusId)));
const $eb8c09ff04a7e642$export$10992041bf7e444a = (transitions)=>transitions.every((t)=>t.isGlobal);
const $eb8c09ff04a7e642$export$707115549202b9e4 = (transitions, currentStatusId)=>$eb8c09ff04a7e642$var$filterLoopedTransitionsToSelf(transitions || [], currentStatusId);
const $eb8c09ff04a7e642$export$38146914a8d06579 = (0, $5iWql.default)((transitions, currentStatusId)=>(transitions || []).filter((transition)=>$eb8c09ff04a7e642$var$isLoopedTransitionToSelf(transition, currentStatusId)));
const $eb8c09ff04a7e642$var$formatOptions = (options)=>options.map((t)=>({
            label: t.to.name,
            value: t.id,
            transition: t
        }));
const $eb8c09ff04a7e642$var$memoizedTranformOptions = (0, $5iWql.default)($eb8c09ff04a7e642$var$formatOptions);
const $eb8c09ff04a7e642$export$8f4ed8ef83bcbf04 = (options)=>$eb8c09ff04a7e642$var$memoizedTranformOptions(options);
const $eb8c09ff04a7e642$export$e2dafe47b17b2cfc = (id, name, category)=>{
    const statusCategoryId = (0, $8Qd0L.StatusCategoryIds)[category] || (0, $8Qd0L.StatusCategoryIds)[(0, $8Qd0L.StatusCategoryTypes).UNDEFINED];
    return {
        id: id,
        name: name,
        statusCategory: {
            id: statusCategoryId,
            name: name
        }
    };
};

});

parcelRegister("1ZZJ4", function(module, exports) {

$parcel$export(module.exports, "hasEpicField", () => $8ea6926ce2a4b63a$export$c4f57165afac73d9);
$parcel$export(module.exports, "isEpicField", () => $8ea6926ce2a4b63a$export$3d4ac06796ffcbf4);
function $8ea6926ce2a4b63a$export$c4f57165afac73d9(issue) {
    return issue && 'epicField' in issue;
}
function $8ea6926ce2a4b63a$export$3d4ac06796ffcbf4(value) {
    return value && 'issueId' in value;
}

});

parcelRegister("bHPpI", function(module, exports) {

$parcel$export(module.exports, "getCardListId", () => $a9d6edbb9e02c6e6$export$e65113cd51859079);
$parcel$export(module.exports, "sendFailToMoveAnalytic", () => $a9d6edbb9e02c6e6$export$a3cba232834b9a4c);
$parcel$export(module.exports, "sendSuccessToMoveAnalytic", () => $a9d6edbb9e02c6e6$export$8b6d119d11f4d263);
$parcel$export(module.exports, "getIdFromAri", () => $a9d6edbb9e02c6e6$export$79640a85913af5aa);
$parcel$export(module.exports, "isObjectArrayEqual", () => $a9d6edbb9e02c6e6$export$65067f0a588374c3);
$parcel$export(module.exports, "toShortCustomFieldId", () => $a9d6edbb9e02c6e6$export$36c037bc7f404c2);
$parcel$export(module.exports, "toArray", () => $a9d6edbb9e02c6e6$export$45b10814cc054894);

var $8blac = parcelRequire("8blac");

var $hTLlD = parcelRequire("hTLlD");

var $ldoFd = parcelRequire("ldoFd");

var $hTVz0 = parcelRequire("hTVz0");

var $JRB5w = parcelRequire("JRB5w");

var $huI7r = parcelRequire("huI7r");

var $jMP2a = parcelRequire("jMP2a");

var $7TyGu = parcelRequire("7TyGu");

var $9eH8H = parcelRequire("9eH8H");
const $a9d6edbb9e02c6e6$export$e65113cd51859079 = (cardListId)=>{
    if (cardListId && cardListId.startsWith((0, $9eH8H.HEADER_DROPPABLE_ID_PREFIX))) return cardListId.substr((0, $9eH8H.HEADER_DROPPABLE_ID_PREFIX).length);
    if (cardListId && cardListId.startsWith((0, $9eH8H.CARD_GROUP_DROPPABLE_TYPE))) return cardListId.split('::')[2];
    if (cardListId && cardListId.startsWith((0, $9eH8H.TRANSITION_ZONE_DROPPABLE_TYPE))) return cardListId.split('::')[1];
    return cardListId;
};
const $a9d6edbb9e02c6e6$export$9067d4d6678cd6bc = (droppableId)=>droppableId.startsWith((0, $9eH8H.TRANSITION_ZONE_DROPPABLE_TYPE));
const $a9d6edbb9e02c6e6$var$getDndOperation = (srcDroppableId, destDroppableId, cardListId, isActiveSprint)=>{
    if (srcDroppableId === destDroppableId) return 0, $9eH8H.DND_OPERATION_MOVE_INSIDE_LIST;
    if (cardListId === (0, $7TyGu.BACKLOG)) return 0, $9eH8H.DND_OPERATION_MOVE_TO_BACKLOG;
    if (cardListId === (0, $7TyGu.BOARD)) return 0, $9eH8H.DND_OPERATION_MOVE_TO_BOARD;
    if (isActiveSprint(cardListId)) return 0, $9eH8H.DND_OPERATION_MOVE_TO_ACTIVE_SPRINT;
    return 0, $9eH8H.DND_OPERATION_MOVE_TO_FUTURE_SPRINT;
};
const $a9d6edbb9e02c6e6$var$getDndSource = (srcDroppableId, destDroppableId, isActiveSprint)=>{
    if (srcDroppableId === (0, $7TyGu.BACKLOG)) return 0, $9eH8H.DND_DROP_ZONES_BACKLOG;
    if (srcDroppableId === (0, $7TyGu.BOARD)) return 0, $9eH8H.DND_DROP_ZONES_BOARD;
    if (isActiveSprint(srcDroppableId)) return 0, $9eH8H.DND_DROP_ZONES_ACTIVE_SPRINT;
    return 0, $9eH8H.DND_DROP_ZONES_FUTURE_SPRINT;
};
const $a9d6edbb9e02c6e6$var$getDndDestination = (cardListId, isActiveSprint)=>{
    if (cardListId === (0, $7TyGu.BACKLOG)) return 0, $9eH8H.DND_DROP_ZONES_BACKLOG;
    if (cardListId === (0, $7TyGu.BOARD)) return 0, $9eH8H.DND_DROP_ZONES_BOARD;
    if (isActiveSprint(cardListId)) return 0, $9eH8H.DND_DROP_ZONES_ACTIVE_SPRINT;
    return 0, $9eH8H.DND_DROP_ZONES_FUTURE_SPRINT;
};
const $a9d6edbb9e02c6e6$export$a3cba232834b9a4c = (analyticsEvent, cardIds, error, cardListId, isActiveSprint)=>{
    const srcDroppableId = analyticsEvent.payload?.attributes?.source ?? '';
    const destDroppableId = analyticsEvent.payload?.attributes?.target ?? '';
    const dndSource = $a9d6edbb9e02c6e6$var$getDndSource(srcDroppableId, destDroppableId, isActiveSprint);
    const dndDestination = $a9d6edbb9e02c6e6$var$getDndDestination(cardListId, isActiveSprint);
    const dndTarget = analyticsEvent.payload?.attributes?.type ?? (0, $9eH8H.DND_TARGET_BACKLOG_CARD);
    const operation = $a9d6edbb9e02c6e6$var$getDndOperation(srcDroppableId, destDroppableId, cardListId, isActiveSprint);
    (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'cards moveFailed', {
        numCards: cardIds.length,
        errorMessage: error.message,
        operation: operation,
        dndDestination: dndDestination,
        dndSource: dndSource,
        dndTarget: dndTarget,
        isClientFetchError: (0, $JRB5w.isClientFetchError)(error)
    });
};
const $a9d6edbb9e02c6e6$export$8b6d119d11f4d263 = (cardId, analyticsEvent, cardListId, isActiveSprint)=>{
    const srcDroppableId = analyticsEvent.payload?.attributes?.source ?? '';
    const destDroppableId = analyticsEvent.payload?.attributes?.target ?? '';
    const dndSource = $a9d6edbb9e02c6e6$var$getDndSource(srcDroppableId, destDroppableId, isActiveSprint);
    const dndDestination = $a9d6edbb9e02c6e6$var$getDndDestination(cardListId, isActiveSprint);
    const dndTarget = analyticsEvent.payload?.attributes?.type ?? (0, $9eH8H.DND_TARGET_BACKLOG_CARD);
    const operation = $a9d6edbb9e02c6e6$var$getDndOperation(srcDroppableId, destDroppableId, cardListId, isActiveSprint);
    (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'backlog updated', String(cardId), {
        operation: operation,
        dndDestination: dndDestination,
        dndSource: dndSource,
        dndTarget: dndTarget
    });
};
const $a9d6edbb9e02c6e6$export$79640a85913af5aa = (ari)=>{
    const possibleAri = (0, $huI7r.toAri)(ari);
    if (possibleAri) return (0, $huI7r.getAriConfig)(possibleAri).resourceId;
    return ari;
};
const $a9d6edbb9e02c6e6$export$65067f0a588374c3 = (a, b)=>(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))((0, (/*@__PURE__*/$parcel$interopDefault($hTVz0)))(a, b, (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))));
const $a9d6edbb9e02c6e6$export$36c037bc7f404c2 = (customFieldId)=>{
    if (!(0, $9eH8H.CUSTOM_FIELD_ID_REGEX).test(customFieldId ?? '')) return undefined;
    const fieldId = customFieldId?.match((0, $9eH8H.CUSTOM_FIELD_ID_REGEX))?.[1];
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(fieldId)) return undefined;
    return `cf[${fieldId}]`;
};
const $a9d6edbb9e02c6e6$export$45b10814cc054894 = (x)=>Array.isArray(x) ? x : x.split(',');

});
parcelRegister("hTVz0", function(module, exports) {

var $904yO = parcelRequire("904yO");

var $9eFtX = parcelRequire("9eFtX");

var $a5Cec = parcelRequire("a5Cec");

var $cRpul = parcelRequire("cRpul");

var $iTvqy = parcelRequire("iTvqy");
/**
 * This method is like `_.xor` except that it accepts `comparator` which is
 * invoked to compare elements of `arrays`. The order of result values is
 * determined by the order they occur in the arrays. The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.xorWith(objects, others, _.isEqual);
 * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
 */ var $d08439ab21e39200$var$xorWith = $9eFtX(function(arrays) {
    var comparator = $iTvqy(arrays);
    comparator = typeof comparator == 'function' ? comparator : undefined;
    return $a5Cec($904yO(arrays, $cRpul), undefined, comparator);
});
module.exports = $d08439ab21e39200$var$xorWith;

});
parcelRegister("a5Cec", function(module, exports) {

var $fa0Ox = parcelRequire("fa0Ox");

var $hKE3p = parcelRequire("hKE3p");

var $42tFs = parcelRequire("42tFs");
/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */ function $7588064e955aa173$var$baseXor(arrays, iteratee, comparator) {
    var length = arrays.length;
    if (length < 2) return length ? $42tFs(arrays[0]) : [];
    var index = -1, result = Array(length);
    while(++index < length){
        var array = arrays[index], othIndex = -1;
        while(++othIndex < length)if (othIndex != index) result[index] = $fa0Ox(result[index] || array, arrays[othIndex], iteratee, comparator);
    }
    return $42tFs($hKE3p(result, 1), iteratee, comparator);
}
module.exports = $7588064e955aa173$var$baseXor;

});


parcelRegister("7TyGu", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_DATE_DISPLAY_FORMAT", () => $6cb67893521cea43$export$faf85b5ed93b0538);
$parcel$export(module.exports, "BACKLOG", () => $6cb67893521cea43$export$dedbdcc35e955187);
$parcel$export(module.exports, "BOARD", () => $6cb67893521cea43$export$9b8283d5878d2491);
$parcel$export(module.exports, "SPRINT", () => $6cb67893521cea43$export$a316570a0dbfd2b0);
$parcel$export(module.exports, "INACTIVE_SPRINT", () => $6cb67893521cea43$export$88abd69a9006b2b);
$parcel$export(module.exports, "ACTIVE_SPRINT", () => $6cb67893521cea43$export$2f9f63c9e8b8a7fc);
$parcel$export(module.exports, "TOP_OF_LIST", () => $6cb67893521cea43$export$1a271033d96c4e9a);
$parcel$export(module.exports, "BOTTOM_OF_LIST", () => $6cb67893521cea43$export$fe366e1b5f8f6917);
$parcel$export(module.exports, "BOTTOM_OF_CARD_GROUP", () => $6cb67893521cea43$export$29472abe5c298701);
$parcel$export(module.exports, "BEFORE_CARD", () => $6cb67893521cea43$export$6ee6fb5615cbbfaf);
$parcel$export(module.exports, "TRANSITION_ZONE", () => $6cb67893521cea43$export$825ad5563e6c16b4);
$parcel$export(module.exports, "NONE", () => $6cb67893521cea43$export$c53d0f541b41b88e);
$parcel$export(module.exports, "ISSUE_LIST", () => $6cb67893521cea43$export$7be7e0393bed6707);
$parcel$export(module.exports, "SPRINT_STATE_FUTURE", () => $6cb67893521cea43$export$1dec7a5987befb9f);
$parcel$export(module.exports, "SPRINT_STATE_ACTIVE", () => $6cb67893521cea43$export$91f438b1afe47b53);
$parcel$export(module.exports, "SPRINT_MOVE_TO_TOP", () => $6cb67893521cea43$export$c557f656e9558605);
$parcel$export(module.exports, "SPRINT_MOVE_UP", () => $6cb67893521cea43$export$d44a21a036e6d362);
$parcel$export(module.exports, "SPRINT_MOVE_DOWN", () => $6cb67893521cea43$export$c3959a41530f5d37);
$parcel$export(module.exports, "SPRINT_MOVE_TO_BOTTOM", () => $6cb67893521cea43$export$40b71d704f7a26b4);
$parcel$export(module.exports, "DEFAULT_PARENT_ISSUE_TYPE_NAME", () => $6cb67893521cea43$export$cb17e3c17bc50301);
$parcel$export(module.exports, "ESTIMATION_ROLLUP_BADGE_MAX", () => $6cb67893521cea43$export$b79b504ff88a1727);
$parcel$export(module.exports, "BACKLOG_LONG_TASKS_DND_MARK_NAME", () => $6cb67893521cea43$export$bb1ee0864c80dcde);
$parcel$export(module.exports, "SPRINT_BACKLOG_STRATEGY", () => $6cb67893521cea43$export$3fa2dca6095ef23a);
$parcel$export(module.exports, "ISSUE_LIST_BACKLOG_STRATEGY", () => $6cb67893521cea43$export$946ee3a604b332d2);
$parcel$export(module.exports, "KANBAN_BACKLOG_STRATEGY", () => $6cb67893521cea43$export$869ee62868d7be07);
$parcel$export(module.exports, "REFRESH_SOURCE_FAILURE", () => $6cb67893521cea43$export$d9d2fe902bd6d9a7);
$parcel$export(module.exports, "REFRESH_SOURCE_REALTIME", () => $6cb67893521cea43$export$af001fd9213b0b63);
$parcel$export(module.exports, "REFRESH_SOURCE_KANBAN_CARD_MOVE_SUCCESS", () => $6cb67893521cea43$export$9af8a111003cd702);
$parcel$export(module.exports, "REFRESH_SOURCE_GLOBAL_ISSUE_CREATE", () => $6cb67893521cea43$export$8cabdc85b8691f12);
$parcel$export(module.exports, "REFRESH_SOURCE_SPRINT_COMPLETE", () => $6cb67893521cea43$export$600567015cf0b58e);
$parcel$export(module.exports, "REFRESH_SOURCE_STATUS_REMAPPED", () => $6cb67893521cea43$export$443de2b93e4aa6c6);
$parcel$export(module.exports, "REFRESH_SOURCE_ON_MOUNT", () => $6cb67893521cea43$export$26392593c7297db8);
$parcel$export(module.exports, "REFRESH_SOURCE_ACTIVE_TAB", () => $6cb67893521cea43$export$968a5895f5ee4e93);
$parcel$export(module.exports, "REFRESH_SOURCE_POLLING", () => $6cb67893521cea43$export$8125ab02c04ac8e7);
$parcel$export(module.exports, "REFRESH_SOURCE_ADD_ISSUE_TYPE_MODAL", () => $6cb67893521cea43$export$66e48a348bf0e91e);
$parcel$export(module.exports, "APP_ID", () => $6cb67893521cea43$export$d76071d5de2774fc);
$parcel$export(module.exports, "TEAM_NAME", () => $6cb67893521cea43$export$d57b6b390e78d90f);
$parcel$export(module.exports, "PACKAGE_NAME", () => $6cb67893521cea43$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "EDIT_BOARD_CONFIG", () => $6cb67893521cea43$export$b893894941c14e43);
$parcel$export(module.exports, "DELETE_ISSUE", () => $6cb67893521cea43$export$4e8756b18ce4cf17);
$parcel$export(module.exports, "CREATE_ISSUE", () => $6cb67893521cea43$export$a84692caf5a334ea);
$parcel$export(module.exports, "MANAGE_SPRINT", () => $6cb67893521cea43$export$47e89ba04d79d88d);
$parcel$export(module.exports, "EDIT_ISSUE", () => $6cb67893521cea43$export$52f11126cce982f0);
$parcel$export(module.exports, "VIEW_BOARD", () => $6cb67893521cea43$export$6fca44a139cecd72);
$parcel$export(module.exports, "ADMINISTER_BOARD", () => $6cb67893521cea43$export$120f9058cc2d23b7);
$parcel$export(module.exports, "BULK_CHANGE", () => $6cb67893521cea43$export$66cb530046350ea5);
$parcel$export(module.exports, "ASSIGN_ISSUE", () => $6cb67893521cea43$export$e3e5ec492e10f340);
$parcel$export(module.exports, "TRANSITION_ISSUE", () => $6cb67893521cea43$export$627a3f8561c04066);
$parcel$export(module.exports, "ISSUE_COUNT_ID", () => $6cb67893521cea43$export$e371c88c3137ffb);
$parcel$export(module.exports, "ESTIMATION_TYPE_ID_PREFIX", () => $6cb67893521cea43$export$81b5ed4ed651b2bc);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_FIELD_ID", () => $6cb67893521cea43$export$d02889a654103c98);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_ID", () => $6cb67893521cea43$export$4c2cf346f4d818c5);
$parcel$export(module.exports, "NUMERIC_ESTIMATE_FIELD_ID_PREFIX", () => $6cb67893521cea43$export$4091097a73cc5002);
$parcel$export(module.exports, "ISSUE_COUNT", () => $6cb67893521cea43$export$8775696968c9b13c);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE", () => $6cb67893521cea43$export$bfb354504bb547a0);
$parcel$export(module.exports, "STORY_POINTS", () => $6cb67893521cea43$export$405b6d72f2d243a9);
$parcel$export(module.exports, "REMAINING_TIME_ESTIMATE", () => $6cb67893521cea43$export$612ef20a8c97681f);
$parcel$export(module.exports, "statisticFieldToEstimateType", () => $6cb67893521cea43$export$674f0c6f9382fdff);
$parcel$export(module.exports, "statisticFieldPrefixes", () => $6cb67893521cea43$export$69ce8a2ab6160d00);
$parcel$export(module.exports, "GROUP_TYPE", () => $6cb67893521cea43$export$d5d0dfb4a0060b5a);
const $6cb67893521cea43$export$45c85543ba71221d = 'YYYY-MM-DDTHH:mm:ssZ';
const $6cb67893521cea43$export$faf85b5ed93b0538 = 'd MMM';
const $6cb67893521cea43$export$dedbdcc35e955187 = 'BACKLOG';
const $6cb67893521cea43$export$9b8283d5878d2491 = 'BOARD';
const $6cb67893521cea43$export$a316570a0dbfd2b0 = 'SPRINT';
const $6cb67893521cea43$export$88abd69a9006b2b = 'INACTIVE_SPRINT';
const $6cb67893521cea43$export$2f9f63c9e8b8a7fc = 'ACTIVE_SPRINT';
const $6cb67893521cea43$export$1a271033d96c4e9a = 'TOP_OF_LIST';
const $6cb67893521cea43$export$fe366e1b5f8f6917 = 'BOTTOM_OF_LIST';
const $6cb67893521cea43$export$29472abe5c298701 = 'BOTTOM_OF_CARD_GROUP';
const $6cb67893521cea43$export$6ee6fb5615cbbfaf = 'BEFORE_CARD';
const $6cb67893521cea43$export$825ad5563e6c16b4 = 'TRANSITION_ZONE';
const $6cb67893521cea43$export$c53d0f541b41b88e = 'NONE';
const $6cb67893521cea43$export$7be7e0393bed6707 = 'ISSUE_LIST';
const $6cb67893521cea43$export$1dec7a5987befb9f = 'FUTURE';
const $6cb67893521cea43$export$91f438b1afe47b53 = 'ACTIVE';
const $6cb67893521cea43$export$c557f656e9558605 = 'SPRINT_MOVE_TO_TOP';
const $6cb67893521cea43$export$d44a21a036e6d362 = 'SPRINT_MOVE_UP';
const $6cb67893521cea43$export$c3959a41530f5d37 = 'SPRINT_MOVE_DOWN';
const $6cb67893521cea43$export$40b71d704f7a26b4 = 'SPRINT_MOVE_TO_BOTTOM';
const $6cb67893521cea43$export$cb17e3c17bc50301 = 'Epic';
const $6cb67893521cea43$export$b79b504ff88a1727 = 999;
const $6cb67893521cea43$export$bb1ee0864c80dcde = 'backlog.long-tasks-dnd';
const $6cb67893521cea43$export$8f153823e4517a88 = 'backlog.long-tasks-card-mouseleave';
const $6cb67893521cea43$export$48a5a6ab3930a7b0 = 'backlog.long-tasks-card-drag-to-drop-target';
const $6cb67893521cea43$export$d7ca4ead68e4382c = 'NONE';
const $6cb67893521cea43$export$3fa2dca6095ef23a = 'SPRINT';
const $6cb67893521cea43$export$946ee3a604b332d2 = 'ISSUE_LIST';
const $6cb67893521cea43$export$869ee62868d7be07 = 'KANBAN_BACKLOG';
const $6cb67893521cea43$export$d9d2fe902bd6d9a7 = 'FAILURE';
const $6cb67893521cea43$export$af001fd9213b0b63 = 'REALTIME';
const $6cb67893521cea43$export$9af8a111003cd702 = 'KANBAN_CARD_MOVE_SUCCESS';
const $6cb67893521cea43$export$8cabdc85b8691f12 = 'GLOBAL_ISSUE_CREATE';
const $6cb67893521cea43$export$600567015cf0b58e = 'SPRINT_COMPLETE';
const $6cb67893521cea43$export$443de2b93e4aa6c6 = 'STATUS_REMAPPED';
const $6cb67893521cea43$export$26392593c7297db8 = 'ON_MOUNT';
const $6cb67893521cea43$export$968a5895f5ee4e93 = 'ACTIVE_TAB';
const $6cb67893521cea43$export$8125ab02c04ac8e7 = 'POLLING';
const $6cb67893521cea43$export$66e48a348bf0e91e = 'ADD_ISSUE_TYPE_MODAL';
const $6cb67893521cea43$export$d76071d5de2774fc = 'software.backlog';
const $6cb67893521cea43$export$d57b6b390e78d90f = 'a4t-tanuki';
const $6cb67893521cea43$export$b8b9d90f9e5bd72b = '@atlassian/jira-software-backlog';
const $6cb67893521cea43$export$b893894941c14e43 = 'EDIT_BOARD_CONFIG';
const $6cb67893521cea43$export$4e8756b18ce4cf17 = 'DELETE_ISSUE';
const $6cb67893521cea43$export$a84692caf5a334ea = 'CREATE_ISSUE';
const $6cb67893521cea43$export$47e89ba04d79d88d = 'MANAGE_SPRINT';
const $6cb67893521cea43$export$52f11126cce982f0 = 'EDIT_ISSUE';
const $6cb67893521cea43$export$6fca44a139cecd72 = 'VIEW_BOARD';
const $6cb67893521cea43$export$120f9058cc2d23b7 = 'ADMINISTER_BOARD';
const $6cb67893521cea43$export$66cb530046350ea5 = 'BULK_CHANGE';
const $6cb67893521cea43$export$e3e5ec492e10f340 = 'ASSIGN_ISSUE';
const $6cb67893521cea43$export$627a3f8561c04066 = 'TRANSITION_ISSUE';
const $6cb67893521cea43$export$e371c88c3137ffb = 'issueCount_';
const $6cb67893521cea43$export$81b5ed4ed651b2bc = 'field_';
const $6cb67893521cea43$export$d02889a654103c98 = 'field_timeoriginalestimate';
const $6cb67893521cea43$export$4c2cf346f4d818c5 = 'timeoriginalestimate';
const $6cb67893521cea43$export$3a68c8006649e940 = 'field_customfield_';
const $6cb67893521cea43$export$4091097a73cc5002 = 'customfield_';
const $6cb67893521cea43$export$8775696968c9b13c = 'ISSUE_COUNT';
const $6cb67893521cea43$export$bfb354504bb547a0 = 'ORIGINAL_ESTIMATE';
const $6cb67893521cea43$export$405b6d72f2d243a9 = 'STORY_POINTS';
const $6cb67893521cea43$export$612ef20a8c97681f = 'timeestimate';
const $6cb67893521cea43$export$674f0c6f9382fdff = {
    [$6cb67893521cea43$export$e371c88c3137ffb]: $6cb67893521cea43$export$8775696968c9b13c,
    [$6cb67893521cea43$export$d02889a654103c98]: $6cb67893521cea43$export$bfb354504bb547a0,
    [$6cb67893521cea43$export$3a68c8006649e940]: $6cb67893521cea43$export$405b6d72f2d243a9
};
const $6cb67893521cea43$export$69ce8a2ab6160d00 = [
    $6cb67893521cea43$export$e371c88c3137ffb,
    $6cb67893521cea43$export$d02889a654103c98,
    $6cb67893521cea43$export$3a68c8006649e940
];
const $6cb67893521cea43$export$31089ea8b3e502e3 = 'card';
const $6cb67893521cea43$export$d5d0dfb4a0060b5a = 'group';

});

parcelRegister("9eH8H", function(module, exports) {

$parcel$export(module.exports, "HEADER_DROPPABLE_ID_PREFIX", () => $fbdd2903bf910039$export$5e2fff92b27c1bb8);
$parcel$export(module.exports, "CARD_LIST_DROPPABLE_TYPE", () => $fbdd2903bf910039$export$afbd2d45ce529690);
$parcel$export(module.exports, "CARD_GROUP_DROPPABLE_TYPE", () => $fbdd2903bf910039$export$849c01670da437ac);
$parcel$export(module.exports, "TRANSITION_ZONE_DROPPABLE_TYPE", () => $fbdd2903bf910039$export$6e35851fe8cf8301);
$parcel$export(module.exports, "UNASSIGNED_EPIC_ID", () => $fbdd2903bf910039$export$794f07be04aca3fe);
$parcel$export(module.exports, "DND_DROP_ZONES_ACTIVE_SPRINT", () => $fbdd2903bf910039$export$adbf9ce386bc3037);
$parcel$export(module.exports, "DND_DROP_ZONES_FUTURE_SPRINT", () => $fbdd2903bf910039$export$bb216fa10db6b6bb);
$parcel$export(module.exports, "DND_DROP_ZONES_BOARD", () => $fbdd2903bf910039$export$338b523135b4db48);
$parcel$export(module.exports, "DND_DROP_ZONES_BACKLOG", () => $fbdd2903bf910039$export$f6bf4fdaad3caf69);
$parcel$export(module.exports, "DND_TARGET_BACKLOG_CARD", () => $fbdd2903bf910039$export$695859afe4db61d7);
$parcel$export(module.exports, "DND_TARGET_DIVIDER", () => $fbdd2903bf910039$export$62679ec8251801eb);
$parcel$export(module.exports, "DND_OPERATION_MOVE_INSIDE_LIST", () => $fbdd2903bf910039$export$7ade48b3d11b4061);
$parcel$export(module.exports, "DND_OPERATION_MOVE_TO_ACTIVE_SPRINT", () => $fbdd2903bf910039$export$1ffb6fb519522507);
$parcel$export(module.exports, "DND_OPERATION_MOVE_TO_FUTURE_SPRINT", () => $fbdd2903bf910039$export$f1ed61bbffc6eb2c);
$parcel$export(module.exports, "DND_OPERATION_MOVE_TO_BACKLOG", () => $fbdd2903bf910039$export$dc9b10088e3cd5b6);
$parcel$export(module.exports, "DND_OPERATION_MOVE_TO_BOARD", () => $fbdd2903bf910039$export$5b4e8a4b9c2dd508);
$parcel$export(module.exports, "CARD_ROW_HEIGHT", () => $fbdd2903bf910039$export$6be26aedd8f95d5e);
$parcel$export(module.exports, "COMPACT_CARD_ROW_HEIGHT", () => $fbdd2903bf910039$export$9207e617cac36dce);
$parcel$export(module.exports, "EXTRA_CARD_ROW_HEIGHT", () => $fbdd2903bf910039$export$85b6f126b8e736d4);
$parcel$export(module.exports, "INLINE_CARD_CREATE_ROW_HEIGHT", () => $fbdd2903bf910039$export$226ce682b3342af4);
$parcel$export(module.exports, "LABELS_FIELD_SEPARATOR", () => $fbdd2903bf910039$export$e74bc8e59eb08066);
$parcel$export(module.exports, "CUSTOM_FIELD_ID_REGEX", () => $fbdd2903bf910039$export$cb26d91c4e639201);
$parcel$export(module.exports, "UNASSIGNED_USER", () => $fbdd2903bf910039$export$299e0e1e1265f5e9);

const $fbdd2903bf910039$export$5e2fff92b27c1bb8 = 'HEADER-DROP-';
const $fbdd2903bf910039$export$afbd2d45ce529690 = 'CARD';
const $fbdd2903bf910039$export$849c01670da437ac = 'CARD-GROUP';
const $fbdd2903bf910039$export$6e35851fe8cf8301 = 'TRANSITION-ZONE';
const $fbdd2903bf910039$export$794f07be04aca3fe = 0;
const $fbdd2903bf910039$export$adbf9ce386bc3037 = 'activeSprint';
const $fbdd2903bf910039$export$bb216fa10db6b6bb = 'futureSprint';
const $fbdd2903bf910039$export$3df2915b3d2a36e = 'sprint';
const $fbdd2903bf910039$export$338b523135b4db48 = 'board';
const $fbdd2903bf910039$export$f6bf4fdaad3caf69 = 'backlog';
const $fbdd2903bf910039$export$67e35e305110c91d = 'epicPanel';
const $fbdd2903bf910039$export$f95492d2a4f371d0 = 'versionPanel';
const $fbdd2903bf910039$export$2a5a5a3183150769 = 'cardGroup';
const $fbdd2903bf910039$export$695859afe4db61d7 = 'backlogCard';
const $fbdd2903bf910039$export$b1b86bcaf2a12330 = 'epicPanelCard';
const $fbdd2903bf910039$export$2e29fc7afa544ab5 = 'versionPanelCard';
const $fbdd2903bf910039$export$62679ec8251801eb = 'divider';
const $fbdd2903bf910039$export$a080ee3f8cb7aa62 = 'moveListToList';
const $fbdd2903bf910039$export$7ade48b3d11b4061 = 'moveInsideList';
const $fbdd2903bf910039$export$1ffb6fb519522507 = 'moveToActiveSprint';
const $fbdd2903bf910039$export$f1ed61bbffc6eb2c = 'moveToFutureSprint';
const $fbdd2903bf910039$export$dc9b10088e3cd5b6 = 'moveToBacklog';
const $fbdd2903bf910039$export$5b4e8a4b9c2dd508 = 'moveToBoard';
const $fbdd2903bf910039$export$41f0d8a4d1ec169b = 'cardParentSet';
const $fbdd2903bf910039$export$bc493dacb9d33787 = 'epicRankUpdate';
const $fbdd2903bf910039$export$6be26aedd8f95d5e = 40;
const $fbdd2903bf910039$export$9207e617cac36dce = 32;
const $fbdd2903bf910039$export$85b6f126b8e736d4 = 30;
const $fbdd2903bf910039$export$226ce682b3342af4 = 40;
const $fbdd2903bf910039$export$e74bc8e59eb08066 = ', ';
const $fbdd2903bf910039$export$cb26d91c4e639201 = /^customfield_([0-9]+)$/;
const $fbdd2903bf910039$export$299e0e1e1265f5e9 = {
    id: (0, $44677eb502cfd308$export$12e572fd459c10dc),
    displayName: '',
    avatarUrl: ''
};

});
const $44677eb502cfd308$export$d597759d33be802e = 'TEXT';
const $44677eb502cfd308$export$f8f7545d2bb78afb = 'ASSIGNEE';
const $44677eb502cfd308$export$37aee82a3cb1e8f7 = 'LABEL';
const $44677eb502cfd308$export$2a4f270075a033de = 'ISSUE_PARENT';
const $44677eb502cfd308$export$401f4b6eda6a369c = 'ISSUE_PROJECT';
const $44677eb502cfd308$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $44677eb502cfd308$export$a4ad2735b021c132 = 'VERSION';
const $44677eb502cfd308$export$af1e30ebbae9df3b = 'COMPONENT';
const $44677eb502cfd308$export$f863b019d19144f4 = 'STATUS_CATEGORY';
const $44677eb502cfd308$export$a316570a0dbfd2b0 = 'SPRINT';
const $44677eb502cfd308$export$e50006273435e7d4 = 'STATUS';
const $44677eb502cfd308$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $44677eb502cfd308$export$68d693c35a8d8866 = 'CUSTOM_FILTER';
const $44677eb502cfd308$export$1ea95b94fb0c51d9 = 'QUICK_FILTER';
const $44677eb502cfd308$export$871e58afc769b358 = 'GOAL';
const $44677eb502cfd308$export$6c4d37c7f376a1de = 'CLEAR';
const $44677eb502cfd308$export$12e572fd459c10dc = 'unassigned';
const $44677eb502cfd308$export$ac95b4b2317d4b33 = 'unassigned';
const $44677eb502cfd308$export$81ef49afbbead0a1 = 'label unassigned';
const $44677eb502cfd308$export$4b7c755e61199a36 = 'unassigned';
const $44677eb502cfd308$export$c9408e3fb31ddc71 = 'offline';
const $44677eb502cfd308$export$7a105aa475396c65 = 'online';





parcelRegister("6M1P4", function(module, exports) {

$parcel$export(module.exports, "useVersionsRefetch", () => $1ca4268321463986$export$869337d912ff312a);

var $RHEhT = parcelRequire("RHEhT");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $2k5g9 = parcelRequire("2k5g9");
const $1ca4268321463986$export$869337d912ff312a = ()=>{
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const boardAri = (0, $2k5g9.useBoardAri)();
    return (0, $eUqFw.useCallback)((jiraProjectIds)=>(0, $iWLL0.fetchQuery)(environment, (0, $RHEhT.default), {
            jiraProjectIds: jiraProjectIds,
            boardId: boardAri
        }), [
        boardAri,
        environment
    ]);
};

});
parcelRegister("RHEhT", function(module, exports) {

$parcel$export(module.exports, "default", () => $711030cea1e955f8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<aadcdd660ac95134ab98c94bc687504c>>
 * @relayHash 6ae849488f1b7fb0d94348332fe27dd4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d486ba02919e69bb0242ace558c2ea8bec89ba6865a123350b455b691c2ae8e2
const $711030cea1e955f8$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraProjectIds"
    }, v2 = {
        "kind": "Literal",
        "name": "filter",
        "value": [
            "UNRELEASED"
        ]
    }, v3 = {
        "kind": "Variable",
        "name": "jiraProjectIds",
        "variableName": "jiraProjectIds"
    }, v4 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v7 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v8 = [
        v2 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        },
        v3 /*: any*/ 
    ], v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useVersionsRefetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "versionsForProjects",
                                "args": [
                                    v2 /*: any*/ ,
                                    v3 /*: any*/ 
                                ],
                                "concreteType": "JiraVersionConnection",
                                "kind": "LinkedField",
                                "name": "__versionBacklogPanelRelay_versionsForProjects_connection",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraVersionEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "versionPanel_softwareVersionBacklogPanelRelay_jiraVersionEdges"
                                            },
                                            {
                                                "concreteType": "JiraVersion",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v4 /*: any*/ ,
                                                    v5 /*: any*/ 
                                                ]
                                            },
                                            v6 /*: any*/ 
                                        ]
                                    },
                                    v7 /*: any*/ 
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.versionsForProjects"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useVersionsRefetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "concreteType": "JiraVersionConnection",
                            "kind": "LinkedField",
                            "name": "versionsForProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraVersionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersion",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "description"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "status"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "startDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "releaseDate"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "boardId",
                                                            "variableName": "boardId"
                                                        }
                                                    ],
                                                    "concreteType": "JiraVersionStatistics",
                                                    "kind": "LinkedField",
                                                    "name": "statistics",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "doneEstimate"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "totalEstimate"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "percentageCompleted"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "notEstimated"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "done"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "totalIssueCount"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "toDo"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "inProgress"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        v10 /*: any*/ ,
                                                        {
                                                            "alias": "editProjectConfig",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "type",
                                                                    "value": "EDIT_PROJECT_CONFIG"
                                                                }
                                                            ],
                                                            "concreteType": "JiraProjectAction",
                                                            "kind": "LinkedField",
                                                            "name": "action",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canPerform"
                                                                }
                                                            ],
                                                            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                },
                                                v10 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ]
                                },
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "args": v8 /*: any*/ ,
                            "filters": [
                                "jiraProjectIds",
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "versionBacklogPanelRelay_versionsForProjects",
                            "kind": "LinkedHandle",
                            "name": "versionsForProjects"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d486ba02919e69bb0242ace558c2ea8bec89ba6865a123350b455b691c2ae8e2",
            "metadata": {
                "connection": [
                    {
                        "count": null,
                        "cursor": null,
                        "direction": "forward",
                        "path": [
                            "jira",
                            "versionsForProjects"
                        ]
                    }
                ]
            },
            "name": "useVersionsRefetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$711030cea1e955f8$var$node.hash = "49947aa3f8615f5dcdee393f6d3fd187";
var $711030cea1e955f8$export$2e2bcd8739ae039 = $711030cea1e955f8$var$node;

});

parcelRegister("2k5g9", function(module, exports) {

$parcel$export(module.exports, "useBoardAri", () => $853288dd75ff38d6$export$f53dd1c04c0f3767);

var $huI7r = parcelRequire("huI7r");

var $kJlBc = parcelRequire("kJlBc");

var $dWLk9 = parcelRequire("dWLk9");
const $853288dd75ff38d6$export$f53dd1c04c0f3767 = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const [{ match: match }] = (0, $kJlBc.useRouter)();
    return (0, $huI7r.createAri)({
        resourceOwner: 'jira-software',
        cloudId: cloudId,
        resourceType: 'board',
        resourceId: String(match.params.boardId)
    });
};

});


parcelRegister("8wXFi", function(module, exports) {

$parcel$export(module.exports, "JSW_SPRINT_PLANNING_WHITEBOARDS_ENTRYPOINT", () => $2a38e25fbb065b91$export$c96e6dd90e90240d);
$parcel$export(module.exports, "getBacklogRealtimeDebounceIntervalMillisecs", () => $2a38e25fbb065b91$export$4eabd6f79a1f0249);
$parcel$export(module.exports, "isErrorTrackingEnabledWithSentry", () => $2a38e25fbb065b91$export$23d600ca6d887b4d);
$parcel$export(module.exports, "isBacklogWithRelayEnabled", () => $2a38e25fbb065b91$export$bc84f8a9593e9b2c);
$parcel$export(module.exports, "isLongTasksRefactorEnabled", () => $2a38e25fbb065b91$export$dd0b3b59404a264e);
$parcel$export(module.exports, "isAlternateTTIMeasurementEnabled", () => $2a38e25fbb065b91$export$3a05e889d4f932e);
$parcel$export(module.exports, "emitApdexOnAnimationFrame", () => $2a38e25fbb065b91$export$2d887f955f551bbf);
$parcel$export(module.exports, "getBacklogPollingInterval", () => $2a38e25fbb065b91$export$e562d26697a3604);
$parcel$export(module.exports, "isNewInlineEditEstimateComponentsEnabled", () => $2a38e25fbb065b91$export$6e9f4841cb12f3f7);
$parcel$export(module.exports, "isInAddPeopleButtonOpenTMPExperimentCohort", () => $2a38e25fbb065b91$export$c1643b1f0828d302);
$parcel$export(module.exports, "isBacklogCardEstimatesA11yImprovementsEnabled", () => $2a38e25fbb065b91$export$51b76b215c678d10);
$parcel$export(module.exports, "isEpicPanelInProgressBarTooltipsUpdateEnabled", () => $2a38e25fbb065b91$export$27e8747e31aae323);
$parcel$export(module.exports, "isViewSettingAsPanelExpEnabledWithNoExposure", () => $2a38e25fbb065b91$export$6f295af995afef94);
$parcel$export(module.exports, "isIssueTypeInContextExperimentEnabled", () => $2a38e25fbb065b91$export$d30d71a42f5b1ecd);
/**
 * Feature flags convention: go/frontend-feature-flags. Please ensure integration tests are still working afterwards.
 */ 
var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");
// Add your feature flag name as a constant
const $2a38e25fbb065b91$var$ERROR_TRACKING_ENABLED = 'fe.platform.error.tracking.enabled';
const $2a38e25fbb065b91$var$BACKLOG_REALTIME_DEBOUNCE_INTERVAL = 'jsw.nextgen.backlog.realtime.debounce.interval';
const $2a38e25fbb065b91$var$CRITICAL_QUERY_WITH_RELAY = 'jsw.perf.critical-backlog-with-relay';
const $2a38e25fbb065b91$var$LONGTASKS_REFACTOR_ENABLED = 'jsw.long-tasks-refactor';
const $2a38e25fbb065b91$var$BACKLOG_WITH_RELAY_ENABLED = 'jsw.perf.critical-backlog-with-relay';
const $2a38e25fbb065b91$var$EMIT_APDEX_ON_ANIMATION_FRAME = 'jsw.perf.board-backlog-emit-apdex-on-animation-frame';
const $2a38e25fbb065b91$var$BACKLOG_POLLING_INTERVAL = 'jsw.nextgen.backlog.polling.interval';
const $2a38e25fbb065b91$var$ALTERNATE_TTI = 'jsw-measure-tti-alternate';
const $2a38e25fbb065b91$var$NEW_INLINE_EDIT_ESTMATE_COMPONENTS = 'jsw.perf.new-inline-edit-estimate-components';
const $2a38e25fbb065b91$var$JSW_BACKLOG_CARD_ESTIMATES_A11Y_IMPROVEMENTS = 'sea-2524-backlog-card-estimates-a11y-improvements_1ljqi';
const $2a38e25fbb065b91$var$FETCH_BACKLOG_CHILD_ISSUES_DATA = 'sea-2127-backlog-fetch-child-issues-data-tmps_obopa';
const $2a38e25fbb065b91$var$UIF_STATSIG_EXPOSURES_UPDATES = 'jsw.perf.uif.statsig-exposures-update';
const $2a38e25fbb065b91$export$c96e6dd90e90240d = 'jsw_sprint_planning_whiteboards';
const $2a38e25fbb065b91$export$52a40ff46dc0c1ad = [
    $2a38e25fbb065b91$var$ERROR_TRACKING_ENABLED,
    $2a38e25fbb065b91$var$CRITICAL_QUERY_WITH_RELAY,
    $2a38e25fbb065b91$var$BACKLOG_WITH_RELAY_ENABLED,
    $2a38e25fbb065b91$var$LONGTASKS_REFACTOR_ENABLED,
    $2a38e25fbb065b91$var$ALTERNATE_TTI,
    $2a38e25fbb065b91$var$EMIT_APDEX_ON_ANIMATION_FRAME,
    $2a38e25fbb065b91$var$BACKLOG_POLLING_INTERVAL,
    $2a38e25fbb065b91$var$NEW_INLINE_EDIT_ESTMATE_COMPONENTS,
    $2a38e25fbb065b91$var$JSW_BACKLOG_CARD_ESTIMATES_A11Y_IMPROVEMENTS,
    $2a38e25fbb065b91$var$FETCH_BACKLOG_CHILD_ISSUES_DATA,
    'modify-cmp-backlog-epic-panel-in-progress-bar-tooltips_gusjl',
    $2a38e25fbb065b91$var$UIF_STATSIG_EXPOSURES_UPDATES,
    $2a38e25fbb065b91$export$c96e6dd90e90240d,
    'show-board-filter-permission-message-to-admins_iqh25',
    'thor-add-original-estimate-to-list-of-available-fields_o4qx6',
    'render-time-tracking-field-in-bulk-edit_nqgx7'
];
const $2a38e25fbb065b91$export$4eabd6f79a1f0249 = ()=>(0, $1ybV0.getFeatureFlagValue)($2a38e25fbb065b91$var$BACKLOG_REALTIME_DEBOUNCE_INTERVAL, 500);
const $2a38e25fbb065b91$export$23d600ca6d887b4d = ()=>(0, $1ybV0.ff)('fe.platform.error.tracking.enabled');
const $2a38e25fbb065b91$export$dbc1d97903ce0912 = ()=>(0, $1ybV0.ff)('jsw.perf.critical-backlog-with-relay');
const $2a38e25fbb065b91$export$bc84f8a9593e9b2c = ()=>(0, $1ybV0.ff)('jsw.perf.critical-backlog-with-relay');
const $2a38e25fbb065b91$export$dd0b3b59404a264e = ()=>(0, $1ybV0.ff)('jsw.long-tasks-refactor');
const $2a38e25fbb065b91$export$3a05e889d4f932e = ()=>(0, $1ybV0.ff)('jsw-measure-tti-alternate');
const $2a38e25fbb065b91$export$2d887f955f551bbf = ()=>(0, $1ybV0.ff)('jsw.perf.board-backlog-emit-apdex-on-animation-frame');
const $2a38e25fbb065b91$export$e562d26697a3604 = ()=>(0, $1ybV0.getFeatureFlagValue)($2a38e25fbb065b91$var$BACKLOG_POLLING_INTERVAL, 600000);
const $2a38e25fbb065b91$export$6e9f4841cb12f3f7 = ()=>(0, $1ybV0.ff)('jsw.perf.new-inline-edit-estimate-components');
function $2a38e25fbb065b91$export$c1643b1f0828d302() {
    return (0, $79xbN.expValEquals)('open_invite_for_open_tmp_projects', 'cohort', 'experiment');
}
const $2a38e25fbb065b91$export$51b76b215c678d10 = ()=>(0, $1ybV0.ff)('sea-2524-backlog-card-estimates-a11y-improvements_1ljqi');
const $2a38e25fbb065b91$export$27e8747e31aae323 = ()=>(0, $1ybV0.ff)('modify-cmp-backlog-epic-panel-in-progress-bar-tooltips_gusjl');
const $2a38e25fbb065b91$export$6f295af995afef94 = ()=>{
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_additional_card_fields_in_view_settings');
    return expConfig.get('cohort', 'not-enrolled') === 'variation';
};
const $2a38e25fbb065b91$export$d30d71a42f5b1ecd = ()=>{
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_config_in_context_issue_types_m2');
    return(// kill switch
    (0, $1ybV0.ff)('config-in-context-issue-type-m2-flag_bddyq') && // check if user is in test / experimentation cohort
    expConfig.get('inlineIssueTypeConfigEnabled', false));
}; // </hyustiawan>

});

parcelRegister("2a0bR", function(module, exports) {

$parcel$export(module.exports, "flagsMapper", () => $435b3cb5e1bdb737$export$4de5eb17326eea98);

var $eUqFw = parcelRequire("eUqFw");

var $iy2aZ = parcelRequire("iy2aZ");

var $illlw = parcelRequire("illlw");

var $3tfzg = parcelRequire("3tfzg");

var $cy3VF = parcelRequire("cy3VF");

var $2emZ8 = parcelRequire("2emZ8");
var $hr2LF = parcelRequire("hr2LF");

var $hniWi = parcelRequire("hniWi");

var $lsENz = parcelRequire("lsENz");

var $5awap = parcelRequire("5awap");

var $7Egcu = parcelRequire("7Egcu");

var $70VKY = parcelRequire("70VKY");

var $bR721 = parcelRequire("bR721");

var $8FgXV = parcelRequire("8FgXV");

var $fIMef = parcelRequire("fIMef");

var $glOhA = parcelRequire("glOhA");

var $ll1jU = parcelRequire("ll1jU");

var $2JAFl = parcelRequire("2JAFl");

var $perS5 = parcelRequire("perS5");

var $27voR = parcelRequire("27voR");

var $j0Zfx = parcelRequire("j0Zfx");

var $4TzjO = parcelRequire("4TzjO");

var $4WG4e = parcelRequire("4WG4e");

var $6gbQ2 = parcelRequire("6gbQ2");
const $435b3cb5e1bdb737$export$4de5eb17326eea98 = (action)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(action, [
        'meta',
        'optimistic',
        'type'
    ], null) === (0, $iy2aZ.REVERT) && (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(action, [
        'meta',
        'showGenericFlag'
    ], null) === true) return (0, $3tfzg.default).genericError();
    switch(action.type){
        case 0, $lsENz.CARD_CREATE_FILTERED:
            return (props)=>// @ts-expect-error - TS2322 - Type '{ card: Card; id: string | number; onDismissed: ((id: string | number) => void) & ((id: string | number) => void); }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<Component<Omit<{ onPrimaryActionClick: (cardId: any) => void; }, "onPrimaryActionClick">, any, any>> & Readonly<...> & Readonly<...>'.
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8FgXV.default), {
                    ...props,
                    card: action.payload
                });
        case 0, $lsENz.CARD_CREATE_FILTERED_V2:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fIMef.default), {
                    ...props,
                    cardIds: action.payload
                });
        case 0, $7Egcu.CARD_DRAG_DISALLOWED:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2JAFl.CardDragDisallowedFlag), props);
        case 0, $70VKY.FLAG_SPRINT_STARTED:
            return (0, $4WG4e.showSprintStartedFlag)();
        case 0, $hr2LF.SHOW_ERROR_FLAG_FROM_SWAG:
            return (0, $2emZ8.extractFlagFromAction)(action);
        case 0, $lsENz.CARD_CREATE_UNMAPPED_WITH_ISSUE_LINK:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ll1jU.default), {
                    ...props,
                    cardKeys: action.payload.cardsIdentifiers.map((cardIds)=>cardIds.key)
                });
        case 0, $lsENz.CARD_CREATE_UNMAPPED:
            return (props)=>{
                const { payload: { cardKeys: cardKeys, numIssues: numIssues } } = action;
                if (cardKeys) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ll1jU.default), {
                    ...props,
                    cardKeys: cardKeys
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $glOhA.default), {
                    ...props,
                    numIssues: numIssues
                });
            };
        case 0, $5awap.FILTERED_CARD_FAILURE:
        case 0, $5awap.REFILTER_FAILURE:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j0Zfx.default), props);
        case 0, $5awap.FILTERED_CARD_CLEAR_FAILURE:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27voR.default), props);
        case 0, $lsENz.CARD_CREATE_GLOBAL:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cy3VF.CardCreateGlobalFlag), {
                    ...props,
                    cardKeys: action.payload.globalIssues.map((issue)=>issue.issueKey)
                });
        case 0, $lsENz.CARD_CREATE_SPLIT_ISSUE:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TzjO.SplitIssueSuccessFlag), {
                    ...props,
                    originalIssueKey: action.payload.originalIssueKey,
                    issueKeys: action.payload.newIssueKeys
                });
        case 0, $7Egcu.CARDS_MOVE_DISABLED:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $perS5.default), {
                    ...props,
                    boardId: action.payload.boardId,
                    isAdmin: action.payload.isAdmin
                });
        case 0, $7Egcu.CARDS_TRANSITION_AND_RANK_FAILURE:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6gbQ2.TransitionAndRankFailureFlag), {
                    ...props,
                    errorMessages: action.payload.errorMessages
                });
        case 0, $hniWi.BULK_OPS_SHOW_FAILED_FLAG:
            return (props)=>{
                const { payload: payload } = action;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bR721.default), {
                    ...props,
                    ...payload
                });
            };
        default:
            return undefined;
    }
};

});
parcelRegister("iy2aZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.optimistic = module.exports.ensureState = module.exports.REVERT = module.exports.COMMIT = module.exports.BEGIN = undefined;
var $d80d17235e179581$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $77HuI = parcelRequire("77HuI");
var $d80d17235e179581$var$BEGIN = module.exports.BEGIN = '@@optimist/BEGIN';
var $d80d17235e179581$var$COMMIT = module.exports.COMMIT = '@@optimist/COMMIT';
var $d80d17235e179581$var$REVERT = module.exports.REVERT = '@@optimist/REVERT';
var $d80d17235e179581$var$isOptimistState = function isOptimistState(state) {
    return state && Object.keys(state).length === 3 && state.hasOwnProperty('beforeState') && state.hasOwnProperty('history') && state.hasOwnProperty('current');
};
var $d80d17235e179581$var$ensureState = module.exports.ensureState = function ensureState(state) {
    return $d80d17235e179581$var$isOptimistState(state) ? state.current : state;
};
var $d80d17235e179581$var$createState = function createState(state) {
    return {
        beforeState: undefined,
        history: [],
        current: state
    };
};
var $d80d17235e179581$var$applyCommit = function applyCommit(state, targetActionIndex, reducer) {
    var history = state.history;
    // If the action to commit is the first in the queue (most common scenario)
    if (targetActionIndex === 0) {
        var historyWithoutCommit = history.slice(1);
        var nextOptimisticIndex = (0, $77HuI.findIndex)(historyWithoutCommit, function(action) {
            return action.meta && action.meta.optimistic && !action.meta.optimistic.isNotOptimistic && action.meta.optimistic.id;
        });
        // If this is the only optimistic item in the queue, we're done!
        if (nextOptimisticIndex === -1) return $d80d17235e179581$var$_extends({}, state, {
            history: [],
            beforeState: undefined
        });
        // Create a new history starting with the next one
        var newHistory = historyWithoutCommit.slice(nextOptimisticIndex);
        // And run every action up until that next one to get the new beforeState
        var newBeforeState = history.reduce(function(mutState, action, index) {
            return index <= nextOptimisticIndex ? reducer(mutState, action) : mutState;
        }, state.beforeState);
        return $d80d17235e179581$var$_extends({}, state, {
            history: newHistory,
            beforeState: newBeforeState
        });
    } else {
        // If the committed action isn't the first in the queue, find out where it is
        var actionToCommit = history[targetActionIndex];
        // Make it a regular non-optimistic action
        var newAction = Object.assign({}, actionToCommit, {
            meta: Object.assign({}, actionToCommit.meta, {
                optimistic: null
            })
        });
        var _newHistory = state.history.slice();
        _newHistory.splice(targetActionIndex, 1, newAction);
        return $d80d17235e179581$var$_extends({}, state, {
            history: _newHistory
        });
    }
};
var $d80d17235e179581$var$applyRevert = function applyRevert(state, targetActionIndex, reducer) {
    var beforeState = state.beforeState, history = state.history;
    var newHistory = void 0;
    // If the action to revert is the first in the queue (most common scenario)
    if (targetActionIndex === 0) {
        var historyWithoutRevert = history.slice(1);
        var nextOptimisticIndex = (0, $77HuI.findIndex)(historyWithoutRevert, function(action) {
            return action.meta && action.meta.optimistic && !action.meta.optimistic.isNotOptimistic && action.meta.optimistic.id;
        });
        // If this is the only optimistic action in the queue, we're done!
        if (nextOptimisticIndex === -1) return $d80d17235e179581$var$_extends({}, state, {
            history: [],
            current: historyWithoutRevert.reduce(function(s, action) {
                return reducer(s, action);
            }, beforeState),
            beforeState: undefined
        });
        newHistory = historyWithoutRevert.slice(nextOptimisticIndex);
    } else {
        newHistory = history.slice();
        newHistory.splice(targetActionIndex, 1);
    }
    var newCurrent = newHistory.reduce(function(s, action) {
        return reducer(s, action);
    }, beforeState);
    return $d80d17235e179581$var$_extends({}, state, {
        history: newHistory,
        current: newCurrent,
        beforeState: beforeState
    });
};
var $d80d17235e179581$var$optimistic = module.exports.optimistic = function optimistic(reducer) {
    var rawConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var config = Object.assign({
        maxHistory: 100
    }, rawConfig);
    return function(state, action) {
        if (state === undefined || !$d80d17235e179581$var$isOptimistState(state)) state = $d80d17235e179581$var$createState(reducer($d80d17235e179581$var$ensureState(state), {}));
        var historySize = state.history.length;
        var _ref = action.meta && action.meta.optimistic || {}, type = _ref.type, id = _ref.id;
        // a historySize means there is at least 1 outstanding fetch
        if (historySize) {
            if (type !== $d80d17235e179581$var$COMMIT && type !== $d80d17235e179581$var$REVERT) {
                if (historySize > config.maxHistory) console.error('@@optimist: Possible memory leak detected.\n                  Verify all actions result in a commit or revert and\n                  don\'t use optimistic-UI for long-running server fetches');
                // if it's a BEGIN but we already have a historySize, treat it like a non-opt
                return $d80d17235e179581$var$_extends({}, state, {
                    history: state.history.concat([
                        action
                    ]),
                    current: reducer(state.current, action)
                });
            }
            var targetActionIndex = (0, $77HuI.findIndex)(state.history, function(action) {
                return action.meta && action.meta.optimistic && action.meta.optimistic.id === id;
            });
            if (targetActionIndex === -1) throw new Error('@@optimist: Failed to ' + (type === $d80d17235e179581$var$COMMIT ? 'commit' : 'revert') + '. Transaction #' + id + ' does not exist!');
            // for resolutions, add a flag so that we know it is not an optimistic action
            action.meta.optimistic.isNotOptimistic = true;
            // include the resolution in the history & current state
            var nextState = $d80d17235e179581$var$_extends({}, state, {
                history: state.history.concat([
                    action
                ]),
                current: reducer(state.current, action)
            });
            var applyFunc = type === $d80d17235e179581$var$COMMIT ? $d80d17235e179581$var$applyCommit : $d80d17235e179581$var$applyRevert;
            return applyFunc(nextState, targetActionIndex, reducer);
        }
        // create a beforeState since one doesn't already exist
        if (type === $d80d17235e179581$var$BEGIN) return $d80d17235e179581$var$_extends({}, state, {
            history: state.history.concat([
                action
            ]),
            current: reducer(state.current, action),
            beforeState: state.current
        });
        // standard action escape
        return $d80d17235e179581$var$_extends({}, state, {
            current: reducer(state.current, action)
        });
    };
};

});
parcelRegister("77HuI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findIndex = $52faecf4d2bdd0cc$var$findIndex;
function $52faecf4d2bdd0cc$var$findIndex(arr, predicate) {
    var l = arr.length;
    for(var i = 0; i < l; i++){
        if (predicate(arr[i])) return i;
    }
    return -1;
}

});


parcelRegister("cy3VF", function(module, exports) {

$parcel$export(module.exports, "CardCreateGlobalFlag", () => $8c145b922db40d08$export$b6918b93a6420e06);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $9zysr = parcelRequire("9zysr");

var $eI5EY = parcelRequire("eI5EY");

var $kQ0RL = parcelRequire("kQ0RL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kffDO = parcelRequire("kffDO");
var $15YMg = parcelRequire("15YMg");

var $gjVGb = parcelRequire("gjVGb");

var $mANno = parcelRequire("mANno");
const $8c145b922db40d08$var$GLOBAL_CREATE_POLLINATOR_DATA_TEST_ID = 'jira-issue-create.modal.create-form.success-flag';
const $8c145b922db40d08$export$93f5b027a66006a6 = ({ onDismissed: onDismissed, id: id, cardKeys: cardKeys })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isCopied, setCopied] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        let timeoutId;
        if (isCopied) timeoutId = setTimeout(()=>{
            setCopied(false);
        }, 2000);
        return ()=>{
            timeoutId && clearTimeout(timeoutId);
        };
    }, [
        isCopied
    ]);
    const issueDiscoveryUrl = (0, $gjVGb.getIssueDiscoveryUrl)(cardKeys);
    const copyToClipboard = (0, $eUqFw.useCallback)(()=>{
        navigator.clipboard.writeText(`${window.location.origin}${issueDiscoveryUrl}`);
        setCopied(true);
    }, [
        issueDiscoveryUrl
    ]);
    const flagTitle = cardKeys.length > 1 ? formatMessage((0, $mANno.default).multiplesIssuesCreatedSuccessFlagTitle, {
        issueCount: cardKeys.length
    }) : formatMessage((0, $mANno.default).createSuccessFlagTitle, {
        issueKey: cardKeys[0]
    });
    const actions = [
        {
            content: formatMessage((0, $mANno.default).viewIssueLinkText, {
                numIssues: cardKeys.length
            }),
            href: issueDiscoveryUrl
        },
        {
            content: isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8c145b922db40d08$var$CopySuccess, null, formatMessage((0, $mANno.default).linkCopied)) : formatMessage((0, $mANno.default).copyLink),
            onClick: ()=>{
                copyToClipboard();
            }
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": $8c145b922db40d08$var$GLOBAL_CREATE_POLLINATOR_DATA_TEST_ID,
        "data-issue-key": cardKeys[0]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.SuccessAutoDismissFlag), {
        id: id,
        onDismissed: onDismissed,
        title: flagTitle,
        actions: actions
    }));
};
const $8c145b922db40d08$var$CheckEligibilityAndReturnFlag = (props)=>{
    const { id: id, cardKeys: cardKeys, onDismissed: onDismissed } = props;
    const { isLoading: isLoading, shouldShowRecommendTrialFlag: shouldShowRecommendTrialFlag } = (0, $15YMg.useRecommendTrialToFree)({
        id: id
    });
    if (isLoading) return null;
    if (shouldShowRecommendTrialFlag) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kffDO.RecommendTrialToFreeFlag), {
        flagId: `${id}`,
        issueKeys: cardKeys,
        onDismiss: onDismissed ? ()=>onDismissed(id) : undefined
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8c145b922db40d08$export$93f5b027a66006a6, props);
};
const $8c145b922db40d08$export$b6918b93a6420e06 = (0, $9zysr.componentWithCondition)(()=>(0, $eI5EY.fg)('jira_recommended_trial_to_free_ab_gate'), $8c145b922db40d08$var$CheckEligibilityAndReturnFlag, $8c145b922db40d08$export$93f5b027a66006a6); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8c145b922db40d08$var$CopySuccess = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1ft0",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kQ0RL", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $2ffdc518941fd08c$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $2ffdc518941fd08c$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $2ffdc518941fd08c$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $2ffdc518941fd08c$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $2ffdc518941fd08c$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $2ffdc518941fd08c$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $2ffdc518941fd08c$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $2ffdc518941fd08c$export$a2c3479950310d7d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $1ybV0 = parcelRequire("1ybV0");

var $5L0Jp = parcelRequire("5L0Jp");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintCommonFlag = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("aiVXY")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintCommonFlag = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("aiVXY")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintJiraCommonFlag = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("aiVXY")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintJiraCommonFlag = (0, $7rh0R.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("aiVXY")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$CommonFlagImpl = (props)=>{
    if ((0, $1ybV0.ff)('post-office_enable_jira_choreographer')) return __SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintJiraCommonFlag, props);
    return __SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintCommonFlag, props);
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintFlagGroup = (0, $7rh0R.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("Tabui")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintFlagGroup = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("Tabui")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintFlagGroup, props);
const $2ffdc518941fd08c$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, props));
const $2ffdc518941fd08c$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $2ffdc518941fd08c$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $2ffdc518941fd08c$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $2ffdc518941fd08c$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $2ffdc518941fd08c$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$FlagGroupImpl, props));

});
parcelRegister("aiVXY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('cCYJs')
        ]);
        const value = parcelRequire('kbpOk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("cCYJs")
    ]).then(()=>parcelRequire('kbpOk'));
}

});

parcelRegister("Tabui", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hkLGi');
        const value = parcelRequire('jkRT2');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hkLGi").then(()=>parcelRequire('jkRT2'));
}

});


parcelRegister("kffDO", function(module, exports) {

$parcel$export(module.exports, "RecommendTrialToFreeFlag", () => $a641ab731e50a08a$export$2de2b4a8ed8a1389);

var $eUqFw = parcelRequire("eUqFw");

var $1nuCz = parcelRequire("1nuCz");

var $8EsTK = parcelRequire("8EsTK");
const $a641ab731e50a08a$export$2de2b4a8ed8a1389 = ({ flagId: flagId, onDismiss: onDismiss, issueKeys: issueKeys })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1nuCz.FeatureGateChecker), {
        experiment: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8EsTK.IssueCreatedFlag), {
            flagId: flagId,
            onDismiss: onDismiss,
            issueKeys: issueKeys
        })
    });

});
parcelRegister("1nuCz", function(module, exports) {

$parcel$export(module.exports, "FeatureGateChecker", () => $6d6d414e779000e8$export$5f9d7deb88921f2f);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $jH6Sl = parcelRequire("jH6Sl");
const $6d6d414e779000e8$export$5f9d7deb88921f2f = ({ experiment: experiment })=>{
    const isInGate = !!(0, $eI5EY.fg)('jira_recommended_trial_to_free_ab_gate');
    if (isInGate) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jH6Sl.EligibilityChecker), null, experiment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
};

});
parcelRegister("jH6Sl", function(module, exports) {

$parcel$export(module.exports, "EligibilityChecker", () => $559f566bc3b940fc$export$cca196bfee81cdcf);

var $eUqFw = parcelRequire("eUqFw");

var $79xbN = parcelRequire("79xbN");

var $6WXNs = parcelRequire("6WXNs");

var $ab6rA = parcelRequire("ab6rA");

var $ePGkI = parcelRequire("ePGkI");
const $559f566bc3b940fc$export$cca196bfee81cdcf = ({ children: children })=>{
    const cohort = (0, $79xbN.expVal)('jira_recommended_trial_to_free_ab', 'cohort', 'not_enrolled');
    const { userCanUpgrade: userCanUpgrade } = (0, $ePGkI.useCheckIfUserCanUpgrade)(cohort === 'not_enrolled');
    const { software: jswEdition } = (0, $ab6rA.useAppEditions)();
    const eligibleForTrial = jswEdition === (0, $6WXNs.FREE_EDITION) && userCanUpgrade && cohort && cohort === 'test';
    if (eligibleForTrial) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
};

});
parcelRegister("ePGkI", function(module, exports) {

$parcel$export(module.exports, "useCheckIfUserCanUpgrade", () => $6c182e778d7aeb3c$export$8242cede3f5a02b3);

var $eQ80M = parcelRequire("eQ80M");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $guiFP = parcelRequire("guiFP");

var $bFzGY = parcelRequire("bFzGY");

var $dWLk9 = parcelRequire("dWLk9");
const $6c182e778d7aeb3c$export$8242cede3f5a02b3 = (skip = false)=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const [userCanUpgrade, setUserCanUpgrade] = (0, $eUqFw.useState)(false);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const environment = (0, $iWLL0.useRelayEnvironment)();
    (0, $eUqFw.useEffect)(()=>{
        if (skip) return;
        (0, $iWLL0.fetchQuery)(environment, (0, $eQ80M.default), {
            cloudId: cloudId,
            productKey: 'jira-software.ondemand',
            offeringKey: 'a70b5cbb-1ae1-4003-8f4a-9001a4a50526'
        }).subscribe({
            start: ()=>{
                setIsLoading(true);
            },
            complete: ()=>{
                setIsLoading(false);
            },
            next: (data)=>{
                const entitlement = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement;
                const canUserUpgrade = entitlement?.experienceCapabilities?.changeOffering?.isAvailableToUser;
                setUserCanUpgrade(!!canUserUpgrade);
            },
            error: (error)=>{
                (0, $guiFP.default)({
                    meta: {
                        id: 'useCheckIfUserCanUpgrade',
                        packageName: 'jiraRecommendTrialToFree',
                        teamName: 'luna-growth'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    error: error
                });
                setIsLoading(false);
                setUserCanUpgrade(false);
            }
        });
    }, [
        cloudId,
        skip,
        createAnalyticsEvent,
        environment
    ]);
    return {
        userCanUpgrade: userCanUpgrade,
        isLoading: isLoading
    };
};

});
parcelRegister("eQ80M", function(module, exports) {

$parcel$export(module.exports, "default", () => $97ba928ddfde51e0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5260673e7b49f18bba0b28122ce4ee09>>
 * @relayHash 0e295bd8cf5556f9a2ed20c4e7811231
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3363969b24a2c14b0a0a295feb9e9c205423d0ccd5685c2eaf9083dda1987721
const $97ba928ddfde51e0$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "offeringKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "productKey"
    }, v3 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "productKey"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "offeringKey",
            "variableName": "offeringKey"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "eligibilityUserCanUpgradeQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v5 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOffering",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "eligibilityUserCanUpgradeQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "args": v5 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOffering",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3363969b24a2c14b0a0a295feb9e9c205423d0ccd5685c2eaf9083dda1987721",
            "metadata": {},
            "name": "eligibilityUserCanUpgradeQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$97ba928ddfde51e0$var$node.hash = "bfb3759dfd2863e60432f4c195d1030a";
var $97ba928ddfde51e0$export$2e2bcd8739ae039 = $97ba928ddfde51e0$var$node;

});




parcelRegister("8EsTK", function(module, exports) {

$parcel$export(module.exports, "IssueCreatedFlag", () => $849156a0b33870b1$export$6ac95aa79f7e7f3f);

var $5Qzo6 = parcelRequire("5Qzo6");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jkH4Q = parcelRequire("jkH4Q");

var $iWLL0 = parcelRequire("iWLL0");

var $7u4fN = parcelRequire("7u4fN");

var $fI650 = parcelRequire("fI650");

var $hI5oG = parcelRequire("hI5oG");

var $02Sz7 = parcelRequire("02Sz7");

var $lD2Nx = parcelRequire("lD2Nx");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $0cdA8 = parcelRequire("0cdA8");

var $k8Qyf = parcelRequire("k8Qyf");

var $8uD7Y = parcelRequire("8uD7Y");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");

var $dWLk9 = parcelRequire("dWLk9");

var $3Jx2h = parcelRequire("3Jx2h");

var $14AG8 = parcelRequire("14AG8");

var $8GZgr = parcelRequire("8GZgr");
function $849156a0b33870b1$export$6ac95aa79f7e7f3f(props) {
    return /*#__PURE__*/ $eUqFw.createElement((0, $0cdA8.JSErrorBoundary), {
        id: "rtfIssueCreatedFlag",
        packageName: "jiraRecommendTrialToFree",
        teamName: "luna-growth",
        fallback: "unmount"
    }, /*#__PURE__*/ $eUqFw.createElement($849156a0b33870b1$export$92f18cc245e11db5, props));
}
function $849156a0b33870b1$export$92f18cc245e11db5({ flagId: flagId, onDismiss: onDismiss, issueKeys: issueKeys }) {
    const [showReloadPageModal, setShowReloadPageModal] = (0, $eUqFw.useState)(false);
    const openModal = (0, $eUqFw.useCallback)(()=>setShowReloadPageModal(true), []);
    const closeModal = (0, $eUqFw.useCallback)(()=>setShowReloadPageModal(false), []);
    const { dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const linkToTrial = (0, $iWLL0.useLazyLoadQuery)((0, $5Qzo6.default), {
        cloudId: cloudId,
        productKey: 'jira-software.ondemand',
        offeringKey: 'a70b5cbb-1ae1-4003-8f4a-9001a4a50526'
    })?.tenantContexts?.[0]?.entitlementInfo?.entitlement?.experienceCapabilities?.changeOffering?.experienceUrl;
    (0, $eUqFw.useEffect)(()=>{
        (0, $14AG8.setHasSeenFlag)(flagId);
    }, [
        flagId
    ]);
    const origin = new (0, $jkH4Q.default)({
        product: 'jira'
    });
    const issueCount = issueKeys.length;
    if (showReloadPageModal) return /*#__PURE__*/ $eUqFw.createElement((0, $8GZgr.ReloadPageModal), {
        closeModal: closeModal
    });
    return /*#__PURE__*/ $eUqFw.createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "recommendTrialToFreeFlag"
    }, /*#__PURE__*/ $eUqFw.createElement((0, $d6f6c.FireScreenAnalytics), null), /*#__PURE__*/ $eUqFw.createElement((0, $b5IAe.default), {
        xcss: $849156a0b33870b1$var$cardStyles
    }, /*#__PURE__*/ $eUqFw.createElement((0, $1zbEq.default), {
        alignInline: "start",
        spread: "space-between"
    }, /*#__PURE__*/ $eUqFw.createElement((0, $9Amv1.default), {
        alignInline: "stretch",
        alignBlock: "center",
        grow: "fill",
        spread: "space-between",
        xcss: $849156a0b33870b1$var$inlineStyles
    }, /*#__PURE__*/ $eUqFw.createElement((0, $9Amv1.default), {
        alignBlock: "center",
        space: "space.200"
    }, /*#__PURE__*/ $eUqFw.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lD2Nx))), {
        label: "success",
        primaryColor: "var(--ds-icon-success, Green600)",
        size: "large"
    }), /*#__PURE__*/ $eUqFw.createElement((0, $b5IAe.default), {
        xcss: $849156a0b33870b1$var$titleStyles
    }, /*#__PURE__*/ $eUqFw.createElement((0, $1Yimi.default), null, issueCount > 1 ? /*#__PURE__*/ $eUqFw.createElement((0, $8uD7Y.default), {
        id: "jira-recommend-trial-to-free.issue-created.card-title-multiple",
        defaultMessage: "You've created {issueCount, plural, one {# issue} other {# issues}}",
        values: {
            issueCount: issueCount
        }
    }) : /*#__PURE__*/ $eUqFw.createElement((0, $8uD7Y.default), {
        id: "jira-recommend-trial-to-free.issue-created.card-title-single",
        defaultMessage: 'You\'ve created "{issueKey}" issue',
        values: {
            issueKey: issueKeys[0]
        }
    })))), /*#__PURE__*/ $eUqFw.createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        onClick: (_, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'rtfDismissFlag');
            if (onDismiss) {
                onDismiss();
                return;
            }
            dismissFlag(flagId);
        },
        "aria-label": "Close"
    }, /*#__PURE__*/ $eUqFw.createElement((0, (/*@__PURE__*/$parcel$interopDefault($02Sz7))), {
        label: "close"
    }))), /*#__PURE__*/ $eUqFw.createElement((0, $9Amv1.default), {
        space: "space.200",
        alignBlock: "center",
        spread: "space-between",
        grow: "fill",
        xcss: $849156a0b33870b1$var$contentContainerStyles
    }, /*#__PURE__*/ $eUqFw.createElement((0, $1zbEq.default), {
        alignBlock: "center",
        alignInline: "start",
        space: "space.100",
        xcss: $849156a0b33870b1$var$mainContentStyles
    }, /*#__PURE__*/ $eUqFw.createElement((0, $hI5oG.default), {
        size: "small"
    }, /*#__PURE__*/ $eUqFw.createElement((0, $8uD7Y.default), {
        id: "jira-recommend-trial-to-free.issue-created.content-title",
        defaultMessage: "Now add your team"
    })), /*#__PURE__*/ $eUqFw.createElement((0, $b5IAe.default), {
        xcss: $849156a0b33870b1$var$bodyStyles
    }, /*#__PURE__*/ $eUqFw.createElement((0, $1Yimi.default), null, /*#__PURE__*/ $eUqFw.createElement((0, $8uD7Y.default), {
        id: "jira-recommend-trial-to-free.issue-created.content",
        defaultMessage: "Upgrade to get unlimited users and add everyone you work with."
    }))), linkToTrial && /*#__PURE__*/ $eUqFw.createElement((0, $fI650.default), {
        appearance: "link",
        href: origin.addToUrl(linkToTrial),
        onClick: (_, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'rtfTryItFree');
            openModal();
        },
        spacing: "none",
        target: "_blank"
    }, /*#__PURE__*/ $eUqFw.createElement((0, $1Yimi.default), {
        color: "color.link"
    }, /*#__PURE__*/ $eUqFw.createElement((0, $8uD7Y.default), {
        id: "jira-recommend-trial-to-free.issue-created.try-it-now-link",
        defaultMessage: "Try it free"
    })))), /*#__PURE__*/ $eUqFw.createElement((0, $1zbEq.default), {
        alignBlock: "center",
        alignInline: "center",
        xcss: $849156a0b33870b1$var$illustrationStackStyles
    }, /*#__PURE__*/ $eUqFw.createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3Jx2h))),
        alt: "",
        className: (0, $7JEyt.default)([
            "_c71l1ame _p12f1ame"
        ])
    }))))));
}
const $849156a0b33870b1$var$cardStyles = (0, $1ZAYh.xcss)({
    borderColor: 'color.border',
    borderRadius: '3px',
    boxShadow: 'elevation.shadow.overlay',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'elevation.surface.overlay'
});
const $849156a0b33870b1$var$inlineStyles = (0, $1ZAYh.xcss)({
    borderBottom: '1px solid',
    borderColor: 'color.border',
    padding: 'space.200'
});
const $849156a0b33870b1$var$titleStyles = (0, $1ZAYh.xcss)({
    fontSize: 'font.body'
});
const $849156a0b33870b1$var$contentContainerStyles = (0, $1ZAYh.xcss)({
    background: 'color.neutral.light',
    paddingInline: 'space.250',
    paddingBlock: 'space.400',
    width: '100%'
});
const $849156a0b33870b1$var$mainContentStyles = (0, $1ZAYh.xcss)({
    maxWidth: '240px'
});
const $849156a0b33870b1$var$bodyStyles = (0, $1ZAYh.xcss)({
    fontSize: 'font.body',
    lineHeight: '20px',
    fontWeight: '400'
});
const $849156a0b33870b1$var$illustrationStyles = null;
const $849156a0b33870b1$var$illustrationStackStyles = (0, $1ZAYh.xcss)({
    paddingTop: 'space.200'
});

});
parcelRegister("5Qzo6", function(module, exports) {

$parcel$export(module.exports, "default", () => $dacae23fa020de7f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7a0d3fbb3610dfdcd8128a1b88d6f6a8>>
 * @relayHash 9e0292a0e9e1a7cfc043ea04242ec447
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d7442a20376f6ce597664338dc598c7ade7ff8e2f238b04acb696e15c5022319
const $dacae23fa020de7f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "offeringKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "productKey"
    }, v3 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "productKey"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "offeringKey",
            "variableName": "offeringKey"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueCreatedFlagGetTrialLinkQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v5 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOffering",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "issueCreatedFlagGetTrialLinkQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "args": v5 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOffering",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d7442a20376f6ce597664338dc598c7ade7ff8e2f238b04acb696e15c5022319",
            "metadata": {},
            "name": "issueCreatedFlagGetTrialLinkQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$dacae23fa020de7f$var$node.hash = "4d50fdd81aa1005eb031986467ce9f75";
var $dacae23fa020de7f$export$2e2bcd8739ae039 = $dacae23fa020de7f$var$node;

});

parcelRegister("02Sz7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $008a83972912ce1e$var$_react = $008a83972912ce1e$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $008a83972912ce1e$var$_UNSAFE_baseNew = $008a83972912ce1e$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $008a83972912ce1e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "Close".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $008a83972912ce1e$var$CloseIcon = (props)=>/*#__PURE__*/ $008a83972912ce1e$var$_react.default.createElement($008a83972912ce1e$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M2.5 13.5 8 8m5.5-5.5L8 8m0 0L2.5 2.5M8 8l5.5 5.5"/>`
    }, props));
$008a83972912ce1e$var$CloseIcon.displayName = 'CloseIcon';
var $008a83972912ce1e$var$_default = module.exports.default = $008a83972912ce1e$var$CloseIcon;

});

parcelRegister("lD2Nx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fbef6921e18df378$var$_react = $fbef6921e18df378$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $fbef6921e18df378$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $fbef6921e18df378$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $fbef6921e18df378$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 20a8 8 0 110-16 8 8 0 010 16zm1.364-10.964l-2.152 4.11-1.543-1.39a1 1 0 10-1.338 1.487l2.5 2.25a1 1 0 001.555-.279l2.75-5.25a1 1 0 00-1.772-.928z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$fbef6921e18df378$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $fbef6921e18df378$var$_default = $fbef6921e18df378$var$EditorSuccessIcon;
module.exports.default = $fbef6921e18df378$var$_default;

});

// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("3Jx2h", function(module, exports) {
module.exports = new URL("now-add-your-team.9826b1af.svg", import.meta.url).toString();

});

parcelRegister("14AG8", function(module, exports) {

$parcel$export(module.exports, "getFlagId", () => $bd1c1f4d48d39074$export$415e9f2b45fdf9bb);
$parcel$export(module.exports, "setHasSeenFlag", () => $bd1c1f4d48d39074$export$3d880171a29f5f5c);
const $bd1c1f4d48d39074$var$storageKey = 'jira_recommended_trial_to_free_ab_flag_seen';
function $bd1c1f4d48d39074$export$415e9f2b45fdf9bb() {
    if (typeof window === 'undefined') return true;
    return localStorage.getItem($bd1c1f4d48d39074$var$storageKey)?.toString();
}
function $bd1c1f4d48d39074$export$3d880171a29f5f5c(id) {
    if (typeof window === 'undefined') return;
    localStorage.setItem($bd1c1f4d48d39074$var$storageKey, id);
}

});

parcelRegister("8GZgr", function(module, exports) {

$parcel$export(module.exports, "ReloadPageModal", () => $d33faae4bec90f4c$export$7db633aff5c8fd9a);

var $eUqFw = parcelRequire("eUqFw");

var $6zOB7 = parcelRequire("6zOB7");

var $h6FFs = parcelRequire("h6FFs");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $9Amv1 = parcelRequire("9Amv1");
var $1Yimi = parcelRequire("1Yimi");

var $8uD7Y = parcelRequire("8uD7Y");
const $d33faae4bec90f4c$export$7db633aff5c8fd9a = ({ closeModal: closeModal })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: closeModal,
        width: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h6FFs))), {
        label: "info",
        color: "var(--ds-icon-accent-blue, #1D7AFC)",
        spacing: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        id: "jira-recommend-trial-to-free.reload-this-page.title",
        defaultMessage: "Reload this page"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        id: "jira-recommend-trial-to-free.reload-this-page.body",
        defaultMessage: "If you've upgraded, reload this page to start your trial. Changes may take up to a minute."
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        appearance: "subtle",
        onClick: closeModal
    }, "Close"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        appearance: "primary",
        onClick: ()=>{
            if (typeof window !== 'undefined') window.location.reload();
        }
    }, "Reload"))));

});
parcelRegister("h6FFs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c743518dce4b322a$var$_react = $c743518dce4b322a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c743518dce4b322a$var$_UNSAFE_baseNew = $c743518dce4b322a$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c743518dce4b322a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "Information".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Known uses: helper message under textfield, information state insection messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c743518dce4b322a$var$InformationIcon = (props)=>/*#__PURE__*/ $c743518dce4b322a$var$_react.default.createElement($c743518dce4b322a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentColor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$c743518dce4b322a$var$InformationIcon.displayName = 'InformationIcon';
var $c743518dce4b322a$var$_default = module.exports.default = $c743518dce4b322a$var$InformationIcon;

});




parcelRegister("15YMg", function(module, exports) {

$parcel$export(module.exports, "useRecommendTrialToFree", () => $76d1b018d0fafbe2$export$12cc6b04754d240d);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $1Iui1 = parcelRequire("1Iui1");

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $bFzGY = parcelRequire("bFzGY");

var $jMP2a = parcelRequire("jMP2a");

var $bNe1g = parcelRequire("bNe1g");

var $6WXNs = parcelRequire("6WXNs");

var $ab6rA = parcelRequire("ab6rA");

var $14AG8 = parcelRequire("14AG8");

var $ePGkI = parcelRequire("ePGkI");
const $76d1b018d0fafbe2$export$12cc6b04754d240d = ({ id: id })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { data: projectContext } = (0, $bNe1g.useProjectContext)();
    const { software: jswEdition } = (0, $ab6rA.useAppEditions)();
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig, fireExposure] = (0, $79xbN.UNSAFE_noExposureExp)('jira_recommended_trial_to_free_ab');
    const cohort = expConfig.get((0, $1Iui1.COHORT), (0, $1Iui1.NOT_ENROLLED));
    const isPassedGate = (0, $eI5EY.fg)('jira_recommended_trial_to_free_ab_gate');
    const flagId = (0, $14AG8.getFlagId)();
    const [shouldShowRecommendTrialFlag, setShouldShowRecommendTrialFlag] = (0, $eUqFw.useState)(false);
    const isInJiraProject = projectContext?.projectType === (0, $7ZZxN.SOFTWARE_PROJECT);
    const isTestCohort = cohort === 'test';
    const isEligible = (0, $eUqFw.useMemo)(()=>isPassedGate && cohort !== (0, $1Iui1.NOT_ENROLLED) && jswEdition === (0, $6WXNs.FREE_EDITION) && isInJiraProject && (!flagId || flagId === `${id}`), [
        isPassedGate,
        cohort,
        jswEdition,
        isInJiraProject,
        flagId,
        id
    ]);
    const { userCanUpgrade: userCanUpgrade, isLoading: isLoading } = (0, $ePGkI.useCheckIfUserCanUpgrade)(!isEligible);
    (0, $eUqFw.useEffect)(()=>{
        if (!isEligible || !userCanUpgrade) return;
        // only fire exposure if the user is eligible
        fireExposure();
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'rtfExperiment exposed', {
            experiment: 'jira_recommended_trial_to_free_ab',
            cohort: cohort
        });
        // for the test cohort, we will set the flag as seen once it has rendered
        if (!isTestCohort) {
            (0, $14AG8.setHasSeenFlag)(`${id}`);
            return;
        }
        // only set the flag if the user is eligible and in the test cohort
        setShouldShowRecommendTrialFlag(true);
    }, [
        isEligible,
        userCanUpgrade,
        cohort,
        isTestCohort,
        id,
        fireExposure,
        createAnalyticsEvent
    ]);
    return {
        shouldShowRecommendTrialFlag: shouldShowRecommendTrialFlag,
        isLoading: isLoading
    };
};

});

parcelRegister("gjVGb", function(module, exports) {

$parcel$export(module.exports, "getIssueDiscoveryUrl", () => $1e7aedecde9d58c7$export$852450339fdb3b37);
const $1e7aedecde9d58c7$export$852450339fdb3b37 = (cardKeys)=>{
    if (cardKeys.length > 1) {
        const issueKeys = cardKeys.join(',');
        const jqlSearch = encodeURIComponent(`issueKey in (${issueKeys})`);
        return `/issues/?jql=${jqlSearch}`;
    }
    return `/browse/${cardKeys[0]}`;
};

});

parcelRegister("mANno", function(module, exports) {

$parcel$export(module.exports, "default", () => $239679b8225600be$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $239679b8225600be$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createSuccessFlagTitle: {
        "id": "software-flags.card-create-global.create-success-flag-title",
        "defaultMessage": "You've created \"{issueKey}\" issue."
    },
    viewIssueLinkText: {
        "id": "software-flags.card-create-global.view-issue-link-text",
        "defaultMessage": "View {numIssues, plural, one {issue} other {issues}}"
    },
    multiplesIssuesCreatedSuccessFlagTitle: {
        "id": "software-flags.card-create-global.multiples-issues-created-success-flag-title",
        "defaultMessage": "You've created {issueCount, plural, one {# issue} other {# issues}}."
    },
    copyLink: {
        "id": "software-flags.card-create-global.copy-link",
        "defaultMessage": "Copy link"
    },
    linkCopied: {
        "id": "software-flags.card-create-global.link-copied",
        "defaultMessage": "Copied"
    }
});

});


parcelRegister("hniWi", function(module, exports) {

$parcel$export(module.exports, "BULK_OPS_SHOW_FAILED_FLAG", () => $f4c295937711ed79$export$d9ef62afaf787d0f);
$parcel$export(module.exports, "bulkOpsShowFailedFlag", () => $f4c295937711ed79$export$4a9779e37388dc91);
const $f4c295937711ed79$export$d9ef62afaf787d0f = 'state.actions.bulk-ops-flags.BULK_OPS_SHOW_FAILED_FLAG';
const $f4c295937711ed79$export$4a9779e37388dc91 = (payload)=>({
        type: $f4c295937711ed79$export$d9ef62afaf787d0f,
        payload: payload
    });

});

parcelRegister("lsENz", function(module, exports) {

$parcel$export(module.exports, "CARD_CREATE_END_OF_BACKLOG_OPTIMISTIC", () => $272eb02f44e9a830$export$3b377ab2ad221faa);
$parcel$export(module.exports, "CARD_CREATE_MULTIPLE_REQUEST", () => $272eb02f44e9a830$export$ffc92aa1986bdcac);
$parcel$export(module.exports, "CARD_CREATE_SUCCESS", () => $272eb02f44e9a830$export$f1c65160dd038544);
$parcel$export(module.exports, "CARD_CREATE_FAILURE", () => $272eb02f44e9a830$export$10f0879d5640132c);
$parcel$export(module.exports, "CARD_CREATE_FILTERED", () => $272eb02f44e9a830$export$20457ba50549c0b6);
$parcel$export(module.exports, "CARD_CREATE_FILTERED_V2", () => $272eb02f44e9a830$export$a7dcdd006d3cee32);
$parcel$export(module.exports, "CARD_CREATE_UNMAPPED", () => $272eb02f44e9a830$export$ac5655119bbf2fd5);
$parcel$export(module.exports, "CARD_CREATE_UNMAPPED_WITH_ISSUE_LINK", () => $272eb02f44e9a830$export$db85d3288a006ee9);
$parcel$export(module.exports, "CARD_CREATE_GLOBAL", () => $272eb02f44e9a830$export$7e3530b9017404ec);
$parcel$export(module.exports, "CARD_CREATE_SPLIT_ISSUE", () => $272eb02f44e9a830$export$3a82665bcf11f9d6);
$parcel$export(module.exports, "cardCreateMultipleRequest", () => $272eb02f44e9a830$export$67a60206c7a89110);
$parcel$export(module.exports, "cardCreateEndOfBacklogOptimistic", () => $272eb02f44e9a830$export$ffd447be3d58e464);
$parcel$export(module.exports, "cardCreateSuccess", () => $272eb02f44e9a830$export$b70c18d8546382b2);
$parcel$export(module.exports, "cardCreateFailure", () => $272eb02f44e9a830$export$151deebc0c103b3c);
$parcel$export(module.exports, "cardCreateFilteredV2", () => $272eb02f44e9a830$export$f1c368b5cfb9b941);
$parcel$export(module.exports, "cardCreateUnmapped", () => $272eb02f44e9a830$export$2afdf25d9071462e);
$parcel$export(module.exports, "cardCreateUnmappedWithIssueLink", () => $272eb02f44e9a830$export$7e2a2d17eb3fb542);
$parcel$export(module.exports, "cardCreateGlobal", () => $272eb02f44e9a830$export$7fd1edcce679a11d);
$parcel$export(module.exports, "splitIssueCreate", () => $272eb02f44e9a830$export$f587280de61983a7);

var $jWq1L = parcelRequire("jWq1L");
const $272eb02f44e9a830$export$3b377ab2ad221faa = 'state.actions.cards.create.CARD_CREATE_END_OF_BACKLOG_OPTIMISTIC';
const $272eb02f44e9a830$export$ffc92aa1986bdcac = 'state.actions.cards.create.CARD_CREATE_MULTIPLE_REQUEST';
const $272eb02f44e9a830$export$f1c65160dd038544 = 'state.actions.cards.create.CARD_CREATE_SUCCESS';
const $272eb02f44e9a830$export$10f0879d5640132c = 'state.actions.cards.create.CARD_CREATE_FAILURE';
const $272eb02f44e9a830$export$20457ba50549c0b6 = 'state.actions.cards.create.CARD_CREATE_FILTERED';
const $272eb02f44e9a830$export$a7dcdd006d3cee32 = 'state.actions.cards.create.CARD_CREATE_FILTERED_V2';
const $272eb02f44e9a830$export$ac5655119bbf2fd5 = 'state.actions.cards.create.CARD_CREATE_UNMAPPED';
const $272eb02f44e9a830$export$db85d3288a006ee9 = 'state.actions.cards.create.CARD_CREATE_UNMAPPED_WITH_ISSUE_LINK';
const $272eb02f44e9a830$export$7e3530b9017404ec = 'state.actions.cards.create.CARD_CREATE_GLOBAL';
const $272eb02f44e9a830$export$3a82665bcf11f9d6 = 'state.actions.cards.create.CARD_CREATE_SPLIT_ISSUE';
const $272eb02f44e9a830$export$67a60206c7a89110 = ({ tempIds: tempIds, summaries: summaries, typeId: typeId, typeIcon: typeIcon, parentId: parentId, fixVersions: fixVersions, insertBefore: insertBefore = null, listId: listId, storeFieldsFromCardCreateData: storeFieldsFromCardCreateData, storeFieldsFromFetchIssuesData: storeFieldsFromFetchIssuesData, analyticsEvent: analyticsEvent })=>({
        type: $272eb02f44e9a830$export$ffc92aa1986bdcac,
        payload: {
            tempIds: tempIds,
            summaries: summaries,
            typeId: typeId,
            parentId: parentId,
            typeIcon: typeIcon,
            fixVersions: fixVersions,
            insertBefore: insertBefore,
            listId: listId,
            storeFieldsFromCardCreateData: storeFieldsFromCardCreateData,
            storeFieldsFromFetchIssuesData: storeFieldsFromFetchIssuesData
        },
        meta: {
            ...(0, $jWq1L.beginOptimisticUiMeta)(),
            analyticsEvent: analyticsEvent
        }
    });
const $272eb02f44e9a830$export$ffd447be3d58e464 = (changeEvent)=>({
        type: $272eb02f44e9a830$export$3b377ab2ad221faa,
        payload: {
            changeEvent: changeEvent
        }
    });
const $272eb02f44e9a830$export$b70c18d8546382b2 = (card, listId, temporaryCardId, createdWithRank, createdWithBulk, optimisticId, analyticsEvent)=>({
        type: $272eb02f44e9a830$export$f1c65160dd038544,
        payload: {
            card: card,
            listId: listId,
            temporaryCardId: temporaryCardId,
            createdWithRank: createdWithRank,
            createdWithBulk: createdWithBulk
        },
        meta: {
            ...(0, $jWq1L.commitOptimisticUiMeta)(optimisticId),
            analyticsEvent: analyticsEvent
        }
    });
const $272eb02f44e9a830$export$151deebc0c103b3c = (numCards, optimisticId, errorMessage, statusCode, isClientFetchError = false, analyticsEvent)=>({
        type: $272eb02f44e9a830$export$10f0879d5640132c,
        meta: {
            ...(0, $jWq1L.revertOptimisticUiMeta)(optimisticId),
            analyticsEvent: analyticsEvent
        },
        payload: {
            numCards: numCards,
            errorMessage: errorMessage,
            statusCode: statusCode,
            isClientFetchError: isClientFetchError
        }
    });
const $272eb02f44e9a830$export$f069b59557af9611 = (card)=>({
        type: $272eb02f44e9a830$export$20457ba50549c0b6,
        payload: card
    });
const $272eb02f44e9a830$export$f1c368b5cfb9b941 = (cardIds)=>({
        type: $272eb02f44e9a830$export$a7dcdd006d3cee32,
        payload: cardIds
    });
const $272eb02f44e9a830$export$2afdf25d9071462e = (numIssues, cardKeys, optimisticId, analyticsEvent)=>({
        type: $272eb02f44e9a830$export$ac5655119bbf2fd5,
        payload: {
            numIssues: numIssues,
            cardKeys: cardKeys
        },
        meta: {
            ...(0, $jWq1L.revertOptimisticUiMeta)(optimisticId),
            analyticsEvent: analyticsEvent
        }
    });
const $272eb02f44e9a830$export$7e2a2d17eb3fb542 = (cardsIdentifiers)=>({
        type: $272eb02f44e9a830$export$db85d3288a006ee9,
        payload: {
            cardsIdentifiers: cardsIdentifiers
        }
    });
const $272eb02f44e9a830$export$7fd1edcce679a11d = (globalIssues)=>({
        type: $272eb02f44e9a830$export$7e3530b9017404ec,
        payload: {
            globalIssues: globalIssues
        }
    });
const $272eb02f44e9a830$export$f587280de61983a7 = (originalIssueKey, newIssueKeys)=>({
        type: $272eb02f44e9a830$export$3a82665bcf11f9d6,
        payload: {
            originalIssueKey: originalIssueKey,
            newIssueKeys: newIssueKeys
        }
    });

});
parcelRegister("jWq1L", function(module, exports) {

$parcel$export(module.exports, "beginOptimisticUiMeta", () => $1768d9adc37f4497$export$ebf02a95198109b6);
$parcel$export(module.exports, "commitOptimisticUiMeta", () => $1768d9adc37f4497$export$76fabd640a0893d7);
$parcel$export(module.exports, "revertOptimisticUiMeta", () => $1768d9adc37f4497$export$732172a3c90c9446);
$parcel$export(module.exports, "revertOptimisticUiWithFlagMeta", () => $1768d9adc37f4497$export$62b48e9d9fa388fd);
$parcel$export(module.exports, "revertOptimisticUiWithDisabledFlagMeta", () => $1768d9adc37f4497$export$b28d028621480a59);

var $iy2aZ = parcelRequire("iy2aZ");

var $hompL = parcelRequire("hompL");
const $1768d9adc37f4497$export$afc40f9cba31cfb3 = 'OPTIMISTIC_REVERT_FLAG';
const $1768d9adc37f4497$export$ebf02a95198109b6 = ()=>({
        optimistic: {
            type: (0, $iy2aZ.BEGIN),
            id: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4()
        }
    });
const $1768d9adc37f4497$export$76fabd640a0893d7 = (optimisticId)=>({
        optimistic: {
            type: (0, $iy2aZ.COMMIT),
            id: optimisticId
        }
    });
const $1768d9adc37f4497$export$732172a3c90c9446 = (optimisticId)=>({
        optimistic: {
            type: (0, $iy2aZ.REVERT),
            id: optimisticId
        }
    });
const $1768d9adc37f4497$export$62b48e9d9fa388fd = (optimisticId)=>({
        optimistic: {
            type: (0, $iy2aZ.REVERT),
            id: optimisticId
        },
        showGenericFlag: true
    });
const $1768d9adc37f4497$export$b28d028621480a59 = (optimisticId)=>({
        optimistic: {
            type: (0, $iy2aZ.REVERT),
            id: optimisticId
        },
        showGenericFlag: false
    });

});


parcelRegister("5awap", function(module, exports) {

$parcel$export(module.exports, "FILTERED_CARD_REQUEST", () => $480a604c67466259$export$4bd6c1b43abf609);
$parcel$export(module.exports, "filteredCardsRequest", () => $480a604c67466259$export$f3f4ad1fd3672b39);
$parcel$export(module.exports, "FILTERED_CARD_SUCCESS", () => $480a604c67466259$export$8f5834f2d50f84b5);
$parcel$export(module.exports, "filteredCardsSuccess", () => $480a604c67466259$export$aa1ef8dc8bb1be1b);
$parcel$export(module.exports, "FILTERED_CARD_FAILURE", () => $480a604c67466259$export$a17483c6b4ef650d);
$parcel$export(module.exports, "filteredCardsFailed", () => $480a604c67466259$export$8357ffeaf5f8e6b8);
$parcel$export(module.exports, "FILTERED_CARD_CLEAR_SUCCESS", () => $480a604c67466259$export$40b57191c66adf76);
$parcel$export(module.exports, "clearFilteredCardsSuccess", () => $480a604c67466259$export$f614b38cfc8bdee4);
$parcel$export(module.exports, "FILTERED_CARD_CLEAR_FAILURE", () => $480a604c67466259$export$deb9be1fa48a7771);
$parcel$export(module.exports, "clearFilteredCardsFailed", () => $480a604c67466259$export$aaedb9c3d66fff54);
$parcel$export(module.exports, "FILTERED_CARD_CLEAR_REQUEST", () => $480a604c67466259$export$55f9625eb5f081fe);
$parcel$export(module.exports, "clearFilteredCardsRequest", () => $480a604c67466259$export$1eb5e229a2675c22);
$parcel$export(module.exports, "FILTERED_CARD_CLEAR", () => $480a604c67466259$export$507d49f4a5857f49);
$parcel$export(module.exports, "clearFilteredCards", () => $480a604c67466259$export$81b4fe421a8e6fe4);
$parcel$export(module.exports, "REFILTER_SUCCESS", () => $480a604c67466259$export$4d3b992e541cd8ce);
$parcel$export(module.exports, "refilterSuccess", () => $480a604c67466259$export$a76ad4df662ec1fb);
$parcel$export(module.exports, "REFILTER_FAILURE", () => $480a604c67466259$export$f09f82741fa84c27);
$parcel$export(module.exports, "refilterFailure", () => $480a604c67466259$export$138c508cb95b66c3);
const $480a604c67466259$export$4bd6c1b43abf609 = 'state.actions.cards.filtered-cards.FILTERED_CARD_REQUEST';
const $480a604c67466259$export$f3f4ad1fd3672b39 = (issueIds, analyticsEvent, customFilterIds)=>({
        type: $480a604c67466259$export$4bd6c1b43abf609,
        payload: {
            issueIds: issueIds,
            customFilterIds: customFilterIds
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $480a604c67466259$export$8f5834f2d50f84b5 = 'state.actions.cards.filtered-cards.FILTERED_CARD_SUCCESS';
const $480a604c67466259$export$aa1ef8dc8bb1be1b = (cardIds, numCustomFiltersApplied, numIssueIds, analyticsEvent)=>({
        type: $480a604c67466259$export$8f5834f2d50f84b5,
        payload: cardIds,
        meta: {
            analyticsEvent: analyticsEvent,
            numCustomFiltersApplied: numCustomFiltersApplied,
            numIssueIds: numIssueIds
        }
    });
const $480a604c67466259$export$a17483c6b4ef650d = 'state.actions.cards.filtered-cards.FILTERED_CARD_FAILURE';
const $480a604c67466259$export$8357ffeaf5f8e6b8 = (error, analyticsEvent)=>({
        type: $480a604c67466259$export$a17483c6b4ef650d,
        payload: {
            error: error
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $480a604c67466259$export$40b57191c66adf76 = 'state.actions.cards.filtered-cards.FILTERED_CARD_CLEAR_SUCCESS';
const $480a604c67466259$export$f614b38cfc8bdee4 = (analyticsEvent)=>({
        type: $480a604c67466259$export$40b57191c66adf76,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $480a604c67466259$export$deb9be1fa48a7771 = 'state.actions.cards.filtered-cards.FILTERED_CARD_CLEAR_FAILURE';
const $480a604c67466259$export$aaedb9c3d66fff54 = (error, analyticsEvent)=>({
        type: $480a604c67466259$export$deb9be1fa48a7771,
        payload: {
            error: error
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $480a604c67466259$export$55f9625eb5f081fe = 'state.actions.cards.filtered-cards.FILTERED_CARD_CLEAR_REQUEST';
const $480a604c67466259$export$1eb5e229a2675c22 = (analyticsEvent)=>({
        type: $480a604c67466259$export$55f9625eb5f081fe,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $480a604c67466259$export$507d49f4a5857f49 = 'state.actions.cards.filtered-cards.FILTERED_CARD_CLEAR';
const $480a604c67466259$export$81b4fe421a8e6fe4 = ()=>({
        type: $480a604c67466259$export$507d49f4a5857f49
    });
const $480a604c67466259$export$4d3b992e541cd8ce = 'state.actions.cards.filtered-cards.REFILTER_SUCCESS';
const $480a604c67466259$export$a76ad4df662ec1fb = (excludedCardIds, filteredCardIds)=>({
        type: $480a604c67466259$export$4d3b992e541cd8ce,
        payload: {
            excludedCardIds: excludedCardIds,
            filteredCardIds: filteredCardIds
        }
    });
const $480a604c67466259$export$f09f82741fa84c27 = 'state.actions.cards.filtered-cards.REFILTER_FAILURE';
const $480a604c67466259$export$138c508cb95b66c3 = (error)=>({
        type: $480a604c67466259$export$f09f82741fa84c27,
        payload: {
            error: error
        }
    });

});

parcelRegister("7Egcu", function(module, exports) {

$parcel$export(module.exports, "CARDS_MOVE", () => $1ae091a5630d21f3$export$b33d2f47990782ba);
$parcel$export(module.exports, "cardsMove", () => $1ae091a5630d21f3$export$68ae240377a1a3d7);
$parcel$export(module.exports, "CARDS_MOVE_REQUEST", () => $1ae091a5630d21f3$export$e13d64a2ffca3097);
$parcel$export(module.exports, "cardsMoveRequest", () => $1ae091a5630d21f3$export$798efca6e002e359);
$parcel$export(module.exports, "CARDS_MOVE_NON_OPTIMISTIC_REQUEST", () => $1ae091a5630d21f3$export$6ae1b17e1807f013);
$parcel$export(module.exports, "cardsMoveNonOptimisticRequest", () => $1ae091a5630d21f3$export$c581f6c48c739c84);
$parcel$export(module.exports, "CARDS_MOVE_SUCCESS", () => $1ae091a5630d21f3$export$1b15bd4898d41956);
$parcel$export(module.exports, "cardsMoveSuccess", () => $1ae091a5630d21f3$export$d9bd27fc2155921d);
$parcel$export(module.exports, "CARDS_MOVE_FAILURE", () => $1ae091a5630d21f3$export$cfcb4c2d7a25be3d);
$parcel$export(module.exports, "cardsMoveFailure", () => $1ae091a5630d21f3$export$418f4abeb5fa5e63);
$parcel$export(module.exports, "CARDS_TRANSITION_AND_RANK_FAILURE", () => $1ae091a5630d21f3$export$f9b68831e6b4477c);
$parcel$export(module.exports, "cardsTransitionAndRankFailure", () => $1ae091a5630d21f3$export$46bbdf3a931c511);
$parcel$export(module.exports, "cardsMoveCancel", () => $1ae091a5630d21f3$export$1d737d00c97bf50e);
$parcel$export(module.exports, "CARDS_MOVE_SET", () => $1ae091a5630d21f3$export$b807c0f117e6382c);
$parcel$export(module.exports, "cardsMoveSet", () => $1ae091a5630d21f3$export$106b66132b61ee71);
$parcel$export(module.exports, "CARDS_MOVE_DISABLED", () => $1ae091a5630d21f3$export$93dd8120f4a8e5e9);
$parcel$export(module.exports, "cardsMoveDisabled", () => $1ae091a5630d21f3$export$426568831df3d9fb);
$parcel$export(module.exports, "CARD_DRAG_DISALLOWED", () => $1ae091a5630d21f3$export$98c6114056f9246b);
$parcel$export(module.exports, "cardDragDisallowed", () => $1ae091a5630d21f3$export$a6e3bd55037d34be);

var $jWq1L = parcelRequire("jWq1L");
const $1ae091a5630d21f3$export$b33d2f47990782ba = 'state.actions.cards.move.CARDS_MOVE';
const $1ae091a5630d21f3$export$68ae240377a1a3d7 = (payload, analyticsEvent)=>({
        type: $1ae091a5630d21f3$export$b33d2f47990782ba,
        payload: payload,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $1ae091a5630d21f3$export$e13d64a2ffca3097 = 'state.actions.cards.move.CARDS_MOVE_REQUEST';
const $1ae091a5630d21f3$export$798efca6e002e359 = (payload, analyticsEvent)=>({
        type: $1ae091a5630d21f3$export$e13d64a2ffca3097,
        payload: payload,
        meta: {
            analyticsEvent: analyticsEvent,
            ...(0, $jWq1L.beginOptimisticUiMeta)()
        }
    });
const $1ae091a5630d21f3$export$6ae1b17e1807f013 = 'state.actions.cards.move.CARDS_MOVE_NON_OPTIMISTIC_REQUEST';
const $1ae091a5630d21f3$export$c581f6c48c739c84 = (optimisticId, payload, analyticsEvent)=>({
        type: $1ae091a5630d21f3$export$6ae1b17e1807f013,
        payload: payload,
        meta: {
            optimisticId: optimisticId,
            analyticsEvent: analyticsEvent
        }
    });
const $1ae091a5630d21f3$export$1b15bd4898d41956 = 'state.actions.cards.move.CARDS_MOVE_SUCCESS';
const $1ae091a5630d21f3$export$d9bd27fc2155921d = (optimisticId, cardIds, cardListId, analyticsEvent, targetStatusId)=>({
        type: $1ae091a5630d21f3$export$1b15bd4898d41956,
        payload: {
            cardIds: cardIds,
            cardListId: cardListId,
            targetStatusId: targetStatusId
        },
        meta: {
            analyticsEvent: analyticsEvent,
            ...(0, $jWq1L.commitOptimisticUiMeta)(optimisticId)
        }
    });
const $1ae091a5630d21f3$export$cfcb4c2d7a25be3d = 'state.actions.cards.move.CARDS_MOVE_FAILURE';
const $1ae091a5630d21f3$export$418f4abeb5fa5e63 = (optimisticId, cardIds, cardListId, analyticsEvent, error)=>({
        type: $1ae091a5630d21f3$export$cfcb4c2d7a25be3d,
        payload: {
            cardIds: cardIds,
            cardListId: cardListId,
            error: error
        },
        meta: {
            analyticsEvent: analyticsEvent,
            ...(0, $jWq1L.revertOptimisticUiWithFlagMeta)(optimisticId)
        }
    });
const $1ae091a5630d21f3$export$f9b68831e6b4477c = 'CARDS_TRANSITION_AND_RANK_FAILURE';
const $1ae091a5630d21f3$export$46bbdf3a931c511 = (optimisticId, errorMessages, analyticsEvent)=>({
        type: $1ae091a5630d21f3$export$f9b68831e6b4477c,
        payload: {
            errorMessages: errorMessages
        },
        meta: {
            analyticsEvent: analyticsEvent,
            ...(0, $jWq1L.revertOptimisticUiWithDisabledFlagMeta)(optimisticId)
        }
    });
const $1ae091a5630d21f3$export$705d22119d4bbfd3 = 'state.actions.cards.move.CARDS_MOVE_CANCEL';
const $1ae091a5630d21f3$export$1d737d00c97bf50e = (optimisticId, analyticsEvent)=>({
        type: $1ae091a5630d21f3$export$705d22119d4bbfd3,
        meta: {
            analyticsEvent: analyticsEvent,
            ...(0, $jWq1L.revertOptimisticUiMeta)(optimisticId)
        }
    });
const $1ae091a5630d21f3$export$b807c0f117e6382c = 'state.actions.cards.move.CARDS_MOVE_SET';
const $1ae091a5630d21f3$export$106b66132b61ee71 = (payload)=>({
        type: $1ae091a5630d21f3$export$b807c0f117e6382c,
        payload: payload
    });
const $1ae091a5630d21f3$export$93dd8120f4a8e5e9 = 'state.actions.cards.move.CARDS_MOVE_DISABLED';
const $1ae091a5630d21f3$export$426568831df3d9fb = (optimisticId, analyticsEvent, boardId, isAdmin)=>({
        type: $1ae091a5630d21f3$export$93dd8120f4a8e5e9,
        payload: {
            boardId: boardId,
            isAdmin: isAdmin
        },
        meta: {
            analyticsEvent: analyticsEvent,
            ...(0, $jWq1L.revertOptimisticUiWithDisabledFlagMeta)(optimisticId)
        }
    });
const $1ae091a5630d21f3$export$98c6114056f9246b = 'state.actions.cards.move.CARD_DRAG_DISALLOWED';
const $1ae091a5630d21f3$export$a6e3bd55037d34be = ()=>({
        type: $1ae091a5630d21f3$export$98c6114056f9246b
    });

});

parcelRegister("70VKY", function(module, exports) {

$parcel$export(module.exports, "FLAG_SPRINT_STARTED", () => $667f11bd509595f0$export$694f8ba06b56ee81);
$parcel$export(module.exports, "showSprintStartedFlagAction", () => $667f11bd509595f0$export$10698da25970db59);
const $667f11bd509595f0$export$694f8ba06b56ee81 = 'state.actions.sprints.start.FLAG_SPRINT_STARTED';
const $667f11bd509595f0$export$10698da25970db59 = ()=>({
        type: $667f11bd509595f0$export$694f8ba06b56ee81
    });

});

parcelRegister("bR721", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4b6158dbb734629$export$2e2bcd8739ae039);

var $MYW4e = parcelRequire("MYW4e");

var $5iWql = parcelRequire("5iWql");

var $lNNXV = parcelRequire("lNNXV");

var $1HfeQ = parcelRequire("1HfeQ");

var $bP7Jx = parcelRequire("bP7Jx");

var $edWFh = parcelRequire("edWFh");
const $e4b6158dbb734629$var$mapDispatchToProps = (dispatch, { failedActionBuilders: failedActionBuilders, onDismissed: onDismissed, id: flagId, failedIssueKeys: failedIssueKeys, failedBatchIds: failedBatchIds })=>({
        onRetry: ()=>{
            onDismissed?.(flagId);
            if (failedActionBuilders.length < 1) return;
            const action = (0, $MYW4e.batchActions)(failedActionBuilders.map((f)=>{
                const builtAction = f();
                return {
                    ...builtAction,
                    meta: {
                        ...builtAction.meta,
                        failedBatchIds: failedBatchIds
                    }
                };
            }));
            dispatch(action);
        },
        onSelectFailedItems: (getCardIdFromCardKey)=>{
            onDismissed?.(flagId);
            const failedCardIds = failedIssueKeys.map((key)=>getCardIdFromCardKey(key));
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            dispatch((0, $1HfeQ.cardMultiSelect)(failedCardIds));
        }
    });
const $e4b6158dbb734629$var$onSelectFailedItemsFactory = (0, $5iWql.default)((getCardIdFromCardKey, onSelectFailedItems)=>()=>onSelectFailedItems(getCardIdFromCardKey));
const $e4b6158dbb734629$var$onViewSummaryFactory = (0, $5iWql.default)((failedIssueKeys, onDismissed, flagId)=>()=>{
        const cardKeys = failedIssueKeys.join(',');
        const jqlSearch = encodeURIComponent(`issueKey in (${cardKeys})`);
        const url = `/issues/?jql=${jqlSearch}`;
        window.open(url, '_blank');
        onDismissed?.(flagId);
    });
const $e4b6158dbb734629$export$9d1611c77c2fe928 = ({ getCardIdFromCardKey: getCardIdFromCardKey }, { onRetry: onRetry, onSelectFailedItems: onSelectFailedItems }, { failedActionBuilders: failedActions, failedIssueKeys: failedIssueKeys, id: flagId, onDismissed: onDismissed, failedBatchIds: failedBatchIds, failureReason: failureReason, ...restOwnProps })=>{
    const hasReachedRetryLimit = failedBatchIds && failedBatchIds?.length > 2;
    const shouldShowRetryButton = failedActions.length > 0 && !hasReachedRetryLimit && failureReason !== 'validation';
    const shouldShowViewSummaryButton = failureReason !== 'network' || failureReason === 'network' && !hasReachedRetryLimit;
    const shouldShowSelectFailedItemsButton = failureReason === 'validation';
    const shouldShowHelpButton = hasReachedRetryLimit && failureReason !== 'network' && failureReason !== 'validation';
    return {
        failedCount: failedIssueKeys.length,
        onRetry: onRetry,
        onSelectFailedItems: $e4b6158dbb734629$var$onSelectFailedItemsFactory(getCardIdFromCardKey, onSelectFailedItems),
        onViewSummary: $e4b6158dbb734629$var$onViewSummaryFactory(failedIssueKeys, onDismissed, flagId),
        showRetryButton: shouldShowRetryButton,
        showViewSummaryButton: shouldShowViewSummaryButton,
        showSelectFailedItemsButton: shouldShowSelectFailedItemsButton,
        showLearnMoreButton: !!shouldShowHelpButton,
        id: flagId,
        failureReason: failureReason,
        onDismissed: onDismissed,
        ...restOwnProps
    };
};
const $e4b6158dbb734629$var$mapStateToProps = (state)=>({
        getCardIdFromCardKey: (0, $bP7Jx.makeCardIdFromCardKey)(state)
    });
var $e4b6158dbb734629$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($e4b6158dbb734629$var$mapStateToProps, $e4b6158dbb734629$var$mapDispatchToProps, $e4b6158dbb734629$export$9d1611c77c2fe928)((0, $edWFh.default));

});
parcelRegister("1HfeQ", function(module, exports) {

$parcel$export(module.exports, "CARD_CLICK", () => $6caea0851d8bed42$export$1f7bc7dd5a83e5d6);
$parcel$export(module.exports, "cardClick", () => $6caea0851d8bed42$export$e7d364bce6e7eb03);
$parcel$export(module.exports, "PARENT_CLICK", () => $6caea0851d8bed42$export$3c3fc48f596a8caf);
$parcel$export(module.exports, "parentClick", () => $6caea0851d8bed42$export$5b3ee90f81d7c287);
$parcel$export(module.exports, "CARD_TOGGLE_SELECTION", () => $6caea0851d8bed42$export$5f8bf17701529b20);
$parcel$export(module.exports, "cardToggleSelection", () => $6caea0851d8bed42$export$bf1970aeeba42166);
$parcel$export(module.exports, "CARD_EMPTY_SELECTION", () => $6caea0851d8bed42$export$9aba3277bb9b4f3);
$parcel$export(module.exports, "cardEmptySelection", () => $6caea0851d8bed42$export$9bbdebcbf6166d18);
$parcel$export(module.exports, "CARD_SINGLE_SELECT", () => $6caea0851d8bed42$export$c68d63d54996a817);
$parcel$export(module.exports, "cardSingleSelect", () => $6caea0851d8bed42$export$9df5a921382fd88e);
$parcel$export(module.exports, "CARD_MULTI_SELECT", () => $6caea0851d8bed42$export$674d868bde506f3c);
$parcel$export(module.exports, "cardMultiSelect", () => $6caea0851d8bed42$export$43cca0fb4ffd3a83);
$parcel$export(module.exports, "SET_LAST_SELECTED_CARD_KEY", () => $6caea0851d8bed42$export$c355c5f11b814fa5);
$parcel$export(module.exports, "setLastSelectedCardKey", () => $6caea0851d8bed42$export$7cfa242c22a8bfdd);
$parcel$export(module.exports, "CARD_CLEAR_RELATIVE_CARD", () => $6caea0851d8bed42$export$2310cdad67e30ee6);
$parcel$export(module.exports, "cardClearRelativeCard", () => $6caea0851d8bed42$export$74e6e8a2495983f2);
$parcel$export(module.exports, "CARD_MULTI_SELECT_EXTEND", () => $6caea0851d8bed42$export$73624cc5484d682a);
$parcel$export(module.exports, "cardMultiSelectExtend", () => $6caea0851d8bed42$export$651e3bf6aa397b17);
$parcel$export(module.exports, "CARD_MULTI_REMOVE", () => $6caea0851d8bed42$export$3311b2d7e3ec44e9);
$parcel$export(module.exports, "cardMultiRemove", () => $6caea0851d8bed42$export$f44e863d2e71da4a);
const $6caea0851d8bed42$export$1f7bc7dd5a83e5d6 = 'state.actions.cards.selection.CARD_CLICK';
const $6caea0851d8bed42$export$e7d364bce6e7eb03 = (cardId, withCmd, withShift, withCheckbox, fireSelectionAnalytics, externalAction, analyticsMetadata)=>({
        type: $6caea0851d8bed42$export$1f7bc7dd5a83e5d6,
        payload: {
            cardId: cardId,
            withCmd: withCmd,
            withShift: withShift,
            withCheckbox: withCheckbox,
            fireSelectionAnalytics: fireSelectionAnalytics,
            externalAction: externalAction,
            analyticsMetadata: analyticsMetadata
        }
    });
const $6caea0851d8bed42$export$3c3fc48f596a8caf = 'state.actions.cards.selection.PARENT_CLICK';
const $6caea0851d8bed42$export$5b3ee90f81d7c287 = (cardId)=>({
        type: $6caea0851d8bed42$export$3c3fc48f596a8caf,
        payload: {
            cardId: cardId
        }
    });
const $6caea0851d8bed42$export$5f8bf17701529b20 = 'state.actions.cards.selection.CARD_TOGGLE_SELECTION';
const $6caea0851d8bed42$export$bf1970aeeba42166 = (cardId)=>({
        type: $6caea0851d8bed42$export$5f8bf17701529b20,
        payload: {
            cardId: cardId
        }
    });
const $6caea0851d8bed42$export$9aba3277bb9b4f3 = 'state.actions.cards.selection.CARD_EMPTY_SELECTION';
const $6caea0851d8bed42$export$9bbdebcbf6166d18 = ()=>({
        type: $6caea0851d8bed42$export$9aba3277bb9b4f3
    });
const $6caea0851d8bed42$export$c68d63d54996a817 = 'state.actions.cards.selection.CARD_SINGLE_SELECT';
const $6caea0851d8bed42$export$9df5a921382fd88e = (cardId)=>({
        type: $6caea0851d8bed42$export$c68d63d54996a817,
        payload: {
            cardId: cardId
        }
    });
const $6caea0851d8bed42$export$674d868bde506f3c = 'state.actions.cards.selection.CARD_MULTI_SELECT';
const $6caea0851d8bed42$export$43cca0fb4ffd3a83 = (cardIds)=>({
        type: $6caea0851d8bed42$export$674d868bde506f3c,
        payload: {
            cardIds: cardIds
        }
    });
const $6caea0851d8bed42$export$c355c5f11b814fa5 = 'state.actions.cards.selection.SET_LAST_SELECTED_CARD_KEY';
const $6caea0851d8bed42$export$7cfa242c22a8bfdd = (cardKey)=>({
        type: $6caea0851d8bed42$export$c355c5f11b814fa5,
        payload: {
            cardKey: cardKey
        }
    });
const $6caea0851d8bed42$export$2310cdad67e30ee6 = 'state.actions.cards.selection.CARD_CLEAR_RELATIVE_CARD';
const $6caea0851d8bed42$export$74e6e8a2495983f2 = ()=>({
        type: $6caea0851d8bed42$export$2310cdad67e30ee6
    });
const $6caea0851d8bed42$export$73624cc5484d682a = 'state.actions.cards.selection.CARD_MULTI_SELECT_EXTEND';
const $6caea0851d8bed42$export$651e3bf6aa397b17 = (cardIds)=>({
        type: $6caea0851d8bed42$export$73624cc5484d682a,
        payload: {
            cardIds: cardIds
        }
    });
const $6caea0851d8bed42$export$3311b2d7e3ec44e9 = 'state.actions.cards.selection.CARD_MULTI_REMOVE';
const $6caea0851d8bed42$export$f44e863d2e71da4a = (cardIds)=>({
        type: $6caea0851d8bed42$export$3311b2d7e3ec44e9,
        payload: {
            cardIds: cardIds
        }
    });

});

parcelRegister("bP7Jx", function(module, exports) {

$parcel$export(module.exports, "getCardLists", () => $ca8b20fab5d75757$export$75be3facf1d769f7);
$parcel$export(module.exports, "getCards", () => $ca8b20fab5d75757$export$bc61c71d8347e4d9);
$parcel$export(module.exports, "isBacklogEmptySelector", () => $ca8b20fab5d75757$export$77a8abb93bb2e730);
$parcel$export(module.exports, "getCardListsKeys", () => $ca8b20fab5d75757$export$b0ebc690fddac876);
$parcel$export(module.exports, "getCardsCount", () => $ca8b20fab5d75757$export$4bb6cca38ab53750);
$parcel$export(module.exports, "getCardColor", () => $ca8b20fab5d75757$export$49e99cd9a6ce8b74);
$parcel$export(module.exports, "getCardEpicColor", () => $ca8b20fab5d75757$export$dc5c6effc654e62c);
$parcel$export(module.exports, "makeGetCardTypeHierarchyLevel", () => $ca8b20fab5d75757$export$66175bb0467d3f5b);
$parcel$export(module.exports, "hasCardExtraFields", () => $ca8b20fab5d75757$export$962651073dd96b20);
$parcel$export(module.exports, "getCardExtraFields", () => $ca8b20fab5d75757$export$f338837bff9d7477);
$parcel$export(module.exports, "getCardListCount", () => $ca8b20fab5d75757$export$d63ed38773ad2770);
$parcel$export(module.exports, "getOrderedCardIdsByCardListId", () => $ca8b20fab5d75757$export$3593c0292d4c2e0b);
$parcel$export(module.exports, "makeOrderedCardIdsByCardListIdExcludingSubtasks", () => $ca8b20fab5d75757$export$91f28e45d69d8c3c);
$parcel$export(module.exports, "getOrderedCardListIds", () => $ca8b20fab5d75757$export$5895481c46e9779a);
$parcel$export(module.exports, "getOrderedCardIdsByCardListIdWithLimit", () => $ca8b20fab5d75757$export$5e8030258431459d);
$parcel$export(module.exports, "makeOrderedCardIdsByCardListIdWithLimitExcludingSubtasks", () => $ca8b20fab5d75757$export$c9e173fcee586682);
$parcel$export(module.exports, "getSelectedCards", () => $ca8b20fab5d75757$export$ad9f3c6d3dd8c300);
$parcel$export(module.exports, "getLastSelectedCardKey", () => $ca8b20fab5d75757$export$c30df5b31e28112c);
$parcel$export(module.exports, "getDetailViewData", () => $ca8b20fab5d75757$export$401c35958b2ae848);
$parcel$export(module.exports, "getListSelectionRelativeCard", () => $ca8b20fab5d75757$export$aa636ff49e4c9964);
$parcel$export(module.exports, "getFocusedCard", () => $ca8b20fab5d75757$export$10aea3ed8ea28af7);
$parcel$export(module.exports, "isFilteredCardsLoading", () => $ca8b20fab5d75757$export$eadf838276efbfae);
$parcel$export(module.exports, "isCardSelected", () => $ca8b20fab5d75757$export$a67ae423fb9ea0f9);
$parcel$export(module.exports, "getCardAutoScroll", () => $ca8b20fab5d75757$export$4eeaff5dde2f423b);
$parcel$export(module.exports, "getActiveCard", () => $ca8b20fab5d75757$export$c090658018e2f5dc);
$parcel$export(module.exports, "getActiveCardKey", () => $ca8b20fab5d75757$export$1542f5de67e48825);
$parcel$export(module.exports, "getActiveCardAssignee", () => $ca8b20fab5d75757$export$1b32fabbb013793a);
$parcel$export(module.exports, "cardsSelector", () => $ca8b20fab5d75757$export$c6ca016832785256);
$parcel$export(module.exports, "getCardIds", () => $ca8b20fab5d75757$export$841def0f013aa3d3);
$parcel$export(module.exports, "isDetailViewOpenWithAnySelectedCardSelector", () => $ca8b20fab5d75757$export$9e2c1554ae605d31);
$parcel$export(module.exports, "getOrderedAssignees", () => $ca8b20fab5d75757$export$793179e0c0778f7d);
$parcel$export(module.exports, "getOrderedLabels", () => $ca8b20fab5d75757$export$2777f818bf992a42);
$parcel$export(module.exports, "getOrderedVersions", () => $ca8b20fab5d75757$export$d35c7777091af15b);
$parcel$export(module.exports, "getOrderedCardTypes", () => $ca8b20fab5d75757$export$7fd50a0e5f559f3a);
$parcel$export(module.exports, "getLastSelectedCard", () => $ca8b20fab5d75757$export$66743788dd4e9bd8);
$parcel$export(module.exports, "willDetailViewShow", () => $ca8b20fab5d75757$export$e6b4eade500df666);
$parcel$export(module.exports, "makeCardKeyFromCardId", () => $ca8b20fab5d75757$export$588fddef6c4ed7f9);
$parcel$export(module.exports, "makeCardIdFromCardKey", () => $ca8b20fab5d75757$export$10cabd141980d8a2);
$parcel$export(module.exports, "makeOrderedVisibleCardsForCardList", () => $ca8b20fab5d75757$export$869d157a8342f44f);
$parcel$export(module.exports, "makeOrderedVisibleCardsExcludingSubtasksForCardList", () => $ca8b20fab5d75757$export$488409900307c7a6);
$parcel$export(module.exports, "makeOrderedVisibleCardsExcludingSubtasksForCardListWithLimit", () => $ca8b20fab5d75757$export$b544e9d18cad6c7d);
$parcel$export(module.exports, "getFilteredOrderedCardIdsByCardListId", () => $ca8b20fab5d75757$export$338dee38ad2f42f6);
$parcel$export(module.exports, "makeOrderVisibleCardIdsForCardListWithLimit", () => $ca8b20fab5d75757$export$d5b2e72cab21ec54);
$parcel$export(module.exports, "shouldShowDetailView", () => $ca8b20fab5d75757$export$786319817f19c360);
$parcel$export(module.exports, "makeOrderedVisibleCardIdsForCardList", () => $ca8b20fab5d75757$export$c24a16d8eafb7cff);
$parcel$export(module.exports, "makeOrderedVisibleCardEntriesOld", () => $ca8b20fab5d75757$export$b3426d0830bb4960);
$parcel$export(module.exports, "getExpandedCardGroups", () => $ca8b20fab5d75757$export$d2f7dc3ebc256192);
$parcel$export(module.exports, "makeGetCardGroupExpanded", () => $ca8b20fab5d75757$export$e3846ee85e6596cc);
$parcel$export(module.exports, "getParentIdByChildIdSelector", () => $ca8b20fab5d75757$export$8f9f740048610b66);
$parcel$export(module.exports, "getChildIdsByParentIdSelector", () => $ca8b20fab5d75757$export$63ae7bac909d8340);
$parcel$export(module.exports, "makeGetCardHierarchyLevel", () => $ca8b20fab5d75757$export$c0ec2d5d5f08d6fd);
$parcel$export(module.exports, "makeGetOrderedCardEntries", () => $ca8b20fab5d75757$export$e8229a391aa249b1);
$parcel$export(module.exports, "makeGetAllAttachedToParentCardGroupEntries", () => $ca8b20fab5d75757$export$8187607852c1fedc);
$parcel$export(module.exports, "makeOrderedVisibleCardEntries", () => $ca8b20fab5d75757$export$f4b996b8eaed63ba);
$parcel$export(module.exports, "makeGetVisibleCardOrderFromCardEntries", () => $ca8b20fab5d75757$export$2a0bb0de1d232830);
$parcel$export(module.exports, "getVisibleCardIds", () => $ca8b20fab5d75757$export$ef62d40ffc479d23);
$parcel$export(module.exports, "makeIsCardVisible", () => $ca8b20fab5d75757$export$6b61f32266c676c3);
$parcel$export(module.exports, "makeIsCardOnBoard", () => $ca8b20fab5d75757$export$325317470b38c674);
$parcel$export(module.exports, "makeGetCardListIdByCardId", () => $ca8b20fab5d75757$export$44b7fd430cc830af);
$parcel$export(module.exports, "makeGetFastVirtualListMinimumOffSetByCardListId", () => $ca8b20fab5d75757$export$9436834ba11ae17a);
$parcel$export(module.exports, "makeGetCardListAnalyticsTypeById", () => $ca8b20fab5d75757$export$ab100b26d47e733e);
$parcel$export(module.exports, "makeGetTopCardIdFromCardList", () => $ca8b20fab5d75757$export$57205cd918d1a471);
$parcel$export(module.exports, "makeGetBottomCardIdFromCardList", () => $ca8b20fab5d75757$export$c30c77f267ed58fa);
$parcel$export(module.exports, "hasCardTypesSelector", () => $ca8b20fab5d75757$export$a1e0feed5c998c95);
$parcel$export(module.exports, "getCollapsedCardLists", () => $ca8b20fab5d75757$export$14682dc3868ac2f2);
$parcel$export(module.exports, "makeIsCardListCollapsed", () => $ca8b20fab5d75757$export$48519a9ef4b7246c);
$parcel$export(module.exports, "getVisibleCardListIds", () => $ca8b20fab5d75757$export$a23657169ef5c959);
$parcel$export(module.exports, "getVisibleSprintCardLists", () => $ca8b20fab5d75757$export$277d12d0ad2acbb1);
$parcel$export(module.exports, "isAnyOptimisticCardList", () => $ca8b20fab5d75757$export$44ac769c42548b1);
$parcel$export(module.exports, "makeGetNextCardListId", () => $ca8b20fab5d75757$export$91ea52aeac57cc52);
$parcel$export(module.exports, "getFlattenOrderedCardIds", () => $ca8b20fab5d75757$export$9fc808638e14d4f0);
$parcel$export(module.exports, "makeIsCardListDisabled", () => $ca8b20fab5d75757$export$b40f586b1b1b5b3d);
$parcel$export(module.exports, "makeGetMaxColumnLimit", () => $ca8b20fab5d75757$export$86fa3555538a1895);
$parcel$export(module.exports, "makeGetMinColumnLimit", () => $ca8b20fab5d75757$export$daddaca8cdd663b3);
$parcel$export(module.exports, "validFilterValuesSelector", () => $ca8b20fab5d75757$export$a3e606d31ce14076);
$parcel$export(module.exports, "hasInvalidFilterValuesSelector", () => $ca8b20fab5d75757$export$e5ce012c8ff94f67);
$parcel$export(module.exports, "selectedCardsForVersionsPanelSelector", () => $ca8b20fab5d75757$export$116ea4e15b17d748);
$parcel$export(module.exports, "selectedPartialCardsWithTypeHierarchyLevelSelector", () => $ca8b20fab5d75757$export$97279e04a1cfee44);
$parcel$export(module.exports, "partialCardsFromCardIdsSelector", () => $ca8b20fab5d75757$export$cb1654a9ed6d9099);
$parcel$export(module.exports, "cardsForFlagWithCommentModalFromCardIdsSelector", () => $ca8b20fab5d75757$export$9656edc7cd965e96);
$parcel$export(module.exports, "numTotalIssueChildren", () => $ca8b20fab5d75757$export$1b6edd941a4eaddd);
$parcel$export(module.exports, "numCompleteIssueChildren", () => $ca8b20fab5d75757$export$18ec94fe8e415ca5);
$parcel$export(module.exports, "getKeyByIdForAllIssueTypes", () => $ca8b20fab5d75757$export$ebb887ede9b3994e);
$parcel$export(module.exports, "getIdByKeyForAllIssueTypes", () => $ca8b20fab5d75757$export$8d7d30d4816f6177);
$parcel$export(module.exports, "getCardIdWithAboveICCOpen", () => $ca8b20fab5d75757$export$7170cae353180463);
$parcel$export(module.exports, "hasICCOpen", () => $ca8b20fab5d75757$export$8f8d79952e8c1b8f);
$parcel$export(module.exports, "getAllCardIdsIncludingIssueParents", () => $ca8b20fab5d75757$export$ee56c425125d2ef6);
$parcel$export(module.exports, "getCardListStats", () => $ca8b20fab5d75757$export$22d153c4cb386f10);
$parcel$export(module.exports, "shouldRenderRichElements", () => $ca8b20fab5d75757$export$6450c8aec6d3b414);
$parcel$export(module.exports, "makeGetDefaultRowSize", () => $ca8b20fab5d75757$export$454eae1b4bd66f70);
$parcel$export(module.exports, "getDefaultCardHeight", () => $ca8b20fab5d75757$export$697c63a5f8659c9);
$parcel$export(module.exports, "getIsCardListDragInProgress", () => $ca8b20fab5d75757$export$ac2362f84ffb1564);
$parcel$export(module.exports, "getIsDragging", () => $ca8b20fab5d75757$export$59261b5a26c04c00);
$parcel$export(module.exports, "makeGetSourceCardListId", () => $ca8b20fab5d75757$export$a62ade440fb97a7a);
$parcel$export(module.exports, "makeGetSourceCardGroupId", () => $ca8b20fab5d75757$export$f787c700d21c234a);
$parcel$export(module.exports, "cardVersionsSelector", () => $ca8b20fab5d75757$export$2b8ccf236ef3c2ad);
$parcel$export(module.exports, "getFirstNonEmptyCardListId", () => $ca8b20fab5d75757$export$10c1cb90425eb140);
$parcel$export(module.exports, "backlogHasFlaggedCards", () => $ca8b20fab5d75757$export$91d6529e043b6231);
$parcel$export(module.exports, "backlogHasPriority", () => $ca8b20fab5d75757$export$df669897ce3195c6);
$parcel$export(module.exports, "backlogHasDueDate", () => $ca8b20fab5d75757$export$41cf0539676d3407);
$parcel$export(module.exports, "backlogHasStoryPoints", () => $ca8b20fab5d75757$export$242c58db4e305622);
$parcel$export(module.exports, "backlogHasEstimates", () => $ca8b20fab5d75757$export$261deb4fe884b0a1);
$parcel$export(module.exports, "getLastNonEmptyCardListId", () => $ca8b20fab5d75757$export$5bab56d9e503125d);
$parcel$export(module.exports, "makeGetDraggingCardIds", () => $ca8b20fab5d75757$export$eb5d19e26822928b);

var $6HC1D = parcelRequire("6HC1D");

var $df4Sl = parcelRequire("df4Sl");

var $gHHen = parcelRequire("gHHen");

var $iVIEg = parcelRequire("iVIEg");

var $bCHHi = parcelRequire("bCHHi");

var $illlw = parcelRequire("illlw");

var $fcWBJ = parcelRequire("fcWBJ");

var $kG4jb = parcelRequire("kG4jb");

var $8blac = parcelRequire("8blac");

var $ldoFd = parcelRequire("ldoFd");

var $czx3b = parcelRequire("czx3b");

var $cD8SO = parcelRequire("cD8SO");

var $jqvCZ = parcelRequire("jqvCZ");

var $kFGm5 = parcelRequire("kFGm5");

var $lUFEu = parcelRequire("lUFEu");

var $4YjDD = parcelRequire("4YjDD");

var $27QuD = parcelRequire("27QuD");

var $MdoH4 = parcelRequire("MdoH4");

var $lyOYo = parcelRequire("lyOYo");

var $h1xZf = parcelRequire("h1xZf");

var $3l6tm = parcelRequire("3l6tm");


var $9eH8H = parcelRequire("9eH8H");

var $8wXFi = parcelRequire("8wXFi");

var $7TyGu = parcelRequire("7TyGu");


var $3sfdp = parcelRequire("3sfdp");

var $hkGxG = parcelRequire("hkGxG");

var $6ncr6 = parcelRequire("6ncr6");

var $kF7v3 = parcelRequire("kF7v3");

var $kdGmo = parcelRequire("kdGmo");

var $k734R = parcelRequire("k734R");

var $c2v8q = parcelRequire("c2v8q");

var $ai2KE = parcelRequire("ai2KE");
const $ca8b20fab5d75757$export$75be3facf1d769f7 = (state)=>(0, $kF7v3.getEntities)(state).cardList;
const $ca8b20fab5d75757$export$bc61c71d8347e4d9 = (state)=>(0, $kF7v3.getEntities)(state).card;
const $ca8b20fab5d75757$export$77a8abb93bb2e730 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$bc61c71d8347e4d9
], (cards)=>Object.keys(cards).length === 0);
const $ca8b20fab5d75757$export$b0ebc690fddac876 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$75be3facf1d769f7
], (cardLists)=>Object.keys(cardLists));
const $ca8b20fab5d75757$export$4bb6cca38ab53750 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$bc61c71d8347e4d9
], (cards)=>Object.keys(cards).length);
const $ca8b20fab5d75757$var$getCardById = (cards, cardId)=>cards[String(cardId)];
const $ca8b20fab5d75757$export$49e99cd9a6ce8b74 = (state, cardId)=>{
    const cards = $ca8b20fab5d75757$export$bc61c71d8347e4d9(state);
    const color = $ca8b20fab5d75757$var$getCardById(cards, cardId)?.color;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(color) || (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))((0, (/*@__PURE__*/$parcel$interopDefault($27QuD)))(color))) return undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($27QuD)))(color);
};
const $ca8b20fab5d75757$export$dc5c6effc654e62c = (state, cardId)=>{
    const cards = $ca8b20fab5d75757$export$bc61c71d8347e4d9(state);
    const color = $ca8b20fab5d75757$var$getCardById(cards, cardId)?.epicColor;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(color) || (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))((0, (/*@__PURE__*/$parcel$interopDefault($27QuD)))(color))) return undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($27QuD)))(color);
};
const $ca8b20fab5d75757$export$66175bb0467d3f5b = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$bc61c71d8347e4d9,
    (0, $k734R.getIssueParents),
    (0, $6ncr6.getBaseLevelCardTypes)
], (cards, parents, allCardTypes)=>(cardId)=>{
        const card = cards[cardId];
        if (card) {
            const cardType = allCardTypes.find((it)=>it.id === card.typeId);
            return cardType?.typeHierarchyLevel ?? (0, $3l6tm.BASE_HIERARCHY_TYPE);
        }
        const parent = parents[cardId];
        return parent ? (0, $3l6tm.PARENT_HIERARCHY_TYPE) : (0, $3l6tm.BASE_HIERARCHY_TYPE);
    });
const $ca8b20fab5d75757$export$962651073dd96b20 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$bc61c71d8347e4d9
], (cards)=>(0, (/*@__PURE__*/$parcel$interopDefault($lUFEu)))(cards, (card)=>card?.extraFields ? card.extraFields.length > 0 : false));
const $ca8b20fab5d75757$export$f338837bff9d7477 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$bc61c71d8347e4d9
], (cards)=>{
    const extraFieldsMap = new Map();
    Object.values(cards).forEach((card)=>{
        card.extraFields?.forEach((field)=>extraFieldsMap.set(field.id, field));
    });
    return Array.from(extraFieldsMap.values());
});
const $ca8b20fab5d75757$export$d63ed38773ad2770 = (state)=>{
    const { cardList: cardList } = (0, $kF7v3.getEntities)(state);
    return Object.keys(cardList).length;
};
const $ca8b20fab5d75757$export$3593c0292d4c2e0b = (state)=>(0, $kF7v3.getEntities)(state).cardOrder;
const $ca8b20fab5d75757$export$85056ee91e64823a = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$3593c0292d4c2e0b
], (orderedCardIdsByCardListId)=>(0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((cardListId)=>orderedCardIdsByCardListId?.[cardListId] || []));
const $ca8b20fab5d75757$export$91f28e45d69d8c3c = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$bc61c71d8347e4d9,
    $ca8b20fab5d75757$export$3593c0292d4c2e0b
], (allCards, orderedCardIdsByCardListId)=>(0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((cardListId)=>{
        const cardIds = orderedCardIdsByCardListId?.[cardListId];
        if (!cardIds) return [];
        return cardIds.filter((cardId)=>!(0, $3l6tm.isSubtaskHierarchyLevel)(allCards[String(cardId)].typeHierarchyLevel));
    }));
const $ca8b20fab5d75757$export$70f41e60f354f620 = (cardOrder, cardListOrder, limit = 50)=>{
    let currentCount = 0;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const truncatedCardIds = {};
    cardListOrder.forEach((listId)=>{
        const cardIds = cardOrder[listId];
        if (!cardIds) return;
        const remaining = limit - currentCount;
        const sliceAmount = Math.min(remaining, cardIds.length);
        const firstCards = cardIds.slice(0, sliceAmount);
        truncatedCardIds[listId] = firstCards;
        currentCount += sliceAmount;
    });
    return truncatedCardIds;
};
const $ca8b20fab5d75757$export$5895481c46e9779a = (state)=>(0, $kF7v3.getEntities)(state).cardListOrder;
const $ca8b20fab5d75757$export$5e8030258431459d = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$3593c0292d4c2e0b,
    $ca8b20fab5d75757$export$5895481c46e9779a
], (cardOrder, cardListOrder)=>$ca8b20fab5d75757$export$70f41e60f354f620(cardOrder, cardListOrder));
const $ca8b20fab5d75757$export$c9e173fcee586682 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$bc61c71d8347e4d9,
    $ca8b20fab5d75757$export$3593c0292d4c2e0b,
    $ca8b20fab5d75757$export$5895481c46e9779a
], (allCards, orderedCardIdsByCardListId, cardListOrder)=>{
    const initialResult = $ca8b20fab5d75757$export$70f41e60f354f620(orderedCardIdsByCardListId, cardListOrder);
    const result = {};
    cardListOrder.forEach((cardListId)=>{
        const cardIds = initialResult[cardListId] ?? [];
        result[cardListId] = cardIds.filter((cardId)=>!(0, $3l6tm.isSubtaskHierarchyLevel)(allCards[String(cardId)].typeHierarchyLevel));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((cardListId)=>result[cardListId] ?? []);
});
const $ca8b20fab5d75757$export$ad9f3c6d3dd8c300 = (state)=>state.ui.cards.selected;
const $ca8b20fab5d75757$export$c30df5b31e28112c = (state)=>state.ui.cards.lastSelectedCardKey;
const $ca8b20fab5d75757$export$401c35958b2ae848 = (state)=>state.ui.detailView;
const $ca8b20fab5d75757$export$aa636ff49e4c9964 = (state)=>state.ui.cards.listSelectionRelativeCard;
const $ca8b20fab5d75757$export$10aea3ed8ea28af7 = (state)=>state.ui.cards.focused;
const $ca8b20fab5d75757$export$5496a8bd76ac3cc7 = (state)=>state.ui.cards.filteredCards.filteredCardsIds;
const $ca8b20fab5d75757$export$eadf838276efbfae = (state)=>state.ui.cards.filteredCards.isLoading;
const $ca8b20fab5d75757$export$73a0d145c861a8f6 = (state)=>state.ui.cards.fields.isStatusFieldsHidden;
const $ca8b20fab5d75757$export$62270500eeccff2a = (state)=>state.ui.cards.fields.isVersionFieldsHidden;
const $ca8b20fab5d75757$export$f96a2f7628e75ad2 = (state)=>state.ui.cards.fields.isEpicFieldsHidden;
const $ca8b20fab5d75757$export$a67ae423fb9ea0f9 = (0, $df4Sl.createSelector)($ca8b20fab5d75757$export$ad9f3c6d3dd8c300, (selectedCards)=>(cardId)=>selectedCards.includes(cardId));
const $ca8b20fab5d75757$export$4eeaff5dde2f423b = (state)=>state.ui.cards.autoScroll;
const $ca8b20fab5d75757$export$c090658018e2f5dc = (state)=>{
    const focusedCard = $ca8b20fab5d75757$export$10aea3ed8ea28af7(state);
    if (focusedCard !== null) return focusedCard;
    const selectedCards = $ca8b20fab5d75757$export$ad9f3c6d3dd8c300(state);
    return selectedCards[selectedCards.length - 1];
};
const $ca8b20fab5d75757$export$1542f5de67e48825 = (state)=>{
    const activeCardId = $ca8b20fab5d75757$export$c090658018e2f5dc(state);
    const allCards = $ca8b20fab5d75757$export$bc61c71d8347e4d9(state);
    return allCards[String(activeCardId)] && allCards[String(activeCardId)].key;
};
const $ca8b20fab5d75757$export$1b32fabbb013793a = (state)=>{
    const activeCardId = $ca8b20fab5d75757$export$c090658018e2f5dc(state);
    const allCards = $ca8b20fab5d75757$export$bc61c71d8347e4d9(state);
    return allCards[String(activeCardId)] && allCards[String(activeCardId)].assignee;
};
const $ca8b20fab5d75757$export$c6ca016832785256 = (0, $df4Sl.createSelector)($ca8b20fab5d75757$export$bc61c71d8347e4d9, (cards)=>Object.values(cards));
const $ca8b20fab5d75757$export$841def0f013aa3d3 = (0, $df4Sl.createSelector)($ca8b20fab5d75757$export$c6ca016832785256, (cards)=>cards.map((card)=>card.id));
const $ca8b20fab5d75757$export$9e2c1554ae605d31 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$401c35958b2ae848,
    $ca8b20fab5d75757$export$ad9f3c6d3dd8c300
], (detailView, selectedCards)=>detailView && selectedCards.indexOf(detailView.cardId) > -1);
const $ca8b20fab5d75757$export$793179e0c0778f7d = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$bc61c71d8347e4d9,
    (0, $c2v8q.getCurrentUser),
    (0, $hkGxG.getIsCompanyManaged)
], (allCards, currentUser, isCompanyManaged)=>{
    const currentUserId = currentUser ? currentUser.id : null;
    const assigneeList = Object.values(allCards).map((card)=>card.assignee) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((people, person)=>{
        if (person && person.id !== currentUserId) people.push(person);
        return people;
    }, []);
    const uniqueAssigneeList = (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(assigneeList, (assignee)=>assignee.id);
    if (isCompanyManaged) uniqueAssigneeList.sort((a, b)=>a.displayName.localeCompare(b.displayName));
    else {
        const assigneeCounts = (0, (/*@__PURE__*/$parcel$interopDefault($gHHen)))(assigneeList, (assignee)=>assignee.id);
        uniqueAssigneeList.sort((a, b)=>assigneeCounts[b.id] - assigneeCounts[a.id]);
    }
    if (currentUser) uniqueAssigneeList.unshift(currentUser);
    return (0, $6HC1D.freeze)(uniqueAssigneeList);
});
const $ca8b20fab5d75757$export$2777f818bf992a42 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$bc61c71d8347e4d9
], (allCards)=>(0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))(Object.values(allCards).reduce((labels, card)=>{
        if (card.labels && card.labels.length > 0) labels.push(...card.labels);
        return labels;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, [])).sort((a, b)=>(0, $h1xZf.alphabeticalSort)(a, b)));
const $ca8b20fab5d75757$export$d35c7777091af15b = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$bc61c71d8347e4d9
], (allCards)=>(0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))(Object.values(allCards).reduce((fixVersions, card)=>card.fixVersions && card.fixVersions.length > 0 ? fixVersions.concat(card.fixVersions) : fixVersions, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    [])).sort((a, b)=>(0, $h1xZf.alphabeticalSort)(a, b)));
const $ca8b20fab5d75757$export$f9311774fcd7a245 = (0, $df4Sl.createSelector)([
    (0, $ai2KE.getVersionsOrder)
], (versions)=>versions.concat().sort((a, b)=>(0, $h1xZf.alphabeticalSort)(a, b)));
const $ca8b20fab5d75757$export$d4dec7daa49a8c5 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$bc61c71d8347e4d9
], (allCards)=>(0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))(Object.values(allCards).map((card)=>String(card.typeId))));
const $ca8b20fab5d75757$export$7fd50a0e5f559f3a = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$d4dec7daa49a8c5,
    (0, $6ncr6.getCardTypes)
], (uniqCardTypeIds, allCardTypes)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const uniqCardTypes = uniqCardTypeIds.reduce((cardTypes, typeId)=>{
        const foundCardType = allCardTypes.find((cardType)=>String(cardType.id) === typeId);
        if (foundCardType) cardTypes.push({
            id: String(foundCardType.id),
            name: foundCardType.name,
            iconUrl: foundCardType.iconUrl,
            typeHierarchyLevel: foundCardType.typeHierarchyLevel ?? null
        });
        return cardTypes;
    }, []);
    return uniqCardTypes.sort((a, b)=>(0, $h1xZf.alphabeticalSort)(a.name, b.name));
});
const $ca8b20fab5d75757$export$66743788dd4e9bd8 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$ad9f3c6d3dd8c300
], (cardSelection)=>cardSelection.slice(-1)[0] || null);
const $ca8b20fab5d75757$export$e6b4eade500df666 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$c30df5b31e28112c
], (lastSelectedCardKey)=>lastSelectedCardKey !== '');
const $ca8b20fab5d75757$export$588fddef6c4ed7f9 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$bc61c71d8347e4d9,
    (0, $k734R.getIssueParents)
], (cards, issueParents)=>{
    const unmappedParents = {};
    Object.values(cards).forEach(({ parentId: parentId, parentKey: parentKey })=>{
        if (parentId && parentKey && !cards[parentId] && !issueParents[parentId] && !unmappedParents[parentId]) unmappedParents[parentId] = {
            key: parentKey
        };
    });
    return (cardId)=>(cards[cardId] || issueParents[cardId] || unmappedParents[cardId])?.key ?? null;
});
const $ca8b20fab5d75757$export$10cabd141980d8a2 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$bc61c71d8347e4d9
], (allCards)=>(0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((cardKey)=>{
        const cardIdWithKey = Object.keys(allCards).find((cardId)=>allCards[cardId]?.key === cardKey);
        return Number(cardIdWithKey);
    }));
const $ca8b20fab5d75757$export$4d2a5b62ef91607b = (0, $df4Sl.createSelector)([
    (0, $kdGmo.getFilters),
    $ca8b20fab5d75757$export$5496a8bd76ac3cc7,
    $ca8b20fab5d75757$export$bc61c71d8347e4d9
], (filterValues, filteredCardIds, allCards)=>(0, $kdGmo.filter)(filterValues, filteredCardIds || undefined, Object.values(allCards)));
const $ca8b20fab5d75757$export$869d157a8342f44f = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$bc61c71d8347e4d9,
    $ca8b20fab5d75757$export$3593c0292d4c2e0b,
    $ca8b20fab5d75757$export$4d2a5b62ef91607b
], (allCards, orderedCardIdsLists, filterFunction)=>{
    const getOrderedVisibleCards = (cardListId)=>{
        const cardIds = orderedCardIdsLists[cardListId];
        if (!cardIds) return [];
        const unfilteredList = cardIds.filter((cardId)=>allCards[String(cardId)]).map((cardId)=>allCards[String(cardId)]);
        return filterFunction(unfilteredList);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))(getOrderedVisibleCards);
});
const $ca8b20fab5d75757$export$488409900307c7a6 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$bc61c71d8347e4d9,
    $ca8b20fab5d75757$export$3593c0292d4c2e0b,
    $ca8b20fab5d75757$export$4d2a5b62ef91607b
], (allCards, orderedCardIdsLists, filterFunction)=>{
    const getOrderedVisibleCardsExcludingSubtasks = (cardListId)=>{
        const cardIds = orderedCardIdsLists[cardListId];
        if (!cardIds) return [];
        const unfilteredList = cardIds.filter((cardId)=>allCards[String(cardId)] && !(0, $3l6tm.isSubtaskHierarchyLevel)(allCards[String(cardId)].typeHierarchyLevel)).map((cardId)=>allCards[String(cardId)]);
        return filterFunction(unfilteredList);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))(getOrderedVisibleCardsExcludingSubtasks);
});
const $ca8b20fab5d75757$export$aed4af4b88bc3874 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$bc61c71d8347e4d9,
    $ca8b20fab5d75757$export$5e8030258431459d,
    $ca8b20fab5d75757$export$4d2a5b62ef91607b
], (allCards, orderedCardIdsLists, filterFunction)=>(0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((cardListId)=>{
        const cardIds = orderedCardIdsLists[cardListId];
        if (!cardIds) return [];
        const unfilteredList = cardIds.filter((cardId)=>allCards[String(cardId)]).map((cardId)=>allCards[String(cardId)]);
        return filterFunction(unfilteredList);
    }));
const $ca8b20fab5d75757$export$b544e9d18cad6c7d = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$bc61c71d8347e4d9,
    $ca8b20fab5d75757$export$5e8030258431459d,
    $ca8b20fab5d75757$export$4d2a5b62ef91607b
], (allCards, orderedCardIdsLists, filterFunction)=>(0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((cardListId)=>{
        const cardIds = orderedCardIdsLists[cardListId];
        if (!cardIds) return [];
        const unfilteredList = cardIds.filter((cardId)=>allCards[String(cardId)] && !(0, $3l6tm.isSubtaskHierarchyLevel)(allCards[String(cardId)].typeHierarchyLevel)).map((cardId)=>allCards[String(cardId)]);
        return filterFunction(unfilteredList);
    }));
const $ca8b20fab5d75757$export$338dee38ad2f42f6 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$bc61c71d8347e4d9,
    $ca8b20fab5d75757$export$3593c0292d4c2e0b,
    $ca8b20fab5d75757$export$4d2a5b62ef91607b
], (allCards, orderedCardIdsLists, filterFunction)=>Object.fromEntries(Object.entries(orderedCardIdsLists).map(([key, values])=>{
        const unfilteredList = values.filter((cardId)=>allCards[String(cardId)]).map((cardId)=>allCards[String(cardId)]);
        const filteredIds = filterFunction(unfilteredList).map((card)=>card.id);
        return [
            key,
            filteredIds
        ];
    })));
const $ca8b20fab5d75757$export$d5b2e72cab21ec54 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$aed4af4b88bc3874
], (getOrderedVisibleCardsForCardList)=>(0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((cardListId)=>getOrderedVisibleCardsForCardList(cardListId).map((card)=>card.id)));
const $ca8b20fab5d75757$export$786319817f19c360 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$401c35958b2ae848
], (detailView)=>detailView !== null);
const $ca8b20fab5d75757$export$c24a16d8eafb7cff = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$869d157a8342f44f
], (getOrderedVisibleCardsForCardList)=>{
    const getOrderedVisibileCardIds = (cardListId)=>getOrderedVisibleCardsForCardList(cardListId).map((card)=>card.id);
    return (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))(getOrderedVisibileCardIds);
});
const $ca8b20fab5d75757$export$b3426d0830bb4960 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$869d157a8342f44f
], (getOrderedVisibleCardsForCardList)=>{
    const getOrderedVisibileCardIds = (cardListId)=>getOrderedVisibleCardsForCardList(cardListId).map((card)=>({
                type: 'card',
                cardId: card.id
            }));
    return (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))(getOrderedVisibileCardIds);
});
const $ca8b20fab5d75757$export$d2f7dc3ebc256192 = (state)=>state.ui.cardList.cardGroupExpanded;
const $ca8b20fab5d75757$export$e3846ee85e6596cc = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$bc61c71d8347e4d9,
    $ca8b20fab5d75757$export$d2f7dc3ebc256192
], (cards, expandedCardGroups)=>{
    const getCardGroupExpanded = (cardId)=>{
        const card = $ca8b20fab5d75757$var$getCardById(cards, cardId);
        if (card && card.parentId && (0, $3l6tm.isSubtaskHierarchyLevel)(card?.typeHierarchyLevel)) // you passed in a subtask, checking if the parent is expanded
        return expandedCardGroups[card.parentId];
        return expandedCardGroups[cardId];
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))(getCardGroupExpanded);
});
const $ca8b20fab5d75757$export$8f9f740048610b66 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$bc61c71d8347e4d9
], (cards)=>{
    const getParentId = (cardId)=>$ca8b20fab5d75757$var$getCardById(cards, cardId)?.parentId ?? undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))(getParentId);
});
const $ca8b20fab5d75757$export$63ae7bac909d8340 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$bc61c71d8347e4d9
], (cards)=>{
    const cardsByParent = (0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))(cards, (card)=>(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(card, 'parentId', 'NO_PARENT'));
    const cardsWithParent = (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(cardsByParent, 'NO_PARENT');
    return (0, (/*@__PURE__*/$parcel$interopDefault($czx3b)))(cardsWithParent, (childCards)=>childCards.map((card)=>card.id));
});
const $ca8b20fab5d75757$export$c0ec2d5d5f08d6fd = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$bc61c71d8347e4d9
], (cards)=>{
    const getHierarchyLevel = (cardId)=>$ca8b20fab5d75757$var$getCardById(cards, cardId)?.typeHierarchyLevel ?? undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))(getHierarchyLevel);
});
const $ca8b20fab5d75757$export$e8229a391aa249b1 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$8f9f740048610b66,
    $ca8b20fab5d75757$export$869d157a8342f44f,
    $ca8b20fab5d75757$export$e3846ee85e6596cc
], (getParentId, getOrderedVisibleCardsForCardList, getIsGroupExpanded)=>{
    const getOrderedVisibileCardIds = (cardListId)=>{
        const cardEntries = [];
        const cards = getOrderedVisibleCardsForCardList(cardListId);
        const cardIds = cards.map((card)=>card.id);
        const nonParentCardIds = cards.filter((card)=>!(0, $3l6tm.isSubtaskHierarchyLevel)(card.typeHierarchyLevel)).map((card)=>card.id);
        const parentCardIds = cards.filter((card)=>(0, $3l6tm.isSubtaskHierarchyLevel)(card.typeHierarchyLevel) && !!getParentId(card.id)).map((card)=>card.id);
        const parentCardIdsByChild = (0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))(parentCardIds, getParentId);
        const childCardEntries = [
            []
        ];
        cardIds?.forEach((cardId)=>{
            if (nonParentCardIds.includes(cardId)) {
                cardEntries.push({
                    type: 'card',
                    cardId: cardId
                });
                return;
            }
            const parentId = getParentId(cardId);
            if (!parentId || !(parentId in parentCardIdsByChild)) return;
            const isGroupCollapsed = !getIsGroupExpanded(parentId);
            const parent = cardEntries.find((entry)=>!(0, $3sfdp.isCardEntryGroup)(entry) && entry.cardId === parentId);
            // If parent and subtasks are in the same list find parent index and insert group next to it
            if (nonParentCardIds.includes(parentId)) {
                const isAttachedToParent = nonParentCardIds.includes(parentId);
                if (parent !== undefined) {
                    const parentIndex = cardEntries.indexOf(parent);
                    cardEntries.splice(parentIndex + 1, 0, {
                        type: 'group',
                        parentId: parentId,
                        cardIds: parentCardIdsByChild[parentId],
                        isAttachedToParent: isAttachedToParent,
                        // Only card groups with a parent are able to be visually collapsed
                        isCollapsed: isGroupCollapsed && isAttachedToParent
                    });
                } else childCardEntries.push(parentCardIdsByChild[parentId]);
            } else {
                const isAttachedToParent = nonParentCardIds.includes(parentId);
                cardEntries.push({
                    type: 'group',
                    parentId: parentId,
                    cardIds: parentCardIdsByChild[parentId],
                    isAttachedToParent: isAttachedToParent,
                    isCollapsed: isGroupCollapsed && isAttachedToParent
                });
            }
            delete parentCardIdsByChild[parentId];
        });
        if (childCardEntries.length > 0) {
            childCardEntries.forEach((subtask)=>{
                const parentId = getParentId(subtask[0]);
                const parent = cardEntries.find((entry)=>!(0, $3sfdp.isCardEntryGroup)(entry) && entry.cardId === parentId);
                if (parent !== undefined && parentId !== undefined) {
                    const parentIndex = cardEntries.indexOf(parent);
                    const isCollapsed = !getIsGroupExpanded(parentId);
                    cardEntries.splice(parentIndex + 1, 0, {
                        type: 'group',
                        parentId: parentId,
                        cardIds: subtask,
                        isAttachedToParent: true,
                        isCollapsed: isCollapsed
                    });
                }
            });
            return cardEntries;
        }
        return cardEntries;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))(getOrderedVisibileCardIds);
});
const $ca8b20fab5d75757$export$8187607852c1fedc = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$b0ebc690fddac876,
    $ca8b20fab5d75757$export$e8229a391aa249b1
], (cardListKeys, getOrderedCardEntries)=>{
    const getAllAttachedToParentCardGroupEntries = ()=>{
        let cardEntryGroups = [];
        cardListKeys.forEach((cardListId)=>{
            const cardEntries = getOrderedCardEntries(cardListId);
            const groupCardEntries = cardEntries.filter((0, $3sfdp.isCardEntryGroup));
            const attachedToParentGroupCardEntries = groupCardEntries.filter((cardEntry)=>cardEntry.isAttachedToParent);
            cardEntryGroups = cardEntryGroups.concat(attachedToParentGroupCardEntries);
        });
        return cardEntryGroups;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))(getAllAttachedToParentCardGroupEntries);
});
const $ca8b20fab5d75757$export$f4b996b8eaed63ba = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$e8229a391aa249b1
], (getOrderedCardEntries)=>{
    const getOrderedVisibileCardIds = (cardListId)=>{
        const cardEntries = getOrderedCardEntries(cardListId);
        return cardEntries.filter((cardEntry)=>{
            if ((0, $3sfdp.isCardEntryGroup)(cardEntry)) return !cardEntry.isCollapsed;
            return true;
        });
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))(getOrderedVisibileCardIds);
});
const $ca8b20fab5d75757$export$2a0bb0de1d232830 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$f4b996b8eaed63ba
], (cardEntries)=>{
    const getVisibleCardOrderFromCardEntries = (cardListId)=>{
        const currentCardEntries = cardEntries(cardListId);
        return currentCardEntries.flatMap((entry)=>(0, $3sfdp.isCardEntryGroup)(entry) ? entry.cardIds : entry.cardId);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))(getVisibleCardOrderFromCardEntries);
});
const $ca8b20fab5d75757$export$ef62d40ffc479d23 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$c24a16d8eafb7cff,
    $ca8b20fab5d75757$export$5895481c46e9779a
], (getOrderedVisibleCardIdsForCardList, cardListIds)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    cardListIds.reduce((allCards, id)=>allCards.concat(getOrderedVisibleCardIdsForCardList(id)), []));
const $ca8b20fab5d75757$export$6b61f32266c676c3 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$bc61c71d8347e4d9,
    $ca8b20fab5d75757$export$4d2a5b62ef91607b
], (allCards, filterFunction)=>(id)=>{
        const card = allCards[`${id}`];
        if (!card) return false;
        const list = filterFunction([
            card
        ]);
        return list.length !== 0;
    });
const $ca8b20fab5d75757$export$325317470b38c674 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$3593c0292d4c2e0b
], (cardIdsByCardList)=>{
    const getIsCardOnBoard = (id)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(cardIdsByCardList, [
            (0, $7TyGu.BOARD)
        ], []).includes(id);
    return getIsCardOnBoard;
});
const $ca8b20fab5d75757$export$44b7fd430cc830af = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$3593c0292d4c2e0b
], (cardIdsByCardList)=>{
    const getCardListIdByCardId = (id)=>Object.keys(cardIdsByCardList).find((cardListId)=>cardIdsByCardList[cardListId].includes(id));
    return getCardListIdByCardId;
});
const $ca8b20fab5d75757$export$9436834ba11ae17a = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$5895481c46e9779a,
    $ca8b20fab5d75757$export$c24a16d8eafb7cff
], (cardListIds, orderedVisibleCardIdsForCardList)=>{
    const getFastVirtualListMinimumOffSetByCardListId = (cardListId)=>{
        const cardListIndex = cardListIds.findIndex((id)=>id === cardListId);
        let offset = 0;
        for(let i = 0; i < cardListIndex; i += 1)offset += orderedVisibleCardIdsForCardList(cardListIds[i]).length * 40;
        return offset;
    };
    return getFastVirtualListMinimumOffSetByCardListId;
});
const $ca8b20fab5d75757$export$ab100b26d47e733e = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$75be3facf1d769f7
], (cardLists)=>(0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((id)=>{
        if (id === (0, $7TyGu.BACKLOG)) return 0, $7TyGu.BACKLOG;
        // If its a sprint, figure out whether its an active one or not, else kanban board
        const card = cardLists[id];
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(card) && card.type === (0, $7TyGu.SPRINT) && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(card.sprintData)) return card.sprintData.state === 'ACTIVE' ? (0, $7TyGu.ACTIVE_SPRINT) : (0, $7TyGu.INACTIVE_SPRINT);
        // Default to null or we will get skewed analytics
        return id === (0, $7TyGu.BOARD) ? (0, $7TyGu.BOARD) : null;
    }));
const $ca8b20fab5d75757$export$57205cd918d1a471 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$3593c0292d4c2e0b,
    $ca8b20fab5d75757$export$bc61c71d8347e4d9
], (cardIdsByCardList, allCards)=>(cardListId, ignoredIds = [])=>{
        const list = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(cardIdsByCardList[cardListId], ignoredIds);
        const cardId = list.length > 0 ? list[0] : null;
        if (cardId && (0, $3l6tm.isSubtaskHierarchyLevel)(allCards[String(cardId)]?.typeHierarchyLevel)) return allCards[String(cardId)].parentId;
        return cardId;
    });
const $ca8b20fab5d75757$export$c30c77f267ed58fa = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$3593c0292d4c2e0b
], (cardIdsByCardList)=>(cardListId, ignoredIds = [])=>{
        const list = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(cardIdsByCardList[cardListId], ignoredIds);
        return list.length > 0 ? list[list.length - 1] : null;
    });
const $ca8b20fab5d75757$export$a1e0feed5c998c95 = (0, $df4Sl.createSelector)([
    (0, $6ncr6.getBaseLevelCardTypes)
], (cardTypes)=>cardTypes?.length > 0);
const $ca8b20fab5d75757$export$14682dc3868ac2f2 = (state)=>state.ui.cardList.collapsed;
const $ca8b20fab5d75757$export$48519a9ef4b7246c = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$14682dc3868ac2f2
], (collapsedCardLists)=>(cardListId)=>!!collapsedCardLists[cardListId]);
const $ca8b20fab5d75757$export$a23657169ef5c959 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$75be3facf1d769f7,
    $ca8b20fab5d75757$export$5895481c46e9779a
], (cardLists, ids)=>ids.filter((id)=>!cardLists[id]?.isOptimistic));
const $ca8b20fab5d75757$export$277d12d0ad2acbb1 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$75be3facf1d769f7,
    $ca8b20fab5d75757$export$5895481c46e9779a
], (cardLists, ids)=>ids.reduce((accVisibleSprintCardLists, id)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const card = cardLists[id];
        if (card && !card.isOptimistic && card.type === (0, $7TyGu.SPRINT)) accVisibleSprintCardLists.push(card);
        return accVisibleSprintCardLists;
    }, []));
const $ca8b20fab5d75757$export$44ac769c42548b1 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$5895481c46e9779a,
    $ca8b20fab5d75757$export$a23657169ef5c959
], (all, visible)=>all.length !== visible.length);
const $ca8b20fab5d75757$export$91ea52aeac57cc52 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$a23657169ef5c959
], (ids)=>{
    const getNextCardListId = (cardListId)=>{
        const index = ids.indexOf(cardListId);
        if (index === -1 || index === ids.length - 1) return null;
        return ids[index + 1];
    };
    return getNextCardListId;
});
const $ca8b20fab5d75757$export$9fc808638e14d4f0 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$3593c0292d4c2e0b,
    $ca8b20fab5d75757$export$a23657169ef5c959
], (cardIdsByCardListId, cardListIds)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    cardListIds.reduce((cardIds, cardListId)=>{
        cardIds.push(...cardIdsByCardListId[cardListId]);
        return cardIds;
    }, []));
const $ca8b20fab5d75757$export$e84ce0fc304b2d5d = (state)=>state.ui.cardList.disabled;
const $ca8b20fab5d75757$export$b40f586b1b1b5b3d = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$e84ce0fc304b2d5d
], (disabled)=>{
    const getIsCardListDisabled = (cardListId)=>Boolean(disabled[cardListId]);
    return getIsCardListDisabled;
});
const $ca8b20fab5d75757$var$getMaxColumnLimitFromCardList = (cardList)=>cardList.maxColumnLimit;
const $ca8b20fab5d75757$var$getMinColumnLimitFromCardList = (cardList)=>cardList.minColumnLimit;
// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
const $ca8b20fab5d75757$var$makeGetColumnLimit = (columnLimitSelector)=>(0, $df4Sl.createSelector)([
        $ca8b20fab5d75757$export$75be3facf1d769f7,
        (0, $hkGxG.getIsCompanyManaged),
        (0, $hkGxG.isKanbanBacklogStrategy)
    ], (cardLists, isCompanyManaged, isKanban)=>{
        // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
        const getColumnLimit = (cardListId)=>isCompanyManaged && isKanban && cardLists[cardListId] && columnLimitSelector(cardLists[cardListId]) ? columnLimitSelector(cardLists[cardListId]) : undefined;
        return getColumnLimit;
    });
const $ca8b20fab5d75757$export$86fa3555538a1895 = $ca8b20fab5d75757$var$makeGetColumnLimit($ca8b20fab5d75757$var$getMaxColumnLimitFromCardList);
const $ca8b20fab5d75757$export$daddaca8cdd663b3 = $ca8b20fab5d75757$var$makeGetColumnLimit($ca8b20fab5d75757$var$getMinColumnLimitFromCardList);
const $ca8b20fab5d75757$export$a3e606d31ce14076 = (0, $df4Sl.createSelector)([
    (0, $kdGmo.getFilters),
    $ca8b20fab5d75757$export$793179e0c0778f7d,
    $ca8b20fab5d75757$export$2777f818bf992a42,
    (0, $k734R.issueParentIdsSelector),
    $ca8b20fab5d75757$export$d4dec7daa49a8c5,
    $ca8b20fab5d75757$export$f9311774fcd7a245,
    (0, $kdGmo.getCMPFilters),
    (0, $hkGxG.getIsCompanyManaged)
], (filters, validAssignees, validLabels, validIssueParentIds, validIssueTypeIds, validVersions, validCustomFilters, isCompanyManaged)=>{
    const filterTypeWhitelist = [
        (0, $6b2c0bb2f15ce467$export$37aee82a3cb1e8f7),
        (0, $6b2c0bb2f15ce467$export$f8f7545d2bb78afb),
        (0, $6b2c0bb2f15ce467$export$d597759d33be802e),
        (0, $6b2c0bb2f15ce467$export$2a4f270075a033de),
        (0, $6b2c0bb2f15ce467$export$ebb48b08205007c5),
        (0, $6b2c0bb2f15ce467$export$a4ad2735b021c132),
        'CUSTOM_FILTER'
    ];
    const validIssueParentIdsWithUnassignedOption = [
        String((0, $9eH8H.UNASSIGNED_EPIC_ID)),
        ...validIssueParentIds
    ];
    const validAssigneesWithUnassignedOption = [
        (0, $9eH8H.UNASSIGNED_USER),
        ...validAssignees
    ];
    const validVersionsWithUnassignedOption = [
        (0, $44677eb502cfd308$export$ac95b4b2317d4b33),
        ...validVersions
    ];
    const validFilters = {};
    if (filters[0, $6b2c0bb2f15ce467$export$f8f7545d2bb78afb]) {
        const allValidAssignees = isCompanyManaged ? validAssigneesWithUnassignedOption : validAssignees;
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($kG4jb)))(allValidAssignees.map((person)=>person.id), filters[0, $6b2c0bb2f15ce467$export$f8f7545d2bb78afb] ?? []);
        if (inter.length > 0) validFilters[0, $6b2c0bb2f15ce467$export$f8f7545d2bb78afb] = inter;
    }
    if (filters[0, $6b2c0bb2f15ce467$export$37aee82a3cb1e8f7]) {
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($kG4jb)))(validLabels, filters[0, $6b2c0bb2f15ce467$export$37aee82a3cb1e8f7]);
        if (inter.length > 0) validFilters[0, $6b2c0bb2f15ce467$export$37aee82a3cb1e8f7] = inter;
    }
    if (filters[0, $6b2c0bb2f15ce467$export$2a4f270075a033de]) {
        // Ignore the epic/issue parent filter validation in CMP
        if (isCompanyManaged) validFilters[0, $6b2c0bb2f15ce467$export$2a4f270075a033de] = filters[0, $6b2c0bb2f15ce467$export$2a4f270075a033de];
        else {
            const inter = (0, (/*@__PURE__*/$parcel$interopDefault($kG4jb)))(validIssueParentIdsWithUnassignedOption, filters[0, $6b2c0bb2f15ce467$export$2a4f270075a033de] ?? []);
            if (inter.length > 0) validFilters[0, $6b2c0bb2f15ce467$export$2a4f270075a033de] = inter;
        }
    }
    if (filters[0, $6b2c0bb2f15ce467$export$ebb48b08205007c5]) {
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($kG4jb)))(validIssueTypeIds, filters[0, $6b2c0bb2f15ce467$export$ebb48b08205007c5] ?? []);
        if (inter.length > 0) validFilters[0, $6b2c0bb2f15ce467$export$ebb48b08205007c5] = inter;
    }
    if (filters[0, $6b2c0bb2f15ce467$export$a4ad2735b021c132]) {
        const allValidVersions = isCompanyManaged ? validVersionsWithUnassignedOption : validVersions;
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($kG4jb)))(allValidVersions, filters[0, $6b2c0bb2f15ce467$export$a4ad2735b021c132] ?? []);
        if (inter.length > 0) validFilters[0, $6b2c0bb2f15ce467$export$a4ad2735b021c132] = inter;
    }
    if (isCompanyManaged && filters[0, $6b2c0bb2f15ce467$export$68d693c35a8d8866]) {
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($kG4jb)))(filters[0, $6b2c0bb2f15ce467$export$68d693c35a8d8866], validCustomFilters.map(({ id: id })=>id));
        if (inter.length > 0) validFilters[0, $6b2c0bb2f15ce467$export$68d693c35a8d8866] = inter;
    }
    Object.keys(filters).filter((filterType)=>!filterTypeWhitelist.includes(filterType)).forEach((notAllowedFilter)=>{
        throw new Error(`Please whitelist filter '${notAllowedFilter}' in filter selectors`);
    });
    return validFilters;
});
const $ca8b20fab5d75757$export$333b83a56fe77194 = (0, $df4Sl.createSelector)([
    (0, $kdGmo.getFilters),
    $ca8b20fab5d75757$export$793179e0c0778f7d,
    $ca8b20fab5d75757$export$2777f818bf992a42,
    (0, $k734R.issueParentIdsSelector),
    $ca8b20fab5d75757$export$d4dec7daa49a8c5,
    $ca8b20fab5d75757$export$f9311774fcd7a245,
    (0, $kdGmo.getCMPFilters),
    (0, $hkGxG.getIsCompanyManaged)
], (filters, validAssignees, validLabels, validIssueParentIds, validIssueTypeIds, validVersions, validCustomFilters, isCompanyManaged)=>{
    const filterTypeWhitelist = [
        (0, $6b2c0bb2f15ce467$export$37aee82a3cb1e8f7),
        (0, $6b2c0bb2f15ce467$export$f8f7545d2bb78afb),
        (0, $6b2c0bb2f15ce467$export$d597759d33be802e),
        (0, $6b2c0bb2f15ce467$export$2a4f270075a033de),
        (0, $6b2c0bb2f15ce467$export$ebb48b08205007c5),
        (0, $6b2c0bb2f15ce467$export$a4ad2735b021c132),
        (0, $6b2c0bb2f15ce467$export$68d693c35a8d8866)
    ];
    const validIssueParentIdsWithUnassignedOption = [
        String((0, $9eH8H.UNASSIGNED_EPIC_ID)),
        ...validIssueParentIds
    ];
    const validAssigneesWithUnassignedOption = [
        (0, $9eH8H.UNASSIGNED_USER),
        ...validAssignees
    ];
    const validVersionsWithUnassignedOption = [
        (0, $44677eb502cfd308$export$ac95b4b2317d4b33),
        ...validVersions
    ];
    const invalidFilters = {};
    if (filters[0, $6b2c0bb2f15ce467$export$f8f7545d2bb78afb]) {
        const allValidAssignees = validAssigneesWithUnassignedOption;
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(filters[0, $6b2c0bb2f15ce467$export$f8f7545d2bb78afb], allValidAssignees.map((person)=>person.id));
        if (diff.length > 0) invalidFilters[0, $6b2c0bb2f15ce467$export$f8f7545d2bb78afb] = diff;
    }
    if (filters[0, $6b2c0bb2f15ce467$export$37aee82a3cb1e8f7]) {
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(filters[0, $6b2c0bb2f15ce467$export$37aee82a3cb1e8f7], validLabels);
        if (diff.length > 0) invalidFilters[0, $6b2c0bb2f15ce467$export$37aee82a3cb1e8f7] = diff;
    }
    // Ignore the epic/issue parent filter validation in CMP
    if (filters[0, $6b2c0bb2f15ce467$export$2a4f270075a033de] && !isCompanyManaged) {
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(filters[0, $6b2c0bb2f15ce467$export$2a4f270075a033de], validIssueParentIdsWithUnassignedOption);
        if (diff.length > 0) invalidFilters[0, $6b2c0bb2f15ce467$export$2a4f270075a033de] = diff;
    }
    if (filters[0, $6b2c0bb2f15ce467$export$ebb48b08205007c5]) {
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(filters[0, $6b2c0bb2f15ce467$export$ebb48b08205007c5], validIssueTypeIds);
        if (diff.length > 0) invalidFilters[0, $6b2c0bb2f15ce467$export$ebb48b08205007c5] = diff;
    }
    if (filters[0, $6b2c0bb2f15ce467$export$a4ad2735b021c132]) {
        const allValidVersions = isCompanyManaged ? validVersionsWithUnassignedOption : validVersions;
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(filters[0, $6b2c0bb2f15ce467$export$a4ad2735b021c132], allValidVersions);
        if (diff.length > 0) invalidFilters[0, $6b2c0bb2f15ce467$export$a4ad2735b021c132] = diff;
    }
    if (isCompanyManaged && filters[0, $6b2c0bb2f15ce467$export$68d693c35a8d8866]) {
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(filters[0, $6b2c0bb2f15ce467$export$68d693c35a8d8866], validCustomFilters.map(({ id: id })=>id));
        if (diff.length > 0) invalidFilters[0, $6b2c0bb2f15ce467$export$68d693c35a8d8866] = diff;
    }
    Object.keys(filters)// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .filter((filterType)=>!filterTypeWhitelist.includes(filterType)).forEach((notAllowedFilter)=>{
        throw new Error(`Please whitelist filter '${notAllowedFilter}' in filter selectors`);
    });
    return invalidFilters;
});
const $ca8b20fab5d75757$export$e5ce012c8ff94f67 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$333b83a56fe77194
], (invalidFilterValues)=>Object.keys(invalidFilterValues).length > 0);
const $ca8b20fab5d75757$export$116ea4e15b17d748 = (0, $df4Sl.createSelector)($ca8b20fab5d75757$export$bc61c71d8347e4d9, $ca8b20fab5d75757$export$ad9f3c6d3dd8c300, (cards, cardIds)=>cardIds.filter((cardId)=>cards[String(cardId)]).map((cardId)=>{
        const { id: id, key: key, parentId: parentId, projectId: projectId, fixVersions: fixVersions } = cards[String(cardId)];
        return {
            id: id,
            key: key,
            parentId: parentId,
            projectId: projectId,
            fixVersions: fixVersions
        };
    }));
const $ca8b20fab5d75757$export$97279e04a1cfee44 = (0, $df4Sl.createSelector)($ca8b20fab5d75757$export$bc61c71d8347e4d9, $ca8b20fab5d75757$export$ad9f3c6d3dd8c300, (cards, cardIds)=>cardIds.filter((cardId)=>cards[String(cardId)]).map((cardId)=>{
        const { id: id, key: key, parentId: parentId, projectId: projectId, typeHierarchyLevel: typeHierarchyLevel } = cards[String(cardId)];
        return {
            id: id,
            key: key,
            parentId: parentId,
            projectId: projectId,
            typeHierarchyLevel: typeHierarchyLevel
        };
    }));
const $ca8b20fab5d75757$export$cb1654a9ed6d9099 = (0, $df4Sl.createSelector)($ca8b20fab5d75757$export$bc61c71d8347e4d9, (cards)=>{
    const getPartialCardsFromCardIds = (cardIds)=>cardIds.filter((cardId)=>cards[String(cardId)]).map((cardId)=>{
            const { id: id, key: key, parentId: parentId, projectId: projectId } = cards[String(cardId)];
            return {
                id: id,
                key: key,
                parentId: parentId,
                projectId: projectId
            };
        });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))(getPartialCardsFromCardIds);
});
const $ca8b20fab5d75757$export$9656edc7cd965e96 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$bc61c71d8347e4d9,
    (0, $6ncr6.getCardTypesForFilter)
], (cards, cardTypes)=>{
    const getCardsForFlagWithCommentModalFromCardIds = (cardIds)=>cardIds.filter((cardId)=>cards[String(cardId)]).map((cardId)=>{
            const { id: id, key: key, summary: summary, typeId: typeId } = cards[String(cardId)];
            const type = cardTypes.find((it)=>it.id === String(typeId)) ?? {
                id: String(typeId),
                name: '',
                iconUrl: ''
            };
            return {
                id: id,
                key: key,
                summary: summary,
                type: type
            };
        });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))(getCardsForFlagWithCommentModalFromCardIds);
});
const $ca8b20fab5d75757$export$a9b1eabca1c583fe = (0, $df4Sl.createSelector)($ca8b20fab5d75757$export$c6ca016832785256, (cards)=>{
    const getIsAssignedToIssueParent = (selectedIds)=>cards.some((card)=>selectedIds.includes(card.id) && card.parentId);
    return getIsAssignedToIssueParent;
});
const $ca8b20fab5d75757$export$1b6edd941a4eaddd = (0, $df4Sl.createSelector)($ca8b20fab5d75757$export$c6ca016832785256, (cards)=>cards.reduce((num, card)=>num + card.numTotalChildren, 0));
const $ca8b20fab5d75757$export$18ec94fe8e415ca5 = (0, $df4Sl.createSelector)($ca8b20fab5d75757$export$c6ca016832785256, (cards)=>cards.reduce((num, card)=>num + card.numCompleteChildren, 0));
const $ca8b20fab5d75757$export$ebb887ede9b3994e = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$bc61c71d8347e4d9,
    (0, $k734R.getIssueParents)
], (cards, parents)=>(0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((cardId)=>{
        if (cards[cardId]) return cards[cardId].key;
        if (parents[cardId]) return parents[cardId].key;
        return null;
    }));
const $ca8b20fab5d75757$export$8d7d30d4816f6177 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$bc61c71d8347e4d9,
    (0, $k734R.getIssueParents)
], (cards, parents)=>(0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((key)=>{
        const cardId = Object.keys(cards).find((id)=>cards[id].key === key);
        if (cardId) return Number(cardId);
        const parentId = Object.keys(parents).find((id)=>parents[id].key === key);
        if (parentId) return Number(parentId);
        return null;
    }));
const $ca8b20fab5d75757$export$7170cae353180463 = (state)=>state.ui.cards.richCard.cardIdWithAboveIccOpen ?? null;
const $ca8b20fab5d75757$export$8f8d79952e8c1b8f = (state, { cardId: cardId })=>cardId === $ca8b20fab5d75757$export$7170cae353180463(state);
const $ca8b20fab5d75757$export$a874620d473113d0 = (state)=>state.ui.cards.richCard.mainActiveCard;
const $ca8b20fab5d75757$export$ee56c425125d2ef6 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$841def0f013aa3d3,
    (0, $k734R.issueParentIdsSelector)
], (cardIds, parentIds)=>{
    const formattedParentIds = parentIds.map((id)=>Number(id));
    return [
        ...cardIds,
        ...formattedParentIds
    ];
});
const $ca8b20fab5d75757$export$22d153c4cb386f10 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$75be3facf1d769f7,
    $ca8b20fab5d75757$export$5895481c46e9779a,
    $ca8b20fab5d75757$export$3593c0292d4c2e0b,
    $ca8b20fab5d75757$export$ab100b26d47e733e
], (cardLists, cardListIds, cardIdsByCardListId, getCardListAnalyticsTypeById)=>{
    const getListCount = (listId)=>listId && cardIdsByCardListId[listId] && cardIdsByCardListId[listId].length || 0;
    const boardIssueNo = getListCount((0, $7TyGu.BOARD));
    const backlogIssueNo = getListCount((0, $7TyGu.BACKLOG));
    const sprintStats = cardListIds.map((cardListId)=>({
            count: getListCount(cardListId),
            type: getCardListAnalyticsTypeById(cardListId)
        })).filter(({ type: type })=>type === (0, $7TyGu.ACTIVE_SPRINT) || type === (0, $7TyGu.INACTIVE_SPRINT));
    const activeSprintIssueNo = sprintStats.find(({ type: type })=>type === (0, $7TyGu.ACTIVE_SPRINT))?.count ?? 0;
    const sprintsCount = sprintStats.length;
    const sprintsCardCounts = sprintStats.map(({ count: count })=>count);
    const sprintsMaxIssueNo = (0, (/*@__PURE__*/$parcel$interopDefault($cD8SO)))(sprintsCardCounts);
    const sprintsIssueNo = (0, (/*@__PURE__*/$parcel$interopDefault($4YjDD)))(sprintsCardCounts);
    const sprintsAverageIssueNo = sprintsIssueNo / sprintsCount;
    return {
        boardIssueNo: boardIssueNo,
        activeSprintIssueNo: activeSprintIssueNo,
        backlogIssueNo: backlogIssueNo,
        sprintsCount: sprintsCount,
        sprintsMaxIssueNo: // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'number'.
        sprintsMaxIssueNo,
        sprintsAverageIssueNo: sprintsAverageIssueNo,
        sprintsIssueNo: sprintsIssueNo
    };
});
const $ca8b20fab5d75757$export$6450c8aec6d3b414 = (0, $df4Sl.createSelector)([
    (state, props)=>props.cardId,
    (state)=>$ca8b20fab5d75757$export$a874620d473113d0(state),
    (state)=>$ca8b20fab5d75757$export$3593c0292d4c2e0b(state),
    (state)=>$ca8b20fab5d75757$export$c24a16d8eafb7cff(state)
], (targetCardId, activeCardId, orderedCardIdsByCardListId, getVisibleCardsForCardList)=>{
    if (!activeCardId) return false;
    if (targetCardId === activeCardId) return true;
    const activeCardList = Object.entries(orderedCardIdsByCardListId).find(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([, cardIds])=>Array.isArray(cardIds) && cardIds.includes(activeCardId));
    if (!activeCardList) return false;
    const [activeCardListId] = activeCardList;
    const activeCardListCardIds = getVisibleCardsForCardList(activeCardListId);
    if (!Array.isArray(activeCardListCardIds)) return false;
    const activeCardIndex = activeCardListCardIds.indexOf(activeCardId);
    const targetCardIndex = activeCardListCardIds.indexOf(targetCardId);
    return activeCardIndex !== -1 && targetCardIndex !== -1 && targetCardIndex === activeCardIndex + 1;
});
const $ca8b20fab5d75757$export$454eae1b4bd66f70 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$962651073dd96b20
], (hasExtraFields)=>({ isInlineCardCreateOpen: isInlineCardCreateOpen, numberOfCardsInCardEntry: numberOfCardsInCardEntry, isCompact: isCompact, hideExtraFields: hideExtraFields = false })=>{
        const cardRowHeight = isCompact ? (0, $9eH8H.COMPACT_CARD_ROW_HEIGHT) : (0, $9eH8H.CARD_ROW_HEIGHT);
        const shouldHideExtraFields = (0, $8wXFi.isViewSettingAsPanelExpEnabledWithNoExposure)() ? hideExtraFields : false;
        const rowHeight = hasExtraFields && !shouldHideExtraFields ? cardRowHeight + (0, $9eH8H.EXTRA_CARD_ROW_HEIGHT) : cardRowHeight;
        const groupHeight = rowHeight * numberOfCardsInCardEntry;
        const inlineCreateHeight = isInlineCardCreateOpen ? (0, $9eH8H.INLINE_CARD_CREATE_ROW_HEIGHT) : 0;
        return groupHeight + inlineCreateHeight;
    });
const $ca8b20fab5d75757$export$697c63a5f8659c9 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$962651073dd96b20
], (hasExtraFields)=>(isCompact)=>{
        const cardRowHeight = isCompact ? (0, $9eH8H.COMPACT_CARD_ROW_HEIGHT) : (0, $9eH8H.CARD_ROW_HEIGHT);
        return hasExtraFields ? cardRowHeight + (0, $9eH8H.EXTRA_CARD_ROW_HEIGHT) : cardRowHeight;
    });
const $ca8b20fab5d75757$export$88889176877886a9 = (state)=>state.ui.cardList.dragState;
const $ca8b20fab5d75757$export$ac2362f84ffb1564 = (state, cardListId)=>Boolean($ca8b20fab5d75757$export$88889176877886a9(state)[cardListId]);
const $ca8b20fab5d75757$export$59261b5a26c04c00 = (state)=>state.ui.cardList.isDragging;
const $ca8b20fab5d75757$export$a62ade440fb97a7a = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$3593c0292d4c2e0b
], (orderedCardListIds)=>(0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((cardId)=>Object.keys(orderedCardListIds).find((cardListId)=>orderedCardListIds[cardListId].includes(cardId))));
const $ca8b20fab5d75757$export$f787c700d21c234a = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$f4b996b8eaed63ba
], (orderedCardEntriesByCardListId)=>{
    const getCardGroupId = (cardListId, cardId)=>{
        if (cardListId === undefined) return undefined;
        const orderedCardEntries = orderedCardEntriesByCardListId(cardListId);
        const group = orderedCardEntries.find((entry)=>entry.type === (0, $7TyGu.GROUP_TYPE) && entry.parentId !== cardId && entry.cardIds.includes(cardId));
        return group !== null && group?.type === (0, $7TyGu.GROUP_TYPE) ? `${group.parentId}-${cardListId}` : undefined;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))(getCardGroupId);
});
const $ca8b20fab5d75757$export$2b8ccf236ef3c2ad = (state, cardId)=>{
    const versions = (0, $ai2KE.getEntitiesVersions)(state);
    const cards = $ca8b20fab5d75757$export$bc61c71d8347e4d9(state);
    const card = $ca8b20fab5d75757$var$getCardById(cards, cardId);
    return card?.fixVersions?.map((versionId)=>versions?.[versionId]).filter(Boolean) ?? [];
};
const $ca8b20fab5d75757$export$10c1cb90425eb140 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$a23657169ef5c959,
    $ca8b20fab5d75757$export$c24a16d8eafb7cff,
    $ca8b20fab5d75757$export$48519a9ef4b7246c
], (visibleCardListIds, getOrderedVisibleCardIdsForCardList, getIsCardListCollapsed)=>visibleCardListIds.find((listId)=>getOrderedVisibleCardIdsForCardList(listId).length > 0 && !getIsCardListCollapsed(listId)));
const $ca8b20fab5d75757$export$91d6529e043b6231 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$bc61c71d8347e4d9
], (cards)=>(0, (/*@__PURE__*/$parcel$interopDefault($lUFEu)))(cards, (card)=>!!card?.isFlagged));
const $ca8b20fab5d75757$export$df669897ce3195c6 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$bc61c71d8347e4d9
], (cards)=>(0, (/*@__PURE__*/$parcel$interopDefault($lUFEu)))(cards, (card)=>!!card?.priority));
const $ca8b20fab5d75757$export$41cf0539676d3407 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$bc61c71d8347e4d9
], (cards)=>(0, (/*@__PURE__*/$parcel$interopDefault($lUFEu)))(cards, (card)=>!!card?.dueDate));
const $ca8b20fab5d75757$export$242c58db4e305622 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$bc61c71d8347e4d9
], (cards)=>(0, (/*@__PURE__*/$parcel$interopDefault($lUFEu)))(cards, (card)=>!!card?.estimate?.storyPoints));
const $ca8b20fab5d75757$export$261deb4fe884b0a1 = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$bc61c71d8347e4d9
], (cards)=>(0, (/*@__PURE__*/$parcel$interopDefault($lUFEu)))(cards, (card)=>!!card?.estimate?.originalEstimate?.value));
const $ca8b20fab5d75757$export$5bab56d9e503125d = (0, $df4Sl.createSelector)([
    $ca8b20fab5d75757$export$5895481c46e9779a,
    $ca8b20fab5d75757$export$c24a16d8eafb7cff
], (orderedCardListIds, getOrderedVisibleCardIdsForCardList)=>(0, (/*@__PURE__*/$parcel$interopDefault($bCHHi)))(orderedCardListIds, (listId)=>getOrderedVisibleCardIdsForCardList(listId).length > 0));
const $ca8b20fab5d75757$export$eb5d19e26822928b = (0, $df4Sl.createSelector)([
    (0, $hkGxG.isCmpKanbanProject),
    $ca8b20fab5d75757$export$ad9f3c6d3dd8c300,
    $ca8b20fab5d75757$export$9fc808638e14d4f0,
    $ca8b20fab5d75757$export$8f9f740048610b66
], (isCmpKanbanBacklog, selectedCardIds, orderedCardIds, getParentIdByChildId)=>(0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((draggingCardId)=>{
        const relevantCards = new Set(selectedCardIds.includes(draggingCardId) ? selectedCardIds : [
            draggingCardId
        ]);
        return orderedCardIds.filter((cardId)=>{
            if (isCmpKanbanBacklog) return relevantCards.has(cardId);
            const parentId = getParentIdByChildId(cardId);
            return relevantCards.has(cardId) && (!parentId || !relevantCards.has(parentId));
        });
    }));

});
parcelRegister("gHHen", function(module, exports) {

var $3pSMu = parcelRequire("3pSMu");

var $f2sQe = parcelRequire("f2sQe");
/** Used for built-in method references. */ var $c292323d8f404a9d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c292323d8f404a9d$var$hasOwnProperty = $c292323d8f404a9d$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the number of times the key was returned by `iteratee`. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.countBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': 1, '6': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.countBy(['one', 'two', 'three'], 'length');
 * // => { '3': 2, '5': 1 }
 */ var $c292323d8f404a9d$var$countBy = $f2sQe(function(result, value, key) {
    if ($c292323d8f404a9d$var$hasOwnProperty.call(result, key)) ++result[key];
    else $3pSMu(result, key, 1);
});
module.exports = $c292323d8f404a9d$var$countBy;

});

parcelRegister("bCHHi", function(module, exports) {

var $e5OGm = parcelRequire("e5OGm");

var $gJXdx = parcelRequire("gJXdx");
/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */ var $876523ae23ec930f$var$findLast = $e5OGm($gJXdx);
module.exports = $876523ae23ec930f$var$findLast;

});
parcelRegister("e5OGm", function(module, exports) {

var $7qARj = parcelRequire("7qARj");

var $jxg5X = parcelRequire("jxg5X");

var $8nrDO = parcelRequire("8nrDO");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $a428d8bbecbff7a6$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$jxg5X(collection)) {
            var iteratee = $7qARj(predicate, 3);
            collection = $8nrDO(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $a428d8bbecbff7a6$var$createFind;

});

parcelRegister("gJXdx", function(module, exports) {

var $9mB9u = parcelRequire("9mB9u");

var $7qARj = parcelRequire("7qARj");

var $hNahz = parcelRequire("hNahz");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c2fec8a2b4cc30dc$var$nativeMax = Math.max, $c2fec8a2b4cc30dc$var$nativeMin = Math.min;
/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */ function $c2fec8a2b4cc30dc$var$findLastIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = length - 1;
    if (fromIndex !== undefined) {
        index = $hNahz(fromIndex);
        index = fromIndex < 0 ? $c2fec8a2b4cc30dc$var$nativeMax(length + index, 0) : $c2fec8a2b4cc30dc$var$nativeMin(index, length - 1);
    }
    return $9mB9u(array, $7qARj(predicate, 3), index, true);
}
module.exports = $c2fec8a2b4cc30dc$var$findLastIndex;

});


parcelRegister("kG4jb", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $kIBQX = parcelRequire("kIBQX");

var $9eFtX = parcelRequire("9eFtX");

var $arA63 = parcelRequire("arA63");
/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */ var $f0db1270e02fec98$var$intersection = $9eFtX(function(arrays) {
    var mapped = $kJvGp(arrays, $arA63);
    return mapped.length && mapped[0] === arrays[0] ? $kIBQX(mapped) : [];
});
module.exports = $f0db1270e02fec98$var$intersection;

});
parcelRegister("kIBQX", function(module, exports) {

var $lYFvJ = parcelRequire("lYFvJ");

var $lqZWH = parcelRequire("lqZWH");

var $6v6uu = parcelRequire("6v6uu");

var $kJvGp = parcelRequire("kJvGp");

var $74vSq = parcelRequire("74vSq");

var $8AO5Q = parcelRequire("8AO5Q");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $f155478e4676feef$var$nativeMin = Math.min;
/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */ function $f155478e4676feef$var$baseIntersection(arrays, iteratee, comparator) {
    var includes = comparator ? $6v6uu : $lqZWH, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
    while(othIndex--){
        var array = arrays[othIndex];
        if (othIndex && iteratee) array = $kJvGp(array, $74vSq(iteratee));
        maxLength = $f155478e4676feef$var$nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new $lYFvJ(othIndex && array) : undefined;
    }
    array = arrays[0];
    var index = -1, seen = caches[0];
    outer: while(++index < length && result.length < maxLength){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (!(seen ? $8AO5Q(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;
            while(--othIndex){
                var cache = caches[othIndex];
                if (!(cache ? $8AO5Q(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
            }
            if (seen) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $f155478e4676feef$var$baseIntersection;

});

parcelRegister("arA63", function(module, exports) {

var $cRpul = parcelRequire("cRpul");
/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */ function $79a86d09190de0cd$var$castArrayLikeObject(value) {
    return $cRpul(value) ? value : [];
}
module.exports = $79a86d09190de0cd$var$castArrayLikeObject;

});


parcelRegister("cD8SO", function(module, exports) {

var $77fbL = parcelRequire("77fbL");

var $bOiiU = parcelRequire("bOiiU");

var $3QMTK = parcelRequire("3QMTK");
/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $932004927d7c326a$var$max(array) {
    return array && array.length ? $77fbL(array, $3QMTK, $bOiiU) : undefined;
}
module.exports = $932004927d7c326a$var$max;

});
parcelRegister("77fbL", function(module, exports) {

var $8aco7 = parcelRequire("8aco7");
/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $52e4f805c3622ecd$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$8aco7(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
module.exports = $52e4f805c3622ecd$var$baseExtremum;

});

parcelRegister("bOiiU", function(module, exports) {
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $899290031a4184bf$var$baseGt(value, other) {
    return value > other;
}
module.exports = $899290031a4184bf$var$baseGt;

});


parcelRegister("lUFEu", function(module, exports) {

var $jqs7R = parcelRequire("jqs7R");

var $7qARj = parcelRequire("7qARj");

var $8v3yf = parcelRequire("8v3yf");

var $1c8hB = parcelRequire("1c8hB");

var $3P7i5 = parcelRequire("3P7i5");
/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $ff3f232f92bb24aa$var$some(collection, predicate, guard) {
    var func = $1c8hB(collection) ? $jqs7R : $8v3yf;
    if (guard && $3P7i5(collection, predicate, guard)) predicate = undefined;
    return func(collection, $7qARj(predicate, 3));
}
module.exports = $ff3f232f92bb24aa$var$some;

});
parcelRegister("8v3yf", function(module, exports) {

var $awetI = parcelRequire("awetI");
/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $6303f9332a27a1b4$var$baseSome(collection, predicate) {
    var result;
    $awetI(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
module.exports = $6303f9332a27a1b4$var$baseSome;

});


parcelRegister("4YjDD", function(module, exports) {

var $835ZM = parcelRequire("835ZM");

var $3QMTK = parcelRequire("3QMTK");
/**
 * Computes the sum of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the sum.
 * @example
 *
 * _.sum([4, 2, 8, 6]);
 * // => 20
 */ function $39ebffc448745d7b$var$sum(array) {
    return array && array.length ? $835ZM(array, $3QMTK) : 0;
}
module.exports = $39ebffc448745d7b$var$sum;

});
parcelRegister("835ZM", function(module, exports) {
/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */ function $5dc3411db180ba2c$var$baseSum(array, iteratee) {
    var result, index = -1, length = array.length;
    while(++index < length){
        var current = iteratee(array[index]);
        if (current !== undefined) result = result === undefined ? current : result + current;
    }
    return result;
}
module.exports = $5dc3411db180ba2c$var$baseSum;

});


parcelRegister("27QuD", function(module, exports) {

var $TLr3n = parcelRequire("TLr3n");

var $2cjNq = parcelRequire("2cjNq");

var $8SGvQ = parcelRequire("8SGvQ");

var $1qE1i = parcelRequire("1qE1i");

var $3Muqa = parcelRequire("3Muqa");

var $aSldm = parcelRequire("aSldm");

var $1uqnh = parcelRequire("1uqnh");
/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */ function $18c4f43cd593e3cf$var$trim(string, chars, guard) {
    string = $1uqnh(string);
    if (string && (guard || chars === undefined)) return $2cjNq(string);
    if (!string || !(chars = $TLr3n(chars))) return string;
    var strSymbols = $aSldm(string), chrSymbols = $aSldm(chars), start = $3Muqa(strSymbols, chrSymbols), end = $1qE1i(strSymbols, chrSymbols) + 1;
    return $8SGvQ(strSymbols, start, end).join('');
}
module.exports = $18c4f43cd593e3cf$var$trim;

});
parcelRegister("1qE1i", function(module, exports) {

var $jkhuN = parcelRequire("jkhuN");
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */ function $10a7434ada2e55c3$var$charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;
    while(index-- && $jkhuN(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
module.exports = $10a7434ada2e55c3$var$charsEndIndex;

});

parcelRegister("3Muqa", function(module, exports) {

var $jkhuN = parcelRequire("jkhuN");
/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */ function $2c0d73c17288fd42$var$charsStartIndex(strSymbols, chrSymbols) {
    var index = -1, length = strSymbols.length;
    while(++index < length && $jkhuN(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
module.exports = $2c0d73c17288fd42$var$charsStartIndex;

});


const $6b2c0bb2f15ce467$export$d597759d33be802e = 'TEXT';
const $6b2c0bb2f15ce467$export$f8f7545d2bb78afb = 'ASSIGNEE';
const $6b2c0bb2f15ce467$export$37aee82a3cb1e8f7 = 'LABEL';
const $6b2c0bb2f15ce467$export$2a4f270075a033de = 'ISSUE_PARENT';
const $6b2c0bb2f15ce467$export$a4ad2735b021c132 = 'VERSION';
const $6b2c0bb2f15ce467$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $6b2c0bb2f15ce467$export$68d693c35a8d8866 = 'CUSTOM_FILTER';
const $6b2c0bb2f15ce467$export$360e7ca29749d455 = 6;

parcelRegister("3sfdp", function(module, exports) {

$parcel$export(module.exports, "isCardEntryGroup", () => $65ac29309ad343b3$export$1f425e415814c059);
$parcel$export(module.exports, "getCardEntryGroupKey", () => $65ac29309ad343b3$export$57a979d82c39e211);
const $65ac29309ad343b3$export$1f425e415814c059 = (cardEntry)=>cardEntry?.type === 'group';
const $65ac29309ad343b3$export$57a979d82c39e211 = ({ parentId: parentId }, cardListId)=>`cardGroup-${cardListId}-${parentId}`;

});

parcelRegister("hkGxG", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $77508a9fd753d787$export$f654b28f82155665);
$parcel$export(module.exports, "getLocale", () => $77508a9fd753d787$export$180605366c04f0cd);
$parcel$export(module.exports, "getCloudId", () => $77508a9fd753d787$export$fdd2c0ba94025c3c);
$parcel$export(module.exports, "getAtlassianAccountId", () => $77508a9fd753d787$export$f5baf4f0aaa47428);
$parcel$export(module.exports, "getIsCompanyManaged", () => $77508a9fd753d787$export$a5407237e82f55bc);
$parcel$export(module.exports, "getIsBoardCrossProject", () => $77508a9fd753d787$export$28687faffae2aeb1);
$parcel$export(module.exports, "getDetailView", () => $77508a9fd753d787$export$afc39f7bfa2dc85);
$parcel$export(module.exports, "getRapidViewId", () => $77508a9fd753d787$export$d5d5a91bd9ef0413);
$parcel$export(module.exports, "getProjectName", () => $77508a9fd753d787$export$2cd058184eb75757);
$parcel$export(module.exports, "getProjects", () => $77508a9fd753d787$export$b00a271f69f3d728);
$parcel$export(module.exports, "getProjectIds", () => $77508a9fd753d787$export$178da5d750a5a582);
$parcel$export(module.exports, "projectIdSelector", () => $77508a9fd753d787$export$4c9d6034f65d22f4);
$parcel$export(module.exports, "getProjectKey", () => $77508a9fd753d787$export$667f2a0f99c75faa);
$parcel$export(module.exports, "getSessionId", () => $77508a9fd753d787$export$b3739caaf2580dd);
$parcel$export(module.exports, "getProjectAris", () => $77508a9fd753d787$export$aa9d76803f3432de);
$parcel$export(module.exports, "getRankCustomFieldId", () => $77508a9fd753d787$export$e98a0db7f9514370);
$parcel$export(module.exports, "getStoryPointFieldId", () => $77508a9fd753d787$export$60b2b9fa88a67144);
$parcel$export(module.exports, "getSprintFieldId", () => $77508a9fd753d787$export$84ee6604e6063636);
$parcel$export(module.exports, "getEpicLinkFieldId", () => $77508a9fd753d787$export$366de0fbf3478a25);
$parcel$export(module.exports, "getEpicIssueType", () => $77508a9fd753d787$export$c58dde3f1e86a4e4);
$parcel$export(module.exports, "getRequestColumnMigration", () => $77508a9fd753d787$export$55ebbbc856ff6213);
$parcel$export(module.exports, "getName", () => $77508a9fd753d787$export$7d9f7e9c1c02b41e);
$parcel$export(module.exports, "getBacklogStrategy", () => $77508a9fd753d787$export$a5a7be8ea88122cc);
$parcel$export(module.exports, "getTimeTrackingOptions", () => $77508a9fd753d787$export$cb06173d4516a1bf);
$parcel$export(module.exports, "getJqlQuery", () => $77508a9fd753d787$export$2af3643b1d2591eb);
$parcel$export(module.exports, "getIsParallelSprintsEnabled", () => $77508a9fd753d787$export$3dc3b60a5f5423b3);
$parcel$export(module.exports, "isKanbanBacklogStrategy", () => $77508a9fd753d787$export$5aa5fa3e0697f97f);
$parcel$export(module.exports, "isScrumBacklogStrategy", () => $77508a9fd753d787$export$3c97bd51d3f010f7);
$parcel$export(module.exports, "getKanbanBoardColumnId", () => $77508a9fd753d787$export$a97644e2ddb37b5e);
$parcel$export(module.exports, "getKanbanBacklogColumnId", () => $77508a9fd753d787$export$b5c1d7f6a57c60b8);
$parcel$export(module.exports, "getKanbanTargetColumnId", () => $77508a9fd753d787$export$e4c5fb56a3200047);
$parcel$export(module.exports, "getHasActiveSprints", () => $77508a9fd753d787$export$b7c097c5d71343b7);
$parcel$export(module.exports, "isCardMoveDisabled", () => $77508a9fd753d787$export$6cea212e63a4af6c);
$parcel$export(module.exports, "isCmpKanbanProject", () => $77508a9fd753d787$export$8b4b78473e0920ac);
$parcel$export(module.exports, "isCheckboxSelectionMode", () => $77508a9fd753d787$export$af914ee70a3d8e9f);
$parcel$export(module.exports, "isCMPScrumBacklog", () => $77508a9fd753d787$export$481012a7a1572742);
$parcel$export(module.exports, "getBoardType", () => $77508a9fd753d787$export$985c8cf86abe2d42);

var $df4Sl = parcelRequire("df4Sl");

var $huI7r = parcelRequire("huI7r");


var $7TyGu = parcelRequire("7TyGu");

var $kF7v3 = parcelRequire("kF7v3");
const $77508a9fd753d787$export$f654b28f82155665 = (state)=>state.config.baseUrl;
const $77508a9fd753d787$export$180605366c04f0cd = (state)=>state.config.locale;
const $77508a9fd753d787$export$14407a25c57e1f92 = (state)=>state.config.xsrfToken;
const $77508a9fd753d787$export$fdd2c0ba94025c3c = (state)=>state.config.cloudId;
const $77508a9fd753d787$export$f5baf4f0aaa47428 = (state)=>state.config.atlassianAccountId;
const $77508a9fd753d787$export$a5407237e82f55bc = (state)=>state.config.isCompanyManaged;
const $77508a9fd753d787$export$28687faffae2aeb1 = (state)=>state.config.isBoardCrossProject;
const $77508a9fd753d787$export$afc39f7bfa2dc85 = (state)=>state.ui.detailView;
const $77508a9fd753d787$export$d5d5a91bd9ef0413 = (state)=>state.config.rapidViewId;
/*
 * @deprecated getProjectId getter should not be used for company-managed. Use projectIdSelector instead.
 * Eventually this will have to be deprecated for team-managed project as well.
 * */ const $77508a9fd753d787$var$getProjectId = (state)=>state.config.projectId;
const $77508a9fd753d787$export$2cd058184eb75757 = (state)=>state.config.projectName;
const $77508a9fd753d787$export$b00a271f69f3d728 = (0, $df4Sl.createSelector)([
    (0, $kF7v3.getEntities)
], (entities)=>entities.project.projects);
const $77508a9fd753d787$export$178da5d750a5a582 = (0, $df4Sl.createSelector)([
    $77508a9fd753d787$export$a5407237e82f55bc,
    $77508a9fd753d787$export$b00a271f69f3d728,
    $77508a9fd753d787$var$getProjectId
], (isCompanyManaged, projects, projectId)=>isCompanyManaged ? projects.map((x)=>x.id) : [
        projectId
    ]);
const $77508a9fd753d787$export$4c9d6034f65d22f4 = (0, $df4Sl.createSelector)([
    $77508a9fd753d787$export$178da5d750a5a582
], (projectIds)=>projectIds[0]);
const $77508a9fd753d787$export$667f2a0f99c75faa = (state)=>state.config.projectKey;
const $77508a9fd753d787$export$b3739caaf2580dd = (state)=>state.config.sessionId;
const $77508a9fd753d787$export$aa9d76803f3432de = (0, $df4Sl.createSelector)([
    $77508a9fd753d787$export$178da5d750a5a582,
    $77508a9fd753d787$export$fdd2c0ba94025c3c
], (projectIds, cloudId)=>projectIds.map((id)=>(0, $huI7r.createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'project',
            resourceId: String(id)
        })));
const $77508a9fd753d787$export$e98a0db7f9514370 = (state)=>state.config.rankCustomFieldId;
const $77508a9fd753d787$export$60b2b9fa88a67144 = (state)=>state.config.storyPointFieldId;
const $77508a9fd753d787$export$84ee6604e6063636 = (state)=>state.config.sprintFieldId;
const $77508a9fd753d787$export$366de0fbf3478a25 = (state)=>state.config.epicLinkField?.id;
const $77508a9fd753d787$export$c58dde3f1e86a4e4 = (state)=>state.config.epicIssueType ?? null;
const $77508a9fd753d787$export$55ebbbc856ff6213 = (state)=>state.config.requestColumnMigration;
const $77508a9fd753d787$export$7d9f7e9c1c02b41e = (state)=>state.config.name;
const $77508a9fd753d787$export$a5a7be8ea88122cc = (state)=>state.config.backlogStrategy;
const $77508a9fd753d787$export$cb06173d4516a1bf = (state)=>state.config.timeTrackingOptions;
const $77508a9fd753d787$export$2af3643b1d2591eb = (state)=>state.config.jqlQuery;
const $77508a9fd753d787$export$3dc3b60a5f5423b3 = (state)=>state.config.parallelSprints;
const $77508a9fd753d787$export$5aa5fa3e0697f97f = (state)=>state.config.backlogStrategy === (0, $7TyGu.KANBAN_BACKLOG_STRATEGY);
const $77508a9fd753d787$export$3c97bd51d3f010f7 = (state)=>$77508a9fd753d787$export$a5a7be8ea88122cc(state) === (0, $7TyGu.SPRINT_BACKLOG_STRATEGY);
const $77508a9fd753d787$export$a97644e2ddb37b5e = (state)=>state?.config?.kanbanBoardColumnId ?? null;
const $77508a9fd753d787$export$b5c1d7f6a57c60b8 = (state)=>state?.config?.kanbanBacklogColumnId ?? null;
const $77508a9fd753d787$export$e4c5fb56a3200047 = (state)=>(cardListType)=>cardListType === (0, $7TyGu.BACKLOG) ? $77508a9fd753d787$export$b5c1d7f6a57c60b8(state) : $77508a9fd753d787$export$a97644e2ddb37b5e(state);
const $77508a9fd753d787$export$b7c097c5d71343b7 = (state)=>{
    // TODO: Update this to use Object.values when TS comes in
    // Damn you Flow.
    const { cardList: cardList } = (0, $kF7v3.getEntities)(state);
    return Object.keys(cardList).some((key)=>cardList[key].sprintData?.state === (0, $7TyGu.SPRINT_STATE_ACTIVE));
};
const $77508a9fd753d787$export$6cea212e63a4af6c = (state)=>state.config.isCompanyManaged === true && state.config.isOrderedByRank === false;
const $77508a9fd753d787$export$8b4b78473e0920ac = (state)=>$77508a9fd753d787$export$a5407237e82f55bc(state) && $77508a9fd753d787$export$5aa5fa3e0697f97f(state);
const $77508a9fd753d787$export$af914ee70a3d8e9f = (state)=>state.ui.cards.isCheckboxSelectionMode;
const $77508a9fd753d787$export$481012a7a1572742 = (state)=>$77508a9fd753d787$export$a5407237e82f55bc(state) && $77508a9fd753d787$export$3c97bd51d3f010f7(state);
const $77508a9fd753d787$export$985c8cf86abe2d42 = (state)=>{
    if ($77508a9fd753d787$export$a5407237e82f55bc(state)) {
        if ($77508a9fd753d787$export$3c97bd51d3f010f7(state)) return 0, $e1409a6fc345c0d8$export$8ee1fad10cc70eb5;
        if ($77508a9fd753d787$export$5aa5fa3e0697f97f(state)) return 0, $e1409a6fc345c0d8$export$9f54a1518145e351;
    }
    return 0, $e1409a6fc345c0d8$export$9a2b21d55c0f061c;
};

});
const $e1409a6fc345c0d8$export$dfd208682d29484c = 'software-backlog';
const $e1409a6fc345c0d8$export$b6e4306772e8a60d = 'ng-backlog';
const $e1409a6fc345c0d8$export$7858b0b4e02abd78 = 'cmp-backlog';
const $e1409a6fc345c0d8$export$840e3848643f7781 = 'backlog';
const $e1409a6fc345c0d8$export$9f54a1518145e351 = 'Kanban';
const $e1409a6fc345c0d8$export$8ee1fad10cc70eb5 = 'Scrum';
const $e1409a6fc345c0d8$export$9a2b21d55c0f061c = 'Agility';

parcelRegister("kF7v3", function(module, exports) {

$parcel$export(module.exports, "getEntities", () => $2ed41ab29149f74d$export$e2e3f9f64b249105);
$parcel$export(module.exports, "getIssueParentsOrderIds", () => $2ed41ab29149f74d$export$6074a6cc45eb2317);

var $iy2aZ = parcelRequire("iy2aZ");
const $2ed41ab29149f74d$export$e2e3f9f64b249105 = (state)=>(0, $iy2aZ.ensureState)(state.entities);
const $2ed41ab29149f74d$export$6074a6cc45eb2317 = (state)=>$2ed41ab29149f74d$export$e2e3f9f64b249105(state).issueParentsOrder;

});


parcelRegister("6ncr6", function(module, exports) {

$parcel$export(module.exports, "getCardTypes", () => $f8ab02977d5861e3$export$b20723ae469526fe);
$parcel$export(module.exports, "getBaseLevelCardTypes", () => $f8ab02977d5861e3$export$25d4089e81ce95ff);
$parcel$export(module.exports, "getCardTypesForFilter", () => $f8ab02977d5861e3$export$9b7f24e4cefec566);
$parcel$export(module.exports, "manageIssueTypesSelector", () => $f8ab02977d5861e3$export$3d59df9affe3fcf3);
$parcel$export(module.exports, "getHasAnyIssueTypeWithRequireFields", () => $f8ab02977d5861e3$export$67aba0fda804be4c);

var $iy2aZ = parcelRequire("iy2aZ");

var $df4Sl = parcelRequire("df4Sl");

var $7ZZxN = parcelRequire("7ZZxN");

var $3l6tm = parcelRequire("3l6tm");

var $cqJw8 = parcelRequire("cqJw8");

var $hkGxG = parcelRequire("hkGxG");
const $f8ab02977d5861e3$export$b20723ae469526fe = (state)=>(0, $iy2aZ.ensureState)(state.entities).cardTypes;
const $f8ab02977d5861e3$export$25d4089e81ce95ff = (0, $df4Sl.createSelector)($f8ab02977d5861e3$export$b20723ae469526fe, (cardTypes)=>cardTypes.length > 0 ? cardTypes?.filter((issueType)=>issueType.typeHierarchyLevel === (0, $3l6tm.BASE_HIERARCHY_TYPE)) : []);
const $f8ab02977d5861e3$export$9b7f24e4cefec566 = (0, $df4Sl.createSelector)($f8ab02977d5861e3$export$25d4089e81ce95ff, (cardTypes)=>cardTypes.map((cardType)=>({
            id: String(cardType.id),
            name: cardType.name,
            iconUrl: cardType.iconUrl
        })));
const $f8ab02977d5861e3$export$d4dec7daa49a8c5 = (0, $df4Sl.createSelector)($f8ab02977d5861e3$export$25d4089e81ce95ff, (cardTypes)=>cardTypes.map((cardType)=>String(cardType.id)));
const $f8ab02977d5861e3$export$3d59df9affe3fcf3 = (0, $df4Sl.createSelector)([
    (0, $hkGxG.getBaseUrl),
    (0, $hkGxG.getProjectKey)
], (baseUrl, projectKey)=>(0, $cqJw8.getNextgenSettingsIssueTypesUrl)((0, $7ZZxN.SOFTWARE_PROJECT), projectKey));
const $f8ab02977d5861e3$export$279c0d17341cb3e1 = (0, $df4Sl.createSelector)([
    $f8ab02977d5861e3$export$25d4089e81ce95ff
], (cardTypes)=>(cardTypeId)=>cardTypes.find(({ id: id })=>id === cardTypeId)?.hasRequiredFields || false);
const $f8ab02977d5861e3$export$67aba0fda804be4c = (0, $df4Sl.createSelector)([
    $f8ab02977d5861e3$export$25d4089e81ce95ff
], (cardTypes)=>cardTypes.some((cardType)=>cardType.hasRequiredFields));

});

parcelRegister("kdGmo", function(module, exports) {

$parcel$export(module.exports, "getFilters", () => $bc312ef74794bf0d$export$1933a9fe712fc1fd);
$parcel$export(module.exports, "getCMPFilters", () => $bc312ef74794bf0d$export$b85cb74b5db260e6);
$parcel$export(module.exports, "getAppliedParentFilters", () => $bc312ef74794bf0d$export$889ee627c9da88af);
$parcel$export(module.exports, "getAppliedAssigneeFilters", () => $bc312ef74794bf0d$export$4724d05a9e1b68d8);
$parcel$export(module.exports, "getAppliedVersionFilters", () => $bc312ef74794bf0d$export$f08351012de61e58);
$parcel$export(module.exports, "getAppliedLabelFilters", () => $bc312ef74794bf0d$export$60ee89f2718fc651);
$parcel$export(module.exports, "getAppliedCustomFilters", () => $bc312ef74794bf0d$export$e4cc6991cb44d849);
$parcel$export(module.exports, "getAppliedCustomFilterQueries", () => $bc312ef74794bf0d$export$5d6b2188da2fc080);
$parcel$export(module.exports, "getLastFilteredIssueTypeId", () => $bc312ef74794bf0d$export$66fc4c808781b0dd);
$parcel$export(module.exports, "filter", () => $bc312ef74794bf0d$export$3dea766d36a8935f);

var $df4Sl = parcelRequire("df4Sl");

var $iTvqy = parcelRequire("iTvqy");

var $jqvCZ = parcelRequire("jqvCZ");

var $3l6tm = parcelRequire("3l6tm");

var $h0Fv2 = parcelRequire("h0Fv2");


var $kF7v3 = parcelRequire("kF7v3");
const $bc312ef74794bf0d$export$1933a9fe712fc1fd = (state)=>state.ui.filters;
const $bc312ef74794bf0d$export$b85cb74b5db260e6 = (state)=>(0, $kF7v3.getEntities)(state).customFilters.filters;
const $bc312ef74794bf0d$export$889ee627c9da88af = (state)=>$bc312ef74794bf0d$export$1933a9fe712fc1fd(state)[0, $6b2c0bb2f15ce467$export$2a4f270075a033de];
const $bc312ef74794bf0d$export$4724d05a9e1b68d8 = (state)=>$bc312ef74794bf0d$export$1933a9fe712fc1fd(state)[0, $6b2c0bb2f15ce467$export$f8f7545d2bb78afb];
const $bc312ef74794bf0d$export$f08351012de61e58 = (state)=>$bc312ef74794bf0d$export$1933a9fe712fc1fd(state)[0, $6b2c0bb2f15ce467$export$a4ad2735b021c132];
const $bc312ef74794bf0d$export$60ee89f2718fc651 = (state)=>$bc312ef74794bf0d$export$1933a9fe712fc1fd(state)[0, $6b2c0bb2f15ce467$export$37aee82a3cb1e8f7];
const $bc312ef74794bf0d$export$e4cc6991cb44d849 = (state)=>$bc312ef74794bf0d$export$1933a9fe712fc1fd(state)[0, $6b2c0bb2f15ce467$export$68d693c35a8d8866];
const $bc312ef74794bf0d$export$5d6b2188da2fc080 = (0, $df4Sl.createSelector)([
    $bc312ef74794bf0d$export$b85cb74b5db260e6,
    $bc312ef74794bf0d$export$e4cc6991cb44d849
], (filters, currentAppliedFilters)=>filters.filter((f)=>currentAppliedFilters?.includes(f.id)).map((f)=>f.query).filter(Boolean));
const $bc312ef74794bf0d$export$7ea0d3589e75ea3e = (state)=>$bc312ef74794bf0d$export$1933a9fe712fc1fd(state)[0, $6b2c0bb2f15ce467$export$ebb48b08205007c5];
const $bc312ef74794bf0d$export$66fc4c808781b0dd = (0, $df4Sl.createSelector)([
    $bc312ef74794bf0d$export$7ea0d3589e75ea3e
], (issueTypes)=>{
    if (issueTypes && issueTypes.length) return Number((0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))(issueTypes));
    return undefined;
});
const $bc312ef74794bf0d$export$79e3f18eafd008ab = (issue)=>Number(issue.id) < 0;
const $bc312ef74794bf0d$export$3dea766d36a8935f = (filterValues, filteredIssueIds, cards)=>{
    const toFilterableIssue = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))(({ id: id, key: key, summary: summary, labels: labels, typeId: typeId, parentId: parentId, assignee: assignee, fixVersions: fixVersions })=>{
        const filterableAssignee = assignee ? {
            id: assignee.id,
            displayName: assignee.displayName
        } : undefined;
        return {
            id: String(id),
            key: key,
            summary: summary,
            labels: labels,
            type: {
                id: String(typeId)
            },
            versionIds: fixVersions,
            parentId: typeof parentId !== 'undefined' && parentId !== null ? String(parentId) : undefined,
            assignee: filterableAssignee
        };
    });
    const issuesContext = cards && cards.length ? {
        list: [],
        hash: {}
    } : undefined;
    if (issuesContext) cards?.filter((card)=>card.typeHierarchyLevel !== (0, $3l6tm.ISSUE_HIERARCHY_LEVEL_EPIC)).forEach((card)=>{
        const filterableIssue = toFilterableIssue(card);
        issuesContext.list.push(filterableIssue);
        issuesContext.hash[card.id] = filterableIssue;
    });
    const filterFunction = (0, $h0Fv2.createFilterFunction)(filterValues, {
        filteredIssueIds: filteredIssueIds,
        issues: issuesContext
    }, (0, $h0Fv2.createDefaultMatcherCreators)(), [
        $bc312ef74794bf0d$export$79e3f18eafd008ab
    ]);
    return (issues)=>issues.filter((issue)=>{
            const filterableIssue = toFilterableIssue(issue);
            return filterFunction(filterableIssue);
        });
};

});
parcelRegister("h0Fv2", function(module, exports) {

$parcel$export(module.exports, "createDefaultMatcherCreators", () => $d1d21cafc14323e5$export$551eb27bf5bd708);
$parcel$export(module.exports, "createFilterFunction", () => $d1d21cafc14323e5$export$5b4da3e2bd753e6);


var $ftKFx = parcelRequire("ftKFx");
var $7TAX0 = parcelRequire("7TAX0");
var $iwYAV = parcelRequire("iwYAV");
var $kaz6O = parcelRequire("kaz6O");
var $cPwAI = parcelRequire("cPwAI");
var $1js3v = parcelRequire("1js3v");
var $ft9WA = parcelRequire("ft9WA");
var $21p3u = parcelRequire("21p3u");
var $bKIUF = parcelRequire("bKIUF");
var $iJnBh = parcelRequire("iJnBh");
var $60yor = parcelRequire("60yor");
var $jHhlI = parcelRequire("jHhlI");
var $4gVwH = parcelRequire("4gVwH");
const $d1d21cafc14323e5$export$551eb27bf5bd708 = ()=>({
        [(0, $44677eb502cfd308$export$d597759d33be802e)]: (0, $jHhlI.textMatcherCreator),
        [(0, $44677eb502cfd308$export$f8f7545d2bb78afb)]: (0, $ftKFx.assigneeMatcherCreator),
        [(0, $44677eb502cfd308$export$37aee82a3cb1e8f7)]: (0, $ft9WA.labelMatcherCreator),
        [(0, $44677eb502cfd308$export$2a4f270075a033de)]: (0, $kaz6O.issueParentMatcherCreator),
        [(0, $44677eb502cfd308$export$401f4b6eda6a369c)]: (0, $cPwAI.issueProjectMatcherCreator),
        [(0, $44677eb502cfd308$export$ebb48b08205007c5)]: (0, $1js3v.issueTypeMatcherCreator),
        [(0, $44677eb502cfd308$export$a4ad2735b021c132)]: (0, $4gVwH.versionMatcherCreator),
        [(0, $44677eb502cfd308$export$68d693c35a8d8866)]: (0, $iwYAV.filteredIssueIdsMatcherCreator),
        [(0, $44677eb502cfd308$export$af1e30ebbae9df3b)]: (0, $7TAX0.componentMatcherCreator),
        [(0, $44677eb502cfd308$export$92ab80c1dc9baf44)]: (0, $21p3u.requestTypeMatcherCreator),
        [(0, $44677eb502cfd308$export$f863b019d19144f4)]: (0, $iJnBh.statusCategoryMatcherCreator),
        [(0, $44677eb502cfd308$export$e50006273435e7d4)]: (0, $60yor.statusMatcherCreator),
        [(0, $44677eb502cfd308$export$1ea95b94fb0c51d9)]: (0, $iwYAV.filteredIssueIdsMatcherCreator),
        [(0, $44677eb502cfd308$export$a316570a0dbfd2b0)]: (0, $bKIUF.sprintMatcherCreator),
        [(0, $44677eb502cfd308$export$871e58afc769b358)]: (0, $iwYAV.filteredIssueIdsMatcherCreator)
    });
const $d1d21cafc14323e5$var$createMatchers = (filter, context, matcherCreators)=>Object.keys(filter).reduce((acc, key)=>{
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Filters'.
        const filterValue = filter[key];
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'MatcherCreators<Issue>'.
        const matcherCreator = matcherCreators[key];
        if (filterValue === undefined || filterValue.length <= 0 || matcherCreator === undefined) return acc;
        acc.push(matcherCreator(filterValue, context));
        return acc;
    }, []);
const $d1d21cafc14323e5$export$5b4da3e2bd753e6 = (filter, context, matcherCreators, overrideMatchers)=>{
    const matchers = $d1d21cafc14323e5$var$createMatchers(filter, context, matcherCreators ?? $d1d21cafc14323e5$export$551eb27bf5bd708());
    return (issue)=>matchers.every((matcher)=>matcher(issue)) || overrideMatchers !== undefined && overrideMatchers.some((matcher)=>matcher(issue));
};

});
parcelRegister("ftKFx", function(module, exports) {

$parcel$export(module.exports, "assigneeMatcherCreator", () => $354afd9c9dee1cb7$export$5c453ff7d8a6957f);

var $6vrw7 = parcelRequire("6vrw7");

const $354afd9c9dee1cb7$export$5c453ff7d8a6957f = (assigneeFilter)=>{
    const assigneeSet = new Set(assigneeFilter);
    return ({ assignee: assignee })=>assignee !== undefined && assigneeSet.has(assignee.id) || assignee === undefined && assigneeSet.has((0, $6vrw7.toAccountId)((0, $44677eb502cfd308$export$12e572fd459c10dc)));
};

});

parcelRegister("7TAX0", function(module, exports) {

$parcel$export(module.exports, "componentMatcherCreator", () => $13808b3decc68df4$export$667cab6ac6c65512);

const $13808b3decc68df4$export$667cab6ac6c65512 = (componentFilter)=>{
    const componentSet = new Set(componentFilter);
    return ({ componentIds: componentIds })=>componentIds !== undefined && (componentIds.some((componentId)=>componentSet.has(componentId)) || componentIds.length === 0 && componentSet.has((0, $44677eb502cfd308$export$4b7c755e61199a36)));
};

});

parcelRegister("iwYAV", function(module, exports) {

$parcel$export(module.exports, "filteredIssueIdsMatcherCreator", () => $003ab2d78b2340e2$export$4493d922cd011b1a);
const $003ab2d78b2340e2$export$4493d922cd011b1a = (value, { filteredIssueIds: filteredIssueIds })=>({ id: id })=>filteredIssueIds !== undefined ? id !== undefined && filteredIssueIds.has(id) : true;

});

parcelRegister("kaz6O", function(module, exports) {

$parcel$export(module.exports, "issueParentMatcherCreator", () => $0b2241078d1b56df$export$4729465fe91e6864);

var $1ybV0 = parcelRequire("1ybV0");

const $0b2241078d1b56df$export$4729465fe91e6864 = (issueParentFilter, { issues: issues })=>{
    const issueParentSet = new Set(issueParentFilter);
    const isAncestorInFilter = (id, checked = [])=>{
        if (id === undefined) return issueParentSet.has((0, $f2d11b1049867935$export$794f07be04aca3fe));
        if (issueParentSet.has(id)) return true;
        if ((0, $1ybV0.ff)('jsw.filter.recursion-fix_jwsm3') && checked.includes(id)) return false;
        if (issues === undefined) return false;
        const issue = issues.hash[id];
        if (issue === undefined) return false;
        const { parentId: parentId } = issue;
        return (0, $1ybV0.ff)('jsw.filter.recursion-fix_jwsm3') ? isAncestorInFilter(parentId, checked.concat(id)) : isAncestorInFilter(parentId);
    };
    return ({ id: id, parentId: parentId })=>{
        if (id === undefined) return false;
        if (issueParentSet.has(id)) return true;
        if ((0, $1ybV0.ff)('jsw.filter.recursion-fix_jwsm3') && id === parentId) return false;
        return (0, $1ybV0.ff)('jsw.filter.recursion-fix_jwsm3') ? isAncestorInFilter(parentId, [
            id
        ]) : isAncestorInFilter(parentId);
    };
};

});
const $f2d11b1049867935$export$794f07be04aca3fe = '0';
const $f2d11b1049867935$export$cb17e3c17bc50301 = 'Epic';
const $f2d11b1049867935$export$7fbc739f2667a35e = 'Subtask';


parcelRegister("cPwAI", function(module, exports) {

$parcel$export(module.exports, "issueProjectMatcherCreator", () => $a372eb626e60d8ee$export$b10ee43342090204);

var $cV7Ha = parcelRequire("cV7Ha");
const $a372eb626e60d8ee$export$b10ee43342090204 = (projectFilter)=>{
    if (!(0, $cV7Ha.isIncrementPlanningBoardM1Enabled)()) return ()=>true;
    const projectSet = new Set(projectFilter);
    return ({ projectId: projectId })=>!!projectId && projectSet.has(projectId);
};

});
parcelRegister("cV7Ha", function(module, exports) {

$parcel$export(module.exports, "isIncrementPlanningBoardM1Enabled", () => $b9d7535b282cdc7b$export$3cf7abcb30f8ee4d);
/**
 * Feature flags convention: go/frontend-feature-flags
 */ 
var $1ybV0 = parcelRequire("1ybV0");
const $b9d7535b282cdc7b$export$40a610084ff0408 = 'com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1';
const $b9d7535b282cdc7b$export$3cf7abcb30f8ee4d = ()=>(0, $1ybV0.ff)($b9d7535b282cdc7b$export$40a610084ff0408); // </qfeyaerts>

});


parcelRegister("1js3v", function(module, exports) {

$parcel$export(module.exports, "issueTypeMatcherCreator", () => $584952870c30b05f$export$48b17418005f8b9b);
const $584952870c30b05f$export$48b17418005f8b9b = (issueTypeFilter)=>{
    const issueTypeSet = new Set(issueTypeFilter);
    return ({ type: type })=>issueTypeSet.has(type.id);
};

});

parcelRegister("ft9WA", function(module, exports) {

$parcel$export(module.exports, "labelMatcherCreator", () => $ab6a1cc6240f5e5d$export$71d90ee236f2e796);

const $ab6a1cc6240f5e5d$export$71d90ee236f2e796 = (labelFilter)=>{
    const labelSet = new Set(labelFilter);
    return ({ labels: labels })=>labels !== undefined && (labels.some((label)=>labelSet.has(label)) || labels.length === 0 && labelSet.has((0, $44677eb502cfd308$export$81ef49afbbead0a1)));
};

});

parcelRegister("21p3u", function(module, exports) {

$parcel$export(module.exports, "requestTypeMatcherCreator", () => $fd9886982e8311a4$export$d04e41d82fbfb8ba);
const $fd9886982e8311a4$export$d04e41d82fbfb8ba = (requestTypeFilter)=>{
    const requestTypeSet = new Set(requestTypeFilter);
    return ({ requestTypeId: requestTypeId })=>!!requestTypeId && requestTypeSet.has(requestTypeId);
};

});

parcelRegister("bKIUF", function(module, exports) {

$parcel$export(module.exports, "sprintMatcherCreator", () => $cd675abcb29605aa$export$4706275ba29d0c7);
const $cd675abcb29605aa$export$4706275ba29d0c7 = (sprintFilter)=>({ sprintId: sprintId })=>sprintFilter.includes(sprintId || '');

});

parcelRegister("iJnBh", function(module, exports) {

$parcel$export(module.exports, "statusCategoryMatcherCreator", () => $4a8647655f62da05$export$bb986e45707c6c33);
const $4a8647655f62da05$export$bb986e45707c6c33 = (statusCategoryFilter)=>{
    const statusCategorySet = new Set(statusCategoryFilter);
    return ({ statusCategoryId: statusCategoryId })=>statusCategoryId !== undefined && statusCategorySet.has(statusCategoryId);
};

});

parcelRegister("60yor", function(module, exports) {

$parcel$export(module.exports, "statusMatcherCreator", () => $d1771c65d5da4b4d$export$c61724a440d8ea1d);
const $d1771c65d5da4b4d$export$c61724a440d8ea1d = (statusFilter)=>{
    const statusSet = new Set(statusFilter);
    return ({ statusId: statusId })=>!!statusId && statusSet.has(statusId);
};

});

parcelRegister("jHhlI", function(module, exports) {

$parcel$export(module.exports, "textMatcherCreator", () => $1398123769c733e8$export$71a22d4a5d2891fc);

var $e1vfz = parcelRequire("e1vfz");

var $jqvCZ = parcelRequire("jqvCZ");
const $1398123769c733e8$export$f3f2882e8b11d731 = (text)=>text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
const $1398123769c733e8$var$doesSummaryContainText = (summary, lowercaseText)=>summary.toLowerCase().includes(lowercaseText) || $1398123769c733e8$export$f3f2882e8b11d731(summary).toLowerCase().includes(lowercaseText);
const $1398123769c733e8$var$doesIssueKeyMatchLoosely = (key, lowercaseText)=>key !== undefined && key?.toLowerCase().includes(lowercaseText);
const $1398123769c733e8$var$createDisplayNameChecker = (text)=>{
    // It transforms a text to a regular expression.
    // eg: text='mi ze', the transformed regexp would be 'mi.*\s+ze'
    // which searches for 'mi' followed by anything then 'ze'.
    const pattern = text.split(/\s+/).map((0, (/*@__PURE__*/$parcel$interopDefault($e1vfz)))).join('.*\\s+');
    const regExp = new RegExp(pattern, 'i');
    return (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((displayName)=>regExp.test(displayName));
};
const $1398123769c733e8$export$71a22d4a5d2891fc = (textFilter)=>{
    const lowercaseText = textFilter.toLowerCase();
    const doesDisplayNameMatchRegExp = $1398123769c733e8$var$createDisplayNameChecker(textFilter);
    return ({ summary: summary, key: key, assignee: assignee })=>summary && $1398123769c733e8$var$doesSummaryContainText(summary, lowercaseText) || $1398123769c733e8$var$doesIssueKeyMatchLoosely(key, lowercaseText) || assignee !== undefined && doesDisplayNameMatchRegExp(assignee.displayName);
};

});

parcelRegister("4gVwH", function(module, exports) {

$parcel$export(module.exports, "versionMatcherCreator", () => $85c08470c7208112$export$fb114a888e0e17b4);

const $85c08470c7208112$export$fb114a888e0e17b4 = (versionFilter)=>{
    const versionSet = new Set(versionFilter);
    return ({ versionIds: versionIds })=>versionIds !== undefined && (versionIds.some((versionId)=>versionSet.has(versionId)) || versionIds.length === 0 && versionSet.has((0, $44677eb502cfd308$export$ac95b4b2317d4b33)));
};

});



parcelRegister("k734R", function(module, exports) {

$parcel$export(module.exports, "getIssueParents", () => $cb500008f1aaf4eb$export$df9259146e40d32c);
$parcel$export(module.exports, "issueParentsSelector", () => $cb500008f1aaf4eb$export$27ed9219e3872aed);
$parcel$export(module.exports, "issueParentsToListItemSelector", () => $cb500008f1aaf4eb$export$ed2bad70f85ffb04);
$parcel$export(module.exports, "issueParentIdsSelector", () => $cb500008f1aaf4eb$export$e69b35537968b7e1);
$parcel$export(module.exports, "partialIssueParentSelector", () => $cb500008f1aaf4eb$export$3e87abb8e670325c);
$parcel$export(module.exports, "issueParentTypeIdsSelector", () => $cb500008f1aaf4eb$export$80f40427dc008040);
$parcel$export(module.exports, "firstParentIssueTypeNameSelector", () => $cb500008f1aaf4eb$export$461364b3b51e10c1);
$parcel$export(module.exports, "filteredParentsSelector", () => $cb500008f1aaf4eb$export$a69ed0ba1bae99d6);
$parcel$export(module.exports, "issueHierarchyLevelSelector", () => $cb500008f1aaf4eb$export$877c3c60e0259f4b);

var $df4Sl = parcelRequire("df4Sl");

var $bnlpg = parcelRequire("bnlpg");

var $illlw = parcelRequire("illlw");

var $8blac = parcelRequire("8blac");

var $jqvCZ = parcelRequire("jqvCZ");

var $MdoH4 = parcelRequire("MdoH4");

var $3l6tm = parcelRequire("3l6tm");

var $7TyGu = parcelRequire("7TyGu");

var $kF7v3 = parcelRequire("kF7v3");

var $kdGmo = parcelRequire("kdGmo");
const $cb500008f1aaf4eb$export$df9259146e40d32c = (state)=>(0, $kF7v3.getEntities)(state).issueParents;
const $cb500008f1aaf4eb$export$fc955fffc3b3200c = (0, $df4Sl.createSelector)([
    $cb500008f1aaf4eb$export$df9259146e40d32c
], (issueParents)=>{
    const issueParentById = (parentId)=>issueParents[String(parentId)] || null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))(issueParentById);
});
const $cb500008f1aaf4eb$export$27ed9219e3872aed = (0, $df4Sl.createSelector)([
    $cb500008f1aaf4eb$export$df9259146e40d32c,
    (0, $kF7v3.getIssueParentsOrderIds)
], (issueParents, issueParentsOrderIds)=>issueParentsOrderIds.reduce((issueParentsArray, issueParentId)=>{
        const issueParent = issueParents[issueParentId];
        issueParent && issueParentsArray.push(issueParent);
        return issueParentsArray;
    }, []));
const $cb500008f1aaf4eb$export$ed2bad70f85ffb04 = (0, $df4Sl.createSelector)($cb500008f1aaf4eb$export$27ed9219e3872aed, (issueParents)=>issueParents.map(({ id: id, summary: summary })=>({
            id: String(id),
            name: summary
        })));
const $cb500008f1aaf4eb$export$e69b35537968b7e1 = (0, $df4Sl.createSelector)($cb500008f1aaf4eb$export$df9259146e40d32c, (issueParents)=>Object.keys(issueParents));
const $cb500008f1aaf4eb$export$3e87abb8e670325c = (0, $df4Sl.createSelector)($cb500008f1aaf4eb$export$27ed9219e3872aed, (issueParents)=>issueParents.map(({ id: id, summary: summary, issueType: issueType, key: key })=>({
            id: id,
            summary: summary,
            key: key,
            issueType: issueType
        })));
const $cb500008f1aaf4eb$export$80f40427dc008040 = (0, $df4Sl.createSelector)($cb500008f1aaf4eb$export$27ed9219e3872aed, (issueParents)=>(0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))(issueParents.map(({ issueType: issueType })=>issueType.id)));
const $cb500008f1aaf4eb$export$461364b3b51e10c1 = (0, $df4Sl.createSelector)($cb500008f1aaf4eb$export$27ed9219e3872aed, (issueParents)=>issueParents ? (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))((0, (/*@__PURE__*/$parcel$interopDefault($bnlpg)))(issueParents), [
        'issueType',
        'name'
    ], (0, $7TyGu.DEFAULT_PARENT_ISSUE_TYPE_NAME)) : (0, $7TyGu.DEFAULT_PARENT_ISSUE_TYPE_NAME));
const $cb500008f1aaf4eb$export$a69ed0ba1bae99d6 = (0, $df4Sl.createSelector)((0, $kdGmo.getAppliedParentFilters), $cb500008f1aaf4eb$export$df9259146e40d32c, (filteredParentIds, issueParents)=>!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(filteredParentIds) ? filteredParentIds?.map((filteredParentId)=>issueParents?.[filteredParentId]) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .filter(Boolean) || [] : []);
const $cb500008f1aaf4eb$export$877c3c60e0259f4b = (0, $df4Sl.createSelector)([], ()=>{
    const getIssueHierarchyLevel = (isEpicPanel = false)=>isEpicPanel ? (0, $3l6tm.ISSUE_HIERARCHY_LEVEL_EPIC) : (0, $3l6tm.ISSUE_HIERARCHY_LEVEL_BASE);
    return getIssueHierarchyLevel;
});

});
parcelRegister("bnlpg", function(module, exports) {

module.exports = (parcelRequire("jtpa0"));

});
parcelRegister("jtpa0", function(module, exports) {
/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */ function $e2d43e13ed703ec3$var$head(array) {
    return array && array.length ? array[0] : undefined;
}
module.exports = $e2d43e13ed703ec3$var$head;

});



parcelRegister("c2v8q", function(module, exports) {

$parcel$export(module.exports, "getCurrentUser", () => $198b6fc06794965c$export$e5432d4c8eb97ea7);
$parcel$export(module.exports, "isCurrentUserLoaded", () => $198b6fc06794965c$export$6b3694fe2dc20c31);

var $iy2aZ = parcelRequire("iy2aZ");
const $198b6fc06794965c$export$e5432d4c8eb97ea7 = (state)=>(0, $iy2aZ.ensureState)(state.entities).currentUser;
const $198b6fc06794965c$export$6b3694fe2dc20c31 = (state)=>$198b6fc06794965c$export$e5432d4c8eb97ea7(state) !== null;
const $198b6fc06794965c$export$5ebc6cb2748e1881 = (state)=>// @ts-expect-error - TS2531 - Object is possibly 'null'.
    (0, $iy2aZ.ensureState)(state.entities).currentUser.id;

});

parcelRegister("ai2KE", function(module, exports) {

$parcel$export(module.exports, "getEntitiesVersions", () => $0edc51cf2dd63423$export$6dd679056b6b958c);
$parcel$export(module.exports, "getVersionsOrder", () => $0edc51cf2dd63423$export$5b7ad9152ad991bf);
$parcel$export(module.exports, "isVersionsFeatureEnabled", () => $0edc51cf2dd63423$export$5f0729b6671904c3);

var $eoER9 = parcelRequire("eoER9");

var $kF7v3 = parcelRequire("kF7v3");
const $0edc51cf2dd63423$var$getConfig = (state)=>state.config;
const $0edc51cf2dd63423$export$6dd679056b6b958c = (state)=>(0, $kF7v3.getEntities)(state).versions;
const $0edc51cf2dd63423$export$5b7ad9152ad991bf = (state)=>(0, $kF7v3.getEntities)(state).version.versions;
const $0edc51cf2dd63423$export$5f0729b6671904c3 = (0, $eoER9.createSelector)([
    $0edc51cf2dd63423$var$getConfig
], (config)=>config.version.isVersionsFeatureEnabled || false);

});
parcelRegister("eoER9", function(module, exports) {

$parcel$export(module.exports, "createWeakMapSelector", () => $83d259675c776220$export$3a90d1d234e724b5);
$parcel$export(module.exports, "createSelector", () => $83d259675c776220$export$595d22ed68ca2841);
// @ts-expect-error - TS2305 - Module '"reselect"' has no exported member 'SelectorCreator'.

var $df4Sl = parcelRequire("df4Sl");

var $3X7pb = parcelRequire("3X7pb");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $83d259675c776220$var$weakMapMemoize = (func)=>{
    const memorizer = (0, $3X7pb.createMemorizer)();
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    return (...args)=>{
        const cached = memorizer.read(args);
        if (cached !== undefined) return (0, $3X7pb.toReturnValue)(cached);
        const result = func.apply(func, args);
        memorizer.store(args, result);
        return result;
    };
};
const $83d259675c776220$export$3a90d1d234e724b5 = (0, $df4Sl.createSelectorCreator)($83d259675c776220$var$weakMapMemoize);
const $83d259675c776220$export$595d22ed68ca2841 = (0, $df4Sl.createSelectorCreator)((0, $df4Sl.defaultMemoize));

});
parcelRegister("3X7pb", function(module, exports) {

$parcel$export(module.exports, "toReturnValue", () => $24f64c7d1be5459a$export$9f3707bed4fc53c8);
$parcel$export(module.exports, "createMemorizer", () => $24f64c7d1be5459a$export$9db09f4ba21f9d2a);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $24f64c7d1be5459a$var$UNDEFINED = {};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $24f64c7d1be5459a$var$NULL = {};
const $24f64c7d1be5459a$export$7abc386bcfed62e1 = (key)=>{
    if (key === undefined) return $24f64c7d1be5459a$var$UNDEFINED;
    if (key === null) return $24f64c7d1be5459a$var$NULL;
    return key;
};
const $24f64c7d1be5459a$export$9f3707bed4fc53c8 = (x)=>{
    if (x === $24f64c7d1be5459a$var$UNDEFINED) return undefined;
    if (x === $24f64c7d1be5459a$var$NULL) return null;
    return x;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $24f64c7d1be5459a$var$getFromWeakMapChain = (args, index, map)=>{
    const element = map.get($24f64c7d1be5459a$export$7abc386bcfed62e1(args[index]));
    if (index < args.length - 1) {
        if (element) return $24f64c7d1be5459a$var$getFromWeakMapChain(args, index + 1, element);
        return undefined;
    }
    return element;
};
const $24f64c7d1be5459a$var$storeToEmptyWeakMapChain = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
args, index, // eslint-disable-next-line @typescript-eslint/no-explicit-any
map, // eslint-disable-next-line @typescript-eslint/no-explicit-any
result)=>{
    if (index < args.length - 1) {
        const subMap = new WeakMap();
        map.set($24f64c7d1be5459a$export$7abc386bcfed62e1(args[index]), subMap);
        $24f64c7d1be5459a$var$storeToEmptyWeakMapChain(args, index + 1, subMap, result);
    } else map.set($24f64c7d1be5459a$export$7abc386bcfed62e1(args[index]), result);
};
const $24f64c7d1be5459a$var$storeToWeakMapChain = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
args, index, // eslint-disable-next-line @typescript-eslint/no-explicit-any
map, // eslint-disable-next-line @typescript-eslint/no-explicit-any
result)=>{
    if (index < args.length - 1) {
        const element = map.get($24f64c7d1be5459a$export$7abc386bcfed62e1(args[index]));
        if (element) $24f64c7d1be5459a$var$storeToWeakMapChain(args, index + 1, element, result);
        else {
            const subMap = new WeakMap();
            map.set($24f64c7d1be5459a$export$7abc386bcfed62e1(args[index]), subMap);
            // we know that from now on, all chain elements need to be new maps,
            // so we move to a slightly more performent recursion
            $24f64c7d1be5459a$var$storeToEmptyWeakMapChain(args, index + 1, subMap, result);
        }
    } else map.set($24f64c7d1be5459a$export$7abc386bcfed62e1(args[index]), result);
};
const $24f64c7d1be5459a$export$9db09f4ba21f9d2a = ()=>{
    const weakMap = new WeakMap();
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        store: (args, result)=>result !== undefined ? $24f64c7d1be5459a$var$storeToWeakMapChain(args, 0, weakMap, result) : $24f64c7d1be5459a$var$storeToWeakMapChain(args, 0, weakMap, $24f64c7d1be5459a$var$UNDEFINED),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        read: (args)=>$24f64c7d1be5459a$var$getFromWeakMapChain(args, 0, weakMap)
    };
};

});




parcelRegister("edWFh", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a4c4df3cb07c12e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kQ0RL = parcelRequire("kQ0RL");

var $3QLcd = parcelRequire("3QLcd");

var $5JgJ2 = parcelRequire("5JgJ2");


var $k2cCe = parcelRequire("k2cCe");
function $0a4c4df3cb07c12e$export$2e2bcd8739ae039({ failedCount: failedCount, id: flagId, onRetry: onRetry, onViewSummary: onViewSummary, totalCount: totalCount, onDismissed: onDismissed, showRetryButton: showRetryButton, showViewSummaryButton: showViewSummaryButton, showSelectFailedItemsButton: showSelectFailedItemsButton, showLearnMoreButton: showLearnMoreButton, failureReason: failureReason, onSelectFailedItems: onSelectFailedItems }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const openInProductHelp = (0, $3QLcd.useHelpPanelLink)();
    const didAllUpdatesFail = failedCount === totalCount;
    const actions = (0, $eUqFw.useMemo)(()=>{
        const flagActions = [];
        if (showSelectFailedItemsButton) flagActions.push({
            content: formatMessage((0, $k2cCe.default).selectFailedActionContent),
            onClick: onSelectFailedItems
        });
        if (showRetryButton) flagActions.push({
            content: formatMessage((0, $k2cCe.default).retryActionContent),
            onClick: onRetry
        });
        if (showViewSummaryButton) flagActions.push({
            content: formatMessage((0, $k2cCe.default).viewSummaryActionContent),
            onClick: onViewSummary
        });
        if (showLearnMoreButton) flagActions.push({
            content: formatMessage((0, $k2cCe.default).learnMoreActionContent),
            onClick: ()=>openInProductHelp?.((0, $f15eaa0dc975a216$export$8f3a5e9fd2211cd2))
        });
        return flagActions;
    }, [
        showRetryButton,
        showViewSummaryButton,
        formatMessage,
        onRetry,
        onViewSummary,
        onSelectFailedItems,
        showSelectFailedItemsButton,
        openInProductHelp,
        showLearnMoreButton
    ]);
    const title = didAllUpdatesFail ? formatMessage((0, $k2cCe.default).flagTitleError) : formatMessage((0, $k2cCe.default).flagTitlePartialError, {
        failedCount: failedCount,
        totalCount: totalCount
    });
    const description = showRetryButton ? formatMessage((0, $k2cCe.default).flagDescriptionError) : formatMessage((0, $k2cCe.default).flagDescriptionErrorTryLater);
    const validationErrorDescription = formatMessage((0, $k2cCe.default).flagDescriptionValidationError);
    const networkErrorDescriptionTryLater = formatMessage((0, $k2cCe.default).flagDescriptionNetworkError);
    const descriptionMap = {
        network: showRetryButton ? description : networkErrorDescriptionTryLater,
        validation: validationErrorDescription,
        server: description,
        mixed: description
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.ErrorFlag), {
        id: flagId,
        onDismissed: onDismissed,
        title: title,
        description: descriptionMap[failureReason],
        actions: actions,
        testId: "software-backlog.flags.bulk-actions.error.bulk-actions-failed-flag"
    });
}

});
parcelRegister("3QLcd", function(module, exports) {

$parcel$export(module.exports, "useHelpPanelLink", () => $82adde900735644c$export$dc5c3cc39ce0d138);
$parcel$export(module.exports, "default", () => $82adde900735644c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $cEaY5 = parcelRequire("cEaY5");

var $zcJ0y = parcelRequire("zcJ0y");

var $1ybV0 = parcelRequire("1ybV0");

var $f2Poq = parcelRequire("f2Poq");

var $1zRTT = parcelRequire("1zRTT");

var $bUi2Q = parcelRequire("bUi2Q");
const $82adde900735644c$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
    const { openRightSidebar: openRightSidebar } = (0, $bUi2Q.useRightSidebarController)();
    const [, { setNavigationData: setNavigationData }] = (0, $1zRTT.useHelpPanelActions)();
    const isIphEnabled = (0, $1ybV0.ff)('iph.enabled') && !(0, $zcJ0y.isIE11)();
    const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
        openRightSidebar((0, $f2Poq.HELP_PANEL_ID), (0, $f2Poq.HELP_PANEL_WIDTH), false, true);
        if (resetHistory) setNavigationData({
            articleId: {
                id: id,
                type: (0, $cEaY5.ARTICLE_TYPE)[type]
            },
            history: []
        });
        else setNavigationData({
            articleId: {
                id: id,
                type: (0, $cEaY5.ARTICLE_TYPE)[type]
            }
        });
    };
    return isIphEnabled ? handleOnClick : undefined;
};
const $82adde900735644c$var$HelpPanelLink = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, fallbackComponent: fallbackComponent = null, onClick: onClick, ...props })=>{
    const onOpenInProductHelpArticle = $82adde900735644c$export$dc5c3cc39ce0d138();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnClick = (event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        onOpenInProductHelpArticle?.(articleId, (0, $cEaY5.ARTICLE_TYPE)[type]);
    };
    return onOpenInProductHelpArticle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ...props,
        onClick: handleOnClick
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, fallbackComponent);
};
var $82adde900735644c$export$2e2bcd8739ae039 = $82adde900735644c$var$HelpPanelLink;

});

const $f15eaa0dc975a216$export$8f3a5e9fd2211cd2 = '62h4g5fA9BUhungZSSNyEl';

parcelRegister("k2cCe", function(module, exports) {

$parcel$export(module.exports, "default", () => $0304c8187cf62ab0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0304c8187cf62ab0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    retryActionContent: {
        "id": "backlog.flags.bulk-actions.error.retry-action-content",
        "defaultMessage": "Try again"
    },
    viewSummaryActionContent: {
        "id": "backlog.flags.bulk-actions.error.view-summary-action-content",
        "defaultMessage": "View summary"
    },
    selectFailedActionContent: {
        "id": "backlog.flags.bulk-actions.error.select-failed-action-content",
        "defaultMessage": "Select failed items"
    },
    learnMoreActionContent: {
        "id": "backlog.flags.bulk-actions.error.learn-more-action-content",
        "defaultMessage": "Learn more"
    },
    flagTitleError: {
        "id": "backlog.flags.bulk-actions.error.flag-title-error",
        "defaultMessage": "Failed to update"
    },
    flagTitlePartialError: {
        "id": "backlog.flags.bulk-actions.error.flag-title-partial-error",
        "defaultMessage": "{failedCount}/{totalCount} {totalCount, plural, one {items} other {items}} not updated"
    },
    flagDescriptionError: {
        "id": "backlog.flags.bulk-actions.error.flag-description-error",
        "defaultMessage": "We were unable to update some of the items. Try again, or view the items that failed to update."
    },
    flagDescriptionErrorTryLater: {
        "id": "backlog.flags.bulk-actions.error.flag-description-error-try-later",
        "defaultMessage": "You can view the items that failed to update in a new tab, or wait a few minutes and try again."
    },
    flagDescriptionNetworkError: {
        "id": "backlog.flags.bulk-actions.error.flag-description-network-error",
        "defaultMessage": "There might be something wrong with the connection. Wait a few minutes, then try again."
    },
    flagDescriptionValidationError: {
        "id": "backlog.flags.bulk-actions.error.flag-description-validation-error",
        "defaultMessage": "The items might not be editable, or you may require permissions. Select the failed items to try again, or view a summary of the failed items."
    }
});

});



parcelRegister("8FgXV", function(module, exports) {

$parcel$export(module.exports, "default", () => $19963d41751d03c1$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $K2SiM = parcelRequire("K2SiM");

var $duuqb = parcelRequire("duuqb");
var $19963d41751d03c1$export$2e2bcd8739ae039 = (0, $lNNXV.connect)(null, (dispatch)=>({
        onPrimaryActionClick: (cardId)=>{
            // @ts-expect-error - Argument of type 'string' is not assignable to parameter of type 'number'.
            dispatch((0, $K2SiM.openDetailView)(cardId));
        }
    }))((0, $duuqb.default));

});
parcelRegister("K2SiM", function(module, exports) {

$parcel$export(module.exports, "OPEN_DETAIL_VIEW", () => $6393571423dd8e0a$export$674d39029d0816cc);
$parcel$export(module.exports, "openDetailView", () => $6393571423dd8e0a$export$d412abc3bc336eb6);
$parcel$export(module.exports, "OPEN_DETAIL_VIEW_DEBOUNCED", () => $6393571423dd8e0a$export$372223232eefdb08);
$parcel$export(module.exports, "openDetailViewDebounced", () => $6393571423dd8e0a$export$9147c3f14f6ec3b9);
$parcel$export(module.exports, "UPDATE_DETAIL_VIEW", () => $6393571423dd8e0a$export$e38020a85931f37e);
$parcel$export(module.exports, "updateDetailView", () => $6393571423dd8e0a$export$d5df566661a69c2d);
$parcel$export(module.exports, "CLOSE_DETAIL_VIEW", () => $6393571423dd8e0a$export$c22445a1fd3a65ce);
$parcel$export(module.exports, "closeDetailView", () => $6393571423dd8e0a$export$b996efd4b4df6740);
const $6393571423dd8e0a$export$674d39029d0816cc = 'state.actions.detail-view.OPEN_DETAIL_VIEW';
const $6393571423dd8e0a$export$d412abc3bc336eb6 = (cardId, externalAction, analyticsMetadata)=>({
        type: $6393571423dd8e0a$export$674d39029d0816cc,
        payload: {
            cardId: cardId,
            externalAction: externalAction,
            analyticsMetadata: analyticsMetadata
        }
    });
const $6393571423dd8e0a$export$372223232eefdb08 = 'state.actions.detail-view.OPEN_DETAIL_VIEW_DEBOUNCED';
const $6393571423dd8e0a$export$9147c3f14f6ec3b9 = (cardId, externalAction)=>({
        type: $6393571423dd8e0a$export$372223232eefdb08,
        payload: {
            cardId: cardId,
            externalAction: externalAction
        }
    });
const $6393571423dd8e0a$export$e38020a85931f37e = 'state.actions.detail-view.UPDATE_DETAIL_VIEW';
const $6393571423dd8e0a$export$d5df566661a69c2d = ()=>({
        type: $6393571423dd8e0a$export$e38020a85931f37e
    });
const $6393571423dd8e0a$export$c22445a1fd3a65ce = 'state.actions.detail-view.CLOSE_DETAIL_VIEW';
const $6393571423dd8e0a$export$b996efd4b4df6740 = (issueId)=>({
        type: $6393571423dd8e0a$export$c22445a1fd3a65ce,
        payload: {
            issueId: issueId
        }
    });

});

parcelRegister("duuqb", function(module, exports) {

$parcel$export(module.exports, "default", () => $5df75ecf20468573$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $82rJa = parcelRequire("82rJa");

var $5JgJ2 = parcelRequire("5JgJ2");

var $90ZS3 = parcelRequire("90ZS3");


var $1y8of = parcelRequire("1y8of");
const $5df75ecf20468573$var$CardIsFiltered = ({ onPrimaryActionClick: onPrimaryActionClick, card: card, ...props })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [, setIssueKey] = (0, $90ZS3.useQueryParam)((0, $5a6592135d519f1e$export$3a0c4bc79274bbaa));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82rJa.default), {
        ...props,
        key: card.key,
        title: formatMessage((0, $1y8of.default).createdCardIsFilteredTitle, {
            cardKey: card.key
        }),
        description: formatMessage((0, $1y8of.default).createdCardIsFilteredDescription),
        actions: [
            {
                content: formatMessage((0, $1y8of.default).createdCardIsFilteredLink),
                onClick: ()=>{
                    onPrimaryActionClick(String(card.id));
                    setIssueKey(card.key);
                }
            }
        ]
    });
};
var $5df75ecf20468573$export$2e2bcd8739ae039 = $5df75ecf20468573$var$CardIsFiltered;

});
parcelRegister("82rJa", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c8bd85b08cb5610$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var $9c8bd85b08cb5610$export$2e2bcd8739ae039 = (0, $kQ0RL.WarningFlag);

});

parcelRegister("90ZS3", function(module, exports) {

$parcel$export(module.exports, "useQueryParam", () => $531b22dea21c6f31$export$ae316f0eeb712a36);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $i7Fym = parcelRequire("i7Fym");

var $53ciZ = parcelRequire("53ciZ");

var $kJlBc = parcelRequire("kJlBc");
const $531b22dea21c6f31$export$ae316f0eeb712a36 = (queryParam)=>{
    const [{ location: { pathname: pathname }, query: query }, { push: push }] = (0, $kJlBc.useRouter)();
    const queryParamValue = query[queryParam];
    const setQueryParam = (0, $eUqFw.useCallback)((newValue)=>{
        const parsedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($i7Fym)))({
            ...query,
            [queryParam]: newValue
        }, (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value));
        const strSearch = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(parsedSearch);
        push(pathname + (strSearch !== '' ? `?${strSearch}` : ''));
    }, [
        pathname,
        push,
        query,
        queryParam
    ]);
    return [
        queryParamValue,
        setQueryParam
    ];
};

});

const $5a6592135d519f1e$export$e39925d10cebc0b = 'text';
const $5a6592135d519f1e$export$f78d8c81fcad32a2 = 'assignee';
const $5a6592135d519f1e$export$e729d951ab128c3b = 'label';
const $5a6592135d519f1e$export$3a0c4bc79274bbaa = 'selectedIssue';
const $5a6592135d519f1e$export$8a2cab795731dc42 = 'issueParent';
const $5a6592135d519f1e$export$7f765927237d6fb0 = 'issueParentPanel';
const $5a6592135d519f1e$export$9c304e612707f622 = 'versionPanel';
const $5a6592135d519f1e$export$fa7b72626a2e0090 = 'issueType';
const $5a6592135d519f1e$export$392308739e657b75 = 'version';
const $5a6592135d519f1e$export$cb08ebea4a46cd29 = 'customFilter';
const $5a6592135d519f1e$export$61119f100c357d06 = 'isInsightsOpen';
const $5a6592135d519f1e$export$ec3c43b997309252 = 'epics';
const $5a6592135d519f1e$export$a86c1a6dde9da34f = 'versions';

parcelRegister("1y8of", function(module, exports) {

$parcel$export(module.exports, "default", () => $37d6e585bbeac306$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $37d6e585bbeac306$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createdCardIsFilteredTitle: {
        "id": "backlog.flags.card-create-filtered.created-card-is-filtered-title",
        "defaultMessage": "{cardKey} has been created."
    },
    createdCardIsFilteredDescription: {
        "id": "backlog.flags.card-create-filtered.created-card-is-filtered-description",
        "defaultMessage": "It's hidden by your current filter."
    },
    createdCardIsFilteredLink: {
        "id": "backlog.flags.card-create-filtered.created-card-is-filtered-link",
        "defaultMessage": "View issue"
    }
});

});



parcelRegister("fIMef", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4f91fd49c855951$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $9H3i5 = parcelRequire("9H3i5");

var $K2SiM = parcelRequire("K2SiM");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $7kNqR = parcelRequire("7kNqR");

var $ihqwI = parcelRequire("ihqwI");
const $d4f91fd49c855951$var$getActiveCustomFilterIds = (state)=>state.ui.filters.CUSTOM_FILTER || [];
const $d4f91fd49c855951$var$isCustomFiltersActive = (state)=>$d4f91fd49c855951$var$getActiveCustomFilterIds(state).length > 0;
const $d4f91fd49c855951$var$mapStateToProps = (state, { cardIds: cardIds })=>({
        cards: (0, $bP7Jx.partialCardsFromCardIdsSelector)(state)(cardIds),
        showCustomFiltersSettingsLink: (0, $7kNqR.canEditBoardConfig)(state) && $d4f91fd49c855951$var$isCustomFiltersActive(state),
        customFiltersSettingsUrl: (0, $9H3i5.getCustomFiltersSettingsUrl)((0, $hkGxG.getProjectKey)(state), (0, $hkGxG.getRapidViewId)(state))
    });
const $d4f91fd49c855951$var$mapDispatchToProps = {
    onViewIssue: (0, $K2SiM.openDetailView)
};
const $d4f91fd49c855951$export$9d1611c77c2fe928 = (stateProps, dispatchProps, { id: id, onDismissed: onDismissed })=>({
        id: id,
        onDismissed: onDismissed,
        ...stateProps,
        ...dispatchProps
    });
var $d4f91fd49c855951$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($d4f91fd49c855951$var$mapStateToProps, $d4f91fd49c855951$var$mapDispatchToProps, $d4f91fd49c855951$export$9d1611c77c2fe928)((0, $ihqwI.default));

});
parcelRegister("9H3i5", function(module, exports) {

$parcel$export(module.exports, "getColumnStatusMappingUrl", () => $4c7ad21892dc116e$export$5eee224adec4e661);
$parcel$export(module.exports, "getCustomFiltersSettingsUrl", () => $4c7ad21892dc116e$export$15f763506e87c58e);
$parcel$export(module.exports, "getCustomFilterFromUrlQuery", () => $4c7ad21892dc116e$export$7076eae01bf61f73);

var $53ciZ = parcelRequire("53ciZ");

var $bHPpI = parcelRequire("bHPpI");
const $4c7ad21892dc116e$export$5eee224adec4e661 = (projectKey, boardId)=>`/jira/software/projects/${projectKey}/settings/boards/${boardId}/columns`;
const $4c7ad21892dc116e$export$15f763506e87c58e = (projectKey, boardId)=>`/jira/software/projects/${projectKey}/settings/boards/${boardId}/custom-filters`;
const $4c7ad21892dc116e$export$7076eae01bf61f73 = ({ search: search })=>{
    const queryParameters = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(search);
    if (queryParameters?.customFilter) return (0, $bHPpI.toArray)(queryParameters.customFilter);
    if (queryParameters.quickFilter) return (0, $bHPpI.toArray)(queryParameters.quickFilter);
    return undefined;
};

});

parcelRegister("7kNqR", function(module, exports) {

$parcel$export(module.exports, "getPermissions", () => $12ad09f741d5f434$export$e10fd44ca431fa8e);
$parcel$export(module.exports, "canViewBoard", () => $12ad09f741d5f434$export$86298d668b506539);
$parcel$export(module.exports, "canEditBoardConfig", () => $12ad09f741d5f434$export$6dd65380225d5199);
$parcel$export(module.exports, "canManageSprints", () => $12ad09f741d5f434$export$8830b0b3ee0a6ade);
$parcel$export(module.exports, "canCreateIssues", () => $12ad09f741d5f434$export$38d976fa7e28ee53);
$parcel$export(module.exports, "canEditIssue", () => $12ad09f741d5f434$export$3f2995080649d07c);
$parcel$export(module.exports, "canDeleteIssues", () => $12ad09f741d5f434$export$f9d3b77685359020);
$parcel$export(module.exports, "canAssignIssues", () => $12ad09f741d5f434$export$5df0ca7091398ef7);
$parcel$export(module.exports, "canTransitionIssues", () => $12ad09f741d5f434$export$e03f24612ae6fce6);
$parcel$export(module.exports, "canBulkEditIssues", () => $12ad09f741d5f434$export$793ca6e17cc6edb8);

const $12ad09f741d5f434$export$e10fd44ca431fa8e = (state)=>state.config.permissions;
const $12ad09f741d5f434$export$86298d668b506539 = (state)=>$12ad09f741d5f434$export$e10fd44ca431fa8e(state)[0, $094620879c5e56fa$export$feb9a4de117c162] || false;
const $12ad09f741d5f434$export$6dd65380225d5199 = (state)=>$12ad09f741d5f434$export$e10fd44ca431fa8e(state)[0, $094620879c5e56fa$export$b35e3ebf2c83a499] || false;
const $12ad09f741d5f434$export$8830b0b3ee0a6ade = (state)=>$12ad09f741d5f434$export$e10fd44ca431fa8e(state)[0, $094620879c5e56fa$export$d765836bd761b2ee] || false;
const $12ad09f741d5f434$export$38d976fa7e28ee53 = (state)=>$12ad09f741d5f434$export$e10fd44ca431fa8e(state)[0, $094620879c5e56fa$export$526c94c551c00291] || false;
const $12ad09f741d5f434$export$3f2995080649d07c = (state)=>$12ad09f741d5f434$export$e10fd44ca431fa8e(state)[0, $094620879c5e56fa$export$8a1ecb9983951227] || false;
const $12ad09f741d5f434$export$f9d3b77685359020 = (state)=>$12ad09f741d5f434$export$e10fd44ca431fa8e(state)[0, $094620879c5e56fa$export$a20ec683078f5f77] || false;
const $12ad09f741d5f434$export$5df0ca7091398ef7 = (state)=>$12ad09f741d5f434$export$e10fd44ca431fa8e(state)[0, $094620879c5e56fa$export$9c0523cef5fab15e] || false;
const $12ad09f741d5f434$export$e03f24612ae6fce6 = (state)=>$12ad09f741d5f434$export$e10fd44ca431fa8e(state)[0, $094620879c5e56fa$export$b5f3bd28b6a935be] || false;
const $12ad09f741d5f434$export$793ca6e17cc6edb8 = (state)=>$12ad09f741d5f434$export$e10fd44ca431fa8e(state)[0, $094620879c5e56fa$export$a71edb30f3453bef] || false;

});
const $094620879c5e56fa$export$feb9a4de117c162 = 'CAN_VIEW_BOARD';
const $094620879c5e56fa$export$a71edb30f3453bef = 'CAN_BULK_CHANGE_ISSUES';
const $094620879c5e56fa$export$b35e3ebf2c83a499 = 'CAN_EDIT_BOARD_CONFIG';
const $094620879c5e56fa$export$d765836bd761b2ee = 'CAN_MANAGE_SPRINTS';
const $094620879c5e56fa$export$526c94c551c00291 = 'CAN_CREATE_ISSUES';
const $094620879c5e56fa$export$8a1ecb9983951227 = 'CAN_EDIT_ISSUES';
const $094620879c5e56fa$export$a20ec683078f5f77 = 'CAN_DELETE_ISSUES';
const $094620879c5e56fa$export$9c0523cef5fab15e = 'CAN_ASSIGN_ISSUES';
const $094620879c5e56fa$export$b5f3bd28b6a935be = 'CAN_TRANSITION_ISSUES';


parcelRegister("ihqwI", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a46fef3328c13a3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kQ0RL = parcelRequire("kQ0RL");

var $3x4sL = parcelRequire("3x4sL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $idkBG = parcelRequire("idkBG");

var $90ZS3 = parcelRequire("90ZS3");


var $ezUr2 = parcelRequire("ezUr2");
const $9a46fef3328c13a3$var$linkStart = '{linkStart}';
const $9a46fef3328c13a3$var$linkEnd = '{linkEnd}';
const $9a46fef3328c13a3$var$getIssueLink = (key)=>`/browse/${key}`;
const $9a46fef3328c13a3$var$CardCreateFiltered = ({ cards: cards, id: id, onDismissed: onDismissed, onViewIssue: onViewIssue, customFiltersSettingsUrl: customFiltersSettingsUrl, showCustomFiltersSettingsLink: showCustomFiltersSettingsLink })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [, setIssueKey] = (0, $90ZS3.useQueryParam)((0, $5a6592135d519f1e$export$3a0c4bc79274bbaa));
    const onActionClick = (0, $eUqFw.useCallback)(()=>{
        (0, $idkBG.setReturnToProjectUrl)();
    }, []);
    const onClickSingleCard = (0, $eUqFw.useCallback)((e)=>{
        if (cards.length === 1) {
            e.preventDefault();
            onViewIssue(cards[0].id);
            setIssueKey(cards[0].key);
        }
    }, [
        cards,
        onViewIssue,
        setIssueKey
    ]);
    const actions = [
        ...showCustomFiltersSettingsLink ? [
            {
                content: formatMessage((0, $ezUr2.default).settingsLink),
                href: customFiltersSettingsUrl,
                target: '_blank',
                onClick: onActionClick
            }
        ] : []
    ];
    const isSingle = cards.length === 1;
    if (isSingle) {
        const card = cards[0];
        const issueLinkComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                href: $9a46fef3328c13a3$var$getIssueLink(card.key),
                onClick: onClickSingleCard
            }, card.key);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.SuccessAutoDismissFlag), {
            id: id,
            onDismissed: onDismissed,
            title: formatMessage((0, $ezUr2.default).issueHiddenTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3x4sL.FormattedI18nMessage), {
                message: formatMessage((0, $ezUr2.default).issueHiddenDescription, {
                    linkStart: $9a46fef3328c13a3$var$linkStart,
                    linkEnd: $9a46fef3328c13a3$var$linkEnd
                }),
                componentsMapping: {
                    link: issueLinkComponent
                }
            }),
            actions: [
                {
                    content: formatMessage((0, $ezUr2.default).issueLink),
                    onClick: onClickSingleCard,
                    href: $9a46fef3328c13a3$var$getIssueLink(card.key)
                },
                ...actions
            ]
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.SuccessAutoDismissFlag), {
        id: id,
        onDismissed: onDismissed,
        title: formatMessage((0, $ezUr2.default).multipleIssuesHiddenTitle),
        description: formatMessage((0, $ezUr2.default).multipleIssuesHiddenDescription),
        actions: actions
    });
};
var $9a46fef3328c13a3$export$2e2bcd8739ae039 = $9a46fef3328c13a3$var$CardCreateFiltered;

});
parcelRegister("3x4sL", function(module, exports) {

$parcel$export(module.exports, "FormattedI18nMessage", () => $88ddecd12f0773cd$export$200d7bd7633253ce);

var $eUqFw = parcelRequire("eUqFw");

var $dO2kc = parcelRequire("dO2kc");

var $6nVYw = parcelRequire("6nVYw");
const $88ddecd12f0773cd$export$200d7bd7633253ce = (props)=>{
    const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
    const messageParts = (0, $eUqFw.useMemo)(()=>{
        const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, $6nVYw.getTags)(componentsMapping);
        try {
            const parts = [];
            let token = '';
            let TagComponent;
            let closeTagLookup;
            for(let i = 0; i < message.length; i += 1){
                const letter = message[i];
                token += letter;
                if ((0, $6nVYw.isCloseTagDelimiter)(letter)) {
                    const firstTagFound = (0, $6nVYw.findTag)(token, {
                        tags: openTags
                    });
                    if (firstTagFound !== null && firstTagFound !== undefined) {
                        // if we have a tag already means it is a malformed message since it is 2 subsequent open tags
                        if (TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                        const text = token.replace(firstTagFound, '');
                        parts.push(text);
                        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                        const tagInfo = tags[firstTagFound];
                        TagComponent = tagInfo.component;
                        closeTagLookup = tagInfo.close;
                        token = '';
                    }
                }
                if (closeTagLookup !== null && closeTagLookup !== undefined && (0, $6nVYw.isCloseTagDelimiter)(letter) && (0, $6nVYw.isAnyTag)(token, {
                    tags: [
                        closeTagLookup
                    ]
                })) {
                    // this mean that we do not have an open tag for this closing tag
                    if (!TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                    const text = token.replace(closeTagLookup, '');
                    parts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TagComponent, null, text));
                    TagComponent = undefined;
                    token = '';
                    closeTagLookup = undefined;
                }
                if ((0, $6nVYw.isCloseTagDelimiter)(letter) && (0, $6nVYw.isAnyTag)(token, {
                    tags: closeTags
                })) {
                    // if we do not have an open tag mean we are closing a tag that is not open
                    if (!TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                }
            }
            // if we reached the end and we have an open tag, mean this message is malformed
            if (TagComponent || closeTagLookup) throw new (0, $dO2kc.MalformedMessageError)();
            // flush anything we keep in the current token
            if (token.length > 0) parts.push(token);
            return parts;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e instanceof (0, $dO2kc.MalformedMessageError)) {
                (0, $dO2kc.logMalformedMessageError)({
                    message: message,
                    packageName: packageName
                });
                return [
                    (0, $dO2kc.getMalformedMessage)({
                        message: message,
                        closeTags: closeTags,
                        openTags: openTags
                    })
                ];
            }
            throw e;
        }
    }, [
        message,
        packageName,
        componentsMapping
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, messageParts.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
            key: index
        }, item)));
};

});
parcelRegister("dO2kc", function(module, exports) {

$parcel$export(module.exports, "getMalformedMessage", () => $1a42e2705665fc85$export$f085cf20ec1f69ab);
$parcel$export(module.exports, "logMalformedMessageError", () => $1a42e2705665fc85$export$954c3e6aad1c9429);
$parcel$export(module.exports, "MalformedMessageError", () => $1a42e2705665fc85$export$40d900e818b9630e);

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

const $1a42e2705665fc85$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
        ...openTags,
        ...closeTags
    ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
const $1a42e2705665fc85$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
    if (packageName !== null && packageName !== undefined) {
        const errorMessage = `Malformed message: ${message}`;
        // Send error log to analytics pipeline (i.e. SFX) and Sentry
        (0, $guiFP.default)({
            meta: {
                packageName: packageName,
                id: (0, $376af31d5cd90f0d$export$f3390a0e172fee41)
            },
            attributes: {
                message: errorMessage
            }
        });
        // Send error log to Splunk
        const location = `${packageName}.${(0, $376af31d5cd90f0d$export$f3390a0e172fee41)}`;
        (0, $gUUjF.default).unsafeErrorWithCustomerData(location, errorMessage);
    }
};
class $1a42e2705665fc85$export$40d900e818b9630e extends Error {
    constructor(){
        super('Malformed i18n message');
    }
}

});
const $376af31d5cd90f0d$export$f3390a0e172fee41 = 'formattedI18NMessage';


parcelRegister("6nVYw", function(module, exports) {

$parcel$export(module.exports, "getTags", () => $ec16d76793463e9e$export$af63d7414243dad3);
$parcel$export(module.exports, "isAnyTag", () => $ec16d76793463e9e$export$38ffa64fc639355f);
$parcel$export(module.exports, "findTag", () => $ec16d76793463e9e$export$dfca0f74034f8657);
$parcel$export(module.exports, "isCloseTagDelimiter", () => $ec16d76793463e9e$export$d5170904651e91b1);

const $ec16d76793463e9e$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, [key, value])=>{
        const open = `{${key}Start}`;
        const close = `{${key}End}`;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        acc.tags[open] = {
            close: close,
            component: value
        };
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.openTags.push(open);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.closeTags.push(close);
        return acc;
    }, {
        tags: {},
        openTags: [],
        closeTags: []
    });
const $ec16d76793463e9e$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
const $ec16d76793463e9e$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
const $ec16d76793463e9e$export$d5170904651e91b1 = (letter)=>letter === (0, $a86f32165c278403$export$a10c567c3288a6b4);

});
const $a86f32165c278403$export$a10c567c3288a6b4 = '}';



parcelRegister("idkBG", function(module, exports) {

$parcel$export(module.exports, "setReturnToProjectUrl", () => $fad8e4e0d6f4380e$export$127f7bd1c092fc8f);
$parcel$export(module.exports, "getReturnToProjectUrl", () => $fad8e4e0d6f4380e$export$575dc7c4a154874b);

var $89bO2 = parcelRequire("89bO2");
const $fad8e4e0d6f4380e$var$RETURN_TO_PROJECT_URL = 'returnToProjectUrl';
const $fad8e4e0d6f4380e$var$sessionStorage = (0, $89bO2.createSessionExpirableStorageProvider)('navigation');
const $fad8e4e0d6f4380e$export$127f7bd1c092fc8f = ()=>{
    $fad8e4e0d6f4380e$var$sessionStorage.set($fad8e4e0d6f4380e$var$RETURN_TO_PROJECT_URL, window.location.pathname + window.location.search);
};
const $fad8e4e0d6f4380e$export$575dc7c4a154874b = ()=>String($fad8e4e0d6f4380e$var$sessionStorage.get($fad8e4e0d6f4380e$var$RETURN_TO_PROJECT_URL) || '');

});

parcelRegister("ezUr2", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ad9101205f0ee26$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6ad9101205f0ee26$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issueHiddenTitle: {
        "id": "backlog.flags.card-create-filtered-v2.issue-hidden-title",
        "defaultMessage": "Changes are saved, but the issue isn\u2019t visible"
    },
    issueHiddenDescription: {
        "id": "backlog.flags.card-create-filtered-v2.issue-hidden-description",
        "defaultMessage": "Issue {linkStart}{linkEnd} is currently hidden by a filter."
    },
    issueLink: {
        "id": "backlog.flags.card-create-filtered-v2.issue-link",
        "defaultMessage": "View issue"
    },
    multipleIssuesHiddenTitle: {
        "id": "backlog.flags.card-create-filtered-v2.multiple-issues-hidden-title",
        "defaultMessage": "Changes are saved, but issues aren't visible"
    },
    multipleIssuesHiddenDescription: {
        "id": "backlog.flags.card-create-filtered-v2.multiple-issues-hidden-description",
        "defaultMessage": "Created issues are currently hidden by a filter."
    },
    settingsLink: {
        "id": "backlog.flags.card-create-filtered-v2.settings-link",
        "defaultMessage": "Manage custom filters"
    }
});

});



parcelRegister("glOhA", function(module, exports) {

$parcel$export(module.exports, "default", () => $edca807fc4fb1292$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $9H3i5 = parcelRequire("9H3i5");

var $hkGxG = parcelRequire("hkGxG");

var $7kNqR = parcelRequire("7kNqR");

var $90M4y = parcelRequire("90M4y");
const $edca807fc4fb1292$var$mapStateToProps = (state)=>({
        boardConfigUrl: (0, $9H3i5.getColumnStatusMappingUrl)((0, $hkGxG.getProjectKey)(state), (0, $hkGxG.getRapidViewId)(state)),
        isConfigureBoardEnabled: (0, $7kNqR.canEditBoardConfig)(state)
    });
var $edca807fc4fb1292$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($edca807fc4fb1292$var$mapStateToProps, {})((0, $90M4y.CardCreateUnmappedFlag));

});
parcelRegister("90M4y", function(module, exports) {

$parcel$export(module.exports, "CardCreateUnmappedFlag", () => $9893c54d2544f30e$export$41f7bf5526b10063);

var $eUqFw = parcelRequire("eUqFw");

var $kQ0RL = parcelRequire("kQ0RL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lByOh = parcelRequire("lByOh");
const $9893c54d2544f30e$export$41f7bf5526b10063 = ({ onDismissed: onDismissed, id: id, numIssues: numIssues, boardConfigUrl: boardConfigUrl, isConfigureBoardEnabled: isConfigureBoardEnabled })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const getActions = isConfigureBoardEnabled ? [
        {
            content: formatMessage((0, $lByOh.default).assignStatuses),
            href: boardConfigUrl
        }
    ] : [];
    const description = numIssues > 1 ? formatMessage((0, $lByOh.default).multipleIssuesHiddenDescription, {
        numIssues: numIssues
    }) : formatMessage((0, $lByOh.default).issueHiddenDescription);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.SuccessAutoDismissFlag), {
        id: id,
        onDismissed: onDismissed,
        title: formatMessage((0, $lByOh.default).issueHiddenTitle, {
            numIssues: numIssues
        }),
        description: description,
        actions: getActions
    });
};

});
parcelRegister("lByOh", function(module, exports) {

$parcel$export(module.exports, "default", () => $09e278f4102a9657$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $09e278f4102a9657$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issueHiddenTitle: {
        "id": "backlog.flags.card-create-unmapped.issue-hidden-title",
        "defaultMessage": "Changes saved, but {numIssues, plural, one {issue} other {issues}} not visible"
    },
    issueHiddenDescription: {
        "id": "backlog.flags.card-create-unmapped.issue-hidden-description",
        "defaultMessage": "The issue is assigned to a status that\u2019s not visible on the board and backlog."
    },
    multipleIssuesHiddenDescription: {
        "id": "backlog.flags.card-create-unmapped.multiple-issues-hidden-description",
        "defaultMessage": "{numIssues} issues have been created, but one or more have a status that\u2019s not visible on the board and backlog."
    },
    assignStatuses: {
        "id": "backlog.flags.card-create-unmapped.assign-statuses",
        "defaultMessage": "Assign statuses"
    }
});

});



parcelRegister("ll1jU", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bbecd1b6b1b8865$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $bTYrv = parcelRequire("bTYrv");

var $9H3i5 = parcelRequire("9H3i5");

var $hkGxG = parcelRequire("hkGxG");

var $7kNqR = parcelRequire("7kNqR");
const $3bbecd1b6b1b8865$var$mapStateToProps = (state)=>({
        boardConfigUrl: (0, $9H3i5.getColumnStatusMappingUrl)((0, $hkGxG.getProjectKey)(state), (0, $hkGxG.getRapidViewId)(state)),
        isConfigureBoardEnabled: (0, $7kNqR.canEditBoardConfig)(state)
    });
var $3bbecd1b6b1b8865$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($3bbecd1b6b1b8865$var$mapStateToProps, {})((0, $bTYrv.CardCreateUnmappedFlag));

});
parcelRegister("bTYrv", function(module, exports) {

$parcel$export(module.exports, "CardCreateUnmappedFlag", () => $f4b97be201d1a88f$export$41f7bf5526b10063);

var $eUqFw = parcelRequire("eUqFw");

var $kQ0RL = parcelRequire("kQ0RL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gjVGb = parcelRequire("gjVGb");

var $cNqoe = parcelRequire("cNqoe");
const $f4b97be201d1a88f$export$41f7bf5526b10063 = ({ cardKeys: cardKeys, onDismissed: onDismissed, id: id })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const numIssues = cardKeys.length;
    const getFlagDescription = ()=>formatMessage((0, $cNqoe.default).updatedIssueHiddenDescription);
    const getActions = ()=>{
        const actions = [
            {
                content: formatMessage((0, $cNqoe.default).issueLink, {
                    numIssues: numIssues
                }),
                href: (0, $gjVGb.getIssueDiscoveryUrl)(cardKeys),
                target: '_blank'
            }
        ];
        return actions;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.SuccessAutoDismissFlag), {
        id: id,
        onDismissed: onDismissed,
        title: formatMessage((0, $cNqoe.default).updatedIssueHiddenTitle, {
            numIssues: numIssues
        }),
        description: getFlagDescription(),
        actions: getActions()
    });
};

});
parcelRegister("cNqoe", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9fd5f4edc526bb1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d9fd5f4edc526bb1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issueHiddenTitle: {
        "id": "software-flags.card-create-unmapped.issue-hidden-title",
        "defaultMessage": "Changes saved, but {numIssues, plural, one {issue} other {issues}} not visible"
    },
    issueHiddenDescription: {
        "id": "software-flags.card-create-unmapped.issue-hidden-description",
        "defaultMessage": "Issue {linkStart}{linkEnd} has a status that\u2019s not visible on the board and backlog."
    },
    multipleIssuesHiddenDescription: {
        "id": "software-flags.card-create-unmapped.multiple-issues-hidden-description",
        "defaultMessage": "{numIssues, plural, one {{numIssues} issue has} other {{numIssues} issues have}} been created, but one or more have a status that's not visible on the board and backlog"
    },
    issueLink: {
        "id": "software-flags.card-create-unmapped.issue-link",
        "defaultMessage": "View {numIssues, plural, one {issue} other {issues}}"
    },
    updatedIssueHiddenTitle: {
        "id": "software-flags.card-create-unmapped.updated-issue-hidden-title",
        "defaultMessage": "Changes saved, but {numIssues, plural, one {Issue} other {Issues}} not visible"
    },
    updatedIssueHiddenDescription: {
        "id": "software-flags.card-create-unmapped.updated-issue-hidden-description",
        "defaultMessage": "For an issue to be visible, it must match your project and filters, and have a status that\u2019s assigned to the board."
    }
});

});



parcelRegister("2JAFl", function(module, exports) {

$parcel$export(module.exports, "CardDragDisallowedFlag", () => $1ccf6e0f9f0fe093$export$7df6cad02c3a09f1);

var $eUqFw = parcelRequire("eUqFw");

var $kQ0RL = parcelRequire("kQ0RL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $56Knm = parcelRequire("56Knm");
function $1ccf6e0f9f0fe093$export$7df6cad02c3a09f1({ id: id, onDismissed: onDismissed }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.ErrorFlag), {
        id: id,
        onDismissed: onDismissed,
        title: formatMessage((0, $56Knm.default).removeSubtaskTitle),
        description: formatMessage((0, $56Knm.default).removeSubtaskDescription)
    });
}

});
parcelRegister("56Knm", function(module, exports) {

$parcel$export(module.exports, "default", () => $366657ae6da6a472$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $366657ae6da6a472$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    removeSubtaskTitle: {
        "id": "backlog.flags.card-drag-disallowed.remove-subtask-title",
        "defaultMessage": "Subtasks can't be moved from their parent on the backlog"
    },
    removeSubtaskDescription: {
        "id": "backlog.flags.card-drag-disallowed.remove-subtask-description",
        "defaultMessage": "Select a subtask to view and edit its details"
    }
});

});


parcelRegister("perS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $56412ccbbc57dae3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $82rJa = parcelRequire("82rJa");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6HhHs = parcelRequire("6HhHs");
const $56412ccbbc57dae3$export$321f8e7a5f776e25 = ({ id: id, boardId: boardId, isAdmin: isAdmin, onDismissed: onDismissed })=>{
    const getEditFilterUrl = `/secure/RapidBoard.jspa?rapidView=${boardId}&config=filter`;
    const learnMoreUrl = 'https://support.atlassian.com/jira-software-cloud/docs/enable-ranking/';
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const getContent = ()=>{
        if (isAdmin) return {
            description: formatMessage((0, $6HhHs.default).description),
            actions: [
                {
                    content: formatMessage((0, $6HhHs.default).showJqlFilterForBoard),
                    href: getEditFilterUrl
                },
                {
                    content: formatMessage((0, $6HhHs.default).learnMore),
                    href: learnMoreUrl
                }
            ]
        };
        return {
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $6HhHs.default).description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), formatMessage((0, $6HhHs.default).contactAdmin)),
            actions: [
                {
                    content: formatMessage((0, $6HhHs.default).learnMore),
                    href: learnMoreUrl
                }
            ]
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82rJa.default), {
        id: id,
        // @ts-expect-error isAutoDismiss prop looks to be unused but should be tested before removing
        isAutoDismiss: true,
        onDismissed: onDismissed,
        title: formatMessage((0, $6HhHs.default).title),
        ...getContent()
    });
};
var $56412ccbbc57dae3$export$2e2bcd8739ae039 = $56412ccbbc57dae3$export$321f8e7a5f776e25;

});
parcelRegister("6HhHs", function(module, exports) {

$parcel$export(module.exports, "default", () => $593515d213717921$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $593515d213717921$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "backlog.flags.card-move-disabled.title",
        "defaultMessage": "Issues can\u2019t be manually ranked"
    },
    description: {
        "id": "backlog.flags.card-move-disabled.description",
        "defaultMessage": "The board\u2019s filter query isn\u2019t sorted by rank. To rank issues manually on your board and backlog, sort issues by ascending rank."
    },
    contactAdmin: {
        "id": "backlog.flags.card-move-disabled.contact-admin",
        "defaultMessage": "Contact your admin to adjust the board filter."
    },
    showJqlFilterForBoard: {
        "id": "backlog.flags.card-move-disabled.show-jql-filter-for-board",
        "defaultMessage": "Manage board filter"
    },
    learnMore: {
        "id": "backlog.flags.card-move-disabled.learn-more",
        "defaultMessage": "Learn more"
    }
});

});


parcelRegister("27voR", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c82eba198469c10$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $82rJa = parcelRequire("82rJa");

var $5JgJ2 = parcelRequire("5JgJ2");

var $31uAn = parcelRequire("31uAn");
const $9c82eba198469c10$var$ClearCustomFilterFailed = ({ id: id, onDismissed: onDismissed })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onClick = (0, $eUqFw.useCallback)(()=>{
        window.location.reload();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82rJa.default), {
        id: id,
        onDismissed: onDismissed,
        title: formatMessage((0, $31uAn.default).endUserTitle),
        description: formatMessage((0, $31uAn.default).endUserDescription),
        actions: [
            {
                content: formatMessage((0, $31uAn.default).endUserActionLink),
                onClick: onClick
            }
        ]
    });
};
var $9c82eba198469c10$export$2e2bcd8739ae039 = $9c82eba198469c10$var$ClearCustomFilterFailed;

});
parcelRegister("31uAn", function(module, exports) {

$parcel$export(module.exports, "default", () => $345297a91f0f916c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $345297a91f0f916c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    endUserTitle: {
        "id": "backlog.flags.clear-custom-filter-failed.end-user-title",
        "defaultMessage": "We couldn't clear your filters"
    },
    endUserDescription: {
        "id": "backlog.flags.clear-custom-filter-failed.end-user-description",
        "defaultMessage": "Refresh the page and try again."
    },
    endUserActionLink: {
        "id": "backlog.flags.clear-custom-filter-failed.end-user-action-link",
        "defaultMessage": "Reload page"
    }
});

});


parcelRegister("j0Zfx", function(module, exports) {

$parcel$export(module.exports, "default", () => $874e5400fb6c2aa7$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $9H3i5 = parcelRequire("9H3i5");

var $hkGxG = parcelRequire("hkGxG");

var $7kNqR = parcelRequire("7kNqR");

var $juKJ0 = parcelRequire("juKJ0");
const $874e5400fb6c2aa7$var$mapStateToProps = (state)=>({
        canAccessCustomFilterSettings: (0, $7kNqR.canEditBoardConfig)(state),
        customFiltersSettingsUrl: (0, $9H3i5.getCustomFiltersSettingsUrl)((0, $hkGxG.getProjectKey)(state), (0, $hkGxG.getRapidViewId)(state))
    });
var $874e5400fb6c2aa7$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($874e5400fb6c2aa7$var$mapStateToProps, {})((0, $juKJ0.default));

});
parcelRegister("juKJ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $f03fd684c52c6018$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $82rJa = parcelRequire("82rJa");

var $5JgJ2 = parcelRequire("5JgJ2");

var $idkBG = parcelRequire("idkBG");

var $jMP2a = parcelRequire("jMP2a");

var $37Icb = parcelRequire("37Icb");
const $f03fd684c52c6018$var$CustomFilterFailed = ({ id: id, customFiltersSettingsUrl: customFiltersSettingsUrl, canAccessCustomFilterSettings: canAccessCustomFilterSettings, onDismissed: onDismissed = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const dismissFlag = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        (0, $idkBG.setReturnToProjectUrl)();
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'customFilterFailedFlagLink', {
            canAccessCustomFilterSettings: canAccessCustomFilterSettings
        });
        onDismissed(id);
    }, [
        canAccessCustomFilterSettings,
        id,
        onDismissed
    ]);
    return canAccessCustomFilterSettings ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82rJa.default), {
        id: id,
        onDismissed: onDismissed,
        title: formatMessage((0, $37Icb.default).adminUserTitle),
        description: formatMessage((0, $37Icb.default).adminUserDescription),
        actions: [
            {
                content: formatMessage((0, $37Icb.default).adminUserActionLink),
                href: customFiltersSettingsUrl,
                target: '_blank',
                onClick: dismissFlag
            }
        ]
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82rJa.default), {
        id: id,
        onDismissed: onDismissed,
        title: formatMessage((0, $37Icb.default).endUserTitle),
        description: formatMessage((0, $37Icb.default).endUserDescription),
        actions: [
            {
                content: formatMessage((0, $37Icb.default).endUserActionLink),
                onClick: dismissFlag
            }
        ]
    });
};
var $f03fd684c52c6018$export$2e2bcd8739ae039 = $f03fd684c52c6018$var$CustomFilterFailed;

});
parcelRegister("37Icb", function(module, exports) {

$parcel$export(module.exports, "default", () => $9656fffc3d2366ce$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9656fffc3d2366ce$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    adminUserTitle: {
        "id": "backlog.flags.custom-filter-failed.admin-user-title",
        "defaultMessage": "We couldn't load your filters"
    },
    adminUserDescription: {
        "id": "backlog.flags.custom-filter-failed.admin-user-description",
        "defaultMessage": "One or more of your filters can't be used right now. You can check your filter queries and try again."
    },
    adminUserActionLink: {
        "id": "backlog.flags.custom-filter-failed.admin-user-action-link",
        "defaultMessage": "Manage custom filters"
    },
    endUserTitle: {
        "id": "backlog.flags.custom-filter-failed.end-user-title",
        "defaultMessage": "We couldn't load your filters"
    },
    endUserDescription: {
        "id": "backlog.flags.custom-filter-failed.end-user-description",
        "defaultMessage": "One or more of your filters can't be used right now. Contact your Jira admin to check the filter queries, then try again."
    },
    endUserActionLink: {
        "id": "backlog.flags.custom-filter-failed.end-user-action-link",
        "defaultMessage": "OK"
    }
});

});



parcelRegister("4TzjO", function(module, exports) {

$parcel$export(module.exports, "SplitIssueSuccessFlag", () => $424058c729394580$export$75ae40d8ea21392a);

var $kwce8 = parcelRequire("kwce8");

var $eUqFw = parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");

var $kQ0RL = parcelRequire("kQ0RL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $900Nx = parcelRequire("900Nx");
// eslint-disable-next-line @compiled/no-css-prop-without-css-function, @atlaskit/design-system/consistent-css-prop-usage
const $424058c729394580$var$copiedSuccessStyles = {
    color: `var(--ds-background-success-pressed, ${(0, $PdmhA.G300)})`
};
const $424058c729394580$var$getIssueDiscoveryUrl = (issueKeys)=>{
    if (issueKeys.length > 1) {
        const cardKeys = issueKeys.join(',');
        const jqlSearch = encodeURIComponent(`issueKey in (${cardKeys})`);
        return `/issues/?jql=${jqlSearch}`;
    }
    return `/browse/${issueKeys[0]}`;
};
var $424058c729394580$var$_StyledSpan = /*#__PURE__*/ (0, $kwce8.default)("span").withConfig({
    componentId: "jhvvvj-0"
})`${$424058c729394580$var$copiedSuccessStyles}`;
const $424058c729394580$export$75ae40d8ea21392a = ({ originalIssueKey: originalIssueKey, issueKeys: issueKeys, onDismissed: onDismissed, id: id })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isCopied, setCopied] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        let timeoutId;
        if (isCopied) timeoutId = setTimeout(()=>{
            setCopied(false);
        }, 2000);
        return ()=>{
            timeoutId && clearTimeout(timeoutId);
        };
    }, [
        isCopied
    ]);
    const issueDiscoveryUrl = $424058c729394580$var$getIssueDiscoveryUrl(issueKeys);
    const copyToClipboard = (0, $eUqFw.useCallback)(()=>{
        navigator.clipboard.writeText(`${window.location.origin}${issueDiscoveryUrl}`);
        setCopied(true);
    }, [
        issueDiscoveryUrl
    ]);
    const flagTitle = issueKeys.length > 1 ? formatMessage((0, $900Nx.default).multiplesIssuesCreatedSuccessFlagTitle, {
        issueCount: issueKeys.length
    }) : formatMessage((0, $900Nx.default).createSuccessFlagTitle, {
        issueKey: issueKeys[0]
    });
    const flagDescription = issueKeys.length > 1 ? formatMessage((0, $900Nx.default).multipleIssuesCreatedSuccessFlagDescription, {
        issueKey: originalIssueKey
    }) : formatMessage((0, $900Nx.default).createSuccessFlagDescription, {
        issueKey: originalIssueKey
    });
    const flagActions = [
        {
            content: formatMessage((0, $900Nx.default).viewIssueLinkText, {
                numIssues: issueKeys.length
            }),
            href: issueDiscoveryUrl
        },
        {
            content: isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($424058c729394580$var$_StyledSpan, null, formatMessage((0, $900Nx.default).linkCopied)) : formatMessage((0, $900Nx.default).copyLink),
            onClick: ()=>{
                copyToClipboard();
            }
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.SuccessAutoDismissFlag), {
        id: id,
        onDismissed: onDismissed,
        title: flagTitle,
        description: flagDescription,
        actions: flagActions
    });
};

});
parcelRegister("900Nx", function(module, exports) {

$parcel$export(module.exports, "default", () => $02a82ed3d1cd4cbf$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $02a82ed3d1cd4cbf$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createSuccessFlagTitle: {
        "id": "backlog.flags.split-issue-success.create-success-flag-title",
        "defaultMessage": "You've created issue \"{issueKey}\""
    },
    multiplesIssuesCreatedSuccessFlagTitle: {
        "id": "backlog.flags.split-issue-success.multiples-issues-created-success-flag-title",
        "defaultMessage": "You've created {issueCount, plural, one {# issue} other {# new issues}}"
    },
    createSuccessFlagDescription: {
        "id": "backlog.flags.split-issue-success.create-success-flag-description",
        "defaultMessage": "It's linked to issue \"{issueKey}\"."
    },
    multipleIssuesCreatedSuccessFlagDescription: {
        "id": "backlog.flags.split-issue-success.multiple-issues-created-success-flag-description",
        "defaultMessage": "They're linked to issue \"{issueKey}\"."
    },
    viewIssueLinkText: {
        "id": "backlog.flags.split-issue-success.view-issue-link-text",
        "defaultMessage": "View {numIssues, plural, one {issue} other {issues}}"
    },
    copyLink: {
        "id": "backlog.flags.split-issue-success.copy-link",
        "defaultMessage": "Copy link"
    },
    linkCopied: {
        "id": "backlog.flags.split-issue-success.link-copied",
        "defaultMessage": "Copied"
    }
});

});


parcelRegister("4WG4e", function(module, exports) {

$parcel$export(module.exports, "showSprintStartedFlag", () => $11314f07ff9fb702$export$16e805c83a7e91ec);

var $lIQul = parcelRequire("lIQul");
const $11314f07ff9fb702$export$16e805c83a7e91ec = ()=>({
        type: 'success',
        title: (0, $lIQul.default).sprintStartedTitle,
        description: (0, $lIQul.default).sprintStartedParallelSprintDescription
    });

});
parcelRegister("lIQul", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7b747f33fa4589f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b7b747f33fa4589f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    sprintStartedTitle: {
        "id": "backlog.flags.sprint-started-flag.sprint-started-title",
        "defaultMessage": "Sprint started"
    },
    sprintStartedDescription: {
        "id": "backlog.flags.sprint-started-flag.sprint-started-description",
        "defaultMessage": "We\u2019ve taken you to your team\u2019s sprint board. Good luck team!"
    },
    sprintStartedParallelSprintDescription: {
        "id": "backlog.flags.sprint-started-flag.sprint-started-parallel-sprint-description",
        "defaultMessage": "We\u2019ve filtered the board to show your new sprint. Good luck, team!"
    }
});

});


parcelRegister("6gbQ2", function(module, exports) {

$parcel$export(module.exports, "TransitionAndRankFailureFlag", () => $1e1f9cfd15f27688$export$ecea190680b7bcc);

var $eUqFw = parcelRequire("eUqFw");

var $kQ0RL = parcelRequire("kQ0RL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $9tWIx = parcelRequire("9tWIx");
function $1e1f9cfd15f27688$export$ecea190680b7bcc({ id: id, errorMessages: errorMessages, onDismissed: onDismissed }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.ErrorFlag), {
        id: id,
        title: formatMessage((0, $9tWIx.default).title),
        onDismissed: onDismissed,
        description: errorMessages.join('. ')
    });
}

});
parcelRegister("9tWIx", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4d90b52cd30d7d3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d4d90b52cd30d7d3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "backlog.flags.transition-and-rank-failure.title",
        "defaultMessage": "We couldn't move your card"
    }
});

});



parcelRegister("d6rfk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0f80f7af043fbff$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $1ybV0 = parcelRequire("1ybV0");

var $caTc0 = parcelRequire("caTc0");

var $h43Ao = parcelRequire("h43Ao");

var $8wXFi = parcelRequire("8wXFi");

var $gYiun = parcelRequire("gYiun");

var $oMuSV = parcelRequire("oMuSV");

var $2lmHx = parcelRequire("2lmHx");

var $cWdPU = parcelRequire("cWdPU");

var $9mf83 = parcelRequire("9mf83");

var $3CWrw = parcelRequire("3CWrw");

var $4pvJN = parcelRequire("4pvJN");

var $7336F = parcelRequire("7336F");

var $j4slN = parcelRequire("j4slN");

var $ib32H = parcelRequire("ib32H");

var $1lQFl = parcelRequire("1lQFl");

var $5xnJJ = parcelRequire("5xnJJ");

var $hqsxa = parcelRequire("hqsxa");

var $keRT4 = parcelRequire("keRT4");

var $6Tnvp = parcelRequire("6Tnvp");

var $dSSv4 = parcelRequire("dSSv4");

var $85lg5 = parcelRequire("85lg5");

var $hFYYF = parcelRequire("hFYYF");

var $dPQST = parcelRequire("dPQST");

var $hkpTY = parcelRequire("hkpTY");

var $7Ectt = parcelRequire("7Ectt");

var $cve9o = parcelRequire("cve9o");

var $c5ZkM = parcelRequire("c5ZkM");

var $5OvhQ = parcelRequire("5OvhQ");

var $3K60I = parcelRequire("3K60I");

var $73Buo = parcelRequire("73Buo");

var $h8d37 = parcelRequire("h8d37");

var $2rJcn = parcelRequire("2rJcn");

var $9NOwm = parcelRequire("9NOwm");

var $a4X60 = parcelRequire("a4X60");

var $ixnoC = parcelRequire("ixnoC");

var $7lCIO = parcelRequire("7lCIO");

var $5W47q = parcelRequire("5W47q");

var $c1oku = parcelRequire("c1oku");

var $lpGAK = parcelRequire("lpGAK");

var $g1Auf = parcelRequire("g1Auf");

var $2mfJC = parcelRequire("2mfJC");

var $71I3R = parcelRequire("71I3R");

var $fdugg = parcelRequire("fdugg");

var $48X9m = parcelRequire("48X9m");

var $fVGud = parcelRequire("fVGud");

var $bJQJr = parcelRequire("bJQJr");

var $dIb9y = parcelRequire("dIb9y");

var $hXqpd = parcelRequire("hXqpd");

var $7Ceyg = parcelRequire("7Ceyg");

var $6ObTx = parcelRequire("6ObTx");

var $j7n3h = parcelRequire("j7n3h");

var $esmDo = parcelRequire("esmDo");

var $d8IAt = parcelRequire("d8IAt");

var $6V0Mk = parcelRequire("6V0Mk");

var $f1grZ = parcelRequire("f1grZ");

var $7UnyG = parcelRequire("7UnyG");

var $9igNA = parcelRequire("9igNA");

var $75fux = parcelRequire("75fux");

var $lnycy = parcelRequire("lnycy");
const $d0f80f7af043fbff$var$createRootEpic = (isServer, isCompanyManaged, getLocation, push, replace, // eslint-disable-next-line @typescript-eslint/no-explicit-any
swagClient)=>{
    const withUifCmpKillSwitch = (0, $h43Ao.withKillSwitch)(isCompanyManaged);
    const withMentionsIndicatorExperimentKillSwitch = (0, $h43Ao.withKillSwitch)((0, $caTc0.isInMentionsIndicatorExperimentCohort)());
    const withAddPeopleButtonOpenTMPExperimentKillSwitch = (0, $h43Ao.withKillSwitch)((0, $8wXFi.isInAddPeopleButtonOpenTMPExperimentCohort)());
    const withIssueTypeInContextExperimentKillSwitch = (0, $h43Ao.withKillSwitch)((0, $8wXFi.isIssueTypeInContextExperimentEnabled), !isCompanyManaged);
    const clientEpics = isServer ? [] : [
        (0, $ixnoC.issueViewUpdateEpic),
        (0, $hXqpd.postLoadCleanDataEpic),
        (0, $6V0Mk.sprintCreateEpic),
        (0, $f1grZ.sprintDeleteEpic),
        (0, $7UnyG.sprintMoveEpic),
        (0, $a4X60.filteredCardsEpic),
        (0, $hFYYF.beforeMoveCardsEpic),
        (0, $dPQST.cardsMoveRequestEpic),
        (0, $3CWrw.cardClickEpic)(getLocation, push),
        (0, $dIb9y.selectIssueParentEpic)(getLocation, push),
        (0, $85lg5.cardsFlagWithCommentEpic),
        (0, $7Ectt.default),
        (0, $7336F.cardDeleteEpic)(getLocation, push),
        (0, $hqsxa.cardRefreshEpic),
        (0, $ib32H.cardListToggleEpic),
        (0, $1lQFl.cardPostCreateEpic),
        (0, $hkpTY.cardsNavigateEpic),
        (0, $5OvhQ.detailViewCloseEpic)(getLocation, push),
        (0, $73Buo.detailViewUpdateEpic),
        (0, $3K60I.detailViewOpenDebouncedEpic)(getLocation, push),
        (0, $9NOwm.filterValidValuesEpic)(getLocation, push),
        (0, $d8IAt.default)(getLocation, push, isCompanyManaged),
        // This still needs to be loaded because the critical query is not loaded in CMP
        // which holds the other user data.
        (0, $g1Auf.loadCurrentUserEpic),
        ...withMentionsIndicatorExperimentKillSwitch([
            (0, $71I3R.loadMentionsEpic),
            (0, $c5ZkM.clearMentionsEpic)
        ]),
        (0, $h43Ao.withSwitch)(isCompanyManaged)((0, $lpGAK.loadConfigDataEpicCmp), (0, $c1oku.loadConfigDataEpic)),
        ...withUifCmpKillSwitch([
            (0, $fdugg.loadPermissionsEpic),
            (0, $2mfJC.loadIssueParentsEpic),
            (0, $5W47q.loadCardCreateConfigEpic),
            (0, $h8d37.refetchEpicPanelEpic),
            (0, $j4slN.cardGroupToggleEpic),
            (0, $5xnJJ.cardRankAfterGlobalIssueCreateEpic),
            (0, $lnycy.workloadModalSubtaskToggleEpic)
        ]),
        (0, $gYiun.default),
        (0, $j7n3h.refreshDataEpic),
        ...withIssueTypeInContextExperimentKillSwitch([
            (0, $esmDo.refreshDataAddIssueTypeEpic)
        ]),
        (0, $7Ceyg.realtimeEventProcessEpic),
        (0, $2rJcn.default),
        (0, $cWdPU.buildAssignToMeEpic)(swagClient),
        (0, $75fux.refreshBacklog)(),
        (0, $cWdPU.cardAssignToMeThrottledEpic),
        (0, $6Tnvp.default),
        (0, $keRT4.default),
        (0, $cve9o.checkGlobalIssueCreateEpic),
        (0, $4pvJN.cardCreateMultipleGqlEpic),
        (0, $bJQJr.onTogglePanelEpic)(getLocation, replace),
        (0, $bJQJr.onCloseInsightsEpic)(getLocation, replace),
        ...(0, $h43Ao.withKillSwitch)(!isCompanyManaged)([
            (0, $fdugg.loadPermissionsEpic)
        ]),
        ...(0, $1ybV0.ff)('priorities.per.project.backlog-contextual-menu') ? [
            (0, $fVGud.loadPrioritiesEpic)
        ] : [
            (0, $fVGud.oldLoadPrioritiesEpic)
        ],
        (0, $oMuSV.default),
        (0, $6ObTx.refetchVersionsEpic),
        (0, $dSSv4.cardsBulkOperationsFailureEpic),
        ...(0, $h43Ao.withKillSwitch)(isCompanyManaged)([
            (0, $dSSv4.cardsBulkOperationsSuccessEpicCmp)
        ]),
        (0, $9mf83.cardAutoScrollOnFilterEpic),
        ...withAddPeopleButtonOpenTMPExperimentKillSwitch([
            (0, $2lmHx.getCanUserInviteEpic)
        ]),
        ...(0, $h43Ao.withKillSwitch)(()=>(0, $1ybV0.ff)('sprint_planning_whiteboards_kill_switch', false))([
            (0, $9igNA.loadWhiteboardsEntrypointExperimentEpic)
        ])
    ];
    const loadEpic = (0, $h43Ao.withSwitch)(isCompanyManaged)((0, $48X9m.loadPlanDataEpic), (0, $7lCIO.loadAgilityGraphqlDataEpic));
    return (0, $bd1K7.combineEpics)(loadEpic, ...clientEpics);
};
var $d0f80f7af043fbff$export$2e2bcd8739ae039 = $d0f80f7af043fbff$var$createRootEpic;

});
parcelRegister("caTc0", function(module, exports) {

$parcel$export(module.exports, "isInMentionsIndicatorExperimentCohort", () => $09e2035ec940dd58$export$4d1c47e616b7a5fb);

var $79xbN = parcelRequire("79xbN");
function $09e2035ec940dd58$export$4d1c47e616b7a5fb() {
    return (0, $79xbN.expValEquals)('mentions_in_board_and_backlog_ver_2', 'cohort', 'test');
}

});

parcelRegister("h43Ao", function(module, exports) {

$parcel$export(module.exports, "withSwitch", () => $9c865954f7f14d48$export$645938e27cb11e4e);
$parcel$export(module.exports, "withKillSwitch", () => $9c865954f7f14d48$export$2a43929f73f32330);
$parcel$export(module.exports, "fromRelayObservable", () => $9c865954f7f14d48$export$b57c7b401625b0df);
parcelRequire("8OtG5");

var $3JafE = parcelRequire("3JafE");
function $9c865954f7f14d48$var$executePredicate(predicate) {
    if (predicate !== null && typeof predicate === 'function') return predicate();
    if (predicate !== null && typeof predicate === 'boolean') return predicate;
    return false;
}
const $9c865954f7f14d48$export$645938e27cb11e4e = (...predicates)=>(matchedPredicateEpic, unmatchedPredicateEpic)=>(action$, store, dependencies)=>predicates.every($9c865954f7f14d48$var$executePredicate) ? matchedPredicateEpic(action$, store, dependencies) : unmatchedPredicateEpic(action$, store, dependencies);
const $9c865954f7f14d48$export$2a43929f73f32330 = (...predicates)=>(epics)=>epics.map((epic)=>(action$, store, dependencies)=>epic(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                action$.filter(()=>predicates.every($9c865954f7f14d48$var$executePredicate)), store, dependencies));
const $9c865954f7f14d48$export$b57c7b401625b0df = (create)=>(0, $3JafE.Observable).create((sink)=>{
        const subscription = create().subscribe(sink);
        return ()=>subscription.unsubscribe();
    });

});

parcelRegister("gYiun", function(module, exports) {

$parcel$export(module.exports, "default", () => $aefede56c838c359$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $3UJA3 = parcelRequire("3UJA3");

var $eBWYx = parcelRequire("eBWYx");
var // @ts-expect-error - TS2769: Type 'void' is not assignable to type 'BoardIssueMoveShowAction'.
$aefede56c838c359$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $3UJA3.default), (0, $eBWYx.default));

});
parcelRegister("3UJA3", function(module, exports) {

$parcel$export(module.exports, "default", () => $57b0f575e55c7b7f$export$2e2bcd8739ae039);

var $3JafE = parcelRequire("3JafE");
parcelRequire("8jBvP");
parcelRequire("jyKN9");
parcelRequire("iects");
parcelRequire("jnCPY");
parcelRequire("3wBUP");

var $6Z5ag = parcelRequire("6Z5ag");

var $jiL2Q = parcelRequire("jiL2Q");

var $jgHdr = parcelRequire("jgHdr");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$57b0f575e55c7b7f$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $jiL2Q.SET_APP_DATA)).take(1).switchMap(()=>(0, $6Z5ag.shouldDisplayDialog)(store.getState()).flatMap((shouldDisplay)=>shouldDisplay ? (0, $3JafE.Observable).of((0, $jgHdr.boardIssueMoveShow)()) : (0, $3JafE.Observable).empty()));

});
parcelRegister("6Z5ag", function(module, exports) {

$parcel$export(module.exports, "shouldDisplayDialog", () => $bdd9b2870dc3bb9a$export$fd02a046fd38bde);
$parcel$export(module.exports, "dismissDialog", () => $bdd9b2870dc3bb9a$export$581c7e9b587e8156);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("fiQ2m");

var $lGXzu = parcelRequire("lGXzu");

var $hkGxG = parcelRequire("hkGxG");

var $8RiAU = parcelRequire("8RiAU");

var $7kNqR = parcelRequire("7kNqR");

var $dtV8v = parcelRequire("dtV8v");
const $bdd9b2870dc3bb9a$var$shouldCheckForDialog = (state)=>{
    const canEdit = (0, $7kNqR.canEditBoardConfig)(state);
    const isAlreadyOpen = (0, $8RiAU.isDialogOpen)(state);
    const isSprintsEnabled = (0, $dtV8v.isBacklogWithSprints)(state);
    return canEdit && !isAlreadyOpen && !isSprintsEnabled;
};
const $bdd9b2870dc3bb9a$export$fd02a046fd38bde = (state)=>{
    if ($bdd9b2870dc3bb9a$var$shouldCheckForDialog(state)) return (0, $3JafE.Observable).of((0, $hkGxG.getRequestColumnMigration)(state));
    return (0, $3JafE.Observable).of(false);
};
const $bdd9b2870dc3bb9a$export$581c7e9b587e8156 = (state)=>{
    const rapidViewId = (0, $hkGxG.getRapidViewId)(state);
    const baseUrl = (0, $hkGxG.getBaseUrl)(state);
    return (0, $lGXzu.dismissMigrationModal)(baseUrl, rapidViewId).ignoreElements();
};

});
parcelRegister("lGXzu", function(module, exports) {

$parcel$export(module.exports, "dismissMigrationModal", () => $56cb1c31831a2317$export$e05baac531611192);

var $aX5if = parcelRequire("aX5if");
var $igbrt = parcelRequire("igbrt");
const $56cb1c31831a2317$export$716b4280dda478e9 = 'DismissFirstColumnMigrationModalBacklog';
const $56cb1c31831a2317$export$19a8cfc9fd174c1c = (0, $aX5if.gqlTagSwag)`
    mutation DismissFirstColumnMigrationModalBacklog($boardId: ID!) {
        dismissFirstColumnMigrationModal(input: {boardId: $boardId}) {
            boardScope {
                id
            }
        }
    }
`;
const $56cb1c31831a2317$export$e05baac531611192 = (baseUrl, boardId)=>(0, $igbrt.mutation$)(baseUrl, $56cb1c31831a2317$export$716b4280dda478e9, $56cb1c31831a2317$export$19a8cfc9fd174c1c, {
        boardId: boardId
    });

});
parcelRegister("aX5if", function(module, exports) {

$parcel$export(module.exports, "gqlTagSwag", () => $f67079231446a778$export$c4eea1172a449e1a);

var $ejLgE = parcelRequire("ejLgE");

var $hr2LF = parcelRequire("hr2LF");

var $2emZ8 = parcelRequire("2emZ8");

var $igbrt = parcelRequire("igbrt");

var $jy01K = parcelRequire("jy01K");

var $R1ugb = parcelRequire("R1ugb");

var $eeJ3R = parcelRequire("eeJ3R");
const $f67079231446a778$export$c4eea1172a449e1a = (0, $ejLgE.gqlTagRest);

});
parcelRegister("ejLgE", function(module, exports) {

$parcel$export(module.exports, "gqlTagRest", () => $8d34ae4c307c0700$export$ecc155df19ba52ff);
/**
 * This file is to define tags for GraphQL queries to be identified
 * by https://github.com/apollographql/eslint-plugin-graphql
 * It returns the full query string for template literals
 */ const $8d34ae4c307c0700$export$ecc155df19ba52ff = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};

});

parcelRegister("igbrt", function(module, exports) {

$parcel$export(module.exports, "mutation$", () => $1de19c187c622568$export$3c168c5a8b47d553);

var $f9vw0 = parcelRequire("f9vw0");
const $1de19c187c622568$export$3c168c5a8b47d553 = (baseUrl, operationName, query, variables, analyticOptions)=>(0, $f9vw0.operation$)('mutation', baseUrl, operationName, query, variables, analyticOptions);

});
parcelRegister("f9vw0", function(module, exports) {

$parcel$export(module.exports, "operation$", () => $82c90398c8cfb5df$export$cbc7c612df05bda);
parcelRequire("jyKN9");
parcelRequire("bI4RP");
parcelRequire("kO85v");
parcelRequire("l5lul");
parcelRequire("1Lcr1");
parcelRequire("iects");

var $illlw = parcelRequire("illlw");

var $dbogu = parcelRequire("dbogu");

var $3JafE = parcelRequire("3JafE");

var $hompL = parcelRequire("hompL");

var $lNfG4 = parcelRequire("lNfG4");

var $gUUjF = parcelRequire("gUUjF");

var $iH6c1 = parcelRequire("iH6c1");

var $aiRd8 = parcelRequire("aiRd8");

var $88Osm = parcelRequire("88Osm");

var $5zSUY = parcelRequire("5zSUY");

var $3FyZ4 = parcelRequire("3FyZ4");

var $R1ugb = parcelRequire("R1ugb");

var $eeJ3R = parcelRequire("eeJ3R");
const $82c90398c8cfb5df$var$sendOperationalEvent = (analyticKey, statusCode)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        // SSR doesn't have an analytics client
        if (!analyticsClient) return;
        let statusCodeFamily = 'unknown';
        if (statusCode !== null) {
            const statusCodeAsStr = String(statusCode);
            if (statusCodeAsStr === '0' || statusCodeAsStr === '429') // special status codes
            statusCodeFamily = statusCodeAsStr;
            else if (statusCodeAsStr.match(/^[12345][0-9]{2}$/)) statusCodeFamily = `${statusCodeAsStr[0]}xx`;
        }
        analyticsClient.sendOperationalEvent({
            action: 'fetch',
            actionSubject: 'swag operation',
            attributes: {
                key: analyticKey,
                statusCode: statusCode,
                statusCodeFamily: statusCodeFamily
            },
            source: 'swagOperation'
        });
    });
};
const $82c90398c8cfb5df$var$onErrorSendOpEventAndCancelMark = (analyticKey, slo, statusCode, concurrentId, // eslint-disable-next-line @typescript-eslint/no-explicit-any
bm3Interaction)=>{
    if (analyticKey !== undefined) {
        // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        $82c90398c8cfb5df$var$sendOperationalEvent(analyticKey, statusCode);
        if (bm3Interaction) bm3Interaction.cancel();
    }
};
const $82c90398c8cfb5df$var$callSwag$ = ({ baseUrl: baseUrl, operationName: operationName, query: query, variables: variables, action: action, headersProcessor: headersProcessor })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let headers = {};
    // set empty xsrfToken for SSR as cookies are unavailable
    const xsrfToken = false ? '' : (0, $5zSUY.default)();
    if (action === 'mutation') {
        if (!xsrfToken) (0, $gUUjF.default).safeErrorWithoutCustomerData('board.xsrf-token.load.failure', 'XSRF Token failed to load');
        headers = {
            'atl-xsrf-token': xsrfToken
        };
    }
    return (0, $aiRd8.default)(`${baseUrl}/jsw2/graphql?operation=${operationName}`, {
        method: 'POST',
        body: JSON.stringify({
            operationName: operationName,
            query: query,
            variables: variables
        }),
        headers: headers,
        headersProcessor: headersProcessor
    });
};
const $82c90398c8cfb5df$export$cbc7c612df05bda = (action, baseUrl, operationName, query, variables, analyticOptions)=>{
    const { analyticKey: analyticKey, slo: slo, useBm3Interaction: useBm3Interaction, concurrentMetricDefinition: concurrentMetricDefinition } = analyticOptions || {};
    let traceId = '';
    const headersProcessor = (headers)=>{
        traceId = headers.get((0, $88Osm.TRACE_ID_HEADER)) || '';
    };
    const concurrentId = (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4();
    let bm3Interaction = null;
    if (analyticKey && useBm3Interaction) bm3Interaction = (0, $lNfG4.metrics).interaction({
        key: analyticKey,
        // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
        histogram: {
            result: '1000_2000_3000_4000_5000_6000'
        }
    });
    return (0, $3JafE.Observable).defer(()=>{
        if (bm3Interaction) bm3Interaction.start();
        if (concurrentMetricDefinition !== undefined) concurrentMetricDefinition(concurrentId).start();
        return $82c90398c8cfb5df$var$callSwag$({
            baseUrl: baseUrl,
            operationName: operationName,
            query: query,
            variables: variables,
            action: action,
            headersProcessor: headersProcessor
        });
    }).catch((error)=>{
        const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
            'statusCode'
        ], null);
        const isRetryStatusCode = [
            502,
            503,
            504
        ].includes(Number(statusCode));
        if (isRetryStatusCode && action === 'query') return $82c90398c8cfb5df$var$callSwag$({
            baseUrl: baseUrl,
            operationName: operationName,
            query: query,
            variables: variables,
            action: action,
            headersProcessor: headersProcessor
        }).do(()=>{
            (0, $eeJ3R.logRestRetry)({
                queryName: operationName,
                statusCode: statusCode,
                isRetrySuccessful: true,
                retryStatusCode: null
            });
        }, (retryError)=>{
            const retryStatusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(retryError, [
                'statusCode'
            ], null);
            (0, $eeJ3R.logRestRetry)({
                queryName: operationName,
                statusCode: statusCode,
                isRetrySuccessful: false,
                retryStatusCode: retryStatusCode
            });
        });
        // throw exception to the next level
        return (0, $3JafE.Observable).throw(error);
    })// catch network error
    .catch((error)=>{
        const e = (0, (/*@__PURE__*/$parcel$interopDefault($dbogu)))(error) ? error.message : `[unknown error] = ${JSON.stringify(error)}`;
        const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
            'statusCode'
        ], null);
        const errorName = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
            'name'
        ], null);
        const swagError = new (0, $R1ugb.SwagError)({
            networkError: error,
            traceId: traceId
        });
        const hash = (0, $iH6c1.getErrorHash)(swagError);
        (0, $eeJ3R.logRestNetworkError)(e, statusCode, operationName, errorName, hash);
        $82c90398c8cfb5df$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, statusCode, concurrentId, bm3Interaction);
        return (0, $3JafE.Observable).throw(swagError);
    }).flatMap((response)=>{
        if (!response || !response.data) (0, $eeJ3R.logRestParsingError)('empty response.data', operationName);
        try {
            // SWAG errors from response
            if (response.errors) {
                const payload = response.errors.map((e)=>{
                    const { path: path, message: message } = e;
                    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(e, [
                        'extensions',
                        'statusCode'
                    ], null);
                    const errorType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(e, [
                        'extensions',
                        'errorType'
                    ], undefined);
                    const userMessage = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(e, [
                        'extensions',
                        'userMessage'
                    ], undefined);
                    (0, $eeJ3R.logRestError)(path, statusCode, operationName, errorType);
                    $82c90398c8cfb5df$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, statusCode, concurrentId, bm3Interaction);
                    return {
                        message: message,
                        path: path,
                        extensions: {
                            statusCode: statusCode ? Number(statusCode) : null,
                            errorType: errorType,
                            userMessage: userMessage
                        }
                    };
                });
                return (0, $3JafE.Observable).throw(new (0, $R1ugb.SwagError)({
                    graphQLErrors: payload,
                    traceId: traceId
                }));
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const e = (0, (/*@__PURE__*/$parcel$interopDefault($dbogu)))(error) ? error.message : `[unknown error] = ${JSON.stringify(error)}`;
            (0, $eeJ3R.logRestParsingError)(e, operationName);
            $82c90398c8cfb5df$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, 'unknown', concurrentId, bm3Interaction);
            throw error;
        }
        if (analyticKey !== undefined) {
            // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Response<Data>'.
            $82c90398c8cfb5df$var$sendOperationalEvent(analyticKey, response.statusCode ?? '200');
            if (bm3Interaction) bm3Interaction.stop();
            if (concurrentMetricDefinition !== undefined) concurrentMetricDefinition(concurrentId).stop();
        }
        return (0, $3JafE.Observable).of(response.data);
    });
};

});
parcelRegister("dbogu", function(module, exports) {

var $2OY5s = parcelRequire("2OY5s");

var $hYEMs = parcelRequire("hYEMs");

var $jtsd5 = parcelRequire("jtsd5");
/** `Object#toString` result references. */ var $998f1ff604abccc1$var$domExcTag = '[object DOMException]', $998f1ff604abccc1$var$errorTag = '[object Error]';
/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */ function $998f1ff604abccc1$var$isError(value) {
    if (!$hYEMs(value)) return false;
    var tag = $2OY5s(value);
    return tag == $998f1ff604abccc1$var$errorTag || tag == $998f1ff604abccc1$var$domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !$jtsd5(value);
}
module.exports = $998f1ff604abccc1$var$isError;

});

parcelRegister("aiRd8", function(module, exports) {

$parcel$export(module.exports, "default", () => $6464cf3e92eca984$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("1Lcr1");
parcelRequire("8OtG5");
parcelRequire("flmol");
parcelRequire("iects");

var $fVqUX = parcelRequire("fVqUX");

var $6iz4v = parcelRequire("6iz4v");

var $88Osm = parcelRequire("88Osm");

var $7byHA = parcelRequire("7byHA");

var $etaBp = parcelRequire("etaBp");
const $6464cf3e92eca984$var$noContentStatus = 204;
const $6464cf3e92eca984$var$transformUrl = (url)=>{
    const lUrl = url.replace(/\//g, '_');
    const resUrl = lUrl.substr(0, lUrl.indexOf('?') > -1 ? lUrl.indexOf('?') : lUrl.length);
    return resUrl;
};
// This function returns a JSON stream which emits a single JSON value on success, and throws
// an error on failure
// Pass the perf object in the options in order to enable performance analytics for your request
// fetchJson$ = ('some url', { perf: { key: 'analytics_key', prefix: 'analytics_prefix' } })
// Pass the headersProcessor in the options to provide a callback function which can respond on headers.
function $6464cf3e92eca984$var$fetchJson$(url, options = {}) {
    const { perf: perf, headersProcessor: headersProcessor, ...opts } = options;
    let key;
    const isPerformanceCheckEnabled = !!perf;
    if (isPerformanceCheckEnabled) {
        const mark = `REST${$6464cf3e92eca984$var$transformUrl(url)}`;
        key = perf && `${perf.prefix != null && perf.prefix !== '' ? `${perf.prefix}_` : ''}${perf.key}` || mark;
        (0, $6iz4v.setMark)(`BEGIN_${key}`);
    }
    return (0, $3JafE.Observable).of(url).mergeMap(()=>fetch(url, (0, $6HC1D.merge)((0, $6HC1D.merge)((0, $fVqUX.default), opts), (0, $etaBp.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (isPerformanceCheckEnabled) (0, $6iz4v.setMark)(`END_${key}`);
        if (!response.ok) {
            const { status: status } = response;
            return response.text().then((str)=>{
                const traceId = response.headers.get((0, $88Osm.TRACE_ID_HEADER));
                if (traceId != null && traceId !== '') throw new (0, $7byHA.default)(status, str, traceId);
                else throw new (0, $7byHA.default)(status, str);
            });
        }
        if (typeof headersProcessor === 'function') headersProcessor(response.headers);
        if (response.status === $6464cf3e92eca984$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $3JafE.Observable).of(null);
        return response.json();
    });
}
var $6464cf3e92eca984$export$2e2bcd8739ae039 = $6464cf3e92eca984$var$fetchJson$;

});



parcelRegister("jy01K", function(module, exports) {

$parcel$export(module.exports, "query$", () => $974ed7d64c30acc8$export$a332dd84c3221bf2);

var $f9vw0 = parcelRequire("f9vw0");
const $974ed7d64c30acc8$export$a332dd84c3221bf2 = (baseUrl, operationName, query, variables, analyticOptions)=>(0, $f9vw0.operation$)('query', baseUrl, operationName, query, variables, analyticOptions);

});



parcelRegister("8RiAU", function(module, exports) {

$parcel$export(module.exports, "isDialogOpen", () => $676f392d4f1197cf$export$61d407d1c7ec6926);
const $676f392d4f1197cf$export$61d407d1c7ec6926 = (state)=>state.ui.boardIssueMoveDialog.isOpen;

});

parcelRegister("dtV8v", function(module, exports) {

$parcel$export(module.exports, "makeGetSprintEstimations", () => $736dd8f43d7babf2$export$36e03197e8c5fd07);
$parcel$export(module.exports, "makeIsCardListActiveSprint", () => $736dd8f43d7babf2$export$5ce180897302be5f);
$parcel$export(module.exports, "makeIsSprintCardList", () => $736dd8f43d7babf2$export$560f07fa8255aee3);
$parcel$export(module.exports, "getAllSprints", () => $736dd8f43d7babf2$export$60a2c24a37c53cfb);
$parcel$export(module.exports, "makeGetOtherOrderedSprints", () => $736dd8f43d7babf2$export$7ac571a2238dcc12);
$parcel$export(module.exports, "makeGetNextSprintId", () => $736dd8f43d7babf2$export$b6b936656317fb38);
$parcel$export(module.exports, "makeGetPreviousNotStartedSprintId", () => $736dd8f43d7babf2$export$a192949a255d1997);
$parcel$export(module.exports, "getFirstInactiveSprintId", () => $736dd8f43d7babf2$export$e5a3f72422855e02);
$parcel$export(module.exports, "getLastInactiveSprintId", () => $736dd8f43d7babf2$export$d38a80f79acac8b8);
$parcel$export(module.exports, "isBacklogWithSprints", () => $736dd8f43d7babf2$export$5a6d0e1cb58a7ee5);
$parcel$export(module.exports, "makeIsSprintMenuVisible", () => $736dd8f43d7babf2$export$c30c507815cb669f);
$parcel$export(module.exports, "makeIsStartSprintVisible", () => $736dd8f43d7babf2$export$b617a44e0fda9735);
$parcel$export(module.exports, "makeIsCreateSprintVisible", () => $736dd8f43d7babf2$export$fd48a9e7d9ffc297);
$parcel$export(module.exports, "makeIsStartSprintEnabled", () => $736dd8f43d7babf2$export$35ab6d7577f201a3);
$parcel$export(module.exports, "makeIsCompleteSprintVisible", () => $736dd8f43d7babf2$export$b447779f07c42b51);
$parcel$export(module.exports, "makeIsAddSprintDatesButtonVisible", () => $736dd8f43d7babf2$export$47615c8fc3c602b6);

var $df4Sl = parcelRequire("df4Sl");

var $jqvCZ = parcelRequire("jqvCZ");

var $3l6tm = parcelRequire("3l6tm");

var $7TyGu = parcelRequire("7TyGu");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $1ircG = parcelRequire("1ircG");

var $7kNqR = parcelRequire("7kNqR");

var $5ceEB = parcelRequire("5ceEB");
const $736dd8f43d7babf2$export$36e03197e8c5fd07 = (0, $df4Sl.createSelector)([
    (0, $bP7Jx.makeOrderedVisibleCardsForCardList),
    (0, $5ceEB.getInitialStatusIds),
    (0, $5ceEB.getResolutionDoneStatusIds),
    (0, $1ircG.getEstimationType),
    (0, $hkGxG.isCmpKanbanProject)
], (getOrderedVisibleCardsForCardList, initialStatusIds, resolutionDoneStatusIds, estimationType, isCmpKanban)=>{
    const getSprintEstimations = (cardListId)=>{
        let list = getOrderedVisibleCardsForCardList(cardListId);
        if (!isCmpKanban) list = list.filter((card)=>!(0, $3l6tm.isSubtaskHierarchyLevel)(card.typeHierarchyLevel));
        const estimations = {
            NOT_STARTED: 0,
            IN_PROGRESS: 0,
            DONE: 0
        };
        list.forEach((card)=>{
            const incrementTypes = Object.freeze({
                [(0, $7TyGu.ORIGINAL_ESTIMATE)]: card.estimate?.originalEstimate?.value || 0,
                [(0, $7TyGu.STORY_POINTS)]: card.estimate?.storyPoints || 0,
                [(0, $7TyGu.ISSUE_COUNT)]: 1
            });
            const increment = incrementTypes[estimationType] || 0;
            if (initialStatusIds.includes(card.statusId)) estimations.NOT_STARTED += increment;
            else if (resolutionDoneStatusIds.includes(card.statusId)) estimations.DONE += increment;
            else estimations.IN_PROGRESS += increment;
        });
        return estimations;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))(getSprintEstimations);
});
const $736dd8f43d7babf2$export$5ce180897302be5f = (0, $df4Sl.createSelector)([
    (0, $bP7Jx.getCardLists)
], (cardLists)=>{
    const isCardListActiveSprint = (cardListId)=>Boolean(cardLists[cardListId]?.type === (0, $7TyGu.SPRINT) && cardLists[cardListId]?.sprintData?.state === 'ACTIVE');
    return isCardListActiveSprint;
});
const $736dd8f43d7babf2$export$548ce523ca2b9fc0 = (0, $df4Sl.createSelector)([
    (0, $bP7Jx.getCardLists)
], (cardLists)=>{
    const isCardListFutureSprint = (cardListId)=>Boolean(cardLists[cardListId]?.type === (0, $7TyGu.SPRINT) && cardLists[cardListId]?.sprintData?.state === 'FUTURE');
    return isCardListFutureSprint;
});
const $736dd8f43d7babf2$export$560f07fa8255aee3 = (0, $df4Sl.createSelector)([
    (0, $bP7Jx.getCardLists)
], (cardLists)=>(cardListId)=>Boolean(cardLists && cardLists[cardListId]?.type === (0, $7TyGu.SPRINT)));
const $736dd8f43d7babf2$export$3df6198cde5435f9 = (state, sprintId)=>(0, $bP7Jx.getCardLists)(state)[String(sprintId)].name;
const $736dd8f43d7babf2$export$4402d4ed26f26131 = (state, sprintId)=>(0, $bP7Jx.getCardLists)(state)[String(sprintId)].sprintData || null;
const $736dd8f43d7babf2$export$60a2c24a37c53cfb = (0, $df4Sl.createSelector)([
    (0, $bP7Jx.getVisibleCardListIds),
    (0, $bP7Jx.getCardLists)
], (cardListIds, cardLists)=>cardListIds.map((cardListId)=>cardLists[cardListId]).filter((cardList)=>cardList.type === (0, $7TyGu.SPRINT)));
const $736dd8f43d7babf2$export$7ac571a2238dcc12 = (0, $df4Sl.createSelector)([
    (0, $bP7Jx.getVisibleCardListIds),
    (0, $bP7Jx.getCardLists)
], (cardListIds, cardLists)=>{
    const getOtherOrderedSprints = (id)=>cardListIds.map((cardListId)=>cardLists[cardListId]).filter((cardList)=>cardList.type === (0, $7TyGu.SPRINT) && cardList.id !== id);
    return (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))(getOtherOrderedSprints);
});
const $736dd8f43d7babf2$export$b6b936656317fb38 = (0, $df4Sl.createSelector)([
    (0, $bP7Jx.getVisibleCardListIds)
], (cardListIds)=>{
    const getNextSprintId = (sprintId)=>{
        const index = cardListIds.indexOf(sprintId);
        const nextCardListIndex = index + 1;
        if (index === -1 || index === cardListIds.length - 1 || cardListIds[nextCardListIndex] === (0, $7TyGu.BACKLOG)) return null;
        return cardListIds[nextCardListIndex];
    };
    return getNextSprintId;
});
const $736dd8f43d7babf2$export$a192949a255d1997 = (0, $df4Sl.createSelector)([
    (0, $bP7Jx.getVisibleCardListIds),
    (0, $bP7Jx.getCardLists)
], (cardListIds, cardLists)=>{
    const getPrevNotStartedSprintId = (sprintId)=>{
        const index = cardListIds.indexOf(sprintId);
        const previousCardListIndex = index - 1;
        const previousCardListId = cardListIds[previousCardListIndex];
        if (index === -1 || index === 0 || cardLists[previousCardListId].type !== (0, $7TyGu.SPRINT) || !cardLists[previousCardListId].sprintData || // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2532 - Object is possibly 'undefined'.
        cardLists[previousCardListId].sprintData.state !== 'FUTURE') return null;
        return previousCardListId;
    };
    return getPrevNotStartedSprintId;
});
const $736dd8f43d7babf2$export$e5a3f72422855e02 = (0, $df4Sl.createSelector)([
    (0, $bP7Jx.getCardLists),
    (0, $bP7Jx.getVisibleCardListIds)
], (cardLists, ids)=>ids.filter((id)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const card = cardLists[id];
        return card.type === (0, $7TyGu.SPRINT) && card.sprintData?.state === 'FUTURE';
    })[0]);
const $736dd8f43d7babf2$export$d38a80f79acac8b8 = (0, $df4Sl.createSelector)([
    (0, $bP7Jx.getCardLists),
    (0, $bP7Jx.getVisibleCardListIds)
], (cardLists, ids)=>{
    const unscheduledSprints = ids.filter((id)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const card = cardLists[id];
        return card.type === (0, $7TyGu.SPRINT) && card.sprintData?.state === 'FUTURE';
    });
    return unscheduledSprints[unscheduledSprints.length - 1];
});
const $736dd8f43d7babf2$export$d0747858fa55f115 = (0, $df4Sl.createSelector)([
    (0, $bP7Jx.getCardLists)
], (cardLists)=>{
    const getCanEditSprint = (id)=>Boolean(cardLists[id] && cardLists[id].type === (0, $7TyGu.SPRINT) && cardLists[id].sprintData && // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2532 - Object is possibly 'undefined'.
        cardLists[id].sprintData.canUpdateSprint);
    return getCanEditSprint;
});
const $736dd8f43d7babf2$export$a0cc63864a6ae856 = (0, $df4Sl.createSelector)([
    (0, $bP7Jx.getCardLists)
], (cardLists)=>{
    const getSprintById = (id)=>// @ts-expect-error - TS2322 - Type 'Sprint | null | undefined' is not assignable to type 'Sprint | null'. | TS2532 - Object is possibly 'undefined'. | TS2532 - Object is possibly 'undefined'.
        cardLists[id] && cardLists[id].sprintData ? cardLists[id].sprintData : null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))(getSprintById);
});
const $736dd8f43d7babf2$export$5a6d0e1cb58a7ee5 = (0, $df4Sl.createSelector)([
    (0, $hkGxG.getBacklogStrategy)
], (backlogStrategy)=>backlogStrategy === (0, $7TyGu.SPRINT));
const $736dd8f43d7babf2$export$c30c507815cb669f = (0, $df4Sl.createSelector)([
    $736dd8f43d7babf2$export$5a6d0e1cb58a7ee5,
    $736dd8f43d7babf2$export$a0cc63864a6ae856,
    $736dd8f43d7babf2$export$d0747858fa55f115
], (areSprintsEnabled, getSprintById, canEditSprint)=>{
    const isSprintMenuVisible = (id)=>{
        if (!areSprintsEnabled) return false;
        const sprint = getSprintById(id);
        if (!sprint) return false;
        return canEditSprint(id);
    };
    return isSprintMenuVisible;
});
const $736dd8f43d7babf2$export$b617a44e0fda9735 = (0, $df4Sl.createSelector)([
    $736dd8f43d7babf2$export$5a6d0e1cb58a7ee5,
    $736dd8f43d7babf2$export$d0747858fa55f115,
    $736dd8f43d7babf2$export$548ce523ca2b9fc0,
    (0, $hkGxG.getIsParallelSprintsEnabled),
    (0, $hkGxG.getIsCompanyManaged)
], (areSprintsEnabled, canEditSprint, isFutureSprint, isParallelSprintsEnabled, isCompanyManaged)=>{
    const isStartSprintVisible = (id, isFirstList)=>{
        if (!areSprintsEnabled || !canEditSprint(id) || isCompanyManaged && !isParallelSprintsEnabled && !isFirstList) return false;
        return isFutureSprint(id);
    };
    return isStartSprintVisible;
});
const $736dd8f43d7babf2$export$fd48a9e7d9ffc297 = (0, $df4Sl.createSelector)([
    $736dd8f43d7babf2$export$5a6d0e1cb58a7ee5,
    (0, $7kNqR.canManageSprints)
], (areSprintsEnabled, sprintsManageEnabled)=>{
    const isCreateSprintVisible = (id)=>{
        if (!areSprintsEnabled || !sprintsManageEnabled) return false;
        return id === (0, $7TyGu.BACKLOG);
    };
    return isCreateSprintVisible;
});
const $736dd8f43d7babf2$export$35ab6d7577f201a3 = (0, $df4Sl.createSelector)([
    (0, $hkGxG.getIsCompanyManaged),
    (0, $hkGxG.getIsParallelSprintsEnabled),
    $736dd8f43d7babf2$export$b617a44e0fda9735
], (isCompanyManaged, isParallelSprintsEnabled, isStartSprintVisible)=>(id, isFirstList)=>{
        if (!isStartSprintVisible(id, isFirstList)) return false;
        // First list in backlog always has start sprint button enabled regardless
        if (isFirstList) return true;
        // Agility Boards always have parallel sprints enabled
        return isCompanyManaged ? isParallelSprintsEnabled : true;
    });
const $736dd8f43d7babf2$export$b447779f07c42b51 = (0, $df4Sl.createSelector)([
    $736dd8f43d7babf2$export$5a6d0e1cb58a7ee5,
    $736dd8f43d7babf2$export$d0747858fa55f115,
    $736dd8f43d7babf2$export$5ce180897302be5f
], (areSprintsEnabled, canEditSprint, isActiveSprint)=>{
    const isCompleteSprintVisible = (id)=>areSprintsEnabled && canEditSprint(id) && isActiveSprint(id);
    return isCompleteSprintVisible;
});
const $736dd8f43d7babf2$export$47615c8fc3c602b6 = (0, $df4Sl.createSelector)([
    (state)=>(0, $bP7Jx.getCardLists)(state),
    (state)=>$736dd8f43d7babf2$export$d0747858fa55f115(state),
    (state)=>$736dd8f43d7babf2$export$5a6d0e1cb58a7ee5(state),
    // @ts-expect-error - TS7031 - Binding element 'cardListId' implicitly has an 'any' type.
    (state, { cardListId: cardListId })=>cardListId
], (cardLists, canEditSprint, areSprintsEnabled, cardListId)=>Boolean(areSprintsEnabled && canEditSprint(cardListId) && cardLists[cardListId].sprintData && !cardLists[cardListId].sprintData?.startDate && !cardLists[cardListId].sprintData?.endDate));

});
parcelRegister("1ircG", function(module, exports) {

$parcel$export(module.exports, "getEstimationType", () => $a4544bd3916da2f3$export$29518a6a820fd3eb);
$parcel$export(module.exports, "isOriginalEstimateTypeSelector", () => $a4544bd3916da2f3$export$6a137137bd478798);
$parcel$export(module.exports, "isNumericEstimateTypeSelector", () => $a4544bd3916da2f3$export$97ec2e51e7a87787);
$parcel$export(module.exports, "getEstimationFieldId", () => $a4544bd3916da2f3$export$d49fd37e39c6e680);
$parcel$export(module.exports, "getEstimationName", () => $a4544bd3916da2f3$export$402e2f057625b12d);
$parcel$export(module.exports, "getIsRemainingTimeTrackingEnabled", () => $a4544bd3916da2f3$export$7de59b2ad512814f);

var $df4Sl = parcelRequire("df4Sl");

var $7TyGu = parcelRequire("7TyGu");

var $bP7Jx = parcelRequire("bP7Jx");

var $kF7v3 = parcelRequire("kF7v3");
const $a4544bd3916da2f3$export$930445b4a7dea9c7 = (state)=>(0, $kF7v3.getEntities)(state).estimation;
const $a4544bd3916da2f3$export$a8f00aa8643e90b5 = (0, $df4Sl.createSelector)($a4544bd3916da2f3$export$930445b4a7dea9c7, (estimation)=>estimation.isEstimationFeatureEnabled);
const $a4544bd3916da2f3$export$29518a6a820fd3eb = (0, $df4Sl.createSelector)($a4544bd3916da2f3$export$930445b4a7dea9c7, (estimation)=>estimation.estimationType);
const $a4544bd3916da2f3$export$6a137137bd478798 = (state)=>$a4544bd3916da2f3$export$29518a6a820fd3eb(state) === (0, $7TyGu.ORIGINAL_ESTIMATE);
const $a4544bd3916da2f3$export$97ec2e51e7a87787 = (state)=>$a4544bd3916da2f3$export$29518a6a820fd3eb(state) === (0, $7TyGu.STORY_POINTS);
const $a4544bd3916da2f3$export$d49fd37e39c6e680 = (0, $df4Sl.createSelector)($a4544bd3916da2f3$export$930445b4a7dea9c7, (estimation)=>estimation.estimationFieldId);
const $a4544bd3916da2f3$export$402e2f057625b12d = (0, $df4Sl.createSelector)($a4544bd3916da2f3$export$930445b4a7dea9c7, (estimation)=>estimation.name);
const $a4544bd3916da2f3$export$7de59b2ad512814f = (0, $df4Sl.createSelector)((0, $bP7Jx.getCards), (allCards)=>{
    const listOfCards = Object.values(allCards);
    if (listOfCards.length <= 0) return false;
    return !!listOfCards[0]?.estimate?.timeRemainingEstimate;
});

});

parcelRegister("5ceEB", function(module, exports) {

$parcel$export(module.exports, "getInitialStatusIds", () => $c3a7251733b917d6$export$3b740680bb74be21);
$parcel$export(module.exports, "getResolutionDoneStatusIds", () => $c3a7251733b917d6$export$a1205d43535ec163);
$parcel$export(module.exports, "getColumnStatusByStatusId", () => $c3a7251733b917d6$export$2ae22d7372adb0d1);
$parcel$export(module.exports, "getColumnStatusIds", () => $c3a7251733b917d6$export$eb0fe596a80f835f);
$parcel$export(module.exports, "isStatusMappedToBoardOld", () => $c3a7251733b917d6$export$b9df98cb1a9ce42b);
$parcel$export(module.exports, "isStatusMappedToBoard", () => $c3a7251733b917d6$export$48bfbcc6c0173871);
$parcel$export(module.exports, "makeGetKanbanSingleColumnStatusId", () => $c3a7251733b917d6$export$5826bba123eba4f6);
$parcel$export(module.exports, "isStatusVisibleOnCmpKanbanBacklog", () => $c3a7251733b917d6$export$87b2d43ded99833b);
$parcel$export(module.exports, "areStatusesFromSameColumn", () => $c3a7251733b917d6$export$7c7e516bfb4a3562);

var $df4Sl = parcelRequire("df4Sl");

var $ldoFd = parcelRequire("ldoFd");

var $jqvCZ = parcelRequire("jqvCZ");

var $8Qd0L = parcelRequire("8Qd0L");

var $7TyGu = parcelRequire("7TyGu");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $b2nol = parcelRequire("b2nol");
const $c3a7251733b917d6$export$3b740680bb74be21 = (0, $df4Sl.createSelector)([
    (0, $hkGxG.getIsCompanyManaged),
    (0, $b2nol.getColumns)
], (isCompanyManaged, columns)=>{
    if (!columns) return [];
    const columnsArray = Object.values(columns);
    if (isCompanyManaged) {
        if (columnsArray.length) {
            const initialStatusColumn = columnsArray.find((column)=>column.order === 0);
            return initialStatusColumn ? initialStatusColumn.statuses.map((status)=>status.id) : [];
        }
    }
    return columnsArray.reduce((initialStatuses, column)=>{
        column.statuses.forEach((status)=>{
            const isInitialStatus = /* eslint-disable @typescript-eslint/consistent-type-assertions */ [
                (0, $8Qd0L.StatusCategoryTypes).NEW,
                (0, $8Qd0L.StatusCategoryTypes).UNDEFINED
            ]/* eslint-enable @typescript-eslint/consistent-type-assertions */ .includes(status.category);
            isInitialStatus && initialStatuses.push(status.id);
        });
        return initialStatuses;
    }, []);
});
const $c3a7251733b917d6$export$a1205d43535ec163 = (0, $df4Sl.createSelector)([
    (0, $hkGxG.getIsCompanyManaged),
    (0, $b2nol.getColumns)
], (isCompanyManaged, columns)=>{
    if (!columns) return [];
    const columnsArray = Object.values(columns);
    if (isCompanyManaged) {
        if (columnsArray.length) {
            const resolutionDoneStatusColumn = columnsArray.find((column)=>column.order === columnsArray.length - 1);
            return resolutionDoneStatusColumn ? resolutionDoneStatusColumn.statuses.map((status)=>status.id) : [];
        }
    }
    return columnsArray.reduce((resolutionDoneStatuses, column)=>{
        column.statuses.forEach((status)=>{
            if (status.category === (0, $8Qd0L.StatusCategoryTypes).DONE) resolutionDoneStatuses.push(status.id);
        });
        return resolutionDoneStatuses;
    }, []);
});
const $c3a7251733b917d6$export$2ae22d7372adb0d1 = (statusId)=>(0, $df4Sl.createSelector)([
        (0, $b2nol.getColumns)
    ], (columns)=>{
        if (!columns) return null;
        // We do this kind of loop because its more efficient than the alternative loops
        for (const columnKey of Object.keys(columns)){
            const status = (columns[columnKey].statuses || []).find((s)=>!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(s) && s.id === statusId);
            // Terminate early if we find what we need (flow doesn't like isNil here)
            if (status !== undefined && status !== null) return status;
        }
        return null;
    });
const $c3a7251733b917d6$export$eb0fe596a80f835f = (0, $df4Sl.createSelector)([
    (0, $b2nol.getColumns)
], (columns)=>{
    if (!columns) return [];
    const columnsArray = Object.values(columns);
    return columnsArray.reduce((statuseIds, column)=>{
        column.statuses.forEach((status)=>{
            statuseIds.push(status.id);
        });
        return statuseIds;
    }, []);
});
const $c3a7251733b917d6$export$b9df98cb1a9ce42b = (statusId)=>(0, $df4Sl.createSelector)([
        $c3a7251733b917d6$export$eb0fe596a80f835f
    ], (columnStatusIds)=>{
        if (!columnStatusIds) return false;
        return columnStatusIds.includes(statusId);
    });
const $c3a7251733b917d6$export$48bfbcc6c0173871 = (0, $df4Sl.createSelector)([
    $c3a7251733b917d6$export$eb0fe596a80f835f
], (columnStatusIds)=>(0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((statusId)=>{
        if (!columnStatusIds) return false;
        return columnStatusIds.includes(statusId);
    }));
const $c3a7251733b917d6$export$5826bba123eba4f6 = (0, $df4Sl.createSelector)([
    (0, $hkGxG.getIsCompanyManaged),
    (0, $hkGxG.isKanbanBacklogStrategy),
    (0, $bP7Jx.getCardLists),
    (0, $hkGxG.getKanbanTargetColumnId),
    (0, $b2nol.makeGetColumn)
], (isCompanyManaged, isKanbanStrategy, cardLists, selectKanbanTargetColumnId, getColumn)=>(cardListId)=>{
        if (!isCompanyManaged || !isKanbanStrategy) return undefined;
        const cardList = cardLists[cardListId];
        if (!cardList) return undefined;
        if (cardList.type === (0, $7TyGu.SPRINT)) return undefined;
        const targetColumnId = selectKanbanTargetColumnId(cardList.type);
        if (!targetColumnId) return undefined;
        const column = getColumn(targetColumnId);
        if (!column) return undefined;
        return column.statuses.length === 1 ? column.statuses[0].id : undefined;
    });
const $c3a7251733b917d6$export$84797642e3c942d3 = (0, $df4Sl.createSelector)([
    (0, $b2nol.getColumns),
    (0, $hkGxG.getKanbanBoardColumnId),
    (0, $hkGxG.getKanbanBacklogColumnId)
], (columns, kanbanBoardColumnId, kanbanBacklogColumnId)=>{
    if (!columns || !kanbanBoardColumnId || !kanbanBacklogColumnId) return [];
    const boardStatuses = columns[kanbanBoardColumnId].statuses;
    const backlogStatuses = columns[kanbanBacklogColumnId].statuses;
    return [
        ...boardStatuses,
        ...backlogStatuses
    ].map((columnStatus)=>columnStatus.id);
});
const $c3a7251733b917d6$export$87b2d43ded99833b = (0, $df4Sl.createSelector)([
    $c3a7251733b917d6$export$84797642e3c942d3
], (visibleStatusIds)=>(0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((statusId)=>visibleStatusIds.includes(statusId)));
const $c3a7251733b917d6$export$7c7e516bfb4a3562 = (0, $df4Sl.createSelector)([
    (0, $b2nol.getColumns)
], (columns)=>// The first two statusIds have been named explicitly to ensure
    // at least two statuses are required for comparison
    (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((firstStatusId, secondStatusId, ...remainingStatusIds)=>{
        if (!columns) return false;
        // The column that houses the first status is the point of reference.
        // We'll check whether all other statuses exist in this column.
        const columnOfFirstStatus = (0, $b2nol.findColumnByStatusId)(columns, firstStatusId);
        const statusesToCheck = [
            secondStatusId,
            ...remainingStatusIds
        ];
        if (!columnOfFirstStatus) return false;
        const columnStatusIds = columnOfFirstStatus.statuses.map(({ id: id })=>id);
        return statusesToCheck.every((statusId)=>columnStatusIds.includes(statusId));
    }, // Construct a custom cache key for memoize as it
    // only uses the first arg for the cache key by default
    (...statusIds)=>[
            ...statusIds.concat().sort()
        ].join('_')));

});
parcelRegister("b2nol", function(module, exports) {

$parcel$export(module.exports, "getColumns", () => $9fac4b92a6a23a20$export$978e30a0fb8610d8);
$parcel$export(module.exports, "makeGetColumn", () => $9fac4b92a6a23a20$export$c8e2f531112a8425);
$parcel$export(module.exports, "findColumnByStatusId", () => $9fac4b92a6a23a20$export$b8cb2be3dbed32e1);
$parcel$export(module.exports, "getColumnCount", () => $9fac4b92a6a23a20$export$813bef8f01765aa1);

var $df4Sl = parcelRequire("df4Sl");

var $jqvCZ = parcelRequire("jqvCZ");

var $kF7v3 = parcelRequire("kF7v3");
const $9fac4b92a6a23a20$export$978e30a0fb8610d8 = (state)=>(0, $kF7v3.getEntities)(state).column;
const $9fac4b92a6a23a20$export$c8e2f531112a8425 = (state)=>(columnId)=>{
        const columns = $9fac4b92a6a23a20$export$978e30a0fb8610d8(state);
        if (!columns) return null;
        return columns[String(columnId)] ?? null;
    };
const $9fac4b92a6a23a20$export$b8cb2be3dbed32e1 = (columns, statusId)=>columns && Object.values(columns).find((column)=>column.statuses.some((columnStatus)=>columnStatus.id === statusId));
const $9fac4b92a6a23a20$export$c0868dfc0085fdc9 = (0, $df4Sl.createSelector)([
    $9fac4b92a6a23a20$export$978e30a0fb8610d8
], (columns)=>(0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((statusId)=>$9fac4b92a6a23a20$export$b8cb2be3dbed32e1(columns, statusId)));
const $9fac4b92a6a23a20$export$813bef8f01765aa1 = (columns)=>{
    if (!columns || Object.keys(columns).length === 0) return {
        initialColumnCount: 0,
        inProgressColumnCount: 0,
        doneColumnCount: 0
    };
    // the order of columns in the state is not guaranteed so if you want to get the correct column object you will need to sort them by tje column's "order"
    const cols = Object.values(columns);
    const initialColumnCount = 1;
    const doneColumnCount = cols.length > 1 ? 1 : 0;
    const inProgressColumnCount = Math.max(0, cols.length - 2); // columns between initial and done
    return {
        initialColumnCount: initialColumnCount,
        inProgressColumnCount: inProgressColumnCount,
        doneColumnCount: doneColumnCount
    };
};

});




parcelRegister("jiL2Q", function(module, exports) {

$parcel$export(module.exports, "INITIALIZE_APP_PROPS", () => $c49ef1a892240425$export$84856e4ae7cd7538);
$parcel$export(module.exports, "initializeAppProps", () => $c49ef1a892240425$export$5f0e35553cecddfe);
$parcel$export(module.exports, "LOAD_APP_DATA_REQUEST", () => $c49ef1a892240425$export$4f8b7d7927a22b01);
$parcel$export(module.exports, "loadAppData", () => $c49ef1a892240425$export$c0b92fee0bc9f9f3);
$parcel$export(module.exports, "LOAD_APP_DATA_FAILURE", () => $c49ef1a892240425$export$b707057781245e8f);
$parcel$export(module.exports, "loadAppDataFailure", () => $c49ef1a892240425$export$442c6ce163728713);
$parcel$export(module.exports, "SET_APP_DATA", () => $c49ef1a892240425$export$913417342844b14c);
$parcel$export(module.exports, "setAppData", () => $c49ef1a892240425$export$9f61e044a5ec71f4);
$parcel$export(module.exports, "LOAD_CONFIG_DATA_REQUEST", () => $c49ef1a892240425$export$a7098c3930b55b23);
$parcel$export(module.exports, "loadConfigData", () => $c49ef1a892240425$export$6ca3a482217f96bb);
$parcel$export(module.exports, "LOAD_CONFIG_DATA_FAILURE", () => $c49ef1a892240425$export$d9a7e4743c3f9bb6);
$parcel$export(module.exports, "loadConfigDataFailure", () => $c49ef1a892240425$export$a6d32f0fe95fd7);
$parcel$export(module.exports, "LOAD_CONFIG_DATA_MODEL_SUCCESS", () => $c49ef1a892240425$export$1231ea6d6fc1e894);
$parcel$export(module.exports, "loadConfigDataModelSuccess", () => $c49ef1a892240425$export$11bca38ca7a076c9);
$parcel$export(module.exports, "LOAD_CONFIG_DATA_SUCCESS", () => $c49ef1a892240425$export$e84bf3e6432acad9);
$parcel$export(module.exports, "loadConfigDataSuccess", () => $c49ef1a892240425$export$2d8a793787dedc61);
$parcel$export(module.exports, "SET_CONFIG_DATA", () => $c49ef1a892240425$export$b46a9391a0c75503);
$parcel$export(module.exports, "setConfigData", () => $c49ef1a892240425$export$6da10c57829cd8e6);
$parcel$export(module.exports, "BACKLOG_VIEW", () => $c49ef1a892240425$export$bcb8585a82b8f8c7);
$parcel$export(module.exports, "backlogView", () => $c49ef1a892240425$export$4696f1f49cfb7d46);
$parcel$export(module.exports, "REFRESH_DATA_REQUEST", () => $c49ef1a892240425$export$f015544c9ef3cb40);
$parcel$export(module.exports, "refreshDataRequest", () => $c49ef1a892240425$export$7245a5bb55cf1c);
$parcel$export(module.exports, "REFRESH_DATA_FAILURE", () => $c49ef1a892240425$export$447a7d83169b5ed9);
$parcel$export(module.exports, "refreshDataFailure", () => $c49ef1a892240425$export$5bb841369f417b5b);
$parcel$export(module.exports, "CHECK_GLOBAL_ISSUE_CREATE", () => $c49ef1a892240425$export$d3342655e6919343);
$parcel$export(module.exports, "checkGlobalIssueCreate", () => $c49ef1a892240425$export$d2425890b90f3347);
$parcel$export(module.exports, "LOAD_CARD_CREATE_CONFIG_REQUEST", () => $c49ef1a892240425$export$1dd1f39bb2e82807);
$parcel$export(module.exports, "LOAD_CARD_CREATE_CONFIG_SUCCESS", () => $c49ef1a892240425$export$a62958b8add4d4a0);
$parcel$export(module.exports, "loadCardCreateConfigSuccess", () => $c49ef1a892240425$export$42eba9692ae3b59c);
$parcel$export(module.exports, "LOAD_CARD_CREATE_CONFIG_FAILURE", () => $c49ef1a892240425$export$4b08535554f72f68);
$parcel$export(module.exports, "loadCardCreateConfigFailure", () => $c49ef1a892240425$export$eddf97b41d9e89cf);
const $c49ef1a892240425$export$84856e4ae7cd7538 = 'state.actions.app.INITIALIZE_APP_PROPS';
const $c49ef1a892240425$export$5f0e35553cecddfe = (payload)=>({
        type: $c49ef1a892240425$export$84856e4ae7cd7538,
        payload: payload
    });
const $c49ef1a892240425$export$4f8b7d7927a22b01 = 'state.actions.app.LOAD_APP_DATA_REQUEST';
const $c49ef1a892240425$export$c0b92fee0bc9f9f3 = (payload = {})=>({
        type: $c49ef1a892240425$export$4f8b7d7927a22b01,
        payload: payload
    });
const $c49ef1a892240425$export$b707057781245e8f = 'state.actions.app.LOAD_APP_DATA_FAILURE';
const $c49ef1a892240425$export$442c6ce163728713 = ()=>({
        type: $c49ef1a892240425$export$b707057781245e8f
    });
const $c49ef1a892240425$export$913417342844b14c = 'state.actions.app.SET_APP_DATA';
const $c49ef1a892240425$export$9f61e044a5ec71f4 = (payload)=>({
        type: $c49ef1a892240425$export$913417342844b14c,
        payload: payload
    });
const $c49ef1a892240425$export$a7098c3930b55b23 = 'state.actions.app.LOAD_CONFIG_DATA_REQUEST';
const $c49ef1a892240425$export$6ca3a482217f96bb = ()=>({
        type: $c49ef1a892240425$export$a7098c3930b55b23
    });
const $c49ef1a892240425$export$d9a7e4743c3f9bb6 = 'state.actions.app.LOAD_CONFIG_DATA_FAILURE';
const $c49ef1a892240425$export$a6d32f0fe95fd7 = ()=>({
        type: $c49ef1a892240425$export$d9a7e4743c3f9bb6
    });
const $c49ef1a892240425$export$1231ea6d6fc1e894 = 'state.actions.app.LOAD_CONFIG_DATA_MODEL_SUCCESS';
const $c49ef1a892240425$export$11bca38ca7a076c9 = (payload)=>({
        type: $c49ef1a892240425$export$1231ea6d6fc1e894,
        payload: payload
    });
const $c49ef1a892240425$export$e84bf3e6432acad9 = 'state.actions.app.LOAD_CONFIG_DATA_SUCCESS';
const $c49ef1a892240425$export$2d8a793787dedc61 = ()=>({
        type: $c49ef1a892240425$export$e84bf3e6432acad9
    });
const $c49ef1a892240425$export$b46a9391a0c75503 = 'state.actions.app.SET_CONFIG_DATA';
const $c49ef1a892240425$export$6da10c57829cd8e6 = (payload)=>({
        type: $c49ef1a892240425$export$b46a9391a0c75503,
        payload: payload
    });
const $c49ef1a892240425$export$bcb8585a82b8f8c7 = 'state.actions.app.BACKLOG_VIEW';
const $c49ef1a892240425$export$4696f1f49cfb7d46 = (analyticsEvent)=>({
        type: $c49ef1a892240425$export$bcb8585a82b8f8c7,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $c49ef1a892240425$export$f015544c9ef3cb40 = 'state.actions.app.REFRESH_DATA_REQUEST';
const $c49ef1a892240425$export$7245a5bb55cf1c = (source, issues, storeFieldsActions)=>({
        type: $c49ef1a892240425$export$f015544c9ef3cb40,
        payload: {
            source: source,
            issues: issues,
            storeFieldsActions: storeFieldsActions
        }
    });
const $c49ef1a892240425$export$447a7d83169b5ed9 = 'state.actions.app.REFRESH_DATA_FAILURE';
const $c49ef1a892240425$export$5bb841369f417b5b = ()=>({
        type: $c49ef1a892240425$export$447a7d83169b5ed9
    });
const $c49ef1a892240425$export$d3342655e6919343 = 'state.actions.app.CHECK_GLOBAL_ISSUE_CREATE';
const $c49ef1a892240425$export$d2425890b90f3347 = (issues)=>({
        type: $c49ef1a892240425$export$d3342655e6919343,
        payload: {
            issues: issues
        }
    });
const $c49ef1a892240425$export$1dd1f39bb2e82807 = 'state.actions.app.LOAD_CARD_CREATE_CONFIG_REQUEST';
const $c49ef1a892240425$export$149bf88f2a958c35 = ()=>({
        type: $c49ef1a892240425$export$1dd1f39bb2e82807
    });
const $c49ef1a892240425$export$a62958b8add4d4a0 = 'state.actions.app.LOAD_CARD_CREATE_CONFIG_SUCCESS';
const $c49ef1a892240425$export$42eba9692ae3b59c = (response, analyticsEvent)=>({
        type: $c49ef1a892240425$export$a62958b8add4d4a0,
        payload: response,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $c49ef1a892240425$export$4b08535554f72f68 = 'state.actions.app.LOAD_CARD_CREATE_CONFIG_FAILURE';
const $c49ef1a892240425$export$eddf97b41d9e89cf = (error, analyticsEvent)=>({
        type: $c49ef1a892240425$export$4b08535554f72f68,
        payload: {
            error: error
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });

});

parcelRegister("jgHdr", function(module, exports) {

$parcel$export(module.exports, "BOARD_ISSUE_MOVE_CANCEL", () => $2e373a92d7d85033$export$22ae87f30df1ab2a);
$parcel$export(module.exports, "boardIssueMoveCancel", () => $2e373a92d7d85033$export$21c319cd4bbf2b2f);
$parcel$export(module.exports, "BOARD_ISSUE_MOVE_SHOW", () => $2e373a92d7d85033$export$e229682e10ad017a);
$parcel$export(module.exports, "boardIssueMoveShow", () => $2e373a92d7d85033$export$afe8c48481994c25);
$parcel$export(module.exports, "BOARD_ISSUE_MOVE_EXECUTE", () => $2e373a92d7d85033$export$a0efdae17a1cafbf);
$parcel$export(module.exports, "boardIssueMoveExecute", () => $2e373a92d7d85033$export$47de1859c695eca7);
$parcel$export(module.exports, "BOARD_ISSUE_MOVE_EXECUTE_SUCCESS", () => $2e373a92d7d85033$export$7bbe0c5ad5f82e3b);
$parcel$export(module.exports, "BOARD_ISSUE_MOVE_EXECUTE_FAILURE", () => $2e373a92d7d85033$export$a246706d8be8143c);

var $jWq1L = parcelRequire("jWq1L");
const $2e373a92d7d85033$export$22ae87f30df1ab2a = 'state.actions.board-issue-move.BOARD_ISSUE_MOVE_CANCEL';
const $2e373a92d7d85033$export$21c319cd4bbf2b2f = ()=>({
        type: $2e373a92d7d85033$export$22ae87f30df1ab2a
    });
const $2e373a92d7d85033$export$e229682e10ad017a = 'state.actions.board-issue-move.BOARD_ISSUE_MOVE_SHOW';
const $2e373a92d7d85033$export$afe8c48481994c25 = ()=>({
        type: $2e373a92d7d85033$export$e229682e10ad017a
    });
const $2e373a92d7d85033$export$a0efdae17a1cafbf = 'state.actions.board-issue-move.BOARD_ISSUE_MOVE_EXECUTE';
const $2e373a92d7d85033$export$47de1859c695eca7 = ()=>({
        type: $2e373a92d7d85033$export$a0efdae17a1cafbf,
        meta: (0, $jWq1L.beginOptimisticUiMeta)()
    });
const $2e373a92d7d85033$export$7bbe0c5ad5f82e3b = 'state.actions.board-issue-move.BOARD_ISSUE_MOVE_EXECUTE_SUCCESS';
const $2e373a92d7d85033$export$403d172f0e549eb1 = (optimisticId)=>({
        type: $2e373a92d7d85033$export$7bbe0c5ad5f82e3b,
        meta: (0, $jWq1L.commitOptimisticUiMeta)(optimisticId)
    });
const $2e373a92d7d85033$export$a246706d8be8143c = 'state.actions.board-issue-move.BOARD_ISSUE_MOVE_EXECUTE_FAILURE';
const $2e373a92d7d85033$export$3c31c79b76c3db3b = (optimisticId)=>({
        type: $2e373a92d7d85033$export$a246706d8be8143c,
        meta: (0, $jWq1L.revertOptimisticUiWithFlagMeta)(optimisticId)
    });

});


parcelRegister("eBWYx", function(module, exports) {

$parcel$export(module.exports, "default", () => $0196e550a4fb5f90$export$2e2bcd8739ae039);

var $6Z5ag = parcelRequire("6Z5ag");
parcelRequire("fiQ2m");
parcelRequire("3wBUP");

var $jgHdr = parcelRequire("jgHdr");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0196e550a4fb5f90$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $jgHdr.BOARD_ISSUE_MOVE_CANCEL), (0, $jgHdr.BOARD_ISSUE_MOVE_EXECUTE)).switchMap(()=>(0, $6Z5ag.dismissDialog)(store.getState()).ignoreElements());

});


parcelRegister("oMuSV", function(module, exports) {

$parcel$export(module.exports, "default", () => $51105d7c44968caf$export$2e2bcd8739ae039);

var $MYW4e = parcelRequire("MYW4e");

var $bd1K7 = parcelRequire("bd1K7");

var $3JafE = parcelRequire("3JafE");
parcelRequire("9u6v2");
parcelRequire("jyKN9");
parcelRequire("1Lcr1");
parcelRequire("iects");
parcelRequire("flmol");
parcelRequire("8OtG5");
parcelRequire("8jBvP");
parcelRequire("4ffW3");
parcelRequire("azOPD");

var $hompL = parcelRequire("hompL");

var $gUUjF = parcelRequire("gUUjF");

var $JRB5w = parcelRequire("JRB5w");
var $7byHA = parcelRequire("7byHA");

var $9iBPc = parcelRequire("9iBPc");

var $hniWi = parcelRequire("hniWi");

var $5Tl9n = parcelRequire("5Tl9n");

var $kfH46 = parcelRequire("kfH46");
const $51105d7c44968caf$export$d03120aa6150e275 = (action$)=>action$.ofType((0, $5Tl9n.CARD_SET_REQUEST)).mergeMap((action)=>{
        const { batchId: batchId, setMutations: setMutations } = action.payload;
        return (0, $3JafE.Observable).from(setMutations).mergeMap((mutation)=>{
            const { optimistic: { id: optimisticId }, [(0, $kfH46.CARD_SET_META_KEY)]: { fieldId: fieldId, issueKey: issueKey, newValue: newValue, retryAction: retryAction }, analyticsEvent: analyticsEvent } = mutation;
            return (0, $9iBPc.default)({
                issueKey: issueKey,
                fieldId: fieldId,
                newValue: newValue
            }).map(()=>(0, $5Tl9n.cardSetIndividualResponseSuccess)({
                    batchId: batchId,
                    issueKey: issueKey,
                    fieldId: fieldId
                }, optimisticId, analyticsEvent)).catch((error)=>{
                (0, $gUUjF.default).safeErrorWithoutCustomerData('bulk-ops-send-request-epic', `Failed to set card field '${fieldId}'`, error);
                const isNetworkError = (0, $JRB5w.isClientFetchError)(error);
                const isUserValidationError = (0, $7byHA.isValidationError)(error);
                // eslint-disable-next-line no-nested-ternary
                const failureReason = isNetworkError ? 'network' : isUserValidationError ? 'validation' : 'server';
                const statusCode = 'statusCode' in error ? error.statusCode : undefined;
                return (0, $3JafE.Observable).of((0, $5Tl9n.cardSetIndividualResponseFailure)({
                    batchId: batchId,
                    issueKey: issueKey,
                    fieldId: fieldId,
                    retryAction: retryAction,
                    failureReason: failureReason,
                    statusCode: statusCode
                }, optimisticId, analyticsEvent));
            });
        }).bufferCount(setMutations.length).mergeMap((cardSetRequestResponses)=>(0, $3JafE.Observable).of((0, $MYW4e.batchActions)(cardSetRequestResponses)));
    });
const $51105d7c44968caf$var$isActionWithCardSetMeta = (action)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    action.meta?.[0, $kfH46.CARD_SET_META_KEY] !== undefined;
const $51105d7c44968caf$var$isCardSetIndividualResponse = (action)=>action.type === (0, $5Tl9n.CARD_SET_INDIVIDUAL_REQUEST_SUCCESS) || action.type === (0, $5Tl9n.CARD_SET_INDIVIDUAL_REQUEST_FAILURE);
const $51105d7c44968caf$var$isCardSetIndividualRequestFailure = (action)=>action.type === (0, $5Tl9n.CARD_SET_INDIVIDUAL_REQUEST_FAILURE);
const $51105d7c44968caf$var$getFailureReason = (failedActions)=>{
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const firstFailureReason = failedActions[0].payload.failureReason;
    const isAllSameFailureReason = failedActions.every((action)=>action.payload.failureReason === firstFailureReason);
    return isAllSameFailureReason ? firstFailureReason : 'mixed';
};
const $51105d7c44968caf$export$1d45daa6c882af99 = (action$)=>action$.ofType((0, $MYW4e.BATCH)).mergeMap((action)=>{
        const cardSetMetaActions = action.payload.filter($51105d7c44968caf$var$isActionWithCardSetMeta);
        if (cardSetMetaActions.length < 1) return (0, $3JafE.Observable).empty();
        const cardSetActions$ = (0, $3JafE.Observable).from(cardSetMetaActions).map((actionWithCardSetMeta)=>actionWithCardSetMeta.meta);
        const batchId = (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4();
        const request$ = cardSetActions$.bufferCount(cardSetMetaActions.length).map((setMutations)=>(0, $5Tl9n.cardSetRequest)(setMutations, batchId));
        const response$ = action$.ofType((0, $MYW4e.BATCH)).mergeMap((batchAction)=>batchAction.payload).filter($51105d7c44968caf$var$isCardSetIndividualResponse).filter((cardSetIndividualResponse)=>cardSetIndividualResponse.payload.batchId === batchId).bufferCount(cardSetMetaActions.length).mergeMap((cardSetRequestResponses)=>{
            const failedActions = cardSetRequestResponses.filter($51105d7c44968caf$var$isCardSetIndividualRequestFailure);
            if (!failedActions.length) return (0, $3JafE.Observable).empty();
            const totalCount = cardSetRequestResponses.length;
            const previousFailedBatchIds = cardSetMetaActions[0].meta.failedBatchIds;
            const failedActionBuilders = failedActions.map((failedAction)=>failedAction.payload.retryAction);
            const failedIssueKeys = failedActions.map((failedAction)=>failedAction.payload.issueKey);
            const failedBatchIds = previousFailedBatchIds?.length ? previousFailedBatchIds.concat(batchId) : [
                batchId
            ];
            return (0, $3JafE.Observable).of((0, $hniWi.bulkOpsShowFailedFlag)({
                failedActionBuilders: failedActionBuilders,
                failedIssueKeys: failedIssueKeys,
                totalCount: totalCount,
                failedBatchIds: failedBatchIds,
                failureReason: $51105d7c44968caf$var$getFailureReason(failedActions)
            }));
        });
        return request$.merge(response$);
    });
var $51105d7c44968caf$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)($51105d7c44968caf$export$1d45daa6c882af99, $51105d7c44968caf$export$d03120aa6150e275);

});
parcelRegister("9iBPc", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a41ffdf4be692a7$export$2e2bcd8739ae039);

var $3JafE = parcelRequire("3JafE");

var $fuPpb = parcelRequire("fuPpb");
parcelRequire("cpH8E");
const $5a41ffdf4be692a7$var$cardSetService = ({ fieldId: fieldId, issueKey: issueKey, newValue: newValue })=>(0, $3JafE.Observable).fromPromise((0, $fuPpb.default)({
        issueKey: issueKey,
        fieldId: fieldId,
        newValue: newValue
    }));
var $5a41ffdf4be692a7$export$2e2bcd8739ae039 = $5a41ffdf4be692a7$var$cardSetService;

});
parcelRegister("fuPpb", function(module, exports) {

$parcel$export(module.exports, "default", () => $2af8d6ce6c05061f$export$2e2bcd8739ae039);

var $53ciZ = parcelRequire("53ciZ");

var $lRmyA = parcelRequire("lRmyA");

var $5zSUY = parcelRequire("5zSUY");
const $2af8d6ce6c05061f$var$getFieldUpdate = (fieldId, value)=>({
        fields: {
            [fieldId]: value
        }
    });
const $2af8d6ce6c05061f$var$cardUpdateRest = ({ fieldId: fieldId, issueKey: issueKey, newValue: newValue })=>(0, $lRmyA.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify($2af8d6ce6c05061f$var$getFieldUpdate(fieldId, newValue))
    });
const $2af8d6ce6c05061f$export$31627ab97a843839 = ({ fieldId: fieldId, cardId: cardId, newValue: newValue, fieldsToForcePresent: fieldsToForcePresent })=>(0, $lRmyA.performPostRequest)('/secure/AjaxIssueAction.jspa?decorator=none', {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: (0, $53ciZ.stringify)({
            issueId: cardId,
            [fieldId]: newValue,
            atl_token: (0, $5zSUY.default)(),
            skipScreenCheck: true,
            singleFieldEdit: true,
            fieldsToForcePresent: fieldsToForcePresent
        })
    });
var $2af8d6ce6c05061f$export$2e2bcd8739ae039 = $2af8d6ce6c05061f$var$cardUpdateRest;

});


parcelRegister("5Tl9n", function(module, exports) {

$parcel$export(module.exports, "CARD_SET_REQUEST", () => $3473a459b20583a4$export$952416878bada00d);
$parcel$export(module.exports, "cardSetRequest", () => $3473a459b20583a4$export$dc4cb42f76517e71);
$parcel$export(module.exports, "CARD_SET_INDIVIDUAL_REQUEST_SUCCESS", () => $3473a459b20583a4$export$8cbba69660c382bc);
$parcel$export(module.exports, "cardSetIndividualResponseSuccess", () => $3473a459b20583a4$export$a84ab8ecccfa05f1);
$parcel$export(module.exports, "CARD_SET_INDIVIDUAL_REQUEST_FAILURE", () => $3473a459b20583a4$export$a0fc6789cc35a208);
$parcel$export(module.exports, "cardSetIndividualResponseFailure", () => $3473a459b20583a4$export$fff072d58f0c031f);

var $jWq1L = parcelRequire("jWq1L");
const $3473a459b20583a4$export$952416878bada00d = 'state.actions.card-set.CARD_SET_REQUEST';
const $3473a459b20583a4$export$dc4cb42f76517e71 = (setMutations, batchId)=>({
        type: $3473a459b20583a4$export$952416878bada00d,
        payload: {
            setMutations: setMutations,
            batchId: batchId
        }
    });
const $3473a459b20583a4$export$8cbba69660c382bc = 'state.actions.card-set.CARD_SET_INDIVIDUAL_REQUEST_SUCCESS';
const $3473a459b20583a4$export$a84ab8ecccfa05f1 = (payload, optimisticId, analyticsEvent)=>({
        type: $3473a459b20583a4$export$8cbba69660c382bc,
        payload: payload,
        meta: {
            ...(0, $jWq1L.commitOptimisticUiMeta)(optimisticId),
            analyticsEvent: analyticsEvent
        }
    });
const $3473a459b20583a4$export$a0fc6789cc35a208 = 'state.actions.card-set.CARD_SET_INDIVIDUAL_REQUEST_FAILURE';
const $3473a459b20583a4$export$fff072d58f0c031f = (payload, optimisticId, analyticsEvent)=>({
        type: $3473a459b20583a4$export$a0fc6789cc35a208,
        payload: payload,
        meta: {
            ...(0, $jWq1L.revertOptimisticUiMeta)(optimisticId),
            analyticsEvent: analyticsEvent
        }
    });

});

parcelRegister("kfH46", function(module, exports) {

$parcel$export(module.exports, "CARD_SET_META_KEY", () => $505b6c6a3cae7cd3$export$d065026949290531);
$parcel$export(module.exports, "setCardSetMeta", () => $505b6c6a3cae7cd3$export$6bd5fd0b08cb2b1d);

var $jWq1L = parcelRequire("jWq1L");
const $505b6c6a3cae7cd3$export$d065026949290531 = Symbol('CARD_SET_META_KEY');
const $505b6c6a3cae7cd3$export$6bd5fd0b08cb2b1d = (payload, analyticsEvent)=>({
        [$505b6c6a3cae7cd3$export$d065026949290531]: payload,
        analyticsEvent: analyticsEvent,
        ...(0, $jWq1L.beginOptimisticUiMeta)()
    });

});


parcelRegister("2lmHx", function(module, exports) {

$parcel$export(module.exports, "getCanUserInviteEpic", () => $f56aa5203b6fd2f2$export$89828008460b535c);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("3wBUP");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $guiFP = parcelRequire("guiFP");

var $JRB5w = parcelRequire("JRB5w");

var $eeEvv = parcelRequire("eeEvv");

var $jiL2Q = parcelRequire("jiL2Q");

var $4ntxZ = parcelRequire("4ntxZ");

var $hkGxG = parcelRequire("hkGxG");
const $f56aa5203b6fd2f2$export$89828008460b535c = (action$, store)=>action$.ofType((0, $jiL2Q.SET_APP_DATA)).switchMap(()=>{
        const state = store.getState();
        const isCMPBoard = (0, $hkGxG.getIsCompanyManaged)(state);
        if (isCMPBoard) return (0, $3JafE.Observable).of();
        const projectId = (0, $hkGxG.projectIdSelector)(state);
        return (0, $eeEvv.fetchCanUserInviteService)(projectId).mergeMap((canUserInviteResponse)=>(0, $3JafE.Observable).of((0, $4ntxZ.setCanUserInvite)(canUserInviteResponse))).catch((error)=>{
            if (!(0, $JRB5w.isClientFetchError)(error)) (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'board.can-user-invite.load.failure',
                    packageName: 'jiraSoftwareBacklog',
                    teamName: 'a4t-tanuki'
                }
            });
            return (0, $3JafE.Observable).of();
        });
    });

});
parcelRegister("eeEvv", function(module, exports) {

$parcel$export(module.exports, "fetchCanUserInviteService", () => $a26fc886d97b4b16$export$583ef539d905855);

var $2rH5o = parcelRequire("2rH5o");
const $a26fc886d97b4b16$export$583ef539d905855 = (projectId)=>(0, $2rH5o.getUserInviteCapability)(projectId);

});
parcelRegister("2rH5o", function(module, exports) {

$parcel$export(module.exports, "getUserInviteCapability", () => $719e088e251e4c93$export$22c733f1adfb0925);
parcelRequire("bI4RP");

var $aiRd8 = parcelRequire("aiRd8");
const $719e088e251e4c93$var$getCanInviteOthersUrl = (projectId)=>`/rest/internal/latest/invite-user/project/${projectId}/can-invite-others`;
const $719e088e251e4c93$export$22c733f1adfb0925 = (projectId)=>(0, $aiRd8.default)($719e088e251e4c93$var$getCanInviteOthersUrl(projectId), {
        method: 'GET'
    });

});


parcelRegister("4ntxZ", function(module, exports) {

$parcel$export(module.exports, "SET_CAN_USER_INVITE", () => $4de2b7149d9ff8ce$export$c09a6e8888fd28fa);
$parcel$export(module.exports, "setCanUserInvite", () => $4de2b7149d9ff8ce$export$c07b821618e68774);
const $4de2b7149d9ff8ce$export$c09a6e8888fd28fa = 'state.actions.can-user-invite.SET_CAN_USER_INVITE';
const $4de2b7149d9ff8ce$export$c07b821618e68774 = (payload)=>({
        type: $4de2b7149d9ff8ce$export$c09a6e8888fd28fa,
        payload: payload
    });

});


parcelRegister("cWdPU", function(module, exports) {

$parcel$export(module.exports, "buildAssignToMeEpic", () => $fb19387423c9ffe0$export$f773e45c14115697);
$parcel$export(module.exports, "cardAssignToMeThrottledEpic", () => $fb19387423c9ffe0$export$5ed483b9a7992e55);
parcelRequire("jyKN9");
parcelRequire("cpH8E");
parcelRequire("b48pz");
parcelRequire("iects");
parcelRequire("flmol");
parcelRequire("1Lcr1");

var $ldoFd = parcelRequire("ldoFd");

var $3JafE = parcelRequire("3JafE");

var $hompL = parcelRequire("hompL");

var $hjuWd = parcelRequire("hjuWd");

var $keTr0 = parcelRequire("keTr0");

var $gPQCf = parcelRequire("gPQCf");

var $hEV2I = parcelRequire("hEV2I");
const $fb19387423c9ffe0$export$59640cb3aa92677 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
swagClient, action, { onStart: onStart, onSuccess: onSuccess } = {})=>{
    const { id: optimisticId } = action.meta.optimistic;
    const { cardId: cardId, assignee: assignee, concurrentId: concurrentId } = action.payload;
    if (onStart) onStart(action);
    return (0, $3JafE.Observable).fromPromise((0, $hjuWd.assignToMe)(swagClient, {
        issueId: `${cardId}`,
        accountId: assignee?.id
    })).map(()=>{
        if (onSuccess) onSuccess(action);
        return (0, $hEV2I.assignToMeSuccess)(optimisticId, concurrentId);
    }).catch(()=>(0, $3JafE.Observable).of((0, $hEV2I.assignToMeFailure)(optimisticId, concurrentId)));
};
const $fb19387423c9ffe0$var$hooks = {
    onStart: ({ payload: { concurrentId: concurrentId, assignee: assignee, fireShortcutAnalyticsFn: fireShortcutAnalyticsFn } })=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(concurrentId)) (0, $keTr0.scheduleAfterRender)(()=>{
            (0, $gPQCf.assignToMeInteraction)(concurrentId).mark('feedback');
        });
        if (fireShortcutAnalyticsFn) fireShortcutAnalyticsFn({
            id: 'assignToMeKeyboardShortcut',
            key: 'i',
            attributes: {
                assignStatus: assignee !== null ? 'assign' : 'unassign'
            }
        });
    },
    onSuccess: ({ payload: { concurrentId: concurrentId } })=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(concurrentId)) (0, $keTr0.scheduleAfterRender)(()=>{
            (0, $gPQCf.assignToMeInteraction)(concurrentId).stop();
        });
    }
};
const $fb19387423c9ffe0$export$f773e45c14115697 = (swagClient)=>(action$)=>action$.ofType((0, $hEV2I.ASSIGN_TO_ME_REQUEST)).flatMap((action)=>$fb19387423c9ffe0$export$59640cb3aa92677(swagClient, action, $fb19387423c9ffe0$var$hooks));
const $fb19387423c9ffe0$export$5ed483b9a7992e55 = (action$)=>action$.ofType((0, $hEV2I.ASSIGN_TO_ME_REQUEST_THROTTLED)).throttleTime(500).flatMap((action)=>{
        const { cardId: cardId, assignee: assignee, fireShortcutAnalyticsFn: fireShortcutAnalyticsFn } = action.payload;
        const concurrentId = (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))();
        (0, $gPQCf.assignToMeInteraction)(concurrentId).start();
        return (0, $3JafE.Observable).of((0, $hEV2I.assignToMeRequest)({
            cardId: cardId,
            assignee: assignee,
            concurrentId: concurrentId,
            fireShortcutAnalyticsFn: fireShortcutAnalyticsFn
        }));
    });

});
parcelRegister("hjuWd", function(module, exports) {

$parcel$export(module.exports, "assignToMe", () => $74ed63623d7ff186$export$521df9d10558315a);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $R1ugb = parcelRequire("R1ugb");

var $4dZAU = parcelRequire("4dZAU");

var $4oB9Z = parcelRequire("4oB9Z");

var $4oB9Z = parcelRequire("4oB9Z");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $74ed63623d7ff186$var$onMutationError = (error)=>{
    if ((0, $4dZAU.isExpectedGraphQLError)(error)) return;
    (0, $guiFP.default)({
        error: error,
        meta: {
            id: 'assignToMeMutationFailed',
            packageName: 'jiraSoftwareKeyboardShortcuts'
        }
    });
};
const $74ed63623d7ff186$export$521df9d10558315a = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
swagClient, variables)=>swagClient.mutate({
        mutation: (0, $4oB9Z.MUTATION),
        variables: variables
    }).then((result)=>{
        if (result.errors && result.errors.length || !result.data) throw new (0, $R1ugb.SwagError)({
            // @ts-expect-error - TS2322 - Type 'readonly GraphQLError[] | undefined' is not assignable to type 'GraphqlError[] | undefined'.
            graphQLErrors: result.errors,
            errorMessage: 'Assign to me failed'
        });
        return result.data;
    }).catch((err)=>{
        $74ed63623d7ff186$var$onMutationError(err);
        throw err;
    });
const $74ed63623d7ff186$export$5d2cd46d1c41b734 = ()=>{
    const [assignToMeMutation] = (0, $4oB9Z.useAssignToMeMutation)();
    return (0, $eUqFw.useCallback)(({ issueId: issueId, accountId: accountId })=>{
        const assignMutationPromise = assignToMeMutation({
            variables: {
                issueId: issueId,
                accountId: accountId
            }
        });
        assignMutationPromise.catch($74ed63623d7ff186$var$onMutationError);
        return assignMutationPromise;
    }, [
        assignToMeMutation
    ]);
};

});
parcelRegister("4dZAU", function(module, exports) {

$parcel$export(module.exports, "isExpectedGraphQLError", () => $b02e4163e54f57c4$export$9bfdf944b8987eac);
const $b02e4163e54f57c4$export$9bfdf944b8987eac = (error)=>Boolean(error.graphQLErrors?.length > 0 && error.graphQLErrors?.every((graphQLError)=>{
        const statusCode = graphQLError?.extensions?.statusCode;
        return Boolean(statusCode);
    }));

});

parcelRegister("4oB9Z", function(module, exports) {

$parcel$export(module.exports, "MUTATION", () => $011ff2c3b922d8c6$export$7473a9a03a67999e);
$parcel$export(module.exports, "useAssignToMeMutation", () => $011ff2c3b922d8c6$export$9c4806aca0078faa);

var $iZuDo = parcelRequire("iZuDo");

var $9ypom = parcelRequire("9ypom");
const $011ff2c3b922d8c6$export$7473a9a03a67999e = (0, $9ypom.default)`
    mutation AssignIssue($issueId: ID!, $accountId: ID) {
        assignIssue(input: { issueId: $issueId, accountId: $accountId }) {
            statusCode
            message
        }
    }
`;
const $011ff2c3b922d8c6$export$9c4806aca0078faa = ()=>(0, $iZuDo.useMutation)($011ff2c3b922d8c6$export$7473a9a03a67999e);

});
parcelRegister("iZuDo", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $dd35afdbf6e72e7e$export$dd0a697e1782aedd);
$parcel$export(module.exports, "useLazyQuery", () => $dd35afdbf6e72e7e$export$fd83eea6ecd2d8fa);
$parcel$export(module.exports, "useMutation", () => $dd35afdbf6e72e7e$export$609860bf8b0084c);
$parcel$export(module.exports, "useApolloClient", () => $dd35afdbf6e72e7e$export$eb9a56e7a29e494);

var $4ErPU = parcelRequire("4ErPU");

var $fKE23 = parcelRequire("fKE23");

var $eUqFw = parcelRequire("eUqFw");

var $jlBDe = parcelRequire("jlBDe");

var $66hGB = parcelRequire("66hGB");

var $8j2fP = parcelRequire("8j2fP");
var $dd35afdbf6e72e7e$var$OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $66hGB.equal)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $8j2fP.invariant)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $4ErPU.parser)(document);
        var requiredOperationName = (0, $4ErPU.operationName)(type);
        var usedOperationName = (0, $4ErPU.operationName)(operation.type);
        (0, $8j2fP.invariant)(operation.type === type, 3);
    };
    return OperationData;
}();
var $dd35afdbf6e72e7e$var$QueryData = function(_super) {
    (0, $fKE23.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.forceUpdate();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.forceUpdate = forceUpdate;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $jlBDe.NetworkStatus).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _this = this;
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) {
            this.handleErrorOrCompleted();
            setTimeout(function() {
                _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
            });
        }
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var treeRenderingInitiated = this.context && this.context.renderPromises;
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = {
            loading: true,
            networkStatus: (0, $jlBDe.NetworkStatus).loading,
            called: true,
            data: undefined
        };
        if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
        var result;
        if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $4ErPU.DocumentType).Query);
        var displayName = options.displayName || 'Query';
        if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, $fKE23.__assign)({}, observableQueryOptions));
            if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $66hGB.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $66hGB.equal)(previousResult.data, data)) return;
                _this.forceUpdate();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $66hGB.equal)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.forceUpdate();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, $jlBDe.ApolloError)({
                graphQLErrors: errors
            });
            result = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, $jlBDe.NetworkStatus).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery) return;
        var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, $66hGB.equal)(this.previousOptions.query, query) && (0, $66hGB.equal)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$var$useDeepMemo(memoFn, key) {
    var ref = (0, $eUqFw.useRef)();
    if (!ref.current || !(0, $66hGB.equal)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function $dd35afdbf6e72e7e$var$useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var _a = (0, $eUqFw.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $eUqFw.useRef)();
    if (!queryDataRef.current) queryDataRef.current = new $dd35afdbf6e72e7e$var$QueryData({
        options: updatedOptions,
        context: context,
        forceUpdate: forceUpdate
    });
    var queryData = queryDataRef.current;
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    var memo = {
        options: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = $dd35afdbf6e72e7e$var$useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $eUqFw.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    (0, $eUqFw.useEffect)(function() {
        return function() {
            return queryData.cleanup();
        };
    }, []);
    return result;
}
function $dd35afdbf6e72e7e$export$dd0a697e1782aedd(query, options) {
    return $dd35afdbf6e72e7e$var$useBaseQuery(query, options, false);
}
function $dd35afdbf6e72e7e$export$fd83eea6ecd2d8fa(query, options) {
    return $dd35afdbf6e72e7e$var$useBaseQuery(query, options, true);
}
var $dd35afdbf6e72e7e$var$MutationData = function(_super) {
    (0, $fKE23.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $4ErPU.DocumentType).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $4ErPU.DocumentType).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, $fKE23.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, $fKE23.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $jlBDe.ApolloError)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $66hGB.equal)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$export$609860bf8b0084c(mutation, options) {
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var _a = (0, $eUqFw.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $eUqFw.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new $dd35afdbf6e72e7e$var$MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $eUqFw.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var $dd35afdbf6e72e7e$var$SubscriptionData = function(_super) {
    (0, $fKE23.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $66hGB.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$export$368b4214baeb914c(subscription, options) {
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $eUqFw.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $eUqFw.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new $dd35afdbf6e72e7e$var$SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $eUqFw.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $eUqFw.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function $dd35afdbf6e72e7e$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext((0, $4ErPU.getApolloContext)()).client;
    (0, $8j2fP.invariant)(client, 1);
    return client;
}
function $dd35afdbf6e72e7e$var$makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var $dd35afdbf6e72e7e$export$260e90e395a79974 = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || $dd35afdbf6e72e7e$var$makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();

});



parcelRegister("keTr0", function(module, exports) {

$parcel$export(module.exports, "scheduleAfterRender", () => $8f3fb9ca53f9d493$export$a845aafd0a0e29e6);

var $9oL1R = parcelRequire("9oL1R");

var $hKj4G = parcelRequire("hKj4G");

var $2fFJv = parcelRequire("2fFJv");
const $8f3fb9ca53f9d493$export$a845aafd0a0e29e6 = (callback)=>{
    if ($9oL1R && $9oL1R.unstable_scheduleCallback) // Wait a tick for renders that will still be scheduled on this event-loop tick.
    $2fFJv.nextTick(()=>{
        try {
            // Schedule an idle priority callback with react's scheduler.
            $9oL1R.unstable_scheduleCallback($9oL1R.unstable_IdlePriority, ()=>{
                callback();
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            // React.js' lower priority is at minimum 0ms or a postMessage tick.
            // Waiting 1ms seems to be a good enough approximation to run after that.
            setTimeout(()=>{
                callback();
            }, 1);
        }
    });
    else setTimeout(()=>{
        callback();
    }, 1);
};

});
parcelRegister("hKj4G", function(module, exports) {

$parcel$export(module.exports, "useAutobatch", () => $8e906032bc4f59a5$export$5b8ae94abd7adcf);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $1ybV0 = parcelRequire("1ybV0");
const $8e906032bc4f59a5$var$queue = new Set();
let $8e906032bc4f59a5$var$hasQueuedFlush = false;
function $8e906032bc4f59a5$var$flush() {
    const tasks = Array.from($8e906032bc4f59a5$var$queue);
    $8e906032bc4f59a5$var$queue.clear();
    (0, $lEfVV.unstable_batchedUpdates)(()=>{
        tasks.forEach((task)=>{
            task();
        });
    });
}
function $8e906032bc4f59a5$export$46f5568dd7916109(task) {
    $8e906032bc4f59a5$var$queue.add(task);
    if (!$8e906032bc4f59a5$var$hasQueuedFlush) {
        $8e906032bc4f59a5$var$hasQueuedFlush = true;
        queueMicrotask(()=>{
            $8e906032bc4f59a5$var$hasQueuedFlush = false;
            $8e906032bc4f59a5$var$flush();
        });
    }
    return ()=>{
        $8e906032bc4f59a5$var$queue.delete(task);
    };
}
function $8e906032bc4f59a5$export$5b8ae94abd7adcf() {
    if (!(0, $1ybV0.ff)('jsw.perf.pragmatic-dnd-auto-batch')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $eUqFw.useCallback)((task)=>task(), []);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const cancelFunctions = (0, $eUqFw.useRef)([]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const batchingFunction = (0, $eUqFw.useCallback)((task)=>{
        const cancel = $8e906032bc4f59a5$export$46f5568dd7916109(task);
        cancelFunctions.current.push(cancel);
    }, []);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eUqFw.useEffect)(()=>()=>{
            cancelFunctions.current.forEach((cancel)=>{
                cancel();
            });
        }, []);
    return batchingFunction;
}

});


parcelRegister("gPQCf", function(module, exports) {

$parcel$export(module.exports, "PAGE_LOAD_MARK_CONSTRUCTOR_START", () => $3d9363c3d986af38$export$c4552a2c37c43ea9);
$parcel$export(module.exports, "PAGE_LOAD_MARK_CONSTRUCTOR_END", () => $3d9363c3d986af38$export$6aa9fcaba5907700);
$parcel$export(module.exports, "PAGE_LOAD_MARK_REDUX_START", () => $3d9363c3d986af38$export$57eb941eb8f235ee);
$parcel$export(module.exports, "PAGE_LOAD_MARK_REDUX_END", () => $3d9363c3d986af38$export$7f8583ae22e5705f);
$parcel$export(module.exports, "PAGE_LOAD_MARK_TRANSFORM_CRITICAL_START", () => $3d9363c3d986af38$export$765cd8e38999963b);
$parcel$export(module.exports, "PAGE_LOAD_MARK_TRANSFORM_CRITICAL_END", () => $3d9363c3d986af38$export$f7e5395ee7a2ecfb);
$parcel$export(module.exports, "PAGE_LOAD_MARK_RENDER_START", () => $3d9363c3d986af38$export$a4eb0ce95caacc19);
$parcel$export(module.exports, "PAGE_LOAD_MARK_RENDER_END", () => $3d9363c3d986af38$export$a4a935943fc371c5);
$parcel$export(module.exports, "CRITICAL_RELAY_RESOURCE_GET_DATA_START", () => $3d9363c3d986af38$export$f987279f084c1947);
$parcel$export(module.exports, "CRITICAL_RELAY_RESOURCE_GET_DATA_END", () => $3d9363c3d986af38$export$86d7d16316a4fd86);
$parcel$export(module.exports, "PAGE_LOAD_MARK_TRANSFORM_CRITICAL_REST_START", () => $3d9363c3d986af38$export$9437b7e8f9f46514);
$parcel$export(module.exports, "PAGE_LOAD_MARK_TRANSFORM_CRITICAL_REST_END", () => $3d9363c3d986af38$export$6377757b944905f8);
$parcel$export(module.exports, "USE_RESOURCE_START", () => $3d9363c3d986af38$export$226c1bb9e4c0f2ee);
$parcel$export(module.exports, "USE_RESOURCE_READY", () => $3d9363c3d986af38$export$1037ea278e95f493);
$parcel$export(module.exports, "RENDER_START", () => $3d9363c3d986af38$export$672257010af09af1);
$parcel$export(module.exports, "RENDER_END", () => $3d9363c3d986af38$export$b4f76538e9c39ff7);
$parcel$export(module.exports, "JSW_CRITICAL_RESOURCE_START", () => $3d9363c3d986af38$export$c637a04c5a8cc32c);
$parcel$export(module.exports, "JSW_CRITICAL_RESOURCE_END", () => $3d9363c3d986af38$export$cbf503ef2abe660d);
$parcel$export(module.exports, "nextGenBacklogPageLoad", () => $3d9363c3d986af38$export$412da6c620d3c22f);
$parcel$export(module.exports, "uifBacklogNewUiPageLoad", () => $3d9363c3d986af38$export$dafd90f37e91dd7d);
$parcel$export(module.exports, "issueViewOpenInteraction", () => $3d9363c3d986af38$export$412ac2e825a54154);
$parcel$export(module.exports, "issueRankInteraction", () => $3d9363c3d986af38$export$b49f1606cfd9ead4);
$parcel$export(module.exports, "filterInteraction", () => $3d9363c3d986af38$export$8decf314e9f3b4a0);
$parcel$export(module.exports, "issueCreateInteraction", () => $3d9363c3d986af38$export$be312698838f27be);
$parcel$export(module.exports, "issueDeleteInteraction", () => $3d9363c3d986af38$export$1b8cf3f3c2894329);
$parcel$export(module.exports, "flagToggleInteraction", () => $3d9363c3d986af38$export$6c532396e24c45e7);
$parcel$export(module.exports, "assignToMeInteraction", () => $3d9363c3d986af38$export$79f93553011c8d54);
$parcel$export(module.exports, "cardListToggleInteraction", () => $3d9363c3d986af38$export$570f89c911f782e4);
$parcel$export(module.exports, "createSprintInteraction", () => $3d9363c3d986af38$export$208bdc4a71e10bff);
$parcel$export(module.exports, "deleteSprintInteraction", () => $3d9363c3d986af38$export$b4f79447cf23e1d8);
$parcel$export(module.exports, "moveSprintInteraction", () => $3d9363c3d986af38$export$6dc2d6f22f8f27e1);
$parcel$export(module.exports, "startSprintModalLoad", () => $3d9363c3d986af38$export$b582949e90c55414);
$parcel$export(module.exports, "completeSprintModalLoad", () => $3d9363c3d986af38$export$281157708c6b132a);
$parcel$export(module.exports, "customFilterInteraction", () => $3d9363c3d986af38$export$ae56111e009a2b76);
$parcel$export(module.exports, "clearCustomFilterInteraction", () => $3d9363c3d986af38$export$776b3d2eaed43448);
$parcel$export(module.exports, "versionsPanelLoad", () => $3d9363c3d986af38$export$b2b67b41751ce72b);
$parcel$export(module.exports, "inlineEditStatusInteraction", () => $3d9363c3d986af38$export$7e4ecb299cc27d61);
$parcel$export(module.exports, "inlineEditAssigneeInteraction", () => $3d9363c3d986af38$export$2acaf09c8ee524bb);
$parcel$export(module.exports, "inlineEditStoryPointInteraction", () => $3d9363c3d986af38$export$98f90b59da066325);
$parcel$export(module.exports, "inlineEditOriginalEstimateInteraction", () => $3d9363c3d986af38$export$d01dddd30d43031c);

var $lNfG4 = parcelRequire("lNfG4");

const $3d9363c3d986af38$export$c4552a2c37c43ea9 = 'CONSTRUCTOR_START';
const $3d9363c3d986af38$export$6aa9fcaba5907700 = 'CONSTRUCTOR_END';
const $3d9363c3d986af38$export$57eb941eb8f235ee = 'REDUX_START';
const $3d9363c3d986af38$export$7f8583ae22e5705f = 'REDUX_END';
const $3d9363c3d986af38$export$765cd8e38999963b = 'TRANSFORM_CRITICAL_START';
const $3d9363c3d986af38$export$f7e5395ee7a2ecfb = 'TRANSFORM_CRITICAL_END';
const $3d9363c3d986af38$export$a4eb0ce95caacc19 = 'RENDER_START';
const $3d9363c3d986af38$export$a4a935943fc371c5 = 'RENDER_END';
const $3d9363c3d986af38$export$f987279f084c1947 = 'relay_resource_get_data:NEXTGEN_BACKLOG_RELAY:start';
const $3d9363c3d986af38$export$86d7d16316a4fd86 = 'relay_resource_get_data:NEXTGEN_BACKLOG_RELAY:end';
const $3d9363c3d986af38$export$9437b7e8f9f46514 = 'TRANSFORM_CRITICAL_REST_START';
const $3d9363c3d986af38$export$6377757b944905f8 = 'TRANSFORM_CRITICAL_REST_END';
const $3d9363c3d986af38$export$226c1bb9e4c0f2ee = 'USE_RESOURCE_START';
const $3d9363c3d986af38$export$1037ea278e95f493 = 'USE_RESOURCE_READY';
const $3d9363c3d986af38$export$672257010af09af1 = 'RENDER_START_FRAME';
const $3d9363c3d986af38$export$b4f76538e9c39ff7 = 'RENDER_END_FRAME';
const $3d9363c3d986af38$export$c637a04c5a8cc32c = 'JSW_CRITICAL_RESOURCE_START';
const $3d9363c3d986af38$export$cbf503ef2abe660d = 'JSW_CRITICAL_RESOURCE_END';
const $3d9363c3d986af38$export$6516506c3fb10def = 'EARLY_FETCH_START';
const $3d9363c3d986af38$export$8d6886d639f5aab0 = 'EARLY_FETCH_END';
const $3d9363c3d986af38$var$NEXT_GEN_BACKLOG = 'next-gen-backlog';
const $3d9363c3d986af38$var$UIF_BACKLOG_NEW_UI = 'classic-backlog';
const $3d9363c3d986af38$var$backlogPageLoad = (key)=>(0, $lNfG4.metrics).pageLoad({
        key: key,
        featureFlags: [],
        ssr: {
            doneAsFmp: true
        },
        slo: {
            fmp: {
                initial: {
                    threshold: 1000
                },
                transition: {
                    threshold: 1000
                }
            },
            tti: {
                initial: {
                    threshold: 14000
                },
                transition: {
                    threshold: 14000
                }
            }
        },
        timings: [
            {
                key: 'product/page-constructor',
                startMark: $3d9363c3d986af38$export$c4552a2c37c43ea9,
                endMark: $3d9363c3d986af38$export$6aa9fcaba5907700
            },
            {
                key: 'product/page-constructor/redux-setup',
                startMark: $3d9363c3d986af38$export$57eb941eb8f235ee,
                endMark: $3d9363c3d986af38$export$7f8583ae22e5705f
            },
            {
                key: 'product/page-constructor/redux-setup/transform-critical-data',
                startMark: $3d9363c3d986af38$export$765cd8e38999963b,
                endMark: $3d9363c3d986af38$export$f7e5395ee7a2ecfb
            },
            {
                key: 'product/page-constructor/redux-setup/transform-critical-rest-data',
                startMark: $3d9363c3d986af38$export$9437b7e8f9f46514,
                endMark: $3d9363c3d986af38$export$6377757b944905f8
            },
            {
                key: 'product/render',
                startMark: $3d9363c3d986af38$export$a4eb0ce95caacc19,
                endMark: $3d9363c3d986af38$export$a4a935943fc371c5
            },
            {
                key: 'fixed-render',
                startMark: $3d9363c3d986af38$export$672257010af09af1,
                endMark: $3d9363c3d986af38$export$b4f76538e9c39ff7
            },
            {
                key: 'use-resource-call',
                startMark: $3d9363c3d986af38$export$226c1bb9e4c0f2ee,
                endMark: $3d9363c3d986af38$export$1037ea278e95f493
            },
            {
                key: 'critical-resource-get-data',
                startMark: $3d9363c3d986af38$export$f987279f084c1947,
                endMark: $3d9363c3d986af38$export$86d7d16316a4fd86
            },
            {
                key: 'critical-resource',
                startMark: $3d9363c3d986af38$export$c637a04c5a8cc32c,
                endMark: $3d9363c3d986af38$export$cbf503ef2abe660d
            },
            {
                key: 'early-fetch',
                startMark: $3d9363c3d986af38$export$6516506c3fb10def,
                endMark: $3d9363c3d986af38$export$8d6886d639f5aab0
            },
            {
                key: (0, $37f655a4e4d5690e$export$48552baa9db8ce1d),
                endMark: (0, $37f655a4e4d5690e$export$99c08ec92759c71c)
            }
        ]
    });
const $3d9363c3d986af38$export$412da6c620d3c22f = $3d9363c3d986af38$var$backlogPageLoad($3d9363c3d986af38$var$NEXT_GEN_BACKLOG);
const $3d9363c3d986af38$export$dafd90f37e91dd7d = $3d9363c3d986af38$var$backlogPageLoad($3d9363c3d986af38$var$UIF_BACKLOG_NEW_UI);
const $3d9363c3d986af38$export$412ac2e825a54154 = (0, $lNfG4.metrics).interaction({
    key: 'backlog.issue-view-open',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '1000_2000_3000_4000_5000_6000'
    },
    timings: [
        {
            key: 'feedbackPreMount',
            endMark: 'feedbackPreMountEnd'
        }
    ]
});
const $3d9363c3d986af38$export$b49f1606cfd9ead4 = (0, $lNfG4.metrics).interaction({
    key: 'backlog.issue-rank',
    histogram: {
        result: '1000_2000_3000_4000_5000_6000',
        response: '100_200_500_1000_1500'
    }
});
const $3d9363c3d986af38$export$8decf314e9f3b4a0 = (0, $lNfG4.metrics).interaction({
    key: 'backlog.filter',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '100_200_500_1000_1200_1500'
    }
});
const $3d9363c3d986af38$export$2562fe4b040b7db0 = (0, $lNfG4.metrics).interaction({
    key: 'backlogCardRenderHoverState',
    histogram: {
        result: '100_200_300_500_700_1000_1250_1500_1750_2000_2500_3000',
        response: ''
    },
    timings: [
        {
            key: 'backlogCardHover',
            endMark: 'backlogCardHoverRendered'
        }
    ]
});
const $3d9363c3d986af38$export$f735dcf907082d42 = (0, $lNfG4.metrics).interaction({
    key: 'backlogCardMouseLeaveTiming',
    histogram: {
        result: '100_200_300_500_700_1000_1250_1500_1750_2000_2500_3000',
        response: ''
    },
    timings: [
        {
            key: 'backlogCardMouseLeaveTiming',
            endMark: 'backlogCardMouseLeaveTimingEnd'
        }
    ]
});
const $3d9363c3d986af38$export$753f9e06af8cfa2e = (0, $lNfG4.metrics).interaction({
    key: 'backlogCardDragDropTargetTiming',
    histogram: {
        result: '100_200_300_500_700_1000_1250_1500_1750_2000_2500_3000',
        response: ''
    },
    timings: [
        {
            key: 'backlogCardDragDropTargetTiming',
            endMark: 'backlogCardDragDropTargetRendered'
        }
    ]
});
const $3d9363c3d986af38$export$be312698838f27be = (0, $lNfG4.metrics).concurrent.interaction({
    key: 'backlog.issue-create',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '1000_2000_3000_4000_5000'
    }
});
const $3d9363c3d986af38$export$1b8cf3f3c2894329 = (0, $lNfG4.metrics).concurrent.interaction({
    key: 'backlog.issue-delete'
});
const $3d9363c3d986af38$export$6c532396e24c45e7 = (0, $lNfG4.metrics).concurrent.interaction({
    key: 'backlog.flag-toggle',
    histogram: {
        result: '1000_2000_3000_4000_5000_6000',
        response: '50_100_150_200_300_500'
    }
});
const $3d9363c3d986af38$export$79f93553011c8d54 = (0, $lNfG4.metrics).concurrent.interaction({
    key: 'backlog.assign-to-me',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.result]' is missing in type '{ response: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        response: '50_100_150_200_300_400_500'
    }
});
const $3d9363c3d986af38$export$570f89c911f782e4 = (0, $lNfG4.metrics).interaction({
    key: 'backlog.card-list-toggle'
});
const $3d9363c3d986af38$export$208bdc4a71e10bff = (0, $lNfG4.metrics).concurrent.interaction({
    key: 'backlog.sprint-create'
});
const $3d9363c3d986af38$export$b4f79447cf23e1d8 = (0, $lNfG4.metrics).concurrent.interaction({
    key: 'backlog.sprint-delete',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '500_1000_1500_2000_2500_3000_3500_4000'
    }
});
const $3d9363c3d986af38$export$6dc2d6f22f8f27e1 = (0, $lNfG4.metrics).interaction({
    key: 'backlog.sprint-move',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '500_1000_1500_2000_2500_3000'
    }
});
const $3d9363c3d986af38$export$b582949e90c55414 = (0, $lNfG4.metrics).interaction({
    key: 'start-sprint-modal-load'
});
const $3d9363c3d986af38$export$281157708c6b132a = (0, $lNfG4.metrics).interaction({
    key: 'complete-sprint-modal-load'
});
const $3d9363c3d986af38$export$ae56111e009a2b76 = (0, $lNfG4.metrics).interaction({
    key: 'backlog.custom-filter',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '500_1000_1500_2000_2500_3000_3500_4000'
    }
});
const $3d9363c3d986af38$export$776b3d2eaed43448 = (0, $lNfG4.metrics).interaction({
    key: 'backlog.clear-custom-filter'
});
const $3d9363c3d986af38$export$b2b67b41751ce72b = (0, $lNfG4.metrics).interaction({
    key: 'backlog.versions-panel-load'
});
const $3d9363c3d986af38$export$7e4ecb299cc27d61 = (0, $lNfG4.metrics).interaction({
    key: 'backlog.inline-issue-field-status'
});
const $3d9363c3d986af38$export$2acaf09c8ee524bb = (0, $lNfG4.metrics).interaction({
    key: 'backlog.inline-issue-field-assignee'
});
const $3d9363c3d986af38$export$98f90b59da066325 = (0, $lNfG4.metrics).interaction({
    key: 'backlog.inline-issue-field-story-point'
});
const $3d9363c3d986af38$export$d01dddd30d43031c = (0, $lNfG4.metrics).interaction({
    key: 'backlog.inline-issue-field-original-estimate'
});

});

parcelRegister("hEV2I", function(module, exports) {

$parcel$export(module.exports, "ASSIGN_TO_ME_REQUEST", () => $d64e42553fc41bd3$export$4a7b4d6811230566);
$parcel$export(module.exports, "assignToMeRequest", () => $d64e42553fc41bd3$export$e2776354d9221c82);
$parcel$export(module.exports, "ASSIGN_TO_ME_REQUEST_THROTTLED", () => $d64e42553fc41bd3$export$f241ab4d2fe8b61e);
$parcel$export(module.exports, "assignToMeRequestThrottled", () => $d64e42553fc41bd3$export$13bfccdb4d681951);
$parcel$export(module.exports, "assignToMeSuccess", () => $d64e42553fc41bd3$export$caabee9a075ba7f1);
$parcel$export(module.exports, "assignToMeFailure", () => $d64e42553fc41bd3$export$50fd16f97611da56);

var $jWq1L = parcelRequire("jWq1L");
const $d64e42553fc41bd3$export$4a7b4d6811230566 = 'state.actions.cards.assign-to-me.ASSIGN_TO_ME_REQUEST';
const $d64e42553fc41bd3$export$e2776354d9221c82 = ({ cardId: cardId, assignee: assignee, concurrentId: concurrentId, fireShortcutAnalyticsFn: fireShortcutAnalyticsFn })=>({
        type: $d64e42553fc41bd3$export$4a7b4d6811230566,
        payload: {
            cardId: cardId,
            assignee: assignee,
            concurrentId: concurrentId,
            fireShortcutAnalyticsFn: fireShortcutAnalyticsFn
        },
        meta: (0, $jWq1L.beginOptimisticUiMeta)()
    });
const $d64e42553fc41bd3$export$f241ab4d2fe8b61e = 'state.actions.cards.assign-to-me.ASSIGN_TO_ME_REQUEST_THROTTLED';
const $d64e42553fc41bd3$export$13bfccdb4d681951 = (cardId, assignee, fireShortcutAnalyticsFn)=>({
        type: $d64e42553fc41bd3$export$f241ab4d2fe8b61e,
        payload: {
            cardId: cardId,
            assignee: assignee,
            fireShortcutAnalyticsFn: fireShortcutAnalyticsFn
        }
    });
const $d64e42553fc41bd3$export$1249a100986a9489 = 'state.actions.cards.assign-to-me.ASSIGN_TO_ME_SUCCESS';
const $d64e42553fc41bd3$export$caabee9a075ba7f1 = (optimisticId, concurrentId)=>({
        type: $d64e42553fc41bd3$export$1249a100986a9489,
        payload: {
            concurrentId: concurrentId
        },
        meta: (0, $jWq1L.commitOptimisticUiMeta)(optimisticId)
    });
const $d64e42553fc41bd3$export$1ce003be5a9445ee = 'state.actions.cards.assign-to-me.ASSIGN_TO_ME_FAILURE';
const $d64e42553fc41bd3$export$50fd16f97611da56 = (optimisticId, concurrentId)=>({
        type: $d64e42553fc41bd3$export$1ce003be5a9445ee,
        payload: {
            concurrentId: concurrentId
        },
        meta: (0, $jWq1L.revertOptimisticUiMeta)(optimisticId)
    });

});


parcelRegister("9mf83", function(module, exports) {

$parcel$export(module.exports, "cardAutoScrollOnFilterEpic", () => $32ad507afeada611$export$1eee00ad491917f1);
parcelRequire("9u6v2");
parcelRequire("8jBvP");
parcelRequire("jyKN9");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");

var $fB0vk = parcelRequire("fB0vk");

var $bP7Jx = parcelRequire("bP7Jx");
const $32ad507afeada611$export$1eee00ad491917f1 = (action$, store)=>action$.ofType((0, $fB0vk.CARD_AUTO_SCROLL_REQUEST_ON_FILTER)).mergeMap(()=>{
        const state = store.getState();
        const selectedIssueId = (0, $bP7Jx.getLastSelectedCard)(state);
        return selectedIssueId ? (0, $3JafE.Observable).of((0, $fB0vk.cardAutoScroll)(selectedIssueId)) : (0, $3JafE.Observable).empty();
    });

});
parcelRegister("fB0vk", function(module, exports) {

$parcel$export(module.exports, "CARD_AUTO_SCROLL", () => $6a1c87603b6ccf1e$export$21e828c0e9d1105a);
$parcel$export(module.exports, "cardAutoScroll", () => $6a1c87603b6ccf1e$export$274e46dc8e4633e0);
$parcel$export(module.exports, "CARD_AUTO_SCROLL_REQUEST_ON_FILTER", () => $6a1c87603b6ccf1e$export$3a965e6001d5e2e9);
$parcel$export(module.exports, "cardAutoScrollRequestOnFilter", () => $6a1c87603b6ccf1e$export$58d9ced87e626159);
const $6a1c87603b6ccf1e$export$21e828c0e9d1105a = 'state.actions.card.CARD_AUTO_SCROLL';
const $6a1c87603b6ccf1e$export$274e46dc8e4633e0 = (cardId)=>({
        type: $6a1c87603b6ccf1e$export$21e828c0e9d1105a,
        payload: {
            cardId: cardId
        }
    });
const $6a1c87603b6ccf1e$export$3a965e6001d5e2e9 = 'state.actions.card.CARD_AUTO_SCROLL_REQUEST_ON_FILTER';
const $6a1c87603b6ccf1e$export$58d9ced87e626159 = ()=>({
        type: $6a1c87603b6ccf1e$export$3a965e6001d5e2e9
    });

});


parcelRegister("3CWrw", function(module, exports) {

$parcel$export(module.exports, "cardClickEpic", () => $2e0237cf6616ccb4$export$d1fdf7f3fe665b5b);
parcelRequire("9u6v2");
parcelRequire("8jBvP");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");

var $1ybV0 = parcelRequire("1ybV0");

var $8wXFi = parcelRequire("8wXFi");


var $Z90Qs = parcelRequire("Z90Qs");

var $e3Gc5 = parcelRequire("e3Gc5");

var $8YxIx = parcelRequire("8YxIx");

var $1HfeQ = parcelRequire("1HfeQ");

var $K2SiM = parcelRequire("K2SiM");

var $a9os4 = parcelRequire("a9os4");

var $bP7Jx = parcelRequire("bP7Jx");
const $2e0237cf6616ccb4$var$getCardIdsToListSelection = (state, relativeCardId, clickedCardId)=>{
    const relativeCardListId = (0, $bP7Jx.makeGetCardListIdByCardId)(state)(relativeCardId);
    const clickedCardListId = (0, $bP7Jx.makeGetCardListIdByCardId)(state)(clickedCardId);
    if (!relativeCardListId || !clickedCardListId) return [];
    // selecting from the same card list
    if (relativeCardListId === clickedCardListId) {
        const cards = (0, $bP7Jx.makeOrderedVisibleCardIdsForCardList)(state)(relativeCardListId);
        const relativeCardIndex = cards.indexOf(relativeCardId);
        const clickedCardIndex = cards.indexOf(clickedCardId);
        const cardInBetween = clickedCardIndex > relativeCardIndex ? cards.slice(relativeCardIndex, clickedCardIndex + 1) : cards.slice(clickedCardIndex, relativeCardIndex + 1).reverse();
        return cardInBetween;
    }
    // selecting from across card lists
    const orderedCardListIds = (0, $bP7Jx.getOrderedCardListIds)(state);
    const relativeCardListIndex = orderedCardListIds.indexOf(relativeCardListId);
    const clickedCardListIndex = orderedCardListIds.indexOf(clickedCardListId);
    const isSelectingCardListBelow = clickedCardListIndex > relativeCardListIndex;
    // getting all cards in card lists that are in between the relative and clicked cards
    const cardListsInBetween = orderedCardListIds.filter((_, index)=>{
        if (isSelectingCardListBelow) return index > relativeCardListIndex && index < clickedCardListIndex;
        return index > clickedCardListIndex && index < relativeCardListIndex;
    });
    const cardsInBetweenCardList = cardListsInBetween.reduce((result, key)=>result.concat((0, $bP7Jx.makeOrderedVisibleCardIdsForCardList)(state)(key)), []);
    const orderedCardsInBetweenCardLists = isSelectingCardListBelow ? cardsInBetweenCardList : cardsInBetweenCardList.reverse();
    // getting cards from where the relative card is based on the card order
    const relativeCardListCards = (0, $bP7Jx.makeOrderedVisibleCardIdsForCardList)(state)(relativeCardListId);
    const cardsToAddInRelativeCardList = isSelectingCardListBelow ? relativeCardListCards.slice(relativeCardListCards.indexOf(relativeCardId), relativeCardListCards.length) : relativeCardListCards.slice(0, relativeCardListCards.indexOf(relativeCardId) + 1).reverse();
    // getting cards from where the clicked card is based on the card order
    const clickedCardListCards = (0, $bP7Jx.makeOrderedVisibleCardIdsForCardList)(state)(clickedCardListId);
    const cardsToAddInClickedCardList = isSelectingCardListBelow ? clickedCardListCards.slice(0, clickedCardListCards.indexOf(clickedCardId) + 1) : clickedCardListCards.slice(clickedCardListCards.indexOf(clickedCardId), clickedCardListCards.length).reverse();
    return [
        ...cardsToAddInRelativeCardList,
        ...orderedCardsInBetweenCardLists,
        ...cardsToAddInClickedCardList
    ];
};
const $2e0237cf6616ccb4$var$getLocationAfterCloseInsights = (location)=>(0, $Z90Qs.setPanelsUrl)((0, $5a6592135d519f1e$export$61119f100c357d06), false, location);
const $2e0237cf6616ccb4$export$d1fdf7f3fe665b5b = (getLocation, push)=>(action$, store)=>action$.ofType((0, $1HfeQ.CARD_CLICK)).mergeMap((action)=>{
            const state = store.getState();
            const { cardId: cardId, withCmd: withCmd, withShift: withShift } = action.payload;
            const selectedCardIds = (0, $bP7Jx.getSelectedCards)(state);
            const focusedCard = (0, $bP7Jx.getFocusedCard)(state);
            const getCardKeyFromCardId = (0, $bP7Jx.makeCardKeyFromCardId)(state);
            if (!withShift && !withCmd && action.payload.externalAction) {
                const actions = [
                    (0, $1HfeQ.cardSingleSelect)(cardId)
                ];
                actions.push((0, $a9os4.closeInsightsPanel)(false));
                (0, $8wXFi.isViewSettingAsPanelExpEnabledWithNoExposure)() && actions.push((0, $a9os4.closeViewSettingsPanel)());
                actions.push((0, $8YxIx.setCheckboxSelectionMode)(!!action.payload.withCheckbox));
                push((0, $e3Gc5.addSelectedIssueToUrl)(getCardKeyFromCardId(cardId), $2e0237cf6616ccb4$var$getLocationAfterCloseInsights(getLocation())));
                actions.push((0, $K2SiM.openDetailView)(cardId, action.payload.externalAction, action.payload.analyticsMetadata));
                action.payload.fireSelectionAnalytics?.({
                    numSelectedCards: 1,
                    issue_ids: [
                        cardId
                    ]
                });
                return (0, $3JafE.Observable).from(actions);
            }
            if (!withShift && !withCmd) {
                const actions = (0, $1ybV0.ff)('sea-2642-issue-viewed-analytics-metadata') ? [
                    (0, $1HfeQ.cardSingleSelect)(cardId),
                    (0, $K2SiM.openDetailView)(cardId, undefined, action.payload.analyticsMetadata)
                ] : [
                    (0, $1HfeQ.cardSingleSelect)(cardId),
                    (0, $K2SiM.openDetailView)(cardId)
                ];
                actions.push((0, $a9os4.closeInsightsPanel)(false));
                (0, $8wXFi.isViewSettingAsPanelExpEnabledWithNoExposure)() && actions.push((0, $a9os4.closeViewSettingsPanel)());
                actions.push((0, $8YxIx.setCheckboxSelectionMode)(!!action.payload.withCheckbox));
                push((0, $e3Gc5.addSelectedIssueToUrl)(getCardKeyFromCardId(cardId), $2e0237cf6616ccb4$var$getLocationAfterCloseInsights(getLocation())));
                action.payload.fireSelectionAnalytics?.({
                    numSelectedCards: 1,
                    issue_ids: [
                        cardId
                    ]
                });
                return (0, $3JafE.Observable).from(actions);
            }
            if (withShift && withCmd) {
                const relativeCardId = (0, $bP7Jx.getListSelectionRelativeCard)(state);
                if (!relativeCardId) return (0, $3JafE.Observable).empty();
                const cardsToBeSelected = $2e0237cf6616ccb4$var$getCardIdsToListSelection(state, relativeCardId, cardId);
                const relativeCardIndex = selectedCardIds.indexOf(relativeCardId);
                const newSelectionList = selectedCardIds.slice(0, relativeCardIndex === -1 ? selectedCardIds.length : relativeCardIndex) // clean last shift+cmd list selection
                .filter((cardIdInSelectedList)=>!cardsToBeSelected.includes(cardIdInSelectedList)) // unique list
                .concat(cardsToBeSelected);
                const actions = [
                    (0, $1HfeQ.cardMultiSelect)(newSelectionList)
                ];
                action.payload.fireSelectionAnalytics?.({
                    numSelectedCards: newSelectionList.length,
                    issue_ids: newSelectionList
                });
                actions.push((0, $8YxIx.setCheckboxSelectionMode)(true));
                return (0, $3JafE.Observable).from(actions);
            }
            if (withShift) {
                const relativeCardId = (0, $bP7Jx.getListSelectionRelativeCard)(state);
                if (!relativeCardId) return (0, $3JafE.Observable).empty();
                const cardsToBeSelected = $2e0237cf6616ccb4$var$getCardIdsToListSelection(state, relativeCardId, cardId).reverse();
                const actions = [
                    (0, $1HfeQ.cardMultiSelect)(cardsToBeSelected)
                ];
                action.payload.fireSelectionAnalytics?.({
                    numSelectedCards: cardsToBeSelected.length,
                    issue_ids: cardsToBeSelected
                });
                focusedCard !== relativeCardId && actions.push((0, $8YxIx.setCheckboxSelectionMode)(true));
                return (0, $3JafE.Observable).from(actions);
            }
            if (withCmd) {
                const actions = [];
                if (selectedCardIds.length === 1 && cardId === selectedCardIds[0]) {
                    actions.push((0, $1HfeQ.cardEmptySelection)(), (0, $K2SiM.closeDetailView)());
                    actions.push((0, $8YxIx.setCheckboxSelectionMode)(false));
                } else {
                    actions.push((0, $1HfeQ.cardToggleSelection)(cardId));
                    actions.push((0, $8YxIx.setCheckboxSelectionMode)(true));
                }
                action.payload.fireSelectionAnalytics?.({
                    numSelectedCards: selectedCardIds.includes(cardId) ? selectedCardIds.length - 1 : selectedCardIds.length + 1,
                    issue_ids: selectedCardIds.includes(cardId) ? selectedCardIds.filter((id)=>id !== cardId) : [
                        ...selectedCardIds,
                        cardId
                    ]
                });
                return (0, $3JafE.Observable).from(actions);
            }
            return (0, $3JafE.Observable).empty();
        });

});
parcelRegister("Z90Qs", function(module, exports) {

$parcel$export(module.exports, "setPanelsUrl", () => $b0913fa3e32c2ecb$export$b0d97eda249239c5);
parcelRequire("8jBvP");
parcelRequire("jyKN9");

var $6HC1D = parcelRequire("6HC1D");

var $53ciZ = parcelRequire("53ciZ");

const $b0913fa3e32c2ecb$export$b0d97eda249239c5 = (panel, isOpen, location)=>{
    const search = (0, $6HC1D.chain)({
        ...(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(location.search)
    });
    if (isOpen) // using 'visible' as this is what the old CMP uses
    search.set(panel, panel === (0, $5a6592135d519f1e$export$61119f100c357d06) ? true : 'visible');
    else search.unset(panel);
    return {
        ...location,
        search: (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(search.value())
    };
};

});

parcelRegister("e3Gc5", function(module, exports) {

$parcel$export(module.exports, "addSelectedIssueToUrl", () => $580e76d5ec417396$export$56eb5b2509c9e59c);
$parcel$export(module.exports, "removeSelectedIssueFromUrl", () => $580e76d5ec417396$export$e850ae281e93782);

var $6HC1D = parcelRequire("6HC1D");

var $53ciZ = parcelRequire("53ciZ");

const $580e76d5ec417396$export$56eb5b2509c9e59c = (cardKey, location)=>{
    const search = (0, $6HC1D.chain)({
        ...(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(location.search)
    });
    search.set((0, $5a6592135d519f1e$export$3a0c4bc79274bbaa), cardKey);
    return {
        ...location,
        search: (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(search.value())
    };
};
const $580e76d5ec417396$export$e850ae281e93782 = (location)=>{
    const search = (0, $6HC1D.chain)({
        ...(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(location.search)
    });
    search.unset((0, $5a6592135d519f1e$export$3a0c4bc79274bbaa));
    return {
        ...location,
        search: (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(search.value())
    };
};

});

parcelRegister("8YxIx", function(module, exports) {

$parcel$export(module.exports, "CHECKBOX_SELECTION_MODE", () => $58f2463e65ad5ca2$export$2993cc8e0a65cc79);
$parcel$export(module.exports, "setCheckboxSelectionMode", () => $58f2463e65ad5ca2$export$bb628ef7fc94ed9);
const $58f2463e65ad5ca2$export$2993cc8e0a65cc79 = 'state.actions.cards.checkbox-selection-mode.CHECKBOX_SELECTION_MODE';
const $58f2463e65ad5ca2$export$bb628ef7fc94ed9 = (isCheckboxSelectionMode)=>({
        type: $58f2463e65ad5ca2$export$2993cc8e0a65cc79,
        payload: {
            isCheckboxSelectionMode: isCheckboxSelectionMode
        }
    });

});

parcelRegister("a9os4", function(module, exports) {

$parcel$export(module.exports, "TOGGLE_PANEL", () => $09de05bca1eda420$export$81879e9427948bf);
$parcel$export(module.exports, "togglePanel", () => $09de05bca1eda420$export$67879b1cfc177b88);
$parcel$export(module.exports, "CLOSE_INSIGHTS_PANEL", () => $09de05bca1eda420$export$8e43d92e9c342d0);
$parcel$export(module.exports, "closeInsightsPanel", () => $09de05bca1eda420$export$4fda8ba2e49f8d0c);
$parcel$export(module.exports, "CLOSE_VIEW_SETTINGS_PANEL", () => $09de05bca1eda420$export$b1f480ba0abd2610);
$parcel$export(module.exports, "closeViewSettingsPanel", () => $09de05bca1eda420$export$ef3e4b5eca4263a7);
$parcel$export(module.exports, "SET_ALL_PANELS", () => $09de05bca1eda420$export$c2b45216f8258443);
$parcel$export(module.exports, "setAllPanels", () => $09de05bca1eda420$export$550d1aa0feb70ab4);
$parcel$export(module.exports, "SET_ALL_PANELS_SUCCESS", () => $09de05bca1eda420$export$8c036bde1eda2c94);
const $09de05bca1eda420$export$81879e9427948bf = 'state.actions.panels.TOGGLE_PANEL';
const $09de05bca1eda420$export$67879b1cfc177b88 = (panel)=>({
        type: $09de05bca1eda420$export$81879e9427948bf,
        payload: {
            panel: panel
        }
    });
const $09de05bca1eda420$export$8e43d92e9c342d0 = 'state.actions.panels.CLOSE_INSIGHTS_PANEL';
const $09de05bca1eda420$export$4fda8ba2e49f8d0c = (shouldUpdateLocation = true)=>({
        type: $09de05bca1eda420$export$8e43d92e9c342d0,
        payload: {
            shouldUpdateLocation: shouldUpdateLocation
        }
    });
const $09de05bca1eda420$export$b1f480ba0abd2610 = 'state.actions.panels.CLOSE_VIEW_SETTINGS_PANEL';
const $09de05bca1eda420$export$ef3e4b5eca4263a7 = ()=>({
        type: $09de05bca1eda420$export$b1f480ba0abd2610
    });
const $09de05bca1eda420$export$c2b45216f8258443 = 'state.actions.panels.SET_ALL_PANELS';
const $09de05bca1eda420$export$550d1aa0feb70ab4 = ()=>({
        type: $09de05bca1eda420$export$c2b45216f8258443
    });
const $09de05bca1eda420$export$8c036bde1eda2c94 = 'state.actions.panels.SET_ALL_PANELS_SUCCESS';
const $09de05bca1eda420$export$9491aa22a408c1a9 = (panels)=>({
        type: $09de05bca1eda420$export$8c036bde1eda2c94,
        payload: {
            panels: panels
        }
    });

});


parcelRegister("4pvJN", function(module, exports) {

$parcel$export(module.exports, "cardCreateMultipleGqlEpic", () => $2f0e4b80abe295f8$export$2d487b79844af2c);

var $bnlpg = parcelRequire("bnlpg");

var $illlw = parcelRequire("illlw");

var $eo8NR = parcelRequire("eo8NR");

var $3JafE = parcelRequire("3JafE");
parcelRequire("9u6v2");
parcelRequire("jyKN9");
parcelRequire("1Lcr1");
parcelRequire("iects");


var $6rUGr = parcelRequire("6rUGr");
var $3YysV = parcelRequire("3YysV");

var $R1ugb = parcelRequire("R1ugb");
var $hr2LF = parcelRequire("hr2LF");

var $7TyGu = parcelRequire("7TyGu");


var $hxmH6 = parcelRequire("hxmH6");

var $lEnU0 = parcelRequire("lEnU0");

var $jiL2Q = parcelRequire("jiL2Q");

var $lsENz = parcelRequire("lsENz");

var $cbRhO = parcelRequire("cbRhO");

var $6iBIZ = parcelRequire("6iBIZ");

var $hkGxG = parcelRequire("hkGxG");

var $lk2Zu = parcelRequire("lk2Zu");

var $5ceEB = parcelRequire("5ceEB");
const $2f0e4b80abe295f8$var$parseFirstFetchErrorMessage = (error)=>{
    if ((0, $R1ugb.isJson)(error.message)) {
        const response = JSON.parse(error.message);
        return(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, (/*@__PURE__*/$parcel$interopDefault($bnlpg)))((0, (/*@__PURE__*/$parcel$interopDefault($eo8NR)))((0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(response, 'errors', null))) ?? (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(response, 'generalErrors[0]', null) ?? null);
    }
    return error.message;
};
const $2f0e4b80abe295f8$var$getBadRequestErrorMessage = (error)=>{
    if ((0, $R1ugb.isSwagError)(error)) {
        const badRequestError = error.graphQLErrors.find(({ extensions: { statusCode: statusCode } })=>statusCode === (0, $1c3fbb431a173cc6$export$9de493bcd9b1d977));
        return badRequestError ? badRequestError.message : null;
    }
    if ((0, $R1ugb.isFetchError)(error) && error.statusCode === (0, $1c3fbb431a173cc6$export$9de493bcd9b1d977)) return $2f0e4b80abe295f8$var$parseFirstFetchErrorMessage(error);
    return null;
};
const $2f0e4b80abe295f8$export$2d487b79844af2c = (action$, store)=>action$.ofType((0, $lsENz.CARD_CREATE_MULTIPLE_REQUEST)).mergeMap((action)=>{
        const { payload: { listId: listId, insertBefore: insertBefore, storeFieldsFromCardCreateData: storeFieldsFromCardCreateData, storeFieldsFromFetchIssuesData: storeFieldsFromFetchIssuesData, tempIds: tempIds, summaries: summaries, typeId: typeId, parentId: parentId, fixVersions: fixVersions }, meta: { optimistic: { id: optimisticId }, analyticsEvent: analyticsEvent } } = action;
        const state = store.getState();
        const serviceContext = (0, $lEnU0.makeServiceContext)(state);
        const inlineCreateSessionId = (0, $lk2Zu.getInlineCreateSessionId)(state);
        return (0, $hxmH6.cardCreateService)(serviceContext, store, summaries, typeId, parentId, fixVersions, listId, insertBefore, storeFieldsFromCardCreateData, storeFieldsFromFetchIssuesData).flatMap((cardsCreated)=>{
            if (cardsCreated === null) return (0, $3JafE.Observable).of((0, $lsENz.cardCreateUnmapped)(summaries.length, null, optimisticId, analyticsEvent));
            if (!(0, $5ceEB.isStatusMappedToBoardOld)(cardsCreated[0].statusId)(state)) return (0, $3JafE.Observable).of((0, $lsENz.cardCreateUnmapped)(summaries.length, cardsCreated.map((cardCreated)=>cardCreated.key), optimisticId, analyticsEvent));
            const actions = cardsCreated.map((cardCreated, index)=>(0, $lsENz.cardCreateSuccess)(cardCreated, listId, tempIds[index], insertBefore !== null, summaries.length > 1, optimisticId, analyticsEvent));
            // We should refetch versions data when an issue is inline created to keep the version panel on sync
            // and to avoid this issue: https://hello.atlassian.net/browse/FEBA-1548a
            actions.push((0, $6iBIZ.refetchVersions)());
            if ((0, $hkGxG.isCmpKanbanProject)(state)) {
                const cardListStatusId = (0, $5ceEB.makeGetKanbanSingleColumnStatusId)(state)(listId);
                if (cardListStatusId && !(0, $5ceEB.areStatusesFromSameColumn)(state)(cardListStatusId, cardsCreated[0].statusId)) actions.push((0, $jiL2Q.loadAppData)());
            }
            return (0, $3JafE.Observable).from(actions);
        }).catch((error)=>{
            const validationErrorMessage = $2f0e4b80abe295f8$var$getBadRequestErrorMessage(error);
            const statusCode = (0, $6rUGr.extractStatusCode)(error);
            if (validationErrorMessage) return (0, $3JafE.Observable).from([
                (0, $cbRhO.openModal)({
                    type: (0, $ebd52ea7083e351b$export$55cae6fd3c958bc5),
                    payload: {
                        cardListId: listId,
                        cardParentId: parentId,
                        cardSummary: summaries[0],
                        cardTypeId: typeId,
                        rankBeforeCardId: insertBefore,
                        fixVersions: fixVersions,
                        submitErrorMessage: validationErrorMessage,
                        sessionId: inlineCreateSessionId
                    }
                }),
                (0, $lsENz.cardCreateFailure)(summaries.length, optimisticId, error.message, statusCode, (0, $3YysV.isUserNetworkError)(error))
            ]);
            return (0, $3JafE.Observable).from([
                (0, $lsENz.cardCreateFailure)(summaries.length, optimisticId, error.message, statusCode, (0, $3YysV.isUserNetworkError)(error), analyticsEvent),
                (0, $hr2LF.showErrorFlag)(error),
                (0, $jiL2Q.refreshDataRequest)((0, $7TyGu.REFRESH_SOURCE_FAILURE))
            ]);
        });
    });

});
const $1c3fbb431a173cc6$export$ff39ebd4bb12b718 = 201;
const $1c3fbb431a173cc6$export$3288b14b6745c572 = 204;
const $1c3fbb431a173cc6$export$9de493bcd9b1d977 = 400;
const $1c3fbb431a173cc6$export$67d19e9a991baa07 = 401;
const $1c3fbb431a173cc6$export$a3269a3914b007e3 = 403;
const $1c3fbb431a173cc6$export$8bca792d963eb0ef = 404;
const $1c3fbb431a173cc6$export$4a3cb39801694eee = 407;
const $1c3fbb431a173cc6$export$fa405bbf47d510e2 = 408;
const $1c3fbb431a173cc6$export$c09e7ea0fc79f34f = 409;
const $1c3fbb431a173cc6$export$5244030134e99 = 412;
const $1c3fbb431a173cc6$export$f90ac1df0b60853d = 413;
const $1c3fbb431a173cc6$export$a447d0a965e16776 = 422;
const $1c3fbb431a173cc6$export$3b48aba8957000cd = 426;
const $1c3fbb431a173cc6$export$6763168a631449a2 = 429;
const $1c3fbb431a173cc6$export$e813cd7045fcc98d = 500;
const $1c3fbb431a173cc6$export$2ce38d41a306034e = 502;
const $1c3fbb431a173cc6$export$974c37534b0191b1 = 503;
const $1c3fbb431a173cc6$export$5400e8dddac3fcf3 = 504;

parcelRegister("6rUGr", function(module, exports) {

$parcel$export(module.exports, "getStatusCodeFromGraphQLErrors", () => $9a98a294942c3212$export$37c7f88726f3fb5e);
$parcel$export(module.exports, "extractStatusCode", () => $9a98a294942c3212$export$1fdf7c1c0741a7e7);

var $illlw = parcelRequire("illlw");

var $cD8SO = parcelRequire("cD8SO");
const $9a98a294942c3212$export$37c7f88726f3fb5e = (graphQLErrors)=>{
    const statusCodes = graphQLErrors.map((e)=>(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(e, [
            'extensions',
            'statusCode'
        ])).filter((statusCode)=>!!statusCode);
    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($cD8SO)))(statusCodes);
    return statusCode || null;
};
const $9a98a294942c3212$export$1fdf7c1c0741a7e7 = (error)=>{
    const errorStatusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
        'statusCode'
    ], null);
    const graphQLErrors = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
        'graphQLErrors'
    ], null);
    const networkError = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
        'networkError'
    ], null);
    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(networkError, [
        'statusCode'
    ], null);
    if (typeof errorStatusCode === 'number') return errorStatusCode;
    if (typeof statusCode === 'number') return statusCode;
    if (Array.isArray(graphQLErrors) && graphQLErrors.length > 0) return $9a98a294942c3212$export$37c7f88726f3fb5e(graphQLErrors);
    return null;
};

});

parcelRegister("3YysV", function(module, exports) {

$parcel$export(module.exports, "isUserNetworkError", () => $a40137074e874fc9$export$34bc86f6bf17f1e0);
$parcel$export(module.exports, "isFailureStatusCode", () => $a40137074e874fc9$export$790c76b8c83c3421);
$parcel$export(module.exports, "default", () => $a40137074e874fc9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $ldoFd = parcelRequire("ldoFd");

var $kwMhr = parcelRequire("kwMhr");

var $gUUjF = parcelRequire("gUUjF");

var $iH6c1 = parcelRequire("iH6c1");

var $1ybV0 = parcelRequire("1ybV0");

var $JRB5w = parcelRequire("JRB5w");

var $kJlBc = parcelRequire("kJlBc");

var $cdFlB = parcelRequire("cdFlB");

var $8QSkp = parcelRequire("8QSkp");

var $6rUGr = parcelRequire("6rUGr");

var $abbBt = parcelRequire("abbBt");

const $a40137074e874fc9$var$renderExperienceFailureWithStatus = ({ location: location, statusCode: statusCode, traceId: traceId, hash: hash, buildKey: buildKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceFailureTracker), {
        location: location,
        failureEventAttributes: {
            ...(0, $abbBt.createFailureReasonWithStatusCode)((0, $e052d5702b12477c$export$a3bb34ea5a520df8), statusCode),
            buildKey: buildKey,
            traceId: traceId,
            hash: hash
        }
    });
const $a40137074e874fc9$export$34bc86f6bf17f1e0 = (error)=>{
    const networkErrorName = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
        'networkError',
        'name'
    ], null);
    const networkErrorStatusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
        'networkError',
        'statusCode'
    ], null);
    if (networkErrorName && !networkErrorStatusCode) (0, $gUUjF.default).safeErrorWithoutCustomerData('nextgen.sla.network.error.unknown.error.name', networkErrorName);
    // A fetch() promise will reject with a TypeError when a network error is encountered or CORS is misconfigured on the server-side,
    // although this usually means permission issues or similar — a 404 does not constitute a network error
    // more https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch#Checking_that_the_fetch_was_successful
    return networkErrorName === 'TypeError' || networkErrorName === 'AbortError';
};
const $a40137074e874fc9$export$8a5d666d6e5b82fc = (error)=>{
    if (error?.name === 'ChunkLoadError') {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('nextgen.sla.chunk.load.error', error?.name, {
            message: error.message
        });
        return true;
    }
    return false;
};
const $a40137074e874fc9$export$7193151b5738a995 = (error)=>{
    if (error?.name === 'ResponseNullError') {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('nextgen.sla.response.null.error', error?.name, {
            message: error.message
        });
        return true;
    }
    return false;
};
const $a40137074e874fc9$var$KNOWN_CLIENT_SIDE_THIRD_PARTY_APP_ERRORS = [
    'FPClassifier is not defined'
];
const $a40137074e874fc9$export$ed0f33c09abc69f3 = (error)=>!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(error) && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(error.message) && !!$a40137074e874fc9$var$KNOWN_CLIENT_SIDE_THIRD_PARTY_APP_ERRORS.find((errorMessage)=>error?.message?.includes(errorMessage));
const $a40137074e874fc9$export$790c76b8c83c3421 = (statusCode)=>{
    if (statusCode == null || statusCode === 429 || statusCode >= 500) // jira is too busy, unknown error or server error
    return true;
    if (statusCode >= 400 && statusCode < 500) return false;
    return true;
};
const $a40137074e874fc9$var$detectLocalNetworkErrors = (errorResponse)=>{
    if ($a40137074e874fc9$export$34bc86f6bf17f1e0(errorResponse)) return 0, $e052d5702b12477c$export$3c39b2049cd1acb3;
    if ($a40137074e874fc9$export$8a5d666d6e5b82fc(errorResponse)) return 0, $e052d5702b12477c$export$fdfe3175a0c7be80;
    if ((0, $JRB5w.isClientFetchError)(errorResponse)) return 0, $e052d5702b12477c$export$38fe4329f59f7ac5;
    if ((0, $1ybV0.ff)('jsw.cmp.response-null-abort') && $a40137074e874fc9$export$7193151b5738a995(errorResponse)) return 0, $e052d5702b12477c$export$49d11848b43d6dbf;
    if ($a40137074e874fc9$export$ed0f33c09abc69f3(errorResponse)) return 0, $e052d5702b12477c$export$32e56551129a1642;
    return null;
};
const $a40137074e874fc9$var$responseToSla = (errorResponse, location)=>{
    const statusCode = (0, $6rUGr.extractStatusCode)(errorResponse);
    const abortFailureReason = $a40137074e874fc9$var$detectLocalNetworkErrors(errorResponse);
    const traceId = (0, $8QSkp.extractTraceId)(errorResponse) || (0, $e052d5702b12477c$export$fa14a20fcf1b1eb4);
    const hash = (0, $iH6c1.getErrorHash)(errorResponse) || (0, $e052d5702b12477c$export$fa14a20fcf1b1eb4);
    const buildKey = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(window, [
        'BUILD_KEY'
    ]) || (0, $e052d5702b12477c$export$fa14a20fcf1b1eb4);
    const errorResponseMessage = errorResponse?.message || (0, $e052d5702b12477c$export$fa14a20fcf1b1eb4);
    if (abortFailureReason) // Fire SLA Abort event to monitor the volume of client-side issues without impacting SLO
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceAbortTracker), {
        location: location,
        failureEventAttributes: {
            ...(0, $abbBt.createFailureReason)(abortFailureReason),
            error: errorResponseMessage,
            statusCode: statusCode || '',
            buildKey: buildKey,
            traceId: traceId,
            hash: hash
        }
    });
    if (statusCode === null) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('nextgen.sla.unknown.failure', (0, $e052d5702b12477c$export$b4f05a271d0831dc), {
            networkErrorName: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(errorResponse, [
                'networkError',
                'name'
            ], ''),
            networkStatusCode: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(errorResponse, [
                'networkError',
                'statusCode'
            ], ''),
            graphqlStatusCode: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(errorResponse, [
                'graphQLErrors',
                0,
                'extensions',
                'statusCode'
            ], ''),
            location: location,
            error: JSON.stringify(errorResponse, Object.getOwnPropertyNames(errorResponse)),
            hash: hash,
            isBacklogWithRelayEnabled: (0, $cdFlB.isBacklogWithRelayEnabled)()
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceFailureTracker), {
            location: location,
            failureEventAttributes: {
                ...(0, $abbBt.createFailureReason)((0, $e052d5702b12477c$export$b4f05a271d0831dc)),
                traceId: traceId,
                buildKey: buildKey,
                error: JSON.stringify({
                    message: errorResponseMessage
                }),
                hash: hash
            }
        });
    }
    // based on https://hello.atlassian.net/wiki/spaces/agile/pages/512782292/SWAG+response+handling+on+the+client
    // 40x missing permission, experience does not exist, not logged in, etc
    if (statusCode === 400 || statusCode === 401 || statusCode === 403) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceSuccessTracker), {
        location: location
    });
    if (statusCode === 429) // jira is too busy
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceAbortTracker), {
        location: location,
        failureEventAttributes: {
            ...(0, $abbBt.createFailureReason)((0, $e052d5702b12477c$export$7b9f56c34c008ec2)),
            error: errorResponseMessage,
            statusCode: '429',
            buildKey: buildKey,
            traceId: traceId,
            hash: hash
        }
    });
    if (statusCode === 404) // redirect to "all-projects" page, when page is not found
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
        to: "/jira/projects?showFlag=jsw.project-not-found"
    });
    if (statusCode > 400 && statusCode < 500) // the rest of 40X
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceSuccessTracker), {
        location: location
    });
    if (statusCode >= 500) return $a40137074e874fc9$var$renderExperienceFailureWithStatus({
        location: location,
        statusCode: statusCode,
        traceId: traceId,
        hash: hash,
        buildKey: buildKey
    });
    return $a40137074e874fc9$var$renderExperienceFailureWithStatus({
        location: location,
        statusCode: statusCode,
        traceId: traceId,
        hash: hash,
        buildKey: buildKey
    });
};
var $a40137074e874fc9$export$2e2bcd8739ae039 = $a40137074e874fc9$var$responseToSla;

});
parcelRegister("cdFlB", function(module, exports) {

$parcel$export(module.exports, "isBacklogWithRelayEnabled", () => $1432a1708fd01450$export$bc84f8a9593e9b2c);

var $1ybV0 = parcelRequire("1ybV0");
const $1432a1708fd01450$export$bc84f8a9593e9b2c = ()=>(0, $1ybV0.ff)('jsw.perf.critical-backlog-with-relay');

});

parcelRegister("8QSkp", function(module, exports) {

$parcel$export(module.exports, "extractTraceId", () => $d4638007eaa5c85e$export$431eacb6aecbacdf);
const $d4638007eaa5c85e$export$431eacb6aecbacdf = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
error)=>String(error?.traceId || error?.networkError?.traceId || '');

});

parcelRegister("abbBt", function(module, exports) {

$parcel$export(module.exports, "createFailureReason", () => $3789a68bf3687ffa$export$b9e48ed6f1b092c7);
$parcel$export(module.exports, "createFailureReasonWithStatusCode", () => $3789a68bf3687ffa$export$cc7dce678df87fe9);
const $3789a68bf3687ffa$export$b9e48ed6f1b092c7 = (reason)=>({
        failureReason: reason,
        errorMessage: reason
    });
const $3789a68bf3687ffa$export$cc7dce678df87fe9 = (reason, statusCode)=>{
    if (statusCode === undefined || statusCode === null) return {
        failureReason: reason,
        statusCode: '[unknown]',
        errorMessage: `${reason}-unknown`
    };
    return {
        failureReason: reason,
        statusCode: `${statusCode}`,
        errorMessage: `${reason}-${statusCode}`
    };
};

});

const $e052d5702b12477c$export$b4f05a271d0831dc = 'critical-data-failed-unknown-reason';
const $e052d5702b12477c$export$a3bb34ea5a520df8 = 'critical-data-failed-with-status-code';
const $e052d5702b12477c$export$7b9f56c34c008ec2 = '429-error';
const $e052d5702b12477c$export$3c39b2049cd1acb3 = 'user-network-error';
const $e052d5702b12477c$export$fdfe3175a0c7be80 = 'chunk-load-error';
const $e052d5702b12477c$export$38fe4329f59f7ac5 = 'client-fetch-error';
const $e052d5702b12477c$export$49d11848b43d6dbf = 'response-null-error';
const $e052d5702b12477c$export$32e56551129a1642 = 'client-third-party-app-error';
const $e052d5702b12477c$export$fa14a20fcf1b1eb4 = 'unknown';


const $ebd52ea7083e351b$export$86a0c18887a92eae = 'MOVE_CARDS_ACTIVE_SPRINT';
const $ebd52ea7083e351b$export$dcb8eb3e585ecde = 'MOVE_CARD_SELECT_TRANSITION';
const $ebd52ea7083e351b$export$87c7cb14aa706e2d = 'DELETE_CARD';
const $ebd52ea7083e351b$export$96d8f8ff51c496e3 = 'DELETE_SPRINT';
const $ebd52ea7083e351b$export$9d5b8103d4fbbb34 = 'ASSIGN_ISSUE_PARENT';
const $ebd52ea7083e351b$export$55cae6fd3c958bc5 = 'GLOBAL_ISSUE_CREATE';
const $ebd52ea7083e351b$export$77e94846ed2f57d7 = 'SPLIT_ISSUE_BACKLOG';
const $ebd52ea7083e351b$export$34f52cb2089ddc40 = 'FLAG_WITH_COMMENT_BACKLOG';

parcelRegister("hxmH6", function(module, exports) {

$parcel$export(module.exports, "cardCreateService", () => $07f3254d890e1979$export$73bba27938f44f97);

var $iTvqy = parcelRequire("iTvqy");

var $hkGxG = parcelRequire("hkGxG");

var $8ZI73 = parcelRequire("8ZI73");

var $kdGmo = parcelRequire("kdGmo");

var $k734R = parcelRequire("k734R");

var $1YFuC = parcelRequire("1YFuC");

var $dtV8v = parcelRequire("dtV8v");

var $1HbG1 = parcelRequire("1HbG1");

var $kLlSf = parcelRequire("kLlSf");
const $07f3254d890e1979$var$createOverrides = (state, cardListId)=>{
    const isSprintCardList = (0, $dtV8v.makeIsSprintCardList)(state);
    const epicLinkShortCustomFieldId = (0, $8ZI73.epicLinkShortCustomFieldIdSelector)(state);
    const sprintShortCustomFieldId = (0, $8ZI73.sprintShortCustomFieldIdSelector)(state);
    const sprintId = isSprintCardList(cardListId) ? Number(cardListId) : undefined;
    const issueParent = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))((0, $k734R.filteredParentsSelector)(state));
    const assignee = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))((0, $kdGmo.getAppliedAssigneeFilters)(state));
    const version = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))((0, $kdGmo.getAppliedVersionFilters)(state));
    const label = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))((0, $kdGmo.getAppliedLabelFilters)(state));
    return {
        ...assignee ? {
            assignee: assignee
        } : {},
        ...sprintId && sprintShortCustomFieldId ? {
            [sprintShortCustomFieldId]: sprintId
        } : {},
        ...issueParent && epicLinkShortCustomFieldId ? {
            [epicLinkShortCustomFieldId]: issueParent.key
        } : {},
        ...version ? {
            fixVersion: version
        } : {},
        ...label ? {
            labels: label
        } : {}
    };
};
function $07f3254d890e1979$export$73bba27938f44f97(serviceContext, store, summaries, issueTypeId, parentId, fixVersions, cardListId, rankBeforeCardId = null, storeFieldsFromCardCreateData, storeFieldsFromFetchIssuesData) {
    if (serviceContext.isCompanyManaged) {
        const state = store.getState();
        const contexts = (0, $1YFuC.jqlContextSelector)(state);
        const epicIssueType = (0, $hkGxG.getEpicIssueType)(state);
        const overrides = $07f3254d890e1979$var$createOverrides(state, cardListId);
        return (0, $kLlSf.inlineCardCreateService)(serviceContext, {
            summary: summaries[0],
            issueTypeId: String(issueTypeId),
            contexts: contexts,
            overrides: overrides,
            epicIssueType: epicIssueType,
            storeFieldsFromFetchIssuesData: storeFieldsFromFetchIssuesData
        });
    }
    return (0, $1HbG1.createMultipleCardService)(store, summaries, issueTypeId, parentId, fixVersions, cardListId, rankBeforeCardId, storeFieldsFromCardCreateData);
}

});
parcelRegister("8ZI73", function(module, exports) {

$parcel$export(module.exports, "getConfig", () => $812f801f27bab08a$export$44487a86467333c3);
$parcel$export(module.exports, "isConfigLoaded", () => $812f801f27bab08a$export$d39ab0d27414dd81);
$parcel$export(module.exports, "isCriticalDataLoaded", () => $812f801f27bab08a$export$d3455c208c1b3727);
$parcel$export(module.exports, "isUserAtLeastMemberOfProject", () => $812f801f27bab08a$export$56dbce3d18728488);
$parcel$export(module.exports, "isInlineIssueCreateAvailableForCurrentUser", () => $812f801f27bab08a$export$61b79888ee8d503a);
$parcel$export(module.exports, "getAllFeatures", () => $812f801f27bab08a$export$a15e774d3d888bb9);
$parcel$export(module.exports, "getShowEpicAsPanel", () => $812f801f27bab08a$export$60ba0c8082dd51bc);
$parcel$export(module.exports, "getEpicLinkField", () => $812f801f27bab08a$export$3a84de4f399e5939);
$parcel$export(module.exports, "getEpicColorFieldId", () => $812f801f27bab08a$export$b02b4f80d1c4ab0b);
$parcel$export(module.exports, "epicLinkShortCustomFieldIdSelector", () => $812f801f27bab08a$export$71a1cd2c8522f4bf);
$parcel$export(module.exports, "sprintShortCustomFieldIdSelector", () => $812f801f27bab08a$export$d1c61551fd7c800e);
$parcel$export(module.exports, "getCanInviteOthersToProject", () => $812f801f27bab08a$export$5124aa00ca92f2c0);

var $df4Sl = parcelRequire("df4Sl");

var $bHPpI = parcelRequire("bHPpI");

var $hkGxG = parcelRequire("hkGxG");

var $7kNqR = parcelRequire("7kNqR");
const $812f801f27bab08a$export$44487a86467333c3 = (state)=>state.config;
const $812f801f27bab08a$export$d39ab0d27414dd81 = (state)=>state.ui.isConfigLoaded;
const $812f801f27bab08a$export$d3455c208c1b3727 = (state)=>state.ui.isCriticalDataLoaded;
const $812f801f27bab08a$export$65853863ca35552 = (state)=>$812f801f27bab08a$export$44487a86467333c3(state).isInlineCardCreateEnabled;
const $812f801f27bab08a$var$canViewBoardAndCreateOrMutateIssues = (state)=>(0, $7kNqR.canViewBoard)(state) && ((0, $7kNqR.canCreateIssues)(state) || (0, $7kNqR.canEditIssue)(state) || (0, $7kNqR.canDeleteIssues)(state) || (0, $7kNqR.canAssignIssues)(state) || (0, $7kNqR.canTransitionIssues)(state) || (0, $7kNqR.canBulkEditIssues)(state));
const $812f801f27bab08a$var$canCreateOrMutateIssues = (state)=>(0, $7kNqR.canCreateIssues)(state) || (0, $7kNqR.canEditIssue)(state) || (0, $7kNqR.canDeleteIssues)(state);
const $812f801f27bab08a$export$56dbce3d18728488 = (state)=>// This is a proxy for the DW idea of Project 'Member' but it's still flawed and not compatible with company-managed permission model.
    // If a user can create, edit or delete issues in this project, they must be at least a Member,
    // and enjoy all the privileges of a Project Member (e.g. creating and ranking issues).
    (0, $hkGxG.getIsCompanyManaged)(state) ? $812f801f27bab08a$var$canViewBoardAndCreateOrMutateIssues(state) : $812f801f27bab08a$var$canCreateOrMutateIssues(state);
const $812f801f27bab08a$export$61b79888ee8d503a = (0, $df4Sl.createSelector)([
    $812f801f27bab08a$export$56dbce3d18728488,
    (0, $hkGxG.getIsCompanyManaged),
    (0, $7kNqR.canCreateIssues)
], (isMember, isCompanyManaged, canUserCreateIssues)=>isCompanyManaged ? canUserCreateIssues : isMember);
const $812f801f27bab08a$export$a15e774d3d888bb9 = (state)=>state.config.allFeatures;
const $812f801f27bab08a$export$60ba0c8082dd51bc = (state)=>!(0, $hkGxG.getIsCompanyManaged)(state) || state.config.showEpicAsPanel;
const $812f801f27bab08a$export$3a84de4f399e5939 = (state)=>state.config.epicLinkField;
const $812f801f27bab08a$export$b02b4f80d1c4ab0b = (state)=>state.config.epicColorFieldId;
const $812f801f27bab08a$export$71a1cd2c8522f4bf = (0, $df4Sl.createSelector)([
    $812f801f27bab08a$export$3a84de4f399e5939
], (epicLinkField)=>epicLinkField?.id ? (0, $bHPpI.toShortCustomFieldId)(epicLinkField?.id) : undefined);
const $812f801f27bab08a$export$d1c61551fd7c800e = (0, $df4Sl.createSelector)([
    (0, $hkGxG.getSprintFieldId)
], (sprintCustomFieldId)=>sprintCustomFieldId ? (0, $bHPpI.toShortCustomFieldId)(sprintCustomFieldId) : undefined);
const $812f801f27bab08a$export$5124aa00ca92f2c0 = (state)=>state.config.canInviteOthersToProject;

});

parcelRegister("1YFuC", function(module, exports) {

$parcel$export(module.exports, "jqlContextSelector", () => $93448efd3730861b$export$a0b5ed948695afc3);

var $df4Sl = parcelRequire("df4Sl");

var $kdGmo = parcelRequire("kdGmo");
const $93448efd3730861b$export$2af3643b1d2591eb = (state)=>state.config.jqlQuery;
const $93448efd3730861b$export$a0b5ed948695afc3 = (0, $df4Sl.createSelector)([
    $93448efd3730861b$export$2af3643b1d2591eb,
    (0, $kdGmo.getAppliedCustomFilterQueries)
], // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
(jqlQuery, jqlCustomFilters)=>[
        jqlQuery,
        ...jqlCustomFilters
    ]);

});

parcelRegister("1HbG1", function(module, exports) {

$parcel$export(module.exports, "createMultipleCardService", () => $e41f5a3b3334e77c$export$76edf6a735664e34);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("iects");

var $9eH8H = parcelRequire("9eH8H");

var $7TyGu = parcelRequire("7TyGu");

var $n82s4 = parcelRequire("n82s4");

var $hkGxG = parcelRequire("hkGxG");

var $h6pBX = parcelRequire("h6pBX");

var $bP7Jx = parcelRequire("bP7Jx");
const $e41f5a3b3334e77c$var$transformer = ({ id: id, done: isDone, flagged: isFlagged, parentId: parentId, fixVersions: fixVersions, issue: { key: key, summary: summary, type: { id: cardTypeId, iconUrl: cardTypeUrl }, labels: labels, status: { id: statusId }, assignee: assignee }, priority: priority, dueDate: dueDate }, projectId)=>({
        id: Number(id),
        key: key,
        summary: summary,
        icon: cardTypeUrl,
        typeId: Number(cardTypeId),
        isDone: isDone,
        labels: labels,
        isFlagged: isFlagged,
        assignee: assignee ? {
            id: assignee.accountId,
            displayName: assignee.displayName,
            avatarUrl: assignee.avatarUrl
        } : null,
        issueUrl: `/browse/${key}`,
        statusId: statusId,
        parentId: parentId || '' ? Number(parentId) : null,
        fixVersions: fixVersions || [],
        priority: priority,
        dueDate: dueDate,
        estimate: null,
        numCompleteChildren: 0,
        numTotalChildren: 0,
        projectId: projectId
    });
const $e41f5a3b3334e77c$export$76edf6a735664e34 = (// TODO: Passing the store is against the architecture, use service-context instead and request objects;
// additionally, don't pass in a callback parameter
store, summaries, issueTypeId, parentId, fixVersions, cardListId, rankBeforeCardId = null, storeFieldsFromCardCreateData)=>{
    const state = store.getState();
    const baseUrl = (0, $hkGxG.getBaseUrl)(state);
    const boardId = (0, $hkGxG.getRapidViewId)(state);
    const storyPointFieldId = (0, $hkGxG.getStoryPointFieldId)(state);
    const assignee = (0, $h6pBX.getMostRecentAssigneeFilter)(state);
    const labels = (0, $h6pBX.getAppliedLabelFilters)(state);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const cardList = (0, $bP7Jx.getCardLists)(state)[cardListId];
    const projectId = (0, $hkGxG.projectIdSelector)(state);
    return (0, $n82s4.default)(baseUrl, {
        boardId: boardId,
        destination: cardList.type,
        destinationId: cardList.type === (0, $7TyGu.SPRINT) ? cardList.id : null,
        newCards: summaries.map((summary)=>({
                summary: summary,
                issueTypeId: issueTypeId,
                parentId: parentId === (0, $9eH8H.UNASSIGNED_EPIC_ID) ? null : parentId,
                fixVersions: fixVersions,
                assigneeId: assignee ? assignee.id : null,
                labels: labels || []
            })),
        rankBeforeCardId: rankBeforeCardId
    }).flatMap((result)=>{
        const fieldConfigs = {
            storyPointFieldId: storyPointFieldId
        };
        // Pre-populate extracted fields (Sweet State) using card create data
        storeFieldsFromCardCreateData(result, fieldConfigs);
        if (result.planModeCardCreate.newCards && result.planModeCardCreate.newCards.length > 0) {
            const transformedCards = result.planModeCardCreate.newCards.map((card)=>$e41f5a3b3334e77c$var$transformer(card, projectId));
            return (0, $3JafE.Observable).of(transformedCards);
        }
        return (0, $3JafE.Observable).of(null);
    });
};

});
parcelRegister("n82s4", function(module, exports) {

$parcel$export(module.exports, "default", () => $901fb4aa18e79c20$export$2e2bcd8739ae039);

var $igbrt = parcelRequire("igbrt");
const $901fb4aa18e79c20$var$MUTATION_NAME = 'BacklogCreateCard';
const $901fb4aa18e79c20$export$e904bac7f43ed94a = ()=>`
    mutation ${$901fb4aa18e79c20$var$MUTATION_NAME} (
        $boardId: ID!,
        $destination: PlanModeDestination!,
        $destinationId: ID,
        $newCards: [NewCard!]!,
        $rankBeforeCardId: Long
    ) {
        planModeCardCreate(input: {
            boardId: $boardId,
            destination: $destination,
            destinationId: $destinationId,
            newCards: $newCards,
            rankBeforeCardId: $rankBeforeCardId
        }) {
            newCards {
                id
                flagged
                done
                parentId
                fixVersions
                issue {
                    id
                    key
                    summary
                    labels
                    status {
                        id
                        name
                        category
                    }
                    assignee {
                        accountId
                        displayName
                        avatarUrl
                    }
                    type {
                        id
                        name
                        iconUrl
                    }
                }
                priority {
                    name
                    iconUrl
                }
                dueDate
            }
        }
    }`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$901fb4aa18e79c20$export$2e2bcd8739ae039 = (baseUrl, input)=>{
    const { boardId: boardId, destination: destination, destinationId: destinationId, newCards: newCards, rankBeforeCardId: rankBeforeCardId } = input;
    const variables = {
        boardId: boardId,
        destination: destination,
        destinationId: destinationId,
        newCards: newCards,
        rankBeforeCardId: rankBeforeCardId
    };
    return (0, $igbrt.mutation$)(baseUrl, $901fb4aa18e79c20$var$MUTATION_NAME, $901fb4aa18e79c20$export$e904bac7f43ed94a(), variables);
};

});

parcelRegister("h6pBX", function(module, exports) {

$parcel$export(module.exports, "getMostRecentAssigneeFilter", () => $50d1024aa8cba6ad$export$aeda5a2993a15e54);
$parcel$export(module.exports, "getAppliedLabelFilters", () => $50d1024aa8cba6ad$export$60ee89f2718fc651);
$parcel$export(module.exports, "getLastAppliedParentFilters", () => $50d1024aa8cba6ad$export$b88c37c6fa8adc17);

var $df4Sl = parcelRequire("df4Sl");

var $iTvqy = parcelRequire("iTvqy");

var $bP7Jx = parcelRequire("bP7Jx");

var $kdGmo = parcelRequire("kdGmo");
const $50d1024aa8cba6ad$export$aeda5a2993a15e54 = (0, $df4Sl.createSelector)((0, $kdGmo.getFilters), (0, $bP7Jx.getOrderedAssignees), (filters, allAssignees)=>{
    const assignees = filters.ASSIGNEE;
    if (assignees && assignees.length > 0) {
        const lastSelectedKey = assignees[assignees.length - 1];
        const lastSelected = allAssignees.find((assignee)=>assignee.id === lastSelectedKey);
        if (lastSelected) return lastSelected;
    }
    return null;
});
const $50d1024aa8cba6ad$export$60ee89f2718fc651 = (state)=>{
    const labels = state.ui.filters.LABEL;
    if (labels && labels.length > 0) return labels;
    return null;
};
const $50d1024aa8cba6ad$export$b88c37c6fa8adc17 = (0, $df4Sl.createSelector)((0, $kdGmo.getAppliedParentFilters), (parentIds)=>{
    if (parentIds && parentIds.length > 0) return Number((0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))(parentIds));
    return null;
});

});


parcelRegister("kLlSf", function(module, exports) {

$parcel$export(module.exports, "inlineCardCreateService", () => $de42ccff600a4cce$export$239dafa7fe96b795);
parcelRequire("jyKN9");
parcelRequire("flmol");
parcelRequire("iects");

var $huNLe = parcelRequire("huNLe");

var $hkNTt = parcelRequire("hkNTt");

var $crCnG = parcelRequire("crCnG");
const $de42ccff600a4cce$var$fetchNewlyCreatedIssue = (boardId)=>(inlineCreateResponse)=>(0, $hkNTt.fetchIssue)(boardId, Number(inlineCreateResponse.issue.issueId));
const $de42ccff600a4cce$var$updateIssueConfigStore = (epicIssueType, storeFieldsFromFetchIssuesData)=>(issue)=>{
        storeFieldsFromFetchIssuesData([
            issue
        ], epicIssueType);
        return issue;
    };
const $de42ccff600a4cce$var$transformIssueToCard = (issue)=>[
        (0, $huNLe.transformCard)(issue)
    ];
function $de42ccff600a4cce$export$239dafa7fe96b795(serviceContext, { summary: summary, issueTypeId: issueTypeId, contexts: contexts, overrides: overrides, epicIssueType: epicIssueType, storeFieldsFromFetchIssuesData: storeFieldsFromFetchIssuesData }) {
    return (0, $crCnG.inlineCreateIssue)({
        summary: summary,
        issueTypeId: issueTypeId,
        contexts: contexts,
        overrides: overrides
    }).flatMap($de42ccff600a4cce$var$fetchNewlyCreatedIssue(serviceContext.boardId)).map($de42ccff600a4cce$var$updateIssueConfigStore(epicIssueType, storeFieldsFromFetchIssuesData)).map($de42ccff600a4cce$var$transformIssueToCard);
}

});
parcelRegister("huNLe", function(module, exports) {

$parcel$export(module.exports, "transformCard", () => $4b68eeb0c2aa4f70$export$dcbde76ab89d36a);

var $ldoFd = parcelRequire("ldoFd");

var $3l6tm = parcelRequire("3l6tm");

var $7TyGu = parcelRequire("7TyGu");

var $6MSC2 = parcelRequire("6MSC2");

var $1ZZJ4 = parcelRequire("1ZZJ4");
const $4b68eeb0c2aa4f70$var$isNumericFieldEstimate = (statisticField)=>statisticField && statisticField?.statFieldId?.includes((0, $7TyGu.NUMERIC_ESTIMATE_FIELD_ID_PREFIX));
const $4b68eeb0c2aa4f70$var$isTimeOriginalEstimate = (statisticField)=>statisticField && statisticField?.statFieldId?.startsWith((0, $7TyGu.ORIGINAL_ESTIMATE_ID));
const $4b68eeb0c2aa4f70$var$transformEstimateStatistic = ({ estimateStatistic: estimateStatistic, trackingStatistic: trackingStatistic })=>{
    const timeRemainingEstimate = trackingStatistic?.statFieldValue ? {
        value: trackingStatistic?.statFieldValue?.value || 0,
        valueAsText: trackingStatistic?.statFieldValue?.text || ''
    } : null;
    const storyPoints = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(estimateStatistic) && $4b68eeb0c2aa4f70$var$isNumericFieldEstimate(estimateStatistic) && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(estimateStatistic?.statFieldValue?.value) ? Number(estimateStatistic?.statFieldValue?.value) : null;
    const originalEstimate = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(estimateStatistic) && $4b68eeb0c2aa4f70$var$isTimeOriginalEstimate(estimateStatistic) && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(estimateStatistic?.statFieldValue?.value) && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(estimateStatistic?.statFieldValue?.text) ? {
        value: estimateStatistic?.statFieldValue?.value,
        valueAsText: estimateStatistic?.statFieldValue?.text
    } : null;
    return {
        storyPoints: storyPoints,
        originalEstimate: originalEstimate,
        timeRemainingEstimate: timeRemainingEstimate
    };
};
const $4b68eeb0c2aa4f70$var$transformPriority = ({ priorityName: priorityName, priorityUrl: priorityUrl })=>priorityName && priorityUrl ? {
        name: priorityName,
        iconUrl: priorityUrl
    } : null;
const $4b68eeb0c2aa4f70$var$transformAssignee = ({ assigneeAccountId: assigneeAccountId, assigneeName: assigneeName, avatarUrl: avatarUrl })=>assigneeAccountId && assigneeName && avatarUrl ? {
        id: assigneeAccountId,
        displayName: assigneeName,
        avatarUrl: avatarUrl
    } : null;
const $4b68eeb0c2aa4f70$var$transformParentId = (issue)=>{
    if ((0, $3l6tm.isSubtaskHierarchyLevel)(issue.typeHierarchyLevel)) return issue.parentId ?? null;
    if (!(0, $1ZZJ4.hasEpicField)(issue) || !(0, $1ZZJ4.isEpicField)(issue.epicField)) return null;
    return issue.epicField.issueId ?? null;
};
const $4b68eeb0c2aa4f70$var$toExtraField = (extraField)=>{
    const { id: id, label: label, renderer: renderer, text: text, html: html } = extraField;
    if ((0, $6MSC2.isExtraFieldHtml)(extraField)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        id: id,
        label: label,
        renderer: renderer,
        html: html
    };
    if ((0, $6MSC2.isExtraFieldDate)(extraField)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        id: id,
        label: label,
        renderer: renderer,
        text: text,
        html: html
    };
    if ((0, $6MSC2.isExtraFieldText)(extraField)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        id: id,
        label: label,
        renderer: renderer,
        text: text
    };
    return undefined;
};
const $4b68eeb0c2aa4f70$var$transformCardExtraFields = (issue)=>(issue?.extraFields ?? []).map($4b68eeb0c2aa4f70$var$toExtraField).filter(Boolean);
const $4b68eeb0c2aa4f70$var$getIssueEpicColor = (issue)=>(0, $1ZZJ4.hasEpicField)(issue) ? issue.epicField.color || issue.epicField.epicColor : issue.color;
const $4b68eeb0c2aa4f70$export$dcbde76ab89d36a = (issue)=>({
        id: issue.id,
        key: issue.key,
        summary: issue.summary,
        labels: issue.labels ?? [],
        assignee: $4b68eeb0c2aa4f70$var$transformAssignee(issue),
        typeId: Number(issue.typeId),
        icon: issue.typeUrl,
        isDone: issue.done,
        isFlagged: issue.flagged,
        issueUrl: `/browse/${issue.key}`,
        statusId: issue.statusId,
        parentId: $4b68eeb0c2aa4f70$var$transformParentId(issue),
        parentKey: issue.parentKey,
        priority: $4b68eeb0c2aa4f70$var$transformPriority(issue),
        projectId: issue.projectId,
        dueDate: null,
        estimate: $4b68eeb0c2aa4f70$var$transformEstimateStatistic(issue),
        numCompleteChildren: 0,
        numTotalChildren: 0,
        fixVersions: issue.fixVersions?.map(String),
        color: issue.color,
        epicColor: $4b68eeb0c2aa4f70$var$getIssueEpicColor(issue),
        extraFields: $4b68eeb0c2aa4f70$var$transformCardExtraFields(issue),
        typeHierarchyLevel: issue.typeHierarchyLevel,
        hidden: issue.hidden
    });

});
parcelRegister("6MSC2", function(module, exports) {

$parcel$export(module.exports, "isExtraFieldHtml", () => $2c3a8a8878df84cd$export$d1fe808976407c4c);
$parcel$export(module.exports, "isExtraFieldDate", () => $2c3a8a8878df84cd$export$da33088c7c3e5cb2);
$parcel$export(module.exports, "isExtraFieldLabel", () => $2c3a8a8878df84cd$export$748f5a82c0532889);
$parcel$export(module.exports, "isExtraFieldThumbnail", () => $2c3a8a8878df84cd$export$236190af5d6fde4c);
$parcel$export(module.exports, "isExtraFieldText", () => $2c3a8a8878df84cd$export$899a90d8d4afc87b);

var $lO4Or = parcelRequire("lO4Or");

function $2c3a8a8878df84cd$var$isExtraField(field, rendererTypes = []) {
    if (field !== null && typeof field === 'object' && 'renderer' in field) return rendererTypes.some((rendererType)=>field?.renderer === rendererType);
    return false;
}
function $2c3a8a8878df84cd$export$d1fe808976407c4c(field) {
    return $2c3a8a8878df84cd$var$isExtraField(field, [
        (0, $261cf0e5c4e37500$export$bda4531b1a353ad5)
    ]) && 'html' in field;
}
function $2c3a8a8878df84cd$export$da33088c7c3e5cb2(field) {
    return $2c3a8a8878df84cd$var$isExtraField(field, [
        (0, $261cf0e5c4e37500$export$17bb0a20b1f25353)
    ]);
}
function $2c3a8a8878df84cd$export$748f5a82c0532889(field) {
    return $2c3a8a8878df84cd$var$isExtraField(field, [
        (0, $261cf0e5c4e37500$export$9b9dcd4746c10184)
    ]) && field.id === (0, $lO4Or.LABELS_TYPE);
}
function $2c3a8a8878df84cd$export$236190af5d6fde4c(field) {
    return $2c3a8a8878df84cd$export$d1fe808976407c4c(field) && field.id === (0, $261cf0e5c4e37500$export$a44cd70654f485a4);
}
function $2c3a8a8878df84cd$export$899a90d8d4afc87b(field) {
    return $2c3a8a8878df84cd$var$isExtraField(field, [
        (0, $261cf0e5c4e37500$export$9b9dcd4746c10184),
        (0, $261cf0e5c4e37500$export$110883b3780f4ea),
        (0, $261cf0e5c4e37500$export$bde36270f821fce6),
        (0, $261cf0e5c4e37500$export$8edb5204f086f2f1)
    ]);
}

});
const $261cf0e5c4e37500$export$9b9dcd4746c10184 = 'text';
const $261cf0e5c4e37500$export$8edb5204f086f2f1 = 'status';
const $261cf0e5c4e37500$export$bde36270f821fce6 = 'duration';
const $261cf0e5c4e37500$export$110883b3780f4ea = 'number';
const $261cf0e5c4e37500$export$17bb0a20b1f25353 = 'date';
const $261cf0e5c4e37500$export$bda4531b1a353ad5 = 'html';
const $261cf0e5c4e37500$export$a44cd70654f485a4 = 'thumbnail';



parcelRegister("hkNTt", function(module, exports) {

$parcel$export(module.exports, "fetchIssue", () => $c81b5411fc5c2daf$export$dcd87b70796c5c27);

var $aiRd8 = parcelRequire("aiRd8");
function $c81b5411fc5c2daf$export$dcd87b70796c5c27(boardId, issueId) {
    return (0, $aiRd8.default)(`/rest/greenhopper/1.0/xboard/plan/backlog/issue.json?rapidViewId=${boardId}&issueId=${issueId}`);
}

});

parcelRegister("crCnG", function(module, exports) {

$parcel$export(module.exports, "inlineCreateIssue", () => $77a6c63dce255f19$export$6a4019ebc77bfcad);

var $aiRd8 = parcelRequire("aiRd8");
function $77a6c63dce255f19$export$6a4019ebc77bfcad({ summary: summary, issueTypeId: issueTypeId, contexts: contexts, overrides: overrides }) {
    return (0, $aiRd8.default)('/rest/inline-create/1.0/issue', {
        method: 'POST',
        body: JSON.stringify({
            summary: summary,
            issueTypeId: issueTypeId,
            contexts: contexts,
            overrides: overrides
        })
    });
}

});



parcelRegister("lEnU0", function(module, exports) {

$parcel$export(module.exports, "makeServiceContext", () => $88b788d9dae25a46$export$47bf8333d7adacd0);

var $hkGxG = parcelRequire("hkGxG");
function $88b788d9dae25a46$export$47bf8333d7adacd0(state) {
    return {
        boardId: (0, $hkGxG.getRapidViewId)(state),
        isCompanyManaged: (0, $hkGxG.getIsCompanyManaged)(state)
    };
}

});

parcelRegister("cbRhO", function(module, exports) {

$parcel$export(module.exports, "OPEN_MODAL", () => $e86676fca9f6dd0f$export$d1956215992c54b);
$parcel$export(module.exports, "openModal", () => $e86676fca9f6dd0f$export$a7f6cffb6b8ba11c);
$parcel$export(module.exports, "CLOSE_MODAL", () => $e86676fca9f6dd0f$export$d984830de9a39518);
$parcel$export(module.exports, "closeModal", () => $e86676fca9f6dd0f$export$3f6fecd573f3fa48);
const $e86676fca9f6dd0f$export$d1956215992c54b = 'state.actions.modals.OPEN_MODAL';
const $e86676fca9f6dd0f$export$a7f6cffb6b8ba11c = (payload)=>({
        type: $e86676fca9f6dd0f$export$d1956215992c54b,
        payload: payload
    });
const $e86676fca9f6dd0f$export$d984830de9a39518 = 'state.actions.modals.CLOSE_MODAL';
const $e86676fca9f6dd0f$export$3f6fecd573f3fa48 = ()=>({
        type: $e86676fca9f6dd0f$export$d984830de9a39518
    });

});

parcelRegister("6iBIZ", function(module, exports) {

$parcel$export(module.exports, "SET_VERSIONS", () => $401973fb039d7bbb$export$8d55849a0d8ef0c7);
$parcel$export(module.exports, "setVersions", () => $401973fb039d7bbb$export$44737a4035599644);
$parcel$export(module.exports, "UPDATE_VERSION", () => $401973fb039d7bbb$export$c4aaf486103b8376);
$parcel$export(module.exports, "updateVersion", () => $401973fb039d7bbb$export$5652a4ac6807e581);
$parcel$export(module.exports, "REFETCH_VERSIONS", () => $401973fb039d7bbb$export$a4ef9c1f4cfa323c);
$parcel$export(module.exports, "refetchVersions", () => $401973fb039d7bbb$export$70fb16a0ad235611);
const $401973fb039d7bbb$export$8d55849a0d8ef0c7 = 'state.actions.version.SET_VERSIONS';
const $401973fb039d7bbb$export$44737a4035599644 = (payload)=>({
        type: $401973fb039d7bbb$export$8d55849a0d8ef0c7,
        payload: payload
    });
const $401973fb039d7bbb$export$c4aaf486103b8376 = 'state.actions.version.UPDATE_VERSION';
const $401973fb039d7bbb$export$5652a4ac6807e581 = (version)=>({
        type: $401973fb039d7bbb$export$c4aaf486103b8376,
        payload: {
            version: version
        }
    });
const $401973fb039d7bbb$export$a4ef9c1f4cfa323c = 'state.actions.version.REFETCH_VERSIONS';
const $401973fb039d7bbb$export$70fb16a0ad235611 = ()=>({
        type: $401973fb039d7bbb$export$a4ef9c1f4cfa323c
    });

});

parcelRegister("lk2Zu", function(module, exports) {

$parcel$export(module.exports, "getInlineCreateSessionId", () => $c049b47510a25c5b$export$12a9e7e0a7f5b591);
$parcel$export(module.exports, "getCardTypesForICC", () => $c049b47510a25c5b$export$544c7fd474a93225);

var $df4Sl = parcelRequire("df4Sl");

var $3l6tm = parcelRequire("3l6tm");

var $hkGxG = parcelRequire("hkGxG");

var $6ncr6 = parcelRequire("6ncr6");

var $8ZI73 = parcelRequire("8ZI73");

var $kF7v3 = parcelRequire("kF7v3");
const $c049b47510a25c5b$export$1ca4cd34e6f2914c = (state)=>(0, $kF7v3.getEntities)(state).inlineCreate;
const $c049b47510a25c5b$export$12a9e7e0a7f5b591 = (0, $df4Sl.createSelector)([
    $c049b47510a25c5b$export$1ca4cd34e6f2914c
], (inlineCreateState)=>inlineCreateState?.sessionId);
const $c049b47510a25c5b$var$getInlineCreateCardTypeIds = (0, $df4Sl.createSelector)([
    $c049b47510a25c5b$export$1ca4cd34e6f2914c
], (inlineCreate)=>inlineCreate.cardTypeIds);
const $c049b47510a25c5b$export$544c7fd474a93225 = (0, $df4Sl.createSelector)([
    (0, $6ncr6.getCardTypes),
    $c049b47510a25c5b$var$getInlineCreateCardTypeIds,
    (0, $hkGxG.isCmpKanbanProject),
    (0, $8ZI73.getShowEpicAsPanel)
], (cardTypes, cardTypeIds, isCmpKanban, showEpicAsPanel)=>cardTypes.filter((cardType)=>isCmpKanban && !showEpicAsPanel ? cardType.typeHierarchyLevel === (0, $3l6tm.EPIC_PARENT_HIERARCHY_TYPE) || cardType.typeHierarchyLevel === (0, $3l6tm.BASE_HIERARCHY_TYPE) : cardType.typeHierarchyLevel === (0, $3l6tm.BASE_HIERARCHY_TYPE)).filter((cardType)=>cardTypeIds?.includes(cardType.id)));

});


parcelRegister("7336F", function(module, exports) {

$parcel$export(module.exports, "cardDeleteEpic", () => $8830b5d831167eb8$export$eb4bca8cd893632);
parcelRequire("9u6v2");
parcelRequire("1Lcr1");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");

var $7TyGu = parcelRequire("7TyGu");

var $cuwzH = parcelRequire("cuwzH");

var $e3Gc5 = parcelRequire("e3Gc5");

var $jiL2Q = parcelRequire("jiL2Q");

var $c4hFt = parcelRequire("c4hFt");

var $hkGxG = parcelRequire("hkGxG");
const $8830b5d831167eb8$export$eb4bca8cd893632 = (getLocation, push)=>(action$, store)=>action$.ofType((0, $c4hFt.CARD_DELETE_REQUEST)).mergeMap((action)=>{
            const { payload: { cardId: cardId }, meta: { optimistic: { id: optimisticId } } } = action;
            const state = store.getState();
            const baseUrl = (0, $hkGxG.getBaseUrl)(state);
            push((0, $e3Gc5.removeSelectedIssueFromUrl)(getLocation()));
            return (0, $cuwzH.default)(baseUrl, String(cardId)).flatMap(()=>{
                const actions = [
                    (0, $c4hFt.cardDeleteSuccess)(cardId, optimisticId)
                ];
                return (0, $3JafE.Observable).from(actions);
            }).catch(()=>(0, $3JafE.Observable).from([
                    (0, $c4hFt.cardDeleteFailure)(cardId, optimisticId),
                    (0, $jiL2Q.refreshDataRequest)((0, $7TyGu.REFRESH_SOURCE_FAILURE))
                ]));
        });

});
parcelRegister("cuwzH", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f1fa6b151d586ec$export$2e2bcd8739ae039);

var $fENSg = parcelRequire("fENSg");
var $5f1fa6b151d586ec$export$2e2bcd8739ae039 = (0, $fENSg.default);

});
parcelRegister("fENSg", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbb6a81034431ad0$export$2e2bcd8739ae039);

var $igbrt = parcelRequire("igbrt");
const $bbb6a81034431ad0$var$MUTATION_NAME = 'BacklogDeleteCard';
const $bbb6a81034431ad0$export$e904bac7f43ed94a = ()=>`mutation ${$bbb6a81034431ad0$var$MUTATION_NAME} ($issueId: ID!) {
        deleteCard(issueId: $issueId) {
            success
        }
    }`;
const $bbb6a81034431ad0$var$cardDeleteGraphql = (baseUrl, issueId)=>// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    (0, $igbrt.mutation$)(baseUrl, $bbb6a81034431ad0$var$MUTATION_NAME, $bbb6a81034431ad0$export$e904bac7f43ed94a(), {
        issueId: issueId
    });
var $bbb6a81034431ad0$export$2e2bcd8739ae039 = $bbb6a81034431ad0$var$cardDeleteGraphql;

});


parcelRegister("c4hFt", function(module, exports) {

$parcel$export(module.exports, "CARD_DELETE_REQUEST", () => $a6d06d041cc040f6$export$9bc1d1c298c8f5af);
$parcel$export(module.exports, "cardDeleteRequest", () => $a6d06d041cc040f6$export$d2ea563d7459b747);
$parcel$export(module.exports, "CARD_DELETE_SUCCESS", () => $a6d06d041cc040f6$export$c9235af922e153a1);
$parcel$export(module.exports, "cardDeleteSuccess", () => $a6d06d041cc040f6$export$abf29851b85a5dc);
$parcel$export(module.exports, "CARD_DELETE_FAILURE", () => $a6d06d041cc040f6$export$229ed28ef1c0b98);
$parcel$export(module.exports, "cardDeleteFailure", () => $a6d06d041cc040f6$export$14995a1d9fdd27aa);
$parcel$export(module.exports, "CARD_DELETE", () => $a6d06d041cc040f6$export$b82590935cfab60f);
$parcel$export(module.exports, "cardDelete", () => $a6d06d041cc040f6$export$ba9d764de574147c);

var $jWq1L = parcelRequire("jWq1L");
const $a6d06d041cc040f6$export$9bc1d1c298c8f5af = 'state.actions.cards.delete.CARD_DELETE_REQUEST';
const $a6d06d041cc040f6$export$d2ea563d7459b747 = (payload)=>({
        type: $a6d06d041cc040f6$export$9bc1d1c298c8f5af,
        payload: payload,
        meta: {
            ...(0, $jWq1L.beginOptimisticUiMeta)()
        }
    });
const $a6d06d041cc040f6$export$c9235af922e153a1 = 'state.actions.cards.delete.CARD_DELETE_SUCCESS';
const $a6d06d041cc040f6$export$abf29851b85a5dc = (cardId, optimisticId)=>({
        type: $a6d06d041cc040f6$export$c9235af922e153a1,
        payload: {
            cardId: cardId
        },
        meta: (0, $jWq1L.commitOptimisticUiMeta)(optimisticId)
    });
const $a6d06d041cc040f6$export$229ed28ef1c0b98 = 'state.actions.cards.delete.CARD_DELETE_FAILURE';
const $a6d06d041cc040f6$export$14995a1d9fdd27aa = (cardId, optimisticId)=>({
        type: $a6d06d041cc040f6$export$229ed28ef1c0b98,
        payload: {
            cardId: cardId
        },
        meta: (0, $jWq1L.revertOptimisticUiWithFlagMeta)(optimisticId)
    });
const $a6d06d041cc040f6$export$b82590935cfab60f = 'state.actions.cards.delete.CARD_DELETE';
const $a6d06d041cc040f6$export$ba9d764de574147c = (cardId)=>({
        type: $a6d06d041cc040f6$export$b82590935cfab60f,
        payload: {
            cardId: cardId
        }
    });

});


parcelRegister("j4slN", function(module, exports) {

$parcel$export(module.exports, "cardGroupToggleEpic", () => $bcab1bd744aea5de$export$dcdf634c78f06f28);

var $3JafE = parcelRequire("3JafE");
parcelRequire("8jBvP");
parcelRequire("iects");

var $iYUz7 = parcelRequire("iYUz7");

var $7TN4i = parcelRequire("7TN4i");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");
const $bcab1bd744aea5de$export$dcdf634c78f06f28 = (action$, store)=>action$.ofType((0, $7TN4i.CARD_GROUP_TOGGLE), (0, $7TN4i.COLLAPSE_ALL_CARD_GROUPS), (0, $7TN4i.SET_EXPANDED_CARD_GROUP)).flatMap(()=>{
        const state = store.getState();
        const expandedCardGroups = (0, $bP7Jx.getExpandedCardGroups)(state);
        (0, $iYUz7.setBacklogCardGroupSettings)(Number((0, $hkGxG.getRapidViewId)(state)), expandedCardGroups);
        return (0, $3JafE.Observable).empty();
    });

});
parcelRegister("iYUz7", function(module, exports) {

$parcel$export(module.exports, "getDetailViewWidthRatio", () => $bfb971e88dad1812$export$5a9c556da9744b1b);
$parcel$export(module.exports, "setDetailViewWidthRatio", () => $bfb971e88dad1812$export$d194f7c4bdc33538);
$parcel$export(module.exports, "getBacklogSettings", () => $bfb971e88dad1812$export$385952056bbb1deb);
$parcel$export(module.exports, "setBacklogSettings", () => $bfb971e88dad1812$export$6ddb49680d7ce77d);
$parcel$export(module.exports, "getPanelStateOld", () => $bfb971e88dad1812$export$87f4e6f908d51646);
$parcel$export(module.exports, "getPanelState", () => $bfb971e88dad1812$export$6f4f3781f70858b9);
$parcel$export(module.exports, "setPanelStateOld", () => $bfb971e88dad1812$export$58bb10ae80996d55);
$parcel$export(module.exports, "setPanelState", () => $bfb971e88dad1812$export$5554b6f93f40abe5);
$parcel$export(module.exports, "unsetPanelState", () => $bfb971e88dad1812$export$48192827b67d2f17);
$parcel$export(module.exports, "getBacklogCardGroupSettings", () => $bfb971e88dad1812$export$74b19271af6b55e5);
$parcel$export(module.exports, "setBacklogCardGroupSettings", () => $bfb971e88dad1812$export$d5b7ae0d62d4ef81);
$parcel$export(module.exports, "getWorkloadSubtaskSettings", () => $bfb971e88dad1812$export$b1494519a5c8386e);
$parcel$export(module.exports, "setWorkloadSubtaskSettings", () => $bfb971e88dad1812$export$fc1a0f95945c8afd);

var $7GXrf = parcelRequire("7GXrf");

var $aZaPn = parcelRequire("aZaPn");

var $5YMxX = parcelRequire("5YMxX");
const $bfb971e88dad1812$var$localStorage = (0, $aZaPn.createLocalStorageProvider)('backlog');
const $bfb971e88dad1812$var$DETAIL_VIEW_WIDTH_RATIO = 'gh.detailViewWidth';
const $bfb971e88dad1812$var$BACKLOG_SETTINGS_PREFIX = 'gh.backlogSettings.';
const $bfb971e88dad1812$var$BACKLOG_CARDGROUP_SETTINGS_PREFIX = 'gh.backlogCardGroupSettings.';
const $bfb971e88dad1812$var$PANEL_STATE = 'panel-state';
const $bfb971e88dad1812$var$WORKLOAD_MODAL_SUBTASKS = 'gh.workloadModal.subtasks';
const $bfb971e88dad1812$export$5a9c556da9744b1b = ()=>{
    const value = $bfb971e88dad1812$var$localStorage.get($bfb971e88dad1812$var$DETAIL_VIEW_WIDTH_RATIO);
    return value ? Number(value) : 0;
};
const $bfb971e88dad1812$export$d194f7c4bdc33538 = (ratio)=>$bfb971e88dad1812$var$localStorage.set($bfb971e88dad1812$var$DETAIL_VIEW_WIDTH_RATIO, ratio);
const $bfb971e88dad1812$export$385952056bbb1deb = (boardId)=>{
    const data = $bfb971e88dad1812$var$localStorage.get(`${$bfb971e88dad1812$var$BACKLOG_SETTINGS_PREFIX}${boardId}`);
    if (!data || !data.collapsedCardLists) return {};
    return data;
};
const $bfb971e88dad1812$export$6ddb49680d7ce77d = (boardId, settings)=>{
    $bfb971e88dad1812$var$localStorage.set(`${$bfb971e88dad1812$var$BACKLOG_SETTINGS_PREFIX}${boardId}`, settings);
};
const $bfb971e88dad1812$export$87f4e6f908d51646 = ()=>$bfb971e88dad1812$var$localStorage.get($bfb971e88dad1812$var$PANEL_STATE);
const $bfb971e88dad1812$export$6f4f3781f70858b9 = (boardId)=>$bfb971e88dad1812$var$localStorage.get(`${$bfb971e88dad1812$var$PANEL_STATE}-${boardId}`);
const $bfb971e88dad1812$export$58bb10ae80996d55 = (panelState)=>$bfb971e88dad1812$var$localStorage.set($bfb971e88dad1812$var$PANEL_STATE, panelState);
const $bfb971e88dad1812$export$5554b6f93f40abe5 = (panelState, boardId)=>{
    const currentPanelState = $bfb971e88dad1812$export$6f4f3781f70858b9(boardId) || [];
    if (!currentPanelState.includes(panelState)) $bfb971e88dad1812$var$localStorage.set(`${$bfb971e88dad1812$var$PANEL_STATE}-${boardId}`, [
        ...currentPanelState,
        panelState
    ]);
};
const $bfb971e88dad1812$export$b31b38479befe75d = (panels, boardId)=>{
    const openPanels = Object.entries(panels).filter(([_, value])=>value === true).map(([key])=>key);
    $bfb971e88dad1812$var$localStorage.set(`${$bfb971e88dad1812$var$PANEL_STATE}-${boardId}`, openPanels);
};
const $bfb971e88dad1812$export$48192827b67d2f17 = (panelState, boardId)=>{
    const currentPanelState = $bfb971e88dad1812$export$6f4f3781f70858b9(boardId);
    if (currentPanelState?.includes(panelState)) $bfb971e88dad1812$var$localStorage.set(`${$bfb971e88dad1812$var$PANEL_STATE}-${boardId}`, (0, (/*@__PURE__*/$parcel$interopDefault($7GXrf)))(currentPanelState, panelState));
};
const $bfb971e88dad1812$export$74b19271af6b55e5 = (boardId)=>{
    const data = $bfb971e88dad1812$var$localStorage.get(`${$bfb971e88dad1812$var$BACKLOG_CARDGROUP_SETTINGS_PREFIX}${boardId}`);
    return data ?? {};
};
const $bfb971e88dad1812$export$d5b7ae0d62d4ef81 = (boardId, settings)=>{
    $bfb971e88dad1812$var$localStorage.set(`${$bfb971e88dad1812$var$BACKLOG_CARDGROUP_SETTINGS_PREFIX}${boardId}`, settings);
};
const $bfb971e88dad1812$export$b1494519a5c8386e = ()=>{
    const data = $bfb971e88dad1812$var$localStorage.get($bfb971e88dad1812$var$WORKLOAD_MODAL_SUBTASKS);
    return !!data;
};
const $bfb971e88dad1812$export$fc1a0f95945c8afd = (includeSubtasks)=>{
    $bfb971e88dad1812$var$localStorage.set($bfb971e88dad1812$var$WORKLOAD_MODAL_SUBTASKS, includeSubtasks);
};

});
parcelRegister("7GXrf", function(module, exports) {

var $fa0Ox = parcelRequire("fa0Ox");

var $9eFtX = parcelRequire("9eFtX");

var $cRpul = parcelRequire("cRpul");
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var $599a8fe1eb632ef8$var$without = $9eFtX(function(array, values) {
    return $cRpul(array) ? $fa0Ox(array, values) : [];
});
module.exports = $599a8fe1eb632ef8$var$without;

});

parcelRegister("5YMxX", function(module, exports) {

$parcel$export(module.exports, "getHideEpics", () => $67044be34289d592$export$344e252cb642fb56);
$parcel$export(module.exports, "getHideStatuses", () => $67044be34289d592$export$d3997e0a815ec9a9);
$parcel$export(module.exports, "getHideVersions", () => $67044be34289d592$export$bccf76194364adbb);
const $67044be34289d592$var$HIDE_EPIC_FIELD_PREFIX = 'gh.epicShownOnRapidBoard.';
const $67044be34289d592$var$HIDE_STATUS_FIELD_PREFIX = 'gh.statusShownOnRapidBoard.';
const $67044be34289d592$var$HIDE_VERSION_FIELD_PREFIX = 'gh.versionShownOnRapidBoard.';
const $67044be34289d592$export$344e252cb642fb56 = (boardId)=>localStorage.getItem(`${$67044be34289d592$var$HIDE_EPIC_FIELD_PREFIX}${boardId}`) === 'false';
const $67044be34289d592$export$c9ac14c6e06788a3 = (boardId, hideEpics)=>localStorage.setItem(`${$67044be34289d592$var$HIDE_EPIC_FIELD_PREFIX}${boardId}`, (!hideEpics).toString());
const $67044be34289d592$export$d3997e0a815ec9a9 = (boardId)=>localStorage.getItem(`${$67044be34289d592$var$HIDE_STATUS_FIELD_PREFIX}${boardId}`) === 'false';
const $67044be34289d592$export$66dad339f6bd60a0 = (boardId, hideStatuses)=>localStorage.setItem(`${$67044be34289d592$var$HIDE_STATUS_FIELD_PREFIX}${boardId}`, (!hideStatuses).toString());
const $67044be34289d592$export$bccf76194364adbb = (boardId)=>localStorage.getItem(`${$67044be34289d592$var$HIDE_VERSION_FIELD_PREFIX}${boardId}`) === 'false';
const $67044be34289d592$export$828020f0cfbd3e66 = (boardId, hideVersions)=>localStorage.setItem(`${$67044be34289d592$var$HIDE_VERSION_FIELD_PREFIX}${boardId}`, (!hideVersions).toString());

});


parcelRegister("7TN4i", function(module, exports) {

$parcel$export(module.exports, "CARD_LIST_TOGGLE", () => $60c545eda9f36c75$export$8ac407f033388640);
$parcel$export(module.exports, "cardListToggle", () => $60c545eda9f36c75$export$90d6f3c77a83064c);
$parcel$export(module.exports, "SET_COLLAPSED_CARD_LIST", () => $60c545eda9f36c75$export$8e3dbeb7df2e2eed);
$parcel$export(module.exports, "setCollapsedCardLists", () => $60c545eda9f36c75$export$5f2a6b9a0552b438);
$parcel$export(module.exports, "CARD_LISTS_DISABLE", () => $60c545eda9f36c75$export$cc7cd3c4009760cc);
$parcel$export(module.exports, "cardListsDisable", () => $60c545eda9f36c75$export$3bb589b09264f63f);
$parcel$export(module.exports, "CARD_LISTS_ENABLE_ALL", () => $60c545eda9f36c75$export$649d537a55101566);
$parcel$export(module.exports, "cardListsEnableAll", () => $60c545eda9f36c75$export$f44d80a86eadf7f4);
$parcel$export(module.exports, "CARD_LIST_DRAG_START", () => $60c545eda9f36c75$export$dc86559f09e710b9);
$parcel$export(module.exports, "cardListDragStart", () => $60c545eda9f36c75$export$87075c8b80f899ee);
$parcel$export(module.exports, "CARD_LIST_DRAG_END", () => $60c545eda9f36c75$export$39a50360ed362605);
$parcel$export(module.exports, "cardListDragEnd", () => $60c545eda9f36c75$export$e6bf5fbe83cd7d74);
$parcel$export(module.exports, "CARD_GROUP_TOGGLE", () => $60c545eda9f36c75$export$bde12efd87a4ac85);
$parcel$export(module.exports, "cardGroupToggle", () => $60c545eda9f36c75$export$92a3d8e003e4f107);
$parcel$export(module.exports, "SET_COLLAPSED_CARD_GROUP", () => $60c545eda9f36c75$export$9da147a1292f7381);
$parcel$export(module.exports, "SET_EXPANDED_CARD_GROUP", () => $60c545eda9f36c75$export$3f7371c8d6ee730e);
$parcel$export(module.exports, "setCollapsedCardGroups", () => $60c545eda9f36c75$export$b56fc1f894629222);
$parcel$export(module.exports, "setExpandedCardGroups", () => $60c545eda9f36c75$export$7ff65c0e4fbb1fb);
$parcel$export(module.exports, "CLEAR_COLLAPSED_CARD_GROUP", () => $60c545eda9f36c75$export$f79940d7e9a921f6);
$parcel$export(module.exports, "CLEAR_EXPANDED_CARD_GROUP", () => $60c545eda9f36c75$export$a93c0bd80b95451c);
$parcel$export(module.exports, "clearExpandedCardGroup", () => $60c545eda9f36c75$export$f3ccf76393691844);
$parcel$export(module.exports, "COLLAPSE_ALL_CARD_GROUPS", () => $60c545eda9f36c75$export$a081f6cfebf37017);
$parcel$export(module.exports, "collapseAllCardGroups", () => $60c545eda9f36c75$export$5f921ba0e1020c03);
const $60c545eda9f36c75$export$8ac407f033388640 = 'state.actions.card-list.CARD_LIST_TOGGLE';
const $60c545eda9f36c75$export$90d6f3c77a83064c = (cardListId)=>({
        type: $60c545eda9f36c75$export$8ac407f033388640,
        payload: {
            cardListId: cardListId
        }
    });
const $60c545eda9f36c75$export$8e3dbeb7df2e2eed = 'state.actions.card-list.SET_COLLAPSED_CARD_LIST';
const $60c545eda9f36c75$export$5f2a6b9a0552b438 = (cardListIds)=>({
        type: $60c545eda9f36c75$export$8e3dbeb7df2e2eed,
        payload: {
            cardListIds: cardListIds
        }
    });
const $60c545eda9f36c75$export$cc7cd3c4009760cc = 'state.actions.card-list.CARD_LISTS_DISABLE';
const $60c545eda9f36c75$export$3bb589b09264f63f = (cardListIds)=>({
        type: $60c545eda9f36c75$export$cc7cd3c4009760cc,
        payload: {
            cardListIds: cardListIds
        }
    });
const $60c545eda9f36c75$export$649d537a55101566 = 'state.actions.card-list.CARD_LISTS_ENABLE_ALL';
const $60c545eda9f36c75$export$f44d80a86eadf7f4 = ()=>({
        type: $60c545eda9f36c75$export$649d537a55101566
    });
const $60c545eda9f36c75$export$dc86559f09e710b9 = 'state.actions.card-list.DRAG_START';
const $60c545eda9f36c75$export$87075c8b80f899ee = (cardListIds, sourceCardListId, sourceCardGroupId)=>({
        type: $60c545eda9f36c75$export$dc86559f09e710b9,
        payload: {
            cardListIds: cardListIds,
            sourceCardListId: sourceCardListId,
            sourceCardGroupId: sourceCardGroupId
        }
    });
const $60c545eda9f36c75$export$39a50360ed362605 = 'state.actions.card-list.DRAG_END';
const $60c545eda9f36c75$export$e6bf5fbe83cd7d74 = ()=>({
        type: $60c545eda9f36c75$export$39a50360ed362605
    });
const $60c545eda9f36c75$export$bde12efd87a4ac85 = 'state.actions.card-list.CARD_GROUP_TOGGLE';
const $60c545eda9f36c75$export$92a3d8e003e4f107 = (parentId)=>({
        type: $60c545eda9f36c75$export$bde12efd87a4ac85,
        payload: {
            parentId: parentId
        }
    });
const $60c545eda9f36c75$export$9da147a1292f7381 = 'state.actions.card-list.SET_COLLAPSED_CARD_GROUP';
const $60c545eda9f36c75$export$3f7371c8d6ee730e = 'state.actions.card-list.SET_EXPANDED_CARD_GROUP';
const $60c545eda9f36c75$export$b56fc1f894629222 = (parentIds)=>({
        type: $60c545eda9f36c75$export$9da147a1292f7381,
        payload: {
            parentIds: parentIds
        }
    });
const $60c545eda9f36c75$export$7ff65c0e4fbb1fb = (parentIds)=>({
        type: $60c545eda9f36c75$export$3f7371c8d6ee730e,
        payload: {
            parentIds: parentIds
        }
    });
const $60c545eda9f36c75$export$f79940d7e9a921f6 = 'state.actions.card-list.CLEAR_COLLAPSED_CARD_GROUP';
const $60c545eda9f36c75$export$a93c0bd80b95451c = 'state.actions.card-list.CLEAR_EXPANDED_CARD_GROUP';
const $60c545eda9f36c75$export$2847fdebb2aad4f5 = (parentId)=>({
        type: $60c545eda9f36c75$export$f79940d7e9a921f6,
        payload: {
            parentId: parentId
        }
    });
const $60c545eda9f36c75$export$f3ccf76393691844 = (parentId)=>({
        type: $60c545eda9f36c75$export$a93c0bd80b95451c,
        payload: {
            parentId: parentId
        }
    });
const $60c545eda9f36c75$export$a081f6cfebf37017 = 'state.actions.card-list.COLLAPSE_ALL_CARD_GROUPS';
const $60c545eda9f36c75$export$5f921ba0e1020c03 = ()=>({
        type: $60c545eda9f36c75$export$a081f6cfebf37017
    });

});


parcelRegister("ib32H", function(module, exports) {

$parcel$export(module.exports, "cardListToggleEpic", () => $e14245b2adeb8ead$export$35eb239dac6e0c31);

var $3JafE = parcelRequire("3JafE");
parcelRequire("8jBvP");
parcelRequire("iects");

var $iYUz7 = parcelRequire("iYUz7");

var $7TN4i = parcelRequire("7TN4i");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");
const $e14245b2adeb8ead$export$35eb239dac6e0c31 = (action$, store)=>action$.ofType((0, $7TN4i.CARD_LIST_TOGGLE)).flatMap(()=>{
        const state = store.getState();
        const collapsedCardLists = (0, $bP7Jx.getCollapsedCardLists)(state);
        (0, $iYUz7.setBacklogSettings)(Number((0, $hkGxG.getRapidViewId)(state)), {
            collapsedCardLists: collapsedCardLists
        });
        return (0, $3JafE.Observable).empty();
    });

});

parcelRegister("1lQFl", function(module, exports) {

$parcel$export(module.exports, "cardPostCreateEpic", () => $eef90eb63659f951$export$bae9f8e0951e31da);

var $3JafE = parcelRequire("3JafE");
parcelRequire("8jBvP");
parcelRequire("jyKN9");
parcelRequire("iects");

var $lsENz = parcelRequire("lsENz");

var $bP7Jx = parcelRequire("bP7Jx");
const $eef90eb63659f951$var$getActiveCustomFilterIds = (state)=>state.ui.filters.CUSTOM_FILTER || [];
const $eef90eb63659f951$var$isCustomFiltersActive = (state)=>$eef90eb63659f951$var$getActiveCustomFilterIds(state).length > 0;
const $eef90eb63659f951$export$bae9f8e0951e31da = (action$, store)=>action$.ofType((0, $lsENz.CARD_CREATE_SUCCESS)).mergeMap((action)=>{
        const state = store.getState();
        const visibleCardIds = (0, $bP7Jx.makeOrderedVisibleCardIdsForCardList)(state)(action.payload.listId);
        if (!visibleCardIds.includes(action.payload.card.id)) {
            // don't show this flag here if custom filters are active,
            // we'll show it after the refiltering succeeds
            if (!$eef90eb63659f951$var$isCustomFiltersActive(state)) return (0, $3JafE.Observable).of((0, $lsENz.cardCreateFilteredV2)([
                action.payload.card.id
            ]));
        }
        return (0, $3JafE.Observable).empty();
    });

});

parcelRegister("5xnJJ", function(module, exports) {

$parcel$export(module.exports, "cardRankAfterGlobalIssueCreateEpic", () => $24bd0e24395608c5$export$40e733b396c30c9b);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("3wBUP");
parcelRequire("jnCPY");

var $7TyGu = parcelRequire("7TyGu");

var $jiL2Q = parcelRequire("jiL2Q");

var $lsENz = parcelRequire("lsENz");

var $7Egcu = parcelRequire("7Egcu");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");
const $24bd0e24395608c5$export$40e733b396c30c9b = (action$, store, dependencies)=>action$.ofType((0, $lsENz.CARD_CREATE_GLOBAL)).switchMap((cardCreateGlobalAction)=>{
        const state = store.getState();
        const lastSelectedCardId = (0, $bP7Jx.getLastSelectedCard)(state);
        const cardMoveDisabled = (0, $hkGxG.isCardMoveDisabled)(state);
        const listId = lastSelectedCardId && (0, $bP7Jx.makeGetCardListIdByCardId)(state)(lastSelectedCardId);
        // We should not rank created issues from GIC when:
        // - there is no selected card
        // - the board is not ordered by rank (this will also filter out TMP projects)
        // - the card is not part of any card list
        // - the card is not on `BACKLOG` card list
        if (!lastSelectedCardId || cardMoveDisabled || !listId || listId !== (0, $7TyGu.BACKLOG)) return (0, $3JafE.Observable).empty();
        const { payload: { globalIssues: globalIssues } } = cardCreateGlobalAction;
        const analyticsEvent = dependencies && dependencies.createAnalyticsEvent ? dependencies.createAnalyticsEvent({}) : {};
        return action$.ofType((0, $jiL2Q.SET_APP_DATA)).filter(()=>{
            const cards = (0, $bP7Jx.getCards)(store.getState());
            return globalIssues.every(({ issueId: issueId })=>cards[issueId]);
        }).take(1).flatMap(()=>{
            const cardIds = globalIssues.map((createdIssue)=>parseInt(createdIssue.issueId, 10));
            return (0, $3JafE.Observable).of((0, $7Egcu.cardsMoveRequest)({
                cardIds: cardIds,
                cardListId: listId,
                isBetweenLists: false,
                beforeCardId: null,
                afterCardId: lastSelectedCardId
            }, analyticsEvent));
        });
    });

});

parcelRegister("hqsxa", function(module, exports) {

$parcel$export(module.exports, "cardRefreshEpic", () => $b54136ae98ed4b90$export$343b49279bcad83d);

var $3JafE = parcelRequire("3JafE");
parcelRequire("8jBvP");
parcelRequire("flmol");
parcelRequire("1Lcr1");
parcelRequire("iects");

var $gUUjF = parcelRequire("gUUjF");

var $6yrI4 = parcelRequire("6yrI4");

var $lEnU0 = parcelRequire("lEnU0");

var $64fZ9 = parcelRequire("64fZ9");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $k734R = parcelRequire("k734R");
const $b54136ae98ed4b90$var$getRefreshCardId = (action, state)=>{
    const { payload: { cardId: cardId } } = action;
    if (cardId) return cardId;
    const detailViewData = (0, $bP7Jx.getDetailViewData)(state);
    if (detailViewData) return detailViewData.cardId;
    return null;
};
const $b54136ae98ed4b90$export$343b49279bcad83d = (action$, store)=>action$.ofType((0, $64fZ9.CARD_REFRESH_REQUEST)).flatMap((action)=>{
        const state = store.getState();
        const cardId = $b54136ae98ed4b90$var$getRefreshCardId(action, state);
        const issueParents = (0, $k734R.getIssueParents)(state);
        const projectId = (0, $hkGxG.projectIdSelector)(state);
        /** TODO: issueParents check part below to be removed WHEN
		 * Swag supports fetching epic level issues OR
		 * FE updates backlog optimistically (in redux store) instead of relying on refetching issues via GraphQL
		 */ if (!cardId || issueParents[String(cardId)]) return (0, $3JafE.Observable).empty();
        const serviceContext = (0, $lEnU0.makeServiceContext)(state);
        return (0, $6yrI4.cardLoadService)(serviceContext, cardId, projectId).map((card)=>(0, $64fZ9.cardRefreshSuccess)(card)).catch((error)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData('backlog.card-refresh-graphql.failure', 'Failed to refresh issue', error);
            return (0, $3JafE.Observable).empty();
        });
    });

});
parcelRegister("6yrI4", function(module, exports) {

$parcel$export(module.exports, "cardLoadService", () => $8beff6e576b0ce81$export$77afcec7b8f1f966);
parcelRequire("flmol");

var $huNLe = parcelRequire("huNLe");

var $7jPiH = parcelRequire("7jPiH");

var $hkNTt = parcelRequire("hkNTt");

var $3VWrx = parcelRequire("3VWrx");
function $8beff6e576b0ce81$export$77afcec7b8f1f966(serviceContext, cardId, projectId) {
    if (serviceContext.isCompanyManaged) return (0, $hkNTt.fetchIssue)(serviceContext.boardId, cardId).map((0, $huNLe.transformCard));
    return (0, $7jPiH.default)('', serviceContext.boardId, cardId).map((cardData)=>(0, $3VWrx.cardTransformer)(cardData, projectId));
}

});
parcelRegister("7jPiH", function(module, exports) {

$parcel$export(module.exports, "default", () => $54c47379f88949b4$export$2e2bcd8739ae039);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("iects");

var $jy01K = parcelRequire("jy01K");
const $54c47379f88949b4$var$cardDataOperationName = 'BacklogCardQuery';
const $54c47379f88949b4$export$71eec30d9db46a56 = ()=>`
    query ${$54c47379f88949b4$var$cardDataOperationName} ($boardId: ID!, $cardId: ID!) {
        boardScope(boardId: $boardId) {
            cards(cardIds: [$cardId]) {
                id
                issue {
                    id
                    key
                    summary
                    labels
                    type {
                        id
                        name
                        iconUrl
                    }
                    status {
                        id
                        name
                        category
                    }
                    assignee {
                        accountId
                        displayName
                        avatarUrl
                    }
                }
                flagged
                done
                parentId
                fixVersions
                estimate {
                    storyPoints
                    originalEstimate {
                        value
                        valueAsText
                    }
                }
                childIssuesMetadata {
                    complete
                    total
                }
                priority {
                    name
                    iconUrl
                }
                dueDate
            }
        }
    }
`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$54c47379f88949b4$export$2e2bcd8739ae039 = (baseUrl, boardId, cardId)=>(0, $jy01K.query$)(baseUrl, $54c47379f88949b4$var$cardDataOperationName, $54c47379f88949b4$export$71eec30d9db46a56(), {
        boardId: boardId,
        cardId: cardId
    }).flatMap((data)=>// @ts-expect-error - TS2571 - Object is of type 'unknown'.
        (0, $3JafE.Observable).of(data.boardScope.cards[0]));

});

parcelRegister("3VWrx", function(module, exports) {

$parcel$export(module.exports, "cardTransformer", () => $2033e4cf280b1817$export$c44fc4642496cd94);
$parcel$export(module.exports, "default", () => $2033e4cf280b1817$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $ldoFd = parcelRequire("ldoFd");

var $MdoH4 = parcelRequire("MdoH4");

var $hvbu2 = parcelRequire("hvbu2");

var $hwbh0 = parcelRequire("hwbh0");

var $3l6tm = parcelRequire("3l6tm");



var $7TyGu = parcelRequire("7TyGu");


var $gPQCf = parcelRequire("gPQCf");
const $2033e4cf280b1817$var$backlogList = (0, $6HC1D.freeze)({
    id: (0, $7TyGu.BACKLOG),
    type: (0, $7TyGu.BACKLOG),
    name: 'Backlog',
    issueListKey: null
});
const $2033e4cf280b1817$var$isFeatureEnabled = (features, featureKey)=>(features || []).some(({ key: key, status: status })=>key === featureKey && status === (0, $e37979b27b7bd428$export$e927a5d1b72f0b68));
const $2033e4cf280b1817$var$isEstimationFeatureEnabled = (features)=>$2033e4cf280b1817$var$isFeatureEnabled(features, (0, $e37979b27b7bd428$export$4181c6622414bfdf));
const $2033e4cf280b1817$var$isVersionsFeatureEnabled = (features)=>$2033e4cf280b1817$var$isFeatureEnabled(features, (0, $e37979b27b7bd428$export$173708eb8a9ba955));
const $2033e4cf280b1817$export$64e7b2d3af76d9e6 = (features)=>$2033e4cf280b1817$var$isFeatureEnabled(features, (0, $e37979b27b7bd428$export$4279f6f79febea0a));
const $2033e4cf280b1817$var$isBacklogFeatureEnabled = (features)=>$2033e4cf280b1817$var$isFeatureEnabled(features, (0, $7TyGu.BACKLOG));
const $2033e4cf280b1817$var$assigneeTransformer = ({ accountId: accountId, displayName: displayName, avatarUrl: avatarUrl })=>({
        id: accountId,
        displayName: displayName,
        avatarUrl: avatarUrl
    });
const $2033e4cf280b1817$export$c44fc4642496cd94 = ({ id: id, issue: { key: key, type: type, summary: summary, labels: labels, status: status, assignee: assignee }, done: done, flagged: flagged, parentId: parentId, priority: priority, dueDate: dueDate, estimate: estimate, childIssuesMetadata: childIssuesMetadata, fixVersions: fixVersions }, projectId)=>({
        summary: summary,
        id: Number(id),
        key: key,
        labels: labels,
        assignee: assignee ? $2033e4cf280b1817$var$assigneeTransformer(assignee) : null,
        icon: type.iconUrl,
        isDone: done,
        isFlagged: flagged,
        typeId: Number(type.id),
        issueUrl: `/browse/${key}`,
        statusId: status.id,
        parentId: parentId || '' ? Number(parentId) : null,
        priority: priority || null,
        dueDate: dueDate || '' || null,
        estimate: (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(estimate) ? null : {
            ...estimate,
            timeRemainingEstimate: null
        },
        numCompleteChildren: childIssuesMetadata?.complete || 0,
        numTotalChildren: childIssuesMetadata?.total || 0,
        fixVersions: fixVersions,
        projectId: Number(projectId)
    });
const $2033e4cf280b1817$var$cardTypesTransformer = (issueTypes)=>issueTypes.reduce((baseLevelCardTypes, { hierarchyLevelType: hierarchyLevelType, id: id, ...issueType })=>{
        if (hierarchyLevelType === (0, $3l6tm.BASE_HIERARCHY_TYPE)) baseLevelCardTypes.push({
            id: Number(id),
            typeHierarchyLevel: hierarchyLevelType,
            ...issueType
        });
        return baseLevelCardTypes;
    }, []);
const $2033e4cf280b1817$var$storyPointFieldIdTransformer = (availableEstimation)=>{
    const storyPointId = availableEstimation.find(({ statisticFieldId: statisticFieldId })=>statisticFieldId !== (0, $7TyGu.ORIGINAL_ESTIMATE_FIELD_ID) && statisticFieldId !== (0, $7TyGu.ISSUE_COUNT_ID))?.statisticFieldId || '';
    return storyPointId.replace((0, $7TyGu.ESTIMATION_TYPE_ID_PREFIX), '') || null;
};
const $2033e4cf280b1817$var$getBacklogStrategy = (features)=>{
    if (!$2033e4cf280b1817$var$isBacklogFeatureEnabled(features)) return 0, $7TyGu.NONE;
    if ($2033e4cf280b1817$export$64e7b2d3af76d9e6(features)) return 0, $7TyGu.SPRINT;
    return 0, $7TyGu.ISSUE_LIST;
};
const $2033e4cf280b1817$export$69760b7e76c533f9 = ({ jira: { timeTrackingOptions: timeTrackingOptions }, boardScope: { board: { rankCustomFieldId: rankCustomFieldId }, projectLocation: { name: name, features: projectFeatures }, currentUser: { permissions: permissions }, features: features, estimation: estimation, backlog: { requestColumnMigration: requestColumnMigration } } })=>{
    const transformedConfig = {
        rankCustomFieldId: Number(rankCustomFieldId),
        requestColumnMigration: requestColumnMigration,
        name: name,
        permissions: {
            [(0, $094620879c5e56fa$export$d765836bd761b2ee)]: permissions.includes((0, $7TyGu.MANAGE_SPRINT)),
            [(0, $094620879c5e56fa$export$526c94c551c00291)]: permissions.includes((0, $7TyGu.CREATE_ISSUE)),
            [(0, $094620879c5e56fa$export$8a1ecb9983951227)]: permissions.includes((0, $7TyGu.EDIT_ISSUE)),
            [(0, $094620879c5e56fa$export$b35e3ebf2c83a499)]: permissions.includes((0, $7TyGu.EDIT_BOARD_CONFIG))
        },
        version: {
            isVersionsFeatureEnabled: $2033e4cf280b1817$var$isVersionsFeatureEnabled(projectFeatures)
        },
        allFeatures: features,
        backlogStrategy: $2033e4cf280b1817$var$getBacklogStrategy(features),
        storyPointFieldId: $2033e4cf280b1817$var$storyPointFieldIdTransformer(estimation.available),
        timeTrackingOptions: timeTrackingOptions
    };
    return transformedConfig;
};
const $2033e4cf280b1817$export$4055277b2f3e701f = ({ id: id, name: name, goal: goal, startDate: startDate, endDate: endDate, daysRemaining: daysRemaining, sprintState: sprintState }, canUpdateSprint)=>({
        id: String(id),
        name: name,
        type: (0, $7TyGu.SPRINT),
        issueListKey: null,
        sprintData: {
            goal: goal || '',
            startDate: startDate,
            endDate: endDate,
            daysRemaining: daysRemaining,
            state: sprintState,
            canUpdateSprint: canUpdateSprint
        }
    });
const $2033e4cf280b1817$export$9a5176a1a22928d9 = (issueParents)=>issueParents.reduce((issueParentsEntityState, issueParent)=>Object.assign(issueParentsEntityState, {
            [issueParent.id]: issueParent
        }), {});
const $2033e4cf280b1817$export$f96dae738e4d5e19 = (isEstimationEnabled, estimation)=>{
    const estimateFieldKey = estimation.current.customFieldId || '';
    if (isEstimationEnabled && estimateFieldKey) return estimateFieldKey === (0, $ebc098a76317be78$export$5fbd3b15555b9ef2) ? (0, $7TyGu.ORIGINAL_ESTIMATE) : (0, $7TyGu.STORY_POINTS);
    return 0, $7TyGu.ISSUE_COUNT;
};
const $2033e4cf280b1817$export$6b3f2edb57acc06e = (isEstimationEnabled, estimation)=>isEstimationEnabled ? estimation.current.customFieldId : null;
const $2033e4cf280b1817$export$3bf59b7c6d7e91d9 = (features, estimation)=>{
    const isEstimationEnabled = $2033e4cf280b1817$var$isEstimationFeatureEnabled(features);
    return {
        isEstimationFeatureEnabled: isEstimationEnabled,
        estimationType: $2033e4cf280b1817$export$f96dae738e4d5e19(isEstimationEnabled, estimation),
        estimationFieldId: $2033e4cf280b1817$export$6b3f2edb57acc06e(isEstimationEnabled, estimation),
        name: ''
    };
};
const $2033e4cf280b1817$export$cfeec69489a32e7d = (allCards)=>({
        versions: (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))((0, (/*@__PURE__*/$parcel$interopDefault($hvbu2)))(allCards).reduce((fixVersions, card)=>card.fixVersions && card.fixVersions.length > 0 ? fixVersions.concat(card.fixVersions) : fixVersions, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        []))
    });
const $2033e4cf280b1817$export$2e67aaf0261afb3 = (data)=>{
    const { currentUser: { permissions: permissions }, sprints: sprints, backlog: backlog, board: { issueParents: issueParents }, features: features, estimation: estimation, projectLocation: { id: projectId, issueTypes: issueTypes } } = data.boardScope;
    const canUpdateSprint = permissions.includes((0, $7TyGu.MANAGE_SPRINT));
    const cardList = {
        [(0, $7TyGu.BACKLOG)]: $2033e4cf280b1817$var$backlogList
    };
    const cardListOrder = [];
    const cardOrder = {
        [(0, $7TyGu.BACKLOG)]: backlog.cards.reduce((backlogCardOrder, { id: id, done: done })=>done ? backlogCardOrder : backlogCardOrder.concat(Number(id)), [])
    };
    let cards = [];
    sprints.forEach((sprint)=>{
        cardList[sprint.id] = $2033e4cf280b1817$export$4055277b2f3e701f(sprint, canUpdateSprint);
        cardListOrder.push(String(sprint.id));
        cardOrder[sprint.id] = sprint.cards.map(({ id: id })=>Number(id));
        cards = cards.concat(sprint.cards);
    });
    cardListOrder.push((0, $7TyGu.BACKLOG));
    cards = cards.concat(backlog.cards);
    const card = (0, (/*@__PURE__*/$parcel$interopDefault($hwbh0)))(cards.map(({ id: id })=>id), cards.map((cardData)=>$2033e4cf280b1817$export$c44fc4642496cd94(cardData, projectId)));
    return {
        entities: {
            cardList: cardList,
            cardListOrder: cardListOrder,
            card: card,
            cardTypes: $2033e4cf280b1817$var$cardTypesTransformer(issueTypes),
            cardOrder: cardOrder,
            issueParents: $2033e4cf280b1817$export$9a5176a1a22928d9(issueParents),
            issueParentsOrder: issueParents.map(({ id: id })=>id),
            estimation: $2033e4cf280b1817$export$3bf59b7c6d7e91d9(features, estimation),
            version: $2033e4cf280b1817$export$cfeec69489a32e7d(card),
            inlineCreate: {
                cardTypeIds: issueTypes.map((it)=>Number(it.id))
            }
        },
        config: $2033e4cf280b1817$export$69760b7e76c533f9(data)
    };
};
const $2033e4cf280b1817$export$8714abbd873c8285 = (data)=>{
    const { backlog: backlog, board: board, board: { issueParents: issueParents }, features: features, estimation: estimation, projectLocation: { id: projectId, issueTypes: issueTypes } } = data.boardScope;
    const cards = backlog.cards.concat(board.cards);
    const card = (0, (/*@__PURE__*/$parcel$interopDefault($hwbh0)))(cards.map(({ id: id })=>id), cards.map((cardData)=>$2033e4cf280b1817$export$c44fc4642496cd94(cardData, projectId)));
    return {
        entities: {
            cardList: {
                [(0, $7TyGu.BOARD)]: {
                    id: (0, $7TyGu.BOARD),
                    type: (0, $7TyGu.BOARD),
                    name: 'Board',
                    issueListKey: backlog.boardIssueListKey
                },
                [(0, $7TyGu.BACKLOG)]: $2033e4cf280b1817$var$backlogList
            },
            cardListOrder: [
                (0, $7TyGu.BOARD),
                (0, $7TyGu.BACKLOG)
            ],
            cardTypes: $2033e4cf280b1817$var$cardTypesTransformer(issueTypes),
            card: card,
            cardOrder: {
                [(0, $7TyGu.BOARD)]: board.cards.map(({ id: id })=>Number(id)),
                [(0, $7TyGu.BACKLOG)]: backlog.cards.map(({ id: id })=>Number(id))
            },
            issueParents: $2033e4cf280b1817$export$9a5176a1a22928d9(issueParents),
            issueParentsOrder: issueParents.map(({ id: id })=>id),
            estimation: $2033e4cf280b1817$export$3bf59b7c6d7e91d9(features, estimation),
            version: $2033e4cf280b1817$export$cfeec69489a32e7d(card),
            inlineCreate: {
                cardTypeIds: issueTypes.map((it)=>Number(it.id))
            }
        },
        config: $2033e4cf280b1817$export$69760b7e76c533f9(data)
    };
};
const $2033e4cf280b1817$var$transformCriticalData = (data, isCompanyManaged)=>{
    const metric = isCompanyManaged ? (0, $gPQCf.uifBacklogNewUiPageLoad) : (0, $gPQCf.nextGenBacklogPageLoad);
    metric.mark((0, $gPQCf.PAGE_LOAD_MARK_TRANSFORM_CRITICAL_START));
    const result = $2033e4cf280b1817$export$64e7b2d3af76d9e6(data.boardScope.features) ? $2033e4cf280b1817$export$2e67aaf0261afb3(data) : $2033e4cf280b1817$export$8714abbd873c8285(data);
    metric.mark((0, $gPQCf.PAGE_LOAD_MARK_TRANSFORM_CRITICAL_END));
    return result;
};
var $2033e4cf280b1817$export$2e2bcd8739ae039 = $2033e4cf280b1817$var$transformCriticalData;

});
parcelRegister("hwbh0", function(module, exports) {

var $jDLwO = parcelRequire("jDLwO");

var $7hlYT = parcelRequire("7hlYT");
/**
 * This method is like `_.fromPairs` except that it accepts two arrays,
 * one of property identifiers and one of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 0.4.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObject(['a', 'b'], [1, 2]);
 * // => { 'a': 1, 'b': 2 }
 */ function $cc0e2b7b9a1e48d7$var$zipObject(props, values) {
    return $7hlYT(props || [], values || [], $jDLwO);
}
module.exports = $cc0e2b7b9a1e48d7$var$zipObject;

});
parcelRegister("7hlYT", function(module, exports) {
/**
 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
 *
 * @private
 * @param {Array} props The property identifiers.
 * @param {Array} values The property values.
 * @param {Function} assignFunc The function to assign values.
 * @returns {Object} Returns the new object.
 */ function $54cb2be8ad88e749$var$baseZipObject(props, values, assignFunc) {
    var index = -1, length = props.length, valsLength = values.length, result = {};
    while(++index < length){
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
    }
    return result;
}
module.exports = $54cb2be8ad88e749$var$baseZipObject;

});


const $e37979b27b7bd428$export$4279f6f79febea0a = 'SPRINTS';
const $e37979b27b7bd428$export$4181c6622414bfdf = 'ESTIMATION';
const $e37979b27b7bd428$export$173708eb8a9ba955 = 'RELEASES';
const $e37979b27b7bd428$export$e927a5d1b72f0b68 = 'ENABLED';
const $e37979b27b7bd428$export$8cd212c10b4124d2 = 'DISABLED';
const $e37979b27b7bd428$export$b0409bb9b247a093 = 'COMING_SOON';



parcelRegister("64fZ9", function(module, exports) {

$parcel$export(module.exports, "CARD_REFRESH_REQUEST", () => $c3b9363f1dc5731f$export$a5cacf6c12c6c43b);
$parcel$export(module.exports, "CARD_REFRESH_SUCCESS", () => $c3b9363f1dc5731f$export$5d5ffe0a39497fb1);
$parcel$export(module.exports, "cardRefreshRequest", () => $c3b9363f1dc5731f$export$54efae65153e525a);
$parcel$export(module.exports, "cardRefreshSuccess", () => $c3b9363f1dc5731f$export$8c0b797631a3987f);
const $c3b9363f1dc5731f$export$a5cacf6c12c6c43b = 'state.actions.cards.refresh.CARD_REFRESH_REQUEST';
const $c3b9363f1dc5731f$export$5d5ffe0a39497fb1 = 'state.actions.cards.refresh.CARD_REFRESH_SUCCESS';
const $c3b9363f1dc5731f$export$54efae65153e525a = (cardId, changeEvent)=>({
        type: $c3b9363f1dc5731f$export$a5cacf6c12c6c43b,
        payload: {
            cardId: cardId,
            changeEvent: changeEvent || null
        }
    });
const $c3b9363f1dc5731f$export$8c0b797631a3987f = (card)=>({
        type: $c3b9363f1dc5731f$export$5d5ffe0a39497fb1,
        payload: card
    });

});


parcelRegister("keRT4", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e07a7af6a188188$export$2e2bcd8739ae039);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("iects");


var $7TyGu = parcelRequire("7TyGu");

var $jiL2Q = parcelRequire("jiL2Q");

var $75nYE = parcelRequire("75nYE");

var $bP7Jx = parcelRequire("bP7Jx");

var $5ceEB = parcelRequire("5ceEB");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2e07a7af6a188188$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $75nYE.CARD_STATUS_CHECK)).mergeMap((action)=>{
        const { payload: payload } = action;
        if ('fieldId' in payload && payload.fieldId !== (0, $ebc098a76317be78$export$4420b7468f889692)) return (0, $3JafE.Observable).empty();
        const state = store.getState();
        const hasIssueOnBacklog = (0, $bP7Jx.getAllCardIdsIncludingIssueParents)(state).includes(Number(payload.issueId));
        // since ChangeEvent can be of different type and not all have fieldValue
        // @ts-expect-error - TS2339 - Property 'fieldValue' does not exist on type '{ fieldId: string; fieldValue: any; } | { fieldId: string; } | { fieldId: string; fieldValue: any; } | { typeName: string; } | { newParentIssueId: string | null; oldParentIssueId: string | null; } | ChangedIssueLink | { ...; } | { ...; } | { ...; }'.
        const isStatusIdMappedToBoard = payload.meta.fieldValue ? (0, $5ceEB.isStatusMappedToBoardOld)(payload.meta.fieldValue.id)(state) : false;
        // if an unmapped issue(including parent) does not exist on backlog & its remapped with status change,
        // need to refresh the data, so that issue will reappear on backlog
        return !hasIssueOnBacklog && isStatusIdMappedToBoard ? (0, $3JafE.Observable).of((0, $jiL2Q.refreshDataRequest)((0, $7TyGu.REFRESH_SOURCE_STATUS_REMAPPED))) : (0, $3JafE.Observable).empty();
    });

});
parcelRegister("75nYE", function(module, exports) {

$parcel$export(module.exports, "CARD_STATUS_SET", () => $de9ddbc32fa24435$export$ecf291dab442850b);
$parcel$export(module.exports, "cardStatusSet", () => $de9ddbc32fa24435$export$8f909d4ac3011c05);
$parcel$export(module.exports, "CARD_STATUS_CHECK", () => $de9ddbc32fa24435$export$17514c9f1eddf04d);
$parcel$export(module.exports, "cardStatusCheck", () => $de9ddbc32fa24435$export$9fafd08cacc25a20);
const $de9ddbc32fa24435$export$ecf291dab442850b = 'state.actions.status.CARD_STATUS_SET';
const $de9ddbc32fa24435$export$8f909d4ac3011c05 = (cardId, prevStatusId, statusId, statusCategory, isCMP)=>({
        type: $de9ddbc32fa24435$export$ecf291dab442850b,
        payload: {
            cardId: cardId,
            prevStatusId: prevStatusId,
            statusId: statusId,
            statusCategory: statusCategory,
            isCMP: isCMP
        }
    });
const $de9ddbc32fa24435$export$17514c9f1eddf04d = 'state.actions.status.CARD_STATUS_CHECK';
const $de9ddbc32fa24435$export$9fafd08cacc25a20 = (payload)=>({
        type: $de9ddbc32fa24435$export$17514c9f1eddf04d,
        payload: payload
    });

});


parcelRegister("6Tnvp", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cafdd86809d5d80$export$2e2bcd8739ae039);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("9u6v2");
parcelRequire("8jBvP");
parcelRequire("iects");

var $1ybV0 = parcelRequire("1ybV0");

var $jiL2Q = parcelRequire("jiL2Q");

var $7TN4i = parcelRequire("7TN4i");

var $lsENz = parcelRequire("lsENz");

var $75nYE = parcelRequire("75nYE");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $5ceEB = parcelRequire("5ceEB");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2cafdd86809d5d80$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $75nYE.CARD_STATUS_SET)).mergeMap((action)=>{
        const { payload: { cardId: cardId, prevStatusId: prevStatusId, statusId: statusId } } = action;
        const state = store.getState();
        const cardKey = (0, $bP7Jx.makeCardKeyFromCardId)(state)(cardId);
        if (!(0, $5ceEB.isStatusMappedToBoard)(state)(statusId)) return (0, $3JafE.Observable).of((0, $lsENz.cardCreateUnmappedWithIssueLink)([
            {
                id: cardId,
                key: cardKey
            }
        ]));
        if ((0, $hkGxG.isCmpKanbanProject)(state)) {
            const statusIdIsVisible = (0, $5ceEB.isStatusVisibleOnCmpKanbanBacklog)(state)(statusId);
            const cardHasMovedColumn = !(0, $5ceEB.areStatusesFromSameColumn)(state)(prevStatusId, statusId);
            if (!statusIdIsVisible || cardHasMovedColumn) return (0, $3JafE.Observable).from([
                (0, $jiL2Q.loadAppData)(),
                (0, $7TN4i.clearExpandedCardGroup)(cardId)
            ]);
        }
        const isCMP = (0, $hkGxG.getIsCompanyManaged)(state);
        if ((0, $1ybV0.ff)('jsw.uif.backlog.fix-strikethrough-on-status-transition') && isCMP) // For CMP, always do a data refresh on status transition
        // to ensure the issue's resolution is correct.
        return (0, $3JafE.Observable).from([
            (0, $jiL2Q.loadAppData)()
        ]);
        return (0, $3JafE.Observable).empty();
    });

});

parcelRegister("dSSv4", function(module, exports) {

$parcel$export(module.exports, "cardsBulkOperationsFailureEpic", () => $f0b25aaae6942d05$export$7900f6327252d82);
$parcel$export(module.exports, "cardsBulkOperationsSuccessEpicCmp", () => $f0b25aaae6942d05$export$1398e97029b0b992);

var $3JafE = parcelRequire("3JafE");
parcelRequire("8jBvP");
parcelRequire("jyKN9");
parcelRequire("iects");

var $7TyGu = parcelRequire("7TyGu");

var $jiL2Q = parcelRequire("jiL2Q");

var $2giiC = parcelRequire("2giiC");
const $f0b25aaae6942d05$export$7900f6327252d82 = (action$)=>action$.ofType((0, $2giiC.CARDS_BULK_OPERATIONS_FAILURE)).flatMap((action)=>{
        if (action.payload.length === 0) return (0, $3JafE.Observable).empty();
        return (0, $3JafE.Observable).of((0, $jiL2Q.refreshDataRequest)((0, $7TyGu.REFRESH_SOURCE_FAILURE)));
    });
const $f0b25aaae6942d05$export$1398e97029b0b992 = (action$)=>action$.ofType((0, $2giiC.CARDS_BULK_OPERATIONS_SUCCESS)).flatMap((action)=>{
        if (action.payload.length === 0) return (0, $3JafE.Observable).empty();
        return (0, $3JafE.Observable).of((0, $jiL2Q.loadAppData)());
    });

});
parcelRegister("2giiC", function(module, exports) {

$parcel$export(module.exports, "CARDS_BULK_OPERATIONS_REQUEST", () => $a7f03f7583601112$export$c06d56521c1e17a2);
$parcel$export(module.exports, "CARDS_BULK_OPERATIONS_REQUESTS", () => $a7f03f7583601112$export$89d925e1f8ce24b2);
$parcel$export(module.exports, "cardsBulkOperationsRequest", () => $a7f03f7583601112$export$46485d818b28554f);
$parcel$export(module.exports, "cardsBulkOperationsRequests", () => $a7f03f7583601112$export$1edfb57ee17c64a7);
$parcel$export(module.exports, "CARDS_BULK_OPERATIONS_SUCCESS", () => $a7f03f7583601112$export$3f2add5deaccd21);
$parcel$export(module.exports, "cardsBulkOperationsSuccess", () => $a7f03f7583601112$export$a9c3b26200843a57);
$parcel$export(module.exports, "CARDS_BULK_OPERATIONS_FAILURE", () => $a7f03f7583601112$export$11514e15dcf93257);
$parcel$export(module.exports, "cardsBulkOperationsFailure", () => $a7f03f7583601112$export$ca0b712e0be4eecd);

var $jWq1L = parcelRequire("jWq1L");
const $a7f03f7583601112$export$c06d56521c1e17a2 = 'state.actions.cards.bulk-operations.CARDS_BULK_OPERATIONS_REQUEST';
const $a7f03f7583601112$export$89d925e1f8ce24b2 = 'state.actions.cards.bulk-operations.CARDS_BULK_OPERATIONS_REQUESTS';
const $a7f03f7583601112$export$46485d818b28554f = (payload)=>({
        type: $a7f03f7583601112$export$c06d56521c1e17a2,
        payload: payload,
        meta: (0, $jWq1L.beginOptimisticUiMeta)()
    });
const $a7f03f7583601112$export$1edfb57ee17c64a7 = (payload)=>({
        type: $a7f03f7583601112$export$89d925e1f8ce24b2,
        payload: payload,
        meta: (0, $jWq1L.beginOptimisticUiMeta)()
    });
const $a7f03f7583601112$export$3f2add5deaccd21 = 'state.actions.cards.bulk-operations.CARDS_BULK_OPERATIONS_SUCCESS';
const $a7f03f7583601112$export$a9c3b26200843a57 = (optimisticId, payload)=>({
        type: $a7f03f7583601112$export$3f2add5deaccd21,
        meta: (0, $jWq1L.commitOptimisticUiMeta)(optimisticId),
        payload: payload
    });
const $a7f03f7583601112$export$11514e15dcf93257 = 'state.actions.cards.bulk-operations.CARDS_BULK_OPERATIONS_FAILURE';
const $a7f03f7583601112$export$ca0b712e0be4eecd = (optimisticId, payload)=>({
        type: $a7f03f7583601112$export$11514e15dcf93257,
        meta: (0, $jWq1L.revertOptimisticUiMeta)(optimisticId),
        payload: payload
    });

});


parcelRegister("85lg5", function(module, exports) {

$parcel$export(module.exports, "cardsFlagWithCommentEpic", () => $c3b548f8d5d65b5c$export$a1e5554df37d16f8);

var $3JafE = parcelRequire("3JafE");
parcelRequire("9u6v2");
parcelRequire("jyKN9");
parcelRequire("1Lcr1");
parcelRequire("iects");

var $gUUjF = parcelRequire("gUUjF");

var $jMP2a = parcelRequire("jMP2a");

var $7TyGu = parcelRequire("7TyGu");

var $32eox = parcelRequire("32eox");

var $jiL2Q = parcelRequire("jiL2Q");

var $1NOG0 = parcelRequire("1NOG0");
const $c3b548f8d5d65b5c$export$a1e5554df37d16f8 = (action$, store)=>action$.ofType((0, $1NOG0.CARDS_FLAG_WITH_COMMENT_REQUEST)).mergeMap((action)=>{
        const { payload: { cards: cards, flag: flag }, meta: { optimistic: { id: optimisticId }, analyticsEvent: analyticsEvent } } = action;
        return (0, $32eox.default)(store, action).flatMap((response)=>{
            if (response === null) {
                // if we get here, all of the issues were successfully updated
                (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'cards flagged', {
                    numCards: cards.length,
                    flagAction: flag ? 'added' : 'removed'
                });
                return (0, $3JafE.Observable).of((0, $1NOG0.cardsFlagWithCommentSuccess)(optimisticId, {
                    cards: cards
                }));
            }
            // if we get here, at least one of the issues failed to be updated,
            // so we treat it as a failure
            const error = new Error(response.errorMessages.join(', '));
            (0, $gUUjF.default).safeErrorWithoutCustomerData('backlog.cards-flag-with-comment.partial-failure', 'Failed to flag and/or comment on some issues.', error);
            throw error;
        }).catch(()=>{
            // if we get here directly from the cardsFlagWithCommentService, none
            // of the issues were successfully updated
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'ui taskFail', {
                task: 'flagCards',
                numCards: cards.length,
                flagAction: flag ? 'added' : 'removed'
            });
            return (0, $3JafE.Observable).from([
                (0, $1NOG0.cardsFlagWithCommentFailure)(optimisticId, {
                    cards: cards
                }),
                (0, $jiL2Q.refreshDataRequest)((0, $7TyGu.REFRESH_SOURCE_FAILURE))
            ]);
        });
    });

});
parcelRegister("32eox", function(module, exports) {

$parcel$export(module.exports, "default", () => $b305494a90d192af$export$2e2bcd8739ae039);

var $3JafE = parcelRequire("3JafE");

var $j1gLS = parcelRequire("j1gLS");

var $bP7Jx = parcelRequire("bP7Jx");
const $b305494a90d192af$export$de42cacd38bf80bd = (store, action)=>{
    const { payload: { cards: cards, flag: flag, comment: comment } } = action;
    const state = store.getState();
    const allCards = (0, $bP7Jx.getCards)(state);
    const issueKeys = cards.map((id)=>allCards[String(id)].key);
    return (0, $3JafE.Observable).fromPromise((0, $j1gLS.default)(issueKeys, flag, comment));
};
var $b305494a90d192af$export$2e2bcd8739ae039 = $b305494a90d192af$export$de42cacd38bf80bd;

});
parcelRegister("j1gLS", function(module, exports) {

$parcel$export(module.exports, "default", () => $07981061d4899f6c$export$2e2bcd8739ae039);

var $7byHA = parcelRequire("7byHA");
var $jxATW = parcelRequire("jxATW");
const $07981061d4899f6c$export$3ae968343ffb0d2b = '/rest/greenhopper/3/xboard/issue/flag/flag';
const $07981061d4899f6c$var$noContentStatus = 204;
const $07981061d4899f6c$export$5e94598347afb988 = (issueKeys, flag, comment)=>fetch($07981061d4899f6c$export$3ae968343ffb0d2b, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            issueKeys: issueKeys,
            flag: flag,
            comment: comment,
            commentProperty: '',
            commentVisibility: ''
        })
    }).then((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            const traceId = (0, $jxATW.getTraceId)(response);
            if (traceId != null && traceId !== '') throw new (0, $7byHA.default)(status, `Fetch call failed with status code: ${status}`, traceId);
            else throw new (0, $7byHA.default)(status);
        }
        if (response.status === $07981061d4899f6c$var$noContentStatus) return null;
        return response.text().then((body)=>body ? JSON.parse(body) : null);
    });
var $07981061d4899f6c$export$2e2bcd8739ae039 = $07981061d4899f6c$export$5e94598347afb988;

});


parcelRegister("1NOG0", function(module, exports) {

$parcel$export(module.exports, "CARDS_FLAG_WITH_COMMENT_REQUEST", () => $4b5616b6688a6a29$export$54cb48f5bedda9b0);
$parcel$export(module.exports, "cardsFlagWithCommentRequest", () => $4b5616b6688a6a29$export$5e94598347afb988);
$parcel$export(module.exports, "CARDS_FLAG_WITH_COMMENT_SUCCESS", () => $4b5616b6688a6a29$export$7ae03d8a0b15c6bb);
$parcel$export(module.exports, "cardsFlagWithCommentSuccess", () => $4b5616b6688a6a29$export$de9dc95767a5ba8a);
$parcel$export(module.exports, "CARDS_FLAG_WITH_COMMENT_FAILURE", () => $4b5616b6688a6a29$export$b85cf7baff5e9cdb);
$parcel$export(module.exports, "cardsFlagWithCommentFailure", () => $4b5616b6688a6a29$export$83679228bcad76fd);

var $jWq1L = parcelRequire("jWq1L");
const $4b5616b6688a6a29$export$54cb48f5bedda9b0 = 'state.actions.cards.flag-with-comment.CARDS_FLAG_WITH_COMMENT_REQUEST';
const $4b5616b6688a6a29$export$5e94598347afb988 = (payload, analyticsEvent)=>({
        type: $4b5616b6688a6a29$export$54cb48f5bedda9b0,
        payload: payload,
        meta: {
            ...(0, $jWq1L.beginOptimisticUiMeta)(),
            analyticsEvent: analyticsEvent
        }
    });
const $4b5616b6688a6a29$export$7ae03d8a0b15c6bb = 'state.actions.cards.flag-with-comment.CARDS_FLAG_WITH_COMMENT_SUCCESS';
const $4b5616b6688a6a29$export$de9dc95767a5ba8a = (optimisticId, payload)=>({
        type: $4b5616b6688a6a29$export$7ae03d8a0b15c6bb,
        meta: (0, $jWq1L.commitOptimisticUiMeta)(optimisticId),
        payload: payload
    });
const $4b5616b6688a6a29$export$b85cf7baff5e9cdb = 'state.actions.cards.flag-with-comment.CARDS_FLAG_WITH_COMMENT_FAILURE';
const $4b5616b6688a6a29$export$83679228bcad76fd = (optimisticId, payload)=>({
        type: $4b5616b6688a6a29$export$b85cf7baff5e9cdb,
        meta: (0, $jWq1L.revertOptimisticUiWithFlagMeta)(optimisticId),
        payload: payload
    });

});


parcelRegister("hFYYF", function(module, exports) {

$parcel$export(module.exports, "beforeMoveCardsEpic", () => $9aa1565de190f9a1$export$4cb77cd53144053d);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("iects");

var $3l6tm = parcelRequire("3l6tm");

var $bHPpI = parcelRequire("bHPpI");

var $7TyGu = parcelRequire("7TyGu");


var $7Egcu = parcelRequire("7Egcu");

var $cbRhO = parcelRequire("cbRhO");

var $hkGxG = parcelRequire("hkGxG");

var $1lsov = parcelRequire("1lsov");

var $bP7Jx = parcelRequire("bP7Jx");

var $dtV8v = parcelRequire("dtV8v");

var $5ceEB = parcelRequire("5ceEB");

var $lqXkz = parcelRequire("lqXkz");
const $9aa1565de190f9a1$var$getBeforeCardId = (action, topCardId)=>{
    const { placement: placement } = action.payload;
    if (placement === (0, $7TyGu.TOP_OF_LIST)) return topCardId || null;
    if (action.payload.placement === (0, $7TyGu.BEFORE_CARD)) return action.payload.beforeCardId;
    return null;
};
const $9aa1565de190f9a1$var$getAfterCardId = (action, bottomCardId)=>{
    const { placement: placement } = action.payload;
    if (placement === (0, $7TyGu.BOTTOM_OF_LIST) || placement === (0, $7TyGu.BOTTOM_OF_CARD_GROUP)) return bottomCardId || null;
    return null;
};
const $9aa1565de190f9a1$export$c53c1ed4374c27e3 = ({ state: state, cardListId: cardListId, cardIds: cardIds, isDroppedInTransitionZone: isDroppedInTransitionZone, beforeCardId: beforeCardId, afterCardId: afterCardId, targetStatusId: targetStatusId, analyticsEvent: analyticsEvent, newCardOrderGlobal: newCardOrderGlobal })=>{
    const newCardOrder = (0, $lqXkz.getNewCardOrder)(state, cardListId, cardIds, beforeCardId, afterCardId, isDroppedInTransitionZone);
    return (0, $3JafE.Observable).of((0, $7Egcu.cardsMoveRequest)({
        cardIds: cardIds,
        cardListId: cardListId,
        newCardOrder: newCardOrder,
        newCardOrderGlobal: newCardOrderGlobal,
        targetStatusId: targetStatusId,
        beforeCardId: beforeCardId,
        afterCardId: afterCardId,
        isBetweenLists: true
    }, analyticsEvent));
};
const $9aa1565de190f9a1$export$4cb77cd53144053d = (action$, store)=>action$.ofType((0, $7Egcu.CARDS_MOVE)).mergeMap((action)=>{
        const state = store.getState();
        const rankCustomFieldId = (0, $hkGxG.getRankCustomFieldId)(state);
        if (!rankCustomFieldId) return (0, $3JafE.Observable).empty();
        const { payload: { cardIds: cardIds, cardListId: destinationCardListId, isBetweenLists: isBetweenLists, isFromActiveSprint: isFromActiveSprint, placement: placement }, meta: { analyticsEvent: analyticsEvent } } = action;
        const cardListId = (0, $bHPpI.getCardListId)(destinationCardListId);
        const cardOrder = (0, $bP7Jx.getFlattenOrderedCardIds)(state);
        const cardLists = (0, $bP7Jx.getCardLists)(state);
        const cards = (0, $bP7Jx.getCards)(state);
        const isCmpKanbanBacklog = (0, $hkGxG.isCmpKanbanProject)(state);
        const isCmpScrumBacklog = (0, $hkGxG.isCMPScrumBacklog)(state);
        const isCmpBacklog = (0, $hkGxG.getIsCompanyManaged)(state);
        let cardsToMove = cardIds || (0, $bP7Jx.getSelectedCards)(state);
        let newCardOrderGlobal;
        const isMovingSubtasks = (0, $lqXkz.getIsMovingSubtasks)(cards, cardsToMove);
        const cardParentId = cardsToMove.filter((card)=>(0, $3l6tm.isSubtaskHierarchyLevel)(cards[card]?.typeHierarchyLevel)).reduce((id, curr)=>cards[curr].parentId ?? id, null);
        const targetStatusId = isBetweenLists ? (0, $5ceEB.makeGetKanbanSingleColumnStatusId)(state)(cardListId) : undefined;
        if (isCmpBacklog) {
            const getCardListIdByCardId = (0, $bP7Jx.makeGetCardListIdByCardId)(state);
            const getCardGroupByParentId = (0, $1lsov.makeGetCardGroupByParentId)(state);
            cardsToMove = (0, $lqXkz.getCMPCardsToMove)({
                cardIds: cardsToMove,
                getCardListIdByCardId: getCardListIdByCardId,
                getCardGroupByParentId: getCardGroupByParentId,
                isCmpScrumBacklog: isCmpScrumBacklog
            });
        }
        const orderedCardIds = cardOrder.filter((orderedCardId)=>cardsToMove.includes(orderedCardId));
        const topCardId = (0, $bP7Jx.makeGetTopCardIdFromCardList)(state)(cardListId, cardsToMove);
        const bottomCardId = isMovingSubtasks && cardParentId && placement !== (0, $7TyGu.BOTTOM_OF_LIST) ? (0, $1lsov.makeGetBottomCardIdFromCardGroup)(state)(cardListId, cardParentId, cardsToMove) : (0, $bP7Jx.makeGetBottomCardIdFromCardList)(state)(cardListId, cardsToMove);
        const beforeCardId = $9aa1565de190f9a1$var$getBeforeCardId(action, topCardId);
        // When dropping on subtask and moving card is not a subtask set bottom as the parentId of the subtasks
        const bottomId = bottomCardId && !isMovingSubtasks && (0, $3l6tm.isSubtaskHierarchyLevel)(cards[bottomCardId]?.typeHierarchyLevel) ? cards[bottomCardId]?.parentId : bottomCardId;
        const afterCardId = $9aa1565de190f9a1$var$getAfterCardId(action, bottomId);
        if (isCmpKanbanBacklog) {
            const isTransitionZoneDestination = action.payload.placement === (0, $7TyGu.TRANSITION_ZONE);
            newCardOrderGlobal = (0, $lqXkz.getNewCardOrderGlobal)(state, orderedCardIds, beforeCardId, afterCardId, isMovingSubtasks);
            if (isBetweenLists && (isTransitionZoneDestination || isMovingSubtasks)) return $9aa1565de190f9a1$export$c53c1ed4374c27e3({
                state: state,
                cardListId: cardListId,
                cardIds: orderedCardIds,
                isDroppedInTransitionZone: isTransitionZoneDestination,
                beforeCardId: beforeCardId,
                afterCardId: afterCardId,
                targetStatusId: targetStatusId,
                analyticsEvent: analyticsEvent,
                newCardOrderGlobal: newCardOrderGlobal
            });
        }
        const payload = {
            cardIds: orderedCardIds,
            cardListId: cardListId,
            isBetweenLists: isBetweenLists,
            beforeCardId: beforeCardId,
            afterCardId: afterCardId,
            targetStatusId: targetStatusId,
            newCardOrderGlobal: newCardOrderGlobal
        };
        const toActiveSprint = (0, $dtV8v.makeIsCardListActiveSprint)(state)(cardListId);
        if (isBetweenLists && (isFromActiveSprint || toActiveSprint)) {
            const originCardListId = (0, $bP7Jx.makeGetCardListIdByCardId)(state)(orderedCardIds[0]);
            return (0, $3JafE.Observable).of((0, $cbRhO.openModal)({
                type: (0, $ebd52ea7083e351b$export$86a0c18887a92eae),
                payload: {
                    cardIds: orderedCardIds,
                    originCardListName: originCardListId ? cardLists[originCardListId].name : '',
                    destinationCardListName: cardLists[cardListId].name,
                    confirmActionPayload: payload,
                    analyticsEvent: analyticsEvent
                }
            }));
        }
        return (0, $3JafE.Observable).of((0, $7Egcu.cardsMoveRequest)(payload, analyticsEvent));
    });

});
parcelRegister("1lsov", function(module, exports) {

$parcel$export(module.exports, "makeGetCardGroupByParentId", () => $c3f97a86ed8ac0a8$export$d2788281fedf0254);
$parcel$export(module.exports, "makeGetCardGroupByChildId", () => $c3f97a86ed8ac0a8$export$c259bd0429fd462d);
$parcel$export(module.exports, "makeGetBottomCardIdFromCardGroup", () => $c3f97a86ed8ac0a8$export$310938eee52c1639);
$parcel$export(module.exports, "makeIsCardInCollapsedCardGroup", () => $c3f97a86ed8ac0a8$export$7e51b32fda52165e);

var $df4Sl = parcelRequire("df4Sl");

var $iVIEg = parcelRequire("iVIEg");

var $jqvCZ = parcelRequire("jqvCZ");

var $3sfdp = parcelRequire("3sfdp");

var $bP7Jx = parcelRequire("bP7Jx");
const $c3f97a86ed8ac0a8$export$d2788281fedf0254 = (0, $df4Sl.createSelector)([
    (0, $bP7Jx.makeGetOrderedCardEntries)
], (getOrderedCardEntries)=>(0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((cardListId, parentId)=>{
        const cardEntries = getOrderedCardEntries(cardListId);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return cardEntries.find((cardEntry)=>(0, $3sfdp.isCardEntryGroup)(cardEntry) && cardEntry.parentId === parentId);
    }, (cardListId, parentId)=>`${cardListId}::${parentId}`));
const $c3f97a86ed8ac0a8$export$c259bd0429fd462d = (0, $df4Sl.createSelector)([
    (0, $bP7Jx.makeGetCardListIdByCardId),
    (0, $bP7Jx.getParentIdByChildIdSelector),
    $c3f97a86ed8ac0a8$export$d2788281fedf0254
], (getCardListIdByCardId, getParentIdByChildId, getCardGroupByParentId)=>{
    const getCardGroupByChildId = (cardId)=>{
        const cardListId = getCardListIdByCardId(cardId);
        if (!cardListId) return null;
        const parentId = getParentIdByChildId(cardId);
        return parentId ? getCardGroupByParentId(cardListId, parentId) : null;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))(getCardGroupByChildId);
});
const $c3f97a86ed8ac0a8$export$310938eee52c1639 = (0, $df4Sl.createSelector)([
    $c3f97a86ed8ac0a8$export$d2788281fedf0254
], (getCardGroupByParentId)=>(cardListId, parentId, ignoredIds)=>{
        const cardGroup = getCardGroupByParentId(cardListId, parentId);
        if (!cardGroup) return null;
        const list = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(cardGroup.cardIds, ignoredIds);
        return list.length > 0 ? list[list.length - 1] : null;
    });
const $c3f97a86ed8ac0a8$export$7e51b32fda52165e = (0, $df4Sl.createSelector)([
    $c3f97a86ed8ac0a8$export$c259bd0429fd462d
], (getCardGroupByChildId)=>(0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((cardId)=>{
        const cardGroup = getCardGroupByChildId(cardId);
        if (cardGroup) return cardGroup.isCollapsed;
        return false;
    }));

});

parcelRegister("lqXkz", function(module, exports) {

$parcel$export(module.exports, "getIsMovingSubtasks", () => $7311a6a92152fa8d$export$a9e6d5ca31611623);
$parcel$export(module.exports, "getCMPCardsToMove", () => $7311a6a92152fa8d$export$9b3afea889889644);
$parcel$export(module.exports, "getNewCardOrder", () => $7311a6a92152fa8d$export$5455144e38b4d576);
$parcel$export(module.exports, "getNewCardOrderGlobal", () => $7311a6a92152fa8d$export$7bc7f0caf073cc20);

var $3l6tm = parcelRequire("3l6tm");

var $daLLg = parcelRequire("daLLg");

var $bP7Jx = parcelRequire("bP7Jx");
const $7311a6a92152fa8d$export$a9e6d5ca31611623 = (cards, cardsToMove)=>cardsToMove.some((cardId)=>cards[cardId] && (0, $3l6tm.isSubtaskHierarchyLevel)(cards[cardId].typeHierarchyLevel));
const $7311a6a92152fa8d$var$removeSubtasks = (cards, cardIds)=>cardIds.filter((cardId)=>cards[cardId] && !(0, $3l6tm.isSubtaskHierarchyLevel)(cards[cardId].typeHierarchyLevel));
const $7311a6a92152fa8d$export$9b3afea889889644 = ({ cardIds: cardIds, getCardListIdByCardId: getCardListIdByCardId, getCardGroupByParentId: getCardGroupByParentId, isCmpScrumBacklog: isCmpScrumBacklog })=>{
    // For each card, we check if it is the parent of
    // a collapsed card group in kanban, or any card
    // group in scurm. If yes, we take the subtasks in
    // this card group and add them to the subtasksToMove.
    const subtasksToMove = cardIds.flatMap((cardId)=>{
        const listId = getCardListIdByCardId(cardId);
        const cardGroup = listId && getCardGroupByParentId(listId, cardId);
        if (cardGroup && (isCmpScrumBacklog || cardGroup.isCollapsed)) return cardGroup.cardIds;
        return [];
    });
    return [
        ...cardIds,
        ...subtasksToMove
    ];
};
const $7311a6a92152fa8d$export$546ed7c4f4fa68f9 = (cardIdOrder, cardIds)=>cardIdOrder.filter((cardId)=>cardIds.includes(cardId));
const $7311a6a92152fa8d$export$5455144e38b4d576 = (state, cardListId, cardIds, beforeCardId, afterCardId, isDroppedInTransitionZone)=>{
    const globalCardOrder = (0, $daLLg.getCardOrderGlobal)(state);
    const cardListCardOrder = (0, $daLLg.getCardOrderByCardlistId)(state, cardListId);
    const allCards = (0, $bP7Jx.getCards)(state);
    // 1. Handle when cards are dropped and ranked within a cardlist.
    // This could include both subtasks and non-subtasks, where
    // the card that was dragged was a non-subtask.
    // This can only occur when the backlog is sorted by rank.
    if (!isDroppedInTransitionZone && (beforeCardId || afterCardId)) {
        const subtaskCardIds = [];
        const nonSubtaskCardIds = [];
        cardIds.forEach((cardId)=>{
            const card = allCards[cardId];
            const isSubtask = (0, $3l6tm.isSubtaskHierarchyLevel)(card.typeHierarchyLevel);
            if (isSubtask) subtaskCardIds.push(cardId);
            else nonSubtaskCardIds.push(cardId);
        });
        // a. Order subtasks within the cardlist according to their global rank
        const newCardOrder = $7311a6a92152fa8d$export$546ed7c4f4fa68f9(globalCardOrder, [
            ...subtaskCardIds,
            ...cardListCardOrder
        ]);
        const insertIndex = beforeCardId ? newCardOrder.indexOf(beforeCardId) : newCardOrder.indexOf(afterCardId || 0) + 1;
        // b. Insert sorted non-subtasks into the position in the cardlist they were dropped
        newCardOrder.splice(insertIndex, 0, ...$7311a6a92152fa8d$export$546ed7c4f4fa68f9(globalCardOrder, nonSubtaskCardIds));
        return newCardOrder;
    }
    // 2. Handle when cards are dropped in a cardlist where the backlog is not
    // sorted by rank, or when the dragged card is a subtask, and therefore
    // not itself rankable.
    return $7311a6a92152fa8d$export$546ed7c4f4fa68f9(globalCardOrder, [
        ...cardIds,
        ...cardListCardOrder
    ]);
};
const $7311a6a92152fa8d$export$7bc7f0caf073cc20 = (state, cardIds, beforeCardId, afterCardId, isMovingSubtasks)=>{
    const globalCardOrder = (0, $daLLg.getCardOrderGlobal)(state);
    const cards = (0, $bP7Jx.getCards)(state);
    if (!(beforeCardId || afterCardId)) return globalCardOrder;
    let cardsToMove = cardIds.concat();
    // When multiple cards including both subtasks and
    // non-subtasks have moved, and the dropped card is
    // a non-subtask, the subtasks will keep their global order,
    // while the non-subtasks will have their order changed
    // based on beforeCardId or afterCardId
    if (isMovingSubtasks) cardsToMove = $7311a6a92152fa8d$var$removeSubtasks(cards, cardIds);
    // Remove all the cards that have moved, to be
    // placed back into their new position below
    const newCardOrderGlobal = globalCardOrder.filter((cardId)=>!cardsToMove.includes(cardId));
    const insertIndex = beforeCardId ? newCardOrderGlobal.indexOf(beforeCardId) : newCardOrderGlobal.indexOf(afterCardId) + 1;
    newCardOrderGlobal.splice(insertIndex, 0, ...$7311a6a92152fa8d$export$546ed7c4f4fa68f9(globalCardOrder, cardsToMove));
    return newCardOrderGlobal;
};

});
parcelRegister("daLLg", function(module, exports) {

$parcel$export(module.exports, "getCardOrderGlobal", () => $5b168c6e904b92fe$export$befde80c539a6f40);
$parcel$export(module.exports, "getCardOrderByCardlistId", () => $5b168c6e904b92fe$export$e79e737a0d7a721b);

var $kF7v3 = parcelRequire("kF7v3");
const $5b168c6e904b92fe$export$b7cd5af9264d7384 = (state)=>(0, $kF7v3.getEntities)(state).cardOrder;
const $5b168c6e904b92fe$export$befde80c539a6f40 = (state)=>(0, $kF7v3.getEntities)(state).cardOrderGlobal;
const $5b168c6e904b92fe$export$e79e737a0d7a721b = (state, cardListId)=>$5b168c6e904b92fe$export$b7cd5af9264d7384(state)[cardListId];

});



parcelRegister("dPQST", function(module, exports) {

$parcel$export(module.exports, "cardsMoveRequestEpic", () => $41428b6573859af0$export$8d85b975065644ab);

var $3JafE = parcelRequire("3JafE");
parcelRequire("9u6v2");
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("1Lcr1");
parcelRequire("iects");

var $gUUjF = parcelRequire("gUUjF");

var $jMP2a = parcelRequire("jMP2a");

var $9eH8H = parcelRequire("9eH8H");

var $deo0n = parcelRequire("deo0n");

var $bHPpI = parcelRequire("bHPpI");

var $7TyGu = parcelRequire("7TyGu");


var $lLgj5 = parcelRequire("lLgj5");

var $glCJX = parcelRequire("glCJX");

var $aqP48 = parcelRequire("aqP48");

var $i4nyo = parcelRequire("i4nyo");

var $gJAsh = parcelRequire("gJAsh");

var $8Ub7o = parcelRequire("8Ub7o");

var $lEnU0 = parcelRequire("lEnU0");

var $7nUCT = parcelRequire("7nUCT");

var $iF8oy = parcelRequire("iF8oy");

var $jiL2Q = parcelRequire("jiL2Q");

var $jiig0 = parcelRequire("jiig0");

var $7Egcu = parcelRequire("7Egcu");

var $cbRhO = parcelRequire("cbRhO");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $7kNqR = parcelRequire("7kNqR");
const $41428b6573859af0$var$isCardsMoveNonOptimisticRequestAction = (action)=>action && 'meta' in action && 'optimisticId' in action.meta;
const $41428b6573859af0$var$getOptimisticId = (action)=>$41428b6573859af0$var$isCardsMoveNonOptimisticRequestAction(action) ? action.meta.optimisticId : action.meta.optimistic.id;
const $41428b6573859af0$var$getTargetStatusId = (action)=>{
    if (action.payload.selectedTransition) return String(action.payload.selectedTransition.toStatusId);
    return action.payload.targetStatusId;
};
const $41428b6573859af0$var$moveToSprint = (params)=>(0, $gJAsh.default)(params.baseUrl, params.rankCustomFieldId, Number(params.rapidViewId), Number(params.cardList.id), params.cardKeys, params.beforeCardKey, params.afterCardKey, false);
const $41428b6573859af0$var$moveCardToList = (params, targetColumn, isCompanyManaged, isCmpKanban)=>isCompanyManaged ? (0, $8Ub7o.transitionAndRankService)({
        rankCustomFieldId: params.rankCustomFieldId,
        issueKeys: params.cardKeys,
        targetColumn: targetColumn,
        rankBeforeIssueIdOrKey: params.beforeCardKey,
        rankAfterIssueIdOrKey: params.afterCardKey,
        rapidViewId: Number(params.rapidViewId),
        selectedTransitionId: params.selectedTransition?.id,
        calculateNewIssuesOrder: isCmpKanban
    }) : (0, $glCJX.default)(params.baseUrl, params.rankCustomFieldId, params.cardKeys, params.beforeCardKey, params.afterCardKey, Number(params.rapidViewId), params.cardListId);
const $41428b6573859af0$var$moveCardToBacklog = (params)=>(0, $gJAsh.default)(params.baseUrl, params.rankCustomFieldId, Number(params.rapidViewId), null, params.cardKeys, params.beforeCardKey, params.afterCardKey, true);
const $41428b6573859af0$var$moveInsideList = (params, errorLogAttributes)=>{
    if (!params.beforeCardKey && !params.afterCardKey) {
        if (errorLogAttributes) (0, $gUUjF.default).safeErrorWithoutCustomerData('jsw.backlog.cards-move.request-epic', 'Failed to rank cards due to missing beforeCardKey and afterCardKey', errorLogAttributes);
        return (0, $3JafE.Observable).empty();
    }
    if (params.afterCardKey) return (0, $aqP48.default)(params.baseUrl, params.rankCustomFieldId, params.cardKeys, params.afterCardKey);
    return (0, $i4nyo.default)(params.baseUrl, params.rankCustomFieldId, params.cardKeys, params.beforeCardKey);
};
const $41428b6573859af0$export$e9800111bfe3c5b3 = (action, state, servicePayload)=>{
    const { payload: { isBetweenLists: isBetweenLists, beforeCardId: beforeCardId, afterCardId: afterCardId } } = action;
    const serviceContext = (0, $lEnU0.makeServiceContext)(state);
    const { cardListType: cardListType } = servicePayload;
    const errorLogAttributes = {
        beforeCardId: beforeCardId,
        afterCardId: afterCardId,
        isCompanyManaged: serviceContext.isCompanyManaged
    };
    // move cards within a Sprint or to a different Sprint list when in Scrum board
    if (cardListType === (0, $7TyGu.SPRINT)) {
        if (serviceContext.isCompanyManaged) return $41428b6573859af0$var$moveToSprint(servicePayload);
        return $41428b6573859af0$var$moveToSprint(servicePayload);
    }
    // move cards within the backlog or to the backlog when in Scrum board
    if ((0, $hkGxG.getBacklogStrategy)(state) === (0, $7TyGu.SPRINT) && cardListType === (0, $7TyGu.BACKLOG)) {
        if (serviceContext.isCompanyManaged) return $41428b6573859af0$var$moveCardToBacklog(servicePayload);
        return $41428b6573859af0$var$moveCardToBacklog(servicePayload);
    }
    const targetColumnId = (0, $hkGxG.getKanbanTargetColumnId)(state)(servicePayload.cardListType);
    if (serviceContext.isCompanyManaged && (0, $hkGxG.isKanbanBacklogStrategy)(state)) {
        // move cards from one list to another list for Kanban board
        if (isBetweenLists) {
            const isCompanyManagedKanban = true;
            return $41428b6573859af0$var$moveCardToList(servicePayload, targetColumnId, serviceContext.isCompanyManaged, isCompanyManagedKanban);
        }
        // move cards within a list for Kanban board
        return $41428b6573859af0$var$moveInsideList(servicePayload, errorLogAttributes);
    }
    // move cards from one list to another list for Kanban board
    if (isBetweenLists) return $41428b6573859af0$var$moveCardToList(servicePayload, targetColumnId, serviceContext.isCompanyManaged, (0, $hkGxG.isKanbanBacklogStrategy)(state));
    // move cards within a list for Kanban board
    return $41428b6573859af0$var$moveInsideList(servicePayload, errorLogAttributes);
};
const $41428b6573859af0$var$rankForTransitionScreen = (action, params)=>(transitionScreenEvent)=>{
        const { payload: { cardIds: cardIds, cardListId: cardListId, selectedTransition: selectedTransition }, meta: { analyticsEvent: analyticsEvent } } = action;
        const optimisticId = $41428b6573859af0$var$getOptimisticId(action);
        const analyticsEventProperties = {
            withSelectedTransition: !!selectedTransition
        };
        if ((0, $iF8oy.isShowEvent)(transitionScreenEvent)) {
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'transitionScreen show', analyticsEventProperties);
            return (0, $3JafE.Observable).empty();
        }
        if ((0, $iF8oy.isSuccessfulEvent)(transitionScreenEvent)) {
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'transitionScreen success', analyticsEventProperties);
            return $41428b6573859af0$var$moveInsideList(params).map(()=>(0, $7Egcu.cardsMoveSuccess)(optimisticId, cardIds, cardListId, analyticsEvent, $41428b6573859af0$var$getTargetStatusId(action)));
        }
        (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'transitionScreen cancel', analyticsEventProperties);
        return (0, $3JafE.Observable).of((0, $7Egcu.cardsMoveCancel)(optimisticId, analyticsEvent));
    };
const $41428b6573859af0$var$handleMoveCardSuccess = (action, state, dispatch, params)=>(response)=>{
        const serviceContext = (0, $lEnU0.makeServiceContext)(state);
        const { payload: { cardIds: cardIds, cardListId: cardListId, isBetweenLists: isBetweenLists, beforeCardId: beforeCardId, afterCardId: afterCardId }, meta: { analyticsEvent: analyticsEvent } } = action;
        const optimisticId = $41428b6573859af0$var$getOptimisticId(action);
        const { cardKeys: cardKeys } = params;
        if (!serviceContext.isCompanyManaged) return (0, $3JafE.Observable).of((0, $7Egcu.cardsMoveSuccess)(optimisticId, cardIds, cardListId, analyticsEvent));
        if ((0, $lLgj5.isFailedTransitionAndRankResponse)(response) && (0, $lLgj5.hasMultipleTransitions)(response)) {
            const transitions = (0, $lLgj5.getPossibleTransitions)(response).map((possibleTransition)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                ({
                    id: possibleTransition.id,
                    name: possibleTransition.name,
                    hasScreen: possibleTransition.hasTransitionView,
                    toStatusId: possibleTransition.targetStatus
                }));
            return (0, $3JafE.Observable).of((0, $cbRhO.openModal)({
                type: (0, $ebd52ea7083e351b$export$dcb8eb3e585ecde),
                payload: {
                    cardKeys: cardKeys,
                    transitions: transitions,
                    moveCardsActionPayload: {
                        cardIds: cardIds,
                        cardListId: cardListId,
                        isBetweenLists: isBetweenLists,
                        beforeCardId: beforeCardId,
                        afterCardId: afterCardId
                    },
                    optimisticId: optimisticId,
                    analyticsEvent: analyticsEvent
                }
            }));
        }
        if ((0, $lLgj5.isFailedTransitionAndRankResponse)(response) && (0, $lLgj5.hasTransitionScreens)(response)) {
            const transition = (0, $lLgj5.getFirstTransitionScreen)(response);
            if (!transition) return (0, $3JafE.Observable).of((0, $7Egcu.cardsMoveCancel)(optimisticId, analyticsEvent));
            return (0, $7nUCT.transitionScreenDialogService)({
                issueId: cardIds[0],
                issueKey: cardKeys[0],
                transitionId: transition.id,
                analyticsEvent: analyticsEvent,
                dispatch: dispatch
            }).flatMap($41428b6573859af0$var$rankForTransitionScreen(action, params));
        }
        if (serviceContext.isCompanyManaged && (0, $hkGxG.getBacklogStrategy)(state) === (0, $7TyGu.KANBAN_BACKLOG_STRATEGY)) {
            const actions = [
                (0, $7Egcu.cardsMoveSuccess)(optimisticId, cardIds, cardListId, analyticsEvent, $41428b6573859af0$var$getTargetStatusId(action)),
                // TODO: Review why we need this and avoid it on most cases
                // This will refresh
                (0, $jiL2Q.refreshDataRequest)((0, $7TyGu.REFRESH_SOURCE_KANBAN_CARD_MOVE_SUCCESS))
            ];
            const getCardIdFromCardKey = (0, $bP7Jx.makeCardIdFromCardKey)(state);
            const newCardOrder = (0, $lLgj5.getNewCardOrder)(response)?.map((cardKey)=>getCardIdFromCardKey(cardKey));
            if (newCardOrder) actions.push((0, $jiig0.setCardOrderGlobal)(newCardOrder));
            return (0, $3JafE.Observable).from(actions);
        }
        return (0, $3JafE.Observable).of((0, $7Egcu.cardsMoveSuccess)(optimisticId, cardIds, cardListId, analyticsEvent, $41428b6573859af0$var$getTargetStatusId(action)));
    };
const $41428b6573859af0$var$getCardMoveParams = (action, state)=>{
    const { payload: { cardIds: cardIds, cardListId: cardListId, beforeCardId: beforeCardId, afterCardId: afterCardId, selectedTransition: selectedTransition } } = action;
    const rankCustomFieldId = (0, $hkGxG.getRankCustomFieldId)(state);
    if (!rankCustomFieldId) return null;
    const baseUrl = (0, $hkGxG.getBaseUrl)(state);
    const cardEntities = (0, $bP7Jx.getCards)(state);
    const cardLists = (0, $bP7Jx.getCardLists)(state);
    const isCardMoveDisabled = (0, $hkGxG.isCardMoveDisabled)(state);
    if (cardListId === String((0, $9eH8H.UNASSIGNED_EPIC_ID))) return null;
    const cardKeys = cardIds.map((id)=>cardEntities[String(id)].key);
    const rapidViewId = (0, $hkGxG.getRapidViewId)(state);
    const derivedCardListId = (0, $bHPpI.getCardListId)(cardListId);
    const cardList = cardLists[derivedCardListId];
    const cardListType = cardList.type;
    const getCardKeyByCardId = (0, $bP7Jx.makeCardKeyFromCardId)(state);
    const beforeCardKey = !isCardMoveDisabled && beforeCardId ? getCardKeyByCardId(beforeCardId) : null;
    const afterCardKey = !isCardMoveDisabled && afterCardId ? getCardKeyByCardId(afterCardId) : null;
    return {
        cardIds: cardIds,
        cardKeys: cardKeys,
        cardListId: derivedCardListId,
        cardList: cardList,
        cardListType: cardListType,
        beforeCardKey: beforeCardKey,
        afterCardKey: afterCardKey,
        baseUrl: baseUrl,
        rankCustomFieldId: rankCustomFieldId,
        rapidViewId: rapidViewId,
        selectedTransition: selectedTransition
    };
};
const $41428b6573859af0$export$8d85b975065644ab = (action$, store)=>action$.ofType((0, $7Egcu.CARDS_MOVE_REQUEST), (0, $7Egcu.CARDS_MOVE_NON_OPTIMISTIC_REQUEST)).mergeMap((action)=>{
        const state = store.getState();
        const dispatch = store.dispatch.bind(store);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const cardsMoveAction = action;
        const { payload: { cardIds: cardIds, cardListId: cardListId, isBetweenLists: isBetweenLists }, meta: { analyticsEvent: analyticsEvent } } = cardsMoveAction;
        const optimisticId = $41428b6573859af0$var$getOptimisticId(cardsMoveAction);
        // Card move is disabled only if in a CMP board jql filter is not order by RANK
        const cardMoveDisabled = (0, $hkGxG.isCardMoveDisabled)(state);
        if (!isBetweenLists && cardMoveDisabled) return (0, $3JafE.Observable).from([
            (0, $7Egcu.cardsMoveDisabled)(optimisticId, analyticsEvent, (0, $hkGxG.getRapidViewId)(state), (0, $7kNqR.canEditBoardConfig)(state)),
            (0, $jiL2Q.refreshDataRequest)((0, $7TyGu.REFRESH_SOURCE_FAILURE))
        ]);
        const cardMoveParams = $41428b6573859af0$var$getCardMoveParams(cardsMoveAction, state);
        if (!cardMoveParams) return (0, $3JafE.Observable).empty();
        const { cardKeys: cardKeys } = cardMoveParams;
        const serviceContext = (0, $lEnU0.makeServiceContext)(state);
        if (serviceContext.isCompanyManaged && (0, $hkGxG.getBacklogStrategy)(state) === (0, $7TyGu.KANBAN_BACKLOG_STRATEGY) && cardMoveParams.selectedTransition && cardMoveParams.selectedTransition.hasScreen) return (0, $7nUCT.transitionScreenDialogService)({
            issueId: cardIds[0],
            issueKey: cardKeys[0],
            transitionId: cardMoveParams.selectedTransition.id,
            analyticsEvent: analyticsEvent,
            dispatch: dispatch
        }).flatMap($41428b6573859af0$var$rankForTransitionScreen(action, cardMoveParams));
        return $41428b6573859af0$export$e9800111bfe3c5b3(cardsMoveAction, state, cardMoveParams).flatMap($41428b6573859af0$var$handleMoveCardSuccess(cardsMoveAction, state, dispatch, cardMoveParams)).catch((error)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData('backlog.cards-move.failure', 'Failed to move cards', error);
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'issueTransition failed', {
                triggerPointKey: (0, $e2577d2663dd43e5$export$7b6d848ab1be1ec3),
                isModalOpen: false
            });
            return (0, $3JafE.Observable).from([
                (0, $deo0n.hasJiraErrorMessages)(error) ? (0, $7Egcu.cardsTransitionAndRankFailure)(optimisticId, (0, $deo0n.parseJiraErrorMessages)(error), analyticsEvent) : (0, $7Egcu.cardsMoveFailure)(optimisticId, cardIds, cardListId, analyticsEvent, error),
                (0, $jiL2Q.refreshDataRequest)((0, $7TyGu.REFRESH_SOURCE_FAILURE))
            ]);
        });
    });

});
parcelRegister("deo0n", function(module, exports) {

$parcel$export(module.exports, "hasJiraErrorMessages", () => $3eb1420dc20228d7$export$7ee986d35f407138);
$parcel$export(module.exports, "parseJiraErrorMessages", () => $3eb1420dc20228d7$export$d11297bc34463f4);

var $illlw = parcelRequire("illlw");
const $3eb1420dc20228d7$var$parseMessage = (error)=>{
    if (error === null || typeof error !== 'object') return null;
    try {
        const message = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
            'message'
        ], null);
        return JSON.parse(message);
    } catch  {
        return null;
    }
};
const $3eb1420dc20228d7$var$hasErrorMessagesProperty = (response)=>response !== null && typeof response === 'object' && 'errorMessages' in response && Array.isArray(response.errorMessages);
function $3eb1420dc20228d7$export$7ee986d35f407138(error) {
    const response = $3eb1420dc20228d7$var$parseMessage(error);
    return $3eb1420dc20228d7$var$hasErrorMessagesProperty(response) && response.errorMessages.length > 0;
}
function $3eb1420dc20228d7$export$d11297bc34463f4(error) {
    const response = $3eb1420dc20228d7$var$parseMessage(error);
    if ($3eb1420dc20228d7$var$hasErrorMessagesProperty(response)) return response.errorMessages;
    return [];
}

});

parcelRegister("lLgj5", function(module, exports) {

$parcel$export(module.exports, "isFailedTransitionAndRankResponse", () => $9d134907f297b708$export$baa57c6351668324);
$parcel$export(module.exports, "hasTransitionScreens", () => $9d134907f297b708$export$197df750c1dc3961);
$parcel$export(module.exports, "hasMultipleTransitions", () => $9d134907f297b708$export$e642abf2d8cab89c);
$parcel$export(module.exports, "getFirstTransitionScreen", () => $9d134907f297b708$export$b886c9119f3b41db);
$parcel$export(module.exports, "getPossibleTransitions", () => $9d134907f297b708$export$a422da2e79341934);
$parcel$export(module.exports, "getNewCardOrder", () => $9d134907f297b708$export$5455144e38b4d576);
function $9d134907f297b708$export$baa57c6351668324(response) {
    if (response !== null && typeof response === 'object') return 'issuesWereTransitioned' in response && !response.issuesWereTransitioned;
    return false;
}
function $9d134907f297b708$export$197df750c1dc3961(response) {
    return response.possibleTransitions.length > 0 && response.possibleTransitions.some((transition)=>transition.hasTransitionView);
}
function $9d134907f297b708$export$e642abf2d8cab89c(response) {
    return response.possibleTransitions.length > 1;
}
function $9d134907f297b708$export$b886c9119f3b41db(response) {
    return response.possibleTransitions.find((transition)=>transition.hasTransitionView);
}
function $9d134907f297b708$export$a422da2e79341934(response) {
    return response.possibleTransitions || [];
}
function $9d134907f297b708$export$5455144e38b4d576(response) {
    return response !== null && typeof response === 'object' && response.newIssuesOrder !== undefined ? response.newIssuesOrder : null;
}

});

parcelRegister("glCJX", function(module, exports) {

$parcel$export(module.exports, "default", () => $d70d939ef596dbff$export$2e2bcd8739ae039);

var $k0fSp = parcelRequire("k0fSp");
var $d70d939ef596dbff$export$2e2bcd8739ae039 = (0, $k0fSp.default);

});
parcelRegister("k0fSp", function(module, exports) {

$parcel$export(module.exports, "default", () => $d38b42d5bd7df3eb$export$2e2bcd8739ae039);

var $5G2eQ = parcelRequire("5G2eQ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d38b42d5bd7df3eb$export$2e2bcd8739ae039 = (baseUrl, rankCustomFieldId, issueKeys, rankBeforeIssueIdOrKey, rankAfterIssueIdOrKey, rapidViewId, target)=>(0, $5G2eQ.default)(`${baseUrl}/rest/greenhopper/1.0/xboard/assignToListAndRank`, {
        method: 'PUT',
        body: JSON.stringify({
            calculateNewIssuesOrder: false,
            issueKeys: issueKeys,
            rankBeforeIssueIdOrKey: rankBeforeIssueIdOrKey,
            rankAfterIssueIdOrKey: rankAfterIssueIdOrKey,
            rankCustomFieldId: rankCustomFieldId,
            rapidViewId: rapidViewId,
            target: target
        })
    });

});
parcelRegister("5G2eQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d9fb25724578ccf$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("iects");

var $fVqUX = parcelRequire("fVqUX");

var $88Osm = parcelRequire("88Osm");

var $7byHA = parcelRequire("7byHA");

var $etaBp = parcelRequire("etaBp");
const $0d9fb25724578ccf$var$noContentStatus = 204;
var // This function returns a stream which emits a single string value on success, and throws
// an error on failure
// eslint-disable-next-line jira/import/no-anonymous-default-export
$0d9fb25724578ccf$export$2e2bcd8739ae039 = (url, options = {})=>(0, $3JafE.Observable).of(url).mergeMap(()=>fetch(url, (0, $6HC1D.merge)((0, $6HC1D.merge)((0, $fVqUX.default), options), (0, $etaBp.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            const traceId = response.headers.get((0, $88Osm.TRACE_ID_HEADER));
            if (traceId != null && traceId !== '') throw new (0, $7byHA.default)(status, `Fetch call failed with status code: ${response.status}`, traceId);
            else throw new (0, $7byHA.default)(status);
        }
        if (response.status === $0d9fb25724578ccf$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $3JafE.Observable).of(null);
        // @ts-expect-error - TS2339 - Property 'responseText' does not exist on type 'Response'.
        return (0, $3JafE.Observable).of(response.responseText || 'OK');
    });

});



parcelRegister("aqP48", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7880e95dff726de$export$2e2bcd8739ae039);

var $kmb5w = parcelRequire("kmb5w");
var $a7880e95dff726de$export$2e2bcd8739ae039 = (0, $kmb5w.default);

});
parcelRegister("kmb5w", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e657b72c94b330a$export$2e2bcd8739ae039);

var $5G2eQ = parcelRequire("5G2eQ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1e657b72c94b330a$export$2e2bcd8739ae039 = (baseUrl, customFieldId, issueKeys, rankAfterKey)=>(0, $5G2eQ.default)(`${baseUrl}/rest/greenhopper/1.0/api/rank/after`, {
        method: 'PUT',
        body: JSON.stringify({
            customFieldId: customFieldId,
            issueKeys: issueKeys,
            rankAfterKey: rankAfterKey
        })
    });

});


parcelRegister("i4nyo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0099ec816e72515a$export$2e2bcd8739ae039);

var $3LHnc = parcelRequire("3LHnc");
var $0099ec816e72515a$export$2e2bcd8739ae039 = (0, $3LHnc.default);

});
parcelRegister("3LHnc", function(module, exports) {

$parcel$export(module.exports, "default", () => $879d9c38d52e6560$export$2e2bcd8739ae039);

var $5G2eQ = parcelRequire("5G2eQ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$879d9c38d52e6560$export$2e2bcd8739ae039 = (baseUrl, customFieldId, issueKeys, rankBeforeKey)=>(0, $5G2eQ.default)(`${baseUrl}/rest/greenhopper/1.0/api/rank/before`, {
        method: 'PUT',
        body: JSON.stringify({
            customFieldId: customFieldId,
            issueKeys: issueKeys,
            rankBeforeKey: rankBeforeKey
        })
    });

});


parcelRegister("gJAsh", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd91a2f173664a5d$export$2e2bcd8739ae039);

var $bZjpI = parcelRequire("bZjpI");
var $fd91a2f173664a5d$export$2e2bcd8739ae039 = (0, $bZjpI.default);

});
parcelRegister("bZjpI", function(module, exports) {

$parcel$export(module.exports, "default", () => $af78c1b0d0933c85$export$2e2bcd8739ae039);

var $5G2eQ = parcelRequire("5G2eQ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$af78c1b0d0933c85$export$2e2bcd8739ae039 = (baseUrl, customFieldId, rapidViewId, sprintId, issueKeys, rankBeforeKey, rankAfterKey, addToBacklog)=>(0, $5G2eQ.default)(`${baseUrl}/rest/greenhopper/1.0/sprint/rank`, {
        method: 'PUT',
        body: JSON.stringify({
            addToBacklog: addToBacklog,
            calculateNewIssuesOrder: false,
            customFieldId: customFieldId,
            idOrKeys: issueKeys,
            rapidViewId: rapidViewId,
            sprintId: sprintId,
            ...rankAfterKey ? {
                idOrKeyAfter: rankAfterKey
            } : {},
            ...!rankAfterKey && rankBeforeKey ? {
                idOrKeyBefore: rankBeforeKey
            } : {}
        })
    });

});


parcelRegister("8Ub7o", function(module, exports) {

$parcel$export(module.exports, "transitionAndRankService", () => $708e367a4a4402da$export$dfb4be6fa5ae4b7);

var $4oClo = parcelRequire("4oClo");
const $708e367a4a4402da$export$dfb4be6fa5ae4b7 = ({ rankCustomFieldId: rankCustomFieldId, issueKeys: issueKeys, targetColumn: targetColumn, rankBeforeIssueIdOrKey: rankBeforeIssueIdOrKey, rankAfterIssueIdOrKey: rankAfterIssueIdOrKey, rapidViewId: rapidViewId, selectedTransitionId: selectedTransitionId, calculateNewIssuesOrder: calculateNewIssuesOrder = false })=>(0, $4oClo.transitionAndRankFetch)({
        rankCustomFieldId: rankCustomFieldId,
        issueKeys: issueKeys,
        targetColumn: targetColumn,
        rankBeforeIssueIdOrKey: rankBeforeIssueIdOrKey,
        rankAfterIssueIdOrKey: rankAfterIssueIdOrKey,
        rapidViewId: rapidViewId,
        selectedTransitionId: selectedTransitionId,
        calculateNewIssuesOrder: calculateNewIssuesOrder
    });

});
parcelRegister("4oClo", function(module, exports) {

$parcel$export(module.exports, "transitionAndRankFetch", () => $a1a4e21c2b1e085a$export$11e7ff3f2320f2c4);

var $aiRd8 = parcelRequire("aiRd8");
const $a1a4e21c2b1e085a$export$11e7ff3f2320f2c4 = ({ rankCustomFieldId: rankCustomFieldId, issueKeys: issueKeys, targetColumn: targetColumn, rankBeforeIssueIdOrKey: rankBeforeIssueIdOrKey, rankAfterIssueIdOrKey: rankAfterIssueIdOrKey, rapidViewId: rapidViewId, selectedTransitionId: selectedTransitionId, calculateNewIssuesOrder: calculateNewIssuesOrder = false })=>(0, $aiRd8.default)('/rest/greenhopper/1.0/xboard/transitionAndRank', {
        method: 'PUT',
        body: JSON.stringify({
            mode: 'plan',
            calculateNewIssuesOrder: calculateNewIssuesOrder,
            rapidViewId: rapidViewId,
            issueKeys: issueKeys,
            targetColumn: targetColumn,
            rankCustomFieldId: rankCustomFieldId,
            rankBeforeIssueIdOrKey: rankBeforeIssueIdOrKey,
            rankAfterIssueIdOrKey: rankAfterIssueIdOrKey,
            selectedTransitionId: selectedTransitionId
        })
    });

});


parcelRegister("7nUCT", function(module, exports) {

$parcel$export(module.exports, "transitionScreenDialogService", () => $1221beadb4c698af$export$659d73295f3a3de8);
$parcel$export(module.exports, "SOFTWARE_BACKLOG_ISSUE_TRANSITION", () => $e2577d2663dd43e5$export$7b6d848ab1be1ec3);

var $3JafE = parcelRequire("3JafE");

var $jMP2a = parcelRequire("jMP2a");

var $eISgW = parcelRequire("eISgW");


var $7ydKn = parcelRequire("7ydKn");
function $1221beadb4c698af$export$659d73295f3a3de8({ issueId: issueId, issueKey: issueKey, transitionId: transitionId, analyticsEvent: analyticsEvent, dispatch: dispatch }) {
    return new (0, $3JafE.Observable)((subscriber)=>{
        const handleDialogSuccess = ()=>{
            subscriber.next((0, $7ydKn.transitionScreenDialogSuccess)());
            subscriber.complete();
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'issueTransition success', {
                triggerPointKey: (0, $e2577d2663dd43e5$export$7b6d848ab1be1ec3),
                isModalOpen: true
            });
        };
        const handleDialogCancel = ()=>{
            subscriber.next((0, $7ydKn.transitionScreenDialogCancel)());
            subscriber.complete();
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'issueTransition cancel', {
                triggerPointKey: (0, $e2577d2663dd43e5$export$7b6d848ab1be1ec3),
                isModalOpen: true
            });
        };
        const handleDialogError = (error)=>{
            subscriber.error(error || new Error('Transition screen failed'));
            subscriber.complete();
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'issueTransition failed', {
                triggerPointKey: (0, $e2577d2663dd43e5$export$7b6d848ab1be1ec3),
                isModalOpen: true
            });
        };
        const handleDialogShow = ()=>{
            subscriber.next((0, $7ydKn.transitionScreenDialogShow)());
        };
        dispatch((0, $eISgW.openIssueTransitionModal)({
            issueId: String(issueId),
            issueKey: issueKey,
            transitionId: String(transitionId),
            onDialogCancel: handleDialogCancel,
            onDialogError: handleDialogError,
            onDialogSuccess: handleDialogSuccess
        }));
        handleDialogShow();
    });
}

});
parcelRegister("eISgW", function(module, exports) {

$parcel$export(module.exports, "OPEN_ISSUE_TRANSITION_MODAL", () => $93169f9d50830769$export$8832c8eada77a7);
$parcel$export(module.exports, "openIssueTransitionModal", () => $93169f9d50830769$export$bb76131907dfafc);
$parcel$export(module.exports, "CLOSE_ISSUE_TRANSITION_MODAL", () => $93169f9d50830769$export$e15861bd6dba960e);
$parcel$export(module.exports, "closeIssueTransitionModal", () => $93169f9d50830769$export$221941c279d4f72);
const $93169f9d50830769$export$8832c8eada77a7 = 'state.actions.issue.issue-transition-modal.OPEN_ISSUE_TRANSITION_MODAL';
const $93169f9d50830769$export$bb76131907dfafc = (payload)=>({
        type: $93169f9d50830769$export$8832c8eada77a7,
        payload: payload
    });
const $93169f9d50830769$export$e15861bd6dba960e = 'state.actions.issue.issue-transition-modal.CLOSE_ISSUE_TRANSITION_MODAL';
const $93169f9d50830769$export$221941c279d4f72 = ()=>({
        type: $93169f9d50830769$export$e15861bd6dba960e
    });

});

const $e2577d2663dd43e5$export$33dc74496d86bd4a = 'SHOW_EVENT';
const $e2577d2663dd43e5$export$d03e9fb76fb73c30 = 'SUCCESS_EVENT';
const $e2577d2663dd43e5$export$c2f5880ac823ea8e = 'CANCEL_EVENT';
const $e2577d2663dd43e5$export$7b6d848ab1be1ec3 = 'software-backlog-issue-transition';

parcelRegister("7ydKn", function(module, exports) {

$parcel$export(module.exports, "transitionScreenDialogShow", () => $5c16659b96d5673e$export$7cab574154dd97ed);
$parcel$export(module.exports, "transitionScreenDialogSuccess", () => $5c16659b96d5673e$export$818eb39bfb8e0008);
$parcel$export(module.exports, "transitionScreenDialogCancel", () => $5c16659b96d5673e$export$b353addc50c0b6fe);

const $5c16659b96d5673e$export$7cab574154dd97ed = ()=>({
        type: (0, $e2577d2663dd43e5$export$33dc74496d86bd4a)
    });
const $5c16659b96d5673e$export$818eb39bfb8e0008 = ()=>({
        type: (0, $e2577d2663dd43e5$export$d03e9fb76fb73c30)
    });
const $5c16659b96d5673e$export$b353addc50c0b6fe = ()=>({
        type: (0, $e2577d2663dd43e5$export$c2f5880ac823ea8e)
    });

});


parcelRegister("iF8oy", function(module, exports) {

$parcel$export(module.exports, "isShowEvent", () => $3a46151c9a35de96$export$cd300abbf6342075);
$parcel$export(module.exports, "isSuccessfulEvent", () => $3a46151c9a35de96$export$351a696eb45d767b);

function $3a46151c9a35de96$export$cd300abbf6342075(event) {
    return event.type === (0, $e2577d2663dd43e5$export$33dc74496d86bd4a);
}
function $3a46151c9a35de96$export$351a696eb45d767b(event) {
    return event.type === (0, $e2577d2663dd43e5$export$d03e9fb76fb73c30);
}

});

parcelRegister("jiig0", function(module, exports) {

$parcel$export(module.exports, "SET_CARD_ORDER_GLOBAL", () => $1f4c7bdc2d5d0319$export$596e51910ab2bf17);
$parcel$export(module.exports, "setCardOrderGlobal", () => $1f4c7bdc2d5d0319$export$4148d0f8b0a57f36);
const $1f4c7bdc2d5d0319$export$596e51910ab2bf17 = 'state.actions.card-order-global.SET_CARD_ORDER_GLOBAL';
const $1f4c7bdc2d5d0319$export$4148d0f8b0a57f36 = (cardIds)=>({
        type: $1f4c7bdc2d5d0319$export$596e51910ab2bf17,
        payload: cardIds
    });

});


parcelRegister("hkpTY", function(module, exports) {

$parcel$export(module.exports, "cardsNavigateEpic", () => $dcaa5e3d3b8cc515$export$e2e898999df763ff);

var $3JafE = parcelRequire("3JafE");
parcelRequire("8jBvP");
parcelRequire("9u6v2");
parcelRequire("b48pz");
parcelRequire("iects");

var $7GTNy = parcelRequire("7GTNy");

var $68H01 = parcelRequire("68H01");

var $1HfeQ = parcelRequire("1HfeQ");

var $K2SiM = parcelRequire("K2SiM");

var $3htHA = parcelRequire("3htHA");

var $bP7Jx = parcelRequire("bP7Jx");

var $7SnwB = parcelRequire("7SnwB");
const $dcaa5e3d3b8cc515$export$e2e898999df763ff = (action$, store)=>action$.ofType((0, $68H01.CARD_NEXT), (0, $68H01.CARD_PREV)).throttleTime(250).mergeMap(({ type: type, payload: payload })=>{
        const state = store.getState();
        const activeCardId = (0, $bP7Jx.getActiveCard)(state);
        const isActiveCardVisible = activeCardId !== undefined ? (0, $3htHA.makeIsCardVisibleAndNotCollapsed)(state)(activeCardId) : false;
        const isNext = type === (0, $68H01.CARD_NEXT);
        const getFirstSelectableIssueFn = isNext ? (0, $3htHA.getFirstSelectableIssueAscending) : (0, $3htHA.getFirstSelectableIssueDescending);
        const makeNextOrPrevIssueFn = isNext ? (0, $3htHA.makeGetNextSelectableIssue) : (0, $3htHA.makeGetPrevSelectableIssue);
        const nextIssueId = activeCardId !== undefined && isActiveCardVisible ? makeNextOrPrevIssueFn(state)(activeCardId) : getFirstSelectableIssueFn(state);
        const attributes = isNext ? {
            key: 'j',
            id: 'nextIssueKeyboardShortcut'
        } : {
            key: 'k',
            id: 'previousIssueKeyboardShortcut'
        };
        payload.fireShortcutAnalyticsFn(attributes);
        if (nextIssueId !== undefined) {
            const actions = [
                (0, $1HfeQ.cardSingleSelect)(nextIssueId),
                (0, $7GTNy.cardFocus)(nextIssueId)
            ];
            if ((0, $7SnwB.isDetailViewOpen)(state)) actions.push((0, $K2SiM.openDetailViewDebounced)(nextIssueId));
            return (0, $3JafE.Observable).from(actions);
        }
        return (0, $3JafE.Observable).empty();
    });

});
parcelRegister("7GTNy", function(module, exports) {

$parcel$export(module.exports, "CARD_FOCUS", () => $b1946837cf3d65ca$export$7de76f693f0d3820);
$parcel$export(module.exports, "cardFocus", () => $b1946837cf3d65ca$export$e462552ef1675527);
$parcel$export(module.exports, "CARD_BLUR", () => $b1946837cf3d65ca$export$6ac448f92e1f338b);
$parcel$export(module.exports, "cardBlur", () => $b1946837cf3d65ca$export$9dea9abf478df7d7);
const $b1946837cf3d65ca$export$7de76f693f0d3820 = 'state.actions.cards.focus.CARD_FOCUS';
const $b1946837cf3d65ca$export$e462552ef1675527 = (cardId)=>({
        type: $b1946837cf3d65ca$export$7de76f693f0d3820,
        payload: {
            cardId: cardId
        }
    });
const $b1946837cf3d65ca$export$6ac448f92e1f338b = 'state.actions.cards.focus.CARD_BLUR';
const $b1946837cf3d65ca$export$9dea9abf478df7d7 = ()=>({
        type: $b1946837cf3d65ca$export$6ac448f92e1f338b
    });

});

parcelRegister("68H01", function(module, exports) {

$parcel$export(module.exports, "CARD_NEXT", () => $d450b8de96d258c4$export$e780294f9cb0bbfd);
$parcel$export(module.exports, "cardNext", () => $d450b8de96d258c4$export$d848405832f5c1d5);
$parcel$export(module.exports, "CARD_PREV", () => $d450b8de96d258c4$export$22f722071ae1a37d);
$parcel$export(module.exports, "cardPrev", () => $d450b8de96d258c4$export$6dc88d98f7609a22);
const $d450b8de96d258c4$export$e780294f9cb0bbfd = 'state.actions.cards.navigate.CARD_NEXT';
const $d450b8de96d258c4$export$d848405832f5c1d5 = (fireShortcutAnalyticsFn)=>({
        type: $d450b8de96d258c4$export$e780294f9cb0bbfd,
        payload: {
            fireShortcutAnalyticsFn: fireShortcutAnalyticsFn
        }
    });
const $d450b8de96d258c4$export$22f722071ae1a37d = 'state.actions.cards.navigate.CARD_PREV';
const $d450b8de96d258c4$export$6dc88d98f7609a22 = (fireShortcutAnalyticsFn)=>({
        type: $d450b8de96d258c4$export$22f722071ae1a37d,
        payload: {
            fireShortcutAnalyticsFn: fireShortcutAnalyticsFn
        }
    });

});

parcelRegister("3htHA", function(module, exports) {

$parcel$export(module.exports, "getFirstSelectableIssueAscending", () => $b2d5661084a77497$export$10c0b19e7f67cd54);
$parcel$export(module.exports, "getFirstSelectableIssueDescending", () => $b2d5661084a77497$export$66eabf17ea5e1f07);
$parcel$export(module.exports, "makeIsCardVisibleAndNotCollapsed", () => $b2d5661084a77497$export$796b5629f15fb2a0);
$parcel$export(module.exports, "makeGetNextSelectableIssue", () => $b2d5661084a77497$export$a57bd23e25548782);
$parcel$export(module.exports, "makeGetPrevSelectableIssue", () => $b2d5661084a77497$export$6075bf86943a5068);

var $df4Sl = parcelRequire("df4Sl");

var $jqvCZ = parcelRequire("jqvCZ");

var $hkGxG = parcelRequire("hkGxG");

var $1lsov = parcelRequire("1lsov");

var $bP7Jx = parcelRequire("bP7Jx");
const $b2d5661084a77497$export$c09bebfcb61f3779 = (0, $df4Sl.createSelector)([
    (0, $bP7Jx.getVisibleCardListIds),
    (0, $bP7Jx.makeOrderedVisibleCardIdsForCardList),
    (0, $bP7Jx.makeGetVisibleCardOrderFromCardEntries),
    (0, $bP7Jx.makeIsCardListCollapsed)
], (cardListIds, getOrderedVisibleCardsByCardList, getVisibleCardOrderFromCardEntries, isCardListCollapsed)=>cardListIds.filter((id)=>!isCardListCollapsed(id)).map((id)=>getVisibleCardOrderFromCardEntries(id)).find((cardList)=>cardList.length));
const $b2d5661084a77497$export$10c0b19e7f67cd54 = (0, $df4Sl.createSelector)($b2d5661084a77497$export$c09bebfcb61f3779, (cardList)=>cardList && cardList[0]);
const $b2d5661084a77497$export$66eabf17ea5e1f07 = (0, $df4Sl.createSelector)($b2d5661084a77497$export$c09bebfcb61f3779, (cardList)=>cardList && cardList[cardList.length - 1]);
const $b2d5661084a77497$export$796b5629f15fb2a0 = (0, $df4Sl.createSelector)([
    (0, $bP7Jx.makeGetCardListIdByCardId),
    (0, $bP7Jx.makeIsCardListCollapsed),
    (0, $bP7Jx.makeIsCardVisible),
    (0, $1lsov.makeIsCardInCollapsedCardGroup),
    (0, $hkGxG.isCmpKanbanProject)
], (getCardListByCardId, isCardListCollapsed, isCardVisible, isCardInCollapsedCardGroup, isCmpKanbanBacklog)=>(0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((cardId)=>{
        const cardListId = getCardListByCardId(cardId);
        if (cardListId === undefined) return false;
        if (isCmpKanbanBacklog) return !isCardListCollapsed(cardListId) && !isCardInCollapsedCardGroup(cardId) && isCardVisible(cardId);
        return !isCardListCollapsed(cardListId) && isCardVisible(cardId);
    }));
const $b2d5661084a77497$export$1b5a343b24b5f39d = (0, $df4Sl.createSelector)([
    (0, $bP7Jx.getVisibleCardListIds),
    (0, $bP7Jx.makeOrderedVisibleCardIdsForCardList),
    (0, $bP7Jx.makeGetVisibleCardOrderFromCardEntries),
    (0, $bP7Jx.makeIsCardListCollapsed)
], (cardListIds, getOrderedVisibleCardsByCardList, getVisibleCardOrderFromCardEntries, isCardListCollapsed)=>cardListIds.filter((id)=>!isCardListCollapsed(id)).map((id)=>getVisibleCardOrderFromCardEntries(id)).flat());
const $b2d5661084a77497$export$a57bd23e25548782 = (0, $df4Sl.createSelector)($b2d5661084a77497$export$1b5a343b24b5f39d, (selectableIssues)=>(0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((cardId)=>{
        const cardIndex = selectableIssues.indexOf(cardId);
        if (cardIndex < 0) return undefined;
        return selectableIssues[cardIndex + 1];
    }));
const $b2d5661084a77497$export$6075bf86943a5068 = (0, $df4Sl.createSelector)($b2d5661084a77497$export$1b5a343b24b5f39d, (selectableIssues)=>(0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((cardId)=>{
        const cardIndex = selectableIssues.indexOf(cardId);
        return selectableIssues[cardIndex - 1];
    }));

});

parcelRegister("7SnwB", function(module, exports) {

$parcel$export(module.exports, "isDetailViewOpen", () => $55573e7f3b74b33c$export$6c8a703f6e6f7f67);
const $55573e7f3b74b33c$export$6c8a703f6e6f7f67 = (state)=>Boolean(state.ui.detailView);

});


parcelRegister("7Ectt", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d2d5039f10bd410$export$2e2bcd8739ae039);

var $3JafE = parcelRequire("3JafE");
parcelRequire("9u6v2");
parcelRequire("cpH8E");
parcelRequire("jyKN9");
parcelRequire("1Lcr1");
parcelRequire("iects");

var $gUUjF = parcelRequire("gUUjF");

var $6apxJ = parcelRequire("6apxJ");

var $64fZ9 = parcelRequire("64fZ9");

var $bP7Jx = parcelRequire("bP7Jx");
function $1d2d5039f10bd410$export$2e2bcd8739ae039(action$, store) {
    return action$.ofType((0, $6apxJ.CARDS_PARENT_SET_OPTIMISTIC)).mergeMap((action)=>{
        const { payload: { cards: cards, parentId: parentId }, meta: { optimistic: optimistic } } = action;
        const cardEntities = (0, $bP7Jx.getCards)(store.getState());
        const changedCardIds = cards.filter(({ id: id })=>{
            const card = cardEntities[id];
            return card?.parentId !== parentId;
        }).map((card)=>card.id);
        if (changedCardIds.length === 0) return (0, $3JafE.Observable).of((0, $6apxJ.cardsParentSetSuccess)(optimistic.id, {
            cards: cards
        }));
        return (0, $3JafE.Observable).fromPromise(action.payload.requestPromise).flatMap(()=>(0, $3JafE.Observable).of((0, $6apxJ.cardsParentSetSuccess)(optimistic.id, {
                cards: cards
            }))).catch((error)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData('cards.parent-set.failure', 'Failed to set card parent', error);
            const actions = changedCardIds.map((cardId)=>(0, $64fZ9.cardRefreshRequest)(cardId));
            return (0, $3JafE.Observable).from([
                (0, $6apxJ.cardsParentSetFailure)(optimistic.id),
                ...actions
            ]);
        });
    });
}

});
parcelRegister("6apxJ", function(module, exports) {

$parcel$export(module.exports, "CARDS_PARENT_SET_OPTIMISTIC", () => $3f1c76b35846828d$export$91e916b961a6d9b);
$parcel$export(module.exports, "cardsParentSetOptimistic", () => $3f1c76b35846828d$export$3feb2fd47a9012aa);
$parcel$export(module.exports, "CARDS_PARENT_SET_SUCCESS", () => $3f1c76b35846828d$export$249765deb6efe8ae);
$parcel$export(module.exports, "cardsParentSetSuccess", () => $3f1c76b35846828d$export$30fe913aeacc7d4c);
$parcel$export(module.exports, "CARDS_PARENT_SET_FAILURE", () => $3f1c76b35846828d$export$36c7e0e6fa088864);
$parcel$export(module.exports, "cardsParentSetFailure", () => $3f1c76b35846828d$export$24c3df942a1f1dd5);

var $jWq1L = parcelRequire("jWq1L");
const $3f1c76b35846828d$export$91e916b961a6d9b = 'state.actions.cards.parent.CARDS_PARENT_SET_OPTIMISTIC';
const $3f1c76b35846828d$export$3feb2fd47a9012aa = (payload)=>({
        type: $3f1c76b35846828d$export$91e916b961a6d9b,
        payload: payload,
        meta: {
            ...(0, $jWq1L.beginOptimisticUiMeta)()
        }
    });
const $3f1c76b35846828d$export$249765deb6efe8ae = 'state.actions.cards.parent.CARDS_PARENT_SET_SUCCESS';
const $3f1c76b35846828d$export$30fe913aeacc7d4c = (optimisticId, payload)=>({
        type: $3f1c76b35846828d$export$249765deb6efe8ae,
        payload: payload,
        meta: (0, $jWq1L.commitOptimisticUiMeta)(optimisticId)
    });
const $3f1c76b35846828d$export$36c7e0e6fa088864 = 'state.actions.cards.parent.CARDS_PARENT_SET_FAILURE';
const $3f1c76b35846828d$export$24c3df942a1f1dd5 = (optimisticId)=>({
        type: $3f1c76b35846828d$export$36c7e0e6fa088864,
        meta: (0, $jWq1L.revertOptimisticUiWithFlagMeta)(optimisticId)
    });

});


parcelRegister("cve9o", function(module, exports) {

$parcel$export(module.exports, "checkGlobalIssueCreateEpic", () => $4aaa42e456e3df34$export$c92e72129db344be);

var $3JafE = parcelRequire("3JafE");
parcelRequire("9u6v2");
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("iects");

var $jiL2Q = parcelRequire("jiL2Q");

var $lsENz = parcelRequire("lsENz");

var $6iBIZ = parcelRequire("6iBIZ");

var $5ceEB = parcelRequire("5ceEB");
const $4aaa42e456e3df34$export$c92e72129db344be = (action$, store)=>action$.ofType((0, $jiL2Q.CHECK_GLOBAL_ISSUE_CREATE)).mergeMap((action)=>{
        const { payload: { issues: globalIssues } } = action;
        if (globalIssues.length === 0) return (0, $3JafE.Observable).empty();
        const state = store.getState();
        const actions = [];
        // We should refetch versions data when an issue is created to keep the version panel on sync
        // and to avoid this issue: https://hello.atlassian.net/browse/FEBA-1548a
        actions.push((0, $6iBIZ.refetchVersions)());
        // Check if any globally created issues have unmapped statuses
        // (this doesn't however apply to epics since they will be visible on the backlog and board)
        const columnStatusIds = (0, $5ceEB.getColumnStatusIds)(state);
        const unmappedIssuesExist = globalIssues.filter((issue)=>issue.createdIssueDetails.fields.issuetype.hierarchyLevel < 1).some((issue)=>!columnStatusIds.includes(issue.createdIssueDetails.fields.status.id));
        if (unmappedIssuesExist) {
            const cardsIdentifiers = globalIssues.map((issue)=>({
                    id: Number(issue.issueId),
                    key: issue.issueKey
                }));
            actions.push((0, $lsENz.cardCreateUnmappedWithIssueLink)(cardsIdentifiers));
        } else actions.push((0, $lsENz.cardCreateGlobal)(globalIssues));
        return (0, $3JafE.Observable).from(actions);
    });

});

parcelRegister("c5ZkM", function(module, exports) {

$parcel$export(module.exports, "clearMentionsEpic", () => $464d97d998bb7def$export$39d982909afdcdcb);
parcelRequire("8jBvP");

var $3JafE = parcelRequire("3JafE");

var $K2SiM = parcelRequire("K2SiM");

var $5Hc4j = parcelRequire("5Hc4j");

var $bP7Jx = parcelRequire("bP7Jx");
function $464d97d998bb7def$export$39d982909afdcdcb(action$, store) {
    return action$.ofType((0, $K2SiM.OPEN_DETAIL_VIEW)).switchMap((action)=>{
        const state = store.getState();
        const allCards = (0, $bP7Jx.getCards)(state);
        if (allCards[String(action.payload.cardId)]?.mentions) return (0, $3JafE.Observable).of((0, $5Hc4j.clearMentionsOptimisticAction)(action.payload.cardId));
        return (0, $3JafE.Observable).empty();
    });
}

});
parcelRegister("5Hc4j", function(module, exports) {

$parcel$export(module.exports, "MENTIONS_LOAD_SUCCESS", () => $05ce2b83298197cf$export$dab12e1fb149de18);
$parcel$export(module.exports, "CLEAR_MENTIONS_OPTIMISTIC", () => $05ce2b83298197cf$export$78cf38d412f9ca9b);
$parcel$export(module.exports, "mentionsLoadSuccess", () => $05ce2b83298197cf$export$82717d65b1adf979);
$parcel$export(module.exports, "clearMentionsOptimisticAction", () => $05ce2b83298197cf$export$c07946e3117cd149);
const $05ce2b83298197cf$export$dab12e1fb149de18 = 'state.actions.issue.mentions.MENTIONS_LOAD_SUCCESS';
const $05ce2b83298197cf$export$78cf38d412f9ca9b = 'state.actions.issue.mentions.CLEAR_MENTIONS';
const $05ce2b83298197cf$export$82717d65b1adf979 = (mentions)=>({
        type: $05ce2b83298197cf$export$dab12e1fb149de18,
        payload: mentions
    });
const $05ce2b83298197cf$export$c07946e3117cd149 = (cardId)=>({
        type: $05ce2b83298197cf$export$78cf38d412f9ca9b,
        payload: {
            cardId: cardId
        }
    });

});


parcelRegister("5OvhQ", function(module, exports) {

$parcel$export(module.exports, "detailViewCloseEpic", () => $f2e8fc9af1610e2e$export$511093f766907f93);
parcelRequire("8jBvP");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");

var $auF0s = parcelRequire("auF0s");

var $e3Gc5 = parcelRequire("e3Gc5");

var $K2SiM = parcelRequire("K2SiM");

var $kdGmo = parcelRequire("kdGmo");
const $f2e8fc9af1610e2e$export$511093f766907f93 = (getLocation, push)=>(action$, store)=>action$.ofType((0, $K2SiM.CLOSE_DETAIL_VIEW)).switchMap((action)=>{
            const state = store.getState();
            const filters = (0, $kdGmo.getAppliedParentFilters)(state);
            const issueId = action.payload?.issueId;
            push((0, $e3Gc5.removeSelectedIssueFromUrl)((0, $auF0s.removeIssueParentFromUrlByFilters)(getLocation(), issueId, filters)));
            return (0, $3JafE.Observable).empty();
        });

});
parcelRegister("auF0s", function(module, exports) {

$parcel$export(module.exports, "removeIssueParentFromUrlByFilters", () => $d99d30a803c22f71$export$87a36404d6a49f8a);

var $6HC1D = parcelRequire("6HC1D");

var $ldoFd = parcelRequire("ldoFd");

var $53ciZ = parcelRequire("53ciZ");

const $d99d30a803c22f71$export$87a36404d6a49f8a = (location, issueId, filters = [])=>{
    const searchParams = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(location.search);
    const updatedSearchParams = (0, $6HC1D.chain)(searchParams);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(searchParams[0, $5a6592135d519f1e$export$8a2cab795731dc42]) && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(issueId)) {
        const urlIssueParents = searchParams[0, $5a6592135d519f1e$export$8a2cab795731dc42].split(',');
        // The closed issueId is in IssueParent QueryParams, but not in Filters , probably caused by deleting epics in detail view
        const issueIdStr = issueId.toString();
        if (urlIssueParents.includes(issueIdStr) && !filters.includes(issueIdStr)) urlIssueParents.splice(urlIssueParents.indexOf(issueIdStr), 1);
        urlIssueParents.length > 0 ? updatedSearchParams.set((0, $5a6592135d519f1e$export$8a2cab795731dc42), urlIssueParents.join(',')) : updatedSearchParams.unset((0, $5a6592135d519f1e$export$8a2cab795731dc42));
    }
    return {
        ...location,
        search: (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(updatedSearchParams.value())
    };
};

});


parcelRegister("3K60I", function(module, exports) {

$parcel$export(module.exports, "detailViewOpenDebouncedEpic", () => $96032ea7a7e932c7$export$2e5970b542a40342);
parcelRequire("jyKN9");
parcelRequire("5dKXv");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");

var $e3Gc5 = parcelRequire("e3Gc5");

var $K2SiM = parcelRequire("K2SiM");

var $bP7Jx = parcelRequire("bP7Jx");
const $96032ea7a7e932c7$export$2e5970b542a40342 = (getLocation, push)=>(action$, store)=>action$.ofType((0, $K2SiM.OPEN_DETAIL_VIEW_DEBOUNCED)).debounceTime(500).mergeMap((action)=>{
            push((0, $e3Gc5.addSelectedIssueToUrl)((0, $bP7Jx.makeCardKeyFromCardId)(store.getState())(action.payload.cardId), getLocation()));
            return (0, $3JafE.Observable).of((0, $K2SiM.openDetailView)(action.payload.cardId, action.payload.externalAction));
        });

});

parcelRegister("73Buo", function(module, exports) {

$parcel$export(module.exports, "detailViewUpdateEpic", () => $edd27296511ab415$export$ddc67837ea92e238);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("3wBUP");

var $2giiC = parcelRequire("2giiC");

var $1NOG0 = parcelRequire("1NOG0");

var $7Egcu = parcelRequire("7Egcu");

var $6apxJ = parcelRequire("6apxJ");

var $K2SiM = parcelRequire("K2SiM");

var $75nYE = parcelRequire("75nYE");

var $bP7Jx = parcelRequire("bP7Jx");
const $edd27296511ab415$export$ddc67837ea92e238 = (action$, store)=>action$.ofType((0, $1NOG0.CARDS_FLAG_WITH_COMMENT_SUCCESS), (0, $6apxJ.CARDS_PARENT_SET_SUCCESS), (0, $7Egcu.CARDS_MOVE_SUCCESS), (0, $75nYE.CARD_STATUS_SET), (0, $2giiC.CARDS_BULK_OPERATIONS_SUCCESS)).switchMap((action)=>{
        const state = store.getState();
        const { cardId: cardId } = (0, $bP7Jx.getDetailViewData)(state) || {};
        if (!cardId) return (0, $3JafE.Observable).empty();
        if (action.type === (0, $2giiC.CARDS_BULK_OPERATIONS_SUCCESS)) {
            if (action.payload.includes(cardId)) return (0, $3JafE.Observable).of((0, $K2SiM.updateDetailView)());
        }
        if (action.type === (0, $1NOG0.CARDS_FLAG_WITH_COMMENT_SUCCESS) && action.payload.cards.includes(cardId)) return (0, $3JafE.Observable).of((0, $K2SiM.updateDetailView)());
        if (action.type === (0, $6apxJ.CARDS_PARENT_SET_SUCCESS) && action.payload.cards.map((card)=>card.id).includes(cardId)) return (0, $3JafE.Observable).of((0, $K2SiM.updateDetailView)());
        if (action.type === (0, $7Egcu.CARDS_MOVE_SUCCESS)) {
            const parentIds = (0, $bP7Jx.partialCardsFromCardIdsSelector)(state)(action.payload.cardIds).map((card)=>card.parentId);
            if (action.payload.cardIds.includes(cardId) || parentIds.includes(cardId)) return (0, $3JafE.Observable).of((0, $K2SiM.updateDetailView)());
        }
        return (0, $3JafE.Observable).empty();
    });

});

parcelRegister("h8d37", function(module, exports) {

$parcel$export(module.exports, "refetchEpicPanelEpic", () => $9461f2c9388cc6cf$export$da2d2f9f49d2aaf1);

var $MYW4e = parcelRequire("MYW4e");

var $gasA1 = parcelRequire("gasA1");

var $3JafE = parcelRequire("3JafE");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("5dKXv");
parcelRequire("3wBUP");

var $ba1Xy = parcelRequire("ba1Xy");

var $jiL2Q = parcelRequire("jiL2Q");

var $5Tl9n = parcelRequire("5Tl9n");

var $lsENz = parcelRequire("lsENz");

var $c4hFt = parcelRequire("c4hFt");

var $6apxJ = parcelRequire("6apxJ");
const $9461f2c9388cc6cf$var$isCardSetIndividualResponse = (action)=>action.type === (0, $5Tl9n.CARD_SET_INDIVIDUAL_REQUEST_SUCCESS);
const $9461f2c9388cc6cf$var$isBatchCardParentSetSuccess = (batchAction)=>batchAction.payload.some((action)=>$9461f2c9388cc6cf$var$isCardSetIndividualResponse(action) && action.payload.fieldId === (0, $lO4Or.PARENT_TYPE));
const $9461f2c9388cc6cf$var$REFETCH_EPIC_PANEL_DEBOUNCE_MS = 500;
const $9461f2c9388cc6cf$export$da2d2f9f49d2aaf1 = (action$)=>action$.ofType((0, $6apxJ.CARDS_PARENT_SET_SUCCESS), (0, $jiL2Q.REFRESH_DATA_REQUEST), (0, $lsENz.CARD_CREATE_SUCCESS), (0, $c4hFt.CARD_DELETE_SUCCESS), (0, $MYW4e.BATCH)).debounceTime($9461f2c9388cc6cf$var$REFETCH_EPIC_PANEL_DEBOUNCE_MS).switchMap((action)=>{
        if (action.type === (0, $MYW4e.BATCH) && !$9461f2c9388cc6cf$var$isBatchCardParentSetSuccess(action)) return (0, $3JafE.Observable).empty();
        /**
			 * This action is only triggered by DnD into the epic panel, so we can directly call refetch
			 * there instead of waiting for the debounce.
			 *
			 * TODO: remove CARDS_PARENT_SET_SUCCESS from action list once FG is cleaned up
			 */ if (action.type === (0, $6apxJ.CARDS_PARENT_SET_SUCCESS) && (0, $eI5EY.fg)('jsw_epic_panel_paginated_fetch')) return (0, $3JafE.Observable).empty();
        const epicPanelRefetchStoreInstance = (0, $gasA1.defaultRegistry).getStore((0, $ba1Xy.EpicPanelRefetchStore));
        const { triggerEpicPanelRefetch: triggerEpicPanelRefetch } = epicPanelRefetchStoreInstance.actions;
        triggerEpicPanelRefetch();
        return (0, $3JafE.Observable).empty();
    });

});
parcelRegister("ba1Xy", function(module, exports) {

$parcel$export(module.exports, "EpicPanelRefetchStore", () => $d14fb4ea71d1e4db$export$161cbc183f817581);
$parcel$export(module.exports, "useShouldRefetchEpicPanel", () => $d14fb4ea71d1e4db$export$3c3bb9bb30c98856);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $d14fb4ea71d1e4db$var$triggerEpicPanelRefetch = ()=>({ setState: setState })=>{
        setState({
            shouldRefetchEpicPanel: true
        });
    };
const $d14fb4ea71d1e4db$var$finishEpicPanelRefetch = ()=>({ setState: setState })=>{
        setState({
            shouldRefetchEpicPanel: false
        });
    };
const $d14fb4ea71d1e4db$var$actions = {
    triggerEpicPanelRefetch: $d14fb4ea71d1e4db$var$triggerEpicPanelRefetch,
    finishEpicPanelRefetch: $d14fb4ea71d1e4db$var$finishEpicPanelRefetch
};
const $d14fb4ea71d1e4db$export$161cbc183f817581 = (0, $a61MH.createStore)({
    name: 'jira-software-backlog-panel-should-refetch-epic',
    initialState: {
        shouldRefetchEpicPanel: false
    },
    actions: $d14fb4ea71d1e4db$var$actions
});
const $d14fb4ea71d1e4db$export$3c3bb9bb30c98856 = (0, $ggKAj.createHook)($d14fb4ea71d1e4db$export$161cbc183f817581);

});


parcelRegister("2rJcn", function(module, exports) {

$parcel$export(module.exports, "default", () => $bff17a3dac75ba2e$export$2e2bcd8739ae039);

var $3JafE = parcelRequire("3JafE");
parcelRequire("8jBvP");
parcelRequire("jyKN9");
parcelRequire("flmol");
parcelRequire("iects");
parcelRequire("1Lcr1");
parcelRequire("3wBUP");

var $gUUjF = parcelRequire("gUUjF");

var $7pUYz = parcelRequire("7pUYz");

var $8fVZP = parcelRequire("8fVZP");

var $lEnU0 = parcelRequire("lEnU0");

var $jiL2Q = parcelRequire("jiL2Q");

var $dQu14 = parcelRequire("dQu14");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bff17a3dac75ba2e$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $jiL2Q.SET_APP_DATA)).switchMap(()=>{
        const state = store.getState();
        const ctx = (0, $lEnU0.makeServiceContext)(state);
        return (0, $8fVZP.loadExtensionDataService)(ctx).map((0, $7pUYz.transformExtensionLoad)).flatMap((extension)=>(0, $3JafE.Observable).of((0, $dQu14.extensionFetchSuccess)(extension))).catch((error)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData('backlog.extension.operations', error.message, error);
            // ABE-21: Handle this when the call is made as part of the non-critical path
            return (0, $3JafE.Observable).empty();
        });
    });

});
parcelRegister("7pUYz", function(module, exports) {

$parcel$export(module.exports, "transformExtensionLoad", () => $be3511964367094d$export$8fb5dd35b8f7d028);
const $be3511964367094d$export$8fb5dd35b8f7d028 = (response)=>{
    const operations = response.extension ? response.extension.operations.map((op)=>({
            icon: {
                url: op.icon && op.icon.url
            },
            name: op.name,
            url: op.url,
            tooltip: op.tooltip,
            styleClass: op.styleClass
        })) : [];
    return {
        operations: operations
    };
};

});

parcelRegister("8fVZP", function(module, exports) {

$parcel$export(module.exports, "loadExtensionDataService", () => $4f43f1e5f6332b27$export$f33c43566824ade1);

var $3JafE = parcelRequire("3JafE");
parcelRequire("8jBvP");

var $7DIEt = parcelRequire("7DIEt");
function $4f43f1e5f6332b27$export$f33c43566824ade1(ctx) {
    if (ctx.isCompanyManaged) return (0, $3JafE.Observable).empty();
    return (0, $7DIEt.fetchExtensionData)('', ctx.boardId);
}

});
parcelRegister("7DIEt", function(module, exports) {

$parcel$export(module.exports, "fetchExtensionData", () => $9fac1a5268761d1a$export$5fe98ae96d282610);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("iects");

var $jy01K = parcelRequire("jy01K");
const $9fac1a5268761d1a$var$softwareBacklogExtensionOperationName = 'SoftwareBacklogExtension';
const $9fac1a5268761d1a$export$1d6e6c1cef4b8fcc = (boardId)=>`query ${$9fac1a5268761d1a$var$softwareBacklogExtensionOperationName} {
        boardScope(boardId:${boardId}) {
            backlog {
                extension {
                    operations {
                        icon {
                           url
                        }
                        name
                        url
                        tooltip
                        styleClass
                    }
                }
            }
        }
    }`;
const $9fac1a5268761d1a$export$5fe98ae96d282610 = (contextPath, boardId)=>(0, $jy01K.query$)(contextPath, $9fac1a5268761d1a$var$softwareBacklogExtensionOperationName, $9fac1a5268761d1a$export$1d6e6c1cef4b8fcc(boardId)).flatMap((data)=>(0, $3JafE.Observable).of(data.boardScope.backlog));

});


parcelRegister("dQu14", function(module, exports) {

$parcel$export(module.exports, "EXTENSION_FETCH_SUCCESS", () => $22890cf0d9e1dadf$export$4b80f261a964f809);
$parcel$export(module.exports, "extensionFetchSuccess", () => $22890cf0d9e1dadf$export$12037fbc95e2254d);
const $22890cf0d9e1dadf$export$4b80f261a964f809 = 'state.actions.extension.EXTENSION_FETCH_SUCCESS';
const $22890cf0d9e1dadf$export$12037fbc95e2254d = (extension)=>({
        type: $22890cf0d9e1dadf$export$4b80f261a964f809,
        payload: {
            extension: extension
        }
    });

});


parcelRegister("9NOwm", function(module, exports) {

$parcel$export(module.exports, "filterValidValuesEpic", () => $ee959e347e982e42$export$92792813ec12d76);
parcelRequire("9u6v2");
parcelRequire("8OtG5");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");

var $6hJzD = parcelRequire("6hJzD");

var $jAbil = parcelRequire("jAbil");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $8ZI73 = parcelRequire("8ZI73");

var $c2v8q = parcelRequire("c2v8q");
const $ee959e347e982e42$var$makeFilter = (state)=>(0, $8ZI73.isCriticalDataLoaded)(state) && (0, $c2v8q.isCurrentUserLoaded)(state) && (0, $8ZI73.isConfigLoaded)(state) && (0, $bP7Jx.hasInvalidFilterValuesSelector)(state);
const $ee959e347e982e42$export$92792813ec12d76 = (getLocation, push)=>(action$, store)=>action$.filter(()=>$ee959e347e982e42$var$makeFilter(store.getState())).mergeMap(()=>{
            const state = store.getState();
            const filters = (0, $bP7Jx.validFilterValuesSelector)(state);
            const actions = [
                (0, $jAbil.setAllFilters)(filters)
            ];
            const isCompanyManaged = (0, $hkGxG.getIsCompanyManaged)(state);
            push((0, $6hJzD.getPushPayload)(filters, getLocation(), isCompanyManaged));
            return (0, $3JafE.Observable).from(actions);
        });

});
parcelRegister("6hJzD", function(module, exports) {

$parcel$export(module.exports, "getPushPayload", () => $e1f76fbe73eb43d6$export$6ee0645423b27902);

var $6HC1D = parcelRequire("6HC1D");

var $53ciZ = parcelRequire("53ciZ");


const $e1f76fbe73eb43d6$export$6ee0645423b27902 = (filters, location, isCompanyManaged)=>{
    const search = (0, $6HC1D.chain)({
        ...(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(location.search)
    });
    filters[0, $6b2c0bb2f15ce467$export$d597759d33be802e] ? search.set((0, $5a6592135d519f1e$export$e39925d10cebc0b), filters[0, $6b2c0bb2f15ce467$export$d597759d33be802e]) : search.unset((0, $5a6592135d519f1e$export$e39925d10cebc0b));
    filters[0, $6b2c0bb2f15ce467$export$f8f7545d2bb78afb] ? search.set((0, $5a6592135d519f1e$export$f78d8c81fcad32a2), filters[0, $6b2c0bb2f15ce467$export$f8f7545d2bb78afb].join(',')) : search.unset((0, $5a6592135d519f1e$export$f78d8c81fcad32a2));
    filters[0, $6b2c0bb2f15ce467$export$37aee82a3cb1e8f7] ? search.set((0, $5a6592135d519f1e$export$e729d951ab128c3b), filters[0, $6b2c0bb2f15ce467$export$37aee82a3cb1e8f7].join(',')) : search.unset((0, $5a6592135d519f1e$export$e729d951ab128c3b));
    filters[0, $6b2c0bb2f15ce467$export$2a4f270075a033de] ? search.set((0, $5a6592135d519f1e$export$8a2cab795731dc42), filters[0, $6b2c0bb2f15ce467$export$2a4f270075a033de].join(',')) : search.unset((0, $5a6592135d519f1e$export$8a2cab795731dc42));
    filters[0, $6b2c0bb2f15ce467$export$ebb48b08205007c5] ? search.set((0, $5a6592135d519f1e$export$fa7b72626a2e0090), filters[0, $6b2c0bb2f15ce467$export$ebb48b08205007c5].join(',')) : search.unset((0, $5a6592135d519f1e$export$fa7b72626a2e0090));
    filters[0, $6b2c0bb2f15ce467$export$a4ad2735b021c132] ? search.set((0, $5a6592135d519f1e$export$392308739e657b75), filters[0, $6b2c0bb2f15ce467$export$a4ad2735b021c132].join(',')) : search.unset((0, $5a6592135d519f1e$export$392308739e657b75));
    if (isCompanyManaged) filters[0, $6b2c0bb2f15ce467$export$68d693c35a8d8866] ? search.set((0, $5a6592135d519f1e$export$cb08ebea4a46cd29), filters[0, $6b2c0bb2f15ce467$export$68d693c35a8d8866].join(',')) : search.unset((0, $5a6592135d519f1e$export$cb08ebea4a46cd29));
    return {
        ...location,
        search: (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(search.value())
    };
};

});

parcelRegister("jAbil", function(module, exports) {

$parcel$export(module.exports, "SET_ALL_FILTERS", () => $8f8c0eb80ae43fdb$export$2771e5a27cdc85fe);
$parcel$export(module.exports, "setAllFilters", () => $8f8c0eb80ae43fdb$export$1e6b2e9f0ff84131);
const $8f8c0eb80ae43fdb$export$2771e5a27cdc85fe = 'state.actions.filters.SET_ALL_FILTERS';
const $8f8c0eb80ae43fdb$export$1e6b2e9f0ff84131 = (filters, filterType)=>({
        type: $8f8c0eb80ae43fdb$export$2771e5a27cdc85fe,
        payload: {
            filters: filters
        },
        meta: {
            filterType: filterType
        }
    });

});


parcelRegister("a4X60", function(module, exports) {

$parcel$export(module.exports, "filteredCardsEpic", () => $d009d9fa6652a953$export$e2f185e35a8c9054);

var $bd1K7 = parcelRequire("bd1K7");

var $1ybV0 = parcelRequire("1ybV0");

var $8LJqN = parcelRequire("8LJqN");

var $fwBbi = parcelRequire("fwBbi");

var $7Q0mj = parcelRequire("7Q0mj");

var $4oqbp = parcelRequire("4oqbp");

var $4vLC2 = parcelRequire("4vLC2");
const $d009d9fa6652a953$var$refilterRequestEpic = (0, $8LJqN.functionWithCondition)(()=>(0, $1ybV0.ff)('issue.dee-3496-batch-realtime-update'), (0, $4vLC2.refilterRequestEpicNew), (0, $4oqbp.refilterRequestEpic));
const $d009d9fa6652a953$export$e2f185e35a8c9054 = (0, $bd1K7.combineEpics)((0, $7Q0mj.filteredCardsRequestEpic), $d009d9fa6652a953$var$refilterRequestEpic, (0, $fwBbi.clearFilterRequestEpic));

});
parcelRegister("fwBbi", function(module, exports) {

$parcel$export(module.exports, "clearFilterRequestEpic", () => $0e6ce51a5edede32$export$f800c2415f438ec5);

var $3JafE = parcelRequire("3JafE");

var $jAy5L = parcelRequire("jAy5L");
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("5dKXv");
parcelRequire("b48pz");
parcelRequire("3wBUP");
parcelRequire("iects");
parcelRequire("1Lcr1");
parcelRequire("9u6v2");

var $gUUjF = parcelRequire("gUUjF");

var $lkfU5 = parcelRequire("lkfU5");

var $lEnU0 = parcelRequire("lEnU0");

var $jiL2Q = parcelRequire("jiL2Q");

var $5awap = parcelRequire("5awap");

var $cmYrZ = parcelRequire("cmYrZ");
const $0e6ce51a5edede32$export$4670d1476dee8194 = (action, store, dependencies)=>{
    const state = store.getState();
    const { analyticsEvent: analyticsEvent } = action.meta;
    const ctx = (0, $lEnU0.makeServiceContext)(state);
    return (0, $lkfU5.loadPlanDataService)({
        boardId: ctx.boardId,
        isCompanyManaged: ctx.isCompanyManaged,
        epicIssueType: null,
        storeFieldsActions: dependencies?.storeFieldsActions
    }).mergeMap((data)=>(0, $3JafE.Observable).from([
            (0, $5awap.clearFilteredCardsSuccess)(analyticsEvent),
            (0, $jiL2Q.setAppData)(data)
        ])).catch((error)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('backlog.clear-filtered-cards.failure', 'Failed to load plan data to clear cards filter', error);
        return (0, $3JafE.Observable).of((0, $5awap.clearFilteredCardsFailed)(error, analyticsEvent));
    });
};
const $0e6ce51a5edede32$export$f800c2415f438ec5 = (action$, store, dependencies)=>action$.ofType((0, $5awap.FILTERED_CARD_CLEAR_REQUEST)).throttleTime((0, $cmYrZ.getCustomFiltersDebounceTime)(), (0, $jAy5L.async), {
        leading: true,
        trailing: true
    }).switchMap((action)=>$0e6ce51a5edede32$export$4670d1476dee8194(action, store, dependencies));

});
parcelRegister("lkfU5", function(module, exports) {

$parcel$export(module.exports, "loadPlanDataService", () => $d23a44e960e8fdf5$export$102560d7738611a1);
parcelRequire("flmol");

var $29S60 = parcelRequire("29S60");

var $65m09 = parcelRequire("65m09");

var $a5ySG = parcelRequire("a5ySG");
function $d23a44e960e8fdf5$export$102560d7738611a1({ boardId: boardId, isCompanyManaged: isCompanyManaged, activeQuickFilters: activeQuickFilters, epicIssueType: epicIssueType, storeFieldsActions: storeFieldsActions }) {
    return (0, $65m09.fetchPlanData)({
        rapidViewId: boardId,
        activeQuickFilters: activeQuickFilters,
        operation: 'fetchBacklogData'
    }).map((data)=>{
        if (storeFieldsActions?.storeFieldsFromPrefetchedPlanData) storeFieldsActions.storeFieldsFromPrefetchedPlanData(data, epicIssueType);
        (0, $29S60.refreshUIFBacklogData)(Number(boardId), data);
        return (0, $a5ySG.transformPlanData)(data, isCompanyManaged, activeQuickFilters);
    });
}

});
parcelRegister("29S60", function(module, exports) {

$parcel$export(module.exports, "fetchUIFBoardData", () => $72f7d8eba96fa460$export$240c6c415d37cd75);
$parcel$export(module.exports, "refreshUIFBoardData", () => $72f7d8eba96fa460$export$f34cbc63057c38be);
$parcel$export(module.exports, "fetchUIFBacklogData", () => $72f7d8eba96fa460$export$60a4d33615c60f8);
$parcel$export(module.exports, "refreshUIFBacklogData", () => $72f7d8eba96fa460$export$69efc1d2bf5ce2ae);

var $3tdFZ = parcelRequire("3tdFZ");

var $jnsOw = parcelRequire("jnsOw");

var $flfbz = parcelRequire("flfbz");

var $gzSgn = parcelRequire("gzSgn");

var $fvaL4 = parcelRequire("fvaL4");
async function $72f7d8eba96fa460$export$240c6c415d37cd75(params) {
    const { cachedPromise: cachedPromise, refreshPromise: refreshPromise } = (0, $gzSgn.fetchUIFBoardDataStream)(params);
    const refreshResult = refreshPromise.then((value)=>({
            value: value,
            type: 'refresh'
        }));
    const { value: result, type: type } = await Promise.race([
        cachedPromise.then((value)=>value != null ? {
                value: value,
                type: 'cache'
            } : refreshResult),
        refreshResult
    ]);
    const isCacheHit = type === 'cache';
    return {
        result: result,
        refresh: isCacheHit ? refreshPromise : null,
        isCacheHit: isCacheHit
    };
}
async function $72f7d8eba96fa460$export$f34cbc63057c38be(boardId, response) {
    (0, $flfbz.setBoardCachedEntry)({
        boardId: boardId
    }, {
        timestamp: Date.now(),
        etag: response.etag,
        data: response
    });
}
async function $72f7d8eba96fa460$export$60a4d33615c60f8(boardId, queryParameters) {
    const { cachedPromise: cachedPromise, requestPromise: requestPromise } = (0, $3tdFZ.fetchUIFBacklogData)(boardId, queryParameters);
    const refreshResult = requestPromise.then((response)=>{
        $72f7d8eba96fa460$export$69efc1d2bf5ce2ae(boardId, response);
        return {
            result: response,
            type: 'refresh'
        };
    });
    const { result: result, type: type } = await Promise.race([
        cachedPromise.then((cachedResult)=>cachedResult != null ? {
                result: cachedResult.data,
                type: 'cache'
            } : refreshResult),
        refreshResult
    ]);
    const isCacheHit = type === 'cache';
    return {
        result: result,
        refresh: type === 'cache' ? requestPromise : null,
        isCacheHit: isCacheHit
    };
}
function $72f7d8eba96fa460$export$69efc1d2bf5ce2ae(boardId, response) {
    return (0, $jnsOw.setBacklogCachedEntry)(boardId, {
        timestamp: Date.now(),
        data: response
    });
}

});
parcelRegister("3tdFZ", function(module, exports) {

$parcel$export(module.exports, "fetchUIFBacklogDataOld", () => $c92fa7371748cd09$export$df49ad631c58a3f6);
$parcel$export(module.exports, "fetchUIFBacklogData", () => $c92fa7371748cd09$export$60a4d33615c60f8);
$parcel$export(module.exports, "runUIFBacklogEarlyScript", () => $c92fa7371748cd09$export$a0c2e05a12ae5621);

var $53ciZ = parcelRequire("53ciZ");


var $6iz4v = parcelRequire("6iz4v");

var $iNkad = parcelRequire("iNkad");
var $lLasf = parcelRequire("lLasf");

var $1ybV0 = parcelRequire("1ybV0");

var $1qnta = parcelRequire("1qnta");

var $jnsOw = parcelRequire("jnsOw");

var $7VFPc = parcelRequire("7VFPc");

var $1gfCa = parcelRequire("1gfCa");
// Removing isIndexedDBCachingEnabledForBacklog will make this obsolete.
let $c92fa7371748cd09$var$backlogResponsePromise;
let $c92fa7371748cd09$var$backlogResponse = null;
const $c92fa7371748cd09$export$b08a6e96e3de5356 = (response)=>{
    $c92fa7371748cd09$var$backlogResponsePromise = response;
};
const $c92fa7371748cd09$export$592ab10c6cb9d596 = ()=>{
    const response = $c92fa7371748cd09$var$backlogResponsePromise;
    $c92fa7371748cd09$var$backlogResponsePromise = null;
    return response;
};
const $c92fa7371748cd09$export$55e9294018933a18 = (response)=>{
    $c92fa7371748cd09$var$backlogResponse = response;
};
const $c92fa7371748cd09$export$b55ab086f6a0c481 = ()=>{
    const response = $c92fa7371748cd09$var$backlogResponse;
    $c92fa7371748cd09$var$backlogResponse = null;
    return response;
};
const $c92fa7371748cd09$var$onEnd = ()=>{
    (0, $6iz4v.setMark)('uif-backlog-fetch-end');
    (0, $6iz4v.setMeasure)('uif-backlog-fetch/request', 'uif-backlog-fetch-start-request', 'uif-backlog-fetch-end');
    (0, $6iz4v.setMeasure)('uif-backlog-fetch', 'uif-backlog-fetch-start', 'uif-backlog-fetch-end');
};
const $c92fa7371748cd09$export$df49ad631c58a3f6 = async (boardId, queryParameters)=>{
    const earlyScriptResponse = $c92fa7371748cd09$export$592ab10c6cb9d596();
    if (earlyScriptResponse) return earlyScriptResponse;
    (0, $6iz4v.setMark)('uif-backlog-fetch-start');
    const fetchUIFBacklogDataParams = (0, $1gfCa.buildPlanDataFetchOptions)(boardId, queryParameters);
    const queryStr = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(fetchUIFBacklogDataParams);
    (0, $6iz4v.setMark)('uif-backlog-fetch-start-request');
    const backlogDataUrl = `/rest/greenhopper/1.0/xboard/plan/v2/backlog/data?${queryStr}`;
    const headers = {
        'X-Atlassian-Capability': (0, $d07297a4af13004b$export$571692eec8a399e1)
    };
    Object.assign(headers, (0, $1qnta.getActiveTraceHttpRequestHeaders)(backlogDataUrl));
    const res = await fetch(backlogDataUrl, {
        headers: headers
    });
    const json = await res.json().catch(()=>null);
    if (!res.ok) {
        $c92fa7371748cd09$var$onEnd();
        const traceId = (0, $lLasf.getTraceId)(res);
        const message = (0, $7VFPc.extractErrorMessage)(json);
        if (traceId) throw new (0, $iNkad.FetchError)(res.status, message, traceId);
        else throw new (0, $iNkad.FetchError)(res.status, message);
    }
    $c92fa7371748cd09$var$onEnd();
    return json;
};
const $c92fa7371748cd09$export$60a4d33615c60f8 = (boardId, queryParameters)=>{
    const earlyScriptResponse = $c92fa7371748cd09$export$b55ab086f6a0c481();
    if (earlyScriptResponse) return earlyScriptResponse;
    const requestPromise = (async ()=>{
        (0, $6iz4v.setMark)('uif-backlog-fetch-start');
        const fetchUIFBacklogDataParams = (0, $1gfCa.buildPlanDataFetchOptions)(boardId, queryParameters);
        const queryStr = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(fetchUIFBacklogDataParams);
        (0, $6iz4v.setMark)('uif-backlog-fetch-start-request');
        const backlogDataUrl = `/rest/greenhopper/1.0/xboard/plan/v2/backlog/data?${queryStr}`;
        const headers = {
            'X-Atlassian-Capability': (0, $d07297a4af13004b$export$571692eec8a399e1)
        };
        Object.assign(headers, (0, $1qnta.getActiveTraceHttpRequestHeaders)(backlogDataUrl));
        const res = await fetch(backlogDataUrl, {
            headers: headers
        });
        const json = await res.json().catch(()=>null);
        if (!res.ok) {
            $c92fa7371748cd09$var$onEnd();
            const traceId = (0, $lLasf.getTraceId)(res);
            const message = (0, $7VFPc.extractErrorMessage)(json);
            if (traceId) throw new (0, $iNkad.FetchError)(res.status, message, traceId);
            else throw new (0, $iNkad.FetchError)(res.status, message);
        }
        $c92fa7371748cd09$var$onEnd();
        return json;
    })();
    const cachedPromise = (0, $jnsOw.getBacklogCachedEntry)(boardId);
    return {
        requestPromise: requestPromise,
        cachedPromise: cachedPromise
    };
};
function $c92fa7371748cd09$export$a0c2e05a12ae5621(location) {
    const parsedResult = (0, $7VFPc.parseBacklogLocation)(location);
    if (!parsedResult) return false;
    const { boardId: boardId, queryParameters: queryParameters } = parsedResult;
    if ((0, $1ybV0.ff)('jsw.perf.enable-indexeddb-caching-for-backlog')) {
        const backlogData = $c92fa7371748cd09$export$60a4d33615c60f8(boardId, queryParameters);
        $c92fa7371748cd09$export$55e9294018933a18(backlogData);
    } else {
        const backlogData = $c92fa7371748cd09$export$df49ad631c58a3f6(boardId, queryParameters);
        $c92fa7371748cd09$export$b08a6e96e3de5356(backlogData);
    }
    return true;
}

});
const $d07297a4af13004b$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $d07297a4af13004b$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $d07297a4af13004b$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $d07297a4af13004b$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $d07297a4af13004b$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $d07297a4af13004b$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $d07297a4af13004b$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $d07297a4af13004b$export$6d592df97fba16ca = 'GIN_GLOBAL_ISSUE_NAVIGATOR';
const $d07297a4af13004b$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $d07297a4af13004b$export$4695c1a423ffe431 = 'DASHBOARD';
const $d07297a4af13004b$export$4ce203fc8c0eb2d1 = 'ISSUE_MOVE';
const $d07297a4af13004b$export$49d57bef9ac2550b = 'GLOBAL_ISSUE_CREATE';
const $d07297a4af13004b$export$9a80695e72849f84 = 'X-Atlassian-Capability';

parcelRegister("jnsOw", function(module, exports) {

$parcel$export(module.exports, "setBacklogCachedEntry", () => $39d1d6d1bd6bce98$export$a9fe76d96b47f80a);
$parcel$export(module.exports, "getBacklogCachedEntry", () => $39d1d6d1bd6bce98$export$d01cbd23f4b0c290);

var $9ENT0 = parcelRequire("9ENT0");

var $1PHwb = parcelRequire("1PHwb");
const $39d1d6d1bd6bce98$export$1ba4f312a27970c1 = (0, $9ENT0.createIndexedDBStorageProvider)('cmp-backlog');
async function $39d1d6d1bd6bce98$export$a9fe76d96b47f80a(boardId, entry) {
    if (!entry.data.localDeviceCacheEnabled) {
        $39d1d6d1bd6bce98$export$1ba4f312a27970c1.clearAll();
        return Promise.resolve();
    }
    const key = (0, $1PHwb.buildCachedEntryKey)(boardId);
    return $39d1d6d1bd6bce98$export$1ba4f312a27970c1.set(key, entry);
}
async function $39d1d6d1bd6bce98$export$d01cbd23f4b0c290(boardId) {
    const key = (0, $1PHwb.buildCachedEntryKey)(boardId);
    try {
        const entry = await $39d1d6d1bd6bce98$export$1ba4f312a27970c1.get(key);
        if (!entry) return null;
        if (!(0, $1PHwb.isValid)(entry)) {
            await $39d1d6d1bd6bce98$export$1ba4f312a27970c1.remove(key);
            return null;
        }
        return entry;
    } catch (err) {
        return null;
    }
}

});
parcelRegister("9ENT0", function(module, exports) {

$parcel$export(module.exports, "createIndexedDBStorageProvider", () => $6d438df2aac0e8d6$export$6ba36c4f5fb8919d);

var $jqvCZ = parcelRequire("jqvCZ");

var $gAbZm = parcelRequire("gAbZm");
const $6d438df2aac0e8d6$export$6ba36c4f5fb8919d = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((appPrefix, options)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const provider = (0, $gAbZm.createStorageProvider)(appPrefix);
    if (options?.shouldAutoReconnect) return (0, $gAbZm.withAutoReconnect)(provider);
    return provider;
});

});
parcelRegister("gAbZm", function(module, exports) {

$parcel$export(module.exports, "createStorageProvider", () => $36fa2b3f05c0cdab$export$8441605555fbd60c);
$parcel$export(module.exports, "withAutoReconnect", () => $36fa2b3f05c0cdab$export$8432fe49db7d8865);

var $k1THV = parcelRequire("k1THV");
const $36fa2b3f05c0cdab$export$7382f85ef4ff4314 = (prefix, key)=>`${prefix.replace(/_*$/, '')}__${key || ''}`;
const $36fa2b3f05c0cdab$var$createCustomStore = ()=>(0, $k1THV.createStore)('keyval-store', 'keyval');
let $36fa2b3f05c0cdab$var$customStore;
const $36fa2b3f05c0cdab$var$getStore = ()=>{
    let store = $36fa2b3f05c0cdab$var$customStore;
    if (!store) {
        $36fa2b3f05c0cdab$var$customStore = $36fa2b3f05c0cdab$var$createCustomStore();
        store = $36fa2b3f05c0cdab$var$customStore;
    }
    return store;
};
const $36fa2b3f05c0cdab$export$8441605555fbd60c = (appPrefix)=>{
    const KEYS_STORE_PREFIX = $36fa2b3f05c0cdab$export$7382f85ef4ff4314(appPrefix);
    const prefix = (key)=>$36fa2b3f05c0cdab$export$7382f85ef4ff4314(appPrefix, key);
    // Runtime check to ensure a key is provided as the prefix without a key
    // holds an array of all the keys that are prefixed by this store
    const assertKey = (key)=>{
        if (!key) throw Error('You must provide a key');
    };
    // Calling `clearAll` would require us to iterate over every key in the
    // indexed-db, filtering by this instance's prefix and subsequently deleting
    // all the filtered keys. As indexed-db gains traction within Jira, this
    // will quickly become an expensive operation. To counteract this, we
    // instead store all the keys that this instance has created so that when it
    // comes time to clear them all, we simply just have to clear every key in
    // this store. This removes the need for iterating and filtering all
    // together.
    const updateStoreKeys = async (key, remove = false)=>(0, $k1THV.update)(KEYS_STORE_PREFIX, (currentKeys)=>{
            const storeKeys = new Set(currentKeys);
            if (remove) {
                storeKeys.delete(key);
                return Array.from(storeKeys.values());
            }
            storeKeys.add(key);
            return Array.from(storeKeys.values());
        }, $36fa2b3f05c0cdab$var$getStore());
    return {
        async get (key) {
            assertKey(key);
            return (0, $k1THV.get)(prefix(key), $36fa2b3f05c0cdab$var$getStore());
        },
        async remove (key) {
            assertKey(key);
            const prefixedKey = prefix(key);
            await (0, $k1THV.del)(prefixedKey, $36fa2b3f05c0cdab$var$getStore());
            return updateStoreKeys(prefixedKey, true);
        },
        async clearAll () {
            const prefixedKeys = await (0, $k1THV.get)(KEYS_STORE_PREFIX, $36fa2b3f05c0cdab$var$getStore());
            if (!prefixedKeys || prefixedKeys.length === 0) return undefined;
            return (0, $k1THV.delMany)(prefixedKeys.concat(KEYS_STORE_PREFIX));
        },
        async set (key, value) {
            assertKey(key);
            const prefixedKey = prefix(key);
            if (typeof value === 'function') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            (0, $k1THV.update)(prefixedKey, value);
            else (0, $k1THV.set)(prefixedKey, value, $36fa2b3f05c0cdab$var$getStore());
            return updateStoreKeys(prefixedKey);
        },
        async reconnect () {
            $36fa2b3f05c0cdab$var$customStore = $36fa2b3f05c0cdab$var$createCustomStore();
        }
    };
};
const $36fa2b3f05c0cdab$export$8432fe49db7d8865 = (storageProvider)=>({
        async get (...args) {
            try {
                return await storageProvider.get(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.get(...args);
                }
                throw e;
            }
        },
        async set (...args) {
            try {
                return await storageProvider.set(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.set(...args);
                }
                throw e;
            }
        },
        async remove (...args) {
            try {
                return await storageProvider.remove(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.remove(...args);
                }
                throw e;
            }
        },
        async clearAll (...args) {
            try {
                return await storageProvider.clearAll(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.clearAll(...args);
                }
                throw e;
            }
        },
        async reconnect () {
            await storageProvider.reconnect?.();
        }
    });

});
parcelRegister("k1THV", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $e94f1cffaec1fb5e$export$f51a9068ac82ea43);
$parcel$export(module.exports, "get", () => $e94f1cffaec1fb5e$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $e94f1cffaec1fb5e$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "update", () => $e94f1cffaec1fb5e$export$722fbec263ad908a);
$parcel$export(module.exports, "del", () => $e94f1cffaec1fb5e$export$1d2f21e549771e67);
$parcel$export(module.exports, "delMany", () => $e94f1cffaec1fb5e$export$c8aa84257229cac8);
function $e94f1cffaec1fb5e$export$b327150396135fe7(request) {
    return new Promise((resolve, reject)=>{
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
function $e94f1cffaec1fb5e$export$f51a9068ac82ea43(dbName, storeName) {
    const request = indexedDB.open(dbName);
    request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
    const dbp = $e94f1cffaec1fb5e$export$b327150396135fe7(request);
    return (txMode, callback)=>dbp.then((db)=>callback(db.transaction(storeName, txMode).objectStore(storeName)));
}
let $e94f1cffaec1fb5e$var$defaultGetStoreFunc;
function $e94f1cffaec1fb5e$var$defaultGetStore() {
    if (!$e94f1cffaec1fb5e$var$defaultGetStoreFunc) $e94f1cffaec1fb5e$var$defaultGetStoreFunc = $e94f1cffaec1fb5e$export$f51a9068ac82ea43('keyval-store', 'keyval');
    return $e94f1cffaec1fb5e$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e94f1cffaec1fb5e$export$3988ae62b71be9a3(key, customStore = $e94f1cffaec1fb5e$var$defaultGetStore()) {
    return customStore('readonly', (store)=>$e94f1cffaec1fb5e$export$b327150396135fe7(store.get(key)));
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e94f1cffaec1fb5e$export$adaa4cf7ef1b65be(key, value, customStore = $e94f1cffaec1fb5e$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.put(value, key);
        return $e94f1cffaec1fb5e$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e94f1cffaec1fb5e$export$daa0a5170277c7a8(entries, customStore = $e94f1cffaec1fb5e$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        entries.forEach((entry)=>store.put(entry[1], entry[0]));
        return $e94f1cffaec1fb5e$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e94f1cffaec1fb5e$export$5df405cccea42673(keys, customStore = $e94f1cffaec1fb5e$var$defaultGetStore()) {
    return customStore('readonly', (store)=>Promise.all(keys.map((key)=>$e94f1cffaec1fb5e$export$b327150396135fe7(store.get(key)))));
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e94f1cffaec1fb5e$export$722fbec263ad908a(key, updater, customStore = $e94f1cffaec1fb5e$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise((resolve, reject)=>{
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($e94f1cffaec1fb5e$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e94f1cffaec1fb5e$export$1d2f21e549771e67(key, customStore = $e94f1cffaec1fb5e$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.delete(key);
        return $e94f1cffaec1fb5e$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e94f1cffaec1fb5e$export$c8aa84257229cac8(keys, customStore = $e94f1cffaec1fb5e$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        keys.forEach((key)=>store.delete(key));
        return $e94f1cffaec1fb5e$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e94f1cffaec1fb5e$export$42ffd38884aecdac(customStore = $e94f1cffaec1fb5e$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.clear();
        return $e94f1cffaec1fb5e$export$b327150396135fe7(store.transaction);
    });
}
function $e94f1cffaec1fb5e$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $e94f1cffaec1fb5e$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e94f1cffaec1fb5e$export$ed97f33186d4b816(customStore = $e94f1cffaec1fb5e$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAllKeys) return $e94f1cffaec1fb5e$export$b327150396135fe7(store.getAllKeys());
        const items = [];
        return $e94f1cffaec1fb5e$var$eachCursor(store, (cursor)=>items.push(cursor.key)).then(()=>items);
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e94f1cffaec1fb5e$export$68c286be0e7e55b7(customStore = $e94f1cffaec1fb5e$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAll) return $e94f1cffaec1fb5e$export$b327150396135fe7(store.getAll());
        const items = [];
        return $e94f1cffaec1fb5e$var$eachCursor(store, (cursor)=>items.push(cursor.value)).then(()=>items);
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e94f1cffaec1fb5e$export$3e9f948b41964866(customStore = $e94f1cffaec1fb5e$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $e94f1cffaec1fb5e$export$b327150396135fe7(store.getAllKeys()),
            $e94f1cffaec1fb5e$export$b327150396135fe7(store.getAll())
        ]).then(([keys, values])=>keys.map((key, i)=>[
                    key,
                    values[i]
                ]));
        const items = [];
        return customStore('readonly', (store)=>$e94f1cffaec1fb5e$var$eachCursor(store, (cursor)=>items.push([
                    cursor.key,
                    cursor.value
                ])).then(()=>items));
    });
}

});



parcelRegister("1PHwb", function(module, exports) {

$parcel$export(module.exports, "isValid", () => $a8934b5895f99e04$export$1ea939691cdc45b8);
$parcel$export(module.exports, "getAccountId", () => $a8934b5895f99e04$export$c1e0336bde96e2dc);
$parcel$export(module.exports, "buildCachedEntryKey", () => $a8934b5895f99e04$export$59c82678f286b00f);

var $5iWql = parcelRequire("5iWql");

var $9ENT0 = parcelRequire("9ENT0");

var $1ybV0 = parcelRequire("1ybV0");
const $a8934b5895f99e04$var$EXPIRATION_TIME_OLD = 86400000; // 1 day
const $a8934b5895f99e04$var$EXPIRATION_TIME = 259200000; // 3 days
const $a8934b5895f99e04$var$extendExpirationTime = ()=>(0, $1ybV0.ff)('jsw.perf.local-device-cache-extend-expiery_seg8y');
function $a8934b5895f99e04$export$1ea939691cdc45b8(cachedDataEntry) {
    const timeDelta = Date.now() - cachedDataEntry.timestamp;
    const expirationTime = $a8934b5895f99e04$var$extendExpirationTime() ? $a8934b5895f99e04$var$EXPIRATION_TIME : $a8934b5895f99e04$var$EXPIRATION_TIME_OLD;
    return timeDelta < expirationTime;
}
const $a8934b5895f99e04$export$c1e0336bde96e2dc = (0, $5iWql.default)(()=>{
    const el = document.querySelector('meta[name="ajs-atlassian-account-id"]');
    return el?.getAttribute('content') ?? null;
});
function $a8934b5895f99e04$export$59c82678f286b00f(boardId) {
    const accountId = $a8934b5895f99e04$export$c1e0336bde96e2dc() ?? 'no-account-id';
    return `local-device-cache::${accountId}::${boardId}`;
}
const $a8934b5895f99e04$export$cc1314e9c2424f02 = (0, $9ENT0.createIndexedDBStorageProvider)('labs-preferences');

});


parcelRegister("7VFPc", function(module, exports) {

$parcel$export(module.exports, "convertQuickFiltersToString", () => $2850e334108a680b$export$4f216f9114f89403);
$parcel$export(module.exports, "getCachedQuickFilters", () => $2850e334108a680b$export$e59cda69449c77c2);
$parcel$export(module.exports, "parseBoardLocation", () => $2850e334108a680b$export$97471107364bd76c);
$parcel$export(module.exports, "parseBacklogLocation", () => $2850e334108a680b$export$be59cb299ab0331c);
$parcel$export(module.exports, "extractErrorMessage", () => $2850e334108a680b$export$8cc545829c7461b0);

var $53ciZ = parcelRequire("53ciZ");
const $2850e334108a680b$var$SOFTWARE_BOARD_REGEX = /\/jira\/software\/c\/?projects\/\w+\/boards\/(\d+)\/?(\?.*)?$/;
const $2850e334108a680b$var$USER_LOCATED_BOARD_REGEX = /\/jira\/people\/[^/]+\/boards\/(\d+)\/?(\?.*)?$/;
// people/project match needs to consider `...:...` ids
const $2850e334108a680b$var$SOFTWARE_BACKLOG_REGEX = /\/jira\/(?:software\/c\/)?(?:projects|people)\/[^/]+\/boards\/(\d+)\/backlog\/?(\?.*)?$/;
const $2850e334108a680b$var$parsePath = (pathname, pattern)=>{
    const match = pattern.exec(pathname);
    if (!match) return null;
    const boardId = match[1];
    return {
        boardId: Number(boardId)
    };
};
const $2850e334108a680b$export$4f216f9114f89403 = (queryParameters)=>{
    // Terminate early for the null/undefined cases
    if (!queryParameters?.quickFilter) return undefined; // This is safe to return as it means the query string will just be excluded
    if (!Array.isArray(queryParameters.quickFilter)) {
        // If for whatever reason an object gets in here
        if (typeof queryParameters.quickFilter === 'object') // Fail gracefully
        return undefined;
        // Ensure that the value is a number
        if (Number.isNaN(Number(queryParameters.quickFilter))) return undefined;
        // this isn't an array. It's probably a string or number which is fine to return as is.
        return `${queryParameters.quickFilter}`;
    }
    // Array passed in is the common case
    // If it is empty, don't include it at all.
    if (queryParameters.quickFilter.length === 0) return undefined;
    return queryParameters.quickFilter.filter((val)=>Number.isInteger(Number(val))).join(',');
};
const $2850e334108a680b$export$e59cda69449c77c2 = (feature, boardId)=>{
    const cachedFilters = localStorage.getItem(`__storejs_software_${feature}-filters.${boardId}`);
    if (!cachedFilters) return undefined;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { CUSTOM_FILTER: cachedQuickFilters } = JSON.parse(cachedFilters);
    return cachedQuickFilters && cachedQuickFilters.length > 0 ? cachedQuickFilters.join(',') : undefined;
};
const $2850e334108a680b$export$97471107364bd76c = ({ pathname: pathname, search: search })=>{
    const parsedPath = $2850e334108a680b$var$parsePath(pathname, $2850e334108a680b$var$SOFTWARE_BOARD_REGEX) ?? $2850e334108a680b$var$parsePath(pathname, $2850e334108a680b$var$USER_LOCATED_BOARD_REGEX);
    if (!parsedPath) return null;
    const queryStringParameters = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(search) ?? {};
    // Early termination if the quick filter isnt a part of the query string
    if (!queryStringParameters.quickFilter) return {
        ...parsedPath
    };
    // Guarantee that the quick filter will be returned as an array. This helps with typing further upstream
    const quickFilterArray = Array.isArray(queryStringParameters.quickFilter) ? queryStringParameters.quickFilter : [
        queryStringParameters.quickFilter
    ];
    return {
        ...parsedPath,
        queryParameters: {
            quickFilter: quickFilterArray
        }
    };
};
const $2850e334108a680b$export$be59cb299ab0331c = ({ pathname: pathname, search: search })=>{
    const parsedPath = $2850e334108a680b$var$parsePath(pathname, $2850e334108a680b$var$SOFTWARE_BACKLOG_REGEX);
    if (!parsedPath) return null;
    return {
        ...parsedPath,
        queryParameters: (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(search) ?? {}
    };
};
const $2850e334108a680b$var$isErrorMessagesResponse = (json)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    json?.errorMessages instanceof Array;
const $2850e334108a680b$export$8cc545829c7461b0 = (json)=>{
    if ($2850e334108a680b$var$isErrorMessagesResponse(json)) {
        const { errorMessages: errorMessages } = json;
        return errorMessages.length ? errorMessages.join(', ') : undefined;
    }
    return undefined;
};

});

parcelRegister("1gfCa", function(module, exports) {

$parcel$export(module.exports, "buildPlanDataFetchOptions", () => $80a458390d49b784$export$dab2d96649ebf00a);

var $7VFPc = parcelRequire("7VFPc");
const $80a458390d49b784$export$68c4c1e22c91f23f = 'fetchBacklogData';
const $80a458390d49b784$var$parseActiveQuickFilters = (queryParameters, boardId)=>{
    if (queryParameters?.customFilter && typeof queryParameters?.customFilter === 'string') return queryParameters.customFilter.split(',');
    return (0, $7VFPc.getCachedQuickFilters)('backlog', boardId)?.split(',');
};
const $80a458390d49b784$export$dab2d96649ebf00a = (boardId, queryParameters)=>({
        rapidViewId: boardId,
        forceConsistency: queryParameters?.forceConsistency ? /true/i.test(String(queryParameters.forceConsistency)) : true,
        activeQuickFilters: $80a458390d49b784$var$parseActiveQuickFilters(queryParameters, boardId),
        operation: $80a458390d49b784$export$68c4c1e22c91f23f
    });

});


parcelRegister("flfbz", function(module, exports) {

$parcel$export(module.exports, "setBoardCachedEntry", () => $1ccdea9e13916bdb$export$ce85349d82f1217c);
$parcel$export(module.exports, "getBoardCachedEntry", () => $1ccdea9e13916bdb$export$992aa38aa2da87a4);

var $9ENT0 = parcelRequire("9ENT0");

var $6iz4v = parcelRequire("6iz4v");

var $1PHwb = parcelRequire("1PHwb");
const $1ccdea9e13916bdb$export$13bc140835202cda = (0, $9ENT0.createIndexedDBStorageProvider)('cmp-board');
function $1ccdea9e13916bdb$export$4c715dd110bf64d2({ boardId: boardId, accountId: accountId, queryParameters: queryParameters }) {
    const params = [
        accountId,
        boardId
    ];
    if (queryParameters) params.push(JSON.stringify(queryParameters));
    const paramString = params.join('::');
    return `local-device-cache::${paramString}`;
}
async function $1ccdea9e13916bdb$export$ce85349d82f1217c({ boardId: boardId, queryParameters: queryParameters }, entry) {
    if (!entry.data.localDeviceCacheEnabled) {
        $1ccdea9e13916bdb$export$13bc140835202cda.clearAll();
        return Promise.resolve();
    }
    const accountId = (0, $1PHwb.getAccountId)() ?? 'no-account-id';
    const key = $1ccdea9e13916bdb$export$4c715dd110bf64d2({
        boardId: boardId,
        accountId: accountId,
        queryParameters: queryParameters
    });
    return $1ccdea9e13916bdb$export$13bc140835202cda.set(key, entry);
}
async function $1ccdea9e13916bdb$export$992aa38aa2da87a4({ boardId: boardId, queryParameters: queryParameters }) {
    const accountId = (0, $1PHwb.getAccountId)() ?? 'no-account-id';
    const cacheKey = $1ccdea9e13916bdb$export$4c715dd110bf64d2({
        boardId: boardId,
        accountId: accountId,
        queryParameters: queryParameters
    });
    try {
        (0, $6iz4v.setMark)('uif-board-fetch-read-cache-start');
        const entry = await $1ccdea9e13916bdb$export$13bc140835202cda.get(cacheKey);
        if (entry) (0, $6iz4v.setMark)('uif-board-fetch-read-cache-end');
        else return null;
        if (!(0, $1PHwb.isValid)(entry)) {
            await $1ccdea9e13916bdb$export$13bc140835202cda.remove(cacheKey);
            return null;
        }
        return entry;
    } catch (err) {
        return null;
    }
}

});

parcelRegister("gzSgn", function(module, exports) {

$parcel$export(module.exports, "fetchUIFBoardDataStream", () => $76c16416df6b0339$export$92fdd848ddb362ed);

var $1ybV0 = parcelRequire("1ybV0");

var $fvaL4 = parcelRequire("fvaL4");

var $flfbz = parcelRequire("flfbz");
function $76c16416df6b0339$export$92fdd848ddb362ed({ boardId: boardId, queryParameters: queryParameters, fields: fields }) {
    const { cachedPromise: cachedBoardData, promise: promise } = (0, $fvaL4.fetchUIFBoardData)({
        boardId: boardId,
        queryParameters: queryParameters,
        fields: fields
    });
    const cachedPromise = cachedBoardData.then((cache)=>cache?.data ?? null);
    const refreshPromise = (async ()=>{
        const response = await promise;
        if ((0, $1ybV0.ff)('jsw.cmp.response-null-abort') && !response) {
            const error = new Error('CMP fetchUIFBoardData returned null');
            error.name = 'ResponseNullError';
            throw error;
        }
        (0, $flfbz.setBoardCachedEntry)({
            boardId: boardId
        }, {
            timestamp: Date.now(),
            etag: response.etag,
            data: response
        });
        return response;
    })();
    return {
        cachedPromise: cachedPromise,
        refreshPromise: refreshPromise
    };
}

});
parcelRegister("fvaL4", function(module, exports) {

$parcel$export(module.exports, "fetchUIFBoardData", () => $49741f5cb605175c$export$240c6c415d37cd75);
$parcel$export(module.exports, "runUIFBoardEarlyScript", () => $49741f5cb605175c$export$4c749dee5e4e8bc6);

var $53ciZ = parcelRequire("53ciZ");


var $6iz4v = parcelRequire("6iz4v");

var $iNkad = parcelRequire("iNkad");
var $lLasf = parcelRequire("lLasf");

var $1ybV0 = parcelRequire("1ybV0");

var $cNlZD = parcelRequire("cNlZD");

var $1qnta = parcelRequire("1qnta");

var $flfbz = parcelRequire("flfbz");

var $7VFPc = parcelRequire("7VFPc");
const $49741f5cb605175c$var$isAlternateTTIMeasurementEnabled = ()=>(0, $1ybV0.ff)('jsw-measure-tti-alternate');
const $49741f5cb605175c$export$5aec1fe89a336a5d = 'fetchBoardData';
let $49741f5cb605175c$var$combinedBoardPromises = null;
function $49741f5cb605175c$var$putBoardEarlyScriptResponse(promises) {
    $49741f5cb605175c$var$combinedBoardPromises = promises;
}
function $49741f5cb605175c$export$1601e80f8f15c5cd() {
    const promises = $49741f5cb605175c$var$combinedBoardPromises;
    $49741f5cb605175c$var$combinedBoardPromises = null;
    return promises;
}
function $49741f5cb605175c$export$240c6c415d37cd75({ boardId: boardId, queryParameters: queryParameters, fields: fields }) {
    // It is important that there is no async operation before this first
    // return block, otherwise we may create a cycle of this fetch with itself.
    const response = $49741f5cb605175c$export$1601e80f8f15c5cd();
    if (response) return response;
    (0, $6iz4v.setMark)('uif-board-fetch-start');
    const query = {
        moduleKey: 'agile-mobile-board-service',
        hideCardExtraFields: true,
        onlyUseEpicsFromIssues: true,
        skipEtag: true,
        skipExtraFields: true,
        includeHidden: true,
        activeQuickFilters: (0, $7VFPc.convertQuickFiltersToString)(queryParameters) ?? (0, $7VFPc.getCachedQuickFilters)('board', boardId),
        fields: fields,
        operation: $49741f5cb605175c$export$5aec1fe89a336a5d
    };
    const queryStr = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(query);
    (0, $6iz4v.setMark)('uif-board-fetch-start-request');
    const boardDataUrl = `/rest/boards/latest/board/${boardId}?${queryStr}`;
    const headers = {
        'X-Atlassian-Capability': (0, $d07297a4af13004b$export$664edf77d4c76110)
    };
    Object.assign(headers, (0, $1qnta.getActiveTraceHttpRequestHeaders)(boardDataUrl));
    const cachedPromise = (0, $flfbz.getBoardCachedEntry)({
        boardId: boardId
    });
    const promise = fetch(boardDataUrl, {
        headers: headers
    }).then(async (res)=>{
        const json = await res.json().catch(()=>null);
        (0, $6iz4v.setMark)('uif-board-fetch-end');
        (0, $6iz4v.setMeasure)('uif-board-fetch/request', 'uif-board-fetch-start-request', 'uif-board-fetch-end');
        (0, $6iz4v.setMeasure)('uif-board-fetch', 'uif-board-fetch-start', 'uif-board-fetch-end');
        if (!res.ok) {
            const traceId = (0, $lLasf.getTraceId)(res);
            const message = (0, $7VFPc.extractErrorMessage)(json);
            if (traceId) throw new (0, $iNkad.FetchError)(res.status, message, traceId);
            else throw new (0, $iNkad.FetchError)(res.status, message);
        }
        return json;
    });
    return {
        cachedPromise: cachedPromise,
        promise: promise
    };
}
function $49741f5cb605175c$export$4c749dee5e4e8bc6(location) {
    if ($49741f5cb605175c$var$isAlternateTTIMeasurementEnabled()) (0, $cNlZD.startTTIObserver)();
    const parsedResult = (0, $7VFPc.parseBoardLocation)(location);
    if (!parsedResult) return false;
    $49741f5cb605175c$var$putBoardEarlyScriptResponse($49741f5cb605175c$export$240c6c415d37cd75(parsedResult));
    return true;
}

});



parcelRegister("65m09", function(module, exports) {

$parcel$export(module.exports, "fetchPlanData", () => $5a730ad4f558cf9d$export$be4775dacb1fbad6);

var $53ciZ = parcelRequire("53ciZ");

var $aiRd8 = parcelRequire("aiRd8");
function $5a730ad4f558cf9d$export$be4775dacb1fbad6(fetchPlanOptions) {
    return (0, $aiRd8.default)(`/rest/greenhopper/1.0/xboard/plan/v2/backlog/data?${(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(fetchPlanOptions)}`);
}

});

parcelRegister("a5ySG", function(module, exports) {

$parcel$export(module.exports, "transformPlanData", () => $0adb2f09c4b7cc56$export$5c1a457e91f81261);

var $6HC1D = parcelRequire("6HC1D");

var $9OdO2 = parcelRequire("9OdO2");

var $6ZDS2 = parcelRequire("6ZDS2");

var $3aUuh = parcelRequire("3aUuh");

var $27QuD = parcelRequire("27QuD");

var $1ybV0 = parcelRequire("1ybV0");

var $3l6tm = parcelRequire("3l6tm");

var $7TyGu = parcelRequire("7TyGu");

var $huNLe = parcelRequire("huNLe");

var $dVCoo = parcelRequire("dVCoo");

var $gPQCf = parcelRequire("gPQCf");
const $0adb2f09c4b7cc56$var$NONE = 'None';
const $0adb2f09c4b7cc56$var$boardList = {
    id: (0, $7TyGu.BOARD),
    type: (0, $7TyGu.BOARD),
    name: 'Board',
    issueListKey: null
};
const $0adb2f09c4b7cc56$var$backlogList = (0, $6HC1D.freeze)({
    id: (0, $7TyGu.BACKLOG),
    type: (0, $7TyGu.BACKLOG),
    name: 'Backlog',
    issueListKey: null
});
const $0adb2f09c4b7cc56$var$transformCards = (issues)=>(0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(issues.map((0, $huNLe.transformCard)), 'id');
const $0adb2f09c4b7cc56$var$isInKanbanContainer = (issue, column)=>!!column && column.statusIds.includes(issue.statusId);
const $0adb2f09c4b7cc56$var$transformKanbanCardsOrder = ({ issues: issues, selectedForDevelopmentColumn: board, backlogColumn: backlog })=>{
    const cardIdByContainerType = {
        [(0, $7TyGu.BOARD)]: [],
        [(0, $7TyGu.BACKLOG)]: []
    };
    issues.forEach((issue)=>{
        if ($0adb2f09c4b7cc56$var$isInKanbanContainer(issue, board)) cardIdByContainerType[0, $7TyGu.BOARD].push(issue.id);
        else if ($0adb2f09c4b7cc56$var$isInKanbanContainer(issue, backlog)) cardIdByContainerType[0, $7TyGu.BACKLOG].push(issue.id);
    });
    return cardIdByContainerType;
};
const $0adb2f09c4b7cc56$var$transformConfig = (response)=>{
    const isKanban = (0, $dVCoo.isKanbanPlanDataResponse)(response);
    return {
        requestColumnMigration: false,
        rankCustomFieldId: response.rankCustomFieldId || -1,
        version: {
            // We want the versions feature to be always true for CMP
            isVersionsFeatureEnabled: true
        },
        allFeatures: [],
        backlogStrategy: isKanban ? (0, $7TyGu.KANBAN_BACKLOG_STRATEGY) : (0, $7TyGu.SPRINT_BACKLOG_STRATEGY),
        kanbanBoardColumnId: isKanban ? response?.selectedForDevelopmentColumn?.id : null,
        kanbanBacklogColumnId: isKanban ? response?.backlogColumn?.id : null,
        hierarchyNomenclature: response?.flexibleNomenclatureData?.levelOneName ? {
            firstLevelName: response?.flexibleNomenclatureData?.levelOneName
        } : null
    };
};
const $0adb2f09c4b7cc56$var$isValidDateSprint = (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($27QuD)))(value) !== $0adb2f09c4b7cc56$var$NONE;
const $0adb2f09c4b7cc56$var$getSprintDate = (value)=>$0adb2f09c4b7cc56$var$isValidDateSprint(value) ? value : '';
const $0adb2f09c4b7cc56$var$transformSprint = ({ id: id, name: name, goal: goal, isoStartDate: isoStartDate, isoEndDate: isoEndDate, daysRemaining: daysRemaining, state: state, canUpdateSprint: canUpdateSprint }, canManageSprints)=>({
        id: String(id),
        name: name,
        type: (0, $7TyGu.SPRINT),
        issueListKey: null,
        sprintData: {
            goal: goal || '',
            startDate: $0adb2f09c4b7cc56$var$getSprintDate(isoStartDate),
            endDate: $0adb2f09c4b7cc56$var$getSprintDate(isoEndDate),
            daysRemaining: daysRemaining,
            state: state,
            canUpdateSprint: (0, $1ybV0.ff)('jsw-uif-fix-backlog-sprint-permission_0t956') ? canUpdateSprint : canManageSprints && canUpdateSprint
        }
    });
const $0adb2f09c4b7cc56$var$transformVersions = (response)=>(0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))((0, (/*@__PURE__*/$parcel$interopDefault($9OdO2)))(response.versionData?.versionsPerProject, (versions, projectId)=>versions.map((version)=>({
                id: version.id,
                name: version.name,
                projectId: Number(projectId)
            }))), (version)=>String(version.id));
const $0adb2f09c4b7cc56$var$toVersionIds = (versions)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    versions ? versions.map((version)=>String(version.id)) : [];
const $0adb2f09c4b7cc56$var$transformVersionsOrder = (response)=>response?.versionData?.versionsPerProject ? (0, (/*@__PURE__*/$parcel$interopDefault($6ZDS2)))(Object.keys(response.versionData.versionsPerProject).map((projectId)=>$0adb2f09c4b7cc56$var$toVersionIds(response.versionData.versionsPerProject[projectId]))) : [];
const $0adb2f09c4b7cc56$var$transformFilteredCardIds = (issues, activeQuickFilters)=>{
    if (!activeQuickFilters.length) return null;
    return new Set(issues.map((issue)=>String(issue.id)));
};
const $0adb2f09c4b7cc56$var$transformIssueIdsBySprint = (issues, sprintId)=>issues.filter((issue)=>issue.sprintIds?.includes(sprintId) ?? false).map((issue)=>issue.id);
const $0adb2f09c4b7cc56$var$extractCardTypes = (issues)=>Array.from(issues.reduce((acc, val)=>{
        if (acc.has(val.typeId)) return acc;
        return acc.set(val.typeId, {
            id: Number(val.typeId),
            name: val.typeName,
            iconUrl: val.typeUrl,
            hasRequiredFields: null,
            typeHierarchyLevel: (0, $3l6tm.getHierarchyLevelType)(val.typeHierarchyLevel)
        });
    }, new Map()).values());
const $0adb2f09c4b7cc56$var$isSubtask = (issue)=>typeof issue.parentKey === 'string' && issue.parentKey.length > 0;
const $0adb2f09c4b7cc56$export$c53ff095db760b09 = (issues, issueIdInSprints)=>{
    if (issues.length === 0) return [];
    const backlogIssues = issues.filter((issue)=>!issueIdInSprints.includes(issue.id));
    const backlogIssueIds = new Set();
    if (backlogIssues.length > 0) {
        const subtasks = backlogIssues.filter($0adb2f09c4b7cc56$var$isSubtask);
        backlogIssues.forEach((issue)=>{
            // In case the issue has already been processed return to prevent the loop below which is expensive.
            if (backlogIssueIds.has(issue.id)) return;
            backlogIssueIds.add(issue.id);
            // subtasks can not have subtasks and thus the work below is unnecessary.
            if ($0adb2f09c4b7cc56$var$isSubtask(issue)) return;
            subtasks.forEach((subtask)=>{
                if (subtask.parentId !== issue.id) return;
                backlogIssueIds.add(subtask.id);
            });
        });
    }
    return Array.from(backlogIssueIds);
};
const $0adb2f09c4b7cc56$var$transformScrumBacklog = (response, activeQuickFilters)=>{
    const cardList = {
        [(0, $7TyGu.BACKLOG)]: $0adb2f09c4b7cc56$var$backlogList
    };
    const cardOrder = {};
    const cardListOrder = [];
    let issueIdInSprints = [];
    const visibleIssues = response.issues.filter((issue)=>!issue.hidden);
    response.sprints.forEach((sprint)=>{
        const sprintIssueIds = $0adb2f09c4b7cc56$var$transformIssueIdsBySprint(response.issues, sprint.id);
        cardList[sprint.id] = $0adb2f09c4b7cc56$var$transformSprint(sprint, response.canManageSprints);
        cardOrder[sprint.id] = sprintIssueIds;
        cardListOrder.push(String(sprint.id));
        issueIdInSprints = issueIdInSprints.concat(sprintIssueIds);
    });
    cardOrder[0, $7TyGu.BACKLOG] = $0adb2f09c4b7cc56$export$c53ff095db760b09(response.issues, issueIdInSprints);
    cardListOrder.push((0, $7TyGu.BACKLOG));
    return {
        entities: {
            card: $0adb2f09c4b7cc56$var$transformCards(response.issues),
            cardOrder: cardOrder,
            cardListOrder: cardListOrder,
            cardList: cardList,
            cardTypes: $0adb2f09c4b7cc56$var$extractCardTypes(response.issues),
            project: {
                projects: response.projects
            },
            versions: $0adb2f09c4b7cc56$var$transformVersions(response),
            version: {
                versions: $0adb2f09c4b7cc56$var$transformVersionsOrder(response)
            }
        },
        config: $0adb2f09c4b7cc56$var$transformConfig(response),
        ui: {
            cards: {
                filteredCards: {
                    isLoading: false,
                    filteredCardsIds: $0adb2f09c4b7cc56$var$transformFilteredCardIds(visibleIssues, activeQuickFilters)
                }
            }
        }
    };
};
const $0adb2f09c4b7cc56$var$transformBoardListWithLimits = (firstColumn)=>{
    if (firstColumn) return {
        ...$0adb2f09c4b7cc56$var$boardList,
        name: firstColumn.name,
        minColumnLimit: firstColumn.min,
        maxColumnLimit: firstColumn.max
    };
    return $0adb2f09c4b7cc56$var$boardList;
};
const $0adb2f09c4b7cc56$var$transformKanbanBacklog = (response, activeQuickFilters)=>{
    const visibleIssues = response.issues.filter((issue)=>!issue.hidden);
    return {
        entities: {
            card: $0adb2f09c4b7cc56$var$transformCards(response.issues),
            cardOrder: $0adb2f09c4b7cc56$var$transformKanbanCardsOrder(response),
            cardOrderGlobal: response.issues.map((issue)=>issue.id),
            cardListOrder: [
                (0, $7TyGu.BOARD),
                (0, $7TyGu.BACKLOG)
            ],
            cardList: {
                [(0, $7TyGu.BOARD)]: $0adb2f09c4b7cc56$var$transformBoardListWithLimits(response.selectedForDevelopmentColumn),
                [(0, $7TyGu.BACKLOG)]: $0adb2f09c4b7cc56$var$backlogList
            },
            project: {
                projects: response.projects
            },
            versions: $0adb2f09c4b7cc56$var$transformVersions(response),
            version: {
                versions: $0adb2f09c4b7cc56$var$transformVersionsOrder(response)
            }
        },
        config: $0adb2f09c4b7cc56$var$transformConfig(response),
        ui: {
            cards: {
                filteredCards: {
                    isLoading: false,
                    filteredCardsIds: $0adb2f09c4b7cc56$var$transformFilteredCardIds(visibleIssues, activeQuickFilters)
                }
            }
        }
    };
};
const $0adb2f09c4b7cc56$export$5c1a457e91f81261 = (response, isCompanyManaged, activeQuickFilters = [])=>{
    const metric = isCompanyManaged ? (0, $gPQCf.uifBacklogNewUiPageLoad) : (0, $gPQCf.nextGenBacklogPageLoad);
    metric.mark((0, $gPQCf.PAGE_LOAD_MARK_TRANSFORM_CRITICAL_REST_START));
    const result = (0, $dVCoo.isKanbanPlanDataResponse)(response) ? $0adb2f09c4b7cc56$var$transformKanbanBacklog(response, activeQuickFilters) : $0adb2f09c4b7cc56$var$transformScrumBacklog(response, activeQuickFilters);
    metric.mark((0, $gPQCf.PAGE_LOAD_MARK_TRANSFORM_CRITICAL_REST_END));
    return result;
};

});
parcelRegister("dVCoo", function(module, exports) {

$parcel$export(module.exports, "isKanbanPlanDataResponse", () => $32b5cc498a67ac34$export$489d7cf1df036453);
function $32b5cc498a67ac34$export$489d7cf1df036453(response) {
    if (response !== null && typeof response === 'object') return 'backlogColumn' in response && 'selectedForDevelopmentColumn' in response;
    return false;
}

});



parcelRegister("cmYrZ", function(module, exports) {

$parcel$export(module.exports, "getCustomFiltersDebounceTime", () => $94e60b4a5009eb74$export$2ecac126a7851701);
const $94e60b4a5009eb74$export$2ecac126a7851701 = ()=>500;

});


parcelRegister("7Q0mj", function(module, exports) {

$parcel$export(module.exports, "filteredCardsRequestEpic", () => $a8e1c974a9b1883f$export$ee8377ae46706014);

var $3JafE = parcelRequire("3JafE");

var $jAy5L = parcelRequire("jAy5L");
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("5dKXv");
parcelRequire("b48pz");
parcelRequire("3wBUP");
parcelRequire("flmol");
parcelRequire("1Lcr1");

var $gUUjF = parcelRequire("gUUjF");

var $6BHSE = parcelRequire("6BHSE");

var $lEnU0 = parcelRequire("lEnU0");

var $jiL2Q = parcelRequire("jiL2Q");

var $fB0vk = parcelRequire("fB0vk");

var $5awap = parcelRequire("5awap");

var $jAbil = parcelRequire("jAbil");

var $hkGxG = parcelRequire("hkGxG");

var $cmYrZ = parcelRequire("cmYrZ");
const $a8e1c974a9b1883f$var$filterCards = (action, store, dependencies)=>{
    const state = store.getState();
    const { issueIds: issueIds, customFilterIds: customFilterIds } = action.payload;
    const { analyticsEvent: analyticsEvent } = action.meta;
    const ctx = (0, $lEnU0.makeServiceContext)(state);
    if (!customFilterIds || !customFilterIds.length) return (0, $3JafE.Observable).from([
        ctx.isCompanyManaged ? (0, $5awap.clearFilteredCardsRequest)(analyticsEvent) : (0, $5awap.clearFilteredCards)(),
        (0, $fB0vk.cardAutoScrollRequestOnFilter)()
    ]);
    return (0, $6BHSE.fetchFilteredCardsService)(ctx, {
        issueIds: issueIds,
        customFilterIds: customFilterIds,
        epicIssueType: (0, $hkGxG.getEpicIssueType)(state),
        storeFieldsActions: dependencies?.storeFieldsActions
    }).flatMap(({ filteredCardIds: filteredCardIds, data: data })=>[
            (0, $5awap.filteredCardsSuccess)(filteredCardIds, customFilterIds.length, issueIds.length, analyticsEvent),
            ...data ? [
                (0, $jiL2Q.setAppData)(data)
            ] : [],
            (0, $fB0vk.cardAutoScrollRequestOnFilter)()
        ]).catch((error)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('backlog.filtered-cards.failure', 'Fail to filter cards with custom filters', error);
        return (0, $3JafE.Observable).of((0, $5awap.filteredCardsFailed)(error, analyticsEvent), (0, $jAbil.setAllFilters)({}));
    });
};
const $a8e1c974a9b1883f$export$ee8377ae46706014 = (action$, store, dependencies)=>action$.ofType((0, $5awap.FILTERED_CARD_REQUEST)).throttleTime((0, $cmYrZ.getCustomFiltersDebounceTime)(), (0, $jAy5L.async), {
        leading: true,
        trailing: true
    }).switchMap((action)=>$a8e1c974a9b1883f$var$filterCards(action, store, dependencies));

});
parcelRegister("6BHSE", function(module, exports) {

$parcel$export(module.exports, "fetchFilteredCardsService", () => $7b4072c09b2cc3e0$export$6aa3118e5c68853c);
parcelRequire("flmol");

var $a5W0H = parcelRequire("a5W0H");

var $lkfU5 = parcelRequire("lkfU5");
function $7b4072c09b2cc3e0$export$6aa3118e5c68853c(ctx, { issueIds: issueIds, customFilterIds: customFilterIds, epicIssueType: epicIssueType, storeFieldsActions: storeFieldsActions }) {
    if (ctx.isCompanyManaged) return (0, $lkfU5.loadPlanDataService)({
        boardId: ctx.boardId,
        isCompanyManaged: ctx.isCompanyManaged,
        activeQuickFilters: customFilterIds,
        epicIssueType: epicIssueType,
        storeFieldsActions: storeFieldsActions
    }).map((data)=>({
            data: data,
            filteredCardIds: Object.values(data.entities.card).filter((card)=>!card.hidden).map((card)=>String(card.id))
        }));
    return (0, $a5W0H.default)('', ctx.boardId, issueIds, customFilterIds).map((filteredCardIds)=>({
            filteredCardIds: filteredCardIds
        }));
}

});
parcelRegister("a5W0H", function(module, exports) {

$parcel$export(module.exports, "default", () => $db42a5ccb299bbba$export$2e2bcd8739ae039);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("iects");

var $jy01K = parcelRequire("jy01K");
const $db42a5ccb299bbba$var$filteredCardsQuery = 'FilteredCardIds';
const $db42a5ccb299bbba$export$71eec30d9db46a56 = ()=>`
    query ${$db42a5ccb299bbba$var$filteredCardsQuery} ($boardId: ID!, $issueIds: [ID]!, $customFilterIds: [ID]!) {
        boardScope(boardId: $boardId) {
            filteredCardIds(
                issueIds: $issueIds,
                customFilterIds: $customFilterIds
            )
        }
    }
`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$db42a5ccb299bbba$export$2e2bcd8739ae039 = (baseUrl, boardId, issueIds, customFilterIds)=>(0, $jy01K.query$)(baseUrl, $db42a5ccb299bbba$var$filteredCardsQuery, $db42a5ccb299bbba$export$71eec30d9db46a56(), {
        boardId: boardId,
        issueIds: issueIds,
        customFilterIds: customFilterIds
    }).flatMap(({ boardScope: boardScope })=>(0, $3JafE.Observable).of(boardScope.filteredCardIds));

});



parcelRegister("4oqbp", function(module, exports) {

$parcel$export(module.exports, "refilterRequestEpic", () => $28a60dc4cad92c82$export$12fb76cfeb5c0ed2);
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("iects");
parcelRequire("1Lcr1");
parcelRequire("3wBUP");
parcelRequire("8OtG5");

var $iVIEg = parcelRequire("iVIEg");

var $7kP6w = parcelRequire("7kP6w");

var $3JafE = parcelRequire("3JafE");

var $i9UF9 = parcelRequire("i9UF9");

var $lzvfM = parcelRequire("lzvfM");

var $gUUjF = parcelRequire("gUUjF");


var $6BHSE = parcelRequire("6BHSE");

var $lEnU0 = parcelRequire("lEnU0");

var $jiL2Q = parcelRequire("jiL2Q");

var $lsENz = parcelRequire("lsENz");

var $5awap = parcelRequire("5awap");

var $bCL12 = parcelRequire("bCL12");

var $hkGxG = parcelRequire("hkGxG");

var $cmYrZ = parcelRequire("cmYrZ");
const $28a60dc4cad92c82$var$isActiveTab = ()=>!document.hidden;
const $28a60dc4cad92c82$var$isCurrentUser = (state, action)=>(0, $hkGxG.getAtlassianAccountId)(state) === action.payload.event.payload.atlassianId;
const $28a60dc4cad92c82$var$isIssueEvent = (action)=>action.payload.event.type === (0, $1d129cd1c8b202ad$export$b22a14d5dac59664) || action.payload.event.type === (0, $1d129cd1c8b202ad$export$b22142e61b3fdbee);
const $28a60dc4cad92c82$var$getActiveCustomFilterIds = (state)=>state.ui.filters.CUSTOM_FILTER || [];
const $28a60dc4cad92c82$var$isCustomFiltersActive = (state)=>$28a60dc4cad92c82$var$getActiveCustomFilterIds(state).length > 0;
const $28a60dc4cad92c82$var$debounce = (0, $lzvfM.debounceTime)((0, $cmYrZ.getCustomFiltersDebounceTime)());
const $28a60dc4cad92c82$export$12fb76cfeb5c0ed2 = (action$, store, dependencies)=>{
    const refilterAction$ = action$.ofType((0, $bCL12.REALTIME_DISPATCH_EVENT)).filter($28a60dc4cad92c82$var$isActiveTab).filter($28a60dc4cad92c82$var$isIssueEvent).filter(()=>$28a60dc4cad92c82$var$isCustomFiltersActive(store.getState())).filter((action)=>$28a60dc4cad92c82$var$isCurrentUser(store.getState(), action));
    return refilterAction$.pipe(// buffer actions happening within a short duration
    // so we can combine them into a single refilter network request
    (0, $i9UF9.buffer)(refilterAction$.pipe($28a60dc4cad92c82$var$debounce))).switchMap((actions)=>{
        const state = store.getState();
        const customFilterIds = $28a60dc4cad92c82$var$getActiveCustomFilterIds(state);
        const issueIds = actions.map(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (action)=>action.payload.event.payload.issueId);
        return (0, $6BHSE.fetchFilteredCardsService)((0, $lEnU0.makeServiceContext)(state), {
            customFilterIds: customFilterIds,
            issueIds: issueIds,
            epicIssueType: (0, $hkGxG.getEpicIssueType)(state),
            storeFieldsActions: dependencies?.storeFieldsActions
        }).mergeMap(({ filteredCardIds: filteredCardIds, data: data })=>{
            const excludedCardIds = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(issueIds.map((issueId)=>String(issueId)), filteredCardIds);
            if (excludedCardIds.length) {
                // we only want to show the flag for created issues
                const excludedCreatedCardIds = excludedCardIds.map((cardId)=>(0, (/*@__PURE__*/$parcel$interopDefault($7kP6w)))(cardId)).filter((cardId)=>actions.some((action)=>// @ts-expect-error - TS2339 - Property 'issueId' does not exist on type 'EventPayload'.
                        action.payload.event.payload.issueId === cardId && action.payload.event.type === (0, $1d129cd1c8b202ad$export$b22a14d5dac59664)));
                if (excludedCreatedCardIds.length) return [
                    ...data ? [
                        (0, $jiL2Q.setAppData)(data)
                    ] : [],
                    (0, $lsENz.cardCreateFilteredV2)(excludedCreatedCardIds),
                    (0, $5awap.refilterSuccess)(excludedCardIds, filteredCardIds)
                ];
            }
            return [
                ...data ? [
                    (0, $jiL2Q.setAppData)(data)
                ] : [],
                (0, $5awap.refilterSuccess)(excludedCardIds, filteredCardIds)
            ];
        }).catch((error)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData('backlog.filtered-cards.refilter.failure', 'Fail to re-filter cards with custom filters', error);
            return (0, $3JafE.Observable).of((0, $5awap.refilterFailure)(error));
        });
    });
};

});
const $1d129cd1c8b202ad$export$86d416e8d15777d = 'avi:jira:assigned:issue';
const $1d129cd1c8b202ad$export$b22a14d5dac59664 = 'avi:jira:created:issue';
const $1d129cd1c8b202ad$export$25fa37e5059c5a99 = 'avi:jira:deleted:issue';
const $1d129cd1c8b202ad$export$d9bc8850eeef9f60 = 'avi:jira:transitioned:issue';
const $1d129cd1c8b202ad$export$b22142e61b3fdbee = 'avi:jira:updated:issue';
const $1d129cd1c8b202ad$export$773466d9acc404c0 = 'avi:jira:commented:issue';
const $1d129cd1c8b202ad$export$6b7e46ea0442b66c = 'avi:jira:updated:issue_parent_association';
const $1d129cd1c8b202ad$export$6024bd0c20931af3 = 'avi:jira-software:update:board-scope-issues';

parcelRegister("bCL12", function(module, exports) {

$parcel$export(module.exports, "REALTIME_DISPATCH_EVENT", () => $30bd7e5d3792b4d4$export$b5816ca887d8baac);
$parcel$export(module.exports, "REALTIME_DISPATCH_EVENT_BATCH", () => $30bd7e5d3792b4d4$export$146c7f09e2af258);
$parcel$export(module.exports, "dispatchRealtimeEvent", () => $30bd7e5d3792b4d4$export$e0f58b7bfd5c1657);
$parcel$export(module.exports, "dispatchRealtimeEventBatch", () => $30bd7e5d3792b4d4$export$884fd41fa17b25da);
const $30bd7e5d3792b4d4$export$b5816ca887d8baac = 'state.actions.realtime.dispatch.REALTIME_DISPATCH_EVENT';
const $30bd7e5d3792b4d4$export$146c7f09e2af258 = 'state.actions.realtime.dispatch.REALTIME_DISPATCH_EVENT_BATCH';
const $30bd7e5d3792b4d4$export$e0f58b7bfd5c1657 = (event)=>({
        type: $30bd7e5d3792b4d4$export$b5816ca887d8baac,
        payload: {
            event: event
        }
    });
const $30bd7e5d3792b4d4$export$884fd41fa17b25da = (event)=>({
        type: $30bd7e5d3792b4d4$export$146c7f09e2af258,
        payload: {
            events: event
        }
    });

});


parcelRegister("4vLC2", function(module, exports) {

$parcel$export(module.exports, "refilterRequestEpicNew", () => $888326314e9d5d3a$export$667b0a1b25ded760);
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("iects");
parcelRequire("1Lcr1");
parcelRequire("3wBUP");
parcelRequire("8OtG5");

var $iVIEg = parcelRequire("iVIEg");

var $7kP6w = parcelRequire("7kP6w");

var $3JafE = parcelRequire("3JafE");

var $gUUjF = parcelRequire("gUUjF");


var $6BHSE = parcelRequire("6BHSE");

var $lEnU0 = parcelRequire("lEnU0");

var $jiL2Q = parcelRequire("jiL2Q");

var $lsENz = parcelRequire("lsENz");

var $5awap = parcelRequire("5awap");

var $bCL12 = parcelRequire("bCL12");

var $hkGxG = parcelRequire("hkGxG");
const $888326314e9d5d3a$var$isActiveTab = ()=>!document.hidden;
const $888326314e9d5d3a$var$getActiveCustomFilterIds = (state)=>state.ui.filters.CUSTOM_FILTER || [];
const $888326314e9d5d3a$var$isCustomFiltersActive = (state)=>$888326314e9d5d3a$var$getActiveCustomFilterIds(state).length > 0;
const $888326314e9d5d3a$export$667b0a1b25ded760 = (action$, store, dependencies)=>action$.ofType((0, $bCL12.REALTIME_DISPATCH_EVENT_BATCH)).filter($888326314e9d5d3a$var$isActiveTab).filter(()=>$888326314e9d5d3a$var$isCustomFiltersActive(store.getState())).switchMap((action)=>{
        const state = store.getState();
        const currentUser = (0, $hkGxG.getAtlassianAccountId)(state);
        const triggerEvents = action.payload.events.filter((event)=>event.payload.atlassianId === currentUser && (event.type === (0, $1d129cd1c8b202ad$export$b22a14d5dac59664) || event.type === (0, $1d129cd1c8b202ad$export$b22142e61b3fdbee)));
        if (triggerEvents.length > 0) {
            const customFilterIds = $888326314e9d5d3a$var$getActiveCustomFilterIds(state);
            const issueIds = triggerEvents.map(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (event)=>event.payload.issueId);
            return (0, $6BHSE.fetchFilteredCardsService)((0, $lEnU0.makeServiceContext)(state), {
                customFilterIds: customFilterIds,
                issueIds: issueIds,
                epicIssueType: (0, $hkGxG.getEpicIssueType)(state),
                storeFieldsActions: dependencies?.storeFieldsActions
            }).mergeMap(({ filteredCardIds: filteredCardIds, data: data })=>{
                const excludedCardIds = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(issueIds.map((issueId)=>String(issueId)), filteredCardIds);
                if (excludedCardIds.length) {
                    // we only want to show the flag for created issues
                    const excludedCreatedCardIds = excludedCardIds.map((cardId)=>(0, (/*@__PURE__*/$parcel$interopDefault($7kP6w)))(cardId)).filter((cardId)=>triggerEvents.some((event)=>// @ts-expect-error - TS2339 - Property 'issueId' does not exist on type 'EventPayload'.
                            event.payload.issueId === cardId && event.type === (0, $1d129cd1c8b202ad$export$b22a14d5dac59664)));
                    if (excludedCreatedCardIds.length) return [
                        ...data ? [
                            (0, $jiL2Q.setAppData)(data)
                        ] : [],
                        (0, $lsENz.cardCreateFilteredV2)(excludedCreatedCardIds),
                        (0, $5awap.refilterSuccess)(excludedCardIds, filteredCardIds)
                    ];
                }
                return [
                    ...data ? [
                        (0, $jiL2Q.setAppData)(data)
                    ] : [],
                    (0, $5awap.refilterSuccess)(excludedCardIds, filteredCardIds)
                ];
            }).catch((error)=>{
                (0, $gUUjF.default).safeErrorWithoutCustomerData('backlog.filtered-cards.refilter.batch.failure', 'Fail to batch re-filter cards with custom filters', error);
                return (0, $3JafE.Observable).of((0, $5awap.refilterFailure)(error));
            });
        }
        return (0, $3JafE.Observable).empty();
    });

});


parcelRegister("ixnoC", function(module, exports) {

$parcel$export(module.exports, "issueViewUpdateEpic", () => $8c24c058a78d2df4$export$f43e66f9c7ce58d1);

var $3JafE = parcelRequire("3JafE");
parcelRequire("8jBvP");
parcelRequire("9u6v2");
parcelRequire("iects");

var $hc9p2 = parcelRequire("hc9p2");

var $lqxNq = parcelRequire("lqxNq");

var $8R4bf = parcelRequire("8R4bf");

var $bP7Jx = parcelRequire("bP7Jx");

var $k734R = parcelRequire("k734R");
const $8c24c058a78d2df4$export$f43e66f9c7ce58d1 = (action$, store)=>action$.ofType((0, $8R4bf.ISSUE_VIEW_UPDATE)).mergeMap((action)=>{
        const state = store.getState();
        const { payload: payload } = action;
        const targetIssueParent = (0, $k734R.getIssueParents)(state)[payload.issueId];
        if (targetIssueParent) {
            const actionsFromMappedResponse = (0, $lqxNq.mapResponseToIssueParent)(targetIssueParent, state, payload);
            return actionsFromMappedResponse ? (0, $3JafE.Observable).from([
                actionsFromMappedResponse
            ]) : (0, $3JafE.Observable).empty();
        }
        // TODO: Add getIssueChildren(state)[payload.issueId] when issue children is supported in Backlog (CATBUS-2200)
        const targetIssue = (0, $bP7Jx.getCards)(state)[payload.issueId];
        const actionsFromMappedResponse = (0, $hc9p2.mapResponseToIssue)(targetIssue, state, payload);
        return actionsFromMappedResponse ? (0, $3JafE.Observable).from([
            actionsFromMappedResponse
        ]) : (0, $3JafE.Observable).empty();
    });

});
parcelRegister("hc9p2", function(module, exports) {

$parcel$export(module.exports, "mapResponseToIssue", () => $c602a2ae3fc9f80f$export$270311cab2abcd0d);

var $fE3Ua = parcelRequire("fE3Ua");

var $jiL2Q = parcelRequire("jiL2Q");

var $hkGxG = parcelRequire("hkGxG");

var $eI3Q1 = parcelRequire("eI3Q1");
const $c602a2ae3fc9f80f$export$270311cab2abcd0d = (issue, state, payload)=>{
    if (!payload.type || !issue) return null;
    // TODO: To be added when Backlog supports issue children (CATBUS-2200)
    // if (payload.type === ChangeEventTypes.ISSUE_CHILDREN_ORDER_CHANGED) {
    //     return setIssueChildrenRank(payload.meta);
    // }
    if (payload.type === (0, $fE3Ua.ChangeEventTypes).FIELD_CHANGED) {
        const isCMPScrum = (0, $hkGxG.isCMPScrumBacklog)(state);
        const sprintFieldId = (0, $hkGxG.getSprintFieldId)(state);
        if (isCMPScrum && payload.meta.fieldId === sprintFieldId) return (0, $jiL2Q.loadAppData)();
    }
    if (payload.type === (0, $fE3Ua.ChangeEventTypes).SUBTASK_ADDED || payload.type === (0, $fE3Ua.ChangeEventTypes).CHILD_ISSUE_ADDED) return (0, $jiL2Q.loadAppData)();
    if (payload.type === (0, $fE3Ua.ChangeEventTypes).ISSUE_CHILDREN_ORDER_CHANGED) return (0, $eI3Q1.updateRankOnChildrenOrderChange)(state, payload.meta);
    return null;
};

});
parcelRegister("fE3Ua", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $407ab16d43881e85$export$8db21fc94823e1cc);
const $407ab16d43881e85$var$FIELD_CHANGE_REQUESTED = 'FIELD_CHANGE_REQUESTED';
const $407ab16d43881e85$var$FIELD_CHANGED = 'FIELD_CHANGED';
const $407ab16d43881e85$var$FIELD_CHANGE_FAILED = 'FIELD_CHANGE_FAILED';
const $407ab16d43881e85$var$ISSUE_TYPE_CHANGED = 'ISSUE_TYPE_CHANGED';
const $407ab16d43881e85$var$ISSUE_RELATIONSHIP_UPDATED = 'ISSUE_RELATIONSHIP_UPDATED';
const $407ab16d43881e85$var$ISSUE_LINKS_CREATED = 'ISSUE_LINKS_CREATED';
const $407ab16d43881e85$var$ISSUE_LINK_DELETED = 'ISSUE_LINK_DELETED';
const $407ab16d43881e85$var$CHILD_ISSUE_ADDED = 'CHILD_ISSUE_ADDED';
const $407ab16d43881e85$var$SUBTASK_ADDED = 'SUBTASK_ADDED';
const $407ab16d43881e85$var$ISSUE_CHILDREN_ORDER_CHANGED = 'ISSUE_CHILDREN_ORDER_CHANGED';
const $407ab16d43881e85$var$CHILD_ISSUE_FIELD_UPDATED = 'CHILD_ISSUE_FIELD_UPDATED';
const $407ab16d43881e85$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS = 'CREATE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $407ab16d43881e85$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS = 'DELETE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $407ab16d43881e85$export$8db21fc94823e1cc = {
    [$407ab16d43881e85$var$FIELD_CHANGE_REQUESTED]: $407ab16d43881e85$var$FIELD_CHANGE_REQUESTED,
    [$407ab16d43881e85$var$FIELD_CHANGE_FAILED]: $407ab16d43881e85$var$FIELD_CHANGE_FAILED,
    [$407ab16d43881e85$var$FIELD_CHANGED]: $407ab16d43881e85$var$FIELD_CHANGED,
    [$407ab16d43881e85$var$ISSUE_TYPE_CHANGED]: $407ab16d43881e85$var$ISSUE_TYPE_CHANGED,
    [$407ab16d43881e85$var$ISSUE_RELATIONSHIP_UPDATED]: $407ab16d43881e85$var$ISSUE_RELATIONSHIP_UPDATED,
    [$407ab16d43881e85$var$ISSUE_LINKS_CREATED]: $407ab16d43881e85$var$ISSUE_LINKS_CREATED,
    [$407ab16d43881e85$var$ISSUE_LINK_DELETED]: $407ab16d43881e85$var$ISSUE_LINK_DELETED,
    [$407ab16d43881e85$var$CHILD_ISSUE_ADDED]: $407ab16d43881e85$var$CHILD_ISSUE_ADDED,
    [$407ab16d43881e85$var$SUBTASK_ADDED]: $407ab16d43881e85$var$SUBTASK_ADDED,
    [$407ab16d43881e85$var$ISSUE_CHILDREN_ORDER_CHANGED]: $407ab16d43881e85$var$ISSUE_CHILDREN_ORDER_CHANGED,
    [$407ab16d43881e85$var$CHILD_ISSUE_FIELD_UPDATED]: $407ab16d43881e85$var$CHILD_ISSUE_FIELD_UPDATED,
    [$407ab16d43881e85$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS]: $407ab16d43881e85$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS,
    [$407ab16d43881e85$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS]: $407ab16d43881e85$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS
};

});

parcelRegister("eI3Q1", function(module, exports) {

$parcel$export(module.exports, "updateRankOnChildrenOrderChange", () => $60254a791644912a$export$d180b3cae3a333fb);

var $7Egcu = parcelRequire("7Egcu");

var $bP7Jx = parcelRequire("bP7Jx");
const $60254a791644912a$export$d180b3cae3a333fb = (state, { issueIds: issueIds, rankId: rankId, isRankAfter: isRankAfter })=>{
    const cardOrder = (0, $bP7Jx.getOrderedCardIdsByCardListId)(state);
    const cardListId = (0, $bP7Jx.makeGetCardListIdByCardId)(state)(rankId);
    if (cardListId == null) return null;
    const cardIds = issueIds.map((id)=>Number(id)).filter((id)=>(cardOrder[cardListId] || []).includes(id));
    const cardsMoveSetPayload = {
        cardIds: cardIds,
        cardListId: cardListId,
        isBetweenLists: false,
        beforeCardId: !isRankAfter ? rankId : null,
        afterCardId: isRankAfter ? rankId : null
    };
    /** cardIds can be an empty list here depending on cardListId.
	 * This check ensures no optimistic ranking updates is triggered in Backlog when the issue ranked (and surrounding issues) in BENTO children panel are from different sections
	 * e.g. one from backlog and another from a sprint etc.
	 */ return cardIds.length ? (0, $7Egcu.cardsMoveSet)(cardsMoveSetPayload) : null;
};

});


parcelRegister("lqxNq", function(module, exports) {

$parcel$export(module.exports, "mapResponseToIssueParent", () => $1a0a21fd0ad753e9$export$b4cee4073a723eae);

var $lPQPn = parcelRequire("lPQPn");

var $fE3Ua = parcelRequire("fE3Ua");

var $lsENz = parcelRequire("lsENz");

var $k9DSA = parcelRequire("k9DSA");

var $8ZI73 = parcelRequire("8ZI73");

var $eI3Q1 = parcelRequire("eI3Q1");
const $1a0a21fd0ad753e9$export$b4cee4073a723eae = (issueParent, state, payload)=>{
    const epicColorFieldId = (0, $8ZI73.getEpicColorFieldId)(state);
    if (!payload.type || !issueParent) return null;
    if (payload.type === (0, $fE3Ua.ChangeEventTypes).FIELD_CHANGED) {
        if (payload.meta.fieldId !== 'summary' && payload.meta.fieldId !== epicColorFieldId) return null;
        const issueParentContent = payload.meta.fieldId === epicColorFieldId ? {
            color: (0, $lPQPn.asColor)(payload.meta.fieldValue)
        } : {
            [payload.meta.fieldId]: payload.meta.fieldValue
        };
        return (0, $k9DSA.issueParentPatch)({
            id: issueParent.id,
            issueParent: issueParentContent
        });
    }
    if (payload.type === (0, $fE3Ua.ChangeEventTypes).ISSUE_CHILDREN_ORDER_CHANGED) return (0, $eI3Q1.updateRankOnChildrenOrderChange)(state, payload.meta);
    if (payload.type === (0, $fE3Ua.ChangeEventTypes).CHILD_ISSUE_ADDED) return (0, $lsENz.cardCreateEndOfBacklogOptimistic)(payload);
    return null;
};

});
parcelRegister("k9DSA", function(module, exports) {

$parcel$export(module.exports, "ISSUE_PARENT_PATCH", () => $b9523dd57d09a151$export$e9af2723cb3ed91e);
$parcel$export(module.exports, "issueParentPatch", () => $b9523dd57d09a151$export$72e99a23ae3ed0b0);
const $b9523dd57d09a151$export$e9af2723cb3ed91e = 'state.actions.issue-parents.patch.ISSUE_PARENT_PATCH';
const $b9523dd57d09a151$export$72e99a23ae3ed0b0 = (payload)=>({
        type: $b9523dd57d09a151$export$e9af2723cb3ed91e,
        payload: payload
    });

});


parcelRegister("8R4bf", function(module, exports) {

$parcel$export(module.exports, "ISSUE_VIEW_UPDATE", () => $aa00501cc3d2fec2$export$be7899fc700a03e7);
$parcel$export(module.exports, "issueViewUpdate", () => $aa00501cc3d2fec2$export$758415d5f0ecccd0);
const $aa00501cc3d2fec2$export$be7899fc700a03e7 = 'state.actions.issue-view-update.ISSUE_VIEW_UPDATE';
const $aa00501cc3d2fec2$export$758415d5f0ecccd0 = (payload)=>({
        type: $aa00501cc3d2fec2$export$be7899fc700a03e7,
        payload: payload
    });

});


parcelRegister("7lCIO", function(module, exports) {

$parcel$export(module.exports, "fetchData", () => $f27f37ff6683fd30$export$8134c072fddab6a5);
$parcel$export(module.exports, "loadAgilityGraphqlDataEpic", () => $f27f37ff6683fd30$export$8976970ef97c8467);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("iects");
parcelRequire("flmol");
parcelRequire("1Lcr1");

var $gUUjF = parcelRequire("gUUjF");

var $8wXFi = parcelRequire("8wXFi");

var $5muvm = parcelRequire("5muvm");

var $jiL2Q = parcelRequire("jiL2Q");

var $hkGxG = parcelRequire("hkGxG");
const $f27f37ff6683fd30$export$8134c072fddab6a5 = (params)=>{
    const { store: store, prefetchedData: prefetchedData = null, prefetchedAggData: prefetchedAggData, fetchDataFromAGG: fetchDataFromAGG, storeFieldsActions: storeFieldsActions } = params;
    const state = store.getState();
    const baseUrl = (0, $hkGxG.getBaseUrl)(state);
    const boardId = (0, $hkGxG.getRapidViewId)(state);
    const isCompanyManaged = (0, $hkGxG.getIsCompanyManaged)(state);
    const storyPointFieldId = (0, $hkGxG.getStoryPointFieldId)(state);
    const fieldConfigs = {
        storyPointFieldId: storyPointFieldId
    };
    return (0, $5muvm.default)({
        baseUrl: baseUrl,
        boardId: boardId,
        fieldConfigs: fieldConfigs,
        prefetchedData: prefetchedData,
        prefetchedAggData: prefetchedAggData,
        storeFieldsActions: storeFieldsActions,
        fetchDataFromAGG: fetchDataFromAGG,
        isCompanyManaged: isCompanyManaged
    }).map((0, $jiL2Q.setAppData)).catch((restError)=>{
        const message = (0, $8wXFi.isBacklogWithRelayEnabled)() && fetchDataFromAGG ? 'Failed to load graphql data from AGG' : 'Failed to load graphql data';
        (0, $gUUjF.default).safeErrorWithoutCustomerData('backlog.load-agility-graphql-data.failure', message, restError);
        return (0, $3JafE.Observable).of((0, $jiL2Q.loadAppDataFailure)());
    });
};
const $f27f37ff6683fd30$export$8976970ef97c8467 = (action$, store)=>action$.ofType((0, $jiL2Q.LOAD_APP_DATA_REQUEST)).flatMap((action)=>$f27f37ff6683fd30$export$8134c072fddab6a5({
            store: store,
            prefetchedData: action.payload.prefetchedData,
            prefetchedAggData: action.payload.prefetchedAggData,
            storeFieldsActions: action.payload.storeFieldsActions
        }));

});
parcelRegister("5muvm", function(module, exports) {

$parcel$export(module.exports, "default", () => $d85393aa752ec56d$export$2e2bcd8739ae039);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("flmol");

var $8riMk = parcelRequire("8riMk");

var $645Hx = parcelRequire("645Hx");

var $8wXFi = parcelRequire("8wXFi");

var $15Ejv = parcelRequire("15Ejv");

var $3VWrx = parcelRequire("3VWrx");
function $d85393aa752ec56d$var$updateStoreFields(data, fieldConfigs, updateFieldsAction) {
    if (updateFieldsAction && fieldConfigs) updateFieldsAction(data, fieldConfigs);
}
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d85393aa752ec56d$export$2e2bcd8739ae039 = ({ baseUrl: baseUrl, boardId: boardId, isCompanyManaged: isCompanyManaged, fieldConfigs: fieldConfigs, prefetchedData: prefetchedData, prefetchedAggData: prefetchedAggData, storeFieldsActions: storeFieldsActions, fetchDataFromAGG: fetchDataFromAGG })=>{
    if ((0, $8wXFi.isBacklogWithRelayEnabled)()) {
        if (prefetchedAggData) {
            $d85393aa752ec56d$var$updateStoreFields(prefetchedAggData, fieldConfigs, storeFieldsActions?.storeFieldsFromPrefetchedAggData);
            return (0, $3JafE.Observable).of((0, $15Ejv.transformAggData)(prefetchedAggData));
        }
        if (fetchDataFromAGG) return (0, $8riMk.fromPromise)(fetchDataFromAGG()).map((data)=>{
            $d85393aa752ec56d$var$updateStoreFields(data, fieldConfigs, storeFieldsActions?.storeFieldsFromPrefetchedAggData);
            return (0, $15Ejv.transformAggData)(data);
        });
        return (0, $645Hx.default)(baseUrl, boardId).map((data)=>{
            $d85393aa752ec56d$var$updateStoreFields(data, fieldConfigs, storeFieldsActions?.storeFieldsFromPrefetchedData);
            return (0, $3VWrx.default)(data, isCompanyManaged);
        });
    }
    const getResponse = ()=>{
        if (prefetchedData) {
            $d85393aa752ec56d$var$updateStoreFields(prefetchedData, fieldConfigs, storeFieldsActions?.storeFieldsFromPrefetchedData);
            return (0, $3JafE.Observable).of(prefetchedData);
        }
        return (0, $645Hx.default)(baseUrl, boardId);
    };
    return getResponse().map((data)=>{
        $d85393aa752ec56d$var$updateStoreFields(data, fieldConfigs, storeFieldsActions?.storeFieldsFromPrefetchedData);
        return (0, $3VWrx.default)(data, isCompanyManaged);
    });
};

});
parcelRegister("645Hx", function(module, exports) {

$parcel$export(module.exports, "fetchAgilityGraphqlData", () => $4dedb3699b17e3a7$export$bd0cd61988658475);
$parcel$export(module.exports, "default", () => $4dedb3699b17e3a7$export$2e2bcd8739ae039);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("iects");

var $70s4u = parcelRequire("70s4u");

var $gUUjF = parcelRequire("gUUjF");

var $jy01K = parcelRequire("jy01K");

var $9XyH5 = parcelRequire("9XyH5");

var $lSDhs = parcelRequire("lSDhs");

var $jKJ89 = parcelRequire("jKJ89");
const $4dedb3699b17e3a7$var$BACKLOG = 'BACKLOG';
// Standard observer pattern, the middleware in board/backlog will invoke this
// when it comes across a matching redux mutation that requires the cache
// to be updated
const $4dedb3699b17e3a7$var$CacheUpdateSubject = new (0, $70s4u.Subject)();
const $4dedb3699b17e3a7$var$loadAgilityGraphqlData = (baseUrl, boardId)=>{
    const requestStartTime = new Date().valueOf();
    let query;
    if ((0, $lSDhs.isFetchBacklogChildIssuesDataEnabled)()) query = (0, $jKJ89.getQueryIncludeChildIssues)();
    else query = (0, $jKJ89.getQuery)();
    (0, $9XyH5.setBacklogFetchStart)();
    return (0, $jy01K.query$)(baseUrl, (0, $jKJ89.backlogDataOperationName), query, {
        boardId: boardId
    }).flatMap((data)=>{
        const requestEndTime = new Date().valueOf();
        (0, $gUUjF.default).safeInfoWithoutCustomerData(`rest.swag.${(0, $jKJ89.backlogDataOperationName)}.success`, '', {
            time: requestEndTime - requestStartTime
        });
        // Everytime we fetch this data, we can use it to hydrate the BACKLOG resources-cache
        $4dedb3699b17e3a7$var$CacheUpdateSubject.next({
            origin: $4dedb3699b17e3a7$var$BACKLOG,
            payload: data
        });
        (0, $9XyH5.setBacklogFetchStop)();
        return (0, $3JafE.Observable).of(data);
    });
};
const $4dedb3699b17e3a7$export$bd0cd61988658475 = (baseUrl, boardId)=>$4dedb3699b17e3a7$var$loadAgilityGraphqlData(baseUrl, boardId).toPromise().then((response)=>response);
var $4dedb3699b17e3a7$export$2e2bcd8739ae039 = $4dedb3699b17e3a7$var$loadAgilityGraphqlData;

});
parcelRegister("9XyH5", function(module, exports) {

$parcel$export(module.exports, "setBacklogFetchStart", () => $8de6eb6c97dd76c0$export$98082f6cfce5fbfd);
$parcel$export(module.exports, "setBacklogFetchStop", () => $8de6eb6c97dd76c0$export$a14619e64801099);

var $cqfhI = parcelRequire("cqfhI");
const $8de6eb6c97dd76c0$export$98082f6cfce5fbfd = ()=>{
    (0, $cqfhI.backlogFetch).start();
};
const $8de6eb6c97dd76c0$export$a14619e64801099 = ()=>{
    (0, $cqfhI.backlogFetch).stop();
};

});
parcelRegister("cqfhI", function(module, exports) {

$parcel$export(module.exports, "backlogFetch", () => $25cf6361395cd062$export$c37fad154e1f0a06);

var $lNfG4 = parcelRequire("lNfG4");
const $25cf6361395cd062$export$c37fad154e1f0a06 = (0, $lNfG4.metrics).interaction({
    key: 'backlog.data-fetch'
});

});


parcelRegister("lSDhs", function(module, exports) {

$parcel$export(module.exports, "isFetchBacklogChildIssuesDataEnabled", () => $d2459d9a9a6a714e$export$b420dd99bec1fa99);

var $1ybV0 = parcelRequire("1ybV0");
const $d2459d9a9a6a714e$export$b420dd99bec1fa99 = ()=>(0, $1ybV0.ff)('sea-2127-backlog-fetch-child-issues-data-tmps_obopa', false); // </esala>

});

parcelRegister("jKJ89", function(module, exports) {

$parcel$export(module.exports, "backlogDataOperationName", () => $7db5a0d0351a4b1f$export$2aa160b066ef4bbe);
$parcel$export(module.exports, "getQuery", () => $7db5a0d0351a4b1f$export$71eec30d9db46a56);
$parcel$export(module.exports, "getQueryIncludeChildIssues", () => $7db5a0d0351a4b1f$export$87718262a5dd5cf5);
/*!
 * ATTENTION
 *
 * This module is used on both the main backlog app and its vendorless early-script entry.
 *
 * Because of this, it can't have dependencies. Feature-flagging logic should be done outside this
 * module and values should be passed in. For now changes must happen on both calls.
 */ const $7db5a0d0351a4b1f$export$2aa160b066ef4bbe = 'BacklogDataQuery';
const $7db5a0d0351a4b1f$export$71eec30d9db46a56 = ()=>`
    query ${$7db5a0d0351a4b1f$export$2aa160b066ef4bbe} ($boardId: ID!) {
        jira {
            timeTrackingOptions {
                workingHoursPerDay
                workingDaysPerWeek
                defaultUnit
                timeFormat
            }
        }
        boardScope(boardId: $boardId) {
            sprints(state:[ACTIVE, FUTURE]) {
                id
                name
                goal
                startDate
                endDate
                daysRemaining
                cards {
                    id
                    issue {
                        id
                        key
                        summary
                        labels
                        type {
                            id
                            name
                            iconUrl
                        }
                        status {
                            id
                            name
                            category
                        }
                        assignee {
                            accountId
                            displayName
                            avatarUrl
                        }
                    }
                    flagged
                    done
                    parentId
                    estimate {
                        storyPoints
                        originalEstimate {
                            value
                            valueAsText
                        }
                    }
                    priority {
                        name
                        iconUrl
                    }
                    dueDate
                    childIssuesMetadata {
                        complete
                        total
                    }
                    fixVersions
                }
                sprintState
            }
            backlog {
                boardIssueListKey
                requestColumnMigration
                cards {
                    id
                    issue {
                        id
                        key
                        summary
                        labels
                        type {
                            id
                            name
                            iconUrl
                        }
                        status {
                            id
                            name
                            category
                        }
                        assignee {
                            accountId
                            displayName
                            avatarUrl
                        }
                    }
                    flagged
                    done
                    parentId
                    estimate {
                        storyPoints
                        originalEstimate {
                            value
                            valueAsText
                        }
                    }
                    priority {
                        name
                        iconUrl
                    }
                    dueDate
                    childIssuesMetadata {
                        complete
                        total
                    }
                    fixVersions
                }
            }
            board {
                cards {
                    id
                    issue {
                        id
                        key
                        summary
                        labels
                        type {
                            id
                            name
                            iconUrl
                        }
                        status {
                            id
                            name
                            category
                        }
                        assignee {
                            accountId
                            displayName
                            avatarUrl
                        }
                    }
                    flagged
                    done
                    parentId
                    estimate {
                        storyPoints
                        originalEstimate {
                            value
                            valueAsText
                        }
                    }
                    priority {
                        name
                        iconUrl
                    }
                    dueDate
                    childIssuesMetadata {
                        complete
                        total
                    }
                    fixVersions
                }
                rankCustomFieldId
                issueParents {
                    id
                    key
                    summary
                    issueType {
                        id
                        name
                        iconUrl
                    }
                    color
                }
            }
            currentUser {
                permissions
            }
            projectLocation {
                id
                key
                name
                issueTypes {
                    id
                    name
                    iconUrl
                    hierarchyLevelType
                    hasRequiredFields
                } 
                features {
                    key
                    status
                }
            }
            features {
                key
                status
            }
            estimation {
                current {
                    customFieldId
                }
                available {
                    statisticFieldId
                }
            }
        }
    }
`;
const $7db5a0d0351a4b1f$export$87718262a5dd5cf5 = ()=>`
    query ${$7db5a0d0351a4b1f$export$2aa160b066ef4bbe} ($boardId: ID!) {
        jira {
            timeTrackingOptions {
                workingHoursPerDay
                workingDaysPerWeek
                defaultUnit
                timeFormat
            }
        }
        boardScope(boardId: $boardId) {
            sprints(state:[ACTIVE, FUTURE]) {
                id
                name
                goal
                startDate
                endDate
                daysRemaining
                cards {
                    id
                    issue {
                        id
                        key
                        summary
                        labels
                        type {
                            id
                            name
                            iconUrl
                        }
                        status {
                            id
                            name
                            category
                        }
                        assignee {
                            accountId
                            displayName
                            avatarUrl
                        }
                    }
                    flagged
                    done
                    parentId
                    estimate {
                        storyPoints
                        originalEstimate {
                            value
                            valueAsText
                        }
                    }
                    priority {
                        name
                        iconUrl
                    }
                    dueDate
                    childIssuesMetadata {
                        complete
                        total
                    }
                    fixVersions
                }
                sprintState      
                        issueChildren {
                    id
                    issue {
                        id
                        key
                        summary
                        labels
                        type {
                            id
                            name
                            iconUrl
                        }
                        status {
                            id
                            name
                            category
                        }
                        assignee {
                            accountId
                            displayName
                            avatarUrl
                        }
                    }
                    flagged
                    done
                    parentId
                    priority {
                        name
                        iconUrl
                    }
                }
            }
            backlog {
                boardIssueListKey
                requestColumnMigration
                cards {
                    id
                    issue {
                        id
                        key
                        summary
                        labels
                        type {
                            id
                            name
                            iconUrl
                        }
                        status {
                            id
                            name
                            category
                        }
                        assignee {
                            accountId
                            displayName
                            avatarUrl
                        }
                    }
                    flagged
                    done
                    parentId
                    estimate {
                        storyPoints
                        originalEstimate {
                            value
                            valueAsText
                        }
                    }
                    priority {
                        name
                        iconUrl
                    }
                    dueDate
                    childIssuesMetadata {
                        complete
                        total
                    }
                    fixVersions
                }
                issueChildren {
                    id
                    issue {
                        id
                        key
                        summary
                        labels
                        type {
                            id
                            name
                            iconUrl
                        }
                        status {
                            id
                            name
                            category
                        }
                        assignee {
                            accountId
                            displayName
                            avatarUrl
                        }
                    }
                    flagged
                    done
                    parentId
                    priority {
                        name
                        iconUrl
                    }
                }
            }
            board {
                cards {
                    id
                    issue {
                        id
                        key
                        summary
                        labels
                        type {
                            id
                            name
                            iconUrl
                        }
                        status {
                            id
                            name
                            category
                        }
                        assignee {
                            accountId
                            displayName
                            avatarUrl
                        }
                    }
                    flagged
                    done
                    parentId
                    estimate {
                        storyPoints
                        originalEstimate {
                            value
                            valueAsText
                        }
                    }
                    priority {
                        name
                        iconUrl
                    }
                    dueDate
                    childIssuesMetadata {
                        complete
                        total
                    }
                    fixVersions
                }
                rankCustomFieldId
                issueParents {
                    id
                    key
                    summary
                    issueType {
                        id
                        name
                        iconUrl
                    }
                    color
                }
            }
            currentUser {
                permissions
            }
            projectLocation {
                id
                key
                name
                issueTypes {
                    id
                    name
                    iconUrl
                    hierarchyLevelType
                    hasRequiredFields
                } 
                features {
                    key
                    status
                }
            }
            features {
                key
                status
            }
            estimation {
                current {
                    customFieldId
                }
                available {
                    statisticFieldId
                }
            }
        }
    }
`;

});


parcelRegister("15Ejv", function(module, exports) {

$parcel$export(module.exports, "transformAggData", () => $a912dcde8cef8a58$export$184ba826956cb720);

var $6HC1D = parcelRequire("6HC1D");

var $ldoFd = parcelRequire("ldoFd");

var $MdoH4 = parcelRequire("MdoH4");

var $hvbu2 = parcelRequire("hvbu2");

var $hwbh0 = parcelRequire("hwbh0");

var $3l6tm = parcelRequire("3l6tm");


var $4m36T = parcelRequire("4m36T");

var $bHPpI = parcelRequire("bHPpI");


var $7TyGu = parcelRequire("7TyGu");

const $a912dcde8cef8a58$var$storyPointFieldIdTransformer = (estimation)=>{
    const storyPointId = estimation.available.find(({ statisticFieldId: statisticFieldId })=>statisticFieldId !== (0, $7TyGu.ORIGINAL_ESTIMATE_FIELD_ID) && statisticFieldId !== (0, $7TyGu.ISSUE_COUNT_ID))?.statisticFieldId || '';
    return storyPointId.replace((0, $7TyGu.ESTIMATION_TYPE_ID_PREFIX), '') || null;
};
const $a912dcde8cef8a58$var$isFeatureEnabled = (features, featureKey)=>(features || []).some(({ key: key, status: status })=>String(key) === featureKey && status === (0, $e37979b27b7bd428$export$e927a5d1b72f0b68));
const $a912dcde8cef8a58$var$getBacklogStrategy = (features)=>{
    if (!$a912dcde8cef8a58$var$isFeatureEnabled(features, (0, $7TyGu.BACKLOG))) return 0, $7TyGu.NONE;
    if ($a912dcde8cef8a58$var$isFeatureEnabled(features, (0, $e37979b27b7bd428$export$4279f6f79febea0a))) return 0, $7TyGu.SPRINT;
    return 0, $7TyGu.ISSUE_LIST;
};
const $a912dcde8cef8a58$var$getJiraTimeUnit = (defaultUnit)=>{
    switch(defaultUnit.toLowerCase()){
        case (0, $4m36T.TimeUnits).DAY:
            return (0, $4m36T.TimeUnits).DAY;
        case (0, $4m36T.TimeUnits).HOUR:
            return (0, $4m36T.TimeUnits).HOUR;
        case (0, $4m36T.TimeUnits).MINUTE:
            return (0, $4m36T.TimeUnits).MINUTE;
        case (0, $4m36T.TimeUnits).WEEK:
            return (0, $4m36T.TimeUnits).WEEK;
        default:
            return (0, $4m36T.TimeUnits).DAY;
    }
};
const $a912dcde8cef8a58$var$getJiraTimeFormat = (format)=>{
    switch(format.toLowerCase()){
        case (0, $4m36T.TimeFormats).DAYS:
            return (0, $4m36T.TimeFormats).DAYS;
        case (0, $4m36T.TimeFormats).HOURS:
            return (0, $4m36T.TimeFormats).HOURS;
        case (0, $4m36T.TimeFormats).PRETTY:
            return (0, $4m36T.TimeFormats).PRETTY;
        default:
            return (0, $4m36T.TimeFormats).DAYS;
    }
};
const $a912dcde8cef8a58$var$cardTypesTransformer = (cardTypes)=>cardTypes.reduce((baseLevelCardTypes, { hierarchyLevelType: hierarchyLevelType, id: id, name: name, iconUrl: iconUrl, hasRequiredFields: hasRequiredFields })=>{
        if (String(hierarchyLevelType) === (0, $3l6tm.BASE_HIERARCHY_TYPE)) baseLevelCardTypes.push({
            id: Number(id),
            name: name,
            iconUrl: iconUrl,
            hasRequiredFields: hasRequiredFields,
            typeHierarchyLevel: (0, $3l6tm.BASE_HIERARCHY_TYPE)
        });
        return baseLevelCardTypes;
    }, []);
const $a912dcde8cef8a58$var$BACKLOG_LIST = (0, $6HC1D.freeze)({
    id: (0, $7TyGu.BACKLOG),
    type: (0, $7TyGu.BACKLOG),
    name: 'Backlog',
    issueListKey: null
});
const $a912dcde8cef8a58$export$69760b7e76c533f9 = ({ jira: { globalTimeTrackingSettings: globalTimeTrackingSettings }, boardScope: { board: { rankCustomFieldId: rankCustomFieldId }, projectLocation: { name: name }, features: features, currentUser: { permissions: permissions }, estimation: estimation, backlog: backlog } })=>{
    if (!backlog) throw new Error('boardScope.backlog is null');
    const filteredFeatures = features.filter(Boolean).map(({ key: key, status: status })=>({
            key: String(key),
            status: String(status)
        }));
    const filteredPermissions = permissions.map((permission)=>String(permission));
    const transformedConfig = {
        rankCustomFieldId: Number(rankCustomFieldId),
        requestColumnMigration: backlog.requestColumnMigration,
        name: name,
        permissions: {
            [(0, $094620879c5e56fa$export$d765836bd761b2ee)]: filteredPermissions.includes((0, $7TyGu.MANAGE_SPRINT)),
            [(0, $094620879c5e56fa$export$526c94c551c00291)]: filteredPermissions.includes((0, $7TyGu.CREATE_ISSUE)),
            [(0, $094620879c5e56fa$export$8a1ecb9983951227)]: filteredPermissions.includes((0, $7TyGu.EDIT_ISSUE)),
            [(0, $094620879c5e56fa$export$b35e3ebf2c83a499)]: filteredPermissions.includes((0, $7TyGu.EDIT_BOARD_CONFIG))
        },
        version: {
            isVersionsFeatureEnabled: $a912dcde8cef8a58$var$isFeatureEnabled(filteredFeatures, (0, $e37979b27b7bd428$export$173708eb8a9ba955))
        },
        allFeatures: filteredFeatures,
        backlogStrategy: $a912dcde8cef8a58$var$getBacklogStrategy(filteredFeatures),
        storyPointFieldId: $a912dcde8cef8a58$var$storyPointFieldIdTransformer(estimation),
        timeTrackingOptions: {
            workingDaysPerWeek: globalTimeTrackingSettings.workingDaysPerWeek,
            workingHoursPerDay: globalTimeTrackingSettings.workingHoursPerDay,
            defaultUnit: $a912dcde8cef8a58$var$getJiraTimeUnit(globalTimeTrackingSettings.defaultUnit),
            timeFormat: $a912dcde8cef8a58$var$getJiraTimeFormat(globalTimeTrackingSettings.defaultFormat)
        }
    };
    return transformedConfig;
};
const $a912dcde8cef8a58$export$c44fc4642496cd94 = (card, projectAri)=>({
        summary: card.summary,
        id: Number((0, $bHPpI.getIdFromAri)(card.id)),
        key: card.key,
        labels: card.labels.filter(Boolean),
        assignee: card.assignee ? {
            id: card.assignee.accountId,
            displayName: card.assignee.name,
            avatarUrl: card.assignee.picture
        } : null,
        icon: card.type.iconUrl,
        isDone: card.done,
        isFlagged: card.flagged,
        typeId: Number(card.type.id),
        issueUrl: `/browse/${card.key}`,
        statusId: card.status.id,
        parentId: card.parentId ? Number((0, $bHPpI.getIdFromAri)(card.parentId)) : null,
        priority: card.priority ? {
            name: card.priority.name,
            iconUrl: card.priority.iconUrl
        } : null,
        // @ts-expect-error - Type 'string | null | undefined' is not assignable to type 'string | null'.
        dueDate: card.dueDate,
        // @ts-expect-error - Type '{ timeRemainingEstimate: null; originalEstimate: { readonly value: number; readonly valueAsText: string; } | null | undefined; storyPoints: number | null | undefined; } | null' is not assignable to type 'CardEstimate | null'.
        estimate: (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(card.estimate) ? null : {
            ...card.estimate,
            timeRemainingEstimate: null
        },
        numCompleteChildren: card.childCardsMetadata ? card.childCardsMetadata.complete : 0,
        numTotalChildren: card.childCardsMetadata ? card.childCardsMetadata.total : 0,
        fixVersions: card.fixVersionsIds.concat(),
        projectId: Number((0, $bHPpI.getIdFromAri)(projectAri))
    });
const $a912dcde8cef8a58$export$56ea715ea3d97dee = (cardParents)=>cardParents.reduce((issueParentsEntityState, cardParent)=>{
        const cardId = (0, $bHPpI.getIdFromAri)(cardParent.id);
        const { key: key, summary: summary, cardType: cardType } = cardParent;
        return Object.assign(issueParentsEntityState, {
            [cardId]: {
                id: cardId,
                key: key,
                summary: summary,
                color: cardParent.color ? String(cardParent.color) : null,
                issueType: {
                    id: cardType.id,
                    name: cardType.name,
                    iconUrl: cardType.iconUrl
                }
            }
        });
    }, {});
const $a912dcde8cef8a58$export$f96dae738e4d5e19 = (isEstimationEnabled, estimation)=>{
    const estimateFieldKey = estimation.current.customFieldId || '';
    if (isEstimationEnabled && estimateFieldKey) return estimateFieldKey === (0, $ebc098a76317be78$export$5fbd3b15555b9ef2) ? (0, $7TyGu.ORIGINAL_ESTIMATE) : (0, $7TyGu.STORY_POINTS);
    return 0, $7TyGu.ISSUE_COUNT;
};
const $a912dcde8cef8a58$export$6b3f2edb57acc06e = (isEstimationEnabled, estimation)=>// @ts-expect-error - Type 'string | null | undefined' is not assignable to type 'string | null'.
    isEstimationEnabled ? estimation.current.customFieldId : null;
const $a912dcde8cef8a58$export$3bf59b7c6d7e91d9 = (features, estimation)=>{
    const isEstimationFeatureEnabled = $a912dcde8cef8a58$var$isFeatureEnabled(features, (0, $e37979b27b7bd428$export$4181c6622414bfdf));
    return {
        isEstimationFeatureEnabled: isEstimationFeatureEnabled,
        estimationType: $a912dcde8cef8a58$export$f96dae738e4d5e19(isEstimationFeatureEnabled, estimation),
        estimationFieldId: $a912dcde8cef8a58$export$6b3f2edb57acc06e(isEstimationFeatureEnabled, estimation),
        name: ''
    };
};
const $a912dcde8cef8a58$export$4055277b2f3e701f = ({ id: id, name: name, goal: goal, startDate: startDate, endDate: endDate, daysRemaining: daysRemaining, sprintState: sprintState }, canUpdateSprint)=>({
        id: (0, $bHPpI.getIdFromAri)(id),
        name: name,
        type: (0, $7TyGu.SPRINT),
        issueListKey: null,
        sprintData: {
            goal: goal || '',
            startDate: startDate || '',
            endDate: endDate || '',
            daysRemaining: daysRemaining || 0,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            state: String(sprintState) || (0, $7TyGu.SPRINT_STATE_FUTURE),
            canUpdateSprint: canUpdateSprint
        }
    });
const $a912dcde8cef8a58$export$cfeec69489a32e7d = (allCards)=>({
        versions: (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))((0, (/*@__PURE__*/$parcel$interopDefault($hvbu2)))(allCards).reduce((fixVersions, card)=>card.fixVersions && card.fixVersions.length > 0 ? fixVersions.concat(card.fixVersions) : fixVersions, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        []))
    });
const $a912dcde8cef8a58$var$backlogOnlyTransformer = (data)=>{
    const { backlog: backlog, board: board, cardParents: cardParents, features: features, estimation: estimation, projectLocation: { id: projectAri, cardTypes: cardTypes } } = data.boardScope;
    if (!backlog) throw new Error('boardScope.backlog is null');
    const boardCards = board.cards.filter(Boolean);
    const backlogCards = backlog.cards.filter(Boolean);
    const cards = backlogCards.concat(boardCards);
    const filteredFeatures = features.filter(Boolean).map(({ key: key, status: status })=>({
            key: String(key),
            status: String(status)
        }));
    const filteredCardParents = cardParents.filter(Boolean);
    const card = (0, (/*@__PURE__*/$parcel$interopDefault($hwbh0)))(cards.map(({ id: id })=>(0, $bHPpI.getIdFromAri)(id)), cards.map((cardData)=>$a912dcde8cef8a58$export$c44fc4642496cd94(cardData, projectAri)));
    return {
        entities: {
            cardList: {
                [(0, $7TyGu.BOARD)]: {
                    id: (0, $7TyGu.BOARD),
                    type: (0, $7TyGu.BOARD),
                    name: 'Board',
                    issueListKey: backlog.boardIssueListKey
                },
                [(0, $7TyGu.BACKLOG)]: $a912dcde8cef8a58$var$BACKLOG_LIST
            },
            cardListOrder: [
                (0, $7TyGu.BOARD),
                (0, $7TyGu.BACKLOG)
            ],
            card: card,
            cardTypes: $a912dcde8cef8a58$var$cardTypesTransformer(cardTypes.filter(Boolean)),
            cardOrder: {
                [(0, $7TyGu.BOARD)]: boardCards.map(({ id: id })=>Number((0, $bHPpI.getIdFromAri)(id))),
                [(0, $7TyGu.BACKLOG)]: backlogCards.map(({ id: id })=>Number((0, $bHPpI.getIdFromAri)(id)))
            },
            issueParents: $a912dcde8cef8a58$export$56ea715ea3d97dee(filteredCardParents),
            issueParentsOrder: filteredCardParents.map(({ id: id })=>(0, $bHPpI.getIdFromAri)(id)),
            estimation: $a912dcde8cef8a58$export$3bf59b7c6d7e91d9(filteredFeatures, estimation),
            version: $a912dcde8cef8a58$export$cfeec69489a32e7d(card),
            inlineCreate: {
                cardTypeIds: cardTypes.filter(Boolean).map((it)=>Number(it.id))
            }
        },
        config: $a912dcde8cef8a58$export$69760b7e76c533f9(data)
    };
};
const $a912dcde8cef8a58$var$backlogWithSprintsTransformer = (data)=>{
    const { currentUser: { permissions: permissions }, sprints: sprints, backlog: backlog, cardParents: cardParents, features: features, estimation: estimation, projectLocation: { id: projectId, cardTypes: cardTypes } } = data.boardScope;
    if (!backlog) throw new Error('boardScope.backlog is null');
    const filteredBacklogCards = backlog.cards.filter(Boolean);
    const filteredCardParents = cardParents.filter(Boolean);
    const filteredFeatures = features.filter(Boolean).map(({ key: key, status: status })=>({
            key: String(key),
            status: String(status)
        }));
    const filteredSprints = sprints.filter(Boolean);
    const canUpdateSprint = permissions.map(String).includes((0, $7TyGu.MANAGE_SPRINT));
    const cardList = {
        [(0, $7TyGu.BACKLOG)]: $a912dcde8cef8a58$var$BACKLOG_LIST
    };
    const cardListOrder = [];
    const cardOrder = {
        [(0, $7TyGu.BACKLOG)]: filteredBacklogCards.map(({ id: id })=>Number((0, $bHPpI.getIdFromAri)(id)))
    };
    let cards = [];
    filteredSprints.forEach((sprint)=>{
        const sprintId = (0, $bHPpI.getIdFromAri)(sprint.id);
        const sprintCards = sprint.cards.filter(Boolean);
        cardList[sprintId] = $a912dcde8cef8a58$export$4055277b2f3e701f(sprint, canUpdateSprint);
        cardListOrder.push(sprintId);
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ BACKLOG: any[]; }'.
        cardOrder[sprintId] = sprintCards.map(({ id: id })=>Number((0, $bHPpI.getIdFromAri)(id)));
        cards = cards.concat(sprintCards);
    });
    cardListOrder.push((0, $7TyGu.BACKLOG));
    cards = cards.concat(filteredBacklogCards);
    const card = (0, (/*@__PURE__*/$parcel$interopDefault($hwbh0)))(cards.map(({ id: id })=>(0, $bHPpI.getIdFromAri)(id)), cards.map((cardData)=>$a912dcde8cef8a58$export$c44fc4642496cd94(cardData, projectId)));
    return {
        entities: {
            cardList: cardList,
            cardListOrder: cardListOrder,
            card: card,
            cardTypes: $a912dcde8cef8a58$var$cardTypesTransformer(cardTypes.filter(Boolean)),
            cardOrder: cardOrder,
            issueParents: $a912dcde8cef8a58$export$56ea715ea3d97dee(cardParents.filter(Boolean)),
            issueParentsOrder: filteredCardParents.map(({ id: id })=>(0, $bHPpI.getIdFromAri)(id)),
            estimation: $a912dcde8cef8a58$export$3bf59b7c6d7e91d9(filteredFeatures, estimation),
            version: $a912dcde8cef8a58$export$cfeec69489a32e7d(card),
            inlineCreate: {
                cardTypeIds: cardTypes.filter(Boolean).map((it)=>Number(it.id))
            }
        },
        config: $a912dcde8cef8a58$export$69760b7e76c533f9(data)
    };
};
const $a912dcde8cef8a58$export$184ba826956cb720 = (data)=>{
    const filteredFeatures = data.boardScope.features.filter(Boolean).map(({ key: key, status: status })=>({
            key: String(key),
            status: String(status)
        }));
    if ($a912dcde8cef8a58$var$isFeatureEnabled(filteredFeatures, (0, $e37979b27b7bd428$export$4279f6f79febea0a))) return $a912dcde8cef8a58$var$backlogWithSprintsTransformer(data);
    return $a912dcde8cef8a58$var$backlogOnlyTransformer(data);
};

});
parcelRegister("4m36T", function(module, exports) {

$parcel$export(module.exports, "SECONDS_PER_MINUTE", () => $8d43f29047a2cbec$export$544c576050746347);
$parcel$export(module.exports, "SECONDS_PER_HOUR", () => $8d43f29047a2cbec$export$3cc7ae4b390f50a);
$parcel$export(module.exports, "TimeFormats", () => $8d43f29047a2cbec$export$5d7ed58d46354b1);
$parcel$export(module.exports, "TimeUnits", () => $8d43f29047a2cbec$export$5d7753c8ad881494);
$parcel$export(module.exports, "defaultTimeTrackingOptions", () => $8d43f29047a2cbec$export$f8d48c1fed813e90);
const $8d43f29047a2cbec$export$544c576050746347 = 60;
const $8d43f29047a2cbec$export$a4982fdb1458274 = 60;
const $8d43f29047a2cbec$export$3cc7ae4b390f50a = $8d43f29047a2cbec$export$a4982fdb1458274 * $8d43f29047a2cbec$export$544c576050746347;
const $8d43f29047a2cbec$var$TIME_FORMAT_PRETTY = 'pretty';
const $8d43f29047a2cbec$var$TIME_FORMAT_DAYS = 'days';
const $8d43f29047a2cbec$var$TIME_FORMAT_HOURS = 'hours';
const $8d43f29047a2cbec$export$5d7ed58d46354b1 = Object.freeze({
    PRETTY: $8d43f29047a2cbec$var$TIME_FORMAT_PRETTY,
    DAYS: $8d43f29047a2cbec$var$TIME_FORMAT_DAYS,
    HOURS: $8d43f29047a2cbec$var$TIME_FORMAT_HOURS
});
const $8d43f29047a2cbec$var$TIME_UNIT_WEEK = 'week';
const $8d43f29047a2cbec$var$TIME_UNIT_DAY = 'day';
const $8d43f29047a2cbec$var$TIME_UNIT_HOUR = 'hour';
const $8d43f29047a2cbec$var$TIME_UNIT_MINUTE = 'minute';
const $8d43f29047a2cbec$export$5d7753c8ad881494 = Object.freeze({
    WEEK: $8d43f29047a2cbec$var$TIME_UNIT_WEEK,
    DAY: $8d43f29047a2cbec$var$TIME_UNIT_DAY,
    HOUR: $8d43f29047a2cbec$var$TIME_UNIT_HOUR,
    MINUTE: $8d43f29047a2cbec$var$TIME_UNIT_MINUTE
});
const $8d43f29047a2cbec$export$f8d48c1fed813e90 = {
    workingHoursPerDay: 8,
    workingDaysPerWeek: 5,
    timeFormat: $8d43f29047a2cbec$export$5d7ed58d46354b1.PRETTY,
    defaultUnit: $8d43f29047a2cbec$export$5d7753c8ad881494.MINUTE
};

});




parcelRegister("5W47q", function(module, exports) {

$parcel$export(module.exports, "loadCardCreateConfigEpic", () => $095c253f5513438f$export$8772c54f1f4570e1);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("iects");
parcelRequire("flmol");
parcelRequire("1Lcr1");

var $gUUjF = parcelRequire("gUUjF");

var $gsTSP = parcelRequire("gsTSP");

var $jiL2Q = parcelRequire("jiL2Q");

var $hkGxG = parcelRequire("hkGxG");
const $095c253f5513438f$export$8772c54f1f4570e1 = (action$, store, dependencies)=>action$.ofType((0, $jiL2Q.LOAD_CARD_CREATE_CONFIG_REQUEST), (0, $jiL2Q.LOAD_CONFIG_DATA_MODEL_SUCCESS)).flatMap((action)=>{
        const state = store.getState();
        const jqlQuery = action.type === (0, $jiL2Q.LOAD_CONFIG_DATA_MODEL_SUCCESS) ? action.payload.config.jqlQuery : (0, $hkGxG.getJqlQuery)(state) || '';
        const analyticsEvent = dependencies && dependencies.createAnalyticsEvent ? dependencies.createAnalyticsEvent({
            action: 'load',
            actionSubject: 'cardCreateConfig'
        }) : undefined;
        return (0, $gsTSP.default)(jqlQuery).map((cardConfigResponse)=>(0, $jiL2Q.loadCardCreateConfigSuccess)(cardConfigResponse, analyticsEvent)).catch((error)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData('backlog.load-card-create-config.failure', 'Failed to load card create config from REST', error);
            return (0, $3JafE.Observable).of((0, $jiL2Q.loadCardCreateConfigFailure)(error, analyticsEvent));
        });
    });

});
parcelRegister("gsTSP", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbeb9253ba2b9788$export$2e2bcd8739ae039);

var $3l6tm = parcelRequire("3l6tm");

var $71QK9 = parcelRequire("71QK9");
parcelRequire("flmol");
const $dbeb9253ba2b9788$export$6b468dcfb64c653c = (response)=>{
    if (!response.issueTypes.successful) return {
        cardTypes: []
    };
    return {
        cardTypes: response.issueTypes.values.map((issueType)=>({
                id: Number(issueType.id),
                name: issueType.name,
                iconUrl: issueType.iconUrl,
                hasRequiredFields: null,
                typeHierarchyLevel: (0, $3l6tm.getHierarchyLevelTypeSplitEpicFromCustom)(issueType.hierarchyLevel)
            }))
    };
};
const $dbeb9253ba2b9788$var$loadCardCreateConfigService = (jqlQuery)=>(0, $71QK9.loadCardCreateConfig)(jqlQuery).map($dbeb9253ba2b9788$export$6b468dcfb64c653c);
var $dbeb9253ba2b9788$export$2e2bcd8739ae039 = $dbeb9253ba2b9788$var$loadCardCreateConfigService;

});
parcelRegister("71QK9", function(module, exports) {

$parcel$export(module.exports, "loadCardCreateConfig", () => $64b6203dda324da6$export$149bf88f2a958c35);

var $53ciZ = parcelRequire("53ciZ");

var $aiRd8 = parcelRequire("aiRd8");
function $64b6203dda324da6$export$149bf88f2a958c35(jqlQuery) {
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify({
        query: jqlQuery
    });
    return (0, $aiRd8.default)(`/rest/inline-create/1.0/context/bootstrap?${query}`);
}

});



parcelRegister("c1oku", function(module, exports) {

$parcel$export(module.exports, "loadConfigDataEpic", () => $24c010126505783b$export$cc32ef09edf2b5cb);
parcelRequire("jyKN9");
parcelRequire("9u6v2");
parcelRequire("6og5C");
parcelRequire("flmol");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $6HC1D = parcelRequire("6HC1D");

var $3JafE = parcelRequire("3JafE");

var $gUUjF = parcelRequire("gUUjF");

var $aISvV = parcelRequire("aISvV");

var $iJu8x = parcelRequire("iJu8x");

var $lEnU0 = parcelRequire("lEnU0");

var $jiL2Q = parcelRequire("jiL2Q");

var $dNkcA = parcelRequire("dNkcA");
const $24c010126505783b$export$cc32ef09edf2b5cb = (action$, store)=>action$.ofType((0, $jiL2Q.LOAD_CONFIG_DATA_REQUEST)).mergeMap(()=>(0, $3JafE.Observable).forkJoin((0, $iJu8x.default)((0, $lEnU0.makeServiceContext)(store.getState())), (0, $aISvV.default)(store))).mergeMap(([{ entities: entities, config: config, columns: columns }, additionalBoardData])=>(0, $3JafE.Observable).from([
            (0, $jiL2Q.setConfigData)((0, $6HC1D.merge)({
                entities: entities,
                config: config
            }, additionalBoardData)),
            (0, $jiL2Q.loadConfigDataSuccess)(),
            (0, $dNkcA.setColumns)(columns)
        ])).catch((error)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('backlog.load-config-data.failure', 'Failed to load config data', error);
        return (0, $3JafE.Observable).of((0, $jiL2Q.loadConfigDataFailure)());
    });

});
parcelRegister("aISvV", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bdd341a68462287$export$2e2bcd8739ae039);
parcelRequire("flmol");


var $kTHQb = parcelRequire("kTHQb");

var $hkGxG = parcelRequire("hkGxG");
const $1bdd341a68462287$export$6b468dcfb64c653c = (response, isCompanyManaged)=>({
        config: {
            permissions: !isCompanyManaged ? {
                [(0, $094620879c5e56fa$export$a20ec683078f5f77)]: response.canDeleteIssues
            } : {},
            isInlineCardCreateEnabled: response.isInlineCardCreateEnabled
        }
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1bdd341a68462287$export$2e2bcd8739ae039 = (store)=>{
    const state = store.getState();
    const baseUrl = (0, $hkGxG.getBaseUrl)(state);
    const rapidViewId = (0, $hkGxG.getRapidViewId)(state);
    const isCompanyManaged = (0, $hkGxG.getIsCompanyManaged)(state);
    return (0, $kTHQb.default)(baseUrl, rapidViewId).map((response)=>$1bdd341a68462287$export$6b468dcfb64c653c(response, isCompanyManaged));
};

});
parcelRegister("kTHQb", function(module, exports) {

$parcel$export(module.exports, "default", () => $249cbd2351a0ab84$export$2e2bcd8739ae039);

var $aiRd8 = parcelRequire("aiRd8");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$249cbd2351a0ab84$export$2e2bcd8739ae039 = (baseUrl, rapidViewId)=>(0, $aiRd8.default)(`${baseUrl}/rest/greenhopper/1.0/xboard/work/additionalBoardData?rapidViewId=${rapidViewId}`);

});


parcelRegister("iJu8x", function(module, exports) {

$parcel$export(module.exports, "default", () => $4be28b24266d0794$export$2e2bcd8739ae039);

var $hwbh0 = parcelRequire("hwbh0");
parcelRequire("flmol");

var $4m36T = parcelRequire("4m36T");


var $7TyGu = parcelRequire("7TyGu");

var $ckuqb = parcelRequire("ckuqb");
const $4be28b24266d0794$var$transformEstimationType = (resp)=>{
    const currentStatisticFieldPrefix = (0, $7TyGu.statisticFieldPrefixes).find((statisticFieldPrefix)=>resp?.estimationStatisticConfig?.currentEstimationStatistic?.id?.startsWith(statisticFieldPrefix) ?? false) ?? (0, $7TyGu.ISSUE_COUNT_ID);
    return (0, $7TyGu.statisticFieldToEstimateType)[currentStatisticFieldPrefix] ?? (0, $7TyGu.ISSUE_COUNT);
};
const $4be28b24266d0794$var$transformEstimation = (response)=>({
        isEstimationFeatureEnabled: response?.estimationStatisticConfig?.currentEstimationStatistic?.isEnabled ?? false,
        estimationType: $4be28b24266d0794$var$transformEstimationType(response),
        estimationFieldId: response?.estimationStatisticConfig?.currentEstimationStatistic?.fieldId ?? null,
        name: response?.estimationStatisticConfig?.currentEstimationStatistic?.name ?? ''
    });
const $4be28b24266d0794$export$6b468dcfb64c653c = (resp, isCompanyManaged = false)=>({
        entities: {
            estimation: $4be28b24266d0794$var$transformEstimation(resp),
            quickFilters: resp?.quickFilterConfig?.quickFilters?.map((f)=>({
                    ...f,
                    id: String(f.id)
                })) ?? []
        },
        config: {
            permissions: !isCompanyManaged ? {
                [(0, $094620879c5e56fa$export$b35e3ebf2c83a499)]: resp.canEdit
            } : {},
            backlogStrategy: resp.backlogStrategy,
            epicIssueType: resp?.globalConfig?.epicConfig?.epicIssueTypeId ? {
                id: resp?.globalConfig?.epicConfig?.epicIssueTypeId,
                name: resp?.globalConfig?.epicConfig?.epicIssueTypeName,
                iconUrl: resp?.globalConfig?.epicConfig?.epicIssueTypeIconUrl
            } : null,
            epicLinkField: resp?.globalConfig?.epicConfig?.epicLinkFieldId ? {
                id: resp?.globalConfig?.epicConfig?.epicLinkFieldId,
                name: resp?.globalConfig?.epicConfig?.epicLinkFieldName
            } : null,
            ...isCompanyManaged ? {
                name: resp.name,
                storyPointFieldId: resp?.estimationStatisticConfig?.currentEstimationStatistic?.fieldId || null,
                sprintFieldId: resp?.globalConfig?.sprintConfig?.sprintFieldId,
                timeTrackingOptions: {
                    workingHoursPerDay: resp?.globalConfig?.timeTrackingConfig?.hoursPerDay || (0, $4m36T.defaultTimeTrackingOptions).workingHoursPerDay,
                    workingDaysPerWeek: resp?.globalConfig?.timeTrackingConfig?.daysPerWeek || (0, $4m36T.defaultTimeTrackingOptions).workingDaysPerWeek,
                    timeFormat: resp?.globalConfig?.timeTrackingConfig?.timeFormat || (0, $4m36T.TimeFormats).PRETTY,
                    defaultUnit: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    resp?.globalConfig?.timeTrackingConfig?.defaultUnit?.toLowerCase() || (0, $4m36T.TimeUnits).MINUTE
                }
            } : undefined,
            jqlQuery: resp?.filterConfig?.query,
            isOrderedByRank: resp?.filterConfig?.isOrderedByRank,
            isBoardCrossProject: resp.isBoardCrossProject,
            parallelSprints: resp.globalConfig.parallelSprints,
            showEpicAsPanel: resp.showEpicAsPanel
        },
        columns: (0, (/*@__PURE__*/$parcel$interopDefault($hwbh0)))(resp.rapidListConfig.mappedColumns.map((column)=>column.id), resp.rapidListConfig.mappedColumns.map((column, index)=>({
                id: column.id,
                name: column.name,
                order: index,
                statuses: column.mappedStatuses.map((status)=>({
                        id: status.id,
                        name: status.name,
                        isInitial: status.isInitial,
                        isResolutionDone: status.isResolutionDone,
                        category: status.statusCategory.key
                    }))
            })))
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4be28b24266d0794$export$2e2bcd8739ae039 = (serviceContext)=>(0, $ckuqb.default)(serviceContext.boardId).map((response)=>$4be28b24266d0794$export$6b468dcfb64c653c(response, serviceContext.isCompanyManaged));

});
parcelRegister("ckuqb", function(module, exports) {

$parcel$export(module.exports, "default", () => $be7f9cb9d1e9c974$export$2e2bcd8739ae039);

var $aiRd8 = parcelRequire("aiRd8");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$be7f9cb9d1e9c974$export$2e2bcd8739ae039 = (rapidViewId)=>(0, $aiRd8.default)(`/rest/greenhopper/1.0/rapidviewconfig/editmodel?rapidViewId=${rapidViewId}`);

});


parcelRegister("dNkcA", function(module, exports) {

$parcel$export(module.exports, "SET_COLUMNS", () => $4b58451ae85dfbd0$export$f7b453d5c91bc422);
$parcel$export(module.exports, "setColumns", () => $4b58451ae85dfbd0$export$cfc099c0be5cff67);
const $4b58451ae85dfbd0$export$f7b453d5c91bc422 = 'state.actions.columns.SET_COLUMNS';
const $4b58451ae85dfbd0$export$cfc099c0be5cff67 = (columns)=>({
        type: $4b58451ae85dfbd0$export$f7b453d5c91bc422,
        payload: {
            columns: columns
        }
    });

});


parcelRegister("lpGAK", function(module, exports) {

$parcel$export(module.exports, "loadConfigDataEpicCmp", () => $e4012122f0241a76$export$6c9a22a434be99a2);
parcelRequire("jyKN9");
parcelRequire("9u6v2");
parcelRequire("6og5C");
parcelRequire("flmol");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $3JafE = parcelRequire("3JafE");

var $gUUjF = parcelRequire("gUUjF");

var $4Jddf = parcelRequire("4Jddf");

var $lEnU0 = parcelRequire("lEnU0");

var $jiL2Q = parcelRequire("jiL2Q");
const $e4012122f0241a76$export$6c9a22a434be99a2 = (action$, store)=>action$.ofType((0, $jiL2Q.LOAD_CONFIG_DATA_REQUEST)).mergeMap(()=>(0, $4Jddf.default)((0, $lEnU0.makeServiceContext)(store.getState()))).mergeMap((response)=>(0, $3JafE.Observable).of((0, $jiL2Q.loadConfigDataModelSuccess)(response))).catch((error)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('backlog.load-config-data-cmp.failure', 'Failed to load config data for CMP', error);
        return (0, $3JafE.Observable).of((0, $jiL2Q.loadConfigDataFailure)());
    });

});
parcelRegister("4Jddf", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc64f2972a88e111$export$2e2bcd8739ae039);

var $hwbh0 = parcelRequire("hwbh0");

var $3JafE = parcelRequire("3JafE");
parcelRequire("flmol");

var $4m36T = parcelRequire("4m36T");

var $7TyGu = parcelRequire("7TyGu");

var $lixBu = parcelRequire("lixBu");

var $7eXY0 = parcelRequire("7eXY0");
const $dc64f2972a88e111$var$transformEstimationType = (resp)=>{
    const currentStatisticFieldPrefix = (0, $7TyGu.statisticFieldPrefixes).find((statisticFieldPrefix)=>resp?.estimationStatisticConfig?.currentEstimationStatistic?.id?.startsWith(statisticFieldPrefix) ?? false) ?? (0, $7TyGu.ISSUE_COUNT_ID);
    return (0, $7TyGu.statisticFieldToEstimateType)[currentStatisticFieldPrefix] ?? (0, $7TyGu.ISSUE_COUNT);
};
const $dc64f2972a88e111$var$transformEstimation = (response)=>({
        isEstimationFeatureEnabled: response.estimationStatisticConfig?.currentEstimationStatistic?.isEnabled ?? false,
        estimationType: $dc64f2972a88e111$var$transformEstimationType(response),
        estimationFieldId: response.estimationStatisticConfig?.currentEstimationStatistic?.fieldId ?? null,
        name: response.estimationStatisticConfig?.currentEstimationStatistic?.name ?? ''
    });
const $dc64f2972a88e111$var$transformTracking = (response)=>({
        isEnabled: response.trackingStatisticConfig?.currentTrackingStatistic.isEnabled ?? false,
        typeId: response.trackingStatisticConfig?.currentTrackingStatistic.typeId ?? '',
        fieldId: response.trackingStatisticConfig?.currentTrackingStatistic.fieldId ?? '',
        isValid: response.trackingStatisticConfig?.currentTrackingStatistic.isValid ?? false,
        name: response.trackingStatisticConfig?.currentTrackingStatistic.name ?? ''
    });
const $dc64f2972a88e111$export$6b468dcfb64c653c = (boardConfig, globalConfig, isCompanyManaged = false)=>({
        entities: {
            estimation: $dc64f2972a88e111$var$transformEstimation(boardConfig),
            ...isCompanyManaged ? {
                tracking: $dc64f2972a88e111$var$transformTracking(boardConfig)
            } : {},
            quickFilters: boardConfig.quickFilterConfig?.quickFilters?.map((f)=>({
                    ...f,
                    id: String(f.id)
                })) ?? []
        },
        config: {
            isInlineCardCreateEnabled: boardConfig.isInlineCardCreateEnabled,
            backlogStrategy: boardConfig.backlogStrategy,
            epicIssueType: globalConfig.epicConfig?.epicIssueTypeId ? {
                id: globalConfig.epicConfig?.epicIssueTypeId,
                name: globalConfig.epicConfig?.epicIssueTypeName,
                iconUrl: globalConfig.epicConfig?.epicIssueTypeIconUrl
            } : null,
            epicLinkField: globalConfig.epicConfig?.epicLinkFieldId ? {
                id: globalConfig.epicConfig?.epicLinkFieldId,
                name: globalConfig.epicConfig?.epicLinkFieldName
            } : null,
            ...isCompanyManaged ? {
                name: boardConfig.name,
                epicColorFieldId: globalConfig?.epicConfig?.colorFieldId,
                storyPointFieldId: boardConfig.estimationStatisticConfig?.currentEstimationStatistic?.fieldId || null,
                sprintFieldId: globalConfig.sprintConfig?.sprintFieldId,
                timeTrackingOptions: {
                    workingHoursPerDay: globalConfig.timeTrackingConfig?.hoursPerDay || (0, $4m36T.defaultTimeTrackingOptions).workingHoursPerDay,
                    workingDaysPerWeek: globalConfig.timeTrackingConfig?.daysPerWeek || (0, $4m36T.defaultTimeTrackingOptions).workingDaysPerWeek,
                    timeFormat: globalConfig.timeTrackingConfig?.timeFormat || (0, $4m36T.TimeFormats).PRETTY,
                    defaultUnit: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    globalConfig.timeTrackingConfig?.defaultUnit?.toLowerCase() || (0, $4m36T.TimeUnits).MINUTE
                }
            } : undefined,
            jqlQuery: boardConfig.filterConfig?.query,
            isOrderedByRank: boardConfig.filterConfig?.isOrderedByRank,
            isBoardCrossProject: boardConfig.isBoardCrossProject,
            parallelSprints: boardConfig.parallelSprints,
            showEpicAsPanel: boardConfig.showEpicAsPanel
        },
        columns: (0, (/*@__PURE__*/$parcel$interopDefault($hwbh0)))(boardConfig.rapidListConfig.mappedColumns.map((column)=>column.id), boardConfig.rapidListConfig.mappedColumns.map((column, index)=>({
                id: column.id,
                name: column.name,
                order: index,
                statuses: column.mappedStatuses.map((status)=>({
                        id: status.id,
                        name: status.name,
                        isInitial: status.isInitial,
                        isResolutionDone: status.isResolutionDone,
                        category: status.statusCategory.key
                    }))
            })))
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$dc64f2972a88e111$export$2e2bcd8739ae039 = (serviceContext)=>(0, $3JafE.Observable).forkJoin((0, $lixBu.default)(serviceContext.boardId), (0, $7eXY0.default)()).map(([boardConfigResponse, globalConfigResponse])=>$dc64f2972a88e111$export$6b468dcfb64c653c(boardConfigResponse, globalConfigResponse, serviceContext.isCompanyManaged));

});
parcelRegister("lixBu", function(module, exports) {

$parcel$export(module.exports, "default", () => $9379595cd81d611f$export$2e2bcd8739ae039);

var $aiRd8 = parcelRequire("aiRd8");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9379595cd81d611f$export$2e2bcd8739ae039 = (rapidViewId)=>(0, $aiRd8.default)(`/rest/greenhopper/3/xboard/config?boardId=${rapidViewId}`);

});

parcelRegister("7eXY0", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f83bf792c79d5c7$export$2e2bcd8739ae039);

var $aiRd8 = parcelRequire("aiRd8");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5f83bf792c79d5c7$export$2e2bcd8739ae039 = ()=>(0, $aiRd8.default)('/rest/greenhopper/3/globalconfig');

});



parcelRegister("g1Auf", function(module, exports) {

$parcel$export(module.exports, "loadCurrentUserEpic", () => $35ea378301e5041d$export$9ce838b1f98e9002);

var $3JafE = parcelRequire("3JafE");
parcelRequire("8jBvP");
parcelRequire("8OtG5");
parcelRequire("iects");
parcelRequire("flmol");
parcelRequire("1Lcr1");

var $gUUjF = parcelRequire("gUUjF");

var $3NyXf = parcelRequire("3NyXf");

var $lafvx = parcelRequire("lafvx");

var $hkGxG = parcelRequire("hkGxG");
const $35ea378301e5041d$export$9ce838b1f98e9002 = (action$, store)=>action$.ofType((0, $lafvx.REQUEST_CURRENT_USER)).map(()=>(0, $hkGxG.getAtlassianAccountId)(store.getState())).filter((accountId)=>accountId !== null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .mergeMap((accountId)=>(0, $3NyXf.default)(store, accountId)).map((appData)=>(0, $lafvx.setCurrentUser)(appData)).catch((error)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('backlog.load-current-user.failure', 'Failed to load current user data', error);
        // no error flag, as this data is not critical for application
        return (0, $3JafE.Observable).empty();
    });

});
parcelRegister("3NyXf", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e5800e82562c177$export$2e2bcd8739ae039);
parcelRequire("flmol");

var $cqcrX = parcelRequire("cqcrX");

var $hkGxG = parcelRequire("hkGxG");
const $4e5800e82562c177$export$6b468dcfb64c653c = (response)=>({
        id: response.accountId,
        displayName: response.displayName,
        avatarUrl: response.avatarUrls['48x48']
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4e5800e82562c177$export$2e2bcd8739ae039 = (store, accountId)=>{
    const state = store.getState();
    const baseUrl = (0, $hkGxG.getBaseUrl)(state);
    return (0, $cqcrX.default)(baseUrl, accountId).map($4e5800e82562c177$export$6b468dcfb64c653c);
};

});
parcelRegister("cqcrX", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f858a0a42447e06$export$2e2bcd8739ae039);

var $aiRd8 = parcelRequire("aiRd8");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2f858a0a42447e06$export$2e2bcd8739ae039 = (baseUrl, accountId)=>(0, $aiRd8.default)(`${baseUrl}/rest/api/2/user?accountId=${accountId}`);

});


parcelRegister("lafvx", function(module, exports) {

$parcel$export(module.exports, "REQUEST_CURRENT_USER", () => $cf6e07c29d5f373a$export$23c24718e49aca5d);
$parcel$export(module.exports, "SET_CURRENT_USER", () => $cf6e07c29d5f373a$export$c6dfa1844d1d3b74);
$parcel$export(module.exports, "requestCurrentUser", () => $cf6e07c29d5f373a$export$96fd75d854a9dd1);
$parcel$export(module.exports, "setCurrentUser", () => $cf6e07c29d5f373a$export$64e99e757b084e7c);
const $cf6e07c29d5f373a$export$23c24718e49aca5d = 'state.actions.user.REQUEST_CURRENT_USER';
const $cf6e07c29d5f373a$export$c6dfa1844d1d3b74 = 'state.actions.user.SET_CURRENT_USER';
const $cf6e07c29d5f373a$export$96fd75d854a9dd1 = ()=>({
        type: $cf6e07c29d5f373a$export$23c24718e49aca5d
    });
const $cf6e07c29d5f373a$export$64e99e757b084e7c = (payload)=>({
        type: $cf6e07c29d5f373a$export$c6dfa1844d1d3b74,
        payload: payload
    });

});


parcelRegister("2mfJC", function(module, exports) {

$parcel$export(module.exports, "loadIssueParentsEpic", () => $bac62db806bc6426$export$62d699ac6a7d88af);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("iects");
parcelRequire("flmol");
parcelRequire("1Lcr1");

var $gUUjF = parcelRequire("gUUjF");

var $87pVm = parcelRequire("87pVm");

var $jiL2Q = parcelRequire("jiL2Q");

var $k0iqO = parcelRequire("k0iqO");

var $hkGxG = parcelRequire("hkGxG");
const $bac62db806bc6426$var$logFailureKey = 'backlog.load-issue-parents.failure';
const $bac62db806bc6426$export$62d699ac6a7d88af = (action$, store)=>action$.ofType((0, $jiL2Q.LOAD_CONFIG_DATA_REQUEST)).flatMap(()=>{
        const state = store.getState();
        const boardId = (0, $hkGxG.getRapidViewId)(state);
        return (0, $87pVm.default)(boardId).map((0, $k0iqO.loadIssueParentsSuccess)).catch((error)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData($bac62db806bc6426$var$logFailureKey, 'Failed to load issue parents from REST', error);
            return (0, $3JafE.Observable).of((0, $k0iqO.loadIssueParentsFailure)());
        });
    });

});
parcelRegister("87pVm", function(module, exports) {

$parcel$export(module.exports, "default", () => $b070232e5fc0a1ee$export$2e2bcd8739ae039);

var $lPQPn = parcelRequire("lPQPn");

var $gbtwl = parcelRequire("gbtwl");
parcelRequire("flmol");
const $b070232e5fc0a1ee$export$6b468dcfb64c653c = (response)=>response.epics.values.map(({ id: id, key: key, summary: summary, issueTypeDetails: issueTypeDetails, color: color, epicColor: epicColor })=>({
            id: String(id),
            key: key,
            summary: summary,
            issueType: {
                id: issueTypeDetails.id,
                name: issueTypeDetails.name,
                iconUrl: issueTypeDetails.iconUrl
            },
            color: (0, $lPQPn.asColor)(color || epicColor)
        }));
const $b070232e5fc0a1ee$var$loadEpicsService = (boardId)=>(0, $gbtwl.loadIssueParents)(boardId).map($b070232e5fc0a1ee$export$6b468dcfb64c653c);
var $b070232e5fc0a1ee$export$2e2bcd8739ae039 = $b070232e5fc0a1ee$var$loadEpicsService;

});
parcelRegister("gbtwl", function(module, exports) {

$parcel$export(module.exports, "loadIssueParents", () => $5404166075adee57$export$ff3ebd776b98f924);

var $aiRd8 = parcelRequire("aiRd8");
function $5404166075adee57$export$ff3ebd776b98f924(boardId) {
    return (0, $aiRd8.default)(`/rest/greenhopper/1.0/xboard/plan/v2/backlog/epics.json?rapidViewId=${boardId}`);
}

});


parcelRegister("k0iqO", function(module, exports) {

$parcel$export(module.exports, "LOAD_ISSUE_PARENTS_SUCCESS", () => $fa40d1ecce9379f7$export$c4816ca6503594af);
$parcel$export(module.exports, "loadIssueParentsSuccess", () => $fa40d1ecce9379f7$export$690a91ea1d3856a7);
$parcel$export(module.exports, "loadIssueParentsFailure", () => $fa40d1ecce9379f7$export$a69a6037d2ab7dc4);
const $fa40d1ecce9379f7$export$c4816ca6503594af = 'state.actions.app.LOAD_ISSUE_PARENTS_SUCCESS';
const $fa40d1ecce9379f7$export$690a91ea1d3856a7 = (issueParents)=>({
        type: $fa40d1ecce9379f7$export$c4816ca6503594af,
        payload: {
            issueParents: issueParents
        }
    });
const $fa40d1ecce9379f7$export$10fa8c4c0ecf4112 = 'state.actions.app.LOAD_ISSUE_PARENTS_FAILURE';
const $fa40d1ecce9379f7$export$a69a6037d2ab7dc4 = ()=>({
        type: $fa40d1ecce9379f7$export$10fa8c4c0ecf4112
    });

});


parcelRegister("71I3R", function(module, exports) {

$parcel$export(module.exports, "loadMentionsEpic", () => $52c9209d5fb6a70e$export$a478e9eaec78181c);
parcelRequire("8jBvP");
parcelRequire("3wBUP");
parcelRequire("1Lcr1");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");

var $gUUjF = parcelRequire("gUUjF");

var $54KLf = parcelRequire("54KLf");

var $jiL2Q = parcelRequire("jiL2Q");

var $5Hc4j = parcelRequire("5Hc4j");

var $bP7Jx = parcelRequire("bP7Jx");
function $52c9209d5fb6a70e$export$a478e9eaec78181c(action$, store) {
    return action$.ofType((0, $jiL2Q.LOAD_CONFIG_DATA_SUCCESS), (0, $jiL2Q.LOAD_CONFIG_DATA_MODEL_SUCCESS), (0, $jiL2Q.SET_APP_DATA)).switchMap(()=>{
        const state = store.getState();
        const issueIds = (0, $bP7Jx.getCardIds)(state);
        return (0, $54KLf.mentionsService)(issueIds).mergeMap((result)=>(0, $3JafE.Observable).of((0, $5Hc4j.mentionsLoadSuccess)(result))).catch((error)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData('backlog.load-mentions-epic.failure', 'Failed to load mentions data from REST', error);
            return (0, $3JafE.Observable).empty();
        });
    });
}

});
parcelRegister("54KLf", function(module, exports) {

$parcel$export(module.exports, "mentionsService", () => $906a900671e24065$export$a70c1d0439b6bb0e);

var $aiRd8 = parcelRequire("aiRd8");
function $906a900671e24065$export$a70c1d0439b6bb0e(issueIds) {
    return (0, $aiRd8.default)('/rest/internal/latest/mentions', {
        method: 'POST',
        body: JSON.stringify(issueIds)
    });
}

});


parcelRegister("fdugg", function(module, exports) {

$parcel$export(module.exports, "loadPermissionsEpic", () => $f76e572a2fdc35e0$export$f7fed3a68920cb18);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("iects");
parcelRequire("flmol");
parcelRequire("1Lcr1");

var $gUUjF = parcelRequire("gUUjF");

var $4slwy = parcelRequire("4slwy");

var $jiL2Q = parcelRequire("jiL2Q");

var $4GiZ2 = parcelRequire("4GiZ2");

var $hkGxG = parcelRequire("hkGxG");
const $f76e572a2fdc35e0$var$loadPermissions = ({ store: store })=>{
    const state = store.getState();
    const boardId = (0, $hkGxG.getRapidViewId)(state);
    return (0, $4slwy.loadPermissionsService)(boardId).map((0, $4GiZ2.fetchPermissionsSuccess)).catch((error)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('backlog.load-permission.failure', 'Failed to fetch permissions for Company-Managed backlog', error);
        return (0, $3JafE.Observable).of((0, $4GiZ2.fetchPermissionsFailure)());
    });
};
const $f76e572a2fdc35e0$export$f7fed3a68920cb18 = (action$, store)=>action$.ofType((0, $jiL2Q.LOAD_APP_DATA_REQUEST)).flatMap(()=>$f76e572a2fdc35e0$var$loadPermissions({
            store: store
        }));

});
parcelRegister("4slwy", function(module, exports) {

$parcel$export(module.exports, "loadPermissionsService", () => $a1380af6e7efc7d5$export$4c653019d1c2f19f);
parcelRequire("flmol");

var $dd9o5 = parcelRequire("dd9o5");

var $6jS8m = parcelRequire("6jS8m");

var $9oMOk = parcelRequire("9oMOk");
const $a1380af6e7efc7d5$var$toBacklogPermissions = (response)=>(0, $dd9o5.fromServicePermission)(response.boardPermissions);
const $a1380af6e7efc7d5$export$4c653019d1c2f19f = (boardId)=>(0, $9oMOk.fetchPermissions)(boardId, (0, $6jS8m.getDefaultCompanyManagedPermissions)()).map($a1380af6e7efc7d5$var$toBacklogPermissions);

});
parcelRegister("dd9o5", function(module, exports) {

$parcel$export(module.exports, "fromServicePermission", () => $ccbe3c400af911a0$export$b37c57dce4c43c62);

var $cnRoI = parcelRequire("cnRoI");

var $7TyGu = parcelRequire("7TyGu");

const $ccbe3c400af911a0$var$serviceToBacklogPermissions = {
    [(0, $7TyGu.VIEW_BOARD)]: (0, $094620879c5e56fa$export$feb9a4de117c162),
    [(0, $7TyGu.ADMINISTER_BOARD)]: (0, $094620879c5e56fa$export$b35e3ebf2c83a499),
    [(0, $7TyGu.BULK_CHANGE)]: (0, $094620879c5e56fa$export$a71edb30f3453bef),
    [(0, $7TyGu.MANAGE_SPRINT)]: (0, $094620879c5e56fa$export$d765836bd761b2ee),
    [(0, $7TyGu.CREATE_ISSUE)]: (0, $094620879c5e56fa$export$526c94c551c00291),
    [(0, $7TyGu.EDIT_ISSUE)]: (0, $094620879c5e56fa$export$8a1ecb9983951227),
    [(0, $7TyGu.DELETE_ISSUE)]: (0, $094620879c5e56fa$export$a20ec683078f5f77),
    [(0, $7TyGu.ASSIGN_ISSUE)]: (0, $094620879c5e56fa$export$9c0523cef5fab15e),
    [(0, $7TyGu.TRANSITION_ISSUE)]: (0, $094620879c5e56fa$export$b5f3bd28b6a935be)
};
const $ccbe3c400af911a0$export$b37c57dce4c43c62 = (permissions)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, (/*@__PURE__*/$parcel$interopDefault($cnRoI)))(permissions, (value, key)=>$ccbe3c400af911a0$var$serviceToBacklogPermissions[key]);

});

parcelRegister("6jS8m", function(module, exports) {

$parcel$export(module.exports, "getDefaultCompanyManagedPermissions", () => $1aad1eabd7c32b61$export$125a09606aa6423a);

var $7TyGu = parcelRequire("7TyGu");
const $1aad1eabd7c32b61$export$125a09606aa6423a = ()=>[
        (0, $7TyGu.VIEW_BOARD),
        (0, $7TyGu.ADMINISTER_BOARD),
        (0, $7TyGu.BULK_CHANGE),
        (0, $7TyGu.DELETE_ISSUE),
        (0, $7TyGu.EDIT_ISSUE),
        (0, $7TyGu.CREATE_ISSUE),
        (0, $7TyGu.ASSIGN_ISSUE),
        (0, $7TyGu.TRANSITION_ISSUE),
        (0, $7TyGu.MANAGE_SPRINT)
    ];

});

parcelRegister("9oMOk", function(module, exports) {

$parcel$export(module.exports, "fetchPermissions", () => $0675636d2520a138$export$4f24ecba11982e9d);

var $aiRd8 = parcelRequire("aiRd8");
function $0675636d2520a138$export$4f24ecba11982e9d(boardId, permissions = []) {
    return (0, $aiRd8.default)(`/rest/greenhopper/1.0/xboard/permissions?boardId=${boardId}&permissions=${permissions.join(',')}`);
}

});


parcelRegister("4GiZ2", function(module, exports) {

$parcel$export(module.exports, "FETCH_PERMISSIONS_SUCCESS", () => $34b4ec2ba197f0d4$export$ba150518109978de);
$parcel$export(module.exports, "fetchPermissionsSuccess", () => $34b4ec2ba197f0d4$export$9ea81e209e5fa95a);
$parcel$export(module.exports, "fetchPermissionsFailure", () => $34b4ec2ba197f0d4$export$81c33c1b0d6e16b1);
const $34b4ec2ba197f0d4$export$ba150518109978de = 'state.actions.permissions.FETCH_PERMISSIONS_SUCCESS';
const $34b4ec2ba197f0d4$export$9ea81e209e5fa95a = (permissions)=>({
        type: $34b4ec2ba197f0d4$export$ba150518109978de,
        payload: {
            permissions: permissions
        }
    });
const $34b4ec2ba197f0d4$export$87e65d60f042b0d0 = 'state.actions.permissions.FETCH_PERMISSIONS_FAILURE';
const $34b4ec2ba197f0d4$export$81c33c1b0d6e16b1 = ()=>({
        type: $34b4ec2ba197f0d4$export$87e65d60f042b0d0
    });

});


parcelRegister("48X9m", function(module, exports) {

$parcel$export(module.exports, "loadPlanDataEpic", () => $3b7d24d922dbcd93$export$e0e3208a5652318a);

var $3JafE = parcelRequire("3JafE");
parcelRequire("8jBvP");
parcelRequire("cpH8E");
parcelRequire("YLEHo");
parcelRequire("jyKN9");
parcelRequire("iects");
parcelRequire("flmol");
parcelRequire("1Lcr1");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $9H3i5 = parcelRequire("9H3i5");

var $lkfU5 = parcelRequire("lkfU5");

var $a5ySG = parcelRequire("a5ySG");

var $jiL2Q = parcelRequire("jiL2Q");

var $hkGxG = parcelRequire("hkGxG");

var $kdGmo = parcelRequire("kdGmo");
const $3b7d24d922dbcd93$var$fetchData = ({ store: store, prefetchedData: prefetchedData, refreshData: refreshData, storeFieldsActions: storeFieldsActions })=>{
    const state = store.getState();
    const isCompanyManaged = (0, $hkGxG.getIsCompanyManaged)(state);
    const epicIssueType = (0, $hkGxG.getEpicIssueType)(state);
    const activeQuickFilters = (0, $kdGmo.getAppliedCustomFilters)(state) ?? (0, $9H3i5.getCustomFilterFromUrlQuery)(window.location);
    if (prefetchedData) {
        const refresh$ = (0, $1ybV0.ff)('jsw.perf.enable-indexeddb-caching-for-backlog') && refreshData ? (0, $3JafE.Observable).fromPromise(refreshData) : (0, $3JafE.Observable).empty();
        const refreshAction$ = refresh$.flatMap((data)=>(0, $3JafE.Observable).of((0, $jiL2Q.setAppData)((0, $a5ySG.transformPlanData)(data, isCompanyManaged, activeQuickFilters))));
        return (0, $3JafE.Observable).merge((0, $3JafE.Observable).of((0, $jiL2Q.setAppData)((0, $a5ySG.transformPlanData)(prefetchedData, isCompanyManaged, activeQuickFilters))), refreshAction$);
    }
    const boardId = (0, $hkGxG.getRapidViewId)(state);
    return (0, $lkfU5.loadPlanDataService)({
        boardId: boardId,
        isCompanyManaged: isCompanyManaged,
        activeQuickFilters: activeQuickFilters,
        epicIssueType: epicIssueType,
        storeFieldsActions: storeFieldsActions
    }).map((0, $jiL2Q.setAppData)).catch((error)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('backlog.load-plan-data.failure', 'Failed to load plan data from REST', error);
        return (0, $3JafE.Observable).of((0, $jiL2Q.loadAppDataFailure)());
    });
};
const $3b7d24d922dbcd93$export$e0e3208a5652318a = (action$, store, dependencies)=>action$.ofType((0, $jiL2Q.LOAD_APP_DATA_REQUEST)).flatMap(({ payload: payload })=>$3b7d24d922dbcd93$var$fetchData({
            store: store,
            prefetchedData: (0, $1ybV0.ff)('jsw.perf.enable-indexeddb-caching-for-backlog') ? payload.prefetchCmpBacklogData?.result : payload.prefetchedJiraPlanRestData,
            refreshData: (0, $1ybV0.ff)('jsw.perf.enable-indexeddb-caching-for-backlog') ? payload.prefetchCmpBacklogData?.refresh : null,
            storeFieldsActions: payload.storeFieldsActions || dependencies?.storeFieldsActions
        }));

});

parcelRegister("fVGud", function(module, exports) {

$parcel$export(module.exports, "oldLoadPrioritiesEpic", () => $cbe199cab715c905$export$5f040894e9be4e25);
$parcel$export(module.exports, "loadPrioritiesEpic", () => $cbe199cab715c905$export$20ae9bff1fb86dc1);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("iects");
parcelRequire("flmol");
parcelRequire("1Lcr1");

var $gUUjF = parcelRequire("gUUjF");

var $3rZF3 = parcelRequire("3rZF3");

var $jiL2Q = parcelRequire("jiL2Q");

var $eYeFr = parcelRequire("eYeFr");

var $hkGxG = parcelRequire("hkGxG");
const $cbe199cab715c905$export$5f040894e9be4e25 = (action$)=>action$.ofType((0, $eYeFr.LOAD_PRIORITIES_REQUEST)).flatMap(()=>(0, $3rZF3.fetchPriorities)().map((0, $eYeFr.loadPrioritiesSuccess)).catch((error)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData('backlog.load-priorities.failure', 'Failed to load priorities from REST', error);
            return (0, $3JafE.Observable).of((0, $eYeFr.loadPrioritiesFailure)());
        }));
const $cbe199cab715c905$export$20ae9bff1fb86dc1 = (action$, store)=>action$.ofType((0, $jiL2Q.SET_APP_DATA), (0, $eYeFr.LOAD_PRIORITIES_REQUEST)).flatMap(()=>{
        const state = store.getState();
        const projectIds = (0, $hkGxG.getProjectAris)(state);
        return (0, $3rZF3.fetchAllPriorities)(projectIds).map((0, $eYeFr.loadPrioritiesSuccess)).catch((error)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData('backlog.load-priorities.failure', 'Failed to load priorities from REST', error);
            return (0, $3JafE.Observable).of((0, $eYeFr.loadPrioritiesFailure)());
        });
    });

});
parcelRegister("3rZF3", function(module, exports) {

$parcel$export(module.exports, "fetchAllPriorities", () => $838ed34a921ac29b$export$910988adc9be7f87);
$parcel$export(module.exports, "fetchPriorities", () => $838ed34a921ac29b$export$36e6009f97ceaf16);
parcelRequire("6og5C");
parcelRequire("flmol");

var $aiRd8 = parcelRequire("aiRd8");

/**
 * @deprecated
 *  This is deprecated use {@link transformer} instead.
 *  TODO: Clean up transformerOld when cleaning up 'priorities.per.project.backlog-contextual-menu' feature flag
 */ const $838ed34a921ac29b$var$transformerOld = (priorities)=>priorities.map((priority)=>({
            id: priority.id,
            name: priority.name,
            iconUrl: priority.iconUrl
        }));
const $838ed34a921ac29b$export$6b468dcfb64c653c = (priorities)=>{
    const allPriorities = priorities.data.jira.jiraProjects.map((project)=>project.priorityScheme.priorities.edges.map((edge)=>({
                id: edge.node.priorityId,
                name: edge.node.name,
                iconUrl: edge.node.iconUrl
            })));
    const intersectingPriorities = allPriorities.reduce((prioritiesA, prioritiesB)=>prioritiesA.filter((priorityA)=>prioritiesB.some((priorityB)=>priorityA.id === priorityB.id)));
    return intersectingPriorities;
};
const $838ed34a921ac29b$export$910988adc9be7f87 = (projectIds)=>(0, $aiRd8.default)(`${(0, $28bde84745763507$export$4159899b2a5c63f2)}?operation=${(0, $28bde84745763507$export$21c589a2cbb3ede0)}`, {
        method: 'post',
        body: JSON.stringify({
            query: (0, $28bde84745763507$export$4459165bea9549c9),
            variables: {
                projectIds: projectIds
            }
        })
    }).map($838ed34a921ac29b$export$6b468dcfb64c653c);
const $838ed34a921ac29b$export$36e6009f97ceaf16 = ()=>(0, $aiRd8.default)((0, $28bde84745763507$export$2ef9cfdcc1cda82e)).map($838ed34a921ac29b$var$transformerOld);

});
// To support the priorities per project feature we need to use the /rest/api/3/priority/search endpoint instead: https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-issue-priorities/#api-rest-api-3-priority-search-get
const $28bde84745763507$export$4159899b2a5c63f2 = '/rest/gira/1/';
const $28bde84745763507$export$21c589a2cbb3ede0 = 'BacklogCardListPrioritiesQuery';
const $28bde84745763507$export$4459165bea9549c9 = `
query ${$28bde84745763507$export$21c589a2cbb3ede0} ($projectIds: [ID!]!) {
    jira {
        jiraProjects(ids: $projectIds) {
          priorityScheme {
            priorities {
              edges {
                node {
                  priorityId
                  name
                  iconUrl
                }
              }
            }
          }
        }
      }
}
`;
const $28bde84745763507$export$2ef9cfdcc1cda82e = '/rest/api/2/priority';


parcelRegister("eYeFr", function(module, exports) {

$parcel$export(module.exports, "LOAD_PRIORITIES_REQUEST", () => $597443b2ccf428c5$export$ec0e161fbc75b17);
$parcel$export(module.exports, "loadPriorities", () => $597443b2ccf428c5$export$298a3cca1db04fc7);
$parcel$export(module.exports, "LOAD_PRIORITIES_SUCCESS", () => $597443b2ccf428c5$export$8e601591d139ea1e);
$parcel$export(module.exports, "loadPrioritiesSuccess", () => $597443b2ccf428c5$export$8c198db10c34eeae);
$parcel$export(module.exports, "loadPrioritiesFailure", () => $597443b2ccf428c5$export$db7c0221961bec8a);
$parcel$export(module.exports, "CARD_PRIORITY_SET", () => $597443b2ccf428c5$export$81f23650b1079e);
$parcel$export(module.exports, "cardPrioritySet", () => $597443b2ccf428c5$export$2054774d4090891c);
$parcel$export(module.exports, "CARD_PRIORITY_SET_OPTIMISTIC", () => $597443b2ccf428c5$export$2357c19e39838a71);
$parcel$export(module.exports, "cardPrioritySetOptimistic", () => $597443b2ccf428c5$export$df682081f15f18be);

var $lO4Or = parcelRequire("lO4Or");

var $kfH46 = parcelRequire("kfH46");
const $597443b2ccf428c5$export$ec0e161fbc75b17 = 'state.actions.priorities.LOAD_PRIORITIES_REQUEST';
const $597443b2ccf428c5$export$298a3cca1db04fc7 = ()=>({
        type: $597443b2ccf428c5$export$ec0e161fbc75b17
    });
const $597443b2ccf428c5$export$8e601591d139ea1e = 'state.actions.priorities.LOAD_PRIORITY_SUCCESS';
const $597443b2ccf428c5$export$8c198db10c34eeae = (response)=>({
        type: $597443b2ccf428c5$export$8e601591d139ea1e,
        payload: response
    });
const $597443b2ccf428c5$export$9f00fd43080ad118 = 'state.actions.priorities.LOAD_PRIORITY_FAILURE';
const $597443b2ccf428c5$export$db7c0221961bec8a = ()=>({
        type: $597443b2ccf428c5$export$9f00fd43080ad118
    });
const $597443b2ccf428c5$export$81f23650b1079e = 'state.actions.priorities.CARD_PRIORITY_SET';
const $597443b2ccf428c5$export$2054774d4090891c = (payload)=>({
        type: $597443b2ccf428c5$export$81f23650b1079e,
        payload: payload
    });
const $597443b2ccf428c5$export$2357c19e39838a71 = 'state.actions.priorities.CARD_PRIORITY_SET_OPTIMISTIC';
const $597443b2ccf428c5$export$df682081f15f18be = (payload, issueKey, analyticsEvent)=>({
        type: $597443b2ccf428c5$export$2357c19e39838a71,
        payload: payload,
        meta: {
            ...(0, $kfH46.setCardSetMeta)({
                fieldId: (0, $lO4Or.PRIORITY_TYPE),
                issueKey: issueKey,
                newValue: payload.priority,
                retryAction: ()=>$597443b2ccf428c5$export$df682081f15f18be(payload, issueKey, analyticsEvent)
            }, analyticsEvent)
        }
    });

});


parcelRegister("bJQJr", function(module, exports) {

$parcel$export(module.exports, "onCloseInsightsEpic", () => $0573c1ce37e8f3b9$export$89929865228bcbd8);
$parcel$export(module.exports, "onTogglePanelEpic", () => $0573c1ce37e8f3b9$export$f59322268512fa6c);
parcelRequire("9u6v2");
parcelRequire("8jBvP");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");

var $8wXFi = parcelRequire("8wXFi");



var $iYUz7 = parcelRequire("iYUz7");

var $ee93g = parcelRequire("ee93g");

var $Z90Qs = parcelRequire("Z90Qs");

var $a9os4 = parcelRequire("a9os4");

var $hkGxG = parcelRequire("hkGxG");

var $cYLrD = parcelRequire("cYLrD");
const $0573c1ce37e8f3b9$export$89929865228bcbd8 = (getLocation, replace)=>(action$, store)=>action$.ofType((0, $a9os4.CLOSE_INSIGHTS_PANEL)).mergeMap((action)=>{
            const state = store.getState();
            if (action.payload && action.payload.shouldUpdateLocation) // We only set the URL if this action is called with `shouldUpdateLocation`
            // Mainly because there is a case user will click on an issue and it auto close the insights panel
            // In this action we will fire two actions.
            // 1. Update the URL selected issue,
            // 2. Update the URL for insights panel.
            // However, these two actions fire at one cycle, and we can't get the updated route location if we fire both actions
            // at the same time. Therefore, the second push action (here) which update the URL will override the first push action,
            // it cause the URL is not changed after we select an issue.
            // Therefore, we will fire all the update to the URL in one push on when the issue card is clicked.
            replace((0, $Z90Qs.setPanelsUrl)((0, $5a6592135d519f1e$export$61119f100c357d06), false, getLocation()));
            // Make sure Insights is removed from the local storage
            (0, $iYUz7.unsetPanelState)((0, $d36e2c37d06c83ff$export$29d7f2210b16d662), (0, $hkGxG.getRapidViewId)(state));
            return (0, $3JafE.Observable).empty();
        });
const $0573c1ce37e8f3b9$export$f59322268512fa6c = (getLocation, replace)=>(action$, store)=>action$.ofType((0, $a9os4.TOGGLE_PANEL)).mergeMap((action)=>{
            const { panel: panel } = action.payload;
            const state = store.getState();
            if (panel === (0, $d36e2c37d06c83ff$export$29d7f2210b16d662)) {
                const isInsightsOpen = (0, $ee93g.isInsightsPanelOpen)();
                const isViewSettingsPanelOpen = (0, $cYLrD.getViewSettingsPanel)(state);
                replace((0, $Z90Qs.setPanelsUrl)((0, $5a6592135d519f1e$export$61119f100c357d06), !isInsightsOpen, getLocation()));
                if ((0, $8wXFi.isViewSettingAsPanelExpEnabledWithNoExposure)() && isViewSettingsPanelOpen) return (0, $3JafE.Observable).of((0, $a9os4.closeViewSettingsPanel)());
            }
            if ((0, $8wXFi.isViewSettingAsPanelExpEnabledWithNoExposure)() && panel === (0, $d36e2c37d06c83ff$export$ba1da943283b9900)) return (0, $3JafE.Observable).of((0, $a9os4.closeInsightsPanel)(true));
            return (0, $3JafE.Observable).empty();
        });

});
const $d36e2c37d06c83ff$export$a10c132b86ae798b = 'ISSUE_PARENT_PANEL';
const $d36e2c37d06c83ff$export$41073ac826c57195 = 'VERSION_PANEL';
const $d36e2c37d06c83ff$export$29d7f2210b16d662 = 'INSIGHTS_PANEL';
const $d36e2c37d06c83ff$export$ba1da943283b9900 = 'VIEW_SETTINGS_PANEL';

parcelRegister("ee93g", function(module, exports) {

$parcel$export(module.exports, "isIssueParentPanelOpen", () => $39d6dd427bed7a5c$export$aba8540b0819f844);
$parcel$export(module.exports, "isVersionPanelOpen", () => $39d6dd427bed7a5c$export$6387d97dce325d43);
$parcel$export(module.exports, "isInsightsPanelOpen", () => $39d6dd427bed7a5c$export$597778e52dd2f97b);

var $53ciZ = parcelRequire("53ciZ");


var $iYUz7 = parcelRequire("iYUz7");
const $39d6dd427bed7a5c$export$d4d8b30943776734 = (currentPanel, panelFromLocalStorage)=>currentPanel === panelFromLocalStorage ? null : currentPanel;
const $39d6dd427bed7a5c$export$b057090d6eb17ec2 = (currentPanel, boardId)=>{
    if (boardId) {
        const panelStateFromLocalStorage = (0, $iYUz7.getPanelState)(boardId);
        panelStateFromLocalStorage?.includes(currentPanel) ? (0, $iYUz7.unsetPanelState)(currentPanel, boardId) : (0, $iYUz7.setPanelState)(currentPanel, boardId);
    } else {
        const panelStateFromLocalStorage = (0, $iYUz7.getPanelStateOld)();
        (0, $iYUz7.setPanelStateOld)($39d6dd427bed7a5c$export$d4d8b30943776734(currentPanel, panelStateFromLocalStorage));
    }
};
const $39d6dd427bed7a5c$export$aba8540b0819f844 = (location)=>{
    const queryParams = (0, $53ciZ.parse)(location ? location.search : window.location.search);
    return queryParams[0, $5a6592135d519f1e$export$ec3c43b997309252] === 'visible';
};
const $39d6dd427bed7a5c$export$6387d97dce325d43 = (location)=>{
    const queryParams = (0, $53ciZ.parse)(location ? location.search : window.location.search);
    return queryParams[0, $5a6592135d519f1e$export$a86c1a6dde9da34f] === 'visible';
};
const $39d6dd427bed7a5c$export$597778e52dd2f97b = ()=>{
    // This is used in the old version and new version
    const queryParams = (0, $53ciZ.parse)(window.location.search);
    return queryParams[0, $5a6592135d519f1e$export$61119f100c357d06] === 'true';
};

});

parcelRegister("cYLrD", function(module, exports) {

$parcel$export(module.exports, "getPanels", () => $0b98db0756f5d299$export$be078297eeb6e8a2);
$parcel$export(module.exports, "getEpicPanel", () => $0b98db0756f5d299$export$9680a3ff98a72c33);
$parcel$export(module.exports, "getInsightsPanel", () => $0b98db0756f5d299$export$806d34b644f1954d);
$parcel$export(module.exports, "getViewSettingsPanel", () => $0b98db0756f5d299$export$a0b20e22a1f77091);

var $8wXFi = parcelRequire("8wXFi");

const $0b98db0756f5d299$export$be078297eeb6e8a2 = (state)=>state.ui.panels;
const $0b98db0756f5d299$export$9680a3ff98a72c33 = (state)=>state.ui.panels[0, $d36e2c37d06c83ff$export$a10c132b86ae798b] || false;
const $0b98db0756f5d299$export$893e9e519770bdb0 = (state)=>state.ui.panels[0, $d36e2c37d06c83ff$export$41073ac826c57195] || false;
const $0b98db0756f5d299$export$806d34b644f1954d = (state)=>state.ui.panels[0, $d36e2c37d06c83ff$export$29d7f2210b16d662] || false;
const $0b98db0756f5d299$export$a0b20e22a1f77091 = (state)=>(0, $8wXFi.isViewSettingAsPanelExpEnabledWithNoExposure)() && state.ui.panels[0, $d36e2c37d06c83ff$export$ba1da943283b9900] || false;

});


parcelRegister("dIb9y", function(module, exports) {

$parcel$export(module.exports, "selectIssueParentEpic", () => $c00afa500ac252c1$export$f716b183f4055d82);
parcelRequire("9u6v2");
parcelRequire("8jBvP");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");

var $e3Gc5 = parcelRequire("e3Gc5");

var $1HfeQ = parcelRequire("1HfeQ");

var $K2SiM = parcelRequire("K2SiM");

var $k734R = parcelRequire("k734R");
const $c00afa500ac252c1$export$f716b183f4055d82 = (getLocation, push)=>(action$, store)=>action$.ofType((0, $1HfeQ.PARENT_CLICK)).mergeMap((action)=>{
            const state = store.getState();
            const { cardId: cardId } = action.payload;
            const issueParents = (0, $k734R.getIssueParents)(state);
            const parentCardId = issueParents[String(cardId)] ? issueParents[String(cardId)].key : null;
            if (!parentCardId) return (0, $3JafE.Observable).empty();
            const actions = [
                (0, $1HfeQ.cardSingleSelect)(cardId),
                (0, $K2SiM.openDetailView)(cardId)
            ];
            push((0, $e3Gc5.addSelectedIssueToUrl)(parentCardId, getLocation()));
            return (0, $3JafE.Observable).from(actions);
        });

});

parcelRegister("hXqpd", function(module, exports) {

$parcel$export(module.exports, "postLoadCleanDataEpic", () => $0663855f3099e54e$export$6404a6651653bf5a);

var $3JafE = parcelRequire("3JafE");
parcelRequire("9u6v2");
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("iects");

var $jiL2Q = parcelRequire("jiL2Q");

var $1HfeQ = parcelRequire("1HfeQ");

var $bP7Jx = parcelRequire("bP7Jx");
const $0663855f3099e54e$export$6404a6651653bf5a = (action$, store)=>// @ts-expect-error - TS2345: Types of property 'type' are incompatible. Type 'state.actions.cards.selection.CARD_MULTI_SELECT' is not assignable to type 'state.actions.cards.selection.CARD_EMPTY_SELECTION'.
    action$.ofType((0, $jiL2Q.SET_APP_DATA)).flatMap(()=>{
        const state = store.getState();
        const actions = [];
        // remove deleted issues from the list
        const cardIds = Object.keys((0, $bP7Jx.getCards)(state)).map((id)=>Number(id));
        const selectedCards = (0, $bP7Jx.getSelectedCards)(state);
        if (selectedCards.length === 0) return (0, $3JafE.Observable).empty();
        const existingSelectedCards = selectedCards.filter((cardId)=>cardIds.includes(cardId));
        const relativeCard = (0, $bP7Jx.getListSelectionRelativeCard)(state);
        if (existingSelectedCards.length !== selectedCards.length) {
            if (existingSelectedCards.length === 0) return (0, $3JafE.Observable).of((0, $1HfeQ.cardEmptySelection)());
            actions.push((0, $1HfeQ.cardMultiSelect)(existingSelectedCards));
        }
        if (relativeCard && existingSelectedCards.length > 0 && !existingSelectedCards.includes(relativeCard)) actions.push((0, $1HfeQ.cardClearRelativeCard)());
        return (0, $3JafE.Observable).from(actions);
    });

});

parcelRegister("7Ceyg", function(module, exports) {

$parcel$export(module.exports, "realtimeEventProcessEpic", () => $c66758737d8db23c$export$e7944216e26471c3);
parcelRequire("jyKN9");
parcelRequire("8OtG5");
parcelRequire("5dKXv");
parcelRequire("3wBUP");
parcelRequire("1Lcr1");

var $illlw = parcelRequire("illlw");

var $3JafE = parcelRequire("3JafE");

var $gUUjF = parcelRequire("gUUjF");

var $8wXFi = parcelRequire("8wXFi");

var $7TyGu = parcelRequire("7TyGu");

var $jiL2Q = parcelRequire("jiL2Q");

var $bCL12 = parcelRequire("bCL12");

var $hkGxG = parcelRequire("hkGxG");
const $c66758737d8db23c$var$isInactiveTab = ()=>document.hidden;
const $c66758737d8db23c$var$isNotCurrentUser = (state, action)=>(0, $hkGxG.getAtlassianAccountId)(state) !== (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(action, [
        'payload',
        'event',
        'payload',
        'atlassianId'
    ], null);
const $c66758737d8db23c$export$e7944216e26471c3 = (action$, store)=>action$.ofType((0, $bCL12.REALTIME_DISPATCH_EVENT)).filter((action)=>$c66758737d8db23c$var$isNotCurrentUser(store.getState(), action)).filter(()=>!$c66758737d8db23c$var$isInactiveTab()).debounceTime((0, $8wXFi.getBacklogRealtimeDebounceIntervalMillisecs)()).switchMap(()=>(0, $3JafE.Observable).of((0, $jiL2Q.refreshDataRequest)((0, $7TyGu.REFRESH_SOURCE_REALTIME)))).catch((error)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('backlog.realtime.event.process.failure', 'Failed to process realtime event', error);
        return (0, $3JafE.Observable).empty();
    });

});

parcelRegister("6ObTx", function(module, exports) {

$parcel$export(module.exports, "refetchVersionsEpic", () => $625ec5f9dc069ae6$export$4c96c86475a36738);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("8jBvP");

var $guiFP = parcelRequire("guiFP");

var $huI7r = parcelRequire("huI7r");

var $h43Ao = parcelRequire("h43Ao");

var $6iBIZ = parcelRequire("6iBIZ");

var $hkGxG = parcelRequire("hkGxG");
const $625ec5f9dc069ae6$export$4c96c86475a36738 = (action$, store, dependencies)=>action$.ofType((0, $6iBIZ.REFETCH_VERSIONS)).mergeMap(()=>{
        const state = store.getState();
        const cloudId = (0, $hkGxG.getCloudId)(state);
        const projectIds = (0, $hkGxG.getProjectIds)(state);
        if (!projectIds.length || !dependencies || !dependencies.refetchVersionsForProjects) return (0, $3JafE.Observable).empty();
        const refetchVersions = dependencies.refetchVersionsForProjects;
        const jiraProjectIds = projectIds.map((id)=>(0, $huI7r.createAri)({
                resourceOwner: 'jira',
                cloudId: cloudId,
                resourceType: 'project',
                resourceId: String(id)
            }));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $h43Ao.fromRelayObservable)(()=>refetchVersions(jiraProjectIds)).flatMap((data)=>{
            const versions = data?.jira?.versionsForProjects;
            return (0, $3JafE.Observable).of((0, $6iBIZ.setVersions)({
                versions: versions?.edges?.map((edge)=>edge?.node?.versionId)?.filter(Boolean) ?? []
            }));
        }).catch((error)=>(0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'refetchVersionsQuery',
                    packageName: 'jiraSoftwareBacklog',
                    teamName: 'a4t-tanuki'
                }
            }));
    });

});

parcelRegister("j7n3h", function(module, exports) {

$parcel$export(module.exports, "refreshDataEpic", () => $1b0379846fa4366d$export$c5e96b1fc124b3e);
parcelRequire("jyKN9");
parcelRequire("9u6v2");
parcelRequire("iects");
parcelRequire("5hZYM");
parcelRequire("dYXzn");
parcelRequire("7MxuP");
parcelRequire("1Lcr1");
parcelRequire("8OtG5");

var $8blac = parcelRequire("8blac");

var $3JafE = parcelRequire("3JafE");

var $gUUjF = parcelRequire("gUUjF");

var $7TyGu = parcelRequire("7TyGu");

var $lEnU0 = parcelRequire("lEnU0");

var $jiL2Q = parcelRequire("jiL2Q");

var $cbRhO = parcelRequire("cbRhO");

var $eYeFr = parcelRequire("eYeFr");

var $2498I = parcelRequire("2498I");

var $aWtR7 = parcelRequire("aWtR7");

var $7lCIO = parcelRequire("7lCIO");
const $1b0379846fa4366d$var$hasSprintCompleteSource = (actions)=>actions.some((action)=>action.payload.source === (0, $7TyGu.REFRESH_SOURCE_SPRINT_COMPLETE));
const $1b0379846fa4366d$export$74060531d4970975 = (refreshActions, resultActions)=>$1b0379846fa4366d$var$hasSprintCompleteSource(refreshActions) ? [
        ...resultActions,
        (0, $cbRhO.closeModal)()
    ] : resultActions;
const $1b0379846fa4366d$var$getGlobalIssueCreateSource = (actions)=>actions.find((action)=>action.payload.source === (0, $7TyGu.REFRESH_SOURCE_GLOBAL_ISSUE_CREATE));
const $1b0379846fa4366d$export$7a1171f81211a01b = (refreshActions, resultActions)=>{
    const globalIssueCreateAction = $1b0379846fa4366d$var$getGlobalIssueCreateSource(refreshActions);
    if (globalIssueCreateAction === undefined) return resultActions;
    const globalIssues = globalIssueCreateAction?.payload?.issues;
    return globalIssues === undefined ? [
        ...resultActions
    ] : [
        ...resultActions,
        (0, $jiL2Q.checkGlobalIssueCreate)(globalIssues)
    ];
};
const $1b0379846fa4366d$var$isOptimitsticOrDragging = (store)=>{
    const state = store.getState();
    return (0, $aWtR7.hasAnyActiveOptimistic)(state) || (0, $2498I.isDragging)(state);
};
const $1b0379846fa4366d$var$shouldCloseBuffer = (action$, store)=>action$.filter(()=>!$1b0379846fa4366d$var$isOptimitsticOrDragging(store));
const $1b0379846fa4366d$var$shouldAbort = (action$, store)=>action$.filter(()=>$1b0379846fa4366d$var$isOptimitsticOrDragging(store));
const $1b0379846fa4366d$export$98174b963acaea1d = (actions)=>actions.some((action)=>action.payload.source === (0, $7TyGu.REFRESH_SOURCE_ON_MOUNT));
const $1b0379846fa4366d$export$c5e96b1fc124b3e = (action$, store, dependencies)=>action$.ofType((0, $jiL2Q.REFRESH_DATA_REQUEST)).bufferWhen(()=>$1b0379846fa4366d$var$shouldCloseBuffer(action$, store)).filter((buffer)=>!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(buffer)).exhaustMap((refreshActions)=>{
        const serviceContext = (0, $lEnU0.makeServiceContext)(store.getState());
        const gicSourceRefreshAction = $1b0379846fa4366d$var$getGlobalIssueCreateSource(refreshActions);
        if (serviceContext.isCompanyManaged) {
            const loadAppDataAction = gicSourceRefreshAction !== undefined ? (0, $jiL2Q.loadAppData)({
                storeFieldsActions: gicSourceRefreshAction.payload.storeFieldsActions
            }) : (0, $jiL2Q.loadAppData)();
            const actions = [
                loadAppDataAction,
                (0, $jiL2Q.loadConfigData)()
            ];
            return (0, $3JafE.Observable).from([
                ...$1b0379846fa4366d$export$74060531d4970975(refreshActions, []),
                ...$1b0379846fa4366d$export$7a1171f81211a01b(refreshActions, []),
                ...actions,
                (0, $eYeFr.loadPriorities)()
            ]).takeUntil($1b0379846fa4366d$var$shouldAbort(action$, store));
        }
        const fetchDataFromAGG = dependencies?.fetchDataFromAGG;
        return (0, $7lCIO.fetchData)({
            store: store,
            ...$1b0379846fa4366d$export$98174b963acaea1d(refreshActions) && fetchDataFromAGG && {
                fetchDataFromAGG: ()=>fetchDataFromAGG(true)
            },
            ...gicSourceRefreshAction && gicSourceRefreshAction.payload.storeFieldsActions && {
                storeFieldsActions: gicSourceRefreshAction.payload.storeFieldsActions
            }
        }).flatMap((resultAction)=>[
                ...$1b0379846fa4366d$export$74060531d4970975(refreshActions, [
                    resultAction
                ]),
                ...$1b0379846fa4366d$export$7a1171f81211a01b(refreshActions, [
                    resultAction
                ])
            ]).takeUntil($1b0379846fa4366d$var$shouldAbort(action$, store));
    }).catch((error)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('backlog.refresh-data.failure', 'Fail to refresh data.', error);
        return (0, $3JafE.Observable).of((0, $jiL2Q.refreshDataFailure)());
    });

});
parcelRegister("2498I", function(module, exports) {

$parcel$export(module.exports, "isDragging", () => $ac15f98bbe216a94$export$9e9bc3c487fccc00);
$parcel$export(module.exports, "getSourceDroppableType", () => $ac15f98bbe216a94$export$e2d19a990d0e9f1c);
$parcel$export(module.exports, "getSourceCardListId", () => $ac15f98bbe216a94$export$3c7985ea201cdfef);
$parcel$export(module.exports, "getIsSubtaskDrag", () => $ac15f98bbe216a94$export$fa75a25bcebce8f1);
const $ac15f98bbe216a94$export$9e9bc3c487fccc00 = (state)=>state.ui.drag.isDragging;
const $ac15f98bbe216a94$export$e2d19a990d0e9f1c = (state)=>state.ui.drag.sourceCardGroupType;
const $ac15f98bbe216a94$export$3c7985ea201cdfef = (state)=>state.ui.drag.sourceCardListId;
const $ac15f98bbe216a94$export$fa75a25bcebce8f1 = (state)=>state.ui.drag.isSubtask;
const $ac15f98bbe216a94$export$376f09b67fc96920 = (state)=>state.ui.drag.sourceParentId;
const $ac15f98bbe216a94$export$158fcd85e87a52bd = (state)=>state.ui.drag.isOverTransitionZone;

});

parcelRegister("aWtR7", function(module, exports) {

$parcel$export(module.exports, "hasAnyActiveOptimistic", () => $996785aa07698510$export$5c9c2a640adc17da);
const $996785aa07698510$export$5c9c2a640adc17da = (state)=>{
    const beforeState = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    state.entities && state.entities.beforeState;
    return beforeState !== undefined;
};

});


parcelRegister("esmDo", function(module, exports) {

$parcel$export(module.exports, "refreshDataAddIssueTypeEpic", () => $44475e2b80333b91$export$61536c381fdc2e62);

var $3JafE = parcelRequire("3JafE");
parcelRequire("iects");
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("8OtG5");
parcelRequire("jnCPY");
parcelRequire("3wBUP");
parcelRequire("1Lcr1");

var $guiFP = parcelRequire("guiFP");

var $4UslI = parcelRequire("4UslI");

var $7TyGu = parcelRequire("7TyGu");

var $jiL2Q = parcelRequire("jiL2Q");
const $44475e2b80333b91$export$61536c381fdc2e62 = (action$)=>action$.ofType((0, $jiL2Q.REFRESH_DATA_REQUEST)).filter(({ payload: payload })=>payload.source === (0, $7TyGu.REFRESH_SOURCE_ADD_ISSUE_TYPE_MODAL)).switchMap(()=>action$.ofType((0, $jiL2Q.SET_APP_DATA), (0, $jiL2Q.LOAD_APP_DATA_FAILURE), (0, $jiL2Q.REFRESH_DATA_FAILURE)).take(1).flatMap(()=>{
            (0, $4UslI.addIssueTypeModalActions)()?.closeAddIssueTypeModal();
            return (0, $3JafE.Observable).empty();
        }).catch((error)=>{
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'backlog.refresh-data-add-issue-type-epic.failure',
                    packageName: 'jiraSoftwareBacklog',
                    // eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
                    teamName: 'jlove-makkuro'
                }
            });
            return (0, $3JafE.Observable).empty();
        }));

});

parcelRegister("d8IAt", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b944d6420085597$export$2e2bcd8739ae039);
parcelRequire("6og5C");
parcelRequire("8jBvP");
parcelRequire("9u6v2");
parcelRequire("2rE4V");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $3JafE = parcelRequire("3JafE");

var $e3Gc5 = parcelRequire("e3Gc5");

var $jiL2Q = parcelRequire("jiL2Q");

var $fB0vk = parcelRequire("fB0vk");

var $1HfeQ = parcelRequire("1HfeQ");

var $K2SiM = parcelRequire("K2SiM");

var $k0iqO = parcelRequire("k0iqO");

var $bP7Jx = parcelRequire("bP7Jx");
const $9b944d6420085597$var$performSelectedKeyCheck = (store, location, push)=>()=>{
        const state = store.getState();
        const lastSelectedCardKeyFromUrl = (0, $bP7Jx.getLastSelectedCardKey)(state);
        if (lastSelectedCardKeyFromUrl) {
            const cardId = (0, $bP7Jx.getIdByKeyForAllIssueTypes)(state)(lastSelectedCardKeyFromUrl);
            if (cardId) return (0, $3JafE.Observable).from([
                (0, $1HfeQ.cardSingleSelect)(cardId),
                (0, $K2SiM.openDetailView)(cardId),
                (0, $fB0vk.cardAutoScroll)(cardId)
            ]);
            push((0, $e3Gc5.removeSelectedIssueFromUrl)(location));
        }
        return (0, $3JafE.Observable).empty();
    };
// there are two cases, when we need to read lastSelectedCardKey from URL and open Bento on Backlog init
// 1) When critical path data is loaded before App routing initialised (with SSR/SPA) -> postLocationSetEpic
// 2) When critical path data is loaded after App routing initialised (without SSR) -> setSelectedIssueFromUrlEpic
const $9b944d6420085597$var$observables = (action$, isCompanyManaged)=>isCompanyManaged ? [
        action$.ofType((0, $1HfeQ.SET_LAST_SELECTED_CARD_KEY)).first(),
        action$.ofType((0, $jiL2Q.SET_APP_DATA)).first(),
        action$.ofType((0, $k0iqO.LOAD_ISSUE_PARENTS_SUCCESS)).first()
    ] : [
        action$.ofType((0, $1HfeQ.SET_LAST_SELECTED_CARD_KEY)).first(),
        action$.ofType((0, $jiL2Q.SET_APP_DATA)).first()
    ];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9b944d6420085597$export$2e2bcd8739ae039 = (getLocation, push, isCompanyManaged)=>(action$, store)=>(0, $3JafE.Observable).forkJoin($9b944d6420085597$var$observables(action$, isCompanyManaged)).mergeMap($9b944d6420085597$var$performSelectedKeyCheck(store, getLocation(), push)).catch(()=>(0, $3JafE.Observable).empty());

});

parcelRegister("6V0Mk", function(module, exports) {

$parcel$export(module.exports, "sprintCreateEpic", () => $daccdaf3644d4555$export$fd754fd9ce87f92b);

var $3JafE = parcelRequire("3JafE");
parcelRequire("9u6v2");
parcelRequire("flmol");
parcelRequire("1Lcr1");
parcelRequire("iects");

var $gUUjF = parcelRequire("gUUjF");

var $7TyGu = parcelRequire("7TyGu");

var $e2DXm = parcelRequire("e2DXm");

var $jiL2Q = parcelRequire("jiL2Q");

var $3i20Q = parcelRequire("3i20Q");

var $hkGxG = parcelRequire("hkGxG");
const $daccdaf3644d4555$export$fd754fd9ce87f92b = (action$, store)=>action$.ofType((0, $3i20Q.SPRINT_CREATE_REQUEST)).mergeMap((action)=>{
        const { meta: { optimistic: { id: optimisticId }, analyticsEvent: analyticsEvent }, payload: { temporaryCardListId: temporaryCardListId } } = action;
        const state = store.getState();
        const baseUrl = (0, $hkGxG.getBaseUrl)(state);
        const rapidViewId = (0, $hkGxG.getRapidViewId)(state);
        return (0, $e2DXm.default)(baseUrl, rapidViewId).map((sprint)=>(0, $3i20Q.sprintCreateSuccess)(sprint, temporaryCardListId, optimisticId, analyticsEvent)).catch((error)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData('backlog.sprint-create.failure', 'Failed to create sprint', error);
            return (0, $3JafE.Observable).from([
                (0, $3i20Q.sprintCreateFailure)(temporaryCardListId, optimisticId, analyticsEvent),
                (0, $jiL2Q.refreshDataRequest)((0, $7TyGu.REFRESH_SOURCE_FAILURE))
            ]);
        });
    });

});
parcelRegister("e2DXm", function(module, exports) {

$parcel$export(module.exports, "default", () => $8581f1af44f23237$export$2e2bcd8739ae039);
parcelRequire("flmol");

var $7TyGu = parcelRequire("7TyGu");

var $hQHgf = parcelRequire("hQHgf");
const $8581f1af44f23237$var$transformer = (response)=>({
        id: String(response.id),
        name: response.name,
        type: (0, $7TyGu.SPRINT),
        issueListKey: null,
        sprintData: {
            goal: '',
            startDate: response.isoStartDate,
            endDate: response.isoEndDate,
            daysRemaining: response.daysRemaining,
            state: response.state,
            canUpdateSprint: response.canUpdateSprint
        }
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8581f1af44f23237$export$2e2bcd8739ae039 = (baseUrl, rapidViewId)=>(0, $hQHgf.default)(baseUrl, rapidViewId).map($8581f1af44f23237$var$transformer);

});
parcelRegister("hQHgf", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9103c5b09d2438e$export$2e2bcd8739ae039);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("iects");

var $igbrt = parcelRequire("igbrt");
const $b9103c5b09d2438e$var$MUTATION_NAME = 'BacklogCreateSprint';
const $b9103c5b09d2438e$export$e904bac7f43ed94a = (boardId)=>`mutation ${$b9103c5b09d2438e$var$MUTATION_NAME} {
        createSprint(input: { 
            boardId: ${boardId}
        }) {
            sprint {
                id,
                name,
                daysRemaining,
                startDate,
                endDate,
                sprintState,
                canUpdateSprint
            }
        }
    }`;
const $b9103c5b09d2438e$export$9c68d69a4c5bbcf9 = (result)=>{
    const { sprintState: sprintState, endDate: endDate, startDate: startDate, ...rest } = result.createSprint.sprint;
    const createdSprint = {
        ...rest,
        state: sprintState,
        isoEndDate: endDate === 'None' ? '' : endDate,
        isoStartDate: startDate === 'None' ? '' : startDate
    };
    return (0, $3JafE.Observable).of(createdSprint);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b9103c5b09d2438e$export$2e2bcd8739ae039 = (baseUrl, boardId)=>(0, $igbrt.mutation$)(baseUrl, $b9103c5b09d2438e$var$MUTATION_NAME, $b9103c5b09d2438e$export$e904bac7f43ed94a(boardId)).flatMap($b9103c5b09d2438e$export$9c68d69a4c5bbcf9);

});


parcelRegister("3i20Q", function(module, exports) {

$parcel$export(module.exports, "SPRINT_CREATE_REQUEST", () => $995acae1df3195f2$export$d59013ccc191ced6);
$parcel$export(module.exports, "sprintCreateRequest", () => $995acae1df3195f2$export$6a8c5a7f76e28862);
$parcel$export(module.exports, "SPRINT_CREATE_SUCCESS", () => $995acae1df3195f2$export$4e82b88c987fbfcb);
$parcel$export(module.exports, "sprintCreateSuccess", () => $995acae1df3195f2$export$4bedc2fcbe2138bd);
$parcel$export(module.exports, "SPRINT_CREATE_FAILURE", () => $995acae1df3195f2$export$fe11ca1e4db494a);
$parcel$export(module.exports, "sprintCreateFailure", () => $995acae1df3195f2$export$cb20bc93da1235f7);

var $jWq1L = parcelRequire("jWq1L");
let $995acae1df3195f2$var$lastSprintId = 0;
const $995acae1df3195f2$var$generateId = ()=>{
    $995acae1df3195f2$var$lastSprintId -= 1;
    return $995acae1df3195f2$var$lastSprintId;
};
const $995acae1df3195f2$export$d59013ccc191ced6 = 'state.actions.sprints.create.SPRINT_CREATE_REQUEST';
const $995acae1df3195f2$export$6a8c5a7f76e28862 = (analyticsEvent)=>({
        type: $995acae1df3195f2$export$d59013ccc191ced6,
        payload: {
            temporaryCardListId: String($995acae1df3195f2$var$generateId())
        },
        meta: {
            ...(0, $jWq1L.beginOptimisticUiMeta)(),
            analyticsEvent: analyticsEvent
        }
    });
const $995acae1df3195f2$export$4e82b88c987fbfcb = 'state.actions.sprints.create.SPRINT_CREATE_SUCCESS';
const $995acae1df3195f2$export$4bedc2fcbe2138bd = (sprint, temporaryCardListId, optimisticId, analyticsEvent)=>({
        type: $995acae1df3195f2$export$4e82b88c987fbfcb,
        payload: {
            sprint: sprint,
            temporaryCardListId: temporaryCardListId
        },
        meta: {
            ...(0, $jWq1L.commitOptimisticUiMeta)(optimisticId),
            analyticsEvent: analyticsEvent
        }
    });
const $995acae1df3195f2$export$fe11ca1e4db494a = 'state.actions.sprints.create.SPRINT_CREATE_FAILURE';
const $995acae1df3195f2$export$cb20bc93da1235f7 = (temporaryCardListId, optimisticId, analyticsEvent)=>({
        type: $995acae1df3195f2$export$fe11ca1e4db494a,
        payload: {
            temporaryCardListId: temporaryCardListId
        },
        meta: {
            ...(0, $jWq1L.revertOptimisticUiWithFlagMeta)(optimisticId),
            ...analyticsEvent ? {
                analyticsEvent: analyticsEvent
            } : {}
        }
    });

});


parcelRegister("f1grZ", function(module, exports) {

$parcel$export(module.exports, "sprintDeleteEpic", () => $1946ecf2beafe966$export$5ffc2a46229f98c0);

var $3JafE = parcelRequire("3JafE");
parcelRequire("9u6v2");
parcelRequire("jyKN9");
parcelRequire("1Lcr1");
parcelRequire("iects");

var $JRB5w = parcelRequire("JRB5w");

var $jMP2a = parcelRequire("jMP2a");

var $7TyGu = parcelRequire("7TyGu");

var $ai2U0 = parcelRequire("ai2U0");

var $jiL2Q = parcelRequire("jiL2Q");

var $cjL82 = parcelRequire("cjL82");

var $hkGxG = parcelRequire("hkGxG");
const $1946ecf2beafe966$export$5ffc2a46229f98c0 = (action$, store)=>action$.ofType((0, $cjL82.SPRINT_DELETE_REQUEST)).mergeMap((action)=>{
        const { payload: { sprintId: sprintId }, meta: { optimistic: { id: optimisticId }, analyticsEvent: analyticsEvent } } = action;
        const state = store.getState();
        const baseUrl = (0, $hkGxG.getBaseUrl)(state);
        const rapidViewId = (0, $hkGxG.getRapidViewId)(state);
        return (0, $ai2U0.default)(baseUrl, sprintId, rapidViewId).flatMap(()=>{
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'sprint deleted');
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'ui taskSuccess', {
                task: 'deleteSprint'
            });
            return (0, $3JafE.Observable).of((0, $cjL82.sprintDeleteSuccess)(sprintId, optimisticId));
        }).catch((error)=>{
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'ui taskFail', {
                task: 'deleteSprint',
                isClientFetchError: (0, $JRB5w.isClientFetchError)(error),
                errorMessage: error.message
            });
            return (0, $3JafE.Observable).from([
                (0, $cjL82.sprintDeleteFailure)(sprintId, optimisticId),
                (0, $jiL2Q.refreshDataRequest)((0, $7TyGu.REFRESH_SOURCE_FAILURE))
            ]);
        });
    });

});
parcelRegister("ai2U0", function(module, exports) {

$parcel$export(module.exports, "default", () => $77fc26d33c54b93f$export$2e2bcd8739ae039);

var $8ja8E = parcelRequire("8ja8E");
var $77fc26d33c54b93f$export$2e2bcd8739ae039 = (0, $8ja8E.default);

});
parcelRegister("8ja8E", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0c3e67fc5084778$export$2e2bcd8739ae039);

var $igbrt = parcelRequire("igbrt");
const $e0c3e67fc5084778$var$MUTATION_NAME = 'BacklogDeleteSprint';
const $e0c3e67fc5084778$export$e904bac7f43ed94a = (boardId, sprintId)=>`mutation ${$e0c3e67fc5084778$var$MUTATION_NAME} {
        deleteSprint(input: { boardId: ${boardId}, sprintId: ${sprintId} }) {
            success
        }
    }`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e0c3e67fc5084778$export$2e2bcd8739ae039 = (baseUrl, sprintId, boardId)=>(0, $igbrt.mutation$)(baseUrl, $e0c3e67fc5084778$var$MUTATION_NAME, $e0c3e67fc5084778$export$e904bac7f43ed94a(boardId, sprintId));

});


parcelRegister("cjL82", function(module, exports) {

$parcel$export(module.exports, "SPRINT_DELETE_REQUEST", () => $7e7dbb605ea6e3af$export$6b303f66a5e5797e);
$parcel$export(module.exports, "sprintDeleteRequest", () => $7e7dbb605ea6e3af$export$35fe698532b74175);
$parcel$export(module.exports, "SPRINT_DELETE_SUCCESS", () => $7e7dbb605ea6e3af$export$834703750976df63);
$parcel$export(module.exports, "sprintDeleteSuccess", () => $7e7dbb605ea6e3af$export$83b0e54db46bc14c);
$parcel$export(module.exports, "sprintDeleteFailure", () => $7e7dbb605ea6e3af$export$f3bca19c58d95d7a);

var $jWq1L = parcelRequire("jWq1L");
const $7e7dbb605ea6e3af$export$6b303f66a5e5797e = 'state.actions.sprints.delete.SPRINT_DELETE_REQUEST';
const $7e7dbb605ea6e3af$export$35fe698532b74175 = (sprintId, nextCardListId, analyticsEvent)=>({
        type: $7e7dbb605ea6e3af$export$6b303f66a5e5797e,
        payload: {
            sprintId: sprintId,
            nextCardListId: nextCardListId
        },
        meta: {
            ...(0, $jWq1L.beginOptimisticUiMeta)(),
            analyticsEvent: analyticsEvent
        }
    });
const $7e7dbb605ea6e3af$export$834703750976df63 = 'state.actions.sprints.delete.SPRINT_DELETE_SUCCESS';
const $7e7dbb605ea6e3af$export$83b0e54db46bc14c = (sprintId, optimisticId)=>({
        type: $7e7dbb605ea6e3af$export$834703750976df63,
        payload: {
            sprintId: sprintId
        },
        meta: (0, $jWq1L.commitOptimisticUiMeta)(optimisticId)
    });
const $7e7dbb605ea6e3af$export$b96bc6bf6780477 = 'state.actions.sprints.delete.SPRINT_DELETE_FAILURE';
const $7e7dbb605ea6e3af$export$f3bca19c58d95d7a = (sprintId, optimisticId)=>({
        type: $7e7dbb605ea6e3af$export$b96bc6bf6780477,
        payload: {
            sprintId: sprintId
        },
        meta: (0, $jWq1L.revertOptimisticUiWithFlagMeta)(optimisticId)
    });

});


parcelRegister("7UnyG", function(module, exports) {

$parcel$export(module.exports, "sprintMoveEpic", () => $eb0fb69eb8b713f9$export$aee7bffc312e2d9d);

var $3JafE = parcelRequire("3JafE");
parcelRequire("9u6v2");
parcelRequire("jyKN9");
parcelRequire("1Lcr1");
parcelRequire("iects");

var $JRB5w = parcelRequire("JRB5w");

var $jMP2a = parcelRequire("jMP2a");

var $bfXzu = parcelRequire("bfXzu");

var $9r33H = parcelRequire("9r33H");

var $jiL2Q = parcelRequire("jiL2Q");

var $9csAN = parcelRequire("9csAN");

var $hkGxG = parcelRequire("hkGxG");
const $eb0fb69eb8b713f9$export$aee7bffc312e2d9d = (action$, store)=>action$.ofType((0, $9csAN.SPRINT_MOVE_REQUEST)).mergeMap((action)=>{
        const { payload: { sprintId: sprintId, targetSprintId: targetSprintId, analyticsEvent: analyticsEvent }, meta: { optimistic: { id: optimisticId } } } = action;
        const state = store.getState();
        const baseUrl = (0, $hkGxG.getBaseUrl)(state);
        const boardId = (0, $hkGxG.getRapidViewId)(state);
        (0, $bfXzu.setMoveSprintInteractionStartMark)();
        return (0, $9r33H.default)(baseUrl, boardId, sprintId, targetSprintId).flatMap(()=>{
            (0, $bfXzu.stopMoveSprintInteraction)();
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'sprint moved');
            return (0, $3JafE.Observable).of((0, $9csAN.sprintMoveSuccess)(optimisticId));
        }).catch((error)=>{
            (0, $bfXzu.cancelMoveSprintInteraction)();
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'sprint moveFailed', {
                isClientFetchError: (0, $JRB5w.isClientFetchError)(error)
            });
            return (0, $3JafE.Observable).from([
                (0, $9csAN.sprintMoveFailure)(optimisticId),
                (0, $jiL2Q.loadAppData)()
            ]);
        });
    });

});
parcelRegister("bfXzu", function(module, exports) {

$parcel$export(module.exports, "setMoveSprintInteractionStartMark", () => $ad377a4a20a25040$export$f22a6d0772829be2);
$parcel$export(module.exports, "cancelMoveSprintInteraction", () => $ad377a4a20a25040$export$24d4fe151992bf19);
$parcel$export(module.exports, "stopMoveSprintInteraction", () => $ad377a4a20a25040$export$a76821761124e4d4);

var $gPQCf = parcelRequire("gPQCf");
const $ad377a4a20a25040$export$f22a6d0772829be2 = ()=>{
    (0, $gPQCf.moveSprintInteraction).start();
};
const $ad377a4a20a25040$export$24d4fe151992bf19 = ()=>{
    (0, $gPQCf.moveSprintInteraction).cancel();
};
const $ad377a4a20a25040$export$a76821761124e4d4 = ()=>{
    (0, $gPQCf.moveSprintInteraction).stop();
};

});

parcelRegister("9r33H", function(module, exports) {

$parcel$export(module.exports, "default", () => $77dc528efa2496e0$export$2e2bcd8739ae039);

var $7U8AO = parcelRequire("7U8AO");
var $77dc528efa2496e0$export$2e2bcd8739ae039 = (0, $7U8AO.default);

});
parcelRegister("7U8AO", function(module, exports) {

$parcel$export(module.exports, "default", () => $abd188d4e2c880ea$export$2e2bcd8739ae039);

var $igbrt = parcelRequire("igbrt");
const $abd188d4e2c880ea$var$MUTATION_NAME = 'BacklogMoveSprint';
const $abd188d4e2c880ea$export$e904bac7f43ed94a = (boardId, sprintId, targetSprintId)=>`mutation ${$abd188d4e2c880ea$var$MUTATION_NAME} {
        moveSprint (input: {
            boardId: ${boardId},
            sprintId: ${sprintId},
            targetSprintId: ${targetSprintId},
        }) {
            success
        }
    }`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$abd188d4e2c880ea$export$2e2bcd8739ae039 = (baseUrl, boardId, sprintId, targetSprintId)=>(0, $igbrt.mutation$)(baseUrl, $abd188d4e2c880ea$var$MUTATION_NAME, $abd188d4e2c880ea$export$e904bac7f43ed94a(boardId, sprintId, targetSprintId));

});


parcelRegister("9csAN", function(module, exports) {

$parcel$export(module.exports, "SPRINT_MOVE_REQUEST", () => $62cb9b1de9284f04$export$af51e9f0383af197);
$parcel$export(module.exports, "sprintMoveRequest", () => $62cb9b1de9284f04$export$3f8b743cac3b0a79);
$parcel$export(module.exports, "sprintMoveSuccess", () => $62cb9b1de9284f04$export$604066b4fdce8da8);
$parcel$export(module.exports, "sprintMoveFailure", () => $62cb9b1de9284f04$export$62075de456e485a);

var $jWq1L = parcelRequire("jWq1L");
const $62cb9b1de9284f04$export$af51e9f0383af197 = 'state.actions.sprints.move.SPRINT_MOVE_REQUEST';
const $62cb9b1de9284f04$export$3f8b743cac3b0a79 = (payload)=>({
        type: $62cb9b1de9284f04$export$af51e9f0383af197,
        payload: payload,
        meta: (0, $jWq1L.beginOptimisticUiMeta)()
    });
const $62cb9b1de9284f04$export$404f9f04f93189f = 'state.actions.sprints.move.SPRINT_MOVE_SUCCESS';
const $62cb9b1de9284f04$export$604066b4fdce8da8 = (optimisticId)=>({
        type: $62cb9b1de9284f04$export$404f9f04f93189f,
        meta: (0, $jWq1L.commitOptimisticUiMeta)(optimisticId)
    });
const $62cb9b1de9284f04$export$512be0ad1cebb005 = 'state.actions.sprints.move.SPRINT_MOVE_FAILURE';
const $62cb9b1de9284f04$export$62075de456e485a = (optimisticId)=>({
        type: $62cb9b1de9284f04$export$512be0ad1cebb005,
        meta: (0, $jWq1L.revertOptimisticUiWithFlagMeta)(optimisticId)
    });

});


parcelRegister("9igNA", function(module, exports) {

$parcel$export(module.exports, "loadWhiteboardsEntrypointExperimentEpic", () => $bfbdf011b2d16ef3$export$217e0b1862428616);

var $bd1K7 = parcelRequire("bd1K7");

var $lEnr9 = parcelRequire("lEnr9");

var $l49DW = parcelRequire("l49DW");

var $ewlNK = parcelRequire("ewlNK");
const $bfbdf011b2d16ef3$export$217e0b1862428616 = (0, $bd1K7.combineEpics)((0, $lEnr9.loadWhiteboardsEntrypointExperimentHasAccessToConfluenceEpic), (0, $l49DW.loadWhiteboardsEntrypointExperimentHasConfluenceSpacesEpic), (0, $ewlNK.loadHasViewedPulseEpic), (0, $ewlNK.setHasViewedPulseEpic));

});
parcelRegister("lEnr9", function(module, exports) {

$parcel$export(module.exports, "loadWhiteboardsEntrypointExperimentHasAccessToConfluenceEpic", () => $8d06f9564310bd32$export$91a6d9d97eec2a49);
parcelRequire("jyKN9");
parcelRequire("iects");
parcelRequire("flmol");
parcelRequire("1Lcr1");

var $b7Uvu = parcelRequire("b7Uvu");

var $jiL2Q = parcelRequire("jiL2Q");

var $h4zn0 = parcelRequire("h4zn0");
const $8d06f9564310bd32$var$loadHasAccessToConfluence = ()=>(0, $b7Uvu.loadConfluencePermissionsService)().map((0, $h4zn0.hasConfluenceAccessEstablished));
const $8d06f9564310bd32$export$91a6d9d97eec2a49 = (action$)=>action$.ofType((0, $jiL2Q.LOAD_APP_DATA_REQUEST)).flatMap(()=>$8d06f9564310bd32$var$loadHasAccessToConfluence());

});
parcelRegister("b7Uvu", function(module, exports) {

$parcel$export(module.exports, "loadConfluencePermissionsService", () => $0a02453675b31309$export$560aec87fc57f4f8);
$parcel$export(module.exports, "loadConfluenceSpaceService", () => $0a02453675b31309$export$2a575dd4a8df50c9);
$parcel$export(module.exports, "loadHasViewedPulseService", () => $0a02453675b31309$export$e4e71ae896d4c436);
$parcel$export(module.exports, "setHasViewedPulseService", () => $0a02453675b31309$export$50e2ed7f4b84c09f);
parcelRequire("flmol");

var $cwK3t = parcelRequire("cwK3t");

var $7xwx0 = parcelRequire("7xwx0");

var $guiFP = parcelRequire("guiFP");

var $hsrY5 = parcelRequire("hsrY5");

var $h4zn0 = parcelRequire("h4zn0");

var $hkGxG = parcelRequire("hkGxG");
const $0a02453675b31309$export$560aec87fc57f4f8 = ()=>(0, $hsrY5.fetchConfluencePermissions)().pipe((0, $7xwx0.map)((response)=>!!response.operations && response.operations.length > 0), (0, $7xwx0.catchError)(()=>(0, $cwK3t.of)(false)));
const $0a02453675b31309$export$2a575dd4a8df50c9 = ()=>(0, $hsrY5.fetchConfluenceSpace)().pipe((0, $7xwx0.map)((response)=>!!response.results && response.results.length > 0), (0, $7xwx0.catchError)(()=>(0, $cwK3t.of)(false)));
const $0a02453675b31309$export$e4e71ae896d4c436 = (accountId)=>(0, $hsrY5.fetchUserProperties)(accountId).pipe((0, $7xwx0.map)((res)=>res.value), (0, $7xwx0.catchError)((error)=>{
        // 404: API deliberately returns 404 if user property is not found
        if (error.statusCode === 404) return (0, $cwK3t.of)(false);
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'backlog.load-has-viewed-pulse-service.failure',
                packageName: 'jiraSoftwareBacklog',
                teamName: 'a4t-tanuki'
            }
        });
        return (0, $cwK3t.of)(true);
    }));
const $0a02453675b31309$export$50e2ed7f4b84c09f = ({ store: store })=>{
    const accountId = (0, $hkGxG.getAtlassianAccountId)(store.getState());
    return (0, $hsrY5.setUserProperties)(accountId ?? '', true).pipe((0, $7xwx0.map)(()=>(0, $h4zn0.setHasViewedPulseSuccess)(true)), (0, $7xwx0.catchError)(()=>(0, $cwK3t.of)((0, $h4zn0.setHasViewedPulseFailure)())));
};

});
parcelRegister("7xwx0", function(module, exports) {

$parcel$export(module.exports, "catchError", () => $57d4d9855b7856ca$export$3dede90624df3ba9, (v) => $57d4d9855b7856ca$export$3dede90624df3ba9 = v);
$parcel$export(module.exports, "map", () => $57d4d9855b7856ca$export$871de8747c9eaa88, (v) => $57d4d9855b7856ca$export$871de8747c9eaa88 = v);
$parcel$export(module.exports, "mergeMap", () => $57d4d9855b7856ca$export$6b9f6c0d32c093f9, (v) => $57d4d9855b7856ca$export$6b9f6c0d32c093f9 = v);
$parcel$export(module.exports, "switchMap", () => $57d4d9855b7856ca$export$9f6ea8e48bc26eab, (v) => $57d4d9855b7856ca$export$9f6ea8e48bc26eab = v);
$parcel$export(module.exports, "throttleTime", () => $57d4d9855b7856ca$export$4efe28f192921dd4, (v) => $57d4d9855b7856ca$export$4efe28f192921dd4 = v);
var $57d4d9855b7856ca$export$d779b02e6b68c3e8;
var $57d4d9855b7856ca$export$719c70722b10e5ff;
var $57d4d9855b7856ca$export$ab1029bcae9ddb4a;
var $57d4d9855b7856ca$export$8916d2c8119541bb;
var $57d4d9855b7856ca$export$d6b40c95035461c7;
var $57d4d9855b7856ca$export$91115bdd8709945f;
var $57d4d9855b7856ca$export$9e55760d3282e08c;
var $57d4d9855b7856ca$export$3dede90624df3ba9;
var $57d4d9855b7856ca$export$29ae691b7de52fe3;
var $57d4d9855b7856ca$export$77fa7d86f5204e8a;
var $57d4d9855b7856ca$export$ee1b3e54f0441b22;
var $57d4d9855b7856ca$export$b314777ae20abca9;
var $57d4d9855b7856ca$export$c28c8388be0ab31a;
var $57d4d9855b7856ca$export$82fbd7a2841d2484;
var $57d4d9855b7856ca$export$85b9a36db797e02b;
var $57d4d9855b7856ca$export$61fc7d43ac8f84b0;
var $57d4d9855b7856ca$export$7843a4469d64c07e;
var $57d4d9855b7856ca$export$e4ca6d7b7a6dcf9b;
var $57d4d9855b7856ca$export$1391212d75b2ee65;
var $57d4d9855b7856ca$export$286ca829307725c9;
var $57d4d9855b7856ca$export$ab9a5985b741fa7a;
var $57d4d9855b7856ca$export$983a3b5fb2f7202e;
var $57d4d9855b7856ca$export$779c5fb865a0172e;
var $57d4d9855b7856ca$export$571da16e28367bde;
var $57d4d9855b7856ca$export$91d69c7761a17bbc;
var $57d4d9855b7856ca$export$7ecc1a3b11b57dab;
var $57d4d9855b7856ca$export$31039f1fbd797b9c;
var $57d4d9855b7856ca$export$d70d492cd31004c0;
var $57d4d9855b7856ca$export$9f77e0932fb78f72;
var $57d4d9855b7856ca$export$3dea766d36a8935f;
var $57d4d9855b7856ca$export$578723aef62d92f5;
var $57d4d9855b7856ca$export$71aa6c912b956294;
var $57d4d9855b7856ca$export$de3a4d4a0d731119;
var $57d4d9855b7856ca$export$43128fadae87b74a;
var $57d4d9855b7856ca$export$3f063810d7bf01bd;
var $57d4d9855b7856ca$export$6953b97c7d866605;
var $57d4d9855b7856ca$export$dd1bc94b04021eeb;
var $57d4d9855b7856ca$export$4c7897fafd92b108;
var $57d4d9855b7856ca$export$871de8747c9eaa88;
var $57d4d9855b7856ca$export$e0eaf3a86c03b2ad;
var $57d4d9855b7856ca$export$76dbd6ffd832405d;
var $57d4d9855b7856ca$export$8960430cfd85939f;
var $57d4d9855b7856ca$export$4950aa0f605343fb;
var $57d4d9855b7856ca$export$18aef43295bbe906;
var $57d4d9855b7856ca$export$6b9f6c0d32c093f9;
var $57d4d9855b7856ca$export$5b8affa63fc6df16;
var $57d4d9855b7856ca$export$bd7cfc9a42b8a412;
var $57d4d9855b7856ca$export$c1fc905202bced53;
var $57d4d9855b7856ca$export$96ec731ed4dcb222;
var $57d4d9855b7856ca$export$1364843af8d5a963;
var $57d4d9855b7856ca$export$9007f49c319d1ac7;
var $57d4d9855b7856ca$export$5fba66d61591f42;
var $57d4d9855b7856ca$export$8f9d79d42bff1aac;
var $57d4d9855b7856ca$export$b29f828819edca8d;
var $57d4d9855b7856ca$export$c44985b87d605eff;
var $57d4d9855b7856ca$export$89b472e03be495df;
var $57d4d9855b7856ca$export$16ae46fda9567053;
var $57d4d9855b7856ca$export$42d9b6b38c68d989;
var $57d4d9855b7856ca$export$1f3342bf81d92d52;
var $57d4d9855b7856ca$export$236c05de452bec2;
var $57d4d9855b7856ca$export$533b26079ad0b4b;
var $57d4d9855b7856ca$export$76d90c956114f2c2;
var $57d4d9855b7856ca$export$b39ac5b4ffd1415a;
var $57d4d9855b7856ca$export$9369b12211e1fce4;
var $57d4d9855b7856ca$export$1281551253cfee02;
var $57d4d9855b7856ca$export$18d0766d894cba0c;
var $57d4d9855b7856ca$export$4812e460280c6ef2;
var $57d4d9855b7856ca$export$fe33c7b2002d97b0;
var $57d4d9855b7856ca$export$c87d910e63d22ed6;
var $57d4d9855b7856ca$export$d0a07e60ae428313;
var $57d4d9855b7856ca$export$ed80d9de1d9df928;
var $57d4d9855b7856ca$export$db61d692014e534e;
var $57d4d9855b7856ca$export$863d7ca51b416cee;
var $57d4d9855b7856ca$export$955fc4a6c4be454d;
var $57d4d9855b7856ca$export$635f6273df29ea1c;
var $57d4d9855b7856ca$export$facc584867c26fde;
var $57d4d9855b7856ca$export$175dedd748069215;
var $57d4d9855b7856ca$export$a4fe86229b0e9bdd;
var $57d4d9855b7856ca$export$6a45284a4b0bf33a;
var $57d4d9855b7856ca$export$9f6ea8e48bc26eab;
var $57d4d9855b7856ca$export$a439dc30c845238;
var $57d4d9855b7856ca$export$b7df5d561049483a;
var $57d4d9855b7856ca$export$1b47ad771ce5af5e;
var $57d4d9855b7856ca$export$ac8dfd3a7ad06e80;
var $57d4d9855b7856ca$export$9384c7afe4015e42;
var $57d4d9855b7856ca$export$3f23594af5f37336;
var $57d4d9855b7856ca$export$de363e709c412c8a;
var $57d4d9855b7856ca$export$4efe28f192921dd4;
var $57d4d9855b7856ca$export$1a539c8b2950ab40;
var $57d4d9855b7856ca$export$83e74882c5df8fe1;
var $57d4d9855b7856ca$export$86fe999fba7953f2;
var $57d4d9855b7856ca$export$fc00ee57782020aa;
var $57d4d9855b7856ca$export$45b10814cc054894;
var $57d4d9855b7856ca$export$8291e5b88f90ce4;
var $57d4d9855b7856ca$export$f3a19e933f377396;
var $57d4d9855b7856ca$export$1284415effa79ee0;
var $57d4d9855b7856ca$export$3182be990e0eeaad;
var $57d4d9855b7856ca$export$6a5dea797879f644;
var $57d4d9855b7856ca$export$d449030e5c10edf7;
var $57d4d9855b7856ca$export$8901015135f2fb22;
var $57d4d9855b7856ca$export$adddb6a2fa3864e9;
"use strict";

var $6EsY3 = parcelRequire("6EsY3");
$57d4d9855b7856ca$export$d779b02e6b68c3e8 = $6EsY3.audit;

var $8Rio7 = parcelRequire("8Rio7");
$57d4d9855b7856ca$export$719c70722b10e5ff = $8Rio7.auditTime;

var $i9UF9 = parcelRequire("i9UF9");
$57d4d9855b7856ca$export$ab1029bcae9ddb4a = $i9UF9.buffer;

var $4ZLqF = parcelRequire("4ZLqF");
$57d4d9855b7856ca$export$8916d2c8119541bb = $4ZLqF.bufferCount;

var $hl24P = parcelRequire("hl24P");
$57d4d9855b7856ca$export$d6b40c95035461c7 = $hl24P.bufferTime;

var $l9hdJ = parcelRequire("l9hdJ");
$57d4d9855b7856ca$export$91115bdd8709945f = $l9hdJ.bufferToggle;

var $5SOVP = parcelRequire("5SOVP");
$57d4d9855b7856ca$export$9e55760d3282e08c = $5SOVP.bufferWhen;

var $df9H8 = parcelRequire("df9H8");
$57d4d9855b7856ca$export$3dede90624df3ba9 = $df9H8.catchError;

var $lQxTf = parcelRequire("lQxTf");
$57d4d9855b7856ca$export$29ae691b7de52fe3 = $lQxTf.combineAll;

var $fEMiR = parcelRequire("fEMiR");
$57d4d9855b7856ca$export$77fa7d86f5204e8a = $fEMiR.combineLatest;

var $bfqZP = parcelRequire("bfqZP");
$57d4d9855b7856ca$export$ee1b3e54f0441b22 = $bfqZP.concat;

var $3joCo = parcelRequire("3joCo");
$57d4d9855b7856ca$export$b314777ae20abca9 = $3joCo.concatAll;

var $eGPtZ = parcelRequire("eGPtZ");
$57d4d9855b7856ca$export$c28c8388be0ab31a = $eGPtZ.concatMap;

var $cmPKV = parcelRequire("cmPKV");
$57d4d9855b7856ca$export$82fbd7a2841d2484 = $cmPKV.concatMapTo;

var $9INaL = parcelRequire("9INaL");
$57d4d9855b7856ca$export$85b9a36db797e02b = $9INaL.count;

var $9PQtY = parcelRequire("9PQtY");
$57d4d9855b7856ca$export$61fc7d43ac8f84b0 = $9PQtY.debounce;

var $lzvfM = parcelRequire("lzvfM");
$57d4d9855b7856ca$export$7843a4469d64c07e = $lzvfM.debounceTime;

var $kyjNq = parcelRequire("kyjNq");
$57d4d9855b7856ca$export$e4ca6d7b7a6dcf9b = $kyjNq.defaultIfEmpty;

var $kW6gr = parcelRequire("kW6gr");
$57d4d9855b7856ca$export$1391212d75b2ee65 = $kW6gr.delay;

var $jrplL = parcelRequire("jrplL");
$57d4d9855b7856ca$export$286ca829307725c9 = $jrplL.delayWhen;

var $GQ41u = parcelRequire("GQ41u");
$57d4d9855b7856ca$export$ab9a5985b741fa7a = $GQ41u.dematerialize;

var $ktZdP = parcelRequire("ktZdP");
$57d4d9855b7856ca$export$983a3b5fb2f7202e = $ktZdP.distinct;

var $8xAAu = parcelRequire("8xAAu");
$57d4d9855b7856ca$export$779c5fb865a0172e = $8xAAu.distinctUntilChanged;

var $aS1Fs = parcelRequire("aS1Fs");
$57d4d9855b7856ca$export$571da16e28367bde = $aS1Fs.distinctUntilKeyChanged;

var $8WPKc = parcelRequire("8WPKc");
$57d4d9855b7856ca$export$91d69c7761a17bbc = $8WPKc.elementAt;

var $7OVJ1 = parcelRequire("7OVJ1");
$57d4d9855b7856ca$export$7ecc1a3b11b57dab = $7OVJ1.every;

var $3VDHE = parcelRequire("3VDHE");
$57d4d9855b7856ca$export$31039f1fbd797b9c = $3VDHE.exhaust;

var $dBdHa = parcelRequire("dBdHa");
$57d4d9855b7856ca$export$d70d492cd31004c0 = $dBdHa.exhaustMap;

var $3MmTN = parcelRequire("3MmTN");
$57d4d9855b7856ca$export$9f77e0932fb78f72 = $3MmTN.expand;

var $dXapj = parcelRequire("dXapj");
$57d4d9855b7856ca$export$3dea766d36a8935f = $dXapj.filter;

var $cyrKF = parcelRequire("cyrKF");
$57d4d9855b7856ca$export$578723aef62d92f5 = $cyrKF.finalize;

var $lHxIn = parcelRequire("lHxIn");
$57d4d9855b7856ca$export$71aa6c912b956294 = $lHxIn.find;

var $1as0c = parcelRequire("1as0c");
$57d4d9855b7856ca$export$de3a4d4a0d731119 = $1as0c.findIndex;

var $iZQrg = parcelRequire("iZQrg");
$57d4d9855b7856ca$export$43128fadae87b74a = $iZQrg.first;

var $896Ie = parcelRequire("896Ie");
$57d4d9855b7856ca$export$3f063810d7bf01bd = $896Ie.groupBy;

var $7o5pq = parcelRequire("7o5pq");
$57d4d9855b7856ca$export$6953b97c7d866605 = $7o5pq.ignoreElements;

var $b095i = parcelRequire("b095i");
$57d4d9855b7856ca$export$dd1bc94b04021eeb = $b095i.isEmpty;

var $bQ3wM = parcelRequire("bQ3wM");
$57d4d9855b7856ca$export$4c7897fafd92b108 = $bQ3wM.last;

var $aynDk = parcelRequire("aynDk");
$57d4d9855b7856ca$export$871de8747c9eaa88 = $aynDk.map;

var $bRS1V = parcelRequire("bRS1V");
$57d4d9855b7856ca$export$e0eaf3a86c03b2ad = $bRS1V.mapTo;

var $iH3rg = parcelRequire("iH3rg");
$57d4d9855b7856ca$export$76dbd6ffd832405d = $iH3rg.materialize;

var $k4LFb = parcelRequire("k4LFb");
$57d4d9855b7856ca$export$8960430cfd85939f = $k4LFb.max;

var $eyE5b = parcelRequire("eyE5b");
$57d4d9855b7856ca$export$4950aa0f605343fb = $eyE5b.merge;

var $3Ut6O = parcelRequire("3Ut6O");
$57d4d9855b7856ca$export$18aef43295bbe906 = $3Ut6O.mergeAll;

var $b1qLQ = parcelRequire("b1qLQ");
$57d4d9855b7856ca$export$6b9f6c0d32c093f9 = $b1qLQ.mergeMap;

var $b1qLQ = parcelRequire("b1qLQ");
$57d4d9855b7856ca$export$5b8affa63fc6df16 = $b1qLQ.mergeMap;

var $g0vpX = parcelRequire("g0vpX");
$57d4d9855b7856ca$export$bd7cfc9a42b8a412 = $g0vpX.mergeMapTo;

var $6zXYF = parcelRequire("6zXYF");
$57d4d9855b7856ca$export$c1fc905202bced53 = $6zXYF.mergeScan;

var $jwlZG = parcelRequire("jwlZG");
$57d4d9855b7856ca$export$96ec731ed4dcb222 = $jwlZG.min;

var $lCBlc = parcelRequire("lCBlc");
$57d4d9855b7856ca$export$1364843af8d5a963 = $lCBlc.multicast;

var $9s3uu = parcelRequire("9s3uu");
$57d4d9855b7856ca$export$9007f49c319d1ac7 = $9s3uu.observeOn;

var $6wVip = parcelRequire("6wVip");
$57d4d9855b7856ca$export$5fba66d61591f42 = $6wVip.onErrorResumeNext;

var $vO84Z = parcelRequire("vO84Z");
$57d4d9855b7856ca$export$8f9d79d42bff1aac = $vO84Z.pairwise;

var $kZNgW = parcelRequire("kZNgW");
$57d4d9855b7856ca$export$b29f828819edca8d = $kZNgW.partition;

var $aOc77 = parcelRequire("aOc77");
$57d4d9855b7856ca$export$c44985b87d605eff = $aOc77.pluck;

var $3hbzh = parcelRequire("3hbzh");
$57d4d9855b7856ca$export$89b472e03be495df = $3hbzh.publish;

var $a9dHZ = parcelRequire("a9dHZ");
$57d4d9855b7856ca$export$16ae46fda9567053 = $a9dHZ.publishBehavior;

var $4ZbWy = parcelRequire("4ZbWy");
$57d4d9855b7856ca$export$42d9b6b38c68d989 = $4ZbWy.publishLast;

var $4g0k7 = parcelRequire("4g0k7");
$57d4d9855b7856ca$export$1f3342bf81d92d52 = $4g0k7.publishReplay;

var $6BYfk = parcelRequire("6BYfk");
$57d4d9855b7856ca$export$236c05de452bec2 = $6BYfk.race;

var $2N4j1 = parcelRequire("2N4j1");
$57d4d9855b7856ca$export$533b26079ad0b4b = $2N4j1.reduce;

var $8npYd = parcelRequire("8npYd");
$57d4d9855b7856ca$export$76d90c956114f2c2 = $8npYd.repeat;

var $4m82s = parcelRequire("4m82s");
$57d4d9855b7856ca$export$b39ac5b4ffd1415a = $4m82s.repeatWhen;

var $jbDDn = parcelRequire("jbDDn");
$57d4d9855b7856ca$export$9369b12211e1fce4 = $jbDDn.retry;

var $7O6Ck = parcelRequire("7O6Ck");
$57d4d9855b7856ca$export$1281551253cfee02 = $7O6Ck.retryWhen;

var $34NII = parcelRequire("34NII");
$57d4d9855b7856ca$export$18d0766d894cba0c = $34NII.refCount;

var $9hUXl = parcelRequire("9hUXl");
$57d4d9855b7856ca$export$4812e460280c6ef2 = $9hUXl.sample;

var $kPJ0i = parcelRequire("kPJ0i");
$57d4d9855b7856ca$export$fe33c7b2002d97b0 = $kPJ0i.sampleTime;

var $haxv1 = parcelRequire("haxv1");
$57d4d9855b7856ca$export$c87d910e63d22ed6 = $haxv1.scan;

var $iwZAW = parcelRequire("iwZAW");
$57d4d9855b7856ca$export$d0a07e60ae428313 = $iwZAW.sequenceEqual;

var $9TIZU = parcelRequire("9TIZU");
$57d4d9855b7856ca$export$ed80d9de1d9df928 = $9TIZU.share;

var $2n4lI = parcelRequire("2n4lI");
$57d4d9855b7856ca$export$db61d692014e534e = $2n4lI.shareReplay;

var $9Pl3U = parcelRequire("9Pl3U");
$57d4d9855b7856ca$export$863d7ca51b416cee = $9Pl3U.single;

var $l8un2 = parcelRequire("l8un2");
$57d4d9855b7856ca$export$955fc4a6c4be454d = $l8un2.skip;

var $b3Afl = parcelRequire("b3Afl");
$57d4d9855b7856ca$export$635f6273df29ea1c = $b3Afl.skipLast;

var $dMiA4 = parcelRequire("dMiA4");
$57d4d9855b7856ca$export$facc584867c26fde = $dMiA4.skipUntil;

var $3MURy = parcelRequire("3MURy");
$57d4d9855b7856ca$export$175dedd748069215 = $3MURy.skipWhile;

var $lwfFQ = parcelRequire("lwfFQ");
$57d4d9855b7856ca$export$a4fe86229b0e9bdd = $lwfFQ.startWith;

var $1csk5 = parcelRequire("1csk5");
$57d4d9855b7856ca$export$6a45284a4b0bf33a = $1csk5.switchAll;

var $6yPEx = parcelRequire("6yPEx");
$57d4d9855b7856ca$export$9f6ea8e48bc26eab = $6yPEx.switchMap;

var $aa4RZ = parcelRequire("aa4RZ");
$57d4d9855b7856ca$export$a439dc30c845238 = $aa4RZ.switchMapTo;

var $8TnD2 = parcelRequire("8TnD2");
$57d4d9855b7856ca$export$b7df5d561049483a = $8TnD2.take;

var $2eZlT = parcelRequire("2eZlT");
$57d4d9855b7856ca$export$1b47ad771ce5af5e = $2eZlT.takeLast;

var $itrTE = parcelRequire("itrTE");
$57d4d9855b7856ca$export$ac8dfd3a7ad06e80 = $itrTE.takeUntil;

var $29RSJ = parcelRequire("29RSJ");
$57d4d9855b7856ca$export$9384c7afe4015e42 = $29RSJ.takeWhile;

var $dBQte = parcelRequire("dBQte");
$57d4d9855b7856ca$export$3f23594af5f37336 = $dBQte.tap;

var $7Vtdp = parcelRequire("7Vtdp");
$57d4d9855b7856ca$export$de363e709c412c8a = $7Vtdp.throttle;

var $1NTdO = parcelRequire("1NTdO");
$57d4d9855b7856ca$export$4efe28f192921dd4 = $1NTdO.throttleTime;

var $kfhNV = parcelRequire("kfhNV");
$57d4d9855b7856ca$export$1a539c8b2950ab40 = $kfhNV.timeInterval;

var $6bEgU = parcelRequire("6bEgU");
$57d4d9855b7856ca$export$83e74882c5df8fe1 = $6bEgU.timeout;

var $7JnJx = parcelRequire("7JnJx");
$57d4d9855b7856ca$export$86fe999fba7953f2 = $7JnJx.timeoutWith;

var $coloa = parcelRequire("coloa");
$57d4d9855b7856ca$export$fc00ee57782020aa = $coloa.timestamp;

var $2arAN = parcelRequire("2arAN");
$57d4d9855b7856ca$export$45b10814cc054894 = $2arAN.toArray;

var $2QlNT = parcelRequire("2QlNT");
$57d4d9855b7856ca$export$8291e5b88f90ce4 = $2QlNT.window;

var $bkg2F = parcelRequire("bkg2F");
$57d4d9855b7856ca$export$f3a19e933f377396 = $bkg2F.windowCount;

var $3SRp7 = parcelRequire("3SRp7");
$57d4d9855b7856ca$export$1284415effa79ee0 = $3SRp7.windowTime;

var $aR6Rt = parcelRequire("aR6Rt");
$57d4d9855b7856ca$export$3182be990e0eeaad = $aR6Rt.windowToggle;

var $hiGV8 = parcelRequire("hiGV8");
$57d4d9855b7856ca$export$6a5dea797879f644 = $hiGV8.windowWhen;

var $hDran = parcelRequire("hDran");
$57d4d9855b7856ca$export$d449030e5c10edf7 = $hDran.withLatestFrom;

var $5f7nL = parcelRequire("5f7nL");
$57d4d9855b7856ca$export$8901015135f2fb22 = $5f7nL.zip;

var $u6syz = parcelRequire("u6syz");
$57d4d9855b7856ca$export$adddb6a2fa3864e9 = $u6syz.zipAll;

});
parcelRegister("6EsY3", function(module, exports) {
"use strict";
var $4d7cf2e00e09dbe1$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jJdW6 = parcelRequire("jJdW6");

var $4b4q3 = parcelRequire("4b4q3");

var $6UnJS = parcelRequire("6UnJS");

var $87MtM = parcelRequire("87MtM");
/**
 * Ignores source values for a duration determined by another Observable, then
 * emits the most recent value from the source Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link auditTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/audit.png" width="100%">
 *
 * `audit` is similar to `throttle`, but emits the last value from the silenced
 * time window, instead of the first value. `audit` emits the most recent value
 * from the source Observable on the output Observable as soon as its internal
 * timer becomes disabled, and ignores source values while the timer is enabled.
 * Initially, the timer is disabled. As soon as the first source value arrives,
 * the timer is enabled by calling the `durationSelector` function with the
 * source value, which returns the "duration" Observable. When the duration
 * Observable emits a value or completes, the timer is disabled, then the most
 * recent source value is emitted on the output Observable, and this process
 * repeats for the next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.audit(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration, returned as an Observable or a Promise.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method audit
 * @owner Observable
 */ function $4d7cf2e00e09dbe1$var$audit(durationSelector) {
    return function auditOperatorFunction(source) {
        return source.lift(new $4d7cf2e00e09dbe1$var$AuditOperator(durationSelector));
    };
}
module.exports.audit = $4d7cf2e00e09dbe1$var$audit;
var $4d7cf2e00e09dbe1$var$AuditOperator = function() {
    function AuditOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    AuditOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $4d7cf2e00e09dbe1$var$AuditSubscriber(subscriber, this.durationSelector));
    };
    return AuditOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $4d7cf2e00e09dbe1$var$AuditSubscriber = function(_super) {
    $4d7cf2e00e09dbe1$var$__extends(AuditSubscriber, _super);
    function AuditSubscriber(destination, durationSelector) {
        _super.call(this, destination);
        this.durationSelector = durationSelector;
        this.hasValue = false;
    }
    AuditSubscriber.prototype._next = function(value) {
        this.value = value;
        this.hasValue = true;
        if (!this.throttled) {
            var duration = $jJdW6.tryCatch(this.durationSelector)(value);
            if (duration === $4b4q3.errorObject) this.destination.error($4b4q3.errorObject.e);
            else {
                var innerSubscription = $87MtM.subscribeToResult(this, duration);
                if (innerSubscription.closed) this.clearThrottle();
                else this.add(this.throttled = innerSubscription);
            }
        }
    };
    AuditSubscriber.prototype.clearThrottle = function() {
        var _a = this, value = _a.value, hasValue = _a.hasValue, throttled = _a.throttled;
        if (throttled) {
            this.remove(throttled);
            this.throttled = null;
            throttled.unsubscribe();
        }
        if (hasValue) {
            this.value = null;
            this.hasValue = false;
            this.destination.next(value);
        }
    };
    AuditSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex) {
        this.clearThrottle();
    };
    AuditSubscriber.prototype.notifyComplete = function() {
        this.clearThrottle();
    };
    return AuditSubscriber;
}($6UnJS.OuterSubscriber);

});

parcelRegister("8Rio7", function(module, exports) {

$parcel$export(module.exports, "auditTime", () => $6731897458e7c8c2$export$719c70722b10e5ff, (v) => $6731897458e7c8c2$export$719c70722b10e5ff = v);
var $6731897458e7c8c2$export$719c70722b10e5ff;
"use strict";

var $jAy5L = parcelRequire("jAy5L");

var $6EsY3 = parcelRequire("6EsY3");

var $29oaj = parcelRequire("29oaj");
/**
 * Ignores source values for `duration` milliseconds, then emits the most recent
 * value from the source Observable, then repeats this process.
 *
 * <span class="informal">When it sees a source values, it ignores that plus
 * the next ones for `duration` milliseconds, and then it emits the most recent
 * value from the source.</span>
 *
 * <img src="./img/auditTime.png" width="100%">
 *
 * `auditTime` is similar to `throttleTime`, but emits the last value from the
 * silenced time window, instead of the first value. `auditTime` emits the most
 * recent value from the source Observable on the output Observable as soon as
 * its internal timer becomes disabled, and ignores source values while the
 * timer is enabled. Initially, the timer is disabled. As soon as the first
 * source value arrives, the timer is enabled. After `duration` milliseconds (or
 * the time unit determined internally by the optional `scheduler`) has passed,
 * the timer is disabled, then the most recent source value is emitted on the
 * output Observable, and this process repeats for the next source value.
 * Optionally takes a {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.auditTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} duration Time to wait before emitting the most recent source
 * value, measured in milliseconds or the time unit determined internally
 * by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the rate-limiting behavior.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method auditTime
 * @owner Observable
 */ function $6731897458e7c8c2$var$auditTime(duration, scheduler) {
    if (scheduler === void 0) scheduler = $jAy5L.async;
    return $6EsY3.audit(function() {
        return $29oaj.timer(duration, scheduler);
    });
}
$6731897458e7c8c2$export$719c70722b10e5ff = $6731897458e7c8c2$var$auditTime;

});

parcelRegister("lQxTf", function(module, exports) {

$parcel$export(module.exports, "combineAll", () => $fe78be27543b4238$export$29ae691b7de52fe3, (v) => $fe78be27543b4238$export$29ae691b7de52fe3 = v);
var $fe78be27543b4238$export$29ae691b7de52fe3;
"use strict";

var $fEMiR = parcelRequire("fEMiR");
function $fe78be27543b4238$var$combineAll(project) {
    return function(source) {
        return source.lift(new $fEMiR.CombineLatestOperator(project));
    };
}
$fe78be27543b4238$export$29ae691b7de52fe3 = $fe78be27543b4238$var$combineAll;

});

parcelRegister("cmPKV", function(module, exports) {

$parcel$export(module.exports, "concatMapTo", () => $900fafbfb298cbe8$export$82fbd7a2841d2484, (v) => $900fafbfb298cbe8$export$82fbd7a2841d2484 = v);
var $900fafbfb298cbe8$export$82fbd7a2841d2484;
"use strict";

var $eGPtZ = parcelRequire("eGPtZ");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is merged multiple
 * times in a serialized fashion on the output Observable.
 *
 * <span class="informal">It's like {@link concatMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/concatMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. Each new `innerObservable`
 * instance emitted on the output Observable is concatenated with the previous
 * `innerObservable` instance.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMapTo` is equivalent to `mergeMapTo` with concurrency parameter
 * set to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMapTo(Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link mergeMapTo}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An observable of values merged together by joining the
 * passed observable with itself, one after the other, for each value emitted
 * from the source.
 * @method concatMapTo
 * @owner Observable
 */ function $900fafbfb298cbe8$var$concatMapTo(innerObservable, resultSelector) {
    return $eGPtZ.concatMap(function() {
        return innerObservable;
    }, resultSelector);
}
$900fafbfb298cbe8$export$82fbd7a2841d2484 = $900fafbfb298cbe8$var$concatMapTo;

});

parcelRegister("9INaL", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");
/**
 * Counts the number of emissions on the source and emits that number when the
 * source completes.
 *
 * <span class="informal">Tells how many values were emitted, when the source
 * completes.</span>
 *
 * <img src="./img/count.png" width="100%">
 *
 * `count` transforms an Observable that emits values into an Observable that
 * emits a single value that represents the number of values emitted by the
 * source Observable. If the source Observable terminates with an error, `count`
 * will pass this error notification along without emitting a value first. If
 * the source Observable does not terminate at all, `count` will neither emit
 * a value nor terminate. This operator takes an optional `predicate` function
 * as argument, in which case the output emission will represent the number of
 * source values that matched `true` with the `predicate`.
 *
 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var secondsBeforeClick = seconds.takeUntil(clicks);
 * var result = secondsBeforeClick.count();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
 * var numbers = Rx.Observable.range(1, 7);
 * var result = numbers.count(i => i % 2 === 1);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 4
 *
 * @see {@link max}
 * @see {@link min}
 * @see {@link reduce}
 *
 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
 * boolean function to select what values are to be counted. It is provided with
 * arguments of:
 * - `value`: the value from the source Observable.
 * - `index`: the (zero-based) "index" of the value from the source Observable.
 * - `source`: the source Observable instance itself.
 * @return {Observable} An Observable of one number that represents the count as
 * described above.
 * @method count
 * @owner Observable
 */ function count(predicate) {
    return function(source) {
        return source.lift(new CountOperator(predicate, source));
    };
}
exports.count = count;
var CountOperator = function() {
    function CountOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    CountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new CountSubscriber(subscriber, this.predicate, this.source));
    };
    return CountOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var CountSubscriber = function(_super) {
    __extends(CountSubscriber, _super);
    function CountSubscriber(destination, predicate, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.count = 0;
        this.index = 0;
    }
    CountSubscriber.prototype._next = function(value) {
        if (this.predicate) this._tryPredicate(value);
        else this.count++;
    };
    CountSubscriber.prototype._tryPredicate = function(value) {
        var result;
        try {
            result = this.predicate(value, this.index++, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.count++;
    };
    CountSubscriber.prototype._complete = function() {
        this.destination.next(this.count);
        this.destination.complete();
    };
    return CountSubscriber;
}($a7QRR.Subscriber);

});

parcelRegister("jrplL", function(module, exports) {
"use strict";
var $e27433ea0c9c0240$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");

var $3JafE = parcelRequire("3JafE");

var $6UnJS = parcelRequire("6UnJS");

var $87MtM = parcelRequire("87MtM");
/**
 * Delays the emission of items from the source Observable by a given time span
 * determined by the emissions of another Observable.
 *
 * <span class="informal">It's like {@link delay}, but the time span of the
 * delay duration is determined by a second Observable.</span>
 *
 * <img src="./img/delayWhen.png" width="100%">
 *
 * `delayWhen` time shifts each emitted value from the source Observable by a
 * time span determined by another Observable. When the source emits a value,
 * the `delayDurationSelector` function is called with the source value as
 * argument, and should return an Observable, called the "duration" Observable.
 * The source value is emitted on the output Observable only when the duration
 * Observable emits a value or completes.
 *
 * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
 * is an Observable. When `subscriptionDelay` emits its first value or
 * completes, the source Observable is subscribed to and starts behaving like
 * described in the previous paragraph. If `subscriptionDelay` is not provided,
 * `delayWhen` will subscribe to the source Observable as soon as the output
 * Observable is subscribed.
 *
 * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delayWhen(event =>
 *   Rx.Observable.interval(Math.random() * 5000)
 * );
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounce}
 * @see {@link delay}
 *
 * @param {function(value: T): Observable} delayDurationSelector A function that
 * returns an Observable for each value emitted by the source Observable, which
 * is then used to delay the emission of that item on the output Observable
 * until the Observable returned from this function emits a value.
 * @param {Observable} subscriptionDelay An Observable that triggers the
 * subscription to the source Observable once it emits any value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by an amount of time specified by the Observable returned by
 * `delayDurationSelector`.
 * @method delayWhen
 * @owner Observable
 */ function $e27433ea0c9c0240$var$delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) return function(source) {
        return new $e27433ea0c9c0240$var$SubscriptionDelayObservable(source, subscriptionDelay).lift(new $e27433ea0c9c0240$var$DelayWhenOperator(delayDurationSelector));
    };
    return function(source) {
        return source.lift(new $e27433ea0c9c0240$var$DelayWhenOperator(delayDurationSelector));
    };
}
module.exports.delayWhen = $e27433ea0c9c0240$var$delayWhen;
var $e27433ea0c9c0240$var$DelayWhenOperator = function() {
    function DelayWhenOperator(delayDurationSelector) {
        this.delayDurationSelector = delayDurationSelector;
    }
    DelayWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $e27433ea0c9c0240$var$DelayWhenSubscriber(subscriber, this.delayDurationSelector));
    };
    return DelayWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $e27433ea0c9c0240$var$DelayWhenSubscriber = function(_super) {
    $e27433ea0c9c0240$var$__extends(DelayWhenSubscriber, _super);
    function DelayWhenSubscriber(destination, delayDurationSelector) {
        _super.call(this, destination);
        this.delayDurationSelector = delayDurationSelector;
        this.completed = false;
        this.delayNotifierSubscriptions = [];
        this.values = [];
    }
    DelayWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(outerValue);
        this.removeSubscription(innerSub);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    DelayWhenSubscriber.prototype.notifyComplete = function(innerSub) {
        var value = this.removeSubscription(innerSub);
        if (value) this.destination.next(value);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype._next = function(value) {
        try {
            var delayNotifier = this.delayDurationSelector(value);
            if (delayNotifier) this.tryDelay(delayNotifier, value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    DelayWhenSubscriber.prototype._complete = function() {
        this.completed = true;
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.removeSubscription = function(subscription) {
        subscription.unsubscribe();
        var subscriptionIdx = this.delayNotifierSubscriptions.indexOf(subscription);
        var value = null;
        if (subscriptionIdx !== -1) {
            value = this.values[subscriptionIdx];
            this.delayNotifierSubscriptions.splice(subscriptionIdx, 1);
            this.values.splice(subscriptionIdx, 1);
        }
        return value;
    };
    DelayWhenSubscriber.prototype.tryDelay = function(delayNotifier, value) {
        var notifierSubscription = $87MtM.subscribeToResult(this, delayNotifier, value);
        if (notifierSubscription && !notifierSubscription.closed) {
            this.add(notifierSubscription);
            this.delayNotifierSubscriptions.push(notifierSubscription);
        }
        this.values.push(value);
    };
    DelayWhenSubscriber.prototype.tryComplete = function() {
        if (this.completed && this.delayNotifierSubscriptions.length === 0) this.destination.complete();
    };
    return DelayWhenSubscriber;
}($6UnJS.OuterSubscriber);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $e27433ea0c9c0240$var$SubscriptionDelayObservable = function(_super) {
    $e27433ea0c9c0240$var$__extends(SubscriptionDelayObservable, _super);
    function SubscriptionDelayObservable(/** @deprecated internal use only */ source, subscriptionDelay) {
        _super.call(this);
        this.source = source;
        this.subscriptionDelay = subscriptionDelay;
    }
    /** @deprecated internal use only */ SubscriptionDelayObservable.prototype._subscribe = function(subscriber) {
        this.subscriptionDelay.subscribe(new $e27433ea0c9c0240$var$SubscriptionDelaySubscriber(subscriber, this.source));
    };
    return SubscriptionDelayObservable;
}($3JafE.Observable);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $e27433ea0c9c0240$var$SubscriptionDelaySubscriber = function(_super) {
    $e27433ea0c9c0240$var$__extends(SubscriptionDelaySubscriber, _super);
    function SubscriptionDelaySubscriber(parent, source) {
        _super.call(this);
        this.parent = parent;
        this.source = source;
        this.sourceSubscribed = false;
    }
    SubscriptionDelaySubscriber.prototype._next = function(unused) {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype._error = function(err) {
        this.unsubscribe();
        this.parent.error(err);
    };
    SubscriptionDelaySubscriber.prototype._complete = function() {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype.subscribeToSource = function() {
        if (!this.sourceSubscribed) {
            this.sourceSubscribed = true;
            this.unsubscribe();
            this.source.subscribe(this.parent);
        }
    };
    return SubscriptionDelaySubscriber;
}($a7QRR.Subscriber);

});

parcelRegister("GQ41u", function(module, exports) {
"use strict";
var $080c4f298d24b623$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");
/**
 * Converts an Observable of {@link Notification} objects into the emissions
 * that they represent.
 *
 * <span class="informal">Unwraps {@link Notification} objects as actual `next`,
 * `error` and `complete` emissions. The opposite of {@link materialize}.</span>
 *
 * <img src="./img/dematerialize.png" width="100%">
 *
 * `dematerialize` is assumed to operate an Observable that only emits
 * {@link Notification} objects as `next` emissions, and does not emit any
 * `error`. Such Observable is the output of a `materialize` operation. Those
 * notifications are then unwrapped using the metadata they contain, and emitted
 * as `next`, `error`, and `complete` on the output Observable.
 *
 * Use this operator in conjunction with {@link materialize}.
 *
 * @example <caption>Convert an Observable of Notifications to an actual Observable</caption>
 * var notifA = new Rx.Notification('N', 'A');
 * var notifB = new Rx.Notification('N', 'B');
 * var notifE = new Rx.Notification('E', void 0,
 *   new TypeError('x.toUpperCase is not a function')
 * );
 * var materialized = Rx.Observable.of(notifA, notifB, notifE);
 * var upperCase = materialized.dematerialize();
 * upperCase.subscribe(x => console.log(x), e => console.error(e));
 *
 * // Results in:
 * // A
 * // B
 * // TypeError: x.toUpperCase is not a function
 *
 * @see {@link Notification}
 * @see {@link materialize}
 *
 * @return {Observable} An Observable that emits items and notifications
 * embedded in Notification objects emitted by the source Observable.
 * @method dematerialize
 * @owner Observable
 */ function $080c4f298d24b623$var$dematerialize() {
    return function dematerializeOperatorFunction(source) {
        return source.lift(new $080c4f298d24b623$var$DeMaterializeOperator());
    };
}
module.exports.dematerialize = $080c4f298d24b623$var$dematerialize;
var $080c4f298d24b623$var$DeMaterializeOperator = function() {
    function DeMaterializeOperator() {}
    DeMaterializeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $080c4f298d24b623$var$DeMaterializeSubscriber(subscriber));
    };
    return DeMaterializeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $080c4f298d24b623$var$DeMaterializeSubscriber = function(_super) {
    $080c4f298d24b623$var$__extends(DeMaterializeSubscriber, _super);
    function DeMaterializeSubscriber(destination) {
        _super.call(this, destination);
    }
    DeMaterializeSubscriber.prototype._next = function(value) {
        value.observe(this.destination);
    };
    return DeMaterializeSubscriber;
}($a7QRR.Subscriber);

});

parcelRegister("ktZdP", function(module, exports) {
"use strict";
var $ee96017fcd44b195$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $6UnJS = parcelRequire("6UnJS");

var $87MtM = parcelRequire("87MtM");

var $4O2Rl = parcelRequire("4O2Rl");
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from previous items.
 *
 * If a keySelector function is provided, then it will project each value from the source observable into a new value that it will
 * check for equality with previously projected values. If a keySelector function is not provided, it will use each value from the
 * source observable directly with an equality check against previous values.
 *
 * In JavaScript runtimes that support `Set`, this operator will use a `Set` to improve performance of the distinct value checking.
 *
 * In other runtimes, this operator will use a minimal implementation of `Set` that relies on an `Array` and `indexOf` under the
 * hood, so performance will degrade as more values are checked for distinction. Even in newer browsers, a long-running `distinct`
 * use might result in memory leaks. To help alleviate this in some scenarios, an optional `flushes` parameter is also provided so
 * that the internal `Set` can be "flushed", basically clearing it of values.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 2, 3, 4, 3, 2, 1)
 *   .distinct()
 *   .subscribe(x => console.log(x)); // 1, 2, 3, 4
 *
 * @example <caption>An example using a keySelector function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     .distinct((p: Person) => p.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 *
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [keySelector] Optional function to select which value you want to check as distinct.
 * @param {Observable} [flushes] Optional Observable for flushing the internal HashSet of the operator.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinct
 * @owner Observable
 */ function $ee96017fcd44b195$var$distinct(keySelector, flushes) {
    return function(source) {
        return source.lift(new $ee96017fcd44b195$var$DistinctOperator(keySelector, flushes));
    };
}
module.exports.distinct = $ee96017fcd44b195$var$distinct;
var $ee96017fcd44b195$var$DistinctOperator = function() {
    function DistinctOperator(keySelector, flushes) {
        this.keySelector = keySelector;
        this.flushes = flushes;
    }
    DistinctOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $ee96017fcd44b195$var$DistinctSubscriber(subscriber, this.keySelector, this.flushes));
    };
    return DistinctOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $ee96017fcd44b195$var$DistinctSubscriber = function(_super) {
    $ee96017fcd44b195$var$__extends(DistinctSubscriber, _super);
    function DistinctSubscriber(destination, keySelector, flushes) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.values = new $4O2Rl.Set();
        if (flushes) this.add($87MtM.subscribeToResult(this, flushes));
    }
    DistinctSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values.clear();
    };
    DistinctSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    DistinctSubscriber.prototype._next = function(value) {
        if (this.keySelector) this._useKeySelector(value);
        else this._finalizeNext(value, value);
    };
    DistinctSubscriber.prototype._useKeySelector = function(value) {
        var key;
        var destination = this.destination;
        try {
            key = this.keySelector(value);
        } catch (err) {
            destination.error(err);
            return;
        }
        this._finalizeNext(key, value);
    };
    DistinctSubscriber.prototype._finalizeNext = function(key, value) {
        var values = this.values;
        if (!values.has(key)) {
            values.add(key);
            this.destination.next(value);
        }
    };
    return DistinctSubscriber;
}($6UnJS.OuterSubscriber);
module.exports.DistinctSubscriber = $ee96017fcd44b195$var$DistinctSubscriber;

});
parcelRegister("4O2Rl", function(module, exports) {

$parcel$export(module.exports, "Set", () => $37fe0cc18a040ad7$export$bdf4ff5a442cbbc5, (v) => $37fe0cc18a040ad7$export$bdf4ff5a442cbbc5 = v);
var $37fe0cc18a040ad7$export$ac57f2e66ff143c0;
var $37fe0cc18a040ad7$export$bdf4ff5a442cbbc5;
"use strict";

var $kt6O7 = parcelRequire("kt6O7");
function $37fe0cc18a040ad7$var$minimalSetImpl() {
    // THIS IS NOT a full impl of Set, this is just the minimum
    // bits of functionality we need for this library.
    return function() {
        function MinimalSet() {
            this._values = [];
        }
        MinimalSet.prototype.add = function(value) {
            if (!this.has(value)) this._values.push(value);
        };
        MinimalSet.prototype.has = function(value) {
            return this._values.indexOf(value) !== -1;
        };
        Object.defineProperty(MinimalSet.prototype, "size", {
            get: function() {
                return this._values.length;
            },
            enumerable: true,
            configurable: true
        });
        MinimalSet.prototype.clear = function() {
            this._values.length = 0;
        };
        return MinimalSet;
    }();
}
$37fe0cc18a040ad7$export$ac57f2e66ff143c0 = $37fe0cc18a040ad7$var$minimalSetImpl;
$37fe0cc18a040ad7$export$bdf4ff5a442cbbc5 = $kt6O7.root.Set || $37fe0cc18a040ad7$var$minimalSetImpl();

});


parcelRegister("aS1Fs", function(module, exports) {

$parcel$export(module.exports, "distinctUntilKeyChanged", () => $7ea03dad1c484c95$export$571da16e28367bde, (v) => $7ea03dad1c484c95$export$571da16e28367bde = v);
var $7ea03dad1c484c95$export$571da16e28367bde;
"use strict";

var $8xAAu = parcelRequire("8xAAu");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item,
 * using a property accessed by using the key provided to check if the two items are distinct.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>An example comparing the name of persons</caption>
 *
 *  interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'},
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilKeyChanged('name')
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @example <caption>An example comparing the first letters of the name</caption>
 *
 * interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo1'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo2'},
 *     { age: 6, name: 'Foo3'})
 *     .distinctUntilKeyChanged('name', (x: string, y: string) => x.substring(0, 3) === y.substring(0, 3))
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo1' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo2' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 *
 * @param {string} key String key for object property lookup on each item.
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values based on the key specified.
 * @method distinctUntilKeyChanged
 * @owner Observable
 */ function $7ea03dad1c484c95$var$distinctUntilKeyChanged(key, compare) {
    return $8xAAu.distinctUntilChanged(function(x, y) {
        return compare ? compare(x[key], y[key]) : x[key] === y[key];
    });
}
$7ea03dad1c484c95$export$571da16e28367bde = $7ea03dad1c484c95$var$distinctUntilKeyChanged;

});

parcelRegister("8WPKc", function(module, exports) {
"use strict";
var $683be0cdb6a2fde9$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");

var $2l9IB = parcelRequire("2l9IB");
/**
 * Emits the single value at the specified `index` in a sequence of emissions
 * from the source Observable.
 *
 * <span class="informal">Emits only the i-th value, then completes.</span>
 *
 * <img src="./img/elementAt.png" width="100%">
 *
 * `elementAt` returns an Observable that emits the item at the specified
 * `index` in the source Observable, or a default value if that `index` is out
 * of range and the `default` argument is provided. If the `default` argument is
 * not given and the `index` is out of range, the output Observable will emit an
 * `ArgumentOutOfRangeError` error.
 *
 * @example <caption>Emit only the third click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.elementAt(2);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // click 1 = nothing
 * // click 2 = nothing
 * // click 3 = MouseEvent object logged to console
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link skip}
 * @see {@link single}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `elementAt(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0` or the
 * Observable has completed before emitting the i-th `next` notification.
 *
 * @param {number} index Is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {T} [defaultValue] The default value returned for missing indices.
 * @return {Observable} An Observable that emits a single item, if it is found.
 * Otherwise, will emit the default value if given. If not, then emits an error.
 * @method elementAt
 * @owner Observable
 */ function $683be0cdb6a2fde9$var$elementAt(index, defaultValue) {
    return function(source) {
        return source.lift(new $683be0cdb6a2fde9$var$ElementAtOperator(index, defaultValue));
    };
}
module.exports.elementAt = $683be0cdb6a2fde9$var$elementAt;
var $683be0cdb6a2fde9$var$ElementAtOperator = function() {
    function ElementAtOperator(index, defaultValue) {
        this.index = index;
        this.defaultValue = defaultValue;
        if (index < 0) throw new $2l9IB.ArgumentOutOfRangeError;
    }
    ElementAtOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $683be0cdb6a2fde9$var$ElementAtSubscriber(subscriber, this.index, this.defaultValue));
    };
    return ElementAtOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $683be0cdb6a2fde9$var$ElementAtSubscriber = function(_super) {
    $683be0cdb6a2fde9$var$__extends(ElementAtSubscriber, _super);
    function ElementAtSubscriber(destination, index, defaultValue) {
        _super.call(this, destination);
        this.index = index;
        this.defaultValue = defaultValue;
    }
    ElementAtSubscriber.prototype._next = function(x) {
        if (this.index-- === 0) {
            this.destination.next(x);
            this.destination.complete();
        }
    };
    ElementAtSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (this.index >= 0) {
            if (typeof this.defaultValue !== 'undefined') destination.next(this.defaultValue);
            else destination.error(new $2l9IB.ArgumentOutOfRangeError);
        }
        destination.complete();
    };
    return ElementAtSubscriber;
}($a7QRR.Subscriber);

});

parcelRegister("7OVJ1", function(module, exports) {
"use strict";
var $5b19faf2e2b0f1a6$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");
/**
 * Returns an Observable that emits whether or not every item of the source satisfies the condition specified.
 *
 * @example <caption>A simple example emitting true if all elements are less than 5, false otherwise</caption>
 *  Observable.of(1, 2, 3, 4, 5, 6)
 *     .every(x => x < 5)
 *     .subscribe(x => console.log(x)); // -> false
 *
 * @param {function} predicate A function for determining if an item meets a specified condition.
 * @param {any} [thisArg] Optional object to use for `this` in the callback.
 * @return {Observable} An Observable of booleans that determines if all items of the source Observable meet the condition specified.
 * @method every
 * @owner Observable
 */ function $5b19faf2e2b0f1a6$var$every(predicate, thisArg) {
    return function(source) {
        return source.lift(new $5b19faf2e2b0f1a6$var$EveryOperator(predicate, thisArg, source));
    };
}
module.exports.every = $5b19faf2e2b0f1a6$var$every;
var $5b19faf2e2b0f1a6$var$EveryOperator = function() {
    function EveryOperator(predicate, thisArg, source) {
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
    }
    EveryOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $5b19faf2e2b0f1a6$var$EverySubscriber(observer, this.predicate, this.thisArg, this.source));
    };
    return EveryOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $5b19faf2e2b0f1a6$var$EverySubscriber = function(_super) {
    $5b19faf2e2b0f1a6$var$__extends(EverySubscriber, _super);
    function EverySubscriber(destination, predicate, thisArg, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
        this.index = 0;
        this.thisArg = thisArg || this;
    }
    EverySubscriber.prototype.notifyComplete = function(everyValueMatch) {
        this.destination.next(everyValueMatch);
        this.destination.complete();
    };
    EverySubscriber.prototype._next = function(value) {
        var result = false;
        try {
            result = this.predicate.call(this.thisArg, value, this.index++, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (!result) this.notifyComplete(false);
    };
    EverySubscriber.prototype._complete = function() {
        this.notifyComplete(true);
    };
    return EverySubscriber;
}($a7QRR.Subscriber);

});

parcelRegister("3VDHE", function(module, exports) {
"use strict";
var $2dc57e30ccabf3fd$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $6UnJS = parcelRequire("6UnJS");

var $87MtM = parcelRequire("87MtM");
/**
 * Converts a higher-order Observable into a first-order Observable by dropping
 * inner Observables while the previous inner Observable has not yet completed.
 *
 * <span class="informal">Flattens an Observable-of-Observables by dropping the
 * next inner Observables while the current inner is still executing.</span>
 *
 * <img src="./img/exhaust.png" width="100%">
 *
 * `exhaust` subscribes to an Observable that emits Observables, also known as a
 * higher-order Observable. Each time it observes one of these emitted inner
 * Observables, the output Observable begins emitting the items emitted by that
 * inner Observable. So far, it behaves like {@link mergeAll}. However,
 * `exhaust` ignores every new inner Observable if the previous Observable has
 * not yet completed. Once that one completes, it will accept and flatten the
 * next inner Observable and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(5));
 * var result = higherOrder.exhaust();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link switch}
 * @see {@link mergeAll}
 * @see {@link exhaustMap}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable that takes a source of Observables and propagates the first observable
 * exclusively until it completes before subscribing to the next.
 * @method exhaust
 * @owner Observable
 */ function $2dc57e30ccabf3fd$var$exhaust() {
    return function(source) {
        return source.lift(new $2dc57e30ccabf3fd$var$SwitchFirstOperator());
    };
}
module.exports.exhaust = $2dc57e30ccabf3fd$var$exhaust;
var $2dc57e30ccabf3fd$var$SwitchFirstOperator = function() {
    function SwitchFirstOperator() {}
    SwitchFirstOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2dc57e30ccabf3fd$var$SwitchFirstSubscriber(subscriber));
    };
    return SwitchFirstOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2dc57e30ccabf3fd$var$SwitchFirstSubscriber = function(_super) {
    $2dc57e30ccabf3fd$var$__extends(SwitchFirstSubscriber, _super);
    function SwitchFirstSubscriber(destination) {
        _super.call(this, destination);
        this.hasCompleted = false;
        this.hasSubscription = false;
    }
    SwitchFirstSubscriber.prototype._next = function(value) {
        if (!this.hasSubscription) {
            this.hasSubscription = true;
            this.add($87MtM.subscribeToResult(this, value));
        }
    };
    SwitchFirstSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (!this.hasSubscription) this.destination.complete();
    };
    SwitchFirstSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.hasSubscription = false;
        if (this.hasCompleted) this.destination.complete();
    };
    return SwitchFirstSubscriber;
}($6UnJS.OuterSubscriber);

});

parcelRegister("3MmTN", function(module, exports) {
"use strict";
var $2c079e0ae269a818$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jJdW6 = parcelRequire("jJdW6");

var $4b4q3 = parcelRequire("4b4q3");

var $6UnJS = parcelRequire("6UnJS");

var $87MtM = parcelRequire("87MtM");
/* tslint:enable:max-line-length */ /**
 * Recursively projects each source value to an Observable which is merged in
 * the output Observable.
 *
 * <span class="informal">It's similar to {@link mergeMap}, but applies the
 * projection function to every source value as well as every output value.
 * It's recursive.</span>
 *
 * <img src="./img/expand.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger. *Expand* will re-emit on the output
 * Observable every source value. Then, each output value is given to the
 * `project` function which returns an inner Observable to be merged on the
 * output Observable. Those output values resulting from the projection are also
 * given to the `project` function to produce new output values. This is how
 * *expand* behaves recursively.
 *
 * @example <caption>Start emitting the powers of two on every click, at most 10 of them</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var powersOfTwo = clicks
 *   .mapTo(1)
 *   .expand(x => Rx.Observable.of(2 * x).delay(1000))
 *   .take(10);
 * powersOfTwo.subscribe(x => console.log(x));
 *
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 *
 * @param {function(value: T, index: number) => Observable} project A function
 * that, when applied to an item emitted by the source or the output Observable,
 * returns an Observable.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
 * each projected inner Observable.
 * @return {Observable} An Observable that emits the source values and also
 * result of applying the projection function to each value emitted on the
 * output Observable and and merging the results of the Observables obtained
 * from this transformation.
 * @method expand
 * @owner Observable
 */ function $2c079e0ae269a818$var$expand(project, concurrent, scheduler) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (scheduler === void 0) scheduler = undefined;
    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
    return function(source) {
        return source.lift(new $2c079e0ae269a818$var$ExpandOperator(project, concurrent, scheduler));
    };
}
module.exports.expand = $2c079e0ae269a818$var$expand;
var $2c079e0ae269a818$var$ExpandOperator = function() {
    function ExpandOperator(project, concurrent, scheduler) {
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
    }
    ExpandOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2c079e0ae269a818$var$ExpandSubscriber(subscriber, this.project, this.concurrent, this.scheduler));
    };
    return ExpandOperator;
}();
module.exports.ExpandOperator = $2c079e0ae269a818$var$ExpandOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2c079e0ae269a818$var$ExpandSubscriber = function(_super) {
    $2c079e0ae269a818$var$__extends(ExpandSubscriber, _super);
    function ExpandSubscriber(destination, project, concurrent, scheduler) {
        _super.call(this, destination);
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
        this.index = 0;
        this.active = 0;
        this.hasCompleted = false;
        if (concurrent < Number.POSITIVE_INFINITY) this.buffer = [];
    }
    ExpandSubscriber.dispatch = function(arg) {
        var subscriber = arg.subscriber, result = arg.result, value = arg.value, index = arg.index;
        subscriber.subscribeToProjection(result, value, index);
    };
    ExpandSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (destination.closed) {
            this._complete();
            return;
        }
        var index = this.index++;
        if (this.active < this.concurrent) {
            destination.next(value);
            var result = $jJdW6.tryCatch(this.project)(value, index);
            if (result === $4b4q3.errorObject) destination.error($4b4q3.errorObject.e);
            else if (!this.scheduler) this.subscribeToProjection(result, value, index);
            else {
                var state = {
                    subscriber: this,
                    result: result,
                    value: value,
                    index: index
                };
                this.add(this.scheduler.schedule(ExpandSubscriber.dispatch, 0, state));
            }
        } else this.buffer.push(value);
    };
    ExpandSubscriber.prototype.subscribeToProjection = function(result, value, index) {
        this.active++;
        this.add($87MtM.subscribeToResult(this, result, value, index));
    };
    ExpandSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.hasCompleted && this.active === 0) this.destination.complete();
    };
    ExpandSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this._next(innerValue);
    };
    ExpandSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer && buffer.length > 0) this._next(buffer.shift());
        if (this.hasCompleted && this.active === 0) this.destination.complete();
    };
    return ExpandSubscriber;
}($6UnJS.OuterSubscriber);
module.exports.ExpandSubscriber = $2c079e0ae269a818$var$ExpandSubscriber;

});

parcelRegister("lHxIn", function(module, exports) {
"use strict";
var $fcc7c427fea3323e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");
/**
 * Emits only the first value emitted by the source Observable that meets some
 * condition.
 *
 * <span class="informal">Finds the first value that passes some test and emits
 * that.</span>
 *
 * <img src="./img/find.png" width="100%">
 *
 * `find` searches for the first item in the source Observable that matches the
 * specified condition embodied by the `predicate`, and returns the first
 * occurrence in the source. Unlike {@link first}, the `predicate` is required
 * in `find`, and does not emit an error if a valid value is not found.
 *
 * @example <caption>Find and emit the first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.find(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link first}
 * @see {@link findIndex}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable<T>} An Observable of the first item that matches the
 * condition.
 * @method find
 * @owner Observable
 */ function $fcc7c427fea3323e$var$find(predicate, thisArg) {
    if (typeof predicate !== 'function') throw new TypeError('predicate is not a function');
    return function(source) {
        return source.lift(new $fcc7c427fea3323e$var$FindValueOperator(predicate, source, false, thisArg));
    };
}
module.exports.find = $fcc7c427fea3323e$var$find;
var $fcc7c427fea3323e$var$FindValueOperator = function() {
    function FindValueOperator(predicate, source, yieldIndex, thisArg) {
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
    }
    FindValueOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $fcc7c427fea3323e$var$FindValueSubscriber(observer, this.predicate, this.source, this.yieldIndex, this.thisArg));
    };
    return FindValueOperator;
}();
module.exports.FindValueOperator = $fcc7c427fea3323e$var$FindValueOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $fcc7c427fea3323e$var$FindValueSubscriber = function(_super) {
    $fcc7c427fea3323e$var$__extends(FindValueSubscriber, _super);
    function FindValueSubscriber(destination, predicate, source, yieldIndex, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
        this.index = 0;
    }
    FindValueSubscriber.prototype.notifyComplete = function(value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    FindValueSubscriber.prototype._next = function(value) {
        var _a = this, predicate = _a.predicate, thisArg = _a.thisArg;
        var index = this.index++;
        try {
            var result = predicate.call(thisArg || this, value, index, this.source);
            if (result) this.notifyComplete(this.yieldIndex ? index : value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    FindValueSubscriber.prototype._complete = function() {
        this.notifyComplete(this.yieldIndex ? -1 : undefined);
    };
    return FindValueSubscriber;
}($a7QRR.Subscriber);
module.exports.FindValueSubscriber = $fcc7c427fea3323e$var$FindValueSubscriber;

});

parcelRegister("1as0c", function(module, exports) {

$parcel$export(module.exports, "findIndex", () => $0d9c7244067d9f71$export$de3a4d4a0d731119, (v) => $0d9c7244067d9f71$export$de3a4d4a0d731119 = v);
var $0d9c7244067d9f71$export$de3a4d4a0d731119;
"use strict";

var $lHxIn = parcelRequire("lHxIn");
/**
 * Emits only the index of the first value emitted by the source Observable that
 * meets some condition.
 *
 * <span class="informal">It's like {@link find}, but emits the index of the
 * found value, not the value itself.</span>
 *
 * <img src="./img/findIndex.png" width="100%">
 *
 * `findIndex` searches for the first item in the source Observable that matches
 * the specified condition embodied by the `predicate`, and returns the
 * (zero-based) index of the first occurrence in the source. Unlike
 * {@link first}, the `predicate` is required in `findIndex`, and does not emit
 * an error if a valid value is not found.
 *
 * @example <caption>Emit the index of first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.findIndex(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link first}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of the index of the first item that
 * matches the condition.
 * @method find
 * @owner Observable
 */ function $0d9c7244067d9f71$var$findIndex(predicate, thisArg) {
    return function(source) {
        return source.lift(new $lHxIn.FindValueOperator(predicate, source, true, thisArg));
    };
}
$0d9c7244067d9f71$export$de3a4d4a0d731119 = $0d9c7244067d9f71$var$findIndex;

});

parcelRegister("b095i", function(module, exports) {
"use strict";
var $8026bdc5b52f9431$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");
function $8026bdc5b52f9431$var$isEmpty() {
    return function(source) {
        return source.lift(new $8026bdc5b52f9431$var$IsEmptyOperator());
    };
}
module.exports.isEmpty = $8026bdc5b52f9431$var$isEmpty;
var $8026bdc5b52f9431$var$IsEmptyOperator = function() {
    function IsEmptyOperator() {}
    IsEmptyOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $8026bdc5b52f9431$var$IsEmptySubscriber(observer));
    };
    return IsEmptyOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $8026bdc5b52f9431$var$IsEmptySubscriber = function(_super) {
    $8026bdc5b52f9431$var$__extends(IsEmptySubscriber, _super);
    function IsEmptySubscriber(destination) {
        _super.call(this, destination);
    }
    IsEmptySubscriber.prototype.notifyComplete = function(isEmpty) {
        var destination = this.destination;
        destination.next(isEmpty);
        destination.complete();
    };
    IsEmptySubscriber.prototype._next = function(value) {
        this.notifyComplete(false);
    };
    IsEmptySubscriber.prototype._complete = function() {
        this.notifyComplete(true);
    };
    return IsEmptySubscriber;
}($a7QRR.Subscriber);

});

parcelRegister("iH3rg", function(module, exports) {
"use strict";
var $d9bee9014899c317$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");

var $8CxxK = parcelRequire("8CxxK");
/**
 * Represents all of the notifications from the source Observable as `next`
 * emissions marked with their original types within {@link Notification}
 * objects.
 *
 * <span class="informal">Wraps `next`, `error` and `complete` emissions in
 * {@link Notification} objects, emitted as `next` on the output Observable.
 * </span>
 *
 * <img src="./img/materialize.png" width="100%">
 *
 * `materialize` returns an Observable that emits a `next` notification for each
 * `next`, `error`, or `complete` emission of the source Observable. When the
 * source Observable emits `complete`, the output Observable will emit `next` as
 * a Notification of type "complete", and then it will emit `complete` as well.
 * When the source Observable emits `error`, the output will emit `next` as a
 * Notification of type "error", and then `complete`.
 *
 * This operator is useful for producing metadata of the source Observable, to
 * be consumed as `next` emissions. Use it in conjunction with
 * {@link dematerialize}.
 *
 * @example <caption>Convert a faulty Observable to an Observable of Notifications</caption>
 * var letters = Rx.Observable.of('a', 'b', 13, 'd');
 * var upperCase = letters.map(x => x.toUpperCase());
 * var materialized = upperCase.materialize();
 * materialized.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - Notification {kind: "N", value: "A", error: undefined, hasValue: true}
 * // - Notification {kind: "N", value: "B", error: undefined, hasValue: true}
 * // - Notification {kind: "E", value: undefined, error: TypeError:
 * //   x.toUpperCase is not a function at MapSubscriber.letters.map.x
 * //   [as project] (http://1…, hasValue: false}
 *
 * @see {@link Notification}
 * @see {@link dematerialize}
 *
 * @return {Observable<Notification<T>>} An Observable that emits
 * {@link Notification} objects that wrap the original emissions from the source
 * Observable with metadata.
 * @method materialize
 * @owner Observable
 */ function $d9bee9014899c317$var$materialize() {
    return function materializeOperatorFunction(source) {
        return source.lift(new $d9bee9014899c317$var$MaterializeOperator());
    };
}
module.exports.materialize = $d9bee9014899c317$var$materialize;
var $d9bee9014899c317$var$MaterializeOperator = function() {
    function MaterializeOperator() {}
    MaterializeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $d9bee9014899c317$var$MaterializeSubscriber(subscriber));
    };
    return MaterializeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d9bee9014899c317$var$MaterializeSubscriber = function(_super) {
    $d9bee9014899c317$var$__extends(MaterializeSubscriber, _super);
    function MaterializeSubscriber(destination) {
        _super.call(this, destination);
    }
    MaterializeSubscriber.prototype._next = function(value) {
        this.destination.next($8CxxK.Notification.createNext(value));
    };
    MaterializeSubscriber.prototype._error = function(err) {
        var destination = this.destination;
        destination.next($8CxxK.Notification.createError(err));
        destination.complete();
    };
    MaterializeSubscriber.prototype._complete = function() {
        var destination = this.destination;
        destination.next($8CxxK.Notification.createComplete());
        destination.complete();
    };
    return MaterializeSubscriber;
}($a7QRR.Subscriber);

});

parcelRegister("k4LFb", function(module, exports) {

$parcel$export(module.exports, "max", () => $e9d92748a5a915ec$export$8960430cfd85939f, (v) => $e9d92748a5a915ec$export$8960430cfd85939f = v);
var $e9d92748a5a915ec$export$8960430cfd85939f;
"use strict";

var $2N4j1 = parcelRequire("2N4j1");
/**
 * The Max operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the largest value.
 *
 * <img src="./img/max.png" width="100%">
 *
 * @example <caption>Get the maximal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .max()
 *   .subscribe(x => console.log(x)); // -> 8
 *
 * @example <caption>Use a comparer function to get the maximal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .max<Person>((a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Beer'
 * }
 *
 * @see {@link min}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable} An Observable that emits item with the largest value.
 * @method max
 * @owner Observable
 */ function $e9d92748a5a915ec$var$max(comparer) {
    var max = typeof comparer === 'function' ? function(x, y) {
        return comparer(x, y) > 0 ? x : y;
    } : function(x, y) {
        return x > y ? x : y;
    };
    return $2N4j1.reduce(max);
}
$e9d92748a5a915ec$export$8960430cfd85939f = $e9d92748a5a915ec$var$max;

});

parcelRegister("g0vpX", function(module, exports) {
"use strict";
var $ba7504565beee60f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $6UnJS = parcelRequire("6UnJS");

var $87MtM = parcelRequire("87MtM");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is merged multiple
 * times in the output Observable.
 *
 * <span class="informal">It's like {@link mergeMap}, but maps each value always
 * to the same inner Observable.</span>
 *
 * <img src="./img/mergeMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then merges those resulting Observables into one
 * single Observable, which is the output Observable.
 *
 * @example <caption>For each click event, start an interval Observable ticking every 1 second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.mergeMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable.
 * @method mergeMapTo
 * @owner Observable
 */ function $ba7504565beee60f$var$mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
        resultSelector = null;
    }
    return function(source) {
        return source.lift(new $ba7504565beee60f$var$MergeMapToOperator(innerObservable, resultSelector, concurrent));
    };
}
module.exports.mergeMapTo = $ba7504565beee60f$var$mergeMapTo;
// TODO: Figure out correct signature here: an Operator<Observable<T>, R>
//       needs to implement call(observer: Subscriber<R>): Subscriber<Observable<T>>
var $ba7504565beee60f$var$MergeMapToOperator = function() {
    function MergeMapToOperator(ish, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        this.ish = ish;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
    }
    MergeMapToOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $ba7504565beee60f$var$MergeMapToSubscriber(observer, this.ish, this.resultSelector, this.concurrent));
    };
    return MergeMapToOperator;
}();
module.exports.MergeMapToOperator = $ba7504565beee60f$var$MergeMapToOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $ba7504565beee60f$var$MergeMapToSubscriber = function(_super) {
    $ba7504565beee60f$var$__extends(MergeMapToSubscriber, _super);
    function MergeMapToSubscriber(destination, ish, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        _super.call(this, destination);
        this.ish = ish;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeMapToSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) {
            var resultSelector = this.resultSelector;
            var index = this.index++;
            var ish = this.ish;
            var destination = this.destination;
            this.active++;
            this._innerSub(ish, destination, resultSelector, value, index);
        } else this.buffer.push(value);
    };
    MergeMapToSubscriber.prototype._innerSub = function(ish, destination, resultSelector, value, index) {
        this.add($87MtM.subscribeToResult(this, ish, value, index));
    };
    MergeMapToSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) this.destination.complete();
    };
    MergeMapToSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        if (resultSelector) this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
        else destination.next(innerValue);
    };
    MergeMapToSubscriber.prototype.trySelectResult = function(outerValue, innerValue, outerIndex, innerIndex) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        var result;
        try {
            result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            destination.error(err);
            return;
        }
        destination.next(result);
    };
    MergeMapToSubscriber.prototype.notifyError = function(err) {
        this.destination.error(err);
    };
    MergeMapToSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) this.destination.complete();
    };
    return MergeMapToSubscriber;
}($6UnJS.OuterSubscriber);
module.exports.MergeMapToSubscriber = $ba7504565beee60f$var$MergeMapToSubscriber;

});

parcelRegister("6zXYF", function(module, exports) {
"use strict";
var $4ca48939de6a2f0b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jJdW6 = parcelRequire("jJdW6");

var $4b4q3 = parcelRequire("4b4q3");

var $87MtM = parcelRequire("87MtM");

var $6UnJS = parcelRequire("6UnJS");
/**
 * Applies an accumulator function over the source Observable where the
 * accumulator function itself returns an Observable, then each intermediate
 * Observable returned is merged into the output Observable.
 *
 * <span class="informal">It's like {@link scan}, but the Observables returned
 * by the accumulator are merged into the outer Observable.</span>
 *
 * @example <caption>Count the number of click events</caption>
 * const click$ = Rx.Observable.fromEvent(document, 'click');
 * const one$ = click$.mapTo(1);
 * const seed = 0;
 * const count$ = one$.mergeScan((acc, one) => Rx.Observable.of(acc + one), seed);
 * count$.subscribe(x => console.log(x));
 *
 * // Results:
 * 1
 * 2
 * 3
 * 4
 * // ...and so on for each click
 *
 * @param {function(acc: R, value: T): Observable<R>} accumulator
 * The accumulator function called on each source value.
 * @param seed The initial accumulation value.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of
 * input Observables being subscribed to concurrently.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method mergeScan
 * @owner Observable
 */ function $4ca48939de6a2f0b$var$mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return function(source) {
        return source.lift(new $4ca48939de6a2f0b$var$MergeScanOperator(accumulator, seed, concurrent));
    };
}
module.exports.mergeScan = $4ca48939de6a2f0b$var$mergeScan;
var $4ca48939de6a2f0b$var$MergeScanOperator = function() {
    function MergeScanOperator(accumulator, seed, concurrent) {
        this.accumulator = accumulator;
        this.seed = seed;
        this.concurrent = concurrent;
    }
    MergeScanOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $4ca48939de6a2f0b$var$MergeScanSubscriber(subscriber, this.accumulator, this.seed, this.concurrent));
    };
    return MergeScanOperator;
}();
module.exports.MergeScanOperator = $4ca48939de6a2f0b$var$MergeScanOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $4ca48939de6a2f0b$var$MergeScanSubscriber = function(_super) {
    $4ca48939de6a2f0b$var$__extends(MergeScanSubscriber, _super);
    function MergeScanSubscriber(destination, accumulator, acc, concurrent) {
        _super.call(this, destination);
        this.accumulator = accumulator;
        this.acc = acc;
        this.concurrent = concurrent;
        this.hasValue = false;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeScanSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) {
            var index = this.index++;
            var ish = $jJdW6.tryCatch(this.accumulator)(this.acc, value);
            var destination = this.destination;
            if (ish === $4b4q3.errorObject) destination.error($4b4q3.errorObject.e);
            else {
                this.active++;
                this._innerSub(ish, value, index);
            }
        } else this.buffer.push(value);
    };
    MergeScanSubscriber.prototype._innerSub = function(ish, value, index) {
        this.add($87MtM.subscribeToResult(this, ish, value, index));
    };
    MergeScanSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            if (this.hasValue === false) this.destination.next(this.acc);
            this.destination.complete();
        }
    };
    MergeScanSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var destination = this.destination;
        this.acc = innerValue;
        this.hasValue = true;
        destination.next(innerValue);
    };
    MergeScanSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) {
            if (this.hasValue === false) this.destination.next(this.acc);
            this.destination.complete();
        }
    };
    return MergeScanSubscriber;
}($6UnJS.OuterSubscriber);
module.exports.MergeScanSubscriber = $4ca48939de6a2f0b$var$MergeScanSubscriber;

});

parcelRegister("jwlZG", function(module, exports) {

$parcel$export(module.exports, "min", () => $e362110636412513$export$96ec731ed4dcb222, (v) => $e362110636412513$export$96ec731ed4dcb222 = v);
var $e362110636412513$export$96ec731ed4dcb222;
"use strict";

var $2N4j1 = parcelRequire("2N4j1");
/**
 * The Min operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the smallest value.
 *
 * <img src="./img/min.png" width="100%">
 *
 * @example <caption>Get the minimal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .min()
 *   .subscribe(x => console.log(x)); // -> 2
 *
 * @example <caption>Use a comparer function to get the minimal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .min<Person>( (a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Bar'
 * }
 *
 * @see {@link max}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable<R>} An Observable that emits item with the smallest value.
 * @method min
 * @owner Observable
 */ function $e362110636412513$var$min(comparer) {
    var min = typeof comparer === 'function' ? function(x, y) {
        return comparer(x, y) < 0 ? x : y;
    } : function(x, y) {
        return x < y ? x : y;
    };
    return $2N4j1.reduce(min);
}
$e362110636412513$export$96ec731ed4dcb222 = $e362110636412513$var$min;

});

parcelRegister("6wVip", function(module, exports) {
"use strict";
var $4c122d03b789c956$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $3Th2Y = parcelRequire("3Th2Y");

var $3DoUz = parcelRequire("3DoUz");

var $6UnJS = parcelRequire("6UnJS");

var $87MtM = parcelRequire("87MtM");
/* tslint:enable:max-line-length */ /**
 * When any of the provided Observable emits an complete or error notification, it immediately subscribes to the next one
 * that was passed.
 *
 * <span class="informal">Execute series of Observables no matter what, even if it means swallowing errors.</span>
 *
 * <img src="./img/onErrorResumeNext.png" width="100%">
 *
 * `onErrorResumeNext` is an operator that accepts a series of Observables, provided either directly as
 * arguments or as an array. If no single Observable is provided, returned Observable will simply behave the same
 * as the source.
 *
 * `onErrorResumeNext` returns an Observable that starts by subscribing and re-emitting values from the source Observable.
 * When its stream of values ends - no matter if Observable completed or emitted an error - `onErrorResumeNext`
 * will subscribe to the first Observable that was passed as an argument to the method. It will start re-emitting
 * its values as well and - again - when that stream ends, `onErrorResumeNext` will proceed to subscribing yet another
 * Observable in provided series, no matter if previous Observable completed or ended with an error. This will
 * be happening until there is no more Observables left in the series, at which point returned Observable will
 * complete - even if the last subscribed stream ended with an error.
 *
 * `onErrorResumeNext` can be therefore thought of as version of {@link concat} operator, which is more permissive
 * when it comes to the errors emitted by its input Observables. While `concat` subscribes to the next Observable
 * in series only if previous one successfully completed, `onErrorResumeNext` subscribes even if it ended with
 * an error.
 *
 * Note that you do not get any access to errors emitted by the Observables. In particular do not
 * expect these errors to appear in error callback passed to {@link subscribe}. If you want to take
 * specific actions based on what error was emitted by an Observable, you should try out {@link catch} instead.
 *
 *
 * @example <caption>Subscribe to the next Observable after map fails</caption>
 * Rx.Observable.of(1, 2, 3, 0)
 *   .map(x => {
 *       if (x === 0) { throw Error(); }
         return 10 / x;
 *   })
 *   .onErrorResumeNext(Rx.Observable.of(1, 2, 3))
 *   .subscribe(
 *     val => console.log(val),
 *     err => console.log(err),          // Will never be called.
 *     () => console.log('that\'s it!')
 *   );
 *
 * // Logs:
 * // 10
 * // 5
 * // 3.3333333333333335
 * // 1
 * // 2
 * // 3
 * // "that's it!"
 *
 * @see {@link concat}
 * @see {@link catch}
 *
 * @param {...ObservableInput} observables Observables passed either directly or as an array.
 * @return {Observable} An Observable that emits values from source Observable, but - if it errors - subscribes
 * to the next passed Observable and so on, until it completes or runs out of Observables.
 * @method onErrorResumeNext
 * @owner Observable
 */ function $4c122d03b789c956$var$onErrorResumeNext() {
    var nextSources = [];
    for(var _i = 0; _i < arguments.length; _i++)nextSources[_i - 0] = arguments[_i];
    if (nextSources.length === 1 && $3DoUz.isArray(nextSources[0])) nextSources = nextSources[0];
    return function(source) {
        return source.lift(new $4c122d03b789c956$var$OnErrorResumeNextOperator(nextSources));
    };
}
module.exports.onErrorResumeNext = $4c122d03b789c956$var$onErrorResumeNext;
/* tslint:enable:max-line-length */ function $4c122d03b789c956$var$onErrorResumeNextStatic() {
    var nextSources = [];
    for(var _i = 0; _i < arguments.length; _i++)nextSources[_i - 0] = arguments[_i];
    var source = null;
    if (nextSources.length === 1 && $3DoUz.isArray(nextSources[0])) nextSources = nextSources[0];
    source = nextSources.shift();
    return new $3Th2Y.FromObservable(source, null).lift(new $4c122d03b789c956$var$OnErrorResumeNextOperator(nextSources));
}
module.exports.onErrorResumeNextStatic = $4c122d03b789c956$var$onErrorResumeNextStatic;
var $4c122d03b789c956$var$OnErrorResumeNextOperator = function() {
    function OnErrorResumeNextOperator(nextSources) {
        this.nextSources = nextSources;
    }
    OnErrorResumeNextOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $4c122d03b789c956$var$OnErrorResumeNextSubscriber(subscriber, this.nextSources));
    };
    return OnErrorResumeNextOperator;
}();
var $4c122d03b789c956$var$OnErrorResumeNextSubscriber = function(_super) {
    $4c122d03b789c956$var$__extends(OnErrorResumeNextSubscriber, _super);
    function OnErrorResumeNextSubscriber(destination, nextSources) {
        _super.call(this, destination);
        this.destination = destination;
        this.nextSources = nextSources;
    }
    OnErrorResumeNextSubscriber.prototype.notifyError = function(error, innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.notifyComplete = function(innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._error = function(err) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._complete = function() {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.subscribeToNextSource = function() {
        var next = this.nextSources.shift();
        if (next) this.add($87MtM.subscribeToResult(this, next));
        else this.destination.complete();
    };
    return OnErrorResumeNextSubscriber;
}($6UnJS.OuterSubscriber);

});

parcelRegister("kZNgW", function(module, exports) {

$parcel$export(module.exports, "partition", () => $f48fb99ec61c7ca1$export$b29f828819edca8d, (v) => $f48fb99ec61c7ca1$export$b29f828819edca8d = v);
var $f48fb99ec61c7ca1$export$b29f828819edca8d;
"use strict";

var $7sUoU = parcelRequire("7sUoU");

var $dXapj = parcelRequire("dXapj");
/**
 * Splits the source Observable into two, one with values that satisfy a
 * predicate, and another with values that don't satisfy the predicate.
 *
 * <span class="informal">It's like {@link filter}, but returns two Observables:
 * one like the output of {@link filter}, and the other with values that did not
 * pass the condition.</span>
 *
 * <img src="./img/partition.png" width="100%">
 *
 * `partition` outputs an array with two Observables that partition the values
 * from the source Observable through the given `predicate` function. The first
 * Observable in that array emits source values for which the predicate argument
 * returns true. The second Observable emits source values for which the
 * predicate returns false. The first behaves like {@link filter} and the second
 * behaves like {@link filter} with the predicate negated.
 *
 * @example <caption>Partition click events into those on DIV elements and those elsewhere</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var parts = clicks.partition(ev => ev.target.tagName === 'DIV');
 * var clicksOnDivs = parts[0];
 * var clicksElsewhere = parts[1];
 * clicksOnDivs.subscribe(x => console.log('DIV clicked: ', x));
 * clicksElsewhere.subscribe(x => console.log('Other clicked: ', x));
 *
 * @see {@link filter}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted on the first Observable in the returned array, if
 * `false` the value is emitted on the second Observable in the array. The
 * `index` parameter is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {[Observable<T>, Observable<T>]} An array with two Observables: one
 * with values that passed the predicate, and another with values that did not
 * pass the predicate.
 * @method partition
 * @owner Observable
 */ function $f48fb99ec61c7ca1$var$partition(predicate, thisArg) {
    return function(source) {
        return [
            $dXapj.filter(predicate, thisArg)(source),
            $dXapj.filter($7sUoU.not(predicate, thisArg))(source)
        ];
    };
}
$f48fb99ec61c7ca1$export$b29f828819edca8d = $f48fb99ec61c7ca1$var$partition;

});
parcelRegister("7sUoU", function(module, exports) {

$parcel$export(module.exports, "not", () => $56f6e5f714cd778e$export$6003a5f097c73977, (v) => $56f6e5f714cd778e$export$6003a5f097c73977 = v);
var $56f6e5f714cd778e$export$6003a5f097c73977;
"use strict";
function $56f6e5f714cd778e$var$not(pred, thisArg) {
    function notPred() {
        return !notPred.pred.apply(notPred.thisArg, arguments);
    }
    notPred.pred = pred;
    notPred.thisArg = thisArg;
    return notPred;
}
$56f6e5f714cd778e$export$6003a5f097c73977 = $56f6e5f714cd778e$var$not;

});


parcelRegister("3hbzh", function(module, exports) {

$parcel$export(module.exports, "publish", () => $262beece1799de9f$export$89b472e03be495df, (v) => $262beece1799de9f$export$89b472e03be495df = v);
var $262beece1799de9f$export$89b472e03be495df;
"use strict";

var $70s4u = parcelRequire("70s4u");

var $lCBlc = parcelRequire("lCBlc");
/* tslint:enable:max-line-length */ /**
 * Returns a ConnectableObservable, which is a variety of Observable that waits until its connect method is called
 * before it begins emitting items to those Observers that have subscribed to it.
 *
 * <img src="./img/publish.png" width="100%">
 *
 * @param {Function} [selector] - Optional selector function which can use the multicasted source sequence as many times
 * as needed, without causing multiple subscriptions to the source sequence.
 * Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
 * @return A ConnectableObservable that upon connection causes the source Observable to emit items to its Observers.
 * @method publish
 * @owner Observable
 */ function $262beece1799de9f$var$publish(selector) {
    return selector ? $lCBlc.multicast(function() {
        return new $70s4u.Subject();
    }, selector) : $lCBlc.multicast(new $70s4u.Subject());
}
$262beece1799de9f$export$89b472e03be495df = $262beece1799de9f$var$publish;

});

parcelRegister("a9dHZ", function(module, exports) {

$parcel$export(module.exports, "publishBehavior", () => $763560d986e95ab6$export$16ae46fda9567053, (v) => $763560d986e95ab6$export$16ae46fda9567053 = v);
var $763560d986e95ab6$export$16ae46fda9567053;
"use strict";

var $1JMwO = parcelRequire("1JMwO");

var $lCBlc = parcelRequire("lCBlc");
/**
 * @param value
 * @return {ConnectableObservable<T>}
 * @method publishBehavior
 * @owner Observable
 */ function $763560d986e95ab6$var$publishBehavior(value) {
    return function(source) {
        return $lCBlc.multicast(new $1JMwO.BehaviorSubject(value))(source);
    };
}
$763560d986e95ab6$export$16ae46fda9567053 = $763560d986e95ab6$var$publishBehavior;

});

parcelRegister("4ZbWy", function(module, exports) {

$parcel$export(module.exports, "publishLast", () => $3a161fa9cd4a2fb6$export$42d9b6b38c68d989, (v) => $3a161fa9cd4a2fb6$export$42d9b6b38c68d989 = v);
var $3a161fa9cd4a2fb6$export$42d9b6b38c68d989;
"use strict";

var $gfQga = parcelRequire("gfQga");

var $lCBlc = parcelRequire("lCBlc");
function $3a161fa9cd4a2fb6$var$publishLast() {
    return function(source) {
        return $lCBlc.multicast(new $gfQga.AsyncSubject())(source);
    };
}
$3a161fa9cd4a2fb6$export$42d9b6b38c68d989 = $3a161fa9cd4a2fb6$var$publishLast;

});
parcelRegister("gfQga", function(module, exports) {
"use strict";
var $bd5695c1c03985b5$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $70s4u = parcelRequire("70s4u");

var $hIoOm = parcelRequire("hIoOm");
/**
 * @class AsyncSubject<T>
 */ var $bd5695c1c03985b5$var$AsyncSubject = function(_super) {
    $bd5695c1c03985b5$var$__extends(AsyncSubject, _super);
    function AsyncSubject() {
        _super.apply(this, arguments);
        this.value = null;
        this.hasNext = false;
        this.hasCompleted = false;
    }
    /** @deprecated internal use only */ AsyncSubject.prototype._subscribe = function(subscriber) {
        if (this.hasError) {
            subscriber.error(this.thrownError);
            return $hIoOm.Subscription.EMPTY;
        } else if (this.hasCompleted && this.hasNext) {
            subscriber.next(this.value);
            subscriber.complete();
            return $hIoOm.Subscription.EMPTY;
        }
        return _super.prototype._subscribe.call(this, subscriber);
    };
    AsyncSubject.prototype.next = function(value) {
        if (!this.hasCompleted) {
            this.value = value;
            this.hasNext = true;
        }
    };
    AsyncSubject.prototype.error = function(error) {
        if (!this.hasCompleted) _super.prototype.error.call(this, error);
    };
    AsyncSubject.prototype.complete = function() {
        this.hasCompleted = true;
        if (this.hasNext) _super.prototype.next.call(this, this.value);
        _super.prototype.complete.call(this);
    };
    return AsyncSubject;
}($70s4u.Subject);
module.exports.AsyncSubject = $bd5695c1c03985b5$var$AsyncSubject;

});


parcelRegister("4g0k7", function(module, exports) {

$parcel$export(module.exports, "publishReplay", () => $3198e846e9f97c74$export$1f3342bf81d92d52, (v) => $3198e846e9f97c74$export$1f3342bf81d92d52 = v);
var $3198e846e9f97c74$export$1f3342bf81d92d52;
"use strict";

var $lXGL9 = parcelRequire("lXGL9");

var $lCBlc = parcelRequire("lCBlc");
/* tslint:enable:max-line-length */ function $3198e846e9f97c74$var$publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
    if (selectorOrScheduler && typeof selectorOrScheduler !== 'function') scheduler = selectorOrScheduler;
    var selector = typeof selectorOrScheduler === 'function' ? selectorOrScheduler : undefined;
    var subject = new $lXGL9.ReplaySubject(bufferSize, windowTime, scheduler);
    return function(source) {
        return $lCBlc.multicast(function() {
            return subject;
        }, selector)(source);
    };
}
$3198e846e9f97c74$export$1f3342bf81d92d52 = $3198e846e9f97c74$var$publishReplay;

});

parcelRegister("6BYfk", function(module, exports) {

$parcel$export(module.exports, "race", () => $4d04ee7226c72b3f$export$236c05de452bec2, (v) => $4d04ee7226c72b3f$export$236c05de452bec2 = v);
var $4d04ee7226c72b3f$export$236c05de452bec2;
"use strict";

var $3DoUz = parcelRequire("3DoUz");

var $hoEqm = parcelRequire("hoEqm");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that mirrors the first source Observable to emit an item
 * from the combination of this Observable and supplied Observables.
 * @param {...Observables} ...observables Sources used to race for which Observable emits first.
 * @return {Observable} An Observable that mirrors the output of the first Observable to emit an item.
 * @method race
 * @owner Observable
 */ function $4d04ee7226c72b3f$var$race() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return function raceOperatorFunction(source) {
        // if the only argument is an array, it was most likely called with
        // `pair([obs1, obs2, ...])`
        if (observables.length === 1 && $3DoUz.isArray(observables[0])) observables = observables[0];
        return source.lift.call($hoEqm.race.apply(void 0, [
            source
        ].concat(observables)));
    };
}
$4d04ee7226c72b3f$export$236c05de452bec2 = $4d04ee7226c72b3f$var$race;

});
parcelRegister("hoEqm", function(module, exports) {
"use strict";
var $0344b5d27faa5477$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $3DoUz = parcelRequire("3DoUz");

var $1Lh1X = parcelRequire("1Lh1X");

var $6UnJS = parcelRequire("6UnJS");

var $87MtM = parcelRequire("87MtM");
function $0344b5d27faa5477$var$race() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    // if the only argument is an array, it was most likely called with
    // `race([obs1, obs2, ...])`
    if (observables.length === 1) {
        if ($3DoUz.isArray(observables[0])) observables = observables[0];
        else return observables[0];
    }
    return new $1Lh1X.ArrayObservable(observables).lift(new $0344b5d27faa5477$var$RaceOperator());
}
module.exports.race = $0344b5d27faa5477$var$race;
var $0344b5d27faa5477$var$RaceOperator = function() {
    function RaceOperator() {}
    RaceOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $0344b5d27faa5477$var$RaceSubscriber(subscriber));
    };
    return RaceOperator;
}();
module.exports.RaceOperator = $0344b5d27faa5477$var$RaceOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $0344b5d27faa5477$var$RaceSubscriber = function(_super) {
    $0344b5d27faa5477$var$__extends(RaceSubscriber, _super);
    function RaceSubscriber(destination) {
        _super.call(this, destination);
        this.hasFirst = false;
        this.observables = [];
        this.subscriptions = [];
    }
    RaceSubscriber.prototype._next = function(observable) {
        this.observables.push(observable);
    };
    RaceSubscriber.prototype._complete = function() {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) this.destination.complete();
        else {
            for(var i = 0; i < len && !this.hasFirst; i++){
                var observable = observables[i];
                var subscription = $87MtM.subscribeToResult(this, observable, observable, i);
                if (this.subscriptions) this.subscriptions.push(subscription);
                this.add(subscription);
            }
            this.observables = null;
        }
    };
    RaceSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (!this.hasFirst) {
            this.hasFirst = true;
            for(var i = 0; i < this.subscriptions.length; i++)if (i !== outerIndex) {
                var subscription = this.subscriptions[i];
                subscription.unsubscribe();
                this.remove(subscription);
            }
            this.subscriptions = null;
        }
        this.destination.next(innerValue);
    };
    return RaceSubscriber;
}($6UnJS.OuterSubscriber);
module.exports.RaceSubscriber = $0344b5d27faa5477$var$RaceSubscriber;

});


parcelRegister("8npYd", function(module, exports) {
"use strict";
var $61949ddbcd71a424$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");

var $9x82Y = parcelRequire("9x82Y");
/**
 * Returns an Observable that repeats the stream of items emitted by the source Observable at most count times.
 *
 * <img src="./img/repeat.png" width="100%">
 *
 * @param {number} [count] The number of times the source Observable items are repeated, a count of 0 will yield
 * an empty Observable.
 * @return {Observable} An Observable that repeats the stream of items emitted by the source Observable at most
 * count times.
 * @method repeat
 * @owner Observable
 */ function $61949ddbcd71a424$var$repeat(count) {
    if (count === void 0) count = -1;
    return function(source) {
        if (count === 0) return new $9x82Y.EmptyObservable();
        else if (count < 0) return source.lift(new $61949ddbcd71a424$var$RepeatOperator(-1, source));
        else return source.lift(new $61949ddbcd71a424$var$RepeatOperator(count - 1, source));
    };
}
module.exports.repeat = $61949ddbcd71a424$var$repeat;
var $61949ddbcd71a424$var$RepeatOperator = function() {
    function RepeatOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RepeatOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $61949ddbcd71a424$var$RepeatSubscriber(subscriber, this.count, this.source));
    };
    return RepeatOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $61949ddbcd71a424$var$RepeatSubscriber = function(_super) {
    $61949ddbcd71a424$var$__extends(RepeatSubscriber, _super);
    function RepeatSubscriber(destination, count, source) {
        _super.call(this, destination);
        this.count = count;
        this.source = source;
    }
    RepeatSubscriber.prototype.complete = function() {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) return _super.prototype.complete.call(this);
            else if (count > -1) this.count = count - 1;
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RepeatSubscriber;
}($a7QRR.Subscriber);

});

parcelRegister("4m82s", function(module, exports) {
"use strict";
var $32bf73d21277d821$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $70s4u = parcelRequire("70s4u");

var $jJdW6 = parcelRequire("jJdW6");

var $4b4q3 = parcelRequire("4b4q3");

var $6UnJS = parcelRequire("6UnJS");

var $87MtM = parcelRequire("87MtM");
/**
 * Returns an Observable that mirrors the source Observable with the exception of a `complete`. If the source
 * Observable calls `complete`, this method will emit to the Observable returned from `notifier`. If that Observable
 * calls `complete` or `error`, then this method will call `complete` or `error` on the child subscription. Otherwise
 * this method will resubscribe to the source Observable.
 *
 * <img src="./img/repeatWhen.png" width="100%">
 *
 * @param {function(notifications: Observable): Observable} notifier - Receives an Observable of notifications with
 * which a user can `complete` or `error`, aborting the repetition.
 * @return {Observable} The source Observable modified with repeat logic.
 * @method repeatWhen
 * @owner Observable
 */ function $32bf73d21277d821$var$repeatWhen(notifier) {
    return function(source) {
        return source.lift(new $32bf73d21277d821$var$RepeatWhenOperator(notifier));
    };
}
module.exports.repeatWhen = $32bf73d21277d821$var$repeatWhen;
var $32bf73d21277d821$var$RepeatWhenOperator = function() {
    function RepeatWhenOperator(notifier) {
        this.notifier = notifier;
    }
    RepeatWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $32bf73d21277d821$var$RepeatWhenSubscriber(subscriber, this.notifier, source));
    };
    return RepeatWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $32bf73d21277d821$var$RepeatWhenSubscriber = function(_super) {
    $32bf73d21277d821$var$__extends(RepeatWhenSubscriber, _super);
    function RepeatWhenSubscriber(destination, notifier, source) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.source = source;
        this.sourceIsBeingSubscribedTo = true;
    }
    RepeatWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.sourceIsBeingSubscribedTo = true;
        this.source.subscribe(this);
    };
    RepeatWhenSubscriber.prototype.notifyComplete = function(innerSub) {
        if (this.sourceIsBeingSubscribedTo === false) return _super.prototype.complete.call(this);
    };
    RepeatWhenSubscriber.prototype.complete = function() {
        this.sourceIsBeingSubscribedTo = false;
        if (!this.isStopped) {
            if (!this.retries) this.subscribeToRetries();
            if (!this.retriesSubscription || this.retriesSubscription.closed) return _super.prototype.complete.call(this);
            this._unsubscribeAndRecycle();
            this.notifications.next();
        }
    };
    /** @deprecated internal use only */ RepeatWhenSubscriber.prototype._unsubscribe = function() {
        var _a = this, notifications = _a.notifications, retriesSubscription = _a.retriesSubscription;
        if (notifications) {
            notifications.unsubscribe();
            this.notifications = null;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = null;
        }
        this.retries = null;
    };
    /** @deprecated internal use only */ RepeatWhenSubscriber.prototype._unsubscribeAndRecycle = function() {
        var _a = this, notifications = _a.notifications, retries = _a.retries, retriesSubscription = _a.retriesSubscription;
        this.notifications = null;
        this.retries = null;
        this.retriesSubscription = null;
        _super.prototype._unsubscribeAndRecycle.call(this);
        this.notifications = notifications;
        this.retries = retries;
        this.retriesSubscription = retriesSubscription;
        return this;
    };
    RepeatWhenSubscriber.prototype.subscribeToRetries = function() {
        this.notifications = new $70s4u.Subject();
        var retries = $jJdW6.tryCatch(this.notifier)(this.notifications);
        if (retries === $4b4q3.errorObject) return _super.prototype.complete.call(this);
        this.retries = retries;
        this.retriesSubscription = $87MtM.subscribeToResult(this, retries);
    };
    return RepeatWhenSubscriber;
}($6UnJS.OuterSubscriber);

});

parcelRegister("kPJ0i", function(module, exports) {
"use strict";
var $f2ab7ae0b6fb5baa$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");

var $jAy5L = parcelRequire("jAy5L");
/**
 * Emits the most recently emitted value from the source Observable within
 * periodic time intervals.
 *
 * <span class="informal">Samples the source Observable at periodic time
 * intervals, emitting what it samples.</span>
 *
 * <img src="./img/sampleTime.png" width="100%">
 *
 * `sampleTime` periodically looks at the source Observable and emits whichever
 * value it has most recently emitted since the previous sampling, unless the
 * source has not emitted anything since the previous sampling. The sampling
 * happens periodically in time every `period` milliseconds (or the time unit
 * defined by the optional `scheduler` argument). The sampling starts as soon as
 * the output Observable is subscribed.
 *
 * @example <caption>Every second, emit the most recent click at most once</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.sampleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {number} period The sampling period expressed in milliseconds or the
 * time unit determined internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the sampling.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable at the specified time interval.
 * @method sampleTime
 * @owner Observable
 */ function $f2ab7ae0b6fb5baa$var$sampleTime(period, scheduler) {
    if (scheduler === void 0) scheduler = $jAy5L.async;
    return function(source) {
        return source.lift(new $f2ab7ae0b6fb5baa$var$SampleTimeOperator(period, scheduler));
    };
}
module.exports.sampleTime = $f2ab7ae0b6fb5baa$var$sampleTime;
var $f2ab7ae0b6fb5baa$var$SampleTimeOperator = function() {
    function SampleTimeOperator(period, scheduler) {
        this.period = period;
        this.scheduler = scheduler;
    }
    SampleTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $f2ab7ae0b6fb5baa$var$SampleTimeSubscriber(subscriber, this.period, this.scheduler));
    };
    return SampleTimeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $f2ab7ae0b6fb5baa$var$SampleTimeSubscriber = function(_super) {
    $f2ab7ae0b6fb5baa$var$__extends(SampleTimeSubscriber, _super);
    function SampleTimeSubscriber(destination, period, scheduler) {
        _super.call(this, destination);
        this.period = period;
        this.scheduler = scheduler;
        this.hasValue = false;
        this.add(scheduler.schedule($f2ab7ae0b6fb5baa$var$dispatchNotification, period, {
            subscriber: this,
            period: period
        }));
    }
    SampleTimeSubscriber.prototype._next = function(value) {
        this.lastValue = value;
        this.hasValue = true;
    };
    SampleTimeSubscriber.prototype.notifyNext = function() {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.lastValue);
        }
    };
    return SampleTimeSubscriber;
}($a7QRR.Subscriber);
function $f2ab7ae0b6fb5baa$var$dispatchNotification(state) {
    var subscriber = state.subscriber, period = state.period;
    subscriber.notifyNext();
    this.schedule(state, period);
}

});

parcelRegister("iwZAW", function(module, exports) {
"use strict";
var $d7dafe9cc0eb1117$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");

var $jJdW6 = parcelRequire("jJdW6");

var $4b4q3 = parcelRequire("4b4q3");
/**
 * Compares all values of two observables in sequence using an optional comparor function
 * and returns an observable of a single boolean value representing whether or not the two sequences
 * are equal.
 *
 * <span class="informal">Checks to see of all values emitted by both observables are equal, in order.</span>
 *
 * <img src="./img/sequenceEqual.png" width="100%">
 *
 * `sequenceEqual` subscribes to two observables and buffers incoming values from each observable. Whenever either
 * observable emits a value, the value is buffered and the buffers are shifted and compared from the bottom
 * up; If any value pair doesn't match, the returned observable will emit `false` and complete. If one of the
 * observables completes, the operator will wait for the other observable to complete; If the other
 * observable emits before completing, the returned observable will emit `false` and complete. If one observable never
 * completes or emits after the other complets, the returned observable will never complete.
 *
 * @example <caption>figure out if the Konami code matches</caption>
 * var code = Rx.Observable.from([
 *  "ArrowUp",
 *  "ArrowUp",
 *  "ArrowDown",
 *  "ArrowDown",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "KeyB",
 *  "KeyA",
 *  "Enter" // no start key, clearly.
 * ]);
 *
 * var keys = Rx.Observable.fromEvent(document, 'keyup')
 *  .map(e => e.code);
 * var matches = keys.bufferCount(11, 1)
 *  .mergeMap(
 *    last11 =>
 *      Rx.Observable.from(last11)
 *        .sequenceEqual(code)
 *   );
 * matches.subscribe(matched => console.log('Successful cheat at Contra? ', matched));
 *
 * @see {@link combineLatest}
 * @see {@link zip}
 * @see {@link withLatestFrom}
 *
 * @param {Observable} compareTo The observable sequence to compare the source sequence to.
 * @param {function} [comparor] An optional function to compare each value pair
 * @return {Observable} An Observable of a single boolean value representing whether or not
 * the values emitted by both observables were equal in sequence.
 * @method sequenceEqual
 * @owner Observable
 */ function $d7dafe9cc0eb1117$var$sequenceEqual(compareTo, comparor) {
    return function(source) {
        return source.lift(new $d7dafe9cc0eb1117$var$SequenceEqualOperator(compareTo, comparor));
    };
}
module.exports.sequenceEqual = $d7dafe9cc0eb1117$var$sequenceEqual;
var $d7dafe9cc0eb1117$var$SequenceEqualOperator = function() {
    function SequenceEqualOperator(compareTo, comparor) {
        this.compareTo = compareTo;
        this.comparor = comparor;
    }
    SequenceEqualOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $d7dafe9cc0eb1117$var$SequenceEqualSubscriber(subscriber, this.compareTo, this.comparor));
    };
    return SequenceEqualOperator;
}();
module.exports.SequenceEqualOperator = $d7dafe9cc0eb1117$var$SequenceEqualOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d7dafe9cc0eb1117$var$SequenceEqualSubscriber = function(_super) {
    $d7dafe9cc0eb1117$var$__extends(SequenceEqualSubscriber, _super);
    function SequenceEqualSubscriber(destination, compareTo, comparor) {
        _super.call(this, destination);
        this.compareTo = compareTo;
        this.comparor = comparor;
        this._a = [];
        this._b = [];
        this._oneComplete = false;
        this.add(compareTo.subscribe(new $d7dafe9cc0eb1117$var$SequenceEqualCompareToSubscriber(destination, this)));
    }
    SequenceEqualSubscriber.prototype._next = function(value) {
        if (this._oneComplete && this._b.length === 0) this.emit(false);
        else {
            this._a.push(value);
            this.checkValues();
        }
    };
    SequenceEqualSubscriber.prototype._complete = function() {
        if (this._oneComplete) this.emit(this._a.length === 0 && this._b.length === 0);
        else this._oneComplete = true;
    };
    SequenceEqualSubscriber.prototype.checkValues = function() {
        var _c = this, _a = _c._a, _b = _c._b, comparor = _c.comparor;
        while(_a.length > 0 && _b.length > 0){
            var a = _a.shift();
            var b = _b.shift();
            var areEqual = false;
            if (comparor) {
                areEqual = $jJdW6.tryCatch(comparor)(a, b);
                if (areEqual === $4b4q3.errorObject) this.destination.error($4b4q3.errorObject.e);
            } else areEqual = a === b;
            if (!areEqual) this.emit(false);
        }
    };
    SequenceEqualSubscriber.prototype.emit = function(value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    SequenceEqualSubscriber.prototype.nextB = function(value) {
        if (this._oneComplete && this._a.length === 0) this.emit(false);
        else {
            this._b.push(value);
            this.checkValues();
        }
    };
    return SequenceEqualSubscriber;
}($a7QRR.Subscriber);
module.exports.SequenceEqualSubscriber = $d7dafe9cc0eb1117$var$SequenceEqualSubscriber;
var $d7dafe9cc0eb1117$var$SequenceEqualCompareToSubscriber = function(_super) {
    $d7dafe9cc0eb1117$var$__extends(SequenceEqualCompareToSubscriber, _super);
    function SequenceEqualCompareToSubscriber(destination, parent) {
        _super.call(this, destination);
        this.parent = parent;
    }
    SequenceEqualCompareToSubscriber.prototype._next = function(value) {
        this.parent.nextB(value);
    };
    SequenceEqualCompareToSubscriber.prototype._error = function(err) {
        this.parent.error(err);
    };
    SequenceEqualCompareToSubscriber.prototype._complete = function() {
        this.parent._complete();
    };
    return SequenceEqualCompareToSubscriber;
}($a7QRR.Subscriber);

});

parcelRegister("2n4lI", function(module, exports) {

$parcel$export(module.exports, "shareReplay", () => $1ba11a7226d88d0a$export$db61d692014e534e, (v) => $1ba11a7226d88d0a$export$db61d692014e534e = v);
var $1ba11a7226d88d0a$export$db61d692014e534e;
"use strict";

var $lXGL9 = parcelRequire("lXGL9");
/**
 * @method shareReplay
 * @owner Observable
 */ function $1ba11a7226d88d0a$var$shareReplay(bufferSize, windowTime, scheduler) {
    return function(source) {
        return source.lift($1ba11a7226d88d0a$var$shareReplayOperator(bufferSize, windowTime, scheduler));
    };
}
$1ba11a7226d88d0a$export$db61d692014e534e = $1ba11a7226d88d0a$var$shareReplay;
function $1ba11a7226d88d0a$var$shareReplayOperator(bufferSize, windowTime, scheduler) {
    var subject;
    var refCount = 0;
    var subscription;
    var hasError = false;
    var isComplete = false;
    return function shareReplayOperation(source) {
        refCount++;
        if (!subject || hasError) {
            hasError = false;
            subject = new $lXGL9.ReplaySubject(bufferSize, windowTime, scheduler);
            subscription = source.subscribe({
                next: function(value) {
                    subject.next(value);
                },
                error: function(err) {
                    hasError = true;
                    subject.error(err);
                },
                complete: function() {
                    isComplete = true;
                    subject.complete();
                }
            });
        }
        var innerSub = subject.subscribe(this);
        return function() {
            refCount--;
            innerSub.unsubscribe();
            if (subscription && refCount === 0 && isComplete) subscription.unsubscribe();
        };
    };
}

});

parcelRegister("9Pl3U", function(module, exports) {
"use strict";
var $727936f8f067a9de$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");

var $iJ8IY = parcelRequire("iJ8IY");
/**
 * Returns an Observable that emits the single item emitted by the source Observable that matches a specified
 * predicate, if that Observable emits one such item. If the source Observable emits more than one such item or no
 * such items, notify of an IllegalArgumentException or NoSuchElementException respectively.
 *
 * <img src="./img/single.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {Function} predicate - A predicate function to evaluate items emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits the single item emitted by the source Observable that matches
 * the predicate.
 .
 * @method single
 * @owner Observable
 */ function $727936f8f067a9de$var$single(predicate) {
    return function(source) {
        return source.lift(new $727936f8f067a9de$var$SingleOperator(predicate, source));
    };
}
module.exports.single = $727936f8f067a9de$var$single;
var $727936f8f067a9de$var$SingleOperator = function() {
    function SingleOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    SingleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $727936f8f067a9de$var$SingleSubscriber(subscriber, this.predicate, this.source));
    };
    return SingleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $727936f8f067a9de$var$SingleSubscriber = function(_super) {
    $727936f8f067a9de$var$__extends(SingleSubscriber, _super);
    function SingleSubscriber(destination, predicate, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.seenValue = false;
        this.index = 0;
    }
    SingleSubscriber.prototype.applySingleValue = function(value) {
        if (this.seenValue) this.destination.error('Sequence contains more than one element');
        else {
            this.seenValue = true;
            this.singleValue = value;
        }
    };
    SingleSubscriber.prototype._next = function(value) {
        var index = this.index++;
        if (this.predicate) this.tryNext(value, index);
        else this.applySingleValue(value);
    };
    SingleSubscriber.prototype.tryNext = function(value, index) {
        try {
            if (this.predicate(value, index, this.source)) this.applySingleValue(value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    SingleSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (this.index > 0) {
            destination.next(this.seenValue ? this.singleValue : undefined);
            destination.complete();
        } else destination.error(new $iJ8IY.EmptyError);
    };
    return SingleSubscriber;
}($a7QRR.Subscriber);

});

parcelRegister("l8un2", function(module, exports) {
"use strict";
var $f631e74d5bdf6cd6$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");
/**
 * Returns an Observable that skips the first `count` items emitted by the source Observable.
 *
 * <img src="./img/skip.png" width="100%">
 *
 * @param {Number} count - The number of times, items emitted by source Observable should be skipped.
 * @return {Observable} An Observable that skips values emitted by the source Observable.
 *
 * @method skip
 * @owner Observable
 */ function $f631e74d5bdf6cd6$var$skip(count) {
    return function(source) {
        return source.lift(new $f631e74d5bdf6cd6$var$SkipOperator(count));
    };
}
module.exports.skip = $f631e74d5bdf6cd6$var$skip;
var $f631e74d5bdf6cd6$var$SkipOperator = function() {
    function SkipOperator(total) {
        this.total = total;
    }
    SkipOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $f631e74d5bdf6cd6$var$SkipSubscriber(subscriber, this.total));
    };
    return SkipOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $f631e74d5bdf6cd6$var$SkipSubscriber = function(_super) {
    $f631e74d5bdf6cd6$var$__extends(SkipSubscriber, _super);
    function SkipSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    SkipSubscriber.prototype._next = function(x) {
        if (++this.count > this.total) this.destination.next(x);
    };
    return SkipSubscriber;
}($a7QRR.Subscriber);

});

parcelRegister("b3Afl", function(module, exports) {
"use strict";
var $80cc1753d77dac56$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");

var $2l9IB = parcelRequire("2l9IB");
/**
 * Skip the last `count` values emitted by the source Observable.
 *
 * <img src="./img/skipLast.png" width="100%">
 *
 * `skipLast` returns an Observable that accumulates a queue with a length
 * enough to store the first `count` values. As more values are received,
 * values are taken from the front of the queue and produced on the result
 * sequence. This causes values to be delayed.
 *
 * @example <caption>Skip the last 2 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 5);
 * var skipLastTwo = many.skipLast(2);
 * skipLastTwo.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 1 2 3
 *
 * @see {@link skip}
 * @see {@link skipUntil}
 * @see {@link skipWhile}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `skipLast(i)`, it throws
 * ArgumentOutOrRangeError if `i < 0`.
 *
 * @param {number} count Number of elements to skip from the end of the source Observable.
 * @returns {Observable<T>} An Observable that skips the last count values
 * emitted by the source Observable.
 * @method skipLast
 * @owner Observable
 */ function $80cc1753d77dac56$var$skipLast(count) {
    return function(source) {
        return source.lift(new $80cc1753d77dac56$var$SkipLastOperator(count));
    };
}
module.exports.skipLast = $80cc1753d77dac56$var$skipLast;
var $80cc1753d77dac56$var$SkipLastOperator = function() {
    function SkipLastOperator(_skipCount) {
        this._skipCount = _skipCount;
        if (this._skipCount < 0) throw new $2l9IB.ArgumentOutOfRangeError;
    }
    SkipLastOperator.prototype.call = function(subscriber, source) {
        if (this._skipCount === 0) // If we don't want to skip any values then just subscribe
        // to Subscriber without any further logic.
        return source.subscribe(new $a7QRR.Subscriber(subscriber));
        else return source.subscribe(new $80cc1753d77dac56$var$SkipLastSubscriber(subscriber, this._skipCount));
    };
    return SkipLastOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $80cc1753d77dac56$var$SkipLastSubscriber = function(_super) {
    $80cc1753d77dac56$var$__extends(SkipLastSubscriber, _super);
    function SkipLastSubscriber(destination, _skipCount) {
        _super.call(this, destination);
        this._skipCount = _skipCount;
        this._count = 0;
        this._ring = new Array(_skipCount);
    }
    SkipLastSubscriber.prototype._next = function(value) {
        var skipCount = this._skipCount;
        var count = this._count++;
        if (count < skipCount) this._ring[count] = value;
        else {
            var currentIndex = count % skipCount;
            var ring = this._ring;
            var oldValue = ring[currentIndex];
            ring[currentIndex] = value;
            this.destination.next(oldValue);
        }
    };
    return SkipLastSubscriber;
}($a7QRR.Subscriber);

});

parcelRegister("dMiA4", function(module, exports) {
"use strict";
var $a07e2bd4db1f8075$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $6UnJS = parcelRequire("6UnJS");

var $87MtM = parcelRequire("87MtM");
/**
 * Returns an Observable that skips items emitted by the source Observable until a second Observable emits an item.
 *
 * <img src="./img/skipUntil.png" width="100%">
 *
 * @param {Observable} notifier - The second Observable that has to emit an item before the source Observable's elements begin to
 * be mirrored by the resulting Observable.
 * @return {Observable<T>} An Observable that skips items from the source Observable until the second Observable emits
 * an item, then emits the remaining items.
 * @method skipUntil
 * @owner Observable
 */ function $a07e2bd4db1f8075$var$skipUntil(notifier) {
    return function(source) {
        return source.lift(new $a07e2bd4db1f8075$var$SkipUntilOperator(notifier));
    };
}
module.exports.skipUntil = $a07e2bd4db1f8075$var$skipUntil;
var $a07e2bd4db1f8075$var$SkipUntilOperator = function() {
    function SkipUntilOperator(notifier) {
        this.notifier = notifier;
    }
    SkipUntilOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $a07e2bd4db1f8075$var$SkipUntilSubscriber(subscriber, this.notifier));
    };
    return SkipUntilOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a07e2bd4db1f8075$var$SkipUntilSubscriber = function(_super) {
    $a07e2bd4db1f8075$var$__extends(SkipUntilSubscriber, _super);
    function SkipUntilSubscriber(destination, notifier) {
        _super.call(this, destination);
        this.hasValue = false;
        this.isInnerStopped = false;
        this.add($87MtM.subscribeToResult(this, notifier));
    }
    SkipUntilSubscriber.prototype._next = function(value) {
        if (this.hasValue) _super.prototype._next.call(this, value);
    };
    SkipUntilSubscriber.prototype._complete = function() {
        if (this.isInnerStopped) _super.prototype._complete.call(this);
        else this.unsubscribe();
    };
    SkipUntilSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.hasValue = true;
    };
    SkipUntilSubscriber.prototype.notifyComplete = function() {
        this.isInnerStopped = true;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    return SkipUntilSubscriber;
}($6UnJS.OuterSubscriber);

});

parcelRegister("3MURy", function(module, exports) {
"use strict";
var $2c21f68bea52c4bd$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");
/**
 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
 * true, but emits all further source items as soon as the condition becomes false.
 *
 * <img src="./img/skipWhile.png" width="100%">
 *
 * @param {Function} predicate - A function to test each item emitted from the source Observable.
 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
 * specified predicate becomes false.
 * @method skipWhile
 * @owner Observable
 */ function $2c21f68bea52c4bd$var$skipWhile(predicate) {
    return function(source) {
        return source.lift(new $2c21f68bea52c4bd$var$SkipWhileOperator(predicate));
    };
}
module.exports.skipWhile = $2c21f68bea52c4bd$var$skipWhile;
var $2c21f68bea52c4bd$var$SkipWhileOperator = function() {
    function SkipWhileOperator(predicate) {
        this.predicate = predicate;
    }
    SkipWhileOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2c21f68bea52c4bd$var$SkipWhileSubscriber(subscriber, this.predicate));
    };
    return SkipWhileOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2c21f68bea52c4bd$var$SkipWhileSubscriber = function(_super) {
    $2c21f68bea52c4bd$var$__extends(SkipWhileSubscriber, _super);
    function SkipWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.skipping = true;
        this.index = 0;
    }
    SkipWhileSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (this.skipping) this.tryCallPredicate(value);
        if (!this.skipping) destination.next(value);
    };
    SkipWhileSubscriber.prototype.tryCallPredicate = function(value) {
        try {
            var result = this.predicate(value, this.index++);
            this.skipping = Boolean(result);
        } catch (err) {
            this.destination.error(err);
        }
    };
    return SkipWhileSubscriber;
}($a7QRR.Subscriber);

});

parcelRegister("1csk5", function(module, exports) {

$parcel$export(module.exports, "switchAll", () => $0dfce1cc6a041396$export$6a45284a4b0bf33a, (v) => $0dfce1cc6a041396$export$6a45284a4b0bf33a = v);
var $0dfce1cc6a041396$export$6a45284a4b0bf33a;
"use strict";

var $6yPEx = parcelRequire("6yPEx");

var $g5M3H = parcelRequire("g5M3H");
function $0dfce1cc6a041396$var$switchAll() {
    return $6yPEx.switchMap($g5M3H.identity);
}
$0dfce1cc6a041396$export$6a45284a4b0bf33a = $0dfce1cc6a041396$var$switchAll;

});

parcelRegister("kfhNV", function(module, exports) {
"use strict";
var $ebd304e5af9707dc$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");

var $jAy5L = parcelRequire("jAy5L");
function $ebd304e5af9707dc$var$timeInterval(scheduler) {
    if (scheduler === void 0) scheduler = $jAy5L.async;
    return function(source) {
        return source.lift(new $ebd304e5af9707dc$var$TimeIntervalOperator(scheduler));
    };
}
module.exports.timeInterval = $ebd304e5af9707dc$var$timeInterval;
var $ebd304e5af9707dc$var$TimeInterval = function() {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}();
module.exports.TimeInterval = $ebd304e5af9707dc$var$TimeInterval;
var $ebd304e5af9707dc$var$TimeIntervalOperator = function() {
    function TimeIntervalOperator(scheduler) {
        this.scheduler = scheduler;
    }
    TimeIntervalOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $ebd304e5af9707dc$var$TimeIntervalSubscriber(observer, this.scheduler));
    };
    return TimeIntervalOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $ebd304e5af9707dc$var$TimeIntervalSubscriber = function(_super) {
    $ebd304e5af9707dc$var$__extends(TimeIntervalSubscriber, _super);
    function TimeIntervalSubscriber(destination, scheduler) {
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.lastTime = 0;
        this.lastTime = scheduler.now();
    }
    TimeIntervalSubscriber.prototype._next = function(value) {
        var now = this.scheduler.now();
        var span = now - this.lastTime;
        this.lastTime = now;
        this.destination.next(new $ebd304e5af9707dc$var$TimeInterval(value, span));
    };
    return TimeIntervalSubscriber;
}($a7QRR.Subscriber);

});

parcelRegister("6bEgU", function(module, exports) {
"use strict";
var $48130245044e6901$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jAy5L = parcelRequire("jAy5L");

var $lmVpl = parcelRequire("lmVpl");

var $a7QRR = parcelRequire("a7QRR");

var $04KXD = parcelRequire("04KXD");
/**
 *
 * Errors if Observable does not emit a value in given time span.
 *
 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
 *
 * <img src="./img/timeout.png" width="100%">
 *
 * `timeout` operator accepts as an argument either a number or a Date.
 *
 * If number was provided, it returns an Observable that behaves like a source
 * Observable, unless there is a period of time where there is no value emitted.
 * So if you provide `100` as argument and first value comes after 50ms from
 * the moment of subscription, this value will be simply re-emitted by the resulting
 * Observable. If however after that 100ms passes without a second value being emitted,
 * stream will end with an error and source Observable will be unsubscribed.
 * These checks are performed throughout whole lifecycle of Observable - from the moment
 * it was subscribed to, until it completes or errors itself. Thus every value must be
 * emitted within specified period since previous value.
 *
 * If provided argument was Date, returned Observable behaves differently. It throws
 * if Observable did not complete before provided Date. This means that periods between
 * emission of particular values do not matter in this case. If Observable did not complete
 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
 * stream behaves just as source Observable.
 *
 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
 * when returned Observable will check if source stream emitted value or completed.
 *
 * @example <caption>Check if ticks are emitted within certain timespan</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
 *                       // since `interval` might fire a bit later then scheduled.
 * .subscribe(
 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
 *     err => console.log(err) // Will never be called.
 * );
 *
 * seconds.timeout(900).subscribe(
 *     value => console.log(value), // Will never be called.
 *     err => console.log(err) // Will emit error before even first value is emitted,
 *                             // since it did not arrive within 900ms period.
 * );
 *
 * @example <caption>Use Date to check if Observable completed</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
 * .subscribe(
 *     value => console.log(value), // Will emit values as regular `interval` would
 *                                  // until December 17, 2020 at 03:24:00.
 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
 *                             // since Observable did not complete by then.
 * );
 *
 * @see {@link timeoutWith}
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
 * @method timeout
 * @owner Observable
 */ function $48130245044e6901$var$timeout(due, scheduler) {
    if (scheduler === void 0) scheduler = $jAy5L.async;
    var absoluteTimeout = $lmVpl.isDate(due);
    var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
    return function(source) {
        return source.lift(new $48130245044e6901$var$TimeoutOperator(waitFor, absoluteTimeout, scheduler, new $04KXD.TimeoutError()));
    };
}
module.exports.timeout = $48130245044e6901$var$timeout;
var $48130245044e6901$var$TimeoutOperator = function() {
    function TimeoutOperator(waitFor, absoluteTimeout, scheduler, errorInstance) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
    }
    TimeoutOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $48130245044e6901$var$TimeoutSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.scheduler, this.errorInstance));
    };
    return TimeoutOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $48130245044e6901$var$TimeoutSubscriber = function(_super) {
    $48130245044e6901$var$__extends(TimeoutSubscriber, _super);
    function TimeoutSubscriber(destination, absoluteTimeout, waitFor, scheduler, errorInstance) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutSubscriber.dispatchTimeout = function(subscriber) {
        subscriber.error(subscriber.errorInstance);
    };
    TimeoutSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) // Recycle the action if we've already scheduled one. All the production
        // Scheduler Actions mutate their state/delay time and return themeselves.
        // VirtualActions are immutable, so they create and return a clone. In this
        // case, we need to set the action reference to the most recent VirtualAction,
        // to ensure that's the one we clone from next time.
        this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutSubscriber.prototype._unsubscribe = function() {
        this.action = null;
        this.scheduler = null;
        this.errorInstance = null;
    };
    return TimeoutSubscriber;
}($a7QRR.Subscriber);

});
parcelRegister("04KXD", function(module, exports) {
"use strict";
var $00e4cd47ebde33ae$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when duetime elapses.
 *
 * @see {@link timeout}
 *
 * @class TimeoutError
 */ var $00e4cd47ebde33ae$var$TimeoutError = function(_super) {
    $00e4cd47ebde33ae$var$__extends(TimeoutError, _super);
    function TimeoutError() {
        var err = _super.call(this, 'Timeout has occurred');
        this.name = err.name = 'TimeoutError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return TimeoutError;
}(Error);
module.exports.TimeoutError = $00e4cd47ebde33ae$var$TimeoutError;

});


parcelRegister("7JnJx", function(module, exports) {
"use strict";
var $5a0f25567b9174cd$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jAy5L = parcelRequire("jAy5L");

var $lmVpl = parcelRequire("lmVpl");

var $6UnJS = parcelRequire("6UnJS");

var $87MtM = parcelRequire("87MtM");
/* tslint:enable:max-line-length */ /**
 *
 * Errors if Observable does not emit a value in given time span, in case of which
 * subscribes to the second Observable.
 *
 * <span class="informal">It's a version of `timeout` operator that let's you specify fallback Observable.</span>
 *
 * <img src="./img/timeoutWith.png" width="100%">
 *
 * `timeoutWith` is a variation of `timeout` operator. It behaves exactly the same,
 * still accepting as a first argument either a number or a Date, which control - respectively -
 * when values of source Observable should be emitted or when it should complete.
 *
 * The only difference is that it accepts a second, required parameter. This parameter
 * should be an Observable which will be subscribed when source Observable fails any timeout check.
 * So whenever regular `timeout` would emit an error, `timeoutWith` will instead start re-emitting
 * values from second Observable. Note that this fallback Observable is not checked for timeouts
 * itself, so it can emit values and complete at arbitrary points in time. From the moment of a second
 * subscription, Observable returned from `timeoutWith` simply mirrors fallback stream. When that
 * stream completes, it completes as well.
 *
 * Scheduler, which in case of `timeout` is provided as as second argument, can be still provided
 * here - as a third, optional parameter. It still is used to schedule timeout checks and -
 * as a consequence - when second Observable will be subscribed, since subscription happens
 * immediately after failing check.
 *
 * @example <caption>Add fallback observable</caption>
 * const seconds = Rx.Observable.interval(1000);
 * const minutes = Rx.Observable.interval(60 * 1000);
 *
 * seconds.timeoutWith(900, minutes)
 *     .subscribe(
 *         value => console.log(value), // After 900ms, will start emitting `minutes`,
 *                                      // since first value of `seconds` will not arrive fast enough.
 *         err => console.log(err) // Would be called after 900ms in case of `timeout`,
 *                                 // but here will never be called.
 *     );
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Observable<T>} withObservable Observable which will be subscribed if source fails timeout check.
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source or, when timeout check fails, of an Observable
 *                          passed as a second parameter.
 * @method timeoutWith
 * @owner Observable
 */ function $5a0f25567b9174cd$var$timeoutWith(due, withObservable, scheduler) {
    if (scheduler === void 0) scheduler = $jAy5L.async;
    return function(source) {
        var absoluteTimeout = $lmVpl.isDate(due);
        var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
        return source.lift(new $5a0f25567b9174cd$var$TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler));
    };
}
module.exports.timeoutWith = $5a0f25567b9174cd$var$timeoutWith;
var $5a0f25567b9174cd$var$TimeoutWithOperator = function() {
    function TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
    }
    TimeoutWithOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $5a0f25567b9174cd$var$TimeoutWithSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.withObservable, this.scheduler));
    };
    return TimeoutWithOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $5a0f25567b9174cd$var$TimeoutWithSubscriber = function(_super) {
    $5a0f25567b9174cd$var$__extends(TimeoutWithSubscriber, _super);
    function TimeoutWithSubscriber(destination, absoluteTimeout, waitFor, withObservable, scheduler) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutWithSubscriber.dispatchTimeout = function(subscriber) {
        var withObservable = subscriber.withObservable;
        subscriber._unsubscribeAndRecycle();
        subscriber.add($87MtM.subscribeToResult(subscriber, withObservable));
    };
    TimeoutWithSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) // Recycle the action if we've already scheduled one. All the production
        // Scheduler Actions mutate their state/delay time and return themeselves.
        // VirtualActions are immutable, so they create and return a clone. In this
        // case, we need to set the action reference to the most recent VirtualAction,
        // to ensure that's the one we clone from next time.
        this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutWithSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutWithSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutWithSubscriber.prototype._unsubscribe = function() {
        this.action = null;
        this.scheduler = null;
        this.withObservable = null;
    };
    return TimeoutWithSubscriber;
}($6UnJS.OuterSubscriber);

});

parcelRegister("coloa", function(module, exports) {
"use strict";

var $jAy5L = parcelRequire("jAy5L");

var $aynDk = parcelRequire("aynDk");
/**
 * @param scheduler
 * @return {Observable<Timestamp<any>>|WebSocketSubject<T>|Observable<T>}
 * @method timestamp
 * @owner Observable
 */ function timestamp(scheduler) {
    if (scheduler === void 0) scheduler = $jAy5L.async;
    return $aynDk.map(function(value) {
        return new Timestamp(value, scheduler.now());
    });
// return (source: Observable<T>) => source.lift(new TimestampOperator(scheduler));
}
exports.timestamp = timestamp;
var Timestamp = function() {
    function Timestamp(value, timestamp) {
        this.value = value;
        this.timestamp = timestamp;
    }
    return Timestamp;
}();
exports.Timestamp = Timestamp;

});

parcelRegister("bkg2F", function(module, exports) {
"use strict";
var $83ee019273a581fe$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $a7QRR = parcelRequire("a7QRR");

var $70s4u = parcelRequire("70s4u");
/**
 * Branch out the source Observable values as a nested Observable with each
 * nested Observable emitting at most `windowSize` values.
 *
 * <span class="informal">It's like {@link bufferCount}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowCount.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows every `startWindowEvery`
 * items, each containing no more than `windowSize` items. When the source
 * Observable completes or encounters an error, the output Observable emits
 * the current window and propagates the notification from the source
 * Observable. If `startWindowEvery` is not provided, then new windows are
 * started immediately at the start of the source and when each window completes
 * with size `windowSize`.
 *
 * @example <caption>Ignore every 3rd click event, starting from the first one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(3)
 *   .map(win => win.skip(1)) // skip first of every 3 clicks
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Ignore every 3rd click event, starting from the third one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(2, 3)
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link bufferCount}
 *
 * @param {number} windowSize The maximum number of values emitted by each
 * window.
 * @param {number} [startWindowEvery] Interval at which to start a new window.
 * For example if `startWindowEvery` is `2`, then a new window will be started
 * on every other value from the source. A new window is started at the
 * beginning of the source by default.
 * @return {Observable<Observable<T>>} An Observable of windows, which in turn
 * are Observable of values.
 * @method windowCount
 * @owner Observable
 */ function $83ee019273a581fe$var$windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) startWindowEvery = 0;
    return function windowCountOperatorFunction(source) {
        return source.lift(new $83ee019273a581fe$var$WindowCountOperator(windowSize, startWindowEvery));
    };
}
module.exports.windowCount = $83ee019273a581fe$var$windowCount;
var $83ee019273a581fe$var$WindowCountOperator = function() {
    function WindowCountOperator(windowSize, startWindowEvery) {
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
    }
    WindowCountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $83ee019273a581fe$var$WindowCountSubscriber(subscriber, this.windowSize, this.startWindowEvery));
    };
    return WindowCountOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $83ee019273a581fe$var$WindowCountSubscriber = function(_super) {
    $83ee019273a581fe$var$__extends(WindowCountSubscriber, _super);
    function WindowCountSubscriber(destination, windowSize, startWindowEvery) {
        _super.call(this, destination);
        this.destination = destination;
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
        this.windows = [
            new $70s4u.Subject()
        ];
        this.count = 0;
        destination.next(this.windows[0]);
    }
    WindowCountSubscriber.prototype._next = function(value) {
        var startWindowEvery = this.startWindowEvery > 0 ? this.startWindowEvery : this.windowSize;
        var destination = this.destination;
        var windowSize = this.windowSize;
        var windows = this.windows;
        var len = windows.length;
        for(var i = 0; i < len && !this.closed; i++)windows[i].next(value);
        var c = this.count - windowSize + 1;
        if (c >= 0 && c % startWindowEvery === 0 && !this.closed) windows.shift().complete();
        if (++this.count % startWindowEvery === 0 && !this.closed) {
            var window_1 = new $70s4u.Subject();
            windows.push(window_1);
            destination.next(window_1);
        }
    };
    WindowCountSubscriber.prototype._error = function(err) {
        var windows = this.windows;
        if (windows) while(windows.length > 0 && !this.closed)windows.shift().error(err);
        this.destination.error(err);
    };
    WindowCountSubscriber.prototype._complete = function() {
        var windows = this.windows;
        if (windows) while(windows.length > 0 && !this.closed)windows.shift().complete();
        this.destination.complete();
    };
    /** @deprecated internal use only */ WindowCountSubscriber.prototype._unsubscribe = function() {
        this.count = 0;
        this.windows = null;
    };
    return WindowCountSubscriber;
}($a7QRR.Subscriber);

});

parcelRegister("3SRp7", function(module, exports) {
"use strict";
var $2d3fd72de49b1523$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $70s4u = parcelRequire("70s4u");

var $jAy5L = parcelRequire("jAy5L");

var $a7QRR = parcelRequire("a7QRR");

var $aziyh = parcelRequire("aziyh");

var $pfY9o = parcelRequire("pfY9o");
function $2d3fd72de49b1523$var$windowTime(windowTimeSpan) {
    var scheduler = $jAy5L.async;
    var windowCreationInterval = null;
    var maxWindowSize = Number.POSITIVE_INFINITY;
    if ($pfY9o.isScheduler(arguments[3])) scheduler = arguments[3];
    if ($pfY9o.isScheduler(arguments[2])) scheduler = arguments[2];
    else if ($aziyh.isNumeric(arguments[2])) maxWindowSize = arguments[2];
    if ($pfY9o.isScheduler(arguments[1])) scheduler = arguments[1];
    else if ($aziyh.isNumeric(arguments[1])) windowCreationInterval = arguments[1];
    return function windowTimeOperatorFunction(source) {
        return source.lift(new $2d3fd72de49b1523$var$WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler));
    };
}
module.exports.windowTime = $2d3fd72de49b1523$var$windowTime;
var $2d3fd72de49b1523$var$WindowTimeOperator = function() {
    function WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
    }
    WindowTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2d3fd72de49b1523$var$WindowTimeSubscriber(subscriber, this.windowTimeSpan, this.windowCreationInterval, this.maxWindowSize, this.scheduler));
    };
    return WindowTimeOperator;
}();
var $2d3fd72de49b1523$var$CountedSubject = function(_super) {
    $2d3fd72de49b1523$var$__extends(CountedSubject, _super);
    function CountedSubject() {
        _super.apply(this, arguments);
        this._numberOfNextedValues = 0;
    }
    CountedSubject.prototype.next = function(value) {
        this._numberOfNextedValues++;
        _super.prototype.next.call(this, value);
    };
    Object.defineProperty(CountedSubject.prototype, "numberOfNextedValues", {
        get: function() {
            return this._numberOfNextedValues;
        },
        enumerable: true,
        configurable: true
    });
    return CountedSubject;
}($70s4u.Subject);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2d3fd72de49b1523$var$WindowTimeSubscriber = function(_super) {
    $2d3fd72de49b1523$var$__extends(WindowTimeSubscriber, _super);
    function WindowTimeSubscriber(destination, windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        _super.call(this, destination);
        this.destination = destination;
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
        this.windows = [];
        var window = this.openWindow();
        if (windowCreationInterval !== null && windowCreationInterval >= 0) {
            var closeState = {
                subscriber: this,
                window: window,
                context: null
            };
            var creationState = {
                windowTimeSpan: windowTimeSpan,
                windowCreationInterval: windowCreationInterval,
                subscriber: this,
                scheduler: scheduler
            };
            this.add(scheduler.schedule($2d3fd72de49b1523$var$dispatchWindowClose, windowTimeSpan, closeState));
            this.add(scheduler.schedule($2d3fd72de49b1523$var$dispatchWindowCreation, windowCreationInterval, creationState));
        } else {
            var timeSpanOnlyState = {
                subscriber: this,
                window: window,
                windowTimeSpan: windowTimeSpan
            };
            this.add(scheduler.schedule($2d3fd72de49b1523$var$dispatchWindowTimeSpanOnly, windowTimeSpan, timeSpanOnlyState));
        }
    }
    WindowTimeSubscriber.prototype._next = function(value) {
        var windows = this.windows;
        var len = windows.length;
        for(var i = 0; i < len; i++){
            var window_1 = windows[i];
            if (!window_1.closed) {
                window_1.next(value);
                if (window_1.numberOfNextedValues >= this.maxWindowSize) this.closeWindow(window_1);
            }
        }
    };
    WindowTimeSubscriber.prototype._error = function(err) {
        var windows = this.windows;
        while(windows.length > 0)windows.shift().error(err);
        this.destination.error(err);
    };
    WindowTimeSubscriber.prototype._complete = function() {
        var windows = this.windows;
        while(windows.length > 0){
            var window_2 = windows.shift();
            if (!window_2.closed) window_2.complete();
        }
        this.destination.complete();
    };
    WindowTimeSubscriber.prototype.openWindow = function() {
        var window = new $2d3fd72de49b1523$var$CountedSubject();
        this.windows.push(window);
        var destination = this.destination;
        destination.next(window);
        return window;
    };
    WindowTimeSubscriber.prototype.closeWindow = function(window) {
        window.complete();
        var windows = this.windows;
        windows.splice(windows.indexOf(window), 1);
    };
    return WindowTimeSubscriber;
}($a7QRR.Subscriber);
function $2d3fd72de49b1523$var$dispatchWindowTimeSpanOnly(state) {
    var subscriber = state.subscriber, windowTimeSpan = state.windowTimeSpan, window = state.window;
    if (window) subscriber.closeWindow(window);
    state.window = subscriber.openWindow();
    this.schedule(state, windowTimeSpan);
}
function $2d3fd72de49b1523$var$dispatchWindowCreation(state) {
    var windowTimeSpan = state.windowTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler, windowCreationInterval = state.windowCreationInterval;
    var window = subscriber.openWindow();
    var action = this;
    var context = {
        action: action,
        subscription: null
    };
    var timeSpanState = {
        subscriber: subscriber,
        window: window,
        context: context
    };
    context.subscription = scheduler.schedule($2d3fd72de49b1523$var$dispatchWindowClose, windowTimeSpan, timeSpanState);
    action.add(context.subscription);
    action.schedule(state, windowCreationInterval);
}
function $2d3fd72de49b1523$var$dispatchWindowClose(state) {
    var subscriber = state.subscriber, window = state.window, context = state.context;
    if (context && context.action && context.subscription) context.action.remove(context.subscription);
    subscriber.closeWindow(window);
}

});

parcelRegister("aR6Rt", function(module, exports) {
"use strict";
var $7e742d2b90f0d0d7$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $70s4u = parcelRequire("70s4u");

var $hIoOm = parcelRequire("hIoOm");

var $jJdW6 = parcelRequire("jJdW6");

var $4b4q3 = parcelRequire("4b4q3");

var $6UnJS = parcelRequire("6UnJS");

var $87MtM = parcelRequire("87MtM");
/**
 * Branch out the source Observable values as a nested Observable starting from
 * an emission from `openings` and ending when the output of `closingSelector`
 * emits.
 *
 * <span class="informal">It's like {@link bufferToggle}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowToggle.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows that contain those items
 * emitted by the source Observable between the time when the `openings`
 * Observable emits an item and when the Observable returned by
 * `closingSelector` emits an item.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var result = clicks.windowToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * ).mergeAll();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowWhen}
 * @see {@link bufferToggle}
 *
 * @param {Observable<O>} openings An observable of notifications to start new
 * windows.
 * @param {function(value: O): Observable} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns an Observable,
 * which, when it emits (either `next` or `complete`), signals that the
 * associated window should complete.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowToggle
 * @owner Observable
 */ function $7e742d2b90f0d0d7$var$windowToggle(openings, closingSelector) {
    return function(source) {
        return source.lift(new $7e742d2b90f0d0d7$var$WindowToggleOperator(openings, closingSelector));
    };
}
module.exports.windowToggle = $7e742d2b90f0d0d7$var$windowToggle;
var $7e742d2b90f0d0d7$var$WindowToggleOperator = function() {
    function WindowToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    WindowToggleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $7e742d2b90f0d0d7$var$WindowToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return WindowToggleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $7e742d2b90f0d0d7$var$WindowToggleSubscriber = function(_super) {
    $7e742d2b90f0d0d7$var$__extends(WindowToggleSubscriber, _super);
    function WindowToggleSubscriber(destination, openings, closingSelector) {
        _super.call(this, destination);
        this.openings = openings;
        this.closingSelector = closingSelector;
        this.contexts = [];
        this.add(this.openSubscription = $87MtM.subscribeToResult(this, openings, openings));
    }
    WindowToggleSubscriber.prototype._next = function(value) {
        var contexts = this.contexts;
        if (contexts) {
            var len = contexts.length;
            for(var i = 0; i < len; i++)contexts[i].window.next(value);
        }
    };
    WindowToggleSubscriber.prototype._error = function(err) {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context = contexts[index];
                context.window.error(err);
                context.subscription.unsubscribe();
            }
        }
        _super.prototype._error.call(this, err);
    };
    WindowToggleSubscriber.prototype._complete = function() {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context = contexts[index];
                context.window.complete();
                context.subscription.unsubscribe();
            }
        }
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ WindowToggleSubscriber.prototype._unsubscribe = function() {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context = contexts[index];
                context.window.unsubscribe();
                context.subscription.unsubscribe();
            }
        }
    };
    WindowToggleSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (outerValue === this.openings) {
            var closingSelector = this.closingSelector;
            var closingNotifier = $jJdW6.tryCatch(closingSelector)(innerValue);
            if (closingNotifier === $4b4q3.errorObject) return this.error($4b4q3.errorObject.e);
            else {
                var window_1 = new $70s4u.Subject();
                var subscription = new $hIoOm.Subscription();
                var context = {
                    window: window_1,
                    subscription: subscription
                };
                this.contexts.push(context);
                var innerSubscription = $87MtM.subscribeToResult(this, closingNotifier, context);
                if (innerSubscription.closed) this.closeWindow(this.contexts.length - 1);
                else {
                    innerSubscription.context = context;
                    subscription.add(innerSubscription);
                }
                this.destination.next(window_1);
            }
        } else this.closeWindow(this.contexts.indexOf(outerValue));
    };
    WindowToggleSubscriber.prototype.notifyError = function(err) {
        this.error(err);
    };
    WindowToggleSubscriber.prototype.notifyComplete = function(inner) {
        if (inner !== this.openSubscription) this.closeWindow(this.contexts.indexOf(inner.context));
    };
    WindowToggleSubscriber.prototype.closeWindow = function(index) {
        if (index === -1) return;
        var contexts = this.contexts;
        var context = contexts[index];
        var window = context.window, subscription = context.subscription;
        contexts.splice(index, 1);
        window.complete();
        subscription.unsubscribe();
    };
    return WindowToggleSubscriber;
}($6UnJS.OuterSubscriber);

});

parcelRegister("hiGV8", function(module, exports) {
"use strict";
var $c9856937ce418dc8$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $70s4u = parcelRequire("70s4u");

var $jJdW6 = parcelRequire("jJdW6");

var $4b4q3 = parcelRequire("4b4q3");

var $6UnJS = parcelRequire("6UnJS");

var $87MtM = parcelRequire("87MtM");
/**
 * Branch out the source Observable values as a nested Observable using a
 * factory function of closing Observables to determine when to start a new
 * window.
 *
 * <span class="informal">It's like {@link bufferWhen}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowWhen.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping windows.
 * It emits the current window and opens a new one whenever the Observable
 * produced by the specified `closingSelector` function emits an item. The first
 * window is opened immediately when subscribing to the output Observable.
 *
 * @example <caption>Emit only the first two clicks events in every window of [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks
 *   .windowWhen(() => Rx.Observable.interval(1000 + Math.random() * 4000))
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link bufferWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals (on either `next` or
 * `complete`) when to close the previous window and start a new one.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowWhen
 * @owner Observable
 */ function $c9856937ce418dc8$var$windowWhen(closingSelector) {
    return function windowWhenOperatorFunction(source) {
        return source.lift(new $c9856937ce418dc8$var$WindowOperator(closingSelector));
    };
}
module.exports.windowWhen = $c9856937ce418dc8$var$windowWhen;
var $c9856937ce418dc8$var$WindowOperator = function() {
    function WindowOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    WindowOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $c9856937ce418dc8$var$WindowSubscriber(subscriber, this.closingSelector));
    };
    return WindowOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $c9856937ce418dc8$var$WindowSubscriber = function(_super) {
    $c9856937ce418dc8$var$__extends(WindowSubscriber, _super);
    function WindowSubscriber(destination, closingSelector) {
        _super.call(this, destination);
        this.destination = destination;
        this.closingSelector = closingSelector;
        this.openWindow();
    }
    WindowSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function(innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype._next = function(value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function(err) {
        this.window.error(err);
        this.destination.error(err);
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype._complete = function() {
        this.window.complete();
        this.destination.complete();
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype.unsubscribeClosingNotification = function() {
        if (this.closingNotification) this.closingNotification.unsubscribe();
    };
    WindowSubscriber.prototype.openWindow = function(innerSub) {
        if (innerSub === void 0) innerSub = null;
        if (innerSub) {
            this.remove(innerSub);
            innerSub.unsubscribe();
        }
        var prevWindow = this.window;
        if (prevWindow) prevWindow.complete();
        var window = this.window = new $70s4u.Subject();
        this.destination.next(window);
        var closingNotifier = $jJdW6.tryCatch(this.closingSelector)();
        if (closingNotifier === $4b4q3.errorObject) {
            var err = $4b4q3.errorObject.e;
            this.destination.error(err);
            this.window.error(err);
        } else this.add(this.closingNotification = $87MtM.subscribeToResult(this, closingNotifier));
    };
    return WindowSubscriber;
}($6UnJS.OuterSubscriber);

});

parcelRegister("u6syz", function(module, exports) {

$parcel$export(module.exports, "zipAll", () => $05a7d032497b53ba$export$adddb6a2fa3864e9, (v) => $05a7d032497b53ba$export$adddb6a2fa3864e9 = v);
var $05a7d032497b53ba$export$adddb6a2fa3864e9;
"use strict";

var $5f7nL = parcelRequire("5f7nL");
function $05a7d032497b53ba$var$zipAll(project) {
    return function(source) {
        return source.lift(new $5f7nL.ZipOperator(project));
    };
}
$05a7d032497b53ba$export$adddb6a2fa3864e9 = $05a7d032497b53ba$var$zipAll;

});


parcelRegister("hsrY5", function(module, exports) {

$parcel$export(module.exports, "fetchConfluencePermissions", () => $5d52f3e69b9d0262$export$332e821aef1400f5);
$parcel$export(module.exports, "fetchConfluenceSpace", () => $5d52f3e69b9d0262$export$41d2a3af49f11b2d);
$parcel$export(module.exports, "fetchUserProperties", () => $5d52f3e69b9d0262$export$71dedae73ec3e04c);
$parcel$export(module.exports, "setUserProperties", () => $5d52f3e69b9d0262$export$d0e176862bf869b8);

var $cwK3t = parcelRequire("cwK3t");

var $7byHA = parcelRequire("7byHA");
var $aiRd8 = parcelRequire("aiRd8");

var $88Osm = parcelRequire("88Osm");
function $5d52f3e69b9d0262$export$332e821aef1400f5() {
    return (0, $aiRd8.default)('/wiki/rest/api/user/current?expand=operations');
}
function $5d52f3e69b9d0262$export$41d2a3af49f11b2d() {
    return (0, $aiRd8.default)('/wiki/api/v2/spaces?limit=1');
}
function $5d52f3e69b9d0262$export$71dedae73ec3e04c(accountId) {
    return (0, $aiRd8.default)(`/rest/api/3/user/properties/viewedJswWhiteboardPulse?accountId=${encodeURIComponent(accountId)}`);
}
function $5d52f3e69b9d0262$export$d0e176862bf869b8(accountId, value) {
    const url = `/rest/api/3/user/properties/viewedJswWhiteboardPulse?accountId=${encodeURIComponent(accountId)}`;
    return (0, $cwK3t.of)(url).mergeMap(()=>fetch(url, {
            method: 'PUT',
            body: JSON.stringify(value)
        })).mergeMap((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            response.text().then((str)=>{
                const traceId = response.headers.get((0, $88Osm.TRACE_ID_HEADER));
                if (traceId != null && traceId !== '') throw new (0, $7byHA.default)(status, str, traceId);
                else throw new (0, $7byHA.default)(status, str);
            });
            return (0, $cwK3t.of)(false);
        }
        return (0, $cwK3t.of)(value);
    });
}

});

parcelRegister("h4zn0", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_ACCESS_ESTABLISHED", () => $efdcbddb85e5887d$export$86ff0b70bde2d576);
$parcel$export(module.exports, "hasConfluenceAccessEstablished", () => $efdcbddb85e5887d$export$c02c656c5dc2a2ee);
$parcel$export(module.exports, "HAS_CONFLUENCE_SPACES", () => $efdcbddb85e5887d$export$a78459aed6412fc9);
$parcel$export(module.exports, "hasConfluenceSpacesEstablished", () => $efdcbddb85e5887d$export$bcddac2aa11c03a1);
$parcel$export(module.exports, "PULSE_VIEWED_ESTABLISHED", () => $efdcbddb85e5887d$export$aff843e6dd79f5fd);
$parcel$export(module.exports, "hasPulseViewedEstablished", () => $efdcbddb85e5887d$export$1aa51b12785e9723);
$parcel$export(module.exports, "SET_HAS_PULSE_VIEWED_REQUEST", () => $efdcbddb85e5887d$export$af0269ca30d614b8);
$parcel$export(module.exports, "setHasViewedPulseRequest", () => $efdcbddb85e5887d$export$6fa3906ec8cd7234);
$parcel$export(module.exports, "SET_HAS_PULSE_VIEWED_SUCCESS", () => $efdcbddb85e5887d$export$87ad89501ab41856);
$parcel$export(module.exports, "setHasViewedPulseSuccess", () => $efdcbddb85e5887d$export$2b30b32270ccf7af);
$parcel$export(module.exports, "setHasViewedPulseFailure", () => $efdcbddb85e5887d$export$bc640b3001815bc);
$parcel$export(module.exports, "SET_WHITEBOARD_ELIGIBILITY", () => $efdcbddb85e5887d$export$4d0a6a14430368e6);
$parcel$export(module.exports, "setWhiteboardEligibility", () => $efdcbddb85e5887d$export$e965b613697e9fbe);
const $efdcbddb85e5887d$export$86ff0b70bde2d576 = 'state.actions.permissions.CONFLUENCE_ACCESS_ESTABLISHED';
const $efdcbddb85e5887d$export$c02c656c5dc2a2ee = (hasConfluenceAccess)=>({
        type: $efdcbddb85e5887d$export$86ff0b70bde2d576,
        payload: {
            hasConfluenceAccess: hasConfluenceAccess
        }
    });
const $efdcbddb85e5887d$export$a78459aed6412fc9 = 'state.actions.HAS_CONFLUENCE_SPACES';
const $efdcbddb85e5887d$export$bcddac2aa11c03a1 = (hasConfluenceSpaces)=>({
        type: $efdcbddb85e5887d$export$a78459aed6412fc9,
        payload: {
            hasConfluenceSpaces: hasConfluenceSpaces
        }
    });
const $efdcbddb85e5887d$export$aff843e6dd79f5fd = 'state.actions.permissions.PULSE_VIEWED_ESTABLISHED';
const $efdcbddb85e5887d$export$1aa51b12785e9723 = (hasViewedPulse)=>({
        type: $efdcbddb85e5887d$export$aff843e6dd79f5fd,
        payload: {
            hasViewedPulse: hasViewedPulse
        }
    });
const $efdcbddb85e5887d$export$af0269ca30d614b8 = 'state.actions.permissions.SET_HAS_PULSE_VIEWED_REQUEST';
const $efdcbddb85e5887d$export$6fa3906ec8cd7234 = ()=>({
        type: $efdcbddb85e5887d$export$af0269ca30d614b8
    });
const $efdcbddb85e5887d$export$87ad89501ab41856 = 'state.actions.permissions.SET_HAS_PULSE_VIEWED_SUCCESS';
const $efdcbddb85e5887d$export$2b30b32270ccf7af = (hasViewedPulse)=>({
        type: $efdcbddb85e5887d$export$87ad89501ab41856,
        payload: {
            hasViewedPulse: hasViewedPulse
        }
    });
const $efdcbddb85e5887d$export$d8f506a9cdc0255f = 'state.actions.permissions.SET_HAS_PULSE_VIEWED_FAILURE';
const $efdcbddb85e5887d$export$bc640b3001815bc = ()=>({
        type: $efdcbddb85e5887d$export$d8f506a9cdc0255f
    });
const $efdcbddb85e5887d$export$4d0a6a14430368e6 = 'state.actions.permissions.SET_WHITEBOARD_ELIGIBILITY';
const $efdcbddb85e5887d$export$e965b613697e9fbe = ({ flow: flow, cohort: cohort })=>({
        type: $efdcbddb85e5887d$export$4d0a6a14430368e6,
        payload: {
            flow: flow,
            cohort: cohort
        }
    });

});



parcelRegister("l49DW", function(module, exports) {

$parcel$export(module.exports, "loadWhiteboardsEntrypointExperimentHasConfluenceSpacesEpic", () => $4b4a9428dadfcb1a$export$f26c26528292651d);
parcelRequire("jyKN9");
parcelRequire("iects");
parcelRequire("flmol");
parcelRequire("1Lcr1");

var $b7Uvu = parcelRequire("b7Uvu");

var $jiL2Q = parcelRequire("jiL2Q");

var $h4zn0 = parcelRequire("h4zn0");
const $4b4a9428dadfcb1a$var$loadHasConfluenceSpaces = ()=>(0, $b7Uvu.loadConfluenceSpaceService)().map((0, $h4zn0.hasConfluenceSpacesEstablished));
const $4b4a9428dadfcb1a$export$f26c26528292651d = (action$)=>action$.ofType((0, $jiL2Q.LOAD_APP_DATA_REQUEST)).flatMap(()=>$4b4a9428dadfcb1a$var$loadHasConfluenceSpaces());

});

parcelRegister("ewlNK", function(module, exports) {

$parcel$export(module.exports, "loadHasViewedPulseEpic", () => $e6254deb27051ad7$export$f180856742fe6c9c);
$parcel$export(module.exports, "setHasViewedPulseEpic", () => $e6254deb27051ad7$export$b20cea5fdc1cf5e2);
parcelRequire("jyKN9");
parcelRequire("iects");
parcelRequire("flmol");
parcelRequire("1Lcr1");

var $b7Uvu = parcelRequire("b7Uvu");

var $jiL2Q = parcelRequire("jiL2Q");

var $h4zn0 = parcelRequire("h4zn0");

var $hkGxG = parcelRequire("hkGxG");
const $e6254deb27051ad7$var$loadHasViewedPulse = ({ store: store })=>{
    const accountId = (0, $hkGxG.getAtlassianAccountId)(store.getState());
    return (0, $b7Uvu.loadHasViewedPulseService)(accountId ?? '').map((0, $h4zn0.hasPulseViewedEstablished));
};
const $e6254deb27051ad7$export$f180856742fe6c9c = (action$, store)=>action$.ofType((0, $jiL2Q.LOAD_APP_DATA_REQUEST)).flatMap(()=>$e6254deb27051ad7$var$loadHasViewedPulse({
            store: store
        }));
const $e6254deb27051ad7$export$b20cea5fdc1cf5e2 = (action$, store)=>action$.ofType((0, $h4zn0.SET_HAS_PULSE_VIEWED_REQUEST)).flatMap(()=>(0, $b7Uvu.setHasViewedPulseService)({
            store: store
        }));

});


parcelRegister("75fux", function(module, exports) {

$parcel$export(module.exports, "refreshBacklog", () => $560f70312d44a243$export$d182fa418f4f1d16);

var $3JafE = parcelRequire("3JafE");
parcelRequire("kIwye");
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("7Rus6");
parcelRequire("dfsI8");
parcelRequire("8OtG5");
parcelRequire("l8Y8n");
parcelRequire("5dKXv");
parcelRequire("b48pz");
parcelRequire("3wBUP");

var $5LWdq = parcelRequire("5LWdq");

var $8wXFi = parcelRequire("8wXFi");

var $7TyGu = parcelRequire("7TyGu");

var $jiL2Q = parcelRequire("jiL2Q");

var $hkGxG = parcelRequire("hkGxG");

var $aWtR7 = parcelRequire("aWtR7");
const $560f70312d44a243$export$4bac01e56d750d42 = Symbol('STREAM_START_MARKER');
const $560f70312d44a243$var$DEBOUNCE_TIME = 1000;
const $560f70312d44a243$export$d182fa418f4f1d16 = (debounceScheduler, intervalScheduler, throttleScheduler)=>(action$, store)=>{
        const pollingInterval = (0, $8wXFi.getBacklogPollingInterval)();
        return (0, $5LWdq.default)().distinctUntilChanged().debounceTime($560f70312d44a243$var$DEBOUNCE_TIME, debounceScheduler) // prevent multiple requests when switching tabs within 1s
        .switchMap((isTabVisible, idx)=>{
            if (!isTabVisible) return (0, $3JafE.Observable).empty();
            const refreshStream$ = (0, $3JafE.Observable).interval(pollingInterval, intervalScheduler).mapTo((0, $jiL2Q.refreshDataRequest)((0, $7TyGu.REFRESH_SOURCE_POLLING))).filter(()=>isTabVisible).filter(()=>!(0, $aWtR7.hasAnyActiveOptimistic)(store.getState())).filter(()=>(0, $hkGxG.getIsCompanyManaged)(store.getState()));
            return idx === 0 ? refreshStream$.startWith($560f70312d44a243$export$4bac01e56d750d42) : refreshStream$.startWith((0, $jiL2Q.refreshDataRequest)((0, $7TyGu.REFRESH_SOURCE_ACTIVE_TAB)));
        }).throttleTime(pollingInterval, throttleScheduler).filter((action)=>action !== $560f70312d44a243$export$4bac01e56d750d42);
    };

});
parcelRegister("5LWdq", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc20929970eebc75$export$2e2bcd8739ae039);

var $3JafE = parcelRequire("3JafE");

var $70s4u = parcelRequire("70s4u");
parcelRequire("fRdoC");
parcelRequire("7Rus6");
parcelRequire("flmol");

var $fEYK5 = parcelRequire("fEYK5");
/**
 * Returns a stream of the current page visibility state whenever it changes.
 * Emits 'true' when the page is visible and 'false' when the page is hidden.
 *
 * Will emit `null` if document is not defined.
 *
 * This Observable WILL EMIT a value at the start of the load. If you're using
 * it to trigger refreshes, you should skip 1 value.
 */ const $fc20929970eebc75$var$getVisibility$ = ()=>// @ts-expect-error - TS2322 - Type 'Observable<unknown>' is not assignable to type 'Observable<boolean | null>'.
    typeof document !== 'undefined' ? (0, $3JafE.Observable).fromEvent(document, (0, $fEYK5.supportedVisiblityEvent))// We want to send the current visibility on a new subscription.
    // If we use `.startWith(isPageVisible())` then new subscribers
    // will get the initial visibility at load and not the current
    // visibility as the initial value.
    .startWith(null).map((0, $fEYK5.isPageVisible)) : new (0, $70s4u.Subject)().startWith(null);
var $fc20929970eebc75$export$2e2bcd8739ae039 = $fc20929970eebc75$var$getVisibility$;

});


parcelRegister("lnycy", function(module, exports) {

$parcel$export(module.exports, "workloadModalSubtaskToggleEpic", () => $ab9024a778362775$export$79647fc8c74209a6);

var $3JafE = parcelRequire("3JafE");
parcelRequire("8jBvP");
parcelRequire("iects");

var $iYUz7 = parcelRequire("iYUz7");

var $bDGeR = parcelRequire("bDGeR");

var $50VCL = parcelRequire("50VCL");
const $ab9024a778362775$export$79647fc8c74209a6 = (action$, store)=>action$.ofType((0, $bDGeR.TOGGLE_INCLUDE_SUBTASKS)).flatMap(()=>{
        const state = store.getState();
        const includeSubtasks = (0, $50VCL.getIncludeSubtasks)(state);
        (0, $iYUz7.setWorkloadSubtaskSettings)(includeSubtasks);
        return (0, $3JafE.Observable).empty();
    });

});
parcelRegister("bDGeR", function(module, exports) {

$parcel$export(module.exports, "TOGGLE_INCLUDE_SUBTASKS", () => $2859cd839ef82557$export$9e8abc0f766522c0);
$parcel$export(module.exports, "SET_INCLUDE_SUBTASKS", () => $2859cd839ef82557$export$2bb50ef8dfae1cac);
$parcel$export(module.exports, "toggleIncludeSubtasks", () => $2859cd839ef82557$export$4010b3772248a658);
$parcel$export(module.exports, "setIncludeSubtasksAction", () => $2859cd839ef82557$export$1c3dc37b8734dfc3);
const $2859cd839ef82557$export$9e8abc0f766522c0 = 'state.actions.workload-modal.TOGGLE_INCLUDE_SUBTASKS';
const $2859cd839ef82557$export$2bb50ef8dfae1cac = 'state.actions.workload-modal.SET_INCLUDE_SUBTASKS';
const $2859cd839ef82557$export$4010b3772248a658 = ()=>({
        type: $2859cd839ef82557$export$9e8abc0f766522c0
    });
const $2859cd839ef82557$export$1c3dc37b8734dfc3 = (includeSubtasks)=>({
        type: $2859cd839ef82557$export$2bb50ef8dfae1cac,
        payload: {
            includeSubtasks: includeSubtasks
        }
    });

});

parcelRegister("50VCL", function(module, exports) {

$parcel$export(module.exports, "getIncludeSubtasks", () => $0d23c8933f0b4ff2$export$2ada7f35c22b42ed);
$parcel$export(module.exports, "makeWorkLoadByAssignee", () => $0d23c8933f0b4ff2$export$cfa0f2c87d880353);

var $df4Sl = parcelRequire("df4Sl");

var $fcWBJ = parcelRequire("fcWBJ");

var $jqvCZ = parcelRequire("jqvCZ");

var $3l6tm = parcelRequire("3l6tm");

var $bP7Jx = parcelRequire("bP7Jx");
const $0d23c8933f0b4ff2$export$2ada7f35c22b42ed = (state)=>state.ui.workloadModal.includeSubtasks;
const $0d23c8933f0b4ff2$export$cfa0f2c87d880353 = (0, $df4Sl.createSelector)([
    (0, $bP7Jx.makeOrderedVisibleCardsForCardList),
    $0d23c8933f0b4ff2$export$2ada7f35c22b42ed
], (getOrderedVisibleCardsForCardList, includeSubtasks)=>{
    const getWorkLoadByAssignee = (cardListId)=>{
        let listOfVisibleCards = getOrderedVisibleCardsForCardList(cardListId);
        if (!includeSubtasks) listOfVisibleCards = listOfVisibleCards.filter((card)=>!(0, $3l6tm.isSubtaskHierarchyLevel)(card.typeHierarchyLevel));
        const cardsGroupedByAssigned = (0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))(listOfVisibleCards, (card)=>card.assignee?.id ?? 'unassigned');
        const assignees = Object.values(cardsGroupedByAssigned).map((cardList)=>{
            const initial = {
                name: undefined,
                profilePicture: undefined,
                storyPoints: 0,
                remainingTimeEstimateInSeconds: 0,
                originalTimeEstimateInSeconds: 0,
                issueCount: 0,
                subtaskCount: 0
            };
            return cardList.reduce((prev, card)=>{
                const storyPointIncrement = card.estimate?.storyPoints ?? 0;
                const timeEstimateIncrement = card.estimate?.originalEstimate?.value ?? 0;
                const timeRemainingIncrement = card.estimate?.timeRemainingEstimate?.value ?? 0;
                return {
                    name: card.assignee?.displayName ?? prev.name,
                    profilePicture: card.assignee?.avatarUrl ?? prev.name,
                    storyPoints: prev.storyPoints + storyPointIncrement,
                    originalTimeEstimateInSeconds: prev.originalTimeEstimateInSeconds + timeEstimateIncrement,
                    remainingTimeEstimateInSeconds: prev.remainingTimeEstimateInSeconds + timeRemainingIncrement,
                    issueCount: (0, $3l6tm.isSubtaskHierarchyLevel)(card.typeHierarchyLevel) ? prev.issueCount : prev.issueCount + 1,
                    subtaskCount: (0, $3l6tm.isSubtaskHierarchyLevel)(card.typeHierarchyLevel) ? (prev.subtaskCount ?? 0) + 1 : prev.subtaskCount
                };
            }, initial);
        });
        return assignees;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))(getWorkLoadByAssignee);
});

});



parcelRegister("4xhKq", function(module, exports) {

$parcel$export(module.exports, "removeLocationLegacyPanelQueryParameters", () => $f5e7656c0e44aad5$export$1c4bddcdc8213ef1);

var $6HC1D = parcelRequire("6HC1D");

var $53ciZ = parcelRequire("53ciZ");

var $gUUjF = parcelRequire("gUUjF");

const $f5e7656c0e44aad5$export$1c4bddcdc8213ef1 = (location, push)=>{
    const search = (0, $6HC1D.chain)({
        ...(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(location.search)
    });
    const searchValue = search.value();
    let legacyPanelQueryParamRemoved = false;
    const { versionPanel: versionPanel, issueParentPanel: issueParentPanel } = searchValue;
    if (versionPanel) {
        search.unset((0, $5a6592135d519f1e$export$9c304e612707f622));
        legacyPanelQueryParamRemoved = true;
    }
    if (issueParentPanel) {
        search.unset((0, $5a6592135d519f1e$export$7f765927237d6fb0));
        legacyPanelQueryParamRemoved = true;
    }
    if (legacyPanelQueryParamRemoved) {
        const routerPayload = {
            ...location,
            search: (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(search.value())
        };
        (0, $gUUjF.default).safeInfoWithoutCustomerData('backlog.services.routing.legacy-panel-query-parameters', 'Removed legacy panel query parameter(s)', {
            versionPanel: versionPanel,
            issueParentPanel: issueParentPanel
        });
        push(routerPayload);
    }
};

});

parcelRegister("4T9ID", function(module, exports) {

$parcel$export(module.exports, "getCustomDataForMemoryAnalyticsFromUrl", () => $7fe1f5b7d4bf494a$export$f0fe5d1ef77b9f92);

const $7fe1f5b7d4bf494a$export$f0fe5d1ef77b9f92 = ()=>{
    // use the URL parameters to determine whether any panels are open
    const queryParams = new URL(window.location.href).searchParams;
    return {
        isEpicPanelOpen: queryParams.has((0, $5a6592135d519f1e$export$ec3c43b997309252)),
        isVersionPanelOpen: queryParams.has((0, $5a6592135d519f1e$export$a86c1a6dde9da34f)),
        isIssueViewOpen: queryParams.has((0, $5a6592135d519f1e$export$3a0c4bc79274bbaa))
    };
};

});

parcelRegister("1gQ73", function(module, exports) {

$parcel$export(module.exports, "createStoreWithCache", () => $5b848ddd6da33353$export$96feb51b037b866);
$parcel$export(module.exports, "unmountCachedStore", () => $5b848ddd6da33353$export$a0196b1023d1dffd);
$parcel$export(module.exports, "BacklogReduxProvider", () => $5b848ddd6da33353$export$ab832ec0f3793a0b);
$parcel$export(module.exports, "useBacklogStore", () => $5b848ddd6da33353$export$bd6baa7168fb537b);
$parcel$export(module.exports, "useBacklogSelector", () => $5b848ddd6da33353$export$3f6a924af1f755b6);
$parcel$export(module.exports, "useBacklogDispatch", () => $5b848ddd6da33353$export$230b86ce3b02444b);
$parcel$export(module.exports, "useBacklogActionCreator", () => $5b848ddd6da33353$export$d20547f842c968f1);
parcelRequire("iFajX");

var $8FRHo = parcelRequire("8FRHo");

var $hLwwF = parcelRequire("hLwwF");

var $7WlHE = parcelRequire("7WlHE");

var $3dfLH = parcelRequire("3dfLH");

var $7TyGu = parcelRequire("7TyGu");


var $fX3hy = parcelRequire("fX3hy");

var $ic57W = parcelRequire("ic57W");

var $jS607 = parcelRequire("jS607");
function $5b848ddd6da33353$export$2e2bcd8739ae039(preloadedState, { rootEpic: rootEpic, dependencies: dependencies }) {
    const middlewares = [
        (0, $fX3hy.default)(dependencies),
        (0, $hLwwF.default)((0, $7TyGu.APP_ID)),
        (0, $ic57W.default)
    ];
    var _getState, action;
    return (0, $8FRHo.default)({
        appName: 'backlog',
        rootReducer: $jS607.default,
        initialState: preloadedState ?? undefined,
        rootEpic: rootEpic,
        middlewares: middlewares,
        rootEpicDependencies: dependencies
    });
}
const $5b848ddd6da33353$export$a6385bddcc8e6b77 = new (0, $7WlHE.CachedStoreManager)({
    storeFactory: $5b848ddd6da33353$export$2e2bcd8739ae039,
    mergeCachedState: (cachedState, _preloadedState)=>cachedState
});
function $5b848ddd6da33353$export$96feb51b037b866(boardId, initialState, options) {
    return $5b848ddd6da33353$export$a6385bddcc8e6b77.createStore(boardId, initialState, options);
}
const $5b848ddd6da33353$export$a0196b1023d1dffd = ()=>{
    $5b848ddd6da33353$export$a6385bddcc8e6b77.unmount();
};
const { Provider: $5b848ddd6da33353$export$ab832ec0f3793a0b, useStore: $5b848ddd6da33353$export$bd6baa7168fb537b, useSelector: $5b848ddd6da33353$export$3f6a924af1f755b6, useDispatch: $5b848ddd6da33353$export$230b86ce3b02444b, useActionCreator: $5b848ddd6da33353$export$d20547f842c968f1 } = (0, $3dfLH.createJiraSoftwareStoreContext)();

});
parcelRegister("hLwwF", function(module, exports) {

$parcel$export(module.exports, "default", () => $2862a2f270e4342c$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $8xmdY = parcelRequire("8xmdY");
/**
 * Catches errors within redux reducers and makes them available to monitoring.
 *
 * Takes an optional error action creator as a parameter to be reduced when an error is encountered.
 * This could be used to show an error flag, for example.
 *
 * Should be passed as part of the middleware array when creating the store.
 * E.g. [middlewareOne, errorHandling('your-app-name')]
 */ const $2862a2f270e4342c$var$errorHandling = (appId, errorActionCreator, /**
		 * Callback for errors
		 */ onError)=>()=>(next)=>(action)=>{
                try {
                    next(action);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    const fullLocation = `common.redux-error.${appId}`;
                    (0, $gUUjF.default).safeErrorWithoutCustomerData(fullLocation, `Unhandled error for Redux action: '${action?.type}'`, error);
                    (0, $8xmdY.captureException)(fullLocation, error);
                    errorActionCreator && next(errorActionCreator());
                    onError && onError(error);
                }
            };
var $2862a2f270e4342c$export$2e2bcd8739ae039 = $2862a2f270e4342c$var$errorHandling;

});

parcelRegister("7WlHE", function(module, exports) {

$parcel$export(module.exports, "CachedStoreManager", () => $0f4b937c98dd2b60$export$519eb0cf9e49db0c);

var $E0NNP = parcelRequire("E0NNP");
class $0f4b937c98dd2b60$export$519eb0cf9e49db0c {
    constructor({ storeFactory: storeFactory, mergeCachedState: mergeCachedState }){
        this.cache = null;
        this.storeFactory = storeFactory;
        this.mergeCachedState = mergeCachedState;
    }
    /**
	 * Return true if the redux state was in cache. In this case, we won't consider
	 * the resources' data.
	 */ hasCachedState(boardId) {
        return Boolean(this.cache && this.cache.boardId === boardId);
    }
    getCachedState(boardId) {
        if (this.cache && this.cache.boardId === boardId) return this.cache.state;
        return null;
    }
    /**
	 * Create a new store, merging a preloadedState with any cached state that was
	 * previously held in memory.
	 */ createStore(boardId, preloadedStateParam, options) {
        // Cast to get rid of Omit<...>. Both types are partial so this is valid
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        let preloadedState = (0, (/*@__PURE__*/$parcel$interopDefault($E0NNP)))(preloadedStateParam);
        const cachedState = this.getCachedState(boardId);
        if (!options.disableStoreCaches && cachedState) preloadedState = this.mergeCachedState(cachedState, preloadedState);
        const store = this.storeFactory(preloadedState, options);
        if (options.disableStoreCaches) return store;
        // On every change copy a reference to the redux state to this
        // `cachedStoreState` object.
        this.unmount();
        this.cache = {
            boardId: boardId,
            state: store.getState(),
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            unsubscribe: ()=>{}
        };
        this.cache.unsubscribe = store.subscribe(()=>{
            if (this.cache) this.cache.state = store.getState();
        });
        return store;
    }
    /**
	 * Clean-up redux store subscriptions.
	 */ unmount() {
        this.cache?.unsubscribe();
    }
    /**
	 * FOR TESTING ONLY
	 */ getCacheForTesting() {
        return this.cache;
    }
}

});

parcelRegister("3dfLH", function(module, exports) {

$parcel$export(module.exports, "createJiraSoftwareStoreContext", () => $4e6a5a19ed02afc0$export$884b1d3e4c97abdd);

var $eUqFw = parcelRequire("eUqFw");

var $awFmn = parcelRequire("awFmn");

var $dkPd7 = parcelRequire("dkPd7");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4e6a5a19ed02afc0$var$refEquality = (a, b)=>a === b;
function $4e6a5a19ed02afc0$export$884b1d3e4c97abdd() {
    const ctx = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
    const useStore = ()=>{
        const store = (0, $eUqFw.useContext)(ctx);
        if (!store) throw new Error('useStore called outside of redux JiraSoftwareStoreContext tree');
        return store;
    };
    function useSelector(selector, equalityFn = $4e6a5a19ed02afc0$var$refEquality) {
        const store = useStore();
        const result = (0, $awFmn.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, // Server state probably wont exist but we can use store.getState in case it does work.
        store.getState, selector, equalityFn);
        return result;
    }
    function useDispatch() {
        const store = useStore();
        return store.dispatch;
    }
    function useActionCreator(actionCreator) {
        const dispatch = useDispatch();
        return (0, $dkPd7.useEvent)((...args)=>{
            const action = actionCreator(...args);
            dispatch(action);
        });
    }
    function ReduxProvider(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ctx.Provider, {
            value: props.store
        }, props.children);
    }
    return {
        Provider: ReduxProvider,
        useSelector: useSelector,
        useStore: useStore,
        useDispatch: useDispatch,
        useActionCreator: useActionCreator
    };
}

});
parcelRegister("dkPd7", function(module, exports) {

$parcel$export(module.exports, "useEvent", () => $e657ee26e376985d$export$90fc3a17d93f704c);

var $eUqFw = parcelRequire("eUqFw");
const $e657ee26e376985d$export$90fc3a17d93f704c = (callback)=>{
    const callbackRef = (0, $eUqFw.useRef)(callback);
    (0, $eUqFw.useLayoutEffect)(()=>{
        callbackRef.current = callback;
    }, [
        callback
    ]);
    return (0, $eUqFw.useCallback)((...args)=>callbackRef.current(...args), []);
};

});


parcelRegister("fX3hy", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e6a5caf7e011319$export$2e2bcd8739ae039);

var $8QOTu = parcelRequire("8QOTu");

var $8blac = parcelRequire("8blac");

var $jUhyG = parcelRequire("jUhyG");

var $hWS8F = parcelRequire("hWS8F");

var $jMP2a = parcelRequire("jMP2a");

var $hkGxG = parcelRequire("hkGxG");

var $4zPnR = parcelRequire("4zPnR");

var $g7xdG = parcelRequire("g7xdG");
const $5e6a5caf7e011319$var$APP_ANALYTICS_PREFIX = 'software-plan-view';
// @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
const $5e6a5caf7e011319$var$shouldTriggerAnalytics = ({ type: type } = {})=>(0, $4zPnR.default)()[type] !== undefined;
const $5e6a5caf7e011319$var$getAnalyticsForAction = (preActionState, postActionState, action, dependencies)=>(0, $4zPnR.default)()[action.type].map((createAnalytic)=>createAnalytic((0, $4zPnR.ANALYTIC_PREFIX))(preActionState, postActionState, action, dependencies)).filter((analyticEvent)=>analyticEvent != null);
const $5e6a5caf7e011319$var$triggerAnalyticsForAction = (analyticEvents, state)=>{
    const triggerSoftwareAnalytics = (0, $g7xdG.triggerAnalytics)($5e6a5caf7e011319$var$APP_ANALYTICS_PREFIX);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(analyticEvents)) return;
    analyticEvents.forEach(({ name: name, data: data = {}, trackEvents: trackEvents = [] })=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($8QOTu)))(data, {
            rapidViewId: (0, $hkGxG.getRapidViewId)(state),
            projectId: (0, $hkGxG.projectIdSelector)(state),
            isCompanyManaged: (0, $hkGxG.getIsCompanyManaged)(state)
        });
        // This is not doing anything, we can remove it as part of
        // https://hello.atlassian.net/browse/CATB-418
        triggerSoftwareAnalytics(name, data);
        trackEvents.forEach((trackEvent)=>{
            const { payload: payload } = trackEvent;
            const { action: action, actionSubject: actionSubject, card: card, ...otherProperties } = payload;
            /**
			 * Fields inputted by the user. When this was created, there was no ability to
			 * add in extra fields in the inline create, so we'll assume it's ONLY summary.
			 */ const issueCreateFieldsUsed = payload.issueCreateFieldsUsed ?? [
                {
                    gqlType: 'JiraSingleLineTextField',
                    issueFieldId: 'summary',
                    issueFieldType: 'summary',
                    isPopulated: true
                }
            ];
            let fieldsPopulated = {};
            if (payload.sessionId !== undefined && !!card) // Fields that can be populated automatically e.g. by filters, swimlanes, postfunctions
            fieldsPopulated = {
                ASSIGNEE: !!card.assignee,
                PARENT: !!card.parentId,
                PRIORITY: !!card.priority,
                FIX_VERSIONS: (0, $hWS8F.getFieldLengthForAnalytics)(card.fixVersions?.length),
                LABELS: (0, $hWS8F.getFieldLengthForAnalytics)(card.labels?.length)
            };
            /**
			 * Facilitate CMP instrumentation for inline creation analytics.
			 *
			 * https://hello.atlassian.net/wiki/spaces/SQE/pages/2613558743/Instrumentation+Spec+Inline+Create+CMP+Boards - ERAI-1376
			 *
			 * The following assumptions are made due to how inline creation is made;
			 * - the only issue create field that is present: summary
			 * - It has to be "backlog" for the source of inline creation, if this is altered in the future, this will not track other sources.
			 */ const additionalPayloads = {
                ...otherProperties,
                isCompanyManaged: (0, $hkGxG.getIsCompanyManaged)(state),
                issueCreateFieldsUsed: issueCreateFieldsUsed,
                fieldsPopulated: fieldsPopulated
            };
            /**
			 * NOTE
			 *
			 * This is a temporary fix for https://hello.atlassian.net/browse/CATB-415
			 *
			 * It should be cleaned up by https://hello.atlassian.net/browse/CATB-418
			 */ if (action && actionSubject) (0, $jMP2a.fireTrackAnalytics)(trackEvent, `${actionSubject} ${action}`, {
                ...additionalPayloads
            });
            else (0, $jUhyG.fireTrackAnalytics)(trackEvent, {
                action: payload.action,
                attributes: {
                    ...additionalPayloads
                }
            });
        });
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5e6a5caf7e011319$export$2e2bcd8739ae039 = (dependencies)=>(store)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (next)=>(action)=>{
                if (!$5e6a5caf7e011319$var$shouldTriggerAnalytics(action)) {
                    next(action);
                    return;
                }
                const preActionState = store.getState();
                next(action);
                const postActionState = store.getState();
                const analyticEvents = $5e6a5caf7e011319$var$getAnalyticsForAction(preActionState, postActionState, action, dependencies);
                $5e6a5caf7e011319$var$triggerAnalyticsForAction(analyticEvents, postActionState);
            };

});
parcelRegister("8QOTu", function(module, exports) {

var $i31gq = parcelRequire("i31gq");

var $3Bqj8 = parcelRequire("3Bqj8");

var $5ovM8 = parcelRequire("5ovM8");
/**
 * This method is like `_.assign` except that it iterates over own and
 * inherited source properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extend
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assign
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assignIn({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
 */ var $671aa88e1b2e86b3$var$assignIn = $3Bqj8(function(object, source) {
    $i31gq(source, $5ovM8(source), object);
});
module.exports = $671aa88e1b2e86b3$var$assignIn;

});

parcelRegister("hWS8F", function(module, exports) {

$parcel$export(module.exports, "getFieldLengthForAnalytics", () => $6a49f470eab7b3c9$export$e337040f61dd6dff);
const $6a49f470eab7b3c9$export$e337040f61dd6dff = (length)=>{
    if (!length) return '0';
    if (length > 3) return '>3';
    return String(length);
};

});

parcelRegister("4zPnR", function(module, exports) {

$parcel$export(module.exports, "ANALYTIC_PREFIX", () => $6a4878fb6a5cb788$export$c88107e5c6decd92);
$parcel$export(module.exports, "default", () => $6a4878fb6a5cb788$export$2e2bcd8739ae039);

var $MYW4e = parcelRequire("MYW4e");

var $jiL2Q = parcelRequire("jiL2Q");

var $jgHdr = parcelRequire("jgHdr");

var $lsENz = parcelRequire("lsENz");

var $c4hFt = parcelRequire("c4hFt");

var $5awap = parcelRequire("5awap");

var $1NOG0 = parcelRequire("1NOG0");

var $7Egcu = parcelRequire("7Egcu");

var $6apxJ = parcelRequire("6apxJ");

var $1HfeQ = parcelRequire("1HfeQ");

var $K2SiM = parcelRequire("K2SiM");

var $jAbil = parcelRequire("jAbil");

var $3i20Q = parcelRequire("3i20Q");

var $cjL82 = parcelRequire("cjL82");

var $98Pk0 = parcelRequire("98Pk0");

var $fEJeo = parcelRequire("fEJeo");

var $dIYE2 = parcelRequire("dIYE2");

var $279GH = parcelRequire("279GH");

var $fDNdb = parcelRequire("fDNdb");

var $9cJW6 = parcelRequire("9cJW6");

var $fAwPy = parcelRequire("fAwPy");

var $2a6ca = parcelRequire("2a6ca");

var $eb0hG = parcelRequire("eb0hG");
const $6a4878fb6a5cb788$export$c88107e5c6decd92 = 'plan-view';
const $6a4878fb6a5cb788$var$actionAnalyticsMap = ()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ({
        [(0, $jiL2Q.BACKLOG_VIEW)]: [
            (0, $98Pk0.backlogView)
        ],
        [(0, $jiL2Q.LOAD_APP_DATA_FAILURE)]: [
            (0, $98Pk0.backlogLoadAppDataFailure)
        ],
        [(0, $jiL2Q.LOAD_CONFIG_DATA_FAILURE)]: [
            (0, $98Pk0.backlogLoadConfigDataFailure)
        ],
        [(0, $jiL2Q.LOAD_CONFIG_DATA_SUCCESS)]: [
            (0, $98Pk0.backlogLoadConfigDataSuccess)
        ],
        [(0, $jiL2Q.LOAD_CONFIG_DATA_MODEL_SUCCESS)]: [
            (0, $98Pk0.backlogLoadConfigDataSuccess)
        ],
        [(0, $jiL2Q.REFRESH_DATA_REQUEST)]: [
            (0, $98Pk0.refreshDataRequest)
        ],
        [(0, $jgHdr.BOARD_ISSUE_MOVE_SHOW)]: [
            (0, $fEJeo.boardIssueMoveShow)
        ],
        [(0, $jgHdr.BOARD_ISSUE_MOVE_CANCEL)]: [
            (0, $fEJeo.boardIssueMoveCancel)
        ],
        [(0, $jgHdr.BOARD_ISSUE_MOVE_EXECUTE)]: [
            (0, $fEJeo.boardIssueMoveExecute)
        ],
        [(0, $jgHdr.BOARD_ISSUE_MOVE_EXECUTE_FAILURE)]: [
            (0, $fEJeo.boardIssueMoveExecuteFailure)
        ],
        [(0, $jgHdr.BOARD_ISSUE_MOVE_EXECUTE_SUCCESS)]: [
            (0, $fEJeo.boardIssueMoveExecuteSuccess)
        ],
        [(0, $lsENz.CARD_CREATE_MULTIPLE_REQUEST)]: [
            (0, $dIYE2.cardCreateMultipleRequestPerformance)
        ],
        [(0, $lsENz.CARD_CREATE_SUCCESS)]: [
            (0, $dIYE2.cardCreateSuccess),
            (0, $dIYE2.cardCreateSuccessPerformance)
        ],
        [(0, $lsENz.CARD_CREATE_FAILURE)]: [
            (0, $dIYE2.cardCreateFailure)
        ],
        [(0, $lsENz.CARD_CREATE_FILTERED)]: [
            (0, $dIYE2.cardCreateFiltered)
        ],
        [(0, $lsENz.CARD_CREATE_FILTERED_V2)]: [
            (0, $dIYE2.cardCreateFilteredV2)
        ],
        [(0, $c4hFt.CARD_DELETE_REQUEST)]: [
            (0, $dIYE2.cardDeleteRequestPerformance)
        ],
        [(0, $c4hFt.CARD_DELETE_SUCCESS)]: [
            (0, $dIYE2.cardDeleteSuccess)
        ],
        [(0, $c4hFt.CARD_DELETE_FAILURE)]: [
            (0, $dIYE2.cardDeleteFailure)
        ],
        [(0, $1NOG0.CARDS_FLAG_WITH_COMMENT_REQUEST)]: [
            (0, $dIYE2.cardsFlagRequestPerformance)
        ],
        [(0, $1NOG0.CARDS_FLAG_WITH_COMMENT_SUCCESS)]: [
            (0, $dIYE2.cardsFlagSuccess)
        ],
        [(0, $1NOG0.CARDS_FLAG_WITH_COMMENT_FAILURE)]: [
            (0, $dIYE2.cardsFlagFailure)
        ],
        [(0, $6apxJ.CARDS_PARENT_SET_SUCCESS)]: [
            (0, $dIYE2.cardsParentSetSuccess)
        ],
        [(0, $6apxJ.CARDS_PARENT_SET_FAILURE)]: [
            (0, $dIYE2.cardsParentSetFailure)
        ],
        [(0, $jAbil.SET_ALL_FILTERS)]: [
            (0, $9cJW6.setAllFilters),
            (0, $9cJW6.setAllFiltersPerformance)
        ],
        [(0, $K2SiM.OPEN_DETAIL_VIEW)]: [
            (0, $dIYE2.cardOpenDetailView)
        ],
        [(0, $7Egcu.CARDS_MOVE)]: [
            (0, $dIYE2.cardRankRequestPerformance)
        ],
        [(0, $7Egcu.CARDS_MOVE_SUCCESS)]: [
            (0, $dIYE2.cardsMoveSuccess)
        ],
        [(0, $7Egcu.CARDS_MOVE_FAILURE)]: [
            (0, $dIYE2.cardsMoveFailure)
        ],
        [(0, $3i20Q.SPRINT_CREATE_REQUEST)]: [
            (0, $eb0hG.sprintCreateRequestPerformance)
        ],
        [(0, $3i20Q.SPRINT_CREATE_SUCCESS)]: [
            (0, $eb0hG.sprintCreateSuccess),
            (0, $eb0hG.sprintCreateSuccessPerformance)
        ],
        [(0, $3i20Q.SPRINT_CREATE_FAILURE)]: [
            (0, $eb0hG.sprintCreateFailure)
        ],
        [(0, $cjL82.SPRINT_DELETE_REQUEST)]: [
            (0, $eb0hG.sprintDeleteRequestPerformance)
        ],
        [(0, $cjL82.SPRINT_DELETE_SUCCESS)]: [
            (0, $eb0hG.sprintDeleteSuccessPerformance)
        ],
        [(0, $1HfeQ.CARD_CLICK)]: [
            (0, $fAwPy.issueViewOpenPerformance)
        ],
        [(0, $5awap.FILTERED_CARD_SUCCESS)]: [
            (0, $fDNdb.setCustomFiltersPerformance),
            (0, $fDNdb.setCustomFiltersSuccess)
        ],
        [(0, $5awap.FILTERED_CARD_FAILURE)]: [
            (0, $fDNdb.setCustomFiltersFailure)
        ],
        [(0, $5awap.REFILTER_SUCCESS)]: [
            (0, $fDNdb.setCustomFiltersRefilterSuccess)
        ],
        [(0, $5awap.REFILTER_FAILURE)]: [
            (0, $fDNdb.setCustomFiltersRefilterFailure)
        ],
        [(0, $5awap.FILTERED_CARD_CLEAR_SUCCESS)]: [
            (0, $fDNdb.setClearCustomFiltersPerformance),
            (0, $fDNdb.setClearCustomFiltersSuccess)
        ],
        [(0, $5awap.FILTERED_CARD_CLEAR_FAILURE)]: [
            (0, $fDNdb.setClearCustomFiltersFailure)
        ],
        [(0, $MYW4e.BATCH)]: [
            (0, $279GH.setCardRequestIndividualResponse)
        ],
        [(0, $jiL2Q.LOAD_CARD_CREATE_CONFIG_SUCCESS)]: [
            (0, $2a6ca.cardCreateConfigLoadSuccess)
        ],
        [(0, $jiL2Q.LOAD_CARD_CREATE_CONFIG_FAILURE)]: [
            (0, $2a6ca.cardCreateConfigLoadFailure)
        ]
    });
var $6a4878fb6a5cb788$export$2e2bcd8739ae039 = $6a4878fb6a5cb788$var$actionAnalyticsMap;

});
parcelRegister("98Pk0", function(module, exports) {

$parcel$export(module.exports, "backlogView", () => $407a7f25bb745575$export$4696f1f49cfb7d46);
$parcel$export(module.exports, "backlogLoadAppDataFailure", () => $407a7f25bb745575$export$326068e951e3c300);
$parcel$export(module.exports, "backlogLoadConfigDataFailure", () => $407a7f25bb745575$export$159273fe78e3d429);
$parcel$export(module.exports, "refreshDataRequest", () => $407a7f25bb745575$export$7245a5bb55cf1c);
$parcel$export(module.exports, "backlogLoadConfigDataSuccess", () => $407a7f25bb745575$export$3d70f256a15041c6);

var $jUhyG = parcelRequire("jUhyG");

var $jMP2a = parcelRequire("jMP2a");

var $i0Fyd = parcelRequire("i0Fyd");

var $c3qrZ = parcelRequire("c3qrZ");

var $cNacc = parcelRequire("cNacc");

var $ee93g = parcelRequire("ee93g");

var $ktkl3 = parcelRequire("ktkl3");

var $hkGxG = parcelRequire("hkGxG");

var $6ncr6 = parcelRequire("6ncr6");

var $bP7Jx = parcelRequire("bP7Jx");

var $8ZI73 = parcelRequire("8ZI73");

var $cYLrD = parcelRequire("cYLrD");
const $407a7f25bb745575$export$4696f1f49cfb7d46 = (eventPrefix)=>(preState, state, action)=>{
        const numCards = Object.keys((0, $bP7Jx.getCards)(state)).length;
        const { analyticsEvent: analyticsEvent } = action.meta;
        const visibleCardIds = (0, $bP7Jx.getVisibleCardIds)(state);
        const orderedLabels = (0, $bP7Jx.getOrderedLabels)(state);
        const sprints = (0, $bP7Jx.getVisibleSprintCardLists)(state);
        const unscheduledSprints = sprints.filter((sprint)=>!sprint.sprintData?.startDate && !sprint.sprintData?.endDate);
        const isCompanyManaged = (0, $hkGxG.getIsCompanyManaged)(state);
        const boardId = Number((0, $hkGxG.getRapidViewId)(state));
        const isQuickFiltersBarToggled = (0, $cNacc.getViewSettings)({
            boardId: boardId,
            view: (0, $c3qrZ.View).BACKLOG
        })?.showQuickFilters;
        const cmpAttributes = isCompanyManaged && {
            isQuickFiltersBarToggled: isQuickFiltersBarToggled
        };
        const extra = {
            numCards: numCards,
            numSprints: sprints.length,
            numUnscheduledSprints: unscheduledSprints.length,
            hasFilteredIssues: visibleCardIds.length !== numCards,
            numLabels: orderedLabels.length,
            issueResultProjectIds: (0, $hkGxG.getProjectIds)(state)
        };
        const featureAttributes = (0, $i0Fyd.getFeatureAnalyticsAttributes)((0, $8ZI73.getAllFeatures)(state));
        (0, $jUhyG.fireTrackAnalytics)(analyticsEvent, {
            action: 'viewed',
            attributes: {
                ...featureAttributes,
                isEpicPanelOpen: (0, $cYLrD.getEpicPanel)(state),
                isVersionPanelOpen: (0, $ee93g.isVersionPanelOpen)(),
                ...extra,
                ...cmpAttributes
            }
        });
        return {
            name: `${eventPrefix}.view`,
            data: {
                ...extra
            }
        };
    };
const $407a7f25bb745575$export$326068e951e3c300 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.load-app-data.failure`,
            data: {}
        });
const $407a7f25bb745575$export$159273fe78e3d429 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.load-config-data.failure`,
            data: {}
        });
const $407a7f25bb745575$export$7245a5bb55cf1c = (eventPrefix)=>(preState, state, action, dependencies)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = dependencies || {};
        if (createAnalyticsEvent) (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'backlog refreshed', {
            ...(0, $ktkl3.getAttributes)(state),
            source: action.payload.source
        });
        return {
            name: `${eventPrefix}.refresh`,
            data: {
                source: action.payload.source
            }
        };
    };
const $407a7f25bb745575$export$3d70f256a15041c6 = (eventPrefix)=>(preState, state)=>({
            name: `${eventPrefix}.load-config-data.success`,
            data: {
                numIssueTypes: (0, $6ncr6.getBaseLevelCardTypes)(state).length
            }
        });

});
parcelRegister("i0Fyd", function(module, exports) {

$parcel$export(module.exports, "getFeatureAnalyticsAttributes", () => $01278e875bedc0a0$export$ac70e171fbeaebce);
const $01278e875bedc0a0$export$4517b897375f940f = (key)=>`is_${key}_enabled`;
const $01278e875bedc0a0$export$ac70e171fbeaebce = (allFeatures)=>{
    const result = {};
    allFeatures.forEach((feature)=>{
        result[$01278e875bedc0a0$export$4517b897375f940f(feature.key)] = feature.status === 'ENABLED';
    });
    return result;
};

});

parcelRegister("c3qrZ", function(module, exports) {

$parcel$export(module.exports, "View", () => $8eb6b75af7e82572$export$27a5bd065ad55220);
$parcel$export(module.exports, "KeyboardShortcut", () => $8eb6b75af7e82572$export$47a1bf8d9994c680);
$parcel$export(module.exports, "ExpandableState", () => $8eb6b75af7e82572$export$d0f8c009a99b9c1b);
$parcel$export(module.exports, "ViewLocation", () => $8eb6b75af7e82572$export$7ee1cf745baadfcd);
$parcel$export(module.exports, "ViewAs", () => $8eb6b75af7e82572$export$70549c4aef7e1632);
$parcel$export(module.exports, "QUICK_FILTERS", () => $8eb6b75af7e82572$export$59191afd909777e0);
$parcel$export(module.exports, "COMPACT_MODE", () => $8eb6b75af7e82572$export$abd09d2531440e47);
$parcel$export(module.exports, "SHOW_EPICS", () => $8eb6b75af7e82572$export$f3d7917d25ca2d13);
$parcel$export(module.exports, "SHOW_STATUSES", () => $8eb6b75af7e82572$export$933792f2c41e7c51);
$parcel$export(module.exports, "SHOW_VERSIONS", () => $8eb6b75af7e82572$export$fe0a5eeac8bdee53);
$parcel$export(module.exports, "SHOW_ISSUE_LINKS_STATS", () => $8eb6b75af7e82572$export$889dbf130218e8b3);
$parcel$export(module.exports, "SHOW_ISSUE_KEY", () => $8eb6b75af7e82572$export$f199de710b228934);
$parcel$export(module.exports, "SHOW_ISSUE_TYPE", () => $8eb6b75af7e82572$export$e8f86e49139c6abb);
$parcel$export(module.exports, "SHOW_ESTIMATE", () => $8eb6b75af7e82572$export$e1f60d3e74825af0);
$parcel$export(module.exports, "SHOW_PRIORITY", () => $8eb6b75af7e82572$export$bcfd60da3302536e);
$parcel$export(module.exports, "SHOW_ASSIGNEE", () => $8eb6b75af7e82572$export$3c14ba0cd46183b);
$parcel$export(module.exports, "SHOW_DAYS_IN_COLUMN", () => $8eb6b75af7e82572$export$8224ffeed837235e);
$parcel$export(module.exports, "SHOW_DUE_DATE", () => $8eb6b75af7e82572$export$770e28bfe2e0208d);
$parcel$export(module.exports, "SHOW_LABELS", () => $8eb6b75af7e82572$export$63993996bfd99919);
$parcel$export(module.exports, "SHOW_CARD_COVERS", () => $8eb6b75af7e82572$export$b811e8bce70dd7c2);
$parcel$export(module.exports, "Panels", () => $8eb6b75af7e82572$export$b94e9de8950563ef);
$parcel$export(module.exports, "IncrementPlanningSettings", () => $8eb6b75af7e82572$export$ad46e765f851721f);
const $8eb6b75af7e82572$export$27a5bd065ad55220 = {
    BACKLOG: 'jsw-backlog',
    BOARD: 'jsw-board',
    INCREMENT_PLANNING_BOARD: 'increment-planning-board',
    JSM_BOARD: 'jsm-board'
};
const $8eb6b75af7e82572$export$47a1bf8d9994c680 = {
    ISSUE_PARENT_PANEL_SHORTCUT: 'E',
    VERSION_PANEL_SHORTCUT: 'V'
};
const $8eb6b75af7e82572$export$d0f8c009a99b9c1b = {
    EXPANDED: 'expanded',
    COLLAPSED: 'collapsed'
};
const $8eb6b75af7e82572$export$7ee1cf745baadfcd = {
    SIDEBAR: 'sidebar',
    MODAL: 'modal'
};
const $8eb6b75af7e82572$export$70549c4aef7e1632 = {
    PANEL: 'Panel',
    POPUP: 'Popup'
};
const $8eb6b75af7e82572$export$41073ac826c57195 = 'VERSION_PANEL';
const $8eb6b75af7e82572$export$86bfe5c9d2cf6b7c = 'EPIC_PANEL';
const $8eb6b75af7e82572$export$59191afd909777e0 = 'QUICK_FILTERS';
const $8eb6b75af7e82572$export$abd09d2531440e47 = 'COMPACT_MODE';
const $8eb6b75af7e82572$export$f3d7917d25ca2d13 = 'SHOW_EPICS';
const $8eb6b75af7e82572$export$933792f2c41e7c51 = 'SHOW_STATUSES';
const $8eb6b75af7e82572$export$fe0a5eeac8bdee53 = 'SHOW_VERSIONS';
const $8eb6b75af7e82572$export$889dbf130218e8b3 = 'SHOW_ISSUE_LINKS_STATS';
const $8eb6b75af7e82572$export$c3308fa11d994bc5 = 'SHOW_UNSCHEDULED_COLUMN';
const $8eb6b75af7e82572$export$f199de710b228934 = 'SHOW_ISSUE_KEY';
const $8eb6b75af7e82572$export$e8f86e49139c6abb = 'SHOW_ISSUE_TYPE';
const $8eb6b75af7e82572$export$e1f60d3e74825af0 = 'SHOW_ESTIMATE';
const $8eb6b75af7e82572$export$bcfd60da3302536e = 'SHOW_PRIORITY';
const $8eb6b75af7e82572$export$3c14ba0cd46183b = 'SHOW_ASSIGNEE';
const $8eb6b75af7e82572$export$8224ffeed837235e = 'SHOW_DAYS_IN_COLUMN';
const $8eb6b75af7e82572$export$770e28bfe2e0208d = 'SHOW_DUE_DATE';
const $8eb6b75af7e82572$export$63993996bfd99919 = 'SHOW_LABELS';
const $8eb6b75af7e82572$export$b811e8bce70dd7c2 = 'SHOW_CARD_COVERS';
const $8eb6b75af7e82572$export$b94e9de8950563ef = {
    VERSION_PANEL: $8eb6b75af7e82572$export$41073ac826c57195,
    EPIC_PANEL: $8eb6b75af7e82572$export$86bfe5c9d2cf6b7c
};
const $8eb6b75af7e82572$export$ad46e765f851721f = {
    SHOW_UNSCHEDULED_COLUMN: $8eb6b75af7e82572$export$c3308fa11d994bc5
};

});

parcelRegister("cNacc", function(module, exports) {

$parcel$export(module.exports, "getViewSettings", () => $168332c15e8ca043$export$3ae70db4a97563c);
$parcel$export(module.exports, "setViewSettingsIsFullscreen", () => $168332c15e8ca043$export$322210075289ef56);
$parcel$export(module.exports, "getViewSettingsIsFullscreen", () => $168332c15e8ca043$export$d2c8042121049ae8);
$parcel$export(module.exports, "getViewSettingsPanels", () => $168332c15e8ca043$export$d6a5a0d616fcec93);
$parcel$export(module.exports, "setViewSettings", () => $168332c15e8ca043$export$99f2d9eb0b41b93);
$parcel$export(module.exports, "setViewSettingsPanels", () => $168332c15e8ca043$export$427f126b21640252);
$parcel$export(module.exports, "getViewSettingsQuickFilters", () => $168332c15e8ca043$export$18eb87e1feb49f18);
$parcel$export(module.exports, "setViewSettingsQuickFilters", () => $168332c15e8ca043$export$60d0caf3b1c59159);
$parcel$export(module.exports, "getViewSettingsCompactMode", () => $168332c15e8ca043$export$658ed39e1ffe75b);
$parcel$export(module.exports, "setViewSettingsCompactMode", () => $168332c15e8ca043$export$9ca6e4490ca9b1fc);
$parcel$export(module.exports, "getViewSettingsCardDetails", () => $168332c15e8ca043$export$a2a95ab43ea98277);
$parcel$export(module.exports, "setViewSettingsCardDetails", () => $168332c15e8ca043$export$af2e5a35023755b5);
$parcel$export(module.exports, "getViewSettingsCardExtraFields", () => $168332c15e8ca043$export$6a2173913af81755);
$parcel$export(module.exports, "setViewSettingsCardExtraFields", () => $168332c15e8ca043$export$b54537ba70def946);
$parcel$export(module.exports, "setShowEpics", () => $168332c15e8ca043$export$294c0e262bd1285a);
$parcel$export(module.exports, "setShowVersions", () => $168332c15e8ca043$export$a3ab3e2c6a6189bd);
$parcel$export(module.exports, "setShowStatuses", () => $168332c15e8ca043$export$e95c7c8d7cbf6350);
$parcel$export(module.exports, "setShowIssueLinksStats", () => $168332c15e8ca043$export$163e0dded7eda9d9);
$parcel$export(module.exports, "setShowUnscheduledColumn", () => $168332c15e8ca043$export$6edce735c6eb4cb0);
$parcel$export(module.exports, "getShowUnscheduledColumn", () => $168332c15e8ca043$export$bf31a7b99f7bc62f);
$parcel$export(module.exports, "setShowDaysInColumn", () => $168332c15e8ca043$export$68382c1a767b0133);
$parcel$export(module.exports, "setShowDueDate", () => $168332c15e8ca043$export$13fed6c54275816a);
$parcel$export(module.exports, "setShowLabels", () => $168332c15e8ca043$export$43aa76b69739d220);
$parcel$export(module.exports, "setExtraFields", () => $168332c15e8ca043$export$b24e660e664a6bba);

var $aZaPn = parcelRequire("aZaPn");

var $jyKDT = parcelRequire("jyKDT");

var $c3qrZ = parcelRequire("c3qrZ");

var $6eyW6 = parcelRequire("6eyW6");
const $168332c15e8ca043$var$VIEW_SETTINGS = 'view-settings';
const $168332c15e8ca043$var$localStorage = (0, $aZaPn.createLocalStorageProvider)('jira-software-view-settings');
const $168332c15e8ca043$export$36e24695f02d4503 = (view)=>{
    if (view && view === (0, $c3qrZ.View).INCREMENT_PLANNING_BOARD) return `${$168332c15e8ca043$var$VIEW_SETTINGS}-${(0, $c3qrZ.View).INCREMENT_PLANNING_BOARD}`;
    if ((0, $6eyW6.isViewSettingsPanelAndTailoredViewExperimentEnabled)()) switch(view){
        case (0, $c3qrZ.View).INCREMENT_PLANNING_BOARD:
            return `${$168332c15e8ca043$var$VIEW_SETTINGS}-${(0, $c3qrZ.View).INCREMENT_PLANNING_BOARD}`;
        case (0, $c3qrZ.View).BACKLOG:
            return `${$168332c15e8ca043$var$VIEW_SETTINGS}-${(0, $c3qrZ.View).BACKLOG}`;
        case (0, $c3qrZ.View).BOARD:
            return `${$168332c15e8ca043$var$VIEW_SETTINGS}-${(0, $c3qrZ.View).BOARD}`;
        case (0, $c3qrZ.View).JSM_BOARD:
            return `${$168332c15e8ca043$var$VIEW_SETTINGS}-${(0, $c3qrZ.View).JSM_BOARD}`;
        default:
            return $168332c15e8ca043$var$VIEW_SETTINGS;
    }
    return $168332c15e8ca043$var$VIEW_SETTINGS;
};
const $168332c15e8ca043$export$3ae70db4a97563c = ({ boardId: boardId, view: view })=>$168332c15e8ca043$var$localStorage.get(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`) || $168332c15e8ca043$var$localStorage.get(`${$168332c15e8ca043$var$VIEW_SETTINGS}-${boardId}`); // return legacy view settings if prefixed storage doesn't exist
const $168332c15e8ca043$export$322210075289ef56 = ({ boardId: boardId, isFullscreen: isFullscreen, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$localStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        isFullscreen: isFullscreen
    });
};
const $168332c15e8ca043$export$d2c8042121049ae8 = ({ boardId: boardId, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return state?.isFullscreen ?? (0, $jyKDT.initialState).isFullscreen;
};
const $168332c15e8ca043$export$d6a5a0d616fcec93 = ({ boardId: boardId, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return {
        EPIC_PANEL: state?.showEpicPanel ?? (0, $jyKDT.initialState).showEpicPanel,
        VERSION_PANEL: state?.showVersionPanel ?? (0, $jyKDT.initialState).showVersionPanel
    };
};
const $168332c15e8ca043$export$99f2d9eb0b41b93 = ({ boardId: boardId, state: state, view: view })=>$168332c15e8ca043$var$localStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, state);
const $168332c15e8ca043$export$427f126b21640252 = ({ boardId: boardId, panelState: panelState, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$localStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showEpicPanel: panelState.EPIC_PANEL,
        showVersionPanel: panelState.VERSION_PANEL
    });
};
const $168332c15e8ca043$export$7a001fa75693814b = ({ boardId: boardId, panel: panel, show: show, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    if (panel === (0, $c3qrZ.Panels).EPIC_PANEL) $168332c15e8ca043$var$localStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showEpicPanel: show
    });
    if (panel === (0, $c3qrZ.Panels).VERSION_PANEL) $168332c15e8ca043$var$localStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showVersionPanel: show
    });
};
const $168332c15e8ca043$export$18eb87e1feb49f18 = ({ boardId: boardId, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return state?.showQuickFilters ?? (0, $jyKDT.initialState).showQuickFilters;
};
const $168332c15e8ca043$export$60d0caf3b1c59159 = ({ boardId: boardId, showQuickFilters: showQuickFilters, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$localStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showQuickFilters: showQuickFilters
    });
};
const $168332c15e8ca043$export$658ed39e1ffe75b = ({ boardId: boardId, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return state?.showCompactMode ?? (0, $jyKDT.initialState).showCompactMode;
};
const $168332c15e8ca043$export$9ca6e4490ca9b1fc = ({ boardId: boardId, showCompactMode: showCompactMode, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$localStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showCompactMode: showCompactMode
    });
};
const $168332c15e8ca043$export$a2a95ab43ea98277 = ({ boardId: boardId, view: view, isDaysInColumnEnabled: isDaysInColumnEnabled, isDueDateEnabled: isDueDateEnabled, isLabelsEnabled: isLabelsEnabled, isEstimateEnabled: isEstimateEnabled, isPriorityEnabled: isPriorityEnabled })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return {
        SHOW_EPICS: state?.showEpics ?? (0, $jyKDT.initialState).showEpics,
        SHOW_STATUSES: state?.showStatuses ?? (0, $jyKDT.initialState).showStatuses,
        SHOW_VERSIONS: state?.showVersions ?? (0, $jyKDT.initialState).showVersions,
        SHOW_ISSUE_LINKS_STATS: state?.showIssueLinksStats ?? (0, $jyKDT.initialState).showIssueLinksStats,
        SHOW_ISSUE_KEY: state?.showIssueKey ?? (0, $jyKDT.initialState).showIssueKey,
        SHOW_ISSUE_TYPE: state?.showIssueType ?? (0, $jyKDT.initialState).showIssueType,
        SHOW_ASSIGNEE: state?.showAssignee ?? (0, $jyKDT.initialState).showAssignee,
        SHOW_PRIORITY: (isPriorityEnabled ? state?.showPriority : (0, $jyKDT.initialState).showPriority) ?? (0, $jyKDT.initialState).showPriority,
        SHOW_ESTIMATE: (isEstimateEnabled ? state?.showEstimate : (0, $jyKDT.initialState).showEstimate) ?? (0, $jyKDT.initialState).showEstimate,
        SHOW_DAYS_IN_COLUMN: (isDaysInColumnEnabled ? state?.showDaysInColumn : (0, $jyKDT.initialState).showDaysInColumn) ?? (0, $jyKDT.initialState).showDaysInColumn,
        SHOW_DUE_DATE: (isDueDateEnabled ? state?.showDueDate : (0, $jyKDT.initialState).showDueDate) ?? (0, $jyKDT.initialState).showDueDate,
        SHOW_LABELS: (isLabelsEnabled ? state?.showLabels : (0, $jyKDT.initialState).showLabels) ?? (0, $jyKDT.initialState).showLabels,
        SHOW_CARD_COVERS: state?.showCardCovers ?? (0, $jyKDT.initialState).showCardCovers
    };
};
const $168332c15e8ca043$export$af2e5a35023755b5 = ({ boardId: boardId, cardDetailsState: cardDetailsState, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$localStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showEpics: cardDetailsState.SHOW_EPICS,
        showStatuses: cardDetailsState.SHOW_STATUSES,
        showVersions: cardDetailsState.SHOW_VERSIONS,
        showDaysInColumn: cardDetailsState.SHOW_DAYS_IN_COLUMN,
        showEstimate: cardDetailsState.SHOW_ESTIMATE,
        showIssueLinksStats: cardDetailsState.SHOW_ISSUE_LINKS_STATS,
        showIssueKey: cardDetailsState.SHOW_ISSUE_KEY,
        showIssueType: cardDetailsState.SHOW_ISSUE_TYPE,
        showAssignee: cardDetailsState.SHOW_ASSIGNEE,
        showPriority: cardDetailsState.SHOW_PRIORITY,
        showDueDate: cardDetailsState.SHOW_DUE_DATE,
        showLabels: cardDetailsState.SHOW_LABELS,
        showCardCovers: cardDetailsState.SHOW_CARD_COVERS
    });
};
const $168332c15e8ca043$export$6a2173913af81755 = ({ boardId: boardId, view: view, cardExtraFields: cardExtraFields })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return cardExtraFields.reduce((acc, field)=>{
        acc[field.id] = state?.cardExtraFields?.[field.id] ?? true;
        return acc;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, {});
};
const $168332c15e8ca043$export$b54537ba70def946 = ({ boardId: boardId, cardExtraFieldsState: cardExtraFieldsState, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$localStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        cardExtraFields: cardExtraFieldsState
    });
};
const $168332c15e8ca043$export$294c0e262bd1285a = ({ boardId: boardId, showEpics: showEpics, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$localStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showEpics: showEpics
    });
};
const $168332c15e8ca043$export$a3ab3e2c6a6189bd = ({ boardId: boardId, showVersions: showVersions, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$localStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showVersions: showVersions
    });
};
const $168332c15e8ca043$export$e95c7c8d7cbf6350 = ({ boardId: boardId, showStatuses: showStatuses, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$localStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showStatuses: showStatuses
    });
};
const $168332c15e8ca043$export$163e0dded7eda9d9 = ({ boardId: boardId, showIssueLinksStats: showIssueLinksStats, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$localStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showIssueLinksStats: showIssueLinksStats
    });
};
const $168332c15e8ca043$export$6edce735c6eb4cb0 = ({ boardId: boardId, showUnscheduledColumn: showUnscheduledColumn })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $c3qrZ.View).INCREMENT_PLANNING_BOARD
    });
    $168332c15e8ca043$var$localStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503((0, $c3qrZ.View).INCREMENT_PLANNING_BOARD)}-${boardId}`, {
        ...state,
        showUnscheduledColumn: showUnscheduledColumn
    });
};
const $168332c15e8ca043$export$bf31a7b99f7bc62f = (boardId)=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $c3qrZ.View).INCREMENT_PLANNING_BOARD
    });
    return state?.showUnscheduledColumn ?? (0, $jyKDT.initialState).showUnscheduledColumn;
};
const $168332c15e8ca043$export$68382c1a767b0133 = ({ boardId: boardId, showDaysInColumn: showDaysInColumn, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$localStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showDaysInColumn: showDaysInColumn
    });
};
const $168332c15e8ca043$export$13fed6c54275816a = ({ boardId: boardId, showDueDate: showDueDate, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$localStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showDueDate: showDueDate
    });
};
const $168332c15e8ca043$export$43aa76b69739d220 = ({ boardId: boardId, showLabels: showLabels, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$localStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showLabels: showLabels
    });
};
const $168332c15e8ca043$export$b24e660e664a6bba = ({ boardId: boardId, cardExtraFields: cardExtraFields, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$localStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        cardExtraFields: cardExtraFields
    });
};
const $168332c15e8ca043$export$90df0703e41f9b = ({ boardId: boardId, showCardCovers: showCardCovers, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$localStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showCardCovers: showCardCovers
    });
};

});
parcelRegister("jyKDT", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $d03619c6ca5a0718$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "boardViewTestIds", () => $d03619c6ca5a0718$export$9cf6a064d9c55597);
$parcel$export(module.exports, "backlogViewTestIds", () => $d03619c6ca5a0718$export$af828cca0407ed81);
$parcel$export(module.exports, "VIEW_SETTINGS_PANEL_CLOSE_BUTTON_TEST_ID", () => $d03619c6ca5a0718$export$b954e2c30216a1e9);
$parcel$export(module.exports, "VIEW_SETTINGS_BUTTON_LG", () => $d03619c6ca5a0718$export$20070c180403c06a);
$parcel$export(module.exports, "VIEW_SETTINGS_BUTTON_SM", () => $d03619c6ca5a0718$export$563c80e8ea5620c4);
$parcel$export(module.exports, "VIEW_SETTINGS_BUTTON_RESPONSIVE", () => $d03619c6ca5a0718$export$3895498dfef21366);
$parcel$export(module.exports, "QUERY_ENABLED_VALUE", () => $d03619c6ca5a0718$export$c0d46007b8549aca);
$parcel$export(module.exports, "QUERY_DISABLED_VALUE", () => $d03619c6ca5a0718$export$788a94e8107fb947);
const $d03619c6ca5a0718$export$d4c72bab9d6cc13a = {
    view: null,
    isFullscreen: false,
    showEpicPanel: false,
    showVersionPanel: false,
    showQuickFilters: false,
    showEpics: true,
    showStatuses: true,
    showVersions: true,
    showCompactMode: false,
    showUnscheduledColumn: true,
    showIssueLinksStats: false,
    showIssueKey: true,
    showIssueType: true,
    showEstimate: true,
    showAssignee: true,
    showPriority: true,
    showDaysInColumn: true,
    showDueDate: true,
    showLabels: true,
    showCardCovers: false,
    cardExtraFields: {}
};
const $d03619c6ca5a0718$export$9cf6a064d9c55597 = {
    viewSettingsBoardMenu: 'software-view-settings.ui.view-settings-menu.menu-board',
    openIssuesInSidebarToggle: 'software-view-settings.ui.view-settings-menu.views.board.open-issues-in-sidebar',
    showQuickFiltersToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-quick-filters-toggle',
    showWorkSuggestionsToggle: 'software-view-settings.ui.view-settings-menu.views.board.work-suggestions-toggle',
    swimlaneExpandAll: 'software-view-settings.ui.view-settings-menu.views.board.expand-all',
    swimlaneCollapseAll: 'software-view-settings.ui.view-settings-menu.views.board.collapse-all',
    cardDetailsSection: 'software-view-settings.ui.view-settings-menu.views.board.card-details-board',
    showIssueTypeToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-issue-type-toggle-board',
    showIssueKeyToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-issue-key-toggle-board',
    showEpicsToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-epics-toggle-board',
    showDueDateToggle: 'software-view-settings.ui.view-settings-menu.views.board.due-date-toggle-board',
    showLabelsToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-labels-toggle-board',
    showEstimateToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-estimate-toggle-board',
    showDaysInColumnToggle: 'software-view-settings.ui.view-settings-menu.views.board.days-in-column-toggle-board',
    showLinkedIssueStatsToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-linked-issue-stats-toggle-board',
    showCardCoversToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-card-covers-toggle-board',
    showPriorityToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-priority-toggle-board',
    showAssigneeToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-assignee-toggle-board',
    customFieldsSection: 'software-view-settings.ui.view-settings-menu.views.board.custom-fields-board'
};
const $d03619c6ca5a0718$export$af828cca0407ed81 = {
    showVersionPanelToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-version-panel-toggle',
    showEpicPanelToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-epic-panel-toggle',
    showQuickFiltersToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-quick-filters-toggle',
    cardLayoutSection: 'software-view-settings.view-settings-menu.card-layout',
    cardLayoutRadioGroup: 'software-view-settings.ui.view-settings-menu.views.backlog.card-layout',
    showCompactModeToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-compact-mode-toggle',
    subtaskSection: 'software-view-settings.view-settings-menu.subtasks',
    subtaskExpandAll: 'software-view-settings.ui.view-settings-menu.views.backlog.expand-all-subtasks',
    subtaskCollapseAll: 'software-view-settings.ui.view-settings-menu.views.backlog.collapse-all-subtasks',
    cardDetailsSection: 'software-view-settings.ui.view-settings-menu.views.backlog.card-details-backlog',
    showIssueTypeToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-issue-type-toggle-backlog',
    showIssueKeyToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-issue-key-toggle-backlog',
    showVersionsToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-versions-toggle-backlog',
    showEpicsToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-epics-toggle-backlog',
    showDueDateToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.due-date-toggle-backlog',
    showStatusToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-statuses-toggle-backlog',
    showEstimateToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-estimate-toggle-backlog',
    showPriorityToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-priority-toggle-backlog',
    showAssigneeToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-assignee-toggle-backlog',
    customFieldsSection: 'software-view-settings.ui.view-settings-menu.views.backlog.custom-fields-backlog'
};
const $d03619c6ca5a0718$export$b954e2c30216a1e9 = 'view-settings.ui.panel.header.close-button';
const $d03619c6ca5a0718$export$20070c180403c06a = 'view-settings-show-button.ui.view-settings-button-large';
const $d03619c6ca5a0718$export$563c80e8ea5620c4 = 'view-settings-show-button.ui.view-settings-button-small';
const $d03619c6ca5a0718$export$3895498dfef21366 = 'view-settings-show-button.ui.view-settings-button-responsive';
const $d03619c6ca5a0718$export$c0d46007b8549aca = 'on';
const $d03619c6ca5a0718$export$788a94e8107fb947 = 'off';

});

parcelRegister("6eyW6", function(module, exports) {

$parcel$export(module.exports, "parseSearchQuery", () => $e52899f32986aa87$export$6298490de4ddc3eb);
$parcel$export(module.exports, "setPanels", () => $e52899f32986aa87$export$d89c07c704083e54);
$parcel$export(module.exports, "parseSearchQueryForIPBoard", () => $e52899f32986aa87$export$442a6f7c9ee1c18a);
$parcel$export(module.exports, "setIncrementPlanningSettings", () => $e52899f32986aa87$export$6220a233dbeb6328);
$parcel$export(module.exports, "isViewSettingsPanelAndTailoredViewExperimentEnabled", () => $e52899f32986aa87$export$eed360eb853808ee);

var $6HC1D = parcelRequire("6HC1D");

var $53ciZ = parcelRequire("53ciZ");

var $79xbN = parcelRequire("79xbN");


const $e52899f32986aa87$export$6298490de4ddc3eb = (search)=>{
    const searchParams = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(search);
    return {
        EPIC_PANEL: searchParams[0, $737beaccda042ec2$export$ec3c43b997309252] === 'visible',
        VERSION_PANEL: searchParams[0, $737beaccda042ec2$export$a86c1a6dde9da34f] === 'visible'
    };
};
const $e52899f32986aa87$export$d89c07c704083e54 = (panels, location)=>{
    const search = (0, $6HC1D.chain)({
        ...(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(location.search)
    });
    search.unset((0, $737beaccda042ec2$export$ec3c43b997309252));
    search.unset((0, $737beaccda042ec2$export$a86c1a6dde9da34f));
    if (panels.EPIC_PANEL) search.set((0, $737beaccda042ec2$export$ec3c43b997309252), 'visible');
    if (panels.VERSION_PANEL) search.set((0, $737beaccda042ec2$export$a86c1a6dde9da34f), 'visible');
    return {
        ...location,
        search: (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(search.value())
    };
};
const $e52899f32986aa87$export$442a6f7c9ee1c18a = (search)=>{
    const searchParams = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(search);
    return {
        SHOW_UNSCHEDULED_COLUMN: searchParams[0, $737beaccda042ec2$export$bfa26a3d2f080ac5] === 'hidden' ? false : undefined
    };
};
const $e52899f32986aa87$export$6220a233dbeb6328 = (incrementPlanningSettings, location)=>{
    const search = (0, $6HC1D.chain)({
        ...(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(location.search)
    });
    search.unset((0, $737beaccda042ec2$export$bfa26a3d2f080ac5));
    if (!incrementPlanningSettings.SHOW_UNSCHEDULED_COLUMN) search.set((0, $737beaccda042ec2$export$bfa26a3d2f080ac5), 'hidden');
    return {
        ...location,
        search: (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(search.value())
    };
};
const $e52899f32986aa87$export$eed360eb853808ee = ()=>(0, $79xbN.expValEquals)('jsw_additional_card_fields_in_view_settings', 'cohort', 'variation');

});
const $737beaccda042ec2$export$ec3c43b997309252 = 'epics';
const $737beaccda042ec2$export$a86c1a6dde9da34f = 'versions';
const $737beaccda042ec2$export$bfa26a3d2f080ac5 = 'unscheduledWork';



parcelRegister("ktkl3", function(module, exports) {

$parcel$export(module.exports, "getAttributes", () => $8a87e0f437d5f1e7$export$fe94072fee8a6976);

var $7ZZxN = parcelRequire("7ZZxN");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $1ircG = parcelRequire("1ircG");

var $7kNqR = parcelRequire("7kNqR");
const $8a87e0f437d5f1e7$export$fe94072fee8a6976 = (state)=>({
        /*
	 * isIssueDetailVisible prop is being equated with it showing in the future
	 *  because the backlog screen event is fired before the issue details
	 *  actually show, but it showing is conditional on there being a last
	 *  selected issue key
	 */ isIssueDetailVisible: (0, $bP7Jx.willDetailViewShow)(state),
        boardType: (0, $hkGxG.getBoardType)(state),
        projectType: (0, $7ZZxN.SOFTWARE_PROJECT),
        boardId: (0, $hkGxG.getRapidViewId)(state),
        projectId: (0, $hkGxG.projectIdSelector)(state),
        isReactifiedBacklog: true,
        numSubtasks: (0, $bP7Jx.numTotalIssueChildren)(state),
        numCompleteSubtasks: (0, $bP7Jx.numCompleteIssueChildren)(state),
        isInactiveTab: document.hidden,
        estimationStatistic: (0, $1ircG.getEstimationType)(state),
        isProjectAdmin: (0, $7kNqR.canEditBoardConfig)(state),
        isUIF: true,
        isClassic: (0, $hkGxG.getIsCompanyManaged)(state)
    });

});


parcelRegister("fEJeo", function(module, exports) {

$parcel$export(module.exports, "boardIssueMoveShow", () => $26d7095df564f967$export$afe8c48481994c25);
$parcel$export(module.exports, "boardIssueMoveCancel", () => $26d7095df564f967$export$21c319cd4bbf2b2f);
$parcel$export(module.exports, "boardIssueMoveExecute", () => $26d7095df564f967$export$47de1859c695eca7);
$parcel$export(module.exports, "boardIssueMoveExecuteSuccess", () => $26d7095df564f967$export$403d172f0e549eb1);
$parcel$export(module.exports, "boardIssueMoveExecuteFailure", () => $26d7095df564f967$export$3c31c79b76c3db3b);
const $26d7095df564f967$export$afe8c48481994c25 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.board-issue-move.show`
        });
const $26d7095df564f967$export$21c319cd4bbf2b2f = (eventPrefix)=>()=>({
            name: `${eventPrefix}.board-issue-move.cancel`
        });
const $26d7095df564f967$export$47de1859c695eca7 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.board-issue-move.execute`,
            data: {
                transactionId: action.meta.optimistic.id
            }
        });
const $26d7095df564f967$export$403d172f0e549eb1 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.board-issue-move.execute.success`,
            data: {
                transactionId: action.meta.optimistic.id
            }
        });
const $26d7095df564f967$export$3c31c79b76c3db3b = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.board-issue-move.execute.failure`,
            data: {
                transactionId: action.meta.optimistic.id
            }
        });

});

parcelRegister("dIYE2", function(module, exports) {

$parcel$export(module.exports, "cardCreateSuccess", () => $8c694a7b29a2b68a$export$b70c18d8546382b2);
$parcel$export(module.exports, "cardCreateFailure", () => $8c694a7b29a2b68a$export$151deebc0c103b3c);
$parcel$export(module.exports, "cardCreateFiltered", () => $8c694a7b29a2b68a$export$f069b59557af9611);
$parcel$export(module.exports, "cardCreateFilteredV2", () => $8c694a7b29a2b68a$export$f1c368b5cfb9b941);
$parcel$export(module.exports, "cardDeleteSuccess", () => $8c694a7b29a2b68a$export$abf29851b85a5dc);
$parcel$export(module.exports, "cardDeleteFailure", () => $8c694a7b29a2b68a$export$14995a1d9fdd27aa);
$parcel$export(module.exports, "cardsFlagSuccess", () => $8c694a7b29a2b68a$export$656497d228a51fa0);
$parcel$export(module.exports, "cardsFlagFailure", () => $8c694a7b29a2b68a$export$a54ef1c368494a58);
$parcel$export(module.exports, "cardOpenDetailView", () => $8c694a7b29a2b68a$export$acfe54087abfec17);
$parcel$export(module.exports, "cardCreateMultipleRequestPerformance", () => $8c694a7b29a2b68a$export$13e8b731273e5b62);
$parcel$export(module.exports, "cardCreateSuccessPerformance", () => $8c694a7b29a2b68a$export$496eebfe0f44eeed);
$parcel$export(module.exports, "cardRankRequestPerformance", () => $8c694a7b29a2b68a$export$195ac2f6e1a95c77);
$parcel$export(module.exports, "cardDeleteRequestPerformance", () => $8c694a7b29a2b68a$export$d3ff2e6ac38e63d6);
$parcel$export(module.exports, "cardsMoveSuccess", () => $8c694a7b29a2b68a$export$d9bd27fc2155921d);
$parcel$export(module.exports, "cardsMoveFailure", () => $8c694a7b29a2b68a$export$418f4abeb5fa5e63);
$parcel$export(module.exports, "cardsFlagRequestPerformance", () => $8c694a7b29a2b68a$export$dc3005aa374f7956);
$parcel$export(module.exports, "cardsParentSetSuccess", () => $8c694a7b29a2b68a$export$30fe913aeacc7d4c);
$parcel$export(module.exports, "cardsParentSetFailure", () => $8c694a7b29a2b68a$export$24c3df942a1f1dd5);

var $illlw = parcelRequire("illlw");

var $lzvR2 = parcelRequire("lzvR2");

var $jMP2a = parcelRequire("jMP2a");

var $keTr0 = parcelRequire("keTr0");

var $bHPpI = parcelRequire("bHPpI");


var $fTGix = parcelRequire("fTGix");

var $gPQCf = parcelRequire("gPQCf");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $kdGmo = parcelRequire("kdGmo");

var $dtV8v = parcelRequire("dtV8v");
const $8c694a7b29a2b68a$export$d516175c274e4e4b = (cardId, issueTypeId, createdWithRank)=>({
        actionSubjectId: cardId,
        objectType: 'issue',
        objectId: cardId,
        issueTypeId: issueTypeId,
        createdWithRank: createdWithRank
    });
const $8c694a7b29a2b68a$export$b70c18d8546382b2 = (eventPrefix)=>(preState, state, action)=>{
        const filterValues = (0, $kdGmo.getFilters)(state);
        // There is only ever at most 1 text filter
        const textFilter = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(filterValues, [
            (0, $6b2c0bb2f15ce467$export$d597759d33be802e),
            'length'
        ], 0) > 0;
        const numAssigneeFilters = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(filterValues, [
            (0, $6b2c0bb2f15ce467$export$f8f7545d2bb78afb),
            'length'
        ], 0);
        const numLabelFilters = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(filterValues, [
            (0, $6b2c0bb2f15ce467$export$37aee82a3cb1e8f7),
            'length'
        ], 0);
        const cardId = action.payload.card.id;
        const issueTypeId = action.payload.card.typeId;
        const { createdWithRank: createdWithRank } = action.payload;
        const { meta: { analyticsEvent: analyticsEvent } } = action;
        const trackEvents = [];
        const event = analyticsEvent?.clone();
        if (event != null) trackEvents.push(event.update({
            ...$8c694a7b29a2b68a$export$d516175c274e4e4b(cardId, issueTypeId, createdWithRank),
            appliedFilters: Object.keys(filterValues),
            card: action.payload.card
        }));
        return {
            name: `${eventPrefix}.card.create.success`,
            data: {
                cardId: cardId,
                issueTypeId: issueTypeId,
                transactionId: action.meta.optimistic.id,
                textFilter: textFilter,
                numAssigneeFilters: numAssigneeFilters,
                numLabelFilters: numLabelFilters
            },
            trackEvents: trackEvents
        };
    };
const $8c694a7b29a2b68a$export$151deebc0c103b3c = (eventPrefix)=>(preState, state, action)=>{
        const { meta: { analyticsEvent: analyticsEvent }, payload: { errorMessage: errorMessage, statusCode: statusCode, numCards: numCards, isClientFetchError: isClientFetchError } } = action;
        const isCompanyManaged = (0, $hkGxG.getIsCompanyManaged)(state);
        if (analyticsEvent) for(let i = 0; i < numCards; i += 1){
            const clonedAnalyticsEvent = analyticsEvent.clone();
            // Will be null if it's already been fired
            if (clonedAnalyticsEvent) (0, $jMP2a.fireOperationalAnalytics)(clonedAnalyticsEvent, 'issue createdFailed', {
                errorMessage: errorMessage,
                isClientFetchError: isClientFetchError,
                statusCode: statusCode,
                isCompanyManaged: isCompanyManaged
            });
        }
        return {
            name: `${eventPrefix}.card.create.failure`,
            data: {
                transactionId: action.meta.optimistic.id,
                isCompanyManaged: isCompanyManaged
            }
        };
    };
const $8c694a7b29a2b68a$export$f069b59557af9611 = (eventPrefix)=>(preState, state, action)=>{
        const card = action.payload;
        const filterValues = (0, $kdGmo.getFilters)(state);
        // There is only ever at most 1 text filter
        const textFilter = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(filterValues, [
            (0, $6b2c0bb2f15ce467$export$d597759d33be802e),
            'length'
        ], 0) > 0;
        const numAssigneeFilters = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(filterValues, [
            (0, $6b2c0bb2f15ce467$export$f8f7545d2bb78afb),
            'length'
        ], 0);
        const numLabelFilters = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(filterValues, [
            (0, $6b2c0bb2f15ce467$export$37aee82a3cb1e8f7),
            'length'
        ], 0);
        return {
            name: `${eventPrefix}.filter.flag.new-card-filtered.shown`,
            data: {
                cardId: card.id,
                textFilter: textFilter,
                numAssigneeFilters: numAssigneeFilters,
                numLabelFilters: numLabelFilters
            }
        };
    };
const $8c694a7b29a2b68a$export$f1c368b5cfb9b941 = (eventPrefix)=>(preState, state, action)=>{
        const cardIds = action.payload;
        const filterValues = (0, $kdGmo.getFilters)(state);
        // There is only ever at most 1 text filter
        const textFilter = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(filterValues, [
            (0, $6b2c0bb2f15ce467$export$d597759d33be802e),
            'length'
        ], 0) > 0;
        const numAssigneeFilters = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(filterValues, [
            (0, $6b2c0bb2f15ce467$export$f8f7545d2bb78afb),
            'length'
        ], 0);
        const numLabelFilters = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(filterValues, [
            (0, $6b2c0bb2f15ce467$export$37aee82a3cb1e8f7),
            'length'
        ], 0);
        return {
            name: `${eventPrefix}.filter.flag.new-card-filtered.shown`,
            data: {
                cardIds: cardIds,
                textFilter: textFilter,
                numAssigneeFilters: numAssigneeFilters,
                numLabelFilters: numLabelFilters
            }
        };
    };
const $8c694a7b29a2b68a$export$abf29851b85a5dc = (eventPrefix)=>(preState, state, action)=>{
        const concurrentId = action.meta.optimistic.id;
        (0, $gPQCf.issueDeleteInteraction)(concurrentId).stop({
            customData: {
                ...(0, $fTGix.getBacklogCardCount)(state)
            }
        });
        return {
            name: `${eventPrefix}.card.delete.success`,
            data: {
                cardId: action.payload.cardId
            }
        };
    };
const $8c694a7b29a2b68a$export$14995a1d9fdd27aa = (eventPrefix)=>(preState, state, action)=>{
        const concurrentId = action.meta.optimistic.id;
        (0, $gPQCf.issueDeleteInteraction)(concurrentId).cancel();
        return {
            name: `${eventPrefix}.card.delete.failure`,
            data: {
                cardId: action.payload.cardId
            }
        };
    };
const $8c694a7b29a2b68a$export$656497d228a51fa0 = (eventPrefix)=>(preState, state, action)=>{
        const concurrentId = action.meta.optimistic.id;
        const isCompanyManaged = (0, $hkGxG.getIsCompanyManaged)(state);
        (0, $gPQCf.flagToggleInteraction)(concurrentId).stop({
            customData: {
                ...(0, $fTGix.getBacklogCardCount)(state),
                isCompanyManaged: isCompanyManaged
            }
        });
        const { cards: cards } = action.payload;
        const flagDirection = (0, $bP7Jx.getCards)(state)[String(cards[0])].isFlagged ? 'added' : 'removed';
        return {
            name: `${eventPrefix}.cards.flag.${flagDirection}`,
            data: {
                numCards: cards.length
            }
        };
    };
const $8c694a7b29a2b68a$export$a54ef1c368494a58 = (eventPrefix)=>(preState, state, action)=>{
        const concurrentId = action.meta.optimistic.id;
        (0, $gPQCf.flagToggleInteraction)(concurrentId).cancel();
        const { cards: cards } = action.payload;
        return {
            name: `${eventPrefix}.cards.flag.failure`,
            data: {
                numCards: cards.length
            }
        };
    };
const $8c694a7b29a2b68a$export$acfe54087abfec17 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.card.open-detail-view`,
            data: {
                cardId: action.payload.cardId
            }
        });
const $8c694a7b29a2b68a$export$13e8b731273e5b62 = ()=>(preState, state, action)=>{
        const concurrentIds = action.payload.tempIds;
        concurrentIds.forEach((concurrentId)=>{
            (0, $gPQCf.issueCreateInteraction)(String(concurrentId)).start();
        });
        (0, $keTr0.scheduleAfterRender)(()=>{
            concurrentIds.forEach((concurrentId)=>{
                (0, $gPQCf.issueCreateInteraction)(String(concurrentId)).mark('feedback');
            });
        });
        return null;
    };
const $8c694a7b29a2b68a$export$496eebfe0f44eeed = ()=>(preState, state, action)=>{
        const { payload: { temporaryCardId: temporaryCardId, listId: listId, createdWithBulk: createdWithBulk } } = action;
        const concurrentId = String(temporaryCardId);
        const isCompanyManaged = (0, $hkGxG.getIsCompanyManaged)(state);
        // listId potential values: 'BOARD', 'BACKLOG' or sprintId e.g. '155'
        const cardListType = Number.isInteger(Number(listId)) ? 'SPRINT' : listId;
        (0, $gPQCf.issueCreateInteraction)(concurrentId).stop({
            customData: {
                ...(0, $lzvR2.getNormalisedPerformanceFFs)(),
                ...(0, $fTGix.getBacklogCardCount)(state),
                cardListType: cardListType,
                createdWithBulk: createdWithBulk,
                isCompanyManaged: isCompanyManaged
            }
        });
        return null;
    };
const $8c694a7b29a2b68a$export$195ac2f6e1a95c77 = ()=>()=>{
        (0, $gPQCf.issueRankInteraction).start();
        (0, $keTr0.scheduleAfterRender)(()=>{
            (0, $gPQCf.issueRankInteraction).mark('feedback');
        });
        return null;
    };
const $8c694a7b29a2b68a$export$d3ff2e6ac38e63d6 = ()=>(preState, state, action)=>{
        const concurrentId = action.meta.optimistic.id;
        (0, $gPQCf.issueDeleteInteraction)(concurrentId).start();
        (0, $keTr0.scheduleAfterRender)(()=>{
            (0, $gPQCf.issueDeleteInteraction)(concurrentId).mark('feedback');
        });
        return null;
    };
const $8c694a7b29a2b68a$export$d9bd27fc2155921d = ()=>(preState, state, action)=>{
        const { meta: { analyticsEvent: analyticsEvent }, payload: { cardIds: cardIds, cardListId: cardListId } } = action;
        if (!analyticsEvent) return null;
        const isCompanyManaged = (0, $hkGxG.getIsCompanyManaged)(state);
        const isActiveSprint = (0, $dtV8v.makeIsCardListActiveSprint)(state);
        cardIds.forEach((id)=>(0, $bHPpI.sendSuccessToMoveAnalytic)(id, // @ts-expect-error Argument of type 'UIAnalyticsEvent | null' is not assignable to parameter of type 'UIAnalyticsEvent'.
            analyticsEvent.clone(), cardListId, isActiveSprint));
        (0, $gPQCf.issueRankInteraction).stop({
            customData: {
                ...(0, $lzvR2.getNormalisedPerformanceFFs)(),
                ...(0, $fTGix.getBacklogCardCount)(state),
                isCompanyManaged: isCompanyManaged
            }
        });
        return null;
    };
const $8c694a7b29a2b68a$export$418f4abeb5fa5e63 = ()=>(preState, state, action)=>{
        const { meta: { analyticsEvent: analyticsEvent }, payload: { error: error, cardIds: cardIds, cardListId: cardListId } } = action;
        if (!analyticsEvent) return null;
        const isActiveSprint = (0, $dtV8v.makeIsCardListActiveSprint)(state);
        (0, $bHPpI.sendFailToMoveAnalytic)(analyticsEvent, cardIds, error, cardListId, isActiveSprint);
        (0, $gPQCf.issueRankInteraction).cancel();
        return null;
    };
const $8c694a7b29a2b68a$export$dc3005aa374f7956 = ()=>(preState, state, action)=>{
        const concurrentId = action.meta.optimistic.id;
        (0, $gPQCf.flagToggleInteraction)(concurrentId).start();
        (0, $keTr0.scheduleAfterRender)(()=>{
            (0, $gPQCf.flagToggleInteraction)(concurrentId).mark('feedback');
        });
        return null;
    };
const $8c694a7b29a2b68a$export$30fe913aeacc7d4c = (eventPrefix)=>()=>({
            name: `${eventPrefix}.cards.parent-set.success`
        });
const $8c694a7b29a2b68a$export$24c3df942a1f1dd5 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.cards.parent-set.failure`
        });

});
parcelRegister("lzvR2", function(module, exports) {

$parcel$export(module.exports, "getPerformanceFFsString", () => $eea190c0a66e0041$export$c983ad7dc5517558);
$parcel$export(module.exports, "getNormalisedPerformanceFFs", () => $eea190c0a66e0041$export$de03840ff3eb49a4);

var $hgFNe = parcelRequire("hgFNe");

var $illlw = parcelRequire("illlw");

var $5iWql = parcelRequire("5iWql");

var $aWbzA = parcelRequire("aWbzA");
const $eea190c0a66e0041$var$PERF_FF_PREFIX = 'jsw.perf.';
const $eea190c0a66e0041$var$EXTRA_FFS_WHITELIST = new Set([
    'fe.platform.error.tracking.enabled',
    'jsw.next-gen.service-worker',
    'sea-2127-backlog-fetch-child-issues-data-tmps_obopa',
    'jsw.roadmap.remote-actions-rollout',
    'jsw-epic-panel-performance-async-epic-details'
]);
const $eea190c0a66e0041$var$getPerformanceFFs = (0, $5iWql.default)(()=>{
    const featureFlags = Object.entries((0, $aWbzA.default)() || {})// @ts-expect-error - TS2769 - No overload matches this call.
    .filter(([key])=>key.startsWith($eea190c0a66e0041$var$PERF_FF_PREFIX)) // eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map(([key, value])=>[
            key.substring($eea190c0a66e0041$var$PERF_FF_PREFIX.length),
            (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(value, [
                'value'
            ], null)
        ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($hgFNe)))(featureFlags);
});
const $eea190c0a66e0041$var$isConsistencyCheckValue = (value)=>value === 'NEW' || value === 'OLD' || value === 'CHECK' || value === 'CHECK_RETURN_NEW';
const $eea190c0a66e0041$export$448575db1388a8e6 = (0, $5iWql.default)((whitelist = $eea190c0a66e0041$var$EXTRA_FFS_WHITELIST)=>{
    const featurePairs = Object.entries((0, $aWbzA.default)() || {})// @ts-expect-error - TS2769 - No overload matches this call.
    .filter(([key])=>whitelist.has(key)) // eslint-disable-line @typescript-eslint/no-explicit-any
    .map(([key, value])=>[
            key,
            (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(value, [
                'value'
            ], null)
        ]); // eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    // @ts-expect-error - TS2345 - Argument of type '([key, value]: [any, any]) => void' is not assignable to parameter of type '(value: any[], index: number, array: any[][]) => void'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    featurePairs.forEach(([key, value])=>{
        result[key] = value;
        if ($eea190c0a66e0041$var$isConsistencyCheckValue(value)) {
            result[`${key}-new`] = value === 'NEW';
            result[`${key}-old`] = value === 'OLD';
            result[`${key}-check`] = value === 'CHECK';
            result[`${key}-check-return-new`] = value === 'CHECK_RETURN_NEW';
        }
    });
    return result;
});
const $eea190c0a66e0041$export$c983ad7dc5517558 = (0, $5iWql.default)(()=>JSON.stringify($eea190c0a66e0041$var$getPerformanceFFs()));
const $eea190c0a66e0041$export$de03840ff3eb49a4 = (0, $5iWql.default)(()=>{
    const featureEntries = Object.entries({
        ...$eea190c0a66e0041$var$getPerformanceFFs(),
        ...$eea190c0a66e0041$export$448575db1388a8e6()
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const map = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    featureEntries.forEach(([key, value])=>{
        const normalisedKey = key.replace(/\./g, '-');
        map[normalisedKey] = value;
        return map;
    });
    return map;
});

});

parcelRegister("fTGix", function(module, exports) {

$parcel$export(module.exports, "getBacklogCardCount", () => $90bae6b476bc5140$export$b90897b496813c20);

var $bP7Jx = parcelRequire("bP7Jx");
const $90bae6b476bc5140$export$b90897b496813c20 = (state)=>({
        cardsCount: Object.keys((0, $bP7Jx.getCards)(state)).length,
        visibleCardsCount: (0, $bP7Jx.getVisibleCardIds)(state).length
    });

});


parcelRegister("279GH", function(module, exports) {

$parcel$export(module.exports, "setCardRequestIndividualResponse", () => $5b8c8a2f4d29125c$export$b8a62aa106707ded);

var $jMP2a = parcelRequire("jMP2a");

var $5Tl9n = parcelRequire("5Tl9n");
const $5b8c8a2f4d29125c$export$b8a62aa106707ded = (eventPrefix)=>(preState, state, action)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const successActions = action.payload.filter((innerAction)=>innerAction.type === (0, $5Tl9n.CARD_SET_INDIVIDUAL_REQUEST_SUCCESS));
        const commonAttributes = {
            isContextualEditing: true
        };
        if (successActions.length) (0, $jMP2a.fireTrackAnalytics)(successActions[0].meta.analyticsEvent, 'field updated', commonAttributes);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const failureActions = action.payload.filter((innerAction)=>innerAction.type === (0, $5Tl9n.CARD_SET_INDIVIDUAL_REQUEST_FAILURE));
        if (failureActions.length) (0, $jMP2a.fireOperationalAnalytics)(failureActions[0].meta.analyticsEvent, 'field updateFailed', {
            ...commonAttributes,
            successCount: successActions.length,
            failureCount: failureActions.length,
            statusCode: failureActions[0].payload.statusCode
        });
        return {
            name: `${eventPrefix}.set-card-request.execute-individual.response`
        };
    };

});

parcelRegister("fDNdb", function(module, exports) {

$parcel$export(module.exports, "setCustomFiltersPerformance", () => $456ca82ac2d60c02$export$a4497c4897069a2b);
$parcel$export(module.exports, "setCustomFiltersFailure", () => $456ca82ac2d60c02$export$b6336fdfea9c7130);
$parcel$export(module.exports, "setCustomFiltersSuccess", () => $456ca82ac2d60c02$export$807bc3d6fd05a3f8);
$parcel$export(module.exports, "setClearCustomFiltersFailure", () => $456ca82ac2d60c02$export$8390cb5d2e786615);
$parcel$export(module.exports, "setClearCustomFiltersSuccess", () => $456ca82ac2d60c02$export$7705547b216dde);
$parcel$export(module.exports, "setClearCustomFiltersPerformance", () => $456ca82ac2d60c02$export$c95dc6c32e218669);
$parcel$export(module.exports, "setCustomFiltersRefilterSuccess", () => $456ca82ac2d60c02$export$be433321d98a3ffa);
$parcel$export(module.exports, "setCustomFiltersRefilterFailure", () => $456ca82ac2d60c02$export$d76e8115781031ba);

var $JRB5w = parcelRequire("JRB5w");

var $jMP2a = parcelRequire("jMP2a");

var $3FyZ4 = parcelRequire("3FyZ4");

var $keTr0 = parcelRequire("keTr0");

var $cm2SB = parcelRequire("cm2SB");

var $hkGxG = parcelRequire("hkGxG");
const $456ca82ac2d60c02$export$a4497c4897069a2b = ()=>(preState, state, action)=>{
        const { meta: { numCustomFiltersApplied: numCustomFiltersApplied, numIssueIds: numIssueIds } } = action;
        const isCompanyManaged = (0, $hkGxG.getIsCompanyManaged)(state);
        (0, $keTr0.scheduleAfterRender)(()=>{
            (0, $cm2SB.stopCustomFilterInteraction)(numCustomFiltersApplied, numIssueIds, isCompanyManaged);
        });
        return null;
    };
const $456ca82ac2d60c02$export$b6336fdfea9c7130 = ()=>(preState, state, action)=>{
        const { payload: { error: error }, meta: { analyticsEvent: analyticsEvent } } = action;
        if (analyticsEvent) (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'customFilters failed', {
            isClientFetchError: (0, $JRB5w.isClientFetchError)(error),
            errorMessage: error?.message
        });
        (0, $cm2SB.cancelCustomFilterInteraction)();
        return null;
    };
const $456ca82ac2d60c02$export$807bc3d6fd05a3f8 = ()=>(preState, state, action)=>{
        const { meta: { analyticsEvent: analyticsEvent, numCustomFiltersApplied: numCustomFiltersApplied, numIssueIds: numIssueIds } } = action;
        (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'customFilters applied', {
            numCustomFiltersApplied: numCustomFiltersApplied,
            numIssueIds: numIssueIds
        });
        return null;
    };
const $456ca82ac2d60c02$export$8390cb5d2e786615 = ()=>(preState, state, action)=>{
        const { payload: { error: error }, meta: { analyticsEvent: analyticsEvent } } = action;
        if (analyticsEvent) (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'clearCustomFilters failed', {
            isClientFetchError: (0, $JRB5w.isClientFetchError)(error),
            errorMessage: error?.message
        });
        (0, $cm2SB.cancelClearCustomFilterInteraction)();
        return null;
    };
const $456ca82ac2d60c02$export$7705547b216dde = ()=>(preState, state, action)=>{
        const { meta: { analyticsEvent: analyticsEvent } } = action;
        // @ts-expect-error - Argument of type 'UIAnalyticsEvent | undefined' is not assignable to parameter of type 'UIAnalyticsEvent'.
        (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'clearCustomFilters applied');
        return null;
    };
const $456ca82ac2d60c02$export$c95dc6c32e218669 = ()=>(preState, state)=>{
        const isCompanyManaged = (0, $hkGxG.getIsCompanyManaged)(state);
        (0, $keTr0.scheduleAfterRender)(()=>{
            (0, $cm2SB.stopClearCustomFilterInteraction)(isCompanyManaged);
        });
        return null;
    };
const $456ca82ac2d60c02$export$be433321d98a3ffa = ()=>(preState, state, action)=>{
        const { excludedCardIds: excludedCardIds, filteredCardIds: filteredCardIds } = action.payload;
        (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                source: 'backlog',
                actionSubject: 'customFiltersRefilter',
                action: 'applied',
                attributes: {
                    excludedCards: excludedCardIds.length,
                    filteredCards: filteredCardIds.length
                }
            };
            client.getInstance().sendTrackEvent(payload);
        });
        return null;
    };
const $456ca82ac2d60c02$export$d76e8115781031ba = ()=>(preState, state, action)=>{
        const { error: error } = action.payload;
        (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                source: 'backlog',
                actionSubject: 'customFiltersRefilter',
                action: 'failed',
                attributes: {
                    isClientFetchError: (0, $JRB5w.isClientFetchError)(error),
                    errorMessage: error?.message
                }
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        return null;
    };

});
parcelRegister("cm2SB", function(module, exports) {

$parcel$export(module.exports, "setCustomFilterInteractionFeedbackMark", () => $277c8f9d8f35b5e8$export$5dd87a22b8e2c81c);
$parcel$export(module.exports, "setCustomFilterInteractionStartMark", () => $277c8f9d8f35b5e8$export$600569a4fb9e5675);
$parcel$export(module.exports, "cancelCustomFilterInteraction", () => $277c8f9d8f35b5e8$export$178f6b8399be6909);
$parcel$export(module.exports, "stopCustomFilterInteraction", () => $277c8f9d8f35b5e8$export$90db63ac5c02197a);
$parcel$export(module.exports, "setClearCustomFilterInteractionStartMark", () => $277c8f9d8f35b5e8$export$962ac6dbaf359610);
$parcel$export(module.exports, "stopClearCustomFilterInteraction", () => $277c8f9d8f35b5e8$export$6960edeeed3db8b2);
$parcel$export(module.exports, "cancelClearCustomFilterInteraction", () => $277c8f9d8f35b5e8$export$9ff508c2f230f886);

var $lzvR2 = parcelRequire("lzvR2");

var $gPQCf = parcelRequire("gPQCf");
const $277c8f9d8f35b5e8$export$5dd87a22b8e2c81c = ()=>{
    (0, $gPQCf.customFilterInteraction).mark('feedback');
};
const $277c8f9d8f35b5e8$export$600569a4fb9e5675 = ()=>{
    (0, $gPQCf.customFilterInteraction).start();
};
const $277c8f9d8f35b5e8$export$178f6b8399be6909 = ()=>{
    (0, $gPQCf.customFilterInteraction).cancel();
};
const $277c8f9d8f35b5e8$export$90db63ac5c02197a = (numCustomFiltersApplied, numIssueIds, isCompanyManaged)=>{
    (0, $gPQCf.customFilterInteraction).stop({
        customData: {
            ...(0, $lzvR2.getNormalisedPerformanceFFs)(),
            numCustomFiltersApplied: numCustomFiltersApplied,
            numIssueIds: numIssueIds,
            isCompanyManaged: isCompanyManaged
        }
    });
};
const $277c8f9d8f35b5e8$export$962ac6dbaf359610 = ()=>{
    (0, $gPQCf.clearCustomFilterInteraction).start();
};
const $277c8f9d8f35b5e8$export$6960edeeed3db8b2 = (isCompanyManaged)=>{
    (0, $gPQCf.clearCustomFilterInteraction).stop({
        customData: {
            isCompanyManaged: isCompanyManaged
        }
    });
};
const $277c8f9d8f35b5e8$export$9ff508c2f230f886 = ()=>{
    (0, $gPQCf.clearCustomFilterInteraction).cancel();
};

});


parcelRegister("9cJW6", function(module, exports) {

$parcel$export(module.exports, "setAllFilters", () => $8de34f566e17997c$export$1e6b2e9f0ff84131);
$parcel$export(module.exports, "setAllFiltersPerformance", () => $8de34f566e17997c$export$338d2cd01a36c93d);

var $illlw = parcelRequire("illlw");

var $lzvR2 = parcelRequire("lzvR2");

var $keTr0 = parcelRequire("keTr0");


var $gPQCf = parcelRequire("gPQCf");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $kdGmo = parcelRequire("kdGmo");

var $c2v8q = parcelRequire("c2v8q");
const $8de34f566e17997c$export$c48d1dabfffb8ec0 = (eventPrefix)=>(preState, state)=>{
        const totalAssigneeCount = (0, $bP7Jx.getOrderedAssignees)(state).length;
        return {
            name: `${eventPrefix}.filters.show`,
            data: {
                numAvatarsDisplayed: totalAssigneeCount > (0, $6b2c0bb2f15ce467$export$360e7ca29749d455) ? (0, $6b2c0bb2f15ce467$export$360e7ca29749d455) : totalAssigneeCount
            }
        };
    };
const $8de34f566e17997c$export$556a5ff7bd7ac86 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.filters.search-field.focus`,
            data: {}
        });
const $8de34f566e17997c$export$5845d1911d8d06dd = (eventPrefix)=>(preState)=>{
        const selectedFilters = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))((0, $kdGmo.getFilters)(preState), [
            'values'
        ]);
        return {
            name: `${eventPrefix}.filters.clear-button.click`,
            data: {
                numSelectedAvatars: (selectedFilters[0, $6b2c0bb2f15ce467$export$f8f7545d2bb78afb] || []).length
            }
        };
    };
const $8de34f566e17997c$var$getFilterAnalyticsData = (state)=>{
    const filters = (0, $kdGmo.getFilters)(state);
    const assigneeFilters = filters[0, $6b2c0bb2f15ce467$export$f8f7545d2bb78afb] || [];
    const labelFilters = filters[0, $6b2c0bb2f15ce467$export$37aee82a3cb1e8f7] || [];
    const issueParentFilters = filters[0, $6b2c0bb2f15ce467$export$2a4f270075a033de] || [];
    const versionFilters = filters[0, $6b2c0bb2f15ce467$export$a4ad2735b021c132] || [];
    const issueTypeFilters = filters[0, $6b2c0bb2f15ce467$export$ebb48b08205007c5] || [];
    const currentUser = (0, $c2v8q.getCurrentUser)(state);
    return {
        numSelectedAvatars: assigneeFilters.length,
        isAssignedToMeSelected: currentUser ? assigneeFilters.indexOf(currentUser.id) > -1 : false,
        numSelectedLabels: labelFilters.length,
        numVisibleIssues: (0, $bP7Jx.getVisibleCardIds)(state).length,
        numSelectedIssueParents: issueParentFilters.length,
        numSelectedVersions: versionFilters.length,
        numSelectedIssueTypes: issueTypeFilters.length
    };
};
const $8de34f566e17997c$export$1e6b2e9f0ff84131 = (eventPrefix)=>(preState, state, action)=>{
        const { filterType: filterType } = action.meta;
        if (filterType) {
            let actionName = 'select';
            const filters = (0, $kdGmo.getFilters)(state);
            if (filterType === (0, $6b2c0bb2f15ce467$export$d597759d33be802e) && !filters[0, $6b2c0bb2f15ce467$export$d597759d33be802e]) actionName = 'deselect';
            else {
                const preFilters = (0, $kdGmo.getFilters)(preState);
                actionName = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(filters, [
                    filterType
                ], []).length < (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(preFilters, [
                    filterType
                ], []).length ? 'deselect' : actionName;
            }
            return {
                name: `${eventPrefix}.filters.${filterType}.${actionName}`,
                data: $8de34f566e17997c$var$getFilterAnalyticsData(state)
            };
        }
        return null;
    };
const $8de34f566e17997c$export$338d2cd01a36c93d = ()=>(preState, state, action)=>{
        const { filters: filters } = action.payload;
        const filterType = Object.keys(filters || {});
        const isCompanyManaged = (0, $hkGxG.getIsCompanyManaged)(state);
        filterType.sort();
        (0, $keTr0.scheduleAfterRender)(()=>{
            (0, $gPQCf.filterInteraction).stop({
                customData: {
                    ...(0, $lzvR2.getNormalisedPerformanceFFs)(),
                    filterType: filterType.join(',') || 'CLEAR',
                    isCompanyManaged: isCompanyManaged
                }
            });
        });
        return null;
    };

});

parcelRegister("fAwPy", function(module, exports) {

$parcel$export(module.exports, "issueViewOpenPerformance", () => $466d2df11e909d1e$export$2da4dabf4eeee402);

var $duQ8C = parcelRequire("duQ8C");

var $gPQCf = parcelRequire("gPQCf");
const $466d2df11e909d1e$export$2da4dabf4eeee402 = ()=>(prevState, state, action)=>{
        if (!action.payload.withCmd && !action.payload.withShift) {
            (0, $duQ8C.default)('backlog.issue-view-opened');
            (0, $gPQCf.issueViewOpenInteraction).start();
        }
        return null;
    };

});

parcelRegister("2a6ca", function(module, exports) {

$parcel$export(module.exports, "cardCreateConfigLoadFailure", () => $7617b1fded5119a8$export$55f7f50ae5d386e);
$parcel$export(module.exports, "cardCreateConfigLoadSuccess", () => $7617b1fded5119a8$export$30b096da81e0022e);

var $JRB5w = parcelRequire("JRB5w");

var $jMP2a = parcelRequire("jMP2a");
const $7617b1fded5119a8$export$55f7f50ae5d386e = ()=>(preState, state, action)=>{
        const { payload: { error: error }, meta: { analyticsEvent: analyticsEvent } } = action;
        if (analyticsEvent) (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'cardCreateConfigLoad failed', {
            isClientFetchError: (0, $JRB5w.isClientFetchError)(error),
            errorMessage: error?.message,
            statusCode: error?.statusCode
        });
        return null;
    };
const $7617b1fded5119a8$export$30b096da81e0022e = ()=>(preState, state, action)=>{
        const { meta: { analyticsEvent: analyticsEvent } } = action;
        if (analyticsEvent) (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'cardCreateConfigLoad success');
        return null;
    };

});

parcelRegister("eb0hG", function(module, exports) {

$parcel$export(module.exports, "sprintCreateRequestPerformance", () => $a89c356d7933159b$export$a2c86d07fe1585ea);
$parcel$export(module.exports, "sprintCreateSuccessPerformance", () => $a89c356d7933159b$export$ffb3b8195785fb3e);
$parcel$export(module.exports, "sprintDeleteRequestPerformance", () => $a89c356d7933159b$export$ffd831d4c6f0494);
$parcel$export(module.exports, "sprintDeleteSuccessPerformance", () => $a89c356d7933159b$export$795344b111af47fb);
$parcel$export(module.exports, "sprintCreateSuccess", () => $a89c356d7933159b$export$4bedc2fcbe2138bd);
$parcel$export(module.exports, "sprintCreateFailure", () => $a89c356d7933159b$export$cb20bc93da1235f7);

var $lzvR2 = parcelRequire("lzvR2");

var $jMP2a = parcelRequire("jMP2a");

var $keTr0 = parcelRequire("keTr0");

var $fTGix = parcelRequire("fTGix");

var $gPQCf = parcelRequire("gPQCf");
const $a89c356d7933159b$export$a2c86d07fe1585ea = ()=>(preState, state, action)=>{
        const concurrentId = action.payload.temporaryCardListId;
        (0, $gPQCf.createSprintInteraction)(concurrentId).start();
        (0, $keTr0.scheduleAfterRender)(()=>{
            (0, $gPQCf.createSprintInteraction)(concurrentId).mark('feedback');
        });
        return null;
    };
const $a89c356d7933159b$export$ffb3b8195785fb3e = ()=>(preState, state, action)=>{
        const concurrentId = String(action.payload.temporaryCardListId);
        (0, $gPQCf.createSprintInteraction)(concurrentId).stop({
            customData: {
                ...(0, $lzvR2.getNormalisedPerformanceFFs)(),
                ...(0, $fTGix.getBacklogCardCount)(state)
            }
        });
        return null;
    };
const $a89c356d7933159b$export$ffd831d4c6f0494 = ()=>(preState, state, action)=>{
        const concurrentId = action.payload.sprintId;
        (0, $gPQCf.deleteSprintInteraction)(concurrentId).start();
        (0, $keTr0.scheduleAfterRender)(()=>{
            (0, $gPQCf.deleteSprintInteraction)(concurrentId).mark('feedback');
        });
        return null;
    };
const $a89c356d7933159b$export$795344b111af47fb = ()=>(preState, state, action)=>{
        const concurrentId = action.payload.sprintId;
        (0, $gPQCf.deleteSprintInteraction)(concurrentId).stop({
            customData: {
                ...(0, $lzvR2.getNormalisedPerformanceFFs)(),
                ...(0, $fTGix.getBacklogCardCount)(state)
            }
        });
    };
const $a89c356d7933159b$export$4bedc2fcbe2138bd = ()=>(preState, state, action)=>{
        const { payload: payload, meta: { analyticsEvent: analyticsEvent } } = action;
        if (!analyticsEvent) return null;
        const trackEvent = analyticsEvent.clone();
        if (trackEvent) {
            const didSprintCreateWithDefaultDates = Boolean(payload.sprint.sprintData?.startDate);
            (0, $jMP2a.fireTrackAnalytics)(trackEvent, 'sprint created', {
                didSprintCreateWithDefaultDates: didSprintCreateWithDefaultDates
            });
        }
        const opEvent = analyticsEvent.clone();
        if (opEvent) (0, $jMP2a.fireOperationalAnalytics)(opEvent, 'ui taskSuccess', {
            task: 'createSprint'
        });
        return null;
    };
const $a89c356d7933159b$export$cb20bc93da1235f7 = ()=>(preState, state, action)=>{
        const { meta: { analyticsEvent: analyticsEvent } } = action;
        if (!analyticsEvent) return null;
        const opEvent = analyticsEvent.clone();
        if (opEvent) (0, $jMP2a.fireOperationalAnalytics)(opEvent, 'ui taskFail', {
            task: 'createSprint'
        });
        return null;
    };

});


parcelRegister("g7xdG", function(module, exports) {

$parcel$export(module.exports, "triggerAnalytics", () => $d0dd9588c3fe8b47$export$2c57de8a70f64057);
/**
 * @deprecated GasV2 has been cleaned up, and it has not been logging any events since July. Please replace implementation with sending GasV3 analytics: go/gasv3
 */ const $d0dd9588c3fe8b47$export$2c57de8a70f64057 = (_appName)=>(_eventNameSuffix, _eventData)=>Promise.resolve(undefined);

});


parcelRegister("ic57W", function(module, exports) {

$parcel$export(module.exports, "default", () => $891de6bab45b5b40$export$2e2bcd8739ae039);

var $hdVXV = parcelRequire("hdVXV");

var $jiL2Q = parcelRequire("jiL2Q");

var $7TN4i = parcelRequire("7TN4i");

var $5awap = parcelRequire("5awap");

var $7GTNy = parcelRequire("7GTNy");

var $68H01 = parcelRequire("68H01");

var $64fZ9 = parcelRequire("64fZ9");

var $59CKH = parcelRequire("59CKH");

var $1HfeQ = parcelRequire("1HfeQ");

var $dNkcA = parcelRequire("dNkcA");

var $K2SiM = parcelRequire("K2SiM");

var $hzOcT = parcelRequire("hzOcT");

var $jAbil = parcelRequire("jAbil");

var $cbRhO = parcelRequire("cbRhO");

var $a9os4 = parcelRequire("a9os4");

var $eYeFr = parcelRequire("eYeFr");

var $bCL12 = parcelRequire("bCL12");

var $lafvx = parcelRequire("lafvx");

var $6iBIZ = parcelRequire("6iBIZ");
// We ignore the success and failure mutations, we just invalidate them as soon as the request
// is fired. That way if someone navigates away before the SUCCESS/FAILURE mutation returns they
// won't get an incorrect cached version
const $891de6bab45b5b40$var$BACKLOG_IGNORE_REGEX = /^(state\.actions\.).+(_SUCCESS|_FAILURE)$/;
// This one helps us ignore junk like COMMON/REDUX_DISPOSABLE/DISPOSE_ACTION
const $891de6bab45b5b40$var$ELIGIBLE_FOR_INVALIDATION = /^(state\.actions\.).+$/;
const $891de6bab45b5b40$export$d4b7dead01a52ae = ({ type: type })=>{
    switch(type){
        case 0, $jiL2Q.REFRESH_DATA_REQUEST:
        case 0, $jiL2Q.LOAD_APP_DATA_REQUEST:
        case 0, $jiL2Q.LOAD_CONFIG_DATA_REQUEST:
        case 0, $eYeFr.LOAD_PRIORITIES_REQUEST:
        case 0, $jiL2Q.SET_CONFIG_DATA:
        case 0, $jiL2Q.LOAD_CONFIG_DATA_MODEL_SUCCESS:
        case 0, $jiL2Q.SET_APP_DATA:
        case 0, $lafvx.REQUEST_CURRENT_USER:
        case 0, $lafvx.SET_CURRENT_USER:
        case 0, $jiL2Q.INITIALIZE_APP_PROPS:
        case 0, $jiL2Q.BACKLOG_VIEW:
        case 0, $jAbil.SET_ALL_FILTERS:
        case 0, $dNkcA.SET_COLUMNS:
        case 0, $68H01.CARD_PREV:
        case 0, $68H01.CARD_NEXT:
        case 0, $7GTNy.CARD_FOCUS:
        case 0, $7GTNy.CARD_BLUR:
        case 0, $59CKH.SET_RICH_ACTIVE_CARD:
        case 0, $1HfeQ.CARD_CLICK:
        case 0, $1HfeQ.CARD_SINGLE_SELECT:
        case 0, $1HfeQ.SET_LAST_SELECTED_CARD_KEY:
        case 0, $7TN4i.CARD_LIST_TOGGLE:
        case 0, $7TN4i.SET_COLLAPSED_CARD_LIST:
        case 0, $K2SiM.OPEN_DETAIL_VIEW:
        case 0, $K2SiM.CLOSE_DETAIL_VIEW:
        case 0, $cbRhO.OPEN_MODAL:
        case 0, $cbRhO.CLOSE_MODAL:
        case 0, $bCL12.REALTIME_DISPATCH_EVENT:
        case 0, $bCL12.REALTIME_DISPATCH_EVENT_BATCH:
        case 0, $59CKH.SET_CARD_ID_WITH_ABOVE_ICC_OPEN:
        case 0, $64fZ9.CARD_REFRESH_REQUEST:
        case 0, $hzOcT.DRAG_START:
        case 0, $hzOcT.DRAG_END:
        case 0, $K2SiM.UPDATE_DETAIL_VIEW:
        case 0, $1HfeQ.CARD_EMPTY_SELECTION:
        case 0, $1HfeQ.PARENT_CLICK:
        case 0, $7TN4i.CARD_LISTS_ENABLE_ALL:
        case 0, $1HfeQ.CARD_TOGGLE_SELECTION:
        case 0, $5awap.FILTERED_CARD_CLEAR:
        case 0, $7TN4i.CARD_LISTS_DISABLE:
        case 0, $K2SiM.OPEN_DETAIL_VIEW_DEBOUNCED:
        case 0, $1HfeQ.CARD_MULTI_SELECT:
        case 0, $a9os4.CLOSE_INSIGHTS_PANEL:
        case 0, $6iBIZ.SET_VERSIONS:
        case 0, $a9os4.SET_ALL_PANELS:
        case 0, $a9os4.SET_ALL_PANELS_SUCCESS:
            return false;
        default:
            break;
    }
    // Ignore stuff that isn't applicable to the board (e.g. COMMON/REDUX_DISPOSABLE/DISPOSE_ACTION)
    // Test against board specific actions
    if (!$891de6bab45b5b40$var$ELIGIBLE_FOR_INVALIDATION.exec(type) || $891de6bab45b5b40$var$BACKLOG_IGNORE_REGEX.exec(type)) return false;
    // DEFAULT TO TRUE. It's better to forcibly refresh the cache if someone forgets to add
    // their mutation here
    return true;
};
var $891de6bab45b5b40$export$2e2bcd8739ae039 = (0, $hdVXV.default)((0, $c22b1ee1fcd49c4a$export$dedbdcc35e955187), $891de6bab45b5b40$export$d4b7dead01a52ae);

});
parcelRegister("hdVXV", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf16d328e2c4f433$export$2e2bcd8739ae039);

var $ieUWD = parcelRequire("ieUWD");
const $cf16d328e2c4f433$export$41c940a04807c68c = (subject)=>(origin, invalidationFunction)=>()=>(next)=>(action)=>{
                    // There is a potential that the action gets passed as undefined
                    if (action && invalidationFunction(action)) {
                        // Trigger cache invalidation. Let the listeners handle everything else
                        subject.next(origin);
                        (0, $ieUWD.addInvalidationReason)(origin, action.type ?? 'UNKNOWN');
                    }
                    return next(action);
                };
var $cf16d328e2c4f433$export$2e2bcd8739ae039 = $cf16d328e2c4f433$export$41c940a04807c68c((0, $ieUWD.default));

});

parcelRegister("59CKH", function(module, exports) {

$parcel$export(module.exports, "SET_RICH_ACTIVE_CARD", () => $f9a692a4025110ce$export$4c9169a58b37875e);
$parcel$export(module.exports, "setRichActiveCard", () => $f9a692a4025110ce$export$64729d240866f3ef);
$parcel$export(module.exports, "SET_CARD_ID_WITH_ABOVE_ICC_OPEN", () => $f9a692a4025110ce$export$ec2969f9f94bf260);
$parcel$export(module.exports, "setCardIdWithAboveICCOpen", () => $f9a692a4025110ce$export$77d156de930b02f2);
const $f9a692a4025110ce$export$4c9169a58b37875e = 'state.actions.cards.rich-card.SET_RICH_ACTIVE_CARD';
const $f9a692a4025110ce$export$64729d240866f3ef = (cardId)=>({
        type: $f9a692a4025110ce$export$4c9169a58b37875e,
        payload: {
            cardId: cardId
        }
    });
const $f9a692a4025110ce$export$ec2969f9f94bf260 = 'state.actions.cards.rich-card.SET_CARD_ID_WITH_ABOVE_ICC_OPEN';
const $f9a692a4025110ce$export$77d156de930b02f2 = (cardId)=>({
        type: $f9a692a4025110ce$export$ec2969f9f94bf260,
        payload: {
            cardId: cardId
        }
    });

});

parcelRegister("hzOcT", function(module, exports) {

$parcel$export(module.exports, "DRAG_START", () => $ee659c417dab7b8e$export$56a2165aef3d890f);
$parcel$export(module.exports, "dragStart", () => $ee659c417dab7b8e$export$c34730c351bf3a09);
$parcel$export(module.exports, "DRAG_END", () => $ee659c417dab7b8e$export$fc1141357993c252);
$parcel$export(module.exports, "dragEnd", () => $ee659c417dab7b8e$export$5d38b0bd4bef40ba);
$parcel$export(module.exports, "BEFORE_CAPTURE", () => $ee659c417dab7b8e$export$243992ddf18a3626);
$parcel$export(module.exports, "beforeCapture", () => $ee659c417dab7b8e$export$f9e12102ea5efb98);
$parcel$export(module.exports, "TRANSITION_ZONE_ENTER", () => $ee659c417dab7b8e$export$204c8582fbaab1b9);
$parcel$export(module.exports, "transitionZoneEnter", () => $ee659c417dab7b8e$export$105dc40c43a094f8);
$parcel$export(module.exports, "TRANSITION_ZONE_LEAVE", () => $ee659c417dab7b8e$export$b6bb144f1db68c2d);
$parcel$export(module.exports, "transitionZoneLeave", () => $ee659c417dab7b8e$export$a9aed1d92a4d13b4);
const $ee659c417dab7b8e$export$56a2165aef3d890f = 'state.actions.drag.DRAG_START';
const $ee659c417dab7b8e$export$c34730c351bf3a09 = ()=>({
        type: $ee659c417dab7b8e$export$56a2165aef3d890f
    });
const $ee659c417dab7b8e$export$fc1141357993c252 = 'state.actions.drag.DRAG_END';
const $ee659c417dab7b8e$export$5d38b0bd4bef40ba = ()=>({
        type: $ee659c417dab7b8e$export$fc1141357993c252
    });
const $ee659c417dab7b8e$export$243992ddf18a3626 = 'state.actions.drag.BEFORE_CAPTURE';
const $ee659c417dab7b8e$export$f9e12102ea5efb98 = (sourceCardGroupType, sourceCardListId, isSubtask, sourceParentId)=>({
        type: $ee659c417dab7b8e$export$243992ddf18a3626,
        payload: {
            sourceCardGroupType: sourceCardGroupType,
            sourceCardListId: sourceCardListId,
            isSubtask: isSubtask,
            sourceParentId: sourceParentId
        }
    });
const $ee659c417dab7b8e$export$204c8582fbaab1b9 = 'state.actions.drag.TRANSITION_ZONE_ENTER';
const $ee659c417dab7b8e$export$105dc40c43a094f8 = ()=>({
        type: $ee659c417dab7b8e$export$204c8582fbaab1b9
    });
const $ee659c417dab7b8e$export$b6bb144f1db68c2d = 'state.actions.drag.TRANSITION_ZONE_LEAVE';
const $ee659c417dab7b8e$export$a9aed1d92a4d13b4 = ()=>({
        type: $ee659c417dab7b8e$export$b6bb144f1db68c2d
    });

});


parcelRegister("jS607", function(module, exports) {

$parcel$export(module.exports, "default", () => $d02dfd1aed3c449d$export$2e2bcd8739ae039);

var $huRi7 = parcelRequire("huRi7");

var $elXCR = parcelRequire("elXCR");

var $1qJOG = parcelRequire("1qJOG");

var $c7xMS = parcelRequire("c7xMS");
var $d02dfd1aed3c449d$export$2e2bcd8739ae039 = (0, $huRi7.combineReducers)({
    ui: $c7xMS.default,
    // Need cast to open-up store to | type that isn't only handling optimistic
    // state. This is due to `optimistic(...)` from redux-optimistic-ui not
    // being fully type-safe.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    entities: (0, $1qJOG.default),
    config: $elXCR.default
});

});
parcelRegister("elXCR", function(module, exports) {

$parcel$export(module.exports, "default", () => $41ec2db28a6b8ea7$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $hompL = parcelRequire("hompL");

var $ao0hp = parcelRequire("ao0hp");

var $94zjC = parcelRequire("94zjC");

var $4m36T = parcelRequire("4m36T");

var $jiL2Q = parcelRequire("jiL2Q");

var $4ntxZ = parcelRequire("4ntxZ");

var $dQu14 = parcelRequire("dQu14");

var $4GiZ2 = parcelRequire("4GiZ2");

var $h4zn0 = parcelRequire("h4zn0");

var $jHgZf = parcelRequire("jHgZf");
const $41ec2db28a6b8ea7$var$defaultState = {
    locale: (0, $ao0hp.defaultLocale),
    baseUrl: '',
    rapidViewId: '',
    isCompanyManaged: false,
    projectKey: '',
    projectId: 1,
    projectName: '',
    rankCustomFieldId: 0,
    // @ts-expect-error(PARTIAL_RECORD) TS2739 - Type '{}' is missing the following properties from type 'Permissions': CAN_CREATE_ISSUES, CAN_DELETE_ISSUES, CAN_MANAGE_SPRINTS, CAN_EDIT_ISSUES, CAN_EDIT_BOARD_CONFIG
    permissions: {},
    timeTrackingOptions: (0, $4m36T.defaultTimeTrackingOptions),
    cloudId: '',
    atlassianAccountId: null,
    xsrfToken: '',
    backlogStrategy: 'NONE',
    name: '',
    sprintFieldId: null,
    storyPointFieldId: null,
    epicIssueType: null,
    epicLinkField: null,
    jqlQuery: null,
    isInlineCardCreateEnabled: false,
    requestColumnMigration: false,
    extension: {
        operations: []
    },
    allFeatures: [],
    version: {
        isVersionsFeatureEnabled: false
    },
    sessionId: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
    kanbanBoardColumnId: null,
    kanbanBacklogColumnId: null,
    isOrderedByRank: true,
    showEpicAsPanel: false,
    canInviteOthersToProject: false,
    whiteboardsEntrypointExperimentConfig: {
        hasConfluenceAccess: false,
        hasConfluenceSpaces: false,
        hasViewedPulse: true,
        eligibility: {
            flow: null,
            cohort: 'not-enrolled'
        }
    }
};
function $41ec2db28a6b8ea7$export$2e2bcd8739ae039(state = $41ec2db28a6b8ea7$var$defaultState, action) {
    switch(action.type){
        case 0, $jiL2Q.INITIALIZE_APP_PROPS:
            return {
                ...state,
                ...action.payload,
                sessionId: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4()
            };
        case 0, $jiL2Q.LOAD_CONFIG_DATA_MODEL_SUCCESS:
            return (0, $6HC1D.merge)((0, $6HC1D.merge)(state, action.payload.config), {
                permissions: state.permissions
            });
        case 0, $jiL2Q.SET_APP_DATA:
        case 0, $jiL2Q.SET_CONFIG_DATA:
            return (0, $6HC1D.merge)((0, $6HC1D.merge)(state, action.payload.config), {
                permissions: (0, $6HC1D.merge)(state.permissions, action.payload.config.permissions)
            });
        case 0, $4GiZ2.FETCH_PERMISSIONS_SUCCESS:
            return (0, $6HC1D.merge)(state, {
                permissions: (0, $6HC1D.merge)(state.permissions, action.payload.permissions)
            });
        case 0, $dQu14.EXTENSION_FETCH_SUCCESS:
            return (0, $94zjC.chainUnsafe)(state).set('extension', (0, $jHgZf.default)(state.extension, action)).value();
        case 0, $4ntxZ.SET_CAN_USER_INVITE:
            return (0, $6HC1D.merge)(state, {
                canInviteOthersToProject: action.payload.canInviteOthersToProject
            });
        case 0, $h4zn0.CONFLUENCE_ACCESS_ESTABLISHED:
            return (0, $6HC1D.merge)(state, {
                whiteboardsEntrypointExperimentConfig: {
                    ...state.whiteboardsEntrypointExperimentConfig,
                    hasConfluenceAccess: action.payload.hasConfluenceAccess
                }
            });
        case 0, $h4zn0.HAS_CONFLUENCE_SPACES:
            return (0, $6HC1D.merge)(state, {
                whiteboardsEntrypointExperimentConfig: {
                    ...state.whiteboardsEntrypointExperimentConfig,
                    hasConfluenceSpaces: action.payload.hasConfluenceSpaces
                }
            });
        case 0, $h4zn0.PULSE_VIEWED_ESTABLISHED:
            return (0, $6HC1D.merge)(state, {
                whiteboardsEntrypointExperimentConfig: {
                    ...state.whiteboardsEntrypointExperimentConfig,
                    hasViewedPulse: action.payload.hasViewedPulse
                }
            });
        case 0, $h4zn0.SET_HAS_PULSE_VIEWED_SUCCESS:
            return (0, $6HC1D.merge)(state, {
                whiteboardsEntrypointExperimentConfig: {
                    ...state.whiteboardsEntrypointExperimentConfig,
                    hasViewedPulse: action.payload.hasViewedPulse
                }
            });
        case 0, $h4zn0.SET_WHITEBOARD_ELIGIBILITY:
            return (0, $6HC1D.merge)(state, {
                whiteboardsEntrypointExperimentConfig: {
                    ...state.whiteboardsEntrypointExperimentConfig,
                    eligibility: {
                        flow: action.payload.flow,
                        cohort: action.payload.cohort
                    }
                }
            });
        default:
            return state;
    }
}

});
parcelRegister("94zjC", function(module, exports) {

$parcel$export(module.exports, "assocUnsafe", () => $56ee753086711575$export$a759ec8fde46de77);
$parcel$export(module.exports, "dissocUnsafe", () => $56ee753086711575$export$e0867c1b5da854fe);
$parcel$export(module.exports, "assocInUnsafe", () => $56ee753086711575$export$1bfac1118aad2c2f);
$parcel$export(module.exports, "updateInUnsafe", () => $56ee753086711575$export$f920b8c255ec1192);
$parcel$export(module.exports, "chainUnsafe", () => $56ee753086711575$export$181c753256d1c9a0);

var $6HC1D = parcelRequire("6HC1D");
const $56ee753086711575$export$a759ec8fde46de77 = (collection, key, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $6HC1D.assoc(collection, key, value);
const $56ee753086711575$export$9b65d21cdbb50a87 = (collection, key, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $6HC1D.set(collection, key, value);
const $56ee753086711575$export$e0867c1b5da854fe = (collection, key)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $6HC1D.dissoc(collection, key);
const $56ee753086711575$export$958195bad0a3dbcf = (collection, key)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $6HC1D.unset(collection, key);
const $56ee753086711575$export$1bfac1118aad2c2f = (collection, path, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $6HC1D.assocIn(collection, path, value);
const $56ee753086711575$export$565e6fa2e54b66b3 = (collection, path, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $6HC1D.setIn(collection, path, value);
const $56ee753086711575$export$75197f11bfe5de5f = (collection, path)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $6HC1D.getIn(collection, path);
const $56ee753086711575$export$f920b8c255ec1192 = (collection, path, callback)=>$6HC1D.updateIn(collection, path, callback);
class $56ee753086711575$var$IcepickUnsafeWrapper {
    constructor(collection){
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        this.wrapper = $6HC1D.chain(collection);
    }
    value() {
        return this.wrapper.value();
    }
    freeze() {
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.freeze().value());
    }
    assoc(key, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.assoc(key, value).value());
    }
    set(key, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.set(key, value).value());
    }
    dissoc(key) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.dissoc(key).value());
    }
    unset(key) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.unset(key).value());
    }
    assocIn(path, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.assocIn(path, value).value());
    }
    setIn(path, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.setIn(path, value).value());
    }
    getIn(path, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.getIn(path, value).value());
    }
    updateIn(path, callback) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.updateIn(path, callback).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    assign(source) {
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.assign(source).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    assign(s1, s2) {
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.assign(s1, s2).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    assign(s1, s2, s3) {
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.assign(s1, s2, s3).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    assign(s1, s2, s3, s4) {
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.assign(s1, s2, s3, s4).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    extend(source) {
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.extend(source).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    extend(s1, s2) {
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.extend(s1, s2).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    extend(s1, s2, s3) {
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.extend(s1, s2, s3).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    extend(s1, s2, s3, s4) {
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.extend(s1, s2, s3, s4).value());
    }
    merge(source) {
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.merge(source).value());
    }
    thru(val) {
        return new $56ee753086711575$var$IcepickUnsafeWrapper(this.wrapper.thru(val).value());
    }
}
const $56ee753086711575$export$181c753256d1c9a0 = (collection)=>new $56ee753086711575$var$IcepickUnsafeWrapper(collection);

});

parcelRegister("jHgZf", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac7facbf1f801fc7$export$2e2bcd8739ae039);

var $dQu14 = parcelRequire("dQu14");
const $ac7facbf1f801fc7$var$initialState = {
    operations: []
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ac7facbf1f801fc7$export$2e2bcd8739ae039 = (state = $ac7facbf1f801fc7$var$initialState, action)=>{
    if (action.type === (0, $dQu14.EXTENSION_FETCH_SUCCESS)) return action.payload.extension;
    return state;
};

});


parcelRegister("1qJOG", function(module, exports) {

$parcel$export(module.exports, "default", () => $77f5d05a9036a12b$export$2e2bcd8739ae039);

var $huRi7 = parcelRequire("huRi7");

var $iy2aZ = parcelRequire("iy2aZ");

var $bAoRt = parcelRequire("bAoRt");

var $3SXtV = parcelRequire("3SXtV");

var $9Wu2U = parcelRequire("9Wu2U");

var $346jd = parcelRequire("346jd");

var $6eZch = parcelRequire("6eZch");

var $i0r7r = parcelRequire("i0r7r");

var $h3dVA = parcelRequire("h3dVA");

var $ka3SF = parcelRequire("ka3SF");

var $dZQ6l = parcelRequire("dZQ6l");

var $8hdiY = parcelRequire("8hdiY");

var $bYp2Q = parcelRequire("bYp2Q");

var $iedB9 = parcelRequire("iedB9");

var $fCZKL = parcelRequire("fCZKL");

var $5GbYf = parcelRequire("5GbYf");

var $7VhMl = parcelRequire("7VhMl");

var $gXmnZ = parcelRequire("gXmnZ");

var $evVQC = parcelRequire("evVQC");

var $jiBsE = parcelRequire("jiBsE");

var $czRWm = parcelRequire("czRWm");
var $77f5d05a9036a12b$export$2e2bcd8739ae039 = (0, $iy2aZ.optimistic)((0, $huRi7.combineReducers)({
    card: (0, $i0r7r.default),
    cardList: (0, $3SXtV.default),
    cardListOrder: (0, $bAoRt.default),
    cardOrder: (0, $346jd.default),
    cardOrderGlobal: (0, $9Wu2U.default),
    column: (0, $h3dVA.default),
    currentUser: (0, $ka3SF.default),
    customFilters: (0, $dZQ6l.customFiltersReducer),
    cardTypes: (0, $6eZch.default),
    estimation: (0, $8hdiY.default),
    tracking: (0, $evVQC.trackingReducer),
    inlineCreate: (0, $bYp2Q.default),
    issueParents: (0, $fCZKL.default),
    issueParentsOrder: (0, $iedB9.default),
    priorities: (0, $7VhMl.default),
    project: (0, $gXmnZ.default),
    versions: (0, $czRWm.versionsReducer),
    version: (0, $jiBsE.default),
    lastCreatedCardId: (0, $5GbYf.default)
}));

});
parcelRegister("bAoRt", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b306a739e89ab21$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $7TyGu = parcelRequire("7TyGu");

var $jiL2Q = parcelRequire("jiL2Q");

var $3i20Q = parcelRequire("3i20Q");

var $cjL82 = parcelRequire("cjL82");

var $9csAN = parcelRequire("9csAN");
const $6b306a739e89ab21$var$defaultState = [];
const $6b306a739e89ab21$var$cardListOrderReducer = (state = $6b306a739e89ab21$var$defaultState, action)=>{
    switch(action.type){
        case 0, $jiL2Q.SET_APP_DATA:
            return action.payload.entities.cardListOrder;
        case 0, $3i20Q.SPRINT_CREATE_REQUEST:
            {
                const backlogIndex = state.indexOf((0, $7TyGu.BACKLOG));
                return (0, $6HC1D.splice)(state, backlogIndex, 0, action.payload.temporaryCardListId);
            }
        case 0, $3i20Q.SPRINT_CREATE_SUCCESS:
            {
                const tempIndex = state.indexOf(action.payload.temporaryCardListId);
                return (0, $6HC1D.splice)(state, tempIndex, 1, action.payload.sprint.id);
            }
        case 0, $cjL82.SPRINT_DELETE_REQUEST:
            return (0, $6HC1D.splice)(state, state.indexOf(action.payload.sprintId), 1);
        case 0, $9csAN.SPRINT_MOVE_REQUEST:
            {
                const { payload: { sprintId: sprintId, targetSprintId: targetSprintId, direction: direction } } = action;
                const sprintIndex = state.indexOf(sprintId);
                const otherSprintIndex = state.indexOf(targetSprintId);
                if (direction === (0, $7TyGu.SPRINT_MOVE_TO_TOP)) {
                    const activeSprints = state.slice(0, otherSprintIndex);
                    const inactiveSprints = state.slice(otherSprintIndex);
                    inactiveSprints.pop(); // pop the "BACKLOG" sprint
                    const sprintIndexWithinInactives = inactiveSprints.indexOf(sprintId);
                    // move sprint to the top of targetSprintId, but below active sprints
                    return [
                        ...activeSprints,
                        sprintId,
                        ...(0, $6HC1D.splice)(inactiveSprints, sprintIndexWithinInactives, 1),
                        (0, $7TyGu.BACKLOG)
                    ];
                }
                if (direction === (0, $7TyGu.SPRINT_MOVE_TO_BOTTOM)) {
                    const sprints = state;
                    sprints.pop(); // pop the "BACKLOG" sprint
                    const sprintIndexWithinSprints = sprints.indexOf(sprintId);
                    return [
                        ...(0, $6HC1D.splice)(sprints, sprintIndexWithinSprints, 1),
                        sprintId,
                        (0, $7TyGu.BACKLOG)
                    ];
                }
                return (0, $6HC1D.chain)(state).set(sprintIndex, targetSprintId).set(otherSprintIndex, sprintId).value();
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $6b306a739e89ab21$export$2e2bcd8739ae039 = $6b306a739e89ab21$var$cardListOrderReducer;

});

parcelRegister("3SXtV", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e1cb7cd62674801$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $94zjC = parcelRequire("94zjC");

var $7TyGu = parcelRequire("7TyGu");

var $jiL2Q = parcelRequire("jiL2Q");

var $3i20Q = parcelRequire("3i20Q");

var $cjL82 = parcelRequire("cjL82");

var $4jE5Q = parcelRequire("4jE5Q");
const $9e1cb7cd62674801$var$defaultState = {};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9e1cb7cd62674801$export$2e2bcd8739ae039 = (state = $9e1cb7cd62674801$var$defaultState, action)=>{
    switch(action.type){
        case 0, $jiL2Q.SET_APP_DATA:
            return action.payload.entities.cardList;
        case 0, $3i20Q.SPRINT_CREATE_REQUEST:
            return (0, $6HC1D.assign)(state, {
                [action.payload.temporaryCardListId]: {
                    id: String(action.payload.temporaryCardListId),
                    name: 'Sprint',
                    type: (0, $7TyGu.SPRINT),
                    issueListKey: null,
                    isOptimistic: true,
                    sprintData: {
                        goal: '',
                        startDate: '',
                        endDate: '',
                        daysRemaining: 0,
                        state: 'FUTURE',
                        canUpdateSprint: true
                    }
                }
            });
        case 0, $3i20Q.SPRINT_CREATE_SUCCESS:
            return (0, $94zjC.chainUnsafe)(state).set(action.payload.sprint.id, action.payload.sprint).unset(action.payload.temporaryCardListId).value();
        case 0, $cjL82.SPRINT_DELETE_REQUEST:
            return (0, $6HC1D.unset)(state, action.payload.sprintId);
        case 0, $4jE5Q.EDIT_SPRINT_REQUEST:
            return (0, $94zjC.chainUnsafe)(state).setIn([
                String(action.payload.id),
                'name'
            ], action.payload.name).setIn([
                String(action.payload.id),
                'sprintData',
                'goal'
            ], action.payload.goal).setIn([
                String(action.payload.id),
                'sprintData',
                'startDate'
            ], action.payload.startDate).setIn([
                String(action.payload.id),
                'sprintData',
                'endDate'
            ], action.payload.endDate).value();
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
parcelRegister("4jE5Q", function(module, exports) {

$parcel$export(module.exports, "EDIT_SPRINT_REQUEST", () => $6a0a195b8c1c3b74$export$123abdbc4d2e52b2);
$parcel$export(module.exports, "editSprintRequest", () => $6a0a195b8c1c3b74$export$f1ede94f3f629cd9);
$parcel$export(module.exports, "editSprintSuccess", () => $6a0a195b8c1c3b74$export$3b274a040443f185);
$parcel$export(module.exports, "editSprintFailure", () => $6a0a195b8c1c3b74$export$193b8520faf6f6b0);

var $jWq1L = parcelRequire("jWq1L");
const $6a0a195b8c1c3b74$export$123abdbc4d2e52b2 = 'state.actions.sprints.edit.EDIT_SPRINT_REQUEST';
const $6a0a195b8c1c3b74$export$f1ede94f3f629cd9 = (id, name, goal, startDate, endDate)=>({
        type: $6a0a195b8c1c3b74$export$123abdbc4d2e52b2,
        payload: {
            id: id,
            name: name,
            goal: goal,
            startDate: startDate,
            endDate: endDate
        },
        meta: (0, $jWq1L.beginOptimisticUiMeta)()
    });
const $6a0a195b8c1c3b74$export$e043c26cf23a5c18 = 'state.actions.sprints.edit.EDIT_SPRINT_SUCCESS';
const $6a0a195b8c1c3b74$export$3b274a040443f185 = (txId)=>({
        type: $6a0a195b8c1c3b74$export$e043c26cf23a5c18,
        meta: (0, $jWq1L.commitOptimisticUiMeta)(txId)
    });
const $6a0a195b8c1c3b74$export$c58baca64c75a779 = 'state.actions.sprints.edit.EDIT_SPRINT_FAILURE';
const $6a0a195b8c1c3b74$export$193b8520faf6f6b0 = (txId)=>({
        type: $6a0a195b8c1c3b74$export$c58baca64c75a779,
        meta: (0, $jWq1L.revertOptimisticUiWithFlagMeta)(txId)
    });

});


parcelRegister("9Wu2U", function(module, exports) {

$parcel$export(module.exports, "default", () => $d74b36f09871fa99$export$2e2bcd8739ae039);

var $jiL2Q = parcelRequire("jiL2Q");

var $jiig0 = parcelRequire("jiig0");

var $7Egcu = parcelRequire("7Egcu");
const $d74b36f09871fa99$var$cardOrderGlobalReducer = (state = [], action)=>{
    if (action.type === (0, $jiL2Q.SET_APP_DATA)) return action.payload.entities.cardOrderGlobal || state;
    if (action.type === (0, $jiig0.SET_CARD_ORDER_GLOBAL)) return action.payload;
    if (action.type === (0, $7Egcu.CARDS_MOVE_REQUEST)) return action.payload.newCardOrderGlobal || state;
    return state;
};
var $d74b36f09871fa99$export$2e2bcd8739ae039 = $d74b36f09871fa99$var$cardOrderGlobalReducer;

});

parcelRegister("346jd", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad413c777c033bca$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $hwbh0 = parcelRequire("hwbh0");

var $fE3Ua = parcelRequire("fE3Ua");

var $9eH8H = parcelRequire("9eH8H");

var $bHPpI = parcelRequire("bHPpI");

var $7TyGu = parcelRequire("7TyGu");

var $jiL2Q = parcelRequire("jiL2Q");

var $lsENz = parcelRequire("lsENz");

var $c4hFt = parcelRequire("c4hFt");

var $7Egcu = parcelRequire("7Egcu");

var $3i20Q = parcelRequire("3i20Q");

var $cjL82 = parcelRequire("cjL82");
const $ad413c777c033bca$var$defaultState = {};
const $ad413c777c033bca$var$getNewCardOrder = (action)=>{
    if (action.type === (0, $7Egcu.CARDS_MOVE_REQUEST)) return action.payload.newCardOrder;
    return undefined;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ad413c777c033bca$export$2e2bcd8739ae039 = (state = $ad413c777c033bca$var$defaultState, action)=>{
    switch(action.type){
        case 0, $jiL2Q.SET_APP_DATA:
            return action.payload.entities.cardOrder;
        case 0, $7Egcu.CARDS_MOVE_SET:
        case 0, $7Egcu.CARDS_MOVE_REQUEST:
            {
                const newState = (0, $6HC1D.chain)(state);
                const { payload: { cardIds: cardIds, beforeCardId: beforeCardId, afterCardId: afterCardId, cardListId: cardListId } } = action;
                const derivedCardListId = (0, $bHPpI.getCardListId)(cardListId);
                if (cardListId === String((0, $9eH8H.UNASSIGNED_EPIC_ID))) return state;
                // Remove the moved cardIds from all cardlists, to be
                // returned to their new location below
                Object.keys(state).forEach((key)=>newState.setIn([
                        key
                    ], state[key].filter((cardId)=>!cardIds.includes(cardId))));
                if ($ad413c777c033bca$var$getNewCardOrder(action)) return newState.setIn([
                    derivedCardListId
                ], $ad413c777c033bca$var$getNewCardOrder(action)).value();
                const cardIdList = newState.value()[derivedCardListId];
                const insertIndex = beforeCardId ? cardIdList.indexOf(beforeCardId) : cardIdList.indexOf(afterCardId || 0) + 1;
                newState.setIn([
                    derivedCardListId
                ], (0, $6HC1D.splice)(cardIdList, insertIndex, 0, ...cardIds));
                return newState.value();
            }
        case 0, $lsENz.CARD_CREATE_MULTIPLE_REQUEST:
            {
                const { tempIds: tempIds, listId: listId, insertBefore: insertBefore } = action.payload;
                if (!insertBefore) {
                    let updatedState = state[listId];
                    tempIds.forEach((tempId)=>{
                        updatedState = (0, $6HC1D.push)(updatedState, tempId);
                    });
                    return (0, $6HC1D.set)(state, listId, updatedState);
                }
                const insertIndex = state[listId].indexOf(insertBefore);
                return (0, $6HC1D.set)(state, listId, (0, $6HC1D.splice)(state[listId], insertIndex, 0, ...tempIds));
            }
        case 0, $lsENz.CARD_CREATE_SUCCESS:
            {
                const { card: card, listId: listId, temporaryCardId: temporaryCardId } = action.payload;
                const index = state[listId].indexOf(temporaryCardId);
                return (0, $6HC1D.setIn)(state, [
                    listId,
                    index
                ], card.id);
            }
        case 0, $c4hFt.CARD_DELETE:
        case 0, $c4hFt.CARD_DELETE_REQUEST:
            {
                const cardListIds = Object.keys(state);
                const { cardId: deletedCardId } = action.payload;
                const filteredLists = cardListIds.map((cardListId)=>state[cardListId].filter((cardId)=>cardId !== deletedCardId));
                return (0, (/*@__PURE__*/$parcel$interopDefault($hwbh0)))(cardListIds, filteredLists);
            }
        case 0, $lsENz.CARD_CREATE_UNMAPPED_WITH_ISSUE_LINK:
            {
                const cardListIds = Object.keys(state);
                const deletedCardIds = action.payload.cardsIdentifiers.map((cardIds)=>cardIds.id);
                const filteredLists = cardListIds.map((cardListId)=>state[cardListId].filter((cardId)=>!deletedCardIds.includes(cardId)));
                return (0, (/*@__PURE__*/$parcel$interopDefault($hwbh0)))(cardListIds, filteredLists);
            }
        case 0, $3i20Q.SPRINT_CREATE_REQUEST:
            return (0, $6HC1D.set)(state, action.payload.temporaryCardListId, []);
        case 0, $3i20Q.SPRINT_CREATE_SUCCESS:
            return (0, $6HC1D.chain)(state).unset(action.payload.temporaryCardListId).set(action.payload.sprint.id, []).value();
        case 0, $cjL82.SPRINT_DELETE_REQUEST:
            {
                const { payload: { nextCardListId: nextCardListId, sprintId: sprintId } } = action;
                if (!nextCardListId) return (0, $6HC1D.unset)(state, sprintId);
                return (0, $6HC1D.chain)(state).set(nextCardListId, state[sprintId].concat(state[nextCardListId])).unset(sprintId).value();
            }
        case 0, $lsENz.CARD_CREATE_END_OF_BACKLOG_OPTIMISTIC:
            {
                const { changeEvent: changeEvent } = action.payload;
                if (changeEvent.type === (0, $fE3Ua.ChangeEventTypes).CHILD_ISSUE_ADDED) {
                    const { meta: { childIssue: { id: id } } } = changeEvent;
                    return {
                        ...state,
                        [(0, $7TyGu.BACKLOG)]: [
                            ...state[0, $7TyGu.BACKLOG],
                            Number(id)
                        ]
                    };
                }
                return state;
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("6eZch", function(module, exports) {

$parcel$export(module.exports, "default", () => $4619f89f16a0e4ff$export$2e2bcd8739ae039);

var $lyOYo = parcelRequire("lyOYo");

var $jiL2Q = parcelRequire("jiL2Q");
const $4619f89f16a0e4ff$var$defaultState = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4619f89f16a0e4ff$export$2e2bcd8739ae039 = (state = $4619f89f16a0e4ff$var$defaultState, action)=>{
    switch(action.type){
        case 0, $jiL2Q.SET_APP_DATA:
            // cardTypes will not be provided in the payload for CMP
            return action.payload.entities.cardTypes || state;
        case 0, $jiL2Q.LOAD_CARD_CREATE_CONFIG_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...action.payload.cardTypes,
                ...state
            ], 'id');
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("i0r7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $e07fd506298a6c02$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $8blac = parcelRequire("8blac");

var $8Qd0L = parcelRequire("8Qd0L");

var $1dO2y = parcelRequire("1dO2y");

var $1ybV0 = parcelRequire("1ybV0");

var $fE3Ua = parcelRequire("fE3Ua");

var $jiL2Q = parcelRequire("jiL2Q");

var $emJ23 = parcelRequire("emJ23");

var $hEV2I = parcelRequire("hEV2I");

var $2giiC = parcelRequire("2giiC");

var $lsENz = parcelRequire("lsENz");

var $c4hFt = parcelRequire("c4hFt");

var $1NOG0 = parcelRequire("1NOG0");

var $7Egcu = parcelRequire("7Egcu");

var $6apxJ = parcelRequire("6apxJ");

var $64fZ9 = parcelRequire("64fZ9");

var $bxHyy = parcelRequire("bxHyy");

var $5Hc4j = parcelRequire("5Hc4j");

var $cPwLN = parcelRequire("cPwLN");

var $eYeFr = parcelRequire("eYeFr");

var $75nYE = parcelRequire("75nYE");

var $ansG8 = parcelRequire("ansG8");

var $jGaez = parcelRequire("jGaez");
const $e07fd506298a6c02$var$defaultState = {};
const $e07fd506298a6c02$var$updateCardFlags = (state, { payload: { cards: cards, flag: flag } })=>{
    const chainedState = (0, $6HC1D.chain)(state);
    cards.forEach((id)=>chainedState.assocIn([
            String(id),
            'isFlagged'
        ], flag));
    return chainedState.value();
};
const $e07fd506298a6c02$var$updateCardsParent = (state, { payload: { cards: cards, parentId: parentId } })=>{
    const chainedState = (0, $6HC1D.chain)(state);
    cards.forEach((card)=>chainedState.assocIn([
            String(card.id),
            'parentId'
        ], parentId));
    return chainedState.value();
};
const $e07fd506298a6c02$var$updateCardsDetails = (state, payload)=>{
    const chainedState = (0, $6HC1D.chain)(state);
    payload.forEach(({ cardIds: cardIds, data: data })=>{
        const dataTransformer = (0, $jGaez.transformBulkOperationsData)(data);
        cardIds.forEach((cardId)=>{
            const id = String(cardId);
            const newData = dataTransformer(state[id]);
            const newCardData = (0, $6HC1D.chain)(state[id]).assign(newData);
            chainedState.assoc(id, newCardData.value());
        });
    });
    return chainedState.value();
};
const $e07fd506298a6c02$var$updateCardsDetailsOld = (state, { payload: { cardIds: cardIds, data: data } })=>{
    const chainedState = (0, $6HC1D.chain)(state);
    const dataTransformer = (0, $jGaez.transformBulkOperationsData)(data);
    cardIds.forEach((cardId)=>{
        const id = String(cardId);
        const newData = dataTransformer(state[id]);
        const newCardData = (0, $6HC1D.chain)(state[id]).assign(newData);
        chainedState.assoc(id, newCardData.value());
    });
    return chainedState.value();
};
const $e07fd506298a6c02$var$updateMentions = (state, { payload: payload })=>{
    const chainedState = (0, $6HC1D.chain)(state);
    payload.forEach((mention)=>{
        chainedState.assocIn([
            String(mention.issueId),
            'mentions',
            'latestUnreadCommentId'
        ], mention.latestUnreadCommentId).assocIn([
            String(mention.issueId),
            'mentions',
            'hasUnreadIssueDescriptionMention'
        ], mention.hasUnreadIssueDescriptionMention);
    });
    return chainedState.value();
};
const $e07fd506298a6c02$var$clearMentions = (state, { payload: payload })=>(0, $1dO2y.default)(state, [
        String(payload.cardId),
        'mentions'
    ]);
const $e07fd506298a6c02$var$setCardStatus = (state, { payload: { cardId: cardId, statusId: statusId, statusCategory: statusCategory, isCMP: isCMP } })=>{
    const chainedState = (0, $6HC1D.chain)(state);
    chainedState.assocIn([
        String(cardId),
        'statusId'
    ], statusId);
    // We use `isDone` to show issue key strikethrough as an indicator of issue resolution.
    // Only for TMP, status' category equaling `Done` means the issue is resolved.
    // For CMP, we cannot determine an issue's resolution completely client-side due to the complexities of non-simplified workflows.
    // As we're fire a data refresh request on each issue transition for CMP, the correct `isDone` value will be pulled from the server anyway with a slight delay.
    if (!(0, $1ybV0.ff)('jsw.uif.backlog.fix-strikethrough-on-status-transition') || !isCMP) {
        const isDone = (0, $8Qd0L.StatusCategoryIds)[statusCategory] === (0, $8Qd0L.StatusCategoryIds)[(0, $8Qd0L.StatusCategoryTypes).DONE];
        chainedState.assocIn([
            String(cardId),
            'isDone'
        ], isDone);
    }
    return chainedState.value();
};
const $e07fd506298a6c02$var$setCardEstimate = (state, { payload: { cardId: cardId, estimate: estimate } })=>{
    const chainedState = (0, $6HC1D.chain)(state);
    chainedState.merge({
        [String(cardId)]: {
            estimate: estimate
        }
    });
    return chainedState.value();
};
const $e07fd506298a6c02$var$setCardAssignee = (state, { payload: { cardId: cardId, assignee: assignee } })=>{
    const chainedState = (0, $6HC1D.chain)(state);
    chainedState.assocIn([
        String(cardId),
        'assignee'
    ], assignee);
    return chainedState.value();
};
const $e07fd506298a6c02$var$setCardSummary = (state, { payload: { cardId: cardId, summary: summary } })=>{
    const chainedState = (0, $6HC1D.chain)(state);
    chainedState.assocIn([
        String(cardId),
        'summary'
    ], summary);
    return chainedState.value();
};
const $e07fd506298a6c02$var$setCardParentId = (state, { payload: { cardId: cardId, parentId: parentId } })=>{
    const chainedState = (0, $6HC1D.chain)(state);
    chainedState.assocIn([
        String(cardId),
        'parentId'
    ], parentId);
    return chainedState.value();
};
const $e07fd506298a6c02$var$setCardParent = (state, { payload: { cardId: cardId, parent: parent } })=>{
    const chainedState = (0, $6HC1D.chain)(state);
    chainedState.assocIn([
        String(cardId),
        'parentId'
    ], (parent?.id && Number(parent.id)) ?? null).assocIn([
        String(cardId),
        'parentKey'
    ], parent?.key ?? null);
    return chainedState.value();
};
const $e07fd506298a6c02$var$setCardTargetStatusId = (state, { payload: { cardIds: cardIds, targetStatusId: targetStatusId } })=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(cardIds) || targetStatusId === undefined) return state;
    const chainedState = (0, $6HC1D.chain)(state);
    cardIds.forEach((cardId)=>{
        chainedState.assocIn([
            String(cardId),
            'statusId'
        ], targetStatusId);
    });
    return chainedState.value();
};
const $e07fd506298a6c02$var$setCardPriority = (state, { payload: { cardId: cardId, priority: priority } })=>{
    const { id: id, ...cardPriority } = priority;
    const chainedState = (0, $6HC1D.chain)(state);
    chainedState.assocIn([
        String(cardId),
        'priority'
    ], cardPriority);
    return chainedState.value();
};
const $e07fd506298a6c02$var$cardReducer = (state = $e07fd506298a6c02$var$defaultState, action)=>{
    switch(action.type){
        case 0, $jiL2Q.SET_APP_DATA:
            return action.payload.entities.card;
        case 0, $lsENz.CARD_CREATE_MULTIPLE_REQUEST:
            {
                const { tempIds: tempIds, summaries: summaries, typeId: typeId, typeIcon: typeIcon } = action.payload;
                const chainState = (0, $6HC1D.chain)(state);
                const defaultCardProps = {
                    key: '',
                    labels: [],
                    assignee: null,
                    isDone: false,
                    isFlagged: false,
                    issueUrl: '',
                    statusId: '',
                    parentId: null,
                    priority: null,
                    dueDate: null,
                    estimate: null,
                    numCompleteChildren: 0,
                    numTotalChildren: 0,
                    fixVersions: []
                };
                for(let i = 0; i < tempIds.length; i += 1){
                    const tempId = tempIds[i];
                    const summary = summaries[i];
                    chainState.set(String(tempId), {
                        ...defaultCardProps,
                        summary: summary,
                        id: tempId,
                        icon: typeIcon,
                        typeId: typeId
                    });
                }
                return chainState.value();
            }
        case 0, $lsENz.CARD_CREATE_SUCCESS:
            {
                const { card: card, temporaryCardId: temporaryCardId } = action.payload;
                return (0, $6HC1D.chain)(state).unset(String(temporaryCardId)).set(String(card.id), card).value();
            }
        case 0, $7Egcu.CARDS_MOVE_REQUEST:
        case 0, $7Egcu.CARDS_MOVE_SUCCESS:
            return $e07fd506298a6c02$var$setCardTargetStatusId(state, action);
        case 0, $1NOG0.CARDS_FLAG_WITH_COMMENT_REQUEST:
            return $e07fd506298a6c02$var$updateCardFlags(state, action);
        case 0, $c4hFt.CARD_DELETE_REQUEST:
        case 0, $c4hFt.CARD_DELETE:
            return (0, $6HC1D.unset)(state, String(action.payload.cardId));
        case 0, $lsENz.CARD_CREATE_UNMAPPED_WITH_ISSUE_LINK:
            {
                const stateChain = (0, $6HC1D.chain)(state);
                action.payload.cardsIdentifiers.forEach(({ id: id })=>{
                    stateChain.unset(String(id));
                });
                return stateChain.value();
            }
        case 0, $64fZ9.CARD_REFRESH_REQUEST:
            {
                const { cardId: cardId, changeEvent: changeEvent } = action.payload;
                if (cardId == null || !changeEvent) return state;
                const cardIdStr = String(cardId);
                const oldCard = state[cardIdStr];
                if (!oldCard) // This should only happen when the updated card is a subtask which doesn't exist in the state
                return state;
                const optimisticCard = (0, $jGaez.updateCardWithChangeEvent)(oldCard, changeEvent);
                return (0, $6HC1D.set)(state, cardIdStr, optimisticCard);
            }
        case 0, $64fZ9.CARD_REFRESH_SUCCESS:
            return (0, $6HC1D.set)(state, String(action.payload.id), action.payload);
        case 0, $6apxJ.CARDS_PARENT_SET_OPTIMISTIC:
            return $e07fd506298a6c02$var$updateCardsParent(state, action);
        case 0, $lsENz.CARD_CREATE_END_OF_BACKLOG_OPTIMISTIC:
            {
                const { changeEvent: changeEvent } = action.payload;
                if (changeEvent.type === (0, $fE3Ua.ChangeEventTypes).CHILD_ISSUE_ADDED) {
                    const [cardId, newCard] = (0, $jGaez.buildCardFromEvent)(changeEvent);
                    return (0, $6HC1D.set)(state, cardId, newCard);
                }
                return state;
            }
        case 0, $75nYE.CARD_STATUS_SET:
            return $e07fd506298a6c02$var$setCardStatus(state, action);
        case 0, $bxHyy.CARD_ESTIMATE_SET_OPTIMISTIC:
        case 0, $bxHyy.CARD_ESTIMATE_SET:
            return $e07fd506298a6c02$var$setCardEstimate(state, action);
        case 0, $emJ23.CARD_ASSIGNEE_SET_OPTIMISTIC:
        case 0, $hEV2I.ASSIGN_TO_ME_REQUEST:
        case 0, $emJ23.CARD_ASSIGNEE_SET:
            return $e07fd506298a6c02$var$setCardAssignee(state, action);
        case 0, $ansG8.CARD_SUMMARY_SET:
            return $e07fd506298a6c02$var$setCardSummary(state, action);
        case 0, $cPwLN.CARD_PARENT_ID_SET:
            return $e07fd506298a6c02$var$setCardParentId(state, action);
        case 0, $cPwLN.CARD_PARENT_SET_OPTIMISTIC:
            return $e07fd506298a6c02$var$setCardParent(state, action);
        case 0, $eYeFr.CARD_PRIORITY_SET_OPTIMISTIC:
        case 0, $eYeFr.CARD_PRIORITY_SET:
            return $e07fd506298a6c02$var$setCardPriority(state, action);
        // TODO: delete this action & the function it calls on bulk-transition-multiple-workflows_wtnvv cleanup
        case 0, $2giiC.CARDS_BULK_OPERATIONS_REQUEST:
            return $e07fd506298a6c02$var$updateCardsDetailsOld(state, action);
        case 0, $2giiC.CARDS_BULK_OPERATIONS_REQUESTS:
            return $e07fd506298a6c02$var$updateCardsDetails(state, action.payload);
        case 0, $5Hc4j.MENTIONS_LOAD_SUCCESS:
            return $e07fd506298a6c02$var$updateMentions(state, action);
        case 0, $5Hc4j.CLEAR_MENTIONS_OPTIMISTIC:
            return $e07fd506298a6c02$var$clearMentions(state, action);
        default:
            return state;
    }
};
var $e07fd506298a6c02$export$2e2bcd8739ae039 = $e07fd506298a6c02$var$cardReducer;

});
parcelRegister("1dO2y", function(module, exports) {

$parcel$export(module.exports, "default", () => $427325626a31a3d6$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $427325626a31a3d6$var$unsetInSingle = (state, pathToParent, key)=>{
    if (pathToParent.length === 0) return (0, $6HC1D.unset)(state, key);
    const ret = (0, $6HC1D.updateIn)(state, pathToParent, (parent)=>parent ? (0, $6HC1D.unset)(parent, key) : undefined);
    return ret;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $427325626a31a3d6$var$unsetInMulti = (state, pathToParent, keys)=>// @ts-expect-error - TS7006 - Parameter 'folded' implicitly has an 'any' type. | TS7006 - Parameter 'subkey' implicitly has an 'any' type.
    keys.reduce((folded, subkey)=>$427325626a31a3d6$var$unsetInSingle(folded, pathToParent, subkey), state);
var //   ['a', 'b', 'c'] - removes values at 'a/b/c'
//   ['a', ['b', 'c']] - removes values at 'a/b' and 'a/c'
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$427325626a31a3d6$export$2e2bcd8739ae039 = (state, path)=>{
    if (path.length === 0) return state;
    const pathToParent = path.slice(0, path.length - 1);
    const lastPathItem = path.slice(-1)[0];
    if (Array.isArray(lastPathItem)) return $427325626a31a3d6$var$unsetInMulti(state, pathToParent, lastPathItem);
    return $427325626a31a3d6$var$unsetInSingle(state, pathToParent, lastPathItem);
};

});

parcelRegister("emJ23", function(module, exports) {

$parcel$export(module.exports, "CARD_ASSIGNEE_SET", () => $b96832b67755ed13$export$8592163118330a98);
$parcel$export(module.exports, "cardAssigneeSet", () => $b96832b67755ed13$export$6b6e5f1997c8a08c);
$parcel$export(module.exports, "CARD_ASSIGNEE_SET_OPTIMISTIC", () => $b96832b67755ed13$export$b43ad5b0028f1504);
$parcel$export(module.exports, "cardAssigneeSetOptimistic", () => $b96832b67755ed13$export$dfd208865fa6a432);

var $lO4Or = parcelRequire("lO4Or");

var $kfH46 = parcelRequire("kfH46");
const $b96832b67755ed13$export$8592163118330a98 = 'state.actions.assignee.CARD_ASSIGNEE_SET';
const $b96832b67755ed13$export$6b6e5f1997c8a08c = (cardId, assignee)=>({
        type: $b96832b67755ed13$export$8592163118330a98,
        payload: {
            cardId: cardId,
            assignee: assignee
        }
    });
const $b96832b67755ed13$export$b43ad5b0028f1504 = 'state.actions.assignee.CARD_ASSIGNEE_SET_OPTIMISTIC';
const $b96832b67755ed13$export$dfd208865fa6a432 = (payload, issueKey, analyticsEvent)=>({
        type: $b96832b67755ed13$export$b43ad5b0028f1504,
        payload: payload,
        meta: {
            ...(0, $kfH46.setCardSetMeta)({
                issueKey: issueKey,
                fieldId: (0, $lO4Or.ASSIGNEE_TYPE),
                newValue: payload.assignee,
                retryAction: ()=>$b96832b67755ed13$export$dfd208865fa6a432(payload, issueKey, analyticsEvent)
            }, analyticsEvent)
        }
    });

});

parcelRegister("bxHyy", function(module, exports) {

$parcel$export(module.exports, "CARD_ESTIMATE_SET", () => $15241ffa7d46d10e$export$3b7d1bc5ea31bea3);
$parcel$export(module.exports, "cardEstimateSet", () => $15241ffa7d46d10e$export$a8708880a95d91af);
$parcel$export(module.exports, "CARD_ESTIMATE_SET_OPTIMISTIC", () => $15241ffa7d46d10e$export$c1b2b9b852128ca2);
$parcel$export(module.exports, "cardEstimateSetOptimistic", () => $15241ffa7d46d10e$export$7f4e1182c4ce5ed4);

var $kfH46 = parcelRequire("kfH46");
const $15241ffa7d46d10e$export$3b7d1bc5ea31bea3 = 'state.actions.estimate.CARD_ESTIMATE_SET';
const $15241ffa7d46d10e$export$a8708880a95d91af = (cardId, estimate)=>({
        type: $15241ffa7d46d10e$export$3b7d1bc5ea31bea3,
        payload: {
            cardId: cardId,
            estimate: estimate
        }
    });
const $15241ffa7d46d10e$export$c1b2b9b852128ca2 = 'state.actions.estimate.CARD_ESTIMATE_SET_OPTIMISTIC';
const $15241ffa7d46d10e$export$7f4e1182c4ce5ed4 = (payload, cardSet, analyticsEvent)=>({
        type: $15241ffa7d46d10e$export$c1b2b9b852128ca2,
        payload: payload,
        meta: (0, $kfH46.setCardSetMeta)({
            issueKey: cardSet.issueKey,
            fieldId: cardSet.estimationFieldId,
            newValue: payload.estimate.originalEstimate ? {
                originalEstimate: payload.estimate.originalEstimate.valueAsText
            } : payload.estimate.storyPoints,
            retryAction: ()=>$15241ffa7d46d10e$export$7f4e1182c4ce5ed4(payload, cardSet, analyticsEvent)
        }, analyticsEvent)
    });

});

parcelRegister("cPwLN", function(module, exports) {

$parcel$export(module.exports, "CARD_PARENT_ID_SET", () => $5c65e75756b5c97e$export$765aff4d74f630ef);
$parcel$export(module.exports, "cardParentIdSet", () => $5c65e75756b5c97e$export$8e5862c35c9d4ec6);
$parcel$export(module.exports, "CARD_PARENT_SET_OPTIMISTIC", () => $5c65e75756b5c97e$export$e771cf2ac685cb14);
$parcel$export(module.exports, "cardParentSetOptimistic", () => $5c65e75756b5c97e$export$f5008334a98f6790);

var $lO4Or = parcelRequire("lO4Or");

var $kfH46 = parcelRequire("kfH46");
const $5c65e75756b5c97e$export$765aff4d74f630ef = 'state.actions.parent.CARD_PARENT_ID_SET';
const $5c65e75756b5c97e$export$8e5862c35c9d4ec6 = (cardId, parentId)=>({
        type: $5c65e75756b5c97e$export$765aff4d74f630ef,
        payload: {
            cardId: cardId,
            parentId: parentId
        }
    });
const $5c65e75756b5c97e$export$e771cf2ac685cb14 = 'state.actions.priorities.CARD_PARENT_SET_OPTIMISTIC';
const $5c65e75756b5c97e$export$f5008334a98f6790 = (payload, issueKey, analyticsEvent)=>({
        type: $5c65e75756b5c97e$export$e771cf2ac685cb14,
        payload: payload,
        meta: {
            ...(0, $kfH46.setCardSetMeta)({
                fieldId: (0, $lO4Or.PARENT_TYPE),
                issueKey: issueKey,
                newValue: payload.parent,
                retryAction: ()=>$5c65e75756b5c97e$export$f5008334a98f6790(payload, issueKey, analyticsEvent)
            }, analyticsEvent)
        }
    });

});

parcelRegister("ansG8", function(module, exports) {

$parcel$export(module.exports, "CARD_SUMMARY_SET", () => $490b4e70bb3770e7$export$447c8cffca6dd3a0);
$parcel$export(module.exports, "cardSummarySet", () => $490b4e70bb3770e7$export$4584175580349cb0);
const $490b4e70bb3770e7$export$447c8cffca6dd3a0 = 'state.actions.summary.CARD_SUMMARY_SET';
const $490b4e70bb3770e7$export$4584175580349cb0 = (cardId, summary)=>({
        type: $490b4e70bb3770e7$export$447c8cffca6dd3a0,
        payload: {
            cardId: cardId,
            summary: summary
        }
    });

});

parcelRegister("jGaez", function(module, exports) {

$parcel$export(module.exports, "updateCardWithChangeEvent", () => $4debfcb02e828653$export$55ea42a298d73e4f);
$parcel$export(module.exports, "buildCardFromEvent", () => $4debfcb02e828653$export$818d870b4da795a8);
$parcel$export(module.exports, "transformBulkOperationsData", () => $4debfcb02e828653$export$bbf3856ca410a627);
/* NOTE:
 * This module is mapping bento change events onto card updates for backlog optimistic state updates.
 * Handling is separated onto different functions to improve documentation.
 */ 
var $czx3b = parcelRequire("czx3b");

var $fE3Ua = parcelRequire("fE3Ua");

const $4debfcb02e828653$export$6232590629abe6b = (oldCard, changeEvent)=>({
        ...oldCard,
        summary: changeEvent.meta.fieldValue || ''
    });
/**
 * Apply a bento labels change event onto a card.
 * We assume that fieldValue will be an array of strings.
 */ const $4debfcb02e828653$var$updateCardWithLabelsChangeEvent = (oldCard, changeEvent)=>({
        ...oldCard,
        labels: changeEvent.meta.fieldValue
    });
const $4debfcb02e828653$var$updateCardWithParentChangeEvent = (oldCard, changeEvent)=>({
        ...oldCard,
        parentId: Number(changeEvent.meta.newParentIssueId)
    });
const $4debfcb02e828653$export$55ea42a298d73e4f = (oldCard, changeEvent)=>{
    if (changeEvent.type === (0, $fE3Ua.ChangeEventTypes).ISSUE_RELATIONSHIP_UPDATED) return $4debfcb02e828653$var$updateCardWithParentChangeEvent(oldCard, changeEvent);
    if (changeEvent.type === (0, $fE3Ua.ChangeEventTypes).FIELD_CHANGE_REQUESTED || changeEvent.type === (0, $fE3Ua.ChangeEventTypes).FIELD_CHANGED) switch(changeEvent.meta.fieldId){
        case 0, $ebc098a76317be78$export$e7cf1830fe735d1f:
            return $4debfcb02e828653$export$6232590629abe6b(oldCard, changeEvent);
        case 0, $ebc098a76317be78$export$93605f2a09aa8d26:
            return $4debfcb02e828653$var$updateCardWithLabelsChangeEvent(oldCard, changeEvent);
        default:
            return oldCard;
    }
    return oldCard;
};
const $4debfcb02e828653$export$818d870b4da795a8 = (changeEvent)=>{
    const { issueId: issueId, meta: { childIssue: { id: id, issueKey: issueKey, issueLink: issueLink, issueSummary: issueSummary, issueTypeIconUrl: issueTypeIconUrl } } } = changeEvent;
    const card = {
        id: Number(id),
        key: issueKey || '',
        statusId: '',
        issueUrl: issueLink || '',
        summary: issueSummary || '',
        icon: issueTypeIconUrl || '',
        typeId: 0,
        labels: [],
        assignee: null,
        parentId: Number(issueId),
        priority: null,
        dueDate: null,
        estimate: null,
        fixVersions: [],
        numCompleteChildren: 0,
        numTotalChildren: 0,
        isDone: false,
        isFlagged: false,
        projectId: 0
    };
    return [
        String(id),
        card
    ];
};
const $4debfcb02e828653$export$5a286d741e9c601b = (input, action, data)=>{
    if (action === 'add') {
        const filtered = data.filter((value)=>!input.includes(value));
        return [
            ...input,
            ...filtered
        ];
    }
    if (action === 'remove') return input.filter((value)=>!data.includes(value));
    if (action === 'set') return data;
    return input;
};
const $4debfcb02e828653$var$transformData = (cardData)=>(data, key)=>{
        if (key === 'labels') {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-non-null-assertion
            const { action: action, value: value } = data;
            return $4debfcb02e828653$export$5a286d741e9c601b(cardData.labels, action, value);
        }
        if (key === 'fixVersions' && cardData.fixVersions) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-non-null-assertion
            const { action: action, value: value } = data;
            return $4debfcb02e828653$export$5a286d741e9c601b(cardData.fixVersions, action, value);
        }
        return data;
    };
const $4debfcb02e828653$export$bbf3856ca410a627 = (data)=>(cardData)=>(0, (/*@__PURE__*/$parcel$interopDefault($czx3b)))(data, $4debfcb02e828653$var$transformData(cardData));

});


parcelRegister("h3dVA", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b13a59ac5e676e7$export$2e2bcd8739ae039);

var $jiL2Q = parcelRequire("jiL2Q");

var $dNkcA = parcelRequire("dNkcA");
const $2b13a59ac5e676e7$var$defaultState = null;
function $2b13a59ac5e676e7$export$2e2bcd8739ae039(state = $2b13a59ac5e676e7$var$defaultState, action) {
    switch(action.type){
        case 0, $jiL2Q.LOAD_CONFIG_DATA_MODEL_SUCCESS:
            return action.payload.columns;
        case 0, $dNkcA.SET_COLUMNS:
            return action.payload.columns;
        default:
            return state;
    }
}

});

parcelRegister("ka3SF", function(module, exports) {

$parcel$export(module.exports, "default", () => $25db432466f04de9$export$2e2bcd8739ae039);

var $lafvx = parcelRequire("lafvx");
const $25db432466f04de9$var$defaultState = null;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$25db432466f04de9$export$2e2bcd8739ae039 = (state = $25db432466f04de9$var$defaultState, action)=>{
    switch(action.type){
        case 0, $lafvx.SET_CURRENT_USER:
            return action.payload;
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("dZQ6l", function(module, exports) {

$parcel$export(module.exports, "customFiltersReducer", () => $9051fa0d376799ed$export$dbd98ee5f91df1a);

var $jiL2Q = parcelRequire("jiL2Q");

var $8vPDs = parcelRequire("8vPDs");
const $9051fa0d376799ed$var$initialState = {
    filters: []
};
function $9051fa0d376799ed$export$dbd98ee5f91df1a(state = $9051fa0d376799ed$var$initialState, action) {
    switch(action.type){
        case 0, $jiL2Q.LOAD_CONFIG_DATA_MODEL_SUCCESS:
            {
                const filters = action.payload.entities.quickFilters;
                return {
                    filters: filters
                };
            }
        case 0, $8vPDs.SET_CUSTOM_FILTERS:
            return {
                filters: action.payload
            };
        default:
            return state;
    }
}

});
parcelRegister("8vPDs", function(module, exports) {

$parcel$export(module.exports, "SET_CUSTOM_FILTERS", () => $194c5d5ba70fb146$export$6388e83e9b720843);
const $194c5d5ba70fb146$export$6388e83e9b720843 = 'state.actions.custom-filters.SET_CUSTOM_FILTERS';
function $194c5d5ba70fb146$export$5500f63fa8214463(customFilters) {
    return {
        type: $194c5d5ba70fb146$export$6388e83e9b720843,
        payload: customFilters
    };
}

});


parcelRegister("8hdiY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3557c4667a180b7$export$2e2bcd8739ae039);

var $7TyGu = parcelRequire("7TyGu");

var $jiL2Q = parcelRequire("jiL2Q");
const $b3557c4667a180b7$var$defaultState = {
    isEstimationFeatureEnabled: false,
    estimationType: (0, $7TyGu.ISSUE_COUNT),
    estimationFieldId: null,
    name: ''
};
function $b3557c4667a180b7$export$2e2bcd8739ae039(state = $b3557c4667a180b7$var$defaultState, action) {
    if (action.type === (0, $jiL2Q.SET_APP_DATA) || action.type === (0, $jiL2Q.SET_CONFIG_DATA) || action.type === (0, $jiL2Q.LOAD_CONFIG_DATA_MODEL_SUCCESS)) {
        if (!action.payload.entities.estimation) return state;
        const { isEstimationFeatureEnabled: isEstimationFeatureEnabled, estimationType: estimationType, estimationFieldId: estimationFieldId, name: name } = action.payload.entities.estimation || {};
        return {
            isEstimationFeatureEnabled: isEstimationFeatureEnabled || false,
            estimationType: estimationType || (0, $7TyGu.ISSUE_COUNT),
            estimationFieldId: estimationFieldId || null,
            name: name || ''
        };
    }
    return state;
}

});

parcelRegister("bYp2Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2b22a5c5b918401$export$2e2bcd8739ae039);

var $jiL2Q = parcelRequire("jiL2Q");

var $4sfcw = parcelRequire("4sfcw");
const $f2b22a5c5b918401$var$defaultState = {
    sessionId: undefined,
    cardTypeIds: []
};
const $f2b22a5c5b918401$var$projectReducer = (state = $f2b22a5c5b918401$var$defaultState, action)=>{
    switch(action.type){
        case 0, $jiL2Q.SET_APP_DATA:
            if (!action.payload.entities.inlineCreate?.cardTypeIds) return state;
            return {
                ...state,
                cardTypeIds: action.payload.entities.inlineCreate.cardTypeIds
            };
        case 0, $4sfcw.SET_INLINE_CREATE_SESSION_ID:
            return {
                ...state,
                sessionId: action.payload.sessionId
            };
        case 0, $4sfcw.CLEAR_INLINE_CREATE_SESSION_ID:
            return {
                ...state,
                sessionId: undefined
            };
        case 0, $jiL2Q.LOAD_CARD_CREATE_CONFIG_SUCCESS:
            return {
                ...state,
                cardTypeIds: action.payload.cardTypes.map((t)=>t.id)
            };
        default:
            return state;
    }
};
var $f2b22a5c5b918401$export$2e2bcd8739ae039 = $f2b22a5c5b918401$var$projectReducer;

});
parcelRegister("4sfcw", function(module, exports) {

$parcel$export(module.exports, "SET_INLINE_CREATE_SESSION_ID", () => $9b930c5aca68e502$export$b7afd69edc8efc16);
$parcel$export(module.exports, "setInlineCreateSessionId", () => $9b930c5aca68e502$export$69abc158578163fc);
$parcel$export(module.exports, "CLEAR_INLINE_CREATE_SESSION_ID", () => $9b930c5aca68e502$export$932498ee6899f22a);
const $9b930c5aca68e502$export$b7afd69edc8efc16 = 'state.actions.inline-create.SET_INLINE_CREATE_SESSION_ID';
const $9b930c5aca68e502$export$69abc158578163fc = ({ sessionId: sessionId })=>({
        type: $9b930c5aca68e502$export$b7afd69edc8efc16,
        payload: {
            sessionId: sessionId
        }
    });
const $9b930c5aca68e502$export$932498ee6899f22a = 'state.actions.inline-create.CLEAR_INLINE_CREATE_SESSION_ID';
const $9b930c5aca68e502$export$138f7b7b7eb9ceaa = ()=>({
        type: $9b930c5aca68e502$export$932498ee6899f22a
    });

});


parcelRegister("iedB9", function(module, exports) {

$parcel$export(module.exports, "default", () => $26add4d043e7837a$export$2e2bcd8739ae039);

var $jiL2Q = parcelRequire("jiL2Q");

var $3ZMdH = parcelRequire("3ZMdH");

var $k0iqO = parcelRequire("k0iqO");
const $26add4d043e7837a$var$defaultState = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$26add4d043e7837a$export$2e2bcd8739ae039 = (state = $26add4d043e7837a$var$defaultState, action)=>{
    switch(action.type){
        case 0, $jiL2Q.SET_APP_DATA:
            {
                const { payload: { entities: { issueParentsOrder: issueParentsOrder } } } = action;
                return issueParentsOrder || state;
            }
        case 0, $3ZMdH.ISSUE_PARENTS_CREATE_SET:
            {
                const issueParentIds = action.payload.issueParents.map((issueParent)=>issueParent.id);
                return [
                    ...state,
                    ...issueParentIds
                ];
            }
        case 0, $k0iqO.LOAD_ISSUE_PARENTS_SUCCESS:
            return action.payload.issueParents.map((issueParent)=>issueParent.id);
        default:
            return state;
    }
};

});
parcelRegister("3ZMdH", function(module, exports) {

$parcel$export(module.exports, "ISSUE_PARENTS_CREATE_SET", () => $6c6fbdeb21ac890c$export$3491dc76ca1d517c);
$parcel$export(module.exports, "issueParentsCreateSet", () => $6c6fbdeb21ac890c$export$55d568aa4e952be5);
const $6c6fbdeb21ac890c$export$3491dc76ca1d517c = 'state.actions.issue-parents.create.ISSUE_PARENTS_CREATE_SET';
const $6c6fbdeb21ac890c$export$55d568aa4e952be5 = (payload)=>({
        type: $6c6fbdeb21ac890c$export$3491dc76ca1d517c,
        payload: payload
    });

});


parcelRegister("fCZKL", function(module, exports) {

$parcel$export(module.exports, "default", () => $96325660ef1786ef$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $jiL2Q = parcelRequire("jiL2Q");

var $3ZMdH = parcelRequire("3ZMdH");

var $k0iqO = parcelRequire("k0iqO");

var $k9DSA = parcelRequire("k9DSA");
const $96325660ef1786ef$var$defaultState = {};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$96325660ef1786ef$export$2e2bcd8739ae039 = (state = $96325660ef1786ef$var$defaultState, action)=>{
    switch(action.type){
        case 0, $jiL2Q.SET_APP_DATA:
            {
                const { payload: { entities: { issueParents: issueParents } } } = action;
                return issueParents ? (0, $6HC1D.freeze)(issueParents) : state;
            }
        case 0, $3ZMdH.ISSUE_PARENTS_CREATE_SET:
        case 0, $k0iqO.LOAD_ISSUE_PARENTS_SUCCESS:
            {
                const { issueParents: issueParents } = action.payload;
                const chainedState = (0, $6HC1D.chain)(state);
                issueParents.forEach((issueParent)=>{
                    chainedState.set(String(issueParent.id), issueParent);
                });
                return chainedState.value();
            }
        case 0, $k9DSA.ISSUE_PARENT_PATCH:
            {
                const { issueParent: issueParent, id: id } = action.payload;
                const oldParent = state[id];
                if (!oldParent) return state;
                return (0, $6HC1D.set)(state, id, (0, $6HC1D.merge)(oldParent, issueParent));
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("5GbYf", function(module, exports) {

$parcel$export(module.exports, "default", () => $694fc84603c4b3ad$export$2e2bcd8739ae039);

var $lsENz = parcelRequire("lsENz");
function $694fc84603c4b3ad$export$2e2bcd8739ae039(state = null, action) {
    switch(action.type){
        case 0, $lsENz.CARD_CREATE_SUCCESS:
            return action.payload.card.id;
        default:
            return state;
    }
}

});

parcelRegister("7VhMl", function(module, exports) {

$parcel$export(module.exports, "default", () => $21be4e30a0bbf0cc$export$2e2bcd8739ae039);

var $eYeFr = parcelRequire("eYeFr");
const $21be4e30a0bbf0cc$var$defaultState = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$21be4e30a0bbf0cc$export$2e2bcd8739ae039 = (state = $21be4e30a0bbf0cc$var$defaultState, action)=>{
    switch(action.type){
        case 0, $eYeFr.LOAD_PRIORITIES_SUCCESS:
            return action.payload;
        default:
            return state;
    }
};

});

parcelRegister("gXmnZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f95cccbe31860f8$export$2e2bcd8739ae039);

var $jiL2Q = parcelRequire("jiL2Q");
const $7f95cccbe31860f8$var$defaultState = {
    projects: []
};
const $7f95cccbe31860f8$var$projectReducer = (state = $7f95cccbe31860f8$var$defaultState, action)=>{
    switch(action.type){
        case 0, $jiL2Q.SET_APP_DATA:
            return action.payload.entities.project ?? $7f95cccbe31860f8$var$defaultState;
        default:
            return state;
    }
};
var $7f95cccbe31860f8$export$2e2bcd8739ae039 = $7f95cccbe31860f8$var$projectReducer;

});

parcelRegister("evVQC", function(module, exports) {

$parcel$export(module.exports, "trackingReducer", () => $727cf650e0b4b047$export$9dc75892c8308f9d);

var $8blac = parcelRequire("8blac");

var $jiL2Q = parcelRequire("jiL2Q");
const $727cf650e0b4b047$var$defaultState = {
    name: '',
    typeId: '',
    fieldId: '',
    isValid: false,
    isEnabled: false
};
const $727cf650e0b4b047$export$9dc75892c8308f9d = (state = $727cf650e0b4b047$var$defaultState, action)=>{
    if (action.type === (0, $jiL2Q.LOAD_CONFIG_DATA_MODEL_SUCCESS)) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(action?.payload?.entities?.tracking)) return state;
        return action.payload.entities.tracking;
    }
    return state;
};

});

parcelRegister("jiBsE", function(module, exports) {

$parcel$export(module.exports, "default", () => $836afc42274d88e1$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $jiL2Q = parcelRequire("jiL2Q");

var $6iBIZ = parcelRequire("6iBIZ");
const $836afc42274d88e1$var$defaultState = {
    versions: []
};
const $836afc42274d88e1$var$versionReducer = (state = $836afc42274d88e1$var$defaultState, action)=>{
    switch(action.type){
        case 0, $jiL2Q.SET_APP_DATA:
            return action.payload.entities.version;
        case 0, $6iBIZ.SET_VERSIONS:
            return action.payload;
        case 0, $6iBIZ.UPDATE_VERSION:
            if (state.versions.includes(String(action.payload.version.id))) return state;
            return (0, $6HC1D.chain)(state).setIn([
                'versions'
            ], (0, $6HC1D.push)(state.versions, String(action.payload.version.id))).value();
        default:
            {
                // @ts-expect-error - TS2322: Type 'BatchAction | ShowErrorFlagAction | InitializeAppPropsAction | LoadAppDataAction | LoadAppDataFailureAction | ... 173 more ... | SetIncludeSubtasksAction' is not assignable to type 'never'.
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $836afc42274d88e1$export$2e2bcd8739ae039 = $836afc42274d88e1$var$versionReducer;

});

parcelRegister("czRWm", function(module, exports) {

$parcel$export(module.exports, "versionsReducer", () => $8a3440d191c3eae5$export$3616d11dc800f8ee);

var $6HC1D = parcelRequire("6HC1D");

var $jiL2Q = parcelRequire("jiL2Q");

var $6iBIZ = parcelRequire("6iBIZ");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $8a3440d191c3eae5$var$defaultState = (0, $6HC1D.freeze)({});
const $8a3440d191c3eae5$export$3616d11dc800f8ee = (state = $8a3440d191c3eae5$var$defaultState, action)=>{
    switch(action.type){
        case 0, $jiL2Q.SET_APP_DATA:
            return action.payload.entities.versions ? (0, $6HC1D.freeze)(action.payload.entities.versions) : state;
        case 0, $6iBIZ.UPDATE_VERSION:
            return (0, $6HC1D.chain)(state).setIn([
                String(action.payload.version.id)
            ], action.payload.version).value();
        default:
            return state;
    }
};

});


parcelRegister("c7xMS", function(module, exports) {

$parcel$export(module.exports, "default", () => $36a0b7b95cb0f08c$export$2e2bcd8739ae039);

var $huRi7 = parcelRequire("huRi7");

var $iF5A5 = parcelRequire("iF5A5");

var $1elmL = parcelRequire("1elmL");

var $djFzA = parcelRequire("djFzA");

var $XfPO5 = parcelRequire("XfPO5");

var $7q80r = parcelRequire("7q80r");

var $ckJzn = parcelRequire("ckJzn");

var $lm2cV = parcelRequire("lm2cV");

var $aeRdy = parcelRequire("aeRdy");

var $gwjXJ = parcelRequire("gwjXJ");

var $gVmbo = parcelRequire("gVmbo");

var $1jDgG = parcelRequire("1jDgG");

var $i6rNA = parcelRequire("i6rNA");
var $36a0b7b95cb0f08c$export$2e2bcd8739ae039 = (0, $huRi7.combineReducers)({
    boardIssueMoveDialog: (0, $iF5A5.default),
    cardList: (0, $1elmL.default),
    cards: (0, $djFzA.default),
    detailView: (0, $XfPO5.detailViewReducer),
    issueTransitionModal: (0, $gwjXJ.default),
    filters: (0, $ckJzn.default),
    panels: (0, $1jDgG.default),
    isConfigLoaded: (0, $lm2cV.default),
    isCriticalDataLoaded: (0, $aeRdy.default),
    modals: (0, $gVmbo.modalsReducer),
    drag: (0, $7q80r.default),
    workloadModal: (0, $i6rNA.default)
});

});
parcelRegister("iF5A5", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a9f830eda2e5e2d$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $jgHdr = parcelRequire("jgHdr");
const $9a9f830eda2e5e2d$var$closedState = (0, $6HC1D.freeze)({
    isOpen: false
});
const $9a9f830eda2e5e2d$var$openState = (0, $6HC1D.freeze)({
    isOpen: true
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9a9f830eda2e5e2d$export$2e2bcd8739ae039 = (state = $9a9f830eda2e5e2d$var$closedState, action)=>{
    switch(action.type){
        case 0, $jgHdr.BOARD_ISSUE_MOVE_SHOW:
            return $9a9f830eda2e5e2d$var$openState;
        case 0, $jgHdr.BOARD_ISSUE_MOVE_CANCEL:
            return $9a9f830eda2e5e2d$var$closedState;
        case 0, $jgHdr.BOARD_ISSUE_MOVE_EXECUTE:
            return $9a9f830eda2e5e2d$var$closedState;
        default:
            return state;
    }
};

});

parcelRegister("1elmL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a485ba79483cb1ff$export$2e2bcd8739ae039);

var $kFGm5 = parcelRequire("kFGm5");

var $hwbh0 = parcelRequire("hwbh0");

var $7TN4i = parcelRequire("7TN4i");

var $3i20Q = parcelRequire("3i20Q");
const $a485ba79483cb1ff$var$defaultState = {
    collapsed: {},
    disabled: {},
    recentCreatedId: undefined,
    dragState: {},
    isDragging: false,
    isDraggingSubtask: false,
    cardGroupCollapsed: {},
    cardGroupExpanded: {}
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a485ba79483cb1ff$export$2e2bcd8739ae039 = (state = $a485ba79483cb1ff$var$defaultState, action)=>{
    switch(action.type){
        case 0, $7TN4i.CARD_LIST_TOGGLE:
            {
                const { cardListId: cardListId } = action.payload;
                if (state.collapsed[cardListId]) return {
                    ...state,
                    collapsed: (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(state.collapsed, cardListId)
                };
                return {
                    ...state,
                    collapsed: {
                        ...state.collapsed,
                        [cardListId]: true
                    }
                };
            }
        case 0, $7TN4i.SET_COLLAPSED_CARD_LIST:
            return {
                ...state,
                collapsed: (0, (/*@__PURE__*/$parcel$interopDefault($hwbh0)))(action.payload.cardListIds, Array(action.payload.cardListIds.length).fill(true))
            };
        case 0, $7TN4i.CARD_LISTS_DISABLE:
            {
                const newDisabled = action.payload.cardListIds.reduce(// eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                (disabled, cardListId)=>({
                        ...disabled,
                        [cardListId]: true
                    }), {
                    ...state.disabled
                });
                return {
                    ...state,
                    disabled: newDisabled
                };
            }
        case 0, $7TN4i.CARD_LISTS_ENABLE_ALL:
            return {
                ...state,
                disabled: {}
            };
        case 0, $3i20Q.SPRINT_CREATE_SUCCESS:
            {
                const { payload: { sprint: { id: id } } } = action;
                return {
                    ...state,
                    recentCreatedId: id
                };
            }
        case 0, $7TN4i.CARD_LIST_DRAG_START:
            {
                const newDragInProgress = action.payload.cardListIds.reduce((dragInProgress, cardListId)=>Object.assign(dragInProgress, {
                        [cardListId]: cardListId === action.payload.sourceCardListId
                    }), {
                    ...state.dragState
                });
                return {
                    ...state,
                    dragState: newDragInProgress,
                    isDragging: true,
                    isDraggingSubtask: action.payload.sourceCardGroupId !== undefined
                };
            }
        case 0, $7TN4i.CARD_LIST_DRAG_END:
            return {
                ...state,
                dragState: {},
                isDragging: false,
                isDraggingSubtask: false
            };
        case 0, $7TN4i.CARD_GROUP_TOGGLE:
            {
                const { parentId: parentId } = action.payload;
                if (state.cardGroupExpanded[parentId]) return {
                    ...state,
                    cardGroupExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(state.cardGroupExpanded, parentId)
                };
                return {
                    ...state,
                    cardGroupExpanded: {
                        ...state.cardGroupExpanded,
                        [parentId]: true
                    }
                };
            }
        case 0, $7TN4i.SET_COLLAPSED_CARD_GROUP:
            return {
                ...state,
                cardGroupCollapsed: (0, (/*@__PURE__*/$parcel$interopDefault($hwbh0)))(action.payload.parentIds, Array(action.payload.parentIds.length).fill(true))
            };
        case 0, $7TN4i.CLEAR_COLLAPSED_CARD_GROUP:
            {
                const { parentId: parentId } = action.payload;
                return {
                    ...state,
                    cardGroupCollapsed: (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(state.cardGroupCollapsed, parentId)
                };
            }
        case 0, $7TN4i.SET_EXPANDED_CARD_GROUP:
            {
                const expandedCardGroup = [
                    ...Object.keys(state.cardGroupExpanded),
                    ...action.payload.parentIds
                ];
                return {
                    ...state,
                    cardGroupExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($hwbh0)))(expandedCardGroup, Array(expandedCardGroup.length).fill(true))
                };
            }
        case 0, $7TN4i.CLEAR_EXPANDED_CARD_GROUP:
            {
                const { parentId: parentId } = action.payload;
                return {
                    ...state,
                    cardGroupExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(state.cardGroupExpanded, parentId)
                };
            }
        case 0, $7TN4i.COLLAPSE_ALL_CARD_GROUPS:
            return {
                ...state,
                cardGroupExpanded: {}
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("djFzA", function(module, exports) {

$parcel$export(module.exports, "default", () => $b37d1ec3a21c3335$export$2e2bcd8739ae039);

var $huRi7 = parcelRequire("huRi7");

var $2NI0a = parcelRequire("2NI0a");

var $laRB5 = parcelRequire("laRB5");

var $6WroX = parcelRequire("6WroX");

var $4bNRx = parcelRequire("4bNRx");

var $bvnyl = parcelRequire("bvnyl");

var $5hWul = parcelRequire("5hWul");

var $jHROC = parcelRequire("jHROC");

var $ksctM = parcelRequire("ksctM");

var $6lCmD = parcelRequire("6lCmD");
var $b37d1ec3a21c3335$export$2e2bcd8739ae039 = (0, $huRi7.combineReducers)({
    richCard: (0, $ksctM.richCardReducer),
    selected: (0, $6lCmD.selectedReducer),
    lastSelectedCardKey: (0, $5hWul.lastSelectedCardKeyReducer),
    listSelectionRelativeCard: (0, $jHROC.listSelectionRelativeCardReducer),
    focused: (0, $bvnyl.focusedReducer),
    filteredCards: (0, $4bNRx.filteredCardsReducer),
    fields: (0, $6WroX.fieldsReducer),
    isCheckboxSelectionMode: (0, $laRB5.checkboxSelectionModeReducer),
    autoScroll: (0, $2NI0a.cardAutoScrollReducer)
});

});
parcelRegister("2NI0a", function(module, exports) {

$parcel$export(module.exports, "cardAutoScrollReducer", () => $0a28d1c1c4336402$export$d9b2c10f6d8f7f96);

var $fB0vk = parcelRequire("fB0vk");
const $0a28d1c1c4336402$var$initialAutoScrollState = {
    cardId: null
};
const $0a28d1c1c4336402$export$d9b2c10f6d8f7f96 = (state = $0a28d1c1c4336402$var$initialAutoScrollState, action)=>{
    if (action.type === (0, $fB0vk.CARD_AUTO_SCROLL)) return {
        cardId: action.payload.cardId
    };
    return state;
};

});

parcelRegister("laRB5", function(module, exports) {

$parcel$export(module.exports, "checkboxSelectionModeReducer", () => $7a06ea09cc8a9214$export$23fed535413aadfa);

var $8YxIx = parcelRequire("8YxIx");
const $7a06ea09cc8a9214$var$initialState = false;
const $7a06ea09cc8a9214$export$23fed535413aadfa = (state = $7a06ea09cc8a9214$var$initialState, action)=>{
    if (action.type === (0, $8YxIx.CHECKBOX_SELECTION_MODE)) return action.payload.isCheckboxSelectionMode;
    return state;
};

});

parcelRegister("6WroX", function(module, exports) {

$parcel$export(module.exports, "fieldsReducer", () => $4ea11783fd8a2b36$export$570db622a488cbe7);

var $lG1Gj = parcelRequire("lG1Gj");
const $4ea11783fd8a2b36$var$initialState = {
    isStatusFieldsHidden: false,
    isVersionFieldsHidden: false,
    isEpicFieldsHidden: false
};
const $4ea11783fd8a2b36$export$570db622a488cbe7 = (state = $4ea11783fd8a2b36$var$initialState, action)=>{
    if (action.type === (0, $lG1Gj.TOGGLE_STATUS_FIELDS)) return {
        ...state,
        isStatusFieldsHidden: action.payload.hideStatusFields
    };
    if (action.type === (0, $lG1Gj.TOGGLE_VERSION_FIELDS)) return {
        ...state,
        isVersionFieldsHidden: action.payload.hideVersionFields
    };
    if (action.type === (0, $lG1Gj.TOGGLE_EPIC_FIELDS)) return {
        ...state,
        isEpicFieldsHidden: action.payload.hideEpicFields
    };
    return state;
};

});
parcelRegister("lG1Gj", function(module, exports) {

$parcel$export(module.exports, "TOGGLE_STATUS_FIELDS", () => $a8e0436fc5ce2550$export$4dd62b8143c11245);
$parcel$export(module.exports, "toggleCardStatusFields", () => $a8e0436fc5ce2550$export$8c139077a3243812);
$parcel$export(module.exports, "TOGGLE_VERSION_FIELDS", () => $a8e0436fc5ce2550$export$afb58370a9942348);
$parcel$export(module.exports, "toggleCardVersionFields", () => $a8e0436fc5ce2550$export$2f4945efdaceca5a);
$parcel$export(module.exports, "TOGGLE_EPIC_FIELDS", () => $a8e0436fc5ce2550$export$b480e0a6893627bb);
$parcel$export(module.exports, "toggleCardEpicFields", () => $a8e0436fc5ce2550$export$f47236aa9e8486c);
const $a8e0436fc5ce2550$export$4dd62b8143c11245 = 'state.actions.cards.fields.TOGGLE_STATUS_FIELDS';
const $a8e0436fc5ce2550$export$8c139077a3243812 = (hideStatusFields)=>({
        type: $a8e0436fc5ce2550$export$4dd62b8143c11245,
        payload: {
            hideStatusFields: hideStatusFields
        }
    });
const $a8e0436fc5ce2550$export$afb58370a9942348 = 'state.actions.cards.fields.TOGGLE_VERSION_FIELDS';
const $a8e0436fc5ce2550$export$2f4945efdaceca5a = (hideVersionFields)=>({
        type: $a8e0436fc5ce2550$export$afb58370a9942348,
        payload: {
            hideVersionFields: hideVersionFields
        }
    });
const $a8e0436fc5ce2550$export$b480e0a6893627bb = 'state.actions.cards.fields.TOGGLE_EPIC_FIELDS';
const $a8e0436fc5ce2550$export$f47236aa9e8486c = (hideEpicFields)=>({
        type: $a8e0436fc5ce2550$export$b480e0a6893627bb,
        payload: {
            hideEpicFields: hideEpicFields
        }
    });

});


parcelRegister("4bNRx", function(module, exports) {

$parcel$export(module.exports, "filteredCardsReducer", () => $07b4e796af163a5d$export$a42af41a01ab9b7a);

var $jiL2Q = parcelRequire("jiL2Q");

var $lsENz = parcelRequire("lsENz");

var $5awap = parcelRequire("5awap");
const $07b4e796af163a5d$export$d4c72bab9d6cc13a = {
    isLoading: false,
    filteredCardsIds: null
};
const $07b4e796af163a5d$export$a42af41a01ab9b7a = (state = $07b4e796af163a5d$export$d4c72bab9d6cc13a, action)=>{
    if (action.type === (0, $jiL2Q.SET_APP_DATA)) return action.payload.ui?.cards?.filteredCards ? action.payload.ui.cards.filteredCards : state;
    if (action.type === (0, $5awap.FILTERED_CARD_REQUEST) || action.type === (0, $5awap.FILTERED_CARD_CLEAR_REQUEST)) return {
        ...state,
        isLoading: true
    };
    if (action.type === (0, $5awap.FILTERED_CARD_SUCCESS)) return {
        isLoading: false,
        filteredCardsIds: new Set(action.payload)
    };
    if (action.type === (0, $5awap.FILTERED_CARD_CLEAR_FAILURE)) return {
        ...state,
        isLoading: false
    };
    if (action.type === (0, $5awap.FILTERED_CARD_CLEAR) || action.type === (0, $5awap.FILTERED_CARD_CLEAR_SUCCESS) || action.type === (0, $5awap.FILTERED_CARD_FAILURE)) return $07b4e796af163a5d$export$d4c72bab9d6cc13a;
    if (action.type === (0, $5awap.REFILTER_SUCCESS)) {
        const { excludedCardIds: excludedCardIds, filteredCardIds: filteredCardIds } = action.payload;
        const updatedFilteredCardIds = new Set([
            ...state.filteredCardsIds || [],
            ...filteredCardIds
        ]);
        excludedCardIds.forEach((cardId)=>updatedFilteredCardIds.delete(cardId)); // delete is faster than filtering on state
        return {
            isLoading: false,
            filteredCardsIds: updatedFilteredCardIds
        };
    }
    if (action.type === (0, $lsENz.CARD_CREATE_SUCCESS)) {
        const { card: card } = action.payload;
        if (card?.hidden) return state;
        const updatedFilteredCardIds = new Set([
            ...state.filteredCardsIds || [],
            String(card.id)
        ]);
        return {
            isLoading: false,
            filteredCardsIds: updatedFilteredCardIds
        };
    }
    return state;
};

});

parcelRegister("bvnyl", function(module, exports) {

$parcel$export(module.exports, "focusedReducer", () => $98751e7ada02a518$export$d95915a76998fdf);

var $7GTNy = parcelRequire("7GTNy");
const $98751e7ada02a518$var$initialState = null;
const $98751e7ada02a518$export$d95915a76998fdf = (state = $98751e7ada02a518$var$initialState, action)=>{
    if (action.type === (0, $7GTNy.CARD_FOCUS)) return action.payload.cardId;
    if (action.type === (0, $7GTNy.CARD_BLUR)) return null;
    return state;
};

});

parcelRegister("5hWul", function(module, exports) {

$parcel$export(module.exports, "lastSelectedCardKeyReducer", () => $f64f5582f86c79b0$export$9db40db2e7ad7222);

var $1HfeQ = parcelRequire("1HfeQ");
const $f64f5582f86c79b0$var$initialState = '';
const $f64f5582f86c79b0$export$9db40db2e7ad7222 = (state = $f64f5582f86c79b0$var$initialState, action)=>{
    if (action.type === (0, $1HfeQ.SET_LAST_SELECTED_CARD_KEY)) {
        const { cardKey: cardKey } = action.payload;
        return cardKey;
    }
    return state;
};

});

parcelRegister("jHROC", function(module, exports) {

$parcel$export(module.exports, "listSelectionRelativeCardReducer", () => $45a8d099846c08de$export$4c9c80b017b58fa6);

var $1HfeQ = parcelRequire("1HfeQ");
const $45a8d099846c08de$var$initialState = null;
const $45a8d099846c08de$export$4c9c80b017b58fa6 = (state = $45a8d099846c08de$var$initialState, action)=>{
    if (action.type === (0, $1HfeQ.CARD_SINGLE_SELECT)) {
        const { cardId: cardId } = action.payload;
        return cardId;
    }
    if (action.type === (0, $1HfeQ.CARD_TOGGLE_SELECTION)) {
        const { cardId: cardId } = action.payload;
        return cardId;
    }
    if (action.type === (0, $1HfeQ.CARD_EMPTY_SELECTION) || action.type === (0, $1HfeQ.CARD_CLEAR_RELATIVE_CARD)) return null;
    return state;
};

});

parcelRegister("ksctM", function(module, exports) {

$parcel$export(module.exports, "richCardReducer", () => $199f6ace16cec3f3$export$a3aea80312727ab4);

var $59CKH = parcelRequire("59CKH");
const $199f6ace16cec3f3$export$d4c72bab9d6cc13a = {
    mainActiveCard: null,
    cardIdWithAboveIccOpen: null
};
const $199f6ace16cec3f3$export$a3aea80312727ab4 = (state, action)=>{
    switch(action.type){
        case 0, $59CKH.SET_RICH_ACTIVE_CARD:
            return {
                ...state || $199f6ace16cec3f3$export$d4c72bab9d6cc13a,
                mainActiveCard: action.payload.cardId
            };
        case 0, $59CKH.SET_CARD_ID_WITH_ABOVE_ICC_OPEN:
            return {
                ...state || $199f6ace16cec3f3$export$d4c72bab9d6cc13a,
                cardIdWithAboveIccOpen: action.payload.cardId
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state || $199f6ace16cec3f3$export$d4c72bab9d6cc13a;
            }
    }
};

});

parcelRegister("6lCmD", function(module, exports) {

$parcel$export(module.exports, "selectedReducer", () => $4faa4552ce66a64b$export$7c705be79fc8c698);

var $6HC1D = parcelRequire("6HC1D");

var $c4hFt = parcelRequire("c4hFt");

var $1HfeQ = parcelRequire("1HfeQ");
const $4faa4552ce66a64b$var$initialState = (0, $6HC1D.freeze)([]);
const $4faa4552ce66a64b$export$7c705be79fc8c698 = (state = $4faa4552ce66a64b$var$initialState, action)=>{
    if (action.type === (0, $1HfeQ.CARD_TOGGLE_SELECTION)) {
        const { cardId: cardId } = action.payload;
        const selectedCardIndex = state.indexOf(cardId);
        return selectedCardIndex === -1 ? (0, $6HC1D.push)(state, cardId) : (0, $6HC1D.splice)(state, selectedCardIndex, 1);
    }
    if (action.type === (0, $1HfeQ.CARD_SINGLE_SELECT)) {
        const { cardId: cardId } = action.payload;
        return [
            cardId
        ];
    }
    if (action.type === (0, $1HfeQ.CARD_MULTI_SELECT)) return action.payload.cardIds;
    if (action.type === (0, $1HfeQ.CARD_EMPTY_SELECTION)) return $4faa4552ce66a64b$var$initialState;
    if (action.type === (0, $c4hFt.CARD_DELETE_REQUEST) || action.type === (0, $c4hFt.CARD_DELETE)) {
        const { cardId: deletedCardId } = action.payload;
        return state.filter((cardId)=>cardId !== deletedCardId);
    }
    if (action.type === (0, $1HfeQ.CARD_MULTI_SELECT_EXTEND)) {
        const { cardIds: cardIds } = action.payload;
        return [
            ...new Set([
                ...state,
                ...cardIds
            ])
        ];
    }
    if (action.type === (0, $1HfeQ.CARD_MULTI_REMOVE)) {
        const { cardIds: cardIds } = action.payload;
        return state.filter((cardId)=>!cardIds.includes(cardId));
    }
    return state;
};

});


parcelRegister("XfPO5", function(module, exports) {

$parcel$export(module.exports, "detailViewReducer", () => $8fd32c30dcad8b45$export$574c967e85ca2750);

var $c4hFt = parcelRequire("c4hFt");

var $K2SiM = parcelRequire("K2SiM");
const $8fd32c30dcad8b45$export$574c967e85ca2750 = (state = null, action)=>{
    switch(action.type){
        case 0, $K2SiM.OPEN_DETAIL_VIEW:
            if (!state || action.payload.cardId !== state.cardId) return {
                timestamp: state ? state.timestamp : Date.now(),
                cardId: action.payload.cardId,
                externalAction: action.payload.externalAction,
                analyticsMetadata: action.payload.analyticsMetadata
            };
            return state;
        case 0, $K2SiM.UPDATE_DETAIL_VIEW:
            return state ? {
                cardId: state.cardId,
                timestamp: Date.now()
            } : null;
        case 0, $K2SiM.CLOSE_DETAIL_VIEW:
            return null;
        case 0, $c4hFt.CARD_DELETE_REQUEST:
            if (state && state.cardId === action.payload.cardId) return null;
            return state;
        default:
            return state;
    }
};

});

parcelRegister("7q80r", function(module, exports) {

$parcel$export(module.exports, "default", () => $28e0a781452b647d$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $hzOcT = parcelRequire("hzOcT");
const $28e0a781452b647d$var$initialState = {
    isDragging: false,
    isSubtask: false,
    isOverTransitionZone: false,
    sourceCardGroupType: '',
    sourceCardListId: '',
    sourceParentId: undefined
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$28e0a781452b647d$export$2e2bcd8739ae039 = (state = $28e0a781452b647d$var$initialState, action)=>{
    switch(action.type){
        case 0, $hzOcT.DRAG_START:
            return (0, $6HC1D.setIn)(state, [
                'isDragging'
            ], true);
        case 0, $hzOcT.DRAG_END:
            return (0, $6HC1D.setIn)(state, [
                'isDragging'
            ], false);
        case 0, $hzOcT.TRANSITION_ZONE_ENTER:
            return (0, $6HC1D.setIn)(state, [
                'isOverTransitionZone'
            ], true);
        case 0, $hzOcT.TRANSITION_ZONE_LEAVE:
            return (0, $6HC1D.setIn)(state, [
                'isOverTransitionZone'
            ], false);
        case 0, $hzOcT.BEFORE_CAPTURE:
            return {
                ...state,
                sourceCardGroupType: action.payload.sourceCardGroupType,
                sourceCardListId: action.payload.sourceCardListId,
                isSubtask: action.payload.isSubtask,
                sourceParentId: action.payload.sourceParentId
            };
        default:
            return state;
    }
};

});

parcelRegister("ckJzn", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1228a264a99fa10$export$2e2bcd8739ae039);

var $jAbil = parcelRequire("jAbil");
const $e1228a264a99fa10$var$initialState = {};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e1228a264a99fa10$export$2e2bcd8739ae039 = (state = $e1228a264a99fa10$var$initialState, action)=>{
    if (action.type === (0, $jAbil.SET_ALL_FILTERS)) return action.payload.filters;
    return state;
};

});

parcelRegister("lm2cV", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e7758434430f1c3$export$2e2bcd8739ae039);

var $jiL2Q = parcelRequire("jiL2Q");
function $6e7758434430f1c3$export$2e2bcd8739ae039(state = false, action) {
    switch(action.type){
        case 0, $jiL2Q.LOAD_CONFIG_DATA_MODEL_SUCCESS:
            return true;
        case 0, $jiL2Q.SET_CONFIG_DATA:
            return true;
        default:
            return state;
    }
}

});

parcelRegister("aeRdy", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe058afb4425c415$export$2e2bcd8739ae039);

var $jiL2Q = parcelRequire("jiL2Q");
function $fe058afb4425c415$export$2e2bcd8739ae039(state = false, action) {
    switch(action.type){
        case 0, $jiL2Q.SET_APP_DATA:
            return true;
        default:
            return state;
    }
}

});

parcelRegister("gwjXJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c16357138c4381b$export$2e2bcd8739ae039);

var $eISgW = parcelRequire("eISgW");
const $1c16357138c4381b$var$defaultState = {
    isOpen: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1c16357138c4381b$export$2e2bcd8739ae039 = (state = $1c16357138c4381b$var$defaultState, action)=>{
    if (action.type === (0, $eISgW.OPEN_ISSUE_TRANSITION_MODAL)) return {
        isOpen: true,
        ...action.payload
    };
    if (action.type === (0, $eISgW.CLOSE_ISSUE_TRANSITION_MODAL)) return {
        isOpen: false
    };
    return state;
};

});

parcelRegister("gVmbo", function(module, exports) {

$parcel$export(module.exports, "modalsReducer", () => $a746c49b3ae3c02f$export$c732e1f962e199dd);

var $cbRhO = parcelRequire("cbRhO");
const $a746c49b3ae3c02f$export$c732e1f962e199dd = (state = null, action)=>{
    switch(action.type){
        case 0, $cbRhO.OPEN_MODAL:
            return action.payload;
        case 0, $cbRhO.CLOSE_MODAL:
            return null;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("1jDgG", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f3af38af3a9130c$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");


var $ee93g = parcelRequire("ee93g");

var $a9os4 = parcelRequire("a9os4");
const $5f3af38af3a9130c$var$initialState = ()=>({
        [(0, $d36e2c37d06c83ff$export$a10c132b86ae798b)]: (0, $ee93g.isIssueParentPanelOpen)(),
        [(0, $d36e2c37d06c83ff$export$41073ac826c57195)]: (0, $ee93g.isVersionPanelOpen)(),
        [(0, $d36e2c37d06c83ff$export$29d7f2210b16d662)]: (0, $ee93g.isInsightsPanelOpen)(),
        [(0, $d36e2c37d06c83ff$export$ba1da943283b9900)]: false
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5f3af38af3a9130c$export$2e2bcd8739ae039 = (state = $5f3af38af3a9130c$var$initialState(), action)=>{
    switch(action.type){
        case 0, $a9os4.TOGGLE_PANEL:
            {
                const { payload: { panel: panel } } = action;
                return state[panel] === true ? (0, $6HC1D.unset)(state, panel) : (0, $6HC1D.chain)(state).set(panel, true).value();
            }
        case 0, $a9os4.CLOSE_INSIGHTS_PANEL:
            return (0, $6HC1D.unset)(state, (0, $d36e2c37d06c83ff$export$29d7f2210b16d662));
        case 0, $a9os4.CLOSE_VIEW_SETTINGS_PANEL:
            return (0, $6HC1D.unset)(state, (0, $d36e2c37d06c83ff$export$ba1da943283b9900));
        case 0, $a9os4.SET_ALL_PANELS_SUCCESS:
            return action.payload.panels;
        default:
            return state;
    }
};

});

parcelRegister("i6rNA", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7f60966ac68b156$export$2e2bcd8739ae039);

var $bDGeR = parcelRequire("bDGeR");
const $e7f60966ac68b156$var$initialState = {
    includeSubtasks: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e7f60966ac68b156$export$2e2bcd8739ae039 = (state = $e7f60966ac68b156$var$initialState, action)=>{
    switch(action.type){
        case 0, $bDGeR.TOGGLE_INCLUDE_SUBTASKS:
            return {
                includeSubtasks: !state.includeSubtasks
            };
        case 0, $bDGeR.SET_INCLUDE_SUBTASKS:
            return {
                includeSubtasks: action.payload.includeSubtasks
            };
        default:
            return state;
    }
};

});




parcelRegister("bLaT7", function(module, exports) {

$parcel$export(module.exports, "default", () => $63dd7eb944408bd1$export$2e2bcd8739ae039);

var $c8Guq = parcelRequire("c8Guq");

var $5iWql = parcelRequire("5iWql");

var $2jDha = parcelRequire("2jDha");

var $hFmdR = parcelRequire("hFmdR");
var $6rCaY = parcelRequire("6rCaY");

var $6iz4v = parcelRequire("6iz4v");

var $lNNXV = parcelRequire("lNNXV");



var $jiL2Q = parcelRequire("jiL2Q");

var $7TN4i = parcelRequire("7TN4i");

var $1HfeQ = parcelRequire("1HfeQ");

var $a9os4 = parcelRequire("a9os4");

var $ktkl3 = parcelRequire("ktkl3");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $k734R = parcelRequire("k734R");

var $jmHHt = parcelRequire("jmHHt");
const $63dd7eb944408bd1$export$c31df4bd766f9c35 = (state)=>({
        storyPointFieldId: (0, $hkGxG.getStoryPointFieldId)(state),
        epicIssueType: (0, $hkGxG.getEpicIssueType)(state),
        cardListIds: (0, $bP7Jx.getVisibleCardListIds)(state),
        cardLists: (0, $bP7Jx.getCardLists)(state),
        selectedCards: (0, $bP7Jx.getSelectedCards)(state),
        isDetailViewVisible: (0, $bP7Jx.shouldShowDetailView)(state),
        getCardKeyFromCardId: (0, $bP7Jx.makeCardKeyFromCardId)(state),
        collapsedCardLists: (0, $bP7Jx.getCollapsedCardLists)(state),
        boardId: Number((0, $hkGxG.getRapidViewId)(state)),
        baseUrl: (0, $hkGxG.getBaseUrl)(state),
        projectKey: (0, $hkGxG.getProjectKey)(state),
        backlogSessionId: (0, $hkGxG.getSessionId)(state),
        issueHierarchyLevel: (0, $k734R.issueHierarchyLevelSelector)(state)(),
        getSourceCardListId: (0, $bP7Jx.makeGetSourceCardListId)(state),
        getSourceCardGroupId: (0, $bP7Jx.makeGetSourceCardGroupId)(state),
        getCardHierarchyLevel: (0, $bP7Jx.makeGetCardHierarchyLevel)(state)
    });
const $63dd7eb944408bd1$export$9e6a17cf56877796 = (dispatch)=>({
        onBacklogView: (analyticsEvent)=>{
            dispatch((0, $jiL2Q.backlogView)(analyticsEvent));
        },
        onCardListsDisable: (cardListIds)=>{
            dispatch((0, $7TN4i.cardListsDisable)(cardListIds));
        },
        onCardListsEnableAll: ()=>{
            dispatch((0, $7TN4i.cardListsEnableAll)());
        },
        onCardSingleSelect: (cardId)=>{
            dispatch((0, $1HfeQ.cardSingleSelect)(cardId));
        },
        onTogglePanel: (panel)=>{
            dispatch((0, $a9os4.togglePanel)(panel));
        }
    });
const $63dd7eb944408bd1$var$onPanelClose = ({ onTogglePanel: onTogglePanel }, panelType)=>()=>{
        onTogglePanel(panelType);
    };
const $63dd7eb944408bd1$var$onBacklogViewFactory = (0, $5iWql.default)((onBacklogView)=>(analyticsEvent)=>{
        (0, $6iz4v.setMark)((0, $755c96fcdc708d92$export$82147bdd117dc85a));
        (0, $6iz4v.setMark)((0, $755c96fcdc708d92$export$e9a67bcd28a7fa89));
        onBacklogView(analyticsEvent);
    });
const $63dd7eb944408bd1$var$onEpicPanelCloseFactory = (0, $5iWql.default)((onTogglePanel, panelType)=>$63dd7eb944408bd1$var$onPanelClose({
        onTogglePanel: onTogglePanel
    }, panelType));
const $63dd7eb944408bd1$var$onVersionPanelCloseFactory = (0, $5iWql.default)((onTogglePanel, panelType)=>$63dd7eb944408bd1$var$onPanelClose({
        onTogglePanel: onTogglePanel
    }, panelType));
const $63dd7eb944408bd1$export$9d1611c77c2fe928 = ({ storyPointFieldId: storyPointFieldId, epicIssueType: epicIssueType, cardListIds: cardListIds, isDetailViewVisible: isDetailViewVisible, boardId: boardId, baseUrl: baseUrl, projectKey: projectKey, issueHierarchyLevel: issueHierarchyLevel }, { onBacklogView: onBacklogView, onTogglePanel: onTogglePanel }, { isCacheHit: isCacheHit, prefetchedData: prefetchedData, prefetchedAggData: prefetchedAggData, prefetchedPlanData: prefetchedPlanData, customFiltersQueryRef: customFiltersQueryRef, versionFilterRelayQueryRef: versionFilterRelayQueryRef })=>({
        isCacheHit: isCacheHit,
        prefetchedData: prefetchedData,
        prefetchedAggData: prefetchedAggData,
        prefetchedPlanData: prefetchedPlanData,
        storyPointFieldId: storyPointFieldId,
        epicIssueType: epicIssueType,
        cardListIds: cardListIds,
        isDetailViewVisible: isDetailViewVisible,
        boardId: boardId,
        baseUrl: baseUrl,
        projectKey: projectKey,
        issueHierarchyLevel: issueHierarchyLevel,
        onBacklogView: $63dd7eb944408bd1$var$onBacklogViewFactory(onBacklogView),
        onEpicPanelClose: $63dd7eb944408bd1$var$onEpicPanelCloseFactory(onTogglePanel, (0, $d36e2c37d06c83ff$export$a10c132b86ae798b)),
        onVersionPanelClose: $63dd7eb944408bd1$var$onVersionPanelCloseFactory(onTogglePanel, (0, $d36e2c37d06c83ff$export$41073ac826c57195)),
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef
    });
var $63dd7eb944408bd1$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $2jDha.default)(), (0, $6rCaY.default)((state)=>({
        attributes: (0, $ktkl3.getAttributes)(state)
    })), (0, $hFmdR.AnalyticsSubject)('backlog'), (0, $lNNXV.connect)($63dd7eb944408bd1$export$c31df4bd766f9c35, $63dd7eb944408bd1$export$9e6a17cf56877796, $63dd7eb944408bd1$export$9d1611c77c2fe928))((0, $jmHHt.default));

});
parcelRegister("6rCaY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b495978a3e51511d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $aw5Sy = parcelRequire("aw5Sy");

var $lNNXV = parcelRequire("lNNXV");

var $hZVJT = parcelRequire("hZVJT");

var $klunD = parcelRequire("klunD");
const $b495978a3e51511d$var$ReduxAnalyticsData = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
mapStateToAnalytics, connectOptions = {})=>(WrappedComponent)=>{
        // eslint-disable-next-line jira/react/no-class-components
        class ComponentWrappedInAnalytics extends (0, $eUqFw.Component) {
            static{
                this.displayName = `ReduxAnalyticsData(${WrappedComponent.displayName || WrappedComponent.name})`;
            }
            static{
                this.defaultProps = {
                    analyticsContext: {}
                };
            }
            render() {
                const { analyticsContext: analyticsContext, ...componentProps } = this.props;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
                    data: analyticsContext
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, componentProps));
            }
        }
        const mapStateToPropsFactory = ()=>{
            const analyticsContextSelectorInstance = (0, $5iWql.default)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
            (state, ownProps)=>(0, $klunD.default)(mapStateToAnalytics(state, ownProps)));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (state, ownProps)=>({
                    analyticsContext: analyticsContextSelectorInstance(state, ownProps)
                });
        };
        return (0, $lNNXV.connect)(mapStateToPropsFactory, ()=>({}), null, {
            // to prevent connected component from unnecessary re-render
            areStatePropsEqual: (nextProps, prevProps)=>{
                const { attributes: prevAttributes, ...prevFields } = prevProps.analyticsContext;
                const { attributes: nextAttributes, ...nextFields } = nextProps.analyticsContext;
                return (0, $hZVJT.default)(prevAttributes, nextAttributes) && (0, $hZVJT.default)(prevFields, nextFields);
            },
            ...connectOptions
        })(ComponentWrappedInAnalytics);
    };
var $b495978a3e51511d$export$2e2bcd8739ae039 = $b495978a3e51511d$var$ReduxAnalyticsData;

});
parcelRegister("hZVJT", function(module, exports) {

$parcel$export(module.exports, "default", () => $831c3a9dcafdabca$export$2e2bcd8739ae039);
const $831c3a9dcafdabca$var$isArrayEqual = (array1 = [], array2 = [])=>{
    if (array1 === array2) return true;
    // check one level deep
    return array1.length === array2.length && array1.every((item, index)=>item === array2[index]);
};
var // one level check to see if object references are equal
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$831c3a9dcafdabca$export$2e2bcd8739ae039 = (obj1, obj2)=>{
    if (obj1 === obj2) return true;
    if (!obj1 || !obj2) return false;
    const item1Keys = Object.keys(obj1).sort();
    const item2Keys = Object.keys(obj2).sort();
    // are keys equal?
    // @ts-expect-error - TS2345 - Argument of type 'string[]' is not assignable to parameter of type 'never[]'.
    if (!$831c3a9dcafdabca$var$isArrayEqual(item1Keys, item2Keys)) return false;
    // are the values equal?
    const areValuesEqual = item2Keys.every((key)=>{
        const value = obj1[key];
        const nextValue = obj2[key];
        if (value === nextValue) return true;
        // @ts-expect-error - TS2345 - Argument of type 'any[]' is not assignable to parameter of type 'never[]'.
        return Array.isArray(nextValue) && Array.isArray(value) && $831c3a9dcafdabca$var$isArrayEqual(value, nextValue);
    });
    return areValuesEqual;
};

});


const $755c96fcdc708d92$export$82147bdd117dc85a = 'BACKLOG_READY_FOR_USER_MARK';
const $755c96fcdc708d92$export$e9a67bcd28a7fa89 = 'BACKLOG_INTERACTIVE_MARK';

parcelRegister("jmHHt", function(module, exports) {

$parcel$export(module.exports, "default", () => $54febb85412000be$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $a576Y = parcelRequire("a576Y");

var $5qTKr = parcelRequire("5qTKr");

var $i0qMh = parcelRequire("i0qMh");
var $8MEtd = parcelRequire("8MEtd");

var $jPfP5 = parcelRequire("jPfP5");

var $4E9Xv = parcelRequire("4E9Xv");

var $5SC3o = parcelRequire("5SC3o");

var $aYtGv = parcelRequire("aYtGv");

var $511uv = parcelRequire("511uv");

var $iRSva = parcelRequire("iRSva");

var $1ybV0 = parcelRequire("1ybV0");

var $3l6tm = parcelRequire("3l6tm");

var $8LIba = parcelRequire("8LIba");

var $8WuJm = parcelRequire("8WuJm");
var $bFzGY = parcelRequire("bFzGY");

var $gFGRe = parcelRequire("gFGRe");

var $7msR2 = parcelRequire("7msR2");

var $fKDIt = parcelRequire("fKDIt");

var $fijOW = parcelRequire("fijOW");

var $dkPd7 = parcelRequire("dkPd7");

var $cyQ1m = parcelRequire("cyQ1m");

var $8HMCF = parcelRequire("8HMCF");

var $f2lzo = parcelRequire("f2lzo");


var $lA3UV = parcelRequire("lA3UV");

var $8wXFi = parcelRequire("8wXFi");


var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $7kNqR = parcelRequire("7kNqR");

var $j258X = parcelRequire("j258X");

var $4lVbF = parcelRequire("4lVbF");

var $2esFI = parcelRequire("2esFI");

var $naWQb = parcelRequire("naWQb");

var $9wiuB = parcelRequire("9wiuB");

var $dgzXR = parcelRequire("dgzXR");

var $9Bj5W = parcelRequire("9Bj5W");

var $fbsNl = parcelRequire("fbsNl");

var $6Euqa = parcelRequire("6Euqa");

var $5QH4Q = parcelRequire("5QH4Q");

var $e3kiu = parcelRequire("e3kiu");

var $c6jno = parcelRequire("c6jno");

var $8viQs = parcelRequire("8viQs");

var $aF9KL = parcelRequire("aF9KL");

var $jo9St = parcelRequire("jo9St");

var $jPmMo = parcelRequire("jPmMo");

var $cwRNF = parcelRequire("cwRNF");

var $eoHTi = parcelRequire("eoHTi");

var $3REKr = parcelRequire("3REKr");

var $1Ieoq = parcelRequire("1Ieoq");
const $54febb85412000be$var$BacklogComponent = ({ isCacheHit: isCacheHit, boardId: boardId, baseUrl: baseUrl, projectKey: projectKey, isDetailViewVisible: isDetailViewVisible, issueHierarchyLevel: issueHierarchyLevel = (0, $3l6tm.ISSUE_HIERARCHY_LEVEL_BASE), cardListIds: cardListIds, onBacklogView: onBacklogViewProp, onEpicPanelClose: onEpicPanelCloseProp, onVersionPanelClose: onVersionPanelCloseProp, customFiltersQueryRef: customFiltersQueryRef, versionFilterRelayQueryRef: versionFilterRelayQueryRef })=>{
    const isViewEventSent = (0, $eUqFw.useRef)(false);
    const [width, setWidth] = (0, $eUqFw.useState)(0);
    const [openSidebar, setOpenSidebar] = (0, $eUqFw.useState)(false);
    const throttledSetWidth = (0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))(setWidth, 50);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const shouldShowAdminInaccessibleBoard = (0, $8MEtd.useShouldShowAdminInaccessibleBoard)((0, $gFGRe.uifBacklogResource));
    const onBacklogView = (0, $dkPd7.useEvent)(onBacklogViewProp);
    const onEpicPanelClose = (0, $dkPd7.useEvent)(onEpicPanelCloseProp);
    const onVersionPanelClose = (0, $dkPd7.useEvent)(onVersionPanelCloseProp);
    const onOpenSidebar = (0, $eUqFw.useCallback)(()=>{
        setOpenSidebar(true);
    }, []);
    const onCloseSidebar = (0, $eUqFw.useCallback)(()=>{
        setOpenSidebar(false);
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        const timer = setTimeout(()=>{
            (0, $511uv.getLongTasksMetrics)('filter').stop((0, $iRSva.filterReporter));
        }, 1);
        document.body?.classList.add('spb');
        return ()=>{
            document.body?.classList.remove('spb');
            clearTimeout(timer);
        };
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        if (!isViewEventSent.current && cardListIds.length > 0) {
            isViewEventSent.current = true;
            const analyticsEvent = createAnalyticsEvent({});
            onBacklogView(analyticsEvent);
        }
    }, [
        onBacklogView,
        cardListIds.length,
        createAnalyticsEvent
    ]);
    const isCMPBoard = (0, $j258X.useIsCMPBacklog)();
    const bulkOperationsToolbar = (0, $5SC3o.useReferenceLoader)();
    const bulkOperationsForm = (0, $5SC3o.useReferenceLoader)();
    const shouldShowIssueLimitFlags = isCMPBoard && (0, $1ybV0.ff)('jsw-board-backlog-show-5k-issues-with-flag') || !isCMPBoard && (0, $1ybV0.ff)('jsw-board-backlog-show-5k-issues-with-flag-tmp');
    const issueCount = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getCardsCount));
    const userCanEditBoardConfig = (0, $1gQ73.useBacklogSelector)((0, $7kNqR.getPermissions))[0, $094620879c5e56fa$export$b35e3ebf2c83a499];
    const backlogContainerIssueCount = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getOrderedCardIdsByCardListId)).BACKLOG?.length;
    const isScrumBacklog = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.isScrumBacklogStrategy));
    const getIssueLimitFlagViews = ()=>{
        if (isCMPBoard) return [
            {
                view: 'BACKLOG',
                issueCount: issueCount
            }
        ];
        return [
            {
                view: 'BACKLOG',
                issueCount: backlogContainerIssueCount
            },
            {
                view: isScrumBacklog ? 'SPRINTS' : 'BOARD',
                issueCount: issueCount - backlogContainerIssueCount
            }
        ];
    };
    // created to avoid duplication and will be moved back when cleaning up the FF.
    const backlogContainerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($54febb85412000be$var$Container, {
        "data-test-id": "software-backlog.backlog",
        "data-testid": "software-backlog.backlog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Euqa.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cyQ1m.StorageLimitsBanner), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8HMCF.UpFlowPersistentUpgradeBanner), {
        isBannerEnabled: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($54febb85412000be$var$PageHeaderWrapper, {
        "data-test-id": "software-backlog.page-header",
        "data-testid": "software-backlog.page-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8viQs.default), {
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: {
            analyticsSource: (0, $e1409a6fc345c0d8$export$840e3848643f7781)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($54febb85412000be$var$SizeDetectorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eoHTi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8LIba.IccProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5qTKr.WidthObserver), {
        setWidth: throttledSetWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2esFI.default), {
        isDetailViewVisible: isDetailViewVisible,
        parentWidth: width || 0,
        boardId: boardId,
        cardListIds: cardListIds,
        DetailView: (0, $fbsNl.default),
        SubmitApdex: (0, $3REKr.default),
        isCacheHit: isCacheHit,
        CardList: (0, $9Bj5W.default),
        BoardIssueMoveDialog: (0, $jPmMo.default),
        onEpicPanelClose: onEpicPanelClose,
        onVersionPanelClose: onVersionPanelClose,
        issueHierarchyLevel: issueHierarchyLevel,
        bulkOperationsToolbar: bulkOperationsToolbar
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwRNF.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jo9St.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5QH4Q.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jPfP5.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f2lzo.default), {
        baseUrl: baseUrl,
        boardId: String(boardId)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Ieoq.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aF9KL.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4lVbF.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e3kiu.FiltersStorage), null), shouldShowIssueLimitFlags && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fKDIt.default), {
        boardId: boardId,
        isCMP: isCMPBoard,
        isProjectAdmin: userCanEditBoardConfig,
        projectKey: projectKey,
        views: getIssueLimitFlagViews()
    }));
    // Show a message to admin users if the board is inaccessible due to filter permissions and how to update it
    if ((0, $1ybV0.ff)('show-board-filter-permission-message-to-admins_iqh25') && shouldShowAdminInaccessibleBoard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i0qMh.AsyncAdminInaccessibleBoard), {
        rapidViewId: boardId.toString(),
        skeleton: (0, $7msR2.NextGenBacklogSkeleton)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "backlog"
    }, isCMPBoard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $naWQb.CmpBacklogSlaTracker), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c6jno.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4E9Xv.BulkOpsAnalyticsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($54febb85412000be$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($54febb85412000be$var$MainContent, null, backlogContainerContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dgzXR.BulkOperationsSidebar), {
        parentWidth: width || 0,
        isOpen: openSidebar,
        bulkOperationsForm: bulkOperationsForm
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9wiuB.BulkOperationsLoader), {
        bulkOperationsForm: bulkOperationsForm,
        bulkOperationsToolbar: bulkOperationsToolbar,
        onCloseSidebar: onCloseSidebar,
        onOpenSidebar: onOpenSidebar
    })), !(0, $1ybV0.ff)('sea-2744-jsw-tabs-nav') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fijOW.default), {
        boardId: boardId,
        projectKey: projectKey,
        isCMPBoard: isCMPBoard
    })));
};
const $54febb85412000be$export$2532845c810cfaa1 = /*#__PURE__*/ (0, $eUqFw.memo)($54febb85412000be$var$BacklogComponent);
var // TODO: This is a flaky design. We shouldn't depend on prefetched data being available at certain points.
// As of current if prefetched data is null (which is a valid state), then the issue fields won't be initialized correctly.
// While there is sync. for lots of values, there is not sync for certain required values, such as `HIERARCHY...` fields. On
// that case, switching into the issue fields epic renderers will hide epics.
// In particular, src/packages/issue/fields/parent-switcher/src/controllers/with-sweet-state-parent-switcher/index.tsx
// won't render the field.
// eslint-disable-next-line jira/import/no-anonymous-default-export
$54febb85412000be$export$2e2bcd8739ae039 = ({ prefetchedData: prefetchedData, prefetchedAggData: prefetchedAggData, prefetchedPlanData: prefetchedPlanData, storyPointFieldId: storyPointFieldId, epicIssueType: epicIssueType, ...rest })=>{
    const { storeFieldsFromPrefetchedData: storeFieldsFromPrefetchedData, storeFieldsFromPrefetchedAggData: storeFieldsFromPrefetchedAggData, storeFieldsFromPrefetchedPlanData: storeFieldsFromPrefetchedPlanData } = (0, $lA3UV.useStoreFields)();
    // Initialise extracted fields (Sweet State) using prefetched data (SSR)
    (0, $eUqFw.useEffect)(()=>{
        const fieldConfigs = {
            storyPointFieldId: storyPointFieldId
        };
        if (prefetchedPlanData) storeFieldsFromPrefetchedPlanData(prefetchedPlanData, epicIssueType);
        else if ((0, $8wXFi.isBacklogWithRelayEnabled)() && prefetchedAggData) storeFieldsFromPrefetchedAggData(prefetchedAggData, fieldConfigs);
        else if (prefetchedData) storeFieldsFromPrefetchedData(prefetchedData, fieldConfigs);
    }, [
        prefetchedData,
        prefetchedAggData,
        prefetchedPlanData,
        storeFieldsFromPrefetchedData,
        storeFieldsFromPrefetchedAggData,
        storeFieldsFromPrefetchedPlanData,
        storyPointFieldId,
        epicIssueType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($54febb85412000be$export$2532845c810cfaa1, rest);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $54febb85412000be$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1s93bfy": (0, $9t7rW.default)((0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP))
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_c71l1l47 _4t3i1l47 _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _12ji1r31 _1qu2glyw _12y31o36",
            __cmplp.className
        ])
    });
});
const $54febb85412000be$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $54febb85412000be$var$MainContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zidpf _i0dlf1ug _1e0c1txw _1reo15vq _18m915vq _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $54febb85412000be$var$SizeDetectorWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_c71l1osq _1reo15vq _18m915vq _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _10pb1h90 _6ndb1osq",
            __cmplp.className
        ])
    });
});
const $54febb85412000be$var$PageHeaderWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qidpf _u5f31ylp _n3tdidpf _19bv1ylp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("i0qMh", function(module, exports) {

$parcel$export(module.exports, "AsyncAdminInaccessibleBoard", () => $ce66c0131444331c$export$516550003e785216);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ce66c0131444331c$var$AdminInaccessibleBoard = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("hqzMl")), {
    ssr: false,
    moduleId: "./src/packages/software/admin-inaccessible-board/src/ui/main.tsx"
});
const $ce66c0131444331c$export$516550003e785216 = (props)=>{
    const Skeleton = props.skeleton;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        packageName: "jiraAdminInaccessibleBoard",
        id: "async-admin-inaccessible-board",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "admin-inaccessible-board",
        fallback: Skeleton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ce66c0131444331c$var$AdminInaccessibleBoard, props)));
};

});
parcelRegister("hqzMl", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('iHSjY');
        const value = parcelRequire('30oMU');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("iHSjY").then(()=>parcelRequire('30oMU'));
}

});


parcelRegister("8MEtd", function(module, exports) {

$parcel$export(module.exports, "useShouldShowAdminInaccessibleBoard", () => $852db5b010ee8f85$export$1a15223f3cf409b4);

var $1ybV0 = parcelRequire("1ybV0");

var $3HCkE = parcelRequire("3HCkE");

var $6rUGr = parcelRequire("6rUGr");

var $c7H0g = parcelRequire("c7H0g");
const $852db5b010ee8f85$export$1a15223f3cf409b4 = (resource)=>{
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const data = (0, $3HCkE.useResource)(resource);
    const statusCode = data.error ? (0, $6rUGr.extractStatusCode)(data.error) : null;
    return (0, $1ybV0.ff)('show-board-filter-permission-message-to-admins_iqh25') && isAdmin && statusCode === 404;
};

});

parcelRegister("jPfP5", function(module, exports) {

$parcel$export(module.exports, "default", () => $87fa35216d96bc0f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $etqm0 = parcelRequire("etqm0");
// eslint-disable-next-line jira/react/no-class-components
class $87fa35216d96bc0f$var$ViewTracker extends (0, $eUqFw.Component) {
    componentDidMount() {
        this.props.onMount();
    }
    render() {
        return null;
    }
}
const $87fa35216d96bc0f$var$ViewTrackerWithAnalytics = (0, $1ngde.default)({
    componentName: 'view-tracker'
})((0, $2jDha.default)({
    onMount: (createEvent)=>createEvent({
            action: (0, $etqm0.PAGE_EVENT_ACTION)
        }).fire()
})($87fa35216d96bc0f$var$ViewTracker));
var // without onMount={noop} it won't work, defaultProps won't help
// @ts-expect-error - TS2322 - Type '{ onMount: (...args: any[]) => void; }' is not assignable to type 'IntrinsicAttributes & Pick<Pick<WithAnalyticsEventsProps, never> & RefAttributes<any> & WithContextProps, "key" | "analyticsContext"> & RefAttributes<...>'.
// eslint-disable-next-line jira/import/no-anonymous-default-export
$87fa35216d96bc0f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($87fa35216d96bc0f$var$ViewTrackerWithAnalytics, {
        onMount: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    });

});

parcelRegister("4E9Xv", function(module, exports) {

$parcel$export(module.exports, "BulkOpsAnalyticsProvider", () => $3d2709472df65d95$export$8ab440f197429d1e);
$parcel$export(module.exports, "useBulkOpsSessionContext", () => $3d2709472df65d95$export$95271787b6ae4d3c);

var $eUqFw = parcelRequire("eUqFw");

var $bAQOb = parcelRequire("bAQOb");

var $8WuJm = parcelRequire("8WuJm");

var $jeI7w = parcelRequire("jeI7w");
const $3d2709472df65d95$var$BulkOpsAnalyticsContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $3d2709472df65d95$var$BulkOpsAnalyticsProviderOld = (props)=>{
    const [bulkOpsFlow] = (0, $eUqFw.useState)(new (0, $jeI7w.DefaultBulkOpsFlow)());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3d2709472df65d95$var$BulkOpsAnalyticsContext.Provider, {
        value: bulkOpsFlow
    }, props.children);
};
const $3d2709472df65d95$var$BulkOpsAnalyticsProviderNew = (props)=>{
    const [bulkOpsFlow] = (0, $eUqFw.useState)(new (0, $jeI7w.DefaultBulkOpsFlow)());
    const [bulkOpsSessionID, setBulkOpsSessionID] = (0, $eUqFw.useState)(bulkOpsFlow?.getFlowAttributes().bulkOpsSessionID || undefined);
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = bulkOpsFlow?.registerAnalyticsEventPublisher((sessionId)=>{
            setBulkOpsSessionID(sessionId);
        });
        return ()=>{
            unsubscribe?.();
        };
    }, [
        bulkOpsFlow
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3d2709472df65d95$var$BulkOpsAnalyticsContext.Provider, {
        value: bulkOpsFlow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: {
            bulkOpsSessionID: bulkOpsSessionID
        }
    }, props.children));
};
const $3d2709472df65d95$export$8ab440f197429d1e = (0, $bAQOb.componentWithFF)('bulk-operations-additions-may08-sprint_rvdeo', $3d2709472df65d95$var$BulkOpsAnalyticsProviderNew, $3d2709472df65d95$var$BulkOpsAnalyticsProviderOld);
const $3d2709472df65d95$export$95271787b6ae4d3c = ()=>(0, $eUqFw.useContext)($3d2709472df65d95$var$BulkOpsAnalyticsContext);

});
parcelRegister("jeI7w", function(module, exports) {

$parcel$export(module.exports, "DefaultBulkOpsFlow", () => $d9ae6884fa818966$export$74bf75c57acfbb74);

var $hompL = parcelRequire("hompL");
class $d9ae6884fa818966$export$74bf75c57acfbb74 {
    isInFlow() {
        return this.bulkOpsSessionID !== undefined;
    }
    get sessionID() {
        return this.bulkOpsSessionID;
    }
    get bulkActionsCompleted() {
        return this.numBulkActionsCompleted;
    }
    notifyAnalyticsEventPublishers(sessionID) {
        let index = 0;
        this.analyticsEventPublishers.forEach((listener)=>{
            listener(sessionID, index);
            index += 1;
        });
        this.analyticsEventPublishers.clear();
    }
    start(_attributes) {
        if (this.isInFlow()) return;
        this.bulkOpsSessionID = (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4();
        this.notifyAnalyticsEventPublishers(this.bulkOpsSessionID);
    }
    end(_attributes) {
        this.bulkOpsSessionID = undefined;
        this.numBulkActionsCompleted = 0;
    }
    executeAction() {
        if (!this.isInFlow()) this.start();
        this.numBulkActionsCompleted += 1;
    }
    getFlowAttributes() {
        if (this.bulkOpsSessionID && this.numBulkActionsCompleted !== 0) return {
            bulkOpsSessionID: this.bulkOpsSessionID,
            numBulkActionsCompleted: this.numBulkActionsCompleted
        };
        return this.bulkOpsSessionID ? {
            bulkOpsSessionID: this.bulkOpsSessionID
        } : {};
    }
    registerAnalyticsEventPublisher(analyticsEventPublisher) {
        this.analyticsEventPublishers.add(analyticsEventPublisher);
        return ()=>{
            this.analyticsEventPublishers.delete(analyticsEventPublisher);
        };
    }
    constructor(){
        this.numBulkActionsCompleted = 0;
        this.analyticsEventPublishers = new Set();
    }
}

});


parcelRegister("5SC3o", function(module, exports) {

$parcel$export(module.exports, "useReferenceLoader", () => $1500fcd781a55507$export$727d936bc4a88f4e);

var $eUqFw = parcelRequire("eUqFw");
const $1500fcd781a55507$export$727d936bc4a88f4e = ()=>{
    const [ref, setRef] = (0, $eUqFw.useState)(null);
    return (0, $eUqFw.useMemo)(()=>({
            setRef: setRef,
            ref: ref
        }), [
        setRef,
        ref
    ]);
};

});

parcelRegister("511uv", function(module, exports) {

$parcel$export(module.exports, "getLongTasksMetrics", () => $6e4a680496b7cbbf$export$b092a8653a66aa5e);

var $jqvCZ = parcelRequire("jqvCZ");

var $8uNQc = parcelRequire("8uNQc");
var $6iz4v = parcelRequire("6iz4v");

var $7tZw9 = parcelRequire("7tZw9");
let $6e4a680496b7cbbf$var$observer = null;
const $6e4a680496b7cbbf$var$stopObserver = ()=>{
    if ($6e4a680496b7cbbf$var$observer) {
        $6e4a680496b7cbbf$var$observer.disconnect();
        $6e4a680496b7cbbf$var$observer = null;
    }
};
const $6e4a680496b7cbbf$export$b092a8653a66aa5e = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((type)=>{
    const clearData = {
        type: type
    };
    let isStarted = false;
    let observationData = {
        ...clearData
    };
    const isDnd = /dnd$/.test(type.toLowerCase());
    return {
        start: (appName, startPerformanceMark, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        extra = {})=>{
            if (window.PerformanceObserver && !isStarted) try {
                const startTimestamp = (0, $8uNQc.default).now();
                observationData = {
                    type: observationData.type,
                    startTimestamp: startTimestamp,
                    dragStartEndTimestamp: startTimestamp,
                    eventStartPerformanceMark: startPerformanceMark,
                    events: [],
                    appName: appName,
                    extra: extra
                };
                isStarted = true;
                $6e4a680496b7cbbf$var$stopObserver();
                $6e4a680496b7cbbf$var$observer = new window.PerformanceObserver((list)=>{
                    list.getEntries().forEach((entry)=>{
                        if (entry.entryType === 'longtask') {
                            if (!(0, $7tZw9.isExpandedObservationData)(observationData) || observationData.events.find((item)=>item.timestamp === entry.startTime && item.duration === entry.duration)) return;
                            observationData.events.push({
                                timestamp: entry.startTime,
                                duration: entry.duration
                            });
                        } else if (entry.entryType === 'event' && entry.name === 'dragstart') /**
								 * Use the observed event to compute the "end" timestamp of the dragstart event,
								 * which will be used for splitting the long tasks for dragstart and dragmove.
								 */ observationData.dragStartEndTimestamp = entry.startTime + entry.duration;
                    });
                });
                $6e4a680496b7cbbf$var$observer.observe({
                    type: 'longtask'
                });
                if (isDnd) /**
						 * Observe events with >48ms duration.
						 * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceObserver/observe
						 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                $6e4a680496b7cbbf$var$observer.observe({
                    type: 'event',
                    durationThreshold: 48
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-empty
            } catch (e) {}
        },
        stop: (callback, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        extra = {})=>{
            if ((0, $8uNQc.default).now && isStarted) {
                const stopTimestamp = (0, $8uNQc.default).now();
                setTimeout(()=>{
                    $6e4a680496b7cbbf$var$stopObserver();
                    callback({
                        ...observationData
                    }, extra, stopTimestamp);
                    observationData = {
                        ...clearData
                    };
                    isStarted = false;
                });
            }
        },
        stopIfNoMark: (performanceMark)=>{
            if ($6e4a680496b7cbbf$var$observer && performanceMark) {
                const perfMark = (0, $6iz4v.getMark)(performanceMark);
                if (!perfMark) {
                    $6e4a680496b7cbbf$var$stopObserver();
                    observationData = {
                        ...clearData
                    };
                    isStarted = false;
                }
            }
        }
    };
});

});
parcelRegister("7tZw9", function(module, exports) {

$parcel$export(module.exports, "isExpandedObservationData", () => $e45a8242e5c0159d$export$3d38a87309e205a4);
const $e45a8242e5c0159d$export$3d38a87309e205a4 = (observationData)=>observationData !== undefined && 'events' in observationData && observationData.events !== undefined;

});


parcelRegister("iRSva", function(module, exports) {

$parcel$export(module.exports, "filterReporter", () => $476c6791c527f85c$export$facf842185aa645c);

var $lzvR2 = parcelRequire("lzvR2");

var $7tZw9 = parcelRequire("7tZw9");

var $fPUXl = parcelRequire("fPUXl");
const $476c6791c527f85c$export$facf842185aa645c = (observationData, // eslint-disable-next-line @typescript-eslint/no-explicit-any
featureFlags = {})=>{
    if ((0, $7tZw9.isExpandedObservationData)(observationData)) {
        const triggerSoftwareAnalytics = (0, $fPUXl.triggerAnalytics)(`software.${observationData.appName}`);
        const startTime = observationData.events.map((event)=>event.timestamp);
        const analyticsData = {
            ...(0, $fPUXl.generateLongTaskAnalyticsSummary)('filter', observationData.events),
            measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTime),
            ...featureFlags,
            performanceFFs: (0, $lzvR2.getPerformanceFFsString)()
        };
        triggerSoftwareAnalytics('long-tasks-filter', analyticsData);
        try {
            performance.measure('filterBarResponsiveness', 'filterBarStart', 'filterBarStop');
            triggerSoftwareAnalytics('performance-filter-bar', performance.getEntriesByName('filterBarResponsiveness')[0]);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
        // do nothing
        }
        try {
            performance.measure('oldFilterBarResponsiveness', 'oldFilterBarStart', 'oldFilterBarStop');
            triggerSoftwareAnalytics('performance-old-filter-bar', performance.getEntriesByName('oldFilterBarResponsiveness')[0]);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
        // do nothing
        }
        performance.clearMeasures();
    }
};

});
parcelRegister("fPUXl", function(module, exports) {

$parcel$export(module.exports, "triggerAnalytics", () => $9e8129e894f8b784$export$2c57de8a70f64057);
$parcel$export(module.exports, "generateLongTaskAnalyticsSummary", () => $9e8129e894f8b784$export$2be2635781d23aab);
$parcel$export(module.exports, "generateLongTaskAnalyticsSummaryWithSlo", () => $9e8129e894f8b784$export$c674a20081e82c6a);
$parcel$export(module.exports, "getAverageResultsFromContinuousActions", () => $9e8129e894f8b784$export$c36fdc326d0c207c);
$parcel$export(module.exports, "generateLongTaskAnalyticsContinuousActionSummary", () => $9e8129e894f8b784$export$7e5f2df95eca342a);

var $x71UL = parcelRequire("x71UL");

var $4YjDD = parcelRequire("4YjDD");

var $9HwDQ = parcelRequire("9HwDQ");
const $9e8129e894f8b784$export$2c57de8a70f64057 = (_appName)=>(_eventNameSuffix, _eventData)=>Promise.resolve(undefined);
const $9e8129e894f8b784$export$2be2635781d23aab = (prefix, longTasks)=>{
    const durations = longTasks.map((task)=>task.duration);
    return {
        [`${prefix}LongTaskCount`]: longTasks.length,
        [`${prefix}LongTaskAvg`]: longTasks.length > 0 ? durations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / longTasks.length : 0,
        [`${prefix}LongTaskMax`]: longTasks.length > 0 ? Math.max(...durations) : 0
    };
};
const $9e8129e894f8b784$export$c674a20081e82c6a = (prefix, longTasks, sloSettings)=>{
    const summary = $9e8129e894f8b784$export$2be2635781d23aab(prefix, longTasks);
    if (!sloSettings) return summary;
    const framerate = summary[`${prefix}LongTaskCount`] === 0 ? 20 : 1000 / summary[`${prefix}LongTaskAvg`];
    const blocktime = summary[`${prefix}LongTaskCount`] === 0 ? 0 : summary[`${prefix}LongTaskCount`] * summary[`${prefix}LongTaskAvg`];
    const isSuccess = framerate >= sloSettings.framerateThreshold && blocktime < sloSettings.blocktimeThreshold;
    return {
        [`${prefix}LongTaskSloIsSuccess`]: isSuccess,
        ...summary
    };
};
const $9e8129e894f8b784$export$c36fdc326d0c207c = (prefix, data)=>({
        [`${prefix}ClusterCount`]: (0, (/*@__PURE__*/$parcel$interopDefault($9HwDQ)))(data, `${prefix}ClusterCount`) || 0,
        [`${prefix}ClusterCountAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($x71UL)))(data, `${prefix}ClusterCount`) || 0,
        [`${prefix}ClusterAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($x71UL)))(data, `${prefix}ClusterAvg`) || 0,
        [`${prefix}ClusterDistanceAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($x71UL)))(data, `${prefix}ClusterDistanceAvg`) || 0,
        [`${prefix}ClusterAvgLongTaskCount`]: (0, (/*@__PURE__*/$parcel$interopDefault($x71UL)))(data, `${prefix}ClusterAvgLongTaskCount`) || 0,
        [`${prefix}ClusterAvgLongTaskAvg`]: data.length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($4YjDD)))(data.map((entry)=>entry[`${prefix}ClusterAvgLongTaskCount`] * entry[`${prefix}ClusterAvgLongTaskAvg`])) / (0, (/*@__PURE__*/$parcel$interopDefault($9HwDQ)))(data, `${prefix}ClusterAvgLongTaskCount`) : 0,
        [`${prefix}Count`]: data.length
    });
const $9e8129e894f8b784$export$7e5f2df95eca342a = (prefix, longTasks)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const clusters = longTasks.reduce((foundClusters, task)=>{
        if (foundClusters.length === 0) foundClusters.push({
            tasks: [],
            start: 0,
            stop: 0
        });
        const prevCluster = foundClusters[foundClusters.length - 1];
        const taskEnd = task.timestamp + task.duration;
        if (prevCluster.tasks.length === 0) {
            prevCluster.tasks.push(task);
            prevCluster.start = task.timestamp;
            prevCluster.stop = taskEnd;
        } else if (task.timestamp - prevCluster.stop < 100) {
            prevCluster.tasks.push(task);
            prevCluster.stop = taskEnd;
        } else foundClusters.push({
            tasks: [
                task
            ],
            start: task.timestamp,
            stop: taskEnd
        });
        return foundClusters;
    }, []);
    const clusterDurations = clusters.map((cluster)=>cluster.stop - cluster.start);
    const tasksDurations = longTasks.map((task)=>task.duration);
    const gapsBetweenClusters = clusters.length > 1 ? clusters // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((gaps, cluster, i)=>{
        if (gaps.length === 0) {
            gaps.push({
                start: cluster.stop,
                stop: null
            });
            return gaps;
        }
        // eslint-disable-next-line no-param-reassign
        gaps[gaps.length - 1].stop = cluster.start;
        if (i !== clusters.length - 1) gaps.push({
            start: cluster.stop,
            stop: null
        });
        return gaps;
    }, []).map((gap)=>gap.stop - gap.start) : [];
    return {
        [`${prefix}ClusterCount`]: clusters.length,
        [`${prefix}ClusterAvg`]: clusters.length > 0 ? clusterDurations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / clusters.length : 0,
        [`${prefix}ClusterDistanceAvg`]: gapsBetweenClusters.length > 0 ? gapsBetweenClusters.reduce((sumAcc, duration)=>sumAcc + duration, 0) / gapsBetweenClusters.length : 0,
        [`${prefix}ClusterAvgLongTaskCount`]: clusters.length > 0 ? clusters.map((cluster)=>cluster.tasks.length).reduce((sumAcc, count)=>sumAcc + count, 0) / clusters.length : 0,
        [`${prefix}ClusterAvgLongTaskAvg`]: longTasks.length > 0 ? tasksDurations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / longTasks.length : 0
    };
};

});
parcelRegister("x71UL", function(module, exports) {

var $7qARj = parcelRequire("7qARj");

var $6P7TZ = parcelRequire("6P7TZ");
/**
 * This method is like `_.mean` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be averaged.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the mean.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.meanBy(objects, function(o) { return o.n; });
 * // => 5
 *
 * // The `_.property` iteratee shorthand.
 * _.meanBy(objects, 'n');
 * // => 5
 */ function $0638892b8ae22890$var$meanBy(array, iteratee) {
    return $6P7TZ(array, $7qARj(iteratee, 2));
}
module.exports = $0638892b8ae22890$var$meanBy;

});
parcelRegister("6P7TZ", function(module, exports) {

var $835ZM = parcelRequire("835ZM");
/** Used as references for various `Number` constants. */ var $4f7da2b12e23c1f3$var$NAN = 0 / 0;
/**
 * The base implementation of `_.mean` and `_.meanBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the mean.
 */ function $4f7da2b12e23c1f3$var$baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? $835ZM(array, iteratee) / length : $4f7da2b12e23c1f3$var$NAN;
}
module.exports = $4f7da2b12e23c1f3$var$baseMean;

});


parcelRegister("9HwDQ", function(module, exports) {

var $7qARj = parcelRequire("7qARj");

var $835ZM = parcelRequire("835ZM");
/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */ function $7101732f00f14013$var$sumBy(array, iteratee) {
    return array && array.length ? $835ZM(array, $7qARj(iteratee, 2)) : 0;
}
module.exports = $7101732f00f14013$var$sumBy;

});



parcelRegister("8LIba", function(module, exports) {

$parcel$export(module.exports, "IccContext", () => $53ef4a1beaf15b73$export$2f62d2dfd027123d);
$parcel$export(module.exports, "useIccContext", () => $53ef4a1beaf15b73$export$f7b8d088c9ea045e);
$parcel$export(module.exports, "IccProvider", () => $53ef4a1beaf15b73$export$4a7497397d7465fc);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");
const $53ef4a1beaf15b73$export$2f62d2dfd027123d = /*#__PURE__*/ (0, $eUqFw.createContext)({
    initialSummary: '',
    initialCardTypeId: null,
    initialFieldValues: new Map(),
    initialProjectId: null,
    onChangeSummary: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onChangeCardType: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onChangeFieldValue: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onChangeProject: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onCreate: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
});
const $53ef4a1beaf15b73$export$f7b8d088c9ea045e = ()=>(0, $eUqFw.useContext)($53ef4a1beaf15b73$export$2f62d2dfd027123d);
// eslint-disable-next-line jira/react/no-class-components
class $53ef4a1beaf15b73$export$4a7497397d7465fc extends (0, $eUqFw.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($53ef4a1beaf15b73$export$2f62d2dfd027123d.Provider, {
            value: {
                initialSummary: this.state.initialSummary,
                initialCardTypeId: this.state.initialCardTypeId,
                initialFieldValues: this.state.initialFieldValues,
                initialProjectId: this.state.initialProjectId,
                onChangeCardType: this.onChangeCardType,
                onChangeSummary: this.onChangeSummary,
                onChangeFieldValue: this.onChangeFieldValue,
                onChangeProject: this.onChangeProject,
                onCancel: this.onCancel,
                onCreate: this.onCreate
            }
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            initialSummary: '',
            initialCardTypeId: null,
            initialFieldValues: new Map(),
            initialProjectId: null
        };
        this.onChangeSummary = (summary)=>{
            this.setState({
                initialSummary: summary
            });
        };
        this.onChangeProject = (projectId)=>{
            this.setState({
                initialProjectId: projectId
            });
        };
        this.onChangeCardType = (cardTypeId)=>{
            this.setState({
                initialCardTypeId: cardTypeId
            });
        };
        this.onChangeFieldValue = (fieldKey, fieldValue)=>{
            this.setState(({ initialFieldValues: initialFieldValues })=>({
                    initialFieldValues: initialFieldValues.set(fieldKey, fieldValue)
                }));
        };
        this.onCancel = ()=>{
            this.setState({
                initialSummary: '',
                initialCardTypeId: null
            });
        };
        this.onCreate = ()=>{
            this.setState({
                initialSummary: ''
            });
        };
    }
}

});

parcelRegister("fKDIt", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fbed6660106050e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $3SH8N = parcelRequire("3SH8N");
const $0fbed6660106050e$var$App = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "app",
        packageName: "jiraSoftwareIssueLimitFlags",
        teamName: "a4t-tanuki",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3SH8N.IssueLimitFlags), props));
var $0fbed6660106050e$export$2e2bcd8739ae039 = $0fbed6660106050e$var$App;

});
parcelRegister("3SH8N", function(module, exports) {

$parcel$export(module.exports, "IssueLimitFlags", () => $ec9e2b3b4c70772b$export$739da16e22409e4d);

var $eUqFw = parcelRequire("eUqFw");

var $fBBEm = parcelRequire("fBBEm");

var $jUgY0 = parcelRequire("jUgY0");
const $ec9e2b3b4c70772b$var$ISSUE_APPROACHING_LIMIT = 4500;
const $ec9e2b3b4c70772b$var$ISSUE_REACHED_LIMIT = 5000;
const $ec9e2b3b4c70772b$export$739da16e22409e4d = ({ isProjectAdmin: isProjectAdmin, ...flagProps })=>{
    const [limitReachedFlagShown, setLimitReachedFlagShown] = (0, $eUqFw.useState)(false);
    const limitReachedViews = flagProps.views.filter((view)=>view.issueCount >= $ec9e2b3b4c70772b$var$ISSUE_REACHED_LIMIT);
    const limitApproachingViews = flagProps.views.filter((view)=>view.issueCount >= $ec9e2b3b4c70772b$var$ISSUE_APPROACHING_LIMIT && view.issueCount < $ec9e2b3b4c70772b$var$ISSUE_REACHED_LIMIT);
    const shouldShowLimitReachedFlag = limitReachedViews.length > 0;
    const shouldShowLimitApproachingFlag = limitApproachingViews.length > 0 && !limitReachedFlagShown;
    (0, $eUqFw.useEffect)(()=>{
        if (shouldShowLimitReachedFlag && !limitReachedFlagShown) setLimitReachedFlagShown(true);
    }, [
        limitReachedFlagShown,
        shouldShowLimitReachedFlag
    ]);
    // Check to ensure permission is defined. If value is not boolean, then it likely
    // means it has not yet been loaded
    if (typeof isProjectAdmin !== 'boolean') return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, shouldShowLimitApproachingFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fBBEm.LimitApproachingFlag), {
        ...flagProps,
        isProjectAdmin: isProjectAdmin,
        views: limitApproachingViews
    }), shouldShowLimitReachedFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jUgY0.LimitReachedFlag), {
        ...flagProps,
        isProjectAdmin: isProjectAdmin,
        views: limitReachedViews
    }));
};

});
parcelRegister("fBBEm", function(module, exports) {

$parcel$export(module.exports, "LimitApproachingFlag", () => $636a4b975dedc3e4$export$c8f47c0b0c12451c);

var $eUqFw = parcelRequire("eUqFw");

var $2bv8J = parcelRequire("2bv8J");

var $PdmhA = parcelRequire("PdmhA");

var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $eYo9A = parcelRequire("eYo9A");

var $9bPGO = parcelRequire("9bPGO");
const $636a4b975dedc3e4$var$LIMIT_APPROACHING_FLAG_ID = 'jsw-issue-approaching-reached-flag';
const $636a4b975dedc3e4$export$c8f47c0b0c12451c = ({ isCMP: isCMP, isProjectAdmin: isProjectAdmin, projectKey: projectKey, views: flagViews })=>{
    const [flagShown, setFlagShown] = (0, $eUqFw.useState)(false);
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const flagActions = (0, $eYo9A.useFlagActions)({
        isProjectAdmin: isProjectAdmin,
        isCMP: isCMP,
        projectKey: projectKey,
        flagType: 'approaching'
    });
    const views = flagViews.map((v)=>v.view);
    (0, $eUqFw.useEffect)(()=>{
        const getFlagTitle = ()=>{
            if (isCMP) return views[0] === 'BOARD' ? (0, $9bPGO.default).boardLimitApproachingFlagTitle : (0, $9bPGO.default).backlogLimitApproachingFlagTitle;
            if (views.includes('BACKLOG') && views.includes('SPRINTS')) return (0, $9bPGO.default).tmpBacklogSprintsLimitApproachingFlagTitle;
            if (views.includes('BACKLOG') && views.includes('BOARD')) return (0, $9bPGO.default).tmpBacklogBoardLimitApproachingFlagTitle;
            if (views.includes('BACKLOG')) return (0, $9bPGO.default).tmpBacklogLimitApproachingFlagTitle;
            if (views.includes('SPRINTS')) return (0, $9bPGO.default).tmpSprintsLimitApproachingFlagTitle;
            if (views.includes('BOARD')) return (0, $9bPGO.default).boardLimitApproachingFlagTitle;
            return (0, $9bPGO.default).boardLimitApproachingFlagTitle;
        };
        const getFlagMessage = ()=>{
            if (isCMP) {
                if (views[0] === 'BOARD') return isProjectAdmin ? (0, $9bPGO.default).boardLimitApproachingAdminFlagBody : (0, $9bPGO.default).boardLimitApproachingEndUserFlagBody;
                return isProjectAdmin ? (0, $9bPGO.default).backlogLimitApproachingAdminFlagBody : (0, $9bPGO.default).backlogLimitApproachingEndUserFlagBody;
            }
            if (views.includes('BACKLOG') && views.includes('SPRINTS')) return (0, $9bPGO.default).tmpBacklogSprintsLimitApproachingFlagBody;
            if (views.includes('BACKLOG') && views.includes('BOARD')) return (0, $9bPGO.default).tmpBacklogBoardLimitApproachingFlagBody;
            if (views.includes('BACKLOG')) return (0, $9bPGO.default).tmpBacklogLimitApproachingFlagBody;
            if (views.includes('SPRINTS')) return (0, $9bPGO.default).tmpSprintsLimitApproachingFlagBody;
            if (views.includes('BOARD')) return (0, $9bPGO.default).tmpBoardLimitApproachingFlagBody;
            return (0, $9bPGO.default).tmpBoardLimitApproachingFlagBody;
        };
        const flagTitle = getFlagTitle();
        const flagDescription = getFlagMessage();
        if (!flagShown) {
            showFlag({
                id: $636a4b975dedc3e4$var$LIMIT_APPROACHING_FLAG_ID,
                type: 'info',
                title: flagTitle,
                description: flagDescription,
                isAutoDismiss: false,
                actions: flagActions,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))), {
                    primaryColor: `var(--ds-icon-information, ${(0, $PdmhA).B300})`,
                    label: ""
                }),
                onDismissed: (_, analyticsEvent)=>{
                    if (analyticsEvent) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'jswIssueLimitApproachingFlag');
                }
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'flag shown', 'jswIssueLimitApproachingFlag');
        }
        setFlagShown(true);
    }, [
        showFlag,
        isProjectAdmin,
        flagActions,
        flagShown,
        createAnalyticsEvent,
        isCMP,
        views
    ]);
    return null;
};

});
parcelRegister("eYo9A", function(module, exports) {

$parcel$export(module.exports, "useFlagActions", () => $32ee2faec2d9108b$export$38e4a892c359139d);

var $eUqFw = parcelRequire("eUqFw");

var $3QLcd = parcelRequire("3QLcd");

var $jMP2a = parcelRequire("jMP2a");

var $5La9v = parcelRequire("5La9v");
const $32ee2faec2d9108b$var$CMP_ISSUE_LIMIT_SUPPORT_ARTICLE_URL = 'https://support.atlassian.com/jira-software-cloud/docs/issue-limits-in-company-managed-projects/';
const $32ee2faec2d9108b$var$CMP_ISSUE_LIMIT_IPH_ARTICLE_ID = '1KMwTxMBNiDPhaHMDlfT4u';
function $32ee2faec2d9108b$export$d53148a666867fe1(flagSource) {
    return {
        content: (0, $5La9v.default).editFilterCta,
        href: `${window.location.pathname}?config=filter`,
        onClick: (_, analyticsEvent)=>{
            if (analyticsEvent) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'editBoardFilter', {
                flagSource: flagSource
            });
        }
    };
}
function $32ee2faec2d9108b$export$72a228c0f924aef1(flagSource) {
    return {
        content: (0, $5La9v.default).viewMoreInfoCta,
        href: $32ee2faec2d9108b$var$CMP_ISSUE_LIMIT_SUPPORT_ARTICLE_URL,
        target: '_blank',
        onClick: (_, analyticsEvent)=>{
            if (analyticsEvent) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'cmpIssueLimitSupportArticle', {
                flagSource: flagSource
            });
        }
    };
}
function $32ee2faec2d9108b$export$d49a14b48e551259(flagSource, setIPHArticleId) {
    return {
        content: (0, $5La9v.default).viewMoreInfoCta,
        onClick: (_, analyticsEvent)=>{
            setIPHArticleId?.($32ee2faec2d9108b$var$CMP_ISSUE_LIMIT_IPH_ARTICLE_ID);
            if (analyticsEvent) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'cmpIssueLimitIph', {
                flagSource: flagSource
            });
        }
    };
}
const $32ee2faec2d9108b$export$226a1330ff7e389b = (projectKey)=>({
        content: (0, $5La9v.default).seeIssuesInSearchCta,
        href: `/issues/?jql=${encodeURIComponent(`project = ${projectKey} ORDER BY rank ASC`)}`
    });
const $32ee2faec2d9108b$export$2ca20f1de5f009d2 = {
    content: (0, $5La9v.default).viewMoreInfoCta,
    href: 'TBD'
};
const $32ee2faec2d9108b$export$38e4a892c359139d = ({ isProjectAdmin: isProjectAdmin, isCMP: isCMP, projectKey: projectKey, flagType: flagType })=>{
    const setIPHArticleId = (0, $3QLcd.useHelpPanelLink)();
    const flagSource = flagType === 'approaching' ? 'jswIssueLimitApproachingFlag' : 'jswIssueLimitReachedFlag';
    return (0, $eUqFw.useMemo)(()=>{
        if (isCMP) {
            if (isProjectAdmin) return [
                $32ee2faec2d9108b$export$d53148a666867fe1(flagSource),
                $32ee2faec2d9108b$export$d49a14b48e551259(flagSource, setIPHArticleId)
            ];
            return [
                $32ee2faec2d9108b$export$72a228c0f924aef1(flagSource)
            ];
        }
        return [
            $32ee2faec2d9108b$export$226a1330ff7e389b(projectKey),
            $32ee2faec2d9108b$export$2ca20f1de5f009d2
        ];
    }, [
        isCMP,
        projectKey,
        isProjectAdmin,
        flagSource,
        setIPHArticleId
    ]);
};

});
parcelRegister("5La9v", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac06a05889cc82d2$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ac06a05889cc82d2$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    editFilterCta: {
        "id": "software-issue-limit-flags.common.edit-filter-cta",
        "defaultMessage": "Edit filter"
    },
    viewMoreInfoCta: {
        "id": "software-issue-limit-flags.common.view-more-info-cta",
        "defaultMessage": "More about issue limits"
    },
    seeIssuesInSearchCta: {
        "id": "software-issue-limit-flags.common.see-issues-in-search-cta",
        "defaultMessage": "See issues in search"
    }
});

});


parcelRegister("9bPGO", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0d7972f2d3d3c7f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f0d7972f2d3d3c7f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    backlogLimitApproachingFlagTitle: {
        "id": "software-issue-limit-flags.limit-approaching-flag.backlog-limit-approaching-flag-title",
        "defaultMessage": "Your backlog is almost full"
    },
    backlogLimitApproachingAdminFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.backlog-limit-approaching-admin-flag-body",
        "defaultMessage": "The backlog can display up to 5000 issues. Edit your board filter to refine what's included and excluded."
    },
    backlogLimitApproachingEndUserFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.backlog-limit-approaching-end-user-flag-body",
        "defaultMessage": "The backlog can display up to 5000 issues. The admin who created the board filter can refine what's included and excluded."
    },
    boardLimitApproachingFlagTitle: {
        "id": "software-issue-limit-flags.limit-approaching-flag.board-limit-approaching-flag-title",
        "defaultMessage": "Your board is almost full"
    },
    boardLimitApproachingAdminFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.board-limit-approaching-admin-flag-body",
        "defaultMessage": "The board can display up to 5000 issues. Edit your board filter to refine what's included and excluded."
    },
    boardLimitApproachingEndUserFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.board-limit-approaching-end-user-flag-body",
        "defaultMessage": "The board can display up to 5000 issues. The admin who created the board filter can refine what's included and excluded."
    },
    tmpBacklogLimitApproachingFlagTitle: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-limit-approaching-flag-title",
        "defaultMessage": "Your backlog is almost full"
    },
    tmpSprintsLimitApproachingFlagTitle: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-sprints-limit-approaching-flag-title",
        "defaultMessage": "Your sprint section is almost full"
    },
    tmpBacklogSprintsLimitApproachingFlagTitle: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-sprints-limit-approaching-flag-title",
        "defaultMessage": "Your backlog and sprint sections are almost full"
    },
    tmpBacklogBoardLimitApproachingFlagTitle: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-board-limit-approaching-flag-title",
        "defaultMessage": "Your backlog and board sections are almost full"
    },
    tmpBoardLimitApproachingFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-board-limit-approaching-flag-body",
        "defaultMessage": "The board can only display up to 5000 issues. It might be time to move some issues."
    },
    tmpBacklogLimitApproachingFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-limit-approaching-flag-body",
        "defaultMessage": "The backlog can display up to 5000 issues. It might be time to move some issues."
    },
    tmpSprintsLimitApproachingFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-sprints-limit-approaching-flag-body",
        "defaultMessage": "We can only display up to 5000 issues across all your sprints. It might be time to move some issues."
    },
    tmpBacklogSprintsLimitApproachingFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-sprints-limit-approaching-flag-body",
        "defaultMessage": "Your backlog and sprint sections can each only display up to 5000 issues. It might be time to move some issues."
    },
    tmpBacklogBoardLimitApproachingFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-board-limit-approaching-flag-body",
        "defaultMessage": "Your backlog and board sections can each only display up to 5000 issues. It might be time to move some issues."
    }
});

});


parcelRegister("jUgY0", function(module, exports) {

$parcel$export(module.exports, "LimitReachedFlag", () => $b7de2f4bc970a890$export$b4f3bdfaaded5337);

var $dRvsP = parcelRequire("dRvsP");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $jDNSq = parcelRequire("jDNSq");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gd0Sp = parcelRequire("gd0Sp");

var $eYo9A = parcelRequire("eYo9A");

var $ej6O0 = parcelRequire("ej6O0");
const $b7de2f4bc970a890$var$LIMIT_REACHED_FLAG_ID = 'jsw-issue-limit-reached-flag';
const $b7de2f4bc970a890$export$b4f3bdfaaded5337 = ({ boardId: boardId, isProjectAdmin: isProjectAdmin, isCMP: isCMP, projectKey: projectKey, views: flagViews })=>{
    const [flagShown, setFlagShown] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const views = flagViews.map((flagView)=>flagView.view);
    const shouldFetchTotalCount = views.length === 1 && [
        'BACKLOG',
        'BOARD'
    ].includes(views[0]);
    const data = (0, $iWLL0.useLazyLoadQuery)((0, $dRvsP.default), {
        cloudId: cloudId,
        issueSearchInput: {
            customInput: {
                jiraSoftwareInput: {
                    context: views[0] === 'BOARD' ? 'BOARD' : 'BACKLOG',
                    jiraEntityId: (0, $jDNSq.JiraSoftwareBoardAri).create({
                        boardId: boardId.toString(),
                        siteId: cloudId
                    }).toString()
                }
            }
        },
        skip: !shouldFetchTotalCount
    }, {
        fetchPolicy: 'network-only'
    });
    const totalCount = data.jira?.issueSearchTotalCount;
    const flagActions = (0, $eYo9A.useFlagActions)({
        isProjectAdmin: isProjectAdmin,
        isCMP: isCMP,
        projectKey: projectKey,
        flagType: 'reached'
    });
    (0, $eUqFw.useEffect)(()=>{
        if (shouldFetchTotalCount && typeof totalCount !== 'number') return;
        const getFlagTitle = ()=>{
            if (isCMP) return views[0] === 'BOARD' ? (0, $ej6O0.default).boardLimitReachedFlagTitle : (0, $ej6O0.default).backlogLimitReachedFlagTitle;
            if (views.includes('BACKLOG') && views.includes('SPRINTS')) return (0, $ej6O0.default).tmpBacklogSprintsLimitReachedFlagTitle;
            if (views.includes('BACKLOG') && views.includes('BOARD')) return (0, $ej6O0.default).tmpBacklogBoardLimitReachedFlagTitle;
            if (views.includes('BACKLOG')) return (0, $ej6O0.default).tmpBacklogLimitReachedFlagTitle;
            if (views.includes('SPRINTS')) return (0, $ej6O0.default).tmpSprintsLimitReachedFlagTitle;
            if (views.includes('BOARD')) return (0, $ej6O0.default).boardLimitReachedFlagTitle;
            return (0, $ej6O0.default).boardLimitReachedFlagTitle;
        };
        const getFlagMessage = ()=>{
            if (isCMP) {
                if (views[0] === 'BOARD') return isProjectAdmin ? (0, $ej6O0.default).boardLimitReachedAdminFlagBody : (0, $ej6O0.default).boardLimitReachedEndUserFlagBody;
                return isProjectAdmin ? (0, $ej6O0.default).backlogLimitReachedAdminFlagBody : (0, $ej6O0.default).backlogLimitReachedEndUserFlagBody;
            }
            if (views.includes('BACKLOG') && views.includes('SPRINTS')) return (0, $ej6O0.default).tmpBacklogSprintsLimitReachedFlagBody;
            if (views.includes('BACKLOG') && views.includes('BOARD')) return (0, $ej6O0.default).tmpBacklogBoardLimitReachedFlagBody;
            if (views.includes('BACKLOG')) return (0, $ej6O0.default).tmpBacklogLimitReachedFlagBody;
            if (views.includes('SPRINTS')) return (0, $ej6O0.default).tmpSprintsLimitReachedFlagBody;
            if (views.includes('BOARD')) return (0, $ej6O0.default).tmpBoardLimitReachedFlagBody;
            return (0, $ej6O0.default).tmpBoardLimitReachedFlagBody;
        };
        const flagTitle = getFlagTitle();
        const flagDescription = getFlagMessage();
        if (!flagShown) {
            showFlag({
                id: $b7de2f4bc970a890$var$LIMIT_REACHED_FLAG_ID,
                type: 'warning',
                title: flagTitle,
                description: formatMessage(flagDescription, {
                    issueCount: totalCount
                }),
                isAutoDismiss: false,
                actions: flagActions,
                onDismissed: (_, analyticsEvent)=>{
                    if (analyticsEvent) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'jswIssueLimitReachedFlag', {
                        totalIssueCount: totalCount
                    });
                }
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'flag shown', 'jswIssueLimitReachedFlag', {
                totalIssueCount: totalCount
            });
            setFlagShown(true);
        }
    }, [
        formatMessage,
        showFlag,
        isProjectAdmin,
        flagActions,
        totalCount,
        flagShown,
        createAnalyticsEvent,
        isCMP,
        shouldFetchTotalCount,
        views
    ]);
    return null;
};

});
parcelRegister("dRvsP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec14246d057fb35c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5081ebe1b7c763d83be8f11da4336340>>
 * @relayHash 16968863187b798a94c81fb2f3c02587
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1d92172fafa12a38c14a21764204ae490c41baf36eb55b3ec10622230a6ef256
const $ec14246d057fb35c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueSearchInput"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skip"
        }
    ], v1 = [
        {
            "condition": "skip",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "issueSearchInput",
                                    "variableName": "issueSearchInput"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "issueSearchTotalCount"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "limitReachedFlagTotalIssueCountQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "limitReachedFlagTotalIssueCountQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "1d92172fafa12a38c14a21764204ae490c41baf36eb55b3ec10622230a6ef256",
            "metadata": {},
            "name": "limitReachedFlagTotalIssueCountQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ec14246d057fb35c$var$node.hash = "1b2bcb6691b0c1b0f0f93eb3b32f4323";
var $ec14246d057fb35c$export$2e2bcd8739ae039 = $ec14246d057fb35c$var$node;

});

parcelRegister("ej6O0", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf1ecdc5e2801759$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $bf1ecdc5e2801759$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    backlogLimitReachedFlagTitle: {
        "id": "software-issue-limit-flags.limit-reached-flag.backlog-limit-reached-flag-title",
        "defaultMessage": "Your backlog is full"
    },
    backlogLimitReachedAdminFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.backlog-limit-reached-admin-flag-body",
        "defaultMessage": "The backlog can only display 5000 issues, and your current filter contains {issueCount}. Edit your filter to refine what's included and excluded."
    },
    backlogLimitReachedEndUserFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.backlog-limit-reached-end-user-flag-body",
        "defaultMessage": "The backlog can only display 5000 issues, and the current filter contains {issueCount}. An admin will need to edit the board filter to refine what's included and excluded."
    },
    boardLimitReachedFlagTitle: {
        "id": "software-issue-limit-flags.limit-reached-flag.board-limit-reached-flag-title",
        "defaultMessage": "Your board is full"
    },
    boardLimitReachedAdminFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.board-limit-reached-admin-flag-body",
        "defaultMessage": "The board can only display 5000 issues, and your current filter contains {issueCount}. Edit your filter to refine what's included and excluded."
    },
    boardLimitReachedEndUserFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.board-limit-reached-end-user-flag-body",
        "defaultMessage": "The board can only display 5000 issues, and the current filter contains {issueCount}. An admin will need to edit the board filter to refine what's included and excluded."
    },
    tmpBacklogSprintsLimitReachedFlagTitle: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-sprints-limit-reached-flag-title",
        "defaultMessage": "Your backlog and sprint sections are full"
    },
    tmpSprintsLimitReachedFlagTitle: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-sprints-limit-reached-flag-title",
        "defaultMessage": "Your sprint section is full"
    },
    tmpBacklogLimitReachedFlagTitle: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-limit-reached-flag-title",
        "defaultMessage": "Your backlog is full"
    },
    tmpBacklogBoardLimitReachedFlagTitle: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-board-limit-reached-flag-title",
        "defaultMessage": "Your backlog and board sections are full"
    },
    tmpBoardLimitReachedFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-board-limit-reached-flag-body",
        "defaultMessage": "The board can only display 5000 issues, and your current board contains {issueCount}. It's time to move some issues."
    },
    tmpBacklogSprintsLimitReachedFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-sprints-limit-reached-flag-body",
        "defaultMessage": "Your backlog and sprint sections can each only display 5000 issues. It's time to move some issues."
    },
    tmpSprintsLimitReachedFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-sprints-limit-reached-flag-body",
        "defaultMessage": "We can only display 5000 issues across all your sprints. It's time to move some issues."
    },
    tmpBacklogLimitReachedFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-limit-reached-flag-body",
        "defaultMessage": "The backlog can only display 5000 issues, and your current backlog contains {issueCount}. It's time to move some issues."
    },
    tmpBacklogBoardLimitReachedFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-board-limit-reached-flag-body",
        "defaultMessage": "Your backlog and board sections can each only display 5000 issues. It's time to move some issues."
    }
});

});




parcelRegister("fijOW", function(module, exports) {

$parcel$export(module.exports, "default", () => $68bf4db62e7e9525$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $68bf4db62e7e9525$var$LazyProjectKeyboardShortcuts = (0, $7rh0R.lazy)(()=>(parcelRequire("kc1HY")), {
    moduleId: "./src/packages/software/keyboard-shortcuts/src/ui/project-shortcuts/main.tsx"
});
/**
 * Binds keyboard shortcuts to navigate to the respective experience when enabled:
 * 1 - Backlog
 * 2 - Board
 * 3 - Reports
 * 4 - Timeline
 */ const $68bf4db62e7e9525$var$ProjectKeyboardShortcuts = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "jira-software-keyboard-shortcuts-project-shortcuts",
        packageName: "jira-software-keyboard-shortcuts",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jira-software-keyboard-shortcuts",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($68bf4db62e7e9525$var$LazyProjectKeyboardShortcuts, props)));
var $68bf4db62e7e9525$export$2e2bcd8739ae039 = $68bf4db62e7e9525$var$ProjectKeyboardShortcuts;

});
parcelRegister("kc1HY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('28hU0')
        ]);
        const value = parcelRequire('8aQut');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("28hU0")
    ]).then(()=>parcelRequire('8aQut'));
}

});


parcelRegister("cyQ1m", function(module, exports) {

$parcel$export(module.exports, "StorageLimitsBanner", () => $dfd96f3cb7f5a040$export$3250e2c90ae56dd9);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $dfd96f3cb7f5a040$var$LazyStorageLimitBanner = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("d5jIw")), {
    ssr: false,
    moduleId: "./src/packages/growth/storage-limits/src/ui/index.tsx"
});
const $dfd96f3cb7f5a040$export$3250e2c90ae56dd9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: (0, $8cd287fa797c55ed$export$5dec3c05c01dac30),
        packageName: (0, $8cd287fa797c55ed$export$b8b9d90f9e5bd72b),
        teamName: "flywheel-tako",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "storage-limits-banner",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dfd96f3cb7f5a040$var$LazyStorageLimitBanner, props)));

});
const $8cd287fa797c55ed$export$bab748d4654ac4a5 = 0.9;
const $8cd287fa797c55ed$export$b8b9d90f9e5bd72b = 'jiraGrowthStorageLimits';
const $8cd287fa797c55ed$export$df9953733f41292a = 'storageLimitsBanner';
const $8cd287fa797c55ed$export$5dec3c05c01dac30 = 'asyncStorageLimitsBanner';
const $8cd287fa797c55ed$export$3aad3de2cc377789 = 'jira_software_free_is_ccp_billing_admins';

parcelRegister("d5jIw", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('iBTRu');
        const value = parcelRequire('i4DKK');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("iBTRu").then(()=>parcelRequire('i4DKK'));
}

});


parcelRegister("8HMCF", function(module, exports) {

$parcel$export(module.exports, "UpFlowPersistentUpgradeBanner", () => $1ded51f6d1fe0671$export$39832316603e4613);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

var $bNa2U = parcelRequire("bNa2U");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1ded51f6d1fe0671$var$LazyUpFlowPersistentUpgradeBanner = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("7dvmu")), {
    ssr: false,
    moduleId: "./src/packages/growth/up-flow/persistent-upgrade-banner/src/main.tsx"
});
const $1ded51f6d1fe0671$export$39832316603e4613 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: (0, $bNa2U.PERSISTENT_UPGRADE_ANALYTICS_SOURCE),
        packageName: (0, $bNa2U.PERSISTENT_UPGRADE_TOUCHPOINT_BANNER),
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "up-flow-persistent-upgrade-banner",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1ded51f6d1fe0671$var$LazyUpFlowPersistentUpgradeBanner, props)));

});
parcelRegister("bNa2U", function(module, exports) {

$parcel$export(module.exports, "PERSISTENT_UPGRADE_PRE_TRIAL_FREE_EDITION", () => $d4c4bcb569ddbdc8$export$75e961f06f21e171);
$parcel$export(module.exports, "PERSISTENT_UPGRADE_ANALYTICS_SOURCE", () => $d4c4bcb569ddbdc8$export$bebf43b5d37dab0);
$parcel$export(module.exports, "PERSISTENT_UPGRADE_ANALYTICS_UPGRADE_FLOW", () => $d4c4bcb569ddbdc8$export$cbfd75a8d4af5ce5);
$parcel$export(module.exports, "PERSISTENT_UPGRADE_UPFLOW_MODAL_FLOW", () => $d4c4bcb569ddbdc8$export$a2684b22124cc502);
$parcel$export(module.exports, "PERSISTENT_UPGRADE_TOUCHPOINT_BANNER", () => $d4c4bcb569ddbdc8$export$e54a73280ddbd89);
$parcel$export(module.exports, "PERSISTENT_UPGRADE_TOUCHPOINT_BANNER_VIEWED", () => $d4c4bcb569ddbdc8$export$96913d5371f745ad);
$parcel$export(module.exports, "MAX_CADENCE_INDEX", () => $d4c4bcb569ddbdc8$export$b8743c23616e54ee);
$parcel$export(module.exports, "KEY_USER_PROPERTIES_JSW", () => $d4c4bcb569ddbdc8$export$6a69b5601e7d435);
$parcel$export(module.exports, "KEY_USER_PROPERTIES_JSM", () => $d4c4bcb569ddbdc8$export$364c2b43630f5cb5);
$parcel$export(module.exports, "BANNER_CADENCE_INFO", () => $d4c4bcb569ddbdc8$export$ec6ce1b450620e5c);
$parcel$export(module.exports, "SEND_OPERATIONAL_EVENT", () => $d4c4bcb569ddbdc8$export$8b4682bf35504518);
$parcel$export(module.exports, "API_SUCCESS", () => $d4c4bcb569ddbdc8$export$6d01cae610456af2);
$parcel$export(module.exports, "API_FAIL", () => $d4c4bcb569ddbdc8$export$6a238c78062d3b8d);
$parcel$export(module.exports, "GET_USER_PROPERTY_API_CALL", () => $d4c4bcb569ddbdc8$export$d094ee3fcda994eb);
$parcel$export(module.exports, "GET_USER_PROPERTY_API_CALL_SUCCESS", () => $d4c4bcb569ddbdc8$export$8357ebd56fd8e5ea);
$parcel$export(module.exports, "GET_USER_PROPERTY_API_CALL_FAIL", () => $d4c4bcb569ddbdc8$export$252ee5e4ed4943dc);
$parcel$export(module.exports, "SET_USER_PROPERTY_API_CALL", () => $d4c4bcb569ddbdc8$export$f3310dd86ae4284b);
$parcel$export(module.exports, "SET_USER_PROPERTY_API_CALL_SUCCESS", () => $d4c4bcb569ddbdc8$export$5e4635b476d2b497);
$parcel$export(module.exports, "SET_USER_PROPERTY_API_CALL_FAIL", () => $d4c4bcb569ddbdc8$export$b49d6161d5ea4a0a);
$parcel$export(module.exports, "PERSISTENT_PRETRIAL_BANNER_CADENCES_MS", () => $d4c4bcb569ddbdc8$export$55aa1fd7f74b53);
const $d4c4bcb569ddbdc8$export$75e961f06f21e171 = 'pre-trial';
const $d4c4bcb569ddbdc8$export$bebf43b5d37dab0 = 'persistentUpgrade';
const $d4c4bcb569ddbdc8$export$cbfd75a8d4af5ce5 = 'upgradeFlow';
const $d4c4bcb569ddbdc8$export$a2684b22124cc502 = 'persistent-upgrade';
const $d4c4bcb569ddbdc8$export$e54a73280ddbd89 = 'persistentUpgradeBanner';
const $d4c4bcb569ddbdc8$export$96913d5371f745ad = 'persistentUpgradeBanner viewed';
const $d4c4bcb569ddbdc8$export$b8743c23616e54ee = 3;
const $d4c4bcb569ddbdc8$export$6a69b5601e7d435 = 'growth-puet-banner-cadence';
const $d4c4bcb569ddbdc8$export$364c2b43630f5cb5 = 'growth-puet-banner-cadence-jsm';
const $d4c4bcb569ddbdc8$export$ec6ce1b450620e5c = 'Banner Cadence Info';
const $d4c4bcb569ddbdc8$export$8b4682bf35504518 = 'sendOperationalEvent';
const $d4c4bcb569ddbdc8$export$6d01cae610456af2 = 'success';
const $d4c4bcb569ddbdc8$export$6a238c78062d3b8d = 'failed';
const $d4c4bcb569ddbdc8$export$d094ee3fcda994eb = 'getUserPropertyApiCall';
const $d4c4bcb569ddbdc8$export$8357ebd56fd8e5ea = 'getUserPropertyApiCall success';
const $d4c4bcb569ddbdc8$export$252ee5e4ed4943dc = 'getUserPropertyApiCall failed';
const $d4c4bcb569ddbdc8$export$f3310dd86ae4284b = 'setUserPropertyApiCall';
const $d4c4bcb569ddbdc8$export$5e4635b476d2b497 = 'setUserPropertyApiCall success';
const $d4c4bcb569ddbdc8$export$b49d6161d5ea4a0a = 'setUserPropertyApiCall failed';
const $d4c4bcb569ddbdc8$export$55aa1fd7f74b53 = [
    0,
    604800000,
    1814400000,
    3628800000
];

});

parcelRegister("7dvmu", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('g8JKE');
        const value = parcelRequire('27Md7');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("g8JKE").then(()=>parcelRequire('27Md7'));
}

});


parcelRegister("f2lzo", function(module, exports) {

$parcel$export(module.exports, "default", () => $4faccd5faba1e60c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lgxha = parcelRequire("lgxha");

var $fVeLa = parcelRequire("fVeLa");
const $4faccd5faba1e60c$var$AddBoardToHistory = ({ baseUrl: baseUrl, boardId: boardId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: ()=>(0, $fVeLa.addBoardToHistory)(baseUrl, boardId)
    });
var $4faccd5faba1e60c$export$2e2bcd8739ae039 = $4faccd5faba1e60c$var$AddBoardToHistory;

});
parcelRegister("fVeLa", function(module, exports) {

$parcel$export(module.exports, "addBoardToHistory", () => $778ed0839b67eb43$export$eef897770c591084);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");
const $778ed0839b67eb43$export$eef897770c591084 = (baseUrl, boardId)=>(0, $lRmyA.performPostRequest)(`${baseUrl}/rest/greenhopper/1.0/rapidview/addtohistory`, {
        body: JSON.stringify({
            rapidViewId: boardId
        })
    }).catch((e)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('software.view-history.src.services', 'Cannot add board to recent history', e);
    });

});


parcelRegister("j258X", function(module, exports) {

$parcel$export(module.exports, "useIsCMPBacklog", () => $4db9b8f04472d2e9$export$7154dac79ee0a0dc);
$parcel$export(module.exports, "useIsCMPKanbanBacklog", () => $4db9b8f04472d2e9$export$fedd46f53876dc1c);

var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");
const $4db9b8f04472d2e9$export$7154dac79ee0a0dc = ()=>(0, $1gQ73.useBacklogSelector)((0, $hkGxG.getIsCompanyManaged));
const $4db9b8f04472d2e9$export$fedd46f53876dc1c = ()=>(0, $1gQ73.useBacklogSelector)((0, $hkGxG.isCmpKanbanProject));

});

parcelRegister("4lVbF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9de1727698547a02$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1gQ73 = parcelRequire("1gQ73");

var $bP7Jx = parcelRequire("bP7Jx");

var $1RKma = parcelRequire("1RKma");
const $9de1727698547a02$var$AllFieldsSync = ()=>{
    const cardIds = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getCardIds));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, cardIds.map((id)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1RKma.default), {
            key: id,
            cardId: id
        })));
};
var $9de1727698547a02$export$2e2bcd8739ae039 = $9de1727698547a02$var$AllFieldsSync;

});
parcelRegister("1RKma", function(module, exports) {

$parcel$export(module.exports, "default", () => $691e159c334a5093$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1gQ73 = parcelRequire("1gQ73");

var $bP7Jx = parcelRequire("bP7Jx");

var $giEkq = parcelRequire("giEkq");

var $SArW7 = parcelRequire("SArW7");

var $4WzV4 = parcelRequire("4WzV4");

var $jtcW7 = parcelRequire("jtcW7");

var $hpehJ = parcelRequire("hpehJ");

var $hP4Sq = parcelRequire("hP4Sq");

var $aBdHm = parcelRequire("aBdHm");
const $691e159c334a5093$var$FieldSync = ({ cardId: cardId })=>{
    const shouldSync = (0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.isCardSelected)(state)(cardId) || (0, $bP7Jx.shouldRenderRichElements)(state, {
            cardId: cardId
        }));
    const card = (0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.getCards)(state)[String(cardId)]);
    const intl = (0, $5JgJ2.default)();
    // don't unmount syncing if once enabled
    const [sync, setSync] = (0, $eUqFw.useState)(shouldSync);
    (0, $eUqFw.useEffect)(()=>{
        if (!sync && shouldSync) setSync(true);
    }, [
        sync,
        shouldSync
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (sync || shouldSync) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $SArW7.default), {
        card: card,
        intl: intl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hP4Sq.default), {
        card: card
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hpehJ.default), {
        card: card
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $giEkq.default), {
        card: card
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aBdHm.default), {
        card: card
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4WzV4.default), {
        card: card
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jtcW7.default), {
        card: card
    })));
};
var $691e159c334a5093$export$2e2bcd8739ae039 = $691e159c334a5093$var$FieldSync;

});
parcelRegister("giEkq", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b62ee574a84e5cb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6cPKE = parcelRequire("6cPKE");

var $kmr29 = parcelRequire("kmr29");


var $bQSj3 = parcelRequire("bQSj3");

var $1gQ73 = parcelRequire("1gQ73");

var $emJ23 = parcelRequire("emJ23");
const $1b62ee574a84e5cb$var$FieldSyncAssignee = ({ card: { key: key, id: id, assignee: assigneeFromBacklog } })=>{
    const { id: assigneeIdFromBacklog, displayName: assigneeNameFromBacklog, avatarUrl: assigneeAvatarUrlFromBacklog } = assigneeFromBacklog || {};
    const [assigneeFromExtractedFields, { setFieldValue: setAssigneeInExtractedFields }] = (0, $kmr29.useFieldValue)({
        issueKey: key,
        fieldKey: (0, $ebc098a76317be78$export$e18419056f3d184a)
    });
    const { accountId: assigneeIdFromExtractedFields, displayName: assigneeNameFromExtractedFields } = assigneeFromExtractedFields || {};
    const assigneeAvatarUrlFromExtractedFields = assigneeFromExtractedFields?.avatarUrls?.['48x48'];
    const assigneeFromBacklogChanged = (0, $bQSj3.useDiffCheck)([
        assigneeIdFromBacklog
    ]);
    const assigneeFromExtractedFieldsChanged = (0, $bQSj3.useDiffCheck)([
        assigneeIdFromExtractedFields
    ]);
    const setAssigneeInBacklog = (0, $1gQ73.useBacklogActionCreator)((0, $emJ23.cardAssigneeSet));
    const storesNeedToSync = assigneeIdFromBacklog !== assigneeIdFromExtractedFields;
    (0, $eUqFw.useEffect)(()=>{
        const assigneeFromBacklogIsDefined = assigneeFromBacklog !== undefined;
        // ASSIGNEE SYNC: BACKLOG -> EXTRACTED FIELDS
        // initial value, realtime...
        if (assigneeFromBacklogIsDefined && assigneeFromBacklogChanged && storesNeedToSync) setAssigneeInExtractedFields(key, (0, $ebc098a76317be78$export$e18419056f3d184a), // if assignee id is '', null or undefined => set assignee to null
        assigneeIdFromBacklog ? (0, $6cPKE.getUserShape)(assigneeIdFromBacklog, // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        assigneeNameFromBacklog, assigneeAvatarUrlFromBacklog) : null);
    }, [
        key,
        assigneeFromBacklog,
        assigneeIdFromBacklog,
        assigneeNameFromBacklog,
        assigneeAvatarUrlFromBacklog,
        assigneeFromBacklogChanged,
        storesNeedToSync,
        setAssigneeInExtractedFields
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const assigneeFromExtractedFieldsIsDefined = assigneeFromExtractedFields !== undefined;
        // ASSIGNEE SYNC: EXTRACTED FIELDS -> BACKLOG REDUX
        // issue view updates, inline assignee edit...
        if (// Ensure no sync will be called by Backlog as Backlog is the driver
        !assigneeFromBacklogChanged && assigneeFromExtractedFieldsIsDefined && assigneeFromExtractedFieldsChanged && storesNeedToSync) setAssigneeInBacklog(id, // if assignee id is '', null or undefined => set assignee to null
        assigneeIdFromExtractedFields ? {
            id: assigneeIdFromExtractedFields,
            displayName: assigneeNameFromExtractedFields,
            avatarUrl: assigneeAvatarUrlFromExtractedFields
        } : null);
    }, [
        id,
        assigneeFromBacklogChanged,
        assigneeFromExtractedFields,
        assigneeIdFromExtractedFields,
        assigneeNameFromExtractedFields,
        assigneeAvatarUrlFromExtractedFields,
        assigneeFromExtractedFieldsChanged,
        storesNeedToSync,
        setAssigneeInBacklog
    ]);
    return null;
};
var $1b62ee574a84e5cb$export$2e2bcd8739ae039 = $1b62ee574a84e5cb$var$FieldSyncAssignee;

});
parcelRegister("bQSj3", function(module, exports) {

$parcel$export(module.exports, "useDiffCheck", () => $3d0ab22c41cd2c70$export$5ade32966816005f);

var $eUqFw = parcelRequire("eUqFw");
const $3d0ab22c41cd2c70$export$5ade32966816005f = (nextValues = [])=>{
    const ref = (0, $eUqFw.useRef)([]);
    const prevValues = ref.current;
    ref.current = nextValues;
    return prevValues.length ? prevValues.some((value, i)=>nextValues[i] !== value) : false;
};

});


parcelRegister("SArW7", function(module, exports) {

$parcel$export(module.exports, "default", () => $34cdf6ca6c775adb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kmr29 = parcelRequire("kmr29");


var $7v0hO = parcelRequire("7v0hO");

var $bQSj3 = parcelRequire("bQSj3");

var $1gQ73 = parcelRequire("1gQ73");

var $bxHyy = parcelRequire("bxHyy");

var $hkGxG = parcelRequire("hkGxG");

var $1ircG = parcelRequire("1ircG");
const $34cdf6ca6c775adb$var$FieldSyncOriginalEstimate = ({ card: { id: id, key: key, estimate: estimate }, intl: intl })=>{
    const timeTrackingOptions = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getTimeTrackingOptions));
    const isOriginalEstimateType = (0, $1gQ73.useBacklogSelector)((0, $1ircG.isOriginalEstimateTypeSelector));
    const setOriginalEstimateInBacklog = (0, $1gQ73.useBacklogActionCreator)((cardId, value)=>{
        const originalEstimate = value === null ? null : {
            value: value,
            valueAsText: (0, $7v0hO.timeTrackingFormatter)(value, timeTrackingOptions, intl)
        };
        return (0, $bxHyy.cardEstimateSet)(cardId, {
            originalEstimate: originalEstimate
        });
    });
    const estimateFromBacklog = estimate?.originalEstimate;
    const originalEstimateFromBacklog = estimateFromBacklog?.value ?? null;
    // This hook updates the state used by bento in the field value service. It's necessary to provide the initial value
    // and to update the bento store when the original estimate changes from elsewhere in the backlog
    const [originalEstimateFromExtractedFields, { setFieldValue: setOriginalEstimateInExtractedFields }] = (0, $kmr29.useFieldValue)({
        issueKey: key,
        fieldKey: (0, $ebc098a76317be78$export$5fbd3b15555b9ef2)
    });
    const originalEstimateFromBacklogChanged = (0, $bQSj3.useDiffCheck)([
        originalEstimateFromBacklog
    ]);
    const originalEstimateFromExtractedFieldsChanged = (0, $bQSj3.useDiffCheck)([
        originalEstimateFromExtractedFields
    ]);
    const storesNeedToSync = originalEstimateFromBacklog !== originalEstimateFromExtractedFields;
    (0, $eUqFw.useEffect)(()=>{
        const originalEstimateFromBacklogIsDefined = estimateFromBacklog !== undefined;
        const shouldSync = originalEstimateFromBacklogIsDefined && originalEstimateFromBacklogChanged && storesNeedToSync && isOriginalEstimateType;
        // ORIGINAL ESTIMATE SYNC: BACKLOG -> EXTRACTED FIELDS
        // Update sweet state (extracted field) when the original estimate value changes elsewhere or the card is initially rendered
        if (shouldSync) setOriginalEstimateInExtractedFields(key, (0, $ebc098a76317be78$export$5fbd3b15555b9ef2), originalEstimateFromBacklog);
    }, [
        key,
        estimateFromBacklog,
        originalEstimateFromBacklog,
        originalEstimateFromBacklogChanged,
        storesNeedToSync,
        setOriginalEstimateInExtractedFields,
        isOriginalEstimateType
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const originalEstimateFromExtractedFieldsIsDefined = originalEstimateFromExtractedFields !== undefined;
        const shouldSync = !originalEstimateFromBacklogChanged && originalEstimateFromExtractedFieldsIsDefined && originalEstimateFromExtractedFieldsChanged && storesNeedToSync && isOriginalEstimateType;
        // ORIGINAL ESTIMATE SYNC: EXTRACTED FIELDS -> BACKLOG
        // Update the backlog store if the value of the original estimate is changed within extracted fields
        if (shouldSync) setOriginalEstimateInBacklog(id, originalEstimateFromExtractedFields);
    }, [
        id,
        originalEstimateFromBacklogChanged,
        originalEstimateFromExtractedFields,
        originalEstimateFromExtractedFieldsChanged,
        storesNeedToSync,
        setOriginalEstimateInBacklog,
        isOriginalEstimateType
    ]);
    return null;
};
var $34cdf6ca6c775adb$export$2e2bcd8739ae039 = $34cdf6ca6c775adb$var$FieldSyncOriginalEstimate;

});
parcelRegister("7v0hO", function(module, exports) {

$parcel$export(module.exports, "timeTrackingFormatter", () => $84936c9163886c98$export$5169d8c8f9327e33);
$parcel$export(module.exports, "timeTrackingFormatterLongForm", () => $84936c9163886c98$export$bb4e82d8c2aeeff1);
$parcel$export(module.exports, "transformAGGToJiraTimeFormat", () => $84936c9163886c98$export$9dccd3a07969375d);
$parcel$export(module.exports, "transformAGGToJiraTimeUnit", () => $84936c9163886c98$export$8516173ab945b52f);

var $4m36T = parcelRequire("4m36T");

var $eyAhE = parcelRequire("eyAhE");
// Format time to be 2 decimal places without trailing zeros
const $84936c9163886c98$var$timeFormatter = (time, unit)=>time > 0 ? `${time.toFixed(2).replace(/\.?0+$/, '')}${unit}` : `0${unit}`;
const $84936c9163886c98$var$timePrettyFormatter = (timeInSeconds, units)=>{
    const timeForZero = `0${units[3].suffix}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        const secondsRemaining = currentTimeValue > 0 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 0 ? `${timeObj.time} ${currentTimeValue}${unit.suffix}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $84936c9163886c98$var$timePrettyFormatterLongForm = (timeInSeconds, units)=>{
    const timeForZero = `0${units[7].suffix}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        if (unit?.isSingular) {
            if (currentTimeValue === 1) return {
                secondsRemaining: timeObj.secondsRemaining % unit.seconds,
                time: `${timeObj.time} ${currentTimeValue}${unit.suffix}`
            };
            return timeObj;
        }
        const secondsRemaining = currentTimeValue > 1 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 1 ? `${timeObj.time} ${currentTimeValue}${unit.suffix}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $84936c9163886c98$export$5169d8c8f9327e33 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $4m36T.defaultTimeTrackingOptions), { formatMessage: formatMessage })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const units = [
        {
            suffix: formatMessage((0, $eyAhE.default).timeUnitWeek),
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR)
        },
        {
            suffix: formatMessage((0, $eyAhE.default).timeUnitDay),
            seconds: Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR)
        },
        {
            suffix: formatMessage((0, $eyAhE.default).timeUnitHour),
            seconds: (0, $4m36T.SECONDS_PER_HOUR)
        },
        {
            suffix: formatMessage((0, $eyAhE.default).timeUnitMinute),
            seconds: (0, $4m36T.SECONDS_PER_MINUTE)
        }
    ];
    switch(timeFormat){
        case (0, $4m36T.TimeFormats).DAYS:
            return $84936c9163886c98$var$timeFormatter(isTimeInDaysValid ? timeInSeconds / units[1].seconds : 0, units[1].suffix);
        case (0, $4m36T.TimeFormats).HOURS:
            return $84936c9163886c98$var$timeFormatter(isTimeValid ? timeInSeconds / units[2].seconds : 0, units[2].suffix);
        case (0, $4m36T.TimeFormats).PRETTY:
        default:
            return $84936c9163886c98$var$timePrettyFormatter(timeInSeconds, units);
    }
};
const $84936c9163886c98$export$71be3aa954f6065b = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat }, intl)=>{
    const timeTrackingSettings = {
        workingHoursPerDay: workingHoursPerDay || (0, $4m36T.defaultTimeTrackingOptions).workingHoursPerDay,
        workingDaysPerWeek: workingDaysPerWeek || (0, $4m36T.defaultTimeTrackingOptions).workingDaysPerWeek,
        timeFormat: timeFormat || (0, $4m36T.defaultTimeTrackingOptions).timeFormat,
        defaultUnit: (0, $4m36T.defaultTimeTrackingOptions).defaultUnit
    };
    return $84936c9163886c98$export$5169d8c8f9327e33(timeInSeconds || 0, timeTrackingSettings, intl);
};
const $84936c9163886c98$export$bb4e82d8c2aeeff1 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $4m36T.defaultTimeTrackingOptions), { formatMessage: formatMessage })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const units = [
        {
            suffix: ` ${formatMessage((0, $eyAhE.default).timeUnitLongWeekSingular)}`,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR),
            isSingular: true
        },
        {
            suffix: ` ${formatMessage((0, $eyAhE.default).timeUnitLongWeekPlural)}`,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR)
        },
        {
            suffix: ` ${formatMessage((0, $eyAhE.default).timeUnitLongDaySingular)}`,
            seconds: Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR),
            isSingular: true
        },
        {
            suffix: ` ${formatMessage((0, $eyAhE.default).timeUnitLongDayPlural)}`,
            seconds: Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR)
        },
        {
            suffix: ` ${formatMessage((0, $eyAhE.default).timeUnitLongHourSingular)}`,
            seconds: (0, $4m36T.SECONDS_PER_HOUR),
            isSingular: true
        },
        {
            suffix: ` ${formatMessage((0, $eyAhE.default).timeUnitLongHourPlural)}`,
            seconds: (0, $4m36T.SECONDS_PER_HOUR)
        },
        {
            suffix: ` ${formatMessage((0, $eyAhE.default).timeUnitLongMinuteSingular)}`,
            seconds: (0, $4m36T.SECONDS_PER_MINUTE),
            isSingular: true
        },
        {
            suffix: ` ${formatMessage((0, $eyAhE.default).timeUnitLongMinutePlural)}`,
            seconds: (0, $4m36T.SECONDS_PER_MINUTE)
        }
    ];
    switch(timeFormat){
        case (0, $4m36T.TimeFormats).DAYS:
            if (timeInSeconds === (0, $4m36T.SECONDS_PER_HOUR) * workingHoursPerDay) return $84936c9163886c98$var$timeFormatter(isTimeInDaysValid ? timeInSeconds / units[2].seconds : 0, units[2].suffix);
            return $84936c9163886c98$var$timeFormatter(isTimeInDaysValid ? timeInSeconds / units[3].seconds : 0, units[3].suffix);
        case (0, $4m36T.TimeFormats).HOURS:
            if (timeInSeconds === (0, $4m36T.SECONDS_PER_HOUR)) return $84936c9163886c98$var$timeFormatter(isTimeValid ? timeInSeconds / units[4].seconds : 0, units[4].suffix);
            return $84936c9163886c98$var$timeFormatter(isTimeValid ? timeInSeconds / units[5].seconds : 0, units[5].suffix);
        case (0, $4m36T.TimeFormats).PRETTY:
        default:
            return $84936c9163886c98$var$timePrettyFormatterLongForm(timeInSeconds, units);
    }
};
const $84936c9163886c98$export$9dccd3a07969375d = (format)=>{
    switch(String(format).toLowerCase()){
        case (0, $4m36T.TimeFormats).DAYS:
            return (0, $4m36T.TimeFormats).DAYS;
        case (0, $4m36T.TimeFormats).HOURS:
            return (0, $4m36T.TimeFormats).HOURS;
        case (0, $4m36T.TimeFormats).PRETTY:
            return (0, $4m36T.TimeFormats).PRETTY;
        default:
            return (0, $4m36T.TimeFormats).DAYS;
    }
};
const $84936c9163886c98$export$8516173ab945b52f = (defaultUnit)=>{
    switch(String(defaultUnit).toLowerCase()){
        case (0, $4m36T.TimeUnits).DAY:
            return (0, $4m36T.TimeUnits).DAY;
        case (0, $4m36T.TimeUnits).HOUR:
            return (0, $4m36T.TimeUnits).HOUR;
        case (0, $4m36T.TimeUnits).MINUTE:
            return (0, $4m36T.TimeUnits).MINUTE;
        case (0, $4m36T.TimeUnits).WEEK:
            return (0, $4m36T.TimeUnits).WEEK;
        default:
            return (0, $4m36T.TimeUnits).DAY;
    }
};

});
parcelRegister("eyAhE", function(module, exports) {

$parcel$export(module.exports, "default", () => $a93ae5507f3c0ae3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a93ae5507f3c0ae3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    timeUnitWeek: {
        "id": "time-tracking-formatter.time-unit-week",
        "defaultMessage": "w"
    },
    timeUnitDay: {
        "id": "time-tracking-formatter.time-unit-day",
        "defaultMessage": "d"
    },
    timeUnitHour: {
        "id": "time-tracking-formatter.time-unit-hour",
        "defaultMessage": "h"
    },
    timeUnitMinute: {
        "id": "time-tracking-formatter.time-unit-minute",
        "defaultMessage": "m"
    },
    timeUnitLongWeekPlural: {
        "id": "time-tracking-formatter.time-unit-long-week-plural",
        "defaultMessage": "weeks"
    },
    timeUnitLongDayPlural: {
        "id": "time-tracking-formatter.time-unit-long-day-plural",
        "defaultMessage": "days"
    },
    timeUnitLongHourPlural: {
        "id": "time-tracking-formatter.time-unit-long-hour-plural",
        "defaultMessage": "hours"
    },
    timeUnitLongMinutePlural: {
        "id": "time-tracking-formatter.time-unit-long-minute-plural",
        "defaultMessage": "minutes"
    },
    timeUnitLongWeekSingular: {
        "id": "time-tracking-formatter.time-unit-long-week-singular",
        "defaultMessage": "week"
    },
    timeUnitLongDaySingular: {
        "id": "time-tracking-formatter.time-unit-long-day-singular",
        "defaultMessage": "day"
    },
    timeUnitLongHourSingular: {
        "id": "time-tracking-formatter.time-unit-long-hour-singular",
        "defaultMessage": "hour"
    },
    timeUnitLongMinuteSingular: {
        "id": "time-tracking-formatter.time-unit-long-minute-singular",
        "defaultMessage": "minute"
    }
});

});



parcelRegister("4WzV4", function(module, exports) {

$parcel$export(module.exports, "default", () => $76a2debfd3c4a7c9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kmr29 = parcelRequire("kmr29");

var $51HAN = parcelRequire("51HAN");

var $lO4Or = parcelRequire("lO4Or");

var $bQSj3 = parcelRequire("bQSj3");

var $1gQ73 = parcelRequire("1gQ73");

var $cPwLN = parcelRequire("cPwLN");

var $k734R = parcelRequire("k734R");
const $76a2debfd3c4a7c9$var$FieldSyncParent = ({ card: { key: key, id: id, parentId: parentIdFromBacklog } })=>{
    const [parentFromExtractedFields, { setFieldValue: setParentInExtractedFields }] = (0, $kmr29.useFieldValue)({
        issueKey: key,
        fieldKey: (0, $lO4Or.PARENT_TYPE)
    });
    // parentId in cards is number | null
    const parentIdFromExtractedFields = parentFromExtractedFields?.id ? Number(parentFromExtractedFields.id) : null;
    const parentNameFromExtractedFields = parentFromExtractedFields?.fields?.summary ?? null;
    const parentColorFromExtractedFields = parentFromExtractedFields?.color ?? null;
    const parentIdFromBacklogChanged = (0, $bQSj3.useDiffCheck)([
        parentIdFromBacklog
    ]);
    const parentIdFromExtractedFieldsChanged = (0, $bQSj3.useDiffCheck)([
        parentIdFromExtractedFields
    ]);
    const storesNeedToSync = parentIdFromBacklog !== parentIdFromExtractedFields;
    const issueParents = (0, $1gQ73.useBacklogSelector)((0, $k734R.issueParentsSelector));
    const setParentInBacklog = (0, $1gQ73.useBacklogActionCreator)((0, $cPwLN.cardParentIdSet));
    (0, $eUqFw.useEffect)(()=>{
        const parentIdFromBacklogIsDefined = parentIdFromBacklog !== undefined;
        // PARENT SYNC: BACKLOG -> EXTRACTED FIELDS
        // initial value, realtime...
        if (parentIdFromBacklogIsDefined && parentIdFromBacklogChanged && storesNeedToSync) {
            const parent = issueParents.length && parentIdFromBacklog && issueParents.find((p)=>Number(p.id) === Number(parentIdFromBacklog));
            setParentInExtractedFields(key, (0, $lO4Or.PARENT_TYPE), parentIdFromBacklogIsDefined && parent ? (0, $51HAN.getParentShape)(parent.id, parent.key, parent.summary, {
                id: parent.issueType.id,
                name: parent.issueType.name,
                iconUrl: parent.issueType.iconUrl
            }) : null);
        }
    }, [
        key,
        storesNeedToSync,
        setParentInExtractedFields,
        parentIdFromBacklog,
        parentIdFromBacklogChanged,
        issueParents
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const parentIdFromExtractedFieldsIsDefined = parentIdFromExtractedFields !== undefined;
        // PARENT SYNC: EXTRACTED FIELDS -> BACKLOG REDUX
        // issue view updates, inline parent edit...
        if (// Ensure no sync will be called by Backlog as Backlog is the driver
        !parentIdFromBacklogChanged && parentIdFromExtractedFieldsIsDefined && parentIdFromExtractedFieldsChanged && storesNeedToSync) setParentInBacklog(id, parentIdFromExtractedFields);
    }, [
        id,
        storesNeedToSync,
        setParentInBacklog,
        parentIdFromExtractedFields,
        parentIdFromBacklogChanged,
        parentIdFromExtractedFieldsChanged
    ]);
    // update epic summary/color if it has been changed in the issue view
    (0, $eUqFw.useEffect)(()=>{
        const parent = issueParents.length && parentIdFromExtractedFields && issueParents.find((p)=>Number(p.id) === Number(parentIdFromExtractedFields));
        if (parent && (parentNameFromExtractedFields !== parent.summary || parentColorFromExtractedFields !== parent.color)) setParentInExtractedFields(key, (0, $lO4Or.PARENT_TYPE), (0, $51HAN.getParentShape)(parent.id, parent.key, parent.summary, {
            id: parent.issueType.id,
            name: parent.issueType.name,
            iconUrl: parent.issueType.iconUrl
        }, parent.color));
    }, [
        issueParents,
        key,
        parentColorFromExtractedFields,
        parentIdFromExtractedFields,
        parentNameFromExtractedFields,
        setParentInExtractedFields
    ]);
    return null;
};
var $76a2debfd3c4a7c9$export$2e2bcd8739ae039 = $76a2debfd3c4a7c9$var$FieldSyncParent;

});

parcelRegister("jtcW7", function(module, exports) {

$parcel$export(module.exports, "default", () => $e065a216bb78c726$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kmr29 = parcelRequire("kmr29");

var $lO4Or = parcelRequire("lO4Or");

var $bQSj3 = parcelRequire("bQSj3");

var $1gQ73 = parcelRequire("1gQ73");

var $eYeFr = parcelRequire("eYeFr");
const $e065a216bb78c726$export$32a891753e1d9d91 = ({ card: { id: id, key: key, priority: priorityFromBacklog } })=>{
    const setPriorityInBacklog = (0, $1gQ73.useBacklogActionCreator)((0, $eYeFr.cardPrioritySet));
    const [priorityFromExtractedField, { setFieldValue: setPriorityInExtractedField }] = (0, $kmr29.useFieldValue)({
        issueKey: key,
        fieldKey: (0, $lO4Or.PRIORITY_TYPE)
    });
    const priorityFromBacklogChanged = (0, $bQSj3.useDiffCheck)([
        priorityFromBacklog?.name
    ]);
    const priorityFromExtractedFieldChanged = (0, $bQSj3.useDiffCheck)([
        priorityFromExtractedField?.name
    ]);
    const storesNeedToSync = priorityFromBacklog !== priorityFromExtractedField;
    (0, $eUqFw.useEffect)(()=>{
        const priorityFromBacklogIsDefined = priorityFromBacklog !== undefined;
        if (priorityFromBacklogIsDefined && priorityFromBacklogChanged && storesNeedToSync) setPriorityInExtractedField(key, (0, $lO4Or.PRIORITY_TYPE), priorityFromBacklog);
    }, [
        key,
        priorityFromBacklogChanged,
        storesNeedToSync,
        setPriorityInExtractedField,
        priorityFromBacklog
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const priorityFromExtractedFieldIsDefined = priorityFromExtractedField !== undefined;
        if (!priorityFromBacklogChanged && priorityFromExtractedFieldIsDefined && priorityFromExtractedFieldChanged && storesNeedToSync) setPriorityInBacklog({
            cardId: id,
            priority: priorityFromExtractedField
        });
    }, [
        id,
        priorityFromBacklogChanged,
        priorityFromExtractedField,
        priorityFromExtractedFieldChanged,
        storesNeedToSync,
        setPriorityInBacklog
    ]);
    return null;
};
var $e065a216bb78c726$export$2e2bcd8739ae039 = $e065a216bb78c726$export$32a891753e1d9d91;

});

parcelRegister("hpehJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5caa4c1b1518fce9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aXGkF = parcelRequire("aXGkF");

var $ldoFd = parcelRequire("ldoFd");

var $8Qd0L = parcelRequire("8Qd0L");

var $kmr29 = parcelRequire("kmr29");

var $50D0V = parcelRequire("50D0V");


var $bQSj3 = parcelRequire("bQSj3");

var $1gQ73 = parcelRequire("1gQ73");

var $75nYE = parcelRequire("75nYE");

var $hkGxG = parcelRequire("hkGxG");

var $5ceEB = parcelRequire("5ceEB");
const $5caa4c1b1518fce9$var$FieldSyncStatus = ({ card: card })=>{
    const statusFromBacklog = (0, $1gQ73.useBacklogSelector)((state)=>card ? (0, $5ceEB.getColumnStatusByStatusId)(card.statusId)(state) : null);
    const isCMP = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getIsCompanyManaged));
    const { key: cardKey, id: cardId, statusId: cardStatusId } = card;
    const setStatusInBacklog = (0, $1gQ73.useBacklogActionCreator)((0, $75nYE.cardStatusSet));
    const { id: statusIdFromBacklog, name: statusNameFromBacklog, category: statusCategoryFromBacklog } = statusFromBacklog || {};
    const [statusFromExtractedFields, { setFieldValue: setStatusInExtractedFields }] = (0, $kmr29.useFieldValue)({
        issueKey: cardKey,
        fieldKey: (0, $ebc098a76317be78$export$4420b7468f889692)
    });
    const { id: statusIdFromExtractedFields, statusCategory: statusCategoryFromExtractedFields } = statusFromExtractedFields || {};
    const statusFromBacklogChanged = (0, $bQSj3.useDiffCheck)([
        statusIdFromBacklog
    ]);
    const statusFromExtractedFieldsChanged = (0, $bQSj3.useDiffCheck)([
        statusIdFromExtractedFields
    ]);
    const storesNeedToSync = statusIdFromBacklog !== statusIdFromExtractedFields;
    (0, $eUqFw.useEffect)(()=>{
        const statusFromBacklogIsDefined = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(statusFromBacklog) && Boolean(statusIdFromBacklog);
        // STATUS SYNC: BACKLOG -> EXTRACTED FIELDS
        // initial value, realtime...
        if (statusFromBacklogIsDefined && statusFromBacklogChanged && storesNeedToSync) setStatusInExtractedFields(cardKey, (0, $ebc098a76317be78$export$4420b7468f889692), (0, $50D0V.getStatusShape)(// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        statusIdFromBacklog, statusNameFromBacklog, statusCategoryFromBacklog));
    }, [
        cardKey,
        statusFromBacklog,
        statusIdFromBacklog,
        statusNameFromBacklog,
        statusCategoryFromBacklog,
        statusFromBacklogChanged,
        storesNeedToSync,
        setStatusInExtractedFields
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const statusFromExtractedFieldsIsDefined = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(statusFromExtractedFields) && Boolean(statusIdFromExtractedFields);
        // STATUS SYNC: EXTRACTED FIELDS -> BACKLOG REDUX
        // issue view updates, inline status edit...
        if (// Ensure no sync will be called by Backlog as Backlog is the driver
        !statusFromBacklogChanged && statusFromExtractedFieldsIsDefined && statusFromExtractedFieldsChanged && storesNeedToSync) setStatusInBacklog(cardId, cardStatusId, statusIdFromExtractedFields, // @ts-expect-error TS2345: Argument of type 'string' is not assignable to parameter of type 'StatusCategoryKeys'.
        (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))((0, $8Qd0L.StatusCategoryIds))[statusCategoryFromExtractedFields.id] || (0, $8Qd0L.StatusCategoryTypes).UNDEFINED, isCMP);
    }, [
        cardId,
        cardStatusId,
        statusFromBacklogChanged,
        statusFromExtractedFields,
        statusIdFromExtractedFields,
        statusCategoryFromExtractedFields,
        statusFromExtractedFieldsChanged,
        storesNeedToSync,
        setStatusInBacklog,
        isCMP
    ]);
    return null;
};
var $5caa4c1b1518fce9$export$2e2bcd8739ae039 = $5caa4c1b1518fce9$var$FieldSyncStatus;

});

parcelRegister("hP4Sq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9e20e4b5323194a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kmr29 = parcelRequire("kmr29");

var $bQSj3 = parcelRequire("bQSj3");

var $1gQ73 = parcelRequire("1gQ73");

var $bxHyy = parcelRequire("bxHyy");

var $hkGxG = parcelRequire("hkGxG");

var $1ircG = parcelRequire("1ircG");
const $a9e20e4b5323194a$var$FieldSyncStoryPoint = ({ card: { id: id, key: key, estimate: estimate } })=>{
    const storyPointFieldId = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getStoryPointFieldId));
    const isNumericEstimateType = (0, $1gQ73.useBacklogSelector)((0, $1ircG.isNumericEstimateTypeSelector));
    const setStoryPointInBacklog = (0, $1gQ73.useBacklogActionCreator)((cardId, storyPoints)=>(0, $bxHyy.cardEstimateSet)(cardId, {
            storyPoints: storyPoints
        }));
    const StoryPointKey = storyPointFieldId || '';
    const storyPointFromBacklog = estimate?.storyPoints;
    // This hook updates the state used by bento in the field value service. It's necessary to provide the initial value
    // and to update the bento store when the story point changes from elsewhere in the backlog
    const [storyPointFromExtractedFields, { setFieldValue: setStoryPointInExtractedFields }] = (0, $kmr29.useFieldValue)({
        issueKey: key,
        fieldKey: StoryPointKey
    });
    const storyPointFromBacklogChanged = (0, $bQSj3.useDiffCheck)([
        storyPointFromBacklog
    ]);
    const storyPointFromExtractedFieldsChanged = (0, $bQSj3.useDiffCheck)([
        storyPointFromExtractedFields
    ]);
    const storesNeedToSync = storyPointFromBacklog !== storyPointFromExtractedFields;
    (0, $eUqFw.useEffect)(()=>{
        const storyPointFromBacklogIsDefined = storyPointFromBacklog !== undefined;
        const shouldSync = StoryPointKey && storyPointFromBacklogIsDefined && storyPointFromBacklogChanged && storesNeedToSync && isNumericEstimateType;
        // STORY POINT SYNC: BACKLOG -> EXTRACTED FIELDS
        // Update sweet state (extracted field) when the story point value changes elsewhere or the card is initially rendered
        if (shouldSync) setStoryPointInExtractedFields(key, StoryPointKey, storyPointFromBacklog);
    }, [
        StoryPointKey,
        key,
        storyPointFromBacklog,
        storyPointFromBacklogChanged,
        storesNeedToSync,
        setStoryPointInExtractedFields,
        isNumericEstimateType
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const storyPointFromExtractedFieldsIsDefined = storyPointFromExtractedFields !== undefined;
        const shouldSync = !storyPointFromBacklogChanged && storyPointFromExtractedFieldsIsDefined && storyPointFromExtractedFieldsChanged && storesNeedToSync && isNumericEstimateType;
        // STORY POINT SYNC: EXTRACTED FIELDS -> BACKLOG
        // Update the backlog store if the value of the story point is changed within extracted fields
        if (shouldSync) setStoryPointInBacklog(id, storyPointFromExtractedFields);
    }, [
        id,
        storyPointFromBacklogChanged,
        storyPointFromExtractedFields,
        storyPointFromExtractedFieldsChanged,
        storesNeedToSync,
        setStoryPointInBacklog,
        isNumericEstimateType
    ]);
    return null;
};
var $a9e20e4b5323194a$export$2e2bcd8739ae039 = $a9e20e4b5323194a$var$FieldSyncStoryPoint;

});

parcelRegister("aBdHm", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fa9480af4def35e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kmr29 = parcelRequire("kmr29");


var $bQSj3 = parcelRequire("bQSj3");

var $1gQ73 = parcelRequire("1gQ73");

var $ansG8 = parcelRequire("ansG8");
const $5fa9480af4def35e$export$e5eb14bcd03ae390 = ({ card: { id: id, key: key, summary: summaryFromBacklog } })=>{
    const setSummaryInBacklog = (0, $1gQ73.useBacklogActionCreator)((0, $ansG8.cardSummarySet));
    const [summaryFromExtractedField, { setFieldValue: setSummaryInExtractedField }] = (0, $kmr29.useFieldValue)({
        issueKey: key,
        fieldKey: (0, $ebc098a76317be78$export$e7cf1830fe735d1f)
    });
    const summaryFromBacklogChanged = (0, $bQSj3.useDiffCheck)([
        summaryFromBacklog
    ]);
    const summaryFromExtractedFieldChanged = (0, $bQSj3.useDiffCheck)([
        summaryFromExtractedField
    ]);
    const storesNeedToSync = summaryFromBacklog !== summaryFromExtractedField;
    // Fixes creating issues from GIC where redux isn't synced with React Sweet
    // State. This is a workaround to unblock me. There is a more permanent
    // solution being investigated here
    // https://hello.atlassian.net/browse/DEE-923
    (0, $eUqFw.useEffect)(()=>{
        const summaryFromBacklogIsDefined = summaryFromBacklog !== undefined;
        const summaryFromExtractedFieldIsUndefined = summaryFromExtractedField === undefined;
        if (summaryFromBacklogIsDefined && summaryFromExtractedFieldIsUndefined) setSummaryInExtractedField(key, (0, $ebc098a76317be78$export$e7cf1830fe735d1f), summaryFromBacklog);
    }, [
        key,
        setSummaryInExtractedField,
        summaryFromBacklog,
        summaryFromExtractedField
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const summaryFromBacklogIsDefined = summaryFromBacklog !== undefined;
        if (summaryFromBacklogIsDefined && summaryFromBacklogChanged && storesNeedToSync) setSummaryInExtractedField(key, (0, $ebc098a76317be78$export$e7cf1830fe735d1f), summaryFromBacklog);
    }, [
        key,
        summaryFromBacklog,
        summaryFromBacklogChanged,
        storesNeedToSync,
        setSummaryInExtractedField
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const summaryFromExtractedFieldIsDefined = summaryFromExtractedField !== undefined;
        if (!summaryFromBacklogChanged && summaryFromExtractedFieldIsDefined && summaryFromExtractedFieldChanged && storesNeedToSync) setSummaryInBacklog(id, summaryFromExtractedField);
    }, [
        id,
        summaryFromBacklogChanged,
        summaryFromExtractedField,
        summaryFromExtractedFieldChanged,
        storesNeedToSync,
        setSummaryInBacklog
    ]);
    return null;
};
var $5fa9480af4def35e$export$2e2bcd8739ae039 = $5fa9480af4def35e$export$e5eb14bcd03ae390;

});



parcelRegister("2esFI", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1e959f16dc3a35e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $1ybV0 = parcelRequire("1ybV0");

var $1gQ73 = parcelRequire("1gQ73");

var $6apxJ = parcelRequire("6apxJ");

var $1HfeQ = parcelRequire("1HfeQ");

var $K2SiM = parcelRequire("K2SiM");

var $3ZMdH = parcelRequire("3ZMdH");

var $bCL12 = parcelRequire("bCL12");

var $6iBIZ = parcelRequire("6iBIZ");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $kdGmo = parcelRequire("kdGmo");

var $j258X = parcelRequire("j258X");

var $1gHOz = parcelRequire("1gHOz");

var $6xUPv = parcelRequire("6xUPv");

var $iSXi5 = parcelRequire("iSXi5");
const $a1e959f16dc3a35e$var$isBatchRealtimeUpdateEnabled = ()=>(0, $1ybV0.ff)('issue.dee-3496-batch-realtime-update');
const $a1e959f16dc3a35e$var$BacklogContentContainerInner = (props)=>{
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const selectedCards = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.selectedCardsForVersionsPanelSelector));
    const lastFilteredIssueTypeId = (0, $1gQ73.useBacklogSelector)((0, $kdGmo.getLastFilteredIssueTypeId));
    const isCompanyManaged = (0, $j258X.useIsCMPBacklog)();
    const epicLinkFieldId = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getEpicLinkFieldId));
    const firstNonEmptyCardListId = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getFirstNonEmptyCardListId));
    const lastNonEmptyCardListId = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getLastNonEmptyCardListId));
    const pushEvent = $a1e959f16dc3a35e$var$isBatchRealtimeUpdateEnabled() ? (0, $6xUPv.useBatchOnReceive)() : (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
    const onCardDetailClick = (0, $1gQ73.useBacklogActionCreator)((0, $1HfeQ.parentClick));
    const onEpicCreate = (0, $1gQ73.useBacklogActionCreator)((issueParents)=>(0, $3ZMdH.issueParentsCreateSet)({
            issueParents: issueParents
        }));
    const onVersionAltered = (0, $eUqFw.useCallback)((version)=>{
        if (isCompanyManaged) dispatch((0, $6iBIZ.updateVersion)({
            id: version.versionId,
            name: version.name,
            projectId: Number(version.projectId)
        }));
        dispatch((0, $K2SiM.updateDetailView)());
    }, [
        dispatch,
        isCompanyManaged
    ]);
    const onIssueVersionsUpdated = (0, $1gHOz.useOnIssueVersionsUpdated)();
    const onEpicAssign = (0, $1gQ73.useBacklogActionCreator)((cards, parentId, requestPromise)=>(0, $6apxJ.cardsParentSetOptimistic)({
            cards: cards,
            parentId: parentId,
            requestPromise: requestPromise
        }));
    const onReceive = (0, $eUqFw.useCallback)((eventType, payload)=>{
        const event = {
            type: eventType,
            payload: payload
        };
        pushEvent(event);
    }, [
        pushEvent
    ]);
    const onReceiveOld = (0, $1gQ73.useBacklogActionCreator)((eventType, payload)=>{
        const event = {
            type: eventType,
            payload: payload
        };
        return (0, $bCL12.dispatchRealtimeEvent)(event);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iSXi5.default), {
        ...props,
        selectedCards: selectedCards,
        selectedCardTypeId: lastFilteredIssueTypeId,
        onCardDetailClick: onCardDetailClick,
        onEpicCreate: onEpicCreate,
        onEpicAssign: onEpicAssign,
        onIssueVersionsUpdated: onIssueVersionsUpdated,
        onVersionAltered: onVersionAltered,
        onReceive: $a1e959f16dc3a35e$var$isBatchRealtimeUpdateEnabled() ? onReceive : onReceiveOld,
        isCompanyManaged: isCompanyManaged,
        epicLinkFieldId: epicLinkFieldId,
        firstNonEmptyCardListId: firstNonEmptyCardListId,
        lastNonEmptyCardListId: lastNonEmptyCardListId,
        issueHierarchyLevel: props.issueHierarchyLevel
    });
};
const $a1e959f16dc3a35e$var$BacklogContentContainer = /*#__PURE__*/ (0, $eUqFw.memo)($a1e959f16dc3a35e$var$BacklogContentContainerInner);
var $a1e959f16dc3a35e$export$2e2bcd8739ae039 = $a1e959f16dc3a35e$var$BacklogContentContainer;

});
parcelRegister("1gHOz", function(module, exports) {

$parcel$export(module.exports, "useOnIssueVersionsUpdated", () => $1cc7071f1750a5f8$export$4b98876a65f85873);

var $eUqFw = parcelRequire("eUqFw");

var $64fZ9 = parcelRequire("64fZ9");

var $K2SiM = parcelRequire("K2SiM");

var $1gQ73 = parcelRequire("1gQ73");

var $bP7Jx = parcelRequire("bP7Jx");
const $1cc7071f1750a5f8$export$4b98876a65f85873 = ()=>{
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const isDetailViewOpenWithAnySelectedCard = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.isDetailViewOpenWithAnySelectedCardSelector));
    return (0, $eUqFw.useCallback)((cardIds)=>{
        cardIds.forEach((id)=>dispatch((0, $64fZ9.cardRefreshRequest)(id)));
        if (isDetailViewOpenWithAnySelectedCard) dispatch((0, $K2SiM.updateDetailView)());
    }, [
        dispatch,
        isDetailViewOpenWithAnySelectedCard
    ]);
};

});

parcelRegister("6xUPv", function(module, exports) {

$parcel$export(module.exports, "useBatchOnReceive", () => $5cad45f873fa5021$export$b02b538e3e12eaf4);

var $eUqFw = parcelRequire("eUqFw");

var $70s4u = parcelRequire("70s4u");
parcelRequire("jXa03");

var $7TyGu = parcelRequire("7TyGu");

var $1gQ73 = parcelRequire("1gQ73");

var $jiL2Q = parcelRequire("jiL2Q");

var $bCL12 = parcelRequire("bCL12");

var $hkGxG = parcelRequire("hkGxG");
const $5cad45f873fa5021$export$23831c9717212b2 = 500;
const $5cad45f873fa5021$var$isActiveTab = ()=>!document.hidden;
const $5cad45f873fa5021$export$b02b538e3e12eaf4 = ()=>{
    const subjectRef = (0, $eUqFw.useRef)(new (0, $70s4u.Subject)());
    const currentUser = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getAtlassianAccountId));
    const refreshData = (0, $1gQ73.useBacklogActionCreator)((0, $jiL2Q.refreshDataRequest));
    const dispatch = (0, $1gQ73.useBacklogActionCreator)((0, $bCL12.dispatchRealtimeEventBatch));
    const pushEvent = (0, $eUqFw.useCallback)((event)=>{
        if (!subjectRef.current.closed) subjectRef.current.next(event);
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        const subject = subjectRef.current;
        subject.buffer(subject.debounceTime($5cad45f873fa5021$export$23831c9717212b2)).filter($5cad45f873fa5021$var$isActiveTab).subscribe((events)=>{
            if (!subjectRef.current.closed) {
                dispatch(events);
                const hasEventsFromOthers = events.filter((s)=>s.payload.atlassianId !== currentUser).length > 0;
                if (hasEventsFromOthers) refreshData((0, $7TyGu.REFRESH_SOURCE_REALTIME));
            }
        });
        return ()=>{
            subject.unsubscribe();
        };
    }, [
        currentUser,
        dispatch,
        refreshData
    ]);
    return pushEvent;
};

});
parcelRegister("jXa03", function(module, exports) {
"use strict";

var $3JafE = parcelRequire("3JafE");

var $iViBk = parcelRequire("iViBk");
$3JafE.Observable.prototype.buffer = $iViBk.buffer;

});
parcelRegister("iViBk", function(module, exports) {

$parcel$export(module.exports, "buffer", () => $dc6bfaa6c2d3d774$export$ab1029bcae9ddb4a, (v) => $dc6bfaa6c2d3d774$export$ab1029bcae9ddb4a = v);
var $dc6bfaa6c2d3d774$export$ab1029bcae9ddb4a;
"use strict";

var $i9UF9 = parcelRequire("i9UF9");
/**
 * Buffers the source Observable values until `closingNotifier` emits.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when another Observable emits.</span>
 *
 * <img src="./img/buffer.png" width="100%">
 *
 * Buffers the incoming Observable values until the given `closingNotifier`
 * Observable emits a value, at which point it emits the buffer on the output
 * Observable and starts a new buffer internally, awaiting the next time
 * `closingNotifier` emits.
 *
 * @example <caption>On every click, emit array of most recent interval events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var buffered = interval.buffer(clicks);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link window}
 *
 * @param {Observable<any>} closingNotifier An Observable that signals the
 * buffer to be emitted on the output Observable.
 * @return {Observable<T[]>} An Observable of buffers, which are arrays of
 * values.
 * @method buffer
 * @owner Observable
 */ function $dc6bfaa6c2d3d774$var$buffer(closingNotifier) {
    return $i9UF9.buffer(closingNotifier)(this);
}
$dc6bfaa6c2d3d774$export$ab1029bcae9ddb4a = $dc6bfaa6c2d3d774$var$buffer;

});



parcelRegister("iSXi5", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6e346a3076ccd0c$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lzvR2 = parcelRequire("lzvR2");

var $eI5EY = parcelRequire("eI5EY");

var $3l6tm = parcelRequire("3l6tm");

var $8LIba = parcelRequire("8LIba");

var $hzcvF = parcelRequire("hzcvF");

var $fLHAD = parcelRequire("fLHAD");

var $dwauK = parcelRequire("dwauK");

var $2U8YO = parcelRequire("2U8YO");

var $fenWW = parcelRequire("fenWW");

var $8MrYx = parcelRequire("8MrYx");
var $c3qrZ = parcelRequire("c3qrZ");
var $3kYjh = parcelRequire("3kYjh");

var $jK1pm = parcelRequire("jK1pm");


var $8wXFi = parcelRequire("8wXFi");

var $8pXmY = parcelRequire("8pXmY");

var $gPQCf = parcelRequire("gPQCf");

var $l9DvH = parcelRequire("l9DvH");

var $7QBTt = parcelRequire("7QBTt");

var $hwYJL = parcelRequire("hwYJL");

var $ivyj7 = parcelRequire("ivyj7");

var $8qqvv = parcelRequire("8qqvv");

var $d9eLC = parcelRequire("d9eLC");

var $gQBix = parcelRequire("gQBix");

var $fxXLk = parcelRequire("fxXLk");

var $iJbrx = parcelRequire("iJbrx");

var $iidnO = parcelRequire("iidnO");

var $jtJ2w = parcelRequire("jtJ2w");
const $d6e346a3076ccd0c$var$RenderEndMark = ()=>{
    const metric = (0, $l9DvH.usePerformanceMetric)();
    (0, $eUqFw.useEffect)(()=>{
        metric.mark((0, $gPQCf.PAGE_LOAD_MARK_RENDER_END));
    }, [
        metric
    ]);
    return null;
};
const $d6e346a3076ccd0c$var$BacklogContentInner = ({ isCacheHit: isCacheHit, boardId: boardId, issueHierarchyLevel: issueHierarchyLevel, isDetailViewVisible: isDetailViewVisible, isCompanyManaged: isCompanyManaged = false, parentWidth: parentWidth, CardList: CardList, cardListIds: cardListIds, selectedCards: selectedCards, SubmitApdex: SubmitApdex, BoardIssueMoveDialog: BoardIssueMoveDialog, selectedCardTypeId: selectedCardTypeId, epicLinkFieldId: epicLinkFieldId, firstNonEmptyCardListId: firstNonEmptyCardListId, lastNonEmptyCardListId: lastNonEmptyCardListId, bulkOperationsToolbar: bulkOperationsToolbar, onEpicAssign: onEpicAssign, onCardDetailClick: onCardDetailClick, onEpicCreate: onEpicCreate, onIssueVersionsUpdated: onIssueVersionsUpdated, onVersionAltered: onVersionAltered, onReceive: onReceive })=>{
    const scrollElementRef = (0, $eUqFw.useRef)(null);
    const { onChangeCardType: onChangeCardType } = (0, $eUqFw.useContext)((0, $8LIba.IccContext));
    // NOTE: Update the selected issue type in ICC when the issue type filter is changed. Doing it here to avoid unnecessary update
    (0, $eUqFw.useEffect)(()=>{
        if (selectedCardTypeId !== undefined) onChangeCardType(selectedCardTypeId);
    }, [
        onChangeCardType,
        selectedCardTypeId
    ]);
    const previousCardListIds = (0, $hzcvF.usePrevious)(cardListIds);
    const isNewCardListAdded = (id)=>{
        if (!previousCardListIds) return false;
        return !previousCardListIds.includes(id);
    };
    (0, $fxXLk.useAutoScroller)();
    (0, $iJbrx.useDragAnalytics)(issueHierarchyLevel);
    (0, $dwauK.useCloseMenuOnScroll)(scrollElementRef);
    (0, $hwYJL.useBulkActionsBarOverlay)(scrollElementRef);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eI5EY.fg)('jsw_epic_panel_paginated_fetch') && (0, $iidnO.useInitEpicData)(boardId);
    const { toggleViewSetting: toggleViewSetting } = (0, $8MrYx.useViewSettingsActions)();
    const handleVersionPanelClose = (0, $eUqFw.useCallback)(()=>{
        toggleViewSetting({
            boardId: boardId,
            setting: (0, $3kYjh.ViewSetting).VERSION_PANEL,
            view: (0, $c3qrZ.View).BACKLOG
        });
    }, [
        boardId,
        toggleViewSetting
    ]);
    const handleEpicPanelClose = (0, $eUqFw.useCallback)(()=>{
        toggleViewSetting({
            boardId: boardId,
            setting: (0, $3kYjh.ViewSetting).EPIC_PANEL,
            view: (0, $c3qrZ.View).BACKLOG
        });
    }, [
        boardId,
        toggleViewSetting
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6e346a3076ccd0c$var$PageWrapper, {
        "data-onboarding-observer-id": "backlog-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "backlog-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jtJ2w.VersionsPanelWithErrorBoundary), {
        boardId: boardId,
        selectedIssues: selectedCards,
        onClose: handleVersionPanelClose,
        onVersionAltered: onVersionAltered,
        onVersionAssigned: onIssueVersionsUpdated,
        onVersionsUnassigned: onIssueVersionsUpdated,
        isCompanyManaged: isCompanyManaged
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d9eLC.EpicPanelWithErrorBoundary), {
        boardId: boardId,
        selectedIssues: selectedCards,
        issueHierarchyLevel: (0, $3l6tm.ISSUE_HIERARCHY_LEVEL_EPIC),
        epicLinkFieldId: epicLinkFieldId,
        onEpicPanelClose: handleEpicPanelClose,
        onCardDetailClick: onCardDetailClick,
        onEpicCreate: onEpicCreate,
        onEpicAssign: onEpicAssign,
        isCompanyManaged: isCompanyManaged
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6e346a3076ccd0c$var$Scrollable, {
        "data-test-id": "software-backlog.backlog-content.scrollable",
        "data-testid": "software-backlog.backlog-content.scrollable",
        ref: scrollElementRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QBTt.BulkActionsBar), {
        bulkOperationsToolbar: bulkOperationsToolbar
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(BoardIssueMoveDialog, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2U8YO.ScrollStateContextProvider), {
        scrollRef: scrollElementRef
    }, cardListIds.map((id, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CardList, {
            key: id,
            id: id,
            isFirstList: index === 0,
            isFirstNonEmptyList: firstNonEmptyCardListId === id,
            isLastNonEmptyList: lastNonEmptyCardListId === id,
            justCreated: isNewCardListAdded(id)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gQBix.MoreResults), {
        scrollableParentRef: scrollElementRef
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ivyj7.default), null), (0, $8wXFi.isLongTasksRefactorEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fenWW.LongTasksScrollObserver), {
        appName: (0, $e1409a6fc345c0d8$export$840e3848643f7781),
        scrollElRef: scrollElementRef,
        attributes: (0, $lzvR2.getNormalisedPerformanceFFs)()
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fenWW.LongTasksScrollObserver), {
        appName: (0, $e1409a6fc345c0d8$export$840e3848643f7781),
        scrollEl: scrollElementRef.current
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8qqvv.DetailViewPanelWithErrorBoundary), {
        boardId: boardId,
        parentWidth: parentWidth,
        isDetailViewVisible: isDetailViewVisible
    }), cardListIds.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6e346a3076ccd0c$var$RenderEndMark, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SubmitApdex, {
        isCacheHit: isCacheHit
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fLHAD.RealtimeClient), {
        events: (0, $8pXmY.REALTIME_EVENTS),
        onReceive: onReceive
    })));
};
const $d6e346a3076ccd0c$var$BacklogContent = /*#__PURE__*/ (0, $eUqFw.memo)($d6e346a3076ccd0c$var$BacklogContentInner);
var $d6e346a3076ccd0c$export$2e2bcd8739ae039 = $d6e346a3076ccd0c$var$BacklogContent;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d6e346a3076ccd0c$var$PageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19bv1jfw _1e0c1txw _2lx2vrvc _4t3i1osq _c71l1osq _1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $d6e346a3076ccd0c$var$Scrollable = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt48vxl _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx21bp4 _c71l1osq _18m915zi _1reo1wug _uiztglyw _kqswh2mm _m6k4brmi _1pbyb4wl",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fLHAD", function(module, exports) {

$parcel$export(module.exports, "RealtimeClient", () => $42b77c4aa56216fa$export$e680ceb7b9fcc184);

var $eUqFw = parcelRequire("eUqFw");

var $c8Guq = parcelRequire("c8Guq");

var $g8JvH = parcelRequire("g8JvH");

var $efKIh = parcelRequire("efKIh");

var $6yVT4 = parcelRequire("6yVT4");
// eslint-disable-next-line jira/react/no-class-components
class $42b77c4aa56216fa$var$RealtimeClientView extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            children: null
        };
    }
    componentDidMount() {
        this.subscribeToPropEvents();
    }
    componentDidUpdate(prevProps) {
        if (this.props.client !== prevProps.client || this.props.events !== prevProps.events) {
            const removedEvents = prevProps.events.filter((prevEvent)=>!this.props.events.includes(prevEvent));
            removedEvents.forEach(this.unSubscribeToEvent);
            this.subscribeToPropEvents();
        }
    }
    componentWillUnmount() {
        this.unsubscribeToPropEvents();
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.onReceiveEvent = (event, payload)=>{
            // @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.
            this.props.onReceive(event, payload);
        };
        this.subscribeToEvent = (eventName)=>{
            this.props.client?.on(eventName, this.onReceiveEvent);
        };
        this.unSubscribeToEvent = (eventName)=>{
            this.props.client?.off(eventName, this.onReceiveEvent);
        };
        this.subscribeToPropEvents = ()=>{
            if (this.props.client) this.props.events.forEach(this.subscribeToEvent);
        };
        this.unsubscribeToPropEvents = ()=>{
            if (this.props.client) this.props.events.forEach(this.unSubscribeToEvent);
        };
    }
}
const $42b77c4aa56216fa$var$withAnalytics = (0, $g8JvH.AnalyticsEventToProps)('realtimeClient', {
    onReceive: 'eventReceived'
});
const $42b77c4aa56216fa$export$e680ceb7b9fcc184 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))($42b77c4aa56216fa$var$withAnalytics, (0, $6yVT4.withPubSubClient), (0, $efKIh.asClientOnly))($42b77c4aa56216fa$var$RealtimeClientView);
var $42b77c4aa56216fa$export$2e2bcd8739ae039 = $42b77c4aa56216fa$export$e680ceb7b9fcc184;

});
parcelRegister("g8JvH", function(module, exports) {

$parcel$export(module.exports, "AnalyticsEventToProps", () => $4e66802e461455f0$export$3e9ef96ba97ea9dc);

var $2jDha = parcelRequire("2jDha");
const $4e66802e461455f0$export$871de8747c9eaa88 = (props, componentName)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [key]: {
                action: props[key],
                actionSubject: componentName
            }
        }), {});
const $4e66802e461455f0$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (WrappedComponent)=>(0, $2jDha.default)($4e66802e461455f0$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);

});

parcelRegister("efKIh", function(module, exports) {

$parcel$export(module.exports, "asClientOnly", () => $4874a35f2e3af873$export$95cd02374de3431);

var $eUqFw = parcelRequire("eUqFw");
function $4874a35f2e3af873$export$95cd02374de3431(WrappedComponent) {
    return (props)=>{
        if (false) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, props);
    };
}
var $4874a35f2e3af873$export$2e2bcd8739ae039 = $4874a35f2e3af873$export$95cd02374de3431;

});

parcelRegister("6yVT4", function(module, exports) {

$parcel$export(module.exports, "withPubSubClient", () => $4857e418d88b13dd$export$32d968d4900ae3cd);

var $eUqFw = parcelRequire("eUqFw");

var $e97Bh = parcelRequire("e97Bh");
function $4857e418d88b13dd$export$32d968d4900ae3cd(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e97Bh.Consumer), null, ({ client: client })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                ...props,
                client: client
            }));
}
var $4857e418d88b13dd$export$2e2bcd8739ae039 = $4857e418d88b13dd$export$32d968d4900ae3cd;

});
parcelRegister("e97Bh", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $4f1fb1ba24fc84ec$export$2881499e37b75b9a);
$parcel$export(module.exports, "Consumer", () => $4f1fb1ba24fc84ec$export$b3bffd4bb7da6b8f);

var $eUqFw = parcelRequire("eUqFw");
const $4f1fb1ba24fc84ec$var$defaultContext = {
    client: null
};
const { Provider: $4f1fb1ba24fc84ec$export$2881499e37b75b9a, Consumer: $4f1fb1ba24fc84ec$export$b3bffd4bb7da6b8f } = /*#__PURE__*/ (0, $eUqFw.createContext)($4f1fb1ba24fc84ec$var$defaultContext);

});



parcelRegister("dwauK", function(module, exports) {

$parcel$export(module.exports, "useCloseMenuOnScroll", () => $b53cd570d32c1a63$export$2cf190faca0f2491);

var $eUqFw = parcelRequire("eUqFw");

var $6DFOC = parcelRequire("6DFOC");
const $b53cd570d32c1a63$export$2cf190faca0f2491 = (ref)=>{
    const { reset: reset } = (0, $6DFOC.useContextMenuActions)();
    const isAnyMenuOpen = (0, $6DFOC.useIsAnyMenuOpen)();
    const added = (0, $eUqFw.useRef)(false);
    const handleScroll = (0, $eUqFw.useCallback)(()=>{
        reset({
            action: 'closeMenu'
        });
    }, [
        reset
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (ref.current) {
            if (isAnyMenuOpen) {
                if (!added.current) {
                    ref.current.addEventListener('scroll', handleScroll);
                    added.current = true;
                }
                return;
            }
            if (added.current) {
                ref.current.removeEventListener('scroll', handleScroll);
                added.current = false;
            }
        }
    }, [
        handleScroll,
        ref,
        isAnyMenuOpen
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            if (ref.current && added.current) {
                ref.current.removeEventListener('scroll', handleScroll);
                added.current = false;
            }
        }, [
        ref,
        handleScroll
    ]);
};

});
parcelRegister("6DFOC", function(module, exports) {

$parcel$export(module.exports, "useContextMenuStore", () => $82e6f88541cf3b18$export$d1b2e16030b3efbf);
$parcel$export(module.exports, "useContextMenuActions", () => $82e6f88541cf3b18$export$fb508b9bcc816326);
$parcel$export(module.exports, "ContextMenuContainer", () => $82e6f88541cf3b18$export$4f48a5067cf73390);
$parcel$export(module.exports, "useMenuItemCheckOpen", () => $82e6f88541cf3b18$export$60c643cac8887fbe);
$parcel$export(module.exports, "useShouldForceFocus", () => $82e6f88541cf3b18$export$ac348ec4828a6056);
$parcel$export(module.exports, "useIsMenuOpen", () => $82e6f88541cf3b18$export$3eef7351bd308de1);
$parcel$export(module.exports, "useAnalyticsAttributes", () => $82e6f88541cf3b18$export$1fd8522aeddaccda);
$parcel$export(module.exports, "useAnalyticsMapping", () => $82e6f88541cf3b18$export$aeb28cc7c774c3ed);
$parcel$export(module.exports, "useIsAnyMenuOpen", () => $82e6f88541cf3b18$export$91d90cb66ff7a71e);
$parcel$export(module.exports, "useIsPersistentFocus", () => $82e6f88541cf3b18$export$1e85791d95627e79);

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");

var $jumVR = parcelRequire("jumVR");

var $aS7cv = parcelRequire("aS7cv");

var $5mnHu = parcelRequire("5mnHu");
const $82e6f88541cf3b18$var$ContextMenuStore = (0, $a61MH.createStore)({
    name: 'software-context-menu',
    initialState: (0, $aS7cv.getInitialState)(),
    actions: $aS7cv.actions
});
const $82e6f88541cf3b18$export$d1b2e16030b3efbf = (0, $ggKAj.createHook)($82e6f88541cf3b18$var$ContextMenuStore);
const $82e6f88541cf3b18$export$fb508b9bcc816326 = (0, $ggKAj.createActionsHook)($82e6f88541cf3b18$var$ContextMenuStore);
const $82e6f88541cf3b18$export$4f48a5067cf73390 = (0, $heB5U.createContainer)($82e6f88541cf3b18$var$ContextMenuStore, {
    onInit: (0, $5mnHu.onContainerInit),
    onUpdate: (0, $5mnHu.onContainerUpdate)
});
const $82e6f88541cf3b18$var$getMenuItemOpen = (state, { menuItem: menuItem, scope: scope })=>state.menus[scope]?.openPath?.startsWith(menuItem.id);
const $82e6f88541cf3b18$export$60c643cac8887fbe = (0, $ggKAj.createStateHook)($82e6f88541cf3b18$var$ContextMenuStore, {
    selector: $82e6f88541cf3b18$var$getMenuItemOpen
});
const $82e6f88541cf3b18$var$getIsFocusForced = (state, { menuItem: menuItem, scope: scope })=>state.menus[scope]?.forcedFocusPath === menuItem.id;
const $82e6f88541cf3b18$export$ac348ec4828a6056 = (0, $ggKAj.createStateHook)($82e6f88541cf3b18$var$ContextMenuStore, {
    selector: $82e6f88541cf3b18$var$getIsFocusForced
});
const $82e6f88541cf3b18$var$getIsMenuOpen = (state, { scope: scope })=>state.openMenu === scope;
const $82e6f88541cf3b18$export$3eef7351bd308de1 = (0, $ggKAj.createStateHook)($82e6f88541cf3b18$var$ContextMenuStore, {
    selector: $82e6f88541cf3b18$var$getIsMenuOpen
});
const $82e6f88541cf3b18$var$getAnalyticsAttributes = (state, { scope: scope, cardId: cardId })=>{
    const isMenuOpen = $82e6f88541cf3b18$var$getIsMenuOpen(state, {
        scope: scope
    });
    const { analytics: { selectedCardIds: selectedCardIds } } = state;
    return (0, $jumVR.getCardSelectionAnalytics)(selectedCardIds, cardId, isMenuOpen);
};
const $82e6f88541cf3b18$export$1fd8522aeddaccda = (0, $ggKAj.createStateHook)($82e6f88541cf3b18$var$ContextMenuStore, {
    selector: $82e6f88541cf3b18$var$getAnalyticsAttributes
});
const $82e6f88541cf3b18$var$getAnalyticsMapping = (state)=>state.analytics.analyticsMapping;
const $82e6f88541cf3b18$export$aeb28cc7c774c3ed = (0, $ggKAj.createStateHook)($82e6f88541cf3b18$var$ContextMenuStore, {
    selector: $82e6f88541cf3b18$var$getAnalyticsMapping
});
const $82e6f88541cf3b18$export$d8b7614abf2894d6 = (state)=>!!state.openMenu;
const $82e6f88541cf3b18$export$91d90cb66ff7a71e = (0, $ggKAj.createStateHook)($82e6f88541cf3b18$var$ContextMenuStore, {
    selector: $82e6f88541cf3b18$export$d8b7614abf2894d6
});
const $82e6f88541cf3b18$var$getIsPersistentFocus = (state)=>!!state?.persistentFocus;
const $82e6f88541cf3b18$export$1e85791d95627e79 = (0, $ggKAj.createStateHook)($82e6f88541cf3b18$var$ContextMenuStore, {
    selector: $82e6f88541cf3b18$var$getIsPersistentFocus
});

});
parcelRegister("jumVR", function(module, exports) {

$parcel$export(module.exports, "hasUserStartedSelecting", () => $597be27db7deda86$export$5195d9082487fa42);
$parcel$export(module.exports, "hasUserUnselectedAll", () => $597be27db7deda86$export$3b8cd3ffacc95e4f);
$parcel$export(module.exports, "getCardSelectionAnalytics", () => $597be27db7deda86$export$f96eca8ded123f8b);
$parcel$export(module.exports, "shouldFlowBeEnded", () => $597be27db7deda86$export$539307982a715ea8);
const $597be27db7deda86$export$5195d9082487fa42 = (analytics, contextMenuContainerAnalytics)=>analytics.selectedCardIds.length === 0 && contextMenuContainerAnalytics.selectedCardIds.length > 0;
const $597be27db7deda86$export$3b8cd3ffacc95e4f = (analytics, contextMenuContainerAnalytics)=>analytics.selectedCardIds.length > 0 && contextMenuContainerAnalytics.selectedCardIds.length === 0;
const $597be27db7deda86$export$f96eca8ded123f8b = (selectedCardIds, cardId, isMenuOpen)=>{
    let cardIds;
    if (isMenuOpen) cardIds = selectedCardIds.includes(cardId) ? selectedCardIds : [
        cardId
    ];
    else cardIds = selectedCardIds;
    const numSelectedCards = cardIds.length;
    return {
        numSelectedCards: numSelectedCards,
        issue_ids: cardIds,
        issue_id: cardId
    };
};
const $597be27db7deda86$export$539307982a715ea8 = (analytics, contextMenuContainerAnalytics, bulkOpsFlow)=>{
    const sessionID = !!bulkOpsFlow?.getFlowAttributes().bulkOpsSessionID;
    return sessionID && contextMenuContainerAnalytics.selectedCardIds.length === 0;
};

});

parcelRegister("aS7cv", function(module, exports) {

$parcel$export(module.exports, "getInitialState", () => $86c3adba46766e51$export$53ac33307b5acee9);
$parcel$export(module.exports, "actions", () => $86c3adba46766e51$export$e324594224ef24da);

var $guiFP = parcelRequire("guiFP");

var $5mnHu = parcelRequire("5mnHu");
const $86c3adba46766e51$export$53ac33307b5acee9 = ()=>({
        menus: {},
        openMenu: null,
        analytics: {
            selectedCardIds: []
        },
        lastAction: {
            action: 'init',
            scope: undefined
        }
    });
const $86c3adba46766e51$export$aad8462122ac592b = (lastAction)=>({ setState: setState })=>{
        const { analytics: analytics, ...initialState } = $86c3adba46766e51$export$53ac33307b5acee9();
        initialState.lastAction = lastAction || {
            action: 'reset'
        };
        setState(initialState);
    };
const $86c3adba46766e51$var$setPersistentFocus = (persistentFocus)=>({ setState: setState })=>{
        setState({
            persistentFocus: persistentFocus
        });
    };
const $86c3adba46766e51$var$openMenu = ({ position: position, scope: scope, analyticsEvent: analyticsEvent, persistentFocus: persistentFocus, openedFrom: openedFrom })=>({ setState: setState }, { selectedCardIds: selectedCardIds, cardId: cardId })=>{
        (0, $5mnHu.fireOpenMenuAnalyticsEvent)({
            event: analyticsEvent,
            selectedCardIds: selectedCardIds,
            cardId: cardId,
            openedFrom: openedFrom
        });
        setState({
            openMenu: scope,
            persistentFocus: persistentFocus,
            menus: {
                [scope]: {
                    openPath: undefined,
                    scope: scope,
                    position: position,
                    forcedFocusPath: undefined
                }
            },
            lastAction: {
                action: 'openMenu',
                scope: scope
            }
        });
    };
const $86c3adba46766e51$export$11ed9b7b8045d408 = (scope, menuItem)=>({ setState: setState, getState: getState })=>{
        const { menus: menus, lastAction: lastAction } = getState();
        const menuState = menus[scope];
        if (!menuState) {
            if (lastAction?.action === 'closeMenu') return;
            const errorMessage = `Menu state is not defined - last action(${lastAction?.action}) scopes(${lastAction?.scope}-${scope})`;
            const error = new Error(errorMessage);
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'jira-software-context-menu-controller-open-sub-menu-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            return;
        }
        setState({
            menus: {
                [scope]: {
                    ...menuState,
                    openPath: menuItem.id
                }
            },
            lastAction: {
                action: 'openSubMenu',
                scope: scope
            }
        });
    };
const $86c3adba46766e51$export$69ff42680518db68 = (scope)=>({ getState: getState, dispatch: dispatch })=>{
        const { menus: menus, lastAction: lastAction } = getState();
        const menuState = menus[scope];
        if (!menuState) {
            if (lastAction?.action === 'closeMenu') return;
            const errorMessage = `Menu state is not defined - last action(${lastAction?.action}) scopes(${lastAction?.scope}-${scope})`;
            const error = new Error(errorMessage);
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'jira-software-context-menu-controller-close-menu-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            return;
        }
        dispatch($86c3adba46766e51$export$aad8462122ac592b({
            action: 'closeMenu',
            scope: scope
        }));
    };
const $86c3adba46766e51$var$closeSubMenu = (scope)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const menuState = state.menus[scope];
        if (!menuState) {
            if (state.lastAction?.action === 'closeMenu') return;
            const errorMessage = `Menu state is not defined - last action(${state.lastAction?.action}) scopes(${state.lastAction?.scope}-${scope})`;
            const error = new Error(errorMessage);
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'jira-software-context-menu-controller-close-sub-menu-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            return;
        }
        setState({
            menus: {
                [scope]: {
                    ...menuState,
                    openPath: undefined
                }
            },
            lastAction: {
                action: 'closeSubMenu',
                scope: scope
            }
        });
    };
const $86c3adba46766e51$var$setForcedFocusPath = (scope, id)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const menuState = state.menus[scope];
        if (!menuState) {
            if (state.lastAction?.action === 'closeMenu') return;
            const errorMessage = `Menu state is not defined - last action(${state.lastAction?.action}) scopes(${state.lastAction?.scope}-${scope}`;
            const error = new Error(errorMessage);
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'jira-software-context-menu-controller-set-focused-path-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            return;
        }
        setState({
            menus: {
                [scope]: {
                    ...menuState,
                    forcedFocusPath: id
                }
            },
            lastAction: {
                action: 'setForcedFocusPath',
                scope: scope
            }
        });
    };
const $86c3adba46766e51$export$e324594224ef24da = {
    openMenu: $86c3adba46766e51$var$openMenu,
    closeMenu: $86c3adba46766e51$export$69ff42680518db68,
    openSubMenu: $86c3adba46766e51$export$11ed9b7b8045d408,
    closeSubMenu: $86c3adba46766e51$var$closeSubMenu,
    setForcedFocusPath: $86c3adba46766e51$var$setForcedFocusPath,
    reset: $86c3adba46766e51$export$aad8462122ac592b,
    setPersistentFocus: $86c3adba46766e51$var$setPersistentFocus
};

});
parcelRegister("5mnHu", function(module, exports) {

$parcel$export(module.exports, "onContainerInit", () => $2bb8e53135c3a836$export$34f4621b58d3fbc8);
$parcel$export(module.exports, "onContainerUpdate", () => $2bb8e53135c3a836$export$ab8f0de40a3a2d2d);
$parcel$export(module.exports, "fireOpenMenuAnalyticsEvent", () => $2bb8e53135c3a836$export$d4ad71c555abd3c8);

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");

var $jumVR = parcelRequire("jumVR");
const $2bb8e53135c3a836$export$34f4621b58d3fbc8 = ()=>({ setState: setState, getState: getState }, { cardId: cardId, bulkOpsFlow: bulkOpsFlow, ...analyticsContainerProps })=>{
        const { analytics: analytics } = getState();
        setState({
            analytics: {
                ...analyticsContainerProps
            }
        });
        if (bulkOpsFlow && (0, $jumVR.shouldFlowBeEnded)(analytics, analyticsContainerProps, bulkOpsFlow)) bulkOpsFlow?.end();
        else if (bulkOpsFlow && (0, $jumVR.hasUserStartedSelecting)(analytics, analyticsContainerProps)) bulkOpsFlow?.start();
    };
const $2bb8e53135c3a836$export$ab8f0de40a3a2d2d = ()=>({ setState: setState, getState: getState }, { cardId: cardId, bulkOpsFlow: bulkOpsFlow, ...analyticsContainerProps })=>{
        const { analytics: analytics } = getState();
        if ((0, $jumVR.hasUserStartedSelecting)(analytics, analyticsContainerProps)) {
            if (!bulkOpsFlow) (0, $guiFP.default)({
                error: new Error('Trying to start a flow while bulkOpsSession is undefined'),
                meta: {
                    id: 'jira-software-context-menu-controller-on-container-update-flow-start-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            else bulkOpsFlow?.start();
        } else if ((0, $jumVR.hasUserUnselectedAll)(analytics, analyticsContainerProps)) {
            if (!bulkOpsFlow) (0, $guiFP.default)({
                error: new Error('Trying to end a flow while bulkOpsSession is undefined'),
                meta: {
                    id: 'jira-software-context-menu-controller-on-container-update-flow-end-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            else bulkOpsFlow?.end();
        }
        setState({
            analytics: {
                ...analytics,
                ...analyticsContainerProps
            }
        });
    };
const $2bb8e53135c3a836$export$d4ad71c555abd3c8 = ({ event: event, cardId: cardId, selectedCardIds: selectedCardIds, openedFrom: openedFrom })=>{
    const attributes = {
        ...(0, $jumVR.getCardSelectionAnalytics)(selectedCardIds, cardId, true),
        isLinkIssueFromBoardCardEnabled: true,
        openedFrom: openedFrom
    };
    // Attributes normally get merged together. We want to override the issue_ids attribute instead
    event.context.push({
        attributes: {
            issue_ids: null
        }
    });
    (0, $jMP2a.fireUIAnalytics)(event, 'cardActions', attributes);
};

});




parcelRegister("2U8YO", function(module, exports) {

$parcel$export(module.exports, "useScrollState", () => $93b1ae720a2f9e16$export$98084ad349e2edae);
$parcel$export(module.exports, "ScrollStateContextProvider", () => $93b1ae720a2f9e16$export$7cc0055278d35041);
/*!
 * Adding too many scroll listeners adds overhead to both the initial
 * "bootstrap" phase, when the listeners are added, and all scroll events.
 *
 * Some virtualisation use-cases such as boards may have a large number of
 * virtual lists instances. Sharing a scroll element through context avoids
 * attaching one listener per list.
 */ 
var $eUqFw = parcelRequire("eUqFw");
const $93b1ae720a2f9e16$export$50b6b7783d156e1b = 200;
const $93b1ae720a2f9e16$var$INITIAL_SCROLL_STATE = {
    height: 0,
    width: 0,
    scrollHeight: 0,
    scrollWidth: 0,
    scrollTop: 0,
    scrollLeft: 0,
    isScrolling: false,
    scrollElement: null
};
const $93b1ae720a2f9e16$var$ScrollStateContext = /*#__PURE__*/ (0, $eUqFw.createContext)($93b1ae720a2f9e16$var$INITIAL_SCROLL_STATE);
const $93b1ae720a2f9e16$export$98084ad349e2edae = ()=>(0, $eUqFw.useContext)($93b1ae720a2f9e16$var$ScrollStateContext);
const $93b1ae720a2f9e16$var$attachResizeObserver = (callback, targetEl)=>{
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    if (!targetEl) return ()=>{};
    let resizeObserver = null;
    // SSR fix. Do not instantiate for SSR
    if (typeof ResizeObserver !== 'undefined') resizeObserver = new ResizeObserver(()=>callback());
    // When mounting our listener, if its the Window object, treat it as such.
    // This can happen in Storybook but not in any other scenario
    if (targetEl instanceof Window) targetEl.addEventListener('resize', callback);
    else resizeObserver?.observe(targetEl);
    return ()=>{
        // Cleanup the resize callback we have attached
        if (targetEl instanceof Window) targetEl.removeEventListener('resize', callback);
        else resizeObserver?.disconnect();
    };
};
/**
 * Listens for scroll events on the `HTMLElement` `scrollRef.current` and updates a state
 * variable with the scroll state, which is returned.
 */ const $93b1ae720a2f9e16$var$useElementScrollState = (scrollRef)=>{
    const [scrollState, setScrollState] = (0, $eUqFw.useState)($93b1ae720a2f9e16$var$INITIAL_SCROLL_STATE);
    (0, $eUqFw.useEffect)(()=>{
        const targetEl = scrollRef.current;
        if (!targetEl) return undefined;
        let clearScrollingTimeoutId;
        const onScroll = ()=>{
            setScrollState((state)=>({
                    ...state,
                    scrollTop: targetEl.scrollTop,
                    scrollLeft: targetEl.scrollLeft,
                    isScrolling: true
                }));
            clearTimeout(clearScrollingTimeoutId);
            clearScrollingTimeoutId = setTimeout(()=>{
                setScrollState((state)=>({
                        ...state,
                        scrollTop: targetEl.scrollTop,
                        scrollLeft: targetEl.scrollLeft,
                        isScrolling: false
                    }));
            }, $93b1ae720a2f9e16$export$50b6b7783d156e1b);
        };
        const onResize = ()=>{
            setScrollState((state)=>({
                    ...state,
                    scrollTop: targetEl.scrollTop,
                    scrollLeft: targetEl.scrollLeft,
                    height: targetEl.clientHeight,
                    width: targetEl.clientWidth,
                    scrollHeight: targetEl.scrollHeight,
                    scrollWidth: targetEl.scrollWidth,
                    isScrolling: true
                }));
            clearTimeout(clearScrollingTimeoutId);
            clearScrollingTimeoutId = setTimeout(()=>{
                setScrollState((state)=>({
                        ...state,
                        scrollTop: targetEl.scrollTop,
                        scrollLeft: targetEl.scrollLeft,
                        isScrolling: false
                    }));
            }, $93b1ae720a2f9e16$export$50b6b7783d156e1b);
        };
        // We want to know when the scroll element/container itself resizes as this impacts
        // the number of rows we show
        const cleanupResizeObserver = $93b1ae720a2f9e16$var$attachResizeObserver(onResize, targetEl);
        targetEl.addEventListener('scroll', onScroll);
        setScrollState({
            height: targetEl.clientHeight,
            width: targetEl.clientWidth,
            scrollHeight: targetEl.scrollHeight,
            scrollWidth: targetEl.scrollWidth,
            scrollTop: targetEl.scrollTop,
            scrollLeft: targetEl.scrollLeft,
            isScrolling: false,
            scrollElement: targetEl
        });
        return ()=>{
            targetEl.removeEventListener('scroll', onScroll);
            cleanupResizeObserver();
            clearTimeout(clearScrollingTimeoutId);
        };
    }, [
        scrollRef
    ]);
    return scrollState;
};
const $93b1ae720a2f9e16$export$7cc0055278d35041 = ({ scrollRef: scrollRef, children: children })=>{
    const scrollState = $93b1ae720a2f9e16$var$useElementScrollState(scrollRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($93b1ae720a2f9e16$var$ScrollStateContext.Provider, {
        value: scrollState
    }, children);
};

});

parcelRegister("fenWW", function(module, exports) {

$parcel$export(module.exports, "LongTasksScrollObserver", () => $6600757d3af00705$export$55bf40af27443842);

var $eUqFw = parcelRequire("eUqFw");

var $511uv = parcelRequire("511uv");

var $6RZSH = parcelRequire("6RZSH");

var $fGi4Q = parcelRequire("fGi4Q");

var $bkIRY = parcelRequire("bkIRY");
/**
 * Tracks long-tasks that happen while scrolling on a certain 'scrollEl'.
 */ const $6600757d3af00705$var$LongTasksScrollObserverBase = ({ observationType: observationType, attributes: attributes, appName: appName, ...rest })=>{
    const onScrollStart = (0, $eUqFw.useCallback)(()=>{
        (0, $511uv.getLongTasksMetrics)(observationType).start(appName, undefined, attributes);
        if ((0, $fGi4Q.isLongTasksRefactorEnabled)()) performance.mark(`${appName}:scrolling-task:start`);
    }, [
        attributes,
        appName,
        observationType
    ]);
    const onScrollEnd = (0, $eUqFw.useCallback)((lastScrollTime)=>{
        (0, $511uv.getLongTasksMetrics)(observationType).stop((0, $6RZSH.softwareGenericLongTasksReporter)('scroll', lastScrollTime));
        if ((0, $fGi4Q.isLongTasksRefactorEnabled)()) {
            performance.mark(`${appName}:scrolling-task:end`);
            performance.measure(`${appName}:scrolling-task`, `${appName}:scrolling-task:start`, `${appName}:scrolling-task:end`);
        }
    }, [
        observationType,
        appName
    ]);
    (0, $bkIRY.useScrollStateObserver)({
        ...rest,
        onScrollStart: onScrollStart,
        onScrollEnd: onScrollEnd
    });
    return null;
};
$6600757d3af00705$var$LongTasksScrollObserverBase.defaultProps = {
    observationType: 'scroll',
    attributes: {}
};
const $6600757d3af00705$export$55bf40af27443842 = /*#__PURE__*/ (0, $eUqFw.memo)($6600757d3af00705$var$LongTasksScrollObserverBase);

});
parcelRegister("6RZSH", function(module, exports) {

$parcel$export(module.exports, "softwareGenericLongTasksReporter", () => $1de416ce1ae9b97d$export$b78c92c0ba709033);

var $x71UL = parcelRequire("x71UL");

var $fPUXl = parcelRequire("fPUXl");

var $7tZw9 = parcelRequire("7tZw9");


var $3FyZ4 = parcelRequire("3FyZ4");

var $4Yq4U = parcelRequire("4Yq4U");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1de416ce1ae9b97d$var$aggregatedDataTimeout = {};
const $1de416ce1ae9b97d$export$b78c92c0ba709033 = (observationType, observationEndTime)=>(observationData)=>{
        if ((0, $4Yq4U.isLongTasksRefactorEnabled)()) {
            if (!(0, $7tZw9.isExpandedObservationData)(observationData) || !('appName' in observationData)) return;
            const { appName: appName, startTimestamp: startTimestamp, events: events } = observationData;
            const startTime = startTimestamp;
            const endTime = observationEndTime ?? performance.now();
            const duration = endTime - startTime;
            if (duration < 100) return;
            const rawLongTasks = events ?? [];
            const longTasks = rawLongTasks.filter((event)=>event.timestamp >= startTime && event.timestamp + event.duration <= endTime).map((event)=>({
                    timestamp: event.timestamp - startTime,
                    duration: event.duration
                }));
            const minimumBlockedDuration = longTasks.reduce((sum, longTask)=>sum + longTask.duration, 0);
            const frameRateTarget = 60;
            const budgetPerFrame = 1000 / frameRateTarget;
            const timeOverBudget = longTasks.map((event)=>event.duration - budgetPerFrame).reduce((sum, time)=>sum + time, 0);
            const summary = {
                qualityIndex: 1 - timeOverBudget / duration,
                hasLongTasks: longTasks.length > 0,
                hasExtraLongTasks: longTasks.filter((l)=>l.duration >= 100).length > 0,
                longTasks: longTasks,
                rawLongTaskCount: rawLongTasks.length,
                longTaskCount: longTasks.length,
                minimumBlockedDuration: minimumBlockedDuration,
                timeOverBudget: timeOverBudget,
                duration: duration,
                startTime: startTime,
                endTime: endTime
            };
            (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
                client.sendEvent({
                    type: (0, $41ea3621645e2acc$export$12346a674644c156),
                    payload: {
                        source: appName,
                        action: 'longTask',
                        actionSubject: 'ui',
                        actionSubjectId: `${appName}-${observationType}`,
                        attributes: {
                            key: appName,
                            ...summary
                        }
                    }
                });
            });
        } else {
            if (!(0, $7tZw9.isExpandedObservationData)(observationData)) return;
            const startTime = observationData.events.map((event)=>event.timestamp);
            const analyticsData = {
                ...(0, $fPUXl.generateLongTaskAnalyticsContinuousActionSummary)(observationType, observationData.events),
                measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTime)
            };
            const { appName: appName } = observationData;
            if ($1de416ce1ae9b97d$var$aggregatedDataTimeout[`software.${appName}.${observationType}`]) $1de416ce1ae9b97d$var$aggregatedDataTimeout[`software.${appName}.${observationType}`].data.push(analyticsData);
            else $1de416ce1ae9b97d$var$aggregatedDataTimeout[`software.${appName}.${observationType}`] = {
                data: [
                    analyticsData
                ],
                extra: observationData.extra,
                timeout: setTimeout(()=>{
                    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
                        const { data: data, extra: extraData } = $1de416ce1ae9b97d$var$aggregatedDataTimeout[`software.${appName}.${observationType}`];
                        client.sendEvent({
                            type: (0, $41ea3621645e2acc$export$12346a674644c156),
                            payload: {
                                source: appName,
                                action: 'longTask',
                                actionSubject: 'ui',
                                actionSubjectId: `${appName}-${observationType}`,
                                attributes: {
                                    key: appName,
                                    ...(0, $fPUXl.getAverageResultsFromContinuousActions)(observationType, data),
                                    ...extraData,
                                    avgScrollTimespan: (0, (/*@__PURE__*/$parcel$interopDefault($x71UL)))(data, 'measureTimespan')
                                }
                            }
                        });
                        delete $1de416ce1ae9b97d$var$aggregatedDataTimeout[`software.${appName}.${observationType}`];
                    });
                }, 7000)
            };
        }
    };

});
parcelRegister("4Yq4U", function(module, exports) {

$parcel$export(module.exports, "isLongTasksRefactorEnabled", () => $7ea40325e3374f03$export$dd0b3b59404a264e);

var $1ybV0 = parcelRequire("1ybV0");
const $7ea40325e3374f03$export$dd0b3b59404a264e = ()=>(0, $1ybV0.ff)('jsw.long-tasks-refactor'); // </pyamada>

});


parcelRegister("fGi4Q", function(module, exports) {

$parcel$export(module.exports, "isLongTasksRefactorEnabled", () => $b3601266cac33b0a$export$dd0b3b59404a264e);

var $1ybV0 = parcelRequire("1ybV0");
const $b3601266cac33b0a$export$dd0b3b59404a264e = ()=>(0, $1ybV0.ff)('jsw.long-tasks-refactor'); // </pyamada>

});

parcelRegister("bkIRY", function(module, exports) {

$parcel$export(module.exports, "useScrollStateObserver", () => $95ba817a630b9060$export$51374614020e4579);

var $eUqFw = parcelRequire("eUqFw");
const $95ba817a630b9060$var$DEFAULT_SCROLL_STOP_INTERVAL_MS = 500;
const $95ba817a630b9060$export$53d63bb2b7d56f77 = ({ onScrollStart: onScrollStart, onScrollEnd: onScrollEnd, scrollStopIntervalMs: scrollStopIntervalMs })=>{
    const isScrollingRef = (0, $eUqFw.useRef)(false);
    const scrollStopTimerRef = (0, $eUqFw.useRef)(null);
    const onScroll = (0, $eUqFw.useCallback)(()=>{
        if (!isScrollingRef.current) {
            isScrollingRef.current = true;
            onScrollStart();
        }
        const lastScrollTime = performance.now();
        // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(scrollStopTimerRef.current);
        scrollStopTimerRef.current = setTimeout(()=>{
            isScrollingRef.current = false;
            onScrollEnd(lastScrollTime);
        }, scrollStopIntervalMs);
        return ()=>{
            if (isScrollingRef.current) onScrollEnd(lastScrollTime);
            // @ts-expect-error - TS2769 - No overload matches this call.
            clearTimeout(scrollStopTimerRef.current);
        };
    }, [
        isScrollingRef,
        scrollStopTimerRef,
        scrollStopIntervalMs,
        onScrollStart,
        onScrollEnd
    ]);
    return {
        onScroll: onScroll,
        isScrollingRef: isScrollingRef
    };
};
const $95ba817a630b9060$export$51374614020e4579 = ({ scrollStopIntervalMs: scrollStopIntervalMs, scrollElRef: scrollElRef, scrollEl: scrollEl, onScrollStart: onScrollStart, onScrollEnd: onScrollEnd })=>{
    const { onScroll: onScroll, isScrollingRef: isScrollingRef } = $95ba817a630b9060$export$53d63bb2b7d56f77({
        onScrollStart: onScrollStart,
        onScrollEnd: onScrollEnd,
        scrollStopIntervalMs: scrollStopIntervalMs ?? $95ba817a630b9060$var$DEFAULT_SCROLL_STOP_INTERVAL_MS
    });
    (0, $eUqFw.useEffect)(()=>{
        const el = scrollEl ?? scrollElRef?.current;
        if (!el) return undefined;
        el.addEventListener('scroll', onScroll);
        return ()=>{
            el.removeEventListener('scroll', onScroll);
        };
    }, [
        scrollEl,
        scrollElRef,
        isScrollingRef,
        onScroll,
        onScrollEnd
    ]);
};

});


parcelRegister("8MrYx", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsContainer", () => $40a687938ce25904$export$920204d7413f6fe1);
$parcel$export(module.exports, "useViewSettings", () => $40a687938ce25904$export$704cffd05c51e2b6);
$parcel$export(module.exports, "useViewSettingsActions", () => $40a687938ce25904$export$d6a70239aff099b8);
$parcel$export(module.exports, "useIsFullscreen", () => $40a687938ce25904$export$d397eccea5f37b0a);
$parcel$export(module.exports, "useShowVersionPanel", () => $40a687938ce25904$export$459b400687bc0f20);
$parcel$export(module.exports, "useShowEpicPanel", () => $40a687938ce25904$export$203c9a05aebea04a);
$parcel$export(module.exports, "useShowQuickFilters", () => $40a687938ce25904$export$714ba21e90859f45);
$parcel$export(module.exports, "useShowCompactMode", () => $40a687938ce25904$export$8a591bb42a805814);
$parcel$export(module.exports, "useShowPanels", () => $40a687938ce25904$export$736bfa164a60e240);
$parcel$export(module.exports, "useShowEpics", () => $40a687938ce25904$export$ecaca052f9755b4e);
$parcel$export(module.exports, "useShowVersions", () => $40a687938ce25904$export$10178a1fc177e27a);
$parcel$export(module.exports, "useShowStatuses", () => $40a687938ce25904$export$7a14d92e68e42de1);
$parcel$export(module.exports, "useShowUnscheduledColumn", () => $40a687938ce25904$export$afb23457b0007ce7);
$parcel$export(module.exports, "useShowIssueLinksStats", () => $40a687938ce25904$export$1d584d816be8e0fd);
$parcel$export(module.exports, "useShowAssignee", () => $40a687938ce25904$export$be6bf1e24771efde);
$parcel$export(module.exports, "useHasCardExtraFields", () => $40a687938ce25904$export$9e1ece2ef34a030);
$parcel$export(module.exports, "useCardFieldsSettings", () => $40a687938ce25904$export$e41d531469117029);

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");

var $jyKDT = parcelRequire("jyKDT");

var $cMFHk = parcelRequire("cMFHk");

var $2R2bz = parcelRequire("2R2bz");
const $40a687938ce25904$var$Store = (0, $a61MH.createStore)({
    name: 'ViewSettings',
    initialState: $jyKDT.initialState,
    actions: $cMFHk.actions
});
const $40a687938ce25904$export$920204d7413f6fe1 = (0, $heB5U.createContainer)($40a687938ce25904$var$Store, {
    onInit: (0, $cMFHk.actions).initState
});
const $40a687938ce25904$export$704cffd05c51e2b6 = (0, $ggKAj.createHook)($40a687938ce25904$var$Store);
const $40a687938ce25904$export$d6a70239aff099b8 = (0, $ggKAj.createActionsHook)($40a687938ce25904$var$Store);
const $40a687938ce25904$export$d397eccea5f37b0a = (0, $ggKAj.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getIsFullscreen)
});
const $40a687938ce25904$export$459b400687bc0f20 = (0, $ggKAj.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowVersionPanel)
});
const $40a687938ce25904$export$203c9a05aebea04a = (0, $ggKAj.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowEpicPanel)
});
const $40a687938ce25904$export$714ba21e90859f45 = (0, $ggKAj.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowQuickFilters)
});
const $40a687938ce25904$export$8a591bb42a805814 = (0, $ggKAj.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowCompactMode)
});
const $40a687938ce25904$export$736bfa164a60e240 = (0, $ggKAj.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowPanels)
});
const $40a687938ce25904$export$ecaca052f9755b4e = (0, $ggKAj.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowEpics)
});
const $40a687938ce25904$export$10178a1fc177e27a = (0, $ggKAj.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowVersions)
});
const $40a687938ce25904$export$7a14d92e68e42de1 = (0, $ggKAj.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowStatuses)
});
const $40a687938ce25904$export$afb23457b0007ce7 = (0, $ggKAj.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowUnscheduledColumn)
});
const $40a687938ce25904$export$1d584d816be8e0fd = (0, $ggKAj.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowIssueLinksStats)
});
const $40a687938ce25904$export$c94c02788702c7e4 = (0, $ggKAj.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowIssueType)
});
const $40a687938ce25904$export$8007ae8b25a75629 = (0, $ggKAj.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowIssueKey)
});
const $40a687938ce25904$export$75223d65852dc3c0 = (0, $ggKAj.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowPriority)
});
const $40a687938ce25904$export$be6bf1e24771efde = (0, $ggKAj.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowAssignee)
});
const $40a687938ce25904$export$b5a76590347456cc = (0, $ggKAj.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowEstimate)
});
const $40a687938ce25904$export$5e8e69c97a3cd45b = (0, $ggKAj.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowCardExtraField)
});
const $40a687938ce25904$export$a53839ab3a916ce3 = (0, $ggKAj.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowDaysInColumn)
});
const $40a687938ce25904$export$77ff271d002b6f7e = (0, $ggKAj.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowCardCovers)
});
const $40a687938ce25904$export$9e1ece2ef34a030 = (0, $ggKAj.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getHasCardExtraFields)
});
const $40a687938ce25904$export$e41d531469117029 = (0, $ggKAj.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getCardFieldsSettings)
});

});
parcelRegister("cMFHk", function(module, exports) {

$parcel$export(module.exports, "actions", () => $09be8f99c8e5e595$export$e324594224ef24da);

var $4E7nZ = parcelRequire("4E7nZ");
const $09be8f99c8e5e595$export$e324594224ef24da = {
    setViewSettings: $4E7nZ.setViewSettings,
    setIsFullscreen: $4E7nZ.setIsFullscreen,
    setViewSettingsPanels: $4E7nZ.setViewSettingsPanels,
    setViewSettingsQuickFilters: $4E7nZ.setViewSettingsQuickFilters,
    setViewSettingsCardDetails: $4E7nZ.setViewSettingsCardDetails,
    setViewSettingsCardExtraFields: $4E7nZ.setViewSettingsCardExtraFields,
    setViewSettingsCompactMode: $4E7nZ.setViewSettingsCompactMode,
    setShowUnscheduledColumn: $4E7nZ.setShowUnscheduledColumn,
    toggleViewSetting: $4E7nZ.toggleViewSetting,
    toggleShowEpics: $4E7nZ.toggleShowEpics,
    toggleShowVersions: $4E7nZ.toggleShowVersions,
    toggleShowStatuses: $4E7nZ.toggleShowStatuses,
    toggleShowLinkedIssuesStats: $4E7nZ.toggleShowLinkedIssuesStats,
    toggleExtraField: $4E7nZ.toggleExtraField,
    toggleShowDaysInColumn: $4E7nZ.toggleShowDaysInColumn,
    toggleShowDueDate: $4E7nZ.toggleShowDueDate,
    toggleShowLabels: $4E7nZ.toggleShowLabels,
    initState: $4E7nZ.initState
};

});
parcelRegister("4E7nZ", function(module, exports) {

$parcel$export(module.exports, "initState", () => $b676a0d483ac8166$export$f6196a6c6bb539b4);
$parcel$export(module.exports, "setViewSettings", () => $b676a0d483ac8166$export$99f2d9eb0b41b93);
$parcel$export(module.exports, "setIsFullscreen", () => $b676a0d483ac8166$export$9c73b2f282069160);
$parcel$export(module.exports, "setViewSettingsPanels", () => $b676a0d483ac8166$export$427f126b21640252);
$parcel$export(module.exports, "setViewSettingsQuickFilters", () => $b676a0d483ac8166$export$60d0caf3b1c59159);
$parcel$export(module.exports, "setViewSettingsCompactMode", () => $b676a0d483ac8166$export$9ca6e4490ca9b1fc);
$parcel$export(module.exports, "setViewSettingsCardDetails", () => $b676a0d483ac8166$export$af2e5a35023755b5);
$parcel$export(module.exports, "setViewSettingsCardExtraFields", () => $b676a0d483ac8166$export$b54537ba70def946);
$parcel$export(module.exports, "toggleViewSetting", () => $b676a0d483ac8166$export$779d9a10b8826796);
$parcel$export(module.exports, "toggleShowEpics", () => $b676a0d483ac8166$export$c1bb93dcfa07c797);
$parcel$export(module.exports, "toggleShowVersions", () => $b676a0d483ac8166$export$582a65f6c8cb93ab);
$parcel$export(module.exports, "toggleShowStatuses", () => $b676a0d483ac8166$export$ac311ca7d5df1d03);
$parcel$export(module.exports, "toggleShowLinkedIssuesStats", () => $b676a0d483ac8166$export$580abda923c30dc5);
$parcel$export(module.exports, "setShowUnscheduledColumn", () => $b676a0d483ac8166$export$6edce735c6eb4cb0);
$parcel$export(module.exports, "toggleShowDaysInColumn", () => $b676a0d483ac8166$export$2849cc68d8e521b7);
$parcel$export(module.exports, "toggleShowDueDate", () => $b676a0d483ac8166$export$ef2b1a307fba6e8a);
$parcel$export(module.exports, "toggleShowLabels", () => $b676a0d483ac8166$export$229260fb852e61e0);
$parcel$export(module.exports, "toggleExtraField", () => $b676a0d483ac8166$export$6acb0c83c20a20);

var $3kYjh = parcelRequire("3kYjh");

var $cNacc = parcelRequire("cNacc");
const $b676a0d483ac8166$export$f6196a6c6bb539b4 = ()=>({ setState: setState }, { view: view })=>{
        setState({
            view: view
        });
    };
const $b676a0d483ac8166$export$99f2d9eb0b41b93 = (newState)=>({ setState: setState })=>{
        setState(newState);
    };
const $b676a0d483ac8166$export$9c73b2f282069160 = ({ boardId: boardId, view: view, isFullscreen: isFullscreen })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setViewSettingsIsFullscreen({
            boardId: boardId,
            isFullscreen: isFullscreen,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            isFullscreen: isFullscreen
        });
    };
const $b676a0d483ac8166$export$427f126b21640252 = ({ boardId: boardId, view: view, panelState: panelState })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setViewSettingsPanels({
            boardId: boardId,
            panelState: panelState,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showEpicPanel: panelState.EPIC_PANEL,
            showVersionPanel: panelState.VERSION_PANEL
        });
    };
const $b676a0d483ac8166$export$60d0caf3b1c59159 = ({ boardId: boardId, view: view, showQuickFilters: showQuickFilters })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setViewSettingsQuickFilters({
            boardId: boardId,
            showQuickFilters: showQuickFilters,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showQuickFilters: showQuickFilters
        });
    };
const $b676a0d483ac8166$export$9ca6e4490ca9b1fc = ({ boardId: boardId, view: view, showCompactMode: showCompactMode })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setViewSettingsCompactMode({
            boardId: boardId,
            showCompactMode: showCompactMode,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showCompactMode: showCompactMode
        });
    };
const $b676a0d483ac8166$export$af2e5a35023755b5 = ({ boardId: boardId, view: view, cardDetailsState: cardDetailsState })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setViewSettingsCardDetails({
            boardId: boardId,
            cardDetailsState: cardDetailsState,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showEpics: cardDetailsState.SHOW_EPICS,
            showVersions: cardDetailsState.SHOW_VERSIONS,
            showStatuses: cardDetailsState.SHOW_STATUSES,
            showIssueLinksStats: cardDetailsState.SHOW_ISSUE_LINKS_STATS,
            showDaysInColumn: cardDetailsState.SHOW_DAYS_IN_COLUMN,
            showIssueType: cardDetailsState.SHOW_ISSUE_TYPE,
            showIssueKey: cardDetailsState.SHOW_ISSUE_KEY,
            showEstimate: cardDetailsState.SHOW_ESTIMATE,
            showPriority: cardDetailsState.SHOW_PRIORITY,
            showAssignee: cardDetailsState.SHOW_ASSIGNEE,
            showDueDate: cardDetailsState.SHOW_DUE_DATE,
            showLabels: cardDetailsState.SHOW_LABELS
        });
    };
const $b676a0d483ac8166$export$b54537ba70def946 = ({ boardId: boardId, view: view, cardExtraFieldsState: cardExtraFieldsState })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setViewSettingsCardExtraFields({
            boardId: boardId,
            cardExtraFieldsState: cardExtraFieldsState,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            cardExtraFields: cardExtraFieldsState
        });
    };
const $b676a0d483ac8166$export$779d9a10b8826796 = ({ boardId: boardId, view: view, setting: setting })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        const set = (newState)=>{
            setState(newState);
            $cNacc.setViewSettings({
                boardId: boardId,
                state: newState,
                view: view || currentSettings.view || undefined
            });
        };
        switch(setting){
            case (0, $3kYjh.ViewSetting).VERSION_PANEL:
                set({
                    ...currentSettings,
                    showVersionPanel: !currentSettings.showVersionPanel
                });
                break;
            case (0, $3kYjh.ViewSetting).EPIC_PANEL:
                set({
                    ...currentSettings,
                    showEpicPanel: !currentSettings.showEpicPanel
                });
                break;
            case (0, $3kYjh.ViewSetting).QUICK_FILTERS:
                set({
                    ...currentSettings,
                    showQuickFilters: !currentSettings.showQuickFilters
                });
                break;
            case (0, $3kYjh.ViewSetting).COMPACT_MODE:
                set({
                    ...currentSettings,
                    showCompactMode: !currentSettings.showCompactMode
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_EPICS:
                set({
                    ...currentSettings,
                    showEpics: !currentSettings.showEpics
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_STATUSES:
                set({
                    ...currentSettings,
                    showStatuses: !currentSettings.showStatuses
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_VERSIONS:
                set({
                    ...currentSettings,
                    showVersions: !currentSettings.showVersions
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_UNSCHEDULED_COLUMN:
                set({
                    ...currentSettings,
                    showUnscheduledColumn: !currentSettings.showUnscheduledColumn
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_ISSUE_KEY:
                set({
                    ...currentSettings,
                    showIssueKey: !currentSettings.showIssueKey
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_ISSUE_TYPE:
                set({
                    ...currentSettings,
                    showIssueType: !currentSettings.showIssueType
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_PRIORITY:
                set({
                    ...currentSettings,
                    showPriority: !currentSettings.showPriority
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_ASSIGNEE:
                set({
                    ...currentSettings,
                    showAssignee: !currentSettings.showAssignee
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_ESTIMATE:
                set({
                    ...currentSettings,
                    showEstimate: !currentSettings.showEstimate
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_DAYS_IN_COLUMN:
                set({
                    ...currentSettings,
                    showDaysInColumn: !currentSettings.showDaysInColumn
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_DUE_DATE:
                set({
                    ...currentSettings,
                    showDueDate: !currentSettings.showDueDate
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_LABELS:
                set({
                    ...currentSettings,
                    showLabels: !currentSettings.showLabels
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_CARD_COVERS:
                set({
                    ...currentSettings,
                    showCardCovers: !currentSettings.showCardCovers
                });
                break;
            default:
                break;
        }
    };
const $b676a0d483ac8166$export$c1bb93dcfa07c797 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setShowEpics({
            boardId: boardId,
            showEpics: !currentSettings.showEpics,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showEpics: !currentSettings.showEpics
        });
    };
const $b676a0d483ac8166$export$582a65f6c8cb93ab = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setShowVersions({
            boardId: boardId,
            showVersions: !currentSettings.showVersions,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showVersions: !currentSettings.showVersions
        });
    };
const $b676a0d483ac8166$export$ac311ca7d5df1d03 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setShowStatuses({
            boardId: boardId,
            showStatuses: !currentSettings.showStatuses,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showStatuses: !currentSettings.showStatuses
        });
    };
const $b676a0d483ac8166$export$580abda923c30dc5 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setShowIssueLinksStats({
            boardId: boardId,
            showIssueLinksStats: !currentSettings.showIssueLinksStats,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showIssueLinksStats: !currentSettings.showIssueLinksStats
        });
    };
const $b676a0d483ac8166$export$6edce735c6eb4cb0 = (boardId, isVisible)=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setShowUnscheduledColumn({
            boardId: boardId,
            showUnscheduledColumn: isVisible
        });
        setState({
            ...currentSettings,
            showUnscheduledColumn: isVisible
        });
    };
const $b676a0d483ac8166$export$2849cc68d8e521b7 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setShowDaysInColumn({
            boardId: boardId,
            showDaysInColumn: !currentSettings.showDaysInColumn,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showDaysInColumn: !currentSettings.showDaysInColumn
        });
    };
const $b676a0d483ac8166$export$ef2b1a307fba6e8a = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setShowDueDate({
            boardId: boardId,
            showDueDate: !currentSettings.showDueDate,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showDueDate: !currentSettings.showDueDate
        });
    };
const $b676a0d483ac8166$export$229260fb852e61e0 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setShowLabels({
            boardId: boardId,
            showLabels: !currentSettings.showLabels,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showLabels: !currentSettings.showLabels
        });
    };
const $b676a0d483ac8166$export$6acb0c83c20a20 = ({ boardId: boardId, view: view, fieldId: fieldId })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        const currentExtraFields = currentSettings.cardExtraFields;
        $cNacc.setExtraFields({
            boardId: boardId,
            cardExtraFields: {
                ...currentExtraFields,
                [fieldId]: !currentExtraFields[fieldId]
            },
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            cardExtraFields: {
                ...currentExtraFields,
                [fieldId]: !currentExtraFields[fieldId]
            }
        });
    };

});
parcelRegister("3kYjh", function(module, exports) {

$parcel$export(module.exports, "ViewSetting", () => $c7ac9f0e85497714$export$b6da678b61e4982c);

var $c3qrZ = parcelRequire("c3qrZ");

var $kqmep = parcelRequire("kqmep");
const $c7ac9f0e85497714$export$b6da678b61e4982c = {
    ...(0, $c3qrZ.Panels),
    ...(0, $kqmep.CardDetails),
    ...(0, $c3qrZ.IncrementPlanningSettings),
    QUICK_FILTERS: $c3qrZ.QUICK_FILTERS,
    COMPACT_MODE: $c3qrZ.COMPACT_MODE
};

});
parcelRegister("kqmep", function(module, exports) {

$parcel$export(module.exports, "CardDetails", () => $17487e014d4eeb0c$export$741386389156bf07);

var $c3qrZ = parcelRequire("c3qrZ");
const $17487e014d4eeb0c$export$741386389156bf07 = {
    SHOW_ISSUE_KEY: $c3qrZ.SHOW_ISSUE_KEY,
    SHOW_ISSUE_TYPE: $c3qrZ.SHOW_ISSUE_TYPE,
    SHOW_EPICS: $c3qrZ.SHOW_EPICS,
    SHOW_STATUSES: $c3qrZ.SHOW_STATUSES,
    SHOW_VERSIONS: $c3qrZ.SHOW_VERSIONS,
    SHOW_ISSUE_LINKS_STATS: $c3qrZ.SHOW_ISSUE_LINKS_STATS,
    SHOW_PRIORITY: $c3qrZ.SHOW_PRIORITY,
    SHOW_ASSIGNEE: $c3qrZ.SHOW_ASSIGNEE,
    SHOW_ESTIMATE: $c3qrZ.SHOW_ESTIMATE,
    SHOW_DAYS_IN_COLUMN: $c3qrZ.SHOW_DAYS_IN_COLUMN,
    SHOW_DUE_DATE: $c3qrZ.SHOW_DUE_DATE,
    SHOW_LABELS: $c3qrZ.SHOW_LABELS,
    SHOW_CARD_COVERS: $c3qrZ.SHOW_CARD_COVERS
};

});




parcelRegister("2R2bz", function(module, exports) {

$parcel$export(module.exports, "getIsFullscreen", () => $0824ef21329004e5$export$b061161f83abaf15);
$parcel$export(module.exports, "getShowVersionPanel", () => $0824ef21329004e5$export$cdf1158c8123d31c);
$parcel$export(module.exports, "getShowEpicPanel", () => $0824ef21329004e5$export$fc9a39e5c1906367);
$parcel$export(module.exports, "getShowQuickFilters", () => $0824ef21329004e5$export$732caa9fcae1c5ff);
$parcel$export(module.exports, "getShowCompactMode", () => $0824ef21329004e5$export$72bae49530cc02bb);
$parcel$export(module.exports, "getShowPanels", () => $0824ef21329004e5$export$e2483fb3e0d0ff4b);
$parcel$export(module.exports, "getShowEpics", () => $0824ef21329004e5$export$b631ebb4887e6060);
$parcel$export(module.exports, "getShowVersions", () => $0824ef21329004e5$export$2cb6de520195dbf5);
$parcel$export(module.exports, "getShowStatuses", () => $0824ef21329004e5$export$b5f1c34af9498ea);
$parcel$export(module.exports, "getShowUnscheduledColumn", () => $0824ef21329004e5$export$bf31a7b99f7bc62f);
$parcel$export(module.exports, "getShowIssueLinksStats", () => $0824ef21329004e5$export$266785c43d094472);
$parcel$export(module.exports, "getShowIssueType", () => $0824ef21329004e5$export$a079b5f709c4d237);
$parcel$export(module.exports, "getShowIssueKey", () => $0824ef21329004e5$export$cb710ef8b1ccd94b);
$parcel$export(module.exports, "getShowPriority", () => $0824ef21329004e5$export$5abfbf16fb2cec7b);
$parcel$export(module.exports, "getShowAssignee", () => $0824ef21329004e5$export$ad1a6d247a05049d);
$parcel$export(module.exports, "getShowEstimate", () => $0824ef21329004e5$export$d21c0b83591460c9);
$parcel$export(module.exports, "getShowCardExtraField", () => $0824ef21329004e5$export$7549550e839e6e0c);
$parcel$export(module.exports, "getShowDaysInColumn", () => $0824ef21329004e5$export$9a608cd91e68c95c);
$parcel$export(module.exports, "getShowCardCovers", () => $0824ef21329004e5$export$983376245b8547dc);
$parcel$export(module.exports, "getCardFieldsSettings", () => $0824ef21329004e5$export$e9dfc10bd434fabb);
$parcel$export(module.exports, "getHasCardExtraFields", () => $0824ef21329004e5$export$1e24fae4497ff7e0);
const $0824ef21329004e5$export$b061161f83abaf15 = (state)=>state.isFullscreen;
const $0824ef21329004e5$export$cdf1158c8123d31c = (state)=>state.showVersionPanel;
const $0824ef21329004e5$export$fc9a39e5c1906367 = (state)=>state.showEpicPanel;
const $0824ef21329004e5$export$732caa9fcae1c5ff = (state)=>state.showQuickFilters;
const $0824ef21329004e5$export$72bae49530cc02bb = (state)=>state.showCompactMode;
const $0824ef21329004e5$export$e2483fb3e0d0ff4b = (state)=>({
        EPIC_PANEL: state.showEpicPanel,
        VERSION_PANEL: state.showVersionPanel
    });
const $0824ef21329004e5$export$b631ebb4887e6060 = (state)=>state.showEpics;
const $0824ef21329004e5$export$2cb6de520195dbf5 = (state)=>state.showVersions;
const $0824ef21329004e5$export$b5f1c34af9498ea = (state)=>state.showStatuses;
const $0824ef21329004e5$export$bf31a7b99f7bc62f = (state)=>state.showUnscheduledColumn;
const $0824ef21329004e5$export$266785c43d094472 = (state)=>state.showIssueLinksStats;
const $0824ef21329004e5$export$a079b5f709c4d237 = (state)=>state.showIssueType;
const $0824ef21329004e5$export$cb710ef8b1ccd94b = (state)=>state.showIssueKey;
const $0824ef21329004e5$export$5abfbf16fb2cec7b = (state)=>state.showPriority;
const $0824ef21329004e5$export$ad1a6d247a05049d = (state)=>state.showAssignee;
const $0824ef21329004e5$export$d21c0b83591460c9 = (state)=>state.showEstimate;
const $0824ef21329004e5$export$7549550e839e6e0c = (state)=>state.cardExtraFields;
const $0824ef21329004e5$export$9a608cd91e68c95c = (state)=>state.showDaysInColumn;
const $0824ef21329004e5$export$983376245b8547dc = (state)=>state.showCardCovers;
const $0824ef21329004e5$export$e9dfc10bd434fabb = (state)=>({
        showIssueType: state.showIssueType,
        showIssueKey: state.showIssueKey,
        showPriority: state.showPriority,
        showAssignee: state.showAssignee,
        showEstimate: state.showEstimate,
        cardExtraFields: state.cardExtraFields,
        showDaysInColumn: state.showDaysInColumn,
        showDueDate: state.showDueDate,
        showLabels: state.showLabels,
        showCardCovers: state.showCardCovers
    });
const $0824ef21329004e5$export$1e24fae4497ff7e0 = (state)=>Object.values(state.cardExtraFields).length > 0 && Object.values(state.cardExtraFields).some((value)=>value === true);

});


parcelRegister("8pXmY", function(module, exports) {

$parcel$export(module.exports, "REALTIME_EVENTS", () => $5aded4ee546162ee$export$a45e758f2a5806e6);

const $5aded4ee546162ee$export$a45e758f2a5806e6 = [
    (0, $1d129cd1c8b202ad$export$86d416e8d15777d),
    (0, $1d129cd1c8b202ad$export$b22a14d5dac59664),
    (0, $1d129cd1c8b202ad$export$25fa37e5059c5a99),
    (0, $1d129cd1c8b202ad$export$d9bc8850eeef9f60),
    (0, $1d129cd1c8b202ad$export$b22142e61b3fdbee),
    (0, $1d129cd1c8b202ad$export$6b7e46ea0442b66c)
];

});

parcelRegister("l9DvH", function(module, exports) {

$parcel$export(module.exports, "usePerformanceMetric", () => $f559342f5eab0617$export$8c654db610e68aa9);

var $gPQCf = parcelRequire("gPQCf");

var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");
const $f559342f5eab0617$export$8c654db610e68aa9 = ()=>(0, $1gQ73.useBacklogSelector)((0, $hkGxG.getIsCompanyManaged)) ? (0, $gPQCf.uifBacklogNewUiPageLoad) : (0, $gPQCf.nextGenBacklogPageLoad);

});

parcelRegister("7QBTt", function(module, exports) {

$parcel$export(module.exports, "BulkActionsBar", () => $a7336af578c21c61$export$96e554270f6fba00);

var $kwce8 = parcelRequire("kwce8");

var $eUqFw = parcelRequire("eUqFw");

var $8WuJm = parcelRequire("8WuJm");


var $1gQ73 = parcelRequire("1gQ73");

var $bP7Jx = parcelRequire("bP7Jx");

var $gIy9B = parcelRequire("gIy9B");

var $ggLLZ = parcelRequire("ggLLZ");

var $6CFOY = parcelRequire("6CFOY");


var $2iD6C = parcelRequire("2iD6C");
const $a7336af578c21c61$export$26984d4d64da8edf = ()=>(0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getSelectedCards));
var $a7336af578c21c61$var$_StyledStaticContainer = /*#__PURE__*/ (0, $kwce8.default)((0, $2iD6C.StaticContainer)).withConfig({
    componentId: "sc-14ml6s9-0"
})`${(p)=>p._css}`;
const $a7336af578c21c61$export$96e554270f6fba00 = ({ bulkOperationsToolbar: bulkOperationsToolbar })=>{
    const showCheckbox = (0, $gIy9B.useShowCheckbox)();
    const selectedCardIds = $a7336af578c21c61$export$26984d4d64da8edf();
    const [{ isOverlaid: isOverlaid }, { setIsOpen: setIsOpen }] = (0, $ggLLZ.useBulkActionsBar)();
    (0, $eUqFw.useEffect)(()=>{
        setIsOpen(showCheckbox);
    }, [
        showCheckbox,
        setIsOpen
    ]);
    const componentStyles = (0, $6CFOY.useCloseGracefully)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: {
            analyticsSource: (0, $e1409a6fc345c0d8$export$840e3848643f7781)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a7336af578c21c61$var$_StyledStaticContainer, {
        isOverlaid: isOverlaid && showCheckbox,
        _css: componentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2iD6C.BulkActionsBarWrapper), {
        "data-testid": (0, $8a4555d9b638dd4e$export$8590613bf6f86e6a),
        isVisible: !!selectedCardIds.length && showCheckbox
    }, showCheckbox && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "software-backlog.header.bulk-actions-bar.bulkops-toolbar-container",
        ref: bulkOperationsToolbar.setRef
    }))));
};

});
parcelRegister("gIy9B", function(module, exports) {

$parcel$export(module.exports, "useShowCheckbox", () => $2b9ae84a8f14afc0$export$78efc2489ae380a9);

var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");
const $2b9ae84a8f14afc0$export$78efc2489ae380a9 = ()=>{
    const isCheckboxSelection = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.isCheckboxSelectionMode));
    const hasMoreThanOneSelectedCard = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getSelectedCards)).length > 1;
    return isCheckboxSelection || hasMoreThanOneSelectedCard;
};

});

parcelRegister("ggLLZ", function(module, exports) {

$parcel$export(module.exports, "useBulkActionsBar", () => $1ea459cbd16952e0$export$b8986d1c49ec5db1);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $1ea459cbd16952e0$var$initialState = {
    isOpen: false,
    isOverlaid: false,
    shouldCloseGracefully: false
};
const $1ea459cbd16952e0$var$actions = {
    setIsOpen: (isOpen)=>({ setState: setState })=>{
            setState({
                isOpen: isOpen
            });
        },
    setIsOverlaid: (isOverlaid)=>({ setState: setState })=>{
            setState({
                isOverlaid: isOverlaid
            });
        },
    setShouldCloseGracefully: (shouldCloseGracefully)=>({ setState: setState })=>{
            setState({
                shouldCloseGracefully: shouldCloseGracefully
            });
        },
    setHasClosedGracefully: ()=>({ setState: setState, getState: getState })=>{
            const { isOpen: isOpen } = getState();
            if (!isOpen) setState({
                shouldCloseGracefully: false,
                isOverlaid: false
            });
        }
};
const $1ea459cbd16952e0$var$store = (0, $a61MH.createStore)({
    initialState: $1ea459cbd16952e0$var$initialState,
    actions: $1ea459cbd16952e0$var$actions,
    name: 'backlog-bulk-actions-bar'
});
const $1ea459cbd16952e0$export$b8986d1c49ec5db1 = (0, $ggKAj.createHook)($1ea459cbd16952e0$var$store);
const $1ea459cbd16952e0$export$8d2298101520e52c = (0, $ggKAj.createActionsHook)($1ea459cbd16952e0$var$store);

});

parcelRegister("6CFOY", function(module, exports) {

$parcel$export(module.exports, "useCloseGracefully", () => $0ca54949773dbf4a$export$c8b83f6b88bb6bf5);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $ggLLZ = parcelRequire("ggLLZ");

var $dtuFp = parcelRequire("dtuFp");
const $0ca54949773dbf4a$export$c8b83f6b88bb6bf5 = ()=>{
    const [{ isOpen: isOpen, shouldCloseGracefully: shouldCloseGracefully }, { setHasClosedGracefully: setHasClosedGracefully }] = (0, $ggLLZ.useBulkActionsBar)();
    const timeout = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>{
        if (!isOpen && shouldCloseGracefully) // We need to wait for the height animation to finish before we can set the visibility to hidden.
        timeout.current = setTimeout(setHasClosedGracefully, (0, $dtuFp.ANIMATION_DURATION_MS) + (0, $dtuFp.OFFSET));
        return ()=>{
            if (timeout.current) clearTimeout(timeout.current);
        };
    }, [
        setHasClosedGracefully,
        timeout,
        isOpen,
        shouldCloseGracefully
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            visibility: isOpen ? 'visible' : 'hidden',
            transition: shouldCloseGracefully ? `height ${0, $dtuFp.HEIGHT_ANIMATION_DURATION_SECONDS}s ease-in, visibility ${0, $dtuFp.VISIBILITY_ANIMATION_DURATION_SECONDS}s ease-in` : 'none',
            ...!isOpen ? {
                height: '0px !important'
            } : {}
        }), [
        isOpen,
        shouldCloseGracefully
    ]);
};

});
parcelRegister("dtuFp", function(module, exports) {

$parcel$export(module.exports, "ANIMATION_DURATION_MS", () => $8d584a82c91c9104$export$381bd857552f2380);
$parcel$export(module.exports, "OFFSET", () => $8d584a82c91c9104$export$3231e969238304f3);
$parcel$export(module.exports, "HEIGHT_ANIMATION_DURATION_SECONDS", () => $8d584a82c91c9104$export$697d389d05b85445);
$parcel$export(module.exports, "VISIBILITY_ANIMATION_DURATION_SECONDS", () => $8d584a82c91c9104$export$3ad3b33c1276dee);
const $8d584a82c91c9104$export$381bd857552f2380 = 100;
const $8d584a82c91c9104$export$3231e969238304f3 = 10;
const $8d584a82c91c9104$export$697d389d05b85445 = $8d584a82c91c9104$export$381bd857552f2380 / 1000;
const $8d584a82c91c9104$export$3ad3b33c1276dee = ($8d584a82c91c9104$export$381bd857552f2380 - $8d584a82c91c9104$export$3231e969238304f3) / 1000;

});


const $8a4555d9b638dd4e$export$8590613bf6f86e6a = 'software-bulk-actions-toolbar.wrapper';
const $8a4555d9b638dd4e$export$c6546257491ca185 = 32;
const $8a4555d9b638dd4e$export$e2842b8fe51e8a19 = 17;

parcelRegister("2iD6C", function(module, exports) {

$parcel$export(module.exports, "BulkActionsBarWrapper", () => $0b30192102cc6027$export$5faed9c94d4db8d1);
$parcel$export(module.exports, "StaticContainer", () => $0b30192102cc6027$export$bc786390a2506ac7);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $0b30192102cc6027$export$5faed9c94d4db8d1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19bvl52n _n3tdutpp _ca0q1b66 _bfhkvuon _4t3izwfg _3um0n7od _1pby1nn1 _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $0b30192102cc6027$export$bc786390a2506ac7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isOverlaid: isOverlaid, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _154iidpf _1ul9cs0k _1bsb1osq _1pby1nn1 _4t3i1c5z",
            __cmplp.isOverlaid ? "_16qs7bxk" : "_16qsglyw",
            __cmplp.className
        ])
    });
});

});


parcelRegister("hwYJL", function(module, exports) {

$parcel$export(module.exports, "useBulkActionsBarOverlay", () => $9d164d3d236214d2$export$bda6f8ee2db20273);

var $eUqFw = parcelRequire("eUqFw");

var $a576Y = parcelRequire("a576Y");

var $iX87Q = parcelRequire("iX87Q");

var $ggLLZ = parcelRequire("ggLLZ");

const $9d164d3d236214d2$var$OFFSET = (parseInt((0, $iX87Q.default)('space.150', '12px'), 10) || 12) + (0, $8a4555d9b638dd4e$export$c6546257491ca185);
const $9d164d3d236214d2$export$bda6f8ee2db20273 = (ref)=>{
    const [{ isOpen: isOpen }, { setIsOverlaid: setIsOverlaid, setShouldCloseGracefully: setShouldCloseGracefully }] = (0, $ggLLZ.useBulkActionsBar)();
    const handleScroll = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))(()=>{
            if (ref.current) {
                const currentScrollPosition = ref.current.scrollTop;
                const isOverlaid = currentScrollPosition > 0;
                const shouldCloseGracefully = currentScrollPosition < $9d164d3d236214d2$var$OFFSET;
                setIsOverlaid(isOverlaid);
                setShouldCloseGracefully(shouldCloseGracefully);
            }
        }, 100), [
        ref,
        setIsOverlaid,
        setShouldCloseGracefully
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const currentRef = ref.current;
        if (currentRef) {
            if (isOpen) currentRef.addEventListener('scroll', handleScroll);
            else currentRef.removeEventListener('scroll', handleScroll);
        }
        return ()=>{
            if (currentRef) currentRef.removeEventListener('scroll', handleScroll);
        };
    }, [
        handleScroll,
        isOpen,
        ref,
        setIsOverlaid,
        setShouldCloseGracefully
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        const currentRef = ref.current;
        if (currentRef) {
            const currentScrollPosition = currentRef.scrollTop;
            if (currentScrollPosition === 0) {
                if (isOpen) {
                    currentRef.scrollTop = currentScrollPosition + $9d164d3d236214d2$var$OFFSET;
                    setIsOverlaid(true);
                } else currentRef.scrollTop = currentScrollPosition - $9d164d3d236214d2$var$OFFSET;
            }
        }
    }, [
        isOpen,
        ref,
        setIsOverlaid
    ]);
};

});

parcelRegister("ivyj7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7657504e6be3f63$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2Fdhj = parcelRequire("2Fdhj");

var $1gQ73 = parcelRequire("1gQ73");

var $bP7Jx = parcelRequire("bP7Jx");
const $d7657504e6be3f63$export$48dddccb48daa6d7 = ()=>{
    // track card lists being expanded and collapsed
    const collapsedCardLists = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getCollapsedCardLists));
    // track sprint containers being created and deleted
    const cardListCount = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getCardListCount));
    // track sprint containers moving up and down from ... menu
    const cardListOrder = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getOrderedCardListIds));
    // track cards moving up and down by draggable divider
    const cardOrder = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getOrderedCardIdsByCardListId));
    (0, $eUqFw.useLayoutEffect)(()=>{
        (0, $2Fdhj.runRecalculateSubscribers)();
    }, [
        collapsedCardLists,
        cardListCount,
        cardListOrder,
        cardOrder
    ]);
    return null;
};
var $d7657504e6be3f63$export$2e2bcd8739ae039 = $d7657504e6be3f63$export$48dddccb48daa6d7;

});
parcelRegister("2Fdhj", function(module, exports) {

$parcel$export(module.exports, "runRecalculateSubscribers", () => $2ad0acb29cba62df$export$c385874db128c328);
$parcel$export(module.exports, "useElementOffset", () => $2ad0acb29cba62df$export$35f58fcda6094144);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $dxIU5 = parcelRequire("dxIU5");

var $iqjbc = parcelRequire("iqjbc");

var $2U8YO = parcelRequire("2U8YO");
const $2ad0acb29cba62df$var$MINIMUM_OFFSET_DIFF = 0.05;
const $2ad0acb29cba62df$export$658605f405ffebd5 = new Set();
const $2ad0acb29cba62df$export$c385874db128c328 = ()=>{
    const recalculateSubscribersArr = Array.from($2ad0acb29cba62df$export$658605f405ffebd5);
    const changes = recalculateSubscribersArr.map((subscriber)=>({
            newOffsetTop: subscriber.measureOffsetTop(),
            subscriber: subscriber
        })).filter(({ subscriber: subscriber, newOffsetTop: newOffsetTop })=>Math.abs((subscriber.offsetTopRef.current ?? 0) - newOffsetTop) > $2ad0acb29cba62df$var$MINIMUM_OFFSET_DIFF);
    if (!changes.length) return 0;
    (0, $lEfVV.unstable_batchedUpdates)(()=>{
        changes.forEach(({ subscriber: subscriber, newOffsetTop: newOffsetTop })=>{
            subscriber.onChange(newOffsetTop);
        });
    });
    return changes.length;
};
// Debounced version of the call used because during DND, the ResizeObserver can
// crash due to being triggered too much
const $2ad0acb29cba62df$var$debouncedRunRecalculateSubscribers = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))($2ad0acb29cba62df$export$c385874db128c328, 50);
let $2ad0acb29cba62df$var$resizeObserver = null;
if (typeof ResizeObserver !== 'undefined') $2ad0acb29cba62df$var$resizeObserver = new ResizeObserver($2ad0acb29cba62df$var$debouncedRunRecalculateSubscribers);
let $2ad0acb29cba62df$var$intersectionObserver = null;
if (typeof IntersectionObserver !== 'undefined') $2ad0acb29cba62df$var$intersectionObserver = new IntersectionObserver($2ad0acb29cba62df$export$c385874db128c328, {
    // Will fire every 1/5000 size visibility change.
    // A list with more than 5000 rows will fail to detect single row
    // changes.
    // A list with 5000 rows will only detect 1 row shifts at a time.
    threshold: (0, (/*@__PURE__*/$parcel$interopDefault($iqjbc)))(5000).map((i, _, arr)=>i / arr.length)
});
function $2ad0acb29cba62df$export$99c4e73123d23bda({ initialOffset: initialOffset, ref: ref }) {
    const [offsetTop, setOffsetTop] = (0, $eUqFw.useState)(initialOffset);
    const previousOffsetTopRef = (0, $eUqFw.useRef)(initialOffset);
    const { scrollElement: scrollElement } = (0, $2U8YO.useScrollState)();
    (0, $eUqFw.useEffect)(()=>{
        const el = ref.current;
        if (!el) throw new Error('Invariant failed, observed element is null on mount');
        const onChange = (size)=>{
            setOffsetTop(size);
            previousOffsetTopRef.current = size;
        };
        const measureOffsetTop = ()=>{
            if (!el || !scrollElement) return previousOffsetTopRef.current;
            // scrollElement defaults to Window.
            // This default value is normally only seen in Storybook.
            if (scrollElement instanceof Window || // FIXME JIV-14148 - unclear behavior in Storybook mount strict - Window is not Window
            !scrollElement.getBoundingClientRect) return 0;
            return el.getBoundingClientRect().top - scrollElement.getBoundingClientRect().top + scrollElement.scrollTop;
        };
        onChange(measureOffsetTop());
        const recalculateGroup = {
            measureOffsetTop: measureOffsetTop,
            onChange: onChange,
            offsetTop: previousOffsetTopRef.current,
            offsetTopRef: previousOffsetTopRef
        };
        $2ad0acb29cba62df$export$658605f405ffebd5.add(recalculateGroup);
        $2ad0acb29cba62df$var$resizeObserver?.observe(el);
        $2ad0acb29cba62df$var$intersectionObserver?.observe(el);
        const onResize = ()=>{
            $2ad0acb29cba62df$var$debouncedRunRecalculateSubscribers();
        };
        if ($2ad0acb29cba62df$export$658605f405ffebd5.size === 1) window.addEventListener('resize', onResize);
        return ()=>{
            $2ad0acb29cba62df$export$658605f405ffebd5.delete(recalculateGroup);
            $2ad0acb29cba62df$var$resizeObserver?.unobserve(el);
            $2ad0acb29cba62df$var$intersectionObserver?.unobserve(el);
            if ($2ad0acb29cba62df$export$658605f405ffebd5.size === 0) window.removeEventListener('resize', onResize);
            // Fire once when we clean this up since when we unmount an element we also
            // want to trigger the callback (e.g. removing a column or cardlist)
            $2ad0acb29cba62df$var$debouncedRunRecalculateSubscribers();
        };
    }, [
        ref,
        scrollElement
    ]);
    return offsetTop;
}
function $2ad0acb29cba62df$export$35f58fcda6094144({ initialOffset: initialOffset }) {
    const ref = (0, $eUqFw.useRef)(null);
    const offsetTop = $2ad0acb29cba62df$export$99c4e73123d23bda({
        initialOffset: initialOffset,
        ref: ref
    });
    return {
        ref: ref,
        offsetTop: offsetTop
    };
}

});
parcelRegister("iqjbc", function(module, exports) {

var $doiuZ = parcelRequire("doiuZ");
/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $d699885de2b5454c$var$range = $doiuZ();
module.exports = $d699885de2b5454c$var$range;

});
parcelRegister("doiuZ", function(module, exports) {

var $iVCWR = parcelRequire("iVCWR");

var $3P7i5 = parcelRequire("3P7i5");

var $d0d5X = parcelRequire("d0d5X");
/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $9bfbddb9d5847b3e$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && $3P7i5(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $d0d5X(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $d0d5X(end);
        step = step === undefined ? start < end ? 1 : -1 : $d0d5X(step);
        return $iVCWR(start, end, step, fromRight);
    };
}
module.exports = $9bfbddb9d5847b3e$var$createRange;

});
parcelRegister("iVCWR", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $dc7bc3319622b4d0$var$nativeCeil = Math.ceil, $dc7bc3319622b4d0$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $dc7bc3319622b4d0$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $dc7bc3319622b4d0$var$nativeMax($dc7bc3319622b4d0$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
module.exports = $dc7bc3319622b4d0$var$baseRange;

});





parcelRegister("8qqvv", function(module, exports) {

$parcel$export(module.exports, "DetailViewPanelWithErrorBoundary", () => $a301f2bb4c8a17b4$export$8dcd12fa4f8f9bff);

var $eUqFw = parcelRequire("eUqFw");

var $7GXrf = parcelRequire("7GXrf");

var $0cdA8 = parcelRequire("0cdA8");

var $hfC0x = parcelRequire("hfC0x");

var $8wXFi = parcelRequire("8wXFi");

var $8wl1S = parcelRequire("8wl1S");

var $i0G2M = parcelRequire("i0G2M");

var $fbsNl = parcelRequire("fbsNl");
const $a301f2bb4c8a17b4$export$eec5a61ba1791f2b = ({ boardId: boardId, parentWidth: parentWidth, isDetailViewVisible: isDetailViewVisible })=>{
    const isInsightsPanelOpen = (0, $8wl1S.useIsInsightsPanelOpen)();
    const isViewSettingsPanelOpen = (0, $i0G2M.useIsViewSettingsPanelOpen)();
    const [epicFilters, { setEpicFilters: setEpicFilters }] = (0, $hfC0x.useEpicFilters)();
    const onBentoDelete = (0, $eUqFw.useCallback)((issueId)=>{
        if (epicFilters && epicFilters.includes(issueId)) setEpicFilters((0, (/*@__PURE__*/$parcel$interopDefault($7GXrf)))(epicFilters, issueId));
    }, [
        epicFilters,
        setEpicFilters
    ]);
    return isDetailViewVisible || isInsightsPanelOpen || (0, $8wXFi.isViewSettingAsPanelExpEnabledWithNoExposure)() && isViewSettingsPanelOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fbsNl.default), {
        parentWidth: parentWidth,
        onDelete: onBentoDelete,
        boardId: boardId
    }) : null;
};
const $a301f2bb4c8a17b4$export$8dcd12fa4f8f9bff = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "backlogContentDetailView",
        packageName: "software-backlog",
        teamName: "a4t-tanuki",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a301f2bb4c8a17b4$export$eec5a61ba1791f2b, props));

});
parcelRegister("hfC0x", function(module, exports) {

$parcel$export(module.exports, "FiltersStore", () => $072473019dfa0ed5$export$83881a29077d5ffe);
$parcel$export(module.exports, "useFilters", () => $072473019dfa0ed5$export$973ca22476b0e05f);
$parcel$export(module.exports, "useEpicFilters", () => $072473019dfa0ed5$export$d840a10da638967b);
$parcel$export(module.exports, "useFixVersionFilters", () => $072473019dfa0ed5$export$55f8e6f74a492d36);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");


var $k9Yj3 = parcelRequire("k9Yj3");

var $kvmWb = parcelRequire("kvmWb");
var $fHmR5 = parcelRequire("fHmR5");
var $7AswH = parcelRequire("7AswH");
const $072473019dfa0ed5$var$initialState = {
    filters: {}
};
const $072473019dfa0ed5$export$83881a29077d5ffe = (0, $a61MH.createStore)({
    name: (0, $5e78e7e537a59c6f$export$37f04a6502d23030),
    initialState: $072473019dfa0ed5$var$initialState,
    actions: $k9Yj3.actions
});
const $072473019dfa0ed5$export$973ca22476b0e05f = (0, $ggKAj.createHook)($072473019dfa0ed5$export$83881a29077d5ffe, {
    selector: (0, $fHmR5.getFilters)
});
const $072473019dfa0ed5$export$d840a10da638967b = (0, $ggKAj.createHook)($072473019dfa0ed5$export$83881a29077d5ffe, {
    selector: (0, $kvmWb.getEpic)
});
const $072473019dfa0ed5$export$55f8e6f74a492d36 = (0, $ggKAj.createHook)($072473019dfa0ed5$export$83881a29077d5ffe, {
    selector: (0, $7AswH.getFixVersion)
});

});
const $5e78e7e537a59c6f$export$37f04a6502d23030 = 'next-gen/backlog-filters-state';
const $5e78e7e537a59c6f$export$d597759d33be802e = 'TEXT';
const $5e78e7e537a59c6f$export$a6b9aaee40d49fd0 = 'SEARCH';
const $5e78e7e537a59c6f$export$f8f7545d2bb78afb = 'ASSIGNEE';
const $5e78e7e537a59c6f$export$37aee82a3cb1e8f7 = 'LABEL';
const $5e78e7e537a59c6f$export$2a4f270075a033de = 'ISSUE_PARENT';
const $5e78e7e537a59c6f$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $5e78e7e537a59c6f$export$a4ad2735b021c132 = 'VERSION';
const $5e78e7e537a59c6f$export$68d693c35a8d8866 = 'CUSTOM_FILTER';
const $5e78e7e537a59c6f$export$e39925d10cebc0b = 'text';
const $5e78e7e537a59c6f$export$a181206198b7f50c = 'search';
const $5e78e7e537a59c6f$export$f78d8c81fcad32a2 = 'assignee';
const $5e78e7e537a59c6f$export$e729d951ab128c3b = 'label';
const $5e78e7e537a59c6f$export$8a2cab795731dc42 = 'issueParent';
const $5e78e7e537a59c6f$export$fa7b72626a2e0090 = 'issueType';
const $5e78e7e537a59c6f$export$392308739e657b75 = 'version';
const $5e78e7e537a59c6f$export$cb08ebea4a46cd29 = 'customFilter';
const $5e78e7e537a59c6f$export$163cc317352fc53e = 'quickFilter';

parcelRegister("k9Yj3", function(module, exports) {

$parcel$export(module.exports, "actions", () => $852cc258922bbe3d$export$e324594224ef24da);

var $30cWa = parcelRequire("30cWa");

var $3ovLR = parcelRequire("3ovLR");

var $aPsRt = parcelRequire("aPsRt");
const $852cc258922bbe3d$export$e324594224ef24da = {
    setFilters: $3ovLR.setFilters,
    setEpicFilters: $30cWa.setEpicFilters,
    setVersionFilters: $aPsRt.setVersionFilters
};

});
parcelRegister("30cWa", function(module, exports) {

$parcel$export(module.exports, "setEpicFilters", () => $ee91749db11f8e21$export$e24537ba01fbbff1);


var $2tmn8 = parcelRequire("2tmn8");
const $ee91749db11f8e21$export$e24537ba01fbbff1 = (0, $2tmn8.setFilter)((0, $5e78e7e537a59c6f$export$2a4f270075a033de));

});
parcelRegister("2tmn8", function(module, exports) {

$parcel$export(module.exports, "setFilter", () => $5ae699be21bef495$export$939370273cf4a757);

var $8blac = parcelRequire("8blac");

var $3ovLR = parcelRequire("3ovLR");
const $5ae699be21bef495$export$939370273cf4a757 = (filterKey)=>(newFilterValue)=>({ getState: getState, dispatch: dispatch })=>{
            const state = getState();
            const filters = {
                ...state.filters
            };
            if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(newFilterValue)) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ TEXT?: string | undefined; ASSIGNEE?: string[] | undefined; LABEL?: string[] | undefined; ISSUE_PARENT?: string[] | undefined; ISSUE_TYPE?: string[] | undefined; VERSION?: string[] | undefined; CUSTOM_FILTER?: string[] | undefined; }'.
            delete filters[filterKey];
            else // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ TEXT?: string | undefined; ASSIGNEE?: string[] | undefined; LABEL?: string[] | undefined; ISSUE_PARENT?: string[] | undefined; ISSUE_TYPE?: string[] | undefined; VERSION?: string[] | undefined; CUSTOM_FILTER?: string[] | undefined; }'.
            filters[filterKey] = newFilterValue;
            dispatch((0, $3ovLR.setFilters)(filters));
        };

});
parcelRegister("3ovLR", function(module, exports) {

$parcel$export(module.exports, "setFilters", () => $b20947d6963268c9$export$90e9b0558f0311af);

var $hTLlD = parcelRequire("hTLlD");
const $b20947d6963268c9$export$90e9b0558f0311af = (filters)=>({ getState: getState, setState: setState }, { onFiltersChange: onFiltersChange })=>{
        const state = getState();
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(state, filters)) {
            setState({
                filters: filters
            });
            onFiltersChange && onFiltersChange(filters);
        }
    };

});



parcelRegister("aPsRt", function(module, exports) {

$parcel$export(module.exports, "setVersionFilters", () => $eb0fe58b3d5de1aa$export$2dd46fe22cb52ed5);


var $2tmn8 = parcelRequire("2tmn8");
const $eb0fe58b3d5de1aa$export$2dd46fe22cb52ed5 = (0, $2tmn8.setFilter)((0, $5e78e7e537a59c6f$export$a4ad2735b021c132));

});


parcelRegister("kvmWb", function(module, exports) {

$parcel$export(module.exports, "getEpic", () => $7fe9f50ec5bc3135$export$73171e65af38eb92);
const $7fe9f50ec5bc3135$export$73171e65af38eb92 = (state)=>state.filters ? state.filters.ISSUE_PARENT : null;

});

parcelRegister("fHmR5", function(module, exports) {

$parcel$export(module.exports, "getFilters", () => $119067318754e485$export$1933a9fe712fc1fd);
const $119067318754e485$export$1933a9fe712fc1fd = (state)=>state.filters;

});

parcelRegister("7AswH", function(module, exports) {

$parcel$export(module.exports, "getFixVersion", () => $b9fa69b9f7dffc2f$export$f234b291359ecd8b);
const $b9fa69b9f7dffc2f$export$f234b291359ecd8b = (state)=>state.filters ? state.filters.VERSION : null;

});


parcelRegister("8wl1S", function(module, exports) {

$parcel$export(module.exports, "useIsInsightsPanelOpen", () => $4acef5d3ce0e5065$export$b1fef7718462a5cf);

var $1gQ73 = parcelRequire("1gQ73");

var $cYLrD = parcelRequire("cYLrD");

var $dtV8v = parcelRequire("dtV8v");
const $4acef5d3ce0e5065$export$b1fef7718462a5cf = ()=>{
    const isInsightsPanelVisible = (0, $1gQ73.useBacklogSelector)((0, $cYLrD.getInsightsPanel));
    const hasSprints = (0, $1gQ73.useBacklogSelector)((0, $dtV8v.isBacklogWithSprints));
    return hasSprints && isInsightsPanelVisible;
};

});

parcelRegister("i0G2M", function(module, exports) {

$parcel$export(module.exports, "useIsViewSettingsPanelOpen", () => $232f7519f0a01534$export$b9d31f582c2f1d3f);

var $1gQ73 = parcelRequire("1gQ73");

var $cYLrD = parcelRequire("cYLrD");
const $232f7519f0a01534$export$b9d31f582c2f1d3f = ()=>{
    const isViewSettingsPanelVisible = (0, $1gQ73.useBacklogSelector)((0, $cYLrD.getViewSettingsPanel));
    return isViewSettingsPanelVisible;
};

});

parcelRegister("fbsNl", function(module, exports) {

$parcel$export(module.exports, "default", () => $28cb74ce03a43983$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $3l6tm = parcelRequire("3l6tm");

var $fE3Ua = parcelRequire("fE3Ua");


var $lNNXV = parcelRequire("lNNXV");

var $lA3UV = parcelRequire("lA3UV");

var $9UqqQ = parcelRequire("9UqqQ");

var $1gQ73 = parcelRequire("1gQ73");

var $c4hFt = parcelRequire("c4hFt");

var $64fZ9 = parcelRequire("64fZ9");

var $K2SiM = parcelRequire("K2SiM");

var $8R4bf = parcelRequire("8R4bf");

var $a9os4 = parcelRequire("a9os4");

var $75nYE = parcelRequire("75nYE");

var $6iBIZ = parcelRequire("6iBIZ");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $dtV8v = parcelRequire("dtV8v");

var $8CMGK = parcelRequire("8CMGK");

var $eBXAX = parcelRequire("eBXAX");
const $28cb74ce03a43983$var$mapStateToProps = (state)=>{
    const { cardId: cardId, timestamp: timestamp, externalAction: externalAction } = (0, $bP7Jx.getDetailViewData)(state) || {};
    const getIssueKey = (0, $bP7Jx.getKeyByIdForAllIssueTypes)(state);
    const cardKey = getIssueKey(cardId);
    const storyPointFieldId = (0, $hkGxG.getStoryPointFieldId)(state);
    const isEpic = cardId ? (0, $bP7Jx.makeGetCardTypeHierarchyLevel)(state)(cardId) === (0, $3l6tm.PARENT_HIERARCHY_TYPE) : false;
    return {
        cardKey: cardKey,
        cardId: // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'number'.
        cardId,
        isEpic: isEpic,
        externalAction: externalAction,
        timestamp: // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'number'.
        timestamp,
        rapidViewId: (0, $hkGxG.getRapidViewId)(state),
        isBacklogWithSprints: (0, $dtV8v.isBacklogWithSprints)(state),
        backlogSessionId: (0, $hkGxG.getSessionId)(state),
        storyPointFieldId: storyPointFieldId
    };
};
const $28cb74ce03a43983$var$mapDispatchToProps = {
    onTogglePanel: (0, $a9os4.togglePanel),
    onCloseInsightsPanel: ()=>(0, $a9os4.closeInsightsPanel)(),
    onCloseViewSettingsPanel: ()=>(0, $a9os4.closeViewSettingsPanel)(),
    onDelete: (0, $c4hFt.cardDelete),
    onIssueViewUpdate: (0, $8R4bf.issueViewUpdate),
    onCardRefreshRequest: (0, $64fZ9.cardRefreshRequest),
    onCardStatusCheck: (0, $75nYE.cardStatusCheck)
};
const $28cb74ce03a43983$var$onCloseFactory = (0, $5iWql.default)((cardId, onCloseWithIssueId)=>()=>onCloseWithIssueId(cardId));
const $28cb74ce03a43983$var$onChangeFactory = (0, $5iWql.default)((storyPointFieldId, onRefetchVersions, isEpic, onUpdateEpicSummary, rapidViewId, onCardStatusCheck, onIssueViewUpdate, onCardRefreshRequest)=>(event)=>{
        // NOTE: Updates for version panel are handled separately (owned by Fusion team: src/packages/software/version-backlog-panel/package.json)
        if (event.type === (0, $fE3Ua.ChangeEventTypes).FIELD_CHANGED) {
            // Cannot remove StatusKey here as the fixed versions panel uses it
            // see https://stash.atlassian.com/projects/JIRACLOUD/repos/jira-frontend/pull-requests/32152/overview?commentId=2346562
            const versionsRefetchEventTypes = [
                (0, $ebc098a76317be78$export$4420b7468f889692),
                (0, $ebc098a76317be78$export$a68dbc90211df1a8),
                (0, $ebc098a76317be78$export$5fbd3b15555b9ef2),
                storyPointFieldId || ''
            ];
            if (versionsRefetchEventTypes.includes(event.fieldId)) onRefetchVersions();
            if (event.meta.fieldId === 'summary') {
                const { issueId: issueId } = event;
                if (isEpic) onUpdateEpicSummary(Number(rapidViewId), issueId, event.meta.fieldValue);
            }
            // with Unmapped status feature, an issue can be moved back to backlog, if status is updated to mapped status
            // In that case backlog need to refresh the data so that issue can reappear on backlog.
            if (event.meta.fieldId === (0, $ebc098a76317be78$export$4420b7468f889692)) onCardStatusCheck(event);
        }
        // NOTE: Updates for extracted fields are managed by Sweet State and handled by field sync (src/packages/software/backlog/src/view/all-fields-sync/field-sync)
        const extractedFields = (0, $lA3UV.getExtractedFields)({
            storyPointFieldId: storyPointFieldId
        });
        if ((event.type === (0, $fE3Ua.ChangeEventTypes).FIELD_CHANGE_REQUESTED || event.type === (0, $fE3Ua.ChangeEventTypes).FIELD_CHANGED || event.type === (0, $fE3Ua.ChangeEventTypes).FIELD_CHANGE_FAILED) && extractedFields.includes(event.meta.fieldId) || event.type === (0, $fE3Ua.ChangeEventTypes).ISSUE_RELATIONSHIP_UPDATED) return;
        // Handles updates for epics or subtasks by updating only relevant parts of the Redux store (non-trivial for Backlog card UI but impact the issue hierarchy relationship)
        onIssueViewUpdate(event);
        const refreshIssueId = event.type === (0, $fE3Ua.ChangeEventTypes).CHILD_ISSUE_ADDED ? Number(event.meta.childIssue.id) : Number(event.issueId);
        // Handles updates for base-level issues by refetching the card (impact Backlog card UI directly)
        onCardRefreshRequest(refreshIssueId, event);
    });
const $28cb74ce03a43983$var$onDeleteFactory = (0, $5iWql.default)((ownPropsOnDelete, onDelete, cardId, onCardRefreshRequest)=>({ issueId: issueId })=>{
        if (ownPropsOnDelete) ownPropsOnDelete(issueId);
        onDelete(Number(issueId));
        if (issueId && Number(issueId) !== cardId) onCardRefreshRequest();
    });
const $28cb74ce03a43983$export$9d1611c77c2fe928 = ({ rapidViewId: rapidViewId, backlogSessionId: backlogSessionId, storyPointFieldId: storyPointFieldId, cardId: cardId, cardKey: cardKey, isEpic: isEpic, timestamp: timestamp, isBacklogWithSprints: isBacklogWithSprints, externalAction: externalAction }, { onCloseInsightsPanel: onCloseInsightsPanel, onCloseViewSettingsPanel: onCloseViewSettingsPanel, onDelete: onDelete, onIssueViewUpdate: onIssueViewUpdate, onCardRefreshRequest: onCardRefreshRequest, onCardStatusCheck: onCardStatusCheck }, { parentWidth: parentWidth, onDelete: ownPropsOnDelete, onRefetchVersions: onRefetchVersions, onUpdateEpicSummary: onUpdateEpicSummary, onCloseWithIssueId: onCloseWithIssueId })=>({
        parentWidth: parentWidth,
        cardKey: cardKey,
        timestamp: timestamp,
        rapidViewId: rapidViewId,
        isBacklogWithSprints: isBacklogWithSprints,
        externalAction: externalAction,
        backlogSessionId: backlogSessionId,
        // extra method to avoid arguments in action creator
        onClose: $28cb74ce03a43983$var$onCloseFactory(cardId, onCloseWithIssueId),
        onCloseInsightsClick: onCloseInsightsPanel,
        onCloseViewSettingsPanelClick: onCloseViewSettingsPanel,
        onChange: $28cb74ce03a43983$var$onChangeFactory(storyPointFieldId, onRefetchVersions, isEpic, onUpdateEpicSummary, rapidViewId, onCardStatusCheck, onIssueViewUpdate, onCardRefreshRequest),
        onDelete: $28cb74ce03a43983$var$onDeleteFactory(ownPropsOnDelete, onDelete, cardId, onCardRefreshRequest),
        IssueWrapper: (0, $8CMGK.default)
    });
const $28cb74ce03a43983$export$812e801c43ce71e3 = (0, $lNNXV.connect)($28cb74ce03a43983$var$mapStateToProps, $28cb74ce03a43983$var$mapDispatchToProps, $28cb74ce03a43983$export$9d1611c77c2fe928)((0, $eBXAX.default));
const $28cb74ce03a43983$export$335ea2193bcd128b = ({ boardId: boardId, ...props })=>{
    const { updateEpicSummary: updateEpicSummary } = (0, $9UqqQ.useUpdateEpicSummary)();
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const refetch = (0, $eUqFw.useCallback)(()=>{
        dispatch((0, $6iBIZ.refetchVersions)());
    }, [
        dispatch
    ]);
    const onCloseWithIssueId = (0, $eUqFw.useCallback)((cardId)=>{
        dispatch((0, $K2SiM.closeDetailView)(cardId));
        return (0, $K2SiM.closeDetailView)(cardId);
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($28cb74ce03a43983$export$812e801c43ce71e3, {
        ...props,
        onRefetchVersions: refetch,
        onUpdateEpicSummary: updateEpicSummary,
        onCloseWithIssueId: onCloseWithIssueId
    });
};
var $28cb74ce03a43983$export$2e2bcd8739ae039 = $28cb74ce03a43983$export$335ea2193bcd128b;

});
parcelRegister("9UqqQ", function(module, exports) {

$parcel$export(module.exports, "useUpdateEpicSummary", () => $e55bd7838d09157a$export$1fa1c6b4dbf736ff);

var $iZuDo = parcelRequire("iZuDo");

var $9ypom = parcelRequire("9ypom");

var $lWcOi = parcelRequire("lWcOi");

var $eI5EY = parcelRequire("eI5EY");

var $4WA4h = parcelRequire("4WA4h");

var $j258X = parcelRequire("j258X");
const $e55bd7838d09157a$export$cb085029733a197f = (0, $9ypom.default)`
    ${(0, $4WA4h.epicFragment)}
    query BacklogEpicsCache($boardId: ID!, $isCompanyManaged: Boolean!) {
        boardScope(boardId: $boardId, isCMP: $isCompanyManaged) {
            issueParents {
                ...EpicPanelIssueParentFragment
            }
        }
    }
`;
const $e55bd7838d09157a$export$1fa1c6b4dbf736ff = ()=>{
    const apolloClient = (0, $iZuDo.useApolloClient)();
    const isCompanyManaged = (0, $j258X.useIsCMPBacklog)();
    const [, { updateEpicAttributes: updateEpicAttributes }] = (0, $lWcOi.useEpicsStoreActions)();
    const updateEpicSummary = (boardId, issueId, summary)=>{
        if ((0, $eI5EY.fg)('jsw_epic_panel_paginated_fetch')) {
            updateEpicAttributes(issueId, {
                name: summary
            });
            return;
        }
        const board = apolloClient.readQuery({
            query: $e55bd7838d09157a$export$cb085029733a197f,
            variables: {
                boardId: boardId,
                isCompanyManaged: isCompanyManaged
            }
        });
        if (board?.boardScope?.issueParents) {
            const issueParents = board.boardScope.issueParents.map((epic)=>{
                if (epic.id === issueId) return {
                    ...epic,
                    summary: summary
                };
                return epic;
            });
            apolloClient.writeQuery({
                query: $e55bd7838d09157a$export$cb085029733a197f,
                variables: {
                    boardId: boardId,
                    isCompanyManaged: isCompanyManaged
                },
                data: {
                    boardScope: {
                        ...board.boardScope,
                        issueParents: [
                            ...issueParents
                        ]
                    }
                }
            });
        }
    };
    return {
        updateEpicSummary: updateEpicSummary
    };
};

});
parcelRegister("lWcOi", function(module, exports) {

$parcel$export(module.exports, "useEpicsStoreActions", () => $c2c3d73b211fd78c$export$cc607320af4fa537);
$parcel$export(module.exports, "useEpicsStoreIsInitialised", () => $c2c3d73b211fd78c$export$9ddd8d2fb828030f);
$parcel$export(module.exports, "useColumnCounts", () => $c2c3d73b211fd78c$export$a1adfbf5b4219803);
$parcel$export(module.exports, "useEpicIssueType", () => $c2c3d73b211fd78c$export$acd1723f083afb7c);
$parcel$export(module.exports, "useEpicIssueTypeName", () => $c2c3d73b211fd78c$export$1392ad62b696a2fd);
$parcel$export(module.exports, "useTimeTrackingOptions", () => $c2c3d73b211fd78c$export$cfd3a8034358ba8f);
$parcel$export(module.exports, "useIsRankingEnabled", () => $c2c3d73b211fd78c$export$f2905104781f6877);
$parcel$export(module.exports, "useEpicCardsState", () => $c2c3d73b211fd78c$export$a1a694f17da9b27c);
$parcel$export(module.exports, "useEpicsFilterData", () => $c2c3d73b211fd78c$export$9162a71a3e0d59c1);

var $ggKAj = parcelRequire("ggKAj");

var $cmtHp = parcelRequire("cmtHp");
const $c2c3d73b211fd78c$export$cc607320af4fa537 = (0, $ggKAj.createHook)((0, $cmtHp.EpicsStore), {
    selector: null
});
const $c2c3d73b211fd78c$var$getEpicsStoreIsInitialised = (state)=>state.isInitialised;
const $c2c3d73b211fd78c$export$9ddd8d2fb828030f = (0, $ggKAj.createHook)((0, $cmtHp.EpicsStore), {
    selector: $c2c3d73b211fd78c$var$getEpicsStoreIsInitialised
});
const $c2c3d73b211fd78c$export$7511c66023e8a822 = (state)=>state.columnCounts;
const $c2c3d73b211fd78c$export$a1adfbf5b4219803 = (0, $ggKAj.createHook)((0, $cmtHp.EpicsStore), {
    selector: $c2c3d73b211fd78c$export$7511c66023e8a822
});
const $c2c3d73b211fd78c$export$c58dde3f1e86a4e4 = (state)=>state.epicIssueType;
const $c2c3d73b211fd78c$export$acd1723f083afb7c = (0, $ggKAj.createHook)((0, $cmtHp.EpicsStore), {
    selector: $c2c3d73b211fd78c$export$c58dde3f1e86a4e4
});
const $c2c3d73b211fd78c$export$d30c1ce996fed20b = (state)=>state.epicIssueTypeName;
const $c2c3d73b211fd78c$export$1392ad62b696a2fd = (0, $ggKAj.createHook)((0, $cmtHp.EpicsStore), {
    selector: $c2c3d73b211fd78c$export$d30c1ce996fed20b
});
const $c2c3d73b211fd78c$export$cb06173d4516a1bf = (state)=>state.timeTrackingOptions;
const $c2c3d73b211fd78c$export$cfd3a8034358ba8f = (0, $ggKAj.createHook)((0, $cmtHp.EpicsStore), {
    selector: $c2c3d73b211fd78c$export$cb06173d4516a1bf
});
const $c2c3d73b211fd78c$export$c8d7f1b90bd94368 = (state)=>state.isRankingEnabled;
const $c2c3d73b211fd78c$export$f2905104781f6877 = (0, $ggKAj.createHook)((0, $cmtHp.EpicsStore), {
    selector: $c2c3d73b211fd78c$export$c8d7f1b90bd94368
});
const $c2c3d73b211fd78c$export$f138f9cd4309615d = (state)=>({
        cards: state.cards,
        loading: state.loading,
        error: state.error,
        refetchError: state.refetchError
    });
const $c2c3d73b211fd78c$export$a1a694f17da9b27c = (0, $ggKAj.createHook)((0, $cmtHp.EpicsStore), {
    selector: $c2c3d73b211fd78c$export$f138f9cd4309615d
});
const $c2c3d73b211fd78c$export$cb007e11c4f92b94 = (state)=>({
        cards: state.cards,
        epicIssueTypeName: state.epicIssueTypeName,
        isEpicIssueTypeAvailable: state.isEpicIssueTypeAvailable
    });
const $c2c3d73b211fd78c$export$9162a71a3e0d59c1 = (0, $ggKAj.createHook)((0, $cmtHp.EpicsStore), {
    selector: $c2c3d73b211fd78c$export$cb007e11c4f92b94
});
const $c2c3d73b211fd78c$export$b2da883a667e9881 = (state)=>state.isEpicIssueTypeAvailable;
const $c2c3d73b211fd78c$export$9f53fc27477100a8 = (0, $ggKAj.createHook)((0, $cmtHp.EpicsStore), {
    selector: $c2c3d73b211fd78c$export$b2da883a667e9881
});

});
parcelRegister("cmtHp", function(module, exports) {

$parcel$export(module.exports, "EpicsStore", () => $00663bc1396744ab$export$718386d323810d5b);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $PcCYF = parcelRequire("PcCYF");

var $16ROK = parcelRequire("16ROK");
const $00663bc1396744ab$export$718386d323810d5b = (0, $a61MH.createStore)({
    name: 'EpicsStore',
    initialState: (0, $16ROK.INITIAL_STATE),
    actions: $PcCYF.actions
});
const $00663bc1396744ab$export$2eb948e5227270ad = (0, $ggKAj.createHook)($00663bc1396744ab$export$718386d323810d5b);
const $00663bc1396744ab$export$e7d232b78090ef52 = (0, $heB5U.createContainer)($00663bc1396744ab$export$718386d323810d5b, {
    onInit: (0, $PcCYF.actions).initContainer
});

});
parcelRegister("PcCYF", function(module, exports) {

$parcel$export(module.exports, "actions", () => $0da62f448298db5e$export$e324594224ef24da);

var $lyOYo = parcelRequire("lyOYo");

var $16ROK = parcelRequire("16ROK");
const $0da62f448298db5e$export$57d319145ef8fcba = ()=>({ setState: setState }, initProps)=>{
        setState({
            ...initProps,
            isInitialised: true
        });
    };
const $0da62f448298db5e$export$f6196a6c6bb539b4 = (initProps)=>({ setState: setState })=>{
        setState({
            ...initProps,
            isInitialised: true
        });
    };
const $0da62f448298db5e$export$8e84bad0b35de9e8 = ()=>({ setState: setState })=>{
        setState((0, $16ROK.INITIAL_STATE));
    };
const $0da62f448298db5e$export$de1bc8024bd89034 = (newQueryState = {})=>({ setState: setState })=>{
        setState({
            ...newQueryState
        });
    };
const $0da62f448298db5e$export$c27415602243c7a5 = (epics, optimisticIds = [])=>({ setState: setState, getState: getState })=>{
        // There is an implicit assumption that the optimisticIds match up 1-1 with the epics provided
        const { cards: cards } = getState();
        if (!optimisticIds.length) {
            setState({
                cards: [
                    ...cards,
                    ...epics
                ]
            });
            return;
        }
        const firstIndex = cards.findIndex(({ epic: { id: id } })=>optimisticIds[0] === id);
        const lastIndex = cards.findIndex(({ epic: { id: id } })=>optimisticIds[optimisticIds.length - 1] === id);
        setState({
            cards: [
                ...cards.slice(0, firstIndex),
                ...epics,
                ...cards.slice(lastIndex + 1)
            ]
        });
    };
const $0da62f448298db5e$export$843544102309bcdc = (epicIds, newPosition)=>({ setState: setState, getState: getState })=>{
        const { cards: existingCards } = getState();
        const cardsNotMoved = existingCards.filter(({ epic: { id: id } })=>!epicIds.includes(Number(id)));
        const cardsMoved = existingCards.filter(({ epic: { id: id } })=>epicIds.includes(Number(id)));
        setState({
            cards: [
                ...cardsNotMoved.slice(0, newPosition),
                ...cardsMoved,
                ...cardsNotMoved.slice(newPosition)
            ]
        });
    };
const $0da62f448298db5e$export$d122bcc694b92bff = ({ updatedCards: updatedCards, startIndex: startIndex = 0, hasNextPage: hasNextPage })=>({ setState: setState, getState: getState })=>{
        const { cards: cards } = getState();
        cards.splice(startIndex, hasNextPage ? updatedCards.length : cards.length - startIndex, ...updatedCards);
        setState({
            cards: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(cards, (card)=>card.epic.id)
        });
    };
const $0da62f448298db5e$export$71b128798a3cdc4b = (epicId, attributes)=>({ setState: setState, getState: getState })=>{
        const { cards: cards } = getState();
        const updatedCards = cards.map((card)=>{
            if (card.epic.id === Number(epicId)) return {
                ...card,
                epic: {
                    ...card.epic,
                    ...attributes
                }
            };
            return card;
        });
        setState({
            cards: updatedCards
        });
    };
const $0da62f448298db5e$export$3293922453e4d4c = (attributes, startIndex = 0)=>({ setState: setState, getState: getState })=>{
        const { cards: existingCards } = getState();
        const cards = existingCards.map((card, index)=>({
                ...card,
                epic: {
                    ...card.epic,
                    ...index >= startIndex && attributes
                }
            }));
        setState({
            cards: cards
        });
    };
const $0da62f448298db5e$export$e324594224ef24da = {
    initContainer: $0da62f448298db5e$export$57d319145ef8fcba,
    initState: $0da62f448298db5e$export$f6196a6c6bb539b4,
    resetState: $0da62f448298db5e$export$8e84bad0b35de9e8,
    updateQueryState: $0da62f448298db5e$export$de1bc8024bd89034,
    addEpics: $0da62f448298db5e$export$c27415602243c7a5,
    rankEpics: $0da62f448298db5e$export$843544102309bcdc,
    updateEpics: $0da62f448298db5e$export$d122bcc694b92bff,
    updateEpicAttributes: $0da62f448298db5e$export$71b128798a3cdc4b,
    updateEpicsAttributes: $0da62f448298db5e$export$3293922453e4d4c
};

});
parcelRegister("16ROK", function(module, exports) {

$parcel$export(module.exports, "INITIAL_STATE", () => $8e9f60c9b1bb6833$export$36d128238e6b60f5);
$parcel$export(module.exports, "STORY_POINTS", () => $8e9f60c9b1bb6833$export$405b6d72f2d243a9);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE", () => $8e9f60c9b1bb6833$export$bfb354504bb547a0);

var $4m36T = parcelRequire("4m36T");
const $8e9f60c9b1bb6833$export$36d128238e6b60f5 = {
    cards: [],
    columnCounts: {
        toDo: 0,
        inProgress: 0,
        done: 0
    },
    isEpicIssueTypeAvailable: false,
    epicIssueType: {
        id: 0,
        name: 'Epic',
        hasRequiredFields: false
    },
    epicIssueTypeName: 'Epic',
    timeTrackingOptions: (0, $4m36T.defaultTimeTrackingOptions),
    isRankingEnabled: false,
    isInitialised: false,
    loading: false
};
const $8e9f60c9b1bb6833$export$405b6d72f2d243a9 = 'STORY_POINTS';
const $8e9f60c9b1bb6833$export$bfb354504bb547a0 = 'ORIGINAL_ESTIMATE';
const $8e9f60c9b1bb6833$export$43cafe5ec3ffdbf5 = 'CUSTOM_NUMBER_FIELD';
const $8e9f60c9b1bb6833$export$8775696968c9b13c = 'ISSUE_COUNT';

});




parcelRegister("4WA4h", function(module, exports) {

$parcel$export(module.exports, "epicFragment", () => $260134d4e108ed85$export$cb2dabc00ff80765);
$parcel$export(module.exports, "estimationInfoFragment", () => $260134d4e108ed85$export$6ac7dc3c00d264bc);
$parcel$export(module.exports, "createEpicFragment", () => $260134d4e108ed85$export$c627d203a3aa0338);
$parcel$export(module.exports, "currentUserFragment", () => $260134d4e108ed85$export$b4896d53c7f4d9c4);
$parcel$export(module.exports, "boardLocationFragment", () => $260134d4e108ed85$export$1be26ac8ab064941);
$parcel$export(module.exports, "timeTrackingOptionsFragment", () => $260134d4e108ed85$export$ad6d7391facb841b);
$parcel$export(module.exports, "epicLiteFragment", () => $260134d4e108ed85$export$ee1de0b7a9498416);
$parcel$export(module.exports, "projectLocationFragment", () => $260134d4e108ed85$export$25c256efca3597d1);
$parcel$export(module.exports, "issueParentTypeConfigFragment", () => $260134d4e108ed85$export$9d88616d202f6817);
$parcel$export(module.exports, "columnFragment", () => $260134d4e108ed85$export$6fed28a6f51b8228);
$parcel$export(module.exports, "boardFragment", () => $260134d4e108ed85$export$e1c6fa95c54eabf5);

var $9ypom = parcelRequire("9ypom");
const $260134d4e108ed85$export$cb2dabc00ff80765 = (0, $9ypom.default)`
    fragment EpicPanelIssueParentFragment on IssueParent {
        id
        key
        summary
        color
        childrenInfo {
            todoStats {
                issueCount
            }
            inProgressStats {
                issueCount
            }
            doneStats {
                issueCount
            }
        }
        startDate
        dueDate
    }
`;
const $260134d4e108ed85$export$6ac7dc3c00d264bc = (0, $9ypom.default)`
    fragment EstimationInfoFragment on EstimationInfo {
        details {
            estimationType
            name
        }
        childrenEstimationStats {
            doneEstimate
            totalEstimate
            percentageCompleted
            notEstimated
        }
    }
`;
const $260134d4e108ed85$export$c627d203a3aa0338 = (0, $9ypom.default)`
    fragment CreateIssueParentFragment on IssueParent {
        id
        key
        summary
        color
        issueType {
            id
            name
            iconUrl
        }
        childrenInfo {
            todoStats {
                issueCount
            }
            inProgressStats {
                issueCount
            }
            doneStats {
                issueCount
            }
        }
        startDate
        dueDate
    }
`;
const $260134d4e108ed85$export$b4896d53c7f4d9c4 = (0, $9ypom.default)`
    fragment CurrentUserFragment on CurrentUser {
        permissions
    }
`;
const $260134d4e108ed85$export$1be26ac8ab064941 = (0, $9ypom.default)`
    fragment BoardLocationFragment on Project {
        id
        name
        key
    }
`;
const $260134d4e108ed85$export$ad6d7391facb841b = (0, $9ypom.default)`
    fragment TimeTrackingOptionsFragment on TimeTrackingOptions {
        workingHoursPerDay
        workingDaysPerWeek
        defaultUnit
        timeFormat
    }
`;
const $260134d4e108ed85$export$ee1de0b7a9498416 = (0, $9ypom.default)`
    fragment EpicPanelIssueParentLiteFragment on IssueParent {
        id
        key
        summary
        color
    }
`;
const $260134d4e108ed85$export$25c256efca3597d1 = (0, $9ypom.default)`
    fragment ProjectLocationFragment on Project {
        id
        issueTypes {
            id
            name
            hierarchyLevelType
            iconUrl
            hasRequiredFields
        }
    }
`;
const $260134d4e108ed85$export$9d88616d202f6817 = (0, $9ypom.default)`
    fragment IssueParentTypeConfigFragment on IssueParentTypeConfig {
        id
        name
        iconUrl
        hierarchyLevelType
    }
`;
const $260134d4e108ed85$export$6fed28a6f51b8228 = (0, $9ypom.default)`
    fragment ColumnFragment on Column {
        isDone
        isInitial
    }
`;
const $260134d4e108ed85$export$e1c6fa95c54eabf5 = (0, $9ypom.default)`
    fragment BoardFragment on Board {
        rankCustomFieldId
    }
`;

});


parcelRegister("8CMGK", function(module, exports) {

$parcel$export(module.exports, "default", () => $42bc6e2b9a99b725$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $c8Guq = parcelRequire("c8Guq");

var $7rh0R = parcelRequire("7rh0R");

var $hFmdR = parcelRequire("hFmdR");


var $1vl6n = parcelRequire("1vl6n");

var $511uv = parcelRequire("511uv");

var $jfNYM = parcelRequire("jfNYM");


var $f9RL0 = parcelRequire("f9RL0");

var $gJYxu = parcelRequire("gJYxu");



var $fTGix = parcelRequire("fTGix");

var $cPaNZ = parcelRequire("cPaNZ");

var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");

var $j258X = parcelRequire("j258X");

var $ckAB8 = parcelRequire("ckAB8");

const $42bc6e2b9a99b725$export$35dd9ab573b87c3f = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("hicnb")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});
const $42bc6e2b9a99b725$var$IssueWrapper = (props)=>{
    const backlogCardCount = (0, $1gQ73.useBacklogSelector)((0, $fTGix.getBacklogCardCount));
    const isCompanyManaged = (0, $j258X.useIsCMPBacklog)(); // If there's an external action to be fired, dispatch it as soon as possible
    const onSetDispatchExternalActionRef = (0, $eUqFw.useCallback)((dispatchExternalActionRef)=>{
        if (dispatchExternalActionRef && props.externalAction) dispatchExternalActionRef(props.externalAction);
    }, [
        props.externalAction
    ]);
    const analyticsMetadata = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getDetailView))?.analyticsMetadata;
    (0, $eUqFw.useEffect)(()=>{
        (0, $cPaNZ.setIssueViewOpenFeedbackMark)();
    }, [
        props.issueKey
    ]);
    const isAgilityBoardForIssue = props.isAgilityBoard !== undefined ? props.isAgilityBoard : (0, $1vl6n.isAgilityBoard);
    const configWithAppKey = isAgilityBoardForIssue ? (0, $f9RL0.simpleSoftwareBoardConfiguration)() : (0, $f9RL0.softwareConfiguration)();
    const { applicationKey: applicationKey, ...configWithoutAppKey } = configWithAppKey;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($42bc6e2b9a99b725$var$BacklogIssueContainer, {
        "data-testid": "software-backlog.detail-view.issue-wrapper.backlog-issue"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ckAB8.PreIssueViewMountFeedbackMark), {
        issueKey: props.issueKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gJYxu.IssueBoundary), {
        packageName: (0, $e1409a6fc345c0d8$export$dfd208682d29484c)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($42bc6e2b9a99b725$export$35dd9ab573b87c3f, {
        ...configWithoutAppKey,
        analyticsSource: (0, $0100842672acae20$export$53d41ff2666118e1),
        analyticsMetadata: analyticsMetadata,
        isLoadedWithPage: true,
        issueKey: props.issueKey,
        onChange: props.onChange,
        onClose: props.onClose,
        rapidViewId: props.rapidViewId,
        viewModeOptions: {
            viewModeSwitchEnabled: false,
            viewMode: (0, $935e771f19f8ea28$export$705305d6da432040)
        },
        onIssueDeleteSuccess: props.onIssueDeleteSuccess,
        shouldSetInitialFocus: true,
        shouldShowCloseButton: true,
        metrics: {
            onReadyForUser: ()=>{
                (0, $511uv.getLongTasksMetrics)('bento').stop((0, $jfNYM.bentoReporter), {
                    type: 'sidebar',
                    backlogSessionId: props.backlogSessionId
                });
            },
            onInteractive: ()=>{
                (0, $cPaNZ.setIssueViewOpenFinishMark)(true, backlogCardCount, isCompanyManaged);
            }
        },
        onIssueKeyChange: props.onIssueKeyChange,
        history: null,
        dispatchExternalActionRef: onSetDispatchExternalActionRef
    })));
};
var $42bc6e2b9a99b725$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $hFmdR.AnalyticsSource)((0, $0100842672acae20$export$53d41ff2666118e1), (0, $41ea3621645e2acc$export$f636b5b56f1d624a)))($42bc6e2b9a99b725$var$IssueWrapper);
const $42bc6e2b9a99b725$var$BacklogIssueContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq",
            __cmplp.className
        ])
    });
});

});
const $0100842672acae20$export$53d41ff2666118e1 = 'agility-backlog';
const $0100842672acae20$export$7552fe2669628499 = 'bitbucket-issue';
const $0100842672acae20$export$41a718da0a8636f4 = 'connect-issue';
const $0100842672acae20$export$cebf0bc8b2ccaf57 = 'core-issue';
const $0100842672acae20$export$5e91e17726e54450 = 'jiraCalendar';
const $0100842672acae20$export$82540942fb014b0a = 'business-calendar';
const $0100842672acae20$export$7ca28938a07e0c33 = 'business-list';
const $0100842672acae20$export$f6cf06aaaeb58a54 = 'business-timeline';
const $0100842672acae20$export$b2c0462ff17aa26e = 'business-board';
const $0100842672acae20$export$a607850ebccd28ac = 'business-approvals';
const $0100842672acae20$export$1da6cede3561048f = 'business-files';
const $0100842672acae20$export$b19f949fb9713614 = 'full-issue';
const $0100842672acae20$export$a5132300c5214280 = 'embed-issue';
const $0100842672acae20$export$710114090a811b37 = 'global-issue-navigator-issue';
const $0100842672acae20$export$ce88447986394f2d = 'mobile-issue';
const $0100842672acae20$export$6a90d9196d330040 = 'project-issue-navigator';
const $0100842672acae20$export$2247c9059c171db1 = 'roadmap-issue';
const $0100842672acae20$export$cd16d39c55c569d0 = 'simple-software-board';
const $0100842672acae20$export$f72626bf0d75dfad = 'software-backlog-issue';
const $0100842672acae20$export$778b4609e784cb27 = 'software-deployments-issue';
const $0100842672acae20$export$5b73d694a6048002 = 'version-detail-issue';
const $0100842672acae20$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $0100842672acae20$export$21b5b7189add7861 = 'software-incidents-issue';
const $0100842672acae20$export$9c5d81b901471b27 = 'software-issue';
const $0100842672acae20$export$1735f6ad917dc411 = 'change-calendar';
const $0100842672acae20$export$7063ee6d0035a982 = 'queues-issue-view';
const $0100842672acae20$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $0100842672acae20$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $0100842672acae20$export$14a8072f422804fd = 'issue-navigator-next';

parcelRegister("1vl6n", function(module, exports) {

$parcel$export(module.exports, "isAgilityBoard", () => $e835ff3ea26acfe2$export$f5c021765283e8bd);

var $6rW04 = parcelRequire("6rW04");
const $e835ff3ea26acfe2$export$f5c021765283e8bd = // this meta actually checks if backlog is using issueLists
(0, $6rW04.default)('ghx-simply-filters-enabled') === 'true';

});

parcelRegister("jfNYM", function(module, exports) {

$parcel$export(module.exports, "bentoReporter", () => $1c7784a42ce37b74$export$b4ea9d181d8adab2);

var $lzvR2 = parcelRequire("lzvR2");

var $7tZw9 = parcelRequire("7tZw9");

var $fPUXl = parcelRequire("fPUXl");
const $1c7784a42ce37b74$export$b4ea9d181d8adab2 = (observationData, extra)=>{
    if ((0, $7tZw9.isExpandedObservationData)(observationData)) {
        const triggerSoftwareAnalytics = (0, $fPUXl.triggerAnalytics)(`software.${observationData.appName}`);
        const startTime = observationData.events.map((event)=>event.timestamp);
        const analyticsData = {
            ...extra,
            ...(0, $fPUXl.generateLongTaskAnalyticsSummary)('bento', observationData.events),
            measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTime),
            type: extra.type || 'unknown',
            performanceFFs: (0, $lzvR2.getPerformanceFFsString)()
        };
        triggerSoftwareAnalytics('long-tasks-bento', analyticsData);
    }
};

});

const $935e771f19f8ea28$export$98c0ebc22792f04 = 'MODAL';
const $935e771f19f8ea28$export$705305d6da432040 = 'SIDEBAR';
const $935e771f19f8ea28$export$2d037fdba4f67558 = 'DEFAULT';
const $935e771f19f8ea28$export$8bcece6b344db0b9 = 'FIELD';
const $935e771f19f8ea28$export$f65dd83d96b675ee = 'DEV_SUMMARY';
const $935e771f19f8ea28$export$971ccedc18d35178 = 'RELEASES_PANEL';
const $935e771f19f8ea28$export$18e4c648db363204 = 'PANEL';
const $935e771f19f8ea28$export$7f66491e43ca5015 = 'TAB';

parcelRegister("f9RL0", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPE", () => $3183c1ede6a2aff4$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_SUMMARY", () => $3183c1ede6a2aff4$export$a464614f8f5fe986);
$parcel$export(module.exports, "SUBTASK_PARENT", () => $3183c1ede6a2aff4$export$a311a3c9b207604e);
$parcel$export(module.exports, "WATCHES", () => $3183c1ede6a2aff4$export$289917d9a7031e1d);
$parcel$export(module.exports, "VOTES", () => $3183c1ede6a2aff4$export$81614f6dc3be5b00);
$parcel$export(module.exports, "SECURITY", () => $3183c1ede6a2aff4$export$72a5630aa398d6b4);
$parcel$export(module.exports, "ISSUE_RESTRICTION", () => $3183c1ede6a2aff4$export$caf1ff54fbdf44bf);
$parcel$export(module.exports, "ASSIGNEE", () => $3183c1ede6a2aff4$export$f8f7545d2bb78afb);
$parcel$export(module.exports, "REPORTER", () => $3183c1ede6a2aff4$export$6d7021166edc895c);
$parcel$export(module.exports, "PRIORITY", () => $3183c1ede6a2aff4$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "LABELS", () => $3183c1ede6a2aff4$export$79b91d4669dcadcb);
$parcel$export(module.exports, "DEV_SUMMARY", () => $3183c1ede6a2aff4$export$950d47e775e208ee);
$parcel$export(module.exports, "EPIC", () => $3183c1ede6a2aff4$export$3cb4a99a332e4186);
$parcel$export(module.exports, "FIX_VERSIONS", () => $3183c1ede6a2aff4$export$d7e18f5730074533);
$parcel$export(module.exports, "AFFECTS_VERSIONS", () => $3183c1ede6a2aff4$export$c435f0000304e508);
$parcel$export(module.exports, "TIME_TRACKING", () => $3183c1ede6a2aff4$export$ee99ef6ee562a446);
$parcel$export(module.exports, "TIME_ESTIMATE", () => $3183c1ede6a2aff4$export$a6a74b4bc927d39f);
$parcel$export(module.exports, "STATUS", () => $3183c1ede6a2aff4$export$e50006273435e7d4);
$parcel$export(module.exports, "CREATED", () => $3183c1ede6a2aff4$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $3183c1ede6a2aff4$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "SLA_PANEL", () => $3183c1ede6a2aff4$export$1d0e0bb6a21b800b);
$parcel$export(module.exports, "LINKED_ALERTS", () => $3183c1ede6a2aff4$export$340fac260c3e3637);
$parcel$export(module.exports, "CHAT_CHANNEL", () => $3183c1ede6a2aff4$export$24ec4dcc8e5b08ef);
$parcel$export(module.exports, "MSTEAMS_CHANNEL", () => $3183c1ede6a2aff4$export$8631065e0909313);
$parcel$export(module.exports, "ZOOM_MEETING", () => $3183c1ede6a2aff4$export$3c4dccba7d7e0acb);
$parcel$export(module.exports, "CONFERENCE_CALL", () => $3183c1ede6a2aff4$export$cd5e9246357daec3);
$parcel$export(module.exports, "KNOWLEDGE_BASE", () => $3183c1ede6a2aff4$export$203643a6fd9496a0);
$parcel$export(module.exports, "SENTIMENT", () => $3183c1ede6a2aff4$export$9c83bd19c3ffd90d);
$parcel$export(module.exports, "ASSET_ONBOARDING", () => $3183c1ede6a2aff4$export$c5c04443c6097d6e);
$parcel$export(module.exports, "MANAGE_STAKEHOLDERS", () => $3183c1ede6a2aff4$export$26d855f4cd7e5fe9);
$parcel$export(module.exports, "SUMMARY", () => $3183c1ede6a2aff4$export$913055729e1380b2);
$parcel$export(module.exports, "DESCRIPTION", () => $3183c1ede6a2aff4$export$d44826c816b5619b);
$parcel$export(module.exports, "COMMENT", () => $3183c1ede6a2aff4$export$a29989082612d0d9);
$parcel$export(module.exports, "EPIC_ISSUES", () => $3183c1ede6a2aff4$export$8fe3d5be8cb17459);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $3183c1ede6a2aff4$export$3b3d0889022c85b3);
$parcel$export(module.exports, "ENVIRONMENT", () => $3183c1ede6a2aff4$export$be46596bc6608f3b);
$parcel$export(module.exports, "SUBTASKS", () => $3183c1ede6a2aff4$export$f528fadbfdb3c25e);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $3183c1ede6a2aff4$export$f10e53e8928b61bd);
$parcel$export(module.exports, "PARENT", () => $3183c1ede6a2aff4$export$e0dfb65d1047c53c);
$parcel$export(module.exports, "PORTFOLIO_CHILD_ISSUES", () => $3183c1ede6a2aff4$export$aba22e09a66f6826);
$parcel$export(module.exports, "FLAG_ACTIONS", () => $3183c1ede6a2aff4$export$cdbd1eb3b05729e0);
$parcel$export(module.exports, "CARD_COVER_ACTIONS", () => $3183c1ede6a2aff4$export$c161a774ec2e7e56);
$parcel$export(module.exports, "specialFields", () => $3183c1ede6a2aff4$export$89e5c40c0f5c7561);
$parcel$export(module.exports, "ecosystemCustomFields", () => $3183c1ede6a2aff4$export$87934b3672715c91);
$parcel$export(module.exports, "customFieldsToDisplay", () => $3183c1ede6a2aff4$export$efd443bccc4c01ed);
$parcel$export(module.exports, "itemDocumentationUrls", () => $3183c1ede6a2aff4$export$a18b3a656ee9c709);
$parcel$export(module.exports, "emptyConfiguration", () => $3183c1ede6a2aff4$export$a52507e68e7aeeb);
$parcel$export(module.exports, "softwareConfiguration", () => $3183c1ede6a2aff4$export$27e0678365e5dcff);
$parcel$export(module.exports, "simpleSoftwareBoardConfiguration", () => $3183c1ede6a2aff4$export$aebf676dfa727a1c);
$parcel$export(module.exports, "standardRoadmapConfiguration", () => $3183c1ede6a2aff4$export$1afca4d3eb6b218b);
$parcel$export(module.exports, "bitbucketConfiguration", () => $3183c1ede6a2aff4$export$8a060ed6f66c43b0);
$parcel$export(module.exports, "mobileConfiguration", () => $3183c1ede6a2aff4$export$78a2cb921e46f5eb);
$parcel$export(module.exports, "serviceDeskConfiguration", () => $3183c1ede6a2aff4$export$db1115186532f6d5);
$parcel$export(module.exports, "connectConfiguration", () => $3183c1ede6a2aff4$export$557d5094ec5cf234);
$parcel$export(module.exports, "getIssueConfiguration", () => $3183c1ede6a2aff4$export$902f6c5cc939598a);

var $2wUFy = parcelRequire("2wUFy");

var $7ZZxN = parcelRequire("7ZZxN");

var $lO4Or = parcelRequire("lO4Or");
const $3183c1ede6a2aff4$export$ebb48b08205007c5 = 'issuetype';
const $3183c1ede6a2aff4$export$a464614f8f5fe986 = 'summary';
const $3183c1ede6a2aff4$export$a311a3c9b207604e = 'parent';
const $3183c1ede6a2aff4$export$2a4f270075a033de = 'parent-issue';
const $3183c1ede6a2aff4$export$4561a4960baf1b2b = 'parent'; // new Hierarchy unification parent field
const $3183c1ede6a2aff4$export$289917d9a7031e1d = 'watches';
const $3183c1ede6a2aff4$export$81614f6dc3be5b00 = 'votes';
const $3183c1ede6a2aff4$export$72a5630aa398d6b4 = 'security';
const $3183c1ede6a2aff4$export$caf1ff54fbdf44bf = 'issuerestriction';
const $3183c1ede6a2aff4$export$f8f7545d2bb78afb = 'assignee';
const $3183c1ede6a2aff4$export$6d7021166edc895c = 'reporter';
const $3183c1ede6a2aff4$export$cf7e173386d30cdd = 'duedate';
const $3183c1ede6a2aff4$export$bb34f3538ba26c7e = 'priority';
const $3183c1ede6a2aff4$export$79b91d4669dcadcb = 'labels';
const $3183c1ede6a2aff4$export$cbedbfe2cd0caec7 = 'components';
const $3183c1ede6a2aff4$export$950d47e775e208ee = 'devSummary';
const $3183c1ede6a2aff4$export$f91d2bb4cc99fa5e = 'releases';
const $3183c1ede6a2aff4$export$a316570a0dbfd2b0 = 'sprint';
const $3183c1ede6a2aff4$export$405b6d72f2d243a9 = 'storyPointsField';
const $3183c1ede6a2aff4$export$3cb4a99a332e4186 = 'epic';
const $3183c1ede6a2aff4$export$d7e18f5730074533 = 'fixVersions';
const $3183c1ede6a2aff4$export$c435f0000304e508 = 'versions';
const $3183c1ede6a2aff4$export$ee99ef6ee562a446 = 'timetracking';
const $3183c1ede6a2aff4$export$a6a74b4bc927d39f = 'timeoriginalestimate';
const $3183c1ede6a2aff4$export$e50006273435e7d4 = 'status';
const $3183c1ede6a2aff4$export$f1a6ce22cbb7eb32 = 'resolution';
const $3183c1ede6a2aff4$export$ff39ebd4bb12b718 = 'created';
const $3183c1ede6a2aff4$export$cd8e68094cb5c3cb = 'updated';
const $3183c1ede6a2aff4$export$1d0e0bb6a21b800b = 'SLA_PANEL';
const $3183c1ede6a2aff4$export$340fac260c3e3637 = 'LINKED_ALERTS';
const $3183c1ede6a2aff4$export$24ec4dcc8e5b08ef = 'CHAT_CHANNEL';
const $3183c1ede6a2aff4$export$8631065e0909313 = 'MSTEAMS_CHANNEL';
const $3183c1ede6a2aff4$export$3c4dccba7d7e0acb = 'ZOOM_MEETING';
const $3183c1ede6a2aff4$export$cd5e9246357daec3 = 'CONFERENCE_CALL';
const $3183c1ede6a2aff4$export$203643a6fd9496a0 = 'KNOWLEDGE_BASE';
const $3183c1ede6a2aff4$export$9c83bd19c3ffd90d = 'SENTIMENT';
const $3183c1ede6a2aff4$export$c5c04443c6097d6e = 'ASSET_ONBOARDING';
const $3183c1ede6a2aff4$export$26d855f4cd7e5fe9 = 'MANAGE_STAKEHOLDERS';
const $3183c1ede6a2aff4$export$913055729e1380b2 = 'summary';
const $3183c1ede6a2aff4$export$d44826c816b5619b = 'description';
const $3183c1ede6a2aff4$export$a29989082612d0d9 = 'comment';
const $3183c1ede6a2aff4$export$8fe3d5be8cb17459 = 'epic-issues'; // this field is only served in classic projects
const $3183c1ede6a2aff4$export$3b3d0889022c85b3 = 'children-issues';
const $3183c1ede6a2aff4$export$be46596bc6608f3b = 'environment';
const $3183c1ede6a2aff4$export$f528fadbfdb3c25e = 'subtasks';
const $3183c1ede6a2aff4$export$f10e53e8928b61bd = 'dataclassification';
const $3183c1ede6a2aff4$export$e0dfb65d1047c53c = (0, $lO4Or.PARENT_CF_TYPE);
const $3183c1ede6a2aff4$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $3183c1ede6a2aff4$export$cdbd1eb3b05729e0 = 'flagActions';
const $3183c1ede6a2aff4$export$c161a774ec2e7e56 = 'cardCoverActions';
const $3183c1ede6a2aff4$export$89e5c40c0f5c7561 = ()=>{
    const fields = {
        [$3183c1ede6a2aff4$export$3cb4a99a332e4186]: 'com.pyxis.greenhopper.jira:gh-epic-link',
        [$3183c1ede6a2aff4$export$a316570a0dbfd2b0]: 'com.pyxis.greenhopper.jira:gh-sprint',
        [$3183c1ede6a2aff4$export$405b6d72f2d243a9]: 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint',
        [(0, $lO4Or.TEAM_CF_TYPE)]: (0, $lO4Or.TEAM_CF_TYPE),
        [(0, $lO4Or.PARENT_CF_TYPE)]: (0, $lO4Or.PARENT_CF_TYPE),
        [(0, $lO4Or.BASELINE_START_CF_TYPE)]: (0, $lO4Or.BASELINE_START_CF_TYPE),
        [(0, $lO4Or.BASELINE_END_CF_TYPE)]: (0, $lO4Or.BASELINE_END_CF_TYPE),
        [(0, $lO4Or.COLOR_CF_TYPE)]: (0, $lO4Or.COLOR_CF_TYPE),
        [(0, $lO4Or.EPIC_COLOR_TYPE)]: (0, $lO4Or.EPIC_COLOR_TYPE),
        [(0, $lO4Or.EPIC_NAME_TYPE)]: (0, $lO4Or.EPIC_NAME_TYPE)
    };
    return fields;
};
const $3183c1ede6a2aff4$export$87934b3672715c91 = [
    (0, $lO4Or.ISSUE_FIELD_NUMBER_CF_TYPE),
    (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
    (0, $lO4Or.ISSUE_FIELD_DATETIME_CF_TYPE),
    (0, $lO4Or.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
    (0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
];
const $3183c1ede6a2aff4$var$serviceDeskCustomFields = [
    (0, $lO4Or.REQUEST_PARTICIPANTS_CF_TYPE),
    (0, $lO4Or.ORGANIZATIONS_CF_TYPE),
    (0, $lO4Or.REQUEST_LANGUAGE_CF_TYPE),
    (0, $lO4Or.REQUEST_FEEDBACK_CF_TYPE),
    (0, $lO4Or.APPROVALS_CF_TYPE),
    (0, $lO4Or.APPROVERS_LIST_CF_TYPE),
    (0, $lO4Or.REQUEST_TYPE_CF_TYPE),
    (0, $lO4Or.CMDB_OBJECT_CF_TYPE),
    (0, $lO4Or.RESPONDERS_CF_TYPE),
    (0, $lO4Or.MAJOR_INCIDENT_CF_TYPE),
    (0, $lO4Or.ENTITLEMENT_CF_TYPE),
    (0, $lO4Or.SENTIMENT_CF_TYPE)
];
const $3183c1ede6a2aff4$export$efd443bccc4c01ed = ()=>[
        (0, $lO4Or.LABELS_CF_TYPE),
        (0, $lO4Or.TEXT_CF_TYPE),
        (0, $lO4Or.MULTI_USER_CF_TYPE),
        (0, $lO4Or.PARTICIPANTS_CF_TYPE),
        (0, $lO4Or.URL_CF_TYPE),
        (0, $lO4Or.NUMBER_CF_TYPE),
        (0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE),
        (0, $lO4Or.SELECT_CF_TYPE),
        (0, $lO4Or.MULTI_SELECT_CF_TYPE),
        (0, $lO4Or.VERSION_CF_TYPE),
        (0, $lO4Or.TEXT_AREA_CF_TYPE),
        (0, $lO4Or.MULTI_VERSION_CF_TYPE),
        (0, $lO4Or.DATE_CF_TYPE),
        (0, $lO4Or.GROUP_CF_TYPE),
        (0, $lO4Or.MULTI_GROUP_CF_TYPE),
        (0, $lO4Or.USER_CF_TYPE),
        (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
        (0, $lO4Or.RADIO_BUTTONS_CF_TYPE),
        (0, $lO4Or.DATETIME_CF_TYPE),
        (0, $lO4Or.ASSETS_CF_TYPE),
        (0, $lO4Or.SERVICE_ENTITY_CF_TYPE),
        (0, $lO4Or.PEOPLE_CF_TYPE),
        (0, $lO4Or.CASCADING_SELECT_CF_TYPE),
        (0, $lO4Or.PROJECT_PICKER_CF_TYPE),
        (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE),
        (0, $lO4Or.READ_ONLY_CF_TYPE),
        (0, $lO4Or.EPIC_STATUS_TYPE),
        (0, $lO4Or.MESSAGE_VIEW_CF_TYPE),
        (0, $lO4Or.MESSAGE_EDIT_CF_TYPE),
        (0, $lO4Or.CATEGORY_TYPE),
        (0, $lO4Or.GOALS_CF_TYPE),
        ...$3183c1ede6a2aff4$export$87934b3672715c91,
        ...$3183c1ede6a2aff4$var$serviceDeskCustomFields
    ];
const $3183c1ede6a2aff4$export$a18b3a656ee9c709 = {
    [(0, $7ZZxN.SOFTWARE_PROJECT)]: 'https://confluence.atlassian.com/jirasoftwarecloud/configure-field-layout-in-the-issue-view-961798059.html',
    [(0, $7ZZxN.CORE_PROJECT)]: 'https://confluence.atlassian.com/jiracorecloud/configure-field-layout-in-the-issue-view-961798123.html',
    [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: 'https://support.atlassian.com/jira-service-desk-cloud/docs/what-are-the-different-sections-in-the-issue-view/'
};
const $3183c1ede6a2aff4$export$a52507e68e7aeeb = ()=>({
        issueActions: []
    });
const $3183c1ede6a2aff4$export$381ce08838c53afa = ()=>({
        applicationKey: (0, $2wUFy.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$27e0678365e5dcff = ()=>({
        applicationKey: (0, $2wUFy.default).SOFTWARE_ISSUE,
        issueActions: [
            $3183c1ede6a2aff4$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$aebf676dfa727a1c = ()=>({
        applicationKey: (0, $2wUFy.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $3183c1ede6a2aff4$export$cdbd1eb3b05729e0,
            $3183c1ede6a2aff4$export$c161a774ec2e7e56
        ],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$1afca4d3eb6b218b = ()=>({
        applicationKey: (0, $2wUFy.default).STANDARD_ROADMAP_ISSUE,
        issueActions: [
            $3183c1ede6a2aff4$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$8a060ed6f66c43b0 = ()=>({
        applicationKey: (0, $2wUFy.default).BITBUCKET_ISSUE,
        issueActions: []
    });
const $3183c1ede6a2aff4$export$78a2cb921e46f5eb = ()=>({
        applicationKey: (0, $2wUFy.default).MOBILE_ISSUE,
        issueActions: []
    });
const $3183c1ede6a2aff4$export$db1115186532f6d5 = ()=>({
        applicationKey: (0, $2wUFy.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$557d5094ec5cf234 = ()=>({
        applicationKey: (0, $2wUFy.default).CONNECT_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            if (config.isSimplified) return $3183c1ede6a2aff4$export$aebf676dfa727a1c();
            return $3183c1ede6a2aff4$export$27e0678365e5dcff();
        case 0, $7ZZxN.CORE_PROJECT:
            return $3183c1ede6a2aff4$export$381ce08838c53afa();
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return $3183c1ede6a2aff4$export$db1115186532f6d5();
        default:
            // fallback to sofware config
            return $3183c1ede6a2aff4$export$27e0678365e5dcff();
    }
    return $3183c1ede6a2aff4$export$27e0678365e5dcff();
};

});

parcelRegister("gJYxu", function(module, exports) {

$parcel$export(module.exports, "IssueBoundary", () => $47dde6f657625382$export$fbf48ede0cf52b5a);
$parcel$export(module.exports, "IssueModalBoundary", () => $47dde6f657625382$export$74d408982642a541);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $cyVXS = parcelRequire("cyVXS");

var $gGtKh = parcelRequire("gGtKh");

var $c4qEZ = parcelRequire("c4qEZ");
const $47dde6f657625382$export$fbf48ede0cf52b5a = ({ children: children, isEmbedView: isEmbedView = true, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4qEZ.IssueViewSkeleton), {
            isEmbedView: isEmbedView
        })
    }, children));
const $47dde6f657625382$export$74d408982642a541 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cyVXS.ModalBoundary), {
        id: "issue-modal",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-modal-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4qEZ.IssueViewSkeleton), {
            isModalView: true
        })
    }, children));

});
parcelRegister("cyVXS", function(module, exports) {

$parcel$export(module.exports, "ModalBoundary", () => $f96d169c5da11246$export$c3f500e812fb1bb3);

var $eUqFw = parcelRequire("eUqFw");

var $h97Af = parcelRequire("h97Af");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $fee69 = parcelRequire("fee69");

var $gGtKh = parcelRequire("gGtKh");
const $f96d169c5da11246$export$c3f500e812fb1bb3 = ({ children: children, id: id, metricKey: metricKey, packageName: packageName, onError: onError })=>{
    const ErrorState = (0, $eUqFw.useCallback)((args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorFlagRenderer), {
            id: id,
            error: args.error
        }), [
        id
    ]);
    const fallback = typeof metricKey === 'string' && metricKey.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: metricKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: id,
        packageName: packageName,
        render: ErrorState,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: id,
        fallback: fallback
    }, children));
};

});


parcelRegister("cPaNZ", function(module, exports) {

$parcel$export(module.exports, "setIssueViewOpenFeedbackMark", () => $f5d918ca70e7a147$export$2c1211bae6c14a9);
$parcel$export(module.exports, "setIssueViewOpenFinishMark", () => $f5d918ca70e7a147$export$74c6496311688a4d);

var $lzvR2 = parcelRequire("lzvR2");

var $gPQCf = parcelRequire("gPQCf");
const $f5d918ca70e7a147$export$2c1211bae6c14a9 = ()=>{
    (0, $gPQCf.issueViewOpenInteraction).mark('feedback');
};
const $f5d918ca70e7a147$export$74c6496311688a4d = (isSideBar, backlogCardCount, isCompanyManaged)=>{
    (0, $gPQCf.issueViewOpenInteraction).stop({
        customData: {
            ...(0, $lzvR2.getNormalisedPerformanceFFs)(),
            ...backlogCardCount,
            isSideBar: isSideBar,
            isCompanyManaged: isCompanyManaged
        }
    });
};

});

parcelRegister("ckAB8", function(module, exports) {

$parcel$export(module.exports, "PreIssueViewMountFeedbackMark", () => $5c5015e7986c1ee9$export$e17cfe6a40740e70);

var $eUqFw = parcelRequire("eUqFw");

var $gPQCf = parcelRequire("gPQCf");
const $5c5015e7986c1ee9$export$e17cfe6a40740e70 = ({ issueKey: issueKey })=>{
    (0, $eUqFw.useEffect)(()=>{
        (0, $gPQCf.issueViewOpenInteraction).mark('feedbackPreMountEnd');
    }, [
        issueKey
    ]);
    return null;
};

});

parcelRegister("hicnb", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('kWrFZ'),
            load('92sUi'),
            load('i5RRW'),
            load('dsiAd'),
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('kMAKK')
        ]);
        const value = parcelRequire('9zAkH');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("kWrFZ"),
        load("92sUi"),
        load("i5RRW"),
        load("dsiAd"),
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("kMAKK")
    ]).then(()=>parcelRequire('9zAkH'));
}

});


parcelRegister("eBXAX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce9421441d5b0af6$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");

var $fE3Ua = parcelRequire("fE3Ua");

var $eKZPH = parcelRequire("eKZPH");

var $gGtKh = parcelRequire("gGtKh");

var $ba1Xy = parcelRequire("ba1Xy");

var $90ZS3 = parcelRequire("90ZS3");

var $8wXFi = parcelRequire("8wXFi");


var $j258X = parcelRequire("j258X");

var $8wl1S = parcelRequire("8wl1S");

var $i0G2M = parcelRequire("i0G2M");

var $bRtVw = parcelRequire("bRtVw");

var $8b3re = parcelRequire("8b3re");

var $9HUWA = parcelRequire("9HUWA");
const $ce9421441d5b0af6$var$REFETCH_EPIC_PANELS_EVENTS = [
    (0, $fE3Ua.ChangeEventTypes).FIELD_CHANGED,
    (0, $fE3Ua.ChangeEventTypes).ISSUE_RELATIONSHIP_UPDATED,
    (0, $fE3Ua.ChangeEventTypes).CHILD_ISSUE_ADDED,
    (0, $fE3Ua.ChangeEventTypes).ISSUE_TYPE_CHANGED
];
const $ce9421441d5b0af6$export$d51fb174c0dd91e9 = ({ parentWidth: parentWidth, cardKey: cardKey, rapidViewId: rapidViewId, onClose: onClose, onChange: onChange, onDelete: onDelete, timestamp: timestamp, onCloseInsightsClick: onCloseInsightsClick, onCloseViewSettingsPanelClick: onCloseViewSettingsPanelClick, isBacklogWithSprints: isBacklogWithSprints, externalAction: externalAction, backlogSessionId: backlogSessionId, IssueWrapper: IssueWrapper })=>{
    const [issueKey, setIssueKey] = (0, $90ZS3.useQueryParam)((0, $5a6592135d519f1e$export$3a0c4bc79274bbaa));
    const issueKeyOrCardKey = issueKey || cardKey;
    const onIssueKeyChange = (0, $eUqFw.useCallback)(({ toIssueKey: toIssueKey })=>setIssueKey(toIssueKey), [
        setIssueKey
    ]);
    const isInsightsOpen = (0, $8wl1S.useIsInsightsPanelOpen)();
    const isViewSettingsPanelOpen = (0, $i0G2M.useIsViewSettingsPanelOpen)();
    const isCompanyManaged = (0, $j258X.useIsCMPBacklog)();
    const [_, { triggerEpicPanelRefetch: triggerEpicPanelRefetch }] = (0, $ba1Xy.useShouldRefetchEpicPanel)();
    const handleChange = (0, $eUqFw.useCallback)((event)=>{
        onChange(event);
        if (isCompanyManaged && $ce9421441d5b0af6$var$REFETCH_EPIC_PANELS_EVENTS.includes(event.type)) triggerEpicPanelRefetch();
    }, [
        isCompanyManaged,
        onChange,
        triggerEpicPanelRefetch
    ]);
    const handleIssueDelete = (0, $eUqFw.useCallback)((data)=>{
        onDelete(data);
        if (isCompanyManaged) triggerEpicPanelRefetch();
    }, [
        isCompanyManaged,
        onDelete,
        triggerEpicPanelRefetch
    ]);
    const getBacklogInsightsPanel = (0, $eUqFw.useCallback)(()=>isInsightsOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ce9421441d5b0af6$var$DetailsPanelContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ce9421441d5b0af6$var$InsightsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "backlog-insights-panel",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bRtVw.AsyncBacklogInsightsPanel), {
            isOpen: isInsightsOpen,
            onClose: onCloseInsightsClick
        })))) : null, [
        isInsightsOpen,
        onCloseInsightsClick
    ]);
    const getBacklogViewSettingsPanel = (0, $eUqFw.useCallback)(()=>isViewSettingsPanelOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $ce9421441d5b0af6$var$ViewSettingsPanelContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9HUWA.ViewSettingsPanel), {
            isPanelOpen: isViewSettingsPanelOpen,
            onPanelClose: onCloseViewSettingsPanelClick
        })) : null, [
        isViewSettingsPanelOpen,
        onCloseViewSettingsPanelClick
    ]);
    return (0, $8wXFi.isViewSettingAsPanelExpEnabledWithNoExposure)() && isViewSettingsPanelOpen ? getBacklogViewSettingsPanel() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eKZPH.JiraDetailPanel), null, (setDetailPanelWidth)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8b3re.Resizer), {
            parentWidth: parentWidth,
            onResize: setDetailPanelWidth
        }, issueKeyOrCardKey !== null && issueKeyOrCardKey !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ce9421441d5b0af6$var$DetailsWrapper, {
            hide: isInsightsOpen
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IssueWrapper, {
            key: issueKeyOrCardKey + timestamp,
            issueKey: issueKeyOrCardKey,
            onClose: onClose,
            onChange: handleChange,
            onIssueDeleteSuccess: handleIssueDelete,
            rapidViewId: Number(rapidViewId),
            isAgilityBoard: true,
            isLoadedWithPage: true,
            onIssueKeyChange: onIssueKeyChange,
            history: null,
            externalAction: externalAction,
            backlogSessionId: backlogSessionId
        })), isBacklogWithSprints && getBacklogInsightsPanel()));
};
var $ce9421441d5b0af6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($ce9421441d5b0af6$export$d51fb174c0dd91e9);
const $ce9421441d5b0af6$var$ViewSettingsPanelContainerStyles = (0, $1ZAYh.xcss)({
    overflowX: 'hidden',
    overflowY: 'auto',
    paddingRight: 'space.500',
    paddingLeft: 'space.300',
    paddingBottom: 'space.300'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $ce9421441d5b0af6$var$DetailsWrapperControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-10sh35q-0"
})((props)=>({
        flex: 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        display: props.hide ? 'none' : undefined,
        height: '100%',
        overflowX: 'hidden'
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce9421441d5b0af6$var$DetailsWrapperExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hide: hide, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _4t3i1osq _1reo15vq",
            __cmplp.hide && "_1e0cglyw",
            __cmplp.className
        ])
    });
});
const $ce9421441d5b0af6$var$DetailsWrapper = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $ce9421441d5b0af6$var$DetailsWrapperExperiment, $ce9421441d5b0af6$var$DetailsWrapperControl); // eslint-disable-next-line @atlaskit/design-system/no-empty-styled-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce9421441d5b0af6$var$InsightsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce9421441d5b0af6$var$DetailsPanelContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _kqswh2mm _4t3i1osq _1reo15vq _18m915zi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eWeL8", function(module, exports) {

$parcel$export(module.exports, "styledComponentWithCondition", () => $e0c5c7e39a960e0c$export$62d8d8fbf238d6af);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");
const $e0c5c7e39a960e0c$export$62d8d8fbf238d6af = (useCompiled, CompiledComponent, StyledComponent)=>// Couldn't destructure like {innerRef, ...rest} as
    // typescript is suspcious on destructing generics
    ({ innerRef: innerRef, ...rest })=>useCompiled() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CompiledComponent, {
            ...rest,
            ref: innerRef
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StyledComponent, {
            ...rest,
            innerRef: innerRef
        });
const $e0c5c7e39a960e0c$export$f5b752428255ba78 = (useCompiled, CompiledComponent, StyledComponent)=>({ innerRef: innerRef, ...rest })=>useCompiled() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CompiledComponent, {
            ...rest,
            ref: innerRef
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StyledComponent, {
            ...rest,
            innerRef: innerRef
        });

});

parcelRegister("eKZPH", function(module, exports) {

$parcel$export(module.exports, "JiraDetailPanel", () => $1b225f5f3fb1073b$export$93acb63f4e179357);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $a576Y = parcelRequire("a576Y");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $53ucm = parcelRequire("53ucm");
const $1b225f5f3fb1073b$var$DetailPanel = ({ children: children, panelWidth: panelWidth })=>{
    const { setWidth: setWidth } = (0, $53ucm.useDetailPanelActions)();
    (0, $eUqFw.useEffect)(()=>{
        if (panelWidth !== undefined) setWidth(panelWidth);
        return ()=>setWidth(0);
    }, [
        panelWidth,
        setWidth
    ]);
    const throttleSetWidth = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))(setWidth, 50, {
            leading: true,
            trailing: true
        }), [
        setWidth
    ]);
    return typeof children === 'function' ? children(throttleSetWidth) : children;
};
const $1b225f5f3fb1073b$export$93acb63f4e179357 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "jira-detail-panel",
        packageName: "jira-bottom-right-corner-controller",
        render: ()=>typeof props.children === 'function' ? props.children((0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))) : props.children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b225f5f3fb1073b$var$DetailPanel, props));

});

parcelRegister("bRtVw", function(module, exports) {

$parcel$export(module.exports, "AsyncBacklogInsightsPanel", () => $8ec0939fbb064021$export$ad767ebad8b61f5b);

var $7rh0R = parcelRequire("7rh0R");

const $8ec0939fbb064021$export$ad767ebad8b61f5b = (0, $7rh0R.lazy)(()=>(parcelRequire("kmtq2")).then((module)=>module.default), {
    moduleId: "./src/packages/software/backlog/src/view/backlog-content/insights-panel/index.tsx"
});

});
parcelRegister("kmtq2", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('7hOvt')
        ]);
        const value = parcelRequire('i78lX');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("7hOvt")
    ]).then(()=>parcelRequire('i78lX'));
}

});


parcelRegister("8b3re", function(module, exports) {

$parcel$export(module.exports, "Resizer", () => $7542472a5c5b0691$export$48a76196cafe3b93);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $511uv = parcelRequire("511uv");

var $6RZSH = parcelRequire("6RZSH");

var $dkPd7 = parcelRequire("dkPd7");

var $iYUz7 = parcelRequire("iYUz7");

var $5QH4Q = parcelRequire("5QH4Q");
const $7542472a5c5b0691$export$b4e0432c87affda2 = 440;
const $7542472a5c5b0691$export$177615fff7f0b5c6 = 440;
function $7542472a5c5b0691$export$48a76196cafe3b93({ setWidth: widthProp, onResize: onResize, children: children, parentWidth: parentWidth, onResizeEnd: onResizeEnd }) {
    const [width, setWidth] = (0, $eUqFw.useState)(()=>{
        const initValue = (0, $iYUz7.getDetailViewWidthRatio)();
        return Math.max(parentWidth * initValue, $7542472a5c5b0691$export$b4e0432c87affda2);
    });
    const startX = (0, $eUqFw.useRef)(0);
    const extraWidth = (0, $eUqFw.useRef)(0);
    (0, $eUqFw.useEffect)(()=>{
        const initValue = (0, $iYUz7.getDetailViewWidthRatio)();
        setWidth(Math.max(parentWidth * initValue, $7542472a5c5b0691$export$b4e0432c87affda2));
    }, [
        parentWidth
    ]);
    (0, $eUqFw.useEffect)(()=>{
        onResize?.(widthProp !== undefined && widthProp !== 0 ? widthProp : width);
    }, [
        onResize,
        width,
        widthProp
    ]);
    const onMouseUp = (0, $dkPd7.useEvent)(()=>{
        startX.current = 0;
        window.removeEventListener('mousemove', onMouseMove);
        window.removeEventListener('mouseup', onMouseUp);
        if (document.body) document.body.classList.remove((0, $5QH4Q.IS_DRAGGING_CLASS_NAME));
        const widthRatio = width === $7542472a5c5b0691$export$b4e0432c87affda2 ? 0 : width / parentWidth;
        (0, $iYUz7.setDetailViewWidthRatio)(widthRatio);
        (0, $511uv.getLongTasksMetrics)('detail-view-resizer').stop((0, $6RZSH.softwareGenericLongTasksReporter)('detail-view-resizer'));
        onResizeEnd && onResizeEnd(width / parentWidth);
    });
    const onMouseDown = (0, $dkPd7.useEvent)((e)=>{
        startX.current = e.clientX + (width - $7542472a5c5b0691$export$b4e0432c87affda2);
        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('mouseup', onMouseUp);
        if (document.body) document.body.classList.add((0, $5QH4Q.IS_DRAGGING_CLASS_NAME));
        (0, $511uv.getLongTasksMetrics)('detail-view-resizer').start('jira-backlog-detail-view-resizer');
    });
    const onMouseMove = (0, $dkPd7.useEvent)((e)=>{
        extraWidth.current = Math.max(startX.current - e.clientX, 0);
        const newValue = Math.min($7542472a5c5b0691$export$b4e0432c87affda2 + extraWidth.current, parentWidth / 2);
        if (newValue === width) return;
        setWidth(newValue);
    });
    return(// dynamic change of values
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7542472a5c5b0691$var$Container, {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            width: widthProp != null && widthProp !== 0 ? widthProp : width
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7542472a5c5b0691$var$ResizeHandle, {
        onMouseDown: onMouseDown,
        "data-testid": "software-backlog.detail-view.resizer.resize-handle"
    }), children));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7542472a5c5b0691$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1tke1osq _c71l1osq _18m91wug _1reo15vq _1e0c1txw _2lx2vrvc _4cvr1y6m",
            __cmplp.className
        ])
    });
});
const $7542472a5c5b0691$var$ResizeHandle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbftgi _80omuf7j _1p3lnqa1 _t6vdyh40 _5wra3acm _1wpz1fhb _v5641w3a _1i2o194a _1smf194a",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5QH4Q", function(module, exports) {

$parcel$export(module.exports, "IS_DRAGGING_CLASS_NAME", () => $efa3f1455ae32f34$export$373c1b4ae027de04);
$parcel$export(module.exports, "default", () => $efa3f1455ae32f34$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $efa3f1455ae32f34$export$373c1b4ae027de04 = 'ak-dnd-is-dragging';
function $efa3f1455ae32f34$export$2e2bcd8739ae039() {
    // Note that react-beautiful-dnd actually handles body styles when dragging
    // BUT it doesn't prevent the ICC placeholder from triggering on the board and backlog
    // and as a result we need this class here to prevent that behaviour
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `
                            /* disable hover events during drag */
                            body.${$efa3f1455ae32f34$export$373c1b4ae027de04} * {
                                pointer-events: none;
                            }
                        `
        }
    }));
}

});


parcelRegister("9HUWA", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsPanel", () => $cd507c195cc1e76f$export$3a81a9760a380951);

var $eUqFw = parcelRequire("eUqFw");

var $8blac = parcelRequire("8blac");

var $79xbN = parcelRequire("79xbN");

var $aDfcw = parcelRequire("aDfcw");
var $c3qrZ = parcelRequire("c3qrZ");

var $1gQ73 = parcelRequire("1gQ73");

var $7TN4i = parcelRequire("7TN4i");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $8ZI73 = parcelRequire("8ZI73");

var $kdGmo = parcelRequire("kdGmo");

var $7kNqR = parcelRequire("7kNqR");

var $ai2KE = parcelRequire("ai2KE");

var $lMwdE = parcelRequire("lMwdE");
const $cd507c195cc1e76f$export$3a81a9760a380951 = ({ isPanelOpen: isPanelOpen, onPanelClose: onPanelClose })=>{
    const boardId = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getRapidViewId));
    const isCMPBoard = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getIsCompanyManaged));
    const showEpicAsPanel = (0, $1gQ73.useBacklogSelector)((0, $8ZI73.getShowEpicAsPanel));
    const allCardGroups = (0, $lMwdE.useAllCardGroups)();
    const isQuickFiltersAvailable = (0, $1gQ73.useBacklogSelector)((0, $kdGmo.getCMPFilters)).length > 0;
    const isVersionsEnabled = (0, $1gQ73.useBacklogSelector)((0, $ai2KE.isVersionsFeatureEnabled));
    const showFilterBarToggle = isCMPBoard && isQuickFiltersAvailable;
    const config = (0, $1gQ73.useBacklogSelector)((0, $8ZI73.getConfig));
    const epicCustomName = config.hierarchyNomenclature?.firstLevelName;
    const canEdit = (0, $1gQ73.useBacklogSelector)((0, $7kNqR.canEditBoardConfig));
    const canInvite = (0, $1gQ73.useBacklogSelector)((0, $8ZI73.getCanInviteOthersToProject));
    const shouldShowSubtasks = (0, $eUqFw.useMemo)(()=>!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(allCardGroups), [
        allCardGroups
    ]);
    const areAllSubtasksExpanded = (0, $eUqFw.useMemo)(()=>allCardGroups.every((card)=>!card.isCollapsed), [
        allCardGroups
    ]);
    const areAllSubtasksCollapsed = (0, $eUqFw.useMemo)(()=>allCardGroups.every((card)=>card.isCollapsed), [
        allCardGroups
    ]);
    const handleExpandSubtasks = (0, $1gQ73.useBacklogActionCreator)(()=>(0, $7TN4i.setExpandedCardGroups)(allCardGroups.map((card)=>card.parentId.toString())));
    const handleCollapseSubtasks = (0, $1gQ73.useBacklogActionCreator)(()=>(0, $7TN4i.collapseAllCardGroups)());
    const cardExtraFields = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getCardExtraFields));
    const hasCardsWithStoryPoint = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.backlogHasStoryPoints));
    const hasCardsWithEstimate = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.backlogHasEstimates));
    const isDueDateEnabled = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.backlogHasDueDate));
    const isPriorityEnabled = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.backlogHasPriority));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aDfcw.default), {
        view: (0, $c3qrZ.View).BACKLOG,
        viewAs: (0, $c3qrZ.ViewAs).PANEL,
        isViewPanelOpen: isPanelOpen,
        onViewPanelClose: onPanelClose,
        boardId: Number(boardId),
        isClassic: isCMPBoard,
        areSubtasksEnabled: isCMPBoard && shouldShowSubtasks,
        onSubtasksExpandAll: handleExpandSubtasks,
        onSubtasksCollapseAll: handleCollapseSubtasks,
        areAllSubtasksExpanded: areAllSubtasksExpanded,
        areAllSubtasksCollapsed: areAllSubtasksCollapsed,
        showEpicAsPanel: showEpicAsPanel,
        epicCustomName: epicCustomName,
        isVersionsEnabled: isVersionsEnabled,
        showFilterBarToggle: showFilterBarToggle,
        cardExtraFields: cardExtraFields,
        isEstimateEnabled: hasCardsWithStoryPoint || hasCardsWithEstimate,
        isDueDateEnabled: !isCMPBoard && isDueDateEnabled,
        isPriorityEnabled: isPriorityEnabled,
        isAddPeopleButtonEnabled: canEdit || canInvite && (0, $79xbN.expValEquals)('open_invite_for_open_tmp_projects', 'cohort', 'experiment')
    });
};

});
parcelRegister("aDfcw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f31f9f5227f9d0e2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");

var $0cdA8 = parcelRequire("0cdA8");

var $1ybV0 = parcelRequire("1ybV0");

var $erql0 = parcelRequire("erql0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");

var $kS8l2 = parcelRequire("kS8l2");

var $jyKDT = parcelRequire("jyKDT");

var $l3HJG = parcelRequire("l3HJG");
var $c3qrZ = parcelRequire("c3qrZ");

var $aZMX1 = parcelRequire("aZMX1");

var $6eyW6 = parcelRequire("6eyW6");

var $8TRqG = parcelRequire("8TRqG");

var $8MrYx = parcelRequire("8MrYx");

var $jEMDE = parcelRequire("jEMDE");

var $dzGPJ = parcelRequire("dzGPJ");

var $6CkDr = parcelRequire("6CkDr");

var $2pNxZ = parcelRequire("2pNxZ");

var $4lQWc = parcelRequire("4lQWc");

var $27GCD = parcelRequire("27GCD");

var $B4KsE = parcelRequire("B4KsE");
parcelRequire("78u8L");
const $f31f9f5227f9d0e2$var$ViewSettings = ({ view: view, boardId: boardId, isClassic: isClassic, epicCustomName: epicCustomName, showEpicAsPanel: showEpicAsPanel = false, showFilterBarToggle: showFilterBarToggle = false, showCardDetails: showCardDetails = true, isVersionsEnabled: isVersionsEnabled = false, viewAs: viewAs = (0, $c3qrZ.ViewAs).POPUP, isViewPanelOpen: isViewPanelOpen = false, onViewPanelClose: onViewPanelClose = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), areSubtasksEnabled: areSubtasksEnabled, onSubtasksExpandAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSubtasksExpandAll = ()=>{}, onSubtasksCollapseAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSubtasksCollapseAll = ()=>{}, onToggleWorkSuggestions: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onToggleWorkSuggestions = ()=>{}, onLinkedIssuesStatsToggledOn: // eslint-disable-next-line @typescript-eslint/no-empty-function
onLinkedIssuesStatsToggledOn = ()=>{}, areAllSubtasksExpanded: areAllSubtasksExpanded = false, areAllSubtasksCollapsed: areAllSubtasksCollapsed = false, isSwimlanesEnabled: isSwimlanesEnabled = false, onSwimlaneExpandAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneExpandAll = ()=>{}, onSwimlaneCollapseAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneCollapseAll = ()=>{}, isDaysInColumnEnabled: isDaysInColumnEnabled = false, showLinkedIssueStatsToggle: showLinkedIssueStatsToggle = false, cardExtraFields: cardExtraFields = [], isEstimateEnabled: isEstimateEnabled = false, isDueDateEnabled: isDueDateEnabled = false, isLabelsEnabled: isLabelsEnabled = false, isPriorityEnabled: isPriorityEnabled = false, isWorkSuggestionsEnabled: isWorkSuggestionsEnabled = false, showWorkSuggestions: showWorkSuggestions = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const sendAnalyticsEvent = (0, $8TRqG.useSendAnalyticsEvent)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const panelRef = (0, $eUqFw.useRef)(null);
    const [{ activeViewSettingsSpotlight: activeViewSettingsSpotlight, onViewSettingsSpotlightEnd: onViewSettingsSpotlightEnd }, { setOpenViewSettings: setOpenViewSettings }] = (0, $erql0.useNextBestTaskContainer)();
    const handleViewPanelClose = ()=>{
        onViewPanelClose();
    };
    const handleClose = ()=>{
        setIsOpen(false);
        if ((0, $1ybV0.ff)('jira.insights.work-suggestions-on-boarding-spotlight-view-settings_dzjgq') && activeViewSettingsSpotlight === 1 && onViewSettingsSpotlightEnd) // To end the spotlight if the popup is closed
        onViewSettingsSpotlightEnd();
    };
    const handleClick = ()=>{
        setIsOpen(!isOpen);
        sendAnalyticsEvent('clicked', 'button', (0, $l3HJG.AnalyticsEvent).UI_EVENT, {
            isClassic: isClassic,
            app: view
        }, viewAs === (0, $c3qrZ.ViewAs).PANEL && (0, $6eyW6.isViewSettingsPanelAndTailoredViewExperimentEnabled)() ? (0, $c3qrZ.ViewAs).PANEL : 'popupMenu');
    };
    const openViewSettings = (0, $eUqFw.useCallback)(()=>{
        if (isOpen) return;
        setIsOpen(true);
        sendAnalyticsEvent('clicked', 'button', (0, $l3HJG.AnalyticsEvent).UI_EVENT, {
            isClassic: isClassic,
            app: view
        }, viewAs === (0, $c3qrZ.ViewAs).PANEL && (0, $6eyW6.isViewSettingsPanelAndTailoredViewExperimentEnabled)() ? (0, $c3qrZ.ViewAs).PANEL : 'popupMenu');
    }, [
        sendAnalyticsEvent,
        isClassic,
        view,
        viewAs,
        isOpen
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if ((0, $1ybV0.ff)('jira.insights.work-suggestions-on-boarding-spotlight-view-settings_dzjgq') && setOpenViewSettings) setOpenViewSettings(openViewSettings);
    }, [
        openViewSettings,
        setOpenViewSettings
    ]);
    const viewSettingsBtnLG = (0, $kS8l2.useGlobalRef)((0, $jyKDT.VIEW_SETTINGS_BUTTON_LG))[0];
    const viewSettingsBtnSM = (0, $kS8l2.useGlobalRef)((0, $jyKDT.VIEW_SETTINGS_BUTTON_SM))[0];
    const [, { register: register }] = (0, $kS8l2.useGlobalRefStoreActions)();
    (0, $eUqFw.useEffect)(()=>{
        // register view settings panel global ref
        register((0, $4d633a261a02c90e$export$989661c424340ff8), panelRef.current);
        const focusOnCloseButton = ()=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const closeButton = panelRef.current?.querySelector(`[data-testid="${(0, $jyKDT.VIEW_SETTINGS_PANEL_CLOSE_BUTTON_TEST_ID)}"]`);
            closeButton?.focus();
        };
        if (document.activeElement === viewSettingsBtnLG) {
            focusOnCloseButton();
            return ()=>viewSettingsBtnLG?.focus();
        }
        if (document.activeElement === viewSettingsBtnSM) {
            focusOnCloseButton();
            return ()=>viewSettingsBtnSM?.focus();
        }
    }, [
        register,
        viewSettingsBtnLG,
        viewSettingsBtnSM
    ]);
    const conditionallyRenderViewSettingsButtonWithAria = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27GCD.ViewSettingsButton), {
            isSelected: isOpen,
            onClick: handleClick,
            ...props
        });
    const viewAsPopup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.Popup), {
        "data-testid": "software-view-settings.ui.popup",
        isOpen: isOpen,
        onClose: handleClose,
        placement: "bottom-end",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $B4KsE.ViewSettingsMenu), {
                view: view,
                viewAs: (0, $c3qrZ.ViewAs).POPUP,
                boardId: boardId,
                isClassic: isClassic,
                showFilterBarToggle: showFilterBarToggle,
                showEpicAsPanel: showEpicAsPanel,
                epicCustomName: epicCustomName,
                showCardDetails: showCardDetails,
                isWorkSuggestionsEnabled: isWorkSuggestionsEnabled,
                showWorkSuggestions: showWorkSuggestions,
                isVersionsEnabled: isVersionsEnabled,
                areSubtasksEnabled: areSubtasksEnabled,
                onSubtasksExpandAll: onSubtasksExpandAll,
                onSubtasksCollapseAll: onSubtasksCollapseAll,
                areAllSubtasksExpanded: areAllSubtasksExpanded,
                areAllSubtasksCollapsed: areAllSubtasksCollapsed,
                isSwimlanesEnabled: isSwimlanesEnabled,
                onSwimlaneExpandAll: onSwimlaneExpandAll,
                onSwimlaneCollapseAll: onSwimlaneCollapseAll,
                onToggleWorkSuggestions: onToggleWorkSuggestions,
                showLinkedIssueStatsToggle: showLinkedIssueStatsToggle,
                onLinkedIssuesStatsToggledOn: onLinkedIssuesStatsToggledOn
            }),
        trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                ref: ref
            }, conditionallyRenderViewSettingsButtonWithAria({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup
            }))
    });
    const viewAsPanel = isViewPanelOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: panelRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aZMX1.Panel), {
        title: formatMessage((0, $4lQWc.default).panelTitle),
        onClose: handleViewPanelClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $B4KsE.ViewSettingsMenu), {
        view: view,
        viewAs: (0, $c3qrZ.ViewAs).PANEL,
        boardId: boardId,
        isClassic: isClassic,
        showFilterBarToggle: showFilterBarToggle,
        showEpicAsPanel: showEpicAsPanel,
        epicCustomName: epicCustomName,
        showCardDetails: showCardDetails,
        isVersionsEnabled: isVersionsEnabled,
        isWorkSuggestionsEnabled: isWorkSuggestionsEnabled,
        showWorkSuggestions: showWorkSuggestions,
        areSubtasksEnabled: areSubtasksEnabled,
        onSubtasksExpandAll: onSubtasksExpandAll,
        onSubtasksCollapseAll: onSubtasksCollapseAll,
        areAllSubtasksExpanded: areAllSubtasksExpanded,
        areAllSubtasksCollapsed: areAllSubtasksCollapsed,
        isSwimlanesEnabled: isSwimlanesEnabled,
        onSwimlaneExpandAll: onSwimlaneExpandAll,
        onSwimlaneCollapseAll: onSwimlaneCollapseAll,
        onToggleWorkSuggestions: onToggleWorkSuggestions,
        isDaysInColumnEnabled: isDaysInColumnEnabled,
        showLinkedIssueStatsToggle: showLinkedIssueStatsToggle,
        cardExtraFields: cardExtraFields,
        isEstimateEnabled: isEstimateEnabled,
        isDueDateEnabled: isDueDateEnabled,
        isLabelsEnabled: isLabelsEnabled,
        isPriorityEnabled: isPriorityEnabled,
        onLinkedIssuesStatsToggledOn: onLinkedIssuesStatsToggledOn
    })));
    (0, $dzGPJ.useOnBacklog)(boardId, view, showEpicAsPanel, isVersionsEnabled);
    (0, $2pNxZ.useSyncFromLocalStorage)(boardId, view, cardExtraFields, isDaysInColumnEnabled, isDueDateEnabled, isLabelsEnabled, isEstimateEnabled, isPriorityEnabled);
    (0, $jEMDE.useCardDetailsInitialState)(boardId, view, isDaysInColumnEnabled);
    // Initialise local storage for Increment Planning board
    (0, $6CkDr.useOnIncrementPlanningBoard)(boardId, view);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: viewAs === (0, $c3qrZ.ViewAs).PANEL ? 'viewSettingsPanel' : 'viewSettingsMenu',
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8MrYx.ViewSettingsContainer), {
        view: view,
        isGlobal: true
    }, viewAs === (0, $c3qrZ.ViewAs).PANEL && (0, $6eyW6.isViewSettingsPanelAndTailoredViewExperimentEnabled)() ? viewAsPanel : viewAsPopup));
};
const $f31f9f5227f9d0e2$var$ViewSettingsWithErrorBoundary = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "errorBoundary",
        packageName: "jiraSoftwareViewSettings",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f31f9f5227f9d0e2$var$ViewSettings, props));
var $f31f9f5227f9d0e2$export$2e2bcd8739ae039 = $f31f9f5227f9d0e2$var$ViewSettingsWithErrorBoundary;

});
parcelRegister("erql0", function(module, exports) {

$parcel$export(module.exports, "NextBestTaskContainer", () => $8bb5be71a5e0cae3$export$d36ece0b77b25b77);
$parcel$export(module.exports, "useNextBestTaskContainer", () => $8bb5be71a5e0cae3$export$4e9c40fce9aa102);
$parcel$export(module.exports, "useNextBestTaskActions", () => $8bb5be71a5e0cae3$export$7f6f764b43177343);

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");
var $gasA1 = parcelRequire("gasA1");

var $aZaPn = parcelRequire("aZaPn");

var $1ybV0 = parcelRequire("1ybV0");

var $aVlZX = parcelRequire("aVlZX");

var $eA2tU = parcelRequire("eA2tU");
const $8bb5be71a5e0cae3$export$7dd0e8f7db9f5f6f = [];
// This is the value of the store on initialisation
const $8bb5be71a5e0cae3$var$initialState = {
    showBubble: false,
    sprints: $8bb5be71a5e0cae3$export$7dd0e8f7db9f5f6f,
    isAutoOpened: false,
    isNbtToggleButtonVisible: false,
    isOnlyCurrentUserSelected: false,
    isHiddenByUser: false,
    queryGithubOnboardingRef: null,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onIssueOpen: ()=>{},
    activeViewSettingsSpotlight: null,
    hasViewedViewSettingsSpotlight: undefined,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onViewSettingsSpotlightEnd: ()=>{},
    openViewSettings: null,
    viewSettingsTogglePulses: false
};
const $8bb5be71a5e0cae3$var$Store = (0, $a61MH.createStore)({
    initialState: $8bb5be71a5e0cae3$var$initialState,
    actions: $eA2tU.actions,
    name: 'jira.insights.next-best-task-store'
});
const $8bb5be71a5e0cae3$export$78c85c0bf5f7e99b = ()=>(0, $gasA1.defaultRegistry).deleteStore($8bb5be71a5e0cae3$var$Store);
const $8bb5be71a5e0cae3$var$handlePropsChange = ()=>({ setState: setState }, { accountId: accountId, boardId: boardId, isCMPBoard: isCMPBoard, sprints: sprints, onIssueOpen: onIssueOpen })=>{
        if ((0, $1ybV0.ff)('jira.insights.work-suggestions-on-boarding-spotlight-view-settings_dzjgq')) {
            const localStorageProvider = (0, $aZaPn.createLocalStorageProvider)((0, $aVlZX.WORK_SUGGESTIONS_VIEW_SETTINGS_ONBOARDING_NAMESPACE));
            const key = `spotlight-${accountId}`;
            const hasViewedViewSettingsSpotlight = localStorageProvider.get(key);
            setState({
                accountId: accountId,
                boardId: boardId,
                isCMPBoard: isCMPBoard,
                sprints: sprints,
                onIssueOpen: onIssueOpen,
                hasViewedViewSettingsSpotlight: hasViewedViewSettingsSpotlight,
                onViewSettingsSpotlightEnd: ()=>{
                    localStorageProvider.set(key, true);
                    setState({
                        hasViewedViewSettingsSpotlight: true,
                        activeViewSettingsSpotlight: null
                    });
                }
            });
        } else setState({
            accountId: accountId,
            boardId: boardId,
            isCMPBoard: isCMPBoard,
            sprints: sprints,
            onIssueOpen: onIssueOpen
        });
    };
const $8bb5be71a5e0cae3$export$e26874c6341f398 = (0, $ggKAj.createHook)($8bb5be71a5e0cae3$var$Store, {
    selector: (state)=>state.sprints || $8bb5be71a5e0cae3$export$7dd0e8f7db9f5f6f
});
const $8bb5be71a5e0cae3$export$d36ece0b77b25b77 = (0, $heB5U.createContainer)($8bb5be71a5e0cae3$var$Store, {
    onInit: $8bb5be71a5e0cae3$var$handlePropsChange,
    onUpdate: $8bb5be71a5e0cae3$var$handlePropsChange
});
const $8bb5be71a5e0cae3$export$4e9c40fce9aa102 = (0, $ggKAj.createHook)($8bb5be71a5e0cae3$var$Store);
const $8bb5be71a5e0cae3$export$7f6f764b43177343 = (0, $ggKAj.createActionsHook)($8bb5be71a5e0cae3$var$Store);

});
parcelRegister("aVlZX", function(module, exports) {

$parcel$export(module.exports, "NBT_TASK_TYPES", () => $8e71f53d81e4ea01$export$c57a079f40d2a99d);
$parcel$export(module.exports, "ITEMS_PER_BATCH", () => $8e71f53d81e4ea01$export$9e952e4d801fa8ed);
$parcel$export(module.exports, "NEXT_BEST_TASK_ANALYTICS", () => $8e71f53d81e4ea01$export$55230ca85072e545);
$parcel$export(module.exports, "ERROR_BOUNDARY_PACKAGE", () => $8e71f53d81e4ea01$export$e6c43e0cbc9a213a);
$parcel$export(module.exports, "PANEL_WIDTH_WITH_MARGIN", () => $8e71f53d81e4ea01$export$8603bff3dda8aaad);
$parcel$export(module.exports, "ANIMATION_TIMEOUT", () => $8e71f53d81e4ea01$export$fdd30d204cbe80e6);
$parcel$export(module.exports, "ARTICLE_ID", () => $8e71f53d81e4ea01$export$7147685613ef9998);
$parcel$export(module.exports, "DEV_DETAILS_DIALOG_SCOPE_ID", () => $8e71f53d81e4ea01$export$6bc465585d114926);
$parcel$export(module.exports, "DEV_DETAILS_DEPLOYMENT_PANEL_TYPE", () => $8e71f53d81e4ea01$export$5653d49c1e9688e9);
$parcel$export(module.exports, "DEV_DETAILS_BUILD_PANEL_TYPE", () => $8e71f53d81e4ea01$export$43925e5456315f);
$parcel$export(module.exports, "NEXT_BEST_TASK_PANEL_ISDISABLED_USERPROPERTY_KEY", () => $8e71f53d81e4ea01$export$d548086d4383c97c);
$parcel$export(module.exports, "NEXT_BEST_TASK_PANEL_LAST_OPENED_TASK_ID_USERPROPERTY_KEY", () => $8e71f53d81e4ea01$export$677d2c355966ef8d);
$parcel$export(module.exports, "NEXT_BEST_TASK_USER_PROPERTIES_SCOPE", () => $8e71f53d81e4ea01$export$ec5e18bceb05348c);
$parcel$export(module.exports, "NEXT_BEST_TASK_PANEL_ISDISABLED_STATE_UPDATE_DEBOUNCE_MS", () => $8e71f53d81e4ea01$export$429b3b48f84b2a13);
$parcel$export(module.exports, "TWO_WEEKS_IN_MS", () => $8e71f53d81e4ea01$export$6610ba860f2307cd);
$parcel$export(module.exports, "WORK_SUGGESTIONS_VIEW_SETTINGS_ONBOARDING_NAMESPACE", () => $8e71f53d81e4ea01$export$e638151250268e0c);
$parcel$export(module.exports, "WORK_SUGGESTIONS_VIEW_SETTINGS_SPOTLIGHT_PANEL_NAME", () => $8e71f53d81e4ea01$export$a038bf8f85264e8b);
$parcel$export(module.exports, "WORK_SUGGESTIONS_VIEW_SETTINGS_SPOTLIGHT_VIEW_SETTINGS_STEP_NAME", () => $8e71f53d81e4ea01$export$3a12d4773adf4b46);
$parcel$export(module.exports, "GITHUB_ONBOARDING_LOCAL_STORAGE_FINISHED_NAMESPACE", () => $8e71f53d81e4ea01$export$a95989662296427);
$parcel$export(module.exports, "GITHUB_ONBOARDING_FINISHED_LOCAL_STORAGE_TTL_IN_MS", () => $8e71f53d81e4ea01$export$4a742eb709905e27);
$parcel$export(module.exports, "WORK_SUGGESTIONS_SPOTLIGHT_MESSAGE_ID", () => $8e71f53d81e4ea01$export$7d212d7793dfc186);


const $8e71f53d81e4ea01$export$8b57ff3b8c315540 = {
    PULL_REQUEST_REVIEW: 'PR_REVIEW',
    PULL_REQUEST_NEEDS_WORK: 'PR_NEEDS_WORK',
    FAILED_DEPLOYMENT: 'DEPLOYMENT_FAILED',
    FAILED_BUILD: 'BUILD_FAILED',
    CRIT_VULN: 'CRIT_VULN',
    BLOCKING_ISSUE: 'BLOCKING_ISSUE'
};
const $8e71f53d81e4ea01$export$c57a079f40d2a99d = {
    InsightsBuildTask: 'BUILD_FAILED',
    InsightsDeploymentTask: 'DEPLOYMENT_FAILED',
    InsightsPullRequestReviewTask: 'PR_REVIEW',
    InsightsPullRequestNeedsWorkTask: 'PR_NEEDS_WORK',
    InsightsCriticalVulnerabilityTask: 'CRIT_VULN',
    InsightsBlockingIssueTask: 'BLOCKING_ISSUE'
};
const $8e71f53d81e4ea01$export$206ba94a466bfde8 = {
    REPO: 'repo',
    APPROVALS: 'approvals',
    COMMENT: 'comment',
    ISSUEKEY: 'issuekey',
    ENVIRONMENT: 'environment',
    UPDATED: 'updated',
    SECURITY_CONTAINER_NAME: 'securityContainerName',
    STATUS: 'status',
    TITLE: 'title',
    INTRODUCED_DATE: 'introducedDate'
};
const $8e71f53d81e4ea01$export$b8b9d90f9e5bd72b = 'jiraInsightsNextBestTask';
const $8e71f53d81e4ea01$export$9e952e4d801fa8ed = 3;
const $8e71f53d81e4ea01$export$b3f5ac625a3b4df0 = 'nextBestTask';
const $8e71f53d81e4ea01$export$55230ca85072e545 = `${(0, $3523ef16f82a4788$export$d3996f57ffa8448f)}.${$8e71f53d81e4ea01$export$b3f5ac625a3b4df0}`;
const $8e71f53d81e4ea01$export$a03b7ee31a7850cc = {
    ACTION_SUBJECT: `${(0, $3523ef16f82a4788$export$d3996f57ffa8448f)}`,
    ACTION_SUBJECT_ID: `${$8e71f53d81e4ea01$export$b3f5ac625a3b4df0}`
};
const $8e71f53d81e4ea01$export$8dfcc2329f051083 = `${(0, $3523ef16f82a4788$export$d3996f57ffa8448f)}.next-best-task`;
const $8e71f53d81e4ea01$export$e6c43e0cbc9a213a = $8e71f53d81e4ea01$export$8dfcc2329f051083;
const $8e71f53d81e4ea01$export$e05cfff20e9274e6 = 272;
const $8e71f53d81e4ea01$export$91fd62fa237e57ae = 450;
const $8e71f53d81e4ea01$export$8603bff3dda8aaad = $8e71f53d81e4ea01$export$e05cfff20e9274e6 + 2;
const $8e71f53d81e4ea01$export$ea74a331a4211d3f = 49; // extra 1px for top border
const $8e71f53d81e4ea01$export$c33dba4345ee2db8 = $8e71f53d81e4ea01$export$ea74a331a4211d3f;
const $8e71f53d81e4ea01$export$fdd30d204cbe80e6 = 600;
const $8e71f53d81e4ea01$export$7147685613ef9998 = '2HtqtVTfYoilHIuYJIGD1T';
const $8e71f53d81e4ea01$export$6bc465585d114926 = 'jira-insights-next-best-task';
const $8e71f53d81e4ea01$export$5653d49c1e9688e9 = (0, $14a090e212ebf7a4$export$90cac6260ae9ced5);
const $8e71f53d81e4ea01$export$43925e5456315f = (0, $14a090e212ebf7a4$export$74a388a09f2a004e);
const $8e71f53d81e4ea01$export$d548086d4383c97c = 'jira.insights.next-best-task-panel.isdisabled';
const $8e71f53d81e4ea01$export$677d2c355966ef8d = 'jira.insights.next-best-task.last-opened-task-ids';
const $8e71f53d81e4ea01$export$ec5e18bceb05348c = 'jira.insights.next-best-task.user-properties';
const $8e71f53d81e4ea01$export$429b3b48f84b2a13 = 300;
const $8e71f53d81e4ea01$export$8217db641c4c0a89 = 86400000;
const $8e71f53d81e4ea01$export$6610ba860f2307cd = 14 * $8e71f53d81e4ea01$export$8217db641c4c0a89;
const $8e71f53d81e4ea01$export$b504dbc209245786 = 180 * $8e71f53d81e4ea01$export$8217db641c4c0a89;
const $8e71f53d81e4ea01$export$75cf347d8d9fe592 = 'jira-insights-next-best-task';
const $8e71f53d81e4ea01$export$b94951a11282ae6a = 'work-suggestions-github-onboarding-hidden';
const $8e71f53d81e4ea01$export$e638151250268e0c = 'work-suggestions-view-settings-onboarding-viewed';
const $8e71f53d81e4ea01$export$a038bf8f85264e8b = 'workSuggestionsViewSettingsSpotlightPanel';
const $8e71f53d81e4ea01$export$3a12d4773adf4b46 = 'workSuggestionsViewSettingsSpotlightViewSettings';
const $8e71f53d81e4ea01$export$a95989662296427 = 'work-suggestions-github-onboarding-finished';
const $8e71f53d81e4ea01$export$4a742eb709905e27 = 259200000; // 3 days
const $8e71f53d81e4ea01$export$7d212d7793dfc186 = 'jira-work-suggestions-spotlight';

});
const $14a090e212ebf7a4$export$e18d81f044132a0e = 'branch';
const $14a090e212ebf7a4$export$74a388a09f2a004e = 'build';
const $14a090e212ebf7a4$export$2e42513c7764d5f3 = 'repository';
const $14a090e212ebf7a4$export$3f1e2b276d607490 = 'review';
const $14a090e212ebf7a4$export$90cac6260ae9ced5 = 'deployment-environment';
const $14a090e212ebf7a4$export$6f74b53d652f13f3 = 'pullrequest';
const $14a090e212ebf7a4$export$c69477f358d30f7e = 'feature-flags';
const $14a090e212ebf7a4$export$56470bdd9cd798d0 = 'remote-links';
const $14a090e212ebf7a4$export$3da53566eda5eeef = 'jira.fe.issue.dev-details.time-to.load';
const $14a090e212ebf7a4$export$b4bb784d069c9ab = 'development.details.details-header';
const $14a090e212ebf7a4$export$74189cec821240a6 = 'development.details.remote-links';

const $3523ef16f82a4788$export$d3996f57ffa8448f = 'jira.insights';
const $3523ef16f82a4788$export$c9290acd1ba498ff = `${$3523ef16f82a4788$export$d3996f57ffa8448f}.board`;
const $3523ef16f82a4788$export$2fd6d7f902b01d67 = `${$3523ef16f82a4788$export$d3996f57ffa8448f}.backlog`;
const $3523ef16f82a4788$export$8e66b21ec141a0bd = `${$3523ef16f82a4788$export$d3996f57ffa8448f}.board-simplified`;
const $3523ef16f82a4788$export$75eb9639a5b0ba25 = `${$3523ef16f82a4788$export$d3996f57ffa8448f}.backlog-simplified`;
const $3523ef16f82a4788$export$1269ea4f2b198811 = `${$3523ef16f82a4788$export$d3996f57ffa8448f}.error-boundary`;


parcelRegister("eA2tU", function(module, exports) {

$parcel$export(module.exports, "actions", () => $5dd7962e3a57583d$export$e324594224ef24da);

var $1ybV0 = parcelRequire("1ybV0");
const $5dd7962e3a57583d$export$e324594224ef24da = {
    setIsAutoOpened: (isAutoOpened)=>({ setState: setState })=>{
            setState({
                isAutoOpened: isAutoOpened
            });
        },
    setIsNbtToggleButtonVisible: (isNbtToggleButtonVisible)=>({ setState: setState })=>{
            setState({
                isNbtToggleButtonVisible: isNbtToggleButtonVisible
            });
        },
    setIsOnlyCurrentUserSelected: (isOnlyCurrentUserSelected)=>({ setState: setState })=>{
            if ((0, $1ybV0.ff)('jira.work-suggestions.remove-nbt-button') && !isOnlyCurrentUserSelected) setState({
                isOnlyCurrentUserSelected: isOnlyCurrentUserSelected,
                isAutoOpened: false,
                isHiddenByUser: false
            });
            else setState({
                isOnlyCurrentUserSelected: isOnlyCurrentUserSelected
            });
        },
    setShowBubbleNotification: (showBubble)=>({ setState: setState })=>{
            setState({
                showBubble: showBubble
            });
        },
    setQueryGithubOnboardingRef: (queryGithubOnboardingRef)=>({ getState: getState, setState: setState })=>{
            if (getState().queryGithubOnboardingRef == null) setState({
                queryGithubOnboardingRef: queryGithubOnboardingRef
            });
        },
    onViewSettingsSpotlightStart: ()=>({ setState: setState })=>{
            setState({
                activeViewSettingsSpotlight: 0
            });
        },
    onViewSettingsSpotlightNext: ()=>({ setState: setState })=>{
            setState({
                activeViewSettingsSpotlight: 1
            });
        },
    setOpenViewSettings: (openViewSettingsCallback)=>({ getState: getState, setState: setState })=>{
            if (!getState().openViewSettings) setState({
                openViewSettings: openViewSettingsCallback
            });
        },
    setViewSettingsTogglePulses: (viewSettingsTogglePulses)=>({ setState: setState })=>{
            setState({
                viewSettingsTogglePulses: viewSettingsTogglePulses
            });
        },
    setIsHiddenByUser: (isHiddenByUser)=>({ setState: setState })=>{
            setState({
                isHiddenByUser: isHiddenByUser
            });
        }
};

});


parcelRegister("kS8l2", function(module, exports) {

$parcel$export(module.exports, "useGlobalRef", () => $450c796f66462b96$export$361e4f658203e95);
$parcel$export(module.exports, "useGlobalRefStoreActions", () => $450c796f66462b96$export$3c6c6911d09d7d8a);
$parcel$export(module.exports, "withGlobalRef", () => $450c796f66462b96$export$6b4b878b04fd3017);

var $eUqFw = parcelRequire("eUqFw");

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $450c796f66462b96$var$store = (0, $a61MH.createStore)({
    initialState: {},
    actions: {
        register: (key, ref)=>({ setState: setState })=>{
                setState({
                    [key]: ref || undefined
                });
            }
    },
    name: 'refs-store'
});
const $450c796f66462b96$export$4beaa3baa53198e4 = (0, $heB5U.createContainer)($450c796f66462b96$var$store);
const $450c796f66462b96$var$useGlobalRefStateSelector = (0, $ggKAj.createStateHook)($450c796f66462b96$var$store, {
    selector: (state, key)=>state[key]
});
const $450c796f66462b96$export$361e4f658203e95 = (key)=>[
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        $450c796f66462b96$var$useGlobalRefStateSelector(key)
    ];
const $450c796f66462b96$export$3c6c6911d09d7d8a = (0, $ggKAj.createHook)($450c796f66462b96$var$store, {
    selector: null
});
const $450c796f66462b96$export$6b4b878b04fd3017 = (propName, refName)=>(Component)=>(props)=>{
            const [ref] = $450c796f66462b96$export$361e4f658203e95(refName);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
                ...props,
                [propName]: ref
            });
        };

});

parcelRegister("l3HJG", function(module, exports) {

$parcel$export(module.exports, "ActionSubject", () => $954a120c5bdda4a2$export$7f97440769de1377);
$parcel$export(module.exports, "AnalyticsEvent", () => $954a120c5bdda4a2$export$30b7662faa307ee);
$parcel$export(module.exports, "ToggleKey", () => $954a120c5bdda4a2$export$3679582258ad0fad);
const $954a120c5bdda4a2$export$7f97440769de1377 = {
    BUTTON: 'button',
    TOGGLE: 'toggle'
};
const $954a120c5bdda4a2$export$30b7662faa307ee = {
    UI_EVENT: 'UI_EVENT',
    OPERATIONAL_EVENT: 'OPERATIONAL_EVENT',
    TRACK_EVENT: 'TRACK_EVENT'
};
const $954a120c5bdda4a2$export$3679582258ad0fad = {
    VERSION_PANEL_TOGGLE: 'versionPanel',
    EPIC_PANEL_TOGGLE: 'epicPanel',
    QUICK_FILTERS_TOGGLE: 'quickFilters',
    COMPACT_MODE_TOGGLE: 'compactMode',
    CARD_DENSITY: 'cardDensity',
    SHOW_VERSIONS_TOGGLE: 'showVersions',
    SHOW_EPICS_TOGGLE: 'showEpics',
    SHOW_STATUSES_TOGGLE: 'showStatuses',
    SHOW_ISSUE_TYPE: 'showIssueType',
    SHOW_ISSUE_KEY: 'showIssueKey',
    SHOW_ESTIMATE: 'showEstimate',
    SHOW_PRIORITY: 'showPriority',
    SHOW_ASSIGNEE: 'showAssignee',
    SHOW_ISSUE_LINKS_STATS: 'showIssueLinksStats',
    OPEN_ISSUES_IN_SIDEBAR_TOGGLE: 'openIssuesInSidebar',
    SUBTASKS_EXPAND_ALL: 'subtasksExpandAll',
    SUBTASKS_COLLAPSE_ALL: 'subtasksCollapseAll',
    SWIMLANE_EXPAND_ALL: 'swimlaneExpandAll',
    SWIMLANE_COLLAPSE_ALL: 'swimlaneCollapseAll',
    UNSCHEDULED_COLUMN_TOGGLE: 'unscheduledColumnToggle',
    SHOW_DAYS_IN_COLUMN: 'showDaysInColumn',
    SHOW_DUE_DATE: 'showDueDate',
    SHOW_LABELS: 'showLabels',
    SHOW_EXTRA_FIELD: 'showExtraField',
    WORK_SUGGESTIONS_TOGGLE: 'workSuggestions',
    SHOW_CARD_COVERS: 'showCardCovers'
};

});

parcelRegister("aZMX1", function(module, exports) {

$parcel$export(module.exports, "Panel", () => $daffa5e9be03fc44$export$2ddb90ad54e5f587);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $jWuk1 = parcelRequire("jWuk1");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $4Ywu9 = parcelRequire("4Ywu9");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jyKDT = parcelRequire("jyKDT");

var $9zeZf = parcelRequire("9zeZf");
const $daffa5e9be03fc44$export$2ddb90ad54e5f587 = ({ title: title = '', onClose: onClose = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), children: children })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $daffa5e9be03fc44$var$panelStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        grow: "fill",
        spread: "space-between",
        xcss: $daffa5e9be03fc44$var$headerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "medium",
        as: "h2"
    }, title || formatMessage((0, $9zeZf.default).defaultTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $daffa5e9be03fc44$var$ButtonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        spacing: "none",
        onClick: onClose,
        testId: (0, $jyKDT.VIEW_SETTINGS_PANEL_CLOSE_BUTTON_TEST_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $daffa5e9be03fc44$var$IconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
        label: formatMessage((0, $9zeZf.default).closeButtonLabel)
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), null, children)));
};
const $daffa5e9be03fc44$var$headerStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.100'
});
const $daffa5e9be03fc44$var$panelStyles = (0, $1ZAYh.xcss)({
    border: `1px solid ${"var(--ds-border, #091E42)"}`,
    borderRadius: 'border.radius.200',
    width: '280px',
    padding: 'space.300',
    [(0, $4Ywu9.media).above.lg]: {
        width: '300px'
    }
});
const $daffa5e9be03fc44$var$ButtonWrapperStyles = (0, $1ZAYh.xcss)({
    width: "var(--ds-space-400, 32px)",
    height: "var(--ds-space-400, 32px)"
});
const $daffa5e9be03fc44$var$IconWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: "var(--ds-space-400, 32px)",
    height: "var(--ds-space-400, 32px)"
});

});
parcelRegister("9zeZf", function(module, exports) {

$parcel$export(module.exports, "default", () => $f19bacb6ede721b3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f19bacb6ede721b3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    defaultTitle: {
        "id": "software-view-settings.common.panel.default-title",
        "defaultMessage": "View settings"
    },
    closeButtonLabel: {
        "id": "software-view-settings.common.panel.close-button-label",
        "defaultMessage": "Close"
    }
});

});


parcelRegister("8TRqG", function(module, exports) {

$parcel$export(module.exports, "useSendAnalyticsEvent", () => $e0ccf9ae91f2d2fd$export$4b1735907ca3ab2f);

var $3FyZ4 = parcelRequire("3FyZ4");

var $l3HJG = parcelRequire("l3HJG");
const $e0ccf9ae91f2d2fd$export$7d2f3f483d8e6742 = 'viewSettings';
const $e0ccf9ae91f2d2fd$export$4b1735907ca3ab2f = ()=>{
    const sendAnalyticsEvent = (action, actionSubject, eventType, attributes = {}, source)=>{
        (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
            const analyticsClient = client.getInstance();
            if (!analyticsClient) return Promise.resolve();
            const event = {
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: $e0ccf9ae91f2d2fd$export$7d2f3f483d8e6742,
                attributes: {
                    ...attributes
                },
                source: source
            };
            switch(eventType){
                case (0, $l3HJG.AnalyticsEvent).UI_EVENT:
                    return analyticsClient.sendUIEvent(event);
                case (0, $l3HJG.AnalyticsEvent).OPERATIONAL_EVENT:
                    return analyticsClient.sendOperationalEvent(event);
                case (0, $l3HJG.AnalyticsEvent).TRACK_EVENT:
                    return analyticsClient.sendTrackEvent(event);
                default:
            }
            return undefined;
        });
    };
    return sendAnalyticsEvent;
};

});

parcelRegister("jEMDE", function(module, exports) {

$parcel$export(module.exports, "useCardDetailsInitialState", () => $3b1f02b5db7c3070$export$2e9f932053c78b66);

var $eUqFw = parcelRequire("eUqFw");

var $kFGm5 = parcelRequire("kFGm5");

var $kJlBc = parcelRequire("kJlBc");

var $jyKDT = parcelRequire("jyKDT");

var $3kYjh = parcelRequire("3kYjh");

var $6eyW6 = parcelRequire("6eyW6");

var $cNacc = parcelRequire("cNacc");

var $8MrYx = parcelRequire("8MrYx");
const $3b1f02b5db7c3070$export$428c87746d3e32da = {
    [(0, $3kYjh.ViewSetting).SHOW_EPICS]: 'showEpics',
    [(0, $3kYjh.ViewSetting).SHOW_STATUSES]: 'showStatuses',
    [(0, $3kYjh.ViewSetting).SHOW_VERSIONS]: 'showVersions',
    [(0, $3kYjh.ViewSetting).SHOW_ASSIGNEE]: 'showAssignee',
    [(0, $3kYjh.ViewSetting).SHOW_DAYS_IN_COLUMN]: 'showDaysInColumn',
    [(0, $3kYjh.ViewSetting).SHOW_ESTIMATE]: 'showEstimate',
    [(0, $3kYjh.ViewSetting).SHOW_ISSUE_KEY]: 'showIssueKey',
    [(0, $3kYjh.ViewSetting).SHOW_ISSUE_LINKS_STATS]: 'showIssueLinksStats',
    [(0, $3kYjh.ViewSetting).SHOW_DUE_DATE]: 'showDueDate',
    [(0, $3kYjh.ViewSetting).SHOW_ISSUE_TYPE]: 'showIssueType',
    [(0, $3kYjh.ViewSetting).SHOW_PRIORITY]: 'showPriority',
    [(0, $3kYjh.ViewSetting).SHOW_LABELS]: 'showLabels',
    [(0, $3kYjh.ViewSetting).SHOW_CARD_COVERS]: 'showCardCovers'
};
const $3b1f02b5db7c3070$export$2e9f932053c78b66 = (boardId, view, isDaysInColumnEnabled)=>{
    const [{ location: location, query: query }, { replace: replace }] = (0, $kJlBc.useRouter)();
    const { setViewSettingsCardDetails: setViewSettingsCardDetails } = (0, $8MrYx.useViewSettingsActions)();
    (0, $eUqFw.useEffect)(()=>{
        if (!(0, $6eyW6.isViewSettingsPanelAndTailoredViewExperimentEnabled)() || !query) return;
        const cardDetailsFromLocalStorage = (0, $cNacc.getViewSettingsCardDetails)({
            boardId: boardId,
            view: view,
            isDaysInColumnEnabled: isDaysInColumnEnabled
        });
        const getInitialCardValue = (stateKey)=>{
            const queryKey = $3b1f02b5db7c3070$export$428c87746d3e32da[stateKey];
            return query[queryKey] ? query[queryKey] === (0, $jyKDT.QUERY_ENABLED_VALUE) : cardDetailsFromLocalStorage[stateKey];
        };
        const cardDetailsState = {
            [(0, $3kYjh.ViewSetting).SHOW_EPICS]: getInitialCardValue((0, $3kYjh.ViewSetting).SHOW_EPICS),
            [(0, $3kYjh.ViewSetting).SHOW_STATUSES]: getInitialCardValue((0, $3kYjh.ViewSetting).SHOW_STATUSES),
            [(0, $3kYjh.ViewSetting).SHOW_VERSIONS]: getInitialCardValue((0, $3kYjh.ViewSetting).SHOW_VERSIONS),
            [(0, $3kYjh.ViewSetting).SHOW_ASSIGNEE]: getInitialCardValue((0, $3kYjh.ViewSetting).SHOW_ASSIGNEE),
            [(0, $3kYjh.ViewSetting).SHOW_DAYS_IN_COLUMN]: getInitialCardValue((0, $3kYjh.ViewSetting).SHOW_DAYS_IN_COLUMN),
            [(0, $3kYjh.ViewSetting).SHOW_ESTIMATE]: getInitialCardValue((0, $3kYjh.ViewSetting).SHOW_ESTIMATE),
            [(0, $3kYjh.ViewSetting).SHOW_ISSUE_KEY]: getInitialCardValue((0, $3kYjh.ViewSetting).SHOW_ISSUE_KEY),
            [(0, $3kYjh.ViewSetting).SHOW_ISSUE_LINKS_STATS]: getInitialCardValue((0, $3kYjh.ViewSetting).SHOW_ISSUE_LINKS_STATS),
            [(0, $3kYjh.ViewSetting).SHOW_ISSUE_TYPE]: getInitialCardValue((0, $3kYjh.ViewSetting).SHOW_ISSUE_TYPE),
            [(0, $3kYjh.ViewSetting).SHOW_PRIORITY]: getInitialCardValue((0, $3kYjh.ViewSetting).SHOW_PRIORITY),
            [(0, $3kYjh.ViewSetting).SHOW_DUE_DATE]: getInitialCardValue((0, $3kYjh.ViewSetting).SHOW_DUE_DATE),
            [(0, $3kYjh.ViewSetting).SHOW_LABELS]: getInitialCardValue((0, $3kYjh.ViewSetting).SHOW_LABELS),
            [(0, $3kYjh.ViewSetting).SHOW_CARD_COVERS]: getInitialCardValue((0, $3kYjh.ViewSetting).SHOW_CARD_COVERS)
        };
        setViewSettingsCardDetails({
            boardId: boardId,
            view: view,
            cardDetailsState: cardDetailsState
        });
        // remove card view initial settings param
        replace({
            ...location,
            search: new URLSearchParams((0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(query, Object.values($3b1f02b5db7c3070$export$428c87746d3e32da))).toString()
        });
    // we want to run this hook on initial render only
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

});

parcelRegister("dzGPJ", function(module, exports) {

$parcel$export(module.exports, "useOnBacklog", () => $6f3c63f936ec699c$export$9c6bcc9d56a57470);

var $eUqFw = parcelRequire("eUqFw");

var $kJlBc = parcelRequire("kJlBc");

var $c3qrZ = parcelRequire("c3qrZ");

var $6eyW6 = parcelRequire("6eyW6");

var $cNacc = parcelRequire("cNacc");

var $8MrYx = parcelRequire("8MrYx");
const $6f3c63f936ec699c$export$9c6bcc9d56a57470 = (boardId, view, showEpicAsPanel = false, isVersionsEnabled = false)=>{
    const [{ location: location }] = (0, $kJlBc.useRouter)();
    const showPanels = (0, $8MrYx.useShowPanels)();
    const { setViewSettingsPanels: setViewSettingsPanels } = (0, $8MrYx.useViewSettingsActions)();
    const { replace: replace } = (0, $kJlBc.useRouterActions)();
    // Sync react-sweet-state store with URL or localStorage state on mount.
    (0, $eUqFw.useEffect)(()=>{
        if (view !== (0, $c3qrZ.View).BACKLOG) return;
        const panelsFromQuery = (0, $6eyW6.parseSearchQuery)(location.search);
        const panelsFromLocalStorage = (0, $cNacc.getViewSettingsPanels)({
            boardId: boardId,
            view: view
        });
        // Search query state takes precedence over localStorage state, which supersedes react-sweet-state state.
        // If there are panels from the search query, update localStorage and react-sweet-state.
        // If not, update react-sweet-state using localStorage instead.
        let panelState = panelsFromLocalStorage;
        if (Object.values(panelsFromQuery).filter(Boolean).length !== 0) {
            const queryPanelState = {
                EPIC_PANEL: panelsFromQuery.EPIC_PANEL ?? false,
                VERSION_PANEL: panelsFromQuery.VERSION_PANEL ?? false
            };
            panelState = queryPanelState;
        }
        setViewSettingsPanels({
            boardId: boardId,
            view: view,
            panelState: panelState
        });
    // Removed `location.search` from the dependency array since we only want this hook to fire once (on mount).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        boardId,
        isVersionsEnabled,
        setViewSettingsPanels,
        showEpicAsPanel,
        view
    ]);
    // Sync URL with react-sweet-state store on mount and when react-sweet-state store changes.
    (0, $eUqFw.useEffect)(()=>{
        if (view !== (0, $c3qrZ.View).BACKLOG) return;
        const url = (0, $6eyW6.setPanels)(showPanels, location);
        if (location.search !== `?${url.search}`) replace(url);
    // `Location` has a `hash` attribute which causes unnecessary calls, so we are only using `search` in the dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        location.search,
        showPanels,
        replace,
        view
    ]);
};

});

parcelRegister("6CkDr", function(module, exports) {

$parcel$export(module.exports, "useOnIncrementPlanningBoard", () => $d6217f1ca1af251e$export$14539b3beca7ada3);

var $eUqFw = parcelRequire("eUqFw");

var $kJlBc = parcelRequire("kJlBc");

var $c3qrZ = parcelRequire("c3qrZ");

var $6eyW6 = parcelRequire("6eyW6");

var $cNacc = parcelRequire("cNacc");

var $8MrYx = parcelRequire("8MrYx");
const $d6217f1ca1af251e$export$14539b3beca7ada3 = (boardId, view)=>{
    const { setShowUnscheduledColumn: setShowUnscheduledColumn } = (0, $8MrYx.useViewSettingsActions)();
    const [{ location: location }] = (0, $kJlBc.useRouter)();
    const { replace: replace } = (0, $kJlBc.useRouterActions)();
    const isUnscheduledColumnVisible = (0, $8MrYx.useShowUnscheduledColumn)();
    (0, $eUqFw.useEffect)(()=>{
        if (view !== (0, $c3qrZ.View).INCREMENT_PLANNING_BOARD) return;
        const settingsFromLocalStorage = (0, $cNacc.getShowUnscheduledColumn)(boardId);
        const settingsFromQuery = (0, $6eyW6.parseSearchQueryForIPBoard)(location.search);
        // Search query state takes precedence over localStorage state, which supersedes react-sweet-state state.
        // If there are IP board settings from the search query, update localStorage and react-sweet-state.
        // If not, update react-sweet-state using localStorage instead.
        const showUnscheduledColumn = settingsFromQuery.SHOW_UNSCHEDULED_COLUMN !== undefined ? settingsFromQuery.SHOW_UNSCHEDULED_COLUMN : settingsFromLocalStorage;
        setShowUnscheduledColumn(boardId, showUnscheduledColumn);
    }, [
        boardId,
        view,
        location.search,
        setShowUnscheduledColumn
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (view !== (0, $c3qrZ.View).INCREMENT_PLANNING_BOARD) return;
        const url = (0, $6eyW6.setIncrementPlanningSettings)({
            SHOW_UNSCHEDULED_COLUMN: isUnscheduledColumnVisible
        }, location);
        if (location.search !== `?${url.search}`) replace(url);
    // `Location` has a `hash` attribute which causes unnecessary calls, so we are only using `search` in the dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        boardId,
        view,
        isUnscheduledColumnVisible,
        location.search,
        replace
    ]);
};

});

parcelRegister("2pNxZ", function(module, exports) {

$parcel$export(module.exports, "useSyncFromLocalStorage", () => $1b9189c8560b9757$export$88f2270d613c342b);

var $eUqFw = parcelRequire("eUqFw");

var $6eyW6 = parcelRequire("6eyW6");

var $cNacc = parcelRequire("cNacc");

var $8MrYx = parcelRequire("8MrYx");
const $1b9189c8560b9757$export$88f2270d613c342b = (boardId, view, cardExtraFields, isDaysInColumnEnabled, isDueDateEnabled, isLabelsEnabled, isEstimateEnabled, isPriorityEnabled)=>{
    const { setIsFullscreen: setIsFullscreen, setViewSettingsCardDetails: setViewSettingsCardDetails, setViewSettingsQuickFilters: setViewSettingsQuickFilters, setViewSettingsCompactMode: setViewSettingsCompactMode, setViewSettingsCardExtraFields: setViewSettingsCardExtraFields } = (0, $8MrYx.useViewSettingsActions)();
    (0, $eUqFw.useEffect)(()=>{
        // card details initial state moved to `useCardDetailsInitialState`
        if (!(0, $6eyW6.isViewSettingsPanelAndTailoredViewExperimentEnabled)()) {
            const cardDetailsFromLocalStorage = (0, $cNacc.getViewSettingsCardDetails)({
                boardId: boardId,
                view: view,
                isDaysInColumnEnabled: isDaysInColumnEnabled,
                isDueDateEnabled: isDueDateEnabled,
                isLabelsEnabled: isLabelsEnabled,
                isEstimateEnabled: isEstimateEnabled,
                isPriorityEnabled: isPriorityEnabled
            });
            setViewSettingsCardDetails({
                boardId: boardId,
                cardDetailsState: cardDetailsFromLocalStorage,
                view: view
            });
        }
        const quickFiltersFromLocalStorage = (0, $cNacc.getViewSettingsQuickFilters)({
            boardId: boardId,
            view: view
        });
        setViewSettingsQuickFilters({
            boardId: boardId,
            view: view,
            showQuickFilters: quickFiltersFromLocalStorage
        });
        const compactModeFromLocalStorage = (0, $cNacc.getViewSettingsCompactMode)({
            boardId: boardId,
            view: view
        });
        setViewSettingsCompactMode({
            boardId: boardId,
            view: view,
            showCompactMode: compactModeFromLocalStorage
        });
        const isFullscreenFromLocalStorage = (0, $cNacc.getViewSettingsIsFullscreen)({
            boardId: boardId,
            view: view
        });
        setIsFullscreen({
            boardId: boardId,
            isFullscreen: isFullscreenFromLocalStorage,
            view: view
        });
    }, [
        boardId,
        view,
        isDaysInColumnEnabled,
        isDueDateEnabled,
        isLabelsEnabled,
        isEstimateEnabled,
        isPriorityEnabled,
        setIsFullscreen,
        setViewSettingsCardDetails,
        setViewSettingsCompactMode,
        setViewSettingsQuickFilters,
        setViewSettingsCardExtraFields
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const cardExtraFieldsFromLocalStorage = (0, $cNacc.getViewSettingsCardExtraFields)({
            boardId: boardId,
            view: view,
            cardExtraFields: cardExtraFields
        });
        setViewSettingsCardExtraFields({
            boardId: boardId,
            cardExtraFieldsState: cardExtraFieldsFromLocalStorage,
            view: view
        });
    }, [
        boardId,
        view,
        cardExtraFields,
        setViewSettingsCardExtraFields
    ]);
};

});

parcelRegister("4lQWc", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab4b64fa3e1ecbaa$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ab4b64fa3e1ecbaa$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    panelTitle: {
        "id": "software-view-settings.panel-title",
        "defaultMessage": "View settings"
    }
});

});

parcelRegister("27GCD", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsSyncFromLocalStorageWrapper", () => $0412336062545bea$export$8c976c7ba46200ff);
$parcel$export(module.exports, "ViewSettingsButton", () => $0412336062545bea$export$805802ea39f3d804);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7u4fN = parcelRequire("7u4fN");

var $fUQgT = parcelRequire("fUQgT");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5ARvW = parcelRequire("5ARvW");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $1ybV0 = parcelRequire("1ybV0");

var $erql0 = parcelRequire("erql0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kS8l2 = parcelRequire("kS8l2");

var $eDgaT = parcelRequire("eDgaT");

var $jyKDT = parcelRequire("jyKDT");

var $jEMDE = parcelRequire("jEMDE");

var $dzGPJ = parcelRequire("dzGPJ");

var $2pNxZ = parcelRequire("2pNxZ");

var $9bm3X = parcelRequire("9bm3X");
const $0412336062545bea$export$8c976c7ba46200ff = ({ boardId: boardId, view: view, cardExtraFields: cardExtraFields = [], isDaysInColumnEnabled: isDaysInColumnEnabled = false, isDueDateEnabled: isDueDateEnabled = false, isLabelsEnabled: isLabelsEnabled = false, isEstimateEnabled: isEstimateEnabled = false, children: children, showEpicAsPanel: showEpicAsPanel = false, isVersionsEnabled: isVersionsEnabled = false, isPriorityEnabled: isPriorityEnabled = false })=>{
    (0, $dzGPJ.useOnBacklog)(boardId, view, showEpicAsPanel, isVersionsEnabled);
    (0, $2pNxZ.useSyncFromLocalStorage)(boardId, view, cardExtraFields, isDaysInColumnEnabled, isDueDateEnabled, isLabelsEnabled, isEstimateEnabled, isPriorityEnabled);
    (0, $jEMDE.useCardDetailsInitialState)(boardId, view, isDaysInColumnEnabled);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};
const $0412336062545bea$export$805802ea39f3d804 = ({ isSelected: isSelected, onClick: onClick = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), removeMargins: removeMargins, ShowDI: ShowDI = (0, $5ARvW.Show), ...restProps })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(isSelected);
    const [, { register: register }] = (0, $kS8l2.useGlobalRefStoreActions)();
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'viewSettingsButton');
        setIsOpen(!isOpen);
        onClick(!isOpen);
    }, [
        createAnalyticsEvent,
        isOpen,
        onClick
    ]);
    const openViewSettings = (0, $eUqFw.useCallback)(()=>{
        if (!(0, $1ybV0.ff)('jira.insights.work-suggestions-on-boarding-spotlight-view-settings_dzjgq') && isOpen) return;
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'viewSettingsButton');
        setIsOpen(true);
        setTimeout(()=>onClick(true));
    }, [
        createAnalyticsEvent,
        onClick,
        isOpen
    ]);
    const { setOpenViewSettings: setOpenViewSettings } = (0, $erql0.useNextBestTaskActions)();
    (0, $eUqFw.useEffect)(()=>{
        if ((0, $1ybV0.ff)('jira.insights.work-suggestions-on-boarding-spotlight-view-settings_dzjgq') && setOpenViewSettings) setOpenViewSettings(openViewSettings);
    }, [
        openViewSettings,
        setOpenViewSettings
    ]);
    const onRefButtonLarge = (0, $eUqFw.useCallback)((ref)=>{
        register((0, $jyKDT.VIEW_SETTINGS_BUTTON_LG), ref);
    }, [
        register
    ]);
    const onRefButtonSmall = (0, $eUqFw.useCallback)((ref)=>{
        register((0, $jyKDT.VIEW_SETTINGS_BUTTON_SM), ref);
    }, [
        register
    ]);
    const onRefButtonResponsive = (0, $eUqFw.useCallback)((ref)=>{
        register((0, $jyKDT.VIEW_SETTINGS_BUTTON_RESPONSIVE), ref);
    }, [
        register
    ]);
    (0, $eUqFw.useEffect)(()=>{
        setIsOpen(isSelected);
    }, [
        isSelected
    ]);
    const iconColor = isSelected ? `var(--ds-icon-selected, ${(0, $PdmhA).B400})` : `var(--ds-icon, ${(0, $PdmhA).N300})`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $1ybV0.ff)('sea-2744-jsw-tabs-nav') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eDgaT.ResponsiveButton), {
        testId: "software-view-settings.ui.view-settings-button.responsive-button",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fUQgT))),
        label: formatMessage((0, $9bm3X.default).buttonLabel),
        isSelected: isOpen,
        onClick: handleClick,
        ref: onRefButtonResponsive,
        "aria-expanded": restProps.ariaExpanded ?? isSelected,
        "aria-controls": restProps.ariaControls,
        "aria-haspopup": restProps.ariaHasPopup ?? true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: removeMargins ? undefined : $0412336062545bea$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ShowDI, {
        above: "lg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "software-view-settings.ui.view-settings-button.large-button",
        appearance: "default",
        isSelected: isOpen,
        onClick: handleClick,
        ref: onRefButtonLarge,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fUQgT))), {
            label: formatMessage((0, $9bm3X.default).buttonLabel),
            primaryColor: iconColor
        }),
        "aria-label": formatMessage((0, $9bm3X.default).buttonLabel),
        "aria-expanded": restProps.ariaExpanded ?? isSelected,
        "aria-controls": restProps.ariaControls,
        "aria-haspopup": restProps.ariaHasPopup ?? true
    }, formatMessage((0, $9bm3X.default).buttonLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ShowDI, {
        below: "lg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formatMessage((0, $9bm3X.default).buttonLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "software-view-settings.ui.view-settings-button.small-button",
        appearance: "default",
        isSelected: isOpen,
        onClick: handleClick,
        spacing: "none",
        ref: onRefButtonSmall,
        "aria-expanded": restProps.ariaExpanded ?? isSelected,
        "aria-controls": restProps.ariaControls,
        "aria-haspopup": restProps.ariaHasPopup ?? true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $0412336062545bea$var$iconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fUQgT))), {
        label: formatMessage((0, $9bm3X.default).buttonLabel),
        primaryColor: iconColor
    })))))));
};
const $0412336062545bea$var$iconWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '32px'
});
const $0412336062545bea$var$buttonWrapperStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.100'
});

});
parcelRegister("fUQgT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b964a2018cb4a0d7$var$_react = $b964a2018cb4a0d7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $b964a2018cb4a0d7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b964a2018cb4a0d7$var$PreferencesIcon = (props)=>/*#__PURE__*/ $b964a2018cb4a0d7$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M3 7h3v2H3zm0 8h11v2H3zm7-8h11v2H10zm8 8h3v2h-3z"/><path d="M11 8a3 3 0 11-5.999.001A3 3 0 0111 8zM9 8a1 1 0 10-1.999-.001A1 1 0 009 8zm10 8a3 3 0 11-5.999.001A3 3 0 0119 16zm-2 0a1 1 0 10-1.999-.001A1 1 0 0017 16z"/></g></svg>`
    }, props));
$b964a2018cb4a0d7$var$PreferencesIcon.displayName = 'PreferencesIcon';
var $b964a2018cb4a0d7$var$_default = $b964a2018cb4a0d7$var$PreferencesIcon;
module.exports.default = $b964a2018cb4a0d7$var$_default;

});

parcelRegister("eDgaT", function(module, exports) {

$parcel$export(module.exports, "ResponsiveButton", () => $ad0d3127c7a37420$export$47e82d861696e68c);
$parcel$export(module.exports, "ResponsiveLinkButton", () => $ad0d3127c7a37420$export$50fd17babcd996ef);

var $eUqFw = parcelRequire("eUqFw");

var $6zOB7 = parcelRequire("6zOB7");
var $j9fWg = parcelRequire("j9fWg");
var $fI650 = parcelRequire("fI650");
var $8GeQ6 = parcelRequire("8GeQ6");

var $9Amv1 = parcelRequire("9Amv1");

var $5ARvW = parcelRequire("5ARvW");

var $8cU5f = parcelRequire("8cU5f");

var $bAQOb = parcelRequire("bAQOb");

const $ad0d3127c7a37420$var$ResponsiveButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, iconAfter: iconAfter, breakpoint: breakpoint, appearance: appearance, testId: testId, isLink: isLink, ...restProps } = props;
    const CollapsedButtonComponent = isLink ? (0, $8GeQ6.default) : (0, $j9fWg.default);
    const ExpandedButtonComponent = isLink ? (0, $fI650.default) : (0, $6zOB7.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ARvW.Show), {
        below: breakpoint ?? 'lg'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CollapsedButtonComponent, {
        ...restProps,
        icon: icon,
        appearance: appearance ?? 'default',
        label: label,
        testId: `${testId ?? (0, $d189205948d5eb28$export$9c51afe8741be906)}.collapsed`,
        /* @ts-expect-error TS2551: Property 'href' does not exist on type ResponsiveButtonProps */ ...isLink && {
            href: restProps.href
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ARvW.Show), {
        above: breakpoint ?? 'lg'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ExpandedButtonComponent, {
        ...restProps,
        iconBefore: icon,
        iconAfter: iconAfter,
        appearance: appearance ?? 'default',
        testId: `${testId ?? (0, $d189205948d5eb28$export$9c51afe8741be906)}.expanded`,
        /* @ts-expect-error TS2551: Property 'href' does not exist on type ResponsiveButtonProps */ ...isLink && {
            href: restProps.href
        }
    }, label)));
});
/**
 * Displays an IconButton+tooltip or a Button with iconBefore, depending on viewport size.
 */ const $ad0d3127c7a37420$var$ResponsiveButtonOld = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ad0d3127c7a37420$var$ResponsiveButtonWrapper, {
        ref: ref,
        ...props
    }));
/**
 * Displays a LinkIconButton+tooltip or a LinkButton with iconBefore, depending on viewport size.
 */ const $ad0d3127c7a37420$var$ResponsiveLinkButtonOld = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ad0d3127c7a37420$var$ResponsiveButtonWrapper, {
        isLink: true,
        ref: ref,
        ...props
    }));
const $ad0d3127c7a37420$export$a40479704fa2e1c7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, iconAfter: iconAfter, breakpoint: breakpoint, appearance: appearance, testId: testId, 'aria-label': ariaLabel, iconButtonSpacing: iconButtonSpacing, buttonSpacing: buttonSpacing, ...restProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ARvW.Show), {
        below: breakpoint ?? 'lg'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        ...restProps,
        icon: icon,
        appearance: appearance ?? 'default',
        label: label,
        testId: `${testId ?? (0, $d189205948d5eb28$export$9c51afe8741be906)}.collapsed`,
        ref: ref,
        spacing: iconButtonSpacing
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ARvW.Show), {
        above: breakpoint ?? 'lg'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        ...restProps,
        iconBefore: icon,
        iconAfter: iconAfter,
        appearance: appearance ?? 'default',
        testId: `${testId ?? (0, $d189205948d5eb28$export$9c51afe8741be906)}.expanded`,
        ref: ref,
        "aria-label": ariaLabel,
        spacing: buttonSpacing
    }, label)));
});
const $ad0d3127c7a37420$export$1f835efc565e57a9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, iconAfter: iconAfter, breakpoint: breakpoint, appearance: appearance, testId: testId, 'aria-label': ariaLabel, iconButtonSpacing: iconButtonSpacing, buttonSpacing: buttonSpacing, ...restProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ARvW.Show), {
        below: breakpoint ?? 'lg'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8GeQ6.default), {
        ...restProps,
        icon: icon,
        appearance: appearance ?? 'default',
        label: label,
        testId: `${testId ?? (0, $d189205948d5eb28$export$9c51afe8741be906)}.collapsed`,
        href: restProps.href,
        ref: ref,
        spacing: iconButtonSpacing
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ARvW.Show), {
        above: breakpoint ?? 'lg'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fI650.default), {
        ...restProps,
        iconBefore: icon,
        iconAfter: iconAfter,
        appearance: appearance ?? 'default',
        testId: `${testId ?? (0, $d189205948d5eb28$export$9c51afe8741be906)}.expanded`,
        href: restProps.href,
        ref: ref,
        "aria-label": ariaLabel,
        spacing: buttonSpacing
    }, label)));
});
const $ad0d3127c7a37420$export$47e82d861696e68c = (0, $bAQOb.componentWithFF)('refactor-jira-responsive-button_3ifhq', $ad0d3127c7a37420$export$a40479704fa2e1c7, $ad0d3127c7a37420$var$ResponsiveButtonOld);
const $ad0d3127c7a37420$export$50fd17babcd996ef = (0, $bAQOb.componentWithFF)('refactor-jira-responsive-button_3ifhq', $ad0d3127c7a37420$export$1f835efc565e57a9, $ad0d3127c7a37420$var$ResponsiveLinkButtonOld);

});
parcelRegister("8GeQ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b9b21212202cc40$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4kMup = parcelRequire("4kMup");

var $8cU5f = parcelRequire("8cU5f");

var $cxipd = parcelRequire("cxipd");
const $3b9b21212202cc40$var$LinkIconButtonBase = ({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance, autoFocus: autoFocus, href: href, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const baseProps = (0, $cxipd.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        ariaLabelledBy: ariaLabelledBy,
        autoFocus: autoFocus,
        buttonType: 'link',
        icon: icon,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shape: shape,
        spacing: spacing,
        testId: testId
    });
    if (!isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: tooltip?.content ?? label,
        testId: tooltip?.testId,
        position: tooltip?.position,
        delay: tooltip?.delay,
        onShow: tooltip?.onShow,
        onHide: tooltip?.onHide,
        mousePosition: tooltip?.mousePosition,
        analyticsContext: tooltip?.analyticsContext,
        strategy: tooltip?.strategy,
        tag: tooltip?.tag,
        truncate: tooltip?.truncate,
        component: tooltip?.component,
        hideTooltipOnClick: tooltip?.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown
    }, (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kMup.default), {
            ...saferRest,
            "aria-labelledby": baseProps['aria-labelledby'],
            testId: testId,
            componentName: "LinkIconButton",
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            // Shared between tooltip and native props
            onMouseOver: (e)=>{
                triggerProps.onMouseOver?.(e);
                saferRest.onMouseOver?.(e);
            },
            onMouseOut: (e)=>{
                triggerProps.onMouseOut?.(e);
                saferRest.onMouseOut?.(e);
            },
            onMouseMove: (e)=>{
                triggerProps.onMouseMove?.(e);
                saferRest.onMouseMove?.(e);
            },
            onMouseDown: (e)=>{
                triggerProps.onMouseDown?.(e);
                saferRest.onMouseDown?.(e);
            },
            onFocus: (e)=>{
                triggerProps.onFocus?.(e);
                saferRest.onFocus?.(e);
            },
            onBlur: (e)=>{
                triggerProps.onBlur?.(e);
                saferRest.onBlur?.(e);
            },
            // Shared between tooltip and base props
            onClick: (event, analyticsEvent)=>{
                baseProps?.onClick?.(event, analyticsEvent);
                triggerProps?.onClick?.(event);
            },
            ref: (ref)=>{
                baseProps.ref(ref);
                triggerProps?.ref?.(ref);
            },
            // Base props only
            xcss: baseProps.xcss,
            onMouseDownCapture: baseProps.onMouseDownCapture,
            onMouseUpCapture: baseProps.onMouseUpCapture,
            onKeyDownCapture: baseProps.onKeyDownCapture,
            onKeyUpCapture: baseProps.onKeyUpCapture,
            onTouchStartCapture: baseProps.onTouchStartCapture,
            onTouchEndCapture: baseProps.onTouchEndCapture,
            onPointerDownCapture: baseProps.onPointerDownCapture,
            onPointerUpCapture: baseProps.onPointerUpCapture,
            onClickCapture: baseProps.onClickCapture,
            /**
						 * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
						 * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
						 */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
            href: baseProps.isDisabled ? undefined : href,
            role: baseProps.isDisabled ? 'link' : undefined,
            "aria-disabled": baseProps.isDisabled === true ? true : undefined
        }, baseProps.children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kMup.default), {
        ...saferRest,
        "aria-labelledby": baseProps['aria-labelledby'],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        testId: testId,
        /**
			 * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
			 * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
			 */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: baseProps.isDisabled ? undefined : href,
        role: baseProps.isDisabled ? 'link' : undefined,
        "aria-disabled": baseProps.isDisabled === true ? true : undefined,
        componentName: "LinkIconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName
    }, baseProps.children);
};
// Workarounds to support generic types with forwardRef + memo
const $3b9b21212202cc40$var$WithRef = /*#__PURE__*/ (0, $eUqFw.forwardRef)($3b9b21212202cc40$var$LinkIconButtonBase);
/**
 * __Link Icon Button__
 *
 * Renders a link in the style of an icon button.
 *
 * - [Examples](https://atlassian.design/components/link-icon-button/examples)
 * - [Code](https://atlassian.design/components/link-icon-button/code)
 * - [Usage](https://atlassian.design/components/link-icon-button/usage)
 */ const $3b9b21212202cc40$var$LinkIconButton = /*#__PURE__*/ (0, $eUqFw.memo)($3b9b21212202cc40$var$WithRef);
var $3b9b21212202cc40$export$2e2bcd8739ae039 = $3b9b21212202cc40$var$LinkIconButton;

});

const $d189205948d5eb28$export$9c51afe8741be906 = 'responsive-button.ui.responsive-button';


parcelRegister("9bm3X", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe0a9e7ec34d5e36$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fe0a9e7ec34d5e36$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    buttonLabel: {
        "id": "software-view-settings.view-settings-button.button-label",
        "defaultMessage": "View settings"
    }
});

});


parcelRegister("B4KsE", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsMenu", () => $628f0d79d11c5af3$export$14138a347411ebf);

var $eUqFw = parcelRequire("eUqFw");

var $l3HJG = parcelRequire("l3HJG");
var $c3qrZ = parcelRequire("c3qrZ");

var $8TRqG = parcelRequire("8TRqG");

var $lnXH6 = parcelRequire("lnXH6");
var $97JUs = parcelRequire("97JUs");
var $bmpW6 = parcelRequire("bmpW6");
const $628f0d79d11c5af3$export$14138a347411ebf = ({ boardId: boardId, isClassic: isClassic, view: view, viewAs: viewAs = (0, $c3qrZ.ViewAs).POPUP, showEpicAsPanel: showEpicAsPanel, isVersionsEnabled: isVersionsEnabled, epicCustomName: epicCustomName = 'Epic', showFilterBarToggle: showFilterBarToggle = false, showCardDetails: showCardDetails = true, areSubtasksEnabled: areSubtasksEnabled = false, showWorkSuggestions: showWorkSuggestions = false, onSubtasksExpandAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSubtasksExpandAll = ()=>{}, onSubtasksCollapseAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSubtasksCollapseAll = ()=>{}, areAllSubtasksExpanded: areAllSubtasksExpanded = false, areAllSubtasksCollapsed: areAllSubtasksCollapsed = false, isSwimlanesEnabled: isSwimlanesEnabled = false, onSwimlaneExpandAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneExpandAll = ()=>{}, onSwimlaneCollapseAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneCollapseAll = ()=>{}, onToggleWorkSuggestions: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onToggleWorkSuggestions = ()=>{}, onLinkedIssuesStatsToggledOn: // eslint-disable-next-line @typescript-eslint/no-empty-function
onLinkedIssuesStatsToggledOn = ()=>{}, isDaysInColumnEnabled: isDaysInColumnEnabled = false, showLinkedIssueStatsToggle: showLinkedIssueStatsToggle = false, cardExtraFields: cardExtraFields = [], isEstimateEnabled: isEstimateEnabled = false, isDueDateEnabled: isDueDateEnabled = false, isLabelsEnabled: isLabelsEnabled = false, isPriorityEnabled: isPriorityEnabled = false, isWorkSuggestionsEnabled: isWorkSuggestionsEnabled = false })=>{
    const sendAnalyticsEvent = (0, $8TRqG.useSendAnalyticsEvent)();
    const handleChange = (actionSubject, attributes)=>{
        sendAnalyticsEvent('clicked', actionSubject, (0, $l3HJG.AnalyticsEvent).UI_EVENT, {
            ...attributes,
            isClassic: isClassic
        }, view);
    };
    switch(view){
        case (0, $c3qrZ.View).BACKLOG:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lnXH6.BacklogMenu), {
                viewAs: viewAs,
                boardId: boardId,
                onHandleChange: handleChange,
                showCardDetails: showCardDetails,
                isClassic: isClassic,
                isVersionsEnabled: isVersionsEnabled,
                showEpicAsPanel: showEpicAsPanel,
                showFilterBarToggle: showFilterBarToggle,
                epicCustomName: epicCustomName,
                areSubtasksEnabled: areSubtasksEnabled,
                areAllSubtasksExpanded: areAllSubtasksExpanded,
                areAllSubtasksCollapsed: areAllSubtasksCollapsed,
                onSubtasksExpandAll: onSubtasksExpandAll,
                onSubtasksCollapseAll: onSubtasksCollapseAll,
                cardExtraFields: cardExtraFields,
                isEstimateEnabled: isEstimateEnabled,
                isDueDateEnabled: isDueDateEnabled,
                isPriorityEnabled: isPriorityEnabled
            });
        case (0, $c3qrZ.View).BOARD:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $97JUs.BoardMenu), {
                viewAs: viewAs,
                boardId: boardId,
                isSwimlanesEnabled: isSwimlanesEnabled,
                onHandleChange: handleChange,
                onSwimlaneExpandAll: onSwimlaneExpandAll,
                onSwimlaneCollapseAll: onSwimlaneCollapseAll,
                showFilterBarToggle: showFilterBarToggle,
                showLinkedIssueStatsToggle: showLinkedIssueStatsToggle,
                showCardDetails: showCardDetails,
                epicCustomName: epicCustomName,
                isDaysInColumnEnabled: isDaysInColumnEnabled,
                cardExtraFields: cardExtraFields,
                isEstimateEnabled: isEstimateEnabled,
                isDueDateEnabled: isDueDateEnabled,
                isLabelsEnabled: isLabelsEnabled,
                isPriorityEnabled: isPriorityEnabled,
                showWorkSuggestions: showWorkSuggestions,
                onToggleWorkSuggestions: onToggleWorkSuggestions,
                isWorkSuggestionsEnabled: isWorkSuggestionsEnabled,
                onLinkedIssuesStatsToggledOn: onLinkedIssuesStatsToggledOn
            });
        case (0, $c3qrZ.View).JSM_BOARD:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $97JUs.BoardMenu), {
                viewAs: viewAs,
                boardId: boardId,
                isSwimlanesEnabled: isSwimlanesEnabled,
                onHandleChange: handleChange,
                showFilterBarToggle: showFilterBarToggle,
                showCardDetails: false,
                onSwimlaneExpandAll: onSwimlaneExpandAll,
                onSwimlaneCollapseAll: onSwimlaneCollapseAll
            });
        case (0, $c3qrZ.View).INCREMENT_PLANNING_BOARD:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bmpW6.IncrementPlanningBoardMenu), {
                viewAs: viewAs,
                boardId: boardId,
                isSwimlanesEnabled: isSwimlanesEnabled,
                onHandleChange: handleChange,
                onSwimlaneExpandAll: onSwimlaneExpandAll,
                onSwimlaneCollapseAll: onSwimlaneCollapseAll
            });
        default:
            return null;
    }
};

});
parcelRegister("lnXH6", function(module, exports) {

$parcel$export(module.exports, "BacklogMenu", () => $98aa08fb843abe3b$export$baf646a48a139934);

var $eUqFw = parcelRequire("eUqFw");

var $bULPy = parcelRequire("bULPy");
var $8PFhw = parcelRequire("8PFhw");
var $8BKky = parcelRequire("8BKky");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $d6f6c = parcelRequire("d6f6c");

var $jyKDT = parcelRequire("jyKDT");

var $iS4KV = parcelRequire("iS4KV");

var $l3HJG = parcelRequire("l3HJG");
var $c3qrZ = parcelRequire("c3qrZ");
var $3kYjh = parcelRequire("3kYjh");

var $6dkWZ = parcelRequire("6dkWZ");
var $GXzXq = parcelRequire("GXzXq");
var $3UVMp = parcelRequire("3UVMp");
var $77HF9 = parcelRequire("77HF9");

var $6eyW6 = parcelRequire("6eyW6");

var $8MrYx = parcelRequire("8MrYx");

var $2PV0G = parcelRequire("2PV0G");

var $eobbE = parcelRequire("eobbE");
const $98aa08fb843abe3b$export$baf646a48a139934 = ({ viewAs: viewAs, boardId: boardId, isClassic: isClassic, isVersionsEnabled: isVersionsEnabled, showEpicAsPanel: showEpicAsPanel, showFilterBarToggle: showFilterBarToggle = false, epicCustomName: epicCustomName = 'Epic', areSubtasksEnabled: areSubtasksEnabled = false, areAllSubtasksExpanded: areAllSubtasksExpanded = false, areAllSubtasksCollapsed: areAllSubtasksCollapsed = false, showCardDetails: showCardDetails = true, isEstimateEnabled: isEstimateEnabled = false, onHandleChange: onHandleChange, onSubtasksExpandAll: // eslint-disable-next-line @typescript-eslint/no-empty-function
onSubtasksExpandAll = ()=>{}, onSubtasksCollapseAll: // eslint-disable-next-line @typescript-eslint/no-empty-function
onSubtasksCollapseAll = ()=>{}, cardExtraFields: cardExtraFields = [], isDueDateEnabled: isDueDateEnabled = false, isPriorityEnabled: isPriorityEnabled = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [state, actions] = (0, $8MrYx.useViewSettings)();
    const Section = viewAs === (0, $c3qrZ.ViewAs).PANEL ? (0, $GXzXq.PanelSection) : (0, $8BKky.default);
    const Group = viewAs === (0, $c3qrZ.ViewAs).PANEL ? (0, $6dkWZ.PanelGroup) : (0, $8PFhw.default);
    const { toggleViewSetting: toggleViewSetting, toggleShowEpics: toggleShowEpics, toggleShowStatuses: toggleShowStatuses, toggleShowVersions: toggleShowVersions, setViewSettingsCompactMode: setViewSettingsCompactMode, toggleExtraField: toggleExtraField, toggleShowDueDate: toggleShowDueDate } = actions;
    const hasCardExtraFields = cardExtraFields.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Group, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Section, null, isVersionsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77HF9.ViewSettingsToggle), {
        testId: (0, $jyKDT.backlogViewTestIds).showVersionPanelToggle,
        title: formatMessage((0, $iS4KV.default).versionPanel),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $c3qrZ.View).BACKLOG,
                setting: (0, $3kYjh.ViewSetting).VERSION_PANEL
            });
            onHandleChange((0, $l3HJG.ActionSubject).TOGGLE, {
                key: (0, $l3HJG.ToggleKey).VERSION_PANEL_TOGGLE,
                state: !state.showVersionPanel
            });
        },
        keyboardShortcut: (0, $c3qrZ.KeyboardShortcut).VERSION_PANEL_SHORTCUT,
        isChecked: state.showVersionPanel,
        viewAs: viewAs
    }), showEpicAsPanel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77HF9.ViewSettingsToggle), {
        testId: (0, $jyKDT.backlogViewTestIds).showEpicPanelToggle,
        title: formatMessage((0, $iS4KV.default).epicPanel, {
            epicName: epicCustomName
        }),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $c3qrZ.View).BACKLOG,
                setting: (0, $3kYjh.ViewSetting).EPIC_PANEL
            });
            onHandleChange((0, $l3HJG.ActionSubject).TOGGLE, {
                key: (0, $l3HJG.ToggleKey).EPIC_PANEL_TOGGLE,
                state: !state.showEpicPanel
            });
        },
        keyboardShortcut: (0, $c3qrZ.KeyboardShortcut).ISSUE_PARENT_PANEL_SHORTCUT,
        isChecked: state.showEpicPanel,
        viewAs: viewAs
    }), showFilterBarToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77HF9.ViewSettingsToggle), {
        testId: (0, $jyKDT.backlogViewTestIds).showQuickFiltersToggle,
        title: formatMessage((0, $iS4KV.default).quickFilters),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $c3qrZ.View).BACKLOG,
                setting: (0, $3kYjh.ViewSetting).QUICK_FILTERS
            });
            onHandleChange((0, $l3HJG.ActionSubject).TOGGLE, {
                key: (0, $l3HJG.ToggleKey).QUICK_FILTERS_TOGGLE,
                state: !state.showQuickFilters
            });
        },
        isChecked: state.showQuickFilters,
        viewAs: viewAs
    }), viewAs === (0, $c3qrZ.ViewAs).PANEL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Section, {
        title: formatMessage((0, $iS4KV.default).cardDensity),
        hasSeparator: true,
        "data-testId": (0, $jyKDT.backlogViewTestIds).cardLayoutSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3UVMp.ViewSettingsRadioGroup), {
        testId: (0, $jyKDT.backlogViewTestIds).cardLayoutRadioGroup,
        onSelect: (value)=>{
            setViewSettingsCompactMode({
                boardId: boardId,
                view: (0, $c3qrZ.View).BACKLOG,
                showCompactMode: value === 'compact'
            });
            onHandleChange((0, $l3HJG.ActionSubject).BUTTON, {
                key: (0, $l3HJG.ToggleKey).CARD_DENSITY,
                state: value
            });
        },
        value: state.showCompactMode ? 'compact' : 'default',
        options: [
            {
                name: 'card-layout',
                value: 'default',
                label: 'Default',
                icon: (0, $eobbE.CardLayoutDefaultIcon)
            },
            {
                name: 'card-layout',
                value: 'compact',
                label: 'Compact',
                icon: (0, $2PV0G.CardLayoutCompactIcon)
            }
        ],
        viewAs: viewAs,
        ariaLabel: formatMessage((0, $iS4KV.default).cardDensity)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77HF9.ViewSettingsToggle), {
        testId: (0, $jyKDT.backlogViewTestIds).showCompactModeToggle,
        title: formatMessage((0, $iS4KV.default).compactMode),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $c3qrZ.View).BACKLOG,
                setting: (0, $3kYjh.ViewSetting).COMPACT_MODE
            });
            onHandleChange((0, $l3HJG.ActionSubject).TOGGLE, {
                key: (0, $l3HJG.ToggleKey).COMPACT_MODE_TOGGLE,
                state: !state.showCompactMode
            });
        },
        isChecked: state.showCompactMode,
        viewAs: viewAs
    })), areSubtasksEnabled && viewAs !== (0, $c3qrZ.ViewAs).PANEL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Section, {
        title: formatMessage((0, $iS4KV.default).subtasks),
        hasSeparator: true,
        "data-testId": (0, $jyKDT.backlogViewTestIds).subtaskSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        testId: (0, $jyKDT.backlogViewTestIds).subtaskExpandAll,
        isDisabled: areAllSubtasksExpanded,
        onClick: ()=>{
            onSubtasksExpandAll();
            onHandleChange((0, $l3HJG.ActionSubject).BUTTON, {
                key: (0, $l3HJG.ToggleKey).SUBTASKS_EXPAND_ALL,
                state: (0, $c3qrZ.ExpandableState).EXPANDED
            });
        }
    }, formatMessage((0, $iS4KV.default).expandAllSubtasks)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        testId: (0, $jyKDT.backlogViewTestIds).subtaskCollapseAll,
        isDisabled: areAllSubtasksCollapsed,
        onClick: ()=>{
            onSubtasksCollapseAll();
            onHandleChange((0, $l3HJG.ActionSubject).BUTTON, {
                key: (0, $l3HJG.ToggleKey).SUBTASKS_COLLAPSE_ALL,
                state: (0, $c3qrZ.ExpandableState).COLLAPSED
            });
        }
    }, formatMessage((0, $iS4KV.default).collapseAllSubtasks))), showCardDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Section, {
        testId: (0, $jyKDT.backlogViewTestIds).cardDetailsSection,
        title: viewAs === (0, $c3qrZ.ViewAs).PANEL ? formatMessage((0, $iS4KV.default).cardFields) : formatMessage((0, $iS4KV.default).cardDetails),
        hasSeparator: true
    }, (0, $6eyW6.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77HF9.ViewSettingsToggle), {
        testId: (0, $jyKDT.backlogViewTestIds).showIssueTypeToggle,
        title: formatMessage((0, $iS4KV.default).cardDetailIssueType),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $c3qrZ.View).BACKLOG,
                setting: (0, $3kYjh.ViewSetting).SHOW_ISSUE_TYPE
            });
            onHandleChange((0, $l3HJG.ActionSubject).TOGGLE, {
                key: (0, $l3HJG.ToggleKey).SHOW_ISSUE_TYPE,
                state: !state.showIssueType
            });
        },
        isChecked: state.showIssueType,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77HF9.ViewSettingsToggle), {
        testId: (0, $jyKDT.backlogViewTestIds).showIssueKeyToggle,
        title: formatMessage((0, $iS4KV.default).cardDetailIssueKey),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $c3qrZ.View).BACKLOG,
                setting: (0, $3kYjh.ViewSetting).SHOW_ISSUE_KEY
            });
            onHandleChange((0, $l3HJG.ActionSubject).TOGGLE, {
                key: (0, $l3HJG.ToggleKey).SHOW_ISSUE_KEY,
                state: !state.showIssueKey
            });
        },
        isChecked: state.showIssueKey,
        viewAs: viewAs
    })), isVersionsEnabled && isClassic && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77HF9.ViewSettingsToggle), {
        testId: (0, $jyKDT.backlogViewTestIds).showVersionsToggle,
        title: formatMessage((0, $iS4KV.default).cardDetailVersion),
        onChange: ()=>{
            toggleShowVersions({
                boardId: boardId,
                view: (0, $c3qrZ.View).BACKLOG
            });
            onHandleChange((0, $l3HJG.ActionSubject).TOGGLE, {
                key: (0, $l3HJG.ToggleKey).SHOW_VERSIONS_TOGGLE,
                state: !state.showVersions
            });
        },
        isChecked: state.showVersions,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77HF9.ViewSettingsToggle), {
        testId: (0, $jyKDT.backlogViewTestIds).showEpicsToggle,
        title: epicCustomName,
        onChange: ()=>{
            toggleShowEpics({
                boardId: boardId,
                view: (0, $c3qrZ.View).BACKLOG
            });
            onHandleChange((0, $l3HJG.ActionSubject).TOGGLE, {
                key: (0, $l3HJG.ToggleKey).SHOW_EPICS_TOGGLE,
                state: !state.showEpics
            });
        },
        isChecked: state.showEpics,
        viewAs: viewAs
    }), (0, $6eyW6.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && isDueDateEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77HF9.ViewSettingsToggle), {
        testId: (0, $jyKDT.backlogViewTestIds).showDueDateToggle,
        title: formatMessage((0, $iS4KV.default).dueDate),
        onChange: ()=>{
            toggleShowDueDate({
                boardId: boardId,
                view: (0, $c3qrZ.View).BACKLOG
            });
            onHandleChange((0, $l3HJG.ActionSubject).TOGGLE, {
                key: (0, $l3HJG.ToggleKey).SHOW_DUE_DATE,
                state: !state.showDueDate
            });
        },
        isChecked: state.showDueDate,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77HF9.ViewSettingsToggle), {
        testId: (0, $jyKDT.backlogViewTestIds).showStatusToggle,
        title: formatMessage((0, $iS4KV.default).cardDetailStatus),
        onChange: ()=>{
            toggleShowStatuses({
                boardId: boardId,
                view: (0, $c3qrZ.View).BACKLOG
            });
            onHandleChange((0, $l3HJG.ActionSubject).TOGGLE, {
                key: (0, $l3HJG.ToggleKey).SHOW_STATUSES_TOGGLE,
                state: !state.showStatuses
            });
        },
        isChecked: state.showStatuses,
        viewAs: viewAs
    }), (0, $6eyW6.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isEstimateEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77HF9.ViewSettingsToggle), {
        testId: (0, $jyKDT.backlogViewTestIds).showEstimateToggle,
        title: formatMessage((0, $iS4KV.default).cardDetailEstimate),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $c3qrZ.View).BACKLOG,
                setting: (0, $3kYjh.ViewSetting).SHOW_ESTIMATE
            });
            onHandleChange((0, $l3HJG.ActionSubject).TOGGLE, {
                key: (0, $l3HJG.ToggleKey).SHOW_ESTIMATE,
                state: !state.showEstimate
            });
        },
        isChecked: state.showEstimate,
        viewAs: viewAs
    }), isPriorityEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77HF9.ViewSettingsToggle), {
        testId: (0, $jyKDT.backlogViewTestIds).showPriorityToggle,
        title: formatMessage((0, $iS4KV.default).cardDetailPriority),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $c3qrZ.View).BACKLOG,
                setting: (0, $3kYjh.ViewSetting).SHOW_PRIORITY
            });
            onHandleChange((0, $l3HJG.ActionSubject).TOGGLE, {
                key: (0, $l3HJG.ToggleKey).SHOW_PRIORITY,
                state: !state.showPriority
            });
        },
        isChecked: state.showPriority,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77HF9.ViewSettingsToggle), {
        testId: (0, $jyKDT.backlogViewTestIds).showAssigneeToggle,
        title: formatMessage((0, $iS4KV.default).cardDetailAssignee),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $c3qrZ.View).BACKLOG,
                setting: (0, $3kYjh.ViewSetting).SHOW_ASSIGNEE
            });
            onHandleChange((0, $l3HJG.ActionSubject).TOGGLE, {
                key: (0, $l3HJG.ToggleKey).SHOW_ASSIGNEE,
                state: !state.showAssignee
            });
        },
        isChecked: state.showAssignee,
        viewAs: viewAs
    }))), hasCardExtraFields && (0, $6eyW6.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Section, {
        testId: (0, $jyKDT.backlogViewTestIds).customFieldsSection,
        hasSeparator: true
    }, cardExtraFields.map((field)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77HF9.ViewSettingsToggle), {
            key: field.id,
            testId: `software-view-settings.ui.view-settings-menu.views.backlog.show-${field.id}-toggle-backlog`,
            title: field.label,
            onChange: ()=>{
                toggleExtraField({
                    boardId: boardId,
                    view: (0, $c3qrZ.View).BACKLOG,
                    fieldId: field.id
                });
                onHandleChange((0, $l3HJG.ActionSubject).TOGGLE, {
                    key: `${(0, $l3HJG.ToggleKey).SHOW_EXTRA_FIELD}_${field.id}`,
                    state: !state.cardExtraFields[field.id]
                });
            },
            isChecked: state.cardExtraFields[field.id],
            viewAs: viewAs
        }))), areSubtasksEnabled && viewAs === (0, $c3qrZ.ViewAs).PANEL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Section, {
        title: formatMessage((0, $iS4KV.default).subtasks),
        hasSeparator: true,
        "data-testId": (0, $jyKDT.backlogViewTestIds).subtaskSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $98aa08fb843abe3b$var$buttonItemContainerPanelModeStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        testId: (0, $jyKDT.backlogViewTestIds).subtaskExpandAll,
        isDisabled: areAllSubtasksExpanded,
        onClick: ()=>{
            onSubtasksExpandAll();
            onHandleChange((0, $l3HJG.ActionSubject).BUTTON, {
                key: (0, $l3HJG.ToggleKey).SUBTASKS_EXPAND_ALL,
                state: (0, $c3qrZ.ExpandableState).EXPANDED
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingInline: "space.100"
    }, formatMessage((0, $iS4KV.default).expandAllSubtasks))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        testId: (0, $jyKDT.backlogViewTestIds).subtaskCollapseAll,
        isDisabled: areAllSubtasksCollapsed,
        onClick: ()=>{
            onSubtasksCollapseAll();
            onHandleChange((0, $l3HJG.ActionSubject).BUTTON, {
                key: (0, $l3HJG.ToggleKey).SUBTASKS_COLLAPSE_ALL,
                state: (0, $c3qrZ.ExpandableState).COLLAPSED
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingInline: "space.100"
    }, formatMessage((0, $iS4KV.default).collapseAllSubtasks)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: {
            viewSettingsState: state
        }
    }));
};
const $98aa08fb843abe3b$var$buttonItemContainerPanelModeStyles = (0, $1ZAYh.xcss)({
    position: 'relative',
    left: '-24px',
    width: 'calc(100% + 48px)'
});

});
parcelRegister("iS4KV", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6900315059f4c1f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c6900315059f4c1f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    buttonLabel: {
        "id": "software-view-settings.common.button-label",
        "defaultMessage": "View settings"
    },
    panelSection: {
        "id": "software-view-settings.common.panel-section",
        "defaultMessage": "Panels"
    },
    versionPanel: {
        "id": "software-view-settings.common.version-panel",
        "defaultMessage": "Version panel"
    },
    epicPanel: {
        "id": "software-view-settings.common.epic-panel",
        "defaultMessage": "{epicName} panel"
    },
    quickFilters: {
        "id": "software-view-settings.common.quick-filters",
        "defaultMessage": "Quick filters"
    },
    workSuggestions: {
        "id": "software-view-settings.common.work-suggestions",
        "defaultMessage": "Work suggestions"
    },
    compactMode: {
        "id": "software-view-settings.common.compact-mode",
        "defaultMessage": "Compact mode"
    },
    cardDetails: {
        "id": "software-view-settings.common.card-details",
        "defaultMessage": "Card details"
    },
    cardFields: {
        "id": "software-view-settings.common.card-fields",
        "defaultMessage": "Fields"
    },
    cardDetailVersion: {
        "id": "software-view-settings.common.card-detail-version",
        "defaultMessage": "Version"
    },
    cardDetailStatus: {
        "id": "software-view-settings.common.card-detail-status",
        "defaultMessage": "Status"
    },
    cardDetailIssueType: {
        "id": "software-view-settings.common.card-detail-issue-type",
        "defaultMessage": "Issue type"
    },
    cardDetailIssueKey: {
        "id": "software-view-settings.common.card-detail-issue-key",
        "defaultMessage": "Issue key"
    },
    cardDetailEstimate: {
        "id": "software-view-settings.common.card-detail-estimate",
        "defaultMessage": "Estimate"
    },
    cardDetailPriority: {
        "id": "software-view-settings.common.card-detail-priority",
        "defaultMessage": "Priority"
    },
    cardDetailAssignee: {
        "id": "software-view-settings.common.card-detail-assignee",
        "defaultMessage": "Assignee"
    },
    swimlanes: {
        "id": "software-view-settings.common.swimlanes",
        "defaultMessage": "Swimlanes"
    },
    expandAll: {
        "id": "software-view-settings.common.expand-all",
        "defaultMessage": "Expand all"
    },
    collapseAll: {
        "id": "software-view-settings.common.collapse-all",
        "defaultMessage": "Collapse all"
    },
    openIssuesInSidebar: {
        "id": "software-view-settings.common.open-issues-in-sidebar",
        "defaultMessage": "Open issues in sidebar"
    },
    subtasks: {
        "id": "software-view-settings.common.subtasks",
        "defaultMessage": "Subtasks"
    },
    expandAllSubtasks: {
        "id": "software-view-settings.common.expand-all-subtasks",
        "defaultMessage": "Expand all"
    },
    collapseAllSubtasks: {
        "id": "software-view-settings.common.collapse-all-subtasks",
        "defaultMessage": "Collapse all"
    },
    showUnscheduledWork: {
        "id": "software-view-settings.common.show-unscheduled-work",
        "defaultMessage": "Show unscheduled work"
    },
    cardLayout: {
        "id": "software-view-settings.common.card-layout",
        "defaultMessage": "Card layout"
    },
    cardDensity: {
        "id": "software-view-settings.common.card-density",
        "defaultMessage": "Density"
    },
    daysInColumn: {
        "id": "software-view-settings.common.days-in-column",
        "defaultMessage": "Days in column"
    },
    dueDate: {
        "id": "software-view-settings.common.due-date",
        "defaultMessage": "Due date"
    },
    labels: {
        "id": "software-view-settings.common.labels",
        "defaultMessage": "Labels"
    },
    linkedIssues: {
        "id": "software-view-settings.common.linked-issues",
        "defaultMessage": "Linked issues"
    },
    cardCovers: {
        "id": "software-view-settings.common.card-covers.non-final",
        "defaultMessage": "Card covers"
    },
    toggleHint: {
        "id": "software-view-settings.common.toggle-hint",
        "defaultMessage": "Press {key} to open and close {panel}"
    },
    beta: {
        "id": "software-view-settings.common.beta",
        "defaultMessage": "Beta"
    }
});

});

parcelRegister("6dkWZ", function(module, exports) {

$parcel$export(module.exports, "PanelGroup", () => $4efdf18b862acff6$export$1d05749f6f573bb);

var $eUqFw = parcelRequire("eUqFw");
const $4efdf18b862acff6$export$1d05749f6f573bb = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);

});

parcelRegister("GXzXq", function(module, exports) {

$parcel$export(module.exports, "PanelSection", () => $269ccaa7ec61a498$export$15906978feb79aa6);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");
const $269ccaa7ec61a498$export$15906978feb79aa6 = ({ title: title, hasSeparator: hasSeparator, children: children, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlockEnd: title ? 'space.0' : 'space.050',
        testId: testId
    }, hasSeparator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($269ccaa7ec61a498$var$Separator, null), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $269ccaa7ec61a498$var$textStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "strong"
    }, title)), children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $269ccaa7ec61a498$var$Separator = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_x3dopdki _19pk12x7 _otyr12x7",
            __cmplp.className
        ])
    });
});
const $269ccaa7ec61a498$var$textStyles = (0, $1ZAYh.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});

});

parcelRegister("3UVMp", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsRadioGroup", () => $4ea4e5fc4d8c0b47$export$1e1eee2ec7833bf1);

var $eUqFw = parcelRequire("eUqFw");

var $jR93G = parcelRequire("jR93G");

var $2ziLQ = parcelRequire("2ziLQ");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");

var $hnuwz = parcelRequire("hnuwz");

var $c3qrZ = parcelRequire("c3qrZ");
const $4ea4e5fc4d8c0b47$export$1e1eee2ec7833bf1 = ({ options: options, value: value, onSelect: onSelect, testId: testId, viewAs: viewAs = (0, $c3qrZ.ViewAs).POPUP, ariaLabel: ariaLabel })=>{
    const onChange = (0, $eUqFw.useCallback)((e)=>{
        onSelect(e.target.value);
    }, [
        onSelect
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: viewAs === (0, $c3qrZ.ViewAs).PANEL ? $4ea4e5fc4d8c0b47$var$panelContainerStyles : $4ea4e5fc4d8c0b47$var$popupContainerStyles,
        testId: testId,
        role: "radiogroup",
        "aria-label": ariaLabel
    }, options.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
            xcss: $4ea4e5fc4d8c0b47$var$radioOptionContainerStyles,
            key: option.value
        }, option.value && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnuwz.default), {
            isChecked: option.value === value,
            onChange: onChange,
            name: option.name,
            label: option.label,
            value: option.value
        }), option.icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $4ea4e5fc4d8c0b47$var$iconContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
            glyph: option.icon,
            label: "",
            primaryColor: `var(--ds-icon-subtle, ${(0, $jR93G.N300)})`
        })))));
};
const $4ea4e5fc4d8c0b47$var$popupContainerStyles = (0, $1ZAYh.xcss)({
    marginBlock: '0',
    marginInline: 'space.200',
    minWidth: '200px'
});
const $4ea4e5fc4d8c0b47$var$panelContainerStyles = (0, $1ZAYh.xcss)({
    marginBlock: 'space.100',
    marginInline: 'auto',
    minWidth: '200px'
});
const $4ea4e5fc4d8c0b47$var$radioOptionContainerStyles = (0, $1ZAYh.xcss)({
    paddingBlock: 'space.075',
    alignItems: 'center',
    justifyContent: 'space-between'
});
const $4ea4e5fc4d8c0b47$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    opacity: 0.3
});

});
parcelRegister("jR93G", function(module, exports) {

$parcel$export(module.exports, "R50", () => $e749fe592a330097$export$4b84fd0e2c617bd);
$parcel$export(module.exports, "R75", () => $e749fe592a330097$export$b34b069eff244586);
$parcel$export(module.exports, "R100", () => $e749fe592a330097$export$be802dd0d8b57f35);
$parcel$export(module.exports, "R300", () => $e749fe592a330097$export$4a7404f376229999);
$parcel$export(module.exports, "R400", () => $e749fe592a330097$export$2010d0fb4295b346);
$parcel$export(module.exports, "R500", () => $e749fe592a330097$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y50", () => $e749fe592a330097$export$8d9596b529bbb9cf);
$parcel$export(module.exports, "Y75", () => $e749fe592a330097$export$41060a744ab0b7ae);
$parcel$export(module.exports, "Y200", () => $e749fe592a330097$export$5aae31392d72caaa);
$parcel$export(module.exports, "Y400", () => $e749fe592a330097$export$59619663aa6500fb);
$parcel$export(module.exports, "G50", () => $e749fe592a330097$export$8a6341c32b6a3ee6);
$parcel$export(module.exports, "G75", () => $e749fe592a330097$export$69a3bf21b9686c2b);
$parcel$export(module.exports, "G200", () => $e749fe592a330097$export$747d86715d4175de);
$parcel$export(module.exports, "G300", () => $e749fe592a330097$export$940e1f69e873f202);
$parcel$export(module.exports, "G400", () => $e749fe592a330097$export$a49394138f7b8e85);
$parcel$export(module.exports, "G500", () => $e749fe592a330097$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "B50", () => $e749fe592a330097$export$226de0355ed012f8);
$parcel$export(module.exports, "B75", () => $e749fe592a330097$export$8c13c2ee36917869);
$parcel$export(module.exports, "B100", () => $e749fe592a330097$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "B400", () => $e749fe592a330097$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $e749fe592a330097$export$a6ee3d71bc067634);
$parcel$export(module.exports, "L200", () => $e749fe592a330097$export$f72948ef771f6f15);
$parcel$export(module.exports, "N0", () => $e749fe592a330097$export$29a4f05edc054374);
$parcel$export(module.exports, "N20", () => $e749fe592a330097$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N30", () => $e749fe592a330097$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N40", () => $e749fe592a330097$export$1ce2d1575d444ceb);
$parcel$export(module.exports, "N50", () => $e749fe592a330097$export$8754fc7e6d8b3000);
$parcel$export(module.exports, "N60", () => $e749fe592a330097$export$c2e91cbeada39b8b);
$parcel$export(module.exports, "N80", () => $e749fe592a330097$export$eaa8c8a70ac22806);
$parcel$export(module.exports, "N200", () => $e749fe592a330097$export$f563ee71e9ee74cd);
$parcel$export(module.exports, "N300", () => $e749fe592a330097$export$e2ef2124cf4024b1);
$parcel$export(module.exports, "Neutral300", () => $e749fe592a330097$export$1ae1cebe22dcedb4);
$parcel$export(module.exports, "N300A", () => $e749fe592a330097$export$13609db0e6812ab8);
$parcel$export(module.exports, "N500", () => $e749fe592a330097$export$c39c0fe0f26207ae);
$parcel$export(module.exports, "N600", () => $e749fe592a330097$export$7090862dc3038a9f);
$parcel$export(module.exports, "N800", () => $e749fe592a330097$export$7d61b15e0da132af);
$parcel$export(module.exports, "N1000", () => $e749fe592a330097$export$f78789c8b01753cd);
$parcel$export(module.exports, "M200", () => $e749fe592a330097$export$a19f0c33186f7767);
$parcel$export(module.exports, "O200", () => $e749fe592a330097$export$51716a84e62e022c);
$parcel$export(module.exports, "P50", () => $e749fe592a330097$export$363e4475840015bb);
$parcel$export(module.exports, "P75", () => $e749fe592a330097$export$4b0a4417ed59760f);
$parcel$export(module.exports, "P100", () => $e749fe592a330097$export$6011520a64d9a187);
$parcel$export(module.exports, "P200", () => $e749fe592a330097$export$a7175d4e9206bc80);
$parcel$export(module.exports, "P300", () => $e749fe592a330097$export$b48405b95304b5a1);
$parcel$export(module.exports, "P500", () => $e749fe592a330097$export$147899de772240ec);
$parcel$export(module.exports, "T50", () => $e749fe592a330097$export$2cf711fe14c66f06);
$parcel$export(module.exports, "T75", () => $e749fe592a330097$export$7a8f4d33f6f9772c);
$parcel$export(module.exports, "T100", () => $e749fe592a330097$export$776c9c497ef08533);
$parcel$export(module.exports, "T200", () => $e749fe592a330097$export$69cb3ca10c1e330e);
$parcel$export(module.exports, "T300", () => $e749fe592a330097$export$9dc1ef0f3f48059b);
$parcel$export(module.exports, "T500", () => $e749fe592a330097$export$6036577f95c3877e);
$parcel$export(module.exports, "normalizeHexColor", () => $e749fe592a330097$export$b61655071712e690);
$parcel$export(module.exports, "isHex", () => $e749fe592a330097$export$8a9b6341a7c96bc);
$parcel$export(module.exports, "isRgb", () => $e749fe592a330097$export$e698776ec826343);
$parcel$export(module.exports, "rgbToHex", () => $e749fe592a330097$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgb", () => $e749fe592a330097$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToRgba", () => $e749fe592a330097$export$9665a07d9187b414);

var $dDX7B = parcelRequire("dDX7B");
const $e749fe592a330097$export$4b84fd0e2c617bd = '#FFEBE6';
const $e749fe592a330097$export$b34b069eff244586 = '#FFBDAD';
const $e749fe592a330097$export$be802dd0d8b57f35 = '#FF8F73';
const $e749fe592a330097$export$4a7404f376229999 = '#FF5630';
const $e749fe592a330097$export$2010d0fb4295b346 = '#DE350B';
const $e749fe592a330097$export$2837b5a1a71d5c02 = '#BF2600';
const $e749fe592a330097$export$8d9596b529bbb9cf = '#FFFAE6';
const $e749fe592a330097$export$41060a744ab0b7ae = '#FFF0B3';
const $e749fe592a330097$export$5aae31392d72caaa = '#FFC400';
const $e749fe592a330097$export$59619663aa6500fb = '#FF991F';
const $e749fe592a330097$export$874739ea9e379ab6 = '#FF8B00';
const $e749fe592a330097$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $e749fe592a330097$export$69a3bf21b9686c2b = '#ABF5D1';
const $e749fe592a330097$export$747d86715d4175de = '#57D9A3';
const $e749fe592a330097$export$940e1f69e873f202 = '#36B37E';
const $e749fe592a330097$export$a49394138f7b8e85 = '#00875A';
const $e749fe592a330097$export$6fa04827ac68a4fb = '#006644';
const $e749fe592a330097$export$226de0355ed012f8 = '#DEEBFF';
const $e749fe592a330097$export$8c13c2ee36917869 = '#B3D4FF';
const $e749fe592a330097$export$ecfc1dff386a3e7a = '#4C9AFF';
const $e749fe592a330097$export$b3de0ae08da2ce64 = '#0052CC';
const $e749fe592a330097$export$a6ee3d71bc067634 = '#0747A6';
const $e749fe592a330097$export$f72948ef771f6f15 = '#D3F1A7';
const $e749fe592a330097$export$29a4f05edc054374 = '#FFFFFF';
const $e749fe592a330097$export$9fdfb749e33cdf97 = '#F4F5F7';
const $e749fe592a330097$export$3e51e8f1440314ba = '#EBECF0';
const $e749fe592a330097$export$1ce2d1575d444ceb = '#DFE1E6';
const $e749fe592a330097$export$8754fc7e6d8b3000 = '#C1C7D0';
const $e749fe592a330097$export$c2e91cbeada39b8b = '#B3BAC5';
const $e749fe592a330097$export$eaa8c8a70ac22806 = '#97A0AF';
const $e749fe592a330097$export$7c87d337fb91a97d = '#8993A4';
const $e749fe592a330097$export$f563ee71e9ee74cd = '#6B778C';
const $e749fe592a330097$export$e2ef2124cf4024b1 = '#5E6C84';
const $e749fe592a330097$export$1ae1cebe22dcedb4 = '#DCDFE4';
const $e749fe592a330097$export$13609db0e6812ab8 = '#091E4224';
const $e749fe592a330097$export$c39c0fe0f26207ae = '#42526E';
const $e749fe592a330097$export$7090862dc3038a9f = '#758195';
const $e749fe592a330097$export$7d61b15e0da132af = '#172B4D';
const $e749fe592a330097$export$f78789c8b01753cd = '#172B4D';
const $e749fe592a330097$export$a19f0c33186f7767 = '#FDD0EC';
const $e749fe592a330097$export$51716a84e62e022c = '#FEDEC8';
const $e749fe592a330097$export$363e4475840015bb = '#EAE6FF';
const $e749fe592a330097$export$4b0a4417ed59760f = '#C0B6F2';
const $e749fe592a330097$export$6011520a64d9a187 = '#998DD9';
const $e749fe592a330097$export$a7175d4e9206bc80 = '#DFD8FD';
const $e749fe592a330097$export$b48405b95304b5a1 = '#6554C0';
const $e749fe592a330097$export$c71e4279dd54a18d = '#5243AA';
const $e749fe592a330097$export$147899de772240ec = '#403294';
const $e749fe592a330097$export$2cf711fe14c66f06 = '#E6FCFF';
const $e749fe592a330097$export$7a8f4d33f6f9772c = '#B3F5FF';
const $e749fe592a330097$export$776c9c497ef08533 = '#79E2F2';
const $e749fe592a330097$export$69cb3ca10c1e330e = '#C6EDFB';
const $e749fe592a330097$export$9dc1ef0f3f48059b = '#00B8D9';
const $e749fe592a330097$export$6036577f95c3877e = '#008DA6';
function $e749fe592a330097$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ($e749fe592a330097$export$8a9b6341a7c96bc(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map((c)=>c === '#' ? '#' : `${c}${c}`).join('');
    } else if ($e749fe592a330097$export$e698776ec826343(color)) return $e749fe592a330097$export$34d09c4a771c46ef(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if ($dDX7B.default && $dDX7B.default[color]) color = $dDX7B.default[color];
        else if ($dDX7B && $dDX7B[color]) color = $dDX7B[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
function $e749fe592a330097$export$5a544e13ad4e1fa5(color) {
    if (!$e749fe592a330097$export$8a9b6341a7c96bc(color)) return null;
    let colorBits = color.substring(1).split('');
    if (colorBits.length === 3) colorBits = [
        colorBits[0],
        colorBits[0],
        colorBits[1],
        colorBits[1],
        colorBits[2],
        colorBits[2]
    ];
    const rgb = Number(`0x${colorBits.join('')}`);
    // eslint-disable-next-line no-bitwise
    return `rgb(${rgb >> 16 & 255},${rgb >> 8 & 255},${rgb & 255})`;
}
function $e749fe592a330097$export$9665a07d9187b414(rawColor, alpha) {
    const color = $e749fe592a330097$export$b61655071712e690(rawColor);
    if (!color) return null;
    const hex2rgb = (color)=>color.match(/[a-z0-9]{2}/gi).map((hex)=>parseInt(hex, 16));
    return `rgba(${hex2rgb(color).concat(alpha).join(',')})`;
}
function $e749fe592a330097$export$34d09c4a771c46ef(value) {
    const matches = value.match(/(0?\.?\d{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        const [red, green, blue] = matches.map(Number);
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1) // eslint-disable-line no-bitwise
        ;
    }
    return null;
}
function $e749fe592a330097$export$e698776ec826343(color) {
    return /rgba?\(/.test(color);
}
function $e749fe592a330097$export$8a9b6341a7c96bc(color) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
}

});
parcelRegister("dDX7B", function(module, exports) {
module.exports = JSON.parse("{\"aliceblue\":\"#f0f8ff\",\"antiquewhite\":\"#faebd7\",\"aqua\":\"#00ffff\",\"aquamarine\":\"#7fffd4\",\"azure\":\"#f0ffff\",\"beige\":\"#f5f5dc\",\"bisque\":\"#ffe4c4\",\"black\":\"#000000\",\"blanchedalmond\":\"#ffebcd\",\"blue\":\"#0000ff\",\"blueviolet\":\"#8a2be2\",\"brown\":\"#a52a2a\",\"burlywood\":\"#deb887\",\"cadetblue\":\"#5f9ea0\",\"chartreuse\":\"#7fff00\",\"chocolate\":\"#d2691e\",\"coral\":\"#ff7f50\",\"cornflowerblue\":\"#6495ed\",\"cornsilk\":\"#fff8dc\",\"crimson\":\"#dc143c\",\"cyan\":\"#00ffff\",\"darkblue\":\"#00008b\",\"darkcyan\":\"#008b8b\",\"darkgoldenrod\":\"#b8860b\",\"darkgray\":\"#a9a9a9\",\"darkgreen\":\"#006400\",\"darkgrey\":\"#a9a9a9\",\"darkkhaki\":\"#bdb76b\",\"darkmagenta\":\"#8b008b\",\"darkolivegreen\":\"#556b2f\",\"darkorange\":\"#ff8c00\",\"darkorchid\":\"#9932cc\",\"darkred\":\"#8b0000\",\"darksalmon\":\"#e9967a\",\"darkseagreen\":\"#8fbc8f\",\"darkslateblue\":\"#483d8b\",\"darkslategray\":\"#2f4f4f\",\"darkslategrey\":\"#2f4f4f\",\"darkturquoise\":\"#00ced1\",\"darkviolet\":\"#9400d3\",\"deeppink\":\"#ff1493\",\"deepskyblue\":\"#00bfff\",\"dimgray\":\"#696969\",\"dimgrey\":\"#696969\",\"dodgerblue\":\"#1e90ff\",\"firebrick\":\"#b22222\",\"floralwhite\":\"#fffaf0\",\"forestgreen\":\"#228b22\",\"fuchsia\":\"#ff00ff\",\"gainsboro\":\"#dcdcdc\",\"ghostwhite\":\"#f8f8ff\",\"gold\":\"#ffd700\",\"goldenrod\":\"#daa520\",\"gray\":\"#808080\",\"green\":\"#008000\",\"greenyellow\":\"#adff2f\",\"grey\":\"#808080\",\"honeydew\":\"#f0fff0\",\"hotpink\":\"#ff69b4\",\"indianred\":\"#cd5c5c\",\"indigo\":\"#4b0082\",\"ivory\":\"#fffff0\",\"khaki\":\"#f0e68c\",\"lavender\":\"#e6e6fa\",\"lavenderblush\":\"#fff0f5\",\"lawngreen\":\"#7cfc00\",\"lemonchiffon\":\"#fffacd\",\"lightblue\":\"#add8e6\",\"lightcoral\":\"#f08080\",\"lightcyan\":\"#e0ffff\",\"lightgoldenrodyellow\":\"#fafad2\",\"lightgray\":\"#d3d3d3\",\"lightgreen\":\"#90ee90\",\"lightgrey\":\"#d3d3d3\",\"lightpink\":\"#ffb6c1\",\"lightsalmon\":\"#ffa07a\",\"lightseagreen\":\"#20b2aa\",\"lightskyblue\":\"#87cefa\",\"lightslategray\":\"#778899\",\"lightslategrey\":\"#778899\",\"lightsteelblue\":\"#b0c4de\",\"lightyellow\":\"#ffffe0\",\"lime\":\"#00ff00\",\"limegreen\":\"#32cd32\",\"linen\":\"#faf0e6\",\"magenta\":\"#ff00ff\",\"maroon\":\"#800000\",\"mediumaquamarine\":\"#66cdaa\",\"mediumblue\":\"#0000cd\",\"mediumorchid\":\"#ba55d3\",\"mediumpurple\":\"#9370db\",\"mediumseagreen\":\"#3cb371\",\"mediumslateblue\":\"#7b68ee\",\"mediumspringgreen\":\"#00fa9a\",\"mediumturquoise\":\"#48d1cc\",\"mediumvioletred\":\"#c71585\",\"midnightblue\":\"#191970\",\"mintcream\":\"#f5fffa\",\"mistyrose\":\"#ffe4e1\",\"moccasin\":\"#ffe4b5\",\"navajowhite\":\"#ffdead\",\"navy\":\"#000080\",\"oldlace\":\"#fdf5e6\",\"olive\":\"#808000\",\"olivedrab\":\"#6b8e23\",\"orange\":\"#ffa500\",\"orangered\":\"#ff4500\",\"orchid\":\"#da70d6\",\"palegoldenrod\":\"#eee8aa\",\"palegreen\":\"#98fb98\",\"paleturquoise\":\"#afeeee\",\"palevioletred\":\"#db7093\",\"papayawhip\":\"#ffefd5\",\"peachpuff\":\"#ffdab9\",\"peru\":\"#cd853f\",\"pink\":\"#ffc0cb\",\"plum\":\"#dda0dd\",\"powderblue\":\"#b0e0e6\",\"purple\":\"#800080\",\"rebeccapurple\":\"#663399\",\"red\":\"#ff0000\",\"rosybrown\":\"#bc8f8f\",\"royalblue\":\"#4169e1\",\"saddlebrown\":\"#8b4513\",\"salmon\":\"#fa8072\",\"sandybrown\":\"#f4a460\",\"seagreen\":\"#2e8b57\",\"seashell\":\"#fff5ee\",\"sienna\":\"#a0522d\",\"silver\":\"#c0c0c0\",\"skyblue\":\"#87ceeb\",\"slateblue\":\"#6a5acd\",\"slategray\":\"#708090\",\"slategrey\":\"#708090\",\"snow\":\"#fffafa\",\"springgreen\":\"#00ff7f\",\"steelblue\":\"#4682b4\",\"tan\":\"#d2b48c\",\"teal\":\"#008080\",\"thistle\":\"#d8bfd8\",\"tomato\":\"#ff6347\",\"turquoise\":\"#40e0d0\",\"violet\":\"#ee82ee\",\"wheat\":\"#f5deb3\",\"white\":\"#ffffff\",\"whitesmoke\":\"#f5f5f5\",\"yellow\":\"#ffff00\",\"yellowgreen\":\"#9acd32\"}");

});


parcelRegister("hnuwz", function(module, exports) {

$parcel$export(module.exports, "default", () => $306a59ce4e6b6146$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $PdmhA = parcelRequire("PdmhA");
const $306a59ce4e6b6146$var$packageName = "platform-pkg";
const $306a59ce4e6b6146$var$packageVersion = "0.0.0-use.local";
const $306a59ce4e6b6146$var$noop = (0, $5Q9wj.default);
const $306a59ce4e6b6146$var$labelPaddingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`
});
const $306a59ce4e6b6146$var$labelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    boxSizing: 'border-box',
    position: 'relative',
    alignItems: 'flex-start',
    color: `var(--ds-text, ${(0, $PdmhA.N900)})`,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-disabled]': {
        color: `var(--ds-text-disabled, ${(0, $PdmhA.N80)})`,
        cursor: 'not-allowed'
    }
});
const $306a59ce4e6b6146$var$radioStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    // TODO https://product-fabric.atlassian.net/browse/DSP-10507 revisit and remove the scale of 14/24
    /*
     The circle should be 14px * 14px centred in a 24px * 24px box.
     This is inclusive of a 2px border and inner circle with 2px radius.
     There is a Chrome bug that makes the circle become an oval and the
     inner circle not be centred at various zoom levels. This bug is fixed
     in all browsers if a scale of 14/24 is applied.
   */ width: '24px',
    height: '24px',
    margin: "var(--ds-space-0, 0px)",
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    backgroundColor: 'var(--radio-background-color)',
    /* Border should multiply by 24/14 to offset scale, a scale of 12 / 7 is to fix a Chrome bug that makes the circle become an oval and the
     inner circle not be centred at various zoom levels */ border: `${"var(--ds-border-width, 1px)"} solid var(--radio-border-color)`,
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    MozAppearance: 'none',
    outline: 'none',
    /*
     Change the variables --radio-background-color, --radio-border-color,
     -radio-dot-color and -radio-dot-opacity according to user interactions.
     All other variables are constant
   */ '--radio-background-color': `var(--ds-background-input, ${(0, $PdmhA.N10)})`,
    '--radio-border-color': `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    '--radio-dot-color': `var(--ds-icon-inverse, ${(0, $PdmhA.N10)})`,
    '--radio-dot-opacity': 0,
    /* 24px * 7 / 12 === 14px height and width */ transform: 'scale(calc(7 / 12))',
    transition: 'border-color 0.2s ease-in-out, background-color 0.2s ease-in-out',
    verticalAlign: 'top',
    WebkitAppearance: 'none',
    '&::after': {
        /* Height and width should by 4px, multiply by 24/14 to offset scale */ width: 'calc(4px * 12 / 7)',
        height: 'calc(4px * 12 / 7)',
        position: 'absolute',
        background: 'var(--radio-dot-color)',
        // TODO Delete this comment after verifying spacing token -> previous value `'50%'`
        borderRadius: "var(--ds-border-radius-circle, 50%)",
        content: "''",
        opacity: 'var(--radio-dot-opacity)',
        transition: 'background-color 0.2s ease-in-out, opacity 0.2s ease-in-out'
    },
    '&:hover': {
        '--radio-background-color': `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`,
        '--radio-border-color': `var(--ds-border-input, ${(0, $PdmhA.N100)})`
    },
    '&:active': {
        '--radio-background-color': `var(--ds-background-input-pressed, ${(0, $PdmhA.N30)})`
    },
    '&:focus': {
        outline: `${"var(--ds-border-width-outline, 3px)"} solid ${`var(--ds-border-focused, ${(0, $PdmhA.B200)})`}`,
        outlineOffset: "var(--ds-border-width-indicator, 3px)"
    },
    '&:checked': {
        '--radio-background-color': `var(--ds-background-selected-bold, ${(0, $PdmhA.B400)})`,
        '--radio-border-color': `var(--ds-background-selected-bold, ${(0, $PdmhA.B400)})`,
        '--radio-dot-opacity': 1
    },
    '&:checked:hover': {
        '--radio-background-color': `var(--ds-background-selected-bold-hovered, ${(0, $PdmhA.B300)})`,
        '--radio-border-color': `var(--ds-background-selected-bold-hovered, ${(0, $PdmhA.B300)})`
    },
    '&:checked:active': {
        '--radio-background-color': `var(--ds-background-selected-bold-pressed, ${(0, $PdmhA.B50)})`,
        '--radio-border-color': `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
        '--radio-dot-color': `var(--ds-icon-inverse, ${(0, $PdmhA.B400)})`
    },
    '&:checked:focus': {
        outline: `${"var(--ds-border-width-outline, 3px)"} solid ${`var(--ds-border-focused, ${(0, $PdmhA.B200)})`}`,
        outlineOffset: "var(--ds-border-width-indicator, 3px)"
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid], &:checked[data-invalid]': {
        '--radio-border-color': `var(--ds-icon-danger, ${(0, $PdmhA.R300)})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled, &:disabled:hover, &:disabled:focus, &:disabled:active, &:disabled[data-invalid]': {
        cursor: 'not-allowed',
        '--radio-background-color': `var(--ds-background-disabled, ${(0, $PdmhA.N20)})`,
        '--radio-border-color': `var(--ds-border-disabled, ${(0, $PdmhA.N20)})`,
        '--radio-dot-color': `var(--ds-icon-disabled, ${(0, $PdmhA.N70)})`
    }
});
const $306a59ce4e6b6146$var$InnerRadio = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, name: name, onChange: onChange = $306a59ce4e6b6146$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $306a59ce4e6b6146$var$packageName,
        packageVersion: $306a59ce4e6b6146$var$packageVersion
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        css: $306a59ce4e6b6146$var$labelStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ...rest,
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        "aria-label": ariaLabel,
        checked: isChecked,
        disabled: isDisabled,
        name: name,
        onChange: onChangeAnalytics,
        required: isRequired,
        type: "radio",
        value: value,
        "data-testid": testId && `${testId}--radio-input`,
        // isInvalid is used in a nonstandard way so cannot
        // use :invalid selector
        "data-invalid": isInvalid ? 'true' : undefined,
        css: $306a59ce4e6b6146$var$radioStyles,
        ref: ref
    }), label ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $306a59ce4e6b6146$var$labelPaddingStyles
    }, label) : null);
});
/**
 * __Radio__
 *
 * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
 *
 * - [Examples](https://atlassian.design/components/radio/examples)
 * - [Code](https://atlassian.design/components/radio/code)
 * - [Usage](https://atlassian.design/components/radio/usage)
 */ const $306a59ce4e6b6146$var$Radio = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ (0, $byn9U.jsx)($306a59ce4e6b6146$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $306a59ce4e6b6146$export$2e2bcd8739ae039 = $306a59ce4e6b6146$var$Radio;

});


parcelRegister("77HF9", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsToggle", () => $61536524ef2f61de$export$aacc18ae911f8e05);

var $eUqFw = parcelRequire("eUqFw");

var $4vTMF = parcelRequire("4vTMF");

var $ffiyv = parcelRequire("ffiyv");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $e270j = parcelRequire("e270j");

var $kjXsi = parcelRequire("kjXsi");

var $5JgJ2 = parcelRequire("5JgJ2");

var $iS4KV = parcelRequire("iS4KV");

var $c3qrZ = parcelRequire("c3qrZ");

var $6eyW6 = parcelRequire("6eyW6");
const $61536524ef2f61de$export$aacc18ae911f8e05 = ({ title: title, isChecked: isChecked, isDisabled: isDisabled, onChange: onChange, keyboardShortcut: keyboardShortcut, subtitleLozenge: subtitleLozenge, testId: testId, viewAs: viewAs = (0, $c3qrZ.ViewAs).POPUP })=>{
    const id = (0, (/*@__PURE__*/$parcel$interopDefault($4vTMF)))(`jira-software-view-settings-${title}`);
    const descriptionId = `${id}-description`;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: viewAs === (0, $c3qrZ.ViewAs).PANEL && (0, $6eyW6.isViewSettingsPanelAndTailoredViewExperimentEnabled)() ? $61536524ef2f61de$var$panelContainerStyles : $61536524ef2f61de$var$popupContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.200",
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("label", {
        "data-testid": testId,
        htmlFor: id
    }, title), subtitleLozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: "new"
    }, subtitleLozenge)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $61536524ef2f61de$var$tooltipContainerStyles
    }, keyboardShortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, keyboardShortcut), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e270j.default), {
        id: id,
        isChecked: isChecked,
        onChange: onChange,
        isDisabled: isDisabled,
        ...keyboardShortcut && {
            descriptionId: descriptionId
        }
    }), keyboardShortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kjXsi.ScreenReaderText), {
        id: descriptionId
    }, formatMessage((0, $iS4KV.default).toggleHint, {
        key: keyboardShortcut,
        panel: title
    })))));
};
const $61536524ef2f61de$var$popupContainerStyles = (0, $1ZAYh.xcss)({
    marginBlock: 'space.100',
    marginInline: 'space.200',
    minWidth: '200px'
});
const $61536524ef2f61de$var$panelContainerStyles = (0, $1ZAYh.xcss)({
    marginBlock: 'space.100',
    marginInline: 'auto',
    minWidth: '200px'
});
const $61536524ef2f61de$var$tooltipContainerStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtlest',
    whiteSpace: 'nowrap',
    lineHeight: 0
});

});
parcelRegister("e270j", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d3122f1d9f9fa05$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $jFtVs = parcelRequire("jFtVs");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $je5kZ = parcelRequire("je5kZ");

var $k9Z3M = parcelRequire("k9Z3M");

var $gnr5M = parcelRequire("gnr5M");
const $4d3122f1d9f9fa05$export$3eb7d6130acfda37 = (size)=>size === 'large' ? 'large' : 'small';
const $4d3122f1d9f9fa05$var$noop = (0, $5Q9wj.default);
const $4d3122f1d9f9fa05$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
/**
 * __Toggle__
 *
 * A toggle is used to view or switch between enabled or disabled states.
 *
 * - [Examples](https://atlassian.design/components/toggle/examples)
 * - [Code](https://atlassian.design/components/toggle/code)
 * - [Usage](https://atlassian.design/components/toggle/usage)
 */ const $4d3122f1d9f9fa05$var$Toggle = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $4d3122f1d9f9fa05$var$noop, onChange: providedChange = $4d3122f1d9f9fa05$var$noop, onFocus: providedFocus = $4d3122f1d9f9fa05$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $eUqFw.useState)(defaultChecked);
    const handleBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedOnBlur,
        action: 'blur',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const handleFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const handleChange = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined
    };
    const toggleStyles = (0, $eUqFw.useMemo)(()=>(0, $gnr5M.getStyles)(size), [
        size
    ]);
    const uuid = (0, $jFtVs.useUIDSeed)()('toggle');
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        ...controlProps,
        css: toggleStyles
    }, label ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        id: `${uuid}-label`,
        hidden: true
    }, label) : null, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ref: ref,
        checked: shouldChecked,
        disabled: isDisabled,
        id: id,
        name: name,
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        type: "checkbox",
        value: value,
        "data-testid": testId && `${testId}--input`,
        "aria-labelledby": label ? `${uuid}-label` : undefined,
        "aria-describedby": descriptionId
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k9Z3M))), {
        label: "",
        size: $4d3122f1d9f9fa05$export$3eb7d6130acfda37(size),
        testId: testId && `${testId}--toggle-check-icon`
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($je5kZ))), {
        label: "",
        size: $4d3122f1d9f9fa05$export$3eb7d6130acfda37(size),
        testId: testId && `${testId}--toggle-cross-icon`
    })));
}));
$4d3122f1d9f9fa05$var$Toggle.displayName = 'Toggle';
var $4d3122f1d9f9fa05$export$2e2bcd8739ae039 = $4d3122f1d9f9fa05$var$Toggle;

});
parcelRegister("k9Z3M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ead4032469749d51$var$_react = $ead4032469749d51$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $ead4032469749d51$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ead4032469749d51$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $ead4032469749d51$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M7.356 10.942a.497.497 0 00-.713 0l-.7.701a.501.501 0 00-.003.71l3.706 3.707a.501.501 0 00.705.003l7.712-7.712a.493.493 0 00-.006-.708l-.7-.7a.504.504 0 00-.714 0l-6.286 6.286a.506.506 0 01-.713 0l-2.288-2.287z" fill="currentColor"/></svg>`
    }, props));
$ead4032469749d51$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $ead4032469749d51$var$_default = $ead4032469749d51$var$EditorDoneIcon;
module.exports.default = $ead4032469749d51$var$_default;

});

parcelRegister("gnr5M", function(module, exports) {

$parcel$export(module.exports, "getStyles", () => $f3c1d4ec47a37a63$export$ffd58b7f6f099a57);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $lcnyw = parcelRequire("lcnyw");

var $3Vu5P = parcelRequire("3Vu5P");
const $f3c1d4ec47a37a63$var$globalGridSize = (0, $lcnyw.gridSize)();
const $f3c1d4ec47a37a63$var$dimensions = {
    regular: {
        height: $f3c1d4ec47a37a63$var$globalGridSize * 2,
        width: $f3c1d4ec47a37a63$var$globalGridSize * 4
    },
    large: {
        height: $f3c1d4ec47a37a63$var$globalGridSize * 2 + $f3c1d4ec47a37a63$var$globalGridSize / 2,
        width: $f3c1d4ec47a37a63$var$globalGridSize * 5
    }
};
const $f3c1d4ec47a37a63$var$getHeight = ({ size: size })=>$f3c1d4ec47a37a63$var$dimensions[size].height;
const $f3c1d4ec47a37a63$var$getWidth = ({ size: size })=>$f3c1d4ec47a37a63$var$dimensions[size].width;
const $f3c1d4ec47a37a63$var$borderWidth = 2;
const $f3c1d4ec47a37a63$var$paddingUnitless = $f3c1d4ec47a37a63$var$globalGridSize / 4;
const $f3c1d4ec47a37a63$var$transition = 'transform 0.2s ease';
const $f3c1d4ec47a37a63$export$ffd58b7f6f099a57 = (size)=>{
    const colors = (0, $3Vu5P.getColors)();
    // TODO: Use tokens and reorganize to alphasemantic ordering (DSP-11769 DSP-11770)
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview,@repo/internal/styles/consistent-style-ordering */ return /*#__PURE__*/ (0, $byn9U.css)({
        boxSizing: 'content-box',
        display: 'inline-block',
        padding: $f3c1d4ec47a37a63$var$borderWidth,
        margin: $f3c1d4ec47a37a63$var$borderWidth,
        backgroundClip: 'content-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: colors.backgroundColorUnchecked,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: `${$f3c1d4ec47a37a63$var$getHeight({
            size: size
        })}px`,
        border: `${$f3c1d4ec47a37a63$var$borderWidth}px solid transparent`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${$f3c1d4ec47a37a63$var$getHeight({
            size: size
        })}px`,
        position: 'relative',
        transition: `${$f3c1d4ec47a37a63$var$transition}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${$f3c1d4ec47a37a63$var$getWidth({
            size: size
        })}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorChecked,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: colors.iconColorChecked
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:not([data-checked])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedDisabled
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled][data-checked],&[data-disabled][data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedDisabled
        },
        '&:focus-within': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            border: `${$f3c1d4ec47a37a63$var$borderWidth}px solid ${colors.borderColorFocus}`
        },
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedHover,
            cursor: 'pointer'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:hover,&[data-disabled][data-checked]:hover,&[data-disabled]:not([data-checked]):hover': {
            cursor: 'not-allowed'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedHover
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not([data-checked]):hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedHover
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:not([data-checked]):hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedDisabled
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: colors.iconColorUnchecked,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled], &[data-disabled][data-checked], &[data-disabled][data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: colors.iconColorDisabled
        },
        // the input element underneath
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'input[type="checkbox"]': {
            opacity: 0,
            margin: 0,
            padding: 0,
            border: 'none',
            '&:focus': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
                outline: 'none !important'
            }
        },
        // slider
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColor,
            borderRadius: "var(--ds-border-radius-circle, 50%)",
            content: '""',
            position: 'absolute',
            transform: 'initial',
            transition: $f3c1d4ec47a37a63$var$transition,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            insetBlockEnd: `${2 * $f3c1d4ec47a37a63$var$paddingUnitless}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            }) - $f3c1d4ec47a37a63$var$paddingUnitless * 2}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            }) - $f3c1d4ec47a37a63$var$paddingUnitless * 2}px`,
            // initially we set left as left-most position
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            insetInlineStart: `${2 * $f3c1d4ec47a37a63$var$paddingUnitless}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColorChecked,
            // when  it's checked, slide the pseudo-element to right-most postion
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transform: `translateX(${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            })}px)`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColorDisabled,
            zIndex: 1
        },
        // icons - check and cross
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> span': {
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            insetBlockStart: `${$f3c1d4ec47a37a63$var$paddingUnitless}px`
        },
        // This is the first of the two on/off symbols. The first of type is a
        // hidden text `span` for labeling
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> span:nth-last-of-type(2)': {
            insetInlineStart: `3px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> span:last-of-type': {
            insetInlineEnd: `3px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...size === 'large' && {
            '> span': {
                position: 'absolute',
                height: '20px',
                width: '20px'
            }
        },
        '@media screen and (forced-colors: active)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '::before': {
                filter: 'grayscale(100%) invert(1)'
            },
            '&:focus-within': {
                outline: '1px solid'
            }
        }
    });
};

});
parcelRegister("3Vu5P", function(module, exports) {

$parcel$export(module.exports, "getColors", () => $a04fcc2fd7c04036$export$6cee60e8aa85e528);

var $PdmhA = parcelRequire("PdmhA");
const $a04fcc2fd7c04036$var$colorMap = {
    backgroundColorChecked: `var(--ds-background-success-bold, ${(0, $PdmhA.G400)})`,
    backgroundColorCheckedHover: `var(--ds-background-success-bold-hovered, ${(0, $PdmhA.G500)})`,
    backgroundColorCheckedDisabled: `var(--ds-background-disabled, ${(0, $PdmhA.N20)})`,
    backgroundColorUnchecked: `var(--ds-background-neutral-bold, ${(0, $PdmhA.N200)})`,
    backgroundColorUncheckedHover: `var(--ds-background-neutral-bold-hovered, ${(0, $PdmhA.N400)})`,
    backgroundColorUncheckedDisabled: `var(--ds-background-disabled, ${(0, $PdmhA.N20)})`,
    borderColorFocus: `var(--ds-border-focused, ${(0, $PdmhA.B200)})`,
    iconColorChecked: `var(--ds-icon-inverse, ${(0, $PdmhA.N0)})`,
    iconColorDisabled: `var(--ds-icon-disabled, ${(0, $PdmhA.N70)})`,
    iconColorUnchecked: `var(--ds-icon-inverse, ${(0, $PdmhA.N0)})`,
    handleBackgroundColor: `var(--ds-icon-inverse, ${(0, $PdmhA.N0)})`,
    handleBackgroundColorChecked: `var(--ds-icon-inverse, ${(0, $PdmhA.N0)})`,
    handleBackgroundColorDisabled: `var(--ds-icon-inverse, ${(0, $PdmhA.N0)})`
};
const $a04fcc2fd7c04036$export$6cee60e8aa85e528 = ()=>$a04fcc2fd7c04036$var$colorMap;

});



parcelRegister("kjXsi", function(module, exports) {

$parcel$export(module.exports, "visuallyHiddenStyles", () => $cfcbcec828cf2e62$export$8dd524ceb40e3d16);
$parcel$export(module.exports, "ScreenReaderText", () => $cfcbcec828cf2e62$export$88fad6aa294f111c);
$parcel$export(module.exports, "ScreenReaderCaption", () => $cfcbcec828cf2e62$export$200c8e5d652aa9af);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");
const $cfcbcec828cf2e62$export$8dd524ceb40e3d16 = {
    clip: 'rect(1px, 1px, 1px, 1px)',
    clipPath: 'inset(50%)',
    height: '1px',
    width: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute'
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $cfcbcec828cf2e62$var$ScreenReaderTextControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1wqp2jw-0"
})($cfcbcec828cf2e62$export$8dd524ceb40e3d16);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $cfcbcec828cf2e62$var$ScreenReaderTextExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw",
            __cmplp.className
        ])
    });
});
const $cfcbcec828cf2e62$export$88fad6aa294f111c = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $cfcbcec828cf2e62$var$ScreenReaderTextExperiment, $cfcbcec828cf2e62$var$ScreenReaderTextControl);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $cfcbcec828cf2e62$var$ScreenReaderCaptionControl = /*#__PURE__*/ (0, $kwce8.default).caption.withConfig({
    componentId: "sc-1wqp2jw-1"
})($cfcbcec828cf2e62$export$8dd524ceb40e3d16);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $cfcbcec828cf2e62$var$ScreenReaderCaptionExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "caption", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw",
            __cmplp.className
        ])
    });
});
const $cfcbcec828cf2e62$export$200c8e5d652aa9af = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $cfcbcec828cf2e62$var$ScreenReaderCaptionExperiment, $cfcbcec828cf2e62$var$ScreenReaderCaptionControl);

});


parcelRegister("2PV0G", function(module, exports) {

$parcel$export(module.exports, "CardLayoutCompactIcon", () => $f7e12c39c06bdef1$export$73c305db8d999c47);
// SVG with custom colours

var $eUqFw = parcelRequire("eUqFw");
const $f7e12c39c06bdef1$export$73c305db8d999c47 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "58",
        height: "28",
        viewBox: "0 0 58 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label']
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H56C56.8284 0.5 57.5 1.17157 57.5 2V9.5H0.5V2Z",
        stroke: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M57 10V18H59V10H57ZM1 18V10H-1V18H1Z",
        fill: "currentColor",
        mask: "url(#path-2-inside-1_1311_59)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0.5 18.5H57.5V26C57.5 26.8284 56.8284 27.5 56 27.5H2C1.17157 27.5 0.5 26.8284 0.5 26V18.5Z",
        stroke: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "5",
        y: "3",
        width: "4",
        height: "4",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "5",
        y: "12",
        width: "4",
        height: "4",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "5",
        y: "21",
        width: "4",
        height: "4",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "12",
        y: "4",
        width: "41",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "12",
        y: "13",
        width: "41",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "12",
        y: "22",
        width: "41",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }));

});

parcelRegister("eobbE", function(module, exports) {

$parcel$export(module.exports, "CardLayoutDefaultIcon", () => $a743cc1c60c0b95d$export$b1c73e945668f4c2);
// SVG with custom colours

var $eUqFw = parcelRequire("eUqFw");
const $a743cc1c60c0b95d$export$b1c73e945668f4c2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "58",
        height: "27",
        viewBox: "0 0 58 27",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label']
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0 14H58H0ZM59 25C59 26.6569 57.6569 28 56 28H2C0.343146 28 -1 26.6569 -1 25H1C1 25.5523 1.44772 26 2 26H56C56.5523 26 57 25.5523 57 25H59ZM2 28C0.343146 28 -1 26.6569 -1 25V14H1V25C1 25.5523 1.44772 26 2 26V28ZM59 14V25C59 26.6569 57.6569 28 56 28V26C56.5523 26 57 25.5523 57 25V14H59Z",
        fill: "currentColor",
        mask: "url(#path-1-inside-1_1311_46)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H56C56.8284 0.5 57.5 1.17157 57.5 2V13.5H0.5V2Z",
        stroke: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "5",
        y: "5",
        width: "4",
        height: "4",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "5",
        y: "18",
        width: "4",
        height: "4",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "12",
        y: "6",
        width: "41",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "12",
        y: "19",
        width: "41",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }));

});


parcelRegister("97JUs", function(module, exports) {

$parcel$export(module.exports, "BoardMenu", () => $6b8e0a5c7dd6902c$export$17445232de9c085a);

var $eUqFw = parcelRequire("eUqFw");

var $bULPy = parcelRequire("bULPy");
var $8PFhw = parcelRequire("8PFhw");
var $8BKky = parcelRequire("8BKky");

var $ltfxy = parcelRequire("ltfxy");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $dfBCt = parcelRequire("dfBCt");

var $1ybV0 = parcelRequire("1ybV0");

var $bAQOb = parcelRequire("bAQOb");

var $eI5EY = parcelRequire("eI5EY");

var $jzDDz = parcelRequire("jzDDz");

var $aVlZX = parcelRequire("aVlZX");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $d6f6c = parcelRequire("d6f6c");

var $jyKDT = parcelRequire("jyKDT");

var $iS4KV = parcelRequire("iS4KV");

var $l3HJG = parcelRequire("l3HJG");
var $c3qrZ = parcelRequire("c3qrZ");
var $3kYjh = parcelRequire("3kYjh");

var $6dkWZ = parcelRequire("6dkWZ");
var $GXzXq = parcelRequire("GXzXq");
var $77HF9 = parcelRequire("77HF9");

var $6eyW6 = parcelRequire("6eyW6");

var $8MrYx = parcelRequire("8MrYx");
const $6b8e0a5c7dd6902c$export$17445232de9c085a = ({ viewAs: viewAs, boardId: boardId, showFilterBarToggle: showFilterBarToggle = false, showLinkedIssueStatsToggle: showLinkedIssueStatsToggle = false, isSwimlanesEnabled: isSwimlanesEnabled = false, showCardDetails: showCardDetails = true, epicCustomName: epicCustomName = 'Epic', onHandleChange: onHandleChange, onSwimlaneExpandAll: // eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneExpandAll = ()=>{}, onSwimlaneCollapseAll: // eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneCollapseAll = ()=>{}, onToggleWorkSuggestions: // eslint-disable-next-line @typescript-eslint/no-empty-function
onToggleWorkSuggestions = ()=>{}, onLinkedIssuesStatsToggledOn: // eslint-disable-next-line @typescript-eslint/no-empty-function
onLinkedIssuesStatsToggledOn = ()=>{}, isDaysInColumnEnabled: isDaysInColumnEnabled = false, isEstimateEnabled: isEstimateEnabled = false, isDueDateEnabled: isDueDateEnabled = false, isLabelsEnabled: isLabelsEnabled = false, isPriorityEnabled: isPriorityEnabled = false, isWorkSuggestionsEnabled: isWorkSuggestionsEnabled = false, showWorkSuggestions: showWorkSuggestions = false, cardExtraFields: cardExtraFields = [] })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [state, actions] = (0, $8MrYx.useViewSettings)();
    const { view: view } = state;
    const { toggleViewSetting: toggleViewSetting, toggleShowEpics: toggleShowEpics, toggleShowLinkedIssuesStats: toggleShowLinkedIssuesStats, toggleShowDaysInColumn: toggleShowDaysInColumn, toggleShowDueDate: toggleShowDueDate, toggleExtraField: toggleExtraField, toggleShowLabels: toggleShowLabels } = actions;
    const viewMode = (0, $hJ992.useViewMode)();
    const [, { setDetailViewAsSidebar: setDetailViewAsSidebar, setDetailViewAsModal: setDetailViewAsModal }] = (0, $hJ992.useIssueContextActions)();
    const Section = viewAs === (0, $c3qrZ.ViewAs).PANEL ? (0, $GXzXq.PanelSection) : (0, $8BKky.default);
    const Group = viewAs === (0, $c3qrZ.ViewAs).PANEL ? (0, $6dkWZ.PanelGroup) : (0, $8PFhw.default);
    const handleBoardViewModeClick = ()=>{
        if (viewMode === (0, $935e771f19f8ea28$export$705305d6da432040)) setDetailViewAsModal();
        else setDetailViewAsSidebar();
    };
    const hasCardExtraFields = cardExtraFields.length > 0;
    const handleLinkedIssuesStatsToggleChange = (0, $eUqFw.useCallback)(()=>{
        const showIssueLinksStatsState = state.showIssueLinksStats;
        toggleShowLinkedIssuesStats({
            boardId: boardId,
            view: (0, $c3qrZ.View).BOARD
        });
        onHandleChange((0, $l3HJG.ActionSubject).TOGGLE, {
            key: (0, $l3HJG.ToggleKey).SHOW_ISSUE_LINKS_STATS,
            state: !showIssueLinksStatsState
        });
        // start fetching issue links stats if the user turned on toggle
        if (!showIssueLinksStatsState) onLinkedIssuesStatsToggledOn();
    }, [
        boardId,
        onHandleChange,
        onLinkedIssuesStatsToggledOn,
        state.showIssueLinksStats,
        toggleShowLinkedIssuesStats
    ]);
    const handleLinkedIssuesStatsToggleChangeOld = (0, $eUqFw.useCallback)(()=>{
        toggleShowLinkedIssuesStats({
            boardId: boardId,
            view: (0, $c3qrZ.View).BOARD
        });
        onHandleChange((0, $l3HJG.ActionSubject).TOGGLE, {
            key: (0, $l3HJG.ToggleKey).SHOW_ISSUE_LINKS_STATS,
            state: !state.showIssueLinksStats
        });
    }, [
        boardId,
        onHandleChange,
        state,
        toggleShowLinkedIssuesStats
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Group, {
        "data-testId": (0, $jyKDT.boardViewTestIds).viewSettingsBoardMenu
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Section, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77HF9.ViewSettingsToggle), {
        testId: (0, $jyKDT.boardViewTestIds).openIssuesInSidebarToggle,
        title: formatMessage((0, $iS4KV.default).openIssuesInSidebar),
        onChange: ()=>{
            handleBoardViewModeClick();
            onHandleChange((0, $l3HJG.ActionSubject).TOGGLE, {
                key: (0, $l3HJG.ToggleKey).OPEN_ISSUES_IN_SIDEBAR_TOGGLE,
                state: viewMode === (0, $935e771f19f8ea28$export$705305d6da432040) ? (0, $c3qrZ.ViewLocation).MODAL : (0, $c3qrZ.ViewLocation).SIDEBAR
            });
        },
        isChecked: viewMode === (0, $935e771f19f8ea28$export$705305d6da432040),
        viewAs: viewAs
    }), showFilterBarToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77HF9.ViewSettingsToggle), {
        testId: (0, $jyKDT.boardViewTestIds).showQuickFiltersToggle,
        title: formatMessage((0, $iS4KV.default).quickFilters),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $c3qrZ.View).BOARD,
                setting: (0, $3kYjh.ViewSetting).QUICK_FILTERS
            });
            onHandleChange((0, $l3HJG.ActionSubject).TOGGLE, {
                key: (0, $l3HJG.ToggleKey).QUICK_FILTERS_TOGGLE,
                state: !state.showQuickFilters
            });
        },
        isChecked: state.showQuickFilters,
        viewAs: viewAs
    }), !(0, $dfBCt.isFedRamp)() && showWorkSuggestions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6b8e0a5c7dd6902c$var$WorkSuggestionsSpotlightTarget, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jzDDz.ViewSettingsTogglePulse), {
        isPanelView: viewAs === (0, $c3qrZ.ViewAs).PANEL
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77HF9.ViewSettingsToggle), {
        testId: (0, $jyKDT.boardViewTestIds).showWorkSuggestionsToggle,
        title: formatMessage((0, $iS4KV.default).workSuggestions),
        onChange: (_, analyticsEvent)=>{
            onToggleWorkSuggestions(analyticsEvent);
            onHandleChange((0, $l3HJG.ActionSubject).TOGGLE, {
                key: (0, $l3HJG.ToggleKey).WORK_SUGGESTIONS_TOGGLE,
                state: !isWorkSuggestionsEnabled
            });
        },
        isChecked: isWorkSuggestionsEnabled,
        viewAs: viewAs
    })))), isSwimlanesEnabled && viewAs !== (0, $c3qrZ.ViewAs).PANEL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Section, {
        title: formatMessage((0, $iS4KV.default).swimlanes),
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        "data-testid": (0, $jyKDT.boardViewTestIds).swimlaneExpandAll,
        onClick: ()=>{
            onSwimlaneExpandAll();
            onHandleChange((0, $l3HJG.ActionSubject).BUTTON, {
                key: (0, $l3HJG.ToggleKey).SWIMLANE_EXPAND_ALL,
                state: (0, $c3qrZ.ExpandableState).EXPANDED
            });
        }
    }, formatMessage((0, $iS4KV.default).expandAll)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        "data-testid": (0, $jyKDT.boardViewTestIds).swimlaneCollapseAll,
        onClick: ()=>{
            onSwimlaneCollapseAll();
            onHandleChange((0, $l3HJG.ActionSubject).BUTTON, {
                key: (0, $l3HJG.ToggleKey).SWIMLANE_COLLAPSE_ALL,
                state: (0, $c3qrZ.ExpandableState).COLLAPSED
            });
        }
    }, formatMessage((0, $iS4KV.default).collapseAll))), showCardDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Section, {
        testId: (0, $jyKDT.boardViewTestIds).cardDetailsSection,
        title: viewAs === (0, $c3qrZ.ViewAs).PANEL ? formatMessage((0, $iS4KV.default).cardFields) : formatMessage((0, $iS4KV.default).cardDetails),
        hasSeparator: true
    }, view === (0, $c3qrZ.View).BOARD && (0, $6eyW6.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77HF9.ViewSettingsToggle), {
        testId: (0, $jyKDT.boardViewTestIds).showIssueTypeToggle,
        title: formatMessage((0, $iS4KV.default).cardDetailIssueType),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $c3qrZ.View).BOARD,
                setting: (0, $3kYjh.ViewSetting).SHOW_ISSUE_TYPE
            });
            onHandleChange((0, $l3HJG.ActionSubject).TOGGLE, {
                key: (0, $l3HJG.ToggleKey).SHOW_ISSUE_TYPE,
                state: !state.showIssueType
            });
        },
        isChecked: state.showIssueType,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77HF9.ViewSettingsToggle), {
        testId: (0, $jyKDT.boardViewTestIds).showIssueKeyToggle,
        title: formatMessage((0, $iS4KV.default).cardDetailIssueKey),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $c3qrZ.View).BOARD,
                setting: (0, $3kYjh.ViewSetting).SHOW_ISSUE_KEY
            });
            onHandleChange((0, $l3HJG.ActionSubject).TOGGLE, {
                key: (0, $l3HJG.ToggleKey).SHOW_ISSUE_KEY,
                state: !state.showIssueKey
            });
        },
        isChecked: state.showIssueKey,
        viewAs: viewAs
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77HF9.ViewSettingsToggle), {
        testId: (0, $jyKDT.boardViewTestIds).showEpicsToggle,
        title: epicCustomName,
        onChange: ()=>{
            toggleShowEpics({
                boardId: boardId,
                view: (0, $c3qrZ.View).BOARD
            });
            onHandleChange((0, $l3HJG.ActionSubject).TOGGLE, {
                key: (0, $l3HJG.ToggleKey).SHOW_EPICS_TOGGLE,
                state: !state.showEpics
            });
        },
        isChecked: state.showEpics,
        viewAs: viewAs
    }), isDueDateEnabled && view === (0, $c3qrZ.View).BOARD && (0, $6eyW6.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77HF9.ViewSettingsToggle), {
        testId: (0, $jyKDT.boardViewTestIds).showDueDateToggle,
        title: formatMessage((0, $iS4KV.default).dueDate),
        onChange: ()=>{
            toggleShowDueDate({
                boardId: boardId,
                view: (0, $c3qrZ.View).BOARD
            });
            onHandleChange((0, $l3HJG.ActionSubject).TOGGLE, {
                key: (0, $l3HJG.ToggleKey).SHOW_DUE_DATE,
                state: !state.showDueDate
            });
        },
        isChecked: state.showDueDate,
        viewAs: viewAs
    }), isLabelsEnabled && view === (0, $c3qrZ.View).BOARD && (0, $6eyW6.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77HF9.ViewSettingsToggle), {
        testId: (0, $jyKDT.boardViewTestIds).showLabelsToggle,
        title: formatMessage((0, $iS4KV.default).labels),
        onChange: ()=>{
            toggleShowLabels({
                boardId: boardId,
                view: (0, $c3qrZ.View).BOARD
            });
            onHandleChange((0, $l3HJG.ActionSubject).TOGGLE, {
                key: (0, $l3HJG.ToggleKey).SHOW_LABELS,
                state: !state.showLabels
            });
        },
        isChecked: state.showLabels,
        viewAs: viewAs
    }), isEstimateEnabled && view === (0, $c3qrZ.View).BOARD && (0, $6eyW6.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77HF9.ViewSettingsToggle), {
        testId: (0, $jyKDT.boardViewTestIds).showEstimateToggle,
        title: formatMessage((0, $iS4KV.default).cardDetailEstimate),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $c3qrZ.View).BOARD,
                setting: (0, $3kYjh.ViewSetting).SHOW_ESTIMATE
            });
            onHandleChange((0, $l3HJG.ActionSubject).TOGGLE, {
                key: (0, $l3HJG.ToggleKey).SHOW_ESTIMATE,
                state: !state.showEstimate
            });
        },
        isChecked: state.showEstimate,
        viewAs: viewAs
    }), isDaysInColumnEnabled && view === (0, $c3qrZ.View).BOARD && (0, $6eyW6.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77HF9.ViewSettingsToggle), {
        testId: (0, $jyKDT.boardViewTestIds).showDaysInColumnToggle,
        title: formatMessage((0, $iS4KV.default).daysInColumn),
        onChange: ()=>{
            toggleShowDaysInColumn({
                boardId: boardId,
                view: (0, $c3qrZ.View).BOARD
            });
            onHandleChange((0, $l3HJG.ActionSubject).TOGGLE, {
                key: (0, $l3HJG.ToggleKey).SHOW_DAYS_IN_COLUMN,
                state: !state.showDaysInColumn
            });
        },
        isChecked: state.showDaysInColumn,
        viewAs: viewAs
    }), showLinkedIssueStatsToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77HF9.ViewSettingsToggle), {
        testId: (0, $jyKDT.boardViewTestIds).showLinkedIssueStatsToggle,
        title: formatMessage((0, $iS4KV.default).linkedIssues),
        onChange: (0, $1ybV0.ff)('jsw-minimise-linked-issues-stats-requests_pn6em') ? handleLinkedIssuesStatsToggleChange : handleLinkedIssuesStatsToggleChangeOld,
        isChecked: state.showIssueLinksStats,
        viewAs: viewAs
    }), view === (0, $c3qrZ.View).BOARD && (0, $eI5EY.fg)('jsw_cmp_card_cover_images') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77HF9.ViewSettingsToggle), {
        testId: (0, $jyKDT.boardViewTestIds).showCardCoversToggle,
        title: formatMessage((0, $iS4KV.default).cardCovers),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $c3qrZ.View).BOARD,
                setting: (0, $3kYjh.ViewSetting).SHOW_CARD_COVERS
            });
            onHandleChange((0, $l3HJG.ActionSubject).TOGGLE, {
                key: (0, $l3HJG.ToggleKey).SHOW_CARD_COVERS,
                state: !state.showCardCovers
            });
        },
        isChecked: state.showCardCovers,
        viewAs: viewAs
    }), view === (0, $c3qrZ.View).BOARD && (0, $6eyW6.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isPriorityEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77HF9.ViewSettingsToggle), {
        testId: (0, $jyKDT.boardViewTestIds).showPriorityToggle,
        title: formatMessage((0, $iS4KV.default).cardDetailPriority),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $c3qrZ.View).BOARD,
                setting: (0, $3kYjh.ViewSetting).SHOW_PRIORITY
            });
            onHandleChange((0, $l3HJG.ActionSubject).TOGGLE, {
                key: (0, $l3HJG.ToggleKey).SHOW_PRIORITY,
                state: !state.showPriority
            });
        },
        isChecked: state.showPriority,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77HF9.ViewSettingsToggle), {
        testId: (0, $jyKDT.boardViewTestIds).showAssigneeToggle,
        title: formatMessage((0, $iS4KV.default).cardDetailAssignee),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $c3qrZ.View).BOARD,
                setting: (0, $3kYjh.ViewSetting).SHOW_ASSIGNEE
            });
            onHandleChange((0, $l3HJG.ActionSubject).TOGGLE, {
                key: (0, $l3HJG.ToggleKey).SHOW_ASSIGNEE,
                state: !state.showAssignee
            });
        },
        isChecked: state.showAssignee,
        viewAs: viewAs
    }))), hasCardExtraFields && (0, $6eyW6.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Section, {
        testId: (0, $jyKDT.boardViewTestIds).customFieldsSection,
        hasSeparator: true
    }, cardExtraFields.map((field)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77HF9.ViewSettingsToggle), {
            key: field.id,
            testId: `software-view-settings.ui.view-settings-menu.views.board.show-${field.id}-toggle-board`,
            title: field.label,
            onChange: ()=>{
                toggleExtraField({
                    boardId: boardId,
                    view: (0, $c3qrZ.View).BOARD,
                    fieldId: field.id
                });
                onHandleChange((0, $l3HJG.ActionSubject).TOGGLE, {
                    key: `${(0, $l3HJG.ToggleKey).SHOW_EXTRA_FIELD}_${field.id}`,
                    state: !state.cardExtraFields[field.id]
                });
            },
            isChecked: state.cardExtraFields[field.id],
            viewAs: viewAs
        }))), isSwimlanesEnabled && viewAs === (0, $c3qrZ.ViewAs).PANEL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Section, {
        title: formatMessage((0, $iS4KV.default).swimlanes),
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $6b8e0a5c7dd6902c$var$buttonItemContainerPanelModeStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        "data-testid": (0, $jyKDT.boardViewTestIds).swimlaneExpandAll,
        onClick: ()=>{
            onSwimlaneExpandAll();
            onHandleChange((0, $l3HJG.ActionSubject).BUTTON, {
                key: (0, $l3HJG.ToggleKey).SWIMLANE_EXPAND_ALL,
                state: (0, $c3qrZ.ExpandableState).EXPANDED
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingInline: "space.100"
    }, formatMessage((0, $iS4KV.default).expandAll))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        "data-testid": (0, $jyKDT.boardViewTestIds).swimlaneCollapseAll,
        onClick: ()=>{
            onSwimlaneCollapseAll();
            onHandleChange((0, $l3HJG.ActionSubject).BUTTON, {
                key: (0, $l3HJG.ToggleKey).SWIMLANE_COLLAPSE_ALL,
                state: (0, $c3qrZ.ExpandableState).COLLAPSED
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingInline: "space.100"
    }, formatMessage((0, $iS4KV.default).collapseAll)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: {
            viewSettingsState: state
        }
    }));
};
const $6b8e0a5c7dd6902c$var$WorkSuggestionsSpotlightTarget = (0, $bAQOb.componentWithFF)('jira.insights.work-suggestions-on-boarding-spotlight-view-settings_dzjgq', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
        name: (0, $aVlZX.WORK_SUGGESTIONS_VIEW_SETTINGS_SPOTLIGHT_VIEW_SETTINGS_STEP_NAME)
    }, children), ({ children: children })=>children);
const $6b8e0a5c7dd6902c$var$buttonItemContainerPanelModeStyles = (0, $1ZAYh.xcss)({
    position: 'relative',
    left: '-24px',
    width: 'calc(100% + 48px)'
});

});
parcelRegister("jzDDz", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsTogglePulse", () => $8e393f11b8ef3c5b$export$1cb4eacfdb188bc8);

var $eUqFw = parcelRequire("eUqFw");

var $8Wt6T = parcelRequire("8Wt6T");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $erql0 = parcelRequire("erql0");
const $8e393f11b8ef3c5b$var$PULSE_DURATION = 7950;
const $8e393f11b8ef3c5b$export$1cb4eacfdb188bc8 = ({ children: children, isPanelView: isPanelView })=>{
    const [{ viewSettingsTogglePulses: viewSettingsTogglePulses }, { setViewSettingsTogglePulses: setViewSettingsTogglePulses }] = (0, $erql0.useNextBestTaskContainer)();
    (0, $eUqFw.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            setViewSettingsTogglePulses(false);
        }, $8e393f11b8ef3c5b$var$PULSE_DURATION);
        return ()=>{
            clearTimeout(timeoutId);
            setViewSettingsTogglePulses(false);
        };
    }, [
        setViewSettingsTogglePulses
    ]);
    if (!viewSettingsTogglePulses) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    return isPanelView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $8e393f11b8ef3c5b$var$negativePadding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Wt6T.Pulse), {
        radius: 5
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $8e393f11b8ef3c5b$var$positivePadding
    }, children))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $8e393f11b8ef3c5b$var$positivePadding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Wt6T.Pulse), {
        radius: 5
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $8e393f11b8ef3c5b$var$negativePadding
    }, children)));
};
const $8e393f11b8ef3c5b$var$negativePadding = (0, $1ZAYh.xcss)({
    marginLeft: 'space.negative.050',
    marginRight: 'space.negative.050'
});
const $8e393f11b8ef3c5b$var$positivePadding = (0, $1ZAYh.xcss)({
    marginLeft: 'space.050',
    marginRight: 'space.050'
});

});

parcelRegister("hJ992", function(module, exports) {

$parcel$export(module.exports, "useChildIssuesLimit", () => $7e3614f655e5103c$export$8d75f312eaa63aec);
$parcel$export(module.exports, "useChildIssuesIssueLimitUrl", () => $7e3614f655e5103c$export$65a59acd1ffc5bba);
$parcel$export(module.exports, "useIsModal", () => $7e3614f655e5103c$export$9ce8428ff198804a);
$parcel$export(module.exports, "useIssueKey", () => $7e3614f655e5103c$export$22108eca27445997);
$parcel$export(module.exports, "useIssueId", () => $7e3614f655e5103c$export$9df8176b5ffce5ab);
$parcel$export(module.exports, "useIsArchived", () => $7e3614f655e5103c$export$7cd1821433aafaee);
$parcel$export(module.exports, "useIsClassifyEditEnabled", () => $7e3614f655e5103c$export$b23b36ed5c42e920);
$parcel$export(module.exports, "useProjectKey", () => $7e3614f655e5103c$export$f87be37f8e8be65);
$parcel$export(module.exports, "useAnalyticsSource", () => $7e3614f655e5103c$export$aad3917152559b87);
$parcel$export(module.exports, "useIssueContextActions", () => $7e3614f655e5103c$export$d6ec1293313f49ac);
$parcel$export(module.exports, "useRapidViewMap", () => $7e3614f655e5103c$export$4d204e800e4e0be7);
$parcel$export(module.exports, "useEstimationStatistic", () => $7e3614f655e5103c$export$5b20e30ee6db56e9);
$parcel$export(module.exports, "useViewMode", () => $7e3614f655e5103c$export$3a7c3e259b6adb93);
$parcel$export(module.exports, "useBackButtonUrl", () => $7e3614f655e5103c$export$cfe64a334903927c);
$parcel$export(module.exports, "useIssueNavigatorData", () => $7e3614f655e5103c$export$aa008a00bae7e7ab);
$parcel$export(module.exports, "useOnIssueKeyChange", () => $7e3614f655e5103c$export$52c975cf0b623556);
$parcel$export(module.exports, "useRapidViewId", () => $7e3614f655e5103c$export$b34d0ea0bf41fee);
$parcel$export(module.exports, "useViewScreenId", () => $7e3614f655e5103c$export$7c142b5701b4c3f9);
$parcel$export(module.exports, "useHasSoftwareAccess", () => $7e3614f655e5103c$export$dcc0d1c3cd4bd9fb);
$parcel$export(module.exports, "useIsFullPageIssueView", () => $7e3614f655e5103c$export$2e131fc4108f9106);
$parcel$export(module.exports, "useIsEmbedPageIssueView", () => $7e3614f655e5103c$export$4596c26005fbb859);
$parcel$export(module.exports, "useIsAiOptInEnabled", () => $7e3614f655e5103c$export$b131d9f6da853161);

var $eUqFw = parcelRequire("eUqFw");


var $e91YZ = parcelRequire("e91YZ");

var $7HKaW = parcelRequire("7HKaW");
var $6vrw7 = parcelRequire("6vrw7");

var $j3FUN = parcelRequire("j3FUN");
var $jBTMs = parcelRequire("jBTMs");

var $hWdjG = parcelRequire("hWdjG");
const $7e3614f655e5103c$export$8d75f312eaa63aec = ()=>{
    const [childIssuesLimit] = (0, $hWdjG.useIssueContextStoreChildIssuesLimit)();
    return childIssuesLimit;
};
const $7e3614f655e5103c$export$cc6e0a43a2a9b17a = ()=>{
    const [childIssuesIssueLimitUrls] = (0, $hWdjG.useIssueContextStoreChildIssuesIssueLimitUrls)();
    return childIssuesIssueLimitUrls;
};
const $7e3614f655e5103c$export$65a59acd1ffc5bba = (fieldId)=>{
    const childIssuesIssueLimitUrls = $7e3614f655e5103c$export$cc6e0a43a2a9b17a();
    return childIssuesIssueLimitUrls?.[fieldId];
};
const $7e3614f655e5103c$export$9ce8428ff198804a = ()=>{
    const [isModal] = (0, $hWdjG.useIssueContextStoreIsModal)();
    return isModal;
};
const $7e3614f655e5103c$export$22108eca27445997 = ()=>{
    const [issueKey] = (0, $hWdjG.useIssueContextStoreIssueKey)();
    return issueKey;
};
const $7e3614f655e5103c$export$9df8176b5ffce5ab = ()=>{
    const [issueId] = (0, $hWdjG.useIssueContextStoreIssueId)();
    return issueId;
};
const $7e3614f655e5103c$export$7cd1821433aafaee = ()=>{
    const [isArchived] = (0, $hWdjG.useIssueContextStoreIsArchived)();
    return isArchived;
};
const $7e3614f655e5103c$export$b23b36ed5c42e920 = ()=>{
    const [isClassifyEditEnabled] = (0, $hWdjG.useIssueContextStoreIsClassifyEditEnabled)();
    return isClassifyEditEnabled;
};
const $7e3614f655e5103c$export$f87be37f8e8be65 = ()=>{
    const [issueKey] = (0, $hWdjG.useIssueContextStoreIssueKey)();
    return (0, $6vrw7.toProjectKey)(issueKey.split('-')[0]);
};
const $7e3614f655e5103c$export$aad3917152559b87 = ()=>{
    const [analyticsSource] = (0, $hWdjG.useIssueContextStoreAnalyticsSource)();
    return analyticsSource;
};
const $7e3614f655e5103c$export$d6ec1293313f49ac = ()=>{
    const [, { setIssueContext: setIssueContext, mergeIssueContext: mergeIssueContext, getChildIssuesLimit: getChildIssuesLimit, getMaxTokenLength: getMaxTokenLength, getIsLoadedWithPage: getIsLoadedWithPage, getBackButtonUrl: getBackButtonUrl, getIsSpaEnabled: getIsSpaEnabled, getIssueKey: getIssueKey, setDetailViewAsModal: setDetailViewAsModal, setDetailViewAsSidebar: setDetailViewAsSidebar, resetDetailView: resetDetailView }] = (0, $hWdjG.useIssueContextStoreActions)();
    const actions = (0, $eUqFw.useMemo)(()=>({
            setIssueContext: setIssueContext,
            mergeIssueContext: mergeIssueContext,
            getChildIssuesLimit: getChildIssuesLimit,
            getMaxTokenLength: getMaxTokenLength,
            getIsLoadedWithPage: getIsLoadedWithPage,
            getBackButtonUrl: getBackButtonUrl,
            getIsSpaEnabled: getIsSpaEnabled,
            getIssueKey: getIssueKey,
            setDetailViewAsModal: setDetailViewAsModal,
            setDetailViewAsSidebar: setDetailViewAsSidebar,
            resetDetailView: resetDetailView
        }), [
        setIssueContext,
        mergeIssueContext,
        getChildIssuesLimit,
        getMaxTokenLength,
        getIsLoadedWithPage,
        getBackButtonUrl,
        getIsSpaEnabled,
        getIssueKey,
        setDetailViewAsModal,
        setDetailViewAsSidebar,
        resetDetailView
    ]);
    return [
        undefined,
        actions
    ];
};
const $7e3614f655e5103c$export$4d204e800e4e0be7 = ()=>{
    const [rapidViewMap] = (0, $hWdjG.useIssueContextRapidViewMap)();
    return rapidViewMap;
};
const $7e3614f655e5103c$export$e0d7666ae716c88a = ()=>{
    const [maxTokenLength] = (0, $hWdjG.useIssueContextStoreMaxTokenLength)();
    return maxTokenLength;
};
const $7e3614f655e5103c$export$b4199f923267161e = ()=>{
    const [isLoadedWithPage] = (0, $hWdjG.useIssueContextStoreIsLoadedWithPage)();
    return isLoadedWithPage;
};
const $7e3614f655e5103c$export$5b20e30ee6db56e9 = ()=>{
    const [estimationStatistic] = (0, $hWdjG.useIssueContextStoreEstimationStatistic)();
    return estimationStatistic;
};
const $7e3614f655e5103c$export$4dface15d86304a4 = ()=>{
    const [isLoading] = (0, $hWdjG.useIssueContextStoreIsLoading)();
    return isLoading;
};
const $7e3614f655e5103c$export$3a7c3e259b6adb93 = ()=>{
    const [viewMode] = (0, $hWdjG.useIssueContextStoreViewMode)();
    return viewMode;
};
const $7e3614f655e5103c$export$cfe64a334903927c = ()=>{
    const [backButtonUrl] = (0, $hWdjG.useIssueContextStoreBackButtonUrl)();
    return backButtonUrl;
};
const $7e3614f655e5103c$export$aa008a00bae7e7ab = ()=>{
    const [issueNavigatorData] = (0, $hWdjG.useIssueContextStoreIssueNavigatorData)();
    return issueNavigatorData;
};
const $7e3614f655e5103c$export$b49754504c41149f = ()=>{
    const [boardId] = (0, $hWdjG.useIssueContextStoreBoardId)();
    return boardId;
};
const $7e3614f655e5103c$export$91aab984882a2a2c = ()=>{
    const [boardType] = (0, $hWdjG.useIssueContextStoreBoardType)();
    return boardType;
};
const $7e3614f655e5103c$export$dbad9dbd4871f2e9 = ()=>{
    const [isSpaEnabled] = (0, $hWdjG.useIssueContextStoreIsSpaEnabled)();
    return isSpaEnabled;
};
const $7e3614f655e5103c$export$7be495880d433ab9 = ()=>{
    const [loginRedirectUrl] = (0, $hWdjG.useIssueContextStoreLoginRedirctUrl)();
    return loginRedirectUrl;
};
const $7e3614f655e5103c$export$52c975cf0b623556 = ()=>{
    const [onIssueKeyChange] = (0, $hWdjG.useIssueContextStoreOnIssueKeyChange)();
    return onIssueKeyChange;
};
const $7e3614f655e5103c$export$b34d0ea0bf41fee = ()=>{
    const [rapidViewId] = (0, $hWdjG.useIssueContextStoreRapidViewId)();
    return rapidViewId;
};
const $7e3614f655e5103c$export$7c142b5701b4c3f9 = ()=>{
    const [viewScreenId] = (0, $hWdjG.useIssueContextStoreViewScreenId)();
    return viewScreenId;
};
const $7e3614f655e5103c$export$dcc0d1c3cd4bd9fb = ()=>{
    const licensedProducts = (0, $j3FUN.useLicensedProducts)();
    const licenseStates = (0, $jBTMs.useLicenseStates)();
    const isJiraSoftwareLicenseActive = licenseStates && licenseStates.software === (0, $7HKaW.LICENSE_STATE_ACTIVE);
    return licensedProducts[(0, $e91YZ.LICENSED_PRODUCTS).JIRA_SOFTWARE] && isJiraSoftwareLicenseActive;
};
const $7e3614f655e5103c$export$2e131fc4108f9106 = ()=>{
    const analyticsSource = $7e3614f655e5103c$export$aad3917152559b87();
    return analyticsSource === (0, $0100842672acae20$export$b19f949fb9713614);
};
const $7e3614f655e5103c$export$4596c26005fbb859 = ()=>{
    const analyticsSource = $7e3614f655e5103c$export$aad3917152559b87();
    return analyticsSource === (0, $0100842672acae20$export$a5132300c5214280);
};
const $7e3614f655e5103c$export$b131d9f6da853161 = ()=>{
    const [isAiOptInEnabled] = (0, $hWdjG.useIssueContextIsAiOptInEnabled)();
    return isAiOptInEnabled;
};

});
parcelRegister("j3FUN", function(module, exports) {

$parcel$export(module.exports, "useLicensedProducts", () => $02df0e5ac33ae573$export$54d534cc91e54850);

var $gd0Sp = parcelRequire("gd0Sp");
const $02df0e5ac33ae573$export$54d534cc91e54850 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.licensedProducts || {};
};

});

parcelRegister("jBTMs", function(module, exports) {

$parcel$export(module.exports, "useLicenseStates", () => $0a5df676eadd90b5$export$268651a63abe408a);

var $gd0Sp = parcelRequire("gd0Sp");
const $0a5df676eadd90b5$export$268651a63abe408a = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.licenseStates;
};

});

parcelRegister("hWdjG", function(module, exports) {

$parcel$export(module.exports, "useIssueContextStoreChildIssuesLimit", () => $c495211a89197754$export$abdbea56d86b4aac);
$parcel$export(module.exports, "useIssueContextStoreChildIssuesIssueLimitUrls", () => $c495211a89197754$export$326ff2b963d51c5c);
$parcel$export(module.exports, "useIssueContextStoreIssueKey", () => $c495211a89197754$export$44bcaaabb74e402b);
$parcel$export(module.exports, "useIssueContextStoreIssueId", () => $c495211a89197754$export$332dcee0cf9f4e45);
$parcel$export(module.exports, "useIssueContextStoreIsArchived", () => $c495211a89197754$export$c940355b1fc6e1c4);
$parcel$export(module.exports, "useIssueContextStoreIsClassifyEditEnabled", () => $c495211a89197754$export$b9eebaa1da421997);
$parcel$export(module.exports, "useIssueContextStoreIsModal", () => $c495211a89197754$export$daa47fd600e43a32);
$parcel$export(module.exports, "useIssueContextStoreViewScreenId", () => $c495211a89197754$export$ba2e9546ab5ba6f);
$parcel$export(module.exports, "useIssueContextStoreAnalyticsSource", () => $c495211a89197754$export$74d38d6c437efc1b);
$parcel$export(module.exports, "useIssueContextRapidViewMap", () => $c495211a89197754$export$2092528ee170d9e7);
$parcel$export(module.exports, "useIssueContextStoreMaxTokenLength", () => $c495211a89197754$export$57898374e6239a5a);
$parcel$export(module.exports, "useIssueContextStoreIsLoadedWithPage", () => $c495211a89197754$export$ff0264ec4c015dc1);
$parcel$export(module.exports, "useIssueContextStoreEstimationStatistic", () => $c495211a89197754$export$6c8b81f6dca8c23d);
$parcel$export(module.exports, "useIssueContextStoreIsLoading", () => $c495211a89197754$export$fe7085456138f0fc);
$parcel$export(module.exports, "useIssueContextStoreViewMode", () => $c495211a89197754$export$c339e36468c12443);
$parcel$export(module.exports, "useIssueContextStoreBackButtonUrl", () => $c495211a89197754$export$ef3bfa2642bb98cd);
$parcel$export(module.exports, "useIssueContextStoreIssueNavigatorData", () => $c495211a89197754$export$8accd063c74cd455);
$parcel$export(module.exports, "useIssueContextStoreBoardId", () => $c495211a89197754$export$e7edffc2a20027e7);
$parcel$export(module.exports, "useIssueContextStoreBoardType", () => $c495211a89197754$export$48aaa3a6bc2085d7);
$parcel$export(module.exports, "useIssueContextStoreIsSpaEnabled", () => $c495211a89197754$export$4a4b96bcf5166327);
$parcel$export(module.exports, "useIssueContextStoreLoginRedirctUrl", () => $c495211a89197754$export$bbd8ba0180545556);
$parcel$export(module.exports, "useIssueContextStoreOnIssueKeyChange", () => $c495211a89197754$export$aaa89627762c7d00);
$parcel$export(module.exports, "useIssueContextStoreRapidViewId", () => $c495211a89197754$export$796589b0ec52848a);
$parcel$export(module.exports, "useIssueContextIsAiOptInEnabled", () => $c495211a89197754$export$7e70ee570119a0a7);
$parcel$export(module.exports, "IssueContextContainer", () => $c495211a89197754$export$93db6a8f3342dddf);
$parcel$export(module.exports, "useIssueContextStoreActions", () => $c495211a89197754$export$965360ae27fcae98);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $6vrw7 = parcelRequire("6vrw7");

var $8d785 = parcelRequire("8d785");

var $hHM8F = parcelRequire("hHM8F");

var $fhgeS = parcelRequire("fhgeS");
const $c495211a89197754$export$d4c72bab9d6cc13a = {
    childIssuesLimit: undefined,
    childIssuesIssueLimitUrls: undefined,
    issueKey: (0, $6vrw7.toIssueKey)(''),
    isArchived: false,
    isClassifyEditEnabled: false,
    isModal: false,
    maxTokenLength: 0,
    isLoadedWithPage: false,
    rapidViewMap: undefined,
    estimationStatistic: undefined,
    isLoading: false,
    // initialise viewMode with the value stored in local storage
    viewMode: (0, $fhgeS.getViewModeFromLocalStorage)(),
    analyticsSource: undefined,
    backButtonUrl: undefined,
    issueNavigatorData: undefined,
    boardId: undefined,
    boardType: undefined,
    isSpaEnabled: false,
    loginRedirectUrl: undefined,
    onIssueKeyChange: undefined,
    rapidViewId: undefined,
    viewScreenId: undefined,
    isAiOptInEnabled: false
};
const $c495211a89197754$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'issue-context',
    initialState: $c495211a89197754$export$d4c72bab9d6cc13a,
    actions: $8d785.actions
});
const $c495211a89197754$var$getIssueContext = (state)=>state;
const $c495211a89197754$var$getIsModal = (state)=>state.isModal;
const $c495211a89197754$var$getIssueKey = (state)=>state.issueKey;
const $c495211a89197754$var$getIsArchived = (state)=>state.isArchived;
const $c495211a89197754$var$getIsClassifyEditEnabled = (state)=>state.isClassifyEditEnabled;
const $c495211a89197754$var$getIssueId = (state)=>state.issueId;
// @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
const $c495211a89197754$var$getAnalyticsSource = (state)=>state.analyticsSource !== undefined ? state.analyticsSource : undefined;
const $c495211a89197754$var$getRapidViewMap = (state)=>state.rapidViewMap;
const $c495211a89197754$var$getMaxTokenLength = (state)=>state.maxTokenLength;
const $c495211a89197754$var$getIsLoadedWithPage = (state)=>state.isLoadedWithPage;
const $c495211a89197754$var$getEstimationStatistic = (state)=>state.estimationStatistic;
const $c495211a89197754$var$getIsLoading = (state)=>state.isLoading;
const $c495211a89197754$var$getViewMode = (state)=>state.viewMode;
const $c495211a89197754$var$getBackButtonUrl = (state)=>state.backButtonUrl;
const $c495211a89197754$var$getIssueNavigatorData = (state)=>state.issueNavigatorData;
const $c495211a89197754$var$getBoardId = (state)=>state.boardId;
const $c495211a89197754$var$getBoardType = (state)=>state.boardType;
const $c495211a89197754$var$getIsSpaEnabled = (state)=>state.isSpaEnabled;
const $c495211a89197754$var$getLoginRedirectUrl = (state)=>state.loginRedirectUrl;
const $c495211a89197754$var$getOnIssueKeyChange = (state)=>state.onIssueKeyChange;
const $c495211a89197754$var$getRapidViewId = (state)=>state.rapidViewId;
const $c495211a89197754$var$getViewScreenId = (state)=>state.viewScreenId;
const $c495211a89197754$var$getIsAiOptInEnabled = (state)=>Boolean(state.isAiOptInEnabled);
const $c495211a89197754$export$f6e0a3ee03299fbc = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueContext
});
const $c495211a89197754$export$abdbea56d86b4aac = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: (0, $hHM8F.getChildIssuesLimit)
});
const $c495211a89197754$export$326ff2b963d51c5c = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: (0, $hHM8F.getChildIssuesIssueLimitUrls)
});
const $c495211a89197754$export$44bcaaabb74e402b = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueKey
});
const $c495211a89197754$export$332dcee0cf9f4e45 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueId
});
const $c495211a89197754$export$c940355b1fc6e1c4 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsArchived
});
const $c495211a89197754$export$b9eebaa1da421997 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsClassifyEditEnabled
});
const $c495211a89197754$export$daa47fd600e43a32 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsModal
});
const $c495211a89197754$export$ba2e9546ab5ba6f = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getViewScreenId
});
const $c495211a89197754$export$74d38d6c437efc1b = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getAnalyticsSource
});
const $c495211a89197754$export$2092528ee170d9e7 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getRapidViewMap
});
const $c495211a89197754$export$57898374e6239a5a = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getMaxTokenLength
});
const $c495211a89197754$export$ff0264ec4c015dc1 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsLoadedWithPage
});
const $c495211a89197754$export$6c8b81f6dca8c23d = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getEstimationStatistic
});
const $c495211a89197754$export$fe7085456138f0fc = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsLoading
});
const $c495211a89197754$export$c339e36468c12443 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getViewMode
});
const $c495211a89197754$export$ef3bfa2642bb98cd = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getBackButtonUrl
});
const $c495211a89197754$export$8accd063c74cd455 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueNavigatorData
});
const $c495211a89197754$export$e7edffc2a20027e7 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getBoardId
});
const $c495211a89197754$export$48aaa3a6bc2085d7 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getBoardType
});
const $c495211a89197754$export$4a4b96bcf5166327 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsSpaEnabled
});
const $c495211a89197754$export$bbd8ba0180545556 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getLoginRedirectUrl
});
const $c495211a89197754$export$aaa89627762c7d00 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getOnIssueKeyChange
});
const $c495211a89197754$export$796589b0ec52848a = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getRapidViewId
});
const $c495211a89197754$export$7e70ee570119a0a7 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsAiOptInEnabled
});
const $c495211a89197754$export$93db6a8f3342dddf = (0, $heB5U.createContainer)($c495211a89197754$export$6f57813fe9f31bf9);
const $c495211a89197754$export$965360ae27fcae98 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("8d785", function(module, exports) {

$parcel$export(module.exports, "actions", () => $0a3f8ba487c482e8$export$e324594224ef24da);

var $7LyiF = parcelRequire("7LyiF");

var $hHM8F = parcelRequire("hHM8F");


var $fhgeS = parcelRequire("fhgeS");
const $0a3f8ba487c482e8$export$784a03c4b74da53e = (issueContext)=>({ setState: setState, getState: getState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !issueContext.issueId && issueContext.issueKey !== currentIssueKey) setState({
            ...issueContext,
            issueId: undefined,
            viewMode: issueContext.viewMode || getState().viewMode
        });
        else setState({
            ...issueContext,
            viewMode: issueContext.viewMode || getState().viewMode
        });
    };
const $0a3f8ba487c482e8$export$666ee48e0eaf4f13 = (partialIssueContext)=>({ getState: getState, setState: setState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !partialIssueContext.issueId && partialIssueContext.issueKey && partialIssueContext.issueKey !== currentIssueKey) setState({
            ...getState(),
            ...partialIssueContext,
            issueId: undefined
        });
        else setState({
            ...getState(),
            ...partialIssueContext
        });
    };
const $0a3f8ba487c482e8$export$89b6937a83edcaa6 = ()=>({ getState: getState })=>(0, $hHM8F.getChildIssuesLimit)(getState());
const $0a3f8ba487c482e8$export$e40f2acaf1a50b00 = ()=>({ getState: getState })=>getState().maxTokenLength;
const $0a3f8ba487c482e8$export$2fe981b90be13483 = ()=>({ getState: getState })=>getState().isLoadedWithPage;
const $0a3f8ba487c482e8$export$afce556782490aae = ()=>({ getState: getState })=>getState().backButtonUrl;
const $0a3f8ba487c482e8$export$711dfa096bf81f2d = ()=>({ getState: getState })=>getState().isSpaEnabled;
const $0a3f8ba487c482e8$export$4a030f6192bebe03 = ()=>({ getState: getState })=>getState().issueKey;
const $0a3f8ba487c482e8$export$b41341ac6c74ca6 = ()=>({ getState: getState })=>getState().isArchived;
const $0a3f8ba487c482e8$export$77ec0de2f63f10c4 = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $7LyiF.localStorage).set((0, $7LyiF.VIEW_MODE_STORAGE_KEY), (0, $935e771f19f8ea28$export$98c0ebc22792f04));
        setState({
            viewMode: (0, $935e771f19f8ea28$export$98c0ebc22792f04)
        });
    };
const $0a3f8ba487c482e8$export$b303af51de56a0e = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $7LyiF.localStorage).set((0, $7LyiF.VIEW_MODE_STORAGE_KEY), (0, $935e771f19f8ea28$export$705305d6da432040));
        setState({
            viewMode: (0, $935e771f19f8ea28$export$705305d6da432040)
        });
    };
const $0a3f8ba487c482e8$export$75007d125f198b78 = ()=>({ setState: setState })=>{
        setState({
            viewMode: (0, $fhgeS.getViewModeFromLocalStorage)()
        });
    };
const $0a3f8ba487c482e8$export$e324594224ef24da = {
    setIssueContext: $0a3f8ba487c482e8$export$784a03c4b74da53e,
    mergeIssueContext: $0a3f8ba487c482e8$export$666ee48e0eaf4f13,
    getChildIssuesLimit: $0a3f8ba487c482e8$export$89b6937a83edcaa6,
    getMaxTokenLength: $0a3f8ba487c482e8$export$e40f2acaf1a50b00,
    getIsLoadedWithPage: $0a3f8ba487c482e8$export$2fe981b90be13483,
    getBackButtonUrl: $0a3f8ba487c482e8$export$afce556782490aae,
    getIsSpaEnabled: $0a3f8ba487c482e8$export$711dfa096bf81f2d,
    getIssueKey: $0a3f8ba487c482e8$export$4a030f6192bebe03,
    getIsArchived: $0a3f8ba487c482e8$export$b41341ac6c74ca6,
    setDetailViewAsModal: $0a3f8ba487c482e8$export$77ec0de2f63f10c4,
    setDetailViewAsSidebar: $0a3f8ba487c482e8$export$b303af51de56a0e,
    resetDetailView: $0a3f8ba487c482e8$export$75007d125f198b78
};

});
parcelRegister("7LyiF", function(module, exports) {

$parcel$export(module.exports, "LOG_LOCATION", () => $7643f341d271ccc9$export$25a759e49d5049db);
$parcel$export(module.exports, "localStorage", () => $7643f341d271ccc9$export$c2ed3351cac403d1);
$parcel$export(module.exports, "VIEW_MODE_STORAGE_KEY", () => $7643f341d271ccc9$export$a13f7f627010bccd);

var $aZaPn = parcelRequire("aZaPn");
const $7643f341d271ccc9$export$25a759e49d5049db = 'issue.issue-context-service';
const $7643f341d271ccc9$export$c2ed3351cac403d1 = (0, $aZaPn.createLocalStorageProvider)('jira_issue_view');
const $7643f341d271ccc9$export$a13f7f627010bccd = 'view-mode';

});

parcelRegister("hHM8F", function(module, exports) {

$parcel$export(module.exports, "getChildIssuesLimit", () => $a9a8c93b5bcca8ab$export$89b6937a83edcaa6);
$parcel$export(module.exports, "getChildIssuesIssueLimitUrls", () => $a9a8c93b5bcca8ab$export$8f43520910e8128c);

var $gUUjF = parcelRequire("gUUjF");

var $7LyiF = parcelRequire("7LyiF");
// This is here solely as a last resort option if the backend for some reason
// is unable to propagate the limit. Or if somehow the code that populates
// this store is broken.
// 500 is the current limit reflected in the backend at the time of writing.
const $a9a8c93b5bcca8ab$var$FALLBACK_CHILD_ISSUES_LIMIT = 500;
const $a9a8c93b5bcca8ab$var$getFallbackChildIssuesLimitAndLogAsUnexpected = ()=>{
    (0, $gUUjF.default).safeErrorWithoutCustomerData(`${(0, $7LyiF.LOG_LOCATION)}.selectors.getChildIssuesLimit`, 'The child issues limit is undefined using the fallback child issues limit');
    return $a9a8c93b5bcca8ab$var$FALLBACK_CHILD_ISSUES_LIMIT;
};
const $a9a8c93b5bcca8ab$export$89b6937a83edcaa6 = (state)=>state.childIssuesLimit ?? $a9a8c93b5bcca8ab$var$getFallbackChildIssuesLimitAndLogAsUnexpected();
const $a9a8c93b5bcca8ab$export$8f43520910e8128c = (state)=>state.childIssuesIssueLimitUrls;

});

parcelRegister("fhgeS", function(module, exports) {

$parcel$export(module.exports, "getViewModeFromLocalStorage", () => $49ad189ccd6ad8c9$export$cae7c4c591dcc261);

var $7LyiF = parcelRequire("7LyiF");

const $49ad189ccd6ad8c9$export$cae7c4c591dcc261 = ()=>(0, $7LyiF.localStorage).get((0, $7LyiF.VIEW_MODE_STORAGE_KEY)) || (0, $935e771f19f8ea28$export$2d037fdba4f67558);

});





parcelRegister("bmpW6", function(module, exports) {

$parcel$export(module.exports, "IncrementPlanningBoardMenu", () => $24b68b28b9445396$export$9a207652c43c8852);

var $eUqFw = parcelRequire("eUqFw");

var $bULPy = parcelRequire("bULPy");
var $8PFhw = parcelRequire("8PFhw");
var $8BKky = parcelRequire("8BKky");

var $5JgJ2 = parcelRequire("5JgJ2");

var $iS4KV = parcelRequire("iS4KV");

var $l3HJG = parcelRequire("l3HJG");
var $c3qrZ = parcelRequire("c3qrZ");

var $77HF9 = parcelRequire("77HF9");

var $8MrYx = parcelRequire("8MrYx");
const $24b68b28b9445396$export$9a207652c43c8852 = ({ viewAs: viewAs, boardId: boardId, isSwimlanesEnabled: isSwimlanesEnabled = false, onHandleChange: onHandleChange, onSwimlaneExpandAll: // eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneExpandAll = ()=>{}, onSwimlaneCollapseAll: // eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneCollapseAll = ()=>{} })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [state, actions] = (0, $8MrYx.useViewSettings)();
    const { setShowUnscheduledColumn: setShowUnscheduledColumn } = actions;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8PFhw.default), {
        "data-testId": "software-view-settings.ui.view-settings-menu.menu-increment-planning-board"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77HF9.ViewSettingsToggle), {
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.show-unscheduled-column-toggle",
        title: formatMessage((0, $iS4KV.default).showUnscheduledWork),
        onChange: ()=>{
            setShowUnscheduledColumn(boardId, !state.showUnscheduledColumn);
            onHandleChange((0, $l3HJG.ActionSubject).TOGGLE, {
                key: (0, $l3HJG.ToggleKey).UNSCHEDULED_COLUMN_TOGGLE,
                state: !state.showUnscheduledColumn
            });
        },
        isChecked: state.showUnscheduledColumn,
        viewAs: viewAs
    })), isSwimlanesEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        title: formatMessage((0, $iS4KV.default).swimlanes),
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        "data-testid": "software-view-settings.ui.view-settings-menu.views.increment-planning-board.expand-all",
        onClick: ()=>{
            onSwimlaneExpandAll();
            onHandleChange((0, $l3HJG.ActionSubject).BUTTON, {
                key: (0, $l3HJG.ToggleKey).SWIMLANE_EXPAND_ALL,
                state: (0, $c3qrZ.ExpandableState).EXPANDED
            });
        }
    }, formatMessage((0, $iS4KV.default).expandAll)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        "data-testid": "software-view-settings.ui.view-settings-menu.views.increment-planning-board.collapse-all",
        onClick: ()=>{
            onSwimlaneCollapseAll();
            onHandleChange((0, $l3HJG.ActionSubject).BUTTON, {
                key: (0, $l3HJG.ToggleKey).SWIMLANE_COLLAPSE_ALL,
                state: (0, $c3qrZ.ExpandableState).COLLAPSED
            });
        }
    }, formatMessage((0, $iS4KV.default).collapseAll))));
};

});


parcelRegister("78u8L", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsPanelOnboarding", () => $e36b93518f354014$export$215da70478ebbc7);
$parcel$export(module.exports, "ViewSettingsPanelButtonSpotlight", () => $e36b93518f354014$export$67c31a192079fb3c);
$parcel$export(module.exports, "VIEW_SETTINGS_PANEL_TARGET", () => $4d633a261a02c90e$export$989661c424340ff8);

var $eUqFw = parcelRequire("eUqFw");

var $eri7S = parcelRequire("eri7S");

var $hJJD2 = parcelRequire("hJJD2");
var $ltfxy = parcelRequire("ltfxy");
var $7zpSo = parcelRequire("7zpSo");

var $PdmhA = parcelRequire("PdmhA");

var $5ge6s = parcelRequire("5ge6s");

var $9zysr = parcelRequire("9zysr");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kS8l2 = parcelRequire("kS8l2");

var $6eyW6 = parcelRequire("6eyW6");


var $1bLbs = parcelRequire("1bLbs");
const $e36b93518f354014$export$83d026e3dd5706d = ({ stop: stop, children: children })=>children(stop);
const $e36b93518f354014$var$ViewSettingsPanelOnboardingBase = ({ onTogglePanel: onTogglePanel, isViewSettingPanelOpen: isViewSettingPanelOpen })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [viewSettingsPanelRef] = (0, $kS8l2.useGlobalRef)((0, $4d633a261a02c90e$export$989661c424340ff8));
    const [addPeopleButtonRef] = (0, $kS8l2.useGlobalRef)((0, $4d633a261a02c90e$export$4a16d41d3ff730bf));
    const [activeSpotlight, setActiveSpotlight] = (0, $eUqFw.useState)(0);
    const next = (0, $eUqFw.useCallback)(()=>setActiveSpotlight((current)=>current !== null ? current + 1 : 0), []);
    const renderSpotlight = (0, $eUqFw.useCallback)((stop)=>{
        const finalStepActions = [
            {
                text: formatMessage((0, $1bLbs.default).doneStepButton),
                onClick: ()=>{
                    isViewSettingPanelOpen && onTogglePanel();
                    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jswViewSettingsPanelSpotlightDone');
                    setActiveSpotlight(null);
                    stop && stop();
                }
            }
        ];
        const isAddPeopleButtonAvailable = Boolean(addPeopleButtonRef);
        const numberOfSpotlights = isAddPeopleButtonAvailable ? 3 : 2;
        const spotlights = [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJJD2.default), {
                key: (0, $4d633a261a02c90e$export$a57856d4380e4bb8),
                target: (0, $4d633a261a02c90e$export$a57856d4380e4bb8),
                heading: formatMessage((0, $1bLbs.default).viewSettingsButtonStepTitle),
                actionsBeforeElement: `1/${numberOfSpotlights}`,
                actions: [
                    {
                        text: formatMessage((0, $1bLbs.default).nextStepButton),
                        onClick: ()=>{
                            !isViewSettingPanelOpen && onTogglePanel();
                            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jswViewSettingsPanelSpotlightNext');
                            next();
                        }
                    },
                    {
                        text: formatMessage((0, $1bLbs.default).dismissStepButton),
                        onClick: ()=>{
                            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jswViewSettingsPanelSpotlightDismiss');
                            setActiveSpotlight(null);
                            stop && stop();
                        }
                    }
                ],
                targetRadius: 3,
                targetBgColor: `var(--ds-surface, ${(0, $PdmhA).N0})`,
                dialogPlacement: "bottom right"
            }, formatMessage((0, $1bLbs.default).viewSettingsButtonStepContent)),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJJD2.default), {
                key: (0, $4d633a261a02c90e$export$989661c424340ff8),
                targetNode: viewSettingsPanelRef,
                actionsBeforeElement: `2/${numberOfSpotlights}`,
                actions: isAddPeopleButtonAvailable ? [
                    {
                        text: formatMessage((0, $1bLbs.default).nextStepButton),
                        onClick: ()=>{
                            isViewSettingPanelOpen && onTogglePanel();
                            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jswViewSettingsPanelSpotlightNext');
                            next();
                        }
                    },
                    {
                        text: formatMessage((0, $1bLbs.default).dismissStepButton),
                        onClick: ()=>{
                            isViewSettingPanelOpen && onTogglePanel();
                            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jswViewSettingsPanelSpotlightDismiss');
                            setActiveSpotlight(null);
                            stop && stop();
                        }
                    }
                ] : finalStepActions,
                targetRadius: 10,
                targetBgColor: `var(--ds-surface, ${(0, $PdmhA).N0})`,
                dialogPlacement: "left top"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $1bLbs.default).viewSettingsPanelFirstPartContent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $1bLbs.default).viewSettingsPanelSecondPartContent)))),
            isAddPeopleButtonAvailable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJJD2.default), {
                key: (0, $4d633a261a02c90e$export$4a16d41d3ff730bf),
                targetNode: addPeopleButtonRef,
                heading: formatMessage((0, $1bLbs.default).addPeopleButtonStepTitle),
                actionsBeforeElement: `3/${numberOfSpotlights}`,
                actions: finalStepActions,
                targetRadius: (0, $eri7S.AVATAR_SIZES).medium,
                targetBgColor: `var(--ds-surface, ${(0, $PdmhA).N0})`,
                dialogPlacement: "bottom left"
            }, formatMessage((0, $1bLbs.default).addPeopleButtonStepContent)) : null
        ];
        return activeSpotlight != null ? spotlights[activeSpotlight] : null;
    }, [
        activeSpotlight,
        createAnalyticsEvent,
        formatMessage,
        isViewSettingPanelOpen,
        next,
        onTogglePanel,
        viewSettingsPanelRef,
        addPeopleButtonRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ge6s.default), {
        messageId: (0, $4d633a261a02c90e$export$8be246eeba922980)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e36b93518f354014$export$83d026e3dd5706d, null, (stop)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7zpSo.default), null, renderSpotlight(stop))));
};
const $e36b93518f354014$export$215da70478ebbc7 = (0, $9zysr.componentWithCondition)((0, $6eyW6.isViewSettingsPanelAndTailoredViewExperimentEnabled), $e36b93518f354014$var$ViewSettingsPanelOnboardingBase, ()=>null);
const $e36b93518f354014$export$67c31a192079fb3c = ({ children: children })=>{
    if ((0, $6eyW6.isViewSettingsPanelAndTailoredViewExperimentEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
        name: (0, $4d633a261a02c90e$export$a57856d4380e4bb8)
    }, children);
    return children;
};

});
parcelRegister("5ge6s", function(module, exports) {

$parcel$export(module.exports, "CoordinationClient", () => $67d1cec28351d2e7$export$580a2294c917898c);
$parcel$export(module.exports, "default", () => $67d1cec28351d2e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $xMKqn = parcelRequire("xMKqn");
var $DEVKo = parcelRequire("DEVKo");

var $9RC8H = parcelRequire("9RC8H");

var $jGBLd = parcelRequire("jGBLd");

var $e91YZ = parcelRequire("e91YZ");

var $1ybV0 = parcelRequire("1ybV0");

var $6rW04 = parcelRequire("6rW04");

var $jD3pk = parcelRequire("jD3pk");
const $67d1cec28351d2e7$var$isSyntheticTenant = ()=>(0, $6rW04.default)('ajs-is-synthetic') === 'true';
class $67d1cec28351d2e7$export$580a2294c917898c extends (0, $DEVKo.default) {
    constructor(cloudId, stargateUrl, shouldAllowOnSynthetic = false, orgId = '', messageType = 'transactional', onMessageDisposition){
        const enableChoreographer = (0, $jGBLd.shouldBeChoreographed)({
            messageType: messageType
        }) && (0, $1ybV0.ff)('post-office_enable_jira_choreographer');
        const coordinationOptions = {
            enableChoreographer: enableChoreographer
        };
        super({
            cloudId: cloudId,
            stargateUrl: stargateUrl,
            orgId: orgId,
            isFedRAMPEnvironment: false,
            coordinationOptions: coordinationOptions
        });
        this.shouldUseMockClient = $67d1cec28351d2e7$var$isSyntheticTenant() && !shouldAllowOnSynthetic;
        this.enableChoreographer = enableChoreographer;
        this.onMessageDisposition = onMessageDisposition;
        // // This is a permanant flag: go/jira-ep-debugging
        this.isDebugModeEnabled = (0, $1ybV0.ff)('ep-external-message-debug-mode');
    }
    async start(messageId) {
        if (this.isDebugModeEnabled) {
            const serverResponse = await super.start(messageId);
            if (this.enableChoreographer) this.onMessageDisposition?.(serverResponse ? (0, $9RC8H.MessageDeliveryStatus).STARTED : (0, $9RC8H.MessageDeliveryStatus).BLOCKED);
            // eslint-disable-next-line no-alert, no-restricted-globals
            const shouldShowMessage = confirm(`\u{1F41E} \u{1D5D8}\u{1D5E3} \u{1D5D8}\u{1D605}\u{1D601}\u{1D5F2}\u{1D5FF}\u{1D5FB}\u{1D5EE}\u{1D5F9} \u{1D5E0}\u{1D5F2}\u{1D600}\u{1D600}\u{1D5EE}\u{1D5F4}\u{1D5F2} \u{1D5D7}\u{1D5F2}\u{1D5EF}\u{1D602}\u{1D5F4}\u{1D5F4}\u{1D5F2}\u{1D5FF}

Message ID: ${messageId}
Start call server response: ${serverResponse}

Do you want to display the message?`);
            if (!shouldShowMessage) {
                const didStop = await super.stop(messageId);
                if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, $9RC8H.MessageDeliveryStatus).STOPPED : (0, $9RC8H.MessageDeliveryStatus).BLOCKED);
            }
            return shouldShowMessage;
        }
        return this.shouldUseMockClient ? false // never allow messages to start
         : super.start(messageId).then((didStart)=>{
            if (this.enableChoreographer) this.onMessageDisposition?.(didStart ? (0, $9RC8H.MessageDeliveryStatus).STARTED : (0, $9RC8H.MessageDeliveryStatus).BLOCKED);
            return didStart;
        });
    }
    async stop(messageId) {
        return this.shouldUseMockClient ? true // always allow messages to stop
         : super.stop(messageId).then((didStop)=>{
            if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, $9RC8H.MessageDeliveryStatus).STOPPED : (0, $9RC8H.MessageDeliveryStatus).BLOCKED);
            return didStop;
        });
    }
}
function $67d1cec28351d2e7$export$2e2bcd8739ae039(props) {
    const { cloudId: cloudId } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const stargateUrl = '/gateway/api';
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const client = new $67d1cec28351d2e7$export$580a2294c917898c(cloudId, stargateUrl, props.shouldAllowOnSynthetic, orgId, props.messageType, props.onMessageDisposition);
    const { fallback: fallback, messageId: messageId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $xMKqn.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        client: client,
        fallback: fallback,
        messageId: messageId
    }, props.children);
}

});
parcelRegister("jGBLd", function(module, exports) {

$parcel$export(module.exports, "shouldBeChoreographed", () => $38eaf8660dcaa871$export$a8ba9111c7eec9ac);

var $eI5EY = parcelRequire("eI5EY");

var $EbGpR = parcelRequire("EbGpR");
function $38eaf8660dcaa871$export$a8ba9111c7eec9ac(props) {
    return (0, $eI5EY.fg)('po-jira-choreographer-api-integration') ? !!props?.messageType && (0, $EbGpR.IntegratedChoreographerMessageTypesEnum).includes(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    props.messageType) : false;
}

});
parcelRegister("EbGpR", function(module, exports) {

$parcel$export(module.exports, "IntegratedChoreographerMessageTypesEnum", () => $e5c6b031155cf9c2$export$dbe9e38c9d6f26d0);
const $e5c6b031155cf9c2$export$94e85cf3348f045a = {
    ENGAGEMENT: 'engagement',
    MARKETING: 'marketing',
    TRANSACTIONAL: 'transactional'
};
const $e5c6b031155cf9c2$export$dbe9e38c9d6f26d0 = [
    $e5c6b031155cf9c2$export$94e85cf3348f045a.ENGAGEMENT,
    $e5c6b031155cf9c2$export$94e85cf3348f045a.MARKETING
];

});



const $4d633a261a02c90e$export$8be246eeba922980 = 'jsw-tailored-board-view-onboarding';
const $4d633a261a02c90e$export$a57856d4380e4bb8 = 'viewSettingsButtonTarget';
const $4d633a261a02c90e$export$989661c424340ff8 = 'viewSettingsPanelTarget';
const $4d633a261a02c90e$export$4a16d41d3ff730bf = 'addPeopleButtonTarget';

parcelRegister("1bLbs", function(module, exports) {

$parcel$export(module.exports, "default", () => $6059903933cb64a4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6059903933cb64a4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    viewSettingsButtonStepTitle: {
        "id": "software-view-settings.view-settings-panel-onboarding.view-settings-button-step-title",
        "defaultMessage": "Customize your view"
    },
    viewSettingsButtonStepContent: {
        "id": "software-view-settings.view-settings-panel-onboarding.view-settings-button-step-content",
        "defaultMessage": "Use view settings to simplify the look and feel of your board and backlog."
    },
    viewSettingsPanelFirstPartContent: {
        "id": "software-view-settings.view-settings-panel-onboarding.view-settings-panel-first-part-content",
        "defaultMessage": "Switch on what you need, and switch off what you don\u2019t."
    },
    viewSettingsPanelSecondPartContent: {
        "id": "software-view-settings.view-settings-panel-onboarding.view-settings-panel-second-part-content",
        "defaultMessage": "Choose to show or hide panels, filters, and issue fields, and change the density of your view."
    },
    addPeopleButtonStepTitle: {
        "id": "software-view-settings.view-settings-panel-onboarding.add-people-button-step-title",
        "defaultMessage": "Share your view"
    },
    addPeopleButtonStepContent: {
        "id": "software-view-settings.view-settings-panel-onboarding.add-people-button-step-content",
        "defaultMessage": "Now when you add a new teammate to Jira, you can share your view settings so they see what you see. Includes view settings and filters."
    },
    nextStepButton: {
        "id": "software-view-settings.view-settings-panel-onboarding.next-step-button",
        "defaultMessage": "Next"
    },
    dismissStepButton: {
        "id": "software-view-settings.view-settings-panel-onboarding.dismiss-step-button",
        "defaultMessage": "Dismiss"
    },
    doneStepButton: {
        "id": "software-view-settings.view-settings-panel-onboarding.done-step-button",
        "defaultMessage": "Done"
    }
});

});



parcelRegister("lMwdE", function(module, exports) {

$parcel$export(module.exports, "useAllCardGroups", () => $2a4423c88f75b96c$export$c3f5757fe39cf802);

var $1gQ73 = parcelRequire("1gQ73");

var $bP7Jx = parcelRequire("bP7Jx");
const $2a4423c88f75b96c$export$c3f5757fe39cf802 = ()=>{
    const allCardGroups = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.makeGetAllAttachedToParentCardGroupEntries))();
    return allCardGroups;
};

});





parcelRegister("d9eLC", function(module, exports) {

$parcel$export(module.exports, "PanelWrapper", () => $2f26eba6efa23681$export$f537a9b13aef4d02);
$parcel$export(module.exports, "EpicPanelWithErrorBoundary", () => $2f26eba6efa23681$export$852c474275ac8b90);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $0cdA8 = parcelRequire("0cdA8");

var $1ybV0 = parcelRequire("1ybV0");

var $8WuJm = parcelRequire("8WuJm");

var $6GPZ5 = parcelRequire("6GPZ5");

var $4VuVx = parcelRequire("4VuVx");

var $cilnB = parcelRequire("cilnB");

var $1gQ73 = parcelRequire("1gQ73");

var $6ncr6 = parcelRequire("6ncr6");

var $bP7Jx = parcelRequire("bP7Jx");

var $2498I = parcelRequire("2498I");

var $22cnO = parcelRequire("22cnO");

var $7kNqR = parcelRequire("7kNqR");

var $j258X = parcelRequire("j258X");

var $cdPNh = parcelRequire("cdPNh");

var $diedG = parcelRequire("diedG");
const $2f26eba6efa23681$export$f69665587e333870 = ({ boardId: boardId, selectedIssues: selectedIssues, issueHierarchyLevel: issueHierarchyLevel, epicLinkFieldId: epicLinkFieldId, onEpicPanelClose: onEpicPanelClose, onCardDetailClick: onCardDetailClick, onEpicCreate: onEpicCreate, onEpicAssign: onEpicAssign, isCompanyManaged: isCompanyManaged })=>{
    const isEpicPanelOpen = (0, $cdPNh.useIsEpicPanelOpen)();
    const baseLevelCardTypes = (0, $1gQ73.useBacklogSelector)((0, $6ncr6.getBaseLevelCardTypes));
    const selectedIssuesWithTypeHierarchyLevel = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.selectedPartialCardsWithTypeHierarchyLevelSelector));
    const canCreate = (0, $1gQ73.useBacklogSelector)((0, $7kNqR.canCreateIssues));
    const canEdit = (0, $1gQ73.useBacklogSelector)((0, $7kNqR.canEditIssue));
    const firstLevelHierarchyName = (0, $1gQ73.useBacklogSelector)((0, $22cnO.getFirstLevelHierarchyName));
    const isCmpManaged = (0, $j258X.useIsCMPBacklog)();
    const sourceDroppableType = (0, $1gQ73.useBacklogSelector)((0, $2498I.getSourceDroppableType));
    return isEpicPanelOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $diedG.default), {
        experienceTarget: "epic panel",
        experienceTargetId: `${boardId}`,
        experienceSource: (0, $4VuVx.EXPERIENCE_TRACKER_PROVIDER_SOURCE)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: {
            analyticsSource: (0, $4VuVx.ANALYTICS_SOURCE_EPIC_PANEL),
            issueHierarchyLevel: issueHierarchyLevel
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f26eba6efa23681$export$f537a9b13aef4d02, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cilnB.PanelDataProvider), {
        sourceDroppableType: sourceDroppableType,
        boardId: boardId,
        isCompanyManaged: isCmpManaged
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6GPZ5.default), {
        selectedIssues: isCompanyManaged ? selectedIssuesWithTypeHierarchyLevel : selectedIssues,
        defaultIssueCreateIssueTypeId: (0, $1ybV0.ff)('jsw-create-std-issue-using-epic-panel-create-issue-_4d68w') ? baseLevelCardTypes[0]?.id.toString() : undefined,
        onClose: onEpicPanelClose,
        onCardDetailClick: onCardDetailClick,
        onEpicCreate: onEpicCreate,
        onEpicAssign: onEpicAssign,
        isCompanyManaged: isCompanyManaged,
        epicLinkFieldId: epicLinkFieldId,
        hierarchyName: firstLevelHierarchyName,
        canCreate: canCreate,
        canEdit: canEdit
    }))))) : null;
};
const $2f26eba6efa23681$export$852c474275ac8b90 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "backlogContentEpicPanel",
        teamName: "a4t-tanuki",
        packageName: "jiraSoftwareBacklog",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f26eba6efa23681$export$f69665587e333870, props));
const $2f26eba6efa23681$export$f537a9b13aef4d02 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1yt41c8u",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6GPZ5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1b331ff1be5444c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $dfXbt = parcelRequire("dfXbt");

const $a1b331ff1be5444c$export$f69665587e333870 = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("gmbbN")), {
    ssr: false,
    moduleId: "./src/packages/software/backlog-panel/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a1b331ff1be5444c$export$2e2bcd8739ae039 = (props)=>{
    const { fireErrorBoundaryExperienceFail: fireErrorBoundaryExperienceFail } = (0, $dfXbt.useViewEpicPanelExperienceTracker)({
        isClassic: props.isCompanyManaged || false
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async.jira.backlog.panel",
        packageName: "jiraSoftwareBacklogPanel",
        fallback: "flag",
        teamName: "a4t-pandora",
        onError: fireErrorBoundaryExperienceFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "backlog-panel-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a1b331ff1be5444c$export$f69665587e333870, props)));
};

});
parcelRegister("dfXbt", function(module, exports) {

$parcel$export(module.exports, "useViewEpicPanelExperienceTracker", () => $233bf5f39642a07e$export$c1017fffc722d968);
$parcel$export(module.exports, "useInlineIssueCreateEpicPanelExperienceTracker", () => $233bf5f39642a07e$export$7ab965f5d69be412);
$parcel$export(module.exports, "useGlobalIssueCreateEpicPanelExperienceTracker", () => $233bf5f39642a07e$export$dff71c2c64b5caea);
$parcel$export(module.exports, "useAssignEpicPanelExperienceTracker", () => $233bf5f39642a07e$export$98afccaa5b17be1);
$parcel$export(module.exports, "useUnassignEpicPanelExperienceTracker", () => $233bf5f39642a07e$export$51f7a79bb0e6c44e);
$parcel$export(module.exports, "useRankExperienceTracker", () => $233bf5f39642a07e$export$8942fc10da43a00a);

var $j6rOo = parcelRequire("j6rOo");

var $4VuVx = parcelRequire("4VuVx");
const $233bf5f39642a07e$export$c1017fffc722d968 = (attributes = {})=>(0, $j6rOo.useExperienceTracker)((0, $4VuVx.APP_ID), (0, $4VuVx.EPIC_PANEL_VIEW_EXPERIENCE), (0, $4VuVx.EXPERIENCE_TRACKER_PROVIDER_SOURCE), attributes);
const $233bf5f39642a07e$export$7ab965f5d69be412 = (attributes = {})=>(0, $j6rOo.useExperienceTracker)((0, $4VuVx.APP_ID), (0, $4VuVx.EPIC_PANEL_INLINE_ISSUE_CREATE_EXPERIENCE), (0, $4VuVx.EXPERIENCE_TRACKER_PROVIDER_SOURCE), attributes);
const $233bf5f39642a07e$export$dff71c2c64b5caea = (attributes = {})=>(0, $j6rOo.useExperienceTracker)((0, $4VuVx.APP_ID), (0, $4VuVx.EPIC_PANEL_GLOBAL_ISSUE_CREATE_EXPERIENCE), (0, $4VuVx.EXPERIENCE_TRACKER_PROVIDER_SOURCE), attributes);
const $233bf5f39642a07e$export$98afccaa5b17be1 = (attributes = {})=>(0, $j6rOo.useExperienceTracker)((0, $4VuVx.APP_ID), (0, $4VuVx.EPIC_PANEL_ASSIGN_EXPERIENCE), (0, $4VuVx.EXPERIENCE_TRACKER_PROVIDER_SOURCE), attributes);
const $233bf5f39642a07e$export$51f7a79bb0e6c44e = (attributes = {})=>(0, $j6rOo.useExperienceTracker)((0, $4VuVx.APP_ID), (0, $4VuVx.EPIC_PANEL_UNASSIGN_EXPERIENCE), (0, $4VuVx.EXPERIENCE_TRACKER_PROVIDER_SOURCE), attributes);
const $233bf5f39642a07e$export$8942fc10da43a00a = (attributes = {})=>(0, $j6rOo.useExperienceTracker)((0, $4VuVx.APP_ID), (0, $4VuVx.EPIC_PANEL_RANK_EXPERIENCE), (0, $4VuVx.EXPERIENCE_TRACKER_PROVIDER_SOURCE), attributes);

});
parcelRegister("4VuVx", function(module, exports) {

$parcel$export(module.exports, "APP_ID", () => $acd7e1c36dce164e$export$d76071d5de2774fc);
$parcel$export(module.exports, "DIVIDER_DRAGGABLE_ID_PREFIX", () => $acd7e1c36dce164e$export$ed2b0386b406afb8);
$parcel$export(module.exports, "ANALYTICS_SOURCE_EPIC_PANEL", () => $acd7e1c36dce164e$export$f1fdbf1399e060a9);
$parcel$export(module.exports, "EXPERIENCE_TRACKER_PROVIDER_SOURCE", () => $acd7e1c36dce164e$export$d91023b42bd42fec);
$parcel$export(module.exports, "EPIC_PANEL_VIEW_EXPERIENCE", () => $acd7e1c36dce164e$export$226ec0e287da7094);
$parcel$export(module.exports, "EPIC_PANEL_INLINE_ISSUE_CREATE_EXPERIENCE", () => $acd7e1c36dce164e$export$c7ce0888e908ec32);
$parcel$export(module.exports, "EPIC_PANEL_GLOBAL_ISSUE_CREATE_EXPERIENCE", () => $acd7e1c36dce164e$export$64c0a8fb162be663);
$parcel$export(module.exports, "EPIC_PANEL_ASSIGN_EXPERIENCE", () => $acd7e1c36dce164e$export$562f3a50ddeda12d);
$parcel$export(module.exports, "EPIC_PANEL_UNASSIGN_EXPERIENCE", () => $acd7e1c36dce164e$export$95ac924aa931f0a6);
$parcel$export(module.exports, "EPIC_PANEL_RANK_EXPERIENCE", () => $acd7e1c36dce164e$export$28fe94147fbd3844);
$parcel$export(module.exports, "ABORT_EXPERIENCE_MISSING_REQUIRED_FIELD_REASON", () => $acd7e1c36dce164e$export$681650f90e45ec69);
$parcel$export(module.exports, "ABORT_EXPERIENCE_CANCELED_BY_USE_REASON", () => $acd7e1c36dce164e$export$7087cf857048f677);
$parcel$export(module.exports, "EPIC_PANEL_DROPPABLE_ID", () => $acd7e1c36dce164e$export$90fd9c0c8ddec7d);
$parcel$export(module.exports, "EPIC_PREFIX", () => $acd7e1c36dce164e$export$de67c9c28353ce6e);
$parcel$export(module.exports, "VERSION_PREFIX", () => $acd7e1c36dce164e$export$28ad8b364940d9aa);
$parcel$export(module.exports, "DEFAULT_PARENT_ISSUE_TYPE_NAME", () => $acd7e1c36dce164e$export$cb17e3c17bc50301);
$parcel$export(module.exports, "UNASSIGNED_EPIC_ID", () => $acd7e1c36dce164e$export$794f07be04aca3fe);
$parcel$export(module.exports, "UNASSIGNED_EPIC_ISSUE_KEY", () => $acd7e1c36dce164e$export$7766a7962c866d1a);
$parcel$export(module.exports, "CREATE_ISSUE_PERMISSION", () => $acd7e1c36dce164e$export$80936eba88d0cae);
$parcel$export(module.exports, "EDIT_ISSUE_PERMISSION", () => $acd7e1c36dce164e$export$762e6520d5274be2);
$parcel$export(module.exports, "REALTIME_EVENTS", () => $acd7e1c36dce164e$export$a45e758f2a5806e6);
$parcel$export(module.exports, "DND_OPERATION_CARD_PARENT_SET", () => $acd7e1c36dce164e$export$41f0d8a4d1ec169b);
$parcel$export(module.exports, "DND_OPERATION_CARD_PARENT_UNSET", () => $acd7e1c36dce164e$export$5fd94e0ea08b5e7);
$parcel$export(module.exports, "DND_OPERATION_EPIC_RANK_UPDATE", () => $acd7e1c36dce164e$export$bc493dacb9d33787);
$parcel$export(module.exports, "EPIC_CARD_DESCRIPTION_ID", () => $acd7e1c36dce164e$export$5511b715832e28a2);
$parcel$export(module.exports, "PAGE_SIZE", () => $acd7e1c36dce164e$export$8ec3d08588d2eeda);

const $acd7e1c36dce164e$export$d76071d5de2774fc = 'software.backlog-panel';
const $acd7e1c36dce164e$export$ed2b0386b406afb8 = 'DIVIDER_DRAGGABLE_ID';
const $acd7e1c36dce164e$export$f1fdbf1399e060a9 = 'epic panel';
const $acd7e1c36dce164e$export$d91023b42bd42fec = 'epicPanel';
const $acd7e1c36dce164e$export$226ec0e287da7094 = 'viewEpicPanel';
const $acd7e1c36dce164e$export$c7ce0888e908ec32 = 'createInlineIssueEpicPanel';
const $acd7e1c36dce164e$export$64c0a8fb162be663 = 'createGlobalIssueEpicPanel';
const $acd7e1c36dce164e$export$562f3a50ddeda12d = 'assignEpicPanel';
const $acd7e1c36dce164e$export$95ac924aa931f0a6 = 'unassignEpicPanel';
const $acd7e1c36dce164e$export$28fe94147fbd3844 = 'rankCardEpicPanel';
const $acd7e1c36dce164e$export$681650f90e45ec69 = 'require-field-missing';
const $acd7e1c36dce164e$export$7087cf857048f677 = 'global-issue-create-canceled-by-user';
const $acd7e1c36dce164e$export$c0489c066d9ea3d7 = 'EPIC_DRAGGABLE_ID';
const $acd7e1c36dce164e$export$90fd9c0c8ddec7d = 'EPIC_PANEL';
const $acd7e1c36dce164e$export$3db8e82d899e7d2a = 'EPIC_PANEL';
const $acd7e1c36dce164e$export$1d0e22f9f6b83f8c = 'CARD';
const $acd7e1c36dce164e$export$849c01670da437ac = 'CARD-GROUP';
const $acd7e1c36dce164e$export$de67c9c28353ce6e = 'EPIC-';
const $acd7e1c36dce164e$export$28ad8b364940d9aa = 'VERSION-';
const $acd7e1c36dce164e$export$cb17e3c17bc50301 = 'Epic';
const $acd7e1c36dce164e$export$794f07be04aca3fe = 0;
const $acd7e1c36dce164e$export$7766a7962c866d1a = 'ISK-0';
const $acd7e1c36dce164e$export$80936eba88d0cae = 'CREATE_ISSUE';
const $acd7e1c36dce164e$export$762e6520d5274be2 = 'EDIT_ISSUE';
const $acd7e1c36dce164e$export$a45e758f2a5806e6 = [
    (0, $1d129cd1c8b202ad$export$86d416e8d15777d),
    (0, $1d129cd1c8b202ad$export$b22a14d5dac59664),
    (0, $1d129cd1c8b202ad$export$25fa37e5059c5a99),
    (0, $1d129cd1c8b202ad$export$d9bc8850eeef9f60),
    (0, $1d129cd1c8b202ad$export$b22142e61b3fdbee),
    (0, $1d129cd1c8b202ad$export$6b7e46ea0442b66c)
];
const $acd7e1c36dce164e$export$dedbdcc35e955187 = 'BACKLOG';
const $acd7e1c36dce164e$export$9b8283d5878d2491 = 'BOARD';
const $acd7e1c36dce164e$export$a316570a0dbfd2b0 = 'SPRINT';
const $acd7e1c36dce164e$export$adbf9ce386bc3037 = 'activeSprint';
const $acd7e1c36dce164e$export$bb216fa10db6b6bb = 'futureSprint';
const $acd7e1c36dce164e$export$3df2915b3d2a36e = 'sprint';
const $acd7e1c36dce164e$export$338b523135b4db48 = 'board';
const $acd7e1c36dce164e$export$f6bf4fdaad3caf69 = 'backlog';
const $acd7e1c36dce164e$export$67e35e305110c91d = 'epicPanel';
const $acd7e1c36dce164e$export$f95492d2a4f371d0 = 'versionPanel';
const $acd7e1c36dce164e$export$695859afe4db61d7 = 'backlogCard';
const $acd7e1c36dce164e$export$b1b86bcaf2a12330 = 'epicPanelCard';
const $acd7e1c36dce164e$export$2e29fc7afa544ab5 = 'versionPanelCard';
const $acd7e1c36dce164e$export$62679ec8251801eb = 'divider';
const $acd7e1c36dce164e$export$41f0d8a4d1ec169b = 'cardParentSet';
const $acd7e1c36dce164e$export$5fd94e0ea08b5e7 = 'cardParentUnset';
const $acd7e1c36dce164e$export$bc493dacb9d33787 = 'epicRankUpdate';
const $acd7e1c36dce164e$export$5511b715832e28a2 = 'epicCardDescriptionId';
const $acd7e1c36dce164e$export$9efe2bc97f2b0faa = 1510;
const $acd7e1c36dce164e$export$8ec3d08588d2eeda = 100;

});


parcelRegister("gmbbN", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('gJrPr')
        ]);
        const value = parcelRequire('3jgdM');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("gJrPr")
    ]).then(()=>parcelRequire('3jgdM'));
}

});


parcelRegister("cilnB", function(module, exports) {

$parcel$export(module.exports, "PanelDataProvider", () => $3f496d3499b8a3ce$export$3391167f05694d55);
$parcel$export(module.exports, "usePanelData", () => $3f496d3499b8a3ce$export$50f78812a0e4a6ee);

var $eUqFw = parcelRequire("eUqFw");
const $3f496d3499b8a3ce$var$PanelDataContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isCompanyManaged: false,
    boardId: -1,
    sourceDroppableType: ''
});
const $3f496d3499b8a3ce$export$3391167f05694d55 = ({ children: children, isCompanyManaged: isCompanyManaged, boardId: boardId, sourceDroppableType: sourceDroppableType })=>{
    const panelData = (0, $eUqFw.useMemo)(()=>({
            isCompanyManaged: isCompanyManaged,
            boardId: boardId,
            sourceDroppableType: sourceDroppableType
        }), [
        boardId,
        isCompanyManaged,
        sourceDroppableType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3f496d3499b8a3ce$var$PanelDataContext.Provider, {
        value: panelData
    }, children);
};
const $3f496d3499b8a3ce$export$50f78812a0e4a6ee = ()=>(0, $eUqFw.useContext)($3f496d3499b8a3ce$var$PanelDataContext);

});

parcelRegister("22cnO", function(module, exports) {

$parcel$export(module.exports, "getFirstLevelHierarchyName", () => $d5f309a19a889457$export$ef3b2d218d80725);

var $8ZI73 = parcelRequire("8ZI73");
const $d5f309a19a889457$export$ef3b2d218d80725 = (state)=>(0, $8ZI73.getConfig)(state).hierarchyNomenclature?.firstLevelName ?? null;

});

parcelRegister("cdPNh", function(module, exports) {

$parcel$export(module.exports, "useIsEpicPanelOpen", () => $6836e6f70c42985b$export$b8bc95e738a09ae0);

var $8MrYx = parcelRequire("8MrYx");

var $1gQ73 = parcelRequire("1gQ73");

var $8ZI73 = parcelRequire("8ZI73");
const $6836e6f70c42985b$export$b8bc95e738a09ae0 = ()=>{
    const showEpicAsPanel = (0, $1gQ73.useBacklogSelector)((0, $8ZI73.getShowEpicAsPanel));
    const isEpicsOpen = (0, $8MrYx.useShowEpicPanel)();
    if (!showEpicAsPanel) return false;
    return isEpicsOpen;
};

});

parcelRegister("diedG", function(module, exports) {

$parcel$export(module.exports, "default", () => $cadb5ac2e95847db$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jh2R9 = parcelRequire("jh2R9");

var $4vTMF = parcelRequire("4vTMF");

var $8yne0 = parcelRequire("8yne0");
var $9EHc8 = parcelRequire("9EHc8");

var $lgxha = parcelRequire("lgxha");

var $eIp1n = parcelRequire("eIp1n");

var $46Siz = parcelRequire("46Siz");

var $gd0Sp = parcelRequire("gd0Sp");


var $j258X = parcelRequire("j258X");
const $cadb5ac2e95847db$var$SLAExperienceTracker = ({ experienceTarget: experienceTarget = '', experienceTargetId: experienceTargetId = '', experienceSource: experienceSource = (0, $e1409a6fc345c0d8$export$840e3848643f7781), additionalAttributes: additionalAttributes = {}, children: children })=>{
    const { appEditions: { software: software } } = (0, $gd0Sp.useTenantContext)();
    const isCompanyManaged = (0, $j258X.useIsCMPBacklog)();
    const experienceTargetKey = (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(experienceTarget);
    const experienceId = experienceTargetId ? `${experienceTargetKey}-${experienceTargetId}` : experienceTargetKey;
    const experience = `view${experienceTargetKey.charAt(0).toUpperCase()}${experienceTargetKey.slice(1)}`;
    const experienceLocation = experienceTarget ? `${0, $e1409a6fc345c0d8$export$b6e4306772e8a60d}-${(0, (/*@__PURE__*/$parcel$interopDefault($4vTMF)))(experienceTarget)}` : (0, $e1409a6fc345c0d8$export$b6e4306772e8a60d);
    const onSuccess = ({ onExperienceSuccess: onExperienceSuccess })=>()=>{
            onExperienceSuccess();
        };
    const onError = ({ onExperienceFailure: onExperienceFailure })=>(location, error)=>{
            onExperienceFailure(undefined, (0, $46Siz.getErrorAttributes)(error));
        };
    const viewExperienceTracker = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8yne0.ExperienceTracker), {
        location: experienceLocation
    }, (trackerCallbacks)=>typeof children === 'function' ? children({
            onSuccess: onSuccess(trackerCallbacks),
            onError: onError(trackerCallbacks)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
            op: trackerCallbacks.onExperienceSuccess
        })));
    return experienceTarget ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9EHc8.ViewExperienceTrackingProvider), {
        experienceId: experienceId,
        experience: experience,
        analyticsSource: experienceSource,
        edition: software,
        application: (0, $eIp1n.JIRA_SOFTWARE),
        additionalAttributes: {
            isUIF: true,
            isClassic: isCompanyManaged,
            ...additionalAttributes
        }
    }, viewExperienceTracker) : viewExperienceTracker;
};
var $cadb5ac2e95847db$export$2e2bcd8739ae039 = $cadb5ac2e95847db$var$SLAExperienceTracker;

});


parcelRegister("gQBix", function(module, exports) {

$parcel$export(module.exports, "MoreResults", () => $b5cf084b9fa6b73e$export$1f344df69afb392e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* eslint-disable @atlaskit/design-system/no-html-button */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $9SdpV = parcelRequire("9SdpV");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $cS9th = parcelRequire("cS9th");

var $1gQ73 = parcelRequire("1gQ73");

var $kdGmo = parcelRequire("kdGmo");

var $2UIEn = parcelRequire("2UIEn");
const $b5cf084b9fa6b73e$export$1f344df69afb392e = ({ scrollableParentRef: scrollableParentRef })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const filters = (0, $1gQ73.useBacklogSelector)((0, $kdGmo.getFilters));
    const [{ isLastResultMarkerBelowFold: isLastResultMarkerBelowFold }] = (0, $cS9th.useMoreResultsStore)();
    const filtersAreApplied = Object.keys(filters).length > 0;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleClick = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'moreResultsButton'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
        if (scrollableParentRef.current) scrollableParentRef.current.scrollTo({
            top: scrollableParentRef.current.scrollTop + scrollableParentRef.current.clientHeight,
            behavior: 'smooth'
        });
    };
    if (!filtersAreApplied || !isLastResultMarkerBelowFold) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b5cf084b9fa6b73e$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b5cf084b9fa6b73e$var$SeeMoreButton, {
        onClick: handleClick,
        tabIndex: -1,
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9SdpV))), {
        label: formatMessage((0, $2UIEn.default).downArrowIconLabel)
    }), formatMessage((0, $2UIEn.default).moreResults)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b5cf084b9fa6b73e$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _1pbyb4wl _1ltvidpf _1xi2idpf _94n51ejb _1e0c1txw _1bah1h6o _lcxvglyw _4t3iidpf",
            __cmplp.className
        ])
    });
});
const $b5cf084b9fa6b73e$var$SeeMoreButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bsb1ns9 _4t3i1ns9 _1yt41r6r _19itglyw _2rko7vkz _syazjjyb _bfhk1bhr _16qs1mxi _80omtlke _lcxv1wug _19lc134c _9h8h11ce _1di61s8i",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9SdpV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $730390946cb60768$var$_react = $730390946cb60768$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $730390946cb60768$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $730390946cb60768$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $730390946cb60768$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11 6v9.586l-3.793-3.793a.999.999 0 00-1.414 0c-.39.39-.39 1.024 0 1.415l5.5 5.499A.993.993 0 0012 19a.993.993 0 00.707-.293l5.5-5.499a1 1 0 10-1.414-1.415L13 15.586V6a1 1 0 00-2 0z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$730390946cb60768$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $730390946cb60768$var$_default = $730390946cb60768$var$ArrowDownIcon;
module.exports.default = $730390946cb60768$var$_default;

});

parcelRegister("cS9th", function(module, exports) {

$parcel$export(module.exports, "useMoreResultsStore", () => $face52d4d5971123$export$2562d6b68d41f3d2);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $face52d4d5971123$var$Store = (0, $a61MH.createStore)({
    initialState: {
        isLastResultMarkerBelowFold: false
    },
    actions: {
        setIsLastResultMarkerBelowFold: (isLastResultMarkerBelowFold)=>({ setState: setState })=>{
                setState({
                    isLastResultMarkerBelowFold: isLastResultMarkerBelowFold
                });
            }
    },
    name: 'more-results'
});
const $face52d4d5971123$export$2562d6b68d41f3d2 = (0, $ggKAj.createHook)($face52d4d5971123$var$Store);

});

parcelRegister("2UIEn", function(module, exports) {

$parcel$export(module.exports, "default", () => $9210e35cbd51642e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9210e35cbd51642e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    moreResults: {
        "id": "backlog.backlog-content.more-results.more-results",
        "defaultMessage": "More results"
    },
    downArrowIconLabel: {
        "id": "backlog.backlog-content.more-results.down-arrow-icon-label",
        "defaultMessage": "Down arrow"
    }
});

});


parcelRegister("fxXLk", function(module, exports) {

$parcel$export(module.exports, "useAutoScroller", () => $ca86627c0f837dac$export$f9101ea66b86493d);

var $eUqFw = parcelRequire("eUqFw");

var $5Pwiq = parcelRequire("5Pwiq");

var $eo9PV = parcelRequire("eo9PV");
const $ca86627c0f837dac$export$ec5b303098bc4b7f = {
    onDragStart: ({ location: location })=>{
        (0, $5Pwiq.autoScroller).start({
            input: location.current.input
        });
    },
    onDrop: ()=>{
        (0, $5Pwiq.autoScroller).stop();
    },
    onDrag: ({ location: location })=>{
        (0, $5Pwiq.autoScroller).updateInput({
            input: location.current.input
        });
    }
};
function $ca86627c0f837dac$export$f9101ea66b86493d() {
    (0, $eUqFw.useEffect)(()=>(0, $eo9PV.monitorForElements)($ca86627c0f837dac$export$ec5b303098bc4b7f), []);
}

});
parcelRegister("5Pwiq", function(module, exports) {

$parcel$export(module.exports, "createAutoScroller", () => $bde649c1e39b5c8c$export$fbda4b72e803ec38);
$parcel$export(module.exports, "autoScroller", () => $bde649c1e39b5c8c$export$d19940cfc7560cd8);

var $dEKnA = parcelRequire("dEKnA");
const $bde649c1e39b5c8c$var$scrollElement = (element, change)=>{
    element.scrollBy(change.x, change.y);
};
const $bde649c1e39b5c8c$var$scrollWindow = (change)=>{
    window.scrollBy(change.x, change.y);
};
const $bde649c1e39b5c8c$export$fbda4b72e803ec38 = ()=>{
    let dragging = null;
    function tryScroll(fakeScrollCallback) {
        if (dragging == null) return;
        (0, $dEKnA.scroll)({
            input: dragging.latestInput,
            dragStartTime: dragging.dragStartTime,
            shouldUseTimeDampening: dragging.shouldUseTimeDampening,
            behavior: dragging.behavior,
            scrollElement: fakeScrollCallback ?? $bde649c1e39b5c8c$var$scrollElement,
            scrollWindow: fakeScrollCallback ?? $bde649c1e39b5c8c$var$scrollWindow
        });
    }
    // Every animation frame use the latest user input to scroll
    // We do this loop manually rather than in response to `onDrag`
    // events as `onDrag` can drop to 50-100ms between events when
    // the user is not actively moving their pointer
    function loop() {
        if (!dragging) return;
        dragging.loopFrameId = requestAnimationFrame(()=>{
            tryScroll();
            loop();
        });
    }
    const start = ({ input: input, behavior: behavior = 'window-then-container' })=>{
        const dragStartTime = Date.now();
        dragging = {
            dragStartTime: dragStartTime,
            latestInput: input,
            loopFrameId: null,
            shouldUseTimeDampening: false,
            behavior: behavior
        };
        // we only use time dampening when auto scrolling starts on lift.
        const fakeScrollCallback = ()=>{
            if (dragging) dragging.shouldUseTimeDampening = true;
        };
        tryScroll(fakeScrollCallback);
        loop();
    };
    function updateInput({ input: input }) {
        if (!dragging) return;
        dragging.latestInput = input;
    }
    const stop = ()=>{
        // can be called defensively
        if (!dragging) return;
        if (dragging.loopFrameId) cancelAnimationFrame(dragging.loopFrameId);
        dragging = null;
    };
    return {
        start: start,
        updateInput: updateInput,
        stop: stop
    };
};
const $bde649c1e39b5c8c$export$d19940cfc7560cd8 = $bde649c1e39b5c8c$export$fbda4b72e803ec38();

});
parcelRegister("dEKnA", function(module, exports) {

$parcel$export(module.exports, "scroll", () => $704cec92194d31d8$export$209876d7b1ac8f3);
parcelRequire("5K1lL");
var $cHW1B = parcelRequire("cHW1B");

var $7E9sF = parcelRequire("7E9sF");

var $1s8mQ = parcelRequire("1s8mQ");

var $cmR18 = parcelRequire("cmR18");

var $91kec = parcelRequire("91kec");

var $2kKFy = parcelRequire("2kKFy");
const $704cec92194d31d8$export$209876d7b1ac8f3 = ({ input: input, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening, scrollElement: scrollElement, scrollWindow: scrollWindow, behavior: behavior })=>{
    const tryScrollWindow = ()=>{
        const viewport = (0, $2kKFy.default)();
        const windowScrollChange = (0, $91kec.default)({
            dragStartTime: dragStartTime,
            viewport: viewport,
            center: {
                x: input.clientX + viewport.scroll.current.x,
                y: input.clientY + viewport.scroll.current.y
            },
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        if (windowScrollChange) {
            scrollWindow(windowScrollChange);
            return true;
        }
        return false;
    };
    const tryScrollContainer = ()=>{
        const over = (0, $cHW1B.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        });
        const closestScrollable = (0, $7E9sF.getClosestScrollableElement)(over);
        if (!closestScrollable) return false;
        const scrollable = (0, $1s8mQ.getScrollable)({
            closestScrollable: closestScrollable
        });
        const scrollableScrollChange = (0, $cmR18.default)({
            dragStartTime: dragStartTime,
            scrollable: scrollable,
            center: {
                x: input.clientX,
                y: input.clientY
            },
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        if (scrollableScrollChange) {
            scrollElement(closestScrollable, scrollableScrollChange);
            return true;
        }
        return false;
    };
    if (behavior === 'container-only') tryScrollContainer();
    if (behavior === 'window-only') tryScrollWindow();
    if (behavior === 'container-then-window') tryScrollContainer() || tryScrollWindow();
    if (behavior === 'window-then-container') tryScrollWindow() || tryScrollContainer();
};

});
parcelRegister("5K1lL", function(module, exports) {

$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => (parcelRequire("cHW1B")).getElementFromPointWithoutHoneypot);

var $cHW1B = parcelRequire("cHW1B");

});

parcelRegister("7E9sF", function(module, exports) {

$parcel$export(module.exports, "getClosestScrollableElement", () => $f466e08163ab9741$export$f39f407dd5a0ebdb);
// Source: https://github.com/atlassian/react-beautiful-dnd
const $f466e08163ab9741$var$isEqual = (base)=>(value)=>base === value;
const $f466e08163ab9741$var$isScroll = $f466e08163ab9741$var$isEqual('scroll');
const $f466e08163ab9741$var$isAuto = $f466e08163ab9741$var$isEqual('auto');
const $f466e08163ab9741$var$isEither = (overflow, fn)=>fn(overflow.overflowX) || fn(overflow.overflowY);
const $f466e08163ab9741$var$isElementScrollable = (el)=>{
    const style = window.getComputedStyle(el);
    const overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return $f466e08163ab9741$var$isEither(overflow, $f466e08163ab9741$var$isScroll) || $f466e08163ab9741$var$isEither(overflow, $f466e08163ab9741$var$isAuto);
};
const $f466e08163ab9741$export$f39f407dd5a0ebdb = (el)=>{
    // cannot do anything else!
    if (!el) return null;
    // not allowing us to go higher then body
    if (el === document.body || el === document.documentElement) return null;
    if (!$f466e08163ab9741$var$isElementScrollable(el)) // keep recursing
    return $f466e08163ab9741$export$f39f407dd5a0ebdb(el.parentElement);
    // success!
    return el;
};

});

parcelRegister("1s8mQ", function(module, exports) {

$parcel$export(module.exports, "getScrollable", () => $6652de0133f228e0$export$9b7238c949d126e9);

var $bn5nT = parcelRequire("bn5nT");
const $6652de0133f228e0$export$9b7238c949d126e9 = ({ closestScrollable: closestScrollable })=>{
    const rect = closestScrollable.getBoundingClientRect();
    const scrollPosition = {
        x: closestScrollable.scrollLeft,
        y: closestScrollable.scrollTop
    };
    return {
        container: (0, $bn5nT.getRect)(rect),
        scroll: {
            current: scrollPosition,
            max: {
                x: closestScrollable.scrollWidth - closestScrollable.clientWidth,
                y: closestScrollable.scrollHeight - closestScrollable.clientHeight
            }
        }
    };
};

});
parcelRegister("bn5nT", function(module, exports) {

$parcel$export(module.exports, "getRect", () => $847604ea52819b67$export$4b834cebd9e5cebe);
$parcel$export(module.exports, "expand", () => $847604ea52819b67$export$9f77e0932fb78f72);
$parcel$export(module.exports, "createBox", () => $847604ea52819b67$export$6459fc9e86be362e);
$parcel$export(module.exports, "offset", () => $847604ea52819b67$export$cc800923e997bb8);
$parcel$export(module.exports, "withScroll", () => $847604ea52819b67$export$1d0caec378d7d0ae);
$parcel$export(module.exports, "calculateBox", () => $847604ea52819b67$export$b8dfc5d4e552b8e1);
$parcel$export(module.exports, "getBox", () => $847604ea52819b67$export$34928e660d2a8702);

var $8ynlC = parcelRequire("8ynlC");
var $847604ea52819b67$export$4b834cebd9e5cebe = function getRect(_ref) {
    var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
    var width = right - left;
    var height = bottom - top;
    var rect = {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height,
        x: left,
        y: top,
        center: {
            x: (right + left) / 2,
            y: (bottom + top) / 2
        }
    };
    return rect;
};
var $847604ea52819b67$export$9f77e0932fb78f72 = function expand(target, expandBy) {
    return {
        top: target.top - expandBy.top,
        left: target.left - expandBy.left,
        bottom: target.bottom + expandBy.bottom,
        right: target.right + expandBy.right
    };
};
var $847604ea52819b67$export$8b1f3092f5e28575 = function shrink(target, shrinkBy) {
    return {
        top: target.top + shrinkBy.top,
        left: target.left + shrinkBy.left,
        bottom: target.bottom - shrinkBy.bottom,
        right: target.right - shrinkBy.right
    };
};
var $847604ea52819b67$var$shift = function shift(target, shiftBy) {
    return {
        top: target.top + shiftBy.y,
        left: target.left + shiftBy.x,
        bottom: target.bottom + shiftBy.y,
        right: target.right + shiftBy.x
    };
};
var $847604ea52819b67$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $847604ea52819b67$export$6459fc9e86be362e = function createBox(_ref2) {
    var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? $847604ea52819b67$var$noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? $847604ea52819b67$var$noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? $847604ea52819b67$var$noSpacing : _ref2$padding;
    var marginBox = $847604ea52819b67$export$4b834cebd9e5cebe($847604ea52819b67$export$9f77e0932fb78f72(borderBox, margin));
    var paddingBox = $847604ea52819b67$export$4b834cebd9e5cebe($847604ea52819b67$export$8b1f3092f5e28575(borderBox, border));
    var contentBox = $847604ea52819b67$export$4b834cebd9e5cebe($847604ea52819b67$export$8b1f3092f5e28575(paddingBox, padding));
    return {
        marginBox: marginBox,
        borderBox: $847604ea52819b67$export$4b834cebd9e5cebe(borderBox),
        paddingBox: paddingBox,
        contentBox: contentBox,
        margin: margin,
        border: border,
        padding: padding
    };
};
var $847604ea52819b67$var$parse = function parse(raw) {
    var value = raw.slice(0, -2);
    var suffix = raw.slice(-2);
    if (suffix !== 'px') return 0;
    var result = Number(value);
    !!isNaN(result) && (0, $8ynlC.default)(false);
    return result;
};
var $847604ea52819b67$var$getWindowScroll = function getWindowScroll() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
var $847604ea52819b67$export$cc800923e997bb8 = function offset(original, change) {
    var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
    var shifted = $847604ea52819b67$var$shift(borderBox, change);
    return $847604ea52819b67$export$6459fc9e86be362e({
        borderBox: shifted,
        border: border,
        margin: margin,
        padding: padding
    });
};
var $847604ea52819b67$export$1d0caec378d7d0ae = function withScroll(original, scroll) {
    if (scroll === void 0) scroll = $847604ea52819b67$var$getWindowScroll();
    return $847604ea52819b67$export$cc800923e997bb8(original, scroll);
};
var $847604ea52819b67$export$b8dfc5d4e552b8e1 = function calculateBox(borderBox, styles) {
    var margin = {
        top: $847604ea52819b67$var$parse(styles.marginTop),
        right: $847604ea52819b67$var$parse(styles.marginRight),
        bottom: $847604ea52819b67$var$parse(styles.marginBottom),
        left: $847604ea52819b67$var$parse(styles.marginLeft)
    };
    var padding = {
        top: $847604ea52819b67$var$parse(styles.paddingTop),
        right: $847604ea52819b67$var$parse(styles.paddingRight),
        bottom: $847604ea52819b67$var$parse(styles.paddingBottom),
        left: $847604ea52819b67$var$parse(styles.paddingLeft)
    };
    var border = {
        top: $847604ea52819b67$var$parse(styles.borderTopWidth),
        right: $847604ea52819b67$var$parse(styles.borderRightWidth),
        bottom: $847604ea52819b67$var$parse(styles.borderBottomWidth),
        left: $847604ea52819b67$var$parse(styles.borderLeftWidth)
    };
    return $847604ea52819b67$export$6459fc9e86be362e({
        borderBox: borderBox,
        margin: margin,
        padding: padding,
        border: border
    });
};
var $847604ea52819b67$export$34928e660d2a8702 = function getBox(el) {
    var borderBox = el.getBoundingClientRect();
    var styles = window.getComputedStyle(el);
    return $847604ea52819b67$export$b8dfc5d4e552b8e1(borderBox, styles);
};

});


parcelRegister("cmR18", function(module, exports) {

$parcel$export(module.exports, "default", () => $f31ebcd079c503fc$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $kuXkS = parcelRequire("kuXkS");

var $h3yff = parcelRequire("h3yff");
var $f31ebcd079c503fc$export$2e2bcd8739ae039 = ({ scrollable: scrollable, center: center, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    const scroll = (0, $h3yff.default)({
        dragStartTime: dragStartTime,
        container: scrollable.container,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && (0, $kuXkS.canScrollScrollable)(scrollable, scroll) ? scroll : null;
};

});
parcelRegister("kuXkS", function(module, exports) {

$parcel$export(module.exports, "canScrollWindow", () => $ed7d2bc081cd70a2$export$cbd1e6fd5e887f10);
$parcel$export(module.exports, "canScrollScrollable", () => $ed7d2bc081cd70a2$export$57c21b61d76c9819);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $6cABY = parcelRequire("6cABY");
const $ed7d2bc081cd70a2$var$smallestSigned = (0, $6cABY.apply)((value)=>{
    if (value === 0) return 0;
    return value > 0 ? 1 : -1;
});
const $ed7d2bc081cd70a2$export$6b13012b06f8f95b = (()=>{
    const getRemainder = (target, max)=>{
        if (target < 0) return target;
        if (target > max) return target - max;
        return 0;
    };
    return ({ current: current, max: max, change: change })=>{
        const targetScroll = (0, $6cABY.add)(current, change);
        const overlap = {
            x: getRemainder(targetScroll.x, max.x),
            y: getRemainder(targetScroll.y, max.y)
        };
        if ((0, $6cABY.isEqual)(overlap, (0, $6cABY.origin))) return null;
        return overlap;
    };
})();
const $ed7d2bc081cd70a2$export$dbc3ad6130556cf6 = ({ max: rawMax, current: current, change: change })=>{
    // It is possible for the max scroll to be greater than the current scroll
    // when there are scrollbars on the cross axis. We adjust for this by
    // increasing the max scroll point if needed
    // This will allow movements backwards even if the current scroll is greater than the max scroll
    const max = {
        x: Math.max(current.x, rawMax.x),
        y: Math.max(current.y, rawMax.y)
    };
    // Only need to be able to move the smallest amount in the desired direction
    const smallestChange = $ed7d2bc081cd70a2$var$smallestSigned(change);
    const overlap = $ed7d2bc081cd70a2$export$6b13012b06f8f95b({
        max: max,
        current: current,
        change: smallestChange
    });
    // no overlap at all - we can move there!
    if (!overlap) return true;
    // if there was an x value, but there is no x overlap - then we can scroll on the x!
    if (smallestChange.x !== 0 && overlap.x === 0) return true;
    // if there was an y value, but there is no y overlap - then we can scroll on the y!
    if (smallestChange.y !== 0 && overlap.y === 0) return true;
    return false;
};
const $ed7d2bc081cd70a2$export$cbd1e6fd5e887f10 = (viewport, change)=>$ed7d2bc081cd70a2$export$dbc3ad6130556cf6({
        current: viewport.scroll.current,
        max: viewport.scroll.max,
        change: change
    });
const $ed7d2bc081cd70a2$export$2f1f3b9e315c6096 = (viewport, change)=>{
    if (!$ed7d2bc081cd70a2$export$cbd1e6fd5e887f10(viewport, change)) return null;
    const max = viewport.scroll.max;
    const current = viewport.scroll.current;
    return $ed7d2bc081cd70a2$export$6b13012b06f8f95b({
        current: current,
        max: max,
        change: change
    });
};
const $ed7d2bc081cd70a2$export$57c21b61d76c9819 = (scrollable, change)=>{
    return $ed7d2bc081cd70a2$export$dbc3ad6130556cf6({
        current: scrollable.scroll.current,
        max: scrollable.scroll.max,
        change: change
    });
};
const $ed7d2bc081cd70a2$export$d88a6b2979421049 = (scrollable, change)=>{
    if (!$ed7d2bc081cd70a2$export$57c21b61d76c9819(scrollable, change)) return null;
    return $ed7d2bc081cd70a2$export$6b13012b06f8f95b({
        current: scrollable.scroll.current,
        max: scrollable.scroll.max,
        change: change
    });
};

});
parcelRegister("6cABY", function(module, exports) {

$parcel$export(module.exports, "origin", () => $bbb11b5c60935496$export$f710a83a91838a36);
$parcel$export(module.exports, "apply", () => $bbb11b5c60935496$export$5635d7ef4b8fee1c);
$parcel$export(module.exports, "isEqual", () => $bbb11b5c60935496$export$248d38f6296296c5);
$parcel$export(module.exports, "add", () => $bbb11b5c60935496$export$e16d8520af44a096);
$parcel$export(module.exports, "subtract", () => $bbb11b5c60935496$export$4e2d2ead65e5f7e3);
// Source: https://github.com/atlassian/react-beautiful-dnd
const $bbb11b5c60935496$export$f710a83a91838a36 = {
    x: 0,
    y: 0
};
const $bbb11b5c60935496$export$5635d7ef4b8fee1c = (fn)=>(point)=>({
            x: fn(point.x),
            y: fn(point.y)
        });
const $bbb11b5c60935496$export$248d38f6296296c5 = (point1, point2)=>point1.x === point2.x && point1.y === point2.y;
const $bbb11b5c60935496$export$e16d8520af44a096 = (point1, point2)=>({
        x: point1.x + point2.x,
        y: point1.y + point2.y
    });
const $bbb11b5c60935496$export$4e2d2ead65e5f7e3 = (point1, point2)=>({
        x: point1.x - point2.x,
        y: point1.y - point2.y
    });

});


parcelRegister("h3yff", function(module, exports) {

$parcel$export(module.exports, "default", () => $04403a563aa15b3f$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $1FJBN = parcelRequire("1FJBN");

var $6cABY = parcelRequire("6cABY");

var $gaAYU = parcelRequire("gaAYU");
// will replace -0 and replace with +0
const $04403a563aa15b3f$var$clean = (0, $6cABY.apply)((value)=>value === 0 ? 0 : value);
var $04403a563aa15b3f$export$2e2bcd8739ae039 = ({ dragStartTime: dragStartTime, container: container, center: center, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    // get distance to each edge
    const distanceToEdges = {
        top: center.y - container.top,
        right: container.right - center.x,
        bottom: container.bottom - center.y,
        left: center.x - container.left
    };
    // 1. Figure out which x,y values are the best target
    // 2. Can the container scroll in that direction at all?
    // If no for both directions, then return null
    // 3. Is the center close enough to a edge to start a drag?
    // 4. Based on the distance, calculate the speed at which a scroll should occur
    // The lower distance value the faster the scroll should be.
    // Maximum speed value should be hit before the distance is 0
    // Negative values to not continue to increase the speed
    const y = (0, $gaAYU.default)({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: (0, $1FJBN.vertical),
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    const x = (0, $gaAYU.default)({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: (0, $1FJBN.horizontal),
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    const required = $04403a563aa15b3f$var$clean({
        x: x,
        y: y
    });
    // nothing required
    if ((0, $6cABY.isEqual)(required, (0, $6cABY.origin))) return null;
    return required;
};

});
parcelRegister("1FJBN", function(module, exports) {

$parcel$export(module.exports, "minScroll", () => $68996f5601ae722f$export$67e2de1e1e796844);
$parcel$export(module.exports, "vertical", () => $68996f5601ae722f$export$32f8a6eb41d46820);
$parcel$export(module.exports, "horizontal", () => $68996f5601ae722f$export$641ecd0b2bc39508);
const $68996f5601ae722f$export$67e2de1e1e796844 = 1;
const $68996f5601ae722f$export$32f8a6eb41d46820 = {
    direction: 'vertical',
    start: 'top',
    end: 'bottom',
    size: 'height',
    scrollAxis: 'scrollTop'
};
const $68996f5601ae722f$export$641ecd0b2bc39508 = {
    direction: 'horizontal',
    start: 'left',
    end: 'right',
    size: 'width',
    scrollAxis: 'scrollLeft'
};
const $68996f5601ae722f$export$1a8fc111f6979e7a = [
    $68996f5601ae722f$export$641ecd0b2bc39508.direction,
    $68996f5601ae722f$export$32f8a6eb41d46820.direction
];

});

parcelRegister("gaAYU", function(module, exports) {

$parcel$export(module.exports, "default", () => $9042b92424eff0cb$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $8Yq8R = parcelRequire("8Yq8R");

var $j3mW5 = parcelRequire("j3mW5");
var $9042b92424eff0cb$export$2e2bcd8739ae039 = ({ container: container, distanceToEdges: distanceToEdges, dragStartTime: dragStartTime, axis: axis, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    const thresholds = (0, $8Yq8R.default)(container, axis);
    const isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
    if (isCloserToEnd) return (0, $j3mW5.default)({
        distanceToEdge: distanceToEdges[axis.end],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return -1 * (0, $j3mW5.default)({
        distanceToEdge: distanceToEdges[axis.start],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
};

});
parcelRegister("8Yq8R", function(module, exports) {

$parcel$export(module.exports, "default", () => $6206878988e06aa9$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $CBqIn = parcelRequire("CBqIn");
const $6206878988e06aa9$export$79446fee27934459 = (container, axis)=>{
    const startScrollingFrom = container[axis.size] * (0, $CBqIn.default).startFromPercentage;
    const maxScrollValueAt = container[axis.size] * (0, $CBqIn.default).maxScrollAtPercentage;
    const thresholds = {
        startScrollingFrom: startScrollingFrom,
        maxScrollValueAt: maxScrollValueAt
    };
    return thresholds;
};
var $6206878988e06aa9$export$2e2bcd8739ae039 = $6206878988e06aa9$export$79446fee27934459;

});
parcelRegister("CBqIn", function(module, exports) {

$parcel$export(module.exports, "default", () => $22e1c26e7adafc61$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd
// Values used to control how the fluid auto scroll feels
const $22e1c26e7adafc61$var$config = {
    // percentage distance from edge of container:
    startFromPercentage: 0.25,
    maxScrollAtPercentage: 0.05,
    // pixels per frame
    maxPixelScroll: 28,
    // A function used to ease a percentage value
    // A simple linear function would be: (percentage) => percentage;
    // percentage is between 0 and 1
    // result must be between 0 and 1
    ease: (percentage)=>Math.pow(percentage, 2),
    durationDampening: {
        // ms: how long to dampen the speed of an auto scroll from the start of a drag
        stopDampeningAt: 1200,
        // ms: when to start accelerating the reduction of duration dampening
        accelerateAt: 360
    }
};
var $22e1c26e7adafc61$export$2e2bcd8739ae039 = $22e1c26e7adafc61$var$config;

});


parcelRegister("j3mW5", function(module, exports) {

$parcel$export(module.exports, "default", () => $4138cfd10b8d6cb6$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $1FJBN = parcelRequire("1FJBN");

var $GGnA2 = parcelRequire("GGnA2");

var $i7kxC = parcelRequire("i7kxC");
const $4138cfd10b8d6cb6$export$bf7199a9ebcb84a9 = ({ distanceToEdge: distanceToEdge, thresholds: thresholds, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    const scroll = (0, $i7kxC.getValueFromDistance)(distanceToEdge, thresholds);
    // not enough distance to trigger a minimum scroll
    // we can bail here
    if (scroll === 0) return 0;
    // Dampen an auto scroll speed based on duration of drag
    if (!shouldUseTimeDampening) return scroll;
    // Once we know an auto scroll should occur based on distance,
    // we must let at least 1px through to trigger a scroll event an
    // another auto scroll call
    return Math.max((0, $GGnA2.dampenValueByTime)(scroll, dragStartTime), (0, $1FJBN.minScroll));
};
var $4138cfd10b8d6cb6$export$2e2bcd8739ae039 = $4138cfd10b8d6cb6$export$bf7199a9ebcb84a9;

});
parcelRegister("GGnA2", function(module, exports) {

$parcel$export(module.exports, "dampenValueByTime", () => $09e5877382e55f91$export$2fe468ff7a999ed6);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $CBqIn = parcelRequire("CBqIn");

var $1FJBN = parcelRequire("1FJBN");

var $gYLmt = parcelRequire("gYLmt");
const $09e5877382e55f91$var$accelerateAt = (0, $CBqIn.default).durationDampening.accelerateAt;
const $09e5877382e55f91$var$stopAt = (0, $CBqIn.default).durationDampening.stopDampeningAt;
const $09e5877382e55f91$export$2fe468ff7a999ed6 = (proposedScroll, dragStartTime)=>{
    const startOfRange = dragStartTime;
    const endOfRange = $09e5877382e55f91$var$stopAt;
    const now = Date.now();
    const runTime = now - startOfRange;
    // we have finished the time dampening period
    if (runTime >= $09e5877382e55f91$var$stopAt) return proposedScroll;
    // Up to this point we know there is a proposed scroll
    // but we have not reached our accelerate point
    // Return the minimum amount of scroll
    if (runTime < $09e5877382e55f91$var$accelerateAt) return 0, $1FJBN.minScroll;
    const betweenAccelerateAtAndStopAtPercentage = (0, $gYLmt.getPercentage)({
        startOfRange: $09e5877382e55f91$var$accelerateAt,
        endOfRange: endOfRange,
        current: runTime
    });
    const scroll = proposedScroll * (0, $CBqIn.default).ease(betweenAccelerateAtAndStopAtPercentage);
    return Math.ceil(scroll);
};

});
parcelRegister("gYLmt", function(module, exports) {

$parcel$export(module.exports, "getPercentage", () => $ee56cf2a5b618f47$export$6712e0f6cd0ea03);
// Source: https://github.com/atlassian/react-beautiful-dnd
const $ee56cf2a5b618f47$export$6712e0f6cd0ea03 = ({ startOfRange: startOfRange, endOfRange: endOfRange, current: current })=>{
    const range = endOfRange - startOfRange;
    if (range === 0) /**
		 * Detected distance range of 0 in the auto scroller
		 * This is unexpected and would cause a divide by 0 issue.
		 * Not allowing an auto scroll
		 */ return 0;
    const currentInRange = current - startOfRange;
    const percentage = currentInRange / range;
    return percentage;
};

});


parcelRegister("i7kxC", function(module, exports) {

$parcel$export(module.exports, "getValueFromDistance", () => $6739aefbd53be9fe$export$f3e495573a199c91);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $CBqIn = parcelRequire("CBqIn");

var $1FJBN = parcelRequire("1FJBN");

var $gYLmt = parcelRequire("gYLmt");
const $6739aefbd53be9fe$export$f3e495573a199c91 = (distanceToEdge, thresholds)=>{
    /*
  // This function only looks at the distance to one edge
  // Example: looking at bottom edge
  |----------------------------------|
  |                                  |
  |                                  |
  |                                  |
  |                                  |
  |                                  | => no scroll in this range
  |                                  |
  |                                  |
  |  startScrollingFrom (eg 100px)   |
  |                                  |
  |                                  | => increased scroll value the closer to maxScrollValueAt
  |  maxScrollValueAt (eg 10px)      |
  |                                  | => max scroll value in this range
  |----------------------------------|
  */ // too far away to auto scroll
    if (distanceToEdge > thresholds.startScrollingFrom) return 0;
    // use max speed when on or over boundary
    if (distanceToEdge <= thresholds.maxScrollValueAt) return (0, $CBqIn.default).maxPixelScroll;
    // when just going on the boundary return the minimum integer
    if (distanceToEdge === thresholds.startScrollingFrom) return 0, $1FJBN.minScroll;
    // to get the % past startScrollingFrom we will calculate
    // the % the value is from maxScrollValueAt and then invert it
    const percentageFromMaxScrollValueAt = (0, $gYLmt.getPercentage)({
        startOfRange: thresholds.maxScrollValueAt,
        endOfRange: thresholds.startScrollingFrom,
        current: distanceToEdge
    });
    const percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
    const scroll = (0, $CBqIn.default).maxPixelScroll * (0, $CBqIn.default).ease(percentageFromStartScrollingFrom);
    // scroll will always be a positive integer
    return Math.ceil(scroll);
};

});





parcelRegister("91kec", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb7d3871adca53b5$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $kuXkS = parcelRequire("kuXkS");

var $h3yff = parcelRequire("h3yff");
var $eb7d3871adca53b5$export$2e2bcd8739ae039 = ({ viewport: viewport, center: center, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    const scroll = (0, $h3yff.default)({
        dragStartTime: dragStartTime,
        container: viewport.container,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && (0, $kuXkS.canScrollWindow)(viewport, scroll) ? scroll : null;
};

});

parcelRegister("2kKFy", function(module, exports) {

$parcel$export(module.exports, "default", () => $02749ab18659f739$export$2e2bcd8739ae039);

var $bn5nT = parcelRequire("bn5nT");

var $iWYOC = parcelRequire("iWYOC");

var $bRP67 = parcelRequire("bRP67");
var $02749ab18659f739$export$2e2bcd8739ae039 = ()=>{
    const scroll = (0, $bRP67.default)();
    const maxScroll = (0, $iWYOC.default)();
    const top = scroll.y;
    const left = scroll.x;
    // window.innerHeight: includes scrollbars (not what we want)
    // document.clientHeight gives us the correct value when using the html5 doctype
    const doc = document.documentElement;
    // Using these values as they do not consider scrollbars
    // padding box, without scrollbar
    const width = doc.clientWidth;
    const height = doc.clientHeight;
    // Computed
    const right = left + width;
    const bottom = top + height;
    const container = (0, $bn5nT.getRect)({
        top: top,
        left: left,
        right: right,
        bottom: bottom
    });
    const viewport = {
        container: container,
        scroll: {
            current: scroll,
            max: maxScroll
        }
    };
    return viewport;
};

});
parcelRegister("iWYOC", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb903add7ce77d90$export$2e2bcd8739ae039);

var $geSJi = parcelRequire("geSJi");
var $bb903add7ce77d90$export$2e2bcd8739ae039 = ()=>{
    const doc = document.documentElement;
    const maxScroll = (0, $geSJi.default)({
        // unclipped padding box, with scrollbar
        scrollHeight: doc.scrollHeight,
        scrollWidth: doc.scrollWidth,
        // clipped padding box, without scrollbar
        width: doc.clientWidth,
        height: doc.clientHeight
    });
    return maxScroll;
};

});
parcelRegister("geSJi", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6c38d3b19198398$export$2e2bcd8739ae039);

var $6cABY = parcelRequire("6cABY");
var $b6c38d3b19198398$export$2e2bcd8739ae039 = ({ scrollHeight: scrollHeight, scrollWidth: scrollWidth, height: height, width: width })=>{
    const maxScroll = (0, $6cABY.subtract)(// full size
    {
        x: scrollWidth,
        y: scrollHeight
    }, // viewport size
    {
        x: width,
        y: height
    });
    const adjustedMaxScroll = {
        x: Math.max(0, maxScroll.x),
        y: Math.max(0, maxScroll.y)
    };
    return adjustedMaxScroll;
};

});


parcelRegister("bRP67", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7d8599f91bb8874$export$2e2bcd8739ae039);
var // The browsers update document.documentElement.scrollTop and window.pageYOffset
// differently as the window scrolls.
// Webkit
// documentElement.scrollTop: no update. Stays at 0
// window.pageYOffset: updates to whole number
// Chrome
// documentElement.scrollTop: update with fractional value
// window.pageYOffset: update with fractional value
// FireFox
// documentElement.scrollTop: updates to whole number
// window.pageYOffset: updates to whole number
// IE11 (same as firefox)
// documentElement.scrollTop: updates to whole number
// window.pageYOffset: updates to whole number
// Edge (same as webkit)
// documentElement.scrollTop: no update. Stays at 0
// window.pageYOffset: updates to whole number
$a7d8599f91bb8874$export$2e2bcd8739ae039 = ()=>({
        x: window.pageXOffset,
        y: window.pageYOffset
    });

});





parcelRegister("iJbrx", function(module, exports) {

$parcel$export(module.exports, "useDragAnalytics", () => $42888d2338a34539$export$660832909d6574f);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $eo9PV = parcelRequire("eo9PV");

var $jMP2a = parcelRequire("jMP2a");

const $42888d2338a34539$export$5dd4ed888d5b12ca = ({ createAnalyticsEvent: createAnalyticsEvent, defaultIssueHierarchyLevel: defaultIssueHierarchyLevel })=>({
        onDragStart: ({ source: source })=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'dragStarted',
                actionSubject: 'card'
            });
            const isSubtask = !!source.data.cardIsSubtask;
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
                isDivider: source.data.type === 'DIVIDER',
                issueHierarchyLevel: isSubtask ? -1 : defaultIssueHierarchyLevel
            });
        },
        onDrop: ({ source: source, location: location })=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'dragEnded',
                actionSubject: 'card'
            });
            const isAbort = location.current.dropTargets.length === 0;
            const isRank = location.current.dropTargets[0]?.data.type === (0, $94c330523ed620b5$export$4d4e6ab48cd5be5b);
            const isDivider = source.data.type === 'DIVIDER';
            // When moving from card list to epic/version panel cardListId wont exist in location.
            const isListMove = isDivider || typeof location.current.dropTargets[0]?.data.cardListId !== 'undefined' && location.current.dropTargets[0]?.data.cardListId !== source.data.cardListId;
            const isSubtask = !!source.data.cardIsSubtask;
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
                isDivider: isDivider,
                ...isAbort ? {
                    isAbort: isAbort
                } : {
                    isAbort: isAbort,
                    isRank: isRank,
                    isListMove: isListMove
                },
                issueHierarchyLevel: isSubtask ? -1 : defaultIssueHierarchyLevel
            });
        }
    });
function $42888d2338a34539$export$660832909d6574f(defaultIssueHierarchyLevel) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>(0, $eo9PV.monitorForElements)($42888d2338a34539$export$5dd4ed888d5b12ca({
            createAnalyticsEvent: createAnalyticsEvent,
            defaultIssueHierarchyLevel: defaultIssueHierarchyLevel
        })), [
        createAnalyticsEvent,
        defaultIssueHierarchyLevel
    ]);
}

});
const $94c330523ed620b5$export$4d4e6ab48cd5be5b = 'CARD_DRAGGABLE_ID';


parcelRegister("iidnO", function(module, exports) {

$parcel$export(module.exports, "useInitEpicData", () => $761925a639e8a338$export$be92c37578cc55ba);

var $eUqFw = parcelRequire("eUqFw");

var $lWcOi = parcelRequire("lWcOi");

var $9vZ7o = parcelRequire("9vZ7o");

var $1gQ73 = parcelRequire("1gQ73");

var $22cnO = parcelRequire("22cnO");

var $j258X = parcelRequire("j258X");

var $aAtiw = parcelRequire("aAtiw");
const $761925a639e8a338$export$be92c37578cc55ba = (boardId)=>{
    const isCompanyManaged = (0, $j258X.useIsCMPBacklog)();
    const firstLevelHierarchyName = (0, $1gQ73.useBacklogSelector)((0, $22cnO.getFirstLevelHierarchyName));
    const [isInitialised, { initState: initState, resetState: resetState, updateQueryState: updateQueryState, updateEpicsAttributes: updateEpicsAttributes }] = (0, $lWcOi.useEpicsStoreIsInitialised)();
    const { data: data, loading: loading, error: error } = (0, $9vZ7o.useEpicQueryLite)(boardId, isCompanyManaged);
    const initData = (0, $eUqFw.useMemo)(()=>(0, $aAtiw.transformLiteQueryData)(data, isCompanyManaged, firstLevelHierarchyName), [
        data,
        firstLevelHierarchyName,
        isCompanyManaged
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (error) updateEpicsAttributes({
            isLoading: false,
            hasError: true
        });
        updateQueryState({
            loading: loading,
            error: error
        });
    }, [
        loading,
        error,
        updateQueryState,
        updateEpicsAttributes
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (data && !loading && !isInitialised) initState({
            ...initData
        });
    }, [
        boardId,
        data,
        initData,
        initState,
        isCompanyManaged,
        isInitialised,
        loading
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            resetState();
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
};

});
parcelRegister("9vZ7o", function(module, exports) {

$parcel$export(module.exports, "useEpicQueryLite", () => $7d184f1688ccb16b$export$8bc41fa6ebe01467);

var $iZuDo = parcelRequire("iZuDo");

var $9ypom = parcelRequire("9ypom");

var $1ybV0 = parcelRequire("1ybV0");

var $litG5 = parcelRequire("litG5");
const $7d184f1688ccb16b$export$446e7345ee07982d = (0, $9ypom.default)`
    ${(0, $litG5.timeTrackingOptionsFragment)}
    ${(0, $litG5.epicLiteFragment)}
    ${(0, $litG5.projectLocationFragment)}
    ${(0, $litG5.issueParentTypeConfigFragment)}
    ${(0, $litG5.columnFragment)}
    ${(0, $litG5.boardFragment)}
    query EpicsLite($boardId: ID!, $isCompanyManaged: Boolean!, $isQueryColumns: Boolean!) {
        jira @include(if: $isCompanyManaged) {
            timeTrackingOptions {
                ...TimeTrackingOptionsFragment
            }
        }
        boardScope(boardId: $boardId, isCMP: $isCompanyManaged) {
            parents {
                edges {
                    node {
                        ...IssueParentLiteFragment
                    }
                }
            }
            board @include(if: $isCompanyManaged) {
                columns @include(if: $isQueryColumns) {
                    ...ColumnFragment
                }
                ...BoardFragment
            }
            projectLocation @skip(if: $isCompanyManaged) {
                ...ProjectLocationFragment
            }
        }
        globalConfig @include(if: $isCompanyManaged) {
            issueParentTypeConfig {
                ...IssueParentTypeConfigFragment
            }
        }
    }
`;
const $7d184f1688ccb16b$export$8bc41fa6ebe01467 = (boardId, isCompanyManaged)=>(0, $iZuDo.useQuery)($7d184f1688ccb16b$export$446e7345ee07982d, {
        skip: false,
        context: {
            headers: {
                'is-company-managed-board': isCompanyManaged
            }
        },
        variables: {
            boardId: String(boardId),
            isCompanyManaged: isCompanyManaged,
            isQueryColumns: (0, $1ybV0.ff)('modify-cmp-backlog-epic-panel-in-progress-bar-tooltips_gusjl')
        },
        fetchPolicy: 'network-only'
    });

});
parcelRegister("litG5", function(module, exports) {

$parcel$export(module.exports, "projectLocationFragment", () => $9eaadf64d9fff9a4$export$25c256efca3597d1);
$parcel$export(module.exports, "timeTrackingOptionsFragment", () => $9eaadf64d9fff9a4$export$ad6d7391facb841b);
$parcel$export(module.exports, "epicLiteFragment", () => $9eaadf64d9fff9a4$export$ee1de0b7a9498416);
$parcel$export(module.exports, "issueParentTypeConfigFragment", () => $9eaadf64d9fff9a4$export$9d88616d202f6817);
$parcel$export(module.exports, "columnFragment", () => $9eaadf64d9fff9a4$export$6fed28a6f51b8228);
$parcel$export(module.exports, "boardFragment", () => $9eaadf64d9fff9a4$export$e1c6fa95c54eabf5);

var $9ypom = parcelRequire("9ypom");
const $9eaadf64d9fff9a4$export$cb2dabc00ff80765 = (0, $9ypom.default)`
    fragment IssueParentFragment on IssueParent {
        id
        key
        summary
        issueType {
            id
            name
            iconUrl
        }
        color
        childrenInfo {
            todoStats {
                issueCount
            }
            inProgressStats {
                issueCount
            }
            doneStats {
                issueCount
            }
        }
        startDate
        dueDate
    }
`;
const $9eaadf64d9fff9a4$export$25c256efca3597d1 = (0, $9ypom.default)`
    fragment ProjectLocationFragment on Project {
        id
        issueTypes {
            id
            name
            hierarchyLevelType
            iconUrl
            hasRequiredFields
        }
    }
`;
const $9eaadf64d9fff9a4$export$ad6d7391facb841b = (0, $9ypom.default)`
    fragment TimeTrackingOptionsFragment on TimeTrackingOptions {
        workingHoursPerDay
        workingDaysPerWeek
        defaultUnit
        timeFormat
    }
`;
const $9eaadf64d9fff9a4$export$ee1de0b7a9498416 = (0, $9ypom.default)`
    fragment IssueParentLiteFragment on IssueParent {
        id
        key
        summary
        color
    }
`;
const $9eaadf64d9fff9a4$export$9d88616d202f6817 = (0, $9ypom.default)`
    fragment IssueParentTypeConfigFragment on IssueParentTypeConfig {
        id
        name
        iconUrl
        hierarchyLevelType
    }
`;
const $9eaadf64d9fff9a4$export$6fed28a6f51b8228 = (0, $9ypom.default)`
    fragment ColumnFragment on Column {
        isDone
        isInitial
    }
`;
const $9eaadf64d9fff9a4$export$e1c6fa95c54eabf5 = (0, $9ypom.default)`
    fragment BoardFragment on Board {
        rankCustomFieldId
    }
`;

});


parcelRegister("aAtiw", function(module, exports) {

$parcel$export(module.exports, "transformLiteQueryData", () => $08abbc7bb924b2a6$export$af76d046c1d42215);

var $f222W = parcelRequire("f222W");

var $3l6tm = parcelRequire("3l6tm");

var $7TyGu = parcelRequire("7TyGu");
const $08abbc7bb924b2a6$var$RANK_DISABLED_ID = '0';
const $08abbc7bb924b2a6$export$66ccee7e75897cc1 = ({ id: id, key: key, summary: summary, color: color }, { toDo: toDo, inProgress: inProgress, done: done })=>{
    const epicData = {
        id: Number(id),
        key: key,
        name: summary,
        color: (0, (/*@__PURE__*/$parcel$interopDefault($f222W)))(color) ? undefined : color,
        isLoading: true,
        hasError: false
    };
    return {
        epic: epicData,
        progress: {
            status: {
                toDo: {
                    issueCount: 0,
                    columnCount: toDo
                },
                inProgress: {
                    issueCount: 0,
                    columnCount: inProgress
                },
                done: {
                    issueCount: 0,
                    columnCount: done
                }
            },
            totalIssues: 0
        }
    };
};
const $08abbc7bb924b2a6$export$af76d046c1d42215 = (data, isCompanyManaged, firstLevelHierarchyName)=>{
    const globalConfig = data?.globalConfig;
    const board = data?.boardScope?.board;
    const columns = board?.columns ?? [];
    let isEpicIssueTypeAvailable = false;
    let epicIssueType;
    let epicIssueTypeName = (0, $7TyGu.DEFAULT_PARENT_ISSUE_TYPE_NAME);
    const columnCounts = {
        toDo: columns.filter((column)=>column.isInitial).length,
        inProgress: columns.filter((column)=>!column.isInitial && !column.isDone).length,
        done: columns.filter((column)=>column.isDone).length
    };
    const cards = data?.boardScope?.parents?.edges?.flatMap((edge)=>edge?.node ? $08abbc7bb924b2a6$export$66ccee7e75897cc1(edge.node, columnCounts) : []) ?? [];
    if (isCompanyManaged) {
        isEpicIssueTypeAvailable = globalConfig?.issueParentTypeConfig.hierarchyLevelType === (0, $3l6tm.PARENT_HIERARCHY_TYPE);
        epicIssueType = globalConfig?.issueParentTypeConfig;
        epicIssueTypeName = firstLevelHierarchyName || globalConfig?.issueParentTypeConfig.name || (0, $7TyGu.DEFAULT_PARENT_ISSUE_TYPE_NAME);
    } else {
        epicIssueType = data?.boardScope?.projectLocation?.issueTypes.find(({ hierarchyLevelType: hierarchyLevelType })=>hierarchyLevelType === (0, $3l6tm.PARENT_HIERARCHY_TYPE));
        isEpicIssueTypeAvailable = Boolean(epicIssueType);
        if (epicIssueType) epicIssueTypeName = epicIssueType.name;
    }
    return {
        cards: cards,
        columnCounts: columnCounts,
        isEpicIssueTypeAvailable: isEpicIssueTypeAvailable,
        epicIssueType: {
            id: epicIssueType?.id ?? 0,
            name: epicIssueTypeName,
            hasRequiredFields: epicIssueType?.hasRequiredFields ?? false
        },
        epicIssueTypeName: epicIssueTypeName,
        ...data?.jira && {
            timeTrackingOptions: data.jira.timeTrackingOptions
        },
        isRankingEnabled: board?.rankCustomFieldId ? board.rankCustomFieldId !== $08abbc7bb924b2a6$var$RANK_DISABLED_ID : true
    };
};

});


parcelRegister("jtJ2w", function(module, exports) {

$parcel$export(module.exports, "VersionsPanelWithErrorBoundary", () => $5e503e175c5c85a4$export$d6f535b626aa9a12);

var $eUqFw = parcelRequire("eUqFw");

var $1HzcR = parcelRequire("1HzcR");

var $0cdA8 = parcelRequire("0cdA8");

var $8WuJm = parcelRequire("8WuJm");

var $cilnB = parcelRequire("cilnB");

var $iIYm6 = parcelRequire("iIYm6");
var $7Kf0k = parcelRequire("7Kf0k");


var $1rVrE = parcelRequire("1rVrE");

var $1gQ73 = parcelRequire("1gQ73");

var $2498I = parcelRequire("2498I");

var $j258X = parcelRequire("j258X");

var $l9Cwt = parcelRequire("l9Cwt");

var $d9eLC = parcelRequire("d9eLC");
const $5e503e175c5c85a4$export$c91390ee18658a60 = (props)=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject, stopMetric: stopMetric } = (0, $eUqFw.useContext)((0, $1rVrE.VersionPanelEntrypointContext));
    const isVersionsOpen = (0, $l9Cwt.useIsVersionsPanelOpen)();
    const runtimeProps = (0, $eUqFw.useMemo)(()=>({
            ...props,
            onReady: stopMetric
        }), [
        props,
        stopMetric
    ]);
    const isCompanyManaged = (0, $j258X.useIsCMPBacklog)();
    const sourceDroppableType = (0, $1gQ73.useBacklogSelector)((0, $2498I.getSourceDroppableType));
    return isVersionsOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d9eLC.PanelWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: {
            analyticsSource: (0, $38e0ff43b94a2dc0$export$71b7a97b7c858c63)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cilnB.PanelDataProvider), {
        sourceDroppableType: sourceDroppableType,
        isCompanyManaged: isCompanyManaged,
        boardId: props.boardId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jira.backlog.version.panel",
        packageName: "jiraSoftwareVersionBacklogPanelRelay",
        errorFallback: "flag",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iIYm6.LoadingSkeleton), null),
        runtimeProps: runtimeProps
    })))) : null;
};
const $5e503e175c5c85a4$export$d6f535b626aa9a12 = (props)=>{
    const { fireErrorBoundaryExperienceFail: fireErrorBoundaryExperienceFail } = (0, $7Kf0k.useViewVersionPanelExperienceTracker)({
        isClassic: props.isCompanyManaged
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Kf0k.VersionBacklogPanelExperienceStart), {
        experienceId: `${props.boardId}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "backlogContentVersionsPanel",
        packageName: "software-backlog",
        fallback: "flag",
        onError: fireErrorBoundaryExperienceFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5e503e175c5c85a4$export$c91390ee18658a60, props)));
};

});
parcelRegister("iIYm6", function(module, exports) {

$parcel$export(module.exports, "LoadingSkeleton", () => $419a2c18b99634f1$export$44c18d210d5de37b);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $4Bees = parcelRequire("4Bees");

var $90IgZ = parcelRequire("90IgZ");
var $5JgJ2 = parcelRequire("5JgJ2");

var $e7t9B = parcelRequire("e7t9B");
const $419a2c18b99634f1$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        "id": "software-version-backlog-panel-relay.common.loading-skeleton.title",
        "defaultMessage": "Versions"
    }
});
const $419a2c18b99634f1$export$44c18d210d5de37b = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7t9B.default), {
        title: formatMessage($419a2c18b99634f1$var$messages.title),
        onClose: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($419a2c18b99634f1$var$LoadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "medium"
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $419a2c18b99634f1$var$LoadingWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _ca0qhwvj",
            __cmplp.className
        ])
    });
});

});
parcelRegister("e7t9B", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8a9a51eb427a8b0$export$2e2bcd8739ae039);

var $pkNSO = parcelRequire("pkNSO");
var $f8a9a51eb427a8b0$export$2e2bcd8739ae039 = (0, $pkNSO.default);

});
parcelRegister("pkNSO", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d459705c7b05612$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $gwyJs = parcelRequire("gwyJs");
const $6d459705c7b05612$export$2ddb90ad54e5f587 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ title: title = '', onClose: onClose = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), children: children }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6d459705c7b05612$var$Container, {
        "data-test-id": "software-backlog-panel.common.ui.panel.container",
        "data-testid": "software-backlog-panel.common.ui.panel.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwyJs.default), {
        title: title,
        onClose: onClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6d459705c7b05612$var$Content, {
        ref: ref
    }, children)));
var $6d459705c7b05612$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($6d459705c7b05612$export$2ddb90ad54e5f587);
const $6d459705c7b05612$var$width = 220;
const $6d459705c7b05612$var$widthLarge = 270;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6d459705c7b05612$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _n3tdv77o _vchhusvi _2rkoftgi _bfhkhri9 _1wpzv2br _c71l1vmz _rq4b1ogy _9szo1ogy _1oba1wdt _1yev1wdt",
            __cmplp.className
        ])
    });
});
const $6d459705c7b05612$var$Content = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _1reo15vq _18m91wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gwyJs", function(module, exports) {

$parcel$export(module.exports, "default", () => $18414e144e89b728$export$2e2bcd8739ae039);

var $f53K6 = parcelRequire("f53K6");
var $18414e144e89b728$export$2e2bcd8739ae039 = (0, $f53K6.default);

});
parcelRegister("f53K6", function(module, exports) {

$parcel$export(module.exports, "default", () => $e093e04d4f20d24c$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $je5kZ = parcelRequire("je5kZ");

var $kjXsi = parcelRequire("kjXsi");

var $c9TLT = parcelRequire("c9TLT");

var $giAhk = parcelRequire("giAhk");

var $4VuVx = parcelRequire("4VuVx");

var $b3NqC = parcelRequire("b3NqC");

var $5dKuI = parcelRequire("5dKuI");
const $e093e04d4f20d24c$export$8b251419efc915eb = ({ title: title, onClose: onClose, intl: { formatMessage: formatMessage } })=>{
    const label = formatMessage((0, $5dKuI.default).closeButtonLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e093e04d4f20d24c$var$Container, {
        "data-testid": "software-backlog-panel.common.ui.panel.header.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e093e04d4f20d24c$var$TitleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e093e04d4f20d24c$var$Title, {
        "data-testid": "software-backlog-panel.common.ui.panel.header.title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        size: "xsmall"
    }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kjXsi.ScreenReaderText), {
        id: (0, $4VuVx.EPIC_CARD_DESCRIPTION_ID)
    }, formatMessage((0, $5dKuI.default).epicCardDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e093e04d4f20d24c$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        spacing: "none",
        onClick: onClose,
        testId: "software-backlog-panel.common.ui.panel.header.close-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e093e04d4f20d24c$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($je5kZ))), {
        label: label,
        primaryColor: "var(--ds-icon, #44546F)"
    })))));
};
var $e093e04d4f20d24c$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)(/*#__PURE__*/ (0, $eUqFw.memo)($e093e04d4f20d24c$export$8b251419efc915eb));
const $e093e04d4f20d24c$var$ICON_SIZE = (0, $c9TLT.gridSize) * 3; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e093e04d4f20d24c$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _1o9zidpf _1yt41a6b",
            __cmplp.className
        ])
    });
});
const $e093e04d4f20d24c$var$TitleWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _16jlkb7n _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $e093e04d4f20d24c$var$ButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _1bsb1tcg _4t3i1tcg _1ul91tcg _1tke1tcg",
            __cmplp.className
        ])
    });
});
const $e093e04d4f20d24c$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1tcg _4t3i1tcg",
            __cmplp.className
        ])
    });
});
const $e093e04d4f20d24c$var$Title = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_ol3jx8": (0, $9t7rW.default)((0, $b3NqC.cardColor).default.textColorSubtle)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _1reo15vq _18m915vq _1bto1l2s _o5721q9c _k48pbfng _syazqpuq _19bvu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("b3NqC", function(module, exports) {

$parcel$export(module.exports, "cardColor", () => $25f355ad2dec9e02$export$7371e516c83e77f1);

var $PdmhA = parcelRequire("PdmhA");
const $25f355ad2dec9e02$var$COLOR_TEXT = `var(--ds-text, ${(0, $PdmhA).N800})`;
const $25f355ad2dec9e02$var$COLOR_TEXT_INVERSE = `var(--ds-text-inverse, ${(0, $PdmhA).N40})`;
const $25f355ad2dec9e02$export$7371e516c83e77f1 = {
    default: {
        textColor: $25f355ad2dec9e02$var$COLOR_TEXT,
        textColorSubtle: `var(--ds-text-subtle, ${(0, $PdmhA).N300})`,
        progressBar: {
            textColor: `var(--ds-text-subtlest, ${(0, $PdmhA).N200})`
        },
        mouseLeave: {
            backgroundColor: `var(--ds-surface-raised, ${(0, $PdmhA).N0})`,
            textColor: $25f355ad2dec9e02$var$COLOR_TEXT
        },
        mouseOver: {
            backgroundColor: `var(--ds-surface-raised-hovered, ${(0, $PdmhA).N20})`,
            textColor: $25f355ad2dec9e02$var$COLOR_TEXT
        },
        mouseDown: {
            backgroundColor: "var(--ds-background-neutral-subtle-pressed, #DDDFE5)"
        }
    },
    active: {
        progressBar: {
            textColor: $25f355ad2dec9e02$var$COLOR_TEXT_INVERSE
        },
        mouseLeave: {
            backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
            textColor: $25f355ad2dec9e02$var$COLOR_TEXT
        },
        mouseOver: {
            backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
            textColor: $25f355ad2dec9e02$var$COLOR_TEXT
        },
        mouseDown: {
            backgroundColor: "var(--ds-background-selected-pressed, #85B8FF)"
        }
    }
};

});

parcelRegister("5dKuI", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f3162fa04b95b8e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4f3162fa04b95b8e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    closeButtonLabel: {
        "id": "software-backlog-panel.common.panel.header.close-button-label",
        "defaultMessage": "Close panel"
    },
    epicCardDescription: {
        "id": "software-backlog-panel.common.panel.header.epic-card-description",
        "defaultMessage": "Whatever you select will be shown in the main content"
    }
});

});






parcelRegister("7Kf0k", function(module, exports) {

$parcel$export(module.exports, "ASSIGN_ABORT_PERMISSION", () => $339a8ee0ffb9241e$export$a7086850d534ca7c);
$parcel$export(module.exports, "ASSIGN_ABORT_CROSS_PROJECT", () => $339a8ee0ffb9241e$export$2c16bbee73016c79);
$parcel$export(module.exports, "UNASSIGN_ABORT_PERMISSION", () => $339a8ee0ffb9241e$export$4a65d324cd30dfb7);
$parcel$export(module.exports, "useViewVersionPanelExperienceTracker", () => $339a8ee0ffb9241e$export$aa37233cd44da53c);
$parcel$export(module.exports, "VersionBacklogPanelExperienceStart", () => $339a8ee0ffb9241e$export$792847156522cd4d);
$parcel$export(module.exports, "VersionBacklogPanelExperienceSuccessTracker", () => $339a8ee0ffb9241e$export$af4d2f7ac24077d1);
$parcel$export(module.exports, "useAssignExperienceTracker", () => $339a8ee0ffb9241e$export$e087867f6020c859);
$parcel$export(module.exports, "useUnassignExperienceTracker", () => $339a8ee0ffb9241e$export$cb1163ce9c396ad5);

var $eUqFw = parcelRequire("eUqFw");

var $ld2Vh = parcelRequire("ld2Vh");
var $cqhwe = parcelRequire("cqhwe");
var $j6rOo = parcelRequire("j6rOo");

const $339a8ee0ffb9241e$export$d95354974e5f5020 = 'viewVersionBacklogPanel';
const $339a8ee0ffb9241e$export$4669ca9d7c97effc = 'assignVersionPanel';
const $339a8ee0ffb9241e$export$a7086850d534ca7c = 'ASSIGN_PERMISSION';
const $339a8ee0ffb9241e$export$2c16bbee73016c79 = 'ASSIGN_CROSS_PROJECT';
const $339a8ee0ffb9241e$export$1eb1042763fdc7c3 = 'unassignVersionPanel';
const $339a8ee0ffb9241e$export$4a65d324cd30dfb7 = 'UNASSIGN_PERMISSION';
const $339a8ee0ffb9241e$export$aa37233cd44da53c = (attributes = {})=>(0, $j6rOo.useExperienceTracker)((0, $38e0ff43b94a2dc0$export$d76071d5de2774fc), $339a8ee0ffb9241e$export$d95354974e5f5020, (0, $38e0ff43b94a2dc0$export$71b7a97b7c858c63), attributes);
const $339a8ee0ffb9241e$export$792847156522cd4d = ({ experienceId: experienceId = (0, $38e0ff43b94a2dc0$export$d76071d5de2774fc) })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ld2Vh.SoftwareExperienceStart), {
        experienceId: experienceId,
        experience: $339a8ee0ffb9241e$export$d95354974e5f5020,
        analyticsSource: (0, $38e0ff43b94a2dc0$export$71b7a97b7c858c63)
    });
const $339a8ee0ffb9241e$export$af4d2f7ac24077d1 = ({ attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cqhwe.SoftwareExperienceSuccess), {
        experience: $339a8ee0ffb9241e$export$d95354974e5f5020,
        attributes: attributes
    });
const $339a8ee0ffb9241e$export$e087867f6020c859 = (attributes = {})=>(0, $j6rOo.useExperienceTracker)((0, $38e0ff43b94a2dc0$export$d76071d5de2774fc), $339a8ee0ffb9241e$export$4669ca9d7c97effc, (0, $38e0ff43b94a2dc0$export$71b7a97b7c858c63), attributes);
const $339a8ee0ffb9241e$export$cb1163ce9c396ad5 = (attributes = {})=>(0, $j6rOo.useExperienceTracker)((0, $38e0ff43b94a2dc0$export$d76071d5de2774fc), $339a8ee0ffb9241e$export$1eb1042763fdc7c3, (0, $38e0ff43b94a2dc0$export$71b7a97b7c858c63), attributes);

});
parcelRegister("ld2Vh", function(module, exports) {

$parcel$export(module.exports, "SoftwareExperienceStart", () => $23a9742bd33ebe8c$export$e18be0cd3b92dda1);

var $eUqFw = parcelRequire("eUqFw");

var $bDhRl = parcelRequire("bDhRl");

var $eIp1n = parcelRequire("eIp1n");

var $ab6rA = parcelRequire("ab6rA");
const $23a9742bd33ebe8c$export$e18be0cd3b92dda1 = ({ experienceId: experienceId, experience: experience, analyticsSource: analyticsSource })=>{
    const appEditions = (0, $ab6rA.useAppEditions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bDhRl.ExperienceStart), {
        experienceId: experienceId,
        experience: experience,
        analyticsSource: analyticsSource,
        edition: appEditions.software,
        application: (0, $eIp1n.JIRA_SOFTWARE)
    });
};

});

parcelRegister("cqhwe", function(module, exports) {

$parcel$export(module.exports, "SoftwareExperienceSuccess", () => $c491efe9d3761e3d$export$a06ece3d589f4c88);

var $eUqFw = parcelRequire("eUqFw");

var $fDZ6r = parcelRequire("fDZ6r");

var $46Siz = parcelRequire("46Siz");
const $c491efe9d3761e3d$export$a06ece3d589f4c88 = ({ experience: experience, attributes: attributes })=>{
    const experienceAttributes = (0, $eUqFw.useMemo)(()=>(0, $46Siz.createCommonAttributes)(attributes), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDZ6r.ExperienceSuccess), {
        experience: experience,
        attributes: experienceAttributes
    });
};

});

const $38e0ff43b94a2dc0$export$d76071d5de2774fc = 'version-panel';
const $38e0ff43b94a2dc0$export$28ad8b364940d9aa = 'VERSION-';
const $38e0ff43b94a2dc0$export$71b7a97b7c858c63 = 'version-panel';
const $38e0ff43b94a2dc0$export$b8b9d90f9e5bd72b = 'jiraSoftwareVersionBacklogPanelRelay';


parcelRegister("1rVrE", function(module, exports) {

$parcel$export(module.exports, "VersionPanelEntrypointContext", () => $b91dfaa960fb067d$export$bdb33cd5a96d0170);

var $gRxol = parcelRequire("gRxol");
const $b91dfaa960fb067d$export$bdb33cd5a96d0170 = (0, $gRxol.createUseEntryPointContext)();

});
parcelRegister("gRxol", function(module, exports) {

$parcel$export(module.exports, "createUseEntryPointContext", () => $1835b430d1386e11$export$41bce2223126846b);

var $eUqFw = parcelRequire("eUqFw");
const $1835b430d1386e11$export$41bce2223126846b = ()=>/*#__PURE__*/ (0, $eUqFw.createContext)({
        entryPointActions: {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            cancelPreload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            load () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            preload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            unload () {}
        },
        entryPointReferenceSubject: {
            getValue: ()=>null,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            subscribe: ()=>()=>{}
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        stopMetric () {}
    });

});


parcelRegister("l9Cwt", function(module, exports) {

$parcel$export(module.exports, "useIsVersionsPanelOpen", () => $437690a2917a83c9$export$2b96edcb84157d9);

var $8MrYx = parcelRequire("8MrYx");

var $1gQ73 = parcelRequire("1gQ73");

var $ai2KE = parcelRequire("ai2KE");
const $437690a2917a83c9$export$2b96edcb84157d9 = ()=>{
    const isVersionPanelOpen = (0, $8MrYx.useShowVersionPanel)();
    const isVersionsEnabled = (0, $1gQ73.useBacklogSelector)((0, $ai2KE.isVersionsFeatureEnabled));
    return isVersionsEnabled && isVersionPanelOpen;
};

});




parcelRegister("naWQb", function(module, exports) {

$parcel$export(module.exports, "BacklogSlaTracker", () => $fcd7324d3aa0af7b$export$a34f0231312fddfc);
$parcel$export(module.exports, "CmpBacklogSlaTracker", () => $fcd7324d3aa0af7b$export$836eecf117869739);

var $eUqFw = parcelRequire("eUqFw");

var $fee69 = parcelRequire("fee69");

var $1ybV0 = parcelRequire("1ybV0");

var $3HCkE = parcelRequire("3HCkE");

var $gFGRe = parcelRequire("gFGRe");


var $3YysV = parcelRequire("3YysV");
const $fcd7324d3aa0af7b$export$a34f0231312fddfc = ({ error: error, location: location })=>{
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $3YysV.default)(error, location ?? (0, $e1409a6fc345c0d8$export$b6e4306772e8a60d)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorFlagRenderer), {
        id: location ?? 'next-gen-backlog',
        error: error
    }));
    // return null when no errors
    return null;
};
const $fcd7324d3aa0af7b$export$836eecf117869739 = ()=>{
    const backlogData = (0, $3HCkE.useResource)((0, $1ybV0.ff)('jsw.perf.enable-indexeddb-caching-for-backlog') ? (0, $gFGRe.uifBacklogResource) : (0, $gFGRe.uifBacklogResourceOld));
    const hasFired = (0, $eUqFw.useRef)(false);
    if (hasFired.current || !backlogData || !backlogData.error || backlogData.data || backlogData.loading) return null;
    hasFired.current = true;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fcd7324d3aa0af7b$export$a34f0231312fddfc, {
        error: backlogData?.error,
        location: (0, $e1409a6fc345c0d8$export$7858b0b4e02abd78)
    });
};

});

parcelRegister("9wiuB", function(module, exports) {

$parcel$export(module.exports, "BulkOperationsLoader", () => $d46182916079184a$export$3af81192d3c2a190);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $eZoe4 = parcelRequire("eZoe4");

var $1ybV0 = parcelRequire("1ybV0");

var $byrHa = parcelRequire("byrHa");

var $1gQ73 = parcelRequire("1gQ73");

var $2giiC = parcelRequire("2giiC");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $1ircG = parcelRequire("1ircG");

var $7kNqR = parcelRequire("7kNqR");

var $7lxdV = parcelRequire("7lxdV");

var $b2naS = parcelRequire("b2naS");
const $d46182916079184a$export$3a055e4082f2e2d5 = ()=>(0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getSelectedCards));
const $d46182916079184a$export$fad9b4c285937b2c = ()=>(0, $1gQ73.useBacklogSelector)((0, $7kNqR.canBulkEditIssues));
const $d46182916079184a$export$9af2fbf60e113c02 = ()=>(0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getVisibleCardIds));
const $d46182916079184a$export$2b501a9ab802e6f9 = ()=>(0, $1gQ73.useBacklogSelector)((0, $1ircG.getEstimationFieldId));
const $d46182916079184a$export$70c1fca7746d50c3 = ()=>(0, $1gQ73.useBacklogSelector)((0, $hkGxG.getIsCompanyManaged));
const $d46182916079184a$export$3af81192d3c2a190 = ({ bulkOperationsToolbar: bulkOperationsToolbar, bulkOperationsForm: bulkOperationsForm, onOpenSidebar: onOpenSidebar, onCloseSidebar: onCloseSidebar })=>{
    const selectedCardIds = $d46182916079184a$export$3a055e4082f2e2d5();
    const hasBulkEditPermission = $d46182916079184a$export$fad9b4c285937b2c();
    const cardEntities = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getCards));
    const visibleCardIds = $d46182916079184a$export$9af2fbf60e113c02();
    const { selectAllVisible: selectAllVisible, clearAll: clearAll, clearAllVisible: clearAllVisible, extraAnalyticsAttributes: extraAnalyticsAttributes } = (0, $b2naS.useSelectActions)();
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const estimationFieldId = $d46182916079184a$export$2b501a9ab802e6f9();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isCMP = (0, $1ybV0.ff)('bulk-operations-transitions-in-backlog_1e7ke') ? $d46182916079184a$export$70c1fca7746d50c3() : false;
    const { openIssueView: openIssueView, closeIssueView: closeIssueView } = (0, $byrHa.useCloseIssueViewOnBulkOpsEdit)();
    const optimisticId = (0, $eUqFw.useRef)();
    const onUpdateStartOld = (0, $eUqFw.useCallback)(({ data: data, issueIds: issueIds })=>{
        const cardsData = (0, $1ybV0.ff)('bulk-operations-transitions-in-backlog_1e7ke') ? (0, $7lxdV.getBulkOperationsData)({
            data: data,
            estimationFieldId: estimationFieldId,
            isCMP: isCMP
        }) : (0, $7lxdV.getBulkOperationsDataOld)(data, estimationFieldId);
        const action = (0, $2giiC.cardsBulkOperationsRequest)({
            cardIds: issueIds,
            data: cardsData
        });
        optimisticId.current = action.meta.optimistic.id;
        dispatch(action);
    }, [
        dispatch,
        estimationFieldId,
        isCMP
    ]);
    const onUpdateStart = (0, $1ybV0.ff)('bulk-transition-multiple-workflows_wtnvv') ? (0, $eUqFw.useCallback)((payload)=>{
        const cardsData = payload.map(({ issueIds: issueIds, data: data })=>{
            const issuesData = (0, $7lxdV.getBulkOperationsData)({
                data: data,
                estimationFieldId: estimationFieldId,
                isCMP: isCMP
            });
            return {
                cardIds: issueIds,
                data: issuesData
            };
        });
        const action = (0, $2giiC.cardsBulkOperationsRequests)(cardsData);
        optimisticId.current = action.meta.optimistic.id;
        dispatch(action);
    }, [
        dispatch,
        estimationFieldId,
        isCMP
    ]) : (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
    /*
    This function is a temporary workaround to open the legacy bulk edit page.
    The Bulk Transition doesn't have support to return the issueKeys so this implementation was done here
    and will be removed when we implement Bulk Transition with multiple workflows.
    Project Plan: https://hello.atlassian.net/wiki/spaces/JSDee/pages/3388755384/Bulk+Transition+Project+Plan
    */ const onLegacyBulkEditRequest = (0, $eUqFw.useCallback)((issueIds)=>{
        if (!(0, $1ybV0.ff)('bulk-operations-transitions-in-backlog_1e7ke')) return;
        const issueKeys = issueIds.map((id)=>cardEntities[String(id)]?.key);
        const url = `/secure/GHBulkChange.jspa?issueKeys=${encodeURIComponent(issueKeys.join(','))}`;
        window.open(url, '_blank');
    }, [
        cardEntities
    ]);
    const onUpdateError = (0, $eUqFw.useCallback)((cardIds)=>{
        if (!optimisticId.current) return;
        dispatch((0, $2giiC.cardsBulkOperationsFailure)(optimisticId.current, cardIds));
    }, [
        dispatch
    ]);
    const onUpdateSuccess = (0, $eUqFw.useCallback)((cardIds)=>{
        if (!optimisticId.current) return;
        dispatch((0, $2giiC.cardsBulkOperationsSuccess)(optimisticId.current, cardIds));
    }, [
        dispatch
    ]);
    const onOpenForm = (0, $eUqFw.useCallback)(()=>{
        onOpenSidebar();
        closeIssueView();
    }, [
        closeIssueView,
        onOpenSidebar
    ]);
    const onCloseForm = (0, $eUqFw.useCallback)(()=>{
        onCloseSidebar();
        openIssueView();
    }, [
        openIssueView,
        onCloseSidebar
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eZoe4.AsyncBulkOpsCore), {
        bulkOperationsToolbar: bulkOperationsToolbar,
        bulkOperationsForm: bulkOperationsForm,
        onOpenForm: onOpenForm,
        onCloseForm: onCloseForm,
        onUpdateStartOld: onUpdateStartOld,
        onUpdateError: onUpdateError,
        onUpdateSuccess: onUpdateSuccess,
        onLegacyBulkEditRequest: onLegacyBulkEditRequest,
        onSelectAll: selectAllVisible,
        selectableIssueIds: visibleCardIds,
        selectedIssueIds: selectedCardIds,
        extraAnalyticsAttributes: extraAnalyticsAttributes,
        onClearAll: clearAll,
        onClearAllVisible: clearAllVisible,
        hasBulkEditPermission: hasBulkEditPermission,
        ...(0, $1ybV0.ff)('bulk-transition-multiple-workflows_wtnvv') ? {
            onUpdateStart: onUpdateStart
        } : {}
    });
};

});
parcelRegister("eZoe4", function(module, exports) {

$parcel$export(module.exports, "AsyncBulkOpsCore", () => $d719578b48c9f60c$export$ac7b39f8b8a9f5cd);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $jt2jz = parcelRequire("jt2jz");
const $d719578b48c9f60c$var$entryPointParams = {};
const $d719578b48c9f60c$export$ac7b39f8b8a9f5cd = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $jt2jz.asyncBulkopsCoreEntryPoint), $d719578b48c9f60c$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jira.backlog.bulk.operations.core",
        packageName: "jiraBulkOperationsCore",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null),
        runtimeProps: props
    });
};

});
parcelRegister("jt2jz", function(module, exports) {

$parcel$export(module.exports, "asyncBulkopsCoreEntryPoint", () => $a24e50e796ac10e7$export$3e78ba4b165ed95e);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $a24e50e796ac10e7$export$3e78ba4b165ed95e = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("8XEa1")), {
        moduleId: "f81933b6"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8XEa1", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('ZR3gR')
        ]);
        const value = parcelRequire('hAaG7');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("ZR3gR")
    ]).then(()=>parcelRequire('hAaG7'));
}

});



parcelRegister("byrHa", function(module, exports) {

$parcel$export(module.exports, "useCloseIssueViewOnBulkOpsEdit", () => $e092cacf2706a137$export$7c7315d3993c325e);

var $eUqFw = parcelRequire("eUqFw");

var $kJlBc = parcelRequire("kJlBc");

var $1gQ73 = parcelRequire("1gQ73");

var $K2SiM = parcelRequire("K2SiM");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");
const $e092cacf2706a137$export$7c7315d3993c325e = ()=>{
    const handleCloseIssueView = (0, $1gQ73.useBacklogActionCreator)((0, $K2SiM.closeDetailView));
    const handleOpenIssueView = (0, $1gQ73.useBacklogActionCreator)((0, $K2SiM.openDetailView));
    const openIssue = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getDetailView));
    const getIssueKey = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.makeCardKeyFromCardId));
    const lastDetailViewOpen = (0, $eUqFw.useRef)(null);
    const [routerState, { replaceTo: replaceTo }] = (0, $kJlBc.useRouter)();
    const closeIssueView = (0, $eUqFw.useCallback)(()=>{
        if (!lastDetailViewOpen.current) {
            lastDetailViewOpen.current = openIssue;
            handleCloseIssueView();
        }
    }, [
        handleCloseIssueView,
        openIssue
    ]);
    const openIssueView = (0, $eUqFw.useCallback)(()=>{
        if (lastDetailViewOpen.current) {
            const { cardId: cardId, externalAction: externalAction } = lastDetailViewOpen.current;
            const selectedIssue = getIssueKey(cardId);
            lastDetailViewOpen.current = null;
            handleOpenIssueView(cardId, externalAction);
            replaceTo(routerState.route, {
                params: routerState.match.params,
                query: {
                    ...routerState.query,
                    selectedIssue: selectedIssue
                }
            });
        }
    }, [
        getIssueKey,
        handleOpenIssueView,
        replaceTo,
        routerState.match.params,
        routerState.query,
        routerState.route
    ]);
    return {
        closeIssueView: closeIssueView,
        openIssueView: openIssueView
    };
};

});

parcelRegister("7lxdV", function(module, exports) {

$parcel$export(module.exports, "getBulkOperationsDataOld", () => $004f33b81d7c20b5$export$519092100bd0840f);
$parcel$export(module.exports, "getBulkOperationsData", () => $004f33b81d7c20b5$export$3adfa80a98ae5d22);

var $8Qd0L = parcelRequire("8Qd0L");

var $lO4Or = parcelRequire("lO4Or");
const $004f33b81d7c20b5$var$getStoryPointValue = (value)=>{
    if (value === null) return null;
    if (typeof value === 'string' && value.trim() === '') return null;
    const valueAsNumber = Number(value);
    if (Number.isNaN(valueAsNumber)) return undefined;
    return parseFloat(valueAsNumber.toFixed(3));
};
const $004f33b81d7c20b5$export$519092100bd0840f = (data, estimationFieldId)=>Object.keys(data).reduce((acc, key)=>{
        if (key === (0, $lO4Or.ASSIGNEE_TYPE)) {
            const value = data[key];
            if (value === undefined) return acc;
            acc.assignee = // TODO: update logic when automatic option is fixed
            // https://hello.atlassian.net/browse/DEE-3217
            value === null ? null : {
                id: value.accountId || '',
                displayName: value.displayName,
                avatarUrl: value.avatarUrls['48x48']
            };
        }
        if (key === (0, $lO4Or.LABELS_TYPE)) {
            const labels = data[key];
            if (labels === undefined) return acc;
            const { value: value, action: action } = labels;
            acc.labels = {
                action: action,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                value: Array.isArray(value) ? value.map((label)=>label.label) : [
                    value.label
                ]
            };
        }
        if (key === (0, $lO4Or.PRIORITY_TYPE)) {
            const value = data[key];
            if (value === undefined) return acc;
            acc.priority = {
                name: value.label,
                iconUrl: value.iconUrl
            };
        }
        if (key === (0, $lO4Or.DUE_DATE_TYPE)) {
            const value = data[key];
            if (value === undefined) return acc;
            acc.dueDate = value;
        }
        if (key === (0, $lO4Or.FIX_VERSIONS_TYPE)) {
            const fixVersions = data[key];
            if (fixVersions === undefined) return acc;
            const { value: value, action: action } = fixVersions;
            acc.fixVersions = {
                action: action,
                value: value.map((version)=>version.value)
            };
        }
        if (key === estimationFieldId) {
            // Temporary solution, when estimate field is available in bulk operations
            // conditions needs to be added to check against estimationFieldId
            // value (eg. timeoriginalestimate (TIME_ESTIMATE_TYPE))
            const storyPoints = $004f33b81d7c20b5$var$getStoryPointValue(data[key]);
            if (storyPoints !== undefined) acc.estimate = {
                storyPoints: storyPoints,
                originalEstimate: null,
                timeRemainingEstimate: null
            };
        }
        if (key === (0, $lO4Or.PARENT_TYPE)) {
            const value = data[key];
            if (value === undefined) return acc;
            acc.parentId = value ? Number(value.id) : null;
        }
        return acc;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, {});
const $004f33b81d7c20b5$export$3adfa80a98ae5d22 = ({ data: data, estimationFieldId: estimationFieldId, isCMP: isCMP })=>Object.keys(data).reduce((acc, key)=>{
        if (key === (0, $lO4Or.ASSIGNEE_TYPE)) {
            const value = data[key];
            if (value === undefined) return acc;
            acc.assignee = // TODO: update logic when automatic option is fixed
            // https://hello.atlassian.net/browse/DEE-3217
            value === null ? null : {
                id: value.accountId || '',
                displayName: value.displayName,
                avatarUrl: value.avatarUrls['48x48']
            };
        }
        if (key === (0, $lO4Or.LABELS_TYPE)) {
            const labels = data[key];
            if (labels === undefined) return acc;
            const { value: value, action: action } = labels;
            acc.labels = {
                action: action,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                value: Array.isArray(value) ? value.map((label)=>label.label) : [
                    value.label
                ]
            };
        }
        if (key === (0, $lO4Or.PRIORITY_TYPE)) {
            const value = data[key];
            if (value === undefined) return acc;
            acc.priority = {
                name: value.label,
                iconUrl: value.iconUrl
            };
        }
        if (key === (0, $lO4Or.DUE_DATE_TYPE)) {
            const value = data[key];
            if (value === undefined) return acc;
            acc.dueDate = value;
        }
        if (key === (0, $lO4Or.FIX_VERSIONS_TYPE)) {
            const fixVersions = data[key];
            if (fixVersions === undefined) return acc;
            const { value: value, action: action } = fixVersions;
            acc.fixVersions = {
                action: action,
                value: value.map((version)=>version.value)
            };
        }
        if (key === estimationFieldId) {
            // Temporary solution, when estimate field is available in bulk operations
            // conditions needs to be added to check against estimationFieldId
            // value (eg. timeoriginalestimate (TIME_ESTIMATE_TYPE))
            const storyPoints = $004f33b81d7c20b5$var$getStoryPointValue(data[key]);
            if (storyPoints !== undefined) acc.estimate = {
                storyPoints: storyPoints,
                originalEstimate: null,
                timeRemainingEstimate: null
            };
        }
        if (key === (0, $lO4Or.PARENT_TYPE)) {
            const value = data[key];
            if (value === undefined) return acc;
            acc.parentId = value ? Number(value.id) : null;
        }
        if (key === (0, $lO4Or.STATUS_TYPE)) {
            const value = data[key];
            if (value !== undefined && value !== null) {
                acc.statusId = value.statusId;
                if (!isCMP) acc.isDone = value.statusCategoryId === `${(0, $8Qd0L.StatusCategoryIds)[(0, $8Qd0L.StatusCategoryTypes).DONE]}`;
            }
        }
        return acc;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, {});

});

parcelRegister("b2naS", function(module, exports) {

$parcel$export(module.exports, "useSelectActions", () => $0fdabee21d59f67f$export$d419676870909930);

var $eUqFw = parcelRequire("eUqFw");

var $1gQ73 = parcelRequire("1gQ73");

var $8YxIx = parcelRequire("8YxIx");

var $1HfeQ = parcelRequire("1HfeQ");

var $bP7Jx = parcelRequire("bP7Jx");
const $0fdabee21d59f67f$export$d419676870909930 = ()=>{
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const visibleCardIds = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getVisibleCardIds));
    const visibleCardListIds = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getVisibleCardListIds));
    const selectAllVisible = (0, $eUqFw.useCallback)(()=>{
        dispatch((0, $1HfeQ.cardMultiSelectExtend)(visibleCardIds));
    }, [
        dispatch,
        visibleCardIds
    ]);
    const clearAll = (0, $eUqFw.useCallback)(()=>{
        dispatch((0, $1HfeQ.cardMultiSelect)([]));
        dispatch((0, $1HfeQ.cardClearRelativeCard)());
        dispatch((0, $8YxIx.setCheckboxSelectionMode)(false));
    }, [
        dispatch
    ]);
    const clearAllVisible = (0, $eUqFw.useCallback)(()=>{
        dispatch((0, $1HfeQ.cardMultiRemove)(visibleCardIds));
        dispatch((0, $8YxIx.setCheckboxSelectionMode)(false));
    }, [
        dispatch,
        visibleCardIds
    ]);
    const extraAnalyticsAttributes = (0, $eUqFw.useMemo)(()=>({
            selectAll: {
                checkbox: {
                    issue_ids: visibleCardIds,
                    numSelectedSprints: visibleCardListIds.length,
                    numSelectedCards: visibleCardIds.length
                },
                option: {
                    numSelectedCards: visibleCardIds.length
                }
            },
            clearAll: {
                checkbox: {
                    issue_ids: [],
                    numSelectedSprints: 0,
                    numSelectedCards: 0
                },
                option: {
                    numSelectedCards: 0
                }
            }
        }), [
        visibleCardIds,
        visibleCardListIds
    ]);
    return {
        selectAllVisible: selectAllVisible,
        clearAll: clearAll,
        clearAllVisible: clearAllVisible,
        extraAnalyticsAttributes: extraAnalyticsAttributes
    };
};

});


parcelRegister("dgzXR", function(module, exports) {

$parcel$export(module.exports, "BulkOperationsSidebar", () => $3f910f7b25e70adf$export$82c880c0082507d0);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $eKZPH = parcelRequire("eKZPH");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $8b3re = parcelRequire("8b3re");
const $3f910f7b25e70adf$export$82c880c0082507d0 = ({ parentWidth: parentWidth, isOpen: isOpen, bulkOperationsForm: bulkOperationsForm })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireResizeAnalytics = (0, $eUqFw.useCallback)((ratio)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'resized',
            actionSubject: 'bulkMenu'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'bulkEdit', {
            width: ratio
        });
    }, [
        createAnalyticsEvent
    ]);
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eKZPH.JiraDetailPanel), null, (setDetailPanelWidth)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8b3re.Resizer), {
            parentWidth: parentWidth,
            onResize: setDetailPanelWidth,
            onResizeEnd: fireResizeAnalytics
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3f910f7b25e70adf$var$SidebarContainer, {
            ref: bulkOperationsForm.setRef,
            "data-testid": "software-backlog.bulk-operations-sidebar.bulkops-sidebar"
        })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3f910f7b25e70adf$var$SidebarContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("9Bj5W", function(module, exports) {

$parcel$export(module.exports, "default", () => $1138e88d274bdb33$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6UWn5 = parcelRequire("6UWn5");

var $aFvYX = parcelRequire("aFvYX");

var $7TyGu = parcelRequire("7TyGu");

var $eVzhz = parcelRequire("eVzhz");

var $1gQ73 = parcelRequire("1gQ73");

var $7TN4i = parcelRequire("7TN4i");

var $3i20Q = parcelRequire("3i20Q");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $8ZI73 = parcelRequire("8ZI73");

var $2498I = parcelRequire("2498I");

var $7kNqR = parcelRequire("7kNqR");

var $dtV8v = parcelRequire("dtV8v");

var $fjBeC = parcelRequire("fjBeC");

var $7YJeQ = parcelRequire("7YJeQ");
const $1138e88d274bdb33$var$CardListContainer = ({ id: id, isFirstList: isFirstList, isFirstNonEmptyList: isFirstNonEmptyList, isLastNonEmptyList: isLastNonEmptyList, justCreated: justCreated })=>{
    const canEditIssue = (0, $1gQ73.useBacklogSelector)((0, $7kNqR.canEditIssue));
    const isBacklogEmpty = (0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.getFlattenOrderedCardIds)(state).length === 0);
    const isActiveSprint = (0, $1gQ73.useBacklogSelector)((0, $dtV8v.makeIsCardListActiveSprint));
    const isIccEnabled = (0, $1gQ73.useBacklogSelector)((state)=>(0, $8ZI73.isInlineIssueCreateAvailableForCurrentUser)(state) && ((0, $hkGxG.getIsCompanyManaged)(state) || (0, $bP7Jx.hasCardTypesSelector)(state)) && // ICC is disabled for CMP kanban board card list or active sprint
        !((0, $hkGxG.getIsCompanyManaged)(state) && (id === (0, $7TyGu.BOARD) || isActiveSprint(id))));
    const isBulkOpsInProgress = (0, $6UWn5.useIsBulkOperationsInProgress)();
    const isDisabled = (0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.makeIsCardListDisabled)(state)(id)) || isBulkOpsInProgress;
    const isSprintMenuVisible = (0, $1gQ73.useBacklogSelector)((state)=>(0, $dtV8v.makeIsSprintMenuVisible)(state)(id));
    const isCreateSprintButtonDisabled = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.isAnyOptimisticCardList));
    const isCreateSprintButtonVisible = (0, $1gQ73.useBacklogSelector)((state)=>(0, $dtV8v.makeIsCreateSprintVisible)(state)(id));
    const isStartSprintButtonVisible = (0, $1gQ73.useBacklogSelector)((state)=>(0, $dtV8v.makeIsStartSprintVisible)(state)(id, isFirstList));
    const isStartSprintEnabled = (0, $1gQ73.useBacklogSelector)((state)=>(0, $dtV8v.makeIsStartSprintEnabled)(state)(id, isFirstList));
    const isCompleteSprintButtonVisible = (0, $1gQ73.useBacklogSelector)((state)=>(0, $dtV8v.makeIsCompleteSprintVisible)(state)(id));
    const cardIds = (0, $1gQ73.useBacklogSelector)((state)=>false ? (0, $bP7Jx.getOrderedCardIdsByCardListIdWithLimit)(state)[id] : (0, $bP7Jx.getOrderedCardIdsByCardListId)(state)[id]);
    const isAddSprintDatesButtonVisible = (0, $1gQ73.useBacklogSelector)((state)=>(0, $dtV8v.makeIsAddSprintDatesButtonVisible)(state, {
            cardListId: id
        }));
    const isCollapsed = (0, $1gQ73.useBacklogSelector)((state)=>false ? (0, $bP7Jx.makeIsCardListCollapsed)(state)(id) || !(0, $bP7Jx.getOrderedCardIdsByCardListIdWithLimit)(state)[id].length && !!(0, $bP7Jx.getOrderedCardIdsByCardListId)(state)[id].length : (0, $bP7Jx.makeIsCardListCollapsed)(state)(id));
    const isWorkloadByAssigneeEnabled = (0, $1gQ73.useBacklogSelector)((0, $dtV8v.isBacklogWithSprints));
    const isDraggingSubtask = (0, $1gQ73.useBacklogSelector)((0, $2498I.getIsSubtaskDrag));
    const isCmpKanbanBacklog = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.isCmpKanbanProject));
    const allCardIds = (0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.getOrderedCardIdsByCardListId)(state)[id]);
    const cardListName = (0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.getCardLists)(state)[id].name);
    const cardListType = (0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.getCardLists)(state)[id].type);
    const typeForAnalytics = (0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.makeGetCardListAnalyticsTypeById)(state)(id));
    const cardListSprintData = (0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.getCardLists)(state)[id].sprintData, (0, $aFvYX.default));
    const isDragging = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getIsDragging));
    const isCurrentCardListDragSource = (0, $1gQ73.useBacklogSelector)((state)=>isDragging ? (0, $bP7Jx.getIsCardListDragInProgress)(state, id) : false);
    const cardMoveDisabled = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.isCardMoveDisabled));
    const minColumnLimit = (0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.makeGetMinColumnLimit)(state)(id));
    const maxColumnLimit = (0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.makeGetMaxColumnLimit)(state)(id));
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const onToggle = (0, $eUqFw.useCallback)(()=>{
        (0, $eVzhz.setCardListToggleStart)();
        dispatch((0, $7TN4i.cardListToggle)(id));
        (0, $eVzhz.scheduleCardListToggleFinish)();
    }, [
        dispatch,
        id
    ]);
    const onCreateSprint = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        dispatch((0, $3i20Q.sprintCreateRequest)(analyticsEvent));
    }, [
        dispatch
    ]);
    const showTransitionZone = (0, $fjBeC.shouldShowTransitionZone)(isDragging, isCurrentCardListDragSource, cardMoveDisabled, isDraggingSubtask, isCmpKanbanBacklog);
    const getCardOrderExcludingSubtasks = (0, $1gQ73.useBacklogSelector)((state)=>false ? (0, $bP7Jx.makeOrderedVisibleCardsExcludingSubtasksForCardListWithLimit)(state) : (0, $bP7Jx.makeOrderedVisibleCardsExcludingSubtasksForCardList)(state));
    const getTotalCardCountExcludingSubtasks = (0, $1gQ73.useBacklogSelector)((state)=>false ? (0, $bP7Jx.makeOrderedCardIdsByCardListIdWithLimitExcludingSubtasks)(state) : (0, $bP7Jx.makeOrderedCardIdsByCardListIdExcludingSubtasks)(state));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7YJeQ.default), {
        cardListId: id,
        type: cardListType,
        typeForAnalytics: typeForAnalytics,
        name: cardListName,
        sprintData: cardListSprintData,
        canEditIssue: canEditIssue,
        isBacklogEmpty: isBacklogEmpty,
        isFirstList: isFirstList,
        isFirstNonEmptyList: isFirstNonEmptyList,
        isLastNonEmptyList: isLastNonEmptyList,
        justCreated: justCreated,
        isIccEnabled: isIccEnabled,
        isDisabled: isDisabled,
        isCollapsed: isCollapsed,
        isActiveSprint: isActiveSprint(id),
        isSprintMenuVisible: isSprintMenuVisible,
        isCreateSprintButtonDisabled: isCreateSprintButtonDisabled,
        isCreateSprintButtonVisible: isCreateSprintButtonVisible,
        isStartSprintButtonVisible: isStartSprintButtonVisible,
        isCompleteSprintButtonVisible: isCompleteSprintButtonVisible,
        isAddSprintDatesButtonVisible: isAddSprintDatesButtonVisible,
        cardIds: cardIds,
        allCardIds: allCardIds,
        cardCountExcludingSubtasks: getTotalCardCountExcludingSubtasks(id).length,
        visibleCardAmount: getCardOrderExcludingSubtasks(id).length,
        onToggle: onToggle,
        onCreateSprint: onCreateSprint,
        isStartSprintEnabled: isStartSprintEnabled,
        showTransitionZone: showTransitionZone,
        minColumnLimit: minColumnLimit,
        maxColumnLimit: maxColumnLimit,
        isWorkloadByAssigneeEnabled: isWorkloadByAssigneeEnabled
    });
};
var $1138e88d274bdb33$export$2e2bcd8739ae039 = $1138e88d274bdb33$var$CardListContainer;

});
parcelRegister("6UWn5", function(module, exports) {

$parcel$export(module.exports, "useBulkOperations", () => $9b1a9f1dbe5cc0c1$export$940587be18a93fc4);
$parcel$export(module.exports, "useBulkOperationsActions", () => $9b1a9f1dbe5cc0c1$export$355499dfde532d1a);
$parcel$export(module.exports, "useIsBulkOperationsInProgress", () => $9b1a9f1dbe5cc0c1$export$760458c2204457a1);
$parcel$export(module.exports, "useShouldRenderSpotlight", () => $9b1a9f1dbe5cc0c1$export$4a165cf2377f023a);
$parcel$export(module.exports, "useBulkTransitionsStage", () => $9b1a9f1dbe5cc0c1$export$b3afff39a0c663ad);
$parcel$export(module.exports, "useBulkOperationInForm", () => $9b1a9f1dbe5cc0c1$export$6794339387d6d562);
$parcel$export(module.exports, "useBulkOperationType", () => $9b1a9f1dbe5cc0c1$export$4289f82da677ffac);
$parcel$export(module.exports, "useCancelDialogTrigger", () => $9b1a9f1dbe5cc0c1$export$babceeeb2408337b);
$parcel$export(module.exports, "useCurrentView", () => $9b1a9f1dbe5cc0c1$export$8ce7af7b2f8c770);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $1ybV0 = parcelRequire("1ybV0");

var $fLVlM = parcelRequire("fLVlM");

var $7otiN = parcelRequire("7otiN");
const $9b1a9f1dbe5cc0c1$export$d4c72bab9d6cc13a = {
    operationType: null,
    isSidebarOpen: false,
    cancelDialogTrigger: undefined,
    currentView: 'edit',
    firstFieldId: undefined
};
const $9b1a9f1dbe5cc0c1$var$actions = {
    setSummaryView: ()=>({ setState: setState })=>{
            setState({
                currentView: 'summary'
            });
        },
    setFirstFieldId: (firstFieldId)=>({ setState: setState })=>{
            setState({
                firstFieldId: firstFieldId
            });
        },
    setEditView: ()=>({ setState: setState })=>{
            setState({
                currentView: 'edit'
            });
        },
    setCancelDialogTrigger: (newTrigger = 'user-triggered')=>({ setState: setState, getState: getState })=>{
            const { cancelDialogTrigger: currentTrigger } = getState();
            /* Sometimes both events can be fired (route change & onclick) in one loop
            We need to prioritise route-change event  */ if (currentTrigger === 'route-change' && newTrigger === 'user-triggered') return;
            setState({
                cancelDialogTrigger: newTrigger
            });
        },
    clearDialogTrigger: ()=>({ setState: setState })=>{
            setState({
                cancelDialogTrigger: undefined
            });
        },
    startEdit: (args)=>({ setState: setState })=>{
            const { shouldRenderSpotlight: shouldRenderSpotlight } = args || {
                shouldRenderSpotlight: false
            };
            (0, $1ybV0.ff)('bulk-edit-discoverability_e2pux') ? setState({
                operationType: {
                    type: (0, $7otiN.BulkOperationsTypes).BULK_EDIT
                },
                shouldRenderSpotlight: shouldRenderSpotlight,
                isSidebarOpen: true
            }) : setState({
                operationType: {
                    type: (0, $7otiN.BulkOperationsTypes).BULK_EDIT
                },
                isSidebarOpen: true
            });
        },
    loadTransitions: ()=>({ setState: setState })=>{
            setState({
                operationType: {
                    type: (0, $7otiN.BulkOperationsTypes).BULK_TRANSITION,
                    stage: (0, $7otiN.BulkTransitionsStage).LOAD_BULK_TRANSITIONS
                },
                isSidebarOpen: false
            });
        },
    startQuickTransitions: ()=>({ setState: setState })=>{
            setState({
                operationType: {
                    type: (0, $7otiN.BulkOperationsTypes).BULK_TRANSITION,
                    stage: (0, $7otiN.BulkTransitionsStage).START_QUICK_TRANSITIONS
                },
                isSidebarOpen: false
            });
        },
    startSidebarTransition: ()=>({ setState: setState })=>{
            setState({
                operationType: {
                    type: (0, $7otiN.BulkOperationsTypes).BULK_TRANSITION,
                    stage: (0, $7otiN.BulkTransitionsStage).START_SIDEBAR_TRANSITION
                },
                isSidebarOpen: true
            });
        },
    startTransitionScreen: ()=>({ setState: setState })=>{
            setState({
                operationType: {
                    type: (0, $7otiN.BulkOperationsTypes).BULK_TRANSITION,
                    stage: (0, $7otiN.BulkTransitionsStage).START_TRANSITION_SCREEN
                },
                isSidebarOpen: true
            });
        },
    /* @deprecated use dismissBulkOperation instead */ closeSidebar: ()=>({ setState: setState })=>{
            setState($9b1a9f1dbe5cc0c1$export$d4c72bab9d6cc13a);
        },
    dismissBulkOperation: ()=>({ setState: setState })=>{
            if ((0, $1ybV0.ff)('bulk-transitions-third-iteration_ecc9c')) (0, $fLVlM.extraFormDataService).clear();
            setState($9b1a9f1dbe5cc0c1$export$d4c72bab9d6cc13a);
        }
};
const $9b1a9f1dbe5cc0c1$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    initialState: $9b1a9f1dbe5cc0c1$export$d4c72bab9d6cc13a,
    actions: $9b1a9f1dbe5cc0c1$var$actions,
    name: 'bulk-operations-store'
});
const $9b1a9f1dbe5cc0c1$export$940587be18a93fc4 = (0, $ggKAj.createHook)($9b1a9f1dbe5cc0c1$export$6f57813fe9f31bf9);
const $9b1a9f1dbe5cc0c1$export$355499dfde532d1a = (0, $ggKAj.createActionsHook)($9b1a9f1dbe5cc0c1$export$6f57813fe9f31bf9);
const $9b1a9f1dbe5cc0c1$export$760458c2204457a1 = (0, $ggKAj.createStateHook)($9b1a9f1dbe5cc0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.operationType !== null
});
const $9b1a9f1dbe5cc0c1$export$4a165cf2377f023a = (0, $ggKAj.createStateHook)($9b1a9f1dbe5cc0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>!!state.shouldRenderSpotlight
});
const $9b1a9f1dbe5cc0c1$export$b3afff39a0c663ad = (0, $ggKAj.createStateHook)($9b1a9f1dbe5cc0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>{
        const { operationType: operationType } = state;
        if (operationType?.type === (0, $7otiN.BulkOperationsTypes).BULK_TRANSITION) return operationType.stage;
        return null;
    }
});
const $9b1a9f1dbe5cc0c1$export$6794339387d6d562 = (0, $ggKAj.createStateHook)($9b1a9f1dbe5cc0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>{
        if (state.isSidebarOpen && state.operationType) return state.operationType.type;
        return null;
    }
});
const $9b1a9f1dbe5cc0c1$export$4289f82da677ffac = (0, $ggKAj.createStateHook)($9b1a9f1dbe5cc0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.operationType
});
const $9b1a9f1dbe5cc0c1$export$babceeeb2408337b = (0, $ggKAj.createStateHook)($9b1a9f1dbe5cc0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.cancelDialogTrigger
});
const $9b1a9f1dbe5cc0c1$export$8ce7af7b2f8c770 = (0, $ggKAj.createStateHook)($9b1a9f1dbe5cc0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.currentView
});

});
parcelRegister("fLVlM", function(module, exports) {

$parcel$export(module.exports, "extraFormDataService", () => $7dc88d7821ecbd34$export$3cd9d97d155e8e66);
class $7dc88d7821ecbd34$var$ExtraFormData {
    clear() {
        this.data = {};
    }
    addByKey(key, value) {
        this.data[key] = value;
    }
    getByKey(key) {
        return this.data[key];
    }
    getAll() {
        return this.data;
    }
    constructor(){
        this.data = {};
    }
}
const $7dc88d7821ecbd34$var$extraFormData = new $7dc88d7821ecbd34$var$ExtraFormData();
const $7dc88d7821ecbd34$var$addDataByKey = (key, value)=>{
    $7dc88d7821ecbd34$var$extraFormData.addByKey(key, value);
};
const $7dc88d7821ecbd34$var$clear = ()=>{
    $7dc88d7821ecbd34$var$extraFormData.clear();
};
const $7dc88d7821ecbd34$var$getDataByKey = (key)=>$7dc88d7821ecbd34$var$extraFormData.getByKey(key);
const $7dc88d7821ecbd34$var$getData = ()=>$7dc88d7821ecbd34$var$extraFormData.getAll();
const $7dc88d7821ecbd34$export$3cd9d97d155e8e66 = {
    addDataByKey: $7dc88d7821ecbd34$var$addDataByKey,
    getDataByKey: $7dc88d7821ecbd34$var$getDataByKey,
    clear: $7dc88d7821ecbd34$var$clear,
    getData: $7dc88d7821ecbd34$var$getData
};

});

parcelRegister("7otiN", function(module, exports) {

$parcel$export(module.exports, "BulkOperationsTypes", () => $25ec162e8a5324bd$export$7ec2782f56bb6e02);
$parcel$export(module.exports, "BulkTransitionsStage", () => $25ec162e8a5324bd$export$a6f51fa6c8971716);
const $25ec162e8a5324bd$export$7ec2782f56bb6e02 = {
    BULK_EDIT: 'BULK_EDIT',
    BULK_TRANSITION: 'BULK_TRANSITION'
};
const $25ec162e8a5324bd$export$a6f51fa6c8971716 = {
    LOAD_BULK_TRANSITIONS: 'LOAD_BULK_TRANSITIONS',
    START_QUICK_TRANSITIONS: 'START_QUICK_TRANSITIONS',
    START_SIDEBAR_TRANSITION: 'START_SIDEBAR_TRANSITION',
    START_TRANSITION_SCREEN: 'START_TRANSITION_SCREEN'
};

});


parcelRegister("eVzhz", function(module, exports) {

$parcel$export(module.exports, "setCardListToggleStart", () => $86aaf5a56caf2b70$export$d309e05c8f7a64b2);
$parcel$export(module.exports, "scheduleCardListToggleFinish", () => $86aaf5a56caf2b70$export$de99a97dc0f8d91f);

var $lzvR2 = parcelRequire("lzvR2");

var $keTr0 = parcelRequire("keTr0");

var $duQ8C = parcelRequire("duQ8C");

var $gPQCf = parcelRequire("gPQCf");
const $86aaf5a56caf2b70$export$d309e05c8f7a64b2 = ()=>{
    (0, $duQ8C.default)('backlog-card-list-toggle');
    (0, $gPQCf.cardListToggleInteraction).start();
};
const $86aaf5a56caf2b70$export$3f196abd7d0c8243 = ()=>{
    (0, $gPQCf.cardListToggleInteraction).stop({
        customData: {
            ...(0, $lzvR2.getNormalisedPerformanceFFs)()
        }
    });
};
const $86aaf5a56caf2b70$export$de99a97dc0f8d91f = ()=>{
    (0, $keTr0.scheduleAfterRender)(()=>{
        $86aaf5a56caf2b70$export$3f196abd7d0c8243();
    });
};

});

parcelRegister("fjBeC", function(module, exports) {

$parcel$export(module.exports, "darkerButtonTheme", () => $e7acf155a811e0eb$export$39794a566394c250);
$parcel$export(module.exports, "shouldShowTransitionZone", () => $e7acf155a811e0eb$export$d2114dbf8a186566);

var $PdmhA = parcelRequire("PdmhA");
const $e7acf155a811e0eb$export$9e32cd4b2f78e398 = (buttonThemeOverrides)=>(currentTheme, themeProps)=>{
        const { buttonStyles: buttonStyles, ...rest } = currentTheme(themeProps);
        const { appearance: appearance, state: state, mode: mode } = themeProps;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type '"" | Appearance' can't be used to index type 'ButtonTheme'.
        const customThemeAppearance = buttonThemeOverrides[`${appearance || ''}`];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let customStyles = {};
        if (customThemeAppearance) // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Record<string, any>'.
        customStyles = Object.keys(customThemeAppearance).reduce((acc, key)=>{
            const value = customThemeAppearance[key];
            if (value[state]) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'ThemeTokens'.
            acc[key] = value[state][mode];
            return acc;
        }, // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'CSSObject'. | TS2322 - Type 'null' is not assignable to type 'CSSObject'.
        {
            buttonStyles: null,
            spinnerStyles: null
        });
        return {
            ...rest,
            buttonStyles: {
                ...buttonStyles,
                ...customStyles
            }
        };
    };
const $e7acf155a811e0eb$var$darkerButtonThemeOverrides = {
    default: {
        background: {
            default: {
                light: `var(--ds-background-neutral, ${(0, $PdmhA).N30A})`
            },
            hover: {
                light: `var(--ds-background-neutral-hovered, ${(0, $PdmhA).N40A})`
            }
        }
    }
};
const $e7acf155a811e0eb$export$39794a566394c250 = $e7acf155a811e0eb$export$9e32cd4b2f78e398($e7acf155a811e0eb$var$darkerButtonThemeOverrides);
const $e7acf155a811e0eb$export$64a0edfb15b72dba = (sourceCardList, destinationCardList, sourceCardIndex, destinationCardIndex, destinationCardListCardOrder, selectedCards)=>{
    const isBottomOfOtherList = sourceCardList !== destinationCardList && destinationCardIndex === destinationCardListCardOrder.length;
    if (isBottomOfOtherList) return true;
    const isMovedFromAbove = sourceCardIndex < destinationCardIndex;
    // Is true when the destinationCardIndex is the last index in the list OR
    // ever card below this index is a selected card
    const isBottomOfSameList = sourceCardList === destinationCardList && (destinationCardIndex === destinationCardListCardOrder.length - 1 || destinationCardListCardOrder.slice(destinationCardIndex + (isMovedFromAbove ? 1 : 0)).every((cardId)=>selectedCards.includes(cardId)));
    return isBottomOfSameList;
};
const $e7acf155a811e0eb$export$f9cab8a22421fe72 = (cardGroup, sourceCardIndex, destinationCardIndex, destinationCardListCardOrder, selectedCards)=>{
    const currentCardAtDestinationIndex = destinationCardListCardOrder[destinationCardIndex];
    const isDestinationBottomOfCardGroup = currentCardAtDestinationIndex === cardGroup.cardIds[cardGroup.cardIds.length - 1];
    if (isDestinationBottomOfCardGroup) return true;
    const isMovedFromAbove = sourceCardIndex < destinationCardIndex;
    const destinationCardIndexWithinCardGroup = cardGroup.cardIds.findIndex((id)=>id === currentCardAtDestinationIndex);
    // Is considered bottom of card group when every
    // card beneath destinationCardIndex is selected
    return cardGroup.cardIds.slice(destinationCardIndexWithinCardGroup + (isMovedFromAbove ? 1 : 0)).every((cardId)=>selectedCards.includes(cardId));
};
const $e7acf155a811e0eb$export$53e40513eb32c9ca = (sourceCardList, destinationCardList, sourceCardIndex, destinationCardIndex, destinationCardListCardOrder, selectedCards)=>{
    let cardIndex = destinationCardIndex;
    const correction = sourceCardList === destinationCardList && sourceCardIndex < destinationCardIndex ? 1 : 0;
    cardIndex = destinationCardListCardOrder.findIndex((cardId, index)=>index < cardIndex + correction ? false : !selectedCards.includes(cardId));
    return destinationCardListCardOrder[cardIndex];
};
const $e7acf155a811e0eb$export$d2114dbf8a186566 = (isDragging, isCurrentCardListDragSource, cardMoveDisabled, isDraggingSubtask, isCmpKanbanBacklog)=>isDragging && !isCurrentCardListDragSource && (cardMoveDisabled && (!isDraggingSubtask || isCmpKanbanBacklog) || isDraggingSubtask && isCmpKanbanBacklog);

});

parcelRegister("7YJeQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dea9b43ba62c01e$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $kwce8 = parcelRequire("kwce8");

var $jG2Eu = parcelRequire("jG2Eu");

var $gtzuR = parcelRequire("gtzuR");

var $aw5Sy = parcelRequire("aw5Sy");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $86Ndv = parcelRequire("86Ndv");

var $dtaN9 = parcelRequire("dtaN9");

var $ffiyv = parcelRequire("ffiyv");

var $c0jFd = parcelRequire("c0jFd");

var $4lTFP = parcelRequire("4lTFP");

var $8cU5f = parcelRequire("8cU5f");

var $kjXsi = parcelRequire("kjXsi");

var $c9TLT = parcelRequire("c9TLT");

var $eWeL8 = parcelRequire("eWeL8");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2jdHI = parcelRequire("2jdHI");

var $jMP2a = parcelRequire("jMP2a");

var $hb3Di = parcelRequire("hb3Di");

var $6ohRd = parcelRequire("6ohRd");
var $2Gmfi = parcelRequire("2Gmfi");
var $aaEXn = parcelRequire("aaEXn");
var $9IOLk = parcelRequire("9IOLk");
var $1LQrA = parcelRequire("1LQrA");

var $105cx = parcelRequire("105cx");

var $9eH8H = parcelRequire("9eH8H");

var $7TyGu = parcelRequire("7TyGu");

var $3sfdp = parcelRequire("3sfdp");

var $1gQ73 = parcelRequire("1gQ73");

var $59CKH = parcelRequire("59CKH");

var $h4zn0 = parcelRequire("h4zn0");

var $j258X = parcelRequire("j258X");

var $j5TDo = parcelRequire("j5TDo");

var $h1Q6f = parcelRequire("h1Q6f");

var $huwiO = parcelRequire("huwiO");

var $gUTCm = parcelRequire("gUTCm");

var $4GaSP = parcelRequire("4GaSP");

var $1Xw9l = parcelRequire("1Xw9l");

var $cwkw0 = parcelRequire("cwkw0");


var $heWc5 = parcelRequire("heWc5");

var $6AF5y = parcelRequire("6AF5y");

var $d016W = parcelRequire("d016W");

var $3NbPH = parcelRequire("3NbPH");

var $5yOXO = parcelRequire("5yOXO");

var $bn3eO = parcelRequire("bn3eO");

var $5qDf1 = parcelRequire("5qDf1");

var $gLLIl = parcelRequire("gLLIl");

var $1sAnk = parcelRequire("1sAnk");

var $k6JfZ = parcelRequire("k6JfZ");

var $f1wUU = parcelRequire("f1wUU");

var $1JLT3 = parcelRequire("1JLT3");

var $2VSqB = parcelRequire("2VSqB");

var $fjBeC = parcelRequire("fjBeC");

var $1z582 = parcelRequire("1z582");
const $0dea9b43ba62c01e$var$BacklogAccordionNudgeAsyncWithFullWidth = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0dea9b43ba62c01e$var$FullWidthWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ohRd.BacklogAccordionNudgeAsync), null, children)); // for jsw_sprint_planning_whiteboards experiment,
const $0dea9b43ba62c01e$var$SprintPlanningWhiteboards = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const eligibleFlow = (0, $h1Q6f.useGetWhiteboardEligibleFlow)();
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const fireWhiteboardsExposureEvents = (0, $h1Q6f.useFireExposureEvents)();
    (0, $eUqFw.useEffect)(()=>{
        if (eligibleFlow === 'coUse' || eligibleFlow === 'crossFlow') {
            const cohort = (0, $79xbN.expVal)('jsw_sprint_planning_whiteboards', 'cohort', 'not-enrolled');
            fireWhiteboardsExposureEvents(cohort);
            dispatch((0, $h4zn0.setWhiteboardEligibility)({
                flow: eligibleFlow,
                cohort: cohort
            }));
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        eligibleFlow
    ]);
    return null;
});
function $0dea9b43ba62c01e$var$CardList({ cardListId: cardListId, type: type, typeForAnalytics: typeForAnalytics, name: name, sprintData: sprintData, isBacklogEmpty: isBacklogEmpty = false, isFirstList: isFirstList = false, isFirstNonEmptyList: isFirstNonEmptyList = false, isLastNonEmptyList: isLastNonEmptyList = false, isIccEnabled: isIccEnabled = false, isDisabled: isDisabled = false, isCollapsed: isCollapsed = false, isActiveSprint: isActiveSprint = false, isSprintMenuVisible: isSprintMenuVisible = false, isStartSprintEnabled: isStartSprintEnabled = false, isCreateSprintButtonDisabled: isCreateSprintButtonDisabled = false, isCreateSprintButtonVisible: isCreateSprintButtonVisible = false, isAddSprintDatesButtonVisible: isAddSprintDatesButtonVisible = false, isStartSprintButtonVisible: isStartSprintButtonVisible = false, isCompleteSprintButtonVisible: isCompleteSprintButtonVisible = false, canEditIssue: canEditIssue = false, visibleCardAmount: visibleCardAmount = 0, justCreated: justCreated = false, onToggle: onToggleProp = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onCreateSprint: onCreateSprintProp = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), cardIds: cardIds, allCardIds: allCardIds, cardCountExcludingSubtasks: cardCountExcludingSubtasks, minColumnLimit: minColumnLimit, maxColumnLimit: maxColumnLimit, showTransitionZone: showTransitionZone, isWorkloadByAssigneeEnabled: isWorkloadByAssigneeEnabled = false }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isCompanyManaged = (0, $j258X.useIsCMPBacklog)();
    const listRef = (0, $eUqFw.useRef)(null);
    const backlogContainerSize = (0, $bn3eO.useBacklogContainerSize)({
        ref: listRef
    });
    const leftSideRef = (0, $eUqFw.useRef)(null);
    const isBacklogCardList = type === (0, $7TyGu.BACKLOG);
    (0, $eUqFw.useEffect)(()=>{
        if (justCreated) leftSideRef?.current?.focus();
    }, [
        justCreated
    ]);
    const formatDate = (0, $5yOXO.useFormatDate)();
    const { ref: startSprintButtonNudgeRef } = (0, $105cx.useRegisterNudgeTarget)('start-sprint-button', isFirstList);
    const isMinLimitReached = !!minColumnLimit && minColumnLimit > allCardIds.length;
    const isMaxLimitReached = !!maxColumnLimit && maxColumnLimit < allCardIds.length;
    const onToggle = (event)=>{
        event.preventDefault();
        onToggleProp();
    };
    const renderRichCardDelay = 300;
    const setRichActiveCard = (0, $1gQ73.useBacklogActionCreator)((0, $59CKH.setRichActiveCard));
    const [setRichActiveCardDebounced] = (0, $2jdHI.default)((cardID)=>{
        setRichActiveCard(cardID);
    }, renderRichCardDelay);
    const onHeaderKeyDown = (event)=>{
        if (event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('enter') || event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('space')) {
            event.preventDefault();
            onToggleProp();
        }
    };
    const onCreateSprint = (event, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'createSprint');
        onCreateSprintProp(analyticsEvent);
    };
    const getListName = ()=>{
        switch(type){
            case 0, $7TyGu.BOARD:
                // Only use name if default name is different
                if (isCompanyManaged) return name;
                return formatMessage((0, $1sAnk.default).boardListName);
            case 0, $7TyGu.BACKLOG:
                return formatMessage((0, $1sAnk.default).backlogListName);
            case 0, $7TyGu.SPRINT:
                return name;
            default:
                return '';
        }
    };
    const getEmptyList = ()=>{
        if (cardIds.length) return formatMessage((0, $1sAnk.default).emptyListFiltered);
        switch(type){
            case 0, $7TyGu.BOARD:
                return formatMessage((0, $1sAnk.default).emptyBoard);
            case 0, $7TyGu.BACKLOG:
                return formatMessage((0, $1sAnk.default).emptyBacklog);
            case 0, $7TyGu.SPRINT:
                if (isActiveSprint) return formatMessage((0, $1sAnk.default).emptyStartedSprint);
                if (isFirstList) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3NbPH.default), null);
                return formatMessage((0, $1sAnk.default).emptyNotStartedSprint);
            default:
                return '';
        }
    };
    const chevronRightIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
        label: "expand",
        primaryColor: "var(--ds-icon, #44546F)"
    });
    const chevronDownIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
        label: "collapse",
        primaryColor: "var(--ds-icon, #44546F)"
    });
    const renderIcon = ()=>isCollapsed ? chevronRightIcon : chevronDownIcon;
    const renderNumberOfVisibleCardsText = ()=>{
        const totalCardAmountUntruncated = cardCountExcludingSubtasks;
        return totalCardAmountUntruncated !== visibleCardAmount ? formatMessage((0, $1sAnk.default).visibleCardAmount, {
            totalCardAmount: totalCardAmountUntruncated,
            cardAmount: visibleCardAmount
        }) : formatMessage((0, $1sAnk.default).cardAmount, {
            cardAmount: totalCardAmountUntruncated
        });
    };
    const renderStartSprintButton = ()=>{
        const totalCardAmount = cardIds.length;
        const isEmpty = totalCardAmount === 0;
        const shouldShowPrimaryButton = !isEmpty && isFirstList;
        const isStartSprintButtonDisabled = !isStartSprintEnabled || isEmpty;
        const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0dea9b43ba62c01e$var$CardListButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f1wUU.default // This test-id is being used for the Jira Software NextGen Sprint Lifecycle pollinator test
        ), {
            testId: "software-backlog.card-list.start-sprint-button",
            sprintId: cardListId,
            theme: !shouldShowPrimaryButton ? (0, $fjBeC.darkerButtonTheme) : null,
            appearance: shouldShowPrimaryButton ? 'primary' : 'default',
            isDisabled: isStartSprintButtonDisabled,
            ref: startSprintButtonNudgeRef
        }, formatMessage((0, $1sAnk.default).startSprint)));
        const possiblyNudgeWrappedButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hb3Di.ConditionalNudgeWrapper), {
            conditionsToApplyWrapper: isFirstList,
            Wrapper: (0, $1LQrA.BacklogStartSprintNudgeAsync)
        }, button);
        if (isStartSprintButtonDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0dea9b43ba62c01e$var$DisabledStartSprintTooltip, null, totalCardAmount === 0 ? formatMessage((0, $1sAnk.default).disabledStartSprintButtonEmpty) : formatMessage((0, $1sAnk.default).disabledStartSprintButtonNoParallel))
        }, possiblyNudgeWrappedButton);
        return possiblyNudgeWrappedButton;
    };
    const renderCompleteSprintButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Gmfi.BacklogCompleteSprintNudgeAsync), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0dea9b43ba62c01e$var$CardListButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwkw0.default), {
            theme: (0, $fjBeC.darkerButtonTheme),
            sprintId: cardListId,
            testId: "software-backlog.card-list.complete-sprint-button"
        }, formatMessage((0, $1sAnk.default).completeSprint))));
    const renderSprintHeader = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0dea9b43ba62c01e$var$RightSide, {
            "data-test-id": "software-backlog.card-list.estimations-and-actions-container",
            "data-testid": "software-backlog.card-list.estimations-and-actions-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6AF5y.default), {
            cardListId: cardListId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0dea9b43ba62c01e$var$CardMenuActionsWrapper, null, isStartSprintButtonVisible && renderStartSprintButton(), isCompleteSprintButtonVisible && renderCompleteSprintButton(), isSprintMenuVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k6JfZ.default), {
            cardListId: cardListId,
            cardListType: type,
            cardListName: name
        })));
    const renderCreateSprint = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0dea9b43ba62c01e$var$RightSide, {
            "data-test-id": "software-backlog.card-list.create-sprint-button-container",
            "data-testid": "software-backlog.card-list.create-sprint-button-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9IOLk.BacklogCreateSprintNudgeAsync), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            onClick: onCreateSprint,
            isDisabled: isCreateSprintButtonDisabled,
            testId: "software-backlog.card-list.create-sprint-button"
        }, formatMessage((0, $1sAnk.default).createSprint))));
    const renderAddSprintDatesButton = ()=>{
        const stopPropogation = (e)=>e.stopPropagation();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0dea9b43ba62c01e$var$AddSprintDatesButtonWrapper, {
            onClick: stopPropogation,
            onKeyDown: stopPropogation,
            "data-test-id": "software-backlog.card-list.add-sprint-date-button-container",
            "data-testid": "software-backlog.card-list.add-sprint-date-button-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $huwiO.default), {
            cardListId: Number(cardListId)
        }));
    };
    const renderSprintData = ()=>{
        if (!sprintData) return null;
        const { goal: goal } = sprintData;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, goal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0dea9b43ba62c01e$var$GoalWrapper, null, goal));
    };
    const renderColumnLimits = ()=>isFirstList && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, minColumnLimit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0dea9b43ba62c01e$var$ColumnLimit, {
            "data-testid": (0, $69f6afc4ea1d7f49$export$54c7326f7173c649)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            appearance: isMinLimitReached ? 'moved' : 'default',
            isBold: isMinLimitReached
        }, `MIN ${minColumnLimit}`)) : null, maxColumnLimit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0dea9b43ba62c01e$var$ColumnLimit, {
            "data-testid": (0, $69f6afc4ea1d7f49$export$54c7326f7173c649)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            appearance: isMaxLimitReached ? 'removed' : 'default',
            isBold: isMaxLimitReached
        }, `MAX ${maxColumnLimit}`)) : null);
    const renderLeftSide = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0dea9b43ba62c01e$var$LeftSide, {
            "data-testid": (0, $69f6afc4ea1d7f49$export$483ac6106791f695),
            role: "button",
            tabIndex: 0,
            "aria-controls": `backlog-accordion-${cardListId}`,
            onClick: onToggle,
            onKeyDown: onHeaderKeyDown,
            "aria-expanded": !isCollapsed,
            ref: leftSideRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0dea9b43ba62c01e$var$Icon, null, renderIcon()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
            alignItems: "baseline"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0dea9b43ba62c01e$var$ListName, null, getListName()), sprintData && !isAddSprintDatesButtonVisible && sprintData.startDate && sprintData.endDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0dea9b43ba62c01e$var$DatesWrapper, null, `${formatDate(sprintData.startDate)} \u{2013} ${formatDate(sprintData.endDate)}`), sprintData && isAddSprintDatesButtonVisible && renderAddSprintDatesButton(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0dea9b43ba62c01e$var$VisibleCardsInCardListHeader, null, "(", renderNumberOfVisibleCardsText(), ")"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            "data-testid": `${(0, $69f6afc4ea1d7f49$export$483ac6106791f695)}-${type}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kjXsi.ScreenReaderText), {
            "aria-live": "polite",
            role: "status"
        }, getListName(), " ", renderNumberOfVisibleCardsText())), renderColumnLimits())));
    const renderHeader = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0dea9b43ba62c01e$var$CardListHeader, {
            isMinLimitReached: isMinLimitReached,
            isMaxLimitReached: isMaxLimitReached
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Xw9l.CardListCheckbox), {
            cardListId: cardListId,
            isDisabled: isDisabled
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hb3Di.ConditionalNudgeWrapper), {
            Wrapper: $0dea9b43ba62c01e$var$BacklogAccordionNudgeAsyncWithFullWidth,
            conditionsToApplyWrapper: type === (0, $7TyGu.BACKLOG)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0dea9b43ba62c01e$var$HeadingWrapper, null, renderLeftSide())), renderSprintHeader(), type === (0, $7TyGu.BACKLOG) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j5TDo.BacklogButtonVariant), null), isCreateSprintButtonVisible && renderCreateSprint());
    const renderIccCard = (0, $eUqFw.useCallback)((cardEntry, row, isScrolling)=>{
        if ((0, $3sfdp.isCardEntryGroup)(cardEntry)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4GaSP.CardGroup), {
            key: (0, $3sfdp.getCardEntryGroupKey)(cardEntry, cardListId),
            isScrolling: isScrolling,
            row: row,
            cardListId: cardListId,
            cardGroup: cardEntry,
            setRichActiveCard: setRichActiveCardDebounced
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gUTCm.default), {
            cardListId: cardListId,
            cardId: cardEntry.cardId,
            row: row,
            isScrolling: isScrolling,
            isAttachedToParent: false,
            setRichActiveCard: setRichActiveCardDebounced
        });
    }, [
        cardListId,
        setRichActiveCardDebounced
    ]);
    const renderA11yScreenReaderInfo = ()=>justCreated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            "data-testid": `${(0, $9eH8H.HEADER_DROPPABLE_ID_PREFIX)}${cardListId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kjXsi.ScreenReaderText), {
            "aria-live": "assertive",
            id: `${(0, $9eH8H.HEADER_DROPPABLE_ID_PREFIX)}${cardListId}`
        }, formatMessage((0, $1sAnk.default).createdSprintAriaLive, {
            sprintName: getListName()
        })));
    const isHeaderDropDisabled = !isCollapsed || isDisabled;
    const isDividerHidden = !canEditIssue || type === (0, $7TyGu.BACKLOG) || isActiveSprint || isCollapsed && type === (0, $7TyGu.SPRINT);
    const headerRef = (0, $eUqFw.useRef)(null);
    const transitionZoneElementRef = (0, $eUqFw.useRef)(null);
    const { isDraggingOver: isDraggingOverPragmatic } = (0, $2VSqB.useCardListDropTarget)({
        headerElementRef: headerRef,
        transitionZoneElementRef: transitionZoneElementRef,
        cardListId: cardListId,
        isHeaderDropDisabled: isHeaderDropDisabled
    });
    const header = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0dea9b43ba62c01e$var$CollapsedDropzoneWrapper, {
        ref: headerRef
    }, !isHeaderDropDisabled && isDraggingOverPragmatic && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0dea9b43ba62c01e$var$CollapsedDropzone, null), renderHeader());
    const list = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bn3eO.ContainerSizeContext).Provider, {
        value: {
            size: backlogContainerSize
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d016W.default), {
        cardListId: cardListId,
        renderCard: renderIccCard,
        isDropDisabled: isDisabled || showTransitionZone,
        emptyList: getEmptyList()
    }));
    const iccAriaLabelledById = `icc-${name.replace(/\s/g, '-')}`.toLowerCase();
    const icc = isIccEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5qDf1.default), {
        listId: cardListId,
        isOpenByDefault: isFirstList && isBacklogEmpty,
        ariaLabelledBy: iccAriaLabelledById
    }) : null;
    const iccWithNudge = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hb3Di.ConditionalNudgeWrapper), {
            Wrapper: (0, $aaEXn.BacklogCreateIssueNudgeAsync),
            conditionsToApplyWrapper: isBacklogCardList
        }, icc);
    const workloadByAssignee = ()=>!isBacklogCardList && isCompanyManaged && isWorkloadByAssigneeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1z582.default), {
            cardListId: cardListId,
            sprintName: name
        }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: {
            attributes: {
                cardListType: typeForAnalytics
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0dea9b43ba62c01e$var$Container, {
        hasSpaceBetweenCardLists: canEditIssue ? isActiveSprint && !isCollapsed : false,
        isBacklogCardList: isBacklogCardList,
        isDisabled: isDisabled,
        "aria-controls": `${(0, $9eH8H.HEADER_DROPPABLE_ID_PREFIX)}${cardListId}`,
        "data-testid": `software-backlog.card-list.container.${cardListId}`
    }, renderA11yScreenReaderInfo(), header, isBacklogCardList && (0, $1ybV0.ff)('sprint_planning_whiteboards_kill_switch', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0dea9b43ba62c01e$var$SprintPlanningWhiteboards, null), !isCollapsed && renderSprintData(), !isCollapsed && workloadByAssignee(), !isCollapsed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0dea9b43ba62c01e$var$ListContainer, {
        id: `backlog-accordion-${cardListId}`,
        "data-testid": "software-backlog.card-list.accordion",
        innerRef: listRef,
        isFirstNonEmptyList: isFirstNonEmptyList
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1JLT3.default), {
        isVisible: showTransitionZone,
        ref: transitionZoneElementRef
    }), list, iccWithNudge(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0dea9b43ba62c01e$var$VisuallyHidden, {
        as: "p",
        id: iccAriaLabelledById
    }, formatMessage((0, $1sAnk.default).inlineCardCreateAriaLabel, {
        sprintName: getListName()
    }))), isLastNonEmptyList && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLLIl.LastResultMarker), null)), !isDividerHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heWc5.default), {
        id: cardListId
    }));
}
var $0dea9b43ba62c01e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($0dea9b43ba62c01e$var$CardList);
const $0dea9b43ba62c01e$var$ListNameExperiment = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "div",
        level: "h400"
    }, children); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0dea9b43ba62c01e$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasSpaceBetweenCardLists: hasSpaceBetweenCardLists, isDisabled: isDisabled, isBacklogCardList: isBacklogCardList, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul9cs0k _2rkou2gc _1yt41uce",
            __cmplp.hasSpaceBetweenCardLists ? "_18s81km1" : "_18s861nu",
            __cmplp.isDisabled && "_tzy4105o",
            __cmplp.isDisabled && "_lcxvglyw",
            !__cmplp.isBacklogCardList && "_bfhkhri9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0dea9b43ba62c01e$var$CardListHeaderControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "ahoa2g-0"
})({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minHeight: `${(0, $c9TLT.gridSize) * 4}px`
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ isMinLimitReached: isMinLimitReached, isMaxLimitReached: isMaxLimitReached })=>(isMinLimitReached || isMaxLimitReached) && `
            background-color: ${isMaxLimitReached ? "var(--ds-background-accent-red-subtlest, #FFEDEB)" : "var(--ds-background-accent-yellow-subtlest, #FFF7D6)"};
            /* negative margin to fill out the header correctly */
${''}
            margin: -${0, $c9TLT.gridSize}px -${(0, $c9TLT.gridSize) * 1.5}px;
${''}
            padding: ${0, $c9TLT.gridSize}px ${(0, $c9TLT.gridSize) * 1.5}px;
${''}
            border-top-left-radius: ${0, $c9TLT.gridSize}px;
${''}
            border-top-right-radius: ${0, $c9TLT.gridSize}px;
        `); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $0dea9b43ba62c01e$var$CardListHeaderExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isMinLimitReached: isMinLimitReached, isMaxLimitReached: isMaxLimitReached, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1lbjnkk": (0, $9t7rW.default)(__cmplp.isMaxLimitReached ? "var(--ds-background-accent-red-subtlest, #FFEDEB)" : "var(--ds-background-accent-yellow-subtlest, #FFF7D6)")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _1tkezwfg",
            (__cmplp.isMinLimitReached || __cmplp.isMaxLimitReached) && "_bfhk9rs6 _19pk1bs0 _2hwx1vh9 _otyr1bs0 _18u01vh9 _ca0qftgi _u5f31crf _n3tdftgi _19bv1crf _13liftgi _qrwqftgi",
            __cmplp.className
        ])
    });
});
const $0dea9b43ba62c01e$var$CardListHeader = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $0dea9b43ba62c01e$var$CardListHeaderExperiment, $0dea9b43ba62c01e$var$CardListHeaderControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0dea9b43ba62c01e$var$CardMenuActionsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19bvu2gc _1e0c1txw _2lx2vrvc _fiawglyw",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0dea9b43ba62c01e$var$ListContainerControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "ahoa2g-1"
})({
    margin: `${"var(--ds-space-100, 8px)"} 0 0 0`,
    position: 'relative'
}, /* to correctly show the spotlight, to be removed when remove UIF changeboarding */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ isFirstNonEmptyList: isFirstNonEmptyList })=>isFirstNonEmptyList && `
        *::before,
        *::after {
            z-index: 9;
        }`); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $0dea9b43ba62c01e$var$ListContainerExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8v0yc _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $0dea9b43ba62c01e$var$ListContainer = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $0dea9b43ba62c01e$var$ListContainerExperiment, $0dea9b43ba62c01e$var$ListContainerControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0dea9b43ba62c01e$var$Icon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_lcxvglyw",
            __cmplp.className
        ])
    });
}); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
const $0dea9b43ba62c01e$var$ListNameControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "ahoa2g-2"
})`${(0, $4lTFP).h400()};margin:0;`;
const $0dea9b43ba62c01e$var$ListName = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $0dea9b43ba62c01e$var$ListNameExperiment, $0dea9b43ba62c01e$var$ListNameControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0dea9b43ba62c01e$var$VisibleCardsInCardListHeader = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyboqnp _syaz1wmz _k48p4jg8 _18s8xmni",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0dea9b43ba62c01e$var$ColumnLimit = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48p4jg8 _18s8xmni _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0dea9b43ba62c01e$var$CollapsedDropzoneWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0dea9b43ba62c01e$var$CollapsedDropzoneControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "ahoa2g-3"
})({
    position: 'absolute',
    width: '100%',
    height: '100%',
    border: `2px dashed ${"var(--ds-border, #dfe1e6)"}`,
    borderRadius: "'3px'"
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $0dea9b43ba62c01e$var$CollapsedDropzoneExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1bsb1osq _4t3i1osq _19it7lsx _2rko15p7",
            __cmplp.className
        ])
    });
});
const $0dea9b43ba62c01e$var$CollapsedDropzone = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $0dea9b43ba62c01e$var$CollapsedDropzoneExperiment, $0dea9b43ba62c01e$var$CollapsedDropzoneControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0dea9b43ba62c01e$var$LeftSide = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _80omtlke _16jlkb7n _1o9zkb7n _i0dlf1ug _19pkidpf _2hwxu2gc _otyridpf _18u0idpf _7ehi1vt6 _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0dea9b43ba62c01e$var$RightSide = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _19bvu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0dea9b43ba62c01e$var$DisabledStartSprintTooltip = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41b66 _y3gn1h6o _vwz410nf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0dea9b43ba62c01e$var$GoalWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81vlj _syaz1wmz _18s8ze3t _19pkv77o _19bvpxbi _u5f3v47k _1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0dea9b43ba62c01e$var$DatesWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyboqnp _k48p4jg8 _18s8xmni",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0dea9b43ba62c01e$var$CardListButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0dea9b43ba62c01e$var$AddSprintDatesButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8xmni",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0dea9b43ba62c01e$var$FullWidthWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0dea9b43ba62c01e$var$HeadingWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1bgi _11c8n7od",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0dea9b43ba62c01e$var$VisuallyHidden = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ogtohxbz _mkrz1wmp _4t3it94y _1reo15vq _18m915vq _kqswstnw _o5721q9c _1bsbt94y",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gtzuR", function(module, exports) {
// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */ function keyCode(searchInput) {
    // Keyboard Events
    if (searchInput && 'object' === typeof searchInput) {
        var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
        if (hasKeyCode) searchInput = hasKeyCode;
    }
    // Numbers
    if ('number' === typeof searchInput) return names[searchInput];
    // Everything else (cast to string)
    var search = String(searchInput);
    // check codes
    var foundNamedKey = codes[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // check aliases
    var foundNamedKey = aliases[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // weird character?
    if (search.length === 1) return search.charCodeAt(0);
    return undefined;
}
/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */ keyCode.isEventKey = function isEventKey(event, nameOrCode) {
    if (event && 'object' === typeof event) {
        var keyCode = event.which || event.keyCode || event.charCode;
        if (keyCode === null || keyCode === undefined) return false;
        if (typeof nameOrCode === 'string') {
            // check codes
            var foundNamedKey = codes[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
            // check aliases
            var foundNamedKey = aliases[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
        } else if (typeof nameOrCode === 'number') return nameOrCode === keyCode;
        return false;
    }
};
exports = module.exports = keyCode;
/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */ var codes = exports.code = exports.codes = {
    'backspace': 8,
    'tab': 9,
    'enter': 13,
    'shift': 16,
    'ctrl': 17,
    'alt': 18,
    'pause/break': 19,
    'caps lock': 20,
    'esc': 27,
    'space': 32,
    'page up': 33,
    'page down': 34,
    'end': 35,
    'home': 36,
    'left': 37,
    'up': 38,
    'right': 39,
    'down': 40,
    'insert': 45,
    'delete': 46,
    'command': 91,
    'left command': 91,
    'right command': 93,
    'numpad *': 106,
    'numpad +': 107,
    'numpad -': 109,
    'numpad .': 110,
    'numpad /': 111,
    'num lock': 144,
    'scroll lock': 145,
    'my computer': 182,
    'my calculator': 183,
    ';': 186,
    '=': 187,
    ',': 188,
    '-': 189,
    '.': 190,
    '/': 191,
    '`': 192,
    '[': 219,
    '\\': 220,
    ']': 221,
    "'": 222
};
// Helper aliases
var aliases = exports.aliases = {
    'windows': 91,
    "\u21E7": 16,
    "\u2325": 18,
    "\u2303": 17,
    "\u2318": 91,
    'ctl': 17,
    'control': 17,
    'option': 18,
    'pause': 19,
    'break': 19,
    'caps': 20,
    'return': 13,
    'escape': 27,
    'spc': 32,
    'spacebar': 32,
    'pgup': 33,
    'pgdn': 34,
    'ins': 45,
    'del': 46,
    'cmd': 91
};
/*!
 * Programatically add the following
 */ // lower case chars
for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
// numbers
for(var i = 48; i < 58; i++)codes[i - 48] = i;
// function keys
for(i = 1; i < 13; i++)codes['f' + i] = i + 111;
// numpad keys
for(i = 0; i < 10; i++)codes['numpad ' + i] = i + 96;
/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */ var names = exports.names = exports.title = {} // title for backward compat
;
// Create reverse mapping
for(i in codes)names[codes[i]] = i;
// Add aliases
for(var alias in aliases)codes[alias] = aliases[alias];

});

parcelRegister("2jdHI", function(module, exports) {

$parcel$export(module.exports, "default", () => $3243fa342b695d88$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");
function $3243fa342b695d88$export$2e2bcd8739ae039(callback, delay, options) {
    const optionsRef = (0, $eUqFw.useRef)(options);
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    const callbackRef = (0, $eUqFw.useRef)((...args)=>{
        callback(...args);
    });
    callbackRef.current = callback;
    const debouncedCallBack = (0, $eUqFw.useMemo)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
        delay
    ]);
    (0, $eUqFw.useEffect)(()=>debouncedCallBack.cancel, [
        debouncedCallBack
    ]);
    return [
        debouncedCallBack,
        debouncedCallBack.cancel
    ];
}

});

parcelRegister("hb3Di", function(module, exports) {

$parcel$export(module.exports, "ConditionalNudgeWrapper", () => $a40d8b671c4ac5be$export$56d544c4f479b7fb);

var $eUqFw = parcelRequire("eUqFw");
const $a40d8b671c4ac5be$export$56d544c4f479b7fb = ({ children: children, Wrapper: Wrapper, conditionsToApplyWrapper: conditionsToApplyWrapper, ...restProps })=>{
    if (conditionsToApplyWrapper && !false && children !== null && children !== false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Wrapper, restProps, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};

});

parcelRegister("6ohRd", function(module, exports) {

$parcel$export(module.exports, "BacklogAccordionNudgeAsync", () => $15b5f87c629708f8$export$42c8a8a359e4c141);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");


var $ewdMq = parcelRequire("ewdMq");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $15b5f87c629708f8$var$BacklogAccordionNudgeLazy = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("951ij")).then((exportedModule)=>exportedModule.BacklogAccordionNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/scrum-onboarding-tour/backlog-accordion/index.tsx"
});
const $15b5f87c629708f8$export$42c8a8a359e4c141 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewdMq.OnboardingNudgeErrorBoundary), {
        id: (0, $99a775c02d636a41$export$65fb0c4e534f03fc),
        attributes: {
            nudgeId: (0, $8379f5d78bf6fb5a$export$b1a6ab17737f33e)
        },
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "software-onboarding-backlog-accordion-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($15b5f87c629708f8$var$BacklogAccordionNudgeLazy, null, children)));
$15b5f87c629708f8$export$42c8a8a359e4c141.displayName = 'BacklogAccordionNudgeAsync';

});
// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
// Note this key used to be 'should-show-scrum-modal' but was changed to prevent a bug where experienced users
// Could see the modal if they were previously enrolled into ISO
const $8379f5d78bf6fb5a$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $8379f5d78bf6fb5a$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $8379f5d78bf6fb5a$export$e3884212029f7bef = 'should-show-welcome-modal';
const $8379f5d78bf6fb5a$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $8379f5d78bf6fb5a$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $8379f5d78bf6fb5a$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $8379f5d78bf6fb5a$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $8379f5d78bf6fb5a$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $8379f5d78bf6fb5a$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $8379f5d78bf6fb5a$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $8379f5d78bf6fb5a$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $8379f5d78bf6fb5a$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $8379f5d78bf6fb5a$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $8379f5d78bf6fb5a$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $8379f5d78bf6fb5a$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $8379f5d78bf6fb5a$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $8379f5d78bf6fb5a$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $8379f5d78bf6fb5a$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $8379f5d78bf6fb5a$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $8379f5d78bf6fb5a$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $8379f5d78bf6fb5a$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $8379f5d78bf6fb5a$export$468488291ccd988 = 'timelineAddItemNudge';
const $8379f5d78bf6fb5a$export$7a33548109ac931d = 'createFormNudge';
const $8379f5d78bf6fb5a$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $8379f5d78bf6fb5a$export$594d3436316492be = 'summaryViewNudge';
const $8379f5d78bf6fb5a$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $8379f5d78bf6fb5a$export$73278890f736ee6f = 'manageProjectsNudge';

const $99a775c02d636a41$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $99a775c02d636a41$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $99a775c02d636a41$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $99a775c02d636a41$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $99a775c02d636a41$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $99a775c02d636a41$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $99a775c02d636a41$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $99a775c02d636a41$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $99a775c02d636a41$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $99a775c02d636a41$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $99a775c02d636a41$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $99a775c02d636a41$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $99a775c02d636a41$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $99a775c02d636a41$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $99a775c02d636a41$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $99a775c02d636a41$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $99a775c02d636a41$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $99a775c02d636a41$export$4d6567e7ee0281bf = 'asyncManageProjectsNudge';
const $99a775c02d636a41$export$f8bf435a6066832c = 'button clicked';
const $99a775c02d636a41$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $99a775c02d636a41$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $99a775c02d636a41$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $99a775c02d636a41$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $99a775c02d636a41$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $99a775c02d636a41$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $99a775c02d636a41$export$5908fa8acd2c0739 = 'filterListNudge';
const $99a775c02d636a41$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $99a775c02d636a41$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $99a775c02d636a41$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $99a775c02d636a41$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $99a775c02d636a41$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $99a775c02d636a41$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $99a775c02d636a41$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $99a775c02d636a41$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $99a775c02d636a41$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $99a775c02d636a41$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $99a775c02d636a41$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $99a775c02d636a41$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $99a775c02d636a41$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $99a775c02d636a41$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $99a775c02d636a41$export$a1be34032ee24f78 = 'shareProjectNudge';
const $99a775c02d636a41$export$29fe6611cc093756 = 'summaryTabNudge';
const $99a775c02d636a41$export$f107c06c0830f09d = 'reportsTabNudge';

parcelRegister("951ij", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('1DDd8');
        const value = parcelRequire('eIPwO');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("1DDd8").then(()=>parcelRequire('eIPwO'));
}

});


parcelRegister("2Gmfi", function(module, exports) {

$parcel$export(module.exports, "BacklogCompleteSprintNudgeAsync", () => $0f2cf2d6b28f7c6f$export$ac45d9b04f7ab6cb);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ewdMq = parcelRequire("ewdMq");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0f2cf2d6b28f7c6f$var$BacklogCompleteSprintNudgeLazy = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("5w4Cx")).then((exportedModule)=>exportedModule.BacklogCompleteSprintNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/scrum-onboarding-tour/backlog-complete-sprint/index.tsx"
});
const $0f2cf2d6b28f7c6f$export$ac45d9b04f7ab6cb = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewdMq.OnboardingNudgeErrorBoundary), {
        id: (0, $99a775c02d636a41$export$65fb0c4e534f03fc),
        fallback: children,
        attributes: {
            nudgeId: (0, $99a775c02d636a41$export$63b61f654ce3da3d)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "software-onboarding-backlog-complete-sprint-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0f2cf2d6b28f7c6f$var$BacklogCompleteSprintNudgeLazy, null, children)));
$0f2cf2d6b28f7c6f$export$ac45d9b04f7ab6cb.displayName = 'BacklogCompleteSprintNudgeAsync';

});
parcelRegister("5w4Cx", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('t3lDD');
        const value = parcelRequire('e7c5a');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("t3lDD").then(()=>parcelRequire('e7c5a'));
}

});


parcelRegister("aaEXn", function(module, exports) {

$parcel$export(module.exports, "BacklogCreateIssueNudgeAsync", () => $2812af2a08a1c62c$export$c82c69976e89b06);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ewdMq = parcelRequire("ewdMq");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2812af2a08a1c62c$var$BacklogCreateIssueNudgeLazy = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("kG0QG")).then((exportedModule)=>exportedModule.BacklogCreateIssueNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/scrum-onboarding-tour/backlog-create-issue/index.tsx"
});
const $2812af2a08a1c62c$export$c82c69976e89b06 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewdMq.OnboardingNudgeErrorBoundary), {
        id: (0, $99a775c02d636a41$export$65fb0c4e534f03fc),
        fallback: children,
        attributes: {
            nudgeId: (0, $99a775c02d636a41$export$64d75060ee6ba425)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-software-onboarding-backlog-create-issue-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2812af2a08a1c62c$var$BacklogCreateIssueNudgeLazy, null, children)));
$2812af2a08a1c62c$export$c82c69976e89b06.displayName = 'BacklogCreateIssueNudgeAsync';

});
parcelRegister("kG0QG", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('k5x8X');
        const value = parcelRequire('ecCsv');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("k5x8X").then(()=>parcelRequire('ecCsv'));
}

});


parcelRegister("9IOLk", function(module, exports) {

$parcel$export(module.exports, "BacklogCreateSprintNudgeAsync", () => $eb0773406a05008b$export$e8f8b0e825812dde);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ewdMq = parcelRequire("ewdMq");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $eb0773406a05008b$var$BacklogCreateSprintNudgeLazy = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("20FJv")).then((exportedModule)=>exportedModule.BacklogCreateSprintNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/scrum-onboarding-tour/backlog-create-sprint/index.tsx"
});
const $eb0773406a05008b$export$e8f8b0e825812dde = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewdMq.OnboardingNudgeErrorBoundary), {
        id: (0, $99a775c02d636a41$export$65fb0c4e534f03fc),
        fallback: children,
        attributes: {
            nudgeId: (0, $99a775c02d636a41$export$e0197e09cccd4e50)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "software-onboarding-backlog-create-sprint-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb0773406a05008b$var$BacklogCreateSprintNudgeLazy, null, children)));
$eb0773406a05008b$export$e8f8b0e825812dde.displayName = 'BacklogCreateSprintNudgeAsync';

});
parcelRegister("20FJv", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8TYmp');
        const value = parcelRequire('eWANn');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8TYmp").then(()=>parcelRequire('eWANn'));
}

});


parcelRegister("1LQrA", function(module, exports) {

$parcel$export(module.exports, "BacklogStartSprintNudgeAsync", () => $4b3b8fe919c3902a$export$fa791bd23efa3d8e);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ewdMq = parcelRequire("ewdMq");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4b3b8fe919c3902a$var$BacklogStartSprintNudgeLazy = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("aYL1U")).then((exportedModule)=>exportedModule.BacklogStartSprintNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/scrum-onboarding-tour/backlog-start-sprint/index.tsx"
});
const $4b3b8fe919c3902a$export$fa791bd23efa3d8e = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewdMq.OnboardingNudgeErrorBoundary), {
        id: (0, $99a775c02d636a41$export$65fb0c4e534f03fc),
        fallback: children,
        attributes: {
            nudgeId: (0, $99a775c02d636a41$export$6770a2081a63fc15)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "software-onboarding-backlog-start-sprint-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4b3b8fe919c3902a$var$BacklogStartSprintNudgeLazy, null, children)));
$4b3b8fe919c3902a$export$fa791bd23efa3d8e.displayName = 'BacklogStartSprintNudgeAsync';

});
parcelRegister("aYL1U", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8RWe4');
        const value = parcelRequire('aIyud');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8RWe4").then(()=>parcelRequire('aIyud'));
}

});


parcelRegister("105cx", function(module, exports) {

$parcel$export(module.exports, "useRegisterNudgeTarget", () => $4897a924f3a2c5b3$export$eb8a96124d659f2d);
$parcel$export(module.exports, "PortalledNudge", () => $4897a924f3a2c5b3$export$74f8d45d75dfda4f);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $9WJJx = parcelRequire("9WJJx");
/**
 * This class tracks nudge target HTML DOM elements by ID.
 * It also tracks subscribers to updates of these elements.
 */ class $4897a924f3a2c5b3$var$NudgeController {
    static{
        /**
	 * Singleton instance of this class.
	 * Alternatively multiple instances would be created and passed through context.
	 */ this.instance = new $4897a924f3a2c5b3$var$NudgeController();
    }
    /**
	 * Register the HTML DOM node for an ID
	 */ registerNudgeTarget(id, ref) {
        this.nudgeTargetsMap.set(id, ref);
        this.notifySubscribers(id);
        // Return a cleanup function that will remove this ID from the map
        return ()=>{
            this.nudgeTargetsMap.delete(id);
        };
    }
    /**
	 * Subscribe to updates to a certain DOM node
	 */ subscribe(id, callback) {
        const subscribers = this.subscribers.get(id) ?? [];
        subscribers.push(callback);
        this.subscribers.set(id, subscribers);
        // Return a cleanup function that will remove this callback from the list of subscribers
        return ()=>{
            const subscribersOnCleanup = this.subscribers.get(id) ?? [];
            this.subscribers.set(id, subscribersOnCleanup.filter((cb)=>cb !== callback));
        };
    }
    /**
	 * Notify subscribers that the HTML DOM node for an ID has been updated.
	 */ notifySubscribers(id) {
        const subscribers = this.subscribers.get(id) ?? [];
        subscribers.forEach((subscriber)=>{
            subscriber();
        });
    }
    constructor(){
        this.nudgeTargetsMap = new Map();
        this.subscribers = new Map();
    }
}
/**
 * Return the singleton controller
 */ const $4897a924f3a2c5b3$var$useNudgeController = ()=>$4897a924f3a2c5b3$var$NudgeController.instance;
const $4897a924f3a2c5b3$export$eb8a96124d659f2d = (id, shouldRegister = true)=>{
    const controller = $4897a924f3a2c5b3$var$useNudgeController();
    const ref = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (shouldRegister) {
            const unregister = controller.registerNudgeTarget(id, ref);
            return ()=>{
                unregister();
            };
        }
    }, [
        controller,
        id,
        shouldRegister
    ]);
    return {
        ref: ref
    };
};
/**
 * Creates a subscription into this component, that will return a boolean stating if
 * the HTML DOM node is associated with a given target ID.
 */ const $4897a924f3a2c5b3$var$useHasNudgeTargetNode = (id)=>{
    const controller = $4897a924f3a2c5b3$var$useNudgeController();
    const [hasRefValue, setHasRefValue] = (0, $eUqFw.useState)(!!controller.nudgeTargetsMap.get(id)?.current);
    (0, $eUqFw.useLayoutEffect)(()=>{
        setHasRefValue(!!controller.nudgeTargetsMap.get(id)?.current);
        const unsubscribe = controller.subscribe(id, ()=>{
            setHasRefValue(!!controller.nudgeTargetsMap.get(id)?.current);
        });
        return ()=>{
            unsubscribe();
        };
    }, [
        controller,
        id
    ]);
    return hasRefValue;
};
/**
 * When the nudge is shown, get and track the rectangle of the target element.
 */ const $4897a924f3a2c5b3$var$useNudgeRectangle = (isShown, id, nudgeContainer)=>{
    const [innerRectangle, setInnerRectangle] = (0, $eUqFw.useState)(null);
    const frameId = (0, $eUqFw.useRef)(null);
    const controller = $4897a924f3a2c5b3$var$useNudgeController();
    const nudgeTarget = controller.nudgeTargetsMap.get(id)?.current;
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!isShown || !nudgeTarget || !nudgeContainer.current) {
            // Reset rectangle to eliminate risk of Spotlight rendering at
            // old position when nudge is e.g. hidden then shown in a different place.
            if (innerRectangle !== null) setInnerRectangle(null);
            return undefined;
        }
        // This is one approach to tracking the elements moving. See https://hello.atlassian.net/wiki/spaces/JST/pages/1759637849/Rendering+performance+Async+component+wrappers
        // for other options.
        const loop = ()=>{
            const targetRectangle = controller.nudgeTargetsMap.get(id)?.current?.getBoundingClientRect();
            if (!targetRectangle) return undefined;
            const newRectangle = {
                top: targetRectangle.top,
                left: targetRectangle.left,
                width: targetRectangle.width,
                height: targetRectangle.height
            };
            if (innerRectangle == null || innerRectangle.top !== newRectangle.top || innerRectangle.left !== newRectangle.left || innerRectangle.width !== newRectangle.width || innerRectangle.height !== newRectangle.height) setInnerRectangle(newRectangle);
            else frameId.current = requestAnimationFrame(loop);
        };
        frameId.current = requestAnimationFrame(loop);
        return ()=>{
            if (frameId.current != null) cancelAnimationFrame(frameId.current);
        };
    }, [
        isShown,
        nudgeContainer,
        innerRectangle,
        nudgeTarget,
        controller.nudgeTargetsMap,
        id
    ]);
    return innerRectangle;
};
/**
 * Create and append a DOM node to use for the nudge. This is on a separate root to the rest of the app.
 */ const $4897a924f3a2c5b3$var$usePortalContainer = ()=>{
    const nudgeContainer = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!nudgeContainer.current) {
            nudgeContainer.current = document.createElement('div');
            document.body.appendChild(nudgeContainer.current);
        }
        return ()=>{
            if (nudgeContainer.current) document.body.removeChild(nudgeContainer.current);
        };
    }, []);
    return nudgeContainer;
};
const $4897a924f3a2c5b3$export$74f8d45d75dfda4f = (props)=>{
    const nudgeContainer = $4897a924f3a2c5b3$var$usePortalContainer();
    const hasRefValue = $4897a924f3a2c5b3$var$useHasNudgeTargetNode(props.nudgeTargetId);
    const innerRectangle = $4897a924f3a2c5b3$var$useNudgeRectangle(!props.hidden, props.nudgeTargetId, nudgeContainer);
    const innerRectanglePrevious = (0, $eUqFw.useRef)(innerRectangle);
    const spotlightRef = (0, $eUqFw.useRef)(null);
    // Force update the Popper spotlight when the innerRectangle (nudge position) changes
    (0, $eUqFw.useEffect)(()=>{
        if (innerRectangle !== null && innerRectanglePrevious.current !== innerRectangle && spotlightRef.current !== null) {
            innerRectanglePrevious.current = innerRectangle;
            if (spotlightRef.current.forceUpdateCardPosition) spotlightRef.current.forceUpdateCardPosition();
        }
    }, [
        innerRectangle
    ]);
    const hasNudgeTarget = hasRefValue;
    if (!nudgeContainer.current || !hasNudgeTarget || !innerRectangle) return null;
    return /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'fixed',
            top: innerRectangle.top,
            left: innerRectangle.left,
            height: innerRectangle.height,
            width: innerRectangle.width,
            zIndex: props.zIndex
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9WJJx.NudgeSpotlight), {
        ...props,
        ref: spotlightRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            height: innerRectangle.height,
            width: innerRectangle.width
        }
    }))), nudgeContainer.current);
};

});

parcelRegister("j5TDo", function(module, exports) {

$parcel$export(module.exports, "BacklogButtonVariant", () => $809f26417496925b$export$5e6e40810a61fa60);

var $eUqFw = parcelRequire("eUqFw");

var $fbeIa = parcelRequire("fbeIa");

var $7u4fN = parcelRequire("7u4fN");

var $ffiyv = parcelRequire("ffiyv");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $a0eNT = parcelRequire("a0eNT");

var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");

var $9sGN6 = parcelRequire("9sGN6");

var $1qxcF = parcelRequire("1qxcF");

var $6kjWj = parcelRequire("6kjWj");

var $2eQUR = parcelRequire("2eQUR");

var $3LHTD = parcelRequire("3LHTD");
const $809f26417496925b$export$5e6e40810a61fa60 = ()=>{
    const { cohort: cohort, flow: flow } = (0, $1gQ73.useBacklogSelector)((0, $9sGN6.getWhiteboardEligibility));
    const coUseEligible = flow === 'coUse';
    const crossFlowEligible = flow === 'crossFlow';
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const crossflow = (0, $fbeIa.useCrossFlow)();
    const { fireInteractedUIEvent: fireInteractedUIEvent } = (0, $a0eNT.useFireCrossFlowAnalyticsEvents)();
    const url = (0, $1qxcF.useCoUseFlow)(coUseEligible);
    // Extract project name and project id
    const projectName = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getProjectName));
    const projectId = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.projectIdSelector));
    const onPlanOnWhiteboard = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'planOnWhiteboardBacklogButton', {
            growthInitiative: 'cross-flow',
            isCrossFlowEligible: crossFlowEligible,
            isCoUseEligible: coUseEligible,
            sourceComponent: 'planOnWhiteboardsButtonCTAScreen',
            sourceContext: 'planOnWhiteboardBacklogButton'
        });
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'planOnWhiteboardBacklogButton'
        }, {
            targetProductId: (0, $fbeIa.Targets).CONFLUENCE,
            recommendedProductIds: [
                (0, $fbeIa.Targets).CONFLUENCE
            ],
            source: 'planOnWhiteboardsButtonCTAScreen'
        });
        (0, $3LHTD.onClickCTA)({
            createAnalyticsEvent: createAnalyticsEvent,
            crossFlowEligible: crossFlowEligible,
            crossflow: crossflow,
            projectId: projectId,
            projectName: projectName,
            component: 'planOnWhiteboardsButtonCTAScreen',
            context: 'planOnWhiteboardBacklogButton',
            coUseEligible: coUseEligible,
            url: url
        });
    }, [
        crossFlowEligible,
        coUseEligible,
        projectId,
        projectName,
        crossflow,
        createAnalyticsEvent,
        fireInteractedUIEvent,
        url
    ]);
    if (!flow || cohort !== (0, $6kjWj.WHITEBOARD_ENTRYPOINT_EXPERIMENT_VARIANTS).BACKLOG_BUTTON) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $809f26417496925b$var$CTAContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onPlanOnWhiteboard
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        space: "space.050"
    }, formatMessage((0, $2eQUR.default).planOnWhiteboard), crossFlowEligible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: "new"
    }, formatMessage((0, $2eQUR.default).planOnWhiteboardTry)))));
};
const $809f26417496925b$var$CTAContainer = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.100'
});

});
parcelRegister("9sGN6", function(module, exports) {

$parcel$export(module.exports, "getHasConfluenceAccess", () => $7ee1ddf3fe946f90$export$6b10e8289feb83ca);
$parcel$export(module.exports, "getHasConfluenceSpaces", () => $7ee1ddf3fe946f90$export$2c012cbcdccebb42);
$parcel$export(module.exports, "getHasViewedPulse", () => $7ee1ddf3fe946f90$export$fa422fe0852b83ec);
$parcel$export(module.exports, "getWhiteboardEligibility", () => $7ee1ddf3fe946f90$export$db95b58c02bd0d3e);
const $7ee1ddf3fe946f90$export$ccc046947a5517f1 = (state)=>state.config.whiteboardsEntrypointExperimentConfig;
const $7ee1ddf3fe946f90$export$6b10e8289feb83ca = (state)=>$7ee1ddf3fe946f90$export$ccc046947a5517f1(state).hasConfluenceAccess;
const $7ee1ddf3fe946f90$export$2c012cbcdccebb42 = (state)=>$7ee1ddf3fe946f90$export$ccc046947a5517f1(state).hasConfluenceSpaces;
const $7ee1ddf3fe946f90$export$fa422fe0852b83ec = (state)=>$7ee1ddf3fe946f90$export$ccc046947a5517f1(state).hasViewedPulse;
const $7ee1ddf3fe946f90$export$db95b58c02bd0d3e = (state)=>$7ee1ddf3fe946f90$export$ccc046947a5517f1(state).eligibility;

});

parcelRegister("1qxcF", function(module, exports) {

$parcel$export(module.exports, "useCoUseFlow", () => $e5576d70297e70fa$export$69587f2db02847d5);

var $dWLk9 = parcelRequire("dWLk9");

var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");

var $eMJLU = parcelRequire("eMJLU");
const $e5576d70297e70fa$export$69587f2db02847d5 = (coUseEligible)=>{
    // Extract project name and project id
    const projectName = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getProjectName));
    const projectId = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.projectIdSelector));
    const spaceKey = (0, $eMJLU.useGetSpaceKey)(projectName, coUseEligible);
    const cloudId = (0, $dWLk9.useCloudId)();
    return `/wiki/create-content/whiteboard?openJiraImportTool=true&cloudId=${cloudId}&projectUuid=${projectId}&insertTemplateWithKey=prioritization-experiment&spaceKey=${spaceKey}&withFallback=True`;
};

});
parcelRegister("eMJLU", function(module, exports) {

$parcel$export(module.exports, "useGetSpaceKey", () => $309825f5b468491e$export$42371466d4d0aa3);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $309825f5b468491e$export$42371466d4d0aa3 = (projectName, coUseEligible)=>{
    const [spaceKey, setSpaceKey] = (0, $eUqFw.useState)('');
    const checkForConfluenceSpace = (0, $eUqFw.useCallback)(async ()=>{
        if (coUseEligible) try {
            const cql = `type = space and title = "${projectName}"`;
            const api = `/wiki/rest/api/search?cql=${cql}`;
            const res = await (0, $lRmyA.performGetRequest)(api);
            if (res.results?.length) setSpaceKey(res.results[0].space.key);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'GetSpaceKey',
                    packageName: 'jiraSoftwareBacklog'
                },
                error: error
            });
            setSpaceKey('');
        }
    }, [
        coUseEligible,
        projectName
    ]);
    (0, $eUqFw.useEffect)(()=>{
        checkForConfluenceSpace();
    }, [
        checkForConfluenceSpace
    ]);
    return spaceKey;
};

});


parcelRegister("6kjWj", function(module, exports) {

$parcel$export(module.exports, "WHITEBOARD_ENTRYPOINT_EXPERIMENT_VARIANTS", () => $afc980b846a91c24$export$ed09d360c28bf9e1);
const $afc980b846a91c24$export$3d370c33621572df = 'cohort';
const $afc980b846a91c24$export$5b7423264d48ab04 = 'not-enrolled';
const $afc980b846a91c24$export$b681d01ca4fade18 = 'jsw_sprint_planning_whiteboards';
const $afc980b846a91c24$export$ed09d360c28bf9e1 = {
    CONTEXT_MENU: 'variant_contextual_menu',
    BACKLOG_BUTTON: 'variant_backlog_button',
    CONTROL: 'control'
};

});

parcelRegister("2eQUR", function(module, exports) {

$parcel$export(module.exports, "default", () => $310f5770bcaaf024$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $310f5770bcaaf024$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    planOnWhiteboard: {
        "id": "backlog.whiteboards-entrypoint-experiment.plan-on-whiteboard",
        "defaultMessage": "Plan on whiteboard"
    },
    planOnWhiteboardTry: {
        "id": "backlog.whiteboards-entrypoint-experiment.plan-on-whiteboard-try",
        "defaultMessage": "Try"
    }
});

});

parcelRegister("3LHTD", function(module, exports) {

$parcel$export(module.exports, "onClickCTA", () => $9b085092c9642741$export$5765570e868a3d49);

var $fbeIa = parcelRequire("fbeIa");

var $jMP2a = parcelRequire("jMP2a");
const $9b085092c9642741$export$5765570e868a3d49 = ({ createAnalyticsEvent: createAnalyticsEvent, crossFlowEligible: crossFlowEligible, crossflow: crossflow, projectId: projectId, projectName: projectName, component: component, context: context, coUseEligible: coUseEligible, url: url })=>{
    if (crossFlowEligible) {
        if (!crossflow.isEnabled) return;
        if (!!projectId && !!projectName) crossflow.api.open({
            sourceComponent: component,
            sourceContext: context,
            targetProduct: (0, $fbeIa.Targets).CONFLUENCE,
            journey: (0, $fbeIa.Journeys).GET_STARTED,
            experimentalOptions: {
                projectId: projectId,
                projectName: projectName
            }
        });
        else (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectInfo missing', {
            growthInitiative: 'cross-flow',
            isCrossFlowEligible: crossFlowEligible,
            isCoUseEligible: coUseEligible,
            projectId: projectId,
            projectName: projectName
        });
    } else if (coUseEligible) window.open(url, '_blank');
};

});


parcelRegister("h1Q6f", function(module, exports) {

$parcel$export(module.exports, "useFireExposureEvents", () => $f0cd234ecde4fe10$export$5659c1a3e6829401);
$parcel$export(module.exports, "useGetWhiteboardEligibleFlow", () => $f0cd234ecde4fe10$export$80c0213bc3410a42);

var $fbeIa = parcelRequire("fbeIa");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $c7H0g = parcelRequire("c7H0g");
var $gd0Sp = parcelRequire("gd0Sp");

var $a0eNT = parcelRequire("a0eNT");

var $8wXFi = parcelRequire("8wXFi");

var $7TyGu = parcelRequire("7TyGu");

var $1gQ73 = parcelRequire("1gQ73");

var $bP7Jx = parcelRequire("bP7Jx");

var $9sGN6 = parcelRequire("9sGN6");
// Checks if the number of issues in the backlog is greater than 2
const $f0cd234ecde4fe10$var$useIsBacklogCardListSizeGreaterThanTwo = ()=>(0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getOrderedCardIdsByCardListId))[0, $7TyGu.BACKLOG]?.length > 2;
// Checks it the tenant has Confluence site
const $f0cd234ecde4fe10$var$useTenantHasConfluence = ()=>{
    const { licensedProducts: licensedProducts } = (0, $gd0Sp.useTenantContext)();
    return licensedProducts?.confluence === true;
};
const $f0cd234ecde4fe10$var$useTenantHasProductSuggestionsEnabled = ()=>{
    const { areProductSuggestionsEnabled: areProductSuggestionsEnabled } = (0, $gd0Sp.useTenantContext)();
    return areProductSuggestionsEnabled;
};
const $f0cd234ecde4fe10$export$ff76dd1cdd043d2b = ()=>{
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const hasConfluence = $f0cd234ecde4fe10$var$useTenantHasConfluence();
    return $f0cd234ecde4fe10$var$useTenantHasProductSuggestionsEnabled() && !hasConfluence && isAdmin;
};
const $f0cd234ecde4fe10$export$9d3b05f7271c5614 = ()=>{
    const hasAccess = (0, $1gQ73.useBacklogSelector)((0, $9sGN6.getHasConfluenceAccess));
    const hasSpaces = (0, $1gQ73.useBacklogSelector)((0, $9sGN6.getHasConfluenceSpaces));
    return $f0cd234ecde4fe10$var$useTenantHasConfluence() && hasAccess && hasSpaces;
};
const $f0cd234ecde4fe10$export$5659c1a3e6829401 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const crossFlowEligible = $f0cd234ecde4fe10$export$ff76dd1cdd043d2b();
    const coUseEligible = $f0cd234ecde4fe10$export$9d3b05f7271c5614();
    const { fireViewedScreenEvent: fireViewedScreenEvent } = (0, $a0eNT.useFireCrossFlowAnalyticsEvents)();
    const fireWhiteboardsExposureEvents = (cohort)=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', 'jswSprintPlanningWhiteboardsExperiment', {
            flagKey: (0, $8wXFi.JSW_SPRINT_PLANNING_WHITEBOARDS_ENTRYPOINT),
            cohort: cohort,
            crossFlowEligible: crossFlowEligible,
            coUseEligible: coUseEligible
        });
        // xflow UCIA events
        if (cohort === 'variant_contextual_menu') fireViewedScreenEvent('planOnWhiteboardsContextualCTAScreen', {
            recommendedProductIds: [
                (0, $fbeIa.Targets).CONFLUENCE
            ]
        });
        else if (cohort === 'variant_backlog_button') fireViewedScreenEvent('planOnWhiteboardsButtonCTAScreen', {
            recommendedProductIds: [
                (0, $fbeIa.Targets).CONFLUENCE
            ]
        });
        else if (cohort === 'control') (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'component'
        }), 'planOnWhiteboardsControlScreen');
    };
    return fireWhiteboardsExposureEvents;
};
const $f0cd234ecde4fe10$export$80c0213bc3410a42 = ()=>{
    const isCrossFlowEligible = $f0cd234ecde4fe10$export$ff76dd1cdd043d2b();
    const isCoUseEligible = $f0cd234ecde4fe10$export$9d3b05f7271c5614();
    const backlogCardListSizeGreaterThanTwo = $f0cd234ecde4fe10$var$useIsBacklogCardListSizeGreaterThanTwo();
    if (isCrossFlowEligible && backlogCardListSizeGreaterThanTwo) return 'crossFlow';
    if (isCoUseEligible && backlogCardListSizeGreaterThanTwo) return 'coUse';
    return null;
};

});

parcelRegister("huwiO", function(module, exports) {

$parcel$export(module.exports, "default", () => $fba4c7429a71325f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $89sIt = parcelRequire("89sIt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $dOL7m = parcelRequire("dOL7m");

var $gE40u = parcelRequire("gE40u");

var $1sAnk = parcelRequire("1sAnk");
const $fba4c7429a71325f$var$ADD_SPRINT_DATES_BUTTON_ICON_SELECTOR = 'software-backlog-add-sprint-dates-button-icon';
const $fba4c7429a71325f$var$AddSprintDates = ({ cardListId: cardListId })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isEditSprintModalOpen, setIsEditSprintModalOpen] = (0, $eUqFw.useState)(false);
    const onEditSprintClick = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        event.stopPropagation();
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'openAddSprintDates');
        setIsEditSprintModalOpen(true);
    }, []);
    const onEditSprintModalCloseClick = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'closeAddSprintDates');
        setIsEditSprintModalOpen(false);
    }, [
        createAnalyticsEvent
    ]);
    const editIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($89sIt))), {
        label: "",
        size: "small",
        primaryColor: "var(--ds-icon, #44546F)"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isEditSprintModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gE40u.default), {
        cardListId: cardListId,
        onClose: onEditSprintModalCloseClick,
        onSubmit: onEditSprintModalCloseClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fba4c7429a71325f$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dOL7m.ModalTriggerButton), {
        appearance: "subtle",
        spacing: "compact",
        onClick: onEditSprintClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fba4c7429a71325f$var$ButtonContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fba4c7429a71325f$var$ButtonIcon, {
        "data-component-selector": $fba4c7429a71325f$var$ADD_SPRINT_DATES_BUTTON_ICON_SELECTOR
    }, editIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fba4c7429a71325f$var$ButtonText, null, formatMessage((0, $1sAnk.default).addSprintDates))))));
};
var $fba4c7429a71325f$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $fba4c7429a71325f$var$AddSprintDates;
const $fba4c7429a71325f$var$ButtonText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fba4c7429a71325f$var$ButtonIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _4t3i7vkz _2hwxv77o",
            __cmplp.className
        ])
    });
});
const $fba4c7429a71325f$var$ButtonContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _4djwglyw",
            __cmplp.className
        ])
    });
});
const $fba4c7429a71325f$var$ButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wybutpp _kewe1khi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("89sIt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ef570750d61ee3c$var$_react = $5ef570750d61ee3c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $5ef570750d61ee3c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $5ef570750d61ee3c$var$EditFilledIcon = (props)=>/*#__PURE__*/ $5ef570750d61ee3c$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M4.02 19.23a1 1 0 001.18 1.18l3.81-.78-4.21-4.21-.78 3.81zM19.844 6.707l-2.12-2.122A1.997 1.997 0 0016.308 4c-.512 0-1.024.195-1.415.585l-9.757 9.758 4.95 4.95 9.757-9.758a2 2 0 000-2.828z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$5ef570750d61ee3c$var$EditFilledIcon.displayName = 'EditFilledIcon';
var $5ef570750d61ee3c$var$_default = $5ef570750d61ee3c$var$EditFilledIcon;
module.exports.default = $5ef570750d61ee3c$var$_default;

});

parcelRegister("dOL7m", function(module, exports) {

$parcel$export(module.exports, "ModalTriggerButton", () => $f391d6ebf1491726$export$f69d15d2f52857d);

var $eUqFw = parcelRequire("eUqFw");

var $bbaTG = parcelRequire("bbaTG");
var $7u4fN = parcelRequire("7u4fN");

var $iVF7F = parcelRequire("iVF7F");
const $f391d6ebf1491726$export$f69d15d2f52857d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ onClick: onClickProp, ...props }, ref)=>{
    const internalRef = (0, $eUqFw.useRef)(null);
    const { setReturnFocusTo: setReturnFocusTo } = (0, $iVF7F.useModalDialogActions)();
    const handleRef = (0, $eUqFw.useCallback)((element)=>{
        if (ref) {
            if (typeof ref === 'function') ref(element);
            else {
                // We need to proxy ref to avoid an eslint error (no-param-reassign)
                const mutableRef = ref;
                mutableRef.current = element;
            }
        }
        internalRef.current = element;
    }, [
        ref
    ]);
    const onClick = (0, $eUqFw.useCallback)((...args)=>{
        onClickProp && onClickProp(...args);
        setReturnFocusTo(internalRef);
    }, [
        onClickProp,
        setReturnFocusTo
    ]);
    if ('theme' in props) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        ref: handleRef,
        onClick: onClick,
        ...props
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ref: handleRef,
        onClick: onClick,
        ...props
    });
});

});
parcelRegister("iVF7F", function(module, exports) {

$parcel$export(module.exports, "useModalDialogActions", () => $e75a117282f2e4ce$export$3cf2e4b6d3541465);
$parcel$export(module.exports, "useReturnFocusTo", () => $e75a117282f2e4ce$export$217308a4ece853b2);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $ljoN7 = parcelRequire("ljoN7");

var $6469v = parcelRequire("6469v");

var $2cPCG = parcelRequire("2cPCG");
const $e75a117282f2e4ce$var$Store = (0, $a61MH.createStore)({
    name: 'JiraSoftwareModalDialog',
    initialState: $ljoN7.initialState,
    actions: $6469v.actions
});
const $e75a117282f2e4ce$export$3cf2e4b6d3541465 = (0, $ggKAj.createActionsHook)($e75a117282f2e4ce$var$Store);
const $e75a117282f2e4ce$export$217308a4ece853b2 = (0, $ggKAj.createStateHook)($e75a117282f2e4ce$var$Store, {
    selector: (0, $2cPCG.getReturnFocusTo)
});

});
parcelRegister("ljoN7", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $4b47f7b3171df3ff$export$d4c72bab9d6cc13a);
const $4b47f7b3171df3ff$export$d4c72bab9d6cc13a = {
    returnFocusTo: null
};

});

parcelRegister("6469v", function(module, exports) {

$parcel$export(module.exports, "actions", () => $efa2fbefc0c70f4e$export$e324594224ef24da);
const $efa2fbefc0c70f4e$export$b263d1e638b131c2 = (returnFocusTo)=>({ setState: setState })=>{
        setState({
            returnFocusTo: returnFocusTo
        });
    };
const $efa2fbefc0c70f4e$export$e324594224ef24da = {
    setReturnFocusTo: $efa2fbefc0c70f4e$export$b263d1e638b131c2
};

});

parcelRegister("2cPCG", function(module, exports) {

$parcel$export(module.exports, "getReturnFocusTo", () => $5b8cf428aaed92c7$export$d5f8692765ccd209);
const $5b8cf428aaed92c7$export$d5f8692765ccd209 = (state)=>state.returnFocusTo;

});



parcelRegister("gE40u", function(module, exports) {

$parcel$export(module.exports, "default", () => $1999514e25d57d5b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $huI7r = parcelRequire("huI7r");

var $5adS1 = parcelRequire("5adS1");

var $gx4hY = parcelRequire("gx4hY");

var $dWLk9 = parcelRequire("dWLk9");

var $1gQ73 = parcelRequire("1gQ73");

var $4jE5Q = parcelRequire("4jE5Q");

var $hkGxG = parcelRequire("hkGxG");

var $j258X = parcelRequire("j258X");
const $1999514e25d57d5b$var$EditSprintModalRelay = (props)=>{
    const { cardListId: cardListId, ...rest } = props;
    const boardId = (0, $1gQ73.useBacklogSelector)((state)=>Number((0, $hkGxG.getRapidViewId)(state)));
    const cloudId = (0, $dWLk9.useCloudId)();
    const isCompanyManaged = (0, $j258X.useIsCMPBacklog)();
    const [queryReference, loadQuery] = (0, $iWLL0.useQueryLoader)((0, $5adS1.default));
    const boardAri = (0, $eUqFw.useMemo)(()=>(0, $huI7r.createAri)({
            resourceOwner: 'jira-software',
            cloudId: cloudId,
            resourceType: 'board',
            resourceId: String(boardId)
        }), [
        boardId,
        cloudId
    ]);
    const sprintAri = (0, $eUqFw.useMemo)(()=>(0, $huI7r.createAri)({
            resourceOwner: 'jira-software',
            cloudId: cloudId,
            resourceType: 'sprint',
            resourceId: String(cardListId)
        }), [
        cloudId,
        cardListId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        loadQuery({
            boardId: boardAri,
            sprintId: sprintAri,
            fetchSprints: false
        }, {
            fetchPolicy: 'network-only'
        });
    }, [
        boardAri,
        loadQuery,
        sprintAri
    ]);
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const onSubmit = (data, submitPromise)=>{
        props.onSubmit(data, submitPromise);
        const { name: name, goal: goal, startDate: startDate, endDate: endDate } = data;
        const action = (0, $4jE5Q.editSprintRequest)(cardListId, name, goal, startDate, endDate);
        const { meta: { optimistic: { id: optimisticId } } } = action;
        dispatch(action);
        submitPromise.then(()=>{
            dispatch((0, $4jE5Q.editSprintSuccess)(optimisticId));
        }).catch(()=>{
            dispatch((0, $4jE5Q.editSprintFailure)(optimisticId));
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gx4hY.default), {
        ...rest,
        onSubmit: onSubmit,
        boardAri: boardAri,
        queryReference: queryReference,
        isCompanyManaged: isCompanyManaged
    });
};
var $1999514e25d57d5b$export$2e2bcd8739ae039 = $1999514e25d57d5b$var$EditSprintModalRelay;

});
parcelRegister("5adS1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5f05e17571860fe$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<deb8dc548bac2381f539e8316cad3232>>
 * @relayHash a7c5c4d6570548dfbbb896009ae5fc47
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 90bffcc09f8865bee8f7861946866baaa79e714bb9afc19568bc71a86050977b

var $cNy9K = parcelRequire("cNy9K");
const $e5f05e17571860fe$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fetchSprints"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sprintId"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "sprintId",
            "variableName": "sprintId"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "goal"
    }, v8 = {
        "kind": "ScalarField",
        "name": "startDate"
    }, v9 = {
        "kind": "ScalarField",
        "name": "endDate"
    }, v10 = {
        "kind": "ScalarField",
        "name": "sprintState"
    }, v11 = [
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ ,
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        v10 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiJiraSoftwareEditSprintModalQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v3 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "Sprint",
                                    "kind": "LinkedField",
                                    "name": "sprint",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "RequiredField",
                                            "field": v6 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.sprint.name"
                                        },
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "RequiredField",
                                            "field": v10 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.sprint.sprintState"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.sprint"
                            },
                            {
                                "condition": "fetchSprints",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "concreteType": "Sprint",
                                        "kind": "LinkedField",
                                        "name": "sprints",
                                        "plural": true,
                                        "selections": [
                                            v5 /*: any*/ ,
                                            {
                                                "kind": "RequiredField",
                                                "field": v6 /*: any*/ ,
                                                "action": "THROW",
                                                "path": "boardScope.sprints.name"
                                            },
                                            v7 /*: any*/ ,
                                            v8 /*: any*/ ,
                                            v9 /*: any*/ ,
                                            {
                                                "kind": "RequiredField",
                                                "field": v10 /*: any*/ ,
                                                "action": "THROW",
                                                "path": "boardScope.sprints.sprintState"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "uiJiraSoftwareEditSprintModalQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "Sprint",
                            "kind": "LinkedField",
                            "name": "sprint",
                            "plural": false,
                            "selections": v11 /*: any*/ 
                        },
                        {
                            "condition": "fetchSprints",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "Sprint",
                                    "kind": "LinkedField",
                                    "name": "sprints",
                                    "plural": true,
                                    "selections": v11 /*: any*/ 
                                }
                            ]
                        },
                        v5 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "90bffcc09f8865bee8f7861946866baaa79e714bb9afc19568bc71a86050977b",
            "metadata": {},
            "name": "uiJiraSoftwareEditSprintModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e5f05e17571860fe$var$node.hash = "c7b9c1c33647526da24d1f5d937ea327";
(0, $cNy9K.PreloadableQueryRegistry).set($e5f05e17571860fe$var$node.params.id, $e5f05e17571860fe$var$node);
var $e5f05e17571860fe$export$2e2bcd8739ae039 = $e5f05e17571860fe$var$node;

});

parcelRegister("gx4hY", function(module, exports) {

$parcel$export(module.exports, "default", () => $87e63b44d43901cc$export$2e2bcd8739ae039);
$parcel$export(module.exports, "editSprintModalLoad", () => (parcelRequire("8Y2Gm")).editSprintModalLoad);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cyVXS = parcelRequire("cyVXS");

var $gGtKh = parcelRequire("gGtKh");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $8Y2Gm = parcelRequire("8Y2Gm");

var $2byXr = parcelRequire("2byXr");

var $cilgq = parcelRequire("cilgq");

const $87e63b44d43901cc$var$LazyEditSprintModal = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("ckPgy")), {
    moduleId: "./src/packages/software/edit-sprint-modal-relay/src/index.tsx"
});
const $87e63b44d43901cc$var$EditSprintModal = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onError = ()=>{
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskFail', {
            isRelay: true,
            task: 'loadEditSprintModal'
        });
        (0, $8Y2Gm.editSprintModalLoad).cancel();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cyVXS.ModalBoundary), {
        id: "edit-sprint-modal",
        packageName: "editSprintModalRelay",
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "edit-sprint-modal-relay",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($87e63b44d43901cc$var$LazyEditSprintModal, props)));
};
var $87e63b44d43901cc$export$2e2bcd8739ae039 = $87e63b44d43901cc$var$EditSprintModal;

});
parcelRegister("8Y2Gm", function(module, exports) {

$parcel$export(module.exports, "clickEditSprintInteraction", () => $e9488ae64fed68a8$export$9c57106ef5795d9a);
$parcel$export(module.exports, "editSprintModalLoad", () => $e9488ae64fed68a8$export$c39d6b5415c8a491);

var $lNfG4 = parcelRequire("lNfG4");
const $e9488ae64fed68a8$export$9c57106ef5795d9a = (0, $lNfG4.metrics).interaction({
    key: 'sprint-edit-click'
});
const $e9488ae64fed68a8$export$c39d6b5415c8a491 = (0, $lNfG4.metrics).interaction({
    key: 'edit-sprint-modal-load'
});

});

parcelRegister("2byXr", function(module, exports) {

$parcel$export(module.exports, "EditSprintModalEntryPointContainer", () => $d99df3b5470985a5$export$385f16077f730dc3);

var $eUqFw = parcelRequire("eUqFw");

var $3q7Yq = parcelRequire("3q7Yq");

var $3tfzg = parcelRequire("3tfzg");
var $k8Qyf = parcelRequire("k8Qyf");

var $huI7r = parcelRequire("huI7r");

var $dWLk9 = parcelRequire("dWLk9");
const $d99df3b5470985a5$export$385f16077f730dc3 = ({ boardId: boardId, isCompanyManaged: isCompanyManaged, entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject, onSubmit: onSubmit, onReady: onReady, onClose: onClose })=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const boardAri = (0, $huI7r.createAri)({
        resourceId: String(boardId),
        resourceType: 'board',
        resourceOwner: 'jira-software',
        cloudId: cloudId
    });
    const handleSubmit = (0, $eUqFw.useCallback)((data, requestPromise)=>{
        // Show a generic error flag on request failure
        requestPromise.catch(()=>{
            showFlag((0, $3tfzg.default).genericError());
            return {
                editSprint: null
            };
        });
        onSubmit(data, requestPromise);
    }, [
        onSubmit,
        showFlag
    ]);
    const props = (0, $eUqFw.useMemo)(()=>({
            boardAri: boardAri,
            isCompanyManaged: isCompanyManaged,
            fetchSprints: true,
            onSubmit: handleSubmit,
            ...onReady && {
                onReady: onReady
            },
            ...onClose && {
                onClose: onClose
            }
        }), [
        boardAri,
        isCompanyManaged,
        handleSubmit,
        onReady,
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3q7Yq.ModalEntryPointContainer), {
        id: "edit-sprint-modal",
        teamName: "a4t-pandora",
        packageName: "jiraSoftwareEditSprintModalRelay",
        entryPointActions: entryPointActions,
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
};

});
parcelRegister("3q7Yq", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPointContainer", () => $79aee538140aeba6$export$4d67c6ee49f3d14d);

var $eUqFw = parcelRequire("eUqFw");

var $dxopF = parcelRequire("dxopF");

var $P6D7Q = parcelRequire("P6D7Q");

var $ioLN0 = parcelRequire("ioLN0");
const $79aee538140aeba6$export$4d67c6ee49f3d14d = ({ entryPointActions: { unload: unload }, entryPointReferenceSubject: entryPointReferenceSubject, errorFallback: errorFallback, runtimeProps: runtimeProps, ...containerProps })=>{
    const entryPointReference = (0, $P6D7Q.useEntryPointSubscription)(entryPointReferenceSubject);
    const props = (0, $eUqFw.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ({
            ...runtimeProps,
            onClose () {
                runtimeProps.onClose?.();
                unload();
            }
        }), [
        runtimeProps,
        unload
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, entryPointReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ioLN0.InternalEntryPointContainer), {
        ...containerProps,
        entryPointReference: entryPointReference,
        errorFallback: errorFallback || 'flag',
        placeholderName: "modal-entry-point-container",
        runtimeProps: props
    }));
};

});


parcelRegister("cilgq", function(module, exports) {

$parcel$export(module.exports, "useEditSprintModalEntryPoint", () => $7edf04cea7541d07$export$6009493f90785e59);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $l3Qg0 = parcelRequire("l3Qg0");

var $huI7r = parcelRequire("huI7r");

var $bU6dn = parcelRequire("bU6dn");

var $dWLk9 = parcelRequire("dWLk9");

var $8Y2Gm = parcelRequire("8Y2Gm");
const $7edf04cea7541d07$export$6009493f90785e59 = (boardId, sprintId, isCompanyManaged)=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const boardAri = (0, $eUqFw.useMemo)(()=>(0, $huI7r.createAri)({
            resourceOwner: 'jira-software',
            cloudId: cloudId,
            resourceType: 'board',
            resourceId: String(boardId)
        }), [
        boardId,
        cloudId
    ]);
    const sprintAri = (0, $eUqFw.useMemo)(()=>(0, $huI7r.createAri)({
            resourceOwner: 'jira-software',
            cloudId: cloudId,
            resourceType: 'sprint',
            resourceId: sprintId
        }), [
        cloudId,
        sprintId
    ]);
    const entryPointParams = (0, $eUqFw.useMemo)(()=>({
            boardId: boardAri,
            sprintId: sprintAri,
            fetchSprints: false,
            isCompanyManaged: isCompanyManaged
        }), [
        boardAri,
        sprintAri,
        isCompanyManaged
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject, stopMetric: stopMetric } = (0, $6j4bv.useEntryPoint)((0, $bU6dn.editSprintModalEntryPoint), entryPointParams, (0, $8Y2Gm.editSprintModalLoad));
    const editSprintModalTriggerRef = (0, $l3Qg0.useEntryPointButtonTrigger)(entryPointActions);
    return {
        entryPointActions: entryPointActions,
        entryPointReferenceSubject: entryPointReferenceSubject,
        stopMetric: stopMetric,
        editSprintModalTriggerRef: editSprintModalTriggerRef
    };
};

});
parcelRegister("l3Qg0", function(module, exports) {

$parcel$export(module.exports, "useEntryPointButtonTrigger", () => $c6e813dbc513f02a$export$25d2524a63315ed);
$parcel$export(module.exports, "getDefaultEntrypointActionEventMap", () => $c6e813dbc513f02a$export$5f13515bd3a35325);

var $eUqFw = parcelRequire("eUqFw");

var $a9frS = parcelRequire("a9frS");
const $c6e813dbc513f02a$export$25d2524a63315ed = (actions, isActive = true, eventMap = $c6e813dbc513f02a$export$5f13515bd3a35325(actions))=>{
    const removePreviousListeners = (0, $eUqFw.useRef)(null);
    const isMounted = (0, $eUqFw.useRef)(true);
    (0, $eUqFw.useEffect)(()=>()=>{
            removePreviousListeners.current?.();
            removePreviousListeners.current = null;
            isMounted.current = false;
        }, []);
    return (0, $eUqFw.useCallback)((element)=>{
        if (!isMounted.current) return;
        removePreviousListeners.current?.();
        if (element && isActive) {
            (0, $a9frS.modifyListeners)({
                element: element,
                operationName: 'add',
                eventMap: eventMap
            });
            removePreviousListeners.current = ()=>{
                (0, $a9frS.modifyListeners)({
                    element: element,
                    operationName: 'remove',
                    eventMap: eventMap
                });
            };
        } else removePreviousListeners.current = null;
    }, [
        eventMap,
        isActive
    ]);
};
const $c6e813dbc513f02a$export$5f13515bd3a35325 = (actions)=>({
        click: actions.load,
        mouseenter: actions.preload,
        mouseleave: actions.cancelPreload,
        focusin: actions.preload,
        focusout: actions.cancelPreload
    });

});
parcelRegister("a9frS", function(module, exports) {

$parcel$export(module.exports, "modifyListeners", () => $592b51d0c18fde03$export$15257a36a7e3f9d6);
function $592b51d0c18fde03$export$15257a36a7e3f9d6(params) {
    const { element: element, operationName: operationName, eventMap: eventMap } = params;
    const functionName = operationName === 'add' ? 'addEventListener' : 'removeEventListener';
    if (element) Object.keys(eventMap).forEach((eventName)=>element[functionName](eventName, eventMap[eventName]));
}

});


parcelRegister("bU6dn", function(module, exports) {

$parcel$export(module.exports, "editSprintModalEntryPoint", () => $a575ddbc99f0c007$export$62497640baecc927);

var $9e6N7 = parcelRequire("9e6N7");

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $a575ddbc99f0c007$export$62497640baecc927 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("5i8zg")), {
        moduleId: "c7ce165f"
    }),
    getPreloadProps: ({ boardId: boardId, sprintId: sprintId, fetchSprints: fetchSprints })=>({
            queries: {
                editSprintModal: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $9e6N7.default,
                    variables: {
                        boardId: boardId,
                        sprintId: sprintId,
                        fetchSprints: fetchSprints
                    }
                }
            }
        })
});

});
parcelRegister("9e6N7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed53291ef2849f32$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a6471efb4cf0d88bef3ca4f275ac9826>>
 * @relayHash a7c5c4d6570548dfbbb896009ae5fc47
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 90bffcc09f8865bee8f7861946866baaa79e714bb9afc19568bc71a86050977b
const $ed53291ef2849f32$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "90bffcc09f8865bee8f7861946866baaa79e714bb9afc19568bc71a86050977b",
        "metadata": {},
        "name": "uiJiraSoftwareEditSprintModalQuery",
        "operationKind": "query",
        "text": null
    }
};
var $ed53291ef2849f32$export$2e2bcd8739ae039 = $ed53291ef2849f32$var$node;

});

parcelRegister("5i8zg", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('35Awq')
        ]);
        const value = parcelRequire('6uWGk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("35Awq")
    ]).then(()=>parcelRequire('6uWGk'));
}

});



parcelRegister("ckPgy", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('iDicM');
        const value = parcelRequire('1bAiq');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("iDicM").then(()=>parcelRequire('1bAiq'));
}

});



parcelRegister("1sAnk", function(module, exports) {

$parcel$export(module.exports, "default", () => $be909c80fb3021b4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $be909c80fb3021b4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    backlogListName: {
        "id": "backlog.card-list.backlog-list-name",
        "defaultMessage": "Backlog"
    },
    boardListName: {
        "id": "backlog.card-list.board-list-name",
        "defaultMessage": "Board"
    },
    cardAmount: {
        "id": "backlog.card-list.card-amount",
        "defaultMessage": "{cardAmount} {cardAmount, plural, one {issue} other {issues}}"
    },
    visibleCardAmount: {
        "id": "backlog.card-list.visible-card-amount",
        "defaultMessage": "{cardAmount} of {totalCardAmount} {totalCardAmount, plural, one {issue} other {issues}} visible"
    },
    emptyListFiltered: {
        "id": "backlog.card-list.empty-list-filtered",
        "defaultMessage": "There are no issues that match your current filter."
    },
    emptyBoard: {
        "id": "backlog.card-list.empty-board",
        "defaultMessage": "There are no issues on the board."
    },
    emptyBacklog: {
        "id": "backlog.card-list.empty-backlog",
        "defaultMessage": "Your backlog is empty."
    },
    emptyNotStartedSprint: {
        "id": "backlog.card-list.empty-not-started-sprint",
        "defaultMessage": "Plan a sprint by dragging the sprint footer down below some issues, or by dragging issues here."
    },
    emptyStartedSprint: {
        "id": "backlog.card-list.empty-started-sprint",
        "defaultMessage": "There are no issues in this sprint."
    },
    startSprint: {
        "id": "backlog.card-list.start-sprint",
        "defaultMessage": "Start sprint"
    },
    createSprint: {
        "id": "backlog.card-list.create-sprint",
        "defaultMessage": "Create sprint"
    },
    completeSprint: {
        "id": "backlog.card-list.complete-sprint",
        "defaultMessage": "Complete sprint"
    },
    addSprintDates: {
        "id": "backlog.card-list.add-sprint-dates",
        "defaultMessage": "Add dates"
    },
    disabledStartSprintButtonEmpty: {
        "id": "backlog.card-list.disabled-start-sprint-button-empty",
        "defaultMessage": "Sprint cannot be started because it contains no issues"
    },
    disabledStartSprintButtonNoParallel: {
        "id": "backlog.card-list.disabled-start-sprint-button-no-parallel",
        "defaultMessage": "Can be planned but not started until the completion of above active sprint"
    },
    createdSprintAriaLive: {
        "id": "backlog.card-list.created-sprint-aria-live",
        "defaultMessage": "{sprintName} created"
    },
    inlineCardCreateAriaLabel: {
        "id": "backlog.card-list.inline-card-create-aria-label",
        "defaultMessage": "Create issue for {sprintName}"
    }
});

});


parcelRegister("gUTCm", function(module, exports) {

$parcel$export(module.exports, "default", () => $103a6edd45f5eeec$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9EtmF = parcelRequire("9EtmF");

var $24NDc = parcelRequire("24NDc");

var $jP33o = parcelRequire("jP33o");
const $103a6edd45f5eeec$var$CardContainer = /*#__PURE__*/ (0, $eUqFw.memo)(({ cardListId: cardListId, cardId: cardId, isScrolling: isScrolling, row: row, isAttachedToParent: isAttachedToParent, forciblyRenderRichCard: forciblyRenderRichCard, setRichActiveCard: setRichActiveCard })=>{
    const renderFullCard = (0, $jP33o.useRenderFullItem)({
        isVisible: row.isVisible,
        isScrolling: isScrolling
    });
    if (!renderFullCard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9EtmF.default), {
        id: typeof cardId === 'string' ? parseInt(cardId, 10) : cardId,
        key: cardId,
        cardListId: cardListId,
        isAttachedToParent: isAttachedToParent
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $24NDc.default), {
        key: cardId,
        cardId: cardId,
        cardListId: cardListId,
        isAttachedToParent: isAttachedToParent,
        forciblyRenderRichCard: forciblyRenderRichCard,
        setRichActiveCard: setRichActiveCard
    });
});
var $103a6edd45f5eeec$export$2e2bcd8739ae039 = $103a6edd45f5eeec$var$CardContainer;

});
parcelRegister("9EtmF", function(module, exports) {

$parcel$export(module.exports, "default", () => $136871eb1058587d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8blac = parcelRequire("8blac");

var $86Ndv = parcelRequire("86Ndv");

var $dtaN9 = parcelRequire("dtaN9");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $c9TLT = parcelRequire("c9TLT");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2F5m4 = parcelRequire("2F5m4");

var $3l6tm = parcelRequire("3l6tm");

var $8MrYx = parcelRequire("8MrYx");

var $9eH8H = parcelRequire("9eH8H");

var $8wXFi = parcelRequire("8wXFi");

var $1gQ73 = parcelRequire("1gQ73");

var $1lsov = parcelRequire("1lsov");

var $bP7Jx = parcelRequire("bP7Jx");

var $j258X = parcelRequire("j258X");

var $gIy9B = parcelRequire("gIy9B");

var $gsBhl = parcelRequire("gsBhl");

var $3pfK3 = parcelRequire("3pfK3");

var $g8AN8 = parcelRequire("g8AN8");


var $dU01J = parcelRequire("dU01J");

var $5WFzC = parcelRequire("5WFzC");

var $939HY = parcelRequire("939HY");

var $bn3eO = parcelRequire("bn3eO");

var $3vQAb = parcelRequire("3vQAb");

var $7AnmZ = parcelRequire("7AnmZ");

var $UzIGp = parcelRequire("UzIGp");

var $2KRYN = parcelRequire("2KRYN");

var $8s89S = parcelRequire("8s89S");

var $lKnUS = parcelRequire("lKnUS");

var $3VLYl = parcelRequire("3VLYl");

var $gKCwa = parcelRequire("gKCwa");

var $6Idg8 = parcelRequire("6Idg8");

var $lLcUL = parcelRequire("lLcUL");
const $136871eb1058587d$var$CardLiteExtended = ({ style: style = {}, id: id, cardListId: cardListId, isAttachedToParent: isAttachedToParent = false })=>{
    const cards = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getCards));
    const card = cards[String(id)] || {};
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { key: cardKey, summary: cardSummary, icon: icon, isDone: isDone, isFlagged: isFlagged, extraFields: extraFields, typeHierarchyLevel: typeHierarchyLevel, parentKey: parentKey } = card; // TODO: Collect these at a higher level and pass them down
    const shouldRenderPriorityColumn = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.backlogHasPriority));
    const shouldRenderEstimatesColumn = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.backlogHasEstimates));
    const shouldRenderInlineAddFlag = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.backlogHasFlaggedCards));
    const orderedVersions = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getOrderedVersions));
    const viewSettings = (0, $8wXFi.isViewSettingAsPanelExpEnabledWithNoExposure)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $8MrYx.useCardFieldsSettings)() : {
        showIssueType: true,
        showIssueKey: true,
        showPriority: true,
        showAssignee: true,
        showEstimate: true,
        showDueDate: true,
        cardExtraFields: undefined
    };
    const cardGroup = (0, $1gQ73.useBacklogSelector)((0, $1lsov.makeGetCardGroupByParentId))(cardListId, id);
    const isCardGroupExpanded = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.makeGetCardGroupExpanded))(id);
    const subtaskIds = cardGroup && cardGroup.cardIds;
    const hasLinkedSubtasks = subtaskIds !== undefined && subtaskIds.length > 0;
    const isSelected = (0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.isCardSelected)(state)(id));
    const shouldShowChevron = hasLinkedSubtasks;
    const isSubtask = (0, $3l6tm.isSubtaskHierarchyLevel)(typeHierarchyLevel);
    const hasExtraFields = extraFields ? extraFields?.length > 0 : false;
    const isCompanyManagedKanban = (0, $j258X.useIsCMPKanbanBacklog)();
    const isCompanyManaged = (0, $j258X.useIsCMPBacklog)();
    const { size: backlogContainerSize } = (0, $bn3eO.useContainerSize)();
    const shouldShowCheckbox = (0, $gIy9B.useShowCheckbox)();
    const showCompactMode = (0, $8MrYx.useShowCompactMode)();
    const isCompactView = backlogContainerSize === (0, $939HY.ScreenSize).EXTRA_SMALL;
    const renderParentKey = ()=>{
        const parentKeyText = parentKey !== undefined ? formatMessage((0, $dU01J.default).parentKeyText, {
            parentKey: parentKey
        }) : '';
        return parentKey !== undefined && isSubtask && !isAttachedToParent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.CardGroupKey), null, `${parentKeyText}`) : null;
    };
    const renderCardColor = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gsBhl.CardColor), {
            id: card.id
        });
    const showCardExtraFieldsColumnBasedOnViewSettings = (0, $8wXFi.isViewSettingAsPanelExpEnabledWithNoExposure)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $8MrYx.useHasCardExtraFields)() : true;
    const renderExtraFields = ()=>hasExtraFields && extraFields && showCardExtraFieldsColumnBasedOnViewSettings && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.ExtraFieldsContainer), {
            isAttachedToParent: isAttachedToParent && isCompanyManaged,
            hideTypeIcon: undefined
        }, extraFields.filter((field)=>viewSettings.cardExtraFields?.[field.id] ?? true).map((field, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, {
                key: field.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3pfK3.CardExtraField), {
                field: field
            }), index < extraFields?.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g8AN8.FieldSeparator), {
                "aria-hidden": "true",
                key: `${field.id}-separator`
            }, "\u2022"))));
    const getCheckboxContainerMargin = (shouldAddMargin)=>{
        if (shouldAddMargin && isAttachedToParent) return 'space.400';
        if (shouldAddMargin) return 'space.250';
        return 'space.0';
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($136871eb1058587d$var$Container // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: style,
        hasExtraFields: hasExtraFields,
        isCompact: showCompactMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gsBhl.CardColor), {
        id: id
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.CardContainer), {
        isCompanyManagedKanban: isCompanyManagedKanban,
        isCompact: showCompactMode,
        shouldShowChevron: shouldShowChevron,
        isFlagged: isFlagged,
        isDraggable: false,
        isDragHandle: false,
        hasExtraFields: hasExtraFields,
        lowerOpacity: false,
        isSelected: isSelected,
        hideTypeIcon: !viewSettings.showIssueType,
        isAssigneeShown: viewSettings.showAssignee,
        "data-component-selector": (0, $becb1ff7485800b5$export$fb374ae0d58ab29b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    ), {
        xcss: (0, $1ZAYh.xcss)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginRight: getCheckboxContainerMargin(isCompanyManaged && !shouldShowChevron)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.CheckboxContainer), {
        shouldShowCheckbox: shouldShowCheckbox
    })), renderCardColor(), // eslint-disable-next-line no-nested-ternary
    hasLinkedSubtasks ? isCardGroupExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($136871eb1058587d$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
        label: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($136871eb1058587d$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
        label: ""
    })) : null, viewSettings.showIssueType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.ImageContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($136871eb1058587d$var$Icon, {
        src: icon
    })), viewSettings.showIssueKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.KeyContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($136871eb1058587d$var$Key, {
        done: isDone,
        cardKey: cardKey
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.SummaryAndParentContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($136871eb1058587d$var$Summary, {
        cardSummary: cardSummary
    })), renderParentKey(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.OptionalFieldsContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLcUL.Versions), {
        card: card,
        isCompanyManaged: isCompanyManaged,
        backlogContainerSize: backlogContainerSize,
        isCardListContainsVersion: !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(orderedVersions)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $UzIGp.EpicLiteWrapper), {
        card: card,
        backlogContainerSize: backlogContainerSize,
        isCompactView: isCompactView,
        isSubtask: isSubtask
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gKCwa.Status), {
        cardKey: cardKey,
        backlogContainerSize: backlogContainerSize
    }), viewSettings.showDueDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7AnmZ.DueDate), {
        dueDate: card?.dueDate,
        isDone: isDone
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lKnUS.Mentions), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8s89S.Flag), {
        isFlagged: isFlagged,
        shouldRenderInlineAddFlag: shouldRenderInlineAddFlag
    }), viewSettings.showEstimate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2KRYN.EstimateLite), {
        shouldRenderEstimatesColumn: shouldRenderEstimatesColumn
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Idg8.StoryPointLite), {
        issue: card
    })), viewSettings.showPriority && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3VLYl.PriorityLite), {
        shouldRenderPriorityColumn: shouldRenderPriorityColumn,
        issueKey: cardKey
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.AssigneeContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2F5m4.AvatarWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3vQAb.AssigneeLite), {
        issueKey: cardKey
    }))), renderExtraFields()));
};
const $136871eb1058587d$var$CardLiteExtendedMemo = /*#__PURE__*/ (0, $eUqFw.memo)($136871eb1058587d$var$CardLiteExtended);
var $136871eb1058587d$export$2e2bcd8739ae039 = $136871eb1058587d$var$CardLiteExtendedMemo;
const $136871eb1058587d$var$Summary = ({ cardSummary: cardSummary })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div" // eslint-disable-next-line jira/react/no-style-attribute
    , {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            color: `${`var(--ds-text, ${(0, $PdmhA).N800})`}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            whiteSpace: 'nowrap',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            textOverflow: 'ellipsis',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 0
        }
    }, cardSummary);
const $136871eb1058587d$var$Key = ({ cardKey: cardKey, done: done })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div" // eslint-disable-next-line jira/react/no-style-attribute
    , {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            color: "var(--ds-text-subtle, #44546F)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            outline: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginTop: '0',
            textDecoration: `${done ? 'line-through' : 'none'}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            whiteSpace: 'nowrap',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            paddingRight: "var(--ds-space-100, 0.5rem)"
        }
    }, cardKey);
const $136871eb1058587d$var$Icon = ({ src: src })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        alt: "" // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        ,
        style: {
            width: (0, $c9TLT.gridSize) * 2,
            height: (0, $c9TLT.gridSize) * 2,
            verticalAlign: 'text-bottom'
        },
        src: src
    });
const $136871eb1058587d$var$Container = ({ children: children, style: style, hasExtraFields: hasExtraFields, isCompact: isCompact })=>{
    const cardRowHeight = isCompact ? (0, $9eH8H.COMPACT_CARD_ROW_HEIGHT) : (0, $9eH8H.CARD_ROW_HEIGHT);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div" // eslint-disable-next-line jira/react/no-style-attribute
    , {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            backgroundColor: "var(--ds-surface-raised, transparent)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            height: `${hasExtraFields ? cardRowHeight + (0, $9eH8H.EXTRA_CARD_ROW_HEIGHT) : cardRowHeight}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            textDecoration: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'grid',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            alignItems: 'center',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flexDirection: 'column',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'relative'
        }
    }, children);
}; // Chevron icon wrapper, keep it consistent with src/packages/software/backlog/src/view/card-list/card/card-contents/view.tsx
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $136871eb1058587d$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_yyhy14f8 _1ii7wtyw _1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2F5m4", function(module, exports) {

$parcel$export(module.exports, "AssigneePickerView", () => $c90269d4d7f5a9b6$export$7df43f1214c1ab94);
$parcel$export(module.exports, "AvatarWrapper", () => $c90269d4d7f5a9b6$export$f7513421c53ce141);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iJlfe = parcelRequire("iJlfe");

var $8cU5f = parcelRequire("8cU5f");

var $4ksts = parcelRequire("4ksts");


var $6cPKE = parcelRequire("6cPKE");

var $lOBpe = parcelRequire("lOBpe");
const $c90269d4d7f5a9b6$export$7df43f1214c1ab94 = ({ value: value })=>{
    const intl = (0, $4ksts.useIntlV2)();
    const unassigned = (0, $6cPKE.getUnassignedUser)(intl);
    const user = value || unassigned;
    const assigneeName = user.accountId === (0, $7a4a7348bcf111f0$export$bdab9bfb39981463) ? user.displayName : intl.formatMessage((0, $lOBpe.default).assigneeTooltip, {
        name: user.displayName
    });
    const avatarUrl = (0, $6cPKE.getUserAvatarUrl)(user);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c90269d4d7f5a9b6$export$f7513421c53ce141, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: assigneeName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        testId: "issue-field-assignee.common.ui.read-view.popover.avatar",
        size: "small",
        src: avatarUrl,
        name: assigneeName,
        borderColor: "transparent"
    })));
};
var $c90269d4d7f5a9b6$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = $c90269d4d7f5a9b6$export$7df43f1214c1ab94;
const $c90269d4d7f5a9b6$export$f7513421c53ce141 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1f4h _4t3i1f4h _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _80om73ad",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lOBpe", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb938cefd9e1b7a1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fb938cefd9e1b7a1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    assigneeTooltip: {
        "id": "issue-field-assignee.common.read-view.popover.assignee-tooltip",
        "defaultMessage": "Assignee: {name}"
    }
});

});


parcelRegister("gsBhl", function(module, exports) {

$parcel$export(module.exports, "CardColor", () => $e54d4ae8313f09d7$export$d6da217c85de72a2);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $1gQ73 = parcelRequire("1gQ73");

var $bP7Jx = parcelRequire("bP7Jx");
function $e54d4ae8313f09d7$export$d6da217c85de72a2({ id: id }) {
    const color = (0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.getCardColor)(state, id));
    if (!color) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e54d4ae8313f09d7$var$Container, {
        role: "presentation",
        color: color
    });
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e54d4ae8313f09d7$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $9t7rW.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _1ltvidpf _94n5idpf _1bsb1y44 _bfhk1cj8",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3pfK3", function(module, exports) {

$parcel$export(module.exports, "CardExtraField", () => $46046547de26e8b5$export$29842e7d338e26a1);

var $eUqFw = parcelRequire("eUqFw");

var $6MSC2 = parcelRequire("6MSC2");

var $g6OKy = parcelRequire("g6OKy");

var $lr1Bl = parcelRequire("lr1Bl");

var $lQJvC = parcelRequire("lQJvC");

var $eQaWx = parcelRequire("eQaWx");

var $fLFjx = parcelRequire("fLFjx");
function $46046547de26e8b5$export$29842e7d338e26a1({ field: field, isLite: isLite }) {
    if ((0, $6MSC2.isExtraFieldThumbnail)(field)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fLFjx.ThumbnailField), {
        field: field
    });
    if ((0, $6MSC2.isExtraFieldLabel)(field)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lQJvC.LabelsField), {
        field: field,
        isLite: isLite
    });
    if ((0, $6MSC2.isExtraFieldHtml)(field)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lr1Bl.HtmlField), {
        field: field
    });
    if ((0, $6MSC2.isExtraFieldDate)(field)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g6OKy.DateField), {
        field: field
    });
    if ((0, $6MSC2.isExtraFieldText)(field)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eQaWx.TextField), {
        field: field
    });
    return null;
}

});
parcelRegister("g6OKy", function(module, exports) {

$parcel$export(module.exports, "DateField", () => $b03c0f1e1b313f74$export$d9781c7894a82487);

var $eUqFw = parcelRequire("eUqFw");

var $kfRpm = parcelRequire("kfRpm");

var $8cU5f = parcelRequire("8cU5f");

var $g8AN8 = parcelRequire("g8AN8");

var $35Igy = parcelRequire("35Igy");
function $b03c0f1e1b313f74$export$d9781c7894a82487({ field: field }) {
    let content = (0, $35Igy.parseContent)(field.html);
    if ((0, $35Igy.isDefault)(content)) content = (0, $35Igy.parseContent)(field.text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: field.label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g8AN8.Container), {
        as: "time",
        // @ts-expect-error Property 'dateTime' does not exist on type 'IntrinsicAttributes & { isDefault: boolean; } & ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps & { ...; }'.
        dateTime: field.text,
        "aria-hidden": (0, $35Igy.isDefault)(content) ? 'true' : 'false',
        "aria-label": field.label,
        isDefault: (0, $35Igy.isDefault)(content),
        dangerouslySetInnerHTML: {
            __html: (0, (/*@__PURE__*/$parcel$interopDefault($kfRpm))).sanitize(content)
        }
    }));
}

});
parcelRegister("kfRpm", function(module, exports) {
/*! @license DOMPurify 2.5.1 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.5.1/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _construct(Parent, args, Class) {
        if (_isNativeReflectConstruct()) _construct = Reflect.construct;
        else _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return _construct.apply(null, arguments);
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var hasOwnProperty = Object.hasOwnProperty, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    var _ref = typeof Reflect !== 'undefined' && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!construct) construct = function construct(Func, args) {
        return _construct(Func, _toConsumableArray(args));
    };
    var arrayForEach = unapply(Array.prototype.forEach);
    var arrayPop = unapply(Array.prototype.pop);
    var arrayPush = unapply(Array.prototype.push);
    var stringToLowerCase = unapply(String.prototype.toLowerCase);
    var stringToString = unapply(String.prototype.toString);
    var stringMatch = unapply(String.prototype.match);
    var stringReplace = unapply(String.prototype.replace);
    var stringIndexOf = unapply(String.prototype.indexOf);
    var stringTrim = unapply(String.prototype.trim);
    var regExpTest = unapply(RegExp.prototype.test);
    var typeErrorCreate = unconstruct(TypeError);
    function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /* Add properties to a lookup table */ function addToSet(set, array, transformCaseFunc) {
        var _transformCaseFunc;
        transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        var l = array.length;
        while(l--){
            var element = array[l];
            if (typeof element === 'string') {
                var lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /* Shallow clone an object */ function clone(object) {
        var newObject = create(null);
        var property;
        for(property in object)if (apply(hasOwnProperty, object, [
            property
        ]) === true) newObject[property] = object[property];
        return newObject;
    }
    /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */ function lookupGetter(object, prop) {
        while(object !== null){
            var desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue(element) {
            console.warn('fallback value for', element);
            return null;
        }
        return fallbackValue;
    }
    var html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'select',
        'shadow',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    // SVG
    var svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    var svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    var svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'fedropshadow',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    var mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    var mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    var text = freeze([
        '#text'
    ]);
    var html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'xmlns',
        'slot'
    ]);
    var svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    var mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    var xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
    var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    var DOCTYPE_NAME = seal(/^html$/i);
    var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */ var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
        if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        var suffix = null;
        var ATTR_NAME = 'data-tt-policy-suffix';
        if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) suffix = document.currentScript.getAttribute(ATTR_NAME);
        var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML: function createHTML(html) {
                    return html;
                },
                createScriptURL: function createScriptURL(scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    function createDOMPurify() {
        var window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        var DOMPurify = function DOMPurify(root) {
            return createDOMPurify(root);
        };
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = '2.5.1';
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== 9) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        var originalDocument = window1.document;
        var document = window1.document;
        var DocumentFragment = window1.DocumentFragment, HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap, HTMLFormElement = window1.HTMLFormElement, DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        var ElementPrototype = Element.prototype;
        var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        var getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            var template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
        var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
        var _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        var importNode = originalDocument.importNode;
        var documentMode = {};
        try {
            documentMode = clone(document).documentMode ? document.documentMode : {};
        } catch (_) {}
        var hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
        var MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
        var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ var ALLOWED_TAGS = null;
        var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
        /* Allowed attribute names */ var ALLOWED_ATTR = null;
        var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ var FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ var FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ var ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ var ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ var ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ var ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ var SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ var SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ var WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ var SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ var FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ var RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ var RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ var RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ var SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ var SANITIZE_NAMED_PROPS = false;
        var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ var KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ var IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ var USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ var FORBID_CONTENTS = null;
        var DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ var DATA_URI_TAGS = null;
        var DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ var URI_SAFE_ATTRIBUTES = null;
        var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ var NAMESPACE = HTML_NAMESPACE;
        var IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ var ALLOWED_NAMESPACES = null;
        var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        /* Parsing of strict XHTML documents */ var PARSER_MEDIA_TYPE;
        var SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        var transformCaseFunc;
        /* Keep a reference to config to pass to hooks */ var CONFIG = null;
        /* Specify the maximum element nesting depth to prevent mXSS */ var MAX_NESTING_DEPTH = 255;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ var formElement = document.createElement('form');
        var isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        var _parseConfig = function _parseConfig(cfg) {
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || _typeof(cfg) !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
            cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
            cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        var HTML_INTEGRATION_POINTS = addToSet({}, [
            'foreignobject',
            'desc',
            'title',
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ var ALL_SVG_TAGS = addToSet({}, svg$1);
        addToSet(ALL_SVG_TAGS, svgFilters);
        addToSet(ALL_SVG_TAGS, svgDisallowed);
        var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
        addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
        /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ var _checkValidNamespace = function _checkValidNamespace(element) {
            var parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            var tagName = stringToLowerCase(element.tagName);
            var parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ var _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                node.parentNode.removeChild(node);
            } catch (_) {
                try {
                    node.outerHTML = emptyHTML;
                } catch (_) {
                    node.remove();
                }
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ var _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name);
            // We void attribute values for unremovable "is"" attributes
            if (name === 'is' && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ var _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ var doc;
            var leadingWhitespace;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ var matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            var body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */ var _createIterator = function _createIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ var _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.__depth !== 'undefined' && typeof elm.__depth !== 'number' || typeof elm.__removalCount !== 'undefined' && typeof elm.__removalCount !== 'number' || typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
        };
        /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ var _isNode = function _isNode(object) {
            return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ var _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], function(hook) {
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ var _sanitizeElements = function _sanitizeElements(currentNode) {
            var content;
            /* Execute a hook if present */ _executeHook('beforeSanitizeElements', currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Check if tagname contains Unicode */ if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ var tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook('uponSanitizeElement', currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Mitigate a problem with templates inside select */ if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any ocurrence of processing instructions */ if (currentNode.nodeType === 7) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    var parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        var childCount = childNodes.length;
                        for(var i = childCount - 1; i >= 0; --i){
                            var childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
                /* Get the element's text content */ content = currentNode.textContent;
                content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
                content = stringReplace(content, ERB_EXPR$1, ' ');
                content = stringReplace(content, TMPLIT_EXPR$1, ' ');
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeElements', currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */ var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT$1);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            var attr;
            var value;
            var lcName;
            var l;
            /* Execute a hook if present */ _executeHook('beforeSanitizeAttributes', currentNode, null);
            var attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes) return;
            var hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                attr = attributes[l];
                var _attr = attr, name = _attr.name, namespaceURI = _attr.namespaceURI;
                value = name === 'value' ? attr.value : stringTrim(attr.value);
                lcName = transformCaseFunc(name);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) {
                    value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
                    value = stringReplace(value, ERB_EXPR$1, ' ');
                    value = stringReplace(value, TMPLIT_EXPR$1, ' ');
                }
                /* Is `value` valid for this attribute? */ var lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeAttributes', currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            var shadowNode;
            var shadowIterator = _createIterator(fragment);
            /* Execute a hook if present */ _executeHook('beforeSanitizeShadowDOM', fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook('uponSanitizeShadowNode', shadowNode, null);
                /* Sanitize tags and elements */ if (_sanitizeElements(shadowNode)) continue;
                /* Set the nesting depth of an element */ if (shadowNode.nodeType === 1) {
                    if (shadowNode.parentNode && shadowNode.parentNode.__depth) /*
              We want the depth of the node in the original tree, which can
              change when it's removed from its parent.
            */ shadowNode.__depth = (shadowNode.__removalCount || 0) + shadowNode.parentNode.__depth + 1;
                    else shadowNode.__depth = 1;
                }
                /* Remove an element if nested too deeply to avoid mXSS */ if (shadowNode.__depth >= MAX_NESTING_DEPTH) _forceRemove(shadowNode);
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) {
                    shadowNode.content.__depth = shadowNode.__depth;
                    _sanitizeShadowDOM(shadowNode.content);
                }
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(shadowNode);
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeShadowDOM', fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var body;
            var importedNode;
            var currentNode;
            var oldNode;
            var returnNode;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Check we can run. Otherwise fall back or ignore */ if (!DOMPurify.isSupported) {
                if (_typeof(window1.toStaticHTML) === 'object' || typeof window1.toStaticHTML === 'function') {
                    if (typeof dirty === 'string') return window1.toStaticHTML(dirty);
                    if (_isNode(dirty)) return window1.toStaticHTML(dirty.outerHTML);
                }
                return dirty;
            }
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    var tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Fix IE's strange behavior with manipulated textNodes #89 */ if (currentNode.nodeType === 3 && currentNode === oldNode) continue;
                /* Sanitize tags and elements */ if (_sanitizeElements(currentNode)) continue;
                /* Set the nesting depth of an element */ if (currentNode.nodeType === 1) {
                    if (currentNode.parentNode && currentNode.parentNode.__depth) /*
              We want the depth of the node in the original tree, which can
              change when it's removed from its parent.
            */ currentNode.__depth = (currentNode.__removalCount || 0) + currentNode.parentNode.__depth + 1;
                    else currentNode.__depth = 1;
                }
                /* Remove an element if nested too deeply to avoid mXSS */ if (currentNode.__depth >= MAX_NESTING_DEPTH) _forceRemove(currentNode);
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) {
                    currentNode.content.__depth = currentNode.__depth;
                    _sanitizeShadowDOM(currentNode.content);
                }
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(currentNode);
                oldNode = currentNode;
            }
            oldNode = null;
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) {
                serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
            }
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function(cfg) {
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            var lcTag = transformCaseFunc(tag);
            var lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

});

parcelRegister("g8AN8", function(module, exports) {

$parcel$export(module.exports, "Container", () => $b4b7cafa5ad9837e$export$42a852a2b6b56249);
$parcel$export(module.exports, "FieldSeparator", () => $b4b7cafa5ad9837e$export$35646e337882f8c7);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $b4b7cafa5ad9837e$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDefault: isDefault, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1e9r _1ul9idpf _4t3iv47k _1reo15vq _18m915vq _o5721q9c _rvu71q9c _3l5f15vq _1eex15vq _lyiy1l2s _1b6lhxbz _mfe41wmp _1rnet94y _r07x15vq _6e8f15vq _nd9nstnw _qb0y1q9c _1fy5t94y _1bsk1osq _1y8m1wug _la1rnkob _bqe6nkob _1ci4idpf _1md0idpf _1qwe1ule _qehnidpf _18vridpf _1nlwidpf _12isidpf _gzx61wug",
            __cmplp.isDefault ? "_zg8l1m30" : "_zg8l1kw7",
            __cmplp.className
        ])
    });
});
const $b4b7cafa5ad9837e$export$35646e337882f8c7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1d1o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("35Igy", function(module, exports) {

$parcel$export(module.exports, "isDefault", () => $447fd243a9a828af$export$75abdbb028a7ab06);
$parcel$export(module.exports, "parseContent", () => $447fd243a9a828af$export$4cf5403beffb0fc1);

var $8blac = parcelRequire("8blac");

var $27QuD = parcelRequire("27QuD");

const $447fd243a9a828af$export$75abdbb028a7ab06 = (content)=>content === (0, $3bdf9082c480a32b$export$2c9ef5d2c18593f7);
const $447fd243a9a828af$var$isNonBreakingSpace = (content)=>content === (0, $3bdf9082c480a32b$export$b6fa73900e7ac785);
const $447fd243a9a828af$var$isEmptyOrBlank = (content)=>!content || (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))((0, (/*@__PURE__*/$parcel$interopDefault($27QuD)))(content));
const $447fd243a9a828af$var$isContentInvalid = (content)=>$447fd243a9a828af$var$isNonBreakingSpace(content) || $447fd243a9a828af$var$isEmptyOrBlank(content);
const $447fd243a9a828af$export$4cf5403beffb0fc1 = (content)=>$447fd243a9a828af$var$isContentInvalid(content) ? (0, $3bdf9082c480a32b$export$2c9ef5d2c18593f7) : (0, (/*@__PURE__*/$parcel$interopDefault($27QuD)))(content);

});
const $3bdf9082c480a32b$export$b6fa73900e7ac785 = '&nbsp;';
const $3bdf9082c480a32b$export$2c9ef5d2c18593f7 = 'None';



parcelRegister("lr1Bl", function(module, exports) {

$parcel$export(module.exports, "HtmlField", () => $eb08122e3e479abb$export$9cda3940184cdf77);

var $eUqFw = parcelRequire("eUqFw");

var $kfRpm = parcelRequire("kfRpm");

var $8cU5f = parcelRequire("8cU5f");

var $g8AN8 = parcelRequire("g8AN8");

var $35Igy = parcelRequire("35Igy");
function $eb08122e3e479abb$export$9cda3940184cdf77({ field: field }) {
    const content = (0, $35Igy.parseContent)(field.html);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: field.label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g8AN8.Container), {
        "aria-label": field.label,
        "aria-hidden": (0, $35Igy.isDefault)(content) ? 'true' : 'false',
        isDefault: (0, $35Igy.isDefault)(content),
        dangerouslySetInnerHTML: {
            __html: (0, (/*@__PURE__*/$parcel$interopDefault($kfRpm))).sanitize(content)
        }
    }));
}

});

parcelRegister("lQJvC", function(module, exports) {

$parcel$export(module.exports, "LabelsField", () => $ac278ce765e0b45b$export$b5a86c9a622796ff);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8blac = parcelRequire("8blac");

var $9jNAz = parcelRequire("9jNAz");

var $8cU5f = parcelRequire("8cU5f");

var $43X6H = parcelRequire("43X6H");


var $35Igy = parcelRequire("35Igy");
const $ac278ce765e0b45b$var$parseLabels = (text)=>{
    const content = (0, $35Igy.parseContent)(text);
    return (0, $35Igy.isDefault)(content) ? [] : (0, $43X6H.toLabels)(content);
};
const $ac278ce765e0b45b$var$ItemRenderer = ({ item: item, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9jNAz.default), {
        "aria-label": label,
        key: item,
        text: item
    });
function $ac278ce765e0b45b$export$b5a86c9a622796ff({ field: field, isLite: isLite }) {
    const content = $ac278ce765e0b45b$var$parseLabels(field.text);
    const wrap = (children)=>isLite ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: field.label
        }, children);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(content)) return wrap(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ac278ce765e0b45b$var$Container, {
        "aria-hidden": "true",
        isDefault: true
    }, (0, $3bdf9082c480a32b$export$2c9ef5d2c18593f7)));
    return wrap(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ac278ce765e0b45b$var$Container, {
        "aria-hidden": "true",
        isDefault: false
    }, content.map((item, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ac278ce765e0b45b$var$ItemRenderer, {
            key: i,
            item: item,
            label: item
        }))));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ac278ce765e0b45b$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDefault: isDefault, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1e9r _1ul9idpf _p12f1osq _1reo15vq _18m915vq _o5721q9c _kqswh2mm _aetrb3bt _19doidpf _15l2idpf _1ywu1ule _1qdg1osq _z0ai1osq _18postnw _16r260i3 _e9q69hw4 _1nvfidpf",
            __cmplp.isDefault ? "_zg8l1m30" : "_zg8l1kw7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9jNAz", function(module, exports) {

$parcel$export(module.exports, "default", () => $02a667cb3800fd5a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $d9W8K = parcelRequire("d9W8K");

var $6aZHE = parcelRequire("6aZHE");

var $gz2Bi = parcelRequire("gz2Bi");
const $02a667cb3800fd5a$var$SimpleTagComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, color: color = 'standard', href: href, testId: testId, text: text = '', linkComponent: linkComponent }, ref)=>{
    const content = /*#__PURE__*/ (0, $byn9U.jsx)((0, $gz2Bi.default), {
        elemBefore: elemBefore,
        isRemovable: false,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $d9W8K.default), {
        ref: ref,
        testId: testId,
        href: href,
        appearance: appearance,
        color: color,
        before: /*#__PURE__*/ (0, $byn9U.jsx)((0, $6aZHE.default), {
            elemBefore: elemBefore
        }),
        contentElement: content
    });
});
/**
 * __Simple tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * `SimpleTag` is the default form of a tag, where text is required. Tags with static text can be used as a flag or as a reference to an object or attribute.
 *
 * - [Examples](https://atlassian.design/components/tag/examples)
 * - [Code](https://atlassian.design/components/tag/code)
 * - [Usage](https://atlassian.design/components/tag/usage)
 */ const $02a667cb3800fd5a$var$SimpleTag = /*#__PURE__*/ (0, $eUqFw.memo)($02a667cb3800fd5a$var$SimpleTagComponent);
var $02a667cb3800fd5a$export$2e2bcd8739ae039 = $02a667cb3800fd5a$var$SimpleTag;

});
parcelRegister("d9W8K", function(module, exports) {

$parcel$export(module.exports, "default", () => $98c5a9f7a5ded4f8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $jFsza = parcelRequire("jFsza");

var $i6wnX = parcelRequire("i6wnX");
function $98c5a9f7a5ded4f8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// To be removed with platform-component-visual-refresh (BLU-2992)
const $98c5a9f7a5ded4f8$var$baseStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-flex',
    minWidth: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $jFsza.tagHeight),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: (0, $jFsza.defaultMargin),
    padding: "var(--ds-space-0, 0px)",
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: `var(${(0, $jFsza.cssVar).color.background.default})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $jFsza.cssVar).borderRadius})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $jFsza.cssVar).color.text.default})`,
    cursor: 'default'
});
const $98c5a9f7a5ded4f8$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    minWidth: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $jFsza.tagHeight),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: (0, $jFsza.defaultMargin),
    position: 'relative',
    alignItems: 'center',
    gap: "var(--ds-space-050, 4px)",
    backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
    border: 'solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderColor: `var(${(0, $jFsza.cssVar).color.borderColor})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    borderWidth: "var(--ds-border-width, 1px)",
    color: "var(--ds-text, #172B4D)",
    cursor: 'default',
    paddingInline: "var(--ds-space-050, 4px)"
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $98c5a9f7a5ded4f8$var$interactiveStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $jFsza.cssVar).color.background.hover})`
    },
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $jFsza.cssVar).color.background.active})`
    }
});
const $98c5a9f7a5ded4f8$var$interactiveStyles = {
    name: "jcdcgl",
    styles: "&:hover{background-color:var(--ds-background-neutral-subtle-hovered, #091E420F);}&:active{background-color:var(--ds-background-neutral-subtle-pressed, #091E4224);}"
};
// To be removed with platform-component-visual-refresh (BLU-2992)
const $98c5a9f7a5ded4f8$var$focusRingStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    '&:focus-within': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `0 0 0 2px var(${(0, $jFsza.cssVar).color.focusRing})`,
        outline: 'none'
    }
});
const $98c5a9f7a5ded4f8$var$focusRingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:focus-within': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        outline: `2px solid ${$i6wnX.focusRingColors}`,
        outlineOffset: '2px '
    }
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $98c5a9f7a5ded4f8$var$nonStandardLinkStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $jFsza.cssVar).color.text.active})`
    }
});
const $98c5a9f7a5ded4f8$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, appearance: appearance = 'default', style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    const isStandardLink = isLink && color === 'standard';
    // Change link text color if  the tag is standard color
    const textLinkColors = isStandardLink ? $i6wnX.textColors['standardLink'] : $i6wnX.textColors[color];
    const backgroundHoverColors = isRemovable && !isLink ? $i6wnX.backgroundColors[color] : $i6wnX.linkHoverBackgroundColors[color];
    const backgroundActiveColors = isRemovable && !isLink ? $i6wnX.backgroundColors[color] : $i6wnX.linkActiveBackgroundColors[color];
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        ...other,
        ref: ref,
        css: [
            (0, $XHGTv.fg)('platform-component-visual-refresh') ? $98c5a9f7a5ded4f8$var$baseStyles : $98c5a9f7a5ded4f8$var$baseStylesOld,
            isInteractive && ((0, $XHGTv.fg)('platform-component-visual-refresh') ? $98c5a9f7a5ded4f8$var$focusRingStyles : $98c5a9f7a5ded4f8$var$focusRingStylesOld),
            (0, $XHGTv.fg)('platform-component-visual-refresh') ? isLink && $98c5a9f7a5ded4f8$var$interactiveStyles : undefined,
            !(0, $XHGTv.fg)('platform-component-visual-refresh') && isLink && !isStandardLink && $98c5a9f7a5ded4f8$var$nonStandardLinkStyles,
            !(0, $XHGTv.fg)('platform-component-visual-refresh') && isInteractive && $98c5a9f7a5ded4f8$var$interactiveStylesOld
        ],
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.borderColor]: $i6wnX.borderColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.default]: $i6wnX.textColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.hover]: $i6wnX.textHoverColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.active]: $i6wnX.textActiveColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.link]: textLinkColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.background.default]: $i6wnX.backgroundColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.background.hover]: backgroundHoverColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.background.active]: backgroundActiveColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.focusRing]: $i6wnX.focusRingColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.removeButton.default]: $i6wnX.removeButtonColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.removeButton.hover]: $i6wnX.removeButtonHoverColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).borderRadius]: $i6wnX.borderRadius[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-testid": testId
    }, before, contentElement, after);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$98c5a9f7a5ded4f8$export$2e2bcd8739ae039 = $98c5a9f7a5ded4f8$var$BaseTag;

});
parcelRegister("jFsza", function(module, exports) {

$parcel$export(module.exports, "tagHeight", () => $2e837ad2e72491cc$export$5b2b1030a679f37);
$parcel$export(module.exports, "buttonWidthUnitless", () => $2e837ad2e72491cc$export$c6f3ea2b4cffd0ca);
$parcel$export(module.exports, "maxTextWidthUnitless", () => $2e837ad2e72491cc$export$2e3bcb01bf928995);
$parcel$export(module.exports, "maxTextWidth", () => $2e837ad2e72491cc$export$982d4a1a6de11130);
$parcel$export(module.exports, "defaultBorderRadius", () => $2e837ad2e72491cc$export$35d5d1e251b985cf);
$parcel$export(module.exports, "defaultRoundedBorderRadius", () => $2e837ad2e72491cc$export$c49771100fee18c8);
$parcel$export(module.exports, "defaultMargin", () => $2e837ad2e72491cc$export$6728fea658cfb92e);
$parcel$export(module.exports, "defaultTextPadding", () => $2e837ad2e72491cc$export$c2d03c4c68282362);
$parcel$export(module.exports, "textPaddingRight", () => $2e837ad2e72491cc$export$b5686dedf408caa0);
$parcel$export(module.exports, "textMarginLeft", () => $2e837ad2e72491cc$export$b824cac86306f7a2);
$parcel$export(module.exports, "cssVar", () => $2e837ad2e72491cc$export$8b4981022bd80a4e);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $lcnyw = parcelRequire("lcnyw");
const $2e837ad2e72491cc$var$gridSizeValue = (0, $lcnyw.gridSize)();
const $2e837ad2e72491cc$var$borderRadiusValue = (0, $lcnyw.borderRadius)();
const $2e837ad2e72491cc$export$b4d89c3994664204 = 2.5 * $2e837ad2e72491cc$var$gridSizeValue;
const $2e837ad2e72491cc$export$5b2b1030a679f37 = `var(--ds-space-250, ${`${$2e837ad2e72491cc$export$b4d89c3994664204}px`})`;
const $2e837ad2e72491cc$export$c6f3ea2b4cffd0ca = $2e837ad2e72491cc$export$b4d89c3994664204; // button should be square
const $2e837ad2e72491cc$export$aba002ef70684916 = $2e837ad2e72491cc$export$5b2b1030a679f37; // button should be square
const $2e837ad2e72491cc$export$d5949a2c2ea9dcea = 25 * $2e837ad2e72491cc$var$gridSizeValue;
const $2e837ad2e72491cc$export$488fda99655ff65a = `${$2e837ad2e72491cc$export$d5949a2c2ea9dcea}px`;
const $2e837ad2e72491cc$export$2e3bcb01bf928995 = $2e837ad2e72491cc$export$d5949a2c2ea9dcea - $2e837ad2e72491cc$export$b4d89c3994664204;
const $2e837ad2e72491cc$export$982d4a1a6de11130 = `${$2e837ad2e72491cc$export$2e3bcb01bf928995}px`;
const $2e837ad2e72491cc$export$35d5d1e251b985cf = `${$2e837ad2e72491cc$var$borderRadiusValue}px`;
const $2e837ad2e72491cc$export$c49771100fee18c8 = `${$2e837ad2e72491cc$export$c6f3ea2b4cffd0ca / 2}px`;
const $2e837ad2e72491cc$export$6728fea658cfb92e = `var(--ds-space-050, ${`${$2e837ad2e72491cc$var$gridSizeValue / 2}px`})`;
const $2e837ad2e72491cc$export$c2d03c4c68282362 = `var(--ds-space-050, ${`${$2e837ad2e72491cc$var$gridSizeValue / 2}px`})`;
const $2e837ad2e72491cc$export$b5686dedf408caa0 = `var(--ds-space-200, ${`${2 * $2e837ad2e72491cc$var$gridSizeValue}px`})`;
const $2e837ad2e72491cc$export$b824cac86306f7a2 = $2e837ad2e72491cc$export$5b2b1030a679f37;
const $2e837ad2e72491cc$export$8b4981022bd80a4e = {
    color: {
        background: {
            default: '--ds-cb',
            hover: '--ds-cbh',
            active: '--ds-cba'
        },
        borderColor: '--ds-bc',
        focusRing: '--ds-cfr',
        text: {
            default: '--ds-ct',
            hover: '--ds-cth',
            active: '--ds-ctp',
            link: '--ds-ctl'
        },
        removeButton: {
            default: '--ds-rb',
            hover: '--ds-rbh'
        }
    },
    borderRadius: '--ds-br'
};

});

parcelRegister("i6wnX", function(module, exports) {

$parcel$export(module.exports, "textColors", () => $fc0da2a7c84ba49c$export$daa0ace263cb20d2);
$parcel$export(module.exports, "borderColors", () => $fc0da2a7c84ba49c$export$1c1b571cf296eca7);
$parcel$export(module.exports, "textHoverColors", () => $fc0da2a7c84ba49c$export$7c7104a5f052cab7);
$parcel$export(module.exports, "textActiveColors", () => $fc0da2a7c84ba49c$export$382469baad253eb7);
$parcel$export(module.exports, "backgroundColors", () => $fc0da2a7c84ba49c$export$b9d7c59a579c23c6);
$parcel$export(module.exports, "linkHoverBackgroundColors", () => $fc0da2a7c84ba49c$export$4410079763249c74);
$parcel$export(module.exports, "linkActiveBackgroundColors", () => $fc0da2a7c84ba49c$export$76be99c5e13e3566);
$parcel$export(module.exports, "focusRingColors", () => $fc0da2a7c84ba49c$export$2a31dbe82788f940);
$parcel$export(module.exports, "borderRadius", () => $fc0da2a7c84ba49c$export$7a57f79000377ca2);
$parcel$export(module.exports, "removalHoverBackgroundColors", () => $fc0da2a7c84ba49c$export$1202b7eb21da7b58);
$parcel$export(module.exports, "removalActiveBackgroundColors", () => $fc0da2a7c84ba49c$export$62ace793ebb16bda);
$parcel$export(module.exports, "removalTextColors", () => $fc0da2a7c84ba49c$export$17d206ccea111bbb);
$parcel$export(module.exports, "removeButtonColors", () => $fc0da2a7c84ba49c$export$f64c7641cbc22da7);
$parcel$export(module.exports, "removeButtonHoverColors", () => $fc0da2a7c84ba49c$export$b03fbc2a369c563e);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $PdmhA = parcelRequire("PdmhA");

var $jFsza = parcelRequire("jFsza");
const $fc0da2a7c84ba49c$export$daa0ace263cb20d2 = {
    standard: `var(--ds-text, ${$PdmhA.N700})`,
    standardLink: `var(--ds-link, ${$PdmhA.B400})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$PdmhA.N800})`,
    red: `var(--ds-text-accent-red-bolder, ${$PdmhA.N800})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$PdmhA.N800})`,
    green: `var(--ds-text-accent-green-bolder, ${$PdmhA.N800})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$PdmhA.N800})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$PdmhA.N800})`,
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: `var(--ds-text-accent-gray-bolder, ${$PdmhA.N0})`,
    blueLight: `var(--ds-text-accent-blue, ${$PdmhA.B500})`,
    redLight: `var(--ds-text-accent-red, ${$PdmhA.N500})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$PdmhA.N500})`,
    greenLight: `var(--ds-text-accent-green, ${$PdmhA.G500})`,
    tealLight: `var(--ds-text-accent-teal, ${$PdmhA.N500})`,
    purpleLight: `var(--ds-text-accent-purple, ${$PdmhA.P500})`,
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: `var(--ds-text-accent-gray, ${$PdmhA.N500})`
};
const $fc0da2a7c84ba49c$export$1c1b571cf296eca7 = {
    standard: '#B7B9BE',
    blue: '#669DF1',
    red: '#F87168',
    yellow: '#DDB30E',
    green: '#4BCE97',
    teal: '#6CC3E0',
    purple: '#C97CF4',
    lime: '#94C748',
    magenta: '#E774BB',
    orange: '#FCA700',
    grey: '#B7B9BE',
    standardLink: '#B7B9BE',
    blueLight: '#669DF1',
    redLight: '#F87168',
    yellowLight: '#DDB30E',
    greenLight: '#4BCE97',
    tealLight: '#6CC3E0',
    purpleLight: '#C97CF4',
    limeLight: '#94C748',
    magentaLight: '#E774BB',
    orangeLight: '#FCA700',
    greyLight: '#B7B9BE'
};
const $fc0da2a7c84ba49c$export$7c7104a5f052cab7 = {
    standard: `var(--ds-link, ${$PdmhA.B300})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$PdmhA.N800})`,
    red: `var(--ds-text-accent-red-bolder, ${$PdmhA.N800})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$PdmhA.N800})`,
    green: `var(--ds-text-accent-green-bolder, ${$PdmhA.N800})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$PdmhA.N800})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$PdmhA.N800})`,
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: `var(--ds-text-accent-gray-bolder, ${$PdmhA.N0})`,
    blueLight: `var(--ds-text-accent-blue, ${$PdmhA.B500})`,
    redLight: `var(--ds-text-accent-red, ${$PdmhA.N500})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$PdmhA.N500})`,
    greenLight: `var(--ds-text-accent-green, ${$PdmhA.G500})`,
    tealLight: `var(--ds-text-accent-teal, ${$PdmhA.N500})`,
    purpleLight: `var(--ds-text-accent-purple, ${$PdmhA.P500})`,
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: `var(--ds-text-accent-gray, ${$PdmhA.N500})`
};
const $fc0da2a7c84ba49c$export$382469baad253eb7 = {
    standard: `var(--ds-link-pressed, ${$PdmhA.B300})`,
    blue: `var(--ds-text-accent-blue, ${$PdmhA.N800})`,
    red: `var(--ds-text-accent-red, ${$PdmhA.N800})`,
    yellow: `var(--ds-text-accent-yellow, ${$PdmhA.N800})`,
    green: `var(--ds-text-accent-green, ${$PdmhA.N800})`,
    teal: `var(--ds-text-accent-teal, ${$PdmhA.N800})`,
    purple: `var(--ds-text-accent-purple, ${$PdmhA.N800})`,
    lime: "var(--ds-text-accent-lime, #4C6B1F)",
    magenta: "var(--ds-text-accent-magenta, #943D73)",
    orange: "var(--ds-text-accent-orange, #974F0C)",
    grey: `var(--ds-text-accent-gray, ${$PdmhA.N0})`,
    blueLight: `var(--ds-text-accent-blue-bolder, ${$PdmhA.B500})`,
    redLight: `var(--ds-text-accent-red-bolder, ${$PdmhA.N500})`,
    yellowLight: `var(--ds-text-accent-yellow-bolder, ${$PdmhA.N500})`,
    greenLight: `var(--ds-text-accent-green-bolder, ${$PdmhA.G500})`,
    tealLight: `var(--ds-text-accent-teal-bolder, ${$PdmhA.N500})`,
    purpleLight: `var(--ds-text-accent-purple-bolder, ${$PdmhA.P500})`,
    limeLight: "var(--ds-text-accent-lime-bolder, #37471F)",
    magentaLight: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orangeLight: "var(--ds-text-accent-orange-bolder, #5F3811)",
    greyLight: `var(--ds-text-accent-gray-bolder, ${$PdmhA.N500})`
};
const $fc0da2a7c84ba49c$export$b9d7c59a579c23c6 = {
    standard: `var(--ds-background-neutral, ${$PdmhA.N20})`,
    blue: `var(--ds-background-accent-blue-subtle, ${$PdmhA.B100})`,
    red: `var(--ds-background-accent-red-subtle, ${$PdmhA.R100})`,
    yellow: `var(--ds-background-accent-yellow-subtle, ${$PdmhA.Y200})`,
    green: `var(--ds-background-accent-green-subtle, ${$PdmhA.G200})`,
    teal: `var(--ds-background-accent-teal-subtle, ${$PdmhA.T200})`,
    purple: `var(--ds-background-accent-purple-subtle, ${$PdmhA.P100})`,
    lime: "var(--ds-background-accent-lime-subtle, #94C748)",
    magenta: "var(--ds-background-accent-magenta-subtle, #E774BB)",
    orange: "var(--ds-background-accent-orange-subtle, #FAA53D)",
    grey: `var(--ds-background-accent-gray-subtle, ${$PdmhA.N500})`,
    blueLight: `var(--ds-background-accent-blue-subtler, ${$PdmhA.B75})`,
    redLight: `var(--ds-background-accent-red-subtler, ${$PdmhA.R75})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler, ${$PdmhA.Y100})`,
    greenLight: `var(--ds-background-accent-green-subtler, ${$PdmhA.G100})`,
    tealLight: `var(--ds-background-accent-teal-subtler, ${$PdmhA.T100})`,
    purpleLight: `var(--ds-background-accent-purple-subtler, ${$PdmhA.P75})`,
    limeLight: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    magentaLight: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    orangeLight: "var(--ds-background-accent-orange-subtler, #FFE2BD)",
    greyLight: `var(--ds-background-accent-gray-subtler, ${$PdmhA.N30})`
};
const $fc0da2a7c84ba49c$export$4410079763249c74 = {
    standard: `var(--ds-background-neutral-hovered, ${$PdmhA.N30})`,
    blue: `var(--ds-background-accent-blue-subtle-hovered, ${$PdmhA.B75})`,
    red: `var(--ds-background-accent-red-subtle-hovered, ${$PdmhA.R75})`,
    yellow: `var(--ds-background-accent-yellow-subtle-hovered, ${$PdmhA.Y100})`,
    green: `var(--ds-background-accent-green-subtle-hovered, ${$PdmhA.G100})`,
    teal: `var(--ds-background-accent-teal-subtle-hovered, ${$PdmhA.T100})`,
    purple: `var(--ds-background-accent-purple-subtle-hovered, ${$PdmhA.P75})`,
    lime: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    magenta: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    orange: "var(--ds-background-accent-orange-subtle-hovered, #FEC57B)",
    grey: `var(--ds-background-accent-gray-subtle-hovered, ${$PdmhA.N400})`,
    blueLight: `var(--ds-background-accent-blue-subtler-hovered, ${$PdmhA.B50})`,
    redLight: `var(--ds-background-accent-red-subtler-hovered, ${$PdmhA.R50})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler-hovered, ${$PdmhA.Y75})`,
    greenLight: `var(--ds-background-accent-green-subtler-hovered, ${$PdmhA.G75})`,
    tealLight: `var(--ds-background-accent-teal-subtler-hovered, ${$PdmhA.T75})`,
    purpleLight: `var(--ds-background-accent-purple-subtler-hovered, ${$PdmhA.P50})`,
    limeLight: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    orangeLight: "var(--ds-background-accent-orange-subtler-hovered, #FEC57B)",
    greyLight: `var(--ds-background-accent-gray-subtler-hovered, ${$PdmhA.N40})`
};
const $fc0da2a7c84ba49c$export$76be99c5e13e3566 = {
    standard: `var(--ds-background-neutral-pressed, ${$PdmhA.N30})`,
    blue: `var(--ds-background-accent-blue-subtle-pressed, ${$PdmhA.B50})`,
    red: `var(--ds-background-accent-red-subtle-pressed, ${$PdmhA.R50})`,
    yellow: `var(--ds-background-accent-yellow-subtle-pressed, ${$PdmhA.Y75})`,
    green: `var(--ds-background-accent-green-subtle-pressed, ${$PdmhA.G75})`,
    teal: `var(--ds-background-accent-teal-subtle-pressed, ${$PdmhA.T75})`,
    purple: `var(--ds-background-accent-purple-subtle-pressed, ${$PdmhA.P50})`,
    grey: `var(--ds-background-accent-gray-subtle-pressed, ${$PdmhA.N300})`,
    lime: "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    magenta: "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    orange: "var(--ds-background-accent-orange-subtle-pressed, #FFE2BD)",
    blueLight: `var(--ds-background-accent-blue-subtler-pressed, ${$PdmhA.B100})`,
    redLight: `var(--ds-background-accent-red-subtler-pressed, ${$PdmhA.R100})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler-pressed, ${$PdmhA.Y200})`,
    greenLight: `var(--ds-background-accent-green-subtler-pressed, ${$PdmhA.G200})`,
    tealLight: `var(--ds-background-accent-teal-subtler-pressed, ${$PdmhA.T200})`,
    purpleLight: `var(--ds-background-accent-purple-subtler-pressed, ${$PdmhA.P100})`,
    limeLight: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    orangeLight: "var(--ds-background-accent-orange-subtler-pressed, #FAA53D)",
    greyLight: `var(--ds-background-accent-gray-subtler-pressed, ${$PdmhA.N50})`
};
const $fc0da2a7c84ba49c$export$2a31dbe82788f940 = `var(--ds-border-focused, ${$PdmhA.B100})`;
const $fc0da2a7c84ba49c$export$7a57f79000377ca2 = {
    default: (0, $jFsza.defaultBorderRadius),
    rounded: (0, $jFsza.defaultRoundedBorderRadius)
};
const $fc0da2a7c84ba49c$export$1202b7eb21da7b58 = `var(--ds-background-danger, ${$PdmhA.R50})`;
const $fc0da2a7c84ba49c$export$62ace793ebb16bda = `var(--ds-background-danger-hovered, ${$PdmhA.R50})`;
const $fc0da2a7c84ba49c$export$17d206ccea111bbb = `var(--ds-text-danger, ${$PdmhA.R500})`;
const $fc0da2a7c84ba49c$export$f64c7641cbc22da7 = {
    standard: `var(--ds-text, ${$PdmhA.N500})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$PdmhA.N500})`,
    red: `var(--ds-text-accent-red-bolder, ${$PdmhA.N500})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$PdmhA.N500})`,
    green: `var(--ds-text-accent-green-bolder, ${$PdmhA.N500})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$PdmhA.N500})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$PdmhA.N500})`,
    lime: `var(--ds-text-accent-lime-bolder, ${$PdmhA.N500})`,
    magenta: `var(--ds-text-accent-magenta-bolder, ${$PdmhA.N500})`,
    orange: `var(--ds-text-accent-orange-bolder, ${$PdmhA.N500})`,
    grey: `var(--ds-text-accent-gray-bolder, ${$PdmhA.N500})`,
    blueLight: `var(--ds-text-accent-blue, ${$PdmhA.N500})`,
    redLight: `var(--ds-text-accent-red, ${$PdmhA.N500})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$PdmhA.N500})`,
    greenLight: `var(--ds-text-accent-green, ${$PdmhA.N500})`,
    tealLight: `var(--ds-text-accent-teal, ${$PdmhA.N500})`,
    purpleLight: `var(--ds-text-accent-purple, ${$PdmhA.N500})`,
    limeLight: `var(--ds-text-accent-lime, ${$PdmhA.N500})`,
    magentaLight: `var(--ds-text-accent-magenta, ${$PdmhA.N500})`,
    orangeLight: `var(--ds-text-accent-orange, ${$PdmhA.N500})`,
    greyLight: `var(--ds-text-accent-gray, ${$PdmhA.N500})`
};
const $fc0da2a7c84ba49c$export$b03fbc2a369c563e = {
    standard: `var(--ds-text-danger, ${$PdmhA.N700})`,
    standardLink: `var(--ds-text-danger, ${$PdmhA.B400})`,
    blue: `var(--ds-text-danger, ${$PdmhA.N800})`,
    red: `var(--ds-text-danger, ${$PdmhA.N800})`,
    yellow: `var(--ds-text-danger, ${$PdmhA.N800})`,
    green: `var(--ds-text-danger, ${$PdmhA.N800})`,
    teal: `var(--ds-text-danger, ${$PdmhA.N800})`,
    purple: `var(--ds-text-danger, ${$PdmhA.N800})`,
    lime: `var(--ds-text-danger, ${$PdmhA.N800})`,
    magenta: `var(--ds-text-danger, ${$PdmhA.N800})`,
    orange: `var(--ds-text-danger, ${$PdmhA.N800})`,
    grey: `var(--ds-text-danger, ${$PdmhA.N0})`,
    blueLight: `var(--ds-text-danger, ${$PdmhA.B500})`,
    redLight: `var(--ds-text-danger, ${$PdmhA.N500})`,
    yellowLight: `var(--ds-text-danger, ${$PdmhA.N500})`,
    greenLight: `var(--ds-text-danger, ${$PdmhA.G500})`,
    tealLight: `var(--ds-text-danger, ${$PdmhA.N500})`,
    purpleLight: `var(--ds-text-danger, ${$PdmhA.P500})`,
    limeLight: `var(--ds-text-danger, ${$PdmhA.P500})`,
    magentaLight: `var(--ds-text-danger, ${$PdmhA.P500})`,
    orangeLight: `var(--ds-text-danger, ${$PdmhA.P500})`,
    greyLight: `var(--ds-text-danger, ${$PdmhA.N500})`
};

});


parcelRegister("6aZHE", function(module, exports) {

$parcel$export(module.exports, "default", () => $70eddb948b5989f5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $jFsza = parcelRequire("jFsza");
function $70eddb948b5989f5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $70eddb948b5989f5$var$beforeElementStyles = {
    name: "cfjv6",
    styles: "display:flex;height:16px;align-items:center;justify-content:center;inset-block-start:var(--ds-space-0, 0px)"
};
// To be removed with platform-component-visual-refresh (BLU-2992)
const $70eddb948b5989f5$var$beforeElementStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $jFsza.cssVar).borderRadius})`,
    insetBlockStart: "var(--ds-space-0, 0px)"
});
const $70eddb948b5989f5$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $XHGTv.fg)('platform-component-visual-refresh') ? $70eddb948b5989f5$var$beforeElementStyles : $70eddb948b5989f5$var$beforeElementStylesOld
    }, elemBefore) : null;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$70eddb948b5989f5$export$2e2bcd8739ae039 = $70eddb948b5989f5$var$Before;

});

parcelRegister("gz2Bi", function(module, exports) {

$parcel$export(module.exports, "default", () => $154b7edc63fec879$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $jFsza = parcelRequire("jFsza");
function $154b7edc63fec879$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// To be removed with platform-component-visual-refresh (BLU-2992)
const $154b7edc63fec879$var$baseStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $jFsza.maxTextWidth),
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    overflow: 'hidden',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineEnd: (0, $jFsza.defaultTextPadding),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineStart: (0, $jFsza.defaultTextPadding),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $154b7edc63fec879$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $jFsza.maxTextWidth),
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $154b7edc63fec879$var$linkStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $jFsza.cssVar).color.text.link})`,
    pointerEvents: 'auto',
    textDecoration: 'none',
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $jFsza.cssVar).color.text.hover})`,
        textDecoration: 'underline'
    },
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $jFsza.cssVar).color.text.active})`,
        textDecoration: 'underline'
    },
    '&:focus': {
        outline: 'none'
    }
});
const $154b7edc63fec879$var$linkStyles = {
    name: "1e5oc06",
    styles: "color:var(--ds-text, #172B4D);pointer-events:auto;text-decoration:none;&:hover{color:var(--ds-text, #172B4D);text-decoration:underline;}&:active{color:var(--ds-text, #172B4D);text-decoration:underline;}&:focus{outline:none;}"
};
const $154b7edc63fec879$var$hasAfterStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $jFsza.maxTextWidthUnitless) - (0, $jFsza.buttonWidthUnitless)}px`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineEnd: (0, $jFsza.textPaddingRight)
});
const $154b7edc63fec879$var$hasAfterStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $jFsza.maxTextWidthUnitless) - (0, $jFsza.buttonWidthUnitless)}px`
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $154b7edc63fec879$var$hasBeforeStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: (0, $jFsza.textMarginLeft)
});
const $154b7edc63fec879$var$Content = ({ elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent })=>{
    const Link = linkComponent ?? 'a';
    if (href) return /*#__PURE__*/ (0, $byn9U.jsx)(Link, {
        href: href,
        "data-color": color,
        css: [
            (0, $XHGTv.fg)('platform-component-visual-refresh') ? $154b7edc63fec879$var$baseStyles : $154b7edc63fec879$var$baseStylesOld,
            (0, $XHGTv.fg)('platform-component-visual-refresh') ? $154b7edc63fec879$var$linkStyles : $154b7edc63fec879$var$linkStylesOld,
            !(0, $XHGTv.fg)('platform-component-visual-refresh') && elemBefore && $154b7edc63fec879$var$hasBeforeStyles,
            isRemovable && (0, $XHGTv.fg)('platform-component-visual-refresh') ? $154b7edc63fec879$var$hasAfterStyles : undefined,
            isRemovable && !(0, $XHGTv.fg)('platform-component-visual-refresh') ? $154b7edc63fec879$var$hasAfterStylesOld : undefined
        ]
    }, text);
    else return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            (0, $XHGTv.fg)('platform-component-visual-refresh') ? $154b7edc63fec879$var$baseStyles : $154b7edc63fec879$var$baseStylesOld,
            !(0, $XHGTv.fg)('platform-component-visual-refresh') && elemBefore && $154b7edc63fec879$var$hasBeforeStyles,
            isRemovable && (0, $XHGTv.fg)('platform-component-visual-refresh') ? $154b7edc63fec879$var$hasAfterStyles : undefined,
            isRemovable && !(0, $XHGTv.fg)('platform-component-visual-refresh') ? $154b7edc63fec879$var$hasAfterStylesOld : undefined
        ]
    }, text);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$154b7edc63fec879$export$2e2bcd8739ae039 = $154b7edc63fec879$var$Content;

});


parcelRegister("43X6H", function(module, exports) {

$parcel$export(module.exports, "toLabels", () => $d11736961ca0a168$export$c17335eb990c7305);

var $ezsJz = parcelRequire("ezsJz");

var $eo8NR = parcelRequire("eo8NR");

var $fHTsk = parcelRequire("fHTsk");

var $27QuD = parcelRequire("27QuD");

var $9eH8H = parcelRequire("9eH8H");
function $d11736961ca0a168$var$notEmpty(value) {
    return Boolean(value);
}
const $d11736961ca0a168$export$c17335eb990c7305 = (content)=>{
    if (!content) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($ezsJz)))((0, (/*@__PURE__*/$parcel$interopDefault($eo8NR)))((0, (/*@__PURE__*/$parcel$interopDefault($fHTsk)))(content, (0, $9eH8H.LABELS_FIELD_SEPARATOR)), (0, (/*@__PURE__*/$parcel$interopDefault($27QuD)))), $d11736961ca0a168$var$notEmpty);
};

});
parcelRegister("fHTsk", function(module, exports) {

var $TLr3n = parcelRequire("TLr3n");

var $8SGvQ = parcelRequire("8SGvQ");

var $fFFC0 = parcelRequire("fFFC0");

var $3P7i5 = parcelRequire("3P7i5");

var $k6zhy = parcelRequire("k6zhy");

var $aSldm = parcelRequire("aSldm");

var $1uqnh = parcelRequire("1uqnh");
/** Used as references for the maximum length and index of an array. */ var $b6f5e3932c40e09a$var$MAX_ARRAY_LENGTH = 4294967295;
/**
 * Splits `string` by `separator`.
 *
 * **Note:** This method is based on
 * [`String#split`](https://mdn.io/String/split).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to split.
 * @param {RegExp|string} separator The separator pattern to split by.
 * @param {number} [limit] The length to truncate results to.
 * @returns {Array} Returns the string segments.
 * @example
 *
 * _.split('a-b-c', '-', 2);
 * // => ['a', 'b']
 */ function $b6f5e3932c40e09a$var$split(string, separator, limit) {
    if (limit && typeof limit != 'number' && $3P7i5(string, separator, limit)) separator = limit = undefined;
    limit = limit === undefined ? $b6f5e3932c40e09a$var$MAX_ARRAY_LENGTH : limit >>> 0;
    if (!limit) return [];
    string = $1uqnh(string);
    if (string && (typeof separator == 'string' || separator != null && !$k6zhy(separator))) {
        separator = $TLr3n(separator);
        if (!separator && $fFFC0(string)) return $8SGvQ($aSldm(string), 0, limit);
    }
    return string.split(separator, limit);
}
module.exports = $b6f5e3932c40e09a$var$split;

});
parcelRegister("k6zhy", function(module, exports) {

var $2b0k8 = parcelRequire("2b0k8");

var $74vSq = parcelRequire("74vSq");

var $2MqHZ = parcelRequire("2MqHZ");
/* Node.js helper references. */ var $ea2fbc79dbd1a9b1$var$nodeIsRegExp = $2MqHZ && $2MqHZ.isRegExp;
/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */ var $ea2fbc79dbd1a9b1$var$isRegExp = $ea2fbc79dbd1a9b1$var$nodeIsRegExp ? $74vSq($ea2fbc79dbd1a9b1$var$nodeIsRegExp) : $2b0k8;
module.exports = $ea2fbc79dbd1a9b1$var$isRegExp;

});
parcelRegister("2b0k8", function(module, exports) {

var $2OY5s = parcelRequire("2OY5s");

var $hYEMs = parcelRequire("hYEMs");
/** `Object#toString` result references. */ var $195cdc22d2f1b49a$var$regexpTag = '[object RegExp]';
/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */ function $195cdc22d2f1b49a$var$baseIsRegExp(value) {
    return $hYEMs(value) && $2OY5s(value) == $195cdc22d2f1b49a$var$regexpTag;
}
module.exports = $195cdc22d2f1b49a$var$baseIsRegExp;

});





parcelRegister("eQaWx", function(module, exports) {

$parcel$export(module.exports, "TextField", () => $a1d2ce0d96c1cc2d$export$2c73285ae9390cec);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $g8AN8 = parcelRequire("g8AN8");

var $35Igy = parcelRequire("35Igy");
function $a1d2ce0d96c1cc2d$export$2c73285ae9390cec({ field: field }) {
    const content = (0, $35Igy.parseContent)(field.text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: field.label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g8AN8.Container), {
        "aria-label": field.label,
        "aria-hidden": (0, $35Igy.isDefault)(content) ? 'true' : 'false',
        isDefault: (0, $35Igy.isDefault)(content)
    }, content));
}

});

parcelRegister("fLFjx", function(module, exports) {

$parcel$export(module.exports, "ThumbnailField", () => $b72067cb79638923$export$1ed5c8a60ea7f0e6);

var $eUqFw = parcelRequire("eUqFw");

var $jUThT = parcelRequire("jUThT");

var $8cU5f = parcelRequire("8cU5f");

var $g8AN8 = parcelRequire("g8AN8");

var $35Igy = parcelRequire("35Igy");

var $2668Y = parcelRequire("2668Y");
function $b72067cb79638923$export$1ed5c8a60ea7f0e6({ field: field }) {
    const content = (0, $35Igy.parseContent)(field.html);
    if ((0, $35Igy.isDefault)(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: field.label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g8AN8.Container), {
        "aria-hidden": "true",
        isDefault: (0, $35Igy.isDefault)(content)
    }, content));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2668Y.Thumbnail), {
            label: field.label,
            content: content
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jUThT))), {
        "aria-label": field.label,
        size: "small",
        label: ""
    }));
}

});
parcelRegister("jUThT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e7fe223acf10e6f6$var$_react = $e7fe223acf10e6f6$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $e7fe223acf10e6f6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e7fe223acf10e6f6$var$AttachmentIcon = (props)=>/*#__PURE__*/ $e7fe223acf10e6f6$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11.643 17.965c-1.53 1.495-4.016 1.496-5.542.004a3.773 3.773 0 01.002-5.412l7.147-6.985a2.316 2.316 0 013.233-.003c.893.873.895 2.282.004 3.153l-6.703 6.55a.653.653 0 01-.914-.008.62.62 0 010-.902l6.229-6.087a.941.941 0 000-1.353.995.995 0 00-1.384 0l-6.23 6.087a2.502 2.502 0 000 3.607 2.643 2.643 0 003.683.009l6.703-6.55a4.074 4.074 0 00-.003-5.859 4.306 4.306 0 00-6.002.003l-7.148 6.985a5.655 5.655 0 00-.001 8.118c2.29 2.239 6.015 2.238 8.31-.005l6.686-6.533a.941.941 0 000-1.353.995.995 0 00-1.384 0l-6.686 6.534z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$e7fe223acf10e6f6$var$AttachmentIcon.displayName = 'AttachmentIcon';
var $e7fe223acf10e6f6$var$_default = $e7fe223acf10e6f6$var$AttachmentIcon;
module.exports.default = $e7fe223acf10e6f6$var$_default;

});

parcelRegister("2668Y", function(module, exports) {

$parcel$export(module.exports, "Thumbnail", () => $051de5b4d7d5c92b$export$1cd1efc78cb52ca5);

var $eUqFw = parcelRequire("eUqFw");

var $kfRpm = parcelRequire("kfRpm");
function $051de5b4d7d5c92b$export$1cd1efc78cb52ca5({ label: label, content: content }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        dangerouslySetInnerHTML: {
            __html: (0, (/*@__PURE__*/$parcel$interopDefault($kfRpm))).sanitize(content)
        }
    }));
}

});



const $becb1ff7485800b5$export$ca45cc072d50480d = 'software-backlog.card-list.card.card-contents.context-menu.menu_placeholder';
const $becb1ff7485800b5$export$fb374ae0d58ab29b = 'software-backlog-card-container';

parcelRegister("dU01J", function(module, exports) {

$parcel$export(module.exports, "default", () => $04bce1d9a35a13f7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $04bce1d9a35a13f7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    childIssuesMetadataTooltip: {
        "id": "backlog.card-list.card.child-issues-metadata-tooltip",
        "defaultMessage": "{complete} of {total, plural, one {# child issue} other {# child issues}} complete"
    },
    cardFocusScreenreaderText: {
        "id": "backlog.card-list.card.card-focus-screenreader-text",
        "defaultMessage": "Use the enter key to load the issue view. Use the space key to move the issue."
    },
    epicLozenge: {
        "id": "backlog.card-list.card.epic-lozenge",
        "defaultMessage": "epic"
    },
    flaggedTooltip: {
        "id": "backlog.card-list.card.flagged-tooltip",
        "defaultMessage": "Flagged"
    },
    addFlagTooltip: {
        "id": "backlog.card-list.card.add-flag-tooltip",
        "defaultMessage": "Add Flag"
    },
    storyPointsTooltip: {
        "id": "backlog.card-list.card.story-points-tooltip",
        "defaultMessage": "Story points"
    },
    storyPointsAriaLabel: {
        "id": "backlog.card-list.card.story-points-aria-label",
        "defaultMessage": "Story points"
    },
    storyPointsAriaLabelNullValue: {
        "id": "backlog.card-list.card.story-points-aria-label-null-value",
        "defaultMessage": "No estimate set"
    },
    statusTooltip: {
        "id": "backlog.card-list.card.status-tooltip",
        "defaultMessage": "Status"
    },
    numberOfChildrenText: {
        "id": "backlog.card-list.card.number-of-children-text",
        "defaultMessage": "{numberOfChildren} {numberOfChildren, plural, one {subtask} other {subtasks}}"
    },
    parentKeyText: {
        "id": "backlog.card-list.card.parent-key-text",
        "defaultMessage": "Subtask of {parentKey}"
    },
    cardGroupToggleExpandedAriaLabel: {
        "id": "backlog.card-list.card.card-group-toggle-expanded-aria-label",
        "defaultMessage": "Hide subtasks for {issueKey} {summary}"
    },
    cardGroupToggleCollapsedAriaLabel: {
        "id": "backlog.card-list.card.card-group-toggle-collapsed-aria-label",
        "defaultMessage": "Show subtasks for {issueKey} {summary}"
    },
    cardGroupToggleTooltipExpand: {
        "id": "backlog.card-list.card.card-group-toggle-tooltip-expand",
        "defaultMessage": "Expand"
    },
    cardGroupToggleTooltipCollapse: {
        "id": "backlog.card-list.card.card-group-toggle-tooltip-collapse",
        "defaultMessage": "Collapse"
    }
});

});

parcelRegister("5WFzC", function(module, exports) {

$parcel$export(module.exports, "Key", () => $0cdc32b9ea8d24b6$export$cd0f44441c3b7719);
$parcel$export(module.exports, "Img", () => $0cdc32b9ea8d24b6$export$cc7b5f925acc71d3);
$parcel$export(module.exports, "CheckboxContainer", () => $0cdc32b9ea8d24b6$export$be6fcc6a7e078caa);
$parcel$export(module.exports, "CardGroupToggle", () => $0cdc32b9ea8d24b6$export$fc8eb8928c84ef7b);
$parcel$export(module.exports, "ImageContainer", () => $0cdc32b9ea8d24b6$export$94026ee33dbabc26);
$parcel$export(module.exports, "KeyContainer", () => $0cdc32b9ea8d24b6$export$87cb5a8bc2c72dc8);
$parcel$export(module.exports, "ScreenReaderKey", () => $0cdc32b9ea8d24b6$export$543895d0ab5334d);
$parcel$export(module.exports, "SummaryAndParentContainer", () => $0cdc32b9ea8d24b6$export$b2027db09cc3f848);
$parcel$export(module.exports, "SummaryWrapper", () => $0cdc32b9ea8d24b6$export$b13648308b87115);
$parcel$export(module.exports, "Summary", () => $0cdc32b9ea8d24b6$export$46453a0401d6cd1a);
$parcel$export(module.exports, "EpicWrapper", () => $0cdc32b9ea8d24b6$export$6dc4dd6105cae5b0);
$parcel$export(module.exports, "ExtraFieldsContainer", () => $0cdc32b9ea8d24b6$export$716284ed33ba9160);
$parcel$export(module.exports, "AssigneeContainer", () => $0cdc32b9ea8d24b6$export$35cb5ad1a5a164c6);
$parcel$export(module.exports, "MenuPlaceholderControl", () => $0cdc32b9ea8d24b6$export$c732a501d4812a69);
$parcel$export(module.exports, "MenuPlaceholder", () => $0cdc32b9ea8d24b6$export$19dffc35a621b610);
$parcel$export(module.exports, "DragHandleCardsAmount", () => $0cdc32b9ea8d24b6$export$574576b1d7c68429);
$parcel$export(module.exports, "StyledSpinner", () => $0cdc32b9ea8d24b6$export$a7b75c5e23a48343);
$parcel$export(module.exports, "OptionalFieldsContainer", () => $0cdc32b9ea8d24b6$export$2c60bada4ddd3b79);
$parcel$export(module.exports, "CardContainerControl", () => $0cdc32b9ea8d24b6$export$512f2a3a331cd04);
$parcel$export(module.exports, "CardContainer", () => $0cdc32b9ea8d24b6$export$8a23e74e5cf3ca41);
$parcel$export(module.exports, "ContentContainer", () => $0cdc32b9ea8d24b6$export$9d2b4227a95687cc);
$parcel$export(module.exports, "CardGroupKey", () => $0cdc32b9ea8d24b6$export$18c03323864bfda5);
$parcel$export(module.exports, "VersionIconWrapper", () => $0cdc32b9ea8d24b6$export$e010d58e8595e079);
$parcel$export(module.exports, "VersionIconNumber", () => $0cdc32b9ea8d24b6$export$b224c3920d5dc114);
$parcel$export(module.exports, "SubtaskIconWrapper", () => $0cdc32b9ea8d24b6$export$bafafde73fef7397);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $kwce8 = parcelRequire("kwce8");

var $7u4fN = parcelRequire("7u4fN");

var $PdmhA = parcelRequire("PdmhA");
var $lcnyw = parcelRequire("lcnyw");

var $kjXsi = parcelRequire("kjXsi");

var $c9TLT = parcelRequire("c9TLT");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");

var $9eH8H = parcelRequire("9eH8H");

var $30WDI = parcelRequire("30WDI");
const $0cdc32b9ea8d24b6$var$CARD_CHECKBOX_COMPONENT_SELECTOR = `[data-component-selector='${(0, $30WDI.CHECKBOX_COMPONENT_SELECTOR)}']`;
const $0cdc32b9ea8d24b6$var$buttonWidth = (0, $c9TLT.gridSize) * 4; // 32px to match the width of the dropdown button
// The hex code for the colour is used as that value does not exist in the colors from '@atlaskit/theme'
const $0cdc32b9ea8d24b6$var$cardFlaggedColor = '#FFF7D6';
const $0cdc32b9ea8d24b6$var$cardFlaggedAndHoveredColor = '#F8E6A0';
const $0cdc32b9ea8d24b6$var$cardFlaggedAndSelectedColor = '#F5CD47'; // If we didn't use an extra local variable, Compiled would auto-assign the value to the first return value
const $0cdc32b9ea8d24b6$export$122b84414b9478ae = (isSelected, isFlagged)=>{
    let bgColor = `var(--ds-surface-raised, ${(0, $PdmhA).N0})`;
    if (isFlagged && isSelected) bgColor = `var(--ds-background-warning-pressed, ${$0cdc32b9ea8d24b6$var$cardFlaggedAndSelectedColor})`;
    else if (isFlagged) bgColor = `var(--ds-background-warning, ${$0cdc32b9ea8d24b6$var$cardFlaggedColor})`;
    else if (isSelected) bgColor = `var(--ds-background-selected, ${(0, $PdmhA).B50})`;
    return bgColor;
};
const $0cdc32b9ea8d24b6$var$getHoverBgColor = (isSelected, isFlagged)=>{
    let hoverBgColor = `var(--ds-background-neutral-subtle-hovered, ${(0, $PdmhA).N10})`;
    if (isFlagged) hoverBgColor = `var(--ds-background-warning-hovered, ${$0cdc32b9ea8d24b6$var$cardFlaggedAndHoveredColor})`;
    else if (isSelected) hoverBgColor = `var(--ds-background-selected-hovered, ${(0, $PdmhA).B50})`;
    return hoverBgColor;
}; // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0cdc32b9ea8d24b6$var$KeyControl = /*#__PURE__*/ (0, $kwce8.default).a.withConfig({
    componentId: "sc-8u98g6-0"
})`font:${"var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"};font-weight:${"var(--ds-font-weight-semibold, 600)"};color:${`var(--ds-text-subtle, ${(0, $PdmhA).N300})`} !important;outline:none;margin-top:0;text-decoration:${({ isDone: isDone = false })=>isDone ? 'line-through' : 'none'} !important;white-space:nowrap;`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $0cdc32b9ea8d24b6$var$KeyExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDone: isDone, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ect4qk37 _k48p1pd9 _1wyb1no3 _syaz1n3s _12ji1r31 _1qu2glyw _12y31o36 _19pkidpf _o5721q9c",
            __cmplp.isDone ?? false ? "_4bfu1r81 _1hms1cog _ajmmvv82" : "_4bfu1r81 _1hmsagmp _ajmmvv82",
            __cmplp.className
        ])
    });
});
const $0cdc32b9ea8d24b6$export$cd0f44441c3b7719 = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $0cdc32b9ea8d24b6$var$KeyExperiment, $0cdc32b9ea8d24b6$var$KeyControl); // TODO remove on TNK-570 clean up - moved to card contents <Type /> component
const $0cdc32b9ea8d24b6$export$cc7b5f925acc71d3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb7vkz _4t3i7vkz _s7n41ndm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0cdc32b9ea8d24b6$export$be6fcc6a7e078caa = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldShowCheckbox: shouldShowCheckbox, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb7vkz _1pbykb7n _1e0c1txw _1bah1h6o _yyhy168a _1ii7wtyw",
            __cmplp.shouldShowCheckbox ? "_3um0ewfl" : "_3um015vq",
            __cmplp.className
        ])
    });
});
const $0cdc32b9ea8d24b6$export$fc8eb8928c84ef7b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbdlk8 _4t3idlk8 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
}); // TODO remove on TNK-570 clean up - moved to card contents <Type /> component
const $0cdc32b9ea8d24b6$export$94026ee33dbabc26 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_yyhy11t1 _1ii7wtyw",
            __cmplp.className
        ])
    });
});
const $0cdc32b9ea8d24b6$export$87cb5a8bc2c72dc8 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1pbykb7n _yyhy1l0g _1ii7wtyw",
            __cmplp.className
        ])
    });
});
const $0cdc32b9ea8d24b6$export$af9c6d3df2ad3478 = /*#__PURE__*/ (0, $kwce8.default)($0cdc32b9ea8d24b6$var$KeyControl).withConfig({
    componentId: "sc-8u98g6-1"
})`&:not(:focus){${(0, $kjXsi.visuallyHiddenStyles)};}&:focus{outline:none;box-shadow:0 0 0 2px ${`var(--ds-border-focused, ${(0, $PdmhA).B200})`};+ ${$0cdc32b9ea8d24b6$var$KeyControl}{display:none;}}&:active{outline:none;}`;
const $0cdc32b9ea8d24b6$export$160385697d56afc5 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $0cdc32b9ea8d24b6$var$KeyExperiment, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_142m7mnp _19pm1wmp _1ybtt94y _1ma0t94y _3sml1n1a _hsjw1n1a _2u081n1a _4jes1n1a _1k9z15vq _xghe15vq _1nagidpf _172jidpf _1lrxidpf _1akkidpf _nxshstnw _nt751r31 _49pcglyw _1hvw1o36 _7ehi1vt6 _twmeglyw _1q5t1r31 _1ohyglyw _1r9x1o36",
            __cmplp.className
        ])
    });
});
const $0cdc32b9ea8d24b6$export$543895d0ab5334d = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $0cdc32b9ea8d24b6$export$160385697d56afc5, $0cdc32b9ea8d24b6$export$af9c6d3df2ad3478); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0cdc32b9ea8d24b6$var$SummaryAndParentContainerControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-8u98g6-2"
})`display:flex;flex:1;box-sizing:border-box;user-select:none;grid-column:summary / span 1;grid-row:card-detail / span 1;${({ isSummaryFieldEditing: isSummaryFieldEditing })=>(0, $kwce8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        position: isSummaryFieldEditing ? 'relative' : 'unset',
        alignItems: 'center'
    })} min-width:0;& > *{min-width:0;}`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $0cdc32b9ea8d24b6$var$SummaryAndParentContainerExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSummaryFieldEditing: isSummaryFieldEditing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _vchhusvi _uiztglyw _yyhy1uzv _1ii7wtyw _4cvr1h6o _1ul9idpf _1ouwidpf",
            __cmplp.isSummaryFieldEditing ? "_kqswh2mm" : "_kqswn7od",
            __cmplp.className
        ])
    });
});
const $0cdc32b9ea8d24b6$export$b2027db09cc3f848 = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $0cdc32b9ea8d24b6$var$SummaryAndParentContainerExperiment, $0cdc32b9ea8d24b6$var$SummaryAndParentContainerControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0cdc32b9ea8d24b6$var$SummaryWrapperControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-8u98g6-3"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        outline: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: props.isSummaryFieldEditing ? 2 : 1 /* surface the element above the interaction layer so tooltips can be triggered */ 
    }), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ isSummaryFieldEditing: isSummaryFieldEditing })=>isSummaryFieldEditing && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $kwce8.css)({
        width: '100%'
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $0cdc32b9ea8d24b6$var$SummaryWrapperExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSummaryFieldEditing: isSummaryFieldEditing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_19g2etl": (0, $9t7rW.default)(__cmplp.isSummaryFieldEditing && '100%')
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _1bsbstyr",
            __cmplp.isSummaryFieldEditing ? "_1pbycs5v" : "_1pbykb7n",
            __cmplp.className
        ])
    });
});
const $0cdc32b9ea8d24b6$export$b13648308b87115 = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $0cdc32b9ea8d24b6$var$SummaryWrapperExperiment, $0cdc32b9ea8d24b6$var$SummaryWrapperControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0cdc32b9ea8d24b6$export$46453a0401d6cd1a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1fxt _o5721q9c _1reo15vq _18m915vq _1bto1l2s _1kt9b3bt _cfu11ule",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0cdc32b9ea8d24b6$export$6dc4dd6105cae5b0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { widthMultiplier: widthMultiplier, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_uu7jbp": (0, $9t7rW.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `repeat(auto-fit,${(0, $c9TLT.gridSize) * __cmplp.widthMultiplier}px)`),
            "--_ichgug": (0, $9t7rW.default)(`${(0, $c9TLT.gridSize) * __cmplp.widthMultiplier}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c11p5 _6a6zv2br _yv0e105t _1ul9bcwo _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
});
const $0cdc32b9ea8d24b6$export$56fba512661ff388 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { widthMultiplier: widthMultiplier, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_uu7jbp": (0, $9t7rW.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `repeat(auto-fit,${(0, $c9TLT.gridSize) * __cmplp.widthMultiplier}px)`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c11p5 _1pbykb7n _1reo15vq _18m915vq _1bto1l2s _4cvr1h6o _6a6zv2br _lcxvglyw _yv0e105t",
            __cmplp.className
        ])
    });
});
const $0cdc32b9ea8d24b6$export$8204ed5340eb7d34 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-8u98g6-4"
})`grid-column:child-meta / span 1;grid-row:card-detail / span 1;outline:none;z-index:1;> *{display:flex;}`;
const $0cdc32b9ea8d24b6$export$1733122af4970989 = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), ()=>null, $0cdc32b9ea8d24b6$export$8204ed5340eb7d34);
const $0cdc32b9ea8d24b6$export$d6d2b7ad039cd190 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1pbykb7n",
            __cmplp.className
        ])
    });
});
const $0cdc32b9ea8d24b6$export$15529022dcaf3eec = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { widthMultiplier: widthMultiplier, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_uu7jbp": (0, $9t7rW.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `repeat(auto-fit,${(0, $c9TLT.gridSize) * __cmplp.widthMultiplier}px)`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c11p5 _4t3i1tcg _lcxvglyw _1reo1kw7 _18m91kw7 _yv0e105t",
            __cmplp.className
        ])
    });
});
const $0cdc32b9ea8d24b6$export$716284ed33ba9160 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hideTypeIcon: hideTypeIcon, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ii7pazf _1e0c11p5 _vchhusvi _yv0eql95 _4cvrv2br _syaz1e9r _gy1p1b66 _4t3i1ul9 _1reo15vq _18m915vq _1ouwidpf _vqbzkb7n",
            __cmplp.hideTypeIcon ? "_yyhy4co5" : "_yyhydpws",
            __cmplp.className
        ])
    });
});
const $0cdc32b9ea8d24b6$export$35cb5ad1a5a164c6 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_yyhy1eaj _1ii7wtyw",
            __cmplp.className
        ])
    });
});
const $0cdc32b9ea8d24b6$export$c732a501d4812a69 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-8u98g6-5"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        minWidth: `${$0cdc32b9ea8d24b6$var$buttonWidth}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        visibility: props.isMenuOpen || props.isPulseActive ? 'visible' : 'hidden'
    }), {
    gridColumn: 'menu / span 1',
    gridRow: 'card-detail / span 1',
    position: 'relative'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $0cdc32b9ea8d24b6$var$MenuPlaceholderExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isMenuOpen: isMenuOpen, isPulseActive: isPulseActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul9xy5q _yyhy1m0k _1ii7wtyw _kqswh2mm",
            __cmplp.isMenuOpen || __cmplp.isPulseActive ? "_3um0ewfl" : "_3um015vq",
            __cmplp.className
        ])
    });
});
const $0cdc32b9ea8d24b6$export$19dffc35a621b610 = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $0cdc32b9ea8d24b6$var$MenuPlaceholderExperiment, $0cdc32b9ea8d24b6$export$c732a501d4812a69);
const $0cdc32b9ea8d24b6$export$444c71687e56d76e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1pbyqfx8 _154iidpf _1xi2idpf _t9ec1tul",
            __cmplp.className
        ])
    });
});
const $0cdc32b9ea8d24b6$export$574576b1d7c68429 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1pbyqfx8 _154ir5cr _1ltvr5cr _t9ec1tul",
            __cmplp.className
        ])
    });
});
const $0cdc32b9ea8d24b6$export$564243b99bc75899 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-8u98g6-6"
})`grid-column:menu / span 1;grid-row:card-detail / span 1;`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $0cdc32b9ea8d24b6$var$StyledSpinnerExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_yyhy1m0k _1ii7wtyw",
            __cmplp.className
        ])
    });
});
const $0cdc32b9ea8d24b6$export$a7b75c5e23a48343 = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $0cdc32b9ea8d24b6$var$StyledSpinnerExperiment, $0cdc32b9ea8d24b6$export$564243b99bc75899);
// TODO Delete this comment after verifying space token -> previous value `margin: 6px`
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0cdc32b9ea8d24b6$var$OptionalFieldsContainerControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-8u98g6-7"
})({
    gridTemplateColumns: 'repeat(auto-fill, min-content)',
    gridColumn: 'optional-fields / span 1',
    gridRow: 'card-detail / span 1',
    display: 'flex',
    boxSizing: 'border-box',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        margin: `0 ${"var(--ds-space-050, 4px)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '& > :first-child': {
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '& > :last-child': {
        marginRight: 0
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $0cdc32b9ea8d24b6$var$OptionalFieldsContainerExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_yv0e1gmk _yyhy1sd3 _1ii7wtyw _1e0c1txw _vchhusvi _4cvr1h6o _etbnotz2 _1bmuidpf _1uu8idpf",
            __cmplp.className
        ])
    });
});
const $0cdc32b9ea8d24b6$export$2c60bada4ddd3b79 = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $0cdc32b9ea8d24b6$var$OptionalFieldsContainerExperiment, $0cdc32b9ea8d24b6$var$OptionalFieldsContainerControl);
const $0cdc32b9ea8d24b6$export$c20c19c635a1723f = ()=>'[start checkbox] min-content ';
const $0cdc32b9ea8d24b6$export$cf4b3a0da67596a8 = (gridTemplateColumnsValue, shouldShowChevron)=>{
    if (shouldShowChevron) {
        if (gridTemplateColumnsValue) return '[chevron] 16px';
        return '[start chevron] 12px ';
    }
    return '';
};
const $0cdc32b9ea8d24b6$export$73efac7034b68854 = (gridTemplateColumnsValue)=>{
    if (gridTemplateColumnsValue) return '[issue-type] 16px ';
    return '[start issue-type] 16px ';
};
const $0cdc32b9ea8d24b6$export$4439a7282ef88de8 = ({ isOptimistic: isOptimistic })=>{
    if (isOptimistic) return `0 ${(0, $c9TLT.gridSize) / 2}px 0 ${(0, $c9TLT.gridSize) * 3.5}px`;
    return `0 ${(0, $c9TLT.gridSize) / 2}px 0 ${(0, $c9TLT.gridSize) * 1.5}px`;
};
const $0cdc32b9ea8d24b6$export$512f2a3a331cd04 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-8u98g6-8"
})`background-color:${({ isSelected: isSelected = false, isFlagged: isFlagged = false })=>$0cdc32b9ea8d24b6$export$122b84414b9478ae(isSelected, isFlagged)};cursor:${({ isDraggable: isDraggable })=>isDraggable === true ? 'pointer' : 'default'};opacity:${({ lowerOpacity: lowerOpacity })=>lowerOpacity ? 0.4 : 'inherit'};${({ hasExtraFields: hasExtraFields, shouldShowChevron: shouldShowChevron, isDragHandle: isDragHandle, isCompact: isCompact = false, hideTypeIcon: hideTypeIcon = false, isAssigneeShown: isAssigneeShown = true })=>{
    let gridTemplateColumnsValue = '';
    let gridTemplateRowsValue = '';
    gridTemplateColumnsValue += $0cdc32b9ea8d24b6$export$c20c19c635a1723f();
    gridTemplateColumnsValue += $0cdc32b9ea8d24b6$export$cf4b3a0da67596a8(gridTemplateColumnsValue, shouldShowChevron);
    if (!hideTypeIcon) gridTemplateColumnsValue += $0cdc32b9ea8d24b6$export$73efac7034b68854(gridTemplateColumnsValue);
    gridTemplateColumnsValue += '[issue-key] min-content [summary] 1fr';
    if (!isDragHandle) {
        gridTemplateColumnsValue += ' ';
        gridTemplateColumnsValue += '[card-group-key] max-content ';
        if ((0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings')) gridTemplateColumnsValue += [
            '[optional-fields] max-content',
            /* These values have to be in PX to ensure the elements take exactly the amount of space they need. Using a token/REM causes issues if browser's font size settings are set to smaller or larger */ `[assignee] ${isAssigneeShown ? 'calc(8px * 3.5)' : "var(--ds-space-0, 0px)"}`,
            '[menu] 32px',
            '[end]'
        ].join(' ');
        else gridTemplateColumnsValue += [
            '[optional-fields] max-content',
            `[assignee] ${isAssigneeShown ? 'calc(8px * 3.5)' : "var(--ds-space-0, 0px)"}`,
            `[menu] ${"var(--ds-space-400, 32px)"}`,
            '[end]'
        ].join(' ');
    }
    // Minus 1 to fix layout issues
    // We need to totally rework the layout to do this properly
    gridTemplateRowsValue += `[start card-detail] ${(isCompact ? (0, $9eH8H.COMPACT_CARD_ROW_HEIGHT) : (0, $9eH8H.CARD_ROW_HEIGHT)) - 1}px `;
    if (!isDragHandle && hasExtraFields) gridTemplateRowsValue += `[card-extra-fields] ${0, $9eH8H.EXTRA_CARD_ROW_HEIGHT}px [end]`;
    else gridTemplateRowsValue += '[end]';
    return (0, $kwce8.css)({
        display: 'grid',
        gridTemplateColumns: gridTemplateColumnsValue,
        gridTemplateRows: gridTemplateRowsValue,
        columnGap: "var(--ds-space-050, 4px)",
        rowGap: 0
    });
}};align-items:center;position:relative;height:${({ hasExtraFields: hasExtraFields, isCompact: isCompact = false })=>{
    const cardRowHeight = isCompact ? (0, $9eH8H.COMPACT_CARD_ROW_HEIGHT) : (0, $9eH8H.CARD_ROW_HEIGHT);
    return hasExtraFields ? `${cardRowHeight + (0, $9eH8H.EXTRA_CARD_ROW_HEIGHT)}px` : `${cardRowHeight}px`;
}};padding:${({ isOptimistic: isOptimistic })=>$0cdc32b9ea8d24b6$export$4439a7282ef88de8({
        isOptimistic: isOptimistic
    })};border:1px solid ${`var(--ds-border, ${(0, $PdmhA).N30})`};text-decoration:none;margin-top:${"var(--ds-space-negative-025, -2px)"};&:hover{background-color:${({ isSelected: isSelected = false, isFlagged: isFlagged = false })=>$0cdc32b9ea8d24b6$var$getHoverBgColor(isSelected, isFlagged)};--jsw-card-background-color:${({ isSelected: isSelected = false, isFlagged: isFlagged = false })=>$0cdc32b9ea8d24b6$var$getHoverBgColor(isSelected, isFlagged)};${$0cdc32b9ea8d24b6$export$c732a501d4812a69}{visibility:visible;}${$0cdc32b9ea8d24b6$var$CARD_CHECKBOX_COMPONENT_SELECTOR}{visibility:visible;}}&:focus,&:focus-within{${$0cdc32b9ea8d24b6$export$c732a501d4812a69}{visibility:visible;}${$0cdc32b9ea8d24b6$var$CARD_CHECKBOX_COMPONENT_SELECTOR}{visibility:visible;}}--jsw-card-background-color:${({ isSelected: isSelected = false, isFlagged: isFlagged = false })=>$0cdc32b9ea8d24b6$export$122b84414b9478ae(isSelected, isFlagged)};`;
const $0cdc32b9ea8d24b6$var$calculateGridTemplateValues = ({ hasExtraFields: hasExtraFields, shouldShowChevron: shouldShowChevron, isDragHandle: isDragHandle, isCompact: isCompact = false, hideTypeIcon: hideTypeIcon = false, isAssigneeShown: isAssigneeShown = true })=>{
    let gridTemplateColumnsValue = '';
    let gridTemplateRowsValue = '';
    gridTemplateColumnsValue += $0cdc32b9ea8d24b6$export$c20c19c635a1723f();
    gridTemplateColumnsValue += $0cdc32b9ea8d24b6$export$cf4b3a0da67596a8(gridTemplateColumnsValue, shouldShowChevron);
    if (!hideTypeIcon) gridTemplateColumnsValue += $0cdc32b9ea8d24b6$export$73efac7034b68854(gridTemplateColumnsValue);
    gridTemplateColumnsValue += '[issue-key] min-content [summary] 1fr';
    if (!isDragHandle) {
        gridTemplateColumnsValue += ' ';
        gridTemplateColumnsValue += '[card-group-key] max-content ';
        if ((0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings')) gridTemplateColumnsValue += [
            '[optional-fields] max-content',
            /* These values have to be in PX to ensure the elements take exactly the amount of space they need. Using a token/REM causes issues if browser's font size settings are set to smaller or larger */ `[assignee] ${isAssigneeShown ? 'calc(8px * 3.5)' : "var(--ds-space-0, 0px)"}`,
            '[menu] 32px',
            '[end]'
        ].join(' ');
        else gridTemplateColumnsValue += [
            '[optional-fields] max-content',
            `[assignee] ${isAssigneeShown ? 'calc(8px * 3.5)' : "var(--ds-space-0, 0px)"}`,
            `[menu] ${"var(--ds-space-400, 32px)"}`,
            '[end]'
        ].join(' ');
    } // Minus 1 to fix layout issues
    // We need to totally rework the layout to do this properly
    gridTemplateRowsValue += `[start card-detail] ${(isCompact ? (0, $9eH8H.COMPACT_CARD_ROW_HEIGHT) : (0, $9eH8H.CARD_ROW_HEIGHT)) - 1}px `;
    if (!isDragHandle && hasExtraFields) gridTemplateRowsValue += `[card-extra-fields] ${0, $9eH8H.EXTRA_CARD_ROW_HEIGHT}px [end]`;
    else gridTemplateRowsValue += '[end]';
    return {
        gridTemplateColumnsValue: gridTemplateColumnsValue,
        gridTemplateRowsValue: gridTemplateRowsValue
    };
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $0cdc32b9ea8d24b6$var$CardContainerExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, isFlagged: isFlagged, isDraggable: isDraggable, lowerOpacity: lowerOpacity, hasExtraFields: hasExtraFields, shouldShowChevron: shouldShowChevron, isDragHandle: isDragHandle, isCompact: isCompact, hideTypeIcon: hideTypeIcon, isAssigneeShown: isAssigneeShown, isOptimistic: isOptimistic, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_fbeie2": (0, $9t7rW.default)($0cdc32b9ea8d24b6$export$122b84414b9478ae(__cmplp.isSelected ?? false, __cmplp.isFlagged ?? false)),
            "--_183xcfk": (0, $9t7rW.default)($0cdc32b9ea8d24b6$var$calculateGridTemplateValues({
                hasExtraFields: __cmplp.hasExtraFields,
                shouldShowChevron: __cmplp.shouldShowChevron,
                isDragHandle: __cmplp.isDragHandle,
                isCompact: __cmplp.isCompact ?? false,
                hideTypeIcon: __cmplp.hideTypeIcon ?? false,
                isAssigneeShown: __cmplp.isAssigneeShown ?? true
            }).gridTemplateColumnsValue),
            "--_1d7lvij": (0, $9t7rW.default)($0cdc32b9ea8d24b6$var$calculateGridTemplateValues({
                hasExtraFields: __cmplp.hasExtraFields,
                shouldShowChevron: __cmplp.shouldShowChevron,
                isDragHandle: __cmplp.isDragHandle,
                isCompact: __cmplp.isCompact ?? false,
                hideTypeIcon: __cmplp.hideTypeIcon ?? false,
                isAssigneeShown: __cmplp.isAssigneeShown ?? true
            }).gridTemplateRowsValue),
            "--_vwvgr5": (0, $9t7rW.default)((()=>{
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                const cardRowHeight = __cmplp.isCompact ?? false ? (0, $9eH8H.COMPACT_CARD_ROW_HEIGHT) : (0, $9eH8H.CARD_ROW_HEIGHT); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                return __cmplp.hasExtraFields ? `${cardRowHeight + (0, $9eH8H.EXTRA_CARD_ROW_HEIGHT)}px` : `${cardRowHeight}px`;
            })()),
            "--_xn0y17": (0, $9t7rW.default)($0cdc32b9ea8d24b6$export$4439a7282ef88de8({
                isOptimistic: __cmplp.isOptimistic
            })),
            "--_13xqh42": (0, $9t7rW.default)($0cdc32b9ea8d24b6$var$getHoverBgColor(__cmplp.isSelected ?? false, __cmplp.isFlagged ?? false))
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkbi58 _1e0c11p5 _yv0es54b _2z05kxnq _gy1p1b66 _1p57idpf _4cvr1h6o _kqswh2mm _4t3i8lrv _1yt414ue _19it1l7n _4bfu18uv _1hmsglyw _ajmmnqa1 _19pk1i6y _1tvzbi58 _v8f3ewfl _f48lewfl _1jy6ewfl _16cmewfl _irr3mtee _nhtqmtee _kb9newfl _7zc6ewfl",
            __cmplp.isDraggable === true ? "_80omtlke" : "_80om73ad",
            __cmplp.lowerOpacity ? "_tzy41ou4" : "_tzy41kw7",
            __cmplp.className
        ])
    });
});
const $0cdc32b9ea8d24b6$export$8a23e74e5cf3ca41 = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $0cdc32b9ea8d24b6$var$CardContainerExperiment, $0cdc32b9ea8d24b6$export$512f2a3a331cd04); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0cdc32b9ea8d24b6$export$9d2b4227a95687cc = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _bfhk1qds",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $0cdc32b9ea8d24b6$export$ceed3f791e497d7e = /*#__PURE__*/ (0, $kwce8.default)($0cdc32b9ea8d24b6$var$KeyControl).withConfig({
    componentId: "sc-8u98g6-9"
})({
    position: 'inherit',
    display: 'contents',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: `${(0, $lcnyw.fontSizeSmall)()}px`
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $0cdc32b9ea8d24b6$var$CardGroupKeyExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $0cdc32b9ea8d24b6$var$KeyExperiment, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqsw1kw7 _1e0c1bgi _1wyb1skh",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0cdc32b9ea8d24b6$export$18c03323864bfda5 = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $0cdc32b9ea8d24b6$var$CardGroupKeyExperiment, $0cdc32b9ea8d24b6$export$ceed3f791e497d7e); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0cdc32b9ea8d24b6$export$e010d58e8595e079 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0cdc32b9ea8d24b6$export$b224c3920d5dc114 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _syaz1wmz _11c81vlj _k48pmoej _19bvv77o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0cdc32b9ea8d24b6$export$44715ef83bdcca01 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_tzy4idpf _v564ch4h _19pkmyb0 _2hwxmyb0 _otyrmyb0 _18u0myb0 _16l4kb7n _19lcglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0cdc32b9ea8d24b6$export$bafafde73fef7397 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1pbykb7n",
            __cmplp.className
        ])
    });
}); // empty column for the cards without due date
const $0cdc32b9ea8d24b6$export$2780fb0d195b1a91 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldRenderColumn: shouldRenderColumn, hasDueDate: hasDueDate, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_13v9lkb": (0, $9t7rW.default)(__cmplp.hasDueDate ? `${(0, $c9TLT.gridSize) * 7.5}px` : `${(0, $c9TLT.gridSize) * 8}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.shouldRenderColumn && "_1ul9n9pv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("30WDI", function(module, exports) {

$parcel$export(module.exports, "CHECKBOX_TESTID", () => $815d2a3fae3feb2d$export$6fe7aa6a89a9b29);
$parcel$export(module.exports, "CARD_CONTAINER_TESTID", () => $815d2a3fae3feb2d$export$b28b0b4c916693a4);
$parcel$export(module.exports, "CARDS_AMOUNT_BADGE_TESTID", () => $815d2a3fae3feb2d$export$d1903e0c7f8ee5c7);
$parcel$export(module.exports, "CMD_CLICK_ANALYTICS_ID", () => $815d2a3fae3feb2d$export$532ecc85a046702a);
$parcel$export(module.exports, "CHECKBOX_ANALYTICS_ID", () => $815d2a3fae3feb2d$export$88f95597995c9129);
$parcel$export(module.exports, "SHIFT_CLICK_ANALYTICS_ID", () => $815d2a3fae3feb2d$export$416730846dcfbfdb);
$parcel$export(module.exports, "CMD_SHIFT_CLICK_ANALYTICS_ID", () => $815d2a3fae3feb2d$export$757f7ef32cfa3ff);
$parcel$export(module.exports, "CHECKBOX_COMPONENT_SELECTOR", () => $815d2a3fae3feb2d$export$40d8217ec5a8ae9a);
$parcel$export(module.exports, "KEY_COMPONENT_SELECTOR", () => $815d2a3fae3feb2d$export$eb017f8fc9323651);
$parcel$export(module.exports, "KEY_CONTAINER_TEST_ID", () => $815d2a3fae3feb2d$export$3ca3a5ea5b54742d);
$parcel$export(module.exports, "SCREEN_READER_KEY_TEST_ID", () => $815d2a3fae3feb2d$export$d30ca8490ead1b3b);
$parcel$export(module.exports, "FLAG_CONTAINER_TEST_ID", () => $815d2a3fae3feb2d$export$97794d9709da94ad);
$parcel$export(module.exports, "FLAGGED_BUTTON_TEST_ID", () => $815d2a3fae3feb2d$export$f84ddfbd95bff080);
$parcel$export(module.exports, "ADD_FLAG_BUTTON_TEST_ID", () => $815d2a3fae3feb2d$export$1dd60f3ce6926cb);
$parcel$export(module.exports, "ESTIMATE_FIELD_WRAPPER_TEST_ID", () => $815d2a3fae3feb2d$export$5242fed4d28f1249);
$parcel$export(module.exports, "SUMMARY_TEST_ID", () => $815d2a3fae3feb2d$export$b6840ddc4661f707);
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles

var $c9TLT = parcelRequire("c9TLT");
const $815d2a3fae3feb2d$export$6fe7aa6a89a9b29 = 'software-backlog.card-list.card.card-contents.checkbox';
const $815d2a3fae3feb2d$export$b28b0b4c916693a4 = 'software-backlog.card-list.card.card-contents.card-container';
const $815d2a3fae3feb2d$export$d1903e0c7f8ee5c7 = 'software-backlog.card-list.card.card-contents.cards-amount-badge';
const $815d2a3fae3feb2d$export$532ecc85a046702a = 'cmdclick';
const $815d2a3fae3feb2d$export$88f95597995c9129 = 'checkbox';
const $815d2a3fae3feb2d$export$416730846dcfbfdb = 'shiftclick';
const $815d2a3fae3feb2d$export$757f7ef32cfa3ff = 'cmdshiftclick';
const $815d2a3fae3feb2d$export$40d8217ec5a8ae9a = 'software-backlog-card-card-contents-checkbox-container';
const $815d2a3fae3feb2d$export$eb017f8fc9323651 = 'software-backlog.card-list.card.card-contents.key';
const $815d2a3fae3feb2d$export$3ca3a5ea5b54742d = 'software-backlog.card-list.card.card-contents.accessible-card-key';
const $815d2a3fae3feb2d$export$d30ca8490ead1b3b = 'software-backlog.card-list.card.card-contents.screen-reader-key';
const $815d2a3fae3feb2d$export$97794d9709da94ad = 'software-backlog.card-list.card.card-contents.flag-container';
const $815d2a3fae3feb2d$export$f84ddfbd95bff080 = 'software-backlog.card-list.card.card-contents.flagged-button';
const $815d2a3fae3feb2d$export$1dd60f3ce6926cb = 'software-backlog.card-list.card.card-contents.add-flag-button';
const $815d2a3fae3feb2d$export$5242fed4d28f1249 = 'software-backlog.card-list.card.card-contents.estimate-field-wrapper';
const $815d2a3fae3feb2d$export$b6840ddc4661f707 = 'software-backlog.card-list.card.card-contents.summary';
const $815d2a3fae3feb2d$export$a7e851dd01b7bece = (0, $c9TLT.gridSize) * 2;

});


parcelRegister("939HY", function(module, exports) {

$parcel$export(module.exports, "ScreenThreshold", () => $33636d7927a7b8b2$export$e533650b80af8cf3);
$parcel$export(module.exports, "ScreenSize", () => $33636d7927a7b8b2$export$9098989df19ab765);
const $33636d7927a7b8b2$export$e533650b80af8cf3 = {
    EXTRA_SMALL: 768,
    SMALL: 1024,
    MEDIUM: 1440,
    LARGE: 1760
};
const $33636d7927a7b8b2$export$9098989df19ab765 = {
    EXTRA_SMALL: 'xs',
    SMALL: 'sm',
    MEDIUM: 'md',
    LARGE: 'lg',
    EXTRA_LARGE: 'xl'
};

});

parcelRegister("bn3eO", function(module, exports) {

$parcel$export(module.exports, "ContainerSizeContext", () => $4b4a3a705188cffd$export$a78b219fc961f8cd);
$parcel$export(module.exports, "useContainerSize", () => $4b4a3a705188cffd$export$1b2c18f86b4398c2);
$parcel$export(module.exports, "useBacklogContainerSize", () => $4b4a3a705188cffd$export$d6913af4e936e4ae);

var $eUqFw = parcelRequire("eUqFw");

var $7uxUn = parcelRequire("7uxUn");

var $939HY = parcelRequire("939HY");
const $4b4a3a705188cffd$export$a78b219fc961f8cd = /*#__PURE__*/ (0, $eUqFw.createContext)({
    size: (0, $939HY.ScreenSize).MEDIUM
});
const $4b4a3a705188cffd$export$1b2c18f86b4398c2 = ()=>(0, $eUqFw.useContext)($4b4a3a705188cffd$export$a78b219fc961f8cd);
function $4b4a3a705188cffd$var$getBacklogContainerSize(offsetWidth) {
    if (offsetWidth === undefined) return (0, $939HY.ScreenSize).MEDIUM;
    if (offsetWidth < (0, $939HY.ScreenThreshold).EXTRA_SMALL) return (0, $939HY.ScreenSize).EXTRA_SMALL;
    if (offsetWidth > (0, $939HY.ScreenThreshold).EXTRA_SMALL && offsetWidth < (0, $939HY.ScreenThreshold).SMALL) return (0, $939HY.ScreenSize).SMALL;
    if (offsetWidth > (0, $939HY.ScreenThreshold).SMALL && offsetWidth < (0, $939HY.ScreenThreshold).MEDIUM) return (0, $939HY.ScreenSize).MEDIUM;
    if (offsetWidth > (0, $939HY.ScreenThreshold).MEDIUM && (0, $939HY.ScreenThreshold).LARGE) return (0, $939HY.ScreenSize).LARGE;
    return (0, $939HY.ScreenSize).EXTRA_LARGE;
}
function $4b4a3a705188cffd$export$d6913af4e936e4ae({ ref: ref }) {
    const [backlogContainerSize, setBacklogContainerSize] = (0, $eUqFw.useState)(ref.current?.offsetWidth !== undefined ? $4b4a3a705188cffd$var$getBacklogContainerSize(ref.current?.offsetWidth) : (0, $939HY.ScreenSize).MEDIUM);
    (0, $7uxUn.useResizeObserver)({
        ref: ref,
        onResize () {
            if (ref.current) {
                const { offsetWidth: offsetWidth } = ref.current;
                setBacklogContainerSize(offsetWidth !== undefined ? $4b4a3a705188cffd$var$getBacklogContainerSize(offsetWidth) : (0, $939HY.ScreenSize).MEDIUM);
            }
        }
    });
    return backlogContainerSize;
}

});
parcelRegister("7uxUn", function(module, exports) {

$parcel$export(module.exports, "createResizeObserverHook", () => $dc839ec384d19a4a$export$87a9d3e287304ae4);
$parcel$export(module.exports, "useResizeObserver", () => $dc839ec384d19a4a$export$683480f191c0e3ea);
$parcel$export(module.exports, "flushResizeObservers", () => $dc839ec384d19a4a$export$a181ef2a6d0a1bb6);
$parcel$export(module.exports, "useRectObserver", () => $dc839ec384d19a4a$export$e58143dc89297272);

var $eUqFw = parcelRequire("eUqFw");

var $gDQs6 = parcelRequire("gDQs6");
function $dc839ec384d19a4a$export$87a9d3e287304ae4(params) {
    const group = new (0, $gDQs6.ResizeObserverGroup)(params?.debouncePeriod);
    /**
	 * This hook uses a shared ResizeObserver instance.
	 *
	 * When a resize notification comes in, a single batched React update will be
	 * dispatched after a debounce period only for the elements that have been
	 * resized.
	 *
	 * This does NOT react to updates to REF
	 */ function useResizeObserver({ ref: ref, onResize: onResize }) {
        const onResizeRef = (0, $eUqFw.useRef)(onResize);
        (0, $eUqFw.useEffect)(()=>{
            onResizeRef.current = onResize;
        });
        const stableOnResize = (0, $eUqFw.useCallback)(()=>onResizeRef.current(), []);
        (0, $eUqFw.useLayoutEffect)(()=>group.observe(ref, stableOnResize), [
            ref,
            stableOnResize
        ]);
    }
    return {
        useResizeObserver: useResizeObserver,
        flushResizeObservers: ()=>group.flush()
    };
}
const { useResizeObserver: $dc839ec384d19a4a$export$683480f191c0e3ea, flushResizeObservers: $dc839ec384d19a4a$export$a181ef2a6d0a1bb6 } = $dc839ec384d19a4a$export$87a9d3e287304ae4();
function $dc839ec384d19a4a$export$e58143dc89297272({ ref: ref, useResizeObserverDI: useResizeObserverDI = $dc839ec384d19a4a$export$683480f191c0e3ea }) {
    const [rect, setRect] = (0, $eUqFw.useState)(null);
    const onResize = ()=>{
        if (ref.current) setRect(ref.current.getBoundingClientRect());
    };
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!ref.current) throw new Error([
            'useRectObserver: ref is not available on mount.',
            'This means you are attaching refs conditionally onto your elements, for example in with an early return.',
            'This will not work properly. Please update your code so that refs are always attached to components on mount.'
        ].join('\n'));
        setRect(ref.current.getBoundingClientRect());
    }, [
        ref
    ]);
    useResizeObserverDI({
        ref: ref,
        onResize: onResize
    });
    return rect;
}

});
parcelRegister("gDQs6", function(module, exports) {

$parcel$export(module.exports, "ResizeObserverGroup", () => $91e461fbc4ab66c0$export$607798bbe2869c0);

var $lEfVV = parcelRequire("lEfVV");

var $dxIU5 = parcelRequire("dxIU5");
class $91e461fbc4ab66c0$export$607798bbe2869c0 {
    constructor(debouncePeriod = 16){
        this.subscribers = new Map();
        this.pendingUpdates = new Map();
        this.onResize = (entries)=>{
            entries.forEach((entry)=>{
                const subscriber = this.subscribers.get(entry.target);
                if (subscriber) this.pendingUpdates.set(subscriber.element, subscriber);
            });
            this.scheduleFlush();
        };
        this.observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(this.onResize) : null;
        this.scheduleFlush = debouncePeriod > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(()=>{
            this.flush();
        }, debouncePeriod, {
            trailing: true,
            maxWait: 32
        }) : ()=>{
            this.flush();
        };
    }
    observe(ref, callback) {
        if (!ref.current) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        this.subscribers.set(ref.current, {
            element: ref.current,
            callback: callback
        });
        this.observer?.observe(ref.current);
        return ()=>{
            if (!ref.current) return;
            this.subscribers.delete(ref.current);
            this.pendingUpdates.delete(ref.current);
            this.observer?.unobserve(ref.current);
        };
    }
    flush() {
        const entries = Array.from(this.pendingUpdates.values()).filter((entry)=>this.subscribers.has(entry.element));
        this.pendingUpdates.clear();
        (0, $lEfVV.unstable_batchedUpdates)(()=>{
            entries.forEach(({ callback: callback })=>{
                callback();
            });
        });
    }
}

});



parcelRegister("3vQAb", function(module, exports) {

$parcel$export(module.exports, "AssigneeLite", () => $66e2a52b43ab91b8$export$a031037f4a309a04);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $kmr29 = parcelRequire("kmr29");


var $8MrYx = parcelRequire("8MrYx");

var $k83hI = parcelRequire("k83hI");
const $66e2a52b43ab91b8$export$a031037f4a309a04 = ({ issueKey: issueKey })=>{
    const showAssignee = (0, $8MrYx.useShowAssignee)();
    const [assigneeFieldValue] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $ebc098a76317be78$export$e18419056f3d184a)
    });
    const value = assigneeFieldValue ? {
        id: assigneeFieldValue.accountId,
        displayName: assigneeFieldValue.displayName,
        avatarUrl: assigneeFieldValue.avatarUrls?.['48x48']
    } : null;
    return showAssignee ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k83hI.AvatarWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        src: value?.avatarUrl,
        size: "small",
        borderColor: "transparent"
    })) : null;
};

});
parcelRegister("k83hI", function(module, exports) {

$parcel$export(module.exports, "AvatarWrapper", () => $a95d7fcd1e9024b8$export$f7513421c53ce141);
$parcel$export(module.exports, "default", () => $a95d7fcd1e9024b8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iJlfe = parcelRequire("iJlfe");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $h3HZ0 = parcelRequire("h3HZ0");
const $a95d7fcd1e9024b8$export$20dedc39b82b5168 = ({ value: value })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const name = value?.id ? formatMessage((0, $h3HZ0.default).assigneeTooltip, {
        name: value.displayName
    }) : formatMessage((0, $h3HZ0.default).assigneeTooltipUnassigned);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a95d7fcd1e9024b8$export$f7513421c53ce141, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        src: value?.avatarUrl,
        name: name,
        size: "small",
        borderColor: "transparent"
    })));
};
var $a95d7fcd1e9024b8$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($a95d7fcd1e9024b8$export$20dedc39b82b5168);
const $a95d7fcd1e9024b8$export$f7513421c53ce141 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1f4h _80om73ad",
            __cmplp.className
        ])
    });
});

});
parcelRegister("h3HZ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $bca7e57f8de323b0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $bca7e57f8de323b0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    assigneeTooltip: {
        "id": "backlog.card-list.card.card-contents.assignee-field.assignee-field-static.assignee-tooltip",
        "defaultMessage": "Assignee: {name}"
    },
    assigneeTooltipUnassigned: {
        "id": "backlog.card-list.card.card-contents.assignee-field.assignee-field-static.assignee-tooltip-unassigned",
        "defaultMessage": "Unassigned"
    }
});

});



parcelRegister("7AnmZ", function(module, exports) {

$parcel$export(module.exports, "DueDate", () => $ace846557e060b52$export$4c248a4717685909);

var $eUqFw = parcelRequire("eUqFw");

var $1gQ73 = parcelRequire("1gQ73");

var $bP7Jx = parcelRequire("bP7Jx");

var $fEa6g = parcelRequire("fEa6g");
const $ace846557e060b52$export$4c248a4717685909 = (props)=>{
    const shouldRenderDueDateColumn = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.backlogHasDueDate));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEa6g.DueDate), {
        ...props,
        shouldRenderDueDateColumn: shouldRenderDueDateColumn
    });
};

});
parcelRegister("fEa6g", function(module, exports) {

$parcel$export(module.exports, "DueDate", () => $40bcbfdd659c1cce$export$4c248a4717685909);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $c9TLT = parcelRequire("c9TLT");

var $daiHs = parcelRequire("daiHs");
const $40bcbfdd659c1cce$export$4c248a4717685909 = ({ dueDate: dueDate, shouldRenderDueDateColumn: shouldRenderDueDateColumn, isDone: isDone })=>{
    const cardDueDate = dueDate || '';
    const dueDateNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $daiHs.CardDueDate), {
        dueDate: cardDueDate,
        isCompleted: isDone
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($40bcbfdd659c1cce$var$CardDueDateWrapper, {
        shouldRenderColumn: shouldRenderDueDateColumn,
        hasDueDate: dueDate !== null,
        "data-testid": "software-backlog.card-list.card.card-contents.due-date"
    }, cardDueDate ? dueDateNode : null);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $40bcbfdd659c1cce$var$CardDueDateWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldRenderColumn: shouldRenderColumn, hasDueDate: hasDueDate, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_13v9lkb": (0, $9t7rW.default)(__cmplp.hasDueDate ? `${(0, $c9TLT.gridSize) * 7.5}px` : `${(0, $c9TLT.gridSize) * 8}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.shouldRenderColumn && "_1ul9n9pv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("daiHs", function(module, exports) {

$parcel$export(module.exports, "CardDueDate", () => $486a10674c0d478f$export$9e242219cf1cc36c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $d2wNG = parcelRequire("d2wNG");
var $7n7Dc = parcelRequire("7n7Dc");
var $EN9B6 = parcelRequire("EN9B6");
var $3xcI8 = parcelRequire("3xcI8");
var $3jYzf = parcelRequire("3jYzf");

var $ffiyv = parcelRequire("ffiyv");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $i0Rm4 = parcelRequire("i0Rm4");

var $9CYrO = parcelRequire("9CYrO");
const $486a10674c0d478f$export$9e242219cf1cc36c = (props)=>{
    const { isCompleted: isCompleted, dueDate: dueDate, dateFormat: dateFormat } = props;
    const dueDateEndOfDay = (0, $7n7Dc.default)((0, $3xcI8.default)(dueDate));
    const currentDate = (0, $3jYzf.default)(new Date());
    const diffInDays = (0, $d2wNG.default)(dueDateEndOfDay, currentDate);
    const isDueBeforeToday = diffInDays <= 0;
    const isOverDue = isCompleted !== true && isDueBeforeToday;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const formattedDueDate = dateFormat !== undefined && dateFormat !== null ? (0, $EN9B6.default)(dueDateEndOfDay, dateFormat) : (0, $EN9B6.default)(dueDateEndOfDay, 'dd MMM');
    const formattedTooltip = formatMessage((0, $9CYrO.messages).text, {
        date: (0, $EN9B6.default)(dueDateEndOfDay, 'dd MMMM yyyy')
    });
    /* eslint-disable jira/react/no-style-attribute */ return dueDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ), {
        style: $486a10674c0d478f$var$dueDateLozengeStyle(isOverDue),
        testId: "platform-card.common.ui.due-date.lozenge"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formattedTooltip,
        testId: "platform-card.common.ui.due-date.tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($486a10674c0d478f$var$Content, {
        "aria-label": formattedTooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i0Rm4.default), {
        type: (0, $db933f3263da36b1$export$d4ee7b46933c494f),
        label: formattedTooltip
    }), formattedDueDate))) : null;
/* eslint-enable jira/react/no-style-attribute */ };
$486a10674c0d478f$export$9e242219cf1cc36c.defaultProps = {
    isCompleted: false
};
var $486a10674c0d478f$export$2e2bcd8739ae039 = $486a10674c0d478f$export$9e242219cf1cc36c;
const $486a10674c0d478f$var$dueDateLozengeStyle = (isOverDue)=>isOverDue ? {
        color: `var(--ds-text-accent-red, ${(0, $PdmhA).R400})`,
        backgroundColor: `var(--ds-background-danger, ${(0, $PdmhA).R50})`
    } : {
        color: `var(--ds-text-subtle, ${(0, $PdmhA).N500})`,
        backgroundColor: `var(--ds-background-neutral, ${(0, $PdmhA).N20})`
    };
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $486a10674c0d478f$var$Content = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1n261g80",
            __cmplp.className
        ])
    });
});

});
parcelRegister("i0Rm4", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b7d80576fbad589$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $kwce8 = parcelRequire("kwce8");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");

var $8jchp = parcelRequire("8jchp");

const $7b7d80576fbad589$var$renderIcon = (type)=>{
    switch(type){
        case 0, $db933f3263da36b1$export$3b43f1ca008dad23:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jchp.ChildIssuesGlyph), null);
        case 0, $db933f3263da36b1$export$aac403da0d127706:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jchp.FlagGlyph), null);
        case 0, $db933f3263da36b1$export$540a31b23d6b9abd:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jchp.CheckGlyph), null);
        case 0, $db933f3263da36b1$export$352da558a3a09227:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jchp.UploadGlyph), null);
        case 0, $db933f3263da36b1$export$178cb2e5b5fc68e8:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jchp.BitbucketBranchesGlyph), null);
        case 0, $db933f3263da36b1$export$a153e0417183b79:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jchp.BitbucketCommitsGlyph), null);
        case 0, $db933f3263da36b1$export$555f9a88a8c5f309:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jchp.BitbucketPullrequestsGlyph), null);
        case 0, $db933f3263da36b1$export$82a1ca282cb5e4e5:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jchp.EmojiFrequentGlyph), null);
        case 0, $db933f3263da36b1$export$423cd243bf1888bc:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jchp.MoreGlyph), null);
        case 0, $db933f3263da36b1$export$30a9be92cbb6f382:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jchp.PersonGlyph), null);
        case 0, $db933f3263da36b1$export$d4ee7b46933c494f:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jchp.DueDateGlyph), null);
        default:
            throw Error(`Invalid Icon type - ${type}`);
    }
};
const $7b7d80576fbad589$var$CardIcon = (props)=>{
    const { label: label, primaryColor: primaryColor, type: type } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7b7d80576fbad589$var$Container, {
        role: "img",
        "aria-label": label,
        primaryColor: primaryColor
    }, $7b7d80576fbad589$var$renderIcon(type));
};
var $7b7d80576fbad589$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
 = $7b7d80576fbad589$var$CardIcon;
const $7b7d80576fbad589$var$ContainerControl = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "sc-1tuyf7k-0"
})((props)=>({
        display: 'inline-block',
        flexShrink: 0,
        lineHeight: 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            verticalAlign: 'bottom',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: props.primaryColor || undefined
        }
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7b7d80576fbad589$var$ContainerExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { primaryColor: primaryColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_yk4yla": (0, $9t7rW.default)(__cmplp.primaryColor || undefined)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _1o9zidpf _vwz4kb7n _1veoyfq0 _1ksv19wz",
            __cmplp.className
        ])
    });
});
const $7b7d80576fbad589$var$Container = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $7b7d80576fbad589$var$ContainerExperiment, $7b7d80576fbad589$var$ContainerControl);

});
parcelRegister("8jchp", function(module, exports) {

$parcel$export(module.exports, "ChildIssuesGlyph", () => $82b158e6c49496ac$export$e45c85830644abc5);
$parcel$export(module.exports, "FlagGlyph", () => $82b158e6c49496ac$export$cef8dc8280f1c02c);
$parcel$export(module.exports, "CheckGlyph", () => $82b158e6c49496ac$export$50963481dc57ac5c);
$parcel$export(module.exports, "UploadGlyph", () => $82b158e6c49496ac$export$330e95d855f0ff0);
$parcel$export(module.exports, "BitbucketBranchesGlyph", () => $82b158e6c49496ac$export$5aa1ec710367c05);
$parcel$export(module.exports, "BitbucketCommitsGlyph", () => $82b158e6c49496ac$export$4f751361dc2785a8);
$parcel$export(module.exports, "BitbucketPullrequestsGlyph", () => $82b158e6c49496ac$export$314907f846d12b79);
$parcel$export(module.exports, "EmojiFrequentGlyph", () => $82b158e6c49496ac$export$e6da30a8001300c0);
$parcel$export(module.exports, "MoreGlyph", () => $82b158e6c49496ac$export$f291c054d6e2e898);
$parcel$export(module.exports, "PersonGlyph", () => $82b158e6c49496ac$export$b59bd42a398a2b3c);
$parcel$export(module.exports, "DueDateGlyph", () => $82b158e6c49496ac$export$45e4820251213456);

var $eUqFw = parcelRequire("eUqFw");
const $82b158e6c49496ac$export$e45c85830644abc5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M11 7h2v5h-2zm5 6h2v3h-2zM6 13h2v3H6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7 11h10a1 1 0 011 1v1H6v-1a1 1 0 011-1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M5 18v1h4v-1H5zm0-2h4a2 2 0 012 2v1a2 2 0 01-2 2H5a2 2 0 01-2-2v-1a2 2 0 012-2zm10 2v1h4v-1h-4zm0-2h4a2 2 0 012 2v1a2 2 0 01-2 2h-4a2 2 0 01-2-2v-1a2 2 0 012-2zM10 5v1h4V5h-4zm0-2h4a2 2 0 012 2v1a2 2 0 01-2 2h-4a2 2 0 01-2-2V5a2 2 0 012-2z",
        fillRule: "nonzero"
    })));
const $82b158e6c49496ac$export$cef8dc8280f1c02c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6 12.235v6.446c0 .537.45.977 1 .977s1-.44 1-.977v-5.778c1.17-.341 2.389-.045 3.768.29.982.238 2.036.495 3.13.495a5.73 5.73 0 002.547-.567 1 1 0 00.563-.9V5.466a.998.998 0 00-1.437-.9c-1.345.654-2.731.317-4.331-.071-1.729-.42-3.687-.895-5.678.072A1 1 0 006 5.466v6.769z",
        fill: "currentColor"
    }));
const $82b158e6c49496ac$export$50963481dc57ac5c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6.735 12.322a1 1 0 00-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2335.638 2335.638 0 003.939-3.883l.04-.04a492.598 492.598 0 003.658-3.643 1 1 0 00-1.424-1.404 518.42 518.42 0 01-3.64 3.625l-.04.04a2049.114 2049.114 0 01-3.775 3.722l-3.098-3.363z",
        fill: "currentColor"
    }));
const $82b158e6c49496ac$export$330e95d855f0ff0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "24",
        width: "24",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M11.208 9.32L9.29 11.253a1 1 0 000 1.409.982.982 0 001.397 0l1.29-1.301 1.336 1.347a.982.982 0 001.397.001 1.002 1.002 0 00.001-1.408l-1.965-1.98a1.08 1.08 0 00-1.538-.001z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M11 10.007l.001 9.986c0 .557.448 1.008 1 1.007.553 0 1-.45 1-1.007L13 10.006C13 9.451 12.552 9 12 9s-1.001.451-1 1.007z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7.938 5.481a4.8 4.8 0 00-.777-.063C4.356 5.419 2 7.62 2 10.499 2 13.408 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.051.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.119a4.14 4.14 0 014.069 3.644l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-1.999-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.021-3.901.901-5.038 2.481z"
    })));
const $82b158e6c49496ac$export$5aa1ec710367c05 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19 11c0 1.3-.8 2.4-2 2.8V15c0 2.2-1.8 4-4 4h-2.2c-.4 1.2-1.5 2-2.8 2-1.7 0-3-1.3-3-3 0-1.3.8-2.4 2-2.8V8.8C5.9 8.4 5 7.3 5 6c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.3-.8 2.4-2.1 2.8v6.4c.9.3 1.6.9 1.9 1.8H13c1.1 0 2-.9 2-2v-1.2c-1.2-.4-2-1.5-2-2.8 0-1.7 1.3-3 3-3s3 1.3 3 3zM8 5c-.5 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zm8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1zm-8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $82b158e6c49496ac$export$4f751361dc2785a8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M16 12c0-1.9-1.3-3.4-3-3.9V4c0-.6-.4-1-1-1s-1 .4-1 1v4.1c-1.7.4-3 2-3 3.9s1.3 3.4 3 3.9V20c0 .6.4 1 1 1s1-.4 1-1v-4.1c1.7-.5 3-2 3-3.9zm-4 2c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $82b158e6c49496ac$export$314907f846d12b79 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M18 15.2V11c0-1.7-1.3-3-3-3h-1.9l.8-.8c.3-.3.3-.8 0-1.1-.3-.3-.8-.3-1.1 0l-2.3 2.3c-.3.4-.3.9 0 1.2l2.3 2.3c.2.2.3.2.5.2s.4-.1.6-.3c.3-.3.3-.8 0-1.1l-.7-.7H15c.6 0 1 .4 1 1v4.2c-1.2.4-2 1.5-2 2.8 0 1.7 1.3 3 3 3s3-1.3 3-3c0-1.3-.8-2.4-2-2.8zM17 19c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zM7 3C5.4 3 4 4.3 4 6c0 1.3.8 2.4 2 2.8V20c0 .6.4 1 1 1s1-.4 1-1V8.8c1.2-.4 2-1.5 2-2.8 0-1.7-1.3-3-3-3zm0 4c-.5 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $82b158e6c49496ac$export$e6da30a8001300c0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8zm0 14.222A6.23 6.23 0 015.778 12 6.23 6.23 0 0112 5.778 6.23 6.23 0 0118.222 12 6.23 6.23 0 0112 18.222zm.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.891.891 0 001.257 0 .891.891 0 000-1.256l-1.942-1.943z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $82b158e6c49496ac$export$f291c054d6e2e898 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "5",
        cy: "12",
        r: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "19",
        cy: "12",
        r: "2"
    })));
const $82b158e6c49496ac$export$b59bd42a398a2b3c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "24",
        width: "24",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0V14z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "12",
        cy: "7",
        r: "4"
    })));
const $82b158e6c49496ac$export$45e4820251213456 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0119.005 21H4.995A1.995 1.995 0 013 19.006V6.994C3 5.893 3.892 5 4.995 5zM5 9v9a1 1 0 001 1h12a1 1 0 001-1V9H5zm1-5a1 1 0 012 0v1H6V4zm10 0a1 1 0 012 0v1h-2V4zm-9 9v-2.001h2V13H7zm8 0v-2.001h2V13h-2zm-4 0v-2.001h2.001V13H11zm-4 4v-2h2v2H7zm4 0v-2h2.001v2H11zm4 0v-2h2v2h-2z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));

});

const $db933f3263da36b1$export$3b43f1ca008dad23 = 'child-issues';
const $db933f3263da36b1$export$aac403da0d127706 = 'flag';
const $db933f3263da36b1$export$540a31b23d6b9abd = 'tick';
const $db933f3263da36b1$export$352da558a3a09227 = 'upload';
const $db933f3263da36b1$export$178cb2e5b5fc68e8 = 'bitbucket-branches';
const $db933f3263da36b1$export$a153e0417183b79 = 'bitbucket-commits';
const $db933f3263da36b1$export$555f9a88a8c5f309 = 'bitbucket-pullrequests';
const $db933f3263da36b1$export$82a1ca282cb5e4e5 = 'emoji-frequent';
const $db933f3263da36b1$export$423cd243bf1888bc = 'more';
const $db933f3263da36b1$export$30a9be92cbb6f382 = 'person';
const $db933f3263da36b1$export$d4ee7b46933c494f = 'due-date';


parcelRegister("9CYrO", function(module, exports) {

$parcel$export(module.exports, "messages", () => $57887752e833b9f2$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $57887752e833b9f2$export$593a022a1631ee1e = 'Due Date: ';
const $57887752e833b9f2$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    text: {
        "id": "due-date.text",
        "defaultMessage": "Due Date: {date}"
    }
});

});




parcelRegister("UzIGp", function(module, exports) {

$parcel$export(module.exports, "EpicLiteWrapper", () => $488a21734a5d4f49$export$bb3aabd940f6f405);

var $eUqFw = parcelRequire("eUqFw");

var $8MrYx = parcelRequire("8MrYx");

var $jIn90 = parcelRequire("jIn90");
const $488a21734a5d4f49$export$bb3aabd940f6f405 = ({ card: card, backlogContainerSize: backlogContainerSize, isCompactView: isCompactView })=>{
    const showEpics = (0, $8MrYx.useShowEpics)();
    if (showEpics) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jIn90.EpicLite), {
        card: card,
        screenSize: backlogContainerSize,
        isCompactView: isCompactView
    });
    return null;
};

});
parcelRegister("jIn90", function(module, exports) {

$parcel$export(module.exports, "EpicLite", () => $cc70d6930d8f7eb5$export$84103c8f50e5bb46);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $opsFH = parcelRequire("opsFH");

var $kmr29 = parcelRequire("kmr29");

var $3l6tm = parcelRequire("3l6tm");

var $lO4Or = parcelRequire("lO4Or");

var $1gQ73 = parcelRequire("1gQ73");

var $bP7Jx = parcelRequire("bP7Jx");

var $k734R = parcelRequire("k734R");

var $5mm8H = parcelRequire("5mm8H");

var $h4Zri = parcelRequire("h4Zri");

var $hkD5e = parcelRequire("hkD5e");

var $5WFzC = parcelRequire("5WFzC");
const $cc70d6930d8f7eb5$var$EpicLozengeForAllNonEpicsLite = ({ card: card, isCompactView: isCompactView, screenSize: screenSize })=>{
    const parents = (0, $1gQ73.useBacklogSelector)((0, $k734R.issueParentsSelector));
    const [parentValue] = (0, $kmr29.useFieldValue)({
        issueKey: card.key,
        fieldKey: (0, $lO4Or.PARENT_TYPE)
    });
    const isSubtask = (0, $3l6tm.isSubtaskHierarchyLevel)(card.typeHierarchyLevel);
    const mappedParent = card.parentId ? parents.find(({ id: id })=>Number(id) === Number(card.parentId)) : null;
    // Check if the card and parent are different as `useFieldValue` can fail and fallback to
    // the current card's summary which is VERY wrong. We need to check this and not show
    // a lozenge if that happens.
    const isParentValueSameAsCard = card.id === parentValue?.id || card.key === parentValue?.key;
    // Use mapped parent first, fallback to parentValue
    const color = mappedParent?.color || parentValue?.color || (0, $opsFH.PURPLE);
    let summary = mappedParent?.summary;
    // If we couldn't get summary from mapped parent, try to add it from parentValue if
    // we got a valid value from useFieldValue.
    if (!summary && !isParentValueSameAsCard) summary = parentValue?.fields?.summary;
    // There are multiple ways that the backlog will fetch the epic. It will either exist in redux
    // OR we will need to retrieve it from the issue fields sweet state.
    const hasValidEpic = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(summary) && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(color);
    return(// Using placeholderWidthMultiplier so that with change in container width the width of placeholder changes
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.EpicWrapper), {
        widthMultiplier: (0, $hkD5e.getLabelWidthMultiplier)((0, $hkD5e.LabelType).EPIC, screenSize),
        // To avoid any extra space show the placeholder only on cards not linked to any epic and are not subtasks
        showPlaceholder: card.parentId === null && !isSubtask
    }, hasValidEpic && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h4Zri.default), {
        color: color,
        summary: summary ?? '',
        isCompactView: isCompactView
    })));
};
const $cc70d6930d8f7eb5$export$84103c8f50e5bb46 = (props)=>{
    const { card: card, screenSize: screenSize } = props;
    const cardHierarchyLevel = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.makeGetCardHierarchyLevel));
    const isEpic = (0, $3l6tm.isEpicHierarchyLevel)(cardHierarchyLevel(card.id));
    if (isEpic) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.EpicWrapper), {
        widthMultiplier: (0, $hkD5e.getLabelWidthMultiplier)((0, $hkD5e.LabelType).EPIC, screenSize),
        // To avoid any extra space show the placeholder only on cards not linked to any epic and are not subtasks
        showPlaceholder: card.parentId === null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mm8H.default), {
        issueId: card.id,
        issueKey: card.key,
        ...props
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cc70d6930d8f7eb5$var$EpicLozengeForAllNonEpicsLite, props);
};

});
parcelRegister("5mm8H", function(module, exports) {

$parcel$export(module.exports, "default", () => $66195f5c940ee0c4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lPQPn = parcelRequire("lPQPn");

var $kmr29 = parcelRequire("kmr29");

var $lO4Or = parcelRequire("lO4Or");

var $1gQ73 = parcelRequire("1gQ73");

var $bP7Jx = parcelRequire("bP7Jx");

var $8ZI73 = parcelRequire("8ZI73");

var $h4Zri = parcelRequire("h4Zri");
const $66195f5c940ee0c4$var$EpicLozengeField = ({ issueKey: issueKey, issueId: issueId, isCompactView: isCompactView })=>{
    const epicColorFieldId = (0, $1gQ73.useBacklogSelector)((0, $8ZI73.getEpicColorFieldId));
    const cardColor = (0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.getCardEpicColor)(state, issueId));
    const [epicColorFromFieldsStore] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: epicColorFieldId ?? ''
    });
    const [epicSummary] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $lO4Or.SUMMARY_TYPE)
    });
    const color = (0, $lPQPn.asColor)(epicColorFromFieldsStore || cardColor);
    return epicSummary ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h4Zri.default), {
        color: (0, $lPQPn.asColor)(color),
        summary: epicSummary,
        isCompactView: isCompactView
    }) : null;
};
var $66195f5c940ee0c4$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($66195f5c940ee0c4$var$EpicLozengeField);

});
parcelRegister("h4Zri", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fd896d30107037d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $1cKV0 = parcelRequire("1cKV0");
const $9fd896d30107037d$export$2fe14dcf8683ace1 = ({ color: color, summary: summary, isCompactView: isCompactView })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9fd896d30107037d$var$StaticLozengeWrapper, {
        isCompactView: isCompactView
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1cKV0.EpicLozenge), {
        color: color,
        summary: summary,
        isCompactView: isCompactView
    }));
var $9fd896d30107037d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($9fd896d30107037d$export$2fe14dcf8683ace1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9fd896d30107037d$var$StaticLozengeWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCompactView: isCompactView, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvresu3 _o5721q9c _1bto1l2s _1reo15vq _18m915vq _vchhusvi _p12f1osq _172pidpf _1hcdidpf _1oyyidpf _19h8idpf",
            !__cmplp.isCompactView && "_19bvu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1cKV0", function(module, exports) {

$parcel$export(module.exports, "EpicLozenge", () => $55728b847ff10d9a$export$2e623d726e27c97);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $ffiyv = parcelRequire("ffiyv");

var $8cU5f = parcelRequire("8cU5f");

var $1ybV0 = parcelRequire("1ybV0");

var $lPQPn = parcelRequire("lPQPn");

var $hVwWE = parcelRequire("hVwWE");

var $51HAN = parcelRequire("51HAN");
const $55728b847ff10d9a$export$2e623d726e27c97 = ({ color: color, summary: summary, maxWidth: maxWidth, isCompactView: isCompactView })=>{
    const paletteColorValues = (0, $lPQPn.transformColorToTheme)((colorSchema)=>colorSchema.primary);
    const selectedColor = color && paletteColorValues[color] || '';
    return isCompactView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: summary
    }, selectedColor && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($55728b847ff10d9a$export$d9d9ccbf5da84ba4, {
        "data-component-selector": "parent-switcher-epic-lozenge-wrapper",
        color: selectedColor
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($55728b847ff10d9a$var$LozengeWrapper, {
        "data-component-selector": "parent-switcher-epic-lozenge-wrapper",
        "data-testid": (0, $hVwWE.PARENT_SWITCHER_LOZENGE_TEST_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: summary,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $51HAN.getLozengeThemeByColor)(color),
        maxWidth: maxWidth,
        testId: "issue-field-parent-switcher.common.ui.epic-lozenge.lozenge"
    }, summary)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $55728b847ff10d9a$var$LozengeWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _4cvr1h6o _p12f1osq _vwz4kb7n _6ndb1osq",
            (0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') && "_1ksmjp4b",
            !(0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') && "_z6ua19ub",
            __cmplp.className
        ])
    });
});
const $55728b847ff10d9a$export$d9d9ccbf5da84ba4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $9t7rW.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1o9zidpf _1bsb7vkz _4t3i7vkz _2rko1l7b _11q71cj8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});

});



parcelRegister("hkD5e", function(module, exports) {

$parcel$export(module.exports, "LabelType", () => $f5b1f1fe00b5c13f$export$db162f9c7976a7ea);
$parcel$export(module.exports, "getLabelWidthMultiplier", () => $f5b1f1fe00b5c13f$export$f9a98c799935274d);

var $939HY = parcelRequire("939HY");
const $f5b1f1fe00b5c13f$export$db162f9c7976a7ea = {
    VERSION: 'version',
    EPIC: 'epic',
    STATUS: 'status'
};
const $f5b1f1fe00b5c13f$export$f9a98c799935274d = (labelType, containerWidth)=>{
    switch(containerWidth){
        case (0, $939HY.ScreenSize).EXTRA_SMALL:
            if (labelType === $f5b1f1fe00b5c13f$export$db162f9c7976a7ea.VERSION) return 3;
            if (labelType === $f5b1f1fe00b5c13f$export$db162f9c7976a7ea.EPIC) return 3;
            return 12.5;
        case (0, $939HY.ScreenSize).SMALL:
            if (labelType === $f5b1f1fe00b5c13f$export$db162f9c7976a7ea.VERSION) return 3;
            return 12.5;
        case (0, $939HY.ScreenSize).MEDIUM:
            return 18.75;
        case (0, $939HY.ScreenSize).LARGE:
            return 18.75;
        case (0, $939HY.ScreenSize).EXTRA_LARGE:
            return 25;
        default:
            return 12.5;
    }
};

});



parcelRegister("2KRYN", function(module, exports) {

$parcel$export(module.exports, "EstimateLite", () => $4800863232349265$export$30d0f48cab624df4);

var $eUqFw = parcelRequire("eUqFw");

var $7TyGu = parcelRequire("7TyGu");

var $1gQ73 = parcelRequire("1gQ73");

var $1ircG = parcelRequire("1ircG");

var $dysb4 = parcelRequire("dysb4");
const $4800863232349265$export$30d0f48cab624df4 = ({ shouldRenderEstimatesColumn: shouldRenderEstimatesColumn })=>{
    const estimationType = (0, $1gQ73.useBacklogSelector)((0, $1ircG.getEstimationType));
    if (estimationType !== (0, $7TyGu.ORIGINAL_ESTIMATE)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dysb4.default), {
        hasEstimate: shouldRenderEstimatesColumn,
        value: undefined
    });
};

});
parcelRegister("dysb4", function(module, exports) {

$parcel$export(module.exports, "default", () => $4df61dc7e32bc463$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $9nkwJ = parcelRequire("9nkwJ");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7v0hO = parcelRequire("7v0hO");

var $dNKdc = parcelRequire("dNKdc");

var $kKv6B = parcelRequire("kKv6B");
const $4df61dc7e32bc463$var$DEFAULT_NO_VALUE = '0m';
const $4df61dc7e32bc463$export$fdcfaf17c0796808 = ({ value: value, hasEstimate: hasEstimate, valueInSeconds: valueInSeconds, timeTrackingOptions: timeTrackingOptions })=>{
    const intl = (0, $5JgJ2.default)();
    if ((0, $1ybV0.ff)('sea-2524-backlog-card-estimates-a11y-improvements_1ljqi')) {
        const longFormValue = hasEstimate && valueInSeconds && timeTrackingOptions ? (0, $7v0hO.timeTrackingFormatterLongForm)(valueInSeconds, timeTrackingOptions, intl) : undefined;
        const ariaLabel = longFormValue ? `${intl.formatMessage((0, $kKv6B.default).originalEstimateAriaLabel)}: ${longFormValue}` : `${intl.formatMessage((0, $kKv6B.default).originalEstimateAriaLabel)}: ${intl.formatMessage((0, $kKv6B.default).originalEstimateAriaLabelNullValue)}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4df61dc7e32bc463$var$OriginalEstimateContainer, null, hasEstimate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dNKdc.default), {
            tooltipLabel: intl.formatMessage((0, $kKv6B.default).originalEstimateTooltip),
            ariaLabel: ariaLabel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4df61dc7e32bc463$var$OriginalEstimateWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
            appearance: "default"
        }, value ?? $4df61dc7e32bc463$var$DEFAULT_NO_VALUE))));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4df61dc7e32bc463$var$OriginalEstimateContainer, null, hasEstimate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4df61dc7e32bc463$var$OriginalEstimateWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
        appearance: "default"
    }, value ?? $4df61dc7e32bc463$var$DEFAULT_NO_VALUE)));
};
var $4df61dc7e32bc463$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($4df61dc7e32bc463$export$fdcfaf17c0796808);
const $4df61dc7e32bc463$var$OriginalEstimateWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1y6m _vchhusvi _19itj1ic _o5721q9c _80om73ad _1bsb1ns9 _1reo1kw7 _18m91kw7 _1ul9ys9h _ks4fys9h _1w7e18uv _z6uakb7n _18j015vq _d38j15vq _1sqt1q9c _14hh1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4df61dc7e32bc463$var$OriginalEstimateContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul9ys9h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9nkwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $00d99ab26ca06411$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $aG4Mw = parcelRequire("aG4Mw");
function $00d99ab26ca06411$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $00d99ab26ca06411$var$boxStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius.200',
    display: 'inline-flex',
    blockSize: 'min-content',
    flexShrink: 0 // Text component can wrap text, this ensures it doesn't wrap in flex containers.
});
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they should not change based on theme, and there are no appropriate color tokens.
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ const $00d99ab26ca06411$var$neutral300 = '#DDDEE1';
const $00d99ab26ca06411$var$red300 = '#FD9891';
const $00d99ab26ca06411$var$blue300 = '#8FB8F6';
const $00d99ab26ca06411$var$neutral1000 = '#292A2E';
const $00d99ab26ca06411$var$styles = {
    root: {
        name: "85bcg3",
        styles: "display:inline-flex;box-sizing:border-box;min-width:var(--ds-space-300, 24px);justify-content:center;flex-shrink:0;block-size:min-content;border-radius:var(--ds-border-radius-050, 2px);padding-inline:var(--ds-space-050, 4px)"
    },
    added: {
        name: "4x7cmh",
        styles: "background-color:var(--ds-background-success, #DCFFF1);color:var(--ds-text, #172B4D)"
    },
    default: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$neutral300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    important: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$red300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    primary: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$blue300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    primaryInverted: {
        name: "1425qmy",
        styles: "background-color:var(--ds-surface, #FFFFFF);color:var(--ds-text-brand, #0C66E4)"
    },
    removed: {
        name: "10hiq01",
        styles: "background-color:var(--ds-background-danger, #FFECEB);color:var(--ds-text, #172B4D)"
    }
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ const $00d99ab26ca06411$var$Badge = /*#__PURE__*/ (0, $eUqFw.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    if ((0, $XHGTv.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-testid": testId,
        css: [
            $00d99ab26ca06411$var$styles.root,
            $00d99ab26ca06411$var$styles[appearance]
        ],
        style: {
            background: style?.backgroundColor,
            color: style?.color
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        size: "small",
        align: "center",
        color: "inherit"
    }, typeof children === 'number' && max ? (0, $aG4Mw.formatValue)(children, max) : children));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        testId: testId,
        as: "span",
        backgroundColor: $00d99ab26ca06411$var$backgroundColors[appearance],
        xcss: $00d99ab26ca06411$var$boxStyles,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        paddingInline: "space.075"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        size: "UNSAFE_small",
        align: "center",
        color: style?.color ? 'inherit' : $00d99ab26ca06411$var$textColors[appearance]
    }, typeof children === 'number' && max ? (0, $aG4Mw.formatValue)(children, max) : children));
});
$00d99ab26ca06411$var$Badge.displayName = 'Badge';
var $00d99ab26ca06411$export$2e2bcd8739ae039 = $00d99ab26ca06411$var$Badge;
const $00d99ab26ca06411$var$backgroundColors = {
    added: 'color.background.success',
    default: 'color.background.neutral',
    important: 'color.background.danger.bold',
    primary: 'color.background.brand.bold',
    primaryInverted: 'elevation.surface',
    removed: 'color.background.danger'
};
const $00d99ab26ca06411$var$textColors = {
    added: 'color.text.success',
    default: 'color.text',
    important: 'color.text.inverse',
    primary: 'color.text.inverse',
    primaryInverted: 'color.text.brand',
    removed: 'color.text.danger'
};

});
parcelRegister("aG4Mw", function(module, exports) {

$parcel$export(module.exports, "formatValue", () => $a8e5bba3d913fce3$export$7c4d25c0c3217d8c);
function $a8e5bba3d913fce3$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $a8e5bba3d913fce3$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $a8e5bba3d913fce3$var$getSafeValue(value);
    const safeMax = $a8e5bba3d913fce3$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("dNKdc", function(module, exports) {

$parcel$export(module.exports, "default", () => $b79b2a8bd464241b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8cU5f = parcelRequire("8cU5f");

var $1ybV0 = parcelRequire("1ybV0");

var $30WDI = parcelRequire("30WDI");
const $b79b2a8bd464241b$var$EstimateFieldWrapper = ({ tooltipLabel: tooltipLabel, ariaLabel: ariaLabel, children: children, tooltipPosition: tooltipPosition = 'bottom' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b79b2a8bd464241b$var$EstimateFieldContainer, {
        role: "group",
        "aria-label": ariaLabel,
        "data-testid": (0, $30WDI.ESTIMATE_FIELD_WRAPPER_TEST_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: tooltipLabel,
        position: (0, $1ybV0.ff)('sea-2524-backlog-card-estimates-a11y-improvements_1ljqi') ? tooltipPosition : 'bottom'
    }, children));
var $b79b2a8bd464241b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($b79b2a8bd464241b$var$EstimateFieldWrapper);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b79b2a8bd464241b$var$EstimateFieldContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("kKv6B", function(module, exports) {

$parcel$export(module.exports, "default", () => $83af3d01b8c5dad6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $83af3d01b8c5dad6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    originalEstimateTooltip: {
        "id": "backlog.card-list.card.card-contents.original-estimate-field.original-estimate-tooltip",
        "defaultMessage": "Original estimate"
    },
    originalEstimateAriaLabel: {
        "id": "backlog.card-list.card.card-contents.original-estimate-field.original-estimate-aria-label",
        "defaultMessage": "Original estimate"
    },
    originalEstimateAriaLabelNullValue: {
        "id": "backlog.card-list.card.card-contents.original-estimate-field.original-estimate-aria-label-null-value",
        "defaultMessage": "No estimate set"
    },
    invalidTimeFormatMessage: {
        "id": "backlog.card-list.card.card-contents.original-estimate-field.invalid-time-format-message",
        "defaultMessage": "Your estimate must be in the format {format}."
    }
});

});



parcelRegister("8s89S", function(module, exports) {

$parcel$export(module.exports, "Flag", () => $cefb50f9c3b458ca$export$48ea269755562084);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8urXR = parcelRequire("8urXR");

var $PdmhA = parcelRequire("PdmhA");
const $cefb50f9c3b458ca$export$48ea269755562084 = ({ shouldRenderInlineAddFlag: shouldRenderInlineAddFlag, isFlagged: isFlagged })=>{
    const inlineFlag = shouldRenderInlineAddFlag ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cefb50f9c3b458ca$var$FlagPlaceHolder, null) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cefb50f9c3b458ca$var$FlagContainer, null, isFlagged ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8urXR))), {
        size: "small",
        primaryColor: `var(--ds-icon-danger, ${(0, $PdmhA).R300})`,
        label: "Flagged icon"
    }) : inlineFlag);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cefb50f9c3b458ca$var$FlagContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1pbykb7n",
            __cmplp.className
        ])
    });
});
const $cefb50f9c3b458ca$var$FlagPlaceHolder = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb7vkz _4t3i1tcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8urXR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $62e6d140d6f5090f$var$_react = $62e6d140d6f5090f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $62e6d140d6f5090f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $62e6d140d6f5090f$var$FlagFilledIcon = (props)=>/*#__PURE__*/ $62e6d140d6f5090f$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M6 12.235v6.446c0 .537.45.977 1 .977s1-.44 1-.977v-5.778c1.17-.341 2.389-.045 3.768.29.982.238 2.036.495 3.13.495a5.73 5.73 0 002.547-.567 1 1 0 00.563-.9V5.466a.998.998 0 00-1.437-.9c-1.345.654-2.731.317-4.331-.071-1.729-.42-3.687-.895-5.678.072A1 1 0 006 5.466v6.769z" fill="currentColor"/></svg>`
    }, props));
$62e6d140d6f5090f$var$FlagFilledIcon.displayName = 'FlagFilledIcon';
var $62e6d140d6f5090f$var$_default = $62e6d140d6f5090f$var$FlagFilledIcon;
module.exports.default = $62e6d140d6f5090f$var$_default;

});


parcelRegister("lKnUS", function(module, exports) {

$parcel$export(module.exports, "Mentions", () => $5f416c32df4c465d$export$34c5aae84beabfeb);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $caTc0 = parcelRequire("caTc0");
const $5f416c32df4c465d$export$34c5aae84beabfeb = ()=>{
    const renderEmptyMentions = (0, $caTc0.isInMentionsIndicatorExperimentCohort)();
    return renderEmptyMentions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $5f416c32df4c465d$var$mentionsIndicatorStyles
    }) : null;
};
const $5f416c32df4c465d$var$mentionsIndicatorStyles = (0, $1ZAYh.xcss)({
    width: "var(--ds-space-300, 1.5rem)"
});

});

parcelRegister("3VLYl", function(module, exports) {

$parcel$export(module.exports, "PriorityLite", () => $69e3eb2dbe9ffe9a$export$919bb9d97260bc8d);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $kmr29 = parcelRequire("kmr29");

var $lO4Or = parcelRequire("lO4Or");

var $1zGZQ = parcelRequire("1zGZQ");

var $6vfDT = parcelRequire("6vfDT");
const $69e3eb2dbe9ffe9a$export$919bb9d97260bc8d = ({ issueKey: issueKey, shouldRenderPriorityColumn: shouldRenderPriorityColumn })=>{
    const [priorityFieldValue] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $lO4Or.PRIORITY_TYPE)
    });
    // Matching src/packages/software/backlog/src/view/card-list/card/card-contents/priority-field/index.tsx
    if (!shouldRenderPriorityColumn) return null;
    const hasPriority = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(priorityFieldValue) && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(priorityFieldValue.name) && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(priorityFieldValue.iconUrl);
    const priorityFieldStatic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zGZQ.StaticPriorityFieldWrapper), {
        shouldRenderColumn: shouldRenderPriorityColumn
    }, hasPriority ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6vfDT.default), {
        name: priorityFieldValue.name,
        iconUrl: priorityFieldValue.iconUrl
    }) : null);
    return priorityFieldStatic;
};

});
parcelRegister("1zGZQ", function(module, exports) {

$parcel$export(module.exports, "StaticPriorityFieldWrapper", () => $8cac4c0998deebb2$export$82aa3dc89c56ae53);
$parcel$export(module.exports, "default", () => $8cac4c0998deebb2$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $ldoFd = parcelRequire("ldoFd");

var $7rh0R = parcelRequire("7rh0R");

var $c9TLT = parcelRequire("c9TLT");

var $kmr29 = parcelRequire("kmr29");

var $fZO6y = parcelRequire("fZO6y");

var $lO4Or = parcelRequire("lO4Or");

var $8WuJm = parcelRequire("8WuJm");


var $diedG = parcelRequire("diedG");

var $6vfDT = parcelRequire("6vfDT");

const $8cac4c0998deebb2$var$PriorityChipFieldLazy = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("3Gfcn")).then(({ PriorityChipField: PriorityChipField })=>PriorityChipField), {
    moduleId: "./src/packages/issue/fields/priority-chip/src/index.tsx"
});
const $8cac4c0998deebb2$var$PriorityField = ({ isUserAtLeastMember: isUserAtLeastMember, shouldRenderRichCard: shouldRenderRichCard, issueKey: issueKey, shouldRenderColumn: shouldRenderColumn })=>{
    const [priorityFieldValue] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $lO4Or.PRIORITY_TYPE)
    });
    // Do not render the priority column if no card on backlog has priority
    if (!shouldRenderColumn && ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(priorityFieldValue) || !priorityFieldValue.name || !priorityFieldValue.iconUrl)) return null;
    const hasPriority = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(priorityFieldValue) && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(priorityFieldValue.name) && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(priorityFieldValue.iconUrl);
    const priorityFieldStatic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8cac4c0998deebb2$export$82aa3dc89c56ae53, {
        shouldRenderColumn: shouldRenderColumn
    }, hasPriority ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6vfDT.default), {
        name: priorityFieldValue.name,
        iconUrl: priorityFieldValue.iconUrl
    }) : null);
    if (isUserAtLeastMember && shouldRenderRichCard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fZO6y.PriorityChipFieldBoundary), {
        packageName: (0, $e1409a6fc345c0d8$export$dfd208682d29484c),
        fallback: priorityFieldStatic
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $diedG.default), {
        experienceTarget: (0, $lO4Or.PRIORITY_TYPE),
        experienceTargetId: issueKey,
        additionalAttributes: {
            issueKey: issueKey
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8cac4c0998deebb2$var$PriorityFieldWrapper, {
        shouldRenderColumn: shouldRenderColumn
    }, hasPriority ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: {
            isInlineEditing: true
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8cac4c0998deebb2$var$PriorityChipFieldLazy, {
        issueKey: issueKey
    })) : null)));
    return priorityFieldStatic;
};
var $8cac4c0998deebb2$export$2e2bcd8739ae039 // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
 = /*#__PURE__*/ (0, $eUqFw.memo)($8cac4c0998deebb2$var$PriorityField);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8cac4c0998deebb2$var$PriorityFieldWrapper = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-178nh9s-0"
})`position:relative;display:flex;align-items:center;cursor:default;min-width:${({ shouldRenderColumn: shouldRenderColumn })=>shouldRenderColumn ? `${(0, $c9TLT.gridSize) * 3}px` : null};max-width:${({ shouldRenderColumn: shouldRenderColumn })=>shouldRenderColumn ? `${(0, $c9TLT.gridSize) * 3}px` : null};& > button + div{position:absolute !important;top:${"var(--ds-space-400, 32px)"} !important;left:auto !important;right:${"var(--ds-space-negative-025, -2px)"} !important;transform:none !important;}&:focus,&:focus-within{outline:none;}`;
const $8cac4c0998deebb2$export$82aa3dc89c56ae53 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldRenderColumn: shouldRenderColumn, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.shouldRenderColumn && "_1ul91tcg _p12f1tcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fZO6y", function(module, exports) {

$parcel$export(module.exports, "PriorityChipFieldBoundary", () => $88436b5a48494e87$export$9d18c32154d1536);

var $eUqFw = parcelRequire("eUqFw");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");
const $88436b5a48494e87$export$9d18c32154d1536 = ({ children: children, fallback: fallback, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue-priority-chip",
        packageName: packageName,
        render: ()=>fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-priority-chip-boundary",
        fallback: fallback
    }, children));

});

parcelRegister("6vfDT", function(module, exports) {

$parcel$export(module.exports, "default", () => $087216ba02c6aa19$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2VZjS = parcelRequire("2VZjS");
const $087216ba02c6aa19$export$2ccb5d74629a741d = ({ name: name, iconUrl: iconUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2VZjS.PriorityChipRead), {
        name: name,
        iconUrl: iconUrl
    });
var $087216ba02c6aa19$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($087216ba02c6aa19$export$2ccb5d74629a741d);

});
parcelRegister("2VZjS", function(module, exports) {

$parcel$export(module.exports, "PriorityChipRead", () => $261eb81bcd133e70$export$92ecdadfd000de84);

var $eUqFw = parcelRequire("eUqFw");

var $l64Qu = parcelRequire("l64Qu");
const $261eb81bcd133e70$export$92ecdadfd000de84 = ({ name: name, iconUrl: iconUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l64Qu.PriorityIcon), {
        name: name,
        iconUrl: iconUrl
    });

});
parcelRegister("l64Qu", function(module, exports) {

$parcel$export(module.exports, "PriorityIcon", () => $b17c804e708217eb$export$3abf8cb3bcb0225);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8cU5f = parcelRequire("8cU5f");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bnOC6 = parcelRequire("bnOC6");
const $b17c804e708217eb$export$3abf8cb3bcb0225 = ({ name: name, iconUrl: iconUrl })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    let priorityName = name;
    if ((0, $1ybV0.ff)('sea-2830-improve-accessibility-of-priority-field-in-backlog-card_k53tq')) priorityName = formatMessage((0, $bnOC6.default).priorityTooltip, {
        name: name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: priorityName,
        testId: "issue-field-priority-chip.common.ui.priority-icon.tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b17c804e708217eb$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b17c804e708217eb$export$f04a61298a47a40f, {
        alt: priorityName,
        src: iconUrl
    })));
};
const $b17c804e708217eb$export$be58b4326e23250f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1e0c1txw _1bah1h6o _4t3i1tcg _1bsb1tcg",
            __cmplp.className
        ])
    });
});
const $b17c804e708217eb$export$f04a61298a47a40f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3if6fq _1bsbf6fq _s7n41ndm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bnOC6", function(module, exports) {

$parcel$export(module.exports, "default", () => $4333b688ef8b66b8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4333b688ef8b66b8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    priorityTooltip: {
        "id": "issue-field-priority-chip.common.priority-icon.priority-tooltip",
        "defaultMessage": "Priority: {name}"
    }
});

});




parcelRegister("3Gfcn", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('k4eAC');
        const value = parcelRequire('8otT7');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("k4eAC").then(()=>parcelRequire('8otT7'));
}

});



parcelRegister("gKCwa", function(module, exports) {

$parcel$export(module.exports, "Status", () => $6fdf5e0393d58801$export$96e9906d6d93a972);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $c9TLT = parcelRequire("c9TLT");

var $8MrYx = parcelRequire("8MrYx");

var $1gQ73 = parcelRequire("1gQ73");

var $8ZI73 = parcelRequire("8ZI73");

var $hkD5e = parcelRequire("hkD5e");

var $6Avyn = parcelRequire("6Avyn");
const $6fdf5e0393d58801$export$96e9906d6d93a972 = ({ cardKey: cardKey, backlogContainerSize: backlogContainerSize })=>{
    const isUserAtLeastMember = (0, $1gQ73.useBacklogSelector)((0, $8ZI73.isUserAtLeastMemberOfProject));
    const showStatuses = (0, $8MrYx.useShowStatuses)();
    return showStatuses ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6fdf5e0393d58801$var$StatusContainer, {
        widthMultiplier: (0, $hkD5e.getLabelWidthMultiplier)((0, $hkD5e.LabelType).STATUS, backlogContainerSize)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Avyn.StatusLite), {
        isUserAtLeastMember: isUserAtLeastMember,
        issueKey: cardKey
    })) : null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6fdf5e0393d58801$var$StatusContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { widthMultiplier: widthMultiplier, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_uu7jbp": (0, $9t7rW.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `repeat(auto-fit,${(0, $c9TLT.gridSize) * __cmplp.widthMultiplier}px)`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c11p5 _4t3i1tcg _lcxvglyw _1reo1kw7 _18m91kw7 _yv0e105t",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6Avyn", function(module, exports) {

$parcel$export(module.exports, "StatusLite", () => $7cea772e382363b4$export$8c32e03375f9b492);

var $eUqFw = parcelRequire("eUqFw");

var $aXGkF = parcelRequire("aXGkF");

var $ldoFd = parcelRequire("ldoFd");

var $8Qd0L = parcelRequire("8Qd0L");

var $kmr29 = parcelRequire("kmr29");


var $2N3Im = parcelRequire("2N3Im");
const $7cea772e382363b4$export$8c32e03375f9b492 = ({ issueKey: issueKey, isUserAtLeastMember: isUserAtLeastMember })=>{
    const [statusFieldValue] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $ebc098a76317be78$export$4420b7468f889692)
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(statusFieldValue) || !statusFieldValue.id || !statusFieldValue.name) return null;
    const value = {
        id: statusFieldValue.id,
        name: statusFieldValue.name,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        category: (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))((0, $8Qd0L.StatusCategoryIds))[statusFieldValue.statusCategory.id] || (0, $8Qd0L.StatusCategoryTypes).UNDEFINED
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2N3Im.default), {
        isUserAtLeastMember: isUserAtLeastMember,
        value: value
    });
};

});
parcelRegister("2N3Im", function(module, exports) {

$parcel$export(module.exports, "default", () => $941d36e9f95c7136$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5iWql = parcelRequire("5iWql");

var $2ziLQ = parcelRequire("2ziLQ");

var $ffiyv = parcelRequire("ffiyv");

var $kjXsi = parcelRequire("kjXsi");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5lqRP = parcelRequire("5lqRP");

var $gREse = parcelRequire("gREse");
const $941d36e9f95c7136$export$5aa9263ebcef0dab = ({ isUserAtLeastMember: isUserAtLeastMember, value: { name: name, category: category } })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const ChevronDownGlyph = (0, $5iWql.default)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
            width: 12,
            height: 12,
            viewBox: "5 5 13 13"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
            d: "M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z",
            fill: "currentColor",
            fillRule: "evenodd"
        })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($941d36e9f95c7136$var$StaticLozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kjXsi.ScreenReaderText), null, formatMessage((0, $5lqRP.default).statusLozenge)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: (0, $gREse.getStatusAppearance)(category)
    }, isUserAtLeastMember ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($941d36e9f95c7136$var$StaticLozengeContentWrapper, null, name, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: ChevronDownGlyph,
        label: ""
    })) : name));
};
var $941d36e9f95c7136$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($941d36e9f95c7136$export$5aa9263ebcef0dab);
const $941d36e9f95c7136$var$StaticLozengeContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _1e0c1o8l _4cvr1h6o _1bto1l2s _o5721q9c _1reo15vq _18m915vq",
            (0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') && "_s7n4jp4b",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $941d36e9f95c7136$var$StaticLozengeWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bto1l2s _o5721q9c _1reo15vq _18m915vq _172pidpf _1hcdidpf _1oyyidpf _19h8idpf",
            (0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') ? "_1npcyh40 _1gicyh40 _1e09yh40 _1mspyh40" : "_7qvs1nxw",
            (0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') ? "_1esrotz2" : "_1esru49m",
            !(0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') && "_h6q3kb7n",
            (0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') && "_1r9u1vlj",
            (0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') && "_26sd1fw0",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5lqRP", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd0d4513c8d47a07$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $cd0d4513c8d47a07$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    statusLozenge: {
        "id": "backlog.card-list.card.card-contents.status-field.status-field-static.status-lozenge",
        "defaultMessage": "status"
    }
});

});

parcelRegister("gREse", function(module, exports) {

$parcel$export(module.exports, "getStatusAppearance", () => $8183c207705e5f4f$export$548966735f47dde3);

var $8Qd0L = parcelRequire("8Qd0L");

var $aACMj = parcelRequire("aACMj");
const $8183c207705e5f4f$export$548966735f47dde3 = (statusCategory)=>{
    const { default: defaultAppearance, inprogress: inprogress, success: success } = (0, $aACMj.LOZENGE_APPEARANCE);
    const StatusCategoryAppearances = Object.freeze({
        [(0, $8Qd0L.StatusCategoryTypes).UNDEFINED]: defaultAppearance,
        [(0, $8Qd0L.StatusCategoryTypes).NEW]: defaultAppearance,
        [(0, $8Qd0L.StatusCategoryTypes).DONE]: success,
        [(0, $8Qd0L.StatusCategoryTypes).INDETERMINATE]: inprogress
    });
    return StatusCategoryAppearances[statusCategory] || defaultAppearance;
};

});
parcelRegister("aACMj", function(module, exports) {

$parcel$export(module.exports, "LOZENGE_APPEARANCE", () => $fecd3763a4a086a2$export$7e4a71985d57222c);
$parcel$export(module.exports, "CARD_CONTAINER_SELECTOR_NAME", () => $fecd3763a4a086a2$export$7608524551986a84);
$parcel$export(module.exports, "CARD_CONTAINER_SELECTOR", () => $fecd3763a4a086a2$export$fb374ae0d58ab29b);
$parcel$export(module.exports, "COLUMN_TITLE_SELECTOR_NAME", () => $fecd3763a4a086a2$export$c2a2d9d97661439b);
$parcel$export(module.exports, "COLUMN_TITLE_LOZENGES_SELECTOR_NAME", () => $fecd3763a4a086a2$export$675d25966b2d2499);
$parcel$export(module.exports, "COLUMN_WRAPPER_FORM_SELECTOR_NAME", () => $fecd3763a4a086a2$export$6c814df87e7543d5);
$parcel$export(module.exports, "DRAGGABLE_COLUMN_SELECTOR_NAME", () => $fecd3763a4a086a2$export$4167d13afb6ba84b);
$parcel$export(module.exports, "DRAGGABLE_COLUMN_SELECTOR", () => $fecd3763a4a086a2$export$9d54b3872a1af680);
$parcel$export(module.exports, "UPDATE_BOARD_SCROLL_POSITION", () => $fecd3763a4a086a2$export$d339f9637e1ca3b4);
$parcel$export(module.exports, "DATA_ANNOUNCED_IGNORE_DND_TYPE", () => $fecd3763a4a086a2$export$e1beb09058b7dca1);
$parcel$export(module.exports, "DATA_ANNOUNCED_COLUMN_HEADER", () => $fecd3763a4a086a2$export$eb11bcee172fa7de);
$parcel$export(module.exports, "DATA_ANNOUNCED_CARD_HEADER", () => $fecd3763a4a086a2$export$f06ed7eae652ab20);
$parcel$export(module.exports, "BoardView", () => $fecd3763a4a086a2$export$373e09b633948dc);

const $fecd3763a4a086a2$export$7e4a71985d57222c = {
    default: 'default',
    inprogress: 'inprogress',
    moved: 'moved',
    new: 'default',
    removed: 'removed',
    success: 'success'
};
const $fecd3763a4a086a2$export$7608524551986a84 = 'platform-board-kit.ui.card-container';
const $fecd3763a4a086a2$export$fb374ae0d58ab29b = `[data-component-selector="${$fecd3763a4a086a2$export$7608524551986a84}"]`;
const $fecd3763a4a086a2$export$c2a2d9d97661439b = 'platform-board-kit.ui.column-title';
const $fecd3763a4a086a2$export$bb13afdd2dbe0316 = `[data-component-selector="${$fecd3763a4a086a2$export$c2a2d9d97661439b}"]`;
const $fecd3763a4a086a2$export$675d25966b2d2499 = 'platform-board-kit.ui.column-title.lozenges';
const $fecd3763a4a086a2$export$1be96bcf0abb2b8e = `[data-component-selector="${$fecd3763a4a086a2$export$675d25966b2d2499}"]`;
const $fecd3763a4a086a2$export$6c814df87e7543d5 = 'platform-board-kit.ui.column.column-create.form.column-wrapper';
const $fecd3763a4a086a2$export$4167d13afb6ba84b = 'platform-board-kit.ui.column.draggable-column';
const $fecd3763a4a086a2$export$9d54b3872a1af680 = `[data-component-selector="${$fecd3763a4a086a2$export$4167d13afb6ba84b}"]`;
const $fecd3763a4a086a2$export$d339f9637e1ca3b4 = 'update-board-scroll-position';
const $fecd3763a4a086a2$export$e1beb09058b7dca1 = 'data-announced-ignore-dnd-type';
const $fecd3763a4a086a2$export$eb11bcee172fa7de = 'data-announced-column-header';
const $fecd3763a4a086a2$export$f06ed7eae652ab20 = 'data-announced-card-header';
const $fecd3763a4a086a2$export$373e09b633948dc = {
    JSW_BOARD: 'jsw-board',
    INCREMENT_PLANNING_BOARD: 'increment-planning-board',
    JSM_BOARD: 'jsm-board'
};

});





parcelRegister("6Idg8", function(module, exports) {

$parcel$export(module.exports, "StoryPointLite", () => $0caae3f226028bd0$export$314bcc76f8a35673);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $kmr29 = parcelRequire("kmr29");

var $5JDKI = parcelRequire("5JDKI");

var $8wXFi = parcelRequire("8wXFi");

var $7TyGu = parcelRequire("7TyGu");

var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $1ircG = parcelRequire("1ircG");

var $kLeWy = parcelRequire("kLeWy");
const $0caae3f226028bd0$export$314bcc76f8a35673 = ({ issue: issue })=>{
    const estimationType = (0, $1gQ73.useBacklogSelector)((0, $1ircG.getEstimationType));
    const shouldRenderStoryPointColumn = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.backlogHasStoryPoints));
    const storyPointFieldId = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getStoryPointFieldId));
    const storyPointKey = storyPointFieldId || '';
    const [storyPointFieldValue] = (0, $kmr29.useFieldValue)({
        issueKey: issue.key,
        fieldKey: storyPointKey
    });
    const hasEstimate = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(issue.estimate);
    if (!shouldRenderStoryPointColumn && (!storyPointKey || estimationType !== (0, $7TyGu.STORY_POINTS))) return null;
    const issueStoryPointFieldStatic = (0, $8wXFi.isNewInlineEditEstimateComponentsEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5JDKI.NumberReadView), {
        isEditable: false,
        value: storyPointFieldValue
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kLeWy.default), {
        value: storyPointFieldValue ?? undefined,
        hasStoryPoints: hasEstimate,
        shouldRenderStoryPointColumn: shouldRenderStoryPointColumn
    });
    return issueStoryPointFieldStatic;
};

});
parcelRegister("5JDKI", function(module, exports) {

$parcel$export(module.exports, "NumberReadView", () => $2a11a4b3f97417f6$export$9267d0b69e52e344);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $9nkwJ = parcelRequire("9nkwJ");

var $5JgJ2 = parcelRequire("5JgJ2");

const $2a11a4b3f97417f6$var$noValueText = '-';
const $2a11a4b3f97417f6$export$9267d0b69e52e344 = ({ isEditable: isEditable, value: value, setIsEditing: setIsEditing })=>{
    const { formatNumber: formatNumber } = (0, $5JgJ2.default)();
    const handleOnClick = (0, $eUqFw.useCallback)(()=>{
        setIsEditing && setIsEditing(true);
    }, [
        setIsEditing
    ]);
    const displayValue = !value ? $2a11a4b3f97417f6$var$noValueText : formatNumber(value);
    const BadgeComp = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
        testId: (0, $e635c523bd699859$export$faee1a1fc8a5b736)
    }, displayValue);
    const BadgeComponent = isEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2a11a4b3f97417f6$var$HoverContainer, {
        "data-testid": (0, $e635c523bd699859$export$b9b94e65b89d20fd),
        onClick: handleOnClick
    }, BadgeComp) : BadgeComp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2a11a4b3f97417f6$var$BadgeWrapper, {
        "data-testId": (0, $e635c523bd699859$export$3f079ba078400398)
    }, BadgeComponent);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a11a4b3f97417f6$var$HoverContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_80omtlke _1lgibn51",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a11a4b3f97417f6$var$BadgeWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19itj1ic",
            __cmplp.className
        ])
    });
});

});
const $e635c523bd699859$export$faee1a1fc8a5b736 = 'issue-field-number-inline-edit-readview.ui.badge';
const $e635c523bd699859$export$b9b94e65b89d20fd = 'issue-field-number-inline-edit-readview.ui.hover-container';
const $e635c523bd699859$export$3f079ba078400398 = 'issue-field-number-inline-edit-readview.ui.wrapper';


parcelRegister("kLeWy", function(module, exports) {

$parcel$export(module.exports, "default", () => $7eddcf04c922ff9f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ldoFd = parcelRequire("ldoFd");

var $9nkwJ = parcelRequire("9nkwJ");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dU01J = parcelRequire("dU01J");

var $dNKdc = parcelRequire("dNKdc");
const $7eddcf04c922ff9f$var$DEFAULT_NO_VALUE = '-';
const $7eddcf04c922ff9f$export$fdd6fddc555f3cc5 = ({ value: value, hasStoryPoints: hasStoryPoints, shouldRenderStoryPointColumn: shouldRenderStoryPointColumn })=>{
    const { formatNumber: formatNumber, formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if ((0, $1ybV0.ff)('sea-2524-backlog-card-estimates-a11y-improvements_1ljqi')) {
        const ariaLabelWithValue = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value) ? `${formatMessage((0, $dU01J.default).storyPointsAriaLabel)}: ${formatNumber(value)}` : formatMessage((0, $dU01J.default).storyPointsAriaLabelNullValue);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7eddcf04c922ff9f$var$StoryPointWrapper, {
            shouldRenderStoryPointColumn: shouldRenderStoryPointColumn
        }, hasStoryPoints && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dNKdc.default), {
            tooltipLabel: formatMessage((0, $dU01J.default).storyPointsTooltip),
            ariaLabel: ariaLabelWithValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7eddcf04c922ff9f$var$StoryPointContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
            appearance: "default"
        }, !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value) ? formatNumber(value) : $7eddcf04c922ff9f$var$DEFAULT_NO_VALUE))));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7eddcf04c922ff9f$var$StoryPointWrapper, {
        shouldRenderStoryPointColumn: shouldRenderStoryPointColumn
    }, hasStoryPoints && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7eddcf04c922ff9f$var$StoryPointContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
        appearance: "default"
    }, !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value) ? formatNumber(value) : $7eddcf04c922ff9f$var$DEFAULT_NO_VALUE)));
};
var $7eddcf04c922ff9f$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($7eddcf04c922ff9f$export$fdd6fddc555f3cc5);
const $7eddcf04c922ff9f$var$StoryPointWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldRenderStoryPointColumn: shouldRenderStoryPointColumn, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _2lx21bp4 _4cvr1h6o _vchhusvi _o5721q9c _80om73ad",
            !(0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') && "_n7zlj1ic",
            (0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') && "_vwz4kb7n",
            __cmplp.shouldRenderStoryPointColumn && "_1reo1kw7 _18m91kw7 _1bsb1ns9 _1ul91shb _p12f1shb _ks4f1shb _1w7e1ule _18j015vq _d38j15vq _1sqt1q9c _14hh1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7eddcf04c922ff9f$var$StoryPointContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});

});


parcelRegister("lLcUL", function(module, exports) {

$parcel$export(module.exports, "Versions", () => $2a02d39965b688e7$export$4893a37082435e75);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $8MrYx = parcelRequire("8MrYx");

var $hkD5e = parcelRequire("hkD5e");

var $iazUW = parcelRequire("iazUW");
const $2a02d39965b688e7$export$4893a37082435e75 = ({ card: card, isCompanyManaged: isCompanyManaged, backlogContainerSize: backlogContainerSize, isCardListContainsVersion: isCardListContainsVersion })=>{
    const shouldDisplayVersions = isCompanyManaged && isCardListContainsVersion;
    const showVersions = (0, $8MrYx.useShowVersions)();
    if (shouldDisplayVersions && showVersions) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2a02d39965b688e7$var$VersionsContainer, {
        widthMultiplier: (0, $hkD5e.getLabelWidthMultiplier)((0, $hkD5e.LabelType).VERSION, backlogContainerSize)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iazUW.VersionsField), {
        cardId: card.id,
        backlogContainerSize: backlogContainerSize
    }));
    return null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a02d39965b688e7$var$VersionsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { widthMultiplier: widthMultiplier, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ewl67i": (0, $9t7rW.default)(`repeat(auto-fit, calc(${"var(--ds-space-100, 8px)"} * ${__cmplp.widthMultiplier}))`),
            "--_1qtnkr6": (0, $9t7rW.default)(`calc(${"var(--ds-space-100, 8px)"} * ${__cmplp.widthMultiplier})`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c11p5 _1pbykb7n _1reo15vq _18m915vq _1bto1l2s _4cvr1h6o _6a6zv2br _lcxvglyw _yv0epq74 _1ul9dike",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iazUW", function(module, exports) {

$parcel$export(module.exports, "VersionsField", () => $cf34bc2638cdfa29$export$5413999baebac1f7);

var $eUqFw = parcelRequire("eUqFw");

var $14lY4 = parcelRequire("14lY4");

var $ffiyv = parcelRequire("ffiyv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1gQ73 = parcelRequire("1gQ73");

var $bP7Jx = parcelRequire("bP7Jx");

var $939HY = parcelRequire("939HY");

var $5WFzC = parcelRequire("5WFzC");

var $eSvmB = parcelRequire("eSvmB");
function $cf34bc2638cdfa29$export$5413999baebac1f7({ cardId: cardId, backlogContainerSize: backlogContainerSize }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const versions = (0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.cardVersionsSelector)(state, cardId));
    const tooltipText = (0, $eUqFw.useMemo)(()=>versions.map((version)=>version.name).join(', '), [
        versions
    ]);
    const text = (0, $eUqFw.useMemo)(()=>versions.length === 1 ? versions[0].name : formatMessage((0, $eSvmB.messages).text, {
            count: versions.length
        }), [
        formatMessage,
        versions
    ]);
    if (!versions.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $cf34bc2638cdfa29$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: tooltipText
    }, backlogContainerSize === (0, $939HY.ScreenSize).EXTRA_SMALL || backlogContainerSize === (0, $939HY.ScreenSize).SMALL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.VersionIconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($14lY4))), {
        primaryColor: `var(--ds-text-subtlest, ${(0, $PdmhA).N200})`,
        size: "small",
        label: "version icon"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.VersionIconNumber), null, versions.length)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, text)));
}
const $cf34bc2638cdfa29$var$containerStyles = (0, $1ZAYh.xcss)({
    maxWidth: '100%',
    pointerEvents: 'all'
});

});
parcelRegister("eSvmB", function(module, exports) {

$parcel$export(module.exports, "messages", () => $eb58983af6ffdb8f$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $eb58983af6ffdb8f$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    text: {
        "id": "backlog.card-list.card.card-contents.versions-field.text",
        "defaultMessage": "{count} versions"
    },
    ariaLabel: {
        "id": "backlog.card-list.card.card-contents.versions-field.aria-label",
        "defaultMessage": "{versions} {count, plural, one {version} other {versions}}"
    }
});

});




parcelRegister("24NDc", function(module, exports) {

$parcel$export(module.exports, "default", () => $f02f0559be923b4e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7TyGu = parcelRequire("7TyGu");

var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");

var $1lsov = parcelRequire("1lsov");

var $bP7Jx = parcelRequire("bP7Jx");

var $8ZI73 = parcelRequire("8ZI73");

var $dtV8v = parcelRequire("dtV8v");

var $2uOPI = parcelRequire("2uOPI");
const $f02f0559be923b4e$export$7b43361c37f3a9e7 = (cardListType)=>cardListType !== (0, $7TyGu.BACKLOG);
function $f02f0559be923b4e$var$ConnectedCardWithIccWrapperInner(props) {
    const { cardId: cardId, cardListId: cardListId, isAttachedToParent: isAttachedToParent, forciblyRenderRichCard: forciblyRenderRichCard, setRichActiveCard: setRichActiveCard } = props;
    // Redux hook
    const cardList = (0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.getCardLists)(state)[cardListId]);
    // Check if the card is not in the backlog (we don't show status lozenges in the backlog)
    const canShowStatusLozengeOnCards = $f02f0559be923b4e$export$7b43361c37f3a9e7(cardList.type);
    const visibleCardIds = (0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.makeGetVisibleCardOrderFromCardEntries)(state)(cardListId));
    // cards that are being hidden by the filter will have index -1.
    // Dnd does not officially support this but it works fine.
    const draggableIndex = visibleCardIds.indexOf(cardId);
    const isActiveSprint = (0, $1gQ73.useBacklogSelector)((state)=>(0, $dtV8v.makeIsCardListActiveSprint)(state)(cardListId));
    const isIccEnabled = (0, $1gQ73.useBacklogSelector)((state)=>!(0, $hkGxG.getIsCompanyManaged)(state) && (0, $8ZI73.isInlineIssueCreateAvailableForCurrentUser)(state) && (0, $bP7Jx.hasCardTypesSelector)(state));
    const isVisible = (0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.makeIsCardVisible)(state)(cardId));
    const shouldRenderRichCard = (0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.shouldRenderRichElements)(state, {
            cardId: cardId
        })) || forciblyRenderRichCard === true;
    const hasIccOpen = (0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.hasICCOpen)(state, {
            cardId: cardId
        }));
    // This will be defined if this card is a parent of a card group
    const cardGroup = (0, $1gQ73.useBacklogSelector)((0, $1lsov.makeGetCardGroupByParentId))(cardListId, cardId);
    const subtaskIds = cardGroup && cardGroup.cardIds;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2uOPI.CardWithIccWrapper), {
        ...props,
        isVisible: isVisible,
        shouldRenderRichCard: shouldRenderRichCard,
        hasIccOpen: hasIccOpen,
        setRichActiveCard: setRichActiveCard,
        isIccEnabled: isIccEnabled,
        draggableIndex: draggableIndex,
        isActiveSprint: isActiveSprint,
        canShowStatusLozengeOnCards: canShowStatusLozengeOnCards,
        isAttachedToParent: isAttachedToParent,
        subtaskIds: subtaskIds
    });
}
const $f02f0559be923b4e$var$ConnectedCardWithIccWrapper = /*#__PURE__*/ (0, $eUqFw.memo)($f02f0559be923b4e$var$ConnectedCardWithIccWrapperInner);
var $f02f0559be923b4e$export$2e2bcd8739ae039 = $f02f0559be923b4e$var$ConnectedCardWithIccWrapper;

});
parcelRegister("2uOPI", function(module, exports) {

$parcel$export(module.exports, "CardWithIccWrapper", () => $5547b5b54220ec90$export$55a2755069cf4bed);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");

var $hKj4G = parcelRequire("hKj4G");

var $dkPd7 = parcelRequire("dkPd7");

var $9pBAl = parcelRequire("9pBAl");

var $eLoNC = parcelRequire("eLoNC");

var $5qDf1 = parcelRequire("5qDf1");

var $k9j9y = parcelRequire("k9j9y");
const $5547b5b54220ec90$var$CardWithIccWrapperInner = ({ cardId: cardId, cardListId: cardListId, isVisible: isVisible, shouldRenderRichCard: shouldRenderRichCard, hasIccOpen: hasIccOpen, setRichActiveCard: setRichActiveCard, isIccEnabled: isIccEnabled, draggableIndex: draggableIndex, canShowStatusLozengeOnCards: canShowStatusLozengeOnCards, isAttachedToParent: isAttachedToParent, subtaskIds: subtaskIds })=>{
    const containerRef = (0, $eUqFw.useRef)(null);
    const hasRenderedRichElements = (0, $eUqFw.useRef)(false);
    const pendingHoverAction = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>()=>clearTimeout(pendingHoverAction.current), [
        pendingHoverAction
    ]);
    const autobatch = (0, $hKj4G.useAutobatch)();
    const onMouseEnter = (0, $dkPd7.useEvent)((e)=>{
        autobatch(()=>{
            (0, $9pBAl.default)('backlog.card-hover', e);
            setRichActiveCard(cardId);
        });
    });
    const onFocus = (0, $dkPd7.useEvent)(()=>{
        setRichActiveCard(cardId);
    });
    const onMouseLeave = (0, $dkPd7.useEvent)(()=>{
        const containerElement = containerRef.current;
        if (!containerElement) return;
         // Remove pending setRichActiveCard if it hasn't already fired
        if (pendingHoverAction) {
            clearTimeout(pendingHoverAction.current);
            pendingHoverAction.current = undefined;
        }
        const activeElement = (0, $k9j9y.getActiveElement)(); // Ignore event if focused on a child
        if (activeElement instanceof Node && containerElement.contains(activeElement)) return;
        setRichActiveCard(null);
    });
    const onBlur = (0, $dkPd7.useEvent)((e)=>{
        const { relatedTarget: relatedTarget } = e;
        if (containerRef.current && relatedTarget instanceof Node && !containerRef.current.contains(relatedTarget)) setRichActiveCard(null);
    });
    if (shouldRenderRichCard && !hasRenderedRichElements.current) hasRenderedRichElements.current = true;
     // First card on the list always renders ICC above itself so tab works from the list header
    const canUseICC = isIccEnabled && cardId > 0;
    const shouldRenderICCAbove = canUseICC && (draggableIndex === 0 || hasIccOpen || shouldRenderRichCard || hasRenderedRichElements.current);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5547b5b54220ec90$export$6236cfcd981152cf, {
        isVisible: isVisible,
        innerRef: containerRef,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, shouldRenderICCAbove && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5qDf1.default), {
        listId: cardListId,
        insertBefore: cardId,
        isBetweenCards: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eLoNC.default), {
        id: cardId,
        cardListId: cardListId,
        canShowStatus: canShowStatusLozengeOnCards,
        draggableIndex: draggableIndex,
        shouldRenderRichCard: shouldRenderRichCard || hasRenderedRichElements.current,
        isAttachedToParent: isAttachedToParent,
        subtaskIds: subtaskIds
    }));
};
const $5547b5b54220ec90$export$55a2755069cf4bed = /*#__PURE__*/ (0, $eUqFw.memo)($5547b5b54220ec90$var$CardWithIccWrapperInner); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $5547b5b54220ec90$var$CardWithICCControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1tdshev-0"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        display: props.isVisible ? 'block' : 'none'
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5547b5b54220ec90$var$CardWithICCExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isVisible ? "_1e0c1ule" : "_1e0cglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $5547b5b54220ec90$export$6236cfcd981152cf = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $5547b5b54220ec90$var$CardWithICCExperiment, $5547b5b54220ec90$var$CardWithICCControl);

});
parcelRegister("9pBAl", function(module, exports) {

$parcel$export(module.exports, "default", () => $686553d52d264390$export$2e2bcd8739ae039);

var $hompL = parcelRequire("hompL");

var $dZdw5 = parcelRequire("dZdw5");

var $4vWWq = parcelRequire("4vWWq");

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");

var $7sbhX = parcelRequire("7sbhX");
function $686553d52d264390$var$mapToInteractionType(eventType) {
    if (eventType === 'click' || eventType === 'dblclick' || eventType === 'mousedown') return 'press';
    if (eventType === 'mouseenter' || eventType === 'mouseover') return 'hover';
    return undefined;
}
function $686553d52d264390$export$2e2bcd8739ae039(name, event) {
    if (!event || !event.isTrusted) return;
    const interactionType = $686553d52d264390$var$mapToInteractionType(event.type);
    if (!interactionType) // when interactionType is falsy we do not yet support this type of event. should we blow up with throwing error instead?
    return;
    const rate = (0, $4vWWq.getInteractionRate)(name, interactionType);
    const pressInteractionsList = (0, $4vWWq.getDoNotAbortActivePressInteraction)();
    if (pressInteractionsList?.includes(name)) {
        const interaction = (0, $fVaJL.getActiveInteraction)();
        if (interaction?.ufoName !== 'unknown' && interaction?.type === 'press') return;
    }
    if ((0, $dZdw5.default)(rate)) {
        (0, $fVaJL.abortAll)('new_interaction', name);
        const startTimestamp = event.timeStamp ?? performance.now();
        const newId = (0, $hompL.v4)();
        (0, $gnIbC.DefaultInteractionID).current = newId;
        (0, $fVaJL.addNewInteraction)(newId, name, 'press', startTimestamp, rate, [], (0, $7sbhX.default).current);
    }
}

});

parcelRegister("eLoNC", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a8f4458d6fbdf4e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");

var $8cU5f = parcelRequire("8cU5f");

var $511uv = parcelRequire("511uv");

var $aFvYX = parcelRequire("aFvYX");

var $6RZSH = parcelRequire("6RZSH");

var $dkPd7 = parcelRequire("dkPd7");

var $8MrYx = parcelRequire("8MrYx");

var $7TyGu = parcelRequire("7TyGu");

var $1gQ73 = parcelRequire("1gQ73");

var $bP7Jx = parcelRequire("bP7Jx");

var $j258X = parcelRequire("j258X");

var $8iu8f = parcelRequire("8iu8f");


var $dPfUC = parcelRequire("dPfUC");

var $5WFzC = parcelRequire("5WFzC");

var $fQe8P = parcelRequire("fQe8P");
const $6a8f4458d6fbdf4e$export$60332b2344f7fe41 = ({ id: id, cardListId: cardListId, canShowStatus: canShowStatus = false, shouldRenderRichCard: shouldRenderRichCard = true, isAttachedToParent: isAttachedToParent = false, subtaskIds: subtaskIds })=>{
    const { key: key, summary: summary, icon: icon } = (0, $1gQ73.useBacklogSelector)((state)=>{
        const card = (0, $bP7Jx.getCards)(state)[String(id)];
        return {
            key: card.key,
            summary: card.summary,
            icon: card.icon
        };
    }, (0, $aFvYX.default));
    const isCompanyManaged = (0, $j258X.useIsCMPBacklog)();
    const showCompactMode = (0, $8MrYx.useShowCompactMode)();
    const onMouseDown = (0, $dkPd7.useEvent)(()=>{
        // Clear any text selection to prevent unexpected dragging behaviour
        window.getSelection()?.removeAllRanges();
        (0, $511uv.getLongTasksMetrics)('dnd').start('backlog', (0, $7TyGu.BACKLOG_LONG_TASKS_DND_MARK_NAME));
    });
    const onMouseUp = (0, $dkPd7.useEvent)(()=>{
        (0, $511uv.getLongTasksMetrics)('dnd').stop((0, $6RZSH.softwareGenericLongTasksReporter)('dnd'));
    });
    const getHasExtraFields = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.hasCardExtraFields));
    const elementRef = (0, $eUqFw.useRef)(null);
    const { isDragging: isDragging, dragPreview: dragPreview, closestEdge: closestEdge, dropState: dropState } = (0, $fQe8P.useDraggableCard)({
        elementRef: elementRef,
        cardListId: cardListId,
        cardId: id
    });
    const isOptimistic = id < 0;
    if (isOptimistic) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.CardContainer), {
        isCompact: showCompactMode,
        lowerOpacity: false,
        isSelected: false,
        isFlagged: false,
        isDraggable: true,
        isDragHandle: false,
        hasExtraFields: getHasExtraFields,
        isOptimistic: true,
        shouldShowChevron: isCompanyManaged,
        "data-component-selector": (0, $becb1ff7485800b5$export$fb374ae0d58ab29b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.ImageContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.Img), {
        role: "presentation",
        src: icon
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.SummaryAndParentContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: summary
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.Summary), null, summary))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.StyledSpinner), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "small"
    })));
    const testIdProps = {
        'data-test-id': `software-backlog.card-list.card.content-container.${key}`,
        'data-testid': `software-backlog.card-list.card.content-container.${key}`
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.ContentContainer), {
        ref: elementRef,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        tabIndex: -1,
        ...testIdProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8iu8f.default), {
        id: id,
        canShowStatus: canShowStatus,
        isDragging: isDragging,
        shouldRenderRichCard: shouldRenderRichCard,
        isAttachedToParent: isAttachedToParent,
        subtaskIds: subtaskIds
    }), closestEdge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dPfUC.DropIndicator), {
        dropStatisticsCardListId: dropState?.cardListIfDivider ?? undefined,
        droppingOverCardListId: cardListId,
        droppingOverCardId: id,
        edge: closestEdge
    }), dragPreview);
};
var $6a8f4458d6fbdf4e$export$2e2bcd8739ae039 = $6a8f4458d6fbdf4e$export$60332b2344f7fe41;

});
parcelRegister("8iu8f", function(module, exports) {

$parcel$export(module.exports, "default", () => $e292fd2a9b36e7a2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8blac = parcelRequire("8blac");

var $511uv = parcelRequire("511uv");

var $3l6tm = parcelRequire("3l6tm");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $c1Zpg = parcelRequire("c1Zpg");

var $4cIIr = parcelRequire("4cIIr");

var $dkPd7 = parcelRequire("dkPd7");


var $1gQ73 = parcelRequire("1gQ73");

var $7TN4i = parcelRequire("7TN4i");

var $7GTNy = parcelRequire("7GTNy");

var $1HfeQ = parcelRequire("1HfeQ");

var $cbRhO = parcelRequire("cbRhO");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $8ZI73 = parcelRequire("8ZI73");

var $1ircG = parcelRequire("1ircG");

var $kdGmo = parcelRequire("kdGmo");

var $k734R = parcelRequire("k734R");

var $7kNqR = parcelRequire("7kNqR");

var $iXotx = parcelRequire("iXotx");

var $eHt0T = parcelRequire("eHt0T");
function $e292fd2a9b36e7a2$var$CardContentsContainer({ id: id, isDragging: isDragging, isDragHandle: isDragHandle, shouldRenderRichCard: shouldRenderRichCard, isAttachedToParent: isAttachedToParent = false, subtaskIds: subtaskIds }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const isCompanyManaged = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getIsCompanyManaged));
    const cards = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getCards));
    // There is always the possibility that the card selected does not exist.
    const card = cards[String(id)];
    const storyPointFieldId = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getStoryPointFieldId));
    const estimationType = (0, $1gQ73.useBacklogSelector)((0, $1ircG.getEstimationType));
    const timeTrackingOptions = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getTimeTrackingOptions));
    const isUserAtLeastMember = (0, $1gQ73.useBacklogSelector)((0, $8ZI73.isUserAtLeastMemberOfProject));
    const canUserEditIssue = (0, $1gQ73.useBacklogSelector)((0, $7kNqR.canEditIssue));
    const currentProjectId = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.projectIdSelector));
    const projectIds = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getProjectIds));
    const projectAris = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getProjectAris));
    const parents = (0, $1gQ73.useBacklogSelector)((0, $k734R.issueParentsSelector));
    const selectedCards = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getSelectedCards));
    const isFocused = (0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.getFocusedCard)(state) === id);
    const isSelected = (0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.isCardSelected)(state)(id));
    const highlightText = (0, $1gQ73.useBacklogSelector)((state)=>(0, $kdGmo.getFilters)(state).TEXT ?? null);
    const hasExtraFields = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.hasCardExtraFields));
    const fireCheckboxAnalytics = (0, $4cIIr.useFireCheckboxAnalytics)();
    const { key: cardKey, priority: priority, summary: summary, issueUrl: issueUrl, isDone: isDone, icon: icon, numCompleteChildren: numCompleteChildren, numTotalChildren: numTotalChildren, parentId: parentId, parentKey: parentKey, dueDate: dueDate, isFlagged: isFlagged, extraFields: extraFields, typeHierarchyLevel: issueHierarchyLevel, mentions: mentions } = card;
    const onClick = (0, $1gQ73.useBacklogActionCreator)((withCmd, withShift, source, // eslint-disable-next-line @typescript-eslint/no-inferrable-types
    viaCheckbox = false, externalAction)=>{
        (0, $511uv.getLongTasksMetrics)('bento').start('backlog');
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'issue'
        }), 'backlogCard', {
            source: source,
            issueHierarchyLevel: issueHierarchyLevel
        });
        const analyticsMetadata = {
            mentionIndicator: !!mentions
        };
        const fireSelectionAnalytics = (extraAttr)=>{
            if (viaCheckbox || withCmd || withShift && extraAttr.numSelectedCards > 1) fireCheckboxAnalytics?.(createAnalyticsEvent({
                action: 'changed',
                actionSubject: 'checkbox'
            }), 'backlogCard', {
                ...extraAttr,
                inputSource: (0, $iXotx.getCardSelectionAnalyticsInputSource)(withShift, withCmd, viaCheckbox),
                isCheckboxChecked: !isSelected,
                issueHierarchyLevel: issueHierarchyLevel,
                selectType: 'individual',
                issueId: id
            });
        };
        return (0, $1HfeQ.cardClick)(id, withCmd, withShift, viaCheckbox, fireSelectionAnalytics, externalAction, analyticsMetadata);
    });
    const singleSelectCard = (0, $1gQ73.useBacklogActionCreator)(()=>(0, $1HfeQ.cardSingleSelect)(id));
    const onContextMenu = (0, $dkPd7.useEvent)(()=>{
        const isCardOutsideOfSelectedCards = !selectedCards.includes(id);
        if (isCardOutsideOfSelectedCards) singleSelectCard();
    });
    const onFocus = (0, $1gQ73.useBacklogActionCreator)(()=>(0, $7GTNy.cardFocus)(id));
    const onBlur = (0, $1gQ73.useBacklogActionCreator)((0, $7GTNy.cardBlur));
    const onToggleCardGroup = (0, $1gQ73.useBacklogActionCreator)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'changed',
            actionSubject: 'expansionState'
        }), 'backlogCardGroup', {
            issueHierarchyLevel: issueHierarchyLevel
        });
        return (0, $7TN4i.cardGroupToggle)(id);
    });
    const isGroupExpanded = (0, $1gQ73.useBacklogSelector)((state)=>false ? (0, $bP7Jx.makeGetCardGroupExpanded)(state)(id) || !!(0, $bP7Jx.getOrderedCardIdsByCardListIdWithLimit)(state)[id].length : (0, $bP7Jx.makeGetCardGroupExpanded)(state)(id));
    const selectedCardsForFlagWithCommentModal = (0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.cardsForFlagWithCommentModalFromCardIdsSelector)(state)([
            id
        ]));
    const onAddFlag = (0, $1gQ73.useBacklogActionCreator)((_)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'inlineCardField'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'addFlag');
        return (0, $cbRhO.openModal)({
            type: (0, $ebd52ea7083e351b$export$34f52cb2089ddc40),
            payload: {
                flagAction: (0, $c1Zpg.ADD),
                cards: selectedCardsForFlagWithCommentModal
            }
        });
    });
    const hasFlaggedCards = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.backlogHasFlaggedCards));
    const hasCardsWithPriority = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.backlogHasPriority));
    const hasCardsWithDueDate = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.backlogHasDueDate));
    const hasCardsWithStoryPoint = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.backlogHasStoryPoints));
    const hasCardsWithEstimate = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.backlogHasEstimates));
    const orderedVersions = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getOrderedVersions));
    if (!card) return null;
    /*
	 * as long as there is a single card having fix version, the orderedVersions is not empty
	 * checking the orderedVersions value against empty to determine if we should preserve the space for version
	 * even this card has no version
	 * the reason to do that is to to make sure the subtask text and subtask icons are aligned.
	 * https://hello.jira.atlassian.cloud/browse/FTFNS-54
	 * https://hello.jira.atlassian.cloud/browse/FTFNS-55
	 */ const shouldDisplayVersions = isCompanyManaged && !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(orderedVersions);
    const isSubtask = (0, $3l6tm.isSubtaskHierarchyLevel)(issueHierarchyLevel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: {
            issueHierarchyLevel: issueHierarchyLevel
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eHt0T.default), {
        cardId: id,
        isSelected: isSelected,
        selectedCards: selectedCards,
        numSelectedCards: selectedCards.length,
        parents: parents,
        currentProjectId: currentProjectId,
        projectIds: projectIds,
        projectAris: projectAris,
        storyPointFieldId: storyPointFieldId,
        isUserAtLeastMember: isUserAtLeastMember,
        canUserEditIssue: canUserEditIssue,
        isDragging: isDragging,
        isDragHandle: isDragHandle,
        estimationType: estimationType,
        timeTrackingOptions: timeTrackingOptions,
        shouldRenderRichCard: shouldRenderRichCard,
        highlightText: highlightText,
        isFocused: isFocused,
        hasExtraFields: hasExtraFields,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onContextMenu: onContextMenu,
        isAttachedToParent: isAttachedToParent,
        isSubtask: isSubtask,
        subtaskIds: subtaskIds,
        isCardGroupExpanded: isGroupExpanded,
        onToggleCardGroup: onToggleCardGroup,
        cardKey: cardKey,
        dueDate: dueDate,
        unreadMentions: mentions || null,
        icon: icon,
        isDone: isDone,
        isFlagged: isFlagged,
        issueUrl: issueUrl,
        numCompleteChildren: numCompleteChildren,
        numTotalChildren: numTotalChildren,
        parentId: parentId,
        parentKey: parentKey,
        priority: priority,
        shouldDisplayVersions: shouldDisplayVersions,
        summary: summary,
        extraFields: extraFields,
        onAddFlag: onAddFlag,
        shouldRenderInlineAddFlag: hasFlaggedCards,
        shouldRenderPriorityColumn: hasCardsWithPriority,
        shouldRenderDueDateColumn: hasCardsWithDueDate,
        shouldRenderStoryPointColumn: hasCardsWithStoryPoint,
        shouldRenderEstimatesColumn: hasCardsWithEstimate
    }));
}
var $e292fd2a9b36e7a2$export$2e2bcd8739ae039 = $e292fd2a9b36e7a2$var$CardContentsContainer;

});
parcelRegister("c1Zpg", function(module, exports) {

$parcel$export(module.exports, "ADD", () => $5fab23fc53462558$export$bb6389024b71c2ae);
$parcel$export(module.exports, "REMOVE", () => $5fab23fc53462558$export$29d55e1f664a246b);
$parcel$export(module.exports, "FLAG_REMOVED_PREFIX", () => $5fab23fc53462558$export$43b00f69c32e9a5);
$parcel$export(module.exports, "FLAG_ADDED_PREFIX", () => $5fab23fc53462558$export$625f394c78645dcd);
const $5fab23fc53462558$export$bb6389024b71c2ae = 'ADD';
const $5fab23fc53462558$export$29d55e1f664a246b = 'REMOVE';
const $5fab23fc53462558$export$43b00f69c32e9a5 = {
    content: [
        {
            type: 'paragraph',
            content: [
                {
                    type: 'emoji',
                    attrs: {
                        shortName: ':flag_off:',
                        id: 'atlassian-flag_off',
                        text: ':flag_off:'
                    }
                },
                {
                    type: 'text',
                    text: ' Flag removed '
                }
            ]
        }
    ],
    type: 'doc',
    version: 1
};
const $5fab23fc53462558$export$625f394c78645dcd = {
    content: [
        {
            type: 'paragraph',
            content: [
                {
                    type: 'emoji',
                    attrs: {
                        shortName: ':flag_on:',
                        id: 'atlassian-flag_on',
                        text: ':flag_on:'
                    }
                },
                {
                    type: 'text',
                    text: ' Flag added '
                }
            ]
        }
    ],
    type: 'doc',
    version: 1
};

});

parcelRegister("4cIIr", function(module, exports) {

$parcel$export(module.exports, "useContextMenuAnalytics", () => $d9a6369012ec5957$export$e3e152955394305b);
$parcel$export(module.exports, "ContextMenuAnalytics", () => $d9a6369012ec5957$export$eceb0d68a993ec5c);
$parcel$export(module.exports, "ContextualAnalyticsDataFromNode", () => $d9a6369012ec5957$export$f9d8ab9f9d913310);
$parcel$export(module.exports, "useFireCheckboxAnalytics", () => $d9a6369012ec5957$export$41c45cbb6f557de5);

var $eUqFw = parcelRequire("eUqFw");

var $4E9Xv = parcelRequire("4E9Xv");

var $guiFP = parcelRequire("guiFP");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");

var $6DFOC = parcelRequire("6DFOC");

var $alHuG = parcelRequire("alHuG");
const $d9a6369012ec5957$export$e3e152955394305b = ()=>{
    const analyticsMapping = (0, $6DFOC.useAnalyticsMapping)();
    const getAnalyticsMapping = (0, $eUqFw.useMemo)(()=>(0, $alHuG.createGetAnalyticsMapping)(analyticsMapping), [
        analyticsMapping
    ]);
    const addMappedAnalyticsToEvent = (0, $eUqFw.useCallback)((event, id, updater)=>{
        const mappedAnalytics = getAnalyticsMapping(id);
        if (mappedAnalytics && typeof mappedAnalytics === 'object') {
            const { actionSubjectId: actionSubjectId, attributes: attributes, ...analytics } = mappedAnalytics;
            event.update(analytics);
        }
        if (updater) {
            if (typeof updater === 'function') event.update(updater);
            else {
                const { actionSubjectId: actionSubjectId, attributes: attributes, ...analytics } = updater;
                event.update(analytics);
            }
        }
        return event;
    }, [
        getAnalyticsMapping
    ]);
    const getAttributesForId = (0, $eUqFw.useCallback)((id, updater)=>{
        const mappedAnalytics = getAnalyticsMapping(id);
        const mappedAttributes = typeof mappedAnalytics === 'object' ? mappedAnalytics.attributes : undefined;
        return typeof updater === 'object' ? {
            ...mappedAttributes,
            ...updater?.attributes
        } : mappedAttributes;
    }, [
        getAnalyticsMapping
    ]);
    const fireUIAnalyticsForNode = (0, $eUqFw.useCallback)((event, id, updater, attributes)=>{
        const mappedAnalytics = getAnalyticsMapping(id);
        let subjectId = typeof updater === 'function' ? updater(event.payload).actionSubjectId : updater?.actionSubjectId;
        if (!subjectId && mappedAnalytics) subjectId = typeof mappedAnalytics === 'string' ? mappedAnalytics : mappedAnalytics.actionSubjectId;
        if (attributes) subjectId ? (0, $jMP2a.fireUIAnalytics)(event, subjectId, attributes) : (0, $jMP2a.fireUIAnalytics)(event, attributes);
        else subjectId ? (0, $jMP2a.fireUIAnalytics)(event, subjectId) : (0, $jMP2a.fireUIAnalytics)(event);
    }, [
        getAnalyticsMapping
    ]);
    const values = (0, $eUqFw.useMemo)(()=>({
            fireUIAnalyticsForNode: fireUIAnalyticsForNode,
            getAttributesForId: getAttributesForId,
            addMappedAnalyticsToEvent: addMappedAnalyticsToEvent
        }), [
        fireUIAnalyticsForNode,
        getAttributesForId,
        addMappedAnalyticsToEvent
    ]);
    return values;
};
const $d9a6369012ec5957$export$eceb0d68a993ec5c = ({ scope: scope, children: children, cardId: cardId })=>{
    const attributes = (0, $6DFOC.useAnalyticsAttributes)({
        scope: scope,
        cardId: cardId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: attributes
    }, children);
};
const $d9a6369012ec5957$export$f9d8ab9f9d913310 = ({ id: id, updater: updater, children: children })=>{
    const { getAttributesForId: getAttributesForId } = $d9a6369012ec5957$export$e3e152955394305b();
    const attributes = (0, $eUqFw.useMemo)(()=>getAttributesForId(id, updater), [
        getAttributesForId,
        id,
        updater
    ]);
    if (!attributes) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: attributes
    }, children);
};
const $d9a6369012ec5957$export$41c45cbb6f557de5 = ()=>{
    const bulkOpsFlow = (0, $4E9Xv.useBulkOpsSessionContext)();
    const fireCheckboxAnalytics = (0, $eUqFw.useCallback)((event, actionSubjectId, attributes)=>{
        if (!bulkOpsFlow) {
            (0, $guiFP.default)({
                error: new Error('Trying to fire checkbox analytics when bulkOpsFlow is undefined'),
                meta: {
                    id: 'jira-software-context-menu-controller-analytics-use-fire-checkbox-analytics',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                },
                attributes: {
                    actionSubjectId: actionSubjectId,
                    attributes: attributes
                }
            });
            (0, $jMP2a.fireUIAnalytics)(event, actionSubjectId, {
                ...attributes,
                bulkOpsSessionID: 'unknown'
            });
            return;
        }
        if (bulkOpsFlow.isInFlow()) (0, $jMP2a.fireUIAnalytics)(event, actionSubjectId, attributes);
        else bulkOpsFlow.registerAnalyticsEventPublisher((sessionID, i)=>{
            const attributesWithSessionId = {
                ...attributes,
                bulkOpsSessionID: sessionID
            };
            (0, $jMP2a.fireUIAnalytics)(event, actionSubjectId, i === 0 ? attributesWithSessionId : attributes);
        });
    }, [
        bulkOpsFlow
    ]);
    return fireCheckboxAnalytics;
};

});
parcelRegister("alHuG", function(module, exports) {

$parcel$export(module.exports, "createGetAnalyticsMapping", () => $7be15d5c67cfde2d$export$836ec4673aac623f);

var $jqvCZ = parcelRequire("jqvCZ");
const $7be15d5c67cfde2d$export$7b036678329a3ea2 = (id, analyticsMapping)=>{
    let result = analyticsMapping[id];
    if (!result) {
        const matchedId = Object.keys(analyticsMapping).find((key)=>key.startsWith(id) || id.startsWith(key));
        if (matchedId) result = analyticsMapping[matchedId];
    }
    return result;
};
const $7be15d5c67cfde2d$export$836ec4673aac623f = (analyticsMapping)=>{
    if (!analyticsMapping) return (_id)=>undefined;
    // Sorting the analytics mapping by key length ensures that the shortest key is matched first - shortest key means best match
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const sortedAnalyticsMapping = Object.fromEntries(Object.entries(analyticsMapping).sort(([keyA], [keyB])=>keyA.length - keyB.length));
    const memoizedGetterFunction = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))($7be15d5c67cfde2d$export$7b036678329a3ea2);
    return (id)=>memoizedGetterFunction(id, sortedAnalyticsMapping);
};

});


parcelRegister("iXotx", function(module, exports) {

$parcel$export(module.exports, "getCardSelectionAnalyticsInputSource", () => $d15867b84ea5342f$export$cddca765560eae90);

var $30WDI = parcelRequire("30WDI");
const $d15867b84ea5342f$export$cddca765560eae90 = (withShift, withCmd, viaCheckbox)=>{
    if (withShift && withCmd) return 0, $30WDI.CMD_SHIFT_CLICK_ANALYTICS_ID;
    if (withShift) return 0, $30WDI.SHIFT_CLICK_ANALYTICS_ID;
    if (viaCheckbox) return 0, $30WDI.CHECKBOX_ANALYTICS_ID;
    return 0, $30WDI.CMD_CLICK_ANALYTICS_ID;
};

});

parcelRegister("eHt0T", function(module, exports) {

$parcel$export(module.exports, "default", () => $95d9103d2bef0d9b$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $iWLL0 = parcelRequire("iWLL0");

var $9nkwJ = parcelRequire("9nkwJ");

var $86Ndv = parcelRequire("86Ndv");

var $dtaN9 = parcelRequire("dtaN9");

var $eyI8O = parcelRequire("eyI8O");

var $8YJjX = parcelRequire("8YJjX");

var $8Wt6T = parcelRequire("8Wt6T");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $6UWn5 = parcelRequire("6UWn5");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3l6tm = parcelRequire("3l6tm");

var $caTc0 = parcelRequire("caTc0");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $1N1uk = parcelRequire("1N1uk");


var $iVF7F = parcelRequire("iVF7F");

var $8MrYx = parcelRequire("8MrYx");

var $8wXFi = parcelRequire("8wXFi");

var $7TyGu = parcelRequire("7TyGu");

var $1gQ73 = parcelRequire("1gQ73");

var $h4zn0 = parcelRequire("h4zn0");

var $bP7Jx = parcelRequire("bP7Jx");

var $2498I = parcelRequire("2498I");

var $9sGN6 = parcelRequire("9sGN6");

var $j258X = parcelRequire("j258X");

var $gIy9B = parcelRequire("gIy9B");

var $6kjWj = parcelRequire("6kjWj");

var $939HY = parcelRequire("939HY");

var $bn3eO = parcelRequire("bn3eO");


var $ivso4 = parcelRequire("ivso4");

var $dU01J = parcelRequire("dU01J");

var $5WFzC = parcelRequire("5WFzC");

var $8MkuF = parcelRequire("8MkuF");

var $4QJAt = parcelRequire("4QJAt");

var $e0tSD = parcelRequire("e0tSD");

var $gsBhl = parcelRequire("gsBhl");

var $30WDI = parcelRequire("30WDI");

var $fEa6g = parcelRequire("fEa6g");

var $3pfK3 = parcelRequire("3pfK3");

var $g8AN8 = parcelRequire("g8AN8");

var $6dmWW = parcelRequire("6dmWW");

var $36Wg2 = parcelRequire("36Wg2");

var $l0b86 = parcelRequire("l0b86");

var $gMlzx = parcelRequire("gMlzx");

var $1muUz = parcelRequire("1muUz");

var $cbbdp = parcelRequire("cbbdp");

var $1zGZQ = parcelRequire("1zGZQ");

var $3uhy5 = parcelRequire("3uhy5");

var $h0mW9 = parcelRequire("h0mW9");

var $yKruN = parcelRequire("yKruN");

var $4jGOQ = parcelRequire("4jGOQ");

var $kDuIt = parcelRequire("kDuIt");
const $95d9103d2bef0d9b$var$CardContents = ({ cardId: cardId, cardKey: cardKey, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onContextMenu: onContextMenu, highlightText: highlightText, summary: summary, parents: parents, parentId: parentId, currentProjectId: currentProjectId, projectIds: projectIds, projectAris: projectAris, issueUrl: issueUrl, icon: icon, dueDate: dueDate, unreadMentions: unreadMentions, estimationType: estimationType, storyPointFieldId: storyPointFieldId, timeTrackingOptions: timeTrackingOptions, extraFields: extraFields, hasExtraFields: hasExtraFields, canUserEditIssue: canUserEditIssue, isUserAtLeastMember: isUserAtLeastMember, isDone: isDone, isFocused: isFocused, isFlagged: isFlagged = false, isSelected: isSelected = false, isDragging: isDragging = false, isDragHandle: isDragHandle = false, shouldRenderRichCard: shouldRenderRichCard = true, selectedCards: selectedCards, numCompleteChildren: numCompleteChildren, numTotalChildren: numTotalChildren, shouldDisplayVersions: shouldDisplayVersions, isAttachedToParent: isAttachedToParent = false, isSubtask: isSubtask = false, subtaskIds: subtaskIds, parentKey: parentKey, isCardGroupExpanded: isCardGroupExpanded = false, onToggleCardGroup: onToggleCardGroupProp = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onAddFlag: onAddFlag, shouldRenderInlineAddFlag: shouldRenderInlineAddFlag, shouldRenderPriorityColumn: shouldRenderPriorityColumn, shouldRenderDueDateColumn: shouldRenderDueDateColumn, shouldRenderStoryPointColumn: shouldRenderStoryPointColumn, shouldRenderEstimatesColumn: shouldRenderEstimatesColumn })=>{
    const prefersReducedMotion = (0, $8YJjX.useIsReducedMotion)();
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { size: backlogContainerSize } = (0, $bn3eO.useContainerSize)();
    const isCompactView = backlogContainerSize === (0, $939HY.ScreenSize).EXTRA_SMALL;
    const [isActionMenuOpen, setIsActionMenuOpen] = (0, $eUqFw.useState)(false); // TODO move to <SummaryAndParents /> during NON UIF clean up
    const [isSummaryFieldEditing, setIsSummaryFieldEditing] = (0, $eUqFw.useState)(false);
    const [isActionMenuTriggerVisible] = (0, $eUqFw.useState)(true);
    const cardHierarchyLevel = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.makeGetCardHierarchyLevel));
    const isTopCardInBacklogContainer = (0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.makeOrderedVisibleCardIdsForCardList)(state)((0, $7TyGu.BACKLOG)))[0] === cardId;
    const isEpic = (0, $3l6tm.isEpicHierarchyLevel)(cardHierarchyLevel(cardId));
    const isCompanyManaged = (0, $j258X.useIsCMPBacklog)();
    const isCompanyManagedKanban = (0, $j258X.useIsCMPKanbanBacklog)();
    const showEpics = (0, $8MrYx.useShowEpics)();
    const showCompactMode = (0, $8MrYx.useShowCompactMode)();
    const isCompactModeEnabled = showCompactMode;
    const draggingIsInProgress = (0, $1gQ73.useBacklogSelector)((0, $2498I.isDragging));
    const isIncludedInCurrentDrag = !isDragHandle && draggingIsInProgress && (isSelected || !isCompanyManagedKanban && !!parentId && selectedCards.includes(parentId));
    const returnFocusTo = (0, $iVF7F.useReturnFocusTo)();
    const { setReturnFocusTo: setReturnFocusTo } = (0, $iVF7F.useModalDialogActions)();
    const menuTriggerRef = (0, $eUqFw.useRef)(null);
    const isBulkOpsInProgress = (0, $6UWn5.useIsBulkOperationsInProgress)();
    const shouldShowCheckbox = (0, $gIy9B.useShowCheckbox)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const viewSettings = (0, $8wXFi.isViewSettingAsPanelExpEnabledWithNoExposure)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $8MrYx.useCardFieldsSettings)() : {
        showIssueType: true,
        showIssueKey: true,
        showPriority: true,
        showAssignee: true,
        showEstimate: true,
        showDueDate: true,
        cardExtraFields: undefined
    };
    const handleClick = (0, $eUqFw.useCallback)((e)=>{
        e.stopPropagation();
        if (e.defaultPrevented) return;
        const withCmd = e.ctrlKey || e.metaKey;
        const withShift = e.shiftKey;
        onClick(withCmd, withShift, 'mouse');
    }, [
        onClick
    ]);
    const onClickThrough = (0, $eUqFw.useCallback)((e)=>{
        const withCmd = e.ctrlKey || e.metaKey;
        const withShift = e.shiftKey;
        if (withCmd || withShift) onFocus();
        handleClick(e);
    }, [
        onFocus,
        handleClick
    ]);
    const onKeyDown = (0, $eUqFw.useCallback)((e)=>{
        const withCmd = e.ctrlKey || e.metaKey;
        const withShift = e.shiftKey;
        if (e.key !== 'Enter' || isDragging) return;
        onClick(withCmd, withShift, 'keyboard');
    }, [
        isDragging,
        onClick
    ]); // TODO move to <SummaryAndParents /> on non UIF clean up
    const onSummaryEditStateChange = (0, $eUqFw.useCallback)((isEditing)=>{
        setIsSummaryFieldEditing(isEditing);
    }, []);
    const onRightClickOutside = (0, $eUqFw.useCallback)((_e)=>{
        setIsActionMenuOpen(false);
    }, []);
    const [versionMenuQueryRef, loadVersionMenuQuery] = (0, $iWLL0.useQueryLoader)((0, $1N1uk.default));
    (0, $eUqFw.useEffect)(()=>{
        if (!versionMenuQueryRef && loadVersionMenuQuery != null && shouldRenderRichCard) loadVersionMenuQuery({
            jiraProjectIds: projectAris,
            first: 500,
            after: null
        });
    }, [
        versionMenuQueryRef,
        loadVersionMenuQuery,
        shouldRenderRichCard,
        projectAris
    ]);
    const renderCardColor = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gsBhl.CardColor), {
            id: cardId
        });
    const handleMenuOpenChange = (0, $eUqFw.useCallback)((isOpen)=>{
        if (isOpen && menuTriggerRef?.current) setReturnFocusTo(menuTriggerRef);
        setIsActionMenuOpen(isOpen);
    }, [
        setReturnFocusTo
    ]);
    const handlePulseMenuOpenChange = (0, $eUqFw.useCallback)((isOpen)=>{
        if (isOpen) {
            dispatch((0, $h4zn0.setHasViewedPulseRequest)());
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                action: 'opened',
                actionSubject: 'contextMenu'
            }), 'contextMenuWithWhiteboardPulse');
        }
        handleMenuOpenChange(isOpen);
    }, [
        handleMenuOpenChange,
        dispatch,
        createAnalyticsEvent
    ]); // for jsw_sprint_planning_whiteboards experiment
    const { cohort: cohort, flow: flow } = (0, $1gQ73.useBacklogSelector)((0, $9sGN6.getWhiteboardEligibility));
    const hasViewedPulse = (0, $1gQ73.useBacklogSelector)((0, $9sGN6.getHasViewedPulse));
    const isPulseActive = isTopCardInBacklogContainer && flow === 'crossFlow' && cohort === (0, $6kjWj.WHITEBOARD_ENTRYPOINT_EXPERIMENT_VARIANTS).CONTEXT_MENU && !hasViewedPulse;
    const getMenuComponent = ()=>isPulseActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Wt6T.Pulse), {
            radius: 3,
            pulse: !prefersReducedMotion
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ivso4.ContextMenu), {
            appearance: (0, $e8879a4af726a467$export$ee5015c6ad52cf0b),
            onOpenChange: handlePulseMenuOpenChange,
            issueId: cardId,
            issueKey: cardKey,
            summary: summary,
            selectedCardIds: selectedCards,
            versionMenuQueryRef: versionMenuQueryRef,
            triggerRef: menuTriggerRef
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ivso4.ContextMenu), {
            appearance: (0, $e8879a4af726a467$export$ee5015c6ad52cf0b),
            onOpenChange: handleMenuOpenChange,
            issueId: cardId,
            issueKey: cardKey,
            summary: summary,
            selectedCardIds: selectedCards,
            versionMenuQueryRef: versionMenuQueryRef,
            triggerRef: menuTriggerRef
        });
    const renderMenu = ()=>{
        const shouldRenderMenu = (isActionMenuOpen || shouldRenderRichCard) && isActionMenuTriggerVisible;
        const triggerIsFocused = returnFocusTo?.current && menuTriggerRef.current && returnFocusTo?.current === menuTriggerRef.current;
        const isMenuOpen = isActionMenuOpen || Boolean(triggerIsFocused);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.MenuPlaceholder), {
            isPulseActive: isPulseActive,
            isMenuOpen: isMenuOpen,
            "data-test-id": "software-backlog.card-list.card.card-contents.context-menu",
            "data-testid": "software-backlog.card-list.card.card-contents.context-menu",
            "data-component-selector": (0, $becb1ff7485800b5$export$ca45cc072d50480d)
        }, shouldRenderMenu || isPulseActive ? getMenuComponent() : null);
    };
    const renderInteractionLayer = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $36Wg2.default), {
            isFocused: isFocused,
            cardKey: cardKey,
            summary: summary,
            onFocus: onFocus,
            onBlur: onBlur,
            onClick: handleClick,
            onKeyDown: onKeyDown
        });
    const renderOriginalEstimateField = ()=>{
        const estimateField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1muUz.default), {
            issueId: cardId,
            issueKey: cardKey,
            estimationType: estimationType,
            timeTrackingOptions: timeTrackingOptions,
            isUserAtLeastMember: isUserAtLeastMember,
            shouldRenderRichCard: shouldRenderRichCard,
            shouldRenderEstimatesColumn: shouldRenderEstimatesColumn
        });
        return estimationType === (0, $7TyGu.ORIGINAL_ESTIMATE) ? estimateField : null;
    };
    const renderStoryPointField = ()=>{
        const estimateField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h0mW9.default), {
            issueId: cardId,
            issueKey: cardKey,
            storyPointFieldId: storyPointFieldId,
            estimationType: estimationType,
            isUserAtLeastMember: isUserAtLeastMember,
            shouldRenderRichCard: shouldRenderRichCard,
            shouldRenderStoryPointColumn: shouldRenderStoryPointColumn
        });
        return storyPointFieldId || estimationType === (0, $7TyGu.STORY_POINTS) ? estimateField : null;
    };
    const renderMentionsIndicator = ()=>{
        if ((0, $caTc0.isInMentionsIndicatorExperimentCohort)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gMlzx.MentionsIndicatorField), {
            onClick: onClick,
            unreadMentions: unreadMentions
        });
        return null;
    };
    const renderAssigneeField = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.AssigneeContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8MkuF.default), {
            isUserAtLeastMember: isUserAtLeastMember,
            shouldRenderRichCard: shouldRenderRichCard,
            issueKey: cardKey
        }));
    const parentKeyText = parentKey !== undefined ? formatMessage((0, $dU01J.default).parentKeyText, {
        parentKey: parentKey
    }) : '';
    const renderParentKey = ()=>parentKey !== undefined && isSubtask && !isAttachedToParent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: parentKeyText,
            position: "mouse"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.CardGroupKey), null, `${parentKeyText}`)) : null;
    const hasLinkedSubtasks = subtaskIds !== undefined && subtaskIds.length > 0;
    const numberOfLinkedSubtasks = hasLinkedSubtasks ? formatMessage((0, $dU01J.default).numberOfChildrenText, {
        numberOfChildren: subtaskIds.length
    }) : '';
    const shouldShowChevron = hasLinkedSubtasks && !isDragHandle;
    const onToggleCardGroup = (event)=>{
        event.preventDefault();
        onToggleCardGroupProp();
    };
    const isExpanded = isCardGroupExpanded;
    const renderCardGroupToggle = ()=>{
        if (!shouldShowChevron) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage(isExpanded ? (0, $dU01J.default).cardGroupToggleTooltipCollapse : (0, $dU01J.default).cardGroupToggleTooltipExpand)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($95d9103d2bef0d9b$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.CardGroupToggle), {
            appearance: "subtle",
            onClick: onToggleCardGroup,
            "aria-label": formatMessage(isExpanded ? (0, $dU01J.default).cardGroupToggleExpandedAriaLabel : (0, $dU01J.default).cardGroupToggleCollapsedAriaLabel, {
                issueKey: cardKey,
                summary: summary
            }),
            testId: "software-backlog.card-list.card.card-contents.subtask",
            "aria-expanded": isExpanded,
            iconBefore: isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                label: ""
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
                label: ""
            })
        })));
    };
    const getCheckboxContainerMargin = (shouldAddMargin)=>{
        if (shouldAddMargin && isAttachedToParent) return 'space.400';
        if (shouldAddMargin) return 'space.250';
        return 'space.0';
    };
    const renderCheckbox = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        ), {
            xcss: (0, $1ZAYh.xcss)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                marginRight: getCheckboxContainerMargin(isCompanyManaged && !shouldShowChevron)
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.CheckboxContainer), {
            "data-component-selector": (0, $30WDI.CHECKBOX_COMPONENT_SELECTOR),
            "data-testid": (0, $30WDI.CHECKBOX_TESTID),
            shouldShowCheckbox: shouldShowCheckbox
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4QJAt.default), {
            isSelected: isSelected,
            onClick: onClick,
            isDisabled: isBulkOpsInProgress,
            shouldShowCheckbox: shouldShowCheckbox
        })));
    const showCardExtraFieldsColumnBasedOnViewSettings = (0, $8wXFi.isViewSettingAsPanelExpEnabledWithNoExposure)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $8MrYx.useHasCardExtraFields)() : true;
    const renderExtraFields = ()=>hasExtraFields && extraFields && showCardExtraFieldsColumnBasedOnViewSettings && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.ExtraFieldsContainer), {
            isAttachedToParent: isAttachedToParent && isCompanyManaged,
            hideTypeIcon: !viewSettings.showIssueType
        }, extraFields.filter((field)=>viewSettings.cardExtraFields?.[field.id] === undefined ? true : viewSettings.cardExtraFields[field.id]).map((field, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, {
                key: field.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3pfK3.CardExtraField), {
                field: field
            }), index < extraFields?.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g8AN8.FieldSeparator), {
                "aria-hidden": "true",
                key: `${field.id}-separator`
            }, "\u2022"))));
    const renderCmpChildIssuesMetadata = ()=>hasLinkedSubtasks ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.SubtaskIconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: numberOfLinkedSubtasks,
            position: "mouse"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eyI8O))), {
            primaryColor: `var(--ds-icon-subtle, ${(0, $PdmhA).N300})`,
            size: "small",
            label: "subatskIcon"
        }))) : null;
    (0, $eUqFw.useEffect)(()=>{
        document.addEventListener('contextmenu', onRightClickOutside);
        return ()=>{
            document.removeEventListener('contextmenu', onRightClickOutside);
        };
    }, [
        onRightClickOutside
    ]);
    const getDraggingCardIds = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.makeGetDraggingCardIds));
    const isOptimistic = cardId < 0;
    if (isOptimistic) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.CardContainer), {
        lowerOpacity: false,
        isSelected: isSelected,
        isFlagged: isFlagged,
        isDraggable: canUserEditIssue,
        isDragHandle: isDragHandle,
        hasExtraFields: hasExtraFields,
        isCompact: isCompactModeEnabled,
        "data-component-selector": (0, $becb1ff7485800b5$export$fb374ae0d58ab29b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4jGOQ.TypeIcon), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $yKruN.SummaryAndParents), {
        cardKey: cardKey,
        summary: summary,
        highlightText: highlightText,
        isUserAtLeastMember: isUserAtLeastMember,
        shouldRenderRichCard: shouldRenderRichCard,
        isSummaryFieldEditing: isSummaryFieldEditing,
        onClickThrough: onClickThrough,
        onSummaryEditStateChange: onSummaryEditStateChange
    }), !isDragHandle && renderExtraFields(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.StyledSpinner), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "small"
    })));
    const numSelected = getDraggingCardIds(cardId).length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ivso4.ContextMenu), {
        appearance: (0, $e8879a4af726a467$export$bb79bd28759ee895),
        issueId: cardId,
        issueKey: cardKey,
        selectedCardIds: selectedCards,
        versionMenuQueryRef: versionMenuQueryRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.CardContainer), {
        "data-testid": (0, $30WDI.CARD_CONTAINER_TESTID),
        shouldShowChevron: shouldShowChevron,
        isCompanyManagedKanban: isCompanyManagedKanban,
        isCompact: isCompactModeEnabled,
        isAttachedToParent: isAttachedToParent,
        isSelected: !isDragHandle && isSelected,
        isFlagged: isFlagged,
        lowerOpacity: isIncludedInCurrentDrag,
        isDragHandle: isDragHandle,
        isDraggable: canUserEditIssue,
        hasExtraFields: !isDragHandle && hasExtraFields && showCardExtraFieldsColumnBasedOnViewSettings,
        onContextMenu: onContextMenu,
        hideTypeIcon: !viewSettings.showIssueType,
        isAssigneeShown: viewSettings.showAssignee,
        "data-component-selector": (0, $becb1ff7485800b5$export$fb374ae0d58ab29b)
    }, !isDragHandle ? renderInteractionLayer() : null, !isDragHandle ? renderCheckbox() : null, renderCardColor(), renderCardGroupToggle(), viewSettings.showIssueType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4jGOQ.TypeIcon), {
        icon: icon
    }), viewSettings.showIssueKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l0b86.Key), {
        isDone: isDone,
        cardKey: cardKey,
        issueUrl: issueUrl,
        summary: summary,
        highlightText: highlightText,
        onClick: onClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $yKruN.SummaryAndParents), {
        cardKey: cardKey,
        summary: summary,
        highlightText: highlightText,
        isUserAtLeastMember: isUserAtLeastMember,
        shouldRenderRichCard: shouldRenderRichCard,
        isSummaryFieldEditing: isSummaryFieldEditing,
        onClickThrough: onClickThrough,
        onSummaryEditStateChange: onSummaryEditStateChange
    }), renderParentKey(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.OptionalFieldsContainer), null, !isDragHandle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e0tSD.ChildIssuesMetadata), {
        numTotalChildren: numTotalChildren,
        numCompleteChildren: numCompleteChildren,
        onClickThrough: onClickThrough
    }), renderCmpChildIssuesMetadata(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kDuIt.VersionsWrapper), {
        shouldDisplayVersions: shouldDisplayVersions,
        backlogContainerSize: backlogContainerSize,
        cardId: cardId
    }), showEpics && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cbbdp.Parent), {
        cardId: cardId,
        cardKey: cardKey,
        isUserAtLeastMember: isUserAtLeastMember,
        parents: parents,
        parentId: parentId,
        currentProjectId: currentProjectId,
        projectIds: projectIds,
        canUserEditIssue: canUserEditIssue,
        shouldRenderRichCard: shouldRenderRichCard,
        backlogContainerSize: backlogContainerSize,
        isCompactView: isCompactView,
        isSubtask: isSubtask,
        isEpic: isEpic,
        isCompanyManaged: isCompanyManaged
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3uhy5.StatusFieldWrapper), {
        isUserAtLeastMember: isUserAtLeastMember,
        shouldRenderRichCard: shouldRenderRichCard,
        cardKey: cardKey,
        cardId: cardId
    })), !isDragHandle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, viewSettings.showDueDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEa6g.DueDate), {
        dueDate: dueDate,
        shouldRenderDueDateColumn: shouldRenderDueDateColumn,
        isDone: isDone
    }), renderMentionsIndicator(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6dmWW.Flag), {
        isFlagged: isFlagged,
        shouldRenderInlineAddFlag: shouldRenderInlineAddFlag,
        onAddFlag: onAddFlag
    }), viewSettings.showEstimate && renderOriginalEstimateField(), viewSettings.showEstimate && renderStoryPointField(), viewSettings.showPriority && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zGZQ.default), {
        isUserAtLeastMember: isUserAtLeastMember,
        issueKey: cardKey,
        shouldRenderRichCard: shouldRenderRichCard,
        shouldRenderColumn: shouldRenderPriorityColumn
    }))), !isDragHandle && viewSettings.showAssignee && renderAssigneeField(), !isDragHandle && renderMenu()), !isDragHandle && renderExtraFields())), isDragHandle && numSelected > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.DragHandleCardsAmount), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
        appearance: "primary",
        testId: (0, $30WDI.CARDS_AMOUNT_BADGE_TESTID)
    }, numSelected)));
};
var $95d9103d2bef0d9b$export$2e2bcd8739ae039 // Chevron icon wrapper, keep it consistent with src/packages/software/backlog/src/view/card-list/card-lite-extended/index.tsx
 = $95d9103d2bef0d9b$var$CardContents;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $95d9103d2bef0d9b$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_yyhy14f8 _1ii7wtyw _1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eyI8O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9967b301fa2e1c2$var$_react = $a9967b301fa2e1c2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $a9967b301fa2e1c2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a9967b301fa2e1c2$var$SubtaskIcon = (props)=>/*#__PURE__*/ $a9967b301fa2e1c2$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor"><path d="M19 7c1.105.003 2 .899 2 2.006v9.988A2.005 2.005 0 0118.994 21H9.006A2.005 2.005 0 017 19h11c.555 0 1-.448 1-1V7zM3 5.006C3 3.898 3.897 3 5.006 3h9.988C16.102 3 17 3.897 17 5.006v9.988A2.005 2.005 0 0114.994 17H5.006A2.005 2.005 0 013 14.994V5.006zM5 5v10h10V5H5z"/><path d="M7.707 9.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L9 10.586 7.707 9.293z"/></g></svg>`
    }, props));
$a9967b301fa2e1c2$var$SubtaskIcon.displayName = 'SubtaskIcon';
var $a9967b301fa2e1c2$var$_default = $a9967b301fa2e1c2$var$SubtaskIcon;
module.exports.default = $a9967b301fa2e1c2$var$_default;

});

parcelRegister("1N1uk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8150a20046b63cd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d89330a12e304d1decdadfb7c7a699ca>>
 * @relayHash 93c0d8d16c4e77e0b03ed1162c0f98a5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8de8818cd89ed97037d20d3a42434b738449fd91fe983e253e41993b4d843c3c
const $d8150a20046b63cd$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraProjectIds"
    }, v3 = {
        "kind": "Literal",
        "name": "filter",
        "value": [
            "RELEASED",
            "UNRELEASED"
        ]
    }, v4 = {
        "kind": "Variable",
        "name": "jiraProjectIds",
        "variableName": "jiraProjectIds"
    }, v5 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v8 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        v3 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v4 /*: any*/ 
    ], v9 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "versionMenuQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "versionsForProjects",
                                    "args": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ],
                                    "concreteType": "JiraVersionConnection",
                                    "kind": "LinkedField",
                                    "name": "__versionBacklogPanelRelay_versionsForProjects_connection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraVersionEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "versionMenu_softwareBacklog_VersionMenuContent"
                                                    },
                                                    v5 /*: any*/ ,
                                                    {
                                                        "concreteType": "JiraVersion",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v6 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.versionsForProjects.edges"
                                        },
                                        v7 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.versionsForProjects"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "versionMenuQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "concreteType": "JiraVersionConnection",
                            "kind": "LinkedField",
                            "name": "versionsForProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraVersionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersion",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "versionId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "status"
                                                },
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        },
                                                        v9 /*: any*/ 
                                                    ]
                                                },
                                                v9 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        v5 /*: any*/ 
                                    ]
                                },
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "args": v8 /*: any*/ ,
                            "filters": [
                                "jiraProjectIds",
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "versionBacklogPanelRelay_versionsForProjects",
                            "kind": "LinkedHandle",
                            "name": "versionsForProjects"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8de8818cd89ed97037d20d3a42434b738449fd91fe983e253e41993b4d843c3c",
            "metadata": {
                "connection": [
                    {
                        "count": "first",
                        "cursor": "after",
                        "direction": "forward",
                        "path": [
                            "jira",
                            "versionsForProjects"
                        ]
                    }
                ]
            },
            "name": "versionMenuQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d8150a20046b63cd$var$node.hash = "ad42f90f36561f245c5fce9acfe51923";
var $d8150a20046b63cd$export$2e2bcd8739ae039 = $d8150a20046b63cd$var$node;

});

const $e8879a4af726a467$export$b9e05b29ae05bdd9 = 32;
const $e8879a4af726a467$export$dce8cd449abd1f77 = 5;
const $e8879a4af726a467$export$1ec3328eed0aedd9 = 300;
const $e8879a4af726a467$export$6b4c950ad6cadf50 = 200;
const $e8879a4af726a467$export$bb89c9064245f005 = 500;
const $e8879a4af726a467$export$f4f3847a7eaec9e9 = 'software-context-menu.ui.context-menu-inner.context-menu-inner-container';
const $e8879a4af726a467$export$b3f11e5d123cdbe9 = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-item.context-menu-submenu';
const $e8879a4af726a467$export$ef86d72244e00c00 = 'software-context-menu.ui.menu-renderer.context-menu-inner.context-menu-node.context-menu-item.chevron-icon';
const $e8879a4af726a467$export$8e765acf3440e0b = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-item.context-menu-item';
const $e8879a4af726a467$export$75f77b2251314894 = 'software-context-menu.ui.menu-renderer.context-menu-inner.context-menu-node.context-menu-item.overflow-visible-popup-container';
const $e8879a4af726a467$export$602eb83148423ac6 = 'software-context-menu.ui.menu-renderer.context-menu-inner.context-menu-node.context-menu-item.tooltip';
const $e8879a4af726a467$export$ae734f89618d3c5f = 'software-context-menu.ui.menu-renderer.context-menu-inner.context-menu-node.context-menu-item.context-menu-label';
const $e8879a4af726a467$export$90350df905144507 = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-search';
const $e8879a4af726a467$export$328d05d650390cfd = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-search.content';
const $e8879a4af726a467$export$1245780b529c0d82 = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-search.loading';
const $e8879a4af726a467$export$803f51dcf576f554 = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-search.no-results';
const $e8879a4af726a467$export$bb79bd28759ee895 = 'context';
const $e8879a4af726a467$export$ee5015c6ad52cf0b = 'meatball';

parcelRegister("ivso4", function(module, exports) {

$parcel$export(module.exports, "ContextMenu", () => $dc3ee5911a6b9611$export$8dc6765e8be191c7);

var $eUqFw = parcelRequire("eUqFw");

var $hCDxr = parcelRequire("hCDxr");

var $5JgJ2 = parcelRequire("5JgJ2");


var $bNhtG = parcelRequire("bNhtG");

var $8MrYx = parcelRequire("8MrYx");

var $1gQ73 = parcelRequire("1gQ73");

var $9sGN6 = parcelRequire("9sGN6");

var $j258X = parcelRequire("j258X");

var $6kjWj = parcelRequire("6kjWj");

var $whrGe = parcelRequire("whrGe");

var $bPVI5 = parcelRequire("bPVI5");

var $lYzsQ = parcelRequire("lYzsQ");

var $kmGl7 = parcelRequire("kmGl7");

var $9cGRb = parcelRequire("9cGRb");

var $6jB1P = parcelRequire("6jB1P");

var $j2ehw = parcelRequire("j2ehw");

var $2ECYR = parcelRequire("2ECYR");

var $8DAgy = parcelRequire("8DAgy");

var $bRC5Z = parcelRequire("bRC5Z");

var $cU7N2 = parcelRequire("cU7N2");

var $cfG6O = parcelRequire("cfG6O");

var $6jc2S = parcelRequire("6jc2S");

var $iEZNy = parcelRequire("iEZNy");

var $4HULd = parcelRequire("4HULd");

var $lC0qI = parcelRequire("lC0qI");

var $fz7Ay = parcelRequire("fz7Ay");

var $guUXv = parcelRequire("guUXv");

var $6n5K0 = parcelRequire("6n5K0");

var $lHIMf = parcelRequire("lHIMf");
const $dc3ee5911a6b9611$export$88a94aa401c6dbd6 = ({ selectedCardIds: selectedCardIds, versionMenuQueryRef: versionMenuQueryRef })=>{
    const priority = (0, $iEZNy.usePriority)({
        selectedCardIds: selectedCardIds
    });
    const assignee = (0, $lYzsQ.useAssignee)({
        selectedCardIds: selectedCardIds
    });
    const estimate = (0, $j2ehw.useEstimate)({
        selectedCardIds: selectedCardIds
    });
    const parent = (0, $cfG6O.useParent)(selectedCardIds);
    const version = (0, $fz7Ay.useVersion)({
        selectedCardIds: selectedCardIds,
        versionMenuQueryRef: versionMenuQueryRef
    });
    const isCompanyManaged = (0, $j258X.useIsCMPBacklog)();
    const isWithinIssueLimit = selectedCardIds.length <= (0, $hCDxr.CONTEXTUAL_BULK_EDIT_ISSUE_LIMIT);
    return isWithinIssueLimit ? [
        ...assignee,
        ...priority,
        ...version,
        ...parent,
        ...!isCompanyManaged ? estimate : []
    ] : [];
};
const $dc3ee5911a6b9611$export$c087a1fcddb96d21 = ({ issueId: issueId, issueKey: issueKey, selectedCardIds: selectedCardIds, versionMenuQueryRef: versionMenuQueryRef })=>{
    const cardIds = (0, $eUqFw.useMemo)(()=>selectedCardIds.includes(issueId) ? selectedCardIds : [
            issueId
        ], [
        issueId,
        selectedCardIds
    ]);
    const isMultiSelect = cardIds?.length > 1;
    const subtasksWithoutParentsAreSelected = (0, $lHIMf.default)(cardIds);
    const header = (0, $bRC5Z.useHeader)({
        selectedCardIds: cardIds
    });
    const moveToActions = (0, $cU7N2.useMoveTo)({
        issueId: issueId,
        cardIds: cardIds,
        hide: subtasksWithoutParentsAreSelected
    });
    const flag = (0, $2ECYR.useFlag)({
        cardIds: cardIds
    });
    const splitIssue = (0, $lC0qI.useSplitIssue)({
        issueId: issueId,
        isMultiSelect: isMultiSelect
    });
    const deleteIssue = (0, $6jB1P.useDeleteIssue)({
        issueId: issueId,
        selectedCardIds: cardIds
    });
    const copyIssueLink = (0, $9cGRb.useCopyIssueLink)({
        selectedCardIds: cardIds,
        issueKey: issueKey
    });
    const copyIssueKey = (0, $kmGl7.useCopyIssueKey)({
        selectedCardIds: cardIds,
        issueKey: issueKey
    });
    const viewInIssueSearch = (0, $guUXv.useViewInIssueSearch)({
        selectedCardIds: cardIds
    });
    const gotoBulkEditor = (0, $8DAgy.useGoToBulkEditor)({
        selectedCardIds: cardIds
    });
    const fieldBulkOperations = $dc3ee5911a6b9611$export$88a94aa401c6dbd6({
        selectedCardIds: cardIds,
        versionMenuQueryRef: versionMenuQueryRef
    });
    // Check if the user is eligible for whiteboard entrypoint experiment and render the plan on whiteboard CTA below the moveTo button before the separator
    const { cohort: cohort, flow: flow } = (0, $1gQ73.useBacklogSelector)((0, $9sGN6.getWhiteboardEligibility));
    const planOnWhiteboard = (0, $6jc2S.usePlanOnWhiteboard)({
        issueKey: issueKey,
        selectedCardIds: selectedCardIds,
        flow: flow
    });
    if (flow && cohort === (0, $6kjWj.WHITEBOARD_ENTRYPOINT_EXPERIMENT_VARIANTS).CONTEXT_MENU) moveToActions.push(...planOnWhiteboard);
    const moveTo = moveToActions.length ? [
        ...moveToActions,
        (0, $4HULd.createSeparator)('move-to-actions')
    ] : [];
    const bulkActions = [
        ...flag,
        ...fieldBulkOperations,
        ...splitIssue
    ];
    const otherActions = [
        ...copyIssueLink,
        ...copyIssueKey,
        ...viewInIssueSearch
    ];
    const deleteAndBulkEditorActions = gotoBulkEditor.length || deleteIssue.length ? [
        (0, $4HULd.createSeparator)('delete-and-bulk-editor-actions'),
        ...gotoBulkEditor,
        ...deleteIssue
    ] : [];
    return [
        ...header,
        ...moveTo,
        ...otherActions,
        ...bulkActions.length ? [
            (0, $4HULd.createSeparator)('bulk-actions'),
            ...bulkActions
        ] : [],
        ...deleteAndBulkEditorActions
    ];
};
const $dc3ee5911a6b9611$var$MenuRendererWithMenuItems = /*#__PURE__*/ (0, $eUqFw.memo)(({ issueId: issueId, issueKey: issueKey, selectedCardIds: selectedCardIds, scope: scope, triggerRef: triggerRef, versionMenuQueryRef: versionMenuQueryRef })=>{
    const menuItems = $dc3ee5911a6b9611$export$c087a1fcddb96d21({
        issueId: issueId,
        issueKey: issueKey,
        selectedCardIds: selectedCardIds,
        versionMenuQueryRef: versionMenuQueryRef
    });
    return(// Prevents drag events being propogated to the parent card
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $whrGe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bNhtG.AsyncMenuRenderer), {
        scope: scope,
        menuItems: menuItems,
        triggerRef: triggerRef
    })));
});
const $dc3ee5911a6b9611$export$8dc6765e8be191c7 = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const { issueId: issueId, issueKey: issueKey, selectedCardIds: selectedCardIds, appearance: appearance, versionMenuQueryRef: versionMenuQueryRef } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const showCompactMode = (0, $8MrYx.useShowCompactMode)();
    const triggerRef = 'triggerRef' in props ? props.triggerRef : null;
    const renderMenu = (0, $eUqFw.useCallback)((scope, menuTriggerRef)=>{
        if (triggerRef && menuTriggerRef?.current) triggerRef.current = menuTriggerRef.current;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dc3ee5911a6b9611$var$MenuRendererWithMenuItems, {
            issueId: issueId,
            issueKey: issueKey,
            selectedCardIds: selectedCardIds,
            versionMenuQueryRef: versionMenuQueryRef,
            scope: scope,
            triggerRef: menuTriggerRef
        });
    }, [
        triggerRef,
        issueId,
        issueKey,
        selectedCardIds,
        versionMenuQueryRef
    ]);
    const handleEscape = (e)=>{
        // this is to prevent the escape key from closing the issue view
        if (e.key === 'Escape') {
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
            if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
        }
    };
    if (appearance === (0, $e8879a4af726a467$export$bb79bd28759ee895)) {
        const { children: children } = props;
        return(// disabling the eslint rule since it asks us to turn this into a button which does not fit our use case
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            onKeyDown: handleEscape,
            "data-testid": (0, $bPVI5.ESCAPE_WRAPPER_TESTID),
            role: "presentation"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bNhtG.AsyncContextMenu), {
            scope: `${issueId}`,
            renderMenu: renderMenu,
            selectedCardIds: selectedCardIds,
            cardId: issueId,
            analyticsMapping: (0, $bPVI5.ANALYTICS_MAPPING_TABLE),
            jsErrorBoundaryProps: {
                id: 'backlogCardListCardContextMenu',
                packageName: 'software-backlog',
                teamName: 'a4t-tanuki'
            }
        }, children)));
    }
    if (appearance === (0, $e8879a4af726a467$export$ee5015c6ad52cf0b)) {
        const { summary: summary, onOpenChange: onOpenChange } = props;
        const ariaLabelMessage = formatMessage(selectedCardIds.length > 1 ? (0, $6n5K0.default).menuTriggerMoreCards : (0, $6n5K0.default).menuTriggerOneCard, {
            summary: summary,
            issueKey: issueKey
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bNhtG.AsyncMeatballMenu), {
            scope: `${issueId}`,
            renderMenu: renderMenu,
            onOpenChange: onOpenChange,
            selectedCardIds: selectedCardIds,
            cardId: issueId,
            analyticsMapping: (0, $bPVI5.ANALYTICS_MAPPING_TABLE),
            ariaLabel: ariaLabelMessage,
            isCompact: showCompactMode,
            jsErrorBoundaryProps: {
                id: 'backlogCardListCardMeatballMenu',
                packageName: 'software-backlog',
                teamName: 'a4t-tanuki'
            }
        });
    }
    return null;
});

});
parcelRegister("hCDxr", function(module, exports) {

$parcel$export(module.exports, "CONTEXTUAL_BULK_EDIT_ISSUE_LIMIT", () => $98afa2a154b9e4a3$export$d05ca0d31d3ffa06);
$parcel$export(module.exports, "BULK_EDIT_SELECTED_ISSUE_LIMIT", () => $98afa2a154b9e4a3$export$45a421fb1ade804f);
$parcel$export(module.exports, "getBulkEditFieldList", () => $98afa2a154b9e4a3$export$e3511e45712e666e);
$parcel$export(module.exports, "FORM_WRAPPER_TEST_ID", () => $98afa2a154b9e4a3$export$71fcb0373c771639);
$parcel$export(module.exports, "FOOTER_CANCEL_BUTTON_TEST_ID", () => $98afa2a154b9e4a3$export$39f1bbbd67c1f72);
$parcel$export(module.exports, "FOOTER_BACK_BUTTON_TEST_ID", () => $98afa2a154b9e4a3$export$a350e08f5290ad98);
$parcel$export(module.exports, "FOOTER_NEXT_BUTTON_TEST_ID", () => $98afa2a154b9e4a3$export$256c8e48a4b7d900);
$parcel$export(module.exports, "EDIT_FIELDS_TEST_ID", () => $98afa2a154b9e4a3$export$9554e5be9bf7faaf);
$parcel$export(module.exports, "EDIT_STATUS_TEST_ID", () => $98afa2a154b9e4a3$export$3f974d81b7882abc);
$parcel$export(module.exports, "FIELD_SEARCH_OPTION_HEIGHT", () => $98afa2a154b9e4a3$export$3d1cf6035bb6e5e6);
$parcel$export(module.exports, "FIELD_SEARCH_OPTION_WITH_FIELD_TYPE_HEIGHT", () => $98afa2a154b9e4a3$export$2bf1ff09810ebfaa);

var $1ybV0 = parcelRequire("1ybV0");

var $lO4Or = parcelRequire("lO4Or");
const $98afa2a154b9e4a3$export$d05ca0d31d3ffa06 = 50; // backlog contextual menu still depends on this constant
const $98afa2a154b9e4a3$export$45a421fb1ade804f = 1000;
const $98afa2a154b9e4a3$export$e3511e45712e666e = ()=>({
        [(0, $lO4Or.ATLASSIAN_TEAM_GQL_FIELD)]: [
            (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)
        ],
        [(0, $lO4Or.CASCADING_SELECT_GQL_FIELD)]: [
            (0, $lO4Or.CASCADING_SELECT_CF_TYPE)
        ],
        [(0, $lO4Or.CHECKBOX_GQL_FIELD)]: [
            (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)
        ],
        [(0, $lO4Or.COLOR_GQL_FIELD)]: [
            (0, $lO4Or.COLOR_CF_TYPE),
            (0, $lO4Or.EPIC_COLOR_TYPE),
            (0, $lO4Or.COLOR_TYPE)
        ],
        [(0, $lO4Or.DATE_PICKER_GQL_FIELD)]: [
            (0, $lO4Or.DATE_CF_TYPE),
            (0, $lO4Or.DUE_DATE_TYPE),
            (0, $lO4Or.BASELINE_START_CF_TYPE),
            (0, $lO4Or.BASELINE_END_CF_TYPE)
        ],
        [(0, $lO4Or.DATE_TIME_GQL_FIELD)]: [
            (0, $lO4Or.DATETIME_CF_TYPE)
        ],
        [(0, $lO4Or.LABEL_GQL_FIELD)]: [
            (0, $lO4Or.LABELS_TYPE),
            (0, $lO4Or.LABELS_CF_TYPE)
        ],
        [(0, $lO4Or.MULTI_GROUP_PICKER_GQL_FIELD)]: [
            (0, $lO4Or.MULTI_GROUP_CF_TYPE)
        ],
        [(0, $lO4Or.MULTI_SELECT_GQL_FIELD)]: [
            (0, $lO4Or.MULTI_SELECT_CF_TYPE)
        ],
        [(0, $lO4Or.MULTI_USER_PICKER_GQL_FIELD)]: [
            (0, $lO4Or.MULTI_USER_CF_TYPE)
        ],
        [(0, $lO4Or.MULTI_VERSION_GQL_FIELD)]: [
            (0, $lO4Or.FIX_VERSIONS_TYPE),
            (0, $lO4Or.AFFECTS_VERSIONS_TYPE),
            (0, $lO4Or.MULTI_VERSION_CF_TYPE)
        ],
        [(0, $lO4Or.NUMBER_GQL_FIELD)]: [
            (0, $lO4Or.NUMBER_CF_TYPE),
            (0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE)
        ],
        [(0, $lO4Or.PARENT_GQL_FIELD)]: [
            (0, $lO4Or.PARENT_TYPE)
        ],
        [(0, $lO4Or.COMPONENTS_GQL_FIELD)]: [
            (0, $lO4Or.COMPONENTS_TYPE)
        ],
        [(0, $lO4Or.PRIORITY_GQL_FIELD)]: [
            (0, $lO4Or.PRIORITY_TYPE)
        ],
        [(0, $lO4Or.PROJECT_GQL_FIELD)]: [
            (0, $lO4Or.ISSUE_FIELD_PROJECT_CF_TYPE),
            (0, $lO4Or.PROJECT_PICKER_CF_TYPE)
        ],
        [(0, $lO4Or.RADIO_GQL_FIELD)]: [
            (0, $lO4Or.RADIO_BUTTONS_CF_TYPE)
        ],
        [(0, $lO4Or.RICH_TEXT_GQL_FIELD)]: [
            (0, $lO4Or.TEXT_AREA_CF_TYPE),
            (0, $lO4Or.ENVIRONMENT_TYPE),
            (0, $lO4Or.COMMENT_TYPE)
        ],
        [(0, $lO4Or.SECURITY_GQL_FIELD)]: [
            (0, $lO4Or.SECURITY_LEVEL_TYPE),
            (0, $lO4Or.SECURITY_LEVEL_TYPE_OVERRIDE)
        ],
        [(0, $lO4Or.SINGLE_GROUP_PICKER_GQL_FIELD)]: [
            (0, $lO4Or.ISSUE_FIELD_SINGLE_GROUP_CF_TYPE),
            (0, $lO4Or.GROUP_CF_TYPE)
        ],
        [(0, $lO4Or.SINGLE_SELECT_GQL_FIELD)]: [
            (0, $lO4Or.SELECT_CF_TYPE)
        ],
        [(0, $lO4Or.SPRINT_GQL_FIELD)]: [
            (0, $lO4Or.SPRINT_TYPE)
        ],
        [(0, $lO4Or.TEXT_GQL_FIELD)]: [
            (0, $lO4Or.TEXT_CF_TYPE)
        ],
        [(0, $lO4Or.URL_GQL_FIELD)]: [
            (0, $lO4Or.URL_CF_TYPE)
        ],
        [(0, $lO4Or.USER_PICKER_GQL_FIELD)]: [
            (0, $lO4Or.ASSIGNEE_TYPE),
            (0, $lO4Or.REPORTER_TYPE),
            (0, $lO4Or.USER_CF_TYPE)
        ],
        [(0, $lO4Or.VERSION_GQL_FIELD)]: [
            (0, $lO4Or.ISSUE_FIELD_VERSION_CF_TYPE),
            (0, $lO4Or.VERSION_CF_TYPE)
        ],
        ...(0, $1ybV0.ff)('thor-add-original-estimate-to-list-of-available-fields_o4qx6') && {
            [(0, $lO4Or.DURATION_GQL_FIELD)]: [
                (0, $lO4Or.TIME_ESTIMATE_TYPE)
            ]
        },
        ...(0, $1ybV0.ff)('render-time-tracking-field-in-bulk-edit_nqgx7') && {
            [(0, $lO4Or.TIME_TRACKING_GQL_FIELD)]: [
                (0, $lO4Or.TIME_TRACKING_TYPE)
            ]
        }
    });
const $98afa2a154b9e4a3$export$71fcb0373c771639 = 'bulk-operations-core.ui.form.form-wrapper';
const $98afa2a154b9e4a3$export$39f1bbbd67c1f72 = 'bulk-operations-core.common.ui.view-footer.cancel-button';
const $98afa2a154b9e4a3$export$a350e08f5290ad98 = 'bulk-operations-core.common.ui.view-footer.back-button';
const $98afa2a154b9e4a3$export$256c8e48a4b7d900 = 'bulk-operations-core.common.ui.view-footer.next-button';
const $98afa2a154b9e4a3$export$9554e5be9bf7faaf = 'bulk-operations-core.ui.toolbar.edit-dropdown.menu.edit-fields';
const $98afa2a154b9e4a3$export$3f974d81b7882abc = 'bulk-operations-core.ui.toolbar.edit-dropdown.menu.edit-status';
const $98afa2a154b9e4a3$export$3d1cf6035bb6e5e6 = 40;
const $98afa2a154b9e4a3$export$2bf1ff09810ebfaa = 50;

});

parcelRegister("bNhtG", function(module, exports) {

$parcel$export(module.exports, "AsyncContextMenu", () => $1f0ee0938fbdec1f$export$88c73a5747b508c6);
$parcel$export(module.exports, "AsyncMeatballMenu", () => $1f0ee0938fbdec1f$export$dad57d856f7c40e9);
$parcel$export(module.exports, "AsyncMenuRenderer", () => $1f0ee0938fbdec1f$export$481d980aecfdabe6);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $9VH28 = parcelRequire("9VH28");

var $laivi = parcelRequire("laivi");
var $gepbf = parcelRequire("gepbf");

var $93Vlr = parcelRequire("93Vlr");

/* istanbul ignore next */ // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1f0ee0938fbdec1f$var$ContextMenuLazy = (0, $7rh0R.lazy)(()=>(parcelRequire("c8xpJ")).then((module)=>module.ContextMenu), {
    moduleId: "./src/packages/software/context-menu/src/ui/index.tsx"
});

/* istanbul ignore next */ // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1f0ee0938fbdec1f$var$MeatballMenuLazy = (0, $7rh0R.lazy)(()=>(parcelRequire("c8xpJ")).then((module)=>module.MeatballMenu), {
    moduleId: "./src/packages/software/context-menu/src/ui/index.tsx"
});

/* istanbul ignore next */ // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1f0ee0938fbdec1f$var$AsyncMenuRendererLazy = (0, $7rh0R.lazy)(()=>(parcelRequire("8LoxZ")).then((module)=>module.MenuRenderer), {
    moduleId: "./src/packages/software/context-menu/src/ui/menu-renderer/index.tsx"
});
const $1f0ee0938fbdec1f$var$InternalAsyncContextMenu = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-software-context-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f0ee0938fbdec1f$var$ContextMenuLazy, props));
const $1f0ee0938fbdec1f$var$InternalAsyncMeatballMenu = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-software-context-menu-meatball-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f0ee0938fbdec1f$var$MeatballMenuLazy, props));
const $1f0ee0938fbdec1f$export$88c73a5747b508c6 = (props)=>{
    const openContextMenuRef = (0, $eUqFw.useRef)(null);
    const childrenRef = (0, $eUqFw.useRef)(null);
    const { onContextMenu: onContextMenu } = (0, $gepbf.useOnContextMenu)({
        childrenRef: childrenRef,
        openContextMenuRef: openContextMenuRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $laivi.ChildrenWrapperWithAnalytics), {
        onChildrenContextMenu: onContextMenu,
        ref: childrenRef
    }, props.children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VH28.ContextMenuErrorBoundary), {
        id: "jira-software-context-menu",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f0ee0938fbdec1f$var$InternalAsyncContextMenu, {
        ...props,
        openContextMenuRef: openContextMenuRef
    })));
};
const $1f0ee0938fbdec1f$export$dad57d856f7c40e9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VH28.ContextMenuErrorBoundary), {
        id: "jira-software-context-menu-meatball-menu",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f0ee0938fbdec1f$var$InternalAsyncMeatballMenu, props));
const $1f0ee0938fbdec1f$export$481d980aecfdabe6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-software-context-menu-menu-renderer",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $93Vlr.MenuRendererPlaceholder), {
            menuItems: props.menuItems
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f0ee0938fbdec1f$var$AsyncMenuRendererLazy, props));

});
parcelRegister("9VH28", function(module, exports) {

$parcel$export(module.exports, "ContextMenuErrorBoundary", () => $758a0e8281722a7d$export$9253ba2022568501);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");
const $758a0e8281722a7d$export$9253ba2022568501 = ({ id: id, children: children, fallback: fallback })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: id,
        packageName: "jiraSoftwareContextMenu",
        fallback: fallback || 'unmount',
        teamName: "deliveroo"
    }, children);

});

parcelRegister("laivi", function(module, exports) {

$parcel$export(module.exports, "ChildrenWrapperWithAnalytics", () => $c26ec081dde345d0$export$1249ce36e893a19b);

var $eUqFw = parcelRequire("eUqFw");

var $g8JvH = parcelRequire("g8JvH");
var $8WuJm = parcelRequire("8WuJm");

const $c26ec081dde345d0$var$WrapperWithAnalytics = (0, $g8JvH.AnalyticsEventToProps)('contextMenu', {
    onContextMenu: 'opened'
})(/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ createAnalyticsEvent: createAnalyticsEvent, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ...props,
        ref: ref
    })));
const $c26ec081dde345d0$export$1249ce36e893a19b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, onChildrenContextMenu: onChildrenContextMenu }, ref)=>{
    const WrapperWithAnalyticsComponent = $c26ec081dde345d0$var$WrapperWithAnalytics;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: {
            inputSource: 'rightClick'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrapperWithAnalyticsComponent, {
        ref: ref,
        onContextMenu: onChildrenContextMenu,
        "data-testid": (0, $1ca77d6485631d49$export$1790245723dd00ad)
    }, children));
});

});
const $1ca77d6485631d49$export$1790245723dd00ad = 'software-context-menu.ui.context-menu.children-wrapper';


parcelRegister("gepbf", function(module, exports) {

$parcel$export(module.exports, "useOnContextMenu", () => $d354b5bc633c6656$export$ca7798d25343efd8);

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $dkPd7 = parcelRequire("dkPd7");
const $d354b5bc633c6656$export$ca7798d25343efd8 = ({ childrenRef: childrenRef, openContextMenuRef: openContextMenuRef })=>{
    const onContextMenu = (0, $dkPd7.useEvent)((e, analyticsEvent)=>{
        e.stopPropagation();
        if ((0, $1ybV0.ff)('sentry-error-trying-to-open-a-context-menu') && (!childrenRef?.current || !openContextMenuRef?.current)) {
            !childrenRef?.current && (0, $guiFP.default)({
                error: new Error('Trying to open a context menu while childrenRef is undefined'),
                meta: {
                    id: 'jira-software-context-menu-controller-on-container-update-flow-start-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            return;
        }
        e.preventDefault();
        // TODO: remove if when cleaning sentry-error-trying-to-open-a-context-menu
        if (!childrenRef?.current || !openContextMenuRef?.current) {
            (0, $guiFP.default)({
                error: new Error(`Trying to open a context menu while childrenRef(${!!childrenRef.current}) or openContextMenuRef(${!!openContextMenuRef.current}) is undefined`),
                meta: {
                    id: 'jira-software-context-menu-controller-on-container-update-flow-start-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            return;
        }
        const { top: top, left: left } = childrenRef.current.getBoundingClientRect();
        const position = {
            x: e.clientX - left,
            y: e.clientY - top
        };
        openContextMenuRef.current.onOpenContextMenu({
            position: position,
            analyticsEvent: analyticsEvent
        });
    });
    return {
        onContextMenu: onContextMenu
    };
};

});

parcelRegister("93Vlr", function(module, exports) {

$parcel$export(module.exports, "MenuRendererPlaceholder", () => $56777e02a2ff1d96$export$9c3503516e6b2b03);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $fMoec = parcelRequire("fMoec");

var $lMuU5 = parcelRequire("lMuU5");

var $92lHN = parcelRequire("92lHN");
const $56777e02a2ff1d96$export$b12353dcfd2c40d3 = (menuItems)=>menuItems.reduce((acc, menuItem)=>{
        if (menuItem.type === (0, $fMoec.MenuNodeType).Separator) return acc + $92lHN.SEPARATOR_PLACEHOLDER_HEIGHT;
        if (menuItem.type === (0, $fMoec.MenuNodeType).Section) return acc + $92lHN.SECTION_HEADER_PLACEHOLDER_HEIGHT + $56777e02a2ff1d96$export$b12353dcfd2c40d3(menuItem.children || []);
        return acc + $92lHN.MENU_ITEM_PLACEHOLDER_HEIGHT;
    }, 0);
const $56777e02a2ff1d96$export$9c3503516e6b2b03 = /*#__PURE__*/ (0, $eUqFw.memo)(({ menuItems: menuItems })=>{
    const height = $56777e02a2ff1d96$export$b12353dcfd2c40d3(menuItems);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($56777e02a2ff1d96$var$Container, {
        "data-testid": $92lHN.CONTEXT_MENU_PLACEHOLDER_TESTID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($56777e02a2ff1d96$var$InnerItems, {
        height: height
    }));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $56777e02a2ff1d96$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $lMuU5.MenuContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bsbuuw1",
            __cmplp.className
        ])
    });
});
const $56777e02a2ff1d96$var$InnerItems = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $9t7rW.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i2nrh _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fMoec", function(module, exports) {

$parcel$export(module.exports, "MenuNodeType", () => $b0a03dbb9a1ca17b$export$d6a3c2c57b227e3b);
const $b0a03dbb9a1ca17b$export$d6a3c2c57b227e3b = {
    Item: 'item',
    Node: 'node',
    Separator: 'separator',
    Section: 'section',
    Search: 'search',
    BulkIndicator: 'bulkIndicator'
};

});

parcelRegister("lMuU5", function(module, exports) {

$parcel$export(module.exports, "MenuContainer", () => $843521fd84243f5d$export$b286f91cddfedb5a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $843521fd84243f5d$export$b286f91cddfedb5a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul9uuw1 _c71ldgin _1yt4swc3 _2rko1l7b _vchhusvi _11q71bhr",
            __cmplp.className
        ])
    });
});

});

parcelRegister("92lHN", function(module, exports) {

$parcel$export(module.exports, "CONTEXT_MENU_PLACEHOLDER_TESTID", () => $3b09de0aa375d2ff$export$d0775d7ba1f28e6);
$parcel$export(module.exports, "SEPARATOR_PLACEHOLDER_HEIGHT", () => $3b09de0aa375d2ff$export$49b3e4b8a0edc9b7);
$parcel$export(module.exports, "SECTION_HEADER_PLACEHOLDER_HEIGHT", () => $3b09de0aa375d2ff$export$71999dec35730ebd);
$parcel$export(module.exports, "MENU_ITEM_PLACEHOLDER_HEIGHT", () => $3b09de0aa375d2ff$export$f9717b5566f9ac9f);
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles

var $c9TLT = parcelRequire("c9TLT");

const $3b09de0aa375d2ff$export$d0775d7ba1f28e6 = 'software-context-menu.ui.menu-renderer-placeholder';
const $3b09de0aa375d2ff$export$49b3e4b8a0edc9b7 = (0, $c9TLT.gridSize) + 1;
const $3b09de0aa375d2ff$export$71999dec35730ebd = (0, $c9TLT.gridSize) * 2;
const $3b09de0aa375d2ff$export$f9717b5566f9ac9f = (0, $e8879a4af726a467$export$b9e05b29ae05bdd9);

});


parcelRegister("c8xpJ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('HZ2Bg');
        const value = parcelRequire('dag3g');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("HZ2Bg").then(()=>parcelRequire('dag3g'));
}

});

parcelRegister("8LoxZ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('k4Snr');
        const value = parcelRequire('etFdJ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("k4Snr").then(()=>parcelRequire('etFdJ'));
}

});


parcelRegister("whrGe", function(module, exports) {

$parcel$export(module.exports, "default", () => $0234121912daca43$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $0234121912daca43$var$stopDrag = (e)=>{
    e.preventDefault();
    e.stopPropagation();
};
/**
 * Prevents `dragstart` events from within child elements from bubbling
 */ const $0234121912daca43$var$BlockDrag = ({ children: children })=>// Need to mark this as `draggable` in order for `onDragStart`
    // to fire when attempting to drag child elements
    // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        draggable: true,
        onDragStart: $0234121912daca43$var$stopDrag
    }, children);
var $0234121912daca43$export$2e2bcd8739ae039 = $0234121912daca43$var$BlockDrag;

});

parcelRegister("bPVI5", function(module, exports) {

$parcel$export(module.exports, "MOVE_TO_MENU_ID", () => $77d861931227c0c5$export$5645be38d58b5483);
$parcel$export(module.exports, "MOVE_TO_TOP_OF_BACKLOG_MENU_ID", () => $77d861931227c0c5$export$13ba6c00d633f348);
$parcel$export(module.exports, "MOVE_TO_BOTTOM_OF_BACKLOG_MENU_ID", () => $77d861931227c0c5$export$319beca788666a0d);
$parcel$export(module.exports, "MOVE_TO_BOARD_MENU_ID", () => $77d861931227c0c5$export$4afa86666270dba0);
$parcel$export(module.exports, "MOVE_TO_SEARCH_MENU_ID", () => $77d861931227c0c5$export$b54531036348079);
$parcel$export(module.exports, "RANK_MENU_UP_ID", () => $77d861931227c0c5$export$10226786f3562a0a);
$parcel$export(module.exports, "RANK_MENU_DOWN_ID", () => $77d861931227c0c5$export$ff981f621183205f);
$parcel$export(module.exports, "FLAG_MENU_ID", () => $77d861931227c0c5$export$63cb4152f50d2665);
$parcel$export(module.exports, "FLAG_ADD_FLAG_MENU_ID", () => $77d861931227c0c5$export$efe455e4d4b4aca9);
$parcel$export(module.exports, "FLAG_REMOVE_FLAG_MENU_ID", () => $77d861931227c0c5$export$356329b49381740c);
$parcel$export(module.exports, "COPY_ISSUE_LINK_MENU_ID", () => $77d861931227c0c5$export$34b38d58090a7162);
$parcel$export(module.exports, "COPY_ISSUE_KEY_MENU_ID", () => $77d861931227c0c5$export$2e74ac183d49087);
$parcel$export(module.exports, "HEADER_BULK_INDICATOR_MENU_ID", () => $77d861931227c0c5$export$bdfa217711a39d8d);
$parcel$export(module.exports, "VIEW_IN_ISSUE_SEARCH_MENU_ID", () => $77d861931227c0c5$export$4231ab934953c1bc);
$parcel$export(module.exports, "SPLIT_ISSUE_MENU_ID", () => $77d861931227c0c5$export$b7bce247cd0b2a49);
$parcel$export(module.exports, "DELETE_ISSUE_MENU_ID", () => $77d861931227c0c5$export$b35363b92f22bb89);
$parcel$export(module.exports, "SEPARATOR_MENU_ID", () => $77d861931227c0c5$export$1fa1533b8d6efd51);
$parcel$export(module.exports, "STORY_POINTS_MENU_ID", () => $77d861931227c0c5$export$38cc7f6fd54f040a);
$parcel$export(module.exports, "STORY_POINTS_EDIT_MENU_ID", () => $77d861931227c0c5$export$d913180634f6bb7a);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_MENU_ID", () => $77d861931227c0c5$export$f44075570bbdc5a9);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_EDIT_MENU_ID", () => $77d861931227c0c5$export$e7a2177d793805f9);
$parcel$export(module.exports, "PARENT_MENU_ID", () => $77d861931227c0c5$export$744dc4889ca2fd20);
$parcel$export(module.exports, "PARENT_SEARCH_MENU_ID", () => $77d861931227c0c5$export$21f306406b358f4f);
$parcel$export(module.exports, "VERSION_MENU_ID", () => $77d861931227c0c5$export$bd3b3ff7a0a9e25a);
$parcel$export(module.exports, "PRIORITY_MENU_ID", () => $77d861931227c0c5$export$203cb0fa00d01abe);
$parcel$export(module.exports, "ASSIGNEE_MENU_ID", () => $77d861931227c0c5$export$c3421a7192b5f002);
$parcel$export(module.exports, "ASSIGNEE_SEARCH_MENU_ID", () => $77d861931227c0c5$export$ddf4731675705ca4);
$parcel$export(module.exports, "GO_TO_BULK_EDITOR_MENU_ID", () => $77d861931227c0c5$export$109f329d0ffd3326);
$parcel$export(module.exports, "PLAN_ON_WHITEBOARD_MENU_ID", () => $77d861931227c0c5$export$b7344797d0384ac5);
$parcel$export(module.exports, "ANALYTICS_MAPPING_TABLE", () => $77d861931227c0c5$export$77ab83fd54e2c3c);
$parcel$export(module.exports, "ESCAPE_WRAPPER_TESTID", () => $77d861931227c0c5$export$341cb34540d073ad);

var $lO4Or = parcelRequire("lO4Or");
const $77d861931227c0c5$export$5645be38d58b5483 = 'actions/move-to';
const $77d861931227c0c5$export$13ba6c00d633f348 = 'actions/move-to/top-of-backlog';
const $77d861931227c0c5$export$319beca788666a0d = 'actions/move-to/bottom-of-backlog';
const $77d861931227c0c5$export$4afa86666270dba0 = 'actions/move-to/board';
const $77d861931227c0c5$export$b54531036348079 = 'actions/move-to/search';
const $77d861931227c0c5$export$10226786f3562a0a = 'actions/move-to/rank-up';
const $77d861931227c0c5$export$ff981f621183205f = 'actions/move-to/rank-down';
const $77d861931227c0c5$export$63cb4152f50d2665 = 'actions/flag';
const $77d861931227c0c5$export$efe455e4d4b4aca9 = 'actions/flag/add-flag';
const $77d861931227c0c5$export$356329b49381740c = 'actions/flag/remove-flag';
const $77d861931227c0c5$export$34b38d58090a7162 = 'actions/copy-issue-link';
const $77d861931227c0c5$export$2e74ac183d49087 = 'actions/copy-issue-key';
const $77d861931227c0c5$export$bdfa217711a39d8d = 'bulk-indicator';
const $77d861931227c0c5$export$4231ab934953c1bc = 'actions/view-in-issue-search';
const $77d861931227c0c5$export$b7bce247cd0b2a49 = 'actions/split-issue';
const $77d861931227c0c5$export$b35363b92f22bb89 = 'actions/delete-issue';
const $77d861931227c0c5$export$1fa1533b8d6efd51 = 'separator';
const $77d861931227c0c5$export$38cc7f6fd54f040a = 'actions/story-point';
const $77d861931227c0c5$export$d913180634f6bb7a = 'actions/story-point/edit';
const $77d861931227c0c5$export$f44075570bbdc5a9 = 'actions/original-estimate';
const $77d861931227c0c5$export$e7a2177d793805f9 = 'actions/original-estimate/edit';
const $77d861931227c0c5$export$744dc4889ca2fd20 = 'actions/parent';
const $77d861931227c0c5$export$21f306406b358f4f = 'actions/parent/search';
const $77d861931227c0c5$export$bd3b3ff7a0a9e25a = 'actions/version';
const $77d861931227c0c5$export$203cb0fa00d01abe = 'actions/priority';
const $77d861931227c0c5$export$c3421a7192b5f002 = 'actions/assignee';
const $77d861931227c0c5$export$ddf4731675705ca4 = 'actions/assignee/search';
const $77d861931227c0c5$export$109f329d0ffd3326 = 'actions/go-to-bulk-editor';
const $77d861931227c0c5$export$b7344797d0384ac5 = 'actions/plan-on-whiteboard';
const $77d861931227c0c5$export$95244264c7c3e7b5 = {
    attributes: {
        actionGroup: 'move'
    }
};
const $77d861931227c0c5$export$e4c12f391981e0cf = {
    attributes: {
        actionGroup: 'update'
    }
};
const $77d861931227c0c5$export$77ab83fd54e2c3c = {
    [$77d861931227c0c5$export$5645be38d58b5483]: {
        actionSubjectId: 'moveToSprintDropdownItem',
        ...$77d861931227c0c5$export$95244264c7c3e7b5
    },
    [$77d861931227c0c5$export$13ba6c00d633f348]: {
        actionSubjectId: 'moveToTopBacklogDropdownItem',
        ...$77d861931227c0c5$export$95244264c7c3e7b5
    },
    [$77d861931227c0c5$export$319beca788666a0d]: {
        actionSubjectId: 'moveToBottomBacklogDropdownItem',
        ...$77d861931227c0c5$export$95244264c7c3e7b5
    },
    [$77d861931227c0c5$export$4afa86666270dba0]: {
        actionSubjectId: 'moveToBoardDropdownItem',
        ...$77d861931227c0c5$export$95244264c7c3e7b5
    },
    [$77d861931227c0c5$export$efe455e4d4b4aca9]: {
        actionSubjectId: 'addFlagDropdownItem',
        ...$77d861931227c0c5$export$e4c12f391981e0cf
    },
    [$77d861931227c0c5$export$356329b49381740c]: {
        actionSubjectId: 'removeFlagDropdownItem',
        ...$77d861931227c0c5$export$e4c12f391981e0cf
    },
    [$77d861931227c0c5$export$4231ab934953c1bc]: 'viewIssueSearchDropdownItem',
    [$77d861931227c0c5$export$109f329d0ffd3326]: 'goToBulkEditorDropdownItem',
    [$77d861931227c0c5$export$b7bce247cd0b2a49]: 'splitIssueDropdownItem',
    [$77d861931227c0c5$export$b35363b92f22bb89]: 'deleteDropdownItem',
    [$77d861931227c0c5$export$34b38d58090a7162]: 'copyIssueLink',
    [$77d861931227c0c5$export$2e74ac183d49087]: 'copyIssueKey',
    [$77d861931227c0c5$export$d913180634f6bb7a]: {
        actionSubjectId: 'updateEstimateDropdownItem',
        attributes: {
            ...$77d861931227c0c5$export$e4c12f391981e0cf.attributes,
            fieldKey: 'storyPointEstimate'
        }
    },
    [$77d861931227c0c5$export$e7a2177d793805f9]: {
        actionSubjectId: 'updateEstimateDropdownItem',
        attributes: {
            ...$77d861931227c0c5$export$e4c12f391981e0cf.attributes,
            fieldKey: (0, $lO4Or.TIME_ESTIMATE_TYPE)
        }
    },
    [$77d861931227c0c5$export$c3421a7192b5f002]: {
        actionSubjectId: 'updateAssigneeDropdownItem',
        attributes: {
            ...$77d861931227c0c5$export$e4c12f391981e0cf.attributes,
            fieldKey: (0, $lO4Or.ASSIGNEE_TYPE)
        }
    },
    [$77d861931227c0c5$export$203cb0fa00d01abe]: {
        actionSubjectId: 'updatePriorityDropdownItem',
        attributes: {
            ...$77d861931227c0c5$export$e4c12f391981e0cf.attributes,
            fieldKey: (0, $lO4Or.PRIORITY_TYPE)
        }
    },
    [$77d861931227c0c5$export$744dc4889ca2fd20]: {
        actionSubjectId: 'updateParentDropdownItem',
        attributes: {
            ...$77d861931227c0c5$export$e4c12f391981e0cf.attributes,
            fieldKey: (0, $lO4Or.PARENT_TYPE)
        }
    }
};
const $77d861931227c0c5$export$341cb34540d073ad = 'software-backlog.card-list.card.context-menu.escape-wrapper';

});

parcelRegister("lYzsQ", function(module, exports) {

$parcel$export(module.exports, "useAssignee", () => $4023536d20a4ef9b$export$db27ad834dc313f2);

var $eUqFw = parcelRequire("eUqFw");

var $MYW4e = parcelRequire("MYW4e");

var $iJlfe = parcelRequire("iJlfe");

var $2OdyW = parcelRequire("2OdyW");

var $5JgJ2 = parcelRequire("5JgJ2");
var $4ksts = parcelRequire("4ksts");


var $6cPKE = parcelRequire("6cPKE");

var $fMoec = parcelRequire("fMoec");

var $lGLse = parcelRequire("lGLse");

var $1gQ73 = parcelRequire("1gQ73");

var $emJ23 = parcelRequire("emJ23");

var $bP7Jx = parcelRequire("bP7Jx");

var $7kNqR = parcelRequire("7kNqR");

var $bPVI5 = parcelRequire("bPVI5");

var $6n5K0 = parcelRequire("6n5K0");
const $4023536d20a4ef9b$export$f3d2344ae01372eb = ({ options: options, isLoading: isLoading, canAssign: canAssign, setQuery: setQuery })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return canAssign ? [
        {
            type: (0, $fMoec.MenuNodeType).Item,
            label: formatMessage((0, $6n5K0.default).assignee),
            id: (0, $bPVI5.ASSIGNEE_MENU_ID),
            submenuWidth: 284,
            children: [
                {
                    type: (0, $fMoec.MenuNodeType).Search,
                    id: (0, $bPVI5.ASSIGNEE_SEARCH_MENU_ID),
                    children: options,
                    hasSearch: true,
                    isAsyncSearch: true,
                    isLoading: isLoading,
                    onChange: (value)=>setQuery(value),
                    ariaLabel: formatMessage((0, $6n5K0.default).ariaLabel)
                }
            ]
        }
    ] : [];
};
const $4023536d20a4ef9b$export$db27ad834dc313f2 = ({ selectedCardIds: selectedCardIds })=>{
    const intl = (0, $4ksts.useIntlV2)(); // used to obtain unassigned and automatic user options
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [assignees, setAssignees] = (0, $eUqFw.useState)([]);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [query, setQuery] = (0, $eUqFw.useState)('');
    const getIssueKey = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.makeCardKeyFromCardId));
    const [{ data: loggedInUser }] = (0, $lGLse.useUserSubscriber)();
    const unassigned = (0, $eUqFw.useMemo)(()=>(0, $6cPKE.getUserOptionFromUser)((0, $6cPKE.getUnassignedUser)(intl)), [
        intl
    ]);
    const automatic = (0, $eUqFw.useMemo)(()=>(0, $6cPKE.getUserOptionFromUser)((0, $6cPKE.getAutomaticUserOption)(intl)), [
        intl
    ]);
    const assignToMe = (0, $eUqFw.useMemo)(()=>loggedInUser ? (0, $6cPKE.getUserOptionFromUser)({
            ...loggedInUser,
            displayName: formatMessage((0, $6n5K0.default).assignToMe)
        }) : null, [
        formatMessage,
        loggedInUser
    ]);
    const defaultOptions = (0, $eUqFw.useMemo)(()=>[
            unassigned,
            automatic,
            ...assignToMe ? [
                assignToMe
            ] : []
        ], [
        assignToMe,
        automatic,
        unassigned
    ]);
    const onAssigneeClick = (0, $1gQ73.useBacklogActionCreator)((assignee, analyticsEvent)=>(0, $MYW4e.batchActions)(selectedCardIds.map((id)=>(0, $emJ23.cardAssigneeSetOptimistic)({
                cardId: id,
                assignee: assignee.id === (0, $7a4a7348bcf111f0$export$bdab9bfb39981463) ? null : {
                    avatarUrl: assignee.avatarUrl,
                    displayName: assignee.name,
                    id: assignee.id
                }
            }, getIssueKey(id), analyticsEvent))));
    const fetchUsers = (keywords)=>(0, $2OdyW.default)(`/rest/api/2/user/search?query=${keywords}`);
    (0, $eUqFw.useEffect)(()=>{
        const handleSearch = async (value)=>{
            setIsLoading(true);
            try {
                const response = await fetchUsers(value);
                setAssignees(response.length ? response.map((0, $6cPKE.getUserOptionFromUser)) : []);
            } catch  {
                setAssignees(defaultOptions);
            }
            setIsLoading(false);
        };
        if (query.length) handleSearch(query);
        else setAssignees(defaultOptions);
    }, [
        query,
        defaultOptions
    ]);
    const options = (0, $eUqFw.useMemo)(()=>assignees.map((assignee)=>({
                type: (0, $fMoec.MenuNodeType).Item,
                label: assignee.name,
                id: `${0, $bPVI5.ASSIGNEE_MENU_ID}__value_${assignee.id}`,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                    src: assignee.avatarUrl,
                    size: "small"
                }),
                onClick: (analyticsEvent)=>onAssigneeClick(assignee, analyticsEvent)
            })), [
        assignees,
        onAssigneeClick
    ]);
    const canBulkEdit = (0, $1gQ73.useBacklogSelector)((0, $7kNqR.canBulkEditIssues));
    const canAssignIssue = (0, $1gQ73.useBacklogSelector)((0, $7kNqR.canAssignIssues));
    const canAssign = canAssignIssue && canBulkEdit;
    return $4023536d20a4ef9b$export$f3d2344ae01372eb({
        options: options,
        isLoading: isLoading,
        canAssign: canAssign,
        setQuery: setQuery
    });
};

});
parcelRegister("6n5K0", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b53e0e9ec5e4cf3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7b53e0e9ec5e4cf3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    moveTo: {
        "id": "backlog.card-list.card.context-menu.move-to",
        "defaultMessage": "Move to"
    },
    topOfTheBacklog: {
        "id": "backlog.card-list.card.context-menu.top-of-the-backlog",
        "defaultMessage": "Top of backlog"
    },
    bottomOfTheBacklog: {
        "id": "backlog.card-list.card.context-menu.bottom-of-the-backlog",
        "defaultMessage": "Bottom of backlog"
    },
    board: {
        "id": "backlog.card-list.card.context-menu.board",
        "defaultMessage": "Board"
    },
    delete: {
        "id": "backlog.card-list.card.context-menu.delete",
        "defaultMessage": "Delete"
    },
    archive: {
        "id": "backlog.card-list.card.context-menu.archive",
        "defaultMessage": "Archive"
    },
    flag: {
        "id": "backlog.card-list.card.context-menu.flag",
        "defaultMessage": "Flag"
    },
    addFlag: {
        "id": "backlog.card-list.card.context-menu.add-flag",
        "defaultMessage": "Add flag"
    },
    removeFlag: {
        "id": "backlog.card-list.card.context-menu.remove-flag",
        "defaultMessage": "Remove flag"
    },
    copyIssueLink: {
        "id": "backlog.card-list.card.context-menu.copy-issue-link",
        "defaultMessage": "Copy issue link"
    },
    copyIssueKey: {
        "id": "backlog.card-list.card.context-menu.copy-issue-key",
        "defaultMessage": "Copy issue key"
    },
    viewInIssueSearch: {
        "id": "backlog.card-list.card.context-menu.view-in-issue-search",
        "defaultMessage": "View in issue search"
    },
    splitIssue: {
        "id": "backlog.card-list.card.context-menu.split-issue",
        "defaultMessage": "Split issue"
    },
    addIssueParent: {
        "id": "backlog.card-list.card.context-menu.add-issue-parent",
        "defaultMessage": "Add parent"
    },
    changeIssueParent: {
        "id": "backlog.card-list.card.context-menu.change-issue-parent",
        "defaultMessage": "Change parent"
    },
    parentOptionLabel: {
        "id": "backlog.card-list.card.context-menu.parent-option-label",
        "defaultMessage": "Parent"
    },
    parentUnlinkOptionLabel: {
        "id": "backlog.card-list.card.context-menu.parent-unlink-option-label",
        "defaultMessage": "Unlink"
    },
    versionOptionLabel: {
        "id": "backlog.card-list.card.context-menu.version-option-label",
        "defaultMessage": "Version"
    },
    versionUnlinkOptionLabel: {
        "id": "backlog.card-list.card.context-menu.version-unlink-option-label",
        "defaultMessage": "Unlink"
    },
    originalEstimate: {
        "id": "backlog.card-list.card.context-menu.original-estimate",
        "defaultMessage": "Original estimate"
    },
    storyPointEstimate: {
        "id": "backlog.card-list.card.context-menu.story-point-estimate",
        "defaultMessage": "Story point estimate"
    },
    priority: {
        "id": "backlog.card-list.card.context-menu.priority",
        "defaultMessage": "Priority"
    },
    assignee: {
        "id": "backlog.card-list.card.context-menu.assignee",
        "defaultMessage": "Assignee"
    },
    assignToMe: {
        "id": "backlog.card-list.card.context-menu.assign-to-me",
        "defaultMessage": "Assign to me"
    },
    bulkChange: {
        "id": "backlog.card-list.card.context-menu.bulk-change",
        "defaultMessage": "Bulk change"
    },
    goToBulkEditorIconLabel: {
        "id": "backlog.card-list.card.context-menu.go-to-bulk-editor-icon-label",
        "defaultMessage": "Open in new window"
    },
    menuTriggerOneCard: {
        "id": "backlog.card-list.card.context-menu.menu-trigger-one-card",
        "defaultMessage": "More actions for {issueKey} {summary}"
    },
    menuTriggerMoreCards: {
        "id": "backlog.card-list.card.context-menu.menu-trigger-more-cards",
        "defaultMessage": "More actions for {issueKey} {summary} and other selected issues"
    },
    rankUp: {
        "id": "backlog.card-list.card.context-menu.rank-up",
        "defaultMessage": "Move up"
    },
    rankDown: {
        "id": "backlog.card-list.card.context-menu.rank-down",
        "defaultMessage": "Move down"
    },
    copyIssueKeySuccessTitle: {
        "id": "backlog.card-list.card.context-menu.copy-issue-key-success-title",
        "defaultMessage": "Issue key copied"
    },
    copyIssueKeySuccessDescription: {
        "id": "backlog.card-list.card.context-menu.copy-issue-key-success-description",
        "defaultMessage": "Issue key successfully copied to your clipboard"
    },
    ariaLabel: {
        "id": "backlog.card-list.card.context-menu.aria-label",
        "defaultMessage": "Select assignee"
    },
    sprintSearchPlaceholder: {
        "id": "backlog.card-list.card.context-menu.sprint-search-placeholder",
        "defaultMessage": "Search sprints"
    }
});

});


parcelRegister("kmGl7", function(module, exports) {

$parcel$export(module.exports, "useCopyIssueKey", () => $ccbaff083043399e$export$e5e3fbcc29675793);

var $3tfzg = parcelRequire("3tfzg");
var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fMoec = parcelRequire("fMoec");

var $bPVI5 = parcelRequire("bPVI5");

var $6n5K0 = parcelRequire("6n5K0");
const $ccbaff083043399e$export$e5e3fbcc29675793 = ({ issueKey: issueKey, selectedCardIds: selectedCardIds })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    if (selectedCardIds.length > 1) return [];
    const onCopyIssueKey = ()=>navigator.clipboard.writeText(issueKey).then(()=>{
            showFlag({
                type: 'success',
                title: (0, $6n5K0.default).copyIssueKeySuccessTitle,
                description: (0, $6n5K0.default).copyIssueKeySuccessDescription
            });
        }).catch(()=>{
            showFlag((0, $3tfzg.default).genericError());
        });
    return [
        {
            type: (0, $fMoec.MenuNodeType).Item,
            label: formatMessage((0, $6n5K0.default).copyIssueKey),
            id: (0, $bPVI5.COPY_ISSUE_KEY_MENU_ID),
            onClick: onCopyIssueKey
        }
    ];
};

});

parcelRegister("9cGRb", function(module, exports) {

$parcel$export(module.exports, "useCopyIssueLink", () => $e8d760cd15cafeb0$export$8fa8485fafd17cef);

var $3tfzg = parcelRequire("3tfzg");
var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fMoec = parcelRequire("fMoec");

var $9s6ck = parcelRequire("9s6ck");

var $bPVI5 = parcelRequire("bPVI5");

var $6n5K0 = parcelRequire("6n5K0");
const $e8d760cd15cafeb0$export$30a9fe39fb33160d = ({ issueKey: issueKey, selectedCardIds: selectedCardIds })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const issueUrl = `${window.location.protocol}//${window.location.hostname}/browse/${issueKey}`;
    if (selectedCardIds.length > 1) return [];
    const onCopyIssueLink = ()=>navigator.clipboard.writeText(issueUrl).then(()=>{
            showFlag((0, $9s6ck.showCopySuccessfulFlag)());
        }).catch(()=>{
            showFlag((0, $3tfzg.default).genericError());
        });
    return [
        {
            type: (0, $fMoec.MenuNodeType).Item,
            label: formatMessage((0, $6n5K0.default).copyIssueLink),
            id: (0, $bPVI5.COPY_ISSUE_LINK_MENU_ID),
            onClick: onCopyIssueLink
        }
    ];
};
const $e8d760cd15cafeb0$export$8fa8485fafd17cef = ({ issueKey: issueKey, selectedCardIds: selectedCardIds })=>$e8d760cd15cafeb0$export$30a9fe39fb33160d({
        issueKey: issueKey,
        selectedCardIds: selectedCardIds
    });

});
parcelRegister("9s6ck", function(module, exports) {

$parcel$export(module.exports, "showCopySuccessfulFlag", () => $d7297463ee78d72f$export$9fd15e3f1d1c1c2a);

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");

var $eGI9v = parcelRequire("eGI9v");

var $eP9Rz = parcelRequire("eP9Rz");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $bDuts = parcelRequire("bDuts");
const $d7297463ee78d72f$export$9fd15e3f1d1c1c2a = ()=>({
        type: 'success',
        title: (0, $bDuts.default).copySuccessTitle,
        description: (0, $bDuts.default).copySuccessMessage
    });
const $d7297463ee78d72f$var$DropdownItemWithAnalytics = (0, $eGI9v.default)('dropdownItem', {
    onClick: 'clicked'
})((0, $hD6GJ.default));
const $d7297463ee78d72f$export$d3521c5b8d9fbf8d = (props)=>{
    const { issueUrl: issueUrl } = props;
    const baseUrl = '';
    const fullIssueUrl = `${window.location.protocol}//${window.location.hostname}${baseUrl}${issueUrl}`;
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eP9Rz.default), {
        shouldFitContainer: true,
        hideFieldText: true,
        label: "",
        tooltipLabel: "",
        value: fullIssueUrl,
        tooltipDisabled: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d7297463ee78d72f$var$DropdownItemWithAnalytics, {
        onClick: (e, analyticsEvent)=>{
            // @ts-expect-error Second argument should be of format "actionSubject action"
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'dropdownItem', 'copyIssueLink', {
                nextGenProject: true
            });
            showFlag($d7297463ee78d72f$export$9fd15e3f1d1c1c2a());
        }
    }, formatMessage((0, $bDuts.default).copyLink)))));
};
var $d7297463ee78d72f$export$2e2bcd8739ae039 = $d7297463ee78d72f$export$d3521c5b8d9fbf8d;

});
parcelRegister("hD6GJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $67738981858b3f25$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");

var $e7PSD = parcelRequire("e7PSD");

var $bo4OB = parcelRequire("bo4OB");

var $h1Q9j = parcelRequire("h1Q9j");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-item/usage)
 */ const $67738981858b3f25$var$DropdownMenuItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, ...rest }, ref)=>{
    const itemRef = (0, $h1Q9j.default)();
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        ...rest
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
});
var $67738981858b3f25$export$2e2bcd8739ae039 = $67738981858b3f25$var$DropdownMenuItem;

});
parcelRegister("h1Q9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $6def866028b8c887$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dkYal = parcelRequire("dkYal");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $6def866028b8c887$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $6def866028b8c887$export$2e2bcd8739ae039 = $6def866028b8c887$var$useRegisterItemWithFocusManager;

});
parcelRegister("dkYal", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $cf3cae93cc4408b7$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $cf3cae93cc4408b7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $eN43R = parcelRequire("eN43R");

var $9wjz6 = parcelRequire("9wjz6");
const $cf3cae93cc4408b7$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic.
 */ const $cf3cae93cc4408b7$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    const { isLayerDisabled: isLayerDisabled } = (0, $eN43R.UNSAFE_useLayering)();
    // Intentionally rebinding on each render
    (0, $eUqFw.useEffect)(()=>{
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $9wjz6.default)(menuItemRefs.current, isLayerDisabled, onClose)
        });
    });
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf3cae93cc4408b7$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $cf3cae93cc4408b7$export$2e2bcd8739ae039 = $cf3cae93cc4408b7$var$FocusManager;

});
parcelRegister("9wjz6", function(module, exports) {

$parcel$export(module.exports, "default", () => $66539497081f56cc$export$2e2bcd8739ae039);

const $66539497081f56cc$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $66539497081f56cc$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        if (isLayerDisabled()) {
            // if nested dropdown isOpen we need to close on Tab key press
            if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        const action = $66539497081f56cc$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx < refs.length - 1) {
                    const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                } else {
                    const firstFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                    firstFocusableElement?.focus();
                }
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx > 0) {
                    const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                } else {
                    const lastFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                    lastFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $54717ce5fa2c74b1$export$390330c10ff2b9a1 = 'ArrowUp';
const $54717ce5fa2c74b1$export$a80636c6f41931fe = 'ArrowDown';
const $54717ce5fa2c74b1$export$4af703091671bc = 'Home';
const $54717ce5fa2c74b1$export$e2bc30913faa5db7 = 'End';
const $54717ce5fa2c74b1$export$10f6869ed0a7d75b = 'Tab';
const $54717ce5fa2c74b1$export$8152f929a25a0ff4 = 'Enter';
const $54717ce5fa2c74b1$export$e51a3576c045c8d5 = 'Space';
const $54717ce5fa2c74b1$export$2bb790b9008907b4 = 'Escape';





parcelRegister("eP9Rz", function(module, exports) {

$parcel$export(module.exports, "default", () => $447f96b73f1cfa1f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dFlYh = parcelRequire("dFlYh");
class $447f96b73f1cfa1f$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            className: undefined,
            shouldFitContainer: false,
            hideFieldText: false,
            onCopyClick: undefined,
            onCopyReset: undefined,
            tooltipDelay: undefined,
            remountOnChange: false,
            tooltipDisabled: false
        };
    }
    componentWillUnmount() {
        clearTimeout(this.timeoutId);
    }
    render() {
        const { id: id, label: label, tooltipLabel: tooltipLabel, tooltipLabelPosition: tooltipLabelPosition, tooltipDelay: tooltipDelay, remountOnChange: remountOnChange, value: value, className: className, shouldFitContainer: shouldFitContainer, hideFieldText: hideFieldText, tooltipDisabled: tooltipDisabled } = this.props;
        // When the input field holding the copy text is hidden, its value is not set in
        // the input field to avoid it accidentally being included in a selection when the user
        // is copying other content on the page.
        const fieldValue = hideFieldText ? '' : value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dFlYh.default), {
            id: id,
            label: label,
            tooltipLabel: tooltipLabel,
            tooltipLabelPosition: tooltipLabelPosition,
            tooltipDelay: tooltipDelay,
            remountOnChange: remountOnChange,
            fieldKey: value,
            value: fieldValue,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            shouldFitContainer: shouldFitContainer,
            hideFieldText: hideFieldText,
            ...this.state,
            onCopyClick: this.onCopyClick,
            innerInputRef: this.onRef,
            tooltipDisabled: tooltipDisabled
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            copied: false,
            copyFailed: false
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onCopyClick = (event, analyticsEvent)=>{
            if (!this.inputTextRef || !this.inputTextRef.current) return;
            this.props.onCopyClick && this.props.onCopyClick(event, analyticsEvent);
            if (this.props.hideFieldText) // For hidden fields, update the input field ref to include the value only after the user
            // has clicked the copy button.
            this.inputTextRef.current.value = this.props.value;
            this.inputTextRef.current.select();
            let success = false;
            try {
                success = document.execCommand('copy');
                this.setState({
                    copied: true
                });
                this.props.onClickChange && this.props.onClickChange(true);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                success = false;
            }
            if (!success) this.setState({
                copyFailed: true
            });
            // @ts-expect-error - TS2322 - Type 'Timeout' is not assignable to type 'number'.
            this.timeoutId = setTimeout(()=>{
                this.setState({
                    copied: false,
                    copyFailed: false
                });
                this.props.onCopyReset && this.props.onCopyReset();
            }, 3000);
            if (this.props.onCopyFinish) this.props.onCopyFinish();
        };
        this.onRef = (ref)=>{
            this.inputTextRef = ref;
        };
    }
}

});
parcelRegister("dFlYh", function(module, exports) {

$parcel$export(module.exports, "default", () => $f28c74331b850b05$export$2e2bcd8739ae039);

var $SA3Qe = parcelRequire("SA3Qe");

var $f28c74331b850b05$export$2e2bcd8739ae039 = (0, $SA3Qe.default);

});
parcelRegister("SA3Qe", function(module, exports) {

$parcel$export(module.exports, "StyledButton", () => $a70a2edd0ca4f430$export$2d5d2ba3c7c8c40b);
$parcel$export(module.exports, "default", () => $a70a2edd0ca4f430$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bbaTG = parcelRequire("bbaTG");

var $dmCPj = parcelRequire("dmCPj");

var $cf2Y4 = parcelRequire("cf2Y4");

var $8cU5f = parcelRequire("8cU5f");

var $bujW1 = parcelRequire("bujW1");

var $c9TLT = parcelRequire("c9TLT");

var $dzpl6 = parcelRequire("dzpl6");

var $1ybV0 = parcelRequire("1ybV0");

var $giAhk = parcelRequire("giAhk");


var $cJa0J = parcelRequire("cJa0J");

var $aV7qy = parcelRequire("aV7qy");
class $a70a2edd0ca4f430$export$71579edc8f362e35 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            id: (0, $df17f23b8446e341$export$4f0520e0d7c4c7b0),
            className: undefined,
            copyFailed: false,
            shouldFitContainer: false,
            hideFieldText: false,
            tooltipDelay: 100,
            remountOnChange: false
        };
    }
    constructor(props){
        super(props);
        this.textInput = /*#__PURE__*/ (0, $eUqFw.createRef)();
        this.props.innerInputRef(this.textInput);
    }
    renderDefaultButton() {
        const { tooltipLabel: tooltipLabel, onCopyClick: onCopyClick } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a70a2edd0ca4f430$export$2d5d2ba3c7c8c40b, {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a70a2edd0ca4f430$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dmCPj))), {
                label: tooltipLabel
            })),
            onClick: onCopyClick
        });
    }
    render() {
        const { id: id, fieldKey: fieldKey, value: value, label: label, tooltipLabel: tooltipLabel, tooltipLabelPosition: tooltipLabelPosition, tooltipDelay: tooltipDelay, remountOnChange: remountOnChange, intl: intl, copied: copied, onCopyClick: onCopyClick, shouldFitContainer: shouldFitContainer, copyFailed: copyFailed, hideFieldText: hideFieldText, tooltipDisabled: tooltipDisabled, ...props } = this.props;
        let actualTooltipLabel = tooltipLabel;
        if (copied) actualTooltipLabel = intl.formatMessage((0, $cJa0J.default).copied);
        else if (copyFailed) actualTooltipLabel = intl.formatMessage((0, $cJa0J.default).copyFailed);
        const copyButton = !this.props.children ? null : // @ts-expect-error - TS2769 - No overload matches this call.
        /*#__PURE__*/ (0, $eUqFw.cloneElement)((0, $eUqFw.Children).only(this.props.children), {
            onClick: onCopyClick
        });
        return(// @ts-expect-error - TS2741 - Property 'hideFieldText' is missing in type '{ children: Element[]; className: string | undefined; innerInputRef: (arg1: HTMLInputElementRef) => void; }' but required in type 'Readonly<ThemedOuterStyledProps<ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & { hideFieldText: boolean; }, any>>'.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aV7qy.Root), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aV7qy.FieldContainer), {
            shouldFitContainer: shouldFitContainer,
            hideFieldText: hideFieldText
        }, label && !hideFieldText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bujW1.default), {
            htmlFor: (0, $df17f23b8446e341$export$4f0520e0d7c4c7b0),
            label: label
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
            "aria-hidden": hideFieldText ? 'true' : undefined,
            key: fieldKey,
            id: id,
            name: (0, $df17f23b8446e341$export$4f0520e0d7c4c7b0),
            label: label,
            value: value,
            isReadOnly: true,
            ref: this.textInput,
            tabIndex: hideFieldText ? -1 : undefined
        })), tooltipDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a70a2edd0ca4f430$var$FlexGrow, null, copyButton || this.renderDefaultButton()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            tag: "span",
            key: remountOnChange ? actualTooltipLabel : undefined,
            delay: tooltipDelay,
            position: tooltipLabelPosition,
            content: (0, $1ybV0.ff)('sptn-1885-fix-to-update-tooltip-content_pa23s') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                "aria-live": "assertive"
            }, actualTooltipLabel) : actualTooltipLabel
        }, copyButton || this.renderDefaultButton())));
    }
}
var $a70a2edd0ca4f430$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($a70a2edd0ca4f430$export$71579edc8f362e35);
const $a70a2edd0ca4f430$export$2d5d2ba3c7c8c40b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        ...props,
        theme: (0, $dzpl6.getTheme)({
            buttonStyles: {
                default: {
                    height: `${(0, $c9TLT.gridSize) * 5}px`,
                    width: `${(0, $c9TLT.gridSize) * 5}px`
                }
            }
        })
    });
$a70a2edd0ca4f430$export$2d5d2ba3c7c8c40b.displayName = 'StyledButton'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a70a2edd0ca4f430$var$IconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0t94y",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a70a2edd0ca4f430$var$FlexGrow = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dmCPj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9bab72963b78cefe$var$_react = $9bab72963b78cefe$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $9bab72963b78cefe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9bab72963b78cefe$var$CopyIcon = (props)=>/*#__PURE__*/ $9bab72963b78cefe$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor"><path d="M10 19h8V8h-8v11zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2.001 2.001 0 018 19.008V7.992z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13H5zm2 0h8V5H7v11z"/></g></svg>`
    }, props));
$9bab72963b78cefe$var$CopyIcon.displayName = 'CopyIcon';
var $9bab72963b78cefe$var$_default = $9bab72963b78cefe$var$CopyIcon;
module.exports.default = $9bab72963b78cefe$var$_default;

});

parcelRegister("cf2Y4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecaf8c9a10cf48c9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $abUSh = parcelRequire("abUSh");
const $ecaf8c9a10cf48c9$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $ecaf8c9a10cf48c9$var$Textfield = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $eUqFw.useRef)(null);
    const handleOnFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnMouseDown = (0, $eUqFw.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $eUqFw.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    const containerStyles = (0, $eUqFw.useMemo)(()=>(0, $abUSh.containerStyles)(appearance, width), [
        appearance,
        width
    ]);
    const inputStyle = (0, $abUSh.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, elemBeforeInput, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ...spreadProps,
        "aria-invalid": isInvalid ? isInvalid : undefined,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    }), elemAfterInput));
});
var $ecaf8c9a10cf48c9$export$2e2bcd8739ae039 = $ecaf8c9a10cf48c9$var$Textfield;

});
parcelRegister("abUSh", function(module, exports) {

$parcel$export(module.exports, "containerStyles", () => $6ff5b404db052892$export$5972a68b6e54f38f);
$parcel$export(module.exports, "inputStyles", () => $6ff5b404db052892$export$3eeb47dc8e6249d9);

var $PdmhA = parcelRequire("PdmhA");
const $6ff5b404db052892$var$backgroundColor = {
    standard: `var(--ds-background-input, ${(0, $PdmhA.N10)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorFocus = {
    standard: `var(--ds-background-input-pressed, ${(0, $PdmhA.N0)})`,
    subtle: `var(--ds-background-input-pressed, ${(0, $PdmhA.N0)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorHover = {
    standard: `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`,
    subtle: `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColor = {
    standard: `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorFocus = {
    standard: `var(--ds-border-focused, ${(0, $PdmhA.B200)})`,
    subtle: `var(--ds-border-focused, ${(0, $PdmhA.B200)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorHover = {
    standard: `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    subtle: "var(--ds-border-input, transparent)",
    none: 'transparent'
};
const $6ff5b404db052892$var$getContainerTextBgAndBorderColor = (appearance)=>({
        backgroundColor: $6ff5b404db052892$var$backgroundColor[appearance],
        borderColor: $6ff5b404db052892$var$borderColor[appearance],
        color: `var(--ds-text, ${0, $PdmhA.N900})`,
        cursor: 'text',
        '&:hover:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorHover[appearance],
            borderColor: $6ff5b404db052892$var$borderColorHover[appearance]
        },
        '&:focus-within:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorFocus[appearance],
            borderColor: $6ff5b404db052892$var$borderColorFocus[appearance],
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$6ff5b404db052892$var$borderColorFocus[appearance]}`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $PdmhA.N70})`,
            cursor: 'not-allowed',
            // Disabled background and border styles should not be applied to components that
            // have either no background or transparent background to begin with
            ...appearance === 'standard' && {
                backgroundColor: `var(--ds-background-disabled, ${0, $PdmhA.N10})`,
                borderColor: `var(--ds-background-disabled, ${0, $PdmhA.N10})`
            }
        },
        '&[data-invalid], &[data-invalid]:hover': {
            borderColor: `var(--ds-border-danger, ${0, $PdmhA.R400})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $PdmhA.R400})`}`
        },
        '&[data-invalid]:focus-within': {
            backgroundColor: `var(--ds-background-input-pressed, ${0, $PdmhA.N0})`,
            borderColor: `var(--ds-border-focused, ${0, $PdmhA.B200})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $PdmhA.B200})`}`
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[data-invalid]:focus-within': {
                borderColor: 'Highlight'
            },
            '&:focus-within': {
                borderColor: 'Highlight'
            },
            '&[data-disabled]': {
                borderColor: 'GrayText'
            }
        }
    });
const $6ff5b404db052892$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $6ff5b404db052892$var$getMaxWidth = (width)=>!width ? `100%` : width in $6ff5b404db052892$var$widthMap ? $6ff5b404db052892$var$widthMap[width] : +width;
const $6ff5b404db052892$export$5972a68b6e54f38f = (appearance, width)=>({
        alignItems: 'center',
        ...$6ff5b404db052892$var$getContainerTextBgAndBorderColor(appearance),
        borderRadius: 3,
        borderWidth: "var(--ds-border-width, 1px)",
        // add 1px padding on both top and bottom to keep the same overall height after border reduced from 2px to 1px under feature flag
        ...appearance !== 'none' ? {
            padding: `${"var(--ds-border-width, 1px)"} 0`
        } : {},
        borderStyle: appearance === 'none' ? 'none' : 'solid',
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 100%',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        justifyContent: 'space-between',
        maxWidth: $6ff5b404db052892$var$getMaxWidth(width),
        overflow: 'hidden',
        transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
        wordWrap: 'break-word',
        verticalAlign: 'top',
        pointerEvents: 'auto'
    });
const $6ff5b404db052892$export$3eeb47dc8e6249d9 = ()=>({
        backgroundColor: 'transparent',
        border: 0,
        boxSizing: 'border-box',
        color: 'inherit',
        cursor: 'inherit',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        minWidth: '0',
        outline: 'none',
        width: '100%',
        '&[data-monospaced]': {
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
        },
        '&[data-compact]': {
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&:not([data-compact])': {
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&[disabled]': {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: `var(--ds-text-disabled, ${0, $PdmhA.N70})`
        },
        // Hide the clear indicator on Edge (Windows only)
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        },
        '&::placeholder': {
            color: `var(--ds-text-subtlest, ${0, $PdmhA.N200})`,
            '&:disabled': {
                color: `var(--ds-text-disabled, ${0, $PdmhA.N70})`
            }
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[disabled]': {
                color: 'GrayText'
            }
        }
    });

});


parcelRegister("bujW1", function(module, exports) {

$parcel$export(module.exports, "default", () => $1634e0d0f9f8a3e7$export$2e2bcd8739ae039);

var $8BJaJ = parcelRequire("8BJaJ");
var $1634e0d0f9f8a3e7$export$2e2bcd8739ae039 = (0, $8BJaJ.FieldLabel);

});
parcelRegister("8BJaJ", function(module, exports) {

$parcel$export(module.exports, "FieldLabel", () => $816236d547316819$export$1acdcf5a973a8414);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $PdmhA = parcelRequire("PdmhA");

var $4lTFP = parcelRequire("4lTFP");

var $c9TLT = parcelRequire("c9TLT");
const $816236d547316819$export$1acdcf5a973a8414 = ({ label: label, htmlFor: htmlFor, isRequired: isRequired = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($816236d547316819$var$Label, {
        htmlFor: htmlFor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($816236d547316819$var$LabelText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, label), isRequired ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($816236d547316819$var$RequiredIndicator, {
        role: "presentation"
    }, "*") : null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $816236d547316819$var$Label = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule",
            __cmplp.className
        ])
    });
});
const $816236d547316819$var$LabelText = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-9kgl5s-0"
})`${(0, $4lTFP.h200)()} display:block;font-family:${(0, $c9TLT.fontFamily)};margin:0;${(0, $kwce8.css)({
    padding: `${"var(--ds-space-250, 20px)"} 0px ${"var(--ds-space-050, 4px)"} 0px`
})}`;
// eslint-disable-next-line @typescript-eslint/no-explicit-any,  @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $816236d547316819$var$RequiredIndicator = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "sc-9kgl5s-1"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-danger, ${(0, $PdmhA).R400})`,
    fontFamily: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $c9TLT.fontFamily,
    paddingLeft: "var(--ds-space-025, 2px)"
});
$816236d547316819$var$RequiredIndicator.displayName = 'RequiredIndicator';

});


parcelRegister("dzpl6", function(module, exports) {

$parcel$export(module.exports, "getTheme", () => $55e2e88bfdce03b8$export$89cbf1a0881c8b9c);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // @ts-expect-error - TS2614 - Module '"@atlaskit/button"' has no exported member 'ButtonTheme'. Did you mean to use 'import ButtonTheme from "@atlaskit/button"' instead?

var $PdmhA = parcelRequire("PdmhA");
const $55e2e88bfdce03b8$export$9e61512f2dc2cbb0 = (currentTheme, props)=>{
    const { buttonStyles: buttonStyles, ...rest } = currentTheme(props);
    const theme = {
        ...rest,
        buttonStyles: {
            ...buttonStyles,
            backgroundColor: (0, $PdmhA).P400,
            '> span': {
                color: (0, $PdmhA).N0
            }
        }
    };
    return theme;
};
const $55e2e88bfdce03b8$export$f9380c9a627682d3 = (newTheme, themeProps)=>{
    const { appearance: appearance, mode: mode, state: state } = themeProps;
    if (!appearance || !newTheme[appearance]) return undefined;
    const root = newTheme[appearance];
    // @ts-expect-error - TS2739 - Type 'Record<string, any>' is missing the following properties from type 'ThemeTokens': buttonStyles, spinnerStyles
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys(root).reduce((acc, val)=>{
        let node = root;
        [
            val,
            state,
            mode
        ].forEach((item)=>{
            if (!item) return;
            if (!node[item] && node[item] !== 0) return;
            if (typeof node[item] !== 'object') {
                acc[val] = node[item];
                return;
            }
            // @ts-expect-error - TS2322 - Type 'string | number | { [key: string]: string | number; } | T' is not assignable to type '{ [key: string]: string | number; } | T'.
            node = node[item];
        });
        return acc;
    }, {});
};
const $55e2e88bfdce03b8$export$89cbf1a0881c8b9c = (overrides)=>(currentTheme, themeProps)=>{
        const theme = currentTheme(themeProps);
        // @ts-expect-error - TS2322 - Type 'Record<string, any>' is not assignable to type 'ThemeTokens'.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const styles = Object.entries(theme).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (acc, [key, value])=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<ThemeTokens>'.
            if (!overrides?.[key]) {
                acc[key] = value;
                return acc;
            }
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<ThemeTokens>'.
            const overriddenStyles = $55e2e88bfdce03b8$export$f9380c9a627682d3(overrides[key], themeProps);
            acc[key] = {
                ...value,
                ...overriddenStyles
            };
            return acc;
        }, {});
        return styles;
    };

});

const $df17f23b8446e341$export$4f0520e0d7c4c7b0 = 'field-copy-text';

parcelRegister("cJa0J", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4aec29dc4c903c3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a4aec29dc4c903c3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    copied: {
        "id": "common.field-copy-text.copied",
        "defaultMessage": "Copied!"
    },
    copyFailed: {
        "id": "common.field-copy-text.copy-failed",
        "defaultMessage": "Couldn't copy to clipboard"
    }
});

});

parcelRegister("aV7qy", function(module, exports) {

$parcel$export(module.exports, "Root", () => $e50c2b052b0ce017$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "FieldContainer", () => $e50c2b052b0ce017$export$b5c4b0e7cd7f148b);
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");
const $e50c2b052b0ce017$export$be92b6f5f03c0fe9 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1g0si8d-0"
})({
    display: 'flex',
    alignItems: 'flex-end'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.hideFieldText === true ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $kwce8.css)({
        userSelect: 'none'
    }) : '');
const $e50c2b052b0ce017$export$b5c4b0e7cd7f148b = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1g0si8d-1"
})({
    marginRight: "var(--ds-space-100, 8px)"
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.shouldFitContainer ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $kwce8.css)({
        flexGrow: 1
    }) : '', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.hideFieldText === true ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $kwce8.css)({
        position: 'absolute',
        left: '-9999px',
        height: 0,
        opacity: 0,
        pointerEvents: 'none',
        userSelect: 'none'
    }) : '');

});




parcelRegister("bDuts", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d08e3ca05ec59f2$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8d08e3ca05ec59f2$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    copyLink: {
        "id": "software-copy-to-clipboard.copy-link",
        "defaultMessage": "Copy issue link"
    },
    copySuccessTitle: {
        "id": "software-copy-to-clipboard.copy-success-title",
        "defaultMessage": "Issue link copied"
    },
    copySuccessMessage: {
        "id": "software-copy-to-clipboard.copy-success-message",
        "defaultMessage": "Issue link successfully copied to your clipboard"
    }
});

});



parcelRegister("6jB1P", function(module, exports) {

$parcel$export(module.exports, "useDeleteIssue", () => $1dd8d697856df3d9$export$43383fdc9fe04fe6);

var $5JgJ2 = parcelRequire("5JgJ2");

var $fMoec = parcelRequire("fMoec");


var $1gQ73 = parcelRequire("1gQ73");

var $cbRhO = parcelRequire("cbRhO");

var $7kNqR = parcelRequire("7kNqR");

var $bPVI5 = parcelRequire("bPVI5");

var $6n5K0 = parcelRequire("6n5K0");
const $1dd8d697856df3d9$export$33577be3a49c7499 = ({ isDeleteEnabled: isDeleteEnabled, onDeleteIssue: onDeleteIssue, selectedCardIds: selectedCardIds })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (!isDeleteEnabled || selectedCardIds.length > 1) return [];
    return [
        {
            type: (0, $fMoec.MenuNodeType).Item,
            label: formatMessage((0, $6n5K0.default).delete),
            id: (0, $bPVI5.DELETE_ISSUE_MENU_ID),
            onClick: onDeleteIssue
        }
    ];
};
const $1dd8d697856df3d9$export$43383fdc9fe04fe6 = ({ issueId: issueId, selectedCardIds: selectedCardIds })=>{
    const isDeleteEnabled = (0, $1gQ73.useBacklogSelector)((0, $7kNqR.canDeleteIssues));
    const onDeleteIssue = (0, $1gQ73.useBacklogActionCreator)(()=>(0, $cbRhO.openModal)({
            type: (0, $ebd52ea7083e351b$export$87c7cb14aa706e2d),
            payload: {
                cardId: issueId
            }
        }));
    return $1dd8d697856df3d9$export$33577be3a49c7499({
        isDeleteEnabled: isDeleteEnabled,
        onDeleteIssue: onDeleteIssue,
        selectedCardIds: selectedCardIds
    });
};

});

parcelRegister("j2ehw", function(module, exports) {

$parcel$export(module.exports, "useEstimate", () => $8bb28a662cbb0fe8$export$3c38ee13c0bb43f6);

var $eUqFw = parcelRequire("eUqFw");

var $MYW4e = parcelRequire("MYW4e");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lO4Or = parcelRequire("lO4Or");

var $fMoec = parcelRequire("fMoec");

var $7TyGu = parcelRequire("7TyGu");

var $1gQ73 = parcelRequire("1gQ73");

var $bxHyy = parcelRequire("bxHyy");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $1ircG = parcelRequire("1ircG");

var $7kNqR = parcelRequire("7kNqR");

var $bPVI5 = parcelRequire("bPVI5");

var $6n5K0 = parcelRequire("6n5K0");

var $eYJUz = parcelRequire("eYJUz");

var $5rgMx = parcelRequire("5rgMx");
const $8bb28a662cbb0fe8$export$5fc1a8ac15e506ee = ({ onSubmit: onSubmit, onCancel: onCancel })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const createConfirmHandler = (0, $eUqFw.useCallback)((scope, closeMenu, analyticsEvent)=>(value)=>onSubmit({
                scope: scope,
                value: value,
                closeMenu: closeMenu,
                analyticsEvent: analyticsEvent
            }), [
        onSubmit
    ]);
    const createCancelHandler = (0, $eUqFw.useCallback)((scope, closeMenu, analyticsEvent)=>()=>onCancel({
                scope: scope,
                closeMenu: closeMenu,
                analyticsEvent: analyticsEvent
            }), [
        onCancel
    ]);
    return [
        {
            type: (0, $fMoec.MenuNodeType).Item,
            id: (0, $bPVI5.STORY_POINTS_MENU_ID),
            label: formatMessage((0, $6n5K0.default).storyPointEstimate),
            shouldOverflowChildren: true,
            submenuWidth: 86,
            children: [
                {
                    type: (0, $fMoec.MenuNodeType).Node,
                    id: (0, $bPVI5.STORY_POINTS_EDIT_MENU_ID),
                    node: ({ scope: scope, closeMenu: closeMenu, analyticsEvent: analyticsEvent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5rgMx.AsyncStoryPointField), {
                            onConfirm: createConfirmHandler(scope, closeMenu, analyticsEvent),
                            onCancel: createCancelHandler(scope, closeMenu, analyticsEvent)
                        })
                }
            ]
        }
    ];
};
const $8bb28a662cbb0fe8$export$14002335a55c84dc = ({ onSubmit: onSubmit, onCancel: onCancel, timeTrackingOptions: timeTrackingOptions })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const createConfirmHandler = (0, $eUqFw.useCallback)((scope, closeMenu, analyticsEvent)=>(estimate)=>onSubmit({
                scope: scope,
                estimate: estimate,
                closeMenu: closeMenu,
                analyticsEvent: analyticsEvent
            }), [
        onSubmit
    ]);
    const createCancelHandler = (0, $eUqFw.useCallback)((scope, closeMenu, analyticsEvent)=>()=>onCancel({
                scope: scope,
                closeMenu: closeMenu,
                analyticsEvent: analyticsEvent
            }), [
        onCancel
    ]);
    if (!timeTrackingOptions) return [];
    return [
        {
            type: (0, $fMoec.MenuNodeType).Item,
            id: (0, $bPVI5.ORIGINAL_ESTIMATE_MENU_ID),
            label: formatMessage((0, $6n5K0.default).originalEstimate),
            shouldOverflowChildren: true,
            submenuWidth: 126,
            children: [
                {
                    type: (0, $fMoec.MenuNodeType).Node,
                    id: (0, $bPVI5.ORIGINAL_ESTIMATE_EDIT_MENU_ID),
                    node: ({ scope: scope, closeMenu: closeMenu, analyticsEvent: analyticsEvent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eYJUz.AsyncOriginalEstimateField), {
                            onConfirm: createConfirmHandler(scope, closeMenu, analyticsEvent),
                            onCancel: createCancelHandler(scope, closeMenu, analyticsEvent),
                            timeTrackingOptions: timeTrackingOptions
                        })
                }
            ]
        }
    ];
};
const $8bb28a662cbb0fe8$export$3c38ee13c0bb43f6 = ({ selectedCardIds: selectedCardIds })=>{
    const estimationType = (0, $1gQ73.useBacklogSelector)((state)=>(0, $1ircG.getEstimationType)(state));
    const timeTrackingOptions = (0, $1gQ73.useBacklogSelector)((state)=>(0, $hkGxG.getTimeTrackingOptions)(state));
    const estimationFieldId = (0, $1gQ73.useBacklogSelector)((0, $1ircG.getEstimationFieldId));
    const getIssueKey = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.makeCardKeyFromCardId));
    const canBulkEdit = (0, $1gQ73.useBacklogSelector)((0, $7kNqR.canBulkEditIssues));
    const canEdit = (0, $1gQ73.useBacklogSelector)((0, $7kNqR.canEditIssue));
    const handleCancel = (0, $eUqFw.useCallback)(({ closeMenu: closeMenu })=>{
        closeMenu();
    }, []);
    const handleSubmitStoryPoint = (0, $1gQ73.useBacklogActionCreator)(({ value: value, closeMenu: closeMenu, analyticsEvent: analyticsEvent })=>{
        closeMenu();
        const actions = selectedCardIds.map((id)=>(0, $bxHyy.cardEstimateSetOptimistic)({
                cardId: id,
                estimate: {
                    storyPoints: value
                }
            }, {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                estimationFieldId: estimationFieldId,
                issueKey: getIssueKey(id)
            }, analyticsEvent));
        return (0, $MYW4e.batchActions)(actions);
    });
    const handleSubmitOriginalEstimate = (0, $1gQ73.useBacklogActionCreator)(({ estimate: estimate, closeMenu: closeMenu, analyticsEvent: analyticsEvent })=>{
        closeMenu();
        const actions = selectedCardIds.map((id)=>(0, $bxHyy.cardEstimateSetOptimistic)({
                cardId: id,
                estimate: {
                    originalEstimate: {
                        value: estimate.value || 0,
                        valueAsText: estimate.valueAsText
                    }
                }
            }, {
                estimationFieldId: (0, $lO4Or.TIME_TRACKING_TYPE),
                issueKey: getIssueKey(id)
            }, analyticsEvent));
        return (0, $MYW4e.batchActions)(actions);
    });
    const storyPointContent = $8bb28a662cbb0fe8$export$5fc1a8ac15e506ee({
        onSubmit: handleSubmitStoryPoint,
        onCancel: handleCancel
    });
    const originalEstimateContent = $8bb28a662cbb0fe8$export$14002335a55c84dc({
        onSubmit: handleSubmitOriginalEstimate,
        onCancel: handleCancel,
        timeTrackingOptions: timeTrackingOptions
    });
    const canEditEstimate = canBulkEdit && canEdit && !!estimationFieldId;
    if (canEditEstimate && estimationType === (0, $7TyGu.STORY_POINTS)) return storyPointContent;
    if (canEditEstimate && estimationType === (0, $7TyGu.ORIGINAL_ESTIMATE)) return originalEstimateContent;
    return [];
};

});
parcelRegister("eYJUz", function(module, exports) {

$parcel$export(module.exports, "AsyncOriginalEstimateField", () => $e333befb40a30b38$export$46675481a7613e3e);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e333befb40a30b38$var$OriginalEstimateFieldLazy = (0, $7rh0R.lazy)(()=>(parcelRequire("g8TCe")).then((module)=>module.OriginalEstimateField), {
    moduleId: "./src/packages/software/backlog/src/view/card-list/card/context-menu/menu-items/estimate/original-estimate-field/index.tsx"
});
const $e333befb40a30b38$export$46675481a7613e3e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "bulkops-original-estimate-field",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e333befb40a30b38$var$OriginalEstimateFieldLazy, props));

});
parcelRegister("g8TCe", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8pulQ');
        const value = parcelRequire('iS48k');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8pulQ").then(()=>parcelRequire('iS48k'));
}

});


parcelRegister("5rgMx", function(module, exports) {

$parcel$export(module.exports, "AsyncStoryPointField", () => $4ac4c8393cb542a7$export$91cc9e87752d0bf8);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4ac4c8393cb542a7$var$StoryPointFieldLazy = (0, $7rh0R.lazy)(()=>(parcelRequire("cENxr")).then((module)=>module.StoryPointField), {
    moduleId: "./src/packages/software/backlog/src/view/card-list/card/context-menu/menu-items/estimate/story-point-field/index.tsx"
});
const $4ac4c8393cb542a7$export$91cc9e87752d0bf8 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "bulkops-story-point-field",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4ac4c8393cb542a7$var$StoryPointFieldLazy, props));

});
parcelRegister("cENxr", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('95JjU');
        const value = parcelRequire('kLUCS');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("95JjU").then(()=>parcelRequire('kLUCS'));
}

});



parcelRegister("2ECYR", function(module, exports) {

$parcel$export(module.exports, "useFlag", () => $65fbf442da902171$export$983b9b54330812cb);

var $eUqFw = parcelRequire("eUqFw");

var $f43UE = parcelRequire("f43UE");

var $8urXR = parcelRequire("8urXR");

var $PdmhA = parcelRequire("PdmhA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $c1Zpg = parcelRequire("c1Zpg");

var $fMoec = parcelRequire("fMoec");


var $1gQ73 = parcelRequire("1gQ73");

var $cbRhO = parcelRequire("cbRhO");

var $bP7Jx = parcelRequire("bP7Jx");

var $7kNqR = parcelRequire("7kNqR");

var $bPVI5 = parcelRequire("bPVI5");

var $6n5K0 = parcelRequire("6n5K0");

var $e3DbB = parcelRequire("e3DbB");
const $65fbf442da902171$export$81c94ca566d6fb97 = ({ cardIds: cardIds })=>{
    const cards = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getCards));
    const flaggedStates = cardIds.map((cardId)=>cards[cardId]?.isFlagged);
    if (flaggedStates.every((isFlagged)=>isFlagged)) return (0, $e3DbB.SelectedIssueFlaggedState).ALL_FLAGGED;
    if (flaggedStates.every((isFlagged)=>!isFlagged)) return (0, $e3DbB.SelectedIssueFlaggedState).NONE_FLAGGED;
    return (0, $e3DbB.SelectedIssueFlaggedState).INDETERMINATE;
};
const $65fbf442da902171$export$64037f4178ea2950 = ({ selectedIssuesFlaggedState: selectedIssuesFlaggedState, onToggleFlag: onToggleFlag, canFlag: canFlag })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (!canFlag) return [];
    const addFlag = {
        type: (0, $fMoec.MenuNodeType).Item,
        id: (0, $bPVI5.FLAG_ADD_FLAG_MENU_ID),
        label: formatMessage((0, $6n5K0.default).addFlag),
        onClick: ()=>onToggleFlag(true)
    };
    const removeFlag = {
        type: (0, $fMoec.MenuNodeType).Item,
        id: (0, $bPVI5.FLAG_REMOVE_FLAG_MENU_ID),
        label: formatMessage((0, $6n5K0.default).removeFlag),
        onClick: ()=>onToggleFlag(false)
    };
    switch(selectedIssuesFlaggedState){
        case (0, $e3DbB.SelectedIssueFlaggedState).NONE_FLAGGED:
            return [
                addFlag
            ];
        case (0, $e3DbB.SelectedIssueFlaggedState).ALL_FLAGGED:
            return [
                removeFlag
            ];
        case (0, $e3DbB.SelectedIssueFlaggedState).INDETERMINATE:
        default:
            return [
                {
                    type: (0, $fMoec.MenuNodeType).Item,
                    label: formatMessage((0, $6n5K0.default).flag),
                    id: (0, $bPVI5.FLAG_MENU_ID),
                    children: [
                        {
                            ...addFlag,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8urXR))), {
                                label: formatMessage((0, $6n5K0.default).addFlag),
                                primaryColor: `var(--ds-icon-danger, ${(0, $PdmhA).R300})`
                            })
                        },
                        {
                            ...removeFlag,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f43UE))), {
                                label: formatMessage((0, $6n5K0.default).removeFlag)
                            })
                        }
                    ]
                }
            ];
    }
};
const $65fbf442da902171$export$983b9b54330812cb = ({ cardIds: cardIds })=>{
    const selectedCardsForFlagWithCommentModal = (0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.cardsForFlagWithCommentModalFromCardIdsSelector)(state)(cardIds));
    const onToggleFlag = (0, $1gQ73.useBacklogActionCreator)((flag)=>(0, $cbRhO.openModal)({
            type: (0, $ebd52ea7083e351b$export$34f52cb2089ddc40),
            payload: {
                flagAction: flag ? (0, $c1Zpg.ADD) : (0, $c1Zpg.REMOVE),
                cards: selectedCardsForFlagWithCommentModal
            }
        }));
    const canFlag = (0, $1gQ73.useBacklogSelector)((0, $7kNqR.canEditIssue));
    const selectedIssuesFlaggedState = $65fbf442da902171$export$81c94ca566d6fb97({
        cardIds: cardIds
    });
    return $65fbf442da902171$export$64037f4178ea2950({
        selectedIssuesFlaggedState: selectedIssuesFlaggedState,
        onToggleFlag: onToggleFlag,
        canFlag: canFlag
    });
};

});
parcelRegister("f43UE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af7a43be6496ba27$var$_react = $af7a43be6496ba27$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $af7a43be6496ba27$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $af7a43be6496ba27$var$EmojiFlagsIcon = (props)=>/*#__PURE__*/ $af7a43be6496ba27$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M6 12.235v6.446c0 .537.45.977 1 .977s1-.44 1-.977v-5.778c1.17-.341 2.389-.045 3.768.29.982.238 2.036.495 3.13.495a5.73 5.73 0 002.547-.567 1 1 0 00.563-.9V5.466a.998.998 0 00-1.437-.9c-1.345.654-2.731.317-4.331-.071-1.729-.42-3.687-.895-5.678.072A1 1 0 006 5.466v6.769zm3.111-1.48c1.094 0 2.148.256 3.129.495 1.381.335 2.6.63 3.768.289V6.836c-1.488.27-2.93-.08-4.24-.398-1.379-.335-2.598-.632-3.768-.29v4.704a6.195 6.195 0 011.111-.097z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$af7a43be6496ba27$var$EmojiFlagsIcon.displayName = 'EmojiFlagsIcon';
var $af7a43be6496ba27$var$_default = $af7a43be6496ba27$var$EmojiFlagsIcon;
module.exports.default = $af7a43be6496ba27$var$_default;

});

parcelRegister("e3DbB", function(module, exports) {

$parcel$export(module.exports, "SelectedIssueFlaggedState", () => $75614f52156966bb$export$c7c32a893388b4e4);
const $75614f52156966bb$export$c7c32a893388b4e4 = {
    ALL_FLAGGED: 'ALL_FLAGGED',
    NONE_FLAGGED: 'NONE_FLAGGED',
    INDETERMINATE: 'INDETERMINATE'
};

});


parcelRegister("8DAgy", function(module, exports) {

$parcel$export(module.exports, "useGoToBulkEditor", () => $ff87d0a366ea362f$export$ef32b88fc4df461d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $23NQ5 = parcelRequire("23NQ5");

var $PdmhA = parcelRequire("PdmhA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fMoec = parcelRequire("fMoec");

var $1gQ73 = parcelRequire("1gQ73");

var $bP7Jx = parcelRequire("bP7Jx");

var $7kNqR = parcelRequire("7kNqR");

var $bPVI5 = parcelRequire("bPVI5");

var $6n5K0 = parcelRequire("6n5K0");
const $ff87d0a366ea362f$export$f62a4789211eedd7 = ({ onGoToBulkEditor: onGoToBulkEditor })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return [
        {
            type: (0, $fMoec.MenuNodeType).Item,
            label: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ff87d0a366ea362f$var$LabelWrapper, null, formatMessage((0, $6n5K0.default).bulkChange), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ff87d0a366ea362f$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
                    size: "small",
                    label: formatMessage((0, $6n5K0.default).goToBulkEditorIconLabel),
                    primaryColor: `var(--ds-icon, ${(0, $PdmhA).N800})`
                }))),
            id: (0, $bPVI5.GO_TO_BULK_EDITOR_MENU_ID),
            onClick: onGoToBulkEditor
        }
    ];
};
const $ff87d0a366ea362f$export$ef32b88fc4df461d = ({ selectedCardIds: selectedCardIds })=>{
    const cardEntities = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getCards));
    const canBulkEdit = (0, $1gQ73.useBacklogSelector)((0, $7kNqR.canBulkEditIssues));
    const isGoToBulkEditorVisible = canBulkEdit && selectedCardIds.length > 1;
    const handleOnGoToBulkEditor = ()=>{
        const issueKeys = selectedCardIds.map((id)=>cardEntities[String(id)].key);
        const url = `/secure/GHBulkChange.jspa?issueKeys=${encodeURIComponent(issueKeys.join(','))}`;
        window.open(url, '_blank');
    };
    const bulkEditorContent = $ff87d0a366ea362f$export$f62a4789211eedd7({
        onGoToBulkEditor: handleOnGoToBulkEditor
    });
    return isGoToBulkEditorVisible ? bulkEditorContent : [];
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ff87d0a366ea362f$var$LabelWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _zulp1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ff87d0a366ea362f$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _154iv77o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("bRC5Z", function(module, exports) {

$parcel$export(module.exports, "useHeader", () => $83d1bbaeeb0f2c32$export$ae602290ebd82f8e);

var $fMoec = parcelRequire("fMoec");

var $bPVI5 = parcelRequire("bPVI5");

var $4HULd = parcelRequire("4HULd");
const $83d1bbaeeb0f2c32$export$ae602290ebd82f8e = ({ selectedCardIds: selectedCardIds })=>{
    const separator = (0, $4HULd.createSeparator)((0, $bPVI5.HEADER_BULK_INDICATOR_MENU_ID));
    return selectedCardIds?.length > 1 ? [
        {
            id: (0, $bPVI5.HEADER_BULK_INDICATOR_MENU_ID),
            type: (0, $fMoec.MenuNodeType).BulkIndicator,
            selectedCount: selectedCardIds.length
        },
        separator
    ] : [];
};

});
parcelRegister("4HULd", function(module, exports) {

$parcel$export(module.exports, "createSeparator", () => $7b8f8606f0b2c176$export$2f446885d1462a2f);

var $jqvCZ = parcelRequire("jqvCZ");

var $fMoec = parcelRequire("fMoec");

var $bPVI5 = parcelRequire("bPVI5");
const $7b8f8606f0b2c176$export$2f446885d1462a2f = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((id)=>({
        id: `${0, $bPVI5.SEPARATOR_MENU_ID}/${id}`,
        type: (0, $fMoec.MenuNodeType).Separator
    }));

});


parcelRegister("cU7N2", function(module, exports) {

$parcel$export(module.exports, "useMoveTo", () => $5802661a686548fb$export$f91d8f33a4d36cb0);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fMoec = parcelRequire("fMoec");

var $7TyGu = parcelRequire("7TyGu");

var $1gQ73 = parcelRequire("1gQ73");

var $7Egcu = parcelRequire("7Egcu");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $7kNqR = parcelRequire("7kNqR");

var $dtV8v = parcelRequire("dtV8v");

var $j258X = parcelRequire("j258X");

var $bPVI5 = parcelRequire("bPVI5");

var $6n5K0 = parcelRequire("6n5K0");

var $kb99p = parcelRequire("kb99p");
const $5802661a686548fb$export$53fb05810700cd9c = 5;
const $5802661a686548fb$export$ba5a2e46cd05ad01 = ({ sprints: sprints, filteredSprints: filteredSprints, onMoveToSprint: onMoveToSprint, onMoveToBacklog: onMoveToBacklog, onMoveToBoard: onMoveToBoard, canMoveIssue: canMoveIssue, isMoveToBoardEnabled: isMoveToBoardEnabled, setQuery: setQuery, isSearching: isSearching, numOfSelectedSprints: numOfSelectedSprints, sprintId: sprintId, issueId: issueId })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const sprintOptions = filteredSprints.map((sprint)=>({
            type: (0, $fMoec.MenuNodeType).Item,
            id: `actions/move-to/${sprint.id}`,
            label: sprint.name,
            analytics: {
                ...isSearching && {
                    actionSubjectId: 'moveToSprintSearchDropdownItem'
                },
                attributes: {
                    numOfSelectedSprints: numOfSelectedSprints,
                    sprintId: sprintId ?? 'backlog'
                }
            },
            onClick: (analyticsEvent)=>onMoveToSprint(sprint.id, analyticsEvent)
        }));
    const sprintsSearchMenu = [
        {
            type: (0, $fMoec.MenuNodeType).Search,
            id: (0, $bPVI5.MOVE_TO_SEARCH_MENU_ID),
            children: sprintOptions,
            hasSearch: sprints.length > $5802661a686548fb$export$53fb05810700cd9c,
            onChange: (value)=>setQuery(value),
            isAsyncSearch: false,
            ariaLabel: formatMessage((0, $6n5K0.default).sprintSearchPlaceholder)
        }
    ];
    const boardLabel = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getCardLists))[0, $7TyGu.BOARD]?.name;
    const isCMPBoard = (0, $j258X.useIsCMPBacklog)();
    const moveToBoard = isMoveToBoardEnabled ? [
        {
            type: (0, $fMoec.MenuNodeType).Item,
            id: (0, $bPVI5.MOVE_TO_BOARD_MENU_ID),
            label: isCMPBoard && boardLabel ? boardLabel : formatMessage((0, $6n5K0.default).board),
            analytics: {
                attributes: {
                    numOfSelectedSprints: numOfSelectedSprints,
                    sprintId: sprintId ?? 'backlog'
                }
            },
            onClick: onMoveToBoard
        }
    ] : [];
    const menuWithSeparator = sprints.length || moveToBoard.length ? [
        ...moveToBoard.length ? moveToBoard : sprintsSearchMenu,
        {
            id: (0, $bPVI5.SEPARATOR_MENU_ID),
            type: (0, $fMoec.MenuNodeType).Separator
        }
    ] : [];
    const rankIssueItems = (0, $kb99p.useRankIssueItems)({
        issueId: issueId
    });
    return canMoveIssue ? [
        {
            type: (0, $fMoec.MenuNodeType).Item,
            label: formatMessage((0, $6n5K0.default).moveTo),
            id: (0, $bPVI5.MOVE_TO_MENU_ID),
            children: [
                ...menuWithSeparator,
                {
                    type: (0, $fMoec.MenuNodeType).Item,
                    id: (0, $bPVI5.MOVE_TO_TOP_OF_BACKLOG_MENU_ID),
                    label: formatMessage((0, $6n5K0.default).topOfTheBacklog),
                    analytics: {
                        attributes: {
                            numOfSelectedSprints: numOfSelectedSprints,
                            sprintId: sprintId ?? 'backlog'
                        }
                    },
                    onClick: (analyticsEvent)=>onMoveToBacklog((0, $7TyGu.TOP_OF_LIST), analyticsEvent)
                },
                ...rankIssueItems,
                {
                    type: (0, $fMoec.MenuNodeType).Item,
                    id: (0, $bPVI5.MOVE_TO_BOTTOM_OF_BACKLOG_MENU_ID),
                    label: formatMessage((0, $6n5K0.default).bottomOfTheBacklog),
                    analytics: {
                        attributes: {
                            numOfSelectedSprints: numOfSelectedSprints,
                            sprintId: sprintId ?? 'backlog'
                        }
                    },
                    onClick: (analyticsEvent)=>onMoveToBacklog((0, $7TyGu.BOTTOM_OF_LIST), analyticsEvent)
                }
            ]
        }
    ] : [];
};
const $5802661a686548fb$export$f91d8f33a4d36cb0 = ({ issueId: issueId, cardIds: cardIds, hide: hide = false })=>{
    const [query, setQuery] = (0, $eUqFw.useState)('');
    const [filteredSprints, setFilteredSprints] = (0, $eUqFw.useState)([]);
    const backlogStrategy = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getBacklogStrategy));
    const getCardListIdByCardId = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.makeGetCardListIdByCardId));
    const originCardListId = (0, $eUqFw.useMemo)(()=>getCardListIdByCardId(issueId), [
        getCardListIdByCardId,
        issueId
    ]);
    const numOfSelectedSprints = (0, $eUqFw.useMemo)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    ()=>new Set(cardIds.map(getCardListIdByCardId)).size, [
        cardIds,
        getCardListIdByCardId
    ]);
    const isFromActiveSprint = (0, $1gQ73.useBacklogSelector)((state)=>(0, $dtV8v.makeIsCardListActiveSprint)(state)(originCardListId || ''));
    const showAllSprints = !!numOfSelectedSprints && numOfSelectedSprints > 1;
    const sprints = (0, $1gQ73.useBacklogSelector)((state)=>showAllSprints ? (0, $dtV8v.getAllSprints)(state) : (0, $dtV8v.makeGetOtherOrderedSprints)(state)(originCardListId || ''), (before, after)=>before.length === after.length && before.every((sprint, index)=>sprint.name === after[index].name));
    const isMoveToBoardEnabled = (0, $1gQ73.useBacklogSelector)((state)=>!(0, $bP7Jx.makeIsCardOnBoard)(state)(issueId) && (backlogStrategy === (0, $7TyGu.ISSUE_LIST_BACKLOG_STRATEGY) || backlogStrategy === (0, $7TyGu.KANBAN_BACKLOG_STRATEGY)) && sprints.length === 0);
    (0, $eUqFw.useEffect)(()=>{
        setFilteredSprints(sprints.filter((sprint)=>sprint.name.toLowerCase().includes(query.toLowerCase())));
    }, [
        query,
        sprints
    ]);
    const onMoveToSprint = (0, $1gQ73.useBacklogActionCreator)((id, analyticsEvent)=>(0, $7Egcu.cardsMove)({
            cardListId: id,
            placement: (0, $7TyGu.BOTTOM_OF_LIST),
            isBetweenLists: originCardListId !== id,
            isFromActiveSprint: isFromActiveSprint,
            cardIds: cardIds
        }, analyticsEvent));
    const onMoveToBacklog = (0, $1gQ73.useBacklogActionCreator)((placement, analyticsEvent)=>(0, $7Egcu.cardsMove)({
            cardListId: (0, $7TyGu.BACKLOG),
            placement: placement,
            isBetweenLists: originCardListId !== (0, $7TyGu.BACKLOG),
            isFromActiveSprint: isFromActiveSprint,
            cardIds: cardIds
        }, analyticsEvent));
    const onMoveToBoard = (0, $1gQ73.useBacklogActionCreator)((analyticsEvent)=>(0, $7Egcu.cardsMove)({
            cardListId: (0, $7TyGu.BOARD),
            placement: (0, $7TyGu.BOTTOM_OF_LIST),
            isBetweenLists: originCardListId !== (0, $7TyGu.BOARD),
            isFromActiveSprint: false,
            cardIds: cardIds
        }, analyticsEvent));
    const canEdit = (0, $1gQ73.useBacklogSelector)((0, $7kNqR.canEditIssue));
    const canMoveIssue = canEdit && !hide;
    return $5802661a686548fb$export$ba5a2e46cd05ad01({
        sprints: sprints,
        issueId: issueId,
        filteredSprints: filteredSprints,
        isMoveToBoardEnabled: isMoveToBoardEnabled,
        onMoveToSprint: onMoveToSprint,
        onMoveToBacklog: onMoveToBacklog,
        onMoveToBoard: onMoveToBoard,
        setQuery: setQuery,
        canMoveIssue: canMoveIssue,
        isSearching: !!query,
        numOfSelectedSprints: numOfSelectedSprints,
        sprintId: originCardListId || ''
    });
};

});
parcelRegister("kb99p", function(module, exports) {

$parcel$export(module.exports, "useRankIssueItems", () => $1906870e961e28e9$export$fbee3c551294933d);

var $5JgJ2 = parcelRequire("5JgJ2");

var $fMoec = parcelRequire("fMoec");

var $ecfSW = parcelRequire("ecfSW");

var $bPVI5 = parcelRequire("bPVI5");

var $6n5K0 = parcelRequire("6n5K0");
function $1906870e961e28e9$export$fbee3c551294933d({ issueId: issueId }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const moveCards = (0, $ecfSW.useSimplyMoveCards)();
    const onClick = (type)=>{
        moveCards({
            source: {
                cardId: issueId
            },
            location: {
                type: type
            }
        });
    };
    const onClickRankUp = ()=>onClick('rank-up');
    const onClickRankDown = ()=>onClick('rank-down');
    return [
        {
            type: (0, $fMoec.MenuNodeType).Item,
            id: (0, $bPVI5.RANK_MENU_UP_ID),
            label: formatMessage((0, $6n5K0.default).rankUp),
            onClick: onClickRankUp
        },
        {
            type: (0, $fMoec.MenuNodeType).Item,
            id: (0, $bPVI5.RANK_MENU_DOWN_ID),
            label: formatMessage((0, $6n5K0.default).rankDown),
            onClick: onClickRankDown
        }
    ];
}

});
parcelRegister("ecfSW", function(module, exports) {

$parcel$export(module.exports, "useSimplyMoveCards", () => $3bc3c9624d476ec8$export$acad231ea38305d4);

var $bFzGY = parcelRequire("bFzGY");

var $3l6tm = parcelRequire("3l6tm");

var $dkPd7 = parcelRequire("dkPd7");

var $9eH8H = parcelRequire("9eH8H");

var $7TyGu = parcelRequire("7TyGu");

var $7Egcu = parcelRequire("7Egcu");

var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $8CqRc = parcelRequire("8CqRc");

var $dtV8v = parcelRequire("dtV8v");
function $3bc3c9624d476ec8$export$20b62d0c0d6c07df(cardIdsByCardListId, cardId) {
    const cardListIds = Object.keys(cardIdsByCardListId);
    for(let i = 0; i < cardListIds.length; i += 1){
        const cardListId = cardListIds[i];
        const cardIds = cardIdsByCardListId[cardListId];
        const maybeCardIndex = cardIds.indexOf(cardId);
        if (maybeCardIndex !== -1) return {
            cardListId: cardListId,
            index: maybeCardIndex
        };
    }
    return null;
}
function $3bc3c9624d476ec8$export$53e40513eb32c9ca({ location: location, targetList: targetList, targetIndex: targetIndex, isCardSubtask: isCardSubtask, cards: cards, card: card, isParentExpanded: isParentExpanded, cardsToMove: cardsToMove }) {
    let index = Math.max(0, targetIndex);
    if (location.type === 'after') index += 1;
    // If the card to move are the target, e.g.: we're moving cards onto themselves, then we
    // scan the list to find the next non-selected card to move before.
    const cardsToMoveSet = new Set(cardsToMove ?? []);
    while(index < targetList.length && cardsToMoveSet.has(targetList[index]))index += 1;
    let beforeCardId = targetList[index] ?? null;
    if (beforeCardId != null && isCardSubtask === false && (0, $3l6tm.isSubtaskHierarchyLevel)(cards[beforeCardId]?.typeHierarchyLevel) && (!isParentExpanded || location.type === 'rank-down')) {
        // find next non subtask related to parent, if none, then set null
        const parentId = cards[beforeCardId]?.parentId;
        const offset = location.type === 'rank-down' && card?.id === parentId ? 2 : 1;
        const nextGroupOffset = targetList.slice(targetIndex + 1).findIndex((id)=>parentId !== cards[id]?.parentId);
        const offsetCard = targetList[targetIndex + nextGroupOffset + offset] ?? null;
        beforeCardId = nextGroupOffset > -1 ? offsetCard : null;
    }
    if (beforeCardId == null) return {
        type: 'bottom'
    };
    // When the ticket user is dragging over is a subtask then we send through the parent ID instead of the subtask id
    if (isCardSubtask === false && (0, $3l6tm.isSubtaskHierarchyLevel)(cards[beforeCardId]?.typeHierarchyLevel)) beforeCardId = cards[beforeCardId]?.parentId ?? beforeCardId;
    return {
        type: 'card',
        beforeCardId: beforeCardId
    };
}
const $3bc3c9624d476ec8$var$getSubtasksIfShouldMoveWithParent = (state, cardIdsByCardListId, cards, cardsToMove)=>{
    const isCardGroupCollapsed = (parentId)=>!(0, $bP7Jx.makeGetCardGroupExpanded)(state)(parentId);
    // If it's a CMP scum project, move all subtasks with parent regardless of expansion state
    // Otherwise, move the subtasks with the parent only if it is collapsed
    const shouldMoveSubtasksIfExpanded = (0, $hkGxG.isCMPScrumBacklog)(state);
    const cardsToCheck = shouldMoveSubtasksIfExpanded ? cardsToMove : cardsToMove.filter(isCardGroupCollapsed);
    return cardsToCheck.flatMap((cardGroupId)=>{
        const list = $3bc3c9624d476ec8$export$20b62d0c0d6c07df(cardIdsByCardListId, cardGroupId);
        return list ? cardIdsByCardListId[list.cardListId].filter((cardId)=>(0, $3l6tm.isSubtaskHierarchyLevel)(cards[cardId]?.typeHierarchyLevel) && cards[cardId]?.parentId === cardGroupId) : [];
    });
};
function $3bc3c9624d476ec8$export$b5e42ff2ff97d25d(state, source, location, createAnalyticsEvent) {
    const cardIdsByCardListId = (0, $bP7Jx.getOrderedCardIdsByCardListId)(state);
    const sourceCardPosition = $3bc3c9624d476ec8$export$20b62d0c0d6c07df(cardIdsByCardListId, source.cardId);
    const targetCardPosition = $3bc3c9624d476ec8$export$20b62d0c0d6c07df(cardIdsByCardListId, location.target);
    if (!sourceCardPosition || !targetCardPosition) return null;
    const selectedCardIds = (0, $bP7Jx.getSelectedCards)(state);
    const cardsToMove = selectedCardIds.includes(source.cardId) ? selectedCardIds : [
        source.cardId
    ];
    const cards = (0, $bP7Jx.getCards)(state);
    const card = cards[source.cardId];
    const extraCards = $3bc3c9624d476ec8$var$getSubtasksIfShouldMoveWithParent(state, cardIdsByCardListId, cards, cardsToMove);
    const allCardsToMove = cardsToMove.concat(extraCards);
    const isFromActiveSprint = (0, $dtV8v.makeIsCardListActiveSprint)(state)(sourceCardPosition.cardListId);
    const isBetweenLists = sourceCardPosition.cardListId !== targetCardPosition.cardListId || selectedCardIds.some((cardId)=>Object.keys(cardIdsByCardListId).some((key)=>{
            if (key === targetCardPosition.cardListId) return false;
            return cardIdsByCardListId[key].includes(cardId);
        }));
    const basePayload = {
        cardIds: allCardsToMove,
        cardListId: targetCardPosition.cardListId,
        isBetweenLists: isBetweenLists,
        isFromActiveSprint: isFromActiveSprint
    };
    const targetList = cardIdsByCardListId[targetCardPosition.cardListId];
    const isParentExpanded = (0, $bP7Jx.makeGetCardGroupExpanded)(state)(cards[location.target]?.id);
    const beforeCardIdResult = $3bc3c9624d476ec8$export$53e40513eb32c9ca({
        location: location,
        targetList: targetList,
        targetIndex: targetCardPosition.index,
        isCardSubtask: (0, $3l6tm.isSubtaskHierarchyLevel)(card.typeHierarchyLevel),
        cardsToMove: allCardsToMove,
        cards: cards,
        card: card,
        isParentExpanded: isParentExpanded
    });
    const event = createAnalyticsEvent({
        attributes: {
            target: targetCardPosition.cardListId,
            source: sourceCardPosition.cardListId
        }
    });
    if (beforeCardIdResult.type === 'bottom') return (0, $7Egcu.cardsMove)({
        ...basePayload,
        placement: (0, $7TyGu.BOTTOM_OF_LIST)
    }, event);
    // Ignore dragging a card onto its own leading and trailing edges
    const beforeCardIndex = targetList.indexOf(beforeCardIdResult.beforeCardId);
    const isNoopChange = card.id !== beforeCardIdResult.beforeCardId && allCardsToMove.every((cardId)=>beforeCardIdResult.beforeCardId === cardId || targetList[beforeCardIndex - 1] === cardId);
    if (isNoopChange) return null;
    const isAllSelectedSiblingSubtasks = (0, $8CqRc.makeIsAllSelectedSiblingSubtasks)(state);
    // If the card is a subtask and all selected cards are siblings, then they can only be moved in the group
    // If the "before" card doesn't have a parent it will mean that they have been moved to the last in the group
    const targetCard = cards[beforeCardIdResult.beforeCardId];
    if (card && targetCard && isAllSelectedSiblingSubtasks && (0, $3l6tm.isSubtaskHierarchyLevel)(card.typeHierarchyLevel) && !(0, $3l6tm.isSubtaskHierarchyLevel)(targetCard.typeHierarchyLevel)) return (0, $7Egcu.cardsMove)({
        ...basePayload,
        placement: (0, $7TyGu.BOTTOM_OF_CARD_GROUP)
    }, event);
    return (0, $7Egcu.cardsMove)({
        ...basePayload,
        beforeCardId: beforeCardIdResult.beforeCardId,
        placement: (0, $7TyGu.BEFORE_CARD)
    }, event);
}
function $3bc3c9624d476ec8$export$b50dfd72a14689ae(state, source, location, createAnalyticsEvent) {
    const cardIdsByCardListId = (0, $bP7Jx.getOrderedCardIdsByCardListId)(state);
    const sourceCardPosition = $3bc3c9624d476ec8$export$20b62d0c0d6c07df(cardIdsByCardListId, source.cardId);
    if (!sourceCardPosition) return null;
    const orderedCardIds = cardIdsByCardListId[sourceCardPosition.cardListId];
    const targetIndex = location.type === 'rank-up' ? sourceCardPosition.index - 1 : sourceCardPosition.index + 2;
    const basePayload = {
        cardIds: [
            source.cardId
        ],
        cardListId: sourceCardPosition.cardListId,
        isBetweenLists: false,
        isFromActiveSprint: false
    };
    const cards = (0, $bP7Jx.getCards)(state);
    const card = cards[source.cardId];
    const beforeCardIdResult = $3bc3c9624d476ec8$export$53e40513eb32c9ca({
        cards: cards,
        card: card,
        isCardSubtask: (0, $3l6tm.isSubtaskHierarchyLevel)(card?.typeHierarchyLevel),
        location: location,
        targetIndex: targetIndex,
        targetList: orderedCardIds,
        isParentExpanded: (0, $bP7Jx.makeGetCardGroupExpanded)(state)(cards[orderedCardIds[targetIndex]]?.id)
    });
    const event = createAnalyticsEvent({
        attributes: {
            source: sourceCardPosition.cardListId,
            target: sourceCardPosition.cardListId
        }
    });
    if (beforeCardIdResult.type === 'bottom') return (0, $7Egcu.cardsMove)({
        ...basePayload,
        placement: (0, $7TyGu.BOTTOM_OF_LIST)
    }, event);
    // If the card is a subtask and the "before" card is not, then move to the bottom of the card list
    const targetCard = cards[beforeCardIdResult.beforeCardId];
    if (card && targetCard && (0, $3l6tm.isSubtaskHierarchyLevel)(card.typeHierarchyLevel) && !(0, $3l6tm.isSubtaskHierarchyLevel)(targetCard.typeHierarchyLevel)) return (0, $7Egcu.cardsMove)({
        ...basePayload,
        placement: (0, $7TyGu.BOTTOM_OF_CARD_GROUP)
    }, event);
    return (0, $7Egcu.cardsMove)({
        ...basePayload,
        beforeCardId: beforeCardIdResult.beforeCardId,
        placement: (0, $7TyGu.BEFORE_CARD)
    }, event);
}
function $3bc3c9624d476ec8$export$a8306ae9a42a578c(state, source, location, createAnalyticsEvent) {
    const cardIdsByCardListId = (0, $bP7Jx.getOrderedCardIdsByCardListId)(state);
    const selectedCardIds = (0, $bP7Jx.getSelectedCards)(state);
    const cardsToMove = selectedCardIds.includes(source.cardId) ? selectedCardIds : [
        source.cardId
    ];
    const sourceCardPosition = $3bc3c9624d476ec8$export$20b62d0c0d6c07df(cardIdsByCardListId, source.cardId);
    const cards = (0, $bP7Jx.getCards)(state);
    const extraCards = $3bc3c9624d476ec8$var$getSubtasksIfShouldMoveWithParent(state, cardIdsByCardListId, cards, cardsToMove);
    const allCardsToMove = cardsToMove.concat(extraCards);
    // Quit if any of the cards are missing from the state
    const cardPositions = allCardsToMove.map((cardId)=>$3bc3c9624d476ec8$export$20b62d0c0d6c07df(cardIdsByCardListId, cardId));
    if (cardPositions.some((cardPosition)=>!cardPosition)) return null;
    // Quit if noop
    const isBetweenLists = cardPositions.some((cardPosition)=>cardPosition?.cardListId !== location.targetListId);
    if (!isBetweenLists) return null;
    // Treat as from active sprint if any of the cards is in the active sprint
    const isFromActiveSprint = cardPositions.some((cardPosition)=>cardPosition && (0, $dtV8v.makeIsCardListActiveSprint)(state)(cardPosition.cardListId));
    return (0, $7Egcu.cardsMove)({
        cardIds: allCardsToMove,
        cardListId: location.targetListId,
        isBetweenLists: true,
        isFromActiveSprint: isFromActiveSprint,
        placement: (0, $7TyGu.BOTTOM_OF_LIST)
    }, createAnalyticsEvent({
        attributes: {
            source: sourceCardPosition?.cardListId,
            target: location.targetListId
        }
    }));
}
/**
 * Returns a filter function that prevents subtasks from being left behind moved without their parents
 * Pass if:
 *  card is not a subtask OR
 *  card's parent is also included in cardsToMove OR
 *  card's parent is in the list we are moving to
 */ function $3bc3c9624d476ec8$var$removeOrphanSubtasks(state, targetList) {
    return (cardId, index, cardsToMove)=>{
        const cardIdsByCardListId = (0, $bP7Jx.getFilteredOrderedCardIdsByCardListId)(state);
        const cards = (0, $bP7Jx.getCards)(state);
        const isSubtask = (0, $3l6tm.isSubtaskHierarchyLevel)(cards[cardId]?.typeHierarchyLevel);
        const { parentId: parentId } = cards[cardId];
        if (!parentId) return true;
        const parentInTargetList = cardIdsByCardListId[targetList].includes(parentId);
        const parentIsIncluded = cardsToMove.includes(parentId);
        return !isSubtask || parentIsIncluded || parentInTargetList;
    };
}
function $3bc3c9624d476ec8$export$5d7be4628e37c837(state, source, location, createAnalyticsEvent) {
    const cardIdsByCardListId = (0, $bP7Jx.getFilteredOrderedCardIdsByCardListId)(state);
    const targetCardPosition = $3bc3c9624d476ec8$export$20b62d0c0d6c07df(cardIdsByCardListId, location.target);
    if (!targetCardPosition) return null;
    const cardListOrder = (0, $bP7Jx.getOrderedCardListIds)(state);
    const sourceCardListId = source.cardListId;
    const dividerListIndex = cardListOrder.indexOf(sourceCardListId);
    if (dividerListIndex === -1) return null;
    const isFromActiveSprint = (0, $dtV8v.makeIsCardListActiveSprint)(state)(sourceCardListId);
    const targetIndex = cardListOrder.findIndex((val)=>val === targetCardPosition.cardListId);
    const sourceIndex = cardListOrder.findIndex((val)=>val === source.cardListId);
    const direction = sourceIndex < targetIndex ? 'down' : 'up';
    const cardsFromOtherLists = cardListOrder.slice(direction === 'down' ? sourceIndex + 1 : targetIndex + 1, direction === 'down' ? targetIndex : sourceIndex + 1).flatMap((key)=>cardIdsByCardListId[key]);
    // We will move the divider list's cards to the list under it
    // This happens when dragging the divider up into a list above
    if (direction === 'up') {
        const targetList = cardListOrder[sourceIndex + 1];
        const cardsToMove = cardIdsByCardListId[targetCardPosition.cardListId].slice(location.type === 'before' ? targetCardPosition.index : targetCardPosition.index + 1).concat(cardsFromOtherLists).filter($3bc3c9624d476ec8$var$removeOrphanSubtasks(state, targetList));
        return (0, $7Egcu.cardsMove)({
            cardIds: cardsToMove,
            cardListId: targetList,
            isBetweenLists: true,
            isFromActiveSprint: isFromActiveSprint,
            placement: (0, $7TyGu.TOP_OF_LIST)
        }, createAnalyticsEvent({
            attributes: {
                type: (0, $9eH8H.DND_TARGET_DIVIDER),
                source: sourceCardListId,
                target: targetCardPosition.cardListId
            }
        }));
    }
    // We will move target list's cards to the divider list
    // This happens when dragging the divider down into a list under it
    const cardsToMove = cardsFromOtherLists.concat(cardIdsByCardListId[targetCardPosition.cardListId].slice(0, location.type === 'before' ? targetCardPosition.index : targetCardPosition.index + 1)).filter($3bc3c9624d476ec8$var$removeOrphanSubtasks(state, cardListOrder[sourceIndex]));
    return (0, $7Egcu.cardsMove)({
        cardIds: cardsToMove,
        cardListId: sourceCardListId,
        isBetweenLists: true,
        isFromActiveSprint: isFromActiveSprint,
        placement: (0, $7TyGu.BOTTOM_OF_LIST)
    }, createAnalyticsEvent({
        attributes: {
            type: (0, $9eH8H.DND_TARGET_DIVIDER),
            // ? With the divider here the source and target are swapped
            target: sourceCardListId,
            source: targetCardPosition.cardListId
        }
    }));
}
function $3bc3c9624d476ec8$export$5c5a9714d8f54364(store, { source: source, location: location }, createAnalyticsEvent) {
    const state = store.getState();
    if ('type' in source && source.type === 'divider' && (location.type === 'before' || location.type === 'after')) return $3bc3c9624d476ec8$export$5d7be4628e37c837(state, source, location, createAnalyticsEvent);
    if (!('cardId' in source)) return null;
    if (location.type === 'before' || location.type === 'after') return $3bc3c9624d476ec8$export$b5e42ff2ff97d25d(state, source, location, createAnalyticsEvent);
    if (location.type === 'rank-up' || location.type === 'rank-down') return $3bc3c9624d476ec8$export$b50dfd72a14689ae(state, source, location, createAnalyticsEvent);
    if (location.type === 'list') return $3bc3c9624d476ec8$export$a8306ae9a42a578c(state, source, location, createAnalyticsEvent);
    return null;
}
function $3bc3c9624d476ec8$export$acad231ea38305d4() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const store = (0, $1gQ73.useBacklogStore)();
    return (0, $dkPd7.useEvent)((payload)=>{
        const action = $3bc3c9624d476ec8$export$5c5a9714d8f54364(store, payload, createAnalyticsEvent);
        if (action) store.dispatch(action);
    });
}

});
parcelRegister("8CqRc", function(module, exports) {

$parcel$export(module.exports, "makeIsAnySelectedOrphanedSubtasks", () => $bb713dd9dfb9faf2$export$18dee6c39753b5ad);
$parcel$export(module.exports, "makeIsAllSelectedSiblingSubtasks", () => $bb713dd9dfb9faf2$export$a018c3db49ab6617);

var $iVIEg = parcelRequire("iVIEg");

var $eoER9 = parcelRequire("eoER9");

var $3l6tm = parcelRequire("3l6tm");

var $1lsov = parcelRequire("1lsov");

var $bP7Jx = parcelRequire("bP7Jx");
const $bb713dd9dfb9faf2$export$18dee6c39753b5ad = (0, $eoER9.createSelector)([
    (0, $bP7Jx.getSelectedCards),
    (0, $bP7Jx.getCards)
], (selectedCards, cards)=>selectedCards.some((cardId)=>{
        const card = cards[cardId];
        const isSubtask = !!card && (0, $3l6tm.isSubtaskHierarchyLevel)(card.typeHierarchyLevel);
        const isOrphaned = !!card?.parentId && !selectedCards.includes(card.parentId);
        return isSubtask && isOrphaned;
    }));
const $bb713dd9dfb9faf2$export$a018c3db49ab6617 = (0, $eoER9.createSelector)([
    (0, $bP7Jx.getSelectedCards),
    (0, $bP7Jx.getCards),
    (0, $1lsov.makeGetCardGroupByChildId)
], (selectedCards, cards, getCardGroupByChildId)=>!!selectedCards.length && selectedCards.every((cardId)=>{
        const card = cards[cardId];
        const isSubtask = !!card && (0, $3l6tm.isSubtaskHierarchyLevel)(card.typeHierarchyLevel);
        if (isSubtask) {
            const cardGroup = getCardGroupByChildId(cardId);
            return !!cardGroup && (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(selectedCards, cardGroup.cardIds).length === 0;
        }
        return false;
    }));

});




parcelRegister("cfG6O", function(module, exports) {

$parcel$export(module.exports, "useParent", () => $3585baaa7236a23b$export$c1a4e24309a2ec52);

var $eUqFw = parcelRequire("eUqFw");

var $MYW4e = parcelRequire("MYW4e");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fMoec = parcelRequire("fMoec");
var $kKRiz = parcelRequire("kKRiz");

var $1gQ73 = parcelRequire("1gQ73");

var $cPwLN = parcelRequire("cPwLN");

var $bP7Jx = parcelRequire("bP7Jx");

var $bPVI5 = parcelRequire("bPVI5");

var $6n5K0 = parcelRequire("6n5K0");

var $fadXb = parcelRequire("fadXb");
const $3585baaa7236a23b$export$2e6dd7b2ab013cea = 6;
const $3585baaa7236a23b$var$UNLINK = 'unlink';
const $3585baaa7236a23b$var$isUnlinkMenuOption = (option)=>'type' in option && option.type === $3585baaa7236a23b$var$UNLINK;
const $3585baaa7236a23b$var$transformOptionToString = (option)=>{
    if ($3585baaa7236a23b$var$isUnlinkMenuOption(option)) return option.label;
    return `${option.key} ${option.summary}`;
};
const $3585baaa7236a23b$export$9e34a407c5c18c2f = ({ issueParents: issueParents, loading: loading, cardSelectionValid: cardSelectionValid, showUnlinkMenuItem: showUnlinkMenuItem, onUpdateParent: onUpdateParent })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const menuOptions = (0, $eUqFw.useMemo)(()=>[
            ...showUnlinkMenuItem ? [
                {
                    type: $3585baaa7236a23b$var$UNLINK,
                    label: formatMessage((0, $6n5K0.default).parentUnlinkOptionLabel)
                }
            ] : [],
            ...issueParents
        ], [
        formatMessage,
        issueParents,
        showUnlinkMenuItem
    ]);
    const [filteredMenuOptions, updateFilter] = (0, $kKRiz.useTextFilter)(menuOptions, $3585baaa7236a23b$var$transformOptionToString);
    return (0, $eUqFw.useMemo)(()=>{
        if (!cardSelectionValid || !issueParents.length && !showUnlinkMenuItem) return [];
        const options = filteredMenuOptions.map((option)=>$3585baaa7236a23b$var$isUnlinkMenuOption(option) ? {
                type: (0, $fMoec.MenuNodeType).Item,
                id: `${0, $bPVI5.PARENT_MENU_ID}/value__unlink`,
                label: option.label,
                onClick: (analyticsEvent)=>{
                    onUpdateParent(null, analyticsEvent);
                }
            } : {
                type: (0, $fMoec.MenuNodeType).Item,
                id: `${0, $bPVI5.PARENT_MENU_ID}/value__${option.id}`,
                label: $3585baaa7236a23b$var$transformOptionToString(option),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
                    width: "var(--ds-space-200, 16px)",
                    height: "var(--ds-space-200, 16px)",
                    src: option.issueType.iconUrl,
                    alt: ""
                }),
                onClick: (analyticsEvent)=>{
                    onUpdateParent(option, analyticsEvent);
                }
            });
        const showSearch = issueParents.length + (showUnlinkMenuItem ? 1 : 0) > $3585baaa7236a23b$export$2e6dd7b2ab013cea;
        const subMenu = showSearch ? [
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            {
                type: (0, $fMoec.MenuNodeType).Search,
                id: (0, $bPVI5.PARENT_SEARCH_MENU_ID),
                children: options,
                hasSearch: true,
                // Parents are only fetched async once during mount
                isAsyncSearch: false,
                isLoading: loading,
                onChange: updateFilter,
                resultsCount: filteredMenuOptions.length
            }
        ] : options;
        return [
            {
                type: (0, $fMoec.MenuNodeType).Item,
                id: (0, $bPVI5.PARENT_MENU_ID),
                label: formatMessage((0, $6n5K0.default).parentOptionLabel),
                submenuWidth: 284,
                children: subMenu
            }
        ];
    }, [
        cardSelectionValid,
        issueParents.length,
        showUnlinkMenuItem,
        filteredMenuOptions,
        loading,
        updateFilter,
        formatMessage,
        onUpdateParent
    ]);
};
const $3585baaa7236a23b$export$c1a4e24309a2ec52 = (selectedCardIds)=>{
    const getIssueKey = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.makeCardKeyFromCardId));
    const allCards = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getCards));
    const selectedCards = (0, $eUqFw.useMemo)(()=>selectedCardIds.map((cardId)=>allCards[cardId]).filter(Boolean), [
        allCards,
        selectedCardIds
    ]);
    const firstCardParentId = selectedCards.length ? selectedCards[0].parentId : null;
    const { issueParents: allIssueParents, loading: loading, cardSelectionValid: cardSelectionValid } = (0, $fadXb.useIssueParents)(selectedCards);
    const multipleCardsSelected = selectedCardIds.length > 1;
    const showUnlinkMenuItem = selectedCards.some((card)=>card.parentId !== null);
    // If we're only editing a single card, remove any
    // epic from the list that's assigned to this card
    const issueParents = (0, $eUqFw.useMemo)(()=>!multipleCardsSelected && firstCardParentId ? allIssueParents.filter((parent)=>parent.id !== String(firstCardParentId)) : allIssueParents, [
        allIssueParents,
        firstCardParentId,
        multipleCardsSelected
    ]);
    const onUpdateParent = (0, $1gQ73.useBacklogActionCreator)((parent, analyticsEvent)=>(0, $MYW4e.batchActions)(selectedCardIds.map((id)=>(0, $cPwLN.cardParentSetOptimistic)({
                cardId: id,
                parent: parent
            }, getIssueKey(id), analyticsEvent))));
    return $3585baaa7236a23b$export$9e34a407c5c18c2f({
        issueParents: issueParents,
        onUpdateParent: onUpdateParent,
        showUnlinkMenuItem: showUnlinkMenuItem,
        loading: loading,
        cardSelectionValid: cardSelectionValid
    });
};

});
parcelRegister("kKRiz", function(module, exports) {

$parcel$export(module.exports, "useTextFilter", () => $d066610fb10ed4dd$export$de949492119ddd44);

var $eUqFw = parcelRequire("eUqFw");
const $d066610fb10ed4dd$var$removeAccents = (text)=>text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
const $d066610fb10ed4dd$var$doesStringContainText = (itemString, text)=>itemString.toLowerCase().includes(text.toLowerCase()) || $d066610fb10ed4dd$var$removeAccents(itemString).toLowerCase().includes(text.toLowerCase());
const $d066610fb10ed4dd$export$de949492119ddd44 = (items, itemToStringTransformer, defaultFilterValue = '')=>{
    const [filterValue, setFilterValue] = (0, $eUqFw.useState)(defaultFilterValue);
    const filteredItems = (0, $eUqFw.useMemo)(()=>{
        if (!filterValue) return items;
        return items.filter((item)=>$d066610fb10ed4dd$var$doesStringContainText(itemToStringTransformer(item), filterValue));
    }, [
        filterValue,
        itemToStringTransformer,
        items
    ]);
    return [
        filteredItems,
        setFilterValue
    ];
};

});

parcelRegister("fadXb", function(module, exports) {

$parcel$export(module.exports, "useIssueParents", () => $5757ee3283f8c39d$export$b72cf91ed30503ee);

var $eUqFw = parcelRequire("eUqFw");

var $lO4Or = parcelRequire("lO4Or");

var $lmgQD = parcelRequire("lmgQD");

var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");

var $k734R = parcelRequire("k734R");

var $6YgDX = parcelRequire("6YgDX");
const $5757ee3283f8c39d$var$SEARCH_FIELDS = [
    (0, $lO4Or.SUMMARY_TYPE),
    (0, $lO4Or.ISSUE_TYPE)
];
const $5757ee3283f8c39d$var$constructSearchJql = (projectIds)=>`project in (${projectIds.join(',')}) AND hierarchyLevel=1 ORDER BY lastViewed DESC, updated DESC, priority DESC`;
const $5757ee3283f8c39d$var$transformSearchResponse = (response)=>response.issues.map((issue)=>{
        const { id: id, name: name, iconUrl: iconUrl } = issue.fields.issuetype;
        return {
            id: issue.id,
            key: issue.key,
            summary: issue.fields.summary,
            issueType: {
                id: id,
                name: name,
                iconUrl: iconUrl
            },
            color: undefined
        };
    });
const $5757ee3283f8c39d$var$EMPTY_ARRAY = [];
const $5757ee3283f8c39d$export$b72cf91ed30503ee = (selectedCards)=>{
    const allProjects = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getProjects));
    const issueParentsInState = (0, $1gQ73.useBacklogSelector)((0, $k734R.issueParentsSelector));
    const isCompanyManaged = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getIsCompanyManaged));
    const projectId = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.projectIdSelector));
    // Array of projects from which a valid parent selection can be made
    const applicableProjects = (0, $eUqFw.useMemo)(()=>isCompanyManaged ? (0, $6YgDX.getAllPossibleProjectsForSelection)(selectedCards, allProjects) : [], [
        allProjects,
        isCompanyManaged,
        selectedCards
    ]);
    // Array of valid issue parents from state
    const filteredIssueParentsInState = (0, $eUqFw.useMemo)(()=>isCompanyManaged ? (0, $6YgDX.filterIssueParentsByProjects)(issueParentsInState, applicableProjects) : issueParentsInState, [
        isCompanyManaged,
        issueParentsInState,
        applicableProjects
    ]);
    // TMP projects do not require validation as they do not
    // include epic or subtasks cards and cross-project boards
    const isCardSelectionValid = isCompanyManaged ? (0, $6YgDX.validateSelectedCards)(selectedCards, allProjects) : true;
    const { data: data, loading: loading, fetch: fetch } = (0, $lmgQD.useIssueSearch)();
    const issueParentsFromSearch = (0, $eUqFw.useMemo)(()=>data && $5757ee3283f8c39d$var$transformSearchResponse(data), [
        data
    ]);
    const issueParents = isCardSelectionValid ? issueParentsFromSearch || filteredIssueParentsInState : $5757ee3283f8c39d$var$EMPTY_ARRAY;
    (0, $eUqFw.useEffect)(()=>{
        if (isCardSelectionValid) {
            const projectIds = isCompanyManaged ? applicableProjects.map((project)=>project.id) : [
                projectId
            ];
            fetch({
                jql: $5757ee3283f8c39d$var$constructSearchJql(projectIds),
                fields: $5757ee3283f8c39d$var$SEARCH_FIELDS
            });
        }
    }, [
        applicableProjects,
        fetch,
        isCardSelectionValid,
        isCompanyManaged,
        projectId
    ]);
    return {
        issueParents: issueParents,
        loading: loading,
        cardSelectionValid: isCardSelectionValid
    };
};

});
parcelRegister("lmgQD", function(module, exports) {

$parcel$export(module.exports, "useIssueSearch", () => $dc9769a634d9ce04$export$2047aaca681570b0);

var $53ciZ = parcelRequire("53ciZ");

var $eEzyV = parcelRequire("eEzyV");

var $lRmyA = parcelRequire("lRmyA");
const $dc9769a634d9ce04$var$BASE_URL = '/rest/api/3/search';
const $dc9769a634d9ce04$var$search = ({ jql: jql, fields: fields = [], maxResults: maxResults = 50 })=>{
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify({
        jql: jql,
        fields: fields,
        maxResults: maxResults
    });
    return (0, $lRmyA.performGetRequest)(`${$dc9769a634d9ce04$var$BASE_URL}?${query}`);
};
const $dc9769a634d9ce04$export$2047aaca681570b0 = ()=>(0, $eEzyV.useService)($dc9769a634d9ce04$var$search);

});

parcelRegister("6YgDX", function(module, exports) {

$parcel$export(module.exports, "getAllPossibleProjectsForSelection", () => $9cb727eac4192ae5$export$73fb4b63f0b800bc);
$parcel$export(module.exports, "filterIssueParentsByProjects", () => $9cb727eac4192ae5$export$6d89fd51639f36fe);
$parcel$export(module.exports, "validateSelectedCards", () => $9cb727eac4192ae5$export$7b9297714722993a);

var $MdoH4 = parcelRequire("MdoH4");

var $3l6tm = parcelRequire("3l6tm");
const $9cb727eac4192ae5$var$EMPTY_ARRAY = [];
const $9cb727eac4192ae5$export$191ca7f80b22e275 = (selectedCards, allProjects)=>{
    const projectIdsOfSelection = (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))(selectedCards.map((card)=>card.projectId));
    return allProjects.filter((project)=>projectIdsOfSelection.includes(project.id));
};
const $9cb727eac4192ae5$export$73fb4b63f0b800bc = (selectedCards, allProjects)=>{
    if (!(selectedCards.length && allProjects.length)) return $9cb727eac4192ae5$var$EMPTY_ARRAY;
    const projectsOfSelection = $9cb727eac4192ae5$export$191ca7f80b22e275(selectedCards, allProjects);
    if (!projectsOfSelection.length) return $9cb727eac4192ae5$var$EMPTY_ARRAY;
    const isTmp = projectsOfSelection[0].isSimplified;
    if (isTmp) return [
        projectsOfSelection[0]
    ];
    return allProjects.filter((project)=>!project.isSimplified);
};
const $9cb727eac4192ae5$export$6d89fd51639f36fe = (issueParents, projects)=>{
    const projectKeys = new Set(projects.map((project)=>project.key));
    return issueParents.filter((parent)=>{
        const [projectKey] = parent.key.split('-');
        return projectKeys.has(projectKey);
    });
};
const $9cb727eac4192ae5$export$7b9297714722993a = (selectedCards, allProjects)=>{
    const projectsOfSelection = $9cb727eac4192ae5$export$191ca7f80b22e275(selectedCards, allProjects);
    if (!projectsOfSelection.length) return false;
    const subtasksOrEpicsAreSelected = selectedCards.some(({ typeHierarchyLevel: typeHierarchyLevel })=>!(0, $3l6tm.isBaseHierarchyLevel)(typeHierarchyLevel));
    const [firstProject, ...remainingProjects] = projectsOfSelection;
    const projectsAreOfDifferentType = remainingProjects.length ? remainingProjects.some((project)=>project.isSimplified !== firstProject.isSimplified) : false;
    const multipleTmpProjectsHaveSelections = !projectsAreOfDifferentType && firstProject.isSimplified && remainingProjects.length > 0;
    return !(subtasksOrEpicsAreSelected || projectsAreOfDifferentType || multipleTmpProjectsHaveSelections);
};

});



parcelRegister("6jc2S", function(module, exports) {

$parcel$export(module.exports, "usePlanOnWhiteboard", () => $4fd48983f96a0360$export$3917b0486d389abb);

var $eUqFw = parcelRequire("eUqFw");

var $fbeIa = parcelRequire("fbeIa");

var $ffiyv = parcelRequire("ffiyv");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $fMoec = parcelRequire("fMoec");

var $a0eNT = parcelRequire("a0eNT");

var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $1qxcF = parcelRequire("1qxcF");

var $2eQUR = parcelRequire("2eQUR");

var $3LHTD = parcelRequire("3LHTD");

var $bPVI5 = parcelRequire("bPVI5");
const $4fd48983f96a0360$var$usePlanOnWhiteboardContent = ({ issueKey: issueKey, selectedCardIds: selectedCardIds, cardEntities: cardEntities, flow: flow })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const crossflow = (0, $fbeIa.useCrossFlow)();
    const { fireInteractedUIEvent: fireInteractedUIEvent } = (0, $a0eNT.useFireCrossFlowAnalyticsEvents)();
    const coUseEligible = flow === 'coUse';
    const crossFlowEligible = flow === 'crossFlow';
    const url = (0, $1qxcF.useCoUseFlow)(coUseEligible);
    // Extract project name and project id
    const projectName = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getProjectName));
    const projectId = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.projectIdSelector));
    const planOnWhiteboardButtonLabel = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, `${formatMessage((0, $2eQUR.default).planOnWhiteboard)} `, crossFlowEligible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            appearance: "new"
        }, formatMessage((0, $2eQUR.default).planOnWhiteboardTry))), [
        formatMessage,
        crossFlowEligible
    ]);
    const saveSelectedIssuesToLocalStorage = (0, $eUqFw.useCallback)((issueKeys)=>{
        localStorage.setItem('whiteboardsExperimentSelectedIssueKeys', JSON.stringify(issueKeys));
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'selectedIssuesInLocalStorage stored', {
            growthInitiative: 'cross-flow',
            storedIssues: issueKeys,
            sourceComponent: 'planOnWhiteboardsContextualCTAScreen',
            sourceContext: 'planOnWhiteboardContextMenuButton'
        });
    }, [
        createAnalyticsEvent
    ]);
    const onPlanOnWhiteboard = (0, $eUqFw.useCallback)(()=>{
        const selectedIssueKeys = selectedCardIds.map((id)=>cardEntities[String(id)]?.key ?? null).filter(Boolean);
        selectedIssueKeys.indexOf(issueKey) === -1 && selectedIssueKeys.push(issueKey);
        saveSelectedIssuesToLocalStorage(selectedIssueKeys);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        }), 'planOnWhiteboardContextMenuButton', {
            growthInitiative: 'cross-flow',
            numSelectedCards: selectedCardIds.length,
            isCrossFlowEligible: crossFlowEligible,
            isCoUseEligible: coUseEligible,
            sourceComponent: 'planOnWhiteboardsContextualCTAScreen',
            sourceContext: 'planOnWhiteboardContextMenuButton'
        });
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'listItem',
            actionSubjectId: 'planOnWhiteboardContextMenuButton'
        }, {
            targetProductId: (0, $fbeIa.Targets).CONFLUENCE,
            recommendedProductIds: [
                (0, $fbeIa.Targets).CONFLUENCE
            ],
            source: 'planOnWhiteboardsContextualCTAScreen'
        });
        (0, $3LHTD.onClickCTA)({
            createAnalyticsEvent: createAnalyticsEvent,
            crossFlowEligible: crossFlowEligible,
            crossflow: crossflow,
            projectId: projectId,
            projectName: projectName,
            component: 'planOnWhiteboardsContextualCTAScreen',
            context: 'planOnWhiteboardContextMenuButton',
            coUseEligible: coUseEligible,
            url: url
        });
    }, [
        selectedCardIds,
        cardEntities,
        crossFlowEligible,
        coUseEligible,
        projectId,
        projectName,
        crossflow,
        createAnalyticsEvent,
        fireInteractedUIEvent,
        saveSelectedIssuesToLocalStorage,
        issueKey,
        url
    ]);
    return (0, $eUqFw.useMemo)(()=>[
            {
                type: (0, $fMoec.MenuNodeType).Item,
                label: ()=>planOnWhiteboardButtonLabel,
                id: (0, $bPVI5.PLAN_ON_WHITEBOARD_MENU_ID),
                onClick: onPlanOnWhiteboard
            }
        ], [
        planOnWhiteboardButtonLabel,
        onPlanOnWhiteboard
    ]);
};
const $4fd48983f96a0360$export$3917b0486d389abb = ({ issueKey: issueKey, selectedCardIds: selectedCardIds, flow: flow })=>{
    const cardEntities = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getCards));
    return $4fd48983f96a0360$var$usePlanOnWhiteboardContent({
        issueKey: issueKey,
        selectedCardIds: selectedCardIds,
        cardEntities: cardEntities,
        flow: flow
    });
};

});

parcelRegister("iEZNy", function(module, exports) {

$parcel$export(module.exports, "usePriority", () => $a55f95cb309b3a7e$export$5b10fbc9ee011cb3);

var $eUqFw = parcelRequire("eUqFw");

var $MYW4e = parcelRequire("MYW4e");

var $hnzPP = parcelRequire("hnzPP");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fMoec = parcelRequire("fMoec");

var $1gQ73 = parcelRequire("1gQ73");

var $eYeFr = parcelRequire("eYeFr");

var $bP7Jx = parcelRequire("bP7Jx");

var $7kNqR = parcelRequire("7kNqR");

var $8NpPd = parcelRequire("8NpPd");

var $bPVI5 = parcelRequire("bPVI5");

var $6n5K0 = parcelRequire("6n5K0");
const $a55f95cb309b3a7e$export$7499acaeff5d6912 = ({ isPriorityEnabled: isPriorityEnabled, priorities: priorities, canChangePriority: canChangePriority, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (!isPriorityEnabled || !canChangePriority) return [];
    const priorityOptions = priorities.map((value)=>({
            type: (0, $fMoec.MenuNodeType).Item,
            id: `${0, $bPVI5.PRIORITY_MENU_ID}/value__${value.id}`,
            label: value.name,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnzPP.default), {
                url: value.iconUrl
            }),
            onClick: (analyticsEvent)=>onClick(value, analyticsEvent)
        }));
    if ((0, $1ybV0.ff)('priorities.per.project.backlog-contextual-menu') && priorityOptions.length === 0) return [];
    return [
        {
            type: (0, $fMoec.MenuNodeType).Item,
            id: (0, $bPVI5.PRIORITY_MENU_ID),
            label: formatMessage((0, $6n5K0.default).priority),
            children: priorityOptions
        }
    ];
};
const $a55f95cb309b3a7e$export$5b10fbc9ee011cb3 = ({ selectedCardIds: selectedCardIds })=>{
    const priorities = (0, $1gQ73.useBacklogSelector)((0, $8NpPd.getPriorities));
    const cardEntities = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getCards));
    const getIssueKey = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.makeCardKeyFromCardId));
    const canBulkEdit = (0, $1gQ73.useBacklogSelector)((0, $7kNqR.canBulkEditIssues));
    const canEdit = (0, $1gQ73.useBacklogSelector)((0, $7kNqR.canEditIssue));
    const canChangePriority = canBulkEdit && canEdit;
    const onPriorityClick = (0, $1gQ73.useBacklogActionCreator)((priority, analyticsEvent)=>(0, $MYW4e.batchActions)(selectedCardIds.map((id)=>(0, $eYeFr.cardPrioritySetOptimistic)({
                cardId: id,
                priority: priority
            }, getIssueKey(id), analyticsEvent))));
    const isPriorityEnabled = (0, $eUqFw.useMemo)(()=>selectedCardIds.some((cardId)=>cardEntities[String(cardId)]?.priority), [
        selectedCardIds,
        cardEntities
    ]);
    return $a55f95cb309b3a7e$export$7499acaeff5d6912({
        isPriorityEnabled: isPriorityEnabled,
        priorities: priorities,
        canChangePriority: canChangePriority,
        onClick: (priority, analyticsEvent)=>onPriorityClick(priority, analyticsEvent)
    });
};

});
parcelRegister("hnzPP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca9fc3da0c774fa7$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ /* eslint-disable jira/react/handler-naming */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $PdmhA = parcelRequire("PdmhA");

var $c9TLT = parcelRequire("c9TLT");
const $ca9fc3da0c774fa7$export$c6d2b2df39d78e5b = (0, $c9TLT.gridSize) * 2;
class $ca9fc3da0c774fa7$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            url: undefined,
            title: undefined,
            alt: undefined,
            width: $ca9fc3da0c774fa7$export$c6d2b2df39d78e5b,
            height: $ca9fc3da0c774fa7$export$c6d2b2df39d78e5b,
            fallback: undefined
        };
    }
    render() {
        const { title: title, url: url, alt: alt, fallback: fallback } = this.props;
        const width = this.convertSize(this.props.width);
        const height = this.convertSize(this.props.height);
        if (this.state.isBroken && fallback) return fallback();
        return url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ca9fc3da0c774fa7$var$Image, {
            src: url,
            width: width,
            height: height,
            title: title ?? undefined,
            alt: alt ?? '',
            onError: this.onError,
            draggable: false
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ca9fc3da0c774fa7$var$ImagePlaceholder, {
            width: width,
            height: height,
            "data-testid": "common-components-async-icon.placeholder"
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            isBroken: false
        };
        this.onError = ()=>{
            this.setState({
                isBroken: true
            });
        };
        this.convertSize = (size)=>size ? `${size}px` : '0';
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ca9fc3da0c774fa7$var$ImagePlaceholder = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "owe24v-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: props.width,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: (0, $PdmhA).N30,
        borderRadius: '3px',
        display: 'flex',
        flex: 'none'
    }));
// Firefox displays the alt text when the image can't load, the narrow provided width
// means this alt text leaks into the summary vertically if overflow is allowed
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ca9fc3da0c774fa7$var$Image = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});

});

parcelRegister("8NpPd", function(module, exports) {

$parcel$export(module.exports, "getPriorities", () => $ec98e9cb1de61c71$export$489e9c0d7da0a5e2);

var $kF7v3 = parcelRequire("kF7v3");
const $ec98e9cb1de61c71$export$489e9c0d7da0a5e2 = (state)=>(0, $kF7v3.getEntities)(state).priorities;

});


parcelRegister("lC0qI", function(module, exports) {

$parcel$export(module.exports, "useSplitIssue", () => $064c04ce00222029$export$ca834a1ba255430d);

var $5JgJ2 = parcelRequire("5JgJ2");

var $fMoec = parcelRequire("fMoec");


var $1gQ73 = parcelRequire("1gQ73");

var $cbRhO = parcelRequire("cbRhO");

var $7kNqR = parcelRequire("7kNqR");

var $bPVI5 = parcelRequire("bPVI5");

var $6n5K0 = parcelRequire("6n5K0");
const $064c04ce00222029$export$5f7e384ce14f24a6 = ({ onSplitIssue: onSplitIssue, canSplitIssue: canSplitIssue, isMultiSelect: isMultiSelect })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return isMultiSelect || !canSplitIssue ? [] : [
        {
            type: (0, $fMoec.MenuNodeType).Item,
            label: formatMessage((0, $6n5K0.default).splitIssue),
            id: (0, $bPVI5.SPLIT_ISSUE_MENU_ID),
            onClick: onSplitIssue
        }
    ];
};
const $064c04ce00222029$export$ca834a1ba255430d = ({ issueId: issueId, isMultiSelect: isMultiSelect })=>{
    const onSplitIssue = (0, $1gQ73.useBacklogActionCreator)(()=>(0, $cbRhO.openModal)({
            type: (0, $ebd52ea7083e351b$export$77e94846ed2f57d7),
            payload: {
                cardId: issueId
            }
        }));
    const canCreate = (0, $1gQ73.useBacklogSelector)((0, $7kNqR.canCreateIssues));
    const canEdit = (0, $1gQ73.useBacklogSelector)((0, $7kNqR.canEditIssue));
    const canSplitIssue = canCreate && canEdit;
    return $064c04ce00222029$export$5f7e384ce14f24a6({
        onSplitIssue: onSplitIssue,
        canSplitIssue: canSplitIssue,
        isMultiSelect: isMultiSelect
    });
};

});

parcelRegister("fz7Ay", function(module, exports) {

$parcel$export(module.exports, "useVersion", () => $416d339e62be3340$export$d01fd6c038443a68);

var $eUqFw = parcelRequire("eUqFw");

var $MdoH4 = parcelRequire("MdoH4");

var $0cdA8 = parcelRequire("0cdA8");

var $fMoec = parcelRequire("fMoec");


var $1gQ73 = parcelRequire("1gQ73");

var $bP7Jx = parcelRequire("bP7Jx");

var $bPVI5 = parcelRequire("bPVI5");

var $dU2n6 = parcelRequire("dU2n6");
const $416d339e62be3340$export$356153774e3dba20 = (versionMenuProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        packageName: (0, $e1409a6fc345c0d8$export$dfd208682d29484c),
        id: "jira.backlog.context-menu.version"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Suspense, {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dU2n6.VersionMenu), versionMenuProps)));
const $416d339e62be3340$var$EMPTY_ARR = [];
const $416d339e62be3340$export$d01fd6c038443a68 = ({ selectedCardIds: selectedCardIds, versionMenuQueryRef: versionMenuQueryRef })=>{
    const cards = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getCards));
    return (0, $eUqFw.useMemo)(()=>{
        if (!versionMenuQueryRef) return $416d339e62be3340$var$EMPTY_ARR;
        const selectedCards = selectedCardIds.map((cardId)=>cards[cardId]).filter(Boolean);
        // Selected cards are valid if they belong to the same project
        const isCardSelectionValid = (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))(selectedCards.map((card)=>card.projectId)).length === 1;
        if (!isCardSelectionValid) return $416d339e62be3340$var$EMPTY_ARR;
        const menuItemNode = {
            type: (0, $fMoec.MenuNodeType).Node,
            id: `${(0, $bPVI5.VERSION_MENU_ID)}/node`,
            node: (menuItemNodeArgs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($416d339e62be3340$export$356153774e3dba20, {
                    selectedCardIds: selectedCardIds,
                    selectedCards: selectedCards,
                    versionMenuQueryRef: versionMenuQueryRef,
                    menuItemNodeArgs: menuItemNodeArgs
                })
        };
        return [
            menuItemNode
        ];
    }, [
        cards,
        selectedCardIds,
        versionMenuQueryRef
    ]);
};

});
parcelRegister("dU2n6", function(module, exports) {

$parcel$export(module.exports, "VersionMenu", () => $f27a977e9e9d1850$export$ff839af10c1133ea);

var $3eP7U = parcelRequire("3eP7U");

var $1N1uk = parcelRequire("1N1uk");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $65rzN = parcelRequire("65rzN");
var $hW9Uo = parcelRequire("hW9Uo");
var $01b2t = parcelRequire("01b2t");
var $fMoec = parcelRequire("fMoec");
var $kKRiz = parcelRequire("kKRiz");

var $bPVI5 = parcelRequire("bPVI5");

var $6n5K0 = parcelRequire("6n5K0");

var $jNtHy = parcelRequire("jNtHy");

var $aqMF3 = parcelRequire("aqMF3");
const $f27a977e9e9d1850$var$OptionType = {
    Version: 'version',
    Unlink: 'unlink'
};
const $f27a977e9e9d1850$var$transformOptionToString = (option)=>option.type === $f27a977e9e9d1850$var$OptionType.Version ? option.edge.node.name : option.label;
const $f27a977e9e9d1850$export$6a451aef481e8837 = (0, $1N1uk.default);
const $f27a977e9e9d1850$export$ff839af10c1133ea = ({ versionMenuQueryRef: versionMenuQueryRef, ...props })=>{
    const data = (0, $iWLL0.usePreloadedQuery)($f27a977e9e9d1850$export$6a451aef481e8837, versionMenuQueryRef);
    const versionEdges = (0, $eUqFw.useMemo)(()=>data.jira.versionsForProjects.edges.filter(Boolean), [
        data
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f27a977e9e9d1850$var$VersionMenuContent, {
        ...props,
        versionEdges: versionEdges
    });
};
const $f27a977e9e9d1850$var$VersionMenuContent = ({ selectedCardIds: selectedCardIds, selectedCards: selectedCards, menuItemNodeArgs: menuItemNodeArgs, versionEdges: versionEdges })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    // Without breaking the edges between query and fragment, we cannot make the fields here required due to the connection
    const versions = (0, $iWLL0.useFragment)((0, $3eP7U.default), versionEdges);
    const versionOptions = (0, $eUqFw.useMemo)(()=>{
        // Menu's only rendered if selected cards belong to the same project, so we can filter the versions using it
        const projectId = String(selectedCards[0].projectId);
        const filteredVersions = versions.filter(({ node: node })=>node.status === 'UNRELEASED' && node.project.projectId === projectId);
        // If there's only 1 card selected, ensure any already assigned versions are removed from the list
        const firstCardVersionIds = selectedCards[0]?.fixVersions ?? [];
        const availableVersions = selectedCards.length === 1 && firstCardVersionIds.length > 0 ? filteredVersions.filter(({ node: node })=>!firstCardVersionIds.includes(node.versionId)) : filteredVersions;
        return availableVersions.map((edge)=>({
                type: $f27a977e9e9d1850$var$OptionType.Version,
                edge: edge
            }));
    }, [
        versions,
        selectedCards
    ]);
    // Show unlink option if any card's version can be found in our queried versions
    const versionIdsSet = (0, $eUqFw.useMemo)(()=>new Set(versions.map(({ node: node })=>node.versionId)), [
        versions
    ]);
    const showUnlinkMenuItem = (0, $eUqFw.useMemo)(()=>selectedCards.some((card)=>card.fixVersions?.some((versionId)=>versionIdsSet.has(versionId)) ?? false), [
        selectedCards,
        versionIdsSet
    ]);
    const options = (0, $eUqFw.useMemo)(()=>showUnlinkMenuItem ? [
            {
                type: $f27a977e9e9d1850$var$OptionType.Unlink,
                label: formatMessage((0, $6n5K0.default).versionUnlinkOptionLabel)
            },
            ...versionOptions
        ] : versionOptions, [
        versionOptions,
        formatMessage,
        showUnlinkMenuItem
    ]);
    const [filteredOptions, updateFilter] = (0, $kKRiz.useTextFilter)(options, $f27a977e9e9d1850$var$transformOptionToString);
    return versionOptions.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hW9Uo.ContextMenuNode), {
        ...menuItemNodeArgs,
        menuNode: {
            type: (0, $fMoec.MenuNodeType).Item,
            id: `${(0, $bPVI5.VERSION_MENU_ID)}/menu`,
            label: formatMessage((0, $6n5K0.default).versionOptionLabel),
            submenuWidth: 284,
            element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $01b2t.ContextMenuSearch), {
                onChange: updateFilter,
                autoFocus: true,
                isAsyncSearch: false,
                isLoading: false,
                hasSearch: options.length > 6,
                hasResult: filteredOptions.length > 0,
                resultsCount: filteredOptions.length
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $65rzN.A11yList), null, filteredOptions.map((option)=>option.type === $f27a977e9e9d1850$var$OptionType.Version ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $65rzN.A11yListItem), {
                    key: option.edge.node.versionId
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aqMF3.VersionMenuItem), {
                    selectedCardIds: selectedCardIds,
                    versionEdge: option.edge,
                    menuItemNodeArgs: menuItemNodeArgs
                })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $65rzN.A11yListItem), {
                    key: "unlink"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jNtHy.UnlinkMenuItem), {
                    key: "unlink",
                    selectedCardIds: selectedCardIds,
                    label: option.label,
                    menuItemNodeArgs: menuItemNodeArgs
                })))))
        }
    }) : null;
};

});
parcelRegister("3eP7U", function(module, exports) {

$parcel$export(module.exports, "default", () => $642a150f25ed8379$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<982c324b2465f44e22128f5709dfdd89>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $642a150f25ed8379$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "versionMenu_softwareBacklog_VersionMenuContent",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "versionId"
                        },
                        "action": "THROW",
                        "path": "node.versionId"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        "action": "THROW",
                        "path": "node.name"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        "action": "THROW",
                        "path": "node.status"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "projectId"
                                    },
                                    "action": "THROW",
                                    "path": "node.project.projectId"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "node.project"
                    }
                ]
            },
            "action": "THROW",
            "path": "node"
        },
        {
            "kind": "FragmentSpread",
            "name": "versionMenuItem_softwareBacklog"
        }
    ],
    "type": "JiraVersionEdge"
};
$642a150f25ed8379$var$node.hash = "a4cdeffafe39db4bddd6ce699b40af53";
var $642a150f25ed8379$export$2e2bcd8739ae039 = $642a150f25ed8379$var$node;

});

parcelRegister("65rzN", function(module, exports) {

$parcel$export(module.exports, "ContextMenuInner", () => $6d9744d6386895ce$export$bcdb1c07321c5951);
$parcel$export(module.exports, "A11yList", () => $6d9744d6386895ce$export$eb8d03735465a5c2);
$parcel$export(module.exports, "A11yListItem", () => $6d9744d6386895ce$export$c545894512c6d817);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4E9Xv = parcelRequire("4E9Xv");

var $dkPd7 = parcelRequire("dkPd7");

var $fMoec = parcelRequire("fMoec");

var $hV91H = parcelRequire("hV91H");

var $4cIIr = parcelRequire("4cIIr");

var $6DFOC = parcelRequire("6DFOC");

var $hW9Uo = parcelRequire("hW9Uo");

var $5tCAH = parcelRequire("5tCAH");

var $do3uV = parcelRequire("do3uV");
const $6d9744d6386895ce$export$bcdb1c07321c5951 = ({ scope: scope, menuItems: menuItems, openPath: openPath, shouldRenderToParent: shouldRenderToParent = true })=>{
    const { closeMenu: closeMenu, openSubMenu: openSubMenu, closeSubMenu: closeSubMenu, setForcedFocusPath: setForcedFocusPath, setPersistentFocus: setPersistentFocus } = (0, $6DFOC.useContextMenuActions)();
    const previousItemFocusPath = (0, $eUqFw.useRef)(undefined);
    const { addMappedAnalyticsToEvent: addMappedAnalyticsToEvent, fireUIAnalyticsForNode: fireUIAnalyticsForNode } = (0, $4cIIr.useContextMenuAnalytics)();
    const bulkOpsFlow = (0, $4E9Xv.useBulkOpsSessionContext)();
    const isPersistentFocus = (0, $6DFOC.useIsPersistentFocus)();
    const handleOpenSubMenu = (0, $eUqFw.useCallback)((menuItem)=>{
        previousItemFocusPath.current = menuItem.id;
        openSubMenu(scope, menuItem);
    }, [
        scope,
        openSubMenu
    ]);
    const handleCloseSubMenu = (0, $eUqFw.useCallback)(()=>{
        closeSubMenu(scope);
    }, [
        scope,
        closeSubMenu
    ]);
    const onClickContentMenuNode = (0, $dkPd7.useEvent)((menuItem, analyticsEvent)=>{
        if (menuItem.type === (0, $fMoec.MenuNodeType).Item) {
            if ((0, $do3uV.hasSubmenuItems)(menuItem)) {
                if (!(0, $do3uV.isSubmenuOpen)(openPath)) // clicked on menu item - submenu closed
                handleOpenSubMenu(menuItem);
                else if ((0, $do3uV.isSubmenuOpenForNode)(menuItem, openPath)) // click on opened menu item - submenu open
                handleCloseSubMenu();
                else if (!(0, $do3uV.isSubmenuOpenForNode)(menuItem, openPath)) {
                    // clicked on different menu item - submenu open
                    handleCloseSubMenu();
                    handleOpenSubMenu(menuItem);
                }
            } else {
                // clicked on root menu item
                const event = addMappedAnalyticsToEvent(analyticsEvent, menuItem.id, menuItem.analytics);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                menuItem.onClick?.(event.clone());
                bulkOpsFlow?.executeAction();
                const attributes = bulkOpsFlow?.getFlowAttributes();
                fireUIAnalyticsForNode(event, menuItem.id, menuItem.analytics, {
                    ...attributes,
                    asdfsadf: 'asdfasdf'
                });
                closeMenu(scope);
            }
        }
    });
    const onMouseEnter = (0, $dkPd7.useEvent)((menuItem)=>{
        if (isPersistentFocus) setPersistentFocus(false);
        if (!(0, $do3uV.isSubmenuOpenForNode)(menuItem, openPath) && menuItem.type === (0, $fMoec.MenuNodeType).Item && (0, $do3uV.hasSubmenuItems)(menuItem)) {
            /*
                 setTimeout is needed to avoid conflicting situation, when 2 updates are being kicked off
                 at the same time because react-sweet-state batches updates.
                */ setTimeout(()=>{
                // hovered on menu item - submenu closed
                handleOpenSubMenu(menuItem);
            }, 0);
            return;
        }
        if ((0, $do3uV.isSubmenuOpen)(openPath) && !(0, $do3uV.isSubmenuOpenForNode)(menuItem, openPath)) {
            // We don't want to focus any element when closing a submenu because of `mouseLeave`
            previousItemFocusPath.current = undefined;
            closeSubMenu(scope);
        }
        if (menuItem.type === (0, $fMoec.MenuNodeType).Item) menuItem.onMouseEnter?.();
    });
    const renderNode = (0, $eUqFw.useCallback)((node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hW9Uo.ContextMenuNode), {
            scope: scope,
            menuNode: node,
            onClick: onClickContentMenuNode,
            onMouseEnter: onMouseEnter,
            shouldRenderToParent: shouldRenderToParent
        }), [
        onClickContentMenuNode,
        onMouseEnter,
        scope,
        shouldRenderToParent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!(0, $do3uV.isSubmenuOpen)(openPath) && previousItemFocusPath.current !== undefined) {
            setForcedFocusPath(scope, previousItemFocusPath.current);
            previousItemFocusPath.current = undefined;
        }
    }, [
        openPath,
        scope,
        setForcedFocusPath
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const handleEscapeNavigation = (ev)=>{
            if (ev.key === 'Escape') {
                ev.preventDefault();
                if ((0, $do3uV.isSubmenuOpen)(openPath)) handleCloseSubMenu();
                else closeMenu(scope);
            }
        };
        window.addEventListener('keyup', handleEscapeNavigation);
        return ()=>{
            window.removeEventListener('keyup', handleEscapeNavigation);
        };
    }, [
        scope,
        closeMenu,
        handleCloseSubMenu,
        openPath
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5tCAH.FocusLockedWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hV91H.ContextMenuNodeList), {
        menuNodes: menuItems,
        renderNode: renderNode
    }));
};
const $6d9744d6386895ce$export$eb8d03735465a5c2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});
const $6d9744d6386895ce$export$c545894512c6d817 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hV91H", function(module, exports) {

$parcel$export(module.exports, "ContextMenuNodeList", () => $b7c476b3f9820844$export$59ef8d374540d9f8);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $b7c476b3f9820844$var$listStyles = (0, $1ZAYh.xcss)({
    listStyle: 'none',
    padding: 'space.0',
    margin: 'space.0'
});
const $b7c476b3f9820844$var$listItemStyles = (0, $1ZAYh.xcss)({
    padding: 'space.0',
    margin: 'space.0'
});
const $b7c476b3f9820844$export$59ef8d374540d9f8 = /*#__PURE__*/ (0, $eUqFw.memo)(({ menuNodes: menuNodes, renderNode: renderNode })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "ul",
        xcss: $b7c476b3f9820844$var$listStyles
    }, menuNodes.map((menuNode)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            as: "li",
            key: menuNode.id,
            xcss: $b7c476b3f9820844$var$listItemStyles
        }, renderNode(menuNode)))));

});

parcelRegister("hW9Uo", function(module, exports) {

$parcel$export(module.exports, "ContextMenuNode", () => $30e4ddeb2e5a4cf6$export$b809af7ff33fc17d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bFzGY = parcelRequire("bFzGY");

var $fMoec = parcelRequire("fMoec");

var $hV91H = parcelRequire("hV91H");

var $4cIIr = parcelRequire("4cIIr");

var $6DFOC = parcelRequire("6DFOC");

var $dabz6 = parcelRequire("dabz6");


var $bkufV = parcelRequire("bkufV");

var $01b2t = parcelRequire("01b2t");

var $jCETS = parcelRequire("jCETS");
const $30e4ddeb2e5a4cf6$export$b809af7ff33fc17d = ({ scope: scope, menuNode: menuNode, onClick: onClick, onMouseEnter: onMouseEnter, shouldRenderToParent: shouldRenderToParent = true })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { addMappedAnalyticsToEvent: addMappedAnalyticsToEvent, fireUIAnalyticsForNode: fireUIAnalyticsForNode } = (0, $4cIIr.useContextMenuAnalytics)();
    const { closeMenu: closeMenu } = (0, $6DFOC.useContextMenuActions)();
    const getMenuItemNodeProps = (0, $eUqFw.useCallback)((menuItem)=>{
        const analyticsEvent = addMappedAnalyticsToEvent(createAnalyticsEvent({
            actionSubject: 'dropdownItem',
            action: 'clicked'
        }), menuItem.id, menuItem.analytics);
        return {
            scope: scope,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            analyticsEvent: analyticsEvent.clone(),
            closeMenu: ()=>{
                closeMenu(scope);
                fireUIAnalyticsForNode(analyticsEvent, menuItem.id, menuItem.analytics);
            },
            onClick: onClick,
            onMouseEnter: onMouseEnter
        };
    }, [
        createAnalyticsEvent,
        fireUIAnalyticsForNode,
        addMappedAnalyticsToEvent,
        closeMenu,
        scope,
        onClick,
        onMouseEnter
    ]);
    const renderNode = (0, $eUqFw.useCallback)((node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($30e4ddeb2e5a4cf6$export$b809af7ff33fc17d, {
            scope: scope,
            menuNode: node,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            shouldRenderToParent: shouldRenderToParent
        }), [
        onClick,
        onMouseEnter,
        scope,
        shouldRenderToParent
    ]);
    if (menuNode.type === (0, $fMoec.MenuNodeType).Section) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jCETS.ContextMenuSection), {
        section: menuNode
    }, menuNode.children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hV91H.ContextMenuNodeList), {
        menuNodes: menuNode.children,
        renderNode: renderNode
    }));
    if (menuNode.type === (0, $fMoec.MenuNodeType).Item) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4cIIr.ContextualAnalyticsDataFromNode), {
        id: menuNode.id,
        updater: menuNode.analytics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bkufV.ContextMenuItem), {
        scope: scope,
        menuItem: menuNode,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        shouldRenderToParent: shouldRenderToParent
    }, /*#__PURE__*/ (0, $eUqFw.isValidElement)(menuNode.element) ? menuNode.element : menuNode.children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hV91H.ContextMenuNodeList), {
        menuNodes: menuNode.children,
        renderNode: renderNode
    })));
    if (menuNode.type === (0, $fMoec.MenuNodeType).Node) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4cIIr.ContextualAnalyticsDataFromNode), {
        id: menuNode.id,
        updater: menuNode.analytics
    }, typeof menuNode.node === 'function' ? menuNode.node(getMenuItemNodeProps(menuNode)) : menuNode.node);
    if (menuNode.type === (0, $fMoec.MenuNodeType).Separator) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($30e4ddeb2e5a4cf6$var$ContextMenuSeparator, {
        tabIndex: -1,
        "data-testid": (0, $136a2a05630e3d03$export$c1dbf4585c850e82)
    });
    if (menuNode.type === (0, $fMoec.MenuNodeType).BulkIndicator) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dabz6.BulkIndicator), {
        selectedCount: menuNode.selectedCount,
        "data-testid": (0, $136a2a05630e3d03$export$4502867028c77602)
    });
    if (menuNode.type === (0, $fMoec.MenuNodeType).Search) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $01b2t.ContextMenuSearch), {
        onChange: menuNode.onChange,
        autoFocus: menuNode.autoFocus,
        maxViewportItems: menuNode.maxViewportItems,
        hasSearch: menuNode.hasSearch,
        isAsyncSearch: menuNode.isAsyncSearch,
        isLoading: menuNode.isLoading ?? false,
        hasResult: !!menuNode.children?.length,
        ariaLabel: menuNode.ariaLabel,
        resultsCount: menuNode.children.length
    }, !menuNode.isLoading && !!menuNode.children?.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hV91H.ContextMenuNodeList), {
        menuNodes: menuNode.children,
        renderNode: renderNode
    }));
    return null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $30e4ddeb2e5a4cf6$var$ContextMenuSeparator = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3it94y _1bsb1osq _11q7hloo _18s8swc3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dabz6", function(module, exports) {

$parcel$export(module.exports, "BulkIndicator", () => $4f955f64098230ef$export$1dde12b63932e6bf);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $9nkwJ = parcelRequire("9nkwJ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dGSnA = parcelRequire("dGSnA");
const $4f955f64098230ef$export$1dde12b63932e6bf = ({ selectedCount: selectedCount })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f955f64098230ef$var$BulkIndicatorContainer, {
        tabIndex: -1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
        appearance: "primary"
    }, selectedCount), " ", formatMessage((0, $dGSnA.messages).selected));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f955f64098230ef$var$BulkIndicatorContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3izwfg _1e0c1txw _1yt4ie5z _4cvr1h6o _1p1dangw _syazjjyb _11c8qk37 _k48p1wq8 _zulpu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dGSnA", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4673951ad29627e3$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $4673951ad29627e3$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    selected: {
        "id": "software-context-menu.menu-renderer.context-menu-inner.context-menu-node.bulk-indicator.selected",
        "defaultMessage": "Selected"
    }
});

});


const $136a2a05630e3d03$export$c1dbf4585c850e82 = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-separator';
const $136a2a05630e3d03$export$4502867028c77602 = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-bulk-indicator';

parcelRegister("bkufV", function(module, exports) {

$parcel$export(module.exports, "ContextMenuItem", () => $c2ed792edea57f29$export$16a26dc176a49100);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");


var $6DFOC = parcelRequire("6DFOC");

var $imCoB = parcelRequire("imCoB");

var $jkl3c = parcelRequire("jkl3c");

var $iLgzn = parcelRequire("iLgzn");
const $c2ed792edea57f29$var$OverflowVisiblePopupContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c2ed792edea57f29$var$OverflowVisiblePopupContainerStyled, {
        ...props,
        ref: ref,
        "data-testid": (0, $e8879a4af726a467$export$75f77b2251314894)
    }, children));
const $c2ed792edea57f29$export$16a26dc176a49100 = ({ scope: scope, menuItem: menuItem, children: children, onMouseEnter: onMouseEnter, shouldRenderToParent: shouldRenderToParent = true, ...others })=>{
    const ref = (0, $eUqFw.useRef)(null);
    const { setForcedFocusPath: setForcedFocusPath } = (0, $6DFOC.useContextMenuActions)();
    const shouldFocus = (0, $6DFOC.useShouldForceFocus)({
        scope: scope,
        menuItem: menuItem
    });
    const { persistentFocus: persistentFocus, enablePersistentFocus: enablePersistentFocus, disablePersistentFocus: disablePersistentFocus, isOpen: isOpen } = (0, $iLgzn.useSubmenuPersistentFocus)({
        menuItem: menuItem,
        scope: scope
    });
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (ref.current !== null && document.activeElement !== ref.current) {
            if (shouldFocus) {
                ref.current?.focus();
                setForcedFocusPath(scope, undefined);
            }
        }
    }, [
        shouldFocus,
        scope,
        setForcedFocusPath
    ]);
    const Content = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jkl3c.SubmenuContainer), {
            width: menuItem.submenuWidth,
            shouldOverflowChildren: menuItem.shouldOverflowChildren,
            persistentFocus: persistentFocus
        }, children), [
        menuItem.submenuWidth,
        menuItem.shouldOverflowChildren,
        children,
        persistentFocus
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        autoFocus: false,
        offset: [
            0,
            0
        ],
        isOpen: !!isOpen && !!children,
        popupComponent: menuItem.shouldOverflowChildren ? $c2ed792edea57f29$var$OverflowVisiblePopupContainer : undefined,
        content: Content,
        placement: "right-start",
        shouldRenderToParent: shouldRenderToParent,
        trigger: ({ ref: popupRef, ...popupProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $imCoB.ContextMenuItemButton), {
                ...popupProps,
                ref: (r)=>{
                    if (popupRef) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    popupRef(r);
                    ref.current = r;
                },
                isOpen: isOpen,
                hasChildren: !!children,
                menuItem: menuItem,
                onOpenWithKeyboard: enablePersistentFocus,
                onMouseEnter: (node)=>{
                    disablePersistentFocus();
                    onMouseEnter(node);
                },
                ...others
            })
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c2ed792edea57f29$var$OverflowVisiblePopupContainerStyled = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reoewfl _18m9ewfl _2rko1l7b _16qs1mxi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("imCoB", function(module, exports) {

$parcel$export(module.exports, "ContextMenuItemButton", () => $471d6285557aeb8b$export$c41377fb9346496d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $dtaN9 = parcelRequire("dtaN9");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $8cU5f = parcelRequire("8cU5f");

var $g8JvH = parcelRequire("g8JvH");

var $dkPd7 = parcelRequire("dkPd7");

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $471d6285557aeb8b$var$ContextMenuItemButtonAnalyticsWrapper = (0, $g8JvH.AnalyticsEventToProps)('dropdownItem', {
    onClick: 'clicked'
})(/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ createAnalyticsEvent: createAnalyticsEvent, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($471d6285557aeb8b$var$StyledContextMenuItemButton, {
        ...props,
        ref: ref
    })));
const $471d6285557aeb8b$export$90c1cb250e648e1f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ menuItem: menuItem, hasChildren: hasChildren }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, menuItem.icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $471d6285557aeb8b$var$contextMenuIconStyles
    }, menuItem.icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($471d6285557aeb8b$var$ContextMenuLabel, {
        ref: ref,
        "data-testid": (0, $e8879a4af726a467$export$ae734f89618d3c5f)
    }, typeof menuItem.label === 'string' ? menuItem.label : menuItem.label()), hasChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
        label: menuItem.id,
        testId: (0, $e8879a4af726a467$export$ef86d72244e00c00)
    })));
const $471d6285557aeb8b$export$7387ff9c7ca7b0ae = ()=>(0, $eUqFw.useRef)(null);
const $471d6285557aeb8b$export$c41377fb9346496d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ menuItem: menuItem, isOpen: isOpen, onMouseEnter: onMouseEnter, onClick: onClick, hasChildren: hasChildren, onOpenWithKeyboard: onOpenWithKeyboard }, ref)=>{
    const [hasEllipsis, setHasEllipsis] = (0, $eUqFw.useState)(false);
    const labelRef = $471d6285557aeb8b$export$7387ff9c7ca7b0ae();
    const onMouseEnterHandler = (0, $dkPd7.useEvent)(()=>onMouseEnter(menuItem));
    const onHandleClick = (0, $dkPd7.useEvent)((e, analyticsEvent)=>{
        e.preventDefault();
        e.stopPropagation();
        if (e.detail === 0) onOpenWithKeyboard?.();
        onClick(menuItem, analyticsEvent);
    });
    const onHandleKeyDown = (0, $dkPd7.useEvent)((e)=>{
        if (e.key === 'Enter') e.stopPropagation();
    });
    (0, $eUqFw.useEffect)(()=>{
        if (labelRef.current) {
            const isContentOverflowing = labelRef.current.scrollWidth > labelRef.current.clientWidth;
            setHasEllipsis(isContentOverflowing);
        }
    }, [
        labelRef
    ]);
    const commonProps = {
        'data-testid': (0, $e8879a4af726a467$export$8e765acf3440e0b),
        ref: ref,
        isOpen: isOpen,
        onClick: onHandleClick,
        onMouseEnter: onMouseEnterHandler,
        onKeyDown: onHandleKeyDown
    };
    return hasEllipsis ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        testId: (0, $e8879a4af726a467$export$602eb83148423ac6),
        content: typeof menuItem.label === 'string' ? menuItem.label : menuItem.label()
    }, ({ ref: tooltipRef, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($471d6285557aeb8b$var$ContextMenuItemButtonAnalyticsWrapper, {
            ...rest,
            ...commonProps,
            ...hasChildren && {
                'aria-expanded': !!isOpen
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($471d6285557aeb8b$export$90c1cb250e648e1f, {
            hasChildren: hasChildren,
            menuItem: menuItem,
            ref: (r)=>{
                labelRef.current = r;
                tooltipRef(r);
            }
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($471d6285557aeb8b$var$ContextMenuItemButtonAnalyticsWrapper, {
        ...commonProps,
        ...hasChildren && {
            'aria-expanded': !!isOpen
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($471d6285557aeb8b$export$90c1cb250e648e1f, {
        hasChildren: hasChildren,
        menuItem: menuItem,
        ref: labelRef
    }));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $471d6285557aeb8b$var$StyledContextMenuItemButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isOpen: isOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _19itglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1e5h _1yt413su _1e0c1txw _1bah1h6o _4cvr1h6o _4t3izwfg _zulp1b66 _7ehiglyw _1bg41i6y",
            __cmplp.isOpen ? "_bfhk29zg" : "_bfhk1kw7",
            __cmplp.isOpen ? "_syaz16q2" : "_syaz1fxt",
            __cmplp.isOpen ? "_irr329zg" : "_irr31nz6",
            __cmplp.className
        ])
    });
});
const $471d6285557aeb8b$var$ContextMenuLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81oud _16jlkb7n _1o9zkb7n _i0dlf1ug _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $471d6285557aeb8b$var$contextMenuIconStyles = (0, $1ZAYh.xcss)({
    paddingRight: 'space.100'
});

});

parcelRegister("jkl3c", function(module, exports) {

$parcel$export(module.exports, "SubmenuContainer", () => $8228bbb6045b5cee$export$5e6b4e3ac9115f51);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $6Pq2D = parcelRequire("6Pq2D");

var $1ybV0 = parcelRequire("1ybV0");

const $8228bbb6045b5cee$var$stopPropagation = (e)=>{
    e.stopPropagation();
};
const $8228bbb6045b5cee$export$5e6b4e3ac9115f51 = ({ children: children, width: width = (0, $e8879a4af726a467$export$6b4c950ad6cadf50), shouldOverflowChildren: shouldOverflowChildren, persistentFocus: persistentFocus = false })=>{
    const contextMenuContainerRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        const eventRef = contextMenuContainerRef.current;
        eventRef?.addEventListener('mousedown', $8228bbb6045b5cee$var$stopPropagation);
        return ()=>{
            eventRef?.removeEventListener('mousedown', $8228bbb6045b5cee$var$stopPropagation);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Pq2D.default), {
        disabled: !persistentFocus,
        persistentFocus: persistentFocus,
        autoFocus: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8228bbb6045b5cee$export$4f48a5067cf73390, {
        width: width,
        ref: contextMenuContainerRef,
        "data-testid": (0, $e8879a4af726a467$export$b3f11e5d123cdbe9),
        shouldOverflowChildren: shouldOverflowChildren
    }, children));
};
const $8228bbb6045b5cee$export$4f48a5067cf73390 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldOverflowChildren: shouldOverflowChildren, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $9t7rW.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q71bhr _c71l1kdj _vchhusvi _1pby16oo _2rko1l7b _1e0c1ule _1bsb1hdq",
            __cmplp.shouldOverflowChildren ? "_1reoewfl" : "_1reo15vq",
            __cmplp.shouldOverflowChildren ? "_18m9ewfl" : "_18m91wug",
            !(0, $1ybV0.ff)('deliveroo-migrate-spacings-to-tokens') && "_1ltv1osq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("iLgzn", function(module, exports) {

$parcel$export(module.exports, "useSubmenuPersistentFocus", () => $c1d8e4f01873e1ad$export$c220508d7e1c51c3);

var $eUqFw = parcelRequire("eUqFw");

var $fMoec = parcelRequire("fMoec");

var $6DFOC = parcelRequire("6DFOC");
const $c1d8e4f01873e1ad$export$c220508d7e1c51c3 = ({ scope: scope, menuItem: menuItem })=>{
    const isOpen = (0, $6DFOC.useMenuItemCheckOpen)({
        scope: scope,
        menuItem: menuItem
    });
    const hasSearch = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, $eUqFw.isValidElement)(menuItem.element) ? menuItem.element.props.hasSearch : menuItem.children?.some((s)=>s.type === (0, $fMoec.MenuNodeType).Search && s.hasSearch), [
        menuItem.element,
        menuItem.children
    ]);
    const [persistentFocus, setPersistentFocus] = (0, $eUqFw.useState)(hasSearch);
    const disablePersistentFocus = (0, $eUqFw.useCallback)(()=>{
        if (!hasSearch) setPersistentFocus(false);
    }, [
        hasSearch
    ]);
    return {
        persistentFocus: persistentFocus && isOpen,
        enablePersistentFocus: ()=>{
            setPersistentFocus(true);
        },
        disablePersistentFocus: disablePersistentFocus,
        isOpen: isOpen
    };
};

});


parcelRegister("01b2t", function(module, exports) {

$parcel$export(module.exports, "ContextMenuSearch", () => $9c9edd90aaa34bbb$export$800c7f2ae9d8f14d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $dxIU5 = parcelRequire("dxIU5");

var $dsroq = parcelRequire("dsroq");

var $cf2Y4 = parcelRequire("cf2Y4");

var $5JgJ2 = parcelRequire("5JgJ2");


var $a39Ky = parcelRequire("a39Ky");

var $jt07S = parcelRequire("jt07S");
const $9c9edd90aaa34bbb$export$800c7f2ae9d8f14d = ({ onChange: onChange, autoFocus: autoFocus = true, hasSearch: hasSearch = true, maxViewportItems: maxViewportItems = (0, $e8879a4af726a467$export$dce8cd449abd1f77), isLoading: isLoading = false, hasResult: hasResult = false, isAsyncSearch: isAsyncSearch, children: children, ariaLabel: ariaLabel, resultsCount: resultsCount })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [query, setQuery] = (0, $eUqFw.useState)('');
    (0, $eUqFw.useEffect)(()=>()=>{
            onChange?.(''); // reset the filter result when the component unmounts
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const debouncedOnChange = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((value)=>{
            onChange?.(value);
        }, (0, $e8879a4af726a467$export$1ec3328eed0aedd9)), [
        onChange
    ]);
    const handleChange = (0, $eUqFw.useCallback)((e)=>{
        const { value: value } = e.target;
        debouncedOnChange(value);
        setQuery(value);
    }, [
        debouncedOnChange,
        setQuery
    ]);
    const handleKeyDown = (e)=>{
        if (e.key === 'Escape' && query !== '') {
            e.preventDefault();
            e.stopPropagation();
            onChange?.('');
            setQuery('');
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9c9edd90aaa34bbb$var$ContextMenuSearchWrapper, {
        "data-testid": (0, $e8879a4af726a467$export$90350df905144507)
    }, hasSearch && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9c9edd90aaa34bbb$var$SearchWrapper, {
        role: "search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        role: "searchbox",
        "aria-label": ariaLabel,
        "aria-autocomplete": "list",
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9c9edd90aaa34bbb$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dsroq))), {
            label: formatMessage((0, $a39Ky.default).search),
            size: "small"
        })),
        onChange: handleChange,
        onKeyDown: handleKeyDown,
        placeholder: formatMessage((0, $a39Ky.default).search),
        isCompact: true,
        value: query,
        autoFocus: autoFocus
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jt07S.default), {
        resultsCount: resultsCount,
        query: query,
        isAsyncSearch: isAsyncSearch,
        isLoading: isLoading
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9c9edd90aaa34bbb$var$ContextMenuSearchContent, {
        maxViewportItems: maxViewportItems,
        "data-testid": (0, $e8879a4af726a467$export$328d05d650390cfd)
    }, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9c9edd90aaa34bbb$var$ContextMenuSearchMessage, {
        "data-testid": (0, $e8879a4af726a467$export$1245780b529c0d82)
    }, formatMessage((0, $a39Ky.default).loading)), !isLoading && !hasResult && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9c9edd90aaa34bbb$var$ContextMenuSearchMessage, {
        "data-testid": (0, $e8879a4af726a467$export$803f51dcf576f554)
    }, formatMessage((0, $a39Ky.default).noResults)), !isLoading && hasResult && children));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9c9edd90aaa34bbb$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syazqjbk _18u0u2gc _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/design-system/no-empty-styled-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9c9edd90aaa34bbb$var$ContextMenuSearchWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9c9edd90aaa34bbb$var$SearchWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4el4l _4t3izwfg _1e0c1txw _4cvr1h6o _n7zlh6cr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9c9edd90aaa34bbb$var$ContextMenuSearchContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { maxViewportItems: maxViewportItems, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_8dv613": (0, $9t7rW.default)(`${(0, $e8879a4af726a467$export$b9e05b29ae05bdd9) * __cmplp.maxViewportItems}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_c71lx1ju _18m91wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9c9edd90aaa34bbb$var$ContextMenuSearchMessage = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3izwfg _1e0c1txw _1bah1h6o _4cvr1h6o _syaz1thw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("a39Ky", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e39711a8b7bb0e6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7e39711a8b7bb0e6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    search: {
        "id": "software-context-menu.menu-renderer.context-menu-inner.context-menu-node.context-menu-search.search",
        "defaultMessage": "Search"
    },
    loading: {
        "id": "software-context-menu.menu-renderer.context-menu-inner.context-menu-node.context-menu-search.loading",
        "defaultMessage": "Loading..."
    },
    noResults: {
        "id": "software-context-menu.menu-renderer.context-menu-inner.context-menu-node.context-menu-search.no-results",
        "defaultMessage": "No results"
    }
});

});

parcelRegister("jt07S", function(module, exports) {

$parcel$export(module.exports, "default", () => $95744fe85dc75d57$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $hPdNw = parcelRequire("hPdNw");

var $5JgJ2 = parcelRequire("5JgJ2");


var $7m2Id = parcelRequire("7m2Id");
/** Generate a JSX friendly string filled with spaces */ const $95744fe85dc75d57$var$generateRandomSpaces = (max = 100)=>{
    const numSpaces = Math.round(Math.random() * max);
    return new Array(numSpaces).fill('\u00a0').join('');
};
const $95744fe85dc75d57$var$appendRandomSpacesToString = (text)=>`${text}${$95744fe85dc75d57$var$generateRandomSpaces()}`;
/**
 *
 * Triggers screenreader announcements of loading state and search result count
 */ const $95744fe85dc75d57$var$ResultsAnnouncer = ({ query: query, resultsCount: resultsCount, isAsyncSearch: isAsyncSearch, isLoading: isLoading })=>{
    const [message, setMessage] = (0, $eUqFw.useState)('');
    const hasMounted = (0, $eUqFw.useRef)(false);
    const prevLoading = (0, $eUqFw.useRef)(false);
    const prevQuery = (0, $eUqFw.useRef)(query);
    const prevCount = (0, $eUqFw.useRef)(resultsCount);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const setResultsMessage = (0, $eUqFw.useCallback)((count)=>{
        setMessage(/**
     * We need to append a random number of empty spaces to messages to
     * make them unique and force a re-announcement for two reasons:
     * 1) When the query has changed but the results count is the same,
     *    so the message wouldn't have changed
     * 2) During VoiceOver testing, it appeared that on ocassion the same
     *    message being output in a short space of time; even when a
     *    unique message was sandwiched in between; lead to messages being
     *    ignored by the screenreader.
     *
     * Although in theory AnnouncerV2 is built to handle these scenarios,
     * in testing this was not the case.
     */ $95744fe85dc75d57$var$appendRandomSpacesToString(formatMessage((0, $7m2Id.default).resultsAnnouncement, {
            count: count
        })));
    }, [
        formatMessage
    ]);
    /**
   * The updating of the message is debounced as 'query'
   * updates in real time, but the on change callback
   * that triggers the updating of results is itself debounced.
   * We only want to update the message once we've received the
   * new results, not everytime the query changes.
   */ const setMessageDebounced = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((newCount, newQuery, loading)=>{
            if (loading) setMessage($95744fe85dc75d57$var$appendRandomSpacesToString(formatMessage((0, $7m2Id.default).loading)));
            else if (isAsyncSearch && prevLoading.current) setResultsMessage(newCount);
            else if (!isAsyncSearch && newQuery !== prevQuery.current) setResultsMessage(newCount);
            prevLoading.current = loading;
            prevCount.current = newCount;
            prevQuery.current = newQuery;
        }, (0, $e8879a4af726a467$export$1ec3328eed0aedd9) + 50), [
        isAsyncSearch,
        formatMessage,
        setResultsMessage
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!hasMounted.current) hasMounted.current = true;
        else setMessageDebounced(resultsCount, query, isLoading);
    }, [
        isLoading,
        query,
        resultsCount,
        setMessageDebounced
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hPdNw.AnnouncerV2), {
        message: message
    });
};
var $95744fe85dc75d57$export$2e2bcd8739ae039 = $95744fe85dc75d57$var$ResultsAnnouncer;

});
parcelRegister("hPdNw", function(module, exports) {

$parcel$export(module.exports, "AnnouncerV2", () => $f3fdf175d37cb8cd$export$a43c8a2f4981e0e);

var $eUqFw = parcelRequire("eUqFw");

var $kjXsi = parcelRequire("kjXsi");
const $f3fdf175d37cb8cd$var$NON_BREAKING_SPACE = '\u00A0';
const $f3fdf175d37cb8cd$export$a43c8a2f4981e0e = /*#__PURE__*/ (0, $eUqFw.memo)(({ message: originalMessage, liveMode: liveMode = 'polite', shouldAnnounce: shouldAnnounce = true, testId: testId })=>{
    const previousMessage = (0, $eUqFw.useRef)('');
    const setAlternatePolite = (0, $eUqFw.useRef)(false);
    const addSuffix = (0, $eUqFw.useRef)(false);
    const [oldMessage, setOldMessage] = (0, $eUqFw.useState)('');
    const [newMessage, setNewMessage] = (0, $eUqFw.useState)('');
    (0, $eUqFw.useEffect)(()=>{
        let message = shouldAnnounce ? originalMessage : $f3fdf175d37cb8cd$var$NON_BREAKING_SPACE;
        if (previousMessage.current === message) {
            addSuffix.current = !addSuffix.current;
            if (addSuffix.current) message += $f3fdf175d37cb8cd$var$NON_BREAKING_SPACE;
        }
        setOldMessage(setAlternatePolite.current ? '' : message);
        setNewMessage(setAlternatePolite.current ? message : '');
        if (shouldAnnounce) setAlternatePolite.current = !setAlternatePolite.current;
        previousMessage.current = originalMessage;
    }, [
        originalMessage,
        shouldAnnounce
    ]);
    // 2 aria-live containers needed to prevent bugs in browsers that will stop
    // announcing updates to the same div if these are too repetitive.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kjXsi.ScreenReaderText), {
        role: "status",
        "aria-live": liveMode,
        "aria-relevant": "additions text",
        "aria-atomic": "true"
    }, oldMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kjXsi.ScreenReaderText), {
        role: "status",
        "aria-live": liveMode,
        "aria-relevant": "additions text",
        "aria-atomic": "true"
    }, newMessage));
});

});

parcelRegister("7m2Id", function(module, exports) {

$parcel$export(module.exports, "default", () => $0232e3e5a6ba8264$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0232e3e5a6ba8264$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    resultsAnnouncement: {
        "id": "software-context-menu.menu-renderer.context-menu-inner.context-menu-node.context-menu-search.results-announcer.results-announcement",
        "defaultMessage": "{count, plural, =0 {no results found} one {one result found} other {# results found}}"
    },
    loading: {
        "id": "software-context-menu.menu-renderer.context-menu-inner.context-menu-node.context-menu-search.results-announcer.loading",
        "defaultMessage": "Loading results"
    }
});

});



parcelRegister("jCETS", function(module, exports) {

$parcel$export(module.exports, "ContextMenuSection", () => $38ac61bf82c01bb4$export$804016f6c3dde223);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

const $38ac61bf82c01bb4$export$804016f6c3dde223 = ({ section: section, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": (0, $9a48749ac2fd63a0$export$6f322a4f1f85b809)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($38ac61bf82c01bb4$var$ContextMenuSectionLabel, null, section.label), children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $38ac61bf82c01bb4$var$ContextMenuSectionLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1thw _1yt418iy _11c81vlj _1p1dangw",
            __cmplp.className
        ])
    });
});

});
const $9a48749ac2fd63a0$export$6f322a4f1f85b809 = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-section';



parcelRegister("5tCAH", function(module, exports) {

$parcel$export(module.exports, "FocusLockedWrapper", () => $dd18011b1ca0941f$export$788065bfcceceaa3);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $6Pq2D = parcelRequire("6Pq2D");


var $lMuU5 = parcelRequire("lMuU5");

var $6DFOC = parcelRequire("6DFOC");
const $dd18011b1ca0941f$var$WrapperDiv = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ onFocus: onFocus, children: children }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dd18011b1ca0941f$var$ContextMenuInnerContainer, {
        ref: ref,
        onFocus: onFocus,
        "data-testid": (0, $e8879a4af726a467$export$f4f3847a7eaec9e9)
    }, children));
const $dd18011b1ca0941f$export$788065bfcceceaa3 = ({ children: children })=>{
    const isPersistentFocus = (0, $6DFOC.useIsPersistentFocus)();
    const [focuslockDisabled, setFocuslockDisabled] = (0, $eUqFw.useState)(!isPersistentFocus);
    const ref = (0, $eUqFw.useRef)(null);
    const onFocus = (0, $eUqFw.useCallback)((e)=>{
        if (focuslockDisabled && ref.current?.contains(e.target)) setFocuslockDisabled(false);
    }, [
        focuslockDisabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dd18011b1ca0941f$var$WrapperDiv, {
        onFocus: onFocus,
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Pq2D.default), {
        disabled: focuslockDisabled,
        persistentFocus: isPersistentFocus,
        autoFocus: false
    }, children));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dd18011b1ca0941f$var$ContextMenuInnerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $lMuU5.MenuContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1pby1nn1 _1reoewfl _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});

parcelRegister("do3uV", function(module, exports) {

$parcel$export(module.exports, "hasSubmenuItems", () => $bdc30be43faadc0a$export$a141a5e74a818335);
$parcel$export(module.exports, "isSubmenuOpen", () => $bdc30be43faadc0a$export$5870693bd83d8526);
$parcel$export(module.exports, "isSubmenuOpenForNode", () => $bdc30be43faadc0a$export$e36cf825fe8902f3);

var $eUqFw = parcelRequire("eUqFw");
const $bdc30be43faadc0a$export$a141a5e74a818335 = (menuNode)=>/*#__PURE__*/ (0, $eUqFw.isValidElement)(menuNode.element) || !!menuNode.children && menuNode.children.length > 0;
const $bdc30be43faadc0a$export$5870693bd83d8526 = (openPath)=>!!openPath;
const $bdc30be43faadc0a$export$e36cf825fe8902f3 = (menuNode, openPath)=>$bdc30be43faadc0a$export$5870693bd83d8526(openPath) && menuNode.id.startsWith(openPath);

});


parcelRegister("jNtHy", function(module, exports) {

$parcel$export(module.exports, "UnlinkMenuItem", () => $9db4efee3492a5be$export$bbb2afae2486e136);

var $eUqFw = parcelRequire("eUqFw");

var $bkufV = parcelRequire("bkufV");
var $fMoec = parcelRequire("fMoec");

var $kLWBQ = parcelRequire("kLWBQ");

var $bPVI5 = parcelRequire("bPVI5");
const $9db4efee3492a5be$export$bbb2afae2486e136 = ({ selectedCardIds: selectedCardIds, label: label, menuItemNodeArgs: menuItemNodeArgs })=>{
    const removeIssuesFromAllVersions = (0, $kLWBQ.useRemoveIssuesFromAllVersionsMutation)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bkufV.ContextMenuItem), {
        ...menuItemNodeArgs,
        menuItem: {
            type: (0, $fMoec.MenuNodeType).Item,
            id: `${(0, $bPVI5.VERSION_MENU_ID)}/menu/value__unlink`,
            label: label,
            onClick: (analyticsEvent)=>{
                removeIssuesFromAllVersions(selectedCardIds, analyticsEvent);
            }
        }
    });
};

});
parcelRegister("kLWBQ", function(module, exports) {

$parcel$export(module.exports, "useRemoveIssuesFromAllVersionsMutation", () => $50917e98d5aae584$export$a54d2e97907396b7);

var $k7ns8 = parcelRequire("k7ns8");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $gUUjF = parcelRequire("gUUjF");

var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");

var $l4c7i = parcelRequire("l4c7i");

var $dWLk9 = parcelRequire("dWLk9");

var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");

var $1gHOz = parcelRequire("1gHOz");


var $6Poxb = parcelRequire("6Poxb");
const $50917e98d5aae584$export$a54d2e97907396b7 = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const boardId = (0, $1gQ73.useBacklogSelector)((state)=>Number((0, $hkGxG.getRapidViewId)(state)));
    const boardAri = (0, $l4c7i.createBoardAri)(cloudId, boardId);
    const onIssueVersionsUpdated = (0, $1gHOz.useOnIssueVersionsUpdated)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const [commitFn] = (0, $iWLL0.useMutation)((0, $k7ns8.default));
    const removeIssuesFromAllVersionsCallback = (0, $eUqFw.useCallback)((issueIds, analyticsEvent)=>{
        commitFn({
            variables: {
                input: {
                    issueIds: (0, $l4c7i.createIssueAris)(cloudId, issueIds)
                },
                boardId: boardAri
            },
            onCompleted: ()=>{
                // Request card data refresh for redux state and detail view if its open
                onIssueVersionsUpdated(issueIds);
                (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'field updated', {
                    analyticsSource: (0, $e1409a6fc345c0d8$export$840e3848643f7781),
                    operation: 'removeIssuesFromAllVersions',
                    isContextualEditing: true
                });
            },
            onError: (error)=>{
                showFlag({
                    type: 'error',
                    title: (0, $6Poxb.default).versionUpdateErrorTitle,
                    description: (0, $6Poxb.default).versionUpdateErrorDescription
                });
                (0, $gUUjF.default).safeErrorWithoutCustomerData('jiraSoftwareContextMenu.jira.backlog.version.removeVersions', 'An error occurred when removing versions from issues in AGG', error);
                (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'field updateFailed', {
                    operation: 'removeIssuesFromAllVersions',
                    analyticsSource: (0, $e1409a6fc345c0d8$export$840e3848643f7781),
                    error: error,
                    isContextualEditing: true
                });
            }
        });
    }, [
        cloudId,
        boardAri,
        commitFn,
        onIssueVersionsUpdated,
        showFlag
    ]);
    return removeIssuesFromAllVersionsCallback;
};

});
parcelRegister("k7ns8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1645097904b44781$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9fd95210a3543ee41d4cf601829b9166>>
 * @relayHash 54f53df9c971403cebb9ceaed9ca1232
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0fa9669b974f688d91987636bbf14d3c1803a4bc062e179d0a09931e8f04d500
const $1645097904b44781$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "concreteType": "JiraVersionIssueUpdateResult",
        "kind": "LinkedField",
        "name": "issueUpdateResults",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "issueId"
            },
            {
                "kind": "ScalarField",
                "name": "updated"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useRemoveIssuesFromAllVersionsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraRemoveIssuesFromAllFixVersionsPayload",
                            "kind": "LinkedField",
                            "name": "removeIssuesFromAllFixVersions",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "versions",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "content_softwareVersionBacklogPanelRelay_jiraVersionFragment"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useRemoveIssuesFromAllVersionsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraRemoveIssuesFromAllFixVersionsPayload",
                            "kind": "LinkedField",
                            "name": "removeIssuesFromAllFixVersions",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "versions",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "versionId"
                                        },
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "description"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "status"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "startDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "releaseDate"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "boardId",
                                                    "variableName": "boardId"
                                                }
                                            ],
                                            "concreteType": "JiraVersionStatistics",
                                            "kind": "LinkedField",
                                            "name": "statistics",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "doneEstimate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "totalEstimate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "percentageCompleted"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "notEstimated"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "done"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "totalIssueCount"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "toDo"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "inProgress"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                },
                                                v6 /*: any*/ ,
                                                {
                                                    "alias": "editProjectConfig",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "EDIT_PROJECT_CONFIG"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "canPerform"
                                                        }
                                                    ],
                                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ClientExtension",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__id"
                                                }
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0fa9669b974f688d91987636bbf14d3c1803a4bc062e179d0a09931e8f04d500",
            "metadata": {},
            "name": "useRemoveIssuesFromAllVersionsMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$1645097904b44781$var$node.hash = "d60aafd65f63c4583af72cc4c256ebbf";
var $1645097904b44781$export$2e2bcd8739ae039 = $1645097904b44781$var$node;

});

parcelRegister("l4c7i", function(module, exports) {

$parcel$export(module.exports, "createBoardAri", () => $2f47909c9e037aa0$export$a9ef0ce47eb35304);
$parcel$export(module.exports, "createIssueAris", () => $2f47909c9e037aa0$export$7a8bc17d57772015);

var $huI7r = parcelRequire("huI7r");
const $2f47909c9e037aa0$export$a9ef0ce47eb35304 = (cloudId, boardId)=>(0, $huI7r.createAri)({
        resourceOwner: 'jira-software',
        cloudId: cloudId,
        resourceType: 'board',
        resourceId: String(boardId)
    });
const $2f47909c9e037aa0$export$6b0ec881a3540845 = (cloudId, issueId)=>(0, $huI7r.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId.toString()
    });
const $2f47909c9e037aa0$export$7a8bc17d57772015 = (cloudId, issueIds)=>issueIds.map((issueId)=>$2f47909c9e037aa0$export$6b0ec881a3540845(cloudId, issueId));

});

parcelRegister("6Poxb", function(module, exports) {

$parcel$export(module.exports, "default", () => $631592fbe38a1f8d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $631592fbe38a1f8d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    // non-final until text is finalised
    /* eslint-disable jira/i18n/id-named-by-package */ versionUpdateErrorTitle: {
        "id": "backlog.common.hooks.version-update-error-title-non-final",
        "defaultMessage": "Failed to update"
    },
    versionUpdateErrorDescription: {
        "id": "backlog.common.hooks.version-update-error-description-non-final",
        "defaultMessage": "Refresh the page and try again."
    }
});

});



parcelRegister("aqMF3", function(module, exports) {

$parcel$export(module.exports, "VersionMenuItem", () => $7502e67d219b0a81$export$ea9d65dd05b6ef3d);

var $b6Hss = parcelRequire("b6Hss");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $bkufV = parcelRequire("bkufV");
var $fMoec = parcelRequire("fMoec");

var $kxDhf = parcelRequire("kxDhf");

var $bPVI5 = parcelRequire("bPVI5");
const $7502e67d219b0a81$export$ea9d65dd05b6ef3d = ({ selectedCardIds: selectedCardIds, versionEdge: versionEdge, menuItemNodeArgs: menuItemNodeArgs })=>{
    const { node: { id: versionAri, versionId: versionId, name: name } } = (0, $iWLL0.useFragment)((0, $b6Hss.default), versionEdge);
    const addIssuesToVersionMutation = (0, $kxDhf.useAddIssuesToVersionMutation)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bkufV.ContextMenuItem), {
        ...menuItemNodeArgs,
        menuItem: {
            type: (0, $fMoec.MenuNodeType).Item,
            id: `${(0, $bPVI5.VERSION_MENU_ID)}/menu/value__${versionId}`,
            label: name,
            onClick: (analyticsEvent)=>{
                addIssuesToVersionMutation(selectedCardIds, versionAri, analyticsEvent);
            }
        }
    });
};

});
parcelRegister("b6Hss", function(module, exports) {

$parcel$export(module.exports, "default", () => $07196d9c68dde05b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fdc3b26ca7718aac65ae162c41620f87>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $07196d9c68dde05b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "versionMenuItem_softwareBacklog",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        "action": "THROW",
                        "path": "node.id"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "versionId"
                        },
                        "action": "THROW",
                        "path": "node.versionId"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        "action": "THROW",
                        "path": "node.name"
                    }
                ]
            },
            "action": "THROW",
            "path": "node"
        }
    ],
    "type": "JiraVersionEdge"
};
$07196d9c68dde05b$var$node.hash = "abd3a2327d76d6cec48e7802950c72b4";
var $07196d9c68dde05b$export$2e2bcd8739ae039 = $07196d9c68dde05b$var$node;

});

parcelRegister("kxDhf", function(module, exports) {

$parcel$export(module.exports, "useAddIssuesToVersionMutation", () => $c881fbe5e19ef52e$export$af7b1139de7c94fd);

var $55oH7 = parcelRequire("55oH7");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $gUUjF = parcelRequire("gUUjF");

var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");

var $l4c7i = parcelRequire("l4c7i");

var $dWLk9 = parcelRequire("dWLk9");

var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");

var $1gHOz = parcelRequire("1gHOz");


var $6Poxb = parcelRequire("6Poxb");
const $c881fbe5e19ef52e$export$af7b1139de7c94fd = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const boardId = (0, $1gQ73.useBacklogSelector)((state)=>Number((0, $hkGxG.getRapidViewId)(state)));
    const boardAri = (0, $l4c7i.createBoardAri)(cloudId, boardId);
    const onIssueVersionsUpdated = (0, $1gHOz.useOnIssueVersionsUpdated)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const [commitFn] = (0, $iWLL0.useMutation)((0, $55oH7.default));
    const addIssuesToVersionCallback = (0, $eUqFw.useCallback)((issueIds, versionAri, analyticsEvent)=>{
        commitFn({
            variables: {
                input: {
                    issueIds: (0, $l4c7i.createIssueAris)(cloudId, issueIds),
                    versionId: versionAri
                },
                boardId: boardAri
            },
            onCompleted: ()=>{
                // Request card data refresh for redux state and detail view if its open
                onIssueVersionsUpdated(issueIds);
                (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'field updated', {
                    analyticsSource: (0, $e1409a6fc345c0d8$export$840e3848643f7781),
                    operation: 'addIssuesToVersion',
                    versionAri: versionAri,
                    isContextualEditing: true
                });
            },
            onError: (error)=>{
                showFlag({
                    type: 'error',
                    title: (0, $6Poxb.default).versionUpdateErrorTitle,
                    description: (0, $6Poxb.default).versionUpdateErrorDescription
                });
                (0, $gUUjF.default).safeErrorWithoutCustomerData('jiraSoftwareContextMenu.jira.backlog.version.addVersion', 'An error occurred when adding a version to issues in AGG', error);
                (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'field updateFailed', {
                    analyticsSource: (0, $e1409a6fc345c0d8$export$840e3848643f7781),
                    operation: 'addIssuesToVersion',
                    error: error,
                    versionAri: versionAri,
                    isContextualEditing: true
                });
            }
        });
    }, [
        cloudId,
        boardAri,
        commitFn,
        onIssueVersionsUpdated,
        showFlag
    ]);
    return addIssuesToVersionCallback;
};

});
parcelRegister("55oH7", function(module, exports) {

$parcel$export(module.exports, "default", () => $431eb9f173286a3a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9a93aed7ead7b9d6ded0f39906f3c47a>>
 * @relayHash 8c63d7bc7fa45a100e638518cca6dbed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 88425252bf81ea78e2669a1c9bf81827b8511256219d0154cd93e0a742613ab0
const $431eb9f173286a3a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useAddIssuesToVersionMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraAddIssuesToFixVersionPayload",
                            "kind": "LinkedField",
                            "name": "addIssuesToFixVersion",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "versionCard_softwareVersionBacklogPanelRelay_jiraVersionFragment"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useAddIssuesToVersionMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraAddIssuesToFixVersionPayload",
                            "kind": "LinkedField",
                            "name": "addIssuesToFixVersion",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "versionId"
                                        },
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "description"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "status"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "startDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "releaseDate"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "boardId",
                                                    "variableName": "boardId"
                                                }
                                            ],
                                            "concreteType": "JiraVersionStatistics",
                                            "kind": "LinkedField",
                                            "name": "statistics",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "doneEstimate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "totalEstimate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "percentageCompleted"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "notEstimated"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "done"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "totalIssueCount"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "toDo"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "inProgress"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "alias": "editProjectConfig",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "EDIT_PROJECT_CONFIG"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "canPerform"
                                                        }
                                                    ],
                                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ClientExtension",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__id"
                                                }
                                            ]
                                        },
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "88425252bf81ea78e2669a1c9bf81827b8511256219d0154cd93e0a742613ab0",
            "metadata": {},
            "name": "useAddIssuesToVersionMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$431eb9f173286a3a$var$node.hash = "78cd3b934e90c86f1f62037be8c3d343";
var $431eb9f173286a3a$export$2e2bcd8739ae039 = $431eb9f173286a3a$var$node;

});





parcelRegister("guUXv", function(module, exports) {

$parcel$export(module.exports, "useViewInIssueSearch", () => $e7dd537cc8a818f1$export$95e4f0766878a325);

var $5JgJ2 = parcelRequire("5JgJ2");

var $kJlBc = parcelRequire("kJlBc");

var $fMoec = parcelRequire("fMoec");

var $1gQ73 = parcelRequire("1gQ73");

var $bP7Jx = parcelRequire("bP7Jx");

var $bPVI5 = parcelRequire("bPVI5");

var $6n5K0 = parcelRequire("6n5K0");
const $e7dd537cc8a818f1$export$b95edc2172de41fe = ({ selectedCardIds: selectedCardIds, cardEntities: cardEntities })=>{
    const { push: push } = (0, $kJlBc.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleClick = ()=>{
        const issueKeys = selectedCardIds.map((id)=>cardEntities[String(id)].key);
        const query = encodeURIComponent(`issuekey IN (${issueKeys.join(',')})`);
        push(`/issues/?jql=${query}`);
    };
    if (selectedCardIds.length < 2) return [];
    return [
        {
            type: (0, $fMoec.MenuNodeType).Item,
            label: formatMessage((0, $6n5K0.default).viewInIssueSearch),
            id: (0, $bPVI5.VIEW_IN_ISSUE_SEARCH_MENU_ID),
            onClick: handleClick
        }
    ];
};
const $e7dd537cc8a818f1$export$95e4f0766878a325 = ({ selectedCardIds: selectedCardIds })=>{
    const cardEntities = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getCards));
    return $e7dd537cc8a818f1$export$b95edc2172de41fe({
        selectedCardIds: selectedCardIds,
        cardEntities: cardEntities
    });
};

});

parcelRegister("lHIMf", function(module, exports) {

$parcel$export(module.exports, "default", () => $98a75883b3f8a672$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3l6tm = parcelRequire("3l6tm");

var $1gQ73 = parcelRequire("1gQ73");

var $bP7Jx = parcelRequire("bP7Jx");
const $98a75883b3f8a672$var$useCardsIncludeSubtasksWithoutParents = (cardIds)=>{
    const selectedCards = (0, $1gQ73.useBacklogSelector)((state)=>{
        const allCards = (0, $bP7Jx.getCards)(state);
        return cardIds.map((cardId)=>allCards[cardId]).filter(Boolean);
    });
    const selectedSubtasks = (0, $eUqFw.useMemo)(()=>selectedCards.filter(({ typeHierarchyLevel: typeHierarchyLevel })=>(0, $3l6tm.isSubtaskHierarchyLevel)(typeHierarchyLevel)), [
        selectedCards
    ]);
    return (0, $eUqFw.useMemo)(()=>selectedSubtasks.some(({ parentId: parentId })=>parentId && !cardIds.includes(parentId)), [
        cardIds,
        selectedSubtasks
    ]);
};
var $98a75883b3f8a672$export$2e2bcd8739ae039 = $98a75883b3f8a672$var$useCardsIncludeSubtasksWithoutParents;

});


parcelRegister("8MkuF", function(module, exports) {

$parcel$export(module.exports, "default", () => $a13c83bba8932ca9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $7rh0R = parcelRequire("7rh0R");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");

var $gvLKK = parcelRequire("gvLKK");

var $kmr29 = parcelRequire("kmr29");



var $eKS1U = parcelRequire("eKS1U");

var $j258X = parcelRequire("j258X");

var $diedG = parcelRequire("diedG");

var $k83hI = parcelRequire("k83hI");

const $a13c83bba8932ca9$export$3ddafe6eb894bff8 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("1RNGm")), {
    moduleId: "./src/packages/issue/fields/assignee/src/ui/popover/index.tsx"
});
const $a13c83bba8932ca9$var$AssigneeField = ({ isUserAtLeastMember: isUserAtLeastMember, shouldRenderRichCard: shouldRenderRichCard, issueKey: issueKey })=>{
    const isCompanyManaged = (0, $j258X.useIsCMPBacklog)();
    const [assigneeFieldValue] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $ebc098a76317be78$export$e18419056f3d184a)
    });
    const value = assigneeFieldValue ? {
        id: assigneeFieldValue.accountId,
        displayName: assigneeFieldValue.displayName,
        avatarUrl: assigneeFieldValue.avatarUrls?.['48x48']
    } : null;
    const issueAssigneeFieldStatic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k83hI.default), {
        value: value
    });
    const handleChange = (0, $eUqFw.useCallback)(()=>{
        (0, $eKS1U.setInlineEditAssigneeInteractionStartMark)();
    }, []);
    const handleUpdate = (0, $eUqFw.useCallback)(()=>{
        (0, $eKS1U.setInlineEditAssigneeInteractionStopMark)(isCompanyManaged);
    }, [
        isCompanyManaged
    ]);
    const handleFailure = (0, $eUqFw.useCallback)(()=>{
        (0, $eKS1U.cancelInlineEditAssigneeInteractionMark)();
    }, []);
    if (isUserAtLeastMember && shouldRenderRichCard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gvLKK.IssueAssigneeFieldBoundary), {
        packageName: (0, $e1409a6fc345c0d8$export$dfd208682d29484c),
        fallback: issueAssigneeFieldStatic
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $diedG.default), {
        experienceTarget: "inline assignee",
        experienceTargetId: issueKey,
        additionalAttributes: {
            issueKey: issueKey
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a13c83bba8932ca9$var$AssigneeFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a13c83bba8932ca9$export$3ddafe6eb894bff8, {
        issueKey: issueKey,
        shouldPreloadAssignToMe: true,
        onChange: handleChange,
        onUpdate: handleUpdate,
        onFailure: handleFailure
    }))));
    return issueAssigneeFieldStatic;
};
var $a13c83bba8932ca9$export$2e2bcd8739ae039 // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
 = /*#__PURE__*/ (0, $eUqFw.memo)($a13c83bba8932ca9$var$AssigneeField);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a13c83bba8932ca9$var$AssigneeFieldWrapperControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "dvn8x3-0"
})`position:relative;display:flex;align-items:center;& > button + div{position:absolute !important;top:${"var(--ds-space-400, 32px)"} !important;left:auto !important;right:${"var(--ds-space-negative-025, -2px)"} !important;transform:none !important;svg:first-of-type{cursor:pointer;& > path{transform:scale(1.10638,1) translate(-1px,0);}}}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a13c83bba8932ca9$var$AssigneeFieldWrapperExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1e0c1txw _4cvr1h6o _vsj07079 _qedf1kev _c6p11h90 _15m21prr _96l5agmp _1hgltlke _1j3t6smz",
            __cmplp.className
        ])
    });
});
const $a13c83bba8932ca9$var$AssigneeFieldWrapper = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $a13c83bba8932ca9$var$AssigneeFieldWrapperExperiment, $a13c83bba8932ca9$var$AssigneeFieldWrapperControl);

});
parcelRegister("gvLKK", function(module, exports) {

$parcel$export(module.exports, "AsyncLazyIssueAssigneeField", () => $6809c90a8bc0ef31$export$3eed76542de607d2);
$parcel$export(module.exports, "AsyncIssueAssigneeField", () => $6809c90a8bc0ef31$export$5cdab73b9e0803a1);
$parcel$export(module.exports, "IssueAssigneeFieldBoundary", () => $6809c90a8bc0ef31$export$9b541007f4ef3ffe);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

var $2F5m4 = parcelRequire("2F5m4");

const $6809c90a8bc0ef31$export$3eed76542de607d2 = (0, $7rh0R.lazy)(()=>(parcelRequire("1RNGm")), {
    moduleId: "./src/packages/issue/fields/assignee/src/ui/popover/index.tsx"
});
const $6809c90a8bc0ef31$export$5cdab73b9e0803a1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue-field-assignee",
        packageName: "jira-issue-field-assignee",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2F5m4.AssigneePickerView), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-assignee-field",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2F5m4.AssigneePickerView), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6809c90a8bc0ef31$export$3eed76542de607d2, props)));
const $6809c90a8bc0ef31$export$9b541007f4ef3ffe = ({ children: children, fallback: fallback, packageName: packageName, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "issue-assignee-field",
        packageName: packageName,
        fallback: fallback ? ()=>fallback : undefined,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-assignee-field-boundary",
        fallback: fallback
    }, children));

});
parcelRegister("1RNGm", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('7sq4c');
        const value = parcelRequire('44OBN');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("7sq4c").then(()=>parcelRequire('44OBN'));
}

});


parcelRegister("eKS1U", function(module, exports) {

$parcel$export(module.exports, "setInlineEditStatusInteractionStartMark", () => $176d3c113efc591b$export$1c8cae5dc9b7d34a);
$parcel$export(module.exports, "setInlineEditStatusInteractionStopMark", () => $176d3c113efc591b$export$b1acd52e03abb3b2);
$parcel$export(module.exports, "cancelInlineEditStatusInteractionMark", () => $176d3c113efc591b$export$cdaa2d2685d8101e);
$parcel$export(module.exports, "setInlineEditAssigneeInteractionStartMark", () => $176d3c113efc591b$export$931331f1846e934f);
$parcel$export(module.exports, "setInlineEditAssigneeInteractionStopMark", () => $176d3c113efc591b$export$40692731bc6535c7);
$parcel$export(module.exports, "cancelInlineEditAssigneeInteractionMark", () => $176d3c113efc591b$export$afc1cc386d2100be);
$parcel$export(module.exports, "setInlineEditStoryPointInteractionStartMark", () => $176d3c113efc591b$export$463102067393e83b);
$parcel$export(module.exports, "setInlineEditStoryPointInteractionStopMark", () => $176d3c113efc591b$export$bb93666f630b9a57);
$parcel$export(module.exports, "cancelInlineEditStoryPointInteractionMark", () => $176d3c113efc591b$export$d0a680c7e3623e7b);
$parcel$export(module.exports, "setInlineEditOriginalEstimateInteractionStartMark", () => $176d3c113efc591b$export$781c8c2cc1ad3945);
$parcel$export(module.exports, "setInlineEditOriginalEstimateInteractionStopMark", () => $176d3c113efc591b$export$65678122e1338f09);
$parcel$export(module.exports, "cancelInlineEditOriginalEstimateInteractionMark", () => $176d3c113efc591b$export$b728cf17d787205d);

var $gPQCf = parcelRequire("gPQCf");
const $176d3c113efc591b$export$1c8cae5dc9b7d34a = ()=>{
    (0, $gPQCf.inlineEditStatusInteraction).start();
};
const $176d3c113efc591b$export$b1acd52e03abb3b2 = (isCompanyManaged)=>{
    (0, $gPQCf.inlineEditStatusInteraction).stop({
        customData: {
            isCompanyManaged: isCompanyManaged
        }
    });
};
const $176d3c113efc591b$export$cdaa2d2685d8101e = ()=>{
    (0, $gPQCf.inlineEditStatusInteraction).cancel();
};
const $176d3c113efc591b$export$931331f1846e934f = ()=>{
    (0, $gPQCf.inlineEditAssigneeInteraction).start();
};
const $176d3c113efc591b$export$40692731bc6535c7 = (isCompanyManaged)=>{
    (0, $gPQCf.inlineEditAssigneeInteraction).stop({
        customData: {
            isCompanyManaged: isCompanyManaged
        }
    });
};
const $176d3c113efc591b$export$afc1cc386d2100be = ()=>{
    (0, $gPQCf.inlineEditAssigneeInteraction).cancel();
};
const $176d3c113efc591b$export$463102067393e83b = ()=>{
    (0, $gPQCf.inlineEditStoryPointInteraction).start();
};
const $176d3c113efc591b$export$bb93666f630b9a57 = (isCompanyManaged)=>{
    (0, $gPQCf.inlineEditStoryPointInteraction).stop({
        customData: {
            isCompanyManaged: isCompanyManaged
        }
    });
};
const $176d3c113efc591b$export$d0a680c7e3623e7b = ()=>{
    (0, $gPQCf.inlineEditStoryPointInteraction).cancel();
};
const $176d3c113efc591b$export$781c8c2cc1ad3945 = ()=>{
    (0, $gPQCf.inlineEditOriginalEstimateInteraction).start();
};
const $176d3c113efc591b$export$65678122e1338f09 = (isCompanyManaged)=>{
    (0, $gPQCf.inlineEditOriginalEstimateInteraction).stop({
        customData: {
            isCompanyManaged: isCompanyManaged
        }
    });
};
const $176d3c113efc591b$export$b728cf17d787205d = ()=>{
    (0, $gPQCf.inlineEditOriginalEstimateInteraction).cancel();
};

});


parcelRegister("4QJAt", function(module, exports) {

$parcel$export(module.exports, "default", () => $6df08047abcf04e2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $bT7k5 = parcelRequire("bT7k5");

var $4E9Xv = parcelRequire("4E9Xv");

var $4cIIr = parcelRequire("4cIIr");

var $1gQ73 = parcelRequire("1gQ73");

var $8YxIx = parcelRequire("8YxIx");

var $iXotx = parcelRequire("iXotx");
const $6df08047abcf04e2$var$CheckboxField = ({ isSelected: isSelected, onClick: onClick, isDisabled: isDisabled, shouldShowCheckbox: shouldShowCheckbox })=>{
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const sessionAttributes = (0, $4E9Xv.useBulkOpsSessionContext)()?.getFlowAttributes();
    const fireCheckboxAnalytics = (0, $4cIIr.useFireCheckboxAnalytics)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleKeyDown = (e)=>{
        const withCmd = true; /* always considered true for checkbox as it is used for multiple selection */ 
        const withShift = e.shiftKey;
        if (e.key === 'Space') {
            if (isSelected && !shouldShowCheckbox) {
                dispatch((0, $8YxIx.setCheckboxSelectionMode)(true));
                return;
            }
            onClick(withCmd, withShift, 'keyboard', true);
        }
    };
    const handleClickCheckbox = (e)=>{
        const withCmd = true; /* always considered true for checkbox as it is used for multiple selection */ 
        const withShift = e.shiftKey;
        if (isSelected && !shouldShowCheckbox) {
            dispatch((0, $8YxIx.setCheckboxSelectionMode)(true));
            fireCheckboxAnalytics(createAnalyticsEvent({
                action: 'changed',
                actionSubject: 'checkbox'
            }), 'backlogCard', {
                isIssueDetailVisible: true,
                numSelectedCards: 1,
                inputSource: (0, $iXotx.getCardSelectionAnalyticsInputSource)(withShift, withCmd, true),
                isCheckboxChecked: isSelected,
                bulkOpsSessionID: sessionAttributes?.bulkOpsSessionID
            });
            return;
        }
        onClick(withCmd, withShift, 'mouse', true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        isChecked: isSelected && shouldShowCheckbox,
        onKeyDown: handleKeyDown,
        onClick: handleClickCheckbox,
        isDisabled: isDisabled
    });
};
var $6df08047abcf04e2$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($6df08047abcf04e2$var$CheckboxField);

});
parcelRegister("bT7k5", function(module, exports) {

$parcel$export(module.exports, "default", () => $562b222d8d94ede5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $1lQG9 = parcelRequire("1lQG9");

var $PdmhA = parcelRequire("PdmhA");

var $eYWZs = parcelRequire("eYWZs");
var $kzlpH = parcelRequire("kzlpH");
var $kbQR9 = parcelRequire("kbQR9");
var $1BPvG = parcelRequire("1BPvG");
/* eslint-disable @atlaskit/design-system/no-nested-styles */ const $562b222d8d94ede5$var$checkboxStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: '100%',
    height: '100%',
    margin: "var(--ds-space-0, 0px)",
    appearance: 'none',
    border: 'none',
    gridArea: '1 / 1 / 2 / 2',
    opacity: 0,
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& + svg': {
        /**
     *  Change the variables --checkbox-background-color, --checkbox-border-color
     *  and --checkbox-tick-color according to user interactions.
     *  All other variables are constant.
     *  All styles from the input target the sibling svg.
     */ '--checkbox-background-color': 'var(--local-background)',
        '--checkbox-border-color': 'var(--local-border)',
        '--checkbox-tick-color': 'var(--local-tick-rest)',
        color: 'var(--checkbox-background-color)',
        fill: 'var(--checkbox-tick-color)',
        gridArea: '1 / 1 / 2 / 2',
        pointerEvents: 'none',
        transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'rect:first-of-type': {
            stroke: 'var(--checkbox-border-color)',
            strokeWidth: "var(--ds-border-width, 1px)",
            transition: 'stroke 0.2s ease-in-out'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&:focus + svg, &&:checked:focus + svg': {
        borderRadius: "var(--ds-border-radius, 0.25rem)",
        outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $PdmhA.B200)})`}`,
        outlineOffset: "var(--ds-space-negative-025, -2px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-hover)',
        '--checkbox-border-color': 'var(--local-border-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-checked-hover)',
        '--checkbox-border-color': 'var(--local-border-checked-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-checked-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)',
        '--checkbox-tick-color': 'var(--local-tick-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        cursor: 'not-allowed',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled:checked + svg': {
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked + svg, &:checked:hover + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:focus + svg rect:first-of-type': {
            stroke: 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'GrayText',
            '--checkbox-tick-color': 'GrayText'
        }
    }
});
/* eslint-enable @atlaskit/design-system/no-nested-styles */ /**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ const $562b222d8d94ede5$var$Checkbox = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Checkbox(props, ref) {
    const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, size: size = 'medium', onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
    const [isCheckedState, setIsCheckedState] = (0, $eUqFw.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $eUqFw.useRef)(null);
    const mergedRefs = (0, $1lQG9.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $kzlpH.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // Currently the rule hasn't been updated to enable "allowed" dynamic pass-throughs.
        // When there is more usage of this pattern we'll update the lint rule.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: xcss
    }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        css: $562b222d8d94ede5$var$checkboxStyles,
        onChange: onChangeAnalytics,
        "aria-checked": isIndeterminate ? 'mixed' : isChecked,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $eYWZs.default), {
        size: size,
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $kbQR9.default), null, label, isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $1BPvG.default), null)));
}));
$562b222d8d94ede5$var$Checkbox.displayName = 'Checkbox';
var $562b222d8d94ede5$export$2e2bcd8739ae039 = $562b222d8d94ede5$var$Checkbox;

});
parcelRegister("eYWZs", function(module, exports) {

$parcel$export(module.exports, "default", () => $3da93fd40e0e88a3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ce8OV = parcelRequire("ce8OV");
function $3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "inherit",
        x: "8",
        y: "11",
        width: "8",
        height: "2",
        rx: "1"
    });
    if (isChecked) return /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $3da93fd40e0e88a3$var$CheckboxIcon = /*#__PURE__*/ (0, $eUqFw.memo)(({ size: size, isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $eUqFw.useMemo)(()=>$3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $ce8OV.default), {
        label: "",
        size: size,
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $3da93fd40e0e88a3$export$2e2bcd8739ae039 = $3da93fd40e0e88a3$var$CheckboxIcon;

});

parcelRegister("kzlpH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4f9422953e9457b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $f4f9422953e9457b$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'grid',
    gridAutoColumns: '1fr',
    gridAutoRows: 'min-content',
    color: `var(--ds-text, ${(0, $PdmhA.N900)})`,
    cursor: 'default',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $f4f9422953e9457b$var$textLabelLayoutStyles = /*#__PURE__*/ (0, $byn9U.css)({
    gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
    gridTemplateColumns: 'min-content auto'
});
const $f4f9422953e9457b$var$disabledStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-disabled, ${(0, $PdmhA.N80)})`,
    cursor: 'not-allowed'
});
const $f4f9422953e9457b$var$labelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    /**
   * Background
   */ '--local-background': `var(--ds-background-input, ${(0, $PdmhA.N10)})`,
    '--local-background-active': `var(--ds-background-input-pressed, ${(0, $PdmhA.B50)})`,
    '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $PdmhA.B400)})`,
    '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $PdmhA.B300)})`,
    '--local-background-disabled': `var(--ds-background-disabled, ${(0, $PdmhA.N20)})`,
    '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`,
    /**
   * Border
   */ '--local-border': `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    '--local-border-active': `var(--ds-border, ${(0, $PdmhA.B50)})`,
    '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $PdmhA.B400)})`,
    '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $PdmhA.B300)})`,
    '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $PdmhA.R300)})`,
    '--local-border-disabled': `var(--ds-background-disabled, ${(0, $PdmhA.N20)})`,
    '--local-border-focus': `var(--ds-border-focused, ${(0, $PdmhA.B200)})`,
    '--local-border-hover': `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    '--local-border-invalid': `var(--ds-border-danger, ${(0, $PdmhA.R300)})`,
    /**
   * Tick
   */ '--local-tick-active': `var(--ds-icon-inverse, ${(0, $PdmhA.B400)})`,
    '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $PdmhA.N10)})`,
    '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $PdmhA.N70)})`,
    '--local-tick-rest': 'transparent'
});
function $f4f9422953e9457b$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        // Because we're using Emotion local jsx namespace we have to coerce xcss prop to a string.
        // When we're fully on Compiled its local jsx namespace accepts the output of xcss prop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: xcss,
        css: [
            $f4f9422953e9457b$var$baseStyles,
            label && $f4f9422953e9457b$var$textLabelLayoutStyles,
            isDisabled && $f4f9422953e9457b$var$disabledStyles,
            $f4f9422953e9457b$var$labelStyles
        ],
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("kbQR9", function(module, exports) {

$parcel$export(module.exports, "default", () => $582b6523b23912df$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $582b6523b23912df$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $582b6523b23912df$var$labelTextStyles = {
    name: "12hofyr",
    styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
};
function $582b6523b23912df$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $582b6523b23912df$var$labelTextStyles
    }, children);
}

});

parcelRegister("1BPvG", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ac167f9dd7ee34$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $87ac167f9dd7ee34$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $PdmhA.R500)})`,
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $87ac167f9dd7ee34$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $87ac167f9dd7ee34$var$requiredIndicatorStyles,
        "aria-hidden": true
    }, "*");
}

});



parcelRegister("e0tSD", function(module, exports) {

$parcel$export(module.exports, "ChildIssuesMetadata", () => $3e8e5d981758b5b5$export$56b7a8e50535249e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jfQfF = parcelRequire("jfQfF");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $Mtmai = parcelRequire("Mtmai");
const $3e8e5d981758b5b5$export$56b7a8e50535249e = ({ numTotalChildren: numTotalChildren, numCompleteChildren: numCompleteChildren, onClickThrough: onClickThrough })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (!numTotalChildren) return null;
    const message = formatMessage((0, $Mtmai.default).childIssuesMetadataTooltip, {
        complete: numCompleteChildren,
        total: numTotalChildren
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e8e5d981758b5b5$var$ChildIssuesMetadataWrapper, {
        tabIndex: -1,
        onClick: onClickThrough,
        "data-testid": "software-backlog.card-list.card.card-contents.child-issues-metadata"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: message,
        testId: "software-backlog.card-list.card.card-contents.child-issues-metadata.tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jfQfF))), {
        testId: "software-backlog.card-list.card.card-contents.child-issues-metadata.child-issues-icon",
        primaryColor: `var(--ds-icon-subtle, ${(0, $PdmhA).N300})`,
        size: "small",
        label: ""
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3e8e5d981758b5b5$var$ChildIssuesMetadataWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _1pbykb7n _yyhy54tg _1ii7wtyw _3rss1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jfQfF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e047f322faad4563$var$_react = $e047f322faad4563$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $e047f322faad4563$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e047f322faad4563$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $e047f322faad4563$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M11 7h2v5h-2zm5 6h2v3h-2zM6 13h2v3H6z"/><path d="M7 11h10a1 1 0 011 1v1H6v-1a1 1 0 011-1z"/><path d="M5 18v1h4v-1H5zm0-2h4a2 2 0 012 2v1a2 2 0 01-2 2H5a2 2 0 01-2-2v-1a2 2 0 012-2zm10 2v1h4v-1h-4zm0-2h4a2 2 0 012 2v1a2 2 0 01-2 2h-4a2 2 0 01-2-2v-1a2 2 0 012-2zM10 5v1h4V5h-4zm0-2h4a2 2 0 012 2v1a2 2 0 01-2 2h-4a2 2 0 01-2-2V5a2 2 0 012-2z" fill-rule="nonzero"/></g></svg>`
    }, props));
$e047f322faad4563$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var $e047f322faad4563$var$_default = $e047f322faad4563$var$ChildIssuesIcon;
module.exports.default = $e047f322faad4563$var$_default;

});

parcelRegister("Mtmai", function(module, exports) {

$parcel$export(module.exports, "default", () => $829b306e6b4dad34$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $829b306e6b4dad34$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    childIssuesMetadataTooltip: {
        "id": "backlog.card-list.card.card-contents.child-issues-metadata.child-issues-metadata-tooltip",
        "defaultMessage": "{complete} of {total, plural, one {# child issue} other {# child issues}} complete"
    }
});

});


parcelRegister("6dmWW", function(module, exports) {

$parcel$export(module.exports, "Flag", () => $89350830b61a1458$export$48ea269755562084);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $8urXR = parcelRequire("8urXR");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dU01J = parcelRequire("dU01J");

var $30WDI = parcelRequire("30WDI");
const $89350830b61a1458$export$48ea269755562084 = ({ isFlagged: isFlagged, shouldRenderInlineAddFlag: shouldRenderInlineAddFlag, onAddFlag: onAddFlag })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($89350830b61a1458$var$FlagContainer, {
        "data-testid": (0, $30WDI.FLAG_CONTAINER_TEST_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: isFlagged ? formatMessage((0, $dU01J.default).flaggedTooltip) : formatMessage((0, $dU01J.default).addFlagTooltip)
    }, isFlagged && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8urXR))), {
        size: "small",
        primaryColor: `var(--ds-icon-danger, ${(0, $PdmhA).R300})`,
        label: "Flagged icon",
        testId: (0, $30WDI.FLAGGED_BUTTON_TEST_ID)
    }), !isFlagged && shouldRenderInlineAddFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($89350830b61a1458$var$AddFlagButton, {
        "aria-label": "Add Flag",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8urXR))), {
            size: "small",
            primaryColor: `var(--ds-text-subtlest, ${(0, $PdmhA).N200})`,
            label: "Add flag icon"
        }),
        spacing: "compact",
        testId: (0, $30WDI.ADD_FLAG_BUTTON_TEST_ID),
        onClick: onAddFlag
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $89350830b61a1458$var$FlagContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1pbykb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $89350830b61a1458$var$AddFlagButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_tzy4idpf _v564ch4h _19pkmyb0 _2hwxmyb0 _otyrmyb0 _18u0myb0 _16l4kb7n _19lcglyw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("36Wg2", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b8874733535e12f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $jG2Eu = parcelRequire("jG2Eu");

var $PdmhA = parcelRequire("PdmhA");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bFzGY = parcelRequire("bFzGY");

var $dU01J = parcelRequire("dU01J");

var $5WFzC = parcelRequire("5WFzC");
const $3b8874733535e12f$var$InteractionLayer = ({ cardKey: cardKey, summary: summary, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onBlur: onBlur = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), isFocused: isFocused = false })=>{
    const ref = (0, $eUqFw.useRef)(null);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $eUqFw.useEffect)(()=>{
        if (isFocused === true && ref.current !== null && document.activeElement !== ref.current) ref.current.focus();
    }, [
        isFocused
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleClick = (0, $eUqFw.useCallback)((e)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'issue'
        });
        onClick(e, analyticsEvent);
    }, [
        onClick,
        createAnalyticsEvent
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((e)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'issue'
        });
        onKeyDown(e, analyticsEvent);
    }, [
        onKeyDown,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3b8874733535e12f$export$42a852a2b6b56249, {
        onClick: handleClick,
        onKeyDown: handleKeyDown,
        tabIndex: 0,
        role: "button",
        "aria-label": `${cardKey} ${summary}. ${formatMessage((0, $dU01J.default).cardFocusScreenreaderText)}`,
        "data-testid": "software-backlog.card-list.card.card-contents.interaction-layer.accessible-card",
        onFocus: onFocus,
        onBlur: onBlur,
        innerRef: ref
    });
};
var $3b8874733535e12f$export$2e2bcd8739ae039 = $3b8874733535e12f$var$InteractionLayer;
const $3b8874733535e12f$var$cardFocusStylesOld = `
    content: '';
    display: block;
    position: absolute;
    z-index: 1;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    box-shadow: 0 0 0 2px ${`var(--ds-border-focused, ${(0, $PdmhA).B200})`};
    pointer-events: none;
`; // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3b8874733535e12f$var$ContainerControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-2rzmae-0"
})`position:absolute;top:0;bottom:0;left:0;right:0;&:focus{outline:none;& ~ ${(0, $5WFzC.MenuPlaceholderControl)}{visibility:visible;}&::after{${$3b8874733535e12f$var$cardFocusStylesOld}}}@supports (-ms-ime-align:auto){&:focus::after{${$3b8874733535e12f$var$cardFocusStylesOld} box-shadow:inset 0 0 0 2px ${`var(--ds-border-focused, ${(0, $PdmhA).B200})`};}}@media screen and (-ms-high-contrast:active),(-ms-high-contrast:none){&:focus::after{${$3b8874733535e12f$var$cardFocusStylesOld} box-shadow:inset 0 0 0 2px ${`var(--ds-border-focused, ${(0, $PdmhA).B200})`};}}`;
const $3b8874733535e12f$var$cardFocusStyles = {
    content: '',
    display: 'block',
    position: 'absolute',
    zIndex: 1,
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    boxShadow: `0 0 0 2px ${`var(--ds-border-focused, ${(0, $PdmhA).B200})`}`,
    pointerEvents: 'none'
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3b8874733535e12f$var$ContainerExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _94n5idpf _1ltvidpf _1xi2idpf _nt751r31 _49pcglyw _1hvw1o36 _1lztewfl _h10pb3bt _j7gt1ule _1tfxstnw _1v98kb7n _1a07idpf _ti30idpf _44x7idpf _gabdidpf _1n511vt6 _6q10glyw _zjd3b3bt _1vfc1ule _hkspstnw _1hl4kb7n _ehfnidpf _1btaidpf _1vdbidpf _o6k0idpf _1m551vt6 _1191glyw _1m552jkb _bwdwb3bt _6ycq1ule _1h9dstnw _i6g0kb7n _9jtdidpf _1snmidpf _1jstidpf _pnw9idpf _xp6a1vt6 _15y0glyw _xp6a2jkb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3b8874733535e12f$export$42a852a2b6b56249 = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $3b8874733535e12f$var$ContainerExperiment, $3b8874733535e12f$var$ContainerControl);

});

parcelRegister("l0b86", function(module, exports) {

$parcel$export(module.exports, "Key", () => $2b9e934632065f61$export$cd0f44441c3b7719);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kjXsi = parcelRequire("kjXsi");

var $5WFzC = parcelRequire("5WFzC");

var $30WDI = parcelRequire("30WDI");

var $7aI1H = parcelRequire("7aI1H");
const $2b9e934632065f61$var$stopPropagation = (event)=>event.stopPropagation();
const $2b9e934632065f61$export$cd0f44441c3b7719 = ({ isDone: isDone, cardKey: cardKey, issueUrl: issueUrl, summary: summary, highlightText: highlightText, onClick: cardOnClick })=>{
    const onKeyClick = (0, $eUqFw.useCallback)((e)=>{
        const withCmd = e.ctrlKey || e.metaKey;
        if (!withCmd) {
            e.preventDefault();
            cardOnClick(false, false, 'mouse');
        }
    }, [
        cardOnClick
    ]);
    // When the ScreenReaderKey is focused, it becomes visible and its sibling
    // Key is hidden. This allows the key to behave as a regular link for keyboard
    // users without compromising dnd functionality for mouse users.
    // Previously, the issue page could not be accessed directly via keyboard.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2b9e934632065f61$var$KeyContainer, {
        "data-testid": (0, $30WDI.KEY_CONTAINER_TEST_ID),
        onContextMenu: $2b9e934632065f61$var$stopPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.ScreenReaderKey), {
        href: issueUrl,
        isDone: isDone,
        "data-testid": (0, $30WDI.SCREEN_READER_KEY_TEST_ID)
    }, cardKey, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kjXsi.ScreenReaderText), null, summary)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7aI1H.default), {
        highlightText: highlightText,
        issueUrl: issueUrl,
        isDone: isDone,
        issueKey: cardKey,
        onClick: onKeyClick
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2b9e934632065f61$var$KeyContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1pbykb7n _u5f3cxkx _yyhy1l0g _1ii7wtyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7aI1H", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae4355d42b55bca5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $7PAQj = parcelRequire("7PAQj");

var $5WFzC = parcelRequire("5WFzC");

var $30WDI = parcelRequire("30WDI");
const $ae4355d42b55bca5$var$KeyWithAnalytics = ({ issueUrl: issueUrl, issueKey: issueKey, isDone: isDone, onClick: onClick, highlightText: highlightText })=>{
    const highlight = (0, $eUqFw.useMemo)(()=>highlightText != null ? [
            highlightText
        ] : [], [
        highlightText
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleClick = (0, $eUqFw.useCallback)((e)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'issue'
        });
        onClick(e, analyticsEvent);
    }, [
        onClick,
        createAnalyticsEvent
    ]);
    const handleOnContextMenu = (0, $eUqFw.useCallback)((e)=>{
        e.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.Key), {
        href: issueUrl,
        tabIndex: -1,
        isDone: isDone,
        onClick: handleClick,
        "aria-hidden": "true",
        onContextMenu: handleOnContextMenu,
        "data-component-selector": (0, $30WDI.KEY_COMPONENT_SELECTOR),
        "data-testid": (0, $30WDI.KEY_COMPONENT_SELECTOR)
    }, highlightText != null && highlightText !== '' && issueKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7PAQj.default), {
        text: issueKey,
        highlight: highlight
    }) : issueKey);
};
var $ae4355d42b55bca5$export$2e2bcd8739ae039 = $ae4355d42b55bca5$var$KeyWithAnalytics;

});
parcelRegister("7PAQj", function(module, exports) {

$parcel$export(module.exports, "default", () => $dea2f8628dbce2aa$export$2e2bcd8739ae039);

var $gttjd = parcelRequire("gttjd");

var $e63D2 = parcelRequire("e63D2");
var $dea2f8628dbce2aa$export$2e2bcd8739ae039 = (0, $e63D2.default);

});
parcelRegister("gttjd", function(module, exports) {

$parcel$export(module.exports, "removeAccents", () => $38a0e824f156ae86$export$f3f2882e8b11d731);
$parcel$export(module.exports, "getParts", () => $38a0e824f156ae86$export$a3aee8a24a54661f);

var $e1vfz = parcelRequire("e1vfz");

var $hTLlD = parcelRequire("hTLlD");

var $lyOYo = parcelRequire("lyOYo");

var $5iWql = parcelRequire("5iWql");
const $38a0e824f156ae86$export$f3f2882e8b11d731 = (0, $5iWql.default)((text)=>text.normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
const $38a0e824f156ae86$export$1633667427d99697 = (0, $5iWql.default)((highlight)=>{
    const escapedFilter = highlight.map((phrase)=>(0, (/*@__PURE__*/$parcel$interopDefault($e1vfz)))(phrase)).join('|');
    return new RegExp(escapedFilter, 'gmi');
}, (newArgs, lastArgs)=>{
    if (newArgs.length !== lastArgs.length) return false;
    const equalityFn = (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)));
    return newArgs.every((newArg, index)=>equalityFn(newArg, lastArgs[index]));
});
const $38a0e824f156ae86$export$2235873b95f89ea = (content)=>({
        type: 'text',
        content: content
    });
const $38a0e824f156ae86$export$39ae7d355c29b45f = (content)=>({
        type: 'highlight',
        content: content
    });
const $38a0e824f156ae86$export$c05c39859172f90c = (str, regExp)=>{
    const ms = [];
    let m = regExp.exec(str);
    while(m){
        ms.push(m);
        m = regExp.exec(str);
    }
    return ms;
};
const $38a0e824f156ae86$export$a3aee8a24a54661f = (highlight, text)=>{
    if (highlight == null || highlight.filter((phrase)=>phrase !== '').length === 0) return [
        $38a0e824f156ae86$export$2235873b95f89ea(text)
    ];
    const parts = [];
    // Long text lengths will cause "Invalid regular expression" error
    const truncatedHighlight = highlight.map((phrase)=>phrase.substring(0, 255));
    const highlightRegExp = $38a0e824f156ae86$export$1633667427d99697(truncatedHighlight.filter((phrase)=>phrase !== ''));
    const textWithoutAccents = $38a0e824f156ae86$export$f3f2882e8b11d731(text);
    const textMatches = $38a0e824f156ae86$export$c05c39859172f90c(text, highlightRegExp);
    const textWithoutAccentsMatches = $38a0e824f156ae86$export$c05c39859172f90c(textWithoutAccents, highlightRegExp);
    const highlightMatches = (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
        ...textWithoutAccentsMatches,
        ...textMatches
    ], 'index');
    let currentPosition = 0;
    highlightMatches.forEach((match)=>{
        const matchText = text.slice(match.index, match.index + match[0].length);
        const leading = text.slice(currentPosition, match.index);
        if (leading !== '') parts.push($38a0e824f156ae86$export$2235873b95f89ea(leading));
        parts.push($38a0e824f156ae86$export$39ae7d355c29b45f(matchText));
        currentPosition = match.index + matchText.length;
    });
    const trailing = text.slice(currentPosition);
    if (trailing !== '') parts.push($38a0e824f156ae86$export$2235873b95f89ea(trailing));
    return parts;
};

});

parcelRegister("e63D2", function(module, exports) {

$parcel$export(module.exports, "default", () => $29e295d31ad42542$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gttjd = parcelRequire("gttjd");

var $lbHMu = parcelRequire("lbHMu");
const $29e295d31ad42542$var$HighlightTextWithParser = /*#__PURE__*/ (0, $eUqFw.memo)(({ text: text, highlight: highlight })=>{
    const parts = (0, $gttjd.getParts)(highlight, text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lbHMu.default), {
        parts: parts
    });
});
var $29e295d31ad42542$export$2e2bcd8739ae039 = $29e295d31ad42542$var$HighlightTextWithParser;

});
parcelRegister("lbHMu", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed9071505b4a281f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gda1r = parcelRequire("gda1r");
const $ed9071505b4a281f$var$HighlightText = ({ parts: parts })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, parts.map((part, i)=>{
        if (part.type === 'text') return part.content;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gda1r.Mark), {
            key: i
        }, part.content);
    }));
var $ed9071505b4a281f$export$2e2bcd8739ae039 = $ed9071505b4a281f$var$HighlightText;

});
parcelRegister("gda1r", function(module, exports) {

$parcel$export(module.exports, "Mark", () => $8f973f57522751f3$export$c9d15bcfc6d42044);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $8f973f57522751f3$export$c9d15bcfc6d42044 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "mark", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkwtfv _syaz1fxt",
            __cmplp.className
        ])
    });
});

});






parcelRegister("gMlzx", function(module, exports) {

$parcel$export(module.exports, "MentionsIndicatorField", () => $2db1a5916339656c$export$b0611c03052451f0);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4j59n = parcelRequire("4j59n");
const $2db1a5916339656c$export$b0611c03052451f0 = ({ unreadMentions: unreadMentions, onClick: onClick })=>{
    const handleClick = (0, $eUqFw.useCallback)((e)=>{
        e.stopPropagation();
        if (e.defaultPrevented) return;
        const withCmd = e.ctrlKey || e.metaKey;
        const withShift = e.shiftKey;
        onClick(withCmd, withShift, 'mouse');
    }, [
        onClick
    ]);
    const onClickToGoToComment = (0, $eUqFw.useCallback)((e)=>{
        e.stopPropagation();
        if (e.defaultPrevented) return;
        const withCmd = e.ctrlKey || e.metaKey;
        const withShift = e.shiftKey;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onClick(withCmd, withShift, e.type === 'keydown' ? 'keyboard' : 'mouse', false, {
            type: 'SCROLL_TO_COMMENT',
            payload: {
                commentId: unreadMentions?.latestUnreadCommentId
            }
        });
    }, [
        onClick,
        unreadMentions?.latestUnreadCommentId
    ]);
    if (unreadMentions) return unreadMentions?.latestUnreadCommentId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $2db1a5916339656c$var$mentionsIndicatorStyles,
        testId: (0, $b381f4fb7caebb83$export$b78dc6cb8982871e)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4j59n.MentionsIndicator), {
        onClick: onClickToGoToComment
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $2db1a5916339656c$var$mentionsIndicatorStyles,
        testId: (0, $b381f4fb7caebb83$export$b78dc6cb8982871e)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4j59n.MentionsIndicator), {
        onClick: handleClick
    }));
    // Render empty div if there are no mentions, to keep elements in a card list aligned vertically
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $2db1a5916339656c$var$mentionsIndicatorStyles,
        testId: (0, $b381f4fb7caebb83$export$b78dc6cb8982871e)
    });
};
const $2db1a5916339656c$var$mentionsIndicatorStyles = (0, $1ZAYh.xcss)({
    width: "var(--ds-space-300, 1.5rem)"
});

});
parcelRegister("4j59n", function(module, exports) {

$parcel$export(module.exports, "MentionsIndicator", () => $07ccbbc8e383561b$export$25cfa29d97948284);

var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $dZhDV = parcelRequire("dZhDV");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");


var $d8sUi = parcelRequire("d8sUi");
const $07ccbbc8e383561b$var$MentionsIndicatorIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZhDV))), {
        primaryColor: `var(--ds-icon-accent-blue, ${(0, $PdmhA).B300})`,
        label: "",
        size: "medium"
    });
const $07ccbbc8e383561b$export$25cfa29d97948284 = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const tooltipLabel = formatMessage((0, $d8sUi.default).unreadMentionsTooltip);
    const a11yLabel = formatMessage((0, $d8sUi.default).unreadMentionsA11YLabel);
    const onShowToolTip = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'mentionIndicator',
            action: 'hovered'
        }));
    }, [
        createAnalyticsEvent
    ]);
    const onMentionIndicatorClick = (0, $eUqFw.useCallback)((e, _)=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'mentionIndicator',
            action: 'clicked'
        }));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const mouseEvent = e;
        onClick(mouseEvent);
    }, [
        onClick,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: tooltipLabel,
        onShow: onShowToolTip,
        delay: 500,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        testId: (0, $b381f4fb7caebb83$export$1cb640bfbaf8d4f2),
        icon: $07ccbbc8e383561b$var$MentionsIndicatorIcon,
        appearance: "subtle",
        label: a11yLabel,
        onClick: onMentionIndicatorClick,
        spacing: "compact"
    }));
};

});
parcelRegister("dZhDV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2eea8678fc0743c$var$_react = $a2eea8678fc0743c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $a2eea8678fc0743c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a2eea8678fc0743c$var$EditorMentionIcon = (props)=>/*#__PURE__*/ $a2eea8678fc0743c$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12.062 13.93c-.904 0-1.451-.734-1.451-1.945 0-1.226.538-1.952 1.466-1.952.928 0 1.422.764 1.422 1.967 0 1.195-.502 1.93-1.438 1.93M12 5c-3.925 0-7 3.075-7 7 0 4.596 3.522 7 7 7 .874 0 1.614-.09 2.26-.279a.751.751 0 00-.42-1.44c-.508.147-1.11.22-1.84.22-2.648 0-5.5-1.722-5.5-5.5 0-3.085 2.417-5.5 5.5-5.5 3.24 0 5.5 1.952 5.5 4.75 0 2.045-1.043 3-1.748 3-.008 0-.752-.11-.752-.75v-4a.75.75 0 10-1.5 0v.187c-.346-.585-1.016-.952-1.795-.952C10.102 8.736 9 10.04 9 11.938c0 1.984 1.103 3.312 2.753 3.312.865 0 1.51-.387 1.865-1.076.334 1.016 1.37 1.576 2.132 1.576 1.598 0 3.25-1.683 3.25-4.5C19 7.628 16.058 5 12 5" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$a2eea8678fc0743c$var$EditorMentionIcon.displayName = 'EditorMentionIcon';
var $a2eea8678fc0743c$var$_default = $a2eea8678fc0743c$var$EditorMentionIcon;
module.exports.default = $a2eea8678fc0743c$var$_default;

});

const $b381f4fb7caebb83$export$b78dc6cb8982871e = 'software.unread-mentions-indicator-wrapper';
const $b381f4fb7caebb83$export$1cb640bfbaf8d4f2 = 'software.unread-mentions-indicator';

parcelRegister("d8sUi", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cf1f724523dabff$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8cf1f724523dabff$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    unreadMentionsTooltip: {
        "id": "mentions-indicator.unread-mentions-tooltip",
        "defaultMessage": "You have been mentioned"
    },
    unreadMentionsA11YLabel: {
        "id": "mentions-indicator.unread-mentions-a-11-y-label",
        "defaultMessage": "You have unread mentions on this issue"
    }
});

});



parcelRegister("1muUz", function(module, exports) {

$parcel$export(module.exports, "default", () => $da8f55e01a84f864$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $kwce8 = parcelRequire("kwce8");

var $ldoFd = parcelRequire("ldoFd");

var $7rh0R = parcelRequire("7rh0R");

var $c9TLT = parcelRequire("c9TLT");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $kmr29 = parcelRequire("kmr29");

var $5EZkh = parcelRequire("5EZkh");
var $gluAC = parcelRequire("gluAC");

var $kPsG3 = parcelRequire("kPsG3");

var $hkpbM = parcelRequire("hkpbM");


var $ba1Xy = parcelRequire("ba1Xy");

var $7v0hO = parcelRequire("7v0hO");

var $7v0hO = parcelRequire("7v0hO");


var $8wXFi = parcelRequire("8wXFi");

var $7TyGu = parcelRequire("7TyGu");

var $eKS1U = parcelRequire("eKS1U");

var $1gQ73 = parcelRequire("1gQ73");

var $6iBIZ = parcelRequire("6iBIZ");

var $bP7Jx = parcelRequire("bP7Jx");

var $j258X = parcelRequire("j258X");

var $diedG = parcelRequire("diedG");

var $5WFzC = parcelRequire("5WFzC");

var $dNKdc = parcelRequire("dNKdc");

var $kKv6B = parcelRequire("kKv6B");

var $dysb4 = parcelRequire("dysb4");

var $chaHX = parcelRequire("chaHX");

const $da8f55e01a84f864$var$IssueOriginalEstimateField = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("hLomP")), {
    moduleId: "./src/packages/issue/fields/original-estimate/src/index.tsx"
});
const $da8f55e01a84f864$var$OriginalEstimateField = ({ issueId: issueId, issueKey: issueKey, estimationType: estimationType, timeTrackingOptions: timeTrackingOptions, isUserAtLeastMember: isUserAtLeastMember, shouldRenderRichCard: shouldRenderRichCard, shouldRenderEstimatesColumn: shouldRenderEstimatesColumn })=>{
    const isCompanyManaged = (0, $j258X.useIsCMPBacklog)();
    const hasEstimate = (0, $1gQ73.useBacklogSelector)((state)=>!!(0, $bP7Jx.getCards)(state)[String(issueId)]?.estimate);
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const [_, { triggerEpicPanelRefetch: triggerEpicPanelRefetch }] = (0, $ba1Xy.useShouldRefetchEpicPanel)();
    const intl = (0, $5JgJ2.default)();
    const [originalEstimateFieldValue] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $ebc098a76317be78$export$5fbd3b15555b9ef2)
    });
    const handleConfirm = (0, $eUqFw.useCallback)(()=>{
        (0, $eKS1U.setInlineEditOriginalEstimateInteractionStartMark)();
    }, []);
    const handleUpdate = (0, $eUqFw.useCallback)(()=>{
        (0, $eKS1U.setInlineEditOriginalEstimateInteractionStopMark)(isCompanyManaged);
        dispatch((0, $6iBIZ.refetchVersions)());
        if (isCompanyManaged) triggerEpicPanelRefetch();
    }, [
        dispatch,
        isCompanyManaged,
        triggerEpicPanelRefetch
    ]);
    const handleFailure = (0, $eUqFw.useCallback)(()=>{
        (0, $eKS1U.cancelInlineEditOriginalEstimateInteractionMark)();
    }, []);
    if (!shouldRenderEstimatesColumn && (estimationType !== (0, $7TyGu.ORIGINAL_ESTIMATE) || !hasEstimate)) return null;
    const isOriginalEstimateAccessible = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(originalEstimateFieldValue);
    const value = isOriginalEstimateAccessible ? (0, $7v0hO.timeTrackingFormatter)(originalEstimateFieldValue, timeTrackingOptions, intl) : undefined;
    const placeholder = '2w 4d 6h 45m';
    const invalidTimeFormatMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $kKv6B.default).invalidTimeFormatMessage,
        values: {
            format: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, placeholder)
        }
    });
    let ariaLabel = '';
    if ((0, $1ybV0.ff)('sea-2524-backlog-card-estimates-a11y-improvements_1ljqi')) {
        const longFormValue = isOriginalEstimateAccessible && originalEstimateFieldValue > 0 ? (0, $7v0hO.timeTrackingFormatterLongForm)(originalEstimateFieldValue, timeTrackingOptions, intl) : undefined;
        ariaLabel = longFormValue ? `${intl.formatMessage((0, $kKv6B.default).originalEstimateAriaLabel)}: ${longFormValue}` : `${intl.formatMessage((0, $kKv6B.default).originalEstimateAriaLabel)}: ${intl.formatMessage((0, $kKv6B.default).originalEstimateAriaLabelNullValue)}`;
    }
    const OriginalEstimateFieldBoundary = (0, $8wXFi.isNewInlineEditEstimateComponentsEnabled)() ? (0, $gluAC.OriginalEstimateInlineEditErrorBoundary) : (0, $hkpbM.IssueOriginalEstimateFieldBoundary);
    const AsyncOriginalEstimateField = (0, $8wXFi.isNewInlineEditEstimateComponentsEnabled)() ? (0, $5EZkh.AsyncOriginalEstimateInlineEdit) : $da8f55e01a84f864$var$IssueOriginalEstimateField;
    let issueOriginalEstimateFieldStatic;
    if ((0, $8wXFi.isNewInlineEditEstimateComponentsEnabled)()) {
        // Both flags on
        if ((0, $1ybV0.ff)('sea-2524-backlog-card-estimates-a11y-improvements_1ljqi')) issueOriginalEstimateFieldStatic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dNKdc.default), {
            tooltipLabel: intl.formatMessage((0, $kKv6B.default).originalEstimateTooltip),
            ariaLabel: ariaLabel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kPsG3.OriginalEstimateReadView), {
            isEditable: false,
            value: value || '0m'
        }));
        else issueOriginalEstimateFieldStatic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kPsG3.OriginalEstimateReadView), {
            isEditable: false,
            value: value || '0m'
        });
    } else if ((0, $1ybV0.ff)('sea-2524-backlog-card-estimates-a11y-improvements_1ljqi')) issueOriginalEstimateFieldStatic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dysb4.default), {
        value: value,
        valueInSeconds: originalEstimateFieldValue,
        hasEstimate: hasEstimate,
        timeTrackingOptions: timeTrackingOptions
    });
    else issueOriginalEstimateFieldStatic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dysb4.default), {
        value: value,
        hasEstimate: hasEstimate
    });
    if (isUserAtLeastMember && shouldRenderRichCard) {
        if ((0, $1ybV0.ff)('sea-2524-backlog-card-estimates-a11y-improvements_1ljqi')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(OriginalEstimateFieldBoundary, {
            packageName: (0, $e1409a6fc345c0d8$export$dfd208682d29484c),
            fallback: issueOriginalEstimateFieldStatic
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $diedG.default), {
            experienceTarget: "inline original estimate",
            experienceTargetId: issueKey,
            additionalAttributes: {
                issueKey: issueKey
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($da8f55e01a84f864$var$OriginalEstimateFieldWrapper, {
            shouldRenderEstimatesColumn: shouldRenderEstimatesColumn
        }, hasEstimate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($da8f55e01a84f864$var$OriginalEstimateFieldContainer, {
            hasValue: isOriginalEstimateAccessible
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dNKdc.default), {
            tooltipLabel: intl.formatMessage((0, $kKv6B.default).originalEstimateTooltip),
            ariaLabel: ariaLabel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AsyncOriginalEstimateField, {
            isEditable: true,
            isMobile: false,
            isFitContainerWidthReadView: true,
            fieldId: (0, $ebc098a76317be78$export$5fbd3b15555b9ef2),
            issueId: String(issueId),
            issueKey: issueKey,
            config: (0, $chaHX.timeTrackingConfigTransformer)(timeTrackingOptions),
            placeholder: placeholder,
            timeTrackingValue: {},
            invalidTimeFormatMessage: invalidTimeFormatMessage,
            isBacklogComponent: true,
            onUpdate: handleUpdate,
            onConfirm: handleConfirm,
            onFailure: handleFailure
        }))))));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(OriginalEstimateFieldBoundary, {
            packageName: (0, $e1409a6fc345c0d8$export$dfd208682d29484c),
            fallback: issueOriginalEstimateFieldStatic
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $diedG.default), {
            experienceTarget: "inline original estimate",
            experienceTargetId: issueKey,
            additionalAttributes: {
                issueKey: issueKey
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($da8f55e01a84f864$var$OriginalEstimateFieldWrapper, {
            shouldRenderEstimatesColumn: shouldRenderEstimatesColumn
        }, hasEstimate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($da8f55e01a84f864$var$OriginalEstimateFieldContainer, {
            hasValue: isOriginalEstimateAccessible
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AsyncOriginalEstimateField, {
            isEditable: true,
            isMobile: false,
            isFitContainerWidthReadView: true,
            fieldId: (0, $ebc098a76317be78$export$5fbd3b15555b9ef2),
            issueId: String(issueId),
            issueKey: issueKey,
            config: (0, $chaHX.timeTrackingConfigTransformer)(timeTrackingOptions),
            placeholder: placeholder,
            timeTrackingValue: {},
            invalidTimeFormatMessage: invalidTimeFormatMessage,
            isBacklogComponent: true,
            onUpdate: handleUpdate,
            onConfirm: handleConfirm,
            onFailure: handleFailure
        })))));
    }
    return issueOriginalEstimateFieldStatic;
};
var $da8f55e01a84f864$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($da8f55e01a84f864$var$OriginalEstimateField);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da8f55e01a84f864$var$OriginalEstimateFieldContainerControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "ucpwgo-0"
})`cursor:default;${()=>(0, $8wXFi.isBacklogCardEstimatesA11yImprovementsEnabled)() && `
        display: flex;
        height: 100%;
        align-items: center;
        `} min-width:${(0, $c9TLT.gridSize) * 10}px;overflow:inherit;[data-testid^='issue-field-original-estimate.ui.view.badge']{display:block;max-width:${(0, $c9TLT.gridSize) * 10}px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;& > span{display:block;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;}}&:focus,&:focus-within{outline:none;}button[aria-label='Edit']:focus + div{${()=>(0, $8wXFi.isBacklogCardEstimatesA11yImprovementsEnabled)() && (0, $8wXFi.isNewInlineEditEstimateComponentsEnabled)() && 'border-color: transparent;'}}${(0, $5WFzC.CardContainerControl)}:hover &,${(0, $5WFzC.CardContainerControl)}:active &,${(0, $5WFzC.CardContainerControl)}:focus &,${(0, $5WFzC.CardContainerControl)}:focus-within &{position:inherit;opacity:inherit;pointer-events:inherit;}*{display:flex;&:empty{box-shadow:none;}}& > div > div{margin-left:0;&[data-component-selector='jira-issue-field-inline-edit-readonly-view-container']{margin:${()=>(0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') ? `${"var(--ds-space-100, 8px)"} 0 0 0` : undefined};}& > div > div{display:flex;}}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $da8f55e01a84f864$var$OriginalEstimateFieldContainerExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1eli9yb": (0, $9t7rW.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $8wXFi.isBacklogCardEstimatesA11yImprovementsEnabled)() && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $8wXFi.isNewInlineEditEstimateComponentsEnabled)() && 'transparent')
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_80om73ad _1ul9ys9h _1reo1kw7 _18m91kw7 _rxafnmwm _tkqh1txw _9t8gglyw _1la1idpf _18vj1txw _18kq1kw7 _1jsw1kw7 _3p7d1kw7 _j88e1kw7 _1ksg1kw7 _zpal1kw7 _wnsb1kw7 _bwtn1kw7 _wlgl1kw7 _1n6k1kw7 _tq0k1kw7 _xzt01kw7 _13mo1ule _1ny3ys9h _1udr15vq _nmyy15vq _g5ay1q9c _ox3r1l2s _1lab1ule _1n1y15vq _2jfx15vq _9xlo1q9c _pgqw1l2s _nt751r31 _1guj1r31 _49pcglyw _pbhaglyw _1hvw1o36 _11ow1o36",
            (0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') && "_9v95v0yc",
            (0, $8wXFi.isBacklogCardEstimatesA11yImprovementsEnabled)() && "_1e0c1txw _4t3i1osq _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $da8f55e01a84f864$var$OriginalEstimateFieldContainer = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $da8f55e01a84f864$var$OriginalEstimateFieldContainerExperiment, $da8f55e01a84f864$var$OriginalEstimateFieldContainerControl); // empty column for the cards that without original estimates
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da8f55e01a84f864$var$OriginalEstimateFieldWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldRenderEstimatesColumn: shouldRenderEstimatesColumn, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.shouldRenderEstimatesColumn && "_1ul9ys9h _p12fys9h",
            (0, $8wXFi.isBacklogCardEstimatesA11yImprovementsEnabled)() && "_1e0c1txw _1wpz1fhb _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5EZkh", function(module, exports) {

$parcel$export(module.exports, "AsyncOriginalEstimateInlineEdit", () => $32653eaef0722269$export$4953f72b4b129e16);

var $7rh0R = parcelRequire("7rh0R");

const $32653eaef0722269$export$4953f72b4b129e16 = (0, $7rh0R.lazy)(()=>(parcelRequire("f6srY")), {
    moduleId: "./src/packages/issue/fields/original-estimate-inline-edit/inline-edit/src/ui/main.tsx"
});

});
parcelRegister("f6srY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('9qtTr');
        const value = parcelRequire('jugV9');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("9qtTr").then(()=>parcelRequire('jugV9'));
}

});


parcelRegister("gluAC", function(module, exports) {

$parcel$export(module.exports, "OriginalEstimateInlineEditErrorBoundary", () => $8b0acb0deaf6334f$export$466499b8671a900);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");
const $8b0acb0deaf6334f$export$466499b8671a900 = ({ fallback: fallback, children: children, packageName: packageName, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "original-estimate-inline-edit",
        packageName: packageName,
        teamName: "deliveroo",
        fallback: "flag",
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "original-estimate-inline-edit-error-boundary",
        fallback: fallback
    }, children));

});

parcelRegister("kPsG3", function(module, exports) {

$parcel$export(module.exports, "OriginalEstimateReadView", () => $4a24071fbf94c816$export$9fbd5776dc81fee9);

var $eUqFw = parcelRequire("eUqFw");

var $9nkwJ = parcelRequire("9nkwJ");


var $jbLr9 = parcelRequire("jbLr9");
const $4a24071fbf94c816$export$9fbd5776dc81fee9 = ({ isEditable: isEditable = false, value: value })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jbLr9.BadgeWrapper), {
        "data-testid": (0, $b517f7e516a8a1a2$export$f8a6f6348211dbc5),
        isEditable: isEditable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
        testId: (0, $b517f7e516a8a1a2$export$2933cf3129243376)
    }, value));

});
const $b517f7e516a8a1a2$export$2933cf3129243376 = 'issue-field-original-estimate-inline-edit-readview.ui.badge';
const $b517f7e516a8a1a2$export$f8a6f6348211dbc5 = 'issue-field-original-estimate-inline-edit-readview.ui.wrapper';

parcelRegister("jbLr9", function(module, exports) {

$parcel$export(module.exports, "BadgeWrapper", () => $a0b558840f363eec$export$1a37a8b7ddf809ac);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $a0b558840f363eec$export$1a37a8b7ddf809ac = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEditable: isEditable, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _kqswh2mm",
            __cmplp.isEditable ? "_80omtlke" : "_80om1wug",
            __cmplp.isEditable ? "_1lgibn51" : "_1lgilecj",
            __cmplp.className
        ])
    });
});

});


parcelRegister("hkpbM", function(module, exports) {

$parcel$export(module.exports, "IssueOriginalEstimateFieldBoundary", () => $7abf30764f2673e5$export$1c6d9e9bdb2427ab);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

const $7abf30764f2673e5$export$1c6d9e9bdb2427ab = ({ children: children, fallback: fallback, packageName: packageName, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "issue-original-estimate-field",
        packageName: packageName,
        fallback: fallback ? ()=>fallback : undefined,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-original-estimate-field-boundary",
        fallback: fallback
    }, children));

const $7abf30764f2673e5$export$572c30be3fc4b061 = (0, $7rh0R.lazy)(()=>(parcelRequire("2Pod5")).then((IssueOriginalEstimateField)=>IssueOriginalEstimateField), {
    moduleId: "./src/packages/issue/fields/original-estimate/src/ui/index.tsx"
});

});
parcelRegister("2Pod5", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('cS979');
        const value = parcelRequire('7jM0B');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("cS979").then(()=>parcelRequire('7jM0B'));
}

});


parcelRegister("chaHX", function(module, exports) {

$parcel$export(module.exports, "timeTrackingConfigTransformer", () => $9e54ba4331bb76c1$export$5507631896590474);
const $9e54ba4331bb76c1$export$5507631896590474 = ({ workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, defaultUnit: defaultUnit, timeFormat: timeFormat })=>({
        isTimeTrackingEnabled: true,
        daysPerWeek: workingDaysPerWeek,
        hoursPerDay: workingHoursPerDay,
        defaultUnit: defaultUnit,
        format: timeFormat
    });

});

parcelRegister("hLomP", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hUppJ');
        const value = parcelRequire('7Z4BP');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hUppJ").then(()=>parcelRequire('7Z4BP'));
}

});


parcelRegister("cbbdp", function(module, exports) {

$parcel$export(module.exports, "Parent", () => $92667a8bc52fdab5$export$ef39aebeb16866ce);

var $eUqFw = parcelRequire("eUqFw");

var $5WFzC = parcelRequire("5WFzC");

var $5mm8H = parcelRequire("5mm8H");

var $cunRa = parcelRequire("cunRa");

var $hkD5e = parcelRequire("hkD5e");
const $92667a8bc52fdab5$export$ef39aebeb16866ce = ({ cardId: cardId, cardKey: cardKey, isUserAtLeastMember: isUserAtLeastMember, parents: parents, parentId: parentId, currentProjectId: currentProjectId, projectIds: projectIds, canUserEditIssue: canUserEditIssue, shouldRenderRichCard: shouldRenderRichCard, backlogContainerSize: backlogContainerSize, isCompactView: isCompactView, isSubtask: isSubtask, isEpic: isEpic, isCompanyManaged: isCompanyManaged })=>// Using placeholderWidthMultiplier so that with change in container width the width of placeholder changes
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.EpicWrapper), {
        widthMultiplier: (0, $hkD5e.getLabelWidthMultiplier)((0, $hkD5e.LabelType).EPIC, backlogContainerSize),
        // To avoid any extra space show the placeholder only on cards not linked to any epic and are not subtasks
        showPlaceholder: parentId === null && !isSubtask
    }, isEpic && isCompanyManaged ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mm8H.default), {
        issueKey: cardKey,
        issueId: cardId,
        isCompactView: isCompactView
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cunRa.default), {
        issueId: cardId,
        issueKey: cardKey,
        isUserAtLeastMember: isUserAtLeastMember,
        parents: parents,
        parentId: parentId,
        currentProjectId: currentProjectId,
        projectIds: projectIds,
        forceEditable: canUserEditIssue,
        shouldRenderRichCard: shouldRenderRichCard,
        isCompactView: isCompactView
    }));

});
parcelRegister("cunRa", function(module, exports) {

$parcel$export(module.exports, "default", () => $d01e080660c49ec8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $ldoFd = parcelRequire("ldoFd");

var $7rh0R = parcelRequire("7rh0R");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");

var $opsFH = parcelRequire("opsFH");

var $kmr29 = parcelRequire("kmr29");

var $48VhW = parcelRequire("48VhW");
var $51HAN = parcelRequire("51HAN");

var $lO4Or = parcelRequire("lO4Or");

var $8WuJm = parcelRequire("8WuJm");

var $ba1Xy = parcelRequire("ba1Xy");


var $j258X = parcelRequire("j258X");

var $diedG = parcelRequire("diedG");

var $5WFzC = parcelRequire("5WFzC");

var $h4Zri = parcelRequire("h4Zri");

const $d01e080660c49ec8$export$470a9ca634922e36 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("liqL9")).then(({ ParentSwitcherField: ParentSwitcherField })=>ParentSwitcherField), {
    moduleId: "./src/packages/issue/fields/parent-switcher/src/index.tsx"
});
const $d01e080660c49ec8$var$ParentField = ({ issueId: issueId, issueKey: issueKey, isUserAtLeastMember: isUserAtLeastMember, parents: parents = [], currentProjectId: currentProjectId, projectIds: projectIds, shouldRenderRichCard: shouldRenderRichCard, forceEditable: forceEditable, parentId: parentId, isCompactView: isCompactView })=>{
    const [parentValue] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $lO4Or.PARENT_TYPE)
    });
    const isCompanyManaged = (0, $j258X.useIsCMPBacklog)();
    const [_, { triggerEpicPanelRefetch: triggerEpicPanelRefetch }] = (0, $ba1Xy.useShouldRefetchEpicPanel)();
    const transformedEpic = (0, $eUqFw.useMemo)(()=>parents.map((p)=>(0, $51HAN.transformToEpic)(p)), [
        parents
    ]); // Mapped parent is required to get the epic/parent's color
    const mappedParent = (0, $eUqFw.useMemo)(()=>parentId ? parents.find(({ id: id })=>Number(id) === Number(parentId)) : null, [
        parentId,
        parents
    ]);
    const renderParentFieldStatic = (0, $eUqFw.useCallback)(()=>{
        const color = mappedParent?.color || parentValue?.color || (0, $opsFH.PURPLE);
        const summary = mappedParent?.summary || parentValue?.fields?.summary;
        return summary ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h4Zri.default), {
            color: color,
            summary: summary,
            isCompactView: isCompactView
        }) : null;
    }, [
        isCompactView,
        mappedParent,
        parentValue?.color,
        parentValue?.fields?.summary
    ]);
    const handleSuccess = (0, $eUqFw.useCallback)(()=>{
        if (isCompanyManaged) triggerEpicPanelRefetch();
    }, [
        isCompanyManaged,
        triggerEpicPanelRefetch
    ]); // in the storybook, it first displays the static epic lozenge.
    // but when we mouse over on a card, the epic field would disappear due to missing hierarchy-level-above value in the sweet state
    if (isUserAtLeastMember && shouldRenderRichCard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $48VhW.ParentSwitcherBoundary), {
        packageName: (0, $e1409a6fc345c0d8$export$dfd208682d29484c),
        fallback: renderParentFieldStatic()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $diedG.default), {
        experienceTarget: "inline epic",
        experienceTargetId: issueKey,
        additionalAttributes: {
            issueKey: issueKey
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d01e080660c49ec8$var$ParentFieldWrapper, {
        hasValue: !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(parentValue),
        isCompactView: isCompactView
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: {
            isInlineEditing: true
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d01e080660c49ec8$export$470a9ca634922e36, {
        onSuccess: handleSuccess,
        issueKey: issueKey,
        issueId: String(issueId),
        epics: transformedEpic,
        forceEditable: forceEditable,
        isSimplifiedProject: !isCompanyManaged,
        currentProjectId: currentProjectId,
        projectIds: projectIds,
        isCompactView: isCompactView
    })))));
    return renderParentFieldStatic();
};
var $d01e080660c49ec8$export$2e2bcd8739ae039 // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
 = /*#__PURE__*/ (0, $eUqFw.memo)($d01e080660c49ec8$var$ParentField);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d01e080660c49ec8$var$ParentFieldWrapperControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-16ie1ab-0"
})`display:flex;align-items:flex-end;position:relative;cursor:default;max-width:100%;box-sizing:border-box;& > div + div{position:absolute !important;top:${"var(--ds-space-400, 32px)"} !important;right:auto !important;left:${"var(--ds-space-050, 4px)"} !important;transform:none !important;}${({ isCompactView: isCompactView })=>!isCompactView && `
        padding-left: ${"var(--ds-space-100, 8px)"};
        `} ${({ hasValue: hasValue })=>!hasValue && `
        opacity: 0;
        `} ${(0, $5WFzC.CardContainerControl)}:hover &,${(0, $5WFzC.CardContainerControl)}:active &,${(0, $5WFzC.CardContainerControl)}:focus &,${(0, $5WFzC.CardContainerControl)}:focus-within &{opacity:inherit;}`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $d01e080660c49ec8$var$ParentFieldWrapperExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCompactView: isCompactView, hasValue: hasValue, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvresu3 _kqswh2mm _80om73ad _p12f1osq _vchhusvi _5ci27079 _907j1kev _1rt91h90 _1u4t126e _nyj2agmp _1ksg1kw7 _zpal1kw7 _wnsb1kw7 _bwtn1kw7",
            !__cmplp.isCompactView && "_19bvu2gc",
            !__cmplp.hasValue && "_tzy4idpf",
            __cmplp.className
        ])
    });
});
const $d01e080660c49ec8$var$ParentFieldWrapper = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $d01e080660c49ec8$var$ParentFieldWrapperExperiment, $d01e080660c49ec8$var$ParentFieldWrapperControl);

});
parcelRegister("48VhW", function(module, exports) {

$parcel$export(module.exports, "ParentSwitcherBoundary", () => $3e3a6e12bbc12828$export$5fd31a263aabeb24);
$parcel$export(module.exports, "AsyncLazyParentSwitcherField", () => $3e3a6e12bbc12828$export$690bf5ebb9d6daf8);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");
const $3e3a6e12bbc12828$export$5fd31a263aabeb24 = ({ children: children, fallback: fallback, packageName: packageName, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "issue-parent-switcher",
        packageName: packageName,
        fallback: fallback ? ()=>fallback : undefined,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-parent-switcher-boundary",
        fallback: fallback
    }, children));

const $3e3a6e12bbc12828$export$690bf5ebb9d6daf8 = (0, $7rh0R.lazy)(()=>(parcelRequire("b1riD")).then(({ ParentSwitcherField: ParentSwitcherField })=>ParentSwitcherField), {
    moduleId: "./src/packages/issue/fields/parent-switcher/src/ui/main.tsx"
});

});
parcelRegister("b1riD", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dWuq9');
        const value = parcelRequire('2nIc4');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dWuq9").then(()=>parcelRequire('2nIc4'));
}

});


parcelRegister("liqL9", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('isxqC');
        const value = parcelRequire('k1dqV');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("isxqC").then(()=>parcelRequire('k1dqV'));
}

});



parcelRegister("3uhy5", function(module, exports) {

$parcel$export(module.exports, "StatusFieldWrapper", () => $a2582740da214535$export$b298de36b54f1050);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $c9TLT = parcelRequire("c9TLT");

var $1ybV0 = parcelRequire("1ybV0");

var $8MrYx = parcelRequire("8MrYx");

var $bn3eO = parcelRequire("bn3eO");

var $hkD5e = parcelRequire("hkD5e");

var $6HgkK = parcelRequire("6HgkK");
const $a2582740da214535$export$b298de36b54f1050 = ({ isUserAtLeastMember: isUserAtLeastMember, shouldRenderRichCard: shouldRenderRichCard, cardKey: cardKey, cardId: cardId })=>{
    const showStatuses = (0, $8MrYx.useShowStatuses)();
    const { size: backlogContainerSize } = (0, $bn3eO.useContainerSize)();
    if (showStatuses) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a2582740da214535$var$StatusContainer, {
        "data-testid": "software-backlog.card-list.card.card-contents.status-field.status-field-wrapper.status-container",
        widthMultiplier: (0, $hkD5e.getLabelWidthMultiplier)((0, $hkD5e.LabelType).STATUS, backlogContainerSize)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6HgkK.default), {
        isUserAtLeastMember: isUserAtLeastMember,
        shouldRenderRichCard: shouldRenderRichCard,
        issueKey: cardKey,
        issueId: String(cardId),
        widthMultiplier: (0, $hkD5e.getLabelWidthMultiplier)((0, $hkD5e.LabelType).STATUS, backlogContainerSize)
    }));
    return null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a2582740da214535$var$StatusContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { widthMultiplier: widthMultiplier, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_uu7jbp": (0, $9t7rW.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `repeat(auto-fit,${(0, $c9TLT.gridSize) * __cmplp.widthMultiplier}px)`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c11p5 _lcxvglyw _1reo1kw7 _18m91kw7 _yv0e105t",
            !(0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') && "_4t3i1tcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6HgkK", function(module, exports) {

$parcel$export(module.exports, "default", () => $583554ad55c67aee$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $kwce8 = parcelRequire("kwce8");

var $aXGkF = parcelRequire("aXGkF");

var $ldoFd = parcelRequire("ldoFd");

var $7rh0R = parcelRequire("7rh0R");

var $8Qd0L = parcelRequire("8Qd0L");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");

var $kmr29 = parcelRequire("kmr29");

var $6nWxr = parcelRequire("6nWxr");


var $ba1Xy = parcelRequire("ba1Xy");


var $eKS1U = parcelRequire("eKS1U");

var $1gQ73 = parcelRequire("1gQ73");

var $6iBIZ = parcelRequire("6iBIZ");

var $j258X = parcelRequire("j258X");

var $diedG = parcelRequire("diedG");

var $2N3Im = parcelRequire("2N3Im");

const $583554ad55c67aee$export$58bec2551a247e1d = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("gyxA6")), {
    moduleId: "./src/packages/issue/fields/status/src/index.tsx"
});
const $583554ad55c67aee$var$StatusField = ({ isUserAtLeastMember: isUserAtLeastMember, shouldRenderRichCard: shouldRenderRichCard, issueKey: issueKey, widthMultiplier: widthMultiplier, issueId: issueId })=>{
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const [statusFieldValue] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $ebc098a76317be78$export$4420b7468f889692)
    });
    const isCompanyManaged = (0, $j258X.useIsCMPBacklog)();
    const [_, { triggerEpicPanelRefetch: triggerEpicPanelRefetch }] = (0, $ba1Xy.useShouldRefetchEpicPanel)();
    const handleSubmit = (0, $eUqFw.useCallback)(()=>{
        (0, $eKS1U.setInlineEditStatusInteractionStartMark)();
    }, []);
    const handleSuccess = (0, $eUqFw.useCallback)(()=>{
        (0, $eKS1U.setInlineEditStatusInteractionStopMark)(isCompanyManaged);
        dispatch((0, $6iBIZ.refetchVersions)());
        if (isCompanyManaged) triggerEpicPanelRefetch();
    }, [
        dispatch,
        isCompanyManaged,
        triggerEpicPanelRefetch
    ]);
    const handleFailure = (0, $eUqFw.useCallback)(()=>{
        (0, $eKS1U.cancelInlineEditStatusInteractionMark)();
    }, []);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(statusFieldValue) || !statusFieldValue.id || !statusFieldValue.name) return null;
    const value = {
        id: statusFieldValue.id,
        name: statusFieldValue.name,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        category: (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))((0, $8Qd0L.StatusCategoryIds))[statusFieldValue.statusCategory.id] || (0, $8Qd0L.StatusCategoryTypes).UNDEFINED
    };
    const issueStatusFieldStatic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2N3Im.default), {
        isUserAtLeastMember: isUserAtLeastMember,
        value: value
    });
    if (isUserAtLeastMember && shouldRenderRichCard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6nWxr.IssueStatusFieldBoundary), {
        packageName: (0, $e1409a6fc345c0d8$export$dfd208682d29484c),
        fallback: issueStatusFieldStatic
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $diedG.default), {
        experienceTarget: "inline status",
        experienceTargetId: issueKey,
        additionalAttributes: {
            issueKey: issueKey
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($583554ad55c67aee$export$653fc70614ecd562, {
        widthMultiplier: widthMultiplier
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($583554ad55c67aee$export$58bec2551a247e1d, {
        appearance: "lozenge",
        issueKey: issueKey,
        issueId: issueId,
        initialValue: statusFieldValue,
        onSubmit: handleSubmit,
        onSuccess: handleSuccess,
        onFailure: handleFailure
    }))));
    return issueStatusFieldStatic;
};
var $583554ad55c67aee$export$2e2bcd8739ae039 // NOTE: The div is needed here because StatusLozenge is an async component and we use a universal selector hack in the styling
 = /*#__PURE__*/ (0, $eUqFw.memo)($583554ad55c67aee$var$StatusField);
// There's a chance that the margin won't apply to the component properly without an anchor container here because the async component is quickly switching on mouse hover
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $583554ad55c67aee$var$StatusLozengeWrapperControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "micses-0"
})`position:relative;align-items:center;& > div{&:first-of-type{display:grid;align-items:center;height:${()=>(0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') ? undefined : '20px'};justify-items:start;}& > div{${({ widthMultiplier: widthMultiplier })=>`
                pointer-events: all;
                max-width: ${widthMultiplier * 8}px;
            `}}& > div > button{vertical-align:${()=>(0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') ? 'top !important' // not perfectly vertically centered without this
     : undefined};}&:nth-of-type(2){position:absolute !important;top:${"var(--ds-space-300, 24px)"} !important;right:${"var(--ds-space-negative-025, -2px)"} !important;bottom:auto !important;left:auto !important;transform:none !important;will-change:auto !important;div[id^='react-select'] span{white-space:nowrap;}}}`;
// NOTE: The div is needed here because StatusLozenge is an async component and
// we use a universal selector hack in the styling.
//
// There's a chance that the margin won't apply to the component properly
// without an anchor container here because the async component is quickly
// switching on mouse hover
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $583554ad55c67aee$var$StatusLozengeWrapperExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { widthMultiplier: widthMultiplier, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_hikewg": (0, $9t7rW.default)(__cmplp.widthMultiplier * 8, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _4cvr1h6o _rcmc11p5 _1i661h6o _5th9v2br _9u161rj4 _1d7y1ljj _bvcr7079 _1sgz1wje _es1l1prr _1o3v1h90 _ewzg1h90 _1dg1agmp _132g1h90 _1v5x1q9c",
            !(0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') && "_1b2sgktf",
            (0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') && "_1a191qo1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $583554ad55c67aee$export$653fc70614ecd562 = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $583554ad55c67aee$var$StatusLozengeWrapperExperiment, $583554ad55c67aee$var$StatusLozengeWrapperControl);

});
parcelRegister("6nWxr", function(module, exports) {

$parcel$export(module.exports, "AsyncIssueStatusField", () => $525e34d5896b7f0a$export$ddd324b06f34200);
$parcel$export(module.exports, "IssueStatusFieldBoundary", () => $525e34d5896b7f0a$export$dba9e9c892560f60);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

var $d16Lt = parcelRequire("d16Lt");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $525e34d5896b7f0a$var$AsyncLazyIssueStatusField = (0, $7rh0R.lazy)(()=>(parcelRequire("2bShl")), {
    moduleId: "./src/packages/issue/fields/status/src/ui/main.tsx"
});
const $525e34d5896b7f0a$export$ddd324b06f34200 = (props)=>{
    const { initialValue: initialValue, value: value } = props;
    const errorProps = {
        initialValue: initialValue,
        value: value
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue-field-status",
        packageName: "jira-issue-field-status",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d16Lt.StatusLozengeWithDropdownIndicator), errorProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-status-field",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d16Lt.StatusLozengeWithDropdownIndicator), errorProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($525e34d5896b7f0a$var$AsyncLazyIssueStatusField, props)));
};
const $525e34d5896b7f0a$export$dba9e9c892560f60 = ({ children: children, fallback: fallback, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue-status-field",
        packageName: packageName,
        render: ()=>fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-status-field-boundary",
        fallback: fallback
    }, children));

});
parcelRegister("d16Lt", function(module, exports) {

$parcel$export(module.exports, "StatusLozenge", () => $ff16a2437ea95212$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "StatusLozengeWithDropdownIndicator", () => $ff16a2437ea95212$export$9f5070a985b0679b);

var $eUqFw = parcelRequire("eUqFw");

var $2GJ4g = parcelRequire("2GJ4g");
const $ff16a2437ea95212$export$f72db4ad1e9b3e6d = (props)=>{
    const status = props.value || props.initialValue;
    if (!status) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GJ4g.WrappedStatusLozenge), {
        status: status,
        isEditable: false,
        hasHoverState: false,
        focused: false
    });
};
const $ff16a2437ea95212$export$9f5070a985b0679b = (props)=>{
    const status = props.value || props.initialValue;
    if (!status) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GJ4g.WrappedStatusLozenge), {
        status: status,
        isEditable: false,
        hasHoverState: false,
        focused: false,
        shouldShowDropdownIndication: true
    });
};

});
parcelRegister("2GJ4g", function(module, exports) {

$parcel$export(module.exports, "TEST_ID_PREFIX", () => $0211a3ed28924b4c$export$9cbc201c09a37b3f);
$parcel$export(module.exports, "StatusLozenge", () => $0211a3ed28924b4c$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "WrappedStatusLozenge", () => $0211a3ed28924b4c$export$69ea4907eefa8e7b);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $bbaTG = parcelRequire("bbaTG");

var $2ziLQ = parcelRequire("2ziLQ");

var $PdmhA = parcelRequire("PdmhA");

var $bR5MV = parcelRequire("bR5MV");

var $iccsh = parcelRequire("iccsh");

var $a8LdG = parcelRequire("a8LdG");
const $0211a3ed28924b4c$export$9cbc201c09a37b3f = 'issue.fields.status.common.ui.status-lozenge.';
const $0211a3ed28924b4c$var$CustomChevronDownGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: 12,
        height: 12,
        viewBox: "5 5 13 13"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $0211a3ed28924b4c$var$EditableLozenge = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a8LdG.Lozenge), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0211a3ed28924b4c$var$StyledLozengeContentWrapper, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $0211a3ed28924b4c$var$CustomChevronDownGlyph,
        label: ""
    })));
const $0211a3ed28924b4c$export$f72db4ad1e9b3e6d = ({ status: { name: name, statusCategory: statusCategory }, isEditable: isEditable, hasHoverState: hasHoverState, targetRef: targetRef, shouldShowDropdownIndication: shouldShowDropdownIndication, isDisabled: isDisabled = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0211a3ed28924b4c$var$StyledLozenge, {
        hasHoverState: hasHoverState,
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0211a3ed28924b4c$var$StatusContentWrapper, {
        ref: targetRef,
        "data-testid": `${$0211a3ed28924b4c$export$9cbc201c09a37b3f}${statusCategory.id}`
    }, isEditable === true || shouldShowDropdownIndication === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0211a3ed28924b4c$var$EditableLozenge, null, name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a8LdG.Lozenge), null, name)));
const $0211a3ed28924b4c$export$69ea4907eefa8e7b = (props)=>{
    const { ariaLabel: ariaLabel, error: error, isEditable: isEditable, isOpen: isOpen, targetRef: targetRef, ...other } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        ref: targetRef,
        appearance: "subtle",
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        theme: (currentTheme, themeProps)=>{
            const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    backgroundColor: 'transparent',
                    margin: 0,
                    width: 'auto',
                    height: 'auto',
                    padding: 0,
                    border: `2px solid ${error ? `var(--ds-border-danger, ${(0, $PdmhA).R300})` : 'transparent'}`,
                    borderRadius: '5px',
                    ...isEditable === true ? undefined : {
                        cursor: 'auto'
                    },
                    outline: 0,
                    boxShadow: `0 0 0 2px ${isOpen === true ? `var(--ds-border-focused, ${(0, $PdmhA).B200})` : 'transparent'}`,
                    '& > span': {
                        margin: 0
                    },
                    '&:focus, &:focus-within': {
                        boxShadow: `0 0 0 2px ${`var(--ds-border-focused, ${(0, $PdmhA).B200})`}`
                    }
                },
                spinnerStyles: spinnerStyles
            };
        },
        interactionName: "auto-generated.jira-issue-field-status.common.ui.status-lozenge.button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0211a3ed28924b4c$export$f72db4ad1e9b3e6d, {
        ...other,
        isEditable: isEditable
    }));
};
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0211a3ed28924b4c$var$StyledLozenge = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "wv585u-0"
})`display:flex;align-items:center;> div{display:flex;line-height:initial;outline:0;> span{padding:${"var(--ds-space-025, 2px)"} 0;vertical-align:text-bottom;color:${(props)=>props.isDisabled ? (0, $bR5MV.disabledColor).text : (0, $bR5MV.textColor)[(0, $bR5MV.statusCategoryToThemeMap)[props.statusCategoryId]]};background-color:${(props)=>props.isDisabled ? (0, $bR5MV.disabledColor).bg : (0, $bR5MV.bgColor)[(0, $bR5MV.statusCategoryToThemeMap)[props.statusCategoryId]]};${(props)=>props.hasHoverState ? `&:hover {
                        color: ${props.isDisabled ? (0, $bR5MV.disabledColor).text : (0, $bR5MV.textHoverColor)[(0, $bR5MV.statusCategoryToThemeMap)[props.statusCategoryId]]};
                        background-color: ${props.isDisabled ? (0, $bR5MV.disabledColor).bg : (0, $bR5MV.bgHoverColor)[(0, $bR5MV.statusCategoryToThemeMap)[props.statusCategoryId]]};
                    }` : ''};${(props)=>props.isDisabled && (0, $kwce8.css)({
        pointerEvents: 'none'
    })}}}`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0211a3ed28924b4c$var$StyledLozengeContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o",
            (0, $iccsh.isTabularGridFieldsEnabled)() ? "_1e0c1bgi" : "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0211a3ed28924b4c$var$StatusContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            (0, $iccsh.isTabularGridFieldsEnabled)() ? "_1bsb1osq" : "_1bsb1wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bR5MV", function(module, exports) {

$parcel$export(module.exports, "STATUS_THEME_DEFAULT", () => $0bd810462bafa4a2$export$61137dce61763ec3);
$parcel$export(module.exports, "STATUS_THEME_SUCCESS", () => $0bd810462bafa4a2$export$132676d06d92ad48);
$parcel$export(module.exports, "STATUS_THEME_IN_PROGRESS", () => $0bd810462bafa4a2$export$5c1f3b72419aa125);
$parcel$export(module.exports, "statusCategoryToThemeMap", () => $0bd810462bafa4a2$export$d9e35f42afe1e488);
$parcel$export(module.exports, "bgColor", () => $0bd810462bafa4a2$export$7dcbec377a25efc6);
$parcel$export(module.exports, "textColor", () => $0bd810462bafa4a2$export$32f78bffcd82ff28);
$parcel$export(module.exports, "bgHoverColor", () => $0bd810462bafa4a2$export$69fdf3ba928b4c77);
$parcel$export(module.exports, "textHoverColor", () => $0bd810462bafa4a2$export$99ec0cf2cf1b2082);
$parcel$export(module.exports, "disabledColor", () => $0bd810462bafa4a2$export$b70f10fc4a6ba453);

var $PdmhA = parcelRequire("PdmhA");
const $0bd810462bafa4a2$export$61137dce61763ec3 = 'default';
const $0bd810462bafa4a2$export$132676d06d92ad48 = 'success';
const $0bd810462bafa4a2$export$5c1f3b72419aa125 = 'inprogress';
const $0bd810462bafa4a2$export$d9e35f42afe1e488 = {
    '1': $0bd810462bafa4a2$export$61137dce61763ec3,
    '2': $0bd810462bafa4a2$export$61137dce61763ec3,
    '3': $0bd810462bafa4a2$export$132676d06d92ad48,
    '4': $0bd810462bafa4a2$export$5c1f3b72419aa125
};
const $0bd810462bafa4a2$export$7dcbec377a25efc6 = {
    [$0bd810462bafa4a2$export$61137dce61763ec3]: `var(--ds-background-neutral, ${(0, $PdmhA.N40)})`,
    [$0bd810462bafa4a2$export$132676d06d92ad48]: `var(--ds-background-success, ${(0, $PdmhA.G50)})`,
    [$0bd810462bafa4a2$export$5c1f3b72419aa125]: `var(--ds-background-information, ${(0, $PdmhA.B50)})`
};
const $0bd810462bafa4a2$export$32f78bffcd82ff28 = {
    [$0bd810462bafa4a2$export$61137dce61763ec3]: `var(--ds-text, ${(0, $PdmhA.N500)})`,
    [$0bd810462bafa4a2$export$132676d06d92ad48]: `var(--ds-text-success, ${(0, $PdmhA.G500)})`,
    [$0bd810462bafa4a2$export$5c1f3b72419aa125]: `var(--ds-text-information, ${(0, $PdmhA.B500)})`
};
const $0bd810462bafa4a2$export$69fdf3ba928b4c77 = {
    [$0bd810462bafa4a2$export$61137dce61763ec3]: `var(--ds-background-neutral-hovered, ${(0, $PdmhA.N70)})`,
    [$0bd810462bafa4a2$export$132676d06d92ad48]: `var(--ds-background-success-hovered, ${(0, $PdmhA.G400)})`,
    [$0bd810462bafa4a2$export$5c1f3b72419aa125]: `var(--ds-background-information-hovered, ${(0, $PdmhA.B400)})`
};
const $0bd810462bafa4a2$export$99ec0cf2cf1b2082 = {
    [$0bd810462bafa4a2$export$61137dce61763ec3]: `var(--ds-text, ${(0, $PdmhA.N800)})`,
    [$0bd810462bafa4a2$export$132676d06d92ad48]: `var(--ds-text-success, ${(0, $PdmhA.N0)})`,
    [$0bd810462bafa4a2$export$5c1f3b72419aa125]: `var(--ds-text-information, ${(0, $PdmhA.N0)})`
};
const $0bd810462bafa4a2$export$b70f10fc4a6ba453 = {
    bg: `var(--ds-background-neutral, ${(0, $PdmhA.N40)})`,
    text: `var(--ds-text-disabled, ${(0, $PdmhA.N200)})`
};

});

parcelRegister("iccsh", function(module, exports) {

$parcel$export(module.exports, "isTabularGridFieldsEnabled", () => $96fedf0b1762860e$export$9605b1d5fe0c238b);
$parcel$export(module.exports, "isWorkflowDataServiceHookEnabled", () => $96fedf0b1762860e$export$60184d6d974595a9);

var $1ybV0 = parcelRequire("1ybV0");
const $96fedf0b1762860e$export$455240e4be839479 = 'jsw.uif.tmp.card.tabular.grid';
const $96fedf0b1762860e$export$9605b1d5fe0c238b = ()=>(0, $1ybV0.ff)($96fedf0b1762860e$export$455240e4be839479, false);
const $96fedf0b1762860e$export$60184d6d974595a9 = ()=>(0, $1ybV0.ff)('use-view-workflow-service-hook_8y6bk', false); // </bento>

});

parcelRegister("a8LdG", function(module, exports) {

$parcel$export(module.exports, "Lozenge", () => $c24adb58350b577e$export$a31cbe1bf5463979);

var $eUqFw = parcelRequire("eUqFw");

var $c9TLT = parcelRequire("c9TLT");

var $1ybV0 = parcelRequire("1ybV0");
const $c24adb58350b577e$var$containerStylesNew = {
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    display: 'inline-block',
    // Hardcoded font size and line height to match @atlaskit/lozenge. This may change in the future due to ADS design decisions
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: '11px',
    lineHeight: '16px',
    fontWeight: "var(--ds-font-weight-bold, 700)",
    maxWidth: '100%',
    padding: 0,
    textTransform: 'uppercase',
    verticalAlign: 'top'
};
const $c24adb58350b577e$var$containerStylesOld = {
    borderRadius: $c9TLT.borderRadius,
    boxSizing: 'border-box',
    display: 'inline-block',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: '11px',
    fontWeight: 700,
    lineHeight: 1,
    maxWidth: '100%',
    padding: `${"var(--ds-space-025, 2px)"} 0`,
    textTransform: 'uppercase',
    verticalAlign: 'baseline'
};
const $c24adb58350b577e$var$contentStyles = {
    boxSizing: 'border-box',
    display: 'inline-block',
    maxWidth: 200,
    overflow: 'hidden',
    padding: `0 ${"var(--ds-space-050, 4px)"}`,
    textOverflow: 'ellipsis',
    verticalAlign: 'top',
    whiteSpace: 'nowrap',
    width: '100%'
};
const $c24adb58350b577e$export$a31cbe1bf5463979 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: (0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') ? $c24adb58350b577e$var$containerStylesNew : $c24adb58350b577e$var$containerStylesOld
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: $c24adb58350b577e$var$contentStyles
    }, children));
$c24adb58350b577e$export$a31cbe1bf5463979.displayName = 'Lozenge';

});



parcelRegister("2bShl", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('k03Ss')
        ]);
        const value = parcelRequire('lpHr5');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("k03Ss")
    ]).then(()=>parcelRequire('lpHr5'));
}

});


parcelRegister("gyxA6", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('aAnTw')
        ]);
        const value = parcelRequire('g2Yce');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("aAnTw")
    ]).then(()=>parcelRequire('g2Yce'));
}

});



parcelRegister("h0mW9", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f2d532184bbd9f2$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $kwce8 = parcelRequire("kwce8");

var $ldoFd = parcelRequire("ldoFd");

var $7rh0R = parcelRequire("7rh0R");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kmr29 = parcelRequire("kmr29");

var $8Bn0M = parcelRequire("8Bn0M");


var $hJ1SV = parcelRequire("hJ1SV");
var $hWeBz = parcelRequire("hWeBz");

var $5JDKI = parcelRequire("5JDKI");

var $87GQt = parcelRequire("87GQt");

var $8WuJm = parcelRequire("8WuJm");

var $6bYiA = parcelRequire("6bYiA");

var $ba1Xy = parcelRequire("ba1Xy");


var $8wXFi = parcelRequire("8wXFi");

var $7TyGu = parcelRequire("7TyGu");

var $eKS1U = parcelRequire("eKS1U");

var $1gQ73 = parcelRequire("1gQ73");

var $6iBIZ = parcelRequire("6iBIZ");

var $bP7Jx = parcelRequire("bP7Jx");

var $j258X = parcelRequire("j258X");

var $diedG = parcelRequire("diedG");

var $dU01J = parcelRequire("dU01J");

var $5WFzC = parcelRequire("5WFzC");

var $dNKdc = parcelRequire("dNKdc");

var $kLeWy = parcelRequire("kLeWy");

const $6f2d532184bbd9f2$export$88b57365e3a3cb92 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("1Vqi3")), {
    moduleId: "./src/packages/issue/fields/number/src/index.tsx"
});
const $6f2d532184bbd9f2$var$StoryPointField = ({ issueKey: issueKey, storyPointFieldId: storyPointFieldId, estimationType: estimationType, issueId: issueId, isUserAtLeastMember: isUserAtLeastMember, shouldRenderRichCard: shouldRenderRichCard, shouldRenderStoryPointColumn: shouldRenderStoryPointColumn })=>{
    const isCompanyManaged = (0, $j258X.useIsCMPBacklog)();
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, $5JgJ2.default)();
    const [isEditing, setIsEditing] = (0, $eUqFw.useState)(false);
    const [_, { triggerEpicPanelRefetch: triggerEpicPanelRefetch }] = (0, $ba1Xy.useShouldRefetchEpicPanel)();
    const storyPointKey = storyPointFieldId || '';
    const [storyPointFieldValue] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: storyPointKey
    });
    const ariaLabelWithValue = `${formatMessage((0, $dU01J.default).storyPointsAriaLabel)}: ${storyPointFieldValue ? formatNumber(storyPointFieldValue) : formatMessage((0, $dU01J.default).storyPointsAriaLabelNullValue)}`; // I think this is more correct since hasEstimate only checks THIS issue but there could be
    // other issues on the backlog that do have estimates. That will mess up the layout
    // and shift all the content slightly across to make space for the story point field
    const shouldRenderEstimatesColumn = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.backlogHasEstimates));
    const hasEstimate = (0, $1gQ73.useBacklogSelector)((state)=>!!(0, $bP7Jx.getCards)(state)[String(issueId)]?.estimate);
    const saveCompanyManaged = (0, $eUqFw.useCallback)((iKey, fieldKey, newValue, baseURL)=>(0, $8Bn0M.saveField)(String(issueId), fieldKey, newValue, baseURL), [
        issueId
    ]);
    const handleEdit = (0, $eUqFw.useCallback)(()=>{
        setIsEditing(true);
    }, [
        setIsEditing
    ]);
    const handleConfirm = (0, $eUqFw.useCallback)(()=>{
        (0, $eKS1U.setInlineEditStoryPointInteractionStartMark)();
        setIsEditing(false);
    }, []);
    const handleUpdate = (0, $eUqFw.useCallback)(()=>{
        (0, $eKS1U.setInlineEditStoryPointInteractionStopMark)(isCompanyManaged);
        dispatch((0, $6iBIZ.refetchVersions)());
        if (isCompanyManaged) triggerEpicPanelRefetch();
        setIsEditing(false);
    }, [
        dispatch,
        isCompanyManaged,
        triggerEpicPanelRefetch
    ]);
    const handleFailure = (0, $eUqFw.useCallback)(()=>{
        (0, $eKS1U.cancelInlineEditStoryPointInteractionMark)();
        setIsEditing(false);
    }, []);
    const handleCancel = (0, $eUqFw.useCallback)(()=>{
        (0, $eKS1U.cancelInlineEditStoryPointInteractionMark)();
        setIsEditing(false);
    }, [
        setIsEditing
    ]); // inline this when cleaning up sea-2524-backlog-card-estimates-a11y-improvements_1ljqi
    const getTooltipPosition = (0, $eUqFw.useCallback)(()=>{
        if (!(0, $1ybV0.ff)('sea-2524-backlog-card-estimates-a11y-improvements_1ljqi')) return undefined;
        return isEditing ? 'top' : 'bottom';
    }, [
        isEditing
    ]);
    if (!shouldRenderStoryPointColumn && (!storyPointKey || estimationType !== (0, $7TyGu.STORY_POINTS) || shouldRenderEstimatesColumn)) return null;
    const isStoryPointAccessible = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(storyPointFieldValue);
    const NumberFieldBoundary = (0, $8wXFi.isNewInlineEditEstimateComponentsEnabled)() ? (0, $hWeBz.NumberInlineEditErrorBoundary) : (0, $87GQt.IssueNumberFieldBoundary);
    const NumberFieldInlineEdit = (0, $8wXFi.isNewInlineEditEstimateComponentsEnabled)() ? (0, $hJ1SV.AsyncLazyNumberFieldInlineEdit) : $6f2d532184bbd9f2$export$88b57365e3a3cb92;
    const issueStoryPointFieldStatic = (0, $8wXFi.isNewInlineEditEstimateComponentsEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dNKdc.default), {
        tooltipLabel: formatMessage((0, $dU01J.default).storyPointsTooltip),
        ariaLabel: ariaLabelWithValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5JDKI.NumberReadView), {
        isEditable: false,
        value: storyPointFieldValue
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kLeWy.default), {
        value: storyPointFieldValue ?? undefined,
        hasStoryPoints: hasEstimate,
        shouldRenderStoryPointColumn: shouldRenderStoryPointColumn
    });
    const renderStorypointField = ()=>{
        // We should always render the container otherwise the layout gets all messed up
        if ((0, $1ybV0.ff)('sea-2524-backlog-card-estimates-a11y-improvements_1ljqi')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f2d532184bbd9f2$var$StoryPointFieldWrapper, {
            shouldRenderStoryPointColumn: shouldRenderStoryPointColumn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dNKdc.default), {
            tooltipLabel: formatMessage((0, $dU01J.default).storyPointsTooltip),
            ariaLabel: ariaLabelWithValue,
            tooltipPosition: getTooltipPosition()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f2d532184bbd9f2$var$StoryPointFieldContainer, {
            hasValue: isStoryPointAccessible
        }, hasEstimate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(NumberFieldInlineEdit, {
            issueKey: issueKey,
            fieldKey: storyPointKey,
            fieldFocusStyle: (0, $ada2d6cf4ae575cf$export$44f42916442b37c3),
            fieldEditStyle: (0, $ada2d6cf4ae575cf$export$1ff9623b26415f8),
            onEdit: handleEdit,
            onUpdate: handleUpdate,
            onConfirm: handleConfirm,
            onFailure: handleFailure,
            onCancel: handleCancel,
            saveField: isCompanyManaged ? saveCompanyManaged : undefined
        }))));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f2d532184bbd9f2$var$StoryPointFieldWrapper, {
            shouldRenderStoryPointColumn: shouldRenderStoryPointColumn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f2d532184bbd9f2$var$StoryPointFieldContainer, {
            hasValue: isStoryPointAccessible
        }, hasEstimate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(NumberFieldInlineEdit, {
            issueKey: issueKey,
            fieldKey: storyPointKey,
            fieldFocusStyle: (0, $ada2d6cf4ae575cf$export$44f42916442b37c3),
            fieldEditStyle: (0, $ada2d6cf4ae575cf$export$1ff9623b26415f8),
            onUpdate: handleUpdate,
            onConfirm: handleConfirm,
            onFailure: handleFailure,
            saveField: isCompanyManaged ? saveCompanyManaged : undefined
        })));
    };
    if (isUserAtLeastMember && shouldRenderRichCard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(NumberFieldBoundary, {
        packageName: (0, $e1409a6fc345c0d8$export$dfd208682d29484c),
        fallback: issueStoryPointFieldStatic
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $diedG.default), {
        experienceTarget: "inline story point",
        experienceTargetId: issueKey,
        additionalAttributes: {
            issueKey: issueKey
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: {
            fieldName: (0, $6bYiA.STORY_POINT_ESTIMATE_CF_ANALYTIC_TYPE)
        }
    }, renderStorypointField())));
    return issueStoryPointFieldStatic;
};
var $6f2d532184bbd9f2$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($6f2d532184bbd9f2$var$StoryPointField);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f2d532184bbd9f2$var$StoryPointFieldContainerControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "bl4025-0"
})`cursor:default;${()=>(0, $8wXFi.isBacklogCardEstimatesA11yImprovementsEnabled)() && 'display: flex;'} &:focus,&:focus-within{outline:none;}button[aria-label='Edit']:focus + div{${()=>(0, $8wXFi.isBacklogCardEstimatesA11yImprovementsEnabled)() && (0, $8wXFi.isNewInlineEditEstimateComponentsEnabled)() && 'border-color: transparent;'}}${(0, $5WFzC.CardContainerControl)}:hover &,${(0, $5WFzC.CardContainerControl)}:active &,${(0, $5WFzC.CardContainerControl)}:focus &,${(0, $5WFzC.CardContainerControl)}:focus-within &{position:inherit;opacity:inherit;pointer-events:inherit;}*{display:flex;&:empty{box-shadow:none;}}& > div > div{margin-left:0;&[data-component-selector='jira-issue-field-inline-edit-readonly-view-container']{margin:${()=>(0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') ? `${"var(--ds-space-100, 8px)"} 0 0 0` : undefined};}& > div > div{display:flex;}}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $6f2d532184bbd9f2$var$StoryPointFieldContainerExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xmq675": (0, $9t7rW.default)((0, $8wXFi.isBacklogCardEstimatesA11yImprovementsEnabled)() && 'flex'),
            "--_1eli9yb": (0, $9t7rW.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $8wXFi.isBacklogCardEstimatesA11yImprovementsEnabled)() && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $8wXFi.isNewInlineEditEstimateComponentsEnabled)() && 'transparent')
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_80om73ad _1e0c13wj _rxafnmwm _18kq1kw7 _1jsw1kw7 _3p7d1kw7 _j88e1kw7 _1ksg1kw7 _zpal1kw7 _wnsb1kw7 _bwtn1kw7 _wlgl1kw7 _1n6k1kw7 _tq0k1kw7 _xzt01kw7 _13g31txw _y5xnglyw _1la1idpf _18vj1txw _nt751r31 _1guj1r31 _49pcglyw _pbhaglyw _1hvw1o36 _11ow1o36",
            (0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') && "_9v95v0yc",
            __cmplp.className
        ])
    });
});
const $6f2d532184bbd9f2$var$StoryPointFieldContainer = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $6f2d532184bbd9f2$var$StoryPointFieldContainerExperiment, $6f2d532184bbd9f2$var$StoryPointFieldContainerControl); // empty column for the cards that without storyPoint
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f2d532184bbd9f2$var$StoryPointFieldWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldRenderStoryPointColumn: shouldRenderStoryPointColumn, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.shouldRenderStoryPointColumn && "_1ul91shb _p12f1shb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8Bn0M", function(module, exports) {

$parcel$export(module.exports, "saveField", () => $462f30fdfe9ba1ca$export$72a8b15fb4557735);
$parcel$export(module.exports, "useClassicStoryPointField", () => $462f30fdfe9ba1ca$export$aa8e8a51326640a2);

var $illlw = parcelRequire("illlw");

var $53ciZ = parcelRequire("53ciZ");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $5zSUY = parcelRequire("5zSUY");

var $6vrw7 = parcelRequire("6vrw7");
const $462f30fdfe9ba1ca$export$72a8b15fb4557735 = async (issueId, fieldKey, newValue, baseUrl)=>(0, $lRmyA.performPostRequest)(`${baseUrl}/secure/AjaxIssueAction.jspa?decorator=none`, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: (0, $53ciZ.stringify)({
            [fieldKey]: newValue,
            issueId: issueId,
            skipScreenCheck: true,
            atl_token: (0, $5zSUY.default)(),
            singleFieldEdit: true
        })
    });
const $462f30fdfe9ba1ca$export$aa8e8a51326640a2 = ({ issueKey: issueKey, issueId: issueId, fieldKey: fieldKey, onSuccess: onSuccess })=>{
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', 'number');
    const saveClassicField = (_issueKey, _fieldKey, newValue, baseUrl)=>$462f30fdfe9ba1ca$export$72a8b15fb4557735((0, $6vrw7.toIssueKey)(issueId.toString()), fieldKey, newValue, baseUrl);
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        saveField: saveClassicField,
        onSuccess: onSuccess,
        ...(0, $1ybV0.ff)('issue.detail.issue-view-story-point-field-type-analytics_n9ha6') ? {
            analyticsFieldTypeAlias: 'classicstorypoint'
        } : {}
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});
parcelRegister("gGiWF", function(module, exports) {

$parcel$export(module.exports, "useEditField", () => $04407df9ae6d3d74$export$343e962d356c0af1);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5oStv = parcelRequire("5oStv");

var $5oStv = parcelRequire("5oStv");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $JRB5w = parcelRequire("JRB5w");

var $7byHA = parcelRequire("7byHA");

var $hJ992 = parcelRequire("hJ992");

var $8wbQu = parcelRequire("8wbQu");

var $7eDnP = parcelRequire("7eDnP");

var $8p8vy = parcelRequire("8p8vy");

var $3koWU = parcelRequire("3koWU");

var $jMP2a = parcelRequire("jMP2a");

var $kmr29 = parcelRequire("kmr29");

var $fecbI = parcelRequire("fecbI");
/**
 * Some responses contain `fields` property without `fieldKey`.
 * We must avoid changing the state of this fields by checking `fieldKey` property in the `fields`.
 * @param response
 * @param fieldKey
 */ const $04407df9ae6d3d74$var$getFieldValue = (response, fieldKey)=>{
    if (!response) return null;
    if (response.fields) {
        if (Object.hasOwnProperty.call(response.fields, fieldKey)) return response.fields[fieldKey];
        return null;
    }
    return response;
};
const $04407df9ae6d3d74$var$shouldCallSetFieldValue = (response, fieldKey)=>{
    if (!response) return false;
    if (response.fields) return !!Object.hasOwnProperty.call(response.fields, fieldKey);
    return true;
};
const $04407df9ae6d3d74$export$3796d3fdbc2e6b54 = (fieldOptions)=>{
    // di-ignore - Please fix parent-switcher examples
    const baseUrl = '';
    const { issueKey: issueKey, issueId: issueId, fieldKey: fieldKey, fieldType: fieldType, initialValue: initialValue, analyticsFieldKeyAlias: analyticsFieldKeyAlias, analyticsFieldTypeAlias: analyticsFieldTypeAlias, mapNonOptimisticResponse: mapNonOptimisticResponse = $04407df9ae6d3d74$var$getFieldValue, saveField: saveField = (0, $fecbI.defaultSaveField), saveFieldById: saveFieldById = (0, $fecbI.defaultSaveFieldById), addValuesToField: addValuesToField = (0, $fecbI.defaultAddValuesToField), removeValuesFromField: removeValuesFromField = (0, $fecbI.defaultRemoveValuesFromField), onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) } = fieldOptions;
    // We need to track the mounted state as it is possible that a component
    // using this hook can be unmounted before the async edit operation is completed.
    // Causing a react warning about setting state on an unmounted component.
    const isMounted = (0, $3koWU.useIsMounted)();
    const [fieldPersistedValue, { setFieldValue: setFieldValue }] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const fieldValue = fieldPersistedValue !== undefined ? fieldPersistedValue : initialValue;
    const [error, setError] = (0, $eUqFw.useState)(null);
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const resetError = (0, $eUqFw.useCallback)(()=>{
        if (isMounted.current) setError(null);
    }, [
        setError,
        isMounted
    ]);
    const editFieldValue = (0, $eUqFw.useCallback)(async (editOperation, editOperationType, valuesForOperation, valuesForUI, meta, analyticsEvent, options = {
        isOptimistic: true
    })=>{
        let result;
        const analyticsData = {
            editOperationType: editOperationType,
            issueId: issueId,
            fieldKey: analyticsFieldKeyAlias ?? fieldKey,
            fieldType: analyticsFieldTypeAlias ?? fieldType
        };
        if (isMounted.current) {
            setLoading(true);
            setError(null);
        }
        try {
            onSubmit(fieldValue, valuesForOperation, meta, analyticsEvent);
            if (options.isOptimistic) setFieldValue(issueKey, fieldKey, valuesForUI);
            result = await editOperation(issueKey, fieldKey, valuesForOperation, baseUrl, meta);
            const fieldValueResponse = mapNonOptimisticResponse(result, fieldKey);
            $04407df9ae6d3d74$var$shouldCallSetFieldValue(result, fieldKey) && setFieldValue(issueKey, fieldKey, fieldValueResponse);
            if ((0, $1ybV0.ff)('ui-modifications-issue-view-status-custom-field-support_hwx15')) onSuccess(fieldValueResponse ?? valuesForOperation, analyticsEvent, meta);
            else onSuccess(fieldValueResponse ?? valuesForOperation, analyticsEvent);
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'field updated', analyticsData);
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'field updateSucceeded', analyticsData);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (ex) {
            result = Promise.reject(ex);
            onFailure(ex, valuesForOperation);
            setFieldValue(issueKey, fieldKey, fieldValue);
            if (isMounted.current) setError(ex);
            const isValidationError = ex instanceof (0, $7byHA.ValidationError);
            if (!isValidationError) (0, $gUUjF.default).safeErrorWithoutCustomerData('issue-field.save-value', `Failed to update field ${fieldKey} of type ${fieldType}`, ex);
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'field updateFailed', {
                fieldKey: fieldKey,
                fieldType: (0, $1ybV0.ff)('issue.detail.issue-view-story-point-field-type-analytics_n9ha6') ? analyticsFieldTypeAlias ?? fieldType : fieldType,
                isValidationError: isValidationError,
                isClientFetchError: (0, $JRB5w.isClientFetchError)(ex)
            });
        }
        if (isMounted.current) setLoading(false);
        return result;
    }, [
        issueId,
        analyticsFieldKeyAlias,
        fieldKey,
        analyticsFieldTypeAlias,
        fieldType,
        isMounted,
        onSubmit,
        fieldValue,
        setFieldValue,
        issueKey,
        onSuccess,
        onFailure,
        mapNonOptimisticResponse
    ]);
    const saveValue = (0, $eUqFw.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveField, 'set', newValue, newValue, meta, analyticsEvent), [
        editFieldValue,
        saveField
    ]);
    const saveById = (0, $eUqFw.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveFieldById, 'set', newValue, newValue, meta, analyticsEvent, {
            isOptimistic: false
        }), [
        editFieldValue,
        saveFieldById
    ]);
    const addValues = (0, $eUqFw.useCallback)(async (valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent)=>editFieldValue(addValuesToField, 'add', valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent), [
        editFieldValue,
        addValuesToField
    ]);
    const removeValues = (0, $eUqFw.useCallback)(async (valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent)=>editFieldValue(removeValuesFromField, 'remove', valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent), [
        editFieldValue,
        removeValuesFromField
    ]);
    return [
        {
            value: fieldValue,
            loading: loading,
            error: error
        },
        {
            saveById: saveById,
            saveValue: saveValue,
            addValues: addValues,
            removeValues: removeValues,
            resetError: resetError
        }
    ];
};
const $04407df9ae6d3d74$export$76d937477b5f784a = (issueKey)=>{
    const contextualIssueId = (0, $hJ992.useIssueId)();
    const contextualIssueKey = (0, $hJ992.useIssueKey)();
    return contextualIssueKey === issueKey ? contextualIssueId : null;
};
const $04407df9ae6d3d74$export$343e962d356c0af1 = (fieldOptions)=>{
    const { fieldKey: fieldKey, issueId: issueIdFromFieldOptions, issueKey: issueKey, onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) } = fieldOptions;
    const [, { fieldChanged: fieldChanged, fieldChangeFailed: fieldChangeFailed, fieldChangeRequested: fieldChangeRequested }] = (0, $8p8vy.useIssueViewFieldUpdateEvents)();
    const contextualIssueId = $04407df9ae6d3d74$export$76d937477b5f784a(issueKey);
    const issueId = issueIdFromFieldOptions ?? contextualIssueId;
    const isEditFromIssueView = (0, $8wbQu.useIsEditFromIssueView);
    const onSubmitFn = (0, $eUqFw.useCallback)((oldValue, newValue, meta, event)=>{
        onSubmit(oldValue, newValue, meta, event);
        issueId && fieldChangeRequested(issueId, fieldKey, newValue, meta);
    }, [
        fieldChangeRequested,
        fieldKey,
        issueId,
        onSubmit
    ]);
    const onSuccessFn = (0, $eUqFw.useCallback)(// Remove optional from meta with `ui-modifications-issue-view-status-custom-field-support_hwx15` FF clean up
    async (fieldValue, event, meta)=>{
        onSuccess(fieldValue);
        if ((0, $1ybV0.ff)('ui-modifications-issue-view-status-custom-field-support_hwx15')) issueId && fieldChanged(issueId, fieldKey, fieldValue, undefined, meta);
        else issueId && fieldChanged(issueId, fieldKey, fieldValue);
        if (!isEditFromIssueView(event)) try {
            const reason = (0, $7eDnP.Reason).SoftRefresh;
            (0, $1ybV0.ff)('relay-migration-issue-fields-soft-refresh-ld') ? await (0, $5oStv.default).refreshIssuePageThrowable(issueKey, reason) : await (0, $5oStv.default).refreshIssuePageThrowable(issueKey, reason);
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.fields.use-edit-field.refresh', error instanceof Error ? error.message : 'useEditField issue refresh failed');
        }
    }, [
        fieldChanged,
        fieldKey,
        isEditFromIssueView,
        issueId,
        issueKey,
        onSuccess
    ]);
    const onFailureFn = (0, $eUqFw.useCallback)((error, failedValue)=>{
        onFailure(error, failedValue);
        issueId && fieldChangeFailed(issueId, fieldKey);
    }, [
        fieldChangeFailed,
        fieldKey,
        issueId,
        onFailure
    ]);
    return $04407df9ae6d3d74$export$3796d3fdbc2e6b54({
        ...fieldOptions,
        onSubmit: onSubmitFn,
        onSuccess: onSuccessFn,
        onFailure: onFailureFn
    });
};

});
parcelRegister("5oStv", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdea36b35279d86d$export$2e2bcd8739ae039);

var $7eDnP = parcelRequire("7eDnP");
const $bdea36b35279d86d$var$REFRESH_ISSUE_PAGE_EVENT = 'legacy_refreshIssuePage';
const $bdea36b35279d86d$var$UPDATE_ISSUE_GLANCE_EVENT = 'legacy_updateIssueGlance';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$addEventListener = (event, callback)=>{
    document.addEventListener(event, callback);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$removeEventListener = (event, callback)=>{
    document.removeEventListener(event, callback);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$addRefreshIssueListener = (callback)=>$bdea36b35279d86d$var$addEventListener($bdea36b35279d86d$var$REFRESH_ISSUE_PAGE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$removeRefreshIssueListener = (callback)=>$bdea36b35279d86d$var$removeEventListener($bdea36b35279d86d$var$REFRESH_ISSUE_PAGE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$addUpdateIssueGlanceListener = (callback)=>$bdea36b35279d86d$var$addEventListener($bdea36b35279d86d$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$removeUpdateIssueGlanceListener = (callback)=>$bdea36b35279d86d$var$removeEventListener($bdea36b35279d86d$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
const $bdea36b35279d86d$var$refreshIssuePageThrowable = (issueKey, reason = (0, $7eDnP.Reason).OnDemand)=>{
    try {
        document.dispatchEvent(new CustomEvent($bdea36b35279d86d$var$REFRESH_ISSUE_PAGE_EVENT, {
            detail: [
                issueKey,
                {
                    mergeIntoCurrent: false,
                    reason: reason
                }
            ]
        }));
        return Promise.resolve();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return Promise.reject(e);
    }
};
const $bdea36b35279d86d$var$refreshIssuePage = (issueKey)=>// Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    $bdea36b35279d86d$var$refreshIssuePageThrowable(issueKey).catch(()=>{});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bdea36b35279d86d$export$2e2bcd8739ae039 = {
    addRefreshIssueListener: $bdea36b35279d86d$var$addRefreshIssueListener,
    removeRefreshIssueListener: $bdea36b35279d86d$var$removeRefreshIssueListener,
    addUpdateIssueGlanceListener: $bdea36b35279d86d$var$addUpdateIssueGlanceListener,
    removeUpdateIssueGlanceListener: $bdea36b35279d86d$var$removeUpdateIssueGlanceListener,
    refreshIssuePageThrowable: $bdea36b35279d86d$var$refreshIssuePageThrowable,
    refreshIssuePage: $bdea36b35279d86d$var$refreshIssuePage
};

});
parcelRegister("7eDnP", function(module, exports) {

$parcel$export(module.exports, "Reason", () => $501d104507444a18$export$fe867595c4640fb1);
const $501d104507444a18$export$fe867595c4640fb1 = {
    /**
	 * Aka hard refresh, used by Ecosystem apps to refresh issue view on demand
	 * 1) Full issue view refresh
	 * 2) Hard Ecosystem apps refresh (causes remounting of the apps)
	 */ OnDemand: 'ON_DEMAND',
    /**
	 * Used by Jira internally to update issue view on demand without forcing Ecosystem apps to rerender
	 * 1) Full issue view refresh only
	 * 2) Ecosystem app aren't hard refreshed, however, if field's value has changed, Forge custom field will rerender
	 */ SoftRefresh: 'SOFT_REFRESH',
    /**
	 * Issue view refresh caused by Realtime service (Jirt)
	 */ Realtime: 'REALTIME'
};

});


parcelRegister("8wbQu", function(module, exports) {

$parcel$export(module.exports, "useIsEditFromIssueView", () => $e05e50438955dd5a$export$870b996a6c1c7896);

var $hRcYT = parcelRequire("hRcYT");

var $iKlrz = parcelRequire("iKlrz");
const $e05e50438955dd5a$export$870b996a6c1c7896 = (event)=>{
    const ISSUE_VIEW_SOURCES = [
        'fullIssueScreen',
        'boardIssueViewScreen',
        'backlogScreen',
        'agility-backlogScreen',
        'issueNavigatorEmbeddedIssueViewScreen',
        'globalIssueNavigatorIssueScreen',
        'mobileIssueScreen',
        'classicRoadmapScreen',
        'roadmapScreen',
        'versionDetailsIssueScreen',
        'bitbucketIssueScreen',
        'jsmQueueAgentViewSidebarScreen',
        'viewQueueIssueScreen',
        'jswModalIssueAppScreen',
        'jwmModalIssueAppScreen',
        'jswSidebarIssueAppScreen',
        'jwmSidebarIssueAppScreen'
    ];
    const { payload: { source: source } } = (0, $iKlrz.getEvent)(event);
    if (!source) return false;
    if (ISSUE_VIEW_SOURCES.includes(source)) // event originated from issue view location
    return true;
    if (source.startsWith((0, $hRcYT.PACKAGE_NAME_GASV3))) // event originated from forge app, which can only be mounted in issue view for field editing
    return true;
    return false;
};

});

parcelRegister("8p8vy", function(module, exports) {

$parcel$export(module.exports, "useIssueViewFieldUpdateEvents", () => $0829b81e40dd527a$export$444af741f6d8f512);
$parcel$export(module.exports, "IssueViewFieldUpdateEventContainer", () => $0829b81e40dd527a$export$f9eb49cc2f0e28ce);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $1ybV0 = parcelRequire("1ybV0");

var $focHG = parcelRequire("focHG");

var $k3tie = parcelRequire("k3tie");
const $0829b81e40dd527a$var$registerEventHandler = (type, eventHandler)=>({ getState: getState, setState: setState })=>{
        if (typeof eventHandler !== 'function') // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const { eventHandlers: eventHandlers } = getState();
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ onChange: OnChangeHandler[]; }'.
        const typeEventHandlers = eventHandlers[type];
        setState({
            eventHandlers: {
                ...eventHandlers,
                [type]: typeEventHandlers.concat([
                    eventHandler
                ])
            }
        });
        return ()=>{
            const { eventHandlers: eventHandlersForUnregister } = getState();
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ onChange: OnChangeHandler[]; }'.
            const typeEventHandlersForUnregister = eventHandlersForUnregister[type];
            const newTypeEventHandlers = typeEventHandlersForUnregister.filter(// @ts-expect-error - TS7006 - Parameter 'handler' implicitly has an 'any' type.
            (handler)=>handler !== eventHandler);
            setState({
                eventHandlers: {
                    ...eventHandlersForUnregister,
                    [type]: newTypeEventHandlers
                }
            });
        };
    };
const $0829b81e40dd527a$var$fieldChanged = (issueId, fieldId, fieldValue, aggFieldChangeProps, additionalProperties)=>({ getState: getState })=>{
        let value = fieldValue;
        if ((0, $1ybV0.ff)('relay-migration-issue-fields-events-transformer-ld')) {
            if (aggFieldChangeProps) value = (0, $focHG.transformAggToLegacy)({
                fieldValue: fieldValue,
                aggFieldChangeProps: aggFieldChangeProps
            });
        }
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                fieldId: // field id is required to be compatible with v1 onChange API
                fieldId,
                meta: {
                    fieldId: fieldId,
                    fieldValue: value,
                    ...(0, $1ybV0.ff)('ui-modifications-issue-view-status-custom-field-support_hwx15') ? {
                        additionalProperties: additionalProperties
                    } : {}
                },
                type: (0, $k3tie.ChangeEventTypes).FIELD_CHANGED
            });
        });
    };
const $0829b81e40dd527a$var$fieldChangeFailed = (issueId, fieldId)=>({ getState: getState })=>{
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                meta: {
                    fieldId: fieldId
                },
                type: (0, $k3tie.ChangeEventTypes).FIELD_CHANGE_FAILED
            });
        });
    };
const $0829b81e40dd527a$var$fieldChangeRequested = (issueId, fieldId, fieldValue, additionalProperties, aggFieldChangeProps)=>({ getState: getState })=>{
        let value = fieldValue;
        if ((0, $1ybV0.ff)('relay-migration-issue-fields-events-transformer-ld')) {
            if (aggFieldChangeProps) value = (0, $focHG.transformAggToLegacy)({
                fieldValue: fieldValue,
                aggFieldChangeProps: aggFieldChangeProps
            });
        }
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                meta: {
                    fieldId: fieldId,
                    fieldValue: value,
                    additionalProperties: additionalProperties
                },
                type: (0, $k3tie.ChangeEventTypes).FIELD_CHANGE_REQUESTED
            });
        });
    };
const $0829b81e40dd527a$var$actions = {
    fieldChanged: $0829b81e40dd527a$var$fieldChanged,
    fieldChangeFailed: $0829b81e40dd527a$var$fieldChangeFailed,
    fieldChangeRequested: $0829b81e40dd527a$var$fieldChangeRequested,
    registerEventHandler: $0829b81e40dd527a$var$registerEventHandler
};
// this is a global state
const $0829b81e40dd527a$var$store = (0, $a61MH.createStore)({
    name: 'issue-view-field-update-events',
    initialState: {
        eventHandlers: {
            onChange: []
        }
    },
    actions: $0829b81e40dd527a$var$actions
});
const $0829b81e40dd527a$export$444af741f6d8f512 = (0, $ggKAj.createHook)($0829b81e40dd527a$var$store, {
    selector: null
});
const $0829b81e40dd527a$export$f9eb49cc2f0e28ce = (0, $heB5U.createContainer)($0829b81e40dd527a$var$store);

});
parcelRegister("focHG", function(module, exports) {

$parcel$export(module.exports, "transformAggToLegacy", () => $ecb153413af3f22f$export$d951e3c38e10736d);

var $9ax61 = parcelRequire("9ax61");

var $lO4Or = parcelRequire("lO4Or");
const $ecb153413af3f22f$export$d951e3c38e10736d = ({ fieldValue: fieldValue, aggFieldChangeProps: aggFieldChangeProps })=>{
    if (!aggFieldChangeProps?.__typename) throw new Error('node did not have __typename');
    switch(aggFieldChangeProps.__typename){
        // These fields require context for their transform in transformAggFieldToLegacyField so need to be manually implemented
        // This is not an exhaustive list, I did a quick check is all, so best to check the transform works as expected as you migrate fields to relay
        // These are commented out because they are not implemented and due to types can't just be added here until implemented
        // case JSM_PEOPLE_GQL_FIELD:
        // case ISSUE_RESTRICTION_GQL_FIELD:
        // case MULTI_USER_PICKER_GQL_FIELD:
        case 0, $lO4Or.PEOPLE_GQL_FIELD:
            throw new Error('Requires manual implementation as the transformer package require context for this field aka all issue fields');
        // otherwise we can default to the existing package
        case 0, $lO4Or.PRIORITY_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $9ax61.transformAggFieldToLegacyField)({
                [$ecb153413af3f22f$var$getValueKey(aggFieldChangeProps.__typename)]: fieldValue,
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type
            })?.value;
        default:
            throw new Error('__typename not implemented');
    }
};
const $ecb153413af3f22f$var$getValueKey = (__typename)=>{
    const VALUE_KEYS = {
        [(0, $lO4Or.PRIORITY_GQL_FIELD)]: 'priority'
    };
    const value = VALUE_KEYS[__typename];
    if (value) return value;
    throw new Error('Did you forget to implement getValueKey for your field type?');
};

});
parcelRegister("9ax61", function(module, exports) {

$parcel$export(module.exports, "transformAggFieldToLegacyField", () => $85127a55c87acb28$export$586ba15cbf3d3031);
$parcel$export(module.exports, "transformAggFieldsToLegacyFields", () => $85127a55c87acb28$export$ba106ff8c087e6b1);

var $5iWql = parcelRequire("5iWql");

var $lO4Or = parcelRequire("lO4Or");

var $kBgu2 = parcelRequire("kBgu2");

var $blEoo = parcelRequire("blEoo");

var $6Ux91 = parcelRequire("6Ux91");

var $5sNJN = parcelRequire("5sNJN");

var $2wvLE = parcelRequire("2wvLE");

var $8d1m1 = parcelRequire("8d1m1");

var $5CYGa = parcelRequire("5CYGa");

var $9wKha = parcelRequire("9wKha");

var $6PKzm = parcelRequire("6PKzm");

var $jyP56 = parcelRequire("jyP56");

var $epJqO = parcelRequire("epJqO");

var $Pxexr = parcelRequire("Pxexr");

var $beuR4 = parcelRequire("beuR4");

var $d9IUw = parcelRequire("d9IUw");

var $xnQ91 = parcelRequire("xnQ91");

var $jsTfy = parcelRequire("jsTfy");

var $55kng = parcelRequire("55kng");

var $7BRej = parcelRequire("7BRej");

var $04Gbh = parcelRequire("04Gbh");

var $3ZJZc = parcelRequire("3ZJZc");

var $bw8ws = parcelRequire("bw8ws");

var $9vCKL = parcelRequire("9vCKL");

var $i5dch = parcelRequire("i5dch");

var $iJcxE = parcelRequire("iJcxE");

var $djkJh = parcelRequire("djkJh");

var $kbDa2 = parcelRequire("kbDa2");

var $4gy8O = parcelRequire("4gy8O");

var $9w928 = parcelRequire("9w928");

var $3khS7 = parcelRequire("3khS7");

var $c52Z6 = parcelRequire("c52Z6");

var $6IjGS = parcelRequire("6IjGS");

var $eOsdu = parcelRequire("eOsdu");

var $6MxWX = parcelRequire("6MxWX");

var $9myMG = parcelRequire("9myMG");

var $gM34d = parcelRequire("gM34d");

var $16kx8 = parcelRequire("16kx8");

var $4IQ8F = parcelRequire("4IQ8F");

var $lcInz = parcelRequire("lcInz");

var $4PFnn = parcelRequire("4PFnn");

var $alpM1 = parcelRequire("alpM1");

var $l6kyU = parcelRequire("l6kyU");

var $gHd8e = parcelRequire("gHd8e");

var $dUrU1 = parcelRequire("dUrU1");

var $hQM7C = parcelRequire("hQM7C");

var $QjWSM = parcelRequire("QjWSM");

var $4CGp4 = parcelRequire("4CGp4");

var $lWE99 = parcelRequire("lWE99");

var $4eNqf = parcelRequire("4eNqf");

var $fkHM1 = parcelRequire("fkHM1");

var $fkaQR = parcelRequire("fkaQR");

var $ijtj3 = parcelRequire("ijtj3");

var $gyvos = parcelRequire("gyvos");

var $3w75b = parcelRequire("3w75b");

var $lQr58 = parcelRequire("lQr58");

var $8oO4q = parcelRequire("8oO4q");

var $5Ne6t = parcelRequire("5Ne6t");

var $2ETkN = parcelRequire("2ETkN");

var $fz8Wc = parcelRequire("fz8Wc");

var $jBiXV = parcelRequire("jBiXV");

var $1XUHd = parcelRequire("1XUHd");

var $c6LKM = parcelRequire("c6LKM");

var $8zTcQ = parcelRequire("8zTcQ");

var $5W75j = parcelRequire("5W75j");

var $7iFVU = parcelRequire("7iFVU");

var $kyZt3 = parcelRequire("kyZt3");

var $dX2ot = parcelRequire("dX2ot");

var $jhiYN = parcelRequire("jhiYN");

var $1BsAz = parcelRequire("1BsAz");
// We're memoising this just in case we FF another field
const $85127a55c87acb28$var$getTransformersNonMemoised = ()=>({
        [(0, $lO4Or.AFFECTED_SERVICES_GQL_FIELD)]: (0, $kBgu2.transformAggAffectedServicesToLegacyField),
        [(0, $lO4Or.BOOLEAN_GQL_FIELD)]: (0, $6Ux91.transformAggBooleanToLegacyField),
        [(0, $lO4Or.CASCADING_SELECT_GQL_FIELD)]: (0, $5sNJN.transformAggCascadingSelectToLegacyField),
        [(0, $lO4Or.CHECKBOX_GQL_FIELD)]: (0, $2wvLE.transformAggCheckboxToLegacyField),
        [(0, $lO4Or.CMDB_GQL_FIELD)]: (0, $8d1m1.transformAggCMDBToLegacyField),
        [(0, $lO4Or.MULTI_SELECT_GQL_FIELD)]: (0, $hQM7C.transformAggMultipleSelectToLegacyField),
        [(0, $lO4Or.COMPONENTS_GQL_FIELD)]: (0, $9wKha.transformAggComponentsToLegacyField),
        [(0, $lO4Or.CONNECT_DATE_TIME_GQL_FIELD)]: (0, $6PKzm.transformAggConnectDateTimeToLegacyField),
        [(0, $lO4Or.CONNECT_MULTI_SELECT_GQL_FIELD)]: (0, $jyP56.transformAggConnectMultipleSelectToLegacyField),
        [(0, $lO4Or.CONNECT_NUMBER_GQL_FIELD)]: (0, $epJqO.transformAggConnectNumberToLegacyField),
        [(0, $lO4Or.CONNECT_RICH_TEXT_GQL_FIELD)]: (0, $Pxexr.transformAggConnectRichTextToLegacyField),
        [(0, $lO4Or.CONNECT_SINGLE_SELECT_GQL_FIELD)]: (0, $beuR4.transformAggConnectSingleSelectToLegacyField),
        [(0, $lO4Or.CONNECT_TEXT_GQL_FIELD)]: (0, $d9IUw.transformAggConnectTextToLegacyField),
        [(0, $lO4Or.COLOR_GQL_FIELD)]: (0, $5CYGa.transformAggColorToLegacyField),
        [(0, $lO4Or.DATE_PICKER_GQL_FIELD)]: (0, $jsTfy.transformAggDatePickerToLegacyField),
        [(0, $lO4Or.DATE_TIME_GQL_FIELD)]: (0, $55kng.transformAggDateTimePickerToLegacyField),
        [(0, $lO4Or.EPIC_LINK_GQL_FIELD)]: (0, $7BRej.transformAggEpicLinkToLegacyField),
        [(0, $lO4Or.FLAG_GQL_FIELD)]: (0, $04Gbh.transformAggFlagToLegacyField),
        [(0, $lO4Or.FORGE_DATETIME_GQL_FIELD)]: (0, $bw8ws.transformAggForgeDateTimeToLegacyField),
        [(0, $lO4Or.FORGE_DATE_GQL_FIELD)]: (0, $3ZJZc.transformAggForgeDateToLegacyField),
        [(0, $lO4Or.FORGE_GROUP_GQL_FIELD)]: (0, $9vCKL.transformAggForgeGroupToLegacyField),
        [(0, $lO4Or.FORGE_GROUPS_GQL_FIELD)]: (0, $i5dch.transformAggForgeGroupsToLegacyField),
        [(0, $lO4Or.FORGE_NUMBER_GQL_FIELD)]: (0, $iJcxE.transformAggForgeNumberToLegacyField),
        [(0, $lO4Or.FORGE_OBJECT_GQL_FIELD)]: (0, $djkJh.transformAggForgeObjectToLegacyField),
        [(0, $lO4Or.FORGE_STRING_GQL_FIELD)]: (0, $kbDa2.transformAggForgeStringToLegacyField),
        [(0, $lO4Or.FORGE_STRINGS_GQL_FIELD)]: (0, $4gy8O.transformAggForgeStringsToLegacyField),
        [(0, $lO4Or.FORGE_USER_GQL_FIELD)]: (0, $9w928.transformAggForgeUserToLegacyField),
        [(0, $lO4Or.FORGE_USERS_GQL_FIELD)]: (0, $3khS7.transformAggForgeUsersToLegacyField),
        [(0, $lO4Or.ISSUE_RESTRICTION_GQL_FIELD)]: (0, $6IjGS.transformAggIssueRestrictionToLegacyField),
        [(0, $lO4Or.ISSUE_TYPE_GQL_FIELD)]: (0, $eOsdu.transformAggIssueTypeToLegacyField),
        [(0, $lO4Or.JSM_APPROVAL_GQL_FIELD)]: (0, $6MxWX.transformAggJSMApprovalsToLegacyField),
        [(0, $lO4Or.JSM_ASSETS_GQL_FIELD)]: (0, $blEoo.transformAggAssetToLegacyField),
        [(0, $lO4Or.JSM_MAJOR_INCIDENT_FIELD)]: (0, $gM34d.transformAggJSMMajorIncidentToLegacyField),
        [(0, $lO4Or.JSM_ORGANIZATION_GQL_FIELD)]: (0, $16kx8.transformAggJSMOrganizationToLegacyField),
        [(0, $lO4Or.JSM_ENTITLEMENTS_GQL_FIELD)]: (0, $9myMG.transformAggJSMEntitlementsToLegacyField),
        [(0, $lO4Or.JSM_SENTIMENT_GQL_FIELD)]: (0, $l6kyU.transformAggJSMSentimentToLegacyField),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        [(0, $lO4Or.JSM_PEOPLE_GQL_FIELD)]: (0, $QjWSM.transformAggMultipleUserPickerToLegacyField),
        [(0, $lO4Or.JSM_REQUEST_FEEDBACK_GQL_FIELD)]: (0, $4IQ8F.transformAggJSMRequestFeedbackToLegacyField),
        [(0, $lO4Or.JSM_REQUEST_LANGUAGE_GQL_FIELD)]: (0, $lcInz.transformAggJSMRequestLanguageToLegacyField),
        [(0, $lO4Or.JSM_REQUEST_TYPE_GQL_FIELD)]: (0, $4PFnn.transformAggJSMRequestTypeToLegacyField),
        [(0, $lO4Or.JSM_RESPONDERS_GQL_FIELD)]: (0, $alpM1.transformAggJSMRespondersToLegacyField),
        [(0, $lO4Or.LABEL_GQL_FIELD)]: (0, $gHd8e.transformAggLabelsNodeToLegacyField),
        [(0, $lO4Or.PRIORITY_GQL_FIELD)]: (0, $fkHM1.transformAggPriorityToLegacyField),
        [(0, $lO4Or.MULTI_GROUP_PICKER_GQL_FIELD)]: (0, $dUrU1.transformAggMultiGroupPickerToLegacyField),
        [(0, $lO4Or.MULTI_USER_PICKER_GQL_FIELD)]: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $QjWSM.transformAggMultipleUserPickerToLegacyField),
        [(0, $lO4Or.NUMBER_GQL_FIELD)]: (0, $lWE99.transformAggNumberToLegacyField),
        [(0, $lO4Or.ORIGINAL_ESTIMATE_GQL_FIELD)]: (0, $4eNqf.transformAggOriginalEstimateToLegacyField),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        [(0, $lO4Or.PEOPLE_GQL_FIELD)]: (0, $QjWSM.transformAggMultipleUserPickerToLegacyField),
        [(0, $lO4Or.PROFORMA_FORMS_GQL_FIELD)]: (0, $fkaQR.transformAggProformaFormsToLegacyField),
        [(0, $lO4Or.PROJECT_GQL_FIELD)]: (0, $ijtj3.transformAggProjectToLegacyField),
        [(0, $lO4Or.MULTI_VERSION_GQL_FIELD)]: (0, $4CGp4.transformAggMultipleVersionPickerToLegacyField),
        [(0, $lO4Or.RADIO_GQL_FIELD)]: (0, $gyvos.transformAggRadioSelectToLegacyField),
        [(0, $lO4Or.RICH_TEXT_GQL_FIELD)]: (0, $lQr58.transformAggRichTextToLegacyField),
        [(0, $lO4Or.RESOLUTION_GQL_FIELD)]: (0, $3w75b.transformAggResolutionToLegacyField),
        [(0, $lO4Or.SECURITY_GQL_FIELD)]: (0, $8oO4q.transformAggSecurityLevelToLegacyField),
        [(0, $lO4Or.SPRINT_GQL_FIELD)]: (0, $c6LKM.transformAggSprintToLegacyField),
        [(0, $lO4Or.STATUS_GQL_FIELD)]: (0, $8zTcQ.transformAggStatusToLegacyField),
        [(0, $lO4Or.SINGLE_GROUP_PICKER_GQL_FIELD)]: (0, $5Ne6t.transformAggSingleGroupPickerToLegacyField),
        [(0, $lO4Or.SINGLE_SELECT_GQL_FIELD)]: (0, $fz8Wc.transformAggSingleSelectToLegacyField),
        [(0, $lO4Or.TEAM_GQL_FIELD)]: (0, $5W75j.transformAggTeamToLegacyField),
        [(0, $lO4Or.TEAM_VIEW_GQL_FIELD)]: (0, $7iFVU.transformAggTeamViewToLegacyField),
        [(0, $lO4Or.TEXT_GQL_FIELD)]: (0, $2ETkN.transformAggSingleLineTextToLegacyField),
        [(0, $lO4Or.TIME_TRACKING_GQL_FIELD)]: (0, $kyZt3.transformAggTimeTrackingToLegacyField),
        [(0, $lO4Or.USER_PICKER_GQL_FIELD)]: (0, $jBiXV.transformAggSingleSelectUserPickerToLegacyField),
        [(0, $lO4Or.URL_GQL_FIELD)]: (0, $dX2ot.transformAggUrlToLegacyField),
        [(0, $lO4Or.VERSION_GQL_FIELD)]: (0, $1XUHd.transformAggSingleVersionPickerToLegacyField),
        [(0, $lO4Or.VOTES_GQL_FIELD)]: (0, $jhiYN.transformAggVotesToLegacyField),
        [(0, $lO4Or.WATCHES_GQL_FIELD)]: (0, $1BsAz.transformAggWatchesToLegacyField),
        [(0, $lO4Or.DATA_CLASSIFICATION_FIELD)]: (0, $xnQ91.transformAggDataClassificationToLegacyField),
        [(0, $lO4Or.GOALS_GQL_FIELD)]: (0, $c52Z6.transformAggGoalsToLegacyField)
    });
const $85127a55c87acb28$var$getTransformers = (0, $5iWql.default)($85127a55c87acb28$var$getTransformersNonMemoised);
const $85127a55c87acb28$export$586ba15cbf3d3031 = (node, context)=>{
    const typename = node.__typename;
    const transformer = $85127a55c87acb28$var$getTransformers()[typename];
    return transformer ? transformer(node, context) : undefined;
};
const $85127a55c87acb28$export$ba106ff8c087e6b1 = (fields)=>{
    if (fields == null) return {};
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return fields.reduce((fieldsState, fieldEdge)=>{
        if (fieldEdge?.node != null) {
            const transformedField = $85127a55c87acb28$export$586ba15cbf3d3031(fieldEdge.node, fields);
            if (transformedField != null) {
                const fieldData = 'key' in transformedField ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {
                    [transformedField.key]: transformedField
                } : transformedField;
                Object.assign(fieldsState, fieldData);
            }
        }
        return fieldsState;
    }, {});
};

});
parcelRegister("kBgu2", function(module, exports) {

$parcel$export(module.exports, "transformAggAffectedServicesToLegacyField", () => $347ea3dcad361eb5$export$231e0419515441d4);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $347ea3dcad361eb5$var$transformJiraServicesToLegacyServices = ({ serviceId: serviceId, name: name })=>({
        id: serviceId,
        name: name ?? undefined
    });
const $347ea3dcad361eb5$export$231e0419515441d4 = (node)=>{
    if (node.type !== (0, $lO4Or.SERVICE_ENTITY_CF_TYPE)) return undefined;
    const hasValue = Boolean(node.selectedAffectedServicesConnection?.edges?.length);
    const value = hasValue ? (0, $f4e7j.transformAggConnection)(node.selectedAffectedServicesConnection, $347ea3dcad361eb5$var$transformJiraServicesToLegacyServices) : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?query=` : null,
        value: value,
        schema: {
            configuration: null,
            custom: (0, $lO4Or.SERVICE_ENTITY_CF_TYPE),
            items: 'service-entity-field',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});
const $c7e7b1d3600a0c0f$export$89b8c5d86c10a68c = 'atlassian-wiki-renderer';
const $c7e7b1d3600a0c0f$export$a4a240cb4053b29f = 'jira-text-renderer';
const $c7e7b1d3600a0c0f$export$840ed33fa94f7693 = 'frother-control-renderer';

parcelRegister("f4e7j", function(module, exports) {

$parcel$export(module.exports, "transformAggNodeToLegacyField", () => $e263c15d21d94d7e$export$e7ea61856a169c36);
$parcel$export(module.exports, "transformAggConnection", () => $e263c15d21d94d7e$export$daf92cda81d86cdc);
$parcel$export(module.exports, "toLegacyConnectOption", () => $e263c15d21d94d7e$export$b5de5f3d2de73afc);
const $e263c15d21d94d7e$export$e7ea61856a169c36 = (node)=>({
        ari: 'id' in node ? node.id : undefined,
        key: 'fieldId' in node && !!node.fieldId ? node.fieldId : '',
        title: 'name' in node ? node.name : '',
        editable: Boolean('isEditableInIssueView' in node ? node.isEditableInIssueView : 'fieldConfig' in node && node.fieldConfig != null && 'isEditable' in node.fieldConfig && node.fieldConfig.isEditable),
        required: Boolean('fieldConfig' in node && node.fieldConfig != null && 'isRequired' in node.fieldConfig && node.fieldConfig.isRequired),
        autoCompleteUrl: 'searchUrl' in node ? node.searchUrl : null,
        allowedValues: [],
        value: null,
        schema: {
            type: 'type' in node ? node.type : '',
            custom: null,
            system: null
        },
        description: 'description' in node && node.description ? node.description : undefined
    });
const $e263c15d21d94d7e$export$daf92cda81d86cdc = (connection, transformCallback)=>{
    const edges = connection?.edges ?? [];
    if (transformCallback) return edges.map((edge)=>edge?.node != null ? transformCallback(edge.node) : null).filter(Boolean);
    return edges.map((edge)=>edge?.node).filter(Boolean);
};
const $e263c15d21d94d7e$export$b5de5f3d2de73afc = (node)=>{
    if (!node) return null;
    return {
        value: node.value ?? null,
        id: parseInt(node.optionId, 10)
    };
};

});


parcelRegister("blEoo", function(module, exports) {

$parcel$export(module.exports, "transformAggAssetToLegacyField", () => $894bbc4a3f1bdf98$export$2136dcd78a2ef18f);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $894bbc4a3f1bdf98$export$2136dcd78a2ef18f = (node)=>{
    switch(node.type){
        case 0, $lO4Or.ASSETS_CF_TYPE:
            {
                const hasValue = Boolean(node.selectedAssetsConnection?.edges?.length);
                const assetValue = hasValue ? (0, $f4e7j.transformAggConnection)(node.selectedAssetsConnection, ({ appKey: appKey, originId: originId, serializedOrigin: serializedOrigin, value: value })=>({
                        appKey: appKey,
                        originId: originId,
                        serializedOrigin: serializedOrigin,
                        value: value
                    })) : null;
                return {
                    ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                    autoCompleteUrl: node.searchUrl,
                    value: assetValue,
                    schema: {
                        custom: node.type,
                        system: null,
                        items: 'sd-asset',
                        type: 'array',
                        renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("6Ux91", function(module, exports) {

$parcel$export(module.exports, "transformAggBooleanToLegacyField", () => $0e4e588f42a69494$export$4bd89b95f0d10de9);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $0e4e588f42a69494$export$4bd89b95f0d10de9 = (node)=>{
    switch(node.type){
        case 0, $lO4Or.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE:
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: {
                    alertLinking: {
                        enabled: node.value
                    }
                },
                schema: {
                    configuration: null,
                    items: null,
                    renderer: null,
                    custom: null,
                    system: (0, $lO4Or.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE),
                    type: (0, $lO4Or.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE)
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("5sNJN", function(module, exports) {

$parcel$export(module.exports, "transformAggCascadingSelectToLegacyField", () => $8a9ad29dba216e4b$export$a8778af5ceb1017c);

var $1ybV0 = parcelRequire("1ybV0");


var $f4e7j = parcelRequire("f4e7j");
const $8a9ad29dba216e4b$export$a8778af5ceb1017c = (node)=>{
    let value = null;
    if (node.cascadingOption) {
        const { childOptionValue: childOptionValue, parentOptionValue: parentOptionValue } = node.cascadingOption;
        const child = childOptionValue ? {
            child: {
                id: childOptionValue.optionId,
                value: childOptionValue.value
            }
        } : {};
        value = {
            // assigned in the statement above
            id: parentOptionValue?.optionId,
            value: parentOptionValue?.value,
            ...child
        };
    }
    const allowedValues = (0, $1ybV0.ff)('issue.details.relay-cascading-select-field-issue-view-layout-integration') ? [] : (0, $f4e7j.transformAggConnection)(node.cascadingOptions, (cascadingOption)=>{
        if (!cascadingOption.parentOptionValue) return null;
        const { parentOptionValue: parentOptionValue, childOptionValues: childOptionValues } = cascadingOption;
        const childrenObj = childOptionValues?.length ? {
            children: childOptionValues.filter(Boolean).map((option)=>({
                    id: option.optionId,
                    value: option.value ?? null,
                    ari: option.id
                }))
        } : {};
        return {
            value: parentOptionValue.value,
            id: parentOptionValue.optionId,
            ...childrenObj
        };
    });
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: allowedValues,
        schema: {
            type: 'option-with-child',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("2wvLE", function(module, exports) {

$parcel$export(module.exports, "transformAggCheckboxToLegacyField", () => $de1faea4cf000ccb$export$baa5afdbd8fd12d3);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $de1faea4cf000ccb$export$baa5afdbd8fd12d3 = (node)=>{
    switch(node.type){
        case 0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE:
            {
                // We're inlining the transformers per field here so it'll be easy to remove them once we make the allowedValues async
                const value = (0, $f4e7j.transformAggConnection)(node.selectedOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                const allowedValues = (0, $f4e7j.transformAggConnection)(node.checkboxesFieldOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                return {
                    ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                    value: value.length ? value : null,
                    allowedValues: allowedValues,
                    schema: {
                        type: 'array',
                        renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                        custom: node.type,
                        system: null,
                        items: 'option',
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("8d1m1", function(module, exports) {

$parcel$export(module.exports, "transformAggCMDBToLegacyField", () => $65b0c941ec21e177$export$93506453d9bb56ae);

var $1ybV0 = parcelRequire("1ybV0");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $65b0c941ec21e177$var$transformObjectTypeToLegacy = (attribute, workspaceId)=>({
        workspaceId: workspaceId,
        id: `${workspaceId}:${attribute.objectTypeId}`,
        name: attribute.name,
        objectSchemaId: attribute.objectSchemaId,
        objectTypeId: attribute.objectTypeId,
        // `icon` is unused
        icon: {
            id: attribute.icon.id,
            name: attribute.icon.name,
            url16: attribute.icon.url16,
            url48: attribute.icon.url48
        }
    });
const $65b0c941ec21e177$var$transformCMDBConfigurationToLegacyConfiguration = (node)=>{
    if (!node.cmdbFieldConfig) return node.isInsightAvailable === false ? {
        isInsightAvailable: node.isInsightAvailable
    } : {};
    return {
        cmdbFieldConfig: {
            multiple: node.cmdbFieldConfig.multiple,
            objectSchemaId: node.cmdbFieldConfig.objectSchemaId.split('/')[2],
            attributesDisplayedOnIssue: (0, $f4e7j.transformAggConnection)(node.cmdbFieldConfig?.attributesDisplayedOnIssue),
            attributesIncludedInAutoCompleteSearch: (0, $f4e7j.transformAggConnection)(node.cmdbFieldConfig?.attributesIncludedInAutoCompleteSearch)
        },
        isInsightAvailable: node.isInsightAvailable,
        wasInsightRequestSuccessful: node.wasInsightRequestSuccessful
    };
};
const $65b0c941ec21e177$var$transformObjectTypeAttributeToLegacy = (type)=>{
    switch(type){
        case 'REFERENCED_OBJECT':
            return 1;
        case 'USER':
            return 2;
        case 'GROUP':
            return 4;
        case 'PROJECT':
            return 6;
        case 'STATUS':
            return 7;
        case 'BITBUCKET_REPO':
            return 8;
        case 'OPSGENIE_TEAM':
            return 9;
        case 'DEFAULT':
            return 0;
        default:
            // eslint-disable-next-line no-console
            console.error(new Error(`Unknown attribute type found in transformObjectTypeAttributeToLegacy: ${type}. Mapping type to '-1'`));
            return -1;
    }
};
const $65b0c941ec21e177$var$transformReferencedObject = (node)=>({
        id: node.objectGlobalId,
        workspaceId: node.workspaceId,
        objectKey: node.objectKey,
        label: node.label,
        avatar: node.avatar,
        objectId: node.objectId
    });
const $65b0c941ec21e177$var$transformCmdbUser = (node)=>({
        avatarUrl: node.picture,
        displayName: node.name,
        name: node.name,
        key: node.accountId
    });
const $65b0c941ec21e177$var$transformCmdbGroup = (node)=>({
        name: node.name
    });
const $65b0c941ec21e177$var$transformCmdbProject = (node)=>({
        avatarUrl: node.avatar?.large,
        id: Number(node.id),
        key: node.key,
        name: node.name
    });
const $65b0c941ec21e177$var$transformCmdbBitbucketRepo = (node)=>({
        uuid: node.uuid,
        name: node.name,
        url: node.url,
        avatarUrl: node.avatarUrl
    });
const $65b0c941ec21e177$var$transformCmdbOpsgenieTeam = (node)=>({
        id: node.id,
        name: node.name,
        url: node.url
    });
const $65b0c941ec21e177$var$transformCmdbStatus = (node)=>({
        id: node.id,
        name: node.name,
        category: node.category
    });
const $65b0c941ec21e177$var$transformObjectAttributeValuesToLegacy = (node)=>{
    if (!node) return null;
    const defaultObjectValue = {
        displayValue: node.displayValue,
        searchValue: node.searchValue,
        ...node.value != null ? {
            value: node.value
        } : {}
    };
    if (node.referencedObject) return {
        ...defaultObjectValue,
        referencedObject: $65b0c941ec21e177$var$transformReferencedObject(node.referencedObject)
    };
    if (node.user) return {
        ...defaultObjectValue,
        user: $65b0c941ec21e177$var$transformCmdbUser(node.user)
    };
    if (node.group) return {
        ...defaultObjectValue,
        group: $65b0c941ec21e177$var$transformCmdbGroup(node.group)
    };
    if (node.project) return {
        ...defaultObjectValue,
        project: $65b0c941ec21e177$var$transformCmdbProject(node.project)
    };
    if (node.bitbucketRepo) return {
        ...defaultObjectValue,
        bitbucketRepo: $65b0c941ec21e177$var$transformCmdbBitbucketRepo(node.bitbucketRepo)
    };
    if (node.opsgenieTeam) return {
        ...defaultObjectValue,
        opsgenieTeam: $65b0c941ec21e177$var$transformCmdbOpsgenieTeam(node.opsgenieTeam)
    };
    if (node.status) return {
        ...defaultObjectValue,
        status: $65b0c941ec21e177$var$transformCmdbStatus(node.status)
    };
    return defaultObjectValue;
};
const $65b0c941ec21e177$var$transformObjectAttributesToLegacyObjectAttributes = (node, workspaceId)=>{
    if (!node) return null;
    const { objectTypeAttributeId: objectTypeAttributeId, objectTypeAttribute: objectTypeAttribute } = node;
    return {
        objectTypeAttributeId: objectTypeAttributeId,
        ...!(0, $1ybV0.ff)('assets-rearch-deprecate-attribute-value-id_ykukg') && {
            id: node.attributeId
        },
        workspaceId: workspaceId,
        objectAttributeValues: (0, $f4e7j.transformAggConnection)(node.objectAttributeValues, $65b0c941ec21e177$var$transformObjectAttributeValuesToLegacy),
        objectTypeAttribute: {
            id: objectTypeAttributeId,
            label: objectTypeAttribute.label,
            name: objectTypeAttribute.name,
            workspaceId: workspaceId,
            type: $65b0c941ec21e177$var$transformObjectTypeAttributeToLegacy(objectTypeAttribute.type),
            ...objectTypeAttribute.defaultType ? {
                defaultType: {
                    id: objectTypeAttribute.defaultType.id,
                    name: objectTypeAttribute.defaultType.name
                }
            } : {}
        }
    };
};
const $65b0c941ec21e177$var$transformJiraCMDBToLegacyCMDB = (node)=>{
    if (!node) return null;
    const { label: label, objectGlobalId: objectGlobalId, objectId: objectId, objectKey: objectKey, workspaceId: workspaceId, webUrl: webUrl, avatar: avatar } = node;
    return {
        attributes: (0, $f4e7j.transformAggConnection)(node.attributes, (nodeAttribute)=>$65b0c941ec21e177$var$transformObjectAttributesToLegacyObjectAttributes(nodeAttribute, workspaceId)),
        avatar: avatar,
        label: label,
        id: objectGlobalId,
        objectId: objectId,
        objectKey: objectKey,
        workspaceId: workspaceId,
        links: {
            self: webUrl
        },
        objectType: $65b0c941ec21e177$var$transformObjectTypeToLegacy(node.objectType, workspaceId)
    };
};
const $65b0c941ec21e177$export$93506453d9bb56ae = (node)=>{
    if (node.type !== (0, $lO4Or.CMDB_OBJECT_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?` : null,
        configuration: $65b0c941ec21e177$var$transformCMDBConfigurationToLegacyConfiguration(node),
        value: (0, $f4e7j.transformAggConnection)(node.selectedCmdbObjectsConnection, $65b0c941ec21e177$var$transformJiraCMDBToLegacyCMDB),
        schema: {
            configuration: null,
            custom: (0, $lO4Or.CMDB_OBJECT_CF_TYPE),
            items: 'cmdb-object-field',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("5CYGa", function(module, exports) {

$parcel$export(module.exports, "transformAggColorToLegacyField", () => $9050c04462f98fea$export$587c178f1b45e5e9);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $9050c04462f98fea$export$587c178f1b45e5e9 = (node)=>{
    const value = node.color?.colorKey ?? null;
    switch(node.type){
        case 0, $lO4Or.EPIC_COLOR_TYPE:
        case 0, $lO4Or.COLOR_CF_TYPE:
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: value,
                schema: {
                    configuration: null,
                    type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
                    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                    custom: node.type,
                    system: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("9wKha", function(module, exports) {

$parcel$export(module.exports, "transformAggComponentsToLegacyField", () => $786c86fdf4d26692$export$97a9275777684b77);

var $1ybV0 = parcelRequire("1ybV0");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
// @DoNotExport Flow is deriving component's type
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $786c86fdf4d26692$var$transformJiraComponentToLegacyComponent = (component)=>{
    if (component == null) return null;
    return {
        id: component.componentId,
        name: component.name,
        ...(0, $1ybV0.ff)('compass-components-in-jira-components_xw42u', false) ? {
            ari: component.ari,
            metadata: component.metadata
        } : {}
    };
};
const $786c86fdf4d26692$export$97a9275777684b77 = (node)=>{
    if (node.type !== (0, $lO4Or.COMPONENTS_TYPE)) return undefined;
    const allowedValues = (0, $f4e7j.transformAggConnection)(node.components, $786c86fdf4d26692$var$transformJiraComponentToLegacyComponent);
    const value = (0, $f4e7j.transformAggConnection)(node.selectedComponentsConnection, $786c86fdf4d26692$var$transformJiraComponentToLegacyComponent);
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        allowedValues: allowedValues,
        value: value,
        schema: {
            configuration: null,
            items: 'component',
            renderer: (0, $c7e7b1d3600a0c0f$export$840ed33fa94f7693),
            type: (0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
            custom: null,
            system: (0, $lO4Or.COMPONENTS_TYPE)
        }
    };
};

});

parcelRegister("6PKzm", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectDateTimeToLegacyField", () => $37a64e51f4c4445c$export$e6d015aa746cbdaf);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $37a64e51f4c4445c$export$e6d015aa746cbdaf = (node)=>({
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.dateTime ?? null,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $lO4Or.ISSUE_FIELD_DATETIME_CF_TYPE)
        }
    });

});

parcelRegister("jyP56", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectMultipleSelectToLegacyField", () => $060cb99a84a6f8a5$export$edf5c98d20696686);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $060cb99a84a6f8a5$export$edf5c98d20696686 = (node)=>{
    const value = (0, $f4e7j.transformAggConnection)(node.selectedOptions, (0, $f4e7j.toLegacyConnectOption));
    const allowedValues = (0, $f4e7j.transformAggConnection)(node.connectMultiSelectFieldOptions, (0, $f4e7j.toLegacyConnectOption));
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value.length ? value : null,
        allowedValues: allowedValues,
        schema: {
            type: (0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: (0, $lO4Or.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
            configuration: null
        }
    };
};

});

parcelRegister("epJqO", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectNumberToLegacyField", () => $c342681984a0fce1$export$4638a5dd3285d8f2);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $c342681984a0fce1$export$4638a5dd3285d8f2 = (node)=>({
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.number ?? null,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $lO4Or.ISSUE_FIELD_NUMBER_CF_TYPE)
        }
    });

});

parcelRegister("Pxexr", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectRichTextToLegacyField", () => $6d21cc1975a64a13$export$11063e1f9210f191);

var $esUXI = parcelRequire("esUXI");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");
const $6d21cc1975a64a13$var$emptyAdfObject = (0, $esUXI.getEmptyADF)();
const $6d21cc1975a64a13$var$getPlainTextValue = (node)=>{
    if (!node.richText) return null;
    if (node.richText.plainText == null) return '';
    return node.richText.plainText;
};
const $6d21cc1975a64a13$export$11063e1f9210f191 = (node)=>{
    const { renderer: renderer } = node;
    if ((0, $2qVcp.default)(node)) return undefined;
    const isPlainTextRenderer = renderer === (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f);
    const values = isPlainTextRenderer ? {
        value: $6d21cc1975a64a13$var$getPlainTextValue(node)
    } : {
        adfValue: node.richText?.adfValue?.json || $6d21cc1975a64a13$var$emptyAdfObject
    };
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        ...values,
        schema: {
            custom: (0, $lO4Or.TEXT_AREA_CF_TYPE),
            renderer: renderer,
            type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
            system: null,
            configuration: null,
            items: null
        }
    };
};

});
parcelRegister("esUXI", function(module, exports) {

$parcel$export(module.exports, "getEmptyADF", () => $e4fec1f97a138b24$export$d109ab46c9575565);
const $e4fec1f97a138b24$export$d109ab46c9575565 = ()=>({
        type: 'doc',
        version: 1,
        content: []
    });

});

parcelRegister("2qVcp", function(module, exports) {

$parcel$export(module.exports, "default", () => $08fb6c9e1b8a0092$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");
const $08fb6c9e1b8a0092$export$c63f561360bafed1 = 'issue.agg-field-transformers.missing-renderer';
// If the renderer is missing, log an error and return true.
// This was added as part of https://jplat.atlassian.net/browse/JIV-14881 to help identify why
// fields are sometimes missing the renderer.
const $08fb6c9e1b8a0092$var$isFieldMissingRenderer = (field)=>{
    try {
        // Narrow the type of field to fields with a renderer
        if (!('renderer' in field)) return false;
        if (field?.renderer) return false;
        (0, $gUUjF.default).safeErrorWithoutCustomerData($08fb6c9e1b8a0092$export$c63f561360bafed1, `Field ${field.fieldId} of type ${field.__typename} has missing renderer: ${field.renderer}`);
        return true;
    } catch  {
        return false;
    }
};
var $08fb6c9e1b8a0092$export$2e2bcd8739ae039 = $08fb6c9e1b8a0092$var$isFieldMissingRenderer;

});


parcelRegister("beuR4", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectSingleSelectToLegacyField", () => $b2ab3564d5e0e945$export$e44db7cf61369a28);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $b2ab3564d5e0e945$export$e44db7cf61369a28 = (node)=>{
    let value = null;
    if (node.fieldOption != null) value = {
        id: parseInt(node.fieldOption?.optionId, 10),
        value: node.fieldOption?.value
    };
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: (0, $f4e7j.transformAggConnection)(node.connectSingleSelectFieldOptions, (0, $f4e7j.toLegacyConnectOption)),
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $lO4Or.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("d9IUw", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectTextToLegacyField", () => $a23506d3b78ec681$export$dd05277f5aa90657);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $a23506d3b78ec681$export$dd05277f5aa90657 = (node)=>({
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.text,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE)
        }
    });

});

parcelRegister("xnQ91", function(module, exports) {

$parcel$export(module.exports, "transformAggDataClassificationToLegacyField", () => $104546bf95896cb2$export$b5edfdc89a7a2932);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $104546bf95896cb2$export$b5edfdc89a7a2932 = (node)=>({
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        key: (0, $lO4Or.DATA_CLASSIFICATION_TYPE),
        value: node,
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            custom: null,
            system: null,
            type: (0, $lO4Or.DATA_CLASSIFICATION_TYPE)
        }
    });

});

parcelRegister("jsTfy", function(module, exports) {

$parcel$export(module.exports, "transformAggDatePickerToLegacyField", () => $cbf69a6b68f1ac34$export$3d6e51d37c0454a9);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $cbf69a6b68f1ac34$export$3d6e51d37c0454a9 = (node)=>{
    switch(node.type){
        case 0, $lO4Or.DUE_DATE_TYPE:
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: typeof node.date === 'string' ? node.date : null,
                schema: {
                    type: (0, $lO4Or.ISSUE_FIELD_DATE_CF_TYPE),
                    configuration: null,
                    system: node.type,
                    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                    custom: null,
                    items: null
                }
            };
        case 0, $lO4Or.DATE_CF_TYPE:
        case 0, $lO4Or.BASELINE_START_CF_TYPE:
        case 0, $lO4Or.BASELINE_END_CF_TYPE:
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: typeof node.date === 'string' ? node.date : null,
                schema: {
                    type: (0, $lO4Or.ISSUE_FIELD_DATE_CF_TYPE),
                    custom: node.type,
                    configuration: null,
                    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                    system: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("55kng", function(module, exports) {

$parcel$export(module.exports, "transformAggDateTimePickerToLegacyField", () => $d108194053a9b0cf$export$3de22f1277f0c239);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $d108194053a9b0cf$var$defaultSchema = {
    type: (0, $lO4Or.ISSUE_FIELD_DATETIME_CF_TYPE),
    custom: null,
    system: null,
    configuration: null,
    items: null,
    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f)
};
const $d108194053a9b0cf$export$3de22f1277f0c239 = (node)=>{
    switch(node.type){
        case 0, $lO4Or.CREATED:
        case 0, $lO4Or.UPDATED:
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: node.dateTime || '',
                schema: {
                    ...$d108194053a9b0cf$var$defaultSchema,
                    system: node.type,
                    renderer: null
                }
            };
        case 0, $lO4Or.RESOLUTION_DATE:
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: node.dateTime ?? null,
                schema: {
                    ...$d108194053a9b0cf$var$defaultSchema,
                    system: node.type,
                    renderer: null
                }
            };
        case 0, $lO4Or.DATETIME_CF_TYPE:
        case 0, $lO4Or.FIRST_RESPONSE_DATE_CF_TYPE:
        case 0, $lO4Or.REQUEST_FEEDBACK_DATE_CF_TYPE:
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: node.dateTime ?? null,
                schema: {
                    ...$d108194053a9b0cf$var$defaultSchema,
                    custom: node.type
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("7BRej", function(module, exports) {

$parcel$export(module.exports, "transformAggEpicLinkToLegacyField", () => $3731013de9f5c7b2$export$1311f30c94840aa2);

var $opsFH = parcelRequire("opsFH");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $3731013de9f5c7b2$var$transformJiraEpicToLegacyEpicLink = (epic)=>{
    if (epic == null) return null;
    return {
        id: Number(epic.issueId),
        key: epic.key || '',
        done: !!epic.done,
        name: epic.name || '',
        summary: epic.summary || '',
        color: {
            key: epic.color ?? (0, $opsFH.AgileColors).AGILE_COLOR_1
        },
        // This can only be set from cache handlers
        fromCache: false
    };
};
const $3731013de9f5c7b2$export$1311f30c94840aa2 = (node)=>{
    if (node.type !== (0, $lO4Or.EPIC_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        value: $3731013de9f5c7b2$var$transformJiraEpicToLegacyEpicLink(node.epic),
        schema: {
            configuration: null,
            items: null,
            renderer: 'jira-text-renderer',
            type: 'any',
            custom: (0, $lO4Or.EPIC_TYPE),
            system: null
        }
    };
};

});

parcelRegister("04Gbh", function(module, exports) {

$parcel$export(module.exports, "transformAggFlagToLegacyField", () => $c8b2d8c7cabddb24$export$31555b6ea19f4c2);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $c8b2d8c7cabddb24$var$transformJiraFlagToLegacyFlag = (flag)=>{
    if (flag == null || flag.isFlagged == null) return null;
    return [
        {
            value: flag.isFlagged
        }
    ];
};
const $c8b2d8c7cabddb24$export$31555b6ea19f4c2 = (node)=>{
    // Agg flag field comes back as multichecbox CF type instead of current graphql flagged CF type
    if (node.type !== (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: $c8b2d8c7cabddb24$var$transformJiraFlagToLegacyFlag(node.flag),
        schema: {
            configuration: null,
            custom: (0, $lO4Or.FLAGGED_CF_TYPE),
            items: 'option',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("3ZJZc", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeDateToLegacyField", () => $c763da6a17e08623$export$30fccfce22948120);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");
const $c763da6a17e08623$export$30fccfce22948120 = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.date,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_DATE_CF_TYPE)
        }
    };
};

});

parcelRegister("bw8ws", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeDateTimeToLegacyField", () => $4c0a1710d24fba77$export$61b1f0cbd04c7b9c);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");
const $4c0a1710d24fba77$export$61b1f0cbd04c7b9c = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.dateTime,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_DATETIME_CF_TYPE)
        }
    };
};

});

parcelRegister("9vCKL", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeGroupToLegacyField", () => $c9b907ff4adf2ba8$export$60b03d63015cbb9f);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");
const $c9b907ff4adf2ba8$export$60b03d63015cbb9f = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.selectedGroup ? {
            name: node.selectedGroup.name
        } : null,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_SINGLE_GROUP_CF_TYPE)
        }
    };
};

});

parcelRegister("i5dch", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeGroupsToLegacyField", () => $a11ed3e141cd8632$export$2dfa4944fba5d1f5);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");
const $a11ed3e141cd8632$export$2dfa4944fba5d1f5 = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    const value = node.selectedGroupsConnection?.edges?.length ? (0, $f4e7j.transformAggConnection)(node.selectedGroupsConnection, ({ name: name })=>({
            name: name
        })) : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: (0, $lO4Or.ISSUE_FIELD_SINGLE_GROUP_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("iJcxE", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeNumberToLegacyField", () => $0d8b7166bd07a2e4$export$5dab8986dc45db07);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");
const $0d8b7166bd07a2e4$export$5dab8986dc45db07 = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.number,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_NUMBER_CF_TYPE)
        }
    };
};

});

parcelRegister("djkJh", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeObjectToLegacyField", () => $d8b2a1a28c816219$export$fbdabdbae2a203b9);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");
const $d8b2a1a28c816219$export$fbdabdbae2a203b9 = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    const value = (()=>{
        if (node.object == null) return null;
        try {
            return JSON.parse(node.object);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            throw new Error('Failed to transform forge object field: node.object was invalid JSON object');
        }
    })();
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_OBJECT_CF_TYPE)
        }
    };
};

});

parcelRegister("kbDa2", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeStringToLegacyField", () => $c3ecb4f8814d5007$export$3a581fb4b3e578bd);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");
const $c3ecb4f8814d5007$export$3a581fb4b3e578bd = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.text,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE)
        }
    };
};

});

parcelRegister("4gy8O", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeStringsToLegacyField", () => $e5fb5863b3ffc3de$export$418a06cb5dc6aba5);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");
const $e5fb5863b3ffc3de$export$418a06cb5dc6aba5 = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    const hasValue = Boolean(node.selectedLabelsConnection?.edges?.length);
    const value = hasValue ? (0, $f4e7j.transformAggConnection)(node.selectedLabelsConnection, ({ name: name })=>name) : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        autoCompleteUrl: node.searchUrl,
        schema: {
            configuration: null,
            items: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("9w928", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeUserToLegacyField", () => $bdc773687305de8f$export$bc73c7a747f907e5);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");

var $g5TY0 = parcelRequire("g5TY0");
const $bdc773687305de8f$export$bc73c7a747f907e5 = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.user ? (0, $g5TY0.transformJiraUserToLegacyServerUser)(node.user) : null,
        autoCompleteUrl: node.searchUrl,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_USER_CF_TYPE)
        }
    };
};

});
parcelRegister("g5TY0", function(module, exports) {

$parcel$export(module.exports, "transformJiraUserToLegacyServerUser", () => $c92150b2c9939d9c$export$d7b231260a016eaf);

const $c92150b2c9939d9c$var$getAccountType = (objectType)=>{
    switch(objectType){
        case 'AtlassianAccountUser':
            return 0, $0f8390fc7463ac8c$export$981400c14dd99bc0;
        case 'CustomerUser':
            return 0, $0f8390fc7463ac8c$export$2823897fb92cd040;
        case 'AppUser':
            return 0, $0f8390fc7463ac8c$export$1973ca62b6c5abfe;
        default:
            return 0, $0f8390fc7463ac8c$export$d1f5101c0939e3fe;
    }
};
const $c92150b2c9939d9c$var$generateAvatarUrls = (url)=>({
        '16x16': url,
        '24x24': url,
        '32x32': url,
        '48x48': url
    });
const $c92150b2c9939d9c$export$d7b231260a016eaf = (user)=>{
    if (!user) return null;
    const userOptionalKeysMap = {
        emailAddress: 'email',
        locale: 'locale',
        timeZone: 'zoneinfo'
    };
    const optionalValues = {};
    Object.entries(userOptionalKeysMap).forEach(([key, aggKey])=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const aggValue = user[aggKey];
        if (aggValue !== undefined && aggValue !== null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        optionalValues[key] = aggValue;
    });
    const avatars = user.picture != null ? {
        avatarUrl: user.picture,
        avatarUrls: $c92150b2c9939d9c$var$generateAvatarUrls(user.picture)
    } : {};
    return {
        ...avatars,
        ...optionalValues,
        accountId: user.accountId,
        accountType: $c92150b2c9939d9c$var$getAccountType(user.__typename),
        active: user.accountStatus === 'active',
        displayName: user.name
    };
};

});
const $0f8390fc7463ac8c$export$981400c14dd99bc0 = 'atlassian';
const $0f8390fc7463ac8c$export$2823897fb92cd040 = 'customer';
const $0f8390fc7463ac8c$export$1973ca62b6c5abfe = 'app';
const $0f8390fc7463ac8c$export$d1f5101c0939e3fe = 'unknown';



parcelRegister("3khS7", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeUsersToLegacyField", () => $04695e9464f736dc$export$bbfea2e2f2c853b8);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");

var $g5TY0 = parcelRequire("g5TY0");
const $04695e9464f736dc$export$bbfea2e2f2c853b8 = (node)=>{
    if ((0, $2qVcp.default)(node)) return undefined;
    const value = node.selectedUsersConnection?.edges?.length ? (0, $f4e7j.transformAggConnection)(node.selectedUsersConnection, (0, $g5TY0.transformJiraUserToLegacyServerUser)) : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: (0, $lO4Or.ISSUE_FIELD_USER_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("c52Z6", function(module, exports) {

$parcel$export(module.exports, "transformAggGoalsToLegacyField", () => $967e7c1cc9b41f1e$export$158301a02ae4cbe7);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $967e7c1cc9b41f1e$export$158301a02ae4cbe7 = (node)=>{
    if (node.type !== (0, $lO4Or.GOALS_CF_TYPE)) return undefined;
    const value = node.selectedGoals ? {
        goals: node.selectedGoals?.edges?.filter((edge)=>edge?.node !== null).map((edge)=>({
                id: edge?.node?.id || '',
                name: edge?.node?.name || '',
                status: edge?.node?.status || null
            })) || [],
        totalCount: node.selectedGoals?.totalCount || 0
    } : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            custom: (0, $lO4Or.GOALS_CF_TYPE),
            items: null,
            renderer: null,
            system: null,
            type: (0, $lO4Or.GOALS_CF_TYPE)
        }
    };
};

});

parcelRegister("6IjGS", function(module, exports) {

$parcel$export(module.exports, "transformAggIssueRestrictionToLegacyField", () => $656ee40cfd5a4289$export$62db794d5816e28e);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $ijtj3 = parcelRequire("ijtj3");
const $656ee40cfd5a4289$var$transformJiraRoleToRestriction = (role)=>{
    if (role == null) return null;
    return {
        restrictionValue: role.roleId
    };
};
const $656ee40cfd5a4289$export$62db794d5816e28e = (node, context)=>{
    if (node.type !== (0, $lO4Or.ISSUE_RESTRICTION_TYPE)) return undefined;
    const roles = (0, $f4e7j.transformAggConnection)(node.selectedRolesConnection, $656ee40cfd5a4289$var$transformJiraRoleToRestriction);
    const restrictions = roles.length > 0 ? {
        projectrole: roles
    } : {};
    const project = (0, $ijtj3.getSystemAggJiraProject)(context);
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: {
            shouldDisplay: project.canSetIssueRestriction === true,
            issuerestrictions: restrictions
        },
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            type: (0, $lO4Or.ISSUE_RESTRICTION_TYPE),
            custom: null,
            system: node.type
        }
    };
};

});
parcelRegister("ijtj3", function(module, exports) {

$parcel$export(module.exports, "getProjectType", () => $b7b19c470c7e1e1a$export$3dd0da95519c1a33);
$parcel$export(module.exports, "getSystemAggJiraProject", () => $b7b19c470c7e1e1a$export$d100105d56da4a0a);
$parcel$export(module.exports, "transformAggProjectToProjectContext", () => $b7b19c470c7e1e1a$export$275f121d4e6f5165);
$parcel$export(module.exports, "transformAggProjectToLegacyField", () => $b7b19c470c7e1e1a$export$30c14b802399f417);

var $7ZZxN = parcelRequire("7ZZxN");


var $6vrw7 = parcelRequire("6vrw7");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $b7b19c470c7e1e1a$var$getProjectStatus = (status)=>{
    switch(status){
        case 'ACTIVE':
            return 0, $5bd9e96e4d7e8aee$export$62113557945f790a;
        case 'ARCHIVED':
            return 0, $5bd9e96e4d7e8aee$export$4ccc35479ba9ad1;
        case 'DELETED':
            return 0, $5bd9e96e4d7e8aee$export$a95d71e582b8bc0;
        default:
            // Based on `getProjectStatus` from src/packages/issue/issue-view/src/common/service/issue/issue-transformer.js
            return 0, $5bd9e96e4d7e8aee$export$62113557945f790a;
    }
};
const $b7b19c470c7e1e1a$export$3dd0da95519c1a33 = (projectType)=>{
    switch(projectType){
        case 'SERVICE_DESK':
            return 0, $7ZZxN.SERVICE_DESK_PROJECT;
        case 'BUSINESS':
            return 0, $7ZZxN.CORE_PROJECT;
        case 'SOFTWARE':
            return 0, $7ZZxN.SOFTWARE_PROJECT;
        case 'PRODUCT_DISCOVERY':
            return 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $b7b19c470c7e1e1a$export$d100105d56da4a0a = (fields)=>{
    /**
	 * We only want the system `PROJECT_TYPE` field.
	 * For custom fields, e.g., project picker, see `transformAggProjectToLegacyField`
	 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const projectField = fields?.find((edge)=>edge?.node?.__typename === (0, $lO4Or.PROJECT_GQL_FIELD) && edge?.node?.type != null && edge.node.type === (0, $lO4Or.PROJECT_TYPE))?.node;
    // Needs the `PROJECT_GQL_FIELD` refinement so we can return as `AggJiraProject`
    if (projectField == null || projectField.__typename !== (0, $lO4Or.PROJECT_GQL_FIELD)) throw new Error(`Failed to get system project data: ${(0, $lO4Or.PROJECT_GQL_FIELD)} with ${(0, $lO4Or.PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(fields ?? '')}]`);
    if (projectField.project == null) throw new Error(`Failed to get system project data: ${(0, $lO4Or.PROJECT_GQL_FIELD)}.project is missing [${JSON.stringify(projectField)}]`);
    return projectField.project;
};
const $b7b19c470c7e1e1a$export$f7d5cb97957d02e3 = (project)=>project.projectStyle === 'TEAM_MANAGED_PROJECT';
const $b7b19c470c7e1e1a$var$transformAggProjectToServerProjectOption = (project)=>{
    if (project == null) return null;
    const { projectId: projectId, key: key, name: name, avatar: avatar } = project;
    return {
        name: name,
        id: projectId ?? undefined,
        key: (0, $6vrw7.toProjectKey)(key),
        avatarUrls: {
            '48x48': avatar.large
        }
    };
};
const $b7b19c470c7e1e1a$export$275f121d4e6f5165 = (fields)=>{
    const project = $b7b19c470c7e1e1a$export$d100105d56da4a0a(fields);
    const { projectId: projectId, name: name, key: key, avatar: avatar, status: status, projectType: type, navigationMetadata: navigationMetadata } = project;
    const projectType = $b7b19c470c7e1e1a$export$3dd0da95519c1a33(type);
    if (projectType == null) throw new Error(`Failed to transform system project: projectType ${String(type)} was invalid`);
    return {
        projectId: projectId,
        projectType: projectType,
        projectName: name,
        projectKey: key,
        projectStatus: $b7b19c470c7e1e1a$var$getProjectStatus(status),
        avatarUrl: avatar.medium,
        isSimplified: $b7b19c470c7e1e1a$export$f7d5cb97957d02e3(project),
        boardId: navigationMetadata?.boardId
    };
};
const $b7b19c470c7e1e1a$var$transformAggProjectToLegacyProjectPickerField = (node)=>({
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        allowedValues: [],
        value: $b7b19c470c7e1e1a$var$transformAggProjectToServerProjectOption(node.project),
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            type: (0, $lO4Or.PROJECT_TYPE),
            custom: (0, $lO4Or.PROJECT_PICKER_CF_TYPE),
            system: null
        }
    });
const $b7b19c470c7e1e1a$var$transformAggProjectToLegacySimilarIssuesField = (node)=>{
    // Similar issues field only exist in JSM projects
    if ($b7b19c470c7e1e1a$export$3dd0da95519c1a33(node.project?.projectType) !== (0, $7ZZxN.SERVICE_DESK_PROJECT)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        key: (0, $lO4Or.SIMILAR_ISSUES_TYPE),
        title: (0, $lO4Or.SIMILAR_ISSUES_TYPE),
        value: node.project?.similarIssues?.featureEnabled === true,
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            type: (0, $lO4Or.SIMILAR_ISSUES_TYPE),
            custom: null,
            system: (0, $lO4Or.SIMILAR_ISSUES_TYPE)
        }
    };
};
const $b7b19c470c7e1e1a$export$30c14b802399f417 = (node)=>{
    switch(node.type){
        case 0, $lO4Or.PROJECT_PICKER_CF_TYPE:
            return $b7b19c470c7e1e1a$var$transformAggProjectToLegacyProjectPickerField(node);
        case 0, $lO4Or.PROJECT_TYPE:
            // For the system project, see `transformAggProjectToProjectContext`
            return $b7b19c470c7e1e1a$var$transformAggProjectToLegacySimilarIssuesField(node);
        default:
            return undefined;
    }
};

});
const $5bd9e96e4d7e8aee$export$62113557945f790a = 'PROJECT_ACTIVE';
const $5bd9e96e4d7e8aee$export$4ccc35479ba9ad1 = 'PROJECT_ARCHIVED';
const $5bd9e96e4d7e8aee$export$a95d71e582b8bc0 = 'PROJECT_TRASHED';



parcelRegister("eOsdu", function(module, exports) {

$parcel$export(module.exports, "getSystemAggJiraIssueType", () => $fddff707046980f2$export$b4644a0cc2f2935e);
$parcel$export(module.exports, "transformJiraIssueTypeToLegacyIssueType", () => $fddff707046980f2$export$2356062173546155);
$parcel$export(module.exports, "transformAggIssueTypeToLegacyField", () => $fddff707046980f2$export$de2eb3b47c7c887b);

var $lO4Or = parcelRequire("lO4Or");
var $edkGa = parcelRequire("edkGa");

var $f4e7j = parcelRequire("f4e7j");
const $fddff707046980f2$export$d95e76b2d065f98d = {
    avatarId: 0,
    self: ''
};
const $fddff707046980f2$export$b4644a0cc2f2935e = (fields)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const issueTypeField = fields?.find((edge)=>edge?.node != null && edge.node.__typename === (0, $lO4Or.ISSUE_TYPE_GQL_FIELD) && edge.node.type === (0, $lO4Or.ISSUE_TYPE))?.node;
    if (issueTypeField == null || issueTypeField.__typename !== (0, $lO4Or.ISSUE_TYPE_GQL_FIELD) || issueTypeField.type !== (0, $lO4Or.ISSUE_TYPE)) throw new Error(`Failed to get system issue type: ${(0, $lO4Or.ISSUE_TYPE_GQL_FIELD)} with ${(0, $lO4Or.ISSUE_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(fields ?? '')}]`);
    if (issueTypeField.issueType == null) throw new Error(`Failed to get system issue type: ${(0, $lO4Or.ISSUE_TYPE_GQL_FIELD)}.issueType is missing [${JSON.stringify(issueTypeField)}]`);
    return issueTypeField.issueType;
};
const $fddff707046980f2$export$2356062173546155 = (issueType)=>({
        ...$fddff707046980f2$export$d95e76b2d065f98d,
        id: issueType.issueTypeId,
        iconUrl: issueType.avatar?.medium ?? '',
        name: issueType.name,
        description: 'description' in issueType && issueType.description != null ? issueType.description : '',
        hierarchyLevel: issueType.hierarchy.level,
        subtask: issueType.hierarchy.level === (0, $edkGa.ISSUE_TYPE_HIERARCHY_LEVEL).SUBTASK_LEVEL
    });
const $fddff707046980f2$export$de2eb3b47c7c887b = (node)=>{
    if (node.type !== (0, $lO4Or.ISSUE_TYPE) || node.issueType == null) throw new Error(`Failed to transform ${(0, $lO4Or.ISSUE_TYPE_GQL_FIELD)}: type is not ${(0, $lO4Or.ISSUE_TYPE)} or 'issueType' is empty [${JSON.stringify(node)}]`);
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: $fddff707046980f2$export$2356062173546155(node.issueType),
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: (0, $lO4Or.ISSUE_TYPE),
            type: (0, $lO4Or.ISSUE_TYPE)
        }
    };
};

});
parcelRegister("edkGa", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPE_HIERARCHY_LEVEL", () => $b500da57c36bb99b$export$2fe6880f0073407c);

var $3l6tm = parcelRequire("3l6tm");
const $b500da57c36bb99b$export$2fe6880f0073407c = {
    SUBTASK_LEVEL: (0, $3l6tm.ISSUE_HIERARCHY_LEVEL_SUBTASK),
    BASE_LEVEL: (0, $3l6tm.ISSUE_HIERARCHY_LEVEL_BASE),
    LEVEL_ONE: (0, $3l6tm.ISSUE_HIERARCHY_LEVEL_EPIC),
    LEVEL_TWO: 2
};

});


parcelRegister("6MxWX", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMApprovalsToLegacyField", () => $3d843a7647f78c65$export$b14d30f2a9e4c343);

var $23qRX = parcelRequire("23qRX");

var $6vrw7 = parcelRequire("6vrw7");

var $23qRX = parcelRequire("23qRX");
var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $g5TY0 = parcelRequire("g5TY0");
const $3d843a7647f78c65$var$transformApproverPrincipalsToLegacy = (approverPrincipal)=>{
    if (!approverPrincipal) return undefined;
    switch(approverPrincipal.__typename){
        case 0, $lO4Or.JSM_USER_APPROVER_PRINCIPAL_FIELD:
            return {
                id: (0, $6vrw7.toAccountId)(approverPrincipal.user.accountId),
                name: approverPrincipal.user.name,
                meta: {
                    jiraRest: approverPrincipal.jiraRest
                },
                type: 'user',
                avatarUrl: approverPrincipal.user.picture
            };
        case 0, $lO4Or.JSM_GROUP_APPROVER_PRINCIPAL_FIELD:
            return {
                id: (0, $23qRX.toGroupId)(approverPrincipal.groupId),
                meta: {
                    memberCount: approverPrincipal.memberCount,
                    approvedCount: approverPrincipal.approvedCount
                },
                name: approverPrincipal.name,
                type: 'group'
            };
        default:
            return undefined;
    }
};
const $3d843a7647f78c65$var$getApproverDecision = (decision)=>{
    switch(decision){
        case 0, $23qRX.APPROVER_APPROVED:
            return 0, $23qRX.APPROVER_APPROVED;
        case 0, $23qRX.APPROVER_DECLINED:
            return 0, $23qRX.APPROVER_DECLINED;
        case 0, $23qRX.APPROVER_PENDING:
        default:
            return 0, $23qRX.APPROVER_PENDING;
    }
};
const $3d843a7647f78c65$var$transformApproverToLegacy = (approvalNode)=>{
    if (!approvalNode) return undefined;
    const approver = (0, $g5TY0.transformJiraUserToLegacyServerUser)(approvalNode.approver);
    if (!approver) return undefined;
    return {
        approverDecision: $3d843a7647f78c65$var$getApproverDecision(approvalNode.approverDecision),
        approver: approver
    };
};
const $3d843a7647f78c65$var$transformConfigurationToLegacy = (configurations)=>{
    // This function contains a lot of null checks and default empty values to satisfy flow because
    // the AGG type coming back is in the shape of [JiraServiceManagementApprovalConfiguration]
    // Which means technically it can be an empty array. Even though we will always only ever
    // get 1 object back.
    const { approversConfigurations: approversConfigurations = [], condition: condition } = configurations?.[0] || {};
    const approverConfiguration = approversConfigurations[0];
    return {
        approvers: {
            type: approverConfiguration?.type ?? '',
            customFieldName: approverConfiguration?.fieldName ?? '',
            customFieldId: approverConfiguration?.fieldId ?? ''
        },
        condition: {
            type: condition?.type ?? '',
            value: condition?.value ?? ''
        }
    };
};
const $3d843a7647f78c65$var$transformDateToLegacy = (date)=>({
        epochMillis: new Date(date).valueOf()
    });
const $3d843a7647f78c65$var$transformStatusToLegacy = (status)=>({
        name: status.name || '',
        category: Number(status.categoryId)
    });
const $3d843a7647f78c65$var$transformActiveApprovalToLegacy = (activeApproval)=>{
    const { id: id, configurations: configurations, status: status, createdDate: createdDate, canAnswerApproval: canAnswerApproval, pendingApprovalCount: pendingApprovalCount, name: name, finalDecision: finalDecision, approvalState: approvalState, approvedStatus: approvedStatus } = activeApproval;
    return {
        id: id,
        approvalState: approvalState,
        approvedStatus: approvedStatus,
        finalDecision: $3d843a7647f78c65$var$getApproverDecision(finalDecision),
        name: name,
        pendingApprovalCount: pendingApprovalCount,
        canAnswerApproval: canAnswerApproval,
        approverPrincipals: (0, $f4e7j.transformAggConnection)(activeApproval.approverPrincipals, $3d843a7647f78c65$var$transformApproverPrincipalsToLegacy),
        approvers: (0, $f4e7j.transformAggConnection)(activeApproval.approvers, $3d843a7647f78c65$var$transformApproverToLegacy),
        configuration: $3d843a7647f78c65$var$transformConfigurationToLegacy(configurations),
        createdDate: $3d843a7647f78c65$var$transformDateToLegacy(createdDate ?? ''),
        decisions: (0, $f4e7j.transformAggConnection)(activeApproval.decisions, $3d843a7647f78c65$var$transformApproverToLegacy),
        excludedApprovers: (0, $f4e7j.transformAggConnection)(activeApproval.excludedApprovers, (0, $g5TY0.transformJiraUserToLegacyServerUser)),
        status: status ? $3d843a7647f78c65$var$transformStatusToLegacy(status) : null
    };
};
const $3d843a7647f78c65$var$transformCompletedApprovalToLegacy = (completedApproval)=>{
    if (!completedApproval) return undefined;
    const { id: id, name: name, finalDecision: finalDecision, createdDate: createdDate, completedDate: completedDate, status: status } = completedApproval;
    return {
        id: id,
        name: name,
        finalDecision: $3d843a7647f78c65$var$getApproverDecision(finalDecision),
        createdDate: $3d843a7647f78c65$var$transformDateToLegacy(createdDate ?? ''),
        completedDate: $3d843a7647f78c65$var$transformDateToLegacy(completedDate),
        status: status ? $3d843a7647f78c65$var$transformStatusToLegacy(status) : null,
        approvers: (0, $f4e7j.transformAggConnection)(completedApproval.approvers, $3d843a7647f78c65$var$transformApproverToLegacy)
    };
};
const $3d843a7647f78c65$export$b14d30f2a9e4c343 = (node)=>{
    if (node.type !== (0, $lO4Or.SERVICEDESK_APPROVAL_TYPE)) return undefined;
    const activeApproval = node.activeApproval ? {
        activeApproval: $3d843a7647f78c65$var$transformActiveApprovalToLegacy(node.activeApproval)
    } : {};
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: {
            ...activeApproval,
            completedApprovals: (0, $f4e7j.transformAggConnection)(node.completedApprovalsConnection, $3d843a7647f78c65$var$transformCompletedApprovalToLegacy)
        },
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $lO4Or.SERVICEDESK_APPROVAL_TYPE),
            type: (0, $lO4Or.SERVICEDESK_APPROVAL_TYPE)
        }
    };
};

});
parcelRegister("23qRX", function(module, exports) {

$parcel$export(module.exports, "toGroupId", () => $f236b06d6aabb595$export$779c261480444a4d);
$parcel$export(module.exports, "APPROVER_PENDING", () => $f236b06d6aabb595$export$3b59c4db06f5829b);
$parcel$export(module.exports, "APPROVER_APPROVED", () => $f236b06d6aabb595$export$e17ae8ca1010e2a4);
$parcel$export(module.exports, "APPROVER_DECLINED", () => $f236b06d6aabb595$export$b5a0d270c9cd7435);
$parcel$export(module.exports, "APPROVAL_OK", () => $f236b06d6aabb595$export$2e6187b6a4348938);
const $f236b06d6aabb595$export$779c261480444a4d = (x)=>x;
const $f236b06d6aabb595$export$3b59c4db06f5829b = 'pending';
const $f236b06d6aabb595$export$e17ae8ca1010e2a4 = 'approved';
const $f236b06d6aabb595$export$b5a0d270c9cd7435 = 'declined';
const $f236b06d6aabb595$export$2e6187b6a4348938 = 'OK';
const $f236b06d6aabb595$export$b5d660d719b8009 = 'INSUFFICIENT_APPROVERS';

});


parcelRegister("9myMG", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMEntitlementsToLegacyField", () => $d0d645fec4d38846$export$850fadda8a5e6f27);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $d0d645fec4d38846$export$850fadda8a5e6f27 = (node)=>{
    if (node.type !== (0, $lO4Or.ENTITLEMENT_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.selectedEntitlement,
        schema: {
            configuration: null,
            custom: (0, $lO4Or.ENTITLEMENT_CF_TYPE),
            items: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("gM34d", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMMajorIncidentToLegacyField", () => $07db702730ef03b7$export$d4e0b2288fb31144);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $07db702730ef03b7$export$d4e0b2288fb31144 = (node)=>({
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.majorIncident,
        renderedValue: null,
        configuration: {},
        schema: {
            configuration: null,
            custom: (0, $lO4Or.MAJOR_INCIDENT_CF_TYPE),
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE)
        }
    });

});

parcelRegister("16kx8", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMOrganizationToLegacyField", () => $cedd80ccbf21d473$export$7bd14951253a7c5f);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $cedd80ccbf21d473$export$7bd14951253a7c5f = (node)=>{
    if (node.type !== (0, $lO4Or.ORGANIZATIONS_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: (0, $f4e7j.transformAggConnection)(node.selectedOrganizationsConnection, (selectedNode)=>({
                id: selectedNode.organizationId,
                name: selectedNode.organizationName
            })),
        schema: {
            configuration: null,
            custom: (0, $lO4Or.ORGANIZATIONS_CF_TYPE),
            items: 'sd-customerorganization',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("4IQ8F", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestFeedbackToLegacyField", () => $2d53157bbab9736d$export$c52c6988b335096);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $2d53157bbab9736d$export$c52c6988b335096 = (node)=>{
    if (node.type !== (0, $lO4Or.REQUEST_FEEDBACK_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.feedback,
        schema: {
            type: 'sd-feedback',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: (0, $lO4Or.REQUEST_FEEDBACK_CF_TYPE),
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("lcInz", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestLanguageToLegacyField", () => $32361ac554652aa8$export$6a53240e225f742);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $32361ac554652aa8$export$6a53240e225f742 = (node)=>{
    if (node.type !== (0, $lO4Or.REQUEST_LANGUAGE_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.language,
        allowedValues: [
            ...node.languages ?? []
        ],
        schema: {
            type: 'sd-request-lang',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: (0, $lO4Or.REQUEST_LANGUAGE_CF_TYPE),
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("4PFnn", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestTypeToLegacyField", () => $97b247bfb6fb2bf8$export$5ffaab1383177efa);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $97b247bfb6fb2bf8$var$transformRequestTypeToLegacy = (requestType)=>{
    if (!requestType) return null;
    return {
        requestType: {
            id: parseInt(requestType.requestTypeId, 10),
            issueTypeId: requestType.issueType?.issueTypeId || '',
            name: requestType.name || '',
            icon: {
                _links: {
                    iconUrls: {
                        '48x48': requestType.avatar?.large || ''
                    }
                }
            }
        }
    };
};
const $97b247bfb6fb2bf8$export$5ffaab1383177efa = (node)=>{
    if (node.type !== (0, $lO4Or.REQUEST_TYPE_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        // @ts-expect-error - Argument of type '{ readonly avatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly id: string; readonly issueType: { ...; } | ... 1 more ... | undefined; readonly name: strin...' is not assignable to parameter of type '{ readonly avatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly id: string; readonly issueType: { ...; } | ... 1 more ... | undefined; readonly name: strin...'.
        value: $97b247bfb6fb2bf8$var$transformRequestTypeToLegacy(node.requestType),
        schema: {
            configuration: null,
            custom: (0, $lO4Or.REQUEST_TYPE_CF_TYPE),
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'sd-customerrequesttype'
        }
    };
};

});

parcelRegister("alpM1", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRespondersToLegacyField", () => $e4d9f726b0420c01$export$5171c4d1ae5bcde5);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $e4d9f726b0420c01$var$transformJiraResponderToLegacyResponder = (responder)=>{
    if (responder == null) return undefined;
    switch(responder.__typename){
        case 0, $lO4Or.JSM_USER_RESPONDER_GQL_FIELD:
            if (responder.user === null) return undefined;
            return {
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                ari: responder.user.canonicalAccountId,
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                avatarUrl: responder.user.picture,
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                name: responder.user.name,
                type: 'user'
            };
        case 0, $lO4Or.JSM_TEAM_RESPONDER_FIELD:
            return {
                // @ts-expect-error - Type 'string | null | undefined' is not assignable to type 'string | null'.
                ari: responder.teamId,
                // @ts-expect-error - Type 'string | null | undefined' is not assignable to type 'string | null'.
                name: responder.teamName,
                type: 'team'
            };
        default:
            return undefined;
    }
};
const $e4d9f726b0420c01$export$5171c4d1ae5bcde5 = (node)=>{
    if (node.type !== (0, $lO4Or.RESPONDERS_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?query=` : null,
        value: (0, $f4e7j.transformAggConnection)(node.respondersConnection, $e4d9f726b0420c01$var$transformJiraResponderToLegacyResponder),
        schema: {
            configuration: null,
            custom: (0, $lO4Or.RESPONDERS_CF_TYPE),
            items: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("l6kyU", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMSentimentToLegacyField", () => $760020295c96925b$export$702d3754a4c7d90a);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $760020295c96925b$export$702d3754a4c7d90a = (node)=>{
    if (node.type !== (0, $lO4Or.SENTIMENT_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.sentiment,
        schema: {
            configuration: null,
            custom: (0, $lO4Or.SENTIMENT_CF_TYPE),
            items: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("gHd8e", function(module, exports) {

$parcel$export(module.exports, "transformAggLabelsNodeToLegacyField", () => $e9d06b1cdd22d77f$export$98e4f56e2e6c44fe);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $e9d06b1cdd22d77f$var$defaultSchema = {
    configuration: null,
    items: 'string',
    type: (0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f)
};
const $e9d06b1cdd22d77f$export$98e4f56e2e6c44fe = (node)=>{
    const selectedLabels = (0, $f4e7j.transformAggConnection)(node.selectedLabelsConnection, ({ name: name })=>name);
    switch(node.type){
        case 0, $lO4Or.LABELS_TYPE:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: selectedLabels,
                schema: {
                    ...$e9d06b1cdd22d77f$var$defaultSchema,
                    custom: null,
                    system: node.type
                }
            };
        case 0, $lO4Or.LABELS_CF_TYPE:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                // empty value for custom labels field is null while system labels field is `[]`
                value: selectedLabels.length === 0 ? null : selectedLabels,
                schema: {
                    ...$e9d06b1cdd22d77f$var$defaultSchema,
                    custom: node.type,
                    system: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("dUrU1", function(module, exports) {

$parcel$export(module.exports, "transformAggMultiGroupPickerToLegacyField", () => $bf00e02f796ca76f$export$f968da580693597d);


var $f4e7j = parcelRequire("f4e7j");
const $bf00e02f796ca76f$export$f968da580693597d = (node)=>{
    const value = (0, $f4e7j.transformAggConnection)(node.selectedGroupsConnection, (groupNode)=>({
            groupId: groupNode.groupId,
            name: groupNode.name
        }));
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value.length > 0 ? value : null,
        schema: {
            type: 'array',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: 'group',
            configuration: null
        }
    };
};

});

parcelRegister("hQM7C", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleSelectToLegacyField", () => $b77f8634d7271da6$export$869fb8fbcb97e0ee);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $b77f8634d7271da6$export$869fb8fbcb97e0ee = (node)=>{
    switch(node.type){
        case 0, $lO4Or.MULTI_SELECT_CF_TYPE:
            {
                const value = (0, $f4e7j.transformAggConnection)(node.selectedOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                return {
                    ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                    value: value.length ? value : null,
                    allowedValues: [],
                    schema: {
                        type: 'array',
                        renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                        custom: node.type,
                        system: null,
                        items: 'option',
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("QjWSM", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleUserPickerToLegacyField", () => $c7caa94b89e539e2$export$cdd9991119eb040e);

var $7ZZxN = parcelRequire("7ZZxN");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $ijtj3 = parcelRequire("ijtj3");

var $g5TY0 = parcelRequire("g5TY0");
const $c7caa94b89e539e2$export$cdd9991119eb040e = (node, context)=>{
    const value = (0, $f4e7j.transformAggConnection)(node.selectedUsersConnection, (0, $g5TY0.transformJiraUserToLegacyServerUser));
    const legacyFieldValues = {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value.length > 0 ? value : null,
        schema: {
            configuration: null,
            custom: node.type,
            items: 'user',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
    switch(node.type){
        case 0, $lO4Or.REQUEST_PARTICIPANTS_CF_TYPE:
            {
                const project = (0, $ijtj3.getSystemAggJiraProject)(context);
                if ((0, $ijtj3.getProjectType)(project.projectType) !== (0, $7ZZxN.SERVICE_DESK_PROJECT)) return undefined;
                // Empty array is the expected value when there are no request
                // participants.
                return {
                    ...legacyFieldValues,
                    value: value
                };
            }
        case 0, $lO4Or.PARTICIPANTS_CF_TYPE:
        case 0, $lO4Or.MULTI_USER_CF_TYPE:
            return legacyFieldValues;
        case 0, $lO4Or.APPROVERS_LIST_CF_TYPE:
        case 0, $lO4Or.PEOPLE_CF_TYPE:
            {
                const schemaConfig = 'isMulti' in node && node.isMulti != null ? [
                    {
                        key: 'isMulti',
                        value: String(node.isMulti)
                    }
                ] : null;
                return {
                    ...legacyFieldValues,
                    autoCompleteUrl: node.searchUrl,
                    schema: {
                        ...legacyFieldValues.schema,
                        configuration: schemaConfig
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("4CGp4", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleVersionPickerToLegacyField", () => $3d2f68ea759270b4$export$6207ea60703068d8);

var $1ybV0 = parcelRequire("1ybV0");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $hd35n = parcelRequire("hd35n");
const $3d2f68ea759270b4$var$defaultSchema = {
    configuration: null,
    custom: null,
    items: 'version',
    renderer: (0, $c7e7b1d3600a0c0f$export$840ed33fa94f7693),
    system: null,
    type: 'array'
};
const $3d2f68ea759270b4$export$6207ea60703068d8 = (node)=>{
    if (node.type !== (0, $lO4Or.MULTI_VERSION_CF_TYPE) && node.type !== (0, $lO4Or.AFFECTS_VERSIONS_TYPE) && node.type !== (0, $lO4Or.FIX_VERSIONS_TYPE)) return undefined;
    const legacyFieldValues = {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        allowedValues: (0, $f4e7j.transformAggConnection)(node.multiPickerVersions, (0, $1ybV0.ff)('issue.details.relay-release-version-field-issue-view-integration') ? (0, $hd35n.transformAggVersionToLegacyVersion) : (0, $hd35n.transformAggVersionToLegacyVersionOld)),
        value: (0, $f4e7j.transformAggConnection)(node.selectedVersionsConnection, (0, $1ybV0.ff)('issue.details.relay-release-version-field-issue-view-integration') ? (0, $hd35n.transformAggVersionToLegacyVersion) : (0, $hd35n.transformAggVersionToLegacyVersionOld))
    };
    switch(node.type){
        case 0, $lO4Or.MULTI_VERSION_CF_TYPE:
            return {
                ...legacyFieldValues,
                value: legacyFieldValues.value.length === 0 ? null : legacyFieldValues.value,
                schema: {
                    ...$3d2f68ea759270b4$var$defaultSchema,
                    custom: (0, $lO4Or.MULTI_VERSION_CF_TYPE)
                }
            };
        case 0, $lO4Or.AFFECTS_VERSIONS_TYPE:
        case 0, $lO4Or.FIX_VERSIONS_TYPE:
            return {
                ...legacyFieldValues,
                allowedValues: legacyFieldValues.allowedValues.filter((v)=>!v.archived),
                schema: {
                    ...$3d2f68ea759270b4$var$defaultSchema,
                    system: node.type
                }
            };
        default:
            return undefined;
    }
};

});
parcelRegister("hd35n", function(module, exports) {

$parcel$export(module.exports, "transformAggVersionToLegacyVersionOld", () => $41957f3e8e88f6a1$export$5427f5949bb0492d);
$parcel$export(module.exports, "transformAggVersionToLegacyVersion", () => $41957f3e8e88f6a1$export$becef8d087e8b62b);

var $exWH1 = parcelRequire("exWH1");
const $41957f3e8e88f6a1$export$5427f5949bb0492d = (version)=>({
        id: version.versionId ?? '',
        name: version.name ?? '',
        description: version.description ?? '',
        archived: version.status === (0, $exWH1.VersionStatus).ARCHIVED,
        released: version.status === (0, $exWH1.VersionStatus).RELEASED
    });
const $41957f3e8e88f6a1$export$becef8d087e8b62b = (version)=>({
        id: version.versionId ?? '',
        name: version.name ?? '',
        description: version.description ?? '',
        archived: version.status === (0, $exWH1.VersionStatus).ARCHIVED,
        released: version.status === (0, $exWH1.VersionStatus).RELEASED,
        ari: version.id
    });

});
parcelRegister("exWH1", function(module, exports) {

$parcel$export(module.exports, "VersionStatus", () => $4c4bb928a168d525$export$8c6e0f93bfb5c6a4);

var $23qRX = parcelRequire("23qRX");
var $03XEB = parcelRequire("03XEB");
var $edkGa = parcelRequire("edkGa");

var $lO4Or = parcelRequire("lO4Or");

const $4c4bb928a168d525$export$8c6e0f93bfb5c6a4 = {
    ARCHIVED: 'ARCHIVED',
    RELEASED: 'RELEASED',
    UNRELEASED: 'UNRELEASED'
};

});
parcelRegister("03XEB", function(module, exports) {

$parcel$export(module.exports, "INWARD_LINK_DIRECTION", () => $dc38a98d5f20359c$export$b5e2b68b0fa7f1c8);
$parcel$export(module.exports, "OUTWARD_LINK_DIRECTION", () => $dc38a98d5f20359c$export$5dec99d71ec794ba);
$parcel$export(module.exports, "BOTH_LINK_DIRECTION", () => $dc38a98d5f20359c$export$6cdcf74878b11d34);
$parcel$export(module.exports, "IssueLinkDirectionTypes", () => $dc38a98d5f20359c$export$4b7bcc27238c61b9);
const $dc38a98d5f20359c$export$b5e2b68b0fa7f1c8 = 'INWARD';
const $dc38a98d5f20359c$export$5dec99d71ec794ba = 'OUTWARD';
const $dc38a98d5f20359c$export$6cdcf74878b11d34 = 'BOTH';
const $dc38a98d5f20359c$export$4b7bcc27238c61b9 = {
    [$dc38a98d5f20359c$export$b5e2b68b0fa7f1c8]: $dc38a98d5f20359c$export$b5e2b68b0fa7f1c8,
    [$dc38a98d5f20359c$export$5dec99d71ec794ba]: $dc38a98d5f20359c$export$5dec99d71ec794ba,
    [$dc38a98d5f20359c$export$6cdcf74878b11d34]: $dc38a98d5f20359c$export$6cdcf74878b11d34
};

});




parcelRegister("lWE99", function(module, exports) {

$parcel$export(module.exports, "transformAggNumberToLegacyField", () => $1ea236981671650b$export$d754a24ed0096d2f);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $1ea236981671650b$export$d754a24ed0096d2f = (node)=>{
    const fieldType = node.isStoryPointField === true ? (0, $lO4Or.STORY_POINTS_TYPE) : node.type;
    switch(fieldType){
        case 0, $lO4Or.NUMBER_CF_TYPE:
        case 0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE:
        case 0, $lO4Or.STORY_POINTS_TYPE:
            return {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: node.number ?? null,
                schema: {
                    configuration: null,
                    items: null,
                    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                    custom: fieldType,
                    system: null,
                    type: (0, $lO4Or.ISSUE_FIELD_NUMBER_CF_TYPE)
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("4eNqf", function(module, exports) {

$parcel$export(module.exports, "transformAggOriginalEstimateToLegacyField", () => $50d87f174d910a4b$export$f08d02fdc74f920e);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $50d87f174d910a4b$export$f08d02fdc74f920e = (node)=>{
    if (node.type !== (0, $lO4Or.TIME_ESTIMATE_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.originalEstimate?.timeInSeconds ?? null,
        schema: {
            configuration: null,
            custom: null,
            system: node.type,
            items: null,
            type: (0, $lO4Or.ISSUE_FIELD_NUMBER_CF_TYPE),
            renderer: null
        }
    };
};

});

parcelRegister("fkHM1", function(module, exports) {

$parcel$export(module.exports, "transformAggPriorityToLegacyField", () => $ccf6d66eff5dbc1f$export$9e966ce605f800d2);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $ccf6d66eff5dbc1f$var$transformJiraPriorityToLegacyPriority = (priority)=>{
    if (priority == null) return null;
    return {
        id: priority.priorityId,
        iconUrl: String(priority.iconUrl || ''),
        name: priority.name || '',
        sequence: priority.sequence || undefined
    };
};
const $ccf6d66eff5dbc1f$export$9e966ce605f800d2 = (node)=>{
    if (node.type !== (0, $lO4Or.PRIORITY_TYPE)) return undefined;
    const allowedValues = (0, $f4e7j.transformAggConnection)('priorities' in node ? node.priorities : null, $ccf6d66eff5dbc1f$var$transformJiraPriorityToLegacyPriority);
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        allowedValues: allowedValues,
        // @ts-expect-error - Argument of type '{ readonly color: string | null | undefined; readonly iconUrl: string | null | undefined; readonly name: string | null | undefined; readonly priorityId: string; } | { readonly iconUrl: string | ... 1 more ... | undefined; readonly name: string | ... 1 more ... | undefined; readonly priorityId: string; } | { ...; } |...' is not assignable to parameter of type 'AggJiraPriority | null'.
        value: $ccf6d66eff5dbc1f$var$transformJiraPriorityToLegacyPriority(node.priority),
        schema: {
            type: (0, $lO4Or.PRIORITY_TYPE),
            custom: null,
            system: (0, $lO4Or.PRIORITY_TYPE),
            configuration: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f)
        }
    };
};

});

parcelRegister("fkaQR", function(module, exports) {

$parcel$export(module.exports, "transformAggProformaFormsToLegacyField", () => $b1792cecaa8dedc0$export$fdcdbf17b0d4e36f);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $b1792cecaa8dedc0$export$fdcdbf17b0d4e36f = (node)=>{
    if (node.type !== (0, $lO4Or.PROFORMA_FORMS)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.proformaForms,
        schema: {
            configuration: null,
            items: null,
            system: (0, $lO4Or.PROFORMA_FORMS),
            custom: null,
            renderer: null,
            type: (0, $lO4Or.PROFORMA_FORMS)
        }
    };
};

});

parcelRegister("gyvos", function(module, exports) {

$parcel$export(module.exports, "transformAggRadioSelectToLegacyField", () => $f7afb2486834699b$export$f147f1eb3a15ccfc);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $f7afb2486834699b$export$f147f1eb3a15ccfc = (node)=>{
    if (node.type !== (0, $lO4Or.RADIO_BUTTONS_CF_TYPE)) return undefined;
    const value = node.selectedOption ? {
        id: node.selectedOption?.optionId,
        value: node.selectedOption?.value,
        isDisabled: node.selectedOption?.isDisabled
    } : null;
    const allowedValues = (0, $f4e7j.transformAggConnection)(node.radioSelectFieldOptions, (option)=>({
            id: option.optionId,
            value: option.value ?? null,
            ari: option.id
        }));
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: allowedValues,
        schema: {
            type: 'option',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("3w75b", function(module, exports) {

$parcel$export(module.exports, "transformAggResolutionToLegacyField", () => $5302369645b034cd$export$179f600c7e1d0230);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $5302369645b034cd$var$resolutionTransformer = (resolution)=>{
    if (resolution == null) return null;
    return {
        id: resolution.resolutionId,
        name: resolution.name || ''
    };
};
const $5302369645b034cd$export$179f600c7e1d0230 = (node)=>{
    if (node.type !== (0, $lO4Or.RESOLUTION_TYPE)) return undefined;
    const value = $5302369645b034cd$var$resolutionTransformer(node.resolution);
    const allowedValues = (0, $f4e7j.transformAggConnection)(node.resolutions, $5302369645b034cd$var$resolutionTransformer);
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: allowedValues,
        schema: {
            type: (0, $lO4Or.RESOLUTION_TYPE),
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: null,
            system: (0, $lO4Or.RESOLUTION_TYPE),
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("lQr58", function(module, exports) {

$parcel$export(module.exports, "transformAggRichTextToLegacyField", () => $63df895e1ecc6044$export$e65ff2ce94be106e);

var $esUXI = parcelRequire("esUXI");

var $7Vbpp = parcelRequire("7Vbpp");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $2qVcp = parcelRequire("2qVcp");
const $63df895e1ecc6044$var$emptyAdfObject = (0, $esUXI.getEmptyADF)();
const $63df895e1ecc6044$var$getSchema = (aggType, renderer)=>{
    switch(aggType){
        case 0, $lO4Or.TEXT_AREA_CF_TYPE:
            return {
                custom: aggType,
                renderer: renderer,
                type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
                system: null,
                configuration: null,
                items: null
            };
        case 0, $lO4Or.DESCRIPTION_TYPE:
        case 0, $lO4Or.ENVIRONMENT_TYPE:
        default:
            return {
                system: aggType,
                renderer: renderer,
                type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
                custom: null,
                configuration: null,
                items: null
            };
    }
};
// Exactly match the legacy /graphql value, handling the case where the field is empty and has never been edited
// There's no functional difference between `null` or empty string when rendering the field in the issue view.
const $63df895e1ecc6044$var$getPlainTextValue = (node)=>{
    // When the field is empty and a value has never been set
    if (!node.richText) return null;
    // When the field has been set to a value, and then set back to empty
    if (node.richText?.plainText == null) return '';
    return node.richText?.plainText;
};
const $63df895e1ecc6044$export$e65ff2ce94be106e = (node)=>{
    // Description field always renders with ADF
    const { renderer: renderer } = node;
    if ((0, $2qVcp.default)(node)) return undefined;
    const isPlainTextRenderer = node.type !== (0, $lO4Or.DESCRIPTION_TYPE) && renderer === (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f);
    if (isPlainTextRenderer) return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: $63df895e1ecc6044$var$getPlainTextValue(node),
        schema: $63df895e1ecc6044$var$getSchema(node.type, renderer)
    };
    const adfValueJson = node.richText?.adfValue?.json ?? null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        // The usages of the collection is deprecated.
        adfValue: adfValueJson ? (0, $7Vbpp.removeCollectionFromAdf)(adfValueJson) : $63df895e1ecc6044$var$emptyAdfObject,
        value: null,
        schema: $63df895e1ecc6044$var$getSchema(node.type, renderer)
    };
};

});
parcelRegister("7Vbpp", function(module, exports) {

$parcel$export(module.exports, "emptyAdfObject", () => $e11eab7652408d68$export$202742e99f678c60);
$parcel$export(module.exports, "removeCollectionFromAdf", () => $e11eab7652408d68$export$9e9311e676291037);
$parcel$export(module.exports, "convertAdfStringToObject", () => $e11eab7652408d68$export$ee70d4eb14697455);
$parcel$export(module.exports, "isOnlyWhitespaceAdf", () => $e11eab7652408d68$export$cf4bde415465976c);
$parcel$export(module.exports, "removeNewLineCharactersFromAdf", () => $e11eab7652408d68$export$d6ce0667c33b94ff);
$parcel$export(module.exports, "removeTrailingNewLineCharacters", () => $e11eab7652408d68$export$3688e35a300432d6);
$parcel$export(module.exports, "simplifyAdf", () => $e11eab7652408d68$export$def86d25f0c7f0bc);
$parcel$export(module.exports, "hasMediaFileNodes", () => $e11eab7652408d68$export$9a632b58fb9b287c);
$parcel$export(module.exports, "hasMediaFileNodesUpdated", () => $e11eab7652408d68$export$80a6e90c7b29d88c);

var $6qhKX = parcelRequire("6qhKX");
var $hYZXM = parcelRequire("hYZXM");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");
const $e11eab7652408d68$export$202742e99f678c60 = {
    type: 'doc',
    version: 1,
    content: []
};
const $e11eab7652408d68$export$9e9311e676291037 = (adf)=>{
    if (adf === null || adf === undefined) return null;
    if (adf.type === 'media' && adf.attrs) return {
        ...adf,
        attrs: {
            ...adf.attrs,
            collection: ''
        }
    };
    if ((0, $1ybV0.ff)('issue.details.media-inline') && adf.type === 'mediaInline' && adf.attrs) return {
        ...adf,
        attrs: {
            ...adf.attrs,
            collection: ''
        }
    };
    if (adf.content) return {
        ...adf,
        content: adf.content.map($e11eab7652408d68$export$9e9311e676291037)
    };
    return adf;
};
const $e11eab7652408d68$export$ee70d4eb14697455 = (adf)=>{
    if (typeof adf === 'string') try {
        return $e11eab7652408d68$export$9e9311e676291037(JSON.parse(adf));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('rich-content.convert-adf-to-object', 'Failed to parse rich content', error);
        return null;
    }
    return $e11eab7652408d68$export$9e9311e676291037(adf);
};
const $e11eab7652408d68$export$cf4bde415465976c = (adf)=>adf && adf.content ? adf.content.every((content)=>{
        if (content.type === 'paragraph') return !content.content || content.content.length === 0 || content.content.every((innerContent)=>innerContent.type === 'text' ? (innerContent.text || '').match(/^\s*$/) !== null : false);
        return false;
    }) : false;
const $e11eab7652408d68$export$d6ce0667c33b94ff = (adf)=>{
    if (!adf || !adf.content) return $e11eab7652408d68$export$202742e99f678c60;
    let len;
    for(len = adf.content.length - 1; len >= 0 && adf.content[len].content && adf.content[len].type === 'paragraph' && adf.content[len].content.length === 0; len -= 1){
        // if the last item of the node is of type mediaGroup, we don't want to strip newline character as
        // it practically makes it unclickable. Leave a new line character so there is still some space for ppl to click
        if (len > 0 && adf.content[len - 1].type === 'mediaGroup') break;
    }
    return {
        ...adf,
        content: adf.content.slice(0, len + 1)
    };
};
const $e11eab7652408d68$export$3688e35a300432d6 = (text)=>text.replace(/[\r\n]+$/, '');
const $e11eab7652408d68$export$def86d25f0c7f0bc = (adf)=>$e11eab7652408d68$export$cf4bde415465976c(adf) ? $e11eab7652408d68$export$202742e99f678c60 : adf;
const $e11eab7652408d68$export$9a632b58fb9b287c = (doc)=>{
    if ((0, $1ybV0.ff)('issue.details.media-inline')) {
        const mediaNodes = new Map();
        (0, $hYZXM.traverse)(doc, {
            media: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaNode = node;
                if (mediaNode.attrs.type === 'external') return;
                mediaNodes.set(mediaNode.attrs.id, node);
            },
            mediaInline: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaInlineNode = node;
                mediaNodes.set(mediaInlineNode.attrs.id, node);
            }
        });
        return mediaNodes.size > 0;
    }
    const mediaNodes = new Map();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $hYZXM.traverse)(doc, {
        media: (node)=>{
            if (!node.attrs.id || node.attrs.collection === undefined) return;
            mediaNodes.set(node.attrs.id, node);
        }
    });
    return mediaNodes.size > 0;
};
const $e11eab7652408d68$export$80a6e90c7b29d88c = (currentDoc, newDoc)=>{
    if ((0, $1ybV0.ff)('issue.details.media-inline')) {
        const currentMediaNodes = new Set();
        const newMediaNodes = new Set();
        const updatedMediaNodes = new Set();
        if (newDoc) (0, $hYZXM.traverse)(newDoc, {
            media: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaNode = node;
                if (mediaNode.attrs.type === 'external') return;
                newMediaNodes.add(mediaNode.attrs.id);
            },
            mediaInline: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaInlineNode = node;
                newMediaNodes.add(mediaInlineNode.attrs.id);
            }
        });
        if (currentDoc) (0, $hYZXM.traverse)(currentDoc, {
            media: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaNode = node;
                if (mediaNode.attrs.type === 'external') return;
                currentMediaNodes.add(mediaNode.attrs.id);
                if (newMediaNodes.size) {
                    const matchedNode = newMediaNodes.has(mediaNode.attrs.id);
                    if (!matchedNode) updatedMediaNodes.add(mediaNode.attrs.id);
                }
            },
            mediaInline: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaInlineNode = node;
                currentMediaNodes.add(mediaInlineNode.attrs.id);
                if (newMediaNodes.size) {
                    const matchedNode = newMediaNodes.has(mediaInlineNode.attrs.id);
                    if (!matchedNode) updatedMediaNodes.add(mediaInlineNode.attrs.id);
                }
            }
        });
        return currentMediaNodes.size !== newMediaNodes.size || !!updatedMediaNodes.size;
    }
    const currentMediaNodes = new Set();
    const newMediaNodes = new Set();
    const updatedMediaNodes = new Set();
    if (newDoc) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $hYZXM.traverse)(newDoc, {
        media: (node)=>{
            if (!node.attrs.id || node.attrs.collection === undefined) return;
            newMediaNodes.add(node.attrs.id);
        }
    });
    if (currentDoc) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $hYZXM.traverse)(currentDoc, {
        media: (node)=>{
            if (!node.attrs.id || node.attrs.collection === undefined) return;
            currentMediaNodes.add(node.attrs.id);
            if (newMediaNodes.size) {
                const matchedNode = newMediaNodes.has(node.attrs.id);
                if (!matchedNode) updatedMediaNodes.add(node.attrs.id);
            }
        }
    });
    return currentMediaNodes.size !== newMediaNodes.size || !!updatedMediaNodes.size;
};
const $e11eab7652408d68$export$ddf077301434502d = (doc)=>{
    if (doc === null || doc === undefined) return false;
    const nonSimpleTextNodes = (0, $6qhKX.filter)(doc, (node)=>node.type !== 'paragraph' && node.type !== 'doc' && node.type !== 'text');
    return nonSimpleTextNodes.length === 0;
};



const $e11eab7652408d68$export$2277e89f0b6d4ed = async (node)=>{
    // the imports here were kept async so as not to blow the bundle sizes for everyone
    const { defaultSchema: defaultSchema } = await (parcelRequire("kM8T5"));
    const { WikiMarkupTransformer: WikiMarkupTransformer } = await (parcelRequire("fDLsg"));
    const { JSONTransformer: JSONTransformer } = await (parcelRequire("dIRBZ"));
    const jsonTransformer = new JSONTransformer();
    const wikiMarkupTransformer = new WikiMarkupTransformer(defaultSchema);
    if (node === null || node === undefined) return '';
    const pmNode = jsonTransformer.parse(node);
    return wikiMarkupTransformer.encode(pmNode);
};

});
parcelRegister("6qhKX", function(module, exports) {

$parcel$export(module.exports, "filter", () => $d1e7bd2dc2348b7c$export$3dea766d36a8935f);

var $hYZXM = parcelRequire("hYZXM");
function $d1e7bd2dc2348b7c$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $hYZXM.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}

});
parcelRegister("hYZXM", function(module, exports) {

$parcel$export(module.exports, "traverse", () => $ed8bc6cb8f4f14d7$export$df3f009e3d155b20);
function $ed8bc6cb8f4f14d7$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $ed8bc6cb8f4f14d7$export$df3f009e3d155b20(adf, visitors) {
    if (!$ed8bc6cb8f4f14d7$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
    return $ed8bc6cb8f4f14d7$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $ed8bc6cb8f4f14d7$var$traverseNode(adfNode, parent, visitors, index, depth) {
    const visitor = visitors[adfNode.type] || visitors['any'];
    let newNode = {
        ...adfNode
    };
    if (visitor) {
        const processedNode = visitor({
            ...newNode
        }, parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
        if (!node) return acc;
        const processedNode = $ed8bc6cb8f4f14d7$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});


parcelRegister("kM8T5", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('deyW2');
        const value = parcelRequire('9wcjJ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("deyW2").then(()=>parcelRequire('9wcjJ'));
}

});

parcelRegister("fDLsg", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('apXnN');
        const value = parcelRequire('fjUC0');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("apXnN").then(()=>parcelRequire('fjUC0'));
}

});

parcelRegister("dIRBZ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('kYJkV');
        const value = parcelRequire('3M3qX');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("kYJkV").then(()=>parcelRequire('3M3qX'));
}

});



parcelRegister("8oO4q", function(module, exports) {

$parcel$export(module.exports, "transformAggSecurityLevelToLegacyField", () => $28a96bf619a924f9$export$45e25e2a6750ea5a);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $28a96bf619a924f9$var$transformJiraSecurityLevel = (securityLevel)=>{
    if (securityLevel == null) return null;
    return {
        id: securityLevel.securityId,
        description: securityLevel.description || '',
        name: securityLevel.name || ''
    };
};
const $28a96bf619a924f9$export$45e25e2a6750ea5a = (node)=>({
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: $28a96bf619a924f9$var$transformJiraSecurityLevel(node.securityLevel),
        allowedValues: (0, $f4e7j.transformAggConnection)(node.securityLevels, $28a96bf619a924f9$var$transformJiraSecurityLevel),
        schema: {
            configuration: null,
            type: (0, $lO4Or.SECURITY_LEVEL_TYPE_OVERRIDE),
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: null,
            system: (0, $lO4Or.SECURITY_LEVEL_TYPE),
            items: null
        }
    });

});

parcelRegister("5Ne6t", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleGroupPickerToLegacyField", () => $1b8c5a144aba3441$export$e6697ec5bdac9ec0);


var $f4e7j = parcelRequire("f4e7j");
const $1b8c5a144aba3441$export$e6697ec5bdac9ec0 = (node)=>{
    const value = node.selectedGroup != null ? {
        groupId: node.selectedGroup.groupId,
        name: node.selectedGroup.name
    } : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            type: 'group',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("2ETkN", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleLineTextToLegacyField", () => $84dcb0c130bea779$export$31f32b3fd9e5ab6);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $84dcb0c130bea779$var$defaultSchema = {
    configuration: null,
    items: null,
    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f)
};
const $84dcb0c130bea779$export$31f32b3fd9e5ab6 = (node)=>{
    const defaultTransformedField = {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.text
    };
    switch(node.type){
        case 0, $lO4Or.EPIC_NAME_TYPE:
        case 0, $lO4Or.MESSAGE_EDIT_CF_TYPE:
        case 0, $lO4Or.MESSAGE_VIEW_CF_TYPE:
        case 0, $lO4Or.READ_ONLY_CF_TYPE:
        case 0, $lO4Or.TEXT_CF_TYPE:
        case 0, $lO4Or.USER_PROPERTY_CF_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$84dcb0c130bea779$var$defaultSchema,
                    custom: node.type,
                    system: null,
                    type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE)
                }
            };
        case 0, $lO4Or.RANK_CF_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$84dcb0c130bea779$var$defaultSchema,
                    custom: node.type,
                    system: null,
                    type: (0, $lO4Or.ISSUE_FIELD_ANY_CF_TYPE)
                }
            };
        case 0, $lO4Or.SUMMARY_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$84dcb0c130bea779$var$defaultSchema,
                    type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
                    custom: null,
                    system: node.type
                }
            };
        case 0, $lO4Or.SERVICEDESK_PRACTICES_TYPE:
            // Transform field only if the practice has a value
            return node.text != null ? {
                ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
                value: [
                    node.text
                ],
                schema: {
                    ...$84dcb0c130bea779$var$defaultSchema,
                    renderer: null,
                    custom: null,
                    system: node.type,
                    type: (0, $lO4Or.SERVICEDESK_PRACTICES_TYPE)
                }
            } : undefined;
        default:
            return undefined;
    }
};

});

parcelRegister("fz8Wc", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleSelectToLegacyField", () => $6eb6c9de60f230bb$export$4e113f935e09d226);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $6eb6c9de60f230bb$var$getField = (node, customType)=>{
    const value = node.fieldOption != null ? {
        ari: node.fieldOption.id,
        id: node.fieldOption.optionId,
        value: node.fieldOption.value
    } : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            type: 'option',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            custom: customType || node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};
const $6eb6c9de60f230bb$export$4e113f935e09d226 = (node)=>{
    switch(node.type){
        case 0, $lO4Or.EPIC_STATUS_TYPE:
        case 0, $lO4Or.SELECT_CF_TYPE:
            return $6eb6c9de60f230bb$var$getField(node);
        case 0, $lO4Or.CATEGORY_TYPE:
            return $6eb6c9de60f230bb$var$getField(node, (0, $lO4Or.SELECT_CF_TYPE));
        default:
            return undefined;
    }
};

});

parcelRegister("jBiXV", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleSelectUserPickerToLegacyField", () => $13d89b5e83359a47$export$7bf73fc06c6d71be);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $g5TY0 = parcelRequire("g5TY0");
const $13d89b5e83359a47$export$7bf73fc06c6d71be = (node)=>{
    const legacyField = {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.user ? (0, $g5TY0.transformJiraUserToLegacyServerUser)(node.user) : null
    };
    switch(node.type){
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
            return {
                ...legacyField,
                schema: {
                    type: (0, $lO4Or.ISSUE_FIELD_USER_CF_TYPE),
                    custom: null,
                    system: node.type,
                    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                    configuration: null,
                    items: null
                }
            };
        case 0, $lO4Or.USER_CF_TYPE:
        case 0, $lO4Or.LAST_UPDATER_OR_COMMENTER_CF_TYPE:
            return {
                ...legacyField,
                schema: {
                    type: (0, $lO4Or.ISSUE_FIELD_USER_CF_TYPE),
                    custom: node.type,
                    system: null,
                    renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
                    configuration: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("1XUHd", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleVersionPickerToLegacyField", () => $c650b563dc539b29$export$d03f622577260442);

var $1ybV0 = parcelRequire("1ybV0");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");

var $hd35n = parcelRequire("hd35n");
const $c650b563dc539b29$export$d03f622577260442 = (node)=>{
    if (node.type !== (0, $lO4Or.VERSION_CF_TYPE)) return undefined;
    const allowedValues = (0, $f4e7j.transformAggConnection)(node.singlePickerVersions, (0, $1ybV0.ff)('issue.details.relay-release-version-field-issue-view-integration') ? (0, $hd35n.transformAggVersionToLegacyVersion) : (0, $hd35n.transformAggVersionToLegacyVersionOld));
    const transformVersion = (0, $1ybV0.ff)('issue.details.relay-release-version-field-issue-view-integration') ? (0, $hd35n.transformAggVersionToLegacyVersion) : (0, $hd35n.transformAggVersionToLegacyVersionOld);
    const value = node.version ? transformVersion(node.version) : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        allowedValues: allowedValues,
        value: value,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            type: (0, $lO4Or.ISSUE_FIELD_VERSION_CF_TYPE),
            custom: (0, $lO4Or.VERSION_CF_TYPE),
            system: null
        }
    };
};

});

parcelRegister("c6LKM", function(module, exports) {

$parcel$export(module.exports, "transformAggSprintToLegacyField", () => $c11b803b5a137e84$export$9b5bb05d50970021);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $c11b803b5a137e84$var$SprintOptionalKeyMap = {
    goal: 'goal',
    completeDate: 'completionDate',
    startDate: 'startDate',
    endDate: 'endDate'
};
const $c11b803b5a137e84$var$transformAggSprintToLegacySprint = (sprint)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const optionalValues = {};
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys($c11b803b5a137e84$var$SprintOptionalKeyMap).forEach((key)=>{
        const aggKey = $c11b803b5a137e84$var$SprintOptionalKeyMap[key];
        const aggValue = sprint[aggKey];
        if (aggValue !== undefined && aggValue !== null) optionalValues[key] = aggValue;
    });
    return {
        id: Number(sprint.sprintId),
        name: sprint.name,
        state: sprint.state?.toLowerCase(),
        boardId: Number(sprint.boardName) || 0,
        ...optionalValues
    };
};
const $c11b803b5a137e84$export$9b5bb05d50970021 = (node)=>{
    if (node.type !== (0, $lO4Or.SPRINT_TYPE)) return undefined;
    const sprints = (0, $f4e7j.transformAggConnection)(node.selectedSprintsConnection, $c11b803b5a137e84$var$transformAggSprintToLegacySprint);
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: sprints,
        schema: {
            configuration: null,
            custom: (0, $lO4Or.SPRINT_TYPE),
            items: 'json',
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("8zTcQ", function(module, exports) {

$parcel$export(module.exports, "getStatusesDeprecatedValue", () => $23ba42f503d38228$export$b80ec59d806c2f94);
$parcel$export(module.exports, "transformAggStatusToLegacyField", () => $23ba42f503d38228$export$c80e5acb1c882c48);

var $8Qd0L = parcelRequire("8Qd0L");

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $23ba42f503d38228$export$b80ec59d806c2f94 = (fields)=>{
    const { status: status } = fields;
    if (!status || status.value == null) return {};
    const { value: value } = status;
    return {
        [value.id]: {
            id: value.id,
            name: value.name,
            statusCategory: (0, $8Qd0L.statusCategoryForId)(value.statusCategory?.id)
        }
    };
};
const $23ba42f503d38228$var$transformJiraStatusToLegacyStatus = (status)=>{
    if (status == null) return null;
    const { statusCategory: statusCategory } = status;
    return {
        id: status.statusId,
        name: status.name || '',
        statusCategory: {
            id: Number(statusCategory.statusCategoryId)
        }
    };
};
const $23ba42f503d38228$export$c80e5acb1c882c48 = (node)=>{
    if (node.type !== (0, $lO4Or.STATUS_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: $23ba42f503d38228$var$transformJiraStatusToLegacyStatus(node.status),
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            type: (0, $lO4Or.STATUS_TYPE),
            custom: null,
            system: (0, $lO4Or.STATUS_TYPE)
        }
    };
};

});

parcelRegister("5W75j", function(module, exports) {

$parcel$export(module.exports, "transformAggTeamToLegacyField", () => $97428b249585cac2$export$fb1b80497e96456f);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $97428b249585cac2$export$fb1b80497e96456f = (node)=>{
    if (node.type !== (0, $lO4Or.TEAM_CF_TYPE)) return undefined;
    const value = node.selectedTeam ? {
        id: node.selectedTeam.teamId,
        title: node.selectedTeam.name,
        isShared: node.selectedTeam.isShared,
        avatarUrl: node.selectedTeam.avatar?.medium
    } : null;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            custom: (0, $lO4Or.TEAM_CF_TYPE),
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: (0, $lO4Or.ISSUE_FIELD_ANY_CF_TYPE)
        }
    };
};

});

parcelRegister("7iFVU", function(module, exports) {

$parcel$export(module.exports, "transformAggTeamViewToLegacyField", () => $bb4542beb2315e32$export$6f6aaafb49bd4769);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $bb4542beb2315e32$var$transformAggTeamViewToLegacyTeam = (team)=>{
    if (team == null) return null;
    return {
        id: team.jiraSuppliedTeamId,
        name: team.jiraSuppliedName || '',
        isVisible: team.jiraSuppliedVisibility || false,
        avatarUrl: team.jiraSuppliedAvatar?.xsmall || ''
    };
};
const $bb4542beb2315e32$export$6f6aaafb49bd4769 = (node)=>{
    if (node.type !== (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        // @ts-expect-error - Argument of type '{ readonly jiraSuppliedAvatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly jiraSuppliedId: string; readonly jiraSuppliedName: string | ... 1 more ... | un...' is not assignable to parameter of type '{ readonly jiraSuppliedAvatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly jiraSuppliedId: string; readonly jiraSuppliedName: string | ... 1 more ... | un...'.
        value: $bb4542beb2315e32$var$transformAggTeamViewToLegacyTeam(node.selectedTeam),
        schema: {
            configuration: null,
            custom: (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE),
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: 'team'
        }
    };
};

});

parcelRegister("kyZt3", function(module, exports) {

$parcel$export(module.exports, "transformAggTimeTrackingToLegacyField", () => $3404d836fe97323f$export$874d9bd14269ec6f);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $3404d836fe97323f$var$getEstimateValues = (estimate, key)=>{
    if (estimate) return {
        [key]: estimate.timeInSeconds || 0
    };
    return {};
};
const $3404d836fe97323f$export$874d9bd14269ec6f = (node)=>{
    if (node.type !== (0, $lO4Or.TIME_TRACKING_TYPE)) return undefined;
    const originalEstimate = $3404d836fe97323f$var$getEstimateValues(node.originalEstimate || null, 'originalEstimateSeconds');
    const remainingEstimate = $3404d836fe97323f$var$getEstimateValues(node.remainingEstimate || null, 'remainingEstimateSeconds');
    const timeSpent = $3404d836fe97323f$var$getEstimateValues(node.timeSpent || null, 'timeSpentSeconds');
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: {
            ...originalEstimate,
            ...remainingEstimate,
            ...timeSpent
        },
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: (0, $lO4Or.TIME_TRACKING_TYPE),
            type: (0, $lO4Or.TIME_TRACKING_TYPE)
        }
    };
};

});

parcelRegister("dX2ot", function(module, exports) {

$parcel$export(module.exports, "transformAggUrlToLegacyField", () => $65722746bbedc61a$export$6e950e0ec9801f6c);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $65722746bbedc61a$export$6e950e0ec9801f6c = (node)=>{
    if (node.type !== (0, $lO4Or.URL_CF_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.uri ?? null,
        schema: {
            configuration: null,
            custom: (0, $lO4Or.URL_CF_TYPE),
            items: null,
            renderer: (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f),
            system: null,
            type: (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE)
        }
    };
};

});

parcelRegister("jhiYN", function(module, exports) {

$parcel$export(module.exports, "transformAggVotesToLegacyField", () => $471f4de3dfdc045c$export$8966614b8594736);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $471f4de3dfdc045c$var$transformAggVoteToLegacyVote = (vote)=>({
        votes: vote.count != null ? Number(vote.count) : 0,
        hasVoted: vote.hasVoted ?? false
    });
const $471f4de3dfdc045c$export$8966614b8594736 = (node)=>{
    if (node.type !== (0, $lO4Or.VOTES_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.vote ? $471f4de3dfdc045c$var$transformAggVoteToLegacyVote(node.vote) : null,
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $lO4Or.VOTES_TYPE),
            type: (0, $lO4Or.VOTES_TYPE)
        }
    };
};

});

parcelRegister("1BsAz", function(module, exports) {

$parcel$export(module.exports, "transformAggWatchesToLegacyField", () => $47cca6eb8a2344d9$export$6730cb17d10d6156);

var $lO4Or = parcelRequire("lO4Or");

var $f4e7j = parcelRequire("f4e7j");
const $47cca6eb8a2344d9$var$transformAggWatchesToLegacyWatches = (watch)=>({
        watchCount: watch.count != null ? Number(watch.count) : 0,
        isWatching: watch.isWatching ?? false
    });
const $47cca6eb8a2344d9$export$6730cb17d10d6156 = (node)=>{
    if (node.type !== (0, $lO4Or.WATCHES_TYPE)) return undefined;
    return {
        ...(0, $f4e7j.transformAggNodeToLegacyField)(node),
        value: node.watch ? $47cca6eb8a2344d9$var$transformAggWatchesToLegacyWatches(node.watch) : null,
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $lO4Or.WATCHES_TYPE),
            type: (0, $lO4Or.WATCHES_TYPE)
        }
    };
};

});



parcelRegister("k3tie", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $8f27d9da737621d3$export$8db21fc94823e1cc);
// Copied over from `src/packages/issue/issue-view/src/model/change-type.js`
const $8f27d9da737621d3$export$8b9b8ed7fbac313c = 'FIELD_CHANGE_REQUESTED';
const $8f27d9da737621d3$export$f567ac9d3526e5ce = 'FIELD_CHANGED';
const $8f27d9da737621d3$export$7c15aaba9a26f469 = 'FIELD_CHANGE_FAILED';
const $8f27d9da737621d3$export$8db21fc94823e1cc = {
    [$8f27d9da737621d3$export$8b9b8ed7fbac313c]: $8f27d9da737621d3$export$8b9b8ed7fbac313c,
    [$8f27d9da737621d3$export$7c15aaba9a26f469]: $8f27d9da737621d3$export$7c15aaba9a26f469,
    [$8f27d9da737621d3$export$f567ac9d3526e5ce]: $8f27d9da737621d3$export$f567ac9d3526e5ce
};

});


parcelRegister("3koWU", function(module, exports) {

$parcel$export(module.exports, "useIsMounted", () => $c314bd343c8e5174$export$80c2a3957bcb42ea);

var $eUqFw = parcelRequire("eUqFw");
const $c314bd343c8e5174$export$80c2a3957bcb42ea = ()=>{
    const isMounted = (0, $eUqFw.useRef)(true);
    (0, $eUqFw.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, [
        isMounted
    ]);
    return isMounted;
};

});

parcelRegister("fecbI", function(module, exports) {

$parcel$export(module.exports, "defaultSaveField", () => $4eca3d717c3df3ee$export$b74e6b7f831f1cb2);
$parcel$export(module.exports, "defaultSaveFieldById", () => $4eca3d717c3df3ee$export$b2c49aae5d84cced);
$parcel$export(module.exports, "defaultAddValuesToField", () => $4eca3d717c3df3ee$export$c46c7284cd9c5d3);
$parcel$export(module.exports, "defaultRemoveValuesFromField", () => $4eca3d717c3df3ee$export$33b78476f5d734b3);

var $lRmyA = parcelRequire("lRmyA");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4eca3d717c3df3ee$var$getFieldUpdate = (fieldKey, value)=>({
        fields: {
            [fieldKey]: value
        }
    });
const $4eca3d717c3df3ee$export$b74e6b7f831f1cb2 = async (issueKey, fieldKey, newValue, baseUrl)=>(0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify($4eca3d717c3df3ee$var$getFieldUpdate(fieldKey, newValue))
    });
const $4eca3d717c3df3ee$export$b2c49aae5d84cced = async (issueKey, fieldKey, newValue, baseUrl)=>(0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/3/issue/${issueKey}/?returnIssue=true`, {
        body: JSON.stringify($4eca3d717c3df3ee$var$getFieldUpdate(fieldKey, newValue))
    });
const $4eca3d717c3df3ee$export$c46c7284cd9c5d3 = async (issueKey, fieldKey, valuesToAdd, baseUrl)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'add',
                    value: valuesToAdd
                }
            ]
        }
    };
    return (0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    });
};
const $4eca3d717c3df3ee$export$33b78476f5d734b3 = async (issueKey, fieldKey, valuesToRemove, baseUrl)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'remove',
                    value: valuesToRemove
                }
            ]
        }
    };
    return (0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    });
};

});


parcelRegister("8411R", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfig", () => $7e02dfdf3441382d$export$5406c21e0d275680);
$parcel$export(module.exports, "useIssueFieldConfigWithoutRefetch", () => $7e02dfdf3441382d$export$217a0e2f2962f4ae);
$parcel$export(module.exports, "useIssueFieldConfigWithoutUimOverrides", () => $7e02dfdf3441382d$export$5f641a998c6dfa06);
$parcel$export(module.exports, "useFieldConfig", () => $7e02dfdf3441382d$export$70da50df1be2dbe1);
$parcel$export(module.exports, "useFieldConfigWithoutRefetch", () => $7e02dfdf3441382d$export$1eed575f8f3334eb);
$parcel$export(module.exports, "useFieldConfigActions", () => $7e02dfdf3441382d$export$28a22fd0dedf31b7);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $lRmyA = parcelRequire("lRmyA");

var $dwyR8 = parcelRequire("dwyR8");

var $kPvBW = parcelRequire("kPvBW");

var $3koWU = parcelRequire("3koWU");

var $6rkLV = parcelRequire("6rkLV");
const $7e02dfdf3441382d$export$9715ac6597e498fd = ()=>`
  query fieldConfigurationQuery($issueKey: String) {
    issue(issueIdOrKey: $issueKey, latestVersion: true, screen: "view") {
      fields {
        key
        schema {
          type
          custom
          customId
          system
          renderer
        }
        autoCompleteUrl
        allowedValues
        operations
        required
        editable
        title
        description
      }
    }
  }`;
const $7e02dfdf3441382d$var$fetchData = async (issueKey)=>{
    const response = await (0, $lRmyA.performPostRequest)((0, $dwyR8.getGraphQlUrl)('', (0, $kPvBW.IssueViewFetchOperations).FIELD_CONFIGURATION), {
        body: JSON.stringify({
            query: $7e02dfdf3441382d$export$9715ac6597e498fd(),
            variables: {
                issueKey: issueKey
            }
        })
    });
    if (response && response.data && response.data.issue && response.data.issue.fields) return response.data.issue.fields.reduce(// @ts-expect-error - TS7006 - Parameter 'result' implicitly has an 'any' type. | TS7006 - Parameter 'field' implicitly has an 'any' type.
    (result, field)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [field.key]: {
                autoCompleteUrl: field.autoCompleteUrl,
                allowedValues: field.allowedValues,
                isEditable: field.editable,
                isRequired: field.required,
                schema: field.schema,
                title: field.title,
                ...field.description ? {
                    description: field.description
                } : {}
            }
        }), {});
    return null;
};
const $7e02dfdf3441382d$var$requestSet = new Set();
const $7e02dfdf3441382d$var$issueFieldConfigServiceDefaultOptions = {
    skipRefresh: false
};
const $7e02dfdf3441382d$var$useIssueFieldConfigRefetch = (issueKey, value, { skipRefresh: skipRefresh } = $7e02dfdf3441382d$var$issueFieldConfigServiceDefaultOptions)=>{
    const isMounted = (0, $3koWU.useIsMounted)();
    const [, { setIssueConfig: setIssueConfig }] = (0, $6rkLV.useFieldConfigStoreActions)();
    const [loading, setLoading] = (0, $eUqFw.useState)(()=>!skipRefresh && value === undefined && !$7e02dfdf3441382d$var$requestSet.has(issueKey));
    const getData = (0, $eUqFw.useCallback)(async ()=>{
        setLoading(true);
        $7e02dfdf3441382d$var$requestSet.add(issueKey);
        const result = await $7e02dfdf3441382d$var$fetchData(issueKey);
        setIssueConfig(issueKey, result);
        $7e02dfdf3441382d$var$requestSet.delete(issueKey);
        if (isMounted.current) setLoading(false);
    }, [
        isMounted,
        issueKey,
        setIssueConfig
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const shouldGetData = !skipRefresh && !$7e02dfdf3441382d$var$requestSet.has(issueKey) && value === undefined;
        if (shouldGetData) getData();
    }, [
        issueKey,
        value,
        getData,
        skipRefresh
    ]);
    return [
        {
            loading: loading
        }
    ];
};
const $7e02dfdf3441382d$var$useIssueFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey })=>{
    const [value] = (0, $6rkLV.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [overrides] = (0, $6rkLV.useIssueOverridesStore)({
        issueKey: issueKey
    });
    return (0, $eUqFw.useMemo)(()=>{
        if (// When fields configurations are not valid, we don't want overrides
        !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value) && // We should not override if UI modifications is not available in general or for the field
        overrides !== undefined) {
            // Iteration over the base fields (`value`) prevents creation of partial configs with just UIM overrides.
            const issueWithOverrides = Object.entries(value).reduce((acc, [fieldKey, fieldValues])=>{
                acc[fieldKey] = {
                    ...fieldValues,
                    ...overrides[fieldKey]
                };
                return acc;
            }, {});
            return [
                issueWithOverrides
            ];
        }
        return [
            value
        ];
    }, [
        value,
        overrides
    ]);
};
const $7e02dfdf3441382d$var$useFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey, fieldKey: fieldKey })=>{
    const [value] = (0, $6rkLV.useFieldConfigStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [overrides] = (0, $6rkLV.useFieldOverridesStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    if (// When fields configurations are not valid, we don't want overrides
    !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value) && // We should not override if UI modifications is not available in general or for the field
    overrides !== undefined) return [
        {
            ...value,
            ...overrides
        }
    ];
    return [
        value
    ];
};
const $7e02dfdf3441382d$export$5406c21e0d275680 = (issueKey)=>{
    const [value] = $7e02dfdf3441382d$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $7e02dfdf3441382d$var$useIssueFieldConfigRefetch(issueKey, value);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $7e02dfdf3441382d$export$217a0e2f2962f4ae = (issueKey)=>{
    const [value] = $7e02dfdf3441382d$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    return [
        {
            value: value
        }
    ];
};
const $7e02dfdf3441382d$export$5f641a998c6dfa06 = ({ issueKey: issueKey })=>{
    const [value] = (0, $6rkLV.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $7e02dfdf3441382d$var$useIssueFieldConfigRefetch(issueKey, value);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $7e02dfdf3441382d$export$70da50df1be2dbe1 = (issueKey, fieldKey, options = $7e02dfdf3441382d$var$issueFieldConfigServiceDefaultOptions)=>{
    const [value] = $7e02dfdf3441382d$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [{ loading: loading }] = $7e02dfdf3441382d$var$useIssueFieldConfigRefetch(issueKey, value, options);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $7e02dfdf3441382d$export$1eed575f8f3334eb = (issueKey, fieldKey)=>{
    const [value] = $7e02dfdf3441382d$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    return [
        {
            value: value
        }
    ];
};
const $7e02dfdf3441382d$export$28a22fd0dedf31b7 = ()=>{
    const [, setIssueConfigActions] = (0, $6rkLV.useFieldConfigStoreActions)();
    const actions = (0, $eUqFw.useMemo)(()=>{
        const setIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.setIssueConfig(issueKey, issueConfig);
        const setIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.setIssuesConfig(issuesWithConfigurations);
        const mergeIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.mergeIssueConfig(issueKey, issueConfig);
        const mergeIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.mergeIssuesConfig(issuesWithConfigurations);
        const setFieldConfigValue = (issueKey, fieldKey, fieldConfigValue)=>setIssueConfigActions.setFieldConfigValue(issueKey, fieldKey, fieldConfigValue);
        return {
            setIssueConfig: setIssueConfig,
            setIssuesConfig: setIssuesConfig,
            mergeIssueConfig: mergeIssueConfig,
            mergeIssuesConfig: mergeIssuesConfig,
            setFieldConfigValue: setFieldConfigValue
        };
    }, [
        setIssueConfigActions
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("dwyR8", function(module, exports) {

$parcel$export(module.exports, "getGraphQlUrl", () => $82ad8876acbb4446$export$5647e6bbf2b3526f);
$parcel$export(module.exports, "getFieldDataOptions", () => $82ad8876acbb4446$export$f2fec0cacdfabaaf);

var $k0k8C = parcelRequire("k0k8C");

var $aAj2A = parcelRequire("aAj2A");
const $82ad8876acbb4446$export$5647e6bbf2b3526f = (baseUrl, operation)=>`${baseUrl}/rest/graphql/1/${(0, $k0k8C.appendOperationQuery)(operation)}`;
const $82ad8876acbb4446$export$f2fec0cacdfabaaf = (issueKey, projectKey)=>({
        method: 'POST',
        body: JSON.stringify({
            query: (0, $aAj2A.default)(issueKey, projectKey)
        })
    });

});
parcelRegister("aAj2A", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f04a44c8c5fa855$export$2e2bcd8739ae039);
const $2f04a44c8c5fa855$export$ecc155df19ba52ff = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};
const $2f04a44c8c5fa855$var$getIsHybridAgilityProjectQuery = ()=>`
    isHybridAgilityProject
    `;
const $2f04a44c8c5fa855$var$getEnvironmentQuery = ()=>`environmentAdf {
        value
    }`;
const $2f04a44c8c5fa855$var$getAgileQuery = ()=>`
    agile {
        epic {
          key
        },
    }`;
const $2f04a44c8c5fa855$var$getCustomFieldSchemaConfiguration = ()=>`configuration {
        key
        value
    }
    `;
const $2f04a44c8c5fa855$var$getProjectQuery = (projectKey)=>`
        project(projectIdOrKey: "${projectKey}") {
            id
            name
            key
            projectTypeKey
            simplified
            avatarUrls {
                key
                value
            }
            archived
            deleted
        }`;
var // Disable this eslint rule temporarily so we can query for configuration
// eslint-disable-next-line jira/import/no-anonymous-default-export
$2f04a44c8c5fa855$export$2e2bcd8739ae039 = (issueKey, projectKey)=>$2f04a44c8c5fa855$export$ecc155df19ba52ff`query issueDataQuery {
        issue(issueIdOrKey: "${issueKey}", latestVersion: true, screen: "view") {
            id
            viewScreenId
            fields {
                key
                title
                editable
                required
                autoCompleteUrl
                allowedValues
                content
                renderedContent
                schema {
                    custom
                    system
                    ${$2f04a44c8c5fa855$var$getCustomFieldSchemaConfiguration()}
                    items
                    type
                    renderer
                }
                configuration
            }
            expandAssigneeInSubtasks
            expandAssigneeInIssuelinks
            expandTimeTrackingInSubtasks
            systemFields {
                descriptionAdf {
                    value
                }
                ${$2f04a44c8c5fa855$var$getEnvironmentQuery()}
            }
            customFields {
                textareaAdf {
                    key
                    value
                }
            }
            ${$2f04a44c8c5fa855$var$getIsHybridAgilityProjectQuery()}
            ${$2f04a44c8c5fa855$var$getAgileQuery()}
        }
        ${$2f04a44c8c5fa855$var$getProjectQuery(projectKey)}
    }`;

});


parcelRegister("kPvBW", function(module, exports) {

$parcel$export(module.exports, "TIMESTAMP_DISPLAY_SETTING", () => $b682c7d6e9f17978$export$9f4ee8e6dc9a0a55);
$parcel$export(module.exports, "CHILD_ISSUES_LIMIT_BEST_PRACTICE_FLAG_DISMISSED", () => $b682c7d6e9f17978$export$e7d75f9d93dfa3df);
$parcel$export(module.exports, "IssueViewFetchOperations", () => $b682c7d6e9f17978$export$b38f30d67f730bc4);
const $b682c7d6e9f17978$export$9f4ee8e6dc9a0a55 = 'jira.user.issue.details.timestamp-display-setting';
const $b682c7d6e9f17978$export$e7d75f9d93dfa3df = 'jira.user.issue.child-issues-limit.best-practice-flag.dismissed';
const $b682c7d6e9f17978$export$757f91ad408a28d4 = 'jira.user.issue.filter.hide-done-subtasks';
const $b682c7d6e9f17978$export$b38f30d67f730bc4 = {
    EARLY_FETCH_GRAPHQL: 'earlyFetchIssueDataQuery',
    INITIAL_GRAPHQL: 'issueDataQuery',
    EARLY_FETCH_GIRA: 'earlyFetchIssueViewInteractiveQuery',
    INITIAL_GIRA: 'issueViewInteractiveQuery',
    EARLY_FETCH_AGG: 'earlyFetchMainIssueAggQuery',
    INITIAL_AGG: 'mainIssueAggQuery',
    EARLY_FETCH_NON_CRITICAL_GIRA: 'earlyFetchIssueViewNonCriticalGiraQuery',
    NON_CRITICAL_GIRA: 'issueViewNonCriticalGiraQuery',
    VIEW_SCREEN_ID: 'viewScreenIdQuery',
    FIELD_CONFIGURATION: 'fieldConfigurationQuery',
    FIELD_DESCRIPTION: 'fieldDescriptionQuery',
    ATTACHMENT: 'attachmentsQuery'
};

});

parcelRegister("6rkLV", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfigStore", () => $2581b610ec8db8fc$export$52f51db4e2b3da57);
$parcel$export(module.exports, "useFieldConfigStore", () => $2581b610ec8db8fc$export$f9beb98c7488fd61);
$parcel$export(module.exports, "useFieldConfigStoreActions", () => $2581b610ec8db8fc$export$314199caf05d245);
$parcel$export(module.exports, "useIssueOverridesStore", () => $2581b610ec8db8fc$export$ff357cf5a96ec0c6);
$parcel$export(module.exports, "useFieldOverridesStore", () => $2581b610ec8db8fc$export$6e41e9c34587d557);
$parcel$export(module.exports, "useFieldOverridesStoreWithLabel", () => $2581b610ec8db8fc$export$e704d739927bd1d6);
$parcel$export(module.exports, "useOverridesStoreActions", () => $2581b610ec8db8fc$export$d94ae842140da412);
$parcel$export(module.exports, "useFieldOptionsOverrides", () => $2581b610ec8db8fc$export$bfea9bb9bad7bc8f);
$parcel$export(module.exports, "useIsFieldBusy", () => $2581b610ec8db8fc$export$982ff1008c2e2780);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $df4Sl = parcelRequire("df4Sl");

var $2vzCR = parcelRequire("2vzCR");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $2581b610ec8db8fc$var$setIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: IssueConfiguration | null; }' is not assignable to parameter of type 'Partial<Partial<Record<string, IssueConfiguration>>>'.
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: issueConfiguration
        });
    };
const $2581b610ec8db8fc$var$mergeIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, getState()[issueKey], issueConfiguration)
        });
    };
const $2581b610ec8db8fc$var$setIssuesConfig = (issuesWithConfigurations)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = issuesWithConfigurations.reduce((acc, issue)=>({
                ...acc,
                ...issue
            }), {});
        setState(newIssues);
    };
const $2581b610ec8db8fc$var$mergeIssuesConfig = (issuesWithConfigurations)=>({ setState: setState, getState: getState })=>{
        if (issuesWithConfigurations.length === 0) return;
        const newIssues = {};
        issuesWithConfigurations.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, getState(), newIssues));
    };
const $2581b610ec8db8fc$var$setFieldConfigValue = (issueKey, fieldKey, fieldConfiguration)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfiguration = getState()[issueKey];
        if (issueKeyFieldConfiguration && issueKeyFieldConfiguration[fieldKey]) setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: {
                    ...getState()[issueKey][fieldKey],
                    ...fieldConfiguration
                }
            }
        });
    };
const $2581b610ec8db8fc$var$actions = {
    setIssueConfig: $2581b610ec8db8fc$var$setIssueConfig,
    setIssuesConfig: $2581b610ec8db8fc$var$setIssuesConfig,
    mergeIssueConfig: $2581b610ec8db8fc$var$mergeIssueConfig,
    mergeIssuesConfig: $2581b610ec8db8fc$var$mergeIssuesConfig,
    setFieldConfigValue: $2581b610ec8db8fc$var$setFieldConfigValue
};
// this is a global state
const $2581b610ec8db8fc$var$store = (0, $a61MH.createStore)({
    name: 'issue-field-config',
    initialState: {},
    actions: $2581b610ec8db8fc$var$actions
});
const $2581b610ec8db8fc$var$getIssueFieldConfig = (0, $df4Sl.createSelector)((state, props)=>state[props.issueKey], (issue)=>issue);
const $2581b610ec8db8fc$export$52f51db4e2b3da57 = (0, $ggKAj.createHook)($2581b610ec8db8fc$var$store, {
    selector: $2581b610ec8db8fc$var$getIssueFieldConfig
});
const $2581b610ec8db8fc$var$getFieldConfig = (0, $df4Sl.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey] : null;
});
const $2581b610ec8db8fc$var$getFieldConfigWithLabel = (0, $df4Sl.createSelector)($2581b610ec8db8fc$var$getFieldConfig, (fieldConfig)=>{
    if (fieldConfig?.title === undefined) return fieldConfig;
    return {
        ...fieldConfig,
        label: fieldConfig.title
    };
});
const $2581b610ec8db8fc$var$getFieldOptionsOverrides = (0, $df4Sl.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey].allowedValuesOverrides : null;
});
const $2581b610ec8db8fc$export$f9beb98c7488fd61 = (0, $ggKAj.createHook)($2581b610ec8db8fc$var$store, {
    selector: $2581b610ec8db8fc$var$getFieldConfig
});
const $2581b610ec8db8fc$export$314199caf05d245 = (0, $ggKAj.createHook)($2581b610ec8db8fc$var$store, {
    selector: null
});
const $2581b610ec8db8fc$var$setOverrides = (issueKey, fieldKey, fieldConfigOverrides)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfigurationWithOverrides = getState()[issueKey] ?? {};
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...issueKeyFieldConfigurationWithOverrides,
                [fieldKey]: {
                    ...issueKeyFieldConfigurationWithOverrides[fieldKey],
                    ...fieldConfigOverrides
                }
            }
        });
    };
const $2581b610ec8db8fc$var$resetOverridesStore = (issueKey)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [issueKey]: undefined
        });
    };
const $2581b610ec8db8fc$var$overridesActions = {
    setFieldConfigOverridesValue: $2581b610ec8db8fc$var$setOverrides,
    resetOverridesStore: $2581b610ec8db8fc$var$resetOverridesStore
};
// Store contains overrides to the field config. It is used by UI modifications to override field config properties by apps.
// UI modifications is a Forge extension point providing apps JS API to override field's properties: name, description, isEditable
// and limit visibility of select fields options.
const $2581b610ec8db8fc$var$overridesStore = (0, $a61MH.createStore)({
    name: 'issue-field-overrides',
    initialState: {},
    actions: $2581b610ec8db8fc$var$overridesActions
});
const $2581b610ec8db8fc$export$ff357cf5a96ec0c6 = (0, $ggKAj.createHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getIssueFieldConfig
});
const $2581b610ec8db8fc$export$6e41e9c34587d557 = (0, $ggKAj.createHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getFieldConfig
});
const $2581b610ec8db8fc$export$e704d739927bd1d6 = (0, $ggKAj.createStateHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getFieldConfigWithLabel
});
const $2581b610ec8db8fc$export$d94ae842140da412 = (0, $ggKAj.createActionsHook)($2581b610ec8db8fc$var$overridesStore);
const $2581b610ec8db8fc$export$bfea9bb9bad7bc8f = (0, $ggKAj.createHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getFieldOptionsOverrides
});
const $2581b610ec8db8fc$var$getIsFieldBusySelector = (state, args)=>{
    const { fieldId: fieldId, issueKey: issueKey } = args;
    return fieldId !== undefined && !!state[issueKey]?.[fieldId]?.isBusy;
};
const $2581b610ec8db8fc$export$982ff1008c2e2780 = (0, $ggKAj.createStateHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getIsFieldBusySelector
});

});



const $ada2d6cf4ae575cf$export$1ff9623b26415f8 = 'INLINE';
const $ada2d6cf4ae575cf$export$44f42916442b37c3 = 'LOZENGE';
const $ada2d6cf4ae575cf$export$eade6b6091579183 = 'NORMAL';
const $ada2d6cf4ae575cf$export$797ed91ebb8db1c5 = 'CHILD_ISSUE_LOZENGE';

parcelRegister("hJ1SV", function(module, exports) {

$parcel$export(module.exports, "AsyncLazyNumberFieldInlineEdit", () => $4dc91c99fa555162$export$914a596381b1e227);

var $7rh0R = parcelRequire("7rh0R");

const $4dc91c99fa555162$export$914a596381b1e227 = (0, $7rh0R.lazy)(()=>(parcelRequire("9pdkG")), {
    moduleId: "./src/packages/issue/fields/number-inline-edit/inline-edit/src/ui/index.tsx"
});

});
parcelRegister("9pdkG", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('ksEmu');
        const value = parcelRequire('dDuPZ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("ksEmu").then(()=>parcelRequire('dDuPZ'));
}

});


parcelRegister("hWeBz", function(module, exports) {

$parcel$export(module.exports, "NumberInlineEditErrorBoundary", () => $a4d1e1d1fde21a52$export$3e0d6107a3584b0b);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");
const $a4d1e1d1fde21a52$export$3e0d6107a3584b0b = ({ fallback: fallback, children: children, packageName: packageName, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "number-inline-edit",
        packageName: packageName,
        teamName: "deliveroo",
        fallback: "flag",
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "number-inline-edit-error-boundary",
        fallback: fallback
    }, children));

});

parcelRegister("87GQt", function(module, exports) {

$parcel$export(module.exports, "IssueNumberFieldBoundary", () => $0112f83c609a0972$export$5efed0d3367e90db);
$parcel$export(module.exports, "IssueNumberFieldReadonly", () => (parcelRequire("6UA3n")).NumberView);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

var $6UA3n = parcelRequire("6UA3n");

const $0112f83c609a0972$export$17e6ae9e4022a01f = (0, $7rh0R.lazy)(()=>(parcelRequire("2RlxX")), {
    moduleId: "./src/packages/issue/fields/number/src/ui/index.tsx"
});
const $0112f83c609a0972$export$e170b9657d273707 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue-field-number",
        packageName: "jira-issue-field-number",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6UA3n.NumberView), {
                isEditable: props.isEditable !== undefined ? props.isEditable : false
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-field-number-readonly",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6UA3n.NumberView), {
            isEditable: props.isEditable !== undefined ? props.isEditable : false
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0112f83c609a0972$export$17e6ae9e4022a01f, props)));
const $0112f83c609a0972$export$5efed0d3367e90db = ({ children: children, fallback: fallback, packageName: packageName, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "issue-number-field",
        packageName: packageName,
        fallback: fallback ? ()=>fallback : undefined,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-number-field-boundary",
        fallback: fallback
    }, children));

});
parcelRegister("6UA3n", function(module, exports) {

$parcel$export(module.exports, "NumberView", () => $72c87111b6cdadb5$export$3a0cbbcc23d8ca3d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $9nkwJ = parcelRequire("9nkwJ");

var $PdmhA = parcelRequire("PdmhA");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");

var $4ksts = parcelRequire("4ksts");

const $72c87111b6cdadb5$var$noValueText = '-';
const $72c87111b6cdadb5$export$3a0cbbcc23d8ca3d = ({ isEditable: isEditable, value: value, setIsEditing: setIsEditing })=>{
    const { formatNumber: formatNumber } = (0, $4ksts.useIntlV2)();
    const handleOnClick = (0, $eUqFw.useCallback)(()=>{
        setIsEditing?.(true);
    }, [
        setIsEditing
    ]);
    if (value === undefined) return null;
    const displayValue = value === null ? $72c87111b6cdadb5$var$noValueText : formatNumber(value);
    const BadgeComp = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
        testId: (0, $f6a7c9af3be196db$export$ddb0dcfa9074309f)
    }, displayValue);
    const BadgeComponent = isEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($72c87111b6cdadb5$var$HoverContainer, {
        "data-testid": `${(0, $f6a7c9af3be196db$export$ddb0dcfa9074309f)}-hover-container`,
        onClick: handleOnClick
    }, BadgeComp) : BadgeComp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($72c87111b6cdadb5$var$BadgeWrapper, null, BadgeComponent);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any,  @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $72c87111b6cdadb5$var$HoverContainerControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "b6v085-0"
})({
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&:hover > span': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `${`var(--ds-text, ${(0, $PdmhA).N800})`} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: `${`var(--ds-background-neutral-hovered, ${(0, $PdmhA).N90})`} !important`
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @typescript-eslint/no-explicit-any
const $72c87111b6cdadb5$var$HoverContainerExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_80omtlke _ll8p16l4 _1lgi1prw",
            __cmplp.className
        ])
    });
});
const $72c87111b6cdadb5$var$HoverContainer = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled-react-migration-issue-view_u9myz'), $72c87111b6cdadb5$var$HoverContainerExperiment, $72c87111b6cdadb5$var$HoverContainerControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $72c87111b6cdadb5$var$BadgeWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19itj1ic",
            __cmplp.className
        ])
    });
});

});
const $f6a7c9af3be196db$export$195635d59130784a = 'issue-field-number.ui.issue-field-number';
const $f6a7c9af3be196db$export$5dadcbcc34de35f = 'issue-field-number.ui.issue-field-number--container';
const $f6a7c9af3be196db$export$ddb0dcfa9074309f = 'issue-field-number.ui.badge';
const $f6a7c9af3be196db$export$3cb3b73ace5de3d1 = `${$f6a7c9af3be196db$export$ddb0dcfa9074309f}-hover-container`;
const $f6a7c9af3be196db$export$ac421571f56485b8 = 'issue-field-number.edit.warning-icon';


parcelRegister("2RlxX", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8cHjV');
        const value = parcelRequire('7vU0J');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8cHjV").then(()=>parcelRequire('7vU0J'));
}

});


parcelRegister("1Vqi3", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('66oUu');
        const value = parcelRequire('41OSj');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("66oUu").then(()=>parcelRequire('41OSj'));
}

});


parcelRegister("yKruN", function(module, exports) {

$parcel$export(module.exports, "SummaryAndParents", () => $e3f60e4a276e5ee1$export$819decb1869bab94);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5iWql = parcelRequire("5iWql");

var $7PAQj = parcelRequire("7PAQj");

var $5WFzC = parcelRequire("5WFzC");

var $30WDI = parcelRequire("30WDI");

var $7GPUb = parcelRequire("7GPUb");
const $e3f60e4a276e5ee1$export$819decb1869bab94 = ({ cardKey: cardKey, summary: summary, highlightText: highlightText, isUserAtLeastMember: isUserAtLeastMember, shouldRenderRichCard: shouldRenderRichCard, isSummaryFieldEditing: isSummaryFieldEditing, onClickThrough: onClickThrough, onSummaryEditStateChange: onSummaryEditStateChange, children: children })=>{
    const getHighlightText = (0, $5iWql.default)((highlightedText)=>[
            highlightedText
        ]);
    const highlightTextEl = // Possibility that summary is null/undefined
    highlightText !== null && highlightText !== '' && summary ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7PAQj.default), {
        text: summary,
        highlight: getHighlightText(highlightText)
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.SummaryAndParentContainer), {
        isSummaryFieldEditing: isSummaryFieldEditing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.SummaryWrapper), {
        tabIndex: -1,
        isSummaryFieldEditing: isSummaryFieldEditing,
        onClick: isSummaryFieldEditing ? (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) : onClickThrough,
        "data-testid": (0, $30WDI.SUMMARY_TEST_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GPUb.default), {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        issueKey: cardKey,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        isUserAtLeastMember: isUserAtLeastMember,
        shouldRenderRichCard: shouldRenderRichCard ?? false,
        summary: summary,
        highlightText: highlightTextEl,
        onSummaryEditStateChange: onSummaryEditStateChange
    })), children);
};

});
parcelRegister("7GPUb", function(module, exports) {

$parcel$export(module.exports, "default", () => $d19efa53aa12da00$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $7rh0R = parcelRequire("7rh0R");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");

var $4qabY = parcelRequire("4qabY");

var $lO4Or = parcelRequire("lO4Or");

var $8WuJm = parcelRequire("8WuJm");


var $diedG = parcelRequire("diedG");

var $5WFzC = parcelRequire("5WFzC");

var $5owCv = parcelRequire("5owCv");

// MultilineInlineSummary is actually just a proxy for @atlassian/jira-issue-field-summary-inline-edit-link
const $d19efa53aa12da00$var$MultilineInlineSummaryLazy = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("f77X5")).then(({ MultilineInlineSummary: MultilineInlineSummary })=>MultilineInlineSummary), {
    moduleId: "./src/packages/issue/fields/summary/src/ui/multiline-inline-summary/index.tsx"
});
const $d19efa53aa12da00$var$SummaryField = ({ shouldRenderRichCard: shouldRenderRichCard, issueKey: issueKey, highlightText: highlightText, onSummaryEditStateChange: onSummaryEditStateChange, summary: summary, isUserAtLeastMember: isUserAtLeastMember })=>{
    const summaryFieldStatic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5owCv.StaticSummaryField), {
        highlightText: highlightText,
        summary: summary
    });
    if (shouldRenderRichCard && isUserAtLeastMember) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4qabY.IssueSummaryFieldBoundary), {
        packageName: (0, $e1409a6fc345c0d8$export$dfd208682d29484c),
        fallback: summaryFieldStatic
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $diedG.default), {
        experienceTarget: (0, $lO4Or.SUMMARY_TYPE),
        experienceTargetId: issueKey,
        additionalAttributes: {
            issueKey: issueKey
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d19efa53aa12da00$var$MultilineSummaryFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: {
            isInlineEditing: true
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d19efa53aa12da00$var$MultilineInlineSummaryLazy, {
        issueKey: issueKey,
        highlightText: highlightText,
        onEditStateChange: onSummaryEditStateChange
    })))));
    return summaryFieldStatic;
};
var $d19efa53aa12da00$export$2e2bcd8739ae039 // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
 = /*#__PURE__*/ (0, $eUqFw.memo)($d19efa53aa12da00$var$SummaryField);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d19efa53aa12da00$var$MultilineSummaryFieldWrapperControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1ahiuhb-0"
})`margin-left:${"var(--ds-space-negative-100, -8px)"};margin-right:${"var(--ds-space-negative-100, -8px)"};& >:not([role='presentation']){margin-left:${"var(--ds-space-0, 0px)"};margin-top:${"var(--ds-space-negative-200, 16px)"};position:absolute;width:100%;form > div{margin-top:0 !important;}}a[data-component-selector='issue-field-summary-inline-edit-link.ui.read.styled-link-item']{display:${()=>(0, $1ybV0.ff)('backlog-issue-summary-browser-large-font-size-fix_0k38w') ? 'flex' : undefined};}${(0, $5WFzC.CardContainerControl)}:hover &,${(0, $5WFzC.CardContainerControl)}:active &,${(0, $5WFzC.CardContainerControl)}:focus &,${(0, $5WFzC.CardContainerControl)}:focus-within &{[data-attr='edit-summary-control']{display:flex !important;}}`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $d19efa53aa12da00$var$MultilineSummaryFieldWrapperExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0x0bf _2hwxx0bf _gjxvze3t _132nubjl _192wstnw _11041osq _1q8jgrf3 _wryf13la _122i13la _570a13la _1kwi13la",
            (0, $1ybV0.ff)('backlog-issue-summary-browser-large-font-size-fix_0k38w') && "_1s8q1txw",
            __cmplp.className
        ])
    });
});
const $d19efa53aa12da00$var$MultilineSummaryFieldWrapper = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $d19efa53aa12da00$var$MultilineSummaryFieldWrapperExperiment, $d19efa53aa12da00$var$MultilineSummaryFieldWrapperControl);

});
parcelRegister("4qabY", function(module, exports) {

$parcel$export(module.exports, "IssueSummaryFieldBoundary", () => $4e5f93be9e577c72$export$f8e4f73217de638d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

const $4e5f93be9e577c72$export$f8e4f73217de638d = ({ children: children, fallback: fallback, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue-summary-field",
        packageName: packageName,
        render: ()=>fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-summary-field-boundary",
        fallback: fallback
    }, children));

});

parcelRegister("5owCv", function(module, exports) {

$parcel$export(module.exports, "StaticSummaryField", () => $71acf35179c3e402$export$852299389cd57d63);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $5WFzC = parcelRequire("5WFzC");
const $71acf35179c3e402$export$852299389cd57d63 = ({ summary: summary, highlightText: highlightText })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: summary
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5WFzC.Summary), null, highlightText ?? summary));

});

parcelRegister("f77X5", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('lBxLf');
        const value = parcelRequire('78eqG');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("lBxLf").then(()=>parcelRequire('78eqG'));
}

});



parcelRegister("4jGOQ", function(module, exports) {

$parcel$export(module.exports, "TypeIcon", () => $8438d68ce1a9101d$export$ad8f8fc3bcd61b4a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $8438d68ce1a9101d$export$ad8f8fc3bcd61b4a = ({ icon: icon })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8438d68ce1a9101d$var$ImageContainer, {
        "data-testid": "software-backlog.card-list.card.card-contents.type-icon.type"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8438d68ce1a9101d$var$Img, {
        role: "presentation",
        src: icon
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8438d68ce1a9101d$var$ImageContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_yyhy11t1 _1ii7wtyw",
            __cmplp.className
        ])
    });
});
const $8438d68ce1a9101d$var$Img = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb7vkz _4t3i7vkz _s7n41ndm",
            __cmplp.className
        ])
    });
});

});

parcelRegister("kDuIt", function(module, exports) {

$parcel$export(module.exports, "VersionsWrapper", () => $94253a037502a68f$export$5c54d44b9c100bd1);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $8MrYx = parcelRequire("8MrYx");

var $hkD5e = parcelRequire("hkD5e");

var $iazUW = parcelRequire("iazUW");
const $94253a037502a68f$export$5c54d44b9c100bd1 = ({ shouldDisplayVersions: shouldDisplayVersions, backlogContainerSize: backlogContainerSize, cardId: cardId })=>{
    const showVersions = (0, $8MrYx.useShowVersions)();
    if (shouldDisplayVersions && showVersions) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($94253a037502a68f$var$VersionsContainer, {
        "data-testid": "software-backlog.card-list.card.card-contents.versions-field.version-field-wrapper.versions-container",
        widthMultiplier: (0, $hkD5e.getLabelWidthMultiplier)((0, $hkD5e.LabelType).VERSION, backlogContainerSize)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iazUW.VersionsField), {
        cardId: cardId,
        backlogContainerSize: backlogContainerSize
    }));
    return null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $94253a037502a68f$var$VersionsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { widthMultiplier: widthMultiplier, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ewl67i": (0, $9t7rW.default)(`repeat(auto-fit, calc(${"var(--ds-space-100, 8px)"} * ${__cmplp.widthMultiplier}))`),
            "--_1qtnkr6": (0, $9t7rW.default)(`calc(${"var(--ds-space-100, 8px)"} * ${__cmplp.widthMultiplier})`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c11p5 _1pbykb7n _1reo15vq _18m915vq _1bto1l2s _4cvr1h6o _6a6zv2br _lcxvglyw _yv0epq74 _1ul9dike",
            __cmplp.className
        ])
    });
});

});



parcelRegister("dPfUC", function(module, exports) {

$parcel$export(module.exports, "DropIndicator", () => $1b5ffb35d490b4de$export$62ed72bc21f6b8a6);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $1ybV0 = parcelRequire("1ybV0");

var $ck0PM = parcelRequire("ck0PM");
function $1b5ffb35d490b4de$export$62ed72bc21f6b8a6({ edge: edge, droppingOverCardId: droppingOverCardId, droppingOverCardListId: droppingOverCardListId, dropStatisticsCardListId: dropStatisticsCardListId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b5ffb35d490b4de$var$DropLine, {
        edge: edge
    }, dropStatisticsCardListId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b5ffb35d490b4de$var$InformationPill, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ck0PM.DividerStatistics), {
        dividerCardListId: dropStatisticsCardListId,
        isDragIndicator: true,
        edge: edge === 'top' ? 'top' : 'bottom',
        droppingOverCardListId: droppingOverCardListId,
        droppingOverCardId: droppingOverCardId
    })));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1b5ffb35d490b4de$var$DropLine = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { edge: edge, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_r3343": (0, $9t7rW.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $1ybV0.ff)('jsw-tanuki-fit-and-finish_rhzmf') ? "var(--ds-space-negative-025, -2px)" : "var(--ds-space-0, 0px)"),
            "--_3wmuo6": (0, $9t7rW.default)(__cmplp.edge === 'bottom' ? "var(--ds-space-0, 0px)" : undefined)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _94n5b65c _1ltvidpf _1bsb1osq _4t3iyh40 _1pbykb7n _1e0c1txw _1bah1y6m _4cvr1h6o _bfhk1r2e _lcxvglyw _1kt9b3bt _cfu11txw _kfgtidpf _1mp4idpf _6w5g1h6o _fntnr5cr _1pq812me _4k1c12me _1n1j18is",
            __cmplp.edge === 'top' && "_154i1kvi",
            __cmplp.className
        ])
    });
});
const $1b5ffb35d490b4de$var$InformationPill = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk1r2e _2rko1tcg _1e0c1txw _4cvr1h6o _1bah1h6o _1yt418iy",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ck0PM", function(module, exports) {

$parcel$export(module.exports, "DividerStatistics", () => $bdb18cbe9e681d33$export$6542605af85d934);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8blac = parcelRequire("8blac");

var $1Yimi = parcelRequire("1Yimi");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7TyGu = parcelRequire("7TyGu");

var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");

var $1ircG = parcelRequire("1ircG");

var $kdGmo = parcelRequire("kdGmo");

var $aEtjw = parcelRequire("aEtjw");

var $3XxT0 = parcelRequire("3XxT0");

var $iRgPd = parcelRequire("iRgPd");
function $bdb18cbe9e681d33$export$6542605af85d934(props) {
    const { dividerCardListId: dividerCardListId, isDragIndicator: isDragIndicator } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const estimationType = (0, $1gQ73.useBacklogSelector)((0, $1ircG.getEstimationType));
    const isCompanyManaged = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getIsCompanyManaged));
    const totalIssues = (0, $1gQ73.useBacklogSelector)((state)=>(0, $iRgPd.getTotalIssues)(state, {
            cardListId: dividerCardListId,
            dropIndicator: isDragIndicator === true ? props : undefined
        }));
    const remainingEstimates = (0, $1gQ73.useBacklogSelector)((state)=>(0, $iRgPd.getRemainingEstimate)(state, {
            cardListId: dividerCardListId,
            dropIndicator: isDragIndicator === true ? props : undefined
        }));
    const filteredIssues = (0, $iRgPd.useFilteredIssueCount)(dividerCardListId);
    const filters = (0, $1gQ73.useBacklogSelector)((0, $kdGmo.getFilters));
    const isFilterOn = !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(filters);
    const isDisplayRemainTimeEnabled = (0, $1gQ73.useBacklogSelector)((0, $aEtjw.getIsRemainingTimeTrackingEnabledSelector));
    const shouldShowFilteredCount = isFilterOn && !isDragIndicator;
    const filteredRemainingEstimates = (0, $iRgPd.useFilteredRemainingEstimate)(dividerCardListId);
    const isRemainDifferentFromOriginal = shouldShowFilteredCount ? filteredRemainingEstimates.originalTimeEstimate !== filteredRemainingEstimates.remainingTimeEstimate : remainingEstimates.originalTimeEstimate !== remainingEstimates.remainingTimeEstimate;
    const formatEstimationValue = (0, $iRgPd.useFormatEstimationValue)();
    const formatTimeTrackingValue = (0, $iRgPd.useFormatTimeTrackingValue)();
    const elements = [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            key: "total"
        }, shouldShowFilteredCount ? formatMessage((0, $3XxT0.messages).filteredAmountCards, {
            cardAmount: totalIssues,
            filteredIssues: filteredIssues,
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                    as: "strong"
                }, chunks)
        }) : formatMessage((0, $3XxT0.messages).totalCards, {
            cardAmount: totalIssues,
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                    as: "strong"
                }, chunks)
        }))
    ];
    const infoVerticalDivider = (prefix)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bdb18cbe9e681d33$var$InfoVerticalDivider, {
            key: `${prefix}VerticalDivider`,
            isDragIndicator: isDragIndicator
        });
    const remainingEstimateState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        key: "remainingEstimate"
    }, shouldShowFilteredCount ? formatMessage((0, $3XxT0.messages).filteredRemainingLabel, {
        estimate: formatTimeTrackingValue(remainingEstimates.remainingTimeEstimate),
        filteredEstimate: formatTimeTrackingValue(filteredRemainingEstimates.remainingTimeEstimate),
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                as: "strong"
            }, chunks)
    }) : formatMessage((0, $3XxT0.messages).remainingLabel, {
        estimate: formatTimeTrackingValue(remainingEstimates.remainingTimeEstimate),
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                as: "strong"
            }, chunks)
    }));
    const storyPointState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        key: "storyPoints"
    }, shouldShowFilteredCount ? formatMessage((0, $3XxT0.messages).filteredEstimateLabel, {
        estimate: formatEstimationValue(remainingEstimates.storyPoints),
        filteredEstimate: formatEstimationValue(filteredRemainingEstimates.storyPoints),
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                as: "strong"
            }, chunks)
    }) : formatMessage((0, $3XxT0.messages).estimateLabel, {
        estimate: formatEstimationValue(remainingEstimates.storyPoints),
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                as: "strong"
            }, chunks)
    }));
    const originalEstimateState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        key: "originalEstimate"
    }, shouldShowFilteredCount ? formatMessage((0, $3XxT0.messages).filteredEstimateLabel, {
        estimate: formatEstimationValue(remainingEstimates.originalTimeEstimate),
        filteredEstimate: formatEstimationValue(filteredRemainingEstimates.originalTimeEstimate),
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                as: "strong"
            }, chunks)
    }) : formatMessage((0, $3XxT0.messages).estimateLabel, {
        estimate: formatEstimationValue(remainingEstimates.originalTimeEstimate),
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                as: "strong"
            }, chunks)
    }));
    if (estimationType === (0, $7TyGu.STORY_POINTS)) {
        if (isCompanyManaged && isDisplayRemainTimeEnabled) elements.push(...[
            infoVerticalDivider('remaining'),
            remainingEstimateState
        ]);
        elements.push(...[
            infoVerticalDivider('storyPoint'),
            storyPointState
        ]);
    } else if (estimationType === (0, $7TyGu.ORIGINAL_ESTIMATE)) {
        if (isCompanyManaged) {
            // in a CMP board
            // show remaining estimate only if it's different from original estimate
            // and Time Tracking is set to "Remaining Estimate and Time Spent"
            isDisplayRemainTimeEnabled && isRemainDifferentFromOriginal && elements.push(...[
                infoVerticalDivider('remaining'),
                remainingEstimateState
            ]); // always show original estimate
            elements.push(...[
                infoVerticalDivider('originalEstimate'),
                originalEstimateState
            ]);
        } else {
            // TMP
            if (remainingEstimates.remainingTimeEstimate > 0) elements.push(...[
                infoVerticalDivider('remaining'),
                remainingEstimateState
            ]);
            if (remainingEstimates.originalTimeEstimate > 0) elements.push(...[
                infoVerticalDivider('originalEstimate'),
                originalEstimateState
            ]);
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bdb18cbe9e681d33$var$DividerStatisticsContainer, {
        isDragIndicator: isDragIndicator
    }, elements);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bdb18cbe9e681d33$var$DividerStatisticsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDragIndicator: isDragIndicator, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wybutpp _1e0c1txw _4cvr1h6o _gy1putpp _1bahv2br _1n261g80 _18u0u2gc",
            __cmplp.isDragIndicator ? "_syaz15cr" : "_syaz1ifp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bdb18cbe9e681d33$var$InfoVerticalDivider = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDragIndicator: isDragIndicator, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbt94y _4t3ipxbi _1s7z1hdd _tzy41ou4",
            __cmplp.isDragIndicator ? "_1h6d15cr" : "_1h6d1ifp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aEtjw", function(module, exports) {

$parcel$export(module.exports, "getIsRemainingTimeTrackingEnabledSelector", () => $666b6960e1f91622$export$8570c81ed161c2ff);

var $df4Sl = parcelRequire("df4Sl");

var $7TyGu = parcelRequire("7TyGu");

var $kF7v3 = parcelRequire("kF7v3");
const $666b6960e1f91622$export$bbf9cd07c2eaa1ef = (state)=>(0, $kF7v3.getEntities)(state).tracking;
const $666b6960e1f91622$export$8570c81ed161c2ff = (0, $df4Sl.createSelector)($666b6960e1f91622$export$bbf9cd07c2eaa1ef, ({ fieldId: fieldId, isEnabled: isEnabled })=>fieldId === (0, $7TyGu.REMAINING_TIME_ESTIMATE) && isEnabled);

});

parcelRegister("3XxT0", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d1b5c76bcc834d90$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $d1b5c76bcc834d90$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    totalCards: {
        "id": "backlog.card-list.divider.divider-statistics.total-cards",
        "defaultMessage": "{cardAmount} {cardAmount, plural, one {issue} other {issues}}"
    },
    remainingLabel: {
        "id": "backlog.card-list.divider.divider-statistics.remaining-label",
        "defaultMessage": "Remaining: <strong> {estimate}</strong>"
    },
    estimateLabel: {
        "id": "backlog.card-list.divider.divider-statistics.estimate-label",
        "defaultMessage": "Estimate: <strong> {estimate}</strong>"
    },
    filteredAmountCards: {
        "id": "backlog.card-list.divider.divider-statistics.filtered-amount-cards",
        "defaultMessage": "{filteredIssues} of {cardAmount} {cardAmount, plural, one {issue} other {issues}} visible"
    },
    filteredRemainingLabel: {
        "id": "backlog.card-list.divider.divider-statistics.filtered-remaining-label",
        "defaultMessage": "Remaining: <strong>{filteredEstimate}</strong> of <strong> {estimate}</strong>"
    },
    filteredEstimateLabel: {
        "id": "backlog.card-list.divider.divider-statistics.filtered-estimate-label",
        "defaultMessage": "Estimate: <strong>{filteredEstimate}</strong> of <strong> {estimate}</strong>"
    }
});

});

parcelRegister("iRgPd", function(module, exports) {

$parcel$export(module.exports, "getTotalIssues", () => $709c26a417085678$export$ccdde37230173dca);
$parcel$export(module.exports, "useFilteredIssueCount", () => $709c26a417085678$export$e00b7e9864c0aea);
$parcel$export(module.exports, "getRemainingEstimate", () => $709c26a417085678$export$f7a6085461cb8569);
$parcel$export(module.exports, "useFilteredRemainingEstimate", () => $709c26a417085678$export$c02472649cbf065e);
$parcel$export(module.exports, "useFormatEstimationValue", () => $709c26a417085678$export$272fec22eab6d7a0);
$parcel$export(module.exports, "useFormatTimeTrackingValue", () => $709c26a417085678$export$4098419827dc90d2);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3l6tm = parcelRequire("3l6tm");

var $7v0hO = parcelRequire("7v0hO");

var $9DRwn = parcelRequire("9DRwn");

var $7TyGu = parcelRequire("7TyGu");

var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $kF7v3 = parcelRequire("kF7v3");

var $1ircG = parcelRequire("1ircG");
function $709c26a417085678$export$a9dc09a05e35644a(state, { cardListId: cardListId, dropIndicator: dropIndicator }) {
    const cardIds = (0, $kF7v3.getEntities)(state).cardOrder[cardListId] ?? [];
    if (!dropIndicator) return cardIds;
    const cardListOrder = (0, $kF7v3.getEntities)(state).cardListOrder ?? [];
    const filteredCards = (0, $bP7Jx.getFilteredOrderedCardIdsByCardListId)(state)[cardListId] ?? [];
    const targetListIndex = cardListOrder.indexOf(dropIndicator.droppingOverCardListId);
    const sourceListIndex = cardListOrder.indexOf(cardListId);
    // When dragging up into a previous list
    if (targetListIndex < sourceListIndex) return cardIds.filter((cardId)=>filteredCards.includes(cardId) === false);
    if (dropIndicator.droppingOverCardListId === cardListId) {
        const { droppingOverCardId: droppingOverCardId, edge: edge } = dropIndicator;
        const targetIndex = filteredCards?.indexOf(droppingOverCardId);
        const limitIndex = edge === 'bottom' ? targetIndex + 1 : targetIndex;
        const cardsToInclude = new Set(filteredCards.slice(0, limitIndex));
        const filteredCardsSet = new Set(filteredCards);
        return cardIds.filter((cardId)=>filteredCardsSet.has(cardId) === false || cardsToInclude.has(cardId));
    }
    const { droppingOverCardId: droppingOverCardId, edge: edge } = dropIndicator;
    const targetListCardIds = (0, $bP7Jx.getFilteredOrderedCardIdsByCardListId)(state)[dropIndicator.droppingOverCardListId] ?? [];
    const targetIndex = targetListCardIds?.indexOf(droppingOverCardId);
    const limitIndex = edge === 'bottom' ? targetIndex + 1 : targetIndex;
    const extraCards = targetListCardIds.slice(0, limitIndex);
    const betweenListsCardIds = cardListOrder.slice(sourceListIndex + 1, targetListIndex).flatMap((listId)=>(0, $bP7Jx.getFilteredOrderedCardIdsByCardListId)(state)[listId]);
    return cardIds.concat(betweenListsCardIds).concat(extraCards);
}
function $709c26a417085678$export$ccdde37230173dca(state, { cardListId: cardListId, dropIndicator: dropIndicator }) {
    const dividerCardIds = $709c26a417085678$export$a9dc09a05e35644a(state, {
        cardListId: cardListId,
        dropIndicator: dropIndicator
    });
    const cards = dividerCardIds.map((cardId)=>(0, $kF7v3.getEntities)(state).card[cardId]);
    const dividerCardIdsExcludingSubtasks = cards.filter((card)=>!(0, $3l6tm.isSubtaskHierarchyLevel)(card.typeHierarchyLevel)).map((card)=>card.id);
    return dividerCardIdsExcludingSubtasks.length;
}
const $709c26a417085678$export$e00b7e9864c0aea = (cardListId)=>{
    const cardIds = (0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.getFilteredOrderedCardIdsByCardListId)(state)[cardListId]) || [];
    const allCards = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getCards));
    const cardIdsExcludingSubtasks = cardIds.filter((cardId)=>{
        const card = allCards[cardId];
        return !(0, $3l6tm.isSubtaskHierarchyLevel)(card.typeHierarchyLevel);
    });
    return cardIdsExcludingSubtasks?.length ?? 0;
};
function $709c26a417085678$export$20385ed8ed7319fa(card) {
    if (card.isDone) return {
        storyPoints: 0,
        originalTimeEstimate: 0,
        remainingTimeEstimate: 0
    };
    return {
        storyPoints: card.estimate?.storyPoints ?? 0,
        originalTimeEstimate: card.estimate?.originalEstimate?.value ?? 0,
        remainingTimeEstimate: card.estimate?.timeRemainingEstimate?.value ?? 0
    };
}
function $709c26a417085678$export$f7a6085461cb8569(state, { cardListId: cardListId, dropIndicator: dropIndicator }) {
    const cardIds = $709c26a417085678$export$a9dc09a05e35644a(state, {
        cardListId: cardListId,
        dropIndicator: dropIndicator
    });
    let cards = cardIds.map((cardId)=>(0, $kF7v3.getEntities)(state).card[cardId]);
    if (!(0, $1ybV0.ff)('jsw.disable-tracking-statistic-parent-aggregation.tnk1073') && !(0, $hkGxG.isCmpKanbanProject)(state)) cards = cards.filter((card)=>!(0, $3l6tm.isSubtaskHierarchyLevel)(card.typeHierarchyLevel));
    const estimates = cards.map((card)=>$709c26a417085678$export$20385ed8ed7319fa(card));
    return estimates.reduce((acc, { storyPoints: storyPoints, originalTimeEstimate: originalTimeEstimate, remainingTimeEstimate: remainingTimeEstimate })=>({
            totalIssues: acc.totalIssues + 1,
            storyPoints: acc.storyPoints + storyPoints,
            originalTimeEstimate: acc.originalTimeEstimate + originalTimeEstimate,
            remainingTimeEstimate: acc.remainingTimeEstimate + remainingTimeEstimate
        }), {
        storyPoints: 0,
        originalTimeEstimate: 0,
        remainingTimeEstimate: 0,
        totalIssues: 0
    });
}
function $709c26a417085678$export$c02472649cbf065e(cardListId) {
    const cardIds = (0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.getFilteredOrderedCardIdsByCardListId)(state)[cardListId] ?? []);
    const allCards = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getCards));
    const isCmpKanban = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.isCmpKanbanProject));
    return (0, $eUqFw.useMemo)(()=>{
        let cards = cardIds.map((cardId)=>allCards[cardId]);
        if (!(0, $1ybV0.ff)('jsw.disable-tracking-statistic-parent-aggregation.tnk1073') && !isCmpKanban) cards = cards.filter((card)=>!(0, $3l6tm.isSubtaskHierarchyLevel)(card.typeHierarchyLevel));
        const estimates = cards.map((card)=>$709c26a417085678$export$20385ed8ed7319fa(card));
        return estimates.reduce((acc, { storyPoints: storyPoints, originalTimeEstimate: originalTimeEstimate, remainingTimeEstimate: remainingTimeEstimate })=>({
                totalIssues: acc.totalIssues + 1,
                storyPoints: acc.storyPoints + storyPoints,
                originalTimeEstimate: acc.originalTimeEstimate + originalTimeEstimate,
                remainingTimeEstimate: acc.remainingTimeEstimate + remainingTimeEstimate
            }), {
            storyPoints: 0,
            originalTimeEstimate: 0,
            remainingTimeEstimate: 0,
            totalIssues: 0
        });
    }, [
        cardIds,
        allCards,
        isCmpKanban
    ]);
}
function $709c26a417085678$export$272fec22eab6d7a0() {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const timeTrackingOptions = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getTimeTrackingOptions));
    const estimationType = (0, $1gQ73.useBacklogSelector)((0, $1ircG.getEstimationType));
    const formatStoryPointsTotal = (0, $9DRwn.useFormatStoryPointsTotal)();
    return (value)=>{
        if (estimationType === (0, $7TyGu.ORIGINAL_ESTIMATE)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $7v0hO.timeTrackingFormatter)(value, timeTrackingOptions, {
            formatMessage: formatMessage
        });
        return formatStoryPointsTotal(value);
    };
}
const $709c26a417085678$export$4098419827dc90d2 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const timeTrackingOptions = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getTimeTrackingOptions));
    return (value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $7v0hO.timeTrackingFormatter)(value, timeTrackingOptions, {
            formatMessage: formatMessage
        });
};

});
parcelRegister("9DRwn", function(module, exports) {

$parcel$export(module.exports, "useFormatStoryPointsTotal", () => $2ca27de228dc36ec$export$1d30858fcd85be3);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");
const $2ca27de228dc36ec$export$1d30858fcd85be3 = ()=>{
    const { formatNumber: formatNumber } = (0, $5JgJ2.default)();
    // fix for floating point math issues (like 0.1 + 0.2 becomes 0.30000000000000004)
    // as the numbers end with lots of zeroes followed by a single digit, trimming
    // after 8 decimal points results in a sane representation
    return (0, $eUqFw.useCallback)((total)=>formatNumber(total, {
            maximumFractionDigits: 8
        }), [
        formatNumber
    ]);
};

});




parcelRegister("fQe8P", function(module, exports) {

$parcel$export(module.exports, "useDraggableCard", () => $7d5e6eaf982e8e28$export$ee9f6369c1b523a9);
/**
 * This module implements the view handling of drag-and-drop for cards on the backlog.
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $8blac = parcelRequire("8blac");

var $fSMvP = parcelRequire("fSMvP");
parcelRequire("3f2za");
var $jFl9L = parcelRequire("jFl9L");

var $eo9PV = parcelRequire("eo9PV");
parcelRequire("dxB16");
var $7CaTR = parcelRequire("7CaTR");
parcelRequire("bweg7");
var $jfbwa = parcelRequire("jfbwa");

var $3l6tm = parcelRequire("3l6tm");

var $hKj4G = parcelRequire("hKj4G");

var $6JHeX = parcelRequire("6JHeX");

var $9eH8H = parcelRequire("9eH8H");


var $1gQ73 = parcelRequire("1gQ73");

var $7TN4i = parcelRequire("7TN4i");

var $7Egcu = parcelRequire("7Egcu");

var $hzOcT = parcelRequire("hzOcT");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $8CqRc = parcelRequire("8CqRc");

var $5iujD = parcelRequire("5iujD");

var $ecfSW = parcelRequire("ecfSW");

var $luai1 = parcelRequire("luai1");
function $7d5e6eaf982e8e28$export$3e7309cd70331d59({ args: args, into: { cardId: cardId, cardParentId: cardParentId, cardIsSubtask: cardIsSubtask, cardIndex: cardIndex, cardOrderList: cardOrderList, cards: cards }, isAllSelectedSiblingSubtasks: isAllSelectedSiblingSubtasks, isAnySelectedOrphanedSubtask: isAnySelectedOrphanedSubtask }) {
    if (args.source.data.type === 'DIVIDER') return !cardIsSubtask;
    if (args.source.data.type !== (0, $94c330523ed620b5$export$4d4e6ab48cd5be5b)) return false;
    if (args.source.data.cardId === cardId) return false;
    if (!args.source.data.cardIsSubtask && cardOrderList.length === 1) return true;
    // ? Parent is in list and next card is subtask and has same parent
    if (cardIsSubtask && args.source.data.cardIsSubtask === false && cardOrderList.find((id)=>id === cardParentId)) return !((0, $3l6tm.isSubtaskHierarchyLevel)(cards[cardOrderList[cardIndex + 1]]?.typeHierarchyLevel) && cardParentId === cards[cardOrderList[cardIndex + 1]]?.parentId);
    // ? Parent is not in list and prev and next card is subtask
    if (cardIsSubtask && args.source.data.cardIsSubtask === false && cardOrderList.find((id)=>id === cardParentId) === undefined) return !((0, $3l6tm.isSubtaskHierarchyLevel)(cards[cardOrderList[cardIndex - 1]]?.typeHierarchyLevel) && (0, $3l6tm.isSubtaskHierarchyLevel)(cards[cardOrderList[cardIndex + 1]]?.typeHierarchyLevel) && cardParentId === cards[cardOrderList[cardIndex - 1]]?.parentId && cardParentId === cards[cardOrderList[cardIndex + 1]]?.parentId);
    // rerank within parent card group if only subtasks within that group are selected
    if (cardIsSubtask) return args.source.data.cardParentId === cardParentId && isAllSelectedSiblingSubtasks;
    return !isAnySelectedOrphanedSubtask;
}
function $7d5e6eaf982e8e28$export$e2e8fa6a19b7160b({ isCmpKanban: isCmpKanban, isAnySelectedOrphanedSubtask: isAnySelectedOrphanedSubtask, isAllSelectedSiblingSubtasks: isAllSelectedSiblingSubtasks }) {
    if (isCmpKanban) return true;
    // disable drag if orphaned subtasks have been selected with other cards
    return !(isAnySelectedOrphanedSubtask && !isAllSelectedSiblingSubtasks);
}
function $7d5e6eaf982e8e28$export$d195ad1a96bdcc9b({ isCmpKanban: isCmpKanban, isAnySelectedOrphanedSubtask: isAnySelectedOrphanedSubtask, isInvalidDropTarget: isInvalidDropTarget }) {
    return !isCmpKanban && isAnySelectedOrphanedSubtask && isInvalidDropTarget;
}
function $7d5e6eaf982e8e28$export$c20a17931b5f1f2d({ source: source, into: into, orderedCardIds: orderedCardIds, cards: cards, isAnySelectedOrphanedSubtask: isAnySelectedOrphanedSubtask, isAllSelectedSiblingSubtasks: isAllSelectedSiblingSubtasks, isCmpKanban: isCmpKanban }) {
    const intoCard = cards[orderedCardIds[into.index]];
    // Cards above and under the *target* card
    const intoCardTop = cards[orderedCardIds[into.index - 1]];
    const intoCardBottom = cards[orderedCardIds[into.index + 1]];
    // Dragging sub-task alone or with its own siblings onto its parent group
    if (source.isSubtask && !into.isSubtask && source.parentId === intoCard?.id && isAllSelectedSiblingSubtasks) return into.isCollapsed ? [] : [
        'bottom'
    ];
    // Dragging sub-task into any of its siblings
    if (source.isSubtask && into.isSubtask && source.parentId === into.parentId) return [
        'top',
        'bottom'
    ];
    // Can't drag sub-task on other cases if their parent isn't also selected
    if (source.isSubtask && isAnySelectedOrphanedSubtask) return [];
    if (isAnySelectedOrphanedSubtask && !isAllSelectedSiblingSubtasks && !isCmpKanban) return [];
    // Dragging task into a parent group
    const isDroppingIntoParentAttachedToGroup = !into.isSubtask && intoCardBottom?.parentId === intoCard?.id && !into.isCollapsed;
    if (isDroppingIntoParentAttachedToGroup) return [
        'top'
    ];
    // Test function for if a card is the same "card group" as the target
    const isSameGroup = (cardToTest)=>{
        if (cardToTest?.id === into.parentId) return true;
        if (cardToTest && (0, $3l6tm.isSubtaskHierarchyLevel)(cardToTest.typeHierarchyLevel) && cardToTest?.parentId === into.parentId) return true;
        return false;
    };
    // Dragging task into a detached sub-task group's first card
    // * target is sub-task
    // * card above it is not or is missing
    // * card above it is not this card's parent
    // This is the "first sub-task in a group without parent"
    const isDetachedSubtaskTopCard = into.isSubtask && !isSameGroup(intoCardTop);
    if (isDetachedSubtaskTopCard) return [
        'top'
    ];
    // This is the "last sub-task in a group with or without parent"
    const isBottomSubtask = into.isSubtask && !isSameGroup(intoCardBottom);
    if (isBottomSubtask) return [
        'bottom'
    ];
    // Dragging task into another task
    return into.isSubtask ? [] : [
        'bottom',
        'top'
    ];
}
function $7d5e6eaf982e8e28$export$ee9f6369c1b523a9({ elementRef: elementRef, cardId: cardId, cardListId: cardListId }) {
    const [dragState, setDragState] = (0, $eUqFw.useState)({
        type: 'idle'
    });
    const [dropState, setDropState] = (0, $eUqFw.useState)(null);
    const selectSingleCard = (0, $5iujD.useSelectSingleCard)();
    const cards = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getCards));
    const card = cards[cardId];
    const cardListKeys = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getCardListsKeys));
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const cardOrderList = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getOrderedCardIdsByCardListId));
    const getIsParentExpanded = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.makeGetCardGroupExpanded));
    const autobatch = (0, $hKj4G.useAutobatch)();
    const isAnySelectedOrphanedSubtask = (0, $1gQ73.useBacklogSelector)((0, $8CqRc.makeIsAnySelectedOrphanedSubtasks));
    const isAllSelectedSiblingSubtasks = (0, $1gQ73.useBacklogSelector)((0, $8CqRc.makeIsAllSelectedSiblingSubtasks));
    const isCmpKanban = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.isCmpKanbanProject));
    const moveCards = (0, $ecfSW.useSimplyMoveCards)();
    (0, $eUqFw.useEffect)(()=>{
        if (!elementRef.current) return undefined;
        if (!card) return undefined;
        const cardParentId = card.parentId;
        const cardIsSubtask = (0, $3l6tm.isSubtaskHierarchyLevel)(card.typeHierarchyLevel);
        const cardIndex = cardOrderList[cardListId].indexOf(cardId);
        return (0, $jFl9L.combine)((0, $eo9PV.draggable)({
            element: elementRef.current,
            getInitialData: ()=>({
                    type: (0, $94c330523ed620b5$export$4d4e6ab48cd5be5b),
                    cardId: cardId,
                    cardIsSubtask: cardIsSubtask,
                    cardParentId: cardParentId,
                    cardListId: cardListId
                }),
            onDragStart: ()=>{
                autobatch(()=>{
                    selectSingleCard(cardId);
                    const sourceCardGroupType = cardIsSubtask === true && cardListId && cardParentId ? (0, $6JHeX.createCardGroupDroppableId)(cardParentId, cardListId) : (0, $9eH8H.CARD_LIST_DROPPABLE_TYPE);
                    dispatch((0, $hzOcT.beforeCapture)(sourceCardGroupType, cardListId, cardIsSubtask, cardParentId ?? undefined));
                    dispatch((0, $7TN4i.cardListDragStart)(cardListKeys, cardListId, cardParentId ? `${cardParentId}-${cardListId}` : undefined));
                    dispatch((0, $hzOcT.dragStart)());
                });
            },
            onDrop: (_args)=>{
                autobatch(()=>{
                    const isInvalidDropTarget = (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(_args.location.current.dropTargets);
                    const showHelperFunction = $7d5e6eaf982e8e28$export$d195ad1a96bdcc9b({
                        isCmpKanban: isCmpKanban,
                        isAnySelectedOrphanedSubtask: isAnySelectedOrphanedSubtask,
                        isInvalidDropTarget: isInvalidDropTarget
                    });
                    if (showHelperFunction) dispatch((0, $7Egcu.cardDragDisallowed)());
                    setDragState({
                        type: 'idle'
                    });
                    dispatch((0, $7TN4i.cardListDragEnd)());
                });
            },
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                (0, $jfbwa.setCustomNativeDragPreview)({
                    getOffset: (0, $7CaTR.pointerOutsideOfPreview)({
                        x: '8px',
                        y: '8px'
                    }),
                    render ({ container: container }) {
                        setDragState({
                            type: 'dragging',
                            container: container
                        });
                        return ()=>setDragState({
                                type: 'idle'
                            });
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            }
        }), (0, $eo9PV.dropTargetForElements)({
            element: elementRef.current,
            getIsSticky: ()=>true,
            getData: ({ input: input, element: element, source: source })=>{
                const data = {
                    type: (0, $94c330523ed620b5$export$4d4e6ab48cd5be5b),
                    cardId: cardId,
                    cardListId: cardListId
                };
                const allowedEdges = $7d5e6eaf982e8e28$export$c20a17931b5f1f2d({
                    source: {
                        isSubtask: Boolean(source.data.cardIsSubtask),
                        cardId: Number(source.data.cardId),
                        parentId: source.data.cardParentId != null ? Number(source.data.cardParentId) : null
                    },
                    into: {
                        index: cardIndex,
                        isSubtask: cardIsSubtask,
                        cardId: cardId,
                        parentId: cardParentId,
                        isCollapsed: !getIsParentExpanded(cardId)
                    },
                    orderedCardIds: cardOrderList[cardListId],
                    cards: cards,
                    isAnySelectedOrphanedSubtask: isAnySelectedOrphanedSubtask,
                    isAllSelectedSiblingSubtasks: isAllSelectedSiblingSubtasks,
                    isCmpKanban: isCmpKanban
                });
                return (0, $fSMvP.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: allowedEdges
                });
            },
            onDrag: (args)=>{
                autobatch(()=>{
                    if (args.source.data.cardId !== cardId) {
                        const edge = (0, $fSMvP.extractClosestEdge)(args.self.data);
                        setDropState(edge && {
                            edge: edge,
                            cardListIfDivider: args.source.data.type === 'DIVIDER' ? String(args.source.data.cardListId) : null
                        });
                    }
                });
            },
            onDragEnter: (args)=>{
                autobatch(()=>{
                    if (args.source.data.cardId !== cardId) {
                        const edge = (0, $fSMvP.extractClosestEdge)(args.self.data);
                        setDropState(edge && {
                            edge: edge,
                            cardListIfDivider: args.source.data.type === 'DIVIDER' ? String(args.self.data.cardListId) : null
                        });
                    }
                });
            },
            onDragLeave: (_args)=>{
                autobatch(()=>{
                    setDropState(null);
                });
            },
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onDropTargetChange: (_args)=>{},
            canDrop: (args)=>$7d5e6eaf982e8e28$export$3e7309cd70331d59({
                    args: args,
                    into: {
                        cardId: cardId,
                        cardParentId: cardParentId,
                        cardIsSubtask: cardIsSubtask,
                        cardIndex: cardIndex,
                        cardOrderList: cardOrderList[cardListId],
                        cards: cards
                    },
                    isAllSelectedSiblingSubtasks: isAllSelectedSiblingSubtasks,
                    isAnySelectedOrphanedSubtask: isAnySelectedOrphanedSubtask
                }),
            onDrop: (args)=>{
                autobatch(()=>{
                    const location = {
                        type: dropState?.edge === 'top' ? 'before' : 'after',
                        target: cardId
                    };
                    if (args.source.data.type === 'DIVIDER') moveCards({
                        source: {
                            type: 'divider',
                            cardListId: String(args.source.data.cardListId)
                        },
                        location: location
                    });
                    if (args.source.data.type === (0, $94c330523ed620b5$export$4d4e6ab48cd5be5b)) moveCards({
                        source: {
                            cardId: Number(args.source.data.cardId)
                        },
                        location: location
                    });
                    setDropState(null);
                    dispatch((0, $hzOcT.dragEnd)());
                });
            }
        }));
    }, [
        card,
        cardId,
        cardListId,
        dispatch,
        moveCards,
        dropState?.edge,
        elementRef,
        selectSingleCard,
        cardListKeys,
        cardOrderList,
        cards,
        getIsParentExpanded,
        autobatch,
        isAnySelectedOrphanedSubtask,
        isAllSelectedSiblingSubtasks,
        isCmpKanban
    ]);
    return {
        isDragging: dragState.type === 'dragging',
        dragPreview: dragState.type === 'dragging' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $luai1.CardDragPreview), {
            id: cardId
        }), dragState.container) : null,
        closestEdge: dropState?.edge ?? null,
        dropState: dropState
    };
}

});
parcelRegister("fSMvP", function(module, exports) {

$parcel$export(module.exports, "attachClosestEdge", () => $2724dbed1c43baeb$export$f0cafff222395e89);
$parcel$export(module.exports, "extractClosestEdge", () => $2724dbed1c43baeb$export$945a571f3b658bf);
const $2724dbed1c43baeb$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
// using a symbol so we can guarantee a key with a unique value
const $2724dbed1c43baeb$var$uniqueKey = Symbol('closestEdge');
function $2724dbed1c43baeb$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $2724dbed1c43baeb$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = entries.sort((a, b)=>a.value - b.value)[0]?.edge ?? null;
    return {
        ...userData,
        [$2724dbed1c43baeb$var$uniqueKey]: addClosestEdge
    };
}
function $2724dbed1c43baeb$export$945a571f3b658bf(userData) {
    return userData[$2724dbed1c43baeb$var$uniqueKey] ?? null;
}

});

parcelRegister("3f2za", function(module, exports) {

$parcel$export(module.exports, "combine", () => (parcelRequire("jFl9L")).combine);

var $jFl9L = parcelRequire("jFl9L");

});

parcelRegister("dxB16", function(module, exports) {

$parcel$export(module.exports, "pointerOutsideOfPreview", () => (parcelRequire("7CaTR")).pointerOutsideOfPreview);

var $7CaTR = parcelRequire("7CaTR");

});
parcelRegister("7CaTR", function(module, exports) {

$parcel$export(module.exports, "pointerOutsideOfPreview", () => $d4283004fec21645$export$427e20518819fabc);
function $d4283004fec21645$export$427e20518819fabc(point) {
    return ({ container: container })=>{
        // Only reliable cross browser technique found to push a
        // drag preview away from the cursor is to use transparent borders on the container
        Object.assign(container.style, {
            borderLeft: `${point.x} solid transparent`,
            borderTop: `${point.y} solid transparent`
        });
        return {
            x: 0,
            y: 0
        };
    };
}

});


parcelRegister("bweg7", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => (parcelRequire("jfbwa")).setCustomNativeDragPreview);

var $jfbwa = parcelRequire("jfbwa");

});
parcelRegister("jfbwa", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => $ec46b73243fa3ce1$export$52d889c66db0f96e);

var $9wCS5 = parcelRequire("9wCS5");

var $Fx8Dp = parcelRequire("Fx8Dp");

/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $ec46b73243fa3ce1$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $ec46b73243fa3ce1$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $ec46b73243fa3ce1$var$defaultOffset }) {
    const container = document.createElement('div');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Using maximum possible z-index so that this element will always be on top
        // https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
        // Did not use `layers` in `@atlaskit/theme` because:
        // 1. This element is not a 'layer' in the conventional sense, as this element
        //    is only created for a single frame for the browser to take a photo of it,
        //    and then it is destroyed
        // 2. Did not want to add a dependency onto `@atlaskit/theme`
        // 3. Want to always be on top of product UI which might have higher z-index's
        zIndex: (0, $3c294e0fb95263f6$export$7d0a15ee70427305),
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    const unmount = render({
        container: container
    });
    const previewOffset = getOffset({
        container: container
    });
    /**
	 * **Problem**
	 * On `Safari@17.1` if a drag preview element has some opacity,
	 * Safari will include elements behind the drag preview element
	 * in the drag preview.
	 * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
	 *
	 * **Fix**
	 * We push the drag preview so it is _almost_ completely offscreen so that
	 * there won't be any elements behind the drag preview element.
	 * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
	 *
	 * Using `-0.0001` so that any potential "see through" on the drag preview element
	 * is effectively invisible 👻
	 *
	 * **Unsuccessful alternatives**
	 * Setting a background color (eg "white") on the `container`
	 * → Wrecks the opacity of the drag preview element
	 *
	 * Adding a parent element of the `container` with a background color (eg "white")
	 * → Wrecks the opacity of the drag preview element
	 */ if ((0, $Fx8Dp.isSafari)()) /**
		 *  For some frameworks (eg `react@18+` with `ReactDOM.createRoot().render()`) the rendering
		 *  inside the `container` does not occur until after a microtask.
		 *
		 *  Notes:
		 *    - This will run before the browser takes it's picture of the element
		 *    - This will run before the animation frame that removes `container`.
		 **/ queueMicrotask(()=>{
        const rect = container.getBoundingClientRect();
        // We cannot apply this fix if nothing has been rendered into the `container`
        if (rect.width === 0) return;
        container.style.left = `-${rect.width - 0.0001}px`;
    });
    nativeSetDragImage?.(container, previewOffset.x, previewOffset.y);
    function cleanup() {
        unbindMonitor();
        unmount?.();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $9wCS5.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}

});
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $3c294e0fb95263f6$export$7d0a15ee70427305 = 2147483647;



parcelRegister("6JHeX", function(module, exports) {

$parcel$export(module.exports, "createCardGroupDroppableId", () => $af710c07e343e64c$export$307280e35e15ee59);

var $9eH8H = parcelRequire("9eH8H");
const $af710c07e343e64c$export$307280e35e15ee59 = (parentId, cardListId)=>`${0, $9eH8H.CARD_GROUP_DROPPABLE_TYPE}::${parentId}::${cardListId}`;
const $af710c07e343e64c$export$241ac0b55520e68e = (droppableId)=>{
    const [prefix, parentId, cardListId] = droppableId.split('::');
    if (prefix === (0, $9eH8H.CARD_GROUP_DROPPABLE_TYPE) && parentId && cardListId) return {
        parentId: Number(parentId),
        cardListId: cardListId
    };
    return null;
};

});

parcelRegister("5iujD", function(module, exports) {

$parcel$export(module.exports, "useSelectSingleCard", () => $be2fe603325125f6$export$a8cb27a008b03fe0);

var $dkPd7 = parcelRequire("dkPd7");

var $1HfeQ = parcelRequire("1HfeQ");

var $1gQ73 = parcelRequire("1gQ73");

var $bP7Jx = parcelRequire("bP7Jx");
function $be2fe603325125f6$export$a8cb27a008b03fe0() {
    const selectedCards = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getSelectedCards));
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    return (0, $dkPd7.useEvent)((cardId)=>{
        if (!selectedCards.includes(cardId)) dispatch((0, $1HfeQ.cardSingleSelect)(cardId));
    });
}

});

parcelRegister("luai1", function(module, exports) {

$parcel$export(module.exports, "CardDragPreview", () => $c75c0633e0fd5c83$export$4b9ac0eff1e3aa75);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $8iu8f = parcelRequire("8iu8f");
function $c75c0633e0fd5c83$export$4b9ac0eff1e3aa75({ id: id }) {
    const isCmpKanbanBacklog = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.isCmpKanbanProject));
    const getDraggingCardIds = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.makeGetDraggingCardIds));
    const getChildIdsByParentId = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getChildIdsByParentIdSelector));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c75c0633e0fd5c83$var$CardDragPreviewContainer, null, getDraggingCardIds(id).slice(0, 5).map((contentsId, index)=>{
        const subtaskIds = isCmpKanbanBacklog ? [] : getChildIdsByParentId[contentsId];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8iu8f.default), {
            id: contentsId,
            key: contentsId,
            canShowStatus: false,
            isDragging: index === 0,
            isDragHandle: true,
            shouldRenderRichCard: false,
            isAttachedToParent: false,
            subtaskIds: subtaskIds
        });
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c75c0633e0fd5c83$var$CardDragPreviewContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _p12fgx0z",
            __cmplp.className
        ])
    });
});

});



parcelRegister("5qDf1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9e4e7a207419da6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $aZaPn = parcelRequire("aZaPn");

var $bKxX9 = parcelRequire("bKxX9");

var $eI5EY = parcelRequire("eI5EY");

var $cwaqP = parcelRequire("cwaqP");
var $knOxy = parcelRequire("knOxy");

var $bFzGY = parcelRequire("bFzGY");

var $lA3UV = parcelRequire("lA3UV");


var $1gQ73 = parcelRequire("1gQ73");

var $lsENz = parcelRequire("lsENz");

var $59CKH = parcelRequire("59CKH");

var $4sfcw = parcelRequire("4sfcw");

var $cbRhO = parcelRequire("cbRhO");

var $hkGxG = parcelRequire("hkGxG");

var $h6pBX = parcelRequire("h6pBX");

var $6ncr6 = parcelRequire("6ncr6");

var $bP7Jx = parcelRequire("bP7Jx");

var $kdGmo = parcelRequire("kdGmo");

var $lk2Zu = parcelRequire("lk2Zu");

var $k734R = parcelRequire("k734R");

var $7kNqR = parcelRequire("7kNqR");

var $83T52 = parcelRequire("83T52");

var $2B8YX = parcelRequire("2B8YX");
// Hacky way to generate optimistic issue id.
// Not ideal, but have to do it for now to react backwards compatibility with current ICC.
let $a9e4e7a207419da6$var$lastCardId = 0;
const $a9e4e7a207419da6$var$generateId = ()=>{
    $a9e4e7a207419da6$var$lastCardId -= 1;
    return $a9e4e7a207419da6$var$lastCardId;
};
const $a9e4e7a207419da6$var$StyledTypeSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const isCompanyManaged = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getIsCompanyManaged));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a9e4e7a207419da6$var$TypeSelectWrapper, {
        shouldShowChevron: isCompanyManaged
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $knOxy.default), {
        ...props,
        ref: ref
    }));
});
const $a9e4e7a207419da6$var$localStorage = (0, $aZaPn.createLocalStorageProvider)('backlog');
const $a9e4e7a207419da6$var$SELECTED_ISSUE_TYPE_KEY = 'selectedIssueType';
const $a9e4e7a207419da6$var$InlineCardCreate = ({ isBetweenCards: isBetweenCards = false, isOpenByDefault: isOpenByDefault = false, messages: messages, insertBefore: insertBefore = null, listId: listId, placeholderText: placeholderText = '', triggerLabel: triggerLabel = '', ariaLabelledBy: ariaLabelledBy, isFormVisible: isFormVisible })=>{
    const initialCardTypes = (0, $1gQ73.useBacklogSelector)((0, $lk2Zu.getCardTypesForICC));
    const parentId = (0, $1gQ73.useBacklogSelector)((0, $h6pBX.getLastAppliedParentFilters));
    const manageIssueTypesLink = (0, $1gQ73.useBacklogSelector)((state)=>{
        if ((0, $7kNqR.canEditBoardConfig)(state)) return (0, $6ncr6.manageIssueTypesSelector)(state);
        return null;
    });
    const enabledFilters = (0, $1gQ73.useBacklogSelector)((0, $kdGmo.getFilters));
    const hasICCOpen = (0, $1gQ73.useBacklogSelector)((state)=>insertBefore != null ? (0, $bP7Jx.hasICCOpen)(state, {
            cardId: insertBefore
        }) : false);
    const issueParents = (0, $1gQ73.useBacklogSelector)((state)=>(0, $k734R.issueParentsSelector)(state));
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const { storeFieldsFromCardCreateData: storeFieldsFromCardCreateData, storeFieldsFromFetchIssuesData: storeFieldsFromFetchIssuesData } = (0, $lA3UV.useStoreFields)({
        issueParents: issueParents
    });
    const isCompanyManaged = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getIsCompanyManaged));
    const isBoardCrossProject = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getIsBoardCrossProject));
    const inlineCreateSessionId = (0, $1gQ73.useBacklogSelector)((0, $lk2Zu.getInlineCreateSessionId));
    const defaultCardTypeId = $a9e4e7a207419da6$var$localStorage.get($a9e4e7a207419da6$var$SELECTED_ISSUE_TYPE_KEY) || null;
    const isEligibleInContextIssueTypesExperiment = (0, $bKxX9.ff)('config-in-context-issue-type-m2-flag_bddyq') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $83T52.useIsEligibleForConfigInContextIssueTypes)() : false;
    const onTriggerClick = (sessionId)=>{
        const shouldOpenGICModal = isCompanyManaged && (isBoardCrossProject || !initialCardTypes?.length);
        if (shouldOpenGICModal) {
            const fixVersions = enabledFilters.VERSION || [];
            const cardTypeId = initialCardTypes?.[0]?.id ?? null;
            dispatch((0, $cbRhO.openModal)({
                type: (0, $ebd52ea7083e351b$export$55cae6fd3c958bc5),
                payload: {
                    cardListId: listId,
                    cardParentId: parentId,
                    cardSummary: '',
                    cardTypeId: cardTypeId,
                    rankBeforeCardId: insertBefore,
                    fixVersions: fixVersions,
                    sessionId: inlineCreateSessionId
                }
            }));
        } else {
            // Dispatch session id.
            if (sessionId) dispatch((0, $4sfcw.setInlineCreateSessionId)({
                sessionId: sessionId
            }));
            dispatch((0, $59CKH.setCardIdWithAboveICCOpen)(insertBefore));
        }
    };
    const onCancel = (0, $eUqFw.useCallback)(()=>{
        dispatch((0, $59CKH.setCardIdWithAboveICCOpen)(null));
    }, [
        dispatch
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onCreate = (0, $eUqFw.useCallback)((inlineCards)=>{
        const { cardTypeId: cardTypeId } = inlineCards[0];
        const cardTypeEntity = initialCardTypes.find((ct)=>ct.id === cardTypeId);
        const fixVersions = enabledFilters.VERSION || [];
        const tempIds = inlineCards.map(()=>$a9e4e7a207419da6$var$generateId());
        const doesCardTypeHaveRequiredFields = !!cardTypeEntity?.hasRequiredFields;
        if (doesCardTypeHaveRequiredFields) {
            dispatch((0, $cbRhO.openModal)({
                type: (0, $ebd52ea7083e351b$export$55cae6fd3c958bc5),
                payload: {
                    cardListId: listId,
                    cardParentId: parentId,
                    // With requiredfield multiple card creation is disabled
                    cardSummary: inlineCards[0].summary,
                    cardTypeId: Number(cardTypeId),
                    rankBeforeCardId: insertBefore,
                    fixVersions: fixVersions,
                    sessionId: inlineCreateSessionId
                }
            }));
            return;
        }
        /** Analytics: We indicate to the analytics for issue creation that the inline creation ended up finishing inline creation (With session ID) */ const analyticsEvent = createAnalyticsEvent({
            action: 'created',
            actionSubject: 'issue',
            sessionId: inlineCreateSessionId
        });
        dispatch((0, $lsENz.cardCreateMultipleRequest)({
            tempIds: tempIds,
            summaries: inlineCards.map((inlineCard)=>inlineCard.summary),
            typeId: Number(cardTypeId),
            typeIcon: cardTypeEntity ? cardTypeEntity.iconUrl : '',
            parentId: parentId,
            fixVersions: fixVersions,
            insertBefore: insertBefore,
            listId: listId,
            storeFieldsFromCardCreateData: storeFieldsFromCardCreateData,
            storeFieldsFromFetchIssuesData: storeFieldsFromFetchIssuesData,
            analyticsEvent: analyticsEvent
        }));
        $a9e4e7a207419da6$var$localStorage.set($a9e4e7a207419da6$var$SELECTED_ISSUE_TYPE_KEY, cardTypeId);
    }, [
        initialCardTypes,
        enabledFilters.VERSION,
        createAnalyticsEvent,
        dispatch,
        parentId,
        insertBefore,
        listId,
        storeFieldsFromCardCreateData,
        storeFieldsFromFetchIssuesData,
        inlineCreateSessionId
    ]);
    const onCancelWrapper = (0, $eUqFw.useCallback)(()=>{
        onCancel();
    }, [
        onCancel
    ]);
    const onIccCreate = (0, $eUqFw.useCallback)((issues)=>{
        onCreate(issues.map((issue)=>({
                summary: issue.summary,
                cardTypeId: Number(issue.cardTypeId)
            })));
    }, [
        onCreate
    ]);
    const isFormHidden = isCompanyManaged && (isBoardCrossProject || !initialCardTypes?.length);
    const InlineIssueCreate = (0, $bKxX9.ff)('config-in-context-issue-type-m2-flag_bddyq') && isEligibleInContextIssueTypesExperiment ? (0, $2B8YX.InlineCardCreateWithIssueTypesInContext) : (0, $cwaqP.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(InlineIssueCreate, {
        cardTypes: initialCardTypes,
        extraItems: manageIssueTypesLink && [
            {
                url: manageIssueTypesLink
            }
        ] || undefined,
        numFilters: Object.keys(enabledFilters).length,
        onCreate: onIccCreate,
        onTriggerClick: onTriggerClick,
        onCancel: onCancelWrapper,
        onBlur: onCancelWrapper,
        appearance: (0, $3b526ddeb90a4d89$export$db1cdb8627b81f84),
        triggerAppearance: isBetweenCards ? (0, $3b526ddeb90a4d89$export$d2f7b3f0efb6e208) : (0, $3b526ddeb90a4d89$export$dda6912361cddac9),
        isFormVisibleDefault: isFormHidden ? false : isOpenByDefault || hasICCOpen,
        isMultiCreateEnabled: (0, $eI5EY.fg)('disable-icc-multi-create-4d2daa44') ? false : !isCompanyManaged,
        messages: messages,
        placeholderText: placeholderText,
        triggerLabel: triggerLabel,
        ariaLabelledBy: ariaLabelledBy,
        defaultCardTypeId: defaultCardTypeId,
        isFormVisible: isFormHidden ? false : isFormVisible,
        TypeSelect: $a9e4e7a207419da6$var$StyledTypeSelect
    });
};
var $a9e4e7a207419da6$export$2e2bcd8739ae039 = $a9e4e7a207419da6$var$InlineCardCreate;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a9e4e7a207419da6$var$TypeSelectWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldShowChevron: shouldShowChevron, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1kl7oyrj",
            __cmplp.shouldShowChevron ? "_18u01jfw" : "_18u0v47k",
            __cmplp.className
        ])
    });
});

});
const $3b526ddeb90a4d89$export$3789e4b2a10baa2b = 'full';
const $3b526ddeb90a4d89$export$db1cdb8627b81f84 = 'compact';
const $3b526ddeb90a4d89$export$aca095bc476d426f = 'simple';
const $3b526ddeb90a4d89$export$1aad44a7533f8ad8 = 'table_row';
const $3b526ddeb90a4d89$export$d2f7b3f0efb6e208 = 'hidden';
const $3b526ddeb90a4d89$export$dda6912361cddac9 = 'visible';
const $3b526ddeb90a4d89$export$565566e3df4dad53 = 'blur';
const $3b526ddeb90a4d89$export$806b905ec7df742f = 'enter';
const $3b526ddeb90a4d89$export$2bb790b9008907b4 = 'escape';
const $3b526ddeb90a4d89$export$ba9f60edfdf2e66 = 'create_button';
const $3b526ddeb90a4d89$export$3dd832bb5d8861ec = 'multi_dialog_single_create_button';
const $3b526ddeb90a4d89$export$b5288579893d806 = 'multi_dialog_multi_create_button';
const $3b526ddeb90a4d89$export$193356664cd84c83 = 255;
const $3b526ddeb90a4d89$export$f9e3e7ede9ba929d = 500;
const $3b526ddeb90a4d89$export$e0bc602b327f818b = 'add-issue-type-option';

parcelRegister("cwaqP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f599ab3d35464d79$export$2e2bcd8739ae039);

var $8LIba = parcelRequire("8LIba");

var $2ANoP = parcelRequire("2ANoP");
var $413NZ = parcelRequire("413NZ");
var $3OzvF = parcelRequire("3OzvF");
var $bZyJo = parcelRequire("bZyJo");
var $knOxy = parcelRequire("knOxy");

var $8LIba = parcelRequire("8LIba");

var $f599ab3d35464d79$export$2e2bcd8739ae039 = (0, $2ANoP.default);

});
parcelRegister("2ANoP", function(module, exports) {

$parcel$export(module.exports, "default", () => $e288578cc45ee77f$export$2e2bcd8739ae039);

var $axP2q = parcelRequire("axP2q");


var $413NZ = parcelRequire("413NZ");
var $knOxy = parcelRequire("knOxy");

var $bZyJo = parcelRequire("bZyJo");
var $3OzvF = parcelRequire("3OzvF");
var $e288578cc45ee77f$export$2e2bcd8739ae039 = (0, $axP2q.default);

});
parcelRegister("axP2q", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fd5506afa773cfb$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ /* eslint-disable jira/styled/styled-component-order */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $hompL = parcelRequire("hompL");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $hzcvF = parcelRequire("hzcvF");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $7LoO9 = parcelRequire("7LoO9");

var $kFmhS = parcelRequire("kFmhS");


var $8LIba = parcelRequire("8LIba");

var $7Y0s7 = parcelRequire("7Y0s7");
var $413NZ = parcelRequire("413NZ");

var $bZyJo = parcelRequire("bZyJo");
const $5fd5506afa773cfb$var$isEnrolledInSimplifyIccBundle = ()=>{
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_simplify_icc_bundle');
    return expConfig.get('cohort', 'not-enrolled') !== 'not-enrolled';
};
const $5fd5506afa773cfb$var$isInSimplifyIccBundleVariation = ()=>{
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_simplify_icc_bundle');
    return expConfig.get('cohort', 'not-enrolled') === 'variation';
};
// exact trigger height
const $5fd5506afa773cfb$var$TRIGGER_HEIGHT = 40;
const $5fd5506afa773cfb$var$containerStyles = (0, $1ZAYh.xcss)({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%'
});
const $5fd5506afa773cfb$var$withTriggerUnmountStyles = (0, $1ZAYh.xcss)({
    minHeight: `${$5fd5506afa773cfb$var$TRIGGER_HEIGHT}px`
});
const $5fd5506afa773cfb$var$withMarginTopStyles = null;
const $5fd5506afa773cfb$var$withTransparentStyles = null;
const $5fd5506afa773cfb$var$getMultiInlineCreateLimit = ()=>(0, $1ybV0.getFeatureFlagValue)('jsw.agility.inline.card.multi.create.limit', 20);
const $5fd5506afa773cfb$export$c283de3a59c46bc6 = (cardTypes, cardTypeId, defaultCardTypeId)=>{
    const selectedCardType = cardTypes.find(({ id: id })=>id === cardTypeId);
    const fallbackCardTypeId = defaultCardTypeId && cardTypes.some(({ id: id, isDisabled: isDisabled })=>id === defaultCardTypeId && isDisabled !== true) ? defaultCardTypeId : null;
    if (selectedCardType?.isDisabled === true) return fallbackCardTypeId;
    // To prevent setting invalid value when user switches to another ICC component that have different cardTypes
    return selectedCardType !== undefined ? cardTypeId : fallbackCardTypeId;
};
const $5fd5506afa773cfb$var$InlineCardCreate = (props)=>{
    const { isFormVisible: isFormVisibleProp, isFormVisibleDefault: isFormVisibleDefault = false, isDisabled: isDisabled = false, shouldScrollIntoView: shouldScrollIntoView, onChangeFormVisible: onChangeFormVisible = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), triggerAppearance: triggerAppearance, onTriggerClick: onTriggerClick = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onCancel: onCancel = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onCreate: onCreate = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), maxMultiCreate: maxMultiCreate, onChangeCardType: onChangeCardType = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onChangeSummary: onChangeSummary = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onChangeStatusTransition: onChangeStatusTransition = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onChangeProject: onChangeProject = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), cardTypes: cardTypes = [], defaultCardTypeId: defaultCardTypeId, autoFocus: autoFocus, isMultiCreateEnabled: isMultiCreateEnabled, extraItems: extraItems, shouldKeepFormOpenOnClickOutside: shouldKeepFormOpenOnClickOutside, triggerLabel: triggerLabel, ariaLabelledBy: ariaLabelledBy, appearance: appearance, placeholderText: placeholderText, numFilters: numFilters, messages: messages, saveOnBlur: saveOnBlur, renderAdditionalTypeSelectOptionContent: renderAdditionalTypeSelectOptionContent, renderAdditionalInlineCreateFooter: renderAdditionalInlineCreateFooter, onBlur: onBlur = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), TypeSelect: TypeSelect, StatusSelect: StatusSelect, statusTransitions: statusTransitions, projects: projects, isModalTrigger: isModalTrigger, shouldShowCreateButton: shouldShowCreateButton, isEligibleInContextIssueTypesExperiment: isEligibleInContextIssueTypesExperiment } = props;
    const [isFormVisible, setIsFormVisible] = (0, $eUqFw.useState)(isFormVisibleProp ?? isFormVisibleDefault);
    const [triggerUnmountTimeoutId, setTriggerUnmountTimeoutId] = (0, $eUqFw.useState)(null);
    const previousIsFormVisibleProp = (0, $hzcvF.usePreviousWithInitial)(isFormVisibleProp);
    const previousIsFormVisible = (0, $hzcvF.usePreviousWithInitial)(isFormVisible);
    const [shouldFocusTrigger, setShouldFocusTrigger] = (0, $eUqFw.useState)(false);
    const setFocusOnTrigger = (0, $eUqFw.useCallback)(()=>{
        setShouldFocusTrigger(true);
    }, []);
    const { showEnforcementIfStorageIsFull: showEnforcementIfStorageIsFull } = (0, $7LoO9.useStorageEnforcement)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    // should be clean up with experiment jsw_simplify_icc_bundle or move up to src/packages/software/board/src/view/board-container/board/inline-card-create/visible-icc
    const { hasCreatedIssueICC: hasCreatedIssueICC, triggerReason: triggerReason } = $5fd5506afa773cfb$var$isEnrolledInSimplifyIccBundle() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $kFmhS.useTriggerEventState)() : {
        hasCreatedIssueICC: false,
        triggerReason: undefined
    };
    const { setHasCreatedIssueICC: setHasCreatedIssueICC, setTriggerReason: setTriggerReason } = $5fd5506afa773cfb$var$isEnrolledInSimplifyIccBundle() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $kFmhS.useKeepIccOpenActions)() : {
        setHasCreatedIssueICC: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        setTriggerReason: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    };
    (0, $eUqFw.useEffect)(()=>{
        if (!false && (previousIsFormVisibleProp !== isFormVisibleProp || previousIsFormVisible !== isFormVisible)) // invoke callback everytime isFormVisibleProp or internal isFormVisible state changes
        onChangeFormVisible(isFormVisibleProp ?? isFormVisible);
    }, [
        isFormVisible,
        isFormVisibleProp,
        onChangeFormVisible,
        previousIsFormVisible,
        previousIsFormVisibleProp
    ]);
    const onTriggerClickCallback = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        const sessionId = (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4();
        if ($5fd5506afa773cfb$var$isEnrolledInSimplifyIccBundle()) setHasCreatedIssueICC(false);
        // @ts-expect-error Second argument should be of format "actionSubject action"
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'triggerClicked', 'triggerButton', {
            formWasOpen: isFormVisible,
            triggerAppearance: triggerAppearance,
            sessionId: sessionId,
            ...$5fd5506afa773cfb$var$isEnrolledInSimplifyIccBundle() && {
                isInSimplifyIccBundleVariation: $5fd5506afa773cfb$var$isInSimplifyIccBundleVariation()
            },
            ...(0, $1ybV0.ff)('icc-experience-enhancements') && {
                isAutoOpen: false
            }
        });
        if (isFormVisibleProp === undefined) {
            setTriggerUnmountTimeoutId(null);
            setIsFormVisible(true);
        }
        if ((0, $eI5EY.fg)('jsw_roadmaps_timeline-issue-creation-ally')) setShouldFocusTrigger(false);
        onTriggerClick(sessionId);
    }, [
        setHasCreatedIssueICC,
        isFormVisible,
        triggerAppearance,
        isFormVisibleProp,
        onTriggerClick
    ]);
    const onCancelCallback = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'blurred',
            actionSubject: 'inlineCardCreate'
        }), {
            cancelledBy: (0, $3b526ddeb90a4d89$export$2bb790b9008907b4)
        });
        if (isFormVisibleProp === undefined) {
            if (triggerUnmountTimeoutId) {
                clearTimeout(triggerUnmountTimeoutId);
                setTriggerUnmountTimeoutId(null);
            }
            setIsFormVisible(false);
        }
        onCancel();
    }, [
        createAnalyticsEvent,
        triggerUnmountTimeoutId,
        isFormVisibleProp,
        onCancel
    ]);
    const makeOnBlur = (0, $eUqFw.useCallback)((context)=>(summary)=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                action: 'blurred',
                actionSubject: 'inlineCardCreate'
            }), {
                cancelledBy: (0, $3b526ddeb90a4d89$export$565566e3df4dad53),
                ...$5fd5506afa773cfb$var$isEnrolledInSimplifyIccBundle() && {
                    withContent: !!summary,
                    isInSimplifyIccBundleVariation: $5fd5506afa773cfb$var$isInSimplifyIccBundleVariation()
                }
            });
            context.onChangeSummary(summary);
            if (isFormVisibleProp === undefined) {
                if (triggerUnmountTimeoutId) {
                    clearTimeout(triggerUnmountTimeoutId);
                    setTriggerUnmountTimeoutId(null);
                }
                setIsFormVisible(false);
            }
            onBlur();
            if ($5fd5506afa773cfb$var$isEnrolledInSimplifyIccBundle()) setHasCreatedIssueICC(true);
        }, [
        createAnalyticsEvent,
        isFormVisibleProp,
        onBlur,
        setHasCreatedIssueICC,
        triggerUnmountTimeoutId
    ]);
    const makeOnCreate = (0, $eUqFw.useCallback)((context)=>(issues, metadata)=>{
            // analytic event name will be changed in the future to match other events
            const analyticsEvent = createAnalyticsEvent({
                action: 'confirmed',
                actionSubject: 'input'
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
                createdBy: metadata.createdBy
            });
            context.onCreate();
            onCreate(issues.slice(0, maxMultiCreate), metadata, analyticsEvent);
            showEnforcementIfStorageIsFull({
                touchpoint: 'inline-card-create'
            });
            if ($5fd5506afa773cfb$var$isEnrolledInSimplifyIccBundle()) {
                setHasCreatedIssueICC(true);
                setTriggerReason('lastIssueCreated');
            }
        }, [
        createAnalyticsEvent,
        onCreate,
        maxMultiCreate,
        showEnforcementIfStorageIsFull,
        setHasCreatedIssueICC,
        setTriggerReason
    ]);
    const makeOnCancel = (0, $eUqFw.useCallback)((context)=>{
        if (context && context.onCancel) return ()=>{
            context.onCancel();
            onCancelCallback();
        };
        return onCancelCallback;
    }, [
        onCancelCallback
    ]);
    const makeOnChangeCardType = (0, $eUqFw.useCallback)((context)=>{
        if (context && context.onChangeCardType) return (issueTypeId)=>{
            context.onChangeCardType(issueTypeId);
            onChangeCardType(issueTypeId);
        };
        return onChangeCardType;
    }, [
        onChangeCardType
    ]);
    const makeOnChangeStatusTransition = (0, $eUqFw.useCallback)((context)=>{
        if (context && context.onChangeFieldValue) return (transitionId)=>{
            context.onChangeFieldValue((0, $413NZ.FIELD_KEY_STATUS_TRANSITIONS), transitionId);
            onChangeStatusTransition(transitionId);
        };
        return onChangeStatusTransition;
    }, [
        onChangeStatusTransition
    ]);
    const makeOnChangeSummary = (0, $eUqFw.useCallback)((context)=>{
        if (context && context.onChangeSummary) return (summary)=>{
            context.onChangeSummary(summary);
            onChangeSummary(summary);
        };
        return onChangeSummary;
    }, [
        onChangeSummary
    ]);
    const makeOnChangeProject = (0, $eUqFw.useCallback)((context)=>{
        if (context && context.onChangeProject) return (projectId)=>{
            context.onChangeProject(projectId);
            onChangeProject(projectId);
        };
        return onChangeProject;
    }, [
        onChangeProject
    ]);
    const isCardTypesEmptyOrAllDisabled = cardTypes.every(({ isDisabled: isCardTypeDisabled })=>Boolean(isCardTypeDisabled));
    const isTriggerDisabled = cardTypes?.length ? isDisabled || isCardTypesEmptyOrAllDisabled : isDisabled;
    const shouldRenderForm = (isFormVisibleProp ?? isFormVisible) && !isTriggerDisabled;
    (0, $eUqFw.useEffect)(()=>{
        /* 	below block is intended for case where icc is automatically opened after icc issue 
    	created when user opens originally opens icc in-between two existing issues */ if ($5fd5506afa773cfb$var$isEnrolledInSimplifyIccBundle() && shouldRenderForm === true && hasCreatedIssueICC) {
            if ((0, $1ybV0.ff)('icc-experience-enhancements')) {
                // unique sessionId for each icc
                const sessionId = (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4();
                // start event for auto open icc
                const startAutoOpenICCAnalyticsEvent = createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'button'
                });
                // firing start event for icc that is auto open - same as onTriggerClickCallback
                // @ts-expect-error Second argument should be of format "actionSubject action"
                (0, $jMP2a.fireUIAnalytics)(startAutoOpenICCAnalyticsEvent, 'triggerClicked', 'triggerButton', {
                    formWasOpen: isFormVisible,
                    triggerAppearance: triggerAppearance,
                    sessionId: sessionId,
                    isInSimplifyIccBundleVariation: $5fd5506afa773cfb$var$isInSimplifyIccBundleVariation(),
                    isAutoOpen: hasCreatedIssueICC
                });
                // to setInlineCreateSessionId for end event
                onTriggerClick(sessionId);
            }
            const autoFocusAnalyticsEvent = createAnalyticsEvent({
                action: 'focused',
                actionSubject: 'input',
                actionSubjectId: 'inlineCreateCard'
            });
            (0, $jMP2a.fireUIAnalytics)(autoFocusAnalyticsEvent, {
                triggeredBy: 'autoFocus',
                reason: triggerReason,
                ...$5fd5506afa773cfb$var$isEnrolledInSimplifyIccBundle() && {
                    isInSimplifyIccBundleVariation: $5fd5506afa773cfb$var$isInSimplifyIccBundleVariation()
                }
            });
            setHasCreatedIssueICC(false);
        }
    }, [
        createAnalyticsEvent,
        hasCreatedIssueICC,
        setHasCreatedIssueICC,
        shouldRenderForm,
        triggerReason,
        isFormVisible,
        triggerAppearance,
        onTriggerClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "inline-card-create",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        attributes: {
            appearance: appearance,
            numFilters: numFilters
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $5fd5506afa773cfb$var$containerStyles,
            triggerUnmountTimeoutId !== null && $5fd5506afa773cfb$var$withTriggerUnmountStyles
        ],
        testId: "platform-inline-card-create.ui.container"
    }, shouldRenderForm && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8LIba.IccContext).Consumer, null, (value)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Y0s7.default), {
            autoFocus: autoFocus,
            shouldScrollIntoView: shouldScrollIntoView,
            isMultiCreateEnabled: isMultiCreateEnabled,
            onSubmit: makeOnCreate(value),
            onCancel: makeOnCancel(value),
            onBlur: makeOnBlur(value),
            onChangeSummary: makeOnChangeSummary(value),
            numFilters: numFilters,
            maxMultiCreate: maxMultiCreate,
            messages: messages,
            cardTypes: cardTypes,
            extraItems: extraItems,
            shouldKeepFormOpenOnClickOutside: shouldKeepFormOpenOnClickOutside,
            selectedCardTypeId: $5fd5506afa773cfb$export$c283de3a59c46bc6(cardTypes, value.initialCardTypeId, defaultCardTypeId),
            selectedFieldValues: value.initialFieldValues,
            appearance: appearance,
            placeholderText: placeholderText,
            saveOnBlur: saveOnBlur,
            onChangeCardType: makeOnChangeCardType(value),
            onChangeStatusTransition: makeOnChangeStatusTransition(value),
            onChangeProject: makeOnChangeProject(value),
            initialSummary: value.initialSummary,
            renderAdditionalTypeSelectOptionContent: renderAdditionalTypeSelectOptionContent,
            renderAdditionalInlineCreateFooter: renderAdditionalInlineCreateFooter,
            TypeSelect: TypeSelect,
            StatusSelect: StatusSelect,
            statusTransitions: statusTransitions,
            selectedProjectId: value.initialProjectId,
            projects: projects,
            shouldShowCreateButton: shouldShowCreateButton,
            isEligibleInContextIssueTypesExperiment: isEligibleInContextIssueTypesExperiment,
            ...(0, $eI5EY.fg)('jsw_roadmaps_timeline-issue-creation-ally') ? {
                setFocusOnTrigger: setFocusOnTrigger
            } : {}
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            triggerUnmountTimeoutId !== null && "_19pk10j7",
            !(!shouldRenderForm && triggerUnmountTimeoutId === null) && "_tzy4idpf"
        ])
    }, (!shouldRenderForm || triggerUnmountTimeoutId !== null) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bZyJo.default), {
        isModalTrigger: isModalTrigger,
        isSticky: appearance === (0, $3b526ddeb90a4d89$export$aca095bc476d426f),
        triggerAppearance: triggerAppearance,
        label: triggerLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onTriggerClickCallback,
        isDisabled: isTriggerDisabled,
        ...(0, $eI5EY.fg)('jsw_roadmaps_timeline-issue-creation-ally') ? {
            shouldFocusTrigger: shouldFocusTrigger
        } : {}
    }))));
};
$5fd5506afa773cfb$var$InlineCardCreate.defaultProps = {
    isFormVisibleDefault: false,
    isMultiCreateEnabled: false,
    isDisabled: false,
    autoFocus: true,
    saveOnBlur: false,
    appearance: (0, $3b526ddeb90a4d89$export$3789e4b2a10baa2b),
    triggerAppearance: (0, $3b526ddeb90a4d89$export$dda6912361cddac9),
    triggerLabel: '',
    placeholderText: '',
    numFilters: 0,
    maxMultiCreate: $5fd5506afa773cfb$var$getMultiInlineCreateLimit() > 0 ? $5fd5506afa773cfb$var$getMultiInlineCreateLimit() : 20,
    messages: [],
    cardTypes: [],
    extraItems: undefined,
    onCreate: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onTriggerClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onChangeSummary: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onChangeCardType: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onChangeStatusTransition: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onChangeFormVisible: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onChangeProject: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    renderAdditionalInlineCreateFooter: undefined,
    shouldShowCreateButton: false
};
var $5fd5506afa773cfb$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($5fd5506afa773cfb$var$InlineCardCreate);

});
parcelRegister("7LoO9", function(module, exports) {

$parcel$export(module.exports, "useStorageEnforcement", () => $f0de573d65b66ce1$export$fa2c25e1ed13a1a8);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $hJ992 = parcelRequire("hJ992");

var $bNe1g = parcelRequire("bNe1g");


var $7YYuY = parcelRequire("7YYuY");

var $lXjME = parcelRequire("lXjME");
const $f0de573d65b66ce1$var$MODAL_COOLDOWN_MS = 86400000; // 1 day in ms
const $f0de573d65b66ce1$export$fa2c25e1ed13a1a8 = ()=>{
    const [currentState, { setIsOpen: setEnforceStorageModalIsOpen }] = (0, $lXjME.useEnforceStorageModal)();
    const issueViewMode = (0, $hJ992.useViewMode)();
    const { data: projectContextData } = (0, $bNe1g.useProjectContext)();
    const isInJSWProject = projectContextData?.projectType === (0, $7ZZxN.SOFTWARE_PROJECT);
    const openModalIfNotOnCooldown = (0, $eUqFw.useCallback)((touchpoint)=>{
        const isOnCooldown = Date.now() - ((0, $7YYuY.localStorage).get((0, $815b5650076b1618$export$ed785d2382d0101d)) || 0) < $f0de573d65b66ce1$var$MODAL_COOLDOWN_MS;
        if (isOnCooldown) {
            if (currentState.isOpen === 'pending') // Reset pending state if modal is on cooldown when it should be shown
            setEnforceStorageModalIsOpen({
                isOpen: 'closed',
                touchpoint: undefined
            });
        } else setEnforceStorageModalIsOpen({
            isOpen: 'open',
            touchpoint: touchpoint
        });
    }, [
        setEnforceStorageModalIsOpen,
        currentState.isOpen
    ]);
    const showEnforcementIfStorageIsFull = (0, $eUqFw.useCallback)(({ delayShow: delayShow = false, shouldOnlyShowInJSWContext: shouldOnlyShowInJSWContext = true, touchpoint: touchpoint })=>{
        if (shouldOnlyShowInJSWContext && !isInJSWProject) return;
        // Issue view use case is checked internally here rather than passed in, to avoid polluting consumer code
        if (delayShow || issueViewMode === (0, $935e771f19f8ea28$export$98c0ebc22792f04)) setEnforceStorageModalIsOpen({
            isOpen: 'pending',
            touchpoint: touchpoint
        });
        else openModalIfNotOnCooldown(touchpoint);
    }, [
        isInJSWProject,
        issueViewMode,
        setEnforceStorageModalIsOpen,
        openModalIfNotOnCooldown
    ]);
    // Used to show enforcement modal after modals are dismissed, to avoid modal on modal UX
    const showEnforcementIfPendingToShow = (0, $eUqFw.useCallback)(()=>{
        if (currentState.isOpen === 'pending') // Use the trigger from created the JSW issue
        openModalIfNotOnCooldown(currentState.touchpoint);
    }, [
        currentState.isOpen,
        openModalIfNotOnCooldown,
        currentState.touchpoint
    ]);
    return {
        showEnforcementIfStorageIsFull: showEnforcementIfStorageIsFull,
        showEnforcementIfPendingToShow: showEnforcementIfPendingToShow
    };
};

});
const $815b5650076b1618$export$b8b9d90f9e5bd72b = 'jira-enforce-storage-limits';
const $815b5650076b1618$export$8f56a4ad6e1486ea = 10;
const $815b5650076b1618$export$ed785d2382d0101d = 'lastStorageEnforcement';

parcelRegister("7YYuY", function(module, exports) {

$parcel$export(module.exports, "localStorage", () => $79189cfebd980a86$export$c2ed3351cac403d1);

var $aZaPn = parcelRequire("aZaPn");
const $79189cfebd980a86$export$c2ed3351cac403d1 = (0, $aZaPn.createLocalStorageProvider)('enforce-storage-limits');

});

parcelRegister("lXjME", function(module, exports) {

$parcel$export(module.exports, "useEnforceStorageModal", () => $2d9caf4f19990d1a$export$56beb4c2629d6615);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $erKBL = parcelRequire("erKBL");
const $2d9caf4f19990d1a$var$initialState = {
    isOpen: 'closed',
    touchpoint: undefined
};
const $2d9caf4f19990d1a$var$store = (0, $a61MH.createStore)({
    name: 'jsw-enforce-storage-limit-modal',
    initialState: $2d9caf4f19990d1a$var$initialState,
    actions: $erKBL.actions
});
const $2d9caf4f19990d1a$export$56beb4c2629d6615 = (0, $ggKAj.createHook)($2d9caf4f19990d1a$var$store);

});
parcelRegister("erKBL", function(module, exports) {

$parcel$export(module.exports, "actions", () => $31c22c176c15a4e6$export$e324594224ef24da);

var $fvtbN = parcelRequire("fvtbN");
const $31c22c176c15a4e6$export$e324594224ef24da = {
    setIsOpen: $fvtbN.setIsOpen
};

});
parcelRegister("fvtbN", function(module, exports) {

$parcel$export(module.exports, "setIsOpen", () => $9702937a09b78fa4$export$dcf23146e0a40195);
const $9702937a09b78fa4$export$dcf23146e0a40195 = (newState)=>({ setState: setState })=>{
        setState(newState);
    };

});




parcelRegister("kFmhS", function(module, exports) {

$parcel$export(module.exports, "useKeepIccOpenState", () => $1a055a762ad96fbc$export$991bb5f828c64eee);
$parcel$export(module.exports, "useKeepIccOpenActions", () => $1a055a762ad96fbc$export$bbdeb5b20a0dc1c1);
$parcel$export(module.exports, "useTriggerEventState", () => $1a055a762ad96fbc$export$438ab5dbdf55872);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $lkBAJ = parcelRequire("lkBAJ");


var $gPeU7 = parcelRequire("gPeU7");
const $1a055a762ad96fbc$var$isModalVisible = (key)=>(0, $lkBAJ.sessionStorage).get(key) !== undefined;
// If either modal is visible, then don't open the ICC
const $1a055a762ad96fbc$var$setInitialState = ()=>!($1a055a762ad96fbc$var$isModalVisible((0, $8379f5d78bf6fb5a$export$4e1360a3e7785935)) || $1a055a762ad96fbc$var$isModalVisible((0, $8379f5d78bf6fb5a$export$e3884212029f7bef)));
const $1a055a762ad96fbc$export$d4c72bab9d6cc13a = {
    keepIccOpen: $1a055a762ad96fbc$var$setInitialState(),
    hasCreatedIssueICC: true,
    triggerReason: 'emptyBoard'
};
const $1a055a762ad96fbc$var$store = (0, $a61MH.createStore)({
    name: 'jsw-onboarding-keep-icc-open',
    initialState: $1a055a762ad96fbc$export$d4c72bab9d6cc13a,
    actions: $gPeU7.actions
});
const $1a055a762ad96fbc$export$991bb5f828c64eee = (0, $ggKAj.createStateHook)($1a055a762ad96fbc$var$store, {
    selector: (state)=>state.keepIccOpen
});
const $1a055a762ad96fbc$export$bbdeb5b20a0dc1c1 = (0, $ggKAj.createActionsHook)($1a055a762ad96fbc$var$store);
const $1a055a762ad96fbc$export$438ab5dbdf55872 = (0, $ggKAj.createStateHook)($1a055a762ad96fbc$var$store, {
    selector: (state)=>({
            hasCreatedIssueICC: state.hasCreatedIssueICC,
            triggerReason: state.triggerReason
        })
});

});
parcelRegister("lkBAJ", function(module, exports) {

$parcel$export(module.exports, "sessionStorage", () => $38ca6466cf2419a3$export$f119d83aa936d634);
$parcel$export(module.exports, "localStorage", () => $38ca6466cf2419a3$export$c2ed3351cac403d1);

var $aZaPn = parcelRequire("aZaPn");
var $89bO2 = parcelRequire("89bO2");


var $hRWVt = parcelRequire("hRWVt");

var $4MMft = parcelRequire("4MMft");

var $kfb7k = parcelRequire("kfb7k");
const $38ca6466cf2419a3$export$f119d83aa936d634 = (0, $89bO2.createSessionExpirableStorageProvider)('onboarding-core');
const $38ca6466cf2419a3$export$c2ed3351cac403d1 = (0, $aZaPn.createLocalExpirableStorageProvider)('onboarding-core');

});
parcelRegister("hRWVt", function(module, exports) {

$parcel$export(module.exports, "isWithinLast30Days", () => $57d12d83709895e4$export$550dea1ca60eaa64);

var $li0pR = parcelRequire("li0pR");
const $57d12d83709895e4$export$550dea1ca60eaa64 = (0, $li0pR.isWithinLast)({
    days: 30
});

});
parcelRegister("li0pR", function(module, exports) {

$parcel$export(module.exports, "isWithinLast", () => $f9fbe1fa8b24f371$export$15bc1a874225842d);

var $aRS7n = parcelRequire("aRS7n");

var $9pRhM = parcelRequire("9pRhM");

var $9myoq = parcelRequire("9myoq");
const $f9fbe1fa8b24f371$export$15bc1a874225842d = (duration)=>(date)=>{
        if (!(0, $aRS7n.default)(date)) return false;
        const end = Date.now();
        const start = (0, $9myoq.default)(duration)(end);
        // `isValid` precludes a nullable date.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return (0, $9pRhM.default)({
            start: start,
            end: end
        })(date);
    };

});


parcelRegister("4MMft", function(module, exports) {

$parcel$export(module.exports, "userBelongsToBusinessUserSegCategory", () => $bea62c923aa19b28$export$517f94ab07724226);

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");
// Roles defined in user segmentation
const $bea62c923aa19b28$var$USER_SEGMENTATION_ROLE_DESIGNER = 'designer';
// Team types defined in user segmentation
const $bea62c923aa19b28$var$USER_SEGMENTATION_TEAM_TYPE_CUSTOMER_SERVICE = 'customer-service';
const $bea62c923aa19b28$var$USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT = 'it-support';
const $bea62c923aa19b28$var$USER_SEGMENTATION_TEAM_TYPE_HR = 'human-resources';
const $bea62c923aa19b28$var$USER_SEGMENTATION_TEAM_TYPE_FINANCE = 'finance';
const $bea62c923aa19b28$var$USER_SEGMENTATION_TEAM_TYPE_LEGAL = 'legal';
const $bea62c923aa19b28$var$USER_SEGMENTATION_TEAM_TYPE_MARKETING = 'marketing';
const $bea62c923aa19b28$var$USER_SEGMENTATION_TEAM_TYPE_OPERATIONS = 'operations';
const $bea62c923aa19b28$var$USER_SEGMENTATION_TEAM_TYPE_SALES = 'sales';
const $bea62c923aa19b28$var$USER_SEGMENTATION_TEAM_TYPE_SOFTWARE = 'software-development';
// Unique identifier used where all roles in a team type are eligible
const $bea62c923aa19b28$var$ALL_ROLES_ELIGIBLE = 'all-roles-eligible';
const $bea62c923aa19b28$export$2f3f9640393bd078 = 'unknown';
const $bea62c923aa19b28$export$4c9a72dac5ce80ae = '';
// @ts-expect-error - It seems to be missing some translations (for all-roles-eligible).
const $bea62c923aa19b28$var$USER_SEGMENTATION_CLIENT_MAPPING = {
    [$bea62c923aa19b28$var$USER_SEGMENTATION_ROLE_DESIGNER]: [
        'Designer',
        'Disainer',
        "Dise\xf1ador",
        'Formgivare',
        "Nh\xe0 thi\u1EBFt k\u1EBF",
        'Projektant',
        'Suunnittelija',
        "Tasar\u0131mc\u0131",
        "Tervez\u0151",
        "\u0414\u0438\u0437\u0430\u0439\u043D\u0435\u0440",
        "\u0E19\u0E31\u0E01\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A",
        "\u30C7\u30B6\u30A4\u30CA\u30FC",
        "\u8A2D\u8A08\u5E2B",
        "\u8BBE\u8BA1\u5E08",
        "\uB514\uC790\uC774\uB108"
    ],
    [$bea62c923aa19b28$var$USER_SEGMENTATION_TEAM_TYPE_CUSTOMER_SERVICE]: [
        'Asiakaspalvelu',
        'Atendimento ao cliente',
        'Customer Service',
        "D\u1ECBch v\u1EE5 kh\xe1ch h\xe0ng",
        'Klantenservice',
        'Klienditeenindus',
        'Kundenservice',
        'Kundeservice',
        'Kundservice',
        "M\xfc\u015Fteri Hizmetleri",
        "Obs\u0142uga klienta",
        "Service \xe0 la client\xe8le",
        "Servicio de atenci\xf3n al cliente",
        'Servizio clienti',
        "Servi\xe7o de apoio ao cliente",
        "Z\xe1kaznick\xfd servis",
        "Z\xe1kazn\xedcky servis",
        "\xdcgyf\xe9lszolg\xe1lati",
        "\u041E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432",
        "\u0421\u043B\u0443\u0436\u0431\u0430 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438 \u043A\u043B\u0456\u0454\u043D\u0442\u0456\u0432",
        "\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32",
        "\u30AB\u30B9\u30BF\u30DE\u30FC \u30B5\u30FC\u30D3\u30B9",
        "\u5BA2\u6237\u670D\u52A1",
        "\u9867\u5BA2\u670D\u52D9",
        "\uACE0\uAC1D \uC11C\uBE44\uC2A4"
    ],
    [$bea62c923aa19b28$var$USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT]: [
        'Assistenza IT',
        "BT Deste\u011Fi",
        "H\u1ED7 tr\u1EE3 CNTT",
        'IT',
        'IT Support',
        'IT podpora',
        "IT \u30B5\u30DD\u30FC\u30C8",
        "IT \u652F\u6301",
        "IT \u652F\u63F4",
        "IT \uC9C0\uC6D0",
        'IT_Support',
        "IT_st\xf8tte",
        'IT_support',
        'IT_tugi',
        'IT_tuki',
        "Informatikai t\xe1mogat\xe1si",
        'Soporte de TI',
        'Suporte de TI',
        "Support\xa0IT",
        'Wsparcie IT',
        "\u0418\u0422-\u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430",
        "\u0421\u043B\u0443\u0436\u0431\u0430 \u0442\u0435\u0445\u043D\u0456\u0447\u043D\u043E\u0457 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438",
        "\u0E1D\u0E48\u0E32\u0E22\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19 IT"
    ],
    [$bea62c923aa19b28$var$USER_SEGMENTATION_TEAM_TYPE_FINANCE]: [
        'Ekonomi',
        'Finance',
        'Financeiro',
        'Financie',
        'Finans',
        'Finanse',
        'Finants',
        'Finanza',
        'Finanzas',
        'Finanzen',
        "Finan\xe7as",
        "P\xe9nz\xfcgyi",
        'Rahoitus',
        "T\xe0i ch\xednh",
        "\xd8konomi",
        "\u0424\u0438\u043D\u0430\u043D\u0441\u044B",
        "\u0424\u0456\u043D\u0430\u043D\u0441\u0438",
        "\u0E01\u0E32\u0E23\u0E40\u0E07\u0E34\u0E19",
        "\u8CA1\u52D9",
        "\u91D1\u878D",
        "\uC7AC\uBB34"
    ],
    [$bea62c923aa19b28$var$USER_SEGMENTATION_TEAM_TYPE_HR]: [
        'HR',
        "Henkil\xf6st\xf6hallinto",
        'Human Resources',
        'Human resources',
        'human-resources',
        "Lidsk\xe9 zdroje",
        'Menneskelige ressourcer',
        "Nh\xe2n s\u1EF1",
        'Personal',
        "Personalfr\xe5gor",
        'RH',
        'Recursos Humanos',
        'Recursos humanos',
        'Risorse umane',
        "Szem\xe9lyzeti",
        'Zasoby ludzkie',
        "\u0130nsan Kaynaklar\u0131",
        "\u013Dudsk\xe9 zdroje",
        "\u0412\u0456\u0434\u0434\u0456\u043B \u043A\u0430\u0434\u0440\u0456\u0432",
        "\u041A\u0430\u0434\u0440\u043E\u0432\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
        "\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E32\u0E01\u0E23\u0E1A\u0E38\u0E04\u0E04\u0E25",
        "\u4EBA\u4E8B",
        "\u4EBA\u529B\u8CC7\u6E90",
        "\u4EBA\u529B\u8D44\u6E90",
        "\uC778\uC0AC"
    ],
    [$bea62c923aa19b28$var$USER_SEGMENTATION_TEAM_TYPE_LEGAL]: [
        "Departamento jur\xeddico",
        'Hukuk',
        'Jogi',
        'Jura',
        'Juridik',
        'Juridisk',
        "Jur\xeddico",
        'Legal',
        'Legale',
        'Oikeudelliset asiat',
        "Ph\xe1p l\xfd",
        'Prawo',
        "Pr\xe1vne oddelenie",
        "Pr\xe1vn\xed odd\u011Blen\xed",
        'Rechtliches',
        'Service juridique',
        "\xd5igus",
        "\u042E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
        "\u042E\u0440\u0438\u0434\u0438\u0447\u043D\u0438\u0439 \u0432\u0456\u0434\u0434\u0456\u043B",
        "\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22",
        "\u6CD5\u52D9",
        "\u6CD5\u5F8B",
        "\uBC95\uB960"
    ],
    [$bea62c923aa19b28$var$USER_SEGMENTATION_TEAM_TYPE_MARKETING]: [
        "Markedsf\xf8ring",
        'Marketing',
        'Markkinointi',
        "Marknadsf\xf6ring",
        'Pazarlama',
        "Ti\u1EBFp th\u1ECB",
        'Turundus',
        "\u041C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0433",
        "\u0E01\u0E32\u0E23\u0E15\u0E25\u0E32\u0E14",
        "\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0",
        "\u8425\u9500",
        "\u884C\u92B7",
        "\uB9C8\uCF00\uD305"
    ],
    [$bea62c923aa19b28$var$USER_SEGMENTATION_TEAM_TYPE_OPERATIONS]: [
        'Drift',
        'Haldus',
        'Operacional',
        'Operaciones',
        'Operacje',
        'Operasyonlar',
        'Operations',
        'Operativer Betrieb',
        'Operazioni',
        "Opera\xe7\xf5es",
        "Op\xe9rations",
        "Prev\xe1dzka",
        'Provoz',
        'Toiminnot',
        "V\u1EADn h\xe0nh",
        "\xdczemeltet\xe9si",
        "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u0447\u0438\u0439 \u0432\u0456\u0434\u0434\u0456\u043B",
        "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
        "\u0E1D\u0E48\u0E32\u0E22\u0E1B\u0E0F\u0E34\u0E1A\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23",
        "\u30AA\u30DA\u30EC\u30FC\u30B7\u30E7\u30F3",
        "\u71DF\u904B",
        "\u8FD0\u8425",
        "\uC6B4\uC601"
    ],
    [$bea62c923aa19b28$var$USER_SEGMENTATION_TEAM_TYPE_SALES]: [
        "B\xe1n h\xe0ng",
        "F\xf6rs\xe4ljning",
        'Myynti',
        "M\xfc\xfck",
        'Predaj',
        'Prodej',
        'Sales',
        'Salg',
        "Sat\u0131\u015F",
        "Sprzeda\u017C",
        'Vendas',
        'Vendite',
        'Ventas',
        'Ventes',
        'Vertrieb',
        "\xc9rt\xe9kes\xedt\xe9si",
        "\u041F\u0440\u043E\u0434\u0430\u0436\u0438",
        "\u041F\u0440\u043E\u0434\u0430\u0436\u0456",
        "\u0E1D\u0E48\u0E32\u0E22\u0E02\u0E32\u0E22",
        "\u30BB\u30FC\u30EB\u30B9",
        "\u92B7\u552E",
        "\u9500\u552E",
        "\uC601\uC5C5"
    ],
    [$bea62c923aa19b28$var$USER_SEGMENTATION_TEAM_TYPE_SOFTWARE]: [
        'Desarrollo de software',
        'Desenvolvimento de software',
        "D\xe9veloppement logiciel",
        'Ohjelmistokehitys',
        "Ph\xe1t tri\u1EC3n ph\u1EA7n m\u1EC1m",
        'Programutveckling',
        'Programvareutvikling',
        'Software Development',
        'Softwareentwicklung',
        'Softwareontwikkeling',
        'Softwareudvikling',
        'Sviluppo software',
        "Szoftverfejleszt\u0151",
        'Tarkvaraarendus',
        'Tworzenie oprogramowania',
        "V\xfdvoj softv\xe9ru",
        "V\xfdvoj softwaru",
        "Yaz\u0131l\u0131m Geli\u015Ftirme",
        "\u0420\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u041F\u041E",
        "\u0420\u043E\u0437\u0440\u043E\u0431\u043A\u0430 \u041F\u0417",
        "\u0E1E\u0E31\u0E12\u0E19\u0E32\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C",
        "\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u958B\u767A",
        "\u8EDF\u9AD4\u958B\u767C",
        "\u8F6F\u4EF6\u5F00\u53D1",
        "\uC18C\uD504\uD2B8\uC6E8\uC5B4 \uAC1C\uBC1C"
    ]
};
const $bea62c923aa19b28$var$BUSINESS_TEAM_TYPES = [
    $bea62c923aa19b28$var$USER_SEGMENTATION_TEAM_TYPE_HR,
    $bea62c923aa19b28$var$USER_SEGMENTATION_TEAM_TYPE_FINANCE,
    $bea62c923aa19b28$var$USER_SEGMENTATION_TEAM_TYPE_LEGAL,
    $bea62c923aa19b28$var$USER_SEGMENTATION_TEAM_TYPE_MARKETING,
    $bea62c923aa19b28$var$USER_SEGMENTATION_TEAM_TYPE_OPERATIONS,
    $bea62c923aa19b28$var$USER_SEGMENTATION_TEAM_TYPE_SALES,
    $bea62c923aa19b28$var$USER_SEGMENTATION_TEAM_TYPE_SOFTWARE
];
const $bea62c923aa19b28$var$BUSINESS_ROLES_PER_TEAM_TYPE = {
    [$bea62c923aa19b28$var$USER_SEGMENTATION_TEAM_TYPE_HR]: [
        $bea62c923aa19b28$var$ALL_ROLES_ELIGIBLE
    ],
    [$bea62c923aa19b28$var$USER_SEGMENTATION_TEAM_TYPE_FINANCE]: [
        $bea62c923aa19b28$var$ALL_ROLES_ELIGIBLE
    ],
    [$bea62c923aa19b28$var$USER_SEGMENTATION_TEAM_TYPE_LEGAL]: [
        $bea62c923aa19b28$var$ALL_ROLES_ELIGIBLE
    ],
    [$bea62c923aa19b28$var$USER_SEGMENTATION_TEAM_TYPE_MARKETING]: [
        $bea62c923aa19b28$var$ALL_ROLES_ELIGIBLE
    ],
    [$bea62c923aa19b28$var$USER_SEGMENTATION_TEAM_TYPE_OPERATIONS]: [
        $bea62c923aa19b28$var$ALL_ROLES_ELIGIBLE
    ],
    [$bea62c923aa19b28$var$USER_SEGMENTATION_TEAM_TYPE_SALES]: [
        $bea62c923aa19b28$var$ALL_ROLES_ELIGIBLE
    ],
    [$bea62c923aa19b28$var$USER_SEGMENTATION_TEAM_TYPE_SOFTWARE]: [
        $bea62c923aa19b28$var$USER_SEGMENTATION_ROLE_DESIGNER
    ]
};
const $bea62c923aa19b28$var$getNormalizedEntryNew = (userSegValue)=>{
    const lowerCaseUserSegValue = userSegValue.toLowerCase();
    return Object.entries($bea62c923aa19b28$var$USER_SEGMENTATION_CLIENT_MAPPING).find(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([, translatedValues])=>translatedValues.map((v)=>v.toLowerCase()).includes(lowerCaseUserSegValue));
};
const $bea62c923aa19b28$var$getNormalizedEntry = (value)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries($bea62c923aa19b28$var$USER_SEGMENTATION_CLIENT_MAPPING).find(([, translatedValues])=>translatedValues.includes(value));
const $bea62c923aa19b28$export$d0bc507f0556398 = (value)=>{
    if (value === '') return $bea62c923aa19b28$export$4c9a72dac5ce80ae;
    const normalizedEntry = (0, $1ybV0.ff)('use-upaas-to-display-template-picker-if-user-seg-is-unknown') ? $bea62c923aa19b28$var$getNormalizedEntryNew(value) : $bea62c923aa19b28$var$getNormalizedEntry(value);
    return normalizedEntry !== undefined ? normalizedEntry[0] : $bea62c923aa19b28$export$2f3f9640393bd078;
};
class $bea62c923aa19b28$var$SkipSentryError extends Error {
    constructor(message){
        super(message);
        this.skipSentry = true;
    }
}
const $bea62c923aa19b28$var$fireAnalyticsError = ({ id: id, field: field, error: error, unMatchedValue: unMatchedValue })=>{
    (0, $guiFP.default)({
        meta: {
            id: id,
            packageName: 'jiraOnboardingCore'
        },
        attributes: {
            field: field,
            unMatchedValue: unMatchedValue
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true
    });
};
const $bea62c923aa19b28$export$af8a28b856b3556f = (teamType)=>{
    if (!teamType) return false;
    const normalizedTeamType = $bea62c923aa19b28$export$d0bc507f0556398(teamType);
    if (normalizedTeamType === $bea62c923aa19b28$export$2f3f9640393bd078) $bea62c923aa19b28$var$fireAnalyticsError({
        id: 'isInSoftwareTeam',
        field: 'teamType',
        error: new $bea62c923aa19b28$var$SkipSentryError('teamType mapping is not found'),
        unMatchedValue: teamType
    });
    return normalizedTeamType === $bea62c923aa19b28$var$USER_SEGMENTATION_TEAM_TYPE_SOFTWARE;
};
const $bea62c923aa19b28$export$517f94ab07724226 = (userAccountData)=>{
    const { teamType: teamType = '', role: role = '' } = userAccountData;
    const normalizedTeamType = $bea62c923aa19b28$export$d0bc507f0556398(teamType);
    if (normalizedTeamType === $bea62c923aa19b28$export$2f3f9640393bd078) $bea62c923aa19b28$var$fireAnalyticsError({
        id: 'userBelongsToBusinessUserSegCategory',
        field: 'teamType',
        error: new $bea62c923aa19b28$var$SkipSentryError('teamType mapping is not found'),
        unMatchedValue: teamType
    });
    const normalizedRole = $bea62c923aa19b28$export$d0bc507f0556398(role);
    if (normalizedRole === $bea62c923aa19b28$export$2f3f9640393bd078) $bea62c923aa19b28$var$fireAnalyticsError({
        id: 'userBelongsToBusinessUserSegCategory',
        field: 'role',
        error: new $bea62c923aa19b28$var$SkipSentryError('role mapping is not found'),
        unMatchedValue: role
    });
    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'UserSegmentationTeamTypes'.
    const isTeamTypeEligible = $bea62c923aa19b28$var$BUSINESS_TEAM_TYPES.includes(normalizedTeamType);
    const isRoleEligible = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<UserSegmentationTeamTypes, UserSegmentationRoleTypes[]>>'.
    $bea62c923aa19b28$var$BUSINESS_ROLES_PER_TEAM_TYPE[normalizedTeamType]?.includes($bea62c923aa19b28$var$ALL_ROLES_ELIGIBLE) || // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<UserSegmentationTeamTypes, UserSegmentationRoleTypes[]>>'.
    $bea62c923aa19b28$var$BUSINESS_ROLES_PER_TEAM_TYPE[normalizedTeamType]?.includes(normalizedRole);
    return isTeamTypeEligible && isRoleEligible;
};
const $bea62c923aa19b28$export$6710e0127706b297 = (userAccountData)=>{
    const { teamType: teamType = '', role: role = '' } = userAccountData;
    const normalizedTeamType = $bea62c923aa19b28$export$d0bc507f0556398(teamType);
    if (normalizedTeamType === $bea62c923aa19b28$export$2f3f9640393bd078) $bea62c923aa19b28$var$fireAnalyticsError({
        id: 'userBelongsToSoftwareUserSegCategory',
        field: 'teamType',
        error: new $bea62c923aa19b28$var$SkipSentryError('teamType mapping is not found'),
        unMatchedValue: teamType
    });
    const normalizedRole = $bea62c923aa19b28$export$d0bc507f0556398(role);
    if (normalizedRole === $bea62c923aa19b28$export$2f3f9640393bd078) $bea62c923aa19b28$var$fireAnalyticsError({
        id: 'userBelongsToSoftwareUserSegCategory',
        field: 'role',
        error: new $bea62c923aa19b28$var$SkipSentryError('role mapping is not found'),
        unMatchedValue: role
    });
    const isTeamTypeEligible = normalizedTeamType === $bea62c923aa19b28$var$USER_SEGMENTATION_TEAM_TYPE_SOFTWARE;
    const isRoleEligible = normalizedRole !== $bea62c923aa19b28$var$USER_SEGMENTATION_ROLE_DESIGNER;
    return isTeamTypeEligible && isRoleEligible;
};

});


parcelRegister("gPeU7", function(module, exports) {

$parcel$export(module.exports, "actions", () => $895614ca13edc974$export$e324594224ef24da);

var $8oCep = parcelRequire("8oCep");

var $7StfE = parcelRequire("7StfE");

var $7iWDE = parcelRequire("7iWDE");
const $895614ca13edc974$export$e324594224ef24da = {
    toggleKeepIccOpen: $7iWDE.toggleKeepIccOpen,
    setHasCreatedIssueICC: $8oCep.setHasCreatedIssueICC,
    setTriggerReason: $7StfE.setTriggerReason
};

});
parcelRegister("8oCep", function(module, exports) {

$parcel$export(module.exports, "setHasCreatedIssueICC", () => $43e1a790e823859f$export$4bb464fc9800c324);
const $43e1a790e823859f$export$4bb464fc9800c324 = (hasCreatedIssueICC)=>({ getState: getState, setState: setState })=>{
        const { hasCreatedIssueICC: currentHasCreatedIssueICC } = getState();
        if (hasCreatedIssueICC === currentHasCreatedIssueICC) return;
        setState({
            hasCreatedIssueICC: hasCreatedIssueICC
        });
    };

});

parcelRegister("7StfE", function(module, exports) {

$parcel$export(module.exports, "setTriggerReason", () => $300156d3bb15f2e3$export$8b8ceaca9e30bc48);
const $300156d3bb15f2e3$export$8b8ceaca9e30bc48 = (triggerReason)=>({ getState: getState, setState: setState })=>{
        const { triggerReason: currentTriggerReason } = getState();
        if (triggerReason === currentTriggerReason) return;
        setState({
            triggerReason: triggerReason
        });
    };

});

parcelRegister("7iWDE", function(module, exports) {

$parcel$export(module.exports, "toggleKeepIccOpen", () => $9d185714023cbcc1$export$d09b33ff198a059);
const $9d185714023cbcc1$export$d09b33ff198a059 = ()=>({ getState: getState, setState: setState })=>{
        const { keepIccOpen: iccOpenState } = getState();
        setState({
            keepIccOpen: !iccOpenState
        });
    };

});



parcelRegister("7Y0s7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef7cf1673f5b1447$export$2e2bcd8739ae039);

var $bHoe9 = parcelRequire("bHoe9");

var $knOxy = parcelRequire("knOxy");

var $413NZ = parcelRequire("413NZ");

var $ef7cf1673f5b1447$export$2e2bcd8739ae039 = (0, $bHoe9.default);

});
parcelRegister("bHoe9", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e3633f6f5330cbb$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $dxIU5 = parcelRequire("dxIU5");

var $jG2Eu = parcelRequire("jG2Eu");

var $3MV1G = parcelRequire("3MV1G");

var $PdmhA = parcelRequire("PdmhA");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $giAhk = parcelRequire("giAhk");


var $hLfBz = parcelRequire("hLfBz");

var $eBF0b = parcelRequire("eBF0b");

var $6CMR1 = parcelRequire("6CMR1");

var $fr62C = parcelRequire("fr62C");

var $CDxeE = parcelRequire("CDxeE");

var $i4kSB = parcelRequire("i4kSB");

var $413NZ = parcelRequire("413NZ");

var $hN8JV = parcelRequire("hN8JV");
var $8XjRr = parcelRequire("8XjRr");

var $knOxy = parcelRequire("knOxy");
const $6e3633f6f5330cbb$export$154199a7e659306d = (initialSelectedCardTypeId, cardTypes)=>{
    if (initialSelectedCardTypeId) return initialSelectedCardTypeId;
    const filteredCardTypes = cardTypes.filter(({ isDisabled: isDisabled })=>!isDisabled);
    return filteredCardTypes.length > 0 ? filteredCardTypes[0].id : null;
};
const $6e3633f6f5330cbb$export$a662648a70e4e0d0 = (target, ref)=>target instanceof Node && ref ? !ref.contains(target) : true;
const $6e3633f6f5330cbb$export$e3399e7287b8e45d = (target, selectRef)=>target instanceof Node && selectRef?.node ? !selectRef.node.menuRef?.contains(target) && !selectRef.node.targetRef?.contains(target) : true;
class $6e3633f6f5330cbb$export$a7fed597f4b8afd8 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isMultiCreateEnabled: false,
            shouldScrollIntoView: false,
            autoFocus: true,
            saveOnBlur: false,
            numFilters: 0,
            messages: [],
            cardTypes: [],
            TypeSelect: (0, $knOxy.default),
            extraItems: undefined,
            shouldKeepFormOpenOnClickOutside: undefined,
            maxMultiCreate: 0,
            selectedCardTypeId: null,
            selectedFieldVaues: new Map(),
            appearance: (0, $3b526ddeb90a4d89$export$3789e4b2a10baa2b),
            placeholderText: '',
            initialSummary: '',
            onSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onChangeSummary: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onChangeCardType: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onChangeStatusTransition: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onChangeProject: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            setFocusOnTrigger: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            renderAdditionalInlineCreateFooter: undefined,
            shouldShowCreateButton: false,
            isEligibleInContextIssueTypesExperiment: false
        };
    }
    static getDerivedStateFromProps(props, state) {
        if ((0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1')) {
            // Checks if the selectedCardTypeId still exists in the cardTypes array and refresh the value if it isn't
            // This is used in Program board where the cardTypes are updated when the project selector value changes
            const selectedCardType = props.cardTypes.find(({ id: id, isDisabled: isDisabled })=>id === state.selectedCardTypeId && !isDisabled);
            if (!selectedCardType) return {
                ...state,
                selectedCardTypeId: $6e3633f6f5330cbb$export$154199a7e659306d(props.selectedCardTypeId, props.cardTypes)
            };
        }
        return null;
    }
    componentDidMount() {
        window.addEventListener('mouseup', this.onMouseUp);
    }
    componentWillUnmount() {
        window.removeEventListener('mouseup', this.onMouseUp);
        this.debouncedOnChangeSummary.flush();
    }
    render() {
        const { appearance: appearance, maxMultiCreate: maxMultiCreate, cardTypes: cardTypes, renderAdditionalInlineCreateFooter: renderAdditionalInlineCreateFooter } = this.props;
        const { sanitisedSummaries: sanitisedSummaries, validationError: validationError } = this.state;
        const { selectedCardTypeId: selectedCardTypeId } = this.state;
        const summariesNo = sanitisedSummaries.length;
        const isSummaryMultiline = summariesNo > 1;
        const hasRequiredFields = cardTypes.find(({ id: id })=>id === selectedCardTypeId)?.hasRequiredFields;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e3633f6f5330cbb$var$Container, {
            ref: this.form,
            appearance: appearance,
            "data-testid": "platform-inline-card-create.ui.form.container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
            isOpen: isSummaryMultiline,
            placement: "bottom-start",
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $CDxeE.default), {
                    innerRef: this.multiCreatePopupRef,
                    summariesNo: summariesNo,
                    maxMultiCreate: maxMultiCreate,
                    validationError: validationError,
                    onSubmitSingle: this.onSubmit({
                        isConcat: true,
                        createdBy: (0, $3b526ddeb90a4d89$export$3dd832bb5d8861ec)
                    }),
                    onSubmitMultiple: this.onSubmit({
                        createdBy: (0, $3b526ddeb90a4d89$export$b5288579893d806)
                    }),
                    hasRequiredFields: hasRequiredFields,
                    onClose: this.onBlur
                }),
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e3633f6f5330cbb$var$StyledForm, {
                    appearance: appearance,
                    ...triggerProps
                }, appearance === (0, $3b526ddeb90a4d89$export$3789e4b2a10baa2b) ? this.renderFullViewContent(renderAdditionalInlineCreateFooter) : this.renderCompactViewContent())
        }));
    }
    constructor(...args){
        super(...args);
        this.state = {
            validationError: (0, $8XjRr.validateSummary)(this.props.initialSummary, this.props.isMultiCreateEnabled, this.props.intl),
            selectedCardTypeId: $6e3633f6f5330cbb$export$154199a7e659306d(this.props.selectedCardTypeId, this.props.cardTypes),
            selectedTransitionId: Number(this.props.selectedFieldValues?.get((0, $413NZ.FIELD_KEY_STATUS_TRANSITIONS))) || null,
            selectedProjectId: this.props.selectedProjectId,
            sanitisedSummaries: (0, $8XjRr.splitSummary)(this.props.initialSummary)
        } // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ;
        this.onMouseUp = ({ target: target })=>{
            if (this.props.shouldKeepFormOpenOnClickOutside) return;
            if ($6e3633f6f5330cbb$export$a662648a70e4e0d0(target, this.form.current) && $6e3633f6f5330cbb$export$a662648a70e4e0d0(target, this.inlineMessagePopupRef.current) && $6e3633f6f5330cbb$export$a662648a70e4e0d0(target, this.multiCreatePopupRef.current) && $6e3633f6f5330cbb$export$e3399e7287b8e45d(target, this.typeSelect.current) && $6e3633f6f5330cbb$export$e3399e7287b8e45d(target, this.statusSelect.current) && $6e3633f6f5330cbb$export$e3399e7287b8e45d(target, this.projectSelect.current)) this.onBlur();
        };
        this.onSubmit = ({ isConcat: isConcat = false, createdBy: createdBy = (0, $3b526ddeb90a4d89$export$806b905ec7df742f) } = {})=>()=>{
                const { sanitisedSummaries: sanitisedSummaries, selectedCardTypeId: selectedCardTypeId, selectedTransitionId: selectedTransitionId, selectedProjectId: selectedProjectId } = this.state;
                if (selectedCardTypeId === null) return;
                this.debouncedOnChangeSummary.flush();
                this.submitCounter += 1;
                const metadata = {
                    createdBy: createdBy
                };
                let summaryData;
                if (isConcat) {
                    if (this.props.isMultiCreateEnabled) summaryData = [
                        sanitisedSummaries.join(' ').substr(0, (0, $3b526ddeb90a4d89$export$193356664cd84c83))
                    ];
                    else summaryData = [
                        sanitisedSummaries.join(' ')
                    ];
                } else summaryData = sanitisedSummaries;
                 // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const summaryDataTransformed = summaryData.reduce((accumulator, summary)=>{
                    if (summary.trim().length > 0) {
                        const fields = new Map();
                        fields.set((0, $413NZ.FIELD_KEY_STATUS_TRANSITIONS), selectedTransitionId);
                        accumulator.push({
                            summary: summary,
                            cardTypeId: selectedCardTypeId,
                            fields: fields,
                            projectId: selectedProjectId
                        });
                    }
                    return accumulator;
                }, []);
                if (summaryDataTransformed.length > 0) this.props.onSubmit(summaryDataTransformed, metadata);
                else this.props.onBlur('');
                this.setState({
                    validationError: (0, $hLfBz.emptyValidationError),
                    sanitisedSummaries: []
                });
            };
        this.onCancel = ()=>{
            this.debouncedOnChangeSummary.flush();
            this.props.onCancel();
            this.setState({
                validationError: (0, $hLfBz.emptyValidationError),
                sanitisedSummaries: []
            });
        };
        this.onSelectCardType = (cardTypeId)=>{
            this.props.onChangeCardType(cardTypeId);
            this.setState({
                selectedCardTypeId: cardTypeId
            });
        };
        this.onSelectProject = (projectId)=>{
            this.props.onChangeProject(projectId);
            this.setState({
                selectedProjectId: projectId
            });
        };
        this.onSelectTransition = (transitionId)=>{
            this.props.onChangeStatusTransition(transitionId);
            this.setState({
                selectedTransitionId: transitionId
            });
        };
        this.onChangeSummary = ({ summary: summary, validationError: validationError })=>{
            const { isMultiCreateEnabled: isMultiCreateEnabled } = this.props;
            this.setState((prevState)=>({
                    sanitisedSummaries: isMultiCreateEnabled ? (0, $8XjRr.splitSummary)(summary) : [
                        summary.replace('\n', ' ')
                    ],
                    validationError: {
                        ...prevState.validationError,
                        ...validationError
                    }
                }));
            this.debouncedOnChangeSummary(summary);
        };
        this.onBlur = ()=>{
            if (this.props.saveOnBlur) this.onSubmit({
                isConcat: true,
                createdBy: (0, $3b526ddeb90a4d89$export$565566e3df4dad53)
            })();
            else this.props.onBlur(this.state.sanitisedSummaries.join('\n'));
        };
        this.submitCounter = 0;
        this.initialSummary = this.props.initialSummary;
        this.form = /*#__PURE__*/ (0, $eUqFw.createRef)();
        this.typeSelect = /*#__PURE__*/ (0, $eUqFw.createRef)();
        this.statusSelect = /*#__PURE__*/ (0, $eUqFw.createRef)();
        this.projectSelect = /*#__PURE__*/ (0, $eUqFw.createRef)();
        this.inlineMessagePopupRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
        this.multiCreatePopupRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
        this.debouncedOnChangeSummary = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((summary)=>{
            this.props.onChangeSummary(summary);
        }, 250);
        this.getSelectedIssueType = ()=>{
            const { selectedCardTypeId: selectedCardTypeId } = this.state;
            const { cardTypes: cardTypes } = this.props;
            return cardTypes.find((type)=>type.id === selectedCardTypeId);
        };
        this.renderTypeDropdown = ()=>{
            const { cardTypes: cardTypes, extraItems: extraItems, TypeSelect: TypeSelect = (0, $knOxy.default), isEligibleInContextIssueTypesExperiment: isEligibleInContextIssueTypesExperiment } = this.props;
            const { selectedCardTypeId: selectedCardTypeId } = this.state;
            if (selectedCardTypeId === null) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TypeSelect, {
                ref: this.typeSelect,
                cardTypes: cardTypes,
                selectedCardTypeId: selectedCardTypeId,
                onSelectCardType: this.onSelectCardType,
                renderAdditionalOptionContent: this.props.renderAdditionalTypeSelectOptionContent,
                shouldRenderToParent: true,
                extraItems: extraItems,
                isEligibleInContextIssueTypesExperiment: isEligibleInContextIssueTypesExperiment
            });
        };
        this.renderProjectDropdown = ()=>{
            if (!(0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1')) return null;
            const { ProjectSelect: ProjectSelect = (0, $i4kSB.default), projects: projects } = this.props;
            const { selectedProjectId: selectedProjectId } = this.state;
            if ((projects?.length || 0) > 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ProjectSelect, {
                ref: this.projectSelect,
                projects: projects || [],
                selectedProjectId: selectedProjectId,
                onSelectProject: this.onSelectProject
            });
            return null;
        };
        this.renderStatusDropdown = ()=>{
            const { StatusSelect: StatusSelect = (0, $413NZ.default), statusTransitions: statusTransitions } = this.props;
            const { selectedTransitionId: selectedTransitionId } = this.state;
            if (!statusTransitions?.length) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StatusSelect, {
                ref: this.statusSelect,
                statusTransitions: statusTransitions,
                selectedTransitionId: selectedTransitionId || statusTransitions[0].transitionId,
                onSelectTransition: this.onSelectTransition
            });
        };
        this.renderSummary = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e3633f6f5330cbb$var$SummaryContainer, {
                appearance: this.props.appearance
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hN8JV.default), {
                initialSummary: this.initialSummary,
                appearance: this.props.appearance,
                submitCounter: this.submitCounter,
                placeholderText: this.props.placeholderText,
                autoFocus: this.props.autoFocus,
                shouldScrollIntoView: this.props.shouldScrollIntoView,
                onChangeSummary: this.onChangeSummary,
                onSubmit: this.onSubmit(),
                onCancel: this.onCancel,
                isMultiCreateEnabled: this.props.isMultiCreateEnabled,
                ...(0, $eI5EY.fg)('jsw_roadmaps_timeline-issue-creation-ally') ? {
                    selectedIssueType: this.getSelectedIssueType()?.name,
                    setFocusOnTrigger: this.props.setFocusOnTrigger
                } : {}
            }));
        this.buildWarnings = ()=>{
            const { intl: { formatMessage: formatMessage } } = this.props;
            const { sanitisedSummaries: sanitisedSummaries, validationError: validationError } = this.state;
            if (sanitisedSummaries.length === 1) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const validationErrors = Object.values(validationError).reduce((accumulator, errorMessage)=>{
                    if (errorMessage) accumulator.push(String(errorMessage));
                    return accumulator;
                }, []);
                return validationErrors.map((error)=>({
                        title: formatMessage((0, $fr62C.default).validationErrorTitle, {
                            validationErrorsNo: validationErrors.length
                        }),
                        description: error
                    }));
            }
            return [];
        };
        this.renderInlineMessageInfo = ()=>{
            const { numFilters: numFilters, messages: inlineMessages, intl: { formatMessage: formatMessage } } = this.props;
            const infos = inlineMessages.length > 0 ? [
                ...inlineMessages
            ] : [];
            const warnings = this.buildWarnings();
            if (numFilters) infos.push({
                title: formatMessage((0, $fr62C.default).appliedFiltersTitleNew),
                description: formatMessage((0, $fr62C.default).appliedFiltersDescription)
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6CMR1.default), {
                infos: infos,
                warnings: warnings,
                innerRef: this.inlineMessagePopupRef
            });
        };
        this.renderCreateButton = ()=>{
            const shouldShowCreateButton = this.props.shouldShowCreateButton && this.state.sanitisedSummaries.length <= 1;
            const isEmpty = this.state.sanitisedSummaries[0] ? this.state.sanitisedSummaries[0].length === 0 : true;
            return shouldShowCreateButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eBF0b.CreateButton), {
                onClick: this.onSubmit({
                    isConcat: false,
                    createdBy: (0, $3b526ddeb90a4d89$export$ba9f60edfdf2e66)
                }),
                isEmpty: isEmpty,
                hasValidationError: (0, $8XjRr.hasValidationError)(this.state.validationError)
            });
        };
        this.renderFullViewContent = (renderAdditionalInlineCreateFooter)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e3633f6f5330cbb$var$FullContent, {
                isInvalid: (0, $8XjRr.hasValidationError)(this.state.validationError)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e3633f6f5330cbb$var$Body, {
                appearance: this.props.appearance
            }, this.renderSummary()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e3633f6f5330cbb$var$FullFooter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e3633f6f5330cbb$var$FooterSection, null, this.renderTypeDropdown(), this.renderProjectDropdown(), this.renderStatusDropdown()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e3633f6f5330cbb$var$FooterSection, null, this.renderInlineMessageInfo(), " ", this.renderCreateButton())), renderAdditionalInlineCreateFooter);
        this.renderCompactViewContent = ()=>{
            const { appearance: appearance } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e3633f6f5330cbb$var$CompactContent, {
                isInvalid: (0, $8XjRr.hasValidationError)(this.state.validationError),
                appearance: appearance
            }, appearance !== (0, $3b526ddeb90a4d89$export$aca095bc476d426f) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e3633f6f5330cbb$var$Header, null, this.renderTypeDropdown(), this.renderProjectDropdown()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e3633f6f5330cbb$var$Body, {
                appearance: appearance
            }, this.renderSummary()), appearance !== (0, $3b526ddeb90a4d89$export$aca095bc476d426f) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e3633f6f5330cbb$var$CompactFooter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e3633f6f5330cbb$var$FooterSection, null, this.renderInlineMessageInfo())));
        };
    }
}
// AK icon is not vertically aligned AK-5620 so we have to hack the button
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6e3633f6f5330cbb$var$FooterSection = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _1ul9idpf _dpd31txw _1n14idpf",
            __cmplp.className
        ])
    });
});
var $6e3633f6f5330cbb$export$2e2bcd8739ae039 /* Card layout */  = (0, $giAhk.injectIntlV2)($6e3633f6f5330cbb$export$a7fed597f4b8afd8);
const $6e3633f6f5330cbb$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { appearance: appearance, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1e0c1txw _16jlkb7n _2lx21bp4 _bfhk18uv",
            __cmplp.appearance !== (0, $3b526ddeb90a4d89$export$3789e4b2a10baa2b) && "_1pby11wp",
            __cmplp.appearance === (0, $3b526ddeb90a4d89$export$3789e4b2a10baa2b) && "_19pkyh40 _2hwxidpf _otyryh40 _18u0idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6e3633f6f5330cbb$var$CompactContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isInvalid: isInvalid, appearance: appearance, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1841qrf": (0, $9t7rW.default)(__cmplp.isInvalid ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `var(--ds-border-danger, ${(0, $PdmhA).R400})` : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `var(--ds-border-focused, ${(0, $PdmhA).B200})`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1e0c1txw _2lx2vrvc _4cvr1h6o _1yt418iy _12ji1r31 _1qu2glyw _12y31o36 _16qs148r _vchhusvi _1bsb1osq _bfhkvuon _v56416gf",
            __cmplp.appearance === (0, $3b526ddeb90a4d89$export$db1cdb8627b81f84) && "_19bv7vkz",
            __cmplp.appearance === (0, $3b526ddeb90a4d89$export$db1cdb8627b81f84) && "_19bv1crf",
            __cmplp.appearance === (0, $3b526ddeb90a4d89$export$1aad44a7533f8ad8) && "_19bv1crf",
            __cmplp.appearance !== (0, $3b526ddeb90a4d89$export$db1cdb8627b81f84) && "_2rko1l7b",
            __cmplp.appearance === (0, $3b526ddeb90a4d89$export$1aad44a7533f8ad8) ? "_4t3i1osq" : "_4t3i1ylp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6e3633f6f5330cbb$var$FullContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $6e3633f6f5330cbb$var$CompactContent, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2lx21bp4 _4cvrv2br _4t3i1wug _1yt4utpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6e3633f6f5330cbb$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1y6m _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6e3633f6f5330cbb$var$Body = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { appearance: appearance, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _16jlkb7n",
            __cmplp.appearance === (0, $3b526ddeb90a4d89$export$3789e4b2a10baa2b) ? "_1bsb1osq" : "_1bsb1wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6e3633f6f5330cbb$var$Footer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1y6m",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6e3633f6f5330cbb$var$FullFooter = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $6e3633f6f5330cbb$var$Footer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _1bah1yb4 _4t3i1f4h _vwz4kb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6e3633f6f5330cbb$var$CompactFooter = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $6e3633f6f5330cbb$var$Footer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bahesu3 _18u0u2gc",
            __cmplp.className
        ])
    });
}); /* Form */ 
const $6e3633f6f5330cbb$var$StyledForm = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { appearance: appearance, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.appearance === (0, $3b526ddeb90a4d89$export$1aad44a7533f8ad8) && "_4t3izwfg",
            __cmplp.className
        ])
    });
}); /* Text area */ 
const $6e3633f6f5330cbb$var$SummaryContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { appearance: appearance, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1bahv2br _4cvr1h6o",
            __cmplp.appearance === (0, $3b526ddeb90a4d89$export$3789e4b2a10baa2b) && "_otyrftgi",
            (__cmplp.appearance === (0, $3b526ddeb90a4d89$export$db1cdb8627b81f84) || __cmplp.appearance === (0, $3b526ddeb90a4d89$export$1aad44a7533f8ad8)) && "_18u0ftgi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hLfBz", function(module, exports) {

$parcel$export(module.exports, "emptyValidationError", () => $6fcc2bb1c154380b$export$a691a8856deba80b);
const $6fcc2bb1c154380b$export$a691a8856deba80b = {
    summary: '',
    summaryConcat: ''
};

});

parcelRegister("eBF0b", function(module, exports) {

$parcel$export(module.exports, "CreateButton", () => $3265eb45619851da$export$6d3c345ce7c38fd9);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lnr0K = parcelRequire("lnr0K");

var $lEgSt = parcelRequire("lEgSt");
const $3265eb45619851da$export$6d3c345ce7c38fd9 = ({ onClick: onClick, isEmpty: isEmpty, hasValidationError: hasValidationError })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isDisabled = isEmpty || hasValidationError;
    let tooltipContent = formatMessage((0, $lnr0K.default).createButtonTooltip, {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lEgSt.default), null)
    });
    if (isEmpty) tooltipContent = formatMessage((0, $lnr0K.default).createButtonTooltipContentEmpty);
    else if (hasValidationError) tooltipContent = undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        xcss: (0, $1ZAYh.xcss)({
            marginLeft: 'space.100'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        spacing: "compact",
        type: "submit",
        isDisabled: isDisabled,
        onClick: (e)=>{
            e.preventDefault();
            onClick();
        }
    }, formatMessage((0, $lnr0K.default).createButtonLabel))));
};

});
parcelRegister("lnr0K", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ede462245e2c612$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0ede462245e2c612$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createButtonLabel: {
        "id": "inline-card-create.form.create-button.create-button-label",
        "defaultMessage": "Create"
    },
    createButtonTooltip: {
        "id": "inline-card-create.form.create-button.create-button-tooltip",
        "defaultMessage": "Create issue <icon>return icon</icon>"
    },
    createButtonTooltipContentEmpty: {
        "id": "inline-card-create.form.create-button.create-button-tooltip-content-empty",
        "defaultMessage": "Type an issue summary"
    }
});

});

parcelRegister("lEgSt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a84471a3b3707049$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $a84471a3b3707049$var$ReturnGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "16",
        height: "12",
        viewBox: "0 0 16 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "16",
        height: "12",
        rx: "2",
        fill: "var(--ds-background-accent-gray-bolder, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12.375 3.1875V4.4375C12.375 6.33597 10.836 7.875 8.9375 7.875H3.9375C3.41974 7.875 3 7.45526 3 6.9375C3 6.41974 3.41974 6 3.9375 6H8.9375C9.8005 6 10.5 5.30045 10.5 4.4375V3.1875C10.5 2.66974 10.9197 2.25 11.4375 2.25C11.9553 2.25 12.375 2.66974 12.375 3.1875Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M4.60041 7.60041L6.78787 5.41291C7.154 5.0468 7.154 4.4532 6.78787 4.08708C6.42175 3.72097 5.82825 3.72097 5.46208 4.08708L3.27458 6.27459C2.90847 6.6407 2.90847 7.2343 3.27458 7.60041C3.6407 7.96652 4.2343 7.96652 4.60041 7.60041Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M4.60041 6.27458L6.78787 8.46208C7.154 8.82825 7.154 9.42175 6.78787 9.78787C6.42175 10.154 5.82825 10.154 5.46208 9.78787L3.27458 7.60041C2.90847 7.2343 2.90847 6.6407 3.27458 6.27458C3.6407 5.90847 4.2343 5.90847 4.60041 6.27458Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }));
const $a84471a3b3707049$var$ReturnIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $a84471a3b3707049$var$ReturnGlyph,
        label: ""
    });
var $a84471a3b3707049$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($a84471a3b3707049$var$ReturnIcon);

});


parcelRegister("6CMR1", function(module, exports) {

$parcel$export(module.exports, "default", () => $be9a61335cfad11f$export$2e2bcd8739ae039);

var $1eiGU = parcelRequire("1eiGU");
var $be9a61335cfad11f$export$2e2bcd8739ae039 = (0, $1eiGU.default);

});
parcelRegister("1eiGU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d31875876f0ae78f$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $2bv8J = parcelRequire("2bv8J");

var $5YsMl = parcelRequire("5YsMl");

var $3MV1G = parcelRequire("3MV1G");

var $PdmhA = parcelRequire("PdmhA");
const $d31875876f0ae78f$var$inlineMessageContentStyles = null;
const $d31875876f0ae78f$var$messageStyles = null;
const $d31875876f0ae78f$var$OPACITY = 0.9;
const $d31875876f0ae78f$var$iconWrapperStyles = null;
const $d31875876f0ae78f$var$getColor = (type)=>{
    const types = {
        info: `var(--ds-icon-discovery, ${(0, $PdmhA).P300})`,
        warning: `var(--ds-icon-warning, ${(0, $PdmhA).Y300})`
    };
    return types[type];
};
const $d31875876f0ae78f$var$typesMapping = {
    info: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))),
        defaultLabel: 'info inline message'
    },
    warning: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))),
        defaultLabel: 'warning inline message'
    }
};
const $d31875876f0ae78f$var$InlineMessages = ({ infos: infos = [], warnings: warnings = [], innerRef: innerRef })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        const onScroll = ()=>{
            setIsOpen(false);
        };
        window.addEventListener('scroll', onScroll, true);
        return ()=>{
            window.removeEventListener('scroll', onScroll);
        };
    }, []);
    const renderMessage = (title, description, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            key: index,
            className: (0, $7JEyt.default)([
                "_1trqf705 _s6711ule _10mapxbi _vy2tpxbi _ja2sv77o _1ceh1osq _1fprhloo"
            ])
        }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, title)), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, description));
    const renderInlineMessage = (messages, type)=>{
        const { [type]: { icon: SelectedIcon, defaultLabel: defaultLabel } } = $d31875876f0ae78f$var$typesMapping;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d31875876f0ae78f$var$Wrapper, {
            "data-testid": `platform-inline-card-create.ui.form.inline-messages-${type}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
            isOpen: isOpen,
            onClose: ()=>setIsOpen(false),
            placement: "bottom-end",
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    ref: innerRef,
                    className: (0, $7JEyt.default)([
                        "_1bsbuuw1 _y3gn1e5h _1yt44ar7"
                    ])
                }, messages.map(({ title: title, description: description }, index)=>(title || description) && renderMessage(title, description, index))),
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                    ...triggerProps,
                    appearance: "subtle-link",
                    spacing: "none",
                    onClick: ()=>setIsOpen(!isOpen)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                    // eslint-disable-next-line jira/react/no-style-attribute
                    style: {
                        opacity: isOpen ? $d31875876f0ae78f$var$OPACITY : 1,
                        color: $d31875876f0ae78f$var$getColor(type)
                    },
                    className: (0, $7JEyt.default)([
                        "_16l4q80t"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SelectedIcon, {
                    label: defaultLabel,
                    size: "medium"
                })))
        }));
    };
    if (warnings.length > 0) return renderInlineMessage(warnings, 'warning');
    if (infos.length > 0) return renderInlineMessage(infos, 'info');
    return null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d31875876f0ae78f$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19bvu2gc _2hwx1i6y",
            __cmplp.className
        ])
    });
});
var $d31875876f0ae78f$export$2e2bcd8739ae039 = $d31875876f0ae78f$var$InlineMessages;

});


parcelRegister("fr62C", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ebdeb72f89a6378$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4ebdeb72f89a6378$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    appliedFiltersTitleNew: {
        "id": "inline-card-create.form.inline-messages.applied-filters-title-new",
        "defaultMessage": "Filters applied"
    },
    appliedFiltersDescription: {
        "id": "inline-card-create.form.inline-messages.applied-filters-description",
        "defaultMessage": "We'll update this issue\u2019s fields to match your current filters."
    },
    willAffectSprintScopeTitle: {
        "id": "inline-card-create.form.inline-messages.will-affect-sprint-scope-title",
        "defaultMessage": "Sprint scope will be affected"
    },
    willAffectSprintScopeDescription: {
        "id": "inline-card-create.form.inline-messages.will-affect-sprint-scope-description",
        "defaultMessage": "Creating an issue in an active sprint will affect it's scope."
    },
    validationErrorTitle: {
        "id": "inline-card-create.form.inline-messages.validation-error-title",
        "defaultMessage": "{validationErrorsNo} {validationErrorsNo, plural, one {error} other {errors}} found"
    }
});

});

parcelRegister("CDxeE", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3c223570f4b2992$export$2e2bcd8739ae039);

var $31OYS = parcelRequire("31OYS");
var $c3c223570f4b2992$export$2e2bcd8739ae039 = (0, $31OYS.default);

});
parcelRegister("31OYS", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5428b2a6bcb3645$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $bLFgh = parcelRequire("bLFgh");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $8cU5f = parcelRequire("8cU5f");

var $giAhk = parcelRequire("giAhk");

var $jMP2a = parcelRequire("jMP2a");
var $d6f6c = parcelRequire("d6f6c");

var $duQ8C = parcelRequire("duQ8C");

var $hLfBz = parcelRequire("hLfBz");

var $2MSxF = parcelRequire("2MSxF");
const $b5428b2a6bcb3645$export$3ddf2d174ce01153 = ({ hasRequiredFields: hasRequiredFields = false, summariesNo: summariesNo = 0, validationError: validationError = (0, $hLfBz.emptyValidationError), onSubmitSingle: onSubmitSingle = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onSubmitMultiple: onSubmitMultiple = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), intl: { formatMessage: formatMessage }, maxMultiCreate: maxMultiCreate = 0, onClose: onClose = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), innerRef: innerRef })=>{
    const { summary: createMultipleButtonError, summaryConcat: createSingleButtonError } = validationError;
    const onClickSingleCreate = (event, analyticsEvent)=>{
        (0, $duQ8C.default)('inline-card-create-submit', event.timeStamp);
        // @ts-expect-error Second argument should be of format "actionSubject action"
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'clickedSingleCreate', 'singleCreateButton', {
            numIssues: summariesNo
        });
        onSubmitSingle();
    };
    const onClickMultiCreate = (event, analyticsEvent)=>{
        (0, $duQ8C.default)('inline-card-create-submit', event.timeStamp);
        // @ts-expect-error Second argument should be of format "actionSubject action"
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'clickedMultiCreate', 'multiCreateButton', {
            numIssues: summariesNo
        });
        onSubmitMultiple();
    };
    const createMultipleButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "platform-inline-card-create.ui.form.multi-create-dialog.multi",
        appearance: "primary",
        isDisabled: Boolean(createMultipleButtonError),
        onClick: onClickMultiCreate
    }, formatMessage((0, $2MSxF.default).createMultiple, {
        summariesNo: summariesNo > maxMultiCreate ? maxMultiCreate : summariesNo
    }));
    const createSingleButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b5428b2a6bcb3645$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "platform-inline-card-create.ui.form.multi-create-dialog.single",
        isDisabled: Boolean(createSingleButtonError),
        onClick: onClickSingleCreate
    }, formatMessage((0, $2MSxF.default).createSingle)));
    const dialogContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b5428b2a6bcb3645$var$DialogContainer, {
        "data-testid": "platform-inline-card-create.ui.form.multi-create-dialog.container",
        ref: innerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall"
    }, formatMessage((0, $2MSxF.default).header)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b5428b2a6bcb3645$var$DialogBody, null, summariesNo >= maxMultiCreate ? formatMessage((0, $2MSxF.default).tooManyIssuesBody, {
        maxNoSummaries: maxMultiCreate
    }) : formatMessage((0, $2MSxF.default).body, {
        summariesNo: summariesNo
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, createMultipleButtonError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: createMultipleButtonError
    }, createMultipleButton) : createMultipleButton, createSingleButtonError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: createSingleButtonError
    }, createSingleButton) : createSingleButton), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireUiAnalytics), {
        eventName: "multiCreateDialog viewed"
    }));
    const dialogContainerWithRequiredFields = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b5428b2a6bcb3645$var$DialogContainer, {
        "data-testid": "platform-inline-card-create.ui.form.multi-create-dialog.container",
        ref: innerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall"
    }, formatMessage((0, $2MSxF.default).multiCreateDisabledHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b5428b2a6bcb3645$var$DialogBody, null, formatMessage((0, $2MSxF.default).multiCreateDisabledBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "platform-inline-card-create.ui.form.multi-create-dialog.cancel",
        isDisabled: Boolean(createSingleButtonError),
        onClick: onClose
    }, formatMessage((0, $2MSxF.default).cancelButton)), createSingleButtonError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: createSingleButtonError
    }, createSingleButton) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b5428b2a6bcb3645$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "platform-inline-card-create.ui.form.multi-create-dialog.single",
        isDisabled: Boolean(createSingleButtonError),
        onClick: onClickSingleCreate,
        appearance: "primary"
    }, formatMessage((0, $2MSxF.default).createSingle)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireUiAnalytics), {
        eventName: "multiCreateDialog viewed"
    }));
    return hasRequiredFields === true ? dialogContainerWithRequiredFields : dialogContainer;
};
var $b5428b2a6bcb3645$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $giAhk.injectIntlV2)($b5428b2a6bcb3645$export$3ddf2d174ce01153);
const $b5428b2a6bcb3645$var$DialogContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1178 _1yt44ar7",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b5428b2a6bcb3645$var$DialogBody = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s85uws",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b5428b2a6bcb3645$var$ButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2MSxF", function(module, exports) {

$parcel$export(module.exports, "default", () => $036170a8b45b95e1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $036170a8b45b95e1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    header: {
        "id": "inline-card-create.form.multi-create-dialog.header",
        "defaultMessage": "Want a hand with that?"
    },
    body: {
        "id": "inline-card-create.form.multi-create-dialog.body",
        "defaultMessage": "If you want, we can create an issue for every new line ({summariesNo} in total)"
    },
    tooManyIssuesBody: {
        "id": "inline-card-create.form.multi-create-dialog.too-many-issues-body",
        "defaultMessage": "If you want, we can create an issue for every new line (up to {maxNoSummaries} at a time)"
    },
    createSingle: {
        "id": "inline-card-create.form.multi-create-dialog.create-single",
        "defaultMessage": "Create one issue"
    },
    createMultiple: {
        "id": "inline-card-create.form.multi-create-dialog.create-multiple",
        "defaultMessage": "Create {summariesNo} issues"
    },
    multiCreateDisabledHeader: {
        "id": "inline-card-create.form.multi-create-dialog.multi-create-disabled-header",
        "defaultMessage": "Multiple issues can\u2019t be created"
    },
    multiCreateDisabledBody: {
        "id": "inline-card-create.form.multi-create-dialog.multi-create-disabled-body",
        "defaultMessage": "For issue types with required fields, multiple issues can\u2019t be created at once.\nSelect another issue type, or create each issue individually."
    },
    cancelButton: {
        "id": "inline-card-create.form.multi-create-dialog.cancel-button",
        "defaultMessage": "Cancel"
    }
});

});



parcelRegister("i4kSB", function(module, exports) {

$parcel$export(module.exports, "default", () => $199572d29a60bd49$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $a0i0f = parcelRequire("a0i0f");

var $iJlfe = parcelRequire("iJlfe");

var $7u4fN = parcelRequire("7u4fN");

var $86Ndv = parcelRequire("86Ndv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $jQxSL = parcelRequire("jQxSL");
var $l44HT = parcelRequire("l44HT");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");


var $38QWb = parcelRequire("38QWb");
const $199572d29a60bd49$var$ANALYTICS_SUBJECT = 'iccProjectSelect';
const $199572d29a60bd49$var$Option = ({ children: children, ...props })=>{
    const { projectInfo: projectInfo } = props.data;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($199572d29a60bd49$var$OptionWrapper, {
        "data-testId": "platform-inline-card-create.ui.form.project-select.option"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($199572d29a60bd49$var$AvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        src: projectInfo.avatar,
        size: "xsmall"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($199572d29a60bd49$var$LabelWrapper, null, projectInfo.name)));
};
const $199572d29a60bd49$var$transformOptions = (projects, selectedProjectId)=>{
    let value;
    const options = [];
    projects.forEach((project)=>{
        const option = {
            label: project.name,
            value: project.id,
            projectInfo: project
        };
        if (project.id === selectedProjectId) value = option;
        else options.push(option);
    });
    if (!value) value = null;
    return {
        options: options,
        value: value
    };
};
const $199572d29a60bd49$var$ProjectSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ projects: projects, selectedProjectId: selectedProjectId, onSelectProject: onSelectProject }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { value: value, options: options } = (0, $eUqFw.useMemo)(()=>$199572d29a60bd49$var$transformOptions(projects, selectedProjectId), [
        projects,
        selectedProjectId
    ]);
    const trigger = (0, $eUqFw.useCallback)(({ isOpen: isOpen, ...triggerProps })=>{
        const { label: label, projectInfo: projectInfo } = value || {
            label: undefined,
            projectInfo: {
                avatar: '',
                name: '',
                key: ''
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $199572d29a60bd49$var$projectContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $199572d29a60bd49$var$projectButtonWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: label ?? null,
            delay: (0, $3b526ddeb90a4d89$export$f9e3e7ede9ba929d),
            hideTooltipOnClick: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            ...triggerProps,
            appearance: "subtle",
            spacing: "none",
            isSelected: isOpen,
            "aria-label": formatMessage((0, $38QWb.default).ariaLabel, {
                value: label ?? formatMessage((0, $38QWb.default).invalid)
            }),
            testId: "platform-inline-card-create.ui.form.project-select.trigger"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($199572d29a60bd49$var$OptionWrapper, null, (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(projectInfo) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($199572d29a60bd49$var$PlaceholderWrapper, null, formatMessage((0, $38QWb.default).placeholder)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($199572d29a60bd49$var$AvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
            src: projectInfo.avatar || '',
            size: "xsmall"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($199572d29a60bd49$var$LabelWrapper, null, projectInfo.key), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
            label: ""
        })))))));
    }, [
        formatMessage,
        value
    ]);
    const onChange = (0, $eUqFw.useCallback)((option)=>{
        option && onSelectProject(option.projectInfo.id);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'dropdown changed',
            actionSubject: $199572d29a60bd49$var$ANALYTICS_SUBJECT
        }), {});
    }, [
        createAnalyticsEvent,
        onSelectProject
    ]);
    const onMenuOpen = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'dropdown opened',
            actionSubject: $199572d29a60bd49$var$ANALYTICS_SUBJECT
        }), {});
    }, [
        createAnalyticsEvent
    ]);
    const setRefNode = (0, $eUqFw.useCallback)((popupSelectRef)=>{
        ref && popupSelectRef && (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(ref, 'current.node', popupSelectRef);
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l44HT.default), {
        ref: setRefNode,
        components: {
            Option: $199572d29a60bd49$var$Option
        },
        target: trigger,
        options: options,
        value: value,
        onChange: onChange,
        onMenuOpen: onMenuOpen,
        isSearchable: false,
        searchThreshold: Number.MAX_SAFE_INTEGER,
        minMenuWidth: "auto",
        classNamePrefix: "inline-card-create-project-select",
        testId: "platform-inline-card-create.ui.form.project-select.project-select"
    });
});
const $199572d29a60bd49$var$projectContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    minWidth: '0px',
    position: 'relative'
});
const $199572d29a60bd49$var$projectButtonWrapperStyles = (0, $1ZAYh.xcss)({
    width: '100%',
    paddingLeft: 'space.100',
    paddingRight: 'space.050'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $199572d29a60bd49$var$PlaceholderWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _syaz131l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $199572d29a60bd49$var$OptionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _19bv1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $199572d29a60bd49$var$AvatarWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwx1b66 _vwz4kb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $199572d29a60bd49$var$LabelWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _1ul9idpf",
            __cmplp.className
        ])
    });
});
var $199572d29a60bd49$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($199572d29a60bd49$var$ProjectSelect);

});
parcelRegister("a0i0f", function(module, exports) {

var $buvff = parcelRequire("buvff");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $7487de7aebcafd99$var$set(object, path, value) {
    return object == null ? object : $buvff(object, path, value);
}
module.exports = $7487de7aebcafd99$var$set;

});

parcelRegister("jQxSL", function(module, exports) {

$parcel$export(module.exports, "K", () => $e72d27f6b1599862$export$3466f893ebf79586);
$parcel$export(module.exports, "E", () => $e72d27f6b1599862$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "I", () => $e72d27f6b1599862$export$9bb611d729802a56);
$parcel$export(module.exports, "L", () => $e72d27f6b1599862$export$61196ced6d74a310);
$parcel$export(module.exports, "H", () => $e72d27f6b1599862$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "J", () => $e72d27f6b1599862$export$b4171a6734a65d42);
$parcel$export(module.exports, "z", () => $e72d27f6b1599862$export$df995fae86a55f06);
$parcel$export(module.exports, "A", () => $e72d27f6b1599862$export$ebd11618f299a286);
$parcel$export(module.exports, "s", () => $e72d27f6b1599862$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "G", () => $e72d27f6b1599862$export$2329c99376c9d0a4);
$parcel$export(module.exports, "D", () => $e72d27f6b1599862$export$96f57966bedc81b4);
$parcel$export(module.exports, "C", () => $e72d27f6b1599862$export$e7094788287c5e9b);
$parcel$export(module.exports, "B", () => $e72d27f6b1599862$export$ef35774e6d314e91);
$parcel$export(module.exports, "r", () => $e72d27f6b1599862$export$43caf9889c228507);
$parcel$export(module.exports, "m", () => $e72d27f6b1599862$export$953cecd6e717a553);
$parcel$export(module.exports, "M", () => $e72d27f6b1599862$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "n", () => $e72d27f6b1599862$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "u", () => $e72d27f6b1599862$export$3b14a55fb2447963);
$parcel$export(module.exports, "k", () => $e72d27f6b1599862$export$342063e11d6c3cad);
$parcel$export(module.exports, "o", () => $e72d27f6b1599862$export$ae1af26003f05816);
$parcel$export(module.exports, "b", () => $e72d27f6b1599862$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "y", () => $e72d27f6b1599862$export$4a5767248b18ef41);
$parcel$export(module.exports, "i", () => $e72d27f6b1599862$export$23f2a1d2818174ef);
$parcel$export(module.exports, "e", () => $e72d27f6b1599862$export$f1e1789686576879);
$parcel$export(module.exports, "a", () => $e72d27f6b1599862$export$407448d2b89b1813);
$parcel$export(module.exports, "h", () => $e72d27f6b1599862$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "l", () => $e72d27f6b1599862$export$882b5998b3b9117c);
$parcel$export(module.exports, "d", () => $e72d27f6b1599862$export$4368d992c4eafac0);
$parcel$export(module.exports, "g", () => $e72d27f6b1599862$export$39b482c5e57630a8);
$parcel$export(module.exports, "f", () => $e72d27f6b1599862$export$2d1720544b23b823);
$parcel$export(module.exports, "j", () => $e72d27f6b1599862$export$35e795649ee09318);
$parcel$export(module.exports, "p", () => $e72d27f6b1599862$export$ffb5f4729a158638);
$parcel$export(module.exports, "q", () => $e72d27f6b1599862$export$9e5f44173e64f162);
$parcel$export(module.exports, "t", () => $e72d27f6b1599862$export$625550452a3fa3ec);
$parcel$export(module.exports, "v", () => $e72d27f6b1599862$export$90a7f3efeed30595);
$parcel$export(module.exports, "w", () => $e72d27f6b1599862$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "x", () => $e72d27f6b1599862$export$d141bba7fdc215a3);
$parcel$export(module.exports, "c", () => $e72d27f6b1599862$export$db3b6bfb95261072);
$parcel$export(module.exports, "F", () => $e72d27f6b1599862$export$d66501df72047452);

var $1Xn5q = parcelRequire("1Xn5q");

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $5sKOb = parcelRequire("5sKOb");

var $jqNEH = parcelRequire("jqNEH");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $5O3G9 = parcelRequire("5O3G9");

var $k286k = parcelRequire("k286k");
var $e72d27f6b1599862$var$_excluded$3 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $e72d27f6b1599862$export$3466f893ebf79586 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $e72d27f6b1599862$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $e72d27f6b1599862$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($e72d27f6b1599862$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $e72d27f6b1599862$export$9bb611d729802a56 = function cleanValue(value) {
    if ($e72d27f6b1599862$var$isArray(value)) return value.filter(Boolean);
    if ((0, $5sKOb.default)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $e72d27f6b1599862$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $bwPfh.default)(props, $e72d27f6b1599862$var$_excluded$3);
    return (0, $1Xn5q.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $e72d27f6b1599862$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $e72d27f6b1599862$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $e72d27f6b1599862$var$normalizedHeight(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $e72d27f6b1599862$var$getScrollTop(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $e72d27f6b1599862$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $e72d27f6b1599862$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $e72d27f6b1599862$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $e72d27f6b1599862$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $e72d27f6b1599862$export$3466f893ebf79586;
    var start = $e72d27f6b1599862$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $e72d27f6b1599862$var$easeOutCubic(currentTime, start, change, duration);
        $e72d27f6b1599862$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $e72d27f6b1599862$export$b4171a6734a65d42(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $e72d27f6b1599862$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $e72d27f6b1599862$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $e72d27f6b1599862$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $e72d27f6b1599862$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $e72d27f6b1599862$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $e72d27f6b1599862$var$passiveOptionAccessed = false;
var $e72d27f6b1599862$var$options = {
    get passive () {
        return $e72d27f6b1599862$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $e72d27f6b1599862$var$w = typeof window !== 'undefined' ? window : {};
if ($e72d27f6b1599862$var$w.addEventListener && $e72d27f6b1599862$var$w.removeEventListener) {
    $e72d27f6b1599862$var$w.addEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, $e72d27f6b1599862$var$options);
    $e72d27f6b1599862$var$w.removeEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, false);
}
var $e72d27f6b1599862$export$2408f22a0fab9ae5 = $e72d27f6b1599862$var$passiveOptionAccessed;
function $e72d27f6b1599862$export$2329c99376c9d0a4(item) {
    return item != null;
}
function $e72d27f6b1599862$var$isArray(arg) {
    return Array.isArray(arg);
}
function $e72d27f6b1599862$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $e72d27f6b1599862$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $e72d27f6b1599862$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $e72d27f6b1599862$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $aKcqM.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $aKcqM.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
function $e72d27f6b1599862$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $e72d27f6b1599862$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $e72d27f6b1599862$var$normalizedHeight(scrollParent);
    var scrollTop = $e72d27f6b1599862$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $e72d27f6b1599862$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $e72d27f6b1599862$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $e72d27f6b1599862$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $e72d27f6b1599862$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $1Xn5q.default)((_objectSpread2 = {
        label: 'menu'
    }, (0, $5zQU9.default)(_objectSpread2, $e72d27f6b1599862$var$alignToControl(placement), '100%'), (0, $5zQU9.default)(_objectSpread2, "position", 'absolute'), (0, $5zQU9.default)(_objectSpread2, "width", '100%'), (0, $5zQU9.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $e72d27f6b1599862$var$PortalPlacementContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
// NOTE: internal only
var $e72d27f6b1599862$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $eUqFw.useContext)($e72d27f6b1599862$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $eUqFw.useRef)(null);
    var _useState = (0, $eUqFw.useState)(maxMenuHeight), _useState2 = (0, $aKcqM.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(null), _useState4 = (0, $aKcqM.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $k286k.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $e72d27f6b1599862$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
            placement: placement || $e72d27f6b1599862$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $e72d27f6b1599862$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu List
// ==============================
var $e72d27f6b1599862$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $e72d27f6b1599862$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $e72d27f6b1599862$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $1Xn5q.default)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $e72d27f6b1599862$export$3b14a55fb2447963 = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$export$342063e11d6c3cad = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$var$NoOptionsMessage = function NoOptionsMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$NoOptionsMessage.defaultProps = {
    children: 'No options'
};
var $e72d27f6b1599862$var$LoadingMessage = function LoadingMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$LoadingMessage.defaultProps = {
    children: 'Loading...'
};
// ==============================
// Menu Portal
// ==============================
var $e72d27f6b1599862$export$ae1af26003f05816 = function menuPortalCSS(_ref6) {
    var rect = _ref6.rect, offset = _ref6.offset, position = _ref6.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $e72d27f6b1599862$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $eUqFw.useRef)(null);
    var cleanupRef = (0, $eUqFw.useRef)(null);
    var _useState5 = (0, $eUqFw.useState)($e72d27f6b1599862$var$coercePlacement(menuPlacement)), _useState6 = (0, $aKcqM.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $eUqFw.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $eUqFw.useState)(null), _useState8 = (0, $aKcqM.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $eUqFw.useCallback)(function() {
        if (!controlElement) return;
        var rect = $e72d27f6b1599862$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $k286k.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $eUqFw.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $5O3G9.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $k286k.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $eUqFw.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: setMenuPortalElement
    }, $e72d27f6b1599862$var$getStyleProps((0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $lEfVV.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $e72d27f6b1599862$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $e72d27f6b1599862$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $e72d27f6b1599862$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $e72d27f6b1599862$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $e72d27f6b1599862$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $e72d27f6b1599862$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_templateObject;
var $e72d27f6b1599862$var$_excluded$2 = [
    "size"
];
function $e72d27f6b1599862$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $e72d27f6b1599862$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $e72d27f6b1599862$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $bwPfh.default)(_ref, $e72d27f6b1599862$var$_excluded$2);
    return (0, $byn9U.jsx)("svg", (0, $kU09D.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $e72d27f6b1599862$var$_ref2
    }, props));
};
var $e72d27f6b1599862$var$CrossIcon = function CrossIcon(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $e72d27f6b1599862$var$DownChevron = function DownChevron(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $e72d27f6b1599862$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $e72d27f6b1599862$export$f1e1789686576879 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$DownChevron, null));
};
var $e72d27f6b1599862$export$407448d2b89b1813 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $e72d27f6b1599862$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({}, innerProps, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $e72d27f6b1599862$var$loadingDotAnimations = (0, $byn9U.keyframes)($e72d27f6b1599862$var$_templateObject || ($e72d27f6b1599862$var$_templateObject = (0, $jqNEH.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $e72d27f6b1599862$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $byn9U.jsx)("span", {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            animation: "".concat($e72d27f6b1599862$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $e72d27f6b1599862$var$LoadingIndicator = function LoadingIndicator(props) {
    var innerProps = props.innerProps, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
$e72d27f6b1599862$var$LoadingIndicator.defaultProps = {
    size: 4
};
var $e72d27f6b1599862$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $e72d27f6b1599862$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: innerRef
    }, $e72d27f6b1599862$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_excluded$1 = [
    "data"
];
var $e72d27f6b1599862$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $e72d27f6b1599862$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $byn9U.jsx)(Heading, (0, $kU09D.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $byn9U.jsx)("div", null, children));
};
var $e72d27f6b1599862$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $e72d27f6b1599862$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded$1);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $e72d27f6b1599862$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $e72d27f6b1599862$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $e72d27f6b1599862$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $e72d27f6b1599862$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $e72d27f6b1599862$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $1Xn5q.default)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $e72d27f6b1599862$var$spacingStyle)
};
var $e72d27f6b1599862$var$inputStyle = function inputStyle(isHidden) {
    return (0, $1Xn5q.default)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $e72d27f6b1599862$var$spacingStyle);
};
var $e72d27f6b1599862$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $e72d27f6b1599862$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $e72d27f6b1599862$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $1Xn5q.default)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $e72d27f6b1599862$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $e72d27f6b1599862$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $byn9U.jsx)("div", innerProps, children);
};
var $e72d27f6b1599862$var$MultiValueContainer = $e72d27f6b1599862$var$MultiValueGeneric;
var $e72d27f6b1599862$var$MultiValueLabel = $e72d27f6b1599862$var$MultiValueGeneric;
function $e72d27f6b1599862$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        role: "button"
    }, innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, {
        size: 14
    }));
}
var $e72d27f6b1599862$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $byn9U.jsx)(Container, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $byn9U.jsx)(Label, {
        data: data,
        innerProps: (0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $byn9U.jsx)(Remove, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $e72d27f6b1599862$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $e72d27f6b1599862$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $e72d27f6b1599862$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $e72d27f6b1599862$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $e72d27f6b1599862$export$db3b6bfb95261072 = {
    ClearIndicator: $e72d27f6b1599862$var$ClearIndicator,
    Control: $e72d27f6b1599862$var$Control,
    DropdownIndicator: $e72d27f6b1599862$var$DropdownIndicator,
    DownChevron: $e72d27f6b1599862$var$DownChevron,
    CrossIcon: $e72d27f6b1599862$var$CrossIcon,
    Group: $e72d27f6b1599862$var$Group,
    GroupHeading: $e72d27f6b1599862$var$GroupHeading,
    IndicatorsContainer: $e72d27f6b1599862$var$IndicatorsContainer,
    IndicatorSeparator: $e72d27f6b1599862$var$IndicatorSeparator,
    Input: $e72d27f6b1599862$var$Input,
    LoadingIndicator: $e72d27f6b1599862$var$LoadingIndicator,
    Menu: $e72d27f6b1599862$var$Menu,
    MenuList: $e72d27f6b1599862$var$MenuList,
    MenuPortal: $e72d27f6b1599862$var$MenuPortal,
    LoadingMessage: $e72d27f6b1599862$var$LoadingMessage,
    NoOptionsMessage: $e72d27f6b1599862$var$NoOptionsMessage,
    MultiValue: $e72d27f6b1599862$var$MultiValue,
    MultiValueContainer: $e72d27f6b1599862$var$MultiValueContainer,
    MultiValueLabel: $e72d27f6b1599862$var$MultiValueLabel,
    MultiValueRemove: $e72d27f6b1599862$var$MultiValueRemove,
    Option: $e72d27f6b1599862$var$Option,
    Placeholder: $e72d27f6b1599862$var$Placeholder,
    SelectContainer: $e72d27f6b1599862$var$SelectContainer,
    SingleValue: $e72d27f6b1599862$var$SingleValue,
    ValueContainer: $e72d27f6b1599862$var$ValueContainer
};
var $e72d27f6b1599862$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("1Xn5q", function(module, exports) {

$parcel$export(module.exports, "default", () => $16cd35a30248fb20$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
function $16cd35a30248fb20$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $16cd35a30248fb20$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $16cd35a30248fb20$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $16cd35a30248fb20$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});

parcelRegister("aKcqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d27d7cb7c770f64$export$2e2bcd8739ae039);

var $kcDiK = parcelRequire("kcDiK");

var $61Jn4 = parcelRequire("61Jn4");

var $e5SQy = parcelRequire("e5SQy");

var $gP5fl = parcelRequire("gP5fl");
function $7d27d7cb7c770f64$export$2e2bcd8739ae039(arr, i) {
    return (0, $kcDiK.default)(arr) || (0, $61Jn4.default)(arr, i) || (0, $e5SQy.default)(arr, i) || (0, $gP5fl.default)();
}

});
parcelRegister("kcDiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb536a1805ce1726$export$2e2bcd8739ae039);
function $eb536a1805ce1726$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("61Jn4", function(module, exports) {

$parcel$export(module.exports, "default", () => $463607d84fb47652$export$2e2bcd8739ae039);
function $463607d84fb47652$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("e5SQy", function(module, exports) {

$parcel$export(module.exports, "default", () => $a42c13bbb83e195c$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $a42c13bbb83e195c$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $aLrjs.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $aLrjs.default)(o, minLen);
}

});
parcelRegister("aLrjs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d637af256120630$export$2e2bcd8739ae039);
function $7d637af256120630$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("gP5fl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3f57a97be8f63bf$export$2e2bcd8739ae039);
function $c3f57a97be8f63bf$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("bwPfh", function(module, exports) {

$parcel$export(module.exports, "default", () => $864a6f28f9285041$export$2e2bcd8739ae039);

var $6XgOP = parcelRequire("6XgOP");
function $864a6f28f9285041$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $6XgOP.default)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});

parcelRegister("jqNEH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e256f68f3295e6bf$export$2e2bcd8739ae039);
function $e256f68f3295e6bf$export$2e2bcd8739ae039(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

});

parcelRegister("5O3G9", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $023d07731ce8610f$export$deee3a793edee05f);

var $7MIdi = parcelRequire("7MIdi");
function $023d07731ce8610f$var$n(t) {
    var e;
    return (null == (e = t.ownerDocument) ? void 0 : e.defaultView) || window;
}
function $023d07731ce8610f$var$o(t) {
    return $023d07731ce8610f$var$n(t).getComputedStyle(t);
}
function $023d07731ce8610f$var$i(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Node;
}
function $023d07731ce8610f$var$r(t) {
    return $023d07731ce8610f$var$i(t) ? (t.nodeName || "").toLowerCase() : "";
}
let $023d07731ce8610f$var$l;
function $023d07731ce8610f$var$c() {
    if ($023d07731ce8610f$var$l) return $023d07731ce8610f$var$l;
    const t = navigator.userAgentData;
    return t && Array.isArray(t.brands) ? ($023d07731ce8610f$var$l = t.brands.map((t)=>t.brand + "/" + t.version).join(" "), $023d07731ce8610f$var$l) : navigator.userAgent;
}
function $023d07731ce8610f$var$s(t) {
    return t instanceof $023d07731ce8610f$var$n(t).HTMLElement;
}
function $023d07731ce8610f$var$f(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Element;
}
function $023d07731ce8610f$var$u(t) {
    if ("undefined" == typeof ShadowRoot) return !1;
    return t instanceof $023d07731ce8610f$var$n(t).ShadowRoot || t instanceof ShadowRoot;
}
function $023d07731ce8610f$var$a(t) {
    const { overflow: e, overflowX: n, overflowY: i, display: r } = $023d07731ce8610f$var$o(t);
    return /auto|scroll|overlay|hidden|clip/.test(e + i + n) && ![
        "inline",
        "contents"
    ].includes(r);
}
function $023d07731ce8610f$var$d(t) {
    return [
        "table",
        "td",
        "th"
    ].includes($023d07731ce8610f$var$r(t));
}
function $023d07731ce8610f$var$h(t) {
    const e = /firefox/i.test($023d07731ce8610f$var$c()), n = $023d07731ce8610f$var$o(t), i = n.backdropFilter || n.WebkitBackdropFilter;
    return "none" !== n.transform || "none" !== n.perspective || !!i && "none" !== i || e && "filter" === n.willChange || e && !!n.filter && "none" !== n.filter || [
        "transform",
        "perspective"
    ].some((t)=>n.willChange.includes(t)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((t)=>{
        const e = n.contain;
        return null != e && e.includes(t);
    });
}
function $023d07731ce8610f$var$p() {
    return /^((?!chrome|android).)*safari/i.test($023d07731ce8610f$var$c());
}
function $023d07731ce8610f$var$g(t) {
    return [
        "html",
        "body",
        "#document"
    ].includes($023d07731ce8610f$var$r(t));
}
const $023d07731ce8610f$var$m = Math.min, $023d07731ce8610f$var$y = Math.max, $023d07731ce8610f$var$x = Math.round;
function $023d07731ce8610f$var$w(t) {
    const e = $023d07731ce8610f$var$o(t);
    let n = parseFloat(e.width), i = parseFloat(e.height);
    const r = $023d07731ce8610f$var$s(t), l = r ? t.offsetWidth : n, c = r ? t.offsetHeight : i, f = $023d07731ce8610f$var$x(n) !== l || $023d07731ce8610f$var$x(i) !== c;
    return f && (n = l, i = c), {
        width: n,
        height: i,
        fallback: f
    };
}
function $023d07731ce8610f$var$v(t) {
    return $023d07731ce8610f$var$f(t) ? t : t.contextElement;
}
const $023d07731ce8610f$var$b = {
    x: 1,
    y: 1
};
function $023d07731ce8610f$var$L(t) {
    const e = $023d07731ce8610f$var$v(t);
    if (!$023d07731ce8610f$var$s(e)) return $023d07731ce8610f$var$b;
    const n = e.getBoundingClientRect(), { width: o, height: i, fallback: r } = $023d07731ce8610f$var$w(e);
    let l = (r ? $023d07731ce8610f$var$x(n.width) : n.width) / o, c = (r ? $023d07731ce8610f$var$x(n.height) : n.height) / i;
    return l && Number.isFinite(l) || (l = 1), c && Number.isFinite(c) || (c = 1), {
        x: l,
        y: c
    };
}
function $023d07731ce8610f$var$E(e, o, i, r) {
    var l, c;
    void 0 === o && (o = !1), void 0 === i && (i = !1);
    const s = e.getBoundingClientRect(), u = $023d07731ce8610f$var$v(e);
    let a = $023d07731ce8610f$var$b;
    o && (r ? $023d07731ce8610f$var$f(r) && (a = $023d07731ce8610f$var$L(r)) : a = $023d07731ce8610f$var$L(e));
    const d = u ? $023d07731ce8610f$var$n(u) : window, h = $023d07731ce8610f$var$p() && i;
    let g = (s.left + (h && (null == (l = d.visualViewport) ? void 0 : l.offsetLeft) || 0)) / a.x, m = (s.top + (h && (null == (c = d.visualViewport) ? void 0 : c.offsetTop) || 0)) / a.y, y = s.width / a.x, x = s.height / a.y;
    if (u) {
        const t = $023d07731ce8610f$var$n(u), e = r && $023d07731ce8610f$var$f(r) ? $023d07731ce8610f$var$n(r) : r;
        let o = t.frameElement;
        for(; o && r && e !== t;){
            const t = $023d07731ce8610f$var$L(o), e = o.getBoundingClientRect(), i = getComputedStyle(o);
            e.x += (o.clientLeft + parseFloat(i.paddingLeft)) * t.x, e.y += (o.clientTop + parseFloat(i.paddingTop)) * t.y, g *= t.x, m *= t.y, y *= t.x, x *= t.y, g += e.x, m += e.y, o = $023d07731ce8610f$var$n(o).frameElement;
        }
    }
    return (0, $7MIdi.rectToClientRect)({
        width: y,
        height: x,
        x: g,
        y: m
    });
}
function $023d07731ce8610f$var$T(t) {
    return (($023d07731ce8610f$var$i(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function $023d07731ce8610f$var$R(t) {
    return $023d07731ce8610f$var$f(t) ? {
        scrollLeft: t.scrollLeft,
        scrollTop: t.scrollTop
    } : {
        scrollLeft: t.pageXOffset,
        scrollTop: t.pageYOffset
    };
}
function $023d07731ce8610f$var$C(t) {
    return $023d07731ce8610f$var$E($023d07731ce8610f$var$T(t)).left + $023d07731ce8610f$var$R(t).scrollLeft;
}
function $023d07731ce8610f$var$F(t) {
    if ("html" === $023d07731ce8610f$var$r(t)) return t;
    const e = t.assignedSlot || t.parentNode || $023d07731ce8610f$var$u(t) && t.host || $023d07731ce8610f$var$T(t);
    return $023d07731ce8610f$var$u(e) ? e.host : e;
}
function $023d07731ce8610f$var$W(t) {
    const e = $023d07731ce8610f$var$F(t);
    return $023d07731ce8610f$var$g(e) ? e.ownerDocument.body : $023d07731ce8610f$var$s(e) && $023d07731ce8610f$var$a(e) ? e : $023d07731ce8610f$var$W(e);
}
function $023d07731ce8610f$export$3b57c1601291186b(t, e) {
    var o;
    void 0 === e && (e = []);
    const i = $023d07731ce8610f$var$W(t), r = i === (null == (o = t.ownerDocument) ? void 0 : o.body), l = $023d07731ce8610f$var$n(i);
    return r ? e.concat(l, l.visualViewport || [], $023d07731ce8610f$var$a(i) ? i : []) : e.concat(i, $023d07731ce8610f$export$3b57c1601291186b(i));
}
function $023d07731ce8610f$var$S(e, i, r) {
    let l;
    if ("viewport" === i) l = function(t, e) {
        const o = $023d07731ce8610f$var$n(t), i = $023d07731ce8610f$var$T(t), r = o.visualViewport;
        let l = i.clientWidth, c = i.clientHeight, s = 0, f = 0;
        if (r) {
            l = r.width, c = r.height;
            const t = $023d07731ce8610f$var$p();
            (!t || t && "fixed" === e) && (s = r.offsetLeft, f = r.offsetTop);
        }
        return {
            width: l,
            height: c,
            x: s,
            y: f
        };
    }(e, r);
    else if ("document" === i) l = function(t) {
        const e = $023d07731ce8610f$var$T(t), n = $023d07731ce8610f$var$R(t), i = t.ownerDocument.body, r = $023d07731ce8610f$var$y(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth), l = $023d07731ce8610f$var$y(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
        let c = -n.scrollLeft + $023d07731ce8610f$var$C(t);
        const s = -n.scrollTop;
        return "rtl" === $023d07731ce8610f$var$o(i).direction && (c += $023d07731ce8610f$var$y(e.clientWidth, i.clientWidth) - r), {
            width: r,
            height: l,
            x: c,
            y: s
        };
    }($023d07731ce8610f$var$T(e));
    else if ($023d07731ce8610f$var$f(i)) l = function(t, e) {
        const n = $023d07731ce8610f$var$E(t, !0, "fixed" === e), o = n.top + t.clientTop, i = n.left + t.clientLeft, r = $023d07731ce8610f$var$s(t) ? $023d07731ce8610f$var$L(t) : {
            x: 1,
            y: 1
        };
        return {
            width: t.clientWidth * r.x,
            height: t.clientHeight * r.y,
            x: i * r.x,
            y: o * r.y
        };
    }(i, r);
    else {
        const t = {
            ...i
        };
        if ($023d07731ce8610f$var$p()) {
            var c, u;
            const o = $023d07731ce8610f$var$n(e);
            t.x -= (null == (c = o.visualViewport) ? void 0 : c.offsetLeft) || 0, t.y -= (null == (u = o.visualViewport) ? void 0 : u.offsetTop) || 0;
        }
        l = t;
    }
    return (0, $7MIdi.rectToClientRect)(l);
}
function $023d07731ce8610f$var$A(t, e) {
    return $023d07731ce8610f$var$s(t) && "fixed" !== $023d07731ce8610f$var$o(t).position ? e ? e(t) : t.offsetParent : null;
}
function $023d07731ce8610f$var$H(t, e) {
    const i = $023d07731ce8610f$var$n(t);
    if (!$023d07731ce8610f$var$s(t)) return i;
    let l = $023d07731ce8610f$var$A(t, e);
    for(; l && $023d07731ce8610f$var$d(l) && "static" === $023d07731ce8610f$var$o(l).position;)l = $023d07731ce8610f$var$A(l, e);
    return l && ("html" === $023d07731ce8610f$var$r(l) || "body" === $023d07731ce8610f$var$r(l) && "static" === $023d07731ce8610f$var$o(l).position && !$023d07731ce8610f$var$h(l)) ? i : l || function(t) {
        let e = $023d07731ce8610f$var$F(t);
        for(; $023d07731ce8610f$var$s(e) && !$023d07731ce8610f$var$g(e);){
            if ($023d07731ce8610f$var$h(e)) return e;
            e = $023d07731ce8610f$var$F(e);
        }
        return null;
    }(t) || i;
}
function $023d07731ce8610f$var$V(t, e, n) {
    const o = $023d07731ce8610f$var$s(e), i = $023d07731ce8610f$var$T(e), l = $023d07731ce8610f$var$E(t, !0, "fixed" === n, e);
    let c = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const f = {
        x: 0,
        y: 0
    };
    if (o || !o && "fixed" !== n) {
        if (("body" !== $023d07731ce8610f$var$r(e) || $023d07731ce8610f$var$a(i)) && (c = $023d07731ce8610f$var$R(e)), $023d07731ce8610f$var$s(e)) {
            const t = $023d07731ce8610f$var$E(e, !0);
            f.x = t.x + e.clientLeft, f.y = t.y + e.clientTop;
        } else i && (f.x = $023d07731ce8610f$var$C(i));
    }
    return {
        x: l.left + c.scrollLeft - f.x,
        y: l.top + c.scrollTop - f.y,
        width: l.width,
        height: l.height
    };
}
const $023d07731ce8610f$export$722a64dea1b767dc = {
    getClippingRect: function(t) {
        let { element: e, boundary: n, rootBoundary: i, strategy: l } = t;
        const c = "clippingAncestors" === n ? function(t, e) {
            const n = e.get(t);
            if (n) return n;
            let i = $023d07731ce8610f$export$3b57c1601291186b(t).filter((t)=>$023d07731ce8610f$var$f(t) && "body" !== $023d07731ce8610f$var$r(t)), l = null;
            const c = "fixed" === $023d07731ce8610f$var$o(t).position;
            let s = c ? $023d07731ce8610f$var$F(t) : t;
            for(; $023d07731ce8610f$var$f(s) && !$023d07731ce8610f$var$g(s);){
                const t = $023d07731ce8610f$var$o(s), e = $023d07731ce8610f$var$h(s);
                "fixed" === t.position ? l = null : (c ? e || l : e || "static" !== t.position || !l || ![
                    "absolute",
                    "fixed"
                ].includes(l.position)) ? l = t : i = i.filter((t)=>t !== s), s = $023d07731ce8610f$var$F(s);
            }
            return e.set(t, i), i;
        }(e, this._c) : [].concat(n), s = [
            ...c,
            i
        ], u = s[0], a = s.reduce((t, n)=>{
            const o = $023d07731ce8610f$var$S(e, n, l);
            return t.top = $023d07731ce8610f$var$y(o.top, t.top), t.right = $023d07731ce8610f$var$m(o.right, t.right), t.bottom = $023d07731ce8610f$var$m(o.bottom, t.bottom), t.left = $023d07731ce8610f$var$y(o.left, t.left), t;
        }, $023d07731ce8610f$var$S(e, u, l));
        return {
            width: a.right - a.left,
            height: a.bottom - a.top,
            x: a.left,
            y: a.top
        };
    },
    convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
        let { rect: e, offsetParent: n, strategy: o } = t;
        const i = $023d07731ce8610f$var$s(n), l = $023d07731ce8610f$var$T(n);
        if (n === l) return e;
        let c = {
            scrollLeft: 0,
            scrollTop: 0
        }, f = {
            x: 1,
            y: 1
        };
        const u = {
            x: 0,
            y: 0
        };
        if ((i || !i && "fixed" !== o) && (("body" !== $023d07731ce8610f$var$r(n) || $023d07731ce8610f$var$a(l)) && (c = $023d07731ce8610f$var$R(n)), $023d07731ce8610f$var$s(n))) {
            const t = $023d07731ce8610f$var$E(n);
            f = $023d07731ce8610f$var$L(n), u.x = t.x + n.clientLeft, u.y = t.y + n.clientTop;
        }
        return {
            width: e.width * f.x,
            height: e.height * f.y,
            x: e.x * f.x - c.scrollLeft * f.x + u.x,
            y: e.y * f.y - c.scrollTop * f.y + u.y
        };
    },
    isElement: $023d07731ce8610f$var$f,
    getDimensions: function(t) {
        return $023d07731ce8610f$var$w(t);
    },
    getOffsetParent: $023d07731ce8610f$var$H,
    getDocumentElement: $023d07731ce8610f$var$T,
    getScale: $023d07731ce8610f$var$L,
    async getElementRects (t) {
        let { reference: e, floating: n, strategy: o } = t;
        const i = this.getOffsetParent || $023d07731ce8610f$var$H, r = this.getDimensions;
        return {
            reference: $023d07731ce8610f$var$V(e, await i(n), o),
            floating: {
                x: 0,
                y: 0,
                ...await r(n)
            }
        };
    },
    getClientRects: (t)=>Array.from(t.getClientRects()),
    isRTL: (t)=>"rtl" === $023d07731ce8610f$var$o(t).direction
};
function $023d07731ce8610f$export$deee3a793edee05f(t, e, n, o) {
    void 0 === o && (o = {});
    const { ancestorScroll: i = !0, ancestorResize: r = !0, elementResize: l = !0, animationFrame: c = !1 } = o, s = i && !c, u = s || r ? [
        ...$023d07731ce8610f$var$f(t) ? $023d07731ce8610f$export$3b57c1601291186b(t) : t.contextElement ? $023d07731ce8610f$export$3b57c1601291186b(t.contextElement) : [],
        ...$023d07731ce8610f$export$3b57c1601291186b(e)
    ] : [];
    u.forEach((t)=>{
        s && t.addEventListener("scroll", n, {
            passive: !0
        }), r && t.addEventListener("resize", n);
    });
    let a, d = null;
    l && (d = new ResizeObserver(()=>{
        n();
    }), $023d07731ce8610f$var$f(t) && !c && d.observe(t), $023d07731ce8610f$var$f(t) || !t.contextElement || c || d.observe(t.contextElement), d.observe(e));
    let h = c ? $023d07731ce8610f$var$E(t) : null;
    return c && function e() {
        const o = $023d07731ce8610f$var$E(t);
        !h || o.x === h.x && o.y === h.y && o.width === h.width && o.height === h.height || n();
        h = o, a = requestAnimationFrame(e);
    }(), n(), ()=>{
        var t;
        u.forEach((t)=>{
            s && t.removeEventListener("scroll", n), r && t.removeEventListener("resize", n);
        }), null == (t = d) || t.disconnect(), d = null, c && cancelAnimationFrame(a);
    };
}
const $023d07731ce8610f$export$48a53dcb22e581d0 = (t, n, o)=>{
    const i = new Map, r = {
        platform: $023d07731ce8610f$export$722a64dea1b767dc,
        ...o
    }, l = {
        ...r.platform,
        _c: i
    };
    return (0, $7MIdi.computePosition)(t, n, {
        ...r,
        platform: l
    });
};

});
parcelRegister("7MIdi", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $4dacbd6c81f90f16$export$48a53dcb22e581d0);
$parcel$export(module.exports, "rectToClientRect", () => $4dacbd6c81f90f16$export$ee05aea0aeecbad4);
function $4dacbd6c81f90f16$var$t(t) {
    return t.split("-")[1];
}
function $4dacbd6c81f90f16$var$e(t) {
    return "y" === t ? "height" : "width";
}
function $4dacbd6c81f90f16$var$n(t) {
    return t.split("-")[0];
}
function $4dacbd6c81f90f16$var$o(t) {
    return [
        "top",
        "bottom"
    ].includes($4dacbd6c81f90f16$var$n(t)) ? "x" : "y";
}
function $4dacbd6c81f90f16$var$i(i, r, a) {
    let { reference: l, floating: s } = i;
    const c = l.x + l.width / 2 - s.width / 2, f = l.y + l.height / 2 - s.height / 2, m = $4dacbd6c81f90f16$var$o(r), u = $4dacbd6c81f90f16$var$e(m), g = l[u] / 2 - s[u] / 2, d = "x" === m;
    let p;
    switch($4dacbd6c81f90f16$var$n(r)){
        case "top":
            p = {
                x: c,
                y: l.y - s.height
            };
            break;
        case "bottom":
            p = {
                x: c,
                y: l.y + l.height
            };
            break;
        case "right":
            p = {
                x: l.x + l.width,
                y: f
            };
            break;
        case "left":
            p = {
                x: l.x - s.width,
                y: f
            };
            break;
        default:
            p = {
                x: l.x,
                y: l.y
            };
    }
    switch($4dacbd6c81f90f16$var$t(r)){
        case "start":
            p[m] -= g * (a && d ? -1 : 1);
            break;
        case "end":
            p[m] += g * (a && d ? -1 : 1);
    }
    return p;
}
const $4dacbd6c81f90f16$export$48a53dcb22e581d0 = async (t, e, n)=>{
    const { placement: o = "bottom", strategy: r = "absolute", middleware: a = [], platform: l } = n, s = a.filter(Boolean), c = await (null == l.isRTL ? void 0 : l.isRTL(e));
    let f = await l.getElementRects({
        reference: t,
        floating: e,
        strategy: r
    }), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, o, c), g = o, d = {}, p = 0;
    for(let n = 0; n < s.length; n++){
        const { name: a, fn: h } = s[n], { x: y, y: x, data: w, reset: v } = await h({
            x: m,
            y: u,
            initialPlacement: o,
            placement: g,
            strategy: r,
            middlewareData: d,
            rects: f,
            platform: l,
            elements: {
                reference: t,
                floating: e
            }
        });
        m = null != y ? y : m, u = null != x ? x : u, d = {
            ...d,
            [a]: {
                ...d[a],
                ...w
            }
        }, v && p <= 50 && (p++, "object" == typeof v && (v.placement && (g = v.placement), v.rects && (f = !0 === v.rects ? await l.getElementRects({
            reference: t,
            floating: e,
            strategy: r
        }) : v.rects), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, g, c)), n = -1);
    }
    return {
        x: m,
        y: u,
        placement: g,
        strategy: r,
        middlewareData: d
    };
};
function $4dacbd6c81f90f16$var$a(t) {
    return "number" != typeof t ? function(t) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...t
        };
    }(t) : {
        top: t,
        right: t,
        bottom: t,
        left: t
    };
}
function $4dacbd6c81f90f16$export$ee05aea0aeecbad4(t) {
    return {
        ...t,
        top: t.y,
        left: t.x,
        right: t.x + t.width,
        bottom: t.y + t.height
    };
}
async function $4dacbd6c81f90f16$export$37b6bde19b108ecc(t, e) {
    var n;
    void 0 === e && (e = {});
    const { x: o, y: i, platform: r, rects: s, elements: c, strategy: f } = t, { boundary: m = "clippingAncestors", rootBoundary: u = "viewport", elementContext: g = "floating", altBoundary: d = !1, padding: p = 0 } = e, h = $4dacbd6c81f90f16$var$a(p), y = c[d ? "floating" === g ? "reference" : "floating" : g], x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(await r.getClippingRect({
        element: null == (n = await (null == r.isElement ? void 0 : r.isElement(y))) || n ? y : y.contextElement || await (null == r.getDocumentElement ? void 0 : r.getDocumentElement(c.floating)),
        boundary: m,
        rootBoundary: u,
        strategy: f
    })), w = "floating" === g ? {
        ...s.floating,
        x: o,
        y: i
    } : s.reference, v = await (null == r.getOffsetParent ? void 0 : r.getOffsetParent(c.floating)), b = await (null == r.isElement ? void 0 : r.isElement(v)) && await (null == r.getScale ? void 0 : r.getScale(v)) || {
        x: 1,
        y: 1
    }, A = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: w,
        offsetParent: v,
        strategy: f
    }) : w);
    return {
        top: (x.top - A.top + h.top) / b.y,
        bottom: (A.bottom - x.bottom + h.bottom) / b.y,
        left: (x.left - A.left + h.left) / b.x,
        right: (A.right - x.right + h.right) / b.x
    };
}
const $4dacbd6c81f90f16$var$c = Math.min, $4dacbd6c81f90f16$var$f = Math.max;
function $4dacbd6c81f90f16$var$m(t, e, n) {
    return $4dacbd6c81f90f16$var$f(t, $4dacbd6c81f90f16$var$c(e, n));
}
const $4dacbd6c81f90f16$export$f2120bbfa5450bd2 = (n)=>({
        name: "arrow",
        options: n,
        async fn (i) {
            const { element: r, padding: l = 0 } = n || {}, { x: s, y: c, placement: f, rects: u, platform: g, elements: d } = i;
            if (null == r) return {};
            const p = $4dacbd6c81f90f16$var$a(l), h = {
                x: s,
                y: c
            }, y = $4dacbd6c81f90f16$var$o(f), x = $4dacbd6c81f90f16$var$e(y), w = await g.getDimensions(r), v = "y" === y, b = v ? "top" : "left", A = v ? "bottom" : "right", R = v ? "clientHeight" : "clientWidth", P = u.reference[x] + u.reference[y] - h[y] - u.floating[x], E = h[y] - u.reference[y], T = await (null == g.getOffsetParent ? void 0 : g.getOffsetParent(r));
            let D = T ? T[R] : 0;
            D && await (null == g.isElement ? void 0 : g.isElement(T)) || (D = d.floating[R] || u.floating[x]);
            const L = P / 2 - E / 2, k = p[b], O = D - w[x] - p[A], B = D / 2 - w[x] / 2 + L, C = $4dacbd6c81f90f16$var$m(k, B, O), H = null != $4dacbd6c81f90f16$var$t(f) && B != C && u.reference[x] / 2 - (B < k ? p[b] : p[A]) - w[x] / 2 < 0;
            return {
                [y]: h[y] - (H ? B < k ? k - B : O - B : 0),
                data: {
                    [y]: C,
                    centerOffset: B - C
                }
            };
        }
    }), $4dacbd6c81f90f16$var$g = [
    "top",
    "right",
    "bottom",
    "left"
], $4dacbd6c81f90f16$var$d = $4dacbd6c81f90f16$var$g.reduce((t, e)=>t.concat(e, e + "-start", e + "-end"), []), $4dacbd6c81f90f16$var$p = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $4dacbd6c81f90f16$var$h(t) {
    return t.replace(/left|right|bottom|top/g, (t)=>$4dacbd6c81f90f16$var$p[t]);
}
function $4dacbd6c81f90f16$var$y(n, i, r) {
    void 0 === r && (r = !1);
    const a = $4dacbd6c81f90f16$var$t(n), l = $4dacbd6c81f90f16$var$o(n), s = $4dacbd6c81f90f16$var$e(l);
    let c = "x" === l ? a === (r ? "end" : "start") ? "right" : "left" : "start" === a ? "bottom" : "top";
    return i.reference[s] > i.floating[s] && (c = $4dacbd6c81f90f16$var$h(c)), {
        main: c,
        cross: $4dacbd6c81f90f16$var$h(c)
    };
}
const $4dacbd6c81f90f16$var$x = {
    start: "end",
    end: "start"
};
function $4dacbd6c81f90f16$var$w(t) {
    return t.replace(/start|end/g, (t)=>$4dacbd6c81f90f16$var$x[t]);
}
const $4dacbd6c81f90f16$export$91fb6ecbd551914 = function(e) {
    return void 0 === e && (e = {}), {
        name: "autoPlacement",
        options: e,
        async fn (o) {
            var i, r, a;
            const { rects: l, middlewareData: c, placement: f, platform: m, elements: u } = o, { crossAxis: g = !1, alignment: p, allowedPlacements: h = $4dacbd6c81f90f16$var$d, autoAlignment: x = !0, ...v } = e, b = void 0 !== p || h === $4dacbd6c81f90f16$var$d ? function(e, o, i) {
                return (e ? [
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) === e),
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) !== e)
                ] : i.filter((t)=>$4dacbd6c81f90f16$var$n(t) === t)).filter((n)=>!e || $4dacbd6c81f90f16$var$t(n) === e || !!o && $4dacbd6c81f90f16$var$w(n) !== n);
            }(p || null, x, h) : h, A = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, v), R = (null == (i = c.autoPlacement) ? void 0 : i.index) || 0, P = b[R];
            if (null == P) return {};
            const { main: E, cross: T } = $4dacbd6c81f90f16$var$y(P, l, await (null == m.isRTL ? void 0 : m.isRTL(u.floating)));
            if (f !== P) return {
                reset: {
                    placement: b[0]
                }
            };
            const D = [
                A[$4dacbd6c81f90f16$var$n(P)],
                A[E],
                A[T]
            ], L = [
                ...(null == (r = c.autoPlacement) ? void 0 : r.overflows) || [],
                {
                    placement: P,
                    overflows: D
                }
            ], k = b[R + 1];
            if (k) return {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: k
                }
            };
            const O = L.map((e)=>{
                const n = $4dacbd6c81f90f16$var$t(e.placement);
                return [
                    e.placement,
                    n && g ? e.overflows.slice(0, 2).reduce((t, e)=>t + e, 0) : e.overflows[0],
                    e.overflows
                ];
            }).sort((t, e)=>t[1] - e[1]), B = (null == (a = O.filter((e)=>e[2].slice(0, $4dacbd6c81f90f16$var$t(e[0]) ? 2 : 3).every((t)=>t <= 0))[0]) ? void 0 : a[0]) || O[0][0];
            return B !== f ? {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: B
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$8a83211c878a3f1f = function(e) {
    return void 0 === e && (e = {}), {
        name: "flip",
        options: e,
        async fn (o) {
            var i;
            const { placement: r, middlewareData: a, rects: l, initialPlacement: c, platform: f, elements: m } = o, { mainAxis: u = !0, crossAxis: g = !0, fallbackPlacements: d, fallbackStrategy: p = "bestFit", fallbackAxisSideDirection: x = "none", flipAlignment: v = !0, ...b } = e, A = $4dacbd6c81f90f16$var$n(r), R = $4dacbd6c81f90f16$var$n(c) === c, P = await (null == f.isRTL ? void 0 : f.isRTL(m.floating)), E = d || (R || !v ? [
                $4dacbd6c81f90f16$var$h(c)
            ] : function(t) {
                const e = $4dacbd6c81f90f16$var$h(t);
                return [
                    $4dacbd6c81f90f16$var$w(t),
                    e,
                    $4dacbd6c81f90f16$var$w(e)
                ];
            }(c));
            d || "none" === x || E.push(...function(e, o, i, r) {
                const a = $4dacbd6c81f90f16$var$t(e);
                let l = function(t, e, n) {
                    const o = [
                        "left",
                        "right"
                    ], i = [
                        "right",
                        "left"
                    ], r = [
                        "top",
                        "bottom"
                    ], a = [
                        "bottom",
                        "top"
                    ];
                    switch(t){
                        case "top":
                        case "bottom":
                            return n ? e ? i : o : e ? o : i;
                        case "left":
                        case "right":
                            return e ? r : a;
                        default:
                            return [];
                    }
                }($4dacbd6c81f90f16$var$n(e), "start" === i, r);
                return a && (l = l.map((t)=>t + "-" + a), o && (l = l.concat(l.map($4dacbd6c81f90f16$var$w)))), l;
            }(c, v, x, P));
            const T = [
                c,
                ...E
            ], D = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, b), L = [];
            let k = (null == (i = a.flip) ? void 0 : i.overflows) || [];
            if (u && L.push(D[A]), g) {
                const { main: t, cross: e } = $4dacbd6c81f90f16$var$y(r, l, P);
                L.push(D[t], D[e]);
            }
            if (k = [
                ...k,
                {
                    placement: r,
                    overflows: L
                }
            ], !L.every((t)=>t <= 0)) {
                var O, B;
                const t = ((null == (O = a.flip) ? void 0 : O.index) || 0) + 1, e = T[t];
                if (e) return {
                    data: {
                        index: t,
                        overflows: k
                    },
                    reset: {
                        placement: e
                    }
                };
                let n = null == (B = k.filter((t)=>t.overflows[0] <= 0).sort((t, e)=>t.overflows[1] - e.overflows[1])[0]) ? void 0 : B.placement;
                if (!n) switch(p){
                    case "bestFit":
                        {
                            var C;
                            const t = null == (C = k.map((t)=>[
                                    t.placement,
                                    t.overflows.filter((t)=>t > 0).reduce((t, e)=>t + e, 0)
                                ]).sort((t, e)=>t[1] - e[1])[0]) ? void 0 : C[0];
                            t && (n = t);
                            break;
                        }
                    case "initialPlacement":
                        n = c;
                }
                if (r !== n) return {
                    reset: {
                        placement: n
                    }
                };
            }
            return {};
        }
    };
};
function $4dacbd6c81f90f16$var$A(t, e) {
    return {
        top: t.top - e.height,
        right: t.right - e.width,
        bottom: t.bottom - e.height,
        left: t.left - e.width
    };
}
function $4dacbd6c81f90f16$var$R(t) {
    return $4dacbd6c81f90f16$var$g.some((e)=>t[e] >= 0);
}
const $4dacbd6c81f90f16$export$fe8985bb6374093c = function(t) {
    return void 0 === t && (t = {}), {
        name: "hide",
        options: t,
        async fn (e) {
            const { strategy: n = "referenceHidden", ...o } = t, { rects: i } = e;
            switch(n){
                case "referenceHidden":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            elementContext: "reference"
                        }), i.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: t,
                                referenceHidden: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                case "escaped":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            altBoundary: !0
                        }), i.floating);
                        return {
                            data: {
                                escapedOffsets: t,
                                escaped: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $4dacbd6c81f90f16$var$E(t) {
    const e = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.left)), n = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.top));
    return {
        x: e,
        y: n,
        width: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.right)) - e,
        height: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.bottom)) - n
    };
}
const $4dacbd6c81f90f16$export$18c8ad048e32c7d5 = function(t) {
    return void 0 === t && (t = {}), {
        name: "inline",
        options: t,
        async fn (e) {
            const { placement: i, elements: r, rects: s, platform: m, strategy: u } = e, { padding: g = 2, x: d, y: p } = t, h = Array.from(await (null == m.getClientRects ? void 0 : m.getClientRects(r.reference)) || []), y = function(t) {
                const e = t.slice().sort((t, e)=>t.y - e.y), n = [];
                let o = null;
                for(let t = 0; t < e.length; t++){
                    const i = e[t];
                    !o || i.y - o.y > o.height / 2 ? n.push([
                        i
                    ]) : n[n.length - 1].push(i), o = i;
                }
                return n.map((t)=>$4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(t)));
            }(h), x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(h)), w = $4dacbd6c81f90f16$var$a(g);
            const v = await m.getElementRects({
                reference: {
                    getBoundingClientRect: function() {
                        if (2 === y.length && y[0].left > y[1].right && null != d && null != p) return y.find((t)=>d > t.left - w.left && d < t.right + w.right && p > t.top - w.top && p < t.bottom + w.bottom) || x;
                        if (y.length >= 2) {
                            if ("x" === $4dacbd6c81f90f16$var$o(i)) {
                                const t = y[0], e = y[y.length - 1], o = "top" === $4dacbd6c81f90f16$var$n(i), r = t.top, a = e.bottom, l = o ? t.left : e.left, s = o ? t.right : e.right;
                                return {
                                    top: r,
                                    bottom: a,
                                    left: l,
                                    right: s,
                                    width: s - l,
                                    height: a - r,
                                    x: l,
                                    y: r
                                };
                            }
                            const t = "left" === $4dacbd6c81f90f16$var$n(i), e = $4dacbd6c81f90f16$var$f(...y.map((t)=>t.right)), r = $4dacbd6c81f90f16$var$c(...y.map((t)=>t.left)), a = y.filter((n)=>t ? n.left === r : n.right === e), l = a[0].top, s = a[a.length - 1].bottom;
                            return {
                                top: l,
                                bottom: s,
                                left: r,
                                right: e,
                                width: e - r,
                                height: s - l,
                                x: r,
                                y: l
                            };
                        }
                        return x;
                    }
                },
                floating: r.floating,
                strategy: u
            });
            return s.reference.x !== v.reference.x || s.reference.y !== v.reference.y || s.reference.width !== v.reference.width || s.reference.height !== v.reference.height ? {
                reset: {
                    rects: v
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$cc800923e997bb8 = function(e) {
    return void 0 === e && (e = 0), {
        name: "offset",
        options: e,
        async fn (i) {
            const { x: r, y: a } = i, l = await async function(e, i) {
                const { placement: r, platform: a, elements: l } = e, s = await (null == a.isRTL ? void 0 : a.isRTL(l.floating)), c = $4dacbd6c81f90f16$var$n(r), f = $4dacbd6c81f90f16$var$t(r), m = "x" === $4dacbd6c81f90f16$var$o(r), u = [
                    "left",
                    "top"
                ].includes(c) ? -1 : 1, g = s && m ? -1 : 1, d = "function" == typeof i ? i(e) : i;
                let { mainAxis: p, crossAxis: h, alignmentAxis: y } = "number" == typeof d ? {
                    mainAxis: d,
                    crossAxis: 0,
                    alignmentAxis: null
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    alignmentAxis: null,
                    ...d
                };
                return f && "number" == typeof y && (h = "end" === f ? -1 * y : y), m ? {
                    x: h * g,
                    y: p * u
                } : {
                    x: p * u,
                    y: h * g
                };
            }(i, e);
            return {
                x: r + l.x,
                y: a + l.y,
                data: l
            };
        }
    };
};
function $4dacbd6c81f90f16$var$L(t) {
    return "x" === t ? "y" : "x";
}
const $4dacbd6c81f90f16$export$fba63a578e423eb = function(t) {
    return void 0 === t && (t = {}), {
        name: "shift",
        options: t,
        async fn (e) {
            const { x: i, y: r, placement: a } = e, { mainAxis: l = !0, crossAxis: c = !1, limiter: f = {
                fn: (t)=>{
                    let { x: e, y: n } = t;
                    return {
                        x: e,
                        y: n
                    };
                }
            }, ...u } = t, g = {
                x: i,
                y: r
            }, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, u), p = $4dacbd6c81f90f16$var$o($4dacbd6c81f90f16$var$n(a)), h = $4dacbd6c81f90f16$var$L(p);
            let y = g[p], x = g[h];
            if (l) {
                const t = "y" === p ? "bottom" : "right";
                y = $4dacbd6c81f90f16$var$m(y + d["y" === p ? "top" : "left"], y, y - d[t]);
            }
            if (c) {
                const t = "y" === h ? "bottom" : "right";
                x = $4dacbd6c81f90f16$var$m(x + d["y" === h ? "top" : "left"], x, x - d[t]);
            }
            const w = f.fn({
                ...e,
                [p]: y,
                [h]: x
            });
            return {
                ...w,
                data: {
                    x: w.x - i,
                    y: w.y - r
                }
            };
        }
    };
}, $4dacbd6c81f90f16$export$7bf07e38f3dc4b69 = function(t) {
    return void 0 === t && (t = {}), {
        options: t,
        fn (e) {
            const { x: i, y: r, placement: a, rects: l, middlewareData: s } = e, { offset: c = 0, mainAxis: f = !0, crossAxis: m = !0 } = t, u = {
                x: i,
                y: r
            }, g = $4dacbd6c81f90f16$var$o(a), d = $4dacbd6c81f90f16$var$L(g);
            let p = u[g], h = u[d];
            const y = "function" == typeof c ? c(e) : c, x = "number" == typeof y ? {
                mainAxis: y,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...y
            };
            if (f) {
                const t = "y" === g ? "height" : "width", e = l.reference[g] - l.floating[t] + x.mainAxis, n = l.reference[g] + l.reference[t] - x.mainAxis;
                p < e ? p = e : p > n && (p = n);
            }
            if (m) {
                var w, v;
                const t = "y" === g ? "width" : "height", e = [
                    "top",
                    "left"
                ].includes($4dacbd6c81f90f16$var$n(a)), o = l.reference[d] - l.floating[t] + (e && (null == (w = s.offset) ? void 0 : w[d]) || 0) + (e ? 0 : x.crossAxis), i = l.reference[d] + l.reference[t] + (e ? 0 : (null == (v = s.offset) ? void 0 : v[d]) || 0) - (e ? x.crossAxis : 0);
                h < o ? h = o : h > i && (h = i);
            }
            return {
                [g]: p,
                [d]: h
            };
        }
    };
}, $4dacbd6c81f90f16$export$346677f925de839c = function(e) {
    return void 0 === e && (e = {}), {
        name: "size",
        options: e,
        async fn (i) {
            const { placement: r, rects: a, platform: l, elements: m } = i, { apply: u = ()=>{}, ...g } = e, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(i, g), p = $4dacbd6c81f90f16$var$n(r), h = $4dacbd6c81f90f16$var$t(r), y = "x" === $4dacbd6c81f90f16$var$o(r), { width: x, height: w } = a.floating;
            let v, b;
            "top" === p || "bottom" === p ? (v = p, b = h === (await (null == l.isRTL ? void 0 : l.isRTL(m.floating)) ? "start" : "end") ? "left" : "right") : (b = p, v = "end" === h ? "top" : "bottom");
            const A = w - d[v], R = x - d[b];
            let P = A, E = R;
            if (y ? E = $4dacbd6c81f90f16$var$c(x - d.right - d.left, R) : P = $4dacbd6c81f90f16$var$c(w - d.bottom - d.top, A), !i.middlewareData.shift && !h) {
                const t = $4dacbd6c81f90f16$var$f(d.left, 0), e = $4dacbd6c81f90f16$var$f(d.right, 0), n = $4dacbd6c81f90f16$var$f(d.top, 0), o = $4dacbd6c81f90f16$var$f(d.bottom, 0);
                y ? E = x - 2 * (0 !== t || 0 !== e ? t + e : $4dacbd6c81f90f16$var$f(d.left, d.right)) : P = w - 2 * (0 !== n || 0 !== o ? n + o : $4dacbd6c81f90f16$var$f(d.top, d.bottom));
            }
            await u({
                ...i,
                availableWidth: E,
                availableHeight: P
            });
            const T = await l.getDimensions(m.floating);
            return x !== T.width || w !== T.height ? {
                reset: {
                    rects: !0
                }
            } : {};
        }
    };
};

});


parcelRegister("k286k", function(module, exports) {

$parcel$export(module.exports, "default", () => $e95a473d1e65c2a9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var $e95a473d1e65c2a9$var$index = (0, $eUqFw.useLayoutEffect);
var $e95a473d1e65c2a9$export$2e2bcd8739ae039 = $e95a473d1e65c2a9$var$index;

});


parcelRegister("l44HT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e29cbcff993ea6c5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $6Pq2D = parcelRequire("6Pq2D");

var $hOLnS = parcelRequire("hOLnS");
var $cEc3i = parcelRequire("cEc3i");

var $tkrFt = parcelRequire("tkrFt");

var $3aVBa = parcelRequire("3aVBa");
var $aV2RP = parcelRequire("aV2RP");
var $6XvxP = parcelRequire("6XvxP");

var $lbDTY = parcelRequire("lbDTY");

var $asNSH = parcelRequire("asNSH");

var $5wCDk = parcelRequire("5wCDk");

var $PdmhA = parcelRequire("PdmhA");

var $XHGTv = parcelRequire("XHGTv");

var $7ldaw = parcelRequire("7ldaw");

var $bKJfr = parcelRequire("bKJfr");

var $74BVL = parcelRequire("74BVL");
/** Are we rendering on the client or server? */ const $e29cbcff993ea6c5$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
// ==============================
// Class
// ==============================
const $e29cbcff993ea6c5$var$modifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            altAxis: true,
            altBoundary: true
        }
    }
];
const $e29cbcff993ea6c5$var$defaultPopperProps = {
    modifiers: $e29cbcff993ea6c5$var$modifiers,
    placement: 'bottom-start'
};
const $e29cbcff993ea6c5$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
class $e29cbcff993ea6c5$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            closeMenuOnSelect: true,
            components: {},
            maxMenuHeight: 300,
            maxMenuWidth: 440,
            minMenuWidth: 220,
            popperProps: {},
            isSearchable: true,
            searchThreshold: 5,
            styles: {},
            options: []
        };
    }
    static getDerivedStateFromProps(props, state) {
        const newState = {};
        // Merge consumer and default popper props
        const mergedPopperProps = {
            ...$e29cbcff993ea6c5$var$defaultPopperProps,
            ...props.popperProps
        };
        if (!(0, $asNSH.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
        // Merge consumer and default components
        const mergedComponents = {
            ...(0, $7ldaw.defaultComponents),
            ...props.components
        };
        if (!(0, $asNSH.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
        if (!$e29cbcff993ea6c5$var$isEmpty(newState)) return newState;
        return null;
    }
    componentDidMount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick = (0, $74BVL.bind)(window, {
            type: 'click',
            listener: this.handleClick,
            options: {
                capture: true
            }
        });
    }
    componentWillUnmount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick?.();
        this.unbindWindowClick = null;
        this.unbindWindowKeydown?.();
        this.unbindWindowKeydown = null;
    }
    componentDidUpdate(prevProps) {
        const { isOpen: isOpen } = this.props;
        if (prevProps.isOpen !== isOpen) {
            if (isOpen === true) this.open({
                controlOverride: true
            });
            else if (isOpen === false) this.close({
                controlOverride: true
            });
        }
    }
    render() {
        const { target: target } = this.props;
        const { isOpen: isOpen } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3aVBa.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6XvxP.Reference), null, ({ ref: ref })=>target && target({
                isOpen: isOpen,
                onKeyDown: this.handleTargetKeyDown,
                ref: this.resolveTargetRef(ref),
                'aria-haspopup': 'true',
                'aria-expanded': isOpen,
                'aria-controls': isOpen ? this.popperWrapperId : undefined
            })), this.renderSelect());
    }
    constructor(...args){
        super(...args);
        this.menuRef = null;
        this.targetRef = null;
        this.unbindWindowClick = null;
        this.unbindWindowKeydown = null;
        this.defaultStyles = (0, $cEc3i.m)((0, $bKJfr.default)(this.props.validationState || (this.props.isInvalid ? 'error' : 'default'), this.props.spacing === 'compact', 'default'), {
            groupHeading: (provided)=>({
                    ...provided,
                    color: `var(--ds-text-subtlest, ${0, $PdmhA.N80})`
                })
        });
        this.isOpenControlled = this.props.isOpen !== undefined;
        this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen;
        this.state = {
            focusLockEnabled: false,
            isOpen: this.defaultOpenState ?? false,
            mergedComponents: (0, $7ldaw.defaultComponents),
            mergedPopperProps: $e29cbcff993ea6c5$var$defaultPopperProps
        };
        this.popperWrapperId = `${(0, $tkrFt.uid)({
            options: this.props.options
        })}-popup-select`;
        // Event Handlers
        // ==============================
        this.handleTargetKeyDown = (event)=>{
            switch(event.key){
                case 'ArrowDown':
                    this.open();
                    break;
                default:
            }
        };
        this.handleKeyDown = (event)=>{
            switch(event.key){
                case 'Escape':
                case 'Esc':
                    this.close();
                    break;
                default:
            }
            if (this.props.onKeyDown) /* @ts-ignore - updating type of event React.KeyboardEvent effects the unbindWindowsKeyDown listener. Check if this can be fixed once the component gets refactor to functional */ this.props.onKeyDown(event);
        };
        this.handleClick = ({ target: target })=>{
            const { isOpen: isOpen } = this.state;
            // appease flow
            if (!(target instanceof Element)) return;
            // NOTE: Why not use the <Blanket /> component to close?
            // We don't want to interupt the user's flow. Taking this approach allows
            // user to click "through" to other elements and close the popout.
            if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
            // open on target click -- we can't trust consumers to spread the onClick
            // property to the target
            if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
        };
        this.handleSelectChange = (value, actionMeta)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
            if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
            if (onChange) onChange(value, actionMeta);
        };
        this.handleFirstPopperUpdate = ()=>{
            // When the popup opens it's focused into. Since the popup is inside a portal, it's position is
            // initially set to 0,0 - this causes the window scroll position to jump to the top. To prevent
            // this we defer enabling the focus-lock until after Popper has positioned the popup the first time.
            this.setState({
                focusLockEnabled: true
            });
        };
        // Internal Lifecycle
        // ==============================
        /**
   * Opens the popup
   *
   * @param options.controlOverride  - Force the popup to open when it's open state is being controlled
   */ this.open = (options)=>{
            const { onOpen: onOpen } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup opening if it's open state is already being controlled
            return;
            if (onOpen) onOpen();
            this.setState({
                isOpen: true
            });
            if (this.selectRef) (0, $XHGTv.getBooleanFF)('platform.design-system-team.use-default-select-in-popup-select_46rmj') ? this.selectRef.select?.openMenu('first') : this.selectRef.openMenu('first');
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown = (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: this.handleKeyDown,
                options: {
                    capture: true
                }
            });
        };
        /**
   * Closes the popup
   *
   * @param options.controlOverride  - Force the popup to close when it's open state is being controlled
   */ this.close = (options)=>{
            const { onClose: onClose } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup closing if it's open state is already being controlled
            return;
            if (onClose) onClose();
            this.setState({
                isOpen: false
            });
            this.setState({
                focusLockEnabled: false
            });
            if (this.targetRef != null) this.targetRef.focus();
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        };
        // Refs
        // ==============================
        this.resolveTargetRef = (popperRef)=>(ref)=>{
                // avoid thrashing fn calls
                if (!this.targetRef && popperRef && ref) {
                    this.targetRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }
            };
        this.resolveMenuRef = (popperRef)=>(ref)=>{
                this.menuRef = ref;
                if (typeof popperRef === 'function') popperRef(ref);
                else popperRef.current = ref;
            };
        this.getSelectRef = (ref)=>{
            this.selectRef = ref;
        };
        // Utils
        // ==============================
        // account for groups when counting options
        // this may need to be recursive, right now it just counts one level
        this.getItemCount = ()=>{
            const { options: options } = this.props;
            let count = 0;
            options.forEach((groupOrOption)=>{
                if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                else count++;
            });
            return count;
        };
        this.getMaxHeight = ()=>{
            const { maxMenuHeight: maxMenuHeight } = this.props;
            if (!this.selectRef) return maxMenuHeight;
            // subtract the control height to maintain consistency
            const showSearchControl = this.showSearchControl();
            let controlRef = (0, $XHGTv.getBooleanFF)('platform.design-system-team.use-default-select-in-popup-select_46rmj') ? this.selectRef.select?.controlRef : this.selectRef.controlRef;
            const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
            const maxHeight = maxMenuHeight - offsetHeight;
            return maxHeight;
        };
        // if the threshold is exceeded, AND isSearchable is true, then display the search control
        this.showSearchControl = ()=>{
            const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
            return isSearchable && this.getItemCount() > searchThreshold;
        };
        // Renderers
        // ==============================
        this.renderSelect = ()=>{
            const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, ...props } = this.props;
            const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
            const showSearchControl = this.showSearchControl();
            const portalDestination = $e29cbcff993ea6c5$var$canUseDOM() ? document.body : null;
            if (!portalDestination || !isOpen) return null;
            const selectComponents = {
                ...mergedComponents,
                Control: showSearchControl ? mergedComponents.Control : (0, $7ldaw.DummyControl)
            };
            const getLabel = ()=>{
                if (label) return label;
                else if (typeof placeholder === 'string') return placeholder;
            };
            const InternalSelect = (0, $XHGTv.getBooleanFF)('platform.design-system-team.use-default-select-in-popup-select_46rmj') ? (0, $5wCDk.default) : (0, $hOLnS.default);
            const popper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aV2RP.Popper), {
                ...mergedPopperProps,
                onFirstUpdate: (state)=>{
                    this.handleFirstPopperUpdate();
                    mergedPopperProps.onFirstUpdate?.(state);
                }
            }, ({ placement: placement, ref: ref, style: style })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbDTY))), {
                    innerRef: this.resolveMenuRef(ref)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ldaw.MenuDialog), {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: style,
                    "data-placement": placement,
                    minWidth: minMenuWidth,
                    maxWidth: maxMenuWidth,
                    id: this.popperWrapperId,
                    testId: testId
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Pq2D.default), {
                    disabled: !focusLockEnabled,
                    returnFocus: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(InternalSelect, {
                    "aria-label": getLabel(),
                    backspaceRemovesValue: false,
                    controlShouldRenderValue: false,
                    isClearable: false,
                    tabSelectsValue: false,
                    menuIsOpen: true,
                    placeholder: placeholder,
                    ref: this.getSelectRef,
                    ...props,
                    onMenuClose: ()=>{
                        (0, $XHGTv.getBooleanFF)('platform.design-system-team.popup-select-close_8h15h') && this.close();
                        props.onMenuClose?.();
                    },
                    isSearchable: showSearchControl,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    styles: (0, $cEc3i.m)(this.defaultStyles, props.styles || {}),
                    maxMenuHeight: this.getMaxHeight(),
                    components: selectComponents,
                    onChange: this.handleSelectChange
                }), footer))));
            return mergedPopperProps.strategy === 'fixed' ? popper : /*#__PURE__*/ (0, $lEfVV.createPortal)(popper, portalDestination);
        };
    }
}

});
parcelRegister("hOLnS", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf8bdca71ec4c4b4$export$2e2bcd8739ae039);

var $7IqRg = parcelRequire("7IqRg");

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $4WmDP = parcelRequire("4WmDP");

var $i4xqP = parcelRequire("i4xqP");

var $jQxSL = parcelRequire("jQxSL");
parcelRequire("1Xn5q");
parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");

parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");
var $cf8bdca71ec4c4b4$var$StateManagedSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $7IqRg.u)(props);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, baseSelectProps));
});
var $cf8bdca71ec4c4b4$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $eUqFw.useMemo)(function() {
        return (0, $i4xqP.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $eUqFw.createElement((0, $4WmDP.C), {
        value: emotionCache
    }, children);
};
var $cf8bdca71ec4c4b4$export$2e2bcd8739ae039 = $cf8bdca71ec4c4b4$var$StateManagedSelect;

});
parcelRegister("7IqRg", function(module, exports) {

$parcel$export(module.exports, "u", () => $59e179ee89746bd6$export$3b14a55fb2447963);

var $1Xn5q = parcelRequire("1Xn5q");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");
var $59e179ee89746bd6$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $59e179ee89746bd6$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $bwPfh.default)(_ref, $59e179ee89746bd6$var$_excluded);
    var _useState = (0, $eUqFw.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $aKcqM.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $aKcqM.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $eUqFw.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $aKcqM.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});

parcelRegister("cEc3i", function(module, exports) {

$parcel$export(module.exports, "c", () => $935291c440101c41$export$db3b6bfb95261072);
$parcel$export(module.exports, "b", () => $935291c440101c41$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "g", () => $935291c440101c41$export$39b482c5e57630a8);
$parcel$export(module.exports, "m", () => $935291c440101c41$export$953cecd6e717a553);
$parcel$export(module.exports, "S", () => $935291c440101c41$export$25ce5a424b770e84);

var $kU09D = parcelRequire("kU09D");

var $1Xn5q = parcelRequire("1Xn5q");

var $lDSrn = parcelRequire("lDSrn");

var $lIEGP = parcelRequire("lIEGP");

var $eT4IF = parcelRequire("eT4IF");

var $7Dzgl = parcelRequire("7Dzgl");

var $fVK4C = parcelRequire("fVK4C");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $5iWql = parcelRequire("5iWql");

var $bwPfh = parcelRequire("bwPfh");
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $935291c440101c41$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $935291c440101c41$var$A11yText = function A11yText(props) {
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({
        css: $935291c440101c41$var$_ref
    }, props));
};
var $935291c440101c41$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu') {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? 'selected' : 'focused').concat(disabled);
            return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $935291c440101c41$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $eUqFw.useMemo)(function() {
        return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $eUqFw.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $1Xn5q.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $eUqFw.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue
    ]);
    var ariaResults = (0, $eUqFw.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus
    ]);
    var ariaGuidance = (0, $eUqFw.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue
    ]);
    var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
    var ScreenReaderText = (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $byn9U.jsx)("span", {
        id: "aria-context"
    }, ariaContext));
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $935291c440101c41$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $935291c440101c41$var$anyDiacritic = new RegExp('[' + $935291c440101c41$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $935291c440101c41$var$diacriticToBase = {};
for(var $935291c440101c41$var$i = 0; $935291c440101c41$var$i < $935291c440101c41$var$diacritics.length; $935291c440101c41$var$i++){
    var $935291c440101c41$var$diacritic = $935291c440101c41$var$diacritics[$935291c440101c41$var$i];
    for(var $935291c440101c41$var$j = 0; $935291c440101c41$var$j < $935291c440101c41$var$diacritic.letters.length; $935291c440101c41$var$j++)$935291c440101c41$var$diacriticToBase[$935291c440101c41$var$diacritic.letters[$935291c440101c41$var$j]] = $935291c440101c41$var$diacritic.base;
}
var $935291c440101c41$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($935291c440101c41$var$anyDiacritic, function(match) {
        return $935291c440101c41$var$diacriticToBase[match];
    });
};
var $935291c440101c41$var$memoizedStripDiacriticsForInput = (0, $5iWql.default)($935291c440101c41$var$stripDiacritics);
var $935291c440101c41$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $935291c440101c41$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $935291c440101c41$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $1Xn5q.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $935291c440101c41$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $935291c440101c41$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $935291c440101c41$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $935291c440101c41$var$memoizedStripDiacriticsForInput(input);
            candidate = $935291c440101c41$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $935291c440101c41$var$_excluded = [
    "innerRef"
];
function $935291c440101c41$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $bwPfh.default)(_ref, $935291c440101c41$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $jQxSL.r)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $935291c440101c41$var$cancelScroll = function cancelScroll(event) {
    event.preventDefault();
    event.stopPropagation();
};
function $935291c440101c41$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $eUqFw.useRef)(false);
    var isTop = (0, $eUqFw.useRef)(false);
    var touchStart = (0, $eUqFw.useRef)(0);
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var handleEventDelta = (0, $eUqFw.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $935291c440101c41$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $eUqFw.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $eUqFw.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $eUqFw.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $jQxSL.s) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $935291c440101c41$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $935291c440101c41$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $935291c440101c41$var$preventTouchMove(e) {
    e.preventDefault();
}
function $935291c440101c41$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $935291c440101c41$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $935291c440101c41$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $935291c440101c41$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $935291c440101c41$var$activeScrollLocks = 0;
var $935291c440101c41$var$listenerOptions = {
    capture: false,
    passive: false
};
function $935291c440101c41$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $eUqFw.useRef)({});
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var addScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($935291c440101c41$var$LOCK_STYLES).forEach(function(key) {
                var val = $935291c440101c41$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $935291c440101c41$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $935291c440101c41$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $935291c440101c41$var$activeScrollLocks = Math.max($935291c440101c41$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $935291c440101c41$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$blurSelectInput = function blurSelectInput() {
    return document.activeElement && document.activeElement.blur();
};
var $935291c440101c41$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $935291c440101c41$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $935291c440101c41$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $935291c440101c41$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, lockEnabled && (0, $byn9U.jsx)("div", {
        onClick: $935291c440101c41$var$blurSelectInput,
        css: $935291c440101c41$var$_ref2$1
    }), children(targetRef));
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $935291c440101c41$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $byn9U.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $935291c440101c41$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $935291c440101c41$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $935291c440101c41$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $935291c440101c41$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $935291c440101c41$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $935291c440101c41$var$defaultStyles = {
    clearIndicator: (0, $jQxSL.a),
    container: (0, $jQxSL.b),
    control: (0, $jQxSL.d),
    dropdownIndicator: (0, $jQxSL.e),
    group: (0, $jQxSL.g),
    groupHeading: (0, $jQxSL.f),
    indicatorsContainer: (0, $jQxSL.i),
    indicatorSeparator: (0, $jQxSL.h),
    input: (0, $jQxSL.j),
    loadingIndicator: (0, $jQxSL.l),
    loadingMessage: (0, $jQxSL.k),
    menu: (0, $jQxSL.m),
    menuList: (0, $jQxSL.n),
    menuPortal: (0, $jQxSL.o),
    multiValue: (0, $jQxSL.p),
    multiValueLabel: (0, $jQxSL.q),
    multiValueRemove: (0, $jQxSL.t),
    noOptionsMessage: (0, $jQxSL.u),
    option: (0, $jQxSL.v),
    placeholder: (0, $jQxSL.w),
    singleValue: (0, $jQxSL.x),
    valueContainer: (0, $jQxSL.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $935291c440101c41$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $1Xn5q.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $935291c440101c41$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $935291c440101c41$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $935291c440101c41$var$baseUnit = 4;
// The minimum height of the control
var $935291c440101c41$var$controlHeight = 38;
// The amount of space between the control and menu */
var $935291c440101c41$var$menuGutter = $935291c440101c41$var$baseUnit * 2;
var $935291c440101c41$var$spacing = {
    baseUnit: $935291c440101c41$var$baseUnit,
    controlHeight: $935291c440101c41$var$controlHeight,
    menuGutter: $935291c440101c41$var$menuGutter
};
var $935291c440101c41$export$4368d992c4eafac0 = {
    borderRadius: $935291c440101c41$var$borderRadius,
    colors: $935291c440101c41$var$colors,
    spacing: $935291c440101c41$var$spacing
};
var $935291c440101c41$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $jQxSL.z)(),
    captureMenuScroll: !(0, $jQxSL.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $935291c440101c41$export$db3b6bfb95261072(),
    formatGroupLabel: $935291c440101c41$var$formatGroupLabel,
    getOptionLabel: $935291c440101c41$export$8b22cf2602fb60ce,
    getOptionValue: $935291c440101c41$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $935291c440101c41$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $jQxSL.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $935291c440101c41$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $935291c440101c41$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $935291c440101c41$var$_isOptionSelected(props, option, selectValue);
    var label = $935291c440101c41$var$getOptionLabel(props, option);
    var value = $935291c440101c41$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $935291c440101c41$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $935291c440101c41$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $935291c440101c41$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $935291c440101c41$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $935291c440101c41$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $jQxSL.G));
}
function $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $fVK4C.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $935291c440101c41$var$buildFocusableOptions(props, selectValue) {
    return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions($935291c440101c41$var$buildCategorizedOptions(props, selectValue));
}
function $935291c440101c41$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$935291c440101c41$var$shouldHideSelectedOptions(props) || !isSelected) && $935291c440101c41$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $935291c440101c41$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $935291c440101c41$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $935291c440101c41$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $935291c440101c41$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $935291c440101c41$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $935291c440101c41$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $935291c440101c41$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $935291c440101c41$var$getOptionValue(props, i) === candidate;
    });
}
function $935291c440101c41$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $935291c440101c41$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $935291c440101c41$var$instanceId = 1;
var $935291c440101c41$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $eT4IF.default)(Select, _Component);
    var _super = (0, $7Dzgl.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $lDSrn.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.instancePrefix = '';
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $jQxSL.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $jQxSL.B)([].concat((0, $fVK4C.default)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $jQxSL.C)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $jQxSL.C)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $jQxSL.D)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $jQxSL.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $935291c440101c41$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $935291c440101c41$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $935291c440101c41$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $jQxSL.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $935291c440101c41$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $1Xn5q.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
            event.stopPropagation();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            event.stopPropagation();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $jQxSL.H)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $935291c440101c41$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$935291c440101c41$var$instanceId);
        _this.state.selectValue = (0, $jQxSL.I)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusedOption = focusableOptions[optionIndex];
        }
        return _this;
    }
    (0, $lIEGP.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex]
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $935291c440101c41$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($935291c440101c41$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $935291c440101c41$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $935291c440101c41$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $935291c440101c41$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox'
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox'),
                    'aria-owns': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$DummyInput, (0, $kU09D.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $jQxSL.K),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $eUqFw.createElement(Input, (0, $kU09D.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $eUqFw.createElement(Placeholder, (0, $kU09D.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $eUqFw.createElement(MultiValue, (0, $kU09D.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $eUqFw.createElement(SingleValue, (0, $kU09D.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(ClearIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(LoadingIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $eUqFw.createElement(IndicatorSeparator, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(DropdownIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    };
                    return /*#__PURE__*/ $eUqFw.createElement(Option, (0, $kU09D.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $eUqFw.createElement(Group, (0, $kU09D.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $eUqFw.createElement((0, $jQxSL.M), (0, $kU09D.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $eUqFw.createElement(Menu, (0, $kU09D.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove,
                            id: _this4.getElementId('listbox')
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $eUqFw.createElement(MenuList, (0, $kU09D.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $eUqFw.createElement(MenuPortal, (0, $kU09D.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$RequiredInput, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $eUqFw.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $eUqFw.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $eUqFw.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$LiveRegion, (0, $kU09D.default)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $eUqFw.createElement(SelectContainer, (0, $kU09D.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $eUqFw.createElement(Control, (0, $kU09D.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $eUqFw.createElement(ValueContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $eUqFw.createElement(IndicatorsContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $jQxSL.I)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $935291c440101c41$var$buildFocusableOptions(props, selectValue) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $935291c440101c41$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $935291c440101c41$var$getNextFocusedOption(state, focusableOptions);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $jQxSL.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $eUqFw.Component));
$935291c440101c41$export$25ce5a424b770e84.defaultProps = $935291c440101c41$export$407448d2b89b1813;

});
parcelRegister("lDSrn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc177843783b087f$export$2e2bcd8739ae039);
function $fc177843783b087f$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("lIEGP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcfd452a83bb612a$export$2e2bcd8739ae039);

var $aM0Ke = parcelRequire("aM0Ke");
function $fcfd452a83bb612a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $aM0Ke.default)(descriptor.key), descriptor);
    }
}
function $fcfd452a83bb612a$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $fcfd452a83bb612a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fcfd452a83bb612a$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

});

parcelRegister("eT4IF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad69dceb97fc37d0$export$2e2bcd8739ae039);

var $c2pQl = parcelRequire("c2pQl");
function $ad69dceb97fc37d0$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $c2pQl.default)(subClass, superClass);
}

});

parcelRegister("7Dzgl", function(module, exports) {

$parcel$export(module.exports, "default", () => $58f7875a71af82f1$export$2e2bcd8739ae039);

var $i3rTN = parcelRequire("i3rTN");

var $8c5pC = parcelRequire("8c5pC");

var $4mIeV = parcelRequire("4mIeV");
function $58f7875a71af82f1$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $8c5pC.default)();
    return function _createSuperInternal() {
        var Super = (0, $i3rTN.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $i3rTN.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $4mIeV.default)(this, result);
    };
}

});
parcelRegister("i3rTN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d24e25f7bdedc6a7$export$2e2bcd8739ae039);
function $d24e25f7bdedc6a7$export$2e2bcd8739ae039(o) {
    $d24e25f7bdedc6a7$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d24e25f7bdedc6a7$export$2e2bcd8739ae039(o);
}

});

parcelRegister("8c5pC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f73a47aa7a9581c$export$2e2bcd8739ae039);
function $5f73a47aa7a9581c$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5f73a47aa7a9581c$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("4mIeV", function(module, exports) {

$parcel$export(module.exports, "default", () => $32db889076b63d40$export$2e2bcd8739ae039);

var $5sKOb = parcelRequire("5sKOb");

var $aCdHv = parcelRequire("aCdHv");
function $32db889076b63d40$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $5sKOb.default)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $aCdHv.default)(self);
}

});


parcelRegister("fVK4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $b98feb1d5dd86921$export$2e2bcd8739ae039);

var $b7OIr = parcelRequire("b7OIr");

var $2B3l3 = parcelRequire("2B3l3");

var $e5SQy = parcelRequire("e5SQy");

var $csAMF = parcelRequire("csAMF");
function $b98feb1d5dd86921$export$2e2bcd8739ae039(arr) {
    return (0, $b7OIr.default)(arr) || (0, $2B3l3.default)(arr) || (0, $e5SQy.default)(arr) || (0, $csAMF.default)();
}

});
parcelRegister("b7OIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $8197b040df4187a0$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $8197b040df4187a0$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $aLrjs.default)(arr);
}

});

parcelRegister("2B3l3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e41a0710a3b4a62$export$2e2bcd8739ae039);
function $1e41a0710a3b4a62$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("csAMF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9124a21752235a23$export$2e2bcd8739ae039);
function $9124a21752235a23$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});




parcelRegister("3aVBa", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $24fefc1eb423cf0c$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $24fefc1eb423cf0c$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $24fefc1eb423cf0c$export$d0d38e7dec7a1a61);

var $eUqFw = parcelRequire("eUqFw");
var $24fefc1eb423cf0c$export$3dbd3405086fec7b = $eUqFw.createContext();
var $24fefc1eb423cf0c$export$cbabb21c2529b130 = $eUqFw.createContext();
function $24fefc1eb423cf0c$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $eUqFw.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $eUqFw.useRef(false);
    $eUqFw.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $eUqFw.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $eUqFw.createElement($24fefc1eb423cf0c$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $eUqFw.createElement($24fefc1eb423cf0c$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("aV2RP", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $7f317398a3c1e136$export$badac9ada3a0bdf9);

var $eUqFw = parcelRequire("eUqFw");

var $3aVBa = parcelRequire("3aVBa");

var $4J8wt = parcelRequire("4J8wt");

var $fATwl = parcelRequire("fATwl");
var $7f317398a3c1e136$var$NOOP = function NOOP() {
    return void 0;
};
var $7f317398a3c1e136$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $7f317398a3c1e136$var$EMPTY_MODIFIERS = [];
function $7f317398a3c1e136$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $7f317398a3c1e136$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $eUqFw.useContext((0, $3aVBa.ManagerReferenceNodeContext));
    var _React$useState = $eUqFw.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $eUqFw.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $eUqFw.useEffect(function() {
        (0, $4J8wt.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $eUqFw.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $fATwl.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $eUqFw.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $7f317398a3c1e136$var$NOOP,
            update: update || $7f317398a3c1e136$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $4J8wt.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("4J8wt", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", () => $3711f9d89c6c0713$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $3711f9d89c6c0713$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $3711f9d89c6c0713$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $3711f9d89c6c0713$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $3711f9d89c6c0713$export$700979bc83e7db82);

var $eUqFw = parcelRequire("eUqFw");
var $3711f9d89c6c0713$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $3711f9d89c6c0713$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $3711f9d89c6c0713$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $3711f9d89c6c0713$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $3711f9d89c6c0713$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $3711f9d89c6c0713$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $eUqFw.useLayoutEffect : $eUqFw.useEffect;

});

parcelRegister("fATwl", function(module, exports) {

$parcel$export(module.exports, "usePopper", () => $b5a5490e72f59dbf$export$f4d5bf230a36dd6e);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $1sNnY = parcelRequire("1sNnY");

var $an8Qp = parcelRequire("an8Qp");

var $4J8wt = parcelRequire("4J8wt");
var $b5a5490e72f59dbf$var$EMPTY_MODIFIERS = [];
var $b5a5490e72f59dbf$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $eUqFw.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $b5a5490e72f59dbf$var$EMPTY_MODIFIERS
    };
    var _React$useState = $eUqFw.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $eUqFw.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $lEfVV.flushSync(function() {
                    setState({
                        styles: (0, $4J8wt.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $4J8wt.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $eUqFw.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($an8Qp)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $eUqFw.useRef();
    (0, $4J8wt.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $4J8wt.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $1sNnY.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("1sNnY", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $110eb6f1d5d14a7b$export$8f7491d57c8f97a9);

var $6dO3d = parcelRequire("6dO3d");

var $hKNVt = parcelRequire("hKNVt");

var $1hjVu = parcelRequire("1hjVu");

var $1T37S = parcelRequire("1T37S");

var $gbbnc = parcelRequire("gbbnc");

var $bX36N = parcelRequire("bX36N");

var $9chVh = parcelRequire("9chVh");

var $e0gkO = parcelRequire("e0gkO");

var $RxAbB = parcelRequire("RxAbB");

var $4Jkbd = parcelRequire("4Jkbd");


var $110eb6f1d5d14a7b$export$d34966752335dd47 = [
    (0, $hKNVt.default),
    (0, $1hjVu.default),
    (0, $1T37S.default),
    (0, $gbbnc.default),
    (0, $bX36N.default),
    (0, $9chVh.default),
    (0, $e0gkO.default),
    (0, $RxAbB.default),
    (0, $4Jkbd.default)
];
var $110eb6f1d5d14a7b$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $6dO3d.popperGenerator)({
    defaultModifiers: $110eb6f1d5d14a7b$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("6dO3d", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $487ac80c4f86ec1e$export$ed5e13716264f202);

var $gka9g = parcelRequire("gka9g");

var $3F4KV = parcelRequire("3F4KV");

var $edd0p = parcelRequire("edd0p");

var $1Z5jy = parcelRequire("1Z5jy");

var $UiAmo = parcelRequire("UiAmo");

var $4YkF9 = parcelRequire("4YkF9");

var $aCxpo = parcelRequire("aCxpo");


var $jxz5k = parcelRequire("jxz5k");
var $487ac80c4f86ec1e$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $487ac80c4f86ec1e$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $487ac80c4f86ec1e$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $487ac80c4f86ec1e$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $487ac80c4f86ec1e$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $jxz5k.isElement)(reference) ? (0, $edd0p.default)(reference) : reference.contextElement ? (0, $edd0p.default)(reference.contextElement) : [],
                    popper: (0, $edd0p.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $UiAmo.default)((0, $aCxpo.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$487ac80c4f86ec1e$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $gka9g.default)(reference, (0, $1Z5jy.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $3F4KV.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $4YkF9.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$487ac80c4f86ec1e$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $487ac80c4f86ec1e$export$8f7491d57c8f97a9 = /*#__PURE__*/ $487ac80c4f86ec1e$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("gka9g", function(module, exports) {

$parcel$export(module.exports, "default", () => $be2662d6eb9e3a4a$export$2e2bcd8739ae039);

var $gQlmL = parcelRequire("gQlmL");

var $3Q5Qy = parcelRequire("3Q5Qy");

var $3Ih4r = parcelRequire("3Ih4r");

var $jxz5k = parcelRequire("jxz5k");

var $gIy3I = parcelRequire("gIy3I");

var $9ce0D = parcelRequire("9ce0D");

var $lp2b7 = parcelRequire("lp2b7");

var $3Gelu = parcelRequire("3Gelu");
function $be2662d6eb9e3a4a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3Gelu.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3Gelu.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $be2662d6eb9e3a4a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $jxz5k.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $jxz5k.isHTMLElement)(offsetParent) && $be2662d6eb9e3a4a$var$isElementScaled(offsetParent);
    var documentElement = (0, $9ce0D.default)(offsetParent);
    var rect = (0, $gQlmL.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $3Ih4r.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $lp2b7.default)(documentElement)) scroll = (0, $3Q5Qy.default)(offsetParent);
        if ((0, $jxz5k.isHTMLElement)(offsetParent)) {
            offsets = (0, $gQlmL.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $gIy3I.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("gQlmL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c432138ece0d4fa8$export$2e2bcd8739ae039);

var $jxz5k = parcelRequire("jxz5k");

var $3Gelu = parcelRequire("3Gelu");

var $eNjCb = parcelRequire("eNjCb");

var $2QPpT = parcelRequire("2QPpT");
function $c432138ece0d4fa8$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $jxz5k.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3Gelu.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3Gelu.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $jxz5k.isElement)(element) ? (0, $eNjCb.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $2QPpT.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("jxz5k", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $e39c508a61a40243$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $e39c508a61a40243$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $e39c508a61a40243$export$af51f0f06c0f328a);

var $eNjCb = parcelRequire("eNjCb");
function $e39c508a61a40243$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $eNjCb.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $e39c508a61a40243$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $eNjCb.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $e39c508a61a40243$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $eNjCb.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("eNjCb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac54db6104c61765$export$2e2bcd8739ae039);
function $ac54db6104c61765$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("3Gelu", function(module, exports) {

$parcel$export(module.exports, "max", () => $2ae06c1a24639922$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $2ae06c1a24639922$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $2ae06c1a24639922$export$2077e0241d6afd3c);
var $2ae06c1a24639922$export$8960430cfd85939f = Math.max;
var $2ae06c1a24639922$export$96ec731ed4dcb222 = Math.min;
var $2ae06c1a24639922$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("2QPpT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2138525ae724b403$export$2e2bcd8739ae039);

var $j87Uw = parcelRequire("j87Uw");
function $2138525ae724b403$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $j87Uw.default)());
}

});
parcelRegister("j87Uw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ded4e693f114a81c$export$2e2bcd8739ae039);
function $ded4e693f114a81c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("3Q5Qy", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cbac36da0487101$export$2e2bcd8739ae039);

var $hRE8q = parcelRequire("hRE8q");

var $eNjCb = parcelRequire("eNjCb");

var $jxz5k = parcelRequire("jxz5k");

var $4K3DC = parcelRequire("4K3DC");
function $2cbac36da0487101$export$2e2bcd8739ae039(node) {
    if (node === (0, $eNjCb.default)(node) || !(0, $jxz5k.isHTMLElement)(node)) return (0, $hRE8q.default)(node);
    else return (0, $4K3DC.default)(node);
}

});
parcelRegister("hRE8q", function(module, exports) {

$parcel$export(module.exports, "default", () => $d01684e258e44be2$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");
function $d01684e258e44be2$export$2e2bcd8739ae039(node) {
    var win = (0, $eNjCb.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("4K3DC", function(module, exports) {

$parcel$export(module.exports, "default", () => $373e47b99d05f3c9$export$2e2bcd8739ae039);
function $373e47b99d05f3c9$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("3Ih4r", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b42b9085e0eb740$export$2e2bcd8739ae039);
function $2b42b9085e0eb740$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("gIy3I", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2bb2ccf0fe2e3c3$export$2e2bcd8739ae039);

var $gQlmL = parcelRequire("gQlmL");

var $9ce0D = parcelRequire("9ce0D");

var $hRE8q = parcelRequire("hRE8q");
function $c2bb2ccf0fe2e3c3$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $gQlmL.default)((0, $9ce0D.default)(element)).left + (0, $hRE8q.default)(element).scrollLeft;
}

});
parcelRegister("9ce0D", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b2019f883903c78$export$2e2bcd8739ae039);

var $jxz5k = parcelRequire("jxz5k");
function $6b2019f883903c78$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $jxz5k.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("lp2b7", function(module, exports) {

$parcel$export(module.exports, "default", () => $f94d9f5c84260b26$export$2e2bcd8739ae039);

var $itp1E = parcelRequire("itp1E");
function $f94d9f5c84260b26$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $itp1E.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("itp1E", function(module, exports) {

$parcel$export(module.exports, "default", () => $d72e58fb356d483c$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");
function $d72e58fb356d483c$export$2e2bcd8739ae039(element) {
    return (0, $eNjCb.default)(element).getComputedStyle(element);
}

});



parcelRegister("3F4KV", function(module, exports) {

$parcel$export(module.exports, "default", () => $2aa8e3d950b93051$export$2e2bcd8739ae039);

var $gQlmL = parcelRequire("gQlmL");
function $2aa8e3d950b93051$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $gQlmL.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("edd0p", function(module, exports) {

$parcel$export(module.exports, "default", () => $a58c5e38958f7507$export$2e2bcd8739ae039);

var $hfADZ = parcelRequire("hfADZ");

var $6P0Dy = parcelRequire("6P0Dy");

var $eNjCb = parcelRequire("eNjCb");

var $lp2b7 = parcelRequire("lp2b7");
function $a58c5e38958f7507$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $hfADZ.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $eNjCb.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $lp2b7.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($a58c5e38958f7507$export$2e2bcd8739ae039((0, $6P0Dy.default)(target)));
}

});
parcelRegister("hfADZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8f043198ffd7cdf$export$2e2bcd8739ae039);

var $6P0Dy = parcelRequire("6P0Dy");

var $lp2b7 = parcelRequire("lp2b7");

var $3Ih4r = parcelRequire("3Ih4r");

var $jxz5k = parcelRequire("jxz5k");
function $c8f043198ffd7cdf$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $3Ih4r.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $jxz5k.isHTMLElement)(node) && (0, $lp2b7.default)(node)) return node;
    return $c8f043198ffd7cdf$export$2e2bcd8739ae039((0, $6P0Dy.default)(node));
}

});
parcelRegister("6P0Dy", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f780000a33023fc$export$2e2bcd8739ae039);

var $3Ih4r = parcelRequire("3Ih4r");

var $9ce0D = parcelRequire("9ce0D");

var $jxz5k = parcelRequire("jxz5k");
function $4f780000a33023fc$export$2e2bcd8739ae039(element) {
    if ((0, $3Ih4r.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $jxz5k.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $9ce0D.default)(element) // fallback
    );
}

});



parcelRegister("1Z5jy", function(module, exports) {

$parcel$export(module.exports, "default", () => $171f9c4bd8752ce1$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");

var $3Ih4r = parcelRequire("3Ih4r");

var $itp1E = parcelRequire("itp1E");

var $jxz5k = parcelRequire("jxz5k");

var $cPuw6 = parcelRequire("cPuw6");

var $6P0Dy = parcelRequire("6P0Dy");

var $j87Uw = parcelRequire("j87Uw");
function $171f9c4bd8752ce1$var$getTrueOffsetParent(element) {
    if (!(0, $jxz5k.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $itp1E.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $171f9c4bd8752ce1$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $j87Uw.default)());
    var isIE = /Trident/i.test((0, $j87Uw.default)());
    if (isIE && (0, $jxz5k.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $itp1E.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $6P0Dy.default)(element);
    if ((0, $jxz5k.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $jxz5k.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $3Ih4r.default)(currentNode)) < 0){
        var css = (0, $itp1E.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $171f9c4bd8752ce1$export$2e2bcd8739ae039(element) {
    var window = (0, $eNjCb.default)(element);
    var offsetParent = $171f9c4bd8752ce1$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $cPuw6.default)(offsetParent) && (0, $itp1E.default)(offsetParent).position === 'static')offsetParent = $171f9c4bd8752ce1$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $3Ih4r.default)(offsetParent) === 'html' || (0, $3Ih4r.default)(offsetParent) === 'body' && (0, $itp1E.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $171f9c4bd8752ce1$var$getContainingBlock(element) || window;
}

});
parcelRegister("cPuw6", function(module, exports) {

$parcel$export(module.exports, "default", () => $9571eb7890da3be6$export$2e2bcd8739ae039);

var $3Ih4r = parcelRequire("3Ih4r");
function $9571eb7890da3be6$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $3Ih4r.default)(element)) >= 0;
}

});


parcelRegister("UiAmo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a93a5c300cea5e9$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");
function $0a93a5c300cea5e9$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $0a93a5c300cea5e9$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $0a93a5c300cea5e9$var$order(modifiers); // order based on phase
    return (0, $cUxAV.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("cUxAV", function(module, exports) {

$parcel$export(module.exports, "top", () => $9664c6303656943f$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $9664c6303656943f$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $9664c6303656943f$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $9664c6303656943f$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $9664c6303656943f$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $9664c6303656943f$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $9664c6303656943f$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $9664c6303656943f$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $9664c6303656943f$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $9664c6303656943f$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $9664c6303656943f$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $9664c6303656943f$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $9664c6303656943f$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $9664c6303656943f$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $9664c6303656943f$export$d087d3878fdf71d5);
var $9664c6303656943f$export$1e95b668f3b82d = 'top';
var $9664c6303656943f$export$40e543e69a8b3fbb = 'bottom';
var $9664c6303656943f$export$79ffe56a765070d2 = 'right';
var $9664c6303656943f$export$eabcd2c8791e7bf4 = 'left';
var $9664c6303656943f$export$dfb5619354ba860 = 'auto';
var $9664c6303656943f$export$aec2ce47c367b8c3 = [
    $9664c6303656943f$export$1e95b668f3b82d,
    $9664c6303656943f$export$40e543e69a8b3fbb,
    $9664c6303656943f$export$79ffe56a765070d2,
    $9664c6303656943f$export$eabcd2c8791e7bf4
];
var $9664c6303656943f$export$b3571188c770cc5a = 'start';
var $9664c6303656943f$export$bd5df0f255a350f8 = 'end';
var $9664c6303656943f$export$390fd549c5303b4d = 'clippingParents';
var $9664c6303656943f$export$d7b7311ec04a3e8f = 'viewport';
var $9664c6303656943f$export$ae5ab1c730825774 = 'popper';
var $9664c6303656943f$export$ca50aac9f3ba507f = 'reference';
var $9664c6303656943f$export$368f9a87e87fa4e1 = /*#__PURE__*/ $9664c6303656943f$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $9664c6303656943f$export$b3571188c770cc5a,
        placement + "-" + $9664c6303656943f$export$bd5df0f255a350f8
    ]);
}, []);
var $9664c6303656943f$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($9664c6303656943f$export$aec2ce47c367b8c3, [
    $9664c6303656943f$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $9664c6303656943f$export$b3571188c770cc5a,
        placement + "-" + $9664c6303656943f$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $9664c6303656943f$export$421679a7c3d56e = 'beforeRead';
var $9664c6303656943f$export$aafa59e2e03f2942 = 'read';
var $9664c6303656943f$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $9664c6303656943f$export$c65e99957a05207c = 'beforeMain';
var $9664c6303656943f$export$f22da7240b7add18 = 'main';
var $9664c6303656943f$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $9664c6303656943f$export$8d4d2d70e7d46032 = 'beforeWrite';
var $9664c6303656943f$export$68d8715fc104d294 = 'write';
var $9664c6303656943f$export$70a6e5159acce2e6 = 'afterWrite';
var $9664c6303656943f$export$d087d3878fdf71d5 = [
    $9664c6303656943f$export$421679a7c3d56e,
    $9664c6303656943f$export$aafa59e2e03f2942,
    $9664c6303656943f$export$6964f6c886723980,
    $9664c6303656943f$export$c65e99957a05207c,
    $9664c6303656943f$export$f22da7240b7add18,
    $9664c6303656943f$export$bab79516f2d662fe,
    $9664c6303656943f$export$8d4d2d70e7d46032,
    $9664c6303656943f$export$68d8715fc104d294,
    $9664c6303656943f$export$70a6e5159acce2e6
];

});


parcelRegister("4YkF9", function(module, exports) {

$parcel$export(module.exports, "default", () => $39eccb35e3c50f87$export$2e2bcd8739ae039);
function $39eccb35e3c50f87$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("aCxpo", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bb75e3a2d172ac3$export$2e2bcd8739ae039);
function $7bb75e3a2d172ac3$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("hKNVt", function(module, exports) {

$parcel$export(module.exports, "default", () => $cecd75ca68a9b247$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");
var $cecd75ca68a9b247$var$passive = {
    passive: true
};
function $cecd75ca68a9b247$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $eNjCb.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $cecd75ca68a9b247$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $cecd75ca68a9b247$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $cecd75ca68a9b247$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $cecd75ca68a9b247$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $cecd75ca68a9b247$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $cecd75ca68a9b247$var$effect,
    data: {}
};

});

parcelRegister("1hjVu", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ee6d5e58dbc65f7$export$2e2bcd8739ae039);

var $2v9wJ = parcelRequire("2v9wJ");
function $0ee6d5e58dbc65f7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $2v9wJ.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $0ee6d5e58dbc65f7$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $0ee6d5e58dbc65f7$var$popperOffsets,
    data: {}
};

});
parcelRegister("2v9wJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d25dddec077799d$export$2e2bcd8739ae039);

var $i0vbU = parcelRequire("i0vbU");

var $hqMUN = parcelRequire("hqMUN");

var $lM4La = parcelRequire("lM4La");

var $cUxAV = parcelRequire("cUxAV");
function $1d25dddec077799d$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $i0vbU.default)(placement) : null;
    var variation = placement ? (0, $hqMUN.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $cUxAV.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $cUxAV.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $cUxAV.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $cUxAV.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $lM4La.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $cUxAV.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $cUxAV.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("i0vbU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1c06bfb436e5b63$export$2e2bcd8739ae039);

function $d1c06bfb436e5b63$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("hqMUN", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb0acede73c1ccbf$export$2e2bcd8739ae039);
function $cb0acede73c1ccbf$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("lM4La", function(module, exports) {

$parcel$export(module.exports, "default", () => $fda1c5d978c44f54$export$2e2bcd8739ae039);
function $fda1c5d978c44f54$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("1T37S", function(module, exports) {

$parcel$export(module.exports, "default", () => $15fd5a492bd54a2d$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $1Z5jy = parcelRequire("1Z5jy");

var $eNjCb = parcelRequire("eNjCb");

var $9ce0D = parcelRequire("9ce0D");

var $itp1E = parcelRequire("itp1E");

var $i0vbU = parcelRequire("i0vbU");

var $hqMUN = parcelRequire("hqMUN");

var $3Gelu = parcelRequire("3Gelu");
var $15fd5a492bd54a2d$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $15fd5a492bd54a2d$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3Gelu.round)(x * dpr) / dpr || 0,
        y: (0, $3Gelu.round)(y * dpr) / dpr || 0
    };
}
function $15fd5a492bd54a2d$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $cUxAV.left);
    var sideY = (0, $cUxAV.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $1Z5jy.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $eNjCb.default)(popper)) {
            offsetParent = (0, $9ce0D.default)(popper);
            if ((0, $itp1E.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $cUxAV.top) || (placement === (0, $cUxAV.left) || placement === (0, $cUxAV.right)) && variation === (0, $cUxAV.end)) {
            sideY = (0, $cUxAV.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $cUxAV.left) || (placement === (0, $cUxAV.top) || placement === (0, $cUxAV.bottom)) && variation === (0, $cUxAV.end)) {
            sideX = (0, $cUxAV.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $15fd5a492bd54a2d$var$unsetSides);
    var _ref4 = roundOffsets === true ? $15fd5a492bd54a2d$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $eNjCb.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $15fd5a492bd54a2d$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $i0vbU.default)(state.placement),
        variation: (0, $hqMUN.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $15fd5a492bd54a2d$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $15fd5a492bd54a2d$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $15fd5a492bd54a2d$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $15fd5a492bd54a2d$var$computeStyles,
    data: {}
};

});

parcelRegister("gbbnc", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc767ee95e24374d$export$2e2bcd8739ae039);

var $3Ih4r = parcelRequire("3Ih4r");

var $jxz5k = parcelRequire("jxz5k");
// and applies them to the HTMLElements such as popper and arrow
function $bc767ee95e24374d$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $jxz5k.isHTMLElement)(element) || !(0, $3Ih4r.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $bc767ee95e24374d$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $jxz5k.isHTMLElement)(element) || !(0, $3Ih4r.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $bc767ee95e24374d$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $bc767ee95e24374d$var$applyStyles,
    effect: $bc767ee95e24374d$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("bX36N", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b379db63df9cbb0$export$2e2bcd8739ae039);

var $i0vbU = parcelRequire("i0vbU");

var $cUxAV = parcelRequire("cUxAV");
function $8b379db63df9cbb0$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $i0vbU.default)(placement);
    var invertDistance = [
        (0, $cUxAV.left),
        (0, $cUxAV.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $cUxAV.left),
        (0, $cUxAV.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $8b379db63df9cbb0$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $cUxAV.placements).reduce(function(acc, placement) {
        acc[placement] = $8b379db63df9cbb0$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $8b379db63df9cbb0$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $8b379db63df9cbb0$var$offset
};

});

parcelRegister("9chVh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b23232380764dc2$export$2e2bcd8739ae039);

var $3J90z = parcelRequire("3J90z");

var $i0vbU = parcelRequire("i0vbU");

var $69vda = parcelRequire("69vda");

var $9c30h = parcelRequire("9c30h");

var $cnkWG = parcelRequire("cnkWG");

var $cUxAV = parcelRequire("cUxAV");

var $hqMUN = parcelRequire("hqMUN");
function $6b23232380764dc2$var$getExpandedFallbackPlacements(placement) {
    if ((0, $i0vbU.default)(placement) === (0, $cUxAV.auto)) return [];
    var oppositePlacement = (0, $3J90z.default)(placement);
    return [
        (0, $69vda.default)(placement),
        oppositePlacement,
        (0, $69vda.default)(oppositePlacement)
    ];
}
function $6b23232380764dc2$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $i0vbU.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $3J90z.default)(preferredPlacement)
    ] : $6b23232380764dc2$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $i0vbU.default)(placement) === (0, $cUxAV.auto) ? (0, $cnkWG.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $i0vbU.default)(placement);
        var isStartVariation = (0, $hqMUN.default)(placement) === (0, $cUxAV.start);
        var isVertical = [
            (0, $cUxAV.top),
            (0, $cUxAV.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $9c30h.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $cUxAV.right) : (0, $cUxAV.left) : isStartVariation ? (0, $cUxAV.bottom) : (0, $cUxAV.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $3J90z.default)(mainVariationSide);
        var altVariationSide = (0, $3J90z.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $6b23232380764dc2$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $6b23232380764dc2$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("3J90z", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b6c8fe3295acfa9$export$2e2bcd8739ae039);
var $2b6c8fe3295acfa9$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $2b6c8fe3295acfa9$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $2b6c8fe3295acfa9$var$hash[matched];
    });
}

});

parcelRegister("69vda", function(module, exports) {

$parcel$export(module.exports, "default", () => $47abcb4441e1bf89$export$2e2bcd8739ae039);
var $47abcb4441e1bf89$var$hash = {
    start: 'end',
    end: 'start'
};
function $47abcb4441e1bf89$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $47abcb4441e1bf89$var$hash[matched];
    });
}

});

parcelRegister("9c30h", function(module, exports) {

$parcel$export(module.exports, "default", () => $01ba2fbfff0d8e73$export$2e2bcd8739ae039);

var $euRUt = parcelRequire("euRUt");

var $9ce0D = parcelRequire("9ce0D");

var $gQlmL = parcelRequire("gQlmL");

var $2v9wJ = parcelRequire("2v9wJ");

var $e4Nvn = parcelRequire("e4Nvn");

var $cUxAV = parcelRequire("cUxAV");

var $jxz5k = parcelRequire("jxz5k");

var $k6Ryt = parcelRequire("k6Ryt");

var $5kx8d = parcelRequire("5kx8d");
function $01ba2fbfff0d8e73$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $cUxAV.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $cUxAV.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $cUxAV.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $k6Ryt.default)(typeof padding !== 'number' ? padding : (0, $5kx8d.default)(padding, (0, $cUxAV.basePlacements)));
    var altContext = elementContext === (0, $cUxAV.popper) ? (0, $cUxAV.reference) : (0, $cUxAV.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $euRUt.default)((0, $jxz5k.isElement)(element) ? element : element.contextElement || (0, $9ce0D.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $gQlmL.default)(state.elements.reference);
    var popperOffsets = (0, $2v9wJ.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $e4Nvn.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $cUxAV.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $cUxAV.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $cUxAV.right),
                (0, $cUxAV.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $cUxAV.top),
                (0, $cUxAV.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("euRUt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8ddaf68f655dcbb$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $9VLoV = parcelRequire("9VLoV");

var $4dh5d = parcelRequire("4dh5d");

var $edd0p = parcelRequire("edd0p");

var $1Z5jy = parcelRequire("1Z5jy");

var $9ce0D = parcelRequire("9ce0D");

var $itp1E = parcelRequire("itp1E");

var $jxz5k = parcelRequire("jxz5k");

var $gQlmL = parcelRequire("gQlmL");

var $6P0Dy = parcelRequire("6P0Dy");

var $lzCV1 = parcelRequire("lzCV1");

var $3Ih4r = parcelRequire("3Ih4r");

var $e4Nvn = parcelRequire("e4Nvn");

var $3Gelu = parcelRequire("3Gelu");
function $a8ddaf68f655dcbb$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $gQlmL.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $a8ddaf68f655dcbb$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $cUxAV.viewport) ? (0, $e4Nvn.default)((0, $9VLoV.default)(element, strategy)) : (0, $jxz5k.isElement)(clippingParent) ? $a8ddaf68f655dcbb$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $e4Nvn.default)((0, $4dh5d.default)((0, $9ce0D.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $a8ddaf68f655dcbb$var$getClippingParents(element) {
    var clippingParents = (0, $edd0p.default)((0, $6P0Dy.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $itp1E.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $jxz5k.isHTMLElement)(element) ? (0, $1Z5jy.default)(element) : element;
    if (!(0, $jxz5k.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $jxz5k.isElement)(clippingParent) && (0, $lzCV1.default)(clippingParent, clipperElement) && (0, $3Ih4r.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $a8ddaf68f655dcbb$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $a8ddaf68f655dcbb$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $a8ddaf68f655dcbb$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3Gelu.max)(rect.top, accRect.top);
        accRect.right = (0, $3Gelu.min)(rect.right, accRect.right);
        accRect.bottom = (0, $3Gelu.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3Gelu.max)(rect.left, accRect.left);
        return accRect;
    }, $a8ddaf68f655dcbb$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("9VLoV", function(module, exports) {

$parcel$export(module.exports, "default", () => $73ae34c7061d9956$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");

var $9ce0D = parcelRequire("9ce0D");

var $gIy3I = parcelRequire("gIy3I");

var $2QPpT = parcelRequire("2QPpT");
function $73ae34c7061d9956$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $eNjCb.default)(element);
    var html = (0, $9ce0D.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $2QPpT.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $gIy3I.default)(element),
        y: y
    };
}

});

parcelRegister("4dh5d", function(module, exports) {

$parcel$export(module.exports, "default", () => $3115a0ad95105587$export$2e2bcd8739ae039);

var $9ce0D = parcelRequire("9ce0D");

var $itp1E = parcelRequire("itp1E");

var $gIy3I = parcelRequire("gIy3I");

var $hRE8q = parcelRequire("hRE8q");

var $3Gelu = parcelRequire("3Gelu");
function $3115a0ad95105587$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $9ce0D.default)(element);
    var winScroll = (0, $hRE8q.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3Gelu.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3Gelu.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $gIy3I.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $itp1E.default)(body || html).direction === 'rtl') x += (0, $3Gelu.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("lzCV1", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb4b0e4a19431f61$export$2e2bcd8739ae039);

var $jxz5k = parcelRequire("jxz5k");
function $fb4b0e4a19431f61$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $jxz5k.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("e4Nvn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3f7d713ddb7bbc6$export$2e2bcd8739ae039);
function $a3f7d713ddb7bbc6$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("k6Ryt", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea3de91a59864afc$export$2e2bcd8739ae039);

var $5ZEXv = parcelRequire("5ZEXv");
function $ea3de91a59864afc$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $5ZEXv.default)(), paddingObject);
}

});
parcelRegister("5ZEXv", function(module, exports) {

$parcel$export(module.exports, "default", () => $45d26bcdb7eb1b34$export$2e2bcd8739ae039);
function $45d26bcdb7eb1b34$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("5kx8d", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e1885427cc06434$export$2e2bcd8739ae039);
function $3e1885427cc06434$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("cnkWG", function(module, exports) {

$parcel$export(module.exports, "default", () => $9027e15f6f74b552$export$2e2bcd8739ae039);

var $hqMUN = parcelRequire("hqMUN");

var $cUxAV = parcelRequire("cUxAV");

var $9c30h = parcelRequire("9c30h");

var $i0vbU = parcelRequire("i0vbU");
function $9027e15f6f74b552$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $cUxAV.placements) : _options$allowedAutoP;
    var variation = (0, $hqMUN.default)(placement);
    var placements = variation ? flipVariations ? (0, $cUxAV.variationPlacements) : (0, $cUxAV.variationPlacements).filter(function(placement) {
        return (0, $hqMUN.default)(placement) === variation;
    }) : (0, $cUxAV.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $9c30h.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $i0vbU.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("e0gkO", function(module, exports) {

$parcel$export(module.exports, "default", () => $a31dbc8612778f59$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $i0vbU = parcelRequire("i0vbU");

var $lM4La = parcelRequire("lM4La");

var $3ZBe7 = parcelRequire("3ZBe7");

var $1lJXP = parcelRequire("1lJXP");

var $3F4KV = parcelRequire("3F4KV");

var $1Z5jy = parcelRequire("1Z5jy");

var $9c30h = parcelRequire("9c30h");

var $hqMUN = parcelRequire("hqMUN");

var $5ZEXv = parcelRequire("5ZEXv");

var $3Gelu = parcelRequire("3Gelu");
function $a31dbc8612778f59$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $9c30h.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $i0vbU.default)(state.placement);
    var variation = (0, $hqMUN.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $lM4La.default)(basePlacement);
    var altAxis = (0, $3ZBe7.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $cUxAV.top) : (0, $cUxAV.left);
        var altSide = mainAxis === 'y' ? (0, $cUxAV.bottom) : (0, $cUxAV.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $cUxAV.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $cUxAV.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $3F4KV.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $5ZEXv.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $1lJXP.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $1Z5jy.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $1lJXP.within)(tether ? (0, $3Gelu.min)(min, tetherMin) : min, offset, tether ? (0, $3Gelu.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $cUxAV.top) : (0, $cUxAV.left);
        var _altSide = mainAxis === 'x' ? (0, $cUxAV.bottom) : (0, $cUxAV.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $cUxAV.top),
            (0, $cUxAV.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $1lJXP.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $1lJXP.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $a31dbc8612778f59$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $a31dbc8612778f59$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("3ZBe7", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e83f21121a987af$export$2e2bcd8739ae039);
function $2e83f21121a987af$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("1lJXP", function(module, exports) {

$parcel$export(module.exports, "within", () => $0fbb681521294cde$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $0fbb681521294cde$export$86c8af6d3ef0b4a);

var $3Gelu = parcelRequire("3Gelu");
function $0fbb681521294cde$export$f28d906d67a997f3(min, value, max) {
    return (0, $3Gelu.max)(min, (0, $3Gelu.min)(value, max));
}
function $0fbb681521294cde$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $0fbb681521294cde$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("RxAbB", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a0f002a9e1932ee$export$2e2bcd8739ae039);

var $i0vbU = parcelRequire("i0vbU");

var $3F4KV = parcelRequire("3F4KV");

var $lzCV1 = parcelRequire("lzCV1");

var $1Z5jy = parcelRequire("1Z5jy");

var $lM4La = parcelRequire("lM4La");

var $1lJXP = parcelRequire("1lJXP");

var $k6Ryt = parcelRequire("k6Ryt");

var $5kx8d = parcelRequire("5kx8d");

var $cUxAV = parcelRequire("cUxAV");
var $0a0f002a9e1932ee$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $k6Ryt.default)(typeof padding !== 'number' ? padding : (0, $5kx8d.default)(padding, (0, $cUxAV.basePlacements)));
};
function $0a0f002a9e1932ee$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $i0vbU.default)(state.placement);
    var axis = (0, $lM4La.default)(basePlacement);
    var isVertical = [
        (0, $cUxAV.left),
        (0, $cUxAV.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $0a0f002a9e1932ee$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $3F4KV.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $cUxAV.top) : (0, $cUxAV.left);
    var maxProp = axis === 'y' ? (0, $cUxAV.bottom) : (0, $cUxAV.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $1Z5jy.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $1lJXP.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $0a0f002a9e1932ee$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $lzCV1.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $0a0f002a9e1932ee$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $0a0f002a9e1932ee$var$arrow,
    effect: $0a0f002a9e1932ee$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("4Jkbd", function(module, exports) {

$parcel$export(module.exports, "default", () => $371b04b800cbe6bc$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $9c30h = parcelRequire("9c30h");
function $371b04b800cbe6bc$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $371b04b800cbe6bc$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $cUxAV.top),
        (0, $cUxAV.right),
        (0, $cUxAV.bottom),
        (0, $cUxAV.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $371b04b800cbe6bc$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $9c30h.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $9c30h.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $371b04b800cbe6bc$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $371b04b800cbe6bc$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $371b04b800cbe6bc$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $371b04b800cbe6bc$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $371b04b800cbe6bc$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $371b04b800cbe6bc$var$hide
};

});




parcelRegister("6XvxP", function(module, exports) {

$parcel$export(module.exports, "Reference", () => $5110b8d9e7655c91$export$e0be378c32fb70a7);

var $eUqFw = parcelRequire("eUqFw");

var $k6muC = parcelRequire("k6muC");

var $3aVBa = parcelRequire("3aVBa");

var $4J8wt = parcelRequire("4J8wt");
function $5110b8d9e7655c91$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $eUqFw.useContext((0, $3aVBa.ManagerReferenceNodeSetterContext));
    var refHandler = $eUqFw.useCallback(function(node) {
        (0, $4J8wt.setRef)(innerRef, node);
        (0, $4J8wt.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $eUqFw.useEffect(function() {
        return function() {
            return (0, $4J8wt.setRef)(innerRef, null);
        };
    }, []);
    $eUqFw.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $4J8wt.unwrapArray)(children)({
        ref: refHandler
    });
}

});

parcelRegister("asNSH", function(module, exports) {

$parcel$export(module.exports, "shallowEqualObjects", () => $c9294410708307cc$export$3e67810a3f0e9f1c);
function $c9294410708307cc$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $c9294410708307cc$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $c9294410708307cc$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $c9294410708307cc$export$967a6b9924a689f7(a, b);
    return $c9294410708307cc$export$3e67810a3f0e9f1c(a, b);
}

});

parcelRegister("5wCDk", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $eb73e877c5661200$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $eb73e877c5661200$export$2e2bcd8739ae039);

var $hOLnS = parcelRequire("hOLnS");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $5FjBr = parcelRequire("5FjBr");
const $eb73e877c5661200$var$packageName = "platform-pkg";
const $eb73e877c5661200$var$packageVersion = "0.0.0-use.local";
const $eb73e877c5661200$export$d1de3b251ccaa8a3 = (0, $5FjBr.default)((0, $hOLnS.default));
const $eb73e877c5661200$var$createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
const $eb73e877c5661200$var$Select = (0, $1ngde.default)({
    componentName: 'select',
    packageName: $eb73e877c5661200$var$packageName,
    packageVersion: $eb73e877c5661200$var$packageVersion
})((0, $2jDha.default)({
    onChange: $eb73e877c5661200$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $eb73e877c5661200$var$packageName,
            packageVersion: $eb73e877c5661200$var$packageVersion
        }
    })
})($eb73e877c5661200$export$d1de3b251ccaa8a3));
var $eb73e877c5661200$export$2e2bcd8739ae039 = $eb73e877c5661200$var$Select;

});
parcelRegister("5FjBr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba6ba00681316b2f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $jQirI = parcelRequire("jQirI");

var $hgqfZ = parcelRequire("hgqfZ");

var $o2lI9 = parcelRequire("o2lI9");
var $7HYS7 = parcelRequire("7HYS7");

var $bKJfr = parcelRequire("bKJfr");

var $lT14u = parcelRequire("lT14u");
function $ba6ba00681316b2f$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $eUqFw.useRef)(null);
        const components = (0, $eUqFw.useMemo)(()=>({
                ClearIndicator: $o2lI9.ClearIndicator,
                DropdownIndicator: $o2lI9.DropdownIndicator,
                LoadingIndicator: $o2lI9.LoadingIndicator,
                MultiValueRemove: $7HYS7.MultiValueRemove,
                IndicatorSeparator: $7HYS7.IndicatorSeparator,
                Input: $jQirI.Input,
                NoOptionsMessage: $hgqfZ.NoOptionsMessage,
                ...componentsProp
            }), [
            componentsProp
        ]);
        const descriptionId = props['aria-describedby'];
        const isSearchable = props.isSearchable;
        (0, $eUqFw.useEffect)(()=>{
            if (!isSearchable && descriptionId) {
                // when isSearchable is false, react-select will create its own dummy input instead of using ours,
                // so we need to manually add the additional aria-describedby using ref.
                const input = internalSelectRef.current?.inputRef;
                const ariaDescribedby = input?.getAttribute('aria-describedby');
                if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
            }
        }, [
            descriptionId,
            isSearchable
        ]);
        const isCompact = spacing === 'compact';
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $eUqFw.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ref: internalSelectRef,
            "aria-live": "assertive",
            ariaLiveMessages: (0, $lT14u.isOptionsGrouped)(props.options) ? {
                onFocus: $lT14u.onFocus,
                ...ariaLiveMessages
            } : {
                ...ariaLiveMessages
            },
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            ...restProps,
            components: components,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            styles: (0, $cEc3i.m)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $bKJfr.default)(// This will cover both props for invalid state while giving priority to isInvalid. When cleaning up validationState, we can just keep the inner condition.
            typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles)
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});
parcelRegister("jQirI", function(module, exports) {

$parcel$export(module.exports, "Input", () => $644d9bc3d652d5d7$export$f5b8910cec6cf069);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
function $644d9bc3d652d5d7$export$f5b8910cec6cf069(props) {
    let ariaDescribedByAttribute;
    const passed_describedby = props.selectProps['aria-describedby'];
    if (props['aria-describedby'] && passed_describedby) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
    else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Input, {
        ...props,
        "aria-describedby": ariaDescribedByAttribute
    });
}

});

parcelRegister("hgqfZ", function(module, exports) {

$parcel$export(module.exports, "NoOptionsMessage", () => $4d0dc96eef1d75f0$export$d58b72b7d3c4072c);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
const $4d0dc96eef1d75f0$export$d58b72b7d3c4072c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).NoOptionsMessage, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        id: "no-options",
        role: "alert"
    }, props.children || `No options`));
};

});

parcelRegister("o2lI9", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $a14d8b5e9bff27a8$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "DropdownIndicator", () => $a14d8b5e9bff27a8$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "LoadingIndicator", () => $a14d8b5e9bff27a8$export$7c20be4c1d342248);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $hUbUe = parcelRequire("hUbUe");

var $86Ndv = parcelRequire("86Ndv");
const $a14d8b5e9bff27a8$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center'
});
const $a14d8b5e9bff27a8$export$ecf9cf59142dd54a = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).ClearIndicator, {
        ...props,
        innerProps: {
            ...props.innerProps,
            'aria-hidden': 'false'
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4ZL0y.default), {
        xcss: $a14d8b5e9bff27a8$var$iconContainerStyles,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hUbUe))), {
        size: "small",
        label: "clear"
    })));
const $a14d8b5e9bff27a8$export$ec98719d3db7f2e4 = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).DropdownIndicator, props, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
        label: "open"
    }));
const $a14d8b5e9bff27a8$export$7c20be4c1d342248 = (props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const loadingStyles = /*#__PURE__*/ (0, $byn9U.css)(props.getStyles('loadingIndicator', props));
    return(// This *must* be constructed this way because this is being consumed by
    // `react-select` and we don't control what it wants.
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: loadingStyles,
        ...props.innerProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small"
    })));
};

});
parcelRegister("hUbUe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d090e6e9cc89e346$var$_react = $d090e6e9cc89e346$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $d090e6e9cc89e346$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d090e6e9cc89e346$var$SelectClearIcon = (props)=>/*#__PURE__*/ $d090e6e9cc89e346$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="9"/><path d="M16.155 14.493a1.174 1.174 0 11-1.662 1.663L12 13.662l-2.494 2.494a1.172 1.172 0 01-1.662 0 1.176 1.176 0 010-1.663L10.337 12 7.844 9.507a1.176 1.176 0 011.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 111.662 1.662L13.662 12l2.493 2.493z" fill="inherit"/></g></svg>`
    }, props));
$d090e6e9cc89e346$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $d090e6e9cc89e346$var$_default = $d090e6e9cc89e346$var$SelectClearIcon;
module.exports.default = $d090e6e9cc89e346$var$_default;

});


parcelRegister("7HYS7", function(module, exports) {

$parcel$export(module.exports, "MultiValueRemove", () => $7fda2332979a5c13$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "IndicatorSeparator", () => $7fda2332979a5c13$export$bd638c2ba7915668);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $hUbUe = parcelRequire("hUbUe");

var $jQxSL = parcelRequire("jQxSL");

var $o2lI9 = parcelRequire("o2lI9");
function $7fda2332979a5c13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7fda2332979a5c13$var$disabledStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $7fda2332979a5c13$var$enabledStyles = {
    name: "ck88l6",
    styles: "display:inherit"
};
const $7fda2332979a5c13$export$8e1fd1a40e7a2f4a = (props)=>{
    const { isDisabled: isDisabled } = props.selectProps;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).MultiValueRemove, props, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: isDisabled ? $7fda2332979a5c13$var$disabledStyles : $7fda2332979a5c13$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hUbUe))), {
        label: "Clear",
        size: "small",
        primaryColor: "transparent",
        secondaryColor: "inherit"
    })));
};
const $7fda2332979a5c13$export$bd638c2ba7915668 = null;

});

parcelRegister("bKJfr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eba8612e97e7e89$export$2e2bcd8739ae039);

var $PdmhA = parcelRequire("PdmhA");

var $XHGTv = parcelRequire("XHGTv");
function $6eba8612e97e7e89$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
    return {
        container: (css, { isDisabled: isDisabled })=>({
                ...css,
                ...(0, $XHGTv.getBooleanFF)('platform.design-system-team.select-new-typography_7m89c') ? {
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
                } : {
                    fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
                },
                // react-select disables pointer events when isDisabled is true.
                // We override this and make the inner container turn it off instead.
                pointerEvents: 'all',
                cursor: isDisabled ? 'not-allowed' : css.cursor
            }),
        input: (css)=>({
                ...css,
                color: "var(--ds-text, hsl(0, 0%, 20%))"
            }),
        control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
            let borderColor = isFocused ? `var(--ds-border-focused, ${0, $PdmhA.B100})` : `var(--ds-border-input, ${0, $PdmhA.N100})`;
            let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $PdmhA.N0})` : `var(--ds-background-input, ${0, $PdmhA.N20})`;
            let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $PdmhA.N0})` : `var(--ds-background-input-hovered, ${0, $PdmhA.N30})`;
            if (isDisabled) {
                backgroundColor = `var(--ds-background-disabled, ${0, $PdmhA.N20})`;
                borderColor = `var(--ds-background-disabled, ${0, $PdmhA.N20})`;
            }
            if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $PdmhA.R400})`;
            if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $PdmhA.G400})`;
            let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $PdmhA.B100})` : `var(--ds-border-input, ${0, $PdmhA.N100})`;
            if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $PdmhA.R400})`;
            if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $PdmhA.G400})`;
            const transitionDuration = '200ms';
            if (appearance === 'subtle') {
                borderColor = isFocused ? `var(--ds-border-focused, ${0, $PdmhA.B100})` : 'transparent';
                backgroundColor = isFocused ? `var(--ds-surface, ${0, $PdmhA.N0})` : 'transparent';
                backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $PdmhA.N0})` : `var(--ds-background-input-hovered, ${0, $PdmhA.N30})`;
            }
            if (appearance === 'none') {
                borderColor = 'transparent';
                backgroundColor = 'transparent';
                backgroundColorHover = 'transparent';
                borderColorHover = 'transparent';
            }
            return {
                ...css,
                // Turn pointer events off when disabled - this makes it so hover etc don't work.
                pointerEvents: isDisabled ? 'none' : undefined,
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                borderStyle: 'solid',
                borderRadius: "var(--ds-border-radius-100, 3px)",
                borderWidth: "var(--ds-border-width, 1px)",
                boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                '&:focus-within': {
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                },
                minHeight: isCompact ? 32 : 40,
                padding: 0,
                transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                '::-webkit-scrollbar': {
                    height: 8,
                    width: 8
                },
                '::-webkit-scrollbar-corner': {
                    display: 'none'
                },
                ':hover': {
                    '::-webkit-scrollbar-thumb': {
                        // scrollbars occur only if the user passes in a custom component with overflow: scroll
                        backgroundColor: 'rgba(0,0,0,0.2)'
                    },
                    cursor: 'pointer',
                    backgroundColor: backgroundColorHover,
                    borderColor: borderColorHover
                },
                '::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: 'rgba(0,0,0,0.4)'
                }
            };
        },
        valueContainer: (css)=>({
                ...css,
                paddingLeft: "var(--ds-space-075, 6px)",
                paddingRight: "var(--ds-space-075, 6px)",
                paddingBottom: isCompact ? 0 : 2,
                paddingTop: isCompact ? 0 : 2
            }),
        clearIndicator: (css)=>({
                ...css,
                color: `var(--ds-text-subtlest, ${0, $PdmhA.N70})`,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $PdmhA.N500})`
                }
            }),
        loadingIndicator: (css)=>({
                ...css,
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6
            }),
        dropdownIndicator: (css, { isDisabled: isDisabled })=>{
            let color = `var(--ds-text-subtle, ${(0, $PdmhA.N500)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $PdmhA.N70})`;
            return {
                ...css,
                color: color,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $PdmhA.N200})`
                }
            };
        },
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
            let color = `var(--ds-text, ${(0, $PdmhA.N800)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $PdmhA.N70})`;
            else if (isSelected) color = `var(--ds-text-selected, ${0, $PdmhA.B400})`;
            let boxShadow;
            let backgroundColor;
            if (isDisabled) backgroundColor = undefined;
            else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $PdmhA.B50})`;
            else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $PdmhA.B50})`;
            else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $PdmhA.N20})`;
            if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $PdmhA.B400})`}`;
            const cursor = isDisabled ? 'not-allowed' : css.cursor;
            return {
                ...css,
                padding: '6px 12px',
                backgroundColor: backgroundColor,
                color: color,
                cursor: cursor,
                boxShadow: boxShadow,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $PdmhA.N20})` : `var(--ds-background-neutral-subtle-pressed, ${0, $PdmhA.N30})` : undefined
                },
                '@media screen and (-ms-high-contrast: active)': {
                    borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                }
            };
        },
        placeholder: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $PdmhA.N300})` : `var(--ds-text-subtlest, ${0, $PdmhA.N200})`
            }),
        singleValue: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $PdmhA.N70})` : `var(--ds-text, ${0, $PdmhA.N800})`,
                ...!(0, $XHGTv.getBooleanFF)('platform.design-system-team.select-new-typography_7m89c') && {
                    lineHeight: '1rem'
                }
            }),
        menu: (css)=>({
                ...css,
                backgroundColor: "var(--ds-surface-overlay, white)",
                boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
            }),
        menuList: (css)=>({
                ...css,
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-100, 8px)"
            }),
        multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
            let backgroundColor;
            let color;
            if (isDisabled) {
                // Use the basic neutral background so it is slightly separate from the
                // field's background
                backgroundColor = `var(--ds-background-neutral, ${0, $PdmhA.N40})`;
                color = `var(--ds-text-disabled, ${0, $PdmhA.N70})`;
            } else if (isFocused) {
                backgroundColor = `var(--ds-background-selected, ${0, $PdmhA.N40})`;
                color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
            } else {
                backgroundColor = `var(--ds-background-neutral, ${0, $PdmhA.N40})`;
                color = "var(--ds-text, hsl(0, 0%, 20%))";
            }
            return {
                ...css,
                borderRadius: "var(--ds-border-radius-050, 2px)",
                backgroundColor: backgroundColor,
                boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                maxWidth: '100%',
                '@media screen and (-ms-high-contrast: active)': {
                    border: isFocused ? '1px solid transparent' : 'none'
                },
                color: color
            };
        },
        multiValueLabel: (css, { isDisabled: isDisabled })=>({
                ...css,
                padding: "var(--ds-space-025, 2px)",
                color: isDisabled ? `var(--ds-text-disabled, ${0, $PdmhA.N70})` : 'inherit',
                paddingRight: "var(--ds-space-025, 2px)"
            }),
        multiValueRemove: (css, { isFocused: isFocused })=>({
                ...css,
                backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $PdmhA.R75})` : undefined,
                fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                borderRadius: '0px 2px 2px 0px',
                // DSP-6470 we should style like Tag once we have the :has selector
                ':hover': {
                    backgroundColor: `var(--ds-background-danger-hovered, ${0, $PdmhA.R75})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ':active': {
                    backgroundColor: `var(--ds-background-danger-pressed, ${0, $PdmhA.R75})`,
                    fill: "var(--ds-text-danger, #000)"
                }
            }),
        groupHeading: (css)=>({
                ...css,
                ...(0, $XHGTv.getBooleanFF)('platform.design-system-team.select-new-typography_7m89c') && {
                    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
                },
                color: `var(--ds-text-subtle, ${0, $PdmhA.N200})`
            })
    };
}

});

parcelRegister("lT14u", function(module, exports) {

$parcel$export(module.exports, "onFocus", () => $7ccc5140c845bc58$export$ecf9bf35ad97eb74);
$parcel$export(module.exports, "isOptionsGrouped", () => $7ccc5140c845bc58$export$d2756249f53f9f8);
function $7ccc5140c845bc58$export$ecf9bf35ad97eb74(props) {
    const { focused: focused, options: options } = props;
    const isOptionFocused = (option)=>{
        return option === focused;
    };
    const groupData = options?.find((option)=>{
        return option.options?.some(isOptionFocused);
    });
    const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
    return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
}
const $7ccc5140c845bc58$export$d2756249f53f9f8 = (arr)=>{
    return arr?.every((obj)=>obj.hasOwnProperty('options'));
};

});



parcelRegister("7ldaw", function(module, exports) {

$parcel$export(module.exports, "MenuDialog", () => $e208c4fdfb4dbbc3$export$c94219dad7c0e37d);
$parcel$export(module.exports, "DummyControl", () => $e208c4fdfb4dbbc3$export$87ce933b7fc29b8c);
$parcel$export(module.exports, "defaultComponents", () => $e208c4fdfb4dbbc3$export$71abc632aa29e6fe);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $lkPEe = parcelRequire("lkPEe");

var $bPZtE = parcelRequire("bPZtE");

var $lcnyw = parcelRequire("lcnyw");

var $PdmhA = parcelRequire("PdmhA");
function $e208c4fdfb4dbbc3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e208c4fdfb4dbbc3$var$menuDialogStyles = /*#__PURE__*/ (0, $byn9U.css)({
    backgroundColor: "var(--ds-surface-overlay, white)",
    borderRadius: "var(--ds-border-radius-100, 4px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $PdmhA.N40A)}, 0 4px 11px ${(0, $PdmhA.N40A)}`})`,
    zIndex: (0, $lcnyw.layers).modal()
});
const $e208c4fdfb4dbbc3$export$c94219dad7c0e37d = ({ maxWidth: maxWidth, minWidth: minWidth, children: children, id: id, style: style, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $e208c4fdfb4dbbc3$var$menuDialogStyles,
            // There is not a limited amount of values for the widths, so they need
            // to remain dynamic.
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            {
                maxWidth: maxWidth,
                minWidth: minWidth
            }
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        id: id,
        "data-testid": testId && `${testId}--menu`
    }, children);
// ==============================
// Custom Components
// ==============================
const $e208c4fdfb4dbbc3$var$dropdownStyles = {
    name: "1sujbl1",
    styles: "margin-inline-end:var(--ds-space-025, 2px);text-align:center;width:32px"
};
const $e208c4fdfb4dbbc3$var$DropdownIndicator = ()=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e208c4fdfb4dbbc3$var$dropdownStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bPZtE))), {
        label: "open"
    }));
const $e208c4fdfb4dbbc3$var$controlStyles = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-050, 4px)"}`
});
const $e208c4fdfb4dbbc3$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: innerRef,
        css: $e208c4fdfb4dbbc3$var$controlStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).Control, {
        ...props,
        innerProps: innerProps
    }));
const $e208c4fdfb4dbbc3$export$87ce933b7fc29b8c = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $lkPEe.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).Control, props));
// NOTE `props` intentionally omitted from `Fragment`
const $e208c4fdfb4dbbc3$var$Menu = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", innerProps, children);
const $e208c4fdfb4dbbc3$export$71abc632aa29e6fe = {
    Control: $e208c4fdfb4dbbc3$var$Control,
    DropdownIndicator: $e208c4fdfb4dbbc3$var$DropdownIndicator,
    Menu: $e208c4fdfb4dbbc3$var$Menu
};

});
parcelRegister("bPZtE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $89e4253a013a6022$var$_react = $89e4253a013a6022$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $89e4253a013a6022$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $89e4253a013a6022$var$EditorSearchIcon = (props)=>/*#__PURE__*/ $89e4253a013a6022$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M14.823 15.883a5.5 5.5 0 111.06-1.06l2.647 2.647c.293.293.53.59 0 1.06-.53.47-.767.293-1.06 0l-2.647-2.647zM11.5 15.5a4 4 0 100-8 4 4 0 000 8z" fill="currentColor"/></svg>`
    }, props));
$89e4253a013a6022$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
var $89e4253a013a6022$var$_default = $89e4253a013a6022$var$EditorSearchIcon;
module.exports.default = $89e4253a013a6022$var$_default;

});



parcelRegister("38QWb", function(module, exports) {

$parcel$export(module.exports, "default", () => $32c62e54d680854b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $32c62e54d680854b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    ariaLabel: {
        "id": "inline-card-create.form.project-select.aria-label",
        "defaultMessage": "The current project is {value}. Press the 'Space' key to change the project."
    },
    invalid: {
        "id": "inline-card-create.form.project-select.invalid",
        "defaultMessage": "invalid"
    },
    placeholder: {
        "id": "inline-card-create.form.project-select.placeholder",
        "defaultMessage": "Select project"
    }
});

});


parcelRegister("413NZ", function(module, exports) {

$parcel$export(module.exports, "FIELD_KEY_STATUS_TRANSITIONS", () => $66628408fae9451d$export$9f9b866ee3adcf04);
$parcel$export(module.exports, "default", () => $66628408fae9451d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eUqFw = parcelRequire("eUqFw");

var $a0i0f = parcelRequire("a0i0f");

var $7u4fN = parcelRequire("7u4fN");

var $86Ndv = parcelRequire("86Ndv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $jQxSL = parcelRequire("jQxSL");
var $l44HT = parcelRequire("l44HT");

var $8cU5f = parcelRequire("8cU5f");

var $bR5MV = parcelRequire("bR5MV");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");


var $iF4Qi = parcelRequire("iF4Qi");
const $66628408fae9451d$var$ANALYTICS_SUBJECT = 'iccStatusSelect';
const $66628408fae9451d$export$9f9b866ee3adcf04 = 'statusTransitions';
const $66628408fae9451d$var$Option = ({ children: children, ...props })=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { statusInfo: statusInfo } = props.data;
    const StyledOption = (0, $eUqFw.useMemo)(()=>$66628408fae9451d$var$OptionContentComponents[(0, $bR5MV.statusCategoryToThemeMap)[statusInfo.statusCategoryId]], [
        statusInfo.statusCategoryId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StyledOption, {
        "data-testId": "platform-inline-card-create.ui.form.status-select.option"
    }, children));
};
const $66628408fae9451d$var$transformOptions = (statusTransitions, selectedTransitionId)=>{
    let value;
    const options = [];
    statusTransitions.forEach((transition)=>{
        const option = {
            label: transition.name,
            value: transition.transitionId,
            statusInfo: transition
        };
        if (transition.transitionId === selectedTransitionId) value = option;
        else options.push(option);
    });
    if (!value) value = options?.[0];
    return {
        options: options,
        value: value
    };
};
const $66628408fae9451d$var$StatusSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ statusTransitions: statusTransitions, selectedTransitionId: selectedTransitionId, onSelectTransition: onSelectTransition }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { value: value, options: options } = (0, $eUqFw.useMemo)(()=>$66628408fae9451d$var$transformOptions(statusTransitions, selectedTransitionId), [
        statusTransitions,
        selectedTransitionId
    ]);
    const ButtonContent = (0, $eUqFw.useMemo)(()=>$66628408fae9451d$var$ButtonContentComponents[(0, $bR5MV.statusCategoryToThemeMap)[value.statusInfo.statusCategoryId]], [
        value.statusInfo.statusCategoryId
    ]);
    const trigger = (0, $eUqFw.useCallback)(({ isOpen: isOpen, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $66628408fae9451d$var$statusContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $66628408fae9451d$var$statusButtonWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: value.label ?? null,
            delay: (0, $3b526ddeb90a4d89$export$f9e3e7ede9ba929d),
            hideTooltipOnClick: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($66628408fae9451d$var$StyledButton, {
            ...triggerProps,
            appearance: "subtle",
            spacing: "none",
            isSelected: isOpen,
            "aria-label": formatMessage((0, $iF4Qi.default).ariaLabel, {
                value: value.label ?? formatMessage((0, $iF4Qi.default).invalid)
            }),
            testId: "platform-inline-card-create.ui.form.status-select.trigger"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ButtonContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($66628408fae9451d$var$ButtonLabel, null, value.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
            label: ""
        })))))), [
        formatMessage,
        value,
        ButtonContent
    ]);
    const onChange = (0, $eUqFw.useCallback)((option)=>{
        option && onSelectTransition(option.statusInfo.transitionId);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'dropdown changed',
            actionSubject: $66628408fae9451d$var$ANALYTICS_SUBJECT
        }), {});
    }, [
        createAnalyticsEvent,
        onSelectTransition
    ]);
    const onMenuOpen = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'dropdown opened',
            actionSubject: $66628408fae9451d$var$ANALYTICS_SUBJECT
        }), {});
    }, [
        createAnalyticsEvent
    ]);
    const setRefNode = (0, $eUqFw.useCallback)((popupSelectRef)=>{
        ref && popupSelectRef && (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(ref, 'current.node', popupSelectRef);
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l44HT.default), {
        ref: setRefNode,
        components: {
            Option: $66628408fae9451d$var$Option
        },
        target: trigger,
        options: options,
        value: value,
        onChange: onChange,
        onMenuOpen: onMenuOpen,
        isSearchable: false,
        searchThreshold: Number.MAX_SAFE_INTEGER,
        minMenuWidth: "auto",
        classNamePrefix: "inline-card-create-status-select",
        testId: "platform-inline-card-create.ui.form.status-select.status-select"
    });
});
const $66628408fae9451d$var$statusContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    minWidth: '0px',
    position: 'relative'
});
const $66628408fae9451d$var$statusButtonWrapperStyles = (0, $1ZAYh.xcss)({
    width: '100%',
    paddingLeft: 'space.100'
});
var $66628408fae9451d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($66628408fae9451d$var$StatusSelect);
const $66628408fae9451d$var$StyledButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $66628408fae9451d$var$buttonContentStyles = {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: '11px',
    textTransform: 'uppercase',
    fontWeight: 700,
    borderRadius: "var(--ds-border-radius, 3px)"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $66628408fae9451d$var$ButtonContentInProgress = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_oaqmaj": (0, $9t7rW.default)((0, $bR5MV.bgColor)[0, $bR5MV.STATUS_THEME_IN_PROGRESS]),
            "--_kvt9wz": (0, $9t7rW.default)((0, $bR5MV.textColor)[0, $bR5MV.STATUS_THEME_IN_PROGRESS]),
            "--_4s8q1e": (0, $9t7rW.default)((0, $bR5MV.textHoverColor)[0, $bR5MV.STATUS_THEME_IN_PROGRESS]),
            "--_ab42zg": (0, $9t7rW.default)((0, $bR5MV.bgHoverColor)[0, $bR5MV.STATUS_THEME_IN_PROGRESS])
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _19bvu2gc _1wyb1skh _1p1dangw _k48p1fw0 _2rko1sit _bfhk1fmj _syaz15pv _30l3v21d _irr310t0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $66628408fae9451d$var$ButtonContentDefault = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_dqjcet": (0, $9t7rW.default)((0, $bR5MV.bgColor)[0, $bR5MV.STATUS_THEME_DEFAULT]),
            "--_1vitxsu": (0, $9t7rW.default)((0, $bR5MV.textColor)[0, $bR5MV.STATUS_THEME_DEFAULT]),
            "--_1st752z": (0, $9t7rW.default)((0, $bR5MV.textHoverColor)[0, $bR5MV.STATUS_THEME_DEFAULT]),
            "--_amppug": (0, $9t7rW.default)((0, $bR5MV.bgHoverColor)[0, $bR5MV.STATUS_THEME_DEFAULT])
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _19bvu2gc _1wyb1skh _1p1dangw _k48p1fw0 _2rko1sit _bfhkxbkr _syaz16nx _30l31deu _irr3dnrc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $66628408fae9451d$var$ButtonContentSuccess = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1a74xzg": (0, $9t7rW.default)((0, $bR5MV.bgColor)[0, $bR5MV.STATUS_THEME_SUCCESS]),
            "--_exonzs": (0, $9t7rW.default)((0, $bR5MV.textColor)[0, $bR5MV.STATUS_THEME_SUCCESS]),
            "--_oi69rk": (0, $9t7rW.default)((0, $bR5MV.textHoverColor)[0, $bR5MV.STATUS_THEME_SUCCESS]),
            "--_13xvf57": (0, $9t7rW.default)((0, $bR5MV.bgHoverColor)[0, $bR5MV.STATUS_THEME_SUCCESS])
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _19bvu2gc _1wyb1skh _1p1dangw _k48p1fw0 _2rko1sit _bfhkmvqp _syazolra _30l3u2gp _irr3yapi",
            __cmplp.className
        ])
    });
});
const $66628408fae9451d$var$ButtonContentComponents = {
    [(0, $bR5MV.STATUS_THEME_IN_PROGRESS)]: $66628408fae9451d$var$ButtonContentInProgress,
    [(0, $bR5MV.STATUS_THEME_DEFAULT)]: $66628408fae9451d$var$ButtonContentDefault,
    [(0, $bR5MV.STATUS_THEME_SUCCESS)]: $66628408fae9451d$var$ButtonContentSuccess
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $66628408fae9451d$var$ButtonLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bto1l2s _1reo15vq _18m915vq _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $66628408fae9451d$var$optionContentStyles = {
    textTransform: 'uppercase',
    fontWeight: 700,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: '11px',
    padding: `0 ${"var(--ds-space-050, 4px)"}`,
    borderRadius: "var(--ds-border-radius, 3px)"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $66628408fae9451d$var$OptionContentInProgress = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_oaqmaj": (0, $9t7rW.default)((0, $bR5MV.bgColor)[0, $bR5MV.STATUS_THEME_IN_PROGRESS]),
            "--_kvt9wz": (0, $9t7rW.default)((0, $bR5MV.textColor)[0, $bR5MV.STATUS_THEME_IN_PROGRESS])
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1p1dangw _k48p1fw0 _1wyb1skh _1yt4otz2 _2rko1sit _bfhk1fmj _syaz15pv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $66628408fae9451d$var$OptionContentDefault = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_dqjcet": (0, $9t7rW.default)((0, $bR5MV.bgColor)[0, $bR5MV.STATUS_THEME_DEFAULT]),
            "--_1vitxsu": (0, $9t7rW.default)((0, $bR5MV.textColor)[0, $bR5MV.STATUS_THEME_DEFAULT])
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1p1dangw _k48p1fw0 _1wyb1skh _1yt4otz2 _2rko1sit _bfhkxbkr _syaz16nx",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $66628408fae9451d$var$OptionContentSuccess = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1a74xzg": (0, $9t7rW.default)((0, $bR5MV.bgColor)[0, $bR5MV.STATUS_THEME_SUCCESS]),
            "--_exonzs": (0, $9t7rW.default)((0, $bR5MV.textColor)[0, $bR5MV.STATUS_THEME_SUCCESS])
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1p1dangw _k48p1fw0 _1wyb1skh _1yt4otz2 _2rko1sit _bfhkmvqp _syazolra",
            __cmplp.className
        ])
    });
});
const $66628408fae9451d$var$OptionContentComponents = {
    [(0, $bR5MV.STATUS_THEME_IN_PROGRESS)]: $66628408fae9451d$var$OptionContentInProgress,
    [(0, $bR5MV.STATUS_THEME_DEFAULT)]: $66628408fae9451d$var$OptionContentDefault,
    [(0, $bR5MV.STATUS_THEME_SUCCESS)]: $66628408fae9451d$var$OptionContentSuccess
};

});
parcelRegister("iF4Qi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba390e129cffb008$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ba390e129cffb008$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    ariaLabel: {
        "id": "inline-card-create.form.status-select.aria-label",
        "defaultMessage": "The current status is {value}. Press the 'Space' key to change the status."
    },
    invalid: {
        "id": "inline-card-create.form.status-select.invalid",
        "defaultMessage": "invalid"
    }
});

});


parcelRegister("hN8JV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2e5020f9b70b103$export$2e2bcd8739ae039);

var $8XjRr = parcelRequire("8XjRr");
var $d2e5020f9b70b103$export$2e2bcd8739ae039 = (0, $8XjRr.default);

});
parcelRegister("8XjRr", function(module, exports) {

$parcel$export(module.exports, "splitSummary", () => $d64459038ce5932f$export$c3b837d7632b4ca1);
$parcel$export(module.exports, "validateSummary", () => $d64459038ce5932f$export$1b7a903b2450d74d);
$parcel$export(module.exports, "hasValidationError", () => $d64459038ce5932f$export$3100ac1da5e98644);
$parcel$export(module.exports, "default", () => $d64459038ce5932f$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $kjXsi = parcelRequire("kjXsi");

var $eI5EY = parcelRequire("eI5EY");

var $giAhk = parcelRequire("giAhk");

var $g8JvH = parcelRequire("g8JvH");

var $duQ8C = parcelRequire("duQ8C");


var $hLfBz = parcelRequire("hLfBz");

var $3QsJ3 = parcelRequire("3QsJ3");
const $d64459038ce5932f$var$textAreaStyles = null;
const $d64459038ce5932f$var$appearanceStyles = null;
const $d64459038ce5932f$var$stripConsecutiveWhitespacesAndTrim = (value)=>value.replace(/\s/g, ' ').replace(/  +/g, ' ').trim();
const $d64459038ce5932f$export$c3b837d7632b4ca1 = (summary)=>summary.split('\n').reduce((summaries, item)=>{
        const trimmedItem = $d64459038ce5932f$var$stripConsecutiveWhitespacesAndTrim(item); // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
        return [
            ...summaries,
            ...trimmedItem ? [
                trimmedItem
            ] : []
        ];
    }, []);
const $d64459038ce5932f$export$1b7a903b2450d74d = (summary, isMultiCreateEnabled, { formatMessage: formatMessage })=>{
    const sanitisedSummaries = $d64459038ce5932f$export$c3b837d7632b4ca1(summary);
    const isSummaryMultiline = sanitisedSummaries.length > 1;
    const invalidSummary = sanitisedSummaries.some((item)=>item.length > (0, $3b526ddeb90a4d89$export$193356664cd84c83));
    if (isSummaryMultiline) {
        const invalidSummaryConcat = sanitisedSummaries.join(' ').length > (0, $3b526ddeb90a4d89$export$193356664cd84c83);
        return {
            ...(0, $hLfBz.emptyValidationError),
            summary: invalidSummary ? formatMessage((0, $3QsJ3.default).maxLengthMultiple) : '',
            summaryConcat: invalidSummaryConcat ? formatMessage((0, $3QsJ3.default).maxLength) : ''
        };
    } // show a warning when multi-create is disabled, and summary has reached max length
    if (!isMultiCreateEnabled && summary.length === (0, $3b526ddeb90a4d89$export$193356664cd84c83)) return {
        ...(0, $hLfBz.emptyValidationError),
        summary: formatMessage((0, $3QsJ3.default).maxLength)
    };
    return {
        ...(0, $hLfBz.emptyValidationError),
        summary: invalidSummary ? formatMessage((0, $3QsJ3.default).maxLength) : ''
    };
};
const $d64459038ce5932f$export$3100ac1da5e98644 = (validationError)=>Object.values(validationError).filter((error)=>error).length > 0;
class $d64459038ce5932f$export$46453a0401d6cd1a extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isMultiCreateEnabled: false,
            autoFocus: true,
            shouldScrollIntoView: false,
            initialSummary: '',
            placeholderText: '',
            appearance: (0, $3b526ddeb90a4d89$export$3789e4b2a10baa2b),
            submitCounter: 0,
            selectedIssueType: undefined,
            onChangeSummary: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            setFocusOnTrigger: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    // then setting the setSelectionRange in the textarea will send the cursor to the end of the textarea value.
    // And setting the textarea scrollHeight to scrollTop will send the cursor to the last line when add multiples.
    componentDidMount() {
        const { shouldScrollIntoView: shouldScrollIntoView, autoFocus: autoFocus } = this.props;
        const textArea = this.textAreaRef.current;
        if (textArea) {
            const { length: length } = textArea.value; // preventScroll used to prevent unwanted scrolling with virtualization mounting / re-mounting the component
            textArea.focus({
                preventScroll: !shouldScrollIntoView
            });
            textArea.setSelectionRange(length, length);
            textArea.scrollTop = textArea.scrollHeight;
            if (autoFocus) {
                textArea.focus();
                textArea.setSelectionRange(length, length);
                textArea.scrollTop = textArea.scrollHeight;
            }
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.submitCounter > prevProps.submitCounter) this.reset();
    }
    shouldSummarySubmit() {
        const { summary: summary, validationError: validationError } = this.state;
        const sanitisedSummaries = $d64459038ce5932f$export$c3b837d7632b4ca1(summary); // the warning when multi-create is disabled, and summary has reached max length, should not block submit
        return (!$d64459038ce5932f$export$3100ac1da5e98644(validationError) || !this.props.isMultiCreateEnabled && summary.length === (0, $3b526ddeb90a4d89$export$193356664cd84c83)) && sanitisedSummaries.length === 1;
    }
    reset() {
        this.setState({
            summary: '',
            validationError: (0, $hLfBz.emptyValidationError)
        });
    }
    render() {
        const { placeholderText: placeholderText, appearance: appearance, isMultiCreateEnabled: isMultiCreateEnabled, selectedIssueType: selectedIssueType, intl: { formatMessage: formatMessage } } = this.props;
        const ariaLabel = selectedIssueType ? formatMessage((0, $3QsJ3.default).ariaLabelSelectedType, {
            value: selectedIssueType
        }) : formatMessage((0, $3QsJ3.default).ariaLabel);
        const ariaLabelOld = formatMessage((0, $3QsJ3.default).ariaLabelOld);
        const accessibilityProps = {
            'aria-label': (0, $eI5EY.fg)('jsw_roadmaps_timeline-issue-creation-ally') ? ariaLabel : ariaLabelOld,
            'aria-required': true,
            'aria-invalid': !this.isValid()
        };
        const accessibilityMessage = formatMessage((0, $3QsJ3.default).issueWithNameCreatedSuccessfully, {
            name: this.state.ariaLive
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kjXsi.ScreenReaderText), {
            "aria-live": "assertive",
            id: "inline-card-create.form.summary.a11y.aria-live",
            "data-testid": "platform-inline-card-create.ui.form.summary.aria-live"
        }, this.state.ariaLive && accessibilityMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("textarea", {
            ref: this.textAreaRef,
            "data-testid": "platform-inline-card-create.ui.form.summary.styled-text-area",
            placeholder: placeholderText || formatMessage((0, $3QsJ3.default).prompt),
            value: this.state.summary,
            onChange: this.onChangeSummary,
            onKeyDown: this.onKeyDown,
            ...(0, $eI5EY.fg)('jsw_roadmaps_timeline-issue-creation-ally') ? {
                onKeyUp: this.onKeyUp
            } : {},
            rows: appearance === (0, $3b526ddeb90a4d89$export$3789e4b2a10baa2b) ? 2 : 1,
            maxLength: isMultiCreateEnabled ? undefined : (0, $3b526ddeb90a4d89$export$193356664cd84c83),
            tabIndex: 0,
            "aria-controls": "inline-card-create.form.summary.a11y.aria-live",
            ...accessibilityProps,
            className: (0, $7JEyt.default)([
                "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4t3i1jfw _1bsb1osq _14zgglyw _bfhkvuon _syaz1fxt _11c81oud _1idr1wmz _1wfakb7n",
                appearance !== (0, $3b526ddeb90a4d89$export$3789e4b2a10baa2b) && "_4t3iv47k _o572qvpr _1fjgglyw _4pckglyw _1cicglyw"
            ])
        }));
    }
    constructor(...args){
        super(...args);
        this.state = {
            summary: this.props.initialSummary,
            validationError: $d64459038ce5932f$export$1b7a903b2450d74d(this.props.initialSummary, this.props.isMultiCreateEnabled, this.props.intl),
            ariaLive: ''
        } // For the cursor to be move to the end when the component remount, the textarea has to have focus first,
        ;
        this.textAreaRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
        this.onChangeSummary = (event)=>{
            const { onChangeSummary: onChangeSummary, isMultiCreateEnabled: isMultiCreateEnabled, intl: intl } = this.props;
            let summary = event.target.value;
            let displayedSummary = summary;
            if (!isMultiCreateEnabled) {
                summary = $d64459038ce5932f$var$stripConsecutiveWhitespacesAndTrim(summary);
                displayedSummary = displayedSummary.replace(/[\n\r]+/g, ' ');
            }
            const validationError = $d64459038ce5932f$export$1b7a903b2450d74d(summary, isMultiCreateEnabled, intl);
            onChangeSummary({
                summary: summary,
                validationError: validationError
            });
            this.setState({
                summary: displayedSummary,
                validationError: validationError,
                ariaLive: ''
            });
        };
        this.onKeyDown = (event)=>{
            event.stopPropagation();
            const { onSubmit: onSubmit, onCancel: onCancel } = this.props; // RTL tests cannot send event ASCII code but only the actual string `Enter` or `Escape`
            // ref: https://github.com/testing-library/user-event/blob/main/src/keyboard/keyMap.ts#L60C24-L60C35
            if (event.key === 'Enter' && !event.nativeEvent.isComposing) {
                event.preventDefault();
                if (this.shouldSummarySubmit()) {
                    (0, $duQ8C.default)('inline-card-create-submit', event.timeStamp);
                    onSubmit();
                    this.setState({
                        ariaLive: this.state.summary
                    });
                }
            } else if (!(0, $eI5EY.fg)('jsw_roadmaps_timeline-issue-creation-ally') && event.key === 'Escape' && !event.nativeEvent.isComposing) return onCancel();
        };
        this.onKeyUp = (event)=>{
            event.stopPropagation();
            const { onCancel: onCancel, setFocusOnTrigger: setFocusOnTrigger } = this.props; // nativeEvent isComposing check is here to prevent ICC from closing when IMEs are open
            // When an IME is open, pressing Escape should close the IME, but ICC should remain open
            if (event.key === 'Escape' && !event.nativeEvent.isComposing) {
                // Set to required on FG cleanup jsw_roadmaps_timeline-issue-creation-ally
                setFocusOnTrigger?.();
                return onCancel();
            }
        };
        this.isValid = ()=>{
            const { summary: summary, summaryConcat: summaryConcat } = this.state.validationError;
            return summary === '' && summaryConcat === '';
        };
    }
}
var $d64459038ce5932f$export$2e2bcd8739ae039 = (0, $g8JvH.AnalyticsEventToProps)('ICC-summary', {
    onSubmit: 'onSubmitSummary',
    onCancel: 'onCancelSummary'
})((0, $giAhk.injectIntlV2)($d64459038ce5932f$export$46453a0401d6cd1a));

});
parcelRegister("3QsJ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcd2d38ca774390a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $dcd2d38ca774390a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    prompt: {
        "id": "inline-card-create.form.summary.prompt",
        "defaultMessage": "What needs to be done?"
    },
    maxLength: {
        "id": "inline-card-create.form.summary.max-length",
        "defaultMessage": "The issue summary must be less than or equal to 255 characters."
    },
    maxLengthMultiple: {
        "id": "inline-card-create.form.summary.max-length-multiple",
        "defaultMessage": "The summary of every issue must be less than or equal to 255 characters."
    },
    issueWithNameCreatedSuccessfully: {
        "id": "inline-card-create.form.summary.issue-with-name-created-successfully",
        "defaultMessage": "Issue {name} created successfully"
    },
    ariaLabel: {
        "id": "inline-card-create.form.summary.aria-label",
        "defaultMessage": "Add your issue summary and then press Enter to submit. Use the Escape key to cancel."
    },
    ariaLabelSelectedType: {
        "id": "inline-card-create.form.summary.aria-label-selected-type",
        "defaultMessage": "{value} selected. Add your issue summary and then press Enter to submit. Use the Escape key to cancel."
    },
    ariaLabelOld: {
        "id": "inline-card-create.form.summary.aria-label-old",
        "defaultMessage": "What needs to be done? - Press the \"Enter\" key to submit or the \"Escape\" key to cancel."
    }
});

});



parcelRegister("knOxy", function(module, exports) {

$parcel$export(module.exports, "default", () => $429f74f3bf765534$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $8blac = parcelRequire("8blac");

var $a0i0f = parcelRequire("a0i0f");

var $7u4fN = parcelRequire("7u4fN");

var $86Ndv = parcelRequire("86Ndv");

var $5xnoX = parcelRequire("5xnoX");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $jQxSL = parcelRequire("jQxSL");
var $l44HT = parcelRequire("l44HT");

var $8cU5f = parcelRequire("8cU5f");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");


var $kRUWQ = parcelRequire("kRUWQ");

var $8ZXsp = parcelRequire("8ZXsp");
const $429f74f3bf765534$var$ANALYTICS_SUBJECT = 'iccTypeSelect'; // NOTE: Compiled/css rules needs to be defined at the top of the component (Otherwise Cypress tests failing)
// ----------------------------------------------------------------------------------------------------------
// kept here the negative margins from the original dropdown component but ideally these shouldn't exist
const $429f74f3bf765534$var$containerStyles = null;
const $429f74f3bf765534$var$optionWrapperStyles = null;
const $429f74f3bf765534$var$triggerContentStyles = null;
const $429f74f3bf765534$var$singValueContainerStyles = null;
const $429f74f3bf765534$var$extraLinksGroupStyles = null;
const $429f74f3bf765534$var$optionContentStyles = null;
const $429f74f3bf765534$var$Option = ({ children: children, ...props })=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { cardType: cardType, renderAdditionalContent: renderAdditionalContent } = props.data;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "platform-inline-card-create.ui.form.type-select.option",
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o"
        ])
    }, !!cardType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ZXsp.default), {
        styles: {
            marginRight: "var(--ds-space-100, 8px)"
        },
        cardType: cardType
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug"
        ])
    }, children), !!cardType && !!renderAdditionalContent && renderAdditionalContent(cardType)));
};
const $429f74f3bf765534$var$Group = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_x3dope8f _19pk1b66 _ca0q1b66"
        ])
    }, children);
const $429f74f3bf765534$var$COMPONENTS = {
    Option: $429f74f3bf765534$var$Option,
    Group: $429f74f3bf765534$var$Group
};
const $429f74f3bf765534$var$makeOption = (cardType, renderAdditionalContent)=>({
        label: cardType.name,
        value: cardType.id,
        cardType: cardType,
        optionType: 'card',
        renderAdditionalContent: renderAdditionalContent
    });
const $429f74f3bf765534$var$TypeSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ cardTypes: cardTypes, selectedCardTypeId: selectedCardTypeId, extraItems: extraItems, shouldRenderToParent: shouldRenderToParent = false, onSelectCardType: onSelectCardType, renderAdditionalOptionContent: renderAdditionalOptionContent, isEligibleInContextIssueTypesExperiment: isEligibleInContextIssueTypesExperiment }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [, fireExperimentExposure] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_config_in_context_issue_types_m2');
    const isDefaultItem = cardTypes[0]?.id === selectedCardTypeId;
    const value = (0, $eUqFw.useMemo)(()=>{
        const selectedType = cardTypes.find((type)=>type.id === selectedCardTypeId);
        return selectedType ? $429f74f3bf765534$var$makeOption(selectedType, renderAdditionalOptionContent) : null;
    }, [
        cardTypes,
        selectedCardTypeId,
        renderAdditionalOptionContent
    ]);
    const options = (0, $eUqFw.useMemo)(()=>{
        const result = cardTypes.filter((type)=>type.id !== selectedCardTypeId).map((type)=>$429f74f3bf765534$var$makeOption(type, renderAdditionalOptionContent)); // add extra links if there are any
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(extraItems)) {
            const linkOptions = extraItems.map((item)=>({
                    label: item.name != null ? item.name : formatMessage((0, $kRUWQ.default).manageIssueTypes),
                    value: item.url,
                    url: item.url,
                    onItemSelect: item.onItemSelect,
                    openNewTab: item.openNewTab ?? false,
                    optionType: 'link'
                })); // if there are other options already, group the extra links in a new section
            if (result.length) result.push({
                options: linkOptions,
                optionType: 'links'
            });
            else result.push(...linkOptions);
        }
        return result;
    }, [
        cardTypes,
        extraItems,
        formatMessage,
        renderAdditionalOptionContent,
        selectedCardTypeId
    ]);
    const isOptionDisabled = (0, $eUqFw.useCallback)((option)=>option.optionType === 'card' && option.cardType.isDisabled === true, []);
    const trigger = (0, $eUqFw.useCallback)(({ isOpen: isOpen, ...triggerProps })=>{
        const triggerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: value?.label ?? null,
            delay: (0, $3b526ddeb90a4d89$export$f9e3e7ede9ba929d),
            hideTooltipOnClick: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $7JEyt.default)([
                "_18u0r5cr _2hwxr5cr"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            ...triggerProps,
            appearance: "subtle",
            spacing: "none",
            isSelected: isOpen,
            "aria-label": formatMessage((0, $kRUWQ.default).ariaLabel, {
                value: value?.label ?? formatMessage((0, $kRUWQ.default).invalid)
            }),
            testId: "platform-inline-card-create.ui.form.type-select.trigger"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $7JEyt.default)([
                "_1e0c1txw _4cvr1h6o _18u01b66"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ZXsp.default), {
            cardType: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(value, 'cardType')
        }), isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5xnoX))), {
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
            label: ""
        })))));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $429f74f3bf765534$var$typeContainerStyles
        }, triggerContent);
    }, [
        formatMessage,
        value
    ]);
    const onChange = (0, $eUqFw.useCallback)((option)=>{
        if (option && 'cardType' in option && option.cardType != null) {
            onSelectCardType(option.cardType.id);
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                action: 'selectedType',
                actionSubject: $429f74f3bf765534$var$ANALYTICS_SUBJECT
            }), {
                issueTypesCount: cardTypes.length
            });
        }
        if (option && 'url' in option && option.url != null) {
            if (option.openNewTab === true) window.open(option.url, '_blank');
            else window.location.href = option.url;
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                action: 'selectedExtraItem',
                actionSubject: $429f74f3bf765534$var$ANALYTICS_SUBJECT
            }), {
                issueTypesCount: cardTypes.length
            });
        }
        if (option && 'onItemSelect' in option && option.onItemSelect) option.onItemSelect();
    }, [
        cardTypes.length,
        createAnalyticsEvent,
        onSelectCardType
    ]);
    const onMenuOpen = (0, $eUqFw.useCallback)(()=>{
        if ((0, $1ybV0.ff)('config-in-context-issue-type-m2-flag_bddyq') && isEligibleInContextIssueTypesExperiment) fireExperimentExposure();
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'opened',
            actionSubject: $429f74f3bf765534$var$ANALYTICS_SUBJECT
        }), {
            isDefaultItem: isDefaultItem
        });
    }, [
        createAnalyticsEvent,
        isDefaultItem,
        isEligibleInContextIssueTypesExperiment,
        fireExperimentExposure
    ]);
    const setRefNode = (0, $eUqFw.useCallback)((popupSelectRef)=>{
        ref && popupSelectRef && (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(ref, 'current.node', popupSelectRef);
    }, [
        ref
    ]);
    if (cardTypes.length === 1 && (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(extraItems)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: value?.label ?? null,
        delay: (0, $3b526ddeb90a4d89$export$f9e3e7ede9ba929d)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_18u0r5cr _2hwxr5cr",
            "_1e0c116y _4cvr1h6o _1yt41b66"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ZXsp.default), {
        cardType: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(value, 'cardType')
    })));
     // to render popup next to the trigger element to achieve DOM order
    const popupStrategy = shouldRenderToParent ? 'fixed' : 'absolute';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l44HT.default // @ts-expect-error — Type 'T | null' is not assignable to type 'PopupSelect<SelectOption, false, ModifierList>'
    ), {
        ref: setRefNode,
        components: $429f74f3bf765534$var$COMPONENTS,
        target: trigger,
        options: options,
        isOptionDisabled: isOptionDisabled,
        value: value,
        onChange: onChange,
        onMenuOpen: onMenuOpen,
        isSearchable: false,
        searchThreshold: Number.MAX_SAFE_INTEGER,
        minMenuWidth: "auto",
        classNamePrefix: "inline-card-create-type-select",
        testId: "platform-inline-card-create.ui.form.type-select.type-select",
        popperProps: {
            strategy: popupStrategy
        }
    });
});
const $429f74f3bf765534$var$typeContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    flexShrink: 0
});
var $429f74f3bf765534$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($429f74f3bf765534$var$TypeSelect);

});
parcelRegister("5xnoX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $40822fe6f5908262$var$_react = $40822fe6f5908262$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $40822fe6f5908262$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $40822fe6f5908262$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $40822fe6f5908262$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11.221 9.322l-2.929 2.955a1.009 1.009 0 000 1.419.986.986 0 001.405 0l2.298-2.317 2.307 2.327a.989.989 0 001.407 0 1.01 1.01 0 000-1.419l-2.94-2.965A1.106 1.106 0 0011.991 9c-.279 0-.557.107-.77.322z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$40822fe6f5908262$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $40822fe6f5908262$var$_default = $40822fe6f5908262$var$ChevronUpIcon;
module.exports.default = $40822fe6f5908262$var$_default;

});

parcelRegister("kRUWQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c10c87b1e4f0344e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c10c87b1e4f0344e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    ariaLabel: {
        "id": "inline-card-create.form.type-select.aria-label",
        "defaultMessage": "The current issue type is {value}. Press the 'Space' key to change the issue type."
    },
    invalid: {
        "id": "inline-card-create.form.type-select.invalid",
        "defaultMessage": "invalid"
    },
    manageIssueTypes: {
        "id": "inline-card-create.form.type-select.manage-issue-types",
        "defaultMessage": "Manage issue types"
    },
    addIssueType: {
        "id": "inline-card-create.form.type-select.add-issue-type",
        "defaultMessage": "Add issue type"
    }
});

});

parcelRegister("8ZXsp", function(module, exports) {

$parcel$export(module.exports, "default", () => $94584bf9a27e724a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* eslint-disable jira/react/no-style-attribute */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");
const $94584bf9a27e724a$export$9fbe3594a958ae08 = '/icons/issuetypes/genericissue.svg';
const $94584bf9a27e724a$var$cardTypeImageStyles = null;
const $94584bf9a27e724a$var$TypeIcon = ({ cardType: cardType, styles: styles, className: className })=>cardType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: cardType.iconUrl,
        alt: cardType.name,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7JEyt.default)([
            "_4t3i7vkz _1bsb7vkz",
            className
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: styles
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        alt: "",
        src: $94584bf9a27e724a$export$9fbe3594a958ae08,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7JEyt.default)([
            "_4t3i7vkz _1bsb7vkz",
            className
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: styles
    });
var $94584bf9a27e724a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($94584bf9a27e724a$var$TypeIcon);

});




parcelRegister("bZyJo", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc288ea5d71ef3c9$export$2e2bcd8739ae039);

var $3OzvF = parcelRequire("3OzvF");

var $jy2ZV = parcelRequire("jy2ZV");
var $dc288ea5d71ef3c9$export$2e2bcd8739ae039 = (0, $jy2ZV.default);

});
parcelRegister("3OzvF", function(module, exports) {

$parcel$export(module.exports, "default", () => $686743de48ea4603$export$2e2bcd8739ae039);

var $basbj = parcelRequire("basbj");
var $686743de48ea4603$export$2e2bcd8739ae039 = (0, $basbj.default);

});
parcelRegister("basbj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bbd783de2591dde$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bkIGg = parcelRequire("bkIGg");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $eI5EY = parcelRequire("eI5EY");

const $6bbd783de2591dde$var$fadeInAnimation = null;
const $6bbd783de2591dde$var$triggerStyles = null;
const $6bbd783de2591dde$var$buttonStyles = null;
// eslint-disable-next-line jira/styled/styled-component-order
const $6bbd783de2591dde$var$centeredIconStyles = (0, $1ZAYh.xcss)({
    margin: 'space.negative.025',
    height: "var(--ds-space-300, 24px)",
    width: "var(--ds-space-300, 24px)"
});
// eslint-disable-next-line jira/styled/styled-component-order
const $6bbd783de2591dde$var$dividerStyles = (0, $1ZAYh.xcss)({
    position: 'absolute',
    transform: 'translateY(3px)',
    height: "var(--ds-space-025, 2px)",
    width: '100%'
});
const $6bbd783de2591dde$var$TriggerFallback = (props)=>/*#__PURE__*/ $eUqFw.createElement("div", {
        ...props,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _kqswh2mm _1pbykb7n _18s8p5ac _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _12ji1r31 _1qu2glyw _12y31o36 _4t3iu2gc _1bsb1osq _bfhk18uv _tzy4idpf _1pjhtlke _1mygkb7n _qj9aglyw _d0altlke _11om1wwu _7psyfnf5 _1uy0fnf5 _bir2q7pw"
        ])
    });
const $6bbd783de2591dde$export$9496cf78b8451731 = ({ label: label, onClick: onClick, TriggerWrapper: TriggerWrapper = $6bbd783de2591dde$var$TriggerFallback, shouldFocusTrigger: shouldFocusTrigger = false })=>/*#__PURE__*/ $eUqFw.createElement(TriggerWrapper, {
        onClick: onClick
    }, /*#__PURE__*/ $eUqFw.createElement((0, $8cU5f.default), {
        content: label,
        position: "left",
        delay: (0, $3b526ddeb90a4d89$export$f9e3e7ede9ba929d),
        hideTooltipOnClick: true
    }, /*#__PURE__*/ $eUqFw.createElement("button", {
        "data-testid": "platform-inline-card-create.ui.trigger.hidden.button",
        ...(0, $eI5EY.fg)('jsw_roadmaps_timeline-issue-creation-ally') ? {
            autoFocus: shouldFocusTrigger
        } : {},
        className: (0, $7JEyt.default)([
            "_1e0c1ule _kqswstnw _t9ec1c9r _1pbykb7n _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _12ji1r31 _1qu2glyw _12y31o36 _4t3iv47k _1bsbv47k _19itglyw _2rko1sit _bfhkq17z _80om1kw7"
        ])
    }, /*#__PURE__*/ $eUqFw.createElement((0, $b5IAe.default), {
        xcss: $6bbd783de2591dde$var$centeredIconStyles
    }, /*#__PURE__*/ $eUqFw.createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
        label: label,
        primaryColor: `var(--ds-icon-inverse, ${(0, $PdmhA).N0})`
    })))), /*#__PURE__*/ $eUqFw.createElement((0, $b5IAe.default), {
        xcss: $6bbd783de2591dde$var$dividerStyles,
        backgroundColor: "color.background.brand.bold"
    }));
var $6bbd783de2591dde$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($6bbd783de2591dde$export$9496cf78b8451731);

});


parcelRegister("jy2ZV", function(module, exports) {

$parcel$export(module.exports, "default", () => $8087cd335509c957$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $eI5EY = parcelRequire("eI5EY");

var $giAhk = parcelRequire("giAhk");

var $g8JvH = parcelRequire("g8JvH");


var $3OzvF = parcelRequire("3OzvF");

var $d3TYt = parcelRequire("d3TYt");

var $5ojFf = parcelRequire("5ojFf");
function $8087cd335509c957$export$41fb9f06171c75f4({ isDisabled: isDisabled, triggerAppearance: triggerAppearance, isSticky: isSticky, label: label, ariaLabelledBy: ariaLabelledBy, onClick: onClick, intl: { formatMessage: formatMessage }, isModalTrigger: isModalTrigger, shouldFocusTrigger: shouldFocusTrigger = false }) {
    const defaultLabel = label || formatMessage((0, $d3TYt.default).label);
    if (triggerAppearance === (0, $3b526ddeb90a4d89$export$dda6912361cddac9)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ojFf.default), {
        isModalTrigger: isModalTrigger,
        isSticky: isSticky,
        label: defaultLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        isDisabled: isDisabled,
        ...(0, $eI5EY.fg)('jsw_roadmaps_timeline-issue-creation-ally') ? {
            shouldFocusTrigger: shouldFocusTrigger
        } : {}
    });
    if (isDisabled !== true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3OzvF.default), {
        label: defaultLabel,
        onClick: onClick,
        ...(0, $eI5EY.fg)('jsw_roadmaps_timeline-issue-creation-ally') ? {
            shouldFocusTrigger: shouldFocusTrigger
        } : {}
    });
    return null;
}
$8087cd335509c957$export$41fb9f06171c75f4.defaultProps = {
    isDisabled: false,
    isSticky: false,
    triggerAppearance: (0, $3b526ddeb90a4d89$export$dda6912361cddac9),
    label: '',
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    shouldFocusTrigger: false
};
var $8087cd335509c957$export$2e2bcd8739ae039 = (0, $g8JvH.AnalyticsEventToProps)('button', {
    onClick: 'clicked'
})((0, $giAhk.injectIntlV2)($8087cd335509c957$export$41fb9f06171c75f4));

});
parcelRegister("d3TYt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0bc75cb9f9d82a0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a0bc75cb9f9d82a0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "inline-card-create.trigger.label",
        "defaultMessage": "Create issue"
    }
});

});

parcelRegister("5ojFf", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c71a13d800d4878$export$2e2bcd8739ae039);

var $lcwYh = parcelRequire("lcwYh");
var $7c71a13d800d4878$export$2e2bcd8739ae039 = (0, $lcwYh.default);

});
parcelRegister("lcwYh", function(module, exports) {

$parcel$export(module.exports, "default", () => $effb20d6e7753ccf$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $bbaTG = parcelRequire("bbaTG");

var $gO9Xw = parcelRequire("gO9Xw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $c9TLT = parcelRequire("c9TLT");

var $eI5EY = parcelRequire("eI5EY");

var $dOL7m = parcelRequire("dOL7m");

var $cezcv = parcelRequire("cezcv");
const $effb20d6e7753ccf$var$labelWrapperStyles = null;
const $effb20d6e7753ccf$var$contentWrapperStyles = null;
const $effb20d6e7753ccf$export$305831e851c35a16 = ({ isDisabled: isDisabled = false, isSticky: isSticky = false, label: label, ariaLabelledBy: ariaLabelledBy, onClick: onClick, isModalTrigger: isModalTrigger, shouldFocusTrigger: shouldFocusTrigger = false })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const iccButtonTheme = (currentTheme, props)=>{
        const themeProps = {
            ...props
        };
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
        return {
            buttonStyles: {
                ...buttonStyles,
                marginTop: "var(--ds-space-025, 2px)",
                marginBottom: "var(--ds-space-025, 2px)",
                height: `${(0, $c9TLT.gridSize) * 4.5}px`,
                alignItems: 'center'
            },
            spinnerStyles: spinnerStyles
        };
    };
    const iconColor = isDisabled ? `var(--ds-icon-disabled, ${(0, $PdmhA).N70})` : `var(--ds-icon, ${(0, $PdmhA).N500})`;
    const shouldShowTooltip = label.length > 16;
    const renderStickyContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            className: (0, $7JEyt.default)([
                "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bah1e5h"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
            testId: "platform-inline-card-create.ui.trigger.visible.add-icon",
            label: "",
            primaryColor: iconColor,
            size: "small"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $7JEyt.default)([
                "_1e0c1ule _18u01b66 _1reo15vq _1wnr15vq"
            ])
        }, (0, $eI5EY.fg)('jsw_roadmaps_timeline-issue-creation-ally') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $effb20d6e7753ccf$var$labelContextStyles,
            as: "span"
        }, label) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cezcv.default), null, label)));
    const ButtonComponent = isModalTrigger ? (0, $dOL7m.ModalTriggerButton) : (0, $bbaTG.default);
    const renderButtonComponent = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ButtonComponent, {
            ...triggerProps,
            iconBefore: isSticky ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
                testId: "platform-inline-card-create.ui.trigger.visible.add-icon",
                label: "",
                primaryColor: iconColor,
                size: "small"
            }),
            appearance: "subtle",
            theme: iccButtonTheme,
            shouldFitContainer: true,
            onClick: onClick,
            isDisabled: isDisabled,
            testId: "platform-inline-card-create.ui.trigger.visible.button",
            "aria-labelledby": ariaLabelledBy,
            "aria-label": label,
            autoFocus: shouldFocusTrigger
        }, isSticky ? renderStickyContent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $effb20d6e7753ccf$var$labelContextStyles,
            as: "span"
        }, label));
    return (0, $eI5EY.fg)('jsw_roadmaps_timeline-issue-creation-ally') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, shouldShowTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: label,
        tag: "span"
    }, renderButtonComponent) : renderButtonComponent()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ButtonComponent, {
        iconBefore: isSticky ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
            testId: "platform-inline-card-create.ui.trigger.visible.add-icon",
            label: "",
            primaryColor: iconColor,
            size: "small"
        }),
        appearance: "subtle",
        theme: iccButtonTheme,
        shouldFitContainer: true,
        onClick: onClick,
        isDisabled: isDisabled,
        testId: "platform-inline-card-create.ui.trigger.visible.button",
        "aria-labelledby": ariaLabelledBy
    }, isSticky ? renderStickyContent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cezcv.default), null, label));
};
const $effb20d6e7753ccf$var$labelContextStyles = (0, $1ZAYh.xcss)({
    display: 'block',
    textAlign: 'left',
    textOverflow: 'ellipsis',
    overflowX: 'hidden'
});
var $effb20d6e7753ccf$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($effb20d6e7753ccf$export$305831e851c35a16);

});
parcelRegister("cezcv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1f6485230187ee4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8cU5f = parcelRequire("8cU5f");
const $f1f6485230187ee4$var$Label = ({ children: children })=>{
    // naive solution to check whether the text is too long and might be truncated with ellipsis
    const shouldShowTooltip = children.length > 16;
    return shouldShowTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: children,
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f1f6485230187ee4$var$Content, null, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f1f6485230187ee4$var$Content, null, children);
};
var $f1f6485230187ee4$export$2e2bcd8739ae039 = $f1f6485230187ee4$var$Label;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f1f6485230187ee4$var$Content = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _y3gn1e5h _1bto1l2s _1reo15vq",
            __cmplp.className
        ])
    });
});

});








parcelRegister("83T52", function(module, exports) {

$parcel$export(module.exports, "useIsEligibleForConfigInContextIssueTypes", () => $aa4c8fe4314b3c45$export$b403eafbcef4a3de);

var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");

var $7kNqR = parcelRequire("7kNqR");
const $aa4c8fe4314b3c45$export$b403eafbcef4a3de = ()=>{
    const isCompanyManaged = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getIsCompanyManaged));
    const canEditBoard = (0, $1gQ73.useBacklogSelector)((0, $7kNqR.canEditBoardConfig));
    return !isCompanyManaged && canEditBoard;
};

});

parcelRegister("2B8YX", function(module, exports) {

$parcel$export(module.exports, "InlineCardCreateWithIssueTypesInContext", () => $8aa25377f778e1f5$export$b5df998697757072);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $3WdG4 = parcelRequire("3WdG4");
var $6cR1a = parcelRequire("6cR1a");

var $79xbN = parcelRequire("79xbN");

var $cwaqP = parcelRequire("cwaqP");

var $4UslI = parcelRequire("4UslI");

var $7TyGu = parcelRequire("7TyGu");

var $1gQ73 = parcelRequire("1gQ73");

var $jiL2Q = parcelRequire("jiL2Q");

var $hkGxG = parcelRequire("hkGxG");

var $6ncr6 = parcelRequire("6ncr6");

var $7kNqR = parcelRequire("7kNqR");
const $8aa25377f778e1f5$export$ee45d518b25c373a = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const isCompanyManaged = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getIsCompanyManaged));
    const manageIssueTypesLink = (0, $1gQ73.useBacklogSelector)((state)=>{
        if ((0, $7kNqR.canEditBoardConfig)(state)) return (0, $6ncr6.manageIssueTypesSelector)(state);
        return null;
    });
    const manageIssueTypeOption = (0, $6cR1a.useManageIssueTypeOption)(manageIssueTypesLink);
    const handleNewIssueTypeCreate = ()=>{
        // handle refresh/dispatch
        dispatch((0, $jiL2Q.refreshDataRequest)((0, $7TyGu.REFRESH_SOURCE_ADD_ISSUE_TYPE_MODAL)));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8aa25377f778e1f5$var$TypeSelectWrapper, {
        shouldShowChevron: isCompanyManaged
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3WdG4.TypeSelectWithAddIssueTypeModal), {
        ...props,
        ref: ref,
        onNewIssueTypeCreated: handleNewIssueTypeCreate,
        extraOptions: manageIssueTypeOption ?? undefined
    }));
});
const $8aa25377f778e1f5$var$InlineCardCreateWithIssueTypesInContextVariant = ({ isEligibleInContextIssueTypesExperiment: isEligibleInContextIssueTypesExperiment, ...props })=>{
    const [{ isActive: isModalOpen }] = (0, $4UslI.useAddIssueTypeContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwaqP.default), {
        ...props,
        // Issue type in Context Experiment
        shouldKeepFormOpenOnClickOutside: isModalOpen,
        TypeSelect: $8aa25377f778e1f5$export$ee45d518b25c373a,
        isEligibleInContextIssueTypesExperiment: isEligibleInContextIssueTypesExperiment
    });
};
const $8aa25377f778e1f5$export$b5df998697757072 = (props)=>{
    // Variant cohort
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_config_in_context_issue_types_m2');
    if (expConfig.get('inlineIssueTypeConfigEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8aa25377f778e1f5$var$InlineCardCreateWithIssueTypesInContextVariant, {
        ...props,
        isEligibleInContextIssueTypesExperiment: true
    });
    // Control cohort
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwaqP.default), {
        ...props,
        isEligibleInContextIssueTypesExperiment: true
    });
};
// NOTE: copy from src/packages/software/backlog/src/view/card-list/inline-card-create/index.tsx
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8aa25377f778e1f5$var$TypeSelectWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldShowChevron: shouldShowChevron, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1kl7oyrj",
            __cmplp.shouldShowChevron ? "_18u01jfw" : "_18u0v47k",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3WdG4", function(module, exports) {

$parcel$export(module.exports, "TypeSelectWithAddIssueTypeModal", () => $cabe010c62db734f$export$136082c885cd8768);

var $eUqFw = parcelRequire("eUqFw");

var $gO9Xw = parcelRequire("gO9Xw");

var $0cdA8 = parcelRequire("0cdA8");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4UslI = parcelRequire("4UslI");

var $hnvmL = parcelRequire("hnvmL");


var $9R3Yu = parcelRequire("9R3Yu");

var $74ZxO = parcelRequire("74ZxO");

var $8lnj6 = parcelRequire("8lnj6");
const $cabe010c62db734f$var$TypeSelectWithAddIssueTypeModalInner = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ onNewIssueTypeCreated: onNewIssueTypeCreated, cardTypes: cardTypes, extraOptions: extraOptions, onSelectCardType: onSelectCardType, ...typeSelectProps }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [_, { openAddIssueTypeModal: openAddIssueTypeModal }] = (0, $4UslI.useAddIssueTypeContext)();
    const [{ isAddIssueTypeDisabled: isAddIssueTypeDisabled }] = (0, $hnvmL.useIssueTypesNavigationItems)();
    const [newTypeId, setNewTypeId] = (0, $eUqFw.useState)(null);
    const addIssueTypeOption = {
        name: 'createIssueType',
        optionType: 'text',
        label: formatMessage((0, $74ZxO.default).addIssueType),
        value: (0, $a11c29c0fe64353a$export$e0bc602b327f818b),
        onItemSelect: openAddIssueTypeModal,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
            size: "small",
            label: formatMessage((0, $74ZxO.default).addIssueType)
        })
    };
    const handleOnNewIssueTypeCreated = (issueType)=>{
        setNewTypeId(issueType.id);
        onNewIssueTypeCreated?.(issueType);
    };
    const handleOnNewIssueTypeCreatedComplete = ()=>{
        if (newTypeId) {
            onSelectCardType(newTypeId);
            setNewTypeId(null);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9R3Yu.AsyncAddIssueModal), {
        onNewIssueTypeCreated: handleOnNewIssueTypeCreated,
        onNewIssueTypeCreatedComplete: handleOnNewIssueTypeCreatedComplete
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8lnj6.default), {
        ...typeSelectProps,
        cardTypes: cardTypes,
        extraOptions: isAddIssueTypeDisabled ? extraOptions : [
            addIssueTypeOption,
            ...extraOptions ?? []
        ],
        onSelectCardType: onSelectCardType,
        ref: ref
    }));
});
const $cabe010c62db734f$export$136082c885cd8768 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "issueTypeCreatableTypeSelectComponent",
        packageName: "jiraConfigInContextIssueTypes",
        teamName: "jlove-makkuro",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8lnj6.default), {
                ...props,
                ref: ref
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cabe010c62db734f$var$TypeSelectWithAddIssueTypeModalInner, {
        ...props,
        ref: ref
    })));

});
const $a11c29c0fe64353a$export$f9e3e7ede9ba929d = 500;
const $a11c29c0fe64353a$export$e0bc602b327f818b = 'add-issue-type-option';

parcelRegister("9R3Yu", function(module, exports) {

$parcel$export(module.exports, "AsyncAddIssueModal", () => $608457d367bd90a6$export$90930c7e7408e7a6);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $608457d367bd90a6$var$AsyncLazyAddIssueModal = (0, $7rh0R.lazy)(()=>(parcelRequire("5pDM4")).then(({ AddIssueTypeModal: AddIssueTypeModal })=>AddIssueTypeModal), {
    moduleId: "./src/packages/software/config-in-context-issue-types/src/ui/type-select-with-add-issue-type-modal/add-issue-type-modal/index.tsx"
});
const $608457d367bd90a6$export$90930c7e7408e7a6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "in-context-add-issue-type-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($608457d367bd90a6$var$AsyncLazyAddIssueModal, props));

});
parcelRegister("5pDM4", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('azJqa')
        ]);
        const value = parcelRequire('1BTf1');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("azJqa")
    ]).then(()=>parcelRequire('1BTf1'));
}

});


parcelRegister("74ZxO", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd81570ec22c6202$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fd81570ec22c6202$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addIssueType: {
        "id": "config-in-context-issue-types.type-select-with-add-issue-type-modal.add-issue-type",
        "defaultMessage": "Add issue type"
    }
});

});

parcelRegister("8lnj6", function(module, exports) {

$parcel$export(module.exports, "default", () => $00a2cb5e03940f16$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $8blac = parcelRequire("8blac");

var $a0i0f = parcelRequire("a0i0f");

var $7u4fN = parcelRequire("7u4fN");

var $86Ndv = parcelRequire("86Ndv");

var $5xnoX = parcelRequire("5xnoX");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");

var $jQxSL = parcelRequire("jQxSL");
var $l44HT = parcelRequire("l44HT");

var $8cU5f = parcelRequire("8cU5f");

var $79xbN = parcelRequire("79xbN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");


var $8qJEP = parcelRequire("8qJEP");

var $iwoiy = parcelRequire("iwoiy");
const $00a2cb5e03940f16$var$CHEVRON_DOWN = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
    label: ""
});
const $00a2cb5e03940f16$var$CHEVRON_UP = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5xnoX))), {
    label: ""
});
const $00a2cb5e03940f16$var$ANALYTICS_SUBJECT = 'iccTypeSelect';
const $00a2cb5e03940f16$var$Option = ({ children: children, ...props })=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { cardType: cardType, renderAdditionalContent: renderAdditionalContent, icon: icon } = props.data;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        alignItems: "center",
        xcss: $00a2cb5e03940f16$var$optionWrapperStyles,
        testId: "config-in-context-issue-types.ui.type-select-with-add-issue-type-modal.type-select.option"
    }, !!cardType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iwoiy.default), {
        cardType: cardType,
        hasMargin: true
    }), !!icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingInlineEnd: "space.100"
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $00a2cb5e03940f16$var$optionContentStyles
    }, children), !!cardType && !!renderAdditionalContent && renderAdditionalContent(cardType)));
};
const $00a2cb5e03940f16$var$Group = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlockStart: "space.050",
        xcss: $00a2cb5e03940f16$var$extraLinksGroupStyles
    }, children);
const $00a2cb5e03940f16$var$COMPONENTS = {
    Option: $00a2cb5e03940f16$var$Option,
    Group: $00a2cb5e03940f16$var$Group
};
const $00a2cb5e03940f16$var$makeOption = (cardType, renderAdditionalContent)=>({
        label: cardType.name,
        value: cardType.id,
        cardType: cardType,
        optionType: 'card',
        renderAdditionalContent: renderAdditionalContent
    });
const $00a2cb5e03940f16$var$TypeSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ cardTypes: cardTypes, selectedCardTypeId: selectedCardTypeId, extraOptions: extraOptions, shouldRenderToParent: shouldRenderToParent = false, onSelectCardType: onSelectCardType, renderAdditionalOptionContent: renderAdditionalOptionContent, isEligibleInContextIssueTypesExperiment: isEligibleInContextIssueTypesExperiment }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [, fireExperimentExposure] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_config_in_context_issue_types_m2');
    const isDefaultItem = cardTypes[0]?.id === selectedCardTypeId;
    const value = (0, $eUqFw.useMemo)(()=>{
        const selectedType = cardTypes.find((type)=>type.id === selectedCardTypeId);
        return selectedType ? $00a2cb5e03940f16$var$makeOption(selectedType, renderAdditionalOptionContent) : null;
    }, [
        cardTypes,
        selectedCardTypeId,
        renderAdditionalOptionContent
    ]);
    const options = (0, $eUqFw.useMemo)(()=>{
        const results = cardTypes.map((type)=>$00a2cb5e03940f16$var$makeOption(type, renderAdditionalOptionContent));
        // if there are other options already, group the extra links in a new section
        if (extraOptions) {
            if (results.length) results.push({
                options: extraOptions
            });
            else // otherwise add them flat
            results.push(...extraOptions);
        }
        return results;
    }, [
        cardTypes,
        extraOptions,
        renderAdditionalOptionContent
    ]);
    const isOptionDisabled = (0, $eUqFw.useCallback)((option)=>option.optionType === 'card' && option.cardType.isDisabled === true, []);
    const trigger = (0, $eUqFw.useCallback)(({ isOpen: isOpen, ...triggerProps })=>{
        const triggerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: value?.label ?? null,
            delay: (0, $a11c29c0fe64353a$export$f9e3e7ede9ba929d),
            hideTooltipOnClick: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $00a2cb5e03940f16$var$containerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            ...triggerProps,
            appearance: "subtle",
            spacing: "none",
            isSelected: isOpen,
            "aria-label": formatMessage((0, $8qJEP.default).ariaLabel, {
                value: value?.label ?? formatMessage((0, $8qJEP.default).invalid)
            }),
            testId: "config-in-context-issue-types.ui.type-select-with-add-issue-type-modal.type-select.trigger"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
            alignItems: "center",
            xcss: $00a2cb5e03940f16$var$triggerContentStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iwoiy.default), {
            cardType: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(value, 'cardType')
        }), isOpen ? $00a2cb5e03940f16$var$CHEVRON_UP : $00a2cb5e03940f16$var$CHEVRON_DOWN))));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $00a2cb5e03940f16$var$typeContainerStyles
        }, triggerContent);
    }, [
        formatMessage,
        value
    ]);
    const onChange = (0, $eUqFw.useCallback)((option)=>{
        if (option) {
            if ('cardType' in option && option.cardType != null) {
                onSelectCardType(option.cardType.id);
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'selectedType',
                    actionSubject: $00a2cb5e03940f16$var$ANALYTICS_SUBJECT
                }), {
                    issueTypesCount: cardTypes.length,
                    issueTypeId: option.cardType.id
                });
                return;
            }
            if ('onItemSelect' in option && option.onItemSelect) {
                if (option.name) (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'selectedExtraItem',
                    actionSubject: $00a2cb5e03940f16$var$ANALYTICS_SUBJECT
                }), option.name, {
                    issueTypesCount: cardTypes.length
                });
                else (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'selectedExtraItem',
                    actionSubject: $00a2cb5e03940f16$var$ANALYTICS_SUBJECT
                }), {
                    issueTypesCount: cardTypes.length
                });
                option.onItemSelect();
            }
        }
    }, [
        cardTypes.length,
        createAnalyticsEvent,
        onSelectCardType
    ]);
    const onMenuOpen = (0, $eUqFw.useCallback)(()=>{
        if (isEligibleInContextIssueTypesExperiment) fireExperimentExposure();
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'opened',
            actionSubject: $00a2cb5e03940f16$var$ANALYTICS_SUBJECT
        }), {
            isDefaultItem: isDefaultItem
        });
    }, [
        createAnalyticsEvent,
        isDefaultItem,
        isEligibleInContextIssueTypesExperiment,
        fireExperimentExposure
    ]);
    const setRefNode = (0, $eUqFw.useCallback)((popupSelectRef)=>{
        ref && popupSelectRef && (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(ref, 'current.node', popupSelectRef);
    }, [
        ref
    ]);
    if (cardTypes.length === 1 && (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(extraOptions)) {
        const existingCardType = $00a2cb5e03940f16$var$makeOption(cardTypes[0], renderAdditionalOptionContent);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: existingCardType.label,
            delay: (0, $a11c29c0fe64353a$export$f9e3e7ede9ba929d)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: [
                $00a2cb5e03940f16$var$containerStyles,
                $00a2cb5e03940f16$var$singValueContainerStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iwoiy.default), {
            cardType: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(existingCardType, 'cardType')
        })));
    }
    // to render popup next to the trigger element to achieve DOM order
    const popupStrategy = shouldRenderToParent ? 'fixed' : 'absolute';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l44HT.default), {
        ref: setRefNode,
        components: $00a2cb5e03940f16$var$COMPONENTS,
        target: trigger,
        options: options,
        isOptionDisabled: isOptionDisabled,
        value: value,
        onChange: onChange,
        onMenuOpen: onMenuOpen,
        isSearchable: false,
        // DSP-2990 - PopupSelect doesn't respect isSearchable, searchThreshold is required
        searchThreshold: Number.MAX_SAFE_INTEGER,
        minMenuWidth: "auto",
        classNamePrefix: "inline-card-create-type-select",
        testId: "config-in-context-issue-types.ui.type-select-with-add-issue-type-modal.type-select",
        popperProps: {
            strategy: popupStrategy
        }
    });
});
// kept here the negative margins from the original dropdown component but ideally these shouldn't exist
const $00a2cb5e03940f16$var$containerStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.negative.050',
    marginRight: 'space.negative.050'
});
const $00a2cb5e03940f16$var$triggerContentStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.050'
});
const $00a2cb5e03940f16$var$typeContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    flexShrink: 0
});
const $00a2cb5e03940f16$var$optionWrapperStyles = (0, $1ZAYh.xcss)({
    padding: 'space.100'
});
const $00a2cb5e03940f16$var$extraLinksGroupStyles = (0, $1ZAYh.xcss)({
    borderTopWidth: '2px',
    borderTopStyle: 'solid',
    borderTopColor: 'color.border',
    marginTop: 'space.050'
});
const $00a2cb5e03940f16$var$optionContentStyles = (0, $1ZAYh.xcss)({
    flex: 1
});
const $00a2cb5e03940f16$var$singValueContainerStyles = (0, $1ZAYh.xcss)({
    display: 'inline-flex',
    alignItems: 'center',
    padding: 'space.050'
});
var $00a2cb5e03940f16$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($00a2cb5e03940f16$var$TypeSelect);

});
parcelRegister("8qJEP", function(module, exports) {

$parcel$export(module.exports, "default", () => $b065d86b4c174d45$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b065d86b4c174d45$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    ariaLabel: {
        "id": "config-in-context-issue-types.type-select-with-add-issue-type-modal.type-select.aria-label",
        "defaultMessage": "The current issue type is {value}. Press the 'Space' key to change the issue type."
    },
    invalid: {
        "id": "config-in-context-issue-types.type-select-with-add-issue-type-modal.type-select.invalid",
        "defaultMessage": "invalid"
    }
});

});

parcelRegister("iwoiy", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa40f5da249e64f8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");
const $aa40f5da249e64f8$export$9fbe3594a958ae08 = '/icons/issuetypes/genericissue.svg';
const $aa40f5da249e64f8$var$cardTypeImageStyles = null;
const $aa40f5da249e64f8$var$hasMarginStyles = null;
const $aa40f5da249e64f8$var$TypeIcon = ({ cardType: cardType, hasMargin: hasMargin })=>cardType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        alt: cardType.name,
        src: cardType.iconUrl,
        className: (0, $7JEyt.default)([
            "_4t3i7vkz _1bsb7vkz",
            hasMargin && "_2hwxu2gc"
        ])
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        alt: "",
        src: $aa40f5da249e64f8$export$9fbe3594a958ae08,
        className: (0, $7JEyt.default)([
            "_4t3i7vkz _1bsb7vkz",
            hasMargin && "_2hwxu2gc"
        ])
    });
var $aa40f5da249e64f8$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($aa40f5da249e64f8$var$TypeIcon);

});



parcelRegister("6cR1a", function(module, exports) {

$parcel$export(module.exports, "useManageIssueTypeOption", () => $01b9d932a1e0ba9a$export$e413d47d1b5b1e62);

var $eUqFw = parcelRequire("eUqFw");

var $89sIt = parcelRequire("89sIt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kJlBc = parcelRequire("kJlBc");

var $9CHj7 = parcelRequire("9CHj7");
const $01b9d932a1e0ba9a$export$e413d47d1b5b1e62 = (manageIssueTypesLink)=>{
    const { push: push } = (0, $kJlBc.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return manageIssueTypesLink ? [
        {
            label: formatMessage((0, $9CHj7.default).manageIssueTypes),
            value: manageIssueTypesLink,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($89sIt))), {
                size: "small",
                label: formatMessage((0, $9CHj7.default).manageIssueTypes)
            }),
            onItemSelect: ()=>{
                push(manageIssueTypesLink);
            },
            optionType: 'link'
        }
    ] : null;
};

});
parcelRegister("9CHj7", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcf0671c70aa4ed3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fcf0671c70aa4ed3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    manageIssueTypes: {
        "id": "config-in-context-issue-types.common.manage-issue-types",
        "defaultMessage": "Manage issue types"
    }
});

});




parcelRegister("k9j9y", function(module, exports) {

$parcel$export(module.exports, "getActiveElement", () => $59bb8e9fc1c1a860$export$cd4e5573fbe2b576);
/**
 * This is here to make testing easier.
 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $59bb8e9fc1c1a860$export$cd4e5573fbe2b576 = ()=>document.activeElement;

});



parcelRegister("jP33o", function(module, exports) {

$parcel$export(module.exports, "useRenderFullItem", () => $23be70bc301018ba$export$f774065b6ff9b006);

var $eUqFw = parcelRequire("eUqFw");
/**
 * Version of requestIdleCallback with fallback to setTimeout of 200ms.
 */ const $23be70bc301018ba$var$scheduleIdle = (cb)=>{
    if (typeof requestIdleCallback === 'undefined') {
        const timer = setTimeout(cb, 200);
        return ()=>{
            clearTimeout(timer);
        };
    }
    const idleCallback = requestIdleCallback(cb);
    return ()=>{
        cancelIdleCallback(idleCallback);
    };
};
const $23be70bc301018ba$export$f774065b6ff9b006 = ({ isVisible: isVisible, isScrolling: isScrolling })=>{
    const [renderFullCard, setRenderFullCard] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (isScrolling) return undefined;
        if (isVisible) {
            setRenderFullCard(true);
            return undefined;
        }
        return $23be70bc301018ba$var$scheduleIdle(()=>{
            setRenderFullCard(true);
        });
    }, [
        isScrolling,
        isVisible
    ]);
    return renderFullCard;
};

});


parcelRegister("4GaSP", function(module, exports) {

$parcel$export(module.exports, "CardGroup", () => $c45eaa556b007a49$export$9acc0474485b44b2);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8MrYx = parcelRequire("8MrYx");

var $9eH8H = parcelRequire("9eH8H");

var $8wXFi = parcelRequire("8wXFi");

var $1gQ73 = parcelRequire("1gQ73");

var $bP7Jx = parcelRequire("bP7Jx");

var $gUTCm = parcelRequire("gUTCm");
function $c45eaa556b007a49$export$9acc0474485b44b2({ cardGroup: { cardIds: cardIds, isAttachedToParent: isAttachedToParent, isCollapsed: isCollapsed }, row: row, isScrolling: isScrolling, cardListId: cardListId, setRichActiveCard: setRichActiveCard }) {
    const isCompactMode = (0, $8MrYx.useShowCompactMode)();
    /**
   * Checking if the card has extra fields set from board configuration
   */ const hasExtraFields = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.hasCardExtraFields));
    /**
   * Checking if the extra fields is off from view settings
   */ const shouldRenderExtraFields = (0, $8MrYx.useHasCardExtraFields)();
    const hasExtraCardHeight = (0, $8wXFi.isViewSettingAsPanelExpEnabledWithNoExposure)() ? shouldRenderExtraFields && hasExtraFields : hasExtraFields;
    let cardRowHeight = isCompactMode ? (0, $9eH8H.COMPACT_CARD_ROW_HEIGHT) : (0, $9eH8H.CARD_ROW_HEIGHT);
    cardRowHeight = hasExtraCardHeight ? cardRowHeight + (0, $9eH8H.EXTRA_CARD_ROW_HEIGHT) : cardRowHeight;
    const content = !isCollapsed ? cardIds.map((cardId, index)=>{
        const cardContainerEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gUTCm.default), {
            row: row,
            isScrolling: isScrolling,
            cardId: cardId,
            cardListId: cardListId,
            isAttachedToParent: isAttachedToParent,
            setRichActiveCard: setRichActiveCard
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c45eaa556b007a49$var$CardWrapper, {
            key: cardId,
            // eslint-disable-next-line jira/react/no-style-attribute
            style: {
                top: index * cardRowHeight
            }
        }, cardContainerEl);
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c45eaa556b007a49$var$CardGroupWrapper, null, content);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c45eaa556b007a49$var$CardGroupWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $c45eaa556b007a49$var$CardWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1bsb1osq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1Xw9l", function(module, exports) {

$parcel$export(module.exports, "CardListCheckbox", () => $0530af869cbe8e81$export$e5861b404a98a88f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bT7k5 = parcelRequire("bT7k5");

var $aZEg1 = parcelRequire("aZEg1");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $1gQ73 = parcelRequire("1gQ73");

var $8YxIx = parcelRequire("8YxIx");

var $1HfeQ = parcelRequire("1HfeQ");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $fYBXo = parcelRequire("fYBXo");

var $esw6l = parcelRequire("esw6l");
const $0530af869cbe8e81$export$3a055e4082f2e2d5 = ()=>(0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getSelectedCards));
const $0530af869cbe8e81$export$2cfb87b4e8fba2a2 = (cardListId)=>(0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.makeOrderedVisibleCardsForCardList)(state)(cardListId));
const $0530af869cbe8e81$export$18cc44b9c48de32 = ()=>(0, $1gQ73.useBacklogSelector)((0, $hkGxG.isCheckboxSelectionMode));
const $0530af869cbe8e81$export$e5861b404a98a88f = ({ cardListId: cardListId, isDisabled: isDisabled })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const selectedCards = $0530af869cbe8e81$export$3a055e4082f2e2d5();
    const selectableCards = $0530af869cbe8e81$export$2cfb87b4e8fba2a2(cardListId);
    const selectionMode = $0530af869cbe8e81$export$18cc44b9c48de32();
    const selectableIssueIds = (0, $eUqFw.useMemo)(()=>selectableCards.map((card)=>card.id), [
        selectableCards
    ]);
    const selectedCardsSet = (0, $eUqFw.useMemo)(()=>new Set(selectedCards), [
        selectedCards
    ]);
    const selectedIssueIds = (0, $eUqFw.useMemo)(()=>selectableIssueIds.filter((id)=>selectedCardsSet.has(id)), [
        selectableIssueIds,
        selectedCardsSet
    ]);
    const extraAnalyticsAttributes = (0, $eUqFw.useMemo)(()=>({
            selectAll: {
                checkbox: {
                    issue_ids: selectableIssueIds,
                    numSelectedCards: selectableIssueIds.length,
                    selectType: 'sprint',
                    isCheckboxChecked: true
                }
            },
            clearAll: {
                checkbox: {
                    issue_ids: [],
                    numSelectedCards: 0,
                    selectType: 'sprint',
                    isCheckboxChecked: false
                }
            }
        }), [
        selectableIssueIds
    ]);
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const onSelectAll = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed',
            actionSubject: 'checkbox'
        });
        dispatch((0, $1HfeQ.cardMultiSelectExtend)(selectableIssueIds));
        dispatch((0, $8YxIx.setCheckboxSelectionMode)(true));
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'bulkSelectCardList', {
            ...extraAnalyticsAttributes.selectAll.checkbox
        });
    }, [
        createAnalyticsEvent,
        dispatch,
        extraAnalyticsAttributes.selectAll.checkbox,
        selectableIssueIds
    ]);
    const onClearAll = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed',
            actionSubject: 'checkbox'
        });
        dispatch((0, $1HfeQ.cardMultiRemove)(selectedIssueIds));
        if (selectedCards.length === selectedIssueIds.length) dispatch((0, $8YxIx.setCheckboxSelectionMode)(false));
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'bulkSelectCardList', {
            ...extraAnalyticsAttributes.clearAll.checkbox
        });
    }, [
        createAnalyticsEvent,
        dispatch,
        extraAnalyticsAttributes.clearAll.checkbox,
        selectedCards.length,
        selectedIssueIds
    ]);
    const checkboxState = (0, $eUqFw.useMemo)(()=>(0, $esw6l.getCardListCheckboxState)({
            selectedIssueIds: selectedIssueIds,
            selectableIssueIds: selectableIssueIds,
            selectionMode: selectionMode
        }), [
        selectedIssueIds,
        selectableIssueIds,
        selectionMode
    ]);
    const onCheckboxClick = (0, $eUqFw.useCallback)((event)=>{
        event.stopPropagation();
        if (checkboxState === (0, $aZEg1.CheckboxState).CHECKED) onClearAll();
        else if (checkboxState === (0, $aZEg1.CheckboxState).UNCHECKED || checkboxState === (0, $aZEg1.CheckboxState).INDETERMINATE) onSelectAll();
    }, [
        checkboxState,
        onClearAll,
        onSelectAll
    ]);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const getLabel = (0, $eUqFw.useMemo)(()=>{
        if (checkboxState === (0, $aZEg1.CheckboxState).CHECKED) return formatMessage((0, $fYBXo.messages).deselectCheckboxLabel);
        return formatMessage((0, $fYBXo.messages).selectCheckboxLabel);
    }, [
        checkboxState,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0530af869cbe8e81$var$StyledCardListCheckbox, {
        "data-testid": "software-backlog.card-list.cardlist-checkbox.checkbox"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        onClick: onCheckboxClick,
        isChecked: checkboxState === (0, $aZEg1.CheckboxState).CHECKED || checkboxState === (0, $aZEg1.CheckboxState).INDETERMINATE,
        isIndeterminate: checkboxState === (0, $aZEg1.CheckboxState).INDETERMINATE,
        isDisabled: isDisabled || selectableIssueIds.length === 0,
        "aria-label": getLabel,
        "aria-disabled": isDisabled || selectableIssueIds.length === 0
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0530af869cbe8e81$var$StyledCardListCheckbox = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19bvu2gc _1bsbgktf _19itoyrj",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aZEg1", function(module, exports) {

$parcel$export(module.exports, "CheckboxState", () => $c74cb778935ea06a$export$10d1ecb0f8412c60);
const $c74cb778935ea06a$export$10d1ecb0f8412c60 = {
    CHECKED: 'checked',
    UNCHECKED: 'unchecked',
    INDETERMINATE: 'indeterminate'
};

});

parcelRegister("fYBXo", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c4a2c5ad9977c9c5$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $c4a2c5ad9977c9c5$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    deselectCheckboxLabel: {
        "id": "backlog.card-list.cardlist-checkbox.deselect-checkbox-label",
        "defaultMessage": "Deselect all issues in sprint"
    },
    selectCheckboxLabel: {
        "id": "backlog.card-list.cardlist-checkbox.select-checkbox-label",
        "defaultMessage": "Select all issues in sprint"
    }
});

});

parcelRegister("esw6l", function(module, exports) {

$parcel$export(module.exports, "getCardListCheckboxState", () => $c396ff4e96669c9c$export$ff0019101ecd17c9);

var $aZEg1 = parcelRequire("aZEg1");
const $c396ff4e96669c9c$export$ff0019101ecd17c9 = ({ selectedIssueIds: selectedIssueIds, selectableIssueIds: selectableIssueIds, selectionMode: selectionMode })=>{
    const selectedSelectableIssueIds = selectableIssueIds.filter((id)=>selectedIssueIds.includes(id));
    if (selectableIssueIds.length === selectedSelectableIssueIds.length && selectedSelectableIssueIds.length > 0 && selectionMode) return (0, $aZEg1.CheckboxState).CHECKED;
    if (selectedIssueIds.length > 0) {
        if (selectedIssueIds.length === 1) {
            if (selectionMode) return (0, $aZEg1.CheckboxState).INDETERMINATE;
            return (0, $aZEg1.CheckboxState).UNCHECKED;
        }
        return (0, $aZEg1.CheckboxState).INDETERMINATE;
    }
    return (0, $aZEg1.CheckboxState).UNCHECKED;
};

});


parcelRegister("cwkw0", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a5a9f49312192c7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Okns = parcelRequire("5Okns");
var $3jYzf = parcelRequire("3jYzf");
var $fiOXn = parcelRequire("fiOXn");

var $lojb8 = parcelRequire("lojb8");

var $6j4bv = parcelRequire("6j4bv");

var $l3Qg0 = parcelRequire("l3Qg0");

var $3q7Yq = parcelRequire("3q7Yq");

var $1ybV0 = parcelRequire("1ybV0");

var $huI7r = parcelRequire("huI7r");

var $bNe1g = parcelRequire("bNe1g");

var $fEWmm = parcelRequire("fEWmm");

var $dOL7m = parcelRequire("dOL7m");

var $ieUWD = parcelRequire("ieUWD");

var $dWLk9 = parcelRequire("dWLk9");


var $7TyGu = parcelRequire("7TyGu");

var $gPQCf = parcelRequire("gPQCf");

var $1gQ73 = parcelRequire("1gQ73");

var $jiL2Q = parcelRequire("jiL2Q");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");
const $9a5a9f49312192c7$var$CompleteSprintButton = ({ children: children, sprintId: sprintId, testId: testId, theme: theme })=>{
    const boardId = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getRapidViewId));
    const cloudId = (0, $dWLk9.useCloudId)();
    const { data: project } = (0, $bNe1g.useProjectContext)();
    const jiraProjectAri = (0, $huI7r.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'project',
        resourceId: String(project?.projectId)
    });
    const sourceIssueNo = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.cardsSelector)).length;
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const boardIdAri = (0, $huI7r.createAri)({
        cloudId: cloudId,
        resourceId: String(boardId),
        resourceOwner: 'jira-software',
        resourceType: 'board'
    });
    const sprintIdAri = (0, $huI7r.createAri)({
        cloudId: cloudId,
        resourceId: sprintId,
        resourceOwner: 'jira-software',
        resourceType: 'sprint'
    });
    const isCompanyManaged = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getIsCompanyManaged));
    const showRetrosModal = (0, $lojb8.useShowCreateRetroOrCrossSellModal)();
    const onCompleted = (0, $eUqFw.useCallback)(()=>{
        dispatch((0, $jiL2Q.refreshDataRequest)((0, $7TyGu.REFRESH_SOURCE_SPRINT_COMPLETE)));
        (0, $ieUWD.triggerResourceCacheInvalidation)((0, $c22b1ee1fcd49c4a$export$dedbdcc35e955187), 'COMPLETE_SPRINT_MODAL_COMPLETE');
        showRetrosModal();
    }, [
        dispatch,
        showRetrosModal
    ]);
    const entryPointParams = (0, $eUqFw.useMemo)(()=>({
            jiraProjectAri: jiraProjectAri,
            // Date of 12 weeks ago as we want to fetch deployments date updated at most 12 weeks ago for deployments report nudge on sprint completion
            updatedFromDeploymentsDate: (0, $5Okns.default)((0, $3jYzf.default)((0, $fiOXn.default)(Date.now(), {
                weeks: 12
            }))),
            boardId: boardIdAri,
            activeSprintIds: [
                sprintIdAri
            ],
            isCompanyManaged: isCompanyManaged
        }), [
        jiraProjectAri,
        boardIdAri,
        sprintIdAri,
        isCompanyManaged
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject, stopMetric: stopMetric } = (0, $6j4bv.useEntryPoint)((0, $fEWmm.completeSprintModalEntryPoint), entryPointParams, (0, $gPQCf.completeSprintModalLoad));
    const entryPointTriggerRef = (0, $l3Qg0.useEntryPointButtonTrigger)(entryPointActions);
    const confluenceRetrosAvailable = (0, $1ybV0.ff)('sprint-retros-company-managed') ? true : !isCompanyManaged;
    const props = (0, $eUqFw.useMemo)(()=>({
            analyticsSource: 'software-backlog',
            boardId: boardIdAri,
            onCompleted: onCompleted,
            sourceIssueNo: sourceIssueNo,
            sprintId: sprintId,
            onReady: stopMetric,
            confluenceRetrosAvailable: confluenceRetrosAvailable,
            isCompanyManaged: isCompanyManaged
        }), [
        boardIdAri,
        onCompleted,
        sourceIssueNo,
        sprintId,
        stopMetric,
        isCompanyManaged,
        confluenceRetrosAvailable
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dOL7m.ModalTriggerButton), {
        ref: entryPointTriggerRef,
        theme: theme,
        testId: testId
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3q7Yq.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "complete-sprint-modal",
        teamName: "a4t-pandora",
        packageName: (0, $e1409a6fc345c0d8$export$dfd208682d29484c),
        entryPointActions: entryPointActions,
        runtimeProps: props
    }));
};
var $9a5a9f49312192c7$export$2e2bcd8739ae039 = $9a5a9f49312192c7$var$CompleteSprintButton;

});
parcelRegister("lojb8", function(module, exports) {

$parcel$export(module.exports, "useShowCreateRetroOrCrossSellModal", () => $5d6ecdaf6e26806f$export$3918442dc3bc3c6b);

var $eUqFw = parcelRequire("eUqFw");

var $9Hi6E = parcelRequire("9Hi6E");

var $j3FUN = parcelRequire("j3FUN");

var $hgMcg = parcelRequire("hgMcg");

var $6L3Px = parcelRequire("6L3Px");
const $5d6ecdaf6e26806f$export$3918442dc3bc3c6b = ()=>{
    const isCrossflowFFEnabled = (0, $hgMcg.isCompleteSprintCrossFlowEnabled)();
    const isCrossjoinFFEnabled = (0, $hgMcg.isCompleteSprintCrossJoinEnabled)();
    const [retrosState, retrosActions] = (0, $6L3Px.useRetros)();
    const licensedProducts = (0, $j3FUN.useLicensedProducts)();
    const { hasAccess: hasAccess } = (0, $9Hi6E.useUserHasConfluenceAccess)();
    return (0, $eUqFw.useCallback)(()=>{
        if (!retrosState.shouldCreateRetro) return;
        let action = retrosActions.setLoadCreateRetroModal;
        if (isCrossflowFFEnabled && isCrossjoinFFEnabled) {
            if (!licensedProducts.confluence) action = retrosActions.setLoadCrossFlowModal;
            else if (!hasAccess) action = retrosActions.setLoadCrossJoinModal;
        } else if (isCrossflowFFEnabled && !licensedProducts.confluence) action = retrosActions.setLoadCrossFlowModal;
        else if (isCrossjoinFFEnabled && licensedProducts.confluence && !hasAccess) action = retrosActions.setLoadCrossJoinModal;
        action(true);
    }, [
        isCrossflowFFEnabled,
        isCrossjoinFFEnabled,
        licensedProducts,
        hasAccess,
        retrosState.shouldCreateRetro,
        retrosActions
    ]);
};

});
parcelRegister("9Hi6E", function(module, exports) {

$parcel$export(module.exports, "useUserHasConfluenceAccess", () => $bdf8426cb8b155be$export$bddce71054147149);

var $eUqFw = parcelRequire("eUqFw");

var $89bO2 = parcelRequire("89bO2");

var $3555e = parcelRequire("3555e");

var $guiFP = parcelRequire("guiFP");

var $gd0Sp = parcelRequire("gd0Sp");

var $cGCxH = parcelRequire("cGCxH");

var $cj5H0 = parcelRequire("cj5H0");

var $3qF4w = parcelRequire("3qF4w");

var $e4oen = parcelRequire("e4oen");
const $bdf8426cb8b155be$var$TIME_TO_LIVE = 3600000; // 1 hr
const $bdf8426cb8b155be$var$storage = (0, $89bO2.createSessionStorageProvider)((0, $cGCxH.CONFLUENCE_ACCESS_STORAGE_PROVIDER_KEY));
const $bdf8426cb8b155be$export$bddce71054147149 = (embeddedConfluenceSource, skip = false)=>{
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const fireAnalyticsEvent = (0, $e4oen.useEmbeddedPageTracking)();
    const tenantHasConfluence = (0, $3555e.useTenantHasConfluence)();
    const [hasAccess, setHasAccess] = (0, $eUqFw.useState)(false);
    const permitted = (0, $eUqFw.useMemo)(()=>(0, $3qF4w.getSessionStorageData)((0, $cGCxH.CONFLUENCE_ACCESS_STORAGE_KEY), $bdf8426cb8b155be$var$storage)?.permitted, []);
    const getConfluencePermissions = (0, $eUqFw.useCallback)(async ()=>{
        try {
            const response = tenantHasConfluence ? await (0, $cj5H0.fetchConfluenceUserPermissions)(cloudId) : {
                permitted: false
            };
            fireAnalyticsEvent({
                action: 'success',
                eventName: 'userConfluenceAccess',
                embeddedConfluenceSource: embeddedConfluenceSource
            });
            (0, $3qF4w.setSessionStorageData)({
                key: (0, $cGCxH.CONFLUENCE_ACCESS_STORAGE_KEY),
                value: response,
                ttl: $bdf8426cb8b155be$var$TIME_TO_LIVE,
                storage: $bdf8426cb8b155be$var$storage
            });
            setHasAccess(response?.permitted);
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'userConfluenceAccess',
                    teamName: 'confluence-better-together'
                },
                attributes: {
                    embeddedConfluenceSource: embeddedConfluenceSource
                },
                error: new Error(`Failed to get user confluence access status: ${error}`)
            });
        }
    }, [
        cloudId,
        embeddedConfluenceSource,
        fireAnalyticsEvent,
        tenantHasConfluence
    ]);
    const refetchHasAccess = (0, $eUqFw.useCallback)(async ()=>{
        (0, $3qF4w.setSessionStorageData)({
            key: (0, $cGCxH.CONFLUENCE_ACCESS_STORAGE_KEY),
            value: {},
            ttl: $bdf8426cb8b155be$var$TIME_TO_LIVE,
            storage: $bdf8426cb8b155be$var$storage
        });
        await getConfluencePermissions();
    }, [
        getConfluencePermissions
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (skip) return;
        if (!(0, $3qF4w.getSessionStorageData)((0, $cGCxH.CONFLUENCE_ACCESS_STORAGE_KEY), $bdf8426cb8b155be$var$storage)) (0, $3qF4w.setSessionStorageData)({
            key: (0, $cGCxH.CONFLUENCE_ACCESS_STORAGE_KEY),
            value: {},
            ttl: $bdf8426cb8b155be$var$TIME_TO_LIVE,
            storage: $bdf8426cb8b155be$var$storage
        });
        if (!(0, $3qF4w.isStorageKeyExpired)((0, $cGCxH.CONFLUENCE_ACCESS_STORAGE_KEY), $bdf8426cb8b155be$var$storage) && permitted !== undefined) setHasAccess(permitted);
        else if (cloudId) getConfluencePermissions();
    }, [
        cloudId,
        embeddedConfluenceSource,
        fireAnalyticsEvent,
        getConfluencePermissions,
        permitted,
        skip
    ]);
    return {
        hasAccess: hasAccess,
        refetchHasAccess: refetchHasAccess
    };
};

});
parcelRegister("3555e", function(module, exports) {

$parcel$export(module.exports, "useTenantHasConfluence", () => $583c95185f8eb6cc$export$964fe2dd9242a588);

var $e91YZ = parcelRequire("e91YZ");

var $j3FUN = parcelRequire("j3FUN");
const $583c95185f8eb6cc$export$964fe2dd9242a588 = ()=>{
    const licensedProducts = (0, $j3FUN.useLicensedProducts)();
    return Boolean(licensedProducts[(0, $e91YZ.LICENSED_PRODUCTS).CONFLUENCE]);
};

});

parcelRegister("cGCxH", function(module, exports) {

$parcel$export(module.exports, "ConfluenceFeatureKeys", () => $8c4704bc755a9560$export$746d4746bf07dd70);
$parcel$export(module.exports, "CONFLUENCE_CONTROLS_STORAGE_KEY", () => $8c4704bc755a9560$export$6247c7e19b71f4e);
$parcel$export(module.exports, "CONFLUENCE_ACCESS_STORAGE_KEY", () => $8c4704bc755a9560$export$e34c4c923d934e7a);
$parcel$export(module.exports, "CONFLUENCE_CONTROLS_STORAGE_PROVIDER_KEY", () => $8c4704bc755a9560$export$ffe60197eb59ca73);
$parcel$export(module.exports, "CONFLUENCE_ACCESS_STORAGE_PROVIDER_KEY", () => $8c4704bc755a9560$export$8d0c4a26241944b8);
const $8c4704bc755a9560$export$746d4746bf07dd70 = {
    ENABLE_CONFLUENCE_SIGNUP: 'jira.admin.confluence.enable-integrations',
    SPRINT_RETRO: 'jira.admin.confluence.enable-sprint-retros',
    CREATE_MENU_TOP_ACTIONS: 'jira.admin.confluence.enable-content-creation-issue-top-actions',
    CREATE_MENU_CONFLUENCE_CONTENT: 'jira.admin.confluence.enable-content-creation-issue-confluence-content'
};
const $8c4704bc755a9560$export$6247c7e19b71f4e = 'confluence-integration-controls';
const $8c4704bc755a9560$export$e34c4c923d934e7a = 'user-confluence-access';
const $8c4704bc755a9560$export$ffe60197eb59ca73 = 'confluence-integration-controls-session-storage';
const $8c4704bc755a9560$export$8d0c4a26241944b8 = 'confluence-permissions-session-storage';

});

parcelRegister("cj5H0", function(module, exports) {

$parcel$export(module.exports, "fetchConfluenceUserPermissions", () => $9735c9c605819bed$export$e1aee708fe0c56c2);

var $2OdyW = parcelRequire("2OdyW");
const $9735c9c605819bed$export$e1aee708fe0c56c2 = async (cloudId)=>{
    const response = await (0, $2OdyW.default)('/gateway/api/permissions/permitted', {
        method: 'POST',
        body: JSON.stringify({
            resourceId: `ari:cloud:confluence::site/${cloudId}`,
            permissionId: 'write'
        }),
        headers: {
            Accept: 'application/json'
        }
    });
    return response;
};

});

parcelRegister("3qF4w", function(module, exports) {

$parcel$export(module.exports, "getSessionStorageData", () => $9b853a0c5a3b3d2d$export$af84d82ff1eea56d);
$parcel$export(module.exports, "setSessionStorageData", () => $9b853a0c5a3b3d2d$export$be8cb7c8f1a1db6b);
$parcel$export(module.exports, "isStorageKeyExpired", () => $9b853a0c5a3b3d2d$export$59dd918a314efec0);
$parcel$export(module.exports, "clearSessionStorageData", () => $9b853a0c5a3b3d2d$export$47001de47bd4a961);
const $9b853a0c5a3b3d2d$var$createTTLTimestamp = (ttl)=>Date.now() + ttl;
const $9b853a0c5a3b3d2d$export$af84d82ff1eea56d = (key, storage)=>storage.get(key);
const $9b853a0c5a3b3d2d$export$be8cb7c8f1a1db6b = ({ key: key, value: value, ttl: ttl, storage: storage })=>{
    const expiresAt = $9b853a0c5a3b3d2d$var$createTTLTimestamp(ttl);
    storage.set(key, {
        ...value,
        expiresAt: expiresAt
    });
};
const $9b853a0c5a3b3d2d$export$59dd918a314efec0 = (key, storage)=>{
    if (!$9b853a0c5a3b3d2d$export$af84d82ff1eea56d(key, storage)) return true;
    const expiresAt = $9b853a0c5a3b3d2d$export$af84d82ff1eea56d(key, storage)?.expiresAt;
    return expiresAt ? new Date().getTime() >= expiresAt : true;
};
const $9b853a0c5a3b3d2d$export$47001de47bd4a961 = (key, storage)=>storage.remove(key);

});

parcelRegister("e4oen", function(module, exports) {

$parcel$export(module.exports, "useEmbeddedPageTracking", () => $563833caf662c029$export$9fcd107e4ed1de75);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $hJ992 = parcelRequire("hJ992");

var $bFzGY = parcelRequire("bFzGY");

var $gd0Sp = parcelRequire("gd0Sp");

var $5DqQW = parcelRequire("5DqQW");
const $563833caf662c029$var$getParentProduct = (projectType)=>{
    switch(projectType){
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return 'JSM';
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            return 'JSW';
        case 0, $7ZZxN.CORE_PROJECT:
            return 'JWM';
        default:
            return 'JSW';
    }
};
const $563833caf662c029$export$9fcd107e4ed1de75 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const source = (0, $hJ992.useAnalyticsSource)();
    const trackEmbeddedConfluence = (0, $eUqFw.useCallback)(({ eventName: eventName, action: action, actionSubject: actionSubject, projectType: projectType, embeddedConfluenceSource: embeddedConfluenceSource = 'jiraIssueView', eventType: eventType = 'ui', userHasConfluenceAccess: userHasConfluenceAccess, tenantHasConfluence: tenantHasConfluence, crossJoinStatus: crossJoinStatus, originProduct: originProduct, requestedProduct: requestedProduct })=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject ?? `${eventName}`
        });
        const attributes = {
            parentProduct: $563833caf662c029$var$getParentProduct(projectType),
            tenantEditions: tenantContext?.appEditions,
            productEntitlementDetails: tenantContext?.productEntitlementDetails,
            embeddedConfluenceSource: embeddedConfluenceSource,
            jiraIssueSurfaceArea: source,
            userHasConfluenceAccess: userHasConfluenceAccess,
            tenantHasConfluence: tenantHasConfluence,
            crossJoinStatus: crossJoinStatus,
            originProduct: originProduct,
            requestedProduct: requestedProduct
        };
        (0, $5DqQW.fireEmbeddedConfluenceAnalytics)({
            analyticsEvent: analyticsEvent,
            attributes: attributes,
            eventType: eventType,
            eventName: `${actionSubject ?? eventName} ${action}`
        });
    }, [
        source,
        tenantContext,
        createAnalyticsEvent
    ]);
    return trackEmbeddedConfluence;
};

});
parcelRegister("5DqQW", function(module, exports) {

$parcel$export(module.exports, "fireEmbeddedConfluenceAnalytics", () => $731065451fcf0853$export$864bc2da9014e8e9);

var $jMP2a = parcelRequire("jMP2a");
const $731065451fcf0853$export$864bc2da9014e8e9 = ({ analyticsEvent: analyticsEvent, attributes: attributes, eventType: eventType, eventName: eventName })=>{
    switch(eventType){
        case 'ui':
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, attributes);
            break;
        case 'operational':
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, `${eventName}`, attributes);
            break;
        case 'track':
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, `${eventName}`, attributes);
            break;
        default:
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, attributes);
            break;
    }
};

});



parcelRegister("hgMcg", function(module, exports) {

$parcel$export(module.exports, "isCompleteSprintCrossFlowEnabled", () => $bcf40ae7a5eb36bd$export$85fbb2a414949eea);
$parcel$export(module.exports, "fireCompleteSprintCrossFlowExposureEventWhenEnrolled", () => $bcf40ae7a5eb36bd$export$f304ef0c9d0114d6);
$parcel$export(module.exports, "isCompleteSprintCrossJoinEnabled", () => $bcf40ae7a5eb36bd$export$80ecf97fd1ddd003);
$parcel$export(module.exports, "fireCompleteSprintCrossJoinExposureEventWhenEnrolled", () => $bcf40ae7a5eb36bd$export$4c5f2c8aff3c3599);

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $jMP2a = parcelRequire("jMP2a");
const $bcf40ae7a5eb36bd$export$69932781b42dd805 = 'jsw_sprint_completion_retro_cross_flow';
const $bcf40ae7a5eb36bd$export$6ae71ceef72281af = 'conf_jira_sprint_completion_cross_join_exp';
const $bcf40ae7a5eb36bd$export$3d370c33621572df = 'cohort';
const $bcf40ae7a5eb36bd$export$8ea6555e3e46f620 = 'not-enrolled';
const $bcf40ae7a5eb36bd$export$e9cae393a0b9eb85 = 'experiment';
const $bcf40ae7a5eb36bd$export$b3ba2b75eab4739d = 'control';
const $bcf40ae7a5eb36bd$export$85fbb2a414949eea = ()=>{
    const [completeSprintCrossFlowConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_sprint_completion_retro_cross_flow');
    return (0, $1ybV0.ff)('sprint-completion-cross-flow') && completeSprintCrossFlowConfig.get($bcf40ae7a5eb36bd$export$3d370c33621572df, $bcf40ae7a5eb36bd$export$8ea6555e3e46f620) === $bcf40ae7a5eb36bd$export$e9cae393a0b9eb85;
};
const $bcf40ae7a5eb36bd$export$f304ef0c9d0114d6 = (createAnalyticsEvent)=>{
    const [completeSprintCrossFlowConfig, completeSprintCrossFlowFireExposure] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_sprint_completion_retro_cross_flow');
    const completeSprintCrossFlowExperimentValue = completeSprintCrossFlowConfig.get($bcf40ae7a5eb36bd$export$3d370c33621572df, $bcf40ae7a5eb36bd$export$8ea6555e3e46f620);
    if ((0, $1ybV0.ff)('sprint-completion-cross-flow') && completeSprintCrossFlowExperimentValue !== $bcf40ae7a5eb36bd$export$8ea6555e3e46f620) {
        completeSprintCrossFlowFireExposure();
        // manually fire for Socrates
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', {
            flagKey: $bcf40ae7a5eb36bd$export$69932781b42dd805,
            value: completeSprintCrossFlowExperimentValue,
            growthInitiative: 'cross-flow'
        });
    }
};
const $bcf40ae7a5eb36bd$export$80ecf97fd1ddd003 = ()=>{
    const [completeSprintCrossJoinConfig] = (0, $79xbN.UNSAFE_noExposureExp)('conf_jira_sprint_completion_cross_join_exp');
    return (0, $1ybV0.ff)('sprint-completion-cross-join') && completeSprintCrossJoinConfig.get($bcf40ae7a5eb36bd$export$3d370c33621572df, $bcf40ae7a5eb36bd$export$8ea6555e3e46f620) === $bcf40ae7a5eb36bd$export$e9cae393a0b9eb85;
};
const $bcf40ae7a5eb36bd$export$4c5f2c8aff3c3599 = (createAnalyticsEvent)=>{
    const [completeSprintCrossJoinConfig, completeSprintCrossJoinFireExposure] = (0, $79xbN.UNSAFE_noExposureExp)('conf_jira_sprint_completion_cross_join_exp');
    const completeSprintCrossJoinExperimentValue = completeSprintCrossJoinConfig.get($bcf40ae7a5eb36bd$export$3d370c33621572df, $bcf40ae7a5eb36bd$export$8ea6555e3e46f620);
    if ((0, $1ybV0.ff)('sprint-completion-cross-join') && completeSprintCrossJoinExperimentValue !== $bcf40ae7a5eb36bd$export$8ea6555e3e46f620) {
        completeSprintCrossJoinFireExposure();
        // manually fire for Socrates
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', {
            flagKey: $bcf40ae7a5eb36bd$export$6ae71ceef72281af,
            value: completeSprintCrossJoinExperimentValue,
            growthInitiative: 'cross-join'
        });
    }
};

});

parcelRegister("6L3Px", function(module, exports) {

$parcel$export(module.exports, "useRetros", () => $d99acce870636278$export$70e27f56232e4ea8);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $4YWJn = parcelRequire("4YWJn");

var $6uCyF = parcelRequire("6uCyF");

var $l4vu1 = parcelRequire("l4vu1");
const $d99acce870636278$var$Store = (0, $a61MH.createStore)({
    initialState: $6uCyF.initialState,
    actions: $4YWJn.default,
    name: 'create-retros'
});
const $d99acce870636278$export$70e27f56232e4ea8 = (0, $ggKAj.createHook)($d99acce870636278$var$Store);

});
parcelRegister("4YWJn", function(module, exports) {

$parcel$export(module.exports, "default", () => $52d920a66896495e$export$2e2bcd8739ae039);

var $1c8hB = parcelRequire("1c8hB");

var $jtsd5 = parcelRequire("jtsd5");

var $4ZYEI = parcelRequire("4ZYEI");

var $7byHA = parcelRequire("7byHA");

var $lNgIW = parcelRequire("lNgIW");
var $a4GhS = parcelRequire("a4GhS");

var $6uCyF = parcelRequire("6uCyF");
const $52d920a66896495e$var$resetState = ()=>({ setState: setState })=>{
        setState((0, $6uCyF.initialState));
    };
const $52d920a66896495e$var$resetCreatedData = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            createRetroPage: (0, $6uCyF.initialState).createRetroPage,
            createWhiteboard: (0, $6uCyF.initialState).createWhiteboard
        });
    };
const $52d920a66896495e$var$setSprintId = (sprintId)=>({ setState: setState })=>{
        setState({
            sprintId: sprintId
        });
    };
const $52d920a66896495e$var$setShouldCreateRetro = (shouldCreateRetro)=>({ setState: setState })=>{
        setState({
            shouldCreateRetro: shouldCreateRetro
        });
    };
const $52d920a66896495e$var$setLoadCreateRetroModal = (loadCreateRetroModal)=>({ setState: setState })=>{
        setState({
            loadCreateRetroModal: loadCreateRetroModal
        });
    };
const $52d920a66896495e$var$setLoadCrossFlowModal = (loadCrossFlowModal)=>({ setState: setState })=>{
        setState({
            loadCrossFlowModal: loadCrossFlowModal
        });
    };
const $52d920a66896495e$var$setLoadCrossJoinModal = (loadCrossJoinModal)=>({ setState: setState })=>{
        setState({
            loadCrossJoinModal: loadCrossJoinModal
        });
    };
const $52d920a66896495e$var$setIsRetroLinked = (isRetroLinked)=>({ setState: setState })=>{
        setState({
            isRetroLinked: isRetroLinked
        });
    };
const $52d920a66896495e$var$setIsRetroLinking = (isRetroLinking)=>({ setState: setState })=>{
        setState({
            isRetroLinking: isRetroLinking
        });
    };
const $52d920a66896495e$var$setRetroLinkingError = (retroLinkingError)=>({ setState: setState })=>{
        setState({
            retroLinkingError: retroLinkingError
        });
    };
const $52d920a66896495e$var$setIsRetroPublished = (isRetroPublished)=>({ setState: setState })=>{
        setState({
            isRetroPublished: isRetroPublished
        });
    };
const $52d920a66896495e$var$setConfluenceData = (data)=>({ getState: getState, setState: setState })=>{
        const { confluenceData: confluenceData } = getState();
        setState({
            confluenceData: {
                ...confluenceData,
                ...data
            }
        });
    };
const $52d920a66896495e$var$setRetroType = (retroType)=>({ setState: setState })=>{
        setState({
            retroType: retroType
        });
    };
const $52d920a66896495e$var$createRetroPage = (cloudId, spaceKey, parentPageId, sprintId)=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            createRetroPage: {
                ...state.createRetroPage,
                loading: true,
                error: undefined
            }
        });
        try {
            const retroPage = await (0, $lNgIW.createRetro)(cloudId, spaceKey, parentPageId, sprintId);
            setState({
                createRetroPage: {
                    ...state.createRetroPage,
                    loading: false,
                    data: retroPage
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                createRetroPage: {
                    ...state.createRetroPage,
                    loading: false,
                    error: error
                }
            });
        }
    };
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $52d920a66896495e$var$isConfluenceWhiteboardsError = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($jtsd5)))(error) && (0, (/*@__PURE__*/$parcel$interopDefault($1c8hB)))(error.errors) && // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error.errors.every((e)=>(0, (/*@__PURE__*/$parcel$interopDefault($jtsd5)))(e) && (0, (/*@__PURE__*/$parcel$interopDefault($4ZYEI)))(e.title) && (0, (/*@__PURE__*/$parcel$interopDefault($4ZYEI)))(e.code));
const $52d920a66896495e$var$isConfluenceWhiteboardsDisabled = async (error)=>{
    if (!(error instanceof (0, $7byHA.default) && error.originalResponse)) return false;
    const errorResponse = await error.originalResponse.json();
    // Check for title until more specific error code is available (CBT-3079)
    return $52d920a66896495e$var$isConfluenceWhiteboardsError(errorResponse) && errorResponse.errors[0].title === 'Whiteboards are not enabled';
};
const $52d920a66896495e$var$createRetroWhiteboard = (cloudId, spaceId, parentId, templateKey)=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            createWhiteboard: {
                ...state.createWhiteboard,
                loading: true,
                error: undefined
            }
        });
        try {
            const whiteboard = await (0, $a4GhS.createWhiteboard)(cloudId, spaceId, parentId, templateKey);
            setState({
                createWhiteboard: {
                    ...state.createWhiteboard,
                    loading: false,
                    data: whiteboard
                }
            });
        } catch (error) {
            setState({
                isWhiteboardsDisabled: state.isWhiteboardsDisabled || await $52d920a66896495e$var$isConfluenceWhiteboardsDisabled(error),
                createWhiteboard: {
                    ...state.createWhiteboard,
                    loading: false,
                    error: error instanceof Error ? error : undefined
                }
            });
        }
    };
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$52d920a66896495e$export$2e2bcd8739ae039 = {
    resetState: $52d920a66896495e$var$resetState,
    resetCreatedData: $52d920a66896495e$var$resetCreatedData,
    setSprintId: $52d920a66896495e$var$setSprintId,
    setShouldCreateRetro: $52d920a66896495e$var$setShouldCreateRetro,
    setLoadCreateRetroModal: $52d920a66896495e$var$setLoadCreateRetroModal,
    setLoadCrossFlowModal: $52d920a66896495e$var$setLoadCrossFlowModal,
    setLoadCrossJoinModal: $52d920a66896495e$var$setLoadCrossJoinModal,
    setIsRetroLinked: $52d920a66896495e$var$setIsRetroLinked,
    setIsRetroLinking: $52d920a66896495e$var$setIsRetroLinking,
    setRetroLinkingError: $52d920a66896495e$var$setRetroLinkingError,
    setIsRetroPublished: $52d920a66896495e$var$setIsRetroPublished,
    setConfluenceData: $52d920a66896495e$var$setConfluenceData,
    createRetroPage: $52d920a66896495e$var$createRetroPage,
    setRetroType: $52d920a66896495e$var$setRetroType,
    createRetroWhiteboard: $52d920a66896495e$var$createRetroWhiteboard
};

});
parcelRegister("4ZYEI", function(module, exports) {

var $2OY5s = parcelRequire("2OY5s");

var $1c8hB = parcelRequire("1c8hB");

var $hYEMs = parcelRequire("hYEMs");
/** `Object#toString` result references. */ var $3a3be8dd1917bddc$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $3a3be8dd1917bddc$var$isString(value) {
    return typeof value == 'string' || !$1c8hB(value) && $hYEMs(value) && $2OY5s(value) == $3a3be8dd1917bddc$var$stringTag;
}
module.exports = $3a3be8dd1917bddc$var$isString;

});

parcelRegister("lNgIW", function(module, exports) {

$parcel$export(module.exports, "createRetro", () => $cb91fbfdddcf3497$export$a63913da797715a6);

var $2OdyW = parcelRequire("2OdyW");

var $7qaff = parcelRequire("7qaff");

var $663xM = parcelRequire("663xM");
const $cb91fbfdddcf3497$export$48a96ef844462313 = 'com.atlassian.confluence.plugins.confluence-software-blueprints:retrospectives-blueprint';
const $cb91fbfdddcf3497$export$a63913da797715a6 = async (cloudId, spaceKey, parentPageId, sprintId)=>{
    const [sprint, blueprint] = await Promise.all([
        (0, $7qaff.getSprint)(sprintId),
        (0, $663xM.getBlueprint)(cloudId, spaceKey, $cb91fbfdddcf3497$export$48a96ef844462313)
    ]);
    const title = `Retrospective: ${sprint.name}`;
    return (0, $2OdyW.default)(`/gateway/api/ex/confluence/${cloudId}/wiki/rest/create-dialog/1.0/content/blueprint/${$cb91fbfdddcf3497$export$48a96ef844462313}/instance`, {
        method: 'POST',
        body: JSON.stringify({
            content: {
                type: 'page',
                title: title,
                status: 'draft',
                ancestors: parentPageId ? [
                    {
                        id: parentPageId
                    }
                ] : undefined,
                space: {
                    key: spaceKey
                },
                // these values are required to create an NCS page
                metadata: {
                    properties: {
                        editor: {
                            value: 'v2'
                        }
                    },
                    frontend: {
                        embedded: true
                    }
                }
            },
            contentBlueprintSpec: {
                context: {
                    spaceKey: spaceKey,
                    parentPageId: parentPageId
                },
                blueprintId: blueprint.contentBlueprintId
            }
        })
    });
};

});
parcelRegister("7qaff", function(module, exports) {

$parcel$export(module.exports, "getSprint", () => $8d1d94820b39a8d2$export$4402d4ed26f26131);

var $2OdyW = parcelRequire("2OdyW");
const $8d1d94820b39a8d2$export$4402d4ed26f26131 = async (sprintId)=>(0, $2OdyW.default)(`/rest/agile/1.0/sprint/${sprintId}`);

});

parcelRegister("663xM", function(module, exports) {

$parcel$export(module.exports, "getBlueprint", () => $a9a64b3d063e82a7$export$ebbc6f9d15c71fb0);

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");
const $a9a64b3d063e82a7$export$ebbc6f9d15c71fb0 = async (cloudId, spaceKey, blueprintModuleCompleteKey)=>{
    let blueprints;
    const url = `/gateway/api/ex/confluence/${cloudId}/wiki/rest/create-dialog/1.0/blueprints/web-items?spaceKey=${spaceKey}`;
    try {
        blueprints = await (0, $2OdyW.default)(url);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'createRetroGetBlueprint',
                packageName: 'jiraConfluenceSprintRetros',
                teamName: 'mdt-zora'
            },
            error: error || `Unknown error calling getBlueprint for space: ${spaceKey}`
        });
        throw error || new Error(`Error calling ${url}`);
    }
    const found = blueprints.find((blueprint)=>blueprint.blueprintModuleCompleteKey === blueprintModuleCompleteKey);
    if (!found) throw new Error(`Fetching blueprints succeeded, but blueprint: ${blueprintModuleCompleteKey} was not found for space: ${spaceKey}`);
    return found;
};

});


parcelRegister("a4GhS", function(module, exports) {

$parcel$export(module.exports, "createWhiteboard", () => $f714467bfaa86d99$export$36ce0aac6b5c6804);

var $2OdyW = parcelRequire("2OdyW");
const $f714467bfaa86d99$export$36ce0aac6b5c6804 = async (cloudId, spaceId, parentId, templateKey)=>(0, $2OdyW.default)(`/gateway/api/ex/confluence/${cloudId}/wiki/api/v2/whiteboards`, {
        method: 'POST',
        body: JSON.stringify({
            spaceId: spaceId,
            parentId: parentId || null,
            templateKey: templateKey
        })
    });

});

parcelRegister("6uCyF", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $57ba44f5814ebbbf$export$d4c72bab9d6cc13a);

var $l4vu1 = parcelRequire("l4vu1");
const $57ba44f5814ebbbf$export$d4c72bab9d6cc13a = {
    sprintId: undefined,
    shouldCreateRetro: false,
    loadCreateRetroModal: false,
    loadCrossFlowModal: false,
    loadCrossJoinModal: false,
    isRetroLinked: false,
    isRetroLinking: false,
    isRetroPublished: false,
    isWhiteboardsDisabled: false,
    retroLinkingError: undefined,
    retroType: (0, $l4vu1.RetroTypes).WHITEBOARD,
    confluenceData: {
        spaceKey: undefined,
        parentPageId: undefined,
        spaceId: undefined
    },
    createRetroPage: {
        data: undefined,
        loading: false,
        error: undefined
    },
    createWhiteboard: {
        data: undefined,
        loading: false,
        error: undefined
    }
};

});
parcelRegister("l4vu1", function(module, exports) {

$parcel$export(module.exports, "RetroTypes", () => $100be1fda33be58a$export$1da38a077679bab0);
const $100be1fda33be58a$export$1da38a077679bab0 = {
    WHITEBOARD: 'whiteboard',
    PAGE: 'page'
};

});





parcelRegister("fEWmm", function(module, exports) {

$parcel$export(module.exports, "completeSprintModalEntryPoint", () => $f77ed86709f3aae5$export$e19f219885fe8c5f);

var $8qdmE = parcelRequire("8qdmE");

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $f77ed86709f3aae5$export$e19f219885fe8c5f = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("a2IKE")), {
        moduleId: "3d417b0d"
    }),
    getPreloadProps: ({ jiraProjectAri: jiraProjectAri, updatedFromDeploymentsDate: updatedFromDeploymentsDate, boardId: boardId, activeSprintIds: activeSprintIds })=>({
            queries: {
                completeSprintMetadata: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $8qdmE.default,
                    variables: {
                        jiraProjectAri: jiraProjectAri,
                        updatedFromDeploymentsDate: updatedFromDeploymentsDate,
                        boardId: boardId,
                        activeSprintIds: activeSprintIds
                    }
                }
            }
        })
});

});
parcelRegister("8qdmE", function(module, exports) {

$parcel$export(module.exports, "default", () => $f83f0d0d0de3f8bf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6fa8139ab68de2adaf65c8eae3998ecd>>
 * @relayHash ea4312ab52f27e8938047934d2f94d9a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7136bf3a8b621191f5688b40ac28c430f5e6237f2ebcb6fea7a09680f67dff05
const $f83f0d0d0de3f8bf$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "7136bf3a8b621191f5688b40ac28c430f5e6237f2ebcb6fea7a09680f67dff05",
        "metadata": {},
        "name": "mainCompleteSprintMetadataQuery",
        "operationKind": "query",
        "text": null
    }
};
var $f83f0d0d0de3f8bf$export$2e2bcd8739ae039 = $f83f0d0d0de3f8bf$var$node;

});

parcelRegister("a2IKE", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('1mAd2')
        ]);
        const value = parcelRequire('dq5eZ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("1mAd2")
    ]).then(()=>parcelRequire('dq5eZ'));
}

});



const $69f6afc4ea1d7f49$export$483ac6106791f695 = 'software-backlog.card-list.left-side';
const $69f6afc4ea1d7f49$export$54c7326f7173c649 = 'software-backlog.card-list.column-limit';

parcelRegister("heWc5", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b3c0d7b40bb73bd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $2ziLQ = parcelRequire("2ziLQ");

var $PdmhA = parcelRequire("PdmhA");

var $ck0PM = parcelRequire("ck0PM");

var $iALTu = parcelRequire("iALTu");

var $kvqJ6 = parcelRequire("kvqJ6");
const $7b3c0d7b40bb73bd$var$GRABBER_SELECTOR = 'software-backlog-divider-grabber';
const $7b3c0d7b40bb73bd$var$GRABBER_LINE_SELECTOR = 'software-backlog-divider-grabber-line';
const $7b3c0d7b40bb73bd$var$DividerContents = /*#__PURE__*/ (0, $eUqFw.memo)(({ id: id })=>{
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7b3c0d7b40bb73bd$var$GrabberContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7b3c0d7b40bb73bd$var$GrabberLine, {
        "data-component-selector": $7b3c0d7b40bb73bd$var$GRABBER_LINE_SELECTOR
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7b3c0d7b40bb73bd$var$Grabber, {
        "data-component-selector": $7b3c0d7b40bb73bd$var$GRABBER_SELECTOR
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: (0, $iALTu.GrabberIcon),
        size: "small",
        primaryColor: `var(--ds-icon-subtle, ${(0, $PdmhA).N90})`,
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7b3c0d7b40bb73bd$var$GrabberContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7b3c0d7b40bb73bd$var$GrabberLine, {
        "data-component-selector": $7b3c0d7b40bb73bd$var$GRABBER_LINE_SELECTOR
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ck0PM.DividerStatistics), {
        dividerCardListId: id
    })));
    const containerRef = (0, $eUqFw.useRef)(null);
    const { dragPreview: dragPreview } = (0, $kvqJ6.useDraggableDivider)({
        elementRef: containerRef,
        cardListId: id
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7b3c0d7b40bb73bd$var$Container, {
        ref: containerRef,
        "data-testid": "software-backlog.card-list.divider.container",
        "aria-hidden": "true"
    }, content), dragPreview);
});
function $7b3c0d7b40bb73bd$export$2e2bcd8739ae039(props) {
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7b3c0d7b40bb73bd$var$DividerContents, {
        id: props.id
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, content);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7b3c0d7b40bb73bd$var$GrabberLine = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _16jlkb7n _4t3iidpf _tzy4idpf _n7zldwhu _v564m7ou",
            __cmplp.className
        ])
    });
});
const $7b3c0d7b40bb73bd$var$Grabber = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _4t3i7vkz _1bsb7vkz _tzy4txnc _v564m7ou _80om776v",
            __cmplp.className
        ])
    });
});
const $7b3c0d7b40bb73bd$var$GrabberContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _i0dlidpf _16jlkb7n _4cvr1h6o _zulpu2gc _bfhk18uv",
            __cmplp.className
        ])
    });
});
const $7b3c0d7b40bb73bd$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3izwfg _1e0c1txw _2lx2vrvc _4cvr1h6o _1bah1h6o _zulpu2gc _otyr1no3 _1yt4119w _16jlkb7n _1ov1kb7n _1minkb7n _10n8kb7n _1us6kb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iALTu", function(module, exports) {

$parcel$export(module.exports, "GrabberIcon", () => $af7ab6272b149b4e$export$1154891bc70a7bd);

var $eUqFw = parcelRequire("eUqFw");
const $af7ab6272b149b4e$export$1154891bc70a7bd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "18px",
        height: "20px",
        viewBox: "0 0 18 20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        transform: "translate(-3.000000, -2.000000)",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        transform: "translate(3.000000, 2.000000)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "0",
        y: "7",
        width: "18",
        height: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "0",
        y: "11",
        width: "18",
        height: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M5.29175912,15.2930586 C4.90274696,15.685137 4.90274696,16.3202641 5.29175912,16.7123425 L8.23085096,19.6779356 C8.44885778,19.8929786 8.73086659,20 9.00987531,20 C9.28888403,20 9.56589268,19.8929786 9.77889934,19.6779356 L12.7089909,16.7223445 C13.097003,16.3302661 13.097003,15.695139 12.7089909,15.3030606 C12.3199787,14.9109822 11.6909591,14.9109822 11.302947,15.3030606 L9.00487515,17.6205241 L6.69780306,15.2930586 C6.50379699,15.0980196 6.24878902,15 5.99478109,15 C5.73977312,15 5.48476515,15.0980196 5.29175912,15.2930586 Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M5.29175912,0.293058612 C4.90274696,0.685137027 4.90274696,1.32026405 5.29175912,1.71234247 L8.23085096,4.67793559 C8.44885778,4.8929786 8.73086659,5 9.00987531,5 C9.28888403,5 9.56589268,4.8929786 9.77889934,4.67793559 L12.7089909,1.72234447 C13.097003,1.33026605 13.097003,0.695139028 12.7089909,0.303060612 C12.3199787,-0.0890178036 11.6909591,-0.0890178036 11.302947,0.303060612 L9.00487515,2.6205241 L6.69780306,0.293058612 C6.50379699,0.0980196039 6.24878902,0 5.99478109,0 C5.73977312,0 5.48476515,0.0980196039 5.29175912,0.293058612 Z",
        transform: "translate(9.000000, 2.500000) rotate(180.000000) translate(-9.000000, -2.500000) "
    })))));

});

parcelRegister("kvqJ6", function(module, exports) {

$parcel$export(module.exports, "useDraggableDivider", () => $736a950232850c9d$export$731cb43729e9cccd);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $2ziLQ = parcelRequire("2ziLQ");

var $eo9PV = parcelRequire("eo9PV");
parcelRequire("bweg7");
var $jfbwa = parcelRequire("jfbwa");

var $PdmhA = parcelRequire("PdmhA");

var $iALTu = parcelRequire("iALTu");
function $736a950232850c9d$export$731cb43729e9cccd({ elementRef: elementRef, cardListId: cardListId }) {
    const [dragState, setDragState] = (0, $eUqFw.useState)({
        type: 'idle'
    });
    (0, $eUqFw.useEffect)(()=>{
        if (!elementRef.current) return undefined;
        return (0, $eo9PV.draggable)({
            element: elementRef.current,
            getInitialData: ()=>({
                    type: 'DIVIDER',
                    cardListId: cardListId
                }),
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                (0, $jfbwa.setCustomNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage,
                    render ({ container: container }) {
                        setDragState({
                            type: 'dragging',
                            container: container
                        });
                        return ()=>setDragState({
                                type: 'idle'
                            });
                    }
                });
            }
        });
    }, [
        cardListId,
        elementRef
    ]);
    return {
        dragPreview: dragState.type === 'dragging' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
            glyph: (0, $iALTu.GrabberIcon),
            size: "small",
            primaryColor: `var(--ds-icon-subtle, ${(0, $PdmhA).N90})`,
            label: ""
        }), dragState.container) : null
    };
}

});


parcelRegister("6AF5y", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbcc8b603810cf58$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $b2nol = parcelRequire("b2nol");

var $1ircG = parcelRequire("1ircG");

var $dtV8v = parcelRequire("dtV8v");

var $j258X = parcelRequire("j258X");

var $7eiE9 = parcelRequire("7eiE9");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$dbcc8b603810cf58$export$2e2bcd8739ae039 = ({ cardListId: cardListId })=>{
    const columns = (0, $1gQ73.useBacklogSelector)((0, $b2nol.getColumns));
    const estimations = (0, $1gQ73.useBacklogSelector)((state)=>columns !== null ? (0, $dtV8v.makeGetSprintEstimations)(state)(cardListId) : null);
    const estimationType = (0, $1gQ73.useBacklogSelector)((0, $1ircG.getEstimationType));
    const timeTrackingOptions = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getTimeTrackingOptions));
    const isCompanyManaged = (0, $j258X.useIsCMPBacklog)();
    const estimationName = (0, $1gQ73.useBacklogSelector)((0, $1ircG.getEstimationName));
    const totalEstimations = estimations ? Object.values(estimations).reduce((a, b)=>a + b, 0) : 0;
    const cardOrder = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getOrderedCardIdsByCardListId));
    const totalCards = cardOrder[cardListId]?.length ?? 0;
    const columnCounts = isCompanyManaged ? (0, $b2nol.getColumnCount)(columns) : undefined;
    const props = {
        estimations: estimations,
        estimationType: estimationType,
        timeTrackingOptions: timeTrackingOptions,
        isCompanyManaged: isCompanyManaged,
        estimationName: estimationName,
        totalEstimations: totalEstimations,
        totalCards: totalCards,
        columnCounts: columnCounts
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eiE9.Estimations), props);
};

});
parcelRegister("7eiE9", function(module, exports) {

$parcel$export(module.exports, "Estimations", () => $41253a0a581bcd92$export$df255ecd06d2abc3);

var $eUqFw = parcelRequire("eUqFw");

var $1Yimi = parcelRequire("1Yimi");

var $PdmhA = parcelRequire("PdmhA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7v0hO = parcelRequire("7v0hO");

var $84CBi = parcelRequire("84CBi");

var $9DRwn = parcelRequire("9DRwn");

var $7TyGu = parcelRequire("7TyGu");


var $3sO37 = parcelRequire("3sO37");

var $01mh5 = parcelRequire("01mh5");
const $41253a0a581bcd92$export$df255ecd06d2abc3 = ({ estimations: estimations, estimationType: estimationType, timeTrackingOptions: timeTrackingOptions, isCompanyManaged: isCompanyManaged, estimationName: estimationName, totalEstimations: totalEstimations, totalCards: totalCards, columnCounts: columnCounts, tooltipDelay: tooltipDelay })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const formatStoryPointsTotal = (0, $9DRwn.useFormatStoryPointsTotal)();
    const formatEstimationValue = (value)=>{
        if (estimationType === (0, $7TyGu.ORIGINAL_ESTIMATE)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $7v0hO.timeTrackingFormatter)(value, timeTrackingOptions, {
            formatMessage: formatMessage
        });
        // fix for floating point math issues (like 0.1 + 0.2 becomes 0.30000000000000004)
        // as the numbers end with lots of zeroes followed by a single digit, trimming
        // after 8 decimal points results in a sane representation
        return formatStoryPointsTotal(value);
    };
    const getTotal = ()=>{
        if (estimationType === (0, $7TyGu.ORIGINAL_ESTIMATE)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $7v0hO.timeTrackingFormatter)(totalEstimations, timeTrackingOptions, {
            formatMessage: formatMessage
        });
        return formatEstimationValue(estimationType === (0, $7TyGu.STORY_POINTS) ? totalEstimations : totalCards);
    };
    const makeStatusWithoutDescription = (statusMessage, estimationFormatted, total, tooltipTarget)=>`${formatMessage(statusMessage)}: ${formatMessage((0, $01mh5.default).tooltip, {
            count: estimationFormatted,
            total: total,
            estimationName: (isCompanyManaged && estimationName && estimationName !== (0, $3bdf9082c480a32b$export$2c9ef5d2c18593f7) ? estimationName : tooltipTarget).toLowerCase()
        })}`;
    const makeTooltipContent = (statusMessage, total, tooltipTarget, estimationCount, statusDescription)=>{
        if (isCompanyManaged) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
            as: "strong",
            color: "color.text.inverse"
        }, formatMessage(statusMessage)), statusDescription ? ` (${formatMessage(statusDescription.statusDescriptionMessage, {
            ...statusDescription.statusDescriptionMessageParams
        })})` : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), formatMessage((0, $01mh5.default).tooltip, {
            count: estimationCount,
            total: total,
            estimationName: (isCompanyManaged && estimationName && estimationName !== (0, $3bdf9082c480a32b$export$2c9ef5d2c18593f7) ? estimationName : tooltipTarget).toLowerCase()
        }));
        return makeStatusWithoutDescription(statusMessage, estimationCount, total, tooltipTarget);
    };
    const makeScreenReaderMessage = (statusMessage, total, tooltipTarget, estimateCount, statusDescription)=>{
        if (isCompanyManaged) return `${formatMessage(statusMessage)}${statusDescription ? ` (${formatMessage(statusDescription.statusDescriptionMessage, {
            ...statusDescription.statusDescriptionMessageParams
        })})` : ''}: ${formatMessage((0, $01mh5.default).tooltip, {
            count: estimateCount,
            total: total,
            estimationName: (isCompanyManaged && estimationName && estimationName !== (0, $3bdf9082c480a32b$export$2c9ef5d2c18593f7) ? estimationName : tooltipTarget).toLowerCase()
        })}`;
        return makeStatusWithoutDescription(statusMessage, estimateCount, total, tooltipTarget);
    };
    const formatEstimation = (estimationValue)=>{
        const value = estimationValue || 0;
        return estimationType === (0, $7TyGu.ORIGINAL_ESTIMATE) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $7v0hO.timeTrackingFormatter)(value, timeTrackingOptions, {
            formatMessage: formatMessage
        }) : formatEstimationValue(value);
    };
    const makeTooltipContentForEstimationGroups = ()=>{
        const { inProgressColumnCount: inProgressColumnCount } = columnCounts || {};
        const showStatusDescriptionForNotStartedAndDone = inProgressColumnCount && inProgressColumnCount > 0;
        const notStarted = {
            status: isCompanyManaged ? (0, $01mh5.default).notStartedV2 : (0, $01mh5.default).notStarted,
            statusDescription: isCompanyManaged && showStatusDescriptionForNotStartedAndDone ? {
                message: (0, $01mh5.default).leftmostColumn
            } : undefined,
            estimationValue: formatEstimation(estimations?.NOT_STARTED)
        };
        const inProgress = {
            status: isCompanyManaged ? (0, $01mh5.default).inProgressV2 : (0, $01mh5.default).inProgress,
            statusDescription: undefined,
            estimationValue: formatEstimation(estimations?.IN_PROGRESS)
        };
        const done = {
            status: isCompanyManaged ? (0, $01mh5.default).completed : (0, $01mh5.default).done,
            statusDescription: isCompanyManaged && showStatusDescriptionForNotStartedAndDone ? {
                message: (0, $01mh5.default).rightmostColumn
            } : undefined,
            estimationValue: formatEstimation(estimations?.DONE)
        };
        const tooltipTypes = Object.freeze({
            [(0, $7TyGu.ORIGINAL_ESTIMATE)]: (0, $01mh5.default).originalEstimate,
            [(0, $7TyGu.STORY_POINTS)]: (0, $01mh5.default).storyPoints,
            [(0, $7TyGu.ISSUE_COUNT)]: (0, $01mh5.default).issueCount
        });
        const tooltipTarget = formatMessage(tooltipTypes[estimationType] || (0, $01mh5.default).issueCount);
        const total = getTotal();
        return {
            notStarted: notStarted,
            inProgress: inProgress,
            done: done,
            tooltipTarget: tooltipTarget,
            total: total
        };
    };
    if (estimations) {
        const { notStarted: notStarted, inProgress: inProgress, done: done, tooltipTarget: tooltipTarget, total: total } = makeTooltipContentForEstimationGroups();
        const { inProgressColumnCount: inProgressColumnCount, doneColumnCount: doneColumnCount } = columnCounts || {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3sO37.default), {
            appearance: "default",
            max: (0, $7TyGu.ESTIMATION_ROLLUP_BADGE_MAX),
            tooltipContent: makeTooltipContent(notStarted.status, total, tooltipTarget, notStarted.estimationValue, notStarted.statusDescription ? {
                statusDescriptionMessage: notStarted.statusDescription.message
            } : undefined),
            tooltipDelay: tooltipDelay,
            screenReaderMessage: makeScreenReaderMessage(notStarted.status, total, tooltipTarget, notStarted.estimationValue, notStarted.statusDescription ? {
                statusDescriptionMessage: notStarted.statusDescription.message
            } : undefined)
        }, formatEstimationValue(estimations.NOT_STARTED)), (inProgressColumnCount && inProgressColumnCount > 0 || !isCompanyManaged) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3sO37.default), {
            // eslint-disable-next-line jira/react/no-style-attribute
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                backgroundColor: `var(--ds-border-information, ${(0, $PdmhA).B400})`
            },
            appearance: "primary",
            max: (0, $7TyGu.ESTIMATION_ROLLUP_BADGE_MAX),
            tooltipContent: makeTooltipContent(inProgress.status, total, tooltipTarget, inProgress.estimationValue, undefined),
            tooltipDelay: tooltipDelay,
            screenReaderMessage: makeScreenReaderMessage(inProgress.status, total, tooltipTarget, inProgress.estimationValue, inProgress.statusDescription)
        }, formatEstimationValue(estimations.IN_PROGRESS)), (doneColumnCount && doneColumnCount === 1 || !isCompanyManaged) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3sO37.default), {
            // eslint-disable-next-line jira/react/no-style-attribute
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                backgroundColor: `var(--ds-border-success, ${(0, $PdmhA).G300})`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                color: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`
            },
            max: (0, $7TyGu.ESTIMATION_ROLLUP_BADGE_MAX),
            tooltipContent: makeTooltipContent(done.status, total, tooltipTarget, done.estimationValue, done.statusDescription ? {
                statusDescriptionMessage: done.statusDescription.message
            } : undefined),
            tooltipDelay: tooltipDelay,
            screenReaderMessage: makeScreenReaderMessage(done.status, total, tooltipTarget, done.estimationValue, done.statusDescription ? {
                statusDescriptionMessage: done.statusDescription.message
            } : undefined)
        }, formatEstimationValue(estimations.DONE)));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $84CBi.default), {
        name: "estimations"
    }, null);
};

});
parcelRegister("3sO37", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b9396cd5e23021d$export$2e2bcd8739ae039);

var $fLbMr = parcelRequire("fLbMr");
var $0b9396cd5e23021d$export$2e2bcd8739ae039 = (0, $fLbMr.default);

});
parcelRegister("fLbMr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0bdc5801775ac4c$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $gtzuR = parcelRequire("gtzuR");

var $9nkwJ = parcelRequire("9nkwJ");

var $8cU5f = parcelRequire("8cU5f");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b0bdc5801775ac4c$export$2e2bcd8739ae039 = ({ appearance: appearance, style: style, children: children, max: max, screenReaderMessage: screenReaderMessage, tooltipContent: tooltipContent, tooltipDelay: tooltipDelay })=>{
    const [active, setActive] = (0, $eUqFw.useState)(false);
    const onFocus = (0, $eUqFw.useCallback)(()=>{
        setActive(true);
    }, []);
    const onBlur = (0, $eUqFw.useCallback)(()=>{
        setActive(false);
    }, []);
    const onKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('enter') || event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('space')) {
            event.preventDefault();
            setActive((prev)=>!prev);
        }
    }, []);
    const tooltipMessage = active ? tooltipContent : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: tooltipMessage,
        delay: tooltipDelay
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b0bdc5801775ac4c$var$EstimationBadgeWrapper, {
        // @ts-expect-error tabIndex should be a number
        tabIndex: "0",
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseLeave: onBlur,
        onMouseEnter: onFocus,
        onKeyDown: onKeyDown,
        "aria-label": screenReaderMessage,
        "data-testid": "software-backlog.card-list.estimations.badge.estimation-badge-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
        appearance: appearance,
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        max: max
    }, children)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0bdc5801775ac4c$var$EstimationBadgeWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01b66 _k48p8n31",
            __cmplp.className
        ])
    });
});

});


parcelRegister("01mh5", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef756c8a92667456$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $ef756c8a92667456$var$messages = (0, $90IgZ.defineMessages)({
    notStarted: {
        "id": "backlog.card-list.estimations.not-started",
        "defaultMessage": "To Do"
    },
    inProgress: {
        "id": "backlog.card-list.estimations.in-progress",
        "defaultMessage": "In Progress"
    },
    done: {
        "id": "backlog.card-list.estimations.done",
        "defaultMessage": "Done"
    },
    notStartedV2: {
        "id": "backlog.card-list.estimations.not-started-v-2",
        "defaultMessage": "Not started"
    },
    inProgressV2: {
        "id": "backlog.card-list.estimations.in-progress-v-2",
        "defaultMessage": "In progress"
    },
    completed: {
        "id": "backlog.card-list.estimations.completed",
        "defaultMessage": "Completed"
    },
    tooltip: {
        "id": "backlog.card-list.estimations.tooltip",
        "defaultMessage": "{count} of {total} ({estimationName})"
    },
    storyPoints: {
        "id": "backlog.card-list.estimations.story-points",
        "defaultMessage": "Story points"
    },
    originalEstimate: {
        "id": "backlog.card-list.estimations.original-estimate",
        "defaultMessage": "Original estimate"
    },
    issueCount: {
        "id": "backlog.card-list.estimations.issue-count",
        "defaultMessage": "Issue count"
    },
    leftmostColumn: {
        "id": "backlog.card-list.estimations.leftmost-column",
        "defaultMessage": "leftmost column"
    },
    rightmostColumn: {
        "id": "backlog.card-list.estimations.rightmost-column",
        "defaultMessage": "rightmost column"
    }
});
var $ef756c8a92667456$export$2e2bcd8739ae039 = $ef756c8a92667456$var$messages;

});



parcelRegister("d016W", function(module, exports) {

$parcel$export(module.exports, "default", () => $79317cc9c50a5a9a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8MrYx = parcelRequire("8MrYx");

var $9eH8H = parcelRequire("9eH8H");

var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $fdVpf = parcelRequire("fdVpf");
const $79317cc9c50a5a9a$var$FastVirtualListContainer = ({ isDropDisabled: isDropDisabled, cardListId: cardListId, emptyList: emptyList, renderCard: renderCard })=>{
    const cardIdWithAboveIccOpen = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getCardIdWithAboveICCOpen));
    const getDefaultRowSize = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.makeGetDefaultRowSize));
    const showCompactMode = (0, $8MrYx.useShowCompactMode)();
    const defaultCardHeight = (0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.getDefaultCardHeight)(state)(showCompactMode));
    const isCmpBacklog = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getIsCompanyManaged));
    const cardEntries = (0, $1gQ73.useBacklogSelector)((state)=>isCmpBacklog ? (0, $bP7Jx.makeOrderedVisibleCardEntries)(state)(cardListId) : (0, $bP7Jx.makeOrderedVisibleCardEntriesOld)(state)(cardListId));
    const cardIds = (0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.makeGetVisibleCardOrderFromCardEntries)(state)(cardListId));
    const visibleCardAmount = (0, $1gQ73.useBacklogSelector)((state)=>false ? (0, $bP7Jx.makeOrderVisibleCardIdsForCardListWithLimit)(state)(cardListId).length : (0, $bP7Jx.makeOrderedVisibleCardIdsForCardList)(state)(cardListId).length);
    const minimumOffset = (0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.makeGetFastVirtualListMinimumOffSetByCardListId)(state)(cardListId));
    const expandedCardGroups = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getExpandedCardGroups));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fdVpf.FastVirtualList), {
        cardIdWithAboveIccOpen: cardIdWithAboveIccOpen,
        cardEntries: cardEntries,
        visibleCardAmount: visibleCardAmount,
        minimumOffset: minimumOffset,
        isDropDisabled: isDropDisabled,
        getDefaultRowSize: getDefaultRowSize,
        defaultCardHeight: defaultCardHeight,
        cardListId: cardListId,
        emptyList: emptyList,
        renderCard: renderCard,
        expandedCardGroups: expandedCardGroups,
        droppableType: (0, $9eH8H.CARD_LIST_DROPPABLE_TYPE),
        cardIds: cardIds
    });
};
var $79317cc9c50a5a9a$export$2e2bcd8739ae039 = $79317cc9c50a5a9a$var$FastVirtualListContainer;

});
parcelRegister("fdVpf", function(module, exports) {

$parcel$export(module.exports, "FastVirtualList", () => $59e2a5b2f2bbd8ce$export$32fc6f03ada9e09e);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $kwce8 = parcelRequire("kwce8");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");
var $4lTFP = parcelRequire("4lTFP");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");

var $2Fdhj = parcelRequire("2Fdhj");
var $5LsVt = parcelRequire("5LsVt");

var $8MrYx = parcelRequire("8MrYx");

var $8wXFi = parcelRequire("8wXFi");

var $3sfdp = parcelRequire("3sfdp");

var $1gQ73 = parcelRequire("1gQ73");

var $2498I = parcelRequire("2498I");

var $ePM9I = parcelRequire("ePM9I");

var $16uJl = parcelRequire("16uJl");

var $hfa5K = parcelRequire("hfa5K");

var $fTaNi = parcelRequire("fTaNi");
const $59e2a5b2f2bbd8ce$export$32fc6f03ada9e09e = ({ cardEntries: cardEntries, renderCard: renderCard, cardIdWithAboveIccOpen: cardIdWithAboveIccOpen, getDefaultRowSize: getDefaultRowSize, defaultCardHeight: defaultCardHeight, cardListId: cardListId, visibleCardAmount: visibleCardAmount, emptyList: emptyList, minimumOffset: minimumOffset, expandedCardGroups: expandedCardGroups, cardIds: cardIds })=>{
    const { ref: listElRef, offsetTop: offsetTop } = (0, $2Fdhj.useElementOffset)({
        initialOffset: minimumOffset
    });
    const cardHeightCache = (0, $16uJl.useCardHeightCache)();
    const isCompact = (0, $8MrYx.useShowCompactMode)();
    const cacheOptions = (0, $eUqFw.useMemo)(()=>({
            cache: cardHeightCache,
            getCacheKey: (index)=>{
                const issueEntry = cardEntries[index];
                if (!issueEntry) return 'none';
                 // If its just 1 extra, we know its the ICC
                if (index === cardEntries.length) return 'ICC';
                if ((0, $3sfdp.isCardEntryGroup)(issueEntry)) return (0, $3sfdp.getCardEntryGroupKey)(issueEntry, cardListId);
                return issueEntry.cardId;
            }
        }), [
        cardEntries,
        cardHeightCache,
        cardListId
    ]);
    const isCardListEmpty = cardEntries.length === 0 || visibleCardAmount === 0;
    (0, $hfa5K.useEmptyCardListDropTarget)({
        elementRef: listElRef,
        isCardListEmpty: isCardListEmpty,
        cardListId: cardListId
    });
    const overscanHeight = (0, $fTaNi.useOverscanHeight)(cardListId, 400);
    const showCardExtraFieldsColumnBasedOnViewSettings = (0, $8wXFi.isViewSettingAsPanelExpEnabledWithNoExposure)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $8MrYx.useHasCardExtraFields)() : true;
    const { rows: rows, totalSize: totalSize, reinitialize: reinitialize, isScrolling: isScrolling, scrollTo: scrollTo } = (0, $5LsVt.useVirtual)({
        rowCount: cardEntries.length,
        overscanHeight: overscanHeight,
        offsetTop: offsetTop,
        cacheOptions: cacheOptions,
        getDefaultRowSize: (index)=>{
            const cardEntry = cardEntries[index];
            const cardId = (0, $3sfdp.isCardEntryGroup)(cardEntry) ? cardEntry?.parentId : cardEntry?.cardId;
            let totalCardsInCardEntry = 1;
            if ((0, $3sfdp.isCardEntryGroup)(cardEntry)) {
                const isCardGroupExpanded = cardEntry.isAttachedToParent === true ? Boolean(expandedCardGroups[cardEntry.parentId]) : true;
                if (isCardGroupExpanded) totalCardsInCardEntry = cardEntry.cardIds.length;
            }
            const height = getDefaultRowSize({
                isInlineCardCreateOpen: cardId === cardIdWithAboveIccOpen,
                numberOfCardsInCardEntry: totalCardsInCardEntry,
                isCompact: isCompact,
                hideExtraFields: !showCardExtraFieldsColumnBasedOnViewSettings
            });
            return height;
        }
    });
    (0, $ePM9I.useAutoScrollCard)(cardEntries, scrollTo);
    (0, $eUqFw.useEffect)(()=>{
        reinitialize(); // ? We need cardIds in here to make sure the card list is recalculated when things change
    // We need `isCompact` as part of dependencies to make sure the card list is recalculated when compact mode is toggled
    }, [
        cardIdWithAboveIccOpen,
        reinitialize,
        cardIds,
        isCompact,
        showCardExtraFieldsColumnBasedOnViewSettings
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        (0, $2Fdhj.runRecalculateSubscribers)();
    }, [
        cardIds,
        isCompact
    ]);
    const isCardDragging = (0, $1gQ73.useBacklogSelector)((0, $2498I.isDragging));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: listElRef,
        "data-test-id": `software-backlog.card-list.id-${cardListId}`,
        "data-testid": `software-backlog.card-list.id-${cardListId}`
    }, isCardListEmpty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($59e2a5b2f2bbd8ce$var$EmptyCardList // eslint-disable-next-line jira/integration/test-id-by-folder-structure
    , {
        "data-test-id": "software-backlog.card-list.empty-card-list",
        "data-testid": "software-backlog.card-list.fast-virtual-list.empty-card-list",
        isDragging: isCardDragging
    }, emptyList) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($59e2a5b2f2bbd8ce$var$ListContainer, {
        hide: !isScrolling || isCardDragging,
        defaultCardHeight: defaultCardHeight,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'relative',
            height: totalSize
        }
    }, rows.map((row)=>{
        const cardEntry = cardEntries[row.index];
        const cardId = (0, $3sfdp.isCardEntryGroup)(cardEntry) ? (0, $3sfdp.getCardEntryGroupKey)(cardEntry, cardListId) : cardEntry?.cardId;
        if (cardId == null) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            key: cardId,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                left: 0,
                top: row.top - offsetTop,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                width: '100%'
            }
        }, renderCard(cardEntry, row, isScrolling));
    })));
};
const $59e2a5b2f2bbd8ce$var$EmptyCardListWrapper = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "div",
        xcss: $59e2a5b2f2bbd8ce$var$emptyCardListWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($59e2a5b2f2bbd8ce$var$EmptyCardListExperiment, props)));
const $59e2a5b2f2bbd8ce$var$emptyCardListWrapperStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.0'
}); /**
     * This is a background for the lists, which is:
     *
     * * White
     * * Has stripes that look like the cards' borders
     *
     * This is to fool people looking at the list to think cards are rendered when
     * they're not. Since it's only using CSS it can always be displayed & should
     * be reasonably efficient.
     *
     * While dragging the background is disabled.
     */ 
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $59e2a5b2f2bbd8ce$var$ListContainerControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1566zr9-0"
})`${({ hide: hide, defaultCardHeight: defaultCardHeight })=>hide ? '' : `
    background-color: ${`var(--ds-surface-raised, ${(0, $PdmhA).N0})`};
    background-image: repeating-linear-gradient(
        180deg,
        ${`var(--ds-background-neutral-hovered, ${(0, $PdmhA).N30})`} 0px,
        ${`var(--ds-surface-raised, ${(0, $PdmhA).N0})`} 1px,
        ${`var(--ds-surface-raised, ${(0, $PdmhA).N0})`} ${defaultCardHeight - 1}px,
        ${`var(--ds-background-neutral-hovered, ${(0, $PdmhA).N30})`} ${defaultCardHeight}px
    );
    box-shadow: inset 0 0 1px 1px ${`var(--ds-border, ${(0, $PdmhA).N30})`};
    `}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $59e2a5b2f2bbd8ce$var$ListContainerExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hide: hide, defaultCardHeight: defaultCardHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_3jsq9m": (0, $9t7rW.default)("repeating-linear-gradient180deg, " + // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `${`var(--ds-background-neutral-hovered, ${(0, $PdmhA).N30})`} 0px, ` + // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `${`var(--ds-surface-raised, ${(0, $PdmhA).N0})`} 1px, ` + // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `${`var(--ds-surface-raised, ${(0, $PdmhA).N0})`} ${__cmplp.defaultCardHeight - 1}px, ` + // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `${`var(--ds-background-neutral-hovered, ${(0, $PdmhA).N30})`} ${__cmplp.defaultCardHeight}px )`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            !__cmplp.hide && "_bfhkhp5a _1itkn3g2 _16qs1ols",
            __cmplp.className
        ])
    });
});
const $59e2a5b2f2bbd8ce$var$ListContainer = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $59e2a5b2f2bbd8ce$var$ListContainerExperiment, $59e2a5b2f2bbd8ce$var$ListContainerControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $59e2a5b2f2bbd8ce$var$EmptyCardListControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1566zr9-1"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        backgroundColor: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        (0, $1ybV0.ff)('jsw-tanuki-fit-and-finish_rhzmf', false) && props.isDragging ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(--ds-background-selected, ${(0, $PdmhA).B50})` : undefined,
        border: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        (0, $1ybV0.ff)('jsw-tanuki-fit-and-finish_rhzmf', false) && props.isDragging ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `2px solid ${`var(--ds-border-selected, ${(0, $PdmhA).B300})`}` : `2px dashed ${"var(--ds-border, #dfe1e6)"}`,
        borderRadius: '3px',
        padding: "var(--ds-space-150, 12px)",
        textAlign: 'center'
    }), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $4lTFP).h100(), {
    fontWeight: 'normal',
    marginTop: "var(--ds-space-0, 0px)"
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $59e2a5b2f2bbd8ce$var$EmptyCardListExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDragging: isDragging, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1l7b _1yt4utpp _y3gn1h6o _k48p4jg8",
            (0, $1ybV0.ff)('jsw-tanuki-fit-and-finish_rhzmf', false) && __cmplp.isDragging && "_bfhk29zg",
            (0, $1ybV0.ff)('jsw-tanuki-fit-and-finish_rhzmf', false) && __cmplp.isDragging ? "_19it5r1b" : "_19it7lsx",
            __cmplp.className
        ])
    });
});
const $59e2a5b2f2bbd8ce$var$EmptyCardList = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $59e2a5b2f2bbd8ce$var$EmptyCardListWrapper, $59e2a5b2f2bbd8ce$var$EmptyCardListControl);

});
parcelRegister("5LsVt", function(module, exports) {

$parcel$export(module.exports, "useVirtual", () => $5c758b02db7cf09a$export$ebc1863da693699a);

var $eUqFw = parcelRequire("eUqFw");

var $8blac = parcelRequire("8blac");

var $ldoFd = parcelRequire("ldoFd");

var $lfAOr = parcelRequire("lfAOr");

var $2U8YO = parcelRequire("2U8YO");

var $dshfj = parcelRequire("dshfj");
const $5c758b02db7cf09a$export$c61d420d8ad72523 = (rowCount, offsetTop, getDefaultRowSize, cacheOptions)=>{
    const states = new Array(rowCount);
    let currentTop = offsetTop;
    for(let i = 0; i < rowCount; i += 1){
        const height = cacheOptions?.cache.get(cacheOptions.getCacheKey(i))?.height ?? getDefaultRowSize(i);
        const result = {
            height: height,
            top: currentTop,
            bottom: currentTop + height
        };
        currentTop = result.bottom;
        states[i] = result;
    }
    return states;
};
const $5c758b02db7cf09a$var$MINIMUM_CARD_HEIGHT = 0.05;
function $5c758b02db7cf09a$export$fd7df3dcf242e12a({ cacheOptions: cacheOptions, index: index, rowStates: rowStates, setRowHeight: setRowHeight, isVisible: isVisible }) {
    const forceRemeasure = (el, withCache = false)=>{
        if (!el) return;
        if (withCache && cacheOptions?.cache?.has(cacheOptions.getCacheKey(index))) return;
        const { height: height } = el.getBoundingClientRect();
        const roundedHeight = Math.round(height * 100) / 100;
        // TODO: React DnD will set row height to 0 on pick-up, that update must be ignored.
        // This is not a clean solution.
        if (roundedHeight > $5c758b02db7cf09a$var$MINIMUM_CARD_HEIGHT && cacheOptions) {
            const cacheKey = cacheOptions.getCacheKey(index);
            if (cacheKey !== undefined) cacheOptions.cache.set(cacheKey, {
                height: height
            });
        }
        if (height != null && height > $5c758b02db7cf09a$var$MINIMUM_CARD_HEIGHT && rowStates[index].height !== height) setRowHeight(index, height);
    };
    return {
        key: index,
        index: index,
        top: rowStates[index].top,
        isVisible: isVisible,
        measure (el) {
            forceRemeasure(el, true);
        },
        forceRemeasure: forceRemeasure
    };
}
function $5c758b02db7cf09a$export$824e0ab10a990d7b({ start: start, end: end, rowStates: rowStates, cacheOptions: cacheOptions, setRowHeight: setRowHeight, startVisible: startVisible, endVisible: endVisible }) {
    if (start === end) return [];
    const numRows = end - start;
    // This code is structured in a way that allows it to be changed into stable indexes and support element recycling.
    const result = new Array(Math.max(numRows, 0));
    for(let offset = 0; offset < numRows; offset += 1){
        const index = start + offset;
        const isVisible = index >= startVisible && index <= endVisible;
        result[offset] = $5c758b02db7cf09a$export$fd7df3dcf242e12a({
            cacheOptions: cacheOptions,
            index: index,
            rowStates: rowStates,
            setRowHeight: setRowHeight,
            isVisible: isVisible
        });
    }
    return result;
}
function $5c758b02db7cf09a$var$useRows(scrollState, rowStates, // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
cacheOptions, setRowHeight, overscanHeight) {
    const { start: start, end: end } = (0, $eUqFw.useMemo)(()=>(0, $lfAOr.getRenderedRange)(scrollState, rowStates, overscanHeight), [
        scrollState,
        rowStates,
        overscanHeight
    ]);
    const { start: startVisible, end: endVisible } = (0, $eUqFw.useMemo)(()=>(0, $lfAOr.getRenderedRange)(scrollState, rowStates, 0), [
        scrollState,
        rowStates
    ]);
    return (0, $eUqFw.useMemo)(()=>$5c758b02db7cf09a$export$824e0ab10a990d7b({
            start: start,
            end: end,
            rowStates: rowStates,
            cacheOptions: cacheOptions,
            setRowHeight: setRowHeight,
            startVisible: startVisible,
            endVisible: endVisible
        }), [
        start,
        end,
        rowStates,
        cacheOptions,
        setRowHeight,
        startVisible,
        endVisible
    ]);
}
function $5c758b02db7cf09a$export$ebc1863da693699a({ rowCount: rowCount, getDefaultRowSize: getDefaultRowSize, offsetTop: offsetTop = 0, overscanHeight: overscanHeight = 0, cacheOptions: cacheOptions, version: version }) {
    const scrollState = (0, $2U8YO.useScrollState)();
    const [rowStates, setRowStates] = (0, $eUqFw.useState)(()=>$5c758b02db7cf09a$export$c61d420d8ad72523(rowCount, offsetTop, getDefaultRowSize, cacheOptions));
    const reinitialize = ()=>setRowStates($5c758b02db7cf09a$export$c61d420d8ad72523(rowCount, offsetTop, getDefaultRowSize, cacheOptions));
    const reinitializeRef = (0, $eUqFw.useRef)(reinitialize);
    reinitializeRef.current = reinitialize;
    const reinitializeCb = (0, $eUqFw.useCallback)(()=>reinitializeRef.current(), []);
    const lastOffsetTop = (0, $eUqFw.useRef)(null);
    const lastVersion = (0, $eUqFw.useRef)(null);
    /**
	 * checking rowCount, offsetTop and version to rebuild the rowStates
	 * if the version is undefined, null or empty string, it will not be used
	 */ const shouldRebuildRowStates = rowCount !== rowStates.length || offsetTop !== lastOffsetTop.current || !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(version) && !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(version) && version !== lastVersion.current;
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (shouldRebuildRowStates) {
            lastVersion.current = version;
            lastOffsetTop.current = offsetTop;
            const states = $5c758b02db7cf09a$export$c61d420d8ad72523(rowCount, offsetTop, getDefaultRowSize, cacheOptions);
            setRowStates(states);
        }
    }, [
        rowStates,
        rowCount,
        offsetTop,
        cacheOptions,
        getDefaultRowSize,
        shouldRebuildRowStates,
        version
    ]);
    const scrollTo = (0, $dshfj.useScrollTo)(rowStates);
    const setRowHeight = (0, $eUqFw.useCallback)((row, height)=>{
        setRowStates((currentRowStates)=>{
            let currentTop = offsetTop;
            return currentRowStates.map((state, index)=>{
                const newState = {
                    ...state
                };
                if (index === row) newState.height = height;
                newState.top = currentTop;
                newState.bottom = currentTop + newState.height;
                currentTop = newState.bottom;
                return newState;
            /* eslint-enable no-param-reassign */ });
        });
    }, [
        offsetTop
    ]);
    const totalSize = (0, $eUqFw.useMemo)(()=>{
        let sum = 0;
        rowStates.forEach(({ height: height })=>{
            sum += height; // This is a float
        });
        // We don't want to end up with a totalSize that is floating point. It results in the
        // ResizeObserver in useElementOffset triggering for pixel changes below 1px
        return Math.ceil(sum);
    }, [
        rowStates
    ]);
    const rows = $5c758b02db7cf09a$var$useRows(scrollState, rowStates, cacheOptions, setRowHeight, overscanHeight);
    return {
        rows: rows,
        scrollTo: scrollTo,
        totalSize: totalSize,
        isScrolling: scrollState.isScrolling,
        reinitialize: reinitializeCb
    };
}

});
parcelRegister("lfAOr", function(module, exports) {

$parcel$export(module.exports, "getRenderedRange", () => $be662863403f013d$export$303e1fc2567e8469);
/**
 * Binary search for the nearest value to a `needle`, given high and low indexes
 * and a `getValue` function to get the value at a certain index.
 */ const $be662863403f013d$export$b961f15adda64c7b = (lowIndexDontRead, highIndexDontRead, getValue, needle)=>{
    // JFE linting doesn't allow changing the arg as a local.
    let low = lowIndexDontRead;
    let high = highIndexDontRead;
    while(low < high){
        const middleIndex = Math.floor((high + low) / 2);
        const candidate = getValue(middleIndex);
        if (candidate > needle) high = middleIndex - 1;
        else if (candidate < needle) low = middleIndex + 1;
        else return middleIndex;
    }
    return low;
};
const $be662863403f013d$export$303e1fc2567e8469 = (viewportRectangle, rowPositions, overscanHeight)=>{
    if (rowPositions.length === 0) return {
        start: 0,
        end: 0
    };
    // Render elements starting at the top edge of the scroll container, minus
    // some overscan height.
    const startPositionTop = viewportRectangle.scrollTop - overscanHeight;
    // And up to elements at the bottom edge of the scroll container, plus some
    // overscan height.
    // NOTE: This needs to default to 0 otherwise it is NaN which means that isAbove is true.
    const endPositionTop = (viewportRectangle?.scrollTop ?? 0) + (viewportRectangle?.height ?? 0) + overscanHeight;
    // If the viewport fully above or under the rows, render nothing
    const isAbove = endPositionTop < rowPositions[0].top;
    const isUnder = startPositionTop > rowPositions[rowPositions.length - 1].bottom;
    if (isAbove || isUnder) return {
        start: 0,
        end: 0
    };
    const startIndex = $be662863403f013d$export$b961f15adda64c7b(0, rowPositions.length, (i)=>rowPositions[i].bottom, startPositionTop);
    let endIndex = startIndex;
    while(endIndex < rowPositions.length && rowPositions[endIndex].top <= endPositionTop)endIndex += 1;
    return {
        start: startIndex,
        end: endIndex
    };
};

});

parcelRegister("dshfj", function(module, exports) {

$parcel$export(module.exports, "useScrollTo", () => $e11dae62e652202e$export$d774db9fe736aa73);

var $eUqFw = parcelRequire("eUqFw");

var $2U8YO = parcelRequire("2U8YO");

var $968qf = parcelRequire("968qf");
const $e11dae62e652202e$export$e1700fccdc2280c5 = 80;
const $e11dae62e652202e$var$SCROLLING_INTERVAL = 50;
const $e11dae62e652202e$var$SCROLLING_ATTEMPT = 5;
const $e11dae62e652202e$export$d774db9fe736aa73 = (rowStates)=>{
    // scrollState CONSTANTLY changes
    // Just grabbing out the scrollElement will hardly change
    const { scrollElement: scrollElement } = (0, $2U8YO.useScrollState)();
    // We do NOT want to regenerate the return function everytime so we should use REFs
    // here instead
    const scrollElementRef = (0, $eUqFw.useRef)(null);
    const rowStatesRef = (0, $eUqFw.useRef)([]);
    (0, $eUqFw.useEffect)(()=>{
        // Only bind to the scrollElementRef once. We don't need it anymore once we have it
        if (scrollElementRef.current === null && scrollElement) scrollElementRef.current = scrollElement;
        // Always ensure our rowStates ref is up to date
        rowStatesRef.current = rowStates ?? rowStatesRef.current;
    }, [
        rowStates,
        scrollElement
    ]);
    const scrollTo = (0, $eUqFw.useCallback)((index, options, attempt = 1)=>{
        let timeoutId = null;
        // Early termination for invalid data
        if (index === -1 || attempt > $e11dae62e652202e$var$SCROLLING_ATTEMPT) {
            options?.onComplete?.();
            return;
        }
        if (rowStatesRef?.current == null || // Can be null on first pass
        scrollElementRef?.current == null || // Can be null on first pass
        index >= rowStatesRef.current.length) {
            timeoutId = window.setTimeout(()=>{
                scrollTo(index, options, attempt + 1);
            }, $e11dae62e652202e$var$SCROLLING_INTERVAL);
            return ()=>{
                timeoutId && clearTimeout(timeoutId);
            };
        }
        const scrollElementEl = scrollElementRef.current;
        const rowState = rowStatesRef.current;
        // Complete scrolling when the target is on screen.
        if ((0, $968qf.hasScrolledIntoView)(scrollElementRef.current, rowStatesRef.current[index])) {
            options?.onComplete?.();
            return;
        }
        const scrollToPosition = (0, $968qf.getScrollToPosition)(scrollElementEl, rowState[index], options);
        if (options?.immediate) scrollElementEl.scrollTop = scrollToPosition;
        else scrollElementEl.scrollTo({
            top: scrollToPosition,
            behavior: 'smooth'
        });
        timeoutId = window.setTimeout(()=>scrollTo(index, options, attempt + 1), $e11dae62e652202e$var$SCROLLING_INTERVAL);
        return ()=>{
            timeoutId && clearTimeout(timeoutId);
        };
    }, [
        scrollElementRef,
        rowStatesRef
    ]);
    return scrollTo;
};

});
parcelRegister("968qf", function(module, exports) {

$parcel$export(module.exports, "hasScrolledIntoView", () => $be0b71ba93ffeca0$export$6ced3bc78dcece56);
$parcel$export(module.exports, "getScrollToPosition", () => $be0b71ba93ffeca0$export$dfe56cb366876f29);
const $be0b71ba93ffeca0$var$VIEWPORT_BUFFER = 50;
const $be0b71ba93ffeca0$export$6ced3bc78dcece56 = (scrollElementEl, rowState)=>{
    if (!scrollElementEl || !rowState) return false;
    const topOfRow = rowState.top;
    const bottomOfRow = rowState.top + rowState.height;
    // Make the viewport a bit smaller so the card won't stick to the edge of the screen
    const topOfView = scrollElementEl.scrollTop + $be0b71ba93ffeca0$var$VIEWPORT_BUFFER;
    const bottomOfView = scrollElementEl.scrollTop + scrollElementEl.clientHeight - $be0b71ba93ffeca0$var$VIEWPORT_BUFFER;
    return topOfRow > topOfView && topOfRow < bottomOfView || bottomOfRow > topOfView && bottomOfRow < bottomOfView || topOfRow < topOfView && bottomOfRow > bottomOfView;
};
const $be0b71ba93ffeca0$export$dfe56cb366876f29 = (scrollElementEl, rowState, options)=>{
    if (!scrollElementEl || !rowState) return 0;
    if (options?.hasVirtualisedChildren) return rowState.top - scrollElementEl.clientHeight;
    return rowState.top + rowState.height / 2 - scrollElementEl.clientHeight / 3;
};

});



parcelRegister("ePM9I", function(module, exports) {

$parcel$export(module.exports, "useAutoScrollCard", () => $00c6394dd1b33d72$export$b61f82894f7693a4);

var $eUqFw = parcelRequire("eUqFw");

var $3sfdp = parcelRequire("3sfdp");

var $1gQ73 = parcelRequire("1gQ73");

var $fB0vk = parcelRequire("fB0vk");

var $bP7Jx = parcelRequire("bP7Jx");
const $00c6394dd1b33d72$export$b61f82894f7693a4 = (cardEntries, scrollTo)=>{
    const autoScroll = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getCardAutoScroll));
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    (0, $eUqFw.useEffect)(()=>{
        const autoScrollCardId = autoScroll?.cardId;
        if (!autoScrollCardId) return;
        // NOTE: Auto scrolling to a subtask may not work as expected
        const cardIndex = cardEntries.findIndex((issueEntry)=>(0, $3sfdp.isCardEntryGroup)(issueEntry) ? issueEntry.cardIds.includes(autoScrollCardId) : issueEntry.cardId === autoScrollCardId);
        if (cardIndex === -1) return;
        return scrollTo(cardIndex, {
            immediate: true,
            onComplete: ()=>dispatch((0, $fB0vk.cardAutoScroll)(null))
        });
    }, [
        autoScroll,
        cardEntries,
        dispatch,
        scrollTo
    ]);
};

});

parcelRegister("16uJl", function(module, exports) {

$parcel$export(module.exports, "useCardHeightCache", () => $4cfdbaa2e379e0ab$export$bd41b84dc563782c);

var $eUqFw = parcelRequire("eUqFw");
const $4cfdbaa2e379e0ab$var$CARD_HEIGHTS_CACHE = new Map();
const $4cfdbaa2e379e0ab$export$bd41b84dc563782c = ()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $4cfdbaa2e379e0ab$var$CARD_HEIGHTS_CACHE;
const $4cfdbaa2e379e0ab$export$201114c49d4ccb5a = ()=>{
    (0, $eUqFw.useEffect)(()=>()=>{
            $4cfdbaa2e379e0ab$var$CARD_HEIGHTS_CACHE.clear();
        }, []);
};

});

parcelRegister("hfa5K", function(module, exports) {

$parcel$export(module.exports, "useEmptyCardListDropTarget", () => $8e79eb93b89bc1ed$export$d05d016cc6925d9c);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("3f2za");
var $jFl9L = parcelRequire("jFl9L");

var $eo9PV = parcelRequire("eo9PV");

var $hKj4G = parcelRequire("hKj4G");

var $1gQ73 = parcelRequire("1gQ73");

var $hzOcT = parcelRequire("hzOcT");

var $8CqRc = parcelRequire("8CqRc");

var $ecfSW = parcelRequire("ecfSW");
function $8e79eb93b89bc1ed$export$d05d016cc6925d9c({ elementRef: elementRef, isCardListEmpty: isCardListEmpty, cardListId: cardListId }) {
    const autobatch = (0, $hKj4G.useAutobatch)();
    const simplyMoveCards = (0, $ecfSW.useSimplyMoveCards)();
    const isAnySelectedOrphanedSubtask = (0, $1gQ73.useBacklogSelector)((0, $8CqRc.makeIsAnySelectedOrphanedSubtasks));
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    (0, $eUqFw.useEffect)(()=>{
        if (!elementRef.current) return undefined;
        return (0, $jFl9L.combine)((0, $eo9PV.dropTargetForElements)({
            element: elementRef.current,
            // Only accept drop events on empty lists. This is because drop events will bubble from the cards
            // when the lists are non-empty. On that case, the card is itself handling move.
            canDrop: ()=>isCardListEmpty && !isAnySelectedOrphanedSubtask,
            onDrop: (args)=>{
                autobatch(()=>{
                    const sourceCardId = Number(args.source.data.cardId);
                    simplyMoveCards({
                        source: {
                            cardId: sourceCardId
                        },
                        location: {
                            type: 'list',
                            targetListId: cardListId
                        }
                    });
                    dispatch((0, $hzOcT.dragEnd)());
                });
            }
        }));
    }, [
        autobatch,
        cardListId,
        elementRef,
        isCardListEmpty,
        simplyMoveCards,
        isAnySelectedOrphanedSubtask,
        dispatch
    ]);
}

});

parcelRegister("fTaNi", function(module, exports) {

$parcel$export(module.exports, "useOverscanHeight", () => $450ed5b2496b972d$export$9af25d9f90686948);

var $eUqFw = parcelRequire("eUqFw");

var $2U8YO = parcelRequire("2U8YO");

var $1gQ73 = parcelRequire("1gQ73");

var $2498I = parcelRequire("2498I");
const $450ed5b2496b972d$export$9af25d9f90686948 = (cardListId, defaultOverscanHeight = 0)=>{
    const { scrollTop: scrollTop } = (0, $2U8YO.useScrollState)();
    const isDraggingSubtask = (0, $1gQ73.useBacklogSelector)((state)=>(0, $2498I.isDragging)(state) && (0, $2498I.getIsSubtaskDrag)(state));
    const isDraggingSourceCardlist = (0, $1gQ73.useBacklogSelector)((state)=>(0, $2498I.getSourceCardListId)(state) === cardListId);
    const scrollTopOnDragStart = (0, $eUqFw.useMemo)(()=>isDraggingSubtask && isDraggingSourceCardlist ? scrollTop : undefined, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isDraggingSubtask,
        isDraggingSourceCardlist
    ]);
    return defaultOverscanHeight + (scrollTopOnDragStart !== undefined ? Math.abs(scrollTop - scrollTopOnDragStart) : 0);
};

});



parcelRegister("3NbPH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d173f2994b145c70$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $kwce8 = parcelRequire("kwce8");

var $PdmhA = parcelRequire("PdmhA");
var $4lTFP = parcelRequire("4lTFP");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $kDODD = parcelRequire("kDODD");

var $c3aPE = parcelRequire("c3aPE");
function $d173f2994b145c70$export$5bf2d993553f05ff() {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d173f2994b145c70$var$FirstSprintPlanning, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d173f2994b145c70$var$SprintPlanningImage, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d173f2994b145c70$var$SprintPlanningMessage, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d173f2994b145c70$var$SprintPlanningTitle, null, formatMessage((0, $c3aPE.default).emptyFirstSprintTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $c3aPE.default).emptyFirstSprintDescription,
        values: {
            backlog: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, formatMessage((0, $c3aPE.default).backlog)),
            startSprint: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, formatMessage((0, $c3aPE.default).startSprint))
        }
    }))));
}
var $d173f2994b145c70$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
 = $d173f2994b145c70$export$5bf2d993553f05ff;
const $d173f2994b145c70$var$FirstSprintPlanning = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _p12f1ogm _19pkidpf _2hwx1wug _otyridpf _18u01wug _y3gn1e5h _4cvr1h6o _1bah1h6o _1tke1lit",
            __cmplp.className
        ])
    });
});
const $d173f2994b145c70$var$SprintPlanningImageControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-8h0lec-0"
})({
    height: '128px',
    width: '128px',
    backgroundPosition: 'center',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundImage: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($kDODD)))})`
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $d173f2994b145c70$var$SprintPlanningImageExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_ixrapm": (0, $9t7rW.default)((0, (/*@__PURE__*/$parcel$interopDefault($kDODD))), ")", "url(")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1qr7 _1bsb1qr7 _ouxl1ssb _1lrw1f51 _12vemgnk _1itk1866",
            __cmplp.className
        ])
    });
});
const $d173f2994b145c70$var$SprintPlanningImage = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $d173f2994b145c70$var$SprintPlanningImageExperiment, $d173f2994b145c70$var$SprintPlanningImageControl);
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d173f2994b145c70$var$SprintPlanningMessageControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-8h0lec-1"
})`${(0, $4lTFP).h500()};font-weight:normal;margin-top:0;color:${`var(--ds-text, ${(0, $PdmhA).N800})`};padding-left:${"var(--ds-space-200, 16px)"};line-height:1.5;`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $d173f2994b145c70$var$SprintPlanningMessageExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81lkt _bt1jqdok _syaz1fxt _19bvpxbi _vwz4bs82",
            __cmplp.className
        ])
    });
});
const $d173f2994b145c70$var$SprintPlanningMessage = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $d173f2994b145c70$var$SprintPlanningMessageExperiment, $d173f2994b145c70$var$SprintPlanningMessageControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d173f2994b145c70$var$SprintPlanningTitle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48pni7l _n3td1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kDODD", function(module, exports) {
module.exports = new URL("sprint-planning.32ed1a38.svg", import.meta.url).toString();

});

parcelRegister("c3aPE", function(module, exports) {

$parcel$export(module.exports, "default", () => $41bdf688c5c80690$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $41bdf688c5c80690$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyFirstSprintTitle: {
        "id": "backlog.card-list.first-sprint-blank-state.empty-first-sprint-title",
        "defaultMessage": "Plan your sprint"
    },
    emptyFirstSprintDescription: {
        "id": "backlog.card-list.first-sprint-blank-state.empty-first-sprint-description",
        "defaultMessage": "Drag issues from the {backlog} section, or create new issues, to plan the work for this sprint. Select {startSprint} when you're ready."
    },
    backlog: {
        "id": "backlog.card-list.first-sprint-blank-state.backlog",
        "defaultMessage": "Backlog"
    },
    startSprint: {
        "id": "backlog.card-list.first-sprint-blank-state.start-sprint",
        "defaultMessage": "Start sprint"
    }
});

});


parcelRegister("5yOXO", function(module, exports) {

$parcel$export(module.exports, "useFormatDate", () => $50c441a48b43870a$export$fc5db2b57ab9d291);

var $eUqFw = parcelRequire("eUqFw");

var $7ueqz = parcelRequire("7ueqz");

var $6Dsxc = parcelRequire("6Dsxc");

var $ao0hp = parcelRequire("ao0hp");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8K9kM = parcelRequire("8K9kM");

var $lGLse = parcelRequire("lGLse");

var $7TyGu = parcelRequire("7TyGu");

var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");

var $9Vpey = parcelRequire("9Vpey");
const $50c441a48b43870a$var$MS_IN_HOURS = 3600000;
const $50c441a48b43870a$export$fc5db2b57ab9d291 = ()=>{
    const [{ data: loggedInUser }] = (0, $lGLse.useUserSubscriber)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const locale = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getLocale)) || (0, $ao0hp.defaultLocale);
    return (0, $eUqFw.useCallback)((date)=>{
        const utcOffset = Math.floor((0, $6Dsxc.default)(loggedInUser?.timeZone ?? 'utc') / $50c441a48b43870a$var$MS_IN_HOURS);
        const parsedDate = (0, $8K9kM.setNumberOffsetToISODate)(date, utcOffset);
        return (0, $7ueqz.default)(parsedDate) ? (0, $8K9kM.formatWithLocale)(parsedDate, (0, $7TyGu.DEFAULT_DATE_DISPLAY_FORMAT), locale) : formatMessage((0, $9Vpey.default).invalidDate);
    }, [
        formatMessage,
        locale,
        loggedInUser?.timeZone
    ]);
};

});
parcelRegister("9Vpey", function(module, exports) {

$parcel$export(module.exports, "default", () => $49187db1027e7ca4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $49187db1027e7ca4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    invalidDate: {
        "id": "backlog.card-list.hooks.use-format-date.invalid-date",
        "defaultMessage": "Invalid date"
    }
});

});


parcelRegister("gLLIl", function(module, exports) {

$parcel$export(module.exports, "LastResultMarker", () => $07ddc597009dcf63$export$cd661a12882ae547);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $2U8YO = parcelRequire("2U8YO");

var $cS9th = parcelRequire("cS9th");

var $1gQ73 = parcelRequire("1gQ73");

var $kdGmo = parcelRequire("kdGmo");
const $07ddc597009dcf63$export$cd661a12882ae547 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    // Only use scrollElement as it wont update as much
    const { scrollElement: scrollElement } = (0, $2U8YO.useScrollState)();
    const markerRef = (0, $eUqFw.useRef)(null);
    const [, actions] = (0, $cS9th.useMoreResultsStore)();
    const filters = (0, $1gQ73.useBacklogSelector)((0, $kdGmo.getFilters));
    const filtersRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (!window.IntersectionObserver) return undefined;
        const observer = new IntersectionObserver((entries)=>{
            const [entry] = entries;
            const isLastResultBelowFold = !entry.isIntersecting && entry.boundingClientRect.top > (entry.rootBounds?.bottom ?? 0);
            const isFilterApplied = Object.keys(filters).length > 0;
            const isFilterChanged = filters !== filtersRef.current;
            if (isLastResultBelowFold && isFilterChanged && isFilterApplied) {
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'moreResultsButton shown');
                filtersRef.current = filters;
            }
            actions.setIsLastResultMarkerBelowFold(isLastResultBelowFold);
        }, {
            root: scrollElement,
            threshold: 0.5
        });
        const markerElement = markerRef.current;
        if (markerElement && markerRef.current) observer.observe(markerRef.current);
        return ()=>{
            if (markerElement) observer.unobserve(markerElement);
            actions.setIsLastResultMarkerBelowFold(false);
        };
    }, [
        scrollElement,
        actions,
        createAnalyticsEvent,
        filters
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($07ddc597009dcf63$var$Marker, {
        ref: markerRef
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $07ddc597009dcf63$var$Marker = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "hr", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("k6JfZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8a8a4ec8ce099f2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bbaTG = parcelRequire("bbaTG");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");

var $jG1wZ = parcelRequire("jG1wZ");

var $eGI9v = parcelRequire("eGI9v");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $4ZsXf = parcelRequire("4ZsXf");
parcelRequire("gx4hY");
var $8Y2Gm = parcelRequire("8Y2Gm");

var $iVF7F = parcelRequire("iVF7F");

var $7TyGu = parcelRequire("7TyGu");


var $1gQ73 = parcelRequire("1gQ73");

var $cbRhO = parcelRequire("cbRhO");

var $9csAN = parcelRequire("9csAN");

var $dtV8v = parcelRequire("dtV8v");

var $j258X = parcelRequire("j258X");

var $gE40u = parcelRequire("gE40u");

var $fjBeC = parcelRequire("fjBeC");

var $hWsHg = parcelRequire("hWsHg");
const $f8a8a4ec8ce099f2$var$DropdownItemWithAnalytics = (0, $eGI9v.default)('dropdownItem', {
    onClick: 'clicked'
})((0, $hD6GJ.default));
function $f8a8a4ec8ce099f2$export$2e2bcd8739ae039({ cardListId: cardListId, cardListName: cardListName, cardListType: cardListType }) {
    const isCMPBoard = (0, $j258X.useIsCMPBacklog)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { setReturnFocusTo: setReturnFocusTo } = (0, $iVF7F.useModalDialogActions)();
    const element = (0, $eUqFw.useRef)(null);
    const [isEditSprintModalOpen, setIsEditSprintModalOpen] = (0, $eUqFw.useState)(false);
    const previousSprintId = (0, $1gQ73.useBacklogSelector)((state)=>(0, $dtV8v.makeGetPreviousNotStartedSprintId)(state)(cardListId));
    const nextSprintId = (0, $1gQ73.useBacklogSelector)((state)=>(0, $dtV8v.makeGetNextSprintId)(state)(cardListId));
    const firstInactiveSprintId = (0, $1gQ73.useBacklogSelector)((0, $dtV8v.getFirstInactiveSprintId));
    const lastInactiveSprintId = (0, $1gQ73.useBacklogSelector)((0, $dtV8v.getLastInactiveSprintId));
    const isCardListActiveSprint = (0, $1gQ73.useBacklogSelector)((state)=>(0, $dtV8v.makeIsCardListActiveSprint)(state)(cardListId));
    const canMoveSprintUp = previousSprintId !== null;
    const canMoveSprintDown = !isCardListActiveSprint && nextSprintId !== null;
    const enabledMenuActions = cardListType !== (0, $7TyGu.SPRINT) ? {} : {
        MOVE_SPRINT_TO_TOP: canMoveSprintUp,
        MOVE_SPRINT_UP: canMoveSprintUp,
        MOVE_SPRINT_DOWN: canMoveSprintDown,
        MOVE_SPRINT_TO_BOTTOM: canMoveSprintDown,
        EDIT_SPRINT: true,
        DELETE_SPRINT: true
    };
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const renderTrigger = (0, $eUqFw.useCallback)(({ triggerRef: triggerRef, ...props })=>{
        const handleRef = (refElement)=>{
            if (typeof triggerRef === 'function') triggerRef(refElement);
            if (refElement) element.current = refElement;
        };
        const moreIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
            label: "More actions",
            primaryColor: "var(--ds-icon, #44546F)"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
            ...props,
            ref: handleRef,
            iconBefore: moreIcon,
            "aria-label": formatMessage((0, $hWsHg.default).menuTrigger, {
                sprintName: cardListName
            }),
            theme: (0, $fjBeC.darkerButtonTheme),
            testId: `software-backlog.card-list.sprints-menu.${cardListName}`
        });
    }, [
        cardListName,
        formatMessage
    ]);
    const handleOpenChange = (0, $eUqFw.useCallback)(()=>setReturnFocusTo(element), [
        element,
        setReturnFocusTo
    ]);
    const isVisible = enabledMenuActions && Object.keys(enabledMenuActions).length > 0;
    if (!isVisible) return null;
    const onDelete = ()=>{
        dispatch((0, $cbRhO.openModal)({
            type: (0, $ebd52ea7083e351b$export$96d8f8ff51c496e3),
            payload: {
                sprintId: cardListId
            }
        }));
    };
    const onMoveUp = (event, analyticsEvent)=>{
        if (previousSprintId != null && previousSprintId !== '') dispatch((0, $9csAN.sprintMoveRequest)({
            sprintId: cardListId,
            targetSprintId: previousSprintId,
            direction: (0, $7TyGu.SPRINT_MOVE_UP),
            analyticsEvent: analyticsEvent
        }));
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'moveSprintUp');
    };
    const onMoveToTop = (event, analyticsEvent)=>{
        dispatch((0, $9csAN.sprintMoveRequest)({
            sprintId: cardListId,
            targetSprintId: firstInactiveSprintId,
            direction: (0, $7TyGu.SPRINT_MOVE_TO_TOP),
            analyticsEvent: analyticsEvent
        }));
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'moveSprintToTop');
    };
    const onMoveDown = (event, analyticsEvent)=>{
        if (nextSprintId != null && nextSprintId !== '') dispatch((0, $9csAN.sprintMoveRequest)({
            sprintId: cardListId,
            targetSprintId: nextSprintId,
            direction: (0, $7TyGu.SPRINT_MOVE_DOWN),
            analyticsEvent: analyticsEvent
        }));
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'moveSprintDown');
    };
    const onMoveToBottom = (event, analyticsEvent)=>{
        dispatch((0, $9csAN.sprintMoveRequest)({
            sprintId: cardListId,
            targetSprintId: lastInactiveSprintId,
            direction: (0, $7TyGu.SPRINT_MOVE_TO_BOTTOM),
            analyticsEvent: analyticsEvent
        }));
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'moveSprintToBottom');
    };
    const onEditSprintClick = (event, analyticsEvent)=>{
        setIsEditSprintModalOpen(true);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'openEditSprint');
        (0, $8Y2Gm.editSprintModalLoad).start();
    };
    const onEditSprintModalCloseClick = ()=>{
        setIsEditSprintModalOpen(false);
    };
    const menuItems = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, enabledMenuActions.MOVE_SPRINT_TO_TOP && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f8a8a4ec8ce099f2$var$DropdownItemWithAnalytics, {
        "data-testid": "software-backlog.card-list.sprints-menu.sprint-move-to-top",
        onClick: onMoveToTop
    }, formatMessage((0, $hWsHg.default).moveSprintToTop)), enabledMenuActions.MOVE_SPRINT_UP && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f8a8a4ec8ce099f2$var$DropdownItemWithAnalytics, {
        "data-testid": "software-backlog.card-list.sprints-menu.sprint-move-up",
        onClick: onMoveUp
    }, formatMessage((0, $hWsHg.default).moveSprintUp)), enabledMenuActions.MOVE_SPRINT_DOWN && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f8a8a4ec8ce099f2$var$DropdownItemWithAnalytics, {
        "data-testid": "software-backlog.card-list.sprints-menu.sprint-move-down",
        onClick: onMoveDown
    }, formatMessage((0, $hWsHg.default).moveSprintDown)), enabledMenuActions.MOVE_SPRINT_TO_BOTTOM && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f8a8a4ec8ce099f2$var$DropdownItemWithAnalytics, {
        "data-testid": "software-backlog.card-list.sprints-menu.sprint-move-to-bottom",
        onClick: onMoveToBottom
    }, formatMessage((0, $hWsHg.default).moveSprintToBottom)), enabledMenuActions.EDIT_SPRINT && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f8a8a4ec8ce099f2$var$DropdownItemWithAnalytics, {
        "data-testid": "software-backlog.card-list.sprints-menu.sprint-edit",
        onClick: onEditSprintClick
    }, formatMessage((0, $hWsHg.default).editSprint)), enabledMenuActions.DELETE_SPRINT && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f8a8a4ec8ce099f2$var$DropdownItemWithAnalytics, {
        "data-testid": "software-backlog.card-list.sprints-menu.sprint-delete",
        onClick: onDelete
    }, formatMessage((0, $hWsHg.default).deleteSprint)), isCMPBoard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZsXf.SprintActionsConnectMenuItems), {
        sprintId: cardListId,
        location: "sprint-move-actions"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZsXf.SprintActionsConnectMenuItems), {
        sprintId: cardListId,
        location: "sprint-edit-action"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZsXf.SprintActionsConnectMenuItems), {
        sprintId: cardListId,
        location: "sprint-delete-action"
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isEditSprintModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gE40u.default), {
        cardListId: Number(cardListId),
        onClose: onEditSprintModalCloseClick,
        onSubmit: onEditSprintModalCloseClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        onOpenChange: handleOpenChange,
        trigger: renderTrigger,
        placement: "bottom-end",
        shouldRenderToParent: true,
        testId: "software-backlog.card-list.sprints-menu.dropdown-menu"
    }, menuItems));
}

});
parcelRegister("6OfWd", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd131b446ad30d0e$export$2e2bcd8739ae039);
/* eslint-disable import/order */ 
var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $6zOB7 = parcelRequire("6zOB7");


var $1lQG9 = parcelRequire("1lQG9");

var $5Q9wj = parcelRequire("5Q9wj");

var $2WwAS = parcelRequire("2WwAS");

var $7PTrT = parcelRequire("7PTrT");

var $86Ndv = parcelRequire("86Ndv");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $dkYal = parcelRequire("dkYal");

var $jiH6M = parcelRequire("jiH6M");

var $7mYCs = parcelRequire("7mYCs");

var $h1Q9j = parcelRequire("h1Q9j");

var $8gwL5 = parcelRequire("8gwL5");
const $cd131b446ad30d0e$var$gridSize = (0, $lcnyw.gridSize)();
const $cd131b446ad30d0e$var$MAX_HEIGHT = `calc(100vh - ${$cd131b446ad30d0e$var$gridSize * 2}px)`;
const $cd131b446ad30d0e$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $cd131b446ad30d0e$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${crossAxis}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-start`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $cd131b446ad30d0e$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $5Q9wj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $lcnyw.layers).modal(), label: label })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $2WwAS.default)(isOpen, ()=>defaultOpen);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const id = (0, $8gwL5.default)();
    const itemRef = (0, $h1Q9j.default)();
    const fallbackPlacements = (0, $eUqFw.useMemo)(()=>$cd131b446ad30d0e$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $eUqFw.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        isLocalOpen,
        setLocalIsOpen
    ]);
    const handleOnClose = (0, $eUqFw.useCallback)((event)=>{
        if (event.key !== 'Escape' && event.key !== 'Tab' && event.target?.closest?.(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`)) // Check if it is within dropdown and it is a trigger button
        // if it is a nested dropdown, clicking trigger won't close the dropdown
        // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
        return;
        if (event.key === 'Tab' && event.shiftKey || event.key === 'Escape') requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        onOpenChange,
        setLocalIsOpen,
        itemRef
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $5Q9wj.default;
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $54717ce5fa2c74b1$export$e51a3576c045c8d5) || e.key === (0, $54717ce5fa2c74b1$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer
    } : {
        shouldRenderToParent: shouldRenderToParent
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7mYCs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        testId: testId && `${testId}--content`,
        shouldUseCaptureOnOutsideClick: true,
        ...conditionalProps,
        shouldDisableFocusLock: true,
        trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
        ...rest })=>{
            if (typeof trigger === 'function') return trigger({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                ...rest,
                ...bindFocus,
                triggerRef: (0, $1lQG9.default)([
                    ref,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
                ...bindFocus,
                ref: (0, $1lQG9.default)([
                    ref,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))),
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`,
                "aria-label": label
            }, trigger);
        },
        content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dkYal.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jiH6M.default), {
                spacing: spacing,
                maxHeight: $cd131b446ad30d0e$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && `${testId}--menu-wrapper`
            }, children))
    }));
};
var $cd131b446ad30d0e$export$2e2bcd8739ae039 = $cd131b446ad30d0e$var$DropdownMenu;

});
parcelRegister("2WwAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc974ed9b9ba7adb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $fc974ed9b9ba7adb$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $eUqFw.useState)(getDefaultPropValue);
    const isControlledRef = (0, $eUqFw.useRef)(isControlled);
    (0, $eUqFw.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $eUqFw.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("7PTrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf74c53325012fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $2cf74c53325012fd$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $eUqFw.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $eUqFw.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("jiH6M", function(module, exports) {

$parcel$export(module.exports, "default", () => $964014f36228d6e8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $dkYal = parcelRequire("dkYal");

var $fccfd = parcelRequire("fccfd");

var $1g0c9 = parcelRequire("1g0c9");
const $964014f36228d6e8$var$spinnerContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
const $964014f36228d6e8$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $964014f36228d6e8$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $964014f36228d6e8$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDecendant = menuItemRefs.some((menuItem)=>{
            const isCheckboxOrRadio = (0, $fccfd.default)(menuItem) || (0, $1g0c9.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDecendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $eUqFw.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.find((ref)=>!ref.hasAttribute('disabled')) ?? null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`
    }, isLoading ? /*#__PURE__*/ (0, $byn9U.jsx)($964014f36228d6e8$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && `${testId}--loading-indicator`
    }) : children);
};
var $964014f36228d6e8$export$2e2bcd8739ae039 = $964014f36228d6e8$var$MenuWrapper;

});
parcelRegister("fccfd", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc914649461e3b8$export$2e2bcd8739ae039);
function $2cc914649461e3b8$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("1g0c9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3727e20ee9b5acb1$export$2e2bcd8739ae039);
function $3727e20ee9b5acb1$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("7mYCs", function(module, exports) {

$parcel$export(module.exports, "SelectionStoreContext", () => $9b55d88a204a2c6b$export$756f795847463ebd);
$parcel$export(module.exports, "default", () => $9b55d88a204a2c6b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $9b55d88a204a2c6b$export$756f795847463ebd = /*#__PURE__*/ (0, $eUqFw.createContext)({
    setItemState: (0, $5Q9wj.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $5Q9wj.default),
    getGroupState: ()=>({})
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $9b55d88a204a2c6b$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $eUqFw.useRef)({});
    const context = (0, $eUqFw.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9b55d88a204a2c6b$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $9b55d88a204a2c6b$export$2e2bcd8739ae039 = $9b55d88a204a2c6b$var$SelectionStore;

});

parcelRegister("8gwL5", function(module, exports) {

$parcel$export(module.exports, "PREFIX", () => $bbafb6080e6e0b27$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $bbafb6080e6e0b27$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $bbafb6080e6e0b27$export$8a682ae47622dbb9 = 'ds--dropdown--';
const $bbafb6080e6e0b27$var$generateRandomString = ()=>// This string is used only on client side usually triggered after a user interaction.
    // Therefore, so there is no risk of mismatch
    // between server and client generated markup.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    `${$bbafb6080e6e0b27$export$8a682ae47622dbb9}${Math.random().toString(16).substr(2, 8)}`;
function $bbafb6080e6e0b27$export$2e2bcd8739ae039() {
    const cachedId = (0, $eUqFw.useRef)($bbafb6080e6e0b27$var$generateRandomString());
    return cachedId.current;
}

});


parcelRegister("4ZsXf", function(module, exports) {

$parcel$export(module.exports, "SprintActionsConnectMenuItems", () => $6dc7b298d11dbc23$export$f9a25247020e32b7);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $be5j9 = parcelRequire("be5j9");

var $jAaTB = parcelRequire("jAaTB");
const $6dc7b298d11dbc23$var$SprintActionsConnectInner = ({ sprintId: sprintId, location: location })=>{
    const sprintActions = (0, $jAaTB.useFetchedSprintActions)({
        sprintId: sprintId
    });
    const targetActions = (0, $eUqFw.useMemo)(()=>sprintActions?.[sprintId]?.[location] ?? null, [
        sprintId,
        location,
        sprintActions
    ]);
    if (!sprintActions || !targetActions) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, targetActions.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $be5j9.BoardToolSubItem), {
            key: item.id,
            subItem: item
        })));
};
function $6dc7b298d11dbc23$export$f9a25247020e32b7(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "board-connect-toolbar",
        packageName: "@atlassian/jira-software-sprint-actions-connect-items",
        teamName: "a4t-tanuki",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6dc7b298d11dbc23$var$SprintActionsConnectInner, props));
}

});
parcelRegister("be5j9", function(module, exports) {

$parcel$export(module.exports, "BoardToolWebItemView", () => $6230fb79f45984d4$export$37f386501b29905e);
$parcel$export(module.exports, "BoardToolSubItem", () => $6230fb79f45984d4$export$dbbc4e042bbab47e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");

var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");

var $bo4OB = parcelRequire("bo4OB");

var $0cdA8 = parcelRequire("0cdA8");

const $6230fb79f45984d4$export$87f324ad8d8a087a = (0, $7rh0R.lazy)(()=>(parcelRequire("NsHGM")).then(({ BoardToolWebPanelView: BoardToolWebPanelView })=>({
            default: BoardToolWebPanelView
        })), {
    moduleId: "./src/packages/software/connect-toolbar/src/common/ui/tool-sections/board-tool-section-view/board-tool-sub-item/board-tool-web-panel-view/index.tsx"
});
function $6230fb79f45984d4$export$37f386501b29905e({ subItem: subItem, mode: mode = 'dropdown-item', onClickWebItem: onClickWebItem }) {
    const webItemLinkRef = (0, $eUqFw.useRef)(null);
    const handleOnClickWebItem = (e)=>{
        e.preventDefault();
        webItemLinkRef.current?.click();
        if (onClickWebItem) onClickWebItem();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, mode === 'dropdown-item' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        "data-testid": "software-connect-toolbar.common.ui.tool-sections.board-tool-section-view.board-tool-sub-item.link-item",
        onClick: handleOnClickWebItem
    }, subItem.label) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "software-connect-toolbar.common.ui.tool-sections.board-tool-section-view.board-tool-sub-item.link-item",
        onClick: handleOnClickWebItem
    }, subItem.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6230fb79f45984d4$var$HiddenLink, {
        ref: webItemLinkRef,
        href: subItem.url,
        className: subItem.cssClass ?? ''
    }, subItem.label));
}
function $6230fb79f45984d4$export$dbbc4e042bbab47e({ subItem: subItem, onClickWebItem: onClickWebItem }) {
    if (subItem.type === 'webItem') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6230fb79f45984d4$export$37f386501b29905e, {
        onClickWebItem: onClickWebItem,
        subItem: subItem
    });
    if (subItem.type === 'section') {
        const content = subItem.subItems?.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6230fb79f45984d4$export$dbbc4e042bbab47e, {
                key: item.id,
                subItem: item
            }));
        if (subItem.label === '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, content);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
            placement: "right-end",
            trigger: subItem.label,
            testId: "software-connect-toolbar.common.ui.tool-sections.board-tool-section-view.board-tool-sub-item.dropdown-menu"
        }, content);
    }
    if (subItem.type === 'webPanel') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "board-tool-web-panel-view",
        packageName: "@atlassian/jira-software-connect-toolbar",
        teamName: "a4t-tanuki"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.LazySuspense), {
        fallback: "Loading..."
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6230fb79f45984d4$export$87f324ad8d8a087a, {
        webPanel: subItem
    })));
    return null;
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6230fb79f45984d4$var$HiddenLink = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("NsHGM", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('96MND');
        const value = parcelRequire('4DM6T');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("96MND").then(()=>parcelRequire('4DM6T'));
}

});


parcelRegister("jAaTB", function(module, exports) {

$parcel$export(module.exports, "useFetchedToolSections", () => $fc90779dfd344c4c$export$32bd6c5ac0419028);
$parcel$export(module.exports, "useFetchedSprintActions", () => $fc90779dfd344c4c$export$d58666d3ff237ccd);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $bHCxi = parcelRequire("bHCxi");
const $fc90779dfd344c4c$export$390f32400eaf98c9 = (0, $a61MH.createStore)({
    name: '@atlassian/jira-software-connect-toolbar',
    initialState: {
        toolSections: null,
        key: null,
        isLoading: false,
        sprintActions: null
    },
    actions: $bHCxi
});
const $fc90779dfd344c4c$export$d5aeb5eefb04c978 = (0, $ggKAj.createHook)($fc90779dfd344c4c$export$390f32400eaf98c9, {
    selector: (state)=>state.toolSections
});
function $fc90779dfd344c4c$export$32bd6c5ac0419028({ boardId: boardId, projectKey: projectKey, mode: mode = 'work' }) {
    const [toolSections, { fetchExtensionData: fetchExtensionData }] = $fc90779dfd344c4c$export$d5aeb5eefb04c978();
    (0, $eUqFw.useEffect)(()=>{
        fetchExtensionData({
            boardId: boardId,
            projectKey: projectKey,
            mode: mode
        });
    }, [
        boardId,
        fetchExtensionData,
        mode,
        projectKey
    ]);
    return toolSections;
}
const $fc90779dfd344c4c$export$fa6cceef0215e684 = (0, $ggKAj.createHook)($fc90779dfd344c4c$export$390f32400eaf98c9, {
    selector: (state)=>state.sprintActions
});
const $fc90779dfd344c4c$export$d58666d3ff237ccd = ({ sprintId: sprintId })=>{
    const [sprintActions, { fetchSprintActionsData: fetchSprintActionsData }] = $fc90779dfd344c4c$export$fa6cceef0215e684();
    (0, $eUqFw.useEffect)(()=>{
        fetchSprintActionsData({
            sprintId: sprintId
        });
    }, [
        fetchSprintActionsData,
        sprintId
    ]);
    return sprintActions;
};

});
parcelRegister("bHCxi", function(module, exports) {

$parcel$export(module.exports, "fetchExtensionData", () => $6dec1f0ce3eabacd$export$5fe98ae96d282610);
$parcel$export(module.exports, "fetchSprintActionsData", () => $6dec1f0ce3eabacd$export$d50a304a5f5a89a3);

var $gUUjF = parcelRequire("gUUjF");

var $1fPWo = parcelRequire("1fPWo");

var $2V1iY = parcelRequire("2V1iY");
const $6dec1f0ce3eabacd$export$5fe98ae96d282610 = ({ boardId: boardId, projectKey: projectKey, mode: mode = 'work' })=>async ({ getState: getState, setState: setState })=>{
        const key = JSON.stringify([
            projectKey,
            boardId,
            mode
        ]);
        const state = getState();
        if (state.key === key && state.isLoading) return;
        if (state.key !== key) setState({
            toolSections: null,
            isLoading: true,
            key: key
        });
        else setState({
            isLoading: true
        });
        try {
            const response = await (0, $2V1iY.fetchCMPExtensionData)({
                boardId: boardId,
                projectKey: projectKey,
                mode: mode
            });
            setState({
                toolSections: response.sections,
                key: key,
                isLoading: false
            });
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('software.extension.board-tools', error instanceof Error ? error.message : String(error), error instanceof Error ? error : undefined);
            setState({
                isLoading: false
            });
        }
    };
const $6dec1f0ce3eabacd$export$d50a304a5f5a89a3 = ({ sprintId: sprintId })=>async ({ getState: getState, setState: setState })=>{
        const { sprintActions: sprintActions } = getState();
        const findActions = sprintActions?.[sprintId] || {
            isLoading: false,
            hasLoaded: false
        };
        if (findActions.isLoading || findActions.hasLoaded) return;
        // set loading to true to prevent multiple requests
        setState({
            sprintActions: {
                ...sprintActions,
                [sprintId]: {
                    isLoading: true,
                    hasLoaded: false
                }
            }
        });
        try {
            const response = await (0, $2V1iY.fetchCMPSprintActionsData)({
                sprintId: sprintId
            });
            const actionsForSprint = (0, $1fPWo.transformSprintActionsResponse)(response);
            setState({
                sprintActions: {
                    ...getState().sprintActions,
                    [sprintId]: {
                        ...actionsForSprint,
                        isLoading: false,
                        hasLoaded: true
                    }
                }
            });
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('software.extension.sprint-actions', error instanceof Error ? error.message : String(error), error instanceof Error ? error : undefined);
            setState({
                sprintActions: {
                    ...getState().sprintActions,
                    [sprintId]: {
                        isLoading: false,
                        hasLoaded: false
                    }
                }
            });
        }
    };

});
parcelRegister("1fPWo", function(module, exports) {

$parcel$export(module.exports, "transformSprintActionsResponse", () => $08b3286bab4049d9$export$bb626d8539383296);
const $08b3286bab4049d9$export$8b3475589327aa1c = (sprintAction)=>({
        id: sprintAction.id,
        type: 'webItem',
        label: sprintAction.name,
        url: sprintAction.url,
        cssClass: sprintAction.styleClass
    });
const $08b3286bab4049d9$export$5365f133b30aefb1 = (sprintAction)=>Boolean(sprintAction.url);
const $08b3286bab4049d9$export$1d427bb13100a4da = (section)=>section.groupId === 'sprint-move-actions' || section.groupId === 'sprint-edit-action' || section.groupId === 'sprint-delete-action';
const $08b3286bab4049d9$export$bb626d8539383296 = (sprintActionsResponse)=>{
    const result = {};
    sprintActionsResponse.sections.filter($08b3286bab4049d9$export$1d427bb13100a4da).forEach((section)=>{
        const actions = section.actions.filter($08b3286bab4049d9$export$5365f133b30aefb1).map($08b3286bab4049d9$export$8b3475589327aa1c);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        result[section.groupId] = actions;
    });
    return result;
};

});

parcelRegister("2V1iY", function(module, exports) {

$parcel$export(module.exports, "fetchCMPExtensionData", () => $66a8b4195f50bf90$export$aa96aae4fab07720);
$parcel$export(module.exports, "fetchCMPSprintActionsData", () => $66a8b4195f50bf90$export$2a796a8235b7b986);

var $2OdyW = parcelRequire("2OdyW");
function $66a8b4195f50bf90$export$aa96aae4fab07720({ boardId: boardId, projectKey: projectKey, mode: mode = 'work' }) {
    return (0, $2OdyW.default)(`/rest/greenhopper/1.0/xboard/toolSections?mode=${mode}&rapidViewId=${boardId}&selectedProjectKey=${projectKey}&_=${Date.now()}`);
}
function $66a8b4195f50bf90$export$2a796a8235b7b986({ sprintId: sprintId }) {
    return (0, $2OdyW.default)(`/rest/greenhopper/1.0/xboard/plan/sprints/actions?sprintId=${sprintId}&_=${Date.now()}`);
}

});




parcelRegister("hWsHg", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aae9e9a359e53f5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8aae9e9a359e53f5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    menuTrigger: {
        "id": "backlog.card-list.sprints-menu.menu-trigger",
        "defaultMessage": "{sprintName} actions"
    },
    editSprint: {
        "id": "backlog.card-list.sprints-menu.edit-sprint",
        "defaultMessage": "Edit sprint"
    },
    deleteSprint: {
        "id": "backlog.card-list.sprints-menu.delete-sprint",
        "defaultMessage": "Delete sprint"
    },
    moveSprintToTop: {
        "id": "backlog.card-list.sprints-menu.move-sprint-to-top",
        "defaultMessage": "Move sprint to top"
    },
    moveSprintUp: {
        "id": "backlog.card-list.sprints-menu.move-sprint-up",
        "defaultMessage": "Move sprint up"
    },
    moveSprintDown: {
        "id": "backlog.card-list.sprints-menu.move-sprint-down",
        "defaultMessage": "Move sprint down"
    },
    moveSprintToBottom: {
        "id": "backlog.card-list.sprints-menu.move-sprint-to-bottom",
        "defaultMessage": "Move sprint to bottom"
    }
});

});


parcelRegister("f1wUU", function(module, exports) {

$parcel$export(module.exports, "default", () => $624420c3582e5285$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $huI7r = parcelRequire("huI7r");

var $8fT28 = parcelRequire("8fT28");

var $dOL7m = parcelRequire("dOL7m");

var $ieUWD = parcelRequire("ieUWD");

var $dWLk9 = parcelRequire("dWLk9");

var $jQLMK = parcelRequire("jQLMK");

var $gPQCf = parcelRequire("gPQCf");

var $1gQ73 = parcelRequire("1gQ73");

var $70VKY = parcelRequire("70VKY");

var $hkGxG = parcelRequire("hkGxG");

var $2bmzC = parcelRequire("2bmzC");
const $624420c3582e5285$var$StartSprintButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ theme: theme, appearance: appearance, isDisabled: isDisabled, testId: testId, children: children, sprintId: sprintId }, ref)=>{
    const boardId = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getRapidViewId));
    const hasActiveSprints = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getHasActiveSprints));
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const isCompanyManaged = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getIsCompanyManaged));
    const onSave = ()=>{
        // Since the sprint modals don't go through redux we need to fire their invalidations manually
        (0, $ieUWD.triggerResourceCacheInvalidation)((0, $c22b1ee1fcd49c4a$export$dedbdcc35e955187), 'START_SPRINT_MODAL_START');
        dispatch((0, $70VKY.showSprintStartedFlagAction)());
    };
    const redirectTo = (0, $jQLMK.useBoardUrl)(hasActiveSprints ? [
        'sprintStarted=true',
        `sprints=${sprintId}`
    ] : [
        'sprintStarted=true'
    ]) || '';
    const [isModalVisible, setModalVisible] = (0, $eUqFw.useState)(false);
    const cloudId = (0, $dWLk9.useCloudId)();
    const [queryReference, loadQuery, disposeQuery] = (0, $iWLL0.useQueryLoader)((0, $8fT28.default));
    const boardIdAri = (0, $huI7r.createAri)({
        resourceOwner: 'jira-software',
        cloudId: cloudId,
        resourceType: 'board',
        resourceId: String(boardId)
    });
    const sprintIdAri = (0, $huI7r.createAri)({
        resourceOwner: 'jira-software',
        cloudId: cloudId,
        resourceType: 'sprint',
        resourceId: String(sprintId)
    });
    const onClick = ()=>{
        (0, $gPQCf.startSprintModalLoad).start();
        loadQuery({
            boardId: boardIdAri,
            sprintId: sprintIdAri,
            isCompanyManaged: isCompanyManaged
        }, {
            fetchPolicy: 'network-only'
        });
        setModalVisible(true);
    };
    const onClose = ()=>{
        setModalVisible(false);
        disposeQuery();
    };
    const onStartSprintSave = ()=>{
        onClose();
        onSave();
    };
    const onReady = ()=>{
        (0, $gPQCf.startSprintModalLoad).stop({
            customData: {
                relay: true
            }
        });
    };
    const commonProps = {
        onClick: onClick,
        isDisabled: isDisabled,
        testId: testId,
        ref: ref
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, theme ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dOL7m.ModalTriggerButton), {
        ...commonProps,
        theme: theme
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dOL7m.ModalTriggerButton), {
        ...commonProps,
        appearance: appearance
    }, children), isModalVisible && queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2bmzC.default), {
        analyticsSource: "software-backlog",
        onClose: onClose,
        onSave: onStartSprintSave,
        queryReference: queryReference,
        onReady: onReady,
        sprintId: String(sprintIdAri),
        boardId: String(boardIdAri),
        redirectTo: redirectTo,
        showAlternateHeaderMessage: hasActiveSprints,
        isCompanyManaged: isCompanyManaged
    }) : null);
});
var $624420c3582e5285$export$2e2bcd8739ae039 = $624420c3582e5285$var$StartSprintButton;

});
parcelRegister("8fT28", function(module, exports) {

$parcel$export(module.exports, "default", () => $97a053c32f66a74a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<460c599037694fd14d389b534583c5cc>>
 * @relayHash 9203ca1c3f1dd776474f4a1b5b46683a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5a8f0bf7cefdeaf4f8d5660e4437c7f1202cb81fec69b986c0ee85314247d3d1
const $97a053c32f66a74a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isCompanyManaged"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sprintId"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v4 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "sprintIds.0",
                    "variableName": "sprintId"
                }
            ],
            "kind": "ListValue",
            "name": "sprintIds"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "goal"
    }, v7 = {
        "kind": "ScalarField",
        "name": "defaultStartDate"
    }, v8 = {
        "kind": "ScalarField",
        "name": "defaultEndDate"
    }, v9 = {
        "kind": "ScalarField",
        "name": "numCompletedIssues"
    }, v10 = {
        "kind": "ScalarField",
        "name": "numOpenIssues"
    }, v11 = {
        "condition": "isCompanyManaged",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "unestimatedIssueKeys"
            },
            {
                "kind": "ScalarField",
                "name": "unestimatedIssueCount"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainJiraSoftwareStartSprintPrototypeQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v3 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "args": v4 /*: any*/ ,
                                "concreteType": "SprintWithStatistics",
                                "kind": "LinkedField",
                                "name": "sprintWithStatistics",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": v5 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "boardScope.sprintWithStatistics.name"
                                    },
                                    v6 /*: any*/ ,
                                    v7 /*: any*/ ,
                                    v8 /*: any*/ ,
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "SoftwareSprintMetadata",
                                            "kind": "LinkedField",
                                            "name": "sprintMetadata",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v9 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.sprintWithStatistics.sprintMetadata.numCompletedIssues"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v10 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.sprintWithStatistics.sprintMetadata.numOpenIssues"
                                                },
                                                v11 /*: any*/ 
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "boardScope.sprintWithStatistics.sprintMetadata"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "startSprintPeriod_softwareStartSprintModalRelay"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainJiraSoftwareStartSprintPrototypeQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "SprintWithStatistics",
                            "kind": "LinkedField",
                            "name": "sprintWithStatistics",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                {
                                    "concreteType": "SoftwareSprintMetadata",
                                    "kind": "LinkedField",
                                    "name": "sprintMetadata",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                },
                                v12 /*: any*/ 
                            ]
                        },
                        v12 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "5a8f0bf7cefdeaf4f8d5660e4437c7f1202cb81fec69b986c0ee85314247d3d1",
            "metadata": {},
            "name": "mainJiraSoftwareStartSprintPrototypeQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$97a053c32f66a74a$var$node.hash = "9ff5d851732ba2b395256eb73ffe6c21";
var $97a053c32f66a74a$export$2e2bcd8739ae039 = $97a053c32f66a74a$var$node;

});

parcelRegister("jQLMK", function(module, exports) {

$parcel$export(module.exports, "useBoardUrl", () => $36594fb726933561$export$66c8e3658ad37452);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $i889l = parcelRequire("i889l");
var $SEaoU = parcelRequire("SEaoU");

var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");
const $36594fb726933561$export$66c8e3658ad37452 = (additionalParams = [])=>{
    const boardId = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getRapidViewId));
    const isCMPBoard = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getIsCompanyManaged));
    const [{ data: data, error: error }] = (0, $SEaoU.useContainerContext)();
    return (0, $eUqFw.useMemo)(()=>{
        if (!data || error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('useBacklogUrl', 'Failed getting container context');
            return null;
        }
        const url = (0, $i889l.isUserContext)(data) ? `/jira/people/${data.user.accountId}` : `/jira/software${isCMPBoard ? '/c' : ''}/projects/${data.project.key}`;
        return `${url}/boards/${boardId}${additionalParams.length ? `?${additionalParams.join('&')}` : ''}`;
    }, [
        additionalParams,
        boardId,
        data,
        error,
        isCMPBoard
    ]);
};

});
parcelRegister("i889l", function(module, exports) {

$parcel$export(module.exports, "isProjectContext", () => $bedad64595855821$export$d46e75e464bf2407);
$parcel$export(module.exports, "isUserContext", () => $bedad64595855821$export$8d1083037a4a6250);
const $bedad64595855821$export$d46e75e464bf2407 = (containerContext)=>containerContext.project !== undefined;
const $bedad64595855821$export$8d1083037a4a6250 = (containerContext)=>containerContext.user !== undefined;

});


parcelRegister("2bmzC", function(module, exports) {

$parcel$export(module.exports, "default", () => $839fb1348e361b93$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $3aiNK = parcelRequire("3aiNK");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $839fb1348e361b93$var$StartSprintModal = (0, $7rh0R.lazy)(()=>(parcelRequire("az2ml")), {
    moduleId: "./src/packages/software/start-sprint-modal-relay/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$839fb1348e361b93$export$2e2bcd8739ae039 = ({ ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3aiNK.StartSprintModalBoundary), {
        packageName: (0, $e1409a6fc345c0d8$export$dfd208682d29484c)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($839fb1348e361b93$var$StartSprintModal, props));

});
parcelRegister("3aiNK", function(module, exports) {

$parcel$export(module.exports, "StartSprintModalBoundary", () => $b8cf07c0473c4519$export$6cfe815c8e1cbd86);

var $eUqFw = parcelRequire("eUqFw");

var $cyVXS = parcelRequire("cyVXS");
const $b8cf07c0473c4519$export$6cfe815c8e1cbd86 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cyVXS.ModalBoundary), {
        id: "start-sprint-modal",
        ...props
    }, children);

});

parcelRegister("az2ml", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('kOd4i');
        const value = parcelRequire('4MN1N');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("kOd4i").then(()=>parcelRequire('4MN1N'));
}

});



parcelRegister("1JLT3", function(module, exports) {

$parcel$export(module.exports, "default", () => $13ed87d71602d374$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $1gQ73 = parcelRequire("1gQ73");

var $hzOcT = parcelRequire("hzOcT");
const $13ed87d71602d374$var$TransitionZone = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isVisible: isVisible }, ref)=>{
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const onEnter = (0, $eUqFw.useCallback)(()=>{
        dispatch((0, $hzOcT.transitionZoneEnter)());
    }, [
        dispatch
    ]);
    const onLeave = (0, $eUqFw.useCallback)(()=>{
        dispatch((0, $hzOcT.transitionZoneLeave)());
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($13ed87d71602d374$var$TransitionZoneOuterContainer, {
        ref: ref,
        isVisible: isVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($13ed87d71602d374$var$TransitionZoneInnerContainer, {
        onMouseOver: onEnter,
        onMouseOut: onLeave,
        "data-testid": "software-backlog.card-list.transition-zone.transition-zone-inner-container"
    }));
});
var $13ed87d71602d374$export$2e2bcd8739ae039 = $13ed87d71602d374$var$TransitionZone;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $13ed87d71602d374$var$TransitionZoneOuterContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1bsb1osq _4t3i1osq _1pbycs5v",
            __cmplp.isVisible ? "_3um0ewfl" : "_3um015vq",
            __cmplp.className
        ])
    });
});
const $13ed87d71602d374$var$TransitionZoneInnerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vchhusvi _1ul91osq _kqswh2mm _1tke1osq _2rkoi2wt _19it24b2 _bfhk29zg _lcxv4shg _irr3wtfv",
            __cmplp.className
        ])
    });
});

});

parcelRegister("2VSqB", function(module, exports) {

$parcel$export(module.exports, "useCardListDropTarget", () => $cdd1a8f1bdd44e97$export$4c4dc2d355187470);

var $eUqFw = parcelRequire("eUqFw");

var $eo9PV = parcelRequire("eo9PV");

var $1ybV0 = parcelRequire("1ybV0");

var $hKj4G = parcelRequire("hKj4G");

var $9eH8H = parcelRequire("9eH8H");


var $1gQ73 = parcelRequire("1gQ73");

var $hzOcT = parcelRequire("hzOcT");

var $j258X = parcelRequire("j258X");

var $ecfSW = parcelRequire("ecfSW");
function $cdd1a8f1bdd44e97$var$useCardListHeaderDropTarget({ headerElementRef: headerElementRef, cardListId: cardListId, isHeaderDropDisabled: isHeaderDropDisabled }) {
    const autobatch = (0, $hKj4G.useAutobatch)();
    const moveCards = (0, $ecfSW.useSimplyMoveCards)();
    const [isDraggingOver, setIsDraggingOver] = (0, $eUqFw.useState)(false);
    const isCompanyManagedKanban = (0, $j258X.useIsCMPKanbanBacklog)();
    (0, $eUqFw.useEffect)(()=>{
        if (!headerElementRef.current) return undefined;
        return (0, $eo9PV.dropTargetForElements)({
            element: headerElementRef.current,
            getData: ()=>({
                    type: (0, $9eH8H.CARD_LIST_DROPPABLE_TYPE)
                }),
            canDrop: (args)=>!isHeaderDropDisabled && args.source.data.type === (0, $94c330523ed620b5$export$4d4e6ab48cd5be5b) && (!args.source.data.cardIsSubtask || !!isCompanyManagedKanban),
            onDrop: (args)=>{
                autobatch(()=>{
                    setIsDraggingOver(false);
                    if (args.source.data.type === (0, $94c330523ed620b5$export$4d4e6ab48cd5be5b)) moveCards({
                        source: {
                            cardId: Number(args.source.data.cardId)
                        },
                        location: {
                            type: 'list',
                            targetListId: cardListId
                        }
                    });
                });
            },
            onDragEnter: ()=>{
                setIsDraggingOver(true);
            },
            onDragLeave: ()=>{
                setIsDraggingOver(false);
            }
        });
    }, [
        autobatch,
        cardListId,
        headerElementRef,
        isHeaderDropDisabled,
        moveCards,
        isCompanyManagedKanban
    ]);
    return {
        isDraggingOver: isDraggingOver
    };
}
function $cdd1a8f1bdd44e97$var$useTransitionZoneDropTarget({ cardListId: cardListId, transitionZoneElementRef: transitionZoneElementRef }) {
    const autobatch = (0, $hKj4G.useAutobatch)();
    const moveCards = (0, $ecfSW.useSimplyMoveCards)();
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    (0, $eUqFw.useEffect)(()=>{
        if (!transitionZoneElementRef.current) return undefined;
        return (0, $eo9PV.dropTargetForElements)({
            element: transitionZoneElementRef.current,
            canDrop: (args)=>args.source.data.type === (0, $94c330523ed620b5$export$4d4e6ab48cd5be5b),
            onDrop: (args)=>{
                autobatch(()=>{
                    if (args.source.data.type === (0, $94c330523ed620b5$export$4d4e6ab48cd5be5b)) moveCards({
                        source: {
                            cardId: Number(args.source.data.cardId)
                        },
                        location: {
                            type: 'list',
                            targetListId: cardListId
                        }
                    });
                    if ((0, $1ybV0.ff)('fix-hanging-low-opacity-after-backlog-card-drag-and-drop_0roex')) dispatch((0, $hzOcT.dragEnd)());
                });
            }
        });
    }, [
        transitionZoneElementRef,
        moveCards,
        cardListId,
        autobatch,
        dispatch
    ]);
}
function $cdd1a8f1bdd44e97$export$4c4dc2d355187470({ headerElementRef: headerElementRef, transitionZoneElementRef: transitionZoneElementRef, cardListId: cardListId, isHeaderDropDisabled: isHeaderDropDisabled }) {
    const { isDraggingOver: isDraggingOver } = $cdd1a8f1bdd44e97$var$useCardListHeaderDropTarget({
        headerElementRef: headerElementRef,
        cardListId: cardListId,
        isHeaderDropDisabled: isHeaderDropDisabled
    });
    $cdd1a8f1bdd44e97$var$useTransitionZoneDropTarget({
        cardListId: cardListId,
        transitionZoneElementRef: transitionZoneElementRef
    });
    return {
        isDraggingOver: isDraggingOver
    };
}

});

parcelRegister("1z582", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bf8d696640b3b0f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");

var $1gQ73 = parcelRequire("1gQ73");

var $bDGeR = parcelRequire("bDGeR");

var $hkGxG = parcelRequire("hkGxG");

var $1ircG = parcelRequire("1ircG");

var $50VCL = parcelRequire("50VCL");

var $gcYr4 = parcelRequire("gcYr4");
const $8bf8d696640b3b0f$var$WorkLoadByAssigneeContainer = ({ cardListId: cardListId, sprintName: sprintName })=>{
    const [isModalOpen, setModal] = (0, $eUqFw.useState)(false);
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const onToggleModal = (0, $eUqFw.useCallback)(()=>{
        setModal((open)=>!open);
    }, [
        setModal
    ]);
    const assignees = (0, $1gQ73.useBacklogSelector)((0, $50VCL.makeWorkLoadByAssignee))(cardListId);
    const estimationType = (0, $1gQ73.useBacklogSelector)((0, $1ircG.getEstimationType));
    const estimationFieldName = (0, $1gQ73.useBacklogSelector)((0, $1ircG.getEstimationName));
    const isRemainingTimeTrackingEnabled = (0, $1gQ73.useBacklogSelector)((0, $1ircG.getIsRemainingTimeTrackingEnabled));
    const isEstimationEnabled = !!estimationType && estimationType !== 'ISSUE_COUNT';
    const timeTrackingOptions = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getTimeTrackingOptions));
    const includeSubtasks = (0, $1gQ73.useBacklogSelector)((0, $50VCL.getIncludeSubtasks));
    const toggleIncludeSubtasks = (event, analyticsEvent)=>{
        dispatch((0, $bDGeR.toggleIncludeSubtasks)());
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'includeSubtasks', {
            includeSubtasks: !includeSubtasks
        });
    };
    const filterUnassignedAssignees = assignees.filter((assignee)=>assignee.name !== undefined);
    const unassigned = (0, $eUqFw.useMemo)(()=>assignees.find((assignee)=>assignee.name === undefined), [
        assignees
    ]);
    return filterUnassignedAssignees.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gcYr4.default), {
        assignees: filterUnassignedAssignees,
        estimationType: estimationType,
        isEstimationEnabled: isEstimationEnabled,
        isRemainingTimeTrackingEnabled: isRemainingTimeTrackingEnabled,
        onToggleModal: onToggleModal,
        isModalOpen: isModalOpen,
        unassigned: unassigned,
        sprintName: sprintName,
        timeTrackingOptions: timeTrackingOptions,
        estimationFieldName: estimationFieldName,
        includeSubtasks: includeSubtasks,
        onToggleIncludeSubtasks: toggleIncludeSubtasks
    }) : null;
};
var $8bf8d696640b3b0f$export$2e2bcd8739ae039 = $8bf8d696640b3b0f$var$WorkLoadByAssigneeContainer;

});
parcelRegister("gcYr4", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8ac54d0d8ebbb79$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $jG1wZ = parcelRequire("jG1wZ");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $dOL7m = parcelRequire("dOL7m");

var $kKCQW = parcelRequire("kKCQW");

var $39L5t = parcelRequire("39L5t");

var $g916f = parcelRequire("g916f");

var $fJyrm = parcelRequire("fJyrm");
const $f8ac54d0d8ebbb79$var$wrapperStyles = null;
const $f8ac54d0d8ebbb79$var$containerStyles = null;
const $f8ac54d0d8ebbb79$var$WorkLoadByAssigneeView = ({ assignees: assignees, estimationType: estimationType, isEstimationEnabled: isEstimationEnabled, isRemainingTimeTrackingEnabled: isRemainingTimeTrackingEnabled, isModalOpen: isModalOpen, onToggleModal: onToggleModal, sprintName: sprintName, unassigned: unassigned, timeTrackingOptions: timeTrackingOptions, estimationFieldName: estimationFieldName, includeSubtasks: includeSubtasks, onToggleIncludeSubtasks: onToggleIncludeSubtasks })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onOpenModal = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        analyticsEvent && (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'openWorkloadModal');
        onToggleModal();
    }, [
        onToggleModal
    ]);
    const firstTenAssignees = (0, $eUqFw.useMemo)(()=>assignees.slice(0, 10), [
        assignees
    ]);
    const assigneeCount = assignees.length;
    const unshownCount = assigneeCount > 10 ? assigneeCount - 10 : undefined;
    const onShowTooltip = (analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'workloadTooltipViewed');
    };
    const moreIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
        label: "More actions",
        primaryColor: "var(--ds-icon, #44546F)"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bahv2br _16jlkb7n _1reo1wug _18m91wug _19pk1b66 _2hwxu2gc _19bvdlk8"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _zulp1b66 _tkqh1txw _dvzt1h6o _1chiglyw"
        ])
    }, firstTenAssignees.map((assignee, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            onShow: onShowTooltip,
            key: `assignee-tool-tip-${index}`,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g916f.default), {
                username: assignee.name ?? '',
                storyPoints: assignee.storyPoints,
                remainingTimeEstimateInSeconds: assignee.remainingTimeEstimateInSeconds,
                issueCount: assignee.issueCount,
                estimationType: estimationType,
                isEstimationEnabled: isEstimationEnabled,
                isRemainingTimeTrackingEnabled: isRemainingTimeTrackingEnabled,
                originalTimeEstimateInSeconds: assignee.originalTimeEstimateInSeconds,
                timeTrackingOptions: timeTrackingOptions,
                estimationFieldName: estimationFieldName
            }),
            position: "bottom-start"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
            src: assignee.profilePicture,
            appearance: "circle",
            name: assignee.name,
            size: "small",
            borderColor: "transparent"
        }))), unshownCount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fJyrm.default), {
        count: unshownCount,
        onClick: onOpenModal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dOL7m.ModalTriggerButton), {
        "aria-label": formatMessage((0, $kKCQW.default).openModalButtonAriaLabel),
        appearance: "subtle",
        iconBefore: moreIcon,
        onClick: onOpenModal
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $39L5t.default), {
        isOpen: isModalOpen,
        onToggleModal: onToggleModal,
        sprintName: sprintName,
        assignees: assignees,
        unassigned: unassigned,
        isEstimationEnabled: isEstimationEnabled,
        isRemainingTimeTrackingEnabled: isRemainingTimeTrackingEnabled,
        estimationType: estimationType,
        timeTrackingOptions: timeTrackingOptions,
        estimationFieldName: estimationFieldName,
        includeSubtasks: includeSubtasks,
        onToggleIncludeSubtasks: onToggleIncludeSubtasks
    }));
};
var $f8ac54d0d8ebbb79$export$2e2bcd8739ae039 = $f8ac54d0d8ebbb79$var$WorkLoadByAssigneeView;

});
parcelRegister("kKCQW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eb8a7062e727b50$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6eb8a7062e727b50$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    openModalButtonAriaLabel: {
        "id": "backlog.card-list.work-load-by-assignee.open-modal-button-aria-label",
        "defaultMessage": "Open workload by assignee summary modal"
    }
});

});

parcelRegister("39L5t", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7e37d760385f8b5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $e270j = parcelRequire("e270j");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $k3YqD = parcelRequire("k3YqD");

var $71RGc = parcelRequire("71RGc");

var $8sZJU = parcelRequire("8sZJU");
const $c7e37d760385f8b5$var$SummaryModal = (props)=>{
    const { isOpen: isOpen, onToggleModal: onToggleModal, sprintName: sprintName, unassigned: unassigned, assignees: assignees, isEstimationEnabled: isEstimationEnabled, isRemainingTimeTrackingEnabled: isRemainingTimeTrackingEnabled, estimationType: estimationType, timeTrackingOptions: timeTrackingOptions, estimationFieldName: estimationFieldName, includeSubtasks: includeSubtasks, onToggleIncludeSubtasks: onToggleIncludeSubtasks } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onCloseModal = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        onToggleModal();
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'closeWorkloadModal');
    }, [
        onToggleModal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k3YqD.ModalDialog), {
        onClose: onCloseModal,
        width: "medium"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $71RGc.default).modalHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $c7e37d760385f8b5$var$sprintNameStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall"
    }, sprintName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c7e37d760385f8b5$var$ToggleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e270j.default), {
        id: "include_subtasks",
        isChecked: includeSubtasks,
        onChange: onToggleIncludeSubtasks
    }), formatMessage((0, $71RGc.default).includeSubtasksToggleLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8sZJU.default), {
        unassigned: unassigned,
        assignees: assignees,
        isEstimationEnabled: isEstimationEnabled,
        isRemainingTimeTrackingEnabled: isRemainingTimeTrackingEnabled,
        estimationType: estimationType,
        timeTrackingOptions: timeTrackingOptions,
        estimationFieldName: estimationFieldName,
        includeSubtasks: includeSubtasks
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        "aria-label": formatMessage((0, $71RGc.default).closeModalButtonAriaLabel),
        appearance: "primary",
        onClick: onCloseModal,
        autoFocus: true
    }, formatMessage((0, $71RGc.default).closeModalButtonLabel)))));
};
var $c7e37d760385f8b5$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $c7e37d760385f8b5$var$SummaryModal;
const $c7e37d760385f8b5$var$ToggleWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _18u0196n",
            __cmplp.className
        ])
    });
});
const $c7e37d760385f8b5$var$sprintNameStyles = (0, $1ZAYh.xcss)({
    paddingBottom: 'space.200'
});

});
parcelRegister("k3YqD", function(module, exports) {

$parcel$export(module.exports, "ModalDialog", () => $d51f615726d59b7b$export$1fa217be60c2f188);

var $eUqFw = parcelRequire("eUqFw");

var $aOw1G = parcelRequire("aOw1G");

var $dnJL9 = parcelRequire("dnJL9");

var $iVF7F = parcelRequire("iVF7F");
const $d51f615726d59b7b$var$ModalDialogOld = ({ onCloseComplete: onCloseComplete, ...rest })=>{
    const returnFocusTarget = (0, $iVF7F.useReturnFocusTo)();
    const { setReturnFocusTo: setReturnFocusTo } = (0, $iVF7F.useModalDialogActions)();
    const handleCloseComplete = (0, $eUqFw.useCallback)((element)=>{
        onCloseComplete && onCloseComplete(element);
    }, [
        onCloseComplete
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            if (returnFocusTarget?.current) {
                returnFocusTarget.current.focus();
                setReturnFocusTo(null);
            }
        }, [
        returnFocusTarget,
        setReturnFocusTo
    ]);
    /**
	 * - If there's no returnFocusTarget, let ModalDialog
	 *   handle passing focus back on close when necessary
	 * - If returnFocusTarget is defined, we'll handle
	 *   passing focus back to this element
	 */ const shouldReturnFocus = !returnFocusTarget;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        shouldReturnFocus: shouldReturnFocus,
        onCloseComplete: handleCloseComplete,
        ...rest
    });
};
const $d51f615726d59b7b$var$ModalDialogNew = ({ shouldReturnFocus: shouldReturnFocus, ...rest })=>{
    const returnFocusTarget = (0, $iVF7F.useReturnFocusTo)();
    const { setReturnFocusTo: setReturnFocusTo } = (0, $iVF7F.useModalDialogActions)();
    (0, $eUqFw.useEffect)(()=>()=>{
            if (returnFocusTarget?.current) {
                !shouldReturnFocus && returnFocusTarget.current.focus();
                setReturnFocusTo(null);
            }
        }, [
        returnFocusTarget,
        setReturnFocusTo,
        shouldReturnFocus
    ]);
    /**
	 *  when shouldReturnFocus is defined,
	 * 	we won't handle passing focus back to this element
	 *	we will ignore the returnFocusTarget
	 */ const returnFocus = shouldReturnFocus ?? !returnFocusTarget;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        shouldReturnFocus: returnFocus,
        ...rest
    });
};
const $d51f615726d59b7b$export$1fa217be60c2f188 = (0, $dnJL9.componentWithFG)('a11y-jira-team_software_modal_type_change', $d51f615726d59b7b$var$ModalDialogNew, $d51f615726d59b7b$var$ModalDialogOld);

});

parcelRegister("71RGc", function(module, exports) {

$parcel$export(module.exports, "default", () => $32ea1ae7bf9e2ae4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $32ea1ae7bf9e2ae4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    modalHeader: {
        "id": "backlog.card-list.work-load-by-assignee.summary-modal.modal-header",
        "defaultMessage": "Workload by assignee"
    },
    closeModalButtonAriaLabel: {
        "id": "backlog.card-list.work-load-by-assignee.summary-modal.close-modal-button-aria-label",
        "defaultMessage": "Close modal"
    },
    closeModalButtonLabel: {
        "id": "backlog.card-list.work-load-by-assignee.summary-modal.close-modal-button-label",
        "defaultMessage": "Done"
    },
    includeSubtasksToggleLabel: {
        "id": "backlog.card-list.work-load-by-assignee.summary-modal.include-subtasks-toggle-label",
        "defaultMessage": "Include subtasks in estimates"
    },
    closeModalButtonLabelOld: {
        "id": "backlog.card-list.work-load-by-assignee.summary-modal.close-modal-button-label-old",
        "defaultMessage": "Close"
    }
});

});

parcelRegister("8sZJU", function(module, exports) {

$parcel$export(module.exports, "default", () => $630f365ebd7ae2c6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7TyGu = parcelRequire("7TyGu");

var $6UC43 = parcelRequire("6UC43");

var $dHBZE = parcelRequire("dHBZE");

var $17ORY = parcelRequire("17ORY");
const $630f365ebd7ae2c6$var$SummaryTable = ({ assignees: assignees, unassigned: unassigned, isEstimationEnabled: isEstimationEnabled, isRemainingTimeTrackingEnabled: isRemainingTimeTrackingEnabled, estimationType: estimationType, timeTrackingOptions: timeTrackingOptions, estimationFieldName: estimationFieldName, includeSubtasks: includeSubtasks })=>{
    const total = (0, $eUqFw.useMemo)(()=>assignees.reduce((prev, assignee)=>({
                storyPoints: prev.storyPoints + assignee.storyPoints,
                remainingTimeEstimateInSeconds: prev.remainingTimeEstimateInSeconds + assignee.remainingTimeEstimateInSeconds,
                originalTimeEstimateInSeconds: prev.originalTimeEstimateInSeconds + assignee.originalTimeEstimateInSeconds,
                issueCount: prev.issueCount + assignee.issueCount,
                subtaskCount: (prev.subtaskCount ?? 0) + (assignee.subtaskCount ?? 0)
            }), unassigned ?? {
            storyPoints: 0,
            remainingTimeEstimateInSeconds: 0,
            originalTimeEstimateInSeconds: 0,
            issueCount: 0,
            subtaskCount: 0
        }), [
        assignees,
        unassigned
    ]);
    const isStoryPointsEnabled = estimationType === (0, $7TyGu.STORY_POINTS) && isEstimationEnabled;
    const isOriginalEstimationEnabled = estimationType === (0, $7TyGu.ORIGINAL_ESTIMATE) && isEstimationEnabled;
    const isRemainingTimeEstimationEnabled = isRemainingTimeTrackingEnabled && isEstimationEnabled;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("table", {
        className: (0, $7JEyt.default)([
            "_yq5h18uv _btyzidpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $17ORY.default), {
        isStoryPointsEnabled: isStoryPointsEnabled,
        isOriginalEstimationEnabled: isOriginalEstimationEnabled,
        isRemainingTimeEstimationEnabled: isRemainingTimeEstimationEnabled,
        estimationFieldName: estimationFieldName,
        includeSubtasks: includeSubtasks
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6UC43.default), {
        isStoryPointsEnabled: isStoryPointsEnabled,
        isOriginalEstimationEnabled: isOriginalEstimationEnabled,
        isRemainingTimeEstimationEnabled: isRemainingTimeEstimationEnabled,
        assignees: assignees,
        unassigned: unassigned,
        timeTrackingOptions: timeTrackingOptions,
        includeSubtasks: includeSubtasks,
        estimationType: estimationType
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dHBZE.default), {
        total: total,
        isStoryPointsEnabled: isStoryPointsEnabled,
        isOriginalEstimationEnabled: isOriginalEstimationEnabled,
        isRemainingTimeEstimationEnabled: isRemainingTimeEstimationEnabled,
        timeTrackingOptions: timeTrackingOptions,
        includeSubtasks: includeSubtasks
    }));
};
var $630f365ebd7ae2c6$export$2e2bcd8739ae039 = $630f365ebd7ae2c6$var$SummaryTable;
const $630f365ebd7ae2c6$var$styles = null;

});
parcelRegister("6UC43", function(module, exports) {

$parcel$export(module.exports, "default", () => $c191a6efc5a26018$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $9nkwJ = parcelRequire("9nkwJ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7v0hO = parcelRequire("7v0hO");

var $9DRwn = parcelRequire("9DRwn");

var $9zxrb = parcelRequire("9zxrb");

var $98LRm = parcelRequire("98LRm");
const $c191a6efc5a26018$var$SummaryTableBody = ({ assignees: assignees, unassigned: unassigned, isStoryPointsEnabled: isStoryPointsEnabled, isOriginalEstimationEnabled: isOriginalEstimationEnabled, isRemainingTimeEstimationEnabled: isRemainingTimeEstimationEnabled, timeTrackingOptions: timeTrackingOptions, includeSubtasks: includeSubtasks, estimationType: estimationType })=>{
    const intl = (0, $5JgJ2.default)();
    const { formatMessage: formatMessage } = intl;
    const formatStoryPointsTotal = (0, $9DRwn.useFormatStoryPointsTotal)();
    const assigneesList = (0, $98LRm.useSortAssignees)(assignees, estimationType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tbody", {
        className: (0, $7JEyt.default)([
            "_x3dorthz"
        ])
    }, unassigned && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _zulpu2gc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        appearance: "circle",
        size: "small"
    }), formatMessage((0, $9zxrb.default).unassignedLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, unassigned.issueCount), includeSubtasks && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, unassigned.subtaskCount), isStoryPointsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
        max: 1000
    }, formatStoryPointsTotal(unassigned.storyPoints))), isOriginalEstimationEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), null, (0, $7v0hO.timeTrackingFormatter)(unassigned.originalTimeEstimateInSeconds, timeTrackingOptions, intl))), isRemainingTimeEstimationEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), null, (0, $7v0hO.timeTrackingFormatter)(unassigned.remainingTimeEstimateInSeconds, timeTrackingOptions, intl)))), assigneesList.map((assignee, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", {
            key: `table-row-key-${i}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
            className: (0, $7JEyt.default)([
                "_1e0c1txw _4cvr1h6o _zulpu2gc"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
            src: assignee.profilePicture,
            appearance: "circle",
            name: assignee.name,
            size: "small"
        }), assignee.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, assignee.issueCount), includeSubtasks && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, assignee.subtaskCount), isStoryPointsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
            max: 1000
        }, formatStoryPointsTotal(assignee.storyPoints))), isOriginalEstimationEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), null, (0, $7v0hO.timeTrackingFormatter)(assignee.originalTimeEstimateInSeconds, timeTrackingOptions, intl))), isRemainingTimeEstimationEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), null, (0, $7v0hO.timeTrackingFormatter)(assignee.remainingTimeEstimateInSeconds, timeTrackingOptions, intl))))));
};
var $c191a6efc5a26018$export$2e2bcd8739ae039 = $c191a6efc5a26018$var$SummaryTableBody;
const $c191a6efc5a26018$var$styles = null;
const $c191a6efc5a26018$var$styles2 = null;

});
parcelRegister("9zxrb", function(module, exports) {

$parcel$export(module.exports, "default", () => $0647255599d5cbee$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0647255599d5cbee$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    unassignedLabel: {
        "id": "backlog.card-list.work-load-by-assignee.summary-modal.summary-table.summary-table-body.unassigned-label",
        "defaultMessage": "Unassigned"
    }
});

});

parcelRegister("98LRm", function(module, exports) {

$parcel$export(module.exports, "useSortAssignees", () => $03a4772b027a83c5$export$2d72e149742335a5);

var $eUqFw = parcelRequire("eUqFw");

var $7TyGu = parcelRequire("7TyGu");
function $03a4772b027a83c5$export$2d72e149742335a5(assignees, estimationType) {
    const sortKey = $03a4772b027a83c5$export$5df81d5bd5f33f5b(estimationType);
    return (0, $eUqFw.useMemo)(()=>[
            ...assignees
        ].sort((a, b)=>b[sortKey] - a[sortKey]), [
        assignees,
        sortKey
    ]);
}
function $03a4772b027a83c5$export$5df81d5bd5f33f5b(estimationType) {
    switch(estimationType){
        case 0, $7TyGu.STORY_POINTS:
            return 'storyPoints';
        case 0, $7TyGu.ORIGINAL_ESTIMATE:
            return 'originalTimeEstimateInSeconds';
        default:
            return 'issueCount';
    }
}

});


parcelRegister("dHBZE", function(module, exports) {

$parcel$export(module.exports, "default", () => $66afc81dabeced12$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $9nkwJ = parcelRequire("9nkwJ");

var $hI5oG = parcelRequire("hI5oG");

var $lcnyw = parcelRequire("lcnyw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7v0hO = parcelRequire("7v0hO");

var $9DRwn = parcelRequire("9DRwn");

var $Ivofv = parcelRequire("Ivofv");
const $66afc81dabeced12$var$gridSize = (0, $lcnyw.gridSize)();
const $66afc81dabeced12$var$SummaryTableFooter = (props)=>{
    const { total: total, isStoryPointsEnabled: isStoryPointsEnabled, isOriginalEstimationEnabled: isOriginalEstimationEnabled, isRemainingTimeEstimationEnabled: isRemainingTimeEstimationEnabled, timeTrackingOptions: timeTrackingOptions, includeSubtasks: includeSubtasks } = props;
    const intl = (0, $5JgJ2.default)();
    const { formatMessage: formatMessage } = intl;
    const formatStoryPointsTotal = (0, $9DRwn.useFormatStoryPointsTotal)();
    const originalTimeEstimate = (0, $7v0hO.timeTrackingFormatter)(total.originalTimeEstimateInSeconds, timeTrackingOptions, intl);
    const remainingTimeEstimate = (0, $7v0hO.timeTrackingFormatter)(total.remainingTimeEstimateInSeconds, timeTrackingOptions, intl);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tfoot", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
        className: (0, $7JEyt.default)([
            "_n7zl1on0 _x3do1on0 _ca0qu2gc _n3tdu2gc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h200",
        as: "h3"
    }, formatMessage((0, $Ivofv.default).totalSummaryLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
        className: (0, $7JEyt.default)([
            "_n7zl1on0 _x3do1on0 _ca0qu2gc _n3tdu2gc"
        ])
    }, total.issueCount), includeSubtasks && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
        className: (0, $7JEyt.default)([
            "_n7zl1on0 _x3do1on0 _ca0qu2gc _n3tdu2gc"
        ])
    }, total.subtaskCount), isStoryPointsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
        className: (0, $7JEyt.default)([
            "_n7zl1on0 _x3do1on0 _ca0qu2gc _n3tdu2gc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
        max: 1000
    }, formatStoryPointsTotal(total.storyPoints))), isOriginalEstimationEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
        className: (0, $7JEyt.default)([
            "_n7zl1on0 _x3do1on0 _ca0qu2gc _n3tdu2gc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), null, originalTimeEstimate)), isRemainingTimeEstimationEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
        className: (0, $7JEyt.default)([
            "_n7zl1on0 _x3do1on0 _ca0qu2gc _n3tdu2gc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), null, remainingTimeEstimate))));
};
var $66afc81dabeced12$export$2e2bcd8739ae039 = $66afc81dabeced12$var$SummaryTableFooter;
const $66afc81dabeced12$var$bottomBorderStyles = null;

});
parcelRegister("Ivofv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f09dbe4caaf50f8c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f09dbe4caaf50f8c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    totalSummaryLabel: {
        "id": "backlog.card-list.work-load-by-assignee.summary-modal.summary-table.summary-table-footer.total-summary-label",
        "defaultMessage": "Total"
    }
});

});


parcelRegister("17ORY", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e0b2994e60a9915$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $lcnyw = parcelRequire("lcnyw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2JGx3 = parcelRequire("2JGx3");
const $9e0b2994e60a9915$var$gridSize = (0, $lcnyw.gridSize)();
const $9e0b2994e60a9915$var$SummaryTableHeader = ({ isStoryPointsEnabled: isStoryPointsEnabled, isOriginalEstimationEnabled: isOriginalEstimationEnabled, isRemainingTimeEstimationEnabled: isRemainingTimeEstimationEnabled, estimationFieldName: estimationFieldName, includeSubtasks: includeSubtasks })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const formattedEstimationFieldName = (0, $eUqFw.useMemo)(()=>estimationFieldName ? estimationFieldName[0].toUpperCase() + estimationFieldName.slice(1).toLowerCase() : '', [
        estimationFieldName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("thead", {
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _154iidpf _1pbyzo7u _1bsb1osq _bfhk1bhr"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("th", {
        className: (0, $7JEyt.default)([
            "_n3tdu2gc _n7zl1on0"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h200"
    }, formatMessage((0, $2JGx3.default).assigneeColumnHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("th", {
        className: (0, $7JEyt.default)([
            "_n3tdu2gc _n7zl1on0"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h200"
    }, formatMessage((0, $2JGx3.default).issueCountColumnHeader))), includeSubtasks && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("th", {
        className: (0, $7JEyt.default)([
            "_n3tdu2gc _n7zl1on0"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h200"
    }, formatMessage((0, $2JGx3.default).subtasksColumnHeader))), isStoryPointsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("th", {
        className: (0, $7JEyt.default)([
            "_n3tdu2gc _n7zl1on0"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h200"
    }, formattedEstimationFieldName)), isOriginalEstimationEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("th", {
        className: (0, $7JEyt.default)([
            "_n3tdu2gc _n7zl1on0"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h200"
    }, formattedEstimationFieldName)), isRemainingTimeEstimationEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("th", {
        className: (0, $7JEyt.default)([
            "_n3tdu2gc _n7zl1on0"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h200"
    }, formatMessage((0, $2JGx3.default).remainingEstimateColumnHeader)))));
};
var $9e0b2994e60a9915$export$2e2bcd8739ae039 = $9e0b2994e60a9915$var$SummaryTableHeader;
const $9e0b2994e60a9915$var$styles = null;
const $9e0b2994e60a9915$var$bottomBorderStyles = null;

});
parcelRegister("2JGx3", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d24161e27459e99$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9d24161e27459e99$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    assigneeColumnHeader: {
        "id": "backlog.card-list.work-load-by-assignee.summary-modal.summary-table.summary-table-header.assignee-column-header",
        "defaultMessage": "Assignee"
    },
    issueCountColumnHeader: {
        "id": "backlog.card-list.work-load-by-assignee.summary-modal.summary-table.summary-table-header.issue-count-column-header",
        "defaultMessage": "Issues"
    },
    remainingEstimateColumnHeader: {
        "id": "backlog.card-list.work-load-by-assignee.summary-modal.summary-table.summary-table-header.remaining-estimate-column-header",
        "defaultMessage": "Remaining time estimate"
    },
    subtasksColumnHeader: {
        "id": "backlog.card-list.work-load-by-assignee.summary-modal.summary-table.summary-table-header.subtasks-column-header",
        "defaultMessage": "Subtasks"
    }
});

});




parcelRegister("g916f", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cded52be84a979a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7v0hO = parcelRequire("7v0hO");

var $7TyGu = parcelRequire("7TyGu");

var $7bn8U = parcelRequire("7bn8U");
const $4cded52be84a979a$var$containerStyles = null;
const $4cded52be84a979a$var$containerP = null;
const $4cded52be84a979a$var$TooltipContent = ({ username: username, storyPoints: storyPoints, remainingTimeEstimateInSeconds: remainingTimeEstimateInSeconds, originalTimeEstimateInSeconds: originalTimeEstimateInSeconds, issueCount: issueCount, estimationType: estimationType, isEstimationEnabled: isEstimationEnabled, isRemainingTimeTrackingEnabled: isRemainingTimeTrackingEnabled, timeTrackingOptions: timeTrackingOptions, estimationFieldName: estimationFieldName })=>{
    const intl = (0, $5JgJ2.default)();
    const { formatMessage: formatMessage } = intl;
    const isShowTimeEstimateVisible = isEstimationEnabled && estimationType === (0, $7TyGu.ORIGINAL_ESTIMATE);
    const isStoryPointsVisible = isEstimationEnabled && estimationType === (0, $7TyGu.STORY_POINTS);
    const remainingTimeEstimate = (0, $eUqFw.useMemo)(()=>(0, $7v0hO.timeTrackingFormatter)(remainingTimeEstimateInSeconds, timeTrackingOptions, intl), [
        remainingTimeEstimateInSeconds,
        timeTrackingOptions,
        intl
    ]);
    const originalTimeEstimate = (0, $eUqFw.useMemo)(()=>(0, $7v0hO.timeTrackingFormatter)(originalTimeEstimateInSeconds, timeTrackingOptions, intl), [
        originalTimeEstimateInSeconds,
        timeTrackingOptions,
        intl
    ]);
    const originalTimeEstimateField = (0, $eUqFw.useMemo)(()=>`${originalTimeEstimate} ${estimationFieldName.toLowerCase()}`, [
        originalTimeEstimate,
        estimationFieldName
    ]);
    const numericEstimateField = (0, $eUqFw.useMemo)(()=>`${storyPoints} ${estimationFieldName.toLowerCase()}`, [
        storyPoints,
        estimationFieldName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_vwz4pxbi _1wybutpp _1yt41b66"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, username), isStoryPointsVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ])
    }, numericEstimateField), isShowTimeEstimateVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ])
    }, originalTimeEstimateField), isRemainingTimeTrackingEnabled && isEstimationEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ])
    }, formatMessage((0, $7bn8U.default).remainingTimeEstimate, {
        remainingTimeEstimate: remainingTimeEstimate
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ])
    }, formatMessage((0, $7bn8U.default).issueCount, {
        issueCount: issueCount
    })));
};
var $4cded52be84a979a$export$2e2bcd8739ae039 = $4cded52be84a979a$var$TooltipContent;

});
parcelRegister("7bn8U", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f4a556b10506e53$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3f4a556b10506e53$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    remainingTimeEstimate: {
        "id": "backlog.card-list.work-load-by-assignee.tooltip-content.remaining-time-estimate",
        "defaultMessage": "{remainingTimeEstimate} remaining time estimate"
    },
    issueCount: {
        "id": "backlog.card-list.work-load-by-assignee.tooltip-content.issue-count",
        "defaultMessage": "{issueCount} {issueCount, plural, one {issue} other {issues}}"
    }
});

});


parcelRegister("fJyrm", function(module, exports) {

$parcel$export(module.exports, "default", () => $18c6ba71ca789e9d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bCpVy = parcelRequire("bCpVy");
const $18c6ba71ca789e9d$var$UnshownCount = ({ count: count, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        appearance: "circle",
        size: "small",
        onClick: onClick
    }, ({ testId: _, className: className, ref: ref, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
            "aria-label": formatMessage((0, $bCpVy.default).openModalButtonAriaLabel),
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            ref: ref,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $7JEyt.default)([
                "_11c81vlj _abyqc8hx _bfhk155y _19itglyw _16qsglyw _irr3u9me",
                className
            ]),
            ...props
        }, `+${count}`));
};
var $18c6ba71ca789e9d$export$2e2bcd8739ae039 = $18c6ba71ca789e9d$var$UnshownCount;
const $18c6ba71ca789e9d$var$buttonStyles = null;

});
parcelRegister("bCpVy", function(module, exports) {

$parcel$export(module.exports, "default", () => $655ee54d51e63892$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $655ee54d51e63892$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    openModalButtonAriaLabel: {
        "id": "backlog.card-list.work-load-by-assignee.unshown-count.open-modal-button-aria-label",
        "defaultMessage": "Open workload by assignee summary modal"
    }
});

});






parcelRegister("6Euqa", function(module, exports) {

$parcel$export(module.exports, "default", () => $20f0041efba1af71$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $heNSb = parcelRequire("heNSb");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");

var $03OTw = parcelRequire("03OTw");
function $20f0041efba1af71$export$2e2bcd8739ae039() {
    const intl = (0, $5JgJ2.default)();
    const boardName = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getName));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: intl.formatMessage((0, $03OTw.default).pageTitle, {
            boardName: boardName
        })
    });
}

});
parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

var $3fq1f = parcelRequire("3fq1f");
class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});

parcelRegister("03OTw", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8d26e7c515898b3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a8d26e7c515898b3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    pageTitle: {
        "id": "backlog.document-title.page-title",
        "defaultMessage": "{boardName} - Backlog"
    }
});

});


parcelRegister("e3kiu", function(module, exports) {

$parcel$export(module.exports, "FiltersStorage", () => $e8258e255baf41be$export$311c7d3073893ae);

var $eUqFw = parcelRequire("eUqFw");

var $3oq6o = parcelRequire("3oq6o");

var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");

var $j258X = parcelRequire("j258X");
const $e8258e255baf41be$export$311c7d3073893ae = ()=>{
    const isCMPBacklog = (0, $j258X.useIsCMPBacklog)();
    const boardId = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getRapidViewId));
    const filters = (0, $1gQ73.useBacklogSelector)((state)=>state.ui.filters);
    (0, $eUqFw.useEffect)(()=>{
        if (isCMPBacklog) (0, $3oq6o.setCachedFilters)('backlog', boardId, filters);
    }, [
        boardId,
        filters,
        isCMPBacklog
    ]);
    return null;
};

});
parcelRegister("3oq6o", function(module, exports) {

$parcel$export(module.exports, "getCachedFilters", () => $92e2723e83a6a6ab$export$cc165fee46da38d4);
$parcel$export(module.exports, "setCachedFilters", () => $92e2723e83a6a6ab$export$fb56bc6b9e534664);

var $aZaPn = parcelRequire("aZaPn");
const $92e2723e83a6a6ab$var$localStorage = (0, $aZaPn.createLocalStorageProvider)('software');
const $92e2723e83a6a6ab$var$CACHED_FILTERS_KEY = 'filters';
const $92e2723e83a6a6ab$var$getKey = (feature, projectId)=>`${feature}-${$92e2723e83a6a6ab$var$CACHED_FILTERS_KEY}.${projectId}`;
function $92e2723e83a6a6ab$export$cc165fee46da38d4(feature, projectId) {
    return $92e2723e83a6a6ab$var$localStorage.get($92e2723e83a6a6ab$var$getKey(feature, projectId)) || undefined;
}
function $92e2723e83a6a6ab$export$fb56bc6b9e534664(feature, projectId, filters) {
    if (filters && Object.entries(filters).length > 0) $92e2723e83a6a6ab$var$localStorage.set($92e2723e83a6a6ab$var$getKey(feature, projectId), filters);
    else $92e2723e83a6a6ab$var$localStorage.remove($92e2723e83a6a6ab$var$getKey(feature, projectId));
}

});


parcelRegister("c6jno", function(module, exports) {

$parcel$export(module.exports, "default", () => $f93b61c5e7728612$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cmc0m = parcelRequire("cmc0m");

var $1gQ73 = parcelRequire("1gQ73");

var $bP7Jx = parcelRequire("bP7Jx");
function $f93b61c5e7728612$export$2e2bcd8739ae039() {
    const numCards = (0, $1gQ73.useBacklogSelector)((state)=>Object.keys((0, $bP7Jx.getCards)(state)).length);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cmc0m.default), {
        analyticsAttributes: {
            numCards: numCards
        }
    });
}

});
parcelRegister("cmc0m", function(module, exports) {

$parcel$export(module.exports, "isMacOS", () => $cda4b48a66b8cbd6$export$6159e43e50a41987);
$parcel$export(module.exports, "useGlobalSearch", () => $cda4b48a66b8cbd6$export$1df85516f1b3e335);
$parcel$export(module.exports, "default", () => $cda4b48a66b8cbd6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gtzuR = parcelRequire("gtzuR");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $cda4b48a66b8cbd6$export$6159e43e50a41987 = ()=>Boolean(navigator && /^Mac/.test(navigator.platform));
const $cda4b48a66b8cbd6$export$1df85516f1b3e335 = (/** Callback to be fired when global search is used */ callback, getGlobalDocument = ()=>document)=>{
    (0, $eUqFw.useEffect)(()=>{
        const trackGlobalSearch = (event)=>{
            const isMacOs = $cda4b48a66b8cbd6$export$6159e43e50a41987();
            if (isMacOs && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('f') && event.metaKey || !isMacOs && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('f') && event.ctrlKey) callback({
                isMacOs: isMacOs,
                event: event
            });
        };
        getGlobalDocument().addEventListener('keydown', trackGlobalSearch);
        return ()=>getGlobalDocument().removeEventListener('keydown', trackGlobalSearch);
    }, [
        callback,
        getGlobalDocument
    ]);
};
const $cda4b48a66b8cbd6$var$GlobalSearchTracker = ({ getGlobalDocument: getGlobalDocument = ()=>document, fireAnalytics: fireAnalytics = (0, $jMP2a.fireTrackAnalytics), analyticsAttributes: analyticsAttributes = {} })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onGlobalSearch = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7031 - Binding element 'isMacOs' implicitly has an 'any' type.
    ({ isMacOs: isMacOs })=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'triggered',
            actionSubject: 'globalSearch'
        });
        const attributes = {
            ...analyticsAttributes,
            isMacOs: isMacOs
        };
        fireAnalytics(analyticsEvent, 'globalSearch triggered', attributes);
    }, [
        analyticsAttributes,
        createAnalyticsEvent,
        fireAnalytics
    ]);
    $cda4b48a66b8cbd6$export$1df85516f1b3e335(onGlobalSearch, getGlobalDocument);
    return null;
};
var $cda4b48a66b8cbd6$export$2e2bcd8739ae039 = $cda4b48a66b8cbd6$var$GlobalSearchTracker;

});


parcelRegister("8viQs", function(module, exports) {

$parcel$export(module.exports, "default", () => $62cef09e65beb556$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $c76ap = parcelRequire("c76ap");

var $3a8wJ = parcelRequire("3a8wJ");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $4ACoF = parcelRequire("4ACoF");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8MrYx = parcelRequire("8MrYx");

var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");

var $7kNqR = parcelRequire("7kNqR");

var $8rowP = parcelRequire("8rowP");

var $LiGHk = parcelRequire("LiGHk");

var $lxSty = parcelRequire("lxSty");

var $4rWh2 = parcelRequire("4rWh2");
const $62cef09e65beb556$export$2676d4da338c3ba1 = (state)=>(0, $7kNqR.canEditBoardConfig)(state) || (0, $hkGxG.getIsCompanyManaged)(state);
function $62cef09e65beb556$var$HeaderNew(props) {
    const { customFiltersQueryRef: customFiltersQueryRef, versionFilterRelayQueryRef: versionFilterRelayQueryRef } = props;
    const isMenuVisible = (0, $1gQ73.useBacklogSelector)($62cef09e65beb556$export$2676d4da338c3ba1);
    const isFilterSelectionBarOpen = (0, $8MrYx.useShowQuickFilters)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ACoF.PageTopBar), {
        bottomBar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: (0, $1ybV0.ff)('sea-2744-backlog-dropdown-bugfix_px6bs') ? $62cef09e65beb556$var$controlsBarWrapperNew : $62cef09e65beb556$var$controlsBarWrapperOld
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $LiGHk.default), {
            customFiltersQueryRef: customFiltersQueryRef,
            versionFilterRelayQueryRef: versionFilterRelayQueryRef
        })),
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8rowP.ActionsBar), {
            isMenuVisible: isMenuVisible
        }),
        wrapAtMd: true
    }), isFilterSelectionBarOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lxSty.default), null));
}
function $62cef09e65beb556$var$HeaderOld(props) {
    const { customFiltersQueryRef: customFiltersQueryRef, versionFilterRelayQueryRef: versionFilterRelayQueryRef } = props;
    const isMenuVisible = (0, $1gQ73.useBacklogSelector)($62cef09e65beb556$export$2676d4da338c3ba1);
    const boardType = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getBoardType));
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a8wJ.default), {
        truncateTitle: true,
        breadcrumbs: $62cef09e65beb556$var$breadcrumbs,
        bottomBar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $LiGHk.default), {
            customFiltersQueryRef: customFiltersQueryRef,
            versionFilterRelayQueryRef: versionFilterRelayQueryRef
        }),
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8rowP.ActionsBar), {
            isMenuVisible: isMenuVisible,
            boardType: boardType
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($62cef09e65beb556$var$HeadingStyle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($62cef09e65beb556$var$TruncatingTextStyle, null, formatMessage((0, $4rWh2.default).pageTitle))));
}
var $62cef09e65beb556$export$2e2bcd8739ae039 = (0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('sea-2744-jsw-tabs-nav'), $62cef09e65beb556$var$HeaderNew, $62cef09e65beb556$var$HeaderOld);
const $62cef09e65beb556$var$controlsBarWrapperOld = (0, $1ZAYh.xcss)({
    // enough width to fit expanded search + avatar filter + clear filters button
    minWidth: '480px',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'end',
    flex: '1 1 auto'
});
const $62cef09e65beb556$var$controlsBarWrapperNew = (0, $1ZAYh.xcss)({
    // enough width to fit expanded search + avatar filter + clear filters button
    minWidth: '480px',
    display: 'flex',
    alignItems: 'end',
    flex: '1 1 auto'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $62cef09e65beb556$export$c7432936d9c50db7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11w3glyw",
            __cmplp.className
        ])
    });
});
const $62cef09e65beb556$var$breadcrumbs = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($62cef09e65beb556$export$c7432936d9c50db7, {
    "data-fullscreen-id": "fullscreen-backlog-breadcrumbs"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c76ap.default), null)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $62cef09e65beb556$var$HeadingStyle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $62cef09e65beb556$var$TruncatingTextStyle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721q9c _1reo15vq _18m915vq _1bto1l2s _16jlidpf _1o9zkb7n _i0dl1wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4ACoF", function(module, exports) {

$parcel$export(module.exports, "PageTopBar", () => $d74ce2d0cb0e9587$export$7e5801dc91bf1819);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $4Ywu9 = parcelRequire("4Ywu9");
var $1ZAYh = parcelRequire("1ZAYh");

var $3a8wJ = parcelRequire("3a8wJ");

var $1ybV0 = parcelRequire("1ybV0");

const $d74ce2d0cb0e9587$var$SporkPageTopBar = ({ bottomBar: bottomBar, actions: actions, wrapAtMd: wrapAtMd = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: (0, $0b51e3566777dd51$export$90c4434a1e138106),
        xcss: [
            $d74ce2d0cb0e9587$var$wrapperStyles,
            wrapAtMd ? $d74ce2d0cb0e9587$var$wrapAtMdStyle : $d74ce2d0cb0e9587$var$noWrapStyle
        ]
    }, bottomBar, actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: (0, $0b51e3566777dd51$export$1742330ac6a668f0),
        xcss: [
            $d74ce2d0cb0e9587$var$actionsBoxStyles,
            wrapAtMd && $d74ce2d0cb0e9587$var$actionsBoxAtMdStyles
        ]
    }, actions));
const $d74ce2d0cb0e9587$export$7e5801dc91bf1819 = (props)=>(0, $1ybV0.ff)('sea-2744-jsw-tabs-nav') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d74ce2d0cb0e9587$var$SporkPageTopBar, {
        bottomBar: props.bottomBar,
        actions: props.actions,
        wrapAtMd: props.wrapAtMd
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a8wJ.default), props);
const $d74ce2d0cb0e9587$var$noWrapStyle = (0, $1ZAYh.xcss)({
    flexWrap: 'nowrap'
});
const $d74ce2d0cb0e9587$var$wrapAtMdStyle = (0, $1ZAYh.xcss)({
    flexWrap: 'wrap-reverse',
    [(0, $4Ywu9.media).above.md]: {
        flexWrap: 'nowrap'
    }
});
const $d74ce2d0cb0e9587$var$wrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    paddingTop: 'space.150',
    paddingBottom: 'space.150',
    justifyContent: 'space-between',
    gap: 'space.100',
    [(0, $4Ywu9.media).above.md]: {
        gap: 'space.300'
    }
});
const $d74ce2d0cb0e9587$var$actionsBoxAtMdStyles = (0, $1ZAYh.xcss)({
    flex: '1 1 auto',
    [(0, $4Ywu9.media).above.md]: {
        flex: '0 1 auto'
    }
});
const $d74ce2d0cb0e9587$var$actionsBoxStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'auto',
    display: 'flex',
    justifyContent: 'flex-end',
    flex: '0 0 auto'
});

});
const $0b51e3566777dd51$export$90c4434a1e138106 = 'horizontal-nav-page-topbar.ui.horizontal-nav-page-topbar';
const $0b51e3566777dd51$export$1742330ac6a668f0 = 'horizontal-nav-page-topbar.ui.horizontal-nav-page-topbar.actions';


parcelRegister("8rowP", function(module, exports) {

$parcel$export(module.exports, "ActionsBar", () => $0a5aaebc8bfbbf3f$export$8c8e9293b68041de);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bLFgh = parcelRequire("bLFgh");

var $c0jFd = parcelRequire("c0jFd");
var $4Ywu9 = parcelRequire("4Ywu9");
var $1ZAYh = parcelRequire("1ZAYh");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kMTQf = parcelRequire("kMTQf");

var $f6xJy = parcelRequire("f6xJy");

var $ab6rA = parcelRequire("ab6rA");

var $1gQ73 = parcelRequire("1gQ73");

var $a9os4 = parcelRequire("a9os4");

var $hkGxG = parcelRequire("hkGxG");

var $dtV8v = parcelRequire("dtV8v");

var $8wl1S = parcelRequire("8wl1S");

var $4hiYU = parcelRequire("4hiYU");

var $bATA3 = parcelRequire("bATA3");

var $ftcXB = parcelRequire("ftcXB");

var $7QvkH = parcelRequire("7QvkH");

var $2KUJD = parcelRequire("2KUJD");

var $k4jYJ = parcelRequire("k4jYJ");
const $0a5aaebc8bfbbf3f$var$ActionsBarNew = ({ isMenuVisible: isMenuVisible })=>{
    const isCompanyManaged = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getIsCompanyManaged));
    const rapidViewId = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getRapidViewId));
    const projectKey = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getProjectKey));
    const appEditions = (0, $ab6rA.useAppEditions)();
    const isInsightsOpen = (0, $8wl1S.useIsInsightsPanelOpen)();
    const backlogWithSprints = (0, $1gQ73.useBacklogSelector)((0, $dtV8v.isBacklogWithSprints));
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const handleOnToggle = (0, $eUqFw.useCallback)((panelType)=>{
        dispatch((0, $a9os4.togglePanel)(panelType));
    }, [
        dispatch
    ]);
    const showImportWork = (0, $79xbN.expVal)('jsw_onboarding_raising_awareness_of_importer', 'cohort', 'not-enrolled') !== 'not-enrolled';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        justifyContent: "end",
        wrap: "wrap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        justifyContent: "end",
        xcss: $0a5aaebc8bfbbf3f$var$extensionsStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4hiYU.default), null), isCompanyManaged && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kMTQf.BoardConnectToolbar), {
        boardId: rapidViewId,
        projectKey: projectKey,
        mode: "plan"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, showImportWork && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f6xJy.ImportWorkButton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ftcXB.FullscreenButton), {
        boardId: Number(rapidViewId)
    }), backlogWithSprints && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QvkH.InsightsButton), {
        onToggle: handleOnToggle,
        isInsightsPanelOpen: isInsightsOpen,
        boardId: Number(rapidViewId),
        edition: appEditions.software
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k4jYJ.default), null), isMenuVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bATA3.default), null)));
};
const $0a5aaebc8bfbbf3f$var$ActionsBarOld = ({ isMenuVisible: isMenuVisible, boardType: boardType })=>{
    const isCompanyManaged = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getIsCompanyManaged));
    const rapidViewId = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getRapidViewId));
    const projectKey = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getProjectKey));
    const shareContentType = `${boardType}_backlog`;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onShareButtonClick = ()=>{
        if ((0, $79xbN.expValEquals)('jsw_enable_tmp_users_with_share_feature', 'cohort', 'variation')) {
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'shareContentType', {
                contentType: shareContentType
            });
        }
    };
    const iconsComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4hiYU.default), null), isCompanyManaged || (0, $79xbN.expValEquals)('jsw_enable_tmp_users_with_share_feature', 'cohort', 'variation') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2KUJD.ShareButton), {
        shareContentType: shareContentType,
        onTriggerButtonClick: onShareButtonClick
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ftcXB.FullscreenButton), {
        boardId: Number(rapidViewId)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0a5aaebc8bfbbf3f$var$ActionsBarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), null, iconsComponent), isCompanyManaged && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kMTQf.BoardConnectToolbar), {
        boardId: rapidViewId,
        projectKey: projectKey,
        mode: "plan"
    }), isMenuVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0a5aaebc8bfbbf3f$var$MenuWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bATA3.default), null)) : null);
};
const $0a5aaebc8bfbbf3f$export$8c8e9293b68041de = (0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('sea-2744-jsw-tabs-nav'), $0a5aaebc8bfbbf3f$var$ActionsBarNew, $0a5aaebc8bfbbf3f$var$ActionsBarOld);
const $0a5aaebc8bfbbf3f$var$extensionsStyles = (0, $1ZAYh.xcss)({
    paddingBottom: 'space.100',
    gap: 'space.100',
    width: '100%',
    flex: '0 1 auto',
    flexWrap: 'wrap',
    [(0, $4Ywu9.media).above.md]: {
        flex: '0 0 auto',
        flexWrap: 'wrap'
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a5aaebc8bfbbf3f$var$ActionsBarWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _zulpu2gc",
            __cmplp.className
        ])
    });
});
const $0a5aaebc8bfbbf3f$var$MenuWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kMTQf", function(module, exports) {

$parcel$export(module.exports, "BoardConnectToolbar", () => $8ec5bae311155558$export$afbfa45d45a0cda1);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $g5Huk = parcelRequire("g5Huk");

var $jAaTB = parcelRequire("jAaTB");
function $8ec5bae311155558$var$BoardConnectToolbarInner({ boardId: boardId, projectKey: projectKey, mode: mode }) {
    const toolSections = (0, $jAaTB.useFetchedToolSections)({
        boardId: boardId,
        projectKey: projectKey,
        mode: mode
    });
    if (!toolSections) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g5Huk.BoardToolsView), {
        toolSections: toolSections
    });
}
function $8ec5bae311155558$export$afbfa45d45a0cda1(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "board-connect-toolbar",
        packageName: "@atlassian/jira-software-board-connect-toolbar",
        teamName: "a4t-tanuki",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8ec5bae311155558$var$BoardConnectToolbarInner, props));
}

});
parcelRegister("g5Huk", function(module, exports) {

$parcel$export(module.exports, "BoardToolsView", () => $20dc8fe7ebed6c09$export$a97914bd35ac0c68);

var $eUqFw = parcelRequire("eUqFw");

var $jCcni = parcelRequire("jCcni");
var $be5j9 = parcelRequire("be5j9");
function $20dc8fe7ebed6c09$export$9f557e5e5102c0b2(toolSections) {
    return (0, $eUqFw.useMemo)(()=>toolSections?.filter((section)=>section.id !== 'board-tools-section'), [
        toolSections
    ]);
}
function $20dc8fe7ebed6c09$export$a97914bd35ac0c68({ toolSections: toolSections }) {
    const relevantSections = $20dc8fe7ebed6c09$export$9f557e5e5102c0b2(toolSections);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, relevantSections?.map((section)=>section.type === 'webItem' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $be5j9.BoardToolWebItemView), {
            key: section.id,
            subItem: section,
            mode: "button"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jCcni.BoardToolSectionView), {
            key: section.id,
            section: section
        })));
}

});
parcelRegister("jCcni", function(module, exports) {

$parcel$export(module.exports, "BoardToolSectionView", () => $744ef7a331dcb566$export$c57d75d82c2414d5);

var $eUqFw = parcelRequire("eUqFw");

var $6OfWd = parcelRequire("6OfWd");

var $be5j9 = parcelRequire("be5j9");
function $744ef7a331dcb566$export$c57d75d82c2414d5({ section: section }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        placement: "bottom-end",
        trigger: section.label,
        testId: "software-connect-toolbar.common.ui.tool-sections.board-tool-section-view.dropdown-menu"
    }, section.subItems?.map((subItem)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $be5j9.BoardToolSubItem), {
            key: subItem.id,
            subItem: subItem
        })));
}

});



parcelRegister("f6xJy", function(module, exports) {

$parcel$export(module.exports, "ImportWorkButton", () => $c299e89a2913b5c6$export$311dc74043c51081);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");


var $X0vFc = parcelRequire("X0vFc");

const $c299e89a2913b5c6$export$1d333e4178627a87 = (0, $7rh0R.lazy)(()=>(parcelRequire("jNSlR")).then(({ ImportWorkButtonInternal: ImportWorkButtonInternal })=>ImportWorkButtonInternal), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-invites/src/ui/import-work-button/index.tsx"
});
const $c299e89a2913b5c6$var$ImportWorkButtonWithTargeting = ()=>{
    const isTargeted = (0, $X0vFc.useIsTargetedForRaisingAwarenessOfImporter)();
    return isTargeted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c299e89a2913b5c6$export$1d333e4178627a87, null) : null;
};
const $c299e89a2913b5c6$export$311dc74043c51081 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "importWorkButton",
        packageName: (0, $3d9590da14e2d6bc$export$b8b9d90f9e5bd72b),
        teamName: (0, $3d9590da14e2d6bc$export$d57b6b390e78d90f),
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c299e89a2913b5c6$var$ImportWorkButtonWithTargeting, null));

});
const $3d9590da14e2d6bc$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingInvites';
const $3d9590da14e2d6bc$export$d57b6b390e78d90f = 'jlove-makkuro';
const $3d9590da14e2d6bc$export$719991a6cc456f06 = 'software-onboarding-invites.ui.import-work-button.button';

parcelRegister("X0vFc", function(module, exports) {

$parcel$export(module.exports, "useIsTargetedForRaisingAwarenessOfImporter", () => $989a0ed12018c0ae$export$c45655b60f7ebf1c);

var $7ZZxN = parcelRequire("7ZZxN");

var $dYni1 = parcelRequire("dYni1");

var $bNe1g = parcelRequire("bNe1g");

var $6WXNs = parcelRequire("6WXNs");

var $ab6rA = parcelRequire("ab6rA");
var $1R3n5 = parcelRequire("1R3n5");
const $989a0ed12018c0ae$export$c45655b60f7ebf1c = ()=>{
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const { data: data } = (0, $bNe1g.useProjectContext)();
    const { software: edition } = (0, $ab6rA.useAppEditions)();
    const isWithin30Day = (0, $dYni1.useIsFirstActivationDateWithinLast30Days)();
    const isSoftwareProject = data?.projectType === (0, $7ZZxN.SOFTWARE_PROJECT);
    return data?.simplified && isSiteAdmin && isWithin30Day && edition === (0, $6WXNs.FREE_EDITION) && isSoftwareProject;
};

});
parcelRegister("dYni1", function(module, exports) {

$parcel$export(module.exports, "useIsFirstActivationDateWithinLast30Days", () => $a92dd8ceb8d6b884$export$f561835faf21b733);

var $21Sgb = parcelRequire("21Sgb");

var $hRWVt = parcelRequire("hRWVt");
const $a92dd8ceb8d6b884$export$f561835faf21b733 = ()=>{
    const firstActivationDate = (0, $21Sgb.useFirstActivationDateMs)();
    return (0, $hRWVt.isWithinLast30Days)(firstActivationDate);
};

});
parcelRegister("21Sgb", function(module, exports) {

$parcel$export(module.exports, "useFirstActivationDateMs", () => $080756a4d87be123$export$9df3a539e50a284b);

var $gd0Sp = parcelRequire("gd0Sp");
const $080756a4d87be123$export$9df3a539e50a284b = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.firstActivationDateMs != null ? tenantContext.firstActivationDateMs : null;
};

});



parcelRegister("jNSlR", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('byvkv');
        const value = parcelRequire('hRR75');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("byvkv").then(()=>parcelRequire('hRR75'));
}

});


parcelRegister("4hiYU", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e2cbf1175a85afc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1QBAj = parcelRequire("1QBAj");

var $1gQ73 = parcelRequire("1gQ73");

var $Q9oQj = parcelRequire("Q9oQj");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5e2cbf1175a85afc$export$2e2bcd8739ae039 = ()=>{
    const operations = (0, $1gQ73.useBacklogSelector)((0, $Q9oQj.operationsSelector));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1QBAj.default), {
        operations: operations
    });
};

});
parcelRegister("1QBAj", function(module, exports) {

$parcel$export(module.exports, "default", () => $09d8df2788030c6c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $1ybV0 = parcelRequire("1ybV0");

var $3a46H = parcelRequire("3a46H");
function $09d8df2788030c6c$export$2e2bcd8739ae039(props) {
    if ((0, $1ybV0.ff)('sea-2744-jsw-tabs-nav')) {
        if (props.operations.length === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.operations.map((op)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a46H.default), {
                key: op.url,
                operation: op,
                onModalClose: props.onModalClose
            })));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.operations.map((op)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($09d8df2788030c6c$var$OperationWrapper, {
            key: op.url
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a46H.default), {
            operation: op,
            onModalClose: props.onModalClose
        }))));
}
$09d8df2788030c6c$export$2e2bcd8739ae039.defaultProps = {
    operations: [],
    onModalClose: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $09d8df2788030c6c$var$OperationWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxu2gc _1xoqidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3a46H", function(module, exports) {

$parcel$export(module.exports, "default", () => $c395e5ed57c76b76$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $7u4fN = parcelRequire("7u4fN");

var $iFXD5 = parcelRequire("iFXD5");

var $8cU5f = parcelRequire("8cU5f");

var $hnzPP = parcelRequire("hnzPP");

var $c9TLT = parcelRequire("c9TLT");
const $c395e5ed57c76b76$var$iconSize = (0, $c9TLT.gridSize) * 3;
class $c395e5ed57c76b76$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        // go/jfe-eslint
        // eslint-disable-next-line react/sort-comp
        this.defaultProps = {
            operation: {},
            onModalClose: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    static{
        this.getFallbackIcon = (name)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iFXD5))), {
                size: "medium",
                label: name
            });
    }
    /*
   * ABE-22: The reason for using this 'invisible' anchor with an href is needed, instead of simply
   * passing the href to the component which would then have an underlying anchor, is that the
   * styleClasses list of classes here are needed to trigger the ecosystem addon modal to come
   * up on click. This is in contrast to the component behaviour of a vanilla anchor that
   * currently does not support custom classes, which would redirect to a Jira 404 error page.
   */ renderEcosystemModalLink() {
        const { url: url, styleClass: styleClass } = this.props.operation;
        return(// go/jfe-eslint
        // eslint-disable-next-line jsx-a11y/anchor-has-content
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
            href: url,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: styleClass,
            ref: this.setEcosystemModalLinkRef,
            // eslint-disable-next-line jira/react/no-style-attribute
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'none'
            }
        }));
    }
    renderIcon() {
        const { icon: icon, name: name } = this.props.operation;
        return icon && icon.url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnzPP.default), {
            title: name,
            url: icon.url,
            width: $c395e5ed57c76b76$var$iconSize,
            height: $c395e5ed57c76b76$var$iconSize,
            fallback: ()=>$c395e5ed57c76b76$export$2e2bcd8739ae039.getFallbackIcon(name || '')
        }) : $c395e5ed57c76b76$export$2e2bcd8739ae039.getFallbackIcon(name || '');
    }
    renderButton() {
        const { name: name } = this.props.operation;
        const icon = this.renderIcon();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            key: name,
            onClick: this.clickEcosystemModalLinkRef,
            // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactChild | undefined'.
            iconBefore: name ? icon : null
        }, name || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c395e5ed57c76b76$var$OnlyIconWrapper, null, icon), this.renderEcosystemModalLink());
    }
    render() {
        const { tooltip: tooltip } = this.props.operation;
        const button = this.renderButton();
        if (tooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: tooltip
        }, button);
        return button;
    }
    constructor(...args){
        super(...args);
        /* not used yet TOTEM-818 */ this.onModalClose = ()=>this.props.onModalClose();
        this.setEcosystemModalLinkRef = (element)=>{
            this.ecosystemModalLinkRef = element;
        };
        this.clickEcosystemModalLinkRef = ()=>{
            this.ecosystemModalLinkRef && this.ecosystemModalLinkRef.click();
        };
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c395e5ed57c76b76$var$OnlyIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});


parcelRegister("Q9oQj", function(module, exports) {

$parcel$export(module.exports, "operationsSelector", () => $9b6c172b3780d02c$export$5244c0030b3a418e);
const $9b6c172b3780d02c$export$5244c0030b3a418e = (state)=>state.config.extension.operations;

});


parcelRegister("bATA3", function(module, exports) {

$parcel$export(module.exports, "default", () => $93d15314fd281cee$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $jG1wZ = parcelRequire("jG1wZ");

var $3MV1G = parcelRequire("3MV1G");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $eDgaT = parcelRequire("eDgaT");

var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $8ZI73 = parcelRequire("8ZI73");

var $7kNqR = parcelRequire("7kNqR");

var $ai2KE = parcelRequire("ai2KE");

var $bjKCy = parcelRequire("bjKCy");

var $GGFXd = parcelRequire("GGFXd");
const $93d15314fd281cee$var$BacklogPopupMenu = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    // from old props
    const isCompanyManaged = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getIsCompanyManaged));
    const canEditBoardConfigProp = (0, $1gQ73.useBacklogSelector)((0, $7kNqR.canEditBoardConfig));
    const shouldShowDetailViewItem = (0, $1gQ73.useBacklogSelector)((state)=>!(0, $bP7Jx.isBacklogEmptySelector)(state));
    const shouldShowEpicAsPanel = (0, $1gQ73.useBacklogSelector)((0, $8ZI73.getShowEpicAsPanel));
    const shouldShowVersionsPanel = (0, $1gQ73.useBacklogSelector)((0, $ai2KE.isVersionsFeatureEnabled));
    const handleClick = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
        setIsOpen(!isOpen);
        analyticsEvent.update({
            action: 'toggled',
            actionSubject: 'dropdownMenu'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'backlogHeaderMenu');
    }, [
        isOpen
    ]);
    const handleClose = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(false);
        const analyticsEvent = createAnalyticsEvent({
            action: 'toggled',
            actionSubject: 'dropdownMenu'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'backlogHeaderMenu');
    }, [
        createAnalyticsEvent
    ]);
    const moreIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
        label: formatMessage((0, $GGFXd.default).dropdownAriaLabel),
        primaryColor: "var(--ds-icon, #44546F)"
    });
    const renderTrigger = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $1ybV0.ff)('sea-2744-jsw-tabs-nav') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eDgaT.ResponsiveButton), {
            ...triggerProps,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))),
            label: formatMessage((0, $GGFXd.default).buttonLabel),
            "aria-label": formatMessage((0, $GGFXd.default).dropdownAriaLabel),
            isSelected: isOpen,
            onClick: handleClick
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            ...triggerProps,
            iconBefore: moreIcon,
            isSelected: isOpen,
            onClick: handleClick
        }));
    const renderContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bjKCy.default), {
            canEditBoardConfig: canEditBoardConfigProp,
            isCompanyManaged: isCompanyManaged,
            shouldShowDetailViewItem: shouldShowDetailViewItem,
            shouldShowEpicAsPanel: shouldShowEpicAsPanel,
            shouldShowVersionsPanel: shouldShowVersionsPanel,
            onClosePopup: handleClose
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        placement: "bottom-end",
        isOpen: isOpen,
        onClose: handleClose,
        content: renderContent,
        trigger: renderTrigger
    });
};
var $93d15314fd281cee$export$2e2bcd8739ae039 = $93d15314fd281cee$var$BacklogPopupMenu;

});
parcelRegister("bjKCy", function(module, exports) {

$parcel$export(module.exports, "default", () => $9787400fa2d086ce$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8PFhw = parcelRequire("8PFhw");
var $8BKky = parcelRequire("8BKky");

var $cU75R = parcelRequire("cU75R");

var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");

var $h4FOT = parcelRequire("h4FOT");

var $gd39x = parcelRequire("gd39x");

var $6ydve = parcelRequire("6ydve");
const $9787400fa2d086ce$var$BacklogMenuContent = ({ isCompanyManaged: isCompanyManaged, canEditBoardConfig: canEditBoardConfig, onClosePopup: onClosePopup })=>{
    const boardId = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getRapidViewId));
    const projectKey = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getProjectKey));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8PFhw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), null, isCompanyManaged ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h4FOT.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cU75R.BoardConnectMenuItems), {
        boardId: boardId,
        projectKey: projectKey,
        location: "board-tools-1",
        mode: "plan"
    }), canEditBoardConfig && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd39x.CreateBoardMenuItem), {
        onClosePopup: onClosePopup
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cU75R.BoardConnectMenuItems), {
        boardId: boardId,
        projectKey: projectKey,
        location: "view-actions-print",
        mode: "plan"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ydve.default), {
        isDisabled: !canEditBoardConfig
    })));
};
var $9787400fa2d086ce$export$2e2bcd8739ae039 = $9787400fa2d086ce$var$BacklogMenuContent;

});
parcelRegister("cU75R", function(module, exports) {

$parcel$export(module.exports, "BoardConnectMenuItems", () => $475c0b4136746937$export$d8d46adb5b629caf);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $be5j9 = parcelRequire("be5j9");

var $jAaTB = parcelRequire("jAaTB");

var $4eNNM = parcelRequire("4eNNM");
function $475c0b4136746937$var$BoardConnectMenuItemsInner({ projectKey: projectKey, boardId: boardId, location: location, mode: mode, onClickWebItem: onClickWebItem }) {
    const toolSections = (0, $jAaTB.useFetchedToolSections)({
        boardId: boardId,
        projectKey: projectKey,
        mode: mode
    });
    const targetSection = (0, $eUqFw.useMemo)(()=>toolSections && (0, $4eNNM.findSection)(toolSections, location), [
        toolSections,
        location
    ]);
    if (!toolSections || !targetSection) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, targetSection.subItems?.filter((item)=>item.id != null) // built-in items don't have IDs set
    .map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $be5j9.BoardToolSubItem), {
            onClickWebItem: onClickWebItem,
            key: item.id,
            subItem: item
        })) ?? null);
}
function $475c0b4136746937$export$d8d46adb5b629caf(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "board-connect-toolbar",
        packageName: "@atlassian/jira-software-board-connect-menu-items",
        teamName: "a4t-tanuki",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($475c0b4136746937$var$BoardConnectMenuItemsInner, props));
}

});
parcelRegister("4eNNM", function(module, exports) {

$parcel$export(module.exports, "findSection", () => $cc999772a21f0b5b$export$967ce3543c950aeb);
function $cc999772a21f0b5b$export$967ce3543c950aeb(toolSections, location) {
    for(let i = 0; i < toolSections.length; i += 1){
        const item = toolSections[i];
        if (item.type === 'section' && item.id === location) return item;
        if (item.type === 'section' && item.subItems != null) {
            const candidate = $cc999772a21f0b5b$export$967ce3543c950aeb(item.subItems, location);
            if (candidate != null) return candidate;
        }
    }
    return null;
}

});


parcelRegister("h4FOT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e16d5ed55b68848f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bo4OB = parcelRequire("bo4OB");

var $gUUjF = parcelRequire("gUUjF");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kJlBc = parcelRequire("kJlBc");

var $dmIGG = parcelRequire("dmIGG");
const $e16d5ed55b68848f$export$444102a091dc311d = ()=>{
    const defaultValue = 'filter';
    try {
        const value = localStorage.getItem('selectedConfigTab');
        return value ? JSON.parse(value) : defaultValue;
    } catch (err) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('software-backlog.header.menu.configure-board-item.dropdown-item', `Error reading "selectedConfigTab" value: ${err}`);
        return defaultValue;
    }
};
const $e16d5ed55b68848f$export$cc501cfa2aa02d4e = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const selectedConfigTab = $e16d5ed55b68848f$export$444102a091dc311d();
    const [{ location: location }] = (0, $kJlBc.useRouter)();
    const url = `${location.pathname}?config=${selectedConfigTab}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        "data-testid": "software-backlog.header.menu.configure-board-item.dropdown-item",
        href: url
    }, formatMessage((0, $dmIGG.default).displayText));
};
var $e16d5ed55b68848f$export$2e2bcd8739ae039 = $e16d5ed55b68848f$export$cc501cfa2aa02d4e;

});
parcelRegister("dmIGG", function(module, exports) {

$parcel$export(module.exports, "default", () => $59612c786938c5e8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $59612c786938c5e8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    displayText: {
        "id": "backlog.header.menu.configure-board-item.display-text",
        "defaultMessage": "Configure board"
    }
});

});


parcelRegister("gd39x", function(module, exports) {

$parcel$export(module.exports, "CreateBoardMenuItem", () => $23dcef5dd9bfe9a2$export$8b66d40068c85a7a);

var $eUqFw = parcelRequire("eUqFw");

var $bULPy = parcelRequire("bULPy");

var $gUUjF = parcelRequire("gUUjF");

var $26xrR = parcelRequire("26xrR");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $hbW8m = parcelRequire("hbW8m");
function $23dcef5dd9bfe9a2$export$8b66d40068c85a7a({ onClosePopup: onClosePopup }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'createBoard clicked',
            actionSubject: 'menuItem'
        }), 'createBoard clicked');
        onClosePopup && onClosePopup();
        (0, $26xrR.default)().catch((error)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData('backlog.modal.create-board.failure', 'Failed to open legacy Create board dialog', error);
        });
    }, [
        createAnalyticsEvent,
        onClosePopup
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        onClick: handleClick
    }, formatMessage((0, $hbW8m.messages).displayText));
}

});
parcelRegister("hbW8m", function(module, exports) {

$parcel$export(module.exports, "messages", () => $15cb914e7714b0c7$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $15cb914e7714b0c7$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    displayText: {
        "id": "backlog.header.menu.create-board.display-text",
        "defaultMessage": "Create board"
    }
});

});


parcelRegister("6ydve", function(module, exports) {

$parcel$export(module.exports, "default", () => $57b2c82d1a12f7db$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bULPy = parcelRequire("bULPy");

var $5JgJ2 = parcelRequire("5JgJ2");

var $idkBG = parcelRequire("idkBG");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");

var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");

var $iLjKY = parcelRequire("iLjKY");
const $57b2c82d1a12f7db$export$84a62bf03b005a81 = (boardUrl)=>`${boardUrl}/custom-filters`;
const $57b2c82d1a12f7db$export$538689bb697618b7 = ({ isDisabled: isDisabled })=>{
    const boardId = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getRapidViewId));
    const projectKey = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getProjectKey));
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { push: push } = (0, $kJlBc.useRouterActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const url = `/jira/software/projects/${projectKey}/settings/boards/${boardId}/custom-filters`;
    const onClick = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        });
        (0, $idkBG.setReturnToProjectUrl)();
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'clickManageCustomFilterItem');
        push(url);
    }, [
        push,
        url,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        isDisabled: isDisabled,
        onClick: onClick
    }, formatMessage((0, $iLjKY.default).displayText));
};
var $57b2c82d1a12f7db$export$2e2bcd8739ae039 = $57b2c82d1a12f7db$export$538689bb697618b7;

});
parcelRegister("iLjKY", function(module, exports) {

$parcel$export(module.exports, "default", () => $356214f79edbfaea$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $356214f79edbfaea$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    displayText: {
        "id": "backlog.header.menu.manage-custom-filters-item.display-text",
        "defaultMessage": "Manage custom filters"
    }
});

});



parcelRegister("GGFXd", function(module, exports) {

$parcel$export(module.exports, "default", () => $eee2d269fa537e14$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $eee2d269fa537e14$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    dropdownAriaLabel: {
        "id": "backlog.header.menu.dropdown-aria-label",
        "defaultMessage": "Backlog menu"
    },
    buttonLabel: {
        "id": "backlog.header.menu.button-label",
        "defaultMessage": "More"
    }
});

});


parcelRegister("ftcXB", function(module, exports) {

$parcel$export(module.exports, "FullscreenButton", () => $e87a689f65f43d3b$export$305be705ce696d42);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $eb6jM = parcelRequire("eb6jM");

var $8MrYx = parcelRequire("8MrYx");
const $e87a689f65f43d3b$var$getFullscreenRefs = ()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Array.from(document.querySelectorAll('[data-fullscreen-id]'));
const $e87a689f65f43d3b$export$305be705ce696d42 = ({ boardId: boardId })=>{
    const { setIsFullscreen: setIsFullscreen } = (0, $8MrYx.useViewSettingsActions)();
    const isFullscreen = (0, $8MrYx.useIsFullscreen)();
    const handleFullscreenToggle = (0, $eUqFw.useCallback)((wasFullscreen)=>{
        setIsFullscreen({
            boardId: boardId,
            isFullscreen: !wasFullscreen
        });
    }, [
        boardId,
        setIsFullscreen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eb6jM.default), {
        testId: "software-backlog.header.actions-bar.fullscreen-button",
        getCustomRefs: $e87a689f65f43d3b$var$getFullscreenRefs,
        withContainerStyles: false,
        onToggle: handleFullscreenToggle,
        isFullscreen: isFullscreen,
        renderAsResponsiveButton: (0, $1ybV0.ff)('sea-2744-jsw-tabs-nav')
    });
};

});
parcelRegister("eb6jM", function(module, exports) {

$parcel$export(module.exports, "default", () => $e63f1a697a100911$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5kZSr = parcelRequire("5kZSr");

var $eQbJ4 = parcelRequire("eQbJ4");
const $e63f1a697a100911$var$FullscreenButton = ({ testId: testId, onToggle: onToggle, getCustomRefs: getCustomRefs, analyticsAttributes: analyticsAttributes, withContainerStyles: withContainerStyles = true, defaultFullscreen: defaultFullscreen = false, isFullscreen: isFullscreenProp, renderAsResponsiveButton: renderAsResponsiveButton = false })=>{
    const [isFullscreenState, setIsFullscreenState] = (0, $eUqFw.useState)(isFullscreenProp ?? defaultFullscreen);
    const isFullscreen = isFullscreenProp ?? isFullscreenState;
    const handleToggle = (wasFullscreen, globalStyle)=>{
        onToggle(wasFullscreen, globalStyle);
        setIsFullscreenState(!wasFullscreen);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5kZSr.default), {
        testId: testId,
        onToggle: handleToggle,
        getCustomRefs: getCustomRefs,
        analyticsAttributes: analyticsAttributes,
        withContainerStyles: withContainerStyles,
        defaultFullscreen: defaultFullscreen,
        isFullscreen: isFullscreen,
        renderAsResponsiveButton: renderAsResponsiveButton
    });
};
$e63f1a697a100911$var$FullscreenButton.defaultProps = {
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    getCustomRefs: ()=>[],
    analyticsAttributes: {}
};
var $e63f1a697a100911$export$2e2bcd8739ae039 = $e63f1a697a100911$var$FullscreenButton;

});
parcelRegister("5kZSr", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b04dcc2d32cc90b$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $22LS1 = parcelRequire("22LS1");

var $drWMe = parcelRequire("drWMe");

var $8cU5f = parcelRequire("8cU5f");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $eDgaT = parcelRequire("eDgaT");

var $ffL85 = parcelRequire("ffL85");
const $1b04dcc2d32cc90b$var$removeFullScreenStyle = (customRefs)=>{
    document.getElementById('fullscreen-global-style')?.remove();
    if (customRefs) customRefs.forEach((ref)=>{
        if (ref !== null) ref.classList.remove('fullscreen');
    });
};
const $1b04dcc2d32cc90b$var$FullscreenButton = ({ testId: testId, onToggle: onToggle, getCustomRefs: getCustomRefs, analyticsAttributes: extraAnalyticsAttributes, withContainerStyles: withContainerStyles = true, defaultFullscreen: defaultFullscreen = false, isFullscreen: isFullscreen, renderAsResponsiveButton: renderAsResponsiveButton = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const customRefElements = (0, $eUqFw.useRef)(null);
    const globalStyle = document.createElement('style');
    const handleKeysInFullScreen = (0, $eUqFw.useCallback)((e)=>{
        // Ignore if it looks like the user is typing something
        if (e.target instanceof HTMLElement && ([
            'INPUT',
            'TEXTAREA',
            'SELECT'
        ].includes(e.target.tagName.toUpperCase()) || e.target.hasAttribute('contenteditable'))) return;
         // Prevent shortcuts
        const shortcutKeysToPrevent = [
            '/',
            // search
            'h' // help
        ];
        if (shortcutKeysToPrevent.includes(e.key)) e.stopPropagation();
        const navigationShortcuts = [
            '1',
            '2',
            '3',
            '4' // number keys
        ];
        if (navigationShortcuts.includes(e.key)) {
            onToggle(true, globalStyle);
            const customRefs = customRefElements.current;
            $1b04dcc2d32cc90b$var$removeFullScreenStyle(customRefs);
        }
    }, [
        globalStyle,
        onToggle
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isFullscreen) window?.addEventListener('keydown', handleKeysInFullScreen, true);
        else window?.removeEventListener('keydown', handleKeysInFullScreen, true);
    }, [
        isFullscreen,
        handleKeysInFullScreen
    ]);
    const createFullScreenStyle = (0, $eUqFw.useCallback)(()=>{
        const customElements = customRefElements.current;
        const hiddenStyles = "#ak-jira-navigation, #ak-side-navigation, #right-sidebar-panel-wrapper, [data-skip-link-wrapper='true'] { display: none }";
        const hiddenStylesNode = document.createTextNode(hiddenStyles);
        globalStyle.id = 'fullscreen-global-style';
        globalStyle.appendChild(hiddenStylesNode);
        if (customElements) customElements.forEach((ref)=>{
            if (ref !== null) ref.classList.add('fullscreen');
        });
        document.head?.appendChild(globalStyle);
    }, [
        globalStyle
    ]);
    const onClick = (event, analyticsEvent)=>{
        customRefElements.current = getCustomRefs();
        const customElements = customRefElements.current;
        const analyticsAttributes = {
            ...extraAnalyticsAttributes,
            expandToFullscreen: !isFullscreen
        };
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'fullscreenButton', analyticsAttributes);
        onToggle(isFullscreen, globalStyle);
        if (isFullscreen) $1b04dcc2d32cc90b$var$removeFullScreenStyle(customElements);
        else createFullScreenStyle();
    };
    (0, $eUqFw.useEffect)(()=>{
        customRefElements.current = getCustomRefs();
        const customElements = customRefElements.current;
        if (isFullscreen) createFullScreenStyle();
        else $1b04dcc2d32cc90b$var$removeFullScreenStyle(customElements);
        return ()=>$1b04dcc2d32cc90b$var$removeFullScreenStyle(customElements);
    }, [
        createFullScreenStyle,
        getCustomRefs,
        isFullscreen
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (defaultFullscreen) createFullScreenStyle();
         // Empty dependency array to only apply fullscreen styling once (on mount).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const colorFf = (0, $1ybV0.ff)('ftfns-19-header-update-share-button-icon-colour-token_g40ho') ? "var(--ds-icon, #44546F)" : undefined;
    const renderButtonWithTooltip = ()=>{
        if (renderAsResponsiveButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eDgaT.ResponsiveButton), {
            label: isFullscreen ? formatMessage((0, $ffL85.default).exitFullScreen) : formatMessage((0, $ffL85.default).enterFullScreen),
            icon: isFullscreen ? (0, (/*@__PURE__*/$parcel$interopDefault($drWMe))) : (0, (/*@__PURE__*/$parcel$interopDefault($22LS1))),
            onClick: onClick,
            testId: testId ?? 'platform.ui.fullscreen-button.fullscreen-button'
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage(isFullscreen ? (0, $ffL85.default).exitFullScreen : (0, $ffL85.default).enterFullScreen),
            position: "top-end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            ...withContainerStyles ? {
                testId: testId
            } : {
                testId: 'platform.ui.fullscreen-button.fullscreen-button'
            },
            appearance: "subtle",
            onClick: onClick,
            iconBefore: isFullscreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($drWMe))), {
                primaryColor: colorFf,
                label: formatMessage((0, $ffL85.default).exitFullScreen)
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($22LS1))), {
                primaryColor: colorFf,
                label: formatMessage((0, $ffL85.default).enterFullScreen)
            })
        }));
    };
    return withContainerStyles ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b04dcc2d32cc90b$var$FullscreenButtonContainer, {
        "data-testid": "platform.ui.fullscreen-button.fullscreen-button"
    }, renderButtonWithTooltip()) : renderButtonWithTooltip();
};
var $1b04dcc2d32cc90b$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $1b04dcc2d32cc90b$var$FullscreenButton;
const $1b04dcc2d32cc90b$var$FullscreenButtonContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _bfhk1bhr _16qsrs09 _2rko1sit",
            __cmplp.className
        ])
    });
});

});
parcelRegister("22LS1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $17d0e6b497755428$var$_react = $17d0e6b497755428$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $17d0e6b497755428$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $17d0e6b497755428$var$MediaServicesActualSizeIcon = (props)=>/*#__PURE__*/ $17d0e6b497755428$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M16.587 6.003H15A1 1 0 0115 4h3.9l.047.001a.975.975 0 01.736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 11-2 0V7.411l-3.309 3.308a.977.977 0 01-1.374-.005l-.032-.032a.976.976 0 01-.005-1.374l3.307-3.305zM7.413 17.997H9A1 1 0 019 20H5.1l-.047-.001a.975.975 0 01-.736-.285l-.032-.032A.977.977 0 014 18.946a1.12 1.12 0 010-.048v-3.896a1 1 0 112 0v1.587l3.309-3.308a.977.977 0 011.374.005l.032.032a.976.976 0 01.005 1.374l-3.307 3.305z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$17d0e6b497755428$var$MediaServicesActualSizeIcon.displayName = 'MediaServicesActualSizeIcon';
var $17d0e6b497755428$var$_default = $17d0e6b497755428$var$MediaServicesActualSizeIcon;
module.exports.default = $17d0e6b497755428$var$_default;

});

parcelRegister("drWMe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9cab63de7a2a3a02$var$_react = $9cab63de7a2a3a02$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $9cab63de7a2a3a02$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9cab63de7a2a3a02$var$MediaServicesFitToPageIcon = (props)=>/*#__PURE__*/ $9cab63de7a2a3a02$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M16.413 8.997H18A1 1 0 0118 11h-3.9l-.047-.001a.975.975 0 01-.736-.285l-.032-.032A.977.977 0 0113 9.946a1.12 1.12 0 010-.048V6.002a1 1 0 112 0v1.587l3.309-3.308a.977.977 0 011.374.005l.032.032a.976.976 0 01.005 1.374l-3.307 3.305zm-8.826 6.006H6A1 1 0 016 13h3.9l.047.001a.975.975 0 01.736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 11-2 0v-1.587l-3.309 3.308a.977.977 0 01-1.374-.005l-.032-.032a.976.976 0 01-.005-1.374l3.307-3.305z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$9cab63de7a2a3a02$var$MediaServicesFitToPageIcon.displayName = 'MediaServicesFitToPageIcon';
var $9cab63de7a2a3a02$var$_default = $9cab63de7a2a3a02$var$MediaServicesFitToPageIcon;
module.exports.default = $9cab63de7a2a3a02$var$_default;

});

parcelRegister("ffL85", function(module, exports) {

$parcel$export(module.exports, "default", () => $20d24ea35e7158d0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $20d24ea35e7158d0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    enterFullScreen: {
        "id": "platform.fullscreen-button.enter-full-screen",
        "defaultMessage": "Enter full screen"
    },
    exitFullScreen: {
        "id": "platform.fullscreen-button.exit-full-screen",
        "defaultMessage": "Exit full screen"
    }
});

});




parcelRegister("7QvkH", function(module, exports) {

$parcel$export(module.exports, "InsightsButton", () => $4f9b11410d2a5866$export$95e4a3c3bc863d9c);

var $eUqFw = parcelRequire("eUqFw");

var $dEpVH = parcelRequire("dEpVH");

var $4lw2o = parcelRequire("4lw2o");

var $4FzzQ = parcelRequire("4FzzQ");


var $j258X = parcelRequire("j258X");
const $4f9b11410d2a5866$export$95e4a3c3bc863d9c = ({ onToggle: onToggle, isInsightsPanelOpen: isInsightsPanelOpen, boardId: boardId, edition: edition = null })=>{
    const isSupported = (0, $4lw2o.useIsCurrentBrowserSupported)();
    const isCMPBacklog = (0, $j258X.useIsCMPBacklog)();
    const onToggleHandler = (0, $eUqFw.useCallback)(()=>{
        onToggle((0, $d36e2c37d06c83ff$export$29d7f2210b16d662));
    }, [
        onToggle
    ]);
    if (!isSupported) return null;
    if (!edition) return null;
    return !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4FzzQ.BacklogInsightsNudgeAsync), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dEpVH.BacklogInsightsButton), {
        isSimplifiedProject: !isCMPBacklog,
        isOpen: isInsightsPanelOpen,
        isCompact: false,
        boardId: Number(boardId),
        edition: edition,
        onToggle: onToggleHandler
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dEpVH.BacklogInsightsButton), {
        isSimplifiedProject: !isCMPBacklog,
        isOpen: isInsightsPanelOpen,
        isCompact: false,
        boardId: Number(boardId),
        edition: edition,
        onToggle: onToggleHandler
    });
};

});
parcelRegister("dEpVH", function(module, exports) {

$parcel$export(module.exports, "BacklogInsightsButton", () => $f7bedde14d78de57$export$fc456a966efbe170);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $1ybV0 = parcelRequire("1ybV0");

var $UduZF = parcelRequire("UduZF");
var $8aiGg = parcelRequire("8aiGg");
var $3Lzxi = parcelRequire("3Lzxi");
var $4lw2o = parcelRequire("4lw2o");
var $fOpgL = parcelRequire("fOpgL");
var $8ag6L = parcelRequire("8ag6L");


var $hKyBG = parcelRequire("hKyBG");

var $c02Pd = parcelRequire("c02Pd");

var $WbcDx = parcelRequire("WbcDx");
var $P6noH = parcelRequire("P6noH");
var $52ZlB = parcelRequire("52ZlB");

var $8B7Mk = parcelRequire("8B7Mk");

var $dvoRM = parcelRequire("dvoRM");

var $5JgJ2 = parcelRequire("5JgJ2");

var $iHjyA = parcelRequire("iHjyA");
var $40ShE = parcelRequire("40ShE");

var $keguF = parcelRequire("keguF");

var $8WuJm = parcelRequire("8WuJm");

var $6Wh45 = parcelRequire("6Wh45");

var $9FSgN = parcelRequire("9FSgN");
const $f7bedde14d78de57$var$ButtonTooltip = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formatMessage((0, $9FSgN.default).tooltip)
    }, children);
};
const $f7bedde14d78de57$var$BacklogInsightsButtonComponent = ({ isCompact: isCompact = false, isSimplifiedProject: isSimplifiedProject, isOpen: isOpen, boardId: boardId, onToggle: onToggle, edition: edition, projectId: projectId })=>{
    const userLocation = (0, $keguF.getUserLocation)();
    const isSupported = (0, $4lw2o.useIsCurrentBrowserSupported)();
    const [{ info: { isAnyLevelOfAdmin: isAnyLevelOfAdmin, isProjectType: isProjectType, uniqueId: uniqueId }, data: { hasPermission: hasPermission } }, { refreshUniqueId: refreshUniqueId, onDataUpdatedCallback: onDataUpdatedCallback, updateIsDeepLinking: updateIsDeepLinking }] = (0, $52ZlB.useInsightsContainer)();
    (0, $eUqFw.useEffect)(()=>{
        if (!isOpen) updateIsDeepLinking(false);
    }, [
        updateIsDeepLinking,
        isOpen
    ]);
    // refresh experience when insights (panel) is closed
    (0, $fOpgL.useValueChangeEffect)({
        listener: isOpen,
        callback: (current, previous)=>{
            if (current === false && previous === true) refreshUniqueId();
        }
    }, [
        refreshUniqueId
    ]);
    const currentPermissionStatus = (0, $WbcDx.getTextValue)(hasPermission, (0, $hKyBG.permissionStatus).LOADING);
    return isSupported ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: {
            boardId: boardId,
            edition: edition,
            experienceId: uniqueId,
            projectId: projectId,
            userLocation: userLocation
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8B7Mk.InsightsSettingsLoader), {
        boardId: boardId,
        onSettingsLoaded: onDataUpdatedCallback('settings')
    }), currentPermissionStatus === (0, $hKyBG.permissionStatus).LOADING && (isSimplifiedProject ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8aiGg.CheckSimplifiedDataPermission), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8aiGg.CheckClassicViewAggregatedDataPermission), {
        boardId: boardId,
        userLocation: userLocation,
        onPermissionLoaded: onDataUpdatedCallback('hasPermission')
    })), (0, $1ybV0.ff)('sea-2744-jsw-tabs-nav') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dvoRM.InsightsButton), {
        boardId: boardId,
        isAnyLevelOfAdmin: !isSimplifiedProject && isAnyLevelOfAdmin,
        isHidden: !isProjectType,
        isInsightsPanelOpen: isOpen,
        isOnboardingDisabled: !isSimplifiedProject ? currentPermissionStatus !== (0, $hKyBG.permissionStatus).ALLOWED : undefined,
        onToggle: onToggle
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dvoRM.InsightsButton), {
        boardId: boardId,
        isAnyLevelOfAdmin: !isSimplifiedProject && isAnyLevelOfAdmin,
        isCompact: isCompact,
        isHidden: !isProjectType,
        isInsightsPanelOpen: isOpen,
        isOnboardingDisabled: !isSimplifiedProject ? currentPermissionStatus !== (0, $hKyBG.permissionStatus).ALLOWED : undefined,
        onToggle: onToggle,
        renderTooltip: $f7bedde14d78de57$var$ButtonTooltip
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $40ShE.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iHjyA.default), {
        onToggle: onToggle,
        isOpen: isOpen,
        experienceId: uniqueId
    }))) : null;
};
const $f7bedde14d78de57$var$BacklogInsightsButtonWithContainer = (props)=>{
    const scope = (0, $UduZF.buildBacklogScopeName)({
        isSimplifiedProject: props.isSimplifiedProject,
        boardId: props.boardId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $P6noH.InsightsContainer), {
        scope: scope,
        packageName: (0, $3523ef16f82a4788$export$d3996f57ffa8448f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f7bedde14d78de57$var$BacklogInsightsButtonComponent, props));
};
const $f7bedde14d78de57$var$BacklogInsightsButtonFinal = $f7bedde14d78de57$var$BacklogInsightsButtonWithContainer;
const $f7bedde14d78de57$var$SafeBacklogInsightsButton = (0, $c02Pd.withComponentSafety)($f7bedde14d78de57$var$BacklogInsightsButtonFinal, {
    condition: ({ boardId: boardId })=>(0, $3Lzxi.isValidBoardId)({
            boardId: boardId
        }),
    location: (0, $6Wh45.BACKLOG_BUTTON_ID),
    message: ({ boardId: boardId })=>`Backlog button received invalid boardId: ${boardId}`
});
const $f7bedde14d78de57$export$fc456a966efbe170 = (0, $8ag6L.WithInsightsErrorBoundary)($f7bedde14d78de57$var$SafeBacklogInsightsButton);

});
parcelRegister("UduZF", function(module, exports) {

$parcel$export(module.exports, "buildBoardScopeName", () => $3a6103928eb70080$export$7cfa8d622acbc99f);
$parcel$export(module.exports, "buildBacklogScopeName", () => $3a6103928eb70080$export$68610636ce5df399);

const $3a6103928eb70080$export$7cfa8d622acbc99f = ({ isSimplifiedProject: isSimplifiedProject, boardId: boardId })=>`${isSimplifiedProject ? (0, $3523ef16f82a4788$export$8e66b21ec141a0bd) : (0, $3523ef16f82a4788$export$c9290acd1ba498ff)}-boardId:${boardId}`;
const $3a6103928eb70080$export$68610636ce5df399 = ({ isSimplifiedProject: isSimplifiedProject, boardId: boardId })=>`${isSimplifiedProject ? (0, $3523ef16f82a4788$export$75eb9639a5b0ba25) : (0, $3523ef16f82a4788$export$2fd6d7f902b01d67)}-boardId:${boardId}`;

});

parcelRegister("8aiGg", function(module, exports) {

$parcel$export(module.exports, "CheckClassicViewAggregatedDataPermission", () => $3c1e63042b4428c8$export$379f6e97a42d4a9d);
$parcel$export(module.exports, "CheckSimplifiedDataPermission", () => $3c1e63042b4428c8$export$b5e65dc6f010c84c);

var $eUqFw = parcelRequire("eUqFw");

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $iFpC0 = parcelRequire("iFpC0");


var $hKyBG = parcelRequire("hKyBG");

var $fWSio = parcelRequire("fWSio");

var $fp9ub = parcelRequire("fp9ub");

var $4kZbn = parcelRequire("4kZbn");

const $3c1e63042b4428c8$export$379f6e97a42d4a9d = ({ boardId: boardId, userLocation: userLocation, onPermissionLoaded: onPermissionLoaded })=>{
    const eventFrom = (0, $iFpC0.getBoardOrBacklogFromLocation)(userLocation);
    const actionSubject = `${(0, $3523ef16f82a4788$export$d3996f57ffa8448f)}.${eventFrom}`;
    const [{ data: permissionResult, loading: loading, fetched: fetched, aborted: aborted, hasError: hasError }] = (0, $fWSio.useFetch)({
        onFetch: (options)=>(0, $fp9ub.fetchInsightPermission)({
                boardId: boardId
            }, options),
        browserMetricsKey: `${actionSubject}.${(0, $0cb16700b774678c$export$5dad270161d08a8c)}`,
        analyticsTracking: {
            actionSubject: `${actionSubject}.${(0, $0cb16700b774678c$export$5dad270161d08a8c)}`,
            packageName: (0, $3523ef16f82a4788$export$d3996f57ffa8448f)
        },
        loggingKey: (0, $0cb16700b774678c$export$5dad270161d08a8c)
    }, []);
    const [_, setShouldUseJQLData] = (0, $4kZbn.useLocalStorage)('jira-insights-should-use-jql', 'shouldUseJQLQuery', {
        defaultValue: false
    });
    (0, $eUqFw.useEffect)(()=>{
        if (loading) onPermissionLoaded((0, $hKyBG.permissionStatus).LOADING);
        if (fetched && !hasError && !aborted) {
            if (permissionResult) {
                onPermissionLoaded((0, $hKyBG.permissionStatus).ALLOWED);
                const shouldPermittedUsersUseJQLData = (0, $eI5EY.fg)('insights-use_jql_query_for_enabled_users');
                setShouldUseJQLData(shouldPermittedUsersUseJQLData);
            } else {
                // target experiment only towards not-permitted users
                const shouldEnableAccess = (0, $79xbN.expVal)('jira_insights_open-insights', 'isEnabled', false);
                onPermissionLoaded(shouldEnableAccess ? (0, $hKyBG.permissionStatus).ALLOWED : (0, $hKyBG.permissionStatus).DISALLOWED);
                setShouldUseJQLData(true);
            }
        }
        if (hasError || aborted) onPermissionLoaded((0, $hKyBG.permissionStatus).DISALLOWED);
    }, [
        fetched,
        loading,
        aborted,
        permissionResult,
        hasError,
        onPermissionLoaded,
        setShouldUseJQLData
    ]);
    return null;
};
const $3c1e63042b4428c8$export$b5e65dc6f010c84c = ()=>{
    const [_, setShouldUseJQLData] = (0, $4kZbn.useLocalStorage)('jira-insights-should-use-jql', 'shouldUseJQLQuery', {
        defaultValue: false
    });
    const shouldPermittedUsersUseJQLData = (0, $eI5EY.fg)('insights-use_jql_query_for_enabled_users');
    (0, $eUqFw.useEffect)(()=>{
        setShouldUseJQLData(shouldPermittedUsersUseJQLData);
    }, [
        setShouldUseJQLData,
        shouldPermittedUsersUseJQLData
    ]);
    return null;
};

});
parcelRegister("iFpC0", function(module, exports) {

$parcel$export(module.exports, "getBoardOrBacklogFromLocation", () => $cb7f0bc61658bb70$export$bb6a57ca7b7487bb);

const $cb7f0bc61658bb70$var$locations = {
    [(0, $7ad984e19135f376$export$743304c0b847bdee)]: (0, $7ad984e19135f376$export$dedbdcc35e955187),
    [(0, $7ad984e19135f376$export$47ae5cd4a7ee5f2a)]: (0, $7ad984e19135f376$export$dedbdcc35e955187),
    [(0, $7ad984e19135f376$export$40705e2848d2f6a5)]: (0, $7ad984e19135f376$export$9b8283d5878d2491),
    [(0, $7ad984e19135f376$export$f995350d8da9bb90)]: (0, $7ad984e19135f376$export$9b8283d5878d2491)
};
const $cb7f0bc61658bb70$export$bb6a57ca7b7487bb = (userLocation)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly "software:software-backlog": "backlog"; readonly "classic-software:rapidboard-backlog": "backlog"; readonly "software:software-boards": "board"; readonly "classic-software:rapidboard-board": "board"; }'.
    $cb7f0bc61658bb70$var$locations[userLocation] || (0, $7ad984e19135f376$export$5f4028218eaee319);

});
const $7ad984e19135f376$export$dedbdcc35e955187 = 'backlog';
const $7ad984e19135f376$export$9b8283d5878d2491 = 'board';
const $7ad984e19135f376$export$5f4028218eaee319 = 'unknown';
const $7ad984e19135f376$export$47ae5cd4a7ee5f2a = 'classic-software:rapidboard-backlog';
const $7ad984e19135f376$export$f995350d8da9bb90 = 'classic-software:rapidboard-board';
const $7ad984e19135f376$export$743304c0b847bdee = 'software:software-backlog';
const $7ad984e19135f376$export$40705e2848d2f6a5 = 'software:software-boards';


parcelRegister("hKyBG", function(module, exports) {

$parcel$export(module.exports, "permissionStatus", () => $49dcf4d15446d857$export$b7019a8563593449);
const $49dcf4d15446d857$export$b7019a8563593449 = {
    LOADING: 'LOADING',
    ALLOWED: 'ALLOWED',
    DISALLOWED: 'DISALLOWED'
};

});

parcelRegister("fWSio", function(module, exports) {

$parcel$export(module.exports, "useFetch", () => $baa94bea8207aabf$export$d852f5f778460fa4);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $7JttX = parcelRequire("7JttX");
var $KLsAA = parcelRequire("KLsAA");
var $cSeyt = parcelRequire("cSeyt");
var $8NZVA = parcelRequire("8NZVA");
var $ggKO2 = parcelRequire("ggKO2");
var $7cySi = parcelRequire("7cySi");
const $baa94bea8207aabf$export$d852f5f778460fa4 = ({ onFetch: onFetch, isAutoFetchable: isAutoFetchable = true, analyticsTracking: analyticsTracking, browserMetricsKey: browserMetricsKey, loggingKey: loggingKey, initialData: initialData, isAbortable: isAbortable = true }, fetchDependencies)=>{
    const [state, dispatch] = (0, $eUqFw.useReducer)((0, $8NZVA.reducer), {
        ...(0, $KLsAA.initialState),
        data: initialData
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { initialized: initialized, fetched: fetched, loading: loading } = state;
    const abortControllerRef = (0, $eUqFw.useRef)();
    const fetchDependenciesRef = (0, $eUqFw.useRef)(fetchDependencies);
    const isMounted = (0, $eUqFw.useRef)(true);
    const getAbortController = (0, $eUqFw.useCallback)(()=>{
        const controller = abortControllerRef.current;
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        if (!abortControllerRef.current || controller?.signal.aborted) abortControllerRef.current = new AbortController();
        return abortControllerRef.current;
    }, []);
    const callFetch = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (...args)=>{
        // @ts-expect-error - TS2339 - Property 'signal' does not exist on type 'unknown'.
        const { signal: signal } = getAbortController();
        (0, $ggKO2.thunks).fetch({
            onFetch: async ()=>{
                try {
                    return await onFetch({
                        signal: signal
                    }, ...args);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (e) {
                    throw new (0, $7cySi.UseFetchHandledError)(isMounted.current, e);
                }
            },
            analyticsTracking: analyticsTracking,
            createAnalyticsEvent: createAnalyticsEvent,
            browserMetricsKey: browserMetricsKey,
            loggingKey: loggingKey,
            signal: signal
        })({
            actions: (0, $7JttX.buildActionDispatchers)(dispatch)
        });
    }, [
        onFetch,
        analyticsTracking,
        browserMetricsKey,
        createAnalyticsEvent,
        loggingKey,
        getAbortController
    ]);
    const doAbort = (0, $eUqFw.useCallback)(()=>{
        if (isAbortable) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        getAbortController().abort();
    }, [
        getAbortController,
        isAbortable
    ]);
    const doFetch = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (...args)=>{
        if (loading) doAbort();
        callFetch(...args);
    }, [
        loading,
        callFetch,
        doAbort
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const hasEffectsChanged = (0, $cSeyt.isShallowDifferent)(fetchDependenciesRef.current, fetchDependencies);
        if (!initialized && !fetched || hasEffectsChanged) {
            if (hasEffectsChanged) fetchDependenciesRef.current = fetchDependencies;
            if (hasEffectsChanged) doAbort();
            if (isAutoFetchable) callFetch();
            else if (initialized && hasEffectsChanged) dispatch({
                type: 'resetInitialState',
                payload: null
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        initialized,
        doAbort,
        fetched,
        callFetch,
        isAutoFetchable,
        ...fetchDependencies
    ]);
    (0, $eUqFw.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
            doAbort();
        };
    }, [
        doAbort
    ]);
    return [
        state,
        {
            doFetch: doFetch,
            doAbort: doAbort
        }
    ];
};

});
parcelRegister("7JttX", function(module, exports) {

$parcel$export(module.exports, "buildActionDispatchers", () => $b255873027b37d10$export$5297818927df1cbf);

var $rqoOi = parcelRequire("rqoOi");
const $b255873027b37d10$export$5297818927df1cbf = (dispatch)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys((0, $rqoOi.strategies)).reduce((accumulator, strategy)=>{
        accumulator[strategy] = (payload)=>dispatch({
                type: strategy,
                payload: payload
            });
        return accumulator;
    }, {});
const $b255873027b37d10$export$25b8423a7d935d64 = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys((0, $rqoOi.strategies)).reduce((accumulator, strategy)=>{
        accumulator[strategy] = (key, initialData, payload)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const sliceState = state.fetchables[key] || initialData;
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly resetInitialState: () => { readonly initialized: false; readonly loading: false; readonly fetched: false; readonly hasError: false; readonly aborted: false; readonly error: undefined; readonly data: undefined; }; ... 4 more ...; readonly default: (state: FetchState) => FetchState; }'.
                const nextSliceState = (0, $rqoOi.strategies)[strategy](sliceState, {
                    type: strategy,
                    payload: payload
                });
                const nextState = {
                    ...state,
                    fetchables: {
                        ...state.fetchables,
                        [key]: nextSliceState
                    }
                };
                setState(nextState);
            };
        return accumulator;
    }, {});
const $b255873027b37d10$export$7f88d514aa0ad345 = ({ actions: actions, key: key, initialData: initialData })=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(actions).reduce((accumulator, strategy)=>{
        const actionExecutor = actions[strategy];
        accumulator[strategy] = (payload)=>{
            actionExecutor(key, initialData, payload);
        };
        return accumulator;
    }, {});

});
parcelRegister("rqoOi", function(module, exports) {

$parcel$export(module.exports, "strategies", () => $ff2d776fd2f3b24f$export$c5491a8691a23b9e);

var $KLsAA = parcelRequire("KLsAA");
const $ff2d776fd2f3b24f$var$resetInitialState = ()=>(0, $KLsAA.initialState);
const $ff2d776fd2f3b24f$var$setFetchStart = (state)=>({
        ...state,
        initialized: true,
        loading: true,
        fetched: false,
        hasError: false,
        aborted: false
    });
const $ff2d776fd2f3b24f$var$setFetchEnd = (_, action)=>({
        initialized: true,
        loading: false,
        fetched: true,
        hasError: false,
        aborted: false,
        data: action.payload
    });
const $ff2d776fd2f3b24f$var$setError = (_, action)=>({
        error: action.payload,
        initialized: true,
        loading: false,
        fetched: false,
        hasError: true,
        aborted: false
    });
const $ff2d776fd2f3b24f$var$setAborted = ()=>({
        initialized: true,
        loading: false,
        fetched: false,
        hasError: false,
        aborted: true
    });
const $ff2d776fd2f3b24f$var$setDefault = (state)=>state;
const $ff2d776fd2f3b24f$export$c5491a8691a23b9e = {
    resetInitialState: $ff2d776fd2f3b24f$var$resetInitialState,
    setFetchStart: $ff2d776fd2f3b24f$var$setFetchStart,
    setFetchEnd: $ff2d776fd2f3b24f$var$setFetchEnd,
    setError: $ff2d776fd2f3b24f$var$setError,
    setAborted: $ff2d776fd2f3b24f$var$setAborted,
    default: $ff2d776fd2f3b24f$var$setDefault
};

});
parcelRegister("KLsAA", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $eba0efccc5a1dead$export$d4c72bab9d6cc13a);
const $eba0efccc5a1dead$export$d4c72bab9d6cc13a = {
    initialized: false,
    loading: false,
    fetched: false,
    hasError: false,
    aborted: false,
    error: undefined,
    data: undefined
};

});



parcelRegister("cSeyt", function(module, exports) {

$parcel$export(module.exports, "isShallowDifferent", () => $762f9e8b1196df26$export$a42e2ec7d66a0c03);
const $762f9e8b1196df26$export$a42e2ec7d66a0c03 = (arrayA, arrayB)=>arrayA.length !== arrayB.length || arrayA.some((currentElement, index)=>currentElement !== arrayB[index]);

});

parcelRegister("8NZVA", function(module, exports) {

$parcel$export(module.exports, "reducer", () => $17793b5513e32ea4$export$1650419e431d3ba3);

var $rqoOi = parcelRequire("rqoOi");

var $KLsAA = parcelRequire("KLsAA");
const $17793b5513e32ea4$export$1650419e431d3ba3 = (state = (0, $KLsAA.initialState), action)=>{
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly resetInitialState: () => { readonly initialized: false; readonly loading: false; readonly fetched: false; readonly hasError: false; readonly aborted: false; readonly error: undefined; readonly data: undefined; }; ... 4 more ...; readonly default: (state: FetchState) => FetchState; }'.
    const transformer = (0, $rqoOi.strategies)[action.type] || (0, $rqoOi.strategies).default;
    return transformer(state, action);
};

});

parcelRegister("ggKO2", function(module, exports) {

$parcel$export(module.exports, "thunks", () => $ac9502aef9cbebd2$export$eb2332b8a94a914a);

var $7OWi6 = parcelRequire("7OWi6");

var $1qlgb = parcelRequire("1qlgb");

var $9o9AY = parcelRequire("9o9AY");
const $ac9502aef9cbebd2$export$eb2332b8a94a914a = {
    fetch: ({ onFetch: onFetch, analyticsTracking: analyticsTracking, browserMetricsKey: browserMetricsKey, loggingKey: loggingKey, signal: signal, createAnalyticsEvent: createAnalyticsEvent })=>{
        const metricsTracker = (0, $7OWi6.trackBrowserMetricsForJira)({
            browserMetricsKey: browserMetricsKey
        });
        const logger = (0, $9o9AY.loggingHandler)({
            loggingKey: loggingKey
        });
        return async ({ actions: actions })=>{
            const analyticsTracker = (0, $1qlgb.trackDataFetchAnalytics)({
                ...analyticsTracking,
                createAnalyticsEvent: createAnalyticsEvent
            });
            metricsTracker.start();
            analyticsTracker.start();
            // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
            actions.setFetchStart();
            try {
                const data = await onFetch({
                    signal: signal
                });
                actions.setFetchEnd(data);
                metricsTracker.end();
                analyticsTracker.succeeded();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                metricsTracker.cancel();
                if (e.componentMounted) {
                    if (signal.aborted) {
                        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
                        actions.setAborted();
                        analyticsTracker.aborted();
                    } else {
                        const thrownError = e.originalError;
                        actions.setError(thrownError);
                        analyticsTracker.failed(thrownError);
                        logger.error(thrownError);
                    }
                }
            }
        };
    }
};

});
parcelRegister("9o9AY", function(module, exports) {

$parcel$export(module.exports, "loggingHandler", () => $93bceaf1b8971ca3$export$f35316da257b76e4);

var $gUUjF = parcelRequire("gUUjF");

var $JRB5w = parcelRequire("JRB5w");
const $93bceaf1b8971ca3$export$f35316da257b76e4 = ({ loggingKey: loggingKey })=>{
    if (loggingKey === null || loggingKey === undefined) return {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        error: ()=>{}
    };
    const errorHandler = (thrownError)=>{
        if (!(0, $JRB5w.isClientFetchError)(thrownError)) (0, $gUUjF.default).safeErrorWithoutCustomerData(loggingKey, 'Error fetching data', thrownError);
    };
    return {
        error: errorHandler
    };
};

});


parcelRegister("7cySi", function(module, exports) {

$parcel$export(module.exports, "UseFetchHandledError", () => $ba21eb973a08845e$export$2801d9c787d65a99);
class $ba21eb973a08845e$export$2801d9c787d65a99 extends Error {
    constructor(componentMounted, e){
        super(e?.message || 'Unknown');
        this.originalError = e;
        this.componentMounted = !!componentMounted;
    }
}

});


parcelRegister("fp9ub", function(module, exports) {

$parcel$export(module.exports, "fetchInsightPermission", () => $86c47c24f5425d66$export$a465feaffcf65c97);

var $8gjGw = parcelRequire("8gjGw");
const $86c47c24f5425d66$export$a465feaffcf65c97 = async ({ boardId: boardId }, options)=>{
    const response = await (0, $8gjGw.fetchJson)(`/rest/internal/board/${boardId}/insight-permission`, options);
    return response && response.allowed;
};

});

parcelRegister("4kZbn", function(module, exports) {

$parcel$export(module.exports, "useLocalStorage", () => $b81f98be78a470b4$export$86e2cef2561044ac);

var $eUqFw = parcelRequire("eUqFw");

var $aZaPn = parcelRequire("aZaPn");
const $b81f98be78a470b4$var$isSetStateFunction = (setStateAction)=>typeof setStateAction === 'function';
const $b81f98be78a470b4$export$86e2cef2561044ac = (namespace, key, options)=>{
    const localStorage = (0, $aZaPn.createLocalStorageProvider)(namespace);
    const initialValue = localStorage.get(key) ?? options?.defaultValue;
    // used to trigger re-render of components
    const [value, setValueInState] = (0, $eUqFw.useState)(initialValue);
    const setValue = (0, $eUqFw.useCallback)((setStateAction)=>{
        if ($b81f98be78a470b4$var$isSetStateFunction(setStateAction)) setValueInState((prevVal)=>{
            const newVal = setStateAction(prevVal);
            localStorage.set(key, newVal);
            return newVal;
        });
        else {
            localStorage.set(key, setStateAction);
            setValueInState(setStateAction);
        }
    }, [
        key,
        localStorage
    ]);
    return [
        value,
        setValue
    ];
};
const $b81f98be78a470b4$export$9c89ac8256e92fbb = (namespace, key, ttlInMs, options)=>{
    const localStorage = (0, $aZaPn.createLocalExpirableStorageProvider)(namespace);
    const initialValue = localStorage.get(key) ?? options?.defaultValue;
    // used to trigger re-render of components
    const [value, setValueInState] = (0, $eUqFw.useState)(initialValue);
    const setValue = (0, $eUqFw.useCallback)((setStateAction)=>{
        if ($b81f98be78a470b4$var$isSetStateFunction(setStateAction)) setValueInState((prevVal)=>{
            const newVal = setStateAction(prevVal);
            localStorage.set(key, newVal, Date.now() + ttlInMs);
            return newVal;
        });
        else {
            localStorage.set(key, setStateAction, Date.now() + ttlInMs);
            setValueInState(setStateAction);
        }
    }, [
        key,
        localStorage,
        ttlInMs
    ]);
    return [
        value,
        setValue
    ];
};
const $b81f98be78a470b4$export$436c2fd92113c067 = (namespace, key, options)=>{
    const [state, setState] = $b81f98be78a470b4$export$86e2cef2561044ac(namespace, key, options);
    return [
        state,
        // This is for batch update
        (objectKey, value)=>setState((prevState)=>({
                    ...prevState,
                    [objectKey]: value
                }))
    ];
};
const $b81f98be78a470b4$export$db70e245473ac2a = (namespace, key, ttlInMs, options)=>{
    const [state, setState] = $b81f98be78a470b4$export$9c89ac8256e92fbb(namespace, key, ttlInMs, options);
    return [
        state,
        // This is for batch update
        (objectKey, value)=>setState((prevState)=>({
                    ...prevState,
                    [objectKey]: value
                }))
    ];
};

});

const $0cb16700b774678c$export$5dad270161d08a8c = 'check-insight-permission';


parcelRegister("3Lzxi", function(module, exports) {

$parcel$export(module.exports, "getMessageFromEstimationUnit", () => $74ae222e3304e07b$export$680a8efbdf2f2020);
$parcel$export(module.exports, "getCommonMessageDescriptorFromEstimationUnit", () => $74ae222e3304e07b$export$c0f3281b1c14f2e6);
$parcel$export(module.exports, "getEstimatedUnit", () => $74ae222e3304e07b$export$120f64ac447e3a5a);
$parcel$export(module.exports, "getUpdatedEstimation", () => $74ae222e3304e07b$export$5ec90264a55fd048);
$parcel$export(module.exports, "getPermissionEnum", () => $74ae222e3304e07b$export$8e09a9f3c4b56097);
$parcel$export(module.exports, "isValidBoardId", () => $74ae222e3304e07b$export$e168d1e9d0082d6a);

var $jh2R9 = parcelRequire("jh2R9");


var $b0f7E = parcelRequire("b0f7E");

var $hArmT = parcelRequire("hArmT");
const $74ae222e3304e07b$export$680a8efbdf2f2020 = ({ estimationUnit: estimationUnit, messages: messages })=>{
    if (!messages[estimationUnit]) throw new Error(`Unsupported estimationUnit: ${estimationUnit} for ${JSON.stringify(messages)}`);
    return messages[estimationUnit];
};
const $74ae222e3304e07b$export$c0f3281b1c14f2e6 = (estimationUnit)=>{
    const estimationUnitCamelCase = (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(estimationUnit);
    const labelDescriptorName = `${estimationUnitCamelCase}Label`;
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ issueCountLabel: MessageDescriptorV2; storyPointsLabel: MessageDescriptorV2; timeOriginalEstimateLabel: MessageDescriptorV2; sprints: MessageDescriptorV2; issueCount: MessageDescriptorV2; storyPoints: MessageDescriptorV2; }'.
    if (!(0, $hArmT.messages)[labelDescriptorName]) throw new Error(`Unsupported estimationUnit: ${estimationUnit}, label not found for ${labelDescriptorName}} in ${JSON.stringify(Object.keys((0, $hArmT.messages)))}`);
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ issueCountLabel: MessageDescriptorV2; storyPointsLabel: MessageDescriptorV2; timeOriginalEstimateLabel: MessageDescriptorV2; sprints: MessageDescriptorV2; issueCount: MessageDescriptorV2; storyPoints: MessageDescriptorV2; }'.
    return (0, $hArmT.messages)[labelDescriptorName];
};
const $74ae222e3304e07b$export$120f64ac447e3a5a = (estimationUnit, estimation)=>{
    // these endpoints returning null shouldn't happen, so let's degrade gracefully
    switch(estimationUnit){
        case (0, $b0f7E.EstimationUnit).ISSUE_COUNT:
            return estimation.issueCount || 0;
        case (0, $b0f7E.EstimationUnit).STORY_POINTS:
            return estimation.storyPoints != null ? parseFloat(estimation.storyPoints.toFixed(1)) : 0;
        case (0, $b0f7E.EstimationUnit).TIME_TRACKING:
            return estimation.time || 0;
        default:
            throw new Error(`Unexpected estimation type: ${estimationUnit}`);
    }
};
const $74ae222e3304e07b$export$5ec90264a55fd048 = (estimationUnit, estimation, value)=>{
    switch(estimationUnit){
        case (0, $b0f7E.EstimationUnit).ISSUE_COUNT:
            return {
                ...estimation,
                issueCount: value
            };
        case (0, $b0f7E.EstimationUnit).STORY_POINTS:
            return {
                ...estimation,
                storyPoints: value
            };
        case (0, $b0f7E.EstimationUnit).TIME_TRACKING:
            return {
                ...estimation,
                time: value
            };
        default:
            throw new Error(`Unexpected estimation type: ${estimationUnit}`);
    }
};
const $74ae222e3304e07b$export$8e09a9f3c4b56097 = (value, defaultValue)=>value === null || value === undefined ? defaultValue : value;
const $74ae222e3304e07b$export$8081780e7051e8dd = (boardId)=>`print-halfway-alert-${boardId ?? (0, $fd9f012b2955034e$export$bc8ae8b96c2da16b)}`;
const $74ae222e3304e07b$export$9eca4630c417f1b = (boardId)=>`auto-expand-halfway-alert-${boardId ?? (0, $fd9f012b2955034e$export$bc8ae8b96c2da16b)}`;
const $74ae222e3304e07b$export$e168d1e9d0082d6a = ({ boardId: boardId })=>{
    // BoardId must be a positive integer
    if (boardId === undefined || boardId === null || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    !(Number.isInteger(boardId) && boardId > 0)) return false;
    return true;
};
const $74ae222e3304e07b$export$2e033b8f7ea3f02a = ({ boardId: boardId })=>{
    if (typeof boardId !== 'string') return false;
    return /^[0-9]+$/.test(boardId) && Number.parseInt(boardId, 10) > 0;
};

});
const $fd9f012b2955034e$export$5c425db6689b9aae = 'no-account-id';
const $fd9f012b2955034e$export$bc8ae8b96c2da16b = 'no-board-id';

parcelRegister("b0f7E", function(module, exports) {

$parcel$export(module.exports, "EstimationUnit", () => $b70efd587dc0d85a$export$65cc899e447718b8);
const $b70efd587dc0d85a$export$65cc899e447718b8 = {
    STORY_POINTS: 'STORY_POINTS',
    ISSUE_COUNT: 'ISSUE_COUNT',
    TIME_TRACKING: 'TIME_TRACKING',
    OTHER: 'OTHER'
};
const $b70efd587dc0d85a$export$c17e0027053340c = 'OTHER';

});

parcelRegister("hArmT", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2683ad3818f32a56$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $2683ad3818f32a56$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    storyPoints: {
        "id": "insights-common.common.story-points",
        "defaultMessage": "{value, plural, one {point} other {points}}"
    },
    issueCount: {
        "id": "insights-common.common.issue-count",
        "defaultMessage": "{value, plural, one {issue} other {issues}}"
    },
    sprints: {
        "id": "insights-common.common.sprints",
        "defaultMessage": "{sprintCount, plural, one {sprint} other {sprints}}"
    },
    timeTrackingLabel: {
        "id": "insights-common.common.time-tracking-label",
        "defaultMessage": "time estimation"
    },
    storyPointsLabel: {
        "id": "insights-common.common.story-points-label",
        "defaultMessage": "story points"
    },
    issueCountLabel: {
        "id": "insights-common.common.issue-count-label",
        "defaultMessage": "issue count"
    }
});

});


parcelRegister("4lw2o", function(module, exports) {

$parcel$export(module.exports, "useIsCurrentBrowserSupported", () => $b1e8cc8b3c1e64fa$export$e2f83ae69f04608f);

var $eUqFw = parcelRequire("eUqFw");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b1e8cc8b3c1e64fa$var$isDefined = (value)=>value !== null && value !== undefined;
const $b1e8cc8b3c1e64fa$var$isCurrentBrowserSupported = ()=>{
    // Supported from:
    // Chrome 66
    // Safari 12.1
    // Edge 16
    if (!$b1e8cc8b3c1e64fa$var$isDefined(window?.AbortController)) return false;
    return true;
};
const $b1e8cc8b3c1e64fa$export$e2f83ae69f04608f = ()=>{
    const isSupported = (0, $eUqFw.useMemo)(()=>$b1e8cc8b3c1e64fa$var$isCurrentBrowserSupported(), []);
    return isSupported;
};

});

parcelRegister("fOpgL", function(module, exports) {

$parcel$export(module.exports, "useValueChangeEffect", () => $98d863b672929e91$export$7dd9a2cc149d56b3);

var $eUqFw = parcelRequire("eUqFw");
const $98d863b672929e91$export$7dd9a2cc149d56b3 = ({ listener: listener, callback: callback }, deps = [])=>{
    const previous = (0, $eUqFw.useRef)(listener);
    (0, $eUqFw.useEffect)(()=>{
        if (listener !== previous.current) callback(listener, previous.current);
        previous.current = listener;
    /* We do not memoize the callback as this will change every render
		 * But it is important to pass in all dependencies used in the callback */ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        listener,
        ...deps
    ]);
};

});

parcelRegister("8ag6L", function(module, exports) {

$parcel$export(module.exports, "WithInsightsErrorBoundary", () => $ea912b171e50d8eb$export$b240a041e4bface8);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $0cdA8 = parcelRequire("0cdA8");

var $eX2O4 = parcelRequire("eX2O4");
var $4qhD6 = parcelRequire("4qhD6");

var $QKvwB = parcelRequire("QKvwB");


var $5odxs = parcelRequire("5odxs");
const $ea912b171e50d8eb$var$insightsExperience = {
    experience: (0, $QKvwB.JIRA_INSIGHTS)
};
const $ea912b171e50d8eb$export$eff352405fe6db90 = ({ children: children, onError: onError = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: (0, $3523ef16f82a4788$export$1269ea4f2b198811),
        packageName: (0, $3523ef16f82a4788$export$d3996f57ffa8448f),
        fallback: "flag",
        onError: onError
    }, children);
const $ea912b171e50d8eb$var$BaseInsightsErrorBoundaryWithExperienceTracker = ({ children: children })=>{
    const onFail = (0, $4qhD6.useExperienceFail)($ea912b171e50d8eb$var$insightsExperience);
    const { fail: fail } = (0, $5odxs.useInsightsExperience)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ea912b171e50d8eb$export$eff352405fe6db90, {
        onError: (...args)=>{
            onFail(...args);
            const [, error] = args;
            fail((0, $QKvwB.ERROR_BOUNDARY_HIT), error);
        }
    }, children);
};
const $ea912b171e50d8eb$export$cf848bf84642a299 = ({ children: children, experienceIdsToTrack: experienceIdsToTrack = [] })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5odxs.InsightsExperienceTracker), {
        experienceId: (0, $QKvwB.INSIGHTS_PANEL_EXPERIENCE),
        experienceIdsToCollect: experienceIdsToTrack || [],
        timeoutInMs: (0, $QKvwB.EXPERIENCE_TIMEOUT_MILLIS)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eX2O4.ExperienceTrackerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ea912b171e50d8eb$var$BaseInsightsErrorBoundaryWithExperienceTracker, null, children)));
const $ea912b171e50d8eb$export$b240a041e4bface8 = (Component)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ea912b171e50d8eb$export$eff352405fe6db90, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, props));

});
parcelRegister("QKvwB", function(module, exports) {

$parcel$export(module.exports, "JIRA_INSIGHTS", () => $455c39aa1dd6c633$export$74798a8d8755efe8);
$parcel$export(module.exports, "INSIGHTS_BEACON", () => $455c39aa1dd6c633$export$36aafe55be325e9c);
$parcel$export(module.exports, "INSIGHTS_PANEL", () => $455c39aa1dd6c633$export$29d7f2210b16d662);
$parcel$export(module.exports, "EXPERIENCE_TIMEOUT_MILLIS", () => $455c39aa1dd6c633$export$b50c2fb16a87be63);
$parcel$export(module.exports, "DATA_FETCH_ACTION", () => $455c39aa1dd6c633$export$4857a322416ea6fc);
$parcel$export(module.exports, "CLIENT_ERROR", () => $455c39aa1dd6c633$export$cb2bfe2a50a1ece2);
$parcel$export(module.exports, "RENDER_ACTION", () => $455c39aa1dd6c633$export$e902262516430940);
$parcel$export(module.exports, "dataFetchSuccess", () => $455c39aa1dd6c633$export$d392c424a6c74b59);
$parcel$export(module.exports, "dataFetchFail", () => $455c39aa1dd6c633$export$8d035b8b8e3383e);
$parcel$export(module.exports, "INSIGHTS_PANEL_EXPERIENCE", () => $455c39aa1dd6c633$export$3ea7cf58d679b8d9);
$parcel$export(module.exports, "ERROR_BOUNDARY_HIT", () => $455c39aa1dd6c633$export$680b36a84ba453e0);
$parcel$export(module.exports, "boardType", () => $455c39aa1dd6c633$export$6796f2a60fb31770);
$parcel$export(module.exports, "BOARD_KANBAN_PANEL_EXPERIENCE", () => $455c39aa1dd6c633$export$36467f64abcaaaa5);
$parcel$export(module.exports, "INSIGHTS_BUTTON_LG", () => $455c39aa1dd6c633$export$8a355daa8d0cf830);
$parcel$export(module.exports, "INSIGHTS_BUTTON_SM", () => $455c39aa1dd6c633$export$f8c16af1b950b647);
$parcel$export(module.exports, "INSIGHTS_BUTTON_RESPONSIVE", () => $455c39aa1dd6c633$export$e80ae42ddabf80c5);

const $455c39aa1dd6c633$export$74798a8d8755efe8 = (0, $3523ef16f82a4788$export$d3996f57ffa8448f);
const $455c39aa1dd6c633$export$36aafe55be325e9c = `${$455c39aa1dd6c633$export$74798a8d8755efe8}.beacon`;
const $455c39aa1dd6c633$export$29d7f2210b16d662 = `${$455c39aa1dd6c633$export$74798a8d8755efe8}.panel`;
const $455c39aa1dd6c633$export$8a1dfa6c0a610c5f = `${$455c39aa1dd6c633$export$29d7f2210b16d662}.help`;
const $455c39aa1dd6c633$export$956c91960ecaaf52 = `${$455c39aa1dd6c633$export$74798a8d8755efe8}.location`;
const $455c39aa1dd6c633$export$b50c2fb16a87be63 = 60000;
const $455c39aa1dd6c633$export$4857a322416ea6fc = 'dataFetch';
const $455c39aa1dd6c633$export$cb2bfe2a50a1ece2 = 'clientError';
const $455c39aa1dd6c633$export$e902262516430940 = 'render';
const $455c39aa1dd6c633$export$d392c424a6c74b59 = {
    successful: true
};
const $455c39aa1dd6c633$export$8d035b8b8e3383e = {
    successful: false
};
const $455c39aa1dd6c633$export$3ea7cf58d679b8d9 = 'panel';
const $455c39aa1dd6c633$export$680b36a84ba453e0 = 'error-boundary-hit';
const $455c39aa1dd6c633$export$6796f2a60fb31770 = {
    SCRUM: 'scrum',
    KANBAN: 'kanban'
};
const $455c39aa1dd6c633$export$36467f64abcaaaa5 = `${$455c39aa1dd6c633$export$74798a8d8755efe8}.board.${$455c39aa1dd6c633$export$6796f2a60fb31770.KANBAN}-panel`;
const $455c39aa1dd6c633$export$8a355daa8d0cf830 = 'insights-show-insights-button.ui.insights-button-large';
const $455c39aa1dd6c633$export$f8c16af1b950b647 = 'insights-show-insights-button.ui.insights-button-small';
const $455c39aa1dd6c633$export$e80ae42ddabf80c5 = 'insights-show-insights-button.ui.insights-button-responsive';

});

parcelRegister("5odxs", function(module, exports) {

$parcel$export(module.exports, "InsightsExperienceTracker", () => $37c15a2310875bd5$export$9c32e0183f3330c4);
$parcel$export(module.exports, "useInsightsExperience", () => $37c15a2310875bd5$export$6a440957407835a0);
$parcel$export(module.exports, "StartInsightsExperience", () => $37c15a2310875bd5$export$d8f7e3f6742303b4);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");


var $iFpC0 = parcelRequire("iFpC0");

var $keguF = parcelRequire("keguF");

var $isy2b = parcelRequire("isy2b");

var $8l9WL = parcelRequire("8l9WL");

var $7OWi6 = parcelRequire("7OWi6");

var $5cQVd = parcelRequire("5cQVd");

var $1hsLW = parcelRequire("1hsLW");

var $gPIn9 = parcelRequire("gPIn9");
const $37c15a2310875bd5$export$9c32e0183f3330c4 = ({ ufoExperience: ufoExperience, experienceId: experienceId, experienceIdsToCollect: experienceIdsToCollect, timeoutInMs: timeoutInMs = (0, $isy2b.TIMEOUT_IN_MS), attributes: attributes, children: children })=>{
    const userLocation = (0, $keguF.getUserLocation)();
    const eventFrom = (0, $iFpC0.getBoardOrBacklogFromLocation)(userLocation);
    const ufoErrorLogger = (0, $gPIn9.useUfoErrorLogger)({
        eventFrom: eventFrom,
        ufoExperience: ufoExperience
    });
    const insightsExperience = `${(0, $3523ef16f82a4788$export$d3996f57ffa8448f)}.${eventFrom}.${experienceId}`;
    const metricsTracker = (0, $1hsLW.useMetricsMemo)(()=>{
        const browserMetricsKey = `${insightsExperience}.${(0, $isy2b.experiences).RENDER}`;
        const metricsAttributes = {
            ...attributes,
            userLocation: userLocation
        };
        const service = (0, $7OWi6.trackBrowserMetricsForJira)({
            browserMetricsKey: browserMetricsKey,
            attributes: metricsAttributes
        });
        return {
            start: ()=>{
                service.start();
                ufoExperience?.start().catch(ufoErrorLogger);
            },
            end: ()=>{
                service.end();
                ufoExperience?.success().catch(ufoErrorLogger);
            },
            cancel: (error)=>{
                // send message to splunk here
                if (error) (0, $gUUjF.default).safeErrorWithoutCustomerData(browserMetricsKey, 'Insights experience failed', new (0, $8l9WL.ExperienceError)(error, metricsAttributes));
                service.cancel();
                ufoExperience?.failure().catch(ufoErrorLogger);
            }
        };
    }, [
        insightsExperience,
        userLocation,
        attributes,
        ufoExperience
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5cQVd.InsightsExperienceTrackerStoreContainer), {
        scope: insightsExperience,
        experienceIdsToCollect: experienceIdsToCollect,
        timeoutInMs: timeoutInMs,
        metricsTracker: metricsTracker,
        ufoExperience: ufoExperience
    }, children);
};
const $37c15a2310875bd5$export$6a440957407835a0 = ()=>{
    const [, actions] = (0, $5cQVd.useInsightsExperienceTracker)();
    const [isExperienceOwner, setExperienceOwner] = (0, $eUqFw.useState)(false);
    // we only need to expose start, fail and success
    const returnActions = (0, $eUqFw.useMemo)(()=>({
            start: ()=>{
                setExperienceOwner(true);
                actions.start();
            },
            fail: actions.fail,
            success: actions.success
        }), [
        actions,
        setExperienceOwner
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            if (isExperienceOwner === true) actions.reset();
        }, [
        isExperienceOwner,
        actions
    ]);
    return returnActions;
};
const $37c15a2310875bd5$export$d8f7e3f6742303b4 = ()=>{
    const { start: start } = $37c15a2310875bd5$export$6a440957407835a0();
    (0, $eUqFw.useLayoutEffect)(()=>{
        start();
    }, [
        start
    ]);
    return null;
};

});
parcelRegister("8l9WL", function(module, exports) {

$parcel$export(module.exports, "ExperienceError", () => $792b6fb68f081266$export$14d796af4fae7309);
class $792b6fb68f081266$export$14d796af4fae7309 extends Error {
    constructor(error, extraProps){
        super(error.message);
        this.name = error.name;
        this.stack = error.stack;
        Object.assign(this, {
            ...error
        });
        Object.assign(this, extraProps);
    }
}

});

parcelRegister("5cQVd", function(module, exports) {

$parcel$export(module.exports, "InsightsExperienceTrackerStoreContainer", () => $8f4380e876217772$export$ed39ab6b8cf88c60);
$parcel$export(module.exports, "useInsightsExperienceTracker", () => $8f4380e876217772$export$941e72d49b686b93);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $isy2b = parcelRequire("isy2b");

var $8LePl = parcelRequire("8LePl");

var $e0Hxk = parcelRequire("e0Hxk");
const $8f4380e876217772$var$Store = (0, $a61MH.createStore)({
    initialState: // @ts-expect-error - TS2322 - Type '{ readonly status: { readonly hasFailed: false; readonly hasCompleted: false; readonly hasStarted: false; readonly hasTimedOut: false; }; readonly timeoutId: null; readonly eventsSuccess: readonly []; readonly eventsFail: readonly []; }' is not assignable to type 'State'.
    $e0Hxk.initialState,
    actions: $8LePl.actions,
    name: (0, $isy2b.STORE_NAME)
});
const $8f4380e876217772$export$ed39ab6b8cf88c60 = (0, $heB5U.createContainer)($8f4380e876217772$var$Store);
const $8f4380e876217772$export$941e72d49b686b93 = (0, $ggKAj.createHook)($8f4380e876217772$var$Store);

});
parcelRegister("8LePl", function(module, exports) {

$parcel$export(module.exports, "actions", () => $846c75674fb94c5a$export$e324594224ef24da);

var $QKvwB = parcelRequire("QKvwB");

var $e0Hxk = parcelRequire("e0Hxk");
const $846c75674fb94c5a$var$success = (experienceId)=>({ getState: getState, setState: setState }, { metricsTracker: metricsTracker, experienceIdsToCollect: experienceIdsToCollect, ufoExperience: ufoExperience })=>{
        const state = getState();
        const currentStatus = state.status;
        if (!experienceId) return;
        if (!currentStatus.hasStarted || currentStatus.hasCompleted || currentStatus.hasTimedOut) return;
        if (!experienceIdsToCollect.includes(experienceId)) return;
        if (state.eventsSuccess.includes(experienceId)) return;
        if (ufoExperience != null) ufoExperience.mark(`${experienceId}_success`);
        const nextEventsSuccess = [
            ...state.eventsSuccess,
            experienceId
        ];
        const shouldSetHasCompleted = nextEventsSuccess.length === experienceIdsToCollect.length && !currentStatus.hasCompleted;
        const nextState = {
            status: shouldSetHasCompleted ? {
                ...currentStatus,
                hasCompleted: true
            } : currentStatus,
            timeoutId: state.timeoutId,
            eventsSuccess: [
                ...state.eventsSuccess,
                experienceId
            ],
            eventsFail: state.eventsFail
        };
        setState(nextState);
        if (shouldSetHasCompleted) {
            if (state.timeoutId) clearTimeout(state.timeoutId);
            metricsTracker.end();
        }
    };
const $846c75674fb94c5a$var$fail = (experienceId, error)=>({ getState: getState, setState: setState }, { metricsTracker: metricsTracker, experienceIdsToCollect: experienceIdsToCollect, ufoExperience: ufoExperience })=>{
        const state = getState();
        const currentStatus = state.status;
        if (!experienceId) return;
        if (!currentStatus.hasStarted || currentStatus.hasCompleted) return;
        if (!experienceIdsToCollect.includes(experienceId) && // Panel level error boundary hits do not pass in an experienceId,
        // so we accept the constant "error-boundary-hit" in addition to the experienceIds
        // Note: Insight level error boundary hits do pass in experienceId
        experienceId !== (0, $QKvwB.ERROR_BOUNDARY_HIT)) return;
        if (state.timeoutId) clearTimeout(state.timeoutId);
        if (ufoExperience != null) ufoExperience.mark(`${experienceId}_fail`);
        const nextEventsFail = [
            ...state.eventsFail,
            experienceId
        ];
        const nextState = {
            status: {
                ...currentStatus,
                hasFailed: true
            },
            timeoutId: state.timeoutId,
            eventsSuccess: state.eventsSuccess,
            eventsFail: nextEventsFail
        };
        setState(nextState);
        metricsTracker.cancel(error);
    };
const $846c75674fb94c5a$var$timeout = ()=>({ getState: getState, setState: setState }, { metricsTracker: metricsTracker })=>{
        const state = getState();
        const currentStatus = state.status;
        if (!currentStatus.hasStarted || currentStatus.hasCompleted || currentStatus.hasFailed) return;
        const nextState = {
            status: {
                ...currentStatus,
                hasFailed: true,
                hasTimedOut: true
            },
            eventsSuccess: state.eventsSuccess,
            eventsFail: state.eventsFail
        };
        setState(nextState);
        metricsTracker.cancel();
    };
const $846c75674fb94c5a$var$start = ()=>({ getState: getState, setState: setState, dispatch: dispatch }, { timeoutInMs: timeoutInMs, metricsTracker: metricsTracker, experienceIdsToCollect: experienceIdsToCollect })=>{
        const state = getState();
        const currentStatus = state.status;
        if (currentStatus.hasCompleted || currentStatus.hasStarted || currentStatus.hasFailed || currentStatus.hasTimedOut || experienceIdsToCollect.length === 0) return;
        const timeoutId = setTimeout(()=>{
            dispatch($846c75674fb94c5a$var$timeout());
        }, timeoutInMs);
        const nextState = {
            status: {
                ...currentStatus,
                hasStarted: true
            },
            timeoutId: timeoutId,
            eventsSuccess: [],
            eventsFail: []
        };
        // @ts-expect-error - TS2345 - Argument of type '{ status: { hasStarted: boolean; hasFailed: boolean; hasCompleted: boolean; hasTimedOut: boolean; }; timeoutId: NodeJS.Timeout; eventsSuccess: never[]; eventsFail: never[]; }' is not assignable to parameter of type 'Partial<State>'.
        setState(nextState);
        metricsTracker.start();
    };
const $846c75674fb94c5a$var$reset = ()=>({ getState: getState, setState: setState }, { metricsTracker: metricsTracker })=>{
        const state = getState();
        if (state.timeoutId) clearTimeout(state.timeoutId);
        const currentStatus = state.status;
        if (currentStatus.hasStarted && !currentStatus.hasCompleted && !currentStatus.hasFailed && !currentStatus.hasTimedOut) metricsTracker.cancel();
        // @ts-expect-error - TS2345 - Argument of type '{ readonly status: { readonly hasFailed: false; readonly hasCompleted: false; readonly hasStarted: false; readonly hasTimedOut: false; }; readonly timeoutId: null; readonly eventsSuccess: readonly []; readonly eventsFail: readonly []; }' is not assignable to parameter of type 'Partial<State>'.
        setState((0, $e0Hxk.initialState));
    };
const $846c75674fb94c5a$export$e324594224ef24da = {
    reset: $846c75674fb94c5a$var$reset,
    start: $846c75674fb94c5a$var$start,
    timeout: $846c75674fb94c5a$var$timeout,
    success: $846c75674fb94c5a$var$success,
    fail: $846c75674fb94c5a$var$fail
};

});
parcelRegister("e0Hxk", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $683dc4acf2a1a398$export$d4c72bab9d6cc13a);
const $683dc4acf2a1a398$export$d4c72bab9d6cc13a = {
    status: {
        hasFailed: false,
        hasCompleted: false,
        hasStarted: false,
        hasTimedOut: false
    },
    timeoutId: null,
    eventsSuccess: [],
    eventsFail: []
};

});



parcelRegister("1hsLW", function(module, exports) {

$parcel$export(module.exports, "useMetricsMemo", () => $17e712fced9be961$export$f5d771045a704f1f);

var $eUqFw = parcelRequire("eUqFw");
const $17e712fced9be961$var$isShallowDifferent = (arrayA, arrayB)=>arrayA.length !== arrayB.length || arrayA.some((currentElement, index)=>currentElement !== arrayB[index]);
const $17e712fced9be961$export$f5d771045a704f1f = (f, deps)=>{
    const metricsTrackerRef = (0, $eUqFw.useRef)();
    const fetchDependenciesRef = (0, $eUqFw.useRef)(deps);
    (0, $eUqFw.useMemo)(()=>{
        const hasEffectsChanged = $17e712fced9be961$var$isShallowDifferent(fetchDependenciesRef.current, deps);
        if (!metricsTrackerRef.current || hasEffectsChanged) {
            if (hasEffectsChanged) fetchDependenciesRef.current = deps;
            // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
            metricsTrackerRef.current = f();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'T'.
    return metricsTrackerRef.current;
};

});

parcelRegister("gPIn9", function(module, exports) {

$parcel$export(module.exports, "useUfoErrorLogger", () => $d210afe50fb6fdd6$export$688547a52c1d762b);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");


var $isy2b = parcelRequire("isy2b");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $d210afe50fb6fdd6$var$noop = ()=>{};
const $d210afe50fb6fdd6$export$688547a52c1d762b = ({ eventFrom: eventFrom, ufoExperience: ufoExperience })=>{
    const ufoErrorLogger = (0, $eUqFw.useCallback)((error)=>(0, $gUUjF.default).safeErrorWithoutCustomerData(`${(0, $3523ef16f82a4788$export$d3996f57ffa8448f)}.${eventFrom}.${ufoExperience?.id || 'unknown'}.${(0, $isy2b.experiences).RENDER}`, 'Insights experience failed', error), [
        eventFrom,
        ufoExperience
    ]);
    return ufoExperience ? ufoErrorLogger : $d210afe50fb6fdd6$var$noop;
};

});



parcelRegister("c02Pd", function(module, exports) {

$parcel$export(module.exports, "withComponentSafety", () => $c10cc774855af295$export$cb70221ec28d89b);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");
/* condition must return true for component to render */ function $c10cc774855af295$export$cb70221ec28d89b(Component, { condition: condition, location: location, message: message = ()=>'withComponentSafety blocked render', Fallback: Fallback = ()=>null }) {
    return (props)=>{
        const isSafe = condition(props);
        const formattedMessage = message(props);
        (0, $eUqFw.useEffect)(()=>{
            if (!isSafe) (0, $gUUjF.default).safeErrorWithoutCustomerData(location, formattedMessage);
        }, [
            isSafe,
            formattedMessage
        ]);
        // @ts-expect-error - Type 'Props' is not assignable to type 'IntrinsicAttributes & Props'.
        return isSafe ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Fallback, props);
    };
}

});

parcelRegister("WbcDx", function(module, exports) {

$parcel$export(module.exports, "getTextValue", () => $6b6a81fb4f40d940$export$6ca03cb7b75bfa13);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6b6a81fb4f40d940$var$isUndefinedOrNull = (value)=>value === null || value === undefined;
const $6b6a81fb4f40d940$export$96252741c837b909 = (value, defaultValue)=>$6b6a81fb4f40d940$var$isUndefinedOrNull(value) ? defaultValue : value;
const $6b6a81fb4f40d940$export$22a0d6ac9d3db3b9 = (value, defaultValue)=>$6b6a81fb4f40d940$var$isUndefinedOrNull(value) ? defaultValue : value;
const $6b6a81fb4f40d940$export$6ca03cb7b75bfa13 = (value, defaultValue)=>$6b6a81fb4f40d940$var$isUndefinedOrNull(value) ? defaultValue : value;
const $6b6a81fb4f40d940$export$e1a3353b722e75de = (value, defaultValue)=>$6b6a81fb4f40d940$var$isUndefinedOrNull(value) ? defaultValue : value;

});

parcelRegister("P6noH", function(module, exports) {

$parcel$export(module.exports, "InsightsContainer", () => $4998da5c93f931c5$export$af2273df1febba45);

var $eUqFw = parcelRequire("eUqFw");

var $8WJdE = parcelRequire("8WJdE");

var $52ZlB = parcelRequire("52ZlB");
const $4998da5c93f931c5$var$buildScopeName = (scope, packageName)=>`${scope}-${packageName}`;
const $4998da5c93f931c5$var$ChildrenWrapperWithHook = ({ children: children })=>{
    const [state, actions] = (0, $52ZlB.useInsightsContainer)();
    return children(state, actions);
};
const $4998da5c93f931c5$export$af2273df1febba45 = ({ scope: scope, packageName: packageName, children: children })=>{
    const insightsStoreContainerScope = $4998da5c93f931c5$var$buildScopeName(scope, packageName);
    if (typeof children === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WJdE.InsightsStoreContainer), {
        scope: insightsStoreContainerScope
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4998da5c93f931c5$var$ChildrenWrapperWithHook, null, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WJdE.InsightsStoreContainer), {
        scope: insightsStoreContainerScope
    }, children);
};

});
parcelRegister("8WJdE", function(module, exports) {

$parcel$export(module.exports, "InsightsStoreContainer", () => $d8ecc49648899d91$export$4b6f97ed14dce97c);
$parcel$export(module.exports, "useInsightsStoreContainer", () => $d8ecc49648899d91$export$bd382fb3f9d0551e);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");


var $4BBDo = parcelRequire("4BBDo");

var $8uQ9q = parcelRequire("8uQ9q");
const $d8ecc49648899d91$var$Store = (0, $a61MH.createStore)({
    initialState: $8uQ9q.initialState,
    actions: $4BBDo.actions,
    name: (0, $4eea1222a132160b$export$cd79d01fb3d2f506)
});
const $d8ecc49648899d91$export$4b6f97ed14dce97c = (0, $heB5U.createContainer)($d8ecc49648899d91$var$Store);
const $d8ecc49648899d91$export$bd382fb3f9d0551e = (0, $ggKAj.createHook)($d8ecc49648899d91$var$Store);

});
const $4eea1222a132160b$export$cd79d01fb3d2f506 = 'jira.insights.container-store';

parcelRegister("4BBDo", function(module, exports) {

$parcel$export(module.exports, "actions", () => $4308fcb41b5db771$export$e324594224ef24da);

var $hompL = parcelRequire("hompL");

var $8uQ9q = parcelRequire("8uQ9q");
const $4308fcb41b5db771$var$updateContainer = (data)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const nextState = {
            info: state.info,
            data: {
                ...state.data,
                ...data
            }
        };
        setState(nextState);
    };
const $4308fcb41b5db771$var$toggleProp = (propsName)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const nextState = {
            info: state.info,
            data: {
                ...state.data,
                [propsName]: !state.data[propsName]
            }
        };
        setState(nextState);
    };
const $4308fcb41b5db771$var$setInfo = (data)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const nextState = {
            data: state.data,
            info: {
                ...state.info,
                ...data
            }
        };
        setState(nextState);
    };
const $4308fcb41b5db771$var$refreshUniqueId = ()=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const nextState = {
            data: state.data,
            info: {
                ...state.info,
                uniqueId: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4()
            }
        };
        setState(nextState);
    };
const $4308fcb41b5db771$var$cleanState = ()=>({ setState: setState })=>{
        setState((0, $8uQ9q.initialState));
    };
const $4308fcb41b5db771$var$updateIsDeepLinking = (isDeepLinking)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const nextState = {
            data: state.data,
            info: {
                ...state.info,
                isDeepLinking: isDeepLinking
            }
        };
        setState(nextState);
    };
const $4308fcb41b5db771$export$e324594224ef24da = {
    setInfo: $4308fcb41b5db771$var$setInfo,
    cleanState: $4308fcb41b5db771$var$cleanState,
    toggleProp: $4308fcb41b5db771$var$toggleProp,
    updateContainer: $4308fcb41b5db771$var$updateContainer,
    refreshUniqueId: $4308fcb41b5db771$var$refreshUniqueId,
    updateIsDeepLinking: $4308fcb41b5db771$var$updateIsDeepLinking
};

});
parcelRegister("8uQ9q", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $9ccb031b976062ee$export$d4c72bab9d6cc13a);

var $hompL = parcelRequire("hompL");
const $9ccb031b976062ee$var$info = {
    uniqueId: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
    isDeepLinking: true
};
const $9ccb031b976062ee$export$d4c72bab9d6cc13a = {
    info: $9ccb031b976062ee$var$info,
    data: {}
};

});



parcelRegister("52ZlB", function(module, exports) {

$parcel$export(module.exports, "useInsightsContainer", () => $7aaf2399ac93015e$export$8ecf81d0c059927c);

var $eUqFw = parcelRequire("eUqFw");

var $lUx93 = parcelRequire("lUx93");

var $8WJdE = parcelRequire("8WJdE");

var $aoiZq = parcelRequire("aoiZq");
const $7aaf2399ac93015e$export$8ecf81d0c059927c = ()=>{
    const [state, actions] = (0, $8WJdE.useInsightsStoreContainer)();
    const memoCallbacksRef = (0, $eUqFw.useRef)({});
    const toggleAction = actions.toggleProp;
    (0, $lUx93.useIsAnyLevelOfAdmin)({
        onIsAnyLevelOfAdminUpdated: actions.setInfo
    });
    (0, $aoiZq.useIsProjectType)({
        onIsProjectTypeUpdated: actions.setInfo
    });
    /*
      This will create a memoized function callback scoped to the current scope + propName so we can easily
      call this function from the onClick of any of the composed components.
      ex:
        <InsightsContainer>
          {({ data: { isPanelOpen } }, { onToggleCallback }) => {
            <HidePanelButton onClick={onToggleCallback('isPanelOpen')}
            <Panel isPanelOpen={isPanelOpen} />
          }}
        <InsightsContainer>
    */ const onToggleCallback = (0, $eUqFw.useCallback)((propName)=>{
        if (!memoCallbacksRef.current) memoCallbacksRef.current = {};
        const callbacksMap = memoCallbacksRef.current;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        if (propName && !callbacksMap[propName]) // this will prevent recreate the callback on each render
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        callbacksMap[propName] = ()=>toggleAction(propName);
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        return callbacksMap[propName];
    }, [
        toggleAction
    ]);
    const updateContainerAction = actions.updateContainer;
    /*
      This will create a memoized function callback scoped to the current scope + propName so we can easily
      call this function from the onClick of any of the composed components.
      ex:
        <InsightsContainer>
          {({ data: { settings } }, { onDataUpdatedCallback }) => {
            <LoadPanelSettings onLoad={onDataUpdatedCallback('settings')}
            <Panel settings={settings} />
          }}
        <InsightsContainer>
    */ const onDataUpdatedCallback = (0, $eUqFw.useCallback)((propName)=>{
        if (!memoCallbacksRef.current) memoCallbacksRef.current = {};
        const callbacksMap = memoCallbacksRef.current;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        if (!callbacksMap[propName]) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        callbacksMap[propName] = (data)=>// this will prevent recreate the callback on each render
            updateContainerAction({
                [propName]: data
            });
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        return callbacksMap[propName];
    }, [
        updateContainerAction
    ]);
    return [
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        state,
        {
            onDataUpdatedCallback: // preferred usage is onDataUpdatedCallback and onToggleCallback
            onDataUpdatedCallback,
            onToggleCallback: onToggleCallback,
            // when we need a big customization and onDataUpdatedCallback and onToggleCallback do not fit
            // to solve the problem, we can use the original implementation onUpdate and onToggle
            doUpdate: actions.updateContainer,
            doToggle: actions.toggleProp,
            doClean: actions.cleanState,
            // pass through actions (from insights container)
            refreshUniqueId: actions.refreshUniqueId,
            updateIsDeepLinking: actions.updateIsDeepLinking
        }
    ];
};

});
parcelRegister("lUx93", function(module, exports) {

$parcel$export(module.exports, "useIsAnyLevelOfAdmin", () => $c5742187f44b39fe$export$b29f514064315678);

var $eUqFw = parcelRequire("eUqFw");

var $bNe1g = parcelRequire("bNe1g");

var $c7H0g = parcelRequire("c7H0g");
var $1R3n5 = parcelRequire("1R3n5");
const $c5742187f44b39fe$export$b29f514064315678 = ({ onIsAnyLevelOfAdminUpdated: onIsAnyLevelOfAdminUpdated })=>{
    const { data: projectContext } = (0, $bNe1g.useProjectContext)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const isProjectAdmin = !!projectContext?.isProjectAdmin;
    (0, $eUqFw.useEffect)(()=>{
        onIsAnyLevelOfAdminUpdated({
            isAnyLevelOfAdmin: !!(isSiteAdmin || isAdmin || isProjectAdmin)
        });
    }, [
        isProjectAdmin,
        isSiteAdmin,
        isAdmin,
        onIsAnyLevelOfAdminUpdated
    ]);
};

});

parcelRegister("aoiZq", function(module, exports) {

$parcel$export(module.exports, "useIsProjectType", () => $24036e8057507301$export$3b6950eab2454ef6);

var $eUqFw = parcelRequire("eUqFw");

var $SEaoU = parcelRequire("SEaoU");
const $24036e8057507301$export$3b6950eab2454ef6 = ({ onIsProjectTypeUpdated: onIsProjectTypeUpdated })=>{
    const [{ data: containerContext }] = (0, $SEaoU.useContainerContext)();
    const isProjectType = containerContext?.contextType === 'project';
    (0, $eUqFw.useEffect)(()=>{
        onIsProjectTypeUpdated({
            isProjectType: isProjectType
        });
    }, [
        isProjectType,
        onIsProjectTypeUpdated
    ]);
};

});



parcelRegister("8B7Mk", function(module, exports) {

$parcel$export(module.exports, "InsightsSettingsLoader", () => $49157a5107ae383b$export$28079df9c9fef0d2);

var $eUqFw = parcelRequire("eUqFw");

var $fWSio = parcelRequire("fWSio");

var $2pKbZ = parcelRequire("2pKbZ");

var $4fN5I = parcelRequire("4fN5I");

var $aND76 = parcelRequire("aND76");
const $49157a5107ae383b$export$28079df9c9fef0d2 = ({ boardId: boardId, onSettingsLoaded: onSettingsLoaded })=>{
    const [{ data: settingsResult, loading: loading, fetched: fetched, aborted: aborted, hasError: hasError }, { doAbort: doAbort }] = (0, $fWSio.useFetch)({
        onFetch: (options)=>(0, $aND76.fetchInsightsSettings)({
                boardId: boardId
            }, options),
        isAbortable: true,
        analyticsTracking: {
            actionSubject: `${(0, $2pKbZ.insightsSettingsLoaderAnalytics).ACTION_SUBJECT}.${(0, $2pKbZ.insightsSettingsLoaderAnalytics).ACTION_SUBJECT_ID}`,
            sampleRate: 100
        },
        browserMetricsKey: `${(0, $2pKbZ.insightsSettingsLoaderAnalytics).ACTION_SUBJECT}.${(0, $2pKbZ.insightsSettingsLoaderAnalytics).ACTION_SUBJECT_ID}`,
        loggingKey: `${(0, $2pKbZ.insightsSettingsLoaderAnalytics).ACTION_SUBJECT}.${(0, $2pKbZ.insightsSettingsLoaderAnalytics).ACTION_SUBJECT_ID}`
    }, [
        boardId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        let timeout;
        if (loading || !settingsResult) {
            onSettingsLoaded({
                status: 'loading'
            });
            timeout = setTimeout(doAbort, (0, $2pKbZ.GET_SETTINGS_ENDPOINT_TIMEOUT_WHEN_INSIGHTS_LOADING));
        }
        if (fetched && settingsResult && !hasError && !aborted) onSettingsLoaded({
            status: 'success',
            data: (0, $4fN5I.withDefaults)(settingsResult.context.board.settings)
        });
        if (hasError || aborted) onSettingsLoaded({
            status: 'error',
            data: (0, $2pKbZ.insightsSettingsDefaults)
        });
        return ()=>clearTimeout(timeout);
    }, [
        fetched,
        loading,
        aborted,
        settingsResult,
        hasError,
        onSettingsLoaded,
        doAbort
    ]);
    return null;
};

});

parcelRegister("dvoRM", function(module, exports) {

$parcel$export(module.exports, "InsightsButton", () => $3e428d864e5c8a8f$export$943e069e37d25a04);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $5tgfW = parcelRequire("5tgfW");

var $3EqqU = parcelRequire("3EqqU");
var $5ARvW = parcelRequire("5ARvW");

var $PdmhA = parcelRequire("PdmhA");

var $0cdA8 = parcelRequire("0cdA8");

var $1ybV0 = parcelRequire("1ybV0");

var $4lw2o = parcelRequire("4lw2o");

var $QKvwB = parcelRequire("QKvwB");

var $5JgJ2 = parcelRequire("5JgJ2");

var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");

var $kS8l2 = parcelRequire("kS8l2");

var $eDgaT = parcelRequire("eDgaT");

var $7DICb = parcelRequire("7DICb");
const $3e428d864e5c8a8f$var$actionSubjectId = 'toggleInsightsPanel';
const $3e428d864e5c8a8f$var$TooltipWrapper = ({ children: children, render: render })=>render != null ? render({
        children: children
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
const $3e428d864e5c8a8f$var$buttonTestId = 'insights-show-insights-button.ui.insights-button';
const $3e428d864e5c8a8f$var$buttonForHiddenTestId = 'insights-show-insights-button.ui.button-test-id-hide';
const $3e428d864e5c8a8f$export$2fdc3445dd252e1 = ({ clickEventAnalytics: clickEventAnalytics, iconAfter: iconAfter, isCompact: isCompact = false, isHidden: isHidden = false, isInsightsPanelOpen: isInsightsPanelOpen, isOnboardingDisabled: isOnboardingDisabled = false, onToggle: onToggle, renderTooltip: renderTooltip })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [, { register: register }] = (0, $kS8l2.useGlobalRefStoreActions)();
    const onRefSmall = (0, $eUqFw.useCallback)((ref)=>{
        register((0, $QKvwB.INSIGHTS_BUTTON_SM), ref);
    }, [
        register
    ]);
    const onRefButtonLarge = (0, $eUqFw.useCallback)((ref)=>{
        register((0, $QKvwB.INSIGHTS_BUTTON_LG), ref);
    }, [
        register
    ]);
    const onRefButtonResponsiveOld = (0, $eUqFw.useCallback)((ref)=>{
        register((0, $QKvwB.INSIGHTS_BUTTON_RESPONSIVE), ref);
    }, [
        register
    ]);
    const onRefButtonResponsiveNew = (0, $eUqFw.useCallback)((ref)=>{
        register((0, $QKvwB.INSIGHTS_BUTTON_RESPONSIVE), ref);
    }, [
        register
    ]);
    const isSupported = (0, $4lw2o.useIsCurrentBrowserSupported)();
    const isDisabled = isOnboardingDisabled;
    const onClick = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, $3e428d864e5c8a8f$var$actionSubjectId, {
            action: isInsightsPanelOpen ? 'close' : 'open',
            isDisabled: isDisabled,
            ...clickEventAnalytics?.attributes || {}
        });
        onToggle(analyticsEvent);
    }, [
        clickEventAnalytics,
        isDisabled,
        isInsightsPanelOpen,
        onToggle
    ]);
    const label = isInsightsPanelOpen ? formatMessage((0, $7DICb.default).hideInsights) : formatMessage((0, $7DICb.default).showInsights);
    if (!isSupported) return null;
    const showInsightsButton = !isHidden;
    if (!showInsightsButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireOperationalAnalytics), {
        action: "hidden",
        actionSubject: "button",
        actionSubjectId: $3e428d864e5c8a8f$var$actionSubjectId
    });
    const iconColor = isInsightsPanelOpen ? undefined : `var(--ds-icon, ${(0, $PdmhA).N500})`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireUiAnalytics), {
        action: "rendered",
        actionSubject: "button",
        actionSubjectId: $3e428d864e5c8a8f$var$actionSubjectId
    }), (0, $1ybV0.ff)('sea-2744-jsw-tabs-nav') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eDgaT.ResponsiveButton), {
        interactionName: "show-insights-button",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5tgfW))),
        label: label,
        iconAfter: typeof iconAfter === 'function' ? iconAfter : undefined,
        isSelected: isInsightsPanelOpen,
        onClick: onClick,
        testId: $3e428d864e5c8a8f$var$buttonTestId,
        ref: (0, $1ybV0.ff)('refactor-jira-responsive-button_3ifhq') ? onRefButtonResponsiveNew : onRefButtonResponsiveOld
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e428d864e5c8a8f$var$TooltipWrapper, {
        render: renderTooltip
    }, isCompact ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        interactionName: "show-insights-button",
        appearance: "subtle",
        spacing: "none",
        isSelected: isInsightsPanelOpen,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5tgfW))), {
            label: label,
            primaryColor: iconColor
        }),
        onClick: onClick,
        testId: $3e428d864e5c8a8f$var$buttonTestId,
        ref: onRefSmall
    }) : // eslint-disable-next-line jira/react/no-empty-divs
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ARvW.Show), {
        above: "lg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        interactionName: "show-insights-button",
        isSelected: isInsightsPanelOpen,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5tgfW))), {
            label: "",
            primaryColor: iconColor
        }),
        iconAfter: typeof iconAfter === 'object' ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        iconAfter : undefined,
        onClick: onClick,
        testId: $3e428d864e5c8a8f$var$buttonTestId,
        ref: onRefButtonLarge
    }, label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3EqqU.Hide), {
        above: "lg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        interactionName: "show-insights-button",
        isSelected: isInsightsPanelOpen,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5tgfW))), {
            label: label,
            primaryColor: iconColor
        }),
        onClick: onClick,
        testId: $3e428d864e5c8a8f$var$buttonForHiddenTestId,
        ref: onRefSmall
    })))));
};
const $3e428d864e5c8a8f$export$943e069e37d25a04 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "button",
        packageName: (0, $QKvwB.JIRA_INSIGHTS),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e428d864e5c8a8f$export$2fdc3445dd252e1, props));

});
parcelRegister("5tgfW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3fbc4552fa192c48$var$_react = $3fbc4552fa192c48$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $3fbc4552fa192c48$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $3fbc4552fa192c48$var$GraphLineIcon = (props)=>/*#__PURE__*/ $3fbc4552fa192c48$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor"><path d="M21 17H4.995C4.448 17 4 16.548 4 15.991V6a1 1 0 10-2 0v9.991A3.004 3.004 0 004.995 19H21a1 1 0 000-2zm-3-8v3a1 1 0 002 0V8a1 1 0 00-1-1h-4a1 1 0 000 2h3z"/><path d="M13.293 13.707a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L14 11.586l-2.293-2.293a1 1 0 00-1.414 0l-4 4a1 1 0 001.414 1.414L11 11.414l2.293 2.293z"/></g></svg>`
    }, props));
$3fbc4552fa192c48$var$GraphLineIcon.displayName = 'GraphLineIcon';
var $3fbc4552fa192c48$var$_default = $3fbc4552fa192c48$var$GraphLineIcon;
module.exports.default = $3fbc4552fa192c48$var$_default;

});

parcelRegister("7DICb", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d5979fd64d9754c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8d5979fd64d9754c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    showInsights: {
        "id": "insights-show-insights-button.show-insights",
        "defaultMessage": "Insights"
    },
    hideInsights: {
        "id": "insights-show-insights-button.hide-insights",
        "defaultMessage": "Insights"
    }
});

});


parcelRegister("iHjyA", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad443ed86cd76613$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $QKvwB = parcelRequire("QKvwB");

var $bFzGY = parcelRequire("bFzGY");

var $aP4j9 = parcelRequire("aP4j9");

var $2oR6p = parcelRequire("2oR6p");

var $5PlC8 = parcelRequire("5PlC8");
function $ad443ed86cd76613$export$2e2bcd8739ae039({ onToggle: onToggle, isOpen: isOpen, experienceId: experienceId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "jptAutoOpenInsightsPanel",
        packageName: "jiraJswPresentationToolkit",
        teamName: "luna-growth",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ad443ed86cd76613$var$CheckTimestamp, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ad443ed86cd76613$var$CheckEligibilityAndToggle, {
        onToggle: onToggle,
        isOpen: isOpen,
        experienceId: experienceId
    })));
}
function $ad443ed86cd76613$var$CheckEligibilityAndToggle({ onToggle: onToggle, isOpen: isOpen, experienceId: experienceId }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const isEligible = (0, $2oR6p.useIsEligibleAutoOpenInsightsPanel)();
    const { updateAutoOpenTimestamp: updateAutoOpenTimestamp } = (0, $5PlC8.useAutoOpenTimestampActions)();
    (0, $eUqFw.useEffect)(()=>{
        if (!isEligible) return;
        updateAutoOpenTimestamp();
        if (isOpen) return;
        onToggle(createAnalyticsEvent({
            actionSubject: `${(0, $QKvwB.INSIGHTS_PANEL)}.${(0, $aP4j9.EXPERIMENT_NAME)}`,
            action: 'expanded'
        }), experienceId);
    }, [
        isEligible,
        onToggle,
        isOpen,
        experienceId,
        createAnalyticsEvent,
        updateAutoOpenTimestamp
    ]);
    return null;
}
function $ad443ed86cd76613$var$CheckTimestamp({ children: children }) {
    const { hasBeenFourteenDays: hasBeenFourteenDays } = (0, $5PlC8.useAutoOpenTimestampState)();
    // we only want to auto-open the insights panel once per trial. Since we only show the experiment in the last week of the trial, 14 days is sufficient for both the Standard trial and Premium trial cases.
    if (!hasBeenFourteenDays) return null;
    return children;
}

});
parcelRegister("aP4j9", function(module, exports) {

$parcel$export(module.exports, "EXPERIMENT_NAME", () => $c49f32479bff656c$export$1a377568e2ef140b);
$parcel$export(module.exports, "ONE_MINUTE_IN_MS", () => $c49f32479bff656c$export$5460cb5065bb4df4);
$parcel$export(module.exports, "ONE_DAY_IN_MS", () => $c49f32479bff656c$export$14c29d43b22a755f);
$parcel$export(module.exports, "STANDARD_EDITION_STAGING", () => $c49f32479bff656c$export$7c1ef5fed2d8cbb6);
$parcel$export(module.exports, "STANDARD_EDITION_PROD", () => $c49f32479bff656c$export$edfe6be85fec8156);
$parcel$export(module.exports, "PREMIUM_EDITION_STAGING", () => $c49f32479bff656c$export$c954d120a5cccb63);
$parcel$export(module.exports, "PREMIUM_EDITION_PROD", () => $c49f32479bff656c$export$b7783c141625d7f6);
const $c49f32479bff656c$export$1a377568e2ef140b = 'jsw_presentation_toolkit_experiment';
const $c49f32479bff656c$export$5460cb5065bb4df4 = 60000;
const $c49f32479bff656c$export$14c29d43b22a755f = $c49f32479bff656c$export$5460cb5065bb4df4 * 1440;
const $c49f32479bff656c$export$7c1ef5fed2d8cbb6 = 'ef35c2d0-782b-4630-892a-dc34b54f1a3e';
const $c49f32479bff656c$export$edfe6be85fec8156 = '7b634a4b-3d3d-41e1-bdd1-a705c97bdbdb';
const $c49f32479bff656c$export$c954d120a5cccb63 = '34e8a66a-709f-41c6-9ca7-39b79432a7f6';
const $c49f32479bff656c$export$b7783c141625d7f6 = 'cbf0a165-b123-498b-8ae0-ea287f543baf';

});

parcelRegister("2oR6p", function(module, exports) {

$parcel$export(module.exports, "useIsEligibleAutoOpenInsightsPanel", () => $acc170aed0a65eb7$export$3ee6d6187157c61c);

var $eUqFw = parcelRequire("eUqFw");

var $1Iui1 = parcelRequire("1Iui1");

var $79xbN = parcelRequire("79xbN");

var $kJlBc = parcelRequire("kJlBc");

var $cQYZD = parcelRequire("cQYZD");

var $2WTQ6 = parcelRequire("2WTQ6");

var $5PlC8 = parcelRequire("5PlC8");
function $acc170aed0a65eb7$export$3ee6d6187157c61c() {
    const [selectedIssue] = (0, $kJlBc.useQueryParam)('selectedIssue');
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [_, fireExposure] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_presentation_toolkit_experiment');
    const { isEligible: isEligible, cohort: cohort } = (0, $2WTQ6.useCheckExperimentEligibility)(false);
    const [isEligibleToOpen, setIsEligibleToOpen] = (0, $eUqFw.useState)(false);
    const { hasBeenFourteenDays: hasBeenFourteenDays } = (0, $5PlC8.useAutoOpenTimestampState)();
    const { updateAutoOpenTimestamp: updateAutoOpenTimestamp } = (0, $5PlC8.useAutoOpenTimestampActions)();
    const { fireOperationalExposureEvent: fireOperationalExposureEvent } = (0, $cQYZD.useOperationalExposureEvent)();
    (0, $eUqFw.useEffect)(()=>{
        if (!isEligible || selectedIssue || !hasBeenFourteenDays) {
            setIsEligibleToOpen(false);
            return;
        }
        fireExposure();
        fireOperationalExposureEvent();
        if (cohort !== (0, $1Iui1.EXPERIMENT)) {
            // update timestamp for control. The "experiment" cohort will be handled when the insights panel is auto-toggled
            updateAutoOpenTimestamp();
            setIsEligibleToOpen(false);
            return;
        }
        setIsEligibleToOpen(true);
    }, [
        isEligible,
        isEligibleToOpen,
        hasBeenFourteenDays,
        setIsEligibleToOpen,
        cohort,
        fireExposure,
        selectedIssue,
        updateAutoOpenTimestamp,
        fireOperationalExposureEvent
    ]);
    return isEligibleToOpen;
}

});
parcelRegister("cQYZD", function(module, exports) {

$parcel$export(module.exports, "useServiceTrackEvent", () => $db63004afece8dac$export$872c39689d8c9703);
$parcel$export(module.exports, "useOperationalExposureEvent", () => $db63004afece8dac$export$c3afad4765507ae8);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $1Iui1 = parcelRequire("1Iui1");

var $jMP2a = parcelRequire("jMP2a");

var $aP4j9 = parcelRequire("aP4j9");

var $gVgw0 = parcelRequire("gVgw0");
function $db63004afece8dac$export$872c39689d8c9703() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const cohort = (0, $gVgw0.useExperimentCohort)((0, $1Iui1.NOT_ENROLLED));
    const fireServiceTrackEvent = (0, $eUqFw.useCallback)(({ service: service })=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'jptDataFetch succeeded', {
            service: service,
            experiment: (0, $aP4j9.EXPERIMENT_NAME),
            cohort: cohort
        });
    }, [
        createAnalyticsEvent,
        cohort
    ]);
    return {
        fireServiceTrackEvent: fireServiceTrackEvent
    };
}
function $db63004afece8dac$export$c3afad4765507ae8() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const cohort = (0, $gVgw0.useExperimentCohort)((0, $1Iui1.NOT_ENROLLED));
    const fireOperationalExposureEvent = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jptFeature exposed', {
            experiment: (0, $aP4j9.EXPERIMENT_NAME),
            cohort: cohort
        });
    }, [
        createAnalyticsEvent,
        cohort
    ]);
    return {
        fireOperationalExposureEvent: fireOperationalExposureEvent
    };
}

});
parcelRegister("gVgw0", function(module, exports) {

$parcel$export(module.exports, "useExperimentCohort", () => $135f9914801b62df$export$2fddd8eded15042b);

var $79xbN = parcelRequire("79xbN");
function $135f9914801b62df$export$2fddd8eded15042b(defaultValue) {
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_presentation_toolkit_experiment');
    return expConfig.get('cohort', defaultValue);
}

});


parcelRegister("2WTQ6", function(module, exports) {

$parcel$export(module.exports, "useCheckExperimentEligibility", () => $bc40f63bc7ab96f1$export$5e69339f603acb1a);

var $6UHYb = parcelRequire("6UHYb");


var $ab6rA = parcelRequire("ab6rA");
var $g4G5S = parcelRequire("g4G5S");

var $h7pdu = parcelRequire("h7pdu");

var $9NlnY = parcelRequire("9NlnY");
function $bc40f63bc7ab96f1$export$5e69339f603acb1a(shouldFireExposure = true) {
    const { software: jswEdition } = (0, $ab6rA.useAppEditions)();
    const productEntitlementDetails = (0, $g4G5S.useProductEntitlementDetails)();
    const { premiumTrialOnSignup: premiumTrialOnSignup, isReady: isDoneFetchingPremiumTrialOnSignup } = (0, $6UHYb.useFetchOnboardingReverseTrial)();
    const { isDirectToStandardTrial: isDirectToStandardTrial, isReady: isDoneFetchingDirectToStandardTrial } = (0, $h7pdu.useDirectToStandardTrial)();
    const jswEntitlement = productEntitlementDetails?.[0, $2edfd53057852e41$export$1346c9aa3cbb477d];
    return (0, $9NlnY.useGetResponseAndFireAnalytics)({
        isDoneFetchingDirectToStandardTrial: isDoneFetchingDirectToStandardTrial,
        isDoneFetchingPremiumTrialOnSignup: isDoneFetchingPremiumTrialOnSignup,
        shouldFireExposure: shouldFireExposure,
        jswEdition: jswEdition,
        jswEntitlement: jswEntitlement,
        premiumTrialOnSignup: premiumTrialOnSignup,
        isDirectToStandardTrial: isDirectToStandardTrial
    });
}

});
parcelRegister("6UHYb", function(module, exports) {

$parcel$export(module.exports, "useFetchOnboardingReverseTrial", () => $b872f119bb939011$export$349fbee95cd03b58);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $3dMdu = parcelRequire("3dMdu");

var $kGBLN = parcelRequire("kGBLN");

var $eqi1A = parcelRequire("eqi1A");
const $b872f119bb939011$var$store = (0, $a61MH.createStore)({
    name: 'jsw-onboarding-reverse-trial',
    initialState: (0, $3dMdu.initialCachedEndpointState),
    actions: $eqi1A.actions
});
const $b872f119bb939011$export$6758b294795e1644 = (0, $ggKAj.createHook)($b872f119bb939011$var$store);
const $b872f119bb939011$export$349fbee95cd03b58 = ()=>{
    const isTargetedForReverseTrials = (0, $kGBLN.useIsTargetedForReverseTrials)();
    const [{ fetchedOnce: fetchedOnce, isFetching: isFetching, data: data }, { getPremiumTrialOnSignup: getPremiumTrialOnSignup }] = $b872f119bb939011$export$6758b294795e1644();
    (0, $eUqFw.useEffect)(()=>{
        if (isTargetedForReverseTrials && !fetchedOnce && !isFetching && data === undefined) // @ts-expect-error Arguments for the rest parameter 'args' were not provided.
        getPremiumTrialOnSignup();
    }, [
        data,
        fetchedOnce,
        getPremiumTrialOnSignup,
        isFetching,
        isTargetedForReverseTrials
    ]);
    if (!isTargetedForReverseTrials) // If not targeted, no fetching is done. Data is ready to be read
    return {
        premiumTrialOnSignup: undefined,
        reverseTrialCohort: data?.reverseTrialCohort,
        isReady: true
    };
    return {
        premiumTrialOnSignup: data?.premiumTrialOnSignup,
        reverseTrialCohort: data?.reverseTrialCohort,
        isReady: fetchedOnce && !isFetching
    };
};

});
parcelRegister("3dMdu", function(module, exports) {

$parcel$export(module.exports, "initialCachedEndpointState", () => $38ffeb975058cb36$export$aaed2d023c5dc2c);
const $38ffeb975058cb36$export$aaed2d023c5dc2c = {
    isFetching: false,
    wasFetched: false,
    fetchedOnce: false,
    fetchError: null
};

});

parcelRegister("kGBLN", function(module, exports) {

$parcel$export(module.exports, "useIsTargetedForReverseTrials", () => $eb0c94e7b9053e0a$export$897219a3ca9649b9);

var $7ZZxN = parcelRequire("7ZZxN");

var $eI5EY = parcelRequire("eI5EY");

var $bNe1g = parcelRequire("bNe1g");

var $6WXNs = parcelRequire("6WXNs");

var $ab6rA = parcelRequire("ab6rA");
const $eb0c94e7b9053e0a$export$897219a3ca9649b9 = ()=>{
    const { data: projectContextData } = (0, $bNe1g.useProjectContext)();
    const jswEdition = (0, $ab6rA.useAppEditions)().software;
    if ((0, $eI5EY.fg)('jsw_reverse_trials_feature_gate')) {
        const isCurrentProjectJSW = projectContextData?.projectType === (0, $7ZZxN.SOFTWARE_PROJECT);
        if (jswEdition === (0, $6WXNs.PREMIUM_EDITION) && isCurrentProjectJSW) return true;
        return false;
    }
    return false;
};

});

parcelRegister("eqi1A", function(module, exports) {

$parcel$export(module.exports, "actions", () => $8ab1d92bbb3896f3$export$e324594224ef24da);

var $879e1 = parcelRequire("879e1");

var $4sxuP = parcelRequire("4sxuP");
const $8ab1d92bbb3896f3$var$getPremiumTrialOnSignup = (0, $879e1.cachedEndpointCall)((0, $4sxuP.getOnboardingPremiumTrialWithRethrow));
const $8ab1d92bbb3896f3$export$e324594224ef24da = {
    getPremiumTrialOnSignup: $8ab1d92bbb3896f3$var$getPremiumTrialOnSignup
};

});
parcelRegister("879e1", function(module, exports) {

$parcel$export(module.exports, "cachedEndpointCall", () => $08a4c99d11c890ab$export$9ab04ab45a9b99da);
const $08a4c99d11c890ab$export$9ab04ab45a9b99da = (call)=>(params)=>async ({ getState: getState, setState: setState })=>{
            const { isFetching: isFetching, wasFetched: wasFetched, fetchedOnce: fetchedOnce } = getState();
            if (isFetching || wasFetched) return;
            setState({
                isFetching: true
            });
            try {
                const data = await call(params);
                if (data !== null) setState({
                    data: data,
                    wasFetched: true
                });
                else setState({
                    wasFetched: fetchedOnce
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    fetchError: error
                });
            } finally{
                setState({
                    isFetching: false,
                    fetchedOnce: true
                });
            }
        };

});



const $2edfd53057852e41$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $2edfd53057852e41$export$e9c56aa3b027d98f = 'jira-customer-service';
const $2edfd53057852e41$export$1346c9aa3cbb477d = 'jira-software';
const $2edfd53057852e41$export$202f50ee62667e32 = 'jira-product-discovery';
const $2edfd53057852e41$export$db515c8cec1e6f79 = 'jira-core';
const $2edfd53057852e41$export$c811f21c9ad05dc2 = 'confluence';
const $2edfd53057852e41$export$961148c98d198270 = 'opsgenie';

parcelRegister("g4G5S", function(module, exports) {

$parcel$export(module.exports, "useProductEntitlementDetails", () => $c8efb20e27e18352$export$e02d6385b5d47f5d);

var $gd0Sp = parcelRequire("gd0Sp");
const $c8efb20e27e18352$export$e02d6385b5d47f5d = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.productEntitlementDetails || null;
};

});

parcelRegister("h7pdu", function(module, exports) {

$parcel$export(module.exports, "useDirectToStandardTrial", () => $655b8f00fad935a4$export$eab89fdd1f3c3bca);

var $eUqFw = parcelRequire("eUqFw");

var $1Iui1 = parcelRequire("1Iui1");

var $79xbN = parcelRequire("79xbN");

var $ccm3Y = parcelRequire("ccm3Y");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6WXNs = parcelRequire("6WXNs");

var $ab6rA = parcelRequire("ab6rA");
var $dWLk9 = parcelRequire("dWLk9");
var $g4G5S = parcelRequire("g4G5S");

var $aP4j9 = parcelRequire("aP4j9");

var $cQYZD = parcelRequire("cQYZD");
const $655b8f00fad935a4$export$eab89fdd1f3c3bca = ()=>{
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_presentation_toolkit_experiment');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { fireServiceTrackEvent: fireServiceTrackEvent } = (0, $cQYZD.useServiceTrackEvent)();
    const productEntitlementDetails = (0, $g4G5S.useProductEntitlementDetails)();
    const { software: jswEdition } = (0, $ab6rA.useAppEditions)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const cohort = expConfig.get('cohort', (0, $1Iui1.NOT_ENROLLED));
    const jswEntitlement = productEntitlementDetails?.[0, $2edfd53057852e41$export$1346c9aa3cbb477d];
    const trialEndTimeMs = jswEntitlement?.trialEndTime;
    const [isReady, setIsReady] = (0, $eUqFw.useState)(false);
    const [isDirectToStandardTrial, setIsDirectToStandardTrial] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (cohort === (0, $1Iui1.NOT_ENROLLED) || jswEdition !== (0, $6WXNs.STANDARD_EDITION) || !trialEndTimeMs) {
            setIsReady(true);
            setIsDirectToStandardTrial(false);
            return;
        }
        const fetchJSWActivationDateTrait = async ()=>{
            try {
                setIsReady(false);
                const siteTraits = await (0, $ccm3Y.memoizedFetchSitePersonalization)({
                    cloudId: cloudId
                });
                setIsDirectToStandardTrial($655b8f00fad935a4$var$isJSWDirectToTrial(siteTraits, trialEndTimeMs));
                setIsReady(true);
                fireServiceTrackEvent({
                    service: 'useDirectToStandardTrial'
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jptUseDirectToTrial failed', {
                    experiment: (0, $aP4j9.EXPERIMENT_NAME),
                    cohort: cohort,
                    error: error,
                    statusCode: error?.statusCode,
                    errorMessage: error?.message
                });
                // if the request fails we will assume they are direct to standard trial to be safe
                setIsDirectToStandardTrial(true);
                setIsReady(true);
            }
        };
        fetchJSWActivationDateTrait();
    }, [
        cloudId,
        trialEndTimeMs,
        createAnalyticsEvent,
        cohort,
        jswEdition,
        fireServiceTrackEvent
    ]);
    return {
        isReady: isReady,
        isDirectToStandardTrial: isDirectToStandardTrial
    };
};
const $655b8f00fad935a4$var$isJSWDirectToTrial = (traits, trialEndTimeMs)=>{
    const jswActivationDateTrait = traits.find((trait)=>trait.name === 'jira-software.ondemand.activationDate');
    if (!jswActivationDateTrait?.value) return false;
    if (typeof jswActivationDateTrait.value !== 'string') return false;
    const jswActivationDate = new Date(jswActivationDateTrait.value);
    const trialStartDate = new Date(trialEndTimeMs - 14 * (0, $aP4j9.ONE_DAY_IN_MS));
    // give 5 minute buffer in case of delay in system
    return trialStartDate.getTime() - jswActivationDate.getTime() < (0, $aP4j9.ONE_MINUTE_IN_MS) * 5;
};

});
parcelRegister("ccm3Y", function(module, exports) {

$parcel$export(module.exports, "memoizedFetchSitePersonalization", () => $23253fa24cdf456f$export$671fb03be30194c3);
$parcel$export(module.exports, "useSitePersonalization", () => $23253fa24cdf456f$export$58982988039b926f);

var $5iWql = parcelRequire("5iWql");

var $eEzyV = parcelRequire("eEzyV");

var $2OdyW = parcelRequire("2OdyW");
const $23253fa24cdf456f$var$getPersonalizationSiteTraitsUrl = (cloudId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
const $23253fa24cdf456f$export$ddf4964d2a406b6a = async ({ cloudId: cloudId })=>{
    if (!cloudId) throw new Error('empty cloudId');
    const { attributes: attributes } = await (0, $2OdyW.default)($23253fa24cdf456f$var$getPersonalizationSiteTraitsUrl(cloudId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    return attributes;
};
const $23253fa24cdf456f$export$671fb03be30194c3 = (0, $5iWql.default)($23253fa24cdf456f$export$ddf4964d2a406b6a, ([{ cloudId: newCloudId }], [{ cloudId: lastCloudId }])=>newCloudId === lastCloudId);
const $23253fa24cdf456f$export$58982988039b926f = ()=>(0, $eEzyV.useService)($23253fa24cdf456f$export$671fb03be30194c3);

});


parcelRegister("9NlnY", function(module, exports) {

$parcel$export(module.exports, "useGetResponseAndFireAnalytics", () => $dfe693653920a55d$export$18a21f5d59a2317b);

var $eUqFw = parcelRequire("eUqFw");

var $1Iui1 = parcelRequire("1Iui1");

var $79xbN = parcelRequire("79xbN");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6WXNs = parcelRequire("6WXNs");

var $aP4j9 = parcelRequire("aP4j9");

var $cQYZD = parcelRequire("cQYZD");
function $dfe693653920a55d$export$18a21f5d59a2317b({ isDoneFetchingPremiumTrialOnSignup: isDoneFetchingPremiumTrialOnSignup, isDoneFetchingDirectToStandardTrial: isDoneFetchingDirectToStandardTrial, shouldFireExposure: shouldFireExposure, jswEdition: jswEdition, jswEntitlement: jswEntitlement, premiumTrialOnSignup: premiumTrialOnSignup, isDirectToStandardTrial: isDirectToStandardTrial }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { fireOperationalExposureEvent: fireOperationalExposureEvent } = (0, $cQYZD.useOperationalExposureEvent)();
    return (0, $eUqFw.useMemo)(()=>{
        // eslint-disable-next-line jira/ff/unsafe-no-exposure
        const [expConfig, fireExposure] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_presentation_toolkit_experiment');
        const cohort = expConfig.get('cohort', (0, $1Iui1.NOT_ENROLLED));
        if (!isDoneFetchingPremiumTrialOnSignup || !isDoneFetchingDirectToStandardTrial) return {
            isEligible: false,
            isLoading: true,
            cohort: cohort
        };
        const trialEndTime = jswEntitlement?.trialEndTime;
        const isLastWeekOfTrial = $dfe693653920a55d$var$isInLastWeekOfTrial(trialEndTime);
        const isEligible = cohort !== (0, $1Iui1.NOT_ENROLLED) && (jswEdition === (0, $6WXNs.STANDARD_EDITION) || jswEdition === (0, $6WXNs.PREMIUM_EDITION)) && !!trialEndTime && isLastWeekOfTrial && !premiumTrialOnSignup && !isDirectToStandardTrial;
        let ineligibilityReason;
        if (cohort === (0, $1Iui1.NOT_ENROLLED)) ineligibilityReason = 'cloudIdNotEnrolled';
        else if (trialEndTime && !isLastWeekOfTrial) ineligibilityReason = 'beforeLastWeekOfTrial';
        else if (trialEndTime && premiumTrialOnSignup) ineligibilityReason = 'premiumReverseTrial';
        else if (isDirectToStandardTrial) ineligibilityReason = 'standardDirectToTrial';
        if (isEligible || ineligibilityReason) (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jptEligibility checked', {
            experiment: (0, $aP4j9.EXPERIMENT_NAME),
            cohort: cohort,
            isEligible: isEligible,
            ineligibilityReason: ineligibilityReason
        });
        if (isEligible && shouldFireExposure) {
            fireExposure();
            fireOperationalExposureEvent();
        }
        return {
            isEligible: isEligible,
            isLoading: false,
            cohort: cohort
        };
    }, [
        isDoneFetchingPremiumTrialOnSignup,
        isDoneFetchingDirectToStandardTrial,
        isDirectToStandardTrial,
        jswEdition,
        premiumTrialOnSignup,
        jswEntitlement,
        shouldFireExposure,
        createAnalyticsEvent,
        fireOperationalExposureEvent
    ]);
}
const $dfe693653920a55d$var$isInLastWeekOfTrial = (trialEndTime)=>{
    if (trialEndTime === undefined) return false;
    return trialEndTime - Date.now() <= 7 * (0, $aP4j9.ONE_DAY_IN_MS);
};

});


parcelRegister("5PlC8", function(module, exports) {

$parcel$export(module.exports, "useAutoOpenTimestampState", () => $412789bbf4960882$export$b6c7e678c035790);
$parcel$export(module.exports, "useAutoOpenTimestampActions", () => $412789bbf4960882$export$3f872bd921a19e7b);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $kEIBe = parcelRequire("kEIBe");

var $3JRjf = parcelRequire("3JRjf");


var $kMHp3 = parcelRequire("kMHp3");
const $412789bbf4960882$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'jsw-presentation-toolkit-auto-open',
    initialState: {
        hasBeenFourteenDays: (0, $kMHp3.getHasBeenFourteenDays)((0, $kEIBe.getLocalStorage)((0, $53b29702bfbea1b5$export$9f0292004eb8db3f)))
    },
    actions: $3JRjf.actions
});
const $412789bbf4960882$var$getAutoOpenTimestampStateSelector = (state)=>state;
const $412789bbf4960882$export$b6c7e678c035790 = (0, $ggKAj.createStateHook)($412789bbf4960882$export$6f57813fe9f31bf9, {
    selector: $412789bbf4960882$var$getAutoOpenTimestampStateSelector
});
const $412789bbf4960882$export$3f872bd921a19e7b = (0, $ggKAj.createActionsHook)($412789bbf4960882$export$6f57813fe9f31bf9);

});
parcelRegister("kEIBe", function(module, exports) {

$parcel$export(module.exports, "setLocalStorage", () => $56e6cc38bd7d0d1a$export$1f73f60bdb811cb1);
$parcel$export(module.exports, "getLocalStorage", () => $56e6cc38bd7d0d1a$export$d3720feff416e85b);

var $aZaPn = parcelRequire("aZaPn");
const $56e6cc38bd7d0d1a$var$localStorage = (0, $aZaPn.createLocalStorageProvider)('jira-presentation-toolkit');
function $56e6cc38bd7d0d1a$export$1f73f60bdb811cb1(key, value) {
    $56e6cc38bd7d0d1a$var$localStorage.set(key, value);
}
function $56e6cc38bd7d0d1a$export$d3720feff416e85b(key) {
    return $56e6cc38bd7d0d1a$var$localStorage.get(key);
}

});

parcelRegister("3JRjf", function(module, exports) {

$parcel$export(module.exports, "actions", () => $7bbf75ce465e1d12$export$e324594224ef24da);

var $kEIBe = parcelRequire("kEIBe");


var $kMHp3 = parcelRequire("kMHp3");
const $7bbf75ce465e1d12$var$updateAutoOpenTimestamp = ()=>async ({ setState: setState })=>{
        const timestamp = Date.now();
        setState({
            hasBeenFourteenDays: (0, $kMHp3.getHasBeenFourteenDays)(timestamp)
        });
        (0, $kEIBe.setLocalStorage)((0, $53b29702bfbea1b5$export$9f0292004eb8db3f), timestamp);
    };
const $7bbf75ce465e1d12$export$e324594224ef24da = {
    updateAutoOpenTimestamp: $7bbf75ce465e1d12$var$updateAutoOpenTimestamp
};

});
const $53b29702bfbea1b5$export$9f0292004eb8db3f = 'last-auto-open-timestamp';

parcelRegister("kMHp3", function(module, exports) {

$parcel$export(module.exports, "getHasBeenFourteenDays", () => $8be21c9847f9b49a$export$385f58d1aa7a17e9);

var $58PtH = parcelRequire("58PtH");
var $9FEvp = parcelRequire("9FEvp");
function $8be21c9847f9b49a$export$385f58d1aa7a17e9(timestamp) {
    return !(timestamp && (0, $58PtH.default)((0, $9FEvp.default)(new Date(), 14), timestamp));
}

});





parcelRegister("40ShE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca2fcd71c159ca9c$export$2e2bcd8739ae039);

var $1Iui1 = parcelRequire("1Iui1");

var $eI5EY = parcelRequire("eI5EY");

var $gVgw0 = parcelRequire("gVgw0");
function $ca2fcd71c159ca9c$export$2e2bcd8739ae039({ children: children }) {
    const cohort = (0, $gVgw0.useExperimentCohort)((0, $1Iui1.NOT_ENROLLED));
    const isPassedGate = (0, $eI5EY.fg)('jsw_presentation_toolkit_gate');
    if (cohort === (0, $1Iui1.NOT_ENROLLED) || !isPassedGate) return null;
    return children;
}

});

parcelRegister("6Wh45", function(module, exports) {

$parcel$export(module.exports, "BACKLOG_BUTTON_ID", () => $858a19ee7bfd26e6$export$8587b2c6e52de53f);

const $858a19ee7bfd26e6$export$8587b2c6e52de53f = `${(0, $3523ef16f82a4788$export$d3996f57ffa8448f)}.backlog-button`;

});

parcelRegister("9FSgN", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e87f03b8004a668$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7e87f03b8004a668$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    tooltip: {
        "id": "insights-backlog-button.tooltip",
        "defaultMessage": "Backlog insights"
    }
});

});


parcelRegister("4FzzQ", function(module, exports) {

$parcel$export(module.exports, "BacklogInsightsNudgeAsync", () => $57c91507a0a8ea85$export$bdccb7ceffac5743);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ewdMq = parcelRequire("ewdMq");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $57c91507a0a8ea85$var$BacklogInsightsNudgeLazy = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("8FEZX")).then((exportedModule)=>exportedModule.BacklogInsightsNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/scrum-onboarding-tour/backlog-insights/index.tsx"
});
const $57c91507a0a8ea85$export$bdccb7ceffac5743 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewdMq.OnboardingNudgeErrorBoundary), {
        id: (0, $99a775c02d636a41$export$65fb0c4e534f03fc),
        fallback: children,
        attributes: {
            nudgeId: (0, $99a775c02d636a41$export$1c7a80b00ad9619)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "software-onboarding-backlog-insights-nudge",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($57c91507a0a8ea85$var$BacklogInsightsNudgeLazy, null, children)));
$57c91507a0a8ea85$export$bdccb7ceffac5743.displayName = 'BacklogInsightsNudgeAsync';

});
parcelRegister("8FEZX", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('bK3fZ')
        ]);
        const value = parcelRequire('63PXy');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("bK3fZ")
    ]).then(()=>parcelRequire('63PXy'));
}

});



parcelRegister("2KUJD", function(module, exports) {

$parcel$export(module.exports, "ShareButton", () => $b8ff4585a5fd1c14$export$e980dfbc2840e8bc);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $huI7r = parcelRequire("huI7r");

var $fQ7Iw = parcelRequire("fQ7Iw");

var $iSNkS = parcelRequire("iSNkS");

var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");

var $4nprL = parcelRequire("4nprL");
const $b8ff4585a5fd1c14$export$e980dfbc2840e8bc = ({ shareContentType: shareContentType, onTriggerButtonClick: onTriggerButtonClick })=>{
    const cloudId = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getCloudId));
    const boardId = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getRapidViewId));
    const boardName = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getName));
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fQ7Iw.default), {
        productId: "jira",
        subProductId: "jira-software",
        shareContentType: shareContentType,
        integrationType: (0, $iSNkS.integrationTypes).BOARD,
        shareTitle: boardName,
        shareFormTitle: formatMessage((0, $4nprL.default).shareFormTitle),
        objectAri: (0, $huI7r.createAri)({
            resourceOwner: 'jira-software',
            cloudId: cloudId,
            resourceType: 'board',
            resourceId: boardId
        }),
        onTriggerButtonClick: onTriggerButtonClick,
        shareFormHelperMessage: formatMessage((0, $4nprL.default).shareHelperMessage)
    });
};

});
parcelRegister("fQ7Iw", function(module, exports) {

$parcel$export(module.exports, "ShareLoadingPlaceholder", () => $eb292e1f91805d5c$export$5619d05bf511476b);
$parcel$export(module.exports, "default", () => $eb292e1f91805d5c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7rh0R = parcelRequire("7rh0R");

var $7u4fN = parcelRequire("7u4fN");

var $dFWNP = parcelRequire("dFWNP");

var $PdmhA = parcelRequire("PdmhA");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGtKh = parcelRequire("gGtKh");

var $8nUKh = parcelRequire("8nUKh");

const $eb292e1f91805d5c$export$5619d05bf511476b = ({ triggerButtonStyle: triggerButtonStyle = 'icon-only' })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dFWNP))), {
            size: "medium",
            label: formatMessage((0, $8nUKh.messages).shareTriggerButtonText),
            primaryColor: `var(--ds-icon, ${(0, $PdmhA).N30})`
        }),
        isDisabled: true
    }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, $8nUKh.messages).shareTriggerButtonText) : null));
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $eb292e1f91805d5c$var$ShareButton = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("jdZ2L")), {
    ssr: false,
    moduleId: "./src/packages/growth/share-button/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$eb292e1f91805d5c$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.share.button",
        packageName: "share-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "share-button",
        fallback: props.renderCustomTriggerButton === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb292e1f91805d5c$export$5619d05bf511476b, {
            triggerButtonStyle: props.triggerButtonStyle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(props.renderCustomTriggerButton, {
            isDisabled: true,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb292e1f91805d5c$var$ShareButton, props)));

});
parcelRegister("dFWNP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9f4cb7ac67043f68$var$_react = $9f4cb7ac67043f68$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $9f4cb7ac67043f68$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9f4cb7ac67043f68$var$ShareIcon = (props)=>/*#__PURE__*/ $9f4cb7ac67043f68$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M6 15a3 3 0 100-6 3 3 0 000 6zm0-2a1 1 0 110-2 1 1 0 010 2zm12-4a3 3 0 100-6 3 3 0 000 6zm0-2a1 1 0 110-2 1 1 0 010 2zm0 14a3 3 0 100-6 3 3 0 000 6zm0-2a1 1 0 110-2 1 1 0 010 2z" fill-rule="nonzero"/><path d="M7 13.562l8.66 5 1-1.732-8.66-5z"/><path d="M7 10.83l1 1.732 8.66-5-1-1.732z"/></g></svg>`
    }, props));
$9f4cb7ac67043f68$var$ShareIcon.displayName = 'ShareIcon';
var $9f4cb7ac67043f68$var$_default = $9f4cb7ac67043f68$var$ShareIcon;
module.exports.default = $9f4cb7ac67043f68$var$_default;

});

parcelRegister("8nUKh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c445af617ae0da86$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $c445af617ae0da86$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    shareTriggerButtonText: {
        "id": "share-button.share-trigger-button-text",
        "defaultMessage": "Share"
    }
});

});

parcelRegister("jdZ2L", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('2hmUs'),
            load('bCeK4'),
            load('dsiAd'),
            load('h2MrD'),
            load('bYT2S'),
            load('2xQrm')
        ]);
        const value = parcelRequire('iHQJU');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("2hmUs"),
        load("bCeK4"),
        load("dsiAd"),
        load("h2MrD"),
        load("bYT2S"),
        load("2xQrm")
    ]).then(()=>parcelRequire('iHQJU'));
}

});


parcelRegister("iSNkS", function(module, exports) {

$parcel$export(module.exports, "integrationTypes", () => $60586429dc17d610$export$a7359bcfb0ca8e98);
const $60586429dc17d610$export$a7359bcfb0ca8e98 = {
    BENTO_ISSUE: 'bentoIssue',
    CLASSIC_BOARD: 'classicBoard',
    NEXTGEN_BOARD: 'nextGenBoard',
    ROADMAP: 'roadmap',
    TIMELINE: 'timeline',
    LIST: 'list',
    CALENDAR: 'calendar',
    BOARD: 'board',
    FORM: 'form',
    SUMMARY: 'summary',
    ATTACHMENTS: 'attachments'
};

});

parcelRegister("4nprL", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ebeafa2bf8296f2$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2ebeafa2bf8296f2$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    shareFormTitle: {
        "id": "backlog.header.actions-bar.share-button.share-form-title",
        "defaultMessage": "Share"
    },
    shareHelperMessage: {
        "id": "backlog.header.actions-bar.share-button.share-helper-message",
        "defaultMessage": "This view, along with any applied groups and filters are shared"
    }
});

});


parcelRegister("k4jYJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c0dd52b76e27456$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $a9os4 = parcelRequire("a9os4");

var $hkGxG = parcelRequire("hkGxG");

var $8ZI73 = parcelRequire("8ZI73");

var $dtV8v = parcelRequire("dtV8v");

var $ai2KE = parcelRequire("ai2KE");

var $frOMS = parcelRequire("frOMS");
var $8c0dd52b76e27456$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state)=>({
        rapidViewId: Number((0, $hkGxG.getRapidViewId)(state)),
        isBacklogWithSprints: (0, $dtV8v.isBacklogWithSprints)(state),
        isClassic: (0, $hkGxG.getIsCompanyManaged)(state),
        showEpicAsPanel: (0, $8ZI73.getShowEpicAsPanel)(state),
        isVersionsEnabled: (0, $ai2KE.isVersionsFeatureEnabled)(state)
    }), {
    onTogglePanel: (0, $a9os4.togglePanel)
})((0, $frOMS.BacklogViewSettings));

});
parcelRegister("frOMS", function(module, exports) {

$parcel$export(module.exports, "BacklogViewSettings", () => $bff7336ee91ec9a5$export$c0bf3e52465abf3b);

var $eUqFw = parcelRequire("eUqFw");

var $8blac = parcelRequire("8blac");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $c3qrZ = parcelRequire("c3qrZ");
var $27GCD = parcelRequire("27GCD");

var $aDfcw = parcelRequire("aDfcw");


var $1gQ73 = parcelRequire("1gQ73");

var $7TN4i = parcelRequire("7TN4i");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $8ZI73 = parcelRequire("8ZI73");

var $lMwdE = parcelRequire("lMwdE");

var $i0G2M = parcelRequire("i0G2M");
const $bff7336ee91ec9a5$export$a893c931e3adac79 = ()=>{
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_additional_card_fields_in_view_settings');
    return (0, $1ybV0.ff)('jsw.perf.additional-card-fields-in-view-settings') && expConfig.get('cohort', 'not-enrolled') === 'variation';
};
const $bff7336ee91ec9a5$export$c0bf3e52465abf3b = (props)=>{
    const { rapidViewId: rapidViewId, isClassic: isClassic, showEpicAsPanel: showEpicAsPanel, isVersionsEnabled: isVersionsEnabled, onTogglePanel: onTogglePanel } = props;
    const isCompanyManaged = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getIsCompanyManaged));
    const config = (0, $1gQ73.useBacklogSelector)((0, $8ZI73.getConfig));
    const epicCustomName = config.hierarchyNomenclature?.firstLevelName;
    const allCardGroups = (0, $lMwdE.useAllCardGroups)();
    const isDataLoaded = (0, $1gQ73.useBacklogSelector)((0, $8ZI73.isCriticalDataLoaded));
    const cardExtraFields = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getCardExtraFields));
    const hasCardsWithPriority = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.backlogHasPriority));
    const isDueDateEnabled = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.backlogHasDueDate));
    const hasCardsWithStoryPoint = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.backlogHasStoryPoints));
    const hasCardsWithEstimate = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.backlogHasEstimates));
    const isViewSettingPanelOpen = (0, $i0G2M.useIsViewSettingsPanelOpen)();
    const showFilterBarToggle = isCompanyManaged;
    const areAllSubtasksExpanded = (0, $eUqFw.useMemo)(()=>allCardGroups.every((card)=>!card.isCollapsed), [
        allCardGroups
    ]);
    const areAllSubtasksCollapsed = (0, $eUqFw.useMemo)(()=>allCardGroups.every((card)=>card.isCollapsed), [
        allCardGroups
    ]);
    const handleExpandSubtasks = (0, $eUqFw.useCallback)(()=>{
        (0, $7TN4i.setExpandedCardGroups)(allCardGroups.map((card)=>card.parentId.toString()));
    }, [
        allCardGroups
    ]);
    const handleCollapseSubtasks = (0, $eUqFw.useCallback)(()=>{
        (0, $7TN4i.collapseAllCardGroups)();
    }, []);
    const handleViewSettingPanelToggle = (0, $eUqFw.useCallback)(()=>{
        onTogglePanel((0, $d36e2c37d06c83ff$export$ba1da943283b9900));
    }, [
        onTogglePanel
    ]);
    const shouldShowSubtasks = (0, $eUqFw.useMemo)(()=>!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(allCardGroups), [
        allCardGroups
    ]);
    return $bff7336ee91ec9a5$export$a893c931e3adac79() ? isDataLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27GCD.ViewSettingsSyncFromLocalStorageWrapper), {
        boardId: rapidViewId,
        view: (0, $c3qrZ.View).BACKLOG,
        cardExtraFields: cardExtraFields,
        isVersionsEnabled: isVersionsEnabled,
        isEstimateEnabled: hasCardsWithStoryPoint || hasCardsWithEstimate,
        showEpicAsPanel: showEpicAsPanel,
        isDueDateEnabled: !isCompanyManaged && isDueDateEnabled,
        isPriorityEnabled: hasCardsWithPriority
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27GCD.ViewSettingsButton), {
        isSelected: isViewSettingPanelOpen,
        onClick: handleViewSettingPanelToggle
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aDfcw.default), {
        view: (0, $c3qrZ.View).BACKLOG,
        boardId: rapidViewId,
        isClassic: isClassic,
        areSubtasksEnabled: isCompanyManaged && shouldShowSubtasks,
        onSubtasksExpandAll: handleExpandSubtasks,
        onSubtasksCollapseAll: handleCollapseSubtasks,
        areAllSubtasksExpanded: areAllSubtasksExpanded,
        areAllSubtasksCollapsed: areAllSubtasksCollapsed,
        showEpicAsPanel: showEpicAsPanel,
        epicCustomName: epicCustomName,
        isVersionsEnabled: isVersionsEnabled,
        showFilterBarToggle: showFilterBarToggle
    });
};

});



parcelRegister("LiGHk", function(module, exports) {

$parcel$export(module.exports, "default", () => $a206dc5b3c08824b$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $7TN4i = parcelRequire("7TN4i");

var $a9os4 = parcelRequire("a9os4");

var $hkGxG = parcelRequire("hkGxG");

var $8ZI73 = parcelRequire("8ZI73");

var $dtV8v = parcelRequire("dtV8v");

var $ai2KE = parcelRequire("ai2KE");

var $4hiYU = parcelRequire("4hiYU");

var $kVhX4 = parcelRequire("kVhX4");

var $7FLNi = parcelRequire("7FLNi");
var $a206dc5b3c08824b$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state)=>({
        rapidViewId: Number((0, $hkGxG.getRapidViewId)(state)),
        isBacklogWithSprints: (0, $dtV8v.isBacklogWithSprints)(state),
        FilterBar: $kVhX4.default,
        Operations: $4hiYU.default,
        isClassic: (0, $hkGxG.getIsCompanyManaged)(state),
        showEpicAsPanel: (0, $8ZI73.getShowEpicAsPanel)(state),
        isVersionsEnabled: (0, $ai2KE.isVersionsFeatureEnabled)(state)
    }), {
    onTogglePanel: (0, $a9os4.togglePanel),
    onSubtasksExpandAll: (0, $7TN4i.setExpandedCardGroups),
    onSubtasksCollapseAll: (0, $7TN4i.collapseAllCardGroups)
})((0, $7FLNi.ControlsBar));

});
parcelRegister("kVhX4", function(module, exports) {

$parcel$export(module.exports, "default", () => $2378e106b0745957$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $c8Guq = parcelRequire("c8Guq");

var $5iWql = parcelRequire("5iWql");

var $511uv = parcelRequire("511uv");

var $79xbN = parcelRequire("79xbN");

var $lNNXV = parcelRequire("lNNXV");

var $kJlBc = parcelRequire("kJlBc");

var $hfC0x = parcelRequire("hfC0x");



var $ee93g = parcelRequire("ee93g");

var $fB0vk = parcelRequire("fB0vk");

var $5awap = parcelRequire("5awap");

var $a9os4 = parcelRequire("a9os4");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $8ZI73 = parcelRequire("8ZI73");

var $kdGmo = parcelRequire("kdGmo");

var $22cnO = parcelRequire("22cnO");

var $k734R = parcelRequire("k734R");

var $lCKiB = parcelRequire("lCKiB");

var $cYLrD = parcelRequire("cYLrD");

var $7kNqR = parcelRequire("7kNqR");

var $ai2KE = parcelRequire("ai2KE");

var $j258X = parcelRequire("j258X");

var $bLpDY = parcelRequire("bLpDY");

var $1kPIv = parcelRequire("1kPIv");
const $2378e106b0745957$export$148c63f5480aef70 = (state)=>(0, $hkGxG.getIsCompanyManaged)(state) ? true // we always want to show the link so user can see read-only board settings page even with no edit board permission
     : (0, $7kNqR.canEditBoardConfig)(state);
const $2378e106b0745957$var$isTMPBoardAddPeopleExperimentEnabled = (state)=>{
    const canInviteOthersToProject = (0, $8ZI73.getCanInviteOthersToProject)(state);
    return canInviteOthersToProject && (0, $79xbN.expValEquals)('open_invite_for_open_tmp_projects', 'cohort', 'experiment');
};
const $2378e106b0745957$export$c31df4bd766f9c35 = (state)=>{
    const isCompanyManaged = (0, $hkGxG.getIsCompanyManaged)(state);
    return {
        assignees: (0, $bP7Jx.getOrderedAssignees)(state),
        filter: (0, $kdGmo.getFilters)(state),
        panels: (0, $cYLrD.getPanels)(state),
        labels: (0, $bP7Jx.getOrderedLabels)(state),
        issueTypes: (0, $bP7Jx.getOrderedCardTypes)(state),
        maxAvatars: (0, $6b2c0bb2f15ce467$export$360e7ca29749d455),
        isAddPeopleButtonEnabled: isCompanyManaged ? (0, $7kNqR.canEditBoardConfig)(state) // Existing permission check for CMP
         : (0, $7kNqR.canEditBoardConfig)(state) || $2378e106b0745957$var$isTMPBoardAddPeopleExperimentEnabled(state),
        isCustomFilterManageLinkEnabled: $2378e106b0745957$export$148c63f5480aef70(state),
        isVersionFilterSpotlightEnabled: (0, $7kNqR.canEditBoardConfig)(state),
        issueParentsLabel: isCompanyManaged ? (0, $22cnO.getFirstLevelHierarchyName)(state) || (0, $k734R.firstParentIssueTypeNameSelector)(state) : (0, $k734R.firstParentIssueTypeNameSelector)(state),
        issueParents: (0, $k734R.issueParentsToListItemSelector)(state),
        isAnyModalOpen: (0, $lCKiB.isAnyModalOpen)(state),
        boardId: Number((0, $hkGxG.getRapidViewId)(state)),
        isVersionsFeatureEnabled: (0, $ai2KE.isVersionsFeatureEnabled)(state),
        projectId: (0, $hkGxG.projectIdSelector)(state),
        projectName: (0, $hkGxG.getProjectName)(state),
        projectKey: (0, $hkGxG.getProjectKey)(state),
        cardIds: (0, $bP7Jx.getCardIds)(state),
        isCustomFiltersLoading: (0, $bP7Jx.isFilteredCardsLoading)(state),
        isEpicPanelOpen: (0, $ee93g.isIssueParentPanelOpen)(),
        isVersionPanelOpen: (0, $ee93g.isVersionPanelOpen)(),
        isCompanyManaged: isCompanyManaged
    };
};
const $2378e106b0745957$var$mapDispatchToProps = (dispatch)=>({
        dispatch: dispatch
    });
const $2378e106b0745957$var$getOnChange = (0, $5iWql.default)((issueIds, dispatch, syncFiltersWithRemoteStore)=>(filters, filterType, _, analyticsEvent)=>{
        if (filterType === (0, $6b2c0bb2f15ce467$export$68d693c35a8d8866)) // @ts-expect-error Argument of type 'UIAnalyticsEvent | undefined' is not assignable to parameter of type 'UIAnalyticsEvent'.
        dispatch((0, $5awap.filteredCardsRequest)(issueIds, analyticsEvent, filters[0, $6b2c0bb2f15ce467$export$68d693c35a8d8866]));
        else (0, $511uv.getLongTasksMetrics)('filter').start('backlog');
        syncFiltersWithRemoteStore(filters);
        if (filterType !== (0, $6b2c0bb2f15ce467$export$68d693c35a8d8866)) dispatch((0, $fB0vk.cardAutoScrollRequestOnFilter)());
    });
const $2378e106b0745957$var$getClearAllFilters = (0, $5iWql.default)((dispatch, isCompanyManaged)=>(event, analyticsEvent)=>{
        isCompanyManaged ? dispatch((0, $5awap.clearFilteredCardsRequest)(analyticsEvent)) : dispatch((0, $5awap.clearFilteredCards)());
        dispatch((0, $fB0vk.cardAutoScrollRequestOnFilter)());
    });
const $2378e106b0745957$var$getOnToggleParentPanel = (0, $5iWql.default)((dispatch)=>()=>{
        dispatch((0, $a9os4.togglePanel)((0, $d36e2c37d06c83ff$export$a10c132b86ae798b)));
    });
const $2378e106b0745957$var$getOnToggleVersionsPanel = (0, $5iWql.default)((dispatch)=>()=>{
        dispatch((0, $a9os4.togglePanel)((0, $d36e2c37d06c83ff$export$41073ac826c57195)));
    });
const $2378e106b0745957$export$9d1611c77c2fe928 = (stateProps, dispatchProps, ownProps)=>{
    const { assignees: assignees, filter: filter, panels: panels, labels: labels, maxAvatars: maxAvatars, isAddPeopleButtonEnabled: isAddPeopleButtonEnabled, isCustomFilterManageLinkEnabled: isCustomFilterManageLinkEnabled, isVersionFilterSpotlightEnabled: isVersionFilterSpotlightEnabled, issueParentsLabel: issueParentsLabel, issueParents: issueParents, issueTypes: issueTypes, boardId: boardId, isVersionsFeatureEnabled: isVersionsFeatureEnabled, projectId: projectId, projectName: projectName, projectKey: projectKey, cardIds: cardIds, isCustomFiltersLoading: isCustomFiltersLoading, isVersionPanelOpen: isVersionsOpen, isEpicPanelOpen: isEpicPanelOpen, isCompanyManaged: isCompanyManaged } = stateProps;
    const { dispatch: dispatch } = dispatchProps;
    const { customFiltersQueryRef: customFiltersQueryRef, versionFilterRelayQueryRef: versionFilterRelayQueryRef } = ownProps;
    return {
        assignees: assignees,
        filter: filter,
        panels: panels,
        labels: labels,
        maxAvatars: maxAvatars,
        isAddPeopleButtonEnabled: isAddPeopleButtonEnabled,
        isCustomFilterManageLinkEnabled: isCustomFilterManageLinkEnabled,
        isVersionFilterSpotlightEnabled: isVersionFilterSpotlightEnabled,
        issueParentsLabel: issueParentsLabel,
        issueParents: issueParents,
        issueTypes: issueTypes,
        AddPeopleModal: $bLpDY.default,
        boardId: boardId,
        isVersionsFeatureEnabled: isVersionsFeatureEnabled,
        isCustomFiltersLoading: isCustomFiltersLoading,
        projectId: projectId,
        projectName: projectName,
        projectKey: projectKey,
        onChange: $2378e106b0745957$var$getOnChange(cardIds, dispatch, ownProps.syncFiltersWithRemoteStore),
        onToggleParentPanel: $2378e106b0745957$var$getOnToggleParentPanel(dispatch),
        isIssueParentPanelToggleChecked: isEpicPanelOpen,
        onToggleVersionsPanel: $2378e106b0745957$var$getOnToggleVersionsPanel(dispatch),
        isVersionPanelToggleChecked: isVersionsOpen,
        onClearAllButtonClicked: $2378e106b0745957$var$getClearAllFilters(dispatch, isCompanyManaged),
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef,
        isCompanyManaged: isCompanyManaged
    };
};
const $2378e106b0745957$var$connector = (0, $lNNXV.connect)($2378e106b0745957$export$c31df4bd766f9c35, $2378e106b0745957$var$mapDispatchToProps, $2378e106b0745957$export$9d1611c77c2fe928);
// @ts-expect-error - TS2345 - Argument of type 'ComponentType<WithIntlProps<APIProps & { intl: IntlShapeV2; customFiltersQueryRef?: PreloadedQuery<viewBacklogCustomFiltersQuery, Record<string, unknown>> | null | undefined; versionFilterRelayQueryRef?: PreloadedQuery<...> | ... 1 more ... | undefined; }>>' is not assignable to parameter of type 'Component<{ assignees: Person[]; filter: Filters; panels: PanelState; labels: string[]; maxAvatars: number; isAddPeopleButtonEnabled: boolean; isCustomFilterManageLinkEnabled: boolean; ... 16 more ...; versionFilterRelayQueryRef: PreloadedQuery<...> | ... 1 more ... | undefined; }>'.
const $2378e106b0745957$var$ConnectedFilterBar = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))($2378e106b0745957$var$connector, (0, $kJlBc.withRouter))((0, $1kPIv.default));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2378e106b0745957$export$2e2bcd8739ae039 = ({ customFiltersQueryRef: customFiltersQueryRef, versionFilterRelayQueryRef: versionFilterRelayQueryRef })=>{
    const [filters, { setFilters: setFilters }] = (0, $hfC0x.useFilters)();
    const isCompanyManaged = (0, $j258X.useIsCMPBacklog)();
    // Temporary remove custom filters from the url on initial load for team-managed backlog.
    // Need to be removed when applying custom filters on initial load.
    const self = (0, $eUqFw.useRef)({
        isMounted: false
    }).current;
    (0, $eUqFw.useEffect)(()=>{
        if (!self.isMounted) {
            if (isCompanyManaged) setFilters(filters);
            else {
                const { [(0, $6b2c0bb2f15ce467$export$68d693c35a8d8866)]: customFilters, ...otherFilters } = filters;
                setFilters(otherFilters);
            }
        }
        self.isMounted = true;
    }, [
        self,
        filters,
        setFilters,
        isCompanyManaged
    ]);
    return(// @ts-expect-error - TS2739 - Type '{ syncFiltersWithRemoteStore: (filters: Filters) => void | Promise<void>; customFiltersQueryRef: PreloadedQuery<viewBacklogCustomFiltersQuery, Record<...>> | null | undefined; versionFilterRelayQueryRef: PreloadedQuery<...> | ... 1 more ... | undefined; }' is missing the following properties from type 'RouteContext': location, query, route, match, action.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2378e106b0745957$var$ConnectedFilterBar, {
        syncFiltersWithRemoteStore: setFilters,
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef
    }));
};

});
parcelRegister("lCKiB", function(module, exports) {

$parcel$export(module.exports, "getOpenModalData", () => $74583242b8ee557d$export$580d73f81f464028);
$parcel$export(module.exports, "makeIsModalOpen", () => $74583242b8ee557d$export$95fc19f697e2a886);
$parcel$export(module.exports, "isAnyModalOpen", () => $74583242b8ee557d$export$5160f01afdf30a59);

var $df4Sl = parcelRequire("df4Sl");
const $74583242b8ee557d$export$580d73f81f464028 = (state)=>state.ui.modals;
const $74583242b8ee557d$export$95fc19f697e2a886 = (0, $df4Sl.createSelector)([
    $74583242b8ee557d$export$580d73f81f464028
], (modalData)=>{
    const isModalOpen = (modalType)=>modalData !== null && modalData.type === modalType;
    return isModalOpen;
});
const $74583242b8ee557d$export$5160f01afdf30a59 = (0, $df4Sl.createSelector)([
    $74583242b8ee557d$export$580d73f81f464028
], (modalData)=>modalData !== null);

});

parcelRegister("bLpDY", function(module, exports) {

$parcel$export(module.exports, "default", () => $24d3467f4a705800$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7rh0R = parcelRequire("7rh0R");

var $7ZZxN = parcelRequire("7ZZxN");

var $3JuZY = parcelRequire("3JuZY");

var $lNNXV = parcelRequire("lNNXV");


var $hkGxG = parcelRequire("hkGxG");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $24d3467f4a705800$var$AddPeopleModal = (0, $7rh0R.lazy)(()=>(parcelRequire("5zF4d")), {
    moduleId: "./src/packages/permissions-administration/components/project-add-people/src/index.tsx"
});
const $24d3467f4a705800$var$Modal = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3JuZY.AddPeopleModalBoundary), {
        packageName: (0, $e1409a6fc345c0d8$export$dfd208682d29484c)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.LazyWait), {
        until: props.isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($24d3467f4a705800$var$AddPeopleModal, props)));
var $24d3467f4a705800$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state, ownProps)=>({
        projectId: (0, $hkGxG.projectIdSelector)(state),
        projectKey: (0, $hkGxG.getProjectKey)(state),
        baseUrl: (0, $hkGxG.getBaseUrl)(state),
        isOpen: ownProps.isOpen,
        onClose: ownProps.onClose || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onError: ownProps.onError || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onAddSuccess: ownProps.onAddSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onStopPerfMetric: ownProps.onStopPerfMetric || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        projectType: (0, $7ZZxN.SOFTWARE_PROJECT),
        isAdmin: true,
        analyticsPrefix: 'software.backlog',
        allowFlags: true
    }), {})($24d3467f4a705800$var$Modal);

});
parcelRegister("3JuZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $0622cdc3f1c5195e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "AddPeopleModalBoundary", () => $0622cdc3f1c5195e$export$374b95de0cd72a02);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $h97Af = parcelRequire("h97Af");

var $0cdA8 = parcelRequire("0cdA8");

var $cyVXS = parcelRequire("cyVXS");

var $gGtKh = parcelRequire("gGtKh");


const $0622cdc3f1c5195e$var$LazyComponent = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("5zF4d")), {
    moduleId: "./src/packages/permissions-administration/components/project-add-people/src/index.tsx"
});
const $0622cdc3f1c5195e$export$c4cbbeec160c9988 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-project-add-people-dialog",
        packageName: "project-add-people"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "project-add-people-dialog",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: (0, $c53566c3ac758a18$export$b68a44ad9e8d6ce)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0622cdc3f1c5195e$var$LazyComponent, props)));
var $0622cdc3f1c5195e$export$2e2bcd8739ae039 = $0622cdc3f1c5195e$export$c4cbbeec160c9988;
const $0622cdc3f1c5195e$export$374b95de0cd72a02 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cyVXS.ModalBoundary), {
        id: "add-people-modal",
        metricKey: (0, $c53566c3ac758a18$export$b68a44ad9e8d6ce),
        ...props
    }, children);

});
const $c53566c3ac758a18$export$8fcd8ea7ed6539b1 = 'project-settings-apps.add-people-dialog';
const $c53566c3ac758a18$export$b68a44ad9e8d6ce = 'ADD_PEOPLE_LOAD_START_MARK_KEY';
const $c53566c3ac758a18$export$656613627a47a509 = 'ADD_PEOPLE_LOAD_END_MARK_KEY';
const $c53566c3ac758a18$export$61762786d0849c64 = 'ADD_PEOPLE_READY_MARK_KEY';

parcelRegister("5zF4d", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('6HI0g')
        ]);
        const value = parcelRequire('4urEy');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("6HI0g")
    ]).then(()=>parcelRequire('4urEy'));
}

});



parcelRegister("1kPIv", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d396c2b651c1672$export$2e2bcd8739ae039);

var $jZqFH = parcelRequire("jZqFH");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $lWcOi = parcelRequire("lWcOi");

var $ebjBV = parcelRequire("ebjBV");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $87usC = parcelRequire("87usC");
var $2fa4K = parcelRequire("2fa4K");

var $9eH8H = parcelRequire("9eH8H");

var $7TyGu = parcelRequire("7TyGu");

var $cm2SB = parcelRequire("cm2SB");

var $5yMWP = parcelRequire("5yMWP");

var $gGjjj = parcelRequire("gGjjj");

var $1rVrE = parcelRequire("1rVrE");

var $1gQ73 = parcelRequire("1gQ73");

var $6iBIZ = parcelRequire("6iBIZ");

var $hkGxG = parcelRequire("hkGxG");

var $8ZI73 = parcelRequire("8ZI73");

var $j258X = parcelRequire("j258X");

var $3GERZ = parcelRequire("3GERZ");

var $iFRbv = parcelRequire("iFRbv");

var $75UOO = parcelRequire("75UOO");
const $4d396c2b651c1672$export$1ac8be34f814ec5b = ({ versionFilterRelayQueryRef: versionFilterRelayQueryRef, ...props })=>{
    const { entryPointActions: entryPointActions } = (0, $eUqFw.useContext)((0, $1rVrE.VersionPanelEntrypointContext));
    const triggerRef = (0, $ebjBV.useEntryPointToggleTrigger)(entryPointActions);
    const data = (0, $iWLL0.usePreloadedQuery)((0, $jZqFH.default), versionFilterRelayQueryRef);
    const versionFilterRelayFragmentRef = (0, $eUqFw.useMemo)(()=>data.jira.versionsForProjects.edges.filter(Boolean), [
        data
    ]);
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    (0, $eUqFw.useEffect)(()=>{
        dispatch({
            type: (0, $6iBIZ.SET_VERSIONS),
            payload: {
                versions: versionFilterRelayFragmentRef.map((edge)=>edge.node?.versionId).filter(Boolean)
            }
        });
    }, [
        dispatch,
        versionFilterRelayFragmentRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2fa4K.VersionFilterRelay), {
        versionFilterRelayFragmentRef: versionFilterRelayFragmentRef,
        toggleRef: triggerRef,
        ...props
    });
};
const $4d396c2b651c1672$var$isShowParentIssueFilter = (isCMPBacklog, isCMPScrum, showEpicPanelToggle, isIssueParents, isParentIssueTypeValid)=>{
    let showParentIssueFilter;
    if (isCMPBacklog) {
        if (isCMPScrum) // CMP Scrum backlog
        showParentIssueFilter = true;
        else // CMP Kanban backlog
        showParentIssueFilter = showEpicPanelToggle || isIssueParents;
    } else // TMP backlog
    showParentIssueFilter = isParentIssueTypeValid;
    return showParentIssueFilter;
};
const $4d396c2b651c1672$export$7a40f967ca91c4d3 = ({ customFiltersQueryRef: customFiltersQueryRef, versionFilterRelayQueryRef: versionFilterRelayQueryRef, issueTypes: issueTypes, ...props })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    let parents = (0, $eUqFw.useMemo)(()=>[], []);
    let issueParentsTypeName = '';
    let isParentIssueTypeAvailable = false;
    if ((0, $eI5EY.fg)('jsw_epic_panel_paginated_fetch')) {
        const [{ cards: parentsNew, epicIssueTypeName: issueParentsTypeNameNew, isEpicIssueTypeAvailable: isParentIssueTypeAvailableNew }] = (0, $lWcOi.useEpicsFilterData)();
        parents = parentsNew;
        issueParentsTypeName = issueParentsTypeNameNew;
        isParentIssueTypeAvailable = isParentIssueTypeAvailableNew;
    } else {
        const { parents: parentsOld, issueParentsTypeName: issueParentsTypeNameOld, isParentIssueTypeAvailable: isParentIssueTypeAvailableOld } = (0, $gGjjj.useGetEpicsAndProject)(props.boardId, true);
        parents = parentsOld;
        issueParentsTypeName = issueParentsTypeNameOld;
        isParentIssueTypeAvailable = isParentIssueTypeAvailableOld;
    }
    const { issueParentsLabel: issueParentsLabel } = props;
    const issueParents = (0, $eUqFw.useMemo)(()=>{
        const target = issueParentsLabel && issueParentsLabel !== (0, $7TyGu.DEFAULT_PARENT_ISSUE_TYPE_NAME) ? issueParentsLabel : (0, $7TyGu.DEFAULT_PARENT_ISSUE_TYPE_NAME).toLowerCase();
        const partialParents = parents.map((parent)=>{
            if ('epic' in parent) return {
                id: String(parent.epic.id),
                key: parent.epic.key,
                name: parent.epic.name
            };
            return {
                id: parent.id,
                key: parent.key,
                name: parent.summary
            };
        });
        return partialParents && partialParents.length ? [
            {
                id: String((0, $9eH8H.UNASSIGNED_EPIC_ID)),
                name: formatMessage((0, $iFRbv.default).unassigned, {
                    target: target
                })
            },
            ...partialParents
        ] : partialParents;
    }, [
        formatMessage,
        issueParentsLabel,
        parents
    ]);
    const isCMPBacklog = (0, $j258X.useIsCMPBacklog)();
    const isCMPScrum = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.isCMPScrumBacklog));
    const showEpicPanelToggle = (0, $1gQ73.useBacklogSelector)((0, $8ZI73.getShowEpicAsPanel));
    const hasMultipleProjects = (0, $1gQ73.useBacklogSelector)((state)=>(0, $hkGxG.getProjects)(state).length > 1);
    const showParentIssueFilter = $4d396c2b651c1672$var$isShowParentIssueFilter(isCMPBacklog, isCMPScrum, showEpicPanelToggle, issueParents.length > 0, isParentIssueTypeAvailable);
    const versionFilterProps = {
        VersionFilterRelay: $4d396c2b651c1672$export$1ac8be34f814ec5b,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef,
        isVersionFilterRelayEnabled: true
    };
    const panelToggleVisibility = {
        showEpicPanelToggle: isCMPBacklog ? showEpicPanelToggle : true,
        showVersionsPanelToggle: true
    };
    const issueTypesToDisplay = (0, $75UOO.useIssueTypes)(issueTypes);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $87usC.default), {
        ...props,
        issueTypes: issueTypesToDisplay,
        issueParents: issueParents,
        issueParentsLabel: issueParentsTypeName,
        showPanelToggle: undefined,
        panelToggleVisibility: panelToggleVisibility,
        showParentIssueMenuIfValuesAreEmpty: showParentIssueFilter,
        showSearchFilterChangeboarding: true,
        hijackBrowserDefaultSearch: !isCMPBacklog,
        screenName: "backlog",
        onChangeInteractionFeedback: (0, $5yMWP.setInteractionFeedbackMark),
        onChangeInteractionStart: (0, $5yMWP.setInteractionStartMark),
        onCustomFilterChangeInteractionFeedback: (0, $cm2SB.setCustomFilterInteractionFeedbackMark),
        onCustomFilterChangeInteractionStart: (0, $cm2SB.setCustomFilterInteractionStartMark),
        showCustomFilters: isCMPBacklog,
        customFiltersQueryRef: customFiltersQueryRef,
        // @ts-expect-error - TS2345 - Type 'CustomFiltersQueryRef | undefined' is not assignable to type 'PreloadedQuery<viewBacklogCustomFiltersQuery, Record<string, unknown>>'.
        CustomFilter: (0, $3GERZ.BacklogCustomFilter),
        placeholder: formatMessage((0, $iFRbv.default).textFilter),
        isUnassignedAssigneeOptionEnabled: true,
        isUnassignedVersionOptionEnabled: isCMPBacklog,
        onClearCustomFilterInteractionStart: (0, $cm2SB.setClearCustomFilterInteractionStartMark),
        hasMultipleProjects: hasMultipleProjects,
        ...versionFilterProps
    });
};
var $4d396c2b651c1672$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($4d396c2b651c1672$export$7a40f967ca91c4d3);

});
parcelRegister("ebjBV", function(module, exports) {

$parcel$export(module.exports, "useEntryPointToggleTrigger", () => $b6a06ebb42c1afd3$export$85854750ad265021);

var $eUqFw = parcelRequire("eUqFw");

var $iKK8N = parcelRequire("iKK8N");
const $b6a06ebb42c1afd3$export$85854750ad265021 = (actions, offValue = false)=>{
    const removePreviousListeners = (0, $eUqFw.useRef)(null);
    const isMounted = (0, $eUqFw.useRef)(true);
    (0, $eUqFw.useEffect)(()=>()=>{
            removePreviousListeners.current?.();
            removePreviousListeners.current = null;
            isMounted.current = false;
        }, []);
    return (0, $eUqFw.useCallback)((refElement)=>{
        if (!isMounted.current) return;
        removePreviousListeners.current?.();
        if (refElement) {
            const { type: type } = refElement;
            if (type !== 'checkbox' && type !== 'radio') throw new Error(`HTMLInputElement ref of type ${type} cannot be used with useEntryPointToggleTrigger. Try checkbox or radio.`);
            const hoverElement = (0, $iKK8N.getHoverProxy)(refElement);
            const handlers = {
                load () {
                    if (refElement.checked !== offValue) actions.load();
                },
                preload () {
                    if (refElement.checked === offValue) actions.preload();
                },
                cancelPreload () {
                    if (refElement.checked === offValue) actions.cancelPreload();
                }
            };
            (0, $iKK8N.addListeners)(handlers, refElement, hoverElement);
            removePreviousListeners.current = ()=>{
                (0, $iKK8N.removeListeners)(handlers, refElement, hoverElement);
            };
        } else removePreviousListeners.current = null;
    }, [
        actions,
        offValue
    ]);
};

});
parcelRegister("iKK8N", function(module, exports) {

$parcel$export(module.exports, "getHoverProxy", () => $54c74651eb4bd5b9$export$ed19923445ff0a86);
$parcel$export(module.exports, "addListeners", () => $54c74651eb4bd5b9$export$95d0815810fa2c63);
$parcel$export(module.exports, "removeListeners", () => $54c74651eb4bd5b9$export$5073839cf61ff85c);
const $54c74651eb4bd5b9$export$ed19923445ff0a86 = (element)=>element.parentElement?.tagName === 'LABEL' ? element.parentElement : element;
const $54c74651eb4bd5b9$export$95d0815810fa2c63 = (handlers, refElement, hoverElement)=>{
    refElement.addEventListener('change', handlers.load);
    refElement.addEventListener('focusin', handlers.preload);
    refElement.addEventListener('focusout', handlers.cancelPreload);
    hoverElement.addEventListener('mouseenter', handlers.preload);
    hoverElement.addEventListener('mouseleave', handlers.cancelPreload);
};
const $54c74651eb4bd5b9$export$5073839cf61ff85c = (handlers, refElement, hoverElement)=>{
    refElement.removeEventListener('change', handlers.load);
    refElement.removeEventListener('focusin', handlers.preload);
    refElement.removeEventListener('focusout', handlers.cancelPreload);
    hoverElement.removeEventListener('mouseenter', handlers.preload);
    hoverElement.removeEventListener('mouseleave', handlers.cancelPreload);
};

});


parcelRegister("87usC", function(module, exports) {

$parcel$export(module.exports, "default", () => $13956b616aa8d060$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $hTLlD = parcelRequire("hTLlD");

var $jG2Eu = parcelRequire("jG2Eu");

var $kFGm5 = parcelRequire("kFGm5");

var $8uNQc = parcelRequire("8uNQc");
var $6iz4v = parcelRequire("6iz4v");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");


var $fmCcJ = parcelRequire("fmCcJ");

var $jgUYF = parcelRequire("jgUYF");
const $13956b616aa8d060$var$clearAndSetPerformanceMark = (markKey)=>{
    if ((0, $8uNQc.default) && (0, $8uNQc.default).clearMarks) (0, $8uNQc.default).clearMarks(markKey);
    (0, $6iz4v.setMark)(markKey);
};
const $13956b616aa8d060$var$useDebouncedOnChange = (onChange, createAnalyticsEvent)=>{
    const debouncedOnChange = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((filters, filterType, attributes)=>{
            if (createAnalyticsEvent) {
                const analyticsEvent = createAnalyticsEvent({
                    action: 'changed',
                    actionSubject: 'filterBar'
                });
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'changeFilterBar', {
                    ...attributes,
                    filterType: filterType
                });
                onChange((0, $jgUYF.getNormalizedFilters)(filters), filterType, attributes, analyticsEvent);
            } else onChange((0, $jgUYF.getNormalizedFilters)(filters), filterType, attributes);
        }, 5), [
        onChange,
        createAnalyticsEvent
    ]);
    return debouncedOnChange;
};
const $13956b616aa8d060$var$useOnChangeFilterValues = (filter, onChange, // @ts-expect-error - TS7006 - Parameter 'onChangeInteractionStart' implicitly has an 'any' type.
onChangeInteractionStart, // @ts-expect-error - TS7006 - Parameter 'onCustomFilterChangeInteractionStart' implicitly has an 'any' type.
onCustomFilterChangeInteractionStart, createAnalyticsEvent, onClearCustomFilterInteractionStart, isCompanyManaged)=>{
    const [localFilter, setFilters] = (0, $eUqFw.useState)(filter);
    (0, $eUqFw.useEffect)(()=>{
        setFilters(filter);
    }, [
        filter
    ]);
    const debouncedOnChange = $13956b616aa8d060$var$useDebouncedOnChange(onChange, createAnalyticsEvent);
    const onChangeFilterValues = (0, $eUqFw.useCallback)((filters, fieldType, attributes)=>{
        if (fieldType !== null) {
            $13956b616aa8d060$var$clearAndSetPerformanceMark('filterBarStart');
            (0, $jgUYF.onFilterChangeStartInteraction)(fieldType, onChangeInteractionStart, onCustomFilterChangeInteractionStart);
            const values = filters[fieldType] ?? [];
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            let updatedFilter = {
                ...localFilter,
                [fieldType]: values
            };
            if (values.length === 0) {
                isCompanyManaged && onClearCustomFilterInteractionStart();
                updatedFilter = (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(localFilter, fieldType);
            }
            setFilters(updatedFilter);
            // fieldType could in theory not be accurate on a final debounced call,
            // however there's only a 5ms window during which this may happen.
            debouncedOnChange(updatedFilter, fieldType, attributes);
        }
    }, [
        onChangeInteractionStart,
        onCustomFilterChangeInteractionStart,
        setFilters,
        localFilter,
        debouncedOnChange,
        isCompanyManaged,
        onClearCustomFilterInteractionStart
    ]);
    const clearFilter = (0, $eUqFw.useCallback)(()=>{
        const emptyFilters = {
            TEXT: undefined,
            ASSIGNEE: undefined,
            LABEL: undefined,
            SPRINT: undefined,
            ISSUE_PARENT: undefined,
            ISSUE_PROJECT: undefined,
            ISSUE_TYPE: undefined,
            VERSION: undefined,
            REQUEST_TYPE: undefined,
            STATUS_CATEGORY: undefined,
            STATUS: undefined,
            CUSTOM_FILTER: undefined
        };
        isCompanyManaged && onClearCustomFilterInteractionStart();
        setFilters(emptyFilters);
        // A 2nd `null` argument is required so that the analytics event doesn't get treated as the
        // filter type on filter analytics.
        onChange((0, $jgUYF.getNormalizedFilters)(emptyFilters), null, undefined);
    }, [
        onChange,
        isCompanyManaged,
        onClearCustomFilterInteractionStart
    ]);
    return [
        localFilter,
        onChangeFilterValues,
        clearFilter
    ];
};
const $13956b616aa8d060$var$SoftwareFilters = (props)=>{
    const { filter: filter, onChange: onChange, onClearAllButtonClicked: onClearAllButtonClicked, onChangeInteractionFeedback: onChangeInteractionFeedback = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onChangeInteractionStart: onChangeInteractionStart = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onCustomFilterChangeInteractionFeedback: onCustomFilterChangeInteractionFeedback = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onCustomFilterChangeInteractionStart: onCustomFilterChangeInteractionStart = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onExperienceSuccess: onExperienceSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), isCompanyManaged: isCompanyManaged = false, onClearCustomFilterInteractionStart: onClearCustomFilterInteractionStart = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [localFilters, onChangeFilterValues, clearFilter] = $13956b616aa8d060$var$useOnChangeFilterValues(filter, onChange, onChangeInteractionStart, onCustomFilterChangeInteractionStart, createAnalyticsEvent, onClearCustomFilterInteractionStart, isCompanyManaged);
    (0, $eUqFw.useEffect)(()=>{
        onExperienceSuccess();
    }, [
        onExperienceSuccess
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(filter, localFilters)) {
            $13956b616aa8d060$var$clearAndSetPerformanceMark('filterBarStop');
            onChangeInteractionFeedback();
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(filter.CUSTOM_FILTER, localFilters.CUSTOM_FILTER)) onCustomFilterChangeInteractionFeedback();
        }
    }, [
        filter,
        localFilters,
        onChangeInteractionFeedback,
        onCustomFilterChangeInteractionFeedback
    ]);
    $13956b616aa8d060$var$clearAndSetPerformanceMark('oldFilterBarStop');
    const onClear = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        // we always have to pass void entityType, so analytics events will always be as third argument
        clearFilter();
        onClearAllButtonClicked && onClearAllButtonClicked(event, analyticsEvent);
        const customAnalyticsEvent = createAnalyticsEvent({
            action: 'changed',
            actionSubject: 'filterBar'
        });
        (0, $jMP2a.fireUIAnalytics)(customAnalyticsEvent, 'changeFilterBar', {
            filterType: (0, $44677eb502cfd308$export$6c4d37c7f376a1de)
        });
    }, [
        clearFilter,
        onClearAllButtonClicked,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fmCcJ.default), {
        ...props,
        filter: localFilters,
        onClearAllButtonClicked: onClear,
        onChange: onChangeFilterValues
    });
};
var $13956b616aa8d060$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($13956b616aa8d060$var$SoftwareFilters);

});
parcelRegister("fmCcJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ea7329b75e4ee65$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $dxIU5 = parcelRequire("dxIU5");

var $illlw = parcelRequire("illlw");

var $ldoFd = parcelRequire("ldoFd");

var $jG2Eu = parcelRequire("jG2Eu");

var $7GXrf = parcelRequire("7GXrf");

var $asu8X = parcelRequire("asu8X");

var $8CfG4 = parcelRequire("8CfG4");

var $dsroq = parcelRequire("dsroq");

var $b5IAe = parcelRequire("b5IAe");

var $4Bees = parcelRequire("4Bees");

var $cf2Y4 = parcelRequire("cf2Y4");

var $kjXsi = parcelRequire("kjXsi");

var $jmejm = parcelRequire("jmejm");
var $9zALC = parcelRequire("9zALC");
var $axKFq = parcelRequire("axKFq");
var $gfXKy = parcelRequire("gfXKy");

var $1Iui1 = parcelRequire("1Iui1");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $7xG8t = parcelRequire("7xG8t");
var $itGQN = parcelRequire("itGQN");
var $35WdX = parcelRequire("35WdX");
var $01UFf = parcelRequire("01UFf");
var $9D86p = parcelRequire("9D86p");
var $6syeh = parcelRequire("6syeh");
var $dNCGp = parcelRequire("dNCGp");
var $kpwtP = parcelRequire("kpwtP");
var $ifij9 = parcelRequire("ifij9");
var $8NoA2 = parcelRequire("8NoA2");
var $37gdQ = parcelRequire("37gdQ");
var $8rjRz = parcelRequire("8rjRz");
var $9iyDY = parcelRequire("9iyDY");
var $hNl8a = parcelRequire("hNl8a");
var $7Xd92 = parcelRequire("7Xd92");
var $2ZPCT = parcelRequire("2ZPCT");
var $b9Y1q = parcelRequire("b9Y1q");

var $5JgJ2 = parcelRequire("5JgJ2");

var $glQYN = parcelRequire("glQYN");

var $7uxUn = parcelRequire("7uxUn");

var $fqAlt = parcelRequire("fqAlt");
var $fmImn = parcelRequire("fmImn");
var $l4zCR = parcelRequire("l4zCR");

var $8Ui86 = parcelRequire("8Ui86");

var $6vrw7 = parcelRequire("6vrw7");

var $1Ksr6 = parcelRequire("1Ksr6");

var $dxcfv = parcelRequire("dxcfv");


var $cV7Ha = parcelRequire("cV7Ha");

var $8gxRf = parcelRequire("8gxRf");

var $8D53g = parcelRequire("8D53g");

var $hREiq = parcelRequire("hREiq");

var $iesgE = parcelRequire("iesgE");

var $gp3Fg = parcelRequire("gp3Fg");

var $84m3I = parcelRequire("84m3I");
const $2ea7329b75e4ee65$var$EMPTY_ARRAY = [];
const $2ea7329b75e4ee65$var$MIN_VISIBLE_USERS = 2;
const $2ea7329b75e4ee65$var$USER_AVATAR_WIDTH = 30;
const $2ea7329b75e4ee65$var$DEFAULT_VISIBLE_USERS = 7;
const $2ea7329b75e4ee65$var$MIN_FILTER_BAR_WIDTH = 510;
const $2ea7329b75e4ee65$var$LARGE_SEARCH_FILTER_BREAKPOINT = 1440;
const $2ea7329b75e4ee65$var$SoftwareFiltersStateless = (props)=>{
    (0, $asu8X.di)(requestAnimationFrame);
    const { filter: filter, issueParentsLabel: issueParentsLabel, assignees: assignees = [], issueParents: issueParents = [], versions: versions = [], components: components = [], labels: labels = [], issueProjects: issueProjects = {}, issueTypes: issueTypes = [], issueTypeGroups: issueTypeGroups = [], statuses: statuses = [], requestTypes: requestTypes = [], onChange: onChange, onSearchFieldFocus: onSearchFieldFocus = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onExtraAvatarMenuOpen: onExtraAvatarMenuOpen = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onFilterPanelMounted: onFilterPanelMounted = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onClearAllButtonClicked: onClearAllButtonClicked = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onToggleParentPanel: onToggleParentPanel = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onToggleVersionsPanel: onToggleVersionsPanel = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), isIssueParentPanelToggleChecked: isIssueParentPanelToggleChecked = false, isVersionPanelToggleChecked: isVersionPanelToggleChecked = false, isAnyModalOpen: isAnyModalOpen = false, AddPeopleModal: AddPeopleModal, showPanelToggle: /**
     * @deprecated `showPanelToggle` used to control visibility of all panel toggles. Use `panelToggleVisibility` instead to control each panel toggle visibility.
     */ showPanelToggle = false, panelToggleVisibility: panelToggleVisibility, showParentIssueMenuIfValuesAreEmpty: showParentIssueMenuIfValuesAreEmpty = false, showSearchFilterChangeboarding: showSearchFilterChangeboarding = false, hijackBrowserDefaultSearch: hijackBrowserDefaultSearch = false, screenName: screenName, isVersionsFeatureEnabled: isVersionsFeatureEnabled = false, isComponentsFeatureEnabled: isComponentsFeatureEnabled = false, isStatusCategoriesFeatureEnabled: isStatusCategoriesFeatureEnabled = true, isIssueParentsFeatureEnabled: isIssueParentsFeatureEnabled = true, isLabelsFeatureEnabled: isLabelsFeatureEnabled = true, isIssueProjectsFeatureEnabled: isIssueProjectsFeatureEnabled = false, isIssueTypesFeatureEnabled: isIssueTypesFeatureEnabled = true, isSprintsFeatureEnabled: isSprintsFeatureEnabled = true, isRequestTypesFeatureEnabled: isRequestTypesFeatureEnabled = false, isStatusesFeatureEnabled: isStatusesFeatureEnabled = false, isGroupIssueTypesEnabled: isGroupIssueTypesEnabled = false, onChangeInteractionStart: onChangeInteractionStart = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), projectId: projectId, projectName: projectName, projectKey: projectKey, boardId: boardId, statusCategories: statusCategories = [], customFiltersQueryRef: customFiltersQueryRef, CustomFilter: CustomFilter, showAssigneeFilter: showAssigneeFilter = true, showCustomFilters: showCustomFilters = false, showBoardSwitcher: showBoardSwitcher = false, isBoardSwitcherReadOnly: isBoardSwitcherReadOnly = true, versionFilterRelayQueryRef: versionFilterRelayQueryRef, VersionFilterRelay: VersionFilterRelay, isVersionFilterRelayEnabled: isVersionFilterRelayEnabled = false, isUnassignedAssigneeOptionEnabled: isUnassignedAssigneeOptionEnabled = false, isUnassignedVersionOptionEnabled: isUnassignedVersionOptionEnabled = false, isUnassignedLabelOptionEnabled: isUnassignedLabelOptionEnabled = false, isUnassignedComponentOptionEnabled: isUnassignedComponentOptionEnabled = false, isCustomFiltersLoading: isCustomFiltersLoading = false, placeholder: placeholder = '', screenReaderInstruction: screenReaderInstruction = '', sprints: sprints = [], isAddPeopleButtonEnabled: isAddPeopleButtonEnabled = false, isCustomFilterManageLinkEnabled: isCustomFilterManageLinkEnabled = false, jqlFilters: jqlFilters = [], isCompanyManaged: isCompanyManaged = false, isJSMBoard: isJSMBoard = false, hasMultipleProjects: hasMultipleProjects = false, isGoalsFeatureOptionEnabled: isGoalsFeatureOptionEnabled = false, goals: goals = [] } = props;
    const accountId = (0, $dxcfv.useAccountId)();
    const isAsyncFilterLoading = isCustomFiltersLoading;
    const [screenReaderInstructionForFilters, setScreenReaderInstructionForFilters] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const allAssignees = (0, $eUqFw.useMemo)(()=>isUnassignedAssigneeOptionEnabled ? [
            ...assignees,
            {
                id: (0, $6vrw7.toAccountId)((0, $44677eb502cfd308$export$12e572fd459c10dc)),
                displayName: formatMessage((0, $gp3Fg.default).unassignedAssigneeDisplayName),
                avatarUrl: undefined
            }
        ] : assignees, [
        assignees,
        isUnassignedAssigneeOptionEnabled,
        formatMessage
    ]);
    const allVersions = (0, $eUqFw.useMemo)(()=>isUnassignedVersionOptionEnabled && versions.length ? [
            {
                id: (0, $44677eb502cfd308$export$ac95b4b2317d4b33),
                name: formatMessage((0, $gp3Fg.default).unassignedVersionLabel)
            },
            ...versions
        ] : versions, [
        versions,
        isUnassignedVersionOptionEnabled,
        formatMessage
    ]);
    const unassignedOption = (0, $eUqFw.useMemo)(()=>({
            label: formatMessage((0, $gp3Fg.default).unassignedLabelLabel),
            value: (0, $44677eb502cfd308$export$81ef49afbbead0a1)
        }), [
        formatMessage
    ]);
    const allComponents = (0, $eUqFw.useMemo)(()=>isUnassignedComponentOptionEnabled && components.length ? [
            {
                id: (0, $44677eb502cfd308$export$4b7c755e61199a36),
                name: formatMessage((0, $gp3Fg.default).unassignedComponentLabel)
            },
            ...components
        ] : components, [
        components,
        isUnassignedComponentOptionEnabled,
        formatMessage
    ]);
    (0, $eUqFw.useEffect)(()=>{
        onFilterPanelMounted();
    }, [
        onFilterPanelMounted
    ]); // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onSearchChange = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((newText)=>{
        onChangeInteractionStart();
        onChange({
            [(0, $44677eb502cfd308$export$d597759d33be802e)]: newText
        }, (0, $44677eb502cfd308$export$d597759d33be802e), undefined);
    }, 300), [
        onChange,
        onChangeInteractionStart
    ]);
    const assigneeValue = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(filter, [
            (0, $44677eb502cfd308$export$f8f7545d2bb78afb)
        ], $2ea7329b75e4ee65$var$EMPTY_ARRAY), [
        filter
    ]);
    const onToggleAssignee = (0, $eUqFw.useCallback)((entryId)=>{
        setScreenReaderInstructionForFilters(true);
        setTimeout(()=>{
            setScreenReaderInstructionForFilters(false);
        });
        const withoutValue = (0, (/*@__PURE__*/$parcel$interopDefault($7GXrf)))(assigneeValue, entryId);
        const newFilterValue = withoutValue.length === assigneeValue.length ? withoutValue.concat(entryId) : withoutValue;
        onChange({
            [(0, $44677eb502cfd308$export$f8f7545d2bb78afb)]: (0, $6vrw7.toAccountIdArray)(newFilterValue)
        }, (0, $44677eb502cfd308$export$f8f7545d2bb78afb), {
            isUnassignedSelected: newFilterValue.includes((0, $44677eb502cfd308$export$12e572fd459c10dc)),
            isOnlyCurrentUserSelected: accountId && newFilterValue.length === 1 && newFilterValue[0] === accountId
        });
    }, [
        assigneeValue,
        onChange,
        accountId
    ]);
    const onChangeParents = (0, $eUqFw.useCallback)((parentIds, attributes)=>{
        onChange({
            [(0, $44677eb502cfd308$export$2a4f270075a033de)]: parentIds
        }, (0, $44677eb502cfd308$export$2a4f270075a033de), attributes);
    }, [
        onChange
    ]);
    const onChangeVersions = (0, $eUqFw.useCallback)((versionIds, attributes)=>{
        onChange({
            [(0, $44677eb502cfd308$export$a4ad2735b021c132)]: (0, $6vrw7.toVersionIdArray)(versionIds)
        }, (0, $44677eb502cfd308$export$a4ad2735b021c132), attributes);
    }, [
        onChange
    ]);
    const onChangeComponents = (0, $eUqFw.useCallback)((componentIds, attributes)=>{
        onChange({
            [(0, $44677eb502cfd308$export$af1e30ebbae9df3b)]: (0, $6vrw7.toComponentIdArray)(componentIds)
        }, (0, $44677eb502cfd308$export$af1e30ebbae9df3b), attributes);
    }, [
        onChange
    ]);
    const onChangeLabels = (0, $eUqFw.useCallback)((newLabels, attributes)=>{
        onChange({
            [(0, $44677eb502cfd308$export$37aee82a3cb1e8f7)]: newLabels
        }, (0, $44677eb502cfd308$export$37aee82a3cb1e8f7), attributes);
    }, [
        onChange
    ]);
    const onChangeIssueProjects = (0, $eUqFw.useCallback)((newProjects, attributes)=>{
        onChange({
            [(0, $44677eb502cfd308$export$401f4b6eda6a369c)]: newProjects
        }, (0, $44677eb502cfd308$export$401f4b6eda6a369c), attributes);
    }, [
        onChange
    ]);
    const onChangeIssueTypes = (0, $eUqFw.useCallback)((issueTypeIds, attributes)=>{
        onChange({
            [(0, $44677eb502cfd308$export$ebb48b08205007c5)]: issueTypeIds
        }, (0, $44677eb502cfd308$export$ebb48b08205007c5), attributes);
    }, [
        onChange
    ]);
    const onChangeStatusCategories = (0, $eUqFw.useCallback)((newStatusCategories, attributes)=>{
        onChange({
            [(0, $44677eb502cfd308$export$f863b019d19144f4)]: newStatusCategories
        }, (0, $44677eb502cfd308$export$f863b019d19144f4), attributes);
    }, [
        onChange
    ]);
    const onChangeCustomFilters = (0, $eUqFw.useCallback)((newCustomFilters, attributes)=>{
        onChange({
            [(0, $44677eb502cfd308$export$68d693c35a8d8866)]: newCustomFilters
        }, (0, $44677eb502cfd308$export$68d693c35a8d8866), attributes);
    }, [
        onChange
    ]);
    const onChangeSprints = (0, $eUqFw.useCallback)((newSprintIds, attributes)=>{
        onChange({
            [(0, $44677eb502cfd308$export$a316570a0dbfd2b0)]: newSprintIds
        }, (0, $44677eb502cfd308$export$a316570a0dbfd2b0), attributes);
    }, [
        onChange
    ]);
    const onChangeStatuses = (0, $eUqFw.useCallback)((newStatuses, attributes)=>{
        onChange({
            [(0, $44677eb502cfd308$export$e50006273435e7d4)]: newStatuses
        }, (0, $44677eb502cfd308$export$e50006273435e7d4), attributes);
    }, [
        onChange
    ]);
    const onChangeRequestTypes = (0, $eUqFw.useCallback)((newRequestTypeIds, attributes)=>{
        onChange({
            [(0, $44677eb502cfd308$export$92ab80c1dc9baf44)]: newRequestTypeIds
        }, (0, $44677eb502cfd308$export$92ab80c1dc9baf44), attributes);
    }, [
        onChange
    ]);
    const onChangeQuickFilters = (0, $eUqFw.useCallback)((newQuickFilters, attributes)=>{
        onChange({
            [(0, $44677eb502cfd308$export$1ea95b94fb0c51d9)]: newQuickFilters
        }, (0, $44677eb502cfd308$export$1ea95b94fb0c51d9), attributes);
    }, [
        onChange
    ]);
    const onChangeGoals = (0, $eUqFw.useCallback)((goalIds, attributes)=>{
        onChange({
            [(0, $44677eb502cfd308$export$871e58afc769b358)]: goalIds
        }, (0, $44677eb502cfd308$export$871e58afc769b358), attributes);
    }, [
        onChange
    ]);
    const isClearButtonVisible = (0, $eUqFw.useMemo)(()=>filter && Object.keys(filter).length > 0, [
        filter
    ]); // useRef to store the ref without causing any re-renders
    const searchInputRef = (0, $eUqFw.useRef)(null);
    const fireShortcutAnalytics = (0, $1Ksr6.useShortcutAnalytics)(screenName);
    const focusSearchInput = ()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(searchInputRef) && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(searchInputRef.current)) {
            // This is the same way the global search input prevents
            // the shortcut from being fed into the input
            // See: src/packages/navigation-apps/atlassian-navigation/src/ui/integrations/keyboard-shortcuts/index.tsx
            requestAnimationFrame(()=>{
                searchInputRef.current && searchInputRef.current.focus();
            });
            const analyticsPayload = {
                id: 'focusSearchField',
                key: 'f',
                attributes: {}
            };
            fireShortcutAnalytics(analyticsPayload);
        }
    };
    const screenReaderDescriptionId = 'search-issue-description';
    const isUserBoard = window.location.pathname.startsWith('/jira/people/');
    const customFilterManageUrl = (0, $84m3I.getManageCustomFiltersUrl)(projectKey, boardId.toString(), isCompanyManaged, isUserBoard, isJSMBoard);
    const showEpicPanelToggle = panelToggleVisibility ? panelToggleVisibility.showEpicPanelToggle : showPanelToggle;
    const isMounted = (0, $eUqFw.useRef)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (isMounted.current) {
            if (!isClearButtonVisible) {
                setScreenReaderInstructionForFilters(true);
                setTimeout(()=>{
                    setScreenReaderInstructionForFilters(false);
                }, 1000);
            }
        } else isMounted.current = true;
    }, [
        isClearButtonVisible
    ]);
    const parentFilter = {
        id: (0, $44677eb502cfd308$export$2a4f270075a033de),
        isStatic: false,
        isHidden: (0, $cV7Ha.isIncrementPlanningBoardM1Enabled)() ? !isIssueParentsFeatureEnabled : undefined,
        renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $37gdQ.default), {
                key: "ParentFilter",
                isNested: isNested,
                label: issueParentsLabel,
                parents: issueParents,
                selectedParents: filter[0, $44677eb502cfd308$export$2a4f270075a033de],
                isToggleChecked: isIssueParentPanelToggleChecked,
                onChange: onChangeParents,
                onTogglePanel: onToggleParentPanel,
                showPanelToggle: showEpicPanelToggle,
                showMenuIfValuesAreEmpty: showParentIssueMenuIfValuesAreEmpty
            })
    };
    const showVersionsPanelToggle = panelToggleVisibility ? panelToggleVisibility.showVersionsPanelToggle : showPanelToggle;
    const versionFilter = {
        id: (0, $44677eb502cfd308$export$a4ad2735b021c132),
        isStatic: false,
        renderer: (isNested)=>isVersionFilterRelayEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iesgE.default), {
                key: "VersionFilterRelayBoundary",
                screenName: screenName,
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b9Y1q.default), {
                    isNested: isNested,
                    versions: $2ea7329b75e4ee65$var$EMPTY_ARRAY,
                    isToggleChecked: isVersionPanelToggleChecked,
                    onChange: onChangeVersions,
                    onTogglePanel: onToggleVersionsPanel,
                    selectedVersions: filter[0, $44677eb502cfd308$export$a4ad2735b021c132] ?? $2ea7329b75e4ee65$var$EMPTY_ARRAY,
                    isSpotlightEnabled: false,
                    showPanelToggle: showVersionsPanelToggle,
                    isVersionsFeatureEnabled: isVersionsFeatureEnabled,
                    hasMultipleProjects: hasMultipleProjects
                })
            }, versionFilterRelayQueryRef != null && VersionFilterRelay != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(VersionFilterRelay, {
                isNested: isNested,
                isToggleChecked: isVersionPanelToggleChecked,
                onChange: onChangeVersions,
                onTogglePanel: onToggleVersionsPanel,
                selectedVersions: filter[0, $44677eb502cfd308$export$a4ad2735b021c132] ?? $2ea7329b75e4ee65$var$EMPTY_ARRAY,
                isSpotlightEnabled: false,
                showPanelToggle: showVersionsPanelToggle,
                isVersionsFeatureEnabled: isVersionsFeatureEnabled,
                versionFilterRelayQueryRef: versionFilterRelayQueryRef,
                isUnassignedVersionOptionEnabled: isUnassignedVersionOptionEnabled,
                hasMultipleProjects: hasMultipleProjects
            }) : null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b9Y1q.default), {
                key: "VersionFilter",
                isNested: isNested,
                versions: allVersions,
                isToggleChecked: isVersionPanelToggleChecked,
                onChange: onChangeVersions,
                onTogglePanel: onToggleVersionsPanel,
                selectedVersions: filter[0, $44677eb502cfd308$export$a4ad2735b021c132] ?? $2ea7329b75e4ee65$var$EMPTY_ARRAY,
                isSpotlightEnabled: false,
                showPanelToggle: showVersionsPanelToggle,
                isVersionsFeatureEnabled: isVersionsFeatureEnabled
            })
    };
    const itemsBefore = [
        {
            id: (0, $44677eb502cfd308$export$f863b019d19144f4),
            isStatic: false,
            isHidden: !isStatusCategoriesFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Xd92.default), {
                    key: "StatusCategoryFilter",
                    isNested: isNested,
                    statusCategories: statusCategories,
                    selectedStatusCategories: filter[0, $44677eb502cfd308$export$f863b019d19144f4],
                    onChange: onChangeStatusCategories
                })
        },
        /**
   * the "Project" filter is currently only used by the Increment Planning board of Advanced Roadmaps
   * please refer to src/packages/software/board/src/services/filter/filter-url-bindings.tsx
   */ {
            id: (0, $44677eb502cfd308$export$401f4b6eda6a369c),
            isStatic: false,
            isHidden: (0, $cV7Ha.isIncrementPlanningBoardM1Enabled)() ? !isIssueProjectsFeatureEnabled : undefined,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6syeh.default), {
                    isNested: isNested,
                    issueProjects: issueProjects,
                    key: "IssueProjectFilter",
                    onChange: onChangeIssueProjects,
                    selectedProjects: filter[0, $44677eb502cfd308$export$401f4b6eda6a369c]
                })
        },
        versionFilter,
        parentFilter,
        {
            id: (0, $44677eb502cfd308$export$37aee82a3cb1e8f7),
            isStatic: false,
            isHidden: !isLabelsFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ifij9.default), {
                    key: "LabelFilter",
                    isNested: isNested,
                    ...isUnassignedLabelOptionEnabled && labels.length ? {
                        unassignedOption: unassignedOption
                    } : undefined,
                    labels: labels,
                    selectedLabels: filter[0, $44677eb502cfd308$export$37aee82a3cb1e8f7],
                    onChange: onChangeLabels
                })
        },
        {
            id: (0, $44677eb502cfd308$export$ebb48b08205007c5),
            isStatic: false,
            isHidden: !isIssueTypesFeatureEnabled,
            renderer: (isNested)=>isGroupIssueTypesEnabled ? // In the program board, we could have multiple issue types with the same hierarchy level and names coming from multiple TWP project. We group them so there's no visually duplicated items in the dropdown
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kpwtP.default), {
                    key: "IssueTypeGroupFilter",
                    isNested: isNested,
                    issueTypeGroups: issueTypeGroups,
                    selectedIssueTypes: filter[0, $44677eb502cfd308$export$ebb48b08205007c5],
                    onChange: onChangeIssueTypes
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dNCGp.default), {
                    key: "IssueTypeFilter",
                    isNested: isNested,
                    issueTypes: issueTypes,
                    selectedIssueTypes: filter[0, $44677eb502cfd308$export$ebb48b08205007c5],
                    onChange: onChangeIssueTypes
                })
        },
        {
            id: (0, $44677eb502cfd308$export$af1e30ebbae9df3b),
            isStatic: false,
            isHidden: !isComponentsFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $35WdX.default), {
                    key: "ComponentFilter",
                    isNested: isNested,
                    components: allComponents,
                    onChange: onChangeComponents,
                    selectedComponents: filter[0, $44677eb502cfd308$export$af1e30ebbae9df3b]
                })
        },
        {
            id: (0, $44677eb502cfd308$export$a316570a0dbfd2b0),
            isStatic: false,
            isHidden: !isSprintsFeatureEnabled || sprints.length <= 1,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hNl8a.default), {
                    key: "SprintFilter",
                    isNested: isNested,
                    sprints: sprints,
                    selectedSprints: filter[0, $44677eb502cfd308$export$a316570a0dbfd2b0],
                    onChange: onChangeSprints
                })
        },
        {
            id: (0, $44677eb502cfd308$export$e50006273435e7d4),
            isStatic: false,
            isHidden: !isStatusesFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ZPCT.default), {
                    key: "StatusFilter",
                    isNested: isNested,
                    statuses: statuses,
                    selectedStatuses: filter[0, $44677eb502cfd308$export$e50006273435e7d4],
                    onChange: onChangeStatuses
                })
        },
        {
            id: (0, $44677eb502cfd308$export$92ab80c1dc9baf44),
            isStatic: false,
            isHidden: !isRequestTypesFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9iyDY.default), {
                    key: "RequestTypeFilter",
                    isNested: isNested,
                    requestTypes: requestTypes,
                    selectedRequestTypes: filter[0, $44677eb502cfd308$export$92ab80c1dc9baf44],
                    onChange: onChangeRequestTypes
                })
        },
        {
            id: (0, $44677eb502cfd308$export$68d693c35a8d8866),
            isStatic: false,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8gxRf.default), {
                    key: "CustomFilterBoundary",
                    screenName: screenName,
                    customFiltersQueryRef: customFiltersQueryRef
                }, (!!customFiltersQueryRef || showCustomFilters) && !!CustomFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CustomFilter, {
                    shouldReturnFocus: isClearButtonVisible === false,
                    isNested: isNested,
                    customFiltersQueryRef: customFiltersQueryRef,
                    selectedFilters: filter[0, $44677eb502cfd308$export$68d693c35a8d8866],
                    filters: jqlFilters,
                    onChange: onChangeCustomFilters,
                    showLink: isCustomFilterManageLinkEnabled,
                    manageUrl: customFilterManageUrl,
                    screenName: screenName
                }))
        },
        {
            id: (0, $44677eb502cfd308$export$1ea95b94fb0c51d9),
            isStatic: false,
            isHidden: showCustomFilters,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8rjRz.default), {
                    key: "QuickFilter",
                    isNested: isNested,
                    filters: jqlFilters,
                    selectedFilters: filter[0, $44677eb502cfd308$export$1ea95b94fb0c51d9],
                    onChange: onChangeQuickFilters
                })
        },
        {
            id: (0, $44677eb502cfd308$export$871e58afc769b358),
            isStatic: false,
            isHidden: !isGoalsFeatureOptionEnabled || goals.length === 0,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9D86p.default), {
                    key: "GoalFilter",
                    isNested: isNested,
                    goals: goals,
                    selectedGoals: filter[0, $44677eb502cfd308$export$871e58afc769b358],
                    onChange: onChangeGoals
                })
        }
    ];
    const itemsAfter = [
        {
            id: 'CLEAR_BUTTON',
            // The CLEAR_BUTTON should be non-static until a filter is added, else it causes the More button to appear
            // in the filter bar on small window sizes, due to overflow calculations in <OverflowHandler />
            isStatic: (0, $1ybV0.ff)('refactor-more-button-display-on-small-devices_tnu38') ? isClearButtonVisible : true,
            isHidden: !isClearButtonVisible,
            renderer: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $itGQN.default), {
                    key: "ClearButton",
                    onClick: onClearAllButtonClicked
                })
        }
    ];
    if (isAsyncFilterLoading) itemsAfter.push({
        id: 'SPINNER',
        isStatic: true,
        isHidden: !isAsyncFilterLoading,
        renderer: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ea7329b75e4ee65$var$SpinnerContainer, {
                key: "SpinnerContainer"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
                size: "small"
            }))
    });
    const { getKeywords: getKeywords } = (0, $gfXKy.useCommandKeywords)();
    const [maxVisibleUsers, setMaxVisibleUsers] = (0, $eUqFw.useState)($2ea7329b75e4ee65$var$DEFAULT_VISIBLE_USERS);
    const [showLargeSearchFilter, setShowLargeSearchFilter] = (0, $eUqFw.useState)(true);
    const filterBarRef = (0, $eUqFw.useRef)(null);
    const handleResize = (0, $eUqFw.useCallback)(()=>{
        if (!filterBarRef.current || !searchInputRef.current) return; // Handle avatar overflow
        const width = filterBarRef.current.offsetWidth - searchInputRef.current.offsetWidth;
        if (width < $2ea7329b75e4ee65$var$MIN_FILTER_BAR_WIDTH) {
            const usersToReduce = Math.ceil(($2ea7329b75e4ee65$var$MIN_FILTER_BAR_WIDTH - width) / $2ea7329b75e4ee65$var$USER_AVATAR_WIDTH);
            const newMax = Math.max($2ea7329b75e4ee65$var$DEFAULT_VISIBLE_USERS - usersToReduce, $2ea7329b75e4ee65$var$MIN_VISIBLE_USERS);
            setMaxVisibleUsers(newMax);
        } else setMaxVisibleUsers($2ea7329b75e4ee65$var$DEFAULT_VISIBLE_USERS);
         // Handle search field width
        setShowLargeSearchFilter(window.innerWidth >= $2ea7329b75e4ee65$var$LARGE_SEARCH_FILTER_BREAKPOINT);
    }, []);
    (0, $7uxUn.useResizeObserver)({
        ref: filterBarRef,
        onResize: handleResize
    });
    (0, $7uxUn.useResizeObserver)({
        ref: searchInputRef,
        onResize: handleResize
    });
    const { experimentCohort: experimentCohort } = (0, $l4zCR.useRealtimePresenceExperiment)();
    const isRealtimePresenceEnabled = ()=>screenName === 'board' && experimentCohort === (0, $1Iui1.VARIATION);
    if (screenName === 'board' && experimentCohort !== (0, $1Iui1.NOT_ENROLLED)) {
        const [, fireExposure] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_board_real-time_collaboration_through_presence');
        fireExposure();
    }
    const [{ participants: participants }] = (0, $fmImn.useCollabStore)();
    const allUsersWithPresence = isRealtimePresenceEnabled() ? (0, $84m3I.getAssigneesWithPresence)(allAssignees, participants) : allAssignees;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $01UFf.FilterBar), {
        ref: filterBarRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $axKFq.CommandShortcuts), {
        keyMap: {
            f: {
                callback: focusSearchInput,
                registerInCommandPalette: {
                    id: 'software-filters-stateless-focus-search-input',
                    name: formatMessage((0, $gp3Fg.default).searchCurrentPage),
                    keywords: getKeywords('pageSearchSynonyms'),
                    priority: (0, $jmejm.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).searchOnCurrentPage,
                    section: (0, $9zALC.COMMAND_PALETTE_SECTIONS).quickActions,
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8CfG4))), {
                                label: formatMessage((0, $gp3Fg.default).searchCurrentPage)
                            })
                    },
                    analytics: {
                        action: 'searchCurrentPage'
                    }
                }
            }
        },
        location: "software.filters.keyboard-shortcuts"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kjXsi.ScreenReaderText), {
        id: screenReaderDescriptionId
    }, screenReaderInstruction || formatMessage((0, $gp3Fg.default).screenReaderInstruction)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, screenReaderInstructionForFilters ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kjXsi.ScreenReaderText), {
        "data-testid": "software-filters.ui.stateless.screen-reader-instruction",
        id: "software-filters.ui.stateless.screen-reader-instruction",
        role: "status",
        "aria-relevant": "all"
    }, formatMessage((0, $gp3Fg.default).screenReaderInstructionForFilters)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kjXsi.ScreenReaderText), {
        "data-testid": "software-filters.ui.stateless.screen-reader-instruction",
        id: "software-filters.ui.stateless.screen-reader-instruction",
        role: "status"
    })), hijackBrowserDefaultSearch === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8D53g.default), {
        onFocusSearch: focusSearchInput,
        isAnyModalOpen: isAnyModalOpen
    }), showSearchFilterChangeboarding === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hREiq.default), {
        hijackBrowserDefaultSearch: hijackBrowserDefaultSearch,
        screenName: screenName,
        isCompanyManaged: isCompanyManaged
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Ui86.SearchField), {
        placeholderAlwaysVisible: true,
        describedById: screenReaderDescriptionId,
        isAlwaysExpanded: showLargeSearchFilter,
        searchIconVisible: false,
        renderCustomSearchField: $2ea7329b75e4ee65$var$CustomSearchInput,
        value: filter[0, $44677eb502cfd308$export$d597759d33be802e] || '',
        placeholder: placeholder || formatMessage((0, $gp3Fg.default).textFilter),
        onChange: onSearchChange,
        onFocus: onSearchFieldFocus,
        inputRef: searchInputRef,
        maxLength: 255,
        testId: "software-filters.ui.stateless.search-field"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Ui86.SearchField), {
        placeholderAlwaysVisible: true,
        describedById: screenReaderDescriptionId,
        isAlwaysExpanded: showLargeSearchFilter,
        searchIconVisible: false,
        renderCustomSearchField: $2ea7329b75e4ee65$var$CustomSearchInput,
        value: filter[0, $44677eb502cfd308$export$d597759d33be802e] || '',
        placeholder: placeholder || formatMessage((0, $gp3Fg.default).textFilter),
        onChange: onSearchChange,
        onFocus: onSearchFieldFocus,
        inputRef: searchInputRef,
        maxLength: 255,
        testId: "software-filters.ui.stateless.search-field"
    }), (0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1') && showBoardSwitcher && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $glQYN.default), {
        boardId: boardId,
        isReadOnly: isBoardSwitcherReadOnly
    }), showAssigneeFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7xG8t.default), {
        maxUsers: maxVisibleUsers,
        users: allUsersWithPresence,
        screenName: screenName,
        selectedUsers: assigneeValue,
        onToggle: onToggleAssignee,
        onAssigneeMenuOpen: onExtraAvatarMenuOpen,
        AddPeopleModal: AddPeopleModal,
        projectId: projectId,
        projectName: projectName,
        isAddPeopleButtonEnabled: isAddPeopleButtonEnabled,
        projectKey: projectKey
    }), isRealtimePresenceEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fqAlt.CollabContainerAsync), {
        screenName: screenName,
        boardId: boardId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $01UFf.ListFilterContainerNextGen // eslint-disable-next-line jira/integration/test-id-by-folder-structure
    ), {
        "data-testid": "software-filters.ui.list-filter-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8NoA2.default), {
        itemsBefore: itemsBefore,
        itemsAfter: itemsAfter,
        selectedItems: filter
    })));
};
const $2ea7329b75e4ee65$var$customSearchInputStyles = null;
const $2ea7329b75e4ee65$var$CustomSearchInput = ({ textFieldProps: textFieldProps, searchIcon: searchIcon })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
    ), {
        ...textFieldProps,
        elemAfterInput: searchIcon,
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            paddingInlineStart: "space.100",
            paddingBlockStart: "space.025"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dsroq))), {
            primaryColor: "var(--ds-icon, #44546F)",
            size: "small",
            label: ""
        })),
        autoComplete: "off",
        testId: "software-filters.ui.stateless.search-field",
        className: (0, $7JEyt.default)([
            "_2rkoq1pp _1yt4ze3t _1rns1b66 _1srlxy5q"
        ])
    });
var $2ea7329b75e4ee65$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($2ea7329b75e4ee65$var$SoftwareFiltersStateless);
const $2ea7329b75e4ee65$var$SpinnerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19bv1b66 _4t3i1osq _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8CfG4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $645e088e86b3f594$var$_react = $645e088e86b3f594$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $645e088e86b3f594$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $645e088e86b3f594$var$PageIcon = (props)=>/*#__PURE__*/ $645e088e86b3f594$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><rect x="8" y="6" width="8" height="2" rx="1"/><rect x="8" y="9" width="8" height="2" rx="1"/><rect x="8" y="12" width="4" height="2" rx="1"/><path d="M7 4v16h10V4H7zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 015 20.01V3.99z" fill-rule="nonzero"/></g></svg>`
    }, props));
$645e088e86b3f594$var$PageIcon.displayName = 'PageIcon';
var $645e088e86b3f594$var$_default = $645e088e86b3f594$var$PageIcon;
module.exports.default = $645e088e86b3f594$var$_default;

});

parcelRegister("jmejm", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY", () => $008cf4f8cce3a652$export$5ea2dca0a260365d);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $008cf4f8cce3a652$export$5ea2dca0a260365d;
(function(COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY) {
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["createIssue"] = 0] = "createIssue";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["searchOnCurrentPage"] = 1] = "searchOnCurrentPage";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["openQuickSearch"] = 2] = "openQuickSearch";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["copyUrl"] = 3] = "copyUrl";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["checkNotifications"] = 4] = "checkNotifications";
})($008cf4f8cce3a652$export$5ea2dca0a260365d || ($008cf4f8cce3a652$export$5ea2dca0a260365d = {}));

});

parcelRegister("9zALC", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS", () => $8bee8fa7684ab6e5$export$16b06d29ef8f802b);
$parcel$export(module.exports, "COMMAND_PALETTE_ISSUE_ACTIONS", () => $8bee8fa7684ab6e5$export$156ebd2354e25466);
$parcel$export(module.exports, "COMMAND_PALETTE_PRESSED_ANALYTICS", () => $8bee8fa7684ab6e5$export$7fe859528e87e623);
$parcel$export(module.exports, "COMMAND_PALETTE_ID", () => $8bee8fa7684ab6e5$export$9f646ab88e1d2b14);
$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS_PRIORITY", () => $8bee8fa7684ab6e5$export$abf26cc5daebd2c8);
$parcel$export(module.exports, "COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY", () => $8bee8fa7684ab6e5$export$12514ca8899b0521);
$parcel$export(module.exports, "COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY", () => $8bee8fa7684ab6e5$export$5fa0bcf59f933c21);
$parcel$export(module.exports, "COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY", () => $8bee8fa7684ab6e5$export$7d9743be0b7d862f);
$parcel$export(module.exports, "COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY", () => $8bee8fa7684ab6e5$export$b4e1633c86db2b70);
$parcel$export(module.exports, "COMMAND_PALETTE_HELP_PRIORITY", () => $8bee8fa7684ab6e5$export$5e5a87aac5d9771f);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $8bee8fa7684ab6e5$export$16b06d29ef8f802b;
(function(COMMAND_PALETTE_SECTIONS) {
    COMMAND_PALETTE_SECTIONS["quickSearch"] = "quick-search";
    COMMAND_PALETTE_SECTIONS["projectNavigation"] = "project-navigation";
    COMMAND_PALETTE_SECTIONS["siteNavigation"] = "site-navigation";
    COMMAND_PALETTE_SECTIONS["help"] = "help";
    COMMAND_PALETTE_SECTIONS["quickActions"] = "quick-actions";
    COMMAND_PALETTE_SECTIONS["personalSettings"] = "personal-settings";
    COMMAND_PALETTE_SECTIONS["jiraSettings"] = "jira-settings";
    COMMAND_PALETTE_SECTIONS["atlassianAdmin"] = "atlassian-admin";
})($8bee8fa7684ab6e5$export$16b06d29ef8f802b || ($8bee8fa7684ab6e5$export$16b06d29ef8f802b = {}));
const $8bee8fa7684ab6e5$export$156ebd2354e25466 = 'issueActions';
const $8bee8fa7684ab6e5$export$7fe859528e87e623 = {
    action: 'pressed',
    actionSubject: 'commandPaletteKeyboardShortcut'
};
const $8bee8fa7684ab6e5$export$9f646ab88e1d2b14 = 'commandPalette';
var $8bee8fa7684ab6e5$export$abf26cc5daebd2c8;
(function(COMMAND_PALETTE_SECTIONS_PRIORITY) {
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickSearch"] = 0] = "quickSearch";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["issueActions"] = 1] = "issueActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["projectNavigation"] = 2] = "projectNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickActions"] = 3] = "quickActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["siteNavigation"] = 4] = "siteNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["atlassianAdmin"] = 5] = "atlassianAdmin";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["jiraSettings"] = 6] = "jiraSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["personalSettings"] = 7] = "personalSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["help"] = 8] = "help";
})($8bee8fa7684ab6e5$export$abf26cc5daebd2c8 || ($8bee8fa7684ab6e5$export$abf26cc5daebd2c8 = {}));
var $8bee8fa7684ab6e5$export$12514ca8899b0521;
(function(COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBacklog"] = 0] = "goToBacklog";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBoard"] = 1] = "goToBoard";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToReports"] = 2] = "goToReports";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToTimeline"] = 3] = "goToTimeline";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToIssues"] = 4] = "goToIssues";
})($8bee8fa7684ab6e5$export$12514ca8899b0521 || ($8bee8fa7684ab6e5$export$12514ca8899b0521 = {}));
var $8bee8fa7684ab6e5$export$5fa0bcf59f933c21;
(function(COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY) {
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["userManagement"] = 0] = "userManagement";
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["billing"] = 1] = "billing";
})($8bee8fa7684ab6e5$export$5fa0bcf59f933c21 || ($8bee8fa7684ab6e5$export$5fa0bcf59f933c21 = {}));
var $8bee8fa7684ab6e5$export$7d9743be0b7d862f;
(function(COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY) {
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToDarkTheme"] = 0] = "switchToDarkTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToLightTheme"] = 1] = "switchToLightTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToSystemTheme"] = 2] = "switchToSystemTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToPersonalSettings"] = 3] = "goToPersonalSettings";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToAccountSettings"] = 4] = "goToAccountSettings";
})($8bee8fa7684ab6e5$export$7d9743be0b7d862f || ($8bee8fa7684ab6e5$export$7d9743be0b7d862f = {}));
var $8bee8fa7684ab6e5$export$b4e1633c86db2b70;
(function(COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["viewAllIssues"] = 0] = "viewAllIssues";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToProjects"] = 1] = "goToProjects";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToBoards"] = 2] = "goToBoards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToFilters"] = 3] = "goToFilters";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToDashboards"] = 4] = "goToDashboards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToPlans"] = 5] = "goToPlans";
})($8bee8fa7684ab6e5$export$b4e1633c86db2b70 || ($8bee8fa7684ab6e5$export$b4e1633c86db2b70 = {}));
var $8bee8fa7684ab6e5$export$5e5a87aac5d9771f;
(function(COMMAND_PALETTE_HELP_PRIORITY) {
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["getHelp"] = 0] = "getHelp";
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["viewKeyboardShortcuts"] = 1] = "viewKeyboardShortcuts";
})($8bee8fa7684ab6e5$export$5e5a87aac5d9771f || ($8bee8fa7684ab6e5$export$5e5a87aac5d9771f = {}));

});

parcelRegister("axKFq", function(module, exports) {

$parcel$export(module.exports, "CommandShortcuts", () => $cc0f6b42d78d14cf$export$7ff7e4fe85a5960a);

var $eUqFw = parcelRequire("eUqFw");

var $6jiFZ = parcelRequire("6jiFZ");

var $fmmnJ = parcelRequire("fmmnJ");
var $awzwr = parcelRequire("awzwr");

var $9aFSa = parcelRequire("9aFSa");
const $cc0f6b42d78d14cf$export$7ff7e4fe85a5960a = (props)=>{
    const { keyMap: keyMap } = props;
    const mappedCommands = (0, $eUqFw.useMemo)(()=>{
        const commands = [];
        Object.entries(keyMap).forEach(([key, mapItem])=>{
            if (!mapItem.registerInCommandPalette) return;
            const { primaryAction: primaryAction, ...command } = mapItem.registerInCommandPalette;
            let shortcutPrimaryAction;
            if (primaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST || primaryAction?.type === (0, $6jiFZ.CommandActionType).PERFORM) shortcutPrimaryAction = primaryAction;
            else if (mapItem.callback) shortcutPrimaryAction = {
                type: (0, $6jiFZ.CommandActionType).PERFORM,
                perform: ()=>mapItem.callback()
            };
            /**
			 * loadChildren function has the preference over the other actions
			 * followed by perform and then, if none set, the KeyMap callback
			 */ commands.push({
                id: `command-shortcut-${key}`,
                shortcut: key,
                ...command,
                primaryAction: shortcutPrimaryAction
            });
        });
        return commands;
    }, [
        keyMap
    ]);
    /**
	 * As mappedCommands is an object, it changes at every render.
	 * To memoise the commands properly in the command palette
	 * the ids are stringified and add as a dependency of the effect
	 */ const shortcutIds = (0, $eUqFw.useMemo)(()=>mappedCommands.map(({ id: id })=>id).toString(), [
        mappedCommands
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9aFSa.default), props), !!mappedCommands.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $awzwr.RegisterCommands), {
        registrationId: (0, $fmmnJ.COMMAND_PALETTE_REGISTRY_IDS).SHORTCUTS,
        commands: mappedCommands,
        deps: [
            shortcutIds
        ]
    }));
};

});
parcelRegister("6jiFZ", function(module, exports) {

$parcel$export(module.exports, "CommandActionType", () => $5c36304d2fa4b1a2$export$f041b1b117ab382f);
$parcel$export(module.exports, "COMMAND_WITH_CHILDREN", () => $5c36304d2fa4b1a2$export$904b2a0e38a1bef3);
var $5c36304d2fa4b1a2$export$f041b1b117ab382f;
(function(CommandActionType) {
    /** Performs action when user clicks or presses Enter in the command. Command Palette closes while performing the action */ CommandActionType["PERFORM"] = "perform";
    /** Loads a sub list of commands  */ CommandActionType["COMMAND_LIST"] = "command-list";
})($5c36304d2fa4b1a2$export$f041b1b117ab382f || ($5c36304d2fa4b1a2$export$f041b1b117ab382f = {}));
const $5c36304d2fa4b1a2$export$3e448fd53031e13c = Object.values($5c36304d2fa4b1a2$export$f041b1b117ab382f);
const $5c36304d2fa4b1a2$export$904b2a0e38a1bef3 = [
    "command-list"
];

});

parcelRegister("fmmnJ", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY_IDS", () => $2688cae36ed8d4f6$export$689de18177335e39);
$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY", () => $2688cae36ed8d4f6$export$96f61eb1261e42c3);
// Documentation for contributing to command palette: go/compal
const $2688cae36ed8d4f6$export$689de18177335e39 = {
    ADD_CHILD_ISSUE: 'ADD_CHILD_ISSUE',
    ADMIN_NAVIGATION: 'ADMIN_NAVIGATION',
    CHECK_NOTIFICATIONS: 'CHECK_NOTIFICATIONS',
    COPY_URL: 'COPY_URL',
    DESCRIPTION: 'DESCRIPTION',
    ISSUE_ACTIONS: 'ISSUE_ACTIONS',
    ISSUE_FIELD_ASSIGN: 'ISSUE_FIELD_ASSIGN',
    ISSUE_HEADER_ACTIONS: 'ISSUE_HEADER_ACTIONS',
    ISSUE_SUB_HEADER_ACTIONS: 'ISSUE_SUB_HEADER_ACTIONS',
    LOG_WORK: 'LOG_WORK',
    NAVIGATION_COMMANDS: 'NAVIGATION_COMMANDS',
    PARENT: 'PARENT',
    PROJECT_NAVIGATION: 'PROJECT_NAVIGATION',
    QUICK_ADD: 'QUICK_ADD',
    QUICK_SEARCH: 'QUICK_SEARCH',
    SHORTCUTS: 'SHORTCUTS',
    STATUS: 'STATUS',
    STORY_POINTS: 'STORY_POINTS',
    TEST: 'TEST',
    THEME_MODE: 'THEME_MODE'
};
// Alphabetical order please
// Update the teamName enum to include your team in the following:
// https://data-portal.internal.atlassian.com/analytics/registry/49626?tabIndex=Attributes
// https://data-portal.internal.atlassian.com/analytics/registry/49627?tabIndex=Attributes
const $2688cae36ed8d4f6$var$teams = {
    Deliveroo: 'Deliveroo'
};
const $2688cae36ed8d4f6$export$96f61eb1261e42c3 = {
    ADMIN_NAVIGATION: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ADMIN_NAVIGATION,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    CHECK_NOTIFICATIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.CHECK_NOTIFICATIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    COPY_URL: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.COPY_URL,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    DESCRIPTION: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.DESCRIPTION,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_ACTIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_ACTIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_FIELD_ASSIGN: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_FIELD_ASSIGN,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_HEADER_ACTIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_HEADER_ACTIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_SUB_HEADER_ACTIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_SUB_HEADER_ACTIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    LOG_WORK: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.LOG_WORK,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    NAVIGATION_COMMANDS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.NAVIGATION_COMMANDS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    PARENT: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.PARENT,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    PROJECT_NAVIGATION: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.PROJECT_NAVIGATION,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    QUICK_ADD: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.QUICK_ADD,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    QUICK_SEARCH: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.QUICK_SEARCH,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    SHORTCUTS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.SHORTCUTS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    STATUS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.STATUS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    STORY_POINTS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.STORY_POINTS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    THEME_MODE: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.THEME_MODE,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    }
};

});

parcelRegister("awzwr", function(module, exports) {

$parcel$export(module.exports, "RegisterCommands", () => $42c02b036374b0c2$export$cd555833c78729f1);

var $eUqFw = parcelRequire("eUqFw");

var $7ElYg = parcelRequire("7ElYg");
const $42c02b036374b0c2$export$cd555833c78729f1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ElYg.RegisterCommandsWithRegistry), props);

});
parcelRegister("7ElYg", function(module, exports) {

$parcel$export(module.exports, "RegisterCommandsWithRegistry", () => $f8fb4bce96babd2d$export$b8955a01360d2876);

var $fqCN8 = parcelRequire("fqCN8");
function $f8fb4bce96babd2d$export$b8955a01360d2876({ registrationId: registrationId, commands: commands, deps: deps }) {
    (0, $fqCN8.useRegisterCommandsWithRegistry)(registrationId, commands, deps);
    return null;
}

});
parcelRegister("fqCN8", function(module, exports) {

$parcel$export(module.exports, "useRegisterCommandsWithRegistry", () => $f1b669646bbb8295$export$8a824ae164ff968d);

var $eUqFw = parcelRequire("eUqFw");

var $7Xm2s = parcelRequire("7Xm2s");
function $f1b669646bbb8295$export$8a824ae164ff968d(registrationId, commands, dependencies = []) {
    const subscribe = (0, $7Xm2s.useSubscribeCommandsWithRegistry)();
    const commandCache = (0, $eUqFw.useRef)(commands);
    (0, $eUqFw.useEffect)(()=>{
        commandCache.current = commands;
    }, [
        commands
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eUqFw.useEffect)(()=>subscribe(registrationId, commandCache.current), [
        ...dependencies,
        subscribe
    ]);
}

});
parcelRegister("7Xm2s", function(module, exports) {

$parcel$export(module.exports, "useSubscribeCommandsWithRegistry", () => $ed5a0599e1840fb5$export$880fc01e31710b27);

var $eUqFw = parcelRequire("eUqFw");

var $gCtL7 = parcelRequire("gCtL7");
function $ed5a0599e1840fb5$export$880fc01e31710b27() {
    const { addCommands: addCommands, removeCommands: removeCommands, updateActiveRegistry: updateActiveRegistry, removeFromActiveRegistry: removeFromActiveRegistry } = (0, $gCtL7.useActionsCommandPalette)();
    const subscribe = (0, $eUqFw.useCallback)((registrationId, commands)=>{
        updateActiveRegistry(registrationId, commands);
        addCommands(commands);
        return ()=>{
            removeCommands(commands);
            removeFromActiveRegistry(registrationId, commands);
        };
    }, [
        addCommands,
        removeCommands,
        removeFromActiveRegistry,
        updateActiveRegistry
    ]);
    return subscribe;
}

});
parcelRegister("gCtL7", function(module, exports) {

$parcel$export(module.exports, "useCommandPalette", () => $9139bfe8dcd2ea64$export$6b58f9610017fbb7);
$parcel$export(module.exports, "useActionsCommandPalette", () => $9139bfe8dcd2ea64$export$72aa7bc7c6a83c36);
$parcel$export(module.exports, "useCommandPaletteAnalyticsAttributes", () => $9139bfe8dcd2ea64$export$1f90c8f89f98110e);
$parcel$export(module.exports, "useCommandPaletteIsOpen", () => $9139bfe8dcd2ea64$export$cc979be9b69236df);
$parcel$export(module.exports, "useCommandPaletteIsLoaded", () => $9139bfe8dcd2ea64$export$af8fd8cd4b048315);
$parcel$export(module.exports, "useCommandPaletteSessionId", () => $9139bfe8dcd2ea64$export$7422170a403e909);
$parcel$export(module.exports, "useCommandPaletteExpandedCommand", () => $9139bfe8dcd2ea64$export$282aa48e4a3afada);
$parcel$export(module.exports, "useCommandPaletteSearch", () => $9139bfe8dcd2ea64$export$96819dfb22ad05d3);
$parcel$export(module.exports, "useCommandPaletteRegistryCurrentAttribution", () => $9139bfe8dcd2ea64$export$f893891deedab3c6);
$parcel$export(module.exports, "useCommandPaletteUsePerformModeState", () => $9139bfe8dcd2ea64$export$bbc05723eb144e03);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $bj4JM = parcelRequire("bj4JM");
var $a61MH = parcelRequire("a61MH");

var $1ybV0 = parcelRequire("1ybV0");

var $8FbYY = parcelRequire("8FbYY");

var $li0m0 = parcelRequire("li0m0");
const $9139bfe8dcd2ea64$var$initialState = {
    commandPaletteSessionId: '',
    isOpen: false,
    isLoaded: false,
    search: '',
    activeIndex: 0,
    isSearchFieldFocused: false,
    commands: [],
    parentCommand: [],
    sections: [],
    isDisabled: false,
    registry: {},
    activeRegistry: {
        commandRegistry: {},
        registryIds: []
    },
    onClosePendingCommandAction: undefined,
    isLoadChildrenError: false
};
const $9139bfe8dcd2ea64$var$store = (0, $a61MH.createStore)({
    initialState: $9139bfe8dcd2ea64$var$initialState,
    actions: $li0m0.actions,
    name: 'commandPalette'
});
const $9139bfe8dcd2ea64$export$6b58f9610017fbb7 = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store);
const $9139bfe8dcd2ea64$export$72aa7bc7c6a83c36 = (0, $ggKAj.createActionsHook)($9139bfe8dcd2ea64$var$store);
const $9139bfe8dcd2ea64$export$e144a44b650635f4 = (ComponentToRender)=>(props)=>{
        const commandPalette = $9139bfe8dcd2ea64$export$6b58f9610017fbb7();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentToRender, {
            ...props,
            commandPalette: commandPalette
        });
    };
const $9139bfe8dcd2ea64$export$56f06313122d0aac = ({ search: search, commandPaletteSessionId: commandPaletteSessionId, expandedCommand: expandedCommand, registry: registry, activeRegistry: activeRegistry })=>({
        wordCount: (0, $8FbYY.getWordCount)(search),
        queryLength: search.length,
        queryHash: (0, $8FbYY.getQueryHash)(search),
        commandPaletteSessionId: commandPaletteSessionId,
        cpMenu: expandedCommand?.id || 'rootMenu',
        ...(0, $8FbYY.getExpandedCommandRegistryAnalytics)(registry, activeRegistry, expandedCommand?.id) || {},
        activeRegistryIds: activeRegistry.registryIds,
        activeRegistryIdsLength: activeRegistry.registryIds.length,
        activeRegistryCommandsLength: Object.keys(activeRegistry.commandRegistry).length,
        ...(0, $1ybV0.ff)('compal.search-algorithm-analytics') ? {
            relevancyModel: 'v2-string-similarity'
        } : {}
    });
const $9139bfe8dcd2ea64$export$1f90c8f89f98110e = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: $9139bfe8dcd2ea64$export$56f06313122d0aac
});
const $9139bfe8dcd2ea64$export$cc979be9b69236df = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ isOpen: isOpen })=>({
            isOpen: isOpen
        })
});
const $9139bfe8dcd2ea64$export$af8fd8cd4b048315 = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ isLoaded: isLoaded })=>({
            isLoaded: isLoaded
        })
});
const $9139bfe8dcd2ea64$export$4372697329bd9cbe = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ isDisabled: isDisabled })=>({
            isDisabled: isDisabled
        })
});
const $9139bfe8dcd2ea64$export$7422170a403e909 = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ commandPaletteSessionId: commandPaletteSessionId })=>({
            commandPaletteSessionId: commandPaletteSessionId
        })
});
const $9139bfe8dcd2ea64$export$282aa48e4a3afada = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ expandedCommand: expandedCommand, isOpen: isOpen })=>({
            expandedCommand: expandedCommand,
            isOpen: isOpen
        })
});
const $9139bfe8dcd2ea64$export$96819dfb22ad05d3 = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ search: search })=>({
            search: search
        })
});
const $9139bfe8dcd2ea64$export$a40e8ae3e53feab0 = (0, $bj4JM.createSelector)(({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>({
        registry: registry,
        activeRegistry: activeRegistry,
        expandedCommand: expandedCommand
    }), ()=>undefined, ({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>{
    if (!expandedCommand) return undefined;
    const registryData = (0, $8FbYY.getRegistryData)(registry, activeRegistry, expandedCommand.id);
    return {
        registryData: registryData,
        analyticsAttributes: registryData
    };
});
const $9139bfe8dcd2ea64$export$f893891deedab3c6 = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: $9139bfe8dcd2ea64$export$a40e8ae3e53feab0
});
const $9139bfe8dcd2ea64$export$bbc05723eb144e03 = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ commands: commands, search: search, expandedCommand: expandedCommand, childResult: childResult, registry: registry, activeRegistry: activeRegistry })=>({
            commands: commands,
            search: search,
            expandedCommand: expandedCommand,
            childResult: childResult,
            registry: registry,
            activeRegistry: activeRegistry
        })
});

});
parcelRegister("8FbYY", function(module, exports) {

$parcel$export(module.exports, "getRegistryData", () => $faf99007a5829b26$export$6a1ed481c04a3ae6);
$parcel$export(module.exports, "getExpandedCommandRegistryAnalytics", () => $faf99007a5829b26$export$eb055284806da6e5);
$parcel$export(module.exports, "getShortcutSpecialCharacters", () => $faf99007a5829b26$export$e6994b845b967732);
$parcel$export(module.exports, "removeShortcutSpecialCharacters", () => $faf99007a5829b26$export$cd2a5827eae5f4cf);
$parcel$export(module.exports, "mergeSections", () => $faf99007a5829b26$export$389b0273703d5c48);
$parcel$export(module.exports, "mergeChildResults", () => $faf99007a5829b26$export$60a91e1b94ab4fef);
$parcel$export(module.exports, "getAnalyticsAttributesFromState", () => $faf99007a5829b26$export$4023cd53e5e5fcb8);
$parcel$export(module.exports, "isSecondaryTrigger", () => $faf99007a5829b26$export$daa5beabdf8d9fc3);
$parcel$export(module.exports, "hasChildren", () => $faf99007a5829b26$export$bd5ff50f0e53d41c);
$parcel$export(module.exports, "getAnalyticsAttributesFromResult", () => $faf99007a5829b26$export$bc9cd28438b3ea4b);
$parcel$export(module.exports, "getQueryHash", () => $faf99007a5829b26$export$fa1c95a5ffa92036);
$parcel$export(module.exports, "getWordCount", () => $faf99007a5829b26$export$dba3e2bcdbd49da4);
$parcel$export(module.exports, "getCommandAction", () => $faf99007a5829b26$export$fb6dafa07e60c21a);
$parcel$export(module.exports, "hasAction", () => $faf99007a5829b26$export$e217e69099d082f5);
$parcel$export(module.exports, "useSetTimeoutAutoClear", () => $faf99007a5829b26$export$c3d20e8c1e93a572);

var $eUqFw = parcelRequire("eUqFw");

var $3IRl5 = parcelRequire("3IRl5");

var $igOBb = parcelRequire("igOBb");

var $ftpwV = parcelRequire("ftpwV");

var $6jiFZ = parcelRequire("6jiFZ");
const $faf99007a5829b26$export$6a1ed481c04a3ae6 = (registry, activeRegistry, commandId)=>{
    if (!commandId) return undefined;
    const activeCommandRegistryData = activeRegistry?.commandRegistry?.[commandId];
    const registryData = activeCommandRegistryData?.registryId ? registry[activeCommandRegistryData?.registryId] : undefined;
    return registryData;
};
const $faf99007a5829b26$export$eb055284806da6e5 = (registry, activeRegistry, commandId)=>$faf99007a5829b26$export$6a1ed481c04a3ae6(registry, activeRegistry, commandId);
const $faf99007a5829b26$export$8af60a6897157f84 = (registry, activeRegistry, parentCommands)=>{
    const parentCommandIds = parentCommands?.map((command)=>command.id);
    while(parentCommandIds?.length){
        const nextParentCommandId = parentCommandIds?.pop();
        const registryData = $faf99007a5829b26$export$6a1ed481c04a3ae6(registry, activeRegistry, nextParentCommandId);
        if (registryData) return registryData;
    }
    return undefined;
};
const $faf99007a5829b26$export$e6994b845b967732 = ()=>[
        {
            char: ' ',
            replacement: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).THEN
        },
        {
            char: '+',
            replacement: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).PLUS
        },
        {
            char: '|',
            replacement: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).OR
        }
    ];
const $faf99007a5829b26$export$cd2a5827eae5f4cf = (shortcut)=>{
    const specialChars = $faf99007a5829b26$export$e6994b845b967732();
    let strippedShortcut = shortcut;
    specialChars.forEach(({ char: char })=>{
        strippedShortcut = strippedShortcut.split(char).join('');
    });
    return strippedShortcut.toLowerCase();
};
const $faf99007a5829b26$export$389b0273703d5c48 = (sections)=>sections.reduce((acc, curr)=>{
        Object.entries(curr).forEach(([key, entry])=>{
            acc[key] = entry;
        });
        return acc;
    }, {});
const $faf99007a5829b26$export$60a91e1b94ab4fef = (childResults)=>{
    const commands = [];
    const sections = [];
    childResults.forEach((childResult)=>{
        commands.push(...childResult.commands);
        if (childResult.sections) sections.push(childResult.sections);
    });
    return {
        commands: commands,
        sections: $faf99007a5829b26$export$389b0273703d5c48(sections)
    };
};
const $faf99007a5829b26$export$ae8f55d2b67cb8d6 = (text, commonWordsToBeRemoved)=>{
    const commonWords = commonWordsToBeRemoved.toLowerCase().replace(/\s{2,}/g, ' ').trim().split(' ');
    const regexString = commonWords.map((word)=>`\\b${word}\\b`).join('|');
    const regex = new RegExp(regexString, 'g');
    return text.replace(/[.,]/g, '') // remove dot and comma
    .replace(regex, '') // remove common words
    .replace(/\s{2,}/g, ' ') // remove double spaces
    .trim();
};
const $faf99007a5829b26$export$4023cd53e5e5fcb8 = (state, command, method = 'undefined', wasSecondaryTriggered, attributes)=>{
    const analyticsAttributes = {
        commandPaletteId: command.id,
        commandPaletteSessionId: state.commandPaletteSessionId,
        searchTaken: !!state.search,
        method: method,
        cpMenu: 'rootMenu',
        action: command.id,
        actionCategory: 'none',
        wasSecondaryTriggered: wasSecondaryTriggered,
        ...$faf99007a5829b26$export$8af60a6897157f84(state.registry, state.activeRegistry, command.parentCommands) || {},
        ...$faf99007a5829b26$export$6a1ed481c04a3ae6(state.registry, state.activeRegistry, command.id) || {},
        ...$faf99007a5829b26$export$eb055284806da6e5(state.registry, state.activeRegistry, state.expandedCommand?.id) || {},
        ...attributes,
        ...!!command.analytics && command.analytics
    };
    if (state.expandedCommand?.analytics) analyticsAttributes.cpMenu = state.expandedCommand.analytics.action;
    else if (state.expandedCommand?.id) analyticsAttributes.cpMenu = state.expandedCommand.id;
    const sections = state.expandedCommand && state.childResult?.sections ? $faf99007a5829b26$export$389b0273703d5c48([
        ...state.sections,
        state.childResult?.sections
    ]) : $faf99007a5829b26$export$389b0273703d5c48(state.sections);
    const rootCommand = state.parentCommand?.[0] || state.expandedCommand || command;
    const rootSection = rootCommand.section ? sections?.[rootCommand.section] : undefined;
    analyticsAttributes.actionCategory = rootSection?.actionCategory || rootCommand?.section || rootCommand?.analytics?.actionCategory || // Fallback to the original command section
    (command?.section ? sections?.[command?.section]?.actionCategory || command?.section : undefined) || analyticsAttributes.actionCategory;
    return analyticsAttributes;
};
const $faf99007a5829b26$export$daa5beabdf8d9fc3 = (event)=>(0, $igOBb.isMacOs)() ? event.metaKey : event.ctrlKey;
const $faf99007a5829b26$export$bd5ff50f0e53d41c = (command)=>{
    if (command?.wasSecondaryTriggered) {
        if (command?.secondaryAction?.type) {
            const hasSecondaryChildren = (0, $6jiFZ.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.secondaryAction?.type);
            return hasSecondaryChildren;
        }
        // secondary action not defined - fallback to primary
        return (0, $6jiFZ.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
    }
    return (0, $6jiFZ.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
};
const $faf99007a5829b26$export$bc9cd28438b3ea4b = (result)=>{
    if (result) return {
        globalIndex: result.index,
        sectionIndex: result.sectionIndex,
        indexWithinSection: result.indexWithinSection,
        sectionId: result.sectionId
    };
    return {};
};
const $faf99007a5829b26$export$fa1c95a5ffa92036 = (str)=>(0, $3IRl5.createHash)().update(str).digest('hex');
const $faf99007a5829b26$export$dba3e2bcdbd49da4 = (str)=>str.length > 0 ? str.split(/\s+/).length : 0;
const $faf99007a5829b26$export$fb6dafa07e60c21a = (command, wasSecondaryTriggered)=>{
    if (!command) return null;
    const { secondaryAction: secondaryAction, primaryAction: primaryAction } = command;
    if (!primaryAction) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const commandAction = wasSecondaryTriggered && secondaryAction ? secondaryAction : primaryAction;
    return {
        ...commandAction
    };
};
const $faf99007a5829b26$export$e217e69099d082f5 = (command)=>Boolean(command.primaryAction || command.secondaryAction);
const $faf99007a5829b26$export$c3d20e8c1e93a572 = ()=>{
    const timeoutRef = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }, []);
    const setTimeoutAutoClear = (...args)=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(...args);
    };
    return {
        setTimeoutAutoClear: setTimeoutAutoClear
    };
};

});
parcelRegister("igOBb", function(module, exports) {

$parcel$export(module.exports, "isMacOs", () => $a127768fd887ea5b$export$c5e71f489eb3970b);
$parcel$export(module.exports, "getShortcutModifierKey", () => $a127768fd887ea5b$export$fe66dae91c68619b);
const $a127768fd887ea5b$export$c5e71f489eb3970b = ()=>/Mac/i.test(window?.navigator?.platform);
const $a127768fd887ea5b$export$fe66dae91c68619b = ()=>$a127768fd887ea5b$export$c5e71f489eb3970b() ? 'meta' : 'ctrl';

});

parcelRegister("ftpwV", function(module, exports) {

$parcel$export(module.exports, "UI_EVENT_TYPE", () => $48b165edb54974f4$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $48b165edb54974f4$export$947dac6c72b26f81);
$parcel$export(module.exports, "SHORTCUT_ELEMENT_TYPES", () => $48b165edb54974f4$export$1ee9d153576afd13);
// EVENT TYPES
const $48b165edb54974f4$export$a1562d08625f5d7e = 'UI';
const $48b165edb54974f4$export$947dac6c72b26f81 = 'TRACK';
const $48b165edb54974f4$export$f1d537d508d2945a = 'SCREEN';
const $48b165edb54974f4$export$12346a674644c156 = 'OPERATIONAL';
var $48b165edb54974f4$export$1ee9d153576afd13;
(function(SHORTCUT_ELEMENT_TYPES) {
    SHORTCUT_ELEMENT_TYPES["THEN"] = "then";
    SHORTCUT_ELEMENT_TYPES["OR"] = "or";
    SHORTCUT_ELEMENT_TYPES["PLUS"] = "plus";
    SHORTCUT_ELEMENT_TYPES["KEY"] = "key";
})($48b165edb54974f4$export$1ee9d153576afd13 || ($48b165edb54974f4$export$1ee9d153576afd13 = {}));

});


parcelRegister("li0m0", function(module, exports) {

$parcel$export(module.exports, "actions", () => $476b965ceb7c28b6$export$e324594224ef24da);

var $MdoH4 = parcelRequire("MdoH4");

var $hompL = parcelRequire("hompL");

var $igOBb = parcelRequire("igOBb");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $9lcOH = parcelRequire("9lcOH");

var $duQ8C = parcelRequire("duQ8C");

var $ftpwV = parcelRequire("ftpwV");

var $6jiFZ = parcelRequire("6jiFZ");

var $8FbYY = parcelRequire("8FbYY");

var $gklnd = parcelRequire("gklnd");

var $2fkzb = parcelRequire("2fkzb");
const $476b965ceb7c28b6$var$rootCommands = {
    parentCommand: [],
    expandedCommand: undefined,
    childCommands: undefined,
    childResult: undefined
};
const $476b965ceb7c28b6$var$open = ()=>({ setState: setState, getState: getState })=>{
        if (getState().isDisabled) return;
        setState({
            commandPaletteSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
            isOpen: true,
            activeIndex: 0,
            search: ''
        });
    };
const $476b965ceb7c28b6$var$close = ()=>({ setState: setState })=>{
        setState({
            isOpen: false,
            commandPaletteSessionId: '',
            search: '',
            ...$476b965ceb7c28b6$var$rootCommands
        });
    };
const $476b965ceb7c28b6$var$toggle = ()=>({ setState: setState, getState: getState })=>{
        const isOpen = !getState().isOpen;
        setState({
            isOpen: isOpen,
            activeIndex: 0,
            search: '',
            commandPaletteSessionId: isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4() : '',
            ...!isOpen ? $476b965ceb7c28b6$var$rootCommands : {}
        });
    };
const $476b965ceb7c28b6$var$addCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newCommands = currentState.commands.concat(commands);
        const newState = {
            commands: newCommands
        };
        if (currentState.expandedCommand) {
            const matchedExpandedCommand = commands.filter((command)=>command.id === currentState.expandedCommand?.id);
            if (matchedExpandedCommand.length === 1) {
                const [updatedExpandedCommand] = matchedExpandedCommand;
                newState.expandedCommand = updatedExpandedCommand;
            }
        }
        setState(newState);
    };
const $476b965ceb7c28b6$var$removeCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commands.includes(command));
        setState({
            commands: newCommands
        });
    };
const $476b965ceb7c28b6$var$removeCommandsById = (commandIds)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commandIds.includes(command.id));
        setState({
            commands: newCommands
        });
    };
const $476b965ceb7c28b6$var$handleSearch = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            activeIndex: 0
        });
    };
const $476b965ceb7c28b6$var$goBackLevel = (goToRoot, analytics)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!currentState.expandedCommand) return;
        const newState = {
            search: '',
            activeIndex: 0,
            childResult: undefined,
            forceSearchFocus: true
        };
        if (currentState.parentCommand.length && !goToRoot) {
            newState.expandedCommand = currentState.parentCommand[currentState.parentCommand.length - 1];
            newState.parentCommand = currentState.parentCommand.slice(0, currentState.parentCommand.length - 1);
            if (newState.expandedCommand?.primaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST && newState.expandedCommand?.primaryAction?.commands) newState.childResult = {
                commands: newState.expandedCommand?.primaryAction?.commands,
                sections: newState.expandedCommand?.primaryAction?.sections
            };
        } else {
            newState.loadingList = false;
            newState.parentCommand = [];
            newState.expandedCommand = undefined;
            newState.childResult = undefined;
        }
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) currentState.onAnalytics(analytics.createAnalyticsEvent({
            action: 'navigation',
            actionSubject: 'commandPalette'
        }), (0, $ftpwV.TRACK_EVENT_TYPE), {
            attributes: {
                cpMenu: currentState.expandedCommand?.id || 'rootMenu',
                searchSessionId: currentState.commandPaletteSessionId,
                action: goToRoot ? 'backToRoot' : 'backToParent',
                actionCategory: 'back',
                method: analytics?.method
            }
        });
        setState(newState);
    };
// Once search input is focused, forceSearchFocus can go back to false
const $476b965ceb7c28b6$var$forceFocusSearch = (forceSearchFocus = false)=>({ setState: setState })=>{
        setState({
            forceSearchFocus: forceSearchFocus
        });
    };
const $476b965ceb7c28b6$var$setActiveIndex = (index)=>({ setState: setState, getState: getState })=>{
        const { isSearchFieldFocused: isSearchFieldFocused } = getState();
        setState({
            activeIndex: index,
            ...!isSearchFieldFocused ? {
                forceSearchFocus: true
            } : {}
        });
    };
const $476b965ceb7c28b6$var$getAnalyticsAttributes = (command, method, wasSecondaryTriggered = false, attributes = {})=>({ getState: getState })=>(0, $8FbYY.getAnalyticsAttributesFromState)(getState(), command, method, wasSecondaryTriggered, attributes);
const $476b965ceb7c28b6$var$performDialogCloseCommand = ()=>({ setState: setState, getState: getState })=>{
        // Timeout applied to ensure that this happens after react-focus-lock is shut down
        // react-focus-lock also has a timeout before it stops listening for focus events
        // tl;dr If you don't add this timeout, cypress gets sad (and probably some actual users too but I've never repro'd it manually)
        setTimeout(()=>{
            const { onClosePendingCommandAction: onClosePendingCommandAction, onAnalytics: onAnalytics } = getState();
            if (onClosePendingCommandAction !== undefined) {
                try {
                    (0, $duQ8C.default)('command-palette-executed');
                    onClosePendingCommandAction.perform();
                    if ((0, $1ybV0.ff)('compal-task-success-event') && onAnalytics && onClosePendingCommandAction?.createAnalyticsEvent) {
                        const performAnalyticsEvent = onClosePendingCommandAction?.createAnalyticsEvent({
                            action: 'taskSucceeded',
                            actionSubject: 'commandPalette'
                        });
                        onAnalytics(performAnalyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                            attributes: onClosePendingCommandAction?.analyticsArgs
                        });
                    }
                } catch (err) {
                    const error = err instanceof Error ? err : new Error('Command palette perform error');
                    (0, $guiFP.default)({
                        error: error,
                        meta: {
                            id: 'compal.performDialogCloseCommand',
                            packageName: 'jiraCommandPalette',
                            teamName: typeof onClosePendingCommandAction?.analyticsArgs?.teamName === 'string' ? onClosePendingCommandAction?.analyticsArgs.teamName : 'deliveroo'
                        },
                        attributes: onClosePendingCommandAction.analyticsArgs
                    });
                    (0, $9lcOH.setInteractionError)('command-palette-executed', {
                        errorMessage: error.message,
                        name: 'performDialogCloseCommandPerformError'
                    });
                }
                setState({
                    onClosePendingCommandAction: undefined
                });
            }
        }, 0);
    };
const $476b965ceb7c28b6$var$executeCommand = (command, analytics, wasSecondaryTriggered = false)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newState = {
            ...!(0, $gklnd.getActiveCommandList)(command, wasSecondaryTriggered)?.keepSearch && {
                search: ''
            },
            activeIndex: 0
        };
        const analyticsAttributes = (0, $8FbYY.getAnalyticsAttributesFromState)(currentState, command, analytics?.method || 'undefined', wasSecondaryTriggered, analytics?.attributes);
        const currentCommandAction = (0, $8FbYY.getCommandAction)(command, wasSecondaryTriggered);
        if (!currentCommandAction) return;
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) {
            const analyticsEvent = analytics.createAnalyticsEvent({
                action: 'navigation',
                actionSubject: 'commandPalette'
            });
            currentState.onAnalytics(analyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                attributes: analyticsAttributes
            });
        }
        const shouldLoadChildren = (0, $8FbYY.hasChildren)({
            ...command,
            wasSecondaryTriggered: wasSecondaryTriggered
        });
        const shouldExecutePerform = currentCommandAction?.type === (0, $6jiFZ.CommandActionType).PERFORM;
        if (shouldLoadChildren) {
            (0, $duQ8C.default)('command-palette-load-child-command-list');
            if (currentState.expandedCommand) newState.parentCommand = [
                ...currentState.parentCommand,
                currentState.expandedCommand
            ];
            newState.expandedCommand = {
                ...command,
                wasSecondaryTriggered: wasSecondaryTriggered
            };
            newState.childResult = undefined;
            newState.forceSearchFocus = true;
            if ((0, $2fkzb.isSearchableChildrenAction)(currentCommandAction)) {
                newState.childResult = {
                    commands: currentCommandAction.commands,
                    sections: currentCommandAction.sections
                };
                if (command.parentCommands?.length) newState.parentCommand = [
                    ...newState.parentCommand || [],
                    ...command.parentCommands
                ];
            } else newState.childResult = undefined;
            setState(newState);
            if ((0, $1ybV0.ff)('compal-issue-actions-very-high-priority_f5w5r')) {
                if (currentCommandAction.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST && currentCommandAction.onClick) currentCommandAction.onClick();
            }
        } else if (shouldExecutePerform) {
            if (!currentCommandAction.preventModalClose) {
                newState.commandPaletteSessionId = '';
                newState.isOpen = false;
                newState.expandedCommand = undefined;
                newState.parentCommand = [];
                newState.childResult = undefined;
                setState(newState);
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'closed',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(closeAnalyticsEvent, (0, $ftpwV.UI_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            }
            if (wasSecondaryTriggered && currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                    action: 'secondaryAction',
                    actionSubject: 'commandPalette'
                });
                currentState.onAnalytics(closeAnalyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                    attributes: {
                        ...analyticsAttributes,
                        keyPressed: (0, $igOBb.isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                        ...currentCommandAction.analyticsArgs
                    }
                });
            }
            // If not closing dialog, execute immediately, otherwise cue for after dialog is closed
            if (currentCommandAction.preventModalClose) try {
                (0, $duQ8C.default)('command-palette-executed');
                currentCommandAction.perform();
                if ((0, $1ybV0.ff)('compal-task-success-event') && currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const performAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'taskSucceeded',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(performAnalyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            } catch (err) {
                const error = err instanceof Error ? err : new Error('Command palette perform error');
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'compal.executeCommand',
                        packageName: 'jiraCommandPalette',
                        teamName: typeof analytics?.attributes?.teamName === 'string' ? analytics?.attributes.teamName : 'deliveroo'
                    },
                    attributes: analytics?.attributes
                });
                (0, $9lcOH.setInteractionError)('command-palette-executed', {
                    errorMessage: error.message,
                    name: 'executeCommandPerformError'
                });
            }
            else setState({
                onClosePendingCommandAction: {
                    ...currentCommandAction,
                    analyticsArgs: (0, $1ybV0.ff)('compal-task-success-event') ? analyticsAttributes : analytics?.attributes,
                    ...(0, $1ybV0.ff)('compal-task-success-event') && {
                        createAnalyticsEvent: analytics?.createAnalyticsEvent
                    }
                }
            });
        }
    };
const $476b965ceb7c28b6$var$setChildCommands = (childResult)=>({ setState: setState })=>{
        setState({
            childResult: childResult
        });
    };
const $476b965ceb7c28b6$var$setLoadingList = (loadingList)=>({ setState: setState })=>{
        setState({
            loadingList: loadingList
        });
    };
const $476b965ceb7c28b6$var$setFocusInput = (isSearchFieldFocused)=>({ setState: setState })=>setState({
            isSearchFieldFocused: isSearchFieldFocused
        });
const $476b965ceb7c28b6$var$registerSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.slice(0);
        sections.push(newSections);
        setState({
            sections: sections
        });
    };
const $476b965ceb7c28b6$var$unregisterSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.filter((section)=>section !== newSections);
        setState({
            sections: sections
        });
    };
const $476b965ceb7c28b6$var$markAsLoaded = ()=>({ setState: setState })=>{
        setState({
            isLoaded: true
        });
    };
const $476b965ceb7c28b6$var$setIsDisabled = (isDisabled)=>({ setState: setState })=>{
        setState({
            isDisabled: isDisabled,
            ...isDisabled ? {
                isOpen: false
            } : {}
        });
    };
const $476b965ceb7c28b6$var$setRegistry = (registry)=>({ setState: setState })=>{
        setState({
            registry: registry
        });
    };
const $476b965ceb7c28b6$var$updateActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const activeRegistry = {
            commandRegistry: {
                ...currentActiveRegistry.commandRegistry,
                ...commands.reduce((acc, command)=>{
                    acc[command.id] = {
                        registryId: registryId
                    };
                    return acc;
                }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {})
            },
            registryIds: (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))([
                ...currentActiveRegistry.registryIds,
                registryId
            ])
        };
        setState({
            activeRegistry: activeRegistry
        });
    };
const $476b965ceb7c28b6$var$removeFromActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const commandRegistry = {
            ...currentActiveRegistry.commandRegistry
        };
        commands.forEach((command)=>{
            delete commandRegistry[command.id];
        });
        setState({
            activeRegistry: {
                commandRegistry: commandRegistry,
                registryIds: currentActiveRegistry.registryIds.filter((id)=>id !== registryId)
            }
        });
    };
const $476b965ceb7c28b6$var$setAnalytics = (onAnalytics, onErrorAnalytics)=>({ setState: setState })=>{
        setState({
            onAnalytics: onAnalytics,
            onErrorAnalytics: onErrorAnalytics
        });
    };
const $476b965ceb7c28b6$var$setFallbackOverride = (fallbackOverride)=>({ setState: setState })=>{
        setState({
            fallbackOverride: fallbackOverride
        });
    };
const $476b965ceb7c28b6$export$e324594224ef24da = {
    open: $476b965ceb7c28b6$var$open,
    toggle: $476b965ceb7c28b6$var$toggle,
    close: $476b965ceb7c28b6$var$close,
    addCommands: $476b965ceb7c28b6$var$addCommands,
    removeCommands: $476b965ceb7c28b6$var$removeCommands,
    handleSearch: $476b965ceb7c28b6$var$handleSearch,
    forceFocusSearch: $476b965ceb7c28b6$var$forceFocusSearch,
    setActiveIndex: $476b965ceb7c28b6$var$setActiveIndex,
    executeCommand: $476b965ceb7c28b6$var$executeCommand,
    goBackLevel: $476b965ceb7c28b6$var$goBackLevel,
    setChildCommands: $476b965ceb7c28b6$var$setChildCommands,
    setLoadingList: $476b965ceb7c28b6$var$setLoadingList,
    setFocusInput: $476b965ceb7c28b6$var$setFocusInput,
    registerSections: $476b965ceb7c28b6$var$registerSections,
    unregisterSections: $476b965ceb7c28b6$var$unregisterSections,
    markAsLoaded: $476b965ceb7c28b6$var$markAsLoaded,
    getAnalyticsAttributes: $476b965ceb7c28b6$var$getAnalyticsAttributes,
    setIsDisabled: $476b965ceb7c28b6$var$setIsDisabled,
    setRegistry: $476b965ceb7c28b6$var$setRegistry,
    updateActiveRegistry: $476b965ceb7c28b6$var$updateActiveRegistry,
    removeCommandsById: $476b965ceb7c28b6$var$removeCommandsById,
    removeFromActiveRegistry: $476b965ceb7c28b6$var$removeFromActiveRegistry,
    performDialogCloseCommand: $476b965ceb7c28b6$var$performDialogCloseCommand,
    setAnalytics: $476b965ceb7c28b6$var$setAnalytics,
    setFallbackOverride: $476b965ceb7c28b6$var$setFallbackOverride
};

});
parcelRegister("gklnd", function(module, exports) {

$parcel$export(module.exports, "getActiveCommandList", () => $b93b5138b1f374a6$export$639b7f41b0b47a01);

var $6jiFZ = parcelRequire("6jiFZ");
const $b93b5138b1f374a6$export$639b7f41b0b47a01 = (expandedCommand, wasSecondaryTriggered)=>{
    if (wasSecondaryTriggered && expandedCommand?.secondaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST) return expandedCommand.secondaryAction;
    if (!wasSecondaryTriggered && expandedCommand?.primaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST) return expandedCommand.primaryAction;
    return null;
};

});

parcelRegister("2fkzb", function(module, exports) {

$parcel$export(module.exports, "isSearchableChildrenAction", () => $20c016b992336e05$export$d75616d77443fe4e);

var $6jiFZ = parcelRequire("6jiFZ");
const $20c016b992336e05$export$d75616d77443fe4e = (action)=>action?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST && action.commands !== undefined;

});







parcelRegister("9aFSa", function(module, exports) {

$parcel$export(module.exports, "default", () => $80173688b586a9b5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7Q1yP = parcelRequire("7Q1yP");

var $cIhGE = parcelRequire("cIhGE");

var $haeC1 = parcelRequire("haeC1");

var $fVFUy = parcelRequire("fVFUy");

var $kGQen = parcelRequire("kGQen");

var $h80SI = parcelRequire("h80SI");
let $80173688b586a9b5$var$shortcutsCount = 0;
let $80173688b586a9b5$var$subscription = null;
const $80173688b586a9b5$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
    const parentRegistry = (0, $eUqFw.useContext)((0, $kGQen.ShortcutRegistryContext)) || (0, $fVFUy.rootRegistry);
    const addKeyMap = (0, $eUqFw.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                keyMap: (0, $h80SI.bindKeyMapWithErrorHandling)(keyMap, location),
                label: label
            })), [
        label,
        parentRegistry,
        keyMap,
        location
    ]);
    (0, $eUqFw.useEffect)(()=>{
        $80173688b586a9b5$var$shortcutsCount += 1;
        const removeKeyMap = addKeyMap();
        return ()=>{
            removeKeyMap();
            $80173688b586a9b5$var$shortcutsCount -= 1;
            if ($80173688b586a9b5$var$subscription && $80173688b586a9b5$var$shortcutsCount === 0) {
                $80173688b586a9b5$var$subscription.unsubscribe();
                $80173688b586a9b5$var$subscription = null;
            }
        };
    }, [
        addKeyMap
    ]);
    (0, $eUqFw.useEffect)(()=>{
        $80173688b586a9b5$var$subscription = $80173688b586a9b5$var$subscription || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $cIhGE.default)().subscribe((0, $haeC1.default));
    }, [
        parentRegistry,
        keyMap
    ]);
    return null;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$80173688b586a9b5$export$2e2bcd8739ae039 = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, $7Q1yP.useKeyboardShortcutsToggle), ...props })=>{
    const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
    return isEnabled && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($80173688b586a9b5$var$ShortcutsSubscriber, props) : null;
};

});
parcelRegister("7Q1yP", function(module, exports) {

$parcel$export(module.exports, "useKeyboardShortcutsToggle", () => $e8e091cfd61e9197$export$a33a81f1fc5458ad);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $6rW04 = parcelRequire("6rW04");

var $jMP2a = parcelRequire("jMP2a");
const $e8e091cfd61e9197$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
const $e8e091cfd61e9197$export$b62f67be35e65859 = (baseUrl, analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState().isEnabled;
        const status = currentState ? 'off' : 'on';
        const url = `${$e8e091cfd61e9197$var$URL_FRAGMENT}${status}`;
        try {
            await (0, $lRmyA.performPutRequest)(url);
            setState({
                isEnabled: !currentState,
                error: null
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                isEnabled: !currentState
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'keyboardShortcutToggleFailure',
                    // eslint-disable-next-line jira/js/package-name-enforcer-for-error-analytics
                    packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                },
                error: err
            });
        }
    };
const $e8e091cfd61e9197$var$Store = (0, $a61MH.createStore)({
    initialState: {
        isEnabled: false ? false : !((0, $6rW04.default)('ajs-keyboard-shortcuts-enabled') === 'false'),
        error: null
    },
    actions: {
        // @ts-expect-error - TS2322 - Type '(baseUrl: string, analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>' is not assignable to type 'ActionThunk<{ isEnabled: boolean; error: null; }, { toggle: (baseUrl: string, analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>; }>'.
        toggle: $e8e091cfd61e9197$export$b62f67be35e65859
    }
});
const $e8e091cfd61e9197$export$a33a81f1fc5458ad = (0, $ggKAj.createHook)($e8e091cfd61e9197$var$Store);
const $e8e091cfd61e9197$export$a0308f0e05568f25 = (0, $dYfll.createSubscriber)($e8e091cfd61e9197$var$Store);

});

parcelRegister("cIhGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $61e80b5974f2eb64$export$2e2bcd8739ae039);
$parcel$export(module.exports, "flush", () => $61e80b5974f2eb64$export$4909b86c8034bf73);
/**
 * An observable that emits key sequences as a string representation
 *
 * Examples:
 *
 * g i
 * shift+enter
 */ 
var $3JafE = parcelRequire("3JafE");

var $70s4u = parcelRequire("70s4u");
parcelRequire("fRdoC");
parcelRequire("5dKXv");
parcelRequire("8OtG5");
parcelRequire("fWv6o");
parcelRequire("flmol");
parcelRequire("7Rus6");
parcelRequire("azOPD");
parcelRequire("1d9Hc");

var $1YqdI = parcelRequire("1YqdI");
const $61e80b5974f2eb64$var$ignoredKeys = {
    Control: true,
    Meta: true,
    Shift: true,
    Alt: true,
    AltGraph: true,
    CapsLock: true,
    Fn: true,
    FnLock: true,
    Hyper: true,
    NumLock: true,
    OS: true,
    ScrollLock: true,
    Super: true,
    Symbol: true,
    SymbolLock: true
};
/**
 * Skipping few input types to allow keydown event propagation to it's parent element
 * inputMode - react-select or select or combo
 * type - skipping these inputtypes (checkbox, radio) to support shortcuts like
 *        e(EPIC panel) or v(VERSION panel) or n(board card selection) in board and backlog
 * This condition added as a part of https://a11y.atlassian.net/browse/JCA11Y-1317
 */ const $61e80b5974f2eb64$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $61e80b5974f2eb64$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$61e80b5974f2eb64$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $61e80b5974f2eb64$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly Control: true; readonly Meta: true; readonly Shift: true; readonly Alt: true; readonly AltGraph: true; readonly CapsLock: true; readonly Fn: true; readonly FnLock: true; readonly Hyper: true; ... 5 more ...; readonly SymbolLock: true; }'.
    (e.key === 'Escape' || !$61e80b5974f2eb64$var$isEditable(e.target) && !$61e80b5974f2eb64$var$ignoredKeys[e.key]);
const $61e80b5974f2eb64$export$25d1b8252b4c49b7 = ()=>{
    const elBlankets = document.querySelectorAll('.aui-blanket');
    if (elBlankets.length === 0) // no aui-blanket in DOM, so it means it's closed
    return true;
    const isAllHidden = Array.from(elBlankets || []).every((el)=>{
        if (el.getAttribute('aria-hidden') === 'true' || // when `el.getAttribute('hidden')` returns an empty string, it means the element has the `hidden` attribute and it's invisible.
        el.getAttribute('hidden') !== null) return true;
        return false;
    });
    return isAllHidden;
};
let $61e80b5974f2eb64$var$key$;
const $61e80b5974f2eb64$var$flush$ = new (0, $70s4u.Subject)();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$61e80b5974f2eb64$export$2e2bcd8739ae039 = ()=>{
    if (!$61e80b5974f2eb64$var$key$) {
        $61e80b5974f2eb64$var$key$ = false ? new (0, $70s4u.Subject)() : (0, $3JafE.Observable).fromEvent(document, 'keydown').filter($61e80b5974f2eb64$var$isRelevantKeyEvent).filter($61e80b5974f2eb64$export$25d1b8252b4c49b7).map((0, $1YqdI.toKeyWithModifiers));
        const sequence$ = $61e80b5974f2eb64$var$key$.scan((seq, key)=>{
            if (!key || !seq) return undefined;
            return {
                sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                e: key.e
            };
        });
        $61e80b5974f2eb64$var$key$ = $61e80b5974f2eb64$var$key$.debounceTime(1000).startWith(null).merge($61e80b5974f2eb64$var$flush$).switchMapTo(sequence$);
    }
    return $61e80b5974f2eb64$var$key$;
};
const $61e80b5974f2eb64$export$4909b86c8034bf73 = ()=>{
    $61e80b5974f2eb64$var$flush$.next();
};

});
parcelRegister("1YqdI", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $1b99fa3356e664b3$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $1b99fa3356e664b3$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $1b99fa3356e664b3$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $1b99fa3356e664b3$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $1b99fa3356e664b3$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $1b99fa3356e664b3$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $1b99fa3356e664b3$var$toKey = (e)=>{
    if ($1b99fa3356e664b3$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $1b99fa3356e664b3$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $1b99fa3356e664b3$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($1b99fa3356e664b3$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $1b99fa3356e664b3$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $1b99fa3356e664b3$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$1b99fa3356e664b3$var$orSpecialChars}))))?(meta\\+)?(${$1b99fa3356e664b3$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $1b99fa3356e664b3$var$shortcutRegex = RegExp(`^${$1b99fa3356e664b3$var$singleShortcutEntry}( ${$1b99fa3356e664b3$var$singleShortcutEntry})*$`);
const $1b99fa3356e664b3$export$8e231506c5580162 = (shortcut)=>$1b99fa3356e664b3$var$shortcutRegex.test(shortcut);
const $1b99fa3356e664b3$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});


parcelRegister("haeC1", function(module, exports) {

$parcel$export(module.exports, "default", () => $44bf9c8ab51bd76c$export$2e2bcd8739ae039);

var $cIhGE = parcelRequire("cIhGE");

var $fVFUy = parcelRequire("fVFUy");
const $44bf9c8ab51bd76c$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
var /**
 * Manages key sequence inputs to execute predefined actions or clear unmatched sequences. This function ensures efficient handling of user inputs by checking against existing sequences and preparing for potential future matches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$44bf9c8ab51bd76c$export$2e2bcd8739ae039 = (keySequence)=>{
    const { sequence: sequence, e: e } = keySequence || {};
    const activeKeyMap = (0, $fVFUy.rootRegistry).getActiveKeyMap();
    if (sequence !== undefined && activeKeyMap[sequence]) {
        activeKeyMap[sequence].callback(e);
        (0, $cIhGE.flush)();
    } else {
        // Are there any sequences that might be activated with more key presses?
        const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($44bf9c8ab51bd76c$var$matches(sequence));
        if (!isFutureMatchPossible) (0, $cIhGE.flush)();
    }
};

});
parcelRegister("fVFUy", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $3843ad0413ec519e$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $3843ad0413ec519e$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $fUTZC = parcelRequire("fUTZC");

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $bFXjh = parcelRequire("bFXjh");

var $1YqdI = parcelRequire("1YqdI");
const $3843ad0413ec519e$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $1YqdI.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $1YqdI.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $1YqdI.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $3843ad0413ec519e$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $3843ad0413ec519e$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$3843ad0413ec519e$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $3843ad0413ec519e$export$1dd4c61d1ce1fa15 = new $3843ad0413ec519e$export$ca1c75b575abf5ff();

});
parcelRegister("bFXjh", function(module, exports) {

var $9eFtX = parcelRequire("9eFtX");

var $49axs = parcelRequire("49axs");
/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */ var $880187c06210b759$var$pull = $9eFtX($49axs);
module.exports = $880187c06210b759$var$pull;

});
parcelRegister("49axs", function(module, exports) {

var $3cvRc = parcelRequire("3cvRc");
/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */ function $30502d761f1085cf$var$pullAll(array, values) {
    return array && array.length && values && values.length ? $3cvRc(array, values) : array;
}
module.exports = $30502d761f1085cf$var$pullAll;

});
parcelRegister("3cvRc", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $jkhuN = parcelRequire("jkhuN");

var $2Rm6I = parcelRequire("2Rm6I");

var $74vSq = parcelRequire("74vSq");

var $b69Sx = parcelRequire("b69Sx");
/** Used for built-in method references. */ var $254b343f3ff82813$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $254b343f3ff82813$var$splice = $254b343f3ff82813$var$arrayProto.splice;
/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */ function $254b343f3ff82813$var$basePullAll(array, values, iteratee, comparator) {
    var indexOf = comparator ? $2Rm6I : $jkhuN, index = -1, length = values.length, seen = array;
    if (array === values) values = $b69Sx(values);
    if (iteratee) seen = $kJvGp(array, $74vSq(iteratee));
    while(++index < length){
        var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
        while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
            if (seen !== array) $254b343f3ff82813$var$splice.call(seen, fromIndex, 1);
            $254b343f3ff82813$var$splice.call(array, fromIndex, 1);
        }
    }
    return array;
}
module.exports = $254b343f3ff82813$var$basePullAll;

});
parcelRegister("2Rm6I", function(module, exports) {
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $2151ae143791d52b$var$baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (comparator(array[index], value)) return index;
    }
    return -1;
}
module.exports = $2151ae143791d52b$var$baseIndexOfWith;

});






parcelRegister("kGQen", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $082205e2100625d8$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $082205e2100625d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVFUy = parcelRequire("fVFUy");
const $082205e2100625d8$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $fVFUy.rootRegistry));
const $082205e2100625d8$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eUqFw.useMemo)(()=>new (0, $fVFUy.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eUqFw.useContext)($082205e2100625d8$export$ebbb59327adb551a) || (0, $fVFUy.rootRegistry);
    (0, $eUqFw.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($082205e2100625d8$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $082205e2100625d8$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : $082205e2100625d8$var$ShortcutScope;

});

parcelRegister("h80SI", function(module, exports) {

$parcel$export(module.exports, "bindKeyMapWithErrorHandling", () => $2297a6a3d8ab933d$export$77477772a9b904da);

var $gUUjF = parcelRequire("gUUjF");
const $2297a6a3d8ab933d$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common')=>(e)=>{
        try {
            callback(e);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
        }
    };
const $2297a6a3d8ab933d$export$77477772a9b904da = (keyMap, location)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(keyMap).reduce((map, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...map,
            [key]: {
                ...keyMap[key],
                callback: $2297a6a3d8ab933d$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location)
            }
        }), {});

});



parcelRegister("gfXKy", function(module, exports) {

$parcel$export(module.exports, "useCommandKeywords", () => $59897234799b31c8$export$4d8fe3ef6385358);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3iBHM = parcelRequire("3iBHM");
const $59897234799b31c8$export$4d8fe3ef6385358 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const getKeywords = (0, $eUqFw.useCallback)((keywordGroup)=>(0, $3iBHM.messages)[keywordGroup] ? formatMessage((0, $3iBHM.messages)[keywordGroup]) : undefined, [
        formatMessage
    ]);
    return {
        getKeywords: getKeywords
    };
};

});
parcelRegister("3iBHM", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2f74b9c3b50ad31d$export$defe85febe8b728c);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $2f74b9c3b50ad31d$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    searchYourIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.search-your-issues-synonyms",
        "defaultMessage": "Find my ideas tickets requests tasks work"
    },
    changeStatusSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.change-status-synonyms",
        "defaultMessage": "Move through workflow  Progress Done Complete transition"
    },
    assignToMeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.assign-to-me-synonyms",
        "defaultMessage": "self"
    },
    assignIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.assign-issue-synonyms",
        "defaultMessage": "Choose person Give work Pick assignee Select ticket idea"
    },
    startWatchingIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.start-watching-issue-synonyms",
        "defaultMessage": "Follow work Track Unwatch Unfollow"
    },
    backlogSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.backlog-synonyms",
        "defaultMessage": "Inventory Go"
    },
    boardSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.board-synonyms",
        "defaultMessage": "Boards Sprint Kanban Swimlanes Do Go"
    },
    reportsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.reports-synonyms",
        "defaultMessage": "Summary Insights Burndown Go"
    },
    timelineSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.timeline-synonyms",
        "defaultMessage": "Plan Work calendar Schedule Overview Delivery Go Roadmap"
    },
    // TODO cleanup isCommandPaletteQuickSearchEnabled
    quickSearchSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.quick-search-synonyms",
        "defaultMessage": "Search products across Atlassian Go to"
    },
    pageSearchSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.page-search-synonyms",
        "defaultMessage": "Control f Command cmd cntrl Go find ctrl"
    },
    createIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.create-issue-synonyms",
        "defaultMessage": "work Start idea New ticket task"
    },
    switchDarkThemeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.switch-dark-theme-synonyms",
        "defaultMessage": "light Darkmode lightmode Change Appearance Colours colors nightmode daymode"
    },
    matchSystemThemeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.match-system-theme-synonyms",
        "defaultMessage": "Sync settings Darkmode lightmode Change Appearance Colours colors nightmode daymode"
    },
    copyCurrentPageUrlSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.copy-current-page-url-synonyms",
        "defaultMessage": "link website address"
    },
    getHelpSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.get-help-synonyms",
        "defaultMessage": "In-product Support Documentation Questions Answers"
    },
    viewKeyboardShortcutsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-keyboard-shortcuts-synonyms",
        "defaultMessage": "Hotkeys Show See"
    },
    editDescriptionSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.edit-description-synonyms",
        "defaultMessage": "Completion criteria Info Information Details Add Write"
    },
    addAttachmentSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-attachment-synonyms",
        "defaultMessage": "Attach Upload Document Media"
    },
    addCommentSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-comment-synonyms",
        "defaultMessage": "Write Message"
    },
    logWorkSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.log-work-synonyms",
        "defaultMessage": "Track Record hours Time spent"
    },
    addRemoveFlagSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-remove-flag-synonyms",
        "defaultMessage": "Unflag Mark Unmark Star Unstar"
    },
    cloneIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.clone-issue-synonyms",
        "defaultMessage": "Copy Duplicate Task Idea Request"
    },
    linkConfluencePageSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.link-confluence-page-synonyms",
        "defaultMessage": "Relate Add Connect"
    },
    addAUrlSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-a-url-synonyms",
        "defaultMessage": "Connect Weblink Link Website Domain"
    },
    goToIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-issues-synonyms",
        "defaultMessage": "Advanced issue search Project Filter JQL search list View all"
    },
    goToPersonalSettingsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-personal-settings-synonyms",
        "defaultMessage": "Preferences Notifications Theme Jira labs"
    },
    goToAccountSettingsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-account-settings-synonyms",
        "defaultMessage": "Preferences Privacy Profile Your details Personal information"
    },
    viewAllIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-issues-synonyms",
        "defaultMessage": "Site issues JQL View all"
    },
    viewAllProjectsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-projects-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllPlansSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-plans-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllBoardsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-boards-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllFiltersSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-filters-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllDashboardsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-dashboards-synonyms",
        "defaultMessage": "List Go"
    },
    checkNotificationsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.check-notifications-synonyms",
        "defaultMessage": "window See Updates"
    },
    goToUserManagementSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-user-management-synonyms",
        "defaultMessage": "Permissions"
    }
});

});


parcelRegister("7xG8t", function(module, exports) {

$parcel$export(module.exports, "default", () => $d21c7a389f4c6f79$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $i528B = parcelRequire("i528B");
var $anpCp = parcelRequire("anpCp");

var $79xbN = parcelRequire("79xbN");

var $g8JvH = parcelRequire("g8JvH");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6Ua7e = parcelRequire("6Ua7e");

var $6WXNs = parcelRequire("6WXNs");
var $eIp1n = parcelRequire("eIp1n");

var $gd0Sp = parcelRequire("gd0Sp");

var $6UBeg = parcelRequire("6UBeg");

var $1Gl68 = parcelRequire("1Gl68");

var $7NnaN = parcelRequire("7NnaN");

var $kovzS = parcelRequire("kovzS");
const $d21c7a389f4c6f79$var$StatelessAssigneeFilterWithAnalytics = (0, $g8JvH.AnalyticsEventToProps)('StatelessAssigneeFilterWithAnalytics', {
    onAddPeopleClick: 'clicked'
})((0, $kovzS.default));
$d21c7a389f4c6f79$var$StatelessAssigneeFilterWithAnalytics.displayName = 'StatelessAssigneeFilterWithAnalytics';
const $d21c7a389f4c6f79$export$3ecb2c48b5973cac = ({ AddPeopleModal: AddPeopleModal, showAddPeopleModal: showAddPeopleModal, onAddPeopleModalClose: onAddPeopleModalClose, cloudId: cloudId, projectName: projectName, projectId: projectId, projectKey: projectKey, appEdition: appEdition, isSiteAdmin: isSiteAdmin, modalRef: modalRef })=>{
    if ((0, $anpCp.isCoreInvitesInJiraProjectsEnabled)(isSiteAdmin)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Ua7e.default), {
        inviteRef: modalRef,
        appEdition: appEdition,
        cloudId: cloudId,
        isOpen: showAddPeopleModal,
        onClose: onAddPeopleModalClose,
        jiraProjectName: projectName,
        projectId: projectId,
        jiraProjectKey: projectKey,
        isSiteAdmin: isSiteAdmin
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AddPeopleModal, {
        onClose: onAddPeopleModalClose,
        isOpen: showAddPeopleModal
    });
};
const $d21c7a389f4c6f79$export$804bfdea59f89629 = (createAnalyticsEvent, baseUrl, setShowUpSell, showUpSell, setShowAddPeopleModal, showAddPeopleModal, jswEdition, analyticsEvent, isSiteAdmin, screenName, fireTriggerClickEvent)=>{
    const openAddPeopleModal = ()=>{
        (0, $i528B.fireCoreInvitesInJiraProjectFeatureExposed)(createAnalyticsEvent, isSiteAdmin);
        setShowAddPeopleModal(!showAddPeopleModal);
    };
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_allow_project_invite_past_10th_user_on_free');
    if (jswEdition === (0, $6WXNs.toEdition)((0, $6WXNs.FREE_EDITION))) (0, $1Gl68.getRemainingSeats)(baseUrl, (0, $2edfd53057852e41$export$1346c9aa3cbb477d)).then((remainingSeats)=>{
        if (remainingSeats === 0) {
            // When the JSW Free instance is at the user limit and
            // the user is enrolled in the auto-upgrade experiment, fire an exposure event
            if (expConfig.get('cohort', 'not-enrolled') !== 'not-enrolled') {
                const [, fireExposureEvent] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_allow_project_invite_past_10th_user_on_free');
                fireExposureEvent();
            }
            fireTriggerClickEvent();
            // If the user is in the auto-upgrade experiment variation cohort, show the invite modal.
            // Otherwise, show the upsell dialog.
            if (expConfig.get('cohort', 'not-enrolled') === 'variation') openAddPeopleModal();
            else {
                setShowUpSell(!showUpSell);
                if (!showUpSell) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, `${screenName}AssigneeFilterAddPeople`);
            }
        } else {
            fireTriggerClickEvent();
            openAddPeopleModal();
        }
    }).catch((e)=>{
        fireTriggerClickEvent();
        openAddPeopleModal();
        throw e;
    });
    else {
        fireTriggerClickEvent();
        // If not on JSW Free, always show the invite modal
        openAddPeopleModal();
    }
};
const $d21c7a389f4c6f79$var$ConditionalUpsellDialogWrapper = (props)=>{
    const { children: children, showUpsellDialog: showUpsellDialog, setShowUpsellDialog: setShowUpsellDialog, screenName: screenName } = props;
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_allow_project_invite_past_10th_user_on_free');
    if (expConfig.get('cohort', 'not-enrolled') === 'variation') // When the user is in the experiment variation cohort, we won't be showing the upsell dialog.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    const onUpgradeDialogClose = ()=>{
        setShowUpsellDialog(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6UBeg.default), {
        isOpen: showUpsellDialog,
        onClose: onUpgradeDialogClose,
        touchpointId: `${screenName || ''}${screenName ? 'A' : 'a'}ssigneeFilterAddPeople`,
        onUpFlowDismiss: onUpgradeDialogClose
    }, children);
};
const $d21c7a389f4c6f79$export$20e0939737a940df = (props)=>{
    const { users: users, maxUsers: maxUsers, AddPeopleModal: AddPeopleModal, screenName: screenName, selectedUsers: selectedUsers, onToggle: onToggle, projectId: projectId, isAddPeopleButtonEnabled: isAddPeopleButtonEnabled, projectName: projectName, projectKey: projectKey } = props;
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const [showAddPeopleModal, setShowAddPeopleModal] = (0, $eUqFw.useState)(false);
    const [showUpSell, setShowUpSell] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const appEdition = (0, $6WXNs.getEdition)((0, $eIp1n.JIRA_SOFTWARE), tenantContext.appEditions);
    const onAddPeopleClick = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        const fireAddPeopleClickEvent = ()=>{
            // If neither the upsell dialog nor the invite modal is currently open,
            // then the user is trying to open one of them. When this happens,
            // we fire an analytics event.
            if (!showAddPeopleModal && !showUpSell) {
                const event = createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'button',
                    source: screenName
                });
                (0, $jMP2a.fireUIAnalytics)(event, 'assigneeFilterAddPeople');
            }
        };
        $d21c7a389f4c6f79$export$804bfdea59f89629(createAnalyticsEvent, tenantContext.baseUrl, setShowUpSell, showUpSell, setShowAddPeopleModal, showAddPeopleModal, appEdition, analyticsEvent, tenantContext.isSiteAdmin, screenName || '', fireAddPeopleClickEvent);
    }, [
        createAnalyticsEvent,
        tenantContext.baseUrl,
        tenantContext.isSiteAdmin,
        showUpSell,
        showAddPeopleModal,
        appEdition,
        screenName
    ]);
    const onAddPeopleModalClose = (0, $eUqFw.useCallback)(()=>{
        setShowAddPeopleModal(false);
    }, []);
    const showAddPeopleButton = AddPeopleModal !== undefined && isAddPeopleButtonEnabled;
    const addButtonRef = (0, $eUqFw.useRef)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d21c7a389f4c6f79$var$ConditionalUpsellDialogWrapper, {
        showUpsellDialog: showUpSell,
        setShowUpsellDialog: setShowUpSell,
        screenName: screenName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d21c7a389f4c6f79$var$StatelessAssigneeFilterWithAnalytics, {
        peopleRef: addButtonRef,
        users: users,
        maxUsers: maxUsers,
        selectedUsers: selectedUsers,
        onToggle: onToggle,
        onAddPeopleClick: onAddPeopleClick,
        showAddPeopleButton: showAddPeopleButton,
        screenName: screenName || '',
        projectId: projectId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7NnaN.Analytics), {
        baseUrl: tenantContext.baseUrl,
        projectId: projectId,
        screenName: screenName || '',
        showAddPeopleButton: showAddPeopleButton
    }), AddPeopleModal && showAddPeopleButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d21c7a389f4c6f79$export$3ecb2c48b5973cac, {
        modalRef: addButtonRef,
        projectName: projectName,
        projectKey: projectKey,
        projectId: projectId,
        AddPeopleModal: AddPeopleModal,
        showAddPeopleButton: showAddPeopleButton,
        showAddPeopleModal: showAddPeopleModal,
        onAddPeopleModalClose: onAddPeopleModalClose,
        cloudId: tenantContext.cloudId,
        appEdition: appEdition,
        isSiteAdmin: tenantContext.isSiteAdmin
    }));
};
$d21c7a389f4c6f79$export$20e0939737a940df.defaultProps = {
    users: [],
    selectedUsers: [],
    maxUsers: 5,
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onAssigneeMenuOpen: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    AddPeopleModal: undefined,
    isAddPeopleButtonEnabled: false,
    projectId: -1
};
const $d21c7a389f4c6f79$var$AssigneeFilterComponent = /*#__PURE__*/ (0, $eUqFw.memo)($d21c7a389f4c6f79$export$20e0939737a940df);
$d21c7a389f4c6f79$var$AssigneeFilterComponent.displayName = 'AssigneeFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<{ isAddPeopleButtonEnabled: boolean; readonly projectId: number; } & CommonAssigneeFilterProps & { AddPeopleModal: ComponentType<{ onClose: () => void; isOpen: boolean; }> | undefined; }>'.
$d21c7a389f4c6f79$var$AssigneeFilterComponent.whyDidYouRender = true;
var $d21c7a389f4c6f79$export$2e2bcd8739ae039 = $d21c7a389f4c6f79$var$AssigneeFilterComponent;

});
parcelRegister("i528B", function(module, exports) {

$parcel$export(module.exports, "fireCoreInvitesInJiraProjectFeatureExposed", () => $0dbd3d296d3d0e11$export$2f2d4a4234531655);

var $1ybV0 = parcelRequire("1ybV0");

var $jMP2a = parcelRequire("jMP2a");

var $anpCp = parcelRequire("anpCp");
const $0dbd3d296d3d0e11$var$getCoreInvitesInJiraProjects = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('core-invites-in-jira-projects', (0, $anpCp.CORE_INVITES_IN_JIRA_PROJECTS).NOT_ENROLLED, [
        (0, $anpCp.CORE_INVITES_IN_JIRA_PROJECTS).NOT_ENROLLED,
        (0, $anpCp.CORE_INVITES_IN_JIRA_PROJECTS).CONTROL,
        (0, $anpCp.CORE_INVITES_IN_JIRA_PROJECTS).INVITE_ONLY,
        (0, $anpCp.CORE_INVITES_IN_JIRA_PROJECTS).INVITE_ONLY_NOT_ENROLLED,
        (0, $anpCp.CORE_INVITES_IN_JIRA_PROJECTS).INVITE_RA,
        (0, $anpCp.CORE_INVITES_IN_JIRA_PROJECTS).INVITE_RA_NOT_ENROLLED
    ]);
const $0dbd3d296d3d0e11$export$2f2d4a4234531655 = (createAnalyticsEvent, isSiteAdmin)=>{
    const featureFlagValue = $0dbd3d296d3d0e11$var$getCoreInvitesInJiraProjects();
    const cohort = featureFlagValue;
    (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', {
        flagKey: 'core-invites-in-jira-projects',
        value: featureFlagValue,
        cohort: cohort,
        isSiteAdmin: isSiteAdmin,
        ineligibilityReasons: [],
        growthInitiative: 'virality'
    });
};

});
parcelRegister("anpCp", function(module, exports) {

$parcel$export(module.exports, "CORE_INVITES_IN_JIRA_PROJECTS", () => $2d494c23fdb3d24c$export$3496ae3c3008d7e5);
$parcel$export(module.exports, "isCoreInvitesInJiraProjectsEnabled", () => $2d494c23fdb3d24c$export$78d85fc0e603743c);
$parcel$export(module.exports, "isElligibleProject", () => $2d494c23fdb3d24c$export$b0222359e25e154);

var $7ZZxN = parcelRequire("7ZZxN");

var $1ybV0 = parcelRequire("1ybV0");
const $2d494c23fdb3d24c$export$3496ae3c3008d7e5 = {
    CONTROL: 'control',
    NOT_ENROLLED: 'not-enrolled',
    INVITE_ONLY: 'invite-only-variation',
    INVITE_ONLY_NOT_ENROLLED: 'invite-only-not-enrolled',
    INVITE_RA: 'invite-ra-variation',
    INVITE_RA_NOT_ENROLLED: 'invite-ra-variation'
};
const $2d494c23fdb3d24c$var$getCoreInvitesInJiraProjects = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('core-invites-in-jira-projects', $2d494c23fdb3d24c$export$3496ae3c3008d7e5.NOT_ENROLLED, [
        $2d494c23fdb3d24c$export$3496ae3c3008d7e5.NOT_ENROLLED,
        $2d494c23fdb3d24c$export$3496ae3c3008d7e5.CONTROL,
        $2d494c23fdb3d24c$export$3496ae3c3008d7e5.INVITE_ONLY,
        $2d494c23fdb3d24c$export$3496ae3c3008d7e5.INVITE_ONLY_NOT_ENROLLED,
        $2d494c23fdb3d24c$export$3496ae3c3008d7e5.INVITE_RA,
        $2d494c23fdb3d24c$export$3496ae3c3008d7e5.INVITE_RA_NOT_ENROLLED
    ]);
const $2d494c23fdb3d24c$export$78d85fc0e603743c = (isSiteAdmin)=>{
    const flag = $2d494c23fdb3d24c$var$getCoreInvitesInJiraProjects();
    return isSiteAdmin && flag === $2d494c23fdb3d24c$export$3496ae3c3008d7e5.INVITE_ONLY || flag === $2d494c23fdb3d24c$export$3496ae3c3008d7e5.INVITE_RA;
};
const $2d494c23fdb3d24c$export$b0222359e25e154 = (projectType)=>projectType === (0, $7ZZxN.CORE_PROJECT) || projectType === (0, $7ZZxN.SOFTWARE_PROJECT);

});


parcelRegister("6Ua7e", function(module, exports) {

$parcel$export(module.exports, "default", () => $586cc92d06f8b9df$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

const $586cc92d06f8b9df$var$LazyComponent = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("3L3ei")), {
    moduleId: "./src/packages/project-settings/invite-people-modal-project/src/index.tsx"
});
const $586cc92d06f8b9df$export$6a02a79fa2b0ddab = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-project-invite-people-modal",
        packageName: "jira-project-invite-people-modal",
        teamName: "groot-growth"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "project-invite-people-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($586cc92d06f8b9df$var$LazyComponent, props)));
var $586cc92d06f8b9df$export$2e2bcd8739ae039 = $586cc92d06f8b9df$export$6a02a79fa2b0ddab;

});
parcelRegister("3L3ei", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('e1vXm')
        ]);
        const value = parcelRequire('bagiu');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("e1vXm")
    ]).then(()=>parcelRequire('bagiu'));
}

});


parcelRegister("6UBeg", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d6c2870ae2a9a87$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bbaTG = parcelRequire("bbaTG");

var $29yDk = parcelRequire("29yDk");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $kDzFH = parcelRequire("kDzFH");

var $3svxt = parcelRequire("3svxt");

var $5oIBC = parcelRequire("5oIBC");

var $giAhk = parcelRequire("giAhk");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");

var $6WXNs = parcelRequire("6WXNs");

var $gd0Sp = parcelRequire("gd0Sp");

var $3uAFr = parcelRequire("3uAFr");

var $3V6nz = parcelRequire("3V6nz");

var $9ekFy = parcelRequire("9ekFy");


var $1Y97h = parcelRequire("1Y97h");
const $3d6c2870ae2a9a87$var$fireCTAButtonAnalytics = (analyticsEvent, actionSubjectId, touchpointId, currentEdition)=>{
    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, actionSubjectId, {
        currentEdition: currentEdition,
        touchpointId: touchpointId,
        targetEdition: (0, $3V6nz.applicationEditionToUpFlowEdition)((0, $6WXNs.STANDARD_EDITION)),
        isGrandfathered: false,
        isSiteAdmin: true,
        upFlowVariateFlag: 'experiment'
    });
};
const $3d6c2870ae2a9a87$var$showTryNowButton = (onClick, label, href, target)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        appearance: "primary",
        onClick: onClick,
        href: href,
        target: target,
        rel: "noopener"
    }, label);
const $3d6c2870ae2a9a87$var$showLearnMoreButton = (appearance, onClick, label, href, target)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        appearance: appearance,
        onClick: onClick,
        href: href,
        target: target,
        rel: "noopener"
    }, label); // TODO split this file in to proper tangerine app structure, it's getting too big
const $3d6c2870ae2a9a87$var$UpgradeToAddUsersDialog = (props)=>{
    const { children: children, isOpen: isOpen, onClose: onClose, intl: intl, touchpointId: touchpointId, onUpFlowDismiss: onUpFlowDismiss } = props;
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const explicitlyLicensedProducts = (0, $3svxt.default)(tenantContext);
    const hasOnlyJSW = explicitlyLicensedProducts.length === 1 && explicitlyLicensedProducts[0] === (0, $2edfd53057852e41$export$1346c9aa3cbb477d);
    const [upFlowIframeState, setUpFlowIframeState] = (0, $eUqFw.useState)(null);
    const currentEdition = (0, $3V6nz.applicationEditionToUpFlowEdition)((0, $kDzFH.getProductEdition)(explicitlyLicensedProducts[0], tenantContext));
    const upgradeButtonOnClick = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type.
    (_, analyticsEvent)=>{
        const actionSubjectId = (0, $3uAFr.mapActionIdFromType)[0, $3uAFr.UPGRADE];
        $3d6c2870ae2a9a87$var$fireCTAButtonAnalytics(analyticsEvent, actionSubjectId, touchpointId, currentEdition);
        hasOnlyJSW && setUpFlowIframeState((0, $3uAFr.UPGRADE));
    }, [
        currentEdition,
        hasOnlyJSW,
        touchpointId
    ]);
    const learnMoreButtonOnClick = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type.
    (_, analyticsEvent)=>{
        const actionSubjectId = (0, $3uAFr.mapActionIdFromType)[0, $3uAFr.LEARN_MORE];
        $3d6c2870ae2a9a87$var$fireCTAButtonAnalytics(analyticsEvent, actionSubjectId, touchpointId, currentEdition);
        hasOnlyJSW && setUpFlowIframeState((0, $3uAFr.LEARN_MORE));
    }, [
        currentEdition,
        hasOnlyJSW,
        touchpointId
    ]);
    const onUpFlowIframeClose = (0, $eUqFw.useCallback)(()=>{
        setUpFlowIframeState(null);
        onUpFlowDismiss();
    }, [
        onUpFlowDismiss
    ]);
    const learnMoreButtonAppearance = tenantContext.isSiteAdmin ? 'link' : 'primary';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: touchpointId,
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29yDk.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            sourceName: "changeEditionGateway",
            sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
            attributes: {
                isSiteAdmin: tenantContext.isSiteAdmin,
                source: touchpointId
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, intl.formatMessage((0, $1Y97h.default).upgradeToAddUsersHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3d6c2870ae2a9a87$var$MultiLineParagraph, null, intl.formatMessage((0, $1Y97h.default).upgradeToAddUsersContent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $3d6c2870ae2a9a87$var$buttonBarStyles
        }, tenantContext.isSiteAdmin ? $3d6c2870ae2a9a87$var$showTryNowButton(// @ts-expect-error - TS2345 - Argument of type '(_: any, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to parameter of type '() => void'.
        upgradeButtonOnClick, intl.formatMessage((0, $1Y97h.default).upgradeButtonLabel), hasOnlyJSW ? undefined : (0, $584c6c5758c545fa$export$cfca87b5d4683694), hasOnlyJSW ? undefined : '_blank') : null, $3d6c2870ae2a9a87$var$showLearnMoreButton(learnMoreButtonAppearance, // @ts-expect-error - TS2345 - Argument of type '(_: any, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to parameter of type '() => void'.
        learnMoreButtonOnClick, intl.formatMessage((0, $1Y97h.default).learnMoreButtonLabel), hasOnlyJSW ? undefined : (0, $584c6c5758c545fa$export$997e23a0aec74966), hasOnlyJSW ? undefined : '_blank')), upFlowIframeState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9ekFy.UpFlowIFrame), {
            targetEdition: (0, $6WXNs.STANDARD_EDITION),
            product: explicitlyLicensedProducts[0],
            flow: upFlowIframeState,
            touchpointId: touchpointId,
            experienceTrackingEnabled: true,
            onClose: onUpFlowIframeClose
        })),
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-start"
    }, children));
};
var $3d6c2870ae2a9a87$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)((0, $5oIBC.default)($3d6c2870ae2a9a87$var$UpgradeToAddUsersDialog));
const $3d6c2870ae2a9a87$var$buttonBarStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3d6c2870ae2a9a87$var$MultiLineParagraph = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5726vc6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("29yDk", function(module, exports) {

$parcel$export(module.exports, "default", () => $99fb58582e83d080$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $lbDTY = parcelRequire("lbDTY");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $5Q9wj = parcelRequire("5Q9wj");

var $etCs9 = parcelRequire("etCs9");
var $eN43R = parcelRequire("eN43R");

var $XHGTv = parcelRequire("XHGTv");

var $8nlzU = parcelRequire("8nlzU");
var $i6BC8 = parcelRequire("i6BC8");
var $6frYP = parcelRequire("6frYP");

var $1GZRB = parcelRequire("1GZRB");
const $99fb58582e83d080$var$packageName = "platform-pkg";
const $99fb58582e83d080$var$packageVersion = "0.0.0-use.local";
const $99fb58582e83d080$var$checkIsChildOfPortal = (node)=>{
    if (!node) return false;
    return node.classList && node.classList.contains('atlaskit-portal-container') || $99fb58582e83d080$var$checkIsChildOfPortal(node.parentElement);
};
// escape close manager for layering
const $99fb58582e83d080$var$EscapeCloseManager = ({ handleClose: handleClose })=>{
    (0, $eN43R.useCloseOnEscapePress)({
        onClose: handleClose
    });
    // only create a dummy component for using ths hook in class component
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", null);
};
const $99fb58582e83d080$export$513033cc22e3bc20 = /*#__PURE__*/ (0, $eUqFw.memo)(function InlineDialog({ isOpen: isOpen = false, onContentBlur: onContentBlur = (0, $5Q9wj.default), onContentClick: onContentClick = (0, $5Q9wj.default), onContentFocus: onContentFocus = (0, $5Q9wj.default), onClose: onClose = (0, $5Q9wj.default), placement: placement = 'bottom-start', strategy: strategy = 'fixed', testId: testId, content: content, children: children }) {
    const containerRef = (0, $eUqFw.useRef)(null);
    const triggerRef = (0, $eUqFw.useRef)(null);
    // we put this into a ref to avoid handleCloseRequest having this as a dependency
    const onCloseRef = (0, $eUqFw.useRef)(onClose);
    const isLayeringEnabled = (0, $XHGTv.fg)('platform.design-system-team.inline-message-layering_wfp1p') && isOpen;
    (0, $eUqFw.useEffect)(()=>{
        onCloseRef.current = onClose;
    });
    const handleCloseRequest = (0, $eUqFw.useCallback)((event)=>{
        const { target: target } = event;
        // checks for when target is not HTMLElement
        if (!(target instanceof HTMLElement)) return;
        // TODO: This is to handle the case where the target is no longer in the DOM.
        // This happens with react-select in datetime picker. There might be other
        // edge cases for this.
        if (!document.body.contains(target)) return;
        if (isLayeringEnabled) {
            onCloseRef.current?.({
                isOpen: false,
                event: event
            });
            return;
        }
        // handles the case where inline dialog opens portalled elements such as modal
        if ($99fb58582e83d080$var$checkIsChildOfPortal(target)) return;
        // call onClose if the click originated from outside the dialog
        if (containerRef.current && !containerRef.current.contains(target)) onCloseRef.current?.({
            isOpen: false,
            event: event
        });
    }, [
        isLayeringEnabled
    ]);
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        // exit if we click outside but on the trigger — it can handle the clicks itself
        if (triggerRef.current && triggerRef.current.contains(event.target)) return;
        // if feature flag is enabled we won't file the close event when clicking inside dialog
        if (isLayeringEnabled && containerRef.current?.contains(event.target)) return;
        handleCloseRequest(event);
    }, [
        handleCloseRequest,
        isLayeringEnabled
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isOpen) return;
        return (0, $74BVL.bind)(window, {
            type: 'click',
            listener: handleClick,
            options: {
                capture: true
            }
        });
    }, [
        isOpen,
        handleClick
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Escape') handleCloseRequest(event);
    }, [
        handleCloseRequest
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // if layering is enabled, we will use useCloseOnEscapePress hook instead
        if (!isOpen || isLayeringEnabled) return;
        const unbind = (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: handleKeyDown,
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        isOpen,
        handleKeyDown,
        isLayeringEnabled
    ]);
    const popper = isOpen ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $i6BC8.Popper), {
        placement: placement,
        strategy: strategy
    }, ({ ref: ref, style: style })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $1GZRB.Container), {
            onBlur: onContentBlur,
            onFocus: onContentFocus,
            onClick: onContentClick,
            ref: (node)=>{
                if (node) {
                    containerRef.current = node;
                    if (typeof ref === 'function') ref(node);
                    else ref.current = node;
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style,
            testId: testId
        }, content)) : null;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8nlzU.Manager), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $6frYP.Reference), null, ({ ref: ref })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lbDTY))), {
            innerRef: (node)=>{
                triggerRef.current = node;
                if (typeof ref === 'function') ref(node);
                else ref.current = node;
            }
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children))), isLayeringEnabled ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $etCs9.UNSAFE_LAYERING), {
        isDisabled: false
    }, popper, /*#__PURE__*/ (0, $byn9U.jsx)($99fb58582e83d080$var$EscapeCloseManager, {
        handleClose: handleCloseRequest
    })) : popper);
});
$99fb58582e83d080$export$513033cc22e3bc20.displayName = 'InlineDialog';
const $99fb58582e83d080$var$createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
/**
 * __Inline dialog__
 *
 * _We are planning on deprecating Inline dialog. We recommend using the Popup component instead._
 *
 * An inline dialog is a pop-up container for small amounts of information. It can also contain controls.
 *
 * - [Examples](https://atlassian.design/components/inline-dialog/examples)
 * - [Code](https://atlassian.design/components/inline-dialog/code)
 * - [Usage](https://atlassian.design/components/inline-dialog/usage)
 */ const $99fb58582e83d080$var$InlineDialog = (0, $1ngde.default)({
    componentName: 'inlineDialog',
    packageName: $99fb58582e83d080$var$packageName,
    packageVersion: $99fb58582e83d080$var$packageVersion
})((0, $2jDha.default)({
    onClose: $99fb58582e83d080$var$createAndFireEventOnAtlaskit({
        action: 'closed',
        actionSubject: 'inlineDialog',
        attributes: {
            componentName: 'inlineDialog',
            packageName: $99fb58582e83d080$var$packageName,
            packageVersion: $99fb58582e83d080$var$packageVersion
        }
    })
})($99fb58582e83d080$export$513033cc22e3bc20));
var $99fb58582e83d080$export$2e2bcd8739ae039 = $99fb58582e83d080$var$InlineDialog;

});
parcelRegister("1GZRB", function(module, exports) {

$parcel$export(module.exports, "Container", () => $9db71f94672a5c3a$export$42a852a2b6b56249);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");
const $9db71f94672a5c3a$var$CSS_THEME_BACKGROUND = '--theme-background';
const $9db71f94672a5c3a$var$CSS_THEME_COLOR = '--theme-color';
const $9db71f94672a5c3a$var$CSS_THEME_BOX_SHADOW = '--theme-box-shadow';
const $9db71f94672a5c3a$var$containerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'content-box',
    maxWidth: `${448}px`,
    maxHeight: `${448}px`,
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-300, 24px)"}`,
    zIndex: (0, $lcnyw.layers).dialog(),
    background: `var(${$9db71f94672a5c3a$var$CSS_THEME_BACKGROUND})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(${$9db71f94672a5c3a$var$CSS_THEME_BOX_SHADOW})`,
    color: `var(${$9db71f94672a5c3a$var$CSS_THEME_COLOR})`,
    '&:focus': {
        outline: 'none'
    }
});
const $9db71f94672a5c3a$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, onBlur: onBlur, onClick: onClick, onFocus: onFocus, style: style, testId: testId }, ref)=>{
    return(// Unfortunately, these are used for products to pass through. Inline Dialog is being deprecated anyway
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $9db71f94672a5c3a$var$containerStyles,
        "data-testid": testId,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$9db71f94672a5c3a$var$CSS_THEME_BACKGROUND]: `var(--ds-surface-overlay, ${(0, $PdmhA.N0)})`,
            [$9db71f94672a5c3a$var$CSS_THEME_COLOR]: `var(--ds-text, ${(0, $PdmhA.N900)})`,
            [$9db71f94672a5c3a$var$CSS_THEME_BOX_SHADOW]: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $PdmhA.N50A)}, 0 0 1px ${(0, $PdmhA.N60A)}`})`,
            ...style
        }
    }, children));
});

});


parcelRegister("kDzFH", function(module, exports) {

$parcel$export(module.exports, "getProductEdition", () => $f3ca75df413b6183$export$53e066a63a960439);

const $f3ca75df413b6183$export$53e066a63a960439 = (product, tenantContext)=>{
    if (product === (0, $2edfd53057852e41$export$1346c9aa3cbb477d)) return tenantContext.appEditions.software;
    if (product === (0, $2edfd53057852e41$export$c8c1c8c3f8ddba61)) return tenantContext.appEditions.serviceDesk;
    return tenantContext.appEditions.core;
};

});

parcelRegister("3svxt", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e55bb6ee669ca6d$export$2e2bcd8739ae039);

var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1e55bb6ee669ca6d$export$2e2bcd8739ae039 = (tenantContext)=>{
    const { licensedProducts: licensedProducts } = tenantContext;
    const result = [];
    licensedProducts[0, $2edfd53057852e41$export$db515c8cec1e6f79] && result.push((0, $2edfd53057852e41$export$db515c8cec1e6f79));
    licensedProducts[0, $2edfd53057852e41$export$c8c1c8c3f8ddba61] && result.push((0, $2edfd53057852e41$export$c8c1c8c3f8ddba61));
    licensedProducts[0, $2edfd53057852e41$export$1346c9aa3cbb477d] && result.push((0, $2edfd53057852e41$export$1346c9aa3cbb477d));
    licensedProducts[0, $2edfd53057852e41$export$202f50ee62667e32] && result.push((0, $2edfd53057852e41$export$202f50ee62667e32));
    return result;
};

});

parcelRegister("3uAFr", function(module, exports) {

$parcel$export(module.exports, "LEARN_MORE", () => $bc6bb1980bacdf08$export$1979295cc80a7ec1);
$parcel$export(module.exports, "READ_ABOUT_CONFIGURING_STATUSES", () => $bc6bb1980bacdf08$export$ec2640a84c44efca);
$parcel$export(module.exports, "UPGRADE", () => $bc6bb1980bacdf08$export$fe5b785cab515b6e);
$parcel$export(module.exports, "mapActionIdFromType", () => $bc6bb1980bacdf08$export$2bf527ee1645dc7d);
const $bc6bb1980bacdf08$export$9ba2bc3b1bdc1519 = 'experiment';
const $bc6bb1980bacdf08$export$5b7423264d48ab04 = 'not-enrolled';
const $bc6bb1980bacdf08$export$43f367b3e957f219 = 'control';
const $bc6bb1980bacdf08$export$1979295cc80a7ec1 = 'learn-more';
const $bc6bb1980bacdf08$export$ec2640a84c44efca = 'read-about-configuring-statuses';
const $bc6bb1980bacdf08$export$fe5b785cab515b6e = 'upgrade';
const $bc6bb1980bacdf08$export$2bf527ee1645dc7d = {
    [$bc6bb1980bacdf08$export$1979295cc80a7ec1]: 'freeLearnMore',
    [$bc6bb1980bacdf08$export$ec2640a84c44efca]: 'readAboutConfiguringStatuses',
    [$bc6bb1980bacdf08$export$fe5b785cab515b6e]: 'freeTryNow'
};

});

parcelRegister("3V6nz", function(module, exports) {

$parcel$export(module.exports, "applicationEditionToUpFlowEdition", () => $4f19dd0acff36bb5$export$b48ea9d6b982b3e1);
$parcel$export(module.exports, "jiraUpFlowIframeUpgradePlanInteraction", () => $4f19dd0acff36bb5$export$7d4045a899f62dfd);
$parcel$export(module.exports, "addChunkLoadErrorAnalyticsAttribute", () => $4f19dd0acff36bb5$export$94ee0b5fca1e74d2);
$parcel$export(module.exports, "handleError", () => $4f19dd0acff36bb5$export$d3da1ecaf1206c58);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $lNfG4 = parcelRequire("lNfG4");

var $guiFP = parcelRequire("guiFP");

var $6WXNs = parcelRequire("6WXNs");



var $fdxQj = parcelRequire("fdxQj");
const $4f19dd0acff36bb5$export$e4e69593f7c9f3b7 = (attributes, error)=>{
    (0, $guiFP.default)({
        meta: {
            // We use the same ID for all errors in the package for easier
            // management in data portal, and use attributes to identify an error instead.
            id: (0, $784e146d081cab2a$export$c73007a11ea7e52),
            packageName: (0, $784e146d081cab2a$export$c73007a11ea7e52),
            teamName: 'flywheel-tako'
        },
        attributes: {
            ...attributes
        },
        error: error
    });
};
const $4f19dd0acff36bb5$export$b48ea9d6b982b3e1 = (applicationEdition)=>{
    if (applicationEdition === (0, $6WXNs.FREE_EDITION)) return 0, $0722a49a19fd82a0$export$e69af2c4378638a2;
    if (applicationEdition === (0, $6WXNs.STANDARD_EDITION)) return 0, $0722a49a19fd82a0$export$7bc7dd5faba7ad6b;
    return 0, $0722a49a19fd82a0$export$3fd0bbb8c68dc4c7;
};
const $4f19dd0acff36bb5$export$7d4045a899f62dfd = (0, $lNfG4.metrics).interaction({
    key: `${(0, $784e146d081cab2a$export$c73007a11ea7e52)}.upgrade.plan`
});
const $4f19dd0acff36bb5$export$94ee0b5fca1e74d2 = (error)=>({
        chunkLoadError: (0, $7rh0R.isLoaderError)(error)
    });
const $4f19dd0acff36bb5$export$d3da1ecaf1206c58 = (subject, onClose, apiError)=>{
    $4f19dd0acff36bb5$export$e4e69593f7c9f3b7({
        subject: subject,
        message: apiError?.message || ''
    }, apiError);
    $4f19dd0acff36bb5$export$7d4045a899f62dfd.cancel();
    onClose();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fdxQj.CommerceApiErrorFlag), null);
};

});
const $784e146d081cab2a$export$c73007a11ea7e52 = 'jiraUpFlowIframe';
const $784e146d081cab2a$export$cb7e587097a78810 = 'upsell-edition';
const $784e146d081cab2a$export$fb320338324d1328 = 'upflowIFrame';
const $784e146d081cab2a$export$782491eab0c2154d = 'INITIATE_SPA_CLOSE';
const $784e146d081cab2a$export$dc3263ec2276f3f3 = 'START_EDITION_POLLING';
const $784e146d081cab2a$export$8a7c66f5574473bd = 'FINISH_EDITION_POLLING';
const $784e146d081cab2a$export$c012ea75b4437aea = 'TRACK_EXPERIENCE_FAIL';
const $784e146d081cab2a$export$1b2e801262ba754 = 'TRACK_EXPERIENCE_SUCCESS';
const $784e146d081cab2a$export$b6cceaecfde9dc91 = 'SPA_READY';

const $0722a49a19fd82a0$export$e69af2c4378638a2 = 'free';
const $0722a49a19fd82a0$export$7bc7dd5faba7ad6b = 'standard';
const $0722a49a19fd82a0$export$3fd0bbb8c68dc4c7 = 'premium';

parcelRegister("fdxQj", function(module, exports) {

$parcel$export(module.exports, "CommerceApiErrorFlag", () => $f9cddb5329b8bde6$export$7ee77c445dd775b4);

var $k8Qyf = parcelRequire("k8Qyf");

var $eo17r = parcelRequire("eo17r");

var $7AaMe = parcelRequire("7AaMe");
const $f9cddb5329b8bde6$export$7ee77c445dd775b4 = ()=>{
    const flagKey = (0, $eo17r.toFlagId)('commerce-api-error');
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    showFlag({
        id: flagKey,
        key: flagKey,
        type: 'error',
        title: (0, $7AaMe.default).title,
        description: (0, $7AaMe.default).description,
        isAutoDismiss: true
    });
    return null;
};

});
parcelRegister("7AaMe", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec87d75cc62a60c4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ec87d75cc62a60c4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "up-flow-iframe.common.commerce-api-error-flag.title",
        "defaultMessage": "We can't upgrade your plan right now"
    },
    description: {
        "id": "up-flow-iframe.common.commerce-api-error-flag.description",
        "defaultMessage": "Try again, or if this keeps happening try contacting support"
    }
});

});



parcelRegister("9ekFy", function(module, exports) {

$parcel$export(module.exports, "UpFlowIFrame", () => $1bd1da7075fc78d1$export$e9eafd8c579e773d);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");


var $3V6nz = parcelRequire("3V6nz");

var $lB1hx = parcelRequire("lB1hx");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1bd1da7075fc78d1$var$UpFlowIFrameLazy = (0, $7rh0R.lazy)(()=>(parcelRequire("cvele")), {
    moduleId: "./src/packages/growth/up-flow/up-flow-iframe/src/main.tsx"
});
const $1bd1da7075fc78d1$export$e9eafd8c579e773d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: (0, $784e146d081cab2a$export$c73007a11ea7e52),
        packageName: (0, $784e146d081cab2a$export$c73007a11ea7e52),
        teamName: "flywheel-tako",
        fallback: (0, $lB1hx.ChunkLoadErrorFlag),
        attributes: (0, $3V6nz.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "flow-iframe-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1bd1da7075fc78d1$var$UpFlowIFrameLazy, props)));

});
parcelRegister("lB1hx", function(module, exports) {

$parcel$export(module.exports, "ChunkLoadErrorFlag", () => $fbcf8118023ec96d$export$7a9d9407b3a5f50e);

var $7rh0R = parcelRequire("7rh0R");

var $k8Qyf = parcelRequire("k8Qyf");

var $eo17r = parcelRequire("eo17r");

var $d7NSa = parcelRequire("d7NSa");
const $fbcf8118023ec96d$export$7a9d9407b3a5f50e = ({ error: error })=>{
    const flagKey = (0, $eo17r.toFlagId)('chunk-load-error');
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    if ((0, $7rh0R.isLoaderError)(error)) showFlag({
        id: flagKey,
        key: flagKey,
        type: 'error',
        title: (0, $d7NSa.default).title,
        description: (0, $d7NSa.default).description,
        isAutoDismiss: true,
        actions: [
            {
                content: (0, $d7NSa.default).refreshPageButton,
                onClick: ()=>{
                    dismissFlag(flagKey);
                    window.location.reload();
                }
            }
        ]
    });
    return null;
};

});
parcelRegister("d7NSa", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf70fc34a5a9ee18$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $cf70fc34a5a9ee18$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "up-flow-iframe.chunk-load-error-flag.title",
        "defaultMessage": "Something went wrong"
    },
    description: {
        "id": "up-flow-iframe.chunk-load-error-flag.description",
        "defaultMessage": "Refresh the page and try again."
    },
    refreshPageButton: {
        "id": "up-flow-iframe.chunk-load-error-flag.refresh-page-button",
        "defaultMessage": "Refresh page"
    }
});

});


parcelRegister("cvele", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('ipZXA')
        ]);
        const value = parcelRequire('9t7R1');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("ipZXA")
    ]).then(()=>parcelRequire('9t7R1'));
}

});


const $584c6c5758c545fa$export$997e23a0aec74966 = 'https://confluence.atlassian.com/display/AdminJIRACloud/Jira+Cloud+plans';
const $584c6c5758c545fa$export$b31b7002b6bdcbe9 = 'https://support.atlassian.com/jira-cloud-administration/docs/configure-statuses-resolutions-and-priorities/';
const $584c6c5758c545fa$export$cfca87b5d4683694 = '/admin/billing/applications';

parcelRegister("1Y97h", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5a007549c91f619$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e5a007549c91f619$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    upgradeToAddUsersHeader: {
        "id": "up-flow-upgrade-to-add-users-dialog.upgrade-to-add-users-header",
        "defaultMessage": "Upgrade to add users"
    },
    upgradeToAddUsersContent: {
        "id": "up-flow-upgrade-to-add-users-dialog.upgrade-to-add-users-content",
        "defaultMessage": "You've reached the maximum number of users for your plan.\nRemove existing users or upgrade to grow your team."
    },
    upgradeButtonLabel: {
        "id": "up-flow-upgrade-to-add-users-dialog.upgrade-button-label",
        "defaultMessage": "Try it now"
    },
    learnMoreButtonLabel: {
        "id": "up-flow-upgrade-to-add-users-dialog.learn-more-button-label",
        "defaultMessage": "Learn more"
    }
});

});


parcelRegister("1Gl68", function(module, exports) {

$parcel$export(module.exports, "getRemainingSeats", () => $a8e8f70e71e008ee$export$6397e3bbf35b34e3);

var $lRmyA = parcelRequire("lRmyA");
const $a8e8f70e71e008ee$var$toRemainingSeats = (json)=>json.remainingSeat;
const $a8e8f70e71e008ee$export$6397e3bbf35b34e3 = (baseUrl, applicationKey)=>(0, $lRmyA.performGetRequest)(`/rest/internal/2/invite-user/application/remaining-seat?key=${applicationKey}`).then((json)=>$a8e8f70e71e008ee$var$toRemainingSeats(json));

});

parcelRegister("7NnaN", function(module, exports) {

$parcel$export(module.exports, "Analytics", () => $92267752c3276ed5$export$2b3af6baec22bd98);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $g1u9S = parcelRequire("g1u9S");

var $2DMQz = parcelRequire("2DMQz");

var $grFrv = parcelRequire("grFrv");
const $92267752c3276ed5$export$2b3af6baec22bd98 = (props)=>{
    const { projectId: projectId, baseUrl: baseUrl, showAddPeopleButton: showAddPeopleButton, screenName: screenName } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        if (projectId >= 0 && showAddPeopleButton) Promise.all([
            (0, $2DMQz.getUserProjectRoles)(baseUrl, projectId),
            (0, $g1u9S.getProjectAccessLevel)(baseUrl, projectId)
        ]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then(([roleData, projectAccessLevel])=>{
            const projectRoleNames = roleData === null || roleData.projectRoleNames === null ? null : (0, $grFrv.reduceCustomRoles)(roleData.projectRoleNames);
            (0, $grFrv.fireAddPeopleRenderedEvent)(createAnalyticsEvent, screenName, projectId, projectRoleNames, projectAccessLevel);
        });
    }, [
        baseUrl,
        createAnalyticsEvent,
        projectId,
        screenName,
        showAddPeopleButton
    ]);
    return null;
};

});
parcelRegister("g1u9S", function(module, exports) {

$parcel$export(module.exports, "getProjectAccessLevel", () => $cb03e98e1c54da65$export$f5f97c28ee230e06);

var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");
var $lRmyA = parcelRequire("lRmyA");
const $cb03e98e1c54da65$export$128fa18b7194ef = (baseUrl, projectId)=>`${baseUrl}/rest/internal/simplified/1.0/accesslevel/project/${projectId}`;
const $cb03e98e1c54da65$var$transform = (data)=>data.value;
const $cb03e98e1c54da65$export$f5f97c28ee230e06 = (baseUrl, projectId)=>{
    const request = ()=>(0, $lRmyA.performGetRequest)($cb03e98e1c54da65$export$128fa18b7194ef(baseUrl, projectId));
    return request().then((data)=>$cb03e98e1c54da65$var$transform(data)).catch((error)=>{
        const attributes = error instanceof (0, $7byHA.default) ? {
            statusCode: error.statusCode,
            traceId: error.traceId
        } : {
            errorMessage: error.message
        };
        (0, $guiFP.default)({
            meta: {
                id: 'fetchProjectAccessLevel',
                packageName: 'jiraFilters',
                teamName: 'a4t-tanuki'
            },
            error: error,
            attributes: attributes,
            sendToPrivacyUnsafeSplunk: true
        });
        return Promise.resolve(null);
    });
};

});

parcelRegister("2DMQz", function(module, exports) {

$parcel$export(module.exports, "getUserProjectRoles", () => $5485a1e5a52a43c5$export$3b587d1e1fe73b9d);

var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");
var $lRmyA = parcelRequire("lRmyA");
const $5485a1e5a52a43c5$var$MEMBER_ROLE_NAME = 'Member';
const $5485a1e5a52a43c5$var$VIEWER_ROLE_NAME = 'Viewer';
const $5485a1e5a52a43c5$var$userProjectRoleNames = (data)=>data.map((projectRole)=>projectRole.name);
const $5485a1e5a52a43c5$export$5a1a2e9d57f47aee = (data)=>data.some((role)=>role.name === $5485a1e5a52a43c5$var$MEMBER_ROLE_NAME);
const $5485a1e5a52a43c5$export$10eeb2d34050404e = (data)=>data.some((role)=>role.admin);
const $5485a1e5a52a43c5$export$a4d7f3415bee4b75 = (data)=>data.some((role)=>role.name !== $5485a1e5a52a43c5$var$VIEWER_ROLE_NAME && role.name !== $5485a1e5a52a43c5$var$MEMBER_ROLE_NAME && !role.admin);
const $5485a1e5a52a43c5$export$128fa18b7194ef = (baseUrl, projectId)=>`${baseUrl}/rest/api/3/project/${projectId}/roledetails?excludeConnectAddons=true&currentMember=true`;
const $5485a1e5a52a43c5$export$3b587d1e1fe73b9d = (baseUrl, projectId)=>{
    const request = ()=>(0, $lRmyA.performGetRequest)($5485a1e5a52a43c5$export$128fa18b7194ef(baseUrl, projectId));
    return request().then((data)=>({
            isMember: $5485a1e5a52a43c5$export$5a1a2e9d57f47aee(data),
            isJiraAdmin: $5485a1e5a52a43c5$export$10eeb2d34050404e(data),
            hasCustomRole: $5485a1e5a52a43c5$export$a4d7f3415bee4b75(data),
            projectRoleNames: $5485a1e5a52a43c5$var$userProjectRoleNames(data)
        })).catch((error)=>{
        const attributes = error instanceof (0, $7byHA.default) ? {
            statusCode: error.statusCode,
            traceId: error.traceId
        } : {
            errorMessage: error.message
        };
        (0, $guiFP.default)({
            meta: {
                id: 'fetchUserProjectRoles',
                packageName: 'jiraFilters',
                teamName: 'a4t-tanuki'
            },
            error: error,
            attributes: attributes,
            sendToPrivacyUnsafeSplunk: true
        });
        return Promise.resolve(null);
    });
};

});

parcelRegister("grFrv", function(module, exports) {

$parcel$export(module.exports, "fireAddPeopleRenderedEvent", () => $c3f54e4ee61be276$export$8014b0c4810b7867);
$parcel$export(module.exports, "reduceCustomRoles", () => $c3f54e4ee61be276$export$7f2d1c0dab5190f9);

var $jMP2a = parcelRequire("jMP2a");
const $c3f54e4ee61be276$var$defaultProjectRoles = [
    'Administrator',
    'Member',
    'Viewer'
];
const $c3f54e4ee61be276$export$ecf9824f02c8a125 = 'Custom Role';
const $c3f54e4ee61be276$export$8014b0c4810b7867 = (createAnalyticsEvent, source, projectId, userProjectRoles, projectAccessLevel)=>{
    const analyticsEvent = createAnalyticsEvent({
        action: 'rendered',
        actionSubject: 'addPeopleButton',
        source: source
    });
    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
        projectId: projectId,
        userProjectRoles: userProjectRoles,
        projectAccessLevel: projectAccessLevel
    });
};
const $c3f54e4ee61be276$export$7f2d1c0dab5190f9 = (userProjectRoles)=>{
    let hasCustomRole = false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const modifiedProjectRoles = userProjectRoles.reduce((acc, role)=>{
        const isDefaultRole = $c3f54e4ee61be276$var$defaultProjectRoles.includes(role);
        hasCustomRole = hasCustomRole || !isDefaultRole;
        if (isDefaultRole) acc.push(role);
        return acc;
    }, []);
    if (hasCustomRole) modifiedProjectRoles.push($c3f54e4ee61be276$export$ecf9824f02c8a125);
    return modifiedProjectRoles;
};

});


parcelRegister("kovzS", function(module, exports) {

$parcel$export(module.exports, "default", () => $a46f6f245d939aef$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $ePCZQ = parcelRequire("ePCZQ");

var $giAhk = parcelRequire("giAhk");

var $3HCkE = parcelRequire("3HCkE");

var $gyys9 = parcelRequire("gyys9");

var $iPduV = parcelRequire("iPduV");

var $9pw6N = parcelRequire("9pw6N");

var $ddnmK = parcelRequire("ddnmK");

var $1Y4Nh = parcelRequire("1Y4Nh");

var $l2Yeb = parcelRequire("l2Yeb");

var $fGrG2 = parcelRequire("fGrG2");
const $a46f6f245d939aef$var$AssigneeFilter = (props)=>{
    const { users: users, selectedUsers: selectedUsers, maxUsers: maxUsers, onAddPeopleClick: onAddPeopleClick, showAddPeopleButton: showAddPeopleButton, onToggle: onToggle, onAssigneeMenuOpen: onAssigneeMenuOpen, intl: { formatMessage: formatMessage }, peopleRef: peopleRef } = props;
    const mainList = (0, $eUqFw.useMemo)(()=>users.length > maxUsers ? users.slice(0, maxUsers - 1) : users.slice(0), [
        users,
        maxUsers
    ]);
    const moreList = (0, $eUqFw.useMemo)(()=>users.length > maxUsers ? users.slice(maxUsers - 1) : [], [
        users,
        maxUsers
    ]);
    const isJSMBoard = (0, $iPduV.useIsJSMBoard)(); // Remove this after cleanup `jira.work-suggestions.remove-nbt-button`
    const { data: data, loading: loading } = (0, $3HCkE.useResource)((0, $gyys9.nextBestTaskFeatureResource));
    const isEnabledNBTOnFilter = !loading && data != null && !!data.hasUserOptedIn && !isJSMBoard;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a46f6f245d939aef$var$Fieldset, {
        "data-test-id": "filters.ui.filters.assignee.stateless.assignee-filter",
        "data-testid": "filters.ui.filters.assignee.stateless.assignee-filter"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a46f6f245d939aef$var$AvatarFilterLegend, {
        id: (0, $9pw6N.FILTER_PREFIX)
    }, formatMessage((0, $l2Yeb.default).label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a46f6f245d939aef$var$AvatarsList, null, mainList.map((user, index)=>isEnabledNBTOnFilter && index === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
            key: user.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Y4Nh.default), {
            zIndex: maxUsers - index,
            user: user,
            isSelected: selectedUsers.includes(user.id),
            onToggle: onToggle
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ePCZQ.SafeNextBestTaskButton), {
            key: "NextBestTaskButton"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Y4Nh.default), {
            key: user.id,
            zIndex: maxUsers - index,
            user: user,
            isSelected: selectedUsers.includes(user.id),
            onToggle: onToggle
        })), moreList.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fGrG2.default), {
        users: moreList,
        selectedUsers: selectedUsers,
        onItemActivated: onToggle,
        onOpen: onAssigneeMenuOpen
    }), showAddPeopleButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ddnmK.default), {
        peopleButtonRef: peopleRef,
        onClick: onAddPeopleClick
    })));
};
$a46f6f245d939aef$var$AssigneeFilter.defaultProps = {
    onAddPeopleClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onAssigneeMenuOpen: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    showAddPeopleButton: false
};
var $a46f6f245d939aef$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $giAhk.injectIntlV2)($a46f6f245d939aef$var$AssigneeFilter);
const $a46f6f245d939aef$var$Fieldset = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "fieldset", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1o9zidpf _19itidpf _18u0utpp _1pbyidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a46f6f245d939aef$var$AvatarsList = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a46f6f245d939aef$var$AvatarFilterLegend = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "legend", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _4t3it94y _1bsbt94y _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _ogto7mnp _1reo15vq _18m915vq _o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ePCZQ", function(module, exports) {

$parcel$export(module.exports, "SafeNextBestTaskButton", () => $a2af67911c389bee$export$47914911a538c5ff);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bbaTG = parcelRequire("bbaTG");

var $kODOJ = parcelRequire("kODOJ");

var $gGyns = parcelRequire("gGyns");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $dfBCt = parcelRequire("dfBCt");

var $dzpl6 = parcelRequire("dzpl6");

var $0cdA8 = parcelRequire("0cdA8");

var $g7rFt = parcelRequire("g7rFt");

var $aVlZX = parcelRequire("aVlZX");
var $erql0 = parcelRequire("erql0");
var $5dTk9 = parcelRequire("5dTk9");

var $aVlZX = parcelRequire("aVlZX");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $d6f6c = parcelRequire("d6f6c");
var $bFzGY = parcelRequire("bFzGY");

var $dxcfv = parcelRequire("dxcfv");

var $hgx7r = parcelRequire("hgx7r");

var $8Ir8Y = parcelRequire("8Ir8Y");
const $a2af67911c389bee$var$BUTTON_CONTAINER_WIDTH = 46;
const $a2af67911c389bee$var$NotificationBubble = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'rendered',
            actionSubject: 'icon'
        }), `${(0, $aVlZX.NEXT_BEST_TASK_ANALYTICS)}.notificationBubble.rendered`);
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a2af67911c389bee$var$PresenceActionIconWrapper, {
        "data-testid": "insights-next-best-task-filter-button.ui.presence-action-icon-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a2af67911c389bee$var$PresenceActionIconBorder, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gGyns))), {
        label: formatMessage((0, $hgx7r.default).presenceActionIconLabelNonfinal),
        primaryColor: "var(--ds-icon-accent-blue, #1D7AFC)",
        size: "small"
    })));
};
const $a2af67911c389bee$export$2564d52c691f5986 = ({ showBubble: showBubble = false })=>{
    const { isOpen: isOpen, isControlVisible: isControlVisible, isNbtToggleButtonVisible: isNbtToggleButtonVisible, onTogglePanelVisibility: onTogglePanelVisibility } = (0, $5dTk9.useNextBestTaskPanel)();
    const onClick = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
        const previousIsOpen = isOpen;
        onTogglePanelVisibility();
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, `${(0, $aVlZX.NEXT_BEST_TASK_ANALYTICS)}.panelButton`, {
            panelIsOpen: !previousIsOpen,
            previousPanelIsOpen: previousIsOpen,
            previousButtonShowBubble: !previousIsOpen && showBubble
        });
    }, [
        isOpen,
        onTogglePanelVisibility,
        showBubble
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a2af67911c389bee$var$AnimatingButtonContainer, {
        isVisible: !!isControlVisible && isNbtToggleButtonVisible,
        isPanelOpen: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a2af67911c389bee$var$NBTButtonMain, {
        isAnimated: true,
        isOpen: isOpen,
        onClick: onClick,
        showBubble: showBubble
    }));
};
const $a2af67911c389bee$var$NBTButtonMain = ({ isAnimated: isAnimated, isOpen: isOpen, showBubble: showBubble, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a2af67911c389bee$var$ButtonWrapper, {
        isFixedWidth: !isAnimated
    }, !isAnimated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireUiAnalytics), {
        action: "render",
        actionSubject: "button",
        actionSubjectId: `${(0, $aVlZX.NEXT_BEST_TASK_ANALYTICS)}.panelButton`,
        attributes: {
            panelIsOpen: isOpen
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formatMessage((0, $hgx7r.default).buttonTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Ir8Y.NextBestTaskSpotlight), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        "aria-label": formatMessage((0, $hgx7r.default).buttonAriaLabel),
        isSelected: isOpen,
        onClick: onClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kODOJ))), {
            label: formatMessage((0, $hgx7r.default).buttonAriaLabel),
            primaryColor: isOpen ? undefined : `var(--ds-icon, ${0, $PdmhA.N500})`
        }),
        theme: (0, $dzpl6.getTheme)({
            buttonStyles: {
                default: {
                    padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-075, 6px)"} ${"var(--ds-space-0, 0px)"} ${"var(--ds-space-150, 12px)"}`,
                    borderRadius: '0 20px 20px 0'
                }
            }
        })
    }), !isOpen && showBubble ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a2af67911c389bee$var$NotificationBubble, null) : null)));
};
// This whole file will be removed when we cleanup 'jira.work-suggestions.remove-nbt-button' FF
// Intentionally not feature-flagging this component because it will never be rendered when FF is true
const $a2af67911c389bee$var$preloadPropertyKeys = [
    (0, $aVlZX.NEXT_BEST_TASK_PANEL_ISDISABLED_USERPROPERTY_KEY),
    (0, $aVlZX.NEXT_BEST_TASK_PANEL_LAST_OPENED_TASK_ID_USERPROPERTY_KEY)
];
const $a2af67911c389bee$export$e571ae9036888be1 = ()=>{
    const accountId = (0, $dxcfv.useAccountId)();
    if (!accountId) throw new Error('accountId could not be found');
    const { isControlVisible: isControlVisible } = (0, $5dTk9.useNextBestTaskPanel)();
    const [{ showBubble: showBubble }] = (0, $erql0.useNextBestTaskContainer)();
    if (!isControlVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g7rFt.UserPropertiesContainer), {
        scope: (0, $aVlZX.NEXT_BEST_TASK_USER_PROPERTIES_SCOPE),
        accountId: accountId,
        preloadPropertyKeys: $a2af67911c389bee$var$preloadPropertyKeys
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a2af67911c389bee$export$2564d52c691f5986, {
        showBubble: showBubble
    }));
};
const $a2af67911c389bee$export$47914911a538c5ff = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "next-best-task-button",
        packageName: (0, $aVlZX.ERROR_BOUNDARY_PACKAGE),
        fallback: "unmount"
    }, !(0, $dfBCt.isFedRamp)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a2af67911c389bee$export$e571ae9036888be1, null));
const $a2af67911c389bee$var$AnimatingButtonContainer = ({ isVisible: isVisible, isPanelOpen: isPanelOpen, children: children })=>{
    const [showOverflow, setShowOverflow] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        if (isVisible && !showOverflow) {
            setShowOverflow(true);
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                action: 'render',
                actionSubject: 'button'
            }), `${(0, $aVlZX.NEXT_BEST_TASK_ANALYTICS)}.panelButton`, {
                panelIsOpen: isPanelOpen
            });
        }
    }, [
        isVisible,
        showOverflow,
        createAnalyticsEvent,
        isPanelOpen
    ]);
    const transitionEndHandler = ()=>{
        if (!isVisible && showOverflow) setShowOverflow(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: "insights-next-best-task-filter-button.ui.animating-button-container",
        xcss: [
            $a2af67911c389bee$var$buttonTransitionStylingStyles,
            isVisible ? $a2af67911c389bee$var$enteringButtonWidthStyles : $a2af67911c389bee$var$exitingButtonWidthStyles,
            showOverflow ? $a2af67911c389bee$var$overflowVisibleStyles : $a2af67911c389bee$var$overflowHiddenStyles
        ],
        onTransitionEnd: transitionEndHandler
    }, children);
};
const $a2af67911c389bee$var$buttonTransitionStylingStyles = (0, $1ZAYh.xcss)({
    transition: 'width 0.3s ease'
});
const $a2af67911c389bee$var$enteringButtonWidthStyles = (0, $1ZAYh.xcss)({
    width: `${$a2af67911c389bee$var$BUTTON_CONTAINER_WIDTH}px`
});
const $a2af67911c389bee$var$exitingButtonWidthStyles = (0, $1ZAYh.xcss)({
    width: '0px'
});
const $a2af67911c389bee$var$overflowHiddenStyles = (0, $1ZAYh.xcss)({
    overflow: 'hidden'
});
const $a2af67911c389bee$var$overflowVisibleStyles = (0, $1ZAYh.xcss)({
    overflow: 'visible'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a2af67911c389bee$var$ButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFixedWidth: isFixedWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _1o9zidpf _kqswh2mm _4cvr1h6o _18u0xmi2 _2hwxutpp",
            __cmplp.isFixedWidth ? "_1bsb1a70" : "_1bsb1kw7",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a2af67911c389bee$var$PresenceActionIconBorder = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhklui3 _1bsb1crf _4t3i1crf _2rko1ssb _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a2af67911c389bee$var$PresenceActionIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_lcxvglyw _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _4t3i1gkc _1bsb1gkc _154ize3t _1xi2ze3t",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kODOJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f2775d08fa787154$var$_react = $f2775d08fa787154$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $f2775d08fa787154$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $f2775d08fa787154$var$DetailViewIcon = (props)=>/*#__PURE__*/ $f2775d08fa787154$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M14 17h6c.003 0 0-9.994 0-9.994C20 7 14 7 14 7v10zM12 5h8c1.105 0 2 .897 2 2.006v9.988A1.998 1.998 0 0120 19h-8V5zM2 7h8V5H2.997A.996.996 0 002 6v1zm0 4h8V9H2zm0 7c0 .552.453 1 .997 1H10v-2H2v1zm0-3h8v-2H2z" fill="currentColor"/></svg>`
    }, props));
$f2775d08fa787154$var$DetailViewIcon.displayName = 'DetailViewIcon';
var $f2775d08fa787154$var$_default = $f2775d08fa787154$var$DetailViewIcon;
module.exports.default = $f2775d08fa787154$var$_default;

});

parcelRegister("gGyns", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c25b3c367a26ef0b$var$_react = $c25b3c367a26ef0b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $c25b3c367a26ef0b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c25b3c367a26ef0b$var$PresenceActiveIcon = (props)=>/*#__PURE__*/ $c25b3c367a26ef0b$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle cx="12" cy="12" r="6" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$c25b3c367a26ef0b$var$PresenceActiveIcon.displayName = 'PresenceActiveIcon';
var $c25b3c367a26ef0b$var$_default = $c25b3c367a26ef0b$var$PresenceActiveIcon;
module.exports.default = $c25b3c367a26ef0b$var$_default;

});

parcelRegister("g7rFt", function(module, exports) {

$parcel$export(module.exports, "useUserPropertyObject", () => $395a7eaba72429d8$export$665203e55622a29c);
$parcel$export(module.exports, "UserPropertiesContainer", () => $395a7eaba72429d8$export$6a3da208e4d7c782);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");

var $fbGni = parcelRequire("fbGni");
const $395a7eaba72429d8$var$initialState = {
    properties: {}
};
const $395a7eaba72429d8$export$42a9887a08055e31 = (0, $a61MH.createStore)({
    initialState: $395a7eaba72429d8$var$initialState,
    actions: $fbGni.default,
    name: 'InsightsUserPropertiesStore'
});
const $395a7eaba72429d8$export$8e7336a0b77711a8 = (0, $ggKAj.createActionsHook)($395a7eaba72429d8$export$42a9887a08055e31);
const $395a7eaba72429d8$export$fbe59e5a949d942d = (0, $ggKAj.createHook)($395a7eaba72429d8$export$42a9887a08055e31, {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    selector: (state, propertyKey)=>{
        const isLoading = state.properties[propertyKey]?.isLoading;
        const currentValue = state.properties[propertyKey]?.value;
        const error = state.properties[propertyKey]?.error;
        const value = isLoading === false && currentValue !== undefined ? currentValue : null;
        return {
            value: value,
            isLoading: isLoading ?? false,
            error: error ?? null
        };
    }
});
const $395a7eaba72429d8$export$4599ff36ff959988 = (propertyValue)=>{
    const currentDate = new Date().getTime();
    return Object.fromEntries(Object.entries(propertyValue).filter(([_, value])=>value.expireAt == null || new Date(value.expireAt).getTime() > currentDate));
};
const $395a7eaba72429d8$var$getExpireAt = (ttl)=>new Date(new Date().getTime() + ttl).toISOString();
const $395a7eaba72429d8$export$665203e55622a29c = (propertyKey, defaultTtlInMs)=>{
    const [{ value: propertyValue, isLoading: isLoading, error: error }, { saveProperty: saveProperty, loadProperty: loadProperty, savePropertyWithoutSendRequest: savePropertyWithoutSendRequest, sendUpdatePropertyRequest: sendUpdatePropertyRequest }] = $395a7eaba72429d8$export$fbe59e5a949d942d(propertyKey);
    const debouncedSendUpdatePropertyRequestRef = (0, $eUqFw.useRef)(null);
    const save = (0, $eUqFw.useCallback)((saveKey, savePropertyValue, ttlInMs, options)=>{
        const ttl = ttlInMs || defaultTtlInMs || undefined;
        const newProperty = {
            ...propertyValue,
            [saveKey]: {
                value: savePropertyValue,
                ...ttl ? {
                    expireAt: $395a7eaba72429d8$var$getExpireAt(ttl)
                } : {}
            }
        };
        const propertyValueNotExpired = $395a7eaba72429d8$export$4599ff36ff959988(newProperty);
        if (options?.debounceMs) {
            if (debouncedSendUpdatePropertyRequestRef.current) debouncedSendUpdatePropertyRequestRef.current.cancel();
            debouncedSendUpdatePropertyRequestRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(sendUpdatePropertyRequest, options.debounceMs || 0);
            savePropertyWithoutSendRequest(propertyKey, propertyValueNotExpired);
            debouncedSendUpdatePropertyRequestRef.current(propertyKey, propertyValueNotExpired);
        } else saveProperty(propertyKey, propertyValueNotExpired, options?.isResetOnFailEnabled);
    }, [
        defaultTtlInMs,
        propertyValue,
        sendUpdatePropertyRequest,
        savePropertyWithoutSendRequest,
        propertyKey,
        saveProperty
    ]);
    const load = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (...args)=>loadProperty.bind(null, propertyKey)(...args), [
        loadProperty,
        propertyKey
    ]);
    if (!isLoading && !error && propertyValue != null) {
        const propertyValueNotExpired = $395a7eaba72429d8$export$4599ff36ff959988(propertyValue);
        return [
            {
                value: propertyValueNotExpired,
                isLoading: isLoading,
                error: error
            },
            {
                save: save,
                loadProperty: load
            }
        ];
    }
    return [
        {
            value: propertyValue,
            isLoading: isLoading,
            error: error
        },
        {
            save: save,
            loadProperty: load
        }
    ];
};
const $395a7eaba72429d8$var$handlePropsChange = ()=>({ dispatch: dispatch }, { preloadPropertyKeys: preloadPropertyKeys })=>{
        preloadPropertyKeys?.forEach((propertyKey)=>dispatch((0, $fbGni.default).loadProperty(propertyKey)));
    };
const $395a7eaba72429d8$export$6a3da208e4d7c782 = (0, $heB5U.createContainer)($395a7eaba72429d8$export$42a9887a08055e31, {
    onInit: $395a7eaba72429d8$var$handlePropsChange,
    onUpdate: $395a7eaba72429d8$var$handlePropsChange
});

});
parcelRegister("fbGni", function(module, exports) {

$parcel$export(module.exports, "default", () => $917caae53762bf06$export$2e2bcd8739ae039);

var $fWPdf = parcelRequire("fWPdf");

var $1ou7Q = parcelRequire("1ou7Q");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$917caae53762bf06$export$2e2bcd8739ae039 = {
    loadProperty: $fWPdf.loadProperty,
    saveProperty: $1ou7Q.saveProperty,
    savePropertyWithoutSendRequest: $1ou7Q.savePropertyWithoutSendRequest,
    sendUpdatePropertyRequest: $1ou7Q.sendUpdatePropertyRequest
};

});
parcelRegister("fWPdf", function(module, exports) {

$parcel$export(module.exports, "loadProperty", () => $93dc8bb3666435e1$export$7bfbec0ee20deb4b);

var $48bs8 = parcelRequire("48bs8");

var $gUUjF = parcelRequire("gUUjF");

var $7EhAs = parcelRequire("7EhAs");

const $93dc8bb3666435e1$export$7bfbec0ee20deb4b = (propertyKey, isRefetch = false)=>async ({ setState: setState, getState: getState }, { accountId: accountId })=>{
        if (!accountId) return;
        const property = getState().properties[propertyKey];
        const isLoading = property?.isLoading === true;
        const hasLoadedSuccessfully = property?.isLoading === false && property?.error == null;
        // skip, if already loaded or loading
        if (isLoading || hasLoadedSuccessfully && !isRefetch) return;
        setState({
            properties: {
                ...getState().properties,
                [propertyKey]: {
                    isLoading: true,
                    error: null,
                    value: null
                }
            }
        });
        try {
            const value = await (0, $48bs8.getUserProperty)('', accountId, propertyKey);
            setState({
                properties: {
                    ...getState().properties,
                    [propertyKey]: {
                        isLoading: false,
                        error: null,
                        value: value
                    }
                }
            });
        } catch (error) {
            if (error instanceof (0, $7EhAs.default)) {
                setState({
                    properties: {
                        ...getState().properties,
                        [propertyKey]: {
                            isLoading: false,
                            error: error,
                            value: null
                        }
                    }
                });
                if (error.statusCode >= 500 && error.statusCode <= 599) (0, $gUUjF.default).safeErrorWithoutCustomerData(`${(0, $3523ef16f82a4788$export$d3996f57ffa8448f)}.user-properties-error`, `Failed to load user property with key: ${propertyKey}`, error);
            } else throw error;
        }
    };

});

parcelRegister("1ou7Q", function(module, exports) {

$parcel$export(module.exports, "saveProperty", () => $dc79e753a79aa0b1$export$3d751d226e9d1512);
$parcel$export(module.exports, "savePropertyWithoutSendRequest", () => $dc79e753a79aa0b1$export$588b3a5c6ec210);
$parcel$export(module.exports, "sendUpdatePropertyRequest", () => $dc79e753a79aa0b1$export$f83f0aadc36cc25f);

var $gUUjF = parcelRequire("gUUjF");

var $7EhAs = parcelRequire("7EhAs");


var $awxYr = parcelRequire("awxYr");
const $dc79e753a79aa0b1$export$3d751d226e9d1512 = (propertyKey, value, isResetOnFailEnabled = true)=>async ({ setState: setState, getState: getState }, { accountId: accountId })=>{
        if (!accountId) return;
        const oldValue = getState().properties[propertyKey]?.value;
        setState({
            properties: {
                ...getState().properties,
                [propertyKey]: {
                    value: value,
                    isLoading: false,
                    error: null
                }
            }
        });
        try {
            await (0, $awxYr.setUserProperties)(accountId, propertyKey, value);
        } catch (error) {
            if (error instanceof (0, $7EhAs.default)) {
                // rollback optimistic update on setUserProperties failure
                if (isResetOnFailEnabled) setState({
                    properties: {
                        ...getState().properties,
                        [propertyKey]: {
                            value: oldValue,
                            isLoading: false,
                            error: null
                        }
                    }
                });
                if (error.statusCode >= 500 && error.statusCode <= 599) (0, $gUUjF.default).safeErrorWithoutCustomerData(`${(0, $3523ef16f82a4788$export$d3996f57ffa8448f)}.user-properties-error`, `Failed to save user property with key: ${propertyKey}`, error);
            } else throw error;
        }
    };
const $dc79e753a79aa0b1$export$588b3a5c6ec210 = (propertyKey, value)=>({ setState: setState, getState: getState }, { accountId: accountId })=>{
        if (!accountId) return;
        setState({
            properties: {
                ...getState().properties,
                [propertyKey]: {
                    value: value,
                    isLoading: false,
                    error: null
                }
            }
        });
    };
const $dc79e753a79aa0b1$export$f83f0aadc36cc25f = (propertyKey, value)=>async (_, { accountId: accountId })=>{
        if (!accountId) return;
        try {
            await (0, $awxYr.setUserProperties)(accountId, propertyKey, value);
        } catch (error) {
            if (error instanceof (0, $7EhAs.default)) {
                if (error.statusCode >= 500 && error.statusCode <= 599) (0, $gUUjF.default).safeErrorWithoutCustomerData(`${(0, $3523ef16f82a4788$export$d3996f57ffa8448f)}.user-properties-error`, `Failed to save user property with key: ${propertyKey}`, error);
            } else throw error;
        }
    };

});
parcelRegister("awxYr", function(module, exports) {

$parcel$export(module.exports, "setUserProperties", () => $403ae437cc2d2ee4$export$d0e176862bf869b8);

var $48bs8 = parcelRequire("48bs8");

var $7EhAs = parcelRequire("7EhAs");
const $403ae437cc2d2ee4$export$d0e176862bf869b8 = async (accountId, propertyKey, value)=>{
    const res = await (0, $48bs8.setUserProperties)('', accountId, propertyKey, JSON.stringify(value) || '');
    if (res.status >= 400 && res.status <= 599) {
        const errResp = await res.text();
        throw new (0, $7EhAs.default)(res.status, errResp);
    }
    return res;
};

});




parcelRegister("5dTk9", function(module, exports) {

$parcel$export(module.exports, "useNextBestTaskPanel", () => $11d765e0efc59644$export$9fac49065b5c5925);

var $1ybV0 = parcelRequire("1ybV0");

var $g7rFt = parcelRequire("g7rFt");

var $3HCkE = parcelRequire("3HCkE");

var $gyys9 = parcelRequire("gyys9");

var $aVlZX = parcelRequire("aVlZX");

var $erql0 = parcelRequire("erql0");
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $11d765e0efc59644$var$noop = ()=>{};
const $11d765e0efc59644$export$9fac49065b5c5925 = ()=>{
    const [{ isAutoOpened: isAutoOpened, isHiddenByUser: isHiddenByUser, isNbtToggleButtonVisible: isNbtToggleButtonVisible, isOnlyCurrentUserSelected: isOnlyCurrentUserSelected }, { setIsAutoOpened: setIsAutoOpened, setIsNbtToggleButtonVisible: setIsNbtToggleButtonVisible }] = (0, $erql0.useNextBestTaskContainer)();
    const [{ value: isNBTPanelDisabledProperty, isLoading: isLoading }, { save: save }] = !(0, $1ybV0.ff)('jira.work-suggestions.remove-nbt-button') ? (0, $g7rFt.useUserPropertyObject)((0, $aVlZX.NEXT_BEST_TASK_PANEL_ISDISABLED_USERPROPERTY_KEY)) : [
        {
            value: undefined,
            isLoading: false
        },
        {
            save: $11d765e0efc59644$var$noop
        }
    ];
    const { data: isWorkSuggestionsEnabledData } = (0, $3HCkE.useResource)((0, $gyys9.nextBestTaskFeatureResource));
    const hasUserOptedIn = !!isWorkSuggestionsEnabledData?.hasUserOptedIn;
    // Replace isControlVisible with after `jira.work-suggestions.remove-nbt-button` FF is removed
    const isControlVisible = !(0, $1ybV0.ff)('jira.work-suggestions.remove-nbt-button') && isOnlyCurrentUserSelected && hasUserOptedIn;
    const isReadyToFetchNBT = isOnlyCurrentUserSelected && hasUserOptedIn && ((0, $1ybV0.ff)('jira.work-suggestions.remove-nbt-button') ? !isHiddenByUser : true);
    const isOpen = isReadyToFetchNBT && isAutoOpened && ((0, $1ybV0.ff)('jira.work-suggestions.remove-nbt-button') ? !isHiddenByUser : !isNBTPanelDisabledProperty?.isDisabled.value && !isLoading);
    // Remove this function after `jira.work-suggestions.remove-nbt-button` FF is removed
    const toggleNBTPanelIsDisabled = ()=>{
        if (!isAutoOpened) setIsAutoOpened(true);
        save('isDisabled', isOpen, undefined, {
            debounceMs: (0, $aVlZX.NEXT_BEST_TASK_PANEL_ISDISABLED_STATE_UPDATE_DEBOUNCE_MS)
        });
    };
    return {
        isControlVisible: isControlVisible,
        isReadyToFetchNBT: isReadyToFetchNBT,
        isOpen: isOpen,
        isAutoOpened: isAutoOpened,
        isNbtToggleButtonVisible: isNbtToggleButtonVisible,
        setIsAutoOpened: setIsAutoOpened,
        isHiddenByUser: isHiddenByUser,
        setIsNbtToggleButtonVisible: setIsNbtToggleButtonVisible,
        onTogglePanelVisibility: toggleNBTPanelIsDisabled
    };
};

});

parcelRegister("hgx7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff171d87ac4b491e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ff171d87ac4b491e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    buttonAriaLabel: {
        "id": "insights-next-best-task-filter-button.button-aria-label",
        "defaultMessage": "Your work suggestions panel"
    },
    buttonTooltip: {
        "id": "insights-next-best-task-filter-button.button-tooltip",
        "defaultMessage": "Work suggestions"
    },
    presenceActionIconLabelNonfinal: {
        "id": "insights-next-best-task-filter-button.presence-action-icon-label-nonfinal",
        "defaultMessage": "New work suggestions"
    }
});

});

parcelRegister("8Ir8Y", function(module, exports) {

$parcel$export(module.exports, "NextBestTaskSpotlight", () => $9b4709dfd8c0dad7$export$375f63786b3e9c0);

var $eUqFw = parcelRequire("eUqFw");

var $9WJJx = parcelRequire("9WJJx");

var $lcnyw = parcelRequire("lcnyw");

var $4kZbn = parcelRequire("4kZbn");

var $5dTk9 = parcelRequire("5dTk9");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dxcfv = parcelRequire("dxcfv");


var $6txg0 = parcelRequire("6txg0");
function $9b4709dfd8c0dad7$var$useOnceFalse(inputValue) {
    const previousInputValue = (0, $eUqFw.useRef)(inputValue);
    const [hasChangedToFalse, setHasChangedToFalse] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (previousInputValue.current && inputValue === false) setHasChangedToFalse(true);
        previousInputValue.current = inputValue;
    }, [
        inputValue,
        setHasChangedToFalse
    ]);
    return hasChangedToFalse;
}
const $9b4709dfd8c0dad7$export$375f63786b3e9c0 = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { isOpen: isOpen } = (0, $5dTk9.useNextBestTaskPanel)();
    const accountId = (0, $dxcfv.useAccountId)();
    const [hasSpotlightBeenViewed, setHasSpotlightBeenViewed] = (0, $4kZbn.useLocalStorage)((0, $1e8f6dbaa7aaec91$export$30db34d13f11d49d), `spotlight-${accountId}`, {
        defaultValue: false
    });
    const hasPanelBeenHidden = $9b4709dfd8c0dad7$var$useOnceFalse(isOpen || false);
    const isSpotlightVisible = hasPanelBeenHidden && !hasSpotlightBeenViewed;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9WJJx.NudgeSpotlight), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        pulseBorderRadius: '0 20px 20px 0',
        position: "bottom-start",
        content: formatMessage((0, $6txg0.default).spotlightMessage),
        hidden: !isSpotlightVisible,
        setHidden: ()=>{
        /* handled via alternate state */ },
        onOutsideClick: ()=>setHasSpotlightBeenViewed(true),
        zIndex: (0, $lcnyw.layers).dialog()
    }, children);
};

});
const $1e8f6dbaa7aaec91$export$30db34d13f11d49d = 'jira-insights-nbt-spotlight-viewed';

parcelRegister("6txg0", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7cff477b10faf9c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f7cff477b10faf9c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    spotlightMessage: {
        "id": "insights-next-best-task-filter-button.spotlight.spotlight-message",
        "defaultMessage": "Open your work suggestions panel here"
    }
});

});



parcelRegister("9pw6N", function(module, exports) {

$parcel$export(module.exports, "FILTER_PREFIX", () => $0967a5c8c840826d$export$d6acfe0d617669c3);
$parcel$export(module.exports, "Z_INDEX", () => $0967a5c8c840826d$export$42310dd57a41067);
const $0967a5c8c840826d$export$d6acfe0d617669c3 = 'assignee';
const $0967a5c8c840826d$export$42310dd57a41067 = {
    SELECTED: 1,
    ADD: 2,
    MENU: 3,
    HOVER: 4
};
const $0967a5c8c840826d$export$e70f7f4a08e4d8fb = 10;
const $0967a5c8c840826d$export$75297e3804621b0 = 36;

});

parcelRegister("ddnmK", function(module, exports) {

$parcel$export(module.exports, "default", () => $70ddc227f3bf4696$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $jG2Eu = parcelRequire("jG2Eu");

var $eri7S = parcelRequire("eri7S");

var $iisnK = parcelRequire("iisnK");

var $2qhQi = parcelRequire("2qhQi");

var $kS8l2 = parcelRequire("kS8l2");

var $aked2 = parcelRequire("aked2");

var $8k8RR = parcelRequire("8k8RR");

var $9pw6N = parcelRequire("9pw6N");

var $9bwt3 = parcelRequire("9bwt3");

var $c6LJE = parcelRequire("c6LJE");

var $3zepQ = parcelRequire("3zepQ");
const $70ddc227f3bf4696$var$ADD_PEOPLE_BUTTON_TARGET = 'addPeopleButtonTarget';
const $70ddc227f3bf4696$var$AddUsersButton = (props)=>{
    const { intl: { formatMessage: formatMessage }, onClick: onClickProp, peopleButtonRef: peopleButtonRef } = props;
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        (0, $9bwt3.onBlur)(event);
        onClickProp();
    }, [
        onClickProp
    ]);
    const [, { register: register }] = (0, $kS8l2.useGlobalRefStoreActions)();
    const onRef = (0, $eUqFw.useCallback)((ref)=>{
        register($70ddc227f3bf4696$var$ADD_PEOPLE_BUTTON_TARGET, ref);
    }, [
        register
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($70ddc227f3bf4696$var$AddButtonWrapper, {
        ref: onRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aked2.AssigneeFilterAddPeopleButtonWrapperNudgeAsync), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3zepQ.AddPeopleTooltip), {
        content: formatMessage((0, $c6LJE.default).addPeople)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($70ddc227f3bf4696$var$ActionAvatarWrapper, {
        ref: peopleButtonRef,
        "data-test-id": "filters.ui.filters.assignee.stateless.add-button",
        "data-testid": "filters.ui.filters.assignee.stateless.add-button",
        "data-pollinator-filter-bar-add-people": true,
        id: `${(0, $9pw6N.FILTER_PREFIX)}-add-person`,
        "aria-label": formatMessage((0, $c6LJE.default).addPeople),
        onClick: onClick,
        "aria-describedby": (0, $9pw6N.FILTER_PREFIX)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($70ddc227f3bf4696$var$AddButtonAvatarSpacer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iisnK))), {
        size: "medium",
        label: formatMessage((0, $c6LJE.default).addPeople)
    }))))));
};
$70ddc227f3bf4696$var$AddUsersButton.defaultProps = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
var $70ddc227f3bf4696$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $2qhQi.default)($70ddc227f3bf4696$var$AddUsersButton);
const $70ddc227f3bf4696$var$AddButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $70ddc227f3bf4696$var$ActionAvatarWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $8k8RR.ActionAvatar), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1ssb _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $70ddc227f3bf4696$var$AddButtonAvatarSpacer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $8k8RR.ActionAvatarSpacer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1lu4wzb": (0, $9t7rW.default)((0, $eri7S.AVATAR_SIZES).medium, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko12pq _1ul912pq _1bsb1wug _1yt4otz2 _vchhusvi _bfhk1s4m _1p9v18uv",
            __cmplp.className
        ])
    });
});
const $70ddc227f3bf4696$export$7ed12d2a5241e393 = {
    ActionAvatarWrapper: $70ddc227f3bf4696$var$ActionAvatarWrapper
};

});
parcelRegister("iisnK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d51fec82b4cf5254$var$_react = $d51fec82b4cf5254$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $d51fec82b4cf5254$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d51fec82b4cf5254$var$InviteTeamIcon = (props)=>/*#__PURE__*/ $d51fec82b4cf5254$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><rect x="18" y="5" width="2" height="6" rx="1"/><rect x="16" y="7" width="6" height="2" rx="1"/><path d="M5 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0V14z"/><circle cx="11" cy="7" r="4"/></g></svg>`
    }, props));
$d51fec82b4cf5254$var$InviteTeamIcon.displayName = 'InviteTeamIcon';
var $d51fec82b4cf5254$var$_default = $d51fec82b4cf5254$var$InviteTeamIcon;
module.exports.default = $d51fec82b4cf5254$var$_default;

});

parcelRegister("aked2", function(module, exports) {

$parcel$export(module.exports, "AssigneeFilterAddPeopleButtonWrapperNudgeAsync", () => $3995bf095383eb37$export$4e4097c2567f79b7);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");


var $ewdMq = parcelRequire("ewdMq");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3995bf095383eb37$var$AssigneeFilterAddPeopleButtonLazy = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("kIell")).then((exportedModule)=>exportedModule.AssigneeFilterAddPeopleButtonWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/assignee-filter-add-people/index.tsx"
});
const $3995bf095383eb37$export$4e4097c2567f79b7 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewdMq.OnboardingNudgeErrorBoundary), {
        id: (0, $8379f5d78bf6fb5a$export$92c7f0eacc8d8d98),
        fallback: children,
        attributes: {
            nudgeId: (0, $8379f5d78bf6fb5a$export$92c7f0eacc8d8d98)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "software-onboarding-assignee-filter-add-people-nudge",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3995bf095383eb37$var$AssigneeFilterAddPeopleButtonLazy, {
        nudgeId: (0, $8379f5d78bf6fb5a$export$92c7f0eacc8d8d98)
    }, children)));

});
parcelRegister("kIell", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('l5jGp')
        ]);
        const value = parcelRequire('htukB');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("l5jGp")
    ]).then(()=>parcelRequire('htukB'));
}

});


parcelRegister("8k8RR", function(module, exports) {

$parcel$export(module.exports, "AvatarWrapper", () => $325bbcd3886753b0$export$f7513421c53ce141);
$parcel$export(module.exports, "ActionAvatar", () => $325bbcd3886753b0$export$1a5d4fdc8fa41cfb);
$parcel$export(module.exports, "ActionAvatarSpacer", () => $325bbcd3886753b0$export$d1aac2da5f30c370);
$parcel$export(module.exports, "AvatarBorder", () => $325bbcd3886753b0$export$398a7826f6fd570e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eri7S = parcelRequire("eri7S");

var $9pw6N = parcelRequire("9pw6N");
const $325bbcd3886753b0$export$483a2b43be170225 = {
    position: 'absolute',
    width: '100%',
    height: '100%',
    padding: 0,
    border: 0,
    opacity: 0,
    overflow: 'hidden',
    'white-space': 'nowrap',
    cursor: 'pointer'
};
const $325bbcd3886753b0$export$f7513421c53ce141 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { zIndex: zIndex, jiggle: jiggle, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_10xi207": (0, $9t7rW.default)(__cmplp.zIndex + (0, $9pw6N.Z_INDEX).SELECTED),
            "--_3qw8s9": (0, $9t7rW.default)(__cmplp.zIndex),
            "--_1rh09jt": (0, $9t7rW.default)(__cmplp.zIndex + (0, $9pw6N.Z_INDEX).HOVER)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _4cvr1h6o _4t3i1ylp _kqswh2mm _18u014id _bfhk18uv _s7n4jp4b _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _v5644a6k _2rko1ssb _11cpidpf _rk8t1bgr _1dig1bgr _yt1x1bgr _qa15stnw _1tfxstnw _ixiwstnw _1wnsb3bt _h10pb3bt _1boqb3bt _328d1osq _cqfi1osq _rtz31osq _1mhnidpf _44x7idpf _l3jaidpf _1rky1n1a _1a071n1a _1wtq1n1a _1xpg1n1a _ti301n1a _1j2w1n1a _s1sf1mrw _1v981mrw _x2d61mrw _1pcqvab1 _1qb3vab1 _1b1bvab1 _vdzntlke _1virtlke _1y7ctlke",
            __cmplp.selected ? "_1pby1ho9" : "_1pby1hh6",
            __cmplp.jiggle ? "_1bvqr915 _66dkr915 _1llwr915" : "_1bvq1kli _66dk1kli _1llw1kli",
            __cmplp.jiggle ? "_n3lxmyb0 _gabdmyb0 _9di1myb0" : "_n3lxidpf _gabdidpf _9di1idpf",
            __cmplp.className
        ])
    });
});
const $325bbcd3886753b0$export$1a5d4fdc8fa41cfb = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2rko1ssb _19it7zi8 _bfhk1s4m _v5644dm8 _80omtlke _7ehi12h7 _nt751r31 _49pcglyw _1hvw1o36 _irr3yucn",
            __cmplp.className
        ])
    });
});
const $325bbcd3886753b0$export$d1aac2da5f30c370 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1lu4wzb": (0, $9t7rW.default)((0, $eri7S.AVATAR_SIZES).medium, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1ssb _1e0c1txw _4cvr1h6o _1bah1h6o _1bsb12pq _4t3i12pq _bfhk18uv _syaz8a6j _vwz412pq",
            __cmplp.className
        ])
    });
});
const $325bbcd3886753b0$export$398a7826f6fd570e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1ssb _19itj1ic",
            __cmplp.selected ? "_1h6d1c86" : "_1h6d3acm",
            __cmplp.className
        ])
    });
});

});

parcelRegister("9bwt3", function(module, exports) {

$parcel$export(module.exports, "onBlur", () => $9033ffcb430e0776$export$5e446bc31724fca4);
$parcel$export(module.exports, "useOnKeyPress", () => $9033ffcb430e0776$export$49f6dd346c7dfb52);

var $eUqFw = parcelRequire("eUqFw");
const $9033ffcb430e0776$export$5e446bc31724fca4 = (event)=>{
    event.currentTarget.blur();
};
const $9033ffcb430e0776$export$49f6dd346c7dfb52 = (callback)=>(0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Enter') callback(event);
    }, [
        callback
    ]);

});

parcelRegister("c6LJE", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ba036c0ba7538c3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4ba036c0ba7538c3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addPeople: {
        "id": "software-filters.filters.assignee.stateless.add-button.add-people",
        "defaultMessage": "Add people"
    }
});

});

parcelRegister("3zepQ", function(module, exports) {

$parcel$export(module.exports, "AddPeopleTooltip", () => $5da98676a909d737$export$7d4858372ded9f0e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8cU5f = parcelRequire("8cU5f");
const $5da98676a909d737$export$7d4858372ded9f0e = ({ content: content, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5da98676a909d737$var$TooltipWrapper, null, children));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5da98676a909d737$var$TooltipWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _kqswh2mm _12ji1r31 _1qu2glyw _12y3idpf _4t3i14no",
            __cmplp.className
        ])
    });
});

});


parcelRegister("1Y4Nh", function(module, exports) {

$parcel$export(module.exports, "default", () => $a09bf05d0581ac1d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $iJlfe = parcelRequire("iJlfe");

var $8cU5f = parcelRequire("8cU5f");

var $1Iui1 = parcelRequire("1Iui1");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $2qhQi = parcelRequire("2qhQi");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $l4zCR = parcelRequire("l4zCR");

var $8k8RR = parcelRequire("8k8RR");

var $9bwt3 = parcelRequire("9bwt3");

var $9lr32 = parcelRequire("9lr32");

var $43XZb = parcelRequire("43XZb");
const $a09bf05d0581ac1d$var$type = 'assignee';
const $a09bf05d0581ac1d$var$AvatarWithAnalytics = ({ isRealtimePresenceEnabled: isRealtimePresenceEnabled, intl: intl, ...user })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = intl;
    const onShow = ()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'tooltip viewed');
    };
    const altTextWithPresence = formatMessage(user.presence === 'online' ? (0, $43XZb.default).presenceOnlineLabel : (0, $43XZb.default).presenceOfflineLabel, {
        name: user.displayName
    });
    if (isRealtimePresenceEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9lr32.default), {
        content: user.label || user.displayName,
        onShow: onShow,
        tag: "span",
        presence: user.presence
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        testId: "filters.ui.filters.assignee.stateless.avatar.ak-avatar",
        size: "medium",
        as: "span",
        src: user.avatarUrl,
        name: user.presence ? altTextWithPresence : user.displayName,
        presence: user.presence
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: user.label || user.displayName,
        onShow: onShow,
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        testId: "filters.ui.filters.assignee.stateless.avatar.ak-avatar",
        size: "medium",
        as: "span",
        src: user.avatarUrl,
        name: user.displayName,
        presence: user.presence
    }));
};
const $a09bf05d0581ac1d$var$Avatar = (props)=>{
    const { user: user, isSelected: isSelected, zIndex: zIndex, intl: intl } = props;
    const { formatMessage: formatMessage } = intl;
    const userIdentifier = user.id;
    const checkboxId = `${$a09bf05d0581ac1d$var$type}-${userIdentifier}`;
    const onToggle = (0, $eUqFw.useCallback)(()=>{
        props.onToggle(user.id);
    }, [
        props,
        user.id
    ]);
    const onKeyPress = (0, $9bwt3.useOnKeyPress)(onToggle);
    const { experimentCohort: experimentCohort } = (0, $l4zCR.useRealtimePresenceExperiment)();
    const isRealtimePresenceEnabled = experimentCohort === (0, $1Iui1.VARIATION);
    const altTextWithPresence = formatMessage(user.presence === 'online' ? (0, $43XZb.default).presenceOnlineLabel : (0, $43XZb.default).presenceOfflineLabel, {
        name: user.displayName
    });
    const avatarWithTooltip = isRealtimePresenceEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9lr32.default), {
        content: user.displayName,
        presence: user.presence,
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        testId: "filters.ui.filters.assignee.stateless.avatar.ak-avatar",
        size: "medium",
        as: "span",
        src: user.avatarUrl,
        name: user.presence ? altTextWithPresence : user.displayName,
        presence: user.presence
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: user.displayName,
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        testId: "filters.ui.filters.assignee.stateless.avatar.ak-avatar",
        size: "medium",
        as: "span",
        src: user.avatarUrl,
        name: user.displayName,
        presence: user.presence
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8k8RR.AvatarWrapper), {
        selected: isSelected,
        zIndex: zIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a09bf05d0581ac1d$var$AvatarInputCheckbox, {
        ...(0, $eI5EY.fg)('jira-software-roadmap-standard-a11y') && {
            'aria-label': formatMessage((0, $43XZb.default).avatarInputCheckboxLabel)
        },
        type: "checkbox",
        id: checkboxId,
        name: $a09bf05d0581ac1d$var$type,
        value: userIdentifier,
        defaultChecked: isSelected,
        onChange: onToggle,
        onKeyPress: onKeyPress,
        onClick: (0, $9bwt3.onBlur)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8k8RR.AvatarBorder), {
        selected: isSelected
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a09bf05d0581ac1d$var$AvatarLabel, {
        "data-test-id": "filters.ui.filters.assignee.stateless.avatar.assignee-filter-avatar",
        "data-testid": "filters.ui.filters.assignee.stateless.avatar.assignee-filter-avatar",
        htmlFor: checkboxId
    }, (0, $1ybV0.ff)('jsw.enable.avatar.tooltip.label.and.analytic_hikl3') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a09bf05d0581ac1d$var$AvatarWithAnalytics, {
        ...user,
        isRealtimePresenceEnabled: isRealtimePresenceEnabled,
        intl: intl
    }) : avatarWithTooltip)));
};
$a09bf05d0581ac1d$var$Avatar.defaultProps = {
    isSelected: false,
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
var $a09bf05d0581ac1d$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $2qhQi.default)($a09bf05d0581ac1d$var$Avatar);
const $a09bf05d0581ac1d$var$AvatarLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz4idpf _1e0c1ule _80omtlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $a09bf05d0581ac1d$var$AvatarInputCheckbox = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1bsb1osq _4t3i1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _tzy4idpf _1reo15vq _18m915vq _o5721q9c _80omtlke _1xp4rg51",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a09bf05d0581ac1d$export$7ed12d2a5241e393 = {
    AvatarInputCheckbox: $a09bf05d0581ac1d$var$AvatarInputCheckbox
};

});
parcelRegister("l4zCR", function(module, exports) {

$parcel$export(module.exports, "useRealtimePresenceExperiment", () => $fd97030f85875137$export$ba964695877b24);

var $d2wNG = parcelRequire("d2wNG");

var $79xbN = parcelRequire("79xbN");

var $21Sgb = parcelRequire("21Sgb");
const $fd97030f85875137$export$ba964695877b24 = ()=>{
    const firstActivationDateMs = (0, $21Sgb.useFirstActivationDateMs)();
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_board_real-time_collaboration_through_presence');
    return {
        experimentCohort: !firstActivationDateMs || (0, $d2wNG.default)(new Date(), firstActivationDateMs) < 30 ? 'not-enrolled' : expConfig.get('cohort', 'not-enrolled')
    };
};

});

parcelRegister("9lr32", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4523828920fa75c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2MpRo = parcelRequire("2MpRo");
const $c4523828920fa75c$var$PresenceTooltip = ({ presence: presence, content: content, children: children, ...restProps })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const contentWithPresence = presence === 'online' ? formatMessage((0, $2MpRo.default).presenceToolTipOnline, {
        name: String(content)
    }) : formatMessage((0, $2MpRo.default).presenceToolTipOffline, {
        name: String(content)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: presence ? contentWithPresence : content,
        ...restProps
    }, children);
};
var $c4523828920fa75c$export$2e2bcd8739ae039 = $c4523828920fa75c$var$PresenceTooltip;

});
parcelRegister("2MpRo", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9e99513c5816bd7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a9e99513c5816bd7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    presenceToolTipOnline: {
        "id": "software-filters.common.presence-tooltip.presence-tool-tip-online",
        "defaultMessage": "{name} is online"
    },
    presenceToolTipOffline: {
        "id": "software-filters.common.presence-tooltip.presence-tool-tip-offline",
        "defaultMessage": "{name} is offline"
    }
});

});


parcelRegister("43XZb", function(module, exports) {

$parcel$export(module.exports, "default", () => $28562c6ddb0b4980$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $28562c6ddb0b4980$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    presenceOnlineLabel: {
        "id": "software-filters.filters.assignee.stateless.avatar.presence-online-label",
        "defaultMessage": "{name} (online)"
    },
    presenceOfflineLabel: {
        "id": "software-filters.filters.assignee.stateless.avatar.presence-offline-label",
        "defaultMessage": "{name} (offline)"
    },
    avatarInputCheckboxLabel: {
        "id": "software-filters.filters.assignee.stateless.avatar.avatar-input-checkbox-label",
        "defaultMessage": "assignee filter avatar"
    }
});

});


parcelRegister("l2Yeb", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ec85272c96e5b8f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1ec85272c96e5b8f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "software-filters.filters.assignee.stateless.label",
        "defaultMessage": "Filter by assignee"
    }
});

});

parcelRegister("fGrG2", function(module, exports) {

$parcel$export(module.exports, "default", () => $f094d1bb53629df3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $iJlfe = parcelRequire("iJlfe");

var $6OfWd = parcelRequire("6OfWd");
var $9mc6u = parcelRequire("9mc6u");

var $8cU5f = parcelRequire("8cU5f");

var $1Iui1 = parcelRequire("1Iui1");

var $l4zCR = parcelRequire("l4zCR");

var $6vrw7 = parcelRequire("6vrw7");

var $8k8RR = parcelRequire("8k8RR");

var $9pw6N = parcelRequire("9pw6N");

var $9bwt3 = parcelRequire("9bwt3");

var $9lr32 = parcelRequire("9lr32");
const $f094d1bb53629df3$var$ShowMoreButton = (props)=>{
    const { users: users, selectedUsers: selectedUsers, onOpen: onOpen, onItemActivated: onItemActivatedProps } = props;
    const [isOpen, setOpenState] = (0, $eUqFw.useState)(false);
    const _onOpenChange = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (attrs)=>{
        setOpenState(attrs.isOpen);
        if (attrs.isOpen) onOpen();
    }, [
        setOpenState,
        onOpen
    ]);
    const isSelected = (0, $eUqFw.useMemo)(()=>users.some((user)=>selectedUsers.includes(user.id)), [
        users,
        selectedUsers
    ]);
    const { experimentCohort: experimentCohort } = (0, $l4zCR.useRealtimePresenceExperiment)();
    const isRealtimePresenceEnabled = experimentCohort === (0, $1Iui1.VARIATION);
    const dropdownItems = (0, $eUqFw.useMemo)(()=>users.map(({ id: id, displayName: displayName, avatarUrl: avatarUrl, presence: presence })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f094d1bb53629df3$var$ItemWrapper, {
                key: id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9mc6u.default), {
                id: id,
                isSelected: selectedUsers.includes(id),
                onClick: ()=>{
                    onItemActivatedProps((0, $6vrw7.toAccountId)(String(id)));
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f094d1bb53629df3$var$ItemContent, null, isRealtimePresenceEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9lr32.default), {
                content: displayName,
                presence: presence
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f094d1bb53629df3$var$DropdownAvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                size: "small",
                src: avatarUrl,
                name: displayName,
                presence: presence
            }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
                content: displayName
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f094d1bb53629df3$var$DropdownAvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                size: "small",
                src: avatarUrl,
                name: displayName,
                presence: presence
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f094d1bb53629df3$var$TextContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f094d1bb53629df3$var$TextContent, null, displayName)))))), [
        users,
        selectedUsers,
        onItemActivatedProps,
        isRealtimePresenceEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f094d1bb53629df3$var$DropdownMenuWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8k8RR.AvatarWrapper), {
                ...triggerProps,
                ref: triggerRef,
                zIndex: (0, $9pw6N.Z_INDEX).MENU
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f094d1bb53629df3$var$ActionInputCheckbox, {
                "data-test-id": "filters.ui.filters.assignee.stateless.show-more-button.assignee-filter-show-more",
                "data-testid": "filters.ui.filters.assignee.stateless.show-more-button.assignee-filter-show-more",
                type: "checkbox",
                id: `${(0, $9pw6N.FILTER_PREFIX)}-show-more`,
                name: (0, $9pw6N.FILTER_PREFIX),
                value: `${(0, $9pw6N.FILTER_PREFIX)}-show-more`,
                defaultChecked: isOpen,
                "aria-describedby": (0, $9pw6N.FILTER_PREFIX),
                onClick: (0, $9bwt3.onBlur)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8k8RR.AvatarBorder), {
                selected: isSelected
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8k8RR.ActionAvatar), {
                tabIndex: -1
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8k8RR.ActionAvatarSpacer), null, `+${users.length}`))))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f094d1bb53629df3$var$DropdownItemsWrapper, null, dropdownItems)));
};
$f094d1bb53629df3$var$ShowMoreButton.defaultProps = {
    onItemActivated: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
var $f094d1bb53629df3$export$2e2bcd8739ae039 = $f094d1bb53629df3$var$ShowMoreButton;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f094d1bb53629df3$var$DropdownMenuWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _4cvr1h6o _18u014id _1pbyidpf",
            __cmplp.className
        ])
    });
});
const $f094d1bb53629df3$var$DropdownItemsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1mjv _1yt4swc3",
            __cmplp.className
        ])
    });
});
const $f094d1bb53629df3$var$ItemWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1t4ug9d8 _k907ze3t",
            __cmplp.className
        ])
    });
});
const $f094d1bb53629df3$var$ItemContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $f094d1bb53629df3$var$DropdownAvatarWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _18u0v77o",
            __cmplp.className
        ])
    });
});
const $f094d1bb53629df3$var$TextContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _18s816r1 _1yt41w01 _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $f094d1bb53629df3$var$TextContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $f094d1bb53629df3$var$ActionInputCheckbox = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1bsb1osq _4t3i1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _tzy4idpf _1reo15vq _18m915vq _o5721q9c _80omtlke _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1glwzk5k _5o9f194a",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9mc6u", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdd85e99771c9c60$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");

var $8jcoK = parcelRequire("8jcoK");

var $bULPy = parcelRequire("bULPy");

var $caOPr = parcelRequire("caOPr");

var $4lVNM = parcelRequire("4lVNM");

var $h1Q9j = parcelRequire("h1Q9j");

var $2fFJv = parcelRequire("2fFJv");
/**
 * __Dropdown item checkbox__
 *
 * A dropdown item checkbox creates groups that have multiple selections.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/usage)
 */ const $bdd85e99771c9c60$var$DropdownItemCheckbox = ({ children: children, defaultSelected: defaultSelected, description: description, id: id, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $5Q9wj.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, testId: testId, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $2fFJv;
    const [selected, setSelected] = (0, $4lVNM.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $eUqFw.useCallback)((event)=>{
        setSelected((selected)=>!selected);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $h1Q9j.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jcoK.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        "aria-checked": selected,
        description: description,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $caOPr.default), {
            checked: selected
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: selected,
        onClick: onClickHandler,
        ref: itemRef,
        role: "menuitemcheckbox",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        ...rest
    }, children));
};
var $bdd85e99771c9c60$export$2e2bcd8739ae039 = $bdd85e99771c9c60$var$DropdownItemCheckbox;

});
parcelRegister("caOPr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f70ae4045f17c28$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ce8OV = parcelRequire("ce8OV");

var $PdmhA = parcelRequire("PdmhA");
/**
 * __Checkbox icon__
 *
 * Used to visually represent the selected state in DropdownItemCheckbox
 *
 * @internal
 */ const $0f70ae4045f17c28$var$CheckboxIcon = ({ checked: checked })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ce8OV.default), {
        label: "",
        size: "medium",
        primaryColor: checked ? `var(--ds-background-selected-bold, ${0, $PdmhA.B400})` : `var(--ds-background-input, ${0, $PdmhA.N10})`,
        secondaryColor: checked ? `var(--ds-icon-inverse, ${0, $PdmhA.N10})` : 'transparent'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2",
        stroke: checked ? `var(--ds-border-selected, ${0, $PdmhA.B400})` : `var(--ds-border-input, ${0, $PdmhA.N100})`,
        strokeWidth: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    })));
};
var $0f70ae4045f17c28$export$2e2bcd8739ae039 = $0f70ae4045f17c28$var$CheckboxIcon;

});

parcelRegister("4lVNM", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f55dd9044769050$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b9WHI = parcelRequire("b9WHI");

var $7mYCs = parcelRequire("7mYCs");
/**
 * Custom hook to handle checkbox state for dropdown menu.
 * It works in tandem with the selection store context when the
 * component is uncontrolled.
 */ const $4f55dd9044769050$var$useCheckboxState = ({ isSelected: isSelected, id: id, defaultSelected: defaultSelected })=>{
    const { setItemState: setItemState, getItemState: getItemState } = (0, $eUqFw.useContext)((0, $7mYCs.SelectionStoreContext));
    const groupId = (0, $eUqFw.useContext)((0, $b9WHI.CheckboxGroupContext));
    const persistedIsSelected = getItemState(groupId, id);
    const [localIsSelected, setLocalIsSelected] = (0, $eUqFw.useState)(// Initial state is set depending on value being defined or not.
    // This state is only utilised if the checkbox is uncontrolled.
    ()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $eUqFw.useCallback)((newValue)=>{
        const nextValue = newValue(persistedIsSelected);
        setLocalIsSelected(nextValue);
        setItemState(groupId, id, nextValue);
    }, [
        setItemState,
        persistedIsSelected,
        groupId,
        id
    ]);
    // Checkbox is controlled - do nothing!
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    // Checkbox is going through its first render pass!
    if (persistedIsSelected === undefined) // Set the item so we have this state to access next time the checkbox renders (either by mounting or re-rendering!)
    setItemState(groupId, id, defaultSelected || false);
    // Return the value and setter!
    // Remember this flow is only returned if the checkbox is uncontrolled.
    return [
        localIsSelected,
        setLocalState
    ];
};
var $4f55dd9044769050$export$2e2bcd8739ae039 = $4f55dd9044769050$var$useCheckboxState;

});
parcelRegister("b9WHI", function(module, exports) {

$parcel$export(module.exports, "CheckboxGroupContext", () => $7d37fbf6df8e3733$export$baf37c4be89255b8);

var $eUqFw = parcelRequire("eUqFw");
const $7d37fbf6df8e3733$export$baf37c4be89255b8 = /*#__PURE__*/ (0, $eUqFw.createContext)('');

});






parcelRegister("itGQN", function(module, exports) {

$parcel$export(module.exports, "default", () => $35bc1d42f552afea$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $7u4fN = parcelRequire("7u4fN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hd6kM = parcelRequire("hd6kM");
const $35bc1d42f552afea$var$ClearFilterButton = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35bc1d42f552afea$var$StyledClearFilterButton, {
        "data-test-id": "filters.ui.filters.clear-button.ak-button",
        "data-testid": "filters.ui.filters.clear-button.ak-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        onClick: props.onClick
    }, props.label || formatMessage((0, $hd6kM.default).label)));
};
$35bc1d42f552afea$var$ClearFilterButton.defaultProps = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
var $35bc1d42f552afea$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $35bc1d42f552afea$var$ClearFilterButton;
const $35bc1d42f552afea$var$StyledClearFilterButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19bv1b66 _u5f31b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hd6kM", function(module, exports) {

$parcel$export(module.exports, "default", () => $f91b0cf94f2a1046$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f91b0cf94f2a1046$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "software-filters.filters.clear-button.label",
        "defaultMessage": "Clear filters"
    }
});

});


parcelRegister("35WdX", function(module, exports) {

$parcel$export(module.exports, "default", () => $592abc4ed745ea19$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6vrw7 = parcelRequire("6vrw7");

var $azooe = parcelRequire("azooe");

var $adsMt = parcelRequire("adsMt");
const $592abc4ed745ea19$var$ComponentFilter = ({ components: components = [], selectedComponents: selectedComponents = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const values = (0, $eUqFw.useMemo)(()=>components.map((component)=>({
                label: component.name,
                // Casting to string normalises the id that may potentially be a number.
                value: String(component.id)
            })), [
        components
    ]);
    const onChangeCallback = (0, $eUqFw.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map(({ value: value })=>value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    return (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azooe.default), {
            label: formatMessage((0, $adsMt.default).label),
            values: values,
            selectedValues: (0, $6vrw7.toStringArray)(selectedComponents),
            onChange: onChangeCallback,
            isNested: isNested
        }), [
        formatMessage,
        onChangeCallback,
        selectedComponents,
        values,
        isNested
    ]);
};
var $592abc4ed745ea19$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($592abc4ed745ea19$var$ComponentFilter);

});
parcelRegister("azooe", function(module, exports) {

$parcel$export(module.exports, "default", () => $e44aa39502f5b060$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $bFzGY = parcelRequire("bFzGY");

var $bVKeg = parcelRequire("bVKeg");
var $jQxSL = parcelRequire("jQxSL");
var $l44HT = parcelRequire("l44HT");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $bBKri = parcelRequire("bBKri");

var $iN7qj = parcelRequire("iN7qj");

var $4q4xB = parcelRequire("4q4xB");

var $o0yPF = parcelRequire("o0yPF");

var $iRoug = parcelRequire("iRoug");

var $kCSUv = parcelRequire("kCSUv");
const $e44aa39502f5b060$var$MenuListWrapper = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "filters.common.ui.list.menu-list-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).MenuList, rest, children));
const $e44aa39502f5b060$export$fa71ab09534e6447 = ({ isOpen: defaultIsOpen, isNested: isNested, isLoading: isLoading, isAsyncSearch: isAsyncSearch, showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty, label: label, toggleLabel: toggleLabel, buttonType: buttonType, values: values, selectedValues: selectedValueIds, onChange: onChange, onInputChange: onInputChange, onOpenChange: onOpenChange, noOptionsMessage: noOptionsMessage, menuGroupTitle: menuGroupTitle, inputValue: inputValue, maxSelectionAllowed: maxSelectionAllowed, maxSelectionReachedTooltip: maxSelectionReachedTooltip, onMouseEnterToTriggerButton: onMouseEnterToTriggerButton, CustomOptionLabel: CustomOptionLabel, placeholder: placeholder, shouldReturnFocus: shouldReturnFocus, ...footerProps })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const options = (0, $eUqFw.useMemo)(()=>(0, $kCSUv.getOptionsFromProps)({
            values: values,
            menuGroupTitle: menuGroupTitle
        }), [
        values,
        menuGroupTitle
    ]);
    const { selectedIdLookup: selectedIdLookup, selectedOptions: selectedOptions } = (0, $eUqFw.useMemo)(()=>(0, $kCSUv.getSelectedOptionsFromProps)({
            values: values,
            selectedValueIds: selectedValueIds
        }), [
        values,
        selectedValueIds
    ]);
    /* Cannot return null here for async search as this would cause the
   * filter to disappear completely when fetch returns no results.
   */ if (!showMenuIfValuesAreEmpty && !isAsyncSearch && values.length === 0) return null;
    // ================= //
    // === Callbacks === //
    // ================= //
    const onChangeHandler = (selected)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onChange(selected);
    };
    const onOpenChangeHandler = (isOpen)=>{
        const analyticsEvent = createAnalyticsEvent((0, $bBKri.OPEN_CHANGE_PAYLOAD));
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, (0, $bBKri.OPEN_CHANGE_SUBJECT_ID));
        onOpenChange(isOpen);
    };
    const isOptionDisabled = (option)=>selectedOptions.length >= maxSelectionAllowed && !selectedIdLookup.has(option.value.toString());
    // ============== //
    // === RENDER === //
    // ============== //
    // Select expects a function that returns a string, rather than a string primitive
    const getNoOptionsMessage = noOptionsMessage === undefined ? noOptionsMessage : ()=>noOptionsMessage;
    const renderTrigger = (popupProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iRoug.default), {
            ...popupProps,
            shouldReturnFocus: shouldReturnFocus,
            buttonType: buttonType,
            label: label,
            selectedCount: selectedOptions.length,
            isNested: isNested,
            onMouseEnter: onMouseEnterToTriggerButton
        });
    const renderFooter = ()=>(footerProps.showLink || footerProps.showPanelToggle) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iN7qj.default), {
            label: label,
            toggleLabel: toggleLabel,
            ...footerProps
        });
    const renderOption = (option)=>{
        const { label: optionLabel, iconUrl: iconUrl, subLabel: subLabel, value: value } = option;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $o0yPF.default), {
            label: optionLabel,
            subLabel: subLabel,
            iconUrl: iconUrl,
            value: String(value),
            isDisabled: isOptionDisabled(option),
            maxSelectionReachedTooltip: maxSelectionReachedTooltip,
            CustomOptionLabel: CustomOptionLabel ?? (0, $o0yPF.DefaultOptionLabel)
        });
    };
    const onKeyDown = (event)=>{
        if (event.key === 'Escape') event.stopPropagation();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l44HT.default), {
        "aria-label": `Select ${label} filters`,
        // testId="filters.common.ui.list.menu-list-wrapper"
        isMulti: true,
        isLoading: isLoading,
        backspaceRemovesValue: true,
        hideSelectedOptions: false,
        closeMenuOnSelect: false,
        defaultIsOpen: defaultIsOpen,
        options: options,
        value: selectedOptions,
        inputValue: inputValue,
        noOptionsMessage: getNoOptionsMessage,
        placeholder: placeholder ?? formatMessage((0, $4q4xB.default).placeholder),
        target: renderTrigger,
        footer: renderFooter(),
        formatOptionLabel: renderOption,
        components: {
            Option: (0, $bVKeg.CheckboxOption),
            DropdownIndicator: null,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            MenuList: $e44aa39502f5b060$var$MenuListWrapper
        },
        popperProps: {
            placement: isNested ? 'right-start' : 'bottom-start',
            // to render popup next to the trigger element to achieve DOM order
            strategy: 'fixed'
        },
        onChange: onChangeHandler,
        onInputChange: onInputChange,
        isOptionDisabled: isOptionDisabled,
        onMenuOpen: ()=>onOpenChangeHandler(true),
        onMenuClose: ()=>onOpenChangeHandler(false),
        onKeyDown: onKeyDown,
        ...(0, $kCSUv.getSearchableProps)({
            isAsyncSearch: isAsyncSearch,
            optionsCount: values.length,
            isNested: isNested
        })
    });
};
$e44aa39502f5b060$export$fa71ab09534e6447.defaultProps = {
    isOpen: false,
    isNested: false,
    isLoading: false,
    isAsyncSearch: false,
    isPanelToggleChecked: false,
    showLink: false,
    showPanelToggle: false,
    showMenuIfValuesAreEmpty: false,
    useHrefForUrl: false,
    values: [],
    selectedValues: [],
    menuGroupTitle: undefined,
    noOptionsMessage: undefined,
    maxSelectionAllowed: Number.MAX_SAFE_INTEGER,
    url: undefined,
    linkTitle: undefined,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onInputChange: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onTogglePanel: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onLinkItemClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onMouseEnterToTriggerButton: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    toggleRef: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
var $e44aa39502f5b060$export$2e2bcd8739ae039 = $e44aa39502f5b060$export$fa71ab09534e6447;

});
parcelRegister("bVKeg", function(module, exports) {

$parcel$export(module.exports, "CheckboxOption", () => $abfb51c6af49e9a3$export$d40cc97ecda916f9);
$parcel$export(module.exports, "RadioOption", () => $abfb51c6af49e9a3$export$82ab7168879267a7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $c6Z6Z = parcelRequire("c6Z6Z");

var $hSJ9G = parcelRequire("hSJ9G");

var $PdmhA = parcelRequire("PdmhA");
function $abfb51c6af49e9a3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $abfb51c6af49e9a3$var$getPrimitiveStyles = (props)=>{
    const { cx: cx, className: className, getStyles: getStyles, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected } = props;
    const baseStyles = {
        alignItems: 'center',
        backgroundColor: isFocused ? `var(--ds-background-neutral-subtle-hovered, ${0, $PdmhA.N20})` : 'transparent',
        color: isDisabled ? "var(--ds-text-disabled, inherit)" : 'inherit',
        display: 'flex ',
        paddingBottom: "var(--ds-space-050, 4px)",
        paddingLeft: "var(--ds-space-200, 16px)",
        paddingTop: "var(--ds-space-050, 4px)",
        // This 'none' needs to be present to ensure that style is not applied when
        // the option is selected but not focused.
        boxShadow: isFocused ? `inset 2px 0px 0px ${`var(--ds-border-focused, ${0, $PdmhA.B400})`}` : 'none',
        ':active': {
            backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $PdmhA.N30)})`
        },
        '@media screen and (-ms-high-contrast: active)': {
            borderLeft: isFocused ? '2px solid transparent' : ''
        }
    };
    const augmentedStyles = /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...getStyles('option', props),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...baseStyles
    });
    const bemClasses = {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    };
    // maintain react-select API
    return [
        augmentedStyles,
        cx(bemClasses, className)
    ];
};
// the primary color represents the outer or background element
const $abfb51c6af49e9a3$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $PdmhA.B75})`;
    else if (isDisabled) return `var(--ds-background-disabled, ${0, $PdmhA.N20A})`;
    else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $PdmhA.B75})`;
    else if (isActive) return `var(--ds-background-selected-pressed, ${0, $PdmhA.B75})`;
    else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $PdmhA.B300})`;
    else if (isFocused) return `var(--ds-surface, ${0, $PdmhA.N0})`;
    else if (isSelected) return `var(--ds-background-selected-bold, ${0, $PdmhA.B400})`;
    return `var(--ds-background-neutral, ${0, $PdmhA.N0})`;
};
// the secondary color represents the radio dot or checkmark
const $abfb51c6af49e9a3$var$getSecondaryColor = ({ isActive: isActive, isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-text-disabled, ${0, $PdmhA.N70})`;
    else if (isActive && isSelected && !isDisabled) return `var(--ds-surface, ${0, $PdmhA.B400})`;
    else if (!isSelected) return 'transparent';
    return `var(--ds-surface, ${0, $PdmhA.N0})`;
};
// the border color surrounds the checkbox/radio
const $abfb51c6af49e9a3$var$getBorderColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $PdmhA.B400})`;
    else if (isDisabled) return `var(--ds-background-disabled, ${0, $PdmhA.N100})`;
    else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $PdmhA.B400})`;
    else if (isActive) return `var(--ds-background-selected-bold, ${0, $PdmhA.B400})`;
    else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $PdmhA.B400})`;
    else if (isFocused) return `var(--ds-border-input, ${0, $PdmhA.N100})`;
    else if (isSelected) return `var(--ds-background-selected-bold, ${0, $PdmhA.B400})`;
    return `var(--ds-border-input, ${0, $PdmhA.N100})`;
};
const $abfb51c6af49e9a3$var$baseIconStyles = {
    name: "zlggru",
    styles: "align-items:center;display:flex ;flex-shrink:0;padding-inline-end:var(--ds-space-050, 4px);& svg rect, & svg circle:first-of-type{stroke-width:var(--ds-border-width, 1px);stroke-linejoin:round;}"
};
const $abfb51c6af49e9a3$var$baseOptionStyles = {
    name: "6gb5tk",
    styles: "text-overflow:ellipsis;overflow-x:hidden;flex-grow:1;white-space:nowrap"
};
class $abfb51c6af49e9a3$var$ControlOption extends (0, $eUqFw.Component) {
    render() {
        const { getStyles: getStyles, Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, ...rest } = this.props;
        // prop assignment
        const props = {
            ...innerProps,
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            onMouseLeave: this.onMouseLeave
        };
        const [styles, classes] = $abfb51c6af49e9a3$var$getPrimitiveStyles({
            getStyles: getStyles,
            ...rest
        });
        return(// These need to remain this way because `react-select` passes props with
        // styles inside, and that must be done dynamically.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: styles,
            className: classes,
            ref: innerRef,
            ...props
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                $abfb51c6af49e9a3$var$baseIconStyles,
                // Here we are adding a border to the Checkbox and Radio SVG icons
                // This is an a11y fix for Select only for now but it may be rolled
                // into the `@atlaskit/icon` package's Checkbox and Radio SVGs later
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                {
                    // This can eventually be changed to static styles that are
                    // applied conditionally (e.g. `isActive && activeBorderStyles`),
                    // but considering there are multiple instances of `react-select`
                    // requiring styles to be generated dynamically, it seemed like a
                    // low priority.
                    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
                    '& svg rect, & svg circle:first-of-type': {
                        stroke: $abfb51c6af49e9a3$var$getBorderColor({
                            ...this.props,
                            ...this.state
                        })
                    }
                }
            ]
        }, !!Icon ? /*#__PURE__*/ (0, $byn9U.jsx)(Icon, {
            label: "",
            primaryColor: $abfb51c6af49e9a3$var$getPrimaryColor({
                ...this.props,
                ...this.state
            }),
            secondaryColor: $abfb51c6af49e9a3$var$getSecondaryColor({
                ...this.props,
                ...this.state
            })
        }) : null), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $abfb51c6af49e9a3$var$baseOptionStyles
        }, children)));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isActive: false
        };
        this.onMouseDown = ()=>this.setState({
                isActive: true
            });
        this.onMouseUp = ()=>this.setState({
                isActive: false
            });
        this.onMouseLeave = ()=>this.setState({
                isActive: false
            });
    }
}
const $abfb51c6af49e9a3$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)($abfb51c6af49e9a3$var$ControlOption, {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($hSJ9G))),
        ...props
    });
const $abfb51c6af49e9a3$export$82ab7168879267a7 = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)($abfb51c6af49e9a3$var$ControlOption, {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($c6Z6Z))),
        ...props
    });

});
parcelRegister("c6Z6Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02468a1d390d1515$var$_react = $02468a1d390d1515$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $02468a1d390d1515$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $02468a1d390d1515$var$RadioIcon = (props)=>/*#__PURE__*/ $02468a1d390d1515$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="6"/><circle fill="inherit" cx="12" cy="12" r="2"/></g></svg>`
    }, props));
$02468a1d390d1515$var$RadioIcon.displayName = 'RadioIcon';
var $02468a1d390d1515$var$_default = $02468a1d390d1515$var$RadioIcon;
module.exports.default = $02468a1d390d1515$var$_default;

});

parcelRegister("hSJ9G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d04a81b304c826a5$var$_react = $d04a81b304c826a5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $d04a81b304c826a5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d04a81b304c826a5$var$CheckboxIcon = (props)=>/*#__PURE__*/ $d04a81b304c826a5$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect fill="currentColor" x="6" y="6" width="12" height="12" rx="2"/><path d="M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z" fill="inherit"/></g></svg>`
    }, props));
$d04a81b304c826a5$var$CheckboxIcon.displayName = 'CheckboxIcon';
var $d04a81b304c826a5$var$_default = $d04a81b304c826a5$var$CheckboxIcon;
module.exports.default = $d04a81b304c826a5$var$_default;

});


parcelRegister("bBKri", function(module, exports) {

$parcel$export(module.exports, "FILTER_MENU_MIN_WIDTH", () => $b7c20e9c2dfb0c8d$export$84ae3fb9fdba8a12);
$parcel$export(module.exports, "FILTER_MENU_MIN_WIDTH_ON_NESTED", () => $b7c20e9c2dfb0c8d$export$920d89f17cd2fe3d);
$parcel$export(module.exports, "FILTER_MENU_MAX_WIDTH", () => $b7c20e9c2dfb0c8d$export$6ea791ab71b8fa00);
$parcel$export(module.exports, "FILTER_SEARCH_THRESHOLD", () => $b7c20e9c2dfb0c8d$export$1d287c6a8b81eb5b);
$parcel$export(module.exports, "OPEN_CHANGE_PAYLOAD", () => $b7c20e9c2dfb0c8d$export$2f5981b7dbafe3a4);
$parcel$export(module.exports, "OPEN_CHANGE_SUBJECT_ID", () => $b7c20e9c2dfb0c8d$export$b94e5dc1a8a1409);
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles

var $c9TLT = parcelRequire("c9TLT");
const $b7c20e9c2dfb0c8d$export$84ae3fb9fdba8a12 = (0, $c9TLT.gridSize) * 21;
const $b7c20e9c2dfb0c8d$export$920d89f17cd2fe3d = (0, $c9TLT.gridSize) * 25;
const $b7c20e9c2dfb0c8d$export$6ea791ab71b8fa00 = (0, $c9TLT.gridSize) * 48;
const $b7c20e9c2dfb0c8d$export$1d287c6a8b81eb5b = 9;
const $b7c20e9c2dfb0c8d$export$2f5981b7dbafe3a4 = {
    action: 'clicked',
    actionSubject: 'dropdownMenu'
};
const $b7c20e9c2dfb0c8d$export$b94e5dc1a8a1409 = 'filterList';

});

parcelRegister("iN7qj", function(module, exports) {

$parcel$export(module.exports, "default", () => $11194a43908dcca2$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $jMP2a = parcelRequire("jMP2a");

var $l61gw = parcelRequire("l61gw");

var $i3CUI = parcelRequire("i3CUI");
const $11194a43908dcca2$var$FilterListFooter = ({ isPanelToggleChecked: isPanelToggleChecked, showLink: showLink, showPanelToggle: showPanelToggle, useHrefForUrl: useHrefForUrl, url: url, label: label, toggleLabel: toggleLabel, linkTitle: linkTitle, toggleRef: toggleRef, onTogglePanel: onTogglePanel, onLinkItemClick: onLinkItemClick })=>{
    const onToggleHandler = (_, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
        onTogglePanel();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (showPanelToggle || showLink && url && linkTitle) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($11194a43908dcca2$var$HorizontalSeparator, null), showPanelToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($11194a43908dcca2$var$PanelToggleContainer, {
        "data-testid": "filters.common.ui.list.footer.panel-toggle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i3CUI.default), {
        label: toggleLabel || label,
        panelType: label,
        isChecked: isPanelToggleChecked,
        toggleRef: toggleRef,
        onToggle: onToggleHandler
    })), showLink && url && linkTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l61gw.default), {
        url: url,
        linkTitle: linkTitle,
        onClick: onLinkItemClick,
        useHref: useHrefForUrl
    }));
};
$11194a43908dcca2$var$FilterListFooter.defaultProps = {
    url: undefined,
    linkTitle: undefined,
    showPanel: false,
    showLink: false,
    toggleRef: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
var $11194a43908dcca2$export$2e2bcd8739ae039 = $11194a43908dcca2$var$FilterListFooter;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $11194a43908dcca2$var$HorizontalSeparator = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "hr", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19itglyw _4t3iv77o _bfhkyucn _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});
const $11194a43908dcca2$var$PanelToggleContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4wux3 _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("l61gw", function(module, exports) {

$parcel$export(module.exports, "default", () => $63861f575a33e906$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");

var $eGI9v = parcelRequire("eGI9v");

var $jMP2a = parcelRequire("jMP2a");

var $kJlBc = parcelRequire("kJlBc");
const $63861f575a33e906$var$DropdownItem = (0, $eGI9v.default)('dropdownItem', {
    onClick: 'clicked'
})((0, $hD6GJ.default));
const $63861f575a33e906$var$linkWrapperStyles = null;
const $63861f575a33e906$export$532cb6865ebe8946 = ({ url: url, linkTitle: linkTitle, onClick: onClick, useHref: useHref = false })=>{
    const { push: push } = (0, $kJlBc.useRouterActions)();
    const onDropdownClick = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'clickLinkFromFilters');
        onClick && onClick();
        if (!useHref) push(url);
    }, [
        useHref,
        onClick,
        push,
        url
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1e0c116y _4cvr1h6o _1bsb1osq _n3td1b66 _n3ag1osq _1i3qd8e8 _hjpp1osq _c24d81pi"
        ])
    }, useHref ? /* @ts-expect-error - Type '(event: SyntheticEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => void' is not assignable to type '(e: MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>, args_1: UIAnalyticsEvent) => any'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($63861f575a33e906$var$DropdownItem, {
        href: url,
        onClick: onDropdownClick
    }, linkTitle) : /* @ts-expect-error - Type '(event: SyntheticEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => void' is not assignable to type '(e: MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>, args_1: UIAnalyticsEvent) => any'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($63861f575a33e906$var$DropdownItem, {
        onClick: onDropdownClick
    }, linkTitle));
};
var $63861f575a33e906$export$2e2bcd8739ae039 = $63861f575a33e906$export$532cb6865ebe8946;

});

parcelRegister("i3CUI", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfb29b4841d4c7f6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $c8Guq = parcelRequire("c8Guq");

var $jG2Eu = parcelRequire("jG2Eu");

var $ffiyv = parcelRequire("ffiyv");

var $e270j = parcelRequire("e270j");

var $eGI9v = parcelRequire("eGI9v");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $5oqMG = parcelRequire("5oqMG");

var $2GBsX = parcelRequire("2GBsX");
const $cfb29b4841d4c7f6$var$TOGGLE_CHECKBOX_ID = 'filters.common.ui.list.panel-toggle.toggle-checkbox';
const $cfb29b4841d4c7f6$var$TOGGLE_HINT_ID = 'filters.common.ui.list.panel-toggle.toggle-hint';
const $cfb29b4841d4c7f6$var$PanelToggle = (props)=>{
    const { isChecked: isChecked, panelType: panelType, onToggle: onToggle, ariaLabel: ariaLabel, intl: { formatMessage: formatMessage }, toggleRef: toggleRef = null, label: label } = props;
    const panelToggleKeyboardShortcut = (0, $5oqMG.getKeyboardShortcutForPanel)(panelType);
    const toggleLabel = label || formatMessage((0, $2GBsX.default).toggleLabel, {
        panelType: panelType
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cfb29b4841d4c7f6$var$PanelToggleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cfb29b4841d4c7f6$var$PanelToggleControl, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e270j.default), {
        label: ariaLabel,
        id: $cfb29b4841d4c7f6$var$TOGGLE_CHECKBOX_ID,
        ref: toggleRef,
        onChange: onToggle,
        isChecked: isChecked,
        testId: "filters.common.ui.list.panel-toggle.panel-toggle",
        descriptionId: $cfb29b4841d4c7f6$var$TOGGLE_HINT_ID
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cfb29b4841d4c7f6$var$PanelToggleLabel, {
        htmlFor: $cfb29b4841d4c7f6$var$TOGGLE_CHECKBOX_ID
    }, toggleLabel)), panelToggleKeyboardShortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cfb29b4841d4c7f6$var$PanelToggleHint, {
        id: $cfb29b4841d4c7f6$var$TOGGLE_HINT_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $2GBsX.default).toggleHint,
        values: {
            kbd: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, chunks),
            key: panelToggleKeyboardShortcut
        }
    })));
};
$cfb29b4841d4c7f6$var$PanelToggle.defaultProps = {
    isChecked: false,
    panelType: '',
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
var $cfb29b4841d4c7f6$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $2qhQi.default), (0, $eUqFw.memo), (0, $eGI9v.default)('filterPanelToggle', {
    onToggle: 'toggled'
}))($cfb29b4841d4c7f6$var$PanelToggle);
const $cfb29b4841d4c7f6$var$PanelToggleContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _4cvr1h6o _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfb29b4841d4c7f6$var$PanelToggleControl = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfb29b4841d4c7f6$var$PanelToggleLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _18u0v77o _1reo15vq _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfb29b4841d4c7f6$var$PanelToggleHint = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "small", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz _o5721q9c _11c8qk37 _19pkidpf _19bv12x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5oqMG", function(module, exports) {

$parcel$export(module.exports, "getKeyboardShortcutForPanel", () => $4efb03f3225c562c$export$fa36ece4b5d88abc);

const $4efb03f3225c562c$var$panelShortcuts = {
    Epic: (0, $b9597ab46ec7cd93$export$9b094cdf6fd7589e),
    Version: (0, $b9597ab46ec7cd93$export$6f416a1fb11a53d9)
};
const $4efb03f3225c562c$export$fa36ece4b5d88abc = (panelType)=>$4efb03f3225c562c$var$panelShortcuts[panelType];

});
const $b9597ab46ec7cd93$export$a10c132b86ae798b = 'Epic';
const $b9597ab46ec7cd93$export$41073ac826c57195 = 'Version';
const $b9597ab46ec7cd93$export$9b094cdf6fd7589e = 'E';
const $b9597ab46ec7cd93$export$6f416a1fb11a53d9 = 'V';


parcelRegister("2GBsX", function(module, exports) {

$parcel$export(module.exports, "default", () => $01d484359a982a7b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $01d484359a982a7b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    toggleAccessibilityLabel: {
        "id": "software-filters.common.list.panel-toggle.toggle-accessibility-label",
        "defaultMessage": "Toggle panel"
    },
    toggleLabel: {
        "id": "software-filters.common.list.panel-toggle.toggle-label",
        "defaultMessage": "{panelType} panel"
    },
    toggleHint: {
        "id": "software-filters.common.list.panel-toggle.toggle-hint",
        "defaultMessage": "Press <kbd>{key}</kbd> to open and close"
    }
});

});



parcelRegister("4q4xB", function(module, exports) {

$parcel$export(module.exports, "default", () => $b803d9be02c7a9c9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b803d9be02c7a9c9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "software-filters.common.list.placeholder",
        "defaultMessage": "Search filters\u2026"
    },
    anounceMessage: {
        "id": "software-filters.common.list.anounce-message",
        "defaultMessage": "When selecting from the {field} filter, content in the backlog board will automatically update"
    }
});

});

parcelRegister("o0yPF", function(module, exports) {

$parcel$export(module.exports, "DefaultOptionLabel", () => $4e0754c0a543f63b$export$86f820b2f37564e5);
$parcel$export(module.exports, "default", () => $4e0754c0a543f63b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $8cU5f = parcelRequire("8cU5f");

var $c9TLT = parcelRequire("c9TLT");
const $4e0754c0a543f63b$export$86f820b2f37564e5 = ({ label: label, iconUrl: iconUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, iconUrl !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4e0754c0a543f63b$var$Icon, {
        src: iconUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4e0754c0a543f63b$var$SelectOptionLabel, null, label));
const $4e0754c0a543f63b$var$ListFilterOption = ({ label: label, subLabel: subLabel, iconUrl: iconUrl, value: value, maxSelectionReachedTooltip: maxSelectionReachedTooltip, isDisabled: isDisabled, CustomOptionLabel: CustomOptionLabel })=>{
    const content = isDisabled && maxSelectionReachedTooltip ? maxSelectionReachedTooltip : label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4e0754c0a543f63b$var$SelectOptionWrapper, {
        "data-testid": "filters.common.ui.list.option"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CustomOptionLabel, {
        label: label,
        value: value,
        iconUrl: iconUrl
    })), subLabel !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4e0754c0a543f63b$var$SelectOptionSubLabel, null, subLabel));
};
$4e0754c0a543f63b$var$ListFilterOption.defaultProps = {
    iconUrl: undefined,
    isDisabled: false
};
var $4e0754c0a543f63b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($4e0754c0a543f63b$var$ListFilterOption);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4e0754c0a543f63b$var$SelectOptionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1y6m",
            __cmplp.className
        ])
    });
});
const $4e0754c0a543f63b$var$SelectOptionLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $4e0754c0a543f63b$var$SelectOptionSubLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _syaz1e9r _1wyb1skh",
            __cmplp.className
        ])
    });
});
const $4e0754c0a543f63b$var$Icon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_zb0g5d": (0, $9t7rW.default)((0, $c9TLT.layout).issueIconSize, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1bsbwrp2 _4t3iwrp2 _u5f3u2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("iRoug", function(module, exports) {

$parcel$export(module.exports, "default", () => $2627b6651f6d491e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $9nkwJ = parcelRequire("9nkwJ");

var $7u4fN = parcelRequire("7u4fN");

var $86Ndv = parcelRequire("86Ndv");

var $dtaN9 = parcelRequire("dtaN9");

var $8cU5f = parcelRequire("8cU5f");

var $2KzVh = parcelRequire("2KzVh");

var $8WuJm = parcelRequire("8WuJm");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2627b6651f6d491e$var$FilterListTrigger = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isOpen: isOpen, isNested: isNested, label: label, buttonType: buttonType, selectedCount: selectedCount, onMouseEnter: onMouseEnter, shouldReturnFocus: shouldReturnFocus, ...popupProps }, ref)=>{
    const testId = `filters.common.ui.list.${label.toLowerCase().replace(/ /g, '-')}-filter`;
    const IconComponent = isNested ? (0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))) : (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv)));
    const primaryColor = isOpen ? "var(--ds-icon-selected, #0052CC)" : "var(--ds-icon, #44546F)";
    const inputRef = (0, $eUqFw.useRef)();
    const isMounted = (0, $eUqFw.useRef)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (shouldReturnFocus && buttonType === 'QuickFilters' && isMounted.current) inputRef?.current?.focus();
        else isMounted.current = true;
    }, [
        shouldReturnFocus,
        buttonType
    ]);
    const conditionalRef = buttonType === 'QuickFilters' ? (0, $2KzVh.mergeRefs)(ref, inputRef) : ref;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2627b6651f6d491e$var$Container, {
        isNested: isNested
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "dropDownMenu",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        attributes: {
            filterType: label
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2627b6651f6d491e$var$StyledButton, {
        ...popupProps,
        ref: conditionalRef,
        isNested: isNested,
        isSelected: isOpen,
        shouldFitContainer: isNested,
        appearance: "subtle",
        onMouseEnter: onMouseEnter,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IconComponent, {
            primaryColor: primaryColor,
            label: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: label,
        hideTooltipOnClick: true,
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2627b6651f6d491e$var$TriggerContainer, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2627b6651f6d491e$var$TriggerLabel, null, label), selectedCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2627b6651f6d491e$var$CountWrapper, {
        isNested: isNested,
        "data-testid": `${testId}-badge`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
        appearance: "primary"
    }, selectedCount)))))));
});
var $2627b6651f6d491e$export$2e2bcd8739ae039 = $2627b6651f6d491e$var$FilterListTrigger;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2627b6651f6d491e$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isNested: isNested, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19bv1b66 _u5f31b66",
            __cmplp.isNested && "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
});
const $2627b6651f6d491e$var$StyledButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isNested && "_2rkogrf3 _u5f3ns44 _1bg412gs",
            __cmplp.className
        ])
    });
});
const $2627b6651f6d491e$var$CountWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isNested: isNested, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l",
            __cmplp.isNested ? "_18u01wug _19bvftgi" : "_19bv1y44",
            __cmplp.className
        ])
    });
});
const $2627b6651f6d491e$var$TriggerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $2627b6651f6d491e$var$TriggerLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f68cl _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2KzVh", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", () => $0be6a57b715845c4$export$c9058316764c140e);
$parcel$export(module.exports, "default", () => $0be6a57b715845c4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $0be6a57b715845c4$export$c9058316764c140e(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref != null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref.current = value; // eslint-disable-line no-param-reassign
        });
    };
}
function $0be6a57b715845c4$export$2e2bcd8739ae039(...refs) {
    return (0, $eUqFw.useMemo)(()=>$0be6a57b715845c4$export$c9058316764c140e(...refs), // eslint-disable-next-line react-hooks/exhaustive-deps
    refs);
}

});


parcelRegister("kCSUv", function(module, exports) {

$parcel$export(module.exports, "getOptionsFromProps", () => $d5275d028e90805a$export$ecd68164c475a713);
$parcel$export(module.exports, "getSelectedOptionsFromProps", () => $d5275d028e90805a$export$94d5b7a6f69b418);
$parcel$export(module.exports, "getSearchableProps", () => $d5275d028e90805a$export$62d9d395b3dd2ae8);

var $cEc3i = parcelRequire("cEc3i");

var $bBKri = parcelRequire("bBKri");
const $d5275d028e90805a$var$isValueGroupOption = (value)=>'options' in value;
const $d5275d028e90805a$var$containsOnlyOption = (values)=>values.every((value)=>!$d5275d028e90805a$var$isValueGroupOption(value));
const $d5275d028e90805a$export$ecd68164c475a713 = ({ values: values, menuGroupTitle: menuGroupTitle })=>{
    // menuGroupTitle should be deprecated
    if (menuGroupTitle && $d5275d028e90805a$var$containsOnlyOption(values)) return [
        {
            label: menuGroupTitle,
            options: values
        }
    ];
    return values;
};
const $d5275d028e90805a$export$94d5b7a6f69b418 = ({ values: values, selectedValueIds: selectedValueIds })=>{
    const selectedIdLookup = selectedValueIds.reduce((acc, cur)=>{
        acc.add(cur);
        return acc;
    }, new Set());
    const valuesToLook = values.flatMap((value)=>$d5275d028e90805a$var$isValueGroupOption(value) ? value.options : [
            value
        ]);
    const selectedOptions = valuesToLook.filter(({ value: value })=>selectedIdLookup.has(value));
    return {
        selectedIdLookup: selectedIdLookup,
        selectedOptions: selectedOptions
    };
};
const $d5275d028e90805a$export$62d9d395b3dd2ae8 = ({ optionsCount: optionsCount, isAsyncSearch: isAsyncSearch, defaultSearchThreshold: defaultSearchThreshold = (0, $bBKri.FILTER_SEARCH_THRESHOLD), isNested: isNested })=>{
    // Search input should always be visible for async selects
    const searchThreshold = isAsyncSearch ? -1 : defaultSearchThreshold;
    const isSearchable = optionsCount > searchThreshold;
    // Due to renderToParent the grid size will change so, incresing the min width for low resolutions
    const filterMenuMinWidth = isNested ? (0, $bBKri.FILTER_MENU_MIN_WIDTH_ON_NESTED) : (0, $bBKri.FILTER_MENU_MIN_WIDTH);
    const maxMenuWidth = (0, $bBKri.FILTER_MENU_MAX_WIDTH);
    // Set the min and max width to be the same so updated search results don't cause the menu to resize
    const minMenuWidth = isSearchable ? maxMenuWidth : filterMenuMinWidth;
    // Don't filter anything on the frontend for async selects
    const filter = (0, $cEc3i.c)({
        stringify: (option)=>option.label
    });
    const filterOption = isAsyncSearch ? undefined : filter;
    return {
        minMenuWidth: minMenuWidth,
        maxMenuWidth: maxMenuWidth,
        searchThreshold: searchThreshold,
        filterOption: filterOption
    };
};

});


parcelRegister("adsMt", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ae72ac02ee48f1a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8ae72ac02ee48f1a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "software-filters.filters.component.label",
        "defaultMessage": "Components"
    }
});

});


parcelRegister("01UFf", function(module, exports) {

$parcel$export(module.exports, "FilterBar", () => $ce41b001519ffea0$export$56a20ec2552ffba2);
$parcel$export(module.exports, "ListFilterContainerNextGen", () => $ce41b001519ffea0$export$4a72bd88f9845459);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $ce41b001519ffea0$export$56a20ec2552ffba2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _kqswh2mm _4cvr1h6o _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $ce41b001519ffea0$export$847557029097218a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jx1txw _1hftutpp _1uf81b66 _1o94h2mm _79vbb3bt _lpsrstnw _9uwn1ssb _41sd7vkz _be5h1i34 _4amot94y _1omzidpf _1sn01d4u",
            __cmplp.className
        ])
    });
});
const $ce41b001519ffea0$export$4a72bd88f9845459 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jx1txw _1hftv77o _1uf81b66 _1o94h2mm _yj55idpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("9D86p", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab6568daa3b64d9d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3aUuh = parcelRequire("3aUuh");

var $jG2Eu = parcelRequire("jG2Eu");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4dREb = parcelRequire("4dREb");
var $As52d = parcelRequire("As52d");

var $azooe = parcelRequire("azooe");

var $bfIfF = parcelRequire("bfIfF");

var $fDvZ4 = parcelRequire("fDvZ4");
const $ab6568daa3b64d9d$var$EMPTY_ARRAY = [];
const $ab6568daa3b64d9d$var$GoalCustomOptionLabel = ({ label: label, value: value })=>{
    const goalContext = (0, $eUqFw.useContext)((0, $bfIfF.GoalFilterContext));
    const goalState = goalContext.goals[value]?.state;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.050",
        alignBlock: "center",
        alignInline: "start",
        grow: "fill"
    }, goalState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4dREb.GoalIcon), {
        state: goalState.value
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $ab6568daa3b64d9d$var$goalLabelStyles
    }, label), goalState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $As52d.GoalTracker), {
        label: goalState.label,
        score: goalState.score,
        value: goalState.value
    }));
};
const $ab6568daa3b64d9d$var$GoalFilter = ({ goals: goals, selectedGoals: selectedGoals = $ab6568daa3b64d9d$var$EMPTY_ARRAY, onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onInputChange: onInputChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onOpenChange: onOpenChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onMouseEnterToTriggerButton: onMouseEnterToTriggerButton = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty = false, inputValue: inputValue, isLoading: isLoading = false, isNested: isNested = false, isOpen: isOpen = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const values = (0, $eUqFw.useMemo)(()=>goals.map((goal)=>({
                label: goal.name,
                value: goal.id,
                data: goal.state
            })), [
        goals
    ]);
    const goalsHash = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(goals, (goal)=>goal.id), [
        goals
    ]);
    const onChangeCallback = (0, $eUqFw.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bfIfF.GoalFilterContext).Provider, {
        value: {
            goals: goalsHash
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azooe.default), {
        label: formatMessage((0, $fDvZ4.default).label),
        values: values,
        isOpen: isOpen,
        selectedValues: selectedGoals,
        isPanelToggleChecked: false,
        onChange: onChangeCallback,
        inputValue: inputValue,
        isLoading: isLoading,
        onInputChange: onInputChange,
        onOpenChange: onOpenChange,
        noOptionsMessage: formatMessage((0, $fDvZ4.default).noGoals),
        showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty,
        isAsyncSearch: false,
        isNested: isNested,
        onMouseEnterToTriggerButton: onMouseEnterToTriggerButton,
        placeholder: formatMessage((0, $fDvZ4.default).placeholder),
        CustomOptionLabel: $ab6568daa3b64d9d$var$GoalCustomOptionLabel,
        showPanelToggle: false,
        showLink: false,
        useHrefForUrl: false,
        maxSelectionAllowed: Number.MAX_SAFE_INTEGER,
        onTogglePanel: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onLinkItemClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        toggleRef: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    }));
};
var $ab6568daa3b64d9d$export$2e2bcd8739ae039 = $ab6568daa3b64d9d$var$GoalFilter;
const $ab6568daa3b64d9d$var$goalLabelStyles = (0, $1ZAYh.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});
parcelRegister("4dREb", function(module, exports) {

$parcel$export(module.exports, "GoalIcon", () => $05f58ca73b129f56$export$134cbcd70c6693b8);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4Deo8 = parcelRequire("4Deo8");

var $gKpeZ = parcelRequire("gKpeZ");
const $05f58ca73b129f56$var$GoalGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9C2 5.13401 5.13401 2 9 2C12.866 2 16 5.13401 16 9ZM18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM11 9C11 10.1046 10.1046 11 9 11C7.89543 11 7 10.1046 7 9C7 7.89543 7.89543 7 9 7C10.1046 7 11 7.89543 11 9ZM13 9C13 11.2091 11.2091 13 9 13C6.79086 13 5 11.2091 5 9C5 6.79086 6.79086 5 9 5C11.2091 5 13 6.79086 13 9Z",
        fillRule: "evenodd"
    })));
const $05f58ca73b129f56$export$134cbcd70c6693b8 = ({ state: state, ariaLabel: ariaLabel })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $05f58ca73b129f56$var$iconContainerStyles,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $4Deo8.mapStateToBgColor)(state)
        },
        "aria-label": ariaLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $05f58ca73b129f56$var$GoalGlyph,
        label: formatMessage((0, $gKpeZ.default).goalIconLabel),
        primaryColor: (0, $4Deo8.mapStateToColor)(state)
    }));
};
const $05f58ca73b129f56$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    minWidth: '24px',
    height: '24px',
    borderRadius: 'border.radius',
    marginRight: 'space.025'
});

});
parcelRegister("4Deo8", function(module, exports) {

$parcel$export(module.exports, "mapStateToBgColor", () => $02d4cc5f6bd3d325$export$931dac3fa53640b1);
$parcel$export(module.exports, "mapStateToColor", () => $02d4cc5f6bd3d325$export$163d1ee1b3b2aead);
$parcel$export(module.exports, "mapScoreToBgColor", () => $02d4cc5f6bd3d325$export$525ec0d5be9572a4);
$parcel$export(module.exports, "extractStatusLabelWithoutScore", () => $02d4cc5f6bd3d325$export$88bbcb3741dee92d);

var $PdmhA = parcelRequire("PdmhA");
const $02d4cc5f6bd3d325$export$931dac3fa53640b1 = (state)=>{
    switch(state){
        case 'off_track':
            return `var(--ds-background-accent-red-subtlest, ${(0, $PdmhA).R50})`;
        case 'at_risk':
            return `var(--ds-background-accent-yellow-subtlest, ${(0, $PdmhA).Y50})`;
        case 'on_track':
            return `var(--ds-background-accent-green-subtlest, ${(0, $PdmhA).G50})`;
        case 'archived':
        case 'cancelled':
        case 'done':
        case 'paused':
        case 'pending':
        default:
            return `var(--ds-background-accent-gray-subtlest, ${(0, $PdmhA).N20})`;
    }
};
const $02d4cc5f6bd3d325$export$163d1ee1b3b2aead = (state)=>{
    switch(state){
        case 'off_track':
            return `var(--ds-text-accent-red, ${(0, $PdmhA).R500})`;
        case 'at_risk':
            return `var(--ds-text-accent-orange, ${(0, $PdmhA).Y500})`;
        case 'on_track':
            return `var(--ds-text-accent-green, ${(0, $PdmhA).G500})`;
        case 'archived':
        case 'cancelled':
        case 'done':
        case 'paused':
        case 'pending':
        default:
            return `var(--ds-text-accent-gray, ${(0, $PdmhA).N500})`;
    }
};
const $02d4cc5f6bd3d325$export$525ec0d5be9572a4 = (score)=>{
    if (score < 0.4) return `var(--ds-background-danger-bold, ${(0, $PdmhA).R500})`;
    if (score < 0.7) return `var(--ds-background-accent-orange-bolder, ${(0, $PdmhA).Y500})`;
    return `var(--ds-background-success-bold, ${(0, $PdmhA).G500})`;
};
const $02d4cc5f6bd3d325$export$88bbcb3741dee92d = (fullLabel)=>fullLabel.split(' - ')[0];

});

parcelRegister("gKpeZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ea671f73d186d15$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0ea671f73d186d15$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    goalIconLabel: {
        "id": "software-goals.goal.icon.goal-icon-label",
        "defaultMessage": "Goal"
    }
});

});


parcelRegister("As52d", function(module, exports) {

$parcel$export(module.exports, "GoalTracker", () => $303e43f665e710f6$export$c0fdf469f92e8578);

var $eUqFw = parcelRequire("eUqFw");

var $4Deo8 = parcelRequire("4Deo8");

var $fKlXo = parcelRequire("fKlXo");

var $hT69m = parcelRequire("hT69m");
const $303e43f665e710f6$export$c0fdf469f92e8578 = ({ value: value, label: label, score: score })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hT69m.Tracker), {
        backgroundColor: (0, $4Deo8.mapStateToBgColor)(value),
        color: (0, $4Deo8.mapStateToColor)(value)
    }, (0, $4Deo8.extractStatusLabelWithoutScore)(label), score !== undefined && score !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fKlXo.Score), {
        score: score
    }));

});
parcelRegister("fKlXo", function(module, exports) {

$parcel$export(module.exports, "Score", () => $8652e2ebcc366b7f$export$6735cf84ecd2736);

var $eUqFw = parcelRequire("eUqFw");

var $4Deo8 = parcelRequire("4Deo8");

var $fdegN = parcelRequire("fdegN");
const $8652e2ebcc366b7f$export$6735cf84ecd2736 = ({ score: score })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fdegN.ScoreContainer), {
        backgroundColor: (0, $4Deo8.mapScoreToBgColor)(score)
    }, score);

});
parcelRegister("fdegN", function(module, exports) {

$parcel$export(module.exports, "ScoreContainer", () => $0423525836f3c2c9$export$32466e20de52fc97);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $0423525836f3c2c9$export$32466e20de52fc97 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1hphqkz": (0, $9t7rW.default)(__cmplp.backgroundColor)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _bfhk3qkl _syaz15cr _2rko1l7b _18u01b66 _1yt4otz2 _4t3i7vkz",
            __cmplp.className
        ])
    });
});

});


parcelRegister("hT69m", function(module, exports) {

$parcel$export(module.exports, "Tracker", () => $ef0bcdff719080e2$export$254d9747e34ddc90);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $ef0bcdff719080e2$export$254d9747e34ddc90 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1hphqkz": (0, $9t7rW.default)(__cmplp.backgroundColor),
            "--_xexnhp": (0, $9t7rW.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk3qkl _2rko1l7b _1yt41b66 _k48p1fw0 _1wyb1skh _syaz1cj8 _1p1dangw _3fcw1q9c _1e0c1ule _4t3i7vkz _vwz47vkz",
            __cmplp.className
        ])
    });
});

});


parcelRegister("bfIfF", function(module, exports) {

$parcel$export(module.exports, "GoalFilterContext", () => $78a8184ec9e445f2$export$f656d92d95229cd2);

var $eUqFw = parcelRequire("eUqFw");
const $78a8184ec9e445f2$export$f656d92d95229cd2 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    goals: {}
});

});

parcelRegister("fDvZ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e9b6c41cb5dbc38$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3e9b6c41cb5dbc38$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noGoals: {
        "id": "software-filters.filters.goals.no-goals",
        "defaultMessage": "There are no matching goals"
    },
    placeholder: {
        "id": "software-filters.filters.goals.placeholder",
        "defaultMessage": "Choose goals"
    },
    label: {
        "id": "software-filters.filters.goals.label",
        "defaultMessage": "Goals"
    }
});

});


parcelRegister("6syeh", function(module, exports) {

$parcel$export(module.exports, "default", () => $87b7489e946c438c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6vrw7 = parcelRequire("6vrw7");

var $azooe = parcelRequire("azooe");

var $9q65n = parcelRequire("9q65n");
const $87b7489e946c438c$var$IssueProjectFilter = ({ isOpen: isOpen = false, isNested: // only used for VR testing purposes
isNested = false, issueProjects: issueProjects = {}, onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), selectedProjects: selectedProjects = [] })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const values = (0, $eUqFw.useMemo)(()=>Object.values(issueProjects).map(({ avatar: avatar, id: id, name: name })=>({
                iconUrl: avatar,
                label: name,
                value: String(id)
            })).sort((a, b)=>a.label.localeCompare(b.label)), [
        issueProjects
    ]);
    const onChangeValue = (0, $eUqFw.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map(({ value: value })=>(0, $6vrw7.toProjectId)(value)), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azooe.default), {
        isOpen: isOpen,
        isNested: isNested,
        label: formatMessage((0, $9q65n.default).label),
        onChange: onChangeValue,
        selectedValues: selectedProjects.map(String),
        values: values
    });
};
$87b7489e946c438c$var$IssueProjectFilter.displayName = 'IssueProjectFilter';
$87b7489e946c438c$var$IssueProjectFilter.whyDidYouRender = true;
var $87b7489e946c438c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($87b7489e946c438c$var$IssueProjectFilter);

});
parcelRegister("9q65n", function(module, exports) {

$parcel$export(module.exports, "default", () => $15c9b06265a5a95e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $15c9b06265a5a95e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "software-filters.filters.issue-project.label",
        "defaultMessage": "Project"
    }
});

});


parcelRegister("dNCGp", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb3e818e9802c28$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6vrw7 = parcelRequire("6vrw7");

var $azooe = parcelRequire("azooe");

var $7Wut4 = parcelRequire("7Wut4");
const $6bb3e818e9802c28$var$IssueTypeFilter = ({ issueTypes: issueTypes = [], selectedIssueTypes: selectedIssueTypes = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const values = (0, $eUqFw.useMemo)(()=>issueTypes.map((issueType)=>({
                label: issueType.name,
                value: issueType.id,
                iconUrl: issueType.iconUrl
            })), [
        issueTypes
    ]);
    const onChangeCallback = (0, $eUqFw.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>(0, $6vrw7.toIssueTypeId)(entry.value)), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    // early exit if we have only one issue type
    if (issueTypes.length <= 1) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azooe.default), {
        label: formatMessage((0, $7Wut4.default).label),
        values: values,
        selectedValues: selectedIssueTypes.map(String),
        onChange: onChangeCallback,
        isNested: isNested
    });
};
const $6bb3e818e9802c28$var$IssueTypeFilterComponent = /*#__PURE__*/ (0, $eUqFw.memo)($6bb3e818e9802c28$var$IssueTypeFilter);
$6bb3e818e9802c28$var$IssueTypeFilterComponent.displayName = 'IssueTypeFilter';
// @ts-expect-error TS2339: Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$6bb3e818e9802c28$var$IssueTypeFilterComponent.whyDidYouRender = true;
var $6bb3e818e9802c28$export$2e2bcd8739ae039 = $6bb3e818e9802c28$var$IssueTypeFilterComponent;

});
parcelRegister("7Wut4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ba2dd317ef60362$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6ba2dd317ef60362$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "software-filters.filters.issue-type.label",
        "defaultMessage": "Type"
    }
});

});


parcelRegister("kpwtP", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b9961d32e52eac2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5JgJ2 = parcelRequire("5JgJ2");

var $azooe = parcelRequire("azooe");

var $lNrGM = parcelRequire("lNrGM");
const $6b9961d32e52eac2$var$IssueTypeGroupFilter = ({ isOpen: isOpen = false, issueTypeGroups: issueTypeGroups = [], selectedIssueTypes: selectedIssueTypes = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const issueTypeGroupByIssueType = (0, $eUqFw.useMemo)(()=>new Map(issueTypeGroups.flatMap((group)=>group.issueTypes.map((issueType)=>[
                    issueType,
                    group
                ]))), [
        issueTypeGroups
    ]);
    const issueTypeGroupByGroupKey = (0, $eUqFw.useMemo)(()=>new Map(issueTypeGroups.map((group)=>[
                group.key,
                group
            ])), [
        issueTypeGroups
    ]);
    const values = (0, $eUqFw.useMemo)(()=>issueTypeGroups.map((group)=>({
                label: group.name,
                value: group.key,
                iconUrl: group.iconUrl
            })), [
        issueTypeGroups
    ]);
    const selectGroupsByKeys = (0, $eUqFw.useCallback)((keys)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(keys.flatMap((key)=>issueTypeGroupByGroupKey.get(key)?.issueTypes).filter(Boolean), analyticAttributes);
    }, [
        onChange,
        issueTypeGroupByGroupKey,
        isNested
    ]);
    const selectedGroups = (0, $eUqFw.useMemo)(()=>Array.from(new Set(selectedIssueTypes.map((key)=>issueTypeGroupByIssueType.get(key)))), [
        issueTypeGroupByIssueType,
        selectedIssueTypes
    ]);
    const selectedGroupKeys = selectedGroups.map((group)=>group?.key).filter(Boolean);
    const selectedGroupsAllIssueTypes = selectedGroups.flatMap((group)=>group?.issueTypes).filter(Boolean);
    const onChangeCallback = (0, $eUqFw.useCallback)((entries)=>{
        const entryValues = entries.map(({ value: value })=>value);
        selectGroupsByKeys(entryValues);
    }, [
        selectGroupsByKeys
    ]);
    // early exit if we have only one issue type group
    if (issueTypeGroups.length <= 1) return null;
    // if there's mismatch between the filters in the url and the issue groups, e.g. when the url is manually edited or when an issue of a new type is created, we would apply the whole group
    if (selectedGroupsAllIssueTypes.length !== selectedIssueTypes.length) {
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(selectedGroupsAllIssueTypes, analyticAttributes);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azooe.default), {
        isOpen: isOpen,
        label: formatMessage((0, $lNrGM.default).label),
        values: values,
        selectedValues: selectedGroupKeys,
        onChange: onChangeCallback,
        isNested: isNested
    });
};
$6b9961d32e52eac2$var$IssueTypeGroupFilter.displayName = 'IssueTypeGroupFilter';
$6b9961d32e52eac2$var$IssueTypeGroupFilter.whyDidYouRender = true;
var $6b9961d32e52eac2$export$2e2bcd8739ae039 = $6b9961d32e52eac2$var$IssueTypeGroupFilter;

});
parcelRegister("lNrGM", function(module, exports) {

$parcel$export(module.exports, "default", () => $92076df1efb7cd76$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $92076df1efb7cd76$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "software-filters.filters.issue-type-group.label",
        "defaultMessage": "Type"
    }
});

});


parcelRegister("ifij9", function(module, exports) {

$parcel$export(module.exports, "default", () => $a428ff4a998e30ae$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5JgJ2 = parcelRequire("5JgJ2");

var $azooe = parcelRequire("azooe");

var $2gCEP = parcelRequire("2gCEP");
const $a428ff4a998e30ae$var$LabelFilter = ({ labels: labels = [], selectedLabels: selectedLabels = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), isNested: isNested = false, unassignedOption: unassignedOption })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const values = (0, $eUqFw.useMemo)(()=>{
        const options = labels.map((label)=>({
                label: label,
                value: label
            }));
        unassignedOption && options.unshift(unassignedOption);
        return options;
    }, [
        labels,
        unassignedOption
    ]);
    const onChangeMapValues = (0, $eUqFw.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azooe.default), {
        label: formatMessage((0, $2gCEP.default).label),
        values: values,
        selectedValues: selectedLabels,
        onChange: onChangeMapValues,
        isNested: isNested
    });
};
const $a428ff4a998e30ae$var$LabelFilterComponent = /*#__PURE__*/ (0, $eUqFw.memo)($a428ff4a998e30ae$var$LabelFilter);
$a428ff4a998e30ae$var$LabelFilterComponent.displayName = 'LabelFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$a428ff4a998e30ae$var$LabelFilterComponent.whyDidYouRender = true;
var $a428ff4a998e30ae$export$2e2bcd8739ae039 = $a428ff4a998e30ae$var$LabelFilterComponent;

});
parcelRegister("2gCEP", function(module, exports) {

$parcel$export(module.exports, "default", () => $1276a32f4064ed01$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1276a32f4064ed01$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "software-filters.filters.label.label",
        "defaultMessage": "Label"
    }
});

});


parcelRegister("8NoA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $d87a122a4f8c098d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $9nkwJ = parcelRequire("9nkwJ");

var $7u4fN = parcelRequire("7u4fN");

var $86Ndv = parcelRequire("86Ndv");

var $3MV1G = parcelRequire("3MV1G");

var $8cU5f = parcelRequire("8cU5f");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $iLKfm = parcelRequire("iLKfm");

var $fMKb3 = parcelRequire("fMKb3");

var $b9IeP = parcelRequire("b9IeP");
const $d87a122a4f8c098d$var$OverflowHandler = ({ itemsBefore: itemsBefore, itemsAfter: itemsAfter, selectedItems: selectedItems = {} })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const overflowContainerRef = (0, $eUqFw.useRef)(null);
    const moreFilterRef = (0, $eUqFw.useRef)(null);
    const elementsRef = (0, $eUqFw.useRef)({});
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const prevOverflowContainerWidthRef = (0, $eUqFw.useRef)(0);
    const elementsWidthRef = (0, $eUqFw.useRef)({});
    const visibleElementsRef = (0, $eUqFw.useRef)({});
    const prevElementsWidthRef = (0, $eUqFw.useRef)({});
    const [{ overflowableHideState: overflowableHideState, isMoreDropdownHidden: isMoreDropdownHidden }, setOverflowState] = (0, $eUqFw.useState)({
        overflowableHideState: {},
        isMoreDropdownHidden: true
    });
    const { renderedOverflowableItems: renderedOverflowableItems, staticItems: staticItems, renderedItemsBefore: renderedItemsBefore, renderedItemsAfter: renderedItemsAfter } = (0, $eUqFw.useMemo)(()=>{
        const theOverflowable = [];
        const theStatic = [];
        const theRenderedBefore = [];
        const theRenderedAfter = [];
        const categoriseItems = ({ isRenderedBefore: isRenderedBefore })=>{
            (isRenderedBefore ? itemsBefore : itemsAfter).forEach((item)=>{
                const { isStatic: isStatic, isHidden: isHidden = false } = item;
                // Exclude hidden overflowable items from rendering
                if (!isStatic && isHidden) return;
                (isStatic ? theStatic : theOverflowable).push(item);
                (isRenderedBefore ? theRenderedBefore : theRenderedAfter).push(item);
            });
        };
        categoriseItems({
            isRenderedBefore: true
        });
        categoriseItems({
            isRenderedBefore: false
        });
        return {
            renderedOverflowableItems: theOverflowable,
            staticItems: theStatic,
            renderedItemsBefore: theRenderedBefore,
            renderedItemsAfter: theRenderedAfter
        };
    }, [
        itemsBefore,
        itemsAfter
    ]);
    /**
   * Calculate the count for "More" dropdown.
   * It excludes the selected items of the visible items.
   */ const selectedOverflowItemsCount = (0, $eUqFw.useMemo)(()=>(0, $b9IeP.getSelectedItemsCount)(overflowableHideState, selectedItems), [
        overflowableHideState,
        selectedItems
    ]);
    const adjustOverflow = (0, $eUqFw.useCallback)(()=>{
        const { current: overflowContainer } = overflowContainerRef;
        const { current: moreFilter } = moreFilterRef;
        const shouldOverflow = (0, $b9IeP.getShouldOverflow)(prevOverflowContainerWidthRef.current, overflowContainer?.offsetWidth ?? 0, prevElementsWidthRef.current, elementsWidthRef.current);
        if (!overflowContainer || !moreFilter || !renderedOverflowableItems.length || !shouldOverflow) return;
        // Store the widths for comparison
        prevOverflowContainerWidthRef.current = overflowContainer.offsetWidth;
        prevElementsWidthRef.current = {
            ...elementsWidthRef.current
        };
        setOverflowState((0, $b9IeP.calcOverflow)(overflowContainer, moreFilter, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        renderedOverflowableItems, staticItems, elementsRef.current));
    }, [
        renderedOverflowableItems,
        staticItems
    ]);
    (0, $fMKb3.useResizeObserver)(overflowContainerRef, adjustOverflow);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(!isOpen);
    }, [
        isOpen,
        setIsOpen
    ]);
    const onClose = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    const triggerLabel = formatMessage((0, $iLKfm.default).more);
    const triggerTooltipText = formatMessage((0, $iLKfm.default).moreFiltersTooltip);
    const buttonToolTip = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: triggerTooltipText,
            hideTooltipOnClick: true,
            tag: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d87a122a4f8c098d$var$TriggerContainer, {
            "data-testid": "filters.common.ui.overflow-handler.trigger-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d87a122a4f8c098d$var$TriggerLabel, null, triggerLabel), selectedOverflowItemsCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d87a122a4f8c098d$var$BadgeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
            appearance: "primary"
        }, selectedOverflowItemsCount)))), [
        selectedOverflowItemsCount,
        triggerTooltipText,
        triggerLabel
    ]);
    const content = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d87a122a4f8c098d$var$PopupContainer, null, renderedOverflowableItems.map(({ id: id, renderer: renderer })=>Boolean(overflowableHideState[id]) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
                key: id
            }, renderer(true)))), [
        renderedOverflowableItems,
        overflowableHideState
    ]);
    const renderItems = (items)=>items.map(({ id: id, isStatic: isStatic, isHidden: isHidden = false, renderer: renderer })=>{
            const isItemHidden = isStatic ? isHidden : Boolean(overflowableHideState[id]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d87a122a4f8c098d$var$ItemWrapper, {
                key: id,
                innerRef: (element)=>{
                    elementsRef.current[id] = element;
                    if (element) {
                        elementsWidthRef.current[id] = element.offsetWidth;
                        if (!isHidden) visibleElementsRef.current[id] = {
                            width: element.offsetWidth,
                            height: element.offsetHeight
                        };
                    }
                },
                "aria-hidden": isItemHidden,
                isHidden: isItemHidden
            }, renderer(false));
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d87a122a4f8c098d$var$OverflowContainer, {
        ref: overflowContainerRef
    }, renderItems(renderedItemsBefore), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d87a122a4f8c098d$var$ItemWrapper, {
        innerRef: moreFilterRef,
        "aria-hidden": isMoreDropdownHidden,
        isHidden: isMoreDropdownHidden
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.Popup), {
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...triggerProps,
                appearance: "subtle",
                isSelected: isOpen,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                    primaryColor: "var(--ds-icon, #44546F)",
                    label: triggerLabel
                }),
                onClick: onClick
            }, buttonToolTip),
        shouldRenderToParent: true,
        shouldFlip: true,
        isOpen: isOpen,
        placement: "bottom-start",
        content: content,
        onClose: onClose
    })), renderItems(renderedItemsAfter));
};
var $d87a122a4f8c098d$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $d87a122a4f8c098d$var$OverflowHandler;
const $d87a122a4f8c098d$var$OverflowContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1ul9idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d87a122a4f8c098d$var$PopupContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4swc3",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d87a122a4f8c098d$var$TriggerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d87a122a4f8c098d$var$TriggerLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721q9c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d87a122a4f8c098d$var$BadgeContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _19bv1b66",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $d87a122a4f8c098d$var$ItemWrapperControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1krxkwp-0"
})((props)=>({
        flexShrink: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        order: props.isHidden ? 2 : 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        visibility: props.isHidden ? 'hidden' : 'visible',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        pointerEvents: props.isHidden ? 'none' : 'auto'
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d87a122a4f8c098d$var$ItemWrapperExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isHidden: isHidden, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1o9zidpf",
            __cmplp.isHidden ? "_1f49cs5v" : "_1f49kb7n",
            __cmplp.isHidden ? "_3um015vq" : "_3um0ewfl",
            __cmplp.isHidden ? "_lcxvglyw" : "_lcxv1wug",
            __cmplp.className
        ])
    });
});
const $d87a122a4f8c098d$var$ItemWrapper = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $d87a122a4f8c098d$var$ItemWrapperExperiment, $d87a122a4f8c098d$var$ItemWrapperControl);

});
parcelRegister("iLKfm", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5a29a4590d069b6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c5a29a4590d069b6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    more: {
        "id": "software-filters.common.overflow-handler.more",
        "defaultMessage": "More"
    },
    moreFiltersTooltip: {
        "id": "software-filters.common.overflow-handler.more-filters-tooltip",
        "defaultMessage": "More filters"
    }
});

});

parcelRegister("fMKb3", function(module, exports) {

$parcel$export(module.exports, "useResizeObserver", () => $21cd25eee961b6ff$export$683480f191c0e3ea);

var $eUqFw = parcelRequire("eUqFw");
let $21cd25eee961b6ff$var$resizeObserver;
const $21cd25eee961b6ff$var$callbacks = new Map();
const $21cd25eee961b6ff$var$runCallbacks = (entries)=>{
    entries.forEach((entry)=>{
        const { target: target } = entry;
        const callback = $21cd25eee961b6ff$var$callbacks.get(target);
        callback?.(entry);
    });
};
const $21cd25eee961b6ff$var$observeElement = (target, callback)=>{
    if (typeof ResizeObserver === 'undefined') return;
    if (!$21cd25eee961b6ff$var$resizeObserver) $21cd25eee961b6ff$var$resizeObserver = new ResizeObserver($21cd25eee961b6ff$var$runCallbacks);
    $21cd25eee961b6ff$var$callbacks.set(target, callback);
    $21cd25eee961b6ff$var$resizeObserver.observe(target);
};
const $21cd25eee961b6ff$var$unobserveElement = (target)=>{
    if (!$21cd25eee961b6ff$var$resizeObserver) return;
    $21cd25eee961b6ff$var$callbacks.delete(target);
    $21cd25eee961b6ff$var$resizeObserver.unobserve(target);
};
const $21cd25eee961b6ff$export$683480f191c0e3ea = (ref, callback)=>{
    (0, $eUqFw.useLayoutEffect)(()=>{
        const element = ref.current;
        element && $21cd25eee961b6ff$var$observeElement(element, callback);
        return ()=>{
            element && $21cd25eee961b6ff$var$unobserveElement(element);
        };
    }, [
        ref,
        callback
    ]);
};

});

parcelRegister("b9IeP", function(module, exports) {

$parcel$export(module.exports, "calcOverflow", () => $274da3a39e4318f2$export$7128ab9dfe00f62e);
$parcel$export(module.exports, "getShouldOverflow", () => $274da3a39e4318f2$export$bed1132ed65531ff);
$parcel$export(module.exports, "getSelectedItemsCount", () => $274da3a39e4318f2$export$b0e31612dc0df344);

var $8blac = parcelRequire("8blac");

var $1ybV0 = parcelRequire("1ybV0");
const $274da3a39e4318f2$export$1fed873882a661c5 = (items, itemElements, spaceLimit)=>{
    const hideState = {};
    let usedSpace = 0;
    let isOverflowingAssumed = false;
    items.forEach(({ id: id })=>{
        const element = itemElements[id];
        if (element) {
            const { offsetWidth: space } = element;
            if ((spaceLimit === undefined || usedSpace + space < spaceLimit) && !isOverflowingAssumed) usedSpace += space;
            else {
                if (!isOverflowingAssumed) isOverflowingAssumed = true;
                hideState[id] = true;
            }
        }
    });
    return {
        usedSpace: usedSpace,
        hideState: hideState
    };
};
const $274da3a39e4318f2$export$7128ab9dfe00f62e = ({ offsetWidth: availableSpace }, { offsetWidth: moreFilterSpace }, renderedOverflowableItems, staticItems, itemElements)=>{
    const { usedSpace: staticSpace } = $274da3a39e4318f2$export$1fed873882a661c5(staticItems, itemElements);
    const maxOverflowableSpace = renderedOverflowableItems.reduce((maxSpace, { id: id })=>maxSpace + (itemElements[id]?.offsetWidth ?? 0), 0);
    const isOverflowing = (0, $1ybV0.ff)('refactor-more-button-display-on-small-devices_tnu38') ? maxOverflowableSpace + staticSpace > availableSpace : maxOverflowableSpace + staticSpace >= availableSpace;
    let overflowableHideState = {};
    if (isOverflowing) {
        const spaceLimit = Math.max(availableSpace - moreFilterSpace - staticSpace, 0);
        const { hideState: hideState } = $274da3a39e4318f2$export$1fed873882a661c5(renderedOverflowableItems, itemElements, spaceLimit);
        overflowableHideState = hideState;
    }
    return {
        overflowableHideState: overflowableHideState,
        isMoreDropdownHidden: !isOverflowing
    };
};
const $274da3a39e4318f2$var$BADGE_WIDTH_THRESHOLD = 25; // Width of count badge
const $274da3a39e4318f2$export$bed1132ed65531ff = (prevContainerWidth, currContainerWidth, prevElementsWidthRef, currElementsWidthRef)=>{
    const currItemIds = Object.keys(currElementsWidthRef);
    const prevItemIds = Object.keys(prevElementsWidthRef);
    if (prevItemIds.length !== currItemIds.length || prevContainerWidth !== currContainerWidth) return true;
    const isItemUpdated = currItemIds.some((id)=>prevElementsWidthRef[id] === undefined || Math.abs(prevElementsWidthRef[id] - currElementsWidthRef[id]) > $274da3a39e4318f2$var$BADGE_WIDTH_THRESHOLD);
    return isItemUpdated;
};
const $274da3a39e4318f2$export$b0e31612dc0df344 = (itemsHiddenState, selectedItems)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(selectedItems) || (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(itemsHiddenState)) return 0;
    return Object.entries(selectedItems).reduce((acc, [key, value])=>{
        if (value === undefined || itemsHiddenState[key] !== true) return acc;
        // selectedItem could be "any" value, if the value is not an Array, it will be counted as 1
        return Array.isArray(value) ? acc + value.length : acc + 1;
    }, 0);
};

});


parcelRegister("37gdQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $89b7bf9c6af5f6d4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $giAhk = parcelRequire("giAhk");

var $kJlBc = parcelRequire("kJlBc");

var $8WuJm = parcelRequire("8WuJm");

var $6vrw7 = parcelRequire("6vrw7");

var $8MrYx = parcelRequire("8MrYx");
var $3kYjh = parcelRequire("3kYjh");

var $azooe = parcelRequire("azooe");

var $9kkzA = parcelRequire("9kkzA");
const $89b7bf9c6af5f6d4$var$ParentFilter = (props)=>{
    const { label: label, parents: parents, selectedParents: selectedParents, isToggleChecked: isToggleChecked, onTogglePanel: onTogglePanel, onInputChange: onInputChange, onOpenChange: onOpenChange, onMouseEnterToTriggerButton: onMouseEnterToTriggerButton, intl: { formatMessage: formatMessage }, showPanelToggle: showPanelToggle, showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty, inputValue: inputValue, isLoading: isLoading, isAsyncSearch: isAsyncSearch, isNested: isNested, isOpen: isOpen } = props;
    const [boardId] = (0, $kJlBc.usePathParam)('boardId');
    const { toggleViewSetting: toggleViewSetting } = (0, $8MrYx.useViewSettingsActions)();
    const values = (0, $eUqFw.useMemo)(()=>parents.map((parent)=>({
                label: parent.name,
                value: parent.id,
                subLabel: parent.key
            })), [
        parents
    ]);
    const onChange = (0, $eUqFw.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        props.onChange(entries.map((entry)=>(0, $6vrw7.toIssueId)(entry.value)), analyticAttributes);
    }, [
        props,
        isNested
    ]);
    const handleTogglePanel = (0, $eUqFw.useCallback)(()=>{
        if (boardId) toggleViewSetting({
            boardId: Number(boardId),
            setting: (0, $3kYjh.ViewSetting).EPIC_PANEL
        });
        onTogglePanel();
    }, [
        boardId,
        onTogglePanel,
        toggleViewSetting
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "epicPanelToggle",
        attributes: {
            isOpen: !isToggleChecked,
            filterType: label
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azooe.default), {
        label: label,
        toggleLabel: formatMessage((0, $9kkzA.default).toggleLabel, {
            parentName: label?.toLowerCase()
        }),
        values: values,
        isOpen: isOpen,
        showPanelToggle: showPanelToggle,
        selectedValues: selectedParents.map(String),
        isPanelToggleChecked: isToggleChecked,
        onChange: onChange,
        inputValue: inputValue,
        isLoading: isLoading,
        onInputChange: onInputChange,
        onTogglePanel: handleTogglePanel,
        onOpenChange: onOpenChange,
        noOptionsMessage: formatMessage((0, $9kkzA.default).noParentIssues, {
            parentName: label
        }),
        showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty,
        isAsyncSearch: isAsyncSearch,
        isNested: isNested,
        onMouseEnterToTriggerButton: onMouseEnterToTriggerButton
    }));
};
$89b7bf9c6af5f6d4$var$ParentFilter.defaultProps = {
    selectedParents: [],
    isToggleChecked: false,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onInputChange: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onTogglePanel: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    showPanelToggle: false,
    showMenuIfValuesAreEmpty: false,
    isLoading: false,
    isAsyncSearch: false,
    isNested: false
};
var $89b7bf9c6af5f6d4$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($89b7bf9c6af5f6d4$var$ParentFilter);

});
parcelRegister("9kkzA", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f2065d18bd5dbf1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1f2065d18bd5dbf1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noParentIssues: {
        "id": "software-filters.filters.parent.no-parent-issues",
        "defaultMessage": "Your project has no {parentName}"
    },
    toggleLabel: {
        "id": "software-filters.filters.parent.toggle-label",
        "defaultMessage": "Show {parentName} panel"
    }
});

});


parcelRegister("8rjRz", function(module, exports) {

$parcel$export(module.exports, "default", () => $20a5d5a3c7bae2f6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $4ksts = parcelRequire("4ksts");

var $azooe = parcelRequire("azooe");

var $6wq34 = parcelRequire("6wq34");
const $20a5d5a3c7bae2f6$var$MAX_SELECTION_ALLOWED = 10;
const $20a5d5a3c7bae2f6$var$QuickFilter = ({ filters: filters = [], selectedFilters: selectedFilters = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const values = (0, $eUqFw.useMemo)(()=>filters.map((filter)=>({
                label: filter.name,
                value: filter.id
            })), [
        filters
    ]);
    const onChangeMapValues = (0, $eUqFw.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    const maxSelectionReachedTooltip = formatMessage((0, $6wq34.default).maxSelectionReachedTooltip, {
        maxSelectionAllowed: $20a5d5a3c7bae2f6$var$MAX_SELECTION_ALLOWED
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azooe.default), {
        label: formatMessage((0, $6wq34.default).label),
        values: values,
        selectedValues: selectedFilters,
        onChange: onChangeMapValues,
        maxSelectionAllowed: $20a5d5a3c7bae2f6$var$MAX_SELECTION_ALLOWED,
        maxSelectionReachedTooltip: maxSelectionReachedTooltip,
        isNested: isNested
    });
};
const $20a5d5a3c7bae2f6$var$QuickFilterComponent = /*#__PURE__*/ (0, $eUqFw.memo)($20a5d5a3c7bae2f6$var$QuickFilter);
$20a5d5a3c7bae2f6$var$QuickFilterComponent.displayName = 'QuickFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$20a5d5a3c7bae2f6$var$QuickFilterComponent.whyDidYouRender = true;
var $20a5d5a3c7bae2f6$export$2e2bcd8739ae039 = $20a5d5a3c7bae2f6$var$QuickFilterComponent;

});
parcelRegister("6wq34", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e68abd7d345f0f5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6e68abd7d345f0f5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "software-filters.filters.quick.label",
        "defaultMessage": "Quick filters"
    },
    maxSelectionReachedTooltip: {
        "id": "software-filters.filters.quick.max-selection-reached-tooltip",
        "defaultMessage": "You can't select more than {maxSelectionAllowed, plural, one {# quick filter} other {# quick filters}}"
    }
});

});


parcelRegister("9iyDY", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfb1e777f4ed1038$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5JgJ2 = parcelRequire("5JgJ2");

var $azooe = parcelRequire("azooe");

var $bQpgz = parcelRequire("bQpgz");
const $cfb1e777f4ed1038$var$RequestTypeFilter = ({ requestTypes: requestTypes = [], selectedRequestTypes: selectedRequestTypes = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const values = (0, $eUqFw.useMemo)(()=>requestTypes.map((requestType)=>({
                label: requestType.name,
                value: requestType.id,
                iconUrl: requestType.iconUrl
            })), [
        requestTypes
    ]);
    const onChangeCallback = (0, $eUqFw.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    // early exit if we have only one option
    if (requestTypes.length <= 1) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azooe.default), {
        label: formatMessage((0, $bQpgz.default).label),
        values: values,
        selectedValues: selectedRequestTypes.map(String),
        onChange: onChangeCallback,
        isNested: isNested
    });
};
const $cfb1e777f4ed1038$var$RequestTypeFilterComponent = /*#__PURE__*/ (0, $eUqFw.memo)($cfb1e777f4ed1038$var$RequestTypeFilter);
$cfb1e777f4ed1038$var$RequestTypeFilterComponent.displayName = 'RequestTypeFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$cfb1e777f4ed1038$var$RequestTypeFilterComponent.whyDidYouRender = true;
var $cfb1e777f4ed1038$export$2e2bcd8739ae039 = $cfb1e777f4ed1038$var$RequestTypeFilterComponent;

});
parcelRegister("bQpgz", function(module, exports) {

$parcel$export(module.exports, "default", () => $60177fa6ca6183ec$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $60177fa6ca6183ec$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "software-filters.filters.request-type.label",
        "defaultMessage": "Request type"
    }
});

});


parcelRegister("hNl8a", function(module, exports) {

$parcel$export(module.exports, "default", () => $69e04c62d6057d97$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $azooe = parcelRequire("azooe");

var $btVqx = parcelRequire("btVqx");
const $69e04c62d6057d97$var$SprintFilter = ({ sprints: sprints = [], selectedSprints: selectedSprints = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'sprintFilter rendered', {
            numberOfSprints: sprints.length
        });
    }, [
        createAnalyticsEvent,
        sprints
    ]);
    const values = (0, $eUqFw.useMemo)(()=>sprints.map((sprint)=>({
                label: sprint.name,
                value: sprint.id.toString()
            })), [
        sprints
    ]);
    const onChangeMapValues = (0, $eUqFw.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azooe.default), {
        label: formatMessage((0, $btVqx.default).label),
        values: values,
        selectedValues: selectedSprints,
        onChange: onChangeMapValues,
        isNested: isNested
    });
};
const $69e04c62d6057d97$var$SprintFilterComponent = /*#__PURE__*/ (0, $eUqFw.memo)($69e04c62d6057d97$var$SprintFilter);
$69e04c62d6057d97$var$SprintFilterComponent.displayName = 'SprintFilter';
var $69e04c62d6057d97$export$2e2bcd8739ae039 = $69e04c62d6057d97$var$SprintFilterComponent;

});
parcelRegister("btVqx", function(module, exports) {

$parcel$export(module.exports, "default", () => $9beb08ea05e17663$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9beb08ea05e17663$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "software-filters.filters.sprint.label",
        "defaultMessage": "Sprint"
    }
});

});


parcelRegister("7Xd92", function(module, exports) {

$parcel$export(module.exports, "default", () => $8db35472b726a302$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $4ksts = parcelRequire("4ksts");

var $6vrw7 = parcelRequire("6vrw7");

var $azooe = parcelRequire("azooe");

var $csSOW = parcelRequire("csSOW");
const $8db35472b726a302$var$StatusCategoryFilter = ({ statusCategories: statusCategories = [], selectedStatusCategories: selectedStatusCategories = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const values = (0, $eUqFw.useMemo)(()=>statusCategories.map(({ id: id, name: name })=>({
                label: name,
                value: id
            })), [
        statusCategories
    ]);
    const onChangeValue = (0, $eUqFw.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map(({ value: value })=>(0, $6vrw7.toIssueStatusCategoryId)(value)), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    // early exit if we have only one option
    if (values.length <= 1) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azooe.default), {
        label: formatMessage((0, $csSOW.default).label),
        values: values,
        selectedValues: selectedStatusCategories.map(String),
        onChange: onChangeValue,
        isNested: isNested
    });
};
const $8db35472b726a302$var$StatusCategoryFilterComponent = /*#__PURE__*/ (0, $eUqFw.memo)($8db35472b726a302$var$StatusCategoryFilter);
$8db35472b726a302$var$StatusCategoryFilterComponent.displayName = 'StatusCategoryFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$8db35472b726a302$var$StatusCategoryFilterComponent.whyDidYouRender = true;
var $8db35472b726a302$export$2e2bcd8739ae039 = $8db35472b726a302$var$StatusCategoryFilterComponent;

});
parcelRegister("csSOW", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f8849ca65a85d2f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8f8849ca65a85d2f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "software-filters.filters.status-category.label",
        "defaultMessage": "Status category"
    }
});

});


parcelRegister("2ZPCT", function(module, exports) {

$parcel$export(module.exports, "default", () => $03c4f6cbe6b6fd36$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6vrw7 = parcelRequire("6vrw7");

var $azooe = parcelRequire("azooe");

var $fjYiT = parcelRequire("fjYiT");
const $03c4f6cbe6b6fd36$var$StatusFilter = ({ statuses: statuses = [], selectedStatuses: selectedStatuses = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const values = (0, $eUqFw.useMemo)(()=>statuses.map(({ id: id, name: name })=>({
                label: name,
                value: id
            })), [
        statuses
    ]);
    const onChangeValue = (0, $eUqFw.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map(({ value: value })=>(0, $6vrw7.toIssueStatusId)(value)), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    // early exit if we have only one option
    if (values.length <= 1) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azooe.default), {
        label: formatMessage((0, $fjYiT.default).label),
        values: values,
        selectedValues: selectedStatuses.map(String),
        onChange: onChangeValue,
        isNested: isNested
    });
};
const $03c4f6cbe6b6fd36$var$StatusFilterComponent = /*#__PURE__*/ (0, $eUqFw.memo)($03c4f6cbe6b6fd36$var$StatusFilter);
$03c4f6cbe6b6fd36$var$StatusFilterComponent.displayName = 'StatusFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$03c4f6cbe6b6fd36$var$StatusFilterComponent.whyDidYouRender = true;
var $03c4f6cbe6b6fd36$export$2e2bcd8739ae039 = $03c4f6cbe6b6fd36$var$StatusFilterComponent;

});
parcelRegister("fjYiT", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3751963510c6878$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f3751963510c6878$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "software-filters.filters.status.label",
        "defaultMessage": "Status"
    }
});

});


parcelRegister("b9Y1q", function(module, exports) {

$parcel$export(module.exports, "default", () => $eab251137c38af3a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $55pTl = parcelRequire("55pTl");

var $aOINP = parcelRequire("aOINP");
var $ltfxy = parcelRequire("ltfxy");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $aR8n6 = parcelRequire("aR8n6");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kJlBc = parcelRequire("kJlBc");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $6vrw7 = parcelRequire("6vrw7");

var $8MrYx = parcelRequire("8MrYx");
var $3kYjh = parcelRequire("3kYjh");

var $azooe = parcelRequire("azooe");

var $e7MSa = parcelRequire("e7MSa");
const $eab251137c38af3a$var$VersionFilter = (props)=>{
    const { versions: versions, selectedVersions: selectedVersions, isToggleChecked: isToggleChecked, onTogglePanel: onTogglePanel, isSpotlightEnabled: isSpotlightEnabled, showPanelToggle: showPanelToggle, isNested: isNested, toggleRef: toggleRef, hasMultipleProjects: hasMultipleProjects } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { toggleViewSetting: toggleViewSetting } = (0, $8MrYx.useViewSettingsActions)();
    const [boardId] = (0, $kJlBc.usePathParam)('boardId');
    const values = (0, $eUqFw.useMemo)(()=>versions.map((version)=>({
                label: version.name,
                // Casting to string normalises the id that may potentially be a number.
                value: String(version.id),
                subLabel: hasMultipleProjects ? version.projectKey : undefined
            })), [
        versions,
        hasMultipleProjects
    ]);
    const onChange = (0, $eUqFw.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        props.onChange(entries.map(({ value: value })=>value), analyticAttributes);
    }, [
        props,
        isNested
    ]);
    const handleTogglePanel = (0, $eUqFw.useCallback)(()=>{
        if (boardId) toggleViewSetting({
            boardId: Number(boardId),
            setting: (0, $3kYjh.ViewSetting).VERSION_PANEL
        });
        onTogglePanel();
    }, [
        boardId,
        onTogglePanel,
        toggleViewSetting
    ]);
    const renderContent = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azooe.default), {
            label: formatMessage((0, $e7MSa.default).label),
            toggleLabel: formatMessage((0, $e7MSa.default).toggleLabel),
            values: values,
            showPanelToggle: showPanelToggle,
            selectedValues: (0, $6vrw7.toStringArray)(selectedVersions),
            isPanelToggleChecked: isToggleChecked,
            onChange: onChange,
            onTogglePanel: handleTogglePanel,
            noOptionsMessage: formatMessage(values.length === 0 ? (0, $e7MSa.default).noUnreleasedVersions : (0, $e7MSa.default).noMatchingVersions),
            showMenuIfValuesAreEmpty: true,
            isNested: isNested,
            toggleRef: toggleRef
        }), [
        formatMessage,
        values,
        showPanelToggle,
        selectedVersions,
        isToggleChecked,
        onChange,
        isNested,
        toggleRef,
        handleTogglePanel
    ]);
    if (isSpotlightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOINP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
        name: "fusionBacklogVersionsPanel"
    }, renderContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $55pTl.EngagementSpotlight), {
        engagementId: "fusionBacklogVersionsPanel"
    })));
    return renderContent;
};
$eab251137c38af3a$var$VersionFilter.displayName = 'VersionFilter';
$eab251137c38af3a$var$VersionFilter.whyDidYouRender = true;
const $eab251137c38af3a$var$ErrorWrapper = (props)=>{
    if (!props.isVersionsFeatureEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "jira.backlog.version.panel",
        packageName: "jiraFilters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
        id: "jira.backlog.version.panel",
        packageName: "jiraFilters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "versionFilter",
        attributes: {
            isVersionPanelOpen: props.isToggleChecked
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eab251137c38af3a$var$VersionFilter, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null))));
};
$eab251137c38af3a$var$ErrorWrapper.defaultProps = {
    versions: [],
    selectedVersions: [],
    isToggleChecked: false,
    isSpotlightEnabled: false,
    showPanelToggle: true,
    isVersionsFeatureEnabled: false,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onTogglePanel: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    isNested: false
};
var $eab251137c38af3a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($eab251137c38af3a$var$ErrorWrapper);

});
parcelRegister("e7MSa", function(module, exports) {

$parcel$export(module.exports, "default", () => $54b1075579499f24$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $54b1075579499f24$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noUnreleasedVersions: {
        "id": "software-filters.filters.version.no-unreleased-versions",
        "defaultMessage": "No unreleased versions in this project"
    },
    noMatchingVersions: {
        "id": "software-filters.filters.version.no-matching-versions",
        "defaultMessage": "No matching versions"
    },
    label: {
        "id": "software-filters.filters.version.label",
        "defaultMessage": "Version"
    },
    toggleLabel: {
        "id": "software-filters.filters.version.toggle-label",
        "defaultMessage": "Show version panel"
    }
});

});


parcelRegister("glQYN", function(module, exports) {

$parcel$export(module.exports, "default", () => $679a38503f8c6462$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $15Xup = parcelRequire("15Xup");

var $klbwP = parcelRequire("klbwP");
const $679a38503f8c6462$var$AsyncBoardSwitcher = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $klbwP.syncBoardSwitcher), {});
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
        return ()=>{
            entryPointActions.unload();
        };
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "plan-increment-board-switcher",
        packageName: (0, $15Xup.PACKAGE_NAME),
        teamName: (0, $15Xup.ERROR_REPORTING_TEAM),
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
};
var $679a38503f8c6462$export$2e2bcd8739ae039 = $679a38503f8c6462$var$AsyncBoardSwitcher;

});
parcelRegister("15Xup", function(module, exports) {

$parcel$export(module.exports, "KANBAN_TEAM", () => $5c98b78e1862f2d4$export$f43662b315e78f32);
$parcel$export(module.exports, "SINGLE_CUSTOM_FIELD_TYPE_KEY", () => $5c98b78e1862f2d4$export$7a7b05cceb7cc8a9);
$parcel$export(module.exports, "MULTI_CUSTOM_FIELD_TYPE_KEY", () => $5c98b78e1862f2d4$export$2afd90c3608e7105);
$parcel$export(module.exports, "SYSTEM_LABEL_FIELD_ID", () => $5c98b78e1862f2d4$export$84bf4e4e31fe4475);
$parcel$export(module.exports, "CUSTOM_FIELD_OPTION_MISSED_ERROR", () => $5c98b78e1862f2d4$export$aa4bdec93afa2924);
$parcel$export(module.exports, "FILTER_FIELD_ERROR", () => $5c98b78e1862f2d4$export$a497a01fd14a64af);
$parcel$export(module.exports, "MAX_ACTIVE_BOARDS", () => $5c98b78e1862f2d4$export$70493a18b15fa2cc);
$parcel$export(module.exports, "IP_BOARD_STORY_POINTS_PLANNING_UNIT", () => $5c98b78e1862f2d4$export$e2ffaae341a16c5e);
$parcel$export(module.exports, "IP_BOARD_HOURS_PLANNING_UNIT", () => $5c98b78e1862f2d4$export$9a6e823d5b9e62be);
$parcel$export(module.exports, "IP_BOARD_DAYS_PLANNING_UNIT", () => $5c98b78e1862f2d4$export$ad92792f1d38ffba);
$parcel$export(module.exports, "ERROR_REPORTING_TEAM", () => $5c98b78e1862f2d4$export$cfeee2ee86ead336);
$parcel$export(module.exports, "PACKAGE_NAME", () => $5c98b78e1862f2d4$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "DOC_LINKS", () => $5c98b78e1862f2d4$export$f8975d2c25cd8c82);
$parcel$export(module.exports, "IPH_IDS", () => $5c98b78e1862f2d4$export$253194752488840a);
$parcel$export(module.exports, "MARK_SYNC_SPRINTS_PREFIX", () => $5c98b78e1862f2d4$export$c78721cd39b97424);
$parcel$export(module.exports, "MARK_SYNC_SPRINTS_START", () => $5c98b78e1862f2d4$export$1bb2633f6c6f66d1);
$parcel$export(module.exports, "MARK_SYNC_SPRINTS_END", () => $5c98b78e1862f2d4$export$9583c6ba8c6caee3);
$parcel$export(module.exports, "BOARD_SCOPE_FILTER_NONE", () => $5c98b78e1862f2d4$export$f2ee1113933b4540);
$parcel$export(module.exports, "BOARD_SCOPE_FILTER_LABEL", () => $5c98b78e1862f2d4$export$3212503575d06ffd);
$parcel$export(module.exports, "BOARD_SCOPE_FILTER_SINGLE_SELECT", () => $5c98b78e1862f2d4$export$ba991b7dc2732ca3);
$parcel$export(module.exports, "BOARD_SCOPE_FILTER_MULTI_SELECT", () => $5c98b78e1862f2d4$export$df2129225b939441);
const $5c98b78e1862f2d4$export$103a728db4a941f8 = 'Scrum';
const $5c98b78e1862f2d4$export$f43662b315e78f32 = 'Kanban';
const $5c98b78e1862f2d4$export$7a7b05cceb7cc8a9 = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $5c98b78e1862f2d4$export$2afd90c3608e7105 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $5c98b78e1862f2d4$export$84bf4e4e31fe4475 = 'labels';
const $5c98b78e1862f2d4$export$aa4bdec93afa2924 = 'CUSTOM_FIELD_OPTION_MISSED';
const $5c98b78e1862f2d4$export$a497a01fd14a64af = {
    NOT_FOUND: 'CUSTOM_FIELD_NOT_FOUND',
    TRASHED: 'CUSTOM_FIELD_TRASHED',
    NOT_IN_PLAN: 'CUSTOM_FIELD_NOT_IN_PLAN',
    OPTION_NOT_FOUND: 'CUSTOM_FIELD_OPTION_NOT_FOUND'
};
const $5c98b78e1862f2d4$export$70493a18b15fa2cc = 2;
const $5c98b78e1862f2d4$export$e2ffaae341a16c5e = 'StoryPoints';
const $5c98b78e1862f2d4$export$9a6e823d5b9e62be = 'Hours';
const $5c98b78e1862f2d4$export$ad92792f1d38ffba = 'Days';
const $5c98b78e1862f2d4$export$cfeee2ee86ead336 = 'axolotl';
const $5c98b78e1862f2d4$export$b8b9d90f9e5bd72b = 'jiraPortfolio3PlanIncrementCommon';
const $5c98b78e1862f2d4$export$f8975d2c25cd8c82 = {
    PROGRAM_BOARD: 'https://support.atlassian.com/jira-software-cloud/docs/what-is-the-program-board-in-my-plan/',
    LINK_SPRINTS: 'https://support.atlassian.com/jira-software-cloud/docs/add-and-change-sprints-on-the-program-board-in-your-plan/',
    CREATION: 'https://support.atlassian.com/jira-software-cloud/docs/what-does-the-program-board-show/'
};
const $5c98b78e1862f2d4$export$253194752488840a = {
    PROGRAM_BOARDS_CREATE: '6gJCMknYvLjnUgKrm4BKIj',
    PROGRAM_BOARDS_SETTINGS: '1pdnvDJUBHtLdAcH6F03rm'
};
const $5c98b78e1862f2d4$export$c78721cd39b97424 = 'plan-increment.sync-sprints:';
const $5c98b78e1862f2d4$export$1bb2633f6c6f66d1 = `${$5c98b78e1862f2d4$export$c78721cd39b97424}start`;
const $5c98b78e1862f2d4$export$9583c6ba8c6caee3 = `${$5c98b78e1862f2d4$export$c78721cd39b97424}end`;
const $5c98b78e1862f2d4$export$f2ee1113933b4540 = 'none';
const $5c98b78e1862f2d4$export$3212503575d06ffd = 'label';
const $5c98b78e1862f2d4$export$ba991b7dc2732ca3 = 'select';
const $5c98b78e1862f2d4$export$df2129225b939441 = 'multiselect';

});

parcelRegister("klbwP", function(module, exports) {

$parcel$export(module.exports, "syncBoardSwitcher", () => $24b2ce6661175299$export$e13b401cdb60e3ed);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $24b2ce6661175299$export$e13b401cdb60e3ed = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("92Bgk")).then((module)=>module.AsyncBoardSwitcher), {
        moduleId: "2623f17b"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("92Bgk", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('4k68Q')
        ]);
        const value = parcelRequire('5pr6u');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("4k68Q")
    ]).then(()=>parcelRequire('5pr6u'));
}

});



parcelRegister("fqAlt", function(module, exports) {

$parcel$export(module.exports, "CollabContainerAsync", () => $4b716fbe5fc1d02e$export$69b83fdf5027068d);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4b716fbe5fc1d02e$var$LazyCollabContainer = (0, $7rh0R.lazy)(()=>(parcelRequire("6ym4O")).then(({ CollabContainer: CollabContainer })=>CollabContainer), {
    moduleId: "./src/packages/software/real-time-presence/src/controllers/collab/index.tsx"
});
const $4b716fbe5fc1d02e$export$69b83fdf5027068d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-jira-software-real-time-presence",
        packageName: "jiraSoftwareRealtimePresence",
        teamName: "a4t-werewolves",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "software-real-time-presence",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4b716fbe5fc1d02e$var$LazyCollabContainer, props)));

});
parcelRegister("6ym4O", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('eSMGv');
        const value = parcelRequire('65xSr');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("eSMGv").then(()=>parcelRequire('65xSr'));
}

});


parcelRegister("fmImn", function(module, exports) {

$parcel$export(module.exports, "useCollabStore", () => $bcb2c318ace1641e$export$4159ae80cfa2156);

var $lyOYo = parcelRequire("lyOYo");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

const $bcb2c318ace1641e$var$updateUserInParticipants = (user)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            participants: state.participants.map((participant)=>{
                if (participant.clientId === user.userId) return {
                    ...participant,
                    avatar: user.avatar,
                    name: user.name,
                    email: user.email
                };
                return participant;
            })
        });
    };
const $bcb2c318ace1641e$var$participantsJoined = (joined)=>({ getState: getState, setState: setState })=>{
        const uniqueJoined = (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(joined, ({ sessionId: sessionId })=>sessionId);
        const newParticipantSessionIds = uniqueJoined.map(({ sessionId: sessionId })=>sessionId);
        const state = getState();
        const { provider: provider } = state;
        const newParticipants = [
            ...state.participants.filter(({ sessionId: sessionId })=>!newParticipantSessionIds.includes(sessionId)),
            ...uniqueJoined
        ];
        // Collab team advised we should limit the number of max connections to control the load on collab service
        if (newParticipants.length >= (0, $356df1c77d24a703$export$3debf01bbfa135e5) && provider) {
            // sort users by last active (last joined)
            const sortedUsers = newParticipants.sort((userA, userB)=>userA.lastActive > userB.lastActive ? 1 : -1);
            const currentUser = sortedUsers.find((user)=>user.sessionId === provider.sessionId);
            const lastActiveUser = sortedUsers[sortedUsers.length - 1];
            // kick the last joined user out
            setState({
                ...state,
                participants: newParticipants.filter(({ sessionId: sessionId })=>sessionId !== lastActiveUser.sessionId)
            });
            if (lastActiveUser.sessionId === currentUser?.sessionId) provider.destroy();
            return;
        }
        setState({
            ...state,
            participants: newParticipants
        });
    };
const $bcb2c318ace1641e$var$participantsLeft = (left)=>({ getState: getState, setState: setState })=>{
        const leftSessionIds = left.map(({ sessionId: sessionId })=>sessionId);
        const state = getState();
        // cleanup user selection when they leave the session
        const newSelection = {};
        Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
            const selections = state.nodeSelection[nodeIdKey];
            if (selections.length > 0) {
                const filteredSelections = selections.filter((selection)=>!leftSessionIds.includes(selection.sessionId));
                if (filteredSelections.length === 0) return;
                newSelection[nodeIdKey] = filteredSelections;
            }
        });
        setState({
            ...state,
            participants: state.participants.filter(({ sessionId: sessionId })=>!leftSessionIds.includes(sessionId)),
            nodeSelection: newSelection
        });
    };
const $bcb2c318ace1641e$var$setProvider = (provider)=>({ getState: getState, setState: setState })=>setState({
            ...getState(),
            provider: provider
        });
const $bcb2c318ace1641e$var$sendNodeSelected = ({ nodeId: nodeId })=>({ getState: getState })=>{
        if (nodeId == null) return;
        const { provider: provider, participants: participants } = getState();
        if (participants.length <= 1) return;
        if (provider) provider.sendMessage({
            type: 'telepointer',
            sessionId: provider.sessionId,
            selection: {
                type: 'nodeSelection',
                anchor: JSON.stringify({
                    nodeId: nodeId
                })
            }
        });
    };
const $bcb2c318ace1641e$var$sendClearNodeSelection = ({ nodeId: nodeId, dropParams: dropParams })=>({ getState: getState })=>{
        if (nodeId == null) return;
        const { provider: provider, participants: participants } = getState();
        if (participants.length <= 1) return;
        if (provider) provider.sendMessage({
            type: 'telepointer',
            sessionId: provider.sessionId,
            selection: {
                type: 'nodeSelection',
                head: JSON.stringify({
                    nodeId: nodeId,
                    dropParams: dropParams
                })
            }
        });
    };
const $bcb2c318ace1641e$var$setNodeSelection = ({ nodeId: nodeId, sessionId: sessionId, user: user })=>({ setState: setState, getState: getState })=>{
        const newSelection = {
            nodeId: nodeId,
            user: user,
            sessionId: sessionId
        };
        const state = getState();
        const dedupCurrentSelection = state.nodeSelection[nodeId] && state.nodeSelection[nodeId].filter((selection)=>selection.user.userId !== user.userId);
        const nodeSelection = dedupCurrentSelection ? [
            ...dedupCurrentSelection,
            newSelection
        ] : [
            newSelection
        ];
        // deduplicate selected nodes from this user, because each user can have only one selected node on the page
        const dedupOtherSelections = {};
        Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
            // keep selections from all other users
            const selections = state.nodeSelection[nodeIdKey];
            if (selections.length > 0) {
                const filteredSelections = selections.filter((selection)=>selection.user.userId !== user.userId);
                if (filteredSelections.length === 0) return;
                dedupOtherSelections[nodeIdKey] = filteredSelections;
            }
        });
        setState({
            ...state,
            nodeSelection: {
                ...dedupOtherSelections,
                [nodeId]: nodeSelection
            }
        });
    };
const $bcb2c318ace1641e$var$clearNodeSelection = ({ nodeId: nodeId, dropParams: dropParams, userId: userId })=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const newNodeSelection = {};
        Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
            if (nodeIdKey !== nodeId) newNodeSelection[nodeIdKey] = state.nodeSelection[nodeIdKey];
        });
        setState({
            ...state,
            nodeSelection: newNodeSelection,
            dragAnimation: dropParams && userId != null ? [
                ...state.dragAnimation,
                {
                    ...dropParams,
                    userId: userId
                }
            ] : state.dragAnimation
        });
    };
const $bcb2c318ace1641e$var$stopDragAnimation = ({ sourceNodeId: sourceNodeId })=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            dragAnimation: state.dragAnimation.filter((animation)=>String(animation.sourceNodeId) !== String(sourceNodeId))
        });
    };
const $bcb2c318ace1641e$var$actions = {
    setProvider: $bcb2c318ace1641e$var$setProvider,
    participantsLeft: $bcb2c318ace1641e$var$participantsLeft,
    participantsJoined: $bcb2c318ace1641e$var$participantsJoined,
    updateUserInParticipants: $bcb2c318ace1641e$var$updateUserInParticipants,
    sendNodeSelected: $bcb2c318ace1641e$var$sendNodeSelected,
    sendClearNodeSelection: $bcb2c318ace1641e$var$sendClearNodeSelection,
    setNodeSelection: $bcb2c318ace1641e$var$setNodeSelection,
    clearNodeSelection: $bcb2c318ace1641e$var$clearNodeSelection,
    stopDragAnimation: $bcb2c318ace1641e$var$stopDragAnimation
};
const $bcb2c318ace1641e$var$Store = (0, $a61MH.createStore)({
    initialState: {
        provider: null,
        participants: [],
        nodeSelection: {},
        dragAnimation: []
    },
    actions: $bcb2c318ace1641e$var$actions,
    name: 'JSWCollabStore'
});
const $bcb2c318ace1641e$export$4159ae80cfa2156 = (0, $ggKAj.createHook)($bcb2c318ace1641e$var$Store);

});
const $356df1c77d24a703$export$3debf01bbfa135e5 = 80;


parcelRegister("8Ui86", function(module, exports) {

$parcel$export(module.exports, "SearchField", () => $02c3e5e2cebd6ff7$export$b94867ecbd698f21);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $gtzuR = parcelRequire("gtzuR");

var $bFzGY = parcelRequire("bFzGY");

var $cf2Y4 = parcelRequire("cf2Y4");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $babBw = parcelRequire("babBw");

var $dAreR = parcelRequire("dAreR");
// This class prevents filled in input field causing confirmation dialog
// when user wants to navigate away. This functionality is coming from Jira monolith.
const $02c3e5e2cebd6ff7$var$className = 'ajs-dirty-warning-exempt';
const $02c3e5e2cebd6ff7$var$SearchFieldUnmemoized = ({ onEnter: onEnter, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', inputRef: inputRef, value: externalValue, autoFocus: autoFocus = false, isCompact: isCompact = false, isDisabled: isDisabled = false, shouldFitContainerWidth: shouldFitContainerWidth = false, isAutocompleteDisabled: isAutocompleteDisabled = false, placeholderAlwaysVisible: placeholderAlwaysVisible = false, searchIconVisible: searchIconVisible = true, isAlwaysExpanded: isAlwaysExpanded = false, increasedWidth: increasedWidth = false, maxLength: maxLength, describedById: describedById = '', ariaLabelText: ariaLabelText, id: id, renderCustomSearchField: renderCustomSearchField, searchIconPrimaryColor: searchIconPrimaryColor, testId: testId, inputProps: inputProps = {}, isResponsive: isResponsive = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    const [value, setValue] = (0, $eUqFw.useState)(externalValue || '');
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const textInput = (0, $eUqFw.useRef)(null);
    const previousValueRef = (0, $eUqFw.useRef)();
    const previousValue = previousValueRef.current;
    if (externalValue !== previousValue && externalValue !== value) // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'SetStateAction<string>'.
    setValue(externalValue);
    previousValueRef.current = externalValue;
    const handleOnFocus = (0, $eUqFw.useCallback)((event)=>{
        setIsFocused(true);
        onFocus && onFocus(event);
    }, [
        onFocus
    ]);
    const handleOnBlur = (0, $eUqFw.useCallback)((event)=>{
        onBlur && onBlur(event);
        setIsFocused(false);
    }, [
        onBlur
    ]);
    const handleOnChange = (0, $eUqFw.useCallback)(({ currentTarget: currentTarget })=>{
        const { value: val } = currentTarget;
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        setValue(val);
        onChange(val, analyticsEvent);
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        if (event.key === 'Escape') {
            setValue('');
            onChange('', analyticsEvent);
        }
        if (onEnter && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('enter')) {
            event.preventDefault();
            onEnter(event.currentTarget && event.currentTarget.value);
        }
    }, [
        createAnalyticsEvent,
        onChange,
        onEnter
    ]);
    const handleOnClear = (0, $eUqFw.useCallback)(()=>{
        if (value !== '') {
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            setValue('');
            onChange('', analyticsEvent);
        }
        if (inputRef && inputRef.current !== null) inputRef.current.blur();
        if (textInput.current !== null) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        textInput.current.blur();
    }, [
        createAnalyticsEvent,
        inputRef,
        onChange,
        value
    ]);
    const isExpanded = isFocused || value !== '' || isAlwaysExpanded;
    const textFieldProps = {
        ...inputProps,
        'aria-label': ariaLabelText || placeholder,
        'aria-describedby': describedById,
        type: 'text',
        // @ts-expect-error - TS2322 - Type '{ 'aria-label': string; 'aria-describedby': string; type: string; 'data-test-id': string; name: string; className: string; placeholder: string; onFocus: (event: React.SyntheticEvent<HTMLInputElement, Event>) => void; ... 9 more ...; maxLength: number | undefined; }' is not assignable to type 'TextfieldProps'.
        'data-test-id': 'searchfield',
        name: 'search',
        className: $02c3e5e2cebd6ff7$var$className,
        placeholder: placeholder,
        onFocus: handleOnFocus,
        onBlur: handleOnBlur,
        width: '120px',
        onChange: handleOnChange,
        onKeyDown: handleKeyDown,
        ref: inputRef || textInput,
        isCompact: isCompact,
        autoFocus: autoFocus,
        autoComplete: isAutocompleteDisabled ? 'off' : 'on',
        value: value,
        maxLength: maxLength,
        isDisabled: isDisabled
    };
    const searchIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dAreR.SearchFieldIcon), {
        onClear: handleOnClear,
        hasValue: value !== '',
        clearIconLabel: formatMessage((0, $babBw.messages).clear),
        searchIconVisible: searchIconVisible,
        primaryColor: searchIconPrimaryColor,
        onlyIconSpacing: isResponsive && !isExpanded
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02c3e5e2cebd6ff7$var$Container, {
        shouldFitContainerWidth: shouldFitContainerWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02c3e5e2cebd6ff7$var$InputWrapper, {
        isExpanded: isExpanded,
        shouldFitContainerWidth: shouldFitContainerWidth,
        increasedWidth: increasedWidth,
        maxWidth: increasedWidth ? 328 : 184,
        placeholderAlwaysVisible: placeholderAlwaysVisible,
        isResponsive: isResponsive
    }, renderCustomSearchField !== undefined ? renderCustomSearchField({
        textFieldProps: textFieldProps,
        searchIcon: searchIcon
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        ...textFieldProps,
        testId: testId,
        elemAfterInput: searchIcon,
        ...id !== undefined ? {
            id: id
        } : {}
    })));
};
$02c3e5e2cebd6ff7$var$SearchFieldUnmemoized.displayName = 'Search';
$02c3e5e2cebd6ff7$var$SearchFieldUnmemoized.whyDidYouRender = true;
const $02c3e5e2cebd6ff7$export$b94867ecbd698f21 = /*#__PURE__*/ (0, $eUqFw.memo)($02c3e5e2cebd6ff7$var$SearchFieldUnmemoized);
$02c3e5e2cebd6ff7$export$b94867ecbd698f21.displayName = 'Search'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02c3e5e2cebd6ff7$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.shouldFitContainerWidth && "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $02c3e5e2cebd6ff7$var$InputWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { placeholderAlwaysVisible: placeholderAlwaysVisible, isResponsive: isResponsive, maxWidth: maxWidth, isExpanded: isExpanded, shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $9t7rW.default)(__cmplp.maxWidth, "px"),
            "--_47juog": (0, $9t7rW.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '30px'),
            "--_h8l327": (0, $9t7rW.default)(// Remove eslint-disable-next-line when nin-jql-builder-text-search-input-responsive-height-fix_t1y03 cleanup
            // Leave isExpanded ? 'auto' : '32px' when nin-jql-builder-text-search-input-responsive-height-fix_t1y03 is removed
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            !(0, $1ybV0.ff)('nin-jql-builder-text-search-input-responsive-height-fix_t1y03') || __cmplp.isExpanded ? 'auto' : '32px'),
            "--_jy5l88": (0, $9t7rW.default)(__cmplp.isExpanded ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-0, 0px)"),
            "--_1skyi4s": (0, $9t7rW.default)(__cmplp.isExpanded ? 'auto' : 0),
            "--_1qenfck": (0, $9t7rW.default)(__cmplp.isExpanded ? 1 : 0),
            "--_1b7586u": (0, $9t7rW.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '120px'),
            "--_1b72lxu": (0, $9t7rW.default)(__cmplp.shouldFitContainerWidth ? '100%' : `${__cmplp.isExpanded ? __cmplp.maxWidth : 120}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _v564zpk5 _166qglyw _101ad2bq _i2ybkb7n",
            __cmplp.placeholderAlwaysVisible ? "_lav0kb7n" : "_lav0idpf",
            __cmplp.isResponsive ? "_1bsb1ayu _1s4pflvl _1kne9uv3 _odci1sf5 _wngi16hp _5xde1wic _1hr27bcq" : "_1bsb1di6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("babBw", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1db92d5b4c5e946f$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $1db92d5b4c5e946f$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    clear: {
        "id": "searchfield.clear",
        "defaultMessage": "Clear"
    }
});

});

parcelRegister("dAreR", function(module, exports) {

$parcel$export(module.exports, "SearchFieldIcon", () => $81537fc79b34b1c4$export$8a82bff895521bd9);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $jWuk1 = parcelRequire("jWuk1");

var $dsroq = parcelRequire("dsroq");

var $b5IAe = parcelRequire("b5IAe");
var $4Ywu9 = parcelRequire("4Ywu9");
var $1ZAYh = parcelRequire("1ZAYh");
const $81537fc79b34b1c4$export$8a82bff895521bd9 = ({ onClear: onClear, hasValue: hasValue, searchIconVisible: searchIconVisible, clearIconLabel: clearIconLabel, primaryColor: primaryColor, onlyIconSpacing: onlyIconSpacing = false })=>{
    const akSearchIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dsroq))), {
        size: "small",
        label: "",
        primaryColor: primaryColor
    });
    const searchIcon = searchIconVisible ? akSearchIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $81537fc79b34b1c4$var$wrapperStyles,
            onlyIconSpacing && $81537fc79b34b1c4$var$spacingStyles
        ]
    }, hasValue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        spacing: "none",
        "data-test-id": "searchfield.ui.searchfield-icon.clear-button",
        onClick: onClear,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
            size: "small",
            label: clearIconLabel,
            primaryColor: primaryColor
        })
    }) : searchIcon);
};
const $81537fc79b34b1c4$var$wrapperStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.accent.gray',
    marginTop: 'space.0',
    marginRight: 'space.100',
    marginBottom: 'space.0',
    marginLeft: 'space.0',
    height: '16px',
    display: 'flex'
});
const $81537fc79b34b1c4$var$spacingStyles = (0, $1ZAYh.xcss)({
    marginRight: 'space.075',
    [(0, $4Ywu9.media).above.md]: {
        marginRight: 'space.100'
    }
});

});


parcelRegister("1Ksr6", function(module, exports) {

$parcel$export(module.exports, "useShortcutAnalytics", () => $6f08a6f9a81f758c$export$cd482f0b72849b2c);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $jMP2a = parcelRequire("jMP2a");
const $6f08a6f9a81f758c$export$56c266726b07692d = (createAnalyticsEvent, { id: id, key: key, attributes: attributes }, shortcutSource)=>{
    const attrs = {
        ...attributes,
        key: key,
        shortcutSource: shortcutSource,
        nextGenProject: true
    };
    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
        action: 'pressed',
        actionSubject: 'keyboardShortcut'
    }), id, attrs);
};
const $6f08a6f9a81f758c$export$cd482f0b72849b2c = (shortcutSource)=>{
    // Will fix on FF cleanup
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireAnalytics = (0, $eUqFw.useCallback)((payload)=>{
        $6f08a6f9a81f758c$export$56c266726b07692d(createAnalyticsEvent, payload, shortcutSource);
    }, [
        createAnalyticsEvent,
        shortcutSource
    ]);
    return fireAnalytics;
};

});

parcelRegister("8gxRf", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5960339ce2b9bc1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $fee69 = parcelRequire("fee69");

var $iH6c1 = parcelRequire("iH6c1");

var $JRB5w = parcelRequire("JRB5w");

var $gGtKh = parcelRequire("gGtKh");

var $jMP2a = parcelRequire("jMP2a");
var $d6f6c = parcelRequire("d6f6c");
var $bFzGY = parcelRequire("bFzGY");

var $15ZJO = parcelRequire("15ZJO");

var $J3y23 = parcelRequire("J3y23");
class $b5960339ce2b9bc1$export$876b3e4acf4df22c extends (0, $eUqFw.Component) {
    static{
        this.getDerivedStateFromError = (error)=>({
                error: error,
                isRelayValidationError: (0, $J3y23.isRelayValidationError)(error)
            });
    }
    static getDerivedStateFromProps({ customFiltersQueryRef: customFiltersQueryRef }, state) {
        if (state.error && !state.aggErrors && customFiltersQueryRef) {
            const capturedGQLErrorsInfo = (0, $15ZJO.stopCaptureGraphQlErrors)(customFiltersQueryRef.fetchKey.toString());
            const validGQLErrorsInfo = capturedGQLErrorsInfo.find((err)=>err.meta.operationName === customFiltersQueryRef.name);
            if (validGQLErrorsInfo?.errors.length) return {
                ...state,
                aggErrors: validGQLErrorsInfo.errors,
                aggErrorsMeta: validGQLErrorsInfo.meta
            };
        }
        return null;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null,
            aggErrors: null,
            aggErrorsMeta: null,
            isRelayValidationError: false
        };
    }
    getCommonErrorAttributes(error) {
        return {
            task: 'loadCustomFilters',
            screenName: this.props.screenName,
            isNetworkError: false,
            isRelayValidationError: this.state.isRelayValidationError,
            hash: (0, $iH6c1.getErrorHash)(error) ?? '',
            errorMessage: error.message,
            stack: error.stack
        };
    }
    render() {
        const { error: error, aggErrors: aggErrors, aggErrorsMeta: aggErrorsMeta, isRelayValidationError: isRelayValidationError } = this.state;
        const { children: children } = this.props;
        if (!error) return children;
        if (aggErrors?.length) {
            const aggError = new (0, $J3y23.AGGErrors)(aggErrors, aggErrorsMeta?.requestId);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireOperationalAnalytics), {
                eventName: "ui taskFail",
                attributes: {
                    traceId: aggError.traceId,
                    statusCode: aggError.statusCode,
                    ...this.getCommonErrorAttributes(aggError)
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorFlagRenderer), {
                id: "custom-filter-dropdown",
                error: aggError
            }));
        }
        if (isRelayValidationError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireOperationalAnalytics), {
            eventName: "ui taskFail",
            attributes: {
                ...this.getCommonErrorAttributes(error)
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorFlagRenderer), {
            id: "custom-filter-dropdown",
            error: error
        }));
        // If this isn't an AGG or Relay error, let the upper error boundary handle it
        throw error;
    }
}
const $b5960339ce2b9bc1$var$CustomFilterBoundary = (props)=>{
    const { children: children, screenName: screenName } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onError = (_, error)=>{
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskFail', {
            screenName: screenName,
            task: 'loadCustomFilters',
            isNetworkError: (0, $JRB5w.isClientFetchError)(error),
            hash: (0, $iH6c1.getErrorHash)(error) ?? '',
            errorMessage: error.message
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "custom-filter-dropdown",
        packageName: "software-filters",
        teamName: "a4t-tanuki",
        fallback: "flag",
        extraEventData: {
            screenName: screenName
        },
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b5960339ce2b9bc1$export$876b3e4acf4df22c, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "custom-filter-boundary",
        fallback: null
    }, children)));
};
var $b5960339ce2b9bc1$export$2e2bcd8739ae039 = $b5960339ce2b9bc1$var$CustomFilterBoundary;

});
parcelRegister("J3y23", function(module, exports) {

$parcel$export(module.exports, "isRelayValidationError", () => $91e455f3f7b68213$export$f450dbe0abffdade);
$parcel$export(module.exports, "AGGErrors", () => $91e455f3f7b68213$export$60d8267243755b9c);

var $lgAsZ = parcelRequire("lgAsZ");
const $91e455f3f7b68213$export$321834dc4377cb7 = 'Relay: Missing @required value at path';
const $91e455f3f7b68213$export$f450dbe0abffdade = (error)=>error.message.includes($91e455f3f7b68213$export$321834dc4377cb7);
class $91e455f3f7b68213$export$60d8267243755b9c extends (0, $lgAsZ.default) {
    constructor(errors, traceId){
        // this is used to generate same 'hash' for error flag and sla event attribute
        super(errors[0].message, {
            cause: errors[0]
        });
        this.name = 'AGGError';
        this.graphQLErrors = errors;
        this.traceId = traceId;
        this.statusCode = errors[0].extensions?.statusCode ?? undefined;
    }
}

});


parcelRegister("8D53g", function(module, exports) {

$parcel$export(module.exports, "default", () => $4937c963117aaed6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $cmc0m = parcelRequire("cmc0m");
const $4937c963117aaed6$var$HijackBrowserDefaultSearch = ({ onFocusSearch: onFocusSearch, isAnyModalOpen: isAnyModalOpen = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onGlobalSearch = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7031 - Binding element 'event' implicitly has an 'any' type.
    ({ event: event })=>{
        // Do not hijack browser default search when any modal is open
        if (isAnyModalOpen) return;
        // Hijacks default browser search and directs user to search in filter bar
        event.preventDefault();
        onFocusSearch();
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'hijackBrowserDefaultSearch triggered');
    }, [
        createAnalyticsEvent,
        isAnyModalOpen,
        onFocusSearch
    ]);
    (0, $cmc0m.useGlobalSearch)(onGlobalSearch);
    return null;
};
var $4937c963117aaed6$export$2e2bcd8739ae039 = $4937c963117aaed6$var$HijackBrowserDefaultSearch;

});

parcelRegister("hREiq", function(module, exports) {

$parcel$export(module.exports, "default", () => $888e8c9db9ec5c9b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $g9Oms = parcelRequire("g9Oms");
var $8Wt6T = parcelRequire("8Wt6T");

var $b5IAe = parcelRequire("b5IAe");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $cmc0m = parcelRequire("cmc0m");

var $kQqwL = parcelRequire("kQqwL");

var $aX4h4 = parcelRequire("aX4h4");
const $888e8c9db9ec5c9b$var$SearchFilterChangeboarding = ({ children: children, hijackBrowserDefaultSearch: hijackBrowserDefaultSearch = false, screenName: screenName, isCompanyManaged: isCompanyManaged = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isVisible, setIsVisible] = (0, $eUqFw.useState)(false);
    const hasShown = (0, $eUqFw.useRef)(false);
    const onGlobalSearch = (0, $eUqFw.useCallback)(()=>{
        if (!hasShown.current) {
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'searchFilterChangeboarding shown', {
                isHijackBrowserDefaultSearchEnabled: hijackBrowserDefaultSearch
            });
            setIsVisible(true);
            hasShown.current = true;
            if (screenName === 'backlog' || screenName === 'board' || screenName === 'roadmap') (0, $kQqwL.setUserSeenSearchFieldChangeboarding)(screenName);
        }
    }, [
        createAnalyticsEvent,
        hijackBrowserDefaultSearch,
        screenName
    ]);
    const onDismiss = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'searchFilterChangeboarding dismissed', {
            isHijackBrowserDefaultSearchEnabled: hijackBrowserDefaultSearch
        });
        setIsVisible(false);
    }, [
        createAnalyticsEvent,
        hijackBrowserDefaultSearch
    ]);
    const actions = (0, $eUqFw.useMemo)(()=>[
            {
                text: formatMessage((0, $aX4h4.default).changeboardingConfirmButton),
                onClick: onDismiss
            }
        ], [
        formatMessage,
        onDismiss
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const getUserSeenSearchFieldChangeboarding = async ()=>{
            if (screenName === 'backlog' || screenName === 'board' || screenName === 'roadmap') {
                const seen = await (0, $kQqwL.hasUserSeenSearchFieldChangeboarding)(createAnalyticsEvent({}), screenName);
                if (seen) hasShown.current = true;
            }
        };
        getUserSeenSearchFieldChangeboarding();
    }, [
        createAnalyticsEvent,
        hijackBrowserDefaultSearch,
        screenName
    ]);
    const changeBoardingMessage = ()=>{
        const ctrlKey = (0, $cmc0m.isMacOS)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($888e8c9db9ec5c9b$var$Code, null, "Cmnd") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($888e8c9db9ec5c9b$var$Code, null, "Ctrl");
        return hijackBrowserDefaultSearch ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $aX4h4.default).hijackingDefaultSearchMessage,
            values: {
                key: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($888e8c9db9ec5c9b$var$Code, null, "F"),
                ctrlKey: ctrlKey
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $aX4h4.default).changeboardingMessage,
            values: {
                key: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($888e8c9db9ec5c9b$var$Code, null, "f")
            }
        });
    };
    let spotlightCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g9Oms.default), {
        actions: actions,
        width: 300
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, changeBoardingMessage()));
    if (isCompanyManaged && (0, $1ybV0.ff)('jsw-uif-ctrl-f5-changeboarding_1ik10')) spotlightCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g9Oms.default), {
        heading: formatMessage((0, $aX4h4.default).changeboardingUifMessageHeading),
        actions: actions,
        width: 300
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, formatMessage((0, $aX4h4.default).changeboardingUifMessage)));
    (0, $cmc0m.useGlobalSearch)(onGlobalSearch);
    if (isVisible) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($888e8c9db9ec5c9b$var$ChangeboardingContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($888e8c9db9ec5c9b$var$Pulse, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($888e8c9db9ec5c9b$var$SpolightCardContainer, null, spotlightCard));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};
var $888e8c9db9ec5c9b$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $888e8c9db9ec5c9b$var$SearchFilterChangeboarding;
const $888e8c9db9ec5c9b$var$Pulse = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $8Wt6T.Pulse), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1pbyowjs",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $888e8c9db9ec5c9b$var$ChangeboardingContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});
const $888e8c9db9ec5c9b$var$spotlightAnimation = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $888e8c9db9ec5c9b$var$SpolightCardContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1pbyowjs _19pku2gc _tzy4idpf _y44v18t4 _o5724jg8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $888e8c9db9ec5c9b$var$Code = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "code", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c8qk37 _11q7exu1 _syaz1fxt _2rko1l7b _1e0c1nu9 _1reo1wug _o5721jtm _1yt4u49m",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kQqwL", function(module, exports) {

$parcel$export(module.exports, "hasUserSeenSearchFieldChangeboarding", () => $e4f443dd945506e2$export$b5010e3edd313ae1);
$parcel$export(module.exports, "setUserSeenSearchFieldChangeboarding", () => $e4f443dd945506e2$export$fba51361338c8f18);

var $jBAQz = parcelRequire("jBAQz");

var $jMP2a = parcelRequire("jMP2a");
const $e4f443dd945506e2$var$changeboardingFlags = {
    board: 'jsw.filters.board.search-field-changeboarding.shown',
    backlog: 'jsw.filters.backlog.search-field-changeboarding.shown'
};
const $e4f443dd945506e2$var$CHANGEBOARDING_TTL_SEEN = 31536000000; // ~ 365 days
const $e4f443dd945506e2$export$b5010e3edd313ae1 = (analyticsEvent, screenName)=>(0, $jBAQz.getFlags)({
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly board: "jsw.filters.board.search-field-changeboarding.shown"; readonly backlog: "jsw.filters.backlog.search-field-changeboarding.shown"; }'.
        [$e4f443dd945506e2$var$changeboardingFlags[screenName]]: {}
    })// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly board: "jsw.filters.board.search-field-changeboarding.shown"; readonly backlog: "jsw.filters.backlog.search-field-changeboarding.shown"; }'.
    .then((res)=>res[$e4f443dd945506e2$var$changeboardingFlags[screenName]].status).catch(()=>{
        (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'searchFilterChangeboarding checkSeenFailed');
        return false;
    });
const $e4f443dd945506e2$export$fba51361338c8f18 = (screenName)=>(0, $jBAQz.setFlag)($e4f443dd945506e2$var$changeboardingFlags[screenName], $e4f443dd945506e2$var$CHANGEBOARDING_TTL_SEEN);

});
parcelRegister("jBAQz", function(module, exports) {

$parcel$export(module.exports, "getFlags", () => $1749c1c9732fa517$export$d5815430bcc75df0);
$parcel$export(module.exports, "setFlag", () => $1749c1c9732fa517$export$5e165df1e30a1331);

var $czx3b = parcelRequire("czx3b");

var $hwbh0 = parcelRequire("hwbh0");

var $e91YZ = parcelRequire("e91YZ");

var $1Cw1V = parcelRequire("1Cw1V");

var $gYp0l = parcelRequire("gYp0l");
const $1749c1c9732fa517$export$442e3330dfabd1f5 = 3600000; // 1 hour
const $1749c1c9732fa517$export$4d45fa66d41a8ca9 = 2592000000; // ~1 month
const $1749c1c9732fa517$export$d5815430bcc75df0 = async (request)=>{
    const { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const flagKeys = Object.keys(request);
    const retrieveFlagKeysLookup = (0, (/*@__PURE__*/$parcel$interopDefault($hwbh0)))(flagKeys);
    if (!atlassianAccountId || isAnonymous) return (0, (/*@__PURE__*/$parcel$interopDefault($czx3b)))(retrieveFlagKeysLookup, ()=>({
            status: true,
            lastSeenDate: null
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const flags = {};
    if (0, $gYp0l.default) flagKeys.forEach((flagKey)=>{
        // @ts-expect-error - Object is possibly 'null'.
        const value = (0, $gYp0l.default).get(flagKey);
        if (value) {
            delete retrieveFlagKeysLookup[flagKey];
            flags[flagKey] = value;
        }
    });
    const retrieveFlagKeys = Object.keys(retrieveFlagKeysLookup);
    if (retrieveFlagKeys.length > 0) Object.assign(flags, await (0, $1Cw1V.getFlags)(atlassianAccountId, retrieveFlagKeys));
    if (0, $gYp0l.default) {
        const now = Date.now();
        retrieveFlagKeys.forEach((flagKey)=>{
            // Not sure whats going wrong here - but i assume `apiGetFlags` may not always return all `retrieveFalgKeys`
            // and so `flags[flagKey]` can be undefined - so we have to guard against it
            if (!flags[flagKey]) return;
            const { status: status } = flags[flagKey];
            const ttlNotSeen = request[flagKey].ttlNotSeen || $1749c1c9732fa517$export$442e3330dfabd1f5;
            const ttlSeen = request[flagKey].ttlSeen || $1749c1c9732fa517$export$4d45fa66d41a8ca9;
            // @ts-expect-error - TS2531: Object is possibly 'null'.
            (0, $gYp0l.default).set(flagKey, flags[flagKey], now + (status ? ttlSeen : ttlNotSeen));
        });
    }
    return flags;
};
const $1749c1c9732fa517$export$5e165df1e30a1331 = async (flagKey, ttl = $1749c1c9732fa517$export$4d45fa66d41a8ca9)=>{
    const { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    if (!atlassianAccountId || isAnonymous) return;
    if (0, $gYp0l.default) {
        const value = (0, $gYp0l.default).get(flagKey);
        if (value && value.status) return;
        const now = new Date();
        (0, $gYp0l.default).set(flagKey, {
            status: true,
            lastSeenDate: now.toISOString()
        }, now.getTime() + ttl);
    }
    await (0, $1Cw1V.setFlag)(atlassianAccountId, flagKey);
};

});
parcelRegister("1Cw1V", function(module, exports) {

$parcel$export(module.exports, "setFlag", () => $27a69f89da9f41d0$export$5e165df1e30a1331);
$parcel$export(module.exports, "getFlags", () => $27a69f89da9f41d0$export$d5815430bcc75df0);

var $czx3b = parcelRequire("czx3b");

var $7EhAs = parcelRequire("7EhAs");
const $27a69f89da9f41d0$export$c1f083639d344e75 = 'https://have-i-seen-it.us-east-1.prod.public.atl-paas.net';
const $27a69f89da9f41d0$export$5e165df1e30a1331 = (userKey, flagKey)=>{
    const data = {
        userKey: userKey,
        flagKey: flagKey
    };
    return fetch(`${$27a69f89da9f41d0$export$c1f083639d344e75}/flag`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }).then((response)=>{
        if (!response.ok) throw new (0, $7EhAs.default)(response.status, response.statusText);
        return undefined;
    });
};
const $27a69f89da9f41d0$var$convertToDates = (response)=>(0, (/*@__PURE__*/$parcel$interopDefault($czx3b)))(response, ({ status: status, lastSeenDate: lastSeenDate })=>({
            status: status,
            lastSeenDate: lastSeenDate ? new Date(lastSeenDate) : null
        }));
const $27a69f89da9f41d0$export$d5815430bcc75df0 = (userKey, flagKeys)=>{
    const params = new URLSearchParams();
    flagKeys.forEach((flagKey)=>params.append('flagKey', flagKey));
    params.append('userKey', userKey);
    return fetch(`${$27a69f89da9f41d0$export$c1f083639d344e75}/flags?${params.toString()}`).then((response)=>{
        if (!response.ok) throw new (0, $7EhAs.default)(response.status, response.statusText);
        return response.json();
    }).then((response)=>$27a69f89da9f41d0$var$convertToDates(response));
};

});

parcelRegister("gYp0l", function(module, exports) {

$parcel$export(module.exports, "default", () => $16304c7221461599$export$2e2bcd8739ae039);

var $89bO2 = parcelRequire("89bO2");

var $e91YZ = parcelRequire("e91YZ");

var $gUUjF = parcelRequire("gUUjF");
/**
 * Return an ExpirableStorage to be used with the "have i seen it" service.
 *
 * If the user is anonymous, return null.
 */ const $16304c7221461599$var$createStorage = ()=>{
    let storage = null;
    try {
        let context;
        try {
            context = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            return storage;
        }
        const { atlassianAccountId: atlassianAccountId } = context;
        if (atlassianAccountId) storage = (0, $89bO2.createSessionExpirableStorageProvider)(`have-i-seen-it-${atlassianAccountId.replace(/:/g, '_')}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('have-i-seen-it.storage', 'Failed to initialize storage.');
    }
    return storage;
};
var $16304c7221461599$export$2e2bcd8739ae039 = $16304c7221461599$var$createStorage();

});



parcelRegister("aX4h4", function(module, exports) {

$parcel$export(module.exports, "default", () => $befdb0d42b23f1e0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $befdb0d42b23f1e0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    changeboardingMessage: {
        "id": "software-filters.search-filter-changeboarding.changeboarding-message",
        "defaultMessage": "For quick access to search, use {key} on your keyboard anywhere in Jira. It takes you directly to the search field."
    },
    changeboardingUifMessageHeading: {
        "id": "software-filters.search-filter-changeboarding.changeboarding-uif-message-heading",
        "defaultMessage": "Search for an issue"
    },
    changeboardingUifMessage: {
        "id": "software-filters.search-filter-changeboarding.changeboarding-uif-message",
        "defaultMessage": "The backlog loads issues as you scroll to help increase performance. If you struggle to find results using a keyboard shortcut, try entering the keyword here instead."
    },
    hijackingDefaultSearchMessage: {
        "id": "software-filters.search-filter-changeboarding.hijacking-default-search-message",
        "defaultMessage": "{ ctrlKey } + { key } takes you directly to the search field, just like keyboard shortcut { key }. Both shortcuts give you quick access to our optimized search."
    },
    changeboardingConfirmButton: {
        "id": "software-filters.search-filter-changeboarding.changeboarding-confirm-button",
        "defaultMessage": "OK"
    }
});

});


parcelRegister("iesgE", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd69c6cadd163f00$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");
const $cd69c6cadd163f00$var$VersionFilterRelayBoundary = ({ fallback: fallback = null, children: children, screenName: screenName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "version-filter-relay-dropdown",
        packageName: "software-filters",
        teamName: "a4t-tanuki",
        fallback: "flag",
        extraEventData: {
            screenName: screenName
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "version-filter-relay-boundary",
        fallback: fallback
    }, children));
var $cd69c6cadd163f00$export$2e2bcd8739ae039 = $cd69c6cadd163f00$var$VersionFilterRelayBoundary;

});

parcelRegister("gp3Fg", function(module, exports) {

$parcel$export(module.exports, "default", () => $58e8b1a5a510d996$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $58e8b1a5a510d996$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    textFilter: {
        "id": "software-filters.stateless.text-filter",
        "defaultMessage": "Filter issues"
    },
    screenReaderInstruction: {
        "id": "software-filters.stateless.screen-reader-instruction",
        "defaultMessage": "Results will be filtered below as you type to search or apply filters."
    },
    screenReaderInstructionForFilters: {
        "id": "software-filters.stateless.screen-reader-instruction-for-filters",
        "defaultMessage": "Content below has been updated"
    },
    searchCurrentPage: {
        "id": "software-filters.stateless.search-current-page",
        "defaultMessage": "Search on current page"
    },
    goToSection: {
        "id": "software-filters.stateless.go-to-section",
        "defaultMessage": "Go to"
    },
    unassignedAssigneeDisplayName: {
        "id": "software-filters.stateless.unassigned-assignee-display-name",
        "defaultMessage": "Unassigned"
    },
    unassignedVersionLabel: {
        "id": "software-filters.stateless.unassigned-version-label",
        "defaultMessage": "Issues without version"
    },
    unassignedLabelLabel: {
        "id": "software-filters.stateless.unassigned-label-label",
        "defaultMessage": "Issues without label"
    },
    unassignedComponentLabel: {
        "id": "software-filters.stateless.unassigned-component-label",
        "defaultMessage": "Issues without component"
    }
});

});

parcelRegister("84m3I", function(module, exports) {

$parcel$export(module.exports, "getManageCustomFiltersUrl", () => $71ff8d7d00a86ae0$export$84a62bf03b005a81);
$parcel$export(module.exports, "getAssigneesWithPresence", () => $71ff8d7d00a86ae0$export$cd7b2f0d4c426239);

var $1ybV0 = parcelRequire("1ybV0");

const $71ff8d7d00a86ae0$export$84a62bf03b005a81 = (projectKey, boardId, isCompanyManaged, isUserBoard, isJSMBoard, // For testing purposes
pathname = window.location.pathname)=>{
    if ((0, $1ybV0.ff)('jsm-fix-board-quick-filter-link-bug_xp1ia')) {
        if (isJSMBoard) return `/jira/servicedesk/projects/${projectKey}/boards/${boardId}?config=quickFilters`;
        if (isCompanyManaged) {
            if (isUserBoard) return `${pathname}?config=quickFilters`;
            return `/jira/software/c/projects/${projectKey}/boards/${boardId}${pathname.endsWith('backlog') ? '/backlog' : ''}?config=quickFilters`;
        }
        return `/jira/software/projects/${projectKey}/settings/boards/${boardId}/custom-filters`;
    }
    return isCompanyManaged ? `${isUserBoard ? pathname : `/jira/software/c/projects/${projectKey}/boards/${boardId}${pathname.endsWith('backlog') ? '/backlog' : ''}`}?config=quickFilters` : `/jira/software/projects/${projectKey}/settings/boards/${boardId}/custom-filters`;
};
const $71ff8d7d00a86ae0$export$cd7b2f0d4c426239 = (allAssignees, participants)=>allAssignees.map((assignee)=>{
        if (assignee.id === (0, $44677eb502cfd308$export$12e572fd459c10dc)) return assignee;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return {
            ...assignee,
            presence: participants.some((participant)=>participant.clientId === assignee.id) ? (0, $44677eb502cfd308$export$7a105aa475396c65) : (0, $44677eb502cfd308$export$c9408e3fb31ddc71)
        };
    }).sort((a, b)=>{
        // sort by presence & keep current user as the first
        if (a.id === allAssignees[0].id) return -1;
        if (b.id === allAssignees[0].id) return 1;
        if (a.presence === (0, $44677eb502cfd308$export$7a105aa475396c65)) return -1;
        if (b.presence === (0, $44677eb502cfd308$export$7a105aa475396c65)) return 1;
        return 0;
    });

});


parcelRegister("jgUYF", function(module, exports) {

$parcel$export(module.exports, "getNormalizedFilters", () => $faf5aa6f742a1f2f$export$459be3406d78c3a5);
$parcel$export(module.exports, "onFilterChangeStartInteraction", () => $faf5aa6f742a1f2f$export$568db3ec08ca631b);

var $6HC1D = parcelRequire("6HC1D");

var $8blac = parcelRequire("8blac");


var $cV7Ha = parcelRequire("cV7Ha");
const $faf5aa6f742a1f2f$export$459be3406d78c3a5 = (filters)=>{
    const chainedFilters = (0, $6HC1D.chain)({}).setIn([
        (0, $44677eb502cfd308$export$d597759d33be802e)
    ], filters[0, $44677eb502cfd308$export$d597759d33be802e] ? filters[0, $44677eb502cfd308$export$d597759d33be802e] : undefined).setIn([
        (0, $44677eb502cfd308$export$37aee82a3cb1e8f7)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(filters[0, $44677eb502cfd308$export$37aee82a3cb1e8f7]) ? filters[0, $44677eb502cfd308$export$37aee82a3cb1e8f7] : undefined).setIn([
        (0, $44677eb502cfd308$export$2a4f270075a033de)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(filters[0, $44677eb502cfd308$export$2a4f270075a033de]) ? filters[0, $44677eb502cfd308$export$2a4f270075a033de] : undefined).setIn([
        (0, $44677eb502cfd308$export$f8f7545d2bb78afb)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(filters[0, $44677eb502cfd308$export$f8f7545d2bb78afb]) ? filters[0, $44677eb502cfd308$export$f8f7545d2bb78afb] : undefined).setIn([
        (0, $44677eb502cfd308$export$ebb48b08205007c5)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(filters[0, $44677eb502cfd308$export$ebb48b08205007c5]) ? filters[0, $44677eb502cfd308$export$ebb48b08205007c5] : undefined).setIn([
        (0, $44677eb502cfd308$export$a4ad2735b021c132)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(filters[0, $44677eb502cfd308$export$a4ad2735b021c132]) ? filters[0, $44677eb502cfd308$export$a4ad2735b021c132] : undefined).setIn([
        (0, $44677eb502cfd308$export$a316570a0dbfd2b0)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(filters[0, $44677eb502cfd308$export$a316570a0dbfd2b0]) ? filters[0, $44677eb502cfd308$export$a316570a0dbfd2b0] : undefined).setIn([
        (0, $44677eb502cfd308$export$92ab80c1dc9baf44)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(filters[0, $44677eb502cfd308$export$92ab80c1dc9baf44]) ? filters[0, $44677eb502cfd308$export$92ab80c1dc9baf44] : undefined).setIn([
        (0, $44677eb502cfd308$export$e50006273435e7d4)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(filters[0, $44677eb502cfd308$export$e50006273435e7d4]) ? filters[0, $44677eb502cfd308$export$e50006273435e7d4] : undefined).setIn([
        (0, $44677eb502cfd308$export$68d693c35a8d8866)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(filters[0, $44677eb502cfd308$export$68d693c35a8d8866]) ? filters[0, $44677eb502cfd308$export$68d693c35a8d8866] : undefined).setIn([
        (0, $44677eb502cfd308$export$f863b019d19144f4)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(filters[0, $44677eb502cfd308$export$f863b019d19144f4]) ? filters[0, $44677eb502cfd308$export$f863b019d19144f4] : undefined);
    /**
	 * Delete the condition and merge the content in the chain({}) above when removing the isIncrementPlanningBoardM1Enabled FF i.e.
	 * getNormalizedFilters = () => chain({}).setIn()...setIn([ISSUE_PROJECT])...setIn().value();
	 */ if ((0, $cV7Ha.isIncrementPlanningBoardM1Enabled)()) chainedFilters.setIn([
        (0, $44677eb502cfd308$export$401f4b6eda6a369c)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(filters[0, $44677eb502cfd308$export$401f4b6eda6a369c]) ? filters[0, $44677eb502cfd308$export$401f4b6eda6a369c] : undefined);
    return chainedFilters.value();
};
const $faf5aa6f742a1f2f$export$568db3ec08ca631b = (filterType, onChangeInteractionStart, onCustomFilterChangeInteractionStart)=>{
    if (filterType === (0, $44677eb502cfd308$export$68d693c35a8d8866)) onCustomFilterChangeInteractionStart();
    else onChangeInteractionStart();
};

});


parcelRegister("2fa4K", function(module, exports) {

$parcel$export(module.exports, "VersionFilterRelay", () => $0d3133f013203675$export$184eebd43fe3b3d8);

var $ajLwh = parcelRequire("ajLwh");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $b9Y1q = parcelRequire("b9Y1q");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");


var $70jnn = parcelRequire("70jnn");
const $0d3133f013203675$export$184eebd43fe3b3d8 = ({ versionFilterRelayFragmentRef: versionFilterRelayFragmentRef, isUnassignedVersionOptionEnabled: isUnassignedVersionOptionEnabled = false, ...props })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const edges = (0, $iWLL0.useFragment)((0, $ajLwh.default), versionFilterRelayFragmentRef);
    // Note: `version.id` from GraphQL represents a version ari
    // `version.versionId` represents the actual monolith numeric ID
    const versions = (0, $eUqFw.useMemo)(()=>{
        const transformedVersions = edges.map(({ node: { name: name, versionId: id, project: project } })=>({
                id: id,
                name: name,
                projectKey: project?.key
            }));
        if (isUnassignedVersionOptionEnabled) transformedVersions.unshift({
            id: (0, $44677eb502cfd308$export$ac95b4b2317d4b33),
            name: formatMessage((0, $70jnn.default).unassignedVersionName),
            projectKey: undefined
        });
        return transformedVersions;
    }, [
        edges,
        formatMessage,
        isUnassignedVersionOptionEnabled
    ]);
    const numVersions = versions.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: {
            numVersions: numVersions
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b9Y1q.default), {
        ...props,
        versions: versions
    }));
};

});
parcelRegister("ajLwh", function(module, exports) {

$parcel$export(module.exports, "default", () => $e05f3461797a7474$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<531d80e7445ae683f74512f9503f3243>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e05f3461797a7474$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "versionFilterRelay_softwareFilters",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "versionId"
                        },
                        "action": "THROW",
                        "path": "node.versionId"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        "action": "THROW",
                        "path": "node.name"
                    },
                    {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "key"
                            }
                        ]
                    }
                ]
            },
            "action": "THROW",
            "path": "node"
        }
    ],
    "type": "JiraVersionEdge"
};
$e05f3461797a7474$var$node.hash = "ecd6dfc3c566dfd4b3cd5078c4c50713";
var $e05f3461797a7474$export$2e2bcd8739ae039 = $e05f3461797a7474$var$node;

});

parcelRegister("70jnn", function(module, exports) {

$parcel$export(module.exports, "default", () => $28557e061dfddb68$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $28557e061dfddb68$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    unassignedVersionName: {
        "id": "software-filters.version-filter-relay.unassigned-version-name",
        "defaultMessage": "Issues without version"
    }
});

});


parcelRegister("5yMWP", function(module, exports) {

$parcel$export(module.exports, "setInteractionFeedbackMark", () => $e7bcb06c4f724091$export$2a56340540433ea3);
$parcel$export(module.exports, "setInteractionStartMark", () => $e7bcb06c4f724091$export$1da8f59ae62c0e17);

var $gPQCf = parcelRequire("gPQCf");
const $e7bcb06c4f724091$export$2a56340540433ea3 = ()=>{
    (0, $gPQCf.filterInteraction).mark('feedback');
};
const $e7bcb06c4f724091$export$1da8f59ae62c0e17 = ()=>{
    (0, $gPQCf.filterInteraction).start();
};

});

parcelRegister("gGjjj", function(module, exports) {

$parcel$export(module.exports, "useGetEpicsAndProject", () => $3c7a94a02310966c$export$6a0adf6c96018071);

var $iZuDo = parcelRequire("iZuDo");

var $1ybV0 = parcelRequire("1ybV0");

var $3l6tm = parcelRequire("3l6tm");

var $2TPOU = parcelRequire("2TPOU");

var $8wXFi = parcelRequire("8wXFi");

var $7TyGu = parcelRequire("7TyGu");

var $1gQ73 = parcelRequire("1gQ73");

var $22cnO = parcelRequire("22cnO");

var $j258X = parcelRequire("j258X");
const $3c7a94a02310966c$var$useEpicQuery = (boardId, isCompanyManaged, shouldSyncEpics)=>(0, $iZuDo.useQuery)((0, $2TPOU.EPIC_QUERY), {
        skip: false,
        variables: {
            boardId: boardId,
            isCompanyManaged: // Legacy BacklogGetAllEpics does not require isCompanyManaged variables
            // Therefore, we omit isCompanyManaged variable if FF is off
            isCompanyManaged,
            isQueryColumns: isCompanyManaged && (0, $8wXFi.isEpicPanelInProgressBarTooltipsUpdateEnabled)(),
            skipEpicDetails: (0, $1ybV0.ff)('jsw-epic-panel-performance-async-epic-details')
        },
        context: {
            headers: {
                /*  This header is required for EpicPanelEpics query
                        Please note that isCompanyManaged == true is also behind feature flag
                */ 'is-company-managed-board': isCompanyManaged
            }
        },
        fetchPolicy: shouldSyncEpics ? 'cache-and-network' : 'cache-first'
    });
const $3c7a94a02310966c$export$6a0adf6c96018071 = (boardId, shouldSyncEpics = false)=>{
    const isCompanyManaged = (0, $j258X.useIsCMPBacklog)();
    const firstLevelHierarchyName = (0, $1gQ73.useBacklogSelector)((0, $22cnO.getFirstLevelHierarchyName));
    let isParentIssueTypeAvailable = false;
    let issueParentsTypeName = (0, $7TyGu.DEFAULT_PARENT_ISSUE_TYPE_NAME);
    const { data: data } = $3c7a94a02310966c$var$useEpicQuery(boardId, isCompanyManaged, shouldSyncEpics);
    if (false || !data) return {
        parents: [],
        isParentIssueTypeAvailable: isParentIssueTypeAvailable,
        issueParentsTypeName: issueParentsTypeName
    };
    const { boardScope: { projectLocation: projectLocation }, globalConfig: globalConfig } = data;
    if (isCompanyManaged) {
        isParentIssueTypeAvailable = globalConfig?.issueParentTypeConfig.hierarchyLevelType === (0, $3l6tm.PARENT_HIERARCHY_TYPE);
        issueParentsTypeName = firstLevelHierarchyName || globalConfig?.issueParentTypeConfig.name || (0, $7TyGu.DEFAULT_PARENT_ISSUE_TYPE_NAME);
    } else if (projectLocation?.issueTypes.length) {
        const issueType = projectLocation.issueTypes.find(({ hierarchyLevelType: hierarchyLevelType })=>hierarchyLevelType === (0, $3l6tm.PARENT_HIERARCHY_TYPE));
        isParentIssueTypeAvailable = Boolean(issueType);
        if (issueType) issueParentsTypeName = issueType.name;
    }
    return {
        parents: data.boardScope.issueParents,
        isParentIssueTypeAvailable: isParentIssueTypeAvailable,
        issueParentsTypeName: issueParentsTypeName
    };
};

});
parcelRegister("2TPOU", function(module, exports) {

$parcel$export(module.exports, "EPIC_QUERY", () => $100f46ea9e3263f3$export$cb085029733a197f);
$parcel$export(module.exports, "useEpicQuery", () => $100f46ea9e3263f3$export$e0168062c1c658e5);
$parcel$export(module.exports, "useEpicDetailsQuery", () => $100f46ea9e3263f3$export$97e1c9675ac0bfb2);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $9ypom = parcelRequire("9ypom");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $4VuVx = parcelRequire("4VuVx");

var $4WA4h = parcelRequire("4WA4h");

var $3RmfR = parcelRequire("3RmfR");
const $100f46ea9e3263f3$export$cb085029733a197f = (0, $9ypom.default)`
    ${(0, $4WA4h.timeTrackingOptionsFragment)}
    ${(0, $4WA4h.epicLiteFragment)}
    ${(0, $4WA4h.epicFragment)}
    ${(0, $4WA4h.estimationInfoFragment)}
    ${(0, $4WA4h.projectLocationFragment)}
    ${(0, $4WA4h.currentUserFragment)}
    ${(0, $4WA4h.boardLocationFragment)}
    ${(0, $4WA4h.issueParentTypeConfigFragment)}
    ${(0, $4WA4h.columnFragment)}
    ${(0, $4WA4h.boardFragment)}
    query EpicPanelEpics($boardId: ID!, $isCompanyManaged: Boolean!, $isQueryColumns: Boolean!, $skipEpicDetails: Boolean! = false) {
        jira @include(if: $isCompanyManaged) {
            timeTrackingOptions {
                ...TimeTrackingOptionsFragment
            }
        }
        boardScope(boardId: $boardId, isCMP: $isCompanyManaged) {
            issueParents @skip(if: $skipEpicDetails) {
                ...EpicPanelIssueParentFragment
                estimationInfo @include(if: $isCompanyManaged) {
                    ...EstimationInfoFragment
                }
            }
            issueParents @include(if: $skipEpicDetails) {
                ...EpicPanelIssueParentLiteFragment
            }
            projectLocation @skip(if: $isCompanyManaged) {
                ...ProjectLocationFragment
            }
            currentUser {
                ...CurrentUserFragment
            }
            boardLocation @include(if: $isCompanyManaged) {
                ...BoardLocationFragment
            }
            board @include(if: $isQueryColumns) {
                columns {
                    ...ColumnFragment
                }
                ...BoardFragment
            }
        }
        globalConfig @include(if: $isCompanyManaged) {
            issueParentTypeConfig {
                ...IssueParentTypeConfigFragment
            }
        }
    }
`;
const $100f46ea9e3263f3$export$e0168062c1c658e5 = (boardId, isCompanyManaged)=>{
    const [hasFullFetched, setFullFetched] = (0, $eUqFw.useState)(false);
    const [shouldShowLoadingState, setShouldShowLoadingState] = (0, $eUqFw.useState)(false);
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $iZuDo.useQuery)($100f46ea9e3263f3$export$cb085029733a197f, {
        skip: (0, $eI5EY.fg)('jsw_epic_panel_paginated_fetch') || false,
        context: {
            headers: {
                'is-company-managed-board': isCompanyManaged
            }
        },
        variables: {
            boardId: boardId,
            isCompanyManaged: isCompanyManaged,
            isQueryColumns: (0, $1ybV0.ff)('modify-cmp-backlog-epic-panel-in-progress-bar-tooltips_gusjl') && isCompanyManaged,
            skipEpicDetails: (0, $1ybV0.ff)('jsw-epic-panel-performance-async-epic-details')
        },
        fetchPolicy: 'cache-first'
    });
    const fetchFull = (0, $eUqFw.useCallback)(async ({ triggerLoadingState: triggerLoadingState = false } = {})=>{
        if ((0, $1ybV0.ff)('jsw-epic-panel-performance-async-epic-details')) {
            setShouldShowLoadingState(triggerLoadingState);
            setFullFetched(true);
            const result = await refetch({
                boardId: boardId,
                isCompanyManaged: isCompanyManaged,
                isQueryColumns: (0, $1ybV0.ff)('modify-cmp-backlog-epic-panel-in-progress-bar-tooltips_gusjl') && isCompanyManaged,
                skipEpicDetails: false
            });
            setShouldShowLoadingState(false);
            return result;
        }
        return refetch();
    }, [
        boardId,
        isCompanyManaged,
        refetch
    ]);
    const transformedData = (0, $eUqFw.useMemo)(()=>(0, $3RmfR.transformEpic)({
            isCompanyManaged: isCompanyManaged,
            isLoading: loading && shouldShowLoadingState,
            hasError: !!error,
            data: data
        }), [
        data,
        error,
        isCompanyManaged,
        loading,
        shouldShowLoadingState
    ]);
    return {
        data: transformedData,
        loading: loading,
        error: error,
        refetch: fetchFull,
        hasFullFetched: (0, $1ybV0.ff)('jsw-epic-panel-performance-async-epic-details') ? hasFullFetched : undefined
    };
};
/* -------------------------------------------------------------------------- */ /**
 * Query to fetch full epic details for the epic panel. This is responsible for updating the apollo cache,
 * and the values are read via VIEW_EPIC_DETAILS_QUERY.
 */ const $100f46ea9e3263f3$var$EPIC_DETAILS_QUERY = (0, $9ypom.default)`
    ${(0, $4WA4h.epicFragment)}
    ${(0, $4WA4h.estimationInfoFragment)}
    query FullEpicDetails($boardId: ID!, $isCompanyManaged: Boolean!, $pageSize: Int!, $startCursor: String) {
        boardScope(boardId: $boardId, isCMP: $isCompanyManaged) {
            parents(first: $pageSize, after: $startCursor) {
                pageInfo {
                    hasNextPage
                    endCursor
                }
                edges {
                    node {
                        ...EpicPanelIssueParentFragment
                        estimationInfo @include(if: $isCompanyManaged) {
                            ...EstimationInfoFragment
                        }
                    }
                }
            }
        }
    }
`;
const $100f46ea9e3263f3$export$97e1c9675ac0bfb2 = ({ boardId: boardId, isCompanyManaged: isCompanyManaged })=>(0, $iZuDo.useQuery)($100f46ea9e3263f3$var$EPIC_DETAILS_QUERY, {
        notifyOnNetworkStatusChange: true,
        context: {
            headers: {
                'is-company-managed-board': isCompanyManaged
            }
        },
        variables: {
            boardId: String(boardId),
            isCompanyManaged: isCompanyManaged,
            pageSize: (0, $4VuVx.PAGE_SIZE)
        },
        fetchPolicy: 'network-only',
        skip: true
    });

});
parcelRegister("3RmfR", function(module, exports) {

$parcel$export(module.exports, "transformEpic", () => $2d18f58c0cbb90eb$export$db2b81c6fdbe846c);
$parcel$export(module.exports, "transformFullCard", () => $2d18f58c0cbb90eb$export$7b09839985806501);

var $f222W = parcelRequire("f222W");

var $1ybV0 = parcelRequire("1ybV0");

var $3l6tm = parcelRequire("3l6tm");

var $4m36T = parcelRequire("4m36T");

var $4VuVx = parcelRequire("4VuVx");
const $2d18f58c0cbb90eb$var$isEpicLoadingBecauseOfOptimisticCreation = (epicId)=>Number(epicId) < 0;
const $2d18f58c0cbb90eb$export$ac8d104fa0f53892 = (estimation)=>{
    const { details: { estimationType: estimationType, name: name }, childrenEstimationStats: { doneEstimate: doneEstimate, totalEstimate: totalEstimate, percentageCompleted: percentageCompleted, notEstimated: notEstimated } } = estimation;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($f222W)))(estimationType) || (0, (/*@__PURE__*/$parcel$interopDefault($f222W)))(name) || (0, (/*@__PURE__*/$parcel$interopDefault($f222W)))(doneEstimate) || (0, (/*@__PURE__*/$parcel$interopDefault($f222W)))(totalEstimate) || (0, (/*@__PURE__*/$parcel$interopDefault($f222W)))(percentageCompleted) || (0, (/*@__PURE__*/$parcel$interopDefault($f222W)))(notEstimated)) return null;
    return {
        estimationType: estimationType,
        name: name,
        doneEstimate: doneEstimate,
        totalEstimate: totalEstimate,
        percentageCompleted: percentageCompleted / 100,
        notEstimated: notEstimated
    };
};
const $2d18f58c0cbb90eb$var$transformCard = ({ id: id, key: key, summary: summary, color: color, childrenInfo: childrenInfo, estimationInfo: estimationInfo, startDate: startDate, dueDate: dueDate }, columnCounts, isLoading, hasError)=>{
    const epicData = {
        id: Number(id),
        key: key,
        name: summary,
        color: (0, (/*@__PURE__*/$parcel$interopDefault($f222W)))(color) ? undefined : color,
        isLoading: $2d18f58c0cbb90eb$var$isEpicLoadingBecauseOfOptimisticCreation(id) || (0, $1ybV0.ff)('jsw-epic-panel-performance-async-epic-details') && (isLoading || !childrenInfo),
        hasError: (0, $1ybV0.ff)('jsw-epic-panel-performance-async-epic-details') && hasError,
        startDate: (0, (/*@__PURE__*/$parcel$interopDefault($f222W)))(startDate) ? undefined : startDate,
        dueDate: (0, (/*@__PURE__*/$parcel$interopDefault($f222W)))(dueDate) ? undefined : dueDate
    };
    const shouldHideProgress = (0, $1ybV0.ff)('jsw-epic-panel-performance-async-epic-details') && (isLoading || hasError);
    const { todoStats: todoStats, inProgressStats: inProgressStats, doneStats: doneStats } = childrenInfo || {};
    const toDo = !shouldHideProgress && todoStats && !(0, (/*@__PURE__*/$parcel$interopDefault($f222W)))(todoStats.issueCount) ? todoStats.issueCount : 0;
    const inProgress = !shouldHideProgress && inProgressStats && !(0, (/*@__PURE__*/$parcel$interopDefault($f222W)))(inProgressStats.issueCount) ? inProgressStats.issueCount : 0;
    const done = !shouldHideProgress && doneStats && !(0, (/*@__PURE__*/$parcel$interopDefault($f222W)))(doneStats.issueCount) ? doneStats.issueCount : 0;
    return {
        epic: epicData,
        progress: {
            status: {
                toDo: {
                    issueCount: toDo,
                    columnCount: columnCounts.toDo
                },
                inProgress: {
                    issueCount: inProgress,
                    columnCount: columnCounts.inProgress
                },
                done: {
                    issueCount: done,
                    columnCount: columnCounts.done
                }
            },
            totalIssues: toDo + inProgress + done
        },
        estimation: estimationInfo ? $2d18f58c0cbb90eb$export$ac8d104fa0f53892(estimationInfo) : null
    };
};
const $2d18f58c0cbb90eb$var$getColumnsCounts = (columns)=>{
    const toDo = columns.filter((column)=>column.isInitial).length;
    const inProgress = columns.filter((column)=>!column.isInitial && !column.isDone).length;
    const done = columns.filter((column)=>column.isDone).length;
    return {
        toDo: toDo,
        inProgress: inProgress,
        done: done
    };
};
const $2d18f58c0cbb90eb$export$db2b81c6fdbe846c = ({ isCompanyManaged: isCompanyManaged, isLoading: isLoading, hasError: hasError, data: data })=>{
    const defaultReturn = {
        ...isCompanyManaged && {
            timeTrackingOptions: (0, $4m36T.defaultTimeTrackingOptions)
        },
        projectId: '0',
        isRankingEnabled: !isCompanyManaged,
        cards: [],
        epicIssueType: {
            id: 0,
            name: (0, $4VuVx.DEFAULT_PARENT_ISSUE_TYPE_NAME),
            hasRequiredFields: false
        },
        currentUserHasCreatePermission: false,
        currentUserHasEditPermission: false
    };
    if (!data) return defaultReturn;
    const { globalConfig: globalConfig, boardScope: { issueParents: issueParents, projectLocation: projectLocation, currentUser: { permissions: permissions }, boardLocation: boardLocation, board: board } } = data;
    let epicIssueType;
    let projectId = '';
    if (isCompanyManaged) {
        epicIssueType = globalConfig?.issueParentTypeConfig;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        projectId = boardLocation?.id ?? '';
    } else if (projectLocation) {
        const { issueTypes: issueTypes, id: id } = projectLocation;
        projectId = id;
        epicIssueType = issueTypes.find(({ hierarchyLevelType: hierarchyLevelType })=>hierarchyLevelType === (0, $3l6tm.PARENT_HIERARCHY_TYPE));
    }
    if (epicIssueType) {
        const currentUserHasCreatePermission = permissions.includes((0, $4VuVx.CREATE_ISSUE_PERMISSION));
        const currentUserHasEditPermission = permissions.includes((0, $4VuVx.EDIT_ISSUE_PERMISSION));
        const columns = board?.columns ?? [];
        const columnCounts = $2d18f58c0cbb90eb$var$getColumnsCounts(columns);
        const cards = issueParents.map((card)=>$2d18f58c0cbb90eb$var$transformCard(card, columnCounts, isLoading, hasError));
        return {
            ...data.jira && {
                timeTrackingOptions: data.jira.timeTrackingOptions
            },
            projectId: projectId,
            isRankingEnabled: board ? !!board.rankCustomFieldId : true,
            cards: cards,
            epicIssueType: {
                id: epicIssueType.id,
                name: epicIssueType.name,
                hasRequiredFields: epicIssueType.hasRequiredFields ?? false
            },
            currentUserHasCreatePermission: currentUserHasCreatePermission,
            currentUserHasEditPermission: currentUserHasEditPermission
        };
    }
    return defaultReturn;
};
const $2d18f58c0cbb90eb$export$7b09839985806501 = ({ id: id, key: key, summary: summary, color: color, childrenInfo: childrenInfo, estimationInfo: estimationInfo, startDate: startDate, dueDate: dueDate }, columnCounts)=>{
    const epicData = {
        id: Number(id),
        key: key,
        name: summary,
        color: (0, (/*@__PURE__*/$parcel$interopDefault($f222W)))(color) ? undefined : color,
        isLoading: $2d18f58c0cbb90eb$var$isEpicLoadingBecauseOfOptimisticCreation(id),
        hasError: false,
        startDate: (0, (/*@__PURE__*/$parcel$interopDefault($f222W)))(startDate) ? undefined : startDate,
        dueDate: (0, (/*@__PURE__*/$parcel$interopDefault($f222W)))(dueDate) ? undefined : dueDate
    };
    const { todoStats: todoStats, inProgressStats: inProgressStats, doneStats: doneStats } = childrenInfo || {};
    const toDo = todoStats && !(0, (/*@__PURE__*/$parcel$interopDefault($f222W)))(todoStats.issueCount) ? todoStats.issueCount : 0;
    const inProgress = inProgressStats && !(0, (/*@__PURE__*/$parcel$interopDefault($f222W)))(inProgressStats.issueCount) ? inProgressStats.issueCount : 0;
    const done = doneStats && !(0, (/*@__PURE__*/$parcel$interopDefault($f222W)))(doneStats.issueCount) ? doneStats.issueCount : 0;
    return {
        epic: epicData,
        progress: {
            status: {
                toDo: {
                    issueCount: toDo,
                    columnCount: columnCounts.toDo
                },
                inProgress: {
                    issueCount: inProgress,
                    columnCount: columnCounts.inProgress
                },
                done: {
                    issueCount: done,
                    columnCount: columnCounts.done
                }
            },
            totalIssues: toDo + inProgress + done
        },
        estimation: estimationInfo ? $2d18f58c0cbb90eb$export$ac8d104fa0f53892(estimationInfo) : null
    };
};

});



parcelRegister("3GERZ", function(module, exports) {

$parcel$export(module.exports, "BacklogCustomFilter", () => $dd9ca22d41bda405$export$34fa6a8efdb70dd8);

var $eUqFw = parcelRequire("eUqFw");

var $k8Lle = parcelRequire("k8Lle");

var $8MrYx = parcelRequire("8MrYx");
var $c3qrZ = parcelRequire("c3qrZ");
var $3kYjh = parcelRequire("3kYjh");

var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");

var $kdGmo = parcelRequire("kdGmo");

var $j258X = parcelRequire("j258X");

var $4IDt8 = parcelRequire("4IDt8");
const $dd9ca22d41bda405$var$BacklogCustomFilterRedux = (props)=>{
    const boardId = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getRapidViewId));
    const filters = (0, $1gQ73.useBacklogSelector)((0, $kdGmo.getCMPFilters));
    const showPanelToggle = props.isCompanyManaged;
    const isFilterBarVisible = (0, $8MrYx.useShowQuickFilters)();
    const { toggleViewSetting: toggleViewSetting } = (0, $8MrYx.useViewSettingsActions)();
    const onToggleIsFilterBarVisible = (0, $eUqFw.useCallback)(()=>{
        if (boardId) toggleViewSetting({
            boardId: Number(boardId),
            view: (0, $c3qrZ.View).BACKLOG,
            setting: (0, $3kYjh.ViewSetting).QUICK_FILTERS
        });
    }, [
        boardId,
        toggleViewSetting
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k8Lle.default), {
        ...props,
        filters: filters,
        isPanelToggleChecked: isFilterBarVisible,
        onTogglePanel: onToggleIsFilterBarVisible,
        showPanelToggle: showPanelToggle
    });
};
const $dd9ca22d41bda405$export$34fa6a8efdb70dd8 = (props)=>{
    const isCMPBoard = (0, $j258X.useIsCMPBacklog)();
    if (isCMPBoard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dd9ca22d41bda405$var$BacklogCustomFilterRedux, {
        ...props,
        isCompanyManaged: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4IDt8.BacklogCustomFilterRelay), props);
};

});
parcelRegister("k8Lle", function(module, exports) {

$parcel$export(module.exports, "default", () => $5108fb81e1ffdb4d$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5JgJ2 = parcelRequire("5JgJ2");

var $idkBG = parcelRequire("idkBG");

var $azooe = parcelRequire("azooe");

var $9QFla = parcelRequire("9QFla");
const $5108fb81e1ffdb4d$var$MAX_SELECTION_ALLOWED = 10;
const $5108fb81e1ffdb4d$var$CustomFilter = ({ filters: filters = [], selectedFilters: selectedFilters = [], showLink: showLink = false, manageUrl: manageUrl = '', onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), isNested: isNested = false, isCompanyManaged: isCompanyManaged = false, isPanelToggleChecked: isPanelToggleChecked = false, onTogglePanel: onTogglePanel = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), showPanelToggle: showPanelToggle = false, shouldReturnFocus: shouldReturnFocus })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const values = (0, $eUqFw.useMemo)(()=>filters.map((filter)=>({
                label: filter.name,
                value: filter.id
            })), [
        filters
    ]);
    const onChangeMapValues = (0, $eUqFw.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    const maxSelectionReachedTooltip = formatMessage((0, $9QFla.default).maxSelectionReachedTooltip, {
        maxSelectionAllowed: $5108fb81e1ffdb4d$var$MAX_SELECTION_ALLOWED
    });
    const onLinkItemClick = (0, $eUqFw.useCallback)(()=>{
        (0, $idkBG.setReturnToProjectUrl)();
    }, []);
    const filterLabel = isCompanyManaged ? (0, $9QFla.default).labelCmp : (0, $9QFla.default).label;
    const manageLinkTitle = isCompanyManaged ? (0, $9QFla.default).manageLinkTitleCmp : (0, $9QFla.default).manageLinkTitle;
    const toggleLabel = isCompanyManaged ? formatMessage((0, $9QFla.default).toggleLabelCmp) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azooe.default), {
        shouldReturnFocus: shouldReturnFocus,
        buttonType: "QuickFilters",
        "data-testid": "filters.ui.filters.custom.assignee-filter",
        label: formatMessage(filterLabel),
        values: values,
        selectedValues: selectedFilters,
        onChange: onChangeMapValues,
        showLink: showLink,
        url: manageUrl,
        useHrefForUrl: isCompanyManaged,
        linkTitle: formatMessage(manageLinkTitle),
        maxSelectionAllowed: isCompanyManaged ? undefined : $5108fb81e1ffdb4d$var$MAX_SELECTION_ALLOWED,
        maxSelectionReachedTooltip: maxSelectionReachedTooltip,
        isNested: isNested,
        onLinkItemClick: onLinkItemClick,
        showPanelToggle: showPanelToggle,
        onTogglePanel: onTogglePanel,
        isPanelToggleChecked: isPanelToggleChecked,
        toggleLabel: toggleLabel
    });
};
const $5108fb81e1ffdb4d$var$CustomFilterComponent = /*#__PURE__*/ (0, $eUqFw.memo)($5108fb81e1ffdb4d$var$CustomFilter);
$5108fb81e1ffdb4d$var$CustomFilterComponent.displayName = 'CustomFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$5108fb81e1ffdb4d$var$CustomFilterComponent.whyDidYouRender = true;
var $5108fb81e1ffdb4d$export$2e2bcd8739ae039 = $5108fb81e1ffdb4d$var$CustomFilterComponent;

});
parcelRegister("9QFla", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c7be5eeb33252bd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5c7be5eeb33252bd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "software-filters.filters.custom.label",
        "defaultMessage": "Custom filters"
    },
    labelCmp: {
        "id": "software-filters.filters.custom.label-cmp",
        "defaultMessage": "Quick filters"
    },
    manageLinkTitle: {
        "id": "software-filters.filters.custom.manage-link-title",
        "defaultMessage": "Manage custom filters"
    },
    manageLinkTitleCmp: {
        "id": "software-filters.filters.custom.manage-link-title-cmp",
        "defaultMessage": "Manage quick filters"
    },
    maxSelectionReachedTooltip: {
        "id": "software-filters.filters.custom.max-selection-reached-tooltip",
        "defaultMessage": "You can't select more than {maxSelectionAllowed} custom filters"
    },
    toggleLabelCmp: {
        "id": "software-filters.filters.custom.toggle-label-cmp",
        "defaultMessage": "Show quick filters"
    }
});

});


parcelRegister("4IDt8", function(module, exports) {

$parcel$export(module.exports, "BacklogCustomFilterRelay", () => $401177076c3009cd$export$bb99cea1633822a7);

var $gH3Un = parcelRequire("gH3Un");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $7piGJ = parcelRequire("7piGJ");
const $401177076c3009cd$export$bb99cea1633822a7 = ({ customFiltersQueryRef: customFiltersQueryRef, ...props })=>{
    const customFiltersFragmentRef = (0, $iWLL0.usePreloadedQuery)((0, $gH3Un.default), customFiltersQueryRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7piGJ.default), {
        customFiltersFragmentRef: customFiltersFragmentRef,
        ...props
    });
};

});
parcelRegister("7piGJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c8ec4cc8b7fb6f5$export$2e2bcd8739ae039);

var $3ELlm = parcelRequire("3ELlm");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $k8Lle = parcelRequire("k8Lle");

var $d6f6c = parcelRequire("d6f6c");
const $2c8ec4cc8b7fb6f5$var$CustomFilterRelay = ({ customFiltersFragmentRef: customFiltersFragmentRef, screenName: screenName, ...props })=>{
    const { boardScope: boardScope } = (0, $iWLL0.useFragment)((0, $3ELlm.default), customFiltersFragmentRef);
    // each item in an array is nullable & an object's keys readonly in relay's generated type
    const filters = (0, $eUqFw.useMemo)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ()=>boardScope?.customFilters.filter(Boolean) || [], [
        boardScope?.customFilters
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k8Lle.default), {
        ...props,
        filters: filters
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireOperationalAnalytics), {
        actionSubject: "ui",
        action: "taskSuccess",
        attributes: {
            screenName: screenName,
            task: 'loadCustomFilters',
            customFiltersCount: filters.length
        }
    }));
};
var $2c8ec4cc8b7fb6f5$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($2c8ec4cc8b7fb6f5$var$CustomFilterRelay);

});
parcelRegister("3ELlm", function(module, exports) {

$parcel$export(module.exports, "default", () => $0755b1b0477278c6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<27f6e515959b3fa71c98f3b9ea403490>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0755b1b0477278c6$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ],
    "kind": "Fragment",
    "name": "customFilter_softwareFilters_CustomFilterRelay",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "boardId",
                        "variableName": "boardId"
                    }
                ],
                "concreteType": "BoardScope",
                "kind": "LinkedField",
                "name": "boardScope",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "CustomFilter",
                            "kind": "LinkedField",
                            "name": "customFilters",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "id"
                                    },
                                    "action": "THROW",
                                    "path": "boardScope.customFilters.id"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "name"
                                    },
                                    "action": "THROW",
                                    "path": "boardScope.customFilters.name"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "boardScope.customFilters"
                    }
                ]
            },
            "action": "THROW",
            "path": "boardScope"
        }
    ],
    "type": "Query"
};
$0755b1b0477278c6$var$node.hash = "ae7389daa2b7626fc0f4f542c785e41f";
var $0755b1b0477278c6$export$2e2bcd8739ae039 = $0755b1b0477278c6$var$node;

});




parcelRegister("iFRbv", function(module, exports) {

$parcel$export(module.exports, "default", () => $9821aa9b5bc5e164$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9821aa9b5bc5e164$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    unassigned: {
        "id": "backlog.header.controls-bar.filter-bar.unassigned",
        "defaultMessage": "Issues without {target}"
    },
    textFilter: {
        "id": "backlog.header.controls-bar.filter-bar.text-filter",
        "defaultMessage": "Search"
    }
});

});

parcelRegister("75UOO", function(module, exports) {

$parcel$export(module.exports, "useIssueTypes", () => $549aa18787a8476c$export$8bbc5cc35915a21b);

var $eUqFw = parcelRequire("eUqFw");

var $3l6tm = parcelRequire("3l6tm");
const $549aa18787a8476c$export$8bbc5cc35915a21b = (issueTypes)=>(0, $eUqFw.useMemo)(()=>{
        if (!issueTypes || !issueTypes.length) return issueTypes;
        return issueTypes.filter((issueType)=>issueType.typeHierarchyLevel !== (0, $3l6tm.EPIC_PARENT_HIERARCHY_TYPE) && issueType.typeHierarchyLevel !== (0, $3l6tm.CHILD_HIERARCHY_TYPE));
    }, [
        issueTypes
    ]);

});



parcelRegister("7FLNi", function(module, exports) {

$parcel$export(module.exports, "ControlsBar", () => $cb2fe5a1db425b4d$export$9b3bbae461092bf8);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8blac = parcelRequire("8blac");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $f6xJy = parcelRequire("f6xJy");

var $aDfcw = parcelRequire("aDfcw");
var $8MrYx = parcelRequire("8MrYx");
var $c3qrZ = parcelRequire("c3qrZ");
var $27GCD = parcelRequire("27GCD");
var $78u8L = parcelRequire("78u8L");

var $ab6rA = parcelRequire("ab6rA");

var $8wXFi = parcelRequire("8wXFi");


var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $8ZI73 = parcelRequire("8ZI73");

var $lMwdE = parcelRequire("lMwdE");

var $8wl1S = parcelRequire("8wl1S");

var $i0G2M = parcelRequire("i0G2M");

var $lxSty = parcelRequire("lxSty");

var $aIijO = parcelRequire("aIijO");
const $cb2fe5a1db425b4d$export$9b3bbae461092bf8 = (props)=>{
    const { isBacklogWithSprints: isBacklogWithSprints, rapidViewId: rapidViewId, FilterBar: FilterBar, onTogglePanel: onTogglePanel, customFiltersQueryRef: customFiltersQueryRef, versionFilterRelayQueryRef: versionFilterRelayQueryRef, isClassic: isClassic, showEpicAsPanel: showEpicAsPanel, isVersionsEnabled: isVersionsEnabled, onSubtasksExpandAll: onSubtasksExpandAll, onSubtasksCollapseAll: onSubtasksCollapseAll } = props;
    const isCompanyManaged = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getIsCompanyManaged));
    const config = (0, $1gQ73.useBacklogSelector)((0, $8ZI73.getConfig));
    const isDataLoaded = (0, $1gQ73.useBacklogSelector)((0, $8ZI73.isCriticalDataLoaded));
    const epicCustomName = config.hierarchyNomenclature?.firstLevelName;
    const appEditions = (0, $ab6rA.useAppEditions)();
    const handleOnToggle = (0, $eUqFw.useCallback)((panelType)=>{
        onTogglePanel(panelType);
    }, [
        onTogglePanel
    ]);
    const handleViewSettingPanelToggle = (0, $eUqFw.useCallback)(()=>{
        onTogglePanel((0, $d36e2c37d06c83ff$export$ba1da943283b9900));
    }, [
        onTogglePanel
    ]);
    const isInsightsOpen = (0, $8wl1S.useIsInsightsPanelOpen)();
    const isViewSettingPanelOpen = (0, $i0G2M.useIsViewSettingsPanelOpen)();
    const isFilterSelectionBarOpen = (0, $8MrYx.useShowQuickFilters)();
    const showFilterBarToggle = isCompanyManaged;
    const allCardGroups = (0, $lMwdE.useAllCardGroups)();
    const shouldShowSubtasks = (0, $eUqFw.useMemo)(()=>!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(allCardGroups), [
        allCardGroups
    ]);
    const isDueDateEnabled = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.backlogHasDueDate));
    const hasCardsWithStoryPoint = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.backlogHasStoryPoints));
    const hasCardsWithEstimate = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.backlogHasEstimates));
    const hasCardsWithPriority = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.backlogHasPriority));
    const areAllSubtasksExpanded = (0, $eUqFw.useMemo)(()=>allCardGroups.every((card)=>!card.isCollapsed), [
        allCardGroups
    ]);
    const areAllSubtasksCollapsed = (0, $eUqFw.useMemo)(()=>allCardGroups.every((card)=>card.isCollapsed), [
        allCardGroups
    ]);
    const handleExpandSubtasks = (0, $eUqFw.useCallback)(()=>{
        onSubtasksExpandAll(allCardGroups.map((card)=>card.parentId.toString()));
    }, [
        allCardGroups,
        onSubtasksExpandAll
    ]);
    const handleCollapseSubtasks = (0, $eUqFw.useCallback)(()=>{
        onSubtasksCollapseAll();
    }, [
        onSubtasksCollapseAll
    ]);
    const cardExtraFields = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getCardExtraFields));
    if ((0, $1ybV0.ff)('sea-2744-jsw-tabs-nav')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FilterBar, {
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cb2fe5a1db425b4d$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cb2fe5a1db425b4d$var$FilterBarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FilterBar, {
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cb2fe5a1db425b4d$var$OperationsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $cb2fe5a1db425b4d$var$importWorkWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f6xJy.ImportWorkButton), null)), isBacklogWithSprints && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aIijO.InsightsButton), {
        onToggle: handleOnToggle,
        isInsightsPanelOpen: isInsightsOpen,
        boardId: rapidViewId,
        edition: appEditions.software
    }), (0, $8wXFi.isViewSettingAsPanelExpEnabledWithNoExposure)() ? isDataLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27GCD.ViewSettingsSyncFromLocalStorageWrapper), {
        boardId: rapidViewId,
        view: (0, $c3qrZ.View).BACKLOG,
        cardExtraFields: cardExtraFields,
        isVersionsEnabled: isVersionsEnabled,
        isEstimateEnabled: hasCardsWithStoryPoint || hasCardsWithEstimate,
        showEpicAsPanel: showEpicAsPanel,
        isDueDateEnabled: !isCompanyManaged && isDueDateEnabled,
        isPriorityEnabled: hasCardsWithPriority
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $78u8L.ViewSettingsPanelOnboarding), {
        isViewSettingPanelOpen: isViewSettingPanelOpen,
        onTogglePanel: handleViewSettingPanelToggle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $78u8L.ViewSettingsPanelButtonSpotlight), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27GCD.ViewSettingsButton), {
        isSelected: isViewSettingPanelOpen,
        onClick: handleViewSettingPanelToggle
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aDfcw.default), {
        view: (0, $c3qrZ.View).BACKLOG,
        boardId: rapidViewId,
        isClassic: isClassic,
        areSubtasksEnabled: isCompanyManaged && shouldShowSubtasks,
        onSubtasksExpandAll: handleExpandSubtasks,
        onSubtasksCollapseAll: handleCollapseSubtasks,
        areAllSubtasksExpanded: areAllSubtasksExpanded,
        areAllSubtasksCollapsed: areAllSubtasksCollapsed,
        showEpicAsPanel: showEpicAsPanel,
        epicCustomName: epicCustomName,
        isVersionsEnabled: isVersionsEnabled,
        showFilterBarToggle: showFilterBarToggle
    })))), isFilterSelectionBarOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lxSty.default), null));
};
var $cb2fe5a1db425b4d$export$2e2bcd8739ae039 = $cb2fe5a1db425b4d$export$9b3bbae461092bf8;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cb2fe5a1db425b4d$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _19pkx0bf _1bsb1osq _o5721q9c",
            __cmplp.className
        ])
    });
});
const $cb2fe5a1db425b4d$var$FilterBarWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _1bah1yb4 _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $cb2fe5a1db425b4d$var$OperationsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4 _1o9zidpf",
            __cmplp.className
        ])
    });
});
const $cb2fe5a1db425b4d$var$importWorkWrapperStyles = (0, $1ZAYh.xcss)({
    marginRight: 'space.050'
});

});
parcelRegister("lxSty", function(module, exports) {

$parcel$export(module.exports, "default", () => $3679e3fbc811869f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hfC0x = parcelRequire("hfC0x");

var $htMHF = parcelRequire("htMHF");


var $1gQ73 = parcelRequire("1gQ73");

var $5awap = parcelRequire("5awap");

var $bP7Jx = parcelRequire("bP7Jx");

var $kdGmo = parcelRequire("kdGmo");
const $3679e3fbc811869f$var$FilterSelectionBarContainer = ()=>{
    const [selectedFilters, { setFilters: setFilters }] = (0, $hfC0x.useFilters)();
    const allFilters = (0, $1gQ73.useBacklogSelector)((0, $kdGmo.getCMPFilters));
    const cardIds = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getCardIds));
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const onChange = (0, $eUqFw.useCallback)((filters, analyticsEvent)=>{
        dispatch((0, $5awap.filteredCardsRequest)(cardIds, analyticsEvent, filters[0, $6b2c0bb2f15ce467$export$68d693c35a8d8866]));
        setFilters({
            ...selectedFilters,
            ...filters
        });
    }, [
        selectedFilters,
        dispatch,
        cardIds,
        setFilters
    ]);
    const selectedFilterSet = (0, $eUqFw.useMemo)(()=>new Set(selectedFilters[0, $6b2c0bb2f15ce467$export$68d693c35a8d8866]), [
        selectedFilters
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $htMHF.default), {
        selectedFilters: selectedFilterSet,
        onChange: onChange,
        filters: allFilters
    });
};
var $3679e3fbc811869f$export$2e2bcd8739ae039 = $3679e3fbc811869f$var$FilterSelectionBarContainer;

});
parcelRegister("htMHF", function(module, exports) {

$parcel$export(module.exports, "default", () => $363d031b5bae6815$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5QxW9 = parcelRequire("5QxW9");

var $5YrvX = parcelRequire("5YrvX");
const $363d031b5bae6815$var$FilterSelectionBar = ({ onChange: onChange, selectedFilters: selectedFilters, filters: filters })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("fieldset", {
        "data-testid": "software-filters.ui.filter-selection-bar.filter-selection-bar",
        className: (0, $7JEyt.default)([
            "_1bsb1osq _1reo1g80 _18m91g80 _1e0c1txw _zulpu2gc _19pku2gc _1n261g80 _qtt8glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("legend", {
        className: (0, $7JEyt.default)([
            "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw"
        ])
    }, formatMessage((0, $5YrvX.default).filterToolBarAriaLabel)), filters.map((filter)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5QxW9.default), {
            key: `filter-option-${filter.id}`,
            onChange: onChange,
            selectedFilters: selectedFilters,
            filter: filter
        })));
};
var $363d031b5bae6815$export$2e2bcd8739ae039 = $363d031b5bae6815$var$FilterSelectionBar;
const $363d031b5bae6815$var$styles = null;

});
parcelRegister("5QxW9", function(module, exports) {

$parcel$export(module.exports, "default", () => $38f2f8ab66d73975$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $8cU5f = parcelRequire("8cU5f");

var $1ybV0 = parcelRequire("1ybV0");

var $bFzGY = parcelRequire("bFzGY");

var $cpu8O = parcelRequire("cpu8O");

var $2GCzm = parcelRequire("2GCzm");
const $38f2f8ab66d73975$var$FilterOption = (props)=>{
    const { onChange: onChange, selectedFilters: selectedFilters, filter: filter } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const isSelected = (0, $eUqFw.useMemo)(()=>selectedFilters.has(filter.id), [
        selectedFilters,
        filter
    ]);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        if (isSelected) selectedFilters.delete(filter.id);
        else selectedFilters.add(filter.id);
        onChange({
            CUSTOM_FILTER: Array.from(selectedFilters)
        }, createAnalyticsEvent({}));
    }, [
        onChange,
        filter,
        isSelected,
        selectedFilters,
        createAnalyticsEvent
    ]);
    const id = `checkbox-id-${filter.name}`;
    const tooltipContent = (0, $1ybV0.ff)('adding-descriptions-to-custom-filter-tooltips_gxby6') ? filter.description : filter.name;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: tooltipContent,
        position: "bottom",
        "data-testid": "software-filters.ui.filter-selection-bar.filter-option.tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $38f2f8ab66d73975$var$maxWidthWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cpu8O.default), {
        id: id,
        checked: isSelected,
        onChange: onClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        id: id,
        isSelected: isSelected,
        component: (0, $2GCzm.default)
    }, filter.name)));
};
var $38f2f8ab66d73975$export$2e2bcd8739ae039 = $38f2f8ab66d73975$var$FilterOption;
const $38f2f8ab66d73975$var$maxWidthWrapperStyles = (0, $1ZAYh.xcss)({
    maxWidth: '380px'
});

});
parcelRegister("cpu8O", function(module, exports) {

$parcel$export(module.exports, "default", () => $72699af7964730ca$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");
const $72699af7964730ca$var$HiddenCheckbox = (props)=>{
    const { id: id, checked: checked, onChange: onChange } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
        id: id,
        type: "checkbox",
        checked: checked,
        onChange: onChange,
        className: (0, $7JEyt.default)([
            "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw _81qx24b2 _ui4mv77o"
        ])
    });
};
var $72699af7964730ca$export$2e2bcd8739ae039 = $72699af7964730ca$var$HiddenCheckbox;
const $72699af7964730ca$var$styles = null;

});

parcelRegister("2GCzm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9d8b208bac09bf9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");
const $f9d8b208bac09bf9$var$Label = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("label", {
        ref: ref,
        htmlFor: props.id,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7JEyt.default)([
            "_uiztglyw",
            props.className
        ]),
        // eslint-disable-next-line react/no-children-prop
        children: props.children
    }));
var $f9d8b208bac09bf9$export$2e2bcd8739ae039 = $f9d8b208bac09bf9$var$Label;
const $f9d8b208bac09bf9$var$styles = null;

});


parcelRegister("5YrvX", function(module, exports) {

$parcel$export(module.exports, "default", () => $caf80903fe30c986$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $caf80903fe30c986$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    filterToolBarAriaLabel: {
        "id": "software-filters.filter-selection-bar.filter-tool-bar-aria-label",
        "defaultMessage": "filter tool bar"
    }
});

});



parcelRegister("aIijO", function(module, exports) {

$parcel$export(module.exports, "InsightsButton", () => $106850fcd3005112$export$95e4a3c3bc863d9c);

var $eUqFw = parcelRequire("eUqFw");

var $dEpVH = parcelRequire("dEpVH");

var $4lw2o = parcelRequire("4lw2o");

var $4FzzQ = parcelRequire("4FzzQ");


var $j258X = parcelRequire("j258X");
const $106850fcd3005112$export$95e4a3c3bc863d9c = ({ onToggle: onToggle, isInsightsPanelOpen: isInsightsPanelOpen, boardId: boardId, edition: edition = null })=>{
    const isSupported = (0, $4lw2o.useIsCurrentBrowserSupported)();
    const isCMPBacklog = (0, $j258X.useIsCMPBacklog)();
    const onToggleHandler = (0, $eUqFw.useCallback)(()=>{
        onToggle((0, $d36e2c37d06c83ff$export$29d7f2210b16d662));
    }, [
        onToggle
    ]);
    if (!isSupported) return null;
    if (!edition) return null;
    return !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4FzzQ.BacklogInsightsNudgeAsync), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dEpVH.BacklogInsightsButton), {
        isSimplifiedProject: !isCMPBacklog,
        isOpen: isInsightsPanelOpen,
        isCompact: false,
        boardId: Number(boardId),
        edition: edition,
        onToggle: onToggleHandler
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dEpVH.BacklogInsightsButton), {
        isSimplifiedProject: !isCMPBacklog,
        isOpen: isInsightsPanelOpen,
        isCompact: false,
        boardId: Number(boardId),
        edition: edition,
        onToggle: onToggleHandler
    });
};

});



parcelRegister("4rWh2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab3a7d7c4936c5f4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ab3a7d7c4936c5f4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    pageTitle: {
        "id": "backlog.header.page-title",
        "defaultMessage": "Backlog"
    },
    beta: {
        "id": "backlog.header.beta",
        "defaultMessage": "Beta"
    }
});

});


parcelRegister("aF9KL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4929e6dc767a45cb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9aFSa = parcelRequire("9aFSa");

var $drteS = parcelRequire("drteS");
const $4929e6dc767a45cb$var$KeyboardShortcuts = ()=>{
    const keyMap = (0, $drteS.useKeyMap)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9aFSa.default), {
        keyMap: keyMap,
        location: "software.backlog.keyboard-shortcuts"
    });
};
var $4929e6dc767a45cb$export$2e2bcd8739ae039 = $4929e6dc767a45cb$var$KeyboardShortcuts;

});
parcelRegister("drteS", function(module, exports) {

$parcel$export(module.exports, "useKeyMap", () => $30b9a77bfb0e4193$export$c83661c96ac791c2);

var $ldoFd = parcelRequire("ldoFd");

var $6UWn5 = parcelRequire("6UWn5");

var $l129t = parcelRequire("l129t");

var $bFzGY = parcelRequire("bFzGY");


var $kJlBc = parcelRequire("kJlBc");

var $1Ksr6 = parcelRequire("1Ksr6");

var $8MrYx = parcelRequire("8MrYx");
var $c3qrZ = parcelRequire("c3qrZ");
var $3kYjh = parcelRequire("3kYjh");

var $7TyGu = parcelRequire("7TyGu");


var $e3Gc5 = parcelRequire("e3Gc5");

var $1gQ73 = parcelRequire("1gQ73");

var $hEV2I = parcelRequire("hEV2I");

var $7Egcu = parcelRequire("7Egcu");

var $68H01 = parcelRequire("68H01");

var $1HfeQ = parcelRequire("1HfeQ");

var $K2SiM = parcelRequire("K2SiM");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $8ZI73 = parcelRequire("8ZI73");

var $7kNqR = parcelRequire("7kNqR");

var $c2v8q = parcelRequire("c2v8q");

var $ai2KE = parcelRequire("ai2KE");
const $30b9a77bfb0e4193$var$bentoShortcutsAnalyticsMap = {
    [(0, $c4988cef483d4737$export$e2291655ce717023)]: 'assignIssueKeyboardShortcut',
    [(0, $c4988cef483d4737$export$4834da14f7c856f4)]: 'editIssueLabelsKeyboardShortcut',
    [(0, $c4988cef483d4737$export$1303babe27c61a83)]: 'commentIssueKeyboardShortcut'
};
const $30b9a77bfb0e4193$var$bentoShortcutKeys = [
    (0, $c4988cef483d4737$export$e2291655ce717023),
    (0, $c4988cef483d4737$export$4834da14f7c856f4),
    (0, $c4988cef483d4737$export$1303babe27c61a83)
];
const $30b9a77bfb0e4193$export$c8673ee45279f35b = (key)=>{
    switch(key){
        case 0, $c4988cef483d4737$export$e2291655ce717023:
            return (0, $l129t.externalEditFieldAction)((0, $ebc098a76317be78$export$e18419056f3d184a));
        case 0, $c4988cef483d4737$export$4834da14f7c856f4:
            return (0, $l129t.externalEditFieldAction)((0, $ebc098a76317be78$export$93605f2a09aa8d26));
        case 0, $c4988cef483d4737$export$1303babe27c61a83:
            return (0, $l129t.externalAddCommentAction)();
        default:
            return null;
    }
};
const $30b9a77bfb0e4193$export$c83661c96ac791c2 = ()=>{
    const fireShortcutAnalytics = (0, $1Ksr6.useShortcutAnalytics)('backlog');
    const [{ location: location }, { push: push }] = (0, $kJlBc.useRouter)();
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const isBulkOperationsInProgress = (0, $6UWn5.useIsBulkOperationsInProgress)();
    const onNextIssue = ()=>{
        if (isBulkOperationsInProgress) return;
        dispatch((0, $68H01.cardNext)(fireShortcutAnalytics));
    };
    const onPrevIssue = ()=>{
        if (isBulkOperationsInProgress) return;
        dispatch((0, $68H01.cardPrev)(fireShortcutAnalytics));
    };
    const onAssignToMe = (activeCardId, activeCardAssignee, currentUser)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(activeCardId)) return;
        const assignee = currentUser?.id === activeCardAssignee?.id ? null : currentUser;
        dispatch((0, $hEV2I.assignToMeRequestThrottled)(activeCardId, assignee, fireShortcutAnalytics));
    };
    const onOpenFocusedCard = (activeCardId, isBulkOperationsSidebarActive)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(activeCardId) || isBulkOperationsSidebarActive) return;
        dispatch((0, $1HfeQ.cardClick)(activeCardId, false, false, false));
        fireShortcutAnalytics({
            key: 'o',
            id: 'viewIssueKeyboardShortcut'
        });
    };
    const onToggleBentoViewForFocusedCard = (detailViewData, activeCardId, isBulkOperationsSidebarActive)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(activeCardId) || isBulkOperationsSidebarActive) return;
        const isDetailsViewAlreadyOpen = detailViewData !== null;
        if (detailViewData !== null && detailViewData.cardId === activeCardId) dispatch((0, $K2SiM.closeDetailView)());
        else dispatch((0, $K2SiM.openDetailView)(activeCardId));
        fireShortcutAnalytics({
            key: 't',
            id: 'toggleDetailsViewKeyboardShortcut',
            attributes: {
                toggled: !isDetailsViewAlreadyOpen ? 'open' : 'closed'
            }
        });
    };
    const onOpenAndFocusBentoField = (key, activeCardId, activeCardKey, isBulkOperationsSidebarActive)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(activeCardId) || (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(activeCardKey) || isBulkOperationsSidebarActive) return;
        const externalAction = $30b9a77bfb0e4193$export$c8673ee45279f35b(key);
        if (!externalAction) return;
        dispatch((0, $K2SiM.openDetailView)(activeCardId, externalAction));
        push((0, $e3Gc5.addSelectedIssueToUrl)(activeCardKey, location));
        if ($30b9a77bfb0e4193$var$bentoShortcutsAnalyticsMap[key]) fireShortcutAnalytics({
            key: key,
            id: $30b9a77bfb0e4193$var$bentoShortcutsAnalyticsMap[key]
        });
    };
    /*
        Required to create a separate AnalyticsEvent for the cardsMove() action since
        fireShortcutAnalytics is of the wrong type. This analytics event is not used and is simply
        created to satisfy the cardsMove input parameters
    */ const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onMoveToTopOrBottomOfContainer = (selectedCards, originCardListId, placement, canUserEditIssues)=>{
        /*
        Adding logic so that if a user only has viewer permissions then they cannot edit the cards
        */ if (!canUserEditIssues || !selectedCards.length || (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(originCardListId)) return;
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'keyboardShortcut',
            action: 'pressed'
        });
        dispatch((0, $7Egcu.cardsMove)({
            cardListId: originCardListId,
            placement: placement,
            isBetweenLists: false,
            isFromActiveSprint: false,
            cardIds: selectedCards
        }, analyticsEvent));
        const isTop = placement === (0, $7TyGu.TOP_OF_LIST);
        const attributes = {
            key: isTop ? 's t' : 's b',
            id: isTop ? 'sendToTopKeyboardShortcut' : 'sendToBottomKeyboardShortcut',
            attributes: {
                isMultiSelect: selectedCards.length > 1
            }
        };
        fireShortcutAnalytics(attributes);
    };
    const selectedCards = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getSelectedCards));
    const selectedCardId = selectedCards.length !== 0 ? selectedCards[selectedCards.length - 1] : undefined;
    const activeCardId = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getActiveCard));
    const activeCardKey = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getActiveCardKey));
    const detailViewData = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getDetailViewData));
    const activeCardAssignee = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getActiveCardAssignee));
    const currentUserAccount = (0, $1gQ73.useBacklogSelector)((0, $c2v8q.getCurrentUser));
    const originCardListId = (0, $1gQ73.useBacklogSelector)((state)=>!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(selectedCardId) ? (0, $bP7Jx.makeGetCardListIdByCardId)(state)(selectedCardId) : undefined);
    const canUserEditIssues = (0, $1gQ73.useBacklogSelector)((0, $7kNqR.canEditIssue));
    const isVersionsEnabled = (0, $1gQ73.useBacklogSelector)((0, $ai2KE.isVersionsFeatureEnabled));
    const isEpicsPanelEnabled = (0, $1gQ73.useBacklogSelector)((0, $8ZI73.getShowEpicAsPanel));
    const rapidViewId = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getRapidViewId));
    const { toggleViewSetting: toggleViewSetting } = (0, $8MrYx.useViewSettingsActions)();
    const onEpicsPanelToggle = ()=>{
        if (!isEpicsPanelEnabled) return;
        toggleViewSetting({
            boardId: Number(rapidViewId),
            setting: (0, $3kYjh.ViewSetting).EPIC_PANEL,
            view: (0, $c3qrZ.View).BACKLOG
        });
        fireShortcutAnalytics({
            key: 'e',
            id: 'epicPanelToggleKeyboardShortcut'
        });
    };
    const onVersionsPanelToggle = ()=>{
        if (!isVersionsEnabled) return;
        toggleViewSetting({
            boardId: Number(rapidViewId),
            setting: (0, $3kYjh.ViewSetting).VERSION_PANEL,
            view: (0, $c3qrZ.View).BACKLOG
        });
        fireShortcutAnalytics({
            key: 'v',
            id: 'versionPanelToggleKeyboardShortcut'
        });
    };
    const keyMap = {
        o: {
            callback: ()=>{
                onOpenFocusedCard(activeCardId, isBulkOperationsInProgress);
            }
        },
        j: {
            callback: onNextIssue
        },
        k: {
            callback: onPrevIssue
        },
        t: {
            callback: ()=>{
                onToggleBentoViewForFocusedCard(detailViewData, activeCardId, isBulkOperationsInProgress);
            }
        },
        i: {
            callback: ()=>{
                onAssignToMe(activeCardId, activeCardAssignee, currentUserAccount);
            }
        },
        's t': {
            callback: ()=>{
                onMoveToTopOrBottomOfContainer(selectedCards, originCardListId, (0, $7TyGu.TOP_OF_LIST), canUserEditIssues);
            }
        },
        's b': {
            callback: ()=>{
                onMoveToTopOrBottomOfContainer(selectedCards, originCardListId, (0, $7TyGu.BOTTOM_OF_LIST), canUserEditIssues);
            }
        },
        e: {
            callback: onEpicsPanelToggle
        },
        v: {
            callback: onVersionsPanelToggle
        }
    };
    $30b9a77bfb0e4193$var$bentoShortcutKeys.forEach((key)=>{
        keyMap[key] = {
            callback: ()=>{
                onOpenAndFocusBentoField(key, activeCardId, activeCardKey, isBulkOperationsInProgress);
            }
        };
    });
    return keyMap;
};

});
parcelRegister("l129t", function(module, exports) {

$parcel$export(module.exports, "externalEditFieldAction", () => $646de4c164a6d485$export$5d020593666779fc);
$parcel$export(module.exports, "externalAddCommentAction", () => $646de4c164a6d485$export$c70036fd42f0ed99);
$parcel$export(module.exports, "SCROLL_TO_COMMENT", () => $646de4c164a6d485$export$3b373f0f7354e781);
$parcel$export(module.exports, "externalAssignToMeAction", () => $646de4c164a6d485$export$8f1d4f64b4b74146);
$parcel$export(module.exports, "FIELD_EDIT_REQUEST_EXTERNAL", () => $646de4c164a6d485$export$c72c6bc149df5e02);
$parcel$export(module.exports, "ASSIGN_TO_ME_EXTERNAL", () => $646de4c164a6d485$export$c60815f29b5cfb6d);
$parcel$export(module.exports, "transformExternalAction", () => $646de4c164a6d485$export$78aa3108fdac0ac3);

var $fYteL = parcelRequire("fYteL");

var $lkPj1 = parcelRequire("lkPj1");
const $646de4c164a6d485$export$5834f946a995a2ca = 'REFRESH_ISSUE';
const $646de4c164a6d485$export$316a97ea1161ac5a = (type)=>({
        type: $646de4c164a6d485$export$5834f946a995a2ca,
        payload: {
            type: type
        }
    });
const $646de4c164a6d485$export$256eddbefbf4b2ce = 'EDIT_FIELD';
const $646de4c164a6d485$export$5d020593666779fc = (fieldId)=>({
        type: $646de4c164a6d485$export$256eddbefbf4b2ce,
        payload: {
            fieldId: fieldId
        }
    });
const $646de4c164a6d485$export$35aff3ed3a26081d = 'ADD_COMMENT';
const $646de4c164a6d485$export$c70036fd42f0ed99 = ()=>({
        type: $646de4c164a6d485$export$35aff3ed3a26081d
    });
const $646de4c164a6d485$export$3b373f0f7354e781 = 'SCROLL_TO_COMMENT';
const $646de4c164a6d485$export$db9eae89818590a4 = (commentId)=>({
        type: $646de4c164a6d485$export$3b373f0f7354e781,
        payload: {
            commentId: commentId
        }
    });
const $646de4c164a6d485$export$ae8a4274289f40bb = 'ASSIGN_TO_ME';
const $646de4c164a6d485$export$8f1d4f64b4b74146 = ()=>({
        type: $646de4c164a6d485$export$ae8a4274289f40bb
    });
const $646de4c164a6d485$export$c72c6bc149df5e02 = 'FIELD_EDIT_REQUEST_EXTERNAL';
const $646de4c164a6d485$export$c3ca6bc94e6e6b5c = (fieldId)=>({
        type: $646de4c164a6d485$export$c72c6bc149df5e02,
        payload: {
            fieldId: fieldId
        }
    });
const $646de4c164a6d485$export$c60815f29b5cfb6d = 'ASSIGN_TO_ME_EXTERNAL';
const $646de4c164a6d485$export$e3035a7e8a739325 = ()=>({
        type: $646de4c164a6d485$export$c60815f29b5cfb6d
    });
const $646de4c164a6d485$export$78aa3108fdac0ac3 = (action)=>{
    switch(action.type){
        case $646de4c164a6d485$export$35aff3ed3a26081d:
            return (0, $lkPj1.addCommentFormExpand)();
        case $646de4c164a6d485$export$3b373f0f7354e781:
            return $646de4c164a6d485$export$db9eae89818590a4(action.payload.commentId);
        case $646de4c164a6d485$export$ae8a4274289f40bb:
            return $646de4c164a6d485$export$e3035a7e8a739325();
        case $646de4c164a6d485$export$256eddbefbf4b2ce:
            return $646de4c164a6d485$export$c3ca6bc94e6e6b5c(action.payload.fieldId);
        case $646de4c164a6d485$export$5834f946a995a2ca:
            return (0, $fYteL.refreshIssueRequest)({
                // todo: swap between soft reload and hard (aka on-demand)
                reason: 'ON_DEMAND'
            });
        default:
            // @ts-expect-error - TS2339 - Property 'type' does not exist on type 'never'.
            throw new Error(`Unhandled external action type: ${action.type}`);
    }
};

});
parcelRegister("fYteL", function(module, exports) {

$parcel$export(module.exports, "FETCH_ISSUE_REQUEST", () => $98506972d7379203$export$afc8565512ebbf99);
$parcel$export(module.exports, "fetchIssueRequest", () => $98506972d7379203$export$ff7cd1a46115d8ca);
$parcel$export(module.exports, "FETCH_ISSUE_SUCCESS", () => $98506972d7379203$export$c32d0e1f370b7914);
$parcel$export(module.exports, "fetchIssueSuccess", () => $98506972d7379203$export$1e39a30e3f37e9d1);
$parcel$export(module.exports, "FETCH_ISSUE_FAILURE", () => $98506972d7379203$export$700ca24f76d5bbe6);
$parcel$export(module.exports, "fetchIssueFailure", () => $98506972d7379203$export$625e6e61fad65793);
$parcel$export(module.exports, "REFRESH_ISSUE_REQUEST", () => $98506972d7379203$export$b48f53bf5b842d57);
$parcel$export(module.exports, "refreshIssueRequest", () => $98506972d7379203$export$ccd0db94940d9159);
$parcel$export(module.exports, "CANCEL_REFRESH_ISSUE_REQUEST", () => $98506972d7379203$export$6b6ca6acd76420d1);
$parcel$export(module.exports, "cancelRefreshIssueRequest", () => $98506972d7379203$export$a7629a657f902cbc);
$parcel$export(module.exports, "REFRESH_ISSUE_SUCCESS", () => $98506972d7379203$export$de11c913f06a7952);
$parcel$export(module.exports, "refreshIssueSuccess", () => $98506972d7379203$export$cbd1c08fb706639c);
$parcel$export(module.exports, "FETCH_FORGE_REQUEST", () => $98506972d7379203$export$36b76b7384d868f3);
$parcel$export(module.exports, "fetchForgeRequest", () => $98506972d7379203$export$6ce2430992033a55);
const $98506972d7379203$export$afc8565512ebbf99 = 'FETCH_ISSUE_REQUEST';
const $98506972d7379203$export$ff7cd1a46115d8ca = ()=>({
        type: $98506972d7379203$export$afc8565512ebbf99
    });
const $98506972d7379203$export$c32d0e1f370b7914 = 'FETCH_ISSUE_SUCCESS';
const $98506972d7379203$export$1e39a30e3f37e9d1 = (entities)=>({
        type: $98506972d7379203$export$c32d0e1f370b7914,
        payload: entities
    });
const $98506972d7379203$export$700ca24f76d5bbe6 = 'FETCH_ISSUE_FAILURE';
const $98506972d7379203$export$625e6e61fad65793 = (failureDescription)=>({
        type: $98506972d7379203$export$700ca24f76d5bbe6,
        payload: failureDescription
    });
const $98506972d7379203$export$b48f53bf5b842d57 = 'REFRESH_ISSUE_REQUEST';
const $98506972d7379203$export$ccd0db94940d9159 = (payload, meta)=>({
        type: $98506972d7379203$export$b48f53bf5b842d57,
        payload: payload,
        meta: meta
    });
const $98506972d7379203$export$6b6ca6acd76420d1 = 'CANCEL_REFRESH_ISSUE_REQUEST';
const $98506972d7379203$export$a7629a657f902cbc = ()=>({
        type: $98506972d7379203$export$6b6ca6acd76420d1
    });
const $98506972d7379203$export$de11c913f06a7952 = 'REFRESH_ISSUE_SUCCESS';
const $98506972d7379203$export$cbd1c08fb706639c = (entities)=>({
        type: $98506972d7379203$export$de11c913f06a7952,
        payload: entities
    });
const $98506972d7379203$export$36b76b7384d868f3 = 'FETCH_FORGE_REQUEST';
const $98506972d7379203$export$6ce2430992033a55 = ()=>({
        type: $98506972d7379203$export$36b76b7384d868f3
    });

});

parcelRegister("lkPj1", function(module, exports) {

$parcel$export(module.exports, "ADD_COMMENT_FORM_EXPAND", () => $2d085d7bc32475e5$export$71d398107e783d48);
$parcel$export(module.exports, "addCommentFormExpand", () => $2d085d7bc32475e5$export$2b19aad250b973d);
$parcel$export(module.exports, "ADD_COMMENT_FORM_COLLAPSE", () => $2d085d7bc32475e5$export$85ff14da4a33157b);
$parcel$export(module.exports, "addCommentFormCollapse", () => $2d085d7bc32475e5$export$835c1049633b19d4);
$parcel$export(module.exports, "ADD_COMMENT_FORM_CANCEL", () => $2d085d7bc32475e5$export$2a743018e170b1c5);
$parcel$export(module.exports, "addCommentFormCancel", () => $2d085d7bc32475e5$export$cbb43c6e2782f713);
$parcel$export(module.exports, "SAVE_COMMENT_RETRY", () => $2d085d7bc32475e5$export$f1da94dd8f2d20f8);
$parcel$export(module.exports, "saveCommentRetry", () => $2d085d7bc32475e5$export$8fe4d7a3b02197cb);
$parcel$export(module.exports, "SAVE_COMMENT_EDIT", () => $2d085d7bc32475e5$export$81e9c11b794a58cd);
$parcel$export(module.exports, "saveCommentEdit", () => $2d085d7bc32475e5$export$854252150d2da91c);
$parcel$export(module.exports, "saveCommentSuccessWithPastedContent", () => $2d085d7bc32475e5$export$74f24e144289c0bf);
$parcel$export(module.exports, "SAVE_COMMENT_REQUEST", () => $2d085d7bc32475e5$export$18d19e9df123c7d4);
$parcel$export(module.exports, "saveCommentRequest", () => $2d085d7bc32475e5$export$180890d02f5569ee);
$parcel$export(module.exports, "SAVE_COMMENT_SUCCESS", () => $2d085d7bc32475e5$export$68a9d3a587260864);
$parcel$export(module.exports, "saveCommentSuccess", () => $2d085d7bc32475e5$export$e25b399b9ba134a2);
$parcel$export(module.exports, "SAVE_COMMENT_FAILURE", () => $2d085d7bc32475e5$export$181640cafd83e422);
$parcel$export(module.exports, "saveCommentFailure", () => $2d085d7bc32475e5$export$c9acef2c154290a0);
$parcel$export(module.exports, "SAVE_COMMENT_CANCEL", () => $2d085d7bc32475e5$export$9188109a1be76d1a);
$parcel$export(module.exports, "saveCommentCancel", () => $2d085d7bc32475e5$export$6971a9cf19e7bff0);
$parcel$export(module.exports, "FETCH_OLDER_COMMENTS_REQUEST", () => $2d085d7bc32475e5$export$8759655e9c2c6d63);
$parcel$export(module.exports, "FETCH_NEWER_COMMENTS_REQUEST", () => $2d085d7bc32475e5$export$d55056f931f514de);
$parcel$export(module.exports, "fetchOlderCommentsRequest", () => $2d085d7bc32475e5$export$89824d2d0989262b);
$parcel$export(module.exports, "fetchNewerCommentsRequest", () => $2d085d7bc32475e5$export$ccf1730684d88fc7);
$parcel$export(module.exports, "FETCH_MORE_COMMENTS_SUCCESS", () => $2d085d7bc32475e5$export$1c31d581a6bc6013);
$parcel$export(module.exports, "fetchMoreCommentsSuccess", () => $2d085d7bc32475e5$export$a06e5ade6af52efd);
$parcel$export(module.exports, "FETCH_MORE_COMMENTS_FAILURE", () => $2d085d7bc32475e5$export$b0ac6cc6abb21a3c);
$parcel$export(module.exports, "fetchMoreCommentsFailure", () => $2d085d7bc32475e5$export$c3ffb947d06519d4);
$parcel$export(module.exports, "FETCH_SORTED_COMMENTS_REQUEST", () => $2d085d7bc32475e5$export$47acda4b8d2cc300);
$parcel$export(module.exports, "fetchSortedCommentsRequest", () => $2d085d7bc32475e5$export$4805c80809193e58);
$parcel$export(module.exports, "FETCH_SORTED_COMMENTS_SUCCESS", () => $2d085d7bc32475e5$export$f72e87877cdff1d3);
$parcel$export(module.exports, "fetchSortedCommentsSuccess", () => $2d085d7bc32475e5$export$248225c0816f92b1);
$parcel$export(module.exports, "fetchSortedCommentsFailure", () => $2d085d7bc32475e5$export$2f204bc36c94722d);
$parcel$export(module.exports, "CHANGE_COMMENT_VISIBILITY", () => $2d085d7bc32475e5$export$27e53ffab4bb4105);
$parcel$export(module.exports, "changeCommentVisibility", () => $2d085d7bc32475e5$export$bdd605e26cb557a);
$parcel$export(module.exports, "EDIT_COMMENT_BEGIN", () => $2d085d7bc32475e5$export$52ec13a9878fb210);
$parcel$export(module.exports, "editCommentBegin", () => $2d085d7bc32475e5$export$b59e3ef618f3f5a4);
$parcel$export(module.exports, "EDIT_COMMENT_COLLAPSE", () => $2d085d7bc32475e5$export$ee24a9af79550b9a);
$parcel$export(module.exports, "editCommentCollapse", () => $2d085d7bc32475e5$export$76f4fdc85b3c4983);
$parcel$export(module.exports, "EDIT_COMMENT_CANCEL", () => $2d085d7bc32475e5$export$34cbc41a86b4aebb);
$parcel$export(module.exports, "editCommentCancel", () => $2d085d7bc32475e5$export$b42a5c3d327fad1a);
$parcel$export(module.exports, "EDIT_COMMENT_UPDATE", () => $2d085d7bc32475e5$export$eae8689994a83d11);
$parcel$export(module.exports, "editCommentUpdate", () => $2d085d7bc32475e5$export$ccfcbe3e4607ec26);
$parcel$export(module.exports, "EDIT_COMMENT_VISIBILITY", () => $2d085d7bc32475e5$export$9a3bec84654d3d8b);
$parcel$export(module.exports, "editCommentVisibility", () => $2d085d7bc32475e5$export$2cbe8c5e21dff6d6);
$parcel$export(module.exports, "EDIT_COMMENT_EVENT_OCCURRED_AT", () => $2d085d7bc32475e5$export$f84d12595d214d0e);
$parcel$export(module.exports, "editCommentEventOccurredAt", () => $2d085d7bc32475e5$export$6b71370b88eec9f);
$parcel$export(module.exports, "DELETE_COMMENT_REQUEST", () => $2d085d7bc32475e5$export$32f9b2d50e470721);
$parcel$export(module.exports, "deleteCommentRequest", () => $2d085d7bc32475e5$export$ed74b3a5f1c036c2);
$parcel$export(module.exports, "DELETE_COMMENT_SUCCESS", () => $2d085d7bc32475e5$export$ad9d0372e68e413d);
$parcel$export(module.exports, "deleteCommentSuccess", () => $2d085d7bc32475e5$export$88e6cb2a45e9c67b);
$parcel$export(module.exports, "DELETE_COMMENT_FAILURE", () => $2d085d7bc32475e5$export$17bfad3338f45e82);
$parcel$export(module.exports, "deleteCommentFailure", () => $2d085d7bc32475e5$export$f1282c6c2bcc0a44);
$parcel$export(module.exports, "SHOW_DELETE_COMMENT_MODAL", () => $2d085d7bc32475e5$export$14760731f36c8fa5);
$parcel$export(module.exports, "showDeleteCommentModal", () => $2d085d7bc32475e5$export$a4e27b77e5b2e1cb);
$parcel$export(module.exports, "DELETE_COMMENT_CANCEL", () => $2d085d7bc32475e5$export$3a3e11677c5cf402);
$parcel$export(module.exports, "deleteCommentCancel", () => $2d085d7bc32475e5$export$bc41e76605cf3270);
$parcel$export(module.exports, "PASTED_INTO_COMMENT_FORM", () => $2d085d7bc32475e5$export$7ef9a590ab69319e);
$parcel$export(module.exports, "pastedIntoCommentForm", () => $2d085d7bc32475e5$export$8ac8e8de3bb0d3);
$parcel$export(module.exports, "SET_COMMENT_ATTACHMENT_IN_PROGRESS", () => $2d085d7bc32475e5$export$ec38bcd617424c64);
$parcel$export(module.exports, "setCommentAttachmentInProgress", () => $2d085d7bc32475e5$export$d7ed3c847a4656f7);
$parcel$export(module.exports, "SET_COMMENT_SCROLL_STATUS", () => $2d085d7bc32475e5$export$f7592333993e8ac2);
$parcel$export(module.exports, "setCommentScrollStatus", () => $2d085d7bc32475e5$export$1dda1a9962bdad5f);

var $f9RL0 = parcelRequire("f9RL0");

var $gIyTt = parcelRequire("gIyTt");
const $2d085d7bc32475e5$export$71d398107e783d48 = 'ADD_COMMENT_FORM_EXPAND';
const $2d085d7bc32475e5$export$2b19aad250b973d = ()=>({
        type: $2d085d7bc32475e5$export$71d398107e783d48
    });
const $2d085d7bc32475e5$export$85ff14da4a33157b = 'ADD_COMMENT_FORM_COLLAPSE';
const $2d085d7bc32475e5$export$835c1049633b19d4 = ()=>({
        type: $2d085d7bc32475e5$export$85ff14da4a33157b
    });
const $2d085d7bc32475e5$export$2a743018e170b1c5 = 'ADD_COMMENT_FORM_CANCEL';
const $2d085d7bc32475e5$export$cbb43c6e2782f713 = ()=>({
        type: $2d085d7bc32475e5$export$2a743018e170b1c5
    });
const $2d085d7bc32475e5$export$f1da94dd8f2d20f8 = 'SAVE_COMMENT_RETRY';
const $2d085d7bc32475e5$export$8fe4d7a3b02197cb = (optimisticId, createdDate, isNewComment)=>({
        type: $2d085d7bc32475e5$export$f1da94dd8f2d20f8,
        payload: {
            optimisticId: optimisticId,
            createdDate: createdDate,
            isNewComment: isNewComment
        }
    });
const $2d085d7bc32475e5$export$81e9c11b794a58cd = 'SAVE_COMMENT_EDIT';
const $2d085d7bc32475e5$export$854252150d2da91c = (optimisticId)=>({
        type: $2d085d7bc32475e5$export$81e9c11b794a58cd,
        payload: {
            optimisticId: optimisticId
        }
    });
const $2d085d7bc32475e5$export$eca5dde908b0cf94 = 'SAVE_COMMENT_SUCCESS_WITH_PASTED_CONTENT';
const $2d085d7bc32475e5$export$74f24e144289c0bf = (comment, pastedContent)=>({
        type: $2d085d7bc32475e5$export$eca5dde908b0cf94,
        payload: {
            comment: comment,
            pastedContent: pastedContent
        }
    });
const $2d085d7bc32475e5$export$18d19e9df123c7d4 = 'SAVE_COMMENT_REQUEST';
const $2d085d7bc32475e5$export$180890d02f5569ee = (comment, analyticsEvent)=>({
        type: $2d085d7bc32475e5$export$18d19e9df123c7d4,
        payload: {
            comment: comment,
            analyticsEvent: analyticsEvent,
            updatedField: (0, $f9RL0.COMMENT)
        }
    });
const $2d085d7bc32475e5$export$68a9d3a587260864 = 'SAVE_COMMENT_SUCCESS';
const $2d085d7bc32475e5$export$e25b399b9ba134a2 = (comment, optimisticId, isNewComment, analyticsEvent, meta, eventOccurredAt, jsdIncidentActivityViewHidden, fullIssueUrl, triggerIncidentSaveCommentFlag)=>({
        type: $2d085d7bc32475e5$export$68a9d3a587260864,
        payload: {
            fieldId: (0, $f9RL0.COMMENT),
            comment: comment,
            optimisticId: optimisticId,
            isNewComment: isNewComment,
            analyticsEvent: analyticsEvent,
            ...(0, $gIyTt.isJsmTimelineEnabled)() ? {
                eventOccurredAt: eventOccurredAt
            } : {},
            ...(0, $gIyTt.isJsmTimelineEnabled)() ? {
                jsdIncidentActivityViewHidden: jsdIncidentActivityViewHidden
            } : {},
            ...(0, $gIyTt.isJsmTimelineEnabled)() && fullIssueUrl ? {
                fullIssueUrl: fullIssueUrl
            } : {},
            ...(0, $gIyTt.isJsmTimelineEnabled)() ? {
                triggerIncidentSaveCommentFlag: triggerIncidentSaveCommentFlag
            } : {}
        },
        meta: meta
    });
const $2d085d7bc32475e5$export$181640cafd83e422 = 'SAVE_COMMENT_FAILURE';
const $2d085d7bc32475e5$export$c9acef2c154290a0 = (payload)=>({
        type: $2d085d7bc32475e5$export$181640cafd83e422,
        payload: payload
    });
const $2d085d7bc32475e5$export$9188109a1be76d1a = 'SAVE_COMMENT_CANCEL';
const $2d085d7bc32475e5$export$6971a9cf19e7bff0 = (optimisticId)=>({
        type: $2d085d7bc32475e5$export$9188109a1be76d1a,
        payload: {
            optimisticId: optimisticId
        }
    });
const $2d085d7bc32475e5$export$8759655e9c2c6d63 = 'FETCH_OLDER_COMMENTS_REQUEST';
const $2d085d7bc32475e5$export$d55056f931f514de = 'FETCH_NEWER_COMMENTS_REQUEST';
const $2d085d7bc32475e5$export$89824d2d0989262b = ()=>({
        type: $2d085d7bc32475e5$export$8759655e9c2c6d63
    });
const $2d085d7bc32475e5$export$ccf1730684d88fc7 = ()=>({
        type: $2d085d7bc32475e5$export$d55056f931f514de
    });
const $2d085d7bc32475e5$export$1c31d581a6bc6013 = 'FETCH_MORE_COMMENTS_SUCCESS';
const $2d085d7bc32475e5$export$a06e5ade6af52efd = (loadedComments)=>({
        type: $2d085d7bc32475e5$export$1c31d581a6bc6013,
        payload: loadedComments
    });
const $2d085d7bc32475e5$export$b0ac6cc6abb21a3c = 'FETCH_MORE_COMMENTS_FAILURE';
const $2d085d7bc32475e5$export$c3ffb947d06519d4 = ()=>({
        type: $2d085d7bc32475e5$export$b0ac6cc6abb21a3c
    });
const $2d085d7bc32475e5$export$47acda4b8d2cc300 = 'FETCH_SORTED_COMMENTS_REQUEST';
const $2d085d7bc32475e5$export$4805c80809193e58 = (commentId)=>({
        type: $2d085d7bc32475e5$export$47acda4b8d2cc300,
        payload: commentId
    });
const $2d085d7bc32475e5$export$f72e87877cdff1d3 = 'FETCH_SORTED_COMMENTS_SUCCESS';
const $2d085d7bc32475e5$export$248225c0816f92b1 = (loadedComments)=>({
        type: $2d085d7bc32475e5$export$f72e87877cdff1d3,
        payload: loadedComments
    });
const $2d085d7bc32475e5$export$5ae0e03aaca20486 = 'FETCH_SORTED_COMMENTS_FAILURE';
const $2d085d7bc32475e5$export$2f204bc36c94722d = ()=>({
        type: $2d085d7bc32475e5$export$5ae0e03aaca20486
    });
const $2d085d7bc32475e5$export$27e53ffab4bb4105 = 'CHANGE_COMMENT_VISIBILITY';
const $2d085d7bc32475e5$export$bdd605e26cb557a = (id, isInternal)=>({
        type: $2d085d7bc32475e5$export$27e53ffab4bb4105,
        payload: {
            id: id,
            isInternal: isInternal
        }
    });
const $2d085d7bc32475e5$export$52ec13a9878fb210 = 'EDIT_COMMENT_BEGIN';
const $2d085d7bc32475e5$export$b59e3ef618f3f5a4 = (id, isInternal)=>({
        type: $2d085d7bc32475e5$export$52ec13a9878fb210,
        payload: {
            id: id,
            isInternal: isInternal
        }
    });
const $2d085d7bc32475e5$export$ee24a9af79550b9a = 'EDIT_COMMENT_COLLAPSE';
const $2d085d7bc32475e5$export$76f4fdc85b3c4983 = (id)=>({
        type: $2d085d7bc32475e5$export$ee24a9af79550b9a,
        payload: {
            id: id,
            fieldId: (0, $f9RL0.COMMENT)
        }
    });
const $2d085d7bc32475e5$export$34cbc41a86b4aebb = 'EDIT_COMMENT_CANCEL';
const $2d085d7bc32475e5$export$b42a5c3d327fad1a = (id)=>({
        type: $2d085d7bc32475e5$export$34cbc41a86b4aebb,
        payload: {
            id: id,
            fieldId: (0, $f9RL0.COMMENT)
        }
    });
const $2d085d7bc32475e5$export$eae8689994a83d11 = 'EDIT_COMMENT_UPDATE';
const $2d085d7bc32475e5$export$ccfcbe3e4607ec26 = (id, value)=>({
        type: $2d085d7bc32475e5$export$eae8689994a83d11,
        payload: {
            id: id,
            value: value,
            fieldId: (0, $f9RL0.COMMENT)
        }
    });
const $2d085d7bc32475e5$export$9a3bec84654d3d8b = 'EDIT_COMMENT_VISIBILITY';
const $2d085d7bc32475e5$export$2cbe8c5e21dff6d6 = (id, visibility)=>({
        type: $2d085d7bc32475e5$export$9a3bec84654d3d8b,
        payload: {
            id: id,
            visibility: visibility
        }
    });
const $2d085d7bc32475e5$export$f84d12595d214d0e = 'EDIT_COMMENT_EVENT_OCCURRED_AT';
const $2d085d7bc32475e5$export$6b71370b88eec9f = (id, eventOccurredAt)=>({
        type: $2d085d7bc32475e5$export$f84d12595d214d0e,
        payload: {
            id: id,
            eventOccurredAt: eventOccurredAt
        }
    });
const $2d085d7bc32475e5$export$32f9b2d50e470721 = 'DELETE_COMMENT_REQUEST';
const $2d085d7bc32475e5$export$ed74b3a5f1c036c2 = (id, analyticsEvent)=>({
        type: $2d085d7bc32475e5$export$32f9b2d50e470721,
        payload: {
            id: id,
            analyticsEvent: analyticsEvent,
            updatedField: (0, $f9RL0.COMMENT)
        }
    });
const $2d085d7bc32475e5$export$ad9d0372e68e413d = 'DELETE_COMMENT_SUCCESS';
const $2d085d7bc32475e5$export$88e6cb2a45e9c67b = (id)=>({
        type: $2d085d7bc32475e5$export$ad9d0372e68e413d,
        payload: {
            id: id,
            fieldId: (0, $f9RL0.COMMENT)
        }
    });
const $2d085d7bc32475e5$export$17bfad3338f45e82 = 'DELETE_COMMENT_FAILURE';
const $2d085d7bc32475e5$export$f1282c6c2bcc0a44 = (id)=>({
        type: $2d085d7bc32475e5$export$17bfad3338f45e82,
        payload: id
    });
const $2d085d7bc32475e5$export$14760731f36c8fa5 = 'SHOW_DELETE_COMMENT_MODAL';
const $2d085d7bc32475e5$export$a4e27b77e5b2e1cb = (id)=>({
        type: $2d085d7bc32475e5$export$14760731f36c8fa5,
        payload: id
    });
const $2d085d7bc32475e5$export$3a3e11677c5cf402 = 'DELETE_COMMENT_CANCEL';
const $2d085d7bc32475e5$export$bc41e76605cf3270 = ()=>({
        type: $2d085d7bc32475e5$export$3a3e11677c5cf402
    });
const $2d085d7bc32475e5$export$7ef9a590ab69319e = 'PASTED_INTO_COMMENT_FORM';
const $2d085d7bc32475e5$export$8ac8e8de3bb0d3 = (id, pastedContent)=>({
        type: $2d085d7bc32475e5$export$7ef9a590ab69319e,
        payload: {
            id: id,
            pastedContent: pastedContent
        }
    });
const $2d085d7bc32475e5$export$ec38bcd617424c64 = 'SET_COMMENT_ATTACHMENT_IN_PROGRESS';
const $2d085d7bc32475e5$export$d7ed3c847a4656f7 = (isInProgress)=>({
        type: $2d085d7bc32475e5$export$ec38bcd617424c64,
        payload: {
            isInProgress: isInProgress
        }
    });
const $2d085d7bc32475e5$export$f7592333993e8ac2 = 'SET_COMMENT_SCROLL_STATUS';
const $2d085d7bc32475e5$export$1dda1a9962bdad5f = (status)=>({
        type: $2d085d7bc32475e5$export$f7592333993e8ac2,
        payload: {
            status: status
        }
    });

});
parcelRegister("gIyTt", function(module, exports) {

$parcel$export(module.exports, "isJsmTimelineEnabled", () => $b83585f211a8f289$export$575e1bf822db15b5);

var $1ybV0 = parcelRequire("1ybV0");
const $b83585f211a8f289$export$575e1bf822db15b5 = ()=>(0, $1ybV0.ff)('jsm-timelines-phase-2_70gja', false);

});



const $c4988cef483d4737$export$e2291655ce717023 = 'a';
const $c4988cef483d4737$export$4834da14f7c856f4 = 'l';
const $c4988cef483d4737$export$1303babe27c61a83 = 'm';



parcelRegister("jo9St", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ea91561ccd23692$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxopF = parcelRequire("dxopF");

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $5ESJx = parcelRequire("5ESJx");
var $dQklQ = parcelRequire("dQklQ");

var $gTP9f = parcelRequire("gTP9f");


var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");

var $6ncr6 = parcelRequire("6ncr6");

var $lCKiB = parcelRequire("lCKiB");

var $2vBAO = parcelRequire("2vBAO");

var $eX5Dv = parcelRequire("eX5Dv");

var $6cT4o = parcelRequire("6cT4o");

var $kcet1 = parcelRequire("kcet1");

var $fsbHj = parcelRequire("fsbHj");

var $M8XzP = parcelRequire("M8XzP");

var $lktxx = parcelRequire("lktxx");

var $Gks9z = parcelRequire("Gks9z");

var $grhmQ = parcelRequire("grhmQ");

var $3fH4n = parcelRequire("3fH4n");

var $4v1bH = parcelRequire("4v1bH");

var $6pJnf = parcelRequire("6pJnf");

var $9TuMj = parcelRequire("9TuMj");

var $2emC4 = parcelRequire("2emC4");
const $5ea91561ccd23692$var$Modals = ()=>{
    const isModalOpen = (0, $1gQ73.useBacklogSelector)((0, $lCKiB.makeIsModalOpen));
    const isCompanyManaged = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getIsCompanyManaged));
    const isCardDeleteModalOpen = isModalOpen((0, $ebd52ea7083e351b$export$87c7cb14aa706e2d));
    const isSprintDeleteModalOpen = isModalOpen((0, $ebd52ea7083e351b$export$96d8f8ff51c496e3));
    const isMoveCardsActiveSprintModalOpen = isModalOpen((0, $ebd52ea7083e351b$export$86a0c18887a92eae));
    const isAssignIssueParentModalOpen = isModalOpen((0, $ebd52ea7083e351b$export$9d5b8103d4fbbb34));
    const isGlobalIssueCreateModal = isModalOpen((0, $ebd52ea7083e351b$export$55cae6fd3c958bc5));
    const isSplitIssueModalOpen = isModalOpen((0, $ebd52ea7083e351b$export$77e94846ed2f57d7));
    const isSelectTransitionsModalOpen = isModalOpen((0, $ebd52ea7083e351b$export$dcb8eb3e585ecde));
    const isFlagWithCommentModalOpen = isModalOpen((0, $ebd52ea7083e351b$export$34f52cb2089ddc40));
    const hasAnyIssueTypeWithRequiredFields = (0, $1gQ73.useBacklogSelector)((0, $6ncr6.getHasAnyIssueTypeWithRequireFields));
    const GlobalIssueCreateModalComponent = isCompanyManaged ? (0, $grhmQ.default) : (0, $Gks9z.default);
    const shouldShowWelcomeModal = (0, $79xbN.expValEquals)('jsw_welcome_modal_m2', 'cohort', 'variation') && // eslint-disable-next-line react-hooks/rules-of-hooks
    (!(0, $eI5EY.fg)('pre-check_welcome_modal_showing_condition') || (0, $gTP9f.useShouldShowWelcomeModal)('backlog'));
    return(// div is required here, otherwise backlog layout breaks when a modal pops up
    // eslint-disable-next-line jira/react/no-empty-divs
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ESJx.AsyncScrumOnboardingModal), null), isCardDeleteModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eX5Dv.default), null), isSprintDeleteModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2emC4.default), null), isMoveCardsActiveSprintModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4v1bH.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isAssignIssueParentModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2vBAO.default), null)), (hasAnyIssueTypeWithRequiredFields || isGlobalIssueCreateModal) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(GlobalIssueCreateModalComponent, null), isSplitIssueModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9TuMj.default), null), isSelectTransitionsModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6pJnf.SelectTransitionsModal), null), isFlagWithCommentModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lktxx.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6cT4o.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kcet1.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fsbHj.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $M8XzP.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3fH4n.IssueTransitionModal), null), shouldShowWelcomeModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dQklQ.AsyncWelcomeModal), {
        source: "backlog"
    })));
};
var $5ea91561ccd23692$export$2e2bcd8739ae039 = $5ea91561ccd23692$var$Modals;

});
parcelRegister("5ESJx", function(module, exports) {

$parcel$export(module.exports, "AsyncScrumOnboardingModal", () => $afeb333d095a0efd$export$744c5f72d1694510);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $kMhLP = parcelRequire("kMhLP");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $afeb333d095a0efd$var$LazyScrumOnboardingModal = (0, $7rh0R.lazy)(()=>(parcelRequire("f0r7F")).then(({ ScrumOnboardingModal: ScrumOnboardingModal })=>ScrumOnboardingModal), {
    moduleId: "./src/packages/software/onboarding-modals/src/ui/scrum-onboarding-modal/index.tsx"
});
const $afeb333d095a0efd$export$744c5f72d1694510 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kMhLP.ErrorBoundaryWithChunkErrorLogging), {
        id: "asyncScrumOnboardingModalComponent",
        fallback: "unmount",
        packageName: "jiraSoftwareOnboardingModals",
        teamName: "jlove-makkuro"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "software-onboarding-modals-scrum-onboarding",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($afeb333d095a0efd$var$LazyScrumOnboardingModal, null)));

});
parcelRegister("f0r7F", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('iR79G')
        ]);
        const value = parcelRequire('dC27m');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("iR79G")
    ]).then(()=>parcelRequire('dC27m'));
}

});


parcelRegister("dQklQ", function(module, exports) {

$parcel$export(module.exports, "AsyncWelcomeModal", () => $dfcf260091c99929$export$d08881a6c29dfdb2);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $kMhLP = parcelRequire("kMhLP");

var $gGtKh = parcelRequire("gGtKh");

var $jK1pm = parcelRequire("jK1pm");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $dfcf260091c99929$var$LazyWelcomeModal = (0, $7rh0R.lazy)(()=>(parcelRequire("ddonq")).then(({ WelcomeModal: WelcomeModal })=>WelcomeModal), {
    moduleId: "./src/packages/software/onboarding-modals/src/ui/welcome-modal/index.tsx"
});
const $dfcf260091c99929$export$d08881a6c29dfdb2 = ({ source: source })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "async-onboarding-welcome-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kMhLP.ErrorBoundaryWithChunkErrorLogging), {
        id: "asyncWelcomeModalComponent",
        fallback: "unmount",
        packageName: "jiraSoftwareOnboardingModals",
        teamName: "jlove-makkuro"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "software-onboarding-modals-welcome-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dfcf260091c99929$var$LazyWelcomeModal, {
        source: source
    }))));

});
parcelRegister("ddonq", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('lEfSG')
        ]);
        const value = parcelRequire('gcXcS');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("lEfSG")
    ]).then(()=>parcelRequire('gcXcS'));
}

});


parcelRegister("gTP9f", function(module, exports) {

$parcel$export(module.exports, "useShouldShowModalBasedOnSessionStorage", () => $cfd93d08d63b3236$export$b39cbd941f378bec);
$parcel$export(module.exports, "useJiraFamiliairtyFromSessionStorage", () => $cfd93d08d63b3236$export$605e7655be24115);
$parcel$export(module.exports, "useShouldShowWelcomeModal", () => $cfd93d08d63b3236$export$b01115c2f75a04f8);

var $eUqFw = parcelRequire("eUqFw");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $8LJqN = parcelRequire("8LJqN");

var $eI5EY = parcelRequire("eI5EY");

var $lkBAJ = parcelRequire("lkBAJ");



var $2Dd39 = parcelRequire("2Dd39");
const $cfd93d08d63b3236$var$isInWelcomeModalVariationCohort = ()=>{
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_welcome_modal_m2');
    return expConfig.get('cohort', 'not-enrolled') === 'variation';
};
const $cfd93d08d63b3236$var$useJiraFamiliairtyFromSessionStorageExists = ()=>{
    const sessionStorageExists = (0, $eUqFw.useMemo)(()=>{
        const sessionStorageVal = (0, $lkBAJ.sessionStorage).get((0, $f4b45fc38eac38b9$export$aa0fb8698c5d30e3));
        if (sessionStorageVal === undefined) return false;
        (0, $lkBAJ.sessionStorage).remove((0, $f4b45fc38eac38b9$export$aa0fb8698c5d30e3));
        return true;
    }, []);
    return sessionStorageExists;
};
const $cfd93d08d63b3236$export$b39cbd941f378bec = ()=>{
    const shouldShowModalBasedOnSessionStorage = (0, $eUqFw.useMemo)(()=>{
        if (!$cfd93d08d63b3236$var$isInWelcomeModalVariationCohort()) return false;
        const sessionStorageVal = (0, $lkBAJ.sessionStorage).get((0, $8379f5d78bf6fb5a$export$e3884212029f7bef));
        if (sessionStorageVal === undefined) return false;
        if (!(0, $eI5EY.fg)('fix_welcome_modal_in_strict_mode_')) (0, $lkBAJ.sessionStorage).remove((0, $8379f5d78bf6fb5a$export$e3884212029f7bef));
        return true;
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        // Remove the session storage value to prevent the modal showing again
        if ((0, $eI5EY.fg)('fix_welcome_modal_in_strict_mode_')) (0, $lkBAJ.sessionStorage).remove((0, $8379f5d78bf6fb5a$export$e3884212029f7bef));
    }, []);
    return shouldShowModalBasedOnSessionStorage;
};
const $cfd93d08d63b3236$export$605e7655be24115 = (0, $8LJqN.functionWithCondition)(()=>(0, $1ybV0.ff)('jfind_update_project_name_and_jira_familiarity'), $cfd93d08d63b3236$var$useJiraFamiliairtyFromSessionStorageExists, ()=>false);
const $cfd93d08d63b3236$export$b01115c2f75a04f8 = (source)=>{
    const canShowNudgeTour = (0, $2Dd39.useCanShowNudgeTour)();
    const sessionStorageVal = (0, $eUqFw.useMemo)(()=>(0, $lkBAJ.sessionStorage).get((0, $8379f5d78bf6fb5a$export$e3884212029f7bef)), []);
    if (sessionStorageVal === undefined) return false;
    return canShowNudgeTour(source);
};

});
// ATLAS-63098
const $f4b45fc38eac38b9$export$aa0fb8698c5d30e3 = 'jira-familiarity';

parcelRegister("2Dd39", function(module, exports) {

$parcel$export(module.exports, "useCanShowNudgeTour", () => $47acbefa3aefafad$export$3381da528a252680);

var $7dRgX = parcelRequire("7dRgX");
var $5cLMB = parcelRequire("5cLMB");
const $47acbefa3aefafad$export$3381da528a252680 = ()=>{
    const [completedTaskList] = (0, $5cLMB.useCompletedTaskList)();
    const [shouldShowScrumOnboardingExperience] = (0, $5cLMB.useShouldShowScrumOnboardingExperience)();
    const [shouldShowOnboardingKanbanTour] = (0, $5cLMB.useShouldShowOnboardingKanbanTour)();
    const shouldShowOnboardingScrumTour = shouldShowScrumOnboardingExperience === true && // edge case for KURO-2088: After welcome modal failed to load, users complete welcome tour by themselves. Welcome modal should be skipped to load on refreshment.
    !completedTaskList.includes((0, $7dRgX.SCRUM_ONBOARDING_TASK));
    return (source)=>{
        switch(source){
            case 'board':
                return shouldShowOnboardingKanbanTour;
            case 'backlog':
                return shouldShowOnboardingScrumTour;
            case 'timeline':
                // display if eligible for either board/backlog scenarios
                return shouldShowOnboardingKanbanTour || shouldShowOnboardingScrumTour;
            default:
                return false;
        }
    };
};

});


parcelRegister("2vBAO", function(module, exports) {

$parcel$export(module.exports, "default", () => $66ddbf9ec64f1344$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $dRH1v = parcelRequire("dRH1v");



var $1gQ73 = parcelRequire("1gQ73");

var $6apxJ = parcelRequire("6apxJ");

var $cbRhO = parcelRequire("cbRhO");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $22cnO = parcelRequire("22cnO");

var $k734R = parcelRequire("k734R");

var $lCKiB = parcelRequire("lCKiB");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $66ddbf9ec64f1344$var$AssignIssueParentModal = (0, $7rh0R.lazy)(()=>(parcelRequire("f5mhf")), {
    moduleId: "./src/packages/assign-issue-parent-modal/src/index.tsx"
});
function $66ddbf9ec64f1344$export$2e2bcd8739ae039() {
    const modalData = (0, $1gQ73.useBacklogSelector)((0, $lCKiB.getOpenModalData));
    const issues = (0, $1gQ73.useBacklogSelector)((state)=>modalData && modalData.type === (0, $ebd52ea7083e351b$export$9d5b8103d4fbbb34) ? (0, $bP7Jx.partialCardsFromCardIdsSelector)(state)(modalData.payload.cardIds) : []);
    const issueParents = (0, $1gQ73.useBacklogSelector)((0, $k734R.partialIssueParentSelector));
    const issueParentTypeIds = (0, $1gQ73.useBacklogSelector)((0, $k734R.issueParentTypeIdsSelector));
    const issueHierarchyLevel = (0, $1gQ73.useBacklogSelector)((0, $k734R.issueHierarchyLevelSelector))();
    const parentIssueTypeName = (0, $1gQ73.useBacklogSelector)((0, $k734R.firstParentIssueTypeNameSelector));
    const firstLevelHierarchyName = (0, $1gQ73.useBacklogSelector)((0, $22cnO.getFirstLevelHierarchyName));
    const baseUrl = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getBaseUrl));
    const currentProjectId = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.projectIdSelector));
    const projectIds = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getProjectIds));
    const isCompanyManaged = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getIsCompanyManaged));
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const onClose = (0, $1gQ73.useBacklogActionCreator)((0, $cbRhO.closeModal));
    const label = isCompanyManaged ? firstLevelHierarchyName : parentIssueTypeName;
    const onSubmit = (cards, parentId, issueParent, requestPromise)=>{
        dispatch((0, $6apxJ.cardsParentSetOptimistic)({
            cards: // @ts-expect-error - TS2322 - Type 'Issue[]' is not assignable to type 'PartialCard[]'.
            cards,
            parentId: // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'number | null'.
            parentId,
            requestPromise: requestPromise
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRH1v.AssignIssueParentModalBoundary), {
        packageName: (0, $e1409a6fc345c0d8$export$dfd208682d29484c)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($66ddbf9ec64f1344$var$AssignIssueParentModal, {
        issues: issues,
        issueParents: issueParents,
        issueParentTypeIds: issueParentTypeIds,
        issueHierarchyLevel: issueHierarchyLevel,
        parentIssueTypeName: label,
        baseUrl: baseUrl,
        currentProjectId: currentProjectId,
        projectIds: projectIds,
        onClose: onClose,
        onSubmit: onSubmit,
        isSimplifiedProject: !isCompanyManaged
    }));
}

});
parcelRegister("dRH1v", function(module, exports) {

$parcel$export(module.exports, "AssignIssueParentModalBoundary", () => $442934592c247c59$export$eb6171d83c7b32bb);

var $eUqFw = parcelRequire("eUqFw");

var $cyVXS = parcelRequire("cyVXS");
const $442934592c247c59$export$eb6171d83c7b32bb = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cyVXS.ModalBoundary), {
        id: "assign-issue-parent-modal",
        ...props
    }, children);

});

parcelRegister("f5mhf", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('5Xulb')
        ]);
        const value = parcelRequire('3RLUO');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("5Xulb")
    ]).then(()=>parcelRequire('3RLUO'));
}

});


parcelRegister("eX5Dv", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e2a79ee5a1d01c9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $jPfP5 = parcelRequire("jPfP5");

var $kGQen = parcelRequire("kGQen");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $k3YqD = parcelRequire("k3YqD");


var $1gQ73 = parcelRequire("1gQ73");

var $c4hFt = parcelRequire("c4hFt");

var $cbRhO = parcelRequire("cbRhO");

var $bP7Jx = parcelRequire("bP7Jx");

var $lCKiB = parcelRequire("lCKiB");

var $1lbKA = parcelRequire("1lbKA");
function $5e2a79ee5a1d01c9$var$CardDeleteModal() {
    const card = (0, $1gQ73.useBacklogSelector)((state)=>{
        const modalData = (0, $lCKiB.getOpenModalData)(state);
        if (!modalData || modalData.type !== (0, $ebd52ea7083e351b$export$87c7cb14aa706e2d)) return null;
        const { payload: { cardId: cardId } } = modalData;
        return cardId ? (0, $bP7Jx.getCards)(state)[String(cardId)] : null;
    });
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    /*
       Should only need to create this once since the modal is closed
       by either confirm or cancel
     */ const analyticsEvent = createAnalyticsEvent({
        actionSubject: 'button',
        action: 'clicked'
    });
    const onDelete = ()=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'confirmButton');
        card && dispatch((0, $c4hFt.cardDeleteRequest)({
            cardId: card.id
        }));
        dispatch((0, $cbRhO.closeModal)());
    };
    const onClose = ()=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'cancelButton');
        dispatch((0, $cbRhO.closeModal)());
    };
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (!card) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k3YqD.ModalDialog), {
        width: 400,
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), {
        appearance: "danger"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $1lbKA.default).title,
        values: {
            cardKey: card.key
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $1lbKA.default).deleteDataPermanentlyWarning)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $1lbKA.default).resolveOrCloseInstead)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jPfP5.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "danger",
        onClick: onDelete
    }, formatMessage((0, $1lbKA.default).delete)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        onClick: onClose
    }, formatMessage((0, $1lbKA.default).cancel)))));
}
function $5e2a79ee5a1d01c9$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa),
        sourceName: "deleteCard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5e2a79ee5a1d01c9$var$CardDeleteModal, null));
}

});
parcelRegister("1lbKA", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffdb3b39a0bdfbb9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ffdb3b39a0bdfbb9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    delete: {
        "id": "backlog.modals.card-delete-modal.delete",
        "defaultMessage": "Delete"
    },
    cancel: {
        "id": "backlog.modals.card-delete-modal.cancel",
        "defaultMessage": "Cancel"
    },
    title: {
        "id": "backlog.modals.card-delete-modal.title",
        "defaultMessage": "Delete {cardKey}?"
    },
    deleteDataPermanentlyWarning: {
        "id": "backlog.modals.card-delete-modal.delete-data-permanently-warning",
        "defaultMessage": "You're about to permanently delete this issue, its comments and attachments, and all of its data."
    },
    resolveOrCloseInstead: {
        "id": "backlog.modals.card-delete-modal.resolve-or-close-instead",
        "defaultMessage": "If you're not sure, you can resolve or close this issue instead."
    }
});

});


parcelRegister("6cT4o", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d1f194e1fd525ae$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gCfLy = parcelRequire("gCfLy");

var $6L3Px = parcelRequire("6L3Px");

var $6j4bv = parcelRequire("6j4bv");

var $3q7Yq = parcelRequire("3q7Yq");
const $3d1f194e1fd525ae$var$entryPointParams = {};
function $3d1f194e1fd525ae$export$2e2bcd8739ae039() {
    const [state, actions] = (0, $6L3Px.useRetros)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $gCfLy.retroCreateModalEntryPoint), $3d1f194e1fd525ae$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        if (state.loadCreateRetroModal) {
            actions.setLoadCreateRetroModal(false);
            entryPointActions.load();
        }
    }, [
        state.loadCreateRetroModal,
        actions,
        entryPointActions
    ]);
    const props = (0, $eUqFw.useMemo)(()=>({}), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3q7Yq.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        entryPointActions: entryPointActions,
        id: "jira-confluence-sprint-retro-create-modal",
        packageName: "jira-confluence-sprint-retro-create-modal",
        teamName: "mdt-zora",
        runtimeProps: props
    });
}

});
parcelRegister("gCfLy", function(module, exports) {

$parcel$export(module.exports, "retroCreateModalEntryPoint", () => $8ffb6572e6329287$export$5475eb8732086597);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $8ffb6572e6329287$export$5475eb8732086597 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("cFZ1n")), {
        moduleId: "5e0982c9"
    }),
    getPreloadProps: (_params)=>({
            queries: {}
        })
});

});
parcelRegister("cFZ1n", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('8TYdh')
        ]);
        const value = parcelRequire('2xg6e');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("8TYdh")
    ]).then(()=>parcelRequire('2xg6e'));
}

});



parcelRegister("kcet1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e583488daf3250da$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9Mk7t = parcelRequire("9Mk7t");

var $6L3Px = parcelRequire("6L3Px");

var $6j4bv = parcelRequire("6j4bv");

var $3q7Yq = parcelRequire("3q7Yq");

const $e583488daf3250da$var$entryPointParams = {};
function $e583488daf3250da$export$2e2bcd8739ae039() {
    const [state, actions] = (0, $6L3Px.useRetros)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $9Mk7t.confluenceCrossFlowModalEntryPoint), $e583488daf3250da$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        if (state.loadCrossFlowModal) {
            actions.setLoadCrossFlowModal(false);
            entryPointActions.load();
        }
    }, [
        state.loadCrossFlowModal,
        entryPointActions,
        actions
    ]);
    const onClose = (0, $eUqFw.useCallback)(()=>{
        actions.resetState();
    }, [
        actions
    ]);
    const onComplete = ({ success: success })=>{
        if (success) window.location.reload();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3q7Yq.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        entryPointActions: entryPointActions,
        id: "jira-confluence-cross-flow-modal",
        packageName: "jira-confluence-cross-flow-modal",
        teamName: "Confluence - Better Together",
        runtimeProps: {
            onClose: onClose,
            onComplete: onComplete,
            embeddedConfluenceSource: (0, $1b2c5e0fcb49d7fc$export$d7568f1916ebda24),
            crossFlowSource: (0, $262736d97f049d42$export$ae844fca2858b7c4)
        }
    }));
}

});
parcelRegister("9Mk7t", function(module, exports) {

$parcel$export(module.exports, "confluenceCrossFlowModalEntryPoint", () => $8f02693c8a984d54$export$d147ed79220ebf4);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $8f02693c8a984d54$export$d147ed79220ebf4 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("gobUU")), {
        moduleId: "75f5e774"
    }),
    getPreloadProps: (_params)=>({
            queries: {}
        })
});

});
parcelRegister("gobUU", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('6tMDT')
        ]);
        const value = parcelRequire('1byQX');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("6tMDT")
    ]).then(()=>parcelRequire('1byQX'));
}

});


const $1b2c5e0fcb49d7fc$export$f19c4e560a68c416 = 'jiraIssueView';
const $1b2c5e0fcb49d7fc$export$2e6ff5d53a830129 = 'jiraIssueViewLinkedMentionedPage';
const $1b2c5e0fcb49d7fc$export$2d990bc8cd668ca1 = 'jiraIssueViewQuickAddItem';
const $1b2c5e0fcb49d7fc$export$d3566448206b58e = 'jiraIssueViewLinkConfluencePage';
const $1b2c5e0fcb49d7fc$export$c257b3d4e328f4ba = 'jiraIssueViewLengthyDescriptionMessage';
const $1b2c5e0fcb49d7fc$export$d7568f1916ebda24 = 'jiraSoftwareBacklogEndOfSprintRetro';

const $262736d97f049d42$export$ae844fca2858b7c4 = 'Retro';
const $262736d97f049d42$export$bda5d6727c30cf36 = 'JiraIssueCreateContent';


parcelRegister("fsbHj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c18eb039f75fd13$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1yNSv = parcelRequire("1yNSv");


var $6L3Px = parcelRequire("6L3Px");

var $6j4bv = parcelRequire("6j4bv");

var $3q7Yq = parcelRequire("3q7Yq");
const $9c18eb039f75fd13$var$entryPointParams = {};
const $9c18eb039f75fd13$var$CROSS_JOIN_SOURCE = 'Retro';
function $9c18eb039f75fd13$export$2e2bcd8739ae039() {
    const [state, actions] = (0, $6L3Px.useRetros)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $1yNSv.confluenceCrossJoinModalEntryPoint), $9c18eb039f75fd13$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        if (state.loadCrossJoinModal) {
            actions.setLoadCrossJoinModal(false);
            entryPointActions.load();
        }
    }, [
        state.loadCrossJoinModal,
        entryPointActions,
        actions
    ]);
    const onComplete = (0, $eUqFw.useCallback)(({ directJoinSuccess: directJoinSuccess })=>{
        if (directJoinSuccess) actions.setLoadCreateRetroModal(true);
    }, [
        actions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3q7Yq.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        entryPointActions: entryPointActions,
        id: "jira-confluence-cross-join-modal",
        packageName: "jira-confluence-cross-join-modal",
        teamName: "Confluence - Better Together",
        runtimeProps: {
            onComplete: onComplete,
            embeddedConfluenceSource: (0, $affbbac26879a13e$export$5cdbf483845e61aa),
            crossJoinSource: $9c18eb039f75fd13$var$CROSS_JOIN_SOURCE
        }
    });
}

});
parcelRegister("1yNSv", function(module, exports) {

$parcel$export(module.exports, "confluenceCrossJoinModalEntryPoint", () => $012a0159e0296d85$export$6b94fb5b310ef3e1);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $012a0159e0296d85$export$6b94fb5b310ef3e1 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("3Qf9I")), {
        moduleId: "8339c23d"
    }),
    getPreloadProps: (_params)=>({
            queries: {}
        })
});

});
parcelRegister("3Qf9I", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('4P7wk')
        ]);
        const value = parcelRequire('cd8jM');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("4P7wk")
    ]).then(()=>parcelRequire('cd8jM'));
}

});


const $affbbac26879a13e$export$5cdbf483845e61aa = 'jiraSprintCompletion';


parcelRegister("M8XzP", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c368c372781573e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $inoTu = parcelRequire("inoTu");

var $6L3Px = parcelRequire("6L3Px");

var $6j4bv = parcelRequire("6j4bv");

var $3q7Yq = parcelRequire("3q7Yq");

var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");
const $0c368c372781573e$var$entryPointParams = {};
function $0c368c372781573e$export$2e2bcd8739ae039() {
    const projectKey = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getProjectKey));
    const rapidViewId = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getRapidViewId));
    const isCompanyManaged = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getIsCompanyManaged));
    const [state, actions] = (0, $6L3Px.useRetros)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $inoTu.retroPublishedModalEntryPoint), $0c368c372781573e$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        if (state.isRetroPublished) {
            entryPointActions.load();
            actions.setIsRetroPublished(false);
        }
    }, [
        state.isRetroPublished,
        entryPointActions,
        actions
    ]);
    const props = (0, $eUqFw.useMemo)(()=>({
            projectKey: projectKey,
            rapidViewId: rapidViewId,
            isCompanyManaged: isCompanyManaged
        }), [
        projectKey,
        rapidViewId,
        isCompanyManaged
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3q7Yq.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        entryPointActions: entryPointActions,
        id: "jira-confluence-sprint-retro-published-modal",
        packageName: "jira-confluence-sprint-retro-published-modal",
        teamName: "mdt-zora",
        runtimeProps: props
    }));
}

});
parcelRegister("inoTu", function(module, exports) {

$parcel$export(module.exports, "retroPublishedModalEntryPoint", () => $00e9bd53ebfccc5f$export$46f503ee10ceb3cd);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $00e9bd53ebfccc5f$export$46f503ee10ceb3cd = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("Ik0Kg")), {
        moduleId: "250e60a4"
    }),
    getPreloadProps: (_params)=>({
            queries: {}
        })
});

});
parcelRegister("Ik0Kg", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dIUhw');
        const value = parcelRequire('bXs5D');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dIUhw").then(()=>parcelRequire('bXs5D'));
}

});



parcelRegister("lktxx", function(module, exports) {

$parcel$export(module.exports, "default", () => $03f88fe405cbaf76$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");


var $1gQ73 = parcelRequire("1gQ73");

var $1NOG0 = parcelRequire("1NOG0");

var $cbRhO = parcelRequire("cbRhO");

var $lCKiB = parcelRequire("lCKiB");

var $elsza = parcelRequire("elsza");
const $03f88fe405cbaf76$var$useFlagWithCommentState = ()=>({
        modalData: (0, $1gQ73.useBacklogSelector)((0, $lCKiB.getOpenModalData))
    });
const $03f88fe405cbaf76$var$useFlagWithCommentActions = ()=>{
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    /*
      Should only need to create this once since the modal is closed
      by either confirm or cancel
    */ const modalAnalyticsEvent = createAnalyticsEvent({
        actionSubject: 'button',
        action: 'clicked'
    });
    const onClose = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(modalAnalyticsEvent, 'cancelButton');
        dispatch((0, $cbRhO.closeModal)());
    }, [
        dispatch,
        modalAnalyticsEvent
    ]);
    const onFlagWithComment = (0, $eUqFw.useCallback)((cards, flag, comment)=>{
        (0, $jMP2a.fireUIAnalytics)(modalAnalyticsEvent, 'confirmButton');
        const requestAnalyticsEvent = createAnalyticsEvent({
            actionSubject: 'cards',
            action: 'flagged'
        });
        dispatch((0, $1NOG0.cardsFlagWithCommentRequest)({
            cards: cards,
            flag: flag,
            comment: comment
        }, requestAnalyticsEvent));
        dispatch((0, $cbRhO.closeModal)());
    }, [
        dispatch,
        modalAnalyticsEvent,
        createAnalyticsEvent
    ]);
    return {
        onClose: onClose,
        onFlagWithComment: onFlagWithComment
    };
};
const $03f88fe405cbaf76$var$FlagWithComment = ()=>{
    const { modalData: modalData } = $03f88fe405cbaf76$var$useFlagWithCommentState();
    const { onClose: onClose, onFlagWithComment: onFlagWithComment } = $03f88fe405cbaf76$var$useFlagWithCommentActions();
    if (modalData?.type !== (0, $ebd52ea7083e351b$export$34f52cb2089ddc40)) return null;
    const { flagAction: flagAction, cards: cards } = modalData.payload;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elsza.FlagWithCommentRenderer), {
        flagAction: flagAction,
        cards: cards,
        onClose: onClose,
        onFlagWithComment: onFlagWithComment
    });
};
function $03f88fe405cbaf76$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa),
        sourceName: "flagCardsWithCommentBacklog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($03f88fe405cbaf76$var$FlagWithComment, null));
}

});
parcelRegister("elsza", function(module, exports) {

$parcel$export(module.exports, "FlagWithCommentRenderer", () => $0eea38f30c503a21$export$5bed0e93a95d2e33);
// eslint-disable-next-line jira/restricted/react-lazy

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $dxopF = parcelRequire("dxopF");

var $0cdA8 = parcelRequire("0cdA8");

const $0eea38f30c503a21$var$FlagWithComment = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("9WkO2")), {
    moduleId: "./src/packages/software/add-comment-on-flag-action/src/index.tsx"
});
const $0eea38f30c503a21$export$5bed0e93a95d2e33 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "backlog-flag-with-comment-modal",
        packageName: "jira-software-backlog",
        teamName: "a4t-tanuki",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.LazySuspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0eea38f30c503a21$var$FlagWithComment, props))));

});
parcelRegister("9WkO2", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('1evbK')
        ]);
        const value = parcelRequire('llOKB');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("1evbK")
    ]).then(()=>parcelRequire('llOKB'));
}

});



parcelRegister("Gks9z", function(module, exports) {

$parcel$export(module.exports, "default", () => $b27e5a0d1122df1d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $gZhLE = parcelRequire("gZhLE");

var $huI7r = parcelRequire("huI7r");

var $jMP2a = parcelRequire("jMP2a");

var $FUqnt = parcelRequire("FUqnt");



var $1gQ73 = parcelRequire("1gQ73");

var $cbRhO = parcelRequire("cbRhO");

var $hkGxG = parcelRequire("hkGxG");

var $9iryK = parcelRequire("9iryK");

var $lCKiB = parcelRequire("lCKiB");
const $b27e5a0d1122df1d$var$GlobalIssueCreate = ()=>{
    const data = (0, $1gQ73.useBacklogSelector)((state)=>{
        const modalData = (0, $lCKiB.getOpenModalData)(state);
        if (!modalData || modalData.type !== (0, $ebd52ea7083e351b$export$55cae6fd3c958bc5)) return {
            fields: null,
            disableCreationSuccessFlag: true,
            sourceName: (0, $e1409a6fc345c0d8$export$840e3848643f7781)
        };
        return {
            fields: (0, $9iryK.getPrefilledFieldsFromInputs)(state),
            disableCreationSuccessFlag: true,
            sourceName: (0, $e1409a6fc345c0d8$export$840e3848643f7781),
            submitErrorMessage: (0, $9iryK.getSubmitErrorMessage)(state),
            sessionId: (0, $9iryK.getSessionIdFromInputs)(state)
        };
    });
    const cloudId = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getCloudId));
    const boardId = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getRapidViewId));
    const closeModalAction = (0, $1gQ73.useBacklogActionCreator)((0, $cbRhO.closeModal));
    const onCreateSuccess = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        closeModalAction();
        (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'issueWithRequiredFields created', {
            createdMultipleIssues: analyticsEvent.payload.createdMultipleIssues
        });
    }, [
        closeModalAction
    ]);
    const onCancel = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        closeModalAction();
        (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'issueWithRequiredFields cancelled', {});
    }, [
        closeModalAction
    ]);
    const [queryReference, loadQuery] = (0, $iWLL0.useQueryLoader)((0, $FUqnt.default));
    (0, $eUqFw.useEffect)(()=>{
        loadQuery({
            boardId: (0, $huI7r.createAri)({
                resourceOwner: 'jira-software',
                cloudId: cloudId,
                resourceType: 'board',
                resourceId: String(boardId)
            })
        }, {
            fetchPolicy: 'store-or-network'
        });
    }, [
        boardId,
        cloudId,
        loadQuery
    ]);
    return queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gZhLE.default), {
        ...data,
        onCancel: onCancel,
        onCreateSuccess: onCreateSuccess,
        queryReference: queryReference
    }) : null;
};
var $b27e5a0d1122df1d$export$2e2bcd8739ae039 = $b27e5a0d1122df1d$var$GlobalIssueCreate;

});
parcelRegister("gZhLE", function(module, exports) {

$parcel$export(module.exports, "default", () => $026b8196d359969b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $026b8196d359969b$var$LazyGICTrigger = (0, $7rh0R.lazy)(()=>(parcelRequire("joQzJ")), {
    moduleId: "./src/packages/software/jsw-adapted-global-issue-create-trigger/src/index.tsx"
});
const $026b8196d359969b$var$AsyncJswAdaptedGlobalIssueCreateTrigger = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-gicTrigger",
        teamName: "a4t-pandora",
        packageName: "jiraJswAdaptedGlobalIssueCreateTrigger"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsw-adapted-gic-trigger",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($026b8196d359969b$var$LazyGICTrigger, props)));
var $026b8196d359969b$export$2e2bcd8739ae039 = $026b8196d359969b$var$AsyncJswAdaptedGlobalIssueCreateTrigger;

});
parcelRegister("joQzJ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('67N5Q');
        const value = parcelRequire('5sLgz');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("67N5Q").then(()=>parcelRequire('5sLgz'));
}

});


parcelRegister("FUqnt", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cefc0370094e8b8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b7ef3dd78f617ba20e117903caea5f68>>
 * @relayHash dff560da6b44e8698cb7db6cce996d50
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ec8ebec42ce3a627014ff3055a722125ee7a7a44b01f69e101974c5c5fe01543
const $6cefc0370094e8b8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isCMP"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        },
        {
            "kind": "Variable",
            "name": "isCMP",
            "variableName": "isCMP"
        }
    ], v2 = {
        "concreteType": "GlobalCardCreateAdditionalFields",
        "kind": "LinkedField",
        "name": "globalCardCreateAdditionalFields",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "sprintCustomFieldId"
            },
            {
                "kind": "ScalarField",
                "name": "rankCustomFieldId"
            },
            {
                "kind": "ScalarField",
                "name": "boardIssueListKey"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "triggerWithCustomFieldsJSWGlobalIssueCreateQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            v2 /*: any*/ 
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "triggerWithCustomFieldsJSWGlobalIssueCreateQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ec8ebec42ce3a627014ff3055a722125ee7a7a44b01f69e101974c5c5fe01543",
            "metadata": {},
            "name": "triggerWithCustomFieldsJSWGlobalIssueCreateQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6cefc0370094e8b8$var$node.hash = "96d35f31f30c5edc94e3d721f9444ea0";
var $6cefc0370094e8b8$export$2e2bcd8739ae039 = $6cefc0370094e8b8$var$node;

});

parcelRegister("9iryK", function(module, exports) {

$parcel$export(module.exports, "getPrefilledFieldsFromInputs", () => $7aee54cbeb521309$export$819256f3c3cb490a);
$parcel$export(module.exports, "getSessionIdFromInputs", () => $7aee54cbeb521309$export$1f4921affea1cade);
$parcel$export(module.exports, "getSubmitErrorMessage", () => $7aee54cbeb521309$export$1facbc353d35a4eb);

var $df4Sl = parcelRequire("df4Sl");

var $ldoFd = parcelRequire("ldoFd");

var $7TyGu = parcelRequire("7TyGu");


var $hkGxG = parcelRequire("hkGxG");

var $h6pBX = parcelRequire("h6pBX");

var $bP7Jx = parcelRequire("bP7Jx");

var $lCKiB = parcelRequire("lCKiB");
const $7aee54cbeb521309$export$819256f3c3cb490a = (0, $df4Sl.createSelector)([
    (0, $lCKiB.getOpenModalData),
    (0, $bP7Jx.getCardLists),
    (0, $hkGxG.projectIdSelector),
    (0, $h6pBX.getAppliedLabelFilters),
    (0, $h6pBX.getMostRecentAssigneeFilter)
], (modalData, cardLists, projectId, appliedLabels, assignee)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(modalData) || modalData?.type !== (0, $ebd52ea7083e351b$export$55cae6fd3c958bc5) || (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(modalData?.payload)) return null;
    const { cardSummary: cardSummary, cardTypeId: cardTypeId, rankBeforeCardId: rankBeforeCardId, cardParentId: cardParentId, cardListId: cardListId, fixVersions: fixVersions } = modalData.payload;
    const parentIssueId = // parentId is 0 when 'issues without epic' filter is selected
    !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(cardParentId) && cardParentId !== 0 ? String(cardParentId) : '';
    const destination = cardLists[cardListId]?.type;
    return {
        projectId: String(projectId),
        issueType: String(cardTypeId),
        summary: cardSummary,
        labels: appliedLabels || [],
        assignee: assignee?.id || '',
        parentIssueId: parentIssueId,
        fixVersions: fixVersions,
        sprintId: destination === (0, $7TyGu.SPRINT) ? cardListId : undefined,
        context: {
            rankBeforeCardId: !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(rankBeforeCardId) ? String(rankBeforeCardId) : null,
            destination: destination
        }
    };
});
const $7aee54cbeb521309$export$1f4921affea1cade = (0, $df4Sl.createSelector)([
    (0, $lCKiB.getOpenModalData)
], (modalData)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(modalData) || modalData?.type !== (0, $ebd52ea7083e351b$export$55cae6fd3c958bc5) || (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(modalData?.payload)) return undefined;
    return modalData?.payload?.sessionId || undefined;
});
const $7aee54cbeb521309$export$1facbc353d35a4eb = (0, $df4Sl.createSelector)([
    (0, $lCKiB.getOpenModalData)
], (modalData)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(modalData) || modalData?.type !== (0, $ebd52ea7083e351b$export$55cae6fd3c958bc5) || (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(modalData?.payload)) return undefined;
    return modalData.payload.submitErrorMessage;
});

});


parcelRegister("grhmQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $abda7cfe2ff2aed4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $abda7cfe2ff2aed4$var$LazyGICTrigger = (0, $7rh0R.lazy)(()=>(parcelRequire("j50g8")), {
    moduleId: "./src/packages/software/backlog/src/view/modals/global-issue-create-cmp/index.tsx"
});
const $abda7cfe2ff2aed4$var$AsyncGlobalIssueCreateCMPTrigger = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-cmp-gicTrigger",
        packageName: "jira-software-backlog",
        teamName: "a4t-tanuki"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "cmp-gic-trigger",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($abda7cfe2ff2aed4$var$LazyGICTrigger, null)));
var $abda7cfe2ff2aed4$export$2e2bcd8739ae039 = $abda7cfe2ff2aed4$var$AsyncGlobalIssueCreateCMPTrigger;

});
parcelRegister("j50g8", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('20ZKn');
        const value = parcelRequire('1719o');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("20ZKn").then(()=>parcelRequire('1719o'));
}

});


parcelRegister("3fH4n", function(module, exports) {

$parcel$export(module.exports, "IssueTransitionModal", () => $ec128193193e865f$export$98b2cbb8ec9c06d8);

var $eUqFw = parcelRequire("eUqFw");

var $1a3la = parcelRequire("1a3la");

var $huI7r = parcelRequire("huI7r");

var $dWLk9 = parcelRequire("dWLk9");

var $1gQ73 = parcelRequire("1gQ73");

var $eISgW = parcelRequire("eISgW");

var $aOwqv = parcelRequire("aOwqv");
const $ec128193193e865f$export$98b2cbb8ec9c06d8 = ()=>{
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const openIssueTransitionModal = (0, $1a3la.useOpenIssueTransitionModal)();
    const onClose = (0, $eUqFw.useCallback)(()=>{
        dispatch((0, $eISgW.closeIssueTransitionModal)());
    }, [
        dispatch
    ]);
    const isOpen = (0, $1gQ73.useBacklogSelector)((state)=>(0, $aOwqv.isIssueTransitionModalOpen)(state));
    const { issueId: issueId = '', issueKey: issueKey = '', transitionId: transitionId = '' } = (0, $1gQ73.useBacklogSelector)((state)=>(0, $aOwqv.getPayloadForIssueTransitionModal)(state));
    const { onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError } = (0, $1gQ73.useBacklogSelector)((state)=>(0, $aOwqv.getHandlersForIssueTransitionModal)(state));
    const cloudId = (0, $dWLk9.useCloudId)();
    const ariIssueId = (0, $huI7r.createAri)({
        resourceOwner: 'jira',
        resourceType: 'issue',
        cloudId: cloudId,
        resourceId: `${issueId}`
    });
    (0, $eUqFw.useEffect)(()=>{
        if (isOpen) {
            const handleDialogCancel = ()=>{
                onDialogCancel?.();
                onClose();
            };
            const handleDialogError = (error)=>{
                onDialogError?.(error);
                onClose();
            };
            const handleDialogSuccess = ()=>{
                onDialogSuccess?.();
                onClose();
            };
            openIssueTransitionModal({
                payload: {
                    issueId: ariIssueId,
                    issueKey: issueKey,
                    transitionId: transitionId
                },
                triggerPointKey: 'issue-transition-board-card-transition',
                onDialogSuccess: handleDialogSuccess,
                onDialogCancel: handleDialogCancel,
                onDialogError: handleDialogError
            });
        }
    }, [
        ariIssueId,
        isOpen,
        issueKey,
        onClose,
        onDialogCancel,
        onDialogError,
        onDialogSuccess,
        openIssueTransitionModal,
        transitionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
};
var $ec128193193e865f$export$2e2bcd8739ae039 = $ec128193193e865f$export$98b2cbb8ec9c06d8;

});
parcelRegister("1a3la", function(module, exports) {

$parcel$export(module.exports, "useOpenIssueTransitionModal", () => $2ec6874397d8d50c$export$736bd10472c63b49);
$parcel$export(module.exports, "useCloseIssueTransitionModal", () => $2ec6874397d8d50c$export$4629f18d511ad32e);
$parcel$export(module.exports, "useTriggerIssueTransitionModal", () => $2ec6874397d8d50c$export$95a1e9702d78f223);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6XOSh = parcelRequire("6XOSh");

var $b3pJg = parcelRequire("b3pJg");

var $5PGkD = parcelRequire("5PGkD");
const $2ec6874397d8d50c$export$736bd10472c63b49 = ()=>{
    const { openIssueTransitionModal: openIssueTransitionModalAction } = (0, $b3pJg.useTriggerIssueTransitionModalActions)();
    const { stateGet: { state: { isEnabled: isEnabled = true } = {} } = {} } = (0, $6XOSh.useIssueTransitionLabsOptIn)();
    return (0, $eUqFw.useCallback)((nextState)=>{
        openIssueTransitionModalAction(nextState, isEnabled);
    }, [
        isEnabled,
        openIssueTransitionModalAction
    ]);
};
const $2ec6874397d8d50c$export$4629f18d511ad32e = ()=>{
    const { closeIssueTransitionModal: closeIssueTransitionModalAction } = (0, $b3pJg.useTriggerIssueTransitionModalActions)();
    const { payload: { issueKey: issueKey, transitionId: transitionId }, onDialogCancel: onDialogCancel, onDialogError: onDialogError, onDialogSuccess: onDialogSuccess } = (0, $b3pJg.useTriggerIssueTransitionModalState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)((shouldOpenLegacyModal = false)=>{
        closeIssueTransitionModalAction();
        if (shouldOpenLegacyModal) {
            const onOpenDialog = ()=>{
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'switch to legacy transition screen');
            };
            (0, $5PGkD.openLegacyIssueTransitionModal)({
                issueKey: issueKey,
                isReopenScenario: true,
                transitionId: transitionId,
                onDialogCancel: onDialogCancel,
                onDialogError: onDialogError,
                onDialogSuccess: onDialogSuccess,
                onOpenDialog: onOpenDialog
            });
        }
    }, [
        closeIssueTransitionModalAction,
        createAnalyticsEvent,
        issueKey,
        onDialogCancel,
        onDialogError,
        onDialogSuccess,
        transitionId
    ]);
};
const $2ec6874397d8d50c$export$95a1e9702d78f223 = ()=>{
    const state = (0, $b3pJg.useTriggerIssueTransitionModalState)();
    const actions = (0, $b3pJg.useTriggerIssueTransitionModalActions)();
    const openIssueTransitionModal = $2ec6874397d8d50c$export$736bd10472c63b49();
    return [
        state,
        {
            ...actions,
            openIssueTransitionModal: openIssueTransitionModal
        }
    ];
};
var $2ec6874397d8d50c$export$2e2bcd8739ae039 = $2ec6874397d8d50c$export$95a1e9702d78f223;

});
parcelRegister("b3pJg", function(module, exports) {

$parcel$export(module.exports, "TriggerIssueTransitionModalContainer", () => $04b7e125a8f2ae4a$export$8ad65e459a406a8a);
$parcel$export(module.exports, "useTriggerIssueTransitionModalActions", () => $04b7e125a8f2ae4a$export$68de001c738e4145);
$parcel$export(module.exports, "useTriggerIssueTransitionModalState", () => $04b7e125a8f2ae4a$export$d3aceeec551eaab5);

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");

var $7iqKZ = parcelRequire("7iqKZ");

var $gtFcb = parcelRequire("gtFcb");
const $04b7e125a8f2ae4a$var$store = (0, $a61MH.createStore)({
    name: 'issue-transition.issue-transition-form.use-trigger-issue-transition-modal',
    initialState: $7iqKZ.initialState,
    actions: $gtFcb
});
const $04b7e125a8f2ae4a$export$8ad65e459a406a8a = (0, $heB5U.createContainer)($04b7e125a8f2ae4a$var$store);
const $04b7e125a8f2ae4a$export$68de001c738e4145 = (0, $ggKAj.createActionsHook)($04b7e125a8f2ae4a$var$store);
const $04b7e125a8f2ae4a$export$d3aceeec551eaab5 = (0, $ggKAj.createStateHook)($04b7e125a8f2ae4a$var$store);

});
parcelRegister("7iqKZ", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $ab6f76333cdb27e5$export$d4c72bab9d6cc13a);

var $hompL = parcelRequire("hompL");

const $ab6f76333cdb27e5$export$d4c72bab9d6cc13a = {
    inProgressTransitionID: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
    isModalOpen: false,
    isSubsequentLoad: false,
    payload: {
        issueId: '',
        issueKey: '',
        transitionId: ''
    },
    id: 'issue-transition-dialog',
    title: null,
    fetchedIssueId: '',
    triggerPointKey: (0, $fa834bef164496cf$export$8d987f6e80b74000),
    onDialogSuccess: null,
    onDialogCancel: null,
    onDialogError: null
};

});
const $fa834bef164496cf$export$ef94a84e2990361c = 'issue-transition-issue-view';
const $fa834bef164496cf$export$de11f84a7d32933b = 'issue-transition-board-card-transition';
const $fa834bef164496cf$export$6c46e4003e7b7e9c = 'issue-transition-advanced-roadmaps-jira-transition';
const $fa834bef164496cf$export$e77cd508fbc3b5ba = 'issue-transition-backlog-inline-transition';
const $fa834bef164496cf$export$4edf4c3eee5081f6 = 'issue-transition-issue-view-shortcut-dialog';
const $fa834bef164496cf$export$27b74e685c26e665 = 'issue-transition-command-palette-status-field-transition';
const $fa834bef164496cf$export$290710ac08f770c0 = 'issue-transition-issue-results-shortcut-transition';
const $fa834bef164496cf$export$ddade13ad1b89bf0 = 'issue-transition-status-field-trigger';
const $fa834bef164496cf$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $fa834bef164496cf$export$2bf0e335b815a90b = 'comment';
const $fa834bef164496cf$export$1b8cc53b37a62399 = 'worklog';
const $fa834bef164496cf$export$d624b8367eb730df = 'issuelinks';


parcelRegister("gtFcb", function(module, exports) {

$parcel$export(module.exports, "closeIssueTransitionModal", () => (parcelRequire("bh2xU")).default);
$parcel$export(module.exports, "openIssueTransitionModal", () => (parcelRequire("kO8vo")).default);
$parcel$export(module.exports, "restoreState", () => (parcelRequire("krvVA")).default);
$parcel$export(module.exports, "setFetchedIssueId", () => (parcelRequire("cqFa9")).default);

var $bh2xU = parcelRequire("bh2xU");

var $kO8vo = parcelRequire("kO8vo");

var $krvVA = parcelRequire("krvVA");

var $cqFa9 = parcelRequire("cqFa9");

});
parcelRegister("bh2xU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8733dbfae9aa86f$export$2e2bcd8739ae039);

var $7iqKZ = parcelRequire("7iqKZ");
const $c8733dbfae9aa86f$var$closeIssueTransitionModal = ()=>({ setState: setState })=>{
        setState({
            ...(0, $7iqKZ.initialState),
            isModalOpen: false,
            isSubsequentLoad: true
        });
    };
var $c8733dbfae9aa86f$export$2e2bcd8739ae039 = $c8733dbfae9aa86f$var$closeIssueTransitionModal;

});

parcelRegister("kO8vo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f64237f09f9bb7e0$export$2e2bcd8739ae039);

var $jG2Eu = parcelRequire("jG2Eu");

var $fzLv5 = parcelRequire("fzLv5");

var $hvjqG = parcelRequire("hvjqG");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $jRlXU = parcelRequire("jRlXU");

var $7ST5U = parcelRequire("7ST5U");
const $f64237f09f9bb7e0$var$openIssueTransitionModal = (nextState, preferNewIssueTransitionScreen = true)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { payload: { issueKey: issueKey = '', transitionId: transitionId = '' }, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, triggerPointKey: triggerPointKey } = nextState || {
            payload: {}
        };
        let transitionModalVersion = '';
        const isNewITSEnabled = (0, $7ST5U.isNewTransitionScreenEnabled)(preferNewIssueTransitionScreen, triggerPointKey);
        try {
            if (isNewITSEnabled) {
                transitionModalVersion = 'NEW';
                (0, $jRlXU.startIssueTransitionMetrics)(currentState.isSubsequentLoad);
                if ((0, $1ybV0.ff)('modernised-issue-transition-iframe-apps-fix_mlwcn')) {
                    const parentWindow = window.parent;
                    const topWindow = window.top;
                    // ? Compare topWindow and parentWindow to check if the current window is in an iframe
                    // ? ref: https://developer.mozilla.org/en-US/docs/Web/API/Window/parent
                    if (parentWindow !== topWindow) parentWindow.postMessage({
                        event: 'openIssueTransitionModal',
                        payload: {
                            payload: nextState?.payload,
                            triggerPointKey: triggerPointKey
                        }
                    });
                    else setState({
                        ...currentState,
                        isModalOpen: true,
                        // making fetchedIssueId as blank to ensure we donot end up using stale issueId
                        fetchedIssueId: '',
                        ...nextState
                    });
                // TODO cleanup else block after removing the ff('modernised-issue-transition-iframe-apps-fix_mlwcn')
                } else setState({
                    ...currentState,
                    isModalOpen: true,
                    // making fetchedIssueId as blank to ensure we donot end up using stale issueId
                    fetchedIssueId: '',
                    ...nextState
                });
            } else {
                transitionModalVersion = 'OLD';
                (0, $hvjqG.timeToRenderTransitionModal).start();
                new (0, $fzLv5.default)({
                    issueKey: issueKey,
                    transitionId: transitionId
                }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))).show();
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'transitionIssueTrigger',
                    packageName: 'jiraIssueTransitionTrigger',
                    teamName: 'gryffindor'
                },
                error: error,
                attributes: {
                    transitionModalVersion: transitionModalVersion
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
var $f64237f09f9bb7e0$export$2e2bcd8739ae039 = $f64237f09f9bb7e0$var$openIssueTransitionModal;

});
parcelRegister("fzLv5", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f25a951ff2b0812$export$2e2bcd8739ae039);

var $jG2Eu = parcelRequire("jG2Eu");

var $2BvS3 = parcelRequire("2BvS3");

var $5zSUY = parcelRequire("5zSUY");

var $hvjqG = parcelRequire("hvjqG");
class $0f25a951ff2b0812$export$2e2bcd8739ae039 {
    constructor({ issueId: issueId, transitionId: transitionId, issueKey: issueKey, issueKeys: issueKeys }){
        this.onDialogSuccessCallback = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
        this.onDialogErrorCallback = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
        this.onDialogCancelCallback = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
        this.issueId = issueId;
        this.transitionId = transitionId;
        this.issueKey = issueKey;
        this.issueKeys = issueKeys;
    }
    static{
        this.onDialogContentReady = ()=>{
            // This event fired by a dialog before the dialog itself is rendered and visible to the user
            // That's why we need to postpone sending the response to the next moment after it became visible
            setTimeout(()=>{
                (0, $hvjqG.timeToRenderTransitionModal).stop();
            });
        };
    }
    onDialogSuccess(onDialogSuccessCallback) {
        this.onDialogSuccessCallback = onDialogSuccessCallback;
        return this;
    }
    onDialogError(onDialogErrorCallback) {
        this.onDialogErrorCallback = onDialogErrorCallback;
        return this;
    }
    onDialogCancel(onDialogCancelCallback) {
        this.onDialogCancelCallback = onDialogCancelCallback;
        return this;
    }
    getIssueParam() {
        if (this.issueId != null) return `id=${this.issueId}`;
        if (this.issueKey != null) return `key=${this.issueKey}`;
        return '';
    }
    getUrl() {
        const { issueKeys: issueKeys } = this;
        if (issueKeys != null) // key= is needed to be sent together with keys= because of legacy API
        return `/secure/BulkTransitionIssue!default.jspa?keys=${issueKeys.join(',')}&key=${issueKeys[0]}&action=${this.transitionId}&atl_token=${(0, $5zSUY.default)() || ''}&decorator=dialog&inline=true&returnUrl=`;
        return `/secure/WorkflowUIDispatcher.jspa?${this.getIssueParam()}&action=${this.transitionId}&atl_token=${(0, $5zSUY.default)() || ''}&returnUrl=`;
    }
    async show() {
        document.addEventListener('legacyJiraDialogContentReady', $0f25a951ff2b0812$export$2e2bcd8739ae039.onDialogContentReady);
        // eslint-disable-next-line jira/wrm/no-load-bridge
        const FormDialog = await (0, $2BvS3.loadBridge)({
            name: 'jira/dialog/form-dialog',
            wrmKeys: 'wrc!jira.webresources:dialogs'
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const dialog = new FormDialog({
            id: 'edit-issue-dialog',
            ajaxOptions: {
                url: this.getUrl(),
                dataType: 'json'
            },
            autoClose: true,
            widthClass: 'large',
            onDialogFinished: this.onDialogSuccessCallback,
            onUnSuccessfulSubmit: this.onDialogErrorCallback,
            shouldLoadHeritageFormDialogContext: true
        });
        const cancelNativeHandler = (event)=>{
            if (!(event instanceof CustomEvent)) return;
            const dialogElement = event.detail.popup;
            const { reason: reason } = event.detail;
            if (dialogElement.is(dialog.get$popup())) {
                if (reason === 'cancel' || reason === 'esc') this.onDialogCancelCallback(event, dialogElement, reason);
                document.removeEventListener('legacyJiraDialogBeforeHide', cancelNativeHandler);
                document.removeEventListener('legacyJiraDialogContentReady', $0f25a951ff2b0812$export$2e2bcd8739ae039.onDialogContentReady);
            }
        };
        document.addEventListener('legacyJiraDialogBeforeHide', cancelNativeHandler);
        dialog.show();
    }
}

});
parcelRegister("hvjqG", function(module, exports) {

$parcel$export(module.exports, "timeToRenderTransitionModal", () => $5364d9ea59150bac$export$9d20a86383e90d09);

var $lNfG4 = parcelRequire("lNfG4");
const $5364d9ea59150bac$export$9d20a86383e90d09 = (0, $lNfG4.metrics).interaction({
    key: 'issue.time-to.render-issue-transition-screen',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '500_1000_2500_4000_7000_10000'
    }
});

});


parcelRegister("jRlXU", function(module, exports) {

$parcel$export(module.exports, "startIssueTransitionMetrics", () => $bd86a98ef7e8a43a$export$3fc439100e136a52);

var $1ybV0 = parcelRequire("1ybV0");

var $3gb01 = parcelRequire("3gb01");
var $67xHO = parcelRequire("67xHO");

var $fy5vB = parcelRequire("fy5vB");

var $duQ8C = parcelRequire("duQ8C");
const $bd86a98ef7e8a43a$export$3fc439100e136a52 = (isSubsequentLoad)=>{
    (0, $3gb01.IssueTransitionLoadUFOExperience).start();
    (0, $3gb01.IssueTransitionUFOExperience).start();
    const issueTransitionModalLoadMetric = isSubsequentLoad ? (0, $67xHO.issueTransittionModalLoadSubsequent) : (0, $67xHO.issueTransitionModalLoad);
    if (isSubsequentLoad) (0, $duQ8C.default)('issue-transition.transition-modal-subsequent');
    else (0, $duQ8C.default)('issue-transition.transition-modal');
    issueTransitionModalLoadMetric.start();
    if ((0, $1ybV0.ff)('ui-modifications-on-issue-transition-view_7z1g0')) (0, $fy5vB.startUimTTI)();
};

});
parcelRegister("3gb01", function(module, exports) {

$parcel$export(module.exports, "IssueTransitionLoadUFOExperience", () => $dda1b5d926efd158$export$8fb308d8abecd81a);
$parcel$export(module.exports, "IssueTransitionSubmitUFOExpereince", () => $dda1b5d926efd158$export$bd3bf8b90a131c50);
$parcel$export(module.exports, "IssueTransitionUFOExperience", () => $dda1b5d926efd158$export$2f3b26e8acf79182);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $dda1b5d926efd158$export$8fb308d8abecd81a = new (0, $kDfSL.UFOExperience)('issue-transition-screen.transition-load', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-load',
    featureFlags: [
        'ui-modifications-on-issue-transition-view_7z1g0'
    ]
});
const $dda1b5d926efd158$export$bd3bf8b90a131c50 = new (0, $kDfSL.UFOExperience)('issue-transition-screen.transition-submit', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-sumbit'
});
const $dda1b5d926efd158$export$2f3b26e8acf79182 = new (0, $kDfSL.UFOExperience)('issue-transition-screen.transition-issue', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-issue'
});

});

parcelRegister("67xHO", function(module, exports) {

$parcel$export(module.exports, "issueTransitionModalLoad", () => $cdba3bd366b58958$export$772fb4a8bd181fd6);
$parcel$export(module.exports, "issueTransittionModalLoadSubsequent", () => $cdba3bd366b58958$export$afa89f024c56a00a);

var $lNfG4 = parcelRequire("lNfG4");
const $cdba3bd366b58958$export$772fb4a8bd181fd6 = (0, $lNfG4.metrics).interaction({
    key: 'issue-transition-modal',
    featureFlags: [
        'ui-modifications-on-issue-transition-view_7z1g0'
    ]
});
const $cdba3bd366b58958$export$afa89f024c56a00a = (0, $lNfG4.metrics).interaction({
    key: 'issue-transition-modal-subsequent',
    featureFlags: [
        'ui-modifications-on-issue-transition-view_7z1g0'
    ]
});

});

parcelRegister("fy5vB", function(module, exports) {

$parcel$export(module.exports, "startUimTTI", () => $cdecbdc0cabe0dc7$export$ae34c17d9cd2c876);
$parcel$export(module.exports, "markIssueTransitionLoaded", () => $cdecbdc0cabe0dc7$export$7cc1bb35860c7c25);
$parcel$export(module.exports, "stopTTI", () => $cdecbdc0cabe0dc7$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $cdecbdc0cabe0dc7$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $cdecbdc0cabe0dc7$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $cdecbdc0cabe0dc7$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $cdecbdc0cabe0dc7$export$d86f4868694f2aa7);

var $lNfG4 = parcelRequire("lNfG4");

var $gGRYc = parcelRequire("gGRYc");
const $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI = (0, $lNfG4.metrics).interaction({
    key: 'ui-modifications-in-issue-transition',
    timings: [
        {
            key: 'issue-transition-tti-delta',
            startMark: 'issue-transition-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        }
    ],
    featureFlags: (0, $gGRYc.TTIFFs)
});
const $cdecbdc0cabe0dc7$export$ae34c17d9cd2c876 = ()=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.start();
};
const $cdecbdc0cabe0dc7$export$7cc1bb35860c7c25 = ()=>$cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.mark('issue-transition-tti');
const $cdecbdc0cabe0dc7$export$30ca4c461fab486c = (customData)=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.stop({
        customData: customData
    });
};
const $cdecbdc0cabe0dc7$export$27f2445288b528c = ()=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.cancel();
};
const $cdecbdc0cabe0dc7$export$7a2709fc1e33401a = ()=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.mark('iframe-load');
};
const $cdecbdc0cabe0dc7$export$cf3893335c93e33b = ()=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.mark('fields-registered');
};
const $cdecbdc0cabe0dc7$export$d86f4868694f2aa7 = ()=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.mark('oninit-resolved');
};

});
parcelRegister("gGRYc", function(module, exports) {

$parcel$export(module.exports, "TTIFFs", () => $05ae9ccc47102fc0$export$c396ba1504d97f3f);
const $05ae9ccc47102fc0$export$c396ba1504d97f3f = [
    'uim-1689-gql-fetch-ui-adjustments_zbqgh'
];

});



parcelRegister("7ST5U", function(module, exports) {

$parcel$export(module.exports, "isNewTransitionScreenEnabled", () => $23d7c4603c0324df$export$1f5b72e7dbe0548d);

var $dfBCt = parcelRequire("dfBCt");

var $1ybV0 = parcelRequire("1ybV0");
const $23d7c4603c0324df$export$3e9c47f2b27760a = (triggerPointKey)=>{
    const triggerPointsFlags = {
        'issue-transition-issue-view': (0, $1ybV0.ff)('issue-transition-issue-view_yq5a8'),
        'issue-transition-issue-view-shortcut-dialog': (0, $1ybV0.ff)('issue-transition-issue-view-shortcut_lv9l3'),
        'issue-transition-board-card-transition': (0, $1ybV0.ff)('issue-transition-board-card-transition_ciq82'),
        'issue-transition-advanced-roadmaps-jira-transition': (0, $1ybV0.ff)('issue-transition-advanced-roadmaps-jira-transition_b1gmi'),
        'issue-transition-command-palette-status-field-transition': (0, $1ybV0.ff)('issue-transition-command-palette-status-field-transition_ddmcl'),
        'issue-transition-issue-results-shortcut-transition': (0, $1ybV0.ff)('issue-transition-issue-results-shortcut-transition_9jznw'),
        'issue-transition-backlog-inline-transition': (0, $1ybV0.ff)('issue-transition-backlog-inline-transition_2mpzc'),
        'issue-transition-status-field-trigger': (0, $1ybV0.ff)('issue-transition-status-field-trigger_ygzr6'),
        'trigger-point-key-not-defined': (0, $1ybV0.ff)('trigger-point-key-not-defined_cixw0')
    };
    return triggerPointsFlags[triggerPointKey];
};
const $23d7c4603c0324df$export$1f5b72e7dbe0548d = (preferNewIssueTransitionScreen, triggerPointKey)=>{
    if ((0, $dfBCt.isFedRamp)()) return true;
    if (!(0, $1ybV0.ff)('render-modern-issue-transition_cxt0z')) return false;
    /* DEFAULT VALUE IS FALSE FOR ANY TRIGGER POINT NOT AVAILABLE IN THE MAP ABOVE
	 *  If trigger key is not present, then by default overall ITS will be false.
	 *  For any new trigger point, it must be necessary to list the trigger point in the map above.
	 *  When we cleanup FF for trigger points, then this should be also removed.
	 */ if (!triggerPointKey || !$23d7c4603c0324df$export$3e9c47f2b27760a(triggerPointKey)) return false;
    return preferNewIssueTransitionScreen || (0, $1ybV0.ff)('issue-transition-customisation-for-srb_0eyvc');
};

});


parcelRegister("krvVA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e2db18eed05b7b$export$2e2bcd8739ae039);
const $a3e2db18eed05b7b$var$restoreState = (stateToRestore)=>({ setState: setState })=>{
        setState(stateToRestore);
    };
var $a3e2db18eed05b7b$export$2e2bcd8739ae039 = $a3e2db18eed05b7b$var$restoreState;

});

parcelRegister("cqFa9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e14702d6ab11f2a$export$2e2bcd8739ae039);
/**
 *
 * @deprecated since we should not be using this in the log run
 * we should not call this method any where and should clean this up as soon as GIC-JIS migration is done
 * @param issueId
 * @returns
 */ const $3e14702d6ab11f2a$var$setFetchedIssueId = (issueId)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { fetchedIssueId: fetchedIssueId } = currentState;
        if (issueId !== fetchedIssueId) setState({
            ...currentState,
            fetchedIssueId: issueId
        });
    };
var $3e14702d6ab11f2a$export$2e2bcd8739ae039 = $3e14702d6ab11f2a$var$setFetchedIssueId;

});



parcelRegister("5PGkD", function(module, exports) {

$parcel$export(module.exports, "openLegacyIssueTransitionModal", () => $4268b8c0f6eff38c$export$6bfef2005bd55204);

var $jG2Eu = parcelRequire("jG2Eu");

var $fzLv5 = parcelRequire("fzLv5");

var $hvjqG = parcelRequire("hvjqG");

var $guiFP = parcelRequire("guiFP");
const $4268b8c0f6eff38c$export$6bfef2005bd55204 = ({ issueKey: issueKey, transitionId: transitionId, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, isReopenScenario: isReopenScenario = false, onOpenDialog: onOpenDialog })=>{
    try {
        (0, $hvjqG.timeToRenderTransitionModal).start();
        new (0, $fzLv5.default)({
            issueKey: issueKey,
            transitionId: transitionId
        }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))).show();
        onOpenDialog?.();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'transitionIssueTrigger',
                packageName: 'jiraIssueTransitionTrigger',
                teamName: 'gryffindor'
            },
            error: error,
            attributes: {
                transitionModalVersion: 'OLD',
                isReopenScenario: isReopenScenario
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});


parcelRegister("aOwqv", function(module, exports) {

$parcel$export(module.exports, "isIssueTransitionModalOpen", () => $0916e83e996fb7bc$export$635dff68cff1d935);
$parcel$export(module.exports, "getPayloadForIssueTransitionModal", () => $0916e83e996fb7bc$export$c7eee86986a78e72);
$parcel$export(module.exports, "getHandlersForIssueTransitionModal", () => $0916e83e996fb7bc$export$514262e3dee62ae2);

var $df4Sl = parcelRequire("df4Sl");

var $jG2Eu = parcelRequire("jG2Eu");
const $0916e83e996fb7bc$var$getUiIssueTransitionModal = (state)=>state.ui.issueTransitionModal;
const $0916e83e996fb7bc$export$635dff68cff1d935 = (state)=>Boolean($0916e83e996fb7bc$var$getUiIssueTransitionModal(state)?.isOpen);
const $0916e83e996fb7bc$var$getSelectedIssueActionPayload = (state)=>$0916e83e996fb7bc$var$getUiIssueTransitionModal(state);
const $0916e83e996fb7bc$var$noSelectedIssue = {
    issueId: '',
    issueKey: '',
    transitionId: ''
};
const $0916e83e996fb7bc$export$c7eee86986a78e72 = (0, $df4Sl.createSelector)([
    $0916e83e996fb7bc$var$getSelectedIssueActionPayload
], (issuePayload)=>{
    if (issuePayload?.isOpen) return {
        issueId: issuePayload.issueId,
        issueKey: issuePayload.issueKey,
        transitionId: issuePayload.transitionId
    };
    return $0916e83e996fb7bc$var$noSelectedIssue;
});
const $0916e83e996fb7bc$var$noHandlers = {
    onDialogCancel: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onDialogError: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onDialogSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
const $0916e83e996fb7bc$export$514262e3dee62ae2 = (0, $df4Sl.createSelector)([
    $0916e83e996fb7bc$var$getSelectedIssueActionPayload
], (issuePayload)=>{
    if (issuePayload?.isOpen) {
        const { onDialogCancel: onDialogCancel = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onDialogError: onDialogError = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onDialogSuccess: onDialogSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) } = issuePayload;
        return {
            onDialogCancel: onDialogCancel,
            onDialogError: onDialogError,
            onDialogSuccess: onDialogSuccess
        };
    }
    return $0916e83e996fb7bc$var$noHandlers;
});

});


parcelRegister("4v1bH", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ff3147c9777ee1f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $jPfP5 = parcelRequire("jPfP5");

var $kGQen = parcelRequire("kGQen");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $k3YqD = parcelRequire("k3YqD");


var $1gQ73 = parcelRequire("1gQ73");

var $7Egcu = parcelRequire("7Egcu");

var $cbRhO = parcelRequire("cbRhO");

var $bP7Jx = parcelRequire("bP7Jx");

var $lCKiB = parcelRequire("lCKiB");

var $1lgHL = parcelRequire("1lgHL");
function $2ff3147c9777ee1f$export$2ddffba95706b42d() {
    const data = (0, $1gQ73.useBacklogSelector)((state)=>{
        const cards = (0, $bP7Jx.getCards)(state);
        const modalData = (0, $lCKiB.getOpenModalData)(state);
        if (!modalData || modalData.type !== (0, $ebd52ea7083e351b$export$86a0c18887a92eae)) return {};
        return {
            confirmActionPayload: modalData.payload.confirmActionPayload,
            originCardListName: modalData.payload.originCardListName,
            destinationCardListName: modalData.payload.destinationCardListName,
            analyticsEvent: modalData.payload.analyticsEvent,
            cards: modalData.payload.cardIds// Make sure the card exists
            .filter((id)=>cards[String(id)]).map((id)=>cards[String(id)])
        };
    });
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    /*
       Should only need to create this once since the modal is closed
       by either confirm or cancel
     */ const analyticsEvent = createAnalyticsEvent({
        actionSubject: 'button',
        action: 'clicked'
    });
    const onClose = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'cancelButton');
        dispatch((0, $cbRhO.closeModal)());
    }, [
        analyticsEvent,
        dispatch
    ]);
    const onMove = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'confirmButton');
        // Wrapping in an if as confirmActionPayload has the potential to be undefined
        if (data.confirmActionPayload) dispatch((0, $7Egcu.cardsMoveRequest)(data.confirmActionPayload, data.analyticsEvent));
        onClose();
    }, [
        analyticsEvent,
        onClose,
        data,
        dispatch
    ]);
    const renderMovedIssues = (0, $eUqFw.useCallback)(()=>{
        const cards = data.cards || [];
        if (cards.length <= 0) return null;
        if (cards.length === 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $1lgHL.default).movedOneCard,
            values: {
                cardName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, cards[0].key),
                originCardListName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, data.originCardListName),
                destinationCardListName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, data.destinationCardListName)
            }
        });
        if (cards.length === 2) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $1lgHL.default).movedTwoCards,
            values: {
                cardName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, cards[0].key),
                anotherCardName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, cards[1].key),
                originCardListName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, data.originCardListName),
                destinationCardListName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, data.destinationCardListName)
            }
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $1lgHL.default).movedMoreCards,
            values: {
                cardName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, cards[0].key),
                anotherCardName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, cards[1].key),
                originCardListName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, data.originCardListName),
                destinationCardListName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, data.destinationCardListName),
                moreCardsCountText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, cards.length - 2),
                moreCardsCount: cards.length - 2
            }
        });
    }, [
        data
    ]);
    const buttonCancel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        onClick: onClose,
        key: "buttonCancel"
    }, formatMessage((0, $1lgHL.default).cancel));
    const buttonConfirm = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        onClick: onMove,
        key: "buttonConfirm"
    }, formatMessage((0, $1lgHL.default).confirm));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k3YqD.ModalDialog), {
        width: 400,
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), {
        appearance: "warning"
    }, formatMessage((0, $1lgHL.default).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $1lgHL.default).changedScope)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
        "data-testid": "software-backlog.modals.move-cards-active-sprint-modal.content"
    }, renderMovedIssues()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jPfP5.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, [
        buttonCancel,
        buttonConfirm
    ])));
}
function $2ff3147c9777ee1f$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa),
        sourceName: "moveCardsActiveSprint"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ff3147c9777ee1f$export$2ddffba95706b42d, null));
}

});
parcelRegister("1lgHL", function(module, exports) {

$parcel$export(module.exports, "default", () => $650419ef42066389$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $650419ef42066389$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "backlog.modals.move-cards-active-sprint-modal.title",
        "defaultMessage": "Move issues"
    },
    changedScope: {
        "id": "backlog.modals.move-cards-active-sprint-modal.changed-scope",
        "defaultMessage": "Sprint scope will be affected by this action."
    },
    movedOneCard: {
        "id": "backlog.modals.move-cards-active-sprint-modal.moved-one-card",
        "defaultMessage": "{cardName} will be moved from sprint {originCardListName} to sprint {destinationCardListName}."
    },
    movedTwoCards: {
        "id": "backlog.modals.move-cards-active-sprint-modal.moved-two-cards",
        "defaultMessage": "{cardName} and {anotherCardName} will be moved from sprint {originCardListName} to sprint {destinationCardListName}."
    },
    movedMoreCards: {
        "id": "backlog.modals.move-cards-active-sprint-modal.moved-more-cards",
        "defaultMessage": "{cardName}, {anotherCardName} and {moreCardsCountText} more {moreCardsCount, plural, one {issue} other {issues}} will be moved from sprint {originCardListName} to sprint {destinationCardListName}."
    },
    confirm: {
        "id": "backlog.modals.move-cards-active-sprint-modal.confirm",
        "defaultMessage": "Confirm"
    },
    cancel: {
        "id": "backlog.modals.move-cards-active-sprint-modal.cancel",
        "defaultMessage": "Cancel"
    }
});

});


parcelRegister("6pJnf", function(module, exports) {

$parcel$export(module.exports, "SelectTransitionsModal", () => $962878e75b6d176a$export$ccd1f82a2bacb02);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $hiIej = parcelRequire("hiIej");

var $jPfP5 = parcelRequire("jPfP5");

var $kGQen = parcelRequire("kGQen");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");


var $1gQ73 = parcelRequire("1gQ73");

var $7Egcu = parcelRequire("7Egcu");

var $cbRhO = parcelRequire("cbRhO");

var $lCKiB = parcelRequire("lCKiB");

var $2IJjf = parcelRequire("2IJjf");
const $962878e75b6d176a$var$getOptions = (transitions)=>transitions.map((transition)=>({
            name: 'transition',
            value: String(transition.id),
            label: transition.name
        }));
function $962878e75b6d176a$export$ccd1f82a2bacb02() {
    const [selectedTransitionId, setSelectedTransitionId] = (0, $eUqFw.useState)(undefined);
    const [isDisabled, setIsDisabled] = (0, $eUqFw.useState)(true);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const modalAnalyticsEvent = createAnalyticsEvent({
        actionSubject: 'button',
        action: 'clicked'
    });
    const modalData = (0, $1gQ73.useBacklogSelector)((state)=>{
        const modal = (0, $lCKiB.getOpenModalData)(state);
        return modal && modal.type === (0, $ebd52ea7083e351b$export$dcb8eb3e585ecde) ? modal.payload : null;
    });
    const onSelectionChange = (0, $eUqFw.useCallback)(({ currentTarget: { value: value } })=>{
        if (value) {
            setSelectedTransitionId(Number(value));
            setIsDisabled(false);
        }
    }, [
        setIsDisabled,
        setSelectedTransitionId
    ]);
    if (!modalData) return null;
    const { cardKeys: cardKeys, transitions: transitions, moveCardsActionPayload: moveCardsActionPayload, optimisticId: optimisticId, analyticsEvent: analyticsEvent } = modalData;
    const onCancel = ()=>{
        (0, $jMP2a.fireUIAnalytics)(modalAnalyticsEvent, 'cancelButton');
        dispatch((0, $7Egcu.cardsMoveCancel)(optimisticId, analyticsEvent));
        dispatch((0, $cbRhO.closeModal)());
    };
    const onChoose = ()=>{
        (0, $jMP2a.fireUIAnalytics)(modalAnalyticsEvent, 'chooseTransitionButton');
        selectedTransitionId && dispatch((0, $7Egcu.cardsMoveNonOptimisticRequest)(optimisticId, {
            ...moveCardsActionPayload,
            selectedTransition: transitions.find((transition)=>transition.id === selectedTransitionId)
        }, analyticsEvent));
        dispatch((0, $cbRhO.closeModal)());
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa),
        sourceName: "selectTransition"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $2IJjf.messages).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $2IJjf.messages).description, {
        count: transitions.length,
        cardKeys: cardKeys.join(', ')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hiIej.default), {
        onChange: onSelectionChange,
        options: $962878e75b6d176a$var$getOptions(transitions)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jPfP5.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        onClick: onCancel
    }, formatMessage((0, $2IJjf.messages).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        isDisabled: isDisabled,
        appearance: "primary",
        onClick: onChoose,
        autoFocus: true
    }, formatMessage((0, $2IJjf.messages).choose)))))));
}

});
parcelRegister("hiIej", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2025a66c6553d911$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");

var $hnuwz = parcelRequire("hnuwz");
const $2025a66c6553d911$var$noOptions = [];
function $2025a66c6553d911$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, options: options = $2025a66c6553d911$var$noOptions, value: propValue, defaultValue: defaultValue, isDisabled: isDisabled, isRequired: isRequired, isInvalid: isInvalid, onInvalid: onInvalid = (0, $5Q9wj.default), name: name, analyticsContext: analyticsContext, ['aria-labelledby']: ariaLabelledBy, testId: testId } = props;
    const [selectedValue, setSelectedValue] = (0, $eUqFw.useState)(propValue !== undefined ? propValue : defaultValue);
    const onRadioChange = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        setSelectedValue(e.currentTarget.value);
        if (onChange) onChange(e, analyticsEvent);
    }, [
        onChange
    ]);
    // If propValue is provided than act as a controlled component
    // If not then act as an uncontrolled component using the value from state
    const value = typeof propValue !== 'undefined' ? propValue : selectedValue;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "radiogroup",
        "aria-labelledby": ariaLabelledBy,
        "data-testid": testId
    }, options.map(({ ...optionProps }, index)=>{
        if (typeof isDisabled !== 'undefined') optionProps.isDisabled = isDisabled;
        const isChecked = value !== null && optionProps.value === value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnuwz.default), {
            ...optionProps,
            name: name || optionProps.name,
            key: index,
            onChange: onRadioChange,
            onInvalid: onInvalid,
            isInvalid: isChecked && isInvalid,
            isChecked: isChecked,
            testId: optionProps.testId || testId,
            isRequired: isRequired,
            analyticsContext: analyticsContext
        });
    }));
}

});

parcelRegister("2IJjf", function(module, exports) {

$parcel$export(module.exports, "messages", () => $18e4c27159988bd9$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $18e4c27159988bd9$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "backlog.modals.select-transitions-modal.title",
        "defaultMessage": "Choose a transition"
    },
    description: {
        "id": "backlog.modals.select-transitions-modal.description",
        "defaultMessage": "Choose one of {count} available transitions for issue {cardKeys}"
    },
    cancel: {
        "id": "backlog.modals.select-transitions-modal.cancel",
        "defaultMessage": "Cancel"
    },
    choose: {
        "id": "backlog.modals.select-transitions-modal.choose",
        "defaultMessage": "Choose"
    }
});

});


parcelRegister("9TuMj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f98cd745ac3cfea$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lbBXW = parcelRequire("lbBXW");

var $lA3UV = parcelRequire("lA3UV");

var $bHPpI = parcelRequire("bHPpI");


var $lEnU0 = parcelRequire("lEnU0");

var $1gQ73 = parcelRequire("1gQ73");

var $jiL2Q = parcelRequire("jiL2Q");

var $lsENz = parcelRequire("lsENz");

var $cbRhO = parcelRequire("cbRhO");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $1ircG = parcelRequire("1ircG");

var $k734R = parcelRequire("k734R");

var $lCKiB = parcelRequire("lCKiB");

var $dtV8v = parcelRequire("dtV8v");

var $chaHX = parcelRequire("chaHX");
const $7f98cd745ac3cfea$var$useSplitIssueState = (cardId)=>{
    const isSprintsEnabled = (0, $1gQ73.useBacklogSelector)((0, $dtV8v.isBacklogWithSprints));
    const card = (0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.getCards)(state)[cardId]);
    const cardListId = (0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.makeGetCardListIdByCardId)(state)(cardId));
    const isCardListActiveSprint = (0, $1gQ73.useBacklogSelector)((state)=>(0, $dtV8v.makeIsCardListActiveSprint)(state)(String(cardListId)));
    const serviceContext = (0, $1gQ73.useBacklogSelector)((state)=>(0, $lEnU0.makeServiceContext)(state));
    const cardLists = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getCardLists));
    const cardListData = (0, $1gQ73.useBacklogSelector)((state)=>Object.values(cardLists).map(({ id: id, name: name })=>({
                id: id,
                name: name,
                type: (0, $bP7Jx.makeGetCardListAnalyticsTypeById)(state)(id),
                isActive: (0, $dtV8v.makeIsCardListActiveSprint)(state)(id)
            })), (0, $bHPpI.isObjectArrayEqual));
    const estimationFieldId = (0, $1gQ73.useBacklogSelector)((0, $1ircG.getEstimationFieldId));
    const estimationType = (0, $1gQ73.useBacklogSelector)((0, $1ircG.getEstimationType));
    const timeTrackingOptions = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getTimeTrackingOptions));
    const timeTrackingConfig = (0, $chaHX.timeTrackingConfigTransformer)(timeTrackingOptions);
    return {
        card: card,
        originalIssueDestinationId: cardListId,
        cardLists: cardListData,
        estimationFieldId: estimationFieldId,
        estimationType: estimationType,
        isCardListActiveSprint: isCardListActiveSprint,
        isSprintsEnabled: isSprintsEnabled,
        timeTrackingConfig: timeTrackingConfig,
        isCompanyManaged: serviceContext.isCompanyManaged
    };
};
const $7f98cd745ac3cfea$export$10af25b190c591c7 = ()=>{
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const issueParents = (0, $1gQ73.useBacklogSelector)((0, $k734R.issueParentsSelector));
    const storeFieldsActions = (0, $lA3UV.useStoreFields)({
        issueParents: issueParents
    });
    const onClose = (0, $eUqFw.useCallback)(()=>{
        dispatch((0, $cbRhO.closeModal)());
    }, [
        dispatch
    ]);
    const onSplitIssue = (0, $eUqFw.useCallback)((originalIssue, newSplitIssues)=>{
        const newSplitIssueKeys = newSplitIssues?.map((issue)=>issue?.key ?? '');
        dispatch((0, $jiL2Q.loadAppData)({
            storeFieldsActions: storeFieldsActions
        }));
        dispatch((0, $lsENz.splitIssueCreate)(originalIssue.key, newSplitIssueKeys));
        dispatch((0, $cbRhO.closeModal)());
    }, [
        dispatch,
        storeFieldsActions
    ]);
    return {
        onClose: onClose,
        onSplitIssue: onSplitIssue
    };
};
const $7f98cd745ac3cfea$var$SplitIssueModalView = ({ cardId: cardId })=>{
    const state = $7f98cd745ac3cfea$var$useSplitIssueState(cardId);
    const actions = $7f98cd745ac3cfea$export$10af25b190c591c7();
    const props = {
        ...state,
        ...actions
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lbBXW.default), props);
};
const $7f98cd745ac3cfea$var$SplitIssueModalContainer = ()=>{
    const modalData = (0, $1gQ73.useBacklogSelector)((0, $lCKiB.getOpenModalData));
    if (modalData?.type !== (0, $ebd52ea7083e351b$export$77e94846ed2f57d7)) return null;
    const { cardId: cardId } = modalData.payload;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7f98cd745ac3cfea$var$SplitIssueModalView, {
        cardId: cardId
    });
};
var $7f98cd745ac3cfea$export$2e2bcd8739ae039 = $7f98cd745ac3cfea$var$SplitIssueModalContainer;

});
parcelRegister("lbBXW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e78c031916fa3f8$export$2e2bcd8739ae039);
/**
 * This async file lives here since it needs to access the generated query, and stricter only allows one level of imports in UI
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $iWLL0 = parcelRequire("iWLL0");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $huI7r = parcelRequire("huI7r");

var $4cdS6 = parcelRequire("4cdS6");

var $kJlBc = parcelRequire("kJlBc");

var $gd0Sp = parcelRequire("gd0Sp");

var $9IbuV = parcelRequire("9IbuV");

var $4dR4I = parcelRequire("4dR4I");

var $d9yNz = parcelRequire("d9yNz");

var $fYDPY = parcelRequire("fYDPY");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5e78c031916fa3f8$var$LazySplitIssueModal = (0, $7rh0R.lazy)(()=>(parcelRequire("21eXd")), {
    moduleId: "./src/packages/software/backlog-split-issue/src/ui/split-issue-modal/index.tsx"
});
const $5e78c031916fa3f8$export$5f61d6092ee768bc = (props)=>{
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const [boardId = null] = (0, $kJlBc.usePathParam)('boardId');
    const [onViewExperienceStart, onViewExperienceSuccess, onViewExperienceFail] = (0, $fYDPY.useExperienceTracker)((0, $4dR4I.EXPERIENCES).viewApp, (0, $4dR4I.SOURCE_NAME));
    (0, $9IbuV.useUFOComponentExperience)((0, $d9yNz.initialLoadSplitIssueModalExperience));
    const [queryReference, loadQuery] = (0, $iWLL0.useQueryLoader)((0, $4cdS6.default));
    const boardARI = (0, $huI7r.createAri)({
        resourceOwner: 'jira-software',
        cloudId: cloudId,
        resourceType: 'board',
        resourceId: String(boardId)
    });
    const cardARI = (0, $huI7r.createAri)({
        resourceOwner: 'jira-software',
        cloudId: cloudId,
        resourceType: 'card',
        resourceId: String(props.card.id)
    });
    const onError = (0, $eUqFw.useCallback)((location, error, errorAttributes)=>{
        onViewExperienceFail(location, error, errorAttributes);
        (0, $d9yNz.initialLoadSplitIssueModalExperience).failure();
    }, [
        onViewExperienceFail
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            (0, $d9yNz.initialLoadSplitIssueModalExperience).abort();
        }, []);
    (0, $eUqFw.useEffect)(()=>{
        loadQuery({
            boardId: boardARI,
            cardId: cardARI
        }, {
            fetchPolicy: 'store-or-network'
        });
        onViewExperienceStart();
    }, [
        boardARI,
        cardARI,
        loadQuery,
        onViewExperienceStart
    ]);
    return queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: (0, $4dR4I.APP_IDENTIFIER),
        packageName: (0, $4dR4I.PACKAGE_NAME),
        fallback: "flag",
        teamName: "a4t-pandora",
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jira-software-backlog-split-issue-ui",
        fallback: "Loading..."
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5e78c031916fa3f8$var$LazySplitIssueModal, {
        queryReference: queryReference,
        ...props,
        onLoadSuccess: onViewExperienceSuccess
    }))) : null;
};
var $5e78c031916fa3f8$export$2e2bcd8739ae039 = $5e78c031916fa3f8$export$5f61d6092ee768bc;

});
parcelRegister("4cdS6", function(module, exports) {

$parcel$export(module.exports, "default", () => $34910aa2bf53c431$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<900b80199afc9efa03c01e67aea1e3e8>>
 * @relayHash cfcfb33cef7d4219a6d3f24984f7bcb0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 32db338fa9736886f416e43946a8e0a64a7b66d85da678268e01a687db02bc1d
const $34910aa2bf53c431$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cardId"
        }
    ], v1 = {
        "args": [
            {
                "kind": "Variable",
                "name": "boardId",
                "variableName": "boardId"
            },
            {
                "kind": "Variable",
                "name": "cardId",
                "variableName": "cardId"
            }
        ],
        "kind": "ScalarField",
        "name": "canSplitIssue"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "splitIssueModalQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": v1 /*: any*/ ,
                    "action": "THROW",
                    "path": "canSplitIssue"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "splitIssueModalQuery",
            "selections": [
                v1 /*: any*/ 
            ]
        },
        "params": {
            "id": "32db338fa9736886f416e43946a8e0a64a7b66d85da678268e01a687db02bc1d",
            "metadata": {},
            "name": "splitIssueModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$34910aa2bf53c431$var$node.hash = "9c5280b41e46526652e1eaef4fc47ef2";
var $34910aa2bf53c431$export$2e2bcd8739ae039 = $34910aa2bf53c431$var$node;

});

parcelRegister("9IbuV", function(module, exports) {

$parcel$export(module.exports, "useUFOComponentExperience", () => $dfcd8ff9c232688c$export$30ab340faaed55d4);

var $eUqFw = parcelRequire("eUqFw");
const $dfcd8ff9c232688c$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $eUqFw.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $dfcd8ff9c232688c$export$30ab340faaed55d4 = (experience)=>{
    (0, $eUqFw.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $dfcd8ff9c232688c$var$useConstructor(()=>experience.start());
    return null;
};

});

parcelRegister("4dR4I", function(module, exports) {

$parcel$export(module.exports, "PERMISSION_ERROR_FLAG_ID", () => $e3f30e8cad56ca06$export$6066d6393ad0b789);
$parcel$export(module.exports, "ERROR_FLAG_ID", () => $e3f30e8cad56ca06$export$f5e4c120ac01b615);
$parcel$export(module.exports, "ISSUE_COUNT", () => $e3f30e8cad56ca06$export$8775696968c9b13c);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE", () => $e3f30e8cad56ca06$export$bfb354504bb547a0);
$parcel$export(module.exports, "STORY_POINTS", () => $e3f30e8cad56ca06$export$405b6d72f2d243a9);
$parcel$export(module.exports, "APP_IDENTIFIER", () => $e3f30e8cad56ca06$export$2cea7f14750b8c19);
$parcel$export(module.exports, "PACKAGE_NAME", () => $e3f30e8cad56ca06$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "SOURCE_NAME", () => $e3f30e8cad56ca06$export$a3821bc63538b210);
$parcel$export(module.exports, "MUTATION_FAILURE", () => $e3f30e8cad56ca06$export$178c5c429f396aa0);
$parcel$export(module.exports, "EXPERIENCES", () => $e3f30e8cad56ca06$export$a2008ed3b02411a3);
$parcel$export(module.exports, "SUMMARY_CHAR_LIMIT", () => $e3f30e8cad56ca06$export$5ff63ab521d3d56c);
$parcel$export(module.exports, "SPLIT_ISSUE_INPUT", () => $e3f30e8cad56ca06$export$5fd76d6bc878265a);

var $eo17r = parcelRequire("eo17r");
const $e3f30e8cad56ca06$export$6066d6393ad0b789 = (0, $eo17r.toFlagId)('permission-error-flag');
const $e3f30e8cad56ca06$export$f5e4c120ac01b615 = (0, $eo17r.toFlagId)('error-flag');
const $e3f30e8cad56ca06$export$8775696968c9b13c = 'ISSUE_COUNT';
const $e3f30e8cad56ca06$export$bfb354504bb547a0 = 'ORIGINAL_ESTIMATE';
const $e3f30e8cad56ca06$export$405b6d72f2d243a9 = 'STORY_POINTS';
const $e3f30e8cad56ca06$export$2cea7f14750b8c19 = 'backlog-split-issue';
const $e3f30e8cad56ca06$export$b8b9d90f9e5bd72b = 'jira-software-backlog-split-issue';
const $e3f30e8cad56ca06$export$a3821bc63538b210 = 'SplitIssue';
const $e3f30e8cad56ca06$export$178c5c429f396aa0 = 'mutation failed';
const $e3f30e8cad56ca06$export$a2008ed3b02411a3 = {
    viewApp: 'viewSplitIssueModal',
    saveApp: 'saveSplitIssue'
};
const $e3f30e8cad56ca06$export$5ff63ab521d3d56c = 255;
const $e3f30e8cad56ca06$export$5fd76d6bc878265a = 'split-issue-modal.summary.split-issue-input';

});

parcelRegister("d9yNz", function(module, exports) {

$parcel$export(module.exports, "initialLoadSplitIssueModalExperience", () => $211ddebf328333d8$export$c85e655fc9a5ae13);
$parcel$export(module.exports, "saveSplitIssuesExperience", () => $211ddebf328333d8$export$82dfb3a19169f7bb);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $211ddebf328333d8$export$c85e655fc9a5ae13 = new (0, $kDfSL.UFOExperience)('split-issue-modal-load', {
    type: (0, $12kyE.ExperienceTypes).Operation,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageLoad
});
const $211ddebf328333d8$export$82dfb3a19169f7bb = new (0, $kDfSL.UFOExperience)('split-issue-save', {
    type: (0, $12kyE.ExperienceTypes).Operation,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("fYDPY", function(module, exports) {

$parcel$export(module.exports, "useExperienceTracker", () => $cd0c252fdb74ede0$export$cdefb2a8b53f879f);

var $hompL = parcelRequire("hompL");

var $4qhD6 = parcelRequire("4qhD6");
var $bDhRl = parcelRequire("bDhRl");
var $fDZ6r = parcelRequire("fDZ6r");

var $eIp1n = parcelRequire("eIp1n");

var $gd0Sp = parcelRequire("gd0Sp");

var $5Vx10 = parcelRequire("5Vx10");
const $cd0c252fdb74ede0$export$cdefb2a8b53f879f = (experience, analyticsSource)=>{
    const { appEditions: appEditions } = (0, $gd0Sp.useTenantContext)();
    const onExperienceStart = (0, $bDhRl.useExperienceStart)({
        experienceId: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
        experience: experience,
        analyticsSource: analyticsSource,
        edition: appEditions.software,
        application: (0, $eIp1n.JIRA_SOFTWARE)
    });
    const synthetic = (0, $5Vx10.isPollinatorTenant)();
    const onExperienceSuccess = (0, $fDZ6r.useExperienceSuccess)({
        experience: experience,
        attributes: {
            synthetic: synthetic
        }
    });
    const onExperienceFail = (0, $4qhD6.useExperienceFail)({
        experience: experience,
        attributes: {
            synthetic: synthetic
        }
    });
    return [
        onExperienceStart,
        onExperienceSuccess,
        onExperienceFail
    ];
};

});
parcelRegister("5Vx10", function(module, exports) {

$parcel$export(module.exports, "isPollinatorTenant", () => $dbf4f7e01afcd24c$export$f59b7b56b5cada61);

var $1ybV0 = parcelRequire("1ybV0");
const $dbf4f7e01afcd24c$export$f59b7b56b5cada61 = ()=>(0, $1ybV0.ff)('jsw.pollinator.tenants');

});


parcelRegister("21eXd", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('42A39')
        ]);
        const value = parcelRequire('j03jt');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("42A39")
    ]).then(()=>parcelRequire('j03jt'));
}

});



parcelRegister("2emC4", function(module, exports) {

$parcel$export(module.exports, "default", () => $462f578f448a3364$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $jPfP5 = parcelRequire("jPfP5");

var $kGQen = parcelRequire("kGQen");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $k3YqD = parcelRequire("k3YqD");

var $ieUWD = parcelRequire("ieUWD");


var $1gQ73 = parcelRequire("1gQ73");

var $cbRhO = parcelRequire("cbRhO");

var $cjL82 = parcelRequire("cjL82");

var $bP7Jx = parcelRequire("bP7Jx");

var $lCKiB = parcelRequire("lCKiB");

var $5GtCB = parcelRequire("5GtCB");
function $462f578f448a3364$var$SprintDeleteModal() {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { sprint: sprint, nextCardListId: nextCardListId } = (0, $1gQ73.useBacklogSelector)((state)=>{
        const modalData = (0, $lCKiB.getOpenModalData)(state);
        if (!modalData || modalData.type !== (0, $ebd52ea7083e351b$export$96d8f8ff51c496e3)) return {};
        const { payload: { sprintId: sprintId } } = modalData;
        return {
            nextCardListId: (0, $bP7Jx.makeGetNextCardListId)(state)(String(sprintId)),
            sprint: sprintId ? (0, $bP7Jx.getCardLists)(state)[String(sprintId)] : null
        };
    });
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    /*
       Should only need to create this once since the modal is closed
       by either confirm or cancel
     */ const analyticsEvent = createAnalyticsEvent({
        actionSubject: 'button',
        action: 'clicked'
    });
    const onDelete = (e, onDeleteAnalyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'confirmButton');
        sprint && dispatch((0, $cjL82.sprintDeleteRequest)(sprint.id, nextCardListId ?? null, onDeleteAnalyticsEvent));
        // Since the sprint modals don't go through redux we need to fire their invalidations manually
        (0, $ieUWD.triggerResourceCacheInvalidation)((0, $c22b1ee1fcd49c4a$export$dedbdcc35e955187), 'DELETE_SPRINT_MODAL_DELETE');
        dispatch((0, $cbRhO.closeModal)());
    };
    const onClose = ()=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'cancelButton');
        dispatch((0, $cbRhO.closeModal)());
    };
    if (!sprint) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k3YqD.ModalDialog), {
        width: 400,
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), {
        appearance: "danger"
    }, formatMessage((0, $5GtCB.default).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $5GtCB.default).areYouSure,
        values: {
            sprintName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, sprint.name)
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jPfP5.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        onClick: onClose
    }, formatMessage((0, $5GtCB.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "danger",
        onClick: onDelete
    }, formatMessage((0, $5GtCB.default).delete)))));
}
function $462f578f448a3364$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa),
        sourceName: "deleteSprint"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($462f578f448a3364$var$SprintDeleteModal, null));
}

});
parcelRegister("5GtCB", function(module, exports) {

$parcel$export(module.exports, "default", () => $243651cff811098c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $243651cff811098c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    delete: {
        "id": "backlog.modals.sprint-delete-modal.delete",
        "defaultMessage": "Delete"
    },
    cancel: {
        "id": "backlog.modals.sprint-delete-modal.cancel",
        "defaultMessage": "Cancel"
    },
    title: {
        "id": "backlog.modals.sprint-delete-modal.title",
        "defaultMessage": "Delete sprint"
    },
    areYouSure: {
        "id": "backlog.modals.sprint-delete-modal.are-you-sure",
        "defaultMessage": "Are you sure you want to delete sprint {sprintName}?"
    }
});

});



parcelRegister("jPmMo", function(module, exports) {

$parcel$export(module.exports, "default", () => $443600aeb2f8cb4a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bLFgh = parcelRequire("bLFgh");
var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $29yDk = parcelRequire("29yDk");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1gQ73 = parcelRequire("1gQ73");

var $jgHdr = parcelRequire("jgHdr");

var $8RiAU = parcelRequire("8RiAU");

var $hR9NS = parcelRequire("hR9NS");
const $443600aeb2f8cb4a$var$BoardIssueMoveDialog = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const isOpen = (0, $1gQ73.useBacklogSelector)((0, $8RiAU.isDialogOpen)); // Strip arguments from event handlers
    const handleConfirm = (0, $eUqFw.useCallback)(()=>dispatch((0, $jgHdr.boardIssueMoveExecute)()), [
        dispatch
    ]);
    const handleCancel = (0, $eUqFw.useCallback)(()=>dispatch((0, $jgHdr.boardIssueMoveCancel)()), [
        dispatch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($443600aeb2f8cb4a$var$AbsolutePosition, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29yDk.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($443600aeb2f8cb4a$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
            as: "h5",
            size: "xsmall"
        }, formatMessage((0, $hR9NS.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($443600aeb2f8cb4a$var$DescriptionStyle, null, formatMessage((0, $hR9NS.default).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            onClick: handleConfirm,
            appearance: "primary"
        }, formatMessage((0, $hR9NS.default).confirm)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            onClick: handleCancel,
            appearance: "subtle"
        }, formatMessage((0, $hR9NS.default).cancel)))),
        isOpen: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null)));
};
var $443600aeb2f8cb4a$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $443600aeb2f8cb4a$var$BoardIssueMoveDialog;
const $443600aeb2f8cb4a$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5724jg8 _11c81oud _1bsbr0r7",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $443600aeb2f8cb4a$var$DescriptionStyle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyrpxbi",
            __cmplp.className
        ])
    });
});
const $443600aeb2f8cb4a$var$AbsolutePosition = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _w4h2stnw _z2g7xy5q",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hR9NS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e29c53912851f87f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e29c53912851f87f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "backlog.modals.board-issue-move-dialog.title",
        "defaultMessage": "Fill your backlog with to-do's"
    },
    description: {
        "id": "backlog.modals.board-issue-move-dialog.description",
        "defaultMessage": "Want to move all issues in your board's first column to the backlog?"
    },
    confirm: {
        "id": "backlog.modals.board-issue-move-dialog.confirm",
        "defaultMessage": "Yes, move"
    },
    cancel: {
        "id": "backlog.modals.board-issue-move-dialog.cancel",
        "defaultMessage": "No thanks"
    }
});

});


parcelRegister("cwRNF", function(module, exports) {

$parcel$export(module.exports, "default", () => $05e7df9f1e9b6941$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gy9MQ = parcelRequire("gy9MQ");

var $1gQ73 = parcelRequire("1gQ73");

var $bP7Jx = parcelRequire("bP7Jx");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$05e7df9f1e9b6941$export$2e2bcd8739ae039 = ()=>{
    const issueIds = (0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.getCardIds)(state).map((cardId)=>String(cardId)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gy9MQ.default), {
        issueIds: issueIds
    });
};

});
parcelRegister("gy9MQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $03cc687fdc6e236f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $frztX = parcelRequire("frztX");
function $03cc687fdc6e236f$var$PrefetchClientOnly(props) {
    if (false) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $frztX.Prefetch), props);
}
var $03cc687fdc6e236f$export$2e2bcd8739ae039 = $03cc687fdc6e236f$var$PrefetchClientOnly;

});
parcelRegister("frztX", function(module, exports) {

$parcel$export(module.exports, "Prefetch", () => $cce652fa651eefcc$export$a92e3edabc61a974);

var $eUqFw = parcelRequire("eUqFw");

var $gZWxz = parcelRequire("gZWxz");
// eslint-disable-next-line jira/react/no-class-components
class $cce652fa651eefcc$var$Prefetch extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.fetchIssues(props.issueIds, props.issueKeys);
    }
    componentDidUpdate({ issueIds: prevIssueIds, issueKeys: prevIssueKeys }) {
        const { issueIds: issueIds, issueKeys: issueKeys } = this.props;
        if (prevIssueIds !== issueIds) {
            const newIds = issueIds.filter((issueId)=>{
                const isTemporaryId = Number(issueId) < 0;
                return !prevIssueIds.includes(issueId) && !isTemporaryId;
            });
            this.fetchIssues(newIds);
        }
        if (issueKeys && prevIssueKeys && prevIssueKeys !== issueKeys) this.fetchIssues([], issueKeys);
    }
    fetchIssues(issueIds, issueKeys) {
        if (issueIds.length > 0) this.props.dataProvider.loadIssuesById(issueIds.map((id)=>String(id)));
        if (issueKeys && issueKeys.length > 0) this.props.dataProvider.loadIssues(issueKeys);
    }
    render() {
        return null;
    }
}
// @ts-expect-error - TS2559 - Type 'Props' has no properties in common with type '{ readonly dataProvider?: DataProvider | undefined; }'.
const $cce652fa651eefcc$export$a92e3edabc61a974 = (0, $gZWxz.WithDataProvider)($cce652fa651eefcc$var$Prefetch);

});
parcelRegister("gZWxz", function(module, exports) {

$parcel$export(module.exports, "WithDataProvider", () => $e2e6d5fa5786b434$export$b0017632f1661e1);

var $eUqFw = parcelRequire("eUqFw");

var $6J3mH = parcelRequire("6J3mH");
const $e2e6d5fa5786b434$export$b0017632f1661e1 = (WrappedComponent)=>// @ts-expect-error - TS2322 - Type '(props: TProps) => JSX.Element' is not assignable to type 'AbstractComponent<TProps, any>'.
    (props)=>{
        const { dataProvider: dataProvider, ...otherProps } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6J3mH.DataProviderContext).Consumer, null, (contextDataProvider)=>// @ts-expect-error - TS2322 - Type 'Omit<TProps, "dataProvider"> & { dataProvider: DataProvider; }' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<TProps & OwnProps> & RefAttributes<any> & { children?: ReactNode; }'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                ...otherProps,
                dataProvider: dataProvider || contextDataProvider()
            }));
    };

});
parcelRegister("6J3mH", function(module, exports) {

$parcel$export(module.exports, "DataProviderContext", () => $4a77777697c6cfb8$export$5bce75db3a3f66c4);

var $eUqFw = parcelRequire("eUqFw");

var $7JlQ7 = parcelRequire("7JlQ7");
const $4a77777697c6cfb8$export$5bce75db3a3f66c4 = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $7JlQ7.getDataProvider));

});
parcelRegister("7JlQ7", function(module, exports) {

$parcel$export(module.exports, "getDataProvider", () => $b647076092cf3969$export$add6bf8e4261fead);

var $3JafE = parcelRequire("3JafE");
parcelRequire("8jBvP");

var $e91YZ = parcelRequire("e91YZ");

var $6vrw7 = parcelRequire("6vrw7");

var $aVkxW = parcelRequire("aVkxW");
const $b647076092cf3969$var$DEFAULT_EXPIRY_THRESHOLD_SECONDS = 3600;
const $b647076092cf3969$var$DEFAULT_MAX_SIZE = 100;
const $b647076092cf3969$var$getTenantBaseUrl = ()=>{
    try {
        return (0, $6vrw7.toBaseUrl)((0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)().baseUrl);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return (0, $6vrw7.toBaseUrl)('');
    }
};
const $b647076092cf3969$var$createConfig = (config = {})=>{
    const defaultConfig = {
        expiryThresholdSeconds: $b647076092cf3969$var$DEFAULT_EXPIRY_THRESHOLD_SECONDS,
        maxSize: $b647076092cf3969$var$DEFAULT_MAX_SIZE,
        // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
        baseUrl: Object.prototype.hasOwnProperty.call(config, 'baseUrl') ? config.baseUrl : $b647076092cf3969$var$getTenantBaseUrl(),
        ssrCachedIssue: null
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    return Object.assign({}, defaultConfig, config);
};
const $b647076092cf3969$export$33c5e0ba77bb7d8 = (options = {})=>{
    const config = $b647076092cf3969$var$createConfig(options);
    const baseUrl = (0, $6vrw7.toBaseUrl)(config.baseUrl);
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const clearCache = ()=>{};
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const insertSerializedIssue = ()=>{};
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const loadIssues = ()=>{};
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const loadIssuesById = ()=>{};
    // @ts-expect-error - TS2355 - A function whose declared type is neither 'void' nor 'any' must return a value.
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const getIssue = ()=>{};
    const loadIssue$ = ()=>(0, $3JafE.Observable).empty();
    const getIssue$ = ()=>(0, $3JafE.Observable).empty();
    const refreshIssue$ = ()=>loadIssue$();
    const getIssueRemoteData$ = (issueKey, cloudId, isIssueViewWhiteboardsStandaloneEnabled)=>isIssueViewWhiteboardsStandaloneEnabled ? (0, $aVkxW.fetchIssueRemoteDataWithWhiteboards$)((0, $6vrw7.toIssueKey)(issueKey), (0, $6vrw7.toCloudId)(cloudId)) : (0, $aVkxW.fetchIssueRemoteData$)(baseUrl, (0, $6vrw7.toIssueKey)(issueKey));
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const updateIssue = ()=>{};
    const getMetrics = ()=>({
            cacheSize: 0,
            cacheStaleCount: 0,
            cacheAvailableCapacity: 0,
            cacheHit: false,
            staleCacheHit: false
        });
    return {
        clearCache: clearCache,
        loadIssues: loadIssues,
        loadIssuesById: loadIssuesById,
        getIssue: getIssue,
        getIssue$: getIssue$,
        getIssueRemoteData$: getIssueRemoteData$,
        refreshIssue$: refreshIssue$,
        updateIssue: updateIssue,
        getMetrics: getMetrics,
        insertSerializedIssue: insertSerializedIssue
    };
};
// store it as a singleton
let $b647076092cf3969$var$dataProvider;
const $b647076092cf3969$export$add6bf8e4261fead = ()=>{
    if ($b647076092cf3969$var$dataProvider == null) $b647076092cf3969$var$dataProvider = $b647076092cf3969$export$33c5e0ba77bb7d8();
    return $b647076092cf3969$var$dataProvider;
};

});
parcelRegister("aVkxW", function(module, exports) {

$parcel$export(module.exports, "fetchIssueRemoteData$", () => $b6c369d51634b049$export$83220ed1a595568a);
$parcel$export(module.exports, "fetchIssueRemoteDataWithWhiteboards$", () => $b6c369d51634b049$export$3aec720cf88c26cd);

var $3JafE = parcelRequire("3JafE");
parcelRequire("flmol");
parcelRequire("8OtG5");
parcelRequire("1Lcr1");
parcelRequire("8jBvP");

var $cwK3t = parcelRequire("cwK3t");

var $df9H8 = parcelRequire("df9H8");

var $dXapj = parcelRequire("dXapj");

var $aynDk = parcelRequire("aynDk");

var $6yPEx = parcelRequire("6yPEx");

var $3ElT9 = parcelRequire("3ElT9");

var $3A3OQ = parcelRequire("3A3OQ");

var $6vrw7 = parcelRequire("6vrw7");

var $l0eyw = parcelRequire("l0eyw");

var $gNavb = parcelRequire("gNavb");

const $b6c369d51634b049$var$LOG_LOCATION = 'issue.data-provider.source.issue-express';
const $b6c369d51634b049$var$getIssueKeyFromResponse = (response)=>{
    // @ts-expect-error - TS2339 - Property 'fields' does not exist on type 'ViewIssue | ViewIssueRemoteData'.
    const fields = response.fields || [];
    const issueKeyField = fields.find(// @ts-expect-error - TS7006 - Parameter 'field' implicitly has an 'any' type.
    (field)=>field.__typename === $330b0f1977bf0938$export$40bed7a29c3b629);
    if (!issueKeyField) throw new Error('Issue key field missing in graphql response');
    return (0, $6vrw7.toIssueKey)(issueKeyField.stringValue);
};
const $b6c369d51634b049$var$transformGraphQlIssueRemoteData = (response, issueKey)=>{
    if (!response) return null;
    const key = issueKey || $b6c369d51634b049$var$getIssueKeyFromResponse(response);
    const now = new Date();
    const { issueId: issueId, remoteLinks: remoteLinks } = response;
    return (0, $l0eyw.createIssue)({
        key: key
    }).withMeta({
        newIssueViewLockedIn: response.meta ? response.meta.newIssueViewLockedIn : false,
        dataSource: 'issueExpress',
        fetchTime: now
    }).withId(issueId).withRemoteLinks(remoteLinks).build();
};
const $b6c369d51634b049$var$transformConfluenceWhiteboardData = (response)=>{
    const issueToWhiteboard = response?.graphStore?.issueToWhiteboard ?? {};
    const whiteboards = issueToWhiteboard.edges?.map(({ node: node })=>({
            whiteboardId: node.whiteboardId,
            author: {
                ...node.author
            },
            href: `${node.links?.base}${node.links?.webUi}`,
            type: (0, $3ElT9.CONFLUENCE_WHITEBOARD),
            id: node.id,
            title: node.title
        }));
    return {
        confluenceWhiteboards: {
            linkedWhiteboards: {
                whiteboardCount: issueToWhiteboard.totalCount,
                whiteboards: whiteboards
            }
        }
    };
};
const $b6c369d51634b049$export$83220ed1a595568a = (baseUrl, issueKey)=>// @ts-expect-error - TS2322 - Type 'Observable<IssueRemoteData | null>' is not assignable to type 'Observable<IssueRemoteData>'.
    (0, $gNavb.fetchIssueRemoteData)(baseUrl, issueKey).map((graphQlIssue)=>$b6c369d51634b049$var$transformGraphQlIssueRemoteData(graphQlIssue, issueKey)).filter(Boolean).catch((err)=>{
        (0, $3A3OQ.trackOrLogClientError)($b6c369d51634b049$var$LOG_LOCATION, 'fetchIssueRemoteData: Failed to fetch issue remote data from gira', err);
        return (0, $3JafE.Observable).empty();
    });
const $b6c369d51634b049$export$3aec720cf88c26cd = (issueKey, cloudId)=>// @ts-expect-error - TS2322 - Type 'Observable<IssueRemoteData | null>' is not assignable to type 'Observable<IssueRemoteData>'.
    (0, $gNavb.fetchIssueRemoteData)('', issueKey).pipe((0, $6yPEx.switchMap)((remoteDataResponse)=>(0, $gNavb.fetchIssueConfluenceWhiteboardData)(remoteDataResponse.issueId, cloudId).pipe((0, $aynDk.map)((confluenceWhiteboardDataResponse)=>{
            const confluenceWhiteboards = $b6c369d51634b049$var$transformConfluenceWhiteboardData(confluenceWhiteboardDataResponse);
            const combinedRemoteData = {
                ...remoteDataResponse,
                remoteLinks: {
                    ...remoteDataResponse.remoteLinks,
                    ...confluenceWhiteboards
                }
            };
            return combinedRemoteData;
        }), (0, $aynDk.map)((graphQlIssue)=>$b6c369d51634b049$var$transformGraphQlIssueRemoteData(graphQlIssue, issueKey)), (0, $dXapj.filter)(Boolean), (0, $df9H8.catchError)((err)=>{
            (0, $3A3OQ.trackOrLogClientError)($b6c369d51634b049$var$LOG_LOCATION, 'fetchIssueConfluenceWhiteboardData: Failed to fetch confluence whiteboards from AGG', err);
            return (0, $cwK3t.of)($b6c369d51634b049$var$transformGraphQlIssueRemoteData(remoteDataResponse, issueKey));
        }))), (0, $df9H8.catchError)((err)=>{
        (0, $3A3OQ.trackOrLogClientError)($b6c369d51634b049$var$LOG_LOCATION, 'fetchIssueRemoteData: Failed to fetch issue remote data from gira', err);
        return (0, $3JafE.Observable).empty();
    }));

});
parcelRegister("3ElT9", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_BLOGPOST", () => $5a00b441e09ec27d$export$b0807d3d613e535);
$parcel$export(module.exports, "CONFLUENCE_WHITEBOARD", () => $5a00b441e09ec27d$export$489cb2e515fef0c4);
$parcel$export(module.exports, "toConfluencePageType", () => $5a00b441e09ec27d$export$a7ae1ae0a3d7d205);
const $5a00b441e09ec27d$export$b0807d3d613e535 = 'blogpost';
const $5a00b441e09ec27d$export$353109fb558251b1 = 'page';
const $5a00b441e09ec27d$export$489cb2e515fef0c4 = 'whiteboard';
const $5a00b441e09ec27d$export$a7ae1ae0a3d7d205 = (type)=>type === $5a00b441e09ec27d$export$b0807d3d613e535 ? $5a00b441e09ec27d$export$b0807d3d613e535 : $5a00b441e09ec27d$export$353109fb558251b1;

});

parcelRegister("3A3OQ", function(module, exports) {

$parcel$export(module.exports, "trackOrLogClientError", () => $abf996733b47dc5f$export$2fc29872103bf255);

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $JRB5w = parcelRequire("JRB5w");
const $abf996733b47dc5f$export$c392d6295c0a29c7 = (location, message, error)=>{
    (0, $guiFP.default)({
        error: error,
        attributes: {
            message: message
        },
        meta: {
            id: location,
            packageName: 'jiraIssueViewCommonUtils'
        }
    });
};
const $abf996733b47dc5f$export$2fc29872103bf255 = (location, message, error)=>{
    if (error instanceof TypeError && (0, $JRB5w.isClientFetchError)(error)) $abf996733b47dc5f$export$c392d6295c0a29c7(location, message, error);
    else (0, $gUUjF.default).safeErrorWithoutCustomerData(location, message, error);
};

});

parcelRegister("l0eyw", function(module, exports) {

$parcel$export(module.exports, "createIssue", () => $97e912da463a0056$export$b61347e00e271b8e);
class $97e912da463a0056$var$IssueBuilder {
    constructor({ key: key }){
        this.key = key;
        this.fields = new Map();
    }
    withMeta(meta) {
        this.meta = meta;
        return this;
    }
    // go/jfe-eslint
    withId(id) {
        this.id = id;
        return this;
    }
    // go/jfe-eslint
    withFields(fields) {
        fields.forEach(this.withField, this);
        return this;
    }
    // go/jfe-eslint
    withField(field) {
        if (field) this.fields.set(String(field.key), field);
        return this;
    }
    // go/jfe-eslint
    withRemoteLinks(remoteLinks) {
        this.remoteLinks = remoteLinks;
        return this;
    }
    // go/jfe-eslint
    withPreferences(myPreferences) {
        this.myPreferences = myPreferences;
        return this;
    }
    // go/jfe-eslint
    withComments(commentsData) {
        this.commentsData = commentsData;
        return this;
    }
    // go/jfe-eslint
    withWorkflow(workflow) {
        this.workflow = workflow;
        return this;
    }
    // go/jfe-eslint
    withActivitySortOrder(activitySortOrder) {
        this.activitySortOrder = activitySortOrder;
        return this;
    }
    build() {
        const meta = this.meta !== null && this.meta !== undefined ? this.meta : {
            dataSource: 'unknown',
            newIssueViewLockedIn: false,
            fetchTime: new Date()
        };
        const remoteLinks = this.remoteLinks !== null && this.remoteLinks !== undefined ? this.remoteLinks : {
            confluencePages: {
                linkedPages: {
                    pageCount: 0
                },
                mentionedPages: {
                    pageCount: 0
                }
            },
            confluenceWhiteboards: {
                linkedWhiteboards: {
                    whiteboardCount: 0
                }
            },
            webLinks: {
                linkCount: 0
            },
            remoteLinkedIssues: []
        };
        const myPreferences = this.myPreferences !== null && this.myPreferences !== undefined ? this.myPreferences : {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let users = {};
        let comments = {
            totalCount: 0,
            startIndex: 0,
            comments: {}
        };
        if (this.commentsData !== null && this.commentsData !== undefined) {
            comments = {
                totalCount: this.commentsData.totalCount,
                // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'number'.
                startIndex: this.commentsData.startIndex,
                comments: this.commentsData.comments
            };
            users = this.commentsData.users;
        }
        const workflow = this.workflow !== null && this.workflow !== undefined ? this.workflow : undefined;
        const activitySortOrder = this.activitySortOrder;
        const issue = {
            key: this.key,
            fields: this.fields,
            meta: meta,
            remoteLinks: remoteLinks,
            myPreferences: myPreferences,
            comments: comments,
            users: users,
            workflow: workflow,
            activitySortOrder: activitySortOrder,
            ...this.id !== null && this.id !== undefined ? {
                id: this.id
            } : undefined
        };
        return issue;
    }
}
const $97e912da463a0056$export$b61347e00e271b8e = ({ key: key })=>new $97e912da463a0056$var$IssueBuilder({
        key: key
    });

});

parcelRegister("gNavb", function(module, exports) {

$parcel$export(module.exports, "fetchIssueRemoteData", () => $c265b6b62f0ef502$export$619c3be06a997564);
$parcel$export(module.exports, "fetchIssueConfluenceWhiteboardData", () => $c265b6b62f0ef502$export$886e1cd5d478fbe5);
parcelRequire("jyKN9");
parcelRequire("bI4RP");
parcelRequire("flmol");
parcelRequire("iects");

var $aiRd8 = parcelRequire("aiRd8");

var $gIOVj = parcelRequire("gIOVj");
parcelRequire("9s86T");
var $6VKiL = parcelRequire("6VKiL");
var $9s86T = parcelRequire("9s86T");

var $5WNEZ = parcelRequire("5WNEZ");

var $fwqh1 = parcelRequire("fwqh1");

var $11LM5 = parcelRequire("11LM5");
const $c265b6b62f0ef502$var$NUM_INITIAL_COMMENTS_TO_LOAD = 5;
const $c265b6b62f0ef502$var$CREATED_ORDER_DESCENDING = '-created';
const $c265b6b62f0ef502$var$commentParameter = ()=>{
    const { hasPermalink: hasPermalink, permalinkId: permalinkId } = (0, $9s86T.getPermalinkStatus)((0, $6VKiL.COMMENTS));
    return hasPermalink ? `, commentId: ${permalinkId}` : '';
};
const $c265b6b62f0ef502$var$LOG_LOCATION = 'issue.data-provider.source.issue-express.graphql';
const $c265b6b62f0ef502$var$VIEW_ISSUE_ALIAS = 'bentoViewIssue';
const $c265b6b62f0ef502$var$addQueryForRemoteLinks = ()=>`remoteLinks {
       isLinkingEnabled
       confluencePages {
         linkedPages {
            pageCount
         }
         mentionedPages {
            pageCount
         }
       }
     }`;
const $c265b6b62f0ef502$var$getCommentsQuery = ()=>{
    const commentAmountParameter = `, commentAmount: ${Math.floor($c265b6b62f0ef502$var$NUM_INITIAL_COMMENTS_TO_LOAD / 2)}`;
    const orderByParameter = `, orderBy: "${$c265b6b62f0ef502$var$CREATED_ORDER_DESCENDING}"`;
    const query = `comments (first: 0, maxResults: ${$c265b6b62f0ef502$var$NUM_INITIAL_COMMENTS_TO_LOAD}${orderByParameter}, isPreview: true ${$c265b6b62f0ef502$var$commentParameter()}${commentAmountParameter}) {
            nodes{
              id
              author {
                  accountId
                  displayName
                  avatarUrl
              }
              updateAuthor {
                  accountId
                  displayName
                  avatarUrl
              }
              visibility {
                  type
                  value
              }
              created
              updated
              jsdPublic
              bodyAdf
              jsdAuthorCanSeeRequest
            }
            totalCount
            startIndex
          }
        `;
    return query;
};
const $c265b6b62f0ef502$export$895cf5b64d42d88d = ()=>`
        issueId
        fields {
            __typename

            ... on ProjectField {
                fieldKey
                type
                simplified
                name
            }

            ... on TextField {
                fieldKey
                title
                isEditable
                textValue
                adf
                renderer
            }

            ... on IssueTypeField {
              fieldKey
              id
              iconUrl
              name
            }

            ... on StatusField {
              fieldKey
              name
              statusCategoryId
            }

            ... on IssueKeyField {
              fieldKey
              stringValue
            }

            ... on PriorityField {
              fieldKey
              title
              isEditable
              iconUrl
              name
              id
            }

            ... on UserField {
              fieldKey
              title
              isEditable
              userValue {
                displayName
                avatarUrl
                accountId
              }
            }

            ... on VersionsField {
              fieldKey
              title
              isEditable
              versions {
                id
                name
              }
            }

            ... on LabelsField {
              fieldKey
              title
              isEditable
              labels
            }

            ... on ProjectComponentsField {
              fieldKey
              title
              isEditable
              componentValues {
                id
                name
              }
            }

            ... on TimeTrackingField {
              fieldKey
              title
              isEditable
              originalEstimate {
                estimateSeconds
              }
              remainingEstimate {
                estimateSeconds
              }
              timeSpent {
                estimateSeconds
              }
            }

            ... on StoryPointsField {
              fieldKey
              title
              isEditable
              floatValue
            }

            ... on EpicLinkField {
              fieldKey
              title
              isEditable
              epic {
                id
                key
                name
                summary
                colorKey
                done
              }
            }

            ... on EpicNameField {
              fieldKey
              stringValue
              title
              isEditable
            }

            ... on EpicStatusField {
              fieldKey
              title
              isEditable
              selectedValue {
                  optionId
                  value
              }
            }

            ... on SprintCustomField {
              fieldKey
              title
              isEditable
              values {
                id
                name
                goal
                state
                boardId
                startDate
                endDate
                completeDate
              }
            }

            ... on SelectCustomField {
              fieldKey
              title
              isEditable
              selectedValue {
                  optionId
                  value
              }
            }

            ... on CascadingSelectCustomField {
              fieldKey
              title
              isEditable
              selectedValue {
                  optionId
                  value
                  child {
                    optionId
                    value
                  }
              }
            }

            ... on UserPickerCustomField {
              fieldKey
              title
              isEditable
              selectedUser {
                displayName
                avatarUrl
              }
            }

            ... on TextAreaCustomField {
              fieldKey
              title
              isEditable
              wiki
              adf
              renderer
              textValue
            }

            ... on FloatCustomField {
              fieldKey
              title
              isEditable
              floatValue
            }

            ... on DatePickerCustomField {
              fieldKey
              title
              isEditable
              stringValue
            }

            ... on DateTimeCustomField {
              fieldKey
              title
              isEditable
              dateTime
            }

            ... on TextFieldCustomField {
              fieldKey
              title
              isEditable
              wiki
            }

            ... on MultiSelectCustomField {
              fieldKey
              title
              isEditable
              selectedValues {
                  optionId
                  value
              }
            }

            ... on LabelsCustomField {
              fieldKey
              title
              isEditable
              labels
            }

            ... on MultiUserPickerCustomField {
              fieldKey
              title
              isEditable
              selectedUsers {
                accountId
                displayName
                avatarUrl
              }
            }

            ... on UrlCustomField {
              fieldKey
              title
              isEditable
              url
            }

            ... on VersionCustomField {
              fieldKey
              title
              isEditable
              version {
                  id
                  name
              }
            }

            ... on GroupPickerCustomField {
              fieldKey
              title
              isEditable
              group
            }

            ... on MultiVersionCustomField {
              fieldKey
              title
              isEditable
              versions {
                  id
                  name
              }
            }

            ... on MultiGroupPickerCustomField {
              fieldKey
              title
              isEditable
              groups
            }

            ... on DateField {
              fieldKey
              stringValue
              isEditable
              title
            }

            ... on CheckBoxesCustomField {
                fieldKey
                isEditable
                title
                selectedValues {
                    optionId
                    value
                }
            }

            ... on RadioButtonsCustomField {
                fieldKey
                isEditable
                title
                selectedValue {
                    optionId
                    value
                }
            }

            ... on ColorField {
                fieldKey
                isEditable
                title
                stringValue
            }

            ... on EpicColorField {
                fieldKey
                isEditable
                title
                stringValue
            }

            ... on ResolutionField {
                id
                fieldKey
                name
            }

            ... on FlaggedCustomField {
                fieldKey
                title
                isFlagged
                isEditable
                selectedValues {
                    optionId
                    value
                }
            }

            ... on ProjectCustomField {
              fieldKey
              key
              name
              title
              avatarUrl
              isEditable
            }
        }
        ${$c265b6b62f0ef502$var$addQueryForRemoteLinks()}
        ${$c265b6b62f0ef502$var$getCommentsQuery()}
    `;
const $c265b6b62f0ef502$var$getQueryPrefix = ()=>'_all';
const $c265b6b62f0ef502$var$getFieldPinningPreference = (projectKey)=>projectKey != null ? `"jira.user.issue.details.pinned-fields.${projectKey}",` : '';
const $c265b6b62f0ef502$var$getQueryForMyPreferences = (projectKey)=>`
    myPreferences(keys: [
        "jira.user.issue.changeboarding.lastinteracted",
        "jira.user.issue.clickthrough-banner.lastinteracted",
        "jira.user.issue.pinned-fields-banner.lastinteracted",
        ${$c265b6b62f0ef502$var$getFieldPinningPreference(projectKey)}
    ])`;
const $c265b6b62f0ef502$var$getProjectQueryFragment = (projectKey)=>`
    project(projectKey: "${projectKey}") {
        newIssueViewLockedIn
    }
`;
const $c265b6b62f0ef502$export$71eec30d9db46a56 = (projectKey)=>`query issueViewQuery($issueKey: String!) {
    ${$c265b6b62f0ef502$var$getQueryForMyPreferences(projectKey)}
    ${projectKey !== undefined ? $c265b6b62f0ef502$var$getProjectQueryFragment(projectKey) : ''}
    ${$c265b6b62f0ef502$var$VIEW_ISSUE_ALIAS}${$c265b6b62f0ef502$var$getQueryPrefix()}: viewIssue(issueKey: $issueKey) {
        ${$c265b6b62f0ef502$export$895cf5b64d42d88d()}
    }
    activitySortOrder
}
`;
const $c265b6b62f0ef502$var$getFieldDataOptions = (query, variables)=>({
        method: 'POST',
        body: JSON.stringify({
            query: query,
            variables: variables
        }),
        perf: (0, $5WNEZ.fetchIssueExpressPerf)
    });
const $c265b6b62f0ef502$export$619c3be06a997564 = (baseUrl, issueKey)=>(0, $aiRd8.default)((0, $gIOVj.getGiraUrl)(baseUrl, 'issueViewRemoteDataQuery'), $c265b6b62f0ef502$var$getFieldDataOptions((0, $fwqh1.getIssueRemoteDataQuery)(), {
        issueKey: issueKey
    }))// @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'GraphqlResponse<ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse>'.
    .map((response)=>(0, $11LM5.getGraphQlData)($c265b6b62f0ef502$var$LOG_LOCATION, response))// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type '`bentoViewIssue${string}`' can't be used to index type 'ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse'.
    .map((value)=>value[`${$c265b6b62f0ef502$var$VIEW_ISSUE_ALIAS}${(0, $fwqh1.getRemoteDataQueryPrefix)()}`]);
const $c265b6b62f0ef502$export$886e1cd5d478fbe5 = (issueId, cloudId)=>(0, $aiRd8.default)('/gateway/api/graphql?operation=issueViewRemoteConfluenceWhiteboardQuery', $c265b6b62f0ef502$var$getFieldDataOptions((0, $fwqh1.getIssueRemoteConfluenceWhiteboardQuery)(), {
        id: `ari:cloud:jira:${cloudId}:issue/${issueId}`
    })).map((response)=>(0, $11LM5.getGraphQlData)($c265b6b62f0ef502$var$LOG_LOCATION, response));

});
parcelRegister("9s86T", function(module, exports) {

$parcel$export(module.exports, "getPermalinkTypeAndId", () => $6e310a2be6a89df8$export$f72cac1fa8a03e80);
$parcel$export(module.exports, "getPermalinkStatus", () => $6e310a2be6a89df8$export$f79ae8c396759c89);
$parcel$export(module.exports, "getUrlPermalinkParameter", () => $6e310a2be6a89df8$export$b66f3e03c722c21c);
$parcel$export(module.exports, "WORKLOG", () => (parcelRequire("6VKiL")).WORKLOG);
$parcel$export(module.exports, "COMMENTS", () => (parcelRequire("6VKiL")).COMMENTS);
$parcel$export(module.exports, "PermalinkType", () => (parcelRequire("6VKiL")).PermalinkType);

var $5iWql = parcelRequire("5iWql");

var $53ciZ = parcelRequire("53ciZ");

var $6VKiL = parcelRequire("6VKiL");
const $6e310a2be6a89df8$export$58d3deae755361f = (0, $5iWql.default)((searchString)=>{
    const params = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parseUrl(searchString).query;
    if (params[(0, $6VKiL.PermalinkType).COMMENTS]) return {
        permalinkType: (0, $6VKiL.COMMENTS),
        permalinkId: params[(0, $6VKiL.PermalinkType).COMMENTS]
    };
    if (params[(0, $6VKiL.PermalinkType).WORKLOG]) return {
        permalinkType: (0, $6VKiL.WORKLOG),
        permalinkId: params[(0, $6VKiL.PermalinkType).WORKLOG]
    };
    return null;
});
const $6e310a2be6a89df8$export$f72cac1fa8a03e80 = ()=>$6e310a2be6a89df8$export$58d3deae755361f(window.location.search);
const $6e310a2be6a89df8$export$f79ae8c396759c89 = (targetPermalinkType)=>{
    const { permalinkId: permalinkId, permalinkType: permalinkType } = $6e310a2be6a89df8$export$f72cac1fa8a03e80() || {};
    const hasPermalink = permalinkType === targetPermalinkType && permalinkId != null;
    return {
        hasPermalink: hasPermalink,
        permalinkId: hasPermalink ? permalinkId : ''
    };
};
const $6e310a2be6a89df8$export$b66f3e03c722c21c = (id, permalinkType)=>{
    const pathName = window.location.pathname;
    let urlQueryParam = `?${permalinkType}=${id}`;
    // in backlogs/modal view, next-gen board view, or jsd queues view
    if (/\/jira\/software\/c\/projects\/[^/]*\/boards\/.*/.test(pathName) || /\/jira\/people\/.*\/boards\/.*/.test(pathName) || pathName === '/secure/RapidBoard.jspa' || pathName.startsWith('/jira/software/projects/') && pathName.split('/')[5] === 'boards' || pathName.startsWith('/jira/servicedesk/projects/') && pathName.split('/')[5] === 'queues') {
        const url = new URL(window.location.href);
        // delete the opposite to avoid doubling up param in url
        url.searchParams.delete(permalinkType === (0, $6VKiL.PermalinkType).WORKLOG ? (0, $6VKiL.PermalinkType).COMMENTS : (0, $6VKiL.PermalinkType).WORKLOG);
        url.searchParams.set(permalinkType, id);
        urlQueryParam = url.search;
    }
    return urlQueryParam;
};

});
parcelRegister("6VKiL", function(module, exports) {

$parcel$export(module.exports, "COMMENTS", () => $5c63d4511ab79db4$export$4cab9dfa8fc858f4);
$parcel$export(module.exports, "WORKLOG", () => $5c63d4511ab79db4$export$df36fc05622c402);
$parcel$export(module.exports, "PermalinkType", () => $5c63d4511ab79db4$export$b18d061fc042df1a);
const $5c63d4511ab79db4$export$4cab9dfa8fc858f4 = 'Comments';
const $5c63d4511ab79db4$export$df36fc05622c402 = 'Worklog';
const $5c63d4511ab79db4$export$b18d061fc042df1a = {
    COMMENTS: 'focusedCommentId',
    WORKLOG: 'focusedWorklogId'
};

});


parcelRegister("5WNEZ", function(module, exports) {

$parcel$export(module.exports, "fetchIssueExpressPerf", () => $9e9290dca99e7c55$export$9040f8aef1f66451);
const $9e9290dca99e7c55$var$ISSUE_DETAILS_ANALYTICS_PREFIX = 'ISSUE_DETAILS';
const $9e9290dca99e7c55$var$FETCH_ISSUE_EXPRESS_REQUEST = 'FETCH_ISSUE_EXPRESS';
const $9e9290dca99e7c55$export$9040f8aef1f66451 = {
    key: $9e9290dca99e7c55$var$FETCH_ISSUE_EXPRESS_REQUEST,
    prefix: $9e9290dca99e7c55$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};

});

parcelRegister("fwqh1", function(module, exports) {

$parcel$export(module.exports, "getRemoteDataQueryPrefix", () => $2acde4462d7c1f98$export$1a164444721ce2fb);
$parcel$export(module.exports, "getIssueRemoteDataQuery", () => $2acde4462d7c1f98$export$65f9808f978ee25);
$parcel$export(module.exports, "getIssueRemoteConfluenceWhiteboardQuery", () => $2acde4462d7c1f98$export$8ec691b48e552cf4);
const $2acde4462d7c1f98$var$VIEW_ISSUE_ALIAS = 'bentoViewIssue';
const $2acde4462d7c1f98$var$getUserQueryFragment = ()=>`
    user {
        key
        accountId
        emailAddress
        avatarUrl
        displayName
        active
    }
`;
const $2acde4462d7c1f98$var$getConfluencePagesQueryFragment = ()=>`
    pages {
        ... on ConfluencePage {
            id
            globalId
            href
            title
            type
            lastUpdatedContext {
                ${$2acde4462d7c1f98$var$getUserQueryFragment()}
            }
        }
        ... on FailedRemoteLink {
            id
            error
            link {
                id
                globalId
                href
            }
            repairLink { href }
        }
    }
`;
const $2acde4462d7c1f98$var$getConfluencePageGroupQueryFragment = ()=>`
    pageCount
    ${$2acde4462d7c1f98$var$getConfluencePagesQueryFragment()}
`;
const $2acde4462d7c1f98$var$getRemoteLinkedIssuesPreviewFragment = ()=>`
    id
    issueId
    globalId
    href
    applicationType
    applicationName
    relationship
    title
`;
const $2acde4462d7c1f98$var$getAssociatedIssueFragment = ()=>`
    issueId
    issueKey {
        stringValue
    }
    summary {
        textValue
    }
    status {
        statusCategoryId
        name
        statusId
    }
    priority {
        iconUrl
        name
    }
    issueType {
        iconUrl
        name
    }
    assignee {
        userValue
        {
            displayName
            avatarUrl
        }
    }
   isResolved
`;
const $2acde4462d7c1f98$var$getRemoteLinkedIssuesDetailsFragment = ()=>`
    ... on AssociatedIssueWrapper {
        associatedIssue {
            ${$2acde4462d7c1f98$var$getAssociatedIssueFragment()}
        }
    }
    ... on FailedRemoteIssue {
        error
        repairLink { href }
    }
`;
const $2acde4462d7c1f98$var$getRemoteLinkedIssuesFragment = ()=>`
    remoteLinkedIssues {
        preview {
            ${$2acde4462d7c1f98$var$getRemoteLinkedIssuesPreviewFragment()}
        }
        details {
            ${$2acde4462d7c1f98$var$getRemoteLinkedIssuesDetailsFragment()}
        }
    }
`;
const $2acde4462d7c1f98$export$761fd517f0dda983 = ()=>`
    webLinks(allowThirdParties: true, orderBy: "-id") {
        linkCount
        links {
            id
            href
            linkText
            iconUrl
            summary
            resolved
            relationship
            applicationName
            applicationType
        }
    }
`;
const $2acde4462d7c1f98$var$getRemoteDataQueryFragment = ()=>`
    issueId
    remoteLinks {
       isLinkingEnabled
       confluencePages {
            linkedPages {
                ${$2acde4462d7c1f98$var$getConfluencePageGroupQueryFragment()}
            }
            mentionedPages {
                ${$2acde4462d7c1f98$var$getConfluencePageGroupQueryFragment()}
            }
        }
        ${$2acde4462d7c1f98$export$761fd517f0dda983()}
        ${$2acde4462d7c1f98$var$getRemoteLinkedIssuesFragment()}
    }
`;
const $2acde4462d7c1f98$export$1a164444721ce2fb = ()=>'_remote_data';
const $2acde4462d7c1f98$export$65f9808f978ee25 = ()=>`
    query issueViewRemoteDataQuery($issueKey: String!) {
        ${$2acde4462d7c1f98$var$VIEW_ISSUE_ALIAS}${$2acde4462d7c1f98$export$1a164444721ce2fb()}: viewIssue(issueKey: $issueKey) {
            ${$2acde4462d7c1f98$var$getRemoteDataQueryFragment()}
        }
    }
`;
const $2acde4462d7c1f98$export$8ec691b48e552cf4 = ()=>`
    query issueViewRemoteConfluenceWhiteboardQuery($id: ID!) {
        graphStore @optIn(to: "GraphStore") {
            issueToWhiteboard (id: $id first: 900) @optIn(to: "GraphStoreIssueToWhiteboard") {
                edges {
                    node {
                        ... on ConfluenceWhiteboard {
                            id
                            links {
                                base
                                webUi
                            }
                            author {
                                user {
                                accountId
                                accountStatus
                                name
                                picture
                                }
                            }
                            title
                            whiteboardId
                        }
                    }
                }
                totalCount
            }
        }
    }
`;

});

parcelRegister("11LM5", function(module, exports) {

$parcel$export(module.exports, "getGraphQlData", () => $c6aa0580bc22e808$export$b30cdd26702abb9d);
$parcel$export(module.exports, "checkEmptyResponse", () => $c6aa0580bc22e808$export$a0603b0ff181c30a);

var $gUUjF = parcelRequire("gUUjF");

var $7byHA = parcelRequire("7byHA");

var $l3WD8 = parcelRequire("l3WD8");
const $c6aa0580bc22e808$export$b30cdd26702abb9d = (logLocation, graphQlResponse)=>{
    if (graphQlResponse.errors) {
        const firstError = graphQlResponse.errors[0];
        const validationError = new (0, $7byHA.ValidationError)(firstError.message);
        (0, $gUUjF.default).safeErrorWithoutCustomerData(logLocation, 'getGraphQlData: Error present in GraphQL response', validationError);
        throw validationError;
    }
    return graphQlResponse.data;
};
const $c6aa0580bc22e808$var$emptyResponseText = 'Response is either not present or has no data.';
const $c6aa0580bc22e808$export$a0603b0ff181c30a = (response)=>{
    if (!response || !Object.prototype.hasOwnProperty.call(response, 'data')) throw new (0, $l3WD8.NoDataError)($c6aa0580bc22e808$var$emptyResponseText);
    if (response.data === null) throw new (0, $l3WD8.NoDataError)($c6aa0580bc22e808$var$emptyResponseText);
    return response;
};

});
parcelRegister("l3WD8", function(module, exports) {

$parcel$export(module.exports, "NoDataError", () => $001694e1095e542c$export$5faf0a0592e30f56);
class $001694e1095e542c$export$5faf0a0592e30f56 extends Error {
}

});



const $330b0f1977bf0938$export$40bed7a29c3b629 = 'IssueKeyField';








parcelRegister("eoHTi", function(module, exports) {

$parcel$export(module.exports, "default", () => $2753e6876d0a4886$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $2W6nG = parcelRequire("2W6nG");

var $7TyGu = parcelRequire("7TyGu");

var $1gQ73 = parcelRequire("1gQ73");

var $UFPYx = parcelRequire("UFPYx");
const $2753e6876d0a4886$var$Realtime = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const realtimeChannels = (0, $1gQ73.useBacklogSelector)((0, $UFPYx.realtimeChannelsSelector));
    if (realtimeChannels?.length === 0) return props.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2W6nG.RealtimeProvider), {
        appId: (0, $7TyGu.APP_ID),
        onJoin: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onReceive: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onLeave: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        channels: realtimeChannels
    }, props.children);
});
var $2753e6876d0a4886$export$2e2bcd8739ae039 = $2753e6876d0a4886$var$Realtime;

});
parcelRegister("2W6nG", function(module, exports) {

$parcel$export(module.exports, "RealtimeProvider", () => $ba1d3670c80098a4$export$64d242981d970821);

var $eUqFw = parcelRequire("eUqFw");

var $c8Guq = parcelRequire("c8Guq");

var $jG2Eu = parcelRequire("jG2Eu");

var $gUUjF = parcelRequire("gUUjF");

var $g8JvH = parcelRequire("g8JvH");

var $3FyZ4 = parcelRequire("3FyZ4");


var $e97Bh = parcelRequire("e97Bh");

var $eBLah = parcelRequire("eBLah");

var $eDbRL = parcelRequire("eDbRL");

const $ba1d3670c80098a4$var$createPubSubClient = (host, analyticsClient)=>(parcelRequire("gewAB")).then((module)=>{
        const Client = module.default;
        return new Client({
            product: (0, $b0799f8f855a2fe4$export$13ac40d1a5475532),
            url: `${host}`,
            apsProtocol: {
                enabled: true
            },
            analyticsClient: analyticsClient
        });
    });
const $ba1d3670c80098a4$export$c127c26e30518ed5 = (appId, client, channels, onHandler)=>client.join(channels).then(onHandler) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .catch((error)=>{
        // Ideally anonymous users shouldn't get there.
        // Ignoring 401 status codes until it is fixed on the app level.
        if (error && error.code === 401) return;
        (0, $gUUjF.default).safeErrorWithoutCustomerData('realtime.channel.join.failure', `Failed to join channel @ ${appId}`, error);
    });
const $ba1d3670c80098a4$export$e6c41c8aa28ddeb9 = (appId, client, channels, onHandler)=>client.leave(channels).then(onHandler) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .catch((error)=>{
        // Ideally anonymous users shouldn't get there.
        // Ignoring 401 status codes until it is fixed on the app level.
        if (error && error.code === 401) return;
        (0, $gUUjF.default).safeErrorWithoutCustomerData('realtime.channel.leave.failure', `Failed to left channel @ ${appId}`, error);
    });
// eslint-disable-next-line jira/react/no-class-components
class $ba1d3670c80098a4$var$RealtimeProviderView extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            host: (0, $b0799f8f855a2fe4$export$92ffb25149c24a33),
            onJoin: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onLeave: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    componentDidMount() {
        const { appId: appId, host: host, channels: channels } = this.props;
        this.isComponentMounted = true;
        (0, $3FyZ4.getAnalyticsWebClientPromise)().then((analyticsClient)=>$ba1d3670c80098a4$var$createPubSubClient(host, analyticsClient.getInstance())).then((pubSubClient)=>$ba1d3670c80098a4$export$c127c26e30518ed5(appId, pubSubClient, channels, this.onJoinChannel).then(()=>{
                if (this.isComponentMounted) this.setState({
                    client: pubSubClient
                });
            }));
    }
    componentDidUpdate({ channels: prevChannels }) {
        const { appId: appId, channels: newChannels } = this.props;
        const { client: client } = this.state;
        if (client && newChannels !== prevChannels) {
            const removedChannels = prevChannels.filter((channel)=>!newChannels.includes(channel));
            $ba1d3670c80098a4$export$e6c41c8aa28ddeb9(appId, client, removedChannels, this.onLeaveChannel);
            $ba1d3670c80098a4$export$c127c26e30518ed5(appId, client, newChannels, this.onJoinChannel);
        }
    }
    componentWillUnmount() {
        const { appId: appId, channels: channels } = this.props;
        const { client: client } = this.state;
        this.isComponentMounted = false;
        if (client) $ba1d3670c80098a4$export$e6c41c8aa28ddeb9(appId, client, channels, this.onLeaveChannel);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e97Bh.Provider), {
            value: {
                client: this.state.client
            }
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            client: null
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onJoinChannel = (result)=>{
            const { onJoin: onJoin } = this.props;
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onJoin(Array.from(result.currentChannels));
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onLeaveChannel = (result)=>{
            const { onLeave: onLeave } = this.props;
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onLeave(Array.from(result.currentChannels));
        };
        this.isComponentMounted = false;
    }
}
const $ba1d3670c80098a4$var$withAnalytics = (0, $g8JvH.AnalyticsEventToProps)('realtimeProvider', {
    onJoin: 'joinedChannel',
    onLeave: 'leftChannel'
});
const $ba1d3670c80098a4$export$64d242981d970821 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))($ba1d3670c80098a4$var$withAnalytics, (0, $eBLah.withHost), (0, $eDbRL.withRuntimeProvider))($ba1d3670c80098a4$var$RealtimeProviderView);
var $ba1d3670c80098a4$export$2e2bcd8739ae039 = $ba1d3670c80098a4$export$64d242981d970821;

});
const $b0799f8f855a2fe4$export$92ffb25149c24a33 = '/gateway/api/pubsub';
const $b0799f8f855a2fe4$export$13ac40d1a5475532 = 'JIRA';

parcelRegister("eBLah", function(module, exports) {

$parcel$export(module.exports, "withHost", () => $bd78fcaaefe05a83$export$b2d89aaea1461cd9);

var $eUqFw = parcelRequire("eUqFw");

var $giZl9 = parcelRequire("giZl9");
function $bd78fcaaefe05a83$export$b2d89aaea1461cd9(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ...props,
            host: (0, $giZl9.getDefaultPubSubHost)()
        });
}
var $bd78fcaaefe05a83$export$2e2bcd8739ae039 = $bd78fcaaefe05a83$export$b2d89aaea1461cd9;

});
parcelRegister("giZl9", function(module, exports) {

$parcel$export(module.exports, "getDefaultPubSubHost", () => $5615d21da29bd94b$export$f795b2d9ba365882);
$parcel$export(module.exports, "buildChannelString", () => $5615d21da29bd94b$export$354e43de513ff5);

var $6rW04 = parcelRequire("6rW04");

const $5615d21da29bd94b$export$f795b2d9ba365882 = ()=>(0, $6rW04.default)('ajs-fabric-realtime-url') || (0, $b0799f8f855a2fe4$export$92ffb25149c24a33);
const $5615d21da29bd94b$export$354e43de513ff5 = (cloudId, projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`;

});


parcelRegister("eDbRL", function(module, exports) {

$parcel$export(module.exports, "withRuntimeProvider", () => $e49daff82a9a2253$export$4b38d0b01368c3f4);

var $eUqFw = parcelRequire("eUqFw");
function $e49daff82a9a2253$export$4b38d0b01368c3f4(WrappedComponent) {
    return (props)=>{
        if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, props);
    };
}
var $e49daff82a9a2253$export$2e2bcd8739ae039 = $e49daff82a9a2253$export$4b38d0b01368c3f4;

});

parcelRegister("gewAB", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('acEmi');
        const value = parcelRequire('3S62s');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("acEmi").then(()=>parcelRequire('3S62s'));
}

});


parcelRegister("UFPYx", function(module, exports) {

$parcel$export(module.exports, "realtimeChannelsSelector", () => $cb111e9f87a2edb9$export$3d8a5aabe9d41ff7);

var $df4Sl = parcelRequire("df4Sl");

var $giZl9 = parcelRequire("giZl9");

var $hkGxG = parcelRequire("hkGxG");
const $cb111e9f87a2edb9$export$3d8a5aabe9d41ff7 = (0, $df4Sl.createSelector)((0, $hkGxG.getCloudId), (0, $hkGxG.getProjectIds), (cloudId, projectIds)=>projectIds.map((projectId)=>(0, $giZl9.buildChannelString)(cloudId, projectId)));

});


parcelRegister("3REKr", function(module, exports) {

$parcel$export(module.exports, "default", () => $84155579c5dbfafc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lzvR2 = parcelRequire("lzvR2");

var $7vf5z = parcelRequire("7vf5z");

var $grnp2 = parcelRequire("grnp2");

var $ieUWD = parcelRequire("ieUWD");

var $8wXFi = parcelRequire("8wXFi");

var $gPQCf = parcelRequire("gPQCf");

var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $k734R = parcelRequire("k734R");

var $9sGN6 = parcelRequire("9sGN6");

var $j258X = parcelRequire("j258X");

var $l9DvH = parcelRequire("l9DvH");
// Also fire BM3 metric.mark() for custom timings, on top of performance.mark() invocations
const $84155579c5dbfafc$var$SubmitApdexContainer = ({ isCacheHit: isCacheHit })=>{
    const issueNo = (0, $1gQ73.useBacklogSelector)((state)=>(0, $bP7Jx.cardsSelector)(state).length);
    const epicsNo = (0, $1gQ73.useBacklogSelector)((state)=>(0, $k734R.issueParentIdsSelector)(state).length);
    const issueChildrenNo = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.numTotalIssueChildren));
    const cardListCounts = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getCardListStats));
    const backlogSessionId = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getSessionId));
    const boardId = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getRapidViewId));
    const projectKey = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getProjectKey));
    const metric = (0, $l9DvH.usePerformanceMetric)();
    const isClassic = (0, $j258X.useIsCMPBacklog)();
    const { cohort: whiteboardCohort } = (0, $1gQ73.useBacklogSelector)((0, $9sGN6.getWhiteboardEligibility));
    const extra = (0, $eUqFw.useMemo)(()=>({
            ...(0, $lzvR2.getNormalisedPerformanceFFs)(),
            isCacheHit: isCacheHit,
            cacheInvalidationReasons: (0, $ieUWD.getAndClearInvalidationReasons)((0, $c22b1ee1fcd49c4a$export$dedbdcc35e955187)).join(','),
            issueNo: issueNo,
            epicsNo: epicsNo,
            issueChildrenNo: issueChildrenNo,
            backlogSessionId: backlogSessionId,
            boardId: boardId,
            projectKey: projectKey,
            ...cardListCounts,
            isSentryEnabled: String((0, $8wXFi.isErrorTrackingEnabledWithSentry)()),
            isPrefetchIssueDataByRankEnabled: false,
            isUIF: true,
            isClassic: isClassic,
            jswSprintPlanningWhiteboards: whiteboardCohort
        }), [
        isCacheHit,
        issueNo,
        epicsNo,
        issueChildrenNo,
        backlogSessionId,
        boardId,
        projectKey,
        cardListCounts,
        isClassic,
        whiteboardCohort
    ]);
    (0, $eUqFw.useEffect)(()=>{
        (0, $grnp2.pushEarlyMarksToBrowserMetrics)(metric, {
            marks: {
                BACKLOG_FETCH_START: (0, $gPQCf.JSW_CRITICAL_RESOURCE_START),
                'jira.fe.spa-prefetchApiReady': (0, $gPQCf.JSW_CRITICAL_RESOURCE_END),
                USE_RESOURCE_START_MARK: (0, $gPQCf.USE_RESOURCE_START),
                USE_RESOURCE_READY_MARK: (0, $gPQCf.USE_RESOURCE_READY),
                'render:start': (0, $gPQCf.RENDER_START),
                'render:end': (0, $gPQCf.RENDER_END),
                'relay_resource_get_data:NEXTGEN_BACKLOG_RELAY:start': (0, $gPQCf.CRITICAL_RELAY_RESOURCE_GET_DATA_START),
                'relay_resource_get_data:NEXTGEN_BACKLOG_RELAY:end': (0, $gPQCf.CRITICAL_RELAY_RESOURCE_GET_DATA_END)
            }
        });
    }, [
        metric
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vf5z.default), {
        extra: extra,
        appName: "software-backlog",
        // @ts-expect-error - TS2322 - Type 'PageLoadMetric' is not assignable to type 'BM3Metric'.
        metric: metric,
        emitOnAnimationFrame: (0, $8wXFi.emitApdexOnAnimationFrame)(),
        waitForLongTaskIdleTTI: (0, $8wXFi.isAlternateTTIMeasurementEnabled)()
    });
};
var $84155579c5dbfafc$export$2e2bcd8739ae039 = $84155579c5dbfafc$var$SubmitApdexContainer;

});
parcelRegister("grnp2", function(module, exports) {

$parcel$export(module.exports, "pushEarlyMarksToBrowserMetrics", () => $2941372c176917e8$export$b7c0f32f0c63e86b);
const $2941372c176917e8$export$2f0748f9bcbd5ff0 = {
    'jira.fe-spa.software.early-preload:start': 'EARLY_FETCH_START',
    'jira.fe-spa.software.early-preload:end': 'EARLY_FETCH_END'
};
const $2941372c176917e8$export$b7c0f32f0c63e86b = (metric, options)=>{
    const marks = {
        ...$2941372c176917e8$export$2f0748f9bcbd5ff0,
        ...options?.marks ?? {}
    };
    Object.keys(marks).forEach((mark)=>{
        const startTime = performance.getEntriesByName(mark)[0]?.startTime;
        if (startTime != null) metric.mark(marks[mark], startTime);
    });
};

});


parcelRegister("1Ieoq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d13272f59707475b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kJlBc = parcelRequire("kJlBc");

var $1gQ73 = parcelRequire("1gQ73");

var $1HfeQ = parcelRequire("1HfeQ");

var $a9os4 = parcelRequire("a9os4");

var $hkGxG = parcelRequire("hkGxG");

var $bP7Jx = parcelRequire("bP7Jx");

var $Kc1f0 = parcelRequire("Kc1f0");
const $d13272f59707475b$var$SyncWithRoutingContainer = ()=>{
    const lastSelectedCardId = (0, $1gQ73.useBacklogSelector)((0, $bP7Jx.getLastSelectedCard));
    const setLastSelectedCardKeyAction = (0, $1gQ73.useBacklogActionCreator)((0, $1HfeQ.setLastSelectedCardKey));
    const setAllPanelsAction = (0, $1gQ73.useBacklogActionCreator)((0, $a9os4.setAllPanels));
    const [{ action: action, location: location }] = (0, $kJlBc.useRouter)();
    const isCompanyManaged = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getIsCompanyManaged));
    const props = {
        lastSelectedCardId: lastSelectedCardId,
        setLastSelectedCardKey: setLastSelectedCardKeyAction,
        setAllPanels: setAllPanelsAction,
        action: action,
        location: location,
        isCompanyManaged: isCompanyManaged
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $Kc1f0.SyncWithRouting), props);
};
var $d13272f59707475b$export$2e2bcd8739ae039 = $d13272f59707475b$var$SyncWithRoutingContainer;

});
parcelRegister("Kc1f0", function(module, exports) {

$parcel$export(module.exports, "SyncWithRouting", () => $637f1652ad1160ea$export$6cfa8b91c03902d6);

var $eUqFw = parcelRequire("eUqFw");

var $53ciZ = parcelRequire("53ciZ");

const $637f1652ad1160ea$export$6cfa8b91c03902d6 = (props)=>{
    const { action: action, location: location, lastSelectedCardId: lastSelectedCardId, setLastSelectedCardKey: setLastSelectedCardKey, setAllPanels: setAllPanels, isCompanyManaged: isCompanyManaged = false } = props;
    const update = (0, $eUqFw.useCallback)(()=>{
        const { search: search } = location;
        const searchParams = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(search);
        if (!isCompanyManaged) setAllPanels();
        // Update Selected Card Key
        const selectedCardKeyFromParams = searchParams[0, $5a6592135d519f1e$export$3a0c4bc79274bbaa];
        if (!lastSelectedCardId && selectedCardKeyFromParams) setLastSelectedCardKey(selectedCardKeyFromParams);
    }, [
        location,
        lastSelectedCardId,
        setLastSelectedCardKey,
        setAllPanels,
        isCompanyManaged
    ]);
    const isMounted = (0, $eUqFw.useRef)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (!isMounted.current) {
            update();
            isMounted.current = true;
        }
    }, [
        update,
        isMounted
    ]);
    const loc = (0, $eUqFw.useRef)(location);
    (0, $eUqFw.useEffect)(()=>{
        if (action === 'POP' && loc.current !== location) update();
        loc.current = location;
    }, [
        action,
        location,
        update
    ]);
    return null;
};

});




parcelRegister("a2Kov", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ce60059828cab70$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $abAv3 = parcelRequire("abAv3");

var $1gQ73 = parcelRequire("1gQ73");

var $jAbil = parcelRequire("jAbil");

var $hkGxG = parcelRequire("hkGxG");

var $ai2KE = parcelRequire("ai2KE");

var $11PXg = parcelRequire("11PXg");
// register root level data-providers here
const $7ce60059828cab70$var$View = (props)=>{
    const { children: children, boardId: boardId } = props;
    const isCompanyManaged = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getIsCompanyManaged));
    const isVersionsFeatureEnabled = (0, $1gQ73.useBacklogSelector)((0, $ai2KE.isVersionsFeatureEnabled));
    const onFiltersChange = (0, $1gQ73.useBacklogActionCreator)((filters)=>(0, $jAbil.setAllFilters)(filters));
    // onSetAllFilters is a redux action fired to sync filters
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $abAv3.FiltersContainer), {
        boardId: boardId,
        onFiltersChange: onFiltersChange,
        isVersionsFeatureEnabled: isCompanyManaged || isVersionsFeatureEnabled,
        isCompanyManaged: isCompanyManaged
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $11PXg.VersionPanelEntrypointContextProvider), null, children));
};
var $7ce60059828cab70$export$2e2bcd8739ae039 = $7ce60059828cab70$var$View;

});
parcelRegister("abAv3", function(module, exports) {

$parcel$export(module.exports, "FiltersContainer", () => $335e6c2c4eb1a1f5$export$4e5fef3bf0d55c67);

var $eUqFw = parcelRequire("eUqFw");

var $53ciZ = parcelRequire("53ciZ");

var $heB5U = parcelRequire("heB5U");

var $3oq6o = parcelRequire("3oq6o");


var $eigjy = parcelRequire("eigjy");

var $hfC0x = parcelRequire("hfC0x");

var $3ovLR = parcelRequire("3ovLR");

var $4xtVG = parcelRequire("4xtVG");
const $335e6c2c4eb1a1f5$var$Container = (0, $heB5U.createContainer)((0, $hfC0x.FiltersStore), {
    onInit: ()=>({ dispatch: dispatch }, { isVersionsFeatureEnabled: isVersionsFeatureEnabled, isCompanyManaged: isCompanyManaged, boardId: boardId })=>{
            // set initial filters from URL
            const { search: search } = window.location;
            const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(search);
            let initialFilters = (0, $eigjy.getFiltersFromQuery)(queryParams, isVersionsFeatureEnabled);
            if (isCompanyManaged && Object.entries(initialFilters).length === 0) initialFilters = (0, $3oq6o.getCachedFilters)('backlog', boardId) ?? {};
            dispatch((0, $3ovLR.setFilters)(initialFilters));
        }
});
const $335e6c2c4eb1a1f5$export$4e5fef3bf0d55c67 = ({ boardId: boardId, onFiltersChange: onFiltersChange, children: children, isVersionsFeatureEnabled: isVersionsFeatureEnabled, isCompanyManaged: isCompanyManaged })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($335e6c2c4eb1a1f5$var$Container, {
        scope: `${(0, $5e78e7e537a59c6f$export$37f04a6502d23030)}-${String(boardId)}`,
        onFiltersChange: onFiltersChange,
        isVersionsFeatureEnabled: isVersionsFeatureEnabled,
        isCompanyManaged: isCompanyManaged,
        boardId: boardId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4xtVG.SyncWithRouting), {
        isVersionsFeatureEnabled: isVersionsFeatureEnabled
    })));

});
parcelRegister("eigjy", function(module, exports) {

$parcel$export(module.exports, "getFiltersFromQuery", () => $681c33144bccf23a$export$7b8e59218dd68efc);
$parcel$export(module.exports, "getQueryFromFilters", () => $681c33144bccf23a$export$aad56ffdcf894f3b);

const $681c33144bccf23a$var$toArray = (x)=>Array.isArray(x) ? x : x.split(',');
const $681c33144bccf23a$export$7b8e59218dd68efc = (searchParams, isVersionsFeatureEnabled)=>{
    const filtersFromQuery = {};
    // search comes from old CMP
    if (searchParams[0, $5e78e7e537a59c6f$export$a181206198b7f50c]) filtersFromQuery[0, $5e78e7e537a59c6f$export$d597759d33be802e] = searchParams[0, $5e78e7e537a59c6f$export$a181206198b7f50c];
    if (searchParams[0, $5e78e7e537a59c6f$export$e39925d10cebc0b]) filtersFromQuery[0, $5e78e7e537a59c6f$export$d597759d33be802e] = searchParams[0, $5e78e7e537a59c6f$export$e39925d10cebc0b];
    if (searchParams[0, $5e78e7e537a59c6f$export$f78d8c81fcad32a2]) filtersFromQuery[0, $5e78e7e537a59c6f$export$f8f7545d2bb78afb] = $681c33144bccf23a$var$toArray(searchParams[0, $5e78e7e537a59c6f$export$f78d8c81fcad32a2]);
    if (searchParams[0, $5e78e7e537a59c6f$export$e729d951ab128c3b]) filtersFromQuery[0, $5e78e7e537a59c6f$export$37aee82a3cb1e8f7] = $681c33144bccf23a$var$toArray(searchParams[0, $5e78e7e537a59c6f$export$e729d951ab128c3b]);
    if (searchParams[0, $5e78e7e537a59c6f$export$8a2cab795731dc42]) filtersFromQuery[0, $5e78e7e537a59c6f$export$2a4f270075a033de] = $681c33144bccf23a$var$toArray(searchParams[0, $5e78e7e537a59c6f$export$8a2cab795731dc42]);
    if (searchParams[0, $5e78e7e537a59c6f$export$392308739e657b75] && isVersionsFeatureEnabled) filtersFromQuery[0, $5e78e7e537a59c6f$export$a4ad2735b021c132] = $681c33144bccf23a$var$toArray(searchParams[0, $5e78e7e537a59c6f$export$392308739e657b75]);
    if (searchParams[0, $5e78e7e537a59c6f$export$fa7b72626a2e0090]) filtersFromQuery[0, $5e78e7e537a59c6f$export$ebb48b08205007c5] = $681c33144bccf23a$var$toArray(searchParams[0, $5e78e7e537a59c6f$export$fa7b72626a2e0090]);
    // quickFilters from the old CMP
    if (searchParams[0, $5e78e7e537a59c6f$export$163cc317352fc53e]) filtersFromQuery[0, $5e78e7e537a59c6f$export$68d693c35a8d8866] = $681c33144bccf23a$var$toArray(searchParams[0, $5e78e7e537a59c6f$export$163cc317352fc53e]);
    if (searchParams[0, $5e78e7e537a59c6f$export$cb08ebea4a46cd29]) filtersFromQuery[0, $5e78e7e537a59c6f$export$68d693c35a8d8866] = $681c33144bccf23a$var$toArray(searchParams[0, $5e78e7e537a59c6f$export$cb08ebea4a46cd29]);
    return filtersFromQuery;
};
const $681c33144bccf23a$export$aad56ffdcf894f3b = (filters)=>({
        [(0, $5e78e7e537a59c6f$export$e39925d10cebc0b)]: filters[0, $5e78e7e537a59c6f$export$d597759d33be802e] || undefined,
        // Replace CMP search with text above
        [(0, $5e78e7e537a59c6f$export$a181206198b7f50c)]: undefined,
        [(0, $5e78e7e537a59c6f$export$f78d8c81fcad32a2)]: filters[0, $5e78e7e537a59c6f$export$f8f7545d2bb78afb] ? filters[0, $5e78e7e537a59c6f$export$f8f7545d2bb78afb].join(',') : undefined,
        [(0, $5e78e7e537a59c6f$export$e729d951ab128c3b)]: filters[0, $5e78e7e537a59c6f$export$37aee82a3cb1e8f7] ? filters[0, $5e78e7e537a59c6f$export$37aee82a3cb1e8f7].join(',') : undefined,
        [(0, $5e78e7e537a59c6f$export$8a2cab795731dc42)]: filters[0, $5e78e7e537a59c6f$export$2a4f270075a033de] ? filters[0, $5e78e7e537a59c6f$export$2a4f270075a033de].join(',') : undefined,
        [(0, $5e78e7e537a59c6f$export$fa7b72626a2e0090)]: filters[0, $5e78e7e537a59c6f$export$ebb48b08205007c5] ? filters[0, $5e78e7e537a59c6f$export$ebb48b08205007c5].join(',') : undefined,
        [(0, $5e78e7e537a59c6f$export$392308739e657b75)]: filters[0, $5e78e7e537a59c6f$export$a4ad2735b021c132] ? filters[0, $5e78e7e537a59c6f$export$a4ad2735b021c132].join(',') : undefined,
        [(0, $5e78e7e537a59c6f$export$cb08ebea4a46cd29)]: filters[0, $5e78e7e537a59c6f$export$68d693c35a8d8866] ? filters[0, $5e78e7e537a59c6f$export$68d693c35a8d8866].join(',') : undefined,
        // Replace CMP quickFilter with customFilter
        [(0, $5e78e7e537a59c6f$export$163cc317352fc53e)]: undefined
    });

});

parcelRegister("4xtVG", function(module, exports) {

$parcel$export(module.exports, "SyncWithRouting", () => $a23f5a5628d71432$export$6cfa8b91c03902d6);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $iclz4 = parcelRequire("iclz4");


var $eigjy = parcelRequire("eigjy");

var $hfC0x = parcelRequire("hfC0x");
const $a23f5a5628d71432$export$6cfa8b91c03902d6 = /*#__PURE__*/ (0, $eUqFw.memo)(({ isVersionsFeatureEnabled: isVersionsFeatureEnabled })=>{
    const [filters, { setFilters: setFilters }] = (0, $hfC0x.useFilters)();
    const [queryParams, setQueryParams] = (0, $iclz4.useQueryParams)((0, $5e78e7e537a59c6f$export$e39925d10cebc0b), (0, $5e78e7e537a59c6f$export$a181206198b7f50c), (0, $5e78e7e537a59c6f$export$f78d8c81fcad32a2), (0, $5e78e7e537a59c6f$export$e729d951ab128c3b), (0, $5e78e7e537a59c6f$export$8a2cab795731dc42), (0, $5e78e7e537a59c6f$export$fa7b72626a2e0090), (0, $5e78e7e537a59c6f$export$392308739e657b75), (0, $5e78e7e537a59c6f$export$cb08ebea4a46cd29), (0, $5e78e7e537a59c6f$export$163cc317352fc53e));
    const filtersFromQuery = (0, $eUqFw.useMemo)(()=>(0, $eigjy.getFiltersFromQuery)(queryParams, isVersionsFeatureEnabled), [
        isVersionsFeatureEnabled,
        queryParams
    ]);
    const filtersRef = (0, $eUqFw.useRef)(filtersFromQuery);
    const queryFromFilters = (0, $eUqFw.useMemo)(()=>(0, $eigjy.getQueryFromFilters)(filters), [
        filters
    ]);
    // set as initially empty so we can sync the query parameters from the filters store
    const routeRef = (0, $eUqFw.useRef)({
        [(0, $5e78e7e537a59c6f$export$e39925d10cebc0b)]: undefined,
        [(0, $5e78e7e537a59c6f$export$a181206198b7f50c)]: undefined,
        [(0, $5e78e7e537a59c6f$export$f78d8c81fcad32a2)]: undefined,
        [(0, $5e78e7e537a59c6f$export$e729d951ab128c3b)]: undefined,
        [(0, $5e78e7e537a59c6f$export$8a2cab795731dc42)]: undefined,
        [(0, $5e78e7e537a59c6f$export$fa7b72626a2e0090)]: undefined,
        [(0, $5e78e7e537a59c6f$export$392308739e657b75)]: undefined,
        [(0, $5e78e7e537a59c6f$export$cb08ebea4a46cd29)]: undefined,
        [(0, $5e78e7e537a59c6f$export$163cc317352fc53e)]: undefined
    });
    // set initial filters from URL (prev componentDidMount)
    (0, $eUqFw.useEffect)(()=>{
        // Sync state -> url
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(queryFromFilters, routeRef.current)) {
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(queryParams, queryFromFilters)) setQueryParams(queryFromFilters);
            routeRef.current = queryFromFilters;
        }
    }, [
        setQueryParams,
        queryFromFilters,
        queryParams
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Sync url -> state
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(filtersFromQuery, filtersRef.current)) {
            // check if filters state is already updated to prevent useless update
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(filtersFromQuery, filters)) setFilters(filtersFromQuery);
            filtersRef.current = filtersFromQuery;
        }
    }, [
        filters,
        filtersFromQuery,
        setFilters
    ]);
    return null;
});

});


parcelRegister("11PXg", function(module, exports) {

$parcel$export(module.exports, "VersionPanelEntrypointContextProvider", () => $9f1f350cb210f626$export$e87f6587ec389c16);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $huI7r = parcelRequire("huI7r");

var $9C2ac = parcelRequire("9C2ac");

var $dWLk9 = parcelRequire("dWLk9");

var $2k5g9 = parcelRequire("2k5g9");

var $gPQCf = parcelRequire("gPQCf");

var $1rVrE = parcelRequire("1rVrE");

var $1gQ73 = parcelRequire("1gQ73");

var $hkGxG = parcelRequire("hkGxG");

var $l9Cwt = parcelRequire("l9Cwt");
const $9f1f350cb210f626$export$e87f6587ec389c16 = ({ children: children })=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const isFirstRender = (0, $eUqFw.useRef)(true);
    const isLoaded = (0, $eUqFw.useRef)(false);
    const isVersionPanelOpen = (0, $l9Cwt.useIsVersionsPanelOpen)();
    const projectIds = (0, $1gQ73.useBacklogSelector)((0, $hkGxG.getProjectIds));
    const jiraProjectIds = projectIds.map((id)=>(0, $huI7r.createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'project',
            resourceId: String(id)
        }));
    const boardARI = (0, $2k5g9.useBoardAri)();
    const entryPointParams = (0, $eUqFw.useMemo)(()=>({
            cloudId: cloudId,
            after: null,
            first: 500,
            jiraProjectIds: jiraProjectIds,
            boardId: boardARI,
            shouldShowVersionPanel: !!jiraProjectIds.length
        }), [
        boardARI,
        cloudId,
        jiraProjectIds
    ]);
    const entryPointHookResult = (0, $6j4bv.useEntryPoint)((0, $9C2ac.versionsPanelEntryPoint), entryPointParams, (0, $gPQCf.versionsPanelLoad));
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        if (!isLoaded.current && isVersionPanelOpen) {
            entryPointHookResult.entryPointActions.load();
            isLoaded.current = true;
        } else if (isFirstRender.current) {
            // if panel is open on first render - load versions panel
            if (isVersionPanelOpen) entryPointHookResult.entryPointActions.load();
            isFirstRender.current = false;
        }
    }, [
        entryPointHookResult,
        isVersionPanelOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1rVrE.VersionPanelEntrypointContext).Provider, {
        value: entryPointHookResult
    }, children);
};

});
parcelRegister("9C2ac", function(module, exports) {

$parcel$export(module.exports, "versionsPanelEntryPoint", () => $5627e385fa39be33$export$b707e1ce7d4339f2);

var $ib3kM = parcelRequire("ib3kM");

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $5627e385fa39be33$export$b707e1ce7d4339f2 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("fytfQ")), {
        moduleId: "a6db963d"
    }),
    getPreloadProps: (variables)=>({
            queries: {
                versionsPanel: {
                    options: {
                        // have to add "as const" https://stackoverflow.com/questions/37978528/typescript-type-string-is-not-assignable-to-type
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $ib3kM.default,
                    variables: variables
                }
            }
        })
});

});
parcelRegister("ib3kM", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ad2603e7763e9fa$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3009e39ea34352233851bcab9fb0fb9f>>
 * @relayHash ea81c42ee88f6f6b7345d1f475afbf69
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ce11c87f1d8dd20e2a8c431c2690eab2d33cb7835f0e966ed411c8a1976142ba
const $0ad2603e7763e9fa$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "ce11c87f1d8dd20e2a8c431c2690eab2d33cb7835f0e966ed411c8a1976142ba",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": [
                        "jira",
                        "versionsForProjects"
                    ]
                }
            ]
        },
        "name": "uiVersionBacklogPanelRelayQuery",
        "operationKind": "query",
        "text": null
    }
};
var $0ad2603e7763e9fa$export$2e2bcd8739ae039 = $0ad2603e7763e9fa$var$node;

});

parcelRegister("fytfQ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('eNjJ0');
        const value = parcelRequire('heTE1');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("eNjJ0").then(()=>parcelRequire('heTE1'));
}

});




parcelRegister("8vO0b", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e35871681bec67a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lA3UV = parcelRequire("lA3UV");

var $7TyGu = parcelRequire("7TyGu");

var $1gQ73 = parcelRequire("1gQ73");

var $jiL2Q = parcelRequire("jiL2Q");

var $k734R = parcelRequire("k734R");
const $1e35871681bec67a$var$GICOnCloseHandler = ({ bindToOnJiraGlobalIssueCreateClose: bindToOnJiraGlobalIssueCreateClose })=>{
    const dispatch = (0, $1gQ73.useBacklogDispatch)();
    const issueParents = (0, $1gQ73.useBacklogSelector)((state)=>(0, $k734R.issueParentsSelector)(state));
    const storeFieldsActions = (0, $lA3UV.useStoreFields)({
        issueParents: issueParents
    });
    (0, $eUqFw.useEffect)(()=>{
        bindToOnJiraGlobalIssueCreateClose((_, issues)=>{
            dispatch((0, $jiL2Q.refreshDataRequest)((0, $7TyGu.REFRESH_SOURCE_GLOBAL_ISSUE_CREATE), issues, storeFieldsActions));
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
var $1e35871681bec67a$export$2e2bcd8739ae039 = $1e35871681bec67a$var$GICOnCloseHandler;

});


parcelRegister("cYzE1", function(module, exports) {

$parcel$export(module.exports, "SuspenseTrackerProvider", () => $914c8793502251f7$export$58f6796252ab3147);
$parcel$export(module.exports, "SuspenseTrackerFallback", () => $914c8793502251f7$export$8637c61d65a3606b);
$parcel$export(module.exports, "useGetHasSuspended", () => $914c8793502251f7$export$a143cd14d496de4d);

var $eUqFw = parcelRequire("eUqFw");
class $914c8793502251f7$export$87993bf75925b3bd {
    getHasSuspended() {
        return this.suspendCount !== 0;
    }
    /**
	 * Should be called on unmount of the tracked sub-tree
	 */ reset() {
        this.suspendCount = 0;
    }
    /**
	 * Should be called when a suspend happens
	 */ onSuspend() {
        this.suspendCount += 1;
    }
    constructor(){
        this.suspendCount = 0;
    }
}
const $914c8793502251f7$var$SuspenseTrackerContext = /*#__PURE__*/ (0, $eUqFw.createContext)(new $914c8793502251f7$export$87993bf75925b3bd());
const $914c8793502251f7$export$58f6796252ab3147 = ({ children: children })=>{
    const suspenseTrackerRef = (0, $eUqFw.useRef)(new $914c8793502251f7$export$87993bf75925b3bd());
    (0, $eUqFw.useEffect)(()=>()=>{
            suspenseTrackerRef.current?.reset();
        }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($914c8793502251f7$var$SuspenseTrackerContext.Provider, {
        value: suspenseTrackerRef.current
    }, children);
};
const $914c8793502251f7$export$8637c61d65a3606b = ()=>{
    const suspenseTracker = (0, $eUqFw.useContext)($914c8793502251f7$var$SuspenseTrackerContext);
    (0, $eUqFw.useEffect)(()=>{
        suspenseTracker.onSuspend();
    }, [
        suspenseTracker
    ]);
    return null;
};
const $914c8793502251f7$export$a143cd14d496de4d = ()=>{
    const suspenseTracker = (0, $eUqFw.useContext)($914c8793502251f7$var$SuspenseTrackerContext);
    return suspenseTracker.getHasSuspended();
};

});

parcelRegister("fO5rB", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $0dcc4693f2e4993e$export$eb40d3df56aa5c53);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $cOnuN = parcelRequire("cOnuN");

var $6QL9v = parcelRequire("6QL9v");

var $kxBN8 = parcelRequire("kxBN8");

var $2SV7r = parcelRequire("2SV7r");
const $0dcc4693f2e4993e$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $2SV7r.isSubProductProps)(props) ? props.subProduct : (0, $6QL9v.subProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
        op: (0, $kxBN8.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOnuN.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("cOnuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e22c81c3ebeab6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lgxha = parcelRequire("lgxha");

var $j5W2t = parcelRequire("j5W2t");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3e22c81c3ebeab6$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: (0, $j5W2t.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("j5W2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8613fa53f568085a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8613fa53f568085a$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $lRmyA.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("kxBN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a7ec92a66826ce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
var $ds5Im = parcelRequire("ds5Im");
var $4DtuZ = parcelRequire("4DtuZ");


var $gUUjF = parcelRequire("gUUjF");

var $3FyZ4 = parcelRequire("3FyZ4");
const $95a7ec92a66826ce$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95a7ec92a66826ce$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $96da08ab2c7a3243$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $95a7ec92a66826ce$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4DtuZ.waitForHeritage)() : null, ()=>(0, $2BvS3.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $ds5Im.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $96da08ab2c7a3243$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("2SV7r", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $5e5ef73a1d4e492a$export$c3063d6d7a8c075f);
const $5e5ef73a1d4e492a$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $5e5ef73a1d4e492a$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});


parcelRegister("3FCHp", function(module, exports) {

$parcel$export(module.exports, "BacklogCriticalDataBoundary", () => $f729d06043d2509a$export$70778fd35e1f4a0d);
// eslint-disable-next-line max-classes-per-file

var $eUqFw = parcelRequire("eUqFw");

var $lgAsZ = parcelRequire("lgAsZ");

var $7byHA = parcelRequire("7byHA");
var $JRB5w = parcelRequire("JRB5w");

var $15ZJO = parcelRequire("15ZJO");

var $naWQb = parcelRequire("naWQb");

var $3YysV = parcelRequire("3YysV");
class $f729d06043d2509a$var$AGGErrors extends (0, $lgAsZ.default) {
    constructor(errors, traceId){
        // this is used to generate same 'hash' for error flag and sla event attribute
        super(errors[0].message, {
            cause: errors[0]
        });
        this.name = 'AGGError';
        this.graphQLErrors = errors;
        this.traceId = traceId;
    }
}
class $f729d06043d2509a$export$70778fd35e1f4a0d extends (0, $eUqFw.Component) {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.error && !state.capturedErrors) {
            // Look for errors in backend response
            const capturedGQLErrorsInfo = (0, $15ZJO.stopCaptureGraphQlErrors)(props.errorCaptureKey);
            const validGQLErrorsInfo = capturedGQLErrorsInfo.find((err)=>err.meta.operationName === props.backlogRootQueryName);
            if (validGQLErrorsInfo?.errors.length) return {
                ...state,
                capturedErrors: validGQLErrorsInfo.errors,
                capturedErrorsMeta: validGQLErrorsInfo.meta
            };
        }
        return null;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null,
            capturedErrors: null
        };
    }
    render() {
        /* If there are no caught errors, render children as usual.
           This could mean there are optional GraphQL errors which won't be captured. If needed use @required to capture them. */ if (!this.state.error) return this.props.children;
        if (this.state.capturedErrors?.length) {
            const aggError = new $f729d06043d2509a$var$AGGErrors(this.state.capturedErrors, this.state.capturedErrorsMeta?.requestId);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $naWQb.BacklogSlaTracker), {
                error: aggError
            });
        }
        // Capture the following errors related to backlog critical data the endpoint:
        // 1. Network errors
        // 2. RelayNetwork error - No data returned for operation
        if (this.state.error instanceof (0, $7byHA.default) || (0, $3YysV.isUserNetworkError)(this.state.error) || (0, $JRB5w.isClientFetchError)(this.state.error) || this.state.error.name === 'RelayNetwork') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $naWQb.BacklogSlaTracker), {
            error: this.state.error
        });
        /* If the error is not something related to the backlog critical data, which we specifically handle above,
           we need to throw so upper error boundary (ExperienceTrackerProvider) can catch and handle it.
           These also include clientside Relay @required errors which doesn't have a corresponding GraphQL error in the backend response */ throw this.state.error;
    }
}

});

parcelRegister("grcgD", function(module, exports) {

$parcel$export(module.exports, "useGetDataFromAGG", () => $6e219e433f4f734b$export$f721677ef2b26eae);

var $eUqFw = parcelRequire("eUqFw");

var $cNy9K = parcelRequire("cNy9K");

var $huI7r = parcelRequire("huI7r");

var $amu7D = parcelRequire("amu7D");

var $3mjFf = parcelRequire("3mjFf");
const $6e219e433f4f734b$export$f721677ef2b26eae = ({ cloudId: cloudId, boardId: boardId })=>{
    const [fetchError, setFetchError] = (0, $eUqFw.useState)();
    const getDataFromAGG = (0, $eUqFw.useCallback)(async (captureError = false)=>{
        const boardAri = (0, $huI7r.createAri)({
            resourceOwner: 'jira-software',
            cloudId: cloudId,
            resourceType: 'board',
            resourceId: String(boardId)
        });
        const variables = {
            boardId: boardAri,
            cloudId: cloudId
        };
        const fetchResponse$ = (0, $cNy9K.fetchQuery)((0, $amu7D.default)(), (0, $3mjFf.default), variables);
        fetchResponse$.subscribe({
            error: captureError ? setFetchError : undefined
        });
        const responseData = await fetchResponse$.toPromise();
        if (!responseData) throw new Error(`${(0, $3mjFf.default).params.name} returned undefined`);
        return responseData;
    }, [
        boardId,
        cloudId
    ]);
    if (fetchError) throw fetchError;
    return getDataFromAGG;
};

});

parcelRegister("fJY8E", function(module, exports) {

$parcel$export(module.exports, "isBacklogDisabledFromAggData", () => $ff8697a066763104$export$21ab9a52bb2020c0);

var $4m36T = parcelRequire("4m36T");

const $ff8697a066763104$export$386a9e1b526d9276 = (defaultUnit)=>{
    switch(defaultUnit.toLowerCase()){
        case (0, $4m36T.TimeUnits).DAY:
            return (0, $4m36T.TimeUnits).DAY;
        case (0, $4m36T.TimeUnits).HOUR:
            return (0, $4m36T.TimeUnits).HOUR;
        case (0, $4m36T.TimeUnits).MINUTE:
            return (0, $4m36T.TimeUnits).MINUTE;
        case (0, $4m36T.TimeUnits).WEEK:
            return (0, $4m36T.TimeUnits).WEEK;
        default:
            return (0, $4m36T.TimeUnits).DAY;
    }
};
const $ff8697a066763104$export$8140cb9d29c60b3b = (format)=>{
    switch(format.toLowerCase()){
        case (0, $4m36T.TimeFormats).DAYS:
            return (0, $4m36T.TimeFormats).DAYS;
        case (0, $4m36T.TimeFormats).HOURS:
            return (0, $4m36T.TimeFormats).HOURS;
        case (0, $4m36T.TimeFormats).PRETTY:
            return (0, $4m36T.TimeFormats).PRETTY;
        default:
            return (0, $4m36T.TimeFormats).DAYS;
    }
};
const $ff8697a066763104$export$21ab9a52bb2020c0 = (aggData)=>{
    if (!aggData || !aggData.boardScope || !aggData.boardScope.features) return true;
    const filteredFeatures = aggData.boardScope.features.filter(Boolean);
    const backlogFeature = filteredFeatures.some((feature)=>String(feature.key) === (0, $ce79b29fab1e78a6$export$dedbdcc35e955187) && String(feature.status) === (0, $ce79b29fab1e78a6$export$e927a5d1b72f0b68));
    return !backlogFeature;
};

});


parcelRegister("6Pp4s", function(module, exports) {

$parcel$export(module.exports, "default", () => $5abef3fde3c7e6f3$export$2e2bcd8739ae039);
parcelRequire("kQSGw");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $6iz4v = parcelRequire("6iz4v");

var $bAQOb = parcelRequire("bAQOb");

var $aULnw = parcelRequire("aULnw");

var $huI7r = parcelRequire("huI7r");

var $eI64M = parcelRequire("eI64M");

var $buJlM = parcelRequire("buJlM");

var $jZqFH = parcelRequire("jZqFH");

var $kJlBc = parcelRequire("kJlBc");
var $3HCkE = parcelRequire("3HCkE");

var $59z8J = parcelRequire("59z8J");

var $gFGRe = parcelRequire("gFGRe");

var $9ohLM = parcelRequire("9ohLM");

var $fO5rB = parcelRequire("fO5rB");

var $67e83 = parcelRequire("67e83");

var $gd0Sp = parcelRequire("gd0Sp");


var $fv2PY = parcelRequire("fv2PY");

var $5SlaJ = parcelRequire("5SlaJ");
const $5abef3fde3c7e6f3$export$ad5cd5a1ff804acc = ()=>{
    const [paramProjectKey] = (0, $kJlBc.usePathParam)('projectKey');
    const [boardIdStr] = (0, $kJlBc.usePathParam)('boardId');
    const boardId = Number(boardIdStr);
    const projectKey = paramProjectKey ?? '';
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    (0, $fv2PY.useOnce)(()=>{
        (0, $6iz4v.setMark)((0, $ce79b29fab1e78a6$export$b5f697f1279a473e));
    });
    const jiraPlanDataRestResource = (0, $3HCkE.useResource)((0, $gFGRe.uifBacklogResourceOld));
    (0, $fv2PY.useOnce)(()=>{
        (0, $6iz4v.setMark)((0, $ce79b29fab1e78a6$export$a6940922387b16));
    });
    (0, $fv2PY.useOnce)(()=>{
        (0, $6iz4v.setMark)((0, $ce79b29fab1e78a6$export$e9163c48bfd4013e));
    }, ()=>!!jiraPlanDataRestResource.data);
    const response = (0, $buJlM.useRelayResource)((0, $59z8J.customFiltersResource));
    const customFiltersQueryRef = response.queryReference;
    const isCacheHitRef = (0, $eUqFw.useRef)(jiraPlanDataRestResource.data != null);
    const isCacheHit = isCacheHitRef.current;
    const { data: data, promise: promise, loading: loading, error: error } = jiraPlanDataRestResource;
    const { data: features } = (0, $aULnw.useFeatures)();
    const [versionFilterRelayQueryRef, loadVersionFilterRelayQuery] = (0, $iWLL0.useQueryLoader)((0, $jZqFH.default));
    (0, $eUqFw.useEffect)(()=>{
        if (loadVersionFilterRelayQuery !== null && data?.projects?.length) {
            const jiraProjectIds = data.projects.map((project)=>(0, $huI7r.createAri)({
                    resourceOwner: 'jira',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'project',
                    resourceId: `${project.id}`
                }));
            loadVersionFilterRelayQuery({
                jiraProjectIds: jiraProjectIds,
                first: 500,
                after: null
            });
        }
    }, [
        loadVersionFilterRelayQuery,
        tenantContext.cloudId,
        data?.projects
    ]);
    /**
	 * Redirect to the board only if the backlog is disabled. Do not redirect on timeout.
	 *
	 * If features.hasBacklog is undefined but the resource has returned a 404 due to
	 * the backlog being disabled, this error will be passed through to responseToSla in
	 * the BacklogApp which will redirect to the projects page as a fallback.
	 *
	 * */ if (loading === false && features?.hasBacklog === false) {
        const boardUrl = (0, $fv2PY.getCMPBoardUrl)(projectKey, String(boardId));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
            to: boardUrl
        });
    }
    const backlogEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
        subProduct: "software"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5SlaJ.default), {
        rapidViewId: boardId,
        projectKeyFromContext: projectKey,
        projectIdFromContext: "",
        tenantContext: tenantContext,
        data: null,
        aggData: null,
        planModeData: data,
        planModeDataPromise: promise,
        error: error,
        loading: loading,
        isCacheHit: isCacheHit,
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9ohLM.default), {
        resource: jiraPlanDataRestResource,
        refreshOnExpired: true
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $67e83.Breadcrumbs), null), backlogEl, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eI64M.default), {
        projectKey: projectKey
    }));
};
const $5abef3fde3c7e6f3$export$dff34c560328b03c = ()=>{
    const [paramProjectKey] = (0, $kJlBc.usePathParam)('projectKey');
    const [boardIdStr] = (0, $kJlBc.usePathParam)('boardId');
    const boardId = Number(boardIdStr);
    const projectKey = paramProjectKey ?? '';
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    (0, $fv2PY.useOnce)(()=>{
        (0, $6iz4v.setMark)((0, $ce79b29fab1e78a6$export$b5f697f1279a473e));
    });
    const uifBacklogDataResult = (0, $3HCkE.useResource)((0, $gFGRe.uifBacklogResource));
    (0, $fv2PY.useOnce)(()=>{
        (0, $6iz4v.setMark)((0, $ce79b29fab1e78a6$export$a6940922387b16));
    });
    (0, $fv2PY.useOnce)(()=>{
        (0, $6iz4v.setMark)((0, $ce79b29fab1e78a6$export$e9163c48bfd4013e));
    }, ()=>!!uifBacklogDataResult.data);
    const response = (0, $buJlM.useRelayResource)((0, $59z8J.customFiltersResource));
    const customFiltersQueryRef = response.queryReference;
    const isCacheHitRef = (0, $eUqFw.useRef)(Boolean(uifBacklogDataResult.data?.isCacheHit));
    const isCacheHit = isCacheHitRef.current;
    const { data: data, promise: promise, loading: loading, error: error } = uifBacklogDataResult;
    const { data: features } = (0, $aULnw.useFeatures)();
    const [versionFilterRelayQueryRef, loadVersionFilterRelayQuery] = (0, $iWLL0.useQueryLoader)((0, $jZqFH.default));
    (0, $eUqFw.useEffect)(()=>{
        if (loadVersionFilterRelayQuery !== null && data?.result?.projects?.length) {
            const jiraProjectIds = data.result.projects.map((project)=>(0, $huI7r.createAri)({
                    resourceOwner: 'jira',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'project',
                    resourceId: `${project.id}`
                }));
            loadVersionFilterRelayQuery({
                jiraProjectIds: jiraProjectIds,
                first: 500,
                after: null
            });
        }
    }, [
        loadVersionFilterRelayQuery,
        tenantContext.cloudId,
        data?.result?.projects
    ]);
    /**
	 * Redirect to the board only if the backlog is disabled. Do not redirect on timeout.
	 *
	 * If features.hasBacklog is undefined but the resource has returned a 404 due to
	 * the backlog being disabled, this error will be passed through to responseToSla in
	 * the BacklogApp which will redirect to the projects page as a fallback.
	 *
	 * */ if (loading === false && features?.hasBacklog === false) {
        const boardUrl = (0, $fv2PY.getCMPBoardUrl)(projectKey, String(boardId));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
            to: boardUrl
        });
    }
    const backlogEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
        subProduct: "software"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5SlaJ.default), {
        rapidViewId: boardId,
        projectKeyFromContext: projectKey,
        projectIdFromContext: "",
        tenantContext: tenantContext,
        data: null,
        aggData: null,
        cmpBacklogData: data,
        cmpBacklogDataPromise: promise,
        error: error,
        loading: loading,
        isCacheHit: isCacheHit,
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9ohLM.default), {
        resource: uifBacklogDataResult,
        refreshOnExpired: true
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $67e83.Breadcrumbs), null), backlogEl, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eI64M.default), {
        projectKey: projectKey
    }));
};
var $5abef3fde3c7e6f3$export$2e2bcd8739ae039 = (0, $bAQOb.componentWithFF)('jsw.perf.enable-indexeddb-caching-for-backlog', $5abef3fde3c7e6f3$export$dff34c560328b03c, $5abef3fde3c7e6f3$export$ad5cd5a1ff804acc);

});
parcelRegister("aULnw", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $891c449596ae78db$export$4a39035bacc4ed76);

var $eUqFw = parcelRequire("eUqFw");

var $2futN = parcelRequire("2futN");

var $knS3A = parcelRequire("knS3A");
const $891c449596ae78db$export$4a39035bacc4ed76 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2futN.useJiraSoftwareProjectNavigation)();
    const extractedData = (0, $eUqFw.useMemo)(()=>data && (0, $knS3A.extractData)(data), [
        data
    ]);
    return {
        data: extractedData,
        loading: loading,
        error: error
    };
};

});
parcelRegister("knS3A", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $3e46d2b0a0801aa3$export$9df5fa0a366163d2);

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");
const $3e46d2b0a0801aa3$export$9df5fa0a366163d2 = (data)=>{
    const { permissionInfo: permissionInfo, hasBoard: hasBoard, hasBacklog: hasBacklog, hasRoadmap: hasRoadmap, hasReports: hasReports, hasCode: hasCode, hasGoals: hasGoals, hasSecurity: hasSecurity, hasDeployments: hasDeployments, hasPages: hasPages, hasOpsgenieSchedule: hasOpsgenieSchedule, hasIssues: hasIssues, hasReleases: hasReleases, hasRequests: hasRequests, hasIncidents: hasIncidents, aiInfo: aiInfo, hasList: hasList, hasCalendar: hasCalendar } = data;
    const isProjectOrSiteAdmin = permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS === true;
    return {
        hasBoard: hasBoard,
        hasBacklog: hasBacklog,
        hasShortcutsAdd: isProjectOrSiteAdmin,
        hasSettings: isProjectOrSiteAdmin,
        hasRoadmap: hasRoadmap,
        hasCode: hasCode,
        hasGoals: hasGoals,
        hasSecurity: hasSecurity,
        hasDeployments: hasDeployments,
        hasOpsgenieSchedule: hasOpsgenieSchedule,
        hasPages: hasPages,
        hasIssues: hasIssues,
        hasReleases: hasReleases,
        hasRequests: hasRequests,
        hasIncidents: hasIncidents,
        hasComponents: true,
        hasList: (0, $79xbN.expValEquals)('jsw_list_view', 'cohort', 'variation') ? hasList : false,
        hasCalendar: (0, $1ybV0.ff)('jsw-calendar-view') && hasCalendar,
        hasAIInNIN: hasIssues && aiInfo?.isEnabledInIssueNavigator === true,
        hasReports: hasReports
    };
};

});


parcelRegister("9ohLM", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c8dd705c55dbbc3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fee69 = parcelRequire("fee69");

var $78d1w = parcelRequire("78d1w");
/**
 * Refresh the resource on mount if it's not already loading or stale, resource from prefetch will have 10s expiry time.
 */ const $0c8dd705c55dbbc3$var$RefreshResourceOnMount = ({ resource: resource, refreshOnExpired: refreshOnExpired })=>{
    const [{ isInitialRender: isInitialRender }] = (0, $78d1w.useSpaStateTransition)();
    // Store these values once, we don't want the useEffect proccing more than once after mount
    const [isFullRender] = (0, $eUqFw.useState)(isInitialRender);
    const [hasCache, setHasCache] = (0, $eUqFw.useState)(false);
    const [hasRefreshed, setHasRefreshed] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (resource === null || hasRefreshed) return;
        // If we started loading set the cache miss flag to true. React-resource-router procs this
        // on page load
        if (resource.loading || refreshOnExpired && resource.expiresAt && resource.expiresAt > Date.now()) {
            setHasCache(true);
            return;
        }
        // If this is not a full render (i.e. a SPA transition)
        // And this is a cache miss (our requested resource never got set to loading true)
        if (!isFullRender && !hasCache) {
            resource.refresh();
            setHasRefreshed(true);
        }
    }, [
        hasRefreshed,
        hasCache,
        isFullRender,
        resource,
        refreshOnExpired
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
};
const $0c8dd705c55dbbc3$var$RefreshResourceOnMountWithBoundaries = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorBoundaryFlag), {
        id: "jira-software-resource-invalidator"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0c8dd705c55dbbc3$var$RefreshResourceOnMount, props));
var $0c8dd705c55dbbc3$export$2e2bcd8739ae039 = $0c8dd705c55dbbc3$var$RefreshResourceOnMountWithBoundaries;

});

parcelRegister("67e83", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", () => $ca520be9beccd9ee$export$2dc68d50d56fbbd);

var $eUqFw = parcelRequire("eUqFw");

var $i889l = parcelRequire("i889l");
var $SEaoU = parcelRequire("SEaoU");

var $6dAo3 = parcelRequire("6dAo3");

var $gTeyj = parcelRequire("gTeyj");

var $37nHj = parcelRequire("37nHj");
const $ca520be9beccd9ee$export$2dc68d50d56fbbd = ()=>{
    const [{ data: data, error: error }] = (0, $SEaoU.useContainerContext)();
    const { chartView: chartView, boardId: boardId, isBoardLocationless: isBoardLocationless, isReportsView: isReportsView, accountId: accountId } = (0, $6dAo3.useUrlState)();
    if (!data || error) return null;
    const boardName = data.scope && data.scope.name || '';
    if ((0, $i889l.isUserContext)(data) && accountId) {
        const { user: user } = data;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $37nHj.UserBreadcrumbs), {
            accountId: accountId,
            boardId: Number(boardId),
            boardName: boardName,
            isReportsView: isReportsView,
            profileUrl: user.profileUrl,
            userName: user.name,
            chart: chartView,
            isLocationlessBoard: isBoardLocationless
        });
    }
    if ((0, $i889l.isProjectContext)(data)) {
        const { project: project } = data;
        const projectKey = project.key;
        const projectName = project.name;
        const projectId = project.id;
        const isSimplifiedProject = project.isSimplified;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gTeyj.ProjectBreadcrumbs), {
            baseUrl: "",
            boardId: Number(boardId),
            boardName: boardName,
            chart: chartView,
            projectKey: projectKey,
            projectName: projectName,
            projectId: projectId,
            isSimplifiedProject: isSimplifiedProject
        });
    }
    return null;
};

});
parcelRegister("6dAo3", function(module, exports) {

$parcel$export(module.exports, "useUrlState", () => $0f22a815527cc869$export$6a582373474709af);

var $kJlBc = parcelRequire("kJlBc");

var $hohfE = parcelRequire("hohfE");
const $0f22a815527cc869$export$6a582373474709af = ()=>{
    const [{ query: query, route: route, match: match }] = (0, $kJlBc.useRouter)();
    const { rapidView: rapidView, chart: chart, view: view, config: config, projectKey: queryProjectKey, locationless: locationless } = query;
    const { accountId: accountId } = match.params;
    const isBoardLocationless = !!locationless;
    const shouldUsePrettyUrlState = !isBoardLocationless;
    const mode = shouldUsePrettyUrlState ? (0, $hohfE.getModeV2)(route) : (0, $hohfE.getMode)(view);
    const boardId = shouldUsePrettyUrlState ? match.params.boardId : rapidView;
    const projectKey = shouldUsePrettyUrlState ? match.params.projectKey : queryProjectKey;
    const chartView = shouldUsePrettyUrlState ? (0, $hohfE.toCamelCaseChartView)(match.params.chartView || '') : chart;
    const isReportsView = query && query.view === 'reporting';
    return {
        accountId: accountId,
        mode: mode,
        boardId: boardId,
        chartView: chartView,
        projectKey: projectKey,
        routeName: route.name,
        config: config,
        isBoardLocationless: isBoardLocationless,
        isReportsView: isReportsView
    };
};

});
parcelRegister("hohfE", function(module, exports) {

$parcel$export(module.exports, "toCamelCaseChartView", () => $dcfda04d03f0bf79$export$f1cb745981250009);
$parcel$export(module.exports, "getMode", () => $dcfda04d03f0bf79$export$1fc0f6205829e19c);
$parcel$export(module.exports, "getModeV2", () => $dcfda04d03f0bf79$export$cc65f5a30b63da10);

var $jh2R9 = parcelRequire("jh2R9");

var $exb0h = parcelRequire("exb0h");

const $dcfda04d03f0bf79$export$f1cb745981250009 = (chartView)=>(0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(chartView);
const $dcfda04d03f0bf79$export$1fc0f6205829e19c = (view)=>{
    switch(view){
        case 'planning':
        case 'planning.nodetail':
            return 0, $47dd4d63e049296c$export$c303e491e026ebc6;
        case 'reporting':
            return 0, $47dd4d63e049296c$export$e3d31417f21c1ce7;
        default:
            return 0, $47dd4d63e049296c$export$77d6f70978850641;
    }
};
const $dcfda04d03f0bf79$export$cc65f5a30b63da10 = (route)=>{
    if (!route) return 0, $47dd4d63e049296c$export$77d6f70978850641;
    switch(route.name){
        case (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_BACKLOG:
        case (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_USER_BACKLOG:
            return 0, $47dd4d63e049296c$export$c303e491e026ebc6;
        case (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_REPORT:
        case (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_USER_REPORT:
            return 0, $47dd4d63e049296c$export$e3d31417f21c1ce7;
        default:
            return 0, $47dd4d63e049296c$export$77d6f70978850641;
    }
};

});
const $47dd4d63e049296c$export$77d6f70978850641 = 'work';
const $47dd4d63e049296c$export$c303e491e026ebc6 = 'plan';
const $47dd4d63e049296c$export$e3d31417f21c1ce7 = 'report';



parcelRegister("gTeyj", function(module, exports) {

$parcel$export(module.exports, "ProjectBreadcrumbs", () => $76cae58ec2fbbc2c$export$38f8c59e2af08a87);

var $eUqFw = parcelRequire("eUqFw");

var $kKe2o = parcelRequire("kKe2o");
var $dpXKE = parcelRequire("dpXKE");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dLzhb = parcelRequire("dLzhb");
const $76cae58ec2fbbc2c$export$38f8c59e2af08a87 = /*#__PURE__*/ (0, $eUqFw.memo)(({ baseUrl: baseUrl, boardId: boardId, boardName: boardName, projectKey: projectKey, projectName: projectName, projectId: projectId, isSimplifiedProject: isSimplifiedProject, chart: chart })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpXKE.default), {
        baseUrl: baseUrl,
        projectKey: projectKey,
        projectName: projectName,
        projectId: projectId,
        isSimplifiedProject: isSimplifiedProject
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKe2o.default), {
        breadcrumb: {
            text: boardName,
            href: `/jira/software/c/projects/${projectKey}/boards/${boardId}`,
            type: 'boardName',
            analyticsAttributes: {
                nextGenProject: isSimplifiedProject,
                projectConfig: isSimplifiedProject ? 'next-gen' : 'classic'
            },
            analyticsFields: {
                name: 'navigateToSubProject',
                containerId: projectId,
                containerType: 'project'
            }
        }
    }, chart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKe2o.default), {
        breadcrumb: {
            text: formatMessage((0, $dLzhb.messages).projectReportBreadcrumb),
            href: `/projects/${projectKey}?selectedItem=com.atlassian.jira.jira-projects-plugin:report-page`
        }
    })));
});

});
parcelRegister("dLzhb", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a71e196e46c338b3$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $a71e196e46c338b3$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    projectReportBreadcrumb: {
        "id": "spa-apps-software-breadcrumbs.project.project-report-breadcrumb",
        "defaultMessage": "Reports"
    }
});

});


parcelRegister("37nHj", function(module, exports) {

$parcel$export(module.exports, "UserBreadcrumbs", () => $13c61ae512d4731f$export$74fdd5a0187b08ef);

var $eUqFw = parcelRequire("eUqFw");

var $kKe2o = parcelRequire("kKe2o");
var $5c2C3 = parcelRequire("5c2C3");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bxX8o = parcelRequire("bxX8o");
const $13c61ae512d4731f$export$74fdd5a0187b08ef = /*#__PURE__*/ (0, $eUqFw.memo)(({ accountId: accountId, boardId: boardId, boardName: boardName, profileUrl: profileUrl, userName: userName, chart: chart, isLocationlessBoard: isLocationlessBoard })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (isLocationlessBoard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5c2C3.default), {
        profileUrl: profileUrl,
        name: userName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKe2o.default), {
        breadcrumb: {
            text: boardName,
            href: `/secure/RapidBoard.jspa?rapidView=${boardId}&locationless=true`,
            type: 'boardName'
        }
    }, chart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKe2o.default), {
        breadcrumb: {
            text: formatMessage((0, $bxX8o.messages).userReportBreadcrumb),
            href: `/secure/RapidBoard.jspa?rapidView=${boardId}&view=reporting&chart=${chart}&locationless=true`
        }
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5c2C3.default), {
        profileUrl: profileUrl,
        name: userName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKe2o.default), {
        breadcrumb: {
            text: boardName,
            href: `/jira/people/${accountId}/boards/${boardId}`,
            type: 'boardName'
        }
    }, chart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKe2o.default), {
        breadcrumb: {
            text: formatMessage((0, $bxX8o.messages).userReportBreadcrumb),
            href: `/jira/people/${accountId}/boards/${boardId}/reports/${chart}`
        }
    })));
});

});
parcelRegister("bxX8o", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c638782cd07129ac$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $c638782cd07129ac$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    userReportBreadcrumb: {
        "id": "spa-apps-software-breadcrumbs.user.user-report-breadcrumb",
        "defaultMessage": "Reports"
    }
});

});



parcelRegister("5SlaJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $632f7cb8249a0996$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("kQSGw");

var $6Zi5E = parcelRequire("6Zi5E");

var $2BvS3 = parcelRequire("2BvS3");

var $1ybV0 = parcelRequire("1ybV0");
parcelRequire("inDCU");
var $eZGdd = parcelRequire("eZGdd");

var $7msR2 = parcelRequire("7msR2");

var $a18DT = parcelRequire("a18DT");

var $gQqyT = parcelRequire("gQqyT");

var $iJHZm = parcelRequire("iJHZm");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $632f7cb8249a0996$var$bindToOnJiraGlobalIssueCreateClose = (callback)=>{
    // window.require is not available on initial script load.
    // eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $2BvS3.loadBridge)({
        name: 'jira/util/events',
        wrmKeys: 'wrc!jira.webresources:jira-events'
    }).then((Events)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        Events?.bind('QuickCreateIssue.sessionComplete', callback);
    });
};
const $632f7cb8249a0996$var$isBoardSizeLimit = (planDataResponse)=>planDataResponse.isIssueLimitExceeded;
const $632f7cb8249a0996$var$BacklogApp = ({ rapidViewId: rapidViewId, projectKeyFromContext: projectKeyFromContext, projectIdFromContext: projectIdFromContext, tenantContext: tenantContext, data: data, aggData: aggData, planModeData: planModeData, planModeDataPromise: planModeDataPromise, cmpBacklogData: cmpBacklogData, cmpBacklogDataPromise: cmpBacklogDataPromise, isCacheHit: isCacheHit, customFiltersQueryRef: customFiltersQueryRef, versionFilterRelayQueryRef: versionFilterRelayQueryRef, getDataFromAGG: getDataFromAGG, error: error, loading: loading })=>{
    // We are assuming that if we get a 400 error, it's because the user doesn't have access to the project for whatever reason
    // including project being deleted that is linked to the board in which we'd prompt the user to change the board's location.
    if (!loading && error && error.message === (0, $ce79b29fab1e78a6$export$912d9029af46d426)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Zi5E.AsyncLocationlessDialog), {
        rapidViewId: rapidViewId
    });
    const shouldRenderSkeleton = (0, $1ybV0.ff)('jsw.perf.enable-indexeddb-caching-for-backlog') ? !cmpBacklogDataPromise : !planModeDataPromise;
    if (shouldRenderSkeleton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7msR2.NextGenBacklogSkeleton), null);
    if ((0, $1ybV0.ff)('jsw.perf.enable-indexeddb-caching-for-backlog') ? cmpBacklogData && $632f7cb8249a0996$var$isBoardSizeLimit(cmpBacklogData.result) : planModeData && $632f7cb8249a0996$var$isBoardSizeLimit(planModeData)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gQqyT.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eZGdd.default), {
        name: "configApiReady"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a18DT.default), {
        isCacheHit: isCacheHit,
        bindToOnJiraGlobalIssueCreateClose: $632f7cb8249a0996$var$bindToOnJiraGlobalIssueCreateClose,
        // Route match data that could be read inside of the app
        projectKey: projectKeyFromContext,
        projectId: Number(projectIdFromContext),
        rapidViewId: String(rapidViewId),
        // Tenant context data that could be read inside of the app
        locale: tenantContext.locale,
        baseUrl: tenantContext.baseUrl,
        xsrfToken: tenantContext.xsrfToken ?? '',
        cloudId: tenantContext.cloudId ?? '',
        atlassianAccountId: tenantContext.atlassianAccountId ?? null,
        prefetchedData: data,
        prefetchedAggData: aggData,
        prefetchedJiraPlanRestData: planModeData,
        prefetchedJiraPlanRestDataPromise: planModeDataPromise,
        prefetchCmpBacklogData: cmpBacklogData,
        prefetchCmpBacklogDataPromise: cmpBacklogDataPromise,
        isServer: false,
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef,
        getDataFromAGG: getDataFromAGG,
        isCompanyManaged: true,
        // TODO: This is wrong
        projectName: projectKeyFromContext
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStatePageReady), null));
};
var $632f7cb8249a0996$export$2e2bcd8739ae039 = $632f7cb8249a0996$var$BacklogApp;

});
parcelRegister("gQqyT", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1e00a10b59492e9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $220ac = parcelRequire("220ac");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $exb0h = parcelRequire("exb0h");

var $3QLcd = parcelRequire("3QLcd");

var $iFocD = parcelRequire("iFocD");

var $5JgJ2 = parcelRequire("5JgJ2");

var $10fdS = parcelRequire("10fdS");

var $kJlBc = parcelRequire("kJlBc");

var $4SE04 = parcelRequire("4SE04");

var $18XWk = parcelRequire("18XWk");

var $jHil2 = parcelRequire("jHil2");
const $c1e00a10b59492e9$var$issueLimitsIPHArticleId = '1KMwTxMBNiDPhaHMDlfT4u';
/**
 * TODO: update primaryAction to redirect to board filter via savedFilterId
 * TODO: accommodate TMP empty states by copying existing version
 */ const $c1e00a10b59492e9$var$SizeLimitError = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { name: name } = (0, $10fdS.useCurrentRoute)();
    const [{ location: location }] = (0, $kJlBc.useRouter)();
    const { headerMessage: headerMessage, descriptionMessage: descriptionMessage } = (0, $eUqFw.useMemo)(()=>(0, $jHil2.getIssueLimitMessages)(name), [
        name
    ]);
    const boardSettingsUrl = `${location.pathname}?config=filter`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($iFocD))),
        header: formatMessage(headerMessage),
        description: formatMessage(descriptionMessage),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            href: boardSettingsUrl,
            appearance: "primary"
        }, formatMessage((0, $4SE04.default).editFilter)),
        tertiaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3QLcd.default), {
            appearance: "link",
            articleId: $c1e00a10b59492e9$var$issueLimitsIPHArticleId,
            fallbackComponent: null
        }, formatMessage((0, $4SE04.default).moreLinkText))
    });
};
const $c1e00a10b59492e9$var$SizeLimitErrorEmptyState = ()=>{
    const { name: name } = (0, $10fdS.useCurrentRoute)();
    const showErrorWithNoCTA = name === (0, $exb0h.ROUTE_NAMES).SERVICEDESK_BOARDS;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $c1e00a10b59492e9$var$containerStyles
    }, showErrorWithNoCTA ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $18XWk.SizeLimitErrorWithNoCTA), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c1e00a10b59492e9$var$SizeLimitError, null));
};
const $c1e00a10b59492e9$var$containerStyles = (0, $1ZAYh.xcss)({
    width: '100%'
});
var $c1e00a10b59492e9$export$2e2bcd8739ae039 = $c1e00a10b59492e9$var$SizeLimitErrorEmptyState;

});
parcelRegister("iFocD", function(module, exports) {
module.exports = new URL("error-loading-file.02dc84f6.svg", import.meta.url).toString();

});

parcelRegister("4SE04", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fb09c006b4f9074$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $2fb09c006b4f9074$var$messages = (0, $90IgZ.defineMessages)({
    boardHeader: {
        "id": "software-size-limit-error-empty-state.board-header",
        "defaultMessage": "Too many issues to display the board"
    },
    backlogHeader: {
        "id": "software-size-limit-error-empty-state.backlog-header",
        "defaultMessage": "Too many issues to display the backlog"
    },
    timelineHeader: {
        "id": "software-size-limit-error-empty-state.timeline-header",
        "defaultMessage": "Too many issues to display the timeline"
    },
    boardDescription: {
        "id": "software-size-limit-error-empty-state.board-description",
        "defaultMessage": "The board can only display up to 5,000 issues at a time. Move or delete issues to continue using your board."
    },
    backlogDescription: {
        "id": "software-size-limit-error-empty-state.backlog-description",
        "defaultMessage": "The backlog can only display up to 5,000 issues at a time. Move or delete issues to continue using your backlog."
    },
    timelineDescription: {
        "id": "software-size-limit-error-empty-state.timeline-description",
        "defaultMessage": "The timeline can only display up to 5,000 issues at a time. Move or delete issues to continue using your timeline."
    },
    editFilter: {
        "id": "software-size-limit-error-empty-state.edit-filter",
        "defaultMessage": "Edit filter"
    },
    moreLinkText: {
        "id": "software-size-limit-error-empty-state.more-link-text",
        "defaultMessage": "More about issue limits"
    }
});
var $2fb09c006b4f9074$export$2e2bcd8739ae039 = $2fb09c006b4f9074$var$messages;

});

parcelRegister("18XWk", function(module, exports) {

$parcel$export(module.exports, "SizeLimitErrorWithNoCTA", () => $b1d1cdc6819275ff$export$c0bbfc5b8cd7cce0);

var $eUqFw = parcelRequire("eUqFw");

var $220ac = parcelRequire("220ac");

var $iFocD = parcelRequire("iFocD");

var $5JgJ2 = parcelRequire("5JgJ2");

var $66P7q = parcelRequire("66P7q");
const $b1d1cdc6819275ff$export$c0bbfc5b8cd7cce0 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($iFocD))),
        header: formatMessage((0, $66P7q.default).header),
        description: formatMessage((0, $66P7q.default).description)
    });
};

});
parcelRegister("66P7q", function(module, exports) {

$parcel$export(module.exports, "default", () => $acee479bd6879dc3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $acee479bd6879dc3$var$messages = (0, $90IgZ.defineMessages)({
    header: {
        "id": "software-size-limit-error-empty-state.size-limit-error-no-cta.header",
        "defaultMessage": "We couldn\u2019t load your board"
    },
    description: {
        "id": "software-size-limit-error-empty-state.size-limit-error-no-cta.description",
        "defaultMessage": "Boards only work in projects with less than 5,000 issues. We\u2019re working on this and will let you know when it has changed."
    }
});
var $acee479bd6879dc3$export$2e2bcd8739ae039 = $acee479bd6879dc3$var$messages;

});


parcelRegister("jHil2", function(module, exports) {

$parcel$export(module.exports, "getIssueLimitMessages", () => $13e7427d8df33d0d$export$5c4dd481ffce3dbf);

var $exb0h = parcelRequire("exb0h");

var $4SE04 = parcelRequire("4SE04");
const $13e7427d8df33d0d$export$5c4dd481ffce3dbf = (routeName)=>{
    switch(routeName){
        case (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_BOARD:
        case (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_USER_BOARD:
        case (0, $exb0h.ROUTE_NAMES).SOFTWARE_BOARDS:
        case (0, $exb0h.ROUTE_NAMES).SERVICEDESK_BOARDS:
            return {
                headerMessage: (0, $4SE04.default).boardHeader,
                descriptionMessage: (0, $4SE04.default).boardDescription
            };
        case (0, $exb0h.ROUTE_NAMES).SOFTWARE_TIMELINE:
        case (0, $exb0h.ROUTE_NAMES).SOFTWARE_TIMELINE_CLASSIC:
            return {
                headerMessage: (0, $4SE04.default).timelineHeader,
                descriptionMessage: (0, $4SE04.default).timelineDescription
            };
        case (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_BACKLOG:
        case (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_USER_BACKLOG:
        case (0, $exb0h.ROUTE_NAMES).SOFTWARE_BACKLOG:
        default:
            return {
                headerMessage: (0, $4SE04.default).backlogHeader,
                descriptionMessage: (0, $4SE04.default).backlogDescription
            };
    }
};

});




parcelRegister("bbDk1", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad6dd8aeddfcf479$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("kQSGw");

var $iWLL0 = parcelRequire("iWLL0");

var $dpXKE = parcelRequire("dpXKE");

var $6iz4v = parcelRequire("6iz4v");

var $huI7r = parcelRequire("huI7r");

var $eI64M = parcelRequire("eI64M");

var $buJlM = parcelRequire("buJlM");

var $jZqFH = parcelRequire("jZqFH");

var $kJlBc = parcelRequire("kJlBc");
var $3HCkE = parcelRequire("3HCkE");

var $4XlfC = parcelRequire("4XlfC");
var $59z8J = parcelRequire("59z8J");

var $9ohLM = parcelRequire("9ohLM");

var $fO5rB = parcelRequire("fO5rB");

var $gd0Sp = parcelRequire("gd0Sp");


var $fv2PY = parcelRequire("fv2PY");

var $cXsCv = parcelRequire("cXsCv");
const $ad6dd8aeddfcf479$export$6a9f96b87df4de90 = ()=>{
    const [projectKey] = (0, $kJlBc.usePathParam)('projectKey');
    const [boardIdStr] = (0, $kJlBc.usePathParam)('boardId');
    const boardId = Number(boardIdStr);
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    (0, $fv2PY.useOnce)(()=>{
        (0, $6iz4v.setMark)((0, $ce79b29fab1e78a6$export$b5f697f1279a473e));
    });
    const backlogDataResource = (0, $3HCkE.useResource)((0, $4XlfC.backlogSyncResource));
    (0, $fv2PY.useOnce)(()=>{
        (0, $6iz4v.setMark)((0, $ce79b29fab1e78a6$export$a6940922387b16));
    });
    (0, $fv2PY.useOnce)(()=>{
        (0, $6iz4v.setMark)((0, $ce79b29fab1e78a6$export$e9163c48bfd4013e));
    }, ()=>!!backlogDataResource.data);
    const response = (0, $buJlM.useRelayResource)((0, $59z8J.customFiltersResource));
    const customFiltersQueryRef = response.queryReference;
    const isCacheHitRef = (0, $eUqFw.useRef)(backlogDataResource.data != null);
    const isCacheHit = isCacheHitRef.current;
    const { data: data, loading: loading, error: error } = backlogDataResource;
    const projectKeyFromContext = data?.boardScope.projectLocation.key || '';
    const projectNameFromContext = data?.boardScope.projectLocation.name || '';
    const projectIdFromContext = data?.boardScope.projectLocation.id || '';
    const [versionFilterRelayQueryRef, loadVersionFilterRelayQuery] = (0, $iWLL0.useQueryLoader)((0, $jZqFH.default));
    (0, $eUqFw.useEffect)(()=>{
        // only run the query if projectId exists in context
        // we load the query client-side because:
        //  1. The field relies on projectId which isn't available from the URL path
        //  2. We don't want version data to block the critical page load
        if (loadVersionFilterRelayQuery != null && projectIdFromContext != null && projectIdFromContext.length > 0) {
            const jiraProjectId = (0, $huI7r.createAri)({
                resourceOwner: 'jira',
                cloudId: tenantContext.cloudId,
                resourceType: 'project',
                resourceId: `${projectIdFromContext}`
            });
            loadVersionFilterRelayQuery({
                jiraProjectIds: [
                    jiraProjectId
                ],
                first: 500,
                after: null
            });
        }
    }, [
        loadVersionFilterRelayQuery,
        projectIdFromContext,
        tenantContext.cloudId
    ]);
    // redirect to the board only if the backlog is disabled, no redirect if timeout
    if (loading === false && (0, $fv2PY.isBacklogDisabled)(data)) {
        const urlProjectKey = projectKey ?? projectKeyFromContext;
        const boardUrl = (0, $fv2PY.getBoardUrl)(urlProjectKey, String(boardId));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
            to: boardUrl
        });
    }
    const backlogEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
        subProduct: "software"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cXsCv.default), {
        rapidViewId: boardId,
        projectKey: projectKey ?? projectKeyFromContext,
        projectKeyFromContext: projectKeyFromContext,
        projectNameFromContext: projectNameFromContext,
        projectIdFromContext: projectIdFromContext,
        tenantContext: tenantContext,
        data: data,
        aggData: null,
        error: error,
        loading: loading,
        isCacheHit: isCacheHit,
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9ohLM.default), {
        resource: backlogDataResource,
        refreshOnExpired: true
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpXKE.default), {
        baseUrl: tenantContext.baseUrl,
        projectKey: projectKeyFromContext,
        projectName: projectNameFromContext,
        projectId: projectIdFromContext,
        isSimplifiedProject: true
    }, backlogEl, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eI64M.default), {
        projectKey: projectKey ?? projectKeyFromContext ?? null
    }));
};
var $ad6dd8aeddfcf479$export$2e2bcd8739ae039 = $ad6dd8aeddfcf479$export$6a9f96b87df4de90;

});
parcelRegister("4XlfC", function(module, exports) {

$parcel$export(module.exports, "backlogSyncResource", () => $58456bd34c62de32$export$ae26ed4881473ce4);

var $3HCkE = parcelRequire("3HCkE");

var $jwzNs = parcelRequire("jwzNs");


var $k5z0l = parcelRequire("k5z0l");
const $58456bd34c62de32$export$ae26ed4881473ce4 = (0, $jwzNs.browserOnlyResourceWithCondition)(()=>false, (0, $3HCkE.createResource)({
    type: (0, $52b7f081c10f9d47$export$a0ef589381533a7c),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>Promise.resolve({
            default: (0, $k5z0l.default)
        }),
    // SSR doesn't care about this and we can't check FFs here because its not in the render path
    maxAge: 3600000
}));

});
const $52b7f081c10f9d47$export$faa68b3df5415bcb = 'NEXTGEN_BACKLOG_CUSTOM_FILTERS';
const $52b7f081c10f9d47$export$a0ef589381533a7c = 'NEXTGEN_BACKLOG';
const $52b7f081c10f9d47$export$463905a04a9a75ce = 'NEXTGEN_BACKLOG_RELAY';

parcelRegister("k5z0l", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getEarlyPreload", () => $d957c4f3c27fb60a$export$fed0052f40119df3);
$parcel$export(module.exports, "fetchData", () => $d957c4f3c27fb60a$export$8134c072fddab6a5);
$parcel$export(module.exports, "default", () => $d957c4f3c27fb60a$export$2e2bcd8739ae039);

var $6iz4v = parcelRequire("6iz4v");

var $5yh8X = parcelRequire("5yh8X");

var $1aPBP = parcelRequire("1aPBP");

var $645Hx = parcelRequire("645Hx");

var $R1ugb = parcelRequire("R1ugb");
const $d957c4f3c27fb60a$export$fed0052f40119df3 = ()=>{
    if (window.__JSW_BACKLOG_DATA_PROMISE__) {
        const earlyPreloadPromise = window.__JSW_BACKLOG_DATA_PROMISE__;
        window.__JSW_BACKLOG_DATA_PROMISE__ = null;
        return earlyPreloadPromise.then((preload)=>{
            if (preload.errors && preload.errors.length || !preload.data?.boardScope) throw new (0, $R1ugb.SwagError)({
                graphQLErrors: preload.errors,
                errorMessage: 'Backlog early fetch failed'
            });
            return preload.data;
        });
    }
    return null;
};
const $d957c4f3c27fb60a$export$8134c072fddab6a5 = (baseUrl, rapidViewId)=>{
    const earlyPreload = $d957c4f3c27fb60a$export$fed0052f40119df3();
    if (earlyPreload != null) return earlyPreload;
    const data = (0, $645Hx.fetchAgilityGraphqlData)(baseUrl, rapidViewId);
    return data;
};
const $d957c4f3c27fb60a$var$BACKLOG_FETCH_START_MARK = 'BACKLOG_FETCH_START';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d957c4f3c27fb60a$export$2e2bcd8739ae039 = async ({ match: match }, { tenantContext: tenantContext })=>{
    const { baseUrl: baseUrl } = tenantContext;
    const rapidViewId = match.params.boardId || '';
    (0, $6iz4v.setMark)($d957c4f3c27fb60a$var$BACKLOG_FETCH_START_MARK);
    try {
        setTimeout(()=>{
            (0, $6iz4v.setMark)((0, $5yh8X.prefetchApiStartMark));
        });
        const data = await $d957c4f3c27fb60a$export$8134c072fddab6a5(baseUrl, rapidViewId);
        (0, $6iz4v.setMark)((0, $5yh8X.prefetchApiReadyMark));
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $1aPBP.createResourceError)({
            component: 'spa.view.routes.next-gen.backlog.getData',
            message: 'An error was thrown while prefetching backlog data',
            name: 'ResourceError'
        }, error);
    }
};

});
parcelRegister("1aPBP", function(module, exports) {

$parcel$export(module.exports, "createResourceError", () => $ab2f50dfea4673ae$export$13487d18466bc8a5);

var $gUUjF = parcelRequire("gUUjF");
class $ab2f50dfea4673ae$var$ResourceErrorClass extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message);
        this.name = options.name || 'ResourceError';
        this.skipSentry = options.skipSentry;
    }
}
const $ab2f50dfea4673ae$export$13487d18466bc8a5 = ({ name: name = 'ResourceError', message: message = '', component: component = '', skipSentry: skipSentry = false }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
errorOverride)=>{
    (0, $gUUjF.default).safeErrorWithoutCustomerData(component, message, errorOverride);
    if (errorOverride) return errorOverride;
    return new $ab2f50dfea4673ae$var$ResourceErrorClass(message, {
        name: name,
        skipSentry: skipSentry
    });
};

});



parcelRegister("cXsCv", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c802926d6ec9608$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("kQSGw");

var $2BvS3 = parcelRequire("2BvS3");
parcelRequire("inDCU");
var $eZGdd = parcelRequire("eZGdd");

var $7msR2 = parcelRequire("7msR2");

var $a18DT = parcelRequire("a18DT");

var $naWQb = parcelRequire("naWQb");

var $f9xU4 = parcelRequire("f9xU4");
var $laUAu = parcelRequire("laUAu");

var $iJHZm = parcelRequire("iJHZm");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3c802926d6ec9608$var$bindToOnJiraGlobalIssueCreateClose = (callback)=>{
    // window.require is not available on initial script load.
    // eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $2BvS3.loadBridge)({
        name: 'jira/util/events',
        wrmKeys: 'wrc!jira.webresources:jira-events'
    }).then((Events)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        Events?.bind('QuickCreateIssue.sessionComplete', callback);
    });
};
const $3c802926d6ec9608$var$BacklogApp = ({ rapidViewId: rapidViewId, projectKey: projectKey, projectKeyFromContext: projectKeyFromContext, projectIdFromContext: projectIdFromContext, projectNameFromContext: projectNameFromContext, tenantContext: tenantContext, data: data, aggData: aggData, error: error, loading: loading, isCacheHit: isCacheHit, customFiltersQueryRef: customFiltersQueryRef, versionFilterRelayQueryRef: versionFilterRelayQueryRef, getDataFromAGG: getDataFromAGG })=>{
    const isAppReady = Boolean(data);
    if ((0, $laUAu.isBoardSizeLimitError)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f9xU4.default), {
        projectKey: projectKey
    });
    if (error && !loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $naWQb.BacklogSlaTracker), {
        error: error
    });
    if (!isAppReady) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7msR2.NextGenBacklogSkeleton), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eZGdd.default), {
        name: "configApiReady"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a18DT.default), {
        isCacheHit: isCacheHit,
        bindToOnJiraGlobalIssueCreateClose: $3c802926d6ec9608$var$bindToOnJiraGlobalIssueCreateClose,
        // Route match data that could be read inside of the app
        projectKey: projectKeyFromContext,
        projectId: Number(projectIdFromContext),
        projectName: projectNameFromContext,
        rapidViewId: String(rapidViewId),
        // Tenant context data that could be read inside of the app
        locale: tenantContext.locale,
        baseUrl: tenantContext.baseUrl,
        xsrfToken: tenantContext.xsrfToken ?? '',
        cloudId: tenantContext.cloudId ?? '',
        atlassianAccountId: tenantContext.atlassianAccountId ?? null,
        prefetchedData: data,
        prefetchedAggData: aggData,
        isServer: false,
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef,
        getDataFromAGG: getDataFromAGG
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStatePageReady), null));
};
var $3c802926d6ec9608$export$2e2bcd8739ae039 = $3c802926d6ec9608$var$BacklogApp;

});
parcelRegister("f9xU4", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f2679607ceefe2a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gd0Sp = parcelRequire("gd0Sp");

var $aYire = parcelRequire("aYire");
/**
 * @deprecated use generic version of SizeLimitErrorEmptyStateComponent component @atlassian/jira-software-size-limit-error-empty-state
 */ const $5f2679607ceefe2a$var$BoardSizeLimitErrorEmptyStateWithBaseUrl = ({ projectKey: projectKey, savedFilterId: savedFilterId, isCMPBoard: isCMPBoard = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        const { baseUrl: baseUrl } = tenantContext;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aYire.default), {
            projectKey: projectKey,
            baseUrl: baseUrl,
            isCMPBoard: isCMPBoard,
            savedFilterId: savedFilterId
        });
    });
var $5f2679607ceefe2a$export$2e2bcd8739ae039 = $5f2679607ceefe2a$var$BoardSizeLimitErrorEmptyStateWithBaseUrl;

});
parcelRegister("aYire", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5a71c235a31fa3f$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ldoFd = parcelRequire("ldoFd");

var $7u4fN = parcelRequire("7u4fN");

var $220ac = parcelRequire("220ac");

var $kMklc = parcelRequire("kMklc");

var $exb0h = parcelRequire("exb0h");

var $giAhk = parcelRequire("giAhk");

var $10fdS = parcelRequire("10fdS");

var $ivc6I = parcelRequire("ivc6I");

var $6gDdX = parcelRequire("6gDdX");
const $a5a71c235a31fa3f$var$BoardSizeLimitError = ({ intl: intl, projectKey: projectKey, baseUrl: baseUrl, isCMPBoard: isCMPBoard = false, savedFilterId: savedFilterId })=>{
    const description = isCMPBoard ? intl.formatMessage((0, $ivc6I.default).descriptionCmp) : intl.formatMessage((0, $ivc6I.default).description);
    const url = isCMPBoard && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(savedFilterId) ? `${baseUrl}/issues/?filter=${savedFilterId}` : `${baseUrl}/issues/?jql=${encodeURIComponent(`project = ${projectKey} ORDER BY rank ASC`)}`;
    const buttonText = isCMPBoard ? intl.formatMessage((0, $ivc6I.default).editBoardFilter) : intl.formatMessage((0, $ivc6I.default).goToSearch);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a5a71c235a31fa3f$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($kMklc))),
        header: intl.formatMessage((0, $ivc6I.default).header),
        description: description,
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            href: url,
            appearance: "primary"
        }, buttonText)
    }));
};
const $a5a71c235a31fa3f$var$BoardSizeLimitErrorEmptyState = (props)=>{
    const { name: name } = (0, $10fdS.useCurrentRoute)();
    const showErrorWithNoCTA = name === (0, $exb0h.ROUTE_NAMES).SERVICEDESK_BOARDS;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a5a71c235a31fa3f$var$Container, null, showErrorWithNoCTA ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6gDdX.BoardSizeLimitErrorWithNoCTA), {
        intl: props.intl
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a5a71c235a31fa3f$var$BoardSizeLimitError, props));
};
const $a5a71c235a31fa3f$var$BoardSizeLimitErrorEmptyStateWithIntl = (0, $giAhk.injectIntlV2)($a5a71c235a31fa3f$var$BoardSizeLimitErrorEmptyState);
var $a5a71c235a31fa3f$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $a5a71c235a31fa3f$var$BoardSizeLimitErrorEmptyStateWithIntl;
const $a5a71c235a31fa3f$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kMklc", function(module, exports) {
module.exports = new URL("something-wrong.1260804e.svg", import.meta.url).toString();

});

parcelRegister("ivc6I", function(module, exports) {

$parcel$export(module.exports, "default", () => $975be96cc442b824$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $975be96cc442b824$var$messages = (0, $90IgZ.defineMessages)({
    header: {
        "id": "software-board-size-limit-error-empty-state.header",
        "defaultMessage": "Your board has too many issues"
    },
    goToSearch: {
        "id": "software-board-size-limit-error-empty-state.go-to-search",
        "defaultMessage": "See issues in search"
    },
    description: {
        "id": "software-board-size-limit-error-empty-state.description",
        "defaultMessage": "Boards can only display up to 5,000 issues at a time. Move or delete issues to continue using your board."
    },
    descriptionCmp: {
        "id": "software-board-size-limit-error-empty-state.description-cmp",
        "defaultMessage": "Boards can only display up to 5,000 issues at a time. Try editing your board's filter query to include fewer issues, or create an additional board."
    },
    editBoardFilter: {
        "id": "software-board-size-limit-error-empty-state.edit-board-filter",
        "defaultMessage": "Edit board filter"
    }
});
var $975be96cc442b824$export$2e2bcd8739ae039 = $975be96cc442b824$var$messages;

});

parcelRegister("6gDdX", function(module, exports) {

$parcel$export(module.exports, "BoardSizeLimitErrorWithNoCTA", () => $2cd1a2752b301cc1$export$67ed49fd05b7aff8);

var $eUqFw = parcelRequire("eUqFw");

var $220ac = parcelRequire("220ac");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $kMklc = parcelRequire("kMklc");

var $iXy1q = parcelRequire("iXy1q");
const $2cd1a2752b301cc1$export$67ed49fd05b7aff8 = ({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $2cd1a2752b301cc1$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($kMklc))),
        header: intl.formatMessage((0, $iXy1q.default).header),
        description: intl.formatMessage((0, $iXy1q.default).description)
    }));
const $2cd1a2752b301cc1$var$containerStyles = (0, $1ZAYh.xcss)({
    width: '100%'
});

});
parcelRegister("iXy1q", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5cf1e34c354d53f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $e5cf1e34c354d53f$var$messages = (0, $90IgZ.defineMessages)({
    header: {
        "id": "software-board-size-limit-error-empty-state.size-limit-error-no-cta.header",
        "defaultMessage": "We couldn\u2019t load your board"
    },
    description: {
        "id": "software-board-size-limit-error-empty-state.size-limit-error-no-cta.description",
        "defaultMessage": "Boards only works in project with less than 5,000 issues. We\u2019re working on this and will let you know when it has changed."
    }
});
var $e5cf1e34c354d53f$export$2e2bcd8739ae039 = $e5cf1e34c354d53f$var$messages;

});




parcelRegister("laUAu", function(module, exports) {

$parcel$export(module.exports, "isBoardSizeLimitError", () => $80a6938b5cc3d14b$export$c72e0becab2a28fe);

var $illlw = parcelRequire("illlw");
const $80a6938b5cc3d14b$export$c72e0becab2a28fe = (error)=>error != null && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    error.graphQLErrors != null && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    Array.isArray(error.graphQLErrors) && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    error.graphQLErrors.length > 0 && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    error.graphQLErrors[0] != null && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error.graphQLErrors[0], [
        'extensions',
        'statusCode'
    ]) && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error.graphQLErrors[0], [
        'extensions',
        'errorType'
    ]) === 'jsw.board-size-limit-exceeded';

});






const $df03f3fe1f111432$export$b05303cbde3e8c8c = 'CARD';
const $df03f3fe1f111432$export$57d0ef745f304b91 = 'COLUMN';
const $df03f3fe1f111432$export$2927f4d423091b16 = 'TRANSITION_ZONE';


//# sourceMappingURL=async-next-gen-backlog.9dc9f10a.js.map
